/**
 * @author Stefano Poli
 * created on 21/10/2016
 */

'use strict';

var deps = [];

var emmaConsip = angular.module('emma.consip', ['ictportal', 'ictportal.constants']);

/**
 * @author Rita Beltrami
 * created on 20/12/2017
 */

'use strict';

var core = angular.module('ictportal.core', ['ictportal', 'ictportal.constants'])

/**
 * @author Stefano Poli
 * created on 07/11/2016
 */

'use strict';

var datasetConsip = angular.module('emma.dataset', ['ictportal', 'ictportal.constants']);

/**
 * @author Stefano Poli
 * created on 21/10/2016
 */

'use strict';

var emmaEnergy = angular.module('emma.energy', ['ictportal', 'ictportal.constants']);


'use strict';

var ferri = angular.module('ictportal.ferri', ['ictportal', 'ictportal.constants'])


'use strict';

var hpe = angular.module('ictportal.hpe', ['ictportal', 'ictportal.constants'])

/**
 * @author Rita Beltrami
 * created on 18/05/2017
 */

'use strict';

var ictEggs = angular.module('ictportal.icteggs', ['ictportal', 'ictportal.constants'])

/**
 * @author Rita Beltrami
 * created on 15/06/2017
 */

'use strict';

var lm = angular.module('ictportal.lm', ['ictportal', 'ictportal.constants'])

/**
 * @author Stefano Poli
 * created on 21/10/2016
 */

'use strict';

var emmaPlan = angular.module('emma.plan', ['ictportal', 'ictportal.constants']);

/**
 * @author Stefano Poli
 * created on 07/11/2016
 */

'use strict';

// var deps = [];
//
// try {
//   //This throws an expection if module does not exist.
//   angular.module('ui.bootstrap');
//   deps.push('ui.bootstrap');
// } catch (e) {}
//
// try {
//   //This throws an expection if module does not exist.
//   angular.module('LocalStorageModule');
//   deps.push('LocalStorageModule');
// } catch (e) {}
//
// try {
//   //This throws an expection if module does not exist.
//   angular.module('schemaForm');
//   deps.push('schemaForm');
// } catch (e) {}

var ictTheme = angular.module('ictportal.theme', ['ictportal', 'ictportal.constants'])
  .config(['cfpLoadingBarProvider', function(cfpLoadingBarProvider) {
    cfpLoadingBarProvider.spinnerTemplate = '<div id="loading-bar-spinner"><div class="spinner-icon"></div></div>';
    cfpLoadingBarProvider.includeSpinner = true;
  }])
  .config(['localStorageServiceProvider', function(localStorageServiceProvider){
    localStorageServiceProvider.setPrefix('ictportal');
  }]);

/**
 * @author Rita Beltrami
 * created on /06/2017
 */

'use strict';

var lm = angular.module('ictportal.tnt', ['ictportal', 'ictportal.constants'])

/**
 * created on /06/2017
 */

'use strict';

var ttr = angular.module('ictportal.ttr', ['ictportal', 'ictportal.constants'])

/**
 * Created by Stefano Poli on 25/01/17.
 */

var ictportalConstants = angular.module('ictportal.constants', ['ictportal'])
  .constant('LOGIN_URL',    'six')
  .constant('APP_URL',      'six')
  .constant('SIX_URL',      'six')
  .constant('EGGS_URL',     'eggs')
  .constant('EGGS_AUTH_URL', 'eggs/api/auth')
  .constant('CONSIP_URL',   'api/six-consip')
  .constant('DATA_SET_URL', 'api/six-data-set')
  .constant('ABNORMAL_URL', '/abnormal') // Primario
  .constant('SCRAMBLED_URL','/scrambled') // Secondario
  .constant('ALFRESCO_URL', 'api/six-alfresco')
  .constant('ENERGY_URL',   'api/six-energy')
  .constant('PLAN_URL',     'api/six-plan')
  .constant('ADMIN_URL',    'http://localhost:8080/six/')  // admin page url when DEV=false
  .constant('ENV', 'asset')  // environment: emma | asset | consip
  .constant('DEV', true)     // developer version true/false
  .constant('CAS', false)    // CAS login enabled (true)/disabled (false)
  .constant('HISTORY', false)    // show upper history bar
  .constant('SIDE_PROFILE', false);   // selezione profili da sidebar destra

'use strict';

/**
 * @ngdoc overview
 * @name ictportal
 * @description
 * # ictportal
 *
 * Main module of the application.
 */
var module = angular
  .module('ictportal', [
    'LocalStorageModule',
    'ngCookies',
    'ngResource',
    'ngRoute',
    'ngSanitize',
    'ngTouch',
    'ui.bootstrap',
    'ui.select',
    'ui.ace',
    'schemaForm',
    'ui.grid',
    'ui.grid.importer',
    'ui.grid.selection',
    'ui.grid.exporter',
    'ui.grid.edit',
    'ui.grid.rowEdit',
    'ui.grid.cellNav',
    'ui.grid.expandable',
    'ui.grid.pinning',
    'ui.grid.resizeColumns',
    'ui.grid.pagination',
    'ui.grid.moveColumns',
    'ui.grid.autoResize',
    'ui.tree',
    'ngDialog',
    'ngMessages',
    'toaster',
    'ngWebSocket',
    'fileSaver',
    'ui.bootstrap-slider',
    'mgcrea.ngStrap',
    'mgcrea.ngStrap.modal',
    'mgcrea.ngStrap.select',
    'pascalprecht.translate',
    'angular-md5',
    'monospaced.qrcode',
    'gantt',
    'gantt.table',
    'gantt.tooltips',
    'gantt.tree',
    'gantt.groups',
    'angularFileUpload',
    'cfp.loadingBar',
    'cfp.loadingBarInterceptor',
    'ictportal.theme',
    'emma.dataset',
    'emma.energy',
    'emma.plan',
    'emma.consip',
    'ictportal.constants',
    'ictportal.icteggs',
    'ictportal.lm',
    'ictportal.ferri',
    'ictportal.core',
    'ictportal.tnt',
    'ictportal.ttr',
    'ictportal.hpe',
    'ngTagsInput',
    "ng-mfb",
    "ui.bootstrap.datetimepicker",
    'pascalprecht.translate',
    'ngPromiseExtras',
    'ngclipboard'
  ])
  .config(['tagsInputConfigProvider', function(tagsInputConfigProvider) {
    tagsInputConfigProvider.setDefaults('tagsInput', { placeholder: '' });
    tagsInputConfigProvider.setActiveInterpolation('tagsInput', { placeholder: true });
  }]);

var auth = {};

/**
 * Created by stefano on 08/11/16.
 */

(function () {
  'use strict';

  angular.module('ictportal.theme')
    .config(httpConfig);

  /** @ngInject */
  function httpConfig($routeProvider, $httpProvider) {
    $routeProvider
      .when('/', {
        templateUrl: 'theme/landing/landing.html',
        controller: 'LandingCtrl'
      })
      .when('/home', {
        templateUrl: 'theme/landing/landing.html',
        controller: 'LandingCtrl'
      })
      .otherwise({
        templateUrl: 'theme/view404.html'
      });
    $httpProvider.interceptors.push('authHttpRequestInterceptor');

    $httpProvider.interceptors.push(function ($q) {
      return {
        //response: function(response) {
        //  errorProvider.handleError(response, true);
        //  console.log('error in interceptor - ', 'fotciarino fotciarellooooo!!!!');
        //  return response;
        //},
        responseError: function (rejection) {
          return $q.reject(rejection);
        }
      };
    });
  }

})();

/**
 * @author Stefano Poli
 * created on 07/11/2016
 */
(function () {
  'use strict';

  angular.module('ictportal.theme')
    .run(function($rootScope, $location, authFactory, $log, $templateCache, ENV, CAS, localStorageService, wsfactory, matrixParFactory) {
      $rootScope.$on( '$routeChangeStart', function(event, next) {
        if (next.templateUrl === 'theme/login/fakelogin.html') {
          $rootScope.bodyClass = 'login-six';
        } else if (next.templateUrl === 'theme/auth/postauth.html') {
          $rootScope.bodyClass = 'login-six';
        } else if (!authFactory.isAuthenticated() || !authFactory.isProfileChoosen()) {
          $rootScope.bodyClass = 'login-six';
          if(CAS) { // autenticazione con CAS CoopService
            window.location = 'emmacas/auth/'+ENV;
          } else {  // autenticazione senza CAS
            if(next.templateUrl !== 'theme/password/password.html'){
              $location.path('login');
            }
          }
        } else if (next.templateUrl === '404.html') {
          $rootScope.bodyClass = 'login-six';
        } else if (next.templateUrl === 'theme/login/login.html') {
          $location.path('logout'); // mi stai richiedendo il login => ti sloggo così ti riloggi
        } else {
          $rootScope.bodyClass = '';
        }
      });
      // Cambio l'icona di espansione righe delle ui-grid
      $templateCache.put('ui-grid/expandableTopRowHeader',
        '<div class="ui-grid-row-header-cell ui-grid-expandable-buttons-cell">' +
        '<div class="ui-grid-cell-contents">' +
        '<i ng-class="{ \'fa fa-chevron-right\' : !grid.expandable.expandedAll, \'fa fa-chevron-down\' : grid.expandable.expandedAll }" ng-click="grid.api.expandable.toggleAllRows()"></i>' +
        '</div>' +
        '</div>'
      );
      $templateCache.put('ui-grid/expandableRowHeader',
        '<div class=\"ui-grid-row-header-cell ui-grid-expandable-buttons-cell\">' +
        '<div class=\"ui-grid-cell-contents\">' +
        '<i ng-class=\"{ \'fa fa-chevron-right\' : !row.isExpanded, \'fa fa-chevron-down\' : row.isExpanded }\" ng-click=\"grid.api.expandable.toggleRowExpansion(row.entity)\"></i>' +
        '</div>' +
        '</div>'
      );


      // NOTIFICHE
      matrixParFactory.getValueOrDefault({key: 'abnormal.url', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}, {defaultValue: null}).$promise.then(function(data){
        if (data.result && data.result.value) {
          var wsUrl = data.result.value.replace("http","ws")
          var workstationCode = localStorageService.get('workstation');
          var notifyProject = 'notify_'+workstationCode;
          wsfactory.open(wsUrl+'/api/ws');
          wsfactory.send({'project': notifyProject});
          window.setInterval(function() {
            // Ping WS
            wsfactory.send({ 'project': notifyProject });
            console.log('ping ws ' + notifyProject);
            }, 120000);
        }
      });
    });

})();

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:AcquisitionStepCtrl
 * @description
 * # AcquisitionStepCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/acquisitionstep', {
        templateUrl: 'consip/acquisitionstep/acquisitionstep_list.html',
        controller: 'AcquisitionStepCtrl'
      })
      .when('/acquisitionstep/page/:number', {
        templateUrl: 'consip/acquisitionstep/acquisitionstep_list.html',
        controller: 'AcquisitionStepCtrl'
      })
      .when('/acquisitionstep/:id', {
        templateUrl: 'consip/acquisitionstep/acquisitionstep_detail.html',
        controller: 'AcquisitionStepCtrl'
      })
  })
  .controller('AcquisitionStepCtrl', function ($scope, $routeParams, $location, formulaFactory, $log, acquisitionStepFactory, $window, schemaFactory, toaster) {

    $scope.form = {};

    $scope.step = {};

    $scope.model = {};

    $scope.schema = {};

    $scope.property = {};

    $scope.checked = {};

    $scope.uiselectMap = {};

    $scope.itemTypeMap =  {};

    $scope.newItemArray = {
      record_id: {}
    };

    $scope.status = {
      isFirstOpen: true,
      isFirstDisabled: false
    };

    $scope.modeltypeList = schemaFactory().lookupList({page_size: 1000});

    /* ------------------------------------------------ */

    $scope.stepList = []; /* lista degli step per la pagina _list */

    $scope.formulaList = {}; /* formule disponibili da poter inserire con il configuratore */

    $scope.selected = {}; /** contenitore */

    $scope.newStep = function () {
      $location.path('acquisitionstep/new');
    };

    $scope.back = function() {
      $location.path('acquisitionstep');
    };

    $scope.pageChanged = function () {
      $location.path('/acquisitionstep/page/'+$scope.stepList.currentPage, false);
    };

    $scope.getFormulaList = function () {
      formulaFactory.getFormulasList({query: $scope.queryParam, page_size: 1000}).$promise.then(function(data) {
        $scope.formulaList = data.list;
      });
    };

    $scope.getStepList = function () {
      /** scarico la lista dei modelli di step inseriti */
      acquisitionStepFactory().lookup({page_size: 1000}).$promise.then(function(data) {
        $scope.stepList = data;
      });
    };

    $scope.getStep = function (UUID) {
      acquisitionStepFactory().byUUID({id: UUID}).$promise.then(function(response){
        if(response.model){
          $scope.selected = angular.copy(response);
          $scope.updateScope();
        }
      });
    };

    $scope.save = function() {
      if($scope.selected.model.code && $scope.selected.model.description) {
        if ($scope.selected.version) {
          acquisitionStepFactory().update({id: $scope.selected.version}, $scope.aceModel)
            .$promise.then(function() {
              $window.history.back();
            });
        } else {
          var toSave = JSON.parse($scope.aceModel);
          acquisitionStepFactory().create(toSave)
            .$promise.then(function() {
              $window.history.back();
            });
        }
      }
      else{
        toaster.pop('error', 'Errore', 'Dati obbligatori mancanti');
      }
    };

    $scope.delete = function (idToDelete) {
      acquisitionStepFactory().delete({id: idToDelete}).$promise.then(function() {
        $window.history.back();
      });
    };


    if($routeParams.id) {
      if($routeParams.id != 'new'){
        /** carico un modello esistente */
        $scope.getStep($routeParams.id);
      }

      /* scarico comunque l'elenco delle formule */
      $scope.getFormulaList();
    } else {
      /* lista delle configurazioni inserite */
      $scope.getStepList();
    }



















    /*****************************************************************************/
    /*************** ADD & DELETE PROPERTIES ON $scope.model.schema *************/
    /***************************************************************************/

    $scope.addProperty = function() {
      if(angular.isDefined($scope.property.key)) {
        var p = {
          title: angular.copy($scope.property.title),
          type: angular.copy($scope.property.type),
          check: false
        };
        if($scope.property.format){
          p.format = angular.copy($scope.property.format);
        }
        if(p.type == 'date'){
          p.type = 'string';
          p.format = 'date';
        }
        if(p.type == 'array'){
          p.items = {type: angular.copy($scope.property.items_type)}; // default
          if($scope.property.items_type === 'date') { // se è una data è diverso...
            p.items = {type: 'string', format: 'date'};
          }
        }
        if($scope.property.inherited){
          if($scope.property.inherited == true){
            p.format = 'inherit';
            p.field = '';
            p.record = '';
            if($scope.property.format){
              p.field_inherit_type = $scope.property.format;
              if($scope.property.format == 'enum'){
                delete p.enum;
              }
            }
            if(p.type == 'integer'){
              p.type = 'number';
            }
          }
        }
        $scope.selected.model.schema.properties[$scope.property.key] = p;
        var item = {
          title: angular.copy($scope.property.title),
          type: null,
          key: [angular.copy($scope.property.key)]
        };
        if(p.format){
          if (p.format == 'date'){
            item.type = 'datepicker';
          } else if (p.format == 'enum'){
            item.type = 'uiselect';
            item.titleMap = [];
          } else if (p.format == 'lookup'){
            item.type = 'sixlookup';
          } else if (p.format == 'formula'){
            item.type = 'sixformula';
          } else if (p.format == 'inherit'){
            item.type = 'sixinherit';
          }
        } else if(p.type == 'string'){
          item.type = 'text';
        } else if(p.type == 'number' || p.type == 'integer'){
          item.type = 'number';
        } else if(p.type == 'boolean'){
          item.type = 'checkbox';
        } else if(p.type == 'array') {
          item.type = 'uiselectmultiple';
          item.titleMap = [];
        } else {  // default
          item.type = angular.copy(p.type);
        }
        for(var i in $scope.selected.model.form[0].items) {
          if($scope.selected.model.form[0].items[i].tabs) {
            $scope.selected.model.form[0].items[i].tabs[0].items.push(item);
          }
        }
      }
      $scope.getUiSelectMap();
      $scope.clearNewCol();
      $scope.updateScope();
    };

    $scope.clearNewCol = function(){
      $scope.property.key = '';
      $scope.property.title = '';
      delete $scope.property.type;
      delete $scope.property.format;
      delete $scope.property.inherited;
    };

    $scope.deleteProperty = function(keyToDelete) {
      delete $scope.selected.model.schema.properties[keyToDelete];
      for (var i = $scope.selected.model.columnDefs.length; i--; ) {
        if ($scope.selected.model.columnDefs[i].field == keyToDelete) $scope.selected.model.columnDefs.splice(i, 1);
      }
      for (var i = $scope.selected.model.form[0].items.length; i--; ) {
        if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == keyToDelete) {
          $scope.selected.model.form[0].items.splice(i, 1);
        }
        // Scorro anche i tabs
        if($scope.selected.model.form[0].items[i].tabs) {
          for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
            for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
              if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == keyToDelete) {
                $scope.selected.model.form[0].items[i].tabs[j].items.splice(k, 1);
              }
            }
          }
        }
      }
      $scope.updateScope();
    };


    /*****************************************************************************/
    /*************** AGGIORNA LA $scope.selected.model.columnDefs ***************/
    /***************************************************************************/


    $scope.changeColumnDefs = function (key, value) {
      var item = {name: value.title, field: key};
      var map = {};
      angular.forEach($scope.selected.model.columnDefs, function (v) {
        map[v.field] = angular.copy(v);
      });
      if(value.check){
        map[item.field] = angular.copy(item);
        if(value.width == '' || value.width == null) {
          delete $scope.selected.model.schema.properties[key].width;
        }
      }
      else{
        delete map[item.field];
        delete $scope.selected.model.schema.properties[key].width;
        $scope.selected.model.schema.properties[key].enableFiltering = false;
        $scope.selected.model.schema.properties[key].enableSorting = false;
      }
      $scope.selected.model.columnDefs=[];
      for(var it in map) {
        var app = {name: map[it].name, field: map[it].field};
        $scope.selected.model.columnDefs.push(app);
      }
      $scope.updateScope();
    };


    /*************************************/
    /*************** FORM ***************/
    /***********************************/

    $scope.newFieldForm = {};
    $scope.newTab = {
      title: "",
      items: []
    };

    $scope.addTab = function(container){
      if(!container.tabs) {
        container.tabs = [];
      }
      if(container.type !== 'tabs') {
        container.type = 'tabs';
      }
      var toAdd = angular.copy($scope.newTab);
      $log.log(container);
      container.tabs.push(toAdd);
      $log.log(container);
      $scope.updateScope();
      $scope.newTab = {
        title: "",
        items: []
      };
    };

    $scope.addFieldToTab = function(tab){
      if(!tab.items) {
        tab.items = [];
      }
      var toAdd = angular.copy($scope.newFieldForm);
      if($scope.newFieldForm.type === '' || $scope.newFieldForm.type === 'formula' || $scope.newFieldForm.type === 'inherited') {
        delete toAdd.type;
      }
      toAdd.key = [];
      toAdd.key.push($scope.newFieldForm.key);
      tab.items.push(toAdd);
      $log.log(tab);
      $scope.updateScope();
      $scope.newFieldForm = {
        key: [],
        title: "",
        required: false,
        type: "text"
      };
    };

    $scope.removeTabOrField = function(key, container){
      container.splice(key, 1);
      $log.log(container);
      $scope.updateScope();
    };

    $scope.swapUp = function(key, collection) {
      if(key > 0) {
        var tmp = collection[key];
        collection[key] = collection[key-1];
        collection[key-1] = tmp;
      }
      $scope.updateScope();
    };

    $scope.swapDown = function(key, collection) {
      if(key < collection.length-1) {
        var tmp = collection[key];
        collection[key] = collection[key+1];
        collection[key+1] = tmp;
      }
      $scope.updateScope();
    };

    $scope.updateField = function(field) {
      if(field.type === '') {
        delete field.type;
      }
      $scope.updateScope();
    };


    /**********************************************************************************************************/
    /*************** GESTIONE DEGLI ELEMENTI NEI TAB $scope.selected.model.form[0].items[i].tabs *************/
    /********************************************************************************************************/

    $scope.addItemOnArray = function(key, newItem){
      if(newItem != undefined && newItem != null){
        newItem.name = newItem.name.toString();
        if($scope.itemTypeMap[key] == 'integer'){
          if(parseInt(newItem.name)){
            newItem.value = parseInt(newItem.name);
            newItem.name = newItem.value.toString(); /* nel caso ci dovesse essere un cast, torno a sovrascrivere il name */
          } else{
            return;
          }
        } else if($scope.itemTypeMap[key] == 'number'){
          if(parseFloat(newItem.name)){
            newItem.value = parseFloat(newItem.name);
          } else{
            return;
          }
        } else{
          newItem.value = newItem.name.toString().replace(/\s/g, '_').toLowerCase();
        }
        for(var i in $scope.selected.model.form[0].items) {
          if($scope.selected.model.form[0].items[i].tabs) {
            $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
              if(key == item.key[0]){
                item.titleMap.push(newItem);
              }
            });
          }
        }
        this.newItem = null;
        $scope.updateScope();
      }
    };

    $scope.deleteItemOnArray = function(key, obj){
      for(var i in $scope.selected.model.form[0].items) {
        if($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            if(key == item.key[0]){
              for (var j = item.titleMap.length; j--; ) {
                if (item.titleMap[j].value == obj.value) {
                  item.titleMap.splice(j, 1);
                }
              }
            }
          });
        }
      }
      this.newItem = null;
      $scope.updateScope();
    };

    $scope.addRefOnArray = function(key, ref) {
      var newItem = {};
      if(ref.record_id != undefined && ref.record_id != null){
        newItem.value = ref.record_id.code;
        newItem.name = ref.record_id.description;
        $scope.addItemOnArray(key, newItem);
      }
    };

    /*****************************************/
    /*************** FIX SCHEMA *************/
    /***************************************/

    $scope.fixSchemaFormModel = function() {
      for(var i in $scope.selected.model.form[0].items) {
        if($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            if(item.type == 'uiselect'){
              $scope.selected.model.schema.properties[item.key[0]].format = 'enum';
            }
            if(item.type == 'uiselectmultiple'){
              $scope.selected.model.schema.properties[item.key[0]].type = 'array';
            }
          });
        }
      }
    };

    /***************************************************************************/
    /***** UTILITY PER DATA BINDING TRA $scope.selected E $scope.aceModel *****/
    /*************************************************************************/

    $scope.isInheritable = function(type){
      return (type == 'number' || type == 'integer' || type == 'string' || type == 'boolean' || type == 'lookup');
    };

    $scope.formChanged = function() {
      $scope.aceModel = JSON.stringify(angular.copy($scope.selected), null, '\t');
    };

    $scope.chargeAceModel = function() {
      var defaultData = angular.fromJson(angular.copy($scope.aceModel));
      if(defaultData) {
        $scope.selected = defaultData;
        $scope.schema = angular.fromJson(defaultData.model.schema);
        $scope.form = angular.fromJson(defaultData.model.form);
        $scope.columnDefs = angular.fromJson(defaultData.model.columnDefs);
      }
    };

    $scope.updateScope = function() {
      $scope.schema = angular.fromJson(angular.copy($scope.selected.model.schema));
      $scope.form = [angular.fromJson(angular.copy($scope.selected.model.form[0]))];
      $scope.columnDefs = angular.fromJson(angular.copy($scope.selected.model.columnDefs));
      $scope.formChanged();
    };

    function addSelectedValue(array, obj) {
      var blankValuePresent = false;
      array.forEach(function (item) {
        if(item.value == obj.value && item.name == obj.name){
          blankValuePresent = true;
        }
      });
      if(blankValuePresent == false){
        array.push(obj);
      }
      return array;
    }

    $scope.getUiSelectMap = function(){
      $scope.uiselectMap = {};
      $scope.itemTypeMap  = {};
      for(var i in $scope.selected.model.form[0].items) {
        if($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            if(item.type !== 'fieldset') {
              $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].type;
              if ($scope.selected.model.schema.properties[item.key[0]].type == 'array') {
                $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].items.type;
              }

              if (item.type == 'uiselect' || item.type == 'uiselectmultiple') {
                var blankObject = {
                  name: '',
                  value: ''
                };
                $scope.uiselectMap[item.key[0]] = addSelectedValue(item.titleMap, blankObject);
                /* aggiunto un elemento vuoto all'array per consentire il deselezionamento */
              }
            }
          });
        }
      }
      console.log($scope.itemTypeMap);
    };

    $scope.aceLoaded = function() {
      var defaultModel = {
        model: {
          schema: {type: "object",
            title: "",
            properties: {
              code: {
                title: "Codice",
                type: "string",
                check: true
              },
              description: {
                title: "Descrizione",
                type: "string",
                check: true
              }
            },
            required: [
              "code",
              "description"
            ]},
          form:[
            {
              type: "fieldset",
              items: [
                {
                  type: "tabs",
                  tabs: [
                    {
                      title: "Dati Base",
                      items: [
                        {
                          key: ["code"],
                          title: "Codice",
                          required: true,
                          type: "text"
                        },
                        {
                          key: ["description"],
                          title: "Descrizione",
                          required: true,
                          type: "text"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          columnDefs:[
            {
              "field": "code",
              "name": "Codice"
            },
            {
              "field": "description",
              "name": "Descrizione"
            }
          ]
        }
      };
      $scope.aceModel = JSON.stringify(defaultModel, null, '\t');
      $scope.chargeAceModel();
      $scope.title = angular.copy($scope.selected.model.form[0].title);
      acquisitionStepFactory().byUUID({id: $routeParams.id}).$promise.then(function (data) {
        if(data.model) {
          $scope.selected.model = angular.copy(data.model);
          $scope.fixSchemaFormModel();
          $scope.schema = angular.copy($scope.selected.model.schema);
          $scope.form = angular.copy($scope.selected.model.form);
          $scope.title = angular.copy($scope.selected.model.form[0].title);
          $scope.code = angular.copy($scope.selected.model.code);
          $scope.description = angular.copy($scope.selected.model.description);
          if($scope.selected.model.columnDefs && ($scope.selected.model.columnDefs.length != 0)) {
            $scope.columnDefs = angular.copy($scope.selected.model.columnDefs);
          } else {
            $scope.columnDefs= [
              { name:'Codice', field: 'code' },
              { name:'Descrizione', field: 'description' }
            ];
            $scope.selected.model.columnDefs = angular.copy($scope.columnDefs);
          }
          angular.forEach($scope.columnDefs, function (value) {
            $scope.selected.model.schema.properties[value.field].check = true;
          });
          $scope.schema = angular.copy($scope.selected.model.schema);
          $scope.aceModel = JSON.stringify($scope.selected, null, '\t');
          $scope.model = {};
          $scope.customForm = angular.copy($scope.selected.model.customForm);
          $scope.history = angular.copy($scope.selected.model.history);
          $scope.attachmentManagement = angular.copy($scope.selected.model.attachmentManagement);
          $scope.getUiSelectMap();
        }
      });
    };

    $scope.$watch('customForm', function() {
      if($scope.selected && $scope.selected.model){
        $scope.selected.model.customForm = $scope.customForm;
        $scope.updateScope();
      }
    });

    $scope.$watch('attachmentManagement', function() {
      if($scope.selected && $scope.selected.model){
        $scope.selected.model.attachmentManagement = $scope.attachmentManagement;
        $scope.updateScope();
      }
    });

    $scope.refreshCode = function(code) {
      $scope.chargeAceModel();
      $scope.selected.model.code = angular.copy(code);
      $scope.updateScope();
    };

    $scope.refreshDescription = function(description) {
      $scope.chargeAceModel();
      if(description) {
        $scope.selected.model.description = angular.copy(description);
        if(angular.isUndefined($scope.selected.UUID)){
          $scope.code = sixStringLib.removeDiacritics(description);
          $scope.code = $scope.code.replace(/[^\w]|_/g, '').replace(/^(\d)(.*)/, '_$1$2').toLowerCase();
          $scope.selected.model.code = angular.copy($scope.code);
        }
      }
      $scope.updateScope();
    };

    $scope.refreshLookup = function(key,entity_id) {
      $scope.chargeAceModel();
      for (var i = $scope.selected.model.form[0].items.length; i--;) {
        if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == key) {
          $scope.selected.model.form[0].items[i].entity_id = angular.copy(entity_id);
        }
        // Scorro anche i tabs
        if($scope.selected.model.form[0].items[i].tabs) {
          for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
            for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
              if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == key) $scope.selected.model.form[0].items[i].tabs[j].items[k].entity_id = angular.copy(entity_id);
            }
          }
        }
      }
      $scope.selected.model.schema.properties[key].entity_id = angular.copy(entity_id);
      $scope.updateScope();
    };

    $scope.refreshCommission = function () {
      $scope.chargeAceModel();
      $scope.selected.model.commission = [];
      angular.forEach($scope.commissionsSelected.codes, function(obj){
        $scope.selected.model.commission.push(obj.code);
      });
      $scope.updateScope();
    };

    $scope.refreshFormula = function(key,formula_id) {
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].formula_id = angular.copy(formula_id);
      $scope.updateScope();
    };

    $scope.refreshFormulaParams = function(key,formula_params){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].formula_params = angular.copy(formula_params);
      $scope.updateScope();
    };

    $scope.refreshBasePath = function(key, basePath){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].basePath = angular.copy(basePath);
      $scope.updateScope();
    };

    $scope.refreshWar = function(key, war){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].war = angular.copy(war);
      $scope.updateScope();
    };

    $scope.refreshInheritRecord = function(key, record){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].record = angular.copy(record);
      $scope.updateScope();
    };

    $scope.refreshInheritField = function(key, field){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].field = angular.copy(field);
      $scope.updateScope();
    };

    $scope.refreshFiltered = function(key, filtered){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].filtered = angular.copy(filtered);
      $scope.updateScope();
    };

    $scope.refreshFilterSourceField = function(key, filterSourceField){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].filterSourceField = angular.copy(filterSourceField);
      $scope.updateScope();
    };

    $scope.refreshFilterDestField = function(key, filterDestField){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].filterDestField = angular.copy(filterDestField);
      $scope.updateScope();
    };

    $scope.refreshTitleForm = function(title) {
      $scope.chargeAceModel();
      $scope.selected.model.form[0].title = angular.copy(title);
      $scope.updateScope();
    };

    $scope.refreshCopyToCheckbox = function(key, enableCopyTo) {
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].enableCopyTo = angular.copy(enableCopyTo);
      if(enableCopyTo == false){
        delete $scope.selected.model.schema.properties[key].copyTo;
      }
      $scope.updateScope();
    };


    $scope.addItemCopyTo = function(key, newItem){
      if(newItem != undefined && newItem.name != null && newItem.name != ''){
        if(!angular.isDefined($scope.selected.model.schema.properties[key].copyTo)){
          $scope.selected.model.schema.properties[key].copyTo = [];
        }
        $scope.selected.model.schema.properties[key].copyTo.push(newItem.name);
        this.newItem = null;
        $scope.updateScope();
      }
    };

    $scope.deleteItemCopyTo = function(key, refName){
      if(angular.isDefined($scope.selected.model.schema.properties[key].copyTo)){
        for (var j = $scope.selected.model.schema.properties[key].copyTo.length; j--; ) {
          if ($scope.selected.model.schema.properties[key].copyTo[j] == refName) {
            $scope.selected.model.schema.properties[key].copyTo.splice(j, 1);
          }
        }
      }
      if($scope.selected.model.schema.properties[key].copyTo.length == 0){
        /* elimino la proprietà per mantenere pulito lo schema */
        $scope.selected.model.schema.properties[key].enableCopyTo = false;
        delete $scope.selected.model.schema.properties[key].copyTo;
      }
      $scope.updateScope();
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:OpfCtrl
 * @description
 * # OpfCtrl
 * Controller of the sixEmmaApp
 */

/**
 * N.B. Il controller principale resta AcquisitionWizardCtrl. Quì c'è solo la logica per lo step OPF,
 * che richiede una gestione un po' particolare non riconducibile al semplice schema/form.
 */
angular.module('emma.consip')
  .controller('OpfCtrl', function ($scope, authFactory, stepToWizardService, $rootScope, $log, $window, ALFRESCO_URL, recordFactory, additionalActsFactory, $q, userFactory) {

    var httpFileRequest = new XMLHttpRequest();
    var MAX_ERR_PERC = 2;
    $scope.serviceMap = {};
    $scope.buildingMap = {};
    $scope.umMap = {};
    $scope.readyToLoadExcel = false;
    var UM =  ' €';
    var EDIFICIO_ID = "edificio_id";
    var UM_ID = "um_id";
    var SERVIZIO_ID = "servizio_id";
    var CLASSE_SERVIZIO_ID = "classeservizio_id";

    var COL = {
        EDIFICIO:           {in: 'Edificio',                    out: 'Cod sito'},
        NOME_EDIFICIO:      {                                   out: 'Nome sito'},
        CLASSE_SERVIZIO:    {                                   out: 'Classe'},
        SERVIZIO:           {in: 'Servizio',                    out: 'Cod servizio'},
        GRUPPO_SERVIZIO:    {in: 'Servizio',                    out: 'Gruppo servizi'},
        TIPO:               {in: 'Tipo',                        out: 'Tipo servizio'},
        DATA_INIZIO :       {in: 'Data inizio',                 out: 'Data inizio'},
        DATA_FINE :         {in: 'Data fine',                   out: 'Data fine'},
        IMPORTO_TOTALE :    {in: 'Importo totale',              out: 'Importo totale'},
        PERC_SCONTO :       {in: '% Sconto',                    out: '% Sconto'},
        QTA :               {in: 'Qta',                         out: 'Qta'},
        INTERVENTI :        {in: 'Interventi',                  out: 'Interventi'},
        PU :                {in: 'PU',                          out: 'PU'},
        UM :                {in: 'UM',                          out: 'UM'},
        IMPORTO_ANNUO :     {in: 'Importo annuo',               out: 'Importo annuo'},
        MESI_EROGAZIONE :   {in: 'Mesi erogazione',             out: 'Mesi erogazione'},
        N_PREST_PER_ANNO :  {in: 'N° prest x anno',             out: 'N° prest x anno'},
        RIDUZ_PER_ATTIVITA :{in: 'Riduzione x attivita canone', out: 'Riduzione x attivita canone'},
        REPERIBILITA :      {in: 'Reperibilita',                out: 'Reperibilita'},
        IMP_TOT_RICALC :    {                                   out: 'Importo totale ricalcolato'},
        IMP_ANNO_RICALC :   {                                   out: 'Importo annuo ricalcolato'},
        ORDER_TYPE:         {                                   out: 'Tipo riga'}
    };

    $scope.gridSeOptions = {
      enableFiltering: true,
      enableOrdering: true,
      onRegisterApi: function(gridApi){
        $scope.gridSeApi = gridApi;
      }
    };

    $scope.gridDveOptions = {
      enableFiltering: true,
      enableOrdering: true,
      onRegisterApi: function(gridApi){
        $scope.gridDveApi = gridApi;
      }
    };

    $scope.clearGrid = function() {
      $scope.reportMessages = [];
      $scope.gridSeOptions.columnDefs = [];
      $scope.gridSeOptions.data = [];
      $scope.gridSeOptions.xlsData = [];
      $scope.gridDveOptions.columnDefs = [];
      $scope.gridDveOptions.data = [];
      $scope.gridDveOptions.xlsData = [];
      $scope.readFileProgressPercent = 0;
    };

    $scope.getInputType = function(modelItem) {
      if(modelItem.type == 'datepicker'){
        return 'date';
      }
      else{
        return modelItem.type;
      }
    };

    $scope.$on( 'schemaFormValidate', function(event, param) {
      var form = document.forms[$scope.opfId];
      var allElements = angular.element(form.getElementsByClassName("sf-form-control"));
      for(var i=0; i<allElements.length; i++){
        var el = $(allElements[i]).parent();
        if(!el.hasClass('form-group')){
          el = el.parent();
        }
        el.addClass('has-success');
      }
      var invElements = angular.element(form.getElementsByClassName("ng-invalid"));
      for(var i=0; i<invElements.length; i++){
        var el = $(invElements[i]).parent();
        if(!el.hasClass('form-group')){
          el = el.parent();
        }
        el.removeClass('has-success');
        el.addClass('has-error');
      }
    });

    httpFileRequest.onload = function(e) {
        var arraybuffer = httpFileRequest.response;

        /* convert data to binary string */
        var data = new Uint8Array(arraybuffer);
        var arr = new Array();
        for(var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
        var bstr = arr.join("");

        /* Call XLSX */
        try{
          var workbook = XLSX.read(bstr, {type:"binary"});
          var headerNames = XLSX.utils.sheet_to_json( workbook.Sheets[workbook.SheetNames[0]], { header: 1 })[0];
          $scope.fileRows = XLSX.utils.sheet_to_json( workbook.Sheets[workbook.SheetNames[0]]);

          resolveRecords();
        }
        catch(err){
          $scope.errorMsg = 'Il file excel caricato presenta un formato non valido.';
          stepToWizardService.lockStepCallback(stepToWizardService.opfIndex);
        }
    };

    function getCellClass(row, col){
        if (row.entity.is_total) {
          return 'font-bold';
        }
        else if( (col.displayName.toLowerCase() ===COL.IMPORTO_ANNUO.out.toLowerCase() ) && (row.entity.err_annuo) ){
          return 'text-danger-dker';
        }
        else if( (col.displayName.toLowerCase() ===COL.IMPORTO_TOTALE.out.toLowerCase() ) && (row.entity.err_totale) ){
          return 'text-danger-dker';
        }
    }

    function initGridSeColumns(){
        $scope.gridSeOptions.columnDefs = [];
        $scope.gridSeOptions.columnDefs.push({ field: COL.TIPO.out, cellClass: function(grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, col); } });
        $scope.gridSeOptions.columnDefs.push({ field: COL.SERVIZIO.out });
        $scope.gridSeOptions.columnDefs.push({ field: COL.GRUPPO_SERVIZIO.out });
        $scope.gridSeOptions.columnDefs.push({ field: COL.CLASSE_SERVIZIO.out });
        $scope.gridSeOptions.columnDefs.push({ field: COL.IMPORTO_ANNUO.out, cellClass: function(grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, col); }, cellFilter: 'currency:"€":3' });
        $scope.gridSeOptions.columnDefs.push({ field: COL.IMPORTO_TOTALE.out, cellClass: function(grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, col); }, cellFilter: 'currency:"€":3' });
        $scope.gridSeOptions.columnDefs.push({ field: COL.IMP_ANNO_RICALC.out, cellClass: function(grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, col); }, cellFilter: 'currency:"€":3' });
        $scope.gridSeOptions.columnDefs.push({ field: COL.IMP_TOT_RICALC.out, cellClass: function(grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, col); }, cellFilter: 'currency:"€":3' });
        $scope.gridSeOptions.columnDefs.push({ field: COL.DATA_INIZIO.out, cellFilter: 'date:"dd/MM/yyyy"' });
        $scope.gridSeOptions.columnDefs.push({ field: COL.DATA_FINE.out, cellFilter: 'date:"dd/MM/yyyy"' });
    }

    function initGridDveColumns(){
        $scope.gridDveOptions.columnDefs = [];
        $scope.gridDveOptions.columnDefs.push({ field: COL.EDIFICIO.out, cellClass: function(grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, col); } });
        $scope.gridDveOptions.columnDefs.push({ field: COL.NOME_EDIFICIO.out });
        $scope.gridDveOptions.columnDefs.push({ field: COL.TIPO.out });
        $scope.gridDveOptions.columnDefs.push({ field: COL.SERVIZIO.out });
        $scope.gridDveOptions.columnDefs.push({ field: COL.GRUPPO_SERVIZIO.out });
        $scope.gridDveOptions.columnDefs.push({ field: COL.CLASSE_SERVIZIO.out });
        $scope.gridDveOptions.columnDefs.push({ field: COL.PU.out, cellFilter: 'currency:"€":3' });
        $scope.gridDveOptions.columnDefs.push({ field: COL.QTA.out });
        $scope.gridDveOptions.columnDefs.push({ field: COL.UM.out });
        $scope.gridDveOptions.columnDefs.push({ field: COL.MESI_EROGAZIONE.out });
        $scope.gridDveOptions.columnDefs.push({ field: COL.IMPORTO_ANNUO.out, cellClass: function(grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, col); }, cellFilter: 'currency:"€":3' });
        $scope.gridDveOptions.columnDefs.push({ field: COL.IMPORTO_TOTALE.out, cellClass: function(grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, col); }, cellFilter: 'currency:"€":3' });
        $scope.gridDveOptions.columnDefs.push({ field: COL.IMP_ANNO_RICALC.out, cellClass: function(grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, col); }, cellFilter: 'currency:"€":3' });
        $scope.gridDveOptions.columnDefs.push({ field: COL.IMP_TOT_RICALC.out, cellClass: function(grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, col); }, cellFilter: 'currency:"€":3' });
        $scope.gridDveOptions.columnDefs.push({ field: COL.DATA_INIZIO.out, cellFilter: 'date:"dd/MM/yyyy"' });
        $scope.gridDveOptions.columnDefs.push({ field: COL.DATA_FINE.out, cellFilter: 'date:"dd/MM/yyyy"' });
    }

    function calcGridDveRow(input){
        var output = {};

        // Edificio
        var buildingCode = input[COL.EDIFICIO.in];
        output[COL.EDIFICIO.out] = buildingCode;
        if(angular.isUndefined($scope.buildingMap[buildingCode])){
          output[COL.NOME_EDIFICIO.out] = '-';
          $scope.anagraphicError = true;
        }
        else{
          output[COL.NOME_EDIFICIO.out] = $scope.buildingMap[buildingCode].description;
          output[EDIFICIO_ID] =  $scope.buildingMap[buildingCode].edificioRef;
        }

        // Servizio
        var serviceCode = input[COL.GRUPPO_SERVIZIO.in];
        var unaTantum = false;
        if(angular.isUndefined($scope.serviceMap[serviceCode])){
          output[COL.CLASSE_SERVIZIO.out] = '-';
          $scope.anagraphicError = true;
        }
        else{
          output[COL.GRUPPO_SERVIZIO.out] = $scope.serviceMap[serviceCode].gruppo;
          output[COL.CLASSE_SERVIZIO.out] = $scope.serviceMap[serviceCode].classe;
          unaTantum = $scope.serviceMap[serviceCode].unaTantum;
          output[SERVIZIO_ID] =  $scope.serviceMap[serviceCode].servizioRef;
          output[CLASSE_SERVIZIO_ID] =  $scope.serviceMap[serviceCode].classeServizioRef;
        }
        output[COL.SERVIZIO.out] = serviceCode;

        // UM
        var umCode = input[COL.UM.in];
        output[COL.UM.out] = umCode;
        var tmpUmCode = umCode.replace(/\//g, '_').toLowerCase();
        if(angular.isUndefined($scope.umMap[tmpUmCode])){
          output[COL.UM.out] = '-';
          $scope.anagraphicError = true;
        }
        else{
          output[COL.UM.out] = $scope.umMap[tmpUmCode].description;
          output[UM_ID] =  $scope.umMap[tmpUmCode].umRef;
        }

        // Totali
        var qta = parseFloat(input[COL.QTA.in]);
        var pu = parseFloat(input[COL.PU.in]);
        var sconto = parseFloat(input[COL.PERC_SCONTO.in]);
        var mesi = parseFloat(input[COL.MESI_EROGAZIONE.in]);
        var nPrestAnno = parseFloat(input[COL.N_PREST_PER_ANNO.in]);
        var ridAtt = parseFloat(input[COL.RIDUZ_PER_ATTIVITA.in]);
        if(!isNaN(nPrestAnno) && qta==1){
            qta = nPrestAnno;
        }
        if(!isNaN(sconto)){
            sconto = sconto/100;
            pu = pu - (sconto*pu);
        }
        if(!isNaN(ridAtt)){
            ridAtt = ridAtt/100;
            pu = pu - (ridAtt*pu);
        }
        var tot_year, tot_month, tot_total;
        if(unaTantum){
          tot_total = pu*qta;
          tot_month = tot_total/mesi;
          tot_year = tot_month*12;
        }
        else{
          tot_year = pu*qta;
          tot_month = tot_year/12;
          tot_total = tot_month*mesi;
        }
        var tot_total_excel = parseFloat(input[COL.IMPORTO_TOTALE.in]);
        var tot_year_excel = parseFloat(input[COL.IMPORTO_ANNUO.in]);
        var err_perc_year = Math.abs((tot_year-tot_year_excel)*100/tot_year);
        var err_perc_total = Math.abs((tot_total-tot_total_excel)*100/tot_total);

        output[COL.QTA.out] = qta;
        output[COL.MESI_EROGAZIONE.out] = mesi;
        output[COL.N_PREST_PER_ANNO.out] = nPrestAnno;
        output[COL.PU.out] = input[COL.PU.in];
        output[COL.IMPORTO_ANNUO.out] = input[COL.IMPORTO_ANNUO.in];
        output[COL.IMPORTO_TOTALE.out] = input[COL.IMPORTO_TOTALE.in];
        output[COL.IMP_ANNO_RICALC.out] = tot_year;
        output[COL.IMP_TOT_RICALC.out] = tot_total;
        output.num_annuo_ricalc = tot_year;
        output.num_total_ricalc = tot_total;
        output.num_annuo_excel = tot_year_excel;
        output.num_total_excel = tot_total_excel;
        output.err_annuo = (err_perc_year>MAX_ERR_PERC)?true:false;
        output.err_totale = (err_perc_total>MAX_ERR_PERC)?true:false;

        $scope.opfModel.opf_totals.complessivoRicalcolato += tot_total;
        $scope.opfModel.opf_totals.annuoRicalcolato += tot_year;
        $scope.opfModel.opf_totals.complessivoExcel += tot_total_excel;
        $scope.opfModel.opf_totals.annuoExcel += tot_year_excel;

        // Tipo: 'canone' o 'extra canone'
        if(input[COL.TIPO.in]==='C'){
            output[COL.TIPO.out] = 'canone';
            $scope.opfModel.opf_totals.canone += tot_total_excel;
        }
        else if(input[COL.TIPO.in]==='EC'){
            output[COL.TIPO.out] = 'extra canone';
            $scope.opfModel.opf_totals.extraCanone += tot_total_excel;
        }
        else{
            output[COL.TIPO.out] = input[COL.TIPO.in];
        }

        // Date inizio e fine
        var dateIn = input[COL.DATA_INIZIO.in].split("/");
        var dateInObject = new Date(dateIn[2], dateIn[1] - 1, dateIn[0]);
        var dateOut = input[COL.DATA_FINE.in].split("/");
        var dateOutObject = new Date(dateOut[2], dateOut[1] - 1, dateOut[0]);
        output[COL.DATA_INIZIO.out] = dateInObject;
        output[COL.DATA_FINE.out] = dateOutObject;

        return output;
    }

    function calcOrderRow(input){
        var acquisitionUUID;
        var orderType;
        if(angular.isDefined($scope.wizard.model.source_acquisition_id)){
            acquisitionUUID = $scope.wizard.model.source_acquisition_id.UUID;
            orderType = 'aa';
        }
        else{
            acquisitionUUID = $scope.wizard.UUID;
            orderType = 'opf';
        }
        var output = {
            customer: [ $scope.wizard.model.client_id.UUID ],
            acquisition_uuid: acquisitionUUID,
            model: {
                code: $scope.opfModel.code
            }
        };

        var tmp = {};

        // Edificio
        var buildingCode = input[COL.EDIFICIO.in];
        tmp[EDIFICIO_ID] =  $scope.buildingMap[buildingCode].edificioRef;

        // Servizio
        var serviceCode = input[COL.GRUPPO_SERVIZIO.in];
        tmp[SERVIZIO_ID] =  $scope.serviceMap[serviceCode].servizioRef;
        tmp[CLASSE_SERVIZIO_ID] =  $scope.serviceMap[serviceCode].classeServizioRef;
        var unaTantum = $scope.serviceMap[serviceCode].unaTantum;

        // UM
        var umCode = input[COL.UM.in];
        var tmpUmCode = umCode.replace(/\//g, '_').toLowerCase(9);
        tmp[UM_ID] =  $scope.umMap[tmpUmCode].umRef;

        // Totali
        var qta = parseFloat(input[COL.QTA.in]);
        var pu = parseFloat(input[COL.PU.in]);
        var sconto = parseFloat(input[COL.PERC_SCONTO.in]);
        var mesi = parseFloat(input[COL.MESI_EROGAZIONE.in]);
        var nPrestAnno = parseFloat(input[COL.N_PREST_PER_ANNO.in]);
        var ridAtt = parseFloat(input[COL.RIDUZ_PER_ATTIVITA.in]);
        var interventi = parseFloat(input[COL.INTERVENTI.in]);
        if(!isNaN(nPrestAnno) && qta==1){
            qta = nPrestAnno;
        }
        if(!isNaN(sconto)){
            sconto = sconto/100;
            pu = pu - (sconto*pu);
        }
        if(!isNaN(ridAtt)){
            ridAtt = ridAtt/100;
            pu = pu - (ridAtt*pu);
        }
        var tot_year, tot_month, tot_total;
        if(unaTantum){
          tot_total = pu*qta;
          tot_month = tot_total/mesi;
          tot_year = tot_month*12;
        }
        else{
          tot_year = pu*qta;
          tot_month = tot_year/12;
          tot_total = tot_month*mesi;
        }
        var tot_total_excel = parseFloat(input[COL.IMPORTO_TOTALE.in]);
        var tot_year_excel = parseFloat(input[COL.IMPORTO_ANNUO.in]);
        var err_perc_year = Math.abs((tot_year-tot_year_excel)*100/tot_year);
        var err_perc_total = Math.abs((tot_total-tot_total_excel)*100/tot_total);

        tmp[COL.IMPORTO_ANNUO.out] = parseFloat(input[COL.IMPORTO_ANNUO.in]);
        tmp[COL.IMPORTO_TOTALE.out] = parseFloat(input[COL.IMPORTO_TOTALE.in]);
        tmp[COL.IMP_ANNO_RICALC.out] = tot_year;
        tmp[COL.IMP_TOT_RICALC.out] = tot_total;
        tmp.num_annuo_ricalc = tot_year;
        tmp.num_total_ricalc = tot_total;
        tmp.num_annuo_excel = tot_year_excel;
        tmp.num_total_excel = tot_total_excel;
        tmp.err_annuo = (err_perc_year>MAX_ERR_PERC)?true:false;
        tmp.err_totale = (err_perc_total>MAX_ERR_PERC)?true:false;

        // Tipo: 'canone' o 'extra canone'
        if(input[COL.TIPO.in]==='C'){
            tmp[COL.TIPO.out] = 'canone';
        }
        else if(input[COL.TIPO.in]==='EC'){
            tmp[COL.TIPO.out] = 'extra canone';
        }
        else{
            tmp[COL.TIPO.out] = input[COL.TIPO.in];
        }

        // Date inizio e fine
        var dateIn = input[COL.DATA_INIZIO.in].split("/");
        var dateInObject = new Date(dateIn[2], dateIn[1] - 1, dateIn[0]);
        var dateOut = input[COL.DATA_FINE.in].split("/");
        var dateOutObject = new Date(dateOut[2], dateOut[1] - 1, dateOut[0]);
        tmp[COL.DATA_INIZIO.out] = dateInObject;
        tmp[COL.DATA_FINE.out] = dateOutObject;

        tmp[COL.PU.out] = isNaN(pu)?0.0:pu*1.0;
        tmp[COL.SERVIZIO.out] = input[COL.SERVIZIO.in];
        tmp[COL.QTA.out] = isNaN(qta)?0.0:qta*1.0;
        tmp[COL.MESI_EROGAZIONE.out] = isNaN(mesi)?0:mesi;
        tmp[COL.N_PREST_PER_ANNO.out] = isNaN(nPrestAnno)?0:nPrestAnno;

        tmp[COL.ORDER_TYPE.out] = orderType;

        // Altri dati che non mostro a video
        /*
        tmp[COL.PERC_SCONTO.out] = isNaN(sconto)?0:sconto;
        tmp[COL.INTERVENTI.out] = isNaN(interventi)?0:interventi;
        tmp[COL.RIDUZ_PER_ATTIVITA.out] = isNaN(ridAtt)?0:ridAtt;
        tmp[COL.REPERIBILITA.out] = (input[COL.REPERIBILITA.in]==="0")?false:true;
        */
        Object.keys(tmp).forEach(function(key,index) {
            var newKey = key.split(' ').join('_').toLowerCase();
            newKey = newKey.replace(/°/g, '_');
            var tmpValue = tmp[key];

            if(tmpValue && tmpValue instanceof Date && !isNaN(tmpValue.valueOf())) {  // controllo se è una data valida ...
              output.model[newKey] = tmpValue;
            } else if(tmpValue && !isNaN(tmpValue)) { // ... se è un numero ..
              output.model[newKey] = parseFloat(tmpValue)*1.0;
            } else {  // ... qualsiasi altra cosa
              output.model[newKey] = tmpValue;
            }
        });

        return output;
    }

    function calcGridSeRow(dveRow){
        var serviceCode = dveRow[COL.TIPO.out] + '_' + dveRow[COL.GRUPPO_SERVIZIO.out];
        var serviceIndex = $scope.seServices.codes.indexOf(serviceCode);
        if(serviceIndex == -1) {
            $scope.seServices.codes.push(serviceCode);
            serviceIndex = $scope.seServices.codes.indexOf(serviceCode);
            var newData = angular.copy(dveRow);
            newData.num_annuo_ricalc = 0;
            newData.num_total_ricalc = 0;
            newData.num_annuo_excel = 0;
            newData.num_total_excel = 0;
            $scope.seServices.data.push(newData);
        }
        $scope.seServices.data[serviceIndex].num_annuo_ricalc += parseFloat(dveRow.num_annuo_ricalc);
        $scope.seServices.data[serviceIndex].num_total_ricalc += parseFloat(dveRow.num_total_ricalc);
        $scope.seServices.data[serviceIndex].num_annuo_excel += parseFloat(dveRow.num_annuo_excel);
        $scope.seServices.data[serviceIndex].num_total_excel += parseFloat(dveRow.num_total_excel);
    }

    function addSeRows(){
        $scope.seServices.data.forEach(function(row){
          row[COL.IMPORTO_ANNUO.out] = row.num_annuo_excel;
          row[COL.IMPORTO_TOTALE.out] = row.num_total_excel;
          row[COL.IMP_ANNO_RICALC.out] = row.num_annuo_ricalc;
          row[COL.IMP_TOT_RICALC.out] = row.num_total_ricalc;
          var err_perc_year = Math.abs((row.num_annuo_ricalc-row.num_annuo_excel)*100/row.num_annuo_ricalc);
          var err_perc_total = Math.abs((row.num_total_ricalc-row.num_total_excel)*100/row.num_total_ricalc);
          row.err_annuo = (err_perc_year>MAX_ERR_PERC)?true:false;
          row.err_totale = (err_perc_total>MAX_ERR_PERC)?true:false;
          $scope.gridSeOptions.data = $scope.gridSeOptions.data.concat( row );
        });
    }

    function addTotals(){
        $scope.wizard.partial_plafond = $scope.opfModel.opf_totals.complessivoExcel;

        var dveTotal = { is_total: true };
        var seTotal = { is_total: true };

        $scope.opfModel.opf_totals.canone = parseFloat($scope.opfModel.opf_totals.canone);
        $scope.opfModel.opf_totals.extraCanone = parseFloat($scope.opfModel.opf_totals.extraCanone);
        $scope.opfModel.opf_totals.complessivoRicalcolato = parseFloat($scope.opfModel.opf_totals.complessivoRicalcolato);
        $scope.opfModel.opf_totals.annuoRicalcolato = parseFloat($scope.opfModel.opf_totals.annuoRicalcolato);
        $scope.opfModel.opf_totals.complessivoExcel = parseFloat($scope.opfModel.opf_totals.complessivoExcel);
        $scope.opfModel.opf_totals.annuoExcel = parseFloat($scope.opfModel.opf_totals.annuoExcel);

        $scope.opfModel.reserved_amount = $scope.opfModel.opf_totals.extraCanone;

        dveTotal[COL.EDIFICIO.out] = "Totali:";
        dveTotal[COL.IMPORTO_ANNUO.out] = $scope.opfModel.opf_totals.annuoExcel;
        dveTotal[COL.IMPORTO_TOTALE.out] = $scope.opfModel.opf_totals.complessivoExcel;
        dveTotal[COL.IMP_ANNO_RICALC.out] = $scope.opfModel.opf_totals.annuoRicalcolato;
        dveTotal[COL.IMP_TOT_RICALC.out] = $scope.opfModel.opf_totals.complessivoRicalcolato;
        $scope.gridDveOptions.data = $scope.gridDveOptions.data.concat( dveTotal );
        seTotal[COL.TIPO.out] = "Totali:";
        seTotal[COL.IMPORTO_ANNUO.out] = $scope.opfModel.opf_totals.annuoExcel;
        seTotal[COL.IMPORTO_TOTALE.out] = $scope.opfModel.opf_totals.complessivoExcel;
        seTotal[COL.IMP_ANNO_RICALC.out] = $scope.opfModel.opf_totals.annuoRicalcolato;
        seTotal[COL.IMP_TOT_RICALC.out] = $scope.opfModel.opf_totals.complessivoRicalcolato;
        $scope.gridSeOptions.data = $scope.gridSeOptions.data.concat( seTotal );
    }

    function loadPdiExcelFile(){
        initGridDveColumns();
        initGridSeColumns();
        $scope.gridDveOptions.xlsData = $scope.fileRows;
        $scope.gridDveOptions.data = [];
        $scope.gridSeOptions.xlsData = $scope.fileRows;
        $scope.gridSeOptions.data = [];

        $scope.readFileProgressPercent = 0;
        var done = 0;
        var tot = $scope.fileRows.length;
        var mult = 100/tot;
        $scope.progressApplied = false;
        $scope.opfModel.opf_totals = {
          canone: 0,
          extraCanone: 0,
          complessivoRicalcolato: 0,
          annuoRicalcolato: 0,
          complessivoExcel: 0,
          annuoExcel:0
        };
        $scope.seServices = {
          codes: [],
          data: []
        };
        $scope.wizard.model.order_rows = [];
        $scope.fileRows.forEach(function(value){
            done++;
            var dveRow = calcGridDveRow(value);
            $scope.gridDveOptions.data = $scope.gridDveOptions.data.concat( dveRow );
            //var orderRow = calcOrderRow(dveRow);
            if(!$scope.anagraphicError){
                var orderRow = calcOrderRow(value);
                $scope.wizard.model.order_rows.push(orderRow);
            }
            var seRow = calcGridSeRow(dveRow);
            $scope.readFileProgressPercent = done*mult;
            if(!$scope.progressApplied || done==tot){
                $scope.progressApplied = true;
                setTimeout(function () {
                    if(! $rootScope.$root.$$phase) {
                        $scope.$digest();
                        $scope.progressApplied = false;
                    }
                }, 200);
            }
        });
        addSeRows();
        addTotals();
        stepToWizardService.unlockStepCallback(stepToWizardService.opfIndex);
    }

    function resolveRecords(){
      var payload = {
          page_size: 10000
      };
      var myPromises = {
          services:   recordFactory('servizio').query(payload).$promise,
          buildings:  recordFactory('edificio').query(payload).$promise,
          ums:  recordFactory('um').query(payload).$promise
      };

      $q.all(myPromises).then(function(responses) {
          resolveServices(responses.services);
          resolveBuildings(responses.buildings);
          resolveUms(responses.ums);
          $scope.anagraphicError = false;
          loadPdiExcelFile();
          if($scope.anagraphicError){
            stepToWizardService.lockStepCallback(stepToWizardService.opfIndex);
          }
      });

    }

    function resolveServices(response){
        if(response.totalResults>0){
          // Compongo un oggetto con le descrizioni dei servizi
          var services = response.list;
          services.forEach(function(item){
            $scope.serviceMap[item.model.code] = {};
            $scope.serviceMap[item.model.code].gruppo = item.model.description;
            $scope.serviceMap[item.model.code].classe = (angular.isDefined(item.model.classeservizio_id))?item.model.classeservizio_id.description:'-';
            $scope.serviceMap[item.model.code].unaTantum = (item.model.una_tantum)?true:false;
            $scope.serviceMap[item.model.code].servizioRef = sixObjectLib.recordToHisRef(item);
            $scope.serviceMap[item.model.code].classeServizioRef = item.model.classeservizio_id;
          });
        }
    }

    function resolveBuildings(response){
        if(response.totalResults>0){
          // Compongo un oggetto con le descrizioni degli edifici
          var buildings = response.list;
          buildings.forEach(function(item){
            $scope.buildingMap[item.model.code] = {};
            $scope.buildingMap[item.model.code].description = item.model.description;
            $scope.buildingMap[item.model.code].edificioRef = sixObjectLib.recordToHisRef(item);
          });
        }
    }

    function resolveUms(response){
      if(response.totalResults>0){
        // Compongo un oggetto con le descrizioni degli edifici
        var ums = response.list;
        ums.forEach(function(item){
          $scope.umMap[item.model.code] = {};
          $scope.umMap[item.model.code].description = item.model.description;
          $scope.umMap[item.model.code].umRef = sixObjectLib.recordToHisRef(item);
        });
      }
    }

    function fixDates(opfModel){
      if(angular.isDefined(opfModel)){
        $scope.opfForm[0].items.forEach(function(item){
          item.tabs.forEach(function(tab){
            tab.items.forEach(function(model_item){
              if(model_item.type==='datepicker'){
                var propertyName = model_item.key[0];
                if(angular.isDefined(opfModel[propertyName]) && opfModel[propertyName]!=null){
                  opfModel[propertyName] = new Date(opfModel[propertyName]);
                }
              }
            });
          });
        });
      }
      return opfModel;
    }

    $scope.readPdiExcelFile = function(file){
        httpFileRequest.open("GET", file, true);
        httpFileRequest.responseType = "arraybuffer";
        httpFileRequest.send();
    };


    function getAdditionalActsTotals(){
        var payload = {
          step_id: $scope.opfId,
          attribute: 'opf_totals',
          list: []
        };
        if(angular.isDefined($scope.wizard.model.additional_acts)){
            for(var i=0; i<$scope.wizard.model.additional_acts.length; i++){
              var act = $scope.wizard.model.additional_acts[i];
              if(angular.isDefined(act.required_plafond)){
                  payload.list.push(act.UUID);
              }
          }
          additionalActsFactory.getAttributes(payload).$promise.then(function(data){
              if(data.response.total_results>0){
                  $scope.opfAdditionalTotals = [];
                  $scope.opfAdditionalTotalsSum = {
                      canone: 0,
                      extraCanone: 0,
                      complessivoExcel: 0
                  };
                  $scope.opfAdditionalTotals = data.response.list;
                  for(var i=0; i<data.response.total_results; i++){
                      var tot = data.response.list[i].opf_totals;
                      $scope.opfAdditionalTotalsSum.canone += tot.canone;
                      $scope.opfAdditionalTotalsSum.extraCanone += tot.extraCanone;
                      $scope.opfAdditionalTotalsSum.complessivoExcel += tot.complessivoExcel;
                  }
              }
          });
      }
    }

    $scope.$watch('opfModel.code',
        function(newValue, oldValue) {
            if(angular.isDefined($scope.wizard.model.order_rows)){
                $scope.wizard.model.order_rows.forEach(function(item){
                    item.model.code = $scope.opfModel.code;
                });
            }
        }
    );

    function initController(){
        $scope.opfIndex = stepToWizardService.opfIndex;
        $scope.opfId = 'step' + ($scope.opfIndex+1);
        $scope.opfSchema = stepToWizardService.opfSchema;
        $scope.opfForm = stepToWizardService.opfForm;
        $scope.opfModel = fixDates(stepToWizardService.opfModel);
        getAdditionalActsTotals();
        $scope.data = {};
        $scope.data.model = stepToWizardService.opfModel;
        $scope.opfRef = getOpfRef();

        if(angular.isDefined($scope.wizard.model.approved_xls_quote)){
          var objectId = $scope.wizard.model.approved_xls_quote.replace('workspace://SpacesStore/', '$WorkspaceSpacesStore$');
          $scope.readPdiExcelFile(ALFRESCO_URL + '/api/alfresco/' + objectId);
        }
        else{
          $scope.clearGrid();
        }
    }


    // ***** EXPORT ***** //

    var currentContract = authFactory.getAuthData().info.commissions.current;

    $scope.exportSe = function() {
      sixExportLib.exportXLSXVisibleRowsGrid($scope.gridSeApi, currentContract.code + '_opf_se_' + $scope.wizard.model.client_id.code);
    };

    $scope.exportDve = function() {
      sixExportLib.exportXLSXVisibleRowsGrid($scope.gridDveApi, currentContract.code + '_opf_dve_' + $scope.wizard.model.client_id.code);
    };

    //__main__
    stepToWizardService.initOpfCallback = initController;
    initController();



    /** ***********************************
     * Messaggi e notifiche
     * ***********************************/

    $scope.loadingSixMail = true;

    $scope.opfRef = null;

    function getOpfRef(){
      var ref = null;
      if($scope.wizard){
        ref = {
          type: $scope.wizard.schemaCode,
          UUID: $scope.wizard.UUID,
          code: $scope.wizard.model.code,
          description: $scope.wizard.model.description
        }
      }
      return ref;
    }

    $scope.getMessage = function () {   /* creazione testo mail */
      var searchInit = {
        search: {  obj: {'username':authFactory.getAuthData().authId}  },
        init: { authId: true,  email: true }
      };
      var promiseMailUser = userFactory.getMail(searchInit).$promise;
      $scope.loadingSixMail = true;
      Promise.all([promiseMailUser]).then(function (response) {
        $scope.loadingSixMail = false;
        $scope.objMail = {
          title: '',
          to: '',
          cc: formatMailCc(response[0].list[0].email),
          message: 'Testo di esempio da sostituire'
        }
      });
    };

    function formatMailCc (UserMailSix) {
      if(UserMailSix){
        return UserMailSix;
      } else {
        return null;
      }
    }

  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:PdiCtrl
 * @description
 * # PdiCtrl
 * Controller of the sixEmmaApp
 */

/**
 * N.B. Il controller principale resta AcquisitionWizardCtrl. Quì c'è solo la logica per lo step PDI,
 * che richiede una gestione un po' particolare non riconducibile al semplice schema/form.
 */
angular.module('emma.consip')
  .constant('REVISION_INSERTED', 0)
  .constant('REVISION_APPROVED', 1)
  .constant('REVISION_REFUSED', 2)
  .controller('PdiCtrl', function ($scope, authFactory, FileUploader, stepToWizardService, $rootScope, alfrescoFactory, ALFRESCO_URL, $log,
                                    REVISION_INSERTED, REVISION_APPROVED, REVISION_REFUSED) {

    $scope.newRevision;
    $scope.upload={ show:false,
                    errors: [],
                    warnings: [],
                    pupupEmissionOpened: false,
                    pupupApprovalOpened: false,
                    pupupRefusalOpened: false
                  };

    // var DESTINATION = "/Sites/emma/documentLibrary/" + authFactory.getAuthData().info.commissions.current.code;
    var DESTINATION = "/Sites/consip/" + authFactory.getAuthData().info.commissions.current.code;
    $scope.DOWNLOAD_URL = ALFRESCO_URL + "/api/alfresco/";

    var uploader = $scope.uploader = new FileUploader({
                                            url: 'six-alfresco/upload',
                                            formData: [
                                                {destination: DESTINATION}
                                            ]
                                        });

    $scope.editing = [];

    $scope.confirmDisabled = function(){
        var result;
        var noFiles = uploader.getNotUploadedItems().length==0;
        var noEmissionDate = angular.isUndefined($scope.revision.date_emission) || $scope.revision.date_emission==='' || $scope.revision.date_emission===null;
        var noRevisionNumber = angular.isUndefined($scope.revision.revision_number) || $scope.revision.revision_number==='';
        result = noFiles || noEmissionDate || noRevisionNumber || (!$scope.hasXls);
        return result;
    };

    $scope.undoUpload = function(){
        $scope.upload.show = false;
        uploader.clearQueue();
        $scope.upload.warnings.length = 0;
    };

    $scope.loadQuote = function() {
        $scope.upload.show = true;
        $scope.upload.errors.length = 0;
        $scope.upload.warnings.length = 0;
        $scope.upload.completed = false;
        $scope.newRevision = true;
        $scope.hasXls = false;
        $scope.revision = {
           date_emission: new Date(),
           revision_number: undefined,
           files: []
        };
        uploader.clearQueue();
        angular.element('#fileUploadBtn').trigger('click');
    };

    $scope.addQuote = function() {
        angular.element('#fileUploadBtn').trigger('click');
    };

    $scope.approveQuote = function(revision, index){
        if(angular.isDefined(revision.date_refusal)){
            // Revisione vecchia, la archivio.
            var oldRevision = jQuery.extend(true, {}, revision);
            oldRevision.date_out = new Date();
            delete oldRevision['selected'];
            $scope.revisions.splice(index, 0, oldRevision);
            index++;
        }
        revision.approval_status = REVISION_APPROVED;
        revision.selected = true;
        revision.date_approval = new Date();
        $scope.wizard.model.approved_xls_quote = getApprovedExcel(revision);
        delete revision.date_refusal;
        // Se avevo già un'altra revisione approvata la rifiuto. Altrimenti salvo e bona.
        var list = getApprovedRevisions();
        var found = false;
        if(list.length>0){
            for(var i=0; i<list.length; i++){
                if(list[i]!=index){
                    found = true;
                    $scope.refuseQuote($scope.revisions[list[i]],list[i]);
                }
            }
        }
        if(!found){
            checkLockStepApproval();
            saveStep("$scope.approveQuote");
        }
    };

    function getApprovedExcel(revision){
        var excelPath = undefined;
        if(revision.selected){
            for(var i=0; i<revision.files.length; i++){
                var file = revision.files[i];
                if(isExcel(file.title)){
                    excelPath = file.object_id;
                    break;
                }
            }
        }
        return excelPath;
    }

    $scope.differentFromPrevious = function(index){
        var result = true;
        if(index>0){
            result = ($scope.revisions[index].revision_number!==$scope.revisions[index-1].revision_number);
        }
        return result;
    };

    $scope.startEditQuote = function(index){
        $scope.datesError = false;
        $scope.editing[index] = true;
        $scope.editingMode = true;
        $scope.editData = {};
        if(angular.isDefined($scope.revisions[index].date_approval)){
            $scope.editData.date_approval = new Date($scope.revisions[index].date_approval);
        }
        if(angular.isDefined($scope.revisions[index].date_emission)){
            $scope.editData.date_emission = new Date($scope.revisions[index].date_emission);
        }
        if(angular.isDefined($scope.revisions[index].date_refusal)){
            $scope.editData.date_refusal = new Date($scope.revisions[index].date_refusal);
        }
    };

    $scope.areDatesValid = function(index){
        $scope.datesError = false;
        if(!$scope.editData.date_emission){
            $scope.datesError |= true;
        }
        if(!$scope.datesError && angular.isDefined($scope.revisions[index].date_approval)){
            if(angular.isUndefined($scope.editData.date_approval)){
                $scope.datesError |= true;
            }
            else{
                $scope.datesError |= ($scope.editData.date_approval<$scope.editData.date_emission);
            }
        }
        if(!$scope.datesError && angular.isDefined($scope.revisions[index].date_refusal)){
            if(angular.isUndefined($scope.editData.date_refusal)){
                $scope.datesError |= true;
            }
            else{
                $scope.datesError |= ($scope.editData.date_refusal<$scope.editData.date_emission);
            }
        }
        return (!$scope.datesError);
    };

    $scope.stopEditQuote = function(index){
        if($scope.areDatesValid(index)){
            $scope.editing[index] = false;
            $scope.editingMode = false;
            if(angular.isDefined($scope.editData.date_approval)){
                $scope.revisions[index].date_approval = $scope.editData.date_approval;
            }
            if(angular.isDefined($scope.editData.date_emission)){
                $scope.revisions[index].date_emission = $scope.editData.date_emission;
                for(var i=index-1; i>=0; i--){
                    if($scope.revisions[index].revision_number===$scope.revisions[i].revision_number){
                        $scope.revisions[i].date_emission = $scope.pupupEmissionOpenededitData.date_emission;
                    }
                    else{
                        break;
                    }
                }
            }
            if(angular.isDefined($scope.editData.date_refusal)){
                $scope.revisions[index].date_refusal = $scope.editData.date_refusal;
            }
            saveStep("$scope.stopEditQuote");
        }
    };

    $scope.undoEditQuote = function(index){
        $scope.editing[index] = false;
        $scope.editingMode = false;
    };

    $scope.refuseQuote = function(revision, index){
        delete revision['selected'];
        if(angular.isDefined(revision.date_approval)){
            // Revisione vecchia, la archivio.
            var oldRevision = jQuery.extend(true, {}, revision);
            oldRevision.date_out = new Date();
            $scope.revisions.splice(index, 0, oldRevision);
            if(!existsSelectedRevision()){
                $scope.wizard.model.approved_xls_quote = undefined;
            }
        }
        revision.approval_status = REVISION_REFUSED;
        revision.date_refusal = new Date();
        delete revision.date_approval;
        checkLockStepApproval();
        saveStep("$scope.refuseQuote");
    };

    function existsSelectedRevision(){
      var exists = false;
      for(var i=0; i<$scope.revisions.length; i++){
          if($scope.revisions[i].selected){
              exists = true;
              break;
          }
      }
      return exists;
    }

    $scope.isInserted = function(revision,index) {
        if(angular.isDefined(index)){
            for(var i=index+1; i<$scope.revisions.length; i++){
                var different = $scope.differentFromPrevious(i);
                if(!different){
                    revision =  $scope.revisions[i];
                }
                else{
                    break;
                }
            }
        }
        var result = revision.approval_status===REVISION_INSERTED;
        return result;
    };

    $scope.isRefused = function(revision,index) {
        if(angular.isDefined(index)){
            for(var i=index+1; i<$scope.revisions.length; i++){
                var different = $scope.differentFromPrevious(i);
                if(!different){
                    revision =  $scope.revisions[i];
                }
                else{
                    break;
                }
            }
        }
        var result = revision.approval_status===REVISION_REFUSED;
        return result;
    };

    $scope.isApproved = function(revision,index) {
        if(angular.isDefined(index)){
            for(var i=index+1; i<$scope.revisions.length; i++){
                var different = $scope.differentFromPrevious(i);
                if(!different){
                    revision =  $scope.revisions[i];
                }
                else{
                    break;
                }
            }
        }
        var result = revision.approval_status===REVISION_APPROVED;
        return result;
    };

    $scope.isOld = function(revision) {
        var result = angular.isDefined(revision.date_out);
        return result;
    };

    //TEMPORANEO DA CANCELLARE!! Solo per test in fase di sviluppo.
    $scope.reset = function(){
        stepToWizardService.pdiModel.revisions.length = 0;
        saveStep("$scope.reset");
    };

    function saveStep(caller){
        $log.warn(caller);
        stepToWizardService.saveCallback();
    }

    $rootScope.$on( 'acquisitionWizard:readonlyChange', function(event,param) {
        $scope.readonlyMode = param[stepToWizardService.pdiIndex];
    });

    function getApprovedRevisions(){
        var array = [];
        if(angular.isDefined(stepToWizardService.pdiModel.revisions)){
            for(var i=0; i<stepToWizardService.pdiModel.revisions.length; i++){
                var revision = stepToWizardService.pdiModel.revisions[i];
                if( angular.isUndefined(revision.date_out) && (revision.approval_status===REVISION_APPROVED)){
                    array.push(i);
                }
            }
        }
        return array;
    }

    function checkLockStepApproval(){
        var locked = !(getApprovedRevisions().length>0);
        if(locked){
            stepToWizardService.lockStepCallback(stepToWizardService.pdiIndex);
        }
        else{
            stepToWizardService.unlockStepCallback(stepToWizardService.pdiIndex);
        }
    }

    function printUploadError(errorMessage){
        $scope.upload.errors.push(errorMessage);
    }

    function printUploadWarning(warningMessage){
        $scope.upload.warnings.push(warningMessage);
    }

    function addUploadedFileToList(fileItem){
        if($scope.newRevision){
            stepToWizardService.pdiModel.revisions.push($scope.revision);
            $scope.newRevision = false;
        }
        $scope.revision.user = authFactory.getAuthData().authId;
        $scope.revision.approval_status = REVISION_INSERTED;
        $scope.revision.files.push({
            title: fileItem.file.name,
            user: authFactory.getAuthData().authId,
            date_insertion: new Date(),
            destination: DESTINATION,
            object_id: fileItem.objectId
        });
        updateEditing();
    }

    function initFiles() {
        if(angular.isUndefined(stepToWizardService.pdiModel.revisions)){
            stepToWizardService.pdiModel.revisions = [];
        }
        $scope.revisions = stepToWizardService.pdiModel.revisions;
        $scope.pdiIndex = stepToWizardService.pdiIndex;
        $scope.pdiId = 'step' + ($scope.pdiIndex+1);
        $scope.pdiSchema = stepToWizardService.pdiSchema;
        $scope.pdiForm = stepToWizardService.pdiForm;
        $scope.pdiModel = stepToWizardService.pdiModel;
        updateEditing();
    }

    function updateEditing(){
        $scope.editing.length = 0;
        for(var i=0; i<$scope.revisions.length; i++){
            $scope.editing[i] = false;
        }
    }

    function initController(){
        initFiles();
        checkLockStepApproval();
    }

    function isExcel(filename){
        var extension = filename.split('.').pop();
        var result = (extension==='xls');
        return result;
    }

    //__main__
    stepToWizardService.initPdiCallback = initController;
    initController();

    /** ***********************************
     * Uploader callbacks
     * ***********************************/
        uploader.onAfterAddingFile = function(fileItem) {
            alfrescoFactory.fileExists({folder: DESTINATION, file:fileItem.file.name}).$promise.then(function(data){
                $scope.upload.warnings.length = 0;
                if(data.exists){
                    printUploadWarning('Sul server esiste già un file di nome "' + fileItem.file.name + '". Rinominarlo e riprovare.');
                    fileItem.remove();
                }
                else{
                    if($scope.hasXls){
                        if(isExcel(fileItem.file.name)){
                            printUploadWarning('Non è possibile caricare più file Excel per una stessa revisione.');
                            fileItem.remove();
                        }
                    }
                    else{
                        $scope.hasXls = isExcel(fileItem.file.name);
                    }
                }
            });
            $scope.upload.completed = false;
            $scope.upload.started = false;
        };
        uploader.onAfterAddingAll = function(addedFileItems) {
            $scope.upload.completed = false;
            $scope.upload.started = false;
        };
        uploader.onBeforeUploadItem = function(item) {
            $scope.upload.started = true;
        };
        uploader.onSuccessItem = function(fileItem, response, status, headers) {
            if(angular.isDefined(response.ERROR)){
                printUploadError(response.ERROR);
            }
            else{
                fileItem.objectId = response.objectId;
                addUploadedFileToList(fileItem);
            }
        };
        uploader.onErrorItem = function(fileItem, response, status, headers) {
            $scope.undoUpload();
            printUploadError("Errore nel caricamento del file " + fileItem.file.name);
        };
        uploader.onCompleteAll = function() {
            $scope.upload.completed = true;
            $scope.upload.show = false;
            saveStep("uploader.onCompleteAll");
        };


        $scope.transformObjectIdForBackend = function(objectId) {
          return objectId.replace('workspace://SpacesStore/', '$WorkspaceSpacesStore$');
        };

  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:AcquisitionWizardCtrl
 * @description
 * # AcquisitionWizardCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/acquisitionwizard/detail', {
        templateUrl: 'consip/acquisitionwizard/acquisitionwizard_detail.html',
        controller: 'AcquisitionWizardCtrl',
        consipEntity: 'acquisitionwizard'
      })
      .when('/acquisitionwizard/detail/:id', {
        templateUrl: 'consip/acquisitionwizard/acquisitionwizard_detail.html',
        controller: 'AcquisitionWizardCtrl',
        consipEntity: 'acquisitionwizard'
      })
      .when('/additionalacts/detail', {
        templateUrl: 'consip/acquisitionwizard/acquisitionwizard_detail.html',
        controller: 'AcquisitionWizardCtrl',
        consipEntity: 'additionalacts'
      })
      .when('/additionalacts/detail/:id', {
        templateUrl: 'consip/acquisitionwizard/acquisitionwizard_detail.html',
        controller: 'AcquisitionWizardCtrl',
        consipEntity: 'additionalacts'
      })
  })
  .constant('ADHESION_ACTIVE', 0)
  .constant('ADHESION_REFUSED', 1)
  .constant('STEP_TIMING_OFF', 0)
  .constant('STEP_TIMING_OK', 1)
  .constant('STEP_TIMING_WARNING', 2)
  .constant('STEP_TIMING_PENALTY', 3)
  .controller('AcquisitionWizardCtrl', function ($scope, contractFactory, $location, acquisitionStepFactory, $routeParams, formulaFactory,
                                                 acquisitionWizardFactory, additionalActsFactory, dialogService, toaster, stepToWizardService,
                                                 $rootScope, $q, $timeout, ADHESION_REFUSED, $log, $route, orderRowFactory, errorService) {

    $scope.tabs = [];

    $scope.stepIds = [];

    $scope.activeTab = 0;

    $scope.wizard = {
        model: {
            current_step: 'step1'
        }
    };

    $scope.pdiStep = undefined;
    $scope.opfStep = undefined;

    $scope.stepCount = 0;

    $scope.form = {};
    $scope.model = {};
    $scope.schema = {};

    $scope.backToList = function(){
        $location.path('acquisitionwizard');
    };

    $scope.getContract = function () {
      contractFactory().recordByCommission().$promise.then(function(data) {
        if(angular.isUndefined(data.model)){
            dialogService.alert('Non è stato definito un modello per la convenzione corrente', 4000);
        }
        else{
            $scope.contract = data;
            initTabs();
            // Carico le form per i singoli step e le riempio con i dati della specifica acquisizione (wizard)
            var wizard_promise;
            if($scope.isAdditionalAct){
                wizard_promise = additionalActsFactory.getActByUUID({id: $routeParams.id}).$promise;
            }
            else{
                wizard_promise = acquisitionWizardFactory.getWizardByUUID({id: $routeParams.id}).$promise;
            }
            var waitForPromises = {wizard: wizard_promise};

            for(var i=0; i<$scope.stepCount; i++){
                var stepId = $scope.stepIds[i];
                waitForPromises[stepId] = acquisitionStepFactory().byUUID({id: $scope.contract.model.steps[stepId].step_id.UUID}).$promise;
            }

            var combinedPromise = $q.all(waitForPromises);
            combinedPromise.then(function(responses) {
                getWizard(responses.wizard);
                for(var i=0; i<$scope.stepCount; i++){
                    var stepId = $scope.stepIds[i];
                    $scope.getStep(responses[stepId], i, stepId);
                }
                // Aspetto che l'interfaccia si sia caricata
                $timeout(function() {
                    $scope.initActiveTab();
                    $scope.initAttachments();
                }, 0);
            });

        }
      });
    };

    function getWizard(data){
        if(angular.isUndefined(data.model)){
            $scope.backToList();
        }
        else{
            $scope.wizard = data;
            $scope.wizard.dataIn = new Date($scope.wizard.dataIn);
            stepToWizardService.document = $scope.wizard;
            $log.info($scope.wizard);
        }
    }

    function initTabs(){
        $scope.stepCount = Object.keys($scope.contract.model.steps).length;
        for(var i=0; i<$scope.stepCount; i++){
            var newTab = {  title:'Step N.1',
                            disabled: false,
                            approvalLocked: false,
                            attachments: []
            };
            $scope.tabs.push(newTab);
            $scope.stepIds.push($scope.getId(i+1));
        }
    }

    $scope.isApprovalLocked = function(){
        var locked = $scope.isWizardReadonly();
        if(!locked && angular.isDefined($scope.activeTab) && angular.isDefined($scope.tabs[$scope.activeTab])){
            locked = $scope.tabs[$scope.activeTab].approvalLocked;
        }
        if(locked){
            locked = locked;
        }
        return locked;
    };

    function initPdiStep(tabIndex){
        $scope.pdiStep = $scope.getId(tabIndex+1);// "step" + (tabIndex+1);
        stepToWizardService.pdiIndex = tabIndex;
        stepToWizardService.pdiModel = $scope.wizard.model[$scope.pdiStep].model;
        stepToWizardService.pdiSchema = $scope.tabs[tabIndex].schema;
        stepToWizardService.pdiForm = $scope.tabs[tabIndex].form;
        stepToWizardService.saveCallback = $scope.save;
        stepToWizardService.lockStepCallback = lockStep;
        stepToWizardService.unlockStepCallback = unlockStep;
    }

    function initOpfStep(tabIndex){
        $scope.opfStep = $scope.getId(tabIndex+1);// "step" + (tabIndex+1);
        stepToWizardService.opfIndex = tabIndex;
        stepToWizardService.opfModel = $scope.wizard.model[$scope.opfStep].model;
        stepToWizardService.opfSchema = $scope.tabs[tabIndex].schema;
        stepToWizardService.opfForm = $scope.tabs[tabIndex].form;
        stepToWizardService.saveCallback = $scope.save;
        stepToWizardService.lockStepCallback = lockStep;
        stepToWizardService.unlockStepCallback = unlockStep;
    }

    $scope.initActiveTab = function(){
      var i=-1;
      for(i=0; i<$scope.stepCount; i++){
          if($scope.wizard.model.current_step.step===$scope.stepIds[i]){
              $scope.activeTab = i;
              $scope.maxActiveTab = i;
              break;
          }
      }
      if( (i<0) || (i>=$scope.stepCount) ){
          if($scope.wizard.model.current_step.status=='terminated'){
            $scope.activeTab = $scope.stepCount-1;
            $scope.maxActiveTab = $scope.stepCount;
          }
          else{
            $scope.activeTab = 0;
            $scope.maxActiveTab = 0;
          }
      }
      updateDisabledTabs();
      updateReadonlyTabs();
    };

    /* rende non modificabili i precedenti a quello corrente */
    function updateReadonlyTabs(){
      var readonlyArray = [];
      for(var i=1; i<=$scope.tabs.length; i++){
        if( (i <= $scope.maxActiveTab) || $scope.isWizardReadonly() ){
          $('#step'+i+' input').attr("disabled",true);
          $('#step'+i+' .ui-select-choices').css("visibility","hidden");
          $('#step'+i+' button').attr("disabled",true);
          $('#step'+i+' textarea').attr("disabled",true);
          $('#step'+i+' .ui-select-match-text').css("cursor","not-allowed");
          $('#step'+i+' .ui-select-toggle').css("background-color","#eee");
          readonlyArray.push(true);
        }
        else{
            $('#step'+i+' input').attr("disabled",false);
            $('#step'+i+' textarea').attr("disabled",false);
            $('#step'+i+' input[ng-model="inherited_value"]').attr("disabled",true);
            $('#step'+i+' .ui-select-choices').css("visibility","visible");
            $('#step'+i+' button').attr("disabled","block");
            $('#step'+i+' .ui-select-match-text').css("cursor","pointer");
            $('#step'+i+' .ui-select-toggle').css("background-color","#fff");
            readonlyArray.push(false);
        }
        disableClientId();
      }
      $rootScope.$broadcast('acquisitionWizard:readonlyChange',readonlyArray);
    }

    function disableClientId(){
        var possibleClients = $('div[ng-model]');
        for(var j=0; j<possibleClients.length; j++){
            if($( possibleClients[j] ).attr( "ng-model" )==="model['client_id']"){
                var myTarget = $( possibleClients[j] ).parent().parent();
                myTarget.find('.ui-select-choices').css("visibility","hidden");
                myTarget.find('input').attr("disabled",true);
                myTarget.find('.ui-select-toggle').css("background-color","#eee");
            }
        }
    }

    /* disabilita i tab successivi a quello corrente */
    function updateDisabledTabs(){
      for(var i=1; i<$scope.tabs.length; i++){
        $scope.tabs[i].disabled = (i>$scope.activeTab);
      }
    }

    $scope.getStep = function (data, tabIndex, stepXstring) {
        if (!data.model) {
          dialogService.alert('Non è stato definito un modello per l\'entità ' + $scope.typeName, 4000);
          $scope.isModelDefined = false;
          return;
        }
        $scope.isCollapsed = true;
        $scope.tabs[tabIndex].schema = data.model.schema;
        $scope.tabs[tabIndex].title = data.model.description;
        $scope.tabs[tabIndex].form = data.model.form;
        $scope.tabs[tabIndex].attachmentManagement = data.model.attachmentManagement;
        $scope.tabs[tabIndex].customForm = data.model.customForm;
        $scope.tabs[tabIndex].code = data.model.code;
        propagateClientId(data.model, stepXstring);
        initCustomSteps(tabIndex, data.model);
    };

    function initCustomSteps(tabIndex, stepModel){
        if(stepModel.customForm){
            if(stepModel.code=='pdi' || stepModel.code=='pditracciato'){
                initPdiStep(tabIndex);
            }
            else if(stepModel.code=='opf' || stepModel.code=='opftracciato'){
                initOpfStep(tabIndex);
            }
        }
    }

    function lockStep(stepIndex){
        if(angular.isDefined($scope.tabs[stepIndex])){
            $scope.tabs[stepIndex].approvalLocked = true;
        }
    }

    function unlockStep(stepIndex){
        if(angular.isDefined($scope.tabs[stepIndex])){
            $scope.tabs[stepIndex].approvalLocked = false;
        }
    }

    function reinitCustomSteps(){
        if(angular.isDefined($scope.wizard.model[$scope.pdiStep]) && angular.isDefined(stepToWizardService.initPdiCallback)){
            if($scope.maxActiveTab>=stepToWizardService.pdiIndex){
                stepToWizardService.pdiModel = $scope.wizard.model[$scope.pdiStep].model;
                stepToWizardService.initPdiCallback();
            }
        }
        if(angular.isDefined($scope.wizard.model[$scope.opfStep]) && angular.isDefined(stepToWizardService.initOpfCallback)){
            if($scope.maxActiveTab>=stepToWizardService.opfIndex){
                stepToWizardService.opfModel = $scope.wizard.model[$scope.opfStep].model;
                stepToWizardService.initOpfCallback();
            }
        }
    }

    $scope.save = function(){
      if(angular.isDefined( $scope.wizard.dataIn)){
            $scope.wizard.dataIn = new Date($scope.wizard.dataIn);
        }
        if($scope.saving){
            dialogService.alert('Impossibile eseguire il salvataggio. Si prega di riprovare', 4000);
        }
        else{
            $scope.saving = true;
            writeAllAttachments();
            var promise;
            if($scope.isAdditionalAct){
                promise = additionalActsFactory.updateAct({id: $scope.wizard.version}, $scope.wizard).$promise;
            }
            else{
                promise = acquisitionWizardFactory.updateWizard({id: $scope.wizard.version}, $scope.wizard).$promise;
            }
            promise.then(function (data) {
                $scope.wizard = data;
                $scope.wizard.dataIn = new Date($scope.wizard.dataIn);
                toaster.pop('success', 'Salvataggio completato', 'Salvataggio eseguito con successo');
                reinitCustomSteps();
                $scope.saving = false;
            });
        }
    };

    function updatePlafond(targetWizard){
        var value = targetWizard.partial_plafond;
        if(angular.isDefined(targetWizard.model.additional_acts)){
            for(var i=0; i<targetWizard.model.additional_acts.length; i++){
                if(angular.isDefined(targetWizard.model.additional_acts[i].required_plafond)){
                    value += targetWizard.model.additional_acts[i].required_plafond;
                }
            }
        }
        targetWizard.required_plafond = value;
    }

    function updateSourceWizard(){
        // Nel caso di atto aggiuntivo, al termine dell'acquisizione riporto i totali OPF sul wizard sorgente.
        acquisitionWizardFactory.getWizardByUUID({id: $scope.wizard.model.source_acquisition_id.UUID}).$promise.then(function (data){
            if(angular.isUndefined(data.model)){
                dialogService.alert('Errore durante la procedura di salvataggio.', 4000);
            }
            else{
                for(var i=0; i<data.model.additional_acts.length; i++){
                    if(data.model.additional_acts[i].UUID===$scope.wizard.UUID){
                        data.model.additional_acts[i].required_plafond = $scope.wizard.model.required_plafond;
                        break;
                    }
                }
                updatePlafond(data);
                acquisitionWizardFactory.updateWizard({id: data.version}, data).$promise.then(function (data){
                    $scope.backToList();
                });
            }
        });
    }

    function saveOrder(){
        orderRowFactory.bulkSave($scope.wizard.model.order_rows).$promise.then(function (data){
            var testMe = data;
        });
    }

    $scope.test = function(){
        saveOrder();
    };

    $scope.doApprove = function(){
        if($scope.saving){
          dialogService.alert('Impossibile eseguire il salvataggio. Si prega di riprovare', 4000);
        }
        else{
          $scope.saving = true;

          /* check sulle date */
          var promiseDaysRefreshed;
          if($scope.isAdditionalAct){
            promiseDaysRefreshed = additionalActsFactory.getDaysRefreshed($scope.wizard).$promise;
          } else {
            promiseDaysRefreshed = acquisitionWizardFactory.getDaysRefreshed($scope.wizard).$promise;
          }
          promiseDaysRefreshed.then(function (data) {
            $scope.wizard = data;
            writeAllAttachments();
            var promise;
            if($scope.isAdditionalAct){
              promise = additionalActsFactory.stepForward({id: $scope.wizard.UUID},$scope.wizard).$promise;
            }
            else{
              promise = acquisitionWizardFactory.stepForward({id: $scope.wizard.UUID},$scope.wizard).$promise;
            }
            promise.then(function (data) {
              $scope.wizard = data;
              $scope.wizard.dataIn = new Date($scope.wizard.dataIn);
              if($scope.wizard.model.current_step.status=="terminated"){
                updatePlafond($scope.wizard);
                saveOrder();
                if($scope.isAdditionalAct){
                  additionalActsFactory.updateAct({id: $scope.wizard.version}, $scope.wizard).$promise.then(function (data){
                    updateSourceWizard();
                  });
                }
                else{
                  acquisitionWizardFactory.updateWizard({id: $scope.wizard.version}, $scope.wizard).$promise.then(function (data){
                    $scope.backToList();
                  });
                }
              }
              else{
                $route.reload();
              }
              $scope.saving = false;
            });
          });
        }
    };

    $scope.approveStep = function(){
      var targetStepId = $scope.getId($scope.maxActiveTab+1);
      var form = document.forms[targetStepId];
      if(form){
        $scope.$broadcast('schemaFormValidate');
        setTimeout(function() {
            var invElements = angular.element(form.getElementsByClassName("ng-invalid"));
            if(invElements.length>0){
                toaster.pop('error', 'Errore', 'Dati obbligatori mancanti.');
            }
            else{
                $scope.doApprove();
            }
        }, 500);
      }
      else{
          $scope.doApprove();
      }
    };

    // Limita la validazione allo step corrente.
    // Finché lasciamo il reload è inutile
    function limitStepValidation(targetStepId){
        for(var i=1; i<=$scope.stepCount; i++){
            var myId = $scope.getId(i);
            if(myId!==targetStepId){
                var myForm = document.forms[myId];
                var allElements = angular.element(myForm.getElementsByClassName("form-group"));
                $log.info("approveStep");
                for(var j=0; j<allElements.length; j++){
                    var el = $(allElements[j]);
                    el.removeClass('has-success');
                    el.removeClass('has-error');
                }
            }
        }
    }

    $scope.insertAdditionalActs = function () {
      var UUIDAcquisitionWizard = $scope.wizard.UUID;
      $location.path('additionalacts/acquisition/'+ UUIDAcquisitionWizard);
    };

    $scope.getId = function (idx) {
      return 'step'+idx;
    };

    $scope.getModel = function (idx) {
      var model = undefined;
      if(angular.isDefined($scope.wizard.model[$scope.getId(idx)])){
        model = $scope.wizard.model[$scope.getId(idx)].model;
      }
      return model;
    };

    $scope.getAcquisitionWizard = function () {
      var acquisitionWizard = undefined;
      if(angular.isDefined($scope.wizard.model)) {
        acquisitionWizard = $scope.wizard.model;
      }
      return acquisitionWizard;
    };

    $scope.getStepDocument = function (idx) {
      return $scope.wizard.model[$scope.getId(idx)];
    };

    $scope.undoStep = function(){
        if($scope.saving){
            dialogService.alert('Impossibile eseguire il salvataggio. Si prega di riprovare', 4000);
        }
        else{
            $scope.saving = true;
            writeAllAttachments();
            var promise;
            if($scope.isAdditionalAct){
                promise = additionalActsFactory.stepBack({id: $scope.wizard.UUID},$scope.wizard).$promise;
            }
            else{
                promise = acquisitionWizardFactory.stepBack({id: $scope.wizard.UUID},$scope.wizard).$promise;
            }
            promise.then(function (data) {
                $scope.wizard = data;
                $scope.wizard.dataIn = new Date($scope.wizard.dataIn);
                $scope.updateTabs(false);
                $scope.approvalLocked = false;
                toaster.pop('success', 'Salvataggio completato', 'Salvataggio eseguito con successo');
                reinitCustomSteps();
                $scope.saving = false;
            });
        }
    };

    $scope.isWizardReadonly = function(){
        var result = ($scope.wizard.model.current_step.status=='terminated') || ($scope.wizard.adhesion_status === ADHESION_REFUSED );
        return result;
    };

    $scope.updateTabs = function(forward){
      var i=-1;
      for(i=0; i<$scope.stepCount; i++){
          if($scope.wizard.model.current_step.step===$scope.stepIds[i]){
              break;
          }
      }
      if( (i<0) || (i>=$scope.stepCount) ){
          if($scope.wizard.model.current_step.status=='terminated'){
            $scope.activeTab = 0;
            $scope.maxActiveTab = 0;
          } else {
            $scope.activeTab = $scope.stepCount;
            $scope.maxActiveTab = $scope.stepCount+1;
          }
      }
      else if(i==0){
          if(forward){
            $scope.activeTab++;
            $scope.maxActiveTab++;
          } else {
            $scope.activeTab = 0;
            $scope.maxActiveTab = 0;
          }
      }
      else{
          if(forward){
            $scope.activeTab++;
            $scope.maxActiveTab++;
          } else {
            $scope.activeTab--;
            $scope.maxActiveTab--;
          }
      }
      updateDisabledTabs();
      updateReadonlyTabs();
    };

    function propagateClientId(stepModel, stepXstring){
        var properties = stepModel.schema.properties;
        if(angular.isDefined(properties.client_id) && angular.isDefined(properties.client_id.format) && (properties.client_id.format==='lookup')){
            $scope.wizard.model[stepXstring].model.client_id = {};
            angular.copy($scope.wizard.model.client_id, $scope.wizard.model[stepXstring].model.client_id);
        }
    }

    // Gestione allegati
    function readAttachments(index){
        $scope.tabs[index].attachments.length = 0;
        var modelList = $scope.getModel(index+1).attachments;
        for(var i=0; i<modelList.length; i++){
            $scope.tabs[index].attachments.push(modelList[i]);
        }
    }
    function writeAttachments(index){
        var modelList = $scope.getModel(index+1).attachments;
        modelList.length = 0;
        for(var i=0; i<$scope.tabs[index].attachments.length; i++){
            modelList.push($scope.tabs[index].attachments[i]);
        }
    }
    function writeAllAttachments(){
        for(var i=0; i<$scope.tabs.length; i++){
            if($scope.tabs[i].attachmentManagement){
                writeAttachments(i);
            }
        }
    }
    $scope.updAttachments = function(index){
        writeAttachments(index);
        $scope.save();
    };
    $scope.initAttachments = function(){
        for(var i=0; i<$scope.tabs.length; i++){
            if($scope.tabs[i].attachmentManagement){
                if(angular.isUndefined($scope.getModel(i+1).attachments)){
                    $scope.getModel(i+1).attachments = [];
                }
                else{
                    readAttachments(i);
                }
            }
        }
    };

    $scope.setNotAdherent = function(){
        dialogService.confirmDialog("L'operazione non potrà essere annullata. Continuare?", function () {
            $scope.wizard.adhesion_status = ADHESION_REFUSED;
            $scope.wizard.adhesion_refusal_date = new Date();
            updateReadonlyTabs();
            $scope.save();
        });
    };

    $scope.isNotAdherent = function(){
        var result = ($scope.wizard.adhesion_status===ADHESION_REFUSED);
        return result;
    };

    $scope.delete = function() {
      dialogService.confirmDialog('Eliminare l\'acquisizione ' + $scope.wizard.model.code + ' del cliente ' + $scope.wizard.model.client_id.description + '?',
        function () {
          acquisitionWizardFactory.deleteWizard({id: $scope.wizard.version}).$promise.then(function (response) {
            if (errorService.handleError(response)) {
              toaster.pop('success', 'Eliminazione completata', 'Eliminazione eseguita con successo');
              $scope.backToList();
            } else {
              toaster.pop('error', 'Errore eliminazione', 'Eliminazione non riuscita');
            }
          });
        }
      );
    };

    //___main__
    var consipEntity = $route.current.$$route.consipEntity;
    $scope.isAdditionalAct = ($route.current.$$route.consipEntity==='additionalacts');
    $scope.getContract();

  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:AcquisitionWizardListCtrl
 * @description
 * # AcquisitionWizardListCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/acquisitionwizard', {
        templateUrl: 'consip/acquisitionwizard/acquisitionwizard_list.html',
        controller: 'AcquisitionWizardListCtrl'
      })
      .when('/acquisitionwizard/page/:number', {
        templateUrl: 'consip/acquisitionwizard/acquisitionwizard_list.html',
        controller: 'AcquisitionWizardListCtrl'
      })
  })
  .controller('AcquisitionWizardListCtrl', function ($scope, acquisitionWizardFactory, $log, $routeParams, $location, lookupFactory,dialogService,  uiGridConstants, contractFactory) {
    $scope.wizardList = {};
    $scope.params = { queryParam: '', filterQuery: '' };
    $scope.viewGridOptions = {};

    var DEFAULT_SORT_FIELD = 'model.code';
    function defaultSort() {
        var result = ($scope.sortFields)?$scope.sortFields:DEFAULT_SORT_FIELD;
        return result;
    }

    var DEFAULT_SORT_ORDER= 'asc';
    function defaultSortOrder() {
        var result = ($scope.sortOrder)?$scope.sortOrder:DEFAULT_SORT_ORDER;
        return result;
    }

    var getPage = function() {
      $scope.viewGridOptions.totalItems = $scope.wizardList.totalResults;
      var firstRow = ($scope.params.pageNumber - 1) * $scope.params.pageSize;
      var lastRow = (firstRow + $scope.params.pageSize);
      $scope.viewGridOptions.data = $scope.viewGridOptions.data.slice(firstRow, lastRow);
    };

    function initGridColumns() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 34,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents" style="text-align: center">' +
            '<a ng-href="#/acquisitionwizard/detail/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' +
              '<span class="fa fa-search"></span>' +
            '</a>' +
          '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice',
        field: 'model.code',
        width: 60,
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descrizione',
        field: 'model.description',
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Step',
        field: 'model.current_step.step',
        enableFiltering:true,
        cellTemplate:'<div class="ui-grid-cell-contents">{{grid.appScope.$parent.stepLabel[row.entity.model.current_step.step]}}</div>' ,
        sixFilteringCallback:$scope.onFilterStepCallback,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Stato',
        field: 'model.current_step.status',
        enableFiltering:true,
        cellTemplate:'<div class="ui-grid-cell-contents">{{grid.appScope.$parent.statusLabel[row.entity.model.current_step.status]}}</div>' ,
        sixFilteringCallback:$scope.onFilterStatusCallback,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Adesione',
        field: 'adhesion_status',
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: true,
        cellTemplate:
          '<div class="ui-grid-cell-contents" style="text-align: center">' +
            '<span ng-if="row.entity.adhesion_status===1">' +
              'Non aderente' +
            '</span>' +
          '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tempistiche',
        field: 'model.code',
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents">' +
            '<span ng-if="row.entity.model.step1">' +
                '<six-consip-timing-led sx-value="row.entity.model.step1.timing_status" sx-description="grid.appScope.$parent.stepLabel.step1"></six-consip-timing-led>' +
            '</span>' +
            '<span ng-if="row.entity.model.step2">' +
                '<six-consip-timing-led sx-value="row.entity.model.step2.timing_status" sx-description="grid.appScope.$parent.stepLabel.step2"></six-consip-timing-led>' +
            '</span>' +
            '<span ng-if="row.entity.model.step3">' +
                '<six-consip-timing-led sx-value="row.entity.model.step3.timing_status" sx-description="grid.appScope.$parent.stepLabel.step3"></six-consip-timing-led>' +
            '</span>' +
            '<span ng-if="row.entity.model.step4">' +
                '<six-consip-timing-led sx-value="row.entity.model.step4.timing_status" sx-description="grid.appScope.$parent.stepLabel.step4"></six-consip-timing-led>' +
            '</span>' +
            '<span ng-if="row.entity.model.step5">' +
                '<six-consip-timing-led sx-value="row.entity.model.step5.timing_status" sx-description="grid.appScope.$parent.stepLabel.step5"></six-consip-timing-led>' +
            '</span>' +
            '<span ng-if="row.entity.model.step6">' +
                '<six-consip-timing-led sx-value="row.entity.model.step6.timing_status" sx-description="grid.appScope.$parent.stepLabel.step6"></six-consip-timing-led>' +
            '</span>' +
            '<span ng-if="row.entity.model.step7">' +
                '<six-consip-timing-led sx-value="row.entity.model.step7.timing_status" sx-description="grid.appScope.$parent.stepLabel.step7"></six-consip-timing-led>' +
            '</span>' +
            '<span ng-if="row.entity.model.step8">' +
                '<six-consip-timing-led sx-value="row.entity.model.step8.timing_status" sx-description="grid.appScope.$parent.stepLabel.step8"></six-consip-timing-led>' +
            '</span>' +
            '<span ng-if="row.entity.model.step9">' +
                '<six-consip-timing-led sx-value="row.entity.model.step9.timing_status" sx-description="grid.appScope.$parent.stepLabel.step9"></six-consip-timing-led>' +
            '</span>' +
          '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Atti aggiuntivi',
        field: 'model.current_step.status',
        enableFiltering:false,
        width: 150,
        cellTemplate:
        '<div class="ui-grid-cell-contents" ng-if="(row.entity.model.current_step.status == \'terminated\')" style="vertical-align:middle;text-align:center;">' +
        '<a ng-href="#/additionalacts/acquisition/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' +
        '<i class="fa fa-pencil-square-o" style="margin: 0;"></i>' +
        '<span ng-if="row.entity.model.additional_acts.length>0" class="m-l-xs"> {{row.entity.model.additional_acts.length}}</span>' +
        '</a>' +
        '</div>'
      });
    }

    $scope.onFilterStatusCallback = function(term){
      if(term && term!=''){
        term = term.toLowerCase();
        var matching = [];
        for(var prop in $scope.statusLabel) {
          var desc = $scope.statusLabel[prop].toLowerCase();
          if(desc.indexOf(term) !== -1)  {
            matching.push(prop);
          }
        }
        if(matching.length>1){
          term = '';
        }
        else if(matching.length<1){
          term="-";
        }
        else{
          term = matching[0];
        }
      }
      return term;
    };

    $scope.onFilterStepCallback = function(term){
      if(term && term!=''){
        term = term.toLowerCase();
        var matching = [];
        for(var prop in $scope.stepLabel) {
          var desc = $scope.stepLabel[prop].toLowerCase();
          if(desc.indexOf(term) !== -1)  {
            matching.push(prop);
          }
        }
        if(matching.length>1){
          term = 'step';
        }
        else if(matching.length<1){
          term="-";
        }
        else{
          term = matching[0];
        }
      }
      return term;
    };

    $scope.getData = function () {
        var payload = {
          query: $scope.params.queryParam,
          page: $scope.params.pageNumber,
          page_size: $scope.params.pageSize,
          sort_fields: defaultSort(),
          sort_order: defaultSortOrder(),
          show_revision: false
        };
        acquisitionWizardFactory.getWizardsListFiltered(payload, $scope.params.filterQuery)
            .$promise.then(function(data) {
                $scope.wizardList.totalResults = data.totalResults;
                $scope.wizardList.list = data.list;
                getPage();
        });
    };

    $scope.getWizardList = function () {
      var payload = {
            query: '',
            page: $scope.params.pageNumber,
            page_size: $scope.params.pageSize
      };
      acquisitionWizardFactory.getWizardsList(payload, $scope.params.filterQuery)
        .$promise.then(function(data) {
            $scope.wizardList.totalResults = data.totalResults;
            $scope.wizardList.list = data.list;
            getPage();
      });
    };

    $scope.newWizard = function(){
      if($scope.plafond.remaining<=0){
        dialogService.alert('Plafond esaurito, impossibile procedere', 4000);
      }
      else{
        $location.path('acquisitionwizard/new');
      }
    };

    function getContract(){
        contractFactory().recordByCommission().$promise.then(function(data) {
          if(!data.model){
            dialogService.alert('Nessuna convenzione definita', 4000);
          }
          else{
            $scope.contract = data;
            loadStepsDescriptions();
            loadStatusesDescriptions();
            getPlafond();
          }
        });
    }

    function loadStepsDescriptions() {
      $scope.steps = $scope.contract.model.steps;
      $scope.stepLabel = {
        step1: angular.isDefined($scope.steps.step1)?$scope.steps.step1.step_id.description:'',
        step2: angular.isDefined($scope.steps.step2)?$scope.steps.step2.step_id.description:'',
        step3: angular.isDefined($scope.steps.step3)?$scope.steps.step3.step_id.description:'',
        step4: angular.isDefined($scope.steps.step4)?$scope.steps.step4.step_id.description:'',
        step5: angular.isDefined($scope.steps.step5)?$scope.steps.step5.step_id.description:'',
        step6: angular.isDefined($scope.steps.step6)?$scope.steps.step6.step_id.description:'',
        step7: angular.isDefined($scope.steps.step7)?$scope.steps.step7.step_id.description:'',
        step8: angular.isDefined($scope.steps.step8)?$scope.steps.step8.step_id.description:'',
        step9: angular.isDefined($scope.steps.step9)?$scope.steps.step9.step_id.description:''
      };
    }

    function loadStatusesDescriptions(){
      $scope.statusLabel = {
        inprogress: 'In corso',
        terminated: 'Terminata'
      };
    }

    function getPlafond(){
      $scope.plafond = {};
      $scope.plafond.available = $scope.contract.model.plafond_total;
      acquisitionWizardFactory.getUsedPlafond().$promise.then(function(data) {
        $scope.plafond.used = data.used_plafond;
        $scope.plafond.remaining = $scope.plafond.available - $scope.plafond.used;
        $scope.plafond.remaining_class = ($scope.plafond.remaining>0)?"text-success-dker":"text-danger-dker";
      });
    }

    //__main__
    getContract();
    initGridColumns();

  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:AcquisitionWizardNewCtrl
 * @description
 * # AcquisitionWizardNewCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/acquisitionwizard/new', {
        templateUrl: 'consip/acquisitionwizard/acquisitionwizard_new.html',
        controller: 'AcquisitionWizardNewCtrl'
      })
  })
  .controller('AcquisitionWizardNewCtrl', function ($scope, acquisitionWizardFactory, toaster, authFactory,
                                                    $location, contractFactory, STEP_TIMING_OFF) {

    $scope.wizard = {};
    $scope.validDefaultSettings = false;

    $scope.$watchCollection('wizard.client_id',
        function(newValue, oldValue) {
            $scope.validDefaultSettings = angular.isDefined($scope.wizard.client_id);
        }
    );

    $scope.confirmNewWizard = function(){
      acquisitionWizardFactory.getByClient({id: $scope.wizard.client_id.UUID}).$promise.then(function(data) {
            var success = !data.exist;
            if(success){
                createNewWizard();
            }
            else{
                toaster.pop('error', 'Errore', 'Esiste già un flusso di acquisizione attivo associato a questo cliente.');
            }
      });
    };

    function createNewWizard(){
        var commission = authFactory.getAuthData().info.commissions.current.code;
        $scope.wizard.description = commission +  " - " + $scope.wizard.client_id.description;
        $scope.wizard.code = commission + "_" + $scope.wizard.client_id.code;
        acquisitionWizardFactory.createWizard({param1: $scope.wizard.client_id.UUID}, $scope.wizard).$promise.then(function(data) {
            if(angular.isUndefined(data.UUID)){
                alert("Servizio non disponibile");
            }
            else{
                $location.path('acquisitionwizard/detail/' + data.UUID);
            }
        });
    };

    function getContract() {
      contractFactory().recordByCommission().$promise.then(function(data) {
        if(angular.isUndefined(data.model)){
            dialogService.alert('Non è stato definito un modello per la convenzione corrente', 4000);
        }
        else{
            var contract = data;
            var stepCount = Object.keys(contract.model.steps).length;
            for(var i=0; i<stepCount; i++){
                var stepId = 'step' + (i+1);
                var days = contract.model.steps[stepId].days;
                var type_days = contract.model.steps[stepId].type_days;
                var dateStart = contract.model.steps[stepId].date_start;
                var dateEnd = contract.model.steps[stepId].date_end;
                $scope.wizard.step_count = stepCount;
                $scope.wizard[stepId] = {
                    type_days: type_days,
                    days: days,
                    date_start: dateStart,
                    date_end: dateEnd,
                    timing_status: STEP_TIMING_OFF,
                    model: {}
                };
            }
        }
      });
    };

    //__main__
    getContract();

  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:AcquisitionWizardListCtrl
 * @description
 * # AcquisitionWizardListCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/additionalacts', {
        templateUrl: 'consip/acquisitionwizard/additionalacts_list.html',
        controller: 'AdditionalActsListCtrl'
      })
      .when('/additionalacts/page/:number', {
        templateUrl: 'consip/acquisitionwizard/additionalacts_list.html',
        controller: 'AdditionalActsListCtrl'
      })
      .when('/additionalacts/acquisition/:acquisitionId', {
        templateUrl: 'consip/acquisitionwizard/additionalacts_list.html',
        controller: 'AdditionalActsListCtrl'
      })
  })
  .controller('AdditionalActsListCtrl', function ($scope, additionalActsFactory, $log, $routeParams, $location, uiGridConstants,
                                                  contractFactory, authFactory, acquisitionWizardFactory, dialogService, STEP_TIMING_OFF) {
    $scope.actsList = {};
    $scope.params = { queryParam: '', filterQuery: {} };
    $scope.viewGridOptions = {};

    var DEFAULT_SORT_FIELD = 'model.code';
    function defaultSort() {
        var result = ($scope.sortFields)?$scope.sortFields:DEFAULT_SORT_FIELD;
        return result;
    }

    var DEFAULT_SORT_ORDER= 'asc';
    function defaultSortOrder() {
        var result = ($scope.sortOrder)?$scope.sortOrder:DEFAULT_SORT_ORDER;
        return result;
    }

    var getPage = function() {
      $scope.viewGridOptions.totalItems = $scope.actsList.totalResults;
      var firstRow = ($scope.params.pageNumber - 1) * $scope.params.pageSize;
      var lastRow = (firstRow + $scope.params.pageSize);
      $scope.viewGridOptions.data = $scope.viewGridOptions.data.slice(firstRow, lastRow);
    };

    function initGridColumns() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 34,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents" style="text-align: center">' +
            '<a ng-href="#/additionalacts/detail/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' +
              '<span class="fa fa-search"></span>' +
            '</a>' +
          '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice',
        field: 'model.code',
        width: 60,
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descrizione',
        field: 'model.step1.model.description',
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Step',
        field: 'model.current_step.step',
        enableFiltering:true,
        cellTemplate:'<div class="ui-grid-cell-contents">{{grid.appScope.$parent.stepLabel[row.entity.model.current_step.step]}}</div>' ,
        sixFilteringCallback:$scope.onFilterStepCallback,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Stato',
        field: 'model.current_step.status',
        enableFiltering:true,
        cellTemplate:'<div class="ui-grid-cell-contents">{{grid.appScope.$parent.statusLabel[row.entity.model.current_step.status]}}</div>' ,
        sixFilteringCallback:$scope.onFilterStatusCallback,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Adesione',
        field: 'adhesion_status',
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: true,
        cellTemplate:
          '<div class="ui-grid-cell-contents" style="text-align: center">' +
            '<span ng-if="row.entity.adhesion_status===1">' +
              'Non aderente' +
            '</span>' +
          '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tempistiche',
        field: 'model.code',
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents">' +
            '<span ng-if="row.entity.model.step1">' +
                '<six-consip-timing-led sx-value="row.entity.model.step1.timing_status" sx-description="grid.appScope.$parent.stepLabel.step1"></six-consip-timing-led>' +
            '</span>' +
            '<span ng-if="row.entity.model.step2">' +
                '<six-consip-timing-led sx-value="row.entity.model.step2.timing_status" sx-description="grid.appScope.$parent.stepLabel.step2"></six-consip-timing-led>' +
            '</span>' +
            '<span ng-if="row.entity.model.step3">' +
                '<six-consip-timing-led sx-value="row.entity.model.step3.timing_status" sx-description="grid.appScope.$parent.stepLabel.step3"></six-consip-timing-led>' +
            '</span>' +
            '<span ng-if="row.entity.model.step4">' +
                '<six-consip-timing-led sx-value="row.entity.model.step4.timing_status" sx-description="grid.appScope.$parent.stepLabel.step4"></six-consip-timing-led>' +
            '</span>' +
            '<span ng-if="row.entity.model.step5">' +
                '<six-consip-timing-led sx-value="row.entity.model.step5.timing_status" sx-description="grid.appScope.$parent.stepLabel.step5"></six-consip-timing-led>' +
            '</span>' +
            '<span ng-if="row.entity.model.step6">' +
                '<six-consip-timing-led sx-value="row.entity.model.step6.timing_status" sx-description="grid.appScope.$parent.stepLabel.step6"></six-consip-timing-led>' +
            '</span>' +
            '<span ng-if="row.entity.model.step7">' +
                '<six-consip-timing-led sx-value="row.entity.model.step7.timing_status" sx-description="grid.appScope.$parent.stepLabel.step7"></six-consip-timing-led>' +
            '</span>' +
            '<span ng-if="row.entity.model.step8">' +
                '<six-consip-timing-led sx-value="row.entity.model.step8.timing_status" sx-description="grid.appScope.$parent.stepLabel.step8"></six-consip-timing-led>' +
            '</span>' +
            '<span ng-if="row.entity.model.step9">' +
                '<six-consip-timing-led sx-value="row.entity.model.step9.timing_status" sx-description="grid.appScope.$parent.stepLabel.step9"></six-consip-timing-led>' +
            '</span>' +
          '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Acquisizione',
        field: 'row.entity.model.source_acquisition_id.UUID',
        enableFiltering:false,
        width: 150,
        cellTemplate:
        '<div class="ui-grid-cell-contents" style="vertical-align:middle;text-align:center;">' +
        '<a ng-href="#/acquisitionwizard/detail/{{row.entity.model.source_acquisition_id.UUID}}" class="btn btn-xs btn-primary">' +
        '{{row.entity.model.source_acquisition_id.UUID}}' +
        '</a>' +
        '</div>'
      });
    }

    $scope.onFilterStatusCallback = function(term){
      if(term && term!=''){
        term = term.toLowerCase();
        var matching = [];
        for(var prop in $scope.statusLabel) {
          var desc = $scope.statusLabel[prop].toLowerCase();
          if(desc.indexOf(term) !== -1)  {
            matching.push(prop);
          }
        }
        if(matching.length>1){
          term = '';
        }
        else if(matching.length<1){
          term="-";
        }
        else{
          term = matching[0];
        }
      }
      return term;
    };

    $scope.onFilterStepCallback = function(term){
      if(term && term!=''){
        term = term.toLowerCase();
        var matching = [];
        for(var prop in $scope.stepLabel) {
          var desc = $scope.stepLabel[prop].toLowerCase();
          if(desc.indexOf(term) !== -1)  {
            matching.push(prop);
          }
        }
        if(matching.length>1){
          term = 'step';
        }
        else if(matching.length<1){
          term="-";
        }
        else{
          term = matching[0];
        }
      }
      return term;
    };

    $scope.getData = function () {
        var payload = {
          query: $scope.params.queryParam,
          page: $scope.params.pageNumber,
          page_size: $scope.params.pageSize,
          sort_fields: defaultSort(),
          sort_order: defaultSortOrder(),
          show_revision: false
        };
        if(angular.isDefined($routeParams.acquisitionId)){
          $scope.params.filterQuery['model.source_acquisition_id.UUID'] = $routeParams.acquisitionId;
        }
        additionalActsFactory.getActsListFiltered(payload, $scope.params.filterQuery)
            .$promise.then(function(data) {
                $scope.actsList.totalResults = data.totalResults;
                $scope.actsList.list = data.list;
                getPage();
        });
    };

    $scope.newAdditionalAct = function(){
      if($scope.plafond.remaining<=0){
        dialogService.alert('Plafond esaurito, impossibile procedere', 4000);
      }
      else{
        var commission = authFactory.getAuthData().info.commissions.current.code;
        var stepCount = Object.keys($scope.contract.model.steps).length;
        var actModel = {
          description: commission +  " - " + $scope.sourceAcquisition.model.client_id.description,
          code: commission + "_" + $scope.sourceAcquisition.model.client_id.code,
          client_id: $scope.sourceAcquisition.model.client_id,
          source_acquisition_id: sixObjectLib.recordToHisRef($scope.sourceAcquisition),
          step_count: stepCount
        };
        for(var i=0; i<stepCount; i++){
          var stepId = 'step' + (i+1);
          var type_days = $scope.contract.model.steps[stepId].type_days_acts;
          var days = $scope.contract.model.steps[stepId].days_acts;
          var dateStart = $scope.contract.model.steps[stepId].date_start;
          var dateEnd = $scope.contract.model.steps[stepId].date_end;
          actModel[stepId] = {
              type_days: type_days,
              days: days,
              date_start: dateStart,
              date_end: dateEnd,
              timing_status: STEP_TIMING_OFF,
              model: {}
          };
        }
        additionalActsFactory.createAct({param1: $scope.sourceAcquisition.model.client_id.UUID}, actModel).$promise.then(function(data) {
            if(angular.isUndefined($scope.sourceAcquisition.model.additional_acts )){
              $scope.sourceAcquisition.model.additional_acts = [];
            }
            $scope.sourceAcquisition.model.additional_acts.push(sixObjectLib.recordToHisRef(data));
            $scope.newActUUID = data.UUID;
            acquisitionWizardFactory.updateWizard({id: $scope.sourceAcquisition.version}, $scope.sourceAcquisition).$promise.then(function (response) {
              $location.path('additionalacts/detail/' + $scope.newActUUID);
            });
        });
      }
    };

    function getContract(){
        contractFactory().recordByCommission().$promise.then(function(data) {
          if(!data.model){
            dialogService.alert('Nessuna convenzione definita', 4000);
          }
          else{
            $scope.contract = data;
            loadStepsDescriptions();
            loadStatusesDescriptions();
            getPlafond();
          }
        });
    }

    function loadStepsDescriptions() {
      $scope.steps = $scope.contract.model.steps;
      $scope.stepLabel = {
        step1: angular.isDefined($scope.steps.step1)?$scope.steps.step1.step_id.description:'',
        step2: angular.isDefined($scope.steps.step2)?$scope.steps.step2.step_id.description:'',
        step3: angular.isDefined($scope.steps.step3)?$scope.steps.step3.step_id.description:'',
        step4: angular.isDefined($scope.steps.step4)?$scope.steps.step4.step_id.description:'',
        step5: angular.isDefined($scope.steps.step5)?$scope.steps.step5.step_id.description:'',
        step6: angular.isDefined($scope.steps.step6)?$scope.steps.step6.step_id.description:'',
        step7: angular.isDefined($scope.steps.step7)?$scope.steps.step7.step_id.description:'',
        step8: angular.isDefined($scope.steps.step8)?$scope.steps.step8.step_id.description:'',
        step9: angular.isDefined($scope.steps.step9)?$scope.steps.step9.step_id.description:''
      };
    }

    function loadStatusesDescriptions(){
      $scope.statusLabel = {
        inprogress: 'In corso',
        terminated: 'Terminata'
      };
    }

    function getSourceAcquisition(UUID){
      acquisitionWizardFactory.getWizardByUUID({id: UUID}).$promise.then(function(data){
        $scope.sourceAcquisition = data;
      });
    };

    function getPlafond(){
      $scope.plafond = {};
      $scope.plafond.available = $scope.contract.model.plafond_total;
      acquisitionWizardFactory.getUsedPlafond().$promise.then(function(data) {
        $scope.plafond.used = data.used_plafond;
        $scope.plafond.remaining = $scope.plafond.available - $scope.plafond.used;
        $scope.plafond.remaining_class = ($scope.plafond.remaining>0)?"text-success-dker":"text-danger-dker";
      });
    }

    //__main__
    getContract();
    if(angular.isDefined($routeParams.acquisitionId)){
      getSourceAcquisition($routeParams.acquisitionId);
    }
    initGridColumns();

  });

'use strict';

angular.module('emma.consip').directive("inputDisabled", function(){
  return function(scope, element, attrs){
    scope.$watch(attrs.inputDisabled, function(val){
      if(val)
        element.removeAttr("disabled");
      else
        element.attr("disabled", "disabled");
    });
  }
});

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ContractCtrl
 * @description
 * # ContractCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip').config(function ($routeProvider) {
    $routeProvider
      .when('/contract', {
        templateUrl: 'consip/contract/contract.html',
        controller: 'ContractCtrl'
      })
  })
  .controller('ContractCtrl', function ($scope, $route, contractFactory, recordFactory, authFactory, acquisitionStepFactory,
                                        formulaFactory, errorService, dialogService, toaster, acquisitionWizardFactory) {

    $scope.currentTab = 0;
    $scope.workflow = { ref: ''};
    $scope.selected = {
      model: {
        workflow_id: '',
        steps: {},
        code: '',
        description: ''
      }
    };
    $scope.formuleStrBodyDays = {};
    $scope.formuleStrBodyDaysActs = {};
    $scope.isPlafondEditing = false;
    $scope.confModel = {};
    $scope.dateStepArray = {};
    $scope.selectedStep = { value: {}};
    $scope.arrayRet = [];
    $scope.arrayIds = [];
    var currentCommission = authFactory.getAuthData().info.commissions.current;

    $scope.refreshCodeByDescription = function() {
      if(angular.isUndefined($scope.selected.UUID)){
        $scope.code = sixStringLib.removeDiacritics($scope.selected.model.description);
        $scope.code = $scope.code.replace(/[^\w]|_/g, '').replace(/^(\d)(.*)/, '_$1$2').toLowerCase();
        $scope.selected.model.code = angular.copy($scope.code);
      }
    };

    $scope.setCurrentTab = function (index) {
      $scope.currentTab = index;
    };

    $scope.onSubmit = function(form) {
      $scope.$broadcast('schemaFormValidate');
      var isValid = form.$valid;
      if(isValid){
          for(var i=0; i<$scope.arrayIds.length; i++){
              var step_id = $scope.selected.model.steps[$scope.arrayIds[i]];
              isValid &= angular.isDefined(step_id);
              isValid &= angular.isDefined(step_id.type_days);
              if(angular.isDefined(step_id.type_days)){
                if(step_id.type_days == 'formula') {
                  isValid &= angular.isDefined(step_id.formula_days) && (step_id.formula_days!=null);
                } else if(step_id.type_days == 'number') {
                  isValid &= angular.isDefined(step_id.days) && (step_id.days!=null);
                }
              }
              isValid &= angular.isDefined(step_id.type_days_acts);
              if(angular.isDefined(step_id.type_days_acts)){
                if(step_id.type_days_acts == 'formula') {
                  isValid &= angular.isDefined(step_id.formula_days_acts) && (step_id.formula_days_acts!=null);
                } else if(step_id.type_days_acts == 'number') {
                  isValid &= angular.isDefined(step_id.days_acts) && (step_id.days_acts!=null);
                }
              }
              isValid &= ( angular.isDefined(step_id.date_start)  && (step_id.date_start!=''));
              isValid &= ( angular.isDefined(step_id.date_end) && (step_id.date_end!=''));
              if(!isValid){
                  break;
              }
          }
      }
      if (isValid) {
        $scope.save();
      }
      else{
        toaster.pop('error', 'Impossibile effettuare il salvataggio: alcuni campi non sono stati compilati', '');
      }
    };

    $scope.getInputType = function(modelItem) {
      if(modelItem.type == 'datepicker'){
        return 'date';
      }
      else{
        return modelItem.type;
      }
    };

    $scope.save = function () {
        $scope.selected.model.plafond_total = getPlafondTotal();
        getPlafondUsed();
        if ($scope.selected.version) {
          /* update */
          contractFactory().updateRecord({id: $scope.selected.version}, $scope.selected).$promise.then(function() {
              console.log('updated!');
              toaster.pop('success', 'Salvataggio effettuato', '');
              $route.reload();
          });
        } else {
          /* create */
          contractFactory().createRecord($scope.selected.model).$promise.then(function() {
              console.log('created!');
              toaster.pop('success', 'Salvataggio effettuato', '');
              $route.reload();
          });
        }
    };


    $scope.delete = function () {
      contractFactory().deleteRecord({id: $scope.selected.version}).$promise.then(function () {
        toaster.pop('success', 'Eliminazione effettuata', '');
        $route.reload();
      });
    };


    $scope.getWorkflowRef = function () {
      /* controllo se tra i campi c'è una lookup sul workflow */
      angular.forEach($scope.form[0].items, function(item) {
        angular.forEach(item.tabs, function (tab) {
          angular.forEach(tab.items, function (model_item){
            if(model_item.entity_id == 'workflow'){
              $scope.workflow.ref = angular.copy(model_item);
            }
          })
        })
      });
    };

    $scope.$watch('selected.model.workflow_id', function (newValue, oldValue) {
      /* mi tiro giù tutto il workflow con il numero di stati */
      //$scope.selected.model.workflow_id = $scope.confModel.workflow_id;
      if($scope.selected.model.workflow_id != undefined){
        var UUID = $scope.selected.model.workflow_id.UUID;
        var type = $scope.selected.model.workflow_id.type;
        recordFactory(type).byUUID({id: UUID}).$promise.then(function (responseWorkflow) {
            if(responseWorkflow.model){
                if(responseWorkflow.model.steps==Object.keys($scope.selected.model.steps).length){
                    for(var i = 0; i < responseWorkflow.model.steps; i++){
                        if(!$scope.selected.UUID){
                            $scope.selected.model.steps['step' + ((i+1).toString())] = {
                            'step_id': {},
                            'days': 0,
                            'days_acts': 0,
                            'date_start': '',
                            'date_end': ''
                            }
                        }
                    }
                }
                else if(responseWorkflow.model.steps<Object.keys($scope.selected.model.steps).length){
                        var start = Object.keys($scope.selected.model.steps).length;
                        for(var i = start; i >= responseWorkflow.model.steps; i--){
                            delete $scope.selected.model.steps['step' + ((i+1).toString())];
                        }
                    }
                else if(responseWorkflow.model.steps>Object.keys($scope.selected.model.steps).length){
                    for(var i = Object.keys($scope.selected.model.steps).length; i < responseWorkflow.model.steps; i++){
                        $scope.selected.model.steps['step' + ((i+1).toString())] = {
                            'step_id': {},
                            'days': 0,
                            'days_acts': 0,
                            'date_start': '',
                            'date_end': ''
                            }
                    }
                }
                $scope.getArrayFromProp($scope.selected.model.steps);
            }
        });
      }
    });


    $scope.$watch('selectedStep.value.UUID', function () {
      if(angular.isDefined($scope.selectedStep.value) && $scope.selectedStep.value.UUID){
        /* devo trovare lo step associato */
        angular.forEach($scope.selected.model.steps, function (value, key) {
          if(value.step_id.UUID == $scope.selectedStep.value.UUID){
            console.log(key);
            $scope.getAttributeList(key);
          }
        });
      }
    });

    $scope.workflowSelected = function (ref) {
      return (ref != null && ref != '' && ref != undefined);
    };

    $scope.getArrayFromProp = function (obj) {
      /* obj = { steps3: '', step2: '', step1: '' } => creo array e ordino per nome proprietà => [ step1 : {}, step2 : {}, step3 : {} ] */
      $scope.arrayRet.length = 0;
      $scope.arrayIds.length = 0;
      var keys = [];
      for (var k in obj) {
        if (obj.hasOwnProperty(k)) {
          keys.push(k);
        }
      }
      keys.sort();
      var len = keys.length;
      for (var i = 0; i < len; i++) {
        k = keys[i];
        $scope.arrayRet.push(obj[k]);
        $scope.arrayIds.push('step' + (i+1));
      }
      return $scope.arrayRet;
    };

    $scope.getAttributeList = function (key) {      // key sarà step1, step2, step3
      $scope.dateStepArray[key] = [];
      if($scope.selectedStep.value.model) {
        angular.forEach($scope.selectedStep.value.model.form[0].items, function(item) {
          angular.forEach(item.tabs, function (tab) {
            angular.forEach(tab.items, function (model_item){
              if(model_item.type == 'datepicker'){
                $scope.dateStepArray[key].push(model_item);
              }
            })
          })
        });
      }
    };

    function fixDates(contract){
      if(angular.isDefined(contract.model)){
        $scope.form[0].items.forEach(function(item){
          item.tabs.forEach(function(tab){
            tab.items.forEach(function(model_item){
              if(model_item.type==='datepicker'){
                var propertyName = model_item.key[0];
                if(angular.isDefined(contract.model[propertyName]) && contract.model[propertyName]!=null){
                  contract.model[propertyName] = new Date(contract.model[propertyName]);
                }
              }
            });
          });
        });
      }
      return contract;
    }

    function getContractRecord(){
        contractFactory().recordByCommission().$promise.then(function (responseRecord){
            if(responseRecord.model){
              $scope.lock = true;
              $scope.selected = fixDates(responseRecord);
              $scope.getArrayFromProp($scope.selected.model.steps);
              $scope.plafond_total = getPlafondTotal();
              getPlafondUsed();
              console.log($scope.selected);
            } else {
              $scope.lock = false;
              $scope.selected = {
                model: {
                  workflow_id: '',
                  steps: {},
                  code: currentCommission.code,
                  description: currentCommission.description
                }
              };
            }
        });
    }

    $scope.getContractSchema = function () {
      /* scarico il modello e se me lo trova scarico anche il record -> che sarà sempre lo stesso */
      contractFactory().schemaByCommission().$promise.then(function(responseSchema){
        if(errorService.handleError(responseSchema)) {
          if (!responseSchema.model) {
            dialogService.alert('Non è stato definito un modello specifico per la convenzione ', 4000);
            return;
          }
          $scope.schema = responseSchema.model.schema;
          $scope.form = responseSchema.model.form;
          $scope.getWorkflowRef();
          getContractRecord();
        }
      });
    };

    $scope.isIntegrationEnabled = function(){
      var enabled = $scope.selected.version && $scope.selected.model.plafond && ($scope.selected.model.plafond>0);
      return enabled;
    };

    $scope.hasPlafondIntegrations = function(){
      var hasIntegrations = $scope.selected.version && $scope.selected.model.plafond && ($scope.selected.model.plafond>0) && angular.isDefined($scope.selected.model.plafond_integrations);
      return hasIntegrations;
    };

    $scope.integratePlafond = function(){
      $scope.isPlafondEditing = true;
      $scope.plafond_total = getPlafondTotal();
      getPlafondUsed();
      $scope.newPlafondIntegration = {
        date: new Date()
      };
    };

    $scope.saveIntegratePlafond = function(){
      if(!$scope.newPlafondIntegration.value){
        toaster.pop('error', 'Inserire un valore valido', 'La cifra inserita per l\'integrazione non è valida.');
      }
      else if(!$scope.newPlafondIntegration.date){
        toaster.pop('error', 'Inserire una data valida', 'La data inserita per l\'integrazione non è valida.');
      }
      else{
        $scope.isPlafondEditing = false;
        var newItem = {};
        for (var key in $scope.newPlafondIntegration) {
            newItem[key] = $scope.newPlafondIntegration[key];
        }
        if(angular.isUndefined($scope.selected.model.plafond_integrations)){
          $scope.selected.model.plafond_integrations = [];
        }
        $scope.selected.model.plafond_integrations.push(newItem);
        $scope.plafond_total = getPlafondTotal();
        getPlafondUsed();
      }
    };

    function getPlafondTotal(){
      $scope.newPlafondIntegration = undefined;
      var sum = $scope.selected.model.plafond;
      if(angular.isDefined($scope.selected.model.plafond_integrations)){
        angular.forEach($scope.selected.model.plafond_integrations, function(item) {
          sum += item.value;
        });
      }
      return sum;
    }

    function getPlafondUsed(){
        $scope.plafond = { used: 0, remaining: 0, available:0 };
        if(angular.isDefined($scope.plafond_total)){
            $scope.plafond.available = $scope.plafond_total;
            acquisitionWizardFactory.getUsedPlafond().$promise.then(function(data) {
              $scope.plafond.used = data.used_plafond;
              $scope.plafond.remaining = $scope.plafond.available - $scope.plafond.used;
              $scope.plafond.remaining_class = ($scope.plafond.remaining>0)?"text-success-dker":"text-danger-dker";
            });
        }
    }

    $scope.undoIntegratePlafond = function(){
      $scope.isPlafondEditing = false;
      $scope.newPlafondIntegration = undefined;
    };

    $scope.getFormulaList = function () {
      formulaFactory.getFormulasList({query: $scope.queryParam, page_size: 1000}).$promise.then(function(data) {
        $scope.formulaList = data.list;
      });
    };

    $scope.setDefaultDays = function (index) {
      if(!angular.isDefined($scope.selected.model.steps[index].type_days)){
        $scope.selected.model.steps[index].type_days = 'number';
      }
    };

    $scope.refreshDays = function (index){
      if($scope.selected.model.steps[index].type_days == 'number'){
        if(angular.isDefined($scope.selected.model.steps[index].formula_days)){
          delete $scope.selected.model.steps[index].formula_days;
          delete $scope.selected.model.steps[index].params_days;
        }
      } else if ($scope.selected.model.steps[index].type_days == 'formula') {
        if(angular.isDefined($scope.selected.model.steps[index].days)) {
          delete $scope.selected.model.steps[index].days;
        }
      } else if($scope.selected.model.steps[index].type_days == 'nolimits') {
        delete $scope.selected.model.steps[index].days;
        if(angular.isDefined($scope.selected.model.steps[index].formula_days)){
          delete $scope.selected.model.steps[index].formula_days;
          delete $scope.selected.model.steps[index].params_days;
        }
      }
    };

    $scope.setDefaultDaysActs = function (index) {
      if(!angular.isDefined($scope.selected.model.steps[index].type_days_acts)){
        $scope.selected.model.steps[index].type_days_acts = 'number';
      }
    };

    $scope.refreshDaysActs = function (index){
      if($scope.selected.model.steps[index].type_days_acts == 'number'){
        if(angular.isDefined($scope.selected.model.steps[index].formula_days_acts)){
          delete $scope.selected.model.steps[index].formula_days_acts;
          delete $scope.selected.model.steps[index].params_days_acts;
        }
      } else if ($scope.selected.model.steps[index].type_days_acts == 'formula') {
        if(angular.isDefined($scope.selected.model.steps[index].days_acts)) {
          delete $scope.selected.model.steps[index].days_acts;
        }
      } else if($scope.selected.model.steps[index].type_days_acts == 'nolimits') {
        delete $scope.selected.model.steps[index].days_acts;
        if(angular.isDefined($scope.selected.model.steps[index].formula_days_acts)){
          delete $scope.selected.model.steps[index].formula_days_acts;
          delete $scope.selected.model.steps[index].params_days_acts;
        }
      }
    };


    $scope.initFormuleDescriptors = function () {
      if(angular.isDefined($scope.selected.model)){
        angular.forEach($scope.selected.model.steps, function (value, key){
          if(angular.isDefined(value['formula_days'])){
            formulaFactory.getFormulaById({id: value['formula_days']}).$promise.then(function (data) {
              if(data.formula){
                $scope.formuleStrBodyDays[key] = data.formula;
              }
            });
          }
          /* atti aggiuntivi */
          if (angular.isDefined(value['formula_days_acts'])) {
            formulaFactory.getFormulaById({id: value['formula_days_acts']}).$promise.then(function (data) {
              if(data.formula){
                $scope.formuleStrBodyDaysActs[key] = data.formula;
              }
            });
          }
        });
      }
    };

    $scope.getFormattedParams = function (index) {
      if($scope.selected.model.steps[index].type_days == 'formula'){
        return 'col-md-offset-1 col-md-6';
      } else {
        return 'col-md-5';
      }
    };

    $scope.getParams = function (step, formulaField, paramsField) {
      formulaFactory.getParamsByArray({id: $scope.selected.model.steps[step][formulaField]}).$promise.then(function (data) {
        if(angular.isDefined(data.result)){
          $scope.selected.model.steps[step][paramsField] = {};
          if(data.result != null){
            $scope.selected.model.steps[step][paramsField] = data.result;
          }
        }
      });
      formulaFactory.getFormulaById({id: $scope.selected.model.steps[step][formulaField]}).$promise.then(function (data) {
        if(data.formula){
          if(formulaField == 'formula_days'){
            $scope.formuleStrBodyDays[step] = data.formula;
          } else if (formulaField == 'formula_days_acts') {
            $scope.formuleStrBodyDaysActs[step] = data.formula;
          }
        }
      });
    };



    $scope.getContractSchema();
    $scope.getFormulaList();
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ContractConfiguratorCtrl
 * @description
 * # ContractConfiguratorCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/contractconfigurator', {
        templateUrl: 'consip/contract/contractconfigurator_detail.html',
        controller: 'ContractConfiguratorCtrl'
      })
  })
  .controller('ContractConfiguratorCtrl', function ($scope, $routeParams, $location, $route, contractFactory, acquisitionStepFactory,
                                        schemaFactory, commissionFactory, formulaFactory, authFactory, toaster, $log) {

    $scope.form = {};

    $scope.model = {};

    $scope.schema = {};

    $scope.property = {};

    $scope.checked = {};

    $scope.uiselectMap = {};

    $scope.itemTypeMap =  {};

    $scope.newItemArray = {
      record_id: {}
    };

    $scope.status = {
      isFirstOpen: true,
      isFirstDisabled: false
    };

    /* ------------------------------------------------ */

    $scope.attachmentManagement = false;

    $scope.contractList = []; /* lista delle convenzioni per la pagina _list */

    $scope.formList = []; /* lista dei form da associare agli step */

    $scope.registry = {}; /* model della CONVENZIONE */

    $scope.steps = {};

    $scope.commissions = []; /* commesse disponibili */

    $scope.commissionsSelected = { codes: [] }; /* commesse selezionate */

    $scope.formulaList = {}; /* formule disponibili da poter inserire con il configuratore */

    $scope.modeltypeList = schemaFactory().lookupList({page_size: 1000});

    var currentCommission = authFactory.getAuthData().info.commissions.current;

    $scope.selected = {   /** contenitore */
      model: {
        commission: [],
        schema: {},
        form: [],
        code: '',
        description: '',
        columnDefs: []
      }
    };

    $scope.getFormulaList = function () {
      formulaFactory.getFormulasList({query: $scope.queryParam, page_size: 1000}).$promise.then(function(data) {
        $scope.formulaList = data.list;
      });
    };

    $scope.save = function () {
      if($scope.code && $scope.description) {
        /* aggiorno code e description */
        $scope.selected.model.code = $scope.code;
        $scope.selected.model.description = $scope.description;
        $scope.selected.model.attachmentManagement = $scope.attachmentManagement;
        if ($scope.selected.version) {
          /* update */
          contractFactory().updateSchema({id: $scope.selected.version}, $scope.aceModel).$promise.then(function() {
            console.log('updated!');
            toaster.pop('success', 'Salvataggio effettuato', '');
            $route.reload();
          });
        } else {
          /* create */
          contractFactory().createSchema($scope.selected).$promise.then(function() {
            console.log('created!');
            toaster.pop('success', 'Salvataggio effettuato', '');
            $route.reload();
           });
        }
      }
    };

    $scope.delete = function () {
      /* eliminare tramite routeParam.id */
      contractFactory().deleteSchema({id: $scope.selected.version}).$promise.then(function () {
        console.log('deleted!');
        toaster.pop('error', 'Eliminazione effettuata', '');
        $route.reload();
      });

    };

    $scope.getSetupConfiguration = function () {
      /* prende i dati del modello convenzione di BASE */
      return schemaFactory().byCode({id: 'convenzione'}).$promise.then(function (data) {
              if(data.model){
                $scope.selected.columnDefs = data.model.columnDefs;
                $scope.selected.schema = data.model.schema;
                $scope.selected.form = data.model.form;
              }
            });
    };

    $scope.setCommissionSelected = function(){
      angular.forEach($scope.selected.model.commission, function( value_cm_string){
        var index = null;
        angular.forEach($scope.commissions, function(value_cm_obj){
          if(value_cm_string == value_cm_obj.code){
            index = $scope.commissions.indexOf(value_cm_obj);
            $scope.commissionsSelected.codes.push(value_cm_obj);
            $scope.commissions.splice(index,1);
          }
        });
      });
    };

    $scope.setCommissionToSelect = function () {
      $scope.selected.model.commission = [];
      angular.forEach($scope.commissionsSelected.codes, function(obj){
        $scope.selected.model.commission.push(obj.code);
      });
    };

    $scope.getCommission = function getCommission(){
      return commissionFactory().getCommissionsList().$promise.then(function (response){
        if(response.list){
          $scope.commissions = response.list;
          var index = null;
          angular.forEach($scope.commissions, function(value_cm_obj){
            if(currentCommission.code == value_cm_obj.code){
              index = $scope.commissions.indexOf(value_cm_obj);
              $scope.commissionsSelected.codes.push(value_cm_obj);
              $scope.commissions.splice(index,1);
            }
          });
          $scope.refreshCommission();
        }
      });
    };

    $scope.getContractConfiguration = function () {
      $scope.getSetupConfiguration().then(function () {
        /* scarico prima la convenzione di base dalla quale partire */
        $scope.getCommission().then(function () {
          /* inserisco la commessa tra i dati */
          contractFactory().schemaByCommission().$promise.then(function(response){
            /* scarico se c'è uno schema di convenzione salvato per la mia commessa  */
            if(response.model){
              $scope.selected = angular.copy(response);
              $scope.code = response.model.code;
              $scope.description = response.model.description;
              $scope.attachmentManagement = response.model.attachmentManagement;
              $scope.setCommissionSelected();
              $scope.updateScope();
            } else {
              $scope.code = currentCommission.code;
              $scope.description = currentCommission.description;
              $scope.updateScope();
            }
          });
        });
      });
    };

    $scope.getContractConfiguration();
    $scope.getFormulaList();

    /*****************************************************************************/
    /*************** ADD & DELETE PROPERTIES ON $scope.model.schema *************/
    /***************************************************************************/

    $scope.addProperty = function() {
      if(angular.isDefined($scope.property.key)) {
        var p = {
          title: angular.copy($scope.property.title),
          type: angular.copy($scope.property.type),
          check: false
        };
        if($scope.property.format){
          p.format = angular.copy($scope.property.format);
        }
        if(p.type == 'date'){
          p.type = 'string';
          p.format = 'date';
        }
        if(p.type == 'array'){
          p.items = {type: angular.copy($scope.property.items_type)}; // default
          if($scope.property.items_type === 'date') { // se è una data è diverso...
            p.items = {type: 'string', format: 'date'};
          }
        }
        if($scope.property.inherited){
          if($scope.property.inherited == true){
            p.format = 'inherit';
            p.field = '';
            p.record = '';
            if($scope.property.format){
              p.field_inherit_type = $scope.property.format;
              if($scope.property.format == 'enum'){
                delete p.enum;
              }
            }
            if(p.type == 'integer'){
              p.type = 'number';
            }
          }
        }
        $scope.selected.model.schema.properties[$scope.property.key] = p;
        var item = {
          title: angular.copy($scope.property.title),
          type: null,
          key: [angular.copy($scope.property.key)]
        };
        if(p.format){
          if (p.format == 'date'){
            item.type = 'datepicker';
          } else if (p.format == 'enum'){
            item.type = 'uiselect';
            item.titleMap = [];
          } else if (p.format == 'lookup'){
            item.type = 'sixlookup';
          } else if (p.format == 'formula'){
            item.type = 'sixformula';
          } else if (p.format == 'inherit'){
            item.type = 'sixinherit';
          }
        } else if(p.type == 'string'){
          item.type = 'text';
        } else if(p.type == 'number' || p.type == 'integer'){
          item.type = 'number';
        } else if(p.type == 'boolean'){
          item.type = 'checkbox';
        } else if(p.type == 'array') {
          item.type = 'uiselectmultiple';
          item.titleMap = [];
        } else {  // default
          item.type = angular.copy(p.type);
        }
        for(var i in $scope.selected.model.form[0].items) {
          if($scope.selected.model.form[0].items[i].tabs) {
            $scope.selected.model.form[0].items[i].tabs[0].items.push(item);
          }
        }
      }
      $scope.getUiSelectMap();
      $scope.clearNewCol();
      $scope.updateScope();
    };

    $scope.clearNewCol = function(){
      $scope.property.key = '';
      $scope.property.title = '';
      delete $scope.property.type;
      delete $scope.property.format;
      delete $scope.property.inherited;
    };

    $scope.deleteProperty = function(keyToDelete) {
      delete $scope.selected.model.schema.properties[keyToDelete];
      for (var i = $scope.selected.model.columnDefs.length; i--; ) {
        if ($scope.selected.model.columnDefs[i].field == keyToDelete) $scope.selected.model.columnDefs.splice(i, 1);
      }
      for (var i = $scope.selected.model.form[0].items.length; i--; ) {
        if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == keyToDelete) {
          $scope.selected.model.form[0].items.splice(i, 1);
        }
        // Scorro anche i tabs
        if($scope.selected.model.form[0].items[i].tabs) {
          for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
            for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
              if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == keyToDelete) {
                $scope.selected.model.form[0].items[i].tabs[j].items.splice(k, 1);
              }
            }
          }
        }
      }
      $scope.updateScope();
    };


    /*****************************************************************************/
    /*************** AGGIORNA LA $scope.selected.model.columnDefs ***************/
    /***************************************************************************/


    $scope.changeColumnDefs = function (key, value) {
      var item = {name: value.title, field: key};
      var map = {};
      angular.forEach($scope.selected.model.columnDefs, function (v) {
        map[v.field] = angular.copy(v);
      });
      if(value.check){
        map[item.field] = angular.copy(item);
        if(value.width == '' || value.width == null) {
          delete $scope.selected.model.schema.properties[key].width;
        }
      }
      else{
        delete map[item.field];
        delete $scope.selected.model.schema.properties[key].width;
        $scope.selected.model.schema.properties[key].enableFiltering = false;
        $scope.selected.model.schema.properties[key].enableSorting = false;
      }
      $scope.selected.model.columnDefs=[];
      for(var it in map) {
        var app = {name: map[it].name, field: map[it].field};
        $scope.selected.model.columnDefs.push(app);
      }
      $scope.updateScope();
    };


    /*************************************/
    /*************** FORM ***************/
    /***********************************/

    $scope.newFieldForm = {};
    $scope.newTab = {
      title: "",
      items: []
    };

    $scope.addTab = function(container){
      if(!container.tabs) {
        container.tabs = [];
      }
      if(container.type !== 'tabs') {
        container.type = 'tabs';
      }
      var toAdd = angular.copy($scope.newTab);
      $log.log(container);
      container.tabs.push(toAdd);
      $log.log(container);
      $scope.updateScope();
      $scope.newTab = {
        title: "",
        items: []
      };
    };

    $scope.addFieldToTab = function(tab){
      if(!tab.items) {
        tab.items = [];
      }
      var toAdd = angular.copy($scope.newFieldForm);
      if($scope.newFieldForm.type === '' || $scope.newFieldForm.type === 'formula' || $scope.newFieldForm.type === 'inherited') {
        delete toAdd.type;
      }
      /* key è da cambiare in un array */
      toAdd.key = [];
      toAdd.key.push($scope.newFieldForm.key);
      /* se è una lookup, e se ha definito il campo entity_id nello schema, ci attacco anche l'entity_id */
      if(toAdd.type == 'sixlookup' && $scope.schema.properties[$scope.newFieldForm.key]['entity_id']){
        toAdd['entity_id'] = $scope.schema.properties[$scope.newFieldForm.key]['entity_id'];
      }
      tab.items.push(toAdd);
      $log.log(tab);
      $scope.updateScope();
      $scope.newFieldForm = {
        key: [],
        title: "",
        required: false,
        type: "text"
      };
    };

    $scope.removeTabOrField = function(key, container){
      container.splice(key, 1);
      $log.log(container);
      $scope.updateScope();
    };

    $scope.swapUp = function(key, collection) {
      if(key > 0) {
        var tmp = collection[key];
        collection[key] = collection[key-1];
        collection[key-1] = tmp;
      }
      $scope.updateScope();
    };

    $scope.swapDown = function(key, collection) {
      if(key < collection.length-1) {
        var tmp = collection[key];
        collection[key] = collection[key+1];
        collection[key+1] = tmp;
      }
      $scope.updateScope();
    };

    $scope.updateField = function(field) {
      if(field.type === '') {
        delete field.type;
      }
      $scope.updateScope();
    };


    /**********************************************************************************************************/
    /*************** GESTIONE DEGLI ELEMENTI NEI TAB $scope.selected.model.form[0].items[i].tabs *************/
    /********************************************************************************************************/

    $scope.addItemOnArray = function(key, newItem){
      if(newItem != undefined && newItem != null){
        newItem.name = newItem.name.toString();
        if($scope.itemTypeMap[key] == 'integer'){
          if(parseInt(newItem.name)){
            newItem.value = parseInt(newItem.name);
            newItem.name = newItem.value.toString(); /* nel caso ci dovesse essere un cast, torno a sovrascrivere il name */
          } else{
            return;
          }
        } else if($scope.itemTypeMap[key] == 'number'){
          if(parseFloat(newItem.name)){
            newItem.value = parseFloat(newItem.name);
          } else{
            return;
          }
        } else{
          newItem.value = newItem.name.toString().replace(/\s/g, '_').toLowerCase();
        }
        for(var i in $scope.selected.model.form[0].items) {
          if($scope.selected.model.form[0].items[i].tabs) {
            $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
              if(key == item.key[0]){
                item.titleMap.push(newItem);
              }
            });
          }
        }
        this.newItem = null;
        $scope.updateScope();
      }
    };

    $scope.deleteItemOnArray = function(key, obj){
      for(var i in $scope.selected.model.form[0].items) {
        if($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            if(key == item.key[0]){
              for (var j = item.titleMap.length; j--; ) {
                if (item.titleMap[j].value == obj.value) {
                  item.titleMap.splice(j, 1);
                }
              }
            }
          });
        }
      }
      this.newItem = null;
      $scope.updateScope();
    };

    $scope.addRefOnArray = function(key, ref) {
      var newItem = {};
      if(ref.record_id != undefined && ref.record_id != null){
        newItem.value = ref.record_id.code;
        newItem.name = ref.record_id.description;
        $scope.addItemOnArray(key, newItem);
      }
    };

    /*****************************************/
    /*************** FIX SCHEMA *************/
    /***************************************/

    $scope.fixSchemaFormModel = function() {
      for(var i in $scope.selected.model.form[0].items) {
        if($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            if(item.type == 'uiselect'){
              $scope.selected.model.schema.properties[item.key[0]].format = 'enum';
            }
            if(item.type == 'uiselectmultiple'){
              $scope.selected.model.schema.properties[item.key[0]].type = 'array';
            }
          });
        }
      }
    };

    /***************************************************************************/
    /***** UTILITY PER DATA BINDING TRA $scope.selected E $scope.aceModel *****/
    /*************************************************************************/

    $scope.isInheritable = function(type){
      return (type == 'number' || type == 'integer' || type == 'string' || type == 'boolean' || type == 'lookup');
    };

    $scope.formChanged = function() {
      $scope.aceModel = JSON.stringify(angular.copy($scope.selected), null, '\t');
    };

    $scope.chargeAceModel = function() {
      var defaultData = angular.fromJson(angular.copy($scope.aceModel));
      if(defaultData) {
        $scope.selected = defaultData;
        $scope.schema = angular.fromJson(defaultData.model.schema);
        $scope.form = angular.fromJson(defaultData.model.form);
        $scope.columnDefs = angular.fromJson(defaultData.model.columnDefs);
      }
    };

    $scope.updateScope = function() {
      $scope.schema = angular.fromJson(angular.copy($scope.selected.model.schema));
      $scope.form = [angular.fromJson(angular.copy($scope.selected.model.form[0]))];
      $scope.columnDefs = angular.fromJson(angular.copy($scope.selected.model.columnDefs));
      $scope.formChanged();
    };

    function addSelectedValue(array, obj) {
      var blankValuePresent = false;
      array.forEach(function (item) {
        if(item.value == obj.value && item.name == obj.name){
          blankValuePresent = true;
        }
      });
      if(blankValuePresent == false){
        array.push(obj);
      }
      return array;
    }

    $scope.getUiSelectMap = function(){
      $scope.uiselectMap = {};
      $scope.itemTypeMap  = {};
      for(var i in $scope.selected.model.form[0].items) {
        if($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            if(item.type !== 'fieldset') {
              $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].type;
              if ($scope.selected.model.schema.properties[item.key[0]].type == 'array') {
                $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].items.type;
              }

              if (item.type == 'uiselect' || item.type == 'uiselectmultiple') {
                var blankObject = {
                  name: '',
                  value: ''
                };
                $scope.uiselectMap[item.key[0]] = addSelectedValue(item.titleMap, blankObject);
                /* aggiunto un elemento vuoto all'array per consentire il deselezionamento */
              }
            }
          });
        }
      }
    };

    $scope.aceLoaded = function() {
      var defaultModel = {
        model: {
          schema: {type: "object",
            title: "",
            properties: {
              code: {
                title: "Codice",
                type: "string",
                check: true
              },
              description: {
                title: "Descrizione",
                type: "string",
                check: true
              }
            },
            required: [
              "code",
              "description"
            ]},
          form:[
            {
              type: "fieldset",
              items: [
                {
                  type: "tabs",
                  tabs: [
                    {
                      title: "Dati Base",
                      items: [
                        {
                          key: ["code"],
                          title: "Codice",
                          required: true,
                          type: "text"
                        },
                        {
                          key: ["description"],
                          title: "Descrizione",
                          required: true,
                          type: "text"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          columnDefs:[
            {
              "field": "code",
              "name": "Codice"
            },
            {
              "field": "description",
              "name": "Descrizione"
            }
          ]
        }
      };
      $scope.aceModel = JSON.stringify(defaultModel, null, '\t');
      $scope.chargeAceModel();
      $scope.title = angular.copy($scope.selected.model.form[0].title);
      schemaFactory().byCode({id: 'convenzione'}).$promise.then(function (data) {
        if(data.model) {
          data.model.code = '';
          data.model.description = '';
          $scope.selected.model = angular.copy(data.model);
          $scope.fixSchemaFormModel();
          $scope.schema = angular.copy($scope.selected.model.schema);
          $scope.form = angular.copy($scope.selected.model.form);
          $scope.title = angular.copy($scope.selected.model.form[0].title);
          $scope.code = angular.copy($scope.selected.model.code);
          $scope.description = angular.copy($scope.selected.model.description);
          if($scope.selected.model.columnDefs && ($scope.selected.model.columnDefs.length != 0)) {
            $scope.columnDefs = angular.copy($scope.selected.model.columnDefs);
          } else {
            $scope.columnDefs= [
              { name:'Codice', field: 'code' },
              { name:'Descrizione', field: 'description' }
            ];
            $scope.selected.model.columnDefs = angular.copy($scope.columnDefs);
          }
          angular.forEach($scope.columnDefs, function (value) {
            $scope.selected.model.schema.properties[value.field].check = true;
          });
          $scope.schema = angular.copy($scope.selected.model.schema);
          $scope.aceModel = JSON.stringify($scope.selected, null, '\t');
          $scope.model = {};
          $scope.commissionDependent = angular.copy($scope.selected.model.commissionDependent);
          $scope.history = angular.copy($scope.selected.model.history);
          $scope.attachmentManagement = angular.copy($scope.selected.model.attachmentManagement);
          $scope.getUiSelectMap();
        }
      });
    };

    $scope.refreshCode = function(code) {
      $scope.chargeAceModel();
      $scope.selected.model.code = angular.copy(code);
      $scope.updateScope();
    };

    $scope.refreshDescription = function(description) {
      $scope.chargeAceModel();
      if(description) {
        $scope.selected.model.description = angular.copy(description);
        if(angular.isUndefined($scope.selected.UUID)){
          $scope.code = sixStringLib.removeDiacritics(description);
          $scope.code = $scope.code.replace(/[^\w]|_/g, '').replace(/^(\d)(.*)/, '_$1$2').toLowerCase();
          $scope.selected.model.code = angular.copy($scope.code);
        }
      }
      $scope.updateScope();
    };

    $scope.refreshLookup = function(key,entity_id) {
      $scope.chargeAceModel();
      for (var i = $scope.selected.model.form[0].items.length; i--;) {
        if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == key) {
          $scope.selected.model.form[0].items[i].entity_id = angular.copy(entity_id);
        }
        // Scorro anche i tabs
        if($scope.selected.model.form[0].items[i].tabs) {
          for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
            for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
              if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == key) $scope.selected.model.form[0].items[i].tabs[j].items[k].entity_id = angular.copy(entity_id);
            }
          }
        }
      }
      $scope.selected.model.schema.properties[key].entity_id = angular.copy(entity_id);
      $scope.updateScope();
    };

    $scope.refreshCommission = function () {
      /** PROBABILMENTE E' DA SISTEMARE */
      $scope.chargeAceModel();
      $scope.selected.model.commission = [];
      angular.forEach($scope.commissionsSelected.codes, function(obj){
        $scope.selected.model.commission.push(obj.code);
      });
      $scope.updateScope();
    };

    $scope.refreshStep = function (step) {
      $scope.chargeAceModel();
      $scope.selected.model.step = step;
      $scope.updateScope();
    };

    $scope.refreshFormula = function(key,formula_id) {
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].formula_id = angular.copy(formula_id);
      $scope.updateScope();
    };

    $scope.refreshFormulaParams = function(key,formula_params){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].formula_params = angular.copy(formula_params);
      $scope.updateScope();
    };

    $scope.refreshBasePath = function(key, basePath){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].basePath = angular.copy(basePath);
      $scope.updateScope();
    };

    $scope.refreshWar = function(key, war){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].war = angular.copy(war);
      $scope.updateScope();
    };

    $scope.refreshInheritRecord = function(key, record){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].record = angular.copy(record);
      $scope.updateScope();
    };

    $scope.refreshInheritField = function(key, field){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].field = angular.copy(field);
      $scope.updateScope();
    };

    $scope.refreshFiltered = function(key, filtered){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].filtered = angular.copy(filtered);
      $scope.updateScope();
    };

    $scope.refreshFilterSourceField = function(key, filterSourceField){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].filterSourceField = angular.copy(filterSourceField);
      $scope.updateScope();
    };

    $scope.refreshFilterDestField = function(key, filterDestField){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].filterDestField = angular.copy(filterDestField);
      $scope.updateScope();
    };

    $scope.refreshTitleForm = function(title) {
      $scope.chargeAceModel();
      $scope.selected.model.form[0].title = angular.copy(title);
      $scope.updateScope();
    };
  });

'use strict';

/**
 * @author Rita Beltrami
 * @ngdoc function
 * @name sixEmmaApp.controller:DashboardConsipCtrl
 * @description
 * # DashboardConsipCtrl
 * Controller of the Consip project dashboard
 */
angular.module('emma.consip')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/consip', {
            templateUrl: 'theme/dashboard/dashboard.html',
            controller: 'DashboardConsipCtrl'
        })
  })
  .controller('DashboardConsipCtrl', function ($scope, $log, dashboardAssetFactory, authFactory) {

    //__params__
    var logInfo = true;
    var config = [];
    $scope.pos1 = [];
    $scope.pos2 = [];
    $scope.pos3 = [];
    $scope.widgetClass = "panel-widge";

    function userInfo(){
        if($scope.isLoggedIn()){
          var authData = authFactory.getAuthData();
          return authData;
        }else{
          return;
        }
    }

    config = [
        {   // Ultimi ODL inseriti
            "maxData": 5, //TODO: gestire
            "widgetApi": "dashboard/odl/list",
            "title": "Ultime acquisizioni completate",
            "skin": "primary",
            "widgetType": "widget-simple-list",
            "position": "pos-1",
            "buttons": [
                {
                    "icon": "fa fa-plus",
                    "label": "Nuova acquisizione",
                    "link": "acquisitionwizard/new"
                }
            ]
        },
        {   // Profilo utente
            "title": "Profilo utente",
            "skin": "info",
            "widgetType": "widget-user",
            "position": "pos-2",
            "data": [
                {
                    "user": userInfo().info.name + " "+ userInfo().info.surname,
                    "group": userInfo().authId,
                    "avatar": "avatar.png",
                    "buttons": [
                    {
                        "icon": "icon-bell",
                        "label": "Notifiche",
                        "link": "notification",
                        "hasBadge": false
                    },
                    {
                        "icon": "icon-logout",
                        "label": "Logout",
                        "link": "#",
                        "hasBadge": false
                    }
                    ]
                }
            ]
        }
    ];

  /*
    function toDonutItem(item) {
        item.data = [
            {label: "1", value: 20, color: $scope.app.color.primary, description: 'Pippo'},
            {label: "2", value: 50, color: $scope.app.color.info, description: 'Pluto'},
            {label: "3", value: 30, color: $scope.app.color.warning, description: 'Paperino'}
        ];
    }
  */


    function convertToDonutFormat(item) {
        item.appColor = item.color;
        switch (item.color) {
            case "primary":
                item.color = $scope.app.color.primary;
                break;
            case "info":
                item.color = $scope.app.color.info;
                break;
            case "success":
                item.color = $scope.app.color.success;
                break;
            case "light":
                item.color = $scope.app.color.light;
                break;
            case "dark":
                item.color = $scope.app.color.dark;
                break;
            case "danger":
                item.color = $scope.app.color.danger;
                break;
            case "warning":
                item.color = $scope.app.color.warning;
                break;
            default:
                break;
        }
    }

    function createWidget(item) {
        // Retrieves data from the backend
        if(angular.isDefined(item.widgetApi)){
            item.data = [];
                dashboardAssetFactory(item.widgetApi).query()
                    .$promise.then(function(data) {
                        for(var i=0; i<data.list.length; i++){
                            if(item.widgetType=="widget-donut"){
                                convertToDonutFormat(data.list[i]);
                            }
                            item.data.push(data.list[i]);
                        }
                });
        }
        // Sets widget to the right position.
        switch (item.position){
            case 'pos-1':
                $scope.pos1.push(item);
                break;
            case 'pos-2':
                $scope.pos2.push(item);
                break;
            case 'pos-3':
                $scope.pos3.push(item);
                break;
            default:
                $log.info("Posizione widget sconosciuta");
        }
    }

    $scope.getDynamic = function(item) {
      return undefined;
    };

    $scope.initDashboard = function(){
        for (var i=0; i<config.length; i++) {
            createWidget(config[i]);
        }
    };

    //__main__
    $scope.initDashboard();

});


angular.module('emma.consip')
  .factory('acquisitionStepFactory', function (CONSIP_URL, $resource) {
    return function(type, param1, param2) {
      return $resource(CONSIP_URL + '/api/acquisitionstep/:verb/:id/:param1/:param2/:param3', {}, {
        query:  {method: 'GET', isArray: false},
        lookup: {method: 'GET', isArray: false, params: {verb: '_lookup'}},
        lookupList: {method: 'GET', isArray: true, params: {verb: '_lookup', res_mode: 'list'}},
        byUUID: {method: 'GET', isArray: false, params: {verb: '_uuid', id: '@version', param1: '_current'}},
        byID:   {method: 'GET', isArray: false, params: {verb: '_id', id: '@version'}},
        byCode: {method: 'GET', isArray: false, params: {verb: '_code', id: '@version'}},
        getSchema:   {method: 'GET', isArray: false, params: {verb: '_uuid'}},
        search: {method: 'POST', isArray: false},
        filter: {method: 'POST', isArray: true},
        select: {method: 'GET', isArray: true},
        create: {method: 'POST'},
        bulk:   {method: 'POST', isArray: true},
        show:   {method: 'GET'},
        update: {method: 'PUT', params: {id: '@id'}},
        delete: {method: 'DELETE', params: {id: '@id'}}
      });
    };
  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.acquisitionWizardFactory
 * @description
 * # acquisitionWizardFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.consip')
  .factory('acquisitionWizardFactory', function (CONSIP_URL, $resource) {
      return $resource(CONSIP_URL + '/api/acquisitionwizard/acquisition/:verb/:id/:param1/:param2/:param3', {}, {
        getWizardById:            {method: 'GET'},
        getWizardByUUID:          {method: 'GET',     params: {verb: '_uuid', param1: '_current'}},
        getWizardsList:           {method: 'GET'},
        getWizardsListFiltered:   {method: 'POST',    params: {verb: '_search'}},
        getByClient:              {method: 'GET',     params: {param1: '_client', param2:'_active'}},
        getTerminatedByClient:    {method: 'GET',     params: {param1: '_client', param2:'_terminated'}},
        createWizard:             {method: 'POST',    params: {verb: '_save', param1: '@param1'}},
        updateWizard:             {method: 'PUT'},
        deleteWizard:             {method: 'DELETE',  params: {id: '@id'}},
        stepForward:              {method: 'PUT',     params: {id: '@id', param1: '_step', param2: 'approved'}},
        stepBack:                 {method: 'PUT',     params: {id: '@id', param1: '_step', param2: 'back'}},
        getStep:                  {method: 'GET',     params: {param1: '_step'}},
        getUsedPlafond:           {method: 'GET',     params: {verb: '_plafond'}},
        adminDeleteInvalidActsRef:{method: 'GET',     params: {verb: '_admin', param1:'_deleteInvalidActsRef'}},
        getDaysRefreshed:         {method: 'POST',    params: {param1: '_days'}}
      });
  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.additionalActsFactory
 * @description
 * # additionalActsFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.consip')
  .factory('additionalActsFactory', function (CONSIP_URL, $resource) {
      return $resource(CONSIP_URL + '/api/acquisitionwizard/additionalacts/:verb/:id/:param1/:param2/:param3', {}, {
        getActById:               {method: 'GET'},
        getActByUUID:             {method: 'GET',     params: {verb: '_uuid', param1: '_current'}},
        getActsList:              {method: 'GET'},
        getActsListFiltered:      {method: 'POST',    params: {verb: '_search'}},
        getBySourceUUID:          {method: 'GET',     params: {param1: '_source'}},
        getByClient:              {method: 'GET',     params: {param1: '_client', param2: '_active'}},
        createAct:                {method: 'POST',    params: {verb: '_save', param1: '@param1'}},
        updateAct:                {method: 'PUT'},
        deleteAct:                {method: 'DELETE',  params: {id: '@id'}},
        stepForward:              {method: 'PUT',     params: {id: '@id', param1: '_step', param2: 'approved'}},
        stepBack:                 {method: 'PUT',     params: {id: '@id', param1: '_step', param2: 'back'}},
        getStep:                  {method: 'GET',     params: {param1: '_step'}},
        adminDeleteOrphanActs:    {method: 'GET',     params: {verb: '_admin', param1:'_deleteOrphanActs'}},
        getAttributes:            {method: 'POST',    params: {verb: '_attribute'}},

        getDaysRefreshed:         {method: 'POST',    params: {param1: '_days'}}
      });
  });


'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.contractFactory
 * @description
 * # contractFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.consip')
  .factory('contractFactory', function (CONSIP_URL, $resource) {
    return function() {
      return $resource(CONSIP_URL + '/api/contract/:type/:verb/:id/:param1/:param2/:param3', {}, {
        createSchema:         {method: 'POST',                params: {type: 'schema'}},
        updateSchema:         {method: 'PUT',                 params: {type: 'schema', id: '@id'}},
        deleteSchema:         {method: 'DELETE',              params: {type: 'schema', id: '@id'}},
        schemaByCommission:   {method: 'GET', isArray: false, params: {type: 'schema', verb: '_commission'}},

        recordByUUID:         {method: 'GET', isArray: false, params: {type: 'record', verb: '_uuid', id: '@version', param1: '_current'}},
        recordByID:           {method: 'GET', isArray: false, params: {type: 'record', verb: '_id', id: '@version'}},
        recordByCommission:   {method: 'GET', isArray: false, params: {type: 'record', verb: '_commission'}},
        recordByCode:         {method: 'GET', isArray: false, params: {type: 'record', verb: '_code', id: '@version'}},
        createRecord:         {method: 'POST',                params: {type: 'record'}},
        updateRecord:         {method: 'PUT',                 params: {type: 'record', id: '@id'}},
        deleteRecord:         {method: 'DELETE',              params: {type: 'record', id: '@id'}},
        getAvailablePlafond:  {method: 'GET', isArray: false, params: {type: 'record', verb: '_plafond'}}
      });
    };
});
// Default:
// {
//   'get':    {method:'GET'},
//   'save':   {method:'POST'},
//   'query':  {method:'GET', isArray:true},
//   'remove': {method:'DELETE'},
//   'delete': {method:'DELETE'}
// }


// ordine CONSIP!!!

angular.module('emma.consip')
  .factory('orderRowFactory', function (CONSIP_URL, $resource) {
      return $resource(CONSIP_URL + '/api/order/row/:verb/:id/:param1/:param2/:param3', {}, {
        search:     {method: 'POST', isArray: false, params: {verb: '_search'}},
        bulkSave:   {method: 'POST', isArray: false, params: {verb: '_bulk'}},
        bulkDelete: {method: 'POST', isArray: false, params: {verb: '_delete'}},
        applyIstat: {method: 'POST', isArray: true, params: {verb: '_applyistat', id: '@id'}}
      });
  });


// listino CONSIP!!!

angular.module('emma.consip')
  .factory('pricelistRowFactory', function (CONSIP_URL, $resource) {
      return $resource(CONSIP_URL + '/api/pricelist/row/:verb/:id/:param1/:param2/:param3', {}, {
        search:   {method: 'POST', isArray: false, params: {verb: '_search'}},
        enriched: {method: 'POST', isArray: false, params: {verb: '_enrich'}},
        delete:   {method: 'POST', isArray: false, params: {verb: '_delete'}},
        bulkSave: {method: 'POST', isArray: false, params: {verb: '_bulk'}}
      });
  });

angular.module('emma.consip')
  .factory('salAttachmentsFactory', function (CONSIP_URL, $resource) {
    return $resource(CONSIP_URL + '/api/sal/attachments/:verb/:id/:param1/:param2/:param3', {}, {
      search:     {method: 'POST', isArray: false, params: {verb: '_search', id: '@id'}},
      bulkDelete: {method: 'POST', isArray: false, params: {verb: '_delete'}},
      generate:   {method: 'POST', isArray: false, params: {verb: '_generate'}},
      save:       {method: 'POST', isArray: false, params: {verb: '_save'}},
      report:     {method: 'POST', isArray: false, params: {verb: '_report'}}
    });
  });


// ordine CONSIP!!!

angular.module('emma.consip')
  .factory('salConfigurationFactory', function (CONSIP_URL, $resource) {
      return $resource(CONSIP_URL + '/api/sal/configuration/:verb/:id/:param1/:param2/:param3', {}, {
        create:     {method: 'POST'},
        update:     {method: 'PUT',  isArray: false, params: {verb: '_update', id: '@id'}},
        search:     {method: 'POST', isArray: false, params: {verb: '_search'}},
        delete:     {method: 'DELETE', isArray: false, params: {id: '@id'}},
        bulkDelete: {method: 'POST', isArray: false, params: {verb: '_delete'}},
        generate:   {method: 'POST', isArray: false, params: {verb: '_generate'}}
      });
  });


// ordine CONSIP!!!

angular.module('emma.consip')
  .factory('salFactory', function (CONSIP_URL, $resource) {
      return $resource(CONSIP_URL + '/api/sal/:verb/:id/:param1/:param2/:param3', {}, {
        search:     {method: 'POST', isArray: false, params: {verb: '_search'}},
        listSal:    {method: 'POST', isArray: false, params: {verb: '_list'}},
        bulkDelete: {method: 'POST', isArray: false, params: {verb: '_delete'}},
        generate:   {method: 'POST', isArray: false, params: {verb: '_generate'}},
        save:       {method: 'POST', isArray: false, params: {verb: '_save'}},
        checkCode:  {method: 'GET',  isArray: false, params: {verb: '_checkunique'}},
        unique:     {method: 'GET',  isArray: false, params: {verb: '_unique'}},
        report:     {method: 'POST', isArray: false, params: {verb: '_report'}},
        head:       {method: 'GET', isArray: false, params: {verb: '_head', id: '@id'}}
      });
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:OrderCtrl
 * @description
 * # OrderCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/order/detail', {
        templateUrl: 'consip/order/order_detail.html',
        controller: 'OrderCtrl'
      })
      .when('/order/detail/:id', {
        templateUrl: 'consip/order/order_detail.html',
        controller: 'OrderCtrl'
      })
  })
  .controller('OrderCtrl', function ($scope, $location, $routeParams, acquisitionWizardFactory, dialogService, toaster,
                                     $log, $route, uiGridConstants, orderRowFactory, ngDialog, $rootScope, authFactory,
                                     sixGridPaginationConstants) {

    var currentCustomer = authFactory.getCurrentCustomer();

    $scope.params = {
      pageNumber: 1,
      pageSize: 100,
      totalItems: 0,
      filters: {}
    };

    $scope.orderRows = {list: [], totalResults: 0};
    $scope.autoResizeParams = {enabled: true, minHeight: 200, marginTop: 260, filterRows: 2};
    $scope.viewGridOptions = {
      enableFiltering: true,
      enableOrdering: true
    };

    function initGridColumns() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice',
        field: 'model.code',
        width: 100,
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Cod. Edificio',
        field: 'model.edificio_id.code',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Edificio',
        field: 'model.edificio_id.description',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Cod. Servizio',
        field: 'model.servizio_id.code',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descr. Servizio',
        field: 'model.servizio_id.description',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo Servizio',
        field: 'model.tipo_servizio',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Cod. Classe',
        field: 'model.classeservizio_id.code',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descr. Classe',
        field: 'model.classeservizio_id.description',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'UM',
        field: 'model.um_id.description',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Importo annuo',
        field: 'model.importo_annuo',
        enableFiltering:true,
        cellFilter: 'currency:"€":3',
        filters:[
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Importo totale',
        field: 'model.importo_totale',
        enableFiltering:true,
        cellFilter: 'currency:"€":3',
        filters:[
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'PU',
        field: 'model.pu',
        enableFiltering:true,
        cellFilter: 'currency:"€":3',
        filters:[
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data inizio validità',
        field: 'model.data_inizio',
        enableFiltering:true,
        cellFilter: 'date:"dd/MM/yyyy"',
        filters:[
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data fine validità',
        field: 'model.data_fine',
        enableFiltering:true,
        cellFilter: 'date:"dd/MM/yyyy"',
        filters:[
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Adeg. ISTAT',
        field: 'model.istat_alteration',
        enableFiltering:true,
        cellFilter: 'currency:"%":1',
        filters:[
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo Rif.',
        field: 'model.tipo_riga',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
    }

    $scope.backToList = function(){
        $location.path('order');
    };

    $scope.getSourceAcquisition = function(){
        acquisitionWizardFactory.getWizardByUUID({id: $routeParams.id}).$promise.then(function(data){
            if(!angular.isDefined(data.model)){
                dialogService.alert('Acquisizione di codice ' + $routeParams.id + ' non trovata', 4000);
            }
            else{
                $scope.wizard = data;
                $scope.getOrder();
            }
        });
    };

    $scope.getOrder = function () {
      var payload = {
        page: $scope.params.pageNumber,
        page_size: $scope.params.pageSize,
        show_revision: false
      };
      $scope.params.filters['acquisition_uuid'] = $scope.wizard.UUID;
      $scope.params.filters['customer'] = $scope.wizard.model.client_id.UUID;
      orderRowFactory.search(payload, $scope.params.filters)
          .$promise.then(function(data) {
              $scope.orderRows.totalResults = data.totalResults;
              $scope.orderRows.list = data.list;

              if(!$scope.orderRows.list || $scope.orderRows.list.length == 0) {
                dialogService.dialog('ATTENZIONE', 'Nessun ordine per il cliente ' + currentCustomer.description, 'warning', -1);//, discreet, bodyTextAlign);
              }
      });
    };

    $scope.bulkDelete = function () {
      dialogService.confirmDialog('Eliminare l\'ordine?',
        function () {
          var payload = {
            show_revision: true
          };
          $scope.params.filters['acquisition_uuid'] = $scope.wizard.UUID;
          $scope.params.filters['customer'] = $scope.wizard.model.client_id.UUID;
          orderRowFactory.bulkDelete(payload, $scope.params.filters).$promise.then(function (data) {
            $scope.getOrder();
          });
        }
      );
    };


    $scope.applyIstat = function(date, percentage) {
      // var istatConfig = { date: new Date(2016, 1, 1), percentage: 0.5 };
      var istatConfig = {
        date: date,
        percentage: parseFloat(percentage),
        filters: $scope.params.filters
      };
      orderRowFactory.applyIstat({id: $scope.wizard.UUID}, istatConfig).$promise.then(function(resp) {
        $log.log(resp);
        $scope.getOrder();
      });
    };

    $scope.dateOptions = {
        formatYear: 'yyyy',
        minDate: new Date(),
        opened: false
    };

    $scope.showIstatDialog = function() {
      var dialogScope = $rootScope.$new();
      dialogScope.fn = $scope.applyIstat;
      dialogScope.datePicker = {from: new Date()};
      ngDialog.open({
        name: 'loadingDialog',
        closeByDocument: true,
        showClose: true,
        template: '' +
        '<div class="modal-body ng-scope">' +
          '<div class="row">' +
            '<div class="col-sm-12">' +
              '<h3 class="m-t-none m-b font-thin">Adeguamento ISTAT</h3>' +
              '<form role="form" class="ng-pristine ng-valid">' +
                '<div class="form-group">' +
                  '<label>Data</label>' +
                  '<p class="input-group">' +
                    '<input type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="datePicker.from" is-open="dateOptions.opened" datepicker-options="dateOptions" ng-required="true" close-text="Chiudi" clear-text="Cancella" current-text="Oggi"/>' +
                    '<span class="input-group-btn">' +
                      '<button type="button" class="btn btn-default" ng-click="dateOptions.opened=!dateOptions.opened"><i class="glyphicon glyphicon-calendar"></i></button>' +
                    '</span>' +
                  '</p>' +
                '</div>' +
                '<div class="form-group">' +
                  '<label>Percentuale adeguamento</label>' +
                  '<div class="input-group">' +
                    '<input type="text" class="form-control" placeholder="Percentuale di adeguamento" ng-model="percentage">' +
                    '<span class="input-group-addon" id="basic-addon1">%</span>' +
                '</div>' +
                '<button class="btn btn-sm btn-success pull-right text-uc m-t-xs" ng-click="fn(datePicker.from, percentage); closeThisDialog();"><i class="fa fa-check"></i>Applica</button>' +
              '</form>' +
            '</div>' +
          '</div>' +
        '</div>',
        plain: true,
        className: 'ngdialog-theme-default',
        width: '60%',
        scope: dialogScope
      });
    };

    // ***** EXPORT ***** //

    var currentContract = authFactory.getAuthData().info.commissions.current;

    $scope.export = function() {
      sixExportLib.exportXLSXVisibleRowsGrid($scope.params.gridApi, currentContract.code + '_order_' + $scope.wizard.model.client_id.code);
    };

    //___main__
    if(!angular.isDefined($routeParams.id)){
        $scope.backToList();
    }
    else{
        initGridColumns();
        // $scope.getSourceAcquisition();
    }

  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:AcquisitionWizardListCtrl
 * @description
 * # AcquisitionWizardListCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/order', {
        templateUrl: 'consip/order/order_list.html',
        controller: 'OrderListCtrl'
      })
      .when('/order/page/:number', {
        templateUrl: 'consip/order/order_list.html',
        controller: 'OrderListCtrl'
      })
  })
  .controller('OrderListCtrl', function ($scope, acquisitionWizardFactory, $log, $routeParams, $location, authFactory, dialogService, uiGridConstants) {

    var currentCustomer = authFactory.getCurrentCustomer();

    $scope.wizardList = {};
    $scope.params = { queryParam: '', filterQuery: {} };
    $scope.viewGridOptions = {};

    var DEFAULT_SORT_FIELD = 'model.code';
    function defaultSort() {
        var result = ($scope.sortFields)?$scope.sortFields:DEFAULT_SORT_FIELD;
        return result;
    }

    var DEFAULT_SORT_ORDER= 'asc';
    function defaultSortOrder() {
        var result = ($scope.sortOrder)?$scope.sortOrder:DEFAULT_SORT_ORDER;
        return result;
    }

    var getPage = function() {
      $scope.viewGridOptions.totalItems = $scope.wizardList.totalResults;
      var firstRow = ($scope.params.pageNumber - 1) * $scope.params.pageSize;
      var lastRow = (firstRow + $scope.params.pageSize);
      $scope.viewGridOptions.data = $scope.viewGridOptions.data.slice(firstRow, lastRow);
    };

    function initGridColumns() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 34,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents" style="text-align: center">' +
            '<a ng-href="#/order/detail/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' +
              '<span class="fa fa-search"></span>' +
            '</a>' +
          '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice',
        field: 'model.code',
        width: 60,
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descrizione',
        field: 'model.description',
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
    }

    $scope.getData = function () {
        var payload = {
          query: $scope.params.queryParam,
          page: $scope.params.pageNumber,
          page_size: $scope.params.pageSize,
          sort_fields: defaultSort(),
          sort_order: defaultSortOrder(),
          show_revision: false
        };
        $scope.params.filterQuery['model.current_step.status'] = sixFiltersLib.exact('model.current_step.status', 'terminated');
        acquisitionWizardFactory.getWizardsListFiltered(payload, $scope.params.filterQuery)
            .$promise.then(function(data) {
                $scope.wizardList.totalResults = data.totalResults;
                $scope.wizardList.list = data.list;
                getPage();
        });
    };

    function isCustomerMissing() {
      var isMissing = $scope.app.profileCustomer && angular.isUndefined(currentCustomer);
      // var isMissing = angular.isUndefined($scope.currentCustomer);
      return isMissing;
    }

    function redirectToCustomerOrder() {
      var payload = {
        query: $scope.params.queryParam,
        page: $scope.params.pageNumber,
        page_size: $scope.params.pageSize,
        sort_fields: defaultSort(),
        sort_order: defaultSortOrder(),
        show_revision: false
      };
      var filters = {
        'model.current_step.status': sixFiltersLib.exact('model.current_step.status', 'terminated')
      };
      acquisitionWizardFactory.getWizardsListFiltered(payload, filters)
        .$promise.then(function(data) {
          if(data && data.list && data.list.length > 0) {
            $location.path('order/detail/'+data.list[0].UUID);
          } else {
            dialogService.dialog('ATTENZIONE', 'Nessun ordine per il cliente ' + currentCustomer.description, 'warning', -1);//, discreet, bodyTextAlign);
          }
      });
    }

    //__main__
    if(isCustomerMissing()) { // visualizzo la lista degli ordini
      initGridColumns();
    } else {
      redirectToCustomerOrder();  // vado diretto sull'ordine del cliente
    }

  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:OrderCtrl
 * @description
 * # OrderCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/consippricelist/detail', {
        templateUrl: 'consip/pricelists/pricelist_detail.html',
        controller: 'ConsipPricelistCtrl'
      })
  })
  .controller('ConsipPricelistCtrl', function ($scope, $location, $routeParams, errorService, dialogService, toaster, $log, $route,
                                               uiGridConstants, pricelistRowFactory, authFactory, recordFactory, loadingBarService) {

    var currentContract = authFactory.getAuthData().info.commissions.current;

    $scope.isAlreadyPresent = false;
    $scope.params = { queryParam: '', filterQuery: {} };
    $scope.pricelistRows = {};
    $scope.viewGridOptions = {
      enableSorting: true,
      enableFiltering: true,
      paginationPageSizes: [10, 20, 50, 100, 250, 500, 1000],
      paginationPageSize: 20,
      data: [],
      onRegisterApi: function(gridApi){
        $scope.gridApi = gridApi;
      }
    };

    function initGridColumns() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice',
        field: 'model.service_id.code',
        width: 100,
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Servizio',
        field: 'model.service_id.description',
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Cod. classe',
        field: 'model.classeservizio_id.code',
        width: 100,
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descrizione classe',
        field: 'model.classeservizio_id.description',
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Valore',
        field: 'model.value',
        width: 100,
        cellFilter: 'number:3',
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Unità di misura',
        field: 'model.um_id.description',
        width: 200,
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
    }

    $scope.backToList = function(){
        $location.path('consippricelist');
    };

    $scope.getPricelist = function () {
      $scope.viewGridOptions.data = [];
      var payload = {
        page: 1,
        page_size: 10000,
        show_revision: false
      };
      $scope.params.filterQuery['contract'] = currentContract;  // = commission
      pricelistRowFactory.enriched(payload, $scope.params.filterQuery).$promise.then(function(data) {
        if(errorService.handleError(data)) {
          if(data.hasErrors || data.hasWarnings) {
            dialogService.serviceResponse('Esito', data, false);
          }
          if(data.result.totalResults > 0) {
            $scope.viewGridOptions.data = data.result.list;
            $scope.isAlreadyPresent = true;
          } else {
            $scope.viewGridOptions.data = [];
            $scope.isAlreadyPresent = false;
          }
        }
        loadingBarService.stop();
      });
    };

    $scope.delete = function () {
      var payload = {
        page: 1,
        page_size: 10000,
        show_revision: false
      };
      $scope.params.filterQuery['contract'] = currentContract;  // = commission
      pricelistRowFactory.delete(payload, $scope.params.filterQuery).$promise.then(function(data) {
        if(errorService.handleError(data)) {
          if(data.hasErrors || data.hasWarnings) {
            dialogService.serviceResponse('Esito', data, false);
          }
          $scope.getPricelist();
        }
      });
    };

    // Quando cambio la dimensione della pagina della grid ridimensiono anche la grid stessa
    $scope.$watch(function() {return $scope.viewGridOptions.paginationPageSize;}, function(newVal, oldVal) {
      if(newVal) {
        resizeGrid();
      }
    });

    // Quando ridimensiono la finestra ridimensiono anche la grid
    $(window).resize(function() {
      resizeGrid();
    });

    function resizeGrid() {
      var newHeight = $scope.viewGridOptions.paginationPageSize * 30 + 110;
      var windowHeight = $(window).height() - 250;
      windowHeight = Math.max(windowHeight, 200); // minimo 200px
      newHeight = Math.min(windowHeight, newHeight);  // massima altezza: altezza visualizzabile dalla finestra alle dimensioni correnti
      angular.element(document.getElementsByClassName('grid')[0]).css('height', newHeight + 'px');
    }



    // ***** IMPORT ***** //

    var messages = [];
    $scope.importingError = false;

    //dati caricati da xls
    $scope.$watch(function( ) {
        return $scope.viewGridOptions.xlsData;
      },
      function( newValue, oldValue ) {
        if (newValue && newValue.length>0){
          messages = [];
          $scope.importingError = false;
          $scope.checkData();
          // ottenuti i riferimenti ai dati, rimpiazzo le vecchie colonne per visualizzare i riferimenti sottoforma di codice invece che oggetti stile lookup
          $scope.viewGridOptions.columnDefs.splice(0, 2,
            {
              displayName: 'Codice',
              field: 'Codice.code',
              width: 150,
              enableFiltering:true,
              filters:[{
                condition: uiGridConstants.filter.CONTAINS,
                placeholder: ''
              }]
            }, {
              displayName: 'Voce',
              field: 'Codice.description',
              enableFiltering:true,
              filters:[{
                condition: uiGridConstants.filter.CONTAINS,
                placeholder: ''
              }]
            }
          );

          $scope.viewGridOptions.columnDefs.splice(3, 1,
            {
              displayName: 'Unità di misura',
              field: 'Unità di misura.description',
              width: 150,
              enableFiltering:true,
              filters:[{
                condition: uiGridConstants.filter.CONTAINS,
                placeholder: ''
              }]
            }
          );
        }
      }
    );

    $scope.checkData = function() {
      var mapToResolve = {};
      $scope.viewGridOptions.xlsData.forEach(function(row) {
        parseTypes(row);
        $scope.viewGridOptions.data = $scope.viewGridOptions.data.concat( row );
        addToMapToResolve(mapToResolve, row);
      });
      checkBulkDependencies(mapToResolve);
    };

    function parseTypes(row) {
      row['Valore'] = parseFloat(row['Valore']);
      return row;
    }

    function addToMapToResolve(mapToResolve, row) {
      var servicesMap = mapToResolve['servizio'] || {};
      servicesMap[row['Codice']] = '';
      mapToResolve['servizio'] = servicesMap;

      var umMap = mapToResolve['um'] || {};
      umMap[row['Unità di misura']] = '';
      mapToResolve['um'] = umMap;

      return mapToResolve;
    }

    function checkBulkDependencies(codeMap) {
      recordFactory('type').bulkResolve(codeMap).$promise.then(function(result) {
        updateDataCheckStatus(result);
        if(messages.length > 0) {
          var messagesToDisplay = sixServiceMessageLib.emulateServiceResponse(messages);
          dialogService.serviceResponse('Risposta', messagesToDisplay, true);
        }
      });
    }

    function updateDataCheckStatus(codeMap) {
      $scope.viewGridOptions.data.forEach(function(row) {
        updateRowCheckStatus(row, codeMap);
      });
    }

    function updateRowCheckStatus(row, codeMap) {
      var code = row['Codice'];
      var servicesMap = codeMap['servizio'];
      var resolved = servicesMap[code];
      if(angular.isDefined(resolved) && resolved != null) {
        row['Codice'] = sixObjectLib.recordToHisRef(resolved);
        // messages.push(sixServiceMessageLib.emulateLogServiceMessage('Servizio \'' + code + '\' trovato', true, false, false));
      } else {
        messages.push(sixServiceMessageLib.emulateLogServiceMessage('Servizio \'' + code + '\' non trovato!!', false, false, true));
        $scope.importingError = true;
      }

      var um = row['Unità di misura'];
      var umMap = codeMap['um'];
      resolved = umMap[um];
      if(angular.isDefined(resolved) && resolved != null) {
        row['Unità di misura'] = sixObjectLib.recordToHisRef(resolved);
        // messages.push(sixServiceMessageLib.emulateLogServiceMessage('Unità di misura \'' + um + '\' trovata', true, false, false));
      } else {
        messages.push(sixServiceMessageLib.emulateLogServiceMessage('Unità di misura \'' + um + '\' non trovata!!', false, false, true));
        $scope.importingError = true;
      }
    }

    $scope.import = function() {
      if($scope.viewGridOptions.data && $scope.viewGridOptions.data.length > 0) {
        loadingBarService.start('Importazione...');
        epurateRows($scope.viewGridOptions.data);
        pricelistRowFactory.bulkSave($scope.viewGridOptions.data).$promise.then(function (response) {
          initGridColumns();
          // dialogService.serviceResponse('Importazione', response);
          $scope.getPricelist();
        });
      }
    };

    function epurateRows(rows) {
      rows.forEach(function(r) {
        delete r['Voce'];

        r['um_id'] = r['Unità di misura'];
        delete r['Unità di misura'];

        r['service_id'] = r['Codice'];
        delete r['Codice'];

        r['value'] = r['Valore'];
        delete r['Valore'];
      });
      return rows;
    }

    // ***** EXPORT ***** //

    $scope.export = function() {
      sixExportLib.exportXLSXVisibleRowsGrid($scope.gridApi, 'pricelist_' + currentContract.code);
    };


    //___main__
    initGridColumns();
    $scope.getPricelist();

  });

'use strict';

/**
 * @ngdoc function
 * @name emma.consip.controller:SalCtrl
 * @description
 * # SalCtrl
 * Controller of the emma.consip
 */
angular.module('emma.consip')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/sal', {
        templateUrl: 'consip/sal/sal_list.html',
        controller: 'SalCtrl'
      })
      .when('/sal/:sal_code', {
        templateUrl: 'consip/sal/sal_detail.html',
        controller: 'SalCtrl'
      })
  })
  .controller('SalCtrl', function ($scope, $location, $routeParams, acquisitionWizardFactory, dialogService, toaster,
                                   $log, $route, uiGridConstants, orderRowFactory, ngDialog, $rootScope, authFactory,
                                   salFactory, salConfigurationFactory, errorService, sixGridPaginationConstants,
                                   $filter, $http, APP_URL, ALFRESCO_URL, SaveAs, salAttachmentsFactory, FileUploader,
                                   alfrescoFactory, notificationFactory, userFactory) {

    var currentContract = authFactory.getAuthData().info.commissions.current;
    $scope.currentCustomer = authFactory.getCurrentCustomer();

    $scope.datePicker = {
      from: new Date(),
      to: new Date()
    };

    $scope.dateOptionsFrom = {
      formatYear: 'yyyy',
      startingDay: 1,
      datepickerMode: 'day',
      minMode: 'day',
      maxMode: 'year'
    };

    $scope.dateOptionsTo = {
      formatYear: 'yyyy',
      startingDay: 1,
      datepickerMode: 'day',
      minMode: 'day',
      maxMode: 'year',
      minDate: $scope.datePicker.from
    };

    $scope.periodTypeList = [
      { key: 'monthly', description: 'Mensile' },
      { key: 'twomonthly', description: 'Bimestrale' },
      { key: 'custom', description: 'Personalizzato' }
    ];

    $scope.serviceTypeList = [
      { key: 'canone', description: 'Canone' },
      { key: 'extra canone', description: 'Extra-canone' }
    ];

    $scope.rowTypeList = [
      { key: 'opf', description: 'OPF' },
      { key: 'aa', description: 'Atti Aggiuntivi' }
    ];

    $scope.dateFormat = 'dd/MM/yyyy';
    $scope.periodType = { selected: $scope.periodTypeList[0] };
    $scope.serviceType = { selected: $scope.serviceTypeList[2] };
    $scope.rowType = { selected: undefined };

    $scope.services = {selected: []};
    $scope.assets = {selected: []};
    $scope.serviceGroups = {selected: []};
    $scope.aggregations = {selected: []};

    $scope.aggregationFields = [
      { key: 'model.row_type', description: 'Tipo riga' },
      { key: 'model.asset_id.code', description: 'Edificio' },
      { key: 'model.serviceclass_id.code', description: 'Classe servizio' },
      { key: 'model.service_id.code', description: 'Servizio' }
    ];

    $scope.salRows = {list: [], totalResults: 0};
    $scope.params = {
      pageNumber: 1,
      pageSize: 100,
      totalItems: 0,
      filters: {}
    };
    $scope.autoResizeParams = {enabled: true, minHeight: 200, marginTop: 260, filterRows: 2};

    $log.log(authFactory.getAuthData());

    $scope.viewGridOptions = {
      enableFiltering: true,
      enableOrdering: true,
      showGridFooter: true,
      showColumnFooter: true
    };

    $scope.result;

    $scope.currentSalCode = null;

    $scope.headerSalInformation = {
      code: null,
      description: null
    };

    $scope.listSalRows = {list: [], totalResults: 0};
    $scope.gridAppCallbacks = {};

    $scope.viewGridListSalOptions = {
      enableFiltering: true,
      enableOrdering: true,
      showGridFooter: true,
      showColumnFooter: true,
      enableHorizontalScrollbar: 1
    };

    $scope.configuration = {
      model: {}
    };

    $scope.configureExport = false;

    function initGridColumns() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo riga',
        field: 'model.row_type',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Cod. Edificio',
        field: 'model.asset_id.code',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Edificio',
        field: 'model.asset_id.description',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Cod. Servizio',
        field: 'model.service_id.code',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descr. Servizio',
        field: 'model.service_id.description',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Cod. Classe',
        field: 'model.serviceclass_id.code',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descr. Classe',
        field: 'model.serviceclass_id.description',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo servizio',
        field: 'model.service_type',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data inizio periodo',
        field: 'model.start_date',
        enableFiltering:true,
        cellFilter: 'date:"dd/MM/yyyy"',
        filters:[
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data fine periodo',
        field: 'model.end_date',
        enableFiltering:true,
        cellFilter: 'date:"dd/MM/yyyy"',
        filters:[
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Quantità',
        field: 'model.qty',
        enableFiltering:true,
        cellFilter: 'number:1',
        filters:[
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'PU',
        field: 'model.pu',
        enableFiltering:true,
        cellFilter: 'currency:"€":3',
        filters:[
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'UM',
        field: 'model.um_id.description',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Importo',
        field: 'model.amount',
        enableFiltering:true,
        cellFilter: 'currency:"€":3',
        aggregationType: uiGridConstants.aggregationTypes.sum,
        filters:[
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Annuo',
        field: 'model.yearly_amount',
        enableFiltering:true,
        cellFilter: 'currency:"€":3',
        aggregationType: uiGridConstants.aggregationTypes.sum,
        filters:[
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Totale',
        field: 'model.total_amount',
        enableFiltering:true,
        cellFilter: 'currency:"€":3',
        aggregationType: uiGridConstants.aggregationTypes.sum,
        filters:[
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Erogato',
        field: 'model.provided_amount',
        enableFiltering:true,
        cellFilter: 'currency:"€":3',
        aggregationType: uiGridConstants.aggregationTypes.sum,
        filters:[
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Residuo',
        field: 'model.residual_amount',
        enableFiltering:true,
        cellFilter: 'currency:"€":3',
        aggregationType: uiGridConstants.aggregationTypes.sum,
        filters:[
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
    }

    function initGridListSalColumns() {
      $scope.viewGridListSalOptions.columnDefs = [];
      $scope.viewGridListSalOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 34,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
        '<div class="ui-grid-cell-contents" style="text-align: center">' +
        '<a ng-href="#/sal/{{row.entity.sal_code}}" class="btn btn-xs btn-primary">' +
        '<span class="fa fa-search"></span>' +
        '</a>' +
        '</div>'
      });
      $scope.viewGridListSalOptions.columnDefs.push({
        displayName: 'Codice SAL',
        field: 'sal_code',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridListSalOptions.columnDefs.push({
        displayName: 'Descrizione SAL',
        field: 'sal_description',
        enableFiltering:true,
        width: 500,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridListSalOptions.columnDefs.push({
        displayName: 'Data inizio',
        field: 'start_date',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        enableFiltering:true,
        width: 300,
        filters: [
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridListSalOptions.columnDefs.push({
        displayName: 'Data fine',
        field: 'end_date',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        enableFiltering:true,
        width: 300,
        filters: [
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
    }

    $scope.create = function() {
      var payload = {
        from: $scope.datePicker.from,
        to: $scope.datePicker.to,
        sal_code: $scope.currentSalCode
      };
      if($scope.services.selected.length > 0) {
        var services = $scope.services.selected.map(function(obj) { return obj.code; });
        payload.services = services;
      }
      if($scope.assets.selected.length > 0) {
        var assets = $scope.assets.selected.map(function(obj) { return obj.code; });
        payload.assets = assets;
      }
      if($scope.serviceGroups.selected.length > 0) {
        var serviceGroups = $scope.serviceGroups.selected.map(function(obj) { return obj.code; });
        payload.service_groups = serviceGroups;
      }
      salFactory.generate(payload).$promise.then(function(response) {
        if(errorService.handleError(response) && !response.hasErrors) {
          // creazione SAL andata a buon fine, ora posso salvare la configurazione
          toaster.pop('success', 'Generazione eseguita', 'Generazione SAL eseguita correttamente');
          $scope.jasperReport('sal', 'pdf');
          //$scope.goToSalList();
        } else {
          if(response.hasErrors) {  // ho una risposta strutturata con messaggi di errore
            dialogService.serviceResponse('Esito SAL', response, true);
          } else {  // errore generico
            toaster.pop('error', 'Errore generazione', 'Generazione SAL fallita');
          }
        }
      });
    };

    $scope.getSal = function() {
      var payload = {
        page: $scope.params.pageNumber,
        page_size: $scope.params.pageSize
      };
      $scope.params.filters['model.sal_code'] = sixFiltersLib.exact('model.sal_code',$scope.currentSalCode);
      salFactory.search(payload, $scope.params.filters).$promise.then(function(response) {
        if(errorService.handleError(response)) {
          $scope.salRows.list = response.list || [];
          $scope.salRows.totalResults = response.totalResults;
          if($scope.salRows.list.length > 0){
            $scope.periodType = { selected: $scope.periodTypeList[2] }; // custom
            $scope.datePicker.from = new Date($scope.salRows.list[0].model.start_date);
            // $scope.datePicker.to = new Date($scope.salRows.list[0].model.end_date);
          }
          // fixDates();
        } else {
          toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
        }
      });
    };

    $scope.getAllSal = function() {
      var payload = {
        page: 1,
        page_size: 10000
      };
      var filters = {'model.sal_code': sixFiltersLib.exact('model.sal_code',$scope.currentSalCode)};
      return salFactory.search(payload, filters).$promise;
    };

    $scope.deleteSal = function() {
      dialogService.confirmDialog('Eliminare il SAL?', function() {
        salFactory.bulkDelete($scope.params.filters).$promise.then(function () {
          $scope.goToSalList();
        });
      });
    };

    $scope.getListSal = function() {
      var payload = {
        page: $scope.params.pageNumber,
        page_size: $scope.params.pageSize
      };
      salFactory.listSal(payload, $scope.params.filters).$promise.then(function(response) {
        if(errorService.handleError(response)) {
          $scope.listSalRows.list = response.list || [];
          $scope.listSalRows.totalResults = response.totalResults;
        } else {
          toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
        }
      });
    };


    // svuoto la variabile contenitore della configurazione...
    function getEmptySalConfiguration () {
      var configuration = {
        model: {
          code: '',
          aggregations: [],
          services: [],
          serviceGroups: [],
          assets: [],
          serviceType: undefined
        }
      };
      return configuration;
    }

     function getSalConfiguration () {
       $scope.params.filters['commission'] = currentContract;
       $scope.params.filters['customer'] = $scope.currentCustomer;
       salConfigurationFactory.search($scope.params.filters).$promise.then(function (response) {
         if(errorService.handleError(response)) {
           if(response.list[0]){
             // carico la configurazione...
             $scope.configuration = response.list[0];
             // e setto anche le lookup...
             if($scope.configuration.model.services){
               $scope.services.selected = $scope.configuration.model.services;
             }
             if($scope.configuration.model.assets){
               $scope.assets.selected = $scope.configuration.model.assets;
             }
             if($scope.configuration.model.serviceGroups){
               $scope.serviceGroups.selected = $scope.configuration.model.serviceGroups;
             }
             if($scope.configuration.model.aggregations){
               $scope.aggregations.selected = $scope.configuration.model.aggregations;
             }
           } else {
             toaster.pop('info', 'Caricamento configurazione', 'Nessuna configurazione scaricata per la commessa ed il cliente selezionati');
             $scope.configuration = getEmptySalConfiguration();
           }
         } else {
           toaster.pop('info', 'Caricamento configurazione', 'Nessuna configurazione scaricata per la commessa ed il cliente selezionati');
           $scope.configuration = getEmptySalConfiguration();
         }
       });
     }

      $scope.jsonReport = function() {
        var payload = {
          from: $scope.datePicker.from,
          to: $scope.datePicker.to,
          sal_code: $scope.currentSalCode
        };
        if($scope.services.selected.length > 0) {
          var services = $scope.services.selected.map(function(obj) { return obj.code; });
          payload.services = services;
        }
        if($scope.assets.selected.length > 0) {
          var assets = $scope.assets.selected.map(function(obj) { return obj.code; });
          payload.assets = assets;
        }
        if($scope.serviceGroups.selected.length > 0) {
          var serviceGroups = $scope.serviceGroups.selected.map(function(obj) { return obj.code; });
          payload.service_groups = serviceGroups;
        }
        if($scope.aggregations.selected.length > 0) {
          var aggregationsPar = $scope.aggregations.selected.map(function(obj) { return obj.key; });
          payload.aggregations = aggregationsPar;
        }
        salFactory.report(payload).$promise.then(function(response) {
          if(errorService.handleError(response) && !response.hasErrors) {
            toaster.pop('success', 'Esportazione eseguita', 'Esportazione SAL eseguita correttamente');
            $scope.result = response.list;
          } else {
            if(response.hasErrors) {  // ho una risposta strutturata con messaggi di errore
              dialogService.serviceResponse('Esito esportazione SAL', response, true);
            } else {  // errore generico
              toaster.pop('error', 'Errore esportazione', 'Esportazione SAL fallita');
            }
          }
        });
      };


     $scope.jasperReport = function(report, extension) {
       var REPORT_URL = 'reports/EMMA/Consip/';
       report = report || 'sal';
       extension = extension || 'pdf';
       var query = '&commission=' + currentContract.code +
         '&customer='  + $scope.currentCustomer.code +
         '&salcode='   + $scope.currentSalCode +
         '&from='      + $filter('date')($scope.datePicker.from, 'yyyy-MM-dd') +
         '&to='        + $filter('date')($scope.datePicker.to, 'yyyy-MM-dd');
       if($scope.assets.selected) {
         var assets = $scope.assets.selected.map(function (obj) { return obj.code; });
         query += '&assets=' + assets.join(';');
       }
       if($scope.services.selected) {
         var services = $scope.services.selected.map(function (obj) { return obj.code; });
         query += '&services=' + services.join(';');
       }
       if($scope.serviceGroups.selected) {
         var serviceGroups = $scope.serviceGroups.selected.map(function (obj) { return obj.code; });
         query += '&servicegroups=' + serviceGroups.join(';');
       }
       if($scope.aggregations.selected) {
         var aggregations = $scope.aggregations.selected.map(function (obj) { return obj.key; });
         query += '&aggregations=' + aggregations.join(';');
       }


       var reportNameToSave = 'sal_' + currentContract.code + '_' + $scope.currentCustomer.code + '.' + extension;
       var reportPath = REPORT_URL + report + '.' + extension;

       $http.post(APP_URL + '/rest/report/generate',
         {
           path: reportPath,
           query: query
         },
         {
           responseType: 'arraybuffer'
         })
         .success(function (data, status, headers, config) {
           if(data) {
             var options;
             if (extension == 'pdf') {
               options = {type: 'application/pdf'};
             } else if (extension == 'xls') {
               options = {type: 'application/vnd.ms-excel;'};
             }
             SaveAs.download(data, reportNameToSave, options);
           } else {
             toaster.pop('error', "Errore", 'Errore generazione report');
           }
         })
         .error(function (data, status, headers, config) {
           toaster.pop('error', "Errore", 'Errore generazione report');
         });
     };

    function getSalHeadInformation() {
      salFactory.head({id: $scope.currentSalCode}).$promise.then(function(response) {
        if(response.result){
          if(response.result.code){
            $scope.headerSalInformation.code = response.result.code;
          }
          if(response.result.description){
            $scope.headerSalInformation.description = response.result.description;
          }
        }
      });
    }


    // ***** _main ***** //
    if($routeParams.sal_code){
      $scope.currentSalCode = $routeParams.sal_code;

      $scope.currentSalRef = setObjectSixSendMail();
      initGridColumns();
      getSalConfiguration();
      getSalAttachment();
      getSalHeadInformation();
    } else {
      $scope.currentSalCode = null;
      initGridListSalColumns();
    }


    // ***** redirects ***** //
    $scope.goToNewSal = function() {
      $location.path('salnew');
    };

    $scope.goToSalList = function() {
      $location.path('sal');
    };


    // se manca il cliente...
    $scope.isCustomerMissing = function(){
      var isMissing = $scope.app.profileCustomer && angular.isUndefined($scope.currentCustomer);
      // var isMissing = angular.isUndefined($scope.currentCustomer);
      return isMissing;
    };

    /* ***************** */
    /* **** WATCHES **** */
    /* ***************** */

    $scope.$watch('datePicker.from', function(newVal, oldVal) {
      if(newVal && oldVal && newVal.getTime() !== oldVal.getTime()) {
        adjustDatePicker();
      }
      if($scope.form && $scope.form.datePickerTo) {
        $scope.form.datePickerTo.$validate();
      }
    });

    $scope.$watch('datePicker.to', function(newVal, oldVal) {
      if($scope.form && $scope.form.datePickerFrom) {
        $scope.form.datePickerFrom.$validate();
      }
    });

    $scope.$watchCollection('periodType', function(newVal, oldVal) {
      if($scope.datePicker.from) {
        switch ($scope.periodType.selected.key) {
          case 'monthly':
          case 'twomonthly':
            $scope.dateFormat = 'MMMM yyyy';
            $scope.dateOptionsFrom.minMode = 'month';
            $scope.dateOptionsFrom.datepickerMode = 'month';
            $scope.dateOptionsTo.minMode = 'month';
            $scope.dateOptionsTo.datepickerMode = 'month';
            break;
          default:
            $scope.dateFormat = 'dd/MM/yyyy';
            $scope.dateOptionsFrom.minMode = 'day';
            $scope.dateOptionsFrom.datepickerMode = 'day';
            $scope.dateOptionsTo.minMode = 'day';
            $scope.dateOptionsTo.datepickerMode = 'day';
            $scope.dateOptionsTo.minDate = $scope.datePicker.from;
            break;
        }
        adjustDatePicker();
      }
    });

    function adjustDatePicker() {
      if($scope.datePicker.from) {
        switch ($scope.periodType.selected.key) {
          case 'monthly':
            $scope.datePicker.from = new Date($scope.datePicker.from.getFullYear(), $scope.datePicker.from.getMonth(), 1);
            $scope.datePicker.to = new Date($scope.datePicker.from.getFullYear(), $scope.datePicker.from.getMonth() + 1, 0);
            break;
          case 'twomonthly':
            $scope.datePicker.from = new Date($scope.datePicker.from.getFullYear(), $scope.datePicker.from.getMonth(), 1);
            $scope.datePicker.to = new Date($scope.datePicker.from.getFullYear(), $scope.datePicker.from.getMonth() + 2, 0);
            break;
          default:
            break;
        }
        $scope.dateOptionsTo.minDate = $scope.datePicker.from;
      }
    }


    /** ***********************************
     * Export
     * ***********************************/

    $scope.export = function() {
      sixExportLib.exportXLSXVisibleRowsGrid($scope.params.gridApi, currentContract.code + '_SAL_' + $scope.currentCustomer.code);
    };


    /** ***********************************
     * Gestione documentale
     * ***********************************/

    var DESTINATION = "/Sites/consip/" + authFactory.getAuthData().info.commissions.current.code;
    $scope.DOWNLOAD_URL = ALFRESCO_URL + "/api/alfresco/";
    $scope.attachmentsListDocument = [];
    $scope.upload={ show:false,
      errors: [],
      warnings: [],
      pupupEmissionOpened: false,
      pupupApprovalOpened: false,
      pupupRefusalOpened: false
    };
    var uploader = $scope.uploader = new FileUploader({
      url: 'six-alfresco/upload',
      formData: [
        {destination: DESTINATION}
      ]
    });

    function getSalAttachment () {
      salAttachmentsFactory.search({id: $scope.currentSalCode}).$promise.then(function (response) {
        $scope.attachmentsListDocument = [];
        if(response.list){
          response.list.forEach(function (currentItem){
            $scope.attachmentsListDocument.push(currentItem.model);
          });
        }
      });
    }

    $scope.undoUpload = function(){
      $scope.upload.show = false;
      uploader.clearQueue();
      $scope.upload.warnings.length = 0;
    };

    $scope.loadQuote = function() {
      $scope.upload.show = true;
      $scope.upload.errors.length = 0;
      $scope.upload.warnings.length = 0;
      $scope.upload.completed = false;
      uploader.clearQueue();
      angular.element('#fileUploadBtn').trigger('click');
    };

    $scope.addQuote = function() {
      angular.element('#fileUploadBtn').trigger('click');
    };

    function saveStep(caller){
      $log.warn(caller);
    }

    function printUploadError(errorMessage){
      $scope.upload.errors.push(errorMessage);
    }

    function printUploadWarning(warningMessage){
      $scope.upload.warnings.push(warningMessage);
    }

    function addUploadedFileToList(fileItem){
      var documentAttachedToSave = {
        model: {
          sal_code: $scope.currentSalCode,
          date_insertion: new Date(),
          object_id: fileItem.objectId,
          title: fileItem.file.name,
          user: authFactory.getAuthData().authId,
          destination: DESTINATION
        }
      };
      salAttachmentsFactory.save(documentAttachedToSave).$promise.then(function (response) {
        if(response.model){
          $scope.attachmentsListDocument.push(response.model);
        }
      });
    }

    /** ***********************************
     * Uploader callbacks
     * ***********************************/

    uploader.onAfterAddingFile = function(fileItem) {
      alfrescoFactory.fileExists({folder: DESTINATION, file:fileItem.file.name}).$promise.then(function(data){
        $scope.upload.warnings.length = 0;
        if(data.exists){
          printUploadWarning('Sul server esiste già un file di nome "' + fileItem.file.name + '". Rinominarlo e riprovare.');
          fileItem.remove();
        }
      });
      $scope.upload.completed = false;
      $scope.upload.started = false;
    };
    uploader.onAfterAddingAll = function(addedFileItems) {
      $scope.upload.completed = false;
      $scope.upload.started = false;
    };
    uploader.onBeforeUploadItem = function(item) {
      $scope.upload.started = true;
    };
    uploader.onSuccessItem = function(fileItem, response, status, headers) {
      if(angular.isDefined(response.ERROR)){
        printUploadError(response.ERROR);
      }
      else{
        fileItem.objectId = response.objectId;
        addUploadedFileToList(fileItem);
      }
    };
    uploader.onErrorItem = function(fileItem, response, status, headers) {
      $scope.undoUpload();
      printUploadError("Errore nel caricamento del file " + fileItem.file.name);
    };
    uploader.onCompleteAll = function() {
      $scope.upload.completed = true;
      $scope.upload.show = false;
      saveStep("uploader.onCompleteAll");
    };



    /** ***********************************
     * Messaggi e notifiche
     * ***********************************/

    $scope.loadingSixMail = true;

    $scope.currentSalRef = null;

    function setObjectSixSendMail () {
      return {
        type: 'sal',
        UUID: '',
        code: $scope.currentSalCode,
        description: ''
      };
    }

    function setBodyText(notification){
      var model = notification.model;
      if(angular.isDefined(model)){
        var bodyHtml = model.body;
        if(angular.isDefined(bodyHtml)){
          bodyHtml = "<div>" + bodyHtml + "</div>";
          var bodyText = $(bodyHtml).text();
          model.bodyAsText = bodyText;
        }
      }
    }

    $scope.getNotificationsList = function() {
      var payload = {
        page: 1,
        pageSize: 10000,
        //UUID: $scope.data.UUID,
        //index: 'six_odl',
        typeNotification: 'sal',
        list: null
      };
      notificationFactory().getListFiltered(payload).$promise.then(function(data) {
        $scope.notifications = data.list;
        if($scope.notifications) {
          for (var i = 0; i < $scope.notifications.length; i++) {
            var notification = $scope.notifications[i];
            setBodyText(notification);
            notification.color = 'b-l-warning';
            notification.href = "#/notification/" + notification.version;
          }
        }
      });
    };

    $scope.getMessage = function () {   /* creazione testo mail */
      var searchInit = {
        search: {  obj: {'username':authFactory.getAuthData().authId}  },
        init: { authId: true,  email: true }
      };
      var promiseMailUser = userFactory.getMail(searchInit).$promise;
      $scope.loadingSixMail = true;
      Promise.all([promiseMailUser]).then(function (response) {
        $scope.loadingSixMail = false;
        $scope.objMail = {
          title: 'Documento Sal',
          to: '',
          cc: formatMailCc(response[0].list[0].email),
          message: 'In allegato, il sal corrispondente'
        }
      });
    };

    function formatMailCc (UserMailSix) {
      if(UserMailSix){
        return UserMailSix;
      } else {
        return null;
      }
    }
  });

/**
 * Created by luca on 12/12/16.
 */


/**
 * @ngdoc function
 * @name emma.consip.controller:SalConfigurationCtrl
 * @description
 * # SalConfigurationCtrl
 * Controller of the emma.consip
 */
angular.module('emma.consip')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/salconfiguration', {
        templateUrl: 'consip/sal/sal_configuration_detail.html',
        controller: 'SalConfigurationCtrl'
      })
  })
  .controller('SalConfigurationCtrl', function ($scope, $location, $routeParams, acquisitionWizardFactory, dialogService, toaster,
                                   $log, $route, uiGridConstants, orderRowFactory, ngDialog, $rootScope, authFactory,
                                   salFactory, salConfigurationFactory, errorService) {

    $scope.currentContract = authFactory.getAuthData().info.commissions.current;
    $scope.currentCustomer = authFactory.getCurrentCustomer();

    $scope.params = { filters: {}};

    $scope.serviceTypeList = [
      { key: 'canone', description: 'Canone' },
      { key: 'extra canone', description: 'Extra-canone' }
    ];

    $scope.aggregationFields = [
      { key: 'model.row_type', description: 'Tipo riga' },
      { key: 'model.asset_id.code', description: 'Edificio' },
      { key: 'model.serviceclass_id.code', description: 'Classe servizio' },
      { key: 'model.service_id.code', description: 'Servizio' }
    ];

    $scope.configuration = {
      model: {
        code: '',
        aggregations: [],
        services: [],
        serviceGroups: [],
        assets: [],
        serviceType: undefined
      }
    };


    // salvataggio configurazione...
    $scope.saveSalConfiguration = function () {
      checkCodeSalConfiguration();
      if(!$scope.configuration.version) {
        salConfigurationFactory.create($scope.configuration).$promise.then(function(response) {
          if(errorService.handleError(response) && !response.hasErrors) {   // contiene la configurazione salvata: console.log(response.result);
            toaster.pop('success', 'Generazione configurazione eseguita', 'Generazione configurazione SAL eseguita correttamente');
          } else {
            toaster.pop('error', 'Errore generazione', 'Generazione configurazione SAL fallita');
          }
        });
      } else {
        salConfigurationFactory.update({id: $scope.configuration.version}, $scope.configuration).$promise.then(function (response) {
          if(errorService.handleError(response) && !response.hasErrors) {   // contiene la configurazione salvata: console.log(response.result);
            toaster.pop('success', 'Aggiornamento configurazione eseguita', 'Aggiornamento configurazione SAL eseguita correttamente');
          } else {
            toaster.pop('error', 'Errore Aggiornamento', 'Aggiornamento configurazione SAL fallita');
          }
        });
      }
    };


    // controllo se la configurazione ha un codice altrimenti lo aggiungo io...
    function checkCodeSalConfiguration () {
      if($scope.configuration.model.code == ''){
        $scope.configuration.model.code = $scope.currentContract.code + ' -- ' + $scope.currentCustomer.description;
      }
    }


    // svuoto la variabile contenitore della configurazione...
    function getEmptySalConfiguration () {
      var configuration = {
        model: {
          code: '',
          aggregations: [],
          services: [],
          serviceGroups: [],
          assets: [],
          serviceType: undefined
        }
      };
      return configuration;
    }


    // scarico la configurazione...
    function getSalConfiguration () {
      $scope.params.filters['commission'] = $scope.currentContract;
      $scope.params.filters['customer'] = $scope.currentCustomer;
      salConfigurationFactory.search($scope.params.filters).$promise.then(function (response) {
        if(errorService.handleError(response)) {
          if(response.list[0]){
            // carico solamente la prima...
            toaster.pop('success', 'Caricamento configurazione', 'Configurazione SAL scaricata correttamente');
            $scope.configuration = response.list[0];
          } else {
            $scope.configuration = getEmptySalConfiguration();
            toaster.pop('info', 'Caricamento configurazione', 'Nessuna configurazione scaricata per la commessa ed il cliente selezionati');
          }
        } else {
          $scope.configuration = getEmptySalConfiguration();
          toaster.pop('info', 'Caricamento configurazione', 'Nessuna configurazione scaricata per la commessa ed il cliente selezionati');
        }
      });
    }

    $scope.deleteSalConfiguration = function () {
      salConfigurationFactory.delete({id: $scope.configuration.version}).$promise.then(function (){
        $scope.configuration = getEmptySalConfiguration();
        toaster.pop('success', 'Eliminazione configurazione', 'Configurazione SAL eliminata correttamente');
      });
    };


    // scarico la configurazione...
    getSalConfiguration();


    // se manca la versione alla configurazione, non può essere eliminata...
    $scope.configurationIsNew = function () {
      var configurationIsNew = true;
      if(angular.isDefined($scope.configuration.version)){
        configurationIsNew = false;
      }
      return configurationIsNew;
    };

    // se manca il cliente...
    $scope.isCustomerMissing = function(){
      // var isMissing = $scope.app.profileCustomer && angular.isUndefined($scope.currentCustomer);
      var isMissing = angular.isUndefined($scope.currentCustomer);
      return isMissing;
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name emma.consip.controller:SalCtrl
 * @description
 * # SalCtrl
 * Controller of the emma.consip
 */
angular.module('emma.consip')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/salnew', {
        templateUrl: 'consip/sal/sal_new.html',
        controller: 'SalGenerationCtrl'
      })
  })
  .controller('SalGenerationCtrl', function ($scope, $location, $routeParams, acquisitionWizardFactory, dialogService, toaster,
                                   $log, $route, uiGridConstants, orderRowFactory, ngDialog, $rootScope, authFactory, recordFactory,
                                   salFactory, errorService, sixGridPaginationConstants, $filter, salConfigurationFactory, $http, APP_URL, SaveAs) {

    var currentContract = authFactory.getAuthData().info.commissions.current;
    $scope.currentCustomer = authFactory.getCurrentCustomer();
    $scope.currentCustomerInfo;

    $scope.datePicker = {
      from: new Date(),
      to:   new Date()
    };

    $scope.salCode = undefined;

    $scope.services =       { selected: [] };
    $scope.assets =         { selected: [] };
    $scope.serviceGroups =  { selected: [] };
    $scope.aggregations =   { selected: [] };

    $scope.salRows = { list: [], totalResults: 0 };

    $scope.periodTypeList = [
      { key: 'monthly', description: 'Mensile' },
      { key: 'twomonthly', description: 'Bimestrale' },
      { key: 'custom', description: 'Personalizzato' }
    ];

    $scope.serviceTypeList = [
      { key: 'canone', description: 'Canone' },
      { key: 'extra canone', description: 'Extra-canone' }
    ];

    $scope.rowTypeList = [
      { key: 'opf', description: 'OPF' },
      { key: 'aa', description: 'Atti Aggiuntivi' }
    ];

    $scope.aggregationFields = [
      { key: 'model.row_type', description: 'Tipo riga' },
      { key: 'model.asset_id.code', description: 'Edificio' },
      { key: 'model.serviceclass_id.code', description: 'Classe servizio' },
      { key: 'model.service_id.code', description: 'Servizio' }
    ];

    $scope.serviceType = { selected: $scope.serviceTypeList[2] };
    $scope.rowType = { selected: undefined };
    $scope.periodType = { selected: $scope.periodTypeList[0] };

    $scope.dateOptionsFrom = {
      formatYear: 'yyyy',
      startingDay: 1,
      datepickerMode: 'day',
      minMode: 'day',
      maxMode: 'year'
    };

    $scope.dateOptionsTo = {
      formatYear: 'yyyy',
      startingDay: 1,
      datepickerMode: 'day',
      minMode: 'day',
      maxMode: 'year',
      minDate: $scope.datePicker.from
    };

    $scope.dateFormat = 'dd/MM/yyyy';

    $log.log(authFactory.getAuthData());

    $scope.configuration = {
      model: {}
    };

    $scope.params = {
      filters: {}
    };

    $scope.viewGridOptions = {
      enableFiltering:      true,
      enableOrdering:       true,
      showGridFooter:       true,
      showColumnFooter:     true,
      multiSelect:          false,
      paginationPageSizes:  [10, 15, 25, 50, 100, 250, 500],
      paginationPageSize:   500,
      data:                 'salRows.list',
      rowEditWaitInterval:  -1,
      onRegisterApi:        onRegisterApi
    };

    function onRegisterApi(gridApi) {
      $scope.gridApi = gridApi;
      gridApi.edit.on.afterCellEdit($scope,function(rowEntity, colDef, newValue, oldValue) {
        if(colDef.field == 'model.amount') {
          var diff = oldValue - newValue;
          rowEntity.model.residual_amount = rowEntity.model.residual_amount + diff;
          rowEntity.model.provided_amount = rowEntity.model.provided_amount - diff;
          if(rowEntity.model.residual_amount < 0) {
            dialogService.dialog('ATTENZIONE', 'Il residuo è negativo', 'warning', -1);//, discreet, bodyTextAlign);
          }
        }

        $scope.$apply();
      });
    }

    function initGridColumns() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo riga',
        field: 'model.row_type',
        width: 100,
        enableFiltering: true,
        enableCellEdit: false,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Cod. Edificio',
        field: 'model.asset_id.code',
        enableFiltering: true,
        enableCellEdit: false,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Edificio',
        field: 'model.asset_id.description',
        enableFiltering: true,
        enableCellEdit: false,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Cod. Servizio',
        field: 'model.service_id.code',
        enableFiltering: true,
        enableCellEdit: false,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descr. Servizio',
        field: 'model.service_id.description',
        enableFiltering: true,
        enableCellEdit: false,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Cod. Classe',
        field: 'model.serviceclass_id.code',
        enableFiltering: true,
        enableCellEdit: false,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descr. Classe',
        field: 'model.serviceclass_id.description',
        enableFiltering: true,
        enableCellEdit: false,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo servizio',
        field: 'model.service_type',
        enableFiltering: true,
        enableCellEdit: false,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data inizio periodo',
        field: 'model.start_date',
        enableFiltering: true,
        enableCellEdit: false,
        cellFilter: 'date:"dd/MM/yyyy"',
        filters:[
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data fine periodo',
        field: 'model.end_date',
        enableFiltering: true,
        enableCellEdit: false,
        cellFilter: 'date:"dd/MM/yyyy"',
        filters:[
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Quantità',
        field: 'model.qty',
        enableFiltering: true,
        enableCellEdit: false,
        cellFilter: 'number:1',
        filters:[
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'PU',
        field: 'model.pu',
        enableFiltering: true,
        enableCellEdit: false,
        cellFilter: 'currency:\'€\':3',
        filters:[
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'UM',
        field: 'model.um_id.description',
        enableFiltering: true,
        enableCellEdit: false,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Importo',
        field: 'model.amount',
        enableFiltering: true,
        enableCellEdit: true,
        cellEditableCondition: isCellEditable,
        cellFilter: 'currency:\'€\':3',
        cellClass: editableCellClass,
        aggregationType: uiGridConstants.aggregationTypes.sum,
        filters:[
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Annuo',
        field: 'model.yearly_amount',
        enableFiltering: true,
        enableCellEdit: false,
        cellFilter: 'currency:\'€\':3',
        aggregationType: uiGridConstants.aggregationTypes.sum,
        filters:[
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Totale',
        field: 'model.total_amount',
        enableFiltering: true,
        enableCellEdit: false,
        cellFilter: 'currency:\'€\':3',
        aggregationType: uiGridConstants.aggregationTypes.sum,
        filters:[
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Erogato',
        field: 'model.provided_amount',
        enableFiltering: true,
        enableCellEdit: false,
        cellFilter: 'currency:\'€\':3',
        aggregationType: uiGridConstants.aggregationTypes.sum,
        filters:[
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Residuo',
        field: 'model.residual_amount',
        enableFiltering: true,
        enableCellEdit: false,
        cellFilter: 'currency:\'€\':3',
        aggregationType: uiGridConstants.aggregationTypes.sum,
        filters:[
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.NUMBER,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo Rif.',
        field: 'model.row_type',
        enableFiltering: true,
        enableCellEdit: false,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Gen.',
        field: 'id',
        enableFiltering: false,
        enableCellEdit: false,
        enableSorting: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents" style="text-align: center" ng-if="row.entity.old">' +
            '<a ng-click="grid.appScope.openAlreadyProcessedRow(row.entity)" class="btn btn-xs btn-primary">' +
              '<span class="fa fa-search"></span>' +
            '</a>' +
            '<input type="checkbox" ng-model="row.entity.override">' +
          '</div>'
      });
    }

    function isCellEditable(scope) {
      return scope.row.entity.model.service_type === 'extra canone';
    }

    function editableCellClass(grid, row, col, rowRenderIndex, colRenderIndex) {
      if(row.entity.model.service_type === 'extra canone') {
        return 'toedit';
      }
      return;
    }

    $scope.create = function() {
      if($scope.form.$invalid) {
        $log.log('errori nella form');
        return;
      }

      var payload = {
        from: $scope.datePicker.from,
        to: $scope.datePicker.to,
        sal_code: $scope.salCode,
        sal_description: $scope.salDescription,
        save: false
      };
      if($scope.services.selected.length > 0) {
        var services = $scope.services.selected.map(function(obj) { return obj.code; });
        payload.services = services;
      }
      if($scope.assets.selected.length > 0) {
        var assets = $scope.assets.selected.map(function(obj) { return obj.code; });
        payload.assets = assets;
      }
      if($scope.serviceGroups.selected.length > 0) {
        var serviceGroups = $scope.serviceGroups.selected.map(function(obj) { return obj.code; });
        payload.service_groups = serviceGroups;
      }
      if($scope.serviceType.selected) {
        payload.service_type = $scope.serviceType.selected.key;
      }
      if($scope.rowType.selected) {
        payload.row_type = $scope.rowType.selected.key;
      }
      salFactory.generate(payload).$promise.then(function(response) {
        if(errorService.handleError(response) && !response.hasErrors) {
          $scope.salRows.list = response.result;
          $scope.salRows.totalResults = $scope.salRows.list.length;
          sixDateLib.fixDates($scope.salRows.list);

          if($scope.manualInsertionNeeded()) {
            dialogService.dialog('Generazione eseguita', 'Proseguire con la modifica manuale degli importi extra-canone', 'info', 5000, true);
          }

          $scope.getAlreadyGenerated();
        } else {
          if(response.hasErrors) {  // ho una risposta strutturata con messaggi di errore
            dialogService.serviceResponse('Esito SAL', response, true);
          } else {  // errore generico
            toaster.pop('error', 'Errore generazione', 'Generazione SAL fallita');
          }
        }
      });
    };

    $scope.alreadyProcessedRows = { list: [], totalResults: 0 };
    $scope.getAlreadyGenerated = function() {
      var filters = {
        'model.from': sixFiltersLib.rangeEq('model.start_date', $scope.datePicker.from),
        'model.to': sixFiltersLib.rangeEq('model.end_date', $scope.datePicker.to)
      };
      if($scope.services.selected.length > 0) {
        var services = $scope.services.selected.map(function(obj) { return obj.UUID; });
        filters['model.service_id.UUID'] = sixFiltersLib.in('model.service_id.UUID', services);
      }
      if($scope.assets.selected.length > 0) {
        var assets = $scope.assets.selected.map(function(obj) { return obj.UUID; });
        filters['model.asset_id.UUID'] = sixFiltersLib.in('model.asset_id.UUID', assets);
      }
      if($scope.serviceGroups.selected.length > 0) {
        var serviceGroups = $scope.serviceGroups.selected.map(function(obj) { return obj.UUID; });
        filters['model.serviceclass_id.UUID'] = sixFiltersLib.in('model.serviceclass_id.UUID', serviceGroups);
      }
      if($scope.serviceType.selected) {
        filters['model.service_type'] = sixFiltersLib.exact('model.service_type', $scope.serviceType.selected.key);
      }
      if($scope.rowType.selected) {
        filters['model.row_type'] = sixFiltersLib.exact('model.row_type', $scope.rowType.selected.key);
      }
      salFactory.search({page: 1, page_size: 10000}, filters).$promise.then(function(response) {
        if(errorService.handleError(response) && !response.hasErrors) {
          $log.log(response);
          $scope.alreadyProcessedRows.list = response.list;
          $scope.alreadyProcessedRows.totalResults = response.totalResults;
          sixDateLib.fixDates($scope.alreadyProcessedRows.list);

          $scope.salRows.list.forEach(function(r) {
            var old = $scope.correspondentAlreadyProcessedRow(r);
            if(angular.isDefined(old)) {
              r.old = old;
              r.version = old.version;  // devo sovrascrivere il vecchio (se r.override resta a true)
              r.UUID = old.UUID;
              r.model.residual_amount += parseFloat(old.model.amount);  // sovrascrivo il precedente => il residuo viene ripristinato
              r.model.provided_amount -= parseFloat(old.model.amount);  // sovrascrivo il precedente => l'erogato viene ripristinato
              r.override = false;
            }
          });

          if($scope.alreadyProcessedRows.totalResults > 0) {
            dialogService.dialog('Righe già presenti', 'Sono presenti righe già generate per lo stesso periodo', 'warning', 5000, true);
          }
        } else {
          if(response.hasErrors) {  // ho una risposta strutturata con messaggi di errore
            dialogService.serviceResponse('Esito ricerca SAL', response, true);
          } else {  // errore generico
            toaster.pop('error', 'Errore ricerca', 'Ricerca SAL fallita');
          }
        }
      });
    };

    $scope.correspondentAlreadyProcessedRow = function(row) {
      for(var idx in $scope.alreadyProcessedRows.list) {
        var r = $scope.alreadyProcessedRows.list[idx];
        if(  r.model.asset_id.UUID == row.model.asset_id.UUID
          && r.model.service_id.UUID == row.model.service_id.UUID
          && r.model.serviceclass_id.UUID == row.model.serviceclass_id.UUID
          && r.model.service_type == row.model.service_type
          // && r.model.start_date == row.model.start_date
          // && r.model.end_date == row.model.end_date
        ) {
          $log.log(r);
          return r;
        }
      }
    };

    $scope.openAlreadyProcessedRow = function(row) {
        var dialogScope = {
          // oldRow: $scope.correspondentAlreadyProcessedRow(row),
          oldRow: row.old,
          newRow: row
        };
        var opts = {
          name: 'salOldRowDialog',
          closeByDocument: true,
          width: '80%',
          plain: false
        };
        // N.B. 'dialogTemplate.html' è definito come <script type="text/ng-template"> nel file sal_new.html
        dialogService.templateDialog('dialogOldRowTemplate.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false);
    };

    $scope.saveWithDialog = function() {
      if(!checkPreSave()) {
        showSaveDialog();
      } else {
        $scope.saveAll();
      }
    };

    $scope.saveAll = function() {
      $log.log('saveAll');
      var toSave = filterToSave();
      _save(toSave);
    };

    $scope.saveOnlyDirty = function() {
      var dirty = getDirty();
      var canone = filterCanone();
      var toSave = filterToSave(dirty.concat(canone));
      _save(toSave);
    };

    function _save(rows) {
      rows.forEach(function(row) {
        delete row.$$hashKey;
        delete row.old;
      });
      salFactory.save(rows).$promise.then(function(response) {
        if(errorService.handleError(response) && !response.hasErrors) {
          toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito correttamente');
          $scope.jasperReport($scope.configuration, 'sal', 'pdf');
        } else {
          if(response.hasErrors) {  // ho una risposta strutturata con messaggi di errore
            dialogService.serviceResponse('Esito SAL', response, true);
          } else {  // errore generico
            toaster.pop('error', 'Errore salvataggio', 'Salvataggio fallito');
          }
        }
      });
    }

    // svuoto la variabile contenitore della configurazione...
    function getEmptySalConfiguration () {
      var configuration = {
        model: {
          code: '',
          aggregations: [],
          services: [],
          serviceGroups: [],
          assets: [],
          serviceType: undefined
        }
      };
      return configuration;
    }

    function getSalConfiguration () {
      $scope.params.filters['commission'] = currentContract.code;
      $scope.params.filters['customer'] = $scope.currentCustomer.code;
      salConfigurationFactory.search($scope.params.filters).$promise.then(function (response) {
        if(errorService.handleError(response)) {
          if(response.list[0]){ // carico la configurazione...
            // toaster.pop('success', 'Caricamento configurazione', 'Configurazione SAL scaricata correttamente');
            $scope.configuration = response.list[0];
            // e setto anche le lookup...
            if($scope.configuration.model.serviceType){
              $scope.serviceType.selected = $scope.configuration.model.serviceType;
            }
            if($scope.configuration.model.services){
              $scope.services.selected = $scope.configuration.model.services;
            }
            if($scope.configuration.model.assets){
              $scope.assets.selected = $scope.configuration.model.assets;
            }
            if($scope.configuration.model.serviceGroups){
              $scope.serviceGroups.selected = $scope.configuration.model.serviceGroups;
            }
            if($scope.configuration.model.aggregations){
              $scope.aggregations.selected = $scope.configuration.model.aggregations;
            }
          } else {
            // toaster.pop('info', 'Caricamento configurazione', 'Nessuna configurazione scaricata per la commessa ed il cliente selezionati');
            $scope.configuration = getEmptySalConfiguration();
          }
        } else {
          toaster.pop('info', 'Caricamento configurazione', 'Nessuna configurazione scaricata per la commessa ed il cliente selezionati');
          $scope.configuration = getEmptySalConfiguration();
        }
      });
    }


    $scope.jasperReport = function(configuration, report, extension) {
      var REPORT_URL = 'reports/EMMA/Consip/';
      report = report || 'sal';
      extension = extension || 'pdf';
      var query = '&commission=' + currentContract.code +
        '&customer='  + $scope.currentCustomer.code +
        '&salcode='   + $scope.salCode +
        '&from='      + $filter('date')($scope.datePicker.from, 'yyyy-MM-dd') +
        '&to='        + $filter('date')($scope.datePicker.to, 'yyyy-MM-dd');

      if(configuration.model.assets) {
        var assets = configuration.model.assets.map(function (obj) { return obj.code; });
        query += '&assets=' + assets.join(';');
      }
      if(configuration.model.services) {
        var services = configuration.model.services.map(function (obj) { return obj.code; });
        query += '&services=' + services.join(';');
      }
      if(configuration.model.serviceGroups) {
        var serviceGroups = configuration.model.serviceGroups.map(function (obj) { return obj.code; });
        query += '&servicegroups=' + serviceGroups.join(';');
      }
      if(configuration.model.aggregations) {
        var aggregations = configuration.model.aggregations.map(function (obj) { return obj.key; });
        query += '&aggregations=' + aggregations.join(';');
      }
      var reportNameToSave = 'sal_' + currentContract.code + '_' + $scope.currentCustomer.code + '.' + extension;
      var reportPath = REPORT_URL + report + '.' + extension;
      $http.post(APP_URL + '/rest/report/generate',
        {
          path: reportPath,
          query: query
        },
        {
          responseType: 'arraybuffer'
        })
        .success(function (data, status, headers, config) {
          if(data) {
            var options;
            if (extension == 'pdf') {
              options = {type: 'application/pdf'};
            } else if (extension == 'xls') {
              options = {type: 'application/vnd.ms-excel;'};
            }
            SaveAs.download(data, reportNameToSave, options);
          } else {
            toaster.pop('error', "Errore", 'Errore generazione report');
          }
        })
        .error(function (data, status, headers, config) {
          toaster.pop('error', "Errore", 'Errore generazione report');
        });
    };


    // ***** WATCHES ***** //

    $scope.$watchCollection('rowType.selected', function(newVal, oldVal) {
      $scope.resetSalRows();
    });

    $scope.$watchCollection('serviceType.selected', function(newVal, oldVal) {
      $scope.resetSalRows();
    });

    $scope.$watchCollection('services.selected', function(newVal, oldVal) {
      $scope.resetSalRows();
    });

    $scope.$watchCollection('assets.selected', function(newVal, oldVal) {
      $scope.resetSalRows();
    });

    $scope.$watchCollection('serviceGroups.selected', function(newVal, oldVal) {
      $scope.resetSalRows();
    });

    $scope.$watchCollection('currentCustomerInfo', function(newVal, oldVal) {
      $scope.resetSalRows();
      generateSalCode();
      generateSalDescription();
    });

    $scope.$watchCollection(function() { return currentContract; }, function(newVal, oldVal) {
      $scope.resetSalRows();
      generateSalCode();
      generateSalDescription();
    });

    $scope.$watch('datePicker.from', function(newVal, oldVal) {
      $scope.resetSalRows();
      generateSalCode();
      generateSalDescription();
      if(newVal && oldVal && newVal.getTime() !== oldVal.getTime()) {
        adjustDatePicker();
        isSalGenerable();
      }
      $scope.form.datePickerFrom.$error.temporal = !getValidFormTemporalFrom($scope.datePicker.from, $scope.datePicker.to);
      $scope.form.datePickerFrom.$error.date = !getValidFormDateFrom($scope.datePicker.from);
      $scope.form.datePickerFrom.$validate();
    });

    $scope.$watch('datePicker.to', function(newVal, oldVal) {
      $scope.resetSalRows();
      generateSalCode();
      generateSalDescription();
      if(newVal && oldVal && newVal.getTime() !== oldVal.getTime()) {
        isSalGenerable();
      }
      $scope.form.datePickerTo.$error.temporal = !getValidFormTemporalTo($scope.datePicker.to, $scope.datePicker.from);
      $scope.form.datePickerTo.$error.date = !getValidFormDateTo($scope.datePicker.to);
      $scope.form.datePickerTo.$validate();
    });

    $scope.$watchCollection('periodType', function(newVal, oldVal) {
      if($scope.datePicker.from) {
        switch ($scope.periodType.selected.key) {
          case 'monthly':
          case 'twomonthly':
            $scope.dateFormat = 'MMMM yyyy';
            $scope.dateOptionsFrom.minMode = 'month';
            $scope.dateOptionsFrom.datepickerMode = 'month';
            $scope.dateOptionsTo.minMode = 'month';
            $scope.dateOptionsTo.datepickerMode = 'month';
            break;
          default:
            $scope.dateFormat = 'dd/MM/yyyy';
            $scope.dateOptionsFrom.minMode = 'day';
            $scope.dateOptionsFrom.datepickerMode = 'day';
            $scope.dateOptionsTo.minMode = 'day';
            $scope.dateOptionsTo.datepickerMode = 'day';
            $scope.dateOptionsTo.minDate = $scope.datePicker.from;
            break;
        }
        adjustDatePicker();
      }
    });




    // ***** redirects ***** //
    $scope.goToSalList = function() {
      $location.path('sal');
    };


    $scope.isCustomerMissing = function(){
      return angular.isUndefined($scope.currentCustomer);
    };

    function loadCustomerInfo() {
      if($scope.currentCustomer) {
        var promise = recordFactory('cliente').byUUID({id: $scope.currentCustomer.code}).$promise;
        promise.then(function (response) {
          if (errorService.handleError(response)) {
            $scope.currentCustomerInfo = response;
          }
        });
        return promise;
      }
    }

    function loadAcquisition() {
      if($scope.currentCustomerInfo) {
        var promise = acquisitionWizardFactory.getTerminatedByClient({id: $scope.currentCustomerInfo.UUID}).$promise;
        promise.then(function (response) {
          if (errorService.handleError(response)) {
            $scope.acquisition = response.result;
          }
        });
        return promise;
      }
    }

    $scope.isSalGenerable = false;
    function isSalGenerable() {
      if($scope.acquisition && $scope.acquisition.model) {
        var startContractDate = $scope.acquisition.model.start_contract_date;
        var endContractDate = $scope.acquisition.model.end_contract_date;
        if(!startContractDate || !endContractDate) {
          // toaster.pop('error', 'Errore', 'Impossibile recuperare le informazioni di inzio e fine contratto');
          $scope.isSalGenerable = false;
        } else {
          var resultStart = compareDate(new Date(startContractDate), $scope.datePicker.from) <= 0;
          var resultEnd = compareDate(new Date(endContractDate), $scope.datePicker.to) >= 0;
          $scope.isSalGenerable = !(resultStart && resultEnd);
        }
      }
    }

    function compareDate(date1, date2) {
      var d1 = angular.copy(date1); // evito di modificare la data originale
      var d2 = angular.copy(date2); // evito di modificare la data originale

      d1.setHours(0);
      d1.setMinutes(0);
      d1.setSeconds(0);
      d1.setMilliseconds(0);

      d2.setHours(0);
      d2.setMinutes(0);
      d2.setSeconds(0);
      d2.setMilliseconds(0);

      if(d1.getTime() > d2.getTime()) return 1;
      if(d1.getTime() == d2.getTime()) return 0;
      if(d1.getTime() < d2.getTime()) return -1;
    }


    // ***** RESIZE GRID ***** //

    // Quando cambio la dimensione della pagina della grid ridimensiono anche la grid stessa
    $scope.$watch(function() {return $scope.viewGridOptions.paginationPageSize;}, function(newVal, oldVal) {
      if(newVal) {
        resizeGrid();
      }
    });

    // Ridimensiona la griglia appena la pagina è caricata
    angular.element(document).ready(function () {
      resizeGrid();
    });

    // Quando ridimensiono la finestra ridimensiono anche la grid
    $(window).resize(function() {
      resizeGrid();
    });

    function resizeGrid() {
      var newHeight = $scope.viewGridOptions.paginationPageSize * 30 + 140 + 2 * 15;
      var windowHeight = $(window).height() - 260;
      windowHeight = Math.max(windowHeight, 200); // minimo 200px
      newHeight = Math.min(windowHeight, newHeight);  // massima altezza: altezza visualizzabile dalla finestra alle dimensioni correnti
      angular.element(document.getElementById('salrows_grid')).css('height', newHeight + 'px');
    }


    // ***** EXPORT ***** //

    $scope.export = function() {
      sixExportLib.exportXLSXVisibleRowsGrid($scope.gridApi, currentContract.code + '_SAL_' + $scope.currentCustomer.code);
    };


    // ***** UTILS ***** //

    // validazione From: funz. per validare il form in base al confronto tra date
    function getValidFormTemporalFrom (modelValue, beforeDate) {
      var valid = true;
      if(beforeDate && modelValue) {
        if(angular.isDate(beforeDate)) {
          valid = valid && (modelValue.getTime() < beforeDate.getTime());
        }
      }
      return valid;
    }

    // validazione To: funz. per validare il form in base al confronto tra date
    function getValidFormTemporalTo (modelValue, afterDate) {
      var valid = true;
      if(afterDate && modelValue) {
        if(angular.isDate(afterDate)) {
          valid = valid && (modelValue.getTime() > afterDate.getTime());
        }
      }
      return valid;
    }

    // validazione From: funz. per validare il form, controlla se la data è definita
    function getValidFormDateFrom (modelValue){
      var valid = true;
      if(angular.isUndefined(modelValue)){
        valid = false;
      }
      return valid;
    }

    // validazione To: funz. per validare il form, controlla se la data è definita
    function getValidFormDateTo (modelValue){
      var valid = true;
      if(angular.isUndefined(modelValue)){
        valid = false;
      }
      return valid;
    }

    // funzione che mi ritona la presenza di un errore, per colorare la label
    // prima era sempre colorata con -> form.datePickerTo.$invalid
    $scope.getErrors = function (form){
      var errorPresent = false;
      if(form.$error){
        for (var property in form.$error) {
          if (form.$error[property] == true) {
            errorPresent = true;
          }
        }
      }
      return errorPresent;
    };

    $scope.resetSalRows = function() {
      $scope.salRows = { list: [], totalResults: 0 };
    };

    function adjustDatePicker() {
      if($scope.datePicker.from) {
        switch ($scope.periodType.selected.key) {
          case 'monthly':
            $scope.datePicker.from = new Date($scope.datePicker.from.getFullYear(), $scope.datePicker.from.getMonth(), 1);
            $scope.datePicker.to = new Date($scope.datePicker.from.getFullYear(), $scope.datePicker.from.getMonth() + 1, 0);
            break;
          case 'twomonthly':
            $scope.datePicker.from = new Date($scope.datePicker.from.getFullYear(), $scope.datePicker.from.getMonth(), 1);
            $scope.datePicker.to = new Date($scope.datePicker.from.getFullYear(), $scope.datePicker.from.getMonth() + 2, 0);
            break;
          default:
            break;
        }
        $scope.dateOptionsTo.minDate = $scope.datePicker.from;
      }
    }

    function generateSalCode() {
      if(!$scope.form.salCode.$dirty) {
        $scope.salCode = 'sal';
        var sep = '_';
        if (currentContract && currentContract.code) {
          $scope.salCode += sep + currentContract.code;
          sep = '_';
        }
        if ($scope.currentCustomerInfo && $scope.currentCustomerInfo.model) {
          $scope.salCode += sep + $scope.currentCustomerInfo.model.code;
          sep = '_';
        }
        if ($scope.datePicker.from) {
          $scope.salCode += sep + $filter('date')($scope.datePicker.from, 'yyyyMMdd');
          sep = '_';
        }
        if ($scope.datePicker.to) {
          $scope.salCode += sep + $filter('date')($scope.datePicker.to, 'yyyyMMdd');
          sep = '_';
        }
      }
    }

    function generateSalDescription() {
      if(!$scope.form.salDescription.$dirty) {
        $scope.salDescription = 'Sal';
        var sep = ' ';
        if (currentContract && currentContract.code) {
          $scope.salDescription += sep + 'contratto' + sep + currentContract.code;
          sep = ' ';
        }
        if ($scope.currentCustomerInfo && $scope.currentCustomerInfo.model) {
          $scope.salDescription += sep + '-' + sep + 'cliente' + sep + $scope.currentCustomerInfo.model.code;
          sep = ' ';
        }
        if ($scope.datePicker.from) {
          $scope.salDescription += sep + 'dal' + sep + $filter('date')($scope.datePicker.from, 'dd/MM/yyyy');
          sep = ' ';
        }
        if ($scope.datePicker.to) {
          $scope.salDescription += sep + 'al' + sep + $filter('date')($scope.datePicker.to, 'dd/MM/yyyy');
          sep = ' ';
        }
      }
    }

    $scope.manualInsertionNeeded = function() {
      return (!$scope.serviceType.selected || $scope.serviceType.selected.key !== 'canone');
    };

    $scope.hasDirtyRows = function() {
      return getDirty().length > 0;
    };

    function filterCanone(toFilter) {
      toFilter = toFilter || $scope.salRows.list;
      // return $filter('filter')(toFilter, { model: { service_type: 'canone' }}, function(actual, expected) { return actual === expected; });
      return toFilter.filter(function(r) { return r.model.service_type === 'canone'; });
    }

    function filterExtraCanone(toFilter) {
      toFilter = toFilter || $scope.salRows.list;
      // return $filter('filter')(toFilter, { model: { service_type: 'extra canone' }}, function(actual, expected) { return actual === expected; });
      return toFilter.filter(function(r) { return r.model.service_type === 'extra canone'; });
    }

    function filterAlreadyGenerated(toFilter) {
      toFilter = toFilter || $scope.salRows.list;
      return toFilter.filter(function(r) { return angular.isDefined(r.old); });
    }

    function filterInOverride(toFilter) {
      toFilter = toFilter || $scope.salRows.list;
      return toFilter.filter(function(r) { return r.override == true; });
    }

    function filterToSave(toFilter) {
      toFilter = toFilter || $scope.salRows.list;
      return toFilter.filter(function(r) { return angular.isUndefined(r.old) || (angular.isDefined(r.old) && r.override == true); });
    }

    function getDirty() {
      return $scope.gridApi.rowEdit.getDirtyRows($scope.gridApi.grid).map(function(row) { return row.entity; });
    }

    function getZeroAmounts(toFilter) {
      var rows = [];
      filterExtraCanone(toFilter).forEach(function(r) {
        if(r.model.amount == 0) {
          rows.push(r);
        }
      });
      return rows;
    }

    function getNotModified(toFilter) {
      var extra = filterExtraCanone(toFilter);
      var dirty = getDirty();
      return sixObjectLib.diffArray(extra, dirty);
    }

    function getResidualErrors(toFilter) {
      toFilter = toFilter || $scope.salRows.list;
      return toFilter.filter(function(r) { return r.model.residual_amount < 0; });
    }

    function checkPreSave() {
      return (getNotModified().length == 0 && getResidualErrors().length == 0 && getZeroAmounts().length == 0 && filterAlreadyGenerated().length == 0);
    }

    function showSaveDialog() {
      var dialogScope = {
        errors                  : getResidualErrors().length,
        saveAll                 : $scope.saveAll,
        saveDirty               : $scope.saveOnlyDirty,
        allCount                : $scope.salRows.list.length,
        canoneCount             : filterCanone().length,
        extraCanoneCount        : filterExtraCanone().length,
        dirtyCount              : getDirty().length,
        zeroAmountCount         : getZeroAmounts().length,
        notModifiedCount        : getNotModified().length,
        alreadyGeneratedCount   : filterAlreadyGenerated().length,
        inOverrideCount         : filterInOverride().length,
        extraCanoneToSaveCount  : filterToSave(filterExtraCanone()).length,
        canoneToSaveCount       : filterToSave(filterCanone()).length,
        dirtyToSaveCount        : filterToSave(getDirty()).length,
        allToSaveCount          : filterToSave().length
      };
      var opts = {
        name: 'salSaveDialog',
        closeByDocument: false,
        width: '40%',
        plain: false
      };
      // N.B. 'dialogTemplate.html' è definito come <script type="text/ng-template"> nel file sal_new.html
      dialogService.templateDialog('dialogTemplate.html', dialogService.DIALOG_TYPE.WARNING, dialogScope, opts, -1, false);
    }



    // ***** _main ***** //
    loadCustomerInfo().then(function() {
      loadAcquisition();
    });
    initGridColumns();
    getSalConfiguration();
  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.stepToWizardService
 * @description
 * # stepToWizardService
 * Service in the sixEmmaApp.
 */
angular.module('emma.consip')
  .service('stepToWizardService', function () {
    // private variable
    var _pdiModel = {};
    var _pdiIndex = -1;
    var _pdiSchema = {};
    var _pdiForm = {};
    var _initPdiCallback = undefined;

    var _opfModel = {};
    var _opfIndex = -1;
    var _opfSchema = {};
    var _opfForm = {};
    var _initOpfCallback = undefined;

    var _saveCallback = undefined;
    var _lockStepCallback = undefined;
    var _unlockStepCallback = undefined;

    // public API
    this.pdiModel = _pdiModel;
    this.pdiIndex = _pdiIndex;
    this.pdiSchema = _pdiSchema;
    this.pdiForm = _pdiForm;
    this.initPdiCallback = _initPdiCallback;

    this.opfModel = _opfModel;
    this.opfIndex = _opfIndex;
    this.opfSchema = _opfSchema;
    this.opfForm = _opfForm;
    this.initOpfCallback = _initOpfCallback;

    this.saveCallback = _saveCallback;
    this.lockStepCallback = _lockStepCallback;
    this.unlockStepCallback = _unlockStepCallback;
  });

'use strict';

angular.module('ictportal.core')
.config(function ($routeProvider) {
    $routeProvider
      .when('/core/avertshipment', {
          templateUrl: 'core/avertShipment/avertShipment.html',
          controller: 'AvertShipmentCtrl'
      })
})
.controller('AvertShipmentCtrl', function ($scope, $q, $location, $log, toaster, sixFactory, recordFactory, dbFilterFactory,  localeFactory, $translate) {
    $scope.queryParamers = $location.search();

    $scope.load = function(read) {
        $log.debug("Loading barcode", read);
        delete $scope.avertRequest;
        delete $scope.ddt;
        delete $scope.error;
        var filter = dbFilterFactory.getStringFilter('barcode',read, '=');
        $q.all({
            roll: recordFactory("container").filter(filter).$promise,
            pack: recordFactory("pack").filter(filter).$promise,
            kit: recordFactory("serial_kit").filter(filter).$promise,
            envelope: recordFactory("serial_kit").filter(dbFilterFactory.getStringFilter('envelope',read, '='))
        })
        .then(function(data){
            var roll = data.roll && data.roll.list && data.roll.list.length && data.roll.list[0],
                pack = data.pack && data.pack.list && data.pack.list.length && data.pack.list[0],
                kit = data.kit && data.kit.list && data.kit.list.length && data.kit.list[0];
            kit = kit || (data.envelope && data.envelope.list && data.envelope.list.length && data.envelope.list[0]);
            $log.debug(roll, pack, kit);
            if (roll || pack || kit) {
                $scope.avertRequest = {
                    type: roll? 'roll' : pack? 'pack' : kit? 'kit' : 0,
                    barcode: read,
                    reason: $scope.queryParamers.reason
                }
                sixFactory.find($scope.avertRequest).$promise.then(function(response){
                    if (response.error_code) {
                        $scope.error = response;
                    } else {
                        $scope.ddt = response;
                    }
                });
            } else {
                $scope.error = {
                    error_code: "AVERT_NOT_EXIST",
                    message: "Cannot find any pack, roll or kit with barcode "+read
                }
                $log.error($scope.error.message);
            }
        });

    };

    $scope.avert = function(){
        sixFactory.avert($scope.avertRequest,{})
        .$promise.then(function(response) {
            if (response.error_code) {
                $scope.error = response;
            } else {
                toaster.pop('success',$scope.successMsg.avert_shipment, $scope.successMsg.op_completed_success);
                $scope.ddt = response;
            }
        });
    };

    // Initialize controller
    (function(){
        localeFactory.detectLanguage();
        localeFactory.loadTranslation('shipment','error')
        .then(function() {
            $translate(['op_completed_success', 'avert_shipment'])
            .then(function(data){
                $scope.successMsg = data;
            }, function(error){
                console.error(error);
            });
        });
    })();

});

'use strict';

angular.module('ictportal.core')
  .factory('sixFactory', function (SIX_URL, $resource) {
      return $resource(SIX_URL + '/rest/:verb/:action', {}, {
        avert: {method: 'POST', isArray: false, params: {verb: 'shipment', action: 'avert'}},
        find:  {method: 'GET' , isArray: false, params: {verb: 'shipment', action: 'find'}},
        agreement: {method: 'GET', isArray: false, params: {verb: 'agreement'}},
        updateProductTNT: {method: 'POST', isArray: false, params: {verb: 'product', action: 'updatefortnt'}},
        dest: {method: 'GET', isArray: false, params: {verb: 'customerdestination'}},
        saveEndowment: {method: 'POST', isArray: false, params: {verb: 'endowment', action: 'tnt'}}
      });
  });

'use strict';

/**
 * @ngdoc factory
 * @name ictportal.core.checkInFactory
 * @author Rita Beltrami
 * created on 09/01/2018
 * # checkInFactory
 * Factory in the ictportal.
 */
angular.module('ictportal.core')
    .factory('checkInFactory', function (SIX_URL, $resource) {
        return $resource(SIX_URL + '/rest/_checkin/:verb/:param1/:param2/:param3', {}, {
            checkInTnt:        { method: 'POST', isArray: false, params: {verb: '_serialkit', param1: '_tnt'} },
            checkReordered:    { method: 'POST', isArray: false, params: {verb: '_serialkit', param1: '_reordered'} }
        });
    });

'use strict';

/**
 * @ngdoc factory
 * @name ictportal.customerDestinationFactory
 * @author Rita Beltrami
 * created on 20/05/2019
 * # customerDestinationFactory
 * Factory in the ictportal.
 */
angular.module('ictportal.core')
  .factory('customerDestinationFactory', function (APP_URL, $resource) {
      return $resource(APP_URL + '/rest/customerdestination/:verb/:id/:param1/:param2/:param3', {}, {
        allowedWardrobes:       {method: 'POST', isArray: false, params: {verb: 'allowed', param1: '_wardrobes'} }
      });
  });
'use strict';

/**
 * @ngdoc service
 * @name ictportal.core.customerOrderFactory
 * @description
 * # customerOrderFactory
 * Factory in the ictportal.core.
 */
angular.module('ictportal.core')
  .factory('customerOrderFactory', function (APP_URL, $resource) {
      return $resource(APP_URL + '/rest/_customerorder/:verb/:id/:param1/:param2/:param3', {}, {
        create:       {method: 'POST', isArray: false},
        createAndDispatch:  {method: 'POST', isArray: false, params: {verb: 'dispatch-order'}}
      });
  });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.core.endowmentFactory
 * @description\
 * # endowmentFactory
 * Factory in the ictportal.core.
 */
angular.module('ictportal.core')
  .factory('endowmentFactory', function (APP_URL, $resource) {
      return $resource(APP_URL + '/rest/endowment/:verb/:id/:type/:param1/:param2/:param3', {}, {
        endowmentImportList:       {method: 'POST', isArray: false, params: {verb: 'import', id: 'list'}},
        accountDeliveredToBalance: {method: 'PUT', isArray: false, params: {verb: '_balance', param1: '_account', param2: '_delivered'}},
        get:                       {method: 'POST', isArray: false, params: {verb: '_get'}},
        getSimple:                 {method: 'POST', isArray: false, params: {verb: 'get'}},
        setLastDelivery:           {method: 'PUT', isArray: false, params: {verb: '_set', param1: '_last', param2: '_delivery'}}
      });
  });

'use strict';

angular.module('ictportal.core')
  .factory('healthFactory', function ($resource, APP_URL) {
    return $resource(APP_URL + '/rest/health/:verb', {}, {
      dateTime: {method: 'GET', isArray: false, params: {verb: 'date-time'}},
    });
  });

'use strict';

angular.module('ictportal.core').factory('$localstorage', ['$window', function ($window) {
  return {
    set: function (key, value) {
      $window.localStorage[key] = value;
    },
    get: function (key, defaultValue) {
      return $window.localStorage[key] || defaultValue || false;
    },
    setObject: function (key, value) {
      $window.localStorage[key] = JSON.stringify(value);
    },
    getObject: function (key, defaultValue) {
      if ($window.localStorage[key] != undefined) {
        return JSON.parse($window.localStorage[key]);
      } else {
        return defaultValue || null;
      }
    },
    remove: function (key) {
      $window.localStorage.removeItem(key);
    },
    clear: function () {
      $window.localStorage.clear();
    }
  }
}]);

'use strict';

angular.module('ictportal.core')
    .factory('profilePermissionFactory', function (APP_URL, $resource) {
        return $resource(APP_URL + '/rest/profile/permission/:verb', {}, {
            search: { method: 'GET', isArray: false, params: {verb: 'search' } }, // Given a key, returns a list of all available permissions
            list: { method: 'GET', isArray: false, params: {verb: 'list' } }, // Return a list of all possibile keys and permissions
            checkPermission: { method: 'GET', isArray: false, params: {verb: 'check' } } // Checks if, for a given key, you have a specific permission
        });
    });

'use strict';

/**
 * @ngdoc factory
 * @name ictportal.customerShipmentDocumentFactory
 * @author Rita Beltrami
 * created on 21/06/2019
 * # customerShipmentDocumentFactory
 * Factory in the ictportal.
 */
angular.module('ictportal')
  .factory('customerShipmentDocumentFactory', function ($resource, APP_URL) {
    return $resource(APP_URL + '/rest/return/shipment/document/:verb/:id/:param1', {}, {
        dispatchDirtyDDT:       {method: 'POST', isArray: false, params: {verb: 'dispatch', param1: '_dirtydestination'}}
    });
  });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.core.serialKitFactory
 * @description
 * # serialKitFactory
 * Factory in the ictportal.core.
 */
angular.module('ictportal.core')
  .factory('serialKitFactory', function (APP_URL, $resource) {
      return $resource(APP_URL + '/rest/serialkit/:verb', {}, {
        printLabel:             {method: 'POST', isArray: false, params: {verb: 'printlabel'}},
        getKitFields:           {method: 'POST', isArray: false, params: {verb: 'getfields'}}
      });
  });

'use strict';

/**
 * @ngdoc factory
 * @name ictportal.shipmentDocumentFactory
 * @author Rita Beltrami
 * created on 31/05/2019
 * # shipmentDocumentFactory
 * Factory in the ictportal.
 */
angular.module('ictportal')
  .factory('shipmentDocumentFactory', function ($resource, APP_URL) {
    return $resource(APP_URL + '/rest/shipment/document/:verb/:id', {}, {
        createCustomerShipmentDocument:                  {method: 'POST', isArray: false, params: {verb: '_customer'}},
        createCustomerShipmentDocumentLog80:             {method: 'POST', isArray: false, params: {verb: 'confirmlog80'}},
        createCustomerShipmentDocumentForComponents:     {method: 'POST', isArray: false, params: {verb: 'components-shipment'}},
        createCustomerShipmentDocumentUnified:           {method: 'POST', isArray: false, params: {verb: 'shipment-unified'}},
        setSendToMaster:                                 {method: 'PUT', isArray: false, params: {verb: '_sendtomaster'}},
        setSendToMasterBatch:                            {method: 'PUT', isArray: false, params: {verb: '_sendtomaster', id:'_batch'}}
    });
  });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.componentService
 * @author Rita Beltrami
 * created on 24/04/2019
 * # componentService
 * Service in the ictportal.
 */
angular.module('ictportal.core')
  .service('componentService', function ($rootScope, localeFactory, $filter) {

    var msg = {
        "N":"New",
        "C":"Compliant",
        "NC":"Not compliant",
        "F":"Folded",
        "P":"Packed",
        "S":"Shipped",
        "E":"Returned",
        "WIP":"Work in progress",
        "A":"Discounted",
        "U":"Used",
        "L":"Washed",
        "SW":"Special washing",
        "T":"Tailor",
        "W":"Wardrobe",
        "SL":"Shipped to laundry",
        "SWA":"Shipped to wardrobe",
        "DWA":"Dirty wardrobe",
        "PCW":"Shipped for pack",
        "LOST":"Lost",
        "ACCD":"Received by ward",
        "SHPBLW":"Shippable to wardrobe",
        "SHPBLD":"Shippable to ward",
        "CDS": "Change plant"
    };  
    var componentService = {
        enum: {
            status: [
                {
                    name: 'New',
                    value: 'N'
                },
                {
                    name: 'Compliant',
                    value: 'C'
                },
                {
                    name: 'Not compliant',
                    value: 'NC'
                },
                {
                    name: 'Folded',
                    value: 'F'
                },
                
                {
                    name: 'Packed',
                    value: 'P'
                },
                {
                    name: 'Shipped',
                    value: 'S'
                },
                {
                    name: 'Returned',
                    value: 'E'
                },
                {
                    name: 'Work in progress',
                    value: 'WIP'
                },
                {
                    name: 'Discounted',
                    value: 'A'
                },
                {
                    name: 'Used',
                    value: 'U'
                },
                {
                    name: 'Washed',
                    value: 'L'
                },
                {
                    name: 'Special washing',
                    value: 'SW'
                },
                {
                    name: 'Tailor',
                    value: 'T'
                },
                {
                    name: 'Wardrobe',
                    value: 'W'
                },
                {
                    name: 'Shipped to laundry',
                    value: 'SL'
                },
                {
                    name: 'Shipped to wardrobe',
                    value: 'SWA'
                },
                {
                    name: 'Dirty wardrobe',
                    value: 'DWA'
                },
                {
                    name: 'Shipped for pack',
                    value: 'PCW'
                },
                {
                    name: 'Lost',
                    value: 'LOST'
                },
                {
                    name: 'Received by ward',
                    value: 'ACCD'
                },
                {
                    name: 'Shippable to wardrobe',
                    value: 'SHPBLW'
                },
                {
                    name: 'Shippable to ward',
                    value: 'SHPBLD'
                },
                {
                    name: 'Change plant',
                    value: 'CDS'
                }
            ]
        }
    };

    componentService.getStatusTranslation = function(status){
        var item = $filter('filter')(componentService.enum.status, {value: status }, true);
        var result = (item.length==0)?status:item[0].name;
        return result; 
    }

    $rootScope.$on('$translateRefreshEnd', function () {
        localeFactory.translateMsg(msg, 'component').then(function(){
            componentService.enum.status.forEach(function(en){
                en.name = msg[en.value];
            });
        });
    });

    return componentService;
  });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.goodsInwardService
 * @author Rita Beltrami
 * created on 09/01/2018
 * # goodsInwardService
 * Service in the ictportal.
 */
angular.module('ictportal.core')
  .service('coreEndowmentService', function ($rootScope, localeFactory) {

    var msg = {
        PIANA: "Linen",
        CONFEZIONATA: "Garments",
        MONOUSO: "Disposable",
        BUDGET: "Budget",
        TTR: "TTR"
    };

    var coreEndowmentService = {
        enum: {
            type: [
                {
                    name: 'Linen',
                    value: 'PIANA'
                },
                {
                    name: 'Garments',
                    value: 'CONFEZIONATA'
                },
                {
                    name: 'Disposable',
                    value: 'MONOUSO'
                },
                {
                    name: 'Budget',
                    value: 'BUDGET'
                },
                {
                    name: 'TTR',
                    value: 'TTR'
                }
            ]
        }
    };

    $rootScope.$on('$translateRefreshEnd', function () {
        localeFactory.translateMsg(msg, 'endowment').then(function(){
            coreEndowmentService.enum.type.forEach(function(en){
                en.name = msg[en.value];
            });
        });
    });

    return coreEndowmentService;
  });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.serialKitService
 * @author Rita Beltrami
 * created on 04/06/2018
 * # serialKitService
 * Service in the ictportal.
 */
angular.module('ictportal.core')
  .service('serialKitService', function ($rootScope, localeFactory, $filter) {

    var msg = {
        "INCOMPLETE": "Incomplete",
        "NEW": "New",
        "CONTAINER": "Container",
        "AUTOCLAVE": "Autoclave",
        "STERILIZED": "Sterilized",
        "SENT": "Sent",
        "SENT_WARDROBE": "Sent wardrobe",
        "CONSUMED": "Consumed",
        "REORDERED": "Reordered",
        "INVALIDATED": "Invalidated",
        "LOST": "Lost",
        "ACCEPTED": "Accepted",
        "ASSOCIATED": "Associated",
        "DECONTAMINATED": "Decontaminated",
        "WASHED": "Washed",
        "PACKED": "Packed",
        "STER_CONTRACT_WORK": "Contract work",
        "ACCEPTED_CLEANED": "Accepted cleaned",
        "SHIPPABLE": "Shippable",
        "WARDROBE": "Wardrobe"
    };  
    var serialKitService = {
        enum: {
            status: [
                {
                    name: 'Incomplete',
                    value: 'INCOMPLETE'
                },
                {
                    name: 'New',
                    value: 'NEW'
                },
                {
                    name: 'Container',
                    value: 'CONTAINER'
                },
                {
                    name: 'Autoclave',
                    value: 'AUTOCLAVE'
                },
                
                {
                    name: 'Sterilized',
                    value: 'STERILIZED'
                },
                {
                    name: 'Sent',
                    value: 'SENT'
                },
                {
                    name: 'Sent wardrobe',
                    value: 'SENT_WARDROBE'
                },
                {
                    name: 'Consumed',
                    value: 'CONSUMED'
                },
                {
                    name: 'Reordered',
                    value: 'REORDERED'
                },
                {
                    name: 'Invalidated',
                    value: 'INVALIDATED'
                },
                {
                    name: 'Lost',
                    value: 'LOST'
                },
                {
                    name: 'Accepted',
                    value: 'ACCEPTED'
                },
                {
                    name: 'Associated',
                    value: 'ASSOCIATED'
                },
                {
                    name: 'Decontaminated',
                    value: 'DECONTAMINATED'
                },
                {
                    name: 'Washed',
                    value: 'WASHED'
                },
                {
                    name: 'Packed',
                    value: 'PACKED'
                },
                {
                    name: 'Contract work',
                    value: 'STER_CONTRACT_WORK'
                },
                {
                    name: 'Accepted cleaned',
                    value: 'ACCEPTED_CLEANED'
                },
                {
                    name: 'Shippable',
                    value: 'SHIPPABLE'
                },
                {
                    name: 'Wardrobe',
                    value: 'WARDROBE'
                }
            ]
        }
    };

    serialKitService.getStatusTranslation = function(status){
        var item = $filter('filter')(serialKitService.enum.status, {value: status }, true);
        var result = (item.length==0)?status:item[0].name;
        return result; 
    }

    $rootScope.$on('$translateRefreshEnd', function () {
        localeFactory.translateMsg(msg, 'serialkit').then(function(){
            serialKitService.enum.status.forEach(function(en){
                en.name = msg[en.value];
            });
        });
    });

    return serialKitService;
  });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.shipmentDocumentService
 * @description Service with common variables and methods to handle shipments.
 * @author Rita Beltrami
 * created on 09/01/2018
 * # shipmentDocumentService
 * Service in the ictportal.
 */
angular.module('ictportal')
  .service('shipmentDocumentService', function ($rootScope, localeFactory) {

    var shipment_msg = {
        LOG80: 'Log80',
        DISPATCHED: 'Dispatched',
        TO_DISPATCH: 'To dispatch',
        CANCELED: 'Canceled',
        SENT_TO_SAP: 'Sent to SAP',
        SAP_CLOSED: 'Closed by SAP',
        RECEIVED: 'Received',
        N_CONFIRMED: 'Not confirmed',
    };  

    var shipmentDocumentService = {
        enum: {
            integration_type: [
                {
                    name: 'Log80',
                    value: 'LOG80'
                }
            ],
            state: [
                {
                    name: 'Dispatched',
                    value: 'DISPATCHED'
                },
                {
                    name: 'To dispatch',
                    value: 'TO_DISPATCH'
                },
                {
                    name: 'Canceled',
                    value: 'CANCELED'
                },
                {
                    name: 'Sent to SAP',
                    value: 'SENT_TO_SAP'
                },
                {
                    name: 'Closed by SAP',
                    value: 'SAP_CLOSED'
                },
                {
                    name: 'Received',
                    value: 'RECEIVED'
                },
                {
                    name: 'Not confirmed',
                    value: 'N_CONFIRMED'
                }
            ] 
        }
    };

    $rootScope.$on('$translateRefreshEnd', function () {
        localeFactory.translateMsg(shipment_msg, 'shipment').then(function(){
            shipmentDocumentService.enum.integration_type.forEach(function(en){
                en.name = shipment_msg[en.value];
            });
            shipmentDocumentService.enum.state.forEach(function(en){
                en.name = shipment_msg[en.value];
            });
        });
    });

    return shipmentDocumentService;
  });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.core.controller:ShipmentDocumentCtrl
 * @description
 * @author Rita Beltrami
 * created on 27/12/2017
 * # ShipmentDocumentCtrl
 * Controller of the ictportal.core
 */
angular.module('ictportal.core')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/core/shipmentdocument/detail', {
          templateUrl: 'core/shipmentdocument/shipmentDocument_detail.html',
          controller: 'ShipmentDocumentCtrl'
        })
        .when('/core/shipmentdocument/detail/:id', {
          templateUrl: 'core/shipmentdocument/shipmentDocument_detail.html',
          controller: 'ShipmentDocumentCtrl'
        })
  })
  .controller('ShipmentDocumentCtrl', function ($scope, $log, recordFactory, $routeParams, $location,
                                          eggsFormFactory, toaster, dbFilterFactory, localeFactory, 
                                          authFactory, $q, $window,  $rootScope, schemaFactory, shipmentDocumentFactory) {
    $scope.readOnly = false;
    $scope.showStdPanel = true;        
    $scope.element = {};   
    $scope.enum = {};     
    //$scope.customer = {};
    $scope.record = {
      lookup: {}, 
      dates: ['created_date', 'last_modified_date', 'date', 'delivery_date', 'ddt_date'],
      model: {}
    };
    $scope.shipmentTypeFilter = [];

    function initLookups() {
      eggsFormFactory.addLookup($scope.record.lookup, 'type_id',                'shipment_type',        'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'customer_id',            'customer',             'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'invoicing_customer_id',  'customer',             'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'agreement_id',           'agreement',            'description', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'customer_destination',   'customer_destination', 'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'wharehouse_id',          'facility',             'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'inventory_reason_id',    'inventory_reason',     'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'zone_id',                'zone',                 'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'created_user_id',        'users',                'username', 'username');
      eggsFormFactory.addLookup($scope.record.lookup, 'last_modified_user_id',  'users',                'username', 'username');
    };

    /* function initDates() {
      $scope.dateFields = [];
      $scope.sf.form[0].items[0].tabs.forEach(function (tab) {
        tab.items.forEach(function (item) {
          if (item.type === 'datepicker') {
            $scope.dateFields.push(item.key[0]);
          }
        });
      });
    }; */

    /* function getComponentHistory(){
      var payload = {
        page_size: 10000,
        show_revision: false,
        sort_fields: 'operation_date',
        sort_order: 'desc'
      };
      var filters = dbFilterFactory.getNumberFilter('component_id',$scope.element.id);
      filters = filters.concat(dbFilterFactory.getCustomFilter("( status='S' OR status='ACCD' OR status='W' OR status='E' OR status='L' OR status='SW' OR status='C'  )"));
      recordFactory('component_status').filter(payload, filters)
          .$promise.then(function(data) {
            $log.info(data);
            $rootScope.$broadcast('sixComponentStatusGrid:dataLoaded','component_status',data.list);
      });
    }; */

    function getShipmentDocument(id) {
      recordFactory('shipment').byId({ id: id }).$promise.then(function (response) {
        $scope.record.model = response;
        eggsFormFactory.convertDates($scope.record.model, $scope.record.dates);
        $log.info($scope.record.model);
        eggsFormFactory.loadLookupData($scope.record.lookup, $scope.record.model);
        $rootScope.$broadcast('sixCheckbox:reload'); // todo: sistemare, eliminando questo broadcast orribile
        //getComponentHistory(); // Al posto di questo, caricare le righe
      });
    };


    function init() {
      localeFactory.loadTranslation('shipment');
      schemaFactory().getCode({ id: 'shipment' }).$promise.then(function (data) {
        $scope.sf = data;
        initLookups();
        //initDates();
        if (angular.isDefined($routeParams.id)) {
          getShipmentDocument($routeParams.id);
        }
      });
      $scope.enum = shipmentDocumentFactory.enum;
      $scope.shipmentTypeFilter = $scope.shipmentTypeFilter.concat(dbFilterFactory.getStringFilter('type', 'SALE'));
      $scope.shipmentTypeFilter = $scope.shipmentTypeFilter.concat(dbFilterFactory.getNullableFilter('validity_end', 'IS NULL'));
    };

    init();

  });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.core.controller:ShipmentDocumentListCtrl
 * @description
 * @author Rita Beltrami
 * created on 20/12/2017
 * # ShipmentDocumentListCtrl
 * Controller of the ictportal.core
 */
angular.module('ictportal.core')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/core/shipmentdocument/list', {
                templateUrl: 'core/shipmentdocument/shipmentDocument_list.html',
                controller: 'ShipmentDocumentListCtrl'
            })
    })
    .controller('ShipmentDocumentListCtrl', function ($scope, recordFactory, $location, shipmentDocumentService, authFactory,
                                                      parseSchemaService, dbFilterFactory, localeFactory, eggsFormFactory) {
        var msg = {};                     
        var shipment_msg = {
            integration_type: "Order from",
            ddt_number: "Shipment number",
            date: "Date",
            bar:  "Bar",
            customer_code: "Cust. code",
            destination: "Destination",
            delivery_date: "Delivery date",
            invoicing_customer: "Billing cust.",
            customer_description: "Cust. corporate"
        };  
        $scope.result = {};
        var authData = authFactory.getAuthData();
        $scope.record = {
            lookup: {}, // Per questa pagina non serve, la lascio un attimo mentre penso a come standardizzare il più possibile le pagine
            dates: ['date', 'delivery_date']
        };
        $scope.params = {
            pageNumber: 1,
            pageSize: 15,
            code: 'component',
            filters: []
        };
        $scope.viewGridOptions = { appScopeProvider: $scope };
        $scope.advFilter = {
            filter: {},
            list: []
        };
        $scope.enum = {};

        $scope.$watchGroup(['advFilter.filter.barcode',
            'advFilter.filter.ddt_number',
            'advFilter.filter.bar',
            'advFilter.filter.ddt_date_from',
            'advFilter.filter.ddt_date_to',
            'advFilter.filter.delivery_date',
            'advFilter.filter.customer_id',
            'advFilter.filter.customer_destination',
            'advFilter.filter.invoicing_customer_id',
            'advFilter.filter.type_id',
            'advFilter.filter.state',
            'advFilter.filter.integration_type'], function () {
                $scope.applyFilter();
            });

        $scope.applyFilter = function () {
            $scope.advFilter.list.length = 0;
            if ($scope.advFilter.filter.barcode) {
                var f = dbFilterFactory.getLikeFilter('t.barcode', $scope.advFilter.filter.barcode);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.ddt_number) {
                var f = dbFilterFactory.getNumberFilter('t.ddt_number', $scope.advFilter.filter.ddt_number);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.bar) {
                var f = dbFilterFactory.getLikeFilter('t.bar', $scope.advFilter.filter.bar);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.ddt_date_from) {
                var f = dbFilterFactory.getDateFilter('t.ddt_date', $scope.advFilter.filter.ddt_date_from, '>=');
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.ddt_date_to) {
                var f = dbFilterFactory.getDateFilter('t.ddt_date', $scope.advFilter.filter.ddt_date_to, '<=');
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.delivery_date) {
                var f = dbFilterFactory.getDateFilter('t.delivery_date', $scope.advFilter.filter.delivery_date);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.customer_id) {
                var f = dbFilterFactory.getNumberFilter('t.customer_id', $scope.advFilter.filter.customer_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.customer_destination) {
                var f = dbFilterFactory.getNumberFilter('t.customer_destination', $scope.advFilter.filter.customer_destination);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.invoicing_customer_id) {
                var f = dbFilterFactory.getNumberFilter('t.invoicing_customer_id', $scope.advFilter.filter.invoicing_customer_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.type_id) {
                var f = dbFilterFactory.getNumberFilter('t.type_id', $scope.advFilter.filter.type_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.state) {
                var f = dbFilterFactory.getStringFilter('t.state', $scope.advFilter.filter.state);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.integration_type) {
                var f = [{
                    "column": "customer_order co",
                    "value": "t.customer_order_id = c.id",
                    "relation": "JOIN",
                    "kind": "co.integration_type"
                }];
                f = f.concat(dbFilterFactory.getStringFilter('co.integration_type', $scope.advFilter.filter.integration_type));
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            $scope.getData();
        };

        function initGridColumns() {
            $scope.lookupCols = [];
            $scope.viewGridOptions.columnDefs = [];
            var dateFormat = localeFactory.getDateFormat();
            $scope.viewGridOptions.columnDefs.push(parseSchemaService.getEditCol());
            $scope.viewGridOptions.columnDefs.push({
                name: 'Cod. cliente',
                field: "customer_code",
                translation: 'customer_code', 
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Ragione sociale cliente",
                field: "customer_description",
                translation: 'customer_description',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Cliente fatt.",
                field: "invoicing_customer_description",
                translation: 'invoicing_customer',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: 'Destinazione',
                cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.customer_destination_code}} - {{row.entity.customer_destination_description}}</div>',
                translation: 'destination',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "DDT Number",
                field: "ddt_number",
                translation: 'ddt_number',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Barra",
                field: "bar",
                translation: 'bar',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Data",
                field: "ddt_date",
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.ddt_date | date:\'' + dateFormat + '\' }}</div>',
                translation: 'date',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Data consegna",
                field: "delivery_date",
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.delivery_date | date:\'' + dateFormat + '\' }}</div>',
                translation: 'delivery_date',
                enableFiltering: false
            });
        };

        $scope.getData = function () {
            var payload = {
                page: $scope.params.pageNumber,
                page_size: $scope.params.pageSize,
                code: $scope.params.code,
                description: $scope.params.description,
                show_revision: false,
                sort_fields: ($scope.params.sortFields ? $scope.params.sortFields : 'created_date'),
                sort_order: $scope.params.sortOrder
            };
            // Qui scrivo i filtri obbligatori, quelli 'avanzati' li accodo 
            var filters = [
                {
                    "column": "customer c",
                    "value": "t.customer_id = c.id",
                    "relation": "JOIN",
                    "kind": "c.code AS customer_code, c.description AS customer_description"
                },
                {
                    "column": "customer i",
                    "value": "t.invoicing_customer_id = i.id",
                    "relation": "JOIN",
                    "kind": "i.code AS invoicing_customer_code"
                },
                {
                    "column": "customer_destination cd",
                    "value": "t.customer_destination = cd.id",
                    "relation": "JOIN",
                    "kind": "cd.code AS customer_destination_code, cd.description AS customer_destination_description"
                }
            ];
            // per i ddt di resto, discriminator = CUSTRETURN
            filters = filters.concat(dbFilterFactory.getStringFilter('discriminator', 'CUSTOMER'));
            filters = filters.concat($scope.advFilter.list);
            recordFactory('shipment').filter(payload, filters)
                .$promise.then(function (data) {
                    $scope.viewGridOptions.totalItems = data.totalResults;
                    $scope.result.totalResults = data.totalResults;
                    $scope.result.list = data.list;
                    if ($scope.record.dates.length > 0) {
                        parseSchemaService.loadDates($scope.record, $scope.result);
                    }
                });
        };

        $scope.viewDetail = function (value) {
            $location.path('/core/shipmentdocument/detail/' + value.id);
        };

        $scope.goToNew = function(){
            $location.path('/core/shipmentdocument/detail');
        };

        function initFilters(){
            // Filtro da applicare alla lookup sul tipo
            $scope.shipmentTypeFilter = dbFilterFactory.getStringFilter('type', 'SALE')
                                        .concat(dbFilterFactory.getNullableFilter('validity_end', 'IS NULL'));
            $scope.customerFilter = authData.filters.customer; // Filtro da applicare alla lookup sugli ospedali
            $scope.shipmentDestinationFilter = authData.filters.customer_destination; // Filtro da applicare sulle righe della tabella
            $scope.employeeCustomerFilter = []; // Filtro da applicare sulla lookup dei dipendenti
        }; 

        function translateGridColumns(){
            $scope.viewGridOptions.columnDefs.forEach(function(col){
                if(col.translation) {
                    col.name = shipment_msg[col.translation];
                }
            });
        };

        function initLookups() {
            $scope.lookup = {};
            eggsFormFactory.addLookup($scope.lookup, 'customer_id', 'customer', 'code', 'description');
            eggsFormFactory.addLookup($scope.lookup, 'customer_destination', 'customer_destination', 'code', 'description');
            eggsFormFactory.addLookup($scope.lookup, 'invoicing_customer_id', 'customer', 'code', 'description');
            eggsFormFactory.addLookup($scope.lookup, 'type_id', 'shipment_type', 'code', 'description');
        };

        function checkPermissions() {
            var profilingKey = 'CUSTOMER_SHIPMENT_CONTROLLER';
            $scope.permission = authFactory.getPermissions(profilingKey);
            if(!$scope.permission.EXEC) {
                $location.path('forbidden').search({key: profilingKey});
            }
            else if(!$scope.permission.DETAIL) {
                $scope.viewGridOptions.columnDefs.splice(0, 1);
            }
        };

        function init() {
            initGridColumns();
            checkPermissions();
            localeFactory.loadTranslation('shipment').then(function() {
                localeFactory.translateMsg(shipment_msg, 'shipment').then(function(){
                    translateGridColumns();
                });
            });
            initLookups();
            initFilters();
            $scope.enum = shipmentDocumentService.enum;
        };

        //___ main ___
        init();

    });
'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:ExportCtrl
 * @description
 * # ExportCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/export', {
          templateUrl: 'dataset/export/export.html',
          controller: 'ExportCtrl'
        });
    })
  .controller('ExportCtrl', function ($scope, $log, schemaFactory, recordFactory, zonaTermicaFactory, dialogService, uiGridConstants, errorService) {
    $scope.limit = 10000;
    $scope.typeExport = 'export';
    $scope.entity = {};
    $scope.schema = {};
    $scope.data = [];
    $scope.isEntitySelected = false;
    $scope.exportList = {list: []};
    $scope.params = {
      pageNumber: 1,
      pageSize: 100,
      totalItems: 0,
      filters: {}
    };

    $scope.viewGridOptions = {
      enableSorting: true,
      enableGridMenu: true,
      exporterCsvColumnSeparator: ';',
      exporterMenuPdf: false,
      enableFiltering: true,
      enableColumnResizing: true,
      paginationPageSizes: [100, 250, 500, 1000, 10000],
      paginationPageSize: 100,
      totalItems: 0,
      useExternalPagination: true,
      useExternalFiltering: true,
      multiSelect: true,
      enableRowHeaderSelection: true,
      enableRowSelection: true
    };

    $scope.$watchGroup(['entity.type', 'limit'],
      function( newValue, oldValue ) {
        $scope.isEntitySelected = angular.isDefined(newValue[0]);
        if($scope.isEntitySelected == true && newValue != oldValue){
          var typeUUID = $scope.entity.type.UUID;

          // getting schema of entity.type
          schemaFactory().byCode({id: typeUUID}).$promise.then(function(response) {
            if (errorService.handleError(response)) {
              $scope.schema = response;
              if($scope.schema.model.columnDefs) {
                $scope.viewGridOptions.columnDefs = [];
                angular.forEach($scope.schema.model.columnDefs, function(colDef) { //colDef has name and field -> {name: 'Codice', field: 'code'}
                  var newColDef = {
                    displayName: $scope.schema.model.schema.properties[colDef.field].title,
                    field: 'model.' + colDef.field,
                    filters: [{ type: 'text', condition: uiGridConstants.filter.CONTAINS, placeholder: ''}],
                    enableFiltering: true
                  };
                  if($scope.schema.model.schema.properties[colDef.field].type === 'string'){ // specific filters for lookup and dates
                    if($scope.schema.model.schema.properties[colDef.field].format === 'lookup'){
                      newColDef.field = 'model.' + colDef.field + '.description';
                      newColDef.filters =
                        [{
                          type: 'sixlookup',
                          condition: uiGridConstants.filter.CONTAINS,
                          placeholder: ''
                      }];
                    }
                    if ($scope.schema.model.schema.properties[colDef.field].format === 'date') {
                      newColDef.filters = [
                        { type: 'date',
                          relation: 'gte',
                          placeholder: 'da...',
                          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL},
                        { type: 'date',
                          relation: 'lte',
                          placeholder: 'a...',
                          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL}
                      ];
                    }
                  }
                  if($scope.schema.model.schema.properties[colDef.field].type === 'number') { // specific filters for numbers
                    newColDef.filters = [
                      { type: 'number',
                        relation: 'gte',
                        placeholder: 'da...',
                        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL},
                      { type: 'number',
                        relation: 'e',
                        placeholder: 'uguale a...',
                        condition: uiGridConstants.filter.EXACT},
                      { type: 'number',
                        relation: 'lte',
                        placeholder: 'a...',
                        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL}
                    ];
                  }
                  $scope.viewGridOptions.columnDefs.push(newColDef);
                });
              }
              $scope.getExportList();
            }
          });
        }
      }
    );

    $scope.getExportList = function () {
      var promise = {};
      var payload = {
        query: $scope.queryParam,
        page_size: $scope.params.pageSize,
        show_revision: false,
        solve_inherit: true
      };
      if($scope.entity.type.UUID != 'zonatermica'){
        promise = recordFactory($scope.entity.type.UUID).search(payload, $scope.params.filters).$promise;
      } else {
        // endpoint per le zt: in modo da risolvere la colonna dei gradi giorno stagione termica
        promise = zonaTermicaFactory.search(payload, $scope.params.filters).$promise;
      }
      // aspetto la risposta
      promise.then(function(data) {
        $scope.params.totalItems = data.totalResults;
        $scope.viewGridOptions.totalItems = data.totalResults;
        $scope.exportList.totalResults = data.totalResults;
        $scope.exportList.list = data.list;
      });
    };

    $scope.importData = function () {
      $scope.data.forEach(function (value) {
        $log.info(value);
      });
    };

    $scope.exportXLSX = function (){
      // preparo colonne
      var columns = [];
      angular.forEach($scope.schema.model.schema.properties, function(property, key) {
        columns.push({
          key: 'model.' + key,
          name: ($scope.typeExport=='exportToImport')?key:property.title
        })
      });
      columns.push({key: 'commission', name: ($scope.typeExport=='exportToImport')?'commission':'Commessa'});

      // preparo righe
      var rows = $scope.params.gridApi.selection.getSelectedRows();
      if(!rows || rows.length == 0) {
        var promise = {};
        var payload = {
          query: $scope.queryParam,
          page: 1,
          page_size: 10000,
          show_revision: false,
          solve_inherit: ($scope.typeExport=='exportToImport')?false:true,
          cross: $scope.findCross
        };
        if($scope.entity.type.UUID != 'zonatermica'){
          promise = recordFactory($scope.entity.type.UUID).search(payload, $scope.params.filters).$promise;
        } else {
          // endpoint per le zt: in modo da risolvere la colonna dei gradi giorno stagione termica
          promise = zonaTermicaFactory.search(payload, $scope.params.filters).$promise;
        }
        // aspetto la risposta...
        promise.then(function(data) {
          rows = data.list;
          sixExportLib.exportXLSX(columns, rows, $scope.entity.type.description, $scope.typeExport!=='exportToImport');
        });
      } else {
        sixExportLib.exportXLSX(columns, rows, $scope.entity.type.description, $scope.typeExport!=='exportToImport');
      }
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:ExportcrossCtrl
 * @description
 * # ExportcrossCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/exportcross', {
        templateUrl: 'dataset/export/exportcross.html',
        controller: 'ExportcrossCtrl'
      });
  })
  .controller('ExportcrossCtrl', function ($scope, $log, schemaFactory, authFactory, loginFactory, $location, recordFactory, zonaTermicaFactory,
                                           dialogService, errorService, uiGridExporterService, uiGridExporterConstants, uiGridConstants) {
    $scope.limit = 10000;
    $scope.typeExport = 'export';
    $scope.findCross = false;
    $scope.entity = {};
    $scope.schema = {};
    $scope.data = [];
    $scope.isEntitySelected = false;
    $scope.exportList = {list: []};
    $scope.params = {
      pageNumber: 1,
      pageSize: 100,
      totalItems: 0,
      filters: {}
    };
    $scope.typeName = '';
    $scope.historyMode = '';

    $scope.currentCommission = authFactory.getAuthData().info.commissions.current;

    $scope.viewGridOptions = {
      //appScopeProvider: this,
      enableSorting: true,
      enableGridMenu: true,
      exporterCsvColumnSeparator: ';',
      exporterMenuPdf: false,
      enableFiltering: true,
      enableColumnResizing: true,
      paginationPageSizes: [100, 250, 500, 1000, 10000],
      paginationPageSize: 100,
      totalItems: 0,
      useExternalPagination: true,
      useExternalFiltering: true,
      multiSelect: true,
      enableRowHeaderSelection: true,
      enableRowSelection: true
    };

    $scope.$watchGroup(['entity.type', 'findCross'],
      function( newValue, oldValue ) {
        $scope.isEntitySelected = angular.isDefined(newValue[0]);
        if($scope.isEntitySelected == true && newValue != oldValue){
          var typeUUID = $scope.entity.type.UUID;

          // getting schema of entity.type
          schemaFactory().byCode({id: typeUUID}).$promise.then(function(response) {
            if (errorService.handleError(response)) {
              $scope.schema = response;
              $scope.typeName = $scope.schema.model.code;
              $scope.historyMode = $scope.schema.model.history ? 'snap' : 'stable';
              if($scope.schema.model.columnDefs) {
                $scope.viewGridOptions.columnDefs = [];
                $scope.viewGridOptions.columnDefs.push({
                  displayName: '',
                  field: 'id',
                  width: 34,
                  enableCellEdit: true,
                  enableFiltering: false,
                  enableSorting: false,
                  cellTemplate:
                   '<div class="ui-grid-cell-contents" style="vertical-align:middle;text-align:center;">' +
                   '<button type="button" class="btn btn-xs btn-primary fa fa-search" ng-click="grid.appScope.$parent.goToItem(row)">' +
                   '</button>' +
                   '</div>'
                });
                angular.forEach($scope.schema.model.columnDefs, function(colDef) { //colDef has name and field -> {name: 'Codice', field: 'code'}
                  var newColDef = {
                    displayName: $scope.schema.model.schema.properties[colDef.field].title,
                    field: 'model.' + colDef.field,
                    filters: [{ type: 'text', condition: uiGridConstants.filter.CONTAINS, placeholder: ''}],
                    enableFiltering: true
                  };
                  if($scope.schema.model.schema.properties[colDef.field].type === 'string'){ // specific filters for lookup and dates
                    if($scope.schema.model.schema.properties[colDef.field].format === 'lookup'){
                      newColDef.field = 'model.' + colDef.field + '.description';
                      newColDef.filters =
                        [{
                          type: 'sixlookup',
                          condition: uiGridConstants.filter.CONTAINS,
                          placeholder: ''
                        }];
                    }
                    if ($scope.schema.model.schema.properties[colDef.field].format === 'date') {
                      newColDef.filters = [
                        { type: 'date',
                          relation: 'gte',
                          placeholder: 'da...',
                          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL},
                        { type: 'date',
                          relation: 'lte',
                          placeholder: 'a...',
                          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL}
                      ];
                    }
                  }
                  if($scope.schema.model.schema.properties[colDef.field].type === 'number') { // specific filters for numbers
                    newColDef.filters = [
                      { type: 'number',
                        relation: 'gte',
                        placeholder: 'da...',
                        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL},
                      { type: 'number',
                        relation: 'e',
                        placeholder: 'uguale a...',
                        condition: uiGridConstants.filter.EXACT},
                      { type: 'number',
                        relation: 'lte',
                        placeholder: 'a...',
                        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL}
                    ];
                  }
                  $scope.viewGridOptions.columnDefs.push(newColDef);
                });

                // the last column is the commission...
                $scope.viewGridOptions.columnDefs.push({
                  displayName: 'Commessa',
                  field: 'commission',
                  cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.$parent.getCommission(row)}}</div>',
                  filters: [{ type: 'text', condition: uiGridConstants.filter.CONTAINS, placeholder: ''}],
                  enableFiltering: true
                });
              }
              $scope.getExportList();
            }
          });
        }
      });

    $scope.getExportList = function () {
      var promise = {};
      var payload = {
        query: $scope.queryParam,
        page: $scope.params.pageNumber,
        page_size: $scope.params.pageSize,
        show_revision: false,
        solve_inherit: true,
        cross: $scope.findCross
      };
      if($scope.entity.type.UUID != 'zonatermica'){
        promise = recordFactory($scope.entity.type.UUID).search(payload, $scope.params.filters).$promise;
      } else {
        // endpoint per le zt: in modo da risolvere la colonna dei gradi giorno stagione termica
        promise = zonaTermicaFactory.search(payload, $scope.params.filters).$promise;
      }
      // aspetto la risposta...
      promise.then(function(data) {
        $scope.params.totalItems = data.totalResults;
        $scope.viewGridOptions.totalItems = data.totalResults;
        $scope.exportList.totalResults = data.totalResults;
        $scope.exportList.list = data.list;
      });
    };

    $scope.importData = function () {
      $scope.dataExp.forEach(function (value) {
        $log.info(value);
      });
    };

    $scope.getCommission = function (row){
      var str = '';
      var sep = '';
      if(row.entity.commission) {
        [].concat(row.entity.commission).forEach(function (c) {
          str += sep + c;
          sep = ',';
        });
      }
      return str;
    };

    $scope.goToItem = function(row) {
      var comm = getCommissionInfoByCode([].concat(row.entity.commission)[0]);
      var desc = (comm) ? comm.description : [].concat(row.entity.commission)[0];
      var switchProfileElement = {
        selected : {
          type:'',
          cod: 0,
          code: [].concat(row.entity.commission)[0],
          description: desc,
          items: [{
            type:'commission',
            cod: 0,
            code: [].concat(row.entity.commission)[0],
            description: desc
          }]
        }
      };
      if(authFactory.getAuthData().info.commissions.current.code == row.entity.commission[0]){
        console.log('record/' + $scope.historyMode + '/'+ $scope.typeName + '/' + row.entity.UUID);
        $location.path('record/' + $scope.historyMode + '/'+ $scope.typeName + '/' + row.entity.UUID);
      } else {
        console.log('GO!!!');
        dialogService.loading('Cambio commessa ' + authFactory.getAuthData().info.commissions.current.code + ' <i class="fa fa-angle-double-right"></i> ' + row.entity.commission[0]);
        loginFactory.switch(switchProfileElement).$promise.then(function (response) {
          authFactory.setAuthData(response);
          dialogService.stopLoading();
          console.log('record/' + $scope.historyMode + '/' + $scope.typeName + '/' + row.entity.UUID);
          $location.path('record/' + $scope.historyMode + '/' + $scope.typeName + '/' + row.entity.UUID);
        });
      }
    };

    function getCommissionInfoByCode(code) {
      for(var i in authFactory.getAuthData().info.commissions.list) {
        var c = authFactory.getAuthData().info.commissions.list[i];
        if(c.code === code) {
          return c;
        }
      }
    }

    $scope.exportXLSX = function () {
      // preparo colonne
      var columns = [];
      angular.forEach($scope.schema.model.schema.properties, function(property, key) {
        columns.push({
          key: 'model.' + key,
          name: ($scope.typeExport=='exportToImport')?key:property.title
        })
      });
      columns.push({key: 'commission', name: ($scope.typeExport=='exportToImport')?'commission':'Commessa'});

      // preparo righe
      var rows = $scope.params.gridApi.selection.getSelectedRows();
      if(!rows || rows.length == 0) {
        var promise = {};
        var payload = {
          query: $scope.queryParam,
          page: 1,
          page_size: 10000,
          show_revision: false,
          solve_inherit: ($scope.typeExport=='exportToImport')?false:true,
          cross: $scope.findCross
        };
        if($scope.entity.type.UUID != 'zonatermica'){
          promise = recordFactory($scope.entity.type.UUID).search(payload, $scope.params.filters).$promise;
        } else {
          // endpoint per le zt: in modo da risolvere la colonna dei gradi giorno stagione termica
           promise = zonaTermicaFactory.search(payload, $scope.params.filters).$promise;
        }
        // aspetto la risposta...
        promise.then(function(data) {
          rows = data.list;
          sixExportLib.exportXLSX(columns, rows, $scope.entity.type.description, $scope.typeExport!=='exportToImport');
        });
      } else {
        sixExportLib.exportXLSX(columns, rows, $scope.entity.type.description, $scope.typeExport!=='exportToImport');
      }
    };


    // typeExport
    $scope.setTypeExport = function(value) {
      $scope.typeExport = value;
    };

    // findCross
    $scope.setFindCross = function (value) {
      $scope.findCross = value;
    };
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.dataset.baseFactory
 * @description
 * # baseFactory
 * Factory in the emma.dataset.
 */
angular.module('emma.dataset')
  .factory('dataSetFactory', function (DATA_SET_URL, $resource) {
    return function(entity) {
      return $resource(DATA_SET_URL + '/api/'+entity+'/'+':id', {}, {
        query:  {method: 'GET', isArray: false},
        search: {method: 'POST', isArray: false},
        filter: {method: 'POST', isArray: true},
        select: {method: 'GET', isArray: true},
        create: {method: 'POST'},
        bulk:   {method: 'POST', isArray: true},
        show:   {method: 'GET'},
        update: {method: 'PUT', params: {id: '@id'}},
        delete: {method: 'DELETE', params: {id: '@id'}}
      });
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:FormulaCtrl
 * @description
 * # FormulaCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/formula', {
        templateUrl: 'dataset/formula/formula_list.html',
        controller: 'FormulaCtrl'
      })
      .when('/formula/:id', {
        templateUrl: 'dataset/formula/formula_detail.html',
        controller: 'FormulaCtrl'
      })
  })
  .controller('FormulaCtrl', function ($scope, $window, $location, $routeParams, formulaFactory, dialogService) {

    $scope.model = {
      code: '',
      description: '',
      formula: undefined
    };

    $scope.output = undefined;

    $scope.arrayFunction = {
      'radice': {
        key:'radice',
        description:'Math.sqrt(value)',
        check: false
      },
      'potenza': {
        key:'potenza',
        description:'Math.pow(value, exponent)',
        check: false
      },
      'seno': {
        key:'seno',
        description:'Math.sin(valueInRadiant)',
        check: false
      },
      'arcoseno': {
        key:'arcoseno',
        description:'Math.asin(value)',
        open: false
      },
      'coseno': {
        key:'coseno',
        description:'Math.cos(valueInRadiant)',
        open: false
      },
      'arcocoseno': {
        key:'arcocoseno',
        description:'Math.acos(value)',
        open: false
      },
      'tangente': {
        key:'tangente',
        description:'Math.tan(valueInRadiant)',
        open: false
      },
      'arcotangente': {
        key:'arcotangente',
        description:'Math.atan(value)',
        open: false
      }
    };

    if($routeParams.id && 'new' !== $routeParams.id) {
      formulaFactory.getFormulaById({id: $routeParams.id}).$promise.then(function (data) {
        $scope.model = data;
      });
    }

    $scope.newFormula = function(){
        $location.path('formula/new');
    };

    $scope.saveForm = function() {
      if($routeParams.id !== 'new'){
        formulaFactory.updateFormula({id: $scope.model.code}, $scope.model)
          .$promise.then(function() {
            $window.history.back();
          });
      } else{
        formulaFactory.createFormula($scope.model)
          .$promise.then(function() {
            $window.history.back();
        });
      }
    };

    $scope.delete = function (idToDelete) {
      formulaFactory.deleteFormula({id: $scope.model.code}).$promise.then(function() {
        $window.history.back();
      });
    };

    $scope.pageChanged = function () {
      $scope.listWrapper = formulaFactory.getFormulasList({query: $scope.queryParam, page: $scope.listWrapper.currentPage});
    };

    $scope.getListWrapper = function () {
      formulaFactory.getFormulasList({query: $scope.queryParam}).$promise.then(function(data) {
        $scope.listWrapper = data;
      });
    };

    $scope.getListWrapper();

    $scope.calculate = function(params){
      var obj = {
        formula: $scope.model.formula,
        value:params
      };
      formulaFactory.getCalculationResult(obj).$promise.then(function(data) {
        $scope.output = data.result;
      });
    };
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.dataset.formulaFactory
 * @description
 * # formulaFactory
 * Factory in the emma.dataset.
 */
angular.module('emma.dataset')
  .factory('formulaFactory', function (DATA_SET_URL, $resource) {
      return $resource(DATA_SET_URL + '/api/formula/:verb/:type/:id/:param1/:param2/:param3', {}, {
        getFormulaById:       {method: 'GET',     params: {verb: '_id'}},
        getFormulasList:      {method: 'GET'},
        getCalculationResult: {method: 'POST',    params: {verb: '_test'}},
        createFormula:        {method: 'POST',    params: {id: '@id'}},
        updateFormula:        {method: 'PUT',     params: {id: '@id'}},
        deleteFormula:        {method: 'DELETE',  params: {id: '@id'}},
        getParamsByNum:       {method: 'GET',     params: {verb: '_params', type: 'number', id: '@id'}},
        getParamsByArray:     {method: 'GET',     params: {verb: '_params', type: 'array', id: '@id'}}
      });
  });

'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:ImportCtrl
 * @description
 * # ImportCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset')
.config(function ($routeProvider) {
    $routeProvider
      .when('/import', {
        templateUrl: 'dataset/import/import.html',
        controller: 'ImportCtrl'
      });
  })
  .controller('ImportCtrl', function ($scope, $log, schemaFactory, recordFactory, priceListFactory, zonaTermicaFactory, errorService, dialogService, $timeout, toaster) {
    $scope.errorCount = 0;
    $scope.importBusy = false;
    $scope.percent = 0;
    $scope.prePercent = 0;
    $scope.preprocessToResolve = 0;
    $scope.preprocessResolved = 0;
    $scope.entity = {};
    $scope.data = [];
    $scope.isEntitySelected = false;
    $scope.typeName = '';
    $scope.reportMessages = [];
    $scope.schemaDefinition ={};
    $scope.gridOptions = {
      importerDataAddCallback: function ( grid, newObjects ) {
       // $scope.data = $scope.data.concat( newObjects ); //questa in realtà non viene chiamata... la direttiva xlsx non scatena l'evento..
      },
      onRegisterApi: function(gridApi){
        $scope.gridApi = gridApi;
      }
    };

    $scope.reportGridOptions = {
      enableSorting: true,
      exporterMenuPdf: false,
      paginationPageSizes: [10, 20, 30],
      paginationPageSize: 10,
      useExternalPagination: false,
      data: 'reportMessages',
      columnDefs: [
        {displayName: 'Codice', field: 'code', width: '60'},
        {displayName: 'Stato', field: 'status', width: '100'},
        {displayName: 'Messaggio', field: 'message'},
        {displayName: 'Record type', field: 'record.type', width: '120'},
        {displayName: 'Record code', field: 'record.code', width: '120'},
        {displayName: 'Record UUID', field: 'record.uuid', width: '120'},
        {displayName: 'Record Id', field: 'recordId', width: '120'},
        {displayName: 'Commission', field: 'commission', width: '120'}
      ]
    };

    $scope.reset = function () {
      $scope.errorCount = 0;
      $scope.percent = 0;
      $scope.prePercent = 0;
      $scope.preprocessToResolve = 0;
      $scope.preprocessResolved = 0;
      $scope.entity = {};
      $scope.data = [];
      $scope.gridOptions.data = [];
      $scope.gridOptions.columnDefs = [];
      $scope.typeName = '';
      $scope.schemaDefinition = {};
      $scope.reportMessages = [];
      $scope.isEntitySelected;
    };

      //dati caricati da xls
    $scope.$watch(function( ) {
          return $scope.gridOptions.xlsData;
        },
      function( newValue, oldValue ) {
        if (newValue && newValue.length>0){
          $scope.checkData();
        }
      }
    );

    $scope.checkData = function () {
      dialogService.showLoadingMessage('Controllo dati...');
      console.log('Controllo e preprocesso i dati');
      /// $scope.gridOptions.xlsData ----> $scope.gridOptions.data

      $scope.gridOptions.columnDefs.splice(0, 0, { field: 'sixImportStatus' });

      var properties = $scope.schemaDefinition.model.schema.properties;
      var propertiesRequired = {};
      var lookups = [];
      var arrays = [];
      var numbers = [];
      var booleans = [];

      // carico i campi obbligatori
      if($scope.schemaDefinition.model.schema.required.length){
        $scope.schemaDefinition.model.schema.required.forEach(function(p){
          propertiesRequired[p] = properties[p];
        });
      }

      for(var key in properties) {
        if (properties[key]) {
          if (properties[key].format == 'lookup' && properties[key].entity_id) {
            lookups.push(key);
          } else if (properties[key].type == 'array') {
            arrays.push(key);
          } else if (properties[key].type == 'integer' || properties[key].type == 'number') {
            numbers.push(key);
          } else if (properties[key].type == 'boolean') {
            booleans.push(key);
          }
        }
      }

      function parseBoolean(value) {
        var lower = value.toLowerCase();
        return (lower === 'vero') || (lower === 'v')
          || (lower === 'true') || (lower === 't')
          || (lower === 'si') || (lower === 's');
      }

      var indexMapToResolve = {
        record: {}
      };

      $scope.gridOptions.xlsData.forEach(function(value){
        // uso un array per gestire l'assenza di uno o più campi -> per stampare un messaggio associato
        var stringWithPropertiesRequired = [];
        value['sixImportStatus']='OK';
        $scope.preprocessToResolve++; ///un po' così.... conto 1 per ogni record+ 1 per ogni lookup da risolvere...
        for(var l in lookups){
          (function() { //closure <3
            var k = lookups[l];
            var v = value[k];

            if(!angular.isUndefined(v)) {
              var mapToResolve = {};
              if (angular.isUndefined(properties[k].basePath)) {  // FIXME forse sarebbe meglio controllare gli attributi 'war' e 'entity_id'
                mapToResolve = indexMapToResolve.record;
              } else {
                if (properties[k].basePath in indexMapToResolve) {
                  mapToResolve = indexMapToResolve[properties[k].basePath];
                } else {
                  indexMapToResolve[properties[k].basePath] = {};
                  mapToResolve = indexMapToResolve[properties[k].basePath];
                }
              }

              if (properties[k].entity_id in mapToResolve) {
                var innerMap = mapToResolve[properties[k].entity_id];
                innerMap[v] = '';
              } else {
                mapToResolve[properties[k].entity_id] = {};
                var innerMap = mapToResolve[properties[k].entity_id];
                if(properties[k].hasOwnProperty('multiple') && properties[k].multiple == true){
                  // gestione lookup multipla
                  var arrayString = v;
                  var arrayLookup = [];
                  arrayString = arrayString.replace(new RegExp('"', 'g'), '');  // pulizia dai vari tipi di virgolette, in base alla formattazione..
                  arrayString = arrayString.replace(new RegExp('“', 'g'), '');
                  arrayString = arrayString.replace(new RegExp('”', 'g'), '');
                  arrayString = arrayString.replace(new RegExp(' ', 'g'), '');  // pulizia dagli spazi dei codici..
                  arrayString = arrayString.substring(arrayString.lastIndexOf("[")+1,arrayString.lastIndexOf("]")); // eliminazione []
                  if(arrayString.length > 0){
                    arrayLookup = arrayString.split(",");                     // creazione array con i 'code'
                    arrayLookup.forEach(function (vlookup){
                      innerMap[vlookup] = '';
                    });
                  }
                } else {
                  // gestione lookup singola
                  innerMap[v] = '';
                }
              }
            }
          })();
        }

        arrays.forEach(function(a) {
          if(value[a]) {
            value[a] = value[a].replace(/[“”']/g, '"');
            value[a] = JSON.parse(value[a]);
          }
        });

        numbers.forEach(function(n) {
          if(value[n]) {
            value[n] = parseFloat(value[n]);
          }
        });

        booleans.forEach(function(b) {
          if(value[b]) {
            value[b] = parseBoolean(value[b]);
          }
        });

        $scope.preprocessResolved++;
        $scope.updatePreprocessPercent();

        // controllo la presenza dei campi obbligatori
        for(var req in propertiesRequired){
          // controllo se non ha la proprietà, oppure se ce l'ha ma non è valorizzata o è uno spazio bianco...
          if(!value.hasOwnProperty(req) || (value.hasOwnProperty(req) && (!value[req] || value[req].trim().length == 0 ))){
            stringWithPropertiesRequired.push(req);
            $scope.errorCount++;
          }
        }
        // stampo un messaggio legato a quanti campi obbligatori non trovo
        if(stringWithPropertiesRequired.length == 1){
          value['sixImportStatus'] = stringWithPropertiesRequired[0] + ' non trovato;';
        } else if(stringWithPropertiesRequired.length > 1){
          value['sixImportStatus'] = stringWithPropertiesRequired.toString() + ' non trovati;';
        }
        $scope.gridOptions.data = $scope.gridOptions.data.concat( value );
      });

      // se non ci sono errori (tutti campi obbligatori presenti): risolvo le lookup
      if($scope.errorCount <= 0){
        $log.info(indexMapToResolve);
        for(var index in indexMapToResolve) {
          var mapToResolve = indexMapToResolve[index];
          var promise;
          if(index === 'record') {
            promise = recordFactory('type').bulkResolve(mapToResolve).$promise;
          } else if(index === 'pricelist') {
            promise = priceListFactory.bulkResolve(mapToResolve).$promise;
          }

          promise.then(function (data) {
            $log.info(data);
            $scope.gridOptions.xlsData.forEach(function (value) {
              if(index === 'record') {
                value['sixImportStatus'] = 'OK';
              }
              $scope.preprocessToResolve++; ///un po' così.... conto 1 per ogni record+ 1 per ogni lookup da risolvere...
              for (var l in lookups) {
                (function () { //closure <3
                  var k = lookups[l];
                  var v = value[k];
                  if (!angular.isUndefined(v) && v !== null) {
                    $scope.preprocessResolved++;
                    //$scope.updatePreprocessPercent();
                    var resolved = data[properties[k].entity_id];
                    if(resolved){
                      if(properties[k].hasOwnProperty('multiple') && properties[k].multiple == true){
                        // lookup multipla
                        value[k] = [];
                        for (var res in resolved) {
                          if (resolved.hasOwnProperty(res)) {
                            var ref = sixObjectLib.recordToHisRef(resolved[res]);
                            if (!ref) {
                              if (value['sixImportStatus'] == 'OK') value['sixImportStatus'] = '';
                              value['sixImportStatus'] = value['sixImportStatus'].concat(k + ' (' + properties[k].entity_id + ') array di lookup non risolto; ');
                              $scope.errorCount++;
                            } else {
                              value[k].push(ref);
                            }
                          }
                        }
                      } else {
                        var ref = sixObjectLib.recordToHisRef(resolved[v]);
                        if (!ref) {
                          if (value['sixImportStatus'] == 'OK') value['sixImportStatus'] = '';
                          value['sixImportStatus'] = value['sixImportStatus'].concat(k + ' (' + properties[k].entity_id + ') ' + v + ' non trovato; ');
                          $scope.errorCount++;
                        } else {
                          value[k] = ref;
                        }
                      }
                    }
                  }
                })();
              }
            });
          });
        }
      }

      dialogService.stopLoading();

    };

    $scope.updatePreprocessPercent = function () {
      $scope.prePercent = ($scope.preprocessResolved*1.0/ $scope.preprocessToResolve) * 100;
    };

    $scope.importData = function () {
      if ($scope.errorCount > 0){
        dialogService.dialog('Sono presenti errori', 'Impossibile importare i dati', 'warning', 4000, true);
        return;
      }
      dialogService.showLoadingMessage('Importazione...');
      $scope.importBusy = true;
      var counter = 0;

      $scope.data = [];

      $scope.gridOptions.data.forEach(function(value) {
        delete value['$$hashKey'];//questa è robaccia di uigrid
        delete value['sixImportStatus'];
        $scope.data = $scope.data.concat(value);
      });

      stopDummyUpdateProgressBar = false;
      updateDummyProgressBar();

      var history = 'stable';
      if($scope.schemaDefinition.model.history === true) {
        history = 'snap';
      }
      var commDep = false;
      if($scope.schemaDefinition.model.commissionDependent) {
        commDep = $scope.schemaDefinition.model.commissionDependent;
      }
      var custDep = false;
      if($scope.schemaDefinition.model.customerDependent) {
        custDep = $scope.schemaDefinition.model.customerDependent;
      }
      var promise;
      if($scope.typeName === 'zonatermica') {
          promise = zonaTermicaFactory.bulk($scope.data).$promise;
      } else {
        promise = recordFactory($scope.typeName ,history,commDep).bulkImport($scope.data).$promise;
        //promise = recordFactory().bulkResolve('record/_bulk/' + history + '/' + commDep + '/' + $scope.typeName).search($scope.data).$promise;
      }
      promise.then(function(response) {
        if (errorService.handleError(response)) {
          $scope.reportMessages = response.messages;
          stopDummyUpdateProgressBar = true;
          dialogService.stopLoading();
          if(response.status === 'errors') {
            toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
          } else {
            counter = $scope.data.length;
            $scope.percent = (counter / $scope.data.length) * 100;
          }
        } else {
          $scope.percent = 0;
          stopDummyUpdateProgressBar = true;
          toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
        }
      });
    };

    //cambio type
    $scope.$watch(function( ) {
                    return $scope.entity.type;
                      },
      function( newValue, oldValue ) {
        $scope.isEntitySelected = angular.isDefined(newValue);
        if(!$scope.isEntitySelected){
            $scope.reset();
        }
        if(newValue != oldValue) {
          $scope.importBusy = false;
          $scope.errorCount = 0;
          $scope.percent = 0;
          $scope.prePercent = 0;
          $scope.preprocessToResolve = 0;
          $scope.preprocessResolved = 0;
          $scope.gridOptions.xlsData = [];
          $scope.data = [];
          $scope.gridOptions.data = [];
          $scope.gridOptions.columnDefs = [];
          $scope.typeName = '';
          $scope.schemaDefinition = {};
          $scope.reportMessages = [];

          if ($scope.entity.type) {
            $scope.typeName = $scope.entity.type.UUID;

            //carico le definizioni dello schema
            dialogService.showLoadingMessage('Caricamento modello...');
            schemaFactory().byCode({id: $scope.typeName}).$promise.then(function (schemaDefinition) {
              setTimeout(function() {dialogService.stopLoading();}, 10);
              $scope.schemaDefinition = schemaDefinition;
              if (!schemaDefinition || !schemaDefinition.model || !schemaDefinition.model.schema.properties){
                dialogService.alert('Definizione modello non trovata o errata');
                return;
              }
            });

          }else{
            $scope.typeName ='';
          }

        }
    });


    /*************************************/
    // Template xlsx
    /*************************************/

    function buildDataType(prop) {
      if(prop.type === 'string' && prop.format === 'date') {
        return 'yyyy-MM-dd';
      }
      else if(prop.type === 'string' && prop.format === 'lookup') {
        return 'ref';
      }
      else if(prop.type === 'integer') {
        return 1;
      }
      else if(prop.type === 'number') {
        return 1.234;
      }
      else if(prop.type === 'object') {
        var obj = {};
        for(var key in prop.properties) {
          obj[key] = buildDataType(prop.properties[key]);
        }
        return JSON.stringify(obj);
      }
      return 'text';
    }

    function schemaDefinitionToSheet() {
      var ws = {};
      var range = {s: {c:10000000, r:10000000}, e: {c:0, r:0 }};
      var data = [[], []];

      if($scope.schemaDefinition.model.commissionDependent) {
        data[0].push("commission");
        data[1].push("text");
      }
      for(var key in $scope.schemaDefinition.model.schema.properties) {
        // Intestazione di colonna
        data[0].push(key);
        // Riga di esempio
        var prop = $scope.schemaDefinition.model.schema.properties[key];
        var example = 'text';
        if(prop.type === 'array') {
          if(!prop.items) {
            example = '[item1, item2]';
          }
          else {
            example = '['+buildDataType(prop.items)+','+buildDataType(prop.items)+']';
          }
        }
        else {
          example = buildDataType(prop);
        }
        data[1].push(example);
      }

      for(var R = 0; R != data.length; ++R) {
        for(var C = 0; C != data[R].length; ++C) {
          if(range.s.r > R) range.s.r = R;
          if(range.s.c > C) range.s.c = C;
          if(range.e.r < R) range.e.r = R;
          if(range.e.c < C) range.e.c = C;
          var cell = {v: data[R][C] };
          if(cell.v == null) continue;
          var cell_ref = XLSX.utils.encode_cell({c:C,r:R});

          if(typeof cell.v === 'number') cell.t = 'n';
          else if(typeof cell.v === 'boolean') cell.t = 'b';
          else if(cell.v instanceof Date) {
            cell.t = 'n'; cell.z = XLSX.SSF._table[14];
            cell.v = datenum(cell.v);
          }
          else cell.t = 's';

          ws[cell_ref] = cell;
        }
      }
      if(range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
      return ws;
    }

    function Workbook() {
      if(!(this instanceof Workbook)) return new Workbook();
      this.SheetNames = [];
      this.Sheets = {};
    }

    function datenum(v, date1904) {
      if(date1904) v+=1462;
      var epoch = Date.parse(v);
      return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
    }

    $scope.schemaDefinitionToXlsx = function() {
      //var ranges = oo[1];

      /* original data */
      var ws_name = $scope.entity.type.UUID;

      var wb = new Workbook();
      var ws = schemaDefinitionToSheet();

      /* add ranges to worksheet */
      //ws['!merges'] = ranges;

      /* add worksheet to workbook */
      wb.SheetNames.push(ws_name);
      wb.Sheets[ws_name] = ws;

      var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:false, type: 'binary'});

      saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), $scope.entity.type.UUID+".xlsx")
    };

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }





    // fa avanzare la progress bar a caso, giusto per far vedere che sta facendo qualcosa
    var stopDummyUpdateProgressBar = false;
    function updateDummyProgressBar() {
      if($scope.percent < 100 && stopDummyUpdateProgressBar === false) {
        $timeout(function() {
          if(stopDummyUpdateProgressBar === false) {
            $scope.percent += ($scope.percent < 90) ? Math.random() * 5 : 0;  // appena supero il 90% mi fermo e attendo che qualcuno lo porti a 100%
            if ($scope.percent < 100) {
              updateDummyProgressBar();
            }
          }
        }, Math.random()*2000);
      }
    }


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'record';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };

  });

'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:MappingDetailCtrl
 * @description
 * # MappingDetailCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset')
.config(function ($routeProvider) {
  $routeProvider
  .when('/mapping/:uuid', {
        templateUrl: 'dataset/rolemapping/mappingdetail.html',
        controller: 'MappingDetailCtrl'
      });
  })
  .controller('MappingDetailCtrl', function (APP_URL, $scope, authFactory, $location, sysConfigFactory, $routeParams, toaster, ENV, DEV) {

    var TYPE = 'rolemapping';

    $scope.mapping = { model: { emma_role_id: undefined, ldap_groups: [] } };

    function loadMapping(uuid) {
      sysConfigFactory(TYPE).byUUID({id: uuid}).$promise.then(function(response) {
        if (response && response.model) {
          $scope.mapping = response;
        } else {
          toaster.pop('error', 'Errore', 'Errore durante il caricamento del dato \'' + uuid + '\'');
        }
      });
    }

    $scope.update = function() {
      var params = {
        commission_dependent: false,
        customer_dependent:   false,
        history:              false
      };
      if($scope.mapping.version) {
        sysConfigFactory(TYPE).update({id: $scope.mapping.version, history: false}, $scope.mapping).$promise.then(function(response) {
          toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
          $scope.goToMappingList();
        });
      } else {
        $scope.mapping.model.code = sixObjectLib.makeGUID();
        $scope.mapping.model.description = 'Mapping per il ruolo ' + $scope.mapping.model.emma_role_id.description;
        sysConfigFactory(TYPE).create(params, $scope.mapping.model).$promise.then(function (response) {
          toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
          $scope.goToMappingList();
        });
      }
    };

    $scope.clearLdapGroup = function() {
      $scope.mapping.model.ldap_groups = [];
    };

    $scope.goToMappingList = function() {
      $location.path('mapping');
    };

    // ***** _main ***** //
    if($routeParams.uuid !== 'new') {
      loadMapping($routeParams.uuid);
    } else {
      $scope.mapping = { model: { emma_role: undefined, ldap_groups: [] } };
    }

  });


'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:MappingCtrl
 * @description
 * # MappingCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset')
.config(function ($routeProvider) {
  $routeProvider
  .when('/mapping', {
        templateUrl: 'dataset/rolemapping/mappinglist.html',
        controller: 'MappingCtrl'
      });
  })
  .controller('MappingCtrl', function (APP_URL, $scope, authFactory, sysConfigFactory, $routeParams, $location, sixGridPaginationConstants, uiGridConstants, ENV, DEV) {

    $scope.rows = { list: [], totalResults: 0 };

    $scope.params = {
      pageNumber: 0,
      pageSize: 10,
      filters: {}
    };

    $scope.viewGridOptions = {
        enableFiltering: true,
        enableOrdering: true,
        showGridFooter: true,
        showColumnFooter: true,
        enableHorizontalScrollbar: 1
    };

    $scope.gridAppCallbacks = {};

    function initGridColumns() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 34,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents" style="text-align: center">' +
            '<a ng-href="#/mapping/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' +
              '<span class="fa fa-search"></span>' +
            '</a>' +
          '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Emma',
        field: 'model.emma_role_id.description',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'LDAP',
        field: 'model.ldap_role',
        enableFiltering:true,
        cellTemplate:
          '<div class="ui-grid-cell-contents" style="text-align: center">' +
            '<span>{{grid.appScope.concatLdapGroups(row.entity.model.ldap_groups)}}</span>' +
          '</div>',
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
    }

    $scope.getList = function() {
      var payload = {
        page: $scope.params.pageNumber,
        page_size: $scope.params.pageSize,
        cross: true,
        history: false
      };
      sysConfigFactory('rolemapping').search(payload, $scope.params.filters).$promise.then(function(result) {
        $scope.rows.list = result.list || [];
        $scope.rows.totalResults = result.totalResults;
      });
    };

    $scope.concatLdapGroups = function(groups) {
      var concat = '';
      var sep = '';
      groups.forEach(function(g) {
        concat += sep + g.code;
        sep = '; ';
      });
      return concat;
    };
    $scope.gridAppCallbacks['concatLdapGroups'] = $scope.concatLdapGroups;

    $scope.goToNewMapping = function() {
      $location.path('mapping/new');
    };

    initGridColumns();
    // $scope.getList();

  });


'use strict';

/**
 * @ngdoc service
 * @name emma.dataset.baseFactory
 * @description
 * # baseFactory
 * Factory in the emma.dataset.
 */
angular.module('emma.dataset')
  .factory('sysConfigFactory', function (DATA_SET_URL, $resource) {
    return function(type, param1, param2) {
      return $resource(DATA_SET_URL + '/api/sysconfig/'+type+'/:verb/:id/:param1/:param2/:param3', {}, {
        query:  {method: 'GET', isArray: false, ignoreLoadingBar: true},
        lookup: {method: 'GET', isArray: false, params: {verb: '_lookup'}, ignoreLoadingBar: true},
        cross:  {method: 'GET', isArray: false, params: {verb: '_listcross'}, ignoreLoadingBar: true},
        byUUID: {method: 'GET', isArray: false, params: {verb: '_uuid', param1: '_current'}, ignoreLoadingBar: true},
        byDate: {method: 'GET', isArray: false, params: {verb: '_uuid'}, ignoreLoadingBar: true},
        byID:   {method: 'GET', isArray: false, params: {verb: '_id'}, ignoreLoadingBar: true},
        byCode: {method: 'GET', isArray: false, params: {verb: '_code'}, ignoreLoadingBar: true},
        getTimeline:   {method: 'GET', isArray: false, params: {verb: '_uuid', param1: param1}},
        search: {method: 'POST', isArray: false, params: {verb: '_search'}, ignoreLoadingBar: true},
        filter: {method: 'POST', isArray: false, params: {verb: '_search'}, ignoreLoadingBar: true},
        select: {method: 'GET', isArray: true, ignoreLoadingBar: true},
        create: {method: 'POST'},
        bulk:   {method: 'POST', isArray: true},
        bulkImport:      {method: 'POST', isArray: false, params: {verb: '_bulk', param1: param1, param2: param2}},
        bulkResolveMC:   {method: 'POST', isArray: false, params: {verb: '_bulk', param1: '_resolve', param2: '_multicommission'}},
        bulkResolve:     {method: 'POST', isArray: false, params: {verb: '_bulk', param1: '_resolve'}},
        show:   {method: 'GET', ignoreLoadingBar: true},
        update: {method: 'PUT', params: {id: '@version'}, ignoreLoadingBar: true},
        delete: {method: 'DELETE', params: {id: '@version'}, ignoreLoadingBar: true},
        check:  {method: 'GET', isArray: false, params: {verb: '_check'}},
        fixAll: {method: 'GET', isArray: false, params: {verb: '_fix', param1: 'all'}},
        unique: {method: 'GET', isArray: false, params: {verb: '_unique'}}
      });
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:TimelineCtrl
 * @description
 * # TimelineCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/timeline/:basePath/:entity/:UUID', {
        templateUrl: 'dataset/timeline/timeline.html',
        controller: 'TimelineCtrl'
      })
      .when('/timeline/:entity/:UUID', {
        templateUrl: 'dataset/timeline/timeline.html',
        controller: 'TimelineCtrl'
      })
  })
  .controller('TimelineCtrl', function ($scope, $routeParams, schemaFactory, authFactory, recordFactory) {

    var currentCommission = authFactory.getAuthData().info.commissions.current;

    $scope.model = {};

    $scope.timeline = [];

    var basePath = $routeParams.basePath || 'record';
    var schemaBasePath = $routeParams.basePath ? $routeParams.basePath + '/' : '';

    $scope.getTimeline = function () {
      if (angular.isDefined($routeParams.entity) && angular.isDefined($routeParams.UUID)) {
        $scope.buildTimeline($routeParams.entity, $routeParams.UUID);
      }
    };

    $scope.buildTimeline = function (entity, UUID, version) {
      $scope.entity = entity;
      $scope.timeline = recordFactory(entity, UUID).getTimeline().$promise.then(function (data) {
        $scope.timeline = data.list;
        if (angular.isDefined(version)) {
            $scope.model['version'] = version;
        }
      });
    };

    $scope.getModelDetail = function (version) {
      recordFactory($routeParams.entity, version).byID({id: version}).$promise.then(function (data) {
        $scope.dataModel = data.model;
        $scope.model.version = data.version;

        if(angular.isUndefined(data.dataOut) || data.dataOut==null){
            data.dataOut = "_current";
        }

        schemaFactory().getSchema({id: data.schemaCode, param1: data.dataOut}).$promise.then(function (response) {
            $scope.showDetail = true;
            $scope.schema = response.model.schema;
            $scope.form = response.model.form;
        });
      });
    };

    $scope.getTimeline();
  });

'use strict';

(function() {

  /**** CONSTANTS ****/

  var SCHEMA = 'schema';  // endpoint per le entity
  var TREE = 'tree';      // endpoint per i tree
  var RECORD = 'record';  // endpoint per le istanze di entity
  var PREFIX = 'def';     // prefisso del code del tree nell'indice
  var DEFAULT_DIALOG_TIMEOUT = 4000;
  var CHILDREN_FIELD_NAME = 'nodes';
  var PARENTS_FIELD_NAME = 'parents';
  var TREETYPE = 'definition';


  /**** COMMON FUNCTIONS ****/

  // Comparatore di oggetti record e schema
  var record2SchemaComparator = function(node1, node2) {
    if (node1 && node2 && node1.schemaCode === node2.model.code) {
      return true;
    }
    return false;
  };

  // Comparatore di oggetti record
  var record2RecordComparator = function(node1, node2) {
    if (node1 && node2 && node1.version === node2.version) {
      return true;
    }
    return false;
  };

  /**** ANGULAR ****/

  /**
   * @ngdoc function
   * @name emma.dataset.controller:TreeCtrl
   * @description
   * # TreeCtrl
   * Controller of the emma.dataset
   */
  var app = angular.module('emma.dataset');
  app.config(function ($routeProvider, treeConfig) {
      $routeProvider
        .when('/tree', {
            templateUrl: 'dataset/tree/tree.html',
            controller: 'TreeCtrl',
          controllerAs: 'treeController'
        })
        .when('/tree/:treeStructureId', {
            templateUrl: 'dataset/tree/tree.html',
            controller: 'TreeCtrl'
        })
        .when('/tree/:treeStructureId/:id', {
            templateUrl: 'dataset/tree/tree.html',
            controller: 'TreeCtrl'
        });

      treeConfig.defaultCollapsed = true; // collapse nodes by default
  });
  app.controller('TreeCtrl', function($scope, $routeParams, $location, treeFactory, recordFactory, schemaFactory, $filter, $log, authFactory, counterFactory,
                                      dialogService, treeService, modelIconService, errorService, toaster, pipeConfigurationTree, treePlanConfigFactory, $q, $timeout) {

    var currentCommission = authFactory.getAuthData().info.commissions.current;

    $scope.showRecordsList = false; // flag per mostrare/nascondere la lista dei record
    $scope.showDetails = false;     // flag per mostrare/nascondere i dettagli del record selezionato
    $scope.rightSidebarSize = '50';

    $scope.searchInput = {text: undefined};       // Oggetto che contiene i filtri di ricerca
    $scope.searchInputInTree = {text: undefined}; // Oggetto che contiene i filtri di ricerca nel tree

    $scope.tree = {
      wrapper: {model: {nodes: [], type: TREETYPE}},    // wrapper che arriva dall'endpoint che fornisce l'albero richiesto
      structure: {},   // struttura dell'albero creata tramite il tree configurator
      loaded: false,
      structureLoaded: false
    };

    $scope.treeCollapsed = true;

    $scope.records = {
      list: [],       // lista non filtrata delle entity ammesse nel nodo selezionato
      loaded: false
    };

    // Parametri di paginazione delle records
    $scope.pagination = {
      totalItems: 0,  // Numero di records in $scope.records.list
      currentPage: 1, // Pagina di navigazione correntemente visualizzata
      pageSize: 15,   // Numero di elementi per pagina da visualizzare
      noOfPages: 4    // Numero di pagine mostrate
    };

    $scope.commissionDependent = false;
    $scope.historyMode = 'snap';

    // Record da aggiungere "inline" da questa pagina
    $scope.record = {
      wrapper: {},      // wrapper che arriva dall'endpoint che fornisce l'albero richiesto
      type: {},         // tipo di record (schemaCode)
      model: {},        // valorizzazione del record
      schema: {},
      form: {},
      version: undefined,
      parent: undefined, // nodo in cui si sta cercando di aggiungere il record
      loaded: false
    };

    $scope.typeDescription = undefined;

    $scope.selected = {
      treeNode: undefined,  // Nodo dell'albero correntemente selezionato
      records: []           // Record correntemente selezionati (selezione multipla)
    };

    $scope.dropdownList = {
      roots: [],  // Lista delle radici che è possibile creare ex-novo
      nodes: []   // Lista dei nodi che è possibile creare ex-novo in base all'elemento del tree selezionato
    };

    $scope.selfGeneratedCode = {
      codeNameSix: '',
      active: false
    };


    $scope.isCustomerMissing = function(){
      var missing = $scope.app.profileCustomer && angular.isUndefined($scope.currentCustomer);
      return missing;
    };

    // records tree callbacks
    $scope.recordsOptions = {
      // Richiamata quando si cerca di trascinare un nodo in un punto dell'albero:
      // controlla se la destinazione può accettare il nodo
      accept: function (sourceNodeScope, destNodesScope, destIndex) {
        return false;
      },
      // Richiamata prima di iniziare il trascinamento
      beforeDrag: function (sourceNodeScope) {
        return $scope.isWritePermAllowed();
      },
      // Richiamata quando si inizia il trascinamento
      dragStart: function (event) {
        // Tolgo dal nodo tutte le info che non servono
      },
      // Richiamata quando si rilascia il nodo dopo il trascinamento
      dragStop: function (event) {
        $scope.addParentToChildren(event.dest.nodesScope.$parent.$modelValue, event.source.nodeScope.$modelValue);
        $scope.removeRecordFromSelection(event.source.nodeScope.$modelValue); // Se era selezionato lo rimuovo
        removeNodeFromRecordsList(event.source.nodeScope.$modelValue); // Rimuovo dalla lista dei record disponibili
        $scope.updateTree();
      }
    };

    // Tree tree callbacks
    $scope.treeOptions = {
      // Richiamata quando si cerca di trascinare un nodo in un punto dell'albero:
      // controlla se la destinazione può accettare il nodo
      accept: function (sourceNodeScope, destNodesScope, destIndex) {
        var destNode = undefined;
        if (destNodesScope.$nodeScope != undefined) {  // per evitare errori nel log
          destNode = destNodesScope.$nodeScope.$modelValue;
        }
        // il nodo è ammesso se è previsto nella struttura del tree e non è già stato inserito
        return isChildAllowed(sourceNodeScope.$modelValue, destNode);
      },
      beforeDrag: function (sourceNodeScope) {
        return $scope.isWritePermAllowed();
      },
      // Richiamata quando si inizia il trascinamento
      dragStart: function (event) {
        $scope.removeParentFromChild(event.dest.nodesScope.$parent.$modelValue, event.source.nodeScope.$modelValue);
      },
      // Richiamata quando si rilascia il nodo dopo il trascinamento
      dragStop: function (event) {
        $scope.addParentToChildren(event.dest.nodesScope.$parent.$modelValue, event.source.nodeScope.$modelValue);
        $scope.updateTree();
      }
    };

    // Rimuove un nodo dall'albero
    $scope.removeTreeNode = function (scope) {
      $log.info('remove ' + scope.index());
      if (scope.$modelValue.nodes.length === 0) {
        scope.remove();
        /* se è una configurazione devo eleminare anche l'elemento associato che abbiamo creato sull'indice di tipo 'configurazione' */
        if(scope.$parent.$modelValue.schemaCode = 'configurazione'){
          treePlanConfigFactory.deleteConfiguration({id: scope.$parent.$modelValue.UUID}).$promise.then(function() {
            console.log('Configuration deleted on index');
            if($scope.showDetails) {
              $scope.getRecordDetail(false, scope.$parent.$modelValue.parents[0].schemaCode, scope.$parent.$modelValue.parents[0].UUID);
            }
          });
        }
        addNodeToRecordsList(scope.$parent.$modelValue);
        $scope.updateTree();
      }
      else {
        // dialogService.dialog('Il nodo non è vuoto', '', 'warning', DEFAULT_DIALOG_TIMEOUT, true);
        dialogService.confirmDialog('Il nodo non è vuoto, eliminarlo ugualmente?', function() {
          scope.remove();
        }, function() {});
      }
    };


    // (De)Comprime i rami dell'albero
    $scope.toggleNode = function (scope) {
      scope.toggle();
    };

    $scope.toggleAll = function() {
      var scope = angular.element(document.getElementById("tree1-root")).scope();
      if($scope.treeCollapsed === false) {
        $scope.collapseAll();
        $scope.treeCollapsed = true;
      }
      else {
        $scope.expandAll();
        $scope.treeCollapsed = false;
      }
    };

    $scope.collapseAll = function () {
        $scope.$broadcast('angular-ui-tree:collapse-all');
    };

    $scope.expandAll = function () {
        $scope.$broadcast('angular-ui-tree:expand-all');
    };

    $scope.isNodeVisible = function(node) {
      if($scope.searchInputInTree.text && $scope.searchInputInTree.text !== '') {
        var expr = $scope.searchInputInTree.text.toLowerCase();
        return recursiveNodeSearch(node, expr, false);
      } else {
        return true;
      }
    };

    $scope.isRecordVisible = function(record) {
      if(angular.isUndefined($scope.searchInput) || angular.isUndefined($scope.searchInput.text)) {
        return true;
      }
      var search = angular.lowercase($scope.searchInput.text);
      if(angular.isDefined(record.model) && (record.model!=null)){
        if (angular.lowercase(record.model.code).includes(search)
          || (angular.lowercase(record.model.description) && angular.lowercase(record.model.description).includes(search))
          || angular.lowercase(record.schemaCode).includes(search)) {
          return true;
        }
      }
      return false;
    };

    function recursiveNodeSearch(node, expr, partialResult) {
      var found = partialResult;
      if(!found && node) {  // se l'ho già trovato ritorno subito true, altrimenti cerco ricorsivamente
        found = found || node.model.code.toLowerCase().includes(expr);
        found = found || node.model.description.toLowerCase().includes(expr);
        if (!found && node.nodes && node.nodes.length > 0) {
          node.nodes.forEach(function (child) {
            if (!found) {
              found = found || recursiveNodeSearch(child, expr, found);
            }
          });
        }
      }
      return found;
    }

    // utils

    // Salva o aggiorna l'albero nell'indice
    $scope.updateTree = function () {
      if ($scope.tree.wrapper.version) {
        treeFactory.update({id: $scope.tree.wrapper.version}, $scope.tree.wrapper)
          .$promise.then(function (data) {
            if(errorService.handleError(data)) {
              var model = $scope.tree.wrapper.model;
              $scope.tree.wrapper = data;
              $scope.tree.wrapper.model = model;
            } else {
              toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
            }
          });
      }
      else {
        $log.info(angular.toJson($scope.tree.wrapper.model));
        treeFactory.create($scope.tree.wrapper.model)
          .$promise.then(function (data) {
            if(errorService.handleError(data)) {
              var model = $scope.tree.wrapper.model;
              model.code = data.model.code;
              $scope.tree.wrapper = data;
              $scope.tree.wrapper.model = model;
            } else {
              toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
            }
          });
      }
    };

    // Cancella un albero dall'indice
    $scope.deleteTree = function () {
      treeFactory.delete({id: $scope.tree.wrapper.version})
        .$promise.then(function () {
          $scope.tree.wrapper = {model: { nodes: [] }};

          dialogService.dialog('Albero eliminato', '', 'success', DEFAULT_DIALOG_TIMEOUT, true);
        });
    };

    // Salva o aggiorna un record nell'indice
    $scope.updateRecord = function () {
      // gestione code tramite contatore di SIX, confermo il codice...
      if($scope.selfGeneratedCode.active == true){
        counterFactory.next({code: $scope.selfGeneratedCode.codeNameSix}).$promise.then(function (response) {
          if (response.errors){
            toaster.pop('error', 'Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + response.errors.error);
          } else {
            if(!$scope.record.model.code){ // se è ancora vuoto lo riempio
              $scope.record.model.code = response.next; // se è nuovo, confermo il codice...
            }
          }
          _update();
        });
      } else {
        _update();
      }
    };


    function _update() {
      if ($scope.record.version) {
        recordFactory($scope.record.type).update({id: $scope.record.version, history: $scope.historyMode==='snap'}, $scope.record.wrapper)
          .$promise.then(function (data) {
          $scope.record.wrapper = data;
          $scope.record.model = $scope.record.wrapper.model;
          $scope.selected.treeNode.model = $scope.record.wrapper.model;  // Aggiorno la visualizzazione nel tree

          dialogService.dialog('Record salvato', '', 'success', DEFAULT_DIALOG_TIMEOUT, true);
        });
      } else {
        recordFactory($scope.record.type).create({commissionDependent: $scope.commissionDependent, history: $scope.historyMode==='snap'}, $scope.record.model)
          .$promise.then(function (data) {
          $scope.record.wrapper = data;
          $scope.record.model = $scope.record.wrapper.model;
          $scope.record.wrapper.nodes = [];
          $scope.addNodesToParent($scope.record.parent, $scope.record.wrapper);
          $scope.updateTree();

          dialogService.dialog('Record salvato', '', 'success', DEFAULT_DIALOG_TIMEOUT, true);
        });
      }
    }

    // Aggiunge un nodo ad un padre
    $scope.addNodesToParent = function (parent, nodes) {
      var root = false;
      if(angular.isUndefined(parent)) {
        root = true;
      }
      parent = parent || $scope.tree.wrapper.model;

      if(parent && nodes && [].concat(nodes).length > 0) {

        // Controllo se i nodi sono già presenti nel tree
        var childrenToAdd = [];
        var alreadyAdded = [];
        [].concat(nodes).forEach(function(child) {
          if(treeService.findNodeInTree(child, $scope.tree.wrapper.model, record2RecordComparator) === undefined) {
            childrenToAdd.push(child);
            removeNodeFromRecordsList(child)
          } else {
            alreadyAdded.push(child);
          }
        });
        // Se ho trovato nodi già presenti nel tree li mostro in una dialog
        if(alreadyAdded.length > 0) {
          var msg = '';
          alreadyAdded.forEach(function(child) {
            msg += child.model.code + ' - ' + child.model.description + '<br/>';
          });
          dialogService.dialog('Nodi già presenti:', msg, 'warning', -1, false, 'left');
        }

        // Se ho nodi da aggiungere (non ancora presenti nel tree) li aggiungo
        if(childrenToAdd.length > 0) {
          if (treeService.addNodesToParent(parent, childrenToAdd, CHILDREN_FIELD_NAME)) {
            if (root === false) {
              $scope.addParentToChildren(parent, childrenToAdd);
            }
            $scope.updateTree();
            $scope.selected.records = [];
          }
          else {
            dialogService.dialog('Errore nell\'inserimento del riferimento al figlio', '', 'danger', DEFAULT_DIALOG_TIMEOUT, true);
          }
        }
      }
      else {
        dialogService.dialog('Nessun nodo selezionato', '', 'warning', DEFAULT_DIALOG_TIMEOUT, true);
      }
    };

    // Aggiunge i parent ai figli
    $scope.addParentToChildren = function(parents, children) {
      if(children && [].concat(children).length > 0 && parents && [].concat(parents).length > 0) {
        [].concat(children).forEach(function(child) {
          if(!child.parents) {
            child.parents = [];
          }
          if (!treeService.addNodesToParent(child, treeService.drainRecords(parents), PARENTS_FIELD_NAME)) {
            dialogService.dialog('Errore nell\'inserimento del riferimento al padre', '', 'danger', DEFAULT_DIALOG_TIMEOUT, true);
          }
        });
      }
    };

    // Rimuove il parent dal figlio
    $scope.removeParentFromChild = function(parent, child) {
      if(child && parent) {
        if(!child.parents) {
          child.parents = [];
        }
        child.parents.forEach(function (p, index) {
          if(p.version === parent.version) {
            child.parents.splice(index, 1);
          }
        });
      }
    };

    // Submit del form dettagli record
    $scope.onSubmitDetailForm = function (form) {
      // First we broadcast an event so all fields validate themselves
      $scope.$broadcast('schemaFormValidate');

      // Then we check if the form is valid
      if (form.$valid) {
        $scope.updateRecord();
      }
    };

    // Recupera i dettagli del record selezionato (o carica il form per inserirne uno nuovo)
    $scope.getRecordDetail = function (isRoot, entityType, id) {
      $scope.record.loaded = false;
      $scope.record.type = entityType;
      if (isRoot) {
        $scope.record.parent = $scope.tree.wrapper.model;
      }
      else {
        $scope.record.parent = $scope.selected.treeNode;
      }
      schemaFactory().byCode({id: $scope.record.type}).$promise.then(function (data) {
        $scope.record.wrapper = data;
        $scope.record.model = {};
        $scope.record.schema = data.model.schema;
        $scope.record.form = data.model.form;
        $scope.commissionDependent = data.model.commissionDependent;
        $scope.historyMode = data.model.history==true?'snap':'stable';
        if(data.model.selfGeneratedCode){
          $scope.selfGeneratedCode = data.model.selfGeneratedCode;
        } else {
          $scope.selfGeneratedCode = {  codeNameSix: '', active: false};
        }
        $scope.record.version = undefined;
        $scope.typeDescription = data.model.description;

        if($scope.record.type == 'configurazione'){
          // apro il caricamento della configurazione...
          $scope.openConfiguration();
          // mostro il pannello (abilito entrambe le variabili)...
          $scope.record.loaded = true;
          $scope.showDetails = true;
        } else {
          // se è un record lancio la chiamata per scaricare il dato...
          recordFactory($scope.record.type).byUUID({id: id}).$promise.then(function (data) {
            if (data.model) {
              $scope.record.wrapper = data;
              $scope.record.model = $scope.record.wrapper.model;
              $scope.record.version = $scope.record.wrapper.version;
              $scope.$broadcast('schemaFormRedraw');
            } else {
              /* scarico il codice della segnalazione dal contatore di SIX */
              if($scope.selfGeneratedCode.active == true){
                counterFactory.current({code: $scope.selfGeneratedCode.codeNameSix}).$promise.then(function (response) {
                  if (response.errors){
                    toaster.pop('error', 'Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + response.errors.error);
                  } else {
                    $scope.record.model.code = (parseInt(response.current)+1).toString();
                  }
                });
              }
            }
            if (!data.model && isRoot) {
              $scope.selected.treeNode = {schemaCode: 'root'};
            }
            // mostro il pannello (abilito entrambe le variabili)...
            $scope.record.loaded = true;
            $scope.showDetails = true;
          });
        }
      });
    };

    $scope.getTreeByUUID = function (treeId) {
      $scope.tree.loaded = false;
      return treeFactory.byUUID({id: treeId}).$promise.then(function (data) {
        if (data.version) {
          $scope.tree.wrapper = data;
        }
        else {
          $scope.tree.wrapper = {model: {nodes: [], type: TREETYPE}};
        }
        $scope.tree.loaded = true;
        $log.info($scope.tree.loaded);
      });
    };

    $scope.getTreeStructureByUUID = function (treeId) {
      $scope.tree.structureLoaded = false;
      return treeFactory.byUUID({id: treeId}).$promise.then(function (data) {
        if (data.model) {
          $scope.tree.structure = data.model.nodes;
          if ($scope.showRecordsList) {
            $scope.loadAllowedRecords();  // senza parametri parte dalla root
          }
          $scope.dropdownList.roots = $scope.getEntityChildsInTreeStructure(); // tutte le root
          $scope.dropdownList.nodes = angular.copy($scope.dropdownList.roots);
        }
        else {
          dialogService.dialog('ATTENZIONE', 'Nessuna struttura albero definita', 'warning', DEFAULT_DIALOG_TIMEOUT);
        }
        $scope.tree.structureLoaded = true;
      });
    };

    // Recupera un tree salvato
    $scope.getTree = function () {
      $scope.tree.loaded = false;
      var promise = treeFactory.getTreeDefinition().$promise;
      promise.then(function (data) {
        if (data.version) {
          $scope.tree.wrapper = data;
        }
        else {
          $scope.tree.wrapper = {model: {nodes: [], type: TREETYPE}};
        }
        $scope.tree.loaded = true;
      });
      return promise;
    };

    // Recupera la struttura dell'albero realizzata con il tree configurator
    $scope.getTreeStructure = function () {
      return treeFactory.getTreeStructure().$promise.then(function (data) {
        if (data.model) {
          $scope.tree.structure = data.model.nodes;
          if ($scope.showRecordsList) {
            $scope.loadAllowedRecords();  // senza parametri parte dalla root
          }
          $scope.dropdownList.roots = $scope.getEntityChildsInTreeStructure(); // tutte le root
          $scope.dropdownList.nodes = angular.copy($scope.dropdownList.roots);
        }
        else {
          dialogService.dialog('ATTENZIONE', 'Nessuna struttura albero definita', 'warning', DEFAULT_DIALOG_TIMEOUT);
        }
      });
    };

    $scope.selectAllFromRecordsList = function() {
      $scope.selected.records = $filter('recordsSearchFilter')($scope.records.list, $scope.searchInput.text);
    };

    $scope.unselectAllFromRecordsList = function() {
      $scope.selected.records = [];
    };

    // De/Seleziona un record (lista di sinistra)
    $scope.toggleRecordSelection = function (node) {
      if (node === undefined) {
        $scope.selected.records = [];
      }
      else {
        if ($scope.isRecordSelected(node)) {
          $scope.removeRecordFromSelection(node);
        }
        else {
          $scope.selected.records.push(node);
        }
      }
    };

    // Deselezione il record
    $scope.removeRecordFromSelection = function (node) {
      if ($scope.selected.records && node) {
        $scope.selected.records.forEach(function (elem, index) {
          if (node.version === elem.version) {
            $scope.selected.records.splice(index, 1);
            return;
          }
        });
      }
    };

    // Seleziona un nodo dell'albero
    $scope.selectNode = function (node) {
      if (node === undefined) {
        if($scope.showRecordsList && angular.isDefined($scope.selected.treeNode)) {
          $scope.loadAllowedRecords();
        }
        $scope.unselectRecord();
        $scope.dropdownList.nodes = angular.copy($scope.dropdownList.roots);
        $scope.showRecordsList = true;
      }
      else {
        if($scope.showRecordsList && (angular.isUndefined($scope.selected.treeNode) || node.UUID != $scope.selected.treeNode.UUID)) {
          $scope.loadAllowedRecords(node);
        }
        if($scope.showDetails && (angular.isUndefined($scope.selected.treeNode) || node.UUID != $scope.selected.treeNode.UUID)) {
          $scope.getRecordDetail(false, node.schemaCode, node.UUID);
        }
        $scope.selected.treeNode = node;
        $scope.selected.records = [];
        $scope.dropdownList.nodes = $scope.getEntityChildsInTreeStructure(node);
      }
    };

    // Deseleziona il nodo selezionato
    $scope.unselectRecord = function () {
      $scope.record = {
        wrapper: {},
        type: {},
        version: undefined,
        schema: {},
        model: {},
        form: {},
        parent: $scope.tree.wrapper.model
      };
      $scope.selected.treeNode = undefined;
      $scope.selected.records = [];
      $scope.dropdownList.nodes = $scope.getEntityChildsInTreeStructure();
    };

    $scope.loadAllowedRecords = function (parent) {
      $scope.records.list = [];
      $scope.records.loaded = false;
      var parentId = angular.isDefined(parent) ? parent.UUID : undefined;
      // rest: six-data-set/api/tree/_allowedChilds/{tree_config_id}/{tree_id}/{parent_id}?dublicates_allowed=[true,false]
      return treeFactory.allowedChilds({ id: currentCommission.code, // tree_config_id
                                  param1: $scope.tree.wrapper.UUID, // tree_id
                                  param2: parentId,  // parent_id
                                  duplicates_allowed: false})
        .$promise.then(function (data) {
          addNodeToRecordsList(treeService.drainRecords(data.list));
          $scope.records.loaded = true;
        });
    };

    // Restituisce i possibili nodi figli (entity) di un parent
    $scope.getEntityChildsInTreeStructure = function (parent) {
      if (parent === undefined) { // root
        return $scope.tree.structure;
      }
      var node = treeService.findNodeInTree(parent, {nodes: $scope.tree.structure}, record2SchemaComparator);
      if (!angular.isUndefined(node)) {
        return node.nodes;
      }
      return undefined;
    };

    // Controlla se un figlio è ammissibile per un nodo
    var isChildAllowed = function (sourceNode, destNode) {
      var allowedChildren = $scope.getEntityChildsInTreeStructure(destNode);
      if (allowedChildren != undefined) {
        var allowed = false;
        allowedChildren.forEach(function (item) {
          if (item.model.code == sourceNode.schemaCode) {
            allowed = true;
          }
        });
        return allowed;
      }
    };

    // Aggiunge un array di nodi alla lista dei records
    function addNodeToRecordsList(nodes) {
      if(angular.isUndefined($scope.records.list)) {
        $scope.records.list = [];
      }
      $scope.records.list = $scope.records.list.concat(nodes);
    }

    // Rimuove un nodo dalla lista dei records
    function removeNodeFromRecordsList(node) {
      if(angular.isDefined($scope.records.list)) {
        var pos = $scope.records.list.indexOf(node);
        if (~pos) $scope.records.list.splice(pos, 1);
      }
    }

    // Mostra/nascondi la lista di record a sinistra
    $scope.toggleRecordsList = function () {
      $scope.showRecordsList = !$scope.showRecordsList;
    };

    // Mostra/nascondi dettagli
    $scope.toggleDetails = function () {
      $scope.showDetails = !$scope.showDetails;
      // se è da visualizzare, allora lancio la chiamata per scaricare il dato...
      if($scope.showDetails == true){
        $scope.getRecordDetail(false, $scope.selected.treeNode.schemaCode, $scope.selected.treeNode.UUID);
      } else {
        // altrimenti pulisco la variabile del panel di destra...
        $scope.record = {
          wrapper: {},
          type: {},
          model: {},
          schema: {},
          form: {},
          version: undefined,
          parent: undefined,
          loaded: false
        };
      }
    };

    $scope.$watch('showRecordsList', function () {
      if($scope.showRecordsList) {
        $scope.loadAllowedRecords($scope.selected.treeNode);  // senza parametri parte dalla root
      }
    });

    // Recuper l'icona del model da menu
    $scope.getModelIcon = function (modelName) {
      var icon = modelIconService.getModelIcon(modelName) || 'fa fa-circle-o';
      return icon;
    };

    // Necessario per evitare deselezione (solo a livello html) del nodo selezionato ogni volta che viene
    // ridisegnato l'albero (i riferimenti cambiano)
    $scope.isNodeSelected = function (node) {
      if ($scope.selected.treeNode && node) {
        return record2RecordComparator(node, $scope.selected.treeNode);
      }
      return false;
    };

    $scope.isRecordSelected = function (node) {
      var selected = false;
      if ($scope.selected.records && node) {
        $scope.selected.records.forEach(function (elem) {
          if (record2RecordComparator(node, elem)) {
            selected = true;
          }
        });
      }
      return selected;
    };

    // Restituisce il path sottoforma di array
    $scope.getNodePath = function (node) {
      if (node) {
        var res = treeService.getNodePath(node, {nodes: $scope.tree.wrapper.model.nodes}, record2RecordComparator, 'nodes');
        if (res && res.length > 1) {
          return res.slice(1);  // La root è solo un contenitore senza code e description
        }
      }
      return [];
    };

    $scope.concatFields = function(item) {
      return item.model.code + item.model.description;
    };

    $scope.saveConfigurationOnTree = function(resp) {
      var obj = {
        schemaVersion: resp.schemaVersion,
        schemaCode: resp.schemaCode,
        model: {
          code: resp.model.code,
          description: resp.model.description
        },
        UUID: resp.UUID,
        version: resp.version,
        parents: [],
        nodes: []
      };
      $scope.addNodesToParent($scope.record.parent, obj);
    };

    $scope.updateConfigurationOnTree = function(resp) {
      dialogService.dialog('Configurazione salvata', '', 'success', DEFAULT_DIALOG_TIMEOUT, true);
    };

    $scope.openConfiguration = function() {
      var ref = {};
      if($scope.selected.treeNode.schemaCode == 'configurazione'){  /* apertura di uno già esistente */
        pipeConfigurationTree.pushTreeIdToConfig($scope.selected.treeNode.UUID);
      } else{ /* gestione per un tipo di dato diverso da 'configurazione' */
        if($scope.record.parent.UUID){   /* se ho selezionato un nodo */
          ref = {
            UUID: $scope.selected.treeNode.UUID,
            code: $scope.selected.treeNode.model.code,
            description: $scope.selected.treeNode.model.description
          };
        } else{  /* se è la root */
          ref = {
            UUID: null,
            code: $scope.selected.treeNode.model.code,
            description: 'Root'
          };
        }
        pipeConfigurationTree.pushTreeObjToConfig(ref);
      }
    };

    $scope.toggleRightSidebarSize = function(){
      $scope.rightSidebarSize = $scope.rightSidebarSize == '50' ? '100' : '50';
    };

    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'tree';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };

    $scope.isWriteRecordPermAllowed = function() {
      return authFactory.isWritePermAllowed('record/{entity}');
    };


    // Route: tree/treeStructureId/id

    $scope.currentCustomer = authFactory.getCurrentCustomer();

    if ($routeParams.id) {
        $scope.getTreeByUUID($routeParams.id);
    }
    else {
        if($scope.isCustomerMissing()){
            dialogService.alert('Selezionare un cliente.', 4000);
        }
        else{
          $scope.getTree();
        }
    }
    if ($routeParams.treeStructureId) {
        $scope.getTreeStructureByUUID($routeParams.treeStructureId);
    }
    else {
        if($scope.isCustomerMissing()){
            dialogService.alert('Selezionare un cliente.', 4000);
        }
        else{
          $scope.getTreeStructure();
        }
    }
  });



  /**** FILTERS ****/

  app.filter('recordsSearchFilter', function () {
    return function (input, search, destList) {
      if (search) {
        var lower = angular.lowercase(search);
        var output = [];
        input.forEach(function (node) {
          if(angular.isDefined(node.model) && (node.model!=null)){
            if (angular.lowercase(node.model.code).includes(lower)
              || (angular.lowercase(node.model.description) && angular.lowercase(node.model.description).includes(lower))
              || angular.lowercase(node.schemaCode).includes(lower)) {
              output.push(node);
            }
          }
        });
        if (destList) {
          destList = output;
        }
        return output;
      }
      else {
        return input;
      }
    };
  });
})();

'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:TreeConfiguratorCtrl
 * @description
 * # TreeConfiguratorCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset')
  .config(function ($routeProvider) {
      $routeProvider
      .when('/treeconfigurator', {
        templateUrl: 'dataset/tree/treeconfigurator.html',
        controller: 'TreeConfiguratorCtrl'
      })
      .when('/treeconfigurator/:id', {
        templateUrl: 'dataset/tree/treeconfigurator.html',
        controller: 'TreeConfiguratorCtrl'
      })
  })
  .controller('TreeConfiguratorCtrl', function ($scope, $routeParams, $location, treeFactory, treeService, schemaFactory,
                                                $filter, $log, authFactory, dialogService, modelIconService, errorService) {

    var DEFAULT_DIALOG_TIMEOUT = 4000;
    var TREETYPE = 'structure';

    var currentCommission = authFactory.getAuthData().info.commissions.current;

    $scope.tree = {
      wrapper: {model: {nodes: [], type: TREETYPE}}  // wrapper che arriva dall'endpoint che fornisce l'albero richiesto
    };

    $scope.entities = {
      list: [],           // lista non filtrata delle entity
      filteredList: [],   // lista delle entity filtrata (serve a evitare problemi con drag&drop sotto paginazione)
      originalFilteredList: []  // lista delle entity filtrata originale (ogni volta che faccio drag&drop
                                // da filteredList il nodo viene cancellato => serve a ripristinare i nodi)
    };

    // Parametri di paginazione delle entities
    $scope.pagination = {
      totalItems: 0,
      currentPage: 1,
      pageSize: 10,
      noOfPages: 0
    };

    // angular-ui-tree

    // Callbacks
    $scope.entitiesOptions = {
      // Richiamata quando si cerca di trascinare un nodo in un punto dell'albero:
      // controlla se la destinazione può accettare il nodo
      accept: function(sourceNodeScope, destNodesScope, destIndex) {
        return false;
      },
      // Richiamata prima di iniziare il trascinamento
      beforeDrag: function(sourceNodeScope) {
        // Per evitare che la paginazione incasini gli index, recupero a mano la entity dalla lista completa (filtrata e non paginata)
        sourceNodeScope.$modelValue = angular.copy($scope.entities.filteredList[sourceNodeScope.index()+($scope.pagination.currentPage-1)*$scope.pagination.pageSize]);
        if (!sourceNodeScope.$modelValue.nodes) {
          sourceNodeScope.$modelValue.nodes = [];
        }
        return $scope.isWritePermAllowed();
      },
      // Richiamata quando si inizia il trascinamento
      dragStart: function (event) {
        // Tolgo dal nodo tutte le info che non servono
        event.source.nodeScope.$modelValue = treeService.drainRecords(event.source.nodeScope.$modelValue);
      },
      // Richiamata quando si rilascia il nodo dopo il trascinamento
      dragStop: function(event) {
        // Rigenera la lista delle entities (gli elementi trascinati spariscono => li ripristino)
        $scope.entities.filteredList = angular.copy($scope.entities.originalFilteredList);
      }
    };

    // Tree tree callbacks
    $scope.treeOptions = {
      // Richiamata quando si cerca di trascinare un nodo in un punto dell'albero:
      // controlla se la destinazione può accettare il nodo
      accept: function(sourceNodeScope, destNodesScope, destIndex) {
        var destNode = $scope.tree;
        if(destNodesScope.$nodeScope != undefined) {  // per evitare errori nel log
          destNode = destNodesScope.$nodeScope.$modelValue;
        }
        var sourceNode = sourceNodeScope.$modelValue;
        // il nodo è ammesso se è previsto nella struttura del tree e non è già stato inserito
        return isChildAllowed(sourceNodeScope.$modelValue, destNode);
      },
      beforeDrag: function(sourceNodeScope) {
        return $scope.isWritePermAllowed();
      }
    };

    // Rimuove un nodo dall'albero
    $scope.remove = function(scope) {
      scope.remove();
    };

    // (De)Comprime i rami dell'albero
    $scope.toggle = function(scope) {
      scope.toggle();
    };


    // utils

    // Salva o aggiorna l'albero nell'indice
    $scope.saveForm = function() {
      if($scope.isCustomerMissing()){
        dialogService.alert('Selezionare un cliente per abilitare il salvataggio.', 4000);
      }
      else{
        if ($scope.tree.wrapper.version) {
          treeFactory.update({id: $scope.tree.wrapper.version}, $scope.tree.wrapper).$promise
            .then(function(data) {
              if(errorService.handleError(data)) {
                //$scope.tree.wrapper = data;
                dialogService.dialog('Salvato', '', 'success', DEFAULT_DIALOG_TIMEOUT, true);
              } else {
                toaster.pop('error', 'Errore', 'Errore nel salvataggio');
              }
            });
        }
        else {
          //var treeObj = {nodes: $scope.tree.wrapper.model.nodes, type: 'structure'};
          var treeObj = $scope.tree.wrapper.model;
          $log.info(angular.toJson(treeObj));
          treeFactory.create(treeObj).$promise
            .then(function(data) {
              if(errorService.handleError(data)) {
                var model = $scope.tree.wrapper.model;
                model.code = data.model.code;
                $scope.tree.wrapper = data;
                $scope.tree.wrapper.model = model;
                dialogService.dialog('Salvato', '', 'success', DEFAULT_DIALOG_TIMEOUT, true);
              } else {
                toaster.pop('error', 'Errore', 'Errore nel salvataggio');
              }
            });
        }
      }
    };

    // Cancella un albero dall'indice
    $scope.delete = function() {
      treeFactory.delete({id: $scope.tree.wrapper.version}).$promise
        .then(function() {
          $scope.tree.wrapper = {};
          $location.path('/treeconfigurator/new');

          dialogService.dialog('Eliminato', '', 'success', DEFAULT_DIALOG_TIMEOUT, true);
        });
    };

    // Recupera la lista delle entities (nodi) da inserire nel tree
    $scope.getEntities = function (query) {
      schemaFactory().query({query: $scope.queryParam, show_version: false, page: 1, page_size: 10000}).$promise
        .then(function (data) {
          $scope.entities.list = data.list;
          $scope.entities.filteredList = angular.copy($scope.entities.list);
          $scope.entities.originalFilteredList = angular.copy($scope.entities.list);
          $scope.pagination.totalItems = $scope.entities.list.length;
          $scope.pagination.noOfPages = Math.ceil($scope.pagination.totalItems / $scope.pagination.pageSize);
        });
    };

    // Recupera un tree salvato
    $scope.getTreeByUUID = function (treeId) {
      treeFactory.byUUID({id: treeId}).$promise
        .then(function (data) {
          if(data.version) {
            $scope.tree.wrapper = data;
          }
        })
    };

    $scope.getTree = function () {
      treeFactory.getTreeStructure().$promise
        .then(function (data) {
          if(data.version) {
            $scope.tree.wrapper = data;
          }
        })
    };

    // Crea una lista filtrata: serve per risolvere i problemi di drag&drop sotto paginazione
    $scope.$watch('entitySearch', function (newVal, oldVal) {
      // devo filtrare la lista per pescare correttamente il node da trascinare dalla lista paginata delle entity
      if(newVal && newVal !== '') {
        $scope.entities.filteredList = $filter('filter')($scope.entities.list, function (input) {
          return angular.lowercase(input.model.code).includes($scope.entitySearch) || angular.lowercase(input.model.description).includes($scope.entitySearch);
        });
      }
      else {
        $scope.entities.filteredList = angular.copy($scope.entities.list);
      }
      $scope.entities.originalFilteredList = angular.copy($scope.entities.filteredList);
    }, true);

    $scope.getModelIcon = function(modelName) {
      var icon = modelIconService.getModelIcon(modelName) || 'fa fa-list';
      return icon;
    };

    var isChildAllowed = function(node, parent) {
      for(var index in parent.nodes) {
        var n = parent.nodes[index];
        if(node.model.code === n.model.code) {
          return false;
        }
      }
      return true;
    };

    $scope.isCustomerMissing = function(){
      var missing = $scope.app.profileCustomer && angular.isUndefined($scope.currentCustomer);
      return missing;
    }

    //___main___
    $scope.getEntities();

    if($routeParams.id) {
      $scope.getTreeByUUID($routeParams.id);
    }
    else {
      if($scope.app.profileCustomer){
        $scope.currentCustomer = authFactory.getCurrentCustomer();
        if(angular.isDefined($scope.currentCustomer)){
          if(angular.isDefined($scope.currentCustomer)){
            treeFactory.getStructureCode().$promise.then(function (data) {
              $scope.getTree();
            });
          }
        }
      }
      else{
        $scope.getTree();
      }
    }


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'tree';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };
  });

// Default:
// {
//   'get':    {method:'GET'},
//   'save':   {method:'POST'},
//   'query':  {method:'GET', isArray:true},
//   'remove': {method:'DELETE'},
//   'delete': {method:'DELETE'}
// }
angular.module('emma.dataset')
  .factory('treeFactory', function (DATA_SET_URL, $resource) {
    return $resource(DATA_SET_URL + '/api/tree/:verb/:id/:param1/:param2/:param3', {}, {
      create:   {method: 'POST', params: {id: '@version'}},
      byUUID:   {method: 'GET', params: {verb: '_uuid', param1: '_current'}},
      update:   {method: 'PUT', params: {id: '@version'}},
      delete:   {method: 'DELETE', params: {id: '@version'}},
      allowedChilds:    {method: 'GET', params: {verb: '_allowedChilds'}},
      nodeSchemasList:  {method: 'GET', params: {verb: '_flat', param1: '_lookup'}},
      getStructureCode:    {method: 'GET', params: {verb: '_structure', param1: '_code'}},
      getDefinitionCode:    {method: 'GET', params: {verb: '_definition', param1: '_code'}},
      getTreeStructure:    {method: 'GET', params: {verb: '_structure', param1: '_current'}},
      getTreeDefinition:    {method: 'GET', params: {verb: '_definition', param1: '_current'}}
    });
});

'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:TreeplanconfigCtrl
 * @description
 * # TreeplanconfigCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/treeplanconfig', {
        templateUrl: 'dataset/tree/treeplanconfig.html',
        controller: 'TreeplanconfigCtrl'
      })
  })
  .controller('TreeplanconfigCtrl', function ($scope, schemaFactory, recordFactory, pipeConfigurationTree, treePlanConfigFactory, toaster, $log) {


    $scope.typeProfilingFilter = { 'model.code' : 'azienda, fornitore, operatore, segreteria' };

    $scope.availableTypeOperatorList = [
      {
        description: 'Responsabile esterno',
        key: 'responsabile_esterno',
        filters: {'typeoperator_id_1': sixFiltersLib.exact('model.typeoperator_id.code', 'tecnico_esterno')}
      },
      {
        description: 'Responsabile interno',
        key: 'responsabile_interno',
        filters: {'typeoperator_id_1': sixFiltersLib.exact('model.typeoperator_id.code', 'tecnico_commessa')}
      },
      {
        description: 'Capo commessa',
        key: 'capo_commessa',
        filters: {'typeoperator_id_1': sixFiltersLib.exact('model.typeoperator_id.code', 'capo_commessa')}
      },
      {
        description: 'Tecnico commessa',
        key: 'tecnico_commessa',
        filters: {'typeoperator_id_1': sixFiltersLib.exact('model.typeoperator_id.code', 'tecnico_commessa')}
      },
      {
        description: 'Manutentore',
        key: 'manutentore',
        filters: {'typeoperator_id_1': sixFiltersLib.exact('model.typeoperator_id.code', 'manutentore')}
      }
    ];

    $scope.insertNewRowAssignee = {};
    $scope.insertNewRowDefault = {};
    $scope.insertNewRowResponsable = {};
    $scope.insertNewWatcher = {};

    $scope.selected = {
      model: {
        configuration: {
          assignee: [],
          default: [],
          responsable: [],
          watchers: {
            external: [],
            internal: []
          }
        }
      }
    };

    function assigneeIsNew (row) {  /* controllo se c'è già una riga uguale */
      var boolResult = true;
      for(var i = 0; i < $scope.selected.model.configuration.assignee.length; i++){
        if($scope.selected.model.configuration.assignee[i].service_id == row.service_id
        && $scope.selected.model.configuration.assignee[i].type_id == row.type_id
        && $scope.selected.model.configuration.assignee[i].typeprofiling_id == row.typeprofiling_id
        && $scope.selected.model.configuration.assignee[i].assignee_id == row.assignee_id){
          boolResult = false;
        }
      }
      return boolResult;
    }

    function defaultIsNew (row) {   /* controllo se c'è già una riga uguale */
      var boolResult = true;
      for(var i = 0; i < $scope.selected.model.configuration.default.length; i++){
        if($scope.selected.model.configuration.default[i].service_id == row.service_id
          && $scope.selected.model.configuration.default[i].type_id == row.type_id
          && $scope.selected.model.configuration.default[i].typeprofiling_id == row.typeprofiling_id
          && $scope.selected.model.configuration.default[i].assignee_id == row.assignee_id){
          boolResult = false;
        }
      }
      return boolResult;
    }

    $scope.addAssignee = function (row) {
      if(assigneeIsNew(row)){
        $scope.selected.model.configuration.assignee.push(angular.copy(row));
        emptyObject(row);
      } else {
        toaster.pop('info', 'Attenzione', 'Configurazione già inserita');
      }
    };

    $scope.delete = function (array, item) {
      var index = array.indexOf(item);
      $log.info('delete ' + index);
      if (index > -1) {
        array.splice(index, 1);
      }
    };

    $scope.deleteAssignee = function (row) {
      $log.info('deleteAssignee');
      $scope.delete($scope.selected.model.configuration.assignee, row);
    };

    $scope.addDefault = function (row) {
      if(defaultIsNew(row)){
        $scope.selected.model.configuration.default.push(angular.copy(row));
        emptyObject(row);
        toaster.pop('success', 'OK', 'Configurazione inserita tra quelle di default');
      } else {
        toaster.pop('info', 'Attenzione', 'Configurazione già inserita tra gli assegnatari di default');
      }

    };

    $scope.deleteDefault = function (row) {
      $log.info('deleteDefault');
      $scope.delete($scope.selected.model.configuration.default, row);
    };

    $scope.addResponsable = function (row){
      $scope.selected.model.configuration.responsable.push(angular.copy(row));
      emptyObject(row);
    };

    function clearDataEntry () {
      $scope.selected.model = {
        code: null,
        description: null,
        configuration:{
          assignee: [],
          responsable: [],
          default: [],
          watchers: {
            external: [],
            internal: []
          }
        }
      };
    }

    function emptyObject(obj) {
      for(var k in obj) {
        delete obj[k];
      }
      return obj;
    }

    function copyInnerProps(source, dest) {
      for(var k in source) {
        dest[k] = angular.copy(source[k]);
      }
      return dest;
    }

    /** PARTE WATCHERS */

    $scope.historyWatcher;

    $scope.editRow = function(row) {
      $scope.historyWatcher = angular.copy(row);
      row.edit = true;
    };

    $scope.restoreHistory = function(row) {
      copyInnerProps($scope.historyWatcher, row);
      row.edit = false;
    };

    $scope.confirmRow = function(row) {
      $scope.historyWatcher = undefined;
      row.edit = false;
    };

    $scope.addWatcher = function (row){
      if(row.internal == true){
        /* interno */
        $scope.selected.model.configuration.watchers.internal.push(row.lookup);
      } else if(row.external == true) {
        /* esterno */
        $scope.selected.model.configuration.watchers.external.push(row.mail);
      }
      /* pulisco la riga */
      emptyObject(row);
      $scope.newWatcher = false;
    };

    $scope.deleteWatcher = function (row){
      
    };

    $scope.getMailWatcher = function (row) {
      /* questa riga contiene il riferimento all'operatore da risolvere  */
      var mail = "";
      recordFactory(row.lookup.type).byUUID({id: row.lookup.UUID}).$promise.then(function (response){
        if(response.model['mail']){
          mail = response.model.mail;
        } else {
          mail = "Mail non recuperata";
        }
        return mail;
      });
    };


    /* nel caso la configurazione non abbia la parte dei watchers -> la impostiamo per aggiornare il dato */
    function fixWatchers (data) {
      if(!data.model.configuration.watchers){
        data.model.configuration.watchers = {
          internal: [],
          external: []
        }
      }
    }

    /** --- FINE PARTE WATCHERS --- */

    $scope.save = function () {
      if($scope.selected.UUID){
        treePlanConfigFactory.updateConfiguration({id: $scope.selected.UUID}, $scope.selected).$promise.then(function (response) {
          if(response.model){
            $scope.$parent.updateConfigurationOnTree(response);
          }
        });
      } else{
        treePlanConfigFactory.createConfiguration($scope.selected).$promise.then(function (response) {
          if(response){
            $scope.$parent.saveConfigurationOnTree(response);
          }
        });
      }
    };

    $scope.history;
    $scope.editRow = function(row) {
      $scope.history = angular.copy(row);
      row.edit = true;
    };

    $scope.restoreHistory = function(row) {
      copyInnerProps($scope.history, row);
      row.edit = false;
    };

    $scope.confirmRow = function(row) {
      $scope.history = undefined;
      row.edit = false;
    };


    /** --- CARICAMENTO CONFIGURAZIONI --- */

    $scope.$watch(['pipeConfigurationTree.treeObjToConfig.list'], function () {
      if(pipeConfigurationTree.treeObjToConfig.list.length != 0){
        var objConf = pipeConfigurationTree.popTreeObjToConfig();
        clearDataEntry();
        if((objConf != undefined) && (objConf != null)){
          $scope.selected.model.code = sixObjectLib.makeGUID();
          $scope.selected.model.description = 'Configurazione ' + objConf.description;
        } else{
          toaster.pop('error', 'Errore creazione configurazione', 'Codice configurazione non presente');
        }
      }
    });

    $scope.$watch(function() { return angular.toJson([pipeConfigurationTree.treeIdToConfig.list.length]); }, function () {
      if(pipeConfigurationTree.treeIdToConfig.list.length != 0){
        var idConf = pipeConfigurationTree.popTreeIdToConfig();
        clearDataEntry();
        if((idConf != undefined) && (idConf != null)){
          /* allora devo reperire la configurazione associata */
          treePlanConfigFactory.getConfigurationById({id: idConf}).$promise.then(function (response){
            if(response.model){
              $scope.selected = response;
              fixWatchers($scope.selected);
            }
          });
        } else{
          toaster.pop('error', 'Errore', 'Apertura configurazione non riuscita');
        }
      }
    }, true);
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.dataset.treeService
 * @description
 * # treeService
 * Service in the emma.dataset.
 */
angular.module('emma.dataset')
  .service('treeService', function () {

    // Deep first
    this.findNodeInTree = function(toFind, parent, comparatorFn, childrenFieldName) {
      childrenFieldName = childrenFieldName || 'nodes';

      for(var index in parent[childrenFieldName]) {
        var node = parent[childrenFieldName][index];
        if (comparatorFn(toFind, node)) {
          return node;
        }
        else {
          var res = this.findNodeInTree(toFind, node, comparatorFn, childrenFieldName);
          if(res !== undefined) {
            return res;
          }
        }
      }
      return undefined;
    };

    // Width first
    this.getNodePath = function(toFind, parent, comparatorFn, childrenFieldName) {
      childrenFieldName = childrenFieldName || 'nodes';

      var me = parent;

      // Se sono io...
      if (comparatorFn(toFind, me)) {
        return [me];
      }

      // ... altrimenti cerco ricorsivamente tra tutti i miei figli
      for(var index in me[childrenFieldName]) {
        var child = me[childrenFieldName][index];
        var subPath = this.getNodePath(toFind, child, comparatorFn, childrenFieldName);
        if(subPath && subPath.length > 0) {
          return [me].concat(subPath);
        }
      }
      return [];
    };

    // Aggiunge una lista di nodi ad un padre
    this.addNodesToParent = function(parent, nodes, childrenFieldName) {
      childrenFieldName = childrenFieldName || 'nodes';

      if(parent && nodes && [].concat(nodes).length > 0) {
        parent[childrenFieldName] = parent[childrenFieldName].concat(nodes);
        return parent;
      }
      else {
        return undefined;
      }
    };

    // "Snellisce" il nodo mantenendo soltanto gli attributi necessari
    this.drainRecords = function (originalObj) {
      var drainedList = [];
      var originals = [].concat(originalObj);
      originals.forEach(function (elem) {
        drainedList.push(
          {
            schemaVersion: elem.schemaVersion,
            schemaCode: elem.schemaCode,
            model: {
              code: elem.model.code,
              description: elem.model.description
            },
            UUID: elem.UUID,
            version: elem.version,
            parents: [],
            nodes: []
          }
        );
      });
      if (drainedList.length === 1) {
        return drainedList[0];
      }
      return drainedList;
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:UomCtrl
 * @description
 * # UomCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/uom/:id', {
        templateUrl: 'dataset/uom/uom_detail.html',
        controller: 'UomCtrl'
      })
      .when('/uom', {
        templateUrl: 'dataset/uom/uom_list.html',
        controller: 'UomCtrl'
      })
  })
  .controller('UomCtrl', function ($scope, $window, $location, $log, $routeParams, uomFactory, dialogService, toaster, authFactory) {


    $scope.model = {
      formula: undefined,
      inputName: undefined,
      uom_from: {
        uom: {},
        obj: ''
      },
      uom_to: {
        uom: {},
        obj: ''
      },
      record_id: {},
      constant_params:[],
      rounding_mode:'',
      precision:''

    };

    $scope.container_from = {obj: {}};

    $scope.container_to = {obj: {}};

    $scope.output = undefined;

    var DEFAULT_DIALOG_TIMEOUT = 4000;

    function buildPath(id) {
      return 'conversion/_id/'+id;
    }

    if($routeParams.id && 'new' !== $routeParams.id) {
      uomFactory.byID({id: $routeParams.id}).$promise.then(function (data) {
        $scope.model = data;
        if(angular.isUndefined($scope.model.record_id)){
            $scope.model.record_id = {};
        }
      });
    }

    $scope.newUom = function(){
        $location.path('uom/new');
    };

    $scope.saveForm = function() {
        if(!$scope.model.formula){
            toaster.pop('error', 'Errore', 'Nessuna formula inserita');
        }
        else{
            if(!$scope.model.uom_from.uom.UUID){
                toaster.pop('error', 'Errore', 'UM di partenza mancante');
            }
            else{
                if(!$scope.model.uom_to.uom.UUID) {
                    toaster.pop('error', 'Errore', 'UM di destinazione mancante');
                }
                else{
                    if($scope.verifyParameters()){
                        $scope.model.uom_from.obj = $scope.container_from.obj.model;
                        $scope.model.uom_to.obj = $scope.container_to.obj.model;
                        if($scope.model.code){
                            uomFactory.update({id: $scope.model.code}, $scope.model)
                            .$promise.then(function() {
                                $window.history.back();
                            });
                        } else{
                            uomFactory.create($scope.model)
                            .$promise.then(function() {
                                $window.history.back();
                            });
                        }
                    }
                }
            }
        }
    };

    $scope.deleteWithDialog = function (idToDelete) {
      dialogService.confirmDialog('Eliminare il record di ' + $scope.schemaDescription + ' \'' + $scope.model.code + '\'?',
        function () {
          $scope.delete(idToDelete);
        });
    };

    $scope.delete = function (idToDelete) {
      uomFactory.delete({id: $scope.model.code}).$promise.then(function() {
        $window.history.back();
      });
    };


    $scope.formChanged = function() {
      /* da implementare, è stato introdotto dalla select sugli arrotondamenti */
    };

    $scope.pageChanged = function () {
      $scope.listWrapper = uomFactory.query({query: $scope.queryParam, page: $scope.listWrapper.currentPage});
    };



    $scope.getListWrapper = function () {
      uomFactory.query({query: $scope.queryParam}).$promise.then(function(data) {
        $scope.listWrapper = data;
      });
    };

    $scope.getListWrapper();



    $scope.calculate = function(inputVal){
      if(inputVal === undefined){
        $scope.output = null;
        toaster.pop('warning', 'Attenzione', 'Inserire un valore di input');
      }
      else{
        var args = $scope.model.inputName;
        var value = new Array();
        var body = 'return '+$scope.model.formula+';';

        for(var i = 0; i < $scope.model.constant_params.length; i++){
          args = args + ', ' + $scope.model.constant_params[i].name;
        }
        if(isNaN(parseFloat(inputVal))){
            toaster.pop('warning', 'Attenzione', 'Inserire un input valido (valore numerico)');
            return;
        }
        value.push(parseFloat(inputVal));
        if(!$scope.verifyParameters()){
            return
        }
        for(var i = 0; i < $scope.model.constant_params.length; i++){
          value.push(parseFloat($scope.model.constant_params[i].value));
        }
        var fn = new Function(args, body);
        $scope.output = fn.apply(null,value);

        if($scope.model.rounding_mode==='none'){
          $scope.output = none($scope.output);
        }
        else if($scope.model.rounding_mode==='round'){
          $scope.output = round($scope.output,$scope.model.precision);
        }
        else if($scope.model.rounding_mode==='ceil'){
          $scope.output = ceil($scope.output,$scope.model.precision);
        }
        else if($scope.model.rounding_mode==='floor'){
          $scope.output = floor($scope.output,$scope.model.precision);
        }
      }
    };

    $scope.verifyParameters = function() {
        var success = true;
        for(var i = 0; i < $scope.model.constant_params.length; i++){
            var name = $scope.model.constant_params[i].name;
            var value = $scope.model.constant_params[i].value;
            if(angular.isUndefined(name) || (name.length==0) ){
                toaster.pop('warning', 'Attenzione', 'Non è possibile inserire un parametro privo di nome');
                success = false;
                break;
            }
            else{
                if(angular.isUndefined(value) || isNaN(value)){
                    toaster.pop('warning', 'Attenzione', 'Inserire un valore numerico per ogni parametro');
                    success = false;
                    break;
                }
            }
        }
        return success;
    };

    $scope.deleteItemOnArray = function(i){
        var rows = $('.params-row');
        $scope.model.constant_params.splice(i,1);
        rows[i].remove();
    };

    $scope.appendToArray = function(){
      var item = {};
      if($scope.verifyParameters()){
        $scope.model.constant_params.push(item);
      }
    };



    function none (result){
      return result;
    }

    function round (result,precision){
      //return Math.round(result);
      var app = 1;
      for(var i = 0; i < precision; i++){
        app = app * 10;
      }
      return Math.round(result * app) / app;
    }

    function ceil (result, precision){
      //return Math.ceil(result);
      var app = 1;
      for(var i = 0; i < precision; i++){
        app = app * 10;
      }
      return (Math.ceil(result * app)) / app;
    }

    function floor (result, precision){
      //return Math.floor(result);
      var app = 1;
      for(var i = 0; i < precision; i++){
        app = app * 10;
      }
      return (Math.floor(result * app)) / app;
    }


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'conversion';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };

  });

// Default:
// {
//   'get':    {method:'GET'},
//   'save':   {method:'POST'},
//   'query':  {method:'GET', isArray:true},
//   'remove': {method:'DELETE'},
//   'delete': {method:'DELETE'}
// }
angular.module('emma.dataset')
  .factory('uomFactory', function (DATA_SET_URL, $resource) {
    return $resource(DATA_SET_URL + '/api/conversion/:verb/:id/:param1/:param2/:param3', {}, {
      query:          {method: 'GET', isArray: false},
      create:         {method: 'POST', params: {id: '@version'}},
      byUUID:         {method: 'GET', params: {verb: '_uuid', param1: '_current'}},
      byID:           {method: 'GET', params: {verb: '_id'}},
      update:         {method: 'PUT', params: {id: '@version'}},
      delete:         {method: 'DELETE', params: {id: '@version'}},
      allowedChilds:  {method: 'GET', params: {verb: '_allowedChilds'}}
    });
});

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:BudgetCtrl
 * @description
 * # BudgetCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/budget/get', {
        templateUrl: 'energy/budget/budget_list.html',
        controller: 'BudgetCtrl'
      })
      .when('/budget/get/:code', {
        templateUrl: 'energy/budget/budget_detail.html',
        controller: 'BudgetCtrl'
      })
      .when('/budget/detail/', {
        templateUrl: 'energy/budget/budget_detail.html',
        controller: 'BudgetCtrl'
      })
      .when('/budget/detail/:code', {
        templateUrl: 'energy/budget/budget_detail.html',
        controller: 'BudgetCtrl'
      })
      .when('/budget/new', {
        templateUrl: 'energy/budget/budget_new.html',
        controller: 'BudgetCtrl'
      })
      .when('/budget/add/:codeToAdd', {
        templateUrl: 'energy/budget/budget_new.html',
        controller: 'BudgetCtrl'
      });
  })
  .controller('BudgetCtrl', function ($scope, $routeParams, $rootScope, $log, $filter, $location, authFactory, budgetFactory,
                                      evalFactory, recordFactory, $q, toaster, SaveAs, APP_URL, $http, dialogService, errorService, loadingBarService) {

    var currentCommission = authFactory.getAuthData().info.commissions.current;

    $scope.CODE_PATTERN = /^[a-zA-Z]+\w*$/;

    $scope.record = {};
    $scope.year = $filter('date')(new Date(), 'yyyy');
    $scope.availableBudgetCodes = [];

    $scope.isCollapsed = false;

    $scope.importingOperation = false;

    $scope.graphData = [];

    $scope.budget = {
      budget_code: undefined,
      budget_description: undefined,
      budget_default: false,
      searchCode: undefined,
      eval_date: null
    };

    $scope.priceListGas = {};

    $scope.priceListElectricity = {};

    $scope.priceList = {};

    var gridDoubleCellTemplate = '<div class="ui-grid-cell ui-grid-cell-contents" style="height: 75px !important">' +
        '<div>{{row.entity[col.field].tot | number: 2}} <span>{{row.entity[col.field].um.description}}</span>' +
        '</div>' +
        '<div ng-if="row.entity.record_type !== \'contatoreelettricita\' && row.entity[col.field].tot_std">{{row.entity[col.field].tot_std | number: 2}} kWh</div>' +
        '<div ng-if="row.entity[col.field].tot_economic">{{row.entity[col.field].tot_economic | number: 2}} €</div>' +
      '</div>';

    var monthsColumnDefs = [
      { name:'tipo', field: 'record_type', enableFiltering: true },
      { name:'cod-descr', field: 'record_code', enableFiltering: true, cellTemplate: '<div class="ui-grid-cell ui-grid-cell-contents"><a href ng-click="grid.appScope.getRecordDetailURL(row.entity.record_type, row.entity.record_uuid)">{{row.entity.record_code}} - {{row.entity.record_description}}</a></div>'},
      { name:'anno', enableFiltering: true },
      { name:'gennaio', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'febbraio', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'marzo', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'aprile', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'maggio', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'giugno', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'luglio', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'agosto', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'settembre', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'ottobre', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'novembre', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'dicembre', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'totale', field: 'tot', enableFiltering: false, cellTemplate: gridDoubleCellTemplate }
    ];

    var monthsColumnDefsSub = [
      { name:'voce', field: 'voice_code', enableFiltering: true },
      { name:'gennaio', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'febbraio', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'marzo', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'aprile', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'maggio', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'giugno', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'luglio', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'agosto', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'settembre', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'ottobre', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'novembre', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'dicembre', enableFiltering: false, cellTemplate: gridDoubleCellTemplate },
      { name:'totale', field: 'tot', enableFiltering: false, cellTemplate: gridDoubleCellTemplate }
    ];


    $scope.gridImportOptions = {
      importerDataAddCallback: function ( grid, newObjects ) {
        // $scope.data = $scope.data.concat( newObjects ); //questa in realtà non viene chiamata... la direttiva xlsx non scatena l'evento..
      },
      onRegisterApi: function(gridApi){
        $scope.gridImportApi = gridApi;
      }
    };


    //dati caricati da xls
    $scope.$watch(function( ) {
        /* qua arriva l'array delle righe in $scope.gridOptions.xlsData  */
        return $scope.gridImportOptions.xlsData;
      },
      function( newValue) {
        if (newValue && newValue.length>0){
          /* chiamata alla funzione per formare i dati */
          $scope.fixBudget();
        }
      }
    );


    $scope.fixBudget = function(){
      for(var n = 0; n < $scope.gridImportOptions.xlsData.length; n++) {
        for (var i = 0; i < 12; i++) {
          parseMonth(sixDateLib.getMonthName(i),$scope.gridImportOptions.xlsData[n]);
        }
      }
      //console.log($scope.gridImportOptions.xlsData);
      $scope.gridImportOptions.data = $scope.gridImportOptions.xlsData;
      $scope.data = $scope.gridImportOptions.xlsData;
      $scope.importingOperation = true;
    };


    function parseMonth(month, line) {
      if(line[month]){
        line[month] = parseFloat(line[month]);
      }else{
        line[month] = 0;
      }
    }

    $scope.downloadTemplate = function(){
        var anchor = $('#linkToTemplate');
        var url = anchor.attr("href");
        anchor.click(function (e) {
            e.preventDefault();
            window.location.href = url;
        });
        anchor.click();
    };

    var parse = function(st){
      if('' === st) {
        return 0;
      } else if(st.indexOf(',') === st.length-3){
        st = st.replace('.', '').replace(',', '.');
      }else{
        st = st.replace(',', '');
      }
      return parseFloat(st, 2);
    };

    $scope.parseColumn = function(value, columnName) {
      switch(columnName) {
        case 'anno':
        case 'record_code':
        case 'record_id':
        case 'record_type':
          return value;
        default:
          if($.isNumeric(value)) {
            return $filter('number')(value, 2);
          }
          return value;
      }
    };

    $scope.parseBoolean = function(value) {
      switch (value) {
        case 'true':
        case 'True':
        case 'TRUE':
        case 't':
        case 'T':
        case '1':
        case true:
          return true;
        default:
          return false;
      }
    };

    $scope.percent = 0;
    $scope.data = [];

    $scope.detailSelected = undefined;

    /***** Grid options *****/

    $scope.gridDetailOptions = {
      enableFiltering: true,
      enableSorting: true,
      enableRowSelection: false,
      enableRowHeaderSelection: false,
      multiSelect: false,
      enableGridMenu: false,
      exporterMenuPdf: false,
      data: 'data',
      //rowTemplate: $scope.gridRowTemplate,
      columnDefs: monthsColumnDefs,
      expandableRowTemplate: 'energy/budget/expandableRowTemplate.html',
      rowHeight: 75,
      expandableRowHeight: 240,
      //subGridVariable will be available in subGrid scope
      expandableRowScope: {
        parseColumn: $scope.parseColumn
      },
      onRegisterApi: function(gridApi){
        $scope.gridApi = gridApi;
        gridApi.selection.on.rowSelectionChanged($scope,function(row){
          if (row.isSelected) {
            $scope.detailSelected = row.entity;
          } else {
            $scope.detailSelected = undefined;
          }
        });
      }
    };

    $scope.colListTemplate = '<div class="ui-grid-cell ui-grid-cell-contents" ng-class="{\'font-bold\': grid.appScope.parseBoolean(row.entity.default)}">{{row.entity[col.field}}</div>';

    $scope.gridListOptions = {
      enableSorting: true,
      enableGridMenu: false,
      exporterMenuPdf: false,
      enableFiltering: true,
      data: 'availableBudgetCodes',
      //rowTemplate: $scope.colListTemplate,
      columnDefs: [
        {displayName: '', field: 'code', enableFiltering: false, width: 34, cellTemplate: '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ng-click="grid.appScope.viewBudgetDetail(row.entity.UUID)"><i class="fa fa-search"></i></button></div>'},
        {displayName: '', field: 'code', enableFiltering: false, width: 34, cellTemplate: '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ng-click="grid.appScope.analyze(row.entity.UUID)"><i class="fa fa-euro"></i></button></div>'},
        {displayName: 'Codice', field: 'code', width: 400, cellTemplate: '<div class="ui-grid-cell-contents" ng-class="{\'font-bold\': grid.appScope.parseBoolean(row.entity.default)}">{{row.entity.code}}</div>'},
        {displayName: 'Descrizione', field: 'description', cellTemplate: '<div class="ui-grid-cell-contents" ng-class="{\'font-bold\': grid.appScope.parseBoolean(row.entity.default)}">{{row.entity.description}}</div>'},
        {displayName: 'Anno', field: 'year', width: 100, cellTemplate: '<div class="ui-grid-cell-contents" ng-class="{\'font-bold\': grid.appScope.parseBoolean(row.entity.default)}">{{row.entity.year}}</div>'},
        {displayName: 'Default', field: 'default', enableFiltering: false, width: 100, cellTemplate: '<div class="ui-grid-cell-contents" ng-class="{\'font-bold\': grid.appScope.parseBoolean(row.entity.default)}" style="vertical-align:middle;text-align:center;"><span class="fa fa-check" ng-if="grid.appScope.parseBoolean(row.entity.default)"></span></div>'}
      ]
    };

    /***** *****/

    $scope.open = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.opened = true;
    };

    function setDefaultDimension(string) {
      string = '' + string;
      if (string.length == 1) {
        string = '0' + string;
      }
      return string;
    }

    $scope.importData = function () {
      if($scope.budget.budget_code) {
        loadingBarService.start('Importazione dati...');
        var counter = 0;
        var toSave = [];
        $scope.data.forEach(function (value) {
          for (var i = 0; i < 12; i++) {
            var month = '' + (i + 1);
            month = setDefaultDimension(month);
            var day = value['anno'] + month + '01';
            var temp = {};
            temp['date'] = value['anno'] +'-'+ month +'-'+ '01';
            temp['budget_code'] = $scope.budget.budget_code;
            temp['budget_description'] = $scope.budget.budget_description;
            temp['budget_default'] = $scope.budget.budget_default;
            temp['budget_eval_date'] = $scope.budget.eval_date;
            temp['voice_key'] = value['voce'];
            temp['voice_value'] = parseFloat(value[sixDateLib.getMonthName(i).toLowerCase()]);
            temp['tot'] = parseFloat(temp['voice_value']);
            temp['um'] = value.um;
            temp['record_type'] = value['tipo_cont'];
            temp['record_code'] = value['cod_cont'];
            $log.log(temp);
            toSave.push(temp);
          }
        });
        budgetFactory.bulk(toSave).$promise.then(function (response) {
          if(errorService.handleError(response)) {
            $scope.percent = 100;
            $scope.reportMessages = response.messages;
            if($scope.reportMessages.length > 0) {
              toaster.pop('warning', 'Attenzione', 'Errori durante l\'importazione: ' + $scope.reportMessages.length);
            } else {
              toaster.pop('success', 'Successo', 'Importazione avvenuta con successo');
            }
          }
          else {
            toaster.pop('error', 'Errore', 'Errore durante l\'importazione');
          }
          loadingBarService.stop();
        });
      }
      else {
        toaster.pop('error', 'Errore', 'Codice budget non specificato');
      }
    };

    $scope.update = function() {
      var budgetDetails = {
        budget_code: $scope.budget.budget_UUID,
        description: $scope.budget.budget_description,
        default: $scope.budget.budget_default,
        year: $scope.year,
        eval_date: $scope.budget.eval_date
      };
      budgetFactory.update(budgetDetails).$promise.then(function (response) {
        if(errorService.handleError(response)) {
          $scope.percent = 100;
        }
        else {
          toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
        }
      });
    };

    $scope.deleteWithDialog = function (budget) {
      dialogService.confirmDialog('Eliminare il budget?',
        function () {
          $scope.delete(budget);
        });
    };

    $scope.delete = function (budget) {
      var budgetDetails = {
        budget_code: $scope.budget.budget_UUID,
        year: $scope.budget.year
      };
      budgetFactory.delete(budgetDetails).$promise.then(function() {
        $scope.unselectBudget();
        $scope.loadAvailableBudgetCodes();
        $location.path('/budget/get');
      });
    };

    $scope.unselectBudget = function(){
      $scope.record = {};
      $scope.importingOperation = false;
      $scope.isCollapsed = false;
      $scope.graphData = [];
      $scope.data = [];
      $scope.percent = 0;
      $scope.budget = {
        budget_code: undefined,
        budget_description: undefined,
        budget_default: false,
        searchCode: undefined
      };
    };

    $scope.getData = function (valorize, valorizeLikeConsumptions) {
      $scope.importingOperation = false;
      $scope.percent = 0;
      $scope.data = [];
      $scope.graphData = [];

      valorize = valorize || false;
      valorizeLikeConsumptions = valorizeLikeConsumptions || false;

      if(!$scope.budget.searchCode || !$scope.budget.searchCode.UUID) {
        toaster.pop('error', 'Errore', 'Budget non specificato');
      }
      else {
        loadingBarService.start('Caricamento dati...');

        getHeader().then(function() {
          var promise;
          if(valorize === true) {
            var params = {
              budgetCode: $scope.budget.budget_UUID,
              to: $scope.budget.year+'-12-31',
              from: $scope.budget.year+'-01-01',
              frequency: 'MONTHLY',
              consumptionsLike: valorizeLikeConsumptions
            };
            promise = evalFactory.budgetAndEval(params).$promise;
          } else {
            var query = {};
            query.year = $scope.budget.year;
            if ($scope.budget.searchCode.UUID) {
              query.budget_codes = $scope.budget.searchCode.UUID;
            }
            if ($scope.record.type_id) {
              query.record_types = $scope.record.type_id.UUID;
            }
            if ($scope.record.record_id) {
              query.record_ids = $scope.record.record_id.UUID;
            }

            promise = budgetFactory.byYear(query).$promise;
          }

          promise.then(function (response) {
            $log.log(response);

            if(errorService.handleError(response)) {
              if (response.hasOwnProperty('list') && response.list.length) {
                response.list.forEach(function (item) {
                  item.subGridOptions = {
                    enableFiltering: true,
                    columnDefs: monthsColumnDefsSub,
                    data: item.details,
                    rowHeight: 75
                  };
                });
                $scope.data = response.list;
                $scope.reportMessages = response.messages;
                buildGraphData();
              }
            } else {
              toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
            }
            $scope.$broadcast(DATA_READY_EVENT, 'data');
            loadingBarService.stop();
          });
        });
      }
    };

    function getHeader() {
      var query = {};
      query.year = $scope.year;
      if ($scope.budget.searchCode.UUID) {
        query.budget_codes = $scope.budget.searchCode.UUID;
      }
      if ($scope.record.type_id) {
        query.record_types = $scope.record.type_id.UUID;
      }
      if ($scope.record.record_id) {
        query.record_ids = $scope.record.record_id.UUID;
      }

      var promise = budgetFactory.byHeader({id: $scope.budget.searchCode.UUID}).$promise;
      promise.then(function (response) {
        if(errorService.handleError(response)) {
          $scope.budget.budget_UUID = response.UUID;
          $scope.budget.budget_code = response.model.code;
          $scope.budget.budget_description = response.model.code;
          $scope.budget.budget_default = response.model.default;
          $scope.budget.year = response.model.year;
          $scope.budget.eval_date = new Date(response.model.eval_date);
        } else {
          toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
        }
      });
      return promise;
    }

    $scope.getRecordDetailURL = function(itemType, itemId) {
      $location.path('/record/snap/'+itemType+'/'+itemId);
    };

    function getAvailableBudgetCodes(from, to, recordType, recordId) {
      loadingBarService.start();

      var query = {};
      if(from) {
        query.from = from;
      }
      if(to) {
        query.to = to;
      }
      if(recordType) {
        query.record_type = recordType;
      }
      if(recordId) {
        query.record_id = recordId;
      }
      return budgetFactory.budgetCodes(query).$promise.then(function (response) {
        if(errorService.handleError(response)) {
          var list = [];
          if (response.hasOwnProperty('list') && response.list.length) {
            list = response.list;
          }
          $scope.$broadcast(DATA_READY_EVENT, 'budgetCodes');
          return list;
        }
        else {
          $scope.$broadcast(DATA_READY_EVENT, 'budgetCodes');
          toaster.pop('error', 'Errore', 'Errore durante il recupero dei budget');
        }
      });
    }

    $scope.getBudgetByCode = function(code) {
      $scope.isCollapsed = true;
      //$location.path('/budget/'+code);
      $scope.budget.searchCode = {UUID: code};
      $scope.getData(false);
    };

    $scope.newBudget = function() {
      $location.path('/budget/new');
    };

    $scope.$watchGroup(['record.type_id', 'record.record_id'], function( newValue, oldValue ) {
      if(newValue) {
        $scope.availableBudgetCodes = [];
        $scope.loadAvailableBudgetCodes();
      }
    });

    $scope.loadAvailableBudgetCodes = function() {
      var from = undefined;
      var to = undefined;
      var recordType = undefined;
      var recordId = undefined;
      if($scope.year) {
        $log.info('year: ' + $scope.year);
        from = $scope.year + '-01-01';
        to = $scope.year + '-12-31';
      }
      if($scope.record && $scope.record.type_id) {
        recordType = $scope.record.type_id.UUID;
      }
      if($scope.record && $scope.record.record_id) {
        recordId = $scope.record.record_id.UUID;
      }
      getAvailableBudgetCodes(from, to, recordType, recordId).then(function(list) {
        $scope.availableBudgetCodes = list;
      });
    };

    $scope.addVoices = function() {
      $location.path('budget/add/'+$scope.budget.searchCode.UUID);
    };

    function buildGraphData() {
      var map = [];
      $scope.data.forEach(function(item) {
        item.details.forEach(function(det) {
          var voiceKey = det.voice_code;
          for(var month = 0 ; month < 12 ; month++) {
            var monthName = sixDateLib.getMonthName(month).toLowerCase();
            var graphKey = monthName;
            var graphItem = map[graphKey] || {tot: 0};
            graphItem.date = new Date($scope.year, month, 1);
            if(!graphItem.hasOwnProperty(voiceKey)) {
              graphItem[voiceKey] = 0;
            }
            graphItem[voiceKey] += det[monthName].tot || 0;
            graphItem.tot += det[monthName].tot || 0;
            map[graphKey] = graphItem;
          }
        });
      });
      $scope.graphData = [];
      for(var i in map) {
        $scope.graphData.push(map[i]);
      }
      $scope.graphData = $filter('orderBy')($scope.graphData, 'date');
    }

    $scope.reset = function() {
      $scope.budget = {
        budget_code: undefined,
        budget_description: undefined,
        budget_default: false,
        searchCode: undefined,
        eval_date: null
      };
      $scope.reportMessages = [];
      $scope.data = [];
      $scope.gridImportOptions.data = [];
      $scope.percent = 0;
    };

    /***** Esportazioni *****/

    var REPORT_BASE_DIR = "reports/EMMA/";
    var REPORT_API_BASE = "http://"+location.host+""+APP_URL+"/rest/report/";
    //var REPORT_API_BASE = "http://docker0.ict-group.it:7878/six/rest/report/";
    var REPORT_QUERY_BASE = "&net.sf.jasperreports.json.source="+REPORT_API_BASE;

    $scope.getPdf = function () {
      loadingBarService.start('Generazione report in corso');

      var query = REPORT_QUERY_BASE + "budget/"+currentCommission.code+"/"+$scope.year+"/"+$scope.budget.budget_UUID;

      $http.post(APP_URL + '/rest/report/generate',
        {
          path: REPORT_BASE_DIR+"Test_Budget.pdf",
          query: query
        },
        { responseType: 'arraybuffer' }).
        then(function(data, status, headers, config) {
        loadingBarService.stop();
          var options = { type: 'application/pdf' };
          SaveAs.download(data, 'report.pdf', options);
      }, function(data, status, headers, config) {
        loadingBarService.stop();
          toaster.pop('error', "Errore", 'Errore generazione report');
          // called asynchronously if an error occurs
          // or server returns response with an error status.
        });
    };

    $scope.getXlsx = function () {
      loadingBarService.start('Generazione report in corso');
      //"&net.sf.jasperreports.json.source=http://docker0.ict-group.it:7878/six/rest/report/budget/"+currentCommission.code+"/"+$scope.year+"/"+$scope.budget.budget_UUID
      var query = REPORT_QUERY_BASE + "budget/"+currentCommission.code+"/"+$scope.year+"/"+$scope.budget.budget_UUID;
      $http.post(APP_URL + '/rest/report/generate',
        {
          path: REPORT_BASE_DIR+"Test_Budget_xlsx.xlsx",
          query: query
        },
        { responseType: 'arraybuffer' }).
        then(function(data, status, headers, config) {
          loadingBarService.stop();
          var options = { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' };
          SaveAs.download(data, 'report.xlsx', options);
        }, function(data, status, headers, config) {
          loadingBarService.stop();
          toaster.pop('error', "Errore", 'Errore generazione report');
          // called asynchronously if an error occurs
          // or server returns response with an error status.
        });
    };

    $scope.getChart = function () {
      loadingBarService.start('Generazione report in corso');
      //"&net.sf.jasperreports.json.source=http://docker0.ict-group.it:7878/six/rest/report/chart/budget/"+currentCommission.code+"/"+$scope.year+"/"+$scope.budget.budget_UUID
      var query = REPORT_QUERY_BASE + "chart/budget/"+currentCommission.code+"/"+$scope.year+"/"+$scope.budget.budget_UUID;
      $http.post(APP_URL + '/rest/report/generate',
        {
          path: REPORT_BASE_DIR+"Test_Budget_graph.pdf",
          query: query
        },
        { responseType: 'arraybuffer' }).
        then(function(data, status, headers, config) {
          loadingBarService.stop();
          var options = { type: 'application/pdf' };
          SaveAs.download(data, 'chart.pdf', options);
        }, function(data, status, headers, config) {
          loadingBarService.stop();
          toaster.pop('error', "Errore", 'Errore generazione report');
          // called asynchronously if an error occurs
          // or server returns response with an error status.
        });
    };

    $scope.analyze = function(uuid) {
      $location.path('/budget/eval/'+uuid);
    };


    /***** Data ready events *****/

    var DATA_READY_EVENT = 'dataReady';

    // $scope.$on(DATA_READY_EVENT, function(event) {
    //   setTimeout(function() { // evita che venga richiamato troppo velocemente (altrimenti si accavalla a showLoadingMessage)
    //     if($scope.gridApi && $scope.gridApi.core) {
    //       $scope.gridApi.core.refresh();
    //     }
    //     loadingBarService.stop();
    //   }, 200);
    // });

    $scope.viewBudgetDetail = function(uuid){
        $location.path('budget/detail/' + uuid);
    };

    $scope.goBack = function(){
        $location.path('budget/get');
    };

    /******* Log messages *******/

    $scope.reportMessages = [];

    $scope.reportGridOptions = {
      enableSorting: true,
      exporterMenuPdf: false,
      paginationPageSizes: [10, 20, 30],
      paginationPageSize: 10,
      useExternalPagination: false,
      data: 'reportMessages',
      columnDefs: [
        {displayName: 'Stato', field: 'status', width: '100'},
        {displayName: 'Messaggio', field: 'message'}
      ]
    };


    /***** Caricamento dati di dettaglio *****/

    if ($routeParams.codeToAdd) {
      $scope.budget.searchCode = {UUID: $routeParams.codeToAdd};
      getHeader();
    } else if ($routeParams.code) {
      $scope.budget.searchCode = {UUID: $routeParams.code};
      $scope.getData(false);
    }


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'budget';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:BudgetCtrl
 * @description
 * # BudgetCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/budget/eval', {
        templateUrl: 'energy/budget/budget_eval.html',
        controller: 'BudgetEvalCtrl'
      })
      .when('/budget/eval/:code', {
        templateUrl: 'energy/budget/budget_eval.html',
        controller: 'BudgetEvalCtrl'
      });
  })
  .controller('BudgetEvalCtrl', function ($scope, $routeParams, $rootScope, $log, $filter, $location, authFactory, budgetFactory, energyCarrierFactory,
                                      evalFactory, recordFactory, $q, toaster, SaveAs, APP_URL, $http, dialogService, errorService) {

    var currentCommission = authFactory.getAuthData().info.commissions.current;

    $scope.loadingPlaceHolder = {
      show: false,
      info: false,
      warn: false,
      error: false,
      message: ''
    };

    $scope.budget = {};
    $scope.data = [];
    $scope.graphData = [];

    // Filtri
    $scope.record = {};
    $scope.type = {};
    $scope.recordTypeFilter = { 'model.code' : '' };
    $scope.vector = {};
    $scope.datePicker = {
      from: new Date(new Date().getFullYear(), 0, 1),
      to: new Date(new Date().getFullYear(), 11, 31)
    };
    $scope.budgetList = [];

    $scope.getData = function () {
      $scope.data = [];
      $scope.graphData = [];

      if(angular.isUndefined($scope.budget) || angular.isUndefined($scope.budget.UUID)) {
        // toaster.pop('error', 'Errore', 'Budget non specificato');
        loadingPlaceHolder(true, false, false, 'Selezionare un budget');
      }
      else {
        loadingPlaceHolder(false, false, false, 'Caricamento dati...');

        budgetFactory.byHeader({id: $scope.budget.UUID}).$promise.then(function (response) {
          if(errorService.handleError(response)) {
            $scope.budget.code = response.model.code;
            $scope.budget.description = response.model.code;
            $scope.budget.default = response.model.default;
            $scope.budget.year = response.model.year;
            $scope.budget.eval_date = new Date(response.model.eval_date);

            $scope.datePicker.from = new Date($scope.budget.year+'-01-01');
            $scope.datePicker.to = new Date($scope.budget.year+'-12-31');

            var params = {
              id: $scope.budget.UUID,
              to: $scope.budget.year+'-12-31',   // FIXME
              from: $scope.budget.year+'-01-01'  // FIXME
            };
            if(angular.isDefined($scope.vector.id)) {
              params.vectorUUID = $scope.vector.id.UUID;
            }
            if(angular.isDefined($scope.type.id)) {
              params.typeUUID = $scope.type.id.UUID;
            }
            if(angular.isDefined($scope.record.id)) {
              params.recordUUID = $scope.record.id.UUID;
            }
            evalFactory.analisys(params).$promise.then(function (response) {
              $log.log(response);
              if (checkResponse(response)) {
                $scope.data = $filter('orderBy')(response.result, 'date', false, function(v1, v2) {
                  if(angular.isUndefined(v1.value)) return 1;
                  if(angular.isUndefined(v2.value)) return -1;
                  return new Date(v1.value) < new Date(v2.value) ? -1 : 1;
                });
                $scope.data.forEach(function(obj) {
                  if(angular.isDefined(obj.date)) { // se undefined è un totale
                    var item = {
                      date: new Date(obj.date)
                    };
                    item['bdg val.'] = obj.bdgEval;
                    item['bdg att.'] = obj.bdgEvalConsLike;
                    item['cons. val.'] = obj.consEval;
                    // item['fatt. rev.'] = obj.fattRevEuros;
                    // item['scost. cons.'] = obj.consDiffEuros;
                    $scope.graphData.push(item);
                  }
                });
              }
            });
          } else {
            toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
            showErrors('Errore durante il recupero dei dati')
          }
        });

      }
    };

    function checkResponse(response) {
      if(errorService.handleError(response)) {
        $scope.reportMessages = response.messages;
        if (response.hasError) {
          showErrors('Errore durante il recupero dei dati');
          return false;
        }
        if (!response.result || response.result.length == 0) {
          showNoResults();
          return false;
        }
        hideLoadingPlaceHolder();
        return true;
      }
      showErrors('Errore durante il recupero dei dati');
      return false;
    }

    function loadAvailableBudgetCodes() {
      var query = {
        from: createDate($scope.datePicker.from),
        to: createDate($scope.datePicker.to)
      };
      if($scope.type.type_id) {
        query.type = $scope.type.type_id.UUID;
      }
      return budgetFactory.budgetCodes(query).$promise.then(function (response) {
        if (response.hasOwnProperty('list') && response.list.length) {
          $scope.budgetList = response.list;
        }
      });
    }

    function createDate(d) {
      var date = new Date(d);
      return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
    }

    $scope.goBack = function(){
      $location.path('budget/get');
    };

    /******* Log messages *******/

    $scope.reportMessages = [];

    $scope.reportGridOptions = {
      enableSorting: true,
      exporterMenuPdf: false,
      paginationPageSizes: [10, 20, 30],
      paginationPageSize: 10,
      useExternalPagination: false,
      data: 'reportMessages',
      columnDefs: [
        {displayName: 'Stato', field: 'status', width: '100'},
        {displayName: 'Messaggio', field: 'message'}
      ]
    };

    /***** Caricamento dati di dettaglio *****/

    if ($routeParams.code) {
      $scope.budget = {UUID: $routeParams.code};
      $scope.getData(false);
    } else {
      loadingPlaceHolder(true, false, false, 'Selezionare un budget');
    }


    /***** Data ready events *****/

    function hideLoadingPlaceHolder() {
      $scope.loadingPlaceHolder = {
        show: false,
        info: false,
        warn: false,
        error: false,
        message: ''
      };
    }

    function showNoResults() {
      loadingPlaceHolder(false, true, false, 'Nessun dato da mostrare');
    }

    function showErrors(msg) {
      loadingPlaceHolder(false, false, true, msg);
    }

    function loadingPlaceHolder(info, warn, err, msg) {
      $scope.loadingPlaceHolder = {
        show: true,
        info: info,
        warn: warn,
        error: err,
        message: msg
      };
    }

    function updateContatoreTypeFilter() {
      if($scope.vector.id) {
        energyCarrierFactory.schemas({id: $scope.vector.id.UUID}).$promise.then(function (response) {
          if (errorService.handleError(response, true)) {
            $scope.recordTypeFilter = { 'model.code' : response.list.join() };
          } else {
            toaster.pop('error', 'Errore', 'Errore durante il recupero dei modelli con vettore_id ' + $scope.vettore.id.code);
          }
        });
      }
    }

    $scope.$watch(function() {return $scope.vector.id;}, function(newVal, oldVal) {
      if(angular.isDefined(newVal) && newVal !== oldVal) {
        updateContatoreTypeFilter();
      } else {
        $scope.type = {};
      }
    });

    $scope.$watchCollection(['datePicker.from', 'datePicker.to'], function(newVal, oldVal) {
      loadAvailableBudgetCodes();
    });


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'budget';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ConsumptionAnalysisCtrl
 * @description
 * # ConsumptionAnalysisCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/closure', {
        templateUrl: 'energy/closure/closure.html',
        controller: 'ClosureCtrl'
      })
  })
  .controller('ClosureCtrl',
  function ($scope, consumptiveFactory, recordFactory, energyCarrierFactory, dialogService, errorService, toaster,
            $log, $q, localStorageService) {

    $scope.schema = {};
    $scope.record = {};
    $scope.um = undefined;
    $scope.read = {};


    // Date Picker

    $scope.datePicker = {};

    $scope.dateOptions = {
      dateDisabled: false,
      formatYear: 'yyyy',
      maxDate: new Date(),
      minDate: new Date() - 365*10,  // -10 anni
      startingDay: 1
    };

    $scope.dpStatus = { opened: false };

    $scope.dpOpen = function($event) {
      $scope.dpStatus.opened = true;
    };


    // Functions

    $scope.checkInputData = function() {
      return angular.isDefined($scope.schema.id) &&
        angular.isDefined($scope.record.id) &&
        angular.isDefined($scope.datePicker.date) &&
        (angular.isDefined($scope.read.f0) || angular.isDefined($scope.read.f1) || angular.isDefined($scope.read.f2) || angular.isDefined($scope.read.f3));
    };

    $scope.closeRecord = function() {
      var p1 = saveRecord();
      var p2 = saveRead();
      $q.all([p1, p2]).then(function(responses) {
        if(responses[0] && responses[1]) {
          toaster.pop('success', 'Ok', 'Chiusura avvenuta correttamente');
        }
      });
    };

    function saveRecord() {
      var toUpdate = $scope.record.obj;
      toUpdate.model.stato = 'chiuso';
      toUpdate.model.data_chiusura = $scope.datePicker.date;
      return recordFactory($scope.schema.id.code).update({id: toUpdate.version}, toUpdate).$promise.then(function (data) {
        if (!errorService.handleError(data)) {
          toaster.pop('error', 'Errore', 'Errore durante il salvataggio del contatore');
          return false;
        }
        return true;
      });
    }

    function saveRead() {
      var toSave = prepareDataForSaving($scope.read);
      toSave.date = $scope.datePicker.date;
      if (!toSave.date || !toSave.record_id.type || !toSave.record_id.code || toSave.reads.length == 0) {
        toaster.pop('error', 'Errore', 'Controllare tipo e codice contatore, data e letture');
        var deferred = $q.defer();
        deferred.resolve(false);
        return deferred.promise;
      }
      return consumptiveFactory.create(toSave).$promise.then(function (data) {
        if (!errorService.handleError(data)) {
          toaster.pop('error', 'Errore', 'Errore durante il salvataggio della lettura');
          return true;
        }
        return false;
      });
    }

    function prepareDataForSaving(value) {
      var toSave = angular.copy(value);
      toSave.reads = [];
      toSave.record_id = $scope.record.id;
      toSave.date = toSave.data;
      toSave.um_id = $scope.um;
      delete toSave.sixImportStatus;
      delete toSave.data;
      delete toSave.um;
      delete toSave.value;
      switch($scope.schema.id.code) {
        case 'contatoreelettricita':
          delete toSave.pod;
          if(toSave.f0) {
            toSave.reads.push({
              time_slot: 'f0',
              value: parseFloat(toSave.f0)
            });
          }
          if(toSave.f1) {
            toSave.reads.push({
              time_slot: 'f1',
              value: parseFloat(toSave.f1)
            });
          }
          if(toSave.f2) {
            toSave.reads.push({
              time_slot: 'f2',
              value: parseFloat(toSave.f2)
            });
          }
          if(toSave.f3) {
            toSave.reads.push({
              time_slot: 'f3',
              value: parseFloat(toSave.f3)
            });
          }
          delete toSave.f0;
          delete toSave.f1;
          delete toSave.f2;
          delete toSave.f3;
          break;

        case 'contatoregas':
          delete toSave.pdr;
          if(toSave.f0) {
            var read = {
              time_slot: 'f0',  // lettura
              value: parseFloat(toSave.f0)
            };
            if(toSave.correttore) {
              read.correttore = parseFloat(toSave.correttore);
            }
            toSave.reads.push(read);
          }
          delete toSave.f0;
          delete toSave.correttore;
          break;

        case 'contatoreacqua':
          delete toSave.matricola;
          if(toSave.f0) {
            toSave.reads.push({
              time_slot: 'f0',  // lettura
              value: parseFloat(toSave.f0)
            });
          }
          delete toSave.f0;
          break;

        case 'serbatoiopressioneatmosferica':
          delete toSave.cod;
          if(toSave.f0) {
            var read = {
              time_slot: 'f0',  // steccatura
              value: parseFloat(toSave.f0)
            };
            if(toSave.scarico) {
              read.scarico = parseFloat(toSave.scarico);
            }
            toSave.reads.push(read);
          }
          delete toSave.f0;
          delete toSave.scarico;
          break;

        case 'serbatoioinpressione':
          delete toSave.cod;
          if(toSave.f0) {
            var read = {
              time_slot: 'f0', // percentuale
              value: parseFloat(toSave.f0)
            };
            if(toSave.scarico) {
              read.scarico = parseFloat(toSave.scarico);
            }
            toSave.reads.push(read);
          }
          delete toSave.f0;
          delete toSave.scarico;
          break;

        case 'contatoreteleriscaldamento':
          delete toSave.cod;
          if(toSave.f0) {
            toSave.reads.push({
              time_slot: 'f0',
              value: parseFloat(toSave.f0)
            });
          }
          delete toSave.f0;
          break;

        case 'contatoreteleraffreddamento':
          delete toSave.cod;
          if(toSave.f0) {
            toSave.reads.push({
              time_slot: 'f0',
              value: parseFloat(toSave.f0)
            });
          }
          delete toSave.f0;
          break;

        default:
          toaster.pop('error', 'Errore', 'Tipo contatore non riconosciuto');
      }
      return toSave;
    }


    // Watchers

    $scope.$watch(function() {return $scope.record.obj}, function(newVal, oldVal) {
      if(angular.isDefined(newVal)) {
        $scope.um = $scope.record.obj.model.um_letture_id;
      }
    });



    if(localStorageService.get('closure.schema') && localStorageService.get('closure.record')) {
      $scope.schema.id = localStorageService.get('closure.schema');
      $scope.record.id = localStorageService.get('closure.record');
      localStorageService.remove('closure.schema');
      localStorageService.remove('closure.record');
    }
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ConsumptionAnalysisCtrl
 * @description
 * # ConsumptionAnalysisCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/consumptionanalysis', {
        templateUrl: 'energy/consumptionanalysis/consumptionanalysis.html',
        controller: 'ConsumptionAnalysisCtrl'
      })
  })
  .controller('ConsumptionAnalysisCtrl',
  function ($scope, energyCarrierFactory, authFactory, consumptionFactory, recordFactory, budgetFactory, $q, ENERGY_URL, DEV,
            consumptionAnalysisFactory, $location, $anchorScroll, dialogService, errorService, toaster, $window,
            $filter, APP_URL, $http, SaveAs, $log, cfpLoadingBar, loadingBarService, ngDialog) {

  var SHOW_ERROR_POPUP = true;

  $scope.contatore = {};
  $scope.type = {};
  $scope.selectedBudgets = {selected: []};
  $scope.info = authFactory.getAuthData().info;

  $scope.totVector = {
    total: true,
    model: {
      code: 'total',
      description: 'Totale',
      um: { type: 'um', UUID: 'kwh', code: 'kwh', description: 'kWh' }
    }
  };

  // Consumi senza vettore energetico (sono errori di dati sull'indice)
  $scope.missingVector = {
    schemaCode: 'vettoreenergetico',
    UUID: 'missing',
    model: {
      code: 'missing',
      description: 'No vett. energ.',
      um: {type: 'um', UUID: 'kwh', code: 'kwh', description: 'kWh'},
      color: '#b3b3cc',
      text_color: 'red'
    }
  };

  $scope.vectors = { total: $scope.totVector };

  $scope.budget = {
    code : undefined,
    description : undefined,
    list : [],
    totalConsumption : 0,
    season : 0,
    totalBudget : 0,
    deltaSeason : 0,
    deltaTech : 0
  };

  $scope.dashYearsPicker = {
    from: new Date(new Date().getFullYear(), 0, 1),
    to: new Date(new Date().getFullYear(), 11, 31)
  };

  $scope.datePicker = {
    from: new Date(new Date().getFullYear(), 0, 1),
    to: new Date(new Date().getFullYear(), 11, 31)
  };

  $scope.availableBudgetCodes = [{
    code: 'test',
    description: 'Test'
  }];

  $scope.currentVector = {};
  $scope.vector = {};

  $scope.contatoreTypeFilter = { 'model.code' : ''};

  $scope.forceReprocessing = false;


  $scope.$watchCollection('type',
    function (newValue, oldValue) {
      if(newValue !== oldValue) {
        $scope.contatore = {};
        refreshAvailableBudgets();
      }
    }
  );

  $scope.$watchCollection('contatore',
    function (newValue, oldValue) {
      if(newValue !== oldValue){
        refreshAvailableBudgets();
      }
    }
  );

  $scope.$watchCollection('datePicker',
    function (newValue, oldValue) {
      if(newValue !== oldValue){
        $scope.selectedBudgets.selected = [];
        refreshAvailableBudgets();
      }
    }
  );

    // FIXME decommentare
  // $scope.$watchCollection('dashYearsPicker',
  //   function (newValue, oldValue) {
  //       $scope.reload();
  //   }
  // );

  $scope.$watch(function() {return $scope.vector.id;}, function(newVal, oldVal) {
    if(angular.isDefined(newVal) && newVal !== oldVal) {
      updateContatoreTypeFilter();
    } else {
      $scope.type = {};
    }
  });

  function refreshSelectedBudgets(selected) {
    if(angular.isDefined(selected) && angular.isArray(selected) && selected.length > 0) {
      var old = angular.copy(selected); // se gli viene passato $scope.selectedBudgets.selected lo copio, altrimenti non funziona più una fava visto che lo resetto a []
      $scope.selectedBudgets.selected = [];
      old.forEach(function (bc) {
        // MODIFICATO
        var result = getBudgetByCodeFromAvailablesList(bc);
        if (angular.isDefined(result)) {
          $scope.selectedBudgets.selected.push(result);
        }
      });
    }
  }

  $scope.loadData = function (vector, forceReprocessing) {

    var queryFromFilters = $scope.currentVector && $scope.currentVector.model && !vector.total;  // $scope.currentVector è il vettore impostato dalla lookup: se definito prendo questo, altrimenti il vettore passato
    var query = queryFromFilters ? getQuery() : getQuery(vector);

    if(forceReprocessing) {
      $scope.recreateDDSnap(queryFromFilters?undefined:vector);
      $scope.recreateConsumptionsSnap(queryFromFilters?undefined:vector);
      $scope.recreateConsAnalisysSnap(queryFromFilters?undefined:vector);
    }

    $scope.budget = {list: undefined};

    vector.loadingPlaceHolder = {
      show: true,
      message: 'Caricamento dati...'
    };


    var promise = consumptionAnalysisFactory().getConsumptionAnalysis(query).$promise;
    promise.then(function (consAnResp) {
      if(errorService.handleError(consAnResp)) {
        console.log(consAnResp);
        var budget = {}, graphData =[], graphDataCumulative=[], selectedBudgets = [];
        if(consAnResp.hasErrors === true) {
          var details = [];
          consAnResp.messages.forEach(function(m) {
            details.push(m.message);
          });
          vector.loadingPlaceHolder= {
            show: true,
            message: 'Errore durante il recupero dei dati',
            error: true,
            details: details
          };
        } else if(angular.isDefined(consAnResp.result) && angular.isDefined(consAnResp.result.list)){
          budget.list = consAnResp.result.list;
          angular.forEach(consAnResp.result.list, function (record, idx) {
            var grpDT = {
              'date': Date.parse(record.date)
            };
            var grpDTCumulative = {
              'date': Date.parse(record.date)
            };

            budget.toRender = {};
            if(vector.total) {
              grpDT['consumi ' + $filter('number')(consAnResp.result.std.cons, 3)] = '' + record.std.cons;
              grpDT['budget ' + $filter('number')(consAnResp.result.std.budget, 3)] = '' + record.std.budget;
              grpDT['stagionalita ' + $filter('number')(consAnResp.result.std.season, 3)] = '' + record.std.season;

              grpDTCumulative['consumi ' + $filter('number')(consAnResp.result.std.cons, 3)] = '' + (record.std.cumCons || 0);
              grpDTCumulative['budget ' + $filter('number')(consAnResp.result.std.budget, 3)] = '' + (record.std.cumBudget || 0);

              budget.toRender.list = [];
              budget.list.forEach(function (record) {
                var r = angular.copy(record.std);
                r.date = record.date;
                budget.toRender.list.push(r);
              });
              budget.toRender.totalBudget = consAnResp.result.std.budget;
              budget.toRender.totalConsumption = consAnResp.result.std.cons;
              budget.toRender.season = consAnResp.result.std.season;
              budget.toRender.deltaSeason = consAnResp.result.std.deltaSeason;
              budget.toRender.deltaTech = consAnResp.result.std.deltaTech;
              budget.toRender.percentage = consAnResp.result.std.percentage;

            } else {
              grpDT['consumi ' + $filter('number')(consAnResp.result.um.cons, 3)] = '' + record.um.cons;
              grpDT['budget ' + $filter('number')(consAnResp.result.um.budget, 3)] = '' + record.um.budget;
              grpDT['stagionalita ' + $filter('number')(consAnResp.result.um.season, 3)] = '' + record.um.season;

              grpDTCumulative['consumi ' + $filter('number')(consAnResp.result.um.cons, 3)] = '' + (record.um.cumCons || 0);
              grpDTCumulative['budget ' + $filter('number')(consAnResp.result.um.budget, 3)] = '' + (record.um.cumBudget || 0);

              budget.toRender.list = [];
              budget.list.forEach(function (record) {
                var r = angular.copy(record.um);
                r.date = record.date;
                budget.toRender.list.push(r);
              });
              budget.toRender.totalBudget = consAnResp.result.um.budget;
              budget.toRender.totalConsumption = consAnResp.result.um.cons;
              budget.toRender.season = consAnResp.result.um.season;
              budget.toRender.deltaSeason = consAnResp.result.um.deltaSeason;
              budget.toRender.deltaTech = consAnResp.result.um.deltaTech;
              budget.toRender.percentage = consAnResp.result.um.percentage;
              budget.toRender.um = consAnResp.result.um.percentage;
            }

            graphData.push(grpDT);
            graphDataCumulative.push(grpDTCumulative);
          });

          if(angular.isDefined(consAnResp.result) && consAnResp.result.um){
            budget.um = consAnResp.result.um;
            budget.totalBudget = consAnResp.result.um.budget;
            budget.totalConsumption = consAnResp.result.um.cons;
          }
          if(angular.isDefined(consAnResp.result) && consAnResp.result.std){
            budget.totalBudgetStd = consAnResp.result.std.budget;
            budget.totalConsumptionStd = consAnResp.result.std.cons;
            budget.std = consAnResp.result.std;
            budget.season = consAnResp.result.std.season;
            budget.deltaSeason = consAnResp.result.std.deltaSeason;
            budget.deltaTech = consAnResp.result.std.deltaTech;
            budget.percentage = consAnResp.result.std.percentage;
          }

          //lo lascio qua budgetComparison, ma in realtà forse non verrà più usato..
          budget.budgetComparison = consAnResp.result.budget?(consAnResp.result.consumptionStd-consAnResp.result.budget)*1.0/consAnResp.result.budget*100:0;

          if(vector && angular.isUndefined(vector.UUID)) {
            selectedBudgets = consAnResp.result.budgetCodes;
            refreshSelectedBudgets(selectedBudgets);
            $scope.analisysHeaderInfos = {
              period: $scope.datePicker.from.getFullYear() + ' - ' + $scope.datePicker.to.getFullYear()
            };
            $scope.analisysHeaderInfos.budgets = '';
            var sep = '';
            $scope.selectedBudgets.selected.forEach(function(bc) {
              if(bc){
                $scope.analisysHeaderInfos.budgets += sep + bc.code;
                sep = ', ';
              }
            });
            $scope.budget = budget;
          }

          // console.log(budget);
          vector.cachedData = {};
          vector.cachedData.graphData = graphData;
          vector.cachedData.graphDataCumulative = graphDataCumulative;
          vector.cachedData.budget = budget;
          console.log(budget);
          vector.loadingPlaceHolder = {
            show: false,
            message: ''
          };
          $scope.reloadDonuts();
        }
      }
      else {
        vector.loadingPlaceHolder= {
          show: true,
          message: 'Errore durante il recupero dei dati',
          error: true
        };
      }
    });
  };


  $scope.loadVectors = function(){
    $scope.vectors = {};
    if(angular.isDefined($scope.currentVector) && angular.isDefined($scope.currentVector.model)) {
      $scope.vectors[$scope.currentVector.model.code] = $scope.currentVector;
      $scope.loadData($scope.currentVector, $scope.forceReprocessing);
    } else {
      angular.forEach($scope.allVectors, function(vector, key) {
        $scope.vectors[key] = angular.copy(vector);
        $scope.vectors[key].loadingPlaceHolder = {
          show: true,
          message: 'Caricamento dati...'
        };
        $scope.loadData($scope.vectors[key], $scope.forceReprocessing);
      });
    }
  };

  $scope.reload = function () {
    $scope.datePicker.from = $scope.dashYearsPicker.from;
    $scope.datePicker.to = $scope.dashYearsPicker.to;
    $scope.selectedBudgets.selected = [];
    $scope.loadVectors();
  };

  function refreshAvailableBudgets() {
    getAvailableBudgetCodes().then(function (list) {
      $scope.availableBudgetCodes = list;
      refreshSelectedBudgets($scope.selectedBudgets.selected);
    });
  }

  function getAvailableBudgetCodes() {
    var query = {
      from: createDate($scope.datePicker.from),
      to: createDate($scope.datePicker.to)
    };
    if($scope.type.type_id) {
      query.type = $scope.type.type_id.UUID;
    }
    return budgetFactory.budgetCodes(query).$promise.then(function (response) {
      var list = [];
      if (response.hasOwnProperty('list') && response.list.length) {
        response.list.forEach(function(item) {
          if(isAlreadySelectedBudget(item.UUID) == false) {
            list.push(item);
          }
        });
      }
      return list;
    });
  }

  function getBudgetByCodeFromAvailablesList(code) {
    for(var idx in $scope.availableBudgetCodes) {
      if($scope.availableBudgetCodes[idx].UUID === code) {
        return $scope.availableBudgetCodes[idx];
      }
    }
  }

  function isAlreadySelectedBudget(uuid) {
    if($scope.selectedBudgets && $scope.selectedBudgets.selected) {
      for(var i in $scope.selectedBudgets.selected) {
        if($scope.selectedBudgets.selected[i] && $scope.selectedBudgets.selected[i].UUID === uuid) {
          return true;
        }
      }
    }
    return false;
  }

  function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
  }


  /* **************** */
  /* **** REPORT **** */
  /* **************** */

  var REPORT_JASPER_DIRECTORY = 'reports/EMMA/Energy/'; /* path del report su jasperserver */
  var REPORT_JASPER_NAME = 'consumptionanalysis_tab_all_vectors'; /* path del report su jasperserver */
  var REPORT_XLS_JASPER_NAME = 'consumptionanalysis_tab_all_vectors_xls'; /* path del report su jasperserver */

  $scope.openDialogReport = function (extensionFile) {
    printReportConsumptionAnalysis(callJasper, extensionFile);
  };

  function printReportConsumptionAnalysis(printReport, extensionFile) {
    var message = 'Selezionare le voci da esportare';
    var listItemDialog = ngDialog.openConfirm({
      name: 'printReportConsumptionAnalysisDialog',
      closeByDocument: false,
      showClose: true,
      template: ''+
        '<div style="text-align:center"><i class="fa fa-list"></i>&nbsp; ' + message + '</div><br>' +
        '<input type="checkbox" id="input_cons" ng-init="itemList.cons=true" ng-model="itemList.cons"/> <label for="input_cons" class="control-label"> Consuntivo</label><br />' +
        '<input type="checkbox" id="input_cons_std" ng-init="itemList.cons_std=true" ng-model="itemList.cons_std"/> <label for="input_cons_std" class="control-label"> Consuntivo std</label><br />' +
        '<input type="checkbox" id="input_budget" ng-init="itemList.budget=true" ng-model="itemList.budget"/> <label for="input_budget" class="control-label"> Budget</label><br />' +
        '<input type="checkbox" id="input_season" ng-model="itemList.season"/> <label for="input_season" class="control-label"> Stagionalità</label><br />' +
        '<input type="checkbox" id="input_delta_season" ng-model="itemList.deltaSeason"/> <label for="input_delta_season" class="control-label"> Delta stagionalità</label><br />' +
        '<input type="checkbox" id="input_delta_tech" ng-model="itemList.deltaTech"/> <label for="input_delta_tech" class="control-label"> Delta tecnico</label><br />' +
        '<input type="checkbox" id="input_percentage" ng-model="itemList.percentage"/> <label for="input_percentage" class="control-label"> Scostamento percentuale</label><br />' +
        '<div class="row wrapper pull-right">' +
          '<input type="checkbox" id="split_by_counter" ng-model="splitByCounter" /> ' +
          '<label id="split_by_counter_key" for="split_by_counter" class="control-label"> Dividi per contatore</label>' +
        '</div>' +
        '<div class="row" style="text-align:center; clear: both">' +
          '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm()">Esporta</button>' +
        '</div>',
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    });

    listItemDialog.then(function() {
      /* lancia la stampa del report */
      var parametersSelected = {};
      parametersSelected['cons'] = document.getElementById("input_cons").checked;
      parametersSelected['cons_std'] = document.getElementById("input_cons_std").checked;
      parametersSelected['budget'] = document.getElementById("input_budget").checked;
      parametersSelected['season'] = document.getElementById("input_season").checked;
      parametersSelected['deltaSeason'] = document.getElementById("input_delta_season").checked;
      parametersSelected['deltaTech'] = document.getElementById("input_delta_tech").checked;
      parametersSelected['percentage'] = document.getElementById("input_percentage").checked;
      var splitByCounter = document.getElementById("split_by_counter").checked;

      if(angular.isFunction(printReport)) {
        printReport(parametersSelected, splitByCounter, extensionFile);
      }
    }, function (){ /* non fa nulla */ });
  }

  function callJasper(parametersMap, splitByCounter, extensionFile){
    var urlPrefix = DEV?'/':'/emma/';
    var endpointAddressGenericReport = 'http://' + $location.$$host + ':' + $location.$$port + urlPrefix + ENERGY_URL + '/api/report/_consumptionanalysis/_get/_url';
    var endpointAddressSingleReport = 'http://' + $location.$$host + ':' + $location.$$port + urlPrefix + ENERGY_URL + '/api/report/_consumptionanalysis/_get/_data';
    var reportNameToSave =  'report_analisi_consumi'; // nome con il quale viene salvato sul pc dell'utente
    var reportPath = REPORT_JASPER_DIRECTORY + REPORT_JASPER_NAME + '.' + extensionFile;   // dove si trova il report su jasperserver (http://172.29.100.155:7878/jasperserver) + nome report .pdf
    if(extensionFile == 'xls' || extensionFile == 'xlsx') {
      reportPath = REPORT_JASPER_DIRECTORY + REPORT_XLS_JASPER_NAME + '.' + extensionFile;   // dove si trova il report su jasperserver (http://172.29.100.155:7878/jasperserver) + nome report .xls
    }

    if(angular.isDefined($scope.datePicker.from) && angular.isDefined($scope.datePicker.to) && $scope.selectedBudgets.selected.length > 0){// obbligatori: from, to, budget
      var commission = null;
      var vectorId = null;
      var contatoreTypeId = null;
      var contatoreId = null;
      var from = null;
      var to = null;
      var budgetCodes = null;
      var parametersToPrint = null;
      /* imposto il codice della commessa */
      if(angular.isDefined(authFactory.getAuthData().info.commissions.current)){  commission = authFactory.getAuthData().info.commissions.current.code; }
      /* imposto il vettore corrente */
      if(angular.isDefined($scope.vector.id)){  vectorId = $scope.vector.id.UUID; }
      /* imposto il tipo contatore */
      if(angular.isDefined($scope.type.type_id)){ contatoreTypeId = $scope.type.type_id.UUID; }
      /* imposto il contatore */
      if(angular.isDefined($scope.contatore.contatore_id)){ contatoreId = $scope.contatore.contatore_id.UUID; }
      /* imposto la data di inizio e di fine */
      if(angular.isDefined($scope.datePicker.from)){
        from = $scope.datePicker.from.getFullYear() +'-'+ ('0'+($scope.datePicker.from.getMonth()+1)).slice(-2) +'-'+ ('0'+$scope.datePicker.from.getDate()).slice(-2);
      }
      if(angular.isDefined($scope.datePicker.to)){
        to = $scope.datePicker.to.getFullYear() +'-'+ ('0'+($scope.datePicker.to.getMonth()+1)).slice(-2) +'-'+ ('0'+$scope.datePicker.to.getDate()).slice(-2);
      }
      /* imposto i codici dei budgets */
      $scope.selectedBudgets.selected.forEach(function (object){
        if(budgetCodes == null){
          budgetCodes = object.UUID;
        } else {
          budgetCodes = budgetCodes + ',' + object.UUID;
        }
      });
      /* imposto i parametri da stampare */
      for (var key in parametersMap) {
        if (parametersMap[key]) {
          if(parametersToPrint == null){
            parametersToPrint = key;
          } else {
            parametersToPrint = parametersToPrint +','+ key;
          }
        }
      }
      endpointAddressSingleReport = replaceAll(endpointAddressSingleReport, '/', '$');
      endpointAddressGenericReport = endpointAddressGenericReport + '/' + commission + '/' + vectorId + '/' + contatoreTypeId + '/' + contatoreId + '/' + from + '/' + to
        + '/' + 'MONTHLY' + '/' + budgetCodes + '/' + splitByCounter + '/' + parametersToPrint + '/' + endpointAddressSingleReport;
      var query = '&net.sf.jasperreports.json.source=' + endpointAddressGenericReport ;
      if(extensionFile == 'xls' || extensionFile == 'xlsx') {
        query += '&ignorePagination=true';
      }
      loadingBarService.start('Generazione report in corso...');
      $http.post(APP_URL + '/rest/report/generate',
        {
          path: reportPath,
          query: query
        },
        {
          responseType: 'arraybuffer'
        }).success(function (data, status, headers, config) {
        var options;
        if(extensionFile == 'pdf'){
          options = {type: 'application/pdf'};
        } else if (extensionFile == 'xls' || extensionFile == 'xlsx') {
          options = {type: 'application/vnd.ms-excel;'};
        }
        SaveAs.download(data, reportNameToSave + '.' + extensionFile, options);
        loadingBarService.stop();
      }).error(function (data, status, headers, config) {
        loadingBarService.stop();
        toaster.pop('error', "Errore", 'Errore generazione report');
      });
    } else {
      toaster.pop('error', "Errore inserimento parametri", 'Parametri obbligatori: data inizio, data fine, almeno un budget di riferimento');
    }
  }



  /*********************/
  /**** Date picker ****/
  /*********************/

  $scope.dateOptions = {
    formatYear: 'yy',
    startingDay: 1
  };

  $scope.openFrom = function($event) {
    $scope.statusFrom.opened = true;
  };

  $scope.openTo = function($event) {
    $scope.statusTo.opened = true;
  };

  $scope.statusFrom = {
    opened: false
  };

  $scope.statusTo = {
    opened: false
  };

  function createDate(d) {
    var date = new Date(d);
    return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
  }

  var REPORT_BASE_DIR = "reports/EMMA/";
  var REPORT_API_BASE = "http://"+location.host+""+APP_URL+"/rest/report/";
  //var REPORT_API_BASE = "http://docker0.ict-group.it:7878/six/rest/report/";
  var REPORT_QUERY_BASE = "&net.sf.jasperreports.json.source="+REPORT_API_BASE;
  var currentCommission = authFactory.getAuthData().info.commissions.current;

  $scope.generateReport = function(reportPath, query){
    console.log("generation report "+(APP_URL + '/rest/report/generate')+" "+reportPath+" "+query);
    loadingBarService.start('Generazione report in corso');
    $http.post(APP_URL + '/rest/report/generate',
        {
          path: reportPath,
          query: query
        },
        {
          responseType: 'arraybuffer'
        }).
    then(function(data, status, headers, config) {
      loadingBarService.stop();
      var options = { type: 'application/pdf' };
      SaveAs.download(data, 'consumption_analisys.pdf', options);
    }, function(data, status, headers, config) {
      loadingBarService.stop();
      toaster.pop('error', "Errore", 'Errore generazione report');
      // called asynchronously if an error occurs
      // or server returns response with an error status.
    });
  };


  $scope.setCurrentVector =function (vector){
    if ($scope.currentVector == vector){
      $scope.currentVector = $scope.totVector;
    }else {
      $scope.currentVector = vector;
    }
    $scope.changedVector();
  };

  $scope.changedVector = function (){
    if ($scope.currentVector && $scope.currentVector.cachedData){
        $scope.graphData = $scope.currentVector.cachedData.graphData;
        $scope.graphDataCumulative = $scope.currentVector.cachedData.graphDataCumulative;
        $scope.budget = $scope.currentVector.cachedData.budget;
    }else {
      $scope.loadData($scope.currentVector, true);
    }
  };

  $scope.reloadDonuts = function (){
    $scope.donutDataBudget =[];
    $scope.donutDataConsumption =[];
    for (var kv in $scope.vectors) {
      if ($scope.vectors.hasOwnProperty(kv)) {
        var v = $scope.vectors[kv];
        if (v.cachedData && "Totale".localeCompare(v.model.description)!=0) {
          if (v.cachedData.budget.totalConsumptionStd > 0) {
            $scope.donutDataConsumption.push({label: v.model.description, value: v.cachedData.budget.totalConsumptionStd});
          }
          if (v.cachedData.budget.totalBudgetStd > 0) {
            $scope.donutDataBudget.push({label: v.model.description, value: v.cachedData.budget.totalBudgetStd});
          }
        }
      }
    }
  };

  /*
  Ritorna i dati in um standard (kwh) o specifica del vettore
   */
  $scope.getValues= function(vectorData){
    if (vectorData && vectorData.cachedData && vectorData.cachedData.budget) {
      if ("Totale".localeCompare(vectorData.model.description)!=0) {
        return vectorData.cachedData.budget.um;
      }else{
        return vectorData.cachedData.budget.std;
      }
    }else{
      return {};
    }
  };

  getAvailableBudgetCodes().then(function (list) {
    $scope.availableBudgetCodes = list;
    // $scope.loadData($scope.currentVector, true);
  });

  function updateContatoreTypeFilter() {
    if($scope.vector.id) {
      energyCarrierFactory.schemas({id: $scope.vector.id.UUID}).$promise.then(function (response) {
        if (errorService.handleError(response, SHOW_ERROR_POPUP)) {
          $scope.contatoreTypeFilter = { 'model.code' : response.list.join() };
        } else {
          toaster.pop('error', 'Errore', 'Errore durante il recupero dei modelli con vettore_id ' + $scope.vettore.id.code);
        }
      });
    }
  }

  $scope.toggleForceReprocessing = function() {
    $scope.forceReprocessing = !$scope.forceReprocessing;
  };

  $scope.goToAnchor = function(x) {
    // call $anchorScroll() explicitly,
    // since $location.hash hasn't changed
    $anchorScroll(x);
    window.scrollBy(0, -100);   // salto le toolbar in alto (tot. 100px)
  };

  // FIXME decommentare
  // $scope.loadVectors();
  // if($location.hash()) {
  //   $scope.goToAnchor($location.hash());
  // }



  /* ********************* */
  /* ***** SNAPSHOTS ***** */
  /* ********************* */

  $scope.allVectors = {};
  $scope.retrieveAllVectors = function() {
    recordFactory('vettoreenergetico').query({page_size: 10000, show_revision: false}).$promise.then(function (data) {
      data.list.forEach(function (value) {
        $scope.allVectors[value.model.code] = value;
      });
      $scope.allVectors[$scope.missingVector.model.code] = $scope.missingVector;
      $scope.allVectors[$scope.totVector.model.code] = $scope.totVector;
    });
  };

  $scope.retrieveAllVectors();

  $scope.loadAllSnapsDate = function() {
    // il recupero dello snapshot dell'analisi consumi richiede il recupero del budget: se non ho snap del budget
    // evito di chiamare (altrimenti la commessa 1600003 scoppia)
    $scope.getBudgetSnapDate().then(function(resp) {
      if (errorService.handleError(resp, false) && resp.result && resp.result.creationDate) {
        $scope.getConsAnalisysSnapDate();
        $scope.getDDSnapDate();
        $scope.getConsumptionsSnapDate();
      }
    });
    for (var v in $scope.allVectors) {
      // il recupero dello snapshot dell'analisi consumi richiede il recupero del budget: se non ho snap del budget
      // evito di chiamare (altrimenti la commessa 1600003 scoppia)
      $scope.getBudgetSnapDate($scope.allVectors[v]).then(function(resp) {
        if (errorService.handleError(resp, false) && resp.result && resp.result.creationDate) {
          $scope.getConsAnalisysSnapDate($scope.allVectors[v]);
          $scope.getDDSnapDate($scope.allVectors[v]);
          $scope.getConsumptionsSnapDate($scope.allVectors[v]);
        }
      });
    }
  };

  //************************************
  // Gestore loading bar e dialog
  //************************************

  var EVENTS = ['snap:creating', 'snap:removing'];
  var waitQueue = {};
  var globalResp = {};

  EVENTS.forEach(function(evt) {
    waitQueue[evt] = 0;
    $scope.$on(evt, function(event, status, component, resp) {
      $log.debug('watcher on evt = ' + evt + ' - status: ' + status + ', component: ' + component);

      var cleanGlobalResp = true;
      angular.forEach(waitQueue, function(queued) {
        if(queued > 0) {
          cleanGlobalResp = false;
        }
      });
      if(cleanGlobalResp===true) {
        globalResp = {
          messages: [],
          hasErrors: false,
          hasWarnings: false
        };
      }

      if(status == 'started') {
        waitQueue[evt]++;
        var message = 'Elaborazione...';
        if(event.name == 'snap:creating') {
            message = 'Creazione snapshot ' + component + ' ...';
        } else if(event.name == 'snap:removing') {
            message = 'Eliminazione snapshot ' + component + ' ...';
        }
        loadingBarService.start(message);
      } else if(status == 'terminated') {
        waitQueue[evt]--;
      }

      if(angular.isDefined(resp)) {
        if(resp.code && angular.isNumber(resp.code) && resp.code >= 500) {  // il backend ha sparato un'eccezione probabilmente
          globalResp.messages = globalResp.messages.concat({status: 'SEVERE', error: true, message: resp.message});
          globalResp.hasErrors = true;
        } else {
          globalResp.messages = globalResp.messages.concat(resp.messages);
          globalResp.hasErrors = globalResp.hasErrors || resp.hasErrors;
          globalResp.hasWarnings = globalResp.hasWarnings || resp.hasWarnings;
        }
      }

      var stillWait = false;
      angular.forEach(waitQueue, function(queued) {
        if(queued > 0) {
          stillWait = true;
        }
      });

      if(stillWait===false) {
        loadingBarService.stop(globalResp, component + ': messaggi');
      }
    });
  });

  //-------------------
  // Budget
  //-------------------

  $scope.loadBudgetSnapDate = function() {
    $scope.getBudgetSnapDate();
    for (var v in $scope.allVectors) {
      $scope.getBudgetSnapDate($scope.allVectors[v]);
    }
  };

  $scope.filterBdgSnapDate = 'Non presente';
  $scope.getBudgetSnapDate = function(vector) {
    if(angular.isDefined(vector)) {
      vector.bdgSnapDate = 'Non presente';
    } else {
      $scope.filterBdgSnapDate = 'Non presente';
    }
    var p = consumptionAnalysisFactory().getBudgetSnap(getQuery(vector)).$promise;
    p.then(function(resp) {
      if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
        if (resp.result && resp.result.creationDate) {
          if (angular.isDefined(vector)) {
            vector.bdgSnapDate = new Date(resp.result.creationDate);
          } else {
            $scope.filterBdgSnapDate = new Date(resp.result.creationDate);
          }
        }
      }
    });
    return p;
  };

  $scope.recreateBudgetSnap = function(vector) {
    $scope.deleteBudgetSnap(vector).then(function(r1) {
      $scope.createBudgetSnap(vector);
    });
  };

  $scope.createBudgetSnap = function(vector) {
    $scope.$broadcast('snap:creating', 'started', 'BUDGET');
    var p = consumptionAnalysisFactory().createBudgetSnap(getQuery(vector)).$promise;
    p.then(function(resp) {
      $scope.$broadcast('snap:creating', 'terminated', 'BUDGET', resp);
      if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
        // toaster.pop('success', 'Success', 'Snapshot budget creato!');
      } else {
        toaster.pop('error', 'Errore', 'Errore durante la creazione dello snapshot del budget');
      }
    });
    return p;
  };

  $scope.createAllBudgetSnap = function() {
    $scope.recreateBudgetSnap();
    angular.forEach($scope.allVectors, function(vector) {
      $scope.recreateBudgetSnap(vector);
    });
  };

  $scope.deleteBudgetSnap = function(vector){
    $scope.$broadcast('snap:removing', 'started', 'BUDGET');
    var p = consumptionAnalysisFactory().deleteBudgetSnap(getQuery(vector)).$promise;
    p.then(function(resp) {
      $scope.$broadcast('snap:removing', 'terminated', 'BUDGET', resp);
      if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
        // toaster.pop('success', 'Success', 'Snapshot budget eliminato!');
      } else {
        toaster.pop('error', 'Errore', 'Errore durante l\'eliminazione dello snapshot del budget');
      }
    });
    return p;
  };

  //-------------------
  // Contatore - Z.T.
  //-------------------

  $scope.recreateZtSnap = function() {
    $scope.deleteZtSnap(false).then(function(resp) {
      $scope.createZtSnap(true);
    });
  };

  $scope.createZtSnap = function(){
    $scope.$broadcast('snap:creating', 'started', 'corrispondenze Contatore-Zona Termica');
    var p = consumptionAnalysisFactory().createRecAssocSnap(getQuery()).$promise;
    p.then(function(resp) {
      $scope.$broadcast('snap:creating', 'terminated', 'corrispondenze Contatore-Zona Termica', resp);
    });
    return p;
  };

  $scope.deleteZtSnap = function(){
    $scope.$broadcast('snap:removing', 'started', 'corrispondenze Contatore-Zona Termica');
    var p = consumptionAnalysisFactory().deleteRecAssocSnap(getQuery()).$promise;
    p.then(function(resp) {
      $scope.$broadcast('snap:removing', 'terminated', 'corrispondenze Contatore-Zona Termica', resp);
    });
    return p;
  };

  //-------------------
  // Day Degrees
  //-------------------

  $scope.loadDDSnapsDate = function() {
    // il recupero dello snapshot dell'analisi consumi richiede il recupero del budget: se non ho snap del budget
    // evito di chiamare (altrimenti la commessa 1600003 scoppia)
    $scope.filterDDSnapDate = 'No budget snap';
    for (var v in $scope.allVectors) {
      $scope.allVectors[v].ddSnapDate = 'No budget snap';
    }
    $scope.getBudgetSnapDate().then(function (resp) {
      if (errorService.handleError(resp, false) && resp.result && resp.result.creationDate) {
        $scope.getDDSnapDate();
      }
    });
    angular.forEach($scope.allVectors, function(vector) {
      $scope.getBudgetSnapDate(vector).then(function (resp) {
        if (errorService.handleError(resp, false) && resp.result && resp.result.creationDate) {
          $scope.getDDSnapDate(vector);
        }
      });
    });
  };

  $scope.filterDDSnapDate = 'Non presente';
  $scope.getDDSnapDate = function(vector) {
    if(angular.isDefined(vector)) {
      vector.ddSnapDate = 'Non presente';
    } else {
      $scope.filterDDSnapDate = 'Non presente';
    }
    consumptionAnalysisFactory().getDDSnap(getQuery(vector)).$promise.then(function(resp) {
      if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
        if(resp.result && resp.result.creationDate) {
          if(angular.isDefined(vector)) {
            vector.ddSnapDate = new Date(resp.result.creationDate);
          } else {
            $scope.filterDDSnapDate = new Date(resp.result.creationDate);
          }
        }
      }
    });
  };

  $scope.recreateDDSnap = function(vector) {
    $scope.deleteDDSnap(vector).then(function(resp) {
      $scope.createDDSnap(vector);
    });
  };

  $scope.createDDSnap = function(vector){
    $scope.$broadcast('snap:creating', 'started', 'GRADI GIORNO');
    var p = consumptionAnalysisFactory().createDDSnap(getQuery(vector)).$promise;
    p.then(function(resp) {
      $scope.$broadcast('snap:creating', 'terminated', 'GRADI GIORNO', resp);
    });
    return p;
  };

  $scope.createAllDDSnap = function() {
    $scope.recreateDDSnap();
    angular.forEach($scope.allVectors, function(vector) {
      $scope.recreateDDSnap(vector);
    });
  };

  $scope.deleteDDSnap = function(vector){
    $scope.$broadcast('snap:removing', 'started', 'GRADI GIORNO');
    var p = consumptionAnalysisFactory().deleteDDSnap(getQuery(vector)).$promise;
    p.then(function(resp) {
      $scope.$broadcast('snap:removing', 'terminated', 'GRADI GIORNO', resp);
    });
    return p;
  };

  //-------------------
  // Consumptions
  //-------------------

  $scope.loadConsumptionsSnapsDate = function() {
    // il recupero dello snapshot dell'analisi consumi richiede il recupero del budget: se non ho snap del budget
    // evito di chiamare (altrimenti la commessa 1600003 scoppia)
    for (var v in $scope.allVectors) {
      $scope.allVectors[v].consumptionsSnapDate = 'No budget snap';
    }
    $scope.getBudgetSnapDate().then(function (resp) {
      if (errorService.handleError(resp, false) && resp.result && resp.result.creationDate) {
        $scope.getConsumptionsSnapDate();
      }
    });
    angular.forEach($scope.allVectors, function(vector) {
      $scope.getBudgetSnapDate(vector).then(function (resp) {
        if (errorService.handleError(resp, false) && resp.result && resp.result.creationDate) {
          $scope.getConsumptionsSnapDate(vector);
        }
      });
    });
  };

  $scope.filterConsumptionsSnapDate = 'Non presente';
  $scope.getConsumptionsSnapDate = function(vector) {
    if(angular.isDefined(vector)) {
      vector.consumptionsSnapDate = 'Non presente';
    } else {
      $scope.filterConsumptionsSnapDate = 'Non presente';
    }
    consumptionAnalysisFactory().getConsumptionsSnap(getQuery(vector)).$promise.then(function(resp) {
      if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
        if(resp.result && resp.result.creationDate) {
          if(angular.isDefined(vector)) {
            vector.consumptionsSnapDate = new Date(resp.result.creationDate);
          } else {
            $scope.filterConsumptionsSnapDate = new Date(resp.result.creationDate);
          }
        }
      }
    });
  };

  $scope.recreateConsumptionsSnap = function(vector) {
    $scope.deleteConsumptionsSnap(vector).then(function(resp) {
      $scope.createConsumptionsSnap(vector);
    });
  };

  $scope.createConsumptionsSnap = function(vector){
    $scope.$broadcast('snap:creating', 'started', 'CONSUMI');
    var p = consumptionAnalysisFactory().createConsumptionsSnap(getQuery(vector)).$promise;
    p.then(function(resp) {
      $scope.$broadcast('snap:creating', 'terminated', 'CONSUMI', resp);
    });
    return p;
  };

  $scope.createAllConsumptionsSnap = function() {
    $scope.recreateConsumptionsSnap();
    angular.forEach($scope.allVectors, function(vector) {
      $scope.recreateConsumptionsSnap(vector);
    });
  };

  $scope.deleteConsumptionsSnap = function(vector){
    $scope.$broadcast('snap:removing', 'started', 'CONSUMI');
    var p = consumptionAnalysisFactory().deleteConsumptionsSnap(getQuery(vector)).$promise;
    p.then(function(resp) {
      $scope.$broadcast('snap:removing', 'terminated', 'CONSUMI', resp);
    });
    return p;
  };

  //------------------------
  // Consumption Analisys
  //------------------------

  $scope.loadConsAnalisysSnapsDate = function() {
    // il recupero dello snapshot dell'analisi consumi richiede il recupero del budget: se non ho snap del budget
    // evito di chiamare (altrimenti la commessa 1600003 scoppia)
    $scope.filterConsAnalisysSnapDate = 'No budget snap';
    for (var v in $scope.allVectors) {
      $scope.allVectors[v].consAnalisysSnapDate = 'No budget snap';
    }
    $scope.getBudgetSnapDate().then(function (resp) {
      if (errorService.handleError(resp, false) && resp.result && resp.result.creationDate) {
        $scope.getConsAnalisysSnapDate();
      }
    });
    angular.forEach($scope.allVectors, function(vector) {
      $scope.getBudgetSnapDate(vector).then(function (resp) {
        if (errorService.handleError(resp, false) && resp.result && resp.result.creationDate) {
          $scope.getConsAnalisysSnapDate(vector);
        }
      });
    });
  };

  $scope.filterConsAnalisysSnapDate = 'Non presente';
  $scope.getConsAnalisysSnapDate = function(vector) {
    if(vector) {
      vector.consAnalisysSnapDate = 'Non presente';
    } else {
      $scope.filterConsAnalisysSnapDate = 'Non presente';
    }
    consumptionAnalysisFactory().getConsAnalisysSnap(getQuery(vector)).$promise.then(function(resp) {
      if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
        if(resp.result && resp.result.creationDate) {
          if(vector) {
            vector.consAnalisysSnapDate = new Date(resp.result.creationDate);
          } else {
            $scope.filterConsAnalisysSnapDate = new Date(resp.result.creationDate);
          }
        }
      }
    });
  };

  $scope.recreateConsAnalisysSnap = function(vector) {
    $scope.deleteConsAnalisysSnap(vector).then(function(resp) {
      $scope.createConsAnalisysSnap(vector);
    });
  };

  $scope.createConsAnalisysSnap = function(vector) {
    $scope.$broadcast('snap:creating', 'started', 'ANALISI CONSUMI');
    var p = consumptionAnalysisFactory().createConsAnalisysSnap(getQuery(vector)).$promise;
    p.then(function(resp) {
      $scope.$broadcast('snap:creating', 'terminated', 'ANALISI CONSUMI', resp);
    });
    return p;
  };

  $scope.createAllConsAnalisysSnap = function() {
    $scope.recreateConsAnalisysSnap();
    angular.forEach($scope.allVectors, function(vector) {
      $scope.recreateConsAnalisysSnap(vector);
    });
  };

  $scope.deleteConsAnalisysSnap = function(vector){
    $scope.$broadcast('snap:removing', 'started', 'ANALISI CONSUMI');
    var p = consumptionAnalysisFactory().deleteConsAnalisysSnap(getQuery(vector)).$promise;
    p.then(function(resp) {
      $scope.$broadcast('snap:removing', 'terminated', 'ANALISI CONSUMI', resp);
    });
    return p;
  };

  //------------------------
  // Query
  //------------------------

  function getQuery(vector) {
    $scope.budget = {list: undefined};

    //CONSUMI E BUDGET
    var query = {frequency: 'MONTHLY', from:'', to:''};
    var from = createDate($scope.datePicker.from);
    var to = createDate($scope.datePicker.to);

    if(from) {
      query.from = from;
    }
    if(to) {
      query.to = to;
    }

    if (vector && vector.UUID) {  // se ho passato un vettore specifico ignoro i filtri impostati
      query.vector_id = vector.UUID;
    } else if(!vector) {  // se non ho passato uno specifico vettore considero i filtri impostati
      if ($scope.currentVector && angular.isDefined($scope.currentVector.UUID)) {
        query.vector_id = $scope.currentVector.UUID;
      }
      if ($scope.type.type_id && angular.isDefined($scope.type.type_id.UUID)) {
        query.contatore_type = $scope.type.type_id.UUID;
      }
      if ($scope.contatore.contatore_id && angular.isDefined($scope.contatore.contatore_id.UUID)) {
        query.contatore_id = $scope.contatore.contatore_id.UUID;
      }
    }

    if ($scope.selectedBudgets.selected && $scope.selectedBudgets.selected.length > 0) {
      query.budget_codes = '';
      var sep = '';
      $scope.selectedBudgets.selected.forEach(function (b) {
        if (b) {
          query.budget_codes += sep + b.UUID;
          sep = ',';
        }
      });
    }
    return query;
  }



  /****** SIDEBAR ******/

  $scope.sidebar = false;
  $scope.toggleSidebar = function() {
    $scope.sidebar = !$scope.sidebar;
  };
});

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ConsumptionAnalysisCtrl
 * @description
 * # ConsumptionAnalysisCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/consumptionanalysis_old', {
        templateUrl: 'energy/consumptionanalysis/consumptionanalysis_old.html',
        controller: 'ConsumptionAnalysisOldCtrl'
      })
  })
  .controller('ConsumptionAnalysisOldCtrl',
  function ($scope, energyCarrierFactory, authFactory, consumptionFactory, recordFactory, budgetFactory,
            consumptionAnalysisFactory, dialogService, errorService, toaster, $window, $filter, APP_URL, $http, SaveAs) {

  var SHOW_ERROR_POPUP = true;

  $scope.contatore = {};
  $scope.type = {};
  $scope.selectedBudgets = {selected: [
    {
      code: 'test',
      description: 'Test'
    }
  ]};
  $scope.graphData =[];
  $scope.graphDataCumulative = [];
  $scope.info = authFactory.getAuthData().info;
  $scope.loadingPlaceHolder = {
    show: false,
    message: ''
  };

  $scope.totVector ={
    'total': true,
    'model':{
        description:'Totale',
      um:{
        code:'kwh'
      }
    }
  };
  $scope.vectors={totVector: $scope.totVector};
  $scope.currentVector={};

  $scope.budget = {
    code : undefined,
    description : undefined,
    list : [],
    totalConsumption : 0,
    season : 0,
    totalBudget : 0,
    deltaSeason : 0,
    deltaTech : 0
  };

  $scope.showJasper = false;

  $scope.dashYearsPicker = {
    from: new Date(new Date().getFullYear(), 0, 1),
    to: new Date(new Date().getFullYear(), 11, 31)
  };

  $scope.datePicker = {
    from: new Date(new Date().getFullYear(), 0, 1),
    to: new Date(new Date().getFullYear(), 11, 31)
  };

  $scope.availableBudgetCodes = [{
    code: 'test',
    description: 'Test'
  }];

  $scope.currentVector = $scope.totVector;
  $scope.vector = {};

  $scope.contatoreTypeFilter = { 'model.code' : ''};

    $scope.forceReprocessing = false;


  $scope.$watchCollection('type',
    function (newValue, oldValue) {
      if(newValue !== oldValue) {
        $scope.contatore = {};
        refreshAvailableBudgets();
      }
    }
  );

  $scope.$watchCollection('contatore',
    function (newValue, oldValue) {
      if(newValue !== oldValue){
        refreshAvailableBudgets();
      }
    }
  );

  $scope.$watchCollection('datePicker',
    function (newValue, oldValue) {
      if(newValue !== oldValue){
        $scope.selectedBudgets.selected = [];
        refreshAvailableBudgets();
      }
    }
  );

  $scope.$watchCollection('dashYearsPicker',
    function (newValue, oldValue) {
        $scope.reload();
    }
  );

  $scope.$watch(function() {return $scope.currentVector;}, function(newVal, oldVal) {
    if(angular.isUndefined($scope.currentVector)) {
      $scope.currentVector = $scope.totVector;
    }
  });

  $scope.$watch(function() {return $scope.vector.id;}, function(newVal, oldVal) {
    if(angular.isDefined(newVal) && newVal !== oldVal) {
      updateContatoreTypeFilter();
    } else {
      $scope.type = {};
    }
  });

  function refreshSelectedBudgets(selected) {
    if(angular.isDefined(selected) && angular.isArray(selected) && selected.length > 0) {
      var old = angular.copy(selected); // se gli viene passato $scope.selectedBudgets.selected lo copio, altrimenti non funziona più una fava visto che lo resetto a []
      $scope.selectedBudgets.selected = [];
      old.forEach(function (bc) {
        // MODIFICATO
        var result = getBudgetByCodeFromAvailablesList(bc);
        if (angular.isDefined(result)) {
          $scope.selectedBudgets.selected.push(result);
        }
      });
    }
  }

  $scope.loadData = function (vector, select) {
    $scope.graphData =[];
    $scope.graphDataCumulative =[];
    $scope.budget = {list: undefined};
    $scope.showJasper = true;

    if(select) {
      $scope.loadingPlaceHolder = {
        show: true,
        message: 'Caricamento dati...'
      };
    }

    vector.loadingPlaceHolder= {
      show: true,
      message: 'Caricamento dati...'
    };

    //CONSUMI E BUDGET
    var query = {frequency: 'MONTHLY', from:'', to:''};
    var from = createDate($scope.datePicker.from);
    var to = createDate($scope.datePicker.to);

    if(from) {
      query.from = from;
    }
    if(to) {
      query.to = to;
    }
    if($scope.type.type_id) {
      query.contatore_type = $scope.type.type_id.UUID;
    }
    if($scope.contatore.contatore_id) {
      query.contatore_id = $scope.contatore.contatore_id.UUID;
    }
    if($scope.selectedBudgets.selected && $scope.selectedBudgets.selected.length > 0) {
      query.budget_codes = '';
      var sep = '';
      $scope.selectedBudgets.selected.forEach(function(b) {
        if(b) {
          query.budget_codes += sep + b.UUID;
          sep = ',';
        }
      });
    }
    if(vector) {
      query.vector_id = vector.UUID;
    }
    if($scope.forceReprocessing) {
      query.force_reprocessing = $scope.forceReprocessing;
    }

    var promise = consumptionAnalysisFactory().getConsumptionAnalysis(query).$promise;
    promise.then(function (consAnResp) {
      if(errorService.handleError(consAnResp)) {
        console.log(consAnResp);
        var budget = {}, graphData =[], graphDataCumulative=[], selectedBudgets = [];
        if(consAnResp.list){
          budget.list = consAnResp.list;
          angular.forEach(consAnResp.list, function (record, idx) {
            var grpDT = {
              'date': Date.parse(record.date)
            };
            var grpDTCumulative = {
              'date': Date.parse(record.date)
            };

            budget.toRender = {};
            if(vector == $scope.totVector) {
              grpDT['consumi ' + $filter('number')(consAnResp.std.cons, 3)] = '' + record.std.cons;
              grpDT['budget ' + $filter('number')(consAnResp.std.budget, 3)] = '' + record.std.budget;
              grpDT['stagionalita ' + $filter('number')(consAnResp.std.season, 3)] = '' + record.std.season;

              grpDTCumulative['consumi ' + $filter('number')(consAnResp.std.cons, 3)] = '' + (record.std.cumCons || 0);
              grpDTCumulative['budget ' + $filter('number')(consAnResp.std.budget, 3)] = '' + (record.std.cumBudget || 0);

              budget.toRender.list = [];
              budget.list.forEach(function (record) {
                var r = angular.copy(record.std);
                r.date = record.date;
                budget.toRender.list.push(r);
              });
              budget.toRender.totalBudget = consAnResp.std.budget;
              budget.toRender.totalConsumption = consAnResp.std.cons;
              budget.toRender.season = consAnResp.std.season;
              budget.toRender.deltaSeason = consAnResp.std.deltaSeason;
              budget.toRender.deltaTech = consAnResp.std.deltaTech;
              budget.toRender.percentage = consAnResp.std.percentage;

            } else {
              grpDT['consumi ' + $filter('number')(consAnResp.um.cons, 3)] = '' + record.um.cons;
              grpDT['budget ' + $filter('number')(consAnResp.um.budget, 3)] = '' + record.um.budget;
              grpDT['stagionalita ' + $filter('number')(consAnResp.um.season, 3)] = '' + record.um.season;

              grpDTCumulative['consumi ' + $filter('number')(consAnResp.um.cons, 3)] = '' + (record.um.cumCons || 0);
              grpDTCumulative['budget ' + $filter('number')(consAnResp.um.budget, 3)] = '' + (record.um.cumBudget || 0);

              budget.toRender.list = [];
              budget.list.forEach(function (record) {
                var r = angular.copy(record.um);
                r.date = record.date;
                budget.toRender.list.push(r);
              });
              budget.toRender.totalBudget = consAnResp.um.budget;
              budget.toRender.totalConsumption = consAnResp.um.cons;
              budget.toRender.season = consAnResp.um.season;
              budget.toRender.deltaSeason = consAnResp.um.deltaSeason;
              budget.toRender.deltaTech = consAnResp.um.deltaTech;
              budget.toRender.percentage = consAnResp.um.percentage;
              budget.toRender.um = consAnResp.um.percentage;
            }

            $scope.um = $scope.currentVector.model.um.code;

            graphData.push(grpDT);
            graphDataCumulative.push(grpDTCumulative);
          });
        }

        if(consAnResp.um){
          budget.um = consAnResp.um;
          budget.totalBudget = consAnResp.um.budget;
          budget.totalConsumption = consAnResp.um.cons;
        }
        if(consAnResp.std){
          budget.totalBudgetStd = consAnResp.std.budget;
          budget.totalConsumptionStd = consAnResp.std.cons;
          budget.std = consAnResp.std;
          budget.season = consAnResp.std.season;
          budget.deltaSeason = consAnResp.std.deltaSeason;
          budget.deltaTech = consAnResp.std.deltaTech;
          budget.percentage = consAnResp.std.percentage;
        }

        //lo lascio qua budgetComparison, ma in realtà forse non verrà più usato..
        budget.budgetComparison = consAnResp.budget?(consAnResp.consumptionStd-consAnResp.budget)*1.0/consAnResp.budget*100:0;
        selectedBudgets = consAnResp.budgetCodes;

        // console.log(budget);

        if(select) {
          $scope.graphData = graphData;
          $scope.graphDataCumulative = graphDataCumulative;
          $scope.budget = budget;
          refreshSelectedBudgets(selectedBudgets);

          $scope.analisysHeaderInfos = {
            period: $scope.datePicker.from.getFullYear() + ' - ' + $scope.datePicker.to.getFullYear()
          };
          $scope.analisysHeaderInfos.budgets = '';
          var sep = '';
          $scope.selectedBudgets.selected.forEach(function(bc) {
            if(bc){
              $scope.analisysHeaderInfos.budgets += sep + bc.code;
              sep = ', ';
            }
          });
          $scope.loadingPlaceHolder = {
            show: false,
            message: ''
          };
        }
        vector.cachedData = {};
        vector.cachedData.graphData = graphData;
        vector.cachedData.graphDataCumulative = graphDataCumulative;
        vector.cachedData.budget = budget;
        console.log(budget);
        vector.loadingPlaceHolder = {
          show: false,
          message: ''
        };
        $scope.reloadDonuts();
      }
      else {
        vector.loadingPlaceHolder= {
          show: true,
          message: 'Errore durante il recupero dei dati',
          error: true
        };

        if(select) {
          $scope.loadingPlaceHolder = {
            show: true,
            message: 'Errore durante il recupero dei dati',
            error: true
          };
        }
      }
    });
    $scope.forceReprocessing = false;
  };


  $scope.loadVectors = function(){
    recordFactory('vettoreenergetico').query({page_size: 10000, show_revision: false}).$promise.then(function (data) {
      data.list.forEach(function (value) {
        $scope.vectors[value.model.code] = value;
        $scope.loadData(value, false);
      });
      // Consumi senza vettore energetico (sono errori di dati sull'indice)
      var value = {
        schemaCode: 'vettoreenergetico',
        UUID: 'missing',
        model: {
          code: 'missing',
          description: 'No vett. energ.',
          um: {type: 'um', UUID: 'kwh', code: 'kwh', description: 'kWh'},
          color: '#b3b3cc',
          text_color: 'red'
        }
      };
      $scope.vectors['missing'] = value;
      $scope.loadData(value, false);

    });
  };

  $scope.reload = function () {
    $scope.datePicker.from = $scope.dashYearsPicker.from;
    $scope.datePicker.to = $scope.dashYearsPicker.to;
    $scope.selectedBudgets.selected = [];
    $scope.loadVectors();
    $scope.loadData($scope.currentVector, true);
  };

  function refreshAvailableBudgets() {
    getAvailableBudgetCodes().then(function (list) {
      $scope.availableBudgetCodes = list;
      refreshSelectedBudgets($scope.selectedBudgets.selected);
    });
  }

  function getAvailableBudgetCodes() {
    var query = {
      from: createDate($scope.datePicker.from),
      to: createDate($scope.datePicker.to)
    };
    if($scope.type.type_id) {
      query.type = $scope.type.type_id.UUID;
    }
    return budgetFactory.budgetCodes(query).$promise.then(function (response) {
      var list = [];
      if (response.hasOwnProperty('list') && response.list.length) {
        response.list.forEach(function(item) {
          if(isAlreadySelectedBudget(item.UUID) == false) {
            list.push(item);
          }
        });
      }
      return list;
    });
  }

  function getBudgetByCodeFromAvailablesList(code) {
    for(var idx in $scope.availableBudgetCodes) {
      if($scope.availableBudgetCodes[idx].UUID === code) {
        return $scope.availableBudgetCodes[idx];
      }
    }
  }

  function isAlreadySelectedBudget(uuid) {
    if($scope.selectedBudgets && $scope.selectedBudgets.selected) {
      for(var i in $scope.selectedBudgets.selected) {
        if($scope.selectedBudgets.selected[i] && $scope.selectedBudgets.selected[i].UUID === uuid) {
          return true;
        }
      }
    }
    return false;
  }



  /*********************/
  /**** Date picker ****/
  /*********************/

  $scope.dateOptions = {
    formatYear: 'yy',
    startingDay: 1
  };

  $scope.openFrom = function($event) {
    $scope.statusFrom.opened = true;
  };

  $scope.openTo = function($event) {
    $scope.statusTo.opened = true;
  };

  $scope.statusFrom = {
    opened: false
  };

  $scope.statusTo = {
    opened: false
  };

  function createDate(d) {
    var date = new Date(d);
    return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
  }

  var REPORT_BASE_DIR = "reports/EMMA/";
  var REPORT_API_BASE = "http://"+location.host+""+APP_URL+"/rest/report/";
  //var REPORT_API_BASE = "http://docker0.ict-group.it:7878/six/rest/report/";
  var REPORT_QUERY_BASE = "&net.sf.jasperreports.json.source="+REPORT_API_BASE;
  var currentCommission = authFactory.getAuthData().info.commissions.current;

  $scope.generateReport = function(reportPath, query){
    console.log("generation report "+(APP_URL + '/rest/report/generate')+" "+reportPath+" "+query);
    dialogService.loading('Generazione report in corso');
    $http.post(APP_URL + '/rest/report/generate',
        {
          path: reportPath,
          query: query
        },
        {
          responseType: 'arraybuffer'
        }).
    then(function(data, status, headers, config) {
      dialogService.stopLoading();
      var options = { type: 'application/pdf' };
      SaveAs.download(data, 'consumption_analisys.pdf', options);
    }, function(data, status, headers, config) {
      dialogService.stopLoading();
      toaster.pop('error', "Errore", 'Errore generazione report');
      // called asynchronously if an error occurs
      // or server returns response with an error status.
    });
  };

  $scope.openAnalysisOne = function(){
    var reportFile = "Test_Budget_graph_split.pdf";
    console.log(JSON.stringify($scope.selectedBudgets.selected[0]));
    var query = REPORT_QUERY_BASE + "chart/analysis/" + currentCommission.code + "/" + $scope.datePicker.from.getFullYear() + "/" + $scope.selectedBudgets.selected[0].UUID;
    $scope.generateReport(REPORT_BASE_DIR+reportFile, query);
    //$window.open('/jasperserver/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FEMMA&reportUnit=%2Freports%2FEMMA%2FTest_Budget_graph_split&j_username=jasperadmin&j_password=jasperadmin', '_blank');
  };

  $scope.openAnalysisTwo = function(){
    //$window.open('/jasperserver/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FEMMA&reportUnit=%2Freports%2FEMMA%2FTest_Budget_graph_trend_consumptive&j_username=jasperadmin&j_password=jasperadmin', '_blank');
    var reportFile = "Test_Budget_graph_trend_consumptive.pdf";
    var query = REPORT_QUERY_BASE + "chart/analysis/" + currentCommission.code + "/" + $scope.datePicker.from.getFullYear() + "/" + $scope.selectedBudgets.selected[0].UUID;
    $scope.generateReport(REPORT_BASE_DIR+reportFile, query);
  };

  $scope.openAnalysisThree = function(){
    //$window.open('/jasperserver/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FEMMA&reportUnit=%2Freports%2FEMMA%2FTest_Budget_graph_lines&j_username=jasperadmin&j_password=jasperadmin', '_blank');
    var reportFile = "Test_Budget_graph_lines.pdf";
    var query = REPORT_QUERY_BASE + "chart/analysis/" + currentCommission.code + "/" + $scope.datePicker.from.getFullYear() + "/" + $scope.selectedBudgets.selected[0].UUID;
    $scope.generateReport(REPORT_BASE_DIR+reportFile, query);
  };


  $scope.setCurrentVector =function (vector){
    if ($scope.currentVector == vector){
      $scope.currentVector = $scope.totVector;
    }else {
      $scope.currentVector = vector;
    }
    $scope.changedVector();
  };

  $scope.changedVector = function (){
    if ($scope.currentVector && $scope.currentVector.cachedData){
        $scope.graphData = $scope.currentVector.cachedData.graphData;
        $scope.graphDataCumulative = $scope.currentVector.cachedData.graphDataCumulative;
        $scope.budget = $scope.currentVector.cachedData.budget;
    }else {
      $scope.loadData($scope.currentVector, true);
    }
  };

  $scope.reloadDonuts = function (){
    $scope.donutDataBudget =[];
    $scope.donutDataConsumption =[];
    for (var kv in $scope.vectors) {
      if ($scope.vectors.hasOwnProperty(kv)) {
        var v = $scope.vectors[kv];
        if (v.cachedData && "Totale".localeCompare(v.model.description)!=0) {
          if (v.cachedData.budget.totalConsumptionStd > 0) {
            $scope.donutDataConsumption.push({label: v.model.description, value: v.cachedData.budget.totalConsumptionStd});
          }
          if (v.cachedData.budget.totalBudgetStd > 0) {
            $scope.donutDataBudget.push({label: v.model.description, value: v.cachedData.budget.totalBudgetStd});
          }
        }
      }
    }
  };

  /*
  Ritorna i dati in um standard (kwh) o specifica del vettore
   */
  $scope.getValues= function(vectorData){
    if (vectorData && vectorData.cachedData && vectorData.cachedData.budget) {
      if ("Totale".localeCompare(vectorData.model.description)!=0) {
        return vectorData.cachedData.budget.um;
      }else{
        return vectorData.cachedData.budget.std;
      }
    }else{
      return {};
    }
  };

  getAvailableBudgetCodes().then(function (list) {
    $scope.availableBudgetCodes = list;
    $scope.loadData($scope.currentVector, true);
  });

  function updateContatoreTypeFilter() {
    if($scope.vector.id) {
      energyCarrierFactory.schemas({id: $scope.vector.id.UUID}).$promise.then(function (response) {
        if (errorService.handleError(response, SHOW_ERROR_POPUP)) {
          $scope.contatoreTypeFilter = { 'model.code' : response.list.join() };
        } else {
          toaster.pop('error', 'Errore', 'Errore durante il recupero dei modelli con vettore_id ' + $scope.vettore.id.code);
        }
      });
    }
  }

    $scope.toggleForceReprocessing = function() {
      $scope.forceReprocessing = !$scope.forceReprocessing;
    };
});

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ConsumptionAnalysisCrossCtrl
 * @description
 * # ConsumptionAnalysisCrossCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/consumptionanalysiscross', {
        templateUrl: 'energy/consumptionanalysis/consumptionanalysiscross.html',
        controller: 'ConsumptionAnalysisCrossCtrl'
      })
  })
  .controller('ConsumptionAnalysisCrossCtrl',
  function ($scope, energyCarrierFactory, authFactory, consumptionFactory, recordFactory, budgetFactory, $q, ENERGY_URL, DEV,
            consumptionAnalysisFactory, $location, $anchorScroll, dialogService, errorService, toaster, $window, commissionFactory,
            $filter, APP_URL, $http, SaveAs, $log, cfpLoadingBar, loadingBarService, ngDialog) {

  var SHOW_ERROR_POPUP = true;

  $scope.type = {};
  $scope.currentVector = {};
  $scope.vector = {};
  $scope.commissionList = [];
  $scope.commissions = {  selected: []};

  $scope.contatoreTypeFilter = { 'model.code' : ''};

  $scope.datePicker = {
    from: new Date(new Date().getFullYear(), 0, 1),
    to: new Date(new Date().getFullYear(), 11, 31)
  };

  $scope.$watch(function() {return $scope.vector.id;}, function(newVal, oldVal) {
    if(angular.isDefined(newVal) && newVal !== oldVal) {
      updateContatoreTypeFilter();
    } else {
      $scope.type = {};
    }
  });

  function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
  }


  /* **************** */
  /* **** REPORT **** */
  /* **************** */

    function dateTimeStringFormatted (date) {
      var dateStr = '';
      if(date instanceof Date){
        dateStr = date.getDate() + "_" + (date.getMonth() + 1) + "_" + date.getFullYear() + "_" + date.getHours() + "_" + date.getMinutes() + "_" + date.getSeconds();
      }
      return dateStr;
    }

  var REPORT_JASPER_DIRECTORY = 'reports/EMMA/Energy/'; /* path del report su jasperserver */
  var REPORT_JASPER_NAME = 'consumptionanalysis_cross_tab_all_vectors'; /* path del report su jasperserver */
  var REPORT_XLS_JASPER_NAME = 'consumptionanalysis_cross_tab_all_vectors_xls'; /* path del report su jasperserver */

  $scope.openDialogReport = function (extensionFile) {
    printReportConsumptionAnalysis(callJasper, extensionFile);
  };

  function printReportConsumptionAnalysis(printReport, extensionFile) {
    var message = 'Selezionare le voci da esportare';
    var listItemDialog = ngDialog.openConfirm({
      name: 'printReportConsumptionAnalysisDialog',
      closeByDocument: false,
      showClose: true,
      template: ''+
        '<div style="text-align:center"><i class="fa fa-list"></i>&nbsp; ' + message + '</div><br>' +
        '<input type="checkbox" id="input_cons" ng-init="itemList.cons=true" ng-model="itemList.cons"/> <label for="input_cons" class="control-label"> Consuntivo</label><br />' +
        '<input type="checkbox" id="input_cons_std" ng-init="itemList.cons_std=true" ng-model="itemList.cons_std"/> <label for="input_cons_std" class="control-label"> Consuntivo std</label><br />' +
        '<input type="checkbox" id="input_budget" ng-init="itemList.budget=true" ng-model="itemList.budget"/> <label for="input_budget" class="control-label"> Budget</label><br />' +
        '<input type="checkbox" id="input_season" ng-model="itemList.season"/> <label for="input_season" class="control-label"> Stagionalità</label><br />' +
        '<input type="checkbox" id="input_delta_season" ng-model="itemList.deltaSeason"/> <label for="input_delta_season" class="control-label"> Delta stagionalità</label><br />' +
        '<input type="checkbox" id="input_delta_tech" ng-model="itemList.deltaTech"/> <label for="input_delta_tech" class="control-label"> Delta tecnico</label><br />' +
        '<input type="checkbox" id="input_percentage" ng-model="itemList.percentage"/> <label for="input_percentage" class="control-label"> Scostamento percentuale</label><br />' +
        '<div class="row wrapper pull-right">' +
          '<input type="checkbox" id="split_by_counter" ng-model="splitByCounter" /> ' +
          '<label id="split_by_counter_key" for="split_by_counter" class="control-label"> Dividi per contatore</label>' +
        '</div>' +
        '<div class="row" style="text-align:center; clear: both">' +
          '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm()">Esporta</button>' +
        '</div>',
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    });
    listItemDialog.then(function() {
      /* lancia la stampa del report */
      var parametersSelected = {};
      parametersSelected['cons'] = document.getElementById("input_cons").checked;
      parametersSelected['cons_std'] = document.getElementById("input_cons_std").checked;
      parametersSelected['budget'] = document.getElementById("input_budget").checked;
      parametersSelected['season'] = document.getElementById("input_season").checked;
      parametersSelected['deltaSeason'] = document.getElementById("input_delta_season").checked;
      parametersSelected['deltaTech'] = document.getElementById("input_delta_tech").checked;
      parametersSelected['percentage'] = document.getElementById("input_percentage").checked;
      var splitByCounter = document.getElementById("split_by_counter").checked;
      if(angular.isFunction(printReport)) {
        printReport(parametersSelected, splitByCounter, extensionFile);
      }
    }, function (){ /* non fa nulla */ });
  }

  function callJasper(parametersMap, splitByCounter, extensionFile){
    var urlPrefix = DEV?'/':'/emma/';
    var endpointAddressGenericReport = 'http://' + $location.$$host + ':' + $location.$$port + urlPrefix + ENERGY_URL + '/api/report/_consumptionanalysis/_get/_cross';
    var endpointAddressSingleReport = 'http://' + $location.$$host + ':' + $location.$$port + urlPrefix + ENERGY_URL + '/api/report/_consumptionanalysis/_get/_data';
    var reportNameToSave =  'report_analisi_consumi_multicommessa_' + dateTimeStringFormatted(new Date()); // nome con il quale viene salvato sul pc dell'utente
    // dove si trova il report su jasperserver (http://172.29.100.155:7878/jasperserver) + nome report .pdf
    var reportPath = REPORT_JASPER_DIRECTORY + REPORT_JASPER_NAME + '.' + extensionFile;
    if(extensionFile == 'xls' || extensionFile == 'xlsx') {
      // dove si trova il report su jasperserver (http://172.29.100.155:7878/jasperserver) + nome report .xls
      reportPath = REPORT_JASPER_DIRECTORY + REPORT_XLS_JASPER_NAME + '.' + extensionFile;
    }
    if(angular.isDefined($scope.datePicker.from) && angular.isDefined($scope.datePicker.to) && $scope.commissions.selected.length > 0){ // obbligatori: from, to, commesse
      var from = $scope.datePicker.from.getFullYear() +'-'+ ('0'+($scope.datePicker.from.getMonth()+1)).slice(-2) +'-'+ ('0'+$scope.datePicker.from.getDate()).slice(-2);
      var to   = $scope.datePicker.to.getFullYear() +'-'+ ('0'+($scope.datePicker.to.getMonth()+1)).slice(-2) +'-'+ ('0'+$scope.datePicker.to.getDate()).slice(-2);

      var commissions = null;
      var vectorId = null;
      var contatoreTypeId = null;
      var parametersToPrint = null;
      /* scarico i codici delle commesse */
      $scope.commissions.selected.forEach(function (c, index){
        if(index == 0){
          commissions = c.key;
        } else {
          commissions = commissions + ',' + c.key;
        }
      });
      /* imposto il vettore corrente */
      if(angular.isDefined($scope.vector.id)){  vectorId = $scope.vector.id.UUID; }
      /* imposto il tipo contatore */
      if(angular.isDefined($scope.type.type_id)){ contatoreTypeId = $scope.type.type_id.UUID; }
      /* imposto i parametri da stampare */
      for (var key in parametersMap) {
        if (parametersMap[key]) {
          if(parametersToPrint == null){
            parametersToPrint = key;
          } else {
            parametersToPrint = parametersToPrint +','+ key;
          }
        }
      }
      endpointAddressSingleReport = replaceAll(endpointAddressSingleReport, '/', '$');
      endpointAddressGenericReport = endpointAddressGenericReport + '/' + commissions + '/' + vectorId + '/' + contatoreTypeId + '/' + from + '/' + to
        + '/' + 'MONTHLY'  + '/' + splitByCounter + '/' + parametersToPrint + '/' + endpointAddressSingleReport;
      var query = '&net.sf.jasperreports.json.source=' + endpointAddressGenericReport ;
      if(extensionFile == 'xls' || extensionFile == 'xlsx') {
        query += '&ignorePagination=true';
      }
      loadingBarService.start('Generazione report in corso...');
      $http.post(APP_URL + '/rest/report/generate',
        {
          path: reportPath,
          query: query
        },
        {
          responseType: 'arraybuffer'
        }).success(function (data, status, headers, config) {
        var options;
        if(extensionFile == 'pdf'){
          options = {type: 'application/pdf'};
        } else if (extensionFile == 'xls' || extensionFile == 'xlsx') {
          options = {type: 'application/vnd.ms-excel;'};
        }
        SaveAs.download(data, reportNameToSave + '.' + extensionFile, options);
        loadingBarService.stop();
      }).error(function (data, status, headers, config) {
        loadingBarService.stop();
        toaster.pop('error', "Errore", 'Errore generazione report');
      });
    } else {
      toaster.pop('error', "Errore inserimento parametri", 'Parametri obbligatori: data inizio, data fine, commessa');
    }
  }



  /*********************/
  /**** Date picker ****/
  /*********************/

  $scope.dateOptions = {
    formatYear: 'yy',
    startingDay: 1
  };

  $scope.openFrom = function($event) {
    $scope.statusFrom.opened = true;
  };

  $scope.openTo = function($event) {
    $scope.statusTo.opened = true;
  };

  $scope.statusFrom = {
    opened: false
  };

  $scope.statusTo = {
    opened: false
  };

  var REPORT_BASE_DIR = "reports/EMMA/";
  var REPORT_API_BASE = "http://"+location.host+""+APP_URL+"/rest/report/";
  //var REPORT_API_BASE = "http://docker0.ict-group.it:7878/six/rest/report/";
  var REPORT_QUERY_BASE = "&net.sf.jasperreports.json.source="+REPORT_API_BASE;
  var currentCommission = authFactory.getAuthData().info.commissions.current;

  $scope.generateReport = function(reportPath, query){
    console.log("generation report "+(APP_URL + '/rest/report/generate')+" "+reportPath+" "+query);
    loadingBarService.start('Generazione report in corso...');
    $http.post(APP_URL + '/rest/report/generate',
        {
          path: reportPath,
          query: query
        },
        {
          responseType: 'arraybuffer'
        }).
    then(function(data, status, headers, config) {
      loadingBarService.stop();
      var options = { type: 'application/pdf' };
      SaveAs.download(data, 'consumption_analisys.pdf', options);
    }, function(data, status, headers, config) {
      loadingBarService.stop();
      toaster.pop('error', "Errore", 'Errore generazione report');
      // called asynchronously if an error occurs or server returns response with an error status.
    });
  };


  /*
   * Ritorna i dati in um standard (kwh) o specifica del vettore
   */
  $scope.getValues = function(vectorData){
    if (vectorData && vectorData.cachedData && vectorData.cachedData.budget) {
      if ("Totale".localeCompare(vectorData.model.description)!=0) {
        return vectorData.cachedData.budget.um;
      }else{
        return vectorData.cachedData.budget.std;
      }
    }else{
      return {};
    }
  };

  function updateContatoreTypeFilter() {
    if($scope.vector.id) {
      energyCarrierFactory.schemas({id: $scope.vector.id.UUID}).$promise.then(function (response) {
        if (errorService.handleError(response, SHOW_ERROR_POPUP)) {
          $scope.contatoreTypeFilter = { 'model.code' : response.list.join() };
        } else {
          toaster.pop('error', 'Errore', 'Errore durante il recupero dei modelli con vettore_id ' + $scope.vettore.id.code);
        }
      });
    }
  }

  $scope.goToAnchor = function(x) {
    $anchorScroll(x);
    window.scrollBy(0, -100);   // salto le toolbar in alto (tot. 100px)
  };

  //------------------------
  // Commesse
  //------------------------

  $scope.loadCommissionList = function () {
    commissionFactory().getCommissionsSelectList().$promise.then(function (response){
      if(response.list){
        $scope.commissionList = response.list;
      }
    });
  };

  $scope.loadCommissionList();

  /****** SIDEBAR ******/

  $scope.sidebar = false;
  $scope.toggleSidebar = function() {
    $scope.sidebar = !$scope.sidebar;
  };
});

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ConsumptiveCtrl
 * @description
 * # ConsumptiveCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/consumptive/consumption', {
        templateUrl: 'energy/consumptive/consumptive.html',
        controller: 'ConsumptiveCtrl'
      })
      .when('/consumptive/consumption/import', {
        templateUrl: 'energy/consumptive/import.html',
        controller: 'ImportConsumptionCtrl'
      })
      .when('/consumptive/import/:multiCommission', {
        templateUrl: 'energy/consumptive/import_multicommission.html',
        controller: 'ConsumptiveCtrl'
      })
  })
  .controller('ConsumptiveCtrl', function ($scope, $routeParams, $timeout, $log, $location, authFactory, $filter,
                                           $q, dialogService, recordFactory, consumptiveFactory, consumptionFactory,
                                           evalFactory, budgetFactory, toaster, errorService, $templateCache,
                                           localStorageService, $window, loadingBarService) {

    /**** Costanti ****/
    var FREQ_MONTH = 'MONTHLY';
    var FREQ_DAY = 'DAILY';
    var DATA_READY_EVENT = 'data_ready';
    var IMPORTED_READS = 'imported_reads';
    var LOADED_READS = 'loaded_reads';
    var LOADED_BUDGET = 'loaded_budget';
    var LOADED_CONSUMPTIONS = 'loaded_consumptions';
    var CALC_CONSUMPTIONS = 'calc_consumptions';
    var LOADED_AVAILABLE_BUDGET_CODES = 'loaded_available_budget_codes';

    $scope.TYPE_BDG = 'budget';
    $scope.TYPE_MIXED = 'mixed';
    $scope.TYPE_CONSUMPTION = 'consumption';
    /**** Costanti: end ****/

    var dataReadyStatus = [];
    resetDataReadyStatus();

    var multiCommission = ($routeParams.multiCommission == 'true');
    var currentCommission = authFactory.getAuthData().info.commissions.current;

    $scope.percent = 0;
    $scope.contatoreType = {};
    $scope.contatoreTypeFilter = { 'model.code' : 'contatoreacqua,contatoreelettricita,contatoregas,contatoregpl,serbatoioinpressione,serbatoiopressioneatmosferica,contatoreteleriscaldamento,contatoreteleraffreddamento'};
    $scope.contatore = {contatore: '', obj: {}};
    $scope.fromYearPicker = {
      year: new Date().getFullYear().toString()
    };
    $scope.toYearPicker = {
      year: new Date().getFullYear().toString()
    };
    $scope.monthlyConsumptions = [];
    $scope.monthlyEvaluatedConsumptions = [];
    $scope.dailyConsumptions = [];
    $scope.totalPeriodConsumptions = {totale: 0};
    $scope.totalPeriodDays = 0;
    $scope.budget = {
      searchCode: undefined,
      list: undefined
    };
    $scope.priceList = {};
    $scope.selectedMonthDetail = {
      month: -1,
      year: -1
    };
    $scope.um = {};
    $scope.importingOperation = false;
    $scope.isImportBusy = false;
    $scope.isAllOk = true;
    $scope.sort = undefined;

    $scope.reportMessages = [];

    $scope.reportGridOptions = {
      enableSorting: true,
      exporterMenuPdf: false,
      paginationPageSizes: [10, 20, 30],
      paginationPageSize: 10,
      useExternalPagination: false,
      data: 'reportMessages',
      columnDefs: [
        {displayName: 'Stato', field: 'status', width: '100'},
        {displayName: 'Messaggio', field: 'message'}
      ]
    };

    $scope.viewGridOptions = {
      enableSorting: true,
      enableGridMenu: true,
      exporterMenuPdf: false,
      expandableRowHeight: 180,
      paginationPageSizes: [10, 20, 30],
      paginationPageSize: 10,
      useExternalPagination: true,
      gridMenuCustomItems: [
        {
          title: 'Pulisci',
          action: function ($event) {
            $scope.resetGrid();
          },
          order: 210
        }
      ],
      onRegisterApi: onRegisterApiCallback
    };

    function cellClassFormatter( grid, row, col, rowRenderIndex, colRenderIndex ) {
      var classes = '';
      var sep = '';
      if(row.entity[col.field] < 0) {
        classes += sep + 'warningRead';
        sep = ' ';
      }
      classes += sep + ((row.entity.reset === true) ? 'resetRead' : '');
      classes += ' ' + ((row.entity.sixImportStatus === 'errore') ? 'errorRead' : '');
      classes += ' ' + ((row.entity.automatic === true) ? 'automaticRead' : '');
      return classes;
    }

    function cellTooltipFormatter( row, col ) {
      if(row.entity[col.field] < 0) {
        return 'Lettura negativa!!';
      }
      if (row.entity.reset === true) {
        return 'Lettura con cambio contatore';
      }
      if (row.entity.automatic === true) {
        return 'Lettura prevista';
      }
      return 'Lettura';
    }

    function isCellEditable(scope) {
      var writePerm = $scope.isWritePermAllowed();
      $log.log($scope.importingOperation + ' ' + scope.row.entity.UUID + ' ' + writePerm);
      return $scope.importingOperation === false && !scope.row.entity.UUID && writePerm === true;
    }

    $scope.downloadTemplate = function(){
        var anchor = $('#linkToTemplate');
        var url = anchor.attr("href");
        anchor.click(function (e) {
            e.preventDefault();
            window.location.href = url;
        });
        anchor.click();
    };

    /***************/
    /**** READS ****/
    /***************/

    $scope.resetGrid = function() {
      $scope.reportMessages = [];
      $scope.viewGridOptions.data = [];
      $scope.viewGridOptions.xlsData = [];
    };

    $scope.importData = function () {
      $scope.isImportBusy = true;
      var toSave = [];
      var selected = $scope.gridApi.selection.getSelectedRows();
      if (!selected || !selected.length) {
        selected = $scope.viewGridOptions.data;
      }
      selected.forEach(function(item) {
        toSave.push(item);
      });
      $scope.saveOrUpdateReads(toSave);
    };

    function prepareDataForSaving(value) {
      var toSave = angular.copy(value);
      toSave.reads = [];
      toSave.record_id.type = $scope.contatoreType.tipo_id.UUID;
      toSave.date = toSave.data;
      delete toSave.sixImportStatus;
      delete toSave.data;
      delete toSave.um;
      delete toSave.value;
      switch($scope.contatoreType.tipo_id.UUID) {
        case 'contatoreelettricita':
          delete toSave.pod;
          if(toSave.f0) {
            toSave.reads.push({
              time_slot: 'f0',
              value: parseFloat(toSave.f0)
            });
          }
          if(toSave.f1) {
            toSave.reads.push({
              time_slot: 'f1',
              value: parseFloat(toSave.f1)
            });
          }
          if(toSave.f2) {
            toSave.reads.push({
              time_slot: 'f2',
              value: parseFloat(toSave.f2)
            });
          }
          if(toSave.f3) {
            toSave.reads.push({
              time_slot: 'f3',
              value: parseFloat(toSave.f3)
            });
          }
          delete toSave.f0;
          delete toSave.f1;
          delete toSave.f2;
          delete toSave.f3;
          break;

        case 'contatoregas':
          delete toSave.pdr;
          if(toSave.f0) {
            var read = {
              time_slot: 'f0',  // lettura
              value: parseFloat(toSave.f0)
            };
            if(toSave.correttore) {
              read.correttore = parseFloat(toSave.correttore);
            }
            toSave.reads.push(read);
          }
          delete toSave.f0;
          delete toSave.correttore;
          break;

        case 'contatoreacqua':
          delete toSave.matricola;
          if(toSave.f0) {
            toSave.reads.push({
              time_slot: 'f0',  // lettura
              value: parseFloat(toSave.f0)
            });
          }
          delete toSave.f0;
          break;

        case 'serbatoiopressioneatmosferica':
          delete toSave.cod;
          if(toSave.f0) {
            var read = {
              time_slot: 'f0',  // steccatura
              value: parseFloat(toSave.f0)
            };
            if(toSave.scarico) {
              read.scarico = parseFloat(toSave.scarico);
            }
            toSave.reads.push(read);
          }
          delete toSave.f0;
          delete toSave.scarico;
          break;

        case 'serbatoioinpressione':
          delete toSave.cod;
          if(toSave.f0) {
            var read = {
              time_slot: 'f0', // percentuale
              value: parseFloat(toSave.f0)
            };
            if(toSave.scarico) {
              read.scarico = parseFloat(toSave.scarico);
            }
            toSave.reads.push(read);
          }
          delete toSave.f0;
          delete toSave.scarico;
          break;

        case 'contatoreteleriscaldamento':
          delete toSave.cod;
          if(toSave.f0) {
            toSave.reads.push({
              time_slot: 'f0',
              value: parseFloat(toSave.f0)
            });
          }
          delete toSave.f0;
          break;

        case 'contatoreteleraffreddamento':
          delete toSave.cod;
          if(toSave.f0) {
            toSave.reads.push({
              time_slot: 'f0',
              value: parseFloat(toSave.f0)
            });
          }
          delete toSave.f0;
          break;

        default:
          toaster.pop('error', 'Errore', 'Tipo contatore non riconosciuto');
      }
      return toSave;
    }

    function prepareDataForGrid(value) {
      var result = angular.copy(value.model);
      result.UUID = value.UUID;
      result.data = result.date;
      result.um = result.um_id.UUID;
      result.reads.forEach(function(read) {
        for(var key in read) {
          if(key === 'time_slot') {
            result[read.time_slot] = read.value;
          } else {
            result[key] = read[key];
          }
        }
      });
      return result;
    }

    $scope.saveOrUpdateReads = function(reads) {
      if($scope.isWritePermAllowed() === true) {
        loadingBarService.start('Importazione...');
        startDummmyProgressBar(Math.random() * 10 + Math.random() * 10); // inizio a caso, giusto per dare la sensazione che stia facendo qualcosa...
        var error = false;
        var toSave = [];
        // Controllo se è tutto corretto
        reads.forEach(function (value) {
          var tmp = prepareDataForSaving(value);
          if (!tmp.date || !tmp.record_id.type || !tmp.record_id.code || tmp.reads.length == 0) {
            toaster.pop('error', 'Errore', 'Controllare tipo e codice contatore, data e letture');
            error = true;
            resetDummmyProgressBar();

            $scope.$broadcast(DATA_READY_EVENT, IMPORTED_READS);
            return;
          }
          toSave.push(tmp);
        });

        if (!error) {
          //consumptiveFactory.bulk(toSave).$promise.then(function (response) {
          var promise;
          if (multiCommission === true) {
            promise = consumptiveFactory.bulkMulticommission(toSave).$promise;
          } else {
            promise = consumptiveFactory.bulk(toSave).$promise;
          }

          promise.then(function (response) {
            if (errorService.handleError(response)) {
              $scope.percent = 100;
              $scope.reportMessages = response.messages;
              reads.forEach(function (item) {
                item['sixImportStatus'] = 'errore';
                response.list.forEach(function (i) { // aggiorno lo stato delle varie righe
                  if (i.model.record_id.code === item.record_id.code) {
                    item['sixImportStatus'] = 'importato';
                  }
                });
              });
            }
            else {
              $scope.percent = 0;
              $scope.reportMessages = response.messages || [];
              stopDummmyProgressBar();
              toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
            }
            $scope.isImportBusy = false;
            $scope.$broadcast(DATA_READY_EVENT, IMPORTED_READS);
            loadingBarService.stop();
          });
        }
      }
    };

    function saveOrUpdateSingleRead(value, counter, totalCount) {
      if($scope.isWritePermAllowed() === true) {
        var toSave = prepareDataForSaving(value);
        if (!toSave.date || !toSave.record_id.type || !toSave.record_id.code || toSave.reads.length == 0) {
          toaster.pop('error', 'Errore', 'Controllare tipo e codice contatore, data e letture');
          return;
        }
        if (angular.isUndefined(value.UUID)) {  // salvo una nuova lettura
          consumptiveFactory.create(toSave).$promise.then(function (data) {
            if (errorService.handleError(data)) {
              counter = counter + 1;
              $scope.percent = (counter / totalCount) * 100;
              value.UUID = data.UUID;               // aggiorno l'UUID
              value.code = data.model.code;   // aggiorno il codice
            }
          });
        }
        else {
          consumptiveFactory.update({id: value.code, type: 'read'}, toSave).$promise.then(function (data) {
            if (errorService.handleError(data)) {
              counter = counter + 1;
              $scope.percent = (counter / totalCount) * 100;
              value.UUID = data.UUID;               // aggiorno l'UUID
              value.code = data.model.code;   // aggiorno il codice
            }
          });
        }
      }
    }

    $scope.addRead = function() {
      var newRead = {};
      newRead.type = 'read';
      newRead.um_id = $scope.contatore.obj.model.um_letture_id;
      newRead.record_id = $scope.contatore.contatore_id;
      newRead.data = $filter('date')(new Date(), 'yyyy-MM-dd');
      $scope.viewGridOptions.data.unshift(newRead);
      $scope.totalResults++;
    };

    $scope.removeReadsWithDialog = function(rows) {
      dialogService.confirmDialog('Eliminare le letture?',
        function () {
          $scope.removeReads(rows);
        });
    };

    $scope.removeReads = function(rows) {
      var promises = [];
      if($scope.importingOperation === false) {
        rows.forEach(function (data) {
          if (data.UUID) {
            var prom = consumptiveFactory.delete({id: data.code}).$promise.then(function (response) {
              if (!errorService.handleError(response)) {
                toaster.pop('error', 'Errore', 'Impossibile eliminare il dato del ' + data.model.date);
              }
            });
            promises.push(prom);
          }
        });
        $q.all(promises).then(function (responses) {
          getReads();
        }); // ricarico i dati solo dopo aver eliminato tutti i selezionati
      }
      else {
        rows.forEach(function (data) {
          var idx = $scope.viewGridOptions.data.indexOf(data);
          $scope.viewGridOptions.data.splice(idx, 1);
        });
      }
    };

    $scope.loadReads = function() {
      loadingBarService.start();
      getReads();
    };

    function getConsumptiveReadsSortFields() {
      if($scope.sort && $scope.sort.fields) {
        if($scope.sort.fields === 'data') { return 'model.date'; }
        return 'model.'+$scope.sort.fields;
      }
      return 'model.date';
    }

    function getConsumptiveReadsSortDirections() {
      if($scope.sort && $scope.sort.directions) {
        return $scope.sort.directions;
      }
      return 'desc';
    }

    function getConsumptiveReadsQuery() {
      var from = $scope.fromYearPicker.year + '-01-01';
      var to = $scope.toYearPicker.year + '-12-31';
      var query = {
        page: paginationOptions.pageNumber,
        page_size: paginationOptions.pageSize,
        sort_fields: getConsumptiveReadsSortFields(),
        sort_directions: getConsumptiveReadsSortDirections()
      };
      if(from) {
        query.from = from;
      }
      if(to) {
        query.to = to;
      }
      if($scope.contatore.contatore_id) {
        query.type = $scope.contatore.contatore_id.type;
        query.id = $scope.contatore.contatore_id.UUID;
      }
      return query;
    }

    $scope.datepickerOptions = {};
    var dateCellTemplate = '<div><form name="inputForm"><div ui-grid-edit-datepicker datepicker-options="datepickerOptions" ng-class="\'colt\' + col.uid"></div></form></div>';

    var actionsCol = {
      displayName: '', field: 'id', headerCellTemplate: '<div><button class="btn btn-sm" style="background-color: transparent !important" ng-disabled="!grid.appScope.contatore.contatore_id || grid.appScope.importingOperation || grid.appScope.isWritePermAllowed() === false || grid.appScope.isClosed()" ng-click="grid.appScope.addRead()"><span class="fa fa-plus"></span></button></div>',
      cellTemplate: '<div title="Elimina"><button class="btn btn-xs" style="background-color: transparent !important" ng-click="grid.appScope.removeReadsWithDialog([row.entity])" ng-disabled="grid.appScope.isDeletePermAllowed() === false"><span class="fa fa-trash"></span></button></div>',
      width: 50, enableSorting: false, enableFiltering: false, enableCellEdit: false
    };
    function updateColumnDefs() {
      $scope.viewGridOptions.columnDefs = [];
      if($scope.contatoreType && $scope.contatoreType.tipo_id) {
        if($scope.importingOperation === true) {
          $scope.viewGridOptions.columnDefs.unshift({field: 'sixImportStatus'});
        }
        switch($scope.contatoreType.tipo_id.UUID) {
          case 'contatoreelettricita':
            $scope.viewGridOptions.columnDefs.push({ name: 'Pod', field: 'record_id.code', cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
            $scope.viewGridOptions.columnDefs.push({ name: 'Data', field: 'data', type: 'date', editableCellTemplate: dateCellTemplate, cellFilter: 'date:"yyyy-MM-dd"', cellClass: cellClassFormatter });
            $scope.viewGridOptions.columnDefs.push({ name: 'F0', field: 'f0', enableCellEdit: isCellEditable, cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
            $scope.viewGridOptions.columnDefs.push({ name: 'F1', field: 'f1', enableCellEdit: isCellEditable, cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
            $scope.viewGridOptions.columnDefs.push({ name: 'F2', field: 'f2', enableCellEdit: isCellEditable, cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
            $scope.viewGridOptions.columnDefs.push({ name: 'F3', field: 'f3', enableCellEdit: isCellEditable, cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
            break;

          case 'contatoregas':
            $scope.viewGridOptions.columnDefs.push({ name: 'PDR', field: 'record_id.code', cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
            $scope.viewGridOptions.columnDefs.push({ name: 'Data', field: 'data', type: 'date', editableCellTemplate: dateCellTemplate, cellFilter: 'date:"yyyy-MM-dd"', cellClass: cellClassFormatter });
            $scope.viewGridOptions.columnDefs.push({ name: 'Lett. contatore', field: 'f0', enableCellEdit: isCellEditable, cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
            $scope.viewGridOptions.columnDefs.push({ name: 'Lett. correttore', field: 'correttore', enableCellEdit: isCellEditable, cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
            break;

          case 'contatoreacqua':
            $scope.viewGridOptions.columnDefs.push({ name: 'Matricola', field: 'record_id.code', cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
            $scope.viewGridOptions.columnDefs.push({ name: 'Data', field: 'data', type: 'date', editableCellTemplate: dateCellTemplate, cellFilter: 'date:"yyyy-MM-dd"', cellClass: cellClassFormatter });
            $scope.viewGridOptions.columnDefs.push({ name: 'Lettura', field: 'f0', enableCellEdit: isCellEditable, cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
            break;

          case 'serbatoiopressioneatmosferica':
            $scope.viewGridOptions.columnDefs.push({ name: 'Cod.', field: 'record_id.code', cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
            $scope.viewGridOptions.columnDefs.push({ name: 'Data', field: 'data', type: 'date', editableCellTemplate: dateCellTemplate, cellFilter: 'date:"yyyy-MM-dd"', cellClass: cellClassFormatter });
            $scope.viewGridOptions.columnDefs.push({ name: 'Steccatura', field: 'f0', enableCellEdit: isCellEditable, cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
            $scope.viewGridOptions.columnDefs.push({ name: 'Scarico [l]', field: 'scarico', enableCellEdit: isCellEditable, cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
            break;

          case 'serbatoioinpressione':
            $scope.viewGridOptions.columnDefs.push({ name: 'Cod.', field: 'record_id.code', cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
            $scope.viewGridOptions.columnDefs.push({ name: 'Data', field: 'data', type: 'date', editableCellTemplate: dateCellTemplate, cellFilter: 'date:"yyyy-MM-dd"', cellClass: cellClassFormatter });
            $scope.viewGridOptions.columnDefs.push({ name: 'Percentuale', field: 'f0', enableCellEdit: isCellEditable, cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
            $scope.viewGridOptions.columnDefs.push({ name: 'Scarico [l]', field: 'scarico', enableCellEdit: isCellEditable, cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
            break;

          case 'contatoreteleriscaldamento':
          case 'contatoreteleraffreddamento':
            $scope.viewGridOptions.columnDefs.push({ name: 'Cod.', field: 'record_id.code', cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
            $scope.viewGridOptions.columnDefs.push({ name: 'Data', field: 'data', type: 'date', editableCellTemplate: dateCellTemplate, cellFilter: 'date:"yyyy-MM-dd"', cellClass: cellClassFormatter });
            $scope.viewGridOptions.columnDefs.push({ name: 'Lettura', field: 'f0', enableCellEdit: isCellEditable, cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
            break;

          default:
            toaster.pop('error', 'Errore', 'Tipo contatore non riconosciuto');
            return false;
        }
        $scope.viewGridOptions.columnDefs.push({ name: 'U.M.', field: 'um_id.code', enableCellEdit: false, cellClass: cellClassFormatter, cellTooltip: cellTooltipFormatter });
        if(multiCommission === true) {
          $scope.viewGridOptions.columnDefs.push({ name: 'Commessa', field: 'commessa', enableCellEdit: false });
        }
        $scope.viewGridOptions.columnDefs.push(actionsCol);
      }
    }

    function getReads() {
      $scope.percent = 0;
      $scope.reportMessages = [];
      $scope.viewGridOptions.useExternalPagination = true;

      $scope.viewGridOptions.data = [];

      $scope.importingOperation = false;
      updateColumnDefs();

      consumptiveFactory.consumptiveByContatoreInPeriod(getConsumptiveReadsQuery()).$promise.then(function (response) {
        if (errorService.handleError(response) && response.list) {
          response.list.forEach(function(item) {
            $scope.viewGridOptions.data.push(prepareDataForGrid(item));
          });
          $scope.totalResults = response.totalResults;
        }
        $scope.$broadcast(DATA_READY_EVENT, LOADED_READS);
      });
    }



    /**********************/
    /**** CONSUMPTIONS ****/
    /**********************/

    $scope.loadConsumptions = function() {
      var from = new Date($scope.fromYearPicker.year + '-01-01');
      var to = new Date ($scope.toYearPicker.year + '-12-31');

      resetMatrixConsumptions();
      $scope.budget.periods = undefined;

      getConsumptions(from, to, FREQ_MONTH, false);
      getConsumptions(from, to, FREQ_DAY, false);

      getEvaluatedConsumptions(from, to, FREQ_MONTH);
    };

    $scope.recalcConsumptions = function() {
      $scope.deleteConsumptions(false).then(function() {
        $scope.calcAndLoadConsumptions();
      });
    };

    $scope.calcAndLoadConsumptions = function() {
      var from = new Date($scope.fromYearPicker.year + '-01-01');
      var to = new Date ($scope.toYearPicker.year + '-12-31');

      resetMatrixConsumptions();
      $scope.budget.periods = undefined;

      getConsumptions(from, to, FREQ_MONTH, true);
    };

    function getConsumptions(fromDate, toDate, frequency, calc) {
      loadingBarService.start('Caricamento consumi...');

      var from = $filter('date')(fromDate, 'yyyy-MM-dd');
      var to = $filter('date')(toDate, 'yyyy-MM-dd');

      var query = {};
      if(from) {
        query.from = from;
      }
      if(to) {
        query.to = to;
      }
      query.frequency = frequency;
      if($scope.um.um) {
        query.um = $scope.um.um.UUID;
      }

      var promise;
      // se è un ricalcolo cancello e ricalcolo tutto
      if(calc) {
        if($scope.contatore.contatore_id) {
          query.type = $scope.contatore.contatore_id.type;
          query.id = $scope.contatore.contatore_id.UUID;
        }
        promise = consumptionFactory.calcAndGetConsumption(query).$promise;
      }
      else {
        if($scope.contatore.contatore_id) {
          query.types = $scope.contatore.contatore_id.type;
          query.codes = $scope.contatore.contatore_id.UUID;
        }
        promise = consumptionFactory.getConsumption(query).$promise;
      }

      if(frequency === FREQ_MONTH) {
        $scope.totalPeriodConsumptions = {totale: 0};
        $scope.totalPeriodDays = sixDateLib.getDatesInPeriod(fromDate, toDate).length;
      }
      promise.then(function (response) {
        if (errorService.handleError(response) && response.consumptions) {
          //console.log(response);

          // Totali
          if(frequency === FREQ_MONTH && response.consumptions) {
            response.consumptions.forEach(function (item) {
              $scope.totalPeriodConsumptions.totale += item.tot;
            });
            response.slots.forEach(function(slot) {
              $scope.totalPeriodConsumptions[slot.time_slot] = slot.consumption;
            });
          }

          response.consumptions.forEach(function (item) {
            item.elements.forEach(function(agg) {
              if(agg.tot !== 0) {
                var year = parseInt($filter('date')(agg.date, 'yyyy'));
                var month = parseInt($filter('date')(agg.date, 'M')) - 1;
                switch (frequency) {
                  case FREQ_MONTH:
                    $scope.monthlyConsumptions[year][month] = {total: agg.tot, type: $scope.TYPE_CONSUMPTION};
                    break;
                  case FREQ_DAY:
                    var day = parseInt($filter('date')(agg.date, 'd')) - 1;
                    $scope.dailyConsumptions[year][month][day] = {
                      total: agg.tot,
                      total_std: agg.tot_std,
                      slotted: agg.slots,
                      type: $scope.TYPE_CONSUMPTION
                    };
                    break;
                }
              }
            });
            $scope.um = undefined;  // Per risvegliare la lookup in modo che si accorga della modifica
            $scope.um = {um: item.um_id};
          });
          // se è un ricalcolo aggiorno anche i giornalieri
          if(calc) {
            getConsumptions(fromDate, toDate, FREQ_DAY, false);
          }
          if(frequency === FREQ_DAY) {
            $scope.graph.graphData = toObjList($scope.dailyConsumptions, false);
            $scope.graph.graphDataCum = toObjList($scope.dailyConsumptions, true);
          }

          // Dati di budget per le date dopo l'ultima lettura registrata
          if(frequency === FREQ_DAY) {
            var query = {
              from: $filter('date')(fromDate, 'yyyy-MM-dd'),
              to: $filter('date')(toDate, 'yyyy-MM-dd'),
              frequency: frequency,
              record_types: $scope.contatore.contatore_id.type,
              record_ids: $scope.contatore.contatore_id.UUID
            };
            if($scope.um.um) {
              query.um = $scope.um.um.UUID;
            }
            var sep = '';
            if($scope.budget.searchCode) {
              query.budget_codes = '';
              $scope.budget.searchCode.forEach(function (b) {
                query.budget_codes += sep + b.UUID;
                sep = ',';
              });
            }
            budgetFactory.byCodeForPeriod(query).$promise.then(function (response) {
              if (errorService.handleError(response)) {
                if(response.periods && response.periods.length > 0) {
                  $scope.budget.periods = response.periods;
                  prepareDailyBudget(response.periods);
                  receivedBudgetCodes = response.budget_codes;
                }
              } else {
                toaster.pop('error', 'Errore', 'Errore durante il recupero del budget');
              }
              $scope.$broadcast(DATA_READY_EVENT, LOADED_BUDGET);
            });
          }
        } else {
          toaster.pop('error', 'Errore', 'Errore durante il recupero dei consumi');
        }
        $scope.$broadcast(DATA_READY_EVENT, LOADED_CONSUMPTIONS);
      });
    }

    function getBudgetByCodeFromAvailablesList(code) {
      for(var idx in $scope.availableBudgetCodes) {
        if($scope.availableBudgetCodes[idx].UUID === code) {
          return $scope.availableBudgetCodes[idx];
        }
      }
      return null;
    }

    $scope.deleteConsumptionsWithDialog = function() {
      dialogService.confirmDialog('Eliminare i consumi?',
        function () {
          $scope.deleteConsumptions();
        });
    };

    $scope.deleteConsumptions = function(reload) {
      if(angular.isUndefined(reload)) { reload = true; }
      var query = {
        from: $scope.fromYearPicker.year + '-01-01',
        to: $scope.toYearPicker.year + '-12-31',
        type: $scope.contatore.contatore_id.type,
        id: $scope.contatore.contatore_id.UUID
      };
      var promise = consumptionFactory.delete(query).$promise;
      promise.then(function(response) {
        if (errorService.handleError(response)) {
          if(reload) {
            $scope.loadConsumptions();
          }
        } else {
          toaster.pop('error', 'Errore', 'Errore durante l\'eliminazione dei consumi');
        }
      });
      return promise;
    };

    function getEvaluatedConsumptions(fromDate, toDate, frequency) {
      $scope.totalEvaluatedPeriodConsumptions = [];

      var query = {
        from: fromDate,
        to: toDate,
        frequency: frequency,
        recordTypeId: $scope.contatore.contatore_id.type,
        recordId: $scope.contatore.contatore_id.UUID
      };
      if($scope.priceList.id && $scope.priceList.id.UUID) {
        query.priceListId = $scope.priceList.id.UUID;
      }
      evalFactory.evalConsumption(query).$promise.then(function (response) {
        if (errorService.handleError(response)) {

          $scope.reportMessages = response.messages;

          response.list.consumptions.forEach(function(rec) {
            rec.elements.forEach(function(date) {
              var year = parseInt($filter('date')(date.date, 'yyyy'));
              var month = parseInt($filter('date')(date.date, 'M')) - 1;
              date.slots.forEach(function(slot) {
                var yearVec = $scope.monthlyEvaluatedConsumptions[year] || [];
                yearVec[month] = slot.consumption;
                $scope.monthlyEvaluatedConsumptions[year] = yearVec;
              });
            });
          });

          // Totali
          if(frequency === FREQ_MONTH) {
            $scope.totalEvaluatedPeriodConsumptions.totale = response.list.tot;
            response.list.slots.forEach(function(slot) {
              $scope.totalEvaluatedPeriodConsumptions[slot.time_slot] = slot.consumption;
            });
          }
        } else {
          toaster.pop('error', 'Errore', 'Errore durante la valorizzazione dei consumi');
        }
      });
    }


    /****************/
    /**** BUDGET ****/
    /****************/

    function prepareDailyBudget(budget) {
      budget.forEach(function (item) {
        // $log.log(item);
        var date = new Date(item.date);
        var day = parseInt($filter('date')(date, 'd')) - 1;
        var month = parseInt($filter('date')(date, 'M')) - 1;
        var year = $filter('date')(date, 'yyyy');
        var toDate = new Date(parseInt(year), month, sixDateLib.daysNumberInMonth(parseInt(year), month) + 1);
        sixDateLib.getDatesInPeriod(date, toDate).forEach(function (d) {
          d.setHours(0);
          d.setMinutes(0);
          d.setSeconds(0);
          d.setMilliseconds(0);
          day = parseInt($filter('date')(d, 'd')) - 1;
          var value = item.tot / sixDateLib.daysNumberInMonth(parseInt(year), month);
          var daily = $scope.dailyConsumptions[year][month][day];
          var monthly = $scope.monthlyConsumptions[year][month];
          if (daily.type === undefined) {
            daily.total = value;
            daily.type = $scope.TYPE_BDG;
            monthly.total += value;
            if (monthly.type === undefined) {
              monthly.type = $scope.TYPE_BDG;
            } else if (monthly.type === $scope.TYPE_CONSUMPTION) {
              monthly.type = $scope.TYPE_MIXED;
            }
          }
        });
      });
    }

    var receivedBudgetCodes = [];

    /*
     * Restituisce una promise => possibile richiamarla anche con $scope.getAvailableBudgetCodes().$promise.then(function(resp) { ... });
     */
    $scope.getAvailableBudgetCodes = function() {
      var query = {
        from: $scope.fromYearPicker.year + '-01-01',
        to: $scope.toYearPicker.year + '-12-31'
      };
      if($scope.contatore.contatore_id) {
        query.record_id = $scope.contatore.contatore_id.UUID;
      }
      if($scope.contatoreType.tipo_id) {
        query.type = $scope.contatoreType.tipo_id.UUID;
      }
      return budgetFactory.budgetCodes(query).$promise.then(function (response) {
        // var resp = [];
        // if (response.hasOwnProperty('list') && response.list.length) {
        //   response.list.forEach(function(item) {
        //     if(isAlreadySelectedBudget(item.UUID) === false) {
        //       resp.push(item);
        //     }
        //   });
        // }
        // $scope.availableBudgetCodes = resp;
        // $scope.$broadcast(DATA_READY_EVENT, LOADED_AVAILABLE_BUDGET_CODES);
        // return resp;
        if (response.hasOwnProperty('list')) {
          $scope.availableBudgetCodes = response.list;
        }
        $scope.$broadcast(DATA_READY_EVENT, LOADED_AVAILABLE_BUDGET_CODES);
        return $scope.availableBudgetCodes;
      });
    };

    function dropAlreadySelectedBudgets() {
      var res = [];
      $scope.availableBudgetCodes.forEach(function(item) {
        if(isAlreadySelectedBudget(item.UUID) === false) {
          res.push(item);
        }
      });
      $scope.availableBudgetCodes = res;
    }

    function isAlreadySelectedBudget(uuid) {
      if($scope.budget.searchCode) {
        for(var i in $scope.budget.searchCode) {
          if($scope.budget.searchCode[i] && $scope.budget.searchCode[i].UUID === uuid) {
            return true;
          }
        }
      }
      return false;
    }



    /****************/
    /**** EVENTS ****/
    /****************/

    $scope.open = function($event, picker) {
      $event.preventDefault();
      $event.stopPropagation();

      picker.opened = true;
    };

    $scope.$watchGroup(['contatore.contatore_id', 'fromYearPicker.year', 'toYearPicker.year'], function(event) {
      resetDataReadyStatus();
      if($scope.contatore && $scope.contatore.contatore_id) {
        $scope.um = undefined;  // Per risvegliare la lookup in modo che si accorga della modifica
        $scope.um = {um_id: undefined};
        $scope.toggleSelectMonth();
        $scope.loadConsumptions();
        $scope.loadReads();
      }
      else if($scope.contatoreType && $scope.contatoreType.tipo_id) {
        toaster.pop('error', 'Errore', 'Il contatore non è stato trovato');
      }
      $scope.getAvailableBudgetCodes();
    });

    $scope.$watchCollection('contatoreType', function( newValue, oldValue ) {
      resetVariables(true);
      updateColumnDefs();
      $scope.loadRecords();
    });

    function resetVariables(resetContatore) {
      $log.log('reset');
      if(resetContatore === true) {
        $scope.contatore.contatore_id = undefined;
        $scope.contatore = {};
        $scope.recordList = [];
      }
      $scope.reportMessages = [];
      $scope.viewGridOptions.data = [];
      $scope.totalPeriodConsumptions = {totale: 0};
      $scope.totalEvaluatedPeriodConsumptions = {totale: 0};
      $scope.totalPeriodDays = 0;
      $scope.budget = {};
      $scope.availableBudgetCodes = [];
      $scope.graph.graphData = [];
      $scope.graph.graphDataCum = [];

      resetDataReadyStatus();
      resetMatrixConsumptions();
    }

    function resetDataReadyStatus() {
      dataReadyStatus = [];
      dataReadyStatus[IMPORTED_READS] = false;
      dataReadyStatus[LOADED_READS] = false;
      dataReadyStatus[LOADED_BUDGET] = false;
      dataReadyStatus[LOADED_CONSUMPTIONS] = false;
      dataReadyStatus[CALC_CONSUMPTIONS] = false;
      dataReadyStatus[LOADED_AVAILABLE_BUDGET_CODES] = false;
    }

    function resetMatrixConsumptions() {
      var yearsArray = $scope.getYears($scope.fromYearPicker.year, $scope.toYearPicker.year);
      $scope.monthlyConsumptions = sixMatrixLib.getInitializedMatrix({total: 0, type: undefined}, yearsArray, 12);
      $scope.dailyConsumptions = sixMatrixLib.getInitializedMatrix({total: 0, slotted: [], type: undefined}, yearsArray, 12, 31);
      $scope.monthlyEvaluatedConsumptions = sixMatrixLib.getInitializedMatrix(0, yearsArray, 12);
    }

    $scope.$on(DATA_READY_EVENT, function(event, args) {
      dataReadyStatus[args] = true;
      if(dataReadyStatus[LOADED_AVAILABLE_BUDGET_CODES] && dataReadyStatus[LOADED_BUDGET]) {
        $scope.budget.searchCode = [];
        if(receivedBudgetCodes && receivedBudgetCodes.length > 0 && $scope.availableBudgetCodes && $scope.availableBudgetCodes.length > 0) {
          receivedBudgetCodes.forEach(function (bc) {
            var b = getBudgetByCodeFromAvailablesList(bc);
            if(angular.isDefined(b) && b != null) {
              $scope.budget.searchCode.push(b);
            }
          });
          dropAlreadySelectedBudgets();
        }
      }
      if(dataReadyStatus[LOADED_AVAILABLE_BUDGET_CODES] && dataReadyStatus[LOADED_BUDGET] && dataReadyStatus[LOADED_CONSUMPTIONS] && dataReadyStatus[LOADED_READS]) {
        setTimeout(function () { // evita che venga richiamato troppo velocemente (altrimenti si accavalla a showLoadingMessage)
          loadingBarService.stop();
        }, 500);
      }
      if(dataReadyStatus[CALC_CONSUMPTIONS]) {
        setTimeout(function () { // evita che venga richiamato troppo velocemente (altrimenti si accavalla a showLoadingMessage)
          loadingBarService.stop();
        }, 500);
      }
    });

    $scope.$watchGroup(['viewGridOptions.data', 'totalResults'], function(newValue) {
      $scope.viewGridOptions.totalItems = $scope.totalResults; // aggiorna la paginazione della grid
    });



    /**** month view detail ****/

    //Month is 0 based
    $scope.daysInMonth = function(year, month) {
      return sixDateLib.daysNumberInMonth(year, month);
    };

    // index from 0 to n-1
    $scope.getTimes = function(n) {
      var list = [];
      for(var i = 0 ; i < n ; i++) {
        list.push(i);
      }
      return list;
    };

    // months from 0 to 11
    $scope.getMonths = function() {
      return [0,1,2,3,4,5,6,7,8,9,10,11];
    };

    // 0-based
    $scope.getMonthName = function(month) {
      return sixDateLib.getMonthShortName(month);
    };

    // years from fromDate (included) to toDate (included)
    $scope.getYears = function(start, end) {
      var list = [];
      for(var y = start ; y <= end ; y++) {
        list.push(y);
      }
      return list;
    };

    $scope.toggleSelectMonth = function(year, month) {
      if($scope.selectedMonthDetail.year == year && $scope.selectedMonthDetail.month == month) {
        $scope.selectedMonthDetail.year = undefined;
        $scope.selectedMonthDetail.month = undefined; // 0-based
      } else {
        $scope.selectedMonthDetail.year = year;
        $scope.selectedMonthDetail.month = month; // 0-based
      }
    };


    /**** Grafico ****/

    $scope.graph = {
      graphData: [],
      graphDataCum: []
    };

    function toObjList(matrix, cumulative) {
      var from = new Date($scope.fromYearPicker.year + '-01-01');
      var to = new Date($scope.toYearPicker.year + '-12-31');
      var data = [];
      cumulative = cumulative || false;
      var dates = sixDateLib.getDatesInPeriod(from, to);
      var totals = [];
      totals.totale = 0;
      dates.forEach(function(d) {
        var year = $filter('date')(d, 'yyyy');
        var month = $filter('date')(d, 'M');
        var day = $filter('date')(d, 'd');
        var item = matrix[year][month-1][day-1];
        totals.totale += item.total;
        var obj = {
          date: new Date(year, month-1, day),
          totale: (cumulative)?totals.totale:item.total
        };
        item.slotted.forEach(function (slot) {
          if (!totals[slot.time_slot]) {
            totals[slot.time_slot] = 0;
          }
          totals[slot.time_slot] += slot.consumption;
          obj[slot.time_slot] = (cumulative) ? totals[slot.time_slot] : slot.consumption;
        });
        data.push(obj);
        data = $filter('orderBy')(data, 'date');
      });
      // aggiorno i time slot degli oggetti dove non sono presenti
      data.forEach(function(item) {
        for(var k in totals) {
          if (k !== 'date' && k !== 'totale') {
            item[k] = item[k] || 0;
          }
        }
      });
      return data;
    }





    /**** Paginazione ****/

    var paginationOptions = {
      pageNumber: 1,
      pageSize: 10
    };

    $scope.updatePagination = function () {
      if($scope.importingOperation === false) {
        getReads();
      }
    };



    /**** UI GRID Callbacks ****/

    function onRegisterApiCallback(gridApi) {
      $scope.gridApi = gridApi;
      gridApi.rowEdit.on.saveRow($scope, onSaveRowCallbach);
      gridApi.edit.on.afterCellEdit($scope, afterCellEditCallback);
      gridApi.pagination.on.paginationChanged($scope, paginationChangedCallback);
      gridApi.core.on.sortChanged($scope, sortChangedCallback);
    }

    //dati caricati da xls
    $scope.$watch(function( ) {
        return $scope.viewGridOptions.xlsData;
      },
      function( newValue, oldValue ) {
        if (newValue && newValue.length>0){
          $scope.importingOperation = true;
          updateColumnDefs();
          processData($scope.viewGridOptions.xlsData);
          resolveRefs($scope.viewGridOptions.data);
        }
      }
    );

    function processData(newObjects) {
      $scope.importingOperation = true;
      $scope.percent = 0;
      $scope.viewGridOptions.useExternalPagination = false;
      newObjects.forEach(function (value) {
        for(var k in value) {
          var splittedKey = k.split(' [');
          if(splittedKey.length > 1) {
            value[splittedKey[0]] = value[k];
            delete value[k];
          }
        }
        value.record_id = {};
        value.um_id = {code: value.um};
        delete value.um;
        switch($scope.contatoreType.tipo_id.UUID) {
          case 'contatoreelettricita':
            value.record_id.code = value.pod;
            break;

          case 'contatoregas':
            value.record_id.code = value.pdr;
            break;

          case 'contatoreacqua':
            value.record_id.code = value.matricola;
            break;

          case 'serbatoiopressioneatmosferica':
          case 'serbatoioinpressione':
          case 'contatoreteleriscaldamento':
          case 'contatoreteleraffreddamento':
            value.record_id.code = value.cod;
            break;

          default:
            toaster.pop('error', 'Errore', 'Tipo contatore non riconosciuto');
        }
        $scope.viewGridOptions.data.push(value);
      });
    }

    function resolveRefs(data) {
      $scope.isAllOk = true;
      var mapToResolve = {};
      //mapToResolve[$scope.contatoreType.tipo_id.UUID] = {};
      //mapToResolve['um'] = {};
      data.forEach(function(item) {
        var comm = item.commessa || currentCommission.code; // se è multi commessa => item.commessa, altrimenti => commessa corrente

        var innerMap = mapToResolve[comm] || {};
        var innerInnerMap = innerMap[$scope.contatoreType.tipo_id.UUID] || {};
        innerInnerMap[item.record_id.code] = '';
        innerMap[$scope.contatoreType.tipo_id.UUID] = innerInnerMap;
        mapToResolve[comm] = innerMap;

        //var innerMap = mapToResolve[$scope.contatoreType.tipo_id.UUID];
        //innerMap[item.record_id.code] = item.commessa || currentCommission; // se è multi commessa => item.commessa, altrimenti => commessa corrente

        var innerMap = mapToResolve[currentCommission.code] || {};
        var innerInnerMap = innerMap['um'] || {};
        innerInnerMap[item.um_id.code] = '';
        innerMap['um'] = innerInnerMap;
        mapToResolve[currentCommission.code] = innerMap;

        //var innerMap = mapToResolve['um'];
        //innerMap[item.um_id.code] = item.commessa || currentCommission; // se è multi commessa => item.commessa, altrimenti => commessa corrente
      });
      recordFactory('type').bulkResolveMC(mapToResolve)
        .$promise.then(function(response) {
          $log.info(response);
          data.forEach(function(item) {
            item['sixImportStatus'] = 'OK';
            var comm = item.commessa || currentCommission.code;
            var resolved = response[comm][$scope.contatoreType.tipo_id.UUID][item.record_id.code];
            if(angular.isUndefined(resolved) || resolved === null) {
              item['sixImportStatus'] = 'record \'' + item.record_id.code + '\'' + ' non trovato per la commessa ' + comm + '!';
              $scope.isAllOk = false;
            } else {
              item['record_id'] = sixObjectLib.recordToHisRef(resolved);
            }
            var resolved = response[currentCommission.code]['um'][item.um_id.code];
            if(angular.isUndefined(resolved) || resolved === null) {
              var message = 'um \'' + item.um_id.code + '\'' + ' non trovata!';
              $scope.isAllOk = false;
              if(item['sixImportStatus'] === 'OK') {
                item['sixImportStatus'] = message;
              } else {
                item['sixImportStatus'] += '; ' + message;
              }
            } else {
              item['um_id'] = sixObjectLib.recordToHisRef(resolved);
            }
          });
        });
    }

    function onSaveRowCallbach(rowEntity) {
      var promise = $q.defer();
      $scope.gridApi.rowEdit.setSavePromise( rowEntity, promise.promise );
      if(!rowEntity || !rowEntity.data || !rowEntity.record_id.code) {
        promise.reject();
      }
      else {
        saveOrUpdateSingleRead(rowEntity, 0, 1);
        promise.resolve();
      }
    }

    function afterCellEditCallback(rowEntity, colDef, newValue, oldValue) {
      if(!rowEntity) { rowEntity = {}; }
    }

    function paginationChangedCallback(newPage, pageSize) {
      paginationOptions.pageNumber = newPage;
      paginationOptions.pageSize = pageSize;
      $scope.updatePagination();
    }

    function sortChangedCallback(sortColumns) {
      if($scope.importingOperation === false) {
        $scope.gridApi.grid.columns.forEach(function (col) {
          if (col.sort.direction) {
            $scope.sort = {fields: col.field, directions: col.sort.direction};
          }
        });
        getReads();
      }
    }

    $scope.getTemplateUrl = function() {
      if($scope.contatoreType && $scope.contatoreType.tipo_id) {
        var prefix = '/energy/attachments/';
        var postfix = '.xls';
        var fileName;
        switch ($scope.contatoreType.tipo_id.UUID) {
          case 'contatoreelettricita':
            fileName = 'template_elettrico_letture';
            break;
          case 'contatoregas':
            fileName = 'template_gas_letture';
            break;
          case 'contatoreacqua':
            fileName = 'template_acqua_letture';
            break;
          case 'contatoreteleriscaldamento':
            fileName = 'template_teleriscaldamento_letture';
            break;
          case 'contatoreteleraffreddamento':
            fileName = 'template_teleraffreddamento_letture';
            break;
          case 'serbatoiopressioneatmosferica':
            fileName = 'template_serbpressatm_letture';
            break;
          case 'serbatoioinpressione':
            fileName = 'template_serbinpress_letture';
            break;
          default:
            return null;
        }
        if(multiCommission === true) {
          postfix = '_mc' + postfix;
        }
        return prefix+fileName+postfix;
      }
      return null;
    };

    $scope.goToImportConsumptions = function() {
      $location.path('consumptive/consumption/import');
    };

    $scope.goToUpdateRegistrationNumber = function() {
      localStorageService.set('resetcounter.type_id', $scope.contatoreType.tipo_id);
      localStorageService.set('resetcounter.record_id', $scope.contatore.contatore_id);
      $window.open('/#/updateregistrationnumber', '_blank');
    };

    $scope.goToClosure = function() {
      localStorageService.set('closure.schema', $scope.contatoreType.tipo_id);
      localStorageService.set('closure.record', $scope.contatore.contatore_id);
      $window.open('/#/closure', '_blank');
    };

    $scope.getTooltip = function(value) {
      if(value.type === $scope.TYPE_MIXED) { return 'budget/consuntivo'; }
      if(value.type === $scope.TYPE_BDG) { return 'budget'; }
      if(value.type === $scope.TYPE_CONSUMPTION) {
        if(value.total < 0) { return 'consuntivo NEGATIVO!!!'; }
        return 'consuntivo';
      }
    };

    $scope.calcAllConsumptions = function(allCommissions) {
        loadingBarService.start('Calcolo...');
        var query = {
            from: $scope.fromYearPicker.year + '-01-01',
            to: $scope.toYearPicker.year + '-12-31',
            type: $scope.contatoreType.tipo_id.code
        };
        var promise;
        if(allCommissions === true) {
            promise = consumptionFactory.calcAll(query).$promise;
        } else {
            query.id = currentCommission.code;
            promise = consumptionFactory.calcAll(query).$promise;
        }
        promise.then(function(resp) {
            if(errorService.handleError(resp)) {
                $scope.reportMessages = resp.messages;
                $scope.$broadcast(DATA_READY_EVENT, CALC_CONSUMPTIONS);
            }
        });
    };




    /***** DUMMY PROGRESS BAR *****/

    // fa avanzare la progress bar a caso, giusto per far vedere che sta facendo qualcosa
    var stopDummyUpdateProgressBar = false;
    function updateDummyProgressBar() {
      if($scope.percent < 100 && stopDummyUpdateProgressBar === false) {
        $timeout(function() {
          if(stopDummyUpdateProgressBar === false) {
            $scope.percent += ($scope.percent < 90) ? Math.random() * 5 : 0;  // appena supero il 90% mi fermo e attendo che qualcuno lo porti a 100%
            if ($scope.percent < 100) {
              updateDummyProgressBar();
            }
          }
        }, Math.random()*2000);
      }
    }

    function resetDummmyProgressBar() {
      stopDummmyProgressBar();
      $scope.percent = 0;
    }

    function startDummmyProgressBar(startVal) {
      stopDummyUpdateProgressBar = false;
      $scope.percent = startVal || 0;
      updateDummyProgressBar();
    }

    function stopDummmyProgressBar() {
      stopDummyUpdateProgressBar = true;
    }





    /***** RECORD SIDEBAR TOGGLE *****/

    // $scope.isSidebarOpened = angular.element(document.getElementById('list-sidebar')).hasClass('open');
    $scope.isSidebarOpened = true;
    $scope.isPinned = true;
    $scope.recordList = [];

    $scope.loadRecords = function() {
      if($scope.contatoreType && $scope.contatoreType.tipo_id && $scope.contatoreType.tipo_id.code) {
        recordFactory($scope.contatoreType.tipo_id.code).lookup({page_size: 1000}).$promise.then(function(resp) {
          if(errorService.handleError(resp)) {
            $scope.recordList = resp.list;
          } else {
            toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
          }
        });
      }
    };

    $scope.selectRecord = function(uuid, code, description) {
      if(uuid) {
        $scope.contatore.contatore_id = {type: $scope.contatoreType.tipo_id.code, UUID: uuid, code: code, description: description};
        recordFactory($scope.contatoreType.tipo_id.code).byUUID({id: uuid}).$promise.then(function (response) {
          $scope.contatore.obj = response;
        });
      }
    };

    $scope.isRecordSelected = function(uuid) {
      if($scope.contatore && $scope.contatore.contatore_id) {
        return $scope.contatore.contatore_id.UUID === uuid;
      }
      return false;
    };

    $scope.toggleSidebar = function() {
      $scope.isSidebarOpened = !$scope.isSidebarOpened;
    };



    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'consumptive';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isClosed = function() {
      if(angular.isDefined($scope.contatore.obj) && angular.isDefined($scope.contatore.obj.model)) {
        return $scope.contatore.obj.model.stato === 'chiuso';
      }
      return false;
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ImportConsumptionCtrl
 * @description
 * # ImportConsumptionCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .controller('ImportConsumptionCtrl', function ($scope, $timeout, $log, $location, authFactory, $filter, $q, dialogService, recordFactory, consumptionFactory, toaster, errorService) {

    $scope.importingOperation = false;
    $scope.isImportBusy = false;
    $scope.isAllOk = true;

    $scope.reportMessages = [];

    $scope.viewGridOptions = {
      enableSorting: true,
      enableGridMenu: true,
      exporterMenuPdf: false,
      paginationPageSizes: [10, 20, 30],
      paginationPageSize: 10,
      useExternalPagination: false,
      gridMenuCustomItems: [
        {
          title: 'Pulisci',
          action: function ($event) {
            $scope.resetGrid();
          },
          order: 210
        }
      ],
      onRegisterApi: function(gridApi) {
        $scope.gridApi = gridApi;
      }
    };

    $scope.reportGridOptions = {
      enableSorting: true,
      exporterMenuPdf: false,
      paginationPageSizes: [10, 20, 30],
      paginationPageSize: 10,
      useExternalPagination: false,
      data: 'reportMessages',
      columnDefs: [
        {displayName: 'Stato', field: 'status', width: '100'},
        {displayName: 'Messaggio', field: 'message'}
      ]
    };

    var columnDefs = [
      { name: 'SixImportStatus', field: 'sixImportStatus', enableSorting: false },
      { name: 'Pod', field: 'record_id.code', enableSorting: false },
      { name: 'Mese', field: 'mese', enableSorting: false },
      { name: 'Anno', field: 'anno', enableSorting: false },
      { name: 'F0', field: 'f0', enableSorting: false },
      { name: 'F1', field: 'f1', enableSorting: false },
      { name: 'F2', field: 'f2', enableSorting: false },
      { name: 'F3', field: 'f3', enableSorting: false },
      { name: 'Tot', field: 'tot', enableSorting: false },
      { name: 'U.M.', field: 'um_id.code', enableSorting: false }
    ];

    $scope.resetGrid = function() {
      $scope.isImportBusy = false;
      $scope.viewGridOptions.data = [];
      $scope.viewGridOptions.xlsData = [];
      $scope.reportMessages = [];
    };

    //dati caricati da xls
    $scope.$watch(function( ) {
        return $scope.viewGridOptions.xlsData;
      },
      function( newValue, oldValue ) {
        if (newValue && newValue.length>0){
          $scope.importingOperation = true;
          $scope.viewGridOptions.columnDefs = columnDefs;
          processData($scope.viewGridOptions.xlsData);
          resolveRefs($scope.viewGridOptions.data);
        }
      }
    );

    function processData(newObjects) {
      $scope.importingOperation = true;
      $scope.percent = 0;
      $scope.viewGridOptions.data = [];
      newObjects.forEach(function (value) {
        value.record_id = {
          type: 'contatoreelettricita',
          code: value.pod
        };
        value.um_id = {
          type: 'um',
          code: value.um
        };
        value.mese = parseInt(value.mese);
        value.anno = parseInt(value.anno);
        value.tot = parseFloat(value.tot || 0.0);
        value.f0 = parseFloat(value.f0 || 0.0);
        value.f1 = parseFloat(value.f1 || 0.0);
        value.f2 = parseFloat(value.f2 || 0.0);
        value.f3 = parseFloat(value.f3 || 0.0);
        value.tot = value.f0 + value.f1 + value.f2 + value.f3;
        delete value.pod;
        delete value.um;
        $scope.viewGridOptions.data.push(value);
      });
    }

    function resolveRefs(data) {
      $scope.isAllOk = true;
      var mapToResolve = {};
      mapToResolve['contatoreelettricita'] = {};
      mapToResolve['um'] = {};
      data.forEach(function(item) {
        var innerMap = mapToResolve['contatoreelettricita'];
        innerMap[item.record_id.code] = '';

        var innerMap = mapToResolve['um'];
        innerMap[item.um_id.code] = '';
      });
      recordFactory('type').bulkResolve(mapToResolve).$promise.then(function(response) {
        if (errorService.handleError(response)) {
          $log.info(response);
          data.forEach(function (item) {
            item['sixImportStatus'] = 'OK';
            var resolved = response['contatoreelettricita'][item.record_id.code];
            if (angular.isUndefined(resolved) || resolved === null) {
              item['sixImportStatus'] = 'record \'' + item.record_id.code + '\'' + ' non trovato!';
              $scope.isAllOk = false;
            } else {
              item['record_id'] = sixObjectLib.recordToHisRef(resolved);
            }
            var resolved = response['um'][item.um_id.code];
            if (angular.isUndefined(resolved) || resolved === null) {
              var message = 'um \'' + item.um_id.code + '\'' + ' non trovata!';
              $scope.isAllOk = false;
              if (item['sixImportStatus'] === 'OK') {
                item['sixImportStatus'] = message;
              } else {
                item['sixImportStatus'] += '; ' + message;
              }
            } else {
              item['um_id'] = sixObjectLib.recordToHisRef(resolved);
            }
          });
        } else {
          toaster.pop('error', 'Errore', 'Errore durante la risoluzione dei riferimenti');
        }
        $scope.isImportBusy = false;
      });
    }

    $scope.importData = function () {
      $scope.isImportBusy = true;
      var toSave = [];
      var selected = $scope.gridApi.selection.getSelectedRows();
      if (!selected || !selected.length) {
        selected = $scope.viewGridOptions.data;
      }
      selected.forEach(function(item) {
        toSave.push(item);
      });
      $scope.saveOrUpdateConsumptions(toSave);
    };

    $scope.saveOrUpdateConsumptions = function(consumptions) {
      dialogService.showLoadingMessage('Importazione dati...');
      startDummmyProgressBar(Math.random()*10 + Math.random()*10); // inizio a caso, giusto per dare la sensazione che stia facendo qualcosa...
      var error = false;
      // Controllo se è tutto corretto
      consumptions.forEach(function (value) {
        if (!value.record_id.type || !value.record_id.code) {
          toaster.pop('error', 'Errore', 'Controllare tipo e codice contatore, data e letture');
          error = true;
          resetDummmyProgressBar();
          return;
        }
      });
      if(!error) {
        consumptionFactory.bulk(consumptions).$promise.then(function (response) {
          if (errorService.handleError(response)) {
            $scope.percent = 100;
          }
          else {
            $scope.percent = 0;
            stopDummmyProgressBar();
            toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
          }
          $scope.reportMessages = response.messages;
          $scope.isImportBusy = false;
          dialogService.hideLoadingMessage();
        });
      }
    };


    /***** DUMMY PROGRESS BAR *****/

    // fa avanzare la progress bar a caso, giusto per far vedere che sta facendo qualcosa
    var stopDummyUpdateProgressBar = false;
    function updateDummyProgressBar() {
      if($scope.percent < 100 && stopDummyUpdateProgressBar === false) {
        $timeout(function() {
          if(stopDummyUpdateProgressBar === false) {
            $scope.percent += ($scope.percent < 90) ? Math.random() * 5 : 0;  // appena supero il 90% mi fermo e attendo che qualcuno lo porti a 100%
            if ($scope.percent < 100) {
              updateDummyProgressBar();
            }
          }
        }, Math.random()*2000);
      }
    }

    function resetDummmyProgressBar() {
      stopDummmyProgressBar();
      $scope.percent = 0;
    }

    function startDummmyProgressBar(startVal) {
      stopDummyUpdateProgressBar = false;
      $scope.percent = startVal || 0;
      updateDummyProgressBar();
    }

    function stopDummmyProgressBar() {
      stopDummyUpdateProgressBar = true;
    }
  });

'use strict';

/**
 * @author Rita Beltrami
 * @ngdoc function
 * @name sixEmmaApp.controller:DashboardEmmaCtrl
 * @description
 * # DashboardEmmaCtrl
 * Controller of the Assets project dashboard
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/emma', {
            templateUrl: 'theme/dashboard/dashboard.html',
            controller: 'DashboardEmmaCtrl'
        })
  })
  .controller('DashboardEmmaCtrl', function ($scope, $log, dashboardEmmaFactory, consumptionAnalysisFactory, recordFactory, errorService, $filter) {

    //__params__
    var ENDPOINT = "dashboard";
    var WIDGET_ON = 'widget-on';
    var WIDGET_OFF = 'widget-off';
    $scope.config = {
      vectors: [],
      total: {},
      others: []
    };
    $scope.vectorsCount = 0;
    $scope.loadedVectors = 0;
    $scope.widgetClass = "panel-widget-emma";
    $scope.pos1 = [];
    $scope.pos2 = [];
    $scope.pos3 = [];
    $scope.tmp1 = [];
    $scope.tmp2 = [];
    $scope.tmp3 = [];
    $scope.wide = [];
    $scope.widgetEmmaClass = [WIDGET_OFF,WIDGET_OFF,WIDGET_OFF,WIDGET_OFF,WIDGET_OFF,WIDGET_OFF];
    $scope.widgetEmmaSelected = {};
    var skins = ["info","primary","success","warning","danger","dark"];
    var skinCount = skins.length;

    $scope.allVectors = {};

    $scope.lightOn = function(index){
        $scope.widgetEmmaClass[index] = WIDGET_ON;
    };

    $scope.lightOff = function(index){
        $scope.widgetEmmaClass[index] = WIDGET_OFF;
    };

    $scope.selectWidget = function(data) {
        $scope.widgetEmmaSelected = data;
    };

    $scope.isSelectedWidget = function(data) {
        return $scope.widgetEmmaSelected == data;
    };

    $scope.getDynamic = function(item) {
      var dynamic = {};
      if(item.widgetType==='widget-consumptive-graph'
        && $scope.widgetEmmaSelected // if per evitare che venga preso un valore 'indefinito'
        && angular.isDefined($scope.widgetEmmaSelected.graph)) {  // if per evitare che venga preso un valore 'indefinito'
        dynamic.subtitle = $scope.widgetEmmaSelected.graph.title;
      }
      return dynamic;
    };

    $scope.createWaitWidget = function(item, num){
        if(num%2){
            $scope.tmp2.push(item);
        }
        else{
            $scope.tmp1.push(item);
        }
    };

    function initDashboard(){
        dashboardEmmaFactory('vettoreenergetico').getConfig({page_size: 10000, show_revision: false}).$promise.then(function (data) {
            var n = 0;
            data.list.forEach(function (item) {
                $scope.createWaitWidget(item, n);
                n++;
            });

            $scope.dashTemp = data;
            setTimeout(function() {
                $scope.loadDeferred($scope.dashTemp);
            }, 50);
        });
    }

    $scope.loadDeferred = function(data) {
        data.list.forEach(function (item) {
            if(item.widgetType == "widget-consumptive"){
                $scope.vectorsCount++;
                $scope.loadData(item);
            }
            else{
                $scope.config.others.push(item);
            }
        });
    };

    function positionWidgets() {
        $scope.wcount = 0;
        $scope.totalWidgets = 0;
        positionWidget($scope.config.total);
        for(var i=0; i<$scope.config.vectors.length; i++){
            positionWidget($scope.config.vectors[i]);
        }
        for(var i=0; i<$scope.config.others.length; i++){
            positionWidget($scope.config.others[i]);
        }
    }

  function positionWidget(item) {
    $log.log(item);
    switch(item.position) {
      case 'pos1':
        $scope.pos1.push(item);
        $scope.wcount++;
        break;
      case 'pos2':
        $scope.pos2.push(item);
        $scope.wcount++;
        break;
      case 'wide':
        $scope.wide.push(item);
        break;
      default:
        if($scope.wcount%2){
            $scope.pos2.push(item);
        }
        else{
            $scope.pos1.push(item);
        }
        $scope.wcount++;
    }
    $scope.totalWidgets++;
    item.skin = skins[$scope.totalWidgets%skinCount];
  }

  var today = new Date();
  var startYear = today.getFullYear();
  if(today.getMonth() == 0) {
    startYear = today.getFullYear()-1;
  }

  $scope.datePicker = {
    from: new Date(startYear, 0, 1),
    to: new Date(today.getFullYear(),today.getMonth(), 0)
  };

  function createDate(d) {
    var date = new Date(d);
    return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
  }

  function createConsumptiveWidget(item, budget, graph) {
        // creo il vero e proprio widget
        if(item.vector.total==true){
            item.data = budget.std;
            $scope.config.total = item;
            item.data.graph = graph;
            item.data.graph.id = 'total';
            item.data.graph.title = 'Totale';
        }
        else{
            item.data = budget.um;
            item.hideWidget = (item.data.cons == 0) && (item.data.budget == 0) ;
            if(!item.hideWidget){
                $scope.config.vectors.push(item);
            }
            item.data.graph = graph;
            item.data.graph.id = item.vector.model.code;
            item.data.graph.title = item.vector.model.description;
        }
        $scope.loadedVectors++;
        if($scope.loadedVectors == $scope.vectorsCount){
            positionWidgets();
        }
  }

  $scope.loadData = function (item) {
    var vector = item.vector;
    $scope.budget = {list: undefined};

    var query = {frequency: 'MONTHLY', from:'', to:''};
    query.from = createDate($scope.datePicker.from);
    query.to = createDate($scope.datePicker.to);

    if(vector) {
      query.vector_id = vector.UUID;
    }

    consumptionAnalysisFactory().getConsumptionAnalysis(query).$promise.then(function (consAnResp) {
      if(errorService.handleError(consAnResp)) {
        var budget = {}, graphData =[], graphDataCumulative=[];
        if(consAnResp.result && consAnResp.result.list){
          budget.list = consAnResp.result.list;
          angular.forEach(consAnResp.result.list, function (record, idx) {
            var grpDT = {
              'date': Date.parse(record.date)
            };
            var grpDTCumulative = {
              'date': Date.parse(record.date)
            };
            budget.toRender = {};
            if(vector.total == true) {
              grpDT['consumi ' + $filter('number')(consAnResp.result.std.cons, 3)] = '' + record.std.cons;
              grpDT['budget ' + $filter('number')(consAnResp.result.std.budget, 3)] = '' + record.std.budget;

              grpDTCumulative['consumi ' + $filter('number')(consAnResp.result.std.cons, 3)] = '' + (record.std.cumCons || 0);
              grpDTCumulative['budget ' + $filter('number')(consAnResp.result.std.budget, 3)] = '' + (record.std.cumBudget || 0);

              budget.toRender.list = [];
              budget.list.forEach(function (record) {
                var r = angular.copy(record.std);
                r.date = record.date;
                budget.toRender.list.push(r);
              });
              budget.toRender.totalBudget = consAnResp.result.std.budget;
              budget.toRender.totalConsumption = consAnResp.result.std.cons;
              budget.toRender.season = consAnResp.result.std.season;
              budget.toRender.deltaSeason = consAnResp.result.std.deltaSeason;
              budget.toRender.deltaTech = consAnResp.result.std.deltaTech;
              budget.toRender.percentage = consAnResp.result.std.percentage;
            } else {
              grpDT['consumi ' + $filter('number')(consAnResp.result.um.cons, 3)] = '' + record.um.cons;
              grpDT['budget ' + $filter('number')(consAnResp.result.um.budget, 3)] = '' + record.um.budget;

              grpDTCumulative['consumi ' + $filter('number')(consAnResp.result.um.cons, 3)] = '' + (record.um.cumCons || 0);
              grpDTCumulative['budget ' + $filter('number')(consAnResp.result.um.budget, 3)] = '' + (record.um.cumBudget || 0);

              budget.toRender.list = [];
              budget.list.forEach(function (record) {
                var r = angular.copy(record.um);
                r.date = record.date;
                budget.toRender.list.push(r);
              });
              budget.toRender.totalBudget = consAnResp.result.um.budget;
              budget.toRender.totalConsumption = consAnResp.result.um.cons;
              budget.toRender.season = consAnResp.result.um.season;
              budget.toRender.deltaSeason = consAnResp.result.um.deltaSeason;
              budget.toRender.deltaTech = consAnResp.result.um.deltaTech;
              budget.toRender.percentage = consAnResp.result.um.percentage;
              budget.toRender.um = consAnResp.result.um.percentage;
            }

            graphData.push(grpDT);
            graphDataCumulative.push(grpDTCumulative);
          });
        }

        if(consAnResp.result && consAnResp.result.um){
          budget.um = consAnResp.result.um;
          budget.totalBudget = consAnResp.result.um.budget;
          budget.totalConsumption = consAnResp.result.um.cons;
        }
        if(consAnResp.result && consAnResp.result.std){
          budget.totalBudgetStd = consAnResp.result.std.budget;
          budget.totalConsumptionStd = consAnResp.result.std.cons;
          budget.std = consAnResp.result.std;
          budget.season = consAnResp.result.std.season;
          budget.deltaSeason = consAnResp.result.std.deltaSeason;
          budget.deltaTech = consAnResp.result.std.deltaTech;
          budget.percentage = consAnResp.result.std.percentage;
        }

        var graph = {
          graphData: graphData,
          graphDataCumulative: graphDataCumulative
        };

        // creo il vero e proprio widget
        createConsumptiveWidget(item, budget, graph) ;
      }

    });
  };


    /** codice per forzare la crezione degli snapshot relativi al consuntivo */

    $scope.totVector = {
      total: true,
      model: {
        code: 'total',
        description: 'Totale',
        um: { type: 'um', UUID: 'kwh', code: 'kwh', description: 'kWh' }
      }
    };

    // Consumi senza vettore energetico (sono errori di dati sull'indice)
    $scope.missingVector = {
      schemaCode: 'vettoreenergetico',
      UUID: 'missing',
      model: {
        code: 'missing',
        description: 'No vett. energ.',
        um: {type: 'um', UUID: 'kwh', code: 'kwh', description: 'kWh'},
        color: '#b3b3cc',
        text_color: 'red'
      }
    };

    function getQuery(vector) {
      $scope.budget = {list: undefined};
      //CONSUMI E BUDGET
      var query = {frequency: 'MONTHLY', from:'', to:''};
      var from = createDate($scope.datePicker.from);
      var to = createDate($scope.datePicker.to);
      if(from) {
        query.from = from;
      }
      if(to) {
        query.to = to;
      }
      if (vector && vector.UUID) {  // se ho passato un vettore specifico ignoro i filtri impostati
        query.vector_id = vector.UUID;
      } else if(!vector) {  // se non ho passato uno specifico vettore considero i filtri impostati
        if ($scope.currentVector && angular.isDefined($scope.currentVector.UUID)) {
          query.vector_id = $scope.currentVector.UUID;
        }
        if ($scope.type.type_id && angular.isDefined($scope.type.type_id.UUID)) {
          query.contatore_type = $scope.type.type_id.UUID;
        }
        if ($scope.contatore.contatore_id && angular.isDefined($scope.contatore.contatore_id.UUID)) {
          query.contatore_id = $scope.contatore.contatore_id.UUID;
        }
      }
      // ignoro la selezione di un budget, in modo che il BE prenda quello di default
      return query;
    }

    $scope.createConsumptionsSnap = function(vector){
      $scope.$broadcast('snap:creating', 'started', 'CONSUMI');
      var p = consumptionAnalysisFactory().createConsumptionsSnap(getQuery(vector)).$promise;
      p.then(function(resp) {
        $scope.$broadcast('snap:creating', 'terminated', 'CONSUMI', resp);
      });
      return p;
    };

    $scope.deleteConsumptionsSnap = function(vector){
      $scope.$broadcast('snap:removing', 'started', 'CONSUMI');
      var p = consumptionAnalysisFactory().deleteConsumptionsSnap(getQuery(vector)).$promise;
      p.then(function(resp) {
        $scope.$broadcast('snap:removing', 'terminated', 'CONSUMI', resp);
      });
      return p;
    };

    $scope.recreateConsumptionsSnap = function(vector) {
      $scope.deleteConsumptionsSnap(vector).then(function(resp) {
        $scope.createConsumptionsSnap(vector);
      });
    };

    $scope.reloadDashboard = function () {
      recordFactory('vettoreenergetico').query({page_size: 10000, show_revision: false}).$promise.then(function (data) {
        data.list.forEach(function (value) {  /* carico tutti i vettori */
          $scope.allVectors[value.model.code] = value;
        });
        $scope.allVectors[$scope.missingVector.model.code] = $scope.missingVector;
        $scope.allVectors[$scope.totVector.model.code] = $scope.totVector;
        /* ricreo tutti gli snapshot, passando vettore per vettore */
        angular.forEach($scope.allVectors, function(vector) {
          $scope.recreateConsumptionsSnap(vector);
        });
      });
    };
    /* fine codice per forzare la crezione degli snapshot relativi al consuntivo */

    //__main__
    initDashboard();
});

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:DaydegreeCtrl
 * @description
 * # DaydegreeCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/energy/daydegree/:type', {
        templateUrl: 'energy/daydegrees/daydegree.html',
        controller: 'DaydegreeCtrl'
      })
  })
  .controller('DaydegreeCtrl', function ($scope, $q, $log, $routeParams, $location, $sce, dayDegreeFactory, recordFactory, $http, SaveAs,
                                         heatingSeasonFactory, zonaTermicaFactory, dialogService, localStorageService, ENERGY_URL, APP_URL, DEV,
                                         zonaClimaticaFactory, errorService, ngDialog, toaster, authFactory, loadingBarService) {

      var HIST_YEAR = 1970;

      $scope.bool = { selectPeriod: false};

      $scope.months = [];

      $scope.dataMatrix = createArray(12, 31);
      $scope.dataTotals = createArray(13);
      $scope.dataGrid =[];
      $scope.graphData = [];
      $scope.graphDataCum = [];

      $scope.dropdownActionList = {
        list: []   // Lista delle azioni disponibili
      };

      $scope.type = $routeParams.type === 'real'|| $routeParams.type === 'hist' ? $routeParams.type: 'real';

      $scope.selected = {   /* metto l'anno in un oggetto altrimenti ng-model non lo aggiorna */
        year: ((new Date()).getFullYear()).toString()
      };
      $scope.period = {
        dateFrom: '',
        dateTo: ''
      };

      $scope.max = 0;
      $scope.realDataLoaded = false;
      $scope.histDataLoaded = false;

      $scope.show = {firstHalf: true, secondHalf: true, stats: false};

      var CONSTANT_YEAR = 5;
      var low = (new Date()).getFullYear() - CONSTANT_YEAR;
      var high = (new Date()).getFullYear() + CONSTANT_YEAR;

      $scope.zonatermica = {};
      $scope.referring = null;
      $scope.refZonaTermica = {aa:'a'};

      $scope.yearsInPeriod = [];

      $scope.seasonYears = {};

      $scope.monthsValues = null;
      $scope.monthsValuesHist = false;

      if(localStorageService.get('daydegree.zonatermica_id')) {
        $scope.zonatermica = {
          zonatermica_id: localStorageService.get('daydegree.zonatermica_id') || {}
        };
      }

      $scope.gridOptions = {
          enableGridMenu: true
      };

      $scope.gridOptions.columnDefs = [
          {field: 'placeLabel', name: 'Zona Termica', headerCellClass: 'largeColumn'},
          {field: 'month', name: 'Mese', width: 100},
          {field: 'year', name: 'Anno', width: 100}
      ];

      for (var colIndex = 1; colIndex < 32; colIndex++) {
          $scope.gridOptions.columnDefs.push({
              field: '' + colIndex,
              name: '' + colIndex,
              width: 34,
              headerCellClass: 'smallHeader',
              enableColumnMenu: false
          });
      }

      $scope.getPlaceCode = function (){
          if(!$scope.zonatermica.zonatermica_id) return '';
          return $scope.zonatermica.zonatermica_id.UUID;
      };

      function createArray(length) {
        var arr = new Array(length || 0);
        var i = length;
        if (arguments.length > 1) {
          var args = Array.prototype.slice.call(arguments, 1);
          while(i--) arr[length-1 - i] = createArray.apply(this, args);
        }
        return arr;
      }

      function reloadLocationData(doNotClear) {
          if (angular.isUndefined(doNotClear)){
              $scope.zonatermica.model = null;
              $scope.referring = null;
              $scope.refZonaTermica = [];
              $scope.provincia = [];
              $scope.zonaClimatica = [];
              $scope.comune = [];//se la località ha un comune, quindi o è un comune o qualcosa di più piccolo, qua ci sono dati del comune e della provincia
              $scope.provincia = [];//se la località è quella che contiene i dati climatici della provincia, i dati della provincia li metto qua
              $scope.seasonEndDay = null;
              $scope.seasonStartDay = null;
              $scope.seasonEndMonth = null;
              $scope.seasonStartMonth = null;
          }
          zonaTermicaFactory.byUUID({id: $scope.zonatermica.zonatermica_id.UUID}).$promise.then(function (zonaTermicaData) {
            if (zonaTermicaData.model) {
              localStorageService.set('daydegree.zonatermica_id', $scope.zonatermica.zonatermica_id);
              $scope.zonatermica.model = zonaTermicaData.model;
              if (zonaTermicaData.model.ref_loc_id) {
                  dayDegreeFactory.zonaTermicaWithDefaults({zt: zonaTermicaData.model.ref_loc_id.UUID}).$promise.then(function (refZonaTermicaData) {
                      if (refZonaTermicaData) {
                          $scope.refZonaTermica = refZonaTermicaData;
                      }
                  });
              }
              dayDegreeFactory.locReferencedBy({zt: zonaTermicaData.UUID}).$promise.then(function (referr) {
                  $scope.referring = referr;
              });
              //recupero le info sulla zona climatica
              zonaClimaticaFactory.findByZonaTermica({id: zonaTermicaData.UUID}).$promise.then(function (zClim) {
                  if (errorService.handleError(zClim)){
                      $scope.zonaClimatica = zClim;
                      $scope.seasonEndDay = zClim.model.day_out;
                      $scope.seasonStartDay = zClim.model.day_in;

                      $scope.seasonEndMonth = sixDateLib.getMonthIndex(zClim.model.month_out);
                      $scope.seasonStartMonth = sixDateLib.getMonthIndex(zClim.model.month_in);
                  } else{
                    toaster.pop('error', 'Errore', 'Zona Climatica non trovata');
                  }
              });
              //E' UNA LOCALITA' "BASE", RECUPERO LE INFO SUL COMUNE E LA RELATIVA PROVINCIA
              if (zonaTermicaData.model.comune_id) {
                  recordFactory(zonaTermicaData.model.comune_id.type).byUUID({id: zonaTermicaData.model.comune_id.UUID})
                      .$promise.then(function (comune) {
                          $scope.comune = comune;
                          if ($scope.comune.model.provincia_id) {
                              recordFactory($scope.comune.model.provincia_id.type)
                                .byUUID({id: $scope.comune.model.provincia_id.UUID}).$promise.then(function (provincia) {
                                  if (errorService.handleError(provincia)){
                                    $scope.provincia = provincia;
                                  }else{
                                      toaster.pop('error', 'Errore', 'Provincia non trovata');
                                  }
                              });
                          }
                      });
              }
            }
        });
      }

      $scope.showDay = function(day){
          return (day<15 && $scope.show.firstHalf ) || (day>=15 && $scope.show.secondHalf);
      };

      function CheckDates(){
        if($scope.bool.selectPeriod == false){
          if(angular.isUndefined($scope.selected.year)){
            return false;
          }
        } else{
          if( $scope.period.dateFrom == null || $scope.period.dateTo == null){
            return false;
          }else{
            if($scope.period.dateFrom > $scope.period.dateTo){
              return false;
            }
          }
        }
        return true;
      }

      $scope.loadDD = function(){
        $log.log('loadDD');
        if (angular.isDefined($scope.zonatermica.zonatermica_id) && CheckDates()) {
          if ($scope.bool.selectPeriod == true) {
            $scope.period.dateFrom = new Date($scope.period.dateFrom);
            $scope.period.dateTo = new Date($scope.period.dateTo);
            var difference = sixDateLib.getMonthsInPeriod($scope.period.dateFrom, $scope.period.dateTo);
            $scope.months = [];
            var index = 0;
            difference.forEach(function (value) {
              var item = {
                numMonth: value.getMonth(),
                yearMonth: ($scope.type==='real') ? value.getFullYear() : HIST_YEAR,
                descrMonth: sixDateLib.getMonthShortName(value.getMonth()) + ' ' + value.getFullYear(),
                dateMonth: value,
                indexMatrix: index
              };
              index++;
              $scope.months.push(item);
            });
            $scope.yearsInPeriod = sixDateLib.getYearsInPeriod($scope.period.dateFrom, $scope.period.dateTo);
          } else{
            // metto da parte l'anno selezionato...
            $scope.year = parseInt($scope.selected.year);
            // inizializzo un array con tutti i dettagli di ogni mese...
            $scope.months = [];
            var index = 0;
            for (var i = 0; i < 12; i++) {
              var item = {
                numMonth: i,
                yearMonth: ($scope.type==='real') ? $scope.selected.year : HIST_YEAR,
                descrMonth: sixDateLib.getMonthShortName(i) + ' ' + $scope.selected.year,
                dateMonth: new Date($scope.selected.year, i, 1),
                indexMatrix: index
              };
              index++;
              $scope.months.push(item);
            }
            // fine inizializzazione array mesi...

            // creo un array contententi gli anni del periodo iniziato... (in questo caso sarà solamente un anno)
            $scope.yearsInPeriod = [];
            if($scope.type === 'real') {
              $scope.yearsInPeriod.push($scope.selected.year);
            } else {
              // prendo lo storico... 1970
              $scope.yearsInPeriod.push(HIST_YEAR);
            }
          }
          // parte comune: dichiaro la matrice per i dati giorno x giorno, e la colonna per salvare i totali...
          $scope.dataMatrix = createArray($scope.months.length, 31);
          $scope.dataTotals = createArray($scope.months.length + 1);
          $scope.realDataLoaded = false;
          $scope.histDataLoaded = false;
          $scope.seasonYears = {};
          // scorro gli anni per prendere tutte le date di inizio/fine stag. termica...
          for(var i = 0; i < $scope.yearsInPeriod.length; i++){
            $scope.seasonYears[$scope.yearsInPeriod[i]] = {};
            var seasonStartPromise = heatingSeasonFactory.begin({
                  type: $scope.zonatermica.zonatermica_id.type,
                  zt: $scope.zonatermica.zonatermica_id.UUID,
                  year: $scope.yearsInPeriod[i]})
                .$promise.then(function(data) {
                if (errorService.handleError(data)){
                  $scope.seasonYears[(new Date(data.result.date)).getFullYear()].seasonStartDay = (new Date(data.result.date)).getDate();
                  $scope.seasonYears[(new Date(data.result.date)).getFullYear()].seasonStartMonth = (new Date(data.result.date)).getMonth();
                } else{
                  toaster.pop('error', 'Errore', 'Zona Climatica per l\'inizio della stagione termica non trovata');
                }
                return this;
              });
            var seasonEndPromise = heatingSeasonFactory.end({
                  type: $scope.zonatermica.zonatermica_id.type,
                  zt: $scope.zonatermica.zonatermica_id.UUID,
                  year: $scope.yearsInPeriod[i]})
              .$promise.then(function(data) {
                if (errorService.handleError(data)){
                  $scope.seasonYears[(new Date(data.result.date)).getFullYear()].seasonEndDay = (new Date(data.result.date)).getDate();
                  $scope.seasonYears[(new Date(data.result.date)).getFullYear()].seasonEndMonth = (new Date(data.result.date)).getMonth();
                } else{
                  toaster.pop('error', 'Errore', 'Zona Climatica per la fine della stagione termica non trovata');
                }
                return this;
              });
          }
          // inizializzo a zero la colonna dei totali...
          for (var i = 0; i <= $scope.months.length; i++){
              $scope.dataTotals[i] = {
                  'totReal':0
              };
          }
          //Se necessario, ricarico la località...
          var locChanged = true;
          if ($scope.zonatermica.model) {
            locChanged = $scope.zonatermica.model.code != $scope.zonatermica.zonatermica_id.UUID;
          }
          if (locChanged) {
            reloadLocationData();
          }
          var placeCode = $scope.getPlaceCode();
          $scope.graphData = [];
          $scope.graphDataCum = [];
          $scope.max = 0;
          // inizializzo la matrice per i dati giorno x giorno, con le date, i tipi 'hist' e 'real', e i valori a 0...
          /* init dataMatrix */
          for (var m = 0; m < $scope.months.length; m++) {
            for (var d = 1; d <= 31; d++) {
              var date = new Date($scope.months[m].dateMonth.getFullYear(), $scope.months[m].dateMonth.getMonth(), d);
              var histDate = new Date(HIST_YEAR, $scope.months[m].dateMonth.getMonth(), d);
              if (date.getMonth() == $scope.months[m].dateMonth.getMonth()) {//non ha shiftato al mese dopo
                var emptyData = {
                  real: {
                    'value': 0,
                    'date': date.getTime(),
                    'type': 'real'
                  },
                  hist: {
                    'value': 0,
                    'date': histDate.getTime(),
                    'type': 'hist'
                  }
                };
                $scope.dataMatrix[m][d - 1] = emptyData;
              }
            }
          }
          // una volta ottenute le date di inizio e fine stagione termica, riempio con i dati ottenuti dalla dayDegreeFactory...
          $q.all([seasonStartPromise, seasonEndPromise]).then(function() {
            if ($scope.bool.selectPeriod == true) {
              if($scope.type == 'real'){
                /* dati di consuntivo del periodo scelto: sia storici che reali... */
                dayDegreeFactory.search({
                  type: 'real',
                  fromDate: $scope.period.dateFrom.getFullYear() + '/' + ($scope.period.dateFrom.getMonth()+1) + '/' + $scope.period.dateFrom.getDate(),
                  toDate: $scope.period.dateTo.getFullYear() + '/' + ($scope.period.dateTo.getMonth()+1) + '/' + $scope.period.dateTo.getDate(),
                  place: placeCode
                }).$promise.then(loadedRealData);
                dayDegreeFactory.search({
                  type: 'hist',
                  //l'anno poi sarà sostituito dal server con 1970..
                  fromDate: $scope.period.dateFrom.getFullYear() + '/01/01',
                  toDate: $scope.period.dateTo.getFullYear() + '/12/31',
                  place: placeCode
                }).$promise.then(loadedHistDataSplit);
              } else if($scope.type == 'hist'){
                /* dati di consuntivo storici, carico solo questi, carico però tutto l'anno... */
                dayDegreeFactory.search({
                  type: 'hist',
                  //l'anno poi sarà sostituito dal server con 1970..
                  fromDate: $scope.period.dateFrom.getFullYear() + '/01/01',
                  toDate: $scope.period.dateTo.getFullYear() + '/12/31',
                  place: placeCode
                }).$promise.then(loadedHistDataSplit);
              }
            } else{
              /* dati di consuntivo dell'anno scelto: sia storici che reali... */
              if($scope.type == 'real'){
                dayDegreeFactory.search({
                  type: 'real',
                  fromDate: $scope.selected.year + '/01/01',
                  toDate: $scope.selected.year + '/12/31',
                  place: placeCode
                }).$promise.then(loadedRealData);
                /* dati di storico */
                dayDegreeFactory.search({
                  type: 'hist',
                  //l'anno poi sarà sostituito dal server con 1970..
                  fromDate: $scope.selected.year + '/01/01',
                  toDate: $scope.selected.year + '/12/31',
                  place: placeCode
                }).$promise.then(loadedHistData);
              } else if($scope.type == 'hist'){
                /* dati di consuntivo storici, carico solo questi... */
                dayDegreeFactory.search({
                  type: 'hist',
                  //l'anno poi sarà sostituito dal server con 1970..
                  fromDate: $scope.selected.year + '/01/01',
                  toDate: $scope.selected.year + '/12/31',
                  place: placeCode
                }).$promise.then(loadedHistData);
              }
            }
          });
        }
      };

      $scope.editingMonth = null;

      function loadedHistData(value) {
        value.list.forEach(function (record) {
          var dateCurrent = new Date(record.date);
          var m = sixDateLib.countMonthsInPeriod(new Date(HIST_YEAR, 0, 1), dateCurrent) - 1;
          $scope.dataMatrix[m][dateCurrent.getDate() - 1].hist = record;
          $scope.dataTotals[m]['totHist'] = ($scope.dataTotals[m]['totHist'] || 0) + record.value;
          $scope.dataTotals[$scope.months.length]['totHist'] = ($scope.dataTotals[$scope.months.length]['totHist'] || 0) + record.value;
          if ($scope.max < record.value)
            $scope.max = record.value;
        });
        $scope.histDataLoaded = true;
        evaluateTotalsAndGraph();
      }

      function loadedRealData(value) {
          value.list.forEach(function (record) {
              var dateCurrent = new Date(record.date);
              var m;
              if($scope.bool.selectPeriod == true){
                m = sixDateLib.countMonthsInPeriod($scope.period.dateFrom, dateCurrent) - 1;
              } else{
                m = sixDateLib.countMonthsInPeriod(new Date($scope.selected.year, 0, 1), dateCurrent) - 1;
              }
              $scope.dataMatrix[m][dateCurrent.getDate() - 1].real = record;
              if($scope.inSeason(dateCurrent.getFullYear(), dateCurrent.getMonth(), dateCurrent.getDate()) === true) {
                $scope.dataTotals[m]['totReal'] = ($scope.dataTotals[m]['totReal'] || 0) + record.value;
                $scope.dataTotals[$scope.months.length]['totReal'] = ($scope.dataTotals[$scope.months.length]['totReal'] || 0) + record.value;
              }
              if ($scope.max < record.value) $scope.max = record.value;
          });
          $scope.realDataLoaded = true;
          evaluateTotalsAndGraph();
      }

      function loadedHistDataSplit(value){
        var dateCurrent = new Date($scope.period.dateFrom.getFullYear(), $scope.period.dateFrom.getMonth(), 1);
        var histMatrix = createArray(12, 31);
        for (var m = 0; m < 12; m++) { /* matrice di appoggio per prelevare il budget di default */
          for (var d = 1; d <= 31; d++) {
            var date = new Date(HIST_YEAR, m, d);
            if (date.getMonth() == m) {
              var emptyData = {
                hist: {
                  'value': 0,
                  'date': date.getTime(),
                  'type': 'hist'
                }
              };
              histMatrix[m][d - 1] = emptyData;
            }
          }
        }
        value.list.forEach(function (record) { /* aggiornamento matrice di appoggio -> con i dati del budget */
          var recordDate = new Date(record.date);
          histMatrix[recordDate.getMonth()][recordDate.getDate() - 1].hist = record;
        });
        var recordCurrent;
        while(dateCurrent <= $scope.period.dateTo){ /* aggiornamento dataMatrix */
          if(angular.isDefined(histMatrix[dateCurrent.getMonth()][dateCurrent.getDate() - 1])){ /* per gestire anni bisestili */
            var m = sixDateLib.countMonthsInPeriod($scope.period.dateFrom, dateCurrent) - 1;
            recordCurrent = histMatrix[dateCurrent.getMonth()][dateCurrent.getDate() - 1].hist;
            $scope.dataMatrix[m][dateCurrent.getDate() - 1].hist = recordCurrent;
            $scope.dataTotals[m]['totHist'] = ($scope.dataTotals[m]['totHist'] || 0) + recordCurrent.value;
            $scope.dataTotals[$scope.months.length]['totHist'] = ($scope.dataTotals[$scope.months.length]['totHist'] || 0) + recordCurrent.value;
            if ($scope.max < recordCurrent.value) {
              $scope.max = recordCurrent.value;
            }
          }
          dateCurrent.setDate(dateCurrent.getDate() + 1);
        }
        $scope.histDataLoaded = true;
        evaluateTotalsAndGraph();
      }

      function evaluateTotalsAndGraph(){
          if (($scope.type == 'hist' && $scope.histDataLoaded) ||
            ($scope.type == 'real' && ($scope.realDataLoaded && $scope.histDataLoaded))) {
            //caricato entrambi o solo gli storici, dipende dalla pagina in cui siamo
              var cumReal = 0, cumHist = 0;
              if ($scope.max > 0) {
                  for (var m = 0; m < $scope.months.length; m++) {
                      var dmm = $scope.dataMatrix[m];
                      var dtm = $scope.dataTotals[m];
                      if (m > 0) {
                          dtm['cumulReal'] = ($scope.dataTotals[m - 1]['cumulReal'] || 0) + (dtm['totReal']||0);
                          dtm['cumulHist'] = ($scope.dataTotals[m - 1]['cumulHist'] || 0) + (dtm['totHist']||0);
                      } else {
                          dtm['cumulReal'] = dtm['totReal'];
                          dtm['cumulHist'] = dtm['totHist'];
                      }
                      for (var d = 1; d <= 31; d++) {
                          if (dmm[d - 1]) {
                              var data = dmm[d - 1].real;
                              cumReal += data.value;
                              cumHist += dmm[d - 1].hist.value;
                              var date = new Date(data.date);
                              var grpDT = {
                                  'date': date
                              };
                              var grpCumDT = {
                                  'date': date
                              };
                              if ($scope.type != 'hist') {
                                  grpDT['Consuntivo'] = '' + data.value;
                                  grpCumDT['Consuntivo'] = '' + cumReal;
                              }
                              grpDT['Storico'] = '' +dmm[d - 1].hist.value;
                              grpCumDT['Storico'] = '' +cumHist;

                              $scope.graphData.push(grpDT);
                              $scope.graphDataCum.push(grpCumDT);
                          }
                      }
                  }
              }
          }
      }


      //TODO: questa parte è fatta in fretta.. sarà da sistemare
      $scope.calculateFromRef = function(){
          var value = {
              code_ref: $scope.refZonaTermica.UUID,
              code: $scope.zonatermica.zonatermica_id.UUID,
              description: $scope.zonatermica.model.description,
              year: $scope.selected.year
          };
          // dialogService.loading('Calcolo dati da località di riferimento ('+$scope.refZonaTermica.model.description+')');
          loadingBarService.start('Calcolo dati da località di riferimento ('+$scope.refZonaTermica.model.description+')');
          dayDegreeFactory.saveByRef({type: $scope.type, op: $scope.refZonaTermica.UUID}, value).$promise.then(function (response) {
            if (errorService.handleError(response)){
              $scope.loadDD();
            } else{
              toaster.pop('error', 'Errore', 'Errore nel calcolo dei gradi giorno');
            }
            // dialogService.stopLoading();
            loadingBarService.stop();
          });
      };

      $scope.calculateReferring = function(){
          var value = {year: $scope.selected.year};
          // dialogService.loading('Calcolo località collegate ('+$scope.zonatermica.model.description+')');
          loadingBarService.start('Calcolo località collegate ('+$scope.zonatermica.model.description+')');
          dayDegreeFactory.saveReferring({type: $scope.type, op: $scope.zonatermica.zonatermica_id.UUID}, value).$promise.then(function (response) {
            if (!errorService.handleError(response)){
              toaster.pop('error', 'Errore', 'Errore nel caricamento dei gradi giorno');
            }
            // dialogService.stopLoading();
            loadingBarService.stop();
          });
      };

      $scope.calculateAllReferring = function(){
        var message = 'ATTENZIONE: Ricalcolare i Gradi Giorno a consuntivo di TUTTE le zone termiche nel sistema?';
        dialogService.confirmDialog(message,
          function () {
            loadingBarService.start('Calcolo TUTTE le località...');
            dayDegreeFactory.saveAllReferring({time: $scope.selected.year}).$promise.then(function (response) {
              if (!errorService.handleError(response)){
                toaster.pop('error', 'Errore', 'Errore nel calcolo dei gradi giorno');
              }
              loadingBarService.stop();
            });
          }
        );
      };

      $scope.tempToDD = function(normalized){
          // dialogService.loading('Ricalcolo gradi giorno');
          loadingBarService.start('Ricalcolo gradi giorno');
          dayDegreeFactory.tempToDD({
              zt: $scope.zonatermica.zonatermica_id.UUID,
              normalize: normalized
          }).$promise.then(function (result) {
            if(errorService.handleError(result)) {
              $scope.loadDD();
            } else {
              toaster.pop('error', 'Errore', 'Errore nel calcolo dei gradi giorno');
            }
            // dialogService.stopLoading();
            loadingBarService.stop();
          });
      };

      $scope.tempToDDAll = function(){
        var message = 'ATTENZIONE: Ricalcolare i Gradi Giorno storici di TUTTE le zone termiche nel sistema?';
        dialogService.confirmDialog(message,
          function () {
            // dialogService.loading('Ricalcolo gradi giorno (TUTTE le ZT)');
            loadingBarService.start('Ricalcolo gradi giorno (TUTTE le ZT)');
            dayDegreeFactory.tempToDDAll().$promise.then(function (result) {
              if(errorService.handleError(result)) {
                $scope.loadDD();
              } else {
                toaster.pop('error', 'Errore', 'Errore nel calcolo dei gradi giorno');
              }
              // dialogService.stopLoading();
              loadingBarService.stop(result);
            });
          }
        );
      };

      $scope.delete = function(){
          var value = {year: $scope.selected.year };
          // dialogService.loading('Cancellazione in corso');
          loadingBarService.start('Cancellazione in corso');
          dayDegreeFactory.delete({type: $scope.type, op: $scope.zonatermica.zonatermica_id.UUID}, value).$promise.then(function (response) {
              $scope.loadDD();
              // dialogService.stopLoading();
              loadingBarService.stop();
          });
      };


      function replaceAll(str, find, replace) {
        return str.replace(new RegExp(find, 'g'), replace);
      }


      var REPORT_JASPER_DIRECTORY = 'reports/EMMA/Energy/daydegree_tab_all_zt'; // path del report su jasperserver


      $scope.printReport = function (extensionFile) {
        var urlPrefix = DEV?'/':'/emma/';
        var endpointAddressGenericReport = 'http://' + $location.$$host + ':' + $location.$$port + urlPrefix + ENERGY_URL + '/api/report/_zonatermica/_list';
        var endpointAddressSingleReport = 'http://' + $location.$$host + ':' + $location.$$port + urlPrefix + ENERGY_URL + '/api/report/_daydegree/_tab';
        var reportNameToSave =  'report_gradi_giorno'; // nome con il quale viene salvato sul pc dell'utente
        var reportPath =  REPORT_JASPER_DIRECTORY + '.' + extensionFile;   // dove si trova il report su jasperserver (http://172.29.100.155:7878/jasperserver) + nome report .pdf
        if(CheckDates()){
          var from = '';
          var to = '';
          var id = $scope.zonatermica.zonatermica_id ? new String($scope.zonatermica.zonatermica_id.UUID) :'null';
          if ($scope.bool.selectPeriod == true) {
            from = sixDateLib.getDateStringFormattedFromDate($scope.period.dateFrom).replace('/', '-');
            to   = sixDateLib.getDateStringFormattedFromDate($scope.period.dateTo).replace('/', '-');
          } else {
            from = $scope.selected.year + '-01-01';
            to =   $scope.selected.year + '-12-31';
          }
          var singleReport = endpointAddressSingleReport + '/' + $scope.type + '/' + from + '/' + to + '/';
          var query = '&net.sf.jasperreports.json.source=' + endpointAddressGenericReport + '/' + id + '/' + replaceAll(singleReport, '/', '$');

          $http.post(APP_URL + '/rest/report/generate',
            {
              path: reportPath,
              query: query
            },
            {
              responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
            var options;
            if(extensionFile == 'pdf'){
              options = {type: 'application/pdf'};
            } else if (extensionFile == 'xls') {
              options = {type: 'application/vnd.ms-excel;'};
            }
            SaveAs.download(data, reportNameToSave + '.' + extensionFile, options);
          }).error(function (data, status, headers, config) {
            toaster.pop('error', "Errore", 'Errore generazione report');
          });
        }
      };


      $scope.getTimes = function(n){
          return new Array(n);
      };

      $scope.getMonths = function(){
          return [0,1,2,3,4,5,6,7,8,9,10,11];
      };

      $scope.clearDates = function(){
        $scope.period.dateFrom = null;
        $scope.period.dateTo = null;
      };

      $scope.getKibanaUrl = function(){
          if(!$scope.zonatermica.zonatermica_id) return;
          var year = $scope.selected.year;
          if ($scope.type === 'hist') year = HIST_YEAR;
          var host = $location.host();
          host = 'localhost' === host ? 'docker.ict-group.it' : host;
          //FIXME: manca il tipo
          var src = 'http://'+host+':5601/#/dashboard/BudgetDashboard?embed&_g=(refreshInterval:(display:Off,section:0,value:0),time:(from:\''+year+'-01-01T00:00:00.000Z\',mode:absolute,to:\''+(year+1)+'-01-01T00:00:00.000Z\'))&_a=(filters:!(),panels:!((col:1,id:Budget-Visualization,row:1,size_x:12,size_y:3,type:visualization)),query:(query_string:(analyze_wildcard:!t,query:\'place.code%3D!\''+$scope.getPlaceCode()+'!\'\')),title:BudgetDashboard)';
          return $sce.trustAsResourceUrl(src);
      };

      $scope.editMonth = function(month){
          $scope.editingMonth = month;
      };

      $scope.confirmMonthWithDialog = function(month){
        if($scope.type === 'real') {
          var message = 'Ricalcolare anche i Gradi Giorno a consuntivo delle località che afferiscono a questa? ';
          dialogService.confirmDialog(message, function () { $scope.confirmMonth(month, true); }, function () { $scope.confirmMonth(month, false); });
        } else {
          $scope.confirmMonth(month, false);
        }
      };

      $scope.confirmMonth = function(month, saveReferring){
          var value=[];
          $scope.editingMonth = null;
          // dialogService.loading('Salvataggio in corso');
          loadingBarService.start('Salvataggio in corso');
          var placeForNewDD = {
              type : $scope.zonatermica.zonatermica_id.type,
              UUID : $scope.zonatermica.zonatermica_id.UUID,
              code : $scope.zonatermica.model.code,
              description : $scope.zonatermica.model.description
          };
          for (var i = 0;i<31;i++){
              if ($scope.dataMatrix[month][i] && $scope.dataMatrix[month][i][$scope.type]) {
                  var toSave = $scope.dataMatrix[month][i][$scope.type];
                  if (!toSave.id){ //nuovo dato
                      toSave.place = placeForNewDD;
                  }
                  value.push(toSave);
              }
          }
          dayDegreeFactory.save({saveReferring: saveReferring}, value).$promise.then(function (response) {
              $log.info('saved');
              $scope.loadDD();
              // dialogService.stopLoading();
              loadingBarService.stop();
          });
      };

      $scope.undoMonth = function(month){
          //ricarico...
          $scope.editingMonth = null;
          $scope.loadDD();
      };

      $scope.inSeason = function(year, month, day){
        // è da adattare in base all'anno passato come funzione sotto
        if (month < $scope.seasonYears[year].seasonEndMonth || month > $scope.seasonYears[year].seasonStartMonth) return true;
        return (month == $scope.seasonYears[year].seasonEndMonth && day <= $scope.seasonYears[year].seasonEndDay)
          || (month == $scope.seasonYears[year].seasonStartMonth && day >= $scope.seasonYears[year].seasonStartDay);

      };

      $scope.DrawInSeason = function(m, day){
        // è da adattare in base all'anno passato come funzione sotto
        if (m.numMonth < $scope.seasonYears[m.yearMonth].seasonEndMonth || m.numMonth > $scope.seasonYears[m.yearMonth].seasonStartMonth) return true;
        return (m.numMonth == $scope.seasonYears[m.yearMonth].seasonEndMonth && day <= $scope.seasonYears[m.yearMonth].seasonEndDay)
          || (m.numMonth == $scope.seasonYears[m.yearMonth].seasonStartMonth && day >= $scope.seasonYears[m.yearMonth].seasonStartDay);
      };

      $scope.drawSeasonEnd = function(m, index){
        if(m.numMonth == $scope.seasonYears[m.yearMonth].seasonEndMonth && index == $scope.seasonYears[m.yearMonth].seasonEndDay - 1){
          return true;
        }else{
          return false;
        }
      };

      $scope.drawSeasonStart = function(m, index){
        if(m.numMonth == $scope.seasonYears[m.yearMonth].seasonStartMonth && index == $scope.seasonYears[m.yearMonth].seasonStartDay - 1){
          return true;
        }else{
          return false;
        }
      };

      $scope.editMonthsValues = function(history){
          $scope.monthsValues = [];
          var type = '';
          if (history) {
              $scope.monthsValuesHist = true;
          }
          else{
              $scope.monthsValuesHist = false;
          }
          for (var m = 0; m < $scope.months.length; m++) {
              var value;
              if ($scope.dataTotals[m]){
                  value = $scope.monthsValuesHist ?
                      $scope.dataTotals[m].totHist :
                      $scope.dataTotals[m].totReal;
              }
              if (value){
                  $scope.monthsValues.push(value);
              } else {
                  $scope.monthsValues.push(0);
              }
          }
      };

      $scope.confirmEditMonthsWithDialog = function(){
        if($scope.type === 'real') {
          var message = 'Ricalcolare anche i Gradi Giorno a consuntivo delle località che afferiscono a questa? ';
          dialogService.confirmDialog(message, function () { $scope.confirmEditMonths(true); }, function () { $scope.confirmEditMonths(false); });
        } else {
          $scope.confirmEditMonths(false);
        }
      };

      $scope.confirmEditMonths = function(saveReferring){
          // dialogService.loading('Salvataggio in corso');
          loadingBarService.start('Salvataggio in corso');
          var type = $scope.monthsValuesHist? 'hist' : 'real';
          var valuesMap = {};
          for (var m = 0; m < $scope.months.length; m++){
              valuesMap[''+m]=$scope.monthsValues[m];
          }
          dayDegreeFactory.saveMonths({type: type, zt: $scope.zonatermica.zonatermica_id.UUID, year: $scope.selected.year, saveReferring: saveReferring}, valuesMap).$promise.then(function (response) {
            if (errorService.handleError(response)) {
              $scope.monthsValues = null;
              $scope.loadDD();
            } else {
              toaster.pop('error', 'Errore', 'Errore durante la modifica dei gradi giorno');
            }
            // dialogService.stopLoading();
            loadingBarService.stop();
          });
      };

      $scope.getYears = function(){
        var years=[];
        for (var i = low; i<high; i++) {
          years.push(i);
        }
        return years;
      };

      $scope.previousYear = function(){
        $scope.selected.year = parseInt($scope.selected.year) - 1;
        if ($scope.selected.year <= low){
          low = low - CONSTANT_YEAR;
        }
      };

      $scope.nextYear = function(){
        $scope.selected.year = parseInt($scope.selected.year) + 1;
        if ($scope.selected.year >= high){
          high = high + CONSTANT_YEAR;
        }
      };

      $scope.undoEditMonths = function(){
          $scope.monthsValues = null;
      };

      $scope.goToImportDD = function() {
        $location.path('energy/importgg');
      };

      $scope.$watch('zonatermica.zonatermica_id',
        function(newValue, oldValue) {
          if (newValue != oldValue){
            $scope.loadDD();
          }
        }
      );

      $scope.$watch('selected.year',
        function(newVal, oldVal) {
          if (newVal != oldVal){
            $scope.loadDD();
          }
        }
      );

      $scope.loadDD();



      /** ***********************************
       * Check permissions
       * ***********************************/

      var RESOURCE_NAME = 'energy/dd';

      $scope.isWritePermAllowed = function() {
        return authFactory.isWritePermAllowed(RESOURCE_NAME);
      };

      $scope.isDeletePermAllowed = function() {
        return authFactory.isDeletePermAllowed(RESOURCE_NAME);
      };

    });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ImportggCtrl
 * @description
 * # ImportggCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/energy/importgg', {
        templateUrl: 'energy/daydegrees/importgg.html',
        controller: 'ImportggCtrl'
      })
  })
  .controller('ImportggCtrl', function ($scope, $location, $log, recordFactory, dayDegreeFactory, zonaTermicaFactory, zonaClimaticaFactory, dialogService, $filter) {
      //http://ui-grid.info/

      $scope.period = 'month';
      $scope.type = 'real';
      $scope.season = {considerSeasonality: false};

      $scope.gridOptions = {
          onRegisterApi: function (gridApi) {
              $scope.gridApi = gridApi;
          }
      };

      $scope.downloadTemplate = function(){
          var anchor = $('#linkToTemplate');
          var url = anchor.attr("href");
          anchor.click(function (e) {
              e.preventDefault();
             window.location.href = url;
          })
          anchor.click();
      }

      $scope.toggleSeasonality = function(){
          $scope.season.considerSeasonality = !$scope.season.considerSeasonality;
      }

      //dati caricati da xls
      $scope.$watch(function( ) {
          return $scope.gridOptions.xlsData;
        },
        function( newValue, oldValue ) {
          if (newValue && newValue.length>0){
            reloadGridOptions();
            processData();
          }
        }
      );

      function processRow(row) {
        var result = angular.copy(row);
        result['placeLabel'] = result['Zona_Termica'];
        delete result.Zona_Termica;

        if ($scope.period === 'month') {
          result['1'] = result['Gen']?parseFloat(result['Gen']):undefined;
          delete result['Gen'];

          result['2'] = result['Feb']?parseFloat(result['Feb']):undefined;
          delete result['Feb'];

          result['3'] = result['Mar']?parseFloat(result['Mar']):undefined;
          delete result['Mar'];

          result['4'] = result['Apr']?parseFloat(result['Apr']):undefined;
          delete result['Apr'];

          result['5'] = result['Mag']?parseFloat(result['Mag']):undefined;
          delete result['Mag'];

          result['6'] = result['Giu']?parseFloat(result['Giu']):undefined;
          delete result['Giu'];

          result['7'] = result['Lug']?parseFloat(result['Lug']):undefined;
          delete result['Lug'];

          result['8'] = result['Ago']?parseFloat(result['Ago']):undefined;
          delete result['Ago'];

          result['9'] = result['Set']?parseFloat(result['Set']):undefined;
          delete result['Set'];

          result['10'] = result['Ott']?parseFloat(result['Ott']):undefined;
          delete result['Ott'];

          result['11'] = result['Nov']?parseFloat(result['Nov']):undefined;
          delete result['Nov'];

          result['12'] = result['Dic']?parseFloat(result['Dic']):undefined;
          delete result['Dic'];

          result['year'] = result['Anno']?parseInt(result['Anno']):undefined;
          delete result['Anno'];
        }
        else if ($scope.period === 'day') {
          result['month'] = parseInt(result['Mese']);
          delete result['Mese'];

          result['year'] = parseInt(result['Anno']);
          delete result['Anno'];

          for (var colIndex = 1; colIndex < 32; colIndex++) {
            if(result[colIndex]) {
              result[colIndex] = result[colIndex]?parseFloat(result[colIndex]):undefined;
            }
          }
        }

        delete result.update;

        return result;
      }


      function processData() {
        $scope.canUndo = false;
        $scope.canImport = false;
        $scope.total = 0;
        $scope.ok = 0;
        $scope.gridOptions.xlsData.forEach(function (value) {
          if(value.update === 's') {
            $scope.total += 1;
            value = processRow(value);

            zonaTermicaFactory.byCode({id: value.placeLabel})
              .$promise.then(function (data) {
                if (data.model) {

                  zonaClimaticaFactory.findByZonaTermica({id: data.UUID}).$promise.then(function (zoneData) {
                    console.log('zona ' + JSON.stringify(zoneData));
                    if (zoneData.model) {

                      var year, monthIn, dayIn, monthOut, dayOut;
                      ($scope.type === 'real') ? year = $filter('date')(new Date(), 'yyyy') : year = '1970';
                      ($scope.type === 'real') ? dayIn = 1 : dayIn = zoneData.model.day_in;
                      ($scope.type === 'real') ? monthIn = 0 : monthIn = sixDateLib.getMonthIndex(zoneData.model.month_in);
                      ($scope.type === 'real') ? dayOut = 31 : dayOut = zoneData.model.day_out;
                      ($scope.type === 'real') ? monthOut = 11 : monthOut = sixDateLib.getMonthIndex(zoneData.model.month_out);
                      value.dateIn = new Date(year, monthIn, dayIn);
                      value.dateOut = new Date(year, monthOut, dayOut);
                      value.zone = zoneData.model.code;
                      if (!value.dateIn || !value.dateOut) {
                        value.Result = 'Date inizio/fine mancanti';
                      } else {
                        value.dateInLabel = zoneData.model.day_in + '-' + zoneData.model.month_in;
                        value.dateOutLabel = zoneData.model.day_out + '-' + zoneData.model.month_out;
                        $scope.ok += 1;
                        if ($scope.ok > 1 && $scope.type === 'hist' && $scope.period === 'month') {
                          value.Result = 'Importare solo un anno per i dati storici';
                        } else {
                          value.Result = 'ok';
                        }
                      }
                      if ($scope.ok === $scope.total
                        && !($scope.ok > 1 && $scope.type === 'hist' && $scope.period === 'month')) {
                        $scope.canImport = true;
                        $scope.canUndo = true;
                        console.log(JSON.stringify($scope.gridOptions.data));
                      }
                    } else {
                      value.Result = 'Zona climatica mancante';
                    }
                  });
                  value.place = sixObjectLib.recordToHisRef(data);
                } else {
                  value.Result = 'Zona termica mancante';
                }
                $scope.gridOptions.data.push(value);
              });
          }
        });
      }

      $scope.importDataWithDialog = function() {
        if($scope.type === 'real') {
          var message = 'Ricalcolare anche i Gradi Giorno a consuntivo delle località che afferiscono a questa? ';
          dialogService.confirmDialog(message, function () {
            $scope.importData(true);
          }, function () {
            $scope.importData(false);
          });
        } else {
          $scope.importData(false);
        }
      };

      $scope.importData = function (saveReferring) {
          $scope.gridOptions.data.forEach(function (value) {

              $log.info($scope.gridOptions.columnDefs);
              $log.info('saving: ' + value);
              value.Result = 'Importazione in corso';
              if ($scope.period == 'month') {
                  dayDegreeFactory.saveByMonth({type: $scope.type, saveReferring: saveReferring, considerSeasonality: $scope.season.considerSeasonality}, value).$promise.then(function (response) {
                      $log.info(response);
                      value.Result = 'Importato';
                  });
              }else{
                  dayDegreeFactory.saveByDay({type: $scope.type, saveReferring: saveReferring, considerSeasonality: $scope.season.considerSeasonality}, value).$promise.then(function (response) {
                      $log.info(response);
                      value.Result = 'Importato';
                  });
              }

          });
      };

      $scope.clearData = function () {
          $scope.canUndo = false;
          $scope.canImport = false;
          $scope.gridOptions.data = [];
      };

      $scope.toggleHelp = function () {
          $scope.showHelp = !$scope.showHelp;
      };

      $scope.showHelp = false;
      $scope.canImport = false;
      $scope.canUndo = false;

      $scope.importByMonth = function() {
          $scope.gridOptions.data = [];
          $scope.period = 'month';
          reloadGridOptions();
      };

      $scope.importByDay = function(){
          $scope.gridOptions.data = [];
          $scope.period = 'day';
          reloadGridOptions();
      };

      $scope.importHist = function(){
          $scope.clearData();
          $scope.type = 'hist';
          reloadGridOptions();
      };

      $scope.importReal = function(){
          $scope.clearData();
          $scope.type = 'real';
          reloadGridOptions();
      };

      function dateLabel(string){
          return string.substr(8,2)+'-'+string.substr(5,2);
      }

      function reloadGridOptions(){
          //DEFINIZIONE TABELLA PER MESE
          if ($scope.period === 'month') {
              $scope.gridOptions.columnDefs = [
                  {field: 'placeLabel', name: 'Zona_Termica', displayName: 'Zona Termica', enableSorting: false, width: 150}];
              if ($scope.type === 'real') {
                  $scope.gridOptions.columnDefs.push(
                      {field: 'year', name: 'Anno', width: 100}
                  );
              }
              $scope.gridOptions.columnDefs.push(
                  {field: 'zone', name: 'Zona', width: 50, enableColumnMenu: false},
                  {field: 'dateInLabel', name: 'Da', width: 50, enableColumnMenu: false},
                  {field: 'dateOutLabel', name: 'A', width: 50, enableColumnMenu: false},
                  {field: '1', name: 'Gen', width: 50, enableColumnMenu: false},
                  {field: '2', name: 'Feb', width: 50, enableColumnMenu: false},
                  {field: '3', name: 'Mar', width: 50, enableColumnMenu: false},
                  {field: '4', name: 'Apr', width: 50, enableColumnMenu: false},
                  {field: '5', name: 'Mag', width: 50, enableColumnMenu: false},
                  {field: '6', name: 'Giu', width: 50, enableColumnMenu: false},
                  {field: '7', name: 'Lug', width: 50, enableColumnMenu: false},
                  {field: '8', name: 'Ago', width: 50, enableColumnMenu: false},
                  {field: '9', name: 'Set', width: 50, enableColumnMenu: false},
                  {field: '10', name: 'Ott', width: 50, enableColumnMenu: false},
                  {field: '11', name: 'Nov', width: 50, enableColumnMenu: false},
                  {field: '12', name: 'Dic', width: 50, enableColumnMenu: false},
                  {name: 'Result', cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) {}}
              );
          }
          //DEFINIZIONE TABELLA PER GIORNO
          if ($scope.period === 'day') {
              $scope.gridOptions.columnDefs = [
                {field: 'placeLabel', name: 'Zona_Termica', displayName: 'Zona Termica', headerCellClass: 'largeColumn'}
              ];
              if ($scope.type === 'real') {
                  $scope.gridOptions.columnDefs.push(
                      {field: 'year', name: 'Anno', width: 50}
                  );
              }
              $scope.gridOptions.columnDefs.push(
                  {field: 'month', name: 'Mese', width: 50},
                  {field: 'dateInLabel', name: 'Inizio', width: 50},
                  {field: 'dateOutLabel', name: 'Fine', width: 50});

              for (var colIndex = 1; colIndex < 32; colIndex++) {
                  $scope.gridOptions.columnDefs.push({
                      field: '' + colIndex,
                      name: '' + colIndex,
                      width: 26,
                      headerCellClass: 'smallHeader',
                      enableColumnMenu: false
                  });
              }
              $scope.gridOptions.columnDefs.push({name: 'Result', cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) {}});
          }
      }

      $scope.importByMonth();
      $scope.type = 'real';
  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.baseFactory
 * @description
 * # baseFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy')
  .factory('budgetFactory', function (ENERGY_URL, $resource) {
      return $resource(ENERGY_URL + '/api/budget/:verb/:id/:param1/:param2/:param3', {}, {
        byYear:                     {method: 'GET',     isArray: false, params: {verb: 'v2', param1: 'fe', param2: 'byyear'}},
        byHeader:                   {method: 'GET',     isArray: false, params: {verb: '_header'}},
        byCodeForPeriod:            {method: 'GET',     isArray: false, params: {verb: 'bycodeforperiod'}},
        budgetCodes:                {method: 'GET',     isArray: false, params: {verb: 'budgetcodes'}},
        budgetCodesFromCommissions: {method: 'GET',     isArray: false, params: {verb: 'budgetcodesfromcommissions'}},
        recordIdsFromBudgets:       {method: 'GET',     isArray: false, params: {verb: 'recordidsfrombudgets'}},
        bulk:                       {method: 'POST',    isArray: false, params: {verb: '_bulk' }},
        update:                     {method: 'PUT',     isArray: false, params: {verb: '_update', id: '@version'}},
        delete:                     {method: 'DELETE',  isArray: false, params: {verb: '_delete', id: '@version'}}
      });
  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.consumptionfactory
 * @description
 * # consumptionfactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy')
  .factory('consumptionAnalysisFactory', function (ENERGY_URL, $resource) {
    return function() {
      return $resource(ENERGY_URL + '/api/consumptionanalysis/:method/:p1/:p2', {}, {
        getConsumptionAnalysisByPlant: {method: 'GET', params: {method: 'getbyplant',  idOrCode: '@id'}},
        getConsumptionAnalysis: {method: 'POST', params: {method: 'get'}},
        createRecAssocSnap: {method: 'POST', params: {method: '_snap', p1: 'zt', p2: '_create'}},
        deleteRecAssocSnap: {method: 'POST', params: {method: '_snap', p1:'zt', p2: '_delete'}},
        getBudgetSnap:    {method: 'POST', params: {method: '_snap', p1: 'budget', p2: '_get'}, ignoreLoadingBar: true},
        createBudgetSnap: {method: 'POST', params: {method: '_snap', p1: 'budget', p2: '_create'}},
        deleteBudgetSnap: {method: 'POST', params: {method: '_snap', p1:'budget', p2: '_delete'}},
        getConsAnalisysSnap:    {method: 'POST', params: {method: '_snap', p1:'consanalisys', p2: '_get'}, ignoreLoadingBar: true},
        createConsAnalisysSnap: {method: 'POST', params: {method: '_snap', p1:'consanalisys', p2: '_create'}},
        deleteConsAnalisysSnap: {method: 'POST', params: {method: '_snap', p1:'consanalisys', p2: '_delete'}},
        getConsumptionsSnap:    {method: 'POST', params: {method: '_snap', p1:'consumptions', p2: '_get'}, ignoreLoadingBar: true},
        createConsumptionsSnap: {method: 'POST', params: {method: '_snap', p1:'consumptions', p2: '_create'}},
        deleteConsumptionsSnap: {method: 'POST', params: {method: '_snap', p1:'consumptions', p2: '_delete'}},
        getDDSnap:    {method: 'POST', params: {method: '_snap', p1:'dd', p2: '_get'}, ignoreLoadingBar: true},
        createDDSnap: {method: 'POST', params: {method: '_snap', p1:'dd', p2: '_create'}},
        deleteDDSnap: {method: 'POST', params: {method: '_snap', p1:'dd', p2: '_delete'}}
      });
    };
  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.consumptionfactory
 * @description
 * # consumptionfactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy')
  .factory('consumptionFactory', function (ENERGY_URL, $resource) {
    return $resource(ENERGY_URL + '/api/consumption/:version/:verb/:type/:id/:param1/:param2/:param3', {}, {
      calcConsumptions:       {method: 'GET',     params: { verb: 'calc', type: '@type', id: '@id' }},
      calcAll:                {method: 'GET',     params: { verb: 'calcall' }},
      getConsumption:         {method: 'GET',     params: { version: 'v2', verb: 'get' }},
      calcAndGetConsumption:  {method: 'GET',     params: { version: 'v2', verb: 'calcget', type: '@type', id: '@id' }},
      getConsumptionByPlant:  {method: 'GET',     params: { verb: 'getbyplant', type: '@type',  id: '@id' }},
      delete:                 {method: 'DELETE',  params: { type: '@type', id: '@id' }},
      bulk:                   {method: 'POST',    params: { verb: '_bulk' }}
    });
  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.consumptivefactory
 * @description
 * # consumptivefactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy')
  .factory('consumptiveFactory', function (ENERGY_URL, $resource) {
    return $resource(ENERGY_URL + '/api/consumptive/:verb/:type/:id/:param1/:param2/:param3', {}, {
      consumptiveByContatoreInPeriod: {method: 'GET', params: {type: '@type', id: '@id'}},
      create: {method: 'POST', params: {verb: 'save'}},
      bulk:   {method: 'POST', params: {verb: '_bulk'}},
      bulkMulticommission:   {method: 'POST', params: {verb: '_bulk', param1: 'multicommission'}},
      update: {method: 'PUT', params: {id: '@id', type: '@type'}},
      delete: {method: 'DELETE', params: {id: '@id'}},
      reset:  {method: 'POST', params: {verb: 'reset'}}
    });
  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.dayDegreeFactory
 * @description
 * # dayDegreeFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy')
    .factory('dayDegreeFactory', function (ENERGY_URL, $resource) {
        return $resource(ENERGY_URL + '/api/energy/dd/:method/:time/:type/:op', {}, {
            saveByMonth: {method: 'POST', params: {method: 'importSave', time: 'month'}},
            saveByDay: {method: 'POST', params: {method: 'importSave', time: 'day'}},
            saveByRef: {method: 'POST', params: {method: 'saveByRef'/*, time: 'day'*/}},
            saveReferring: {method: 'POST', params: {method: 'saveReferring', type: '@zt'}},
            saveAllReferring: {method: 'GET', params: {method: 'saveAllReferring', type: '@type'}},
            save: {method: 'POST', params: {method: 'save'}},
            delete: {method: 'POST', params: {method: 'delete', type: '@zt'}},
            create: {method: 'POST'},
            query: {method: 'GET', params: {time: 'day'/*??*/, type: '@type'}, isArray: false},
            search: {method: 'GET', params: {time: 'day'/*??*/, type: '@type', op:'search'}, isArray: false},
            //FIXME: i parametri in get sono usati male... sistemare
            locReferencedBy: {method: 'POST', params: {method: 'locReferencedBy', time: '@zt'}, isArray: true},
            provinciaLocalita: {method: 'POST', params: {method: 'provinciaLocalita', time: '@zt'}},
            tempToDD: {method: 'POST', params: {method: 'tempToDD', time: '@zt'}},
            tempToDDAll: {method: 'GET', params: {method: 'tempToDD', time: 'all'}},
            saveMonths: {method: 'POST', params: {method: 'saveMonths', type: '@type', zt: '@zt', year: '@year'}},
            zonaTermicaWithDefaults: {method: 'POST', params: {method: 'zonaTermicaWithDefaults', time: '@zt'}}
        });
    });

// Default:
// {
//   'get':    {method:'GET'},
//   'save':   {method:'POST'},
//   'query':  {method:'GET', isArray:true},
//   'remove': {method:'DELETE'},
//   'delete': {method:'DELETE'}
// }
angular.module('emma.energy')
  .factory('energyCarrierFactory', function (ENERGY_URL, $resource) {
    return $resource(ENERGY_URL + '/api/energycarrier/:verb/:id/:param1/:param2/:param3', {}, {
      byUUID:    {method: 'GET', isArray: false, params: {verb: '_uuid', param1: '_current'}},
      schemas:   {method: 'GET', isArray: false, params: {verb: '_schemas'}}
    });
});

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.baseFactory
 * @description
 * # baseFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy')
  .factory('heatingSeasonFactory', function (ENERGY_URL, $resource) {
      return $resource(ENERGY_URL + '/api/heatingseason/:verb/:type/:zt/:year/:param1', {}, {
        begin:    {method: 'GET', isArray: false, params: {verb: '_date', param1: 'begin'}},
        end:      {method: 'GET', isArray: false, params: {verb: '_date', param1: 'end'}},
        get:      {method: 'GET', isArray: false},
        create:   {method: 'POST'},
        delete:   {method: 'DELETE', params: {zt: '@id'}}
      });
  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.listcomponentfactory
 * @description
 * # listcomponentfactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy')
  .factory('listComponentFactory', function (ENERGY_URL, $resource) {
    return function(type) {
      return $resource(ENERGY_URL + '/api/list/component/'+type+'/:verb/:id/:param1/:param2/:param3', {}, {
        findAll: { method: 'GET',  isArray: false,  params: {verb: '_findall'} },
        grouped: { method: 'GET',  isArray: false,  params: {verb: '_grouped', type: '@type'} },
        perdite: { method: 'POST', isArray: false,  params: {verb: '_find'} },

        query: {method: 'GET', isArray: false},
        search: {method: 'POST', isArray: false},
        select: {method: 'GET', isArray: true, params: {verb: '_list'}},
        create: {method: 'POST', params: {id: '@id'}},
        bulk: {method: 'POST', isArray: false, params: {verb: '_bulk'}},
        show: {method: 'GET'},
        update: {method: 'PUT', params: {id: '@id'}},
        delete: {method: 'DELETE', params: {id: '@id'}}
      });
    };
  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.perspectiveFactory
 * @description
 * # perspectiveFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy')
  .factory('perspectiveFactory', function (ENERGY_URL, $resource) {
      return $resource(ENERGY_URL + '/api/perspective/:verb/:id/:param1/:param2/:param3', {}, {
        getHeaders:           {method: 'GET', isArray: false, params: {verb: 'headers'}},
        createPerspective:    {method: 'POST', isArray: false, params: {verb: 'create'}},
        generatePerspective:  {method: 'POST', isArray: false, params: {verb: 'generate'}},
        deletePerspective:    {method: 'DELETE', params: {verb: '_delete'}}
      });
  });

// Default:
// {
//   'get':    {method:'GET'},
//   'save':   {method:'POST'},
//   'query':  {method:'GET', isArray:true},
//   'remove': {method:'DELETE'},
//   'delete': {method:'DELETE'}
// }
angular.module('emma.energy')
  .factory('priceListFactory', function (ENERGY_URL, $resource) {
    return $resource(ENERGY_URL + '/api/pricelist/:type/:verb/:id/:param1/:param2/:param3', {}, {
      findAllList: {method: 'GET', isArray: true, params: {verb: '_list'}},
      findAll: {method: 'GET', params: {verb: '_headers'}},
      findAllByVector: {method: 'POST', params: {verb: '_headers'}},
      lookup: {method: 'GET', params: {verb: '_lookup'}},
      byUUID: {method: 'GET', params: {type: 'header', verb: '_uuid'}},
      byHeader: {method: 'GET', params: {verb: '_byheader'}},
      bulk: {method: 'POST', params: {verb: '_bulk'}},
      create: {method: 'POST'},
      bulkUpdate: {method: 'PUT', params: {verb: '_bulk'}},
      bulkResolve: {method: 'POST', params: {verb: '_bulk', param1: '_resolve'}},
      delete: {method: 'DELETE', params: {id: '@id'}}
    });
});

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.reportFactory
 * @description
 * # reportFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy')
  .factory('reportFactory', function (ENERGY_URL, $resource) {
    return $resource(ENERGY_URL + '/api/report/:type/:method', {}, {
      dayDegreeTab:   {method: 'POST', isArray: false, params: { type: '_daydegree', method: '_tab' }}
    });
  });

// Default:
// {
//   'get':    {method:'GET'},
//   'save':   {method:'POST'},
//   'query':  {method:'GET', isArray:true},
//   'remove': {method:'DELETE'},
//   'delete': {method:'DELETE'}
// }
angular.module('emma.energy')
  .factory('simulationFactory', function (ENERGY_URL, $resource) {
    return $resource(ENERGY_URL + '/api/list/simulation/:verb/:id/:param1/:param2/:param3/:param4/:param5/:param6', {}, {
      get:      { method: 'GET',     isArray: false },
      list:     { method: 'GET',     isArray: false },
      params:   { method: 'GET',     isArray: false,   params: {verb: '_params'} },
      simulate: { method: 'POST',    isArray: false,   params: {verb: '_simulate'} },
      binomia:  { method: 'POST',    isArray: false,   params: {verb: '_binomia'} },
      spread:   { method: 'GET',     isArray: false,   params: {verb: '_params', param1: 'spread'} },
      save:     { method: 'POST',    isArray: false,   params: {verb: '_save'} },
      delete:   { method: 'DELETE',  isArray: false,   params: {id: '@id'} }
    });
});

// Default:
// {
//   'get':    {method:'GET'},
//   'save':   {method:'POST'},
//   'query':  {method:'GET', isArray:true},
//   'remove': {method:'DELETE'},
//   'delete': {method:'DELETE'}
// }
angular.module('emma.energy')
  .factory('voltageClassFactory', function (ENERGY_URL, $resource) {
    return $resource(ENERGY_URL + '/api/voltageclass/:verb/:id/:param1/:param2/:param3', {}, {
      show:   {method: 'GET'}
    });
});

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.zonaTermicaFactory
 * @description
 * # zonaTermicaFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy')
  .factory('zonaClimaticaFactory', function (ENERGY_URL, $resource) {
    return $resource(ENERGY_URL + '/api/zonaclimatica/:verb/:id/:param1/:param2/:param3', {}, {
      findByZonaTermica: {method: 'GET', params:{ verb: 'findByZonaTermica', id: '@save' }}
    });
  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.zonaTermicaFactory
 * @description
 * # zonaTermicaFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy')
  .factory('zonaTermicaFactory', function (ENERGY_URL, $resource) {
    return $resource(ENERGY_URL + '/api/zonatermica/:verb/:id/:param1/:param2/:param3', {}, {
      query:    {method: 'GET', isArray: false},
      search:   {method: 'POST', isArray: false, params: {verb: '_search'}},
      show:     {method: 'GET', params: { id: '@id' }},
      byID:     {method: 'GET', params: { verb: '_id' }},
      byUUID:   {method: 'GET', params: { verb: '_uuid', param1: '_current' }},
      byCode:   {method: 'GET', params: { verb: '_code', id: '@id' }},
      create:   {method: 'POST'},
      update:   {method: 'PUT', params: { id: '@id' }},
      delete:   {method: 'DELETE', params: { id: '@id' }},
      zonaTermicaWithDefaults:        {method: 'POST', params: { verb: 'zonaTermicaWithDefaults', id: '@id' }},
      tempProvinciaToZonaTermica:     {method: 'POST', params:{ verb: 'tempProvinciaToZonaTermica', id: '@save' }},
      tempProvinciaToZonaTermicaAll:  {method: 'GET', params:{ verb: 'tempProvinciaToZonaTermica', id: '_all', param1: '@save' }},
      bulkResolve:                {method: 'POST', isArray: false, params: {verb: '_bulk', param1: '_resolve'}},
      bulk:                       {method: 'POST', isArray: false, params: {verb: '_bulk'}}
    });
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:MeasurementCtrl
 * @description
 * # MeasurementCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/measurement', {
        templateUrl: 'energy/measurements/measurement.html',
        controller: 'MeasurementCtrl'
      })
  })
  .controller('MeasurementCtrl', function ($scope, $log, $interval, wsfactory) {

    $scope.dayCount = 0;

    $scope.monthCount = 120;

    $scope.graphData = [];

    $scope.testWS = wsfactory;

    $scope.runningDisabled = false;
    $scope.stopDisabled = true;
    $scope.resetDisabled = true;

    var stop;
    $scope.fight = function() {
      // Don't start a new fight if we are already fighting
      if ( angular.isDefined(stop) ) return;

      $scope.runningDisabled = true; $scope.stopDisabled = false; $scope.resetDisabled = false;

      stop = $interval(function() {
        $scope.setData();
        $scope.dayCount++;
        $scope.monthCount++;
        //$scope.testWS.get();
      }, 100);
    };

    $scope.stopFight = function() {
      if (angular.isDefined(stop)) {
        $interval.cancel(stop);
        stop = undefined;
        $scope.runningDisabled = false; $scope.stopDisabled = true; $scope.resetDisabled = false;
      }
    };

    $scope.resetFight = function() {
      $scope.dayCount = 0;
      $scope.monthCount = 120;
      if($scope.stopDisabled){
          $scope.resetDisabled = true;
      }
    };

    $scope.$on('$destroy', function() {
      // Make sure that the interval is destroyed too
      $scope.stopFight();
    });

    $scope.setData = function () {
      var date = new Date();
      var grpDT = {
        'date': date
      };
      grpDT['T_Esterna'] = '' + Math.floor((Math.random()*45)+1);
      grpDT['T_Mandata'] = '' +Math.floor((Math.random()*45)+1);
      $scope.graphData.push(grpDT);
      if(100 < $scope.graphData.length) {
        $scope.graphData.splice(0,1)
      }
      $log.info(JSON.stringify($scope.graphData));
    }
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:OverridedatesCtrl
 * @description
 * # OverridedatesCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/overridedates', {
        templateUrl: 'energy/overridedates/overridedates.html',
        controller: 'OverridedatesCtrl'
      })
  })
  .controller('OverridedatesCtrl', function ($scope, heatingSeasonFactory, zonaClimaticaFactory, authFactory, uiGridConstants, errorService, toaster) {

    var currentCommission = authFactory.getAuthData().info.commissions.current;

    $scope.limit = 65536;

    $scope.record = { type_id: {code: 'zonatermica', UUID: 'zonatermica', description: 'Zona Termica'} };

    $scope.model = {};

    $scope.date = '';

    $scope.dates = {
      in: '',
      out: ''
    };

    $scope.datesList = [];

    $scope.defaultDateBegin = '';

    $scope.defaultDateEnd = '';

    $scope.zonaClimatica = {};

    $scope.gridDates = {
      enableSorting: true,
      enableGridMenu: false,
      exporterMenuPdf: false,
      data: 'datesList',
      columnDefs: [
        {
          displayName: '',
          field: 'id',
          width: 40,
          enableCellEdit: true,
          enableFiltering: false,
          enableSorting: false,
          cellTemplate: '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ng-click="grid.appScope.delete(row.entity.model.code)" ng-disabled="grid.appScope.isDeletePermAllowed()===false"><i class="fa fa-trash"></i></button></div>'
        },
        {
          displayName: 'Data',
          field: 'model.date',
          type: 'date',
          cellFilter: 'date:"dd-MM-yyyy"',
          sort: {
            direction: uiGridConstants.ASC,
            priority: 0
          }
        },
        {
          displayName: 'Tipo di data',
          field: 'model.mode',
          sort: {
            direction: uiGridConstants.ASC
          },
          cellTemplate: '<div class="ui-grid-cell-contents"><div ng-if="row.entity.model.mode == \'begin\'">Inizio</div> <div ng-if="row.entity.model.mode == \'end\'">Fine</div></div>'
        }
      ]
    };

    function dateIsDefined(date) {
      return (date != '' && date != undefined && date != null);
    }

    $scope.addDate = function(date, mode){
      if(angular.isDefined($scope.record.record_id) && angular.isDefined($scope.record.type_id) && dateIsDefined(date)) {
        var newCode = true;
        var code = currentCommission.code+'_'+$scope.record.type_id.code+'_'+$scope.record.record_id.code+'_'+
          mode +'_'+ date.getFullYear();
        $scope.model = {
          code: code,
          date: date,
          mode: mode,
          record_id: $scope.record.record_id
        };
        angular.forEach($scope.datesList, function(item){
          if(code == item.model.code){
            newCode = false;
          }
        });
        if(newCode == true){
          heatingSeasonFactory.create($scope.model).$promise.then(function() {
            $scope.refreshGrid();
          });
        } else{
          toaster.pop('error', 'Errore', 'Sovrascrittura già inserita: eliminare prima la data presente, poi procedere con un nuovo inserimento');
        }
      } else {
        toaster.pop('error', 'Errore', 'Errore inserimento parametri');
      }
    };


    $scope.delete = function(idToDelete){
      heatingSeasonFactory.delete({zt: idToDelete}).$promise.then(function() {
          $scope.refreshGrid();
      });
    };

    $scope.$watchGroup(['record.type_id', 'record.record_id'], function(newValue){
      if(angular.isDefined(newValue[0]) && angular.isDefined(newValue[1])){
        var type = newValue[0].UUID;
        var record = newValue[1].UUID;
        heatingSeasonFactory.get({type: type, zt: record}).$promise.then(function(data) {
          if(data.result.list){
            createDatesList(data.result.list);
          }
        });
        zonaClimaticaFactory.findByZonaTermica({id: newValue[1].UUID}).$promise.then(function(data){
          $scope.zonaClimatica = data;
        });
      }else{
        $scope.datesList = [];
        $scope.zonaClimatica = {};
      }
      unselectRecord();
    });

    $scope.refreshGrid = function(){
      var type = $scope.record.type_id.UUID;
      var record = $scope.record.record_id.UUID;
      heatingSeasonFactory.get({type: type, zt: record}).$promise.then(function(data) {
        if(data.result.list){
          createDatesList(data.result.list);
        }
      });
      unselectRecord();
    };

    function unselectRecord () {
      /* bisognerebbe riuscire a pulire anche le 2 lookup */
      $scope.dates.in = angular.copy('');
      $scope.dates.out = angular.copy('');
    }

    function createDatesList (list) {
      /* metodo per costruire i dati della grid:
      *  gli viene passata una list con tutti gli override delle date di inizio/fine che son state inserite
      *  e sulla base di queste organizza delle righe in maniera ordinata scaricando per ogni anno dove ci sono degli override
      *  le date di inizio e di fine della stagione termica */
      $scope.datesList = [];
      angular.forEach(list, function (item) {
        $scope.datesList.push(item);
      });
    }

    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'heatingseason';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };


  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:PerspectiveCtrl
 * @description
 * # PerspectiveCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/perspective', {
        templateUrl: 'energy/perspective/perspective.html',
        controller: 'PerspectiveCtrl',
        controllerAs: 'perspective'
      })
  })
  .controller('PerspectiveCtrl', function ($scope, $filter, $log, dialogService, errorService,
                                           consumptionAnalysisFactory, perspectiveFactory) {

    $scope.searchFilter = {
      year: (1 + parseInt($filter('date')(new Date(), 'yyyy'))).toString()
    };

    $scope.percent = 10;
    $scope.step = 1;
    $scope.goToStep = function(index) {
        $scope.step = index;
    };

    $scope.perspective = {};
    $scope.seasonFactor = {};
    $scope.techFactor = {0: 0.0,1: 0.0,2: 0.0,3: 0.0,4: 0.0,5: 0.0,6: 0.0,7: 0.0,8: 0.0,9: 0.0,10: 0.0,11: 0.0};

    $scope.generatePerspectiveForm = false;

    $scope.perspectiveTemplate = {
      template: [
        {code: "PT001", description: "Budget anno precedente"},
        {code: "PT002", description: "Consuntivo anno precedente"},
        {code: "PT003", description: "Media Consuntivi anni precedenti"},
        {code: "PT004", description: "Stagionalizzazione con regressione lineare"}
      ]
    };

    $scope.availablePerspectiveCodes = [];

    $scope.gridListOptions = {
      enableSorting: true,
      enableGridMenu: true,
      exporterCsvColumnSeparator: ';',
      exporterSuppressColumns: [ 'view', 'delete' ],
      exporterMenuPdf: false,
      exporterMenuCsv: true,
      enableFiltering: false,
      data: 'availablePerspectiveCodes',
      columnDefs: [
        {displayName: '', field: 'view', enableFiltering: false, width: 40, cellTemplate: '<div class="ui-grid-cell-contents" style="text-content: center;"><button type="button" class="btn btn-xs btn-primary" ng-click="grid.appScope.getPerspective(row.entity)"><i class="fa fa-search"></i></button></div>'},
        {displayName: 'Codice', field: 'code', width: 400, cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.model.code}}</div>'},
        {displayName: 'Descrizione', field: 'description', cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.model.description}}</div>'},
        {displayName: 'Anno', field: 'year', width: 100, cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.model.year}}</div>'},
        {displayName: '', field: 'delete', enableFiltering: false, width: 40, cellTemplate: '<div class="ui-grid-cell-contents" style="text-content: center;"><a ng-confirm-message="Confermare?" ng-confirm-click="grid.appScope.delete(row.entity)" ng-confirm-condition=true class="btn btn-xs btn-danger"><span class="glyphicon glyphicon-trash"></span></a></div>'}
      ]
    };

    /***** Data ready events *****/

    var DATA_READY_EVENT = 'dataReady';

    $scope.$on(DATA_READY_EVENT, function(event) {
      setTimeout(function() { // evita che venga richiamato troppo velocemente (altrimenti si accavalla a showLoadingMessage)
        dialogService.hideLoadingMessage();
      }, 200);
    });

    $scope.budget = {
      code : undefined,
      description : undefined,
      list : [],
      totalConsumption : 0,
      season : 0,
      totalBudget : 0,
      deltaSeason : 0,
      deltaTech : 0
    };

    $scope.graphData =[];
    $scope.graphDataCumulative = [];

    $scope.backToPerspective = function() {
        $scope.generatePerspectiveForm = false;
    }

    $scope.getPerspective = function(perspective) {
      $scope.isCollapsed = true;
      $scope.perspective = perspective.model;
      var prevYear = perspective.model.year - 1;
      //CONSUMI E BUDGET
      var query = {frequency: 'MONTHLY', from: prevYear + '-01-01', to: prevYear + '-12-31'};

      var promise = consumptionAnalysisFactory().getConsumptionAnalysis(query).$promise;
      //var promise = baseFactory('consumptionanalysis/get').search(query).$promise;
      promise.then(function (consAnResp) {
        if (errorService.handleError(consAnResp)) {
          var budget = {}, graphData = [], graphDataCumulative = [];
          budget.list = consAnResp.list;
          angular.forEach(consAnResp.list, function (record, idx) {
            var grpDT = {
              'date': Date.parse(record.date)
            };
            grpDT['consumi ' + $filter('number')(consAnResp.consumption, 3)] = '' + record.consumption;
            grpDT['budget ' + $filter('number')(consAnResp.budget, 3)] = '' + record.budget;
            grpDT['stagionalita ' + $filter('number')(consAnResp.season, 3)] = '' + record.season;

            graphData.push(grpDT);

            var grpDTCumulative = {
              'date': Date.parse(record.date)
            };
            grpDTCumulative['consumi ' + $filter('number')(consAnResp.consumption, 3)] = '' + record.cumulativeConsumption;
            grpDTCumulative['budget ' + $filter('number')(consAnResp.budget, 3)] = '' + record.cumulativeBudget;

            graphDataCumulative.push(grpDTCumulative);
          });
          console.log(consAnResp);
          budget.totalBudget = consAnResp.budget;
          budget.totalConsumption = consAnResp.consumption;
          budget.totalConsumptionStd = consAnResp.consumptionStd;
          budget.budgetComparison = consAnResp.budget ? (consAnResp.consumptionStd - consAnResp.budget) / consAnResp.budget * 100 : 0;
          budget.season = consAnResp.season;
          budget.deltaSeason = consAnResp.deltaSeason;
          budget.deltaTech = consAnResp.deltaTech;
          budget.percentage = consAnResp.percentage;
          budget.code = consAnResp.budgetCode;
          budget.description = consAnResp.budgetDescription;

          $scope.graphData = graphData;
          $scope.graphDataCumulative = graphDataCumulative;
          $scope.budget = budget;
          $scope.perspectiveComputation($scope.budget);

        }
      });
    };

    $scope.perspectiveComputation = function (dataset, seasonFactor) {
      $scope.graphPrev = [];
      $scope.perspective.totalOldBudget = dataset.totalBudget;
      $scope.perspective.totalBudget = dataset.totalConsumption;
      $scope.perspective.deltaTech = dataset.deltaTech;
      $scope.perspective.season = 0;
      $scope.perspective.deltaSeason = 0;
      $scope.perspective.list = [];
      angular.forEach(dataset.list, function(item) {
        var newItem = {};

        var prevDate = new Date(item.date);
        prevDate.setYear($scope.perspective.year);

        newItem.date = prevDate;
        newItem.oldBudget = item.budget;
        newItem.budget = item.consumption;
        if (seasonFactor) {
          $scope.seasonFactor = seasonFactor;
        } else {
          var sf = 0;
          if (item.historicalDD !== 0) {
            sf = sf - (item.realDD / item.historicalDD);
          }
          $scope.seasonFactor[prevDate.getMonth()] = sf;
        }
        newItem.season = $scope.seasonFactor[prevDate.getMonth()] * item.consumption;
        newItem.perspective = (newItem.budget + newItem.season);
        if($scope.techFactor[prevDate.getMonth()]) {
          newItem.perspective = newItem.perspective + ($scope.techFactor[prevDate.getMonth()] * item.deltaTech);
        }
        newItem.deltaSeason = 0 + (newItem.season - newItem.budget) / 100;
        $scope.perspective.season = $scope.perspective.season + newItem.season;
        newItem.deltaTech = item.deltaTech;
        this.push(newItem);

        var grpDT = {
          'date': prevDate,
          'previsione': newItem.budget,
          'fattore stag.': newItem.season,
          'prospettiva': newItem.perspective
        };
        $scope.graphPrev.push(grpDT);

      }, $scope.perspective.list);
      $scope.perspective.deltaSeason = ($scope.perspective.season / $scope.perspective.totalBudget) * 100;
      $scope.perspective.totalPerspective = $scope.perspective.season + $scope.perspective.totalBudget;
    };

    $scope.unselect = function(){
      $scope.perspective = {};
      $scope.isCollapsed = false;
      $scope.loadPerspectiveList();
    };

    $scope.toggleNewPerspective = function() {
      $scope.generatePerspectiveForm = !($scope.generatePerspectiveForm);
    };

    $scope.loadPerspectiveList = function() {
      var year = $scope.searchFilter.year;
      getAvailablePerspectiveCodes(year).then(function(list) {
        $scope.availablePerspectiveCodes = list;
      });
    };

    function getAvailablePerspectiveCodes(year) {
      dialogService.showLoadingMessage('Caricamento prospettive disponibili...');

      var query = {};
      if(year) {
        query.year = year;
      }

      return perspectiveFactory.getHeaders(query).$promise.then(function (response) {
        if(errorService.handleError(response)) {
          var list = [];
          if (response.hasOwnProperty('list') && response.list.length) {
            list = response.list;
          }
          $scope.$broadcast(DATA_READY_EVENT, 'perspective');
          return list;
        }
        else {
          $scope.$broadcast(DATA_READY_EVENT, 'perspective');
          toaster.pop('error', 'Errore', 'Errore durante il recupero delle prospettive');
        }
      });
    }

    $scope.createPerspective = function() {
      perspectiveFactory.createPerspective($scope.perspective).$promise.then(function() {
        $scope.toggleNewPerspective();
        $scope.loadPerspectiveList();
      });
    };

    $scope.generate = function() {
      perspectiveFactory.generatePerspective($scope.perspective).$promise.then(function() {
        $scope.unselect();
      });
    };

    $scope.delete = function(item) {
      var obj = {
        uuid: item.UUID,
        year: item.model.year
      };
      perspectiveFactory.deletePerspective(obj).$promise.then(function() {
        $scope.unselect();
      });
    };

    $scope.loadPerspectiveList();
  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.componenttypefactory
 * @description
 * # componenttypefactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy')
  .factory('componenttypefactory', function (uiGridConstants) {

    function getFilters(type) {
      var filters;
      switch(type) {
        case 'fascia':
          filters = [
            {
              //term: '',
              type: uiGridConstants.filter.SELECT,
              selectOptions: [
                {value: 'F1', label: 'F1'},
                {value: 'F2', label: 'F2'},
                {value: 'F3', label: 'F3'},
                {value: 'F23', label: 'F23'}
              ]
            },
            {
              placeholder: 'Testo libero...'
            }
          ];
          break;
        case 'gt':
          filters = [
            {
              condition: uiGridConstants.filter.GREATER_THAN,
              placeholder: 'maggiore di...'
            }
          ];
          break;
        case 'lt':
          filters = [
            {
              condition: uiGridConstants.filter.LESS_THAN,
              placeholder: 'minore di...'
            }
          ];
          break;
        case 'lgt':
          filters = [
            {
              condition: uiGridConstants.filter.GREATER_THAN,
              placeholder: 'maggiore di...'
            },
            {
              condition: uiGridConstants.filter.LESS_THAN,
              placeholder: 'minore di...'
            }
          ];
          break;
        default:
          filters = {
            condition: uiGridConstants.filter.CONTAINS,
            placeholder: 'Testo libero...'
          };
      }
      return filters;
    }

    function isCellEditable(scope) {
      return !scope.row.entity.wrapper || !scope.row.entity.wrapper.UUID;
    }

    var componentTypesMap = [];
    componentTypesMap['ee'] = [];
    componentTypesMap['ee']['sv'] = [];
    componentTypesMap['ee']['sr'] = [];
    componentTypesMap['ee']['og'] = [];
    componentTypesMap['ee']['add'] = [];
    componentTypesMap['gas'] = [];
    componentTypesMap['gas']['sv'] = [];
    componentTypesMap['gas']['sr'] = [];
    componentTypesMap['gas']['add'] = [];
    componentTypesMap['gas']['altro'] = [];

    // Energia Elettrica (ee)
    // Servizi di Vendita (sv)
    componentTypesMap['ee']['sv'].push({code: 'PED_F', description: 'Servizi di vendita - Energia e Dispacciamento', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Fascia', field: 'fascia', filters: getFilters('fascia'), cellEditableCondition: isCellEditable},
      {displayName: 'PEDF,a.1', field: 'pedf_a1', type: 'number', filters: getFilters('lgt'), cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'PEDF,a.2', field: 'pedf_a2', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'PEDF,b', field: 'pedf_b', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'PEDF,c', field: 'pedf_c', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'}
    ]});
    componentTypesMap['ee']['sv'].push({code: 'PED_M', description: 'Servizi di vendita - Energia e Dispacciamento', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Utenza', field: 'utenza', cellEditableCondition: isCellEditable},
      {displayName: 'PEDM', field: 'pedm', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'}
    ]});
    componentTypesMap['ee']['sv'].push({code: 'PCV', description: 'Servizi di vendita - Commercializzazione e Vendita', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Utenza', field: 'utenza', cellEditableCondition: isCellEditable},
      {displayName: 'PCV_fissa', field: 'pcv_fissa', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'PCV_var', field: 'pcv_var', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'}
    ]});
    componentTypesMap['ee']['sv'].push({code: 'PPE', description: 'Servizi di vendita - Componenti di Perequazione', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Utenza', field: 'utenza', cellEditableCondition: isCellEditable},
      {displayName: 'PPE', field: 'ppe', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'}
    ]});
    componentTypesMap['ee']['sv'].push({code: 'DISPbt_fissa', description: 'Servizi di vendita - Dispacciamento', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Utenza', field: 'utenza', cellEditableCondition: isCellEditable},
      {displayName: 'DISPbt_fissa', type: 'number', field: 'dispbt_fissa', enableFiltering: false, cellFilter: 'currency:"c€/POD/Anno":3'}
    ]});
    componentTypesMap['ee']['sv'].push({code: 'DISPbt_var', description: 'Servizi di vendita - Dispacciamento', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Scaglione', field: 'scaglione', cellEditableCondition: isCellEditable},
      {displayName: 'Lim. inf.', field: 'lim_inf', type: 'number', cellFilter: 'currency:"kWh":0'},
      {displayName: 'Lim. sup.', field: 'lim_sup', type: 'number', cellFilter: 'currency:"kWh":0'},
      {displayName: 'DISPbtvar,a1', field: 'dispbt_var_a1', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'DISPbtvar,a2', field: 'dispbt_var_a2', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'DISPbtvar,b', field: 'dispbt_var_b', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'DISPbtvar,c', field: 'dispbt_var_c', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'}
    ]});
    componentTypesMap['ee']['sv'].push({code: 'Perdite', description: 'Servizi di vendita - Fattore di perdita', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Tipo Utenza', field: 'tipo_utenza_id', lookup: 'classificazionetensione', cellEditableCondition: isCellEditable},
      {displayName: 'Tensione', field: 'tensione', type: 'number', cellFilter: 'currency:"kV":0', cellEditableCondition: isCellEditable},
      {displayName: 'Fattore', field: 'fattore', type: 'number', cellFilter: 'percentage:1'}
    ]});

    // Servizi di Rete (sr)
    componentTypesMap['ee']['sr'].push({code: 'DIST', description: 'Servizi di rete - Distribuzione', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Utenza', field: 'utenza', cellEditableCondition: isCellEditable},
      {displayName: 'DISE', field: 'dise', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'DISP', field: 'disp', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'DIS_fissa', field: 'dis_fissa', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/POD/Anno":3'}
    ]});
    componentTypesMap['ee']['sr'].push({code: 'TRAS', description: 'Servizi di rete - Trasporto (utenze non domestiche)', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Utenza', field: 'utenza', cellEditableCondition: isCellEditable},
      {displayName: 'TRASE', field: 'trase', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'TRASP', field: 'trasp', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'}
    ]});
    componentTypesMap['ee']['sr'].push({code: 'MIS', description: 'Servizi di rete - Misura (utenze non domestiche)', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Utenza', field: 'utenza', cellEditableCondition: isCellEditable},
      {displayName: 'MISE', field: 'mise', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'MISPOD', field: 'mispod', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/POD/Anno":3'}
    ]});
    componentTypesMap['ee']['sr'].push({code: 'Di', description: 'Servizi di rete - Distribuzione, trasporto e misura (utenze domestiche BT)', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Utenza', field: 'utenza', cellEditableCondition: isCellEditable},
      {displayName: 'Scaglione', field: 'scaglione', cellEditableCondition: isCellEditable},
      {displayName: 'Lim. inf.', field: 'lim_inf', type: 'number', cellFilter: 'currency:"kWh":0'},
      {displayName: 'Lim. sup.', field: 'lim_sup', type: 'number', cellFilter: 'currency:"kWh":0'},
      {displayName: 'Di,E', field: 'di_e', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'Di,P', field: 'di_p', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'Di,POD', field: 'di_pod', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/POD/Anno":3'}
    ]});

    // Oneri Generali (og)
    componentTypesMap['ee']['og'].push({code: 'Oneri_UD', description: 'Oneri generali - Componenti A, UC e MCT (utenti domestici)', columnDefs: [
      {displayName: 'Data', field: 'date', minWidth: 80, type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Utenza', field: 'utenza', minWidth: 80, cellEditableCondition: isCellEditable},
      {displayName: 'Scaglione', field: 'scaglione', minWidth: 80, cellEditableCondition: isCellEditable},
      {displayName: 'Lim. inf.', field: 'lim_inf', type: 'number', cellFilter: 'currency: "kWh"', minWidth: 80},
      {displayName: 'Lim. sup.', field: 'lim_sup', type: 'number', cellFilter: 'currency: "kWh"', minWidth: 80},
      {displayName: 'A2POD', field: 'a2pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'A3POD', field: 'a3pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'A4POD', field: 'a4pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'A5POD', field: 'a5pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'ASPOD', field: 'aspod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'ATOT,POD', field: 'atot_pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'A2E', field: 'a2e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'A3E', field: 'a3e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'A4E', field: 'a4e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'A5E', field: 'a5e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'ASE', field: 'ase', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'ATOT,E', field: 'atot_e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'UC3POD', field: 'uc3pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'UC4POD', field: 'uc4pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'UC6POD', field: 'uc6pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'UC7POD', field: 'uc7pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'UCTOT,POD', field: 'uctot_pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'UC3E', field: 'uc3e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'UC4E', field: 'uc4e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'UC6E', field: 'uc6e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'UC7E', field: 'uc7e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'UCTOT,E', field: 'uctot_e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'UC6P', field: 'uc6p', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'UCTOT,P', field: 'uctot_p', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'MCTPOD', field: 'mctpod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'MCTE', field: 'mcte', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'OGPOD', field: 'ogpod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'OGP', field: 'ogp', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'OGE', field: 'oge', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'}
    ]});
    componentTypesMap['ee']['og'].push({code: 'Oneri_UND', description: 'Oneri generali - Componenti A, UC e MCT (utenti non domestici)', columnDefs: [
      {displayName: 'Data', field: 'date', minWidth: 80, type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Utenza', field: 'utenza', minWidth: 80, cellEditableCondition: isCellEditable},
      {displayName: 'A2POD', field: 'a2pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'A3POD', field: 'a3pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'A4POD', field: 'a4pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'A5POD', field: 'a5pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'ASPOD', field: 'aspod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'ATOT,POD', field: 'atot_pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'A2E', field: 'a2e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'A3E', field: 'a3e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'A4E', field: 'a4e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'A5E', field: 'a5e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'ASE', field: 'ase', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'AE', field: 'ae', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'ATOT,E', field: 'atot_e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'UC3POD', field: 'uc3pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'UC4POD', field: 'uc4pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'UC6POD', field: 'uc6pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'UC7POD', field: 'uc7pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'UCTOT,POD', field: 'uctot_pod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'UC3E', field: 'uc3e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'UC4E', field: 'uc4e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'UC6E', field: 'uc6e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'UC7E', field: 'uc7e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'UCTOT,E', field: 'uctot_e', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'UC6P', field: 'uc6p', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'UCTOT,P', field: 'uctot_p', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'MCTPOD', field: 'mctpod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'MCTE', field: 'mcte', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'OGPOD', field: 'ogpod', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/POD/Anno":3'},
      {displayName: 'OGP', field: 'ogp', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'OGE', field: 'oge', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/kWh":3'}
    ]});

    // Addizionali (add)
    componentTypesMap['ee']['add'].push({code: 'EE_Addizionale', description: 'Addizionale provinciale', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Provincia', field: 'provincia_id', lookup: 'provincia', cellEditableCondition: isCellEditable},
      {displayName: 'addizionale', field: 'addizionale', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'}
    ]});
    componentTypesMap['ee']['add'].push({code: 'EE_Accise', description: 'Accise', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Scaglione', field: 'scaglione', cellEditableCondition: isCellEditable},
      {displayName: 'Lim. inf.', field: 'lim_inf', type: 'number', cellFilter: 'currency:"kWh":0'},
      {displayName: 'Lim. sup.', field: 'lim_sup', type: 'number', cellFilter: 'currency:"kWh":0'},
      {displayName: 'AccisaCIV', field: 'accisaciv', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'AccisaIND,varINF.1200', field: 'accisaind_varinf_1200', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'AccisaIND,varSUP.1200', field: 'accisaind_varsup_1200', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/kWh":3'},
      {displayName: 'AccisaIND,meseSUP.1200', field: 'accisaind_mesesup_1200', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/Mese":3'}
    ]});

    // Gas (gas)
    // Servizi di Vendita (sv)
    componentTypesMap['gas']['sv'].push({code: 'QVD_fissa', description: 'Servizi di vendita - Quota fissa di vendita', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Tipo cliente', field: 'tipo_cliente_id', lookup: 'tipologiacliente', cellEditableCondition: isCellEditable},
      {displayName: 'QVD fissa', field: 'qvd_fissa', type: 'number', cellFilter: 'currency:"€/PDR/Anno":3'}
    ]});
    componentTypesMap['gas']['sv'].push({code: 'QVD_var', description: 'Servizi di vendita - Quota vendita al dettaglio', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Scaglione', field: 'scaglione', cellEditableCondition: isCellEditable},
      {displayName: 'Lim. inf.', field: 'lim_inf', type: 'number', cellFilter: 'currency:"SMC":0'},
      {displayName: 'Lim. sup.', field: 'lim_sup', type: 'number', cellFilter: 'currency:"SMC":0'},
      {displayName: 'QVD var', field: 'qvd_var', type: 'number', cellFilter: 'currency:"c€/SMC":3'}
    ]});
    componentTypesMap['gas']['sv'].push({code: 'CCI_CMEM', description: 'Commercializzazione all\'ingrosso', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', minWidth: 80, cellEditableCondition: isCellEditable},
      {displayName: 'Indice IT', field: 'indice_it', type: 'number', enableFiltering: false, minWidth: 80},
      {displayName: 'at', field: 'at', type: 'number', enableFiltering: false, minWidth: 80},
      {displayName: 'PFOR,t', field: 'pfor_t', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'QTint', field: 'qtint', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'QTPSV', field: 'qtpsv', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'QTMCV', field: 'qtmcv', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'CCIt Tutela', field: 'ccit', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'CCIt 38.10', field: 'ccit_3810', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'CCIt 38.52', field: 'ccit_3852', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'CCIt 64.09', field: 'ccit_6409', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'CCIt 64.09 38.10', field: 'ccit_6409_3810', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'CCIt 64.09 38.52', field: 'ccit_6409_3852', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'CCIt 89.10', field: 'ccit_8910', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'CCIt 89.10 38.10', field: 'ccit_8910_3810', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'CCIt 89.10 38.52', field: 'ccit_8910_3852', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'CCIt 77.11', field: 'ccit_7711', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'CCIt 77.11 38.10', field: 'ccit_7711_3810', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'CCIt 77.11 38.52', field: 'ccit_7711_3852', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'CCIt 117.12', field: 'ccit_11712', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'CCIt 117.12 38.10', field: 'ccit_11712_3810', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/SMC":4'},
      {displayName: 'CCIt 117.12 38.52', field: 'ccit_11712_3852', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/SMC":4'},
      {displayName: 'CCIt 385.12', field: 'ccit_38512', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/GJ":6'},
      {displayName: 'CCIt 385.12 38.10', field: 'ccit_385_3810', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'CCIt 385.12 38.52', field: 'ccit_385_3852', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'CMEM,t 196.13', field: 'cmem_19613', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'CMEM,t 196.13 38.10', field: 'cmem_19613_3810', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'CMEM,t 196.13 38.52', field: 'cmem_19613_3852', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'}
    ]});
    componentTypesMap['gas']['sv'].push({code: 'CCR', description: 'Servizi di vendita - CCR', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'CCR', field: 'ccr', type: 'number', enableFiltering: false, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'CCR (PCS 38.10)', field: 'ccr_pcs_3810', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/SMC":2'},
      {displayName: 'CCR (PCS 38.52)', field: 'ccr_pcs_3852', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/SMC":2'}
    ]});
    componentTypesMap['gas']['sv'].push({code: 'GRAD', description: 'Servizi di vendita - Oneri di gradualità', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'GRAD', field: 'grad', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/SMC":2'},
      {displayName: 'CPR', field: 'cpr', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/SMC":2'},
      {displayName: 'GRA TOT', field: 'grad_tot', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/SMC":2'}
    ]});
    componentTypesMap['gas']['sv'].push({code: 'QOA', description: 'Servizi di vendita - Quota oneri aggiuntivi', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'QOA', field: 'qoa', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/SMC":4'}
    ]});

    // Serzizi di Rete (sr)
    componentTypesMap['gas']['sr'].push({code: 'QT', description: 'Trasporto', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', minWidth: 80, cellEditableCondition: isCellEditable},
      {displayName: 'Ambito Tariffario', field: 'ambito_tariffario_id', lookup: 'ambitotariffario', enableFiltering: false, minWidth: 80, cellEditableCondition: isCellEditable},
      {displayName: 'QT (tutela)', field: 'qt_tutela', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'QT (tutela;t;38,10)', field: 'qt_tutela_t_3810', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'QT (tutela;t;38,52)', field: 'qt_tutela_t_3852', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'QT (64,09;t)', field: 'qt_6409_t', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'QT (64,09;t;38,10)', field: 'qt_6409_t_3810', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'QT (64,09;t;38,52)', field: 'qt_6409_t_3852', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'QT (89,10;t)', field: 'qt_8910_t', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'QT (89,10;t;38,10)', field: 'qt_8910_t_3810', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'QT (89,10;t;38,52)', field: 'qt_8910_t_3852', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'QT (77,11;t)', field: 'qt_7711_t', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'QT (77,11;t;38,10)', field: 'qt_7711_t_3810', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'QT (77,11;t;38,52)', field: 'qt_7711_t_3852', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'QT (117,12;t)', field: 'qt_11712_t', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'QT (117,12;t;38,10)', field: 'qt_11712_t_3810', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'QT (117,12;t;38,52)', field: 'qt_11712_t_3852', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'QT (385,12;t)', field: 'qt_38512_t', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'QT (385,12;t;38,10)', field: 'qt_38512_t_3810', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'QT (385,12;t;38,52)', field: 'qt_38512_t_3852', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'QT (196,13;t)', field: 'qt_19613_t', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'QT (196,13;t;38,10)', field: 'qt_19613_t_3810', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'QT (196,13;t;38,52)', field: 'qt_19613_t_3852', type: 'number', enableFiltering: false, minWidth: 80, cellFilter: 'currency:"c€/SMC":4'}
    ]});
    componentTypesMap['gas']['sr'].push({code: 'QS', description: 'Stoccaggio', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'QS', field: 'qs', type: 'number', enableFiltering: false, cellFilter: 'currency:"€/GJ":6'},
      {displayName: 'QS (PCS 38,10)', field: 'pcs_3810', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/SMC":4'},
      {displayName: 'QS (PCS 38,52)', field: 'pcs_3852', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/SMC":4'}
    ]});
    componentTypesMap['gas']['sr'].push({code: 'TD_fissa', description: 'Stoccaggio', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Ambito Tariffario', field: 'ambito_tariffario_id', lookup: 'ambitotariffario', enableFiltering: false, cellEditableCondition: isCellEditable},
      {displayName: 'Classe misuratore', field: 'classe_misuratore', type: 'string', enableFiltering: false, cellEditableCondition: isCellEditable},
      {displayName: 'TD fissa', field: 'td_fissa', type: 'number', enableFiltering: false, cellFilter: 'currency:"€/PDR/Anno":2'}
    ]});
    componentTypesMap['gas']['sr'].push({code: 'TD_var', description: 'Distribuzione variabile', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Ambito Tariffario', field: 'ambito_tariffario_id', lookup: 'ambitotariffario', enableFiltering: false, cellEditableCondition: isCellEditable},
      {displayName: 'Scaglione', field: 'scaglione', enableFiltering: false, cellEditableCondition: isCellEditable},
      {displayName: 'Lim. inf.', field: 'lim_inf', type: 'number', cellFilter: 'currency:"SMC":0'},
      {displayName: 'Lim. sup.', field: 'lim_sup', type: 'number', cellFilter: 'currency:"SMC":0'},
      {displayName: 'TD var', field: 'td_var', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/SMC":3'}
    ]});
    componentTypesMap['gas']['sr'].push({code: 'CRV', description: 'CRV', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'CRV i', field: 'crv_i', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/SMC":3'},
      {displayName: 'CRV OS', field: 'crv_os', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/SMC":3'},
      {displayName: 'CRV BL', field: 'crv_bl', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/SMC":3'},
      {displayName: 'CRV TOT', field: 'crv_tot', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/SMC":3'}
    ]});
    componentTypesMap['gas']['sr'].push({code: 'CPU', description: 'Corrispettivi unitari di capacità di rete nazionale', columnDefs: [
      {displayName: 'Anno', field: 'date', type: 'date', cellFilter: 'date:"yyyy"', cellEditableCondition: isCellEditable},
      {displayName: 'Ambito Tariffario', field: 'ambito_tariffario_id', lookup: 'ambitotariffario', enableFiltering: false, cellEditableCondition: isCellEditable},
      {displayName: 'CPU', field: 'cpu', type: 'number', enableFiltering: false, cellFilter: 'currency:"€/Anno/SMC/g":6'}
    ]});
    componentTypesMap['gas']['sr'].push({code: 'CRR', description: 'Corrispettivo unitario di capacità di rete regionale', columnDefs: [
      {displayName: 'Anno', field: 'date', type: 'date', cellFilter: 'date:"yyyy"', cellEditableCondition: isCellEditable},
      {displayName: 'CRR', field: 'crr', type: 'number', enableFiltering: false, cellFilter: 'currency:"€/Anno/SMC/g":6'}
    ]});
    componentTypesMap['gas']['sr'].push({code: 'CMT', description: 'Corrispettivo transitorio per il servizio di misura', columnDefs: [
      {displayName: 'Anno', field: 'date', type: 'date', cellFilter: 'date:"yyyy"', cellEditableCondition: isCellEditable},
      {displayName: 'CMT', field: 'cmt', type: 'number', enableFiltering: false, cellFilter: 'currency:"€/Anno/SMC/g":6'}
    ]});

    // Accise (add)
    componentTypesMap['gas']['add'].push({code: 'GAS_Accise', description: 'Accisa e IVA', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Scaglione', field: 'scaglione', enableFiltering: false, cellEditableCondition: isCellEditable},
      {displayName: 'Lim. inf.', field: 'lim_inf', type: 'number', cellFilter: 'currency:"SMC":0'},
      {displayName: 'Lim. sup.', field: 'lim_sup', type: 'number', cellFilter: 'currency:"SMC":0'},
      {displayName: 'Accisa uso civile Centro-Nord', field: 'uso_civile_centro_nord', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€":3'},
      {displayName: 'Accisa uso civile Mezzogiorno', field: 'uso_civile_mezzogiorno', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€":3'},
      {displayName: 'Accisa uso industriale/agevolata', field: 'uso_industriale_agevolato', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€":3'},
      {displayName: 'Accisa autotrazione', field: 'autotrazione', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€":3'},
      {displayName: 'Accisa Forze armate', field: 'forze_armate', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€":3'},
      {displayName: 'Esente', field: 'esente', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€":3'}
    ]});
    componentTypesMap['gas']['add'].push({code: 'GAS_Addizionale', description: 'Addizionale regionale', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Scaglione', field: 'scaglione', enableFiltering: false, cellEditableCondition: isCellEditable},
      {displayName: 'Lim. inf.', field: 'lim_inf', type: 'number', cellFilter: 'currency:"SMC":0'},
      {displayName: 'Lim. sup.', field: 'lim_sup', type: 'number', cellFilter: 'currency:"SMC":0'},
      {displayName: 'Regione', field: 'regione_id', lookup: 'regione', enableFiltering: false},
      {displayName: 'Uso civile', field: 'uso_civile', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/SMC":3'},
      {displayName: 'Uso industriale', field: 'uso_industriale', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/SMC":3'},
      {displayName: 'Identificativo delibera', field: 'identificativo_delibera', enableFiltering: false}
    ]});
    componentTypesMap['gas']['add'].push({code: 'IVA', description: 'IVA', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Scaglione', field: 'scaglione', enableFiltering: false, cellEditableCondition: isCellEditable},
      {displayName: 'Lim. inf.', field: 'lim_inf', type: 'number', cellFilter: 'currency:"SMC":0'},
      {displayName: 'Lim. sup.', field: 'lim_sup', type: 'number', cellFilter: 'currency:"SMC":0'},
      {displayName: 'IVA Uso civile', field: 'uso_civile', type: 'number', enableFiltering: false, cellFilter: 'percentage:2'},
      {displayName: 'IVA Uso industriale', field: 'uso_industriale', type: 'number', enableFiltering: false, cellFilter: 'percentage:2'},
      {displayName: 'IVA uso ind. agevolata', field: 'uso_industriale_agevolato', type: 'number', enableFiltering: false, cellFilter: 'percentage:2'}
    ]});

    // Altro
    componentTypesMap['gas']['altro'].push({code: 'GAS_Spread', description: 'Spread', columnDefs: [
      {displayName: 'Data', field: 'date', type: 'date', cellFilter: 'date:"yyyy-MM-dd"', cellEditableCondition: isCellEditable},
      {displayName: 'Tipo contratto', field: 'tipo_contratto', type: 'string', cellEditableCondition: isCellEditable},
      {displayName: 'Fornitore', field: 'fornitore_id', lookup: 'fornitore', enableFiltering: false, cellEditableCondition: isCellEditable},
      {displayName: 'Comune', field: 'comune_id', lookup: 'comune', enableFiltering: false, cellEditableCondition: isCellEditable},
      {displayName: 'Spread', field: 'spread', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/SMC":3', cellEditableCondition: isCellEditable},
      {displayName: 'Fisso', field: 'fisso', type: 'number', enableFiltering: false, cellFilter: 'currency:"c€/SMC":3', cellEditableCondition: isCellEditable}
    ]});
    //componentTypesMap['gas']['altro'].push({code: 'prof_utenza', description: 'Prof. Utenza', columnDefs: [
    //  {displayName: 'Gruppo Utente', field: 'gruppo_utenze', cellEditableCondition: isCellEditable},
    //  {displayName: 'Pp', field: 'pp', enableFiltering: false},
    //  {displayName: 'Gen', field: 'gennaio', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
    //  {displayName: 'Feb', field: 'febbraio', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
    //  {displayName: 'Mar', field: 'marzo', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
    //  {displayName: 'Apr', field: 'aprile', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
    //  {displayName: 'Mag', field: 'maggio', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
    //  {displayName: 'Giu', field: 'giugno', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
    //  {displayName: 'Lug', field: 'luglio', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
    //  {displayName: 'Ago', field: 'agosto', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
    //  {displayName: 'Set', field: 'settembre', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
    //  {displayName: 'Ott', field: 'ottobre', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
    //  {displayName: 'Nov', field: 'novembre', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
    //  {displayName: 'Dic', field: 'dicembre', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'}
    //]});




    var typeDescriptors = [];

    typeDescriptors['ee'] = {code:'ee', description: 'Energia Elettrica'};
    typeDescriptors['gas'] = {code:'gas', description: 'Gas'};



    var categoryDescriptors = [];

    categoryDescriptors['sv'] = {code: 'sv', description: 'Servizi di Vendita', fornitore_dependent: false};
    categoryDescriptors['sr'] = {code: 'sr', description: 'Servizi di Rete e Distribuzione', fornitore_dependent: false};
    categoryDescriptors['og'] = {code: 'og', description: 'Oneri Generali', fornitore_dependent: false};
    categoryDescriptors['add'] = {code: 'add', description: 'Addizionali', fornitore_dependent: false};
    categoryDescriptors['altro'] = {code: 'altro', description: 'Altro', fornitore_dependent: false};





    // Public API here
    return {
      getTypes: function () {
        return componentTypesMap;
      },
      getCategories: function (type) {
        return componentTypesMap[type];
      },
      getCodes: function (type, category) {
        return componentTypesMap[type][category];
      },
      getByCode: function (type, category, code) {
        for(var idx in componentTypesMap[type][category]) {
          if((componentTypesMap[type][category][idx]).code === code) {
            return componentTypesMap[type][category][idx];
          }
        }
      },
      getAll: function() {
        var list = [];
        for(var typeIdx in componentTypesMap) {
          for(var catIdx in componentTypesMap[typeIdx]) {
            for(var codeIdx in componentTypesMap[typeIdx][catIdx]) {
              list.push(componentTypesMap[typeIdx][catIdx][codeIdx]);
            }
          }
        }
        return list;
      },
      getTypeDescriptor: function(type) {
        return typeDescriptors[type];
      },
      getCategoryDescriptor: function(category) {
        return categoryDescriptors[category];
      }
    };
  });

angular.module('emma.energy').filter('cellFormatter', function ($log, $filter) {
  return function (value, scope) {
    //$log.log(scope);
    // TODO a seconda del tipo di colonna posso applicare formattazioni differenti (scope.col... o scope.row.entity...)
    return $filter('currency')(value, 'c€', 3);
  };
});

angular.module('emma.energy').filter('percentage', function ($log, $filter) {
  return function (value, decimalPosition, scope) {
    return $filter('currency')(value*100, '%', decimalPosition);
  };
});

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ListCtrl
 * @description
 * # PriceListCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/pricelist/list', {
        templateUrl: 'energy/pricelist/pricelist_list.html',
        controller: 'PriceListCtrl'
      })
      .when('/pricelist/detail', {
        templateUrl: 'energy/pricelist/pricelist_detail.html',
        controller: 'PriceListCtrl'
      })
      .when('/pricelist/detail/:id', {
        templateUrl: 'energy/pricelist/pricelist_detail.html',
        controller: 'PriceListCtrl'
      })
  })
  .controller('PriceListCtrl', function ($scope, $routeParams, $timeout, $rootScope, $log, $filter, $location, authFactory, componenttypefactory,
                                         priceListFactory, listComponentFactory, $q, toaster, errorService, uiGridConstants, dialogService) {

    // Gas
    $scope.deliberaAEEGList = [
      {code: 'arg_gas_64_09', description: 'ARG/gas 64/09'},
      {code: 'arg_gas_77_11', description: 'ARG/gas 77/11'},
      {code: 'arg_gas_117_12', description: 'ARG/gas 117/12'},
      {code: 'arg_gas_385_12', description: 'ARG/gas 385/12'},
      {code: 'arg_gas_196_13', description: 'ARG/gas 196/13'},
      {code: 'cond_tutela', description: 'Condizioni di tutela'}
    ];

    $scope.pcsStdList = [38.100, 38.52];

    $scope.pcsList = [];

    $scope.resetFields = function() {
      $scope.contatoreTypeFilter = {'model.code': 'contatoreacqua,contatoreelettricita,contatoregas,contatoregpl,serbatoioinpressione,serbatoiopressioneatmosferica,contatoreteleriscaldamento,contatoreteleraffreddamento'};
      $scope.header = {
        version: undefined,
        model: {
          code: undefined,
          description: undefined,
          vettore_id: undefined,
          fornitore_id: undefined,
          from: undefined,
          to: undefined,
          delibera_aeeg: {code: 'arg_gas_196_13', description: 'ARG/gas 196/13'},
          pcs_std: 38.100
        }
      };
      $scope.contatoreType = {};
      $scope.prices = [];
      $scope.list = [];
      $scope.types = [];
    };

    var paginationOptions = {
      pageNumber: 1,
      pageSize: 15
    };

    var genericTypes = [
      { code: 'fisso' }
    ];

    var gasTypes = [
      { code: 'fisso' },
      { code: 'monomia' },
      { code: 'binomia' }
    ];

    var eeTypes = [
      { code: 'fisso' },
      { code: 'monomia' }
    ];

    var actionsCol = {
      displayName: '', field: 'model.code', headerCellTemplate: '<div><button class="btn btn-sm" style="background-color: transparent !important" ng-disabled="!grid.appScope.header.model.vettore_id || grid.appScope.isWritePermAllowed()===false" ng-click="grid.appScope.addPrice()"><span class="fa fa-plus"></span></button></div>',
      cellTemplate: '<div class="ui-grid-cell-contents"><button class="btn btn-xs btn-danger" ng-click="grid.appScope.removePricesWithDialog([row.entity])" ng-disabled="grid.appScope.isWritePermAllowed()===false"><span class="fa fa-trash"></span></button></div>',
      width: 50, enableSorting: false, enableFiltering: false, enableCellEdit: false
    };

    var fixedColumnDefs = [
      {displayName: 'Fascia', field: 'model.slot', sort: {direction: 'asc', priority: 0 }, maxWidth: 200},
      {displayName: 'Tariffa', field: 'model.price', type: 'number', cellFilter: "currencyFilter:grid.appScope.header.model.vettore_id.code"}
    ];

    // Grid
    $scope.listGridOptions = {
      paginationPageSizes: [10, 15, 20, 30],
      paginationPageSize: 15,
      useExternalPagination: true,
      enableHorizontalScrollbar: true,
      columnDefs: [
        {displayName: '', field: 'model.code', enableFiltering: false, width: 34, cellTemplate: '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ng-click="grid.appScope.viewDetail(row.entity.UUID)"><i class="fa fa-search"></i></button></div>'},
        {displayName: 'Codice', field: 'model.code'},
        {displayName: 'Descrizione', field: 'model.description'},
        {displayName: 'Fornitore', field: 'model.fornitore_id.description'},
        {displayName: 'Vettore', field: 'model.vettore_id.description'},
        {displayName: 'Tipo', field: 'model.type.code'},
        {displayName: '', field: 'model.code', width: 40, cellTemplate: '<div class="ui-grid-cell-contents"><button class="btn btn-xs btn-danger" ng-click="grid.appScope.deleteWithDialog(row.entity.version)" ng-disabled="grid.appScope.isDeletePermAllowed()===false"><i class="fa fa-trash"></i></button></div>' },
      ],
      data: 'list.list',
      onRegisterApi: function(gridApi) {
        $scope.listGridApi = gridApi;
        gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
          paginationOptions.pageNumber = newPage;
          paginationOptions.pageSize = pageSize;
          $scope.updatePagination();
        });
      }
    };

    $scope.pricesGridOptions = {
      paginationPageSizes: [10, 20, 30],
      paginationPageSize: 10,
      useExternalPagination: false,
      enableHorizontalScrollbar: true,
      data: 'prices',
      onRegisterApi: function(gridApi) {
        $scope.pricesGridApi = gridApi;
      }
    };

    $scope.removePricesWithDialog = function(items) {
      dialogService.confirmDialog('Eliminare la tariffa?',
        function () {
          $scope.removePrices(items);
        });
    };

    $scope.removePrices = function(items) {
      if($scope.header.model.vettore_id && Array.isArray($scope.prices)) {
        items.forEach(function (item) {
          var i = $scope.prices.indexOf(item);
          $scope.prices.splice(i, 1);
        });
      }
    };

    $scope.newPricelist = function(){
        $location.path('/pricelist/detail');
    };

    $scope.addPrice = function() {
      if($scope.header.model.vettore_id) {
        if(!Array.isArray($scope.prices)) {
          $scope.prices = [];
        }

        // aggiorno il contatore degli slot
        var ordered = $filter('orderBy')($scope.prices, 'model.slot', false);
        var counter = 0;
        if(ordered.length > 0) {
          counter = parseInt(ordered[ordered.length-1].model.slot.substring(1))+1;
        }
        for (var i = 1 ; i < ordered.length ; i++) {
          var last = parseInt(ordered[i-1].model.slot.substring(1));
          var current = parseInt(ordered[i].model.slot.substring(1));
          if(current-last > 1) {
            counter = last+1;
          }
        }

        // aggiungo
        $scope.prices.push({
          model: {slot: 'F'+counter, price: ''}
        });
      }
    };

    function updateColumnDefs() {
      if($scope.header.model.type.code === 'fisso') {
        $scope.pricesGridOptions.columnDefs = angular.copy(fixedColumnDefs);
        $scope.pricesGridOptions.columnDefs.push(actionsCol);
      }
      if ($scope.slotsGridApi) {
        $scope.slotsGridApi.core.refresh();
      }
    }

    function updateTypes() {
      if($scope.header.model.vettore_id && $scope.header.model.vettore_id.code === 'elettricita') {
        $scope.types = eeTypes;
      } else if($scope.header.model.vettore_id && $scope.header.model.vettore_id.code === 'gas') {
        $scope.types = gasTypes;
      } else {
        $scope.types = genericTypes;
      }
    }

    function isValidInput() {
      var isValid = true;
      if(angular.isUndefined($scope.header.model.code)){
        toaster.pop('error', 'Errore', 'Inserire un codice');
        isValid = false;
      }
      if(angular.isUndefined($scope.header.model.description)){
        toaster.pop('error', 'Errore', 'Inserire una descrizione');
        isValid = false;
      }
      if(angular.isUndefined($scope.header.model.to)){
        toaster.pop('error', 'Errore', 'Definire una data di fine validità');
        isValid = false;
      }
      if($scope.header.model.from>$scope.header.model.to){
        toaster.pop('error', 'Errore', 'La data di fine validità non può essere antecedente alla data di inizio validità');
        isValid = false;
      }
      return isValid;
    };

    $scope.saveOrUpdate = function() {
      var promise;
      if(isValidInput() && $scope.header.model.type) {
        if($scope.header.version) {  // update
          promise = priceListFactory.bulkUpdate({header: $scope.header, list: $scope.prices}).$promise;
        } else {  // create
          var toSave = [];
          if($scope.prices && $scope.prices.length > 0) {
            $scope.prices.forEach(function (p) {
              toSave.push(p.model);
            });
          }
          promise = priceListFactory.bulk({header: $scope.header.model, list: toSave}).$promise;
        }
        promise.then(function(response) {
          if (errorService.handleError(response)) {
            if($scope.header.model.type.code === 'fisso') {
              $scope.prices = response.list;
            }
            $scope.findPriceList();
            toaster.pop('success', 'Salvato', 'Salvataggio riuscito con successo');
            $location.path('pricelist/list');
          }
          else {
            toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
          }
        });
      } else {
        toaster.pop('error', 'Errore', 'Selezionare il tipo di calcolo');
      }
    };

    $scope.deleteWithDialog = function(itemId) {
      dialogService.confirmDialog('Eliminare il listino?',
        function () {
          $scope.delete(itemId);
        });
    };

    $scope.delete = function(itemId) {
      priceListFactory.delete({id: itemId}).$promise.then(function (resp) {
        if (errorService.handleError(resp)) {
          $scope.findPriceList();
          $scope.resetFields();
          $location.path('pricelist/list');
        } else {
          toaster.pop('error', 'Errore', 'Errore durante l\'eliminazione');
        }
      });
    };

    $scope.findPriceList = function() {
      priceListFactory.findAll(
        {page: paginationOptions.pageNumber, page_size: paginationOptions.pageSize, query: $scope.queryParam}
      ).$promise.then(function(result) {
        $scope.list = result;
        getPage();
      });
    };

    $scope.load = function(uuid) {
      priceListFactory.byUUID({id: uuid}).$promise.then(function(response) {
        if (errorService.handleError(response)) {
          $scope.header = response;
          $scope.header.model.from = new Date(response.model.from);
          $scope.header.model.to = new Date(response.model.to);
          if(response.model.record_id) {
            $scope.contatoreType = {
              id: {
                type: 'schema',
                UUID: response.model.record_id.type,
                code: response.model.record_id.UUID
              }
            };
          }

          // carico i dati
          priceListFactory.byHeader({id: uuid}).$promise.then(function(prices) {
            if (errorService.handleError(prices)) {
              $scope.prices = prices.list;
            } else {
              toaster.pop('error', 'Errore', 'Errore durante il recuepro dei dati');
            }
          });
        } else {
          toaster.pop('error', 'Errore', 'Errore durante il recuepro dei dati');
        }
      });
    };

    var getPage = function() {
      $scope.listGridOptions.totalItems = $scope.list.totalResults;
      var firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
      $scope.listGridOptions.data = $scope.listGridOptions.data.slice(firstRow, firstRow + paginationOptions.pageSize);
    };

    $scope.updatePagination =  function () {
      $scope.listGridOptions.totalItems = $scope.list.totalResults;
      $scope.list = priceListFactory.findAll({page: paginationOptions.pageNumber, page_size: paginationOptions.pageSize});
      $scope.listGridOptions.data = $scope.list.list;
    };

    $scope.showFixedPricesGrid = function() {
      return $scope.header.model.type && $scope.header.model.type.code === 'fisso' && $scope.header.model.vettore_id.code !== 'gas' && $scope.header.model.vettore_id.code !== 'elettricita';
    };

    $scope.viewDetail = function(uuid){
        $location.path('/pricelist/detail/' + uuid);
    };

    $scope.goBack = function(){
        $("#code").removeAttr('required');
        $("#description").removeAttr('required');
        $("#from").removeAttr('required');
        $("#to").removeAttr('required');
        $location.path('/pricelist/list/');
    };

    if($routeParams.id) {
      $scope.load($routeParams.id);
    }
    else{
      $scope.resetFields();
    }

    /********************/
    /***** WATCHERS *****/
    /********************/

    $scope.$watch('header.model.type.code', function(newVal, oldVal) {
      if(newVal) {
        updateColumnDefs();
      }
    });

    $scope.$watch(function() {return $scope.header.model.vettore_id;}, function(newVal, oldVal) {
      if(newVal) {
        updateTypes();
      }
    });


    $scope.onPcsStdSelect = function(selected) {
      var n = parseFloat(selected);
      if(!isFinite(n)) {
        return '';
      }
      $scope.pcsList = [selected];
      return selected;
    };


    $scope.findPriceList();


    $scope.$watch(function() {return $scope.listGridOptions.paginationPageSize;}, function(newVal, oldVal) {
      if(newVal) {
        var newHeight = $scope.listGridOptions.paginationPageSize * 30 + 110;
        newHeight = Math.min(710, newHeight);
        angular.element(document.getElementsByClassName('grid')[0]).css('height', newHeight + 'px');
        //angular.element(document.getElementsByClassName('grid')[0]).css('width', newWidth + 'px');
      }
    });


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'pricelist';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };


  })

  .filter('currencyFilter', function() {
    return function(value, vectorCode) {
      if(angular.isNumber(value)) {
        if (vectorCode === 'elettricita') {
          return parseFloat(value).toFixed(5) + ' c€/kWh';
        } else if (vectorCode === 'gas') {
          return parseFloat(value).toFixed(5) + ' c€/SMC';
        } else {
          return parseFloat(value).toFixed(5) + ' c€';
        }
      }
    }
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ListComponentCtrl
 * @description
 * # ListComponentCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/pricelist/listcomponent/:type/:category', {
        templateUrl: 'energy/pricelist/pricelist_component_list.html',
        controller: 'PriceListComponentCtrl'
      })
      .when('/pricelist/listcomponent/:type/:category/:component', {
        templateUrl: 'energy/pricelist/pricelist_component.html',
        controller: 'PriceListComponentCtrl'
      })
      .when('/pricelist/listcomponent/:type/:category/:component/:fornitore', {
        templateUrl: 'energy/pricelist/pricelist_component.html',
        controller: 'PriceListComponentCtrl'
      })
  })
  .controller('PriceListComponentCtrl', function ($scope, $routeParams, $rootScope, $log, $filter, $location, authFactory,
                                                  componenttypefactory, listComponentFactory, recordFactory, $q, toaster,
                                                  errorService, uiGridConstants) {

    $scope.queryFilter = undefined;
    $scope.sort = undefined;

    $scope.mode = {mode: 'show'};

    var paginationOptions = {
      pageNumber: 1,
      pageSize: 10
    };

    var listColumnDefs = [
      {displayName: '', field: 'visualizza', width: 34, enableCellEdit: true, enableFiltering: false, enableSorting: false, cellTemplate: '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ng-click="grid.appScope.openDetails(row.entity.fornitore_code)"><i class="fa fa-search"></i></button></div>'},
      {displayName: 'Cod. Fornitore', field: 'fornitore_code', width: 150},
      {displayName: 'Descrizione', field: 'fornitore_description'}
    ];

    $scope.gridListOptions = {
      enableSorting: true,
      enableGridMenu: false,
      exporterMenuPdf: false,
      enableFiltering: true,
      paginationPageSizes: [10, 20, 30],
      paginationPageSize: 10,
      useExternalPagination: true,
      columnDefs: listColumnDefs,
      onRegisterApi: onRegisterApiList
    };

    $scope.gridDetailOptions = {
      enableSorting: true,
      enableGridMenu: true,
      exporterMenuPdf: false,
      enableFiltering: true,
      paginationPageSizes: [10, 20, 30],
      paginationPageSize: 10,
      useExternalPagination: true,
      onRegisterApi: onRegisterApi
    };

    $scope.importData = function() {
      if($scope.gridDetailOptions.data && $scope.gridDetailOptions.data) {
        var selected = $scope.gridApiDetail.selection.getSelectedRows();
        var toSave = [];
        if (!selected || !selected.length) {
          selected = $scope.gridDetailOptions.data;
        }
        selected.forEach(function(item) {
          if($scope.category.descriptor.fornitore_dependent) {
            item.fornitore_id = $scope.fornitore.fornitore_id;
          }
          item.type = $scope.type.type.toLowerCase();
          item.category = $scope.category.category.toLowerCase();
          item.component = $scope.selectedComponentType.code.toLowerCase();
          toSave.push(item);
        });

        // bulk save
        listComponentFactory($scope.selectedComponentType.code).bulk(toSave).$promise.then(function(resp) {
          if(errorService.handleError(resp)) {
            $scope.percent = 100;
            toaster.pop('success', 'Salvataggio', 'Importazione eseguita con successo');
            $scope.loadData();
          }
          else {
            toaster.pop('error', 'Errore', 'Errore durante l\'importazione');
          }
        }, function(resp) {
            toaster.pop('error', 'Errore', 'Errore durante l\'importazione: ' + resp.message);
        });
      }
    };

    $scope.saveOrUpdate = function(item) {
      if($scope.mode.mode === 'show') {
        if($scope.category.descriptor.fornitore_dependent) {
          item.fornitore_id = $scope.fornitore.fornitore_id;
        }
        item.type = $scope.type.type.toLowerCase();
        item.category = $scope.category.category.toLowerCase();
        item.component = $scope.selectedComponentType.code.toLowerCase();
        if(item.date) {
          item.date = $filter('date')(item.date, 'yyyy-MM-dd');
        }
        delete item.sixImportStatus;
        if (item.wrapper && item.wrapper.UUID) {
          // update
          var toUpdate = angular.copy(item.wrapper);
          toUpdate.model = angular.copy(item);
          delete toUpdate.model.wrapper;
          listComponentFactory($scope.selectedComponentType.code).update({id: toUpdate.model.code}, toUpdate).$promise.then(function (resp) {
            if (errorService.handleError(resp)) {
              var idx = $scope.gridDetailOptions.data.indexOf(item);
              item = resp.model;
              item.wrapper = resp;
              delete item.wrapper.model;
              $scope.gridDetailOptions.data[idx] = item;
              $scope.percent = 100;
              toaster.pop('success', 'Salvataggio', 'Salvataggio eseguito con successo');
            }
            else {
              toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
            }
          });
        }
        else {
          // create
          listComponentFactory($scope.selectedComponentType.code).create(item).$promise.then(function (resp) {
            if (errorService.handleError(resp)) {
              var idx = $scope.gridDetailOptions.data.indexOf(item);
              item = resp.model;
              item.wrapper = resp;
              delete item.wrapper.model;
              $scope.gridDetailOptions.data[idx] = item;
              $scope.percent = 100;
              toaster.pop('success', 'Salvataggio', 'Salvataggio eseguito con successo');
            }
            else {
              toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
            }
          });
        }
      }
    };

    $scope.openDetails = function(fornitore) {
      $location.path('/list/listcomponent/'+$scope.type.type+'/'+$scope.category.category+'/'+$scope.selectedComponentType.code+'/'+fornitore);
    };

    $scope.loadData = function() {
      if($scope.mode.mode === 'show') {
        $scope.gridDetailOptions.data = [];
        find().then(function (resp) {
          paginationOptions.pageNumber = 1;
          getPage($scope.gridDetailOptions);
          //$scope.gridApiDetail.pagination.seek(1);
        });
      }
    };

    function find() {
      $scope.percent = 0;
      $scope.gridDetailOptions.data = [];
      return listComponentFactory($scope.selectedComponentType.code).findAll(getQuery()).$promise.then(function(resp) {
        if(errorService.handleError(resp)) {
          fromIndexToGrid(resp.list);
          $scope.gridDetailOptions.totalItems = resp.totalResults;
        }
        else {
          toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
        }
      });
    }

    $scope.loadGroupByFornitori = function() {
      findGroupByFornitori().then(function(resp) {
        paginationOptions.pageNumber = 1;
        getPage($scope.gridListOptions);
        //$scope.gridApiList.pagination.seek(1);
      });
    };

    function findGroupByFornitori() {
      return listComponentFactory(buildQueryPath()).grouped(getQuery()).$promise.then(function(resp) {
        if(errorService.handleError(resp)) {
          $scope.gridListOptions.data = resp.list;
          $scope.gridListOptions.totalItems = resp.totalResults;
        }
        else {
          toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
        }
      });
    }

    $scope.addRecord = function() {
      $scope.gridDetailOptions.data.unshift({
          type: $scope.selectedComponentType.code,
          date: Date.now()
      });
      $scope.gridDetailOptions.data.totalItems++;
    };

    $scope.removeRecords = function() {
      var promises = [];
      $scope.gridApiDetail.selection.getSelectedRows().forEach(function(item) {
        if(item.code) {
          var prom = listComponentFactory(item.component.toLowerCase()).delete({id: item.code}).$promise.then(function(response) {
            if (!errorService.handleError(response)) {
              toaster.pop('error', 'Errore', 'Impossibile eliminare il dato del ' + item.date);
            }
          });
          promises.push(prom);
        }
      });
      $q.all(promises).then(function(responses) { find(); }); // ricarico i dati solo dopo aver eliminato tutti i selezionati
    };

    $scope.tabSelected = function(component) {
      $scope.selectedComponentType = component;
    };

    function updateColumnDefs() {
      $scope.gridDetailOptions.columnDefs = angular.copy($scope.selectedComponentType.columnDefs);
      if ($scope.mode.mode === 'show') {
        $scope.gridDetailOptions.columnDefs.forEach(function (col) {
          if (col.lookup) {
            col.field = col.field + '.description'; // mostro la descrizione e non tutto l'oggetto
          }
        });
      } else {
        $scope.gridDetailOptions.columnDefs.unshift({field: 'sixImportStatus'});
      }
      if($scope.gridApiDetail) {
        $scope.gridApiDetail.core.refresh();
      }
    }

    function fromIndexToGrid(data) {
      data.forEach(function(row) {
        var item = row.model;
        item.wrapper = angular.copy(row);
        delete item.wrapper.model;
        $scope.gridDetailOptions.data.push(item);
      });
    }

    function processData(data) {
      var mapToResolve = {};

      // processo i numeri e preparo la richiesta per risolvere le lookup
      data.forEach(function(row) {
        for(var key in row) {
          if(row.hasOwnProperty(key)) {
            $scope.selectedComponentType.columnDefs.forEach(function (col) {
              if (col.field === key) {
                if (col.type === 'number' && !isNaN(row[key])) {
                  row[key] = parseFloat(row[key]);
                } else if (col.lookup) {
                  var innerMap = mapToResolve[col.lookup] || {};
                  innerMap[row[key]] = '';
                  mapToResolve[col.lookup] = innerMap;
                }
              }
            });
          }
        }
      });

      // risolvo le lookup
      data.forEach(function(row) {
        row['sixImportStatus'] = 'OK';
      });
      if(!sixObjectLib.isEmpty(mapToResolve)) {
        $scope.isAllOk = true;
        recordFactory('type').bulkResolve(mapToResolve).$promise.then(function(response) {
          $log.info(response);
          data.forEach(function(row) {
            var message = '';
            var sep = '';
            for(var key in row) {
              $scope.selectedComponentType.columnDefs.forEach(function(col) {
                if (col.field === key) {
                  if (col.lookup) {
                    var resolved = response[col.lookup][row[key]];
                    if(angular.isUndefined(resolved) || resolved === null) {
                      message += sep + 'record \'' + row[key] + '\'' + ' non trovato!';
                      sep = '; ';
                      row['sixImportStatus'] = message;
                      $scope.isAllOk = false;
                    } else {
                      row[key] = sixObjectLib.recordToHisRef(resolved);
                    }
                  }
                }
              });
            }
          });
        });
      }

      return data;
    }




    /**********************/
    /****** Watchers ******/
    /**********************/

    $scope.$watchGroup(['selectedComponentType', 'selectedComponentType.code', 'fornitore', 'fornitore.fornitore_id', 'upperDate'], function(newValue) {
      $scope.queryFilter = undefined;
      $scope.sort = undefined;
      paginationOptions.pageNumber = 1;
      $scope.percent = 0;
      updateColumnDefs();
      $scope.gridDetailOptions.xlsData = [];
      $scope.gridDetailOptions.data = [];
      if($scope.selectedComponentType && (($scope.fornitore && $scope.fornitore.fornitore_id) || $scope.category.descriptor.fornitore_dependent === false)) {
        $scope.loadData();
      }
      else if($scope.selectedComponentType) {
        $scope.gridDetailOptions.data = [];
        $scope.loadGroupByFornitori();
      }
      else {
        $scope.gridDetailOptions.data = [];
      }
    });

    $scope.$watch(function() { return $scope.mode.mode; }, function(newVal, oldVal) {
      updateColumnDefs();
      if($scope.mode.mode === 'import') {
        $scope.gridDetailOptions.data = [];
      } else {
        $scope.loadData();
      }
    });

    //dati caricati da xls
    $scope.$watch(function() {
        return $scope.gridDetailOptions.xlsData;
      },
      function( newValue, oldValue ) {
        if (newValue && newValue.length>0){
          updateColumnDefs();
          $scope.gridDetailOptions.data = processData($scope.gridDetailOptions.xlsData);
        }
      }
    );




    /***********************/
    /**** Query builder ****/
    /***********************/

    function getSortFields() {
      if($scope.sort && $scope.sort.fields) {
        return $scope.sort.fields;
      }
      return 'model.date';
    }

    function getSortDirections() {
      if($scope.sort && $scope.sort.directions) {
        return $scope.sort.directions;
      }
      return 'desc';
    }

    function buildQueryPath() {
      var code = '';
      if($scope.fornitore && $scope.fornitore.fornitore_id) {
        code = $scope.fornitore.fornitore_id.UUID;
      }
      return $scope.selectedComponentType.code + '/' + code;
    }

    function getQuery() {
      var query = {
        date: $scope.upperDate,
        page: paginationOptions.pageNumber,
        page_size: paginationOptions.pageSize,
        sort_fields: getSortFields(),
        sort_order: getSortDirections()
      };
      if($scope.queryFilter) {
        query.query = $scope.queryFilter;
      }
      return query;
    }




    /*********************/
    /**** Paginazione ****/
    /*********************/

    function getPage(grid) {
      if(grid.data && $scope.mode.mode === 'show') {
        var firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
        grid.data = grid.data.slice(firstRow, firstRow + paginationOptions.pageSize);
      }
    }

    $scope.updatePagination = function () {
      if($scope.mode.mode === 'show') {
        find();
      }
    };

    $scope.updatePaginationList = function () {
      if($scope.mode.mode === 'show') {
        findGroupByFornitori();
      }
    };




    /*****************************/
    /***** UI GRID Callbacks *****/
    /*****************************/

    function onRegisterApiList(gridApi){
      $scope.gridApiList = gridApi;
      gridApi.pagination.on.paginationChanged($scope, paginationChangedCallbackList);
      gridApi.core.on.filterChanged($scope, filterChangedCallbackList);
      gridApi.core.on.sortChanged($scope, sortChangedCallbackList);
    }

    function onRegisterApi(gridApi){
      $scope.gridApiDetail = gridApi;
      gridApi.rowEdit.on.saveRow($scope, saveRowCallback);
      gridApi.pagination.on.paginationChanged($scope, paginationChangedCallback);
      gridApi.core.on.filterChanged($scope, filterChangedCallback);
      gridApi.core.on.sortChanged($scope, sortChangedCallback);

      gridApi.core.registerColumnsProcessor(function(columns, rows) {
        columns.forEach(function(col) {});
        return columns;
      }, 1000);
    }

    function saveRowCallback(rowEntity) {
      $scope.percent = 0;
      var promise = $q.defer();
      $scope.gridApiDetail.rowEdit.setSavePromise( rowEntity, promise.promise );
      if(!rowEntity || !rowEntity.date) {
        toaster.pop('error', 'Errore', 'Errore durante l\'aggiornamento');
        promise.reject();
      }
      else {
        $scope.saveOrUpdate(rowEntity);
        promise.resolve();
      }
    }

    function paginationChangedCallback(newPage, pageSize) {
      paginationOptions.pageNumber = newPage;
      paginationOptions.pageSize = pageSize;
      $scope.updatePagination();
    }

    function paginationChangedCallbackList(newPage, pageSize) {
      paginationOptions.pageNumber = newPage;
      paginationOptions.pageSize = pageSize;
      $scope.updatePaginationList();
    }

    function filterChangedCallback() {
      if($scope.mode.mode === 'show') {
        $scope.queryFilter = '';  // lo ricostruisco tutte le volte
        var separator = '';
        $scope.gridApiDetail.grid.columns.forEach(function (col) {
          col.filters.forEach(function (filter) {
            var term = filter.term;
            var condition = filter.condition;
            var field = col.field;
            if (term && term != '') {
              //$log.log('Field: ' + field + '\nSearch Term: ' + term);
              var op;
              var del = '';
              switch (condition) {
                case uiGridConstants.filter.LESS_THAN:
                  op = ' < ';
                  break;
                case uiGridConstants.filter.GREATER_THAN:
                  op = ' > ';
                  break;
                default:
                  op = ' like ';
                  del = '\'';
              }
              $scope.queryFilter += separator + field + op + del + term + del;
              separator = '&';
            }
          });
        });
        find();
      }
    }

    function sortChangedCallback(sortColumns) {
      if($scope.mode.mode === 'show') {
        $scope.gridApiDetail.grid.columns.forEach(function (col) {
          if (col.sort.direction) {
            $scope.sort = {fields: col.field, directions: col.sort.direction};
          }
        });
        find();
      }
    }

    function filterChangedCallbackList() {
      if($scope.mode.mode === 'show') {
        $scope.queryFilter = '';  // lo ricostruisco tutte le volte
        var separator = '';
        $scope.gridApiList.grid.columns.forEach(function (col) {
          col.filters.forEach(function (filter) {
            var term = filter.term;
            var condition = filter.condition;
            var field = col.field;
            if (term && term != '') {
              //$log.log('Field: ' + field + '\nSearch Term: ' + term);
              var op;
              var del = '';
              switch (condition) {
                case uiGridConstants.filter.LESS_THAN:
                  op = ' < ';
                  break;
                case uiGridConstants.filter.GREATER_THAN:
                  op = ' > ';
                  break;
                default:
                  op = ' like ';
                  del = '\'';
              }
              $scope.queryFilter += separator + field + op + del + term + del;
              separator = '&';
            }
          });
        });
        findGroupByFornitori();
      }
    }

    function sortChangedCallbackList(sortColumns) {
      if($scope.mode.mode === 'show') {
        $scope.gridApiList.grid.columns.forEach(function (col) {
          if (col.sort.direction) {
            $scope.sort = {fields: col.field, directions: col.sort.direction};
          }
        });
        find();
      }
    }



    /*****************************/
    /**** Definizione colonne ****/
    /*****************************/

    if($routeParams.fornitore) {
      if($routeParams.fornitore === '_new_') {
        $scope.fornitore = {};
      }
      else {
        $scope.fornitore = {fornitore_id: { type: 'fornitore', UUID: $routeParams.fornitore}};
      }
    }
    if($routeParams.type && $routeParams.category) {
      $scope.componentTypesList = componenttypefactory.getCodes($routeParams.type, $routeParams.category);
      $scope.type = {
        type: $routeParams.type,
        descriptor: componenttypefactory.getTypeDescriptor($routeParams.type)
      };
      $scope.category = {
        category: $routeParams.category,
        descriptor: componenttypefactory.getCategoryDescriptor($routeParams.category)
      };
      if($routeParams.component) {
        $scope.selectedComponentType = componenttypefactory.getByCode($routeParams.type, $routeParams.category, $routeParams.component);
      }
    }
    else {
      $scope.componentTypesList = componenttypefactory.getAll();
      $scope.typeDesc = 'tutto';
      $scope.categoryDesc = 'tutto';
    }




    /*********************/
    /**** Date picker ****/
    /*********************/

    $scope.upperDate = new Date();

    $scope.dateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };

    $scope.open = function($event) {
      $scope.status.opened = true;
    };

    $scope.status = {
      opened: false
    };




    /*************************************/
    /*********** Template xlsx ***********/
    /*************************************/

    function buildDataType(prop) {
      if(prop.type === 'string' && prop.format === 'date') {
        return 'yyyy-MM-dd';
      }
      else if(prop.type === 'string' && prop.format === 'lookup') {
        return 'ref';
      }
      else if(prop.type === 'integer') {
        return 1;
      }
      else if(prop.type === 'number') {
        return 1.234;
      }
      else if(prop.type === 'object') {
        var obj = {};
        for(var key in prop.properties) {
          obj[key] = buildDataType(prop.properties[key]);
        }
        return JSON.stringify(obj);
      }
      return 'text';
    }

    function columnsToSheet() {
      var ws = {};
      var range = {s: {c:10000000, r:10000000}, e: {c:0, r:0 }};
      var data = [[], []];

      $scope.selectedComponentType.columnDefs.forEach(function(col) {
        // Intestazione di colonna
        data[0].push(col.field);
        // Riga di esempio
        //var prop = $scope.schemaDefinition.model.schema.properties[key];
        //var example = 'text';
        //if(prop.type === 'array') {
        //  if(!prop.items) {
        //    example = '[item1, item2]';
        //  }
        //  else {
        //    example = '['+buildDataType(prop.items)+','+buildDataType(prop.items)+']';
        //  }
        //}
        //else {
        //  example = buildDataType(prop);
        //}
        //data[1].push(example);
      });

      for(var R = 0; R != data.length; ++R) {
        for(var C = 0; C != data[R].length; ++C) {
          if(range.s.r > R) range.s.r = R;
          if(range.s.c > C) range.s.c = C;
          if(range.e.r < R) range.e.r = R;
          if(range.e.c < C) range.e.c = C;
          var cell = {v: data[R][C] };
          if(cell.v == null) continue;
          var cell_ref = XLSX.utils.encode_cell({c:C,r:R});

          if(typeof cell.v === 'number') cell.t = 'n';
          else if(typeof cell.v === 'boolean') cell.t = 'b';
          else if(cell.v instanceof Date) {
            cell.t = 'n'; cell.z = XLSX.SSF._table[14];
            cell.v = datenum(cell.v);
          }
          else cell.t = 's';

          ws[cell_ref] = cell;
        }
      }
      if(range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
      return ws;
    }

    function Workbook() {
      if(!(this instanceof Workbook)) return new Workbook();
      this.SheetNames = [];
      this.Sheets = {};
    }

    function datenum(v, date1904) {
      if(date1904) v+=1462;
      var epoch = Date.parse(v);
      return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
    }

    $scope.createTemplate = function() {
      //var ranges = oo[1];

      /* original data */
      var ws_name = $scope.selectedComponentType.code;

      var wb = new Workbook();
      var ws = columnsToSheet();

      /* add ranges to worksheet */
      //ws['!merges'] = ranges;

      /* add worksheet to workbook */
      wb.SheetNames.push(ws_name);
      wb.Sheets[ws_name] = ws;

      var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:false, type: 'binary'});

      saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), $scope.selectedComponentType.code+".xlsx")
    };

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'list/component/{entity}';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };


  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:PriceListSimulatorCtrl
 * @description
 * # PriceListComponentCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/pricelist/sim/:sim_type', {
        templateUrl: 'energy/pricelist/pricelist_sim.html',
        controller: 'PriceListSimulatorCtrl'
      })
  })
  .controller('PriceListSimulatorCtrl', function ($scope, $routeParams, $timeout, $rootScope, $log, $filter, $location,
                                                  authFactory, energyCarrierFactory, recordFactory, componenttypefactory, listComponentFactory,
                                                  voltageClassFactory, contractFactory, priceListFactory, simulationFactory,  $q, toaster,
                                                  errorService, uiGridConstants, dialogService) {

    var SHOW_ERROR_POPUP = true;

    $scope.ELETTRICITA = 'elettricita';
    $scope.GAS = 'gas';

    $scope.simType = $scope.ELETTRICITA; // 'elettricita' o 'gas'
    $scope.contatoreTypeFilter = undefined;

    $scope.vettore = {};

    $scope.advancedStatus = {open: false};
    $scope.advancedPriceListStatus = {open: true};

    // Parametri comuni per elettricita e gas
    $scope.params = {};
    $scope.params.contatoreType = {};
    $scope.params.contatore = {};
    $scope.params.code;
    $scope.params.year = (new Date().getFullYear()).toString();
    //$scope.params.month = sixDateLib.getMonthName(new Date().getMonth());
    $scope.params.month = 'Gennaio';
    $scope.params.algorithmType = {};
    $scope.params.fornitore = {};

    resetParams();

    $scope.ee_columnDefs = [
      {name: 'Data', field: 'date', type: 'date', sort: {direction: 'asc'}, cellFilter: 'date: "MMMM-yyyy"', minWidth: 100},
      {name: 'PE M', field: 'pem', cellFilter: 'number: 4', minWidth: 100},
      {name: 'PE F1', field: 'pef1', cellFilter: 'number: 4', minWidth: 100},
      {name: 'PE F2', field: 'pef2', cellFilter: 'number: 4', minWidth: 100},
      {name: 'PE F3', field: 'pef3', cellFilter: 'number: 4', minWidth: 100},
      {name: 'PE F23', field: 'pef23', cellFilter: 'number: 4', minWidth: 100},
      {name: 'Tot. servizi rete', field: 'tot_rete', cellFilter: 'number: 4', minWidth: 100},
      {name: 'Tot. oneri', field: 'tot_oneri', cellFilter: 'number: 4', minWidth: 100},
      {name: 'Tot. accise', field: 'tot_accise', cellFilter: 'number: 4', minWidth: 100},
      {name: 'Tot. Monorario', field: 'tot_monorario', cellFilter: 'number: 4', minWidth: 100},
      {name: 'Tot. F1', field: 'tot_f1', cellFilter: 'number: 4', minWidth: 100},
      {name: 'Tot. F2', field: 'tot_f2', cellFilter: 'number: 4', minWidth: 100},
      {name: 'Tot. F3', field: 'tot_f3', cellFilter: 'number: 4', minWidth: 100},
      {name: 'Tot. F23', field: 'tot_f23', cellFilter: 'number: 4', minWidth: 100}
    ];

    $scope.gas_columnDefs = [
      {name: 'Data', field: 'date', type: 'date', sort: {direction: 'asc'}, cellFilter: 'date: "MMMM-yyyy"', minWidth: 100},
      {name: 'CCI periodo', field: 'cci', minWidth: 100},
      {name: 'CCI t', field: 'cci_t', cellFilter: 'number: 4', minWidth: 100},
      {name: 'PFOR t (196.13)', field: 'pfor_t_19613', cellFilter: 'number: 4', minWidth: 100},
      {name: 'PFOR t (196.13, 38.10)', field: 'pfor_t_19613_3810', cellFilter: 'number: 4', minWidth: 100},
      {name: 'PCS Sim', field: 'pcs_sim', cellFilter: 'number: 4', minWidth: 100},
      {name: 'PFOR (PCS comune)', field: 'pfor_pcs_comune', cellFilter: 'number: 4', minWidth: 100},
      {name: 'Spread', field: 'spread', cellFilter: 'number: 4', minWidth: 100},
      {name: 'QTmcv', field: 'qtmcv', cellFilter: 'number: 4', minWidth: 100},
      {name: 'Tot. vendita', field: 'tot_vendita', cellFilter: 'number: 4', minWidth: 100},
      {name: 'QF', field: 'qf', cellFilter: 'number: 4', minWidth: 100},
      {name: 'TD Var', field: 'td_var', cellFilter: 'number: 4', minWidth: 100},
      {name: 'Add. regionale', field: 'add_regionale', cellFilter: 'number: 4', minWidth: 100},
      {name: 'Accisa', field: 'accisa', cellFilter: 'number: 4', minWidth: 100},
      {name: 'Tot. accise', field: 'tot_accise', cellFilter: 'number: 4', minWidth: 100},
      {name: 'Imponibile un.', field: 'imponibile_unitario', cellFilter: 'number: 4', minWidth: 100},
      {name: 'Imponibile', field: 'imponibile', cellFilter: 'number: 4', minWidth: 100},
      {name: 'IVA', field: 'iva', cellFilter: 'percentage: 2', minWidth: 100},
      {name: 'Costo finale + IVA', field: 'costo_finale_iva', cellFilter: 'currency: "€": 4', minWidth: 100}
    ];

    var paginationOptions = {
      pageNumber: 1,
      pageSize: 15
    };

    // elettricita
    $scope.tensioneList = [
      {code: '1', description: '1 kV', value: 1},
      {code: '35', description: '35 kV', value: 35},
      {code: '150', description: '150 kV', value: 150},
      {code: '220', description: '220 kV', value: 220},
      {code: '380', description: '380 kV', value: 380}
    ];

    // Gas
    $scope.deliberaEEGList = [
      {code: 'arg_gas_64_09', description: 'ARG/gas 64/09'},
      {code: 'arg_gas_77_11', description: 'ARG/gas 77/11'},
      {code: 'arg_gas_117_12', description: 'ARG/gas 117/12'},
      {code: 'arg_gas_385_12', description: 'ARG/gas 385/12'},
      {code: 'arg_gas_196_13', description: 'ARG/gas 196/13'},
      {code: 'cond_tutela', description: 'Condizioni di tutela'}
    ];

    $scope.pcsSimTypeList = [
      {code: 'pcs_comune', description: 'PCS Comune'},
      {code: 'pcs_std', description: $scope.params.pcs_std}
    ];

    $scope.algorithmTypes = [
      {code: 'fisso'},
      {code: 'monomia'},
      {code: 'binomia'}
    ];

    $scope.pcsStdList = [ Number('38.100'), Number('38.52')];

    $scope.pcsList = [ Number('38.100'), Number('38.52')];


    // Grid
    $scope.listGridOptions = {
      paginationPageSizes: [10, 20, 30],
      paginationPageSize: 10,
      useExternalPagination: false,
      enableHorizontalScrollbar: true,
      columnDefs: [
        {displayName: '', field: 'model.code', enableFiltering: false, width: 34, cellTemplate: '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ng-click="grid.appScope.load(row.entity.version)"><i class="fa fa-search"></i></button></div>'},
        {displayName: 'Codice', field: 'model.code'},
        {displayName: '', field: 'model.code', width: 40, cellTemplate: '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-danger" ng-click="grid.appScope.deleteWithDialog(row.entity.version)" ng-disabled="grid.appScope.isDeletePermAllowed()===false"><i class="fa fa-trash"></i></button></div>' },
      ]
    };

    $scope.gridOptions = {
      paginationPageSizes: [10, 20, 30],
      paginationPageSize: 20,
      useExternalPagination: false,
      enableHorizontalScrollbar: true
    };

    // Grid
    $scope.priceListGridOptions = {
      paginationPageSizes: [10, 15, 20, 30],
      paginationPageSize: 15,
      useExternalPagination: true,
      enableHorizontalScrollbar: true,
      columnDefs: [
        {displayName: '', field: 'model.code', enableFiltering: false, width: 34, cellTemplate: '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ng-click="grid.appScope.loadPriceList(row.entity.UUID)"><i class="fa fa-search"></i></button></div>'},
        {displayName: 'Codice', field: 'model.code'},
        {displayName: 'Descrizione', field: 'model.description'},
        {displayName: 'Fornitore', field: 'model.fornitore_id.description'},
        {displayName: 'Vettore', field: 'model.vettore_id.description'}
      ],
      data: 'pricelist.list',
      onRegisterApi: function(gridApi) {
        $scope.listGridApi = gridApi;
        gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
          paginationOptions.pageNumber = newPage;
          paginationOptions.pageSize = pageSize;
          $scope.updatePriceListPagination();
        });
      }
    };

    $scope.simulate = function() {
      if(checkRequiredParams() === true) {
        var params = {};

        if($scope.simType === $scope.ELETTRICITA) {
          params.date = new Date($scope.params.year, sixDateLib.getMonthIndex($scope.params.month), 1);
          params.utenza = $scope.params.utenza.id;
          params.regime_fiscale = $scope.params.regimeFiscale.id;
          params.tensione = $scope.params.tensione.selected.value;
          params.livello_tensione = $scope.params.livelloTensione;
          params.potenza_impegnata = $scope.params.potenzaImpegnata;
          params.potenza_disponibile = $scope.params.potenzaDisponibile;
          params.tiv = $scope.params.tiv;
          params.tit = $scope.params.tit;
          params.perdite = $scope.params.perdite;
          params.comune = $scope.params.comune.id;
          params.provincia = $scope.params.provincia.id;
          params.regione = $scope.params.regione.id;
          params.potenza_max = $scope.params.potenzaMax;
          params.consumptions = $scope.params.consumptions;
          params.spread = $scope.params.spread;
        } else if($scope.simType === $scope.GAS) {
          params.date = new Date($scope.params.year, sixDateLib.getMonthIndex($scope.params.month), 1);
          params.regime_fiscale = $scope.params.regimeFiscale.id;
          params.comune = $scope.params.comune.id;
          params.provincia = $scope.params.provincia.id;
          params.regione = $scope.params.regione.id;
          params.ambito_tariffario = $scope.params.ambitoTariffario.id;
          params.tipologia_cliente = $scope.params.tipologiaCliente.id;
          params.delibera_aeeg = $scope.params.deliberaAEEG.code;
          params.spread = $scope.params.spread;
          params.tf = $scope.params.tf;
          params.pcs_std = parseFloat($scope.params.pcsStd);
          params.pcs_sim = parseFloat($scope.params.pcsSim);
          params.classe_misuratore = $scope.params.classeMisuratore;
          params.consumptions = $scope.params.consumptions;
          params.tipo_algoritmo = $scope.params.algorithmType.code;
          params.fornitore = $scope.params.fornitore.id;
          params.fisso = $scope.params.fisso;
        }

        $scope.gridOptions.data = [];

        if($scope.simType === $scope.ELETTRICITA) {
          $scope.gridOptions.columnDefs = $scope.ee_columnDefs;
        } else if($scope.simType === $scope.GAS) {
          $scope.gridOptions.columnDefs = $scope.gas_columnDefs;
        }

        simulationFactory.simulate({param1: $scope.simType}, params).$promise.then(function (resp) {
          if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
            console.log(resp);
            for (var d in resp.list) {
              var r = angular.copy(resp.list[d]);
              r.date = new Date(d);
              $scope.gridOptions.data.push(r);
            }
          } else {
            toaster.pop('error', 'Errore', 'Impossibile completare la simulazione');
          }
        });
      }
    };

    function checkRequiredParams() {
      if($scope.simType === $scope.ELETTRICITA) {
        var error = getErrorMessage(['params.year', 'params.month', 'params.tiv', 'params.tit', 'params.comune.id', 'params.potenzaMax']);
        if(angular.isUndefined(error)) {
          return true;
        }
        toaster.pop('error', 'Errore', error);
        return false;
      } else if($scope.simType === $scope.GAS) {
        var error = getErrorMessage(['params.year', 'params.month', 'params.tipologiaCliente.id', 'params.comune.id', 'params.deliberaAEEG.code']);
        if(angular.isUndefined(error)) {
          return true;
        }
        toaster.pop('error', 'Errore', error);
        return false;
      }
      toaster.pop('error', 'Errore', 'Tipo simulazione non riconosciuto: ' + $scope.simType);
      return false;
    }

    function getErrorMessage(params) {
      var msg = undefined;
      var sep = '';
      for (var i in params) {
        var v = getDescendantProp($scope, params[i]);
        $log.log(params[i] + ' -> ' + v);
        if(angular.isUndefined(v)) {
          if(angular.isUndefined(msg)) {
            msg = '';
          }
          msg += sep + params[i];
          sep = ', ';
        }
      }
      if(angular.isDefined(msg)) {
        msg += ' non definiti';
      }
      return msg;
    }

    function getDescendantProp(obj, desc) {
      var arr = desc.split(".");
      while(arr.length && (obj = obj[arr.shift()]));
      return obj;
    }




    /********************/
    /***** WATCHERS *****/
    /********************/

    $scope.$watch(function() {return $scope.params.comune.obj;}, function(newVal, oldVal) {
      if(newVal && $scope.params.comune.obj && $scope.params.comune.obj.model && $scope.params.comune.obj.model.provincia_id) {
        recordFactory('provincia').byUUID({id: $scope.params.comune.obj.model.provincia_id.UUID}).$promise.then(function(resp) {
          if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
            $scope.params.provincia.id = sixObjectLib.recordToHisRef(resp);
          } else {
            toaster.pop('error', 'Errore', 'Impossibile recuperare la provincia ' + $scope.params.comune.obj.model.regione_id.UUID);
            $scope.params.provincia.id = {};
          }
        });
      } else {
        $scope.params.provincia.id = {};
      }
    });

    $scope.$watch(function() {return $scope.params.provincia.obj;}, function(newVal, oldVal) {
      if(newVal && $scope.params.provincia.obj && $scope.params.provincia.obj.model && $scope.params.provincia.obj.model.regione_id) {
        recordFactory('regione').byUUID({id: $scope.params.provincia.obj.model.regione_id.UUID}).$promise.then(function(resp) {
          if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
            $scope.params.regione.id = sixObjectLib.recordToHisRef(resp);
          } else {
            toaster.pop('error', 'Errore', 'Impossibile recuperare la regione ' + $scope.comune.obj.regione_id.UUID);
            $scope.params.regione.id = {};
          }
        });
      } else {
        $scope.params.regione.id = {};
      }
    });

    $scope.$watch(function() {return $scope.params.regione.obj;}, function(newVal, oldVal) {
      if(newVal && $scope.params.regione.obj && $scope.params.regione.obj.model && $scope.params.regione.obj.model.ambito_id) {
        recordFactory('ambitotariffario').byUUID({id: $scope.params.regione.obj.model.ambito_id.UUID}).$promise.then(function(resp) {
          if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
            $scope.params.ambitoTariffario.id = sixObjectLib.recordToHisRef(resp);
          } else {
            toaster.pop('error', 'Errore', 'Impossibile recuperare l\'ambito tariffario ' + $scope.params.regione.obj.model.ambito_id.UUID);
            $scope.params.ambitoTariffario.id = {};
          }
        });
      } else {
        $scope.params.ambitoTariffario.id = {};
      }
    });

    $scope.$watch(function() {return $scope.params.tensione.selected;}, function(newVal, oldVal) {
      if(newVal && $scope.params.tensione.selected && $scope.params.tensione.selected.value) {
        voltageClassFactory.show({id: $scope.params.tensione.selected.value}).$promise.then(function(resp) {
          if (errorService.handleError(resp)) {
            $scope.params.livelloTensione.id = sixObjectLib.recordToHisRef(resp);
          } else {
            toaster.pop('error', 'Errore', 'Impossibile recuperare il livello di tensione per ' + $scope.tensione.selected.description);
            $scope.params.livelloTensione.id = {};
          }
        });
      } else {
        $scope.params.livelloTensione.id = {};
      }

    });

    $scope.$watch(function() {return $scope.params.utenza.obj;}, function(newVal, oldVal) {
      if($scope.simType === $scope.ELETTRICITA) {
        if (newVal && $scope.params.utenza.obj && $scope.params.utenza.obj.model && $scope.params.utenza.obj.model.regimefiscale_id) {
          recordFactory('regimefiscale').byUUID({id: $scope.params.utenza.obj.model.regimefiscale_id.UUID}).$promise.then(function (resp) {
            if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
              $scope.params.regimeFiscale.id = sixObjectLib.recordToHisRef(resp);
            } else {
              toaster.pop('error', 'Errore', 'Impossibile recuperare il regime fiscale per l\'utenza ' + $scope.params.utenza.id.code);
              $scope.params.regimeFiscale.id = {};
            }
          });
        } else {
          $scope.params.regimeFiscale.id = {};
        }
      }
    });

    $scope.$watchGroup(['params.utenza.id.UUID', 'params.livelloTensione.id.UUID',
      'params.potenzaImpegnata', 'params.potenzaDisponibile'],
      function(newVal, oldVal) {
        resetContractData();
        if(newVal) {
          updateContract();
        }
    });

    $scope.$watchGroup(['params.livelloTensione.id', 'params.year', 'params.month'],
      function(newVal, oldVal) {
        if(newVal && $scope.params.livelloTensione.id && $scope.params.tensione.selected && $scope.params.year && $scope.params.month) {
          var dateStr = $scope.params.year+'-'+('0' + (sixDateLib.getMonthIndex($scope.params.month)+1)).slice(-2)+'-01';
          var query = { tensione: $scope.params.tensione.selected.value };
          query['tipo_utenza_id.UUID'] = $scope.params.livelloTensione.id.UUID;
          listComponentFactory('perdite').perdite({date: dateStr}, query).$promise.then(function(resp) {
            if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
              if(resp.model) {
                $scope.params.perdite = resp.model.fattore;
              } else {
                toaster.pop('error', 'Errore', 'Impossibile recuperare le perdite per: utenza ' + $scope.params.livelloTensione.id.code
                  + ', tensione ' + $scope.params.tensione.selected.value + ', anno ' + $scope.params.year + ', mese ' + $scope.params.month);
                $scope.params.perdite = undefined;
              }
            } else {
              toaster.pop('error', 'Errore', 'Impossibile recuperare le perdite per: utenza ' + $scope.params.livelloTensione.id.code
                + ', tensione ' + $scope.params.tensione.selected.value + ', anno ' + $scope.params.year + ', mese ' + $scope.params.month);
              $scope.params.perdite = undefined;
            }
          });
        } else {
          $scope.params.perdite = undefined;
        }
    });

    $scope.$watch(function() {return $scope.simType;}, function(newVal, oldVal) {
      if(newVal) {
        $location.path('/pricelist/sim/' + $scope.simType);
      }
    });

    $scope.$watchGroup(['params.d', 'params.cg', 'params.ambitoTariffario.id.UUID'], function(newVal, oldVal) {
      if(newVal) {
        var cg = parseFloat($scope.params.cg);
        var d = parseFloat($scope.params.d);
        if(isFinite(cg) && isFinite(d) && $scope.params.ambitoTariffario.id && $scope.params.ambitoTariffario.id.UUID) {
          var params = {};
          params.date = new Date($scope.params.year, sixDateLib.getMonthIndex($scope.params.month), 1);
          params.cg = cg;
          params.d = d;
          params.ambito_tariffario = $scope.params.ambitoTariffario.id;

          simulationFactory.binomia(params).$promise.then(function(resp) {
            if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
              $scope.params.tf = parseFloat(resp.tf.toFixed(6));
            } else {
              toaster.pop('error', 'Errore', 'Impossibile simulare TF: ambito tariffario = ' + $scope.params.ambitoTariffario.id.code
                + ', Cg = ' + cg + ', D = ' + d + ', anno = ' + $scope.params.year);
              $scope.params.tf = undefined;
            }
          });
        } else {
          $scope.params.tf = undefined;
        }
      }
    });

    // spread
    $scope.$watchGroup(['params.fornitore.id.UUID', 'params.algorithmType', 'params.month', 'params.comune.id.UUID'], function(newVal, oldVal) {
      if(newVal && $scope.params.fornitore.id && $scope.params.algorithmType && $scope.params.comune.id) {
        var date = new Date($scope.params.year, sixDateLib.getMonthIndex($scope.params.month), 1);
        var dateStr = $filter('date')(date, 'yyyy-MM-dd');
        simulationFactory.spread({param2: $scope.simType,
            param3: dateStr,
            param4: $scope.params.algorithmType.code,
            param5: $scope.params.fornitore.id.UUID,
            param6: $scope.params.comune.id.UUID}).query().$promise.then(function(resp) {

              if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
                $scope.params.spread = resp.spread;
                $scope.params.fisso = resp.fisso;
              } else {
                toaster.pop('error', 'Errore', 'Impossibile recuperare il parametro spread per tipo = ' + $scope.simType
                    + ', data = ' + dateStr + ' contratto = ' + $scope.params.algorithmType.code
                    + ', fornitore = ' + $scope.params.fornitore.id.code + ', comune = ' + $scope.params.comune.id.code);
              }
        });
      }
    });

    $scope.$watchGroup(['params.contatore.id.UUID', 'params.year', 'params.month'], function(newVal, oldVal) {
      if(newVal && $scope.params.contatore.id && $scope.params.contatore.id.UUID) {
        resetParams();
        var date = new Date($scope.params.year, sixDateLib.getMonthIndex($scope.params.month), 1);
        simulationFactory.params({
          param1: $scope.simType,
          param2: $scope.params.contatoreType.id.UUID,
          param3: $scope.params.contatore.id.UUID,
          date: date}).$promise.then(function(resp) {
            if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
              $scope.params.comune.id = resp.comune;
              $scope.params.regimeFiscale.id = resp.regime_fiscale;
              //$scope.params.consumptions = resp.consumptions;
              for(var i in resp.consumptions) {
                $scope.params.consumptions[i] = parseFloat(resp.consumptions[i].toFixed(4));
              }
              if($scope.simType === $scope.ELETTRICITA) {
                $scope.params.utenza.id = resp.utenza;
                $scope.params.potenzaMax = resp.potenza_max;
                $scope.params.potenzaImpegnata = resp.potenza_impegnata;
                $scope.params.potenzaDisponibile = resp.potenza_disponibile;
                $scope.params.tensione.selected = {
                  code: resp.tensione,
                  description: resp.tensione + ' kWh',
                  value: parseFloat(resp.tensione)
                };
              }
              else if($scope.simType === $scope.GAS) {
                $scope.params.pcsSim = resp.pcs_sim;
                $scope.params.tipologiaCliente.id = resp.tipologia_cliente;
                $scope.params.cg = resp.cg;
                $scope.params.d = resp.d;
                $scope.params.classeMisuratore = resp.classe_misuratore;
              }
            } else {
              toaster.pop('error', 'Errore', 'Impossibile recuperare i parametri per ' + $scope.params.contatoreType.id.code + ' ' + $scope.params.contatore.id.code);
            }
        }, function(err) {
          $log.error('ERROR - ' + err);
        });
      }
    });

    $scope.$watch(function() {return $scope.vettore.id;}, function(newVal, oldVal) {
      if(newVal) {
        updateContatoreTypeFilter();
      }
    });


    function updateContract() {
      if($scope.params.utenza.id && $scope.params.utenza.id.UUID
        && $scope.params.livelloTensione.id && $scope.params.livelloTensione.id.UUID
        && $scope.params.potenzaImpegnata && $scope.params.potenzaDisponibile) {

        var query = {
          utenza: $scope.params.utenza.id.UUID,
          livello_tensione: $scope.params.livelloTensione.id.UUID,
          pot_impegnata: $scope.params.potenzaImpegnata,
          pot_disponibile: $scope.params.potenzaDisponibile
        };

        contractFactory.find(query).$promise.then(function (resp) {
          if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
            $scope.params.numContratto = resp.model.code;
            $scope.params.tipoContratto = resp.model.description;
            $scope.params.tiv = resp.model.tiv;
            $scope.params.tit = resp.model.tit;
          } else {
            toaster.pop('error', 'Errore', 'Impossibile recuperare il contratto per: utenza ' + $scope.params.utenza.id.code
              + ', tensione ' + $scope.params.livelloTensione.id.description
              + ', pot. impegnata ' + $scope.params.potenzaImpegnata
              + ', pot. disponibile ' + $scope.params.potenzaDisponibile);
            resetContractData();
          }
        });
      } else {
        resetContractData();
      }
    }

    function resetContractData() {
      $scope.params.numContratto = '';
      $scope.params.tipoContratto = '';
      $scope.params.tiv = '';
      $scope.params.tit = '';
    }

    $scope.simulateElettric = function(){
        $scope.simType = $scope.ELETTRICITA;
        //$log.info($scope.simType);
        //$scope.simType === $scope.ELETTRICITA
    };

    $scope.simulateGas = function(){
        //$log.info($scope.simType);
        $scope.simType = $scope.GAS;
    };

    $scope.saveOrUpdate = function() {
      $scope.form.$submitted = true;
      if ($scope.form.$valid) {
        var toSave = angular.copy($scope.params);
        delete toSave.comune.obj;
        delete toSave.provincia.obj;
        delete toSave.regione.obj;
        delete toSave.utenza.obj;
        delete toSave.regimeFiscale.obj;
        simulationFactory.save({id: $scope.simType}, $scope.params).$promise.then(function (resp) {
          if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
            toaster.pop('success', 'Salvataggio', 'Salvataggio eseguito con successo');
            $scope.loadList();
          }
          else {
            toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
          }
        });
      } else {
        toaster.pop('error', 'Errore', 'Codice non specificato');
      }
    };

    $scope.loadList = function() {
      simulationFactory.list({param1: $scope.simType}).$promise.then(function (resp) {
        if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
          $scope.listGridOptions.data = resp.list;
        }
        else {
          toaster.pop('error', 'Errore', 'Errore durante il caricamento');
        }
      });
    };

    $scope.load = function(itemId) {
      resetParams();
      $scope.params.contatore = {};
      $scope.params.contatoreType = {};
      simulationFactory.get({param1: $scope.simType, param2: itemId}).$promise.then(function (resp) {
        if (errorService.handleError(resp, SHOW_ERROR_POPUP) && resp.model) {
          $scope.params = resp.model;
        }
        else {
          toaster.pop('error', 'Errore', 'Errore durante il caricamento');
        }
      });
    };

    $scope.deleteWithDialog = function(itemId) {
      dialogService.confirmDialog('Eliminare la simulazione?',
        function () {
          $scope.delete(itemId);
        });
    };

    $scope.delete = function(itemId) {
      simulationFactory.delete({param1: $scope.simType, param2: itemId}).$promise.then(function (resp) {
        if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
          $scope.loadList();
        } else {
          toaster.pop('error', 'Errore', 'Errore durante l\'eliminazione');
        }
      });
    };

    function updateContatoreTypeFilter() {
      if($scope.vettore.id) {
        energyCarrierFactory.schemas({id: $scope.vettore.id.UUID}).$promise.then(function (response) {
          if (errorService.handleError(response, SHOW_ERROR_POPUP)) {
            $scope.contatoreTypeFilter = { 'model.code' : response.list.join() };
            $log.info($scope.contatoreTypeFilter);
          } else {
            toaster.pop('error', 'Errore', 'Errore durante il recupero dei modelli con vettore_id ' + $scope.vettore.id.code);
          }
        });
      }
    }


    /**********************/
    /***** Price List *****/
    /**********************/

    var getPriceListPage = function() {
      $scope.priceListGridOptions.totalItems = $scope.pricelist.totalResults;
      var firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
      $scope.priceListGridOptions.data = $scope.priceListGridOptions.data.slice(firstRow, firstRow + paginationOptions.pageSize);
    };

    $scope.updatePriceListPagination =  function () {
      $scope.priceListGridOptions.totalItems = $scope.pricelist.totalResults;
      var filter = {};
      filter['model.vettore_id.UUID'] = $scope.vettore.id.UUID;
      $scope.pricelist = priceListFactory.findAllByVector({page: paginationOptions.pageNumber, page_size: paginationOptions.pageSize}, filter);
      $scope.priceListGridOptions.data = $scope.list.list;
    };

    $scope.findPriceList = function() {
      var filter = {};
      filter['model.vettore_id.UUID'] = $scope.vettore.id.UUID;
      priceListFactory.findAllByVector(
        {page: paginationOptions.pageNumber, page_size: paginationOptions.pageSize},
        filter
      ).$promise.then(function(result) {
        $scope.pricelist = result;
        getPriceListPage();
      });
    };

    $scope.loadPriceList = function(uuid) {
      priceListFactory.byUUID({id: uuid}).$promise.then(function(response) {
        if (errorService.handleError(response, SHOW_ERROR_POPUP)) {
          $scope.params.deliberaAEEG = response.model.delibera_aeeg;
          $scope.params.pcsStd = ''+response.model.pcs_std;
          $scope.params.algorithmType = response.model.type;
          $scope.params.fornitore.id = response.model.fornitore_id;
          $log.log(response);
        } else {
          toaster.pop('error', 'Errore', 'Errore durante il recuepro dei dati');
        }
      });
    };


    /*************************/
    /********* ROUTE *********/
    /*************************/

    if($routeParams.sim_type) {
      $scope.simType = $routeParams.sim_type;
      recordFactory('vettoreenergetico').byCode({id: $scope.simType}).$promise.then(function(resp) {
        if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
          $scope.vettore.id = sixObjectLib.recordToHisRef(resp);
          $scope.findPriceList();
        } else {
          toaster.pop('error', 'Errore', 'Errore durante il recuepro dei dati');
        }
      });

      $scope.loadList();

      // FIXME cablone da togliere
      if($scope.simType === $scope.ELETTRICITA) {
        $scope.um = 'c€/kWh';

        //$scope.params.consumptions[0] = 47340.0;
        //$scope.params.consumptions[1] = 32850.0;
        //$scope.params.consumptions[2] = 30970.0;
        //$scope.params.consumptions[3] = 31080.0;
        //$scope.params.consumptions[4] = 35600.0;
        //$scope.params.consumptions[5] = 48750.0;
        //$scope.params.consumptions[6] = 54350.0;
        //$scope.params.consumptions[7] = 56290.0;
        //$scope.params.consumptions[8] = 56990.0;
        //$scope.params.consumptions[9] = 53310.0;
        //$scope.params.consumptions[10] = 54930.0;
        //$scope.params.consumptions[11] = 47540.0;
      } else if($scope.simType === $scope.GAS) {
        $scope.um = 'c€/SMC';

        //$scope.params.consumptions[0] = 83333.0;
        //$scope.params.consumptions[1] = 83333.0;
        //$scope.params.consumptions[2] = 83333.0;
        //$scope.params.consumptions[3] = 83333.0;
        //$scope.params.consumptions[4] = 83333.0;
        //$scope.params.consumptions[5] = 83333.0;
        //$scope.params.consumptions[6] = 83333.0;
        //$scope.params.consumptions[7] = 83333.0;
        //$scope.params.consumptions[8] = 83333.0;
        //$scope.params.consumptions[9] = 83333.0;
        //$scope.params.consumptions[10] = 83333.0;
        //$scope.params.consumptions[11] = 83333.0;
        //
        //$scope.params.month = 'Gennaio';
        //$scope.params.comune = {id: {type: 'comune', UUID: '035016', code: '035016'}, obj: {}};
        //$scope.params.tipologiaCliente = {id: {type: 'tipologiacliente', UUID: 'AVFJZnxvTmDQzQRR_-mW', code: 'altri_servizi'}, obj: {}};
        //$scope.params.regimeFiscale = {id: {type: 'regimefiscale', UUID: 'AVGHSam4pkq3TGYMNmCu', code: 'uso_industriale_agevolato'}, obj: {}};
        //$scope.params.deliberaAEEG = {code: 'arg_gas_196_13', description: 'ARG/gas 196/13'};
        //$scope.params.spread = 4.3;
        //$scope.params.tf = 0.0;
        //$scope.params.pcsSim = 39.370;
        //$scope.params.pcsSimType = {code: 'pcs_comune', description: 'PCS Comune'};
      }
    }


    /*************************/
    /********* UTILS *********/
    /*************************/

    function resetParams() {
      // Parametri comuni per elettricita e gas
      $scope.params.comune = {};
      $scope.params.provincia = {};
      $scope.params.regione = {};

      // Parametri elettricita
      $scope.params.utenza = {};  // readonly
      $scope.params.regimeFiscale = {};  // readonly
      $scope.params.tensione = {selected: undefined};
      $scope.params.livelloTensione = {};  // readonly
      $scope.params.potenzaImpegnata = undefined;
      $scope.params.potenzaDisponibile = undefined;
      $scope.params.numContratto = undefined;  // readonly
      $scope.params.tipoContratto = undefined;  // readonly
      $scope.params.tiv = undefined;  // readonly
      $scope.params.tit = undefined;  // readonly
      $scope.params.perdite = undefined;
      $scope.params.potenzaMax = undefined;
      $scope.params.potenzaImpegnataClass = undefined;
      $scope.params.potenzaDisponibileClass = undefined;
      $scope.params.consumptions = [];
      $scope.params.spread = undefined;

      // Parametri gas
      $scope.params.ambitoTariffario = {};
      $scope.params.tipologiaCliente = {};
      $scope.params.regimeFiscale = {};
      $scope.params.deliberaAEEG = {code: 'arg_gas_196_13', description: 'ARG/gas 196/13'};
      $scope.params.spread = undefined;
      $scope.params.fisso = undefined;
      $scope.params.tf = undefined;
      $scope.params.pcsStd = Number('38.100');
      $scope.params.pcsSim = undefined;
      $scope.params.cg = undefined;
      $scope.params.d = undefined;
      $scope.params.classeMisuratore = undefined;
      $scope.params.consumptions = [];
    }

    $scope.getMonths = function() {
      return [0,1,2,3,4,5,6,7,8,9,10,11];
    };

    $scope.getMonthName = function(monthIndex) {
      return sixDateLib.getMonthShortName(monthIndex);
    };

    $scope.onPcsStdSelect = function(selected) {
      var n = parseFloat(selected);
      if(!isFinite(n)) {
        return '';
      }
      $scope.pcsList = [selected];
      return selected;
    };

    $scope.onPcsSelect = function(selected) {
      var n = parseFloat(selected);
      if(!isFinite(n)) {
        return '';
      }
      return selected;
    };

    $scope.tagTransform = function(tag) {
      return ''+tag;
    };


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'list/simulation';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };
  });

angular.module('emma.energy').filter('percentage', function ($log, $filter) {
  return function (value, decimalPosition, scope) {
    return $filter('currency')(value*100, '%', decimalPosition);
  };
});

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ReadtemplateCtrl
 * @description
 * # ReadtemplateCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/consumptive/readtemplate', {
        templateUrl: 'energy/readtemplate/readtemplate.html',
        controller: 'ReadtemplateCtrl'
      })
  })
  .controller('ReadtemplateCtrl', function ($scope, schemaFactory, recordFactory, dialogService, toaster, uiGridExporterService, uiGridExporterConstants, authFactory) {

    $scope.year = new Date().getFullYear().toString();
    $scope.month = sixDateLib.getMonthName(new Date().getMonth());
    $scope.info = authFactory.getAuthData().info;

    $scope.entity = {};
    $scope.data = [];
    $scope.dataExport = [];
    $scope.limit = 10000;
    $scope.referencesExcluded = true;
    $scope.gridOptions = {
      columnDefs:[
        {
          name: 'Tipo contatore',
          field:'tipo_contatore',
          type: 'string'
        },
        {
          name: 'Codice',
          field: 'code',
          type: 'string'
        },
        {
          name: 'Descrizione',
          field: 'description',
          type: 'string'
        },
        {
          name: 'Data lettura',
          field:'data_lettura',
          type: 'string'
        },
        {
          name: 'UM',
          field: 'um_letture_id',
          type: 'string'
        }
      ],
      multiSelect: true,
      enableGridMenu: true,
      exporterMenuPdf: false,
      exporterCsvColumnSeparator: ';',
      exporterHeaderFilter: function( displayName ) {
        var header = displayName.toLowerCase();
        header = header.replace(/ /g, '_');
        return header;
      },
      data: 'data',
      onRegisterApi: function(gridApi){
        $scope.gridApi = gridApi;
      }
    };

    $scope.exportGridOptions = {
      columnDefs:[
        {
          name: 'Tipo contatore',
          field:'tipo_contatore',
          type: 'string'
        },
        {
          name: 'Codice',
          field: 'code',
          type: 'string'
        },
        {
          name: 'Descrizione',
          field: 'description',
          type: 'string'
        },
        {
          name: 'Data lettura',
          field:'data_lettura',
          type: 'string'
        },
        {
          name: 'UM',
          field: 'um_letture_id',
          type: 'string'
        }
      ],
      enableRowHeaderSelection: false,
      enableRowSelection: false,
      enableGridMenu: true,
      exporterMenuPdf: false,
      exporterCsvColumnSeparator: ';',
      exporterHeaderFilter: function( displayName ) {
        var header = displayName.toLowerCase();
        header = header.replace(/ /g, '_');
        return header;
      },
      data: 'dataExport',
      onRegisterApi: function(gridApiExport){
        $scope.gridApiExport = gridApiExport;
      }
    };


    $scope.addToExportGridOptions = function(){
      if(angular.isUndefined($scope.typeExported)){
        /* imposto il tipo di contatore che verrà esportato, viene fatto la prima volta */
        $scope.typeExported = $scope.entity.type.code;
      }
      /* se non è la prima importazione */
      if($scope.typeExported == $scope.entity.type.code){
        /* sono le righe da prendere e da copiare nella seconda tabella */
        var selectedRows = $scope.gridApi.selection.getSelectedRows();
        for(var i = 0; i < selectedRows.length; i++){
          var isPresent = false;
          for(var j = 0; j < $scope.dataExport.length; j++){
            if(selectedRows[i].tipo_contatore == $scope.dataExport[j].tipo_contatore
              && selectedRows[i].code == $scope.dataExport[j].code){
              isPresent  = true;
            }
          }
          if(!isPresent){
            $scope.dataExport.push(selectedRows[i]);
          }
          $scope.data.forEach(function (item, index) {
            if (selectedRows[i].tipo_contatore == item.tipo_contatore
              && selectedRows[i].code == item.code) {
              $scope.data.splice(index, 1);
            }
          });
        }
      }
    };

    $scope.clearGridOptions = function(){
      $scope.data = [];
    };

    $scope.clearExportGridOptions = function(){
      $scope.dataExport = [];
    };

    $scope.$watchGroup(['entity.type', 'referencesExcluded', 'limit'],
      function( newValue, oldValue ) {
        var modelsCont = ['contatoreelettricita', 'contatoregas', 'contatoreacqua',
          'serbatoiopressioneatmosferica', 'serbatoioinpressione', 'contatoreteleriscaldamento', 'contatoreteleraffreddamento'];

        if(angular.isDefined($scope.entity.type)){
          if(modelsCont.indexOf($scope.entity.type.code)!= -1){
            /* codice eseguito solamente se si seleziona uno dei contatori */
            if(angular.isDefined(newValue) && newValue != oldValue) {
              $scope.data = [];
              var schema;
              var typeName = $scope.entity.type.UUID;
              dialogService.showLoadingMessage('Esportazione...');
              if($scope.referencesExcluded === true) {
                schema = schemaFactory().byCode({id: typeName});
              }
              recordFactory(typeName).query({page_size: $scope.limit, show_revision: false}).$promise.then(function (data) {
                var ErrorListCodes = '';
                data.list.forEach(function (value) {
                  var row  = {};
                  var lastDay = new Date($scope.year, sixDateLib.getMonthIndex($scope.month) + 1, 0);
                  row.tipo_contatore = $scope.entity.type.description;
                  row.code = value.model.code;
                  row.description = value.model.description;
                  if(angular.isDefined(value.model.um_letture_id)){
                    row.um_letture_id = value.model.um_letture_id.code;
                  }else{
                    if(ErrorListCodes.length == 0){
                      ErrorListCodes = value.model.code;
                    }else{
                      ErrorListCodes = ErrorListCodes+', '+value.model.code;
                    }
                  }
                  row.data_lettura = formatDate(lastDay);
                  $scope.data.push(row);
                });
                if(ErrorListCodes.length != 0){
                  toaster.pop('error', 'Errore', 'Errore durante il caricamento UM dei contatori con codice: '+ErrorListCodes);
                }
                dialogService.stopLoading();
              });
            }
          }
        }
    });


    $scope.$watchGroup(['month', 'year'], function(newValue, oldValue){
      if(angular.isDefined(newValue) && angular.isDefined(oldValue)){
        if(newValue != oldValue){
          refreshDate($scope.data);
          refreshDate($scope.dataExport);
        }
      }
    });

    function refreshDate(array){
      var lastDay = new Date($scope.year, sixDateLib.getMonthIndex($scope.month) + 1, 0);
      for(var i = 0; i < array.length; i++){
        if(array[i].data_lettura){
          array[i].data_lettura = formatDate(lastDay);
        }
      }
    }

    function formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('-');
    }

    $scope.exportXLSX = function () {
      dialogService.showLoadingMessage('Esportazione...');
      var data = [
        [] // header row
      ];
      var rows = uiGridExporterService.getData($scope.gridApiExport.grid, uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE);
      var columns = [];
      var sheet = {};
      var i = 0;

      var endLoc;
      if($scope.typeExported) {
        switch($scope.typeExported) {

          case 'contatoreelettricita':
            columns.push({name: 'pod'});
            columns.push({name: 'data'});
            columns.push({name: 'f0'});
            columns.push({name: 'f1'});
            columns.push({name: 'f2'});
            columns.push({name: 'f3'});
            columns.push({name: 'um'});
            columns.forEach(function (col) {
              var loc = XLSX.utils.encode_cell({r: 0, c: i});
              sheet[loc] = {
                v: col.name,
                t: 's'
              };
              i += 1;
            });
            rows.forEach(function (row, ri) {
              ri +=1;
              for( var ci = 0; ci < columns.length; ci++){
                var loc = XLSX.utils.encode_cell({r: ri, c: ci});
                if(angular.isDefined(row[ci])) {
                  if(ci == 0){
                    sheet[loc] = {
                      v: row[1].value,
                      t: 's'
                    };
                  }else if(ci == 1){
                    sheet[loc] = {
                      v: row[3].value,
                      t: 's'
                    };
                  }else if(ci == 2){
                    sheet[loc] = {
                      v: '',
                      t: 'n'
                    };
                  }else if(ci == 3){
                    sheet[loc] = {
                      v: '',
                      t: 'n'
                    };
                  }else if(ci == 4){
                    sheet[loc] = {
                      v: '',
                      t: 'n'
                    };
                  }else if(ci == 5){
                    sheet[loc] = {
                      v: '',
                      t: 'n'
                    };
                  }else if(ci == 6){
                    sheet[loc] = {
                      v: row[4].value,
                      t: 's'
                    };
                  }
                }
                endLoc = loc;
              }
            });
            break;

          case 'contatoregas':
            columns.push({name: 'pdr'});
            columns.push({name: 'data'});
            columns.push({name: 'lettura'});
            columns.push({name: 'correttore'});
            columns.push({name: 'um'});
            columns.forEach(function (col) {
              var loc = XLSX.utils.encode_cell({r: 0, c: i});
              sheet[loc] = {
                v: col.name,
                t: 's'
              };
              i += 1;
            });
            rows.forEach(function (row, ri) {
              ri +=1;
              for( var ci = 0; ci < columns.length; ci++){
                var loc = XLSX.utils.encode_cell({r: ri, c: ci});
                if(angular.isDefined(row[ci])) {
                  if(ci == 0){
                    sheet[loc] = {
                      v: row[1].value,
                      t: 's'
                    };
                  }else if(ci == 1){
                    sheet[loc] = {
                      v: row[3].value,
                      t: 's'
                    };
                  }else if(ci == 2){
                    sheet[loc] = {
                      v: '',
                      t: 'n'
                    };
                  }else if(ci == 3){
                    sheet[loc] = {
                      v: '',
                      t: 'n'
                    };
                  }else if(ci == 4){
                    sheet[loc] = {
                      v: row[4].value,
                      t: 's'
                    };
                  }
                }
                endLoc = loc;
              }
            });
            break;

          case 'contatoreacqua':
            columns.push({name: 'matricola'});
            columns.push({name: 'data'});
            columns.push({name: 'lettura'});
            columns.push({name: 'um'});
            columns.forEach(function (col) {
                var loc = XLSX.utils.encode_cell({r: 0, c: i});
                sheet[loc] = {
                  v: col.name,
                  t: 's'
                };
                i += 1;
            });
            rows.forEach(function (row, ri) {
              ri +=1;
              for( var ci = 0; ci < columns.length; ci++){
                var loc = XLSX.utils.encode_cell({r: ri, c: ci});
                if(angular.isDefined(row[ci])) {
                  if(ci == 0){
                    sheet[loc] = {
                      v: row[1].value,
                      t: 's'
                    };
                  }else if(ci == 1){
                    sheet[loc] = {
                      v: row[3].value,
                      t: 's'
                    };
                  }else if(ci == 2){
                    sheet[loc] = {
                      v: '',
                      t: 'n'
                    };
                  }else if(ci == 3){
                    sheet[loc] = {
                      v: row[4].value,
                      t: 's'
                    };
                  }
                }
                endLoc = loc;
              }
            });
            break;

          case 'serbatoiopressioneatmosferica':
            columns.push({name: 'cod'});
            columns.push({name: 'data'});
            columns.push({name: 'steccatura'});
            columns.push({name: 'scarico'});
            columns.push({name: 'um'});
            columns.forEach(function (col) {
              var loc = XLSX.utils.encode_cell({r: 0, c: i});
              sheet[loc] = {
                v: col.name,
                t: 's'
              };
              i += 1;
            });
            rows.forEach(function (row, ri) {
              ri +=1;
              for( var ci = 0; ci < columns.length; ci++){
                var loc = XLSX.utils.encode_cell({r: ri, c: ci});
                if(angular.isDefined(row[ci])) {
                  if(ci == 0){
                    sheet[loc] = {
                      v: row[1].value,
                      t: 's'
                    };
                  }else if(ci == 1){
                    sheet[loc] = {
                      v: row[3].value,
                      t: 's'
                    };
                  }else if(ci == 2){
                    sheet[loc] = {
                      v: '',
                      t: 'n'
                    };
                  }
                  else if(ci == 3){
                    sheet[loc] = {
                      v: '',
                      t: 'n'
                    };
                  }else if(ci == 4){
                    sheet[loc] = {
                      v: row[4].value,
                      t: 's'
                    };
                  }
                }
                endLoc = loc;
              }
            });
            break;

          case 'serbatoioinpressione':
            columns.push({name: 'cod'});
            columns.push({name: 'data'});
            columns.push({name: 'percentuale'});
            columns.push({name: 'scarico'});
            columns.push({name: 'um'});
            columns.forEach(function (col) {
              var loc = XLSX.utils.encode_cell({r: 0, c: i});
              sheet[loc] = {
                v: col.name,
                t: 's'
              };
              i += 1;
            });
            rows.forEach(function (row, ri) {
              ri +=1;
              for( var ci = 0; ci < columns.length; ci++){
                var loc = XLSX.utils.encode_cell({r: ri, c: ci});
                if(angular.isDefined(row[ci])) {
                  if(ci == 0){
                    sheet[loc] = {
                      v: row[1].value,
                      t: 's'
                    };
                  }else if(ci == 1){
                    sheet[loc] = {
                      v: row[3].value,
                      t: 's'
                    };
                  }else if(ci == 2){
                    sheet[loc] = {
                      v: '',
                      t: 'n'
                    };
                  }
                  else if(ci == 3){
                    sheet[loc] = {
                      v: '',
                      t: 'n'
                    };
                  }else if(ci == 4){
                    sheet[loc] = {
                      v: row[4].value,
                      t: 's'
                    };
                  }
                }
                endLoc = loc;
              }
            });
            break;

          case 'contatoreteleriscaldamento':
          case 'contatoreteleraffreddamento':
            columns.push({name: 'cod'});
            columns.push({name: 'data'});
            columns.push({name: 'lettura'});
            columns.push({name: 'um'});
            columns.forEach(function (col) {
              var loc = XLSX.utils.encode_cell({r: 0, c: i});
              sheet[loc] = {
                v: col.name,
                t: 's'
              };
              i += 1;
            });
            rows.forEach(function (row, ri) {
              ri +=1;
              for( var ci = 0; ci < columns.length; ci++){
                var loc = XLSX.utils.encode_cell({r: ri, c: ci});
                if(angular.isDefined(row[ci])) {
                  if(ci == 0){
                    sheet[loc] = {
                      v: row[1].value,
                      t: 's'
                    };
                  }else if(ci == 1){
                    sheet[loc] = {
                      v: row[3].value,
                      t: 's'
                    };
                  }else if(ci == 2){
                    sheet[loc] = {
                      v: '',
                      t: 'n'
                    };
                  }else if(ci == 3){
                    sheet[loc] = {
                      v: row[4].value,
                      t: 's'
                    };
                  }
                }
                endLoc = loc;
              }
            });
            break;

          default:
            toaster.pop('error', 'Errore', 'Tipo contatore non riconosciuto');
        }
      }
      sheet['!ref'] = XLSX.utils.encode_range({ s: 'A1', e: endLoc });
      var workbook = {
        SheetNames: ['Sheet1'],
        Sheets: {
          Sheet1: sheet
        }
      };
      var wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' };
      var wbout = XLSX.write(workbook, wopts);
      saveAs(new Blob([s2ab(wbout)], {type: ""}), "letture_"+$scope.typeExported+"_"+$scope.month.toLowerCase()+"_"+$scope.year+".xlsx");
      dialogService.stopLoading();
      $scope.dataExport = [];
      $scope.typeExported = undefined;
    };

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:UpdateregistrationnumberCtrl
 * @description
 * # UpdateregistrationnumberCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/updateregistrationnumber', {
        templateUrl: 'energy/updateregistrationnumber/updateregistrationnumber.html',
        controller: 'UpdateregistrationnumberCtrl'
      })
  })
  .controller('UpdateregistrationnumberCtrl', function ($scope, $filter, recordFactory, $route, consumptiveFactory, toaster, $log, localStorageService) {

    $scope.searchFilter = {
      year: parseInt($filter('date')(new Date(), 'yyyy'))
    };

    $scope.date = { changingDate: new Date() };

    $scope.record = {};

    $scope.updates = {};

    $scope.reads = {
      readNew: '',
      readOld: ''
    };

    $scope.availablePerspectiveCodes = [];

    $scope.matricolaDefault = '';

    $scope.getPerspective = function(uuid) {
      $scope.isCollapsed = true;
      $scope.updates.searchCode = {UUID: uuid};
      $scope.getData();
    };

    $scope.$watchGroup(['record.type_id', 'record.record_id'], function( newValue) {
      if(angular.isDefined(newValue[0]) && angular.isDefined(newValue[1])) {
        $scope.updates.type_id = $scope.record.type_id;
        $scope.updates.record_id = $scope.record.record_id;
        recordFactory($scope.record.type_id.UUID).byUUID({id: $scope.record.record_id.UUID}).$promise.then(function(data) {
          $scope.updates.contatore = data;
          if($scope.record.type_id.UUID == 'contatoregas'){ // se è un contatore del gas carico la matricola...
            $scope.matricolaDefault = data.model.matricola; // ... così da controllare le modifiche rispetto al valore iniziale, per attivare il bottone
          }
        });
      } else{
        $scope.updates = {};
      }
    });

    function pad(value, char, length) {
      return (value.toString().length < length) ? pad(char+value, char, length):value;
    }

    $scope.update = function() {
      var typeName = $scope.updates.type_id.UUID;
      var toSave = [];
      /* salvo la modifica della matricola */
      recordFactory(typeName).update({id: $scope.updates.contatore.version, history: true}, $scope.updates.contatore)
        .$promise.then(function () {
          /* gestisco la creazione della lettura da inserire */
          createReads(typeName, toSave);
          /* la carico */
          consumptiveFactory.reset(toSave).$promise.then(function () {
            $route.reload();
          });
        });
    };

    function createReads(typeName, toSave){
      var date = $scope.date.changingDate;
      var lastRead = {
        date: '',
        reads: [],
        um_id: {},
        record_id: {},
        reset: true
      };
      var newRead = {
        date: '',
        reads: [],
        um_id: {},
        record_id: {},
        first : true,
        reset: true
      };
      switch(typeName) {
        case 'contatoregas':
          /* costruisco lastRead */
          var value = {
            time_slot : 'f0',
            value: $scope.reads.readOld.lettura
          };
          if(angular.isDefined($scope.reads.readOld.correttore)){
            value.correttore = $scope.reads.readOld.correttore;
          }
          lastRead.date = createFormattedDate(date);
          lastRead.um_id = $scope.updates.contatore.model.um_letture_id;
          lastRead.record_id = angular.copy($scope.updates.record_id);
          lastRead.reads.push(value);
          /* costruisco newRead */
          var value2 = {
            time_slot : 'f0',
            value: $scope.reads.readNew.lettura
          };
          if(angular.isDefined($scope.reads.readNew.correttore)){
            value2.correttore = $scope.reads.readNew.correttore;
          }
          //date.setDate(date.getDate() + 1); // sposto la data avanti di un giorno per evitare di scrivere sullo stesso giorno...
          newRead.date = createFormattedDate(date);
          newRead.um_id = $scope.updates.contatore.model.um_letture_id;
          newRead.record_id = angular.copy($scope.updates.record_id);
          newRead.reads.push(value2);
          break;
        case 'contatoreacqua':
          /* costruisco lastRead */
          var value = {
            time_slot : 'f0',
            value: $scope.reads.readOld.lettura
          };
          lastRead.date = createFormattedDate(date);
          lastRead.um_id = $scope.updates.contatore.model.um_letture_id;
          lastRead.record_id = angular.copy($scope.updates.record_id);
          lastRead.reads.push(value);
          /* costruisco newRead */
          var value2 = {
            time_slot : 'f0',
            value: $scope.reads.readNew.lettura
          };
          //date.setDate(date.getDate() + 1); // sposto la data avanti di un giorno per evitare di scrivere sullo stesso giorno...
          newRead.date = createFormattedDate(date);
          newRead.um_id = $scope.updates.contatore.model.um_letture_id;
          newRead.record_id = angular.copy($scope.updates.record_id);
          newRead.record_id.code = $scope.updates.contatore.model.code;
          newRead.reads.push(value2);
          break;
        case 'contatoreelettricita':
          /* costruisco lastRead */
          var value = {};
          if(angular.isDefined($scope.reads.readOld.lettura.f0)){
            value.time_slot = 'f0';
            value.value = $scope.reads.readOld.lettura.f0;
            lastRead.reads.push(value);
          }
          if(angular.isDefined($scope.reads.readOld.lettura.f1)){
            value = {};
            value.time_slot = 'f1';
            value.value = $scope.reads.readOld.lettura.f1;
            lastRead.reads.push(value);
          }
          if(angular.isDefined($scope.reads.readOld.lettura.f2)){
            value = {};
            value.time_slot = 'f2';
            value.value = $scope.reads.readOld.lettura.f2;
            lastRead.reads.push(value);
          }
          if(angular.isDefined($scope.reads.readOld.lettura.f3)){
            value = {};
            value.time_slot = 'f3';
            value.value = $scope.reads.readOld.lettura.f3;
            lastRead.reads.push(value);
          }
          lastRead.date = createFormattedDate(date);
          lastRead.um_id = $scope.updates.contatore.model.um_letture_id;
          lastRead.record_id = angular.copy($scope.updates.record_id);
          /* costruisco newRead */
          var value2 = {};
          if(angular.isDefined($scope.reads.readNew.lettura.f0)){
            value2.time_slot = 'f0';
            value2.value = $scope.reads.readNew.lettura.f0;
            newRead.reads.push(value2);
          }
          if(angular.isDefined($scope.reads.readNew.lettura.f1)){
            value2 = {};
            value2.time_slot = 'f1';
            value2.value = $scope.reads.readNew.lettura.f1;
            newRead.reads.push(value2);
          }
          if(angular.isDefined($scope.reads.readNew.lettura.f2)){
            value2 = {};
            value2.time_slot = 'f2';
            value2.value = $scope.reads.readNew.lettura.f2;
            newRead.reads.push(value2);
          }
          if(angular.isDefined($scope.reads.readNew.lettura.f3)){
            value2 = {};
            value2.time_slot = 'f3';
            value2.value = $scope.reads.readNew.lettura.f3;
            newRead.reads.push(value2);
          }
          //date.setDate(date.getDate() + 1); // sposto la data avanti di un giorno per evitare di scrivere sullo stesso giorno...
          newRead.date = createFormattedDate(date);
          newRead.um_id = $scope.updates.contatore.model.um_letture_id;
          newRead.record_id = angular.copy($scope.updates.record_id);
          newRead.record_id.code = $scope.updates.contatore.model.code;
          break;
        case 'contatoreteleriscaldamento':
        case 'contatoreteleraffreddamento':
          /* costruisco lastRead */
          var value = {
            time_slot : 'f0',
            value: $scope.reads.readOld.lettura
          };
          lastRead.date = createFormattedDate(date);
          lastRead.um_id = $scope.updates.contatore.model.um_letture_id;
          lastRead.record_id = angular.copy($scope.updates.record_id);
          lastRead.reads.push(value);
          /* costruisco newRead */
          var value2 = {
            time_slot : 'f0',
            value: $scope.reads.readNew.lettura
          };
          //date.setDate(date.getDate() + 1); // sposto la data avanti di un giorno per evitare di scrivere sullo stesso giorno...
          newRead.date = createFormattedDate(date);
          newRead.um_id = $scope.updates.contatore.model.um_letture_id;
          newRead.record_id = angular.copy($scope.updates.record_id);
          newRead.record_id.code = $scope.updates.contatore.model.code;
          newRead.reads.push(value2);
          break;
        default:
          toaster.pop('error', 'Errore', 'Errore nel caricamento delle letture');
      }
      toSave.push(lastRead);
      toSave.push(newRead);
      return toSave;
    }

    function createFormattedDate(date){
      var string = date.getFullYear().toString()+'-'+pad((date.getMonth()+1).toString(), '0', 2)+'-'+pad(date.getDate().toString(), '0', 2);
      return string
    }

    $scope.allDataInserted = function(){
      /* check per controllare che siano stati riempiti i campi necessari in base al tipo di contatore */
      if($scope.updates.record_id.type == 'contatoregas'){
        /* controllo prima l'inserimento della lettura e poi la presenza dei correttori, se necessario */
        if(angular.isDefined($scope.reads.readOld.lettura) && angular.isDefined($scope.reads.readNew.lettura)){
          if($scope.updates.contatore.model.correttore == false
            || (($scope.updates.contatore.model.correttore == true && angular.isDefined($scope.reads.readOld.correttore))
                  && ($scope.updates.contatore.model.correttore == true && angular.isDefined($scope.reads.readNew.correttore)))){
            return true;
          } else {
            return false;
          }
        } else{
          return false;
        }
      } else if($scope.updates.record_id.type == 'contatoreelettricita'){
        /* controllo l'ultima lettura */
        if((angular.isDefined($scope.reads.readOld.lettura.f0)
          && angular.isDefined($scope.reads.readOld.lettura.f1)
          && angular.isDefined($scope.reads.readOld.lettura.f2)
          && angular.isDefined($scope.reads.readOld.lettura.f3))
          /* controllo anche la prima lettura */
          && (angular.isDefined($scope.reads.readNew.lettura.f0)
          && angular.isDefined($scope.reads.readNew.lettura.f1)
          && angular.isDefined($scope.reads.readNew.lettura.f2)
          && angular.isDefined($scope.reads.readNew.lettura.f3))){
          return true;
        } else{
          return false;
        }
      } else if($scope.updates.record_id.type == 'contatoreteleriscaldamento'
                || $scope.updates.record_id.type == 'contatoreteleraffreddamento'){
        /* basta controllare che siano state inserite le 2 letture */
        if(angular.isDefined($scope.reads.readOld.lettura) && angular.isDefined($scope.reads.readNew.lettura)){
          return true;
        } else{
          return false;
        }
      }
    };

    if(localStorageService.get('resetcounter.type_id') && localStorageService.get('resetcounter.record_id')) {
      $scope.record.type_id = localStorageService.get('resetcounter.type_id');
      $scope.record.record_id = localStorageService.get('resetcounter.record_id');
      localStorageService.remove('resetcounter.type_id');
      localStorageService.remove('resetcounter.record_id');
    }
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ZonatermicaCtrl
 * @description
 * # ZonatermicaCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/zonatermica/:id', {
        templateUrl: 'energy/zonatermica/zonatermica_detail.html',
        controller: 'ZonatermicaCtrl'
      })
      .when('/zonatermica', {
        templateUrl: 'energy/zonatermica/zonatermica_list.html',
        controller: 'ZonatermicaCtrl'
      })
      .when('/zonatermica/page/:number', {
        templateUrl: 'energy/zonatermica/zonatermica_list.html',
        controller: 'ZonatermicaCtrl'
      })
  })
  .controller('ZonatermicaCtrl', function ($scope, $location, $log, $window, $routeParams,
                                           $rootScope, baseFactory, schemaFactory, recordFactory, dialogService,
                                           sessionFactory, uiGridConstants, dayDegreeFactory, sixGridPaginationConstants,
                                           zonaTermicaFactory, errorService, toaster, authFactory) {

    var STABLE = 'stable', SNAP='snap';//eventualmente costanti?

    var SORT_FIELD = 'model.code';

    var saveArray; /* variabile booleana per comunicare al Backend di salvare o meno l'array delle temperature  */

    $scope.params = {
      pageNumber: 1,
      pageSize: 15,
      totalItems: 0,
      filters: {}
    };

    $scope.queryParam = '';
    $scope.uiGridFiltersQuery = '';

    $scope.showDetailView = false;

    $scope.form = {};

    $scope.model = {};

    $scope.schema = {};

    $scope.type = { list: [], totalResults: 0 };

    $scope.commissionDependent = false;

    $scope.isCollapsed = false;

    $scope.isModelDefined = true; /* al momento do per scontato che ci sia, al primo 'nuovo', faccio il controllo */

    $scope.historyMode = $routeParams.historyMode ? $routeParams.historyMode : STABLE;

    $scope.showTimeline = false;

    $scope.provincia = {
      type: {},
      model: {}
    };

    $scope.comune = {
      type: {},
      model: {}
    };

    $scope.mapProvTemp = {}; /* mappa con le temperature della provincia */

    $scope.backupArrayTemp = []; /* array di appoggio per tenere salvate le temperature in caso di modifica */

    $scope.editingMode = false;

    $scope.updateArrayTemp = false; /* variabile booleana per tenere memoria della riposta dell'utente sull'aggiornamento dell'array */

    $scope.disableModify = true;

    $scope.gridAppCallbacks = {};

    $scope.viewGridOptions = {
      enableSorting: true,
      enableGridMenu: false,
      exporterMenuPdf: false,
      enableFiltering: true,
      columnDef: [],
      enableColumnResizing: true,
      paginationPageSize: $scope.params.pageSize
    };

    var walkThruField = function (item, parts) {
      if (!angular.isArray(parts)) {
        return item[parts];
      } else if (parts.length == 1) {
        return item[parts[0]];
      } else {
        return walkThruField(item[parts[0]], parts.pop());
      }
    };

    $scope.refresh = function() {
        $scope.getType();
        // $location.path('zonatermica');
    };

    $scope.getItemField = function(item, field){
      var parts = field.split( "." ),
        property = item.model || this;
      if (angular.isUndefined(parts) || parts.length == 0) {
        return property;
      }
      return walkThruField(property, parts);
    };

    $scope.getColumns = function(){
      $scope.typeName = 'zonatermica';
      schemaFactory().byUUID({id: $scope.typeName}).$promise.then(function (data) {
        if(errorService.handleError(data)) {
          getColumnOrDefault(data);
        } else {
          toaster.pop('error', 'Errore', 'Impossibile recuperare il modello');
        }
      });
      return $scope.columnDefs;
    };

    function getColumnOrDefault(data) {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push(
        {displayName: '', field: 'id', width: 34, enableCellEdit: true, enableFiltering: false, enableSorting: false, cellTemplate:
          '<div class="ui-grid-cell-contents" style="text-align: center">' +
            '<a ng-href="#/zonatermica/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' +
              '<span class="fa fa-search"></span>' +
            '</a>' +
          '</div>'
        });
      if (angular.isUndefined(data.model.columnDefs) || data.model.columnDefs.length == 0 || data.model.columnDefs === null) {
        $scope.viewGridOptions.columnDefs.push({
          displayName: 'Codice',
          field: 'model.code',
          enableFiltering:true,
          filters:[{
            type: sixGridPaginationConstants.filterType.TEXT,
            condition: uiGridConstants.filter.CONTAINS, //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
            placeholder: ''
          }]
        });
        $scope.viewGridOptions.columnDefs.push({
          displayName: 'Descrizione',
          field: 'model.description',
          enableFiltering:true,
          filters:[{
            type: sixGridPaginationConstants.filterType.TEXT,
            condition: uiGridConstants.filter.CONTAINS,
            placeholder: ''
          }]
        });
      }else{
        data.model.columnDefs.forEach( function (arrayItem)
        {
          var filterType = sixGridPaginationConstants.filterType.TEXT;
          var cellTemplate = undefined;
          switch(data.model.schema.properties[arrayItem.field].format) {
            case 'lookup':
              filterType = sixGridPaginationConstants.filterType.SIXLOOKUP;
              cellTemplate = '<div class="ui-grid-cell ui-grid-cell-contents"><span ng-if="grid.getCellValue(row, col)">{{grid.getCellValue(row, col).code}} ({{grid.getCellValue(row, col).description}})</span></div>';
              break;
            default:
              filterType = sixGridPaginationConstants.filterType.TEXT;
              break;
          }
          var colDef = {
            displayName: data.model.schema.properties[arrayItem.field].title,
            field: 'model.'+arrayItem.field,
            enableFiltering: data.model.schema.properties[arrayItem.field].enableFiltering,
            enableSorting: data.model.schema.properties[arrayItem.field].enableSorting,
            width: data.model.schema.properties[arrayItem.field].width,
            filters:[{
              type: filterType,
              condition: uiGridConstants.filter.CONTAINS,
              placeholder: ''
            }]
          };
          if(angular.isDefined(cellTemplate)) {
            colDef.cellTemplate = cellTemplate;
          }
          $scope.viewGridOptions.columnDefs.push(colDef);
        });
      }
      if (!$scope.isStable()) {
        $scope.viewGridOptions.columnDefs.push({
          displayName: 'Timeline',
          field: 'timeline',
          width: 106,
          enableCellEdit: false,
          enableFiltering: false,
          enableSorting: false,
          cellTemplate: '<div class="ui-grid-cell-contents" style="vertical-align:middle;text-align:center;"><a ng-href="#/timeline/{{row.entity.schemaCode}}/{{row.entity.UUID}}"><button type="button" class="btn btn-xs btn-primary"><i class="fa fa-history"></i></button></a></div>'
        });
      }
      // setTimeout(function() {
      //   $scope.params.gridApi.core.refresh();
      // }, 500);
    }


    $scope.isStable = function() {
      return $scope.historyMode == STABLE;
    };


    $scope.isSnapshot = function() {
      return $scope.historyMode == SNAP;
    };


    function buildPath(){
      return 'record/'+$scope.typeName;
    }


    function buildPathForWrite(){
      return 'zonatermica/_save';
    }

    $scope.getType = function () {
      $scope.showDetailView = false;
      $scope.showTimeline = false;

      var payload = {
        page: $scope.params.pageNumber,
        page_size: $scope.params.pageSize,
        sort_fields: $scope.params.sortFields,
        sort_order: $scope.params.sortOrder,
        show_revision: false,
        solve_inherit: true,
        query: $scope.params.queryParam
      };
      zonaTermicaFactory.search(payload, $scope.params.filters).$promise.then(function(result) {
        if(errorService.handleError(result)) {
          $scope.type.list = result.list || [];
          $scope.type.totalResults = result.totalResults;
        } else {
          toaster.pop('error', 'Errore', 'Impossibile recuperare la zona termica');
        }
      });
      $scope.showTimeline = false;
      $scope.isCollapsed = false;
    };

    $scope.new = function (){
      $location.path('zonatermica/new');
    };

    $scope.back = function() {
      $location.path('zonatermica/');
    };

    function FromObjToArray(obj){
      var array = [];
      for (var i = 0; i < 12; i++) {
        if (!angular.isUndefined(obj) && obj !== null && obj[i]) {
          obj[i].month = sixDateLib.getMonthName(i);
        }
      }
      for (var i = 0; i < 12; i++) {
        if (!angular.isUndefined(obj) && obj !== null && obj[i]) {
          array.push(obj[i]);
        } else {
          var item = {
            month: sixDateLib.getMonthName(i),
            temp: null
          };
          array.push(item);
        }
      }
      return array;
    }

    $scope.updateWithDialog = function () {
      if (angular.isDefined($scope.type) && angular.isDefined($scope.type.selected) && $scope.type.selected.version) {
        var message = 'ATTENZIONE: I valori modificati influenzano le temperature medie mensili. Si desidera ricalcolarle?';
        if ($scope.updateArrayTemp == true) {
          dialogService.confirmDialog(message,
            function () {
              saveArray = true;
              zonaTermicaFactory.tempProvinciaToZonaTermica({id: saveArray}, $scope.type.selected).$promise.then(function (result) {
                if (!errorService.handleError(result)) {
                  toaster.pop('error', 'Errore', 'Errore durante il calcolo delle temperature');
                }
                else {
                  $scope.type.selected.model = angular.copy(result.model);
                  $scope.back();
                }
              });
            }, function () {
              /* update normale non devo aggiornare il vettore delle temperature  */
              zonaTermicaFactory.update({id: $scope.type.selected.version}, $scope.type.selected)
                .$promise.then(function(resp) {
                  if (!errorService.handleError(resp)) {
                    toaster.pop('error', 'Errore', 'Errore durante l\'aggiornamento');
                  }
                  else {
                    $scope.back();
                  }
              });
            }
          );
        } else {
          zonaTermicaFactory.update({id: $scope.type.selected.version}, $scope.type.selected)
            .$promise.then(function(resp) {
              if (!errorService.handleError(resp)) {
                toaster.pop('error', 'Errore', 'Errore durante l\'aggiornamento');
              }
              else {
                $scope.back();
              }
          });
        }
      }else{
        if(!angular.isArray($scope.model.temp_giorn_medie)){
          $scope.model.temp_giorn_medie = FromObjToArray($scope.model.temp_giorn_medie);
        }
        zonaTermicaFactory.create({commission_dependent: $scope.commissionDependent}, $scope.model)
          .$promise.then(function(resp) {
            if (!errorService.handleError(resp)) {
              toaster.pop('error', 'Errore', 'Errore durante l\'aggiornamento');
            }
            else {
              $scope.back();
            }
        });
      }
    };

    $scope.calculateTempFromProv = function() {
      if (angular.isDefined($scope.type) && angular.isDefined($scope.type.selected) && $scope.type.selected.version) {
        if (!$scope.type.selected.model) {
          dialogService.alert('Dati non configurati per la zona termica corrente', 2000);
          return false;
        }
        saveArray = false;
        zonaTermicaFactory.tempProvinciaToZonaTermica({id: saveArray}, $scope.type.selected).$promise.then(function (result) {
          if (!errorService.handleError(result)) {
            toaster.pop('error', 'Errore', 'Errore durante il calcolo delle temperature');
          }
          $scope.type.selected.model = angular.copy(result.model);
          $scope.model = $scope.type.selected.model;
        });
      }else{
        saveArray = false;
        var obj = {model: angular.copy($scope.model)};
        zonaTermicaFactory.tempProvinciaToZonaTermica({id: saveArray}, obj).$promise.then(function (result) {
          if (!errorService.handleError(result)) {
            toaster.pop('error', 'Errore', 'Errore durante il calcolo delle temperature');
          }
          $scope.model = angular.copy(result.model);
        });
      }
      $scope.updateArrayTemp = false;
    };

    $scope.delete = function (idToDelete) {
      zonaTermicaFactory.delete({id: idToDelete}).$promise.then(function() {
        $scope.back();
      });
    };

    $scope.deleteWithDialog = function (idToDelete) {
      dialogService.confirmDialog('Eliminare il record di ' + $scope.schemaDescription + ' \'' + $scope.model.code + '\'?',
        function () {
          $scope.delete(idToDelete);
        });
    };


    $scope.getRecordDetail = function (UUID) {
      $scope.showDetailView = true;
      $scope.showTimeline = false;
      $scope.typeName = 'zonatermica';
      schemaFactory().byUUID({id: $scope.typeName}).$promise.then(function (data) {
        if(errorService.handleError(data)) {
          if (!data.model) {
            dialogService.alert('Non è stato definito un modello per l\'entità ' + $scope.typeName, 4000);
            $scope.isModelDefined = false;
            return;
          }
          $scope.isCollapsed = true;
          $scope.schema = data.model.schema;
          $scope.schemaDescription = data.model.description;
          $scope.schemaUUID = data.UUID;
          $scope.schemaVersion = data.version;
          $scope.schemaCreationDate = data.creationDate;
          $scope.schemaDataIn = data.dataIn;
          $scope.schemaDataOut = data.dataOut;
          $scope.schemaCode = data.model.code;
          $scope.form = data.model.form;
          $scope.commissionDependent = data.commissionDependent;
          getColumnOrDefault(data);
          if (angular.isUndefined(UUID)) {
            $scope.disableModify = true;
            $scope.type['selected'] = {};
            $scope.type.selected['model'] = {};
            $scope.model = {};
            $scope.mapProvTemp = {};
            $scope.comune = undefined;
            $scope.provincia = undefined;
          } else {
            if (UUID != 'new') {
              zonaTermicaFactory.byUUID({ id: UUID }).$promise.then(function (data) {
                if(data.model){
                  $scope.type['selected'] = data;
                  $scope.model = $scope.type.selected.model;
                  if($scope.model.temp_giorn_medie){
                    reOrderTemps();
                  }
                  /* inseriamo qua il recupero dei dati della provincia e del comune */
                  if( $scope.type.selected.model.comune_id || $scope.type.selected.model.provincia_id){
                    recordFactory('comune').byUUID({id: $scope.type.selected.model.comune_id.UUID}).$promise.then(function (data) {
                      $scope.comune = {};
                      $scope.comune.type = data;
                      $scope.comune.model = data.model;
                      recordFactory('provincia').byUUID({id: $scope.comune.model.provincia_id.UUID}).$promise.then(function (data) {
                        $scope.provincia = {};
                        $scope.provincia.type = data;
                        $scope.provincia.model = data.model;
                        if($scope.provincia.model.temp_giorn_medie){
                          angular.forEach($scope.provincia.model.temp_giorn_medie, function(value) {
                            $scope.mapProvTemp[sixDateLib.getMonthIndex(value.month)] = value;
                          });
                        }
                      });
                    });
                  }

                  $scope.$broadcast('schemaFormRedraw');
                } else{
                  dialogService.alert('Non sono presenti versioni nella data selezionata per l\'entità ', 4000);
                }
              });
            }
          }
        }
        $scope.updateArrayTemp = false;
      });
    };

    function reOrderTemps(){
      /* funzione per riordinare l'array delle temperature da dare in pasto alla pagina */
      var map = {};
      var array = [];
      for(var i = 0; i < $scope.model.temp_giorn_medie.length; i++){
        /* mappa di appoggio */
        map[$scope.model.temp_giorn_medie[i].month] = $scope.model.temp_giorn_medie[i].temp;
      }
      for(var i = 0; i < 12; i++){
        var app = {
            month: sixDateLib.getMonthName(i),
            temp: null
        };
        if(angular.isDefined(map[sixDateLib.getMonthName(i)])){
          app.temp = map[sixDateLib.getMonthName(i)];
        }
        array.push(app);
      }
      $scope.type.selected.model.temp_giorn_medie = angular.copy(array);
    }

    $scope.getTypeDescription = function () {
      schemaFactory().byUUID({id: $scope.typeName}).$promise.then(function (data) {
        if(errorService.handleError(data)) {
          if (!data.model) {
            dialogService.alert('Non è stato definito un modello per l\'entità ' + $scope.typeName, 4000);
            $scope.isModelDefined = false;
            return;
          }
          $scope.typeDescription = data.model.description;
        } else {
          toaster.pop('error', 'Errore', 'Impossibile recuperare il modello');
        }
      });
    };

    $scope.onSubmit = function(form) {
      // First we broadcast an event so all fields validate themselves
      $scope.$broadcast('schemaFormValidate');
      // Then we check if the form is valid
      if (form.$valid) {
        $scope.updateWithDialog();
      }
    };

    $scope.getTimes=function(n){
      return new Array(n);
    };

    $scope.getMonthName = function(index){
      return sixDateLib.getMonthName(index);
    };

    $scope.edit = function(){
      $scope.editingMode = true;
      $scope.backupArrayTemp = angular.copy($scope.model.temp_giorn_medie);
    };

    $scope.undo = function(){
      $scope.editingMode = false;
      $scope.model.temp_giorn_medie = angular.copy($scope.backupArrayTemp);
    };

    $scope.confirm = function(){
      $scope.editingMode = false;
    };

    $scope.dataPrint = function(item) {
      var string = '';
      if(angular.isUndefined($scope.comune) && angular.isUndefined($scope.provincia)) {
        return string;
      }else{
        if(item != 'code' && item != 'description'){
          if(item != 'temp_giorn_medie'){
            if($scope.comune.model[item]){
              string = string + $scope.comune.model[item].toString() + ' (comune)';
            }
            if($scope.provincia.model[item]){
              if(string.length != 0){
                string = string + ' - ';
                string = string + $scope.provincia.model[item].toString() + ' (provincia)';
              } else {
                string = $scope.provincia.model[item].toString() + '(provincia)';
              }
            }
          }
        }
        return string;
      }
    };

    $scope.boolUpdate = function(item){
      if(item.key[0] == 'altitude'){
        $scope.updateArrayTemp = true;
      }
    };

    $scope.$watch('type.selected.model.comune_id.code',
      function(newValue, oldValue) {
        if(angular.isDefined(newValue) && angular.isDefined(oldValue)){
          if(newValue != oldValue){
            $scope.updateArrayTemp = true;
          }
        }
      }
    );

    $scope.$watch('model.comune_id.code',
      function(newValue, oldValue) {
        if(angular.isDefined(newValue) && angular.isDefined(oldValue)){
          if(newValue != oldValue){
            recordFactory('comune').byUUID({id: $scope.model.comune_id.UUID}).$promise.then(function (comune) {
              if(errorService.handleError(comune)) {
                recordFactory('provincia').byUUID({id: comune.model.provincia_id.UUID}).$promise.then(function (provincia) {
                  if(errorService.handleError(provincia)) {
                    $scope.provincia = {};
                    $scope.provincia.type = provincia;
                    $scope.provincia.model = provincia.model;
                    if($scope.provincia.model.temp_giorn_medie){
                      angular.forEach($scope.provincia.model.temp_giorn_medie, function(value) {
                        $scope.mapProvTemp[sixDateLib.getMonthIndex(value.month)] = value;
                      });
                    }
                  } else {
                    toaster.pop('error', 'Errore', 'Impossibile recuperare la provincia');
                  }
                });
              } else {
                toaster.pop('error', 'Errore', 'Impossibile recuperare il comune');
              }
            });
          }
        }
      }
    );

    $scope.typeName = 'zonatermica';
    if($routeParams.id){
      $scope.getRecordDetail($routeParams.id);
      $scope.getTypeDescription();
    } else{
      $scope.getTypeDescription();
      $scope.getColumns();
    }


    $scope.showRecordInfo = function() {
      var dialogScope = {
        record: $scope.type.selected,
        schema: {
          code: $scope.schemaCode,
          UUID: $scope.schemaUUID,
          version: $scope.schemaVersion,
          creationDate: $scope.schemaCreationDate,
          dataIn: $scope.schemaDataIn,
          dataOut: $scope.schemaDataOut,
          commission: $scope.schemaCommission
        }
      };
      var opts = {
        name: 'recordInfoDialog',
        closeByDocument: true,
        plain: false
      };
      dialogService.templateDialog('recordInfoTemplate.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false);
    };

    /****************************************/
    /********** check and fix type **********/
    /****************************************/

    var FIXABLE_CODE_PROBLEMS = { // code: path per al service di fix
      '2': 'record/'+$scope.typeName+'/_fix/dataout',     // più dataOut = null
      '3': 'record/'+$scope.typeName+'/_fix/schemacode',  // schema mancante
      '6': 'record/'+$scope.typeName+'/_fix/commission'   // commission defined per STABLE record
    };

    $scope.reportGridOptions = {
      enableSorting: true,
      exporterMenuPdf: false,
      paginationPageSizes: [10, 20, 30],
      paginationPageSize: 10,
      useExternalPagination: false,
      data: 'messages',
      columnDefs: [
        {displayName: 'Codice', field: 'code', width: '60'},
        {displayName: 'Stato', field: 'status', width: '100'},
        {displayName: 'Messaggio', field: 'message'},
        {displayName: 'Record type', field: 'record.type', width: '120'},
        {displayName: 'Record code', field: 'record.code', width: '120'},
        {displayName: 'Record UUID', field: 'record.uuid', width: '120'},
        {displayName: 'Record Id', field: 'recordId', width: '120'},
        {displayName: 'Commission', field: 'commission', width: '120'},
        {
          displayName: '', field: 'code',
          cellTemplate: '<div><a class="btn btn-xs" title="Correggi" ng-confirm-message="Correggere?" ng-if="grid.appScope.isFixable(row.entity.code)===true" ng-confirm-click="grid.appScope.tryFixProblem(row.entity)" ng-confirm-condition=true><span class="fa fa-medkit"></span></a></div>',
          width: 50, enableSorting: false, enableFiltering: false, enableCellEdit: false
        }
      ]
    };

    $scope.isFixable = function(problemCode) {
      for(var code in FIXABLE_CODE_PROBLEMS) {
        if(problemCode === code) {
          return true;
        }
      }
      return false;
    };

    $scope.checkType = function() {
      dialogService.showLoadingMessage('Checking ' + $scope.typeName + '...');
      recordFactory($scope.typeName).check().$promise.then(function(response) {
        if (errorService.handleError(response)) {
          $scope.messages = response.messages;
          if(response.status === 'ok') {
            toaster.pop('success', 'Tutto ok', 'Nessun problema rilevato');
          } else {
            toaster.pop('warning', 'Attenzione', 'Problemi rilevati: ' + $scope.messages.length);
          }
        } else {
          toaster.pop('error', 'Errore', 'Impossibile controllare il tipo ' + $scope.typeName);
        }
        dialogService.hideLoadingMessage();
      });
    };

    $scope.tryFixAllProblems = function() {
      dialogService.showLoadingMessage('Fixing ' + $scope.typeName + '...');
      recordFactory($scope.typeName).fixAll().$promise.then(function(response) {
        if (errorService.handleError(response)) {
          $scope.messages = response.messages;
          toaster.pop('success', 'Corretto', 'Gli errori rilevati sono stati corretti sul tipo ' + $scope.typeName);
        } else {
          toaster.pop('error', 'Errore', 'Impossibile correggere gli errori sui dati del tipo ' + $scope.typeName);
        }
        dialogService.hideLoadingMessage();
      });
    };

    $scope.tryFixProblem = function(problem) {
      if (problem) {
        var path = FIXABLE_CODE_PROBLEMS[problem.code];
        if(path) {
          dialogService.showLoadingMessage('Fixing ' + $scope.typeName + '...');
          baseFactory(path + '/' + problem.record.type + '/' + problem.record.uuid).query().$promise.then(function (response) {
            if (errorService.handleError(response)) {
              $scope.messages = response.messages;
              if(response.status !== 'ok') {
                toaster.pop('error', 'Errore', 'Impossibile correggere gli errori sul record ' + problem.record.uuid + ' del tipo ' + problem.record.type);
              } else {
                toaster.pop('success', 'Corretto', 'Gli errori rilevati sono stati corretti sul record ' + problem.record.uuid + ' di tipo ' + problem.record.type);
              }
            } else {
              toaster.pop('error', 'Errore', 'Impossibile correggere gli errori sul record ' + problem.record.uuid + ' del tipo ' + problem.record.type);
            }
            dialogService.hideLoadingMessage();
          });
        }
      }
    };



    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'zonatermica';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.ferri.controller:FerriAutoclaveCycleValidationCtrl
 * @description Shows a list of sterilized lots and allowes users to validate them.
 * @author Rita Beltrami
 * 
 * created on 20/09/2018
 * # FerriAutoclaveCycleValidationCtrl
 * Controller of the ictportal.ferri
 */
angular.module('ictportal.ferri')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/ferri/autoclavecycle/validation', {
                templateUrl: 'ferri/autoclave-cycle-validation/autoclave-cycle-validation.html',
                controller: 'FerriAutoclaveCycleValidationCtrl'
            })
    })
    .controller('FerriAutoclaveCycleValidationCtrl', function ($scope, recordFactory, $location, authFactory, dbFilterFactory, dialogService, 
                                                            sixGridPaginationConstants, uiGridConstants, $log, $rootScope, matrixParFactory,
                                                            localeFactory, $q, toaster, eggsFormFactory, autoclaveCycleValidationFactory, parseSchemaService) {

        var stepReader = {
            STEP1_2_STER_PROD_ORDER_EQUIP: 'STER_PROD_ORDER_EQUIP', // commessa di sterilizzazione (prod_order) o autoclave --> una commessa di sterilizzazione equivale ad un carrello. Il barcode che vado a leggere infatti è del carrello
            STEP3_STER_IS_COMPLIANT: "STER_IS_COMPLIANT" // ciclo conforme/non conforme
        };

        var pageBundle = 'autoclave_cycle_validation';
        var msg = {
            operation_completed: "Operation completed",
            operation_completed_success: "Operation completed successfully",
            error: "Errore",
            confirm: "Conferma"
        };
        var page_msg = {
            "table_head_prod_order_barcode": "Barcode carrello",
            "table_head_prod_order_code": "Codice commessa",
            "table_head_prod_order_date": "Data commessa",
            "table_head_equipment_reason_code": "Programma sterilizzazione",
            "table_detail_title": "Commessa",
            "info_unselect_prod_order": "Commessa deselezionata",
            "error_prod_order_not_found": "Commessa non trovata",
            "error_equipment_mismatch": "Autoclave differente dalla precedente",
            "error_equipment_reason_mismatch": "Programma di sterilizzazione di tipo differente dal precedente",
            "error_autoequip_prodord_not_found": "Commessa o autoclave con barcode selezionato non presenti",
            "error_autoequip_not_found": "Autoclave con barcode selezionato non presente",
            "error_compliant_barcode_not_found": "Barcode di conformità/non conformità non valido"
        };
        var sterProdOrderCode;
        var baseEquipmentReasonFilter = [{
            column: 'equipment_autoclave_reason er',
            value: 'er.admittedautoclavereasons_id = t.id',
            relation: 'JOIN',
            kind: 'er.autoclaveequipments_id AS equipment_id'
        }].concat(dbFilterFactory.getStringFilter('discriminator', 'AUTO'));
        var baseEquipmentFilter = [{
            column: 'container_type ct',
            value: 'ct.id = t.container_type_id',
            relation: 'JOIN',
            kind: 'ct.code AS ct_code'
        },
        {
            column: 'equipment_autoclave_reason ear',
            value: 'ear.autoclaveequipments_id = t.id',
            relation: 'JOIN',
            kind: 'ear.admittedautoclavereasons_id AS addmitted_reason'
        }].concat(dbFilterFactory.getStringFilter('t.discriminator', 'AUTO'))
                        .concat(dbFilterFactory.getStringFilter('t.status', 'AVAILABLE'))
                        .concat(dbFilterFactory.getNumberFilter('t.azcod', authFactory.getAuthData().info.azCod))
                        .concat(dbFilterFactory.getCustomFilter("(t.divcod=" + authFactory.getAuthData().info.divCod +" OR t.divcod is null)"))
        var baseProdOrderDetFilter = [
            {
                column: 'serial_kit sk',
                value: 't.serial_kit_id = sk.id',
                relation: 'JOIN',
                kind: 'sk.barcode as sk_barcode, sk.urgent as sk_urgent'
            },
            {
                column: 'bom b',
                value: 'sk.bom_id = b.id',
                relation: 'JOIN',
                kind: 'b.item_id as bom_item_id'
            },
            {
                column: 'product p',
                value: 'b.item_id = p.id',
                relation: 'JOIN',
                kind: 'p.code as product_code, p.description as product_desc'
            }
        ];
        var currentStepReader = stepReader.STEP1_2_STER_PROD_ORDER_EQUIP;
        var compliantBarcode = undefined;
        var notCompliantBarcode = undefined;
        $scope.hasAlreadyAutoclaveEquipmentAssociated = undefined;
        $scope.isOnlyBarcodeUse = false; // utilizzo unicamente del barcode per procedere con gli step (permesso sul ruolo utente)
        $scope.msgUnion = {};
        $scope.reportParameters = {};
        $scope.showReport = false;
        $scope.isCompliant = undefined;
        $scope.productionOrdersSelected = [];
        $scope.viewProductionOrdersGridParams = {
            pageNumber: 1,
            pageSize: 1000,
            sortOrder: 'desc',
            filters: []
        };
        $scope.productionOrdersTableData = {};
        $scope.gridApi;
        // ATTENZIONE: non spostare da qui
        $scope.sixRowSelectionChangedCallback = function(row, col, event){
            var rows = $scope.viewProductionOrdersGridOptions.gridApi.selection.getSelectedRows();
            // Se ho deselezionato tutto allora posso resettare il programma di sterilizzazione correnti letti
            if (rows.length <= 0) {
                $scope.record.model.equipment_reason_id = undefined;
                $scope.record.model.equipment_id = undefined;
                $scope.hasAlreadyAutoclaveEquipmentAssociated = undefined;
            }
            $scope.productionOrdersSelected.length = 0;
            rows.forEach(function(item) {
                // Setto la prima autoclave selezionata
                if ($scope.hasAlreadyAutoclaveEquipmentAssociated == undefined && $scope.record.model.equipment_id == undefined) {
                    if (item.autoclave_equipment_id != undefined) {
                        $scope.record.model.equipment_id = item.autoclave_equipment_id;
                        $scope.hasAlreadyAutoclaveEquipmentAssociated = true;
                    }
                    else {
                        $scope.hasAlreadyAutoclaveEquipmentAssociated = false;
                    }
                }
                // Setto il primo programma di sterilizzazione selezionato
                if ($scope.record.model.equipment_reason_id == undefined) {
                    $scope.record.model.equipment_reason_id = item.equipment_reason_id;
                    setSterEquipmentReason();
                }

                // Se non ho associato la stessa lavastrumenti allora restituisco errore (posso selezionare solo ordini appartenenti alla stessa lavastrumenti)
                if (
                    ($scope.hasAlreadyAutoclaveEquipmentAssociated == true && item.autoclave_equipment_id != $scope.record.model.equipment_id)
                    || ($scope.hasAlreadyAutoclaveEquipmentAssociated == false && item.autoclave_equipment_id != undefined)
                ) {
                    $scope.viewProductionOrdersGridOptions.gridApi.selection.unSelectRow(item);
                    toaster.error(msg.error, page_msg.error_equipment_mismatch);
                }
                // Se non ho associato lo stesso programma di sterilizzazione allora restituisco errore (posso selezionare solo ordini appartenenti allo stesso programma di sterilizzazione)
                else if (item.equipment_reason_id != $scope.record.model.equipment_reason_id) {
                    $scope.viewProductionOrdersGridOptions.gridApi.selection.unSelectRow(item);
                    toaster.error(msg.error, page_msg.error_equipment_reason_mismatch);
                }
                // Se è tutto ok, seleziono la commessa di sterilizzazione
                else {
                    $scope.productionOrdersSelected.push(item.id);
                }
            });
        };
        $scope.viewProductionOrdersGridOptions = {
            appScopeProvider: $scope,
            multiSelect: true,
            enableRowHeaderSelection: true,
            enableRowSelection: true,
            rowHeight: 33,
            enablePaginationControls: true,
            rowSelectionChanged: $scope.sixRowSelectionChangedCallback
        };
        $scope.record = {
            lookup: {},
            dates: [],
            model: {
                /* prod_order: [] */
            },
            detail: {
                currentProdOrderElement: null,
                currentProdOrderElementDetail: null,
                showProdOrderDetail: false
            }
        };
        $scope.filter = {
            equipment: angular.copy(baseEquipmentFilter),
            equipment_reason_modal: angular.copy(baseEquipmentReasonFilter),
        }


        /* FUNCTION */

        $scope.reloadPage = function() {
            location.reload();
        }

        $scope.translateValue = function(value) {
            return page_msg[value];
        }

        /**
         * Help dialog
         */
        $scope.showHelpDialog = function() {
            var dlgScope = {
              lang: 'html'
            };
            var dlgOpts = {
              name: 'helpDialog',
              closeByDocument: true,
              plain: false
            };
            var helpDialog = dialogService.templateDialog('helpTemplate.html', dialogService.DIALOG_TYPE.INFO, dlgScope, dlgOpts, -1, false, '50%');
        };

        // Load data for table to list production order (NOTDISPACHED) of type STER
        $scope.loadProductionOrders = function() {
            if (sterProdOrderCode) {
                var filter = [
                    {
                        column: 'container c',
                        value: 't.container_id = c.id',
                        relation: 'JOIN',
                        kind: 'c.barcode AS barcode'
                    },
                    {
                        column: 'prod_order_type pot',
                        value: 't.prod_order_type_id = pot.id',
                        relation: 'JOIN',
                        kind: 'pot.code AS pot_code'
                    },
                    {
                        column: 'equipment_reason er',
                        value: 't.equipment_reason_id = er.id',
                        relation: 'JOIN',
                        kind: 'er.code AS reason_code'
                    },
                    {
                        column: 'equipment e',
                        value: 't.autoclave_equipment_id = e.id',
                        relation: 'JOIN',
                        kind: 'e.code AS equipment_code'
                    }
                ].concat(dbFilterFactory.getStringFilter('t.status', 'NOTDISPATCHED'))
                .concat(dbFilterFactory.getStringFilter('pot.code', sterProdOrderCode))
                .concat($scope.viewProductionOrdersGridParams.filters); // aggancio i filtri sopra alle colonne;
                var payload = {
                    page: $scope.viewProductionOrdersGridParams.pageNumber,
                    page_size: $scope.viewProductionOrdersGridParams.pageSize,
                    sort_fields: ($scope.viewProductionOrdersGridParams.sortFields?$scope.viewProductionOrdersGridParams.sortFields:'order_date'),
                    sort_order: $scope.viewProductionOrdersGridParams.sortOrder
                };
                recordFactory('prod_order').filter(payload,filter).$promise
                    .then(function(data){
                        $scope.productionOrdersTableData.list = data.list;
                        $scope.productionOrdersTableData.totalResults = data.totalResults;
                        $scope.viewProductionOrdersGridOptions.totalItems = data.totalResults;
                        var height = (data.totalResults * $scope.viewProductionOrdersGridOptions.rowHeight) + 150;
                        $scope.viewProductionOrdersGridOptions.gridApi.grid.gridHeight = height;
                    });
            }
        }

        $scope.formatDateToString = function(dateToFormat) {
            return sixDateLib.getDateStringFormattedFromDate(new Date(dateToFormat));
        }

        /**
         * View production order detail on right of screen
         */
        $scope.viewDetail = function(selected) {
            // Toggle: se riclicco sullo stesso elemento, nascondo il dettaglio. Se è un elemento nuovo, invece, lo mostro
            if ($scope.record.detail.currentProdOrderElement == null || (selected.id != $scope.record.detail.currentProdOrderElement.id)) {
                var filter = baseProdOrderDetFilter
                            .concat(dbFilterFactory.getNumberFilter('t.prod_order_id', selected.id));
                recordFactory('prod_order_load_equip_det').filter(filter).$promise
                    .then(function(data){
                        $scope.record.detail.currentProdOrderElementDetail = data.list;
                    });
                $scope.record.detail.currentProdOrderElement = selected;
                $scope.record.detail.showProdOrderDetail = true;
            }
            else {
                $scope.record.detail.currentProdOrderElement = null;
                $scope.record.detail.showProdOrderDetail = false; 
            }
        }

        $scope.getDetailRowStyleClass = function(item) {
            if (item.sk_urgent != undefined && item.sk_urgent == 'T') {
                return "row-urgent";
            }
            return "";
        }

        // Code reader
        $scope.readCodeReader = function(read) {
            if(read.read) {
                console.log("Barcode read: ", read.read);
                switch (currentStepReader) {
                    // STEP1_2: leggo il barcode dei carrelli (minimo 1, posso leggerne più di 1). Un carrello equivale ad una commessa di sterilizzazione. 
                    // Se, invece di un carrello, riconosco un'autoclave vuol dire che ho finito di leggere le commesse e passo allo step2 di lettura autoclavi,
                    // in questo caso il barcode letto non è più del carello ma dell'autoclave.
                    // Quindi posso leggere carrelli finché non mi arriva poi un barcode di autoclave, a quel punto passo allo step successivo.
                    case stepReader.STEP1_2_STER_PROD_ORDER_EQUIP:
                        $log.info("Read prod order or autoclave equipment with barcode: ", read.read);
                        readBarcodeProdOrderOrSterEquip(read.read);
                        break;
                    // STEP3: leggo il barcode per determinare se il ciclo è conforme o non conforme
                    case stepReader.STEP3_STER_IS_COMPLIANT:
                        readBarcodeIsCompliant(read.read);
                        break;
                }
            }
        };

        $scope.toggleConfirmCycleCompliant = function() {
            if ($scope.isCompliant == true) {
                $scope.isCompliant = undefined;
                currentStepReader = stepReader.STEP4_STER_IS_COMPLIANT; // Annulla la conferma, torno indietro di step
            }
            else {
                $scope.isCompliant = true;
                nextStepAfterCompliant();
            }         
        }

        $scope.toggleConfirmCycleNotCompliant = function() {
            if ($scope.isCompliant == false) {
                $scope.isCompliant = undefined;
                currentStepReader = stepReader.STEP4_STER_IS_COMPLIANT; // Annulla la conferma, torno indietro di step
            }
            else {
                $scope.isCompliant = false;
                nextStepAfterCompliant();
            }
        }

        $scope.confirmNotCompliantSterCycle = function(equipmentReason) {
            $scope.record.model.equipment_reason_id = equipmentReason.id;
            $scope.confirmSterilizationCycle();
        }

        $scope.confirmSterilizationCycle = function() {
            var payload = {
                autoclaveEquipmentId: ""+$scope.record.model.equipment_id, // id autocalve
                autoclaveReasonId: ""+$scope.record.model.equipment_reason_id, // id programma sterilizzazione
                productionOrderIds: $scope.productionOrdersSelected // id ordini di produzione
            };
            if($scope.isCompliant) {
                autoclaveCycleValidationFactory.cycleCompliant({},payload).$promise.then(function(data){
                    displayResult(data, true);
                });
            }
            else {
                autoclaveCycleValidationFactory.cycleNotCompliant({},payload).$promise.then(function(data){
                    displayResult(data, false);
                });
            } 
        }

        $scope.nextStepAfterEquipment = function() {
            // Ho letto la lavastrumenti, passo allo step successivo
            currentStepReader = stepReader.STEP3_STER_IS_COMPLIANT; // passo allo step successivo
        }

        $scope.clearEquipmentLookup = function() {
            $scope.record.model.equipment_id = null;
            $scope.isCompliant = undefined;
            currentStepReader = stepReader.STEP1_2_STER_PROD_ORDER_EQUIP; // torno allo step precedente
        }

        /**
         * Tramite il barcode reader leggo o una commessa (prod_order) o un'autoclave
         * @param {*} barcode barcode letto
         */
        function readBarcodeProdOrderOrSterEquip (barcode) {
            // Cerco se esiste un prod_order associato ad un carrello con barcode passato
            // Se non ho letto nessun'altro prod_order restituisco errore poiché almeno un prod_order devo leggerlo
            // Altrimenti, se non esiste un prod_order cerco un'autoclave con barcode passato
            $log.info("Find valid prod order");
            // Cerco il prod_order con barcode passato
            var filter = [
                {
                    column: 'container c',
                    value: 't.container_id = c.id',
                    relation: 'JOIN',
                    kind: 'c.barcode AS barcode'
                },
                {
                    column: 'prod_order_type pot',
                    value: 't.prod_order_type_id = pot.id',
                    relation: 'JOIN',
                    kind: 'pot.code AS pot_code'
                }
            ].concat(dbFilterFactory.getStringFilter('c.barcode', barcode))
            .concat(dbFilterFactory.getStringFilter('t.status', 'NOTDISPATCHED'))
            .concat(dbFilterFactory.getStringFilter('pot.code', sterProdOrderCode));

            var tryFindSterEquipment = false;

            // Se ho la seleziona multipla degli ordini posso leggere più ordini, altrimenti passo direttamente a cercare un'autoclave con barcode passato
            if ($location.search().single && $scope.productionOrdersSelected <= 0 || !$location.search().single) {

                recordFactory('prod_order').filter(filter).$promise
                    .then(function(data) {
                        var errorMsg = "";
                        if (data.totalResults <= 0) {
                            tryFindSterEquipment = true;
                        }
                        else {
                            var firstResult = data.list[0];
                            
                            tryFindSterEquipment = false;

                            // Setto la prima autoclave selezionata
                            if ($scope.hasAlreadyAutoclaveEquipmentAssociated == undefined && $scope.record.model.equipment_id == undefined) {
                                if (firstResult.autoclave_equipment_id != undefined) {
                                    $scope.record.model.equipment_id = firstResult.autoclave_equipment_id;
                                    $scope.hasAlreadyAutoclaveEquipmentAssociated = true;
                                }
                                else {
                                    $scope.record.model.equipment_id = undefined;
                                    $scope.hasAlreadyAutoclaveEquipmentAssociated = false;
                                }
                            }
                            // Setto il primo programma di sterilizzazione selezionato
                            if ($scope.record.model.equipment_reason_id == undefined) {
                                $scope.record.model.equipment_reason_id = firstResult.equipment_reason_id;
                                setSterEquipmentReason();
                            }

                            var selItem = $scope.productionOrdersTableData.list.find(function(r) {
                                return r.id == firstResult.id;
                            });

                            // Se non ho associato la stessa autocalve allora restituisco errore (posso selezionare solo ordini appartenenti alla stessa autocalve)
                            if ($scope.hasAlreadyAutoclaveEquipmentAssociated == true && firstResult.autoclave_equipment_id != $scope.record.model.equipment_id) {
                                $scope.viewProductionOrdersGridOptions.gridApi.selection.unSelectRow(selItem);
                                errorMsg = page_msg.error_equipment_mismatch;
                            }
                            // Se non ho associato lo stesso programma di lavaggio allora restituisco errore (posso selezionare solo ordini appartenenti allo stesso programma di lavaggio)
                            else if (firstResult.equipment_reason_id != $scope.record.model.equipment_reason_id)  {
                                $scope.viewProductionOrdersGridOptions.gridApi.selection.unSelectRow(selItem);
                                errorMsg = page_msg.error_equipment_reason_mismatch;
                            }
                            else if (!$scope.productionOrdersSelected.includes(firstResult.id)) {
                                $scope.viewProductionOrdersGridOptions.gridApi.selection.selectRow(selItem);
                            }
                            else {
                                $scope.viewProductionOrdersGridOptions.gridApi.selection.unSelectRow(selItem);
                                errorMsg = page_msg.info_unselect_prod_order;
                                toaster.info(errorMsg);
                                return;
                            }
                        }
                        // Se non ho trovato un prod_order ma ne avevo già letti in precedenza, posso provare a cercare un'autoclave
                        // Se non ho mai letto un prod_order restituisco errore. Prima dell'autoclave devo avere un prod_order letto.
                        if (tryFindSterEquipment && $scope.productionOrdersSelected.length <= 0) {
                            tryFindSterEquipment = false;
                            errorMsg = page_msg.error_prod_order_not_found;
                        }

                        // Se ho già un'autoclave associata, non devo leggere il barcode dell'autoclave
                        if (tryFindSterEquipment == true && $scope.hasAlreadyAutoclaveEquipmentAssociated == true) {
                            tryFindSterEquipment = false;
                            readBarcodeIsCompliant(barcode);
                        }

                        // Verifico se non devo cercare l'autoclave
                        if (!tryFindSterEquipment) {
                            if (errorMsg != "") {
                                toaster.error(msg.error, errorMsg);
                            }
                            return;
                        }

                        // Altrimenti provo a leggere il barcode come barcode di un'autoclave
                        readBarcodeSterEquipment(barcode);
                    });
            }
            else {
                // Se ho già un'autoclave associata, non devo leggere il barcode dell'autoclave
                if ($scope.hasAlreadyAutoclaveEquipmentAssociated == false) {
                    readBarcodeSterEquipment(barcode);
                }
                else {
                    readBarcodeIsCompliant(barcode);
                }
            }
        }

        /**
         * Tramite il barcode reader leggo un'autoclave
         * @param {*} barcode barcode dell'autoclave
         */
        function readBarcodeSterEquipment(barcode) {
            $log.info("Find valid sterilization equipment");
            var filter = $scope.filter.equipment.concat(dbFilterFactory.getStringFilter('t.barcode', barcode));
            recordFactory('equipment').filter(filter).$promise
                .then(function(data) {
                    // Se non ho alcun risultato restituisco errore
                    if (data.totalResults <= 0) {
                        var errorMsg = "";
                        if ($location.search().single) {
                            errorMsg = page_msg.error_autoequip_not_found;
                        }
                        else {
                            errorMsg = page_msg.error_autoequip_prodord_not_found;
                        }
                        toaster.error(msg.error, errorMsg); 
                    }
                    else {
                        // Altrimento ho letto un'autoclave, passo allo step successivo 
                        $scope.record.model.equipment_id = data.list[0].id;
                        $scope.record.lookup.equipment_id.obj = data.list[0];
                        eggsFormFactory.loadLookupData($scope.record.lookup, $scope.record.model);
                        $scope.nextStepAfterEquipment();
                    }
                });
        }

        function setSterEquipmentReason() {
            if ($scope.record.model.equipment_reason_id != undefined) {
                $scope.filter.equipment = angular.copy(baseEquipmentFilter)
                    .concat(dbFilterFactory.getNumberFilter('ear.admittedautoclavereasons_id', $scope.record.model.equipment_reason_id));
            }
            else {
                $scope.filter.equipment = angular.copy(baseEquipmentFilter);
            }
        }

        /**
         * Tramite il barcode reader leggo il barcode di convalida "CONFROME" o "NON CONFORME".
         * Se è "CONFORME" convalido dirttamente il ciclo, altrimenti propongo una modale all'utente per selezionare la causale di non conformità.
         * @param {*} barcode barcode di conforme/non conforme
         */
        function readBarcodeIsCompliant(barcode) {
            $log.info("Read barcode compliant not compliant cycle");
            var readOk = false;
            if (barcode == compliantBarcode) {
                $scope.isCompliant = true;
                readOk = true;
            }
            else if (barcode == notCompliantBarcode) {
                $scope.isCompliant = false;
                readOk = true;
            }
            
            if (readOk) {
                nextStepAfterCompliant(); // Convalido o apro la modale
            }
            else {
                toaster.error(msg.error, page_msg.error_compliant_barcode_not_found);
            }
        }

        /**
         * Se ho premuto su "conforme" convalido direttamente il ciclo.
         * Se ho premuto su "non conforme" apro la modale per scegliere la causale di non conformità.
         */
        function nextStepAfterCompliant() {
            // Se ho premuto "ciclo conforme" convalido direttamente il ciclo
            if ($scope.isCompliant) {
                $scope.confirmSterilizationCycle();
            }
            else {
                // Altrimenti, se ho premuto "ciclo non conforme", apro la modale che selezionare la causale di non conformità
                displayModal();
            }
        }

        // Display result after validation
        function displayResult(data, isCompliant) {
            $log.info(data);
            if (data.status == 'ok') {
                toaster.pop('success', msg.operation_completed, msg.operation_completed_success);

                //Show report
                if (isCompliant) {      
                    $scope.showReport = true;
                    $scope.reportParameters = {
                        "autoclave_id": data.result.equipmentId,
                        "user": data.result.userId,
                        "azCod": authFactory.getAuthData().info.azCod,
                        "cycle_count": data.result.cycleCount,
                        "sterilizationLotCode": data.result.sterLotCode
                    };
                }
                else {
                    location.reload();
                }
                
            }
            else {
                eggsFormFactory.logServerException(data, pageBundle);
            }
        }

        /**
         * Modale per selezionare la causale di non conformità del ciclo che si sta tentando di validare
         */
        function displayModal() {
            $scope.filter.equipment_reason_modal.length = 0;
            $scope.filter.equipment_reason_modal = angular.copy(baseEquipmentReasonFilter)
                                            .concat(dbFilterFactory.getNumberFilter('er.autoclaveequipments_id', $scope.record.model.equipment_id))
                                            .concat(dbFilterFactory.getStringFilter('type', 'NOT_ACCORDANT')); // causali di non conformità
            $rootScope.$broadcast('autoclaveCycleValidationModalCtrl_open');
        }

        // Retrieve from datamatrix code of production order type for sterilization cycle
        function getSterProdOrderTypeCode(azCod, divCod) {
            var deferred = $q.defer();
    
            matrixParFactory.getValueOrDefault({key: 'productionOrderType.sterilizationcycle', d1: azCod, d2: divCod, d3: '*', d4: '*', d5: '*'}, {defaultValue: "STER"}).$promise.then(function(data){
                deferred.resolve(data.result.value);
            });
    
            return deferred.promise;
        }

        // init prod order column grid
        function initProdOrderColumnDefGrids() {
            $scope.viewProductionOrdersGridOptions.columnDefs = [];
            $scope.viewProductionOrdersGridOptions.columnDefs.push(parseSchemaService.getEditCol());
            $scope.viewProductionOrdersGridOptions.columnDefs.push({
                name: "Barcode carrello",
                translation: 'table_head_prod_order_barcode',
                field: 'barcode',
                enableFiltering: true,
                filters: [{
                    type: sixGridPaginationConstants.filterType.TEXT,
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: '',
                    kind: 'string',
                    aliasResolver: 'c.barcode'
                }]
            });
            $scope.viewProductionOrdersGridOptions.columnDefs.push({
                name: "Codice commessa",
                translation: 'table_head_prod_order_code',
                field: 'code',
                enableFiltering: true,
                filters: [{
                    type: sixGridPaginationConstants.filterType.TEXT,
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: '',
                    kind: 'string',
                    aliasResolver: 't.code'
                }]
            });
            $scope.viewProductionOrdersGridOptions.columnDefs.push({
                name: "Data commessa",
                translation: 'table_head_prod_order_date',
                field: 'order_date',
                enableFiltering:false,
                cellTemplate:
                '<div class="ui-grid-cell-contents">{{grid.appScope.formatDateToString(COL_FIELD)}}</div>'
            });
            $scope.viewProductionOrdersGridOptions.columnDefs.push({
                name: "Autoclave",
                translation: 'table_head_equipment_code',
                field: 'equipment_code',
                enableFiltering: true,
                filters: [{
                    type: sixGridPaginationConstants.filterType.TEXT,
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: '',
                    kind: 'string',
                    aliasResolver: 'e.code'
                }]
            });
            $scope.viewProductionOrdersGridOptions.columnDefs.push({
                name: "Programma sterilizzazione",
                translation: 'table_head_equipment_reason_code',
                field: 'reason_code',
                enableFiltering: true,
                filters: [{
                    type: sixGridPaginationConstants.filterType.TEXT,
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: '',
                    kind: 'string',
                    aliasResolver: 'er.code'
                }]
            });
        }

        function initLookups() {
            eggsFormFactory.addLookup($scope.record.lookup, 'equipment_id',             'equipment',             't.code',     't.description');
            eggsFormFactory.addLookup($scope.record.lookup, 'equipment_reason_id',      'equipment_reason',      'code',     'description');
        }

        function checkPermissions() {
            var profilingKey = 'FERRI-AUTOCLAVE-CYCLE-VALIDATION';
            var permission = authFactory.getPermissions(profilingKey);
            if (!permission.EXEC) {
                $location.path('forbidden').search({ key: profilingKey });
            }
            else {
                $scope.isNewAllowed = permission.NEW;
                $scope.isDetailAllowed = permission.DETAIL;
                $scope.isUpdateAllowed = permission.UPDATE;
                $scope.isOnlyBarcodeUse = permission.USE_ONLY_DEVICE_BARCODE;
            }
        };

        function init() {
            if($location.search().single) {
                $scope.viewProductionOrdersGridOptions.multiSelect = false;
            }
            initProdOrderColumnDefGrids();
            localeFactory.loadTranslation(pageBundle)
                .then(function(){
                    $q.all({
                        general: localeFactory.translateMsg(msg),
                        specific: localeFactory.translateMsg(page_msg, pageBundle),
                        sterProdOrderCode: getSterProdOrderTypeCode(authFactory.getAuthData().info.azCod, authFactory.getAuthData().info.divCod),
                        compliantBarcodeResponse: recordFactory('confpar').filter(dbFilterFactory.getStringFilter('t.name', 'EQUIPMENT_CONTROLLER_BARCODECOMPLIANT')).$promise, // barcode per definire ciclo conforme
                        notCompliantBarcodeResponse: recordFactory('confpar').filter(dbFilterFactory.getStringFilter('t.name', 'EQUIPMENT_CONTROLLER_BARCODENOTCOMPLIANT')).$promise, // barcode per definire ciclo non conforme
                    })
                    .then(function(data){ 
                        if (data.compliantBarcodeResponse.totalResults > 0) {
                            compliantBarcode = data.compliantBarcodeResponse.list[0].value; // barcode per convalida ciclo conforme
                        }
                        if (data.notCompliantBarcodeResponse.totalResults > 0) {
                            notCompliantBarcode = data.notCompliantBarcodeResponse.list[0].value; // barcode per convalida ciclo non conforme
                        }
                        sterProdOrderCode = data.sterProdOrderCode;
                        $scope.msgUnion = angular.extend({}, msg, page_msg);
                        $scope.loadProductionOrders(); // Ricarico per poter avere i soli prod_order con il tipo corretto
                    })
                    .catch(function(ex){});
                })
                .catch(function(ex){});
            checkPermissions();
            initLookups();
        };

        //___ main ___
        init();

    });
'use strict';

/**
 * @ngdoc function
 * @name ictportal.ferri.controller:DirtAcceptanceKitCtrl
 * @description
 * @author Anna Salvato
 * 
 * created on 20/12/2017
 * # DirtAcceptanceKitCtrl
 * Controller of the ictportal.ferri
 */
angular.module('ictportal.ferri')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/ferri/dirtacceptancekit/list', {
            templateUrl: 'ferri/dirtAcceptanceKit/dirtAcceptanceKit_list.html',
            controller: 'DirtAcceptanceKitCtrl'
        })
  })
  .controller('DirtAcceptanceKitCtrl', function ($scope, dirtAcceptanceKitFactory, $log, $routeParams, $location, toaster, 
                dbFilterFactory, recordFactory, matrixParFactory, localeFactory, authFactory, sixGridPaginationConstants, uiGridConstants) {

    
    $scope.consumedKitsTableData = {};
    $scope.serialKitsReadTableData = {};
    $scope.localeMessages;
    $scope.viewConsumedGridOptions = {};
    $scope.viewReadGridOptions = {
        appScopeProvider: $scope,
        enablePaginationControls: false,
        rowHeight: 44 // x Anna: imposto a piacere l'altezza delle righe
    };
    $scope.viewReadGridParams = {
        pageNumber: 1,
        pageSize: 15,
        sortOrder: 'desc',
        filters: []
    };
    $scope.viewConsumedGridParams = {
        pageNumber: 1,
        pageSize: 15,
        sortOrder: 'desc',
        filters: []
    };
    var serialKitsReadMaxLength = 5;
    var azCod;
    var username;
    var kitProductTypeCode;
    var filters = [
        {
            "column": "bom b",
            "value": "t.bom_id = b.id",
            "relation": "JOIN",
            "kind": "b.id AS bom_id"
        },
        {
            "column": "product p",
            "value": "b.item_id = p.id",
            "relation": "JOIN",
            "kind": "p.description AS product_description, p.code AS product_code"
        },
        {
            "column": "product_type pt",
            "value": "p.product_type_id = pt.id",
            "relation": "JOIN",
            "kind": "pt.code AS product_type_code"
        },
        {
            "column": "product_category pg",
            "value": "p.product_category_id = pg.id",
            "relation": "JOIN",
            "kind": "pg.description AS product_category_description"
        },
        {
            "column": "customer_destination cd",
            "value": "t.shipment_destination = cd.id",
            "relation": "JOIN",
            "kind": "cd.description AS customer_destination_description, cd.code AS customer_destination_code"
        },
        {
            "column": "customer c",
            "value": "cd.customer_id = c.id",
            "relation": "JOIN",
            "kind": "c.description AS customer_description, c.code AS customer_code"
        },
        {
            "column": "customer_cost_center ccc",
            "value": "cd.customer_cost_center_id = ccc.id",
            "relation": "JOIN",
            "kind": "ccc.description AS customer_cost_center_description"
        }
    ];

    init();

    function init() {
        localeFactory.detectLanguage();

        var authData = authFactory.getAuthData();
        azCod = authData.info.azCod;
        username = authData.authId;

        localeFactory.loadTranslation('dirt_acceptance_kit').then(function (){
            localeFactory.translateMsg({
                function_title : 'Accettazione Sporco Kit',
                table_readkit_title : 'Ultimi serial kit letti',
                table_consumedkit_title : 'Serial kit in stato consumato',
                table_head_customer : 'Cliente',
                table_head_customer_destination : 'Destinatario',
                table_head_barcode_inv : 'Barcode Inv.',
                table_head_barcode : 'Barcode Proc.',
                table_head_product_code : 'Codice Articolo',
                table_head_product_desc : 'Desc. Articolo',
                table_head_product_category : 'Specialistica',
                table_head_operation_date : 'Data',
                table_head_urgent_internal : 'Modifica proprietà',
                error_title : 'Errore',
                error_product_type_body: 'Product type non definito, definirlo tramite parametro di configurazione',
                error_barcode_not_found : 'Serial kit non presente'
            }, 'dirt_acceptance_kit').then(function(data) { 
                $scope.localeMessages = data;            

                // Configuration parameter used to know who is the type of serial kit
                matrixParFactory.getMatrixPar({key: 'KIT_PRODUCT_TYPE_CODE', d1: azCod, d2: '*', d3: '*', d4: '*', d5: '*'}).$promise.then(function(data){                
                    
                    if(data.value) {
                        kitProductTypeCode = data.value;
                        // Init column definitions for grid in view
                        initColumnDefGrids();
                        // Generate list of consumed serial kits
                        $scope.generateConsumedKitsTableData();
                        // Generate list for the latest N serial kits accepted by the current user
                        $scope.generateLatestSerialKitRead();
                    }
                    else {
                        toaster.pop('error', $scope.localeMessages.error_title, $scope.localeMessages.error_product_type_body);
                    }
                });   
            });
        });
    }

    //Switch status values or urgent or internal_proc properties on column table click
    $scope.switchStatusValue = function(columnName, columnValue, serialKitId) {
        if(columnValue == 'T') {
            columnValue = 'F';
        }
        else {
            columnValue = 'T';
        }
        var updateField = {};
        updateField[columnName] = columnValue;
        recordFactory('serial_kit').update({id: serialKitId}, updateField)
            .$promise.then(function (data) {
                $scope.generateLatestSerialKitRead();
            });
    };

    //Get map to show serial kits consumed
    $scope.generateConsumedKitsTableData = function () {
        //Get all serial kits with status "CONSUMED"
        if(kitProductTypeCode){
            var payload = {
                page: $scope.viewConsumedGridParams.pageNumber,
                page_size: $scope.viewConsumedGridParams.pageSize,
                sort_fields: ($scope.viewConsumedGridParams.sortFields?$scope.viewConsumedGridParams.sortFields:'barcode'),
                sort_order: $scope.viewConsumedGridParams.sortOrder
            };
            var consumedKitsFilters = filters.concat(dbFilterFactory.getStringFilter('t.status', 'CONSUMED'))
                    .concat($scope.viewConsumedGridParams.filters)
                    .concat(dbFilterFactory.getStringFilter('pt.code', kitProductTypeCode));

            recordFactory('serial_kit').filter(payload, consumedKitsFilters)
                .$promise.then(function (data) {
                    $scope.consumedKitsTableData.list = data.list;
                    $scope.consumedKitsTableData.totalResults = data.totalResults;
                    $scope.viewConsumedGridOptions.totalItems = data.totalResults;
                });
        }
    }

    //Get map to show latest serial kits accepted by the current user
    $scope.generateLatestSerialKitRead = function () {
        if(kitProductTypeCode){
            var payload = {
                page: $scope.viewReadGridParams.pageNumber,
                page_size: serialKitsReadMaxLength,
                sort_fields: ($scope.viewReadGridParams.sortFields?$scope.viewReadGridParams.sortFields:'operation_date'),
                sort_order: $scope.viewReadGridParams.sortOrder
            };
            var filtersLatestSerialKit = [
                {
                    "column": "serial_kit_status sks",
                    "value": "t.current_serial_kit_status_id = sks.id",
                    "relation": "JOIN",
                    "kind": "sks.operation_date AS operation_date"
                },
                {
                    "column": "human_resource hr",
                    "value": "hr.id = sks.operator_id",
                    "relation": "JOIN",
                    "kind": "hr.id as human_resource_id"
                },
                {
                    "column": "users u",
                    "value": "u.id = hr.user_id",
                    "relation": "JOIN",
                    "kind": "u.username as user_username"
                }
            ];
            var latestKitsFilters = filters.concat(filtersLatestSerialKit);
            latestKitsFilters = latestKitsFilters.concat(dbFilterFactory.getStringFilter('t.status', 'ACCEPTED'))
                    .concat($scope.viewReadGridParams.filters) // x Anna: aggancio i filtri sopra alle colonne
                    .concat(dbFilterFactory.getStringFilter('pt.code', kitProductTypeCode))
                    .concat(dbFilterFactory.getStringFilter('u.username', username));

            recordFactory('serial_kit').filter(payload, latestKitsFilters)
                .$promise.then(function (data) {
                    $scope.serialKitsRead = data.list;
                    $scope.serialKitsReadTableData.list = data.list;
                    $scope.serialKitsReadTableData.totalResults = data.totalResults;
                    $scope.viewReadGridOptions.totalItems = data.totalResults;
                    // x Anna: Fisso l'altezza della griglia
                    var height = ((data.totalResults * $scope.viewReadGridOptions.rowHeight) + 70);
                    $scope.viewReadGridParams.gridApi.grid.gridHeight = height;
                });  
        }
    }
    
    // Accept serial kit that was read
    $scope.readSerialKitCode = function(read){
        if(read.read) {
            var queryParameters = {
                barcode: read.read
            };
            
            dirtAcceptanceKitFactory.dirtAcceptanceKit(queryParameters,{}).$promise.then(function(data){
                // Acceptance error
                if(data.errorMessage) {
                    toaster.pop('error', $scope.localeMessages.error_title, $scope.localeMessages[data.errorMessage]);
                    return;
                }
                // Accptance success
                // Generate list of consumed serial kits
                $scope.generateConsumedKitsTableData();
                // Generate list for the latest N serial kits accepted by the current user
                $scope.generateLatestSerialKitRead();
            });
        }
    };

    // Set column def for grid to view
    function initColumnDefGrids() {
        $scope.viewConsumedGridOptions.columnDefs = [
            {
                displayName: $scope.localeMessages.table_head_customer_destination,
                field: 'customer_destination_code',
                enableFiltering:true,
                filters:[{
                    type: sixGridPaginationConstants.filterType.TEXT,
                    condition: uiGridConstants.filter.CONTAINS, //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
                    placeholder: '',
                    // x Anna: per far funzionare i filtri, ti mancavano queste due proprietà (nota: aliasResolver serve solo se fai un SELECT .. AS )
                    kind: 'string',
                    aliasResolver: 'cd.code'
                }]
            },
            {
                displayName: $scope.localeMessages.table_head_barcode_inv,
                field: 'barcode',
                enableFiltering: true,
                filters: [{
                    type: sixGridPaginationConstants.filterType.TEXT,
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: ''
                }]
            },
            {
                displayName: $scope.localeMessages.table_head_barcode,
                field: 'current_barcode',
                enableFiltering: true,
                filters: [{
                    type: sixGridPaginationConstants.filterType.TEXT,
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: ''
                }]
            },
            {
                displayName: $scope.localeMessages.table_head_product_code,
                field: 'product_code',
                enableFiltering: true,
                filters: [{
                    type: sixGridPaginationConstants.filterType.TEXT,
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: ''
                }]
            },
            {
                displayName: $scope.localeMessages.table_head_product_desc,
                field: 'product_description',
                enableFiltering: true,
                filters: [{
                    type: sixGridPaginationConstants.filterType.TEXT,
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: ''
                }]
            }
        ];  
        $scope.viewReadGridOptions.columnDefs = [
            {
                displayName: $scope.localeMessages.table_head_customer,
                field: 'customer_code',
                enableFiltering: false
            },
            {
                displayName: $scope.localeMessages.table_head_customer_destination,
                field: 'customer_destination_code',
                enableFiltering: false
            },
            {
                displayName: $scope.localeMessages.table_head_barcode_inv,
                field: 'barcode',
                enableFiltering: false
            },
            {
                displayName: $scope.localeMessages.table_head_product_desc,
                field: 'product_code',
                enableFiltering: false
            },
            {
                displayName: $scope.localeMessages.table_head_product_category,
                field: 'product_category_description',
                enableFiltering: false
            },
            {
                displayName: $scope.localeMessages.table_head_operation_date,
                field: 'operation_date',
                enableFiltering: false,
                cellFilter: 'date:"dd/MM/yyyy HH:mm:ss"'
            },
            {
                displayName: $scope.localeMessages.table_head_urgent_internal,
                field: 'urgent',
                enableFiltering: false,
                cellTemplate:
                '<div class="ui-grid-cell-contents" style="text-align: center; height: 44px;">' +
                    '<button class="btn m-r-lg btn-rounded btn-icon {{row.entity.urgent == \'T\' ? \'btn-success\' : \'btn-default\'}}" '+
                            'ng-click="grid.appScope.switchStatusValue(\'urgent\', row.entity.urgent, row.entity.id)"'+
                            'uib-tooltip="{{\'dirt_acceptance_kit.urgent_tooltip\' | translate}}"'+
                            'tooltip-placement="top"'+
                            'tooltip-trigger="mouseenter">'+
                        '<i class="fa fa-rocket"/>'+
                    '</button>' +
                    '<button class="btn btn-rounded btn-icon {{row.entity.internal_proc == \'T\' ? \'btn-success\' : \'btn-default\'}}" '+
                            'ng-click="grid.appScope.switchStatusValue(\'internal_proc\', row.entity.internal_proc, row.entity.id)"'+
                            'uib-tooltip="{{\'dirt_acceptance_kit.internal_tooltip\' | translate}}"'+
                            'tooltip-placement="top"'+
                            'tooltip-trigger="mouseenter">'+
                        '<i class="fa fa-home"/>'+
                    '</button>' +
                '</div>'
            }
        ];  
    }

 });

'use strict';

/**
 * @ngdoc factory
 * @name ictportal.washingCycleValidationFactory
 * @author Rita Beltrami
 * created on 21/09/2018
 * # autoclaveCycleValidationFactory
 * Factory in the ictportal.
 */
angular.module('ictportal.tnt')
    .factory('autoclaveCycleValidationFactory', function (SIX_URL, $resource) {
        return $resource(SIX_URL + '/rest/ferri/autoclavecycle/validation/:verb/:param1/:param2/:param3', {}, {
            cycleCompliant:    { method: 'POST', isArray: false, params: {verb: 'compliant'} },
            cycleNotCompliant:    { method: 'POST', isArray: false, params: {verb: 'notcompliant'} }
        });
    });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.ferri.dirtAcceptanceKitFactory
 * @description
 * # dirtAcceptanceKitFactory
 * Factory in the ictportal.ferri.
 */
angular.module('ictportal.ferri')
  .factory('dirtAcceptanceKitFactory', function (APP_URL, $resource) {
      return $resource(APP_URL + '/rest/ferri/dirtacceptancekit/:verb', {}, {
        dirtAcceptanceKit:                      {method: 'PUT'}
      });
  });

'use strict';

/**
 * @ngdoc factory
 * @name ictportal.notificationFactory
 * @author Rita Beltrami
 * created on 21/09/2018
 * # notificationFactory
 * Factory in the ictportal.
 */
angular.module('ictportal.tnt')
    .factory('notificationFactory', function (SIX_URL, $resource) {
        return $resource(SIX_URL + '/rest/ferri/notification/:verb/:param1/:param2/:param3', {}, {
            readNotification:    { method: 'POST', isArray: false, params: {verb: 'read'} }
        });
    });


'use strict';

/**
 * @ngdoc factory
 * @name ictportal.washingCycleValidationFactory
 * @author Rita Beltrami
 * created on 21/09/2018
 * # washingCycleValidationFactory
 * Factory in the ictportal.
 */
angular.module('ictportal.tnt')
    .factory('washingCycleValidationFactory', function (SIX_URL, $resource) {
        return $resource(SIX_URL + '/rest/ferri/washing/cycle/validation/:verb/:param1/:param2/:param3', {}, {
            cycleCompliant:    { method: 'POST', isArray: false, params: {verb: 'compliant'} },
            cycleNotCompliant:    { method: 'POST', isArray: false, params: {verb: 'notcompliant'} }
        });
    });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.ferri.controller:FerriWashingCycleValidationCtrl
 * @description Shows a list of washing lots and allowes users to validate them.
 * @author Rita Beltrami
 * 
 * created on 20/09/2018
 * # FerriWashingCycleValidationCtrl
 * Controller of the ictportal.ferri
 */
angular.module('ictportal.ferri')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/ferri/washingcycle/validation', {
                templateUrl: 'ferri/washing-cycle-validation/washing-cycle-validation.html',
                controller: 'FerriWashingCycleValidationCtrl'
            })
    })
    .controller('FerriWashingCycleValidationCtrl', function ($scope, recordFactory, $location, authFactory, dbFilterFactory, dialogService,
                                                            sixGridPaginationConstants, uiGridConstants, $log, $rootScope, matrixParFactory,
                                                            localeFactory, $q, toaster, eggsFormFactory, washingCycleValidationFactory, parseSchemaService) {

        var stepReader = {
            STEP1_2_WASH_PROD_ORDER_EQUIP: 'WASH_PROD_ORDER_EQUIP', // commessa di lavaggio (prod_order) o lavastrumenti --> una commessa di lavaggio equivale ad un carrello. Il barcode che vado a leggere infatti è del carrello
            STEP3_WASH_IS_COMPLIANT: "WASH_IS_COMPLIANT" // ciclo conforme/non conforme
        };

        var pageBundle = 'washing_cycle_validation';
        var msg = {
            operation_completed: "Operation completed",
            operation_completed_success: "Operation completed successfully",
            error: "Errore",
            confirm: "Conferma"
        };
        var page_msg = {
            "WASH": "Strumenti",
            "WASH_CONT": "Container",
            "table_detail_title": "Commessa",
            "table_detail_type_imb": "Imbustato",
            "table_detail_type_kit": "Kit",
            "table_detail_type_container": "Contenitore",
            "table_head_prod_order_type": "Tipo commessa",
            "table_head_prod_order_barcode": "Barcode carrello",
            "table_head_prod_order_code": "Codice commessa",
            "table_head_prod_order_date": "Data commessa",
            "table_head_equipment_code": "Lavastrumenti",
            "table_head_equipment_reason_code": "Programma lavaggio",
            "info_unselect_prod_order": "Commessa deselezionata",
            "error_prod_order_not_found": "Commessa non trovata",
            "error_prod_order_type_mismatch": "Commessa di produzione di tipo differente dalla precedente",
            "error_equipment_mismatch": "Lavastrumenti differente dalla precedente",
            "error_equipment_reason_mismatch": "Programma di lavaggio di tipo differente dal precedente",
            "error_washequip_prodord_not_found": "Commessa o lavasturmenti con barcode selezionato non presenti",
            "error_washequip_not_found": "Lavastrumenti con barcode selezionato non presente",
            "error_compliant_barcode_not_found": "Barcode di conformità/non conformità non valido"
        };
        var washProdOrderCodes = [];
        var equipmentWashContainerTypeCodes = [];
        var prodOrderWashTypeContainer = undefined;
        var compliantBarcode = undefined;
        var notCompliantBarcode = undefined;
        var baseEquipmentReasonFilter = [{
            column: 'equipment_wash_reason w',
            value: 'w.admittedwashingreasons_id = t.id',
            relation: 'JOIN',
            kind: 'w.equipment_id AS equipment_id'
        }].concat(dbFilterFactory.getStringFilter('discriminator', 'WASH'));
        var baseEquipmentFilter = [{
            column: 'container_type ct',
            value: 'ct.id = t.container_type_id',
            relation: 'JOIN',
            kind: 'ct.code AS ct_code'
        },
        {
            column: 'equipment_wash_reason ewr',
            value: 'ewr.equipment_id = t.id',
            relation: 'JOIN',
            kind: 'ewr.admittedwashingreasons_id AS addmitted_reason'
        }].concat(dbFilterFactory.getStringFilter('t.discriminator', 'WASH'))
                .concat(dbFilterFactory.getStringFilter('t.status', 'AVAILABLE'))
                .concat(dbFilterFactory.getNumberFilter('t.azcod', authFactory.getAuthData().info.azCod))
                .concat(dbFilterFactory.getCustomFilter("(t.divcod=" + authFactory.getAuthData().info.divCod +" OR t.divcod is null)"))
        var baseProdOrderDetFilter = [
            {
                column: 'customer_order co',
                value: 't.customer_order_id = co.id',
                relation: 'JOIN',
                kind: 'co.co_number as imbco_number, co.priority as imbco_priority'
            },
            {
                column: 'customer_destination cd',
                value: 'co.customer_destination = cd.id',
                relation: 'JOIN',
                kind: 'cd.barcode as imbco_barcode'
            },
            {
                column: 'serial_kit sk',
                value: 't.serial_kit_id = sk.id',
                relation: 'JOIN',
                kind: 'sk.barcode as sk_barcode, sk.urgent as sk_urgent'
            },
            {
                column: 'bom b',
                value: 'sk.bom_id = b.id',
                relation: 'JOIN',
                kind: 'b.item_id as bom_item_id'
            }
        ];
        var currentStepReader = stepReader.STEP1_2_WASH_PROD_ORDER_EQUIP;
        var currentProdOrderTypeSelected = undefined;
        $scope.hasAlreadyWashingEquipmentAssociated = undefined;
        $scope.isOnlyBarcodeUse = false; // utilizzo unicamente del barcode per procedere con gli step (permesso sul ruolo utente)
        $scope.msgUnion = {};
        $scope.showReport = false;
        $scope.reportParameters = {};
        $scope.productionOrdersSelected = [];
        $scope.record = {
            lookup: {},
            dates: [],
            model: {
                /* prod_order: [] */
            },
            detail: {
                currentProdOrderElement: null,
                currentProdOrderElementDetail: null,
                showProdOrderDetail: false
            }
        };
        $scope.params = {
            pageNumber: 1,
            pageSize: 15,
            code: 'component',
            filters: []
        };
        $scope.viewProductionOrdersGridOptions = { appScopeProvider: $scope };
        $scope.isCompliant = undefined;
        $scope.filter = {
            equipment: angular.copy(baseEquipmentFilter),
            equipment_reason_modal: angular.copy(baseEquipmentReasonFilter),
        }
        $scope.productionOrdersTableData = {};
        $scope.viewProductionOrdersGridParams = {
            pageNumber: 1,
            pageSize: 1000,
            sortOrder: 'desc',
            filters: []
        };
        $scope.gridApi;
        // ATTENZIONE: non spostare da qui
        $scope.sixRowSelectionChangedCallback = function(row, col, event){
            var rows = $scope.viewProductionOrdersGridOptions.gridApi.selection.getSelectedRows();
            // Se ho deselezionato tutto allora posso resettare il tipo ordine e il programma di lavaggio correnti letti
            if (rows.length <= 0) {
                currentProdOrderTypeSelected = undefined;
                $scope.record.model.equipment_reason_id = undefined;
                $scope.record.model.equipment_id = undefined;
                $scope.hasAlreadyWashingEquipmentAssociated = undefined;
            }
            $scope.productionOrdersSelected.length = 0;
            rows.forEach(function(item) {
                // Setto il primo tipo ordine selezionato
                if (currentProdOrderTypeSelected == undefined) {
                    currentProdOrderTypeSelected = item.pot_code;
                    setWashEquipmentType();
                }
                // Setto la prima lavastrumenti selezionato
                if ($scope.hasAlreadyWashingEquipmentAssociated == undefined && $scope.record.model.equipment_id == undefined) {
                    if (item.washing_equipment_id != undefined) {
                        $scope.record.model.equipment_id = item.washing_equipment_id;
                        $scope.hasAlreadyWashingEquipmentAssociated = true;
                    }
                    else {
                        $scope.hasAlreadyWashingEquipmentAssociated = false;
                    }
                }
                // Setto il primo programma di lavagaggio selezionato
                if ($scope.record.model.equipment_reason_id == undefined) {
                    $scope.record.model.equipment_reason_id = item.equipment_reason_id;
                    setWashEquipmentReason();
                }
                // Se non sono dello stesso tipo allora restituisco errore (posso selezionare solo ordini appartenenti allo stesso tipo ordine)
                if (item.pot_code != currentProdOrderTypeSelected) {
                    $scope.viewProductionOrdersGridOptions.gridApi.selection.unSelectRow(item);                  
                    toaster.error(msg.error, page_msg.error_prod_order_type_mismatch);
                }
                // Se non ho associato la stessa lavastrumenti allora restituisco errore (posso selezionare solo ordini appartenenti alla stessa lavastrumenti)
                else if (
                    ($scope.hasAlreadyWashingEquipmentAssociated == true && item.washing_equipment_id != $scope.record.model.equipment_id)
                    || ($scope.hasAlreadyWashingEquipmentAssociated == false && item.washing_equipment_id != undefined)
                ) {
                    $scope.viewProductionOrdersGridOptions.gridApi.selection.unSelectRow(item);
                    toaster.error(msg.error, page_msg.error_equipment_mismatch);
                }
                // Se non ho associato lo stesso programma di lavaggio allora restituisco errore (posso selezionare solo ordini appartenenti allo stesso programma di lavaggio)
                else if (item.equipment_reason_id != $scope.record.model.equipment_reason_id) {
                    $scope.viewProductionOrdersGridOptions.gridApi.selection.unSelectRow(item);
                    toaster.error(msg.error, page_msg.error_equipment_reason_mismatch);
                }
                // Se è tutto ok, seleziono la commessa di lavaggio
                else {
                    $scope.productionOrdersSelected.push(item.id);
                }
            });
        };
        $scope.viewProductionOrdersGridOptions = {
            appScopeProvider: $scope,
            multiSelect: true,
            enableRowHeaderSelection: true,
            enableRowSelection: true,
            rowHeight: 33,
            enablePaginationControls: true,
            rowSelectionChanged: $scope.sixRowSelectionChangedCallback
        };

        /**
         * View production order detail on right of screen
         */
        $scope.viewDetail = function(selected) {
            // Toggle: se riclicco sullo stesso elemento, nascondo il dettaglio. Se è un elemento nuovo, invece, lo mostro
            if ($scope.record.detail.currentProdOrderElement == null || (selected.id != $scope.record.detail.currentProdOrderElement.id)) {
                var filter = baseProdOrderDetFilter
                            .concat(dbFilterFactory.getNumberFilter('t.prod_order_id', selected.id));
                recordFactory('prod_order_load_equip_det').filter(filter).$promise
                    .then(function(data){
                        $scope.record.detail.currentProdOrderElementDetail = data.list;
                    });
                $scope.record.detail.currentProdOrderElement = selected;
                $scope.record.detail.showProdOrderDetail = true;
            }
            else {
                $scope.record.detail.currentProdOrderElement = null;
                $scope.record.detail.showProdOrderDetail = false; 
            }
        }

        $scope.getDetailRowStyleClass = function(item) {
            if (item.sk_urgent != undefined && item.sk_urgent == 'T') {
                return "row-urgent";
            }
            if (item.imbco_priority != undefined && item.imbco_priority == 'HIGH') {
                return "row-urgent";
            }
            return "";
        }

        $scope.isProdOrderWashTypeContainer = function() {
            if (prodOrderWashTypeContainer == $scope.record.detail.currentProdOrderElement.pot_code) {
                return true;
            }
            return false;
        }
       

        function initLookups() {
            eggsFormFactory.addLookup($scope.record.lookup, 'equipment_id',             'equipment',             't.code',     't.description');
        }

        function checkPermissions() {
            var profilingKey = 'FERRI-WASHING-CYCLE-VALIDATION';
            var permission = authFactory.getPermissions(profilingKey);
            if (!permission.EXEC) {
                $location.path('forbidden').search({ key: profilingKey });
            }
            else {
                $scope.isNewAllowed = permission.NEW;
                $scope.isDetailAllowed = permission.DETAIL;
                $scope.isUpdateAllowed = permission.UPDATE;
                $scope.isOnlyBarcodeUse = permission.USE_ONLY_DEVICE_BARCODE;
            }
        };

        // init prod order column grid
        function initProdOrderColumnDefGrids() {
            $scope.viewProductionOrdersGridOptions.columnDefs = [];
            $scope.viewProductionOrdersGridOptions.columnDefs.push(parseSchemaService.getEditCol());
            $scope.viewProductionOrdersGridOptions.columnDefs.push({
                name: $scope.translateValue('table_head_prod_order_type'),
                field: 'pot_code',
                enableFiltering: true,
                filters: [{
                    type: sixGridPaginationConstants.filterType.TEXT,
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: '',
                    kind: 'string',
                    aliasResolver: 'pot.code'
                }],
                cellTemplate:
                '<div class="ui-grid-cell-contents">{{grid.appScope.translateValue(row.entity.pot_code)}}</div>'
            });
            $scope.viewProductionOrdersGridOptions.columnDefs.push({
                name: "Barcode carrello",
                translation: 'table_head_prod_order_barcode',
                field: 'barcode',
                enableFiltering: true,
                filters: [{
                    type: sixGridPaginationConstants.filterType.TEXT,
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: '',
                    kind: 'string',
                    aliasResolver: 'c.barcode'
                }]
            });
            $scope.viewProductionOrdersGridOptions.columnDefs.push({
                name: "Codice commessa",
                translation: 'table_head_prod_order_code',
                field: 'code',
                enableFiltering: true,
                filters: [{
                    type: sixGridPaginationConstants.filterType.TEXT,
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: '',
                    kind: 'string',
                    aliasResolver: 't.code'
                }]
            });
            $scope.viewProductionOrdersGridOptions.columnDefs.push({
                name: "Data commessa",
                translation: 'table_head_prod_order_date',
                field: 'order_date',
                enableFiltering:false,
                cellTemplate:
                '<div class="ui-grid-cell-contents">{{grid.appScope.formatDateToString(COL_FIELD)}}</div>'
            });
            $scope.viewProductionOrdersGridOptions.columnDefs.push({
                name: "Lavastrumenti",
                translation: 'table_head_equipment_code',
                field: 'equipment_code',
                enableFiltering: true,
                filters: [{
                    type: sixGridPaginationConstants.filterType.TEXT,
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: '',
                    kind: 'string',
                    aliasResolver: 'e.code'
                }]
            });
            $scope.viewProductionOrdersGridOptions.columnDefs.push({
                name: "Programma lavaggio",
                translation: 'table_head_equipment_reason_code',
                field: 'reason_code',
                enableFiltering: true,
                filters: [{
                    type: sixGridPaginationConstants.filterType.TEXT,
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: '',
                    kind: 'string',
                    aliasResolver: 'er.code'
                }]
            });
        }

        function setWashEquipmentType() {
            // Se sto selezionando delle commesse di lavaggio per container, devo mostrare solo lavacontainer e non lavastrumenti
            if (prodOrderWashTypeContainer == currentProdOrderTypeSelected) {
                $scope.filter.equipment = angular.copy(baseEquipmentFilter)
                    .concat(dbFilterFactory.getInFilter('ct.code', equipmentWashContainerTypeCodes));
            }
            else {
                $scope.filter.equipment = angular.copy(baseEquipmentFilter);
            }
        }

        function setWashEquipmentReason() {
            if ($scope.record.model.equipment_reason_id != undefined) {
                $scope.filter.equipment = angular.copy(baseEquipmentFilter)
                    .concat(dbFilterFactory.getNumberFilter('ewr.admittedwashingreasons_id', $scope.record.model.equipment_reason_id));
            }
            else {
                $scope.filter.equipment = angular.copy(baseEquipmentFilter);
            }
        }

        $scope.translateValue = function(value) {
            console.log(value);
            return page_msg[value];
        }

        /**
         * Help dialog
         */
        $scope.showHelpDialog = function() {
            var dlgScope = {
              lang: 'html'
            };
            var dlgOpts = {
              name: 'helpDialog',
              closeByDocument: true,
              plain: false
            };
            var helpDialog = dialogService.templateDialog('helpTemplate.html', dialogService.DIALOG_TYPE.INFO, dlgScope, dlgOpts, -1, false, '50%');
        };
      

        // Code reader
        $scope.readCodeReader = function(read) {
            if(read.read) {
                console.log("Barcode read: ", read.read);
                switch (currentStepReader) {
                    // STEP1_2: leggo il barcode dei carrelli (minimo 1, posso leggerne più di 1). Un carrello equivale ad una commessa di lavaggio. 
                    // Se, invece di un carrello, riconosco una lavastrumenti vuol dire che ho finito di leggere le commesse e passo allo step2 di lettura lavastrumenti,
                    // in questo caso il barcode letto non è più del carello ma della lavastrumenti.
                    // Quindi posso leggere carrelli finché non mi arriva poi un barcode di lavasturmenti, a quel punto passo allo step successivo.
                    case stepReader.STEP1_2_WASH_PROD_ORDER_EQUIP:
                        $log.info("Read prod order or washing equipment with barcode: ", read.read);
                        readBarcodeProdOrderOrWashEquip(read.read);
                        break;
                    // STEP3: leggo il barcode per determinare se il ciclo è conforme o non conforme
                    case stepReader.STEP3_WASH_IS_COMPLIANT:
                        readBarcodeIsCompliant(read.read);
                        break;
                }
            }
        };

        // Load data for table to list production order (NOTDISPACHED) of type WASH and WASHCONT
        $scope.loadProductionOrders = function() {
            if (washProdOrderCodes.length > 0) {
                var filter = [
                    {
                        column: 'container c',
                        value: 't.container_id = c.id',
                        relation: 'JOIN',
                        kind: 'c.barcode AS barcode'
                    },
                    {
                        column: 'prod_order_type pot',
                        value: 't.prod_order_type_id = pot.id',
                        relation: 'JOIN',
                        kind: 'pot.code AS pot_code'
                    },
                    {
                        column: 'equipment_reason er',
                        value: 't.equipment_reason_id = er.id',
                        relation: 'JOIN',
                        kind: 'er.code AS reason_code'
                    },
                    {
                        column: 'equipment e',
                        value: 't.washing_equipment_id = e.id',
                        relation: 'JOIN',
                        kind: 'e.code AS equipment_code'
                    }
                ].concat(dbFilterFactory.getStringFilter('t.status', 'NOTDISPATCHED'))
                .concat(dbFilterFactory.getInFilter('pot.code', washProdOrderCodes))
                .concat($scope.viewProductionOrdersGridParams.filters); // aggancio i filtri sopra alle colonne;
                var payload = {
                    page: $scope.viewProductionOrdersGridParams.pageNumber,
                    page_size: $scope.viewProductionOrdersGridParams.pageSize,
                    sort_fields: ($scope.viewProductionOrdersGridParams.sortFields?$scope.viewProductionOrdersGridParams.sortFields:'order_date'),
                    sort_order: $scope.viewProductionOrdersGridParams.sortOrder
                };
                recordFactory('prod_order').filter(payload,filter).$promise
                    .then(function(data){
                        $scope.productionOrdersTableData.list = data.list;
                        $scope.productionOrdersTableData.totalResults = data.totalResults;
                        $scope.viewProductionOrdersGridOptions.totalItems = data.totalResults;
                        var height = (data.totalResults * $scope.viewProductionOrdersGridOptions.rowHeight) + 150;
                        $scope.viewProductionOrdersGridOptions.gridApi.grid.gridHeight = height;
                    });
            }
        }

        $scope.formatDateToString = function(dateToFormat) {
            return sixDateLib.getDateStringFormattedFromDate(new Date(dateToFormat));
        }

        $scope.toggleConfirmCycleCompliant = function() {
            if ($scope.isCompliant == true) {
                $scope.isCompliant = undefined;
                currentStepReader = stepReader.STEP3_WASH_IS_COMPLIANT; // Annulla la conferma, torno indietro di step
            }
            else {
                $scope.isCompliant = true;
                nextStepAfterCompliant();
            }         
        }

        $scope.toggleConfirmCycleNotCompliant = function() {
            if ($scope.isCompliant == false) {
                $scope.isCompliant = undefined;
                currentStepReader = stepReader.STEP3_WASH_IS_COMPLIANT; // Annulla la conferma, torno indietro di step
            }
            else {
                $scope.isCompliant = false;
                nextStepAfterCompliant();
            }
        }

        $scope.confirmNotCompliantWashingCycle = function(equipmentReason) {
            $scope.record.model.equipment_reason_id = equipmentReason.id;
            $scope.confirmWashingCycle();
        }

        $scope.confirmWashingCycle = function() {
            var payload = {
                washingEquipmentId: ""+$scope.record.model.equipment_id, // id lavastrumenti
                washingReasonId: ""+$scope.record.model.equipment_reason_id, // id programma lavaggio
                productionOrderIds: $scope.productionOrdersSelected // id ordini di produzione
            };
            if($scope.isCompliant) {
                washingCycleValidationFactory.cycleCompliant({},payload).$promise.then(function(data){
                    displayResult(data, true);
                });
            }
            else {
                washingCycleValidationFactory.cycleNotCompliant({},payload).$promise.then(function(data){
                    displayResult(data, false);
                });
            } 
        }

        $scope.reloadPage = function() {
            location.reload();
        }

        $scope.clearEquipmentLookup = function() {
            $scope.record.model.equipment_id = null;
            $scope.isCompliant = undefined;
            currentStepReader = stepReader.STEP1_2_WASH_PROD_ORDER_EQUIP; // torno allo step precedente
        }

        $scope.nextStepAfterEquipment = function() {
            // Ho letto la lavastrumenti, passo allo step successivo
            currentStepReader = stepReader.STEP3_WASH_IS_COMPLIANT; // passo allo step successivo
        }

        /**
         * Modale per selezionare la causale di non conformità del ciclo che si sta tentando di validare
         */
        function displayModal() {
            $scope.filter.equipment_reason_modal.length = 0;
            $scope.filter.equipment_reason_modal = angular.copy(baseEquipmentReasonFilter)
                                            .concat(dbFilterFactory.getNumberFilter('w.equipment_id',$scope.record.model.equipment_id))
                                            .concat(dbFilterFactory.getStringFilter('type', 'NOT_ACCORDANT')); // causali di non conformità
            $rootScope.$broadcast('washingCycleValidationModalCtrl_open');
        }

        /**
         * Se ho premuto su "conforme" convalido direttamente il ciclo.
         * Se ho premuto su "non conforme" apro la modale per scegliere la causale di non conformità.
         */
        function nextStepAfterCompliant() {
            // Se ho premuto "ciclo conforme" convalido direttamente il ciclo
            if ($scope.isCompliant) {
                $scope.confirmWashingCycle();
            }
            else {
                // Altrimenti, se ho premuto "ciclo non conforme", apro la modale che selezionare la causale di non conformità
                displayModal();
            }
        }
        

        /**
         * Tramite il barcode reader leggo o una commessa (prod_order) o una lavastrumenti
         * @param {*} barcode barcode letto
         */
        function readBarcodeProdOrderOrWashEquip (barcode) {
            // Cerco se esiste un prod_order associato ad un carrello con barcode passato
            // Se non ho letto nessun'altro prod_order restituisco errore poiché almeno un prod_order devo leggerlo
            // Altrimenti, se non esiste un prod_order cerco una lavastrumenti con barcode passato
            $log.info("Find valid prod order");
            // Cerco il prod_order con barcode passato
            var filter = [
                {
                    column: 'container c',
                    value: 't.container_id = c.id',
                    relation: 'JOIN',
                    kind: 'c.barcode AS barcode'
                },
                {
                    column: 'prod_order_type pot',
                    value: 't.prod_order_type_id = pot.id',
                    relation: 'JOIN',
                    kind: 'pot.code AS pot_code'
                }
            ].concat(dbFilterFactory.getStringFilter('c.barcode', barcode))
            .concat(dbFilterFactory.getStringFilter('t.status', 'NOTDISPATCHED'))
            .concat(dbFilterFactory.getInFilter('pot.code', washProdOrderCodes));

            var tryFindWashEquipment = false;

            // Se ho la seleziona multipla degli ordini posso leggere più ordini, altrimenti passo direttamente a cercare una lavastrumenti con barcode passato
            if ($location.search().single && $scope.productionOrdersSelected <= 0 || !$location.search().single) {

                recordFactory('prod_order').filter(filter).$promise
                    .then(function(data) {
                        var errorMsg = "";
                        if (data.totalResults <= 0) {
                            tryFindWashEquipment = true;
                        }
                        else {
                            var firstResult = data.list[0];
                            
                            tryFindWashEquipment = false;
                            
                            // Setto il primo tipo ordine selezionato
                            if (currentProdOrderTypeSelected == undefined) {
                                currentProdOrderTypeSelected = firstResult.pot_code;
                                setWashEquipmentType();
                            }
                            // Setto la prima lavastrumenti selezionato
                            if ($scope.hasAlreadyWashingEquipmentAssociated == undefined && $scope.record.model.equipment_id == undefined) {
                                if (firstResult.washing_equipment_id != undefined) {
                                    $scope.record.model.equipment_id = firstResult.washing_equipment_id;
                                    $scope.hasAlreadyWashingEquipmentAssociated = true;
                                }
                                else {
                                    $scope.record.model.equipment_id = undefined;
                                    $scope.hasAlreadyWashingEquipmentAssociated = false;
                                }
                            }
                            // Setto il primo programma di lavaggio selezionato
                            if ($scope.record.model.equipment_reason_id == undefined) {
                                $scope.record.model.equipment_reason_id = firstResult.equipment_reason_id;
                                setWashEquipmentReason();
                            }

                            var selItem = $scope.productionOrdersTableData.list.find(function(r) {
                                return r.id == firstResult.id;
                            });

                            // Se non sono dello stesso tipo allora restituisco errore (posso selezionare solo ordini appartenenti allo stesso tipo ordine)
                            if (firstResult.pot_code != currentProdOrderTypeSelected) {
                                $scope.viewProductionOrdersGridOptions.gridApi.selection.unSelectRow(selItem);
                                errorMsg = page_msg.error_prod_order_type_mismatch;
                            }
                            // Se non ho associato la stessa lavastrumenti allora restituisco errore (posso selezionare solo ordini appartenenti alla stessa lavastrumenti)
                            else if ($scope.hasAlreadyWashingEquipmentAssociated == true && firstResult.washing_equipment_id != $scope.record.model.equipment_id) {
                                $scope.viewProductionOrdersGridOptions.gridApi.selection.unSelectRow(selItem);
                                errorMsg = page_msg.error_equipment_mismatch;
                            }
                            // Se non ho associato lo stesso programma di lavaggio allora restituisco errore (posso selezionare solo ordini appartenenti allo stesso programma di lavaggio)
                            else if (firstResult.equipment_reason_id != $scope.record.model.equipment_reason_id)  {
                                $scope.viewProductionOrdersGridOptions.gridApi.selection.unSelectRow(selItem);
                                errorMsg = page_msg.error_equipment_reason_mismatch;
                            }
                            else if (!$scope.productionOrdersSelected.includes(firstResult.id)) {
                                $scope.viewProductionOrdersGridOptions.gridApi.selection.selectRow(selItem); // questo scatena l'evento sixRowSelectionChangedCallback
                            }
                            else {
                                $scope.viewProductionOrdersGridOptions.gridApi.selection.unSelectRow(selItem);
                                errorMsg = page_msg.info_unselect_prod_order;
                                toaster.info(errorMsg);
                                return;
                            }
                        }
                        // Se non ho trovato un prod_order ma ne avevo già letti in precedenza, posso provare a cercare una lavastrumenti
                        // Se non ho mai letto un prod_order restituisco errore. Prima della lavastrumenti devo avere un prod_order letto.
                        if (tryFindWashEquipment && $scope.productionOrdersSelected.length <= 0) {
                            tryFindWashEquipment = false;
                            errorMsg = page_msg.error_prod_order_not_found;
                        }

                        // Se ho già una lavasturmenti associata, non devo leggere il barcode della lavasturmenti
                        if (tryFindWashEquipment == true && $scope.hasAlreadyWashingEquipmentAssociated == true) {
                            tryFindWashEquipment = false;
                            readBarcodeIsCompliant(barcode);
                        }

                        // Verifico se non devo cercare la lavastrumenti
                        if (!tryFindWashEquipment) {
                            if (errorMsg != "") {
                                toaster.error(msg.error, errorMsg);
                            }
                            return;
                        }

                        // Altrimenti provo a leggere il barcode come barcode di una lavastrumenti
                        readBarcodeWashingEquipment(barcode);
                    });
            }
            else {
                // Se ho già una lavasturmenti associata, non devo leggere il barcode della lavasturmenti
                if ($scope.hasAlreadyWashingEquipmentAssociated == false) {
                    readBarcodeWashingEquipment(barcode);
                }
                else {
                    readBarcodeIsCompliant(barcode);
                }
            }
        }

        /**
         * Tramite il barcode reader leggo una lavastrumenti
         * @param {*} barcode barcode della lavastrumenti
         */
        function readBarcodeWashingEquipment(barcode) {
            $log.info("Find valid washing equipment");
            setWashEquipmentType();
            setWashEquipmentReason();
            var filter = $scope.filter.equipment.concat(dbFilterFactory.getStringFilter('t.barcode', barcode));
            recordFactory('equipment').filter(filter).$promise
                .then(function(data) {
                    // Se non ho alcun risultato restituisco errore
                    if (data.totalResults <= 0) {
                        var errorMsg = "";
                        if ($location.search().single) {
                            errorMsg = page_msg.error_washequip_not_found;
                        }
                        else {
                            errorMsg = page_msg.error_washequip_prodord_not_found;
                        }
                        toaster.error(msg.error, errorMsg); 
                    }
                    else {
                        // Altrimento ho letto una lavasturmenti, passo allo step successivo 
                        $scope.record.model.equipment_id = data.list[0].id;
                        $scope.record.lookup.equipment_id.obj = data.list[0];
                        eggsFormFactory.loadLookupData($scope.record.lookup, $scope.record.model);
                        $scope.nextStepAfterEquipment();
                    }
                });
        }

        /**
         * Tramite il barcode reader leggo il barcode di convalida "CONFROME" o "NON CONFORME".
         * Se è "CONFORME" convalido dirttamente il ciclo, altrimenti propongo una modale all'utente per selezionare la causale di non conformità.
         * @param {*} barcode barcode di conforme/non conforme
         */
        function readBarcodeIsCompliant(barcode) {
            $log.info("Read barcode compliant not compliant cycle");
            var readOk = false;
            if (barcode == compliantBarcode) {
                $scope.isCompliant = true;
                readOk = true;
            }
            else if (barcode == notCompliantBarcode) {
                $scope.isCompliant = false;
                readOk = true;
            }
            
            if (readOk) {
                nextStepAfterCompliant(); // Convalido o apro la modale
            }
            else {
                $scope.isCompliant = undefined;
                toaster.error(msg.error, page_msg.error_compliant_barcode_not_found);
            }
        }

        function displayResult(data, isCompliant) {
            $log.info(data);
            if (data.status == 'ok') {
                toaster.pop('success', msg.operation_completed, msg.operation_completed_success);

                //Show report
                if (isCompliant) {      
                    $scope.showReport = true;
                    $scope.reportParameters = {
                        "p_autoclave_id": $scope.record.model.equipment_id,
                        "p_date": data.result.date,
                        "p_barcode": data.result.barcode,
                        "p_cycle_id": data.result.cycleId
                    };
                }
                else {
                    location.reload();
                }
            }
            else {
                eggsFormFactory.logServerException(data, pageBundle);
            }
        }

        // Recupero da matrix par il codice del tipo commessa (tipo prod ordine) usato per il lavaggio
        function getWashProdOrderTypeCode(azCod, divCod) {
            var deferred = $q.defer();
    
            $q.all({
                washProdOrderCode: matrixParFactory.getValueOrDefault({key: 'productionOrderType.washingcycle', d1: azCod, d2: divCod, d3: '*', d4: '*', d5: '*'}, {defaultValue: "WASH"}).$promise,
                washContainerProdOrderCode: matrixParFactory.getValueOrDefault({key: 'productionOrderType.washingcontainercycle', d1: azCod, d2: divCod, d3: '*', d4: '*', d5: '*'}, {defaultValue: "WASH_CONT"}).$promise
            })
            .then(function(data){ 
                deferred.resolve(data);
            })
    
            return deferred.promise;
        }

        function translateGridColumns(){
            $scope.viewProductionOrdersGridOptions.columnDefs.forEach(function(col){
              if(col.translation) {
                if(page_msg[col.translation]){
                  col.displayName = page_msg[col.translation];
                  col.name = page_msg[col.translation];
                }
                else{
                  col.displayName = msg[col.translation];
                  col.name = msg[col.translation];
                }
              }
            });
            if($scope.viewProductionOrdersGridOptions.gridApi) {
                $scope.viewProductionOrdersGridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
            }
          }


        function init() {
            if($location.search().single) {
                $scope.viewProductionOrdersGridOptions.multiSelect = false;
            }
            initProdOrderColumnDefGrids();
            localeFactory.loadTranslation(pageBundle)
                .then(function(){
                    $q.all({
                        general: localeFactory.translateMsg(msg),
                        specific: localeFactory.translateMsg(page_msg, pageBundle),
                        prodOrderCode: getWashProdOrderTypeCode(authFactory.getAuthData().info.azCod, authFactory.getAuthData().info.divCod),
                        equipmentWashContainerTypeCodes: matrixParFactory.getValueOrDefault({key: 'containerTypeCode.washingContainer', d1: authFactory.getAuthData().info.azCod, d2: authFactory.getAuthData().info.divCod, d3: '*', d4: '*', d5: '*'}, {defaultValue: "WASH_CONT"}).$promise,
                        compliantBarcodeResponse: recordFactory('confpar').filter(dbFilterFactory.getStringFilter('t.name', 'EQUIPMENT_CONTROLLER_BARCODECOMPLIANT')).$promise, // barcode per definire ciclo conforme
                        notCompliantBarcodeResponse: recordFactory('confpar').filter(dbFilterFactory.getStringFilter('t.name', 'EQUIPMENT_CONTROLLER_BARCODENOTCOMPLIANT')).$promise, // barcode per definire ciclo non conforme
                    })
                    .then(function(data){ 
                        if (data.compliantBarcodeResponse.totalResults > 0) {
                            compliantBarcode = data.compliantBarcodeResponse.list[0].value; // barcode per convalida ciclo conforme
                        }
                        if (data.notCompliantBarcodeResponse.totalResults > 0) {
                            notCompliantBarcode = data.notCompliantBarcodeResponse.list[0].value; // barcode per convalida ciclo non conforme
                        }
                        if (data.equipmentWashContainerTypeCodes != null) {
                            equipmentWashContainerTypeCodes = data.equipmentWashContainerTypeCodes.result.value.trim().split(',');
                        }
                        prodOrderWashTypeContainer = data.prodOrderCode.washContainerProdOrderCode.result.value;
                        washProdOrderCodes = [data.prodOrderCode.washProdOrderCode.result.value, data.prodOrderCode.washContainerProdOrderCode.result.value];
                        //$scope.filter.prod_order_det = $scope.filter.prod_order_det
                        //                .concat(dbFilterFactory.getInFilter('pot.code', washProdOrderCodes));
                        $scope.loadProductionOrders(); // Ricarico per poter avere i soli prod_order con il tipo corretto
                        $scope.msgUnion = angular.extend({}, msg, page_msg);
                        translateGridColumns();
                    })
                    .catch(function(ex){});
                })
                .catch(function(ex){});  
            checkPermissions();
            initLookups();
        };

        //___ main ___
        init();

    });
'use strict';

/**
 * @ngdoc factory
 * @name ictportal.hpeControlReportProductionFactory
 * @author Mattia Freda
 * created on 01/10/2018
 * # hpeControlReportProductionFactory
 * Factory in the ictportal.
 */
angular.module('ictportal.hpe')
    .factory('hpeControlReportProductionFactory', function (SIX_URL, $resource) {
        return $resource(SIX_URL + '/rest/rcp/:verb/:param1/:param2/:param3', {}, {
            saveOrUpdateControlReportProduction:    { method: 'POST', isArray: false },
            deleteControlReportProduction:          { method: 'POST', isArray: false , params: {verb: 'delete'} }
        });
    });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.controller:GestioneagentiCtrl
 * @description
 * # GestioneagentiCtrl
 * Controller of the ictportal
 */
angular.module('ictportal.icteggs').config(function ($routeProvider) {
    $routeProvider
      .when('/ageana/detail', {
        templateUrl: 'icteggs/ageana/ageana.html',
        controller: 'GestioneagentiCtrl'
      })
      .when('/ageana/detail/:id', {
        templateUrl: 'icteggs/ageana/ageana.html',
        controller: 'GestioneagentiCtrl'
      })
  })
  .controller('GestioneagentiCtrl', function ($scope) {
    $scope.pageTitle = 'Gestione Agenti';
     
     
     $scope.agente = {
      id: undefined,
      nome: undefined,
      repartoid: undefined
    };

    $scope.checkFields = ['esc'];

    function initCheckboxes(){
      $scope.checkbox = {};
      $scope.checkFields.forEach(function(field){
        eggsFormFactory.addCheckbox($scope.checkbox,field);
      });
      // adding custom mappings
    };

 
        function getAgente(id) {
      recordFactory('ageana').byId({ id: id }).$promise.then(function (response) {
        $scope.agente = response;
        $log.info($scope.agente);
        
        
      });
    };
        function init() {
      schemaFactory().getCode({id: 'ageana'}).$promise.then(function (data) {
        $scope.sf = data;
       
        initCheckboxes();
        if (angular.isDefined($routeParams.id)) {
          getAgente($routeParams.id);
        }
      });
    };
    
    
    init();
        
        });
/**
 * Created by Rita Beltrami on 12/06/17.
 */
'use strict';

angular.module('ictportal.icteggs')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/tabnotestnd/detail', {
          templateUrl: 'icteggs/tabnotestnd/tabnotestnd.html',
          controller: 'TabnotestndCtrl'
        })
        .when('/tabnotestnd/detail/:id', {
          templateUrl: 'icteggs/tabnotestnd/tabnotestnd.html',
          controller: 'TabnotestndCtrl'
        })
  })
  .controller('TabnotestndCtrl', function ($scope, $log, recordFactory, $routeParams, 
                                          eggsFormFactory, toaster, dbFilterFactory, 
                                          authFactory, $q, $window,  $rootScope) {

    $scope.enum = {
        tiponote: [
          {
            label: 'Note testa',
            value: 'T'
          },
          {
            label: 'Note piede',
            value: 'P'
          },
          {
            label: 'Note riga',
            value: 'R'
          },
          {
            label: 'Nota fondo modulo',
            value: 'F'
          }
        ],
        visualizza: [
          {
            label: 'Sì',
            value: 'S'
          },
          {
            label: 'No',
            value: 'N'
          },
          {
            label: 'Automatica',
            value: 'A'
          }
        ]            
    };                                
    $scope.lookup = {};

    function getRecord(id) {
      recordFactory('tabnotestnd').byId({ id: id }).$promise.then(function (response) {
        $scope.record = response;
        eggsFormFactory.restore($scope.record);
        $rootScope.$broadcast('sixCheckbox:reload'); 
        eggsFormFactory.loadLookupData($scope.lookup, $scope.record);
        $log.info($scope.record);
      });
    };
    
    function getUtenteLogin(){
      var user = authFactory.getAuthData();
      var payloadUtente = {
        code: 'username',
        description: 'username',
        query: user.authId
      };
      recordFactory('utenti').query(payloadUtente)
        .$promise.then(function (data){
          if(data.totalResults>0){
            $scope.loginUser = data.list[0];
          }
          else{
            toaster.pop('warning','Attenzione','Utente di login non trovato');
          }
        });
    };

    $scope.$watch('record.attivo', function(newVal,oldVal){
        if(newVal==='N'){
            $scope.record.valido = new Date();
        }
        else {
            delete $scope.record['valido'];
        }
    });

    function customValidation(){
      var isValid = ($scope.record.codice);
      return isValid;
    };

    $scope.save = function(){
      if(customValidation()){
          if($scope.record.id){
              recordFactory('tabnotestnd').update({id: $scope.record.id},$scope.record)
                  .$promise.then(function(data){
                    toaster.pop('success','Operazione completata','Operazione completata con successo');
                    $window.history.back();
                  });
          }
          else{
              $scope.record.azcod = parseInt(authFactory.getAuthData().info.azCod);  
              recordFactory('tabnotestnd').create($scope.record)
                .$promise.then(function(data){
                  if(!data.id){
                    toaster.pop('error', 'Errore', 'Si è verificato un errore durante la fase di salvataggio');
                  }
                  else{
                    toaster.pop('success','Operazione completata','Operazione completata con successo');
                    $window.history.back();
                  }
                });
          }
      }
      else{
        toaster.pop('error', 'Codice mancante', 'Compilare tutti i campi e riprovare');
      }
    };

    $scope.delete = function(){
      recordFactory('tabnotestnd').delete({ id: $scope.record.id}).$promise.then(function (data) {
        if(data.result === 1){
            toaster.pop('success','Operazione completata','Operazione completata con successo');
            $window.history.back();
        }
        else{
            toaster.pop('error', 'Operazione fallita', 'Cancellazione non riuscita');
        }
      });
    };

    function init() {
      getUtenteLogin();
      eggsFormFactory.addLookup($scope.lookup, 'linguaid', 'lingua', 'lingua', 'descrizione');
      if (angular.isDefined($routeParams.id) && $routeParams.id!=='new') {
        getRecord($routeParams.id);
      }
      else{
        $scope.record = { attivo: 'S' };
      }
    };

    init();

  });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.controller:TaboperatoriCtrl
 * @description
 * # TaboperatoriCtrl
 * Controller of the ictportal
 */
angular.module('ictportal.icteggs').config(function ($routeProvider) {
  $routeProvider
    .when('/taboperatori/detail', {
      templateUrl: 'icteggs/taboperatori/taboperatori.html',
      controller: 'TaboperatoriCtrl'
    })
    .when('/taboperatori/detail/:id', {
      templateUrl: 'icteggs/taboperatori/taboperatori.html',
      controller: 'TaboperatoriCtrl'
    })
})
  .controller('TaboperatoriCtrl', function ($scope, recordFactory, $routeParams, $log, $rootScope, toaster, dbFilterFactory, schemaFactory, eggsFormFactory) {
    var centerPage = angular.element(document.getElementsByClassName('center-page')[0]);
    var overlay = angular.element(document.getElementsByClassName('list-sidebar-overlay')[0]);
    $scope.operatore = {
      attivo: 'S', femmina: 'S', tipoqualificasco: '00'
    };
    $scope.tipiSalarioSideList = [];
    $scope.tipiAssunzioneSideList = [];
    $scope.tipiSalarioSideFiltered = [];
    $scope.tipiAssunzioneSideFiltered = [];
    $scope.tipiSalarioOperatore = [];
    $scope.tipiAssunzione = [];
    $scope.selFamiliariDetr = undefined;
    $scope.selVecchiContr=undefined;
    $scope.familiariDetrazioni=[];
    $scope.vecchiContratti=[];
    $scope.documenti=[];
    $scope.assunzioniInqu=[];
    $scope.tipiSalarioFilter = "";
    $scope.tipiAssunzioneFilter = "";
    $scope.addCheckModel = [];
    $scope.remCheckModel = [];
    $scope.planOptions = {};
    $scope.planOptions.generateOverParent = false;
    $scope.planOptions.specifyAssets = false;
    $scope.planOptions.modelChanged = false;
    $scope.mappingLoaded = false;
    $scope.modal = {
      title: 'Conferma eliminazione',
      message: 'Sei sicuro di voler eliminare l\'elemento corrente?'
    };
    $scope.pageTitle = 'Dettaglio operatore';
    $scope.mode = {
      DEFAULT: 0,
      FAMILIARI_DETR: 1,
      DOCUMENTI_PAGE:2
    };
    $scope.selMode = $scope.mode.DEFAULT;
    $scope.SIDEBAR = {
      NONE: 0,
      TIPO_SALARIO: 1,
      LIVELLO_ASSUNZIONE: 2
    };
    $scope.sidebarIndex = $scope.SIDEBAR.NONE;
    $scope.enum = {
      sesso: [
        {
          label: 'Maschio',
          value: 'M'
        },
        {
          label: 'Femmina',
          value: 'F'
        }
      ],
      statocivile: [
        {
          label: 'Da definire',
          value: 'U'
        },
        {
          label: 'Libero/a',
          value: 'L'
        },
        {
          label: 'Coniugato/a',
          value: 'C'
        },

        {
          label: 'Divorziato/a',
          value: 'D'
        },
        {
          label: 'Separato/a',
          value: 'S'
        },
        {
          label: 'Vedovo/a',
          value: 'V'
        }

      ],
      tipoqualificasco: [

        {
          label: 'Nessuna',
          value: "00"
        },
        {
          label: 'Elementare',
          value: "10"
        },
        {
          label: 'Media',
          value: "20"
        },
        {
          label: 'Superiore no acc univ',
          value: "30"
        },
        {
          label: 'Superiore acesso univ',
          value: "40"
        },
        {
          label: 'Terziario',
          value: "50"
        },
        {
          label: 'Diploma univ',
          value: "60"
        },
        {
          label: 'Laurea',
          value: "70"
        }
      ],
      inviocedolino: [
        {
          label: 'Portale',
          value: 'P'
        },
        {
          label: 'Cartaceo',
          value: 'C'
        }],
      tiporetribuzione: [
        {
          label: 'Oraria',
          value: 'O'
        },
        {
          label: 'Mensile',
          value: 'M'
        }
      ],
      contrtipodurataprova: [
        {
          label: 'Giorni',
          value: 'G'
        },
        {
          label: 'Mesi',
          value: 'M'
        }
      ],
      duratalavoroperiodoprova: [
        {
          label: 'Giorni',
          value: 'G'
        },
        {
          label: 'Mesi',
          value: 'M'
        }
      ],
      tipoorario: [
        {
          label: 'Scegli',
          value: ''
        },
        {
          label: 'Part time',
          value: 'P'
        },
        {
          label: 'Tempo pieno',
          value: 'T'
        }
      ],
      contrtipocontratto: [

        {
          label: 'T.det.proroga',
          value: "P"
        },
        {
          label: 'T.det.cont.',
          value: "C"
        },
        {
          label: 'Tempo determinato',
          value: "D"
        },
        {
          label: 'Tempo indeterminato',
          value: "I"
        },
        {
          label: 'Stagionale',
          value: "S"
        },
        {
          label: 'Durata mesi',
          value: "M"
        }
      ],
    };

    $scope.uiselect = {
      model: undefined,
      costoindividuale: undefined,
      assunzioneforzamagg: undefined,//adeline
      distaccoparziale: undefined,
      distaccoazestero: undefined,//adeline

      options: [
        {
          label: 'Scegli',
          value: ''
        }
      ],
       presentazione: [
        {
          label: 'SI',
          value: 'S'
        },
        {
          label: 'NO',
          value: 'N'
        },
         {
          label: 'Esente',
          value: 'E'
        },
      ],
    };

    function updateOperatore(){
      recordFactory('taboperatori').update({id: $scope.operatore.id},$scope.operatore)
        .$promise.then(function(data){
          if(data.query){
            toaster.pop('success','Operatore salvato','Operazione completata');
          }
          else {
            toaster.pop('error', 'Si è verificato un errore', 'Operazione fallita. Si prega di riprovare.');
          }
        });
    };

    function createOperatore() {
      recordFactory('taboperatori').create($scope.operatore)
        .$promise.then(function (data) {
          $log.info(data);
          if (data.id) {
            $scope.operatore = data;
            toaster.pop('success', 'Operatore salvato', 'Operazione completata');
          }
          else {
            toaster.pop('error', 'Si è verificato un errore', 'Operazione fallita. Si prega di riprovare.');
          }
        });
    };

    $scope.saveOperatore = function () {
      if ($scope.operatore.id) {
        updateOperatore();
      }
      else {
        createOperatore();
      }
    };

    $scope.deleteOperatore = function () {
      if (!$scope.modal) {
        alert('Modal not found');
      }
      else {
        $scope.modal.title = 'Conferma eliminazione';
        $scope.modal.message = 'Sei sicuro di voler eliminare l\'operatore selezionato?';
        $scope.modal.callback = $scope.doDeleteOperatore;
        $rootScope.$broadcast('sixConfirmModal:open');
      }
    };

    $scope.doDeleteOperatore = function () {
      recordFactory('taboperatori').delete({ id: $scope.operatore.id })
        .$promise.then(function (data) {
          if (data.result === 1) {
            toaster.pop('success', 'Operatore eliminato', 'Operazione completata');
          }
          else {
            toaster.pop('error', 'Si è verificato un errore', 'Operazione fallita. Si prega di riprovare.');
          }
        });
    };

    function initAddCheckModel(length) {
      $scope.addCheckModel = [];
      for (var i = 0; i < length; i++) {
        $scope.addCheckModel.push(false);
      }
    };
    function initRemCheckModel(length) {
      $scope.remCheckModel = [];
      for (var i = 0; i < length; i++) {
        $scope.remCheckModel.push(false);
      }
    }

    $scope.openSidebar = function (sidebarIndex) {
      $scope.sidebarIndex = sidebarIndex;
      var sidebar = angular.element(document.getElementById('list-sidebar'));
      initAddCheckModel();
      sidebar.addClass('open');
      centerPage.addClass('center-open');
      $scope.isSidebarOpened = true;
      if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass('open')) {
        overlay.addClass('active');
      } else {
        overlay.removeClass('active');
      }
    };

    $scope.closeSidebar = function () {
      var sidebar = angular.element(document.getElementById('list-sidebar'));
      sidebar.removeClass('open');
      centerPage.removeClass('center-open');
      $scope.isSidebarOpened = false;
      if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass('open')) {
        overlay.addClass('active');
      } else {
        overlay.removeClass('active');
      }
    };
    $scope.clearSiderbar = function () {
      $scope.closeSidebar();
      $scope.planOptions.modelChanged = true;
    };

    function getTipiSalario() {
      var params = {
        page: 1,
        page_size: 10000
      };
      if ($scope.operatore.id) {
        var filter = dbFilterFactory.getNumberFilter('operatoreid', $scope.operatore.id);
        recordFactory('operatoritiposalario').filter(params, filter)
          .$promise.then(function (data) {
            if (data.list.length > 0) {
              var expected = data.list.length;
              var loaded = 0;
              data.list.forEach(function (row) {
                var item = {
                  model: {
                    code: undefined,
                    description: undefined
                  },
                  datafinesalario: row.datafinesalario
                };
                recordFactory('tabtiposalario').byId({ id: row.tiposalarioid }).$promise.then(function (data) {
                  item.codice = data.codice;
                  item.model.description = data.descrizione;
                  $scope.tipiSalarioOperatore.push(item);
                  loaded++;
                  if (loaded === expected) {
                    initRemCheckModel($scope.tipiSalarioOperatore.length);
                  }
                });
              }, this);
            }
          });
      }
    };


    function getTipiAssunzione() {
      var params = {
        page: 1,
        page_size: 10000
      };
      if ($scope.operatore.id) {
        var filter = dbFilterFactory.getNumberFilter('operatoreid', $scope.operatore.id);
        recordFactory('operatorilivelliassunzione').filter(params, filter)
          .$promise.then(function (data) {
            if (data.list.length > 0) {
              var expected = data.list.length;
              var loaded = 0;
              data.list.forEach(function (row) {
                var item = {
                  model: {
                    code: undefined,
                    description: undefined
                  },
                  dataprevistapassaggio: row.dataprevistapassaggio
                };
                recordFactory('tablivello').byId({ id: row.livelloassunzioneid }).$promise.then(function (data) {
                  item.codice = data.codice;
                  item.model.description = data.descrizione;
                  $scope.tipiAssunzione.push(item);
                  loaded++;
                  if (loaded === expected) {
                    initRemCheckModel($scope.tipiAssunzione.length);
                  }
                });
              }, this);
            }
          });
      }
    };
    function getFamiliariDetrazioni() {
      $scope.familiariDetrazioni.list.length = 0;
      var params = {
        page: 1,
        page_size: 10000
      };
      if ($scope.operatore.id) {
        var filter = dbFilterFactory.getNumberFilter('operatoreid', $scope.operatore.id);
        recordFactory('operatorifamiliaridetr').filter(params, filter)
          .$promise.then(function (data) {
            $scope.familiariDetrazioni.list = $scope.familiariDetrazioni.list.concat(data.list.map(eggsFormFactory.restore));
          });
      }
    };

    function getDocumenti(){
       var params = {
        page: 1,
        page_size: 10000
      };
      if($scope.operatore.id){
        var filter = dbFilterFactory.getNumberFilter('operatoreid',$scope.operatore.id);
        recordFactory('operatoridocumenti').filter(params, filter)
          .$promise.then(function (data) {
            if($scope.documenti && $scope.documenti.list){
              $scope.documenti.list = $scope.documenti.list.concat(data.list.map(eggsFormFactory.restore));
            }
          });
      }

    };
  function getVecchiContratti() {
      var params = {
        page: 1,
        page_size: 10000
      };
      if ($scope.operatore.id) {
        var filter = dbFilterFactory.getNumberFilter('operatoreid', $scope.operatore.id);
        recordFactory('operatoriscadenze').filter(params, filter)
          .$promise.then(function (data) {
            $scope.vecchiContratti.list = $scope.vecchiContratti.list.concat(data.list.map(eggsFormFactory.restore));
          });
      }
    };

    function loadTipiSalario() {
      var params = {
        page: 1,
        page_size: 10000
      };
      var body = [];
      recordFactory('tabtiposalario').filter(params, body).$promise.then(function (response) {
        $scope.tipiSalarioSideList = response.list;
        initAddCheckModel($scope.tipiSalarioSideList.length);
      });
    };

    function loadAssunzione() {
      var params = {
        page: 1,
        page_size: 10000
      };
      var body = [];
      recordFactory('tablivello').filter(params, body).$promise.then(function (response) {
        $scope.tipiAssunzioneSideList = response.list;
        initAddCheckModel($scope.tipiAssunzioneSideList.length);
      });

    };
    $scope.selectAssunzione = function () {
      $scope.openSidebar($scope.SIDEBAR.LIVELLO_ASSUNZIONE);
      loadAssunzione();
      var item2;
      $scope.tipiAssunzioneId = [];
      for (var i = 0; i < $scope.tipiAssunzione.length; i++) {
        item2 = $scope.tipiAssunzione[i];
        $scope.tipiAssunzioneId.push(item2.codice);
      }

    };


    $scope.selectSalario = function () {
      $scope.openSidebar($scope.SIDEBAR.TIPO_SALARIO);
      loadTipiSalario();
      var item;
      $scope.tipiSalarioId = [];
      for (var i = 0; i < $scope.tipiSalarioOperatore.length; i++) {
        item = $scope.tipiSalarioOperatore[i];
        $scope.tipiSalarioId.push(item.codice);
      }
    };



    $scope.confirmSelectItems = function (filteredList) {
      $scope.closeSidebar();
      for (var i = 0; i < $scope.addCheckModel.length; i++) {
        if ($scope.addCheckModel[i]) {
          var r = filteredList[i];

          $scope.tipiSalarioOperatore.push(r);

        }
      }
      initRemCheckModel($scope.tipiSalarioOperatore.length);
    };

    $scope.confirmSelectItems2 = function (filteredList) {
      $scope.closeSidebar();
      for (var i = 0; i < $scope.addCheckModel.length; i++) {
        if ($scope.addCheckModel[i]) {
          var r = filteredList[i];

          $scope.tipiAssunzione.push(r);

        }
      }
      initRemCheckModel($scope.tipiAssunzione.length);
    };

    $scope.selectAllAddCheck = function (array) {
      for (var i = 0; i < $scope.addCheckModel.length; i++) {
        $scope.addCheckModel[i] = true;
      }
    };
    $scope.unselectAllAddCheck = function (array) {
      for (var i = 0; i < $scope.addCheckModel.length; i++) {
        $scope.addCheckModel[i] = false;
      }
    };
    $scope.selectAllRemCheck = function (array) {
      for (var i = 0; i < $scope.remCheckModel.length; i++) {
        $scope.remCheckModel[i] = true;
      }
    };

    $scope.unselectAllRemCheck = function (array) {
      for (var i = 0; i < $scope.remCheckModel.length; i++) {
        $scope.remCheckModel[i] = false;
      }
    };
    $scope.removeItems = function () {
      var count = $scope.remCheckModel.length;
      var removed = 0;
      for (var i = 0; i < $scope.remCheckModel.length; i++) {
        if ($scope.remCheckModel[i]) {
          $scope.tipiSalarioOperatore.splice(i - removed, 1);
          removed++;
        }
      }
      count -= removed;
      initRemCheckModel(count);
    };
    $scope.removeItems2 = function () {
      var count = $scope.remCheckModel.length;
      var removed = 0;
      for (var i = 0; i < $scope.remCheckModel.length; i++) {
        if ($scope.remCheckModel[i]) {
          $scope.tipiAssunzione.splice(i - removed, 1);
          removed++;
        }
      }
      count -= removed;
      initRemCheckModel(count);
    };

    function getOperatore(id) {
      recordFactory('taboperatori').byId({ id: id }).$promise.then(function (response) {
        $scope.operatore = response;
        eggsFormFactory.convertDates($scope.operatore, $scope.dateFields);
        $log.info($scope.operatore);
        eggsFormFactory.loadLookupData($scope.lookup, $scope.operatore);
        $rootScope.$broadcast('sixCheckbox:reload');
        getTipiSalario();
        getTipiAssunzione();
        getFamiliariDetrazioni();
        getVecchiContratti();
        getDocumenti();
      });
    };

    function initCheckboxes() {
      $scope.checkbox = {};
      for (var key in $scope.sf.schema.properties) {
        var prop = $scope.sf.schema.properties[key];
        if (prop.format === 'eggscheckbox') {
          eggsFormFactory.addCheckbox($scope.checkbox, key);
        }
      }
      // adding custom mappings
      //eggsFormFactory.addCheckbox($scope.checkbox,field);
    };

    function initLookups() {
      $scope.lookup = {};
      for (var key in $scope.sf.schema.properties) {
        var prop = $scope.sf.schema.properties[key];
        if (prop.format === 'lookup') {
          eggsFormFactory.addLookup($scope.lookup, key, prop.entity_id, 'codice', 'descrizione');
        }
      }
      // adding custom mappings
      eggsFormFactory.addLookup($scope.lookup, 'bancaid', 'cganaban', 'bancod', 'banrag');
      eggsFormFactory.addLookup($scope.lookup, 'utenteid', 'utenti', 'username', 'nome,cognome');
      eggsFormFactory.addLookup($scope.lookup, 'motivazione', 'tabmotivazionescadcontratto', 'codice', 'descrizione');
      eggsFormFactory.addLookup($scope.lookup, 'tipodocumentoid', 'tabtipodoc', 'codice', 'descrizione');
      $scope.mappingLoaded = true;
    };

    $scope.addFamiliariDetrazioni = function () {
      $scope.selMode = $scope.mode.FAMILIARI_DETR;
      $scope.familiariDetrazioni.flags.show = true;
      $scope.familiariDetrazioni.selected = {};
    };

    $scope.addDocumenti = function(){
      $scope.selMode = $scope.mode.DOCUMENTI_PAGE;
      $scope.documenti.flags.show = true;
      $scope.documenti.selected = {};

    };

    $scope.selectDocumenti = function(row){
      $scope.selMode = $scope.mode.DOCUMENTI_PAGE;
      $scope.documenti.flags.show = true;
      $scope.documenti.selected = row;
    };
    $scope.saveVecchi = function () {
      $scope.vecchiContratti.list.forEach(function(row){
        saveVecchiContratti(row);
      })
    };
    
    function saveVecchiContratti(item){
      //una sola riga....devo fare per tot rige
      if(!item.id)
      
      { 
        item.riga = $scope.vecchiContratti.list.length + 1,
        item.operatoreid = $scope.operatore.id
        
        
      recordFactory('operatoriscadenze').create(item).$promise.then(function (data) {
        alert("created");
        $scope.vecchiContratti.list.push(item);
      });
    }
      else{
      recordFactory('operatoriscadenze').update({ id: item.id }, item).$promise.then(function (data) {
        alert("updated");
      });}
       
    }


    $scope.selectFamiliariDetrazioni = function(row){
      $scope.selMode = $scope.mode.FAMILIARI_DETR;
      $scope.familiariDetrazioni.flags.show = true;
      $scope.familiariDetrazioni.selected = row;
    };

    $scope.removeFamiliariDetrazioni = function (row) {
      recordFactory('operatorifamiliaridetr').delete({ id: row.id }, row).$promise.then(function (data) {
        if(data.result === 1){
          toaster.pop('success','Elemento cancellato','Operazione completata con successo');
          var index = $scope.familiariDetrazioni.list.indexOf(row);
          $scope.familiariDetrazioni.list.splice(index, 1);
        }
        else{
          toaster.pop('Error','Eliminazione fallita','Si è verificato un errore');
        }
      });
      $scope.familiariDetrazioni.showDetail = true;
      $scope.familiariDetrazioni.selected = row;
      $scope.familiariDetrazioni.flags.delete = true;
      $scope.familiariDetrazioni.flags.show = true;
    };

    $scope.removeVecchiContratti = function (row) {
      recordFactory('operatoriscadenze').delete({ id: row.id }, row).$promise.then(function (data) {
        var index = $scope.vecchiContratti.list.indexOf(row);
        $scope.vecchiContratti.list.splice(index, 1);
        toaster.pop('success','Elemento cancellato','Operazione completata con successo');
      });
    };

    $scope.removeAssunzioniInqu = function (row) {
      var index = $scope.assunzioniInqu.indexOf(row);
      $scope.assunzioniInqu.splice(index, 1);
  };

  $scope.removeDocumenti = function(row){
      var index=$scope.documenti.list.indexOf(row);
    $scope.documenti.list.splice(index,1);
    recordFactory('operatoridocumenti').delete({ id: row.id }, row).$promise.then(function (data) {
        alert("deleted");
      });

  };

  $scope.removeAssunzioniInqu = function(row){
    var index=$scope.assunzioniInqu.indexOf(row);
    $scope.assunzioniInqu.splice(index,1);
  };

    $scope.backToOp = function () {
      $scope.selMode = $scope.mode.DEFAULT;
      for (var key in $scope.showComp) {
        $scope.showComp[key] = false;
      }
    };

    $scope.onFamiliariDetrazioniClose = function () {
      $scope.backToOp();
      getFamiliariDetrazioni();
    };
    $scope.onDocumentiClose = function(){
      $scope.backToOp();
    };

    function initDates() {
      $scope.dateFields = [];
      $scope.sf.form[0].items[0].tabs.forEach(function (tab) {
        tab.items.forEach(function (item) {
          if (item.type === 'datepicker') {
            $scope.dateFields.push(item.key[0]);
          }
        });
      });
    };

    function init() {
      $scope.familiariDetrazioni = {
        selected: {},
        list: [],
        closeCallback: $scope.backToOp,
        flags: {
          show: false,
          delete: false
        }
      };
      $scope.vecchiContratti = {
        selected: {},
        list: [],
        closeCallback: $scope.backToOp,
        flags: {
          show: false,
          delete: false
        }
      };
      schemaFactory().getCode({ id: 'taboperatori' }).$promise.then(function (data) {
        $scope.sf = data;
        initLookups();
        initCheckboxes();
        initDates();
        if (angular.isDefined($routeParams.id)) {
          getOperatore($routeParams.id);
        }
      });
    };


    init();

  });

/**
 * Created by Rita Beltrami on 09/06/17.
 */
'use strict';

angular.module('ictportal.icteggs')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/tabumconvt/detail', {
          templateUrl: 'icteggs/tabumconvt/tabumconvt.html',
          controller: 'TabumconvtCtrl'
        })
        .when('/tabumconvt/detail/:id', {
          templateUrl: 'icteggs/tabumconvt/tabumconvt.html',
          controller: 'TabumconvtCtrl'
        })
  })
  .controller('TabumconvtCtrl', function ($scope, $log, recordFactory, $routeParams, 
                                          eggsFormFactory, toaster, dbFilterFactory, 
                                          authFactory, $q, $window) {

    $scope.coeff = 1;
    $scope.um1 = undefined;
    $scope.um2 = undefined;
    $scope.enum = {
      ope: [
        {
          label: '/',
          value: '/'
        },
        {
          label: '*',
          value: '*'
        }
      ]
    };

    $scope.invertOpe = function(field){
      switch(field){
        case 'first':
          $scope.enum.second = ($scope.enum.first==='/')?'*':'/';
          break;
        case 'second':
          $scope.enum.first = ($scope.enum.second==='/')?'*':'/';
          break;
      }
    };

    function getRecord(id) {
      recordFactory('tabumconvt').byId({ id: id }).$promise.then(function (response) {
        $scope.record = response;
        eggsFormFactory.restore($scope.record);
        $log.info($scope.record);
        getRows();
      });
    };

    function getRows(){
      var filter = dbFilterFactory.getNumberFilter('testataid', $scope.record.id);
      recordFactory('tabumconvc').filter({page_size: 10}, filter).$promise.then(function(response){
        $scope.rows = response.list;
        switch($scope.rows[0].ope){
          case '/':
            $scope.enum.first = '/';
            $scope.enum.second = '*';
            break;
          case '*':
            $scope.enum.first = '*';
            $scope.enum.second = '/';
            break;
        }
        $scope.um1 = $scope.rows[0].um1;
        $scope.um2 = $scope.rows[0].um2;
        $log.info($scope.rows);
      });
    }
    
    function getUtenteLogin(){
      var user = authFactory.getAuthData();
      var payloadUtente = {
        code: 'username',
        description: 'username',
        query: user.authId
      };
      recordFactory('utenti').query(payloadUtente)
        .$promise.then(function (data){
          if(data.totalResults>0){
            $scope.loginUser = data.list[0];
          }
          else{
            toaster.pop('warning','Attenzione','Utente di login non trovato');
          }
        });
    };

    function customValidation(){
      var isValid = ($scope.um1) && ($scope.um2) && ($scope.coeff);
      return isValid;
    };

    $scope.save = function(){
      if(customValidation()){
          if($scope.record.id){
              if($scope.loginUser){
                $scope.record.utvarid = $scope.loginUser.id;
                $scope.record.dtvar = new Date();
              }
              eggsFormFactory.convertDates($scope.record,['dtins','dtvar']);
              delete $scope.record['UUID'];
              recordFactory('tabumconvt').update({id: $scope.record.id},$scope.record)
                  .$promise.then(function(data){
                    var row0 = $scope.rows[0];
                    var row1 = $scope.rows[1];
                    row0.um1 = $scope.um1; row1.um1 = $scope.um2;
                    row0.um2 = $scope.um2; row1.um2 = $scope.um1;
                    row0.ope = $scope.ope; row1.ope = $scope.ope;
                    row0.coeff = $scope.coeff; row1.ope = $scope.coeff;
                    delete row0['UUID'];delete row1['UUID'];
                    var promises = [
                      recordFactory('tabumconvc').update(row0).$promise,
                      recordFactory('tabumconvc').update(row1).$promise,
                    ];
                    $q.all(promises).then(function (responses) {
                      toaster.pop('success','Salvataggio completato','Operazione completata con successo');
                    });
                  });
          }
          else{
              if($scope.loginUser){
                $scope.record.utinsid = $scope.loginUser.id;
                $scope.record.dtins = new Date();
              }
              $scope.record.azcod = parseInt(authFactory.getAuthData().info.azCod);  
              recordFactory('tabumconvt').create($scope.record)
                .$promise.then(function(data){
                  if(!data.id){
                    toaster.pop('error', 'Errore', 'Si è verificato un errore durante la fase di salvataggio');
                  }
                  else{
                    var row0 = {
                      testataid: data.id,
                      riga: 1,
                      um1: $scope.um1,
                      um2: $scope.um2,
                      ope: $scope.enum.first,
                      coeff: $scope.coeff
                    };
                    var row1 = {
                      testataid: data.id,
                      riga: 2,
                      um1: $scope.um2,
                      um2: $scope.um1,
                      ope: $scope.enum.second,
                      coeff: $scope.coeff
                    };
                    var promises = [
                      recordFactory('tabumconvc').create(row0).$promise,
                      recordFactory('tabumconvc').create(row1).$promise,
                    ];
                    $q.all(promises).then(function (responses) {
                      toaster.pop('success','Salvataggio completato','Operazione completata con successo');
                      $window.history.back();
                    });
                  }
                });
          }
      }
      else{
        toaster.pop('error', 'Dati necessari mancanti', 'Compilare tutti i campi e riprovare');
      }
    };

    $scope.delete = function(){
      recordFactory('tabumconvc').deleteByField({ id: $scope.record.id, param1: 'testataid'}).$promise.then(function (response) {
        recordFactory('tabumconvt').delete({ id: $scope.record.id }).$promise.then(function (data) {
          if(data.result === 1){
            toaster.pop('success','Operazione completata','Operazione completata con successo');
            $window.history.back();
          }
          else{
            toaster.pop('error', 'Operazione fallita', 'Cancellazione non riuscita');
          }
        });
      });
    };

    function init() {
      getUtenteLogin();
      if (angular.isDefined($routeParams.id) && $routeParams.id!=='new') {
        getRecord($routeParams.id);
      }
      else{
        $scope.record = {};
        $scope.rows = [{riga: 1},{riga: 2}];
      }
    };

    init();

  });

/**
 * Created by Rita Beltrami on 13/06/17.
 */
'use strict';

angular.module('ictportal.icteggs')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/tabvet/detail', {
                templateUrl: 'icteggs/tabvet/tabvet.html',
                controller: 'TabvetCtrl'
            })
            .when('/tabvet/detail/:id', {
                templateUrl: 'icteggs/tabvet/tabvet.html',
                controller: 'TabvetCtrl'
            })
    })
    .controller('TabvetCtrl', function ($scope, $log, recordFactory, $routeParams,
                                        eggsFormFactory, toaster, dbFilterFactory,
                                        authFactory, $q, $window, $rootScope) {

        /*Sidebar*/
        var centerPage = angular.element(document.getElementsByClassName('center-page')[0]);
        var overlay = angular.element(document.getElementsByClassName('list-sidebar-overlay')[0]);
        $scope.detailList       = { agenti: [], vettori: [], clienti: [], automezzi: [] }; // Riga della lista di dettaglio
        $scope.addCheckModel    = { agenti: [], vettori: [], clienti: [], automezzi: [] }; // Modelli per check sidebar
        $scope.disabledIds      = { agenti: [], vettori: [], clienti: [], automezzi: [] }; // Id righe da nascondere nella sidebar
        $scope.remCheckModel    = { agenti: [], vettori: [], clienti: [], automezzi: [] }; // Modelli per check pagina per rimozione elementi
        $scope.sideList         = { agenti: [], vettori: [], clienti: [], automezzi: [] }; // Lista righe sidebar
        $scope.srcDetailList    = { agenti: [], vettori: [], clienti: [], automezzi: [] }; // Elenco id a db al caricamento della pagina
        /*Sidebar - fine*/

        $scope.enum = { tracciato: [] };
        $scope.lookup = {};
        $scope.SIDEBAR = {
            NONE: 0,
            AGENTI: 1,
            VETTORI: 2,
            CLIENTI: 3,
            AUTOMEZZI: 4
        };
        $scope.sidebarIndex = $scope.SIDEBAR.NONE;

        function getRecord(id) {
            recordFactory('tabvet').byId({ id: id }).$promise.then(function (response) {
                $scope.record = response;
                eggsFormFactory.restore($scope.record);
                $rootScope.$broadcast('sixCheckbox:reload');
                eggsFormFactory.loadLookupData($scope.lookup, $scope.record);
                $log.info($scope.record);
            });
        };

        function getAgenti(id) {
            var params = {
                page_size: 10000
            };
            var body = dbFilterFactory.getNumberFilter('tabvetid', id);
            recordFactory('tabvetagenti').filter(params, body).$promise.then(function (response) {
                if(response.list.length>0){
                    var query = '';
                    response.list.forEach(function(e){
                        query += ' id=' + e.agenteid + ' OR ';
                    });
                    query = query.slice(0, -4);
                    var filter = dbFilterFactory.getCustomFilter(query);
                    recordFactory('ageana').filter(params, filter).$promise.then(function (data) {
                        $scope.detailList.agenti = $scope.detailList.agenti.concat(data.list);
                        $scope.srcDetailList.agenti = angular.copy($scope.detailList.agenti);
                    });
                }
            });
        };

        function getVettori(id) {
            var params = {
                page_size: 10000
            };
            var body = dbFilterFactory.getNumberFilter('tabvetid', id);
            recordFactory('tabvetvettori').filter(params, body).$promise.then(function (response) {
                if(response.list.length>0){
                    var query = '';
                    response.list.forEach(function(e){
                        query += ' id=' + e.vettoreid + ' OR ';
                        $scope.srcDetailList.vettori.push(e.vettoreid);
                    });
                    query = query.slice(0, -4);
                    var filter = dbFilterFactory.getCustomFilter(query);
                    recordFactory('tabvet').filter(params, filter).$promise.then(function (data) {
                        $scope.detailList.vettori = $scope.detailList.vettori.concat(data.list);
                        $scope.srcDetailList.vettori = angular.copy($scope.detailList.vettori);
                    });
                }
            });
        };

        function getClienti(id) {
            var params = {
                page_size: 10000
            };
            var body = dbFilterFactory.getNumberFilter('tabvetid', id);
            recordFactory('tabvetclienti').filter(params, body).$promise.then(function (response) {
                if(response.list.length>0){
                    var query = '';
                    response.list.forEach(function(e){
                        query += ' id=' + e.clienteid + ' OR ';
                        $scope.srcDetailList.clienti.push(e.clienteid);
                    });
                    query = query.slice(0, -4);
                    var filter = dbFilterFactory.getCustomFilter(query);
                    recordFactory('anacli').filter(params, filter).$promise.then(function (data) {
                        $scope.detailList.clienti = $scope.detailList.clienti.concat(data.list);
                        $scope.srcDetailList.clienti = angular.copy($scope.detailList.clienti);
                    });
                }
            });
        };

        function getAutomezzi(id) {
            var params = {
                page_size: 10000
            };
            var body = dbFilterFactory.getNumberFilter('tabvetid', id);
            recordFactory('tabvetautomezzi').filter(params, body).$promise.then(function (response) {
                if(response.list.length>0){
                    var query = '';
                    response.list.forEach(function(e){
                        query += ' id=' + e.automezzoid + ' OR ';
                        $scope.srcDetailList.automezzi.push(e.automezzoid);
                    });
                    query = query.slice(0, -4);
                    var filter = dbFilterFactory.getCustomFilter(query);
                    recordFactory('tabautomezzi').filter(params, filter).$promise.then(function (data) {
                        $scope.detailList.automezzi = $scope.detailList.automezzi.concat(data.list);
                        $scope.srcDetailList.automezzi = angular.copy($scope.detailList.automezzi);
                    });
                }
            });
        };

        function getUtenteLogin() {
            var user = authFactory.getAuthData();
            var payloadUtente = {
                code: 'username',
                description: 'username',
                query: user.authId
            };
            recordFactory('utenti').query(payloadUtente)
                .$promise.then(function (data) {
                    if (data.totalResults > 0) {
                        $scope.loginUser = data.list[0];
                    }
                    else {
                        toaster.pop('warning', 'Attenzione', 'Utente di login non trovato');
                    }
                });
        };

        $scope.$watch('record.attivo', function (newVal, oldVal) {
            if (newVal === 'N') {
                $scope.record.valido = new Date();
            }
            else if ($scope.record) {
                delete $scope.record['valido'];
            }
        });

        function customValidation() {
            var isValid = ($scope.record.codice);
            return isValid;
        };

        $scope.save = function () {
            if (customValidation()) {
                if ($scope.record.id) {
                    fillUtvaridDtvar($scope.record);
                    recordFactory('tabvet').update({ id: $scope.record.id }, $scope.record)
                        .$promise.then(function (data) {
                            toaster.pop('success', 'Operazione completata', 'Operazione completata con successo');
                            $window.history.back();
                        });
                }
                else {
                    fillUtinsidDtins($scope.record);
                    fillAzCode($scope.record);
                    $scope.record.azcod = parseInt(authFactory.getAuthData().info.azCod);
                    recordFactory('tabvet').create($scope.record).$promise.then(function (data) {
                        // save detail rows
                        var promises = [];
                        promises = promises.concat(getPromises('agenti'));
                        promises = promises.concat(getPromises('vettori'));
                        promises = promises.concat(getPromises('clienti'));
                        promises = promises.concat(getPromises('automezzi'));
                        /*if (!data.id) {
                            toaster.pop('error', 'Errore', 'Si è verificato un errore durante la fase di salvataggio');
                        }
                        else {
                            toaster.pop('success', 'Operazione completata', 'Operazione completata con successo');
                            $window.history.back();
                        }*/
                    });
                }
            }
            else {
                toaster.pop('error', 'Codice mancante', 'Compilare tutti i campi e riprovare');
            }
        };

        function getPromises(type){
/*            var promises = [];
            var tableName = 'tabvet' + type;
            var field = '';
            switch(type){
                case 'agenti':
                    field = 'agenteid';
                    break;
                case 'vettori':
                    field = 'vettoreid';
                    break;
                case 'clienti':
                    field = 'clientiid';
                    break;
                case 'automezzi':
                    field = 'automezzoid';
                    break;
            }
            $scope.detailList[type].forEach(function(item){

            });*/
        };

        function fillAzCode(document) {
            document.azcod = authFactory.getAuthData().info.azCod;
        };

        function fillUtvaridDtvar(document) {
            if ($scope.loginUser) {
                document.utvarid = $scope.loginUser.id;
                document.dtvar = new Date();
            }
        };

        function fillUtinsidDtins(document) {
            if ($scope.loginUser) {
                document.utinsid = $scope.loginUser.id;
            }
            if ($scope.loginUser) {
                document.dtins = new Date();
            }
        };

        $scope.delete = function () {
            recordFactory('tabvet').delete({ id: $scope.record.id }).$promise.then(function (data) {
                if (data.result === 1) {
                    toaster.pop('success', 'Operazione completata', 'Operazione completata con successo');
                    $window.history.back();
                }
                else {
                    toaster.pop('error', 'Operazione fallita', 'Cancellazione non riuscita');
                }
            });
        };

        $scope.editPwd = function () {
            alert('todo');
        };

        $scope.selectDetail = function (type) {
            $scope.openSidebar(type);
            switch(type){
                case 'agenti':
                    loadAgenti();
                    break;
                case 'vettori':
                    loadVettori();
                    break;
                case 'clienti':
                    loadClienti();
                    break;
                case 'automezzi':
                    loadAutomezzi();
                    break;
            }
        };

        function invalidateItems(type){
            var item;
            $scope.disabledIds[type] = [];
            for(var i=0; i<$scope.detailList[type].length; i++){
                item = $scope.detailList[type][i];
                $scope.disabledIds[type].push(item.id);
            }
        };

        $scope.isDisabledItem = function(id,type){
            var result;
            if($scope.disabledIds[type].indexOf(id) == -1) {
                result = false;
            }
            else{
                result = true;
            }
            return result;
        };

        function loadAgenti() {
            var params = {
                page_size: 10000
            };
            var body = [];
            recordFactory('ageana').filter(params, body).$promise.then(function (response) {
                $scope.sideList.agenti = response.list;
                initAddCheckModel($scope.sideList.agenti.length,'agenti');
                invalidateItems('agenti');
            });
        };

        function loadVettori() {
            var params = {
                page_size: 10000
            };
            var body = [];
            recordFactory('tabvet').filter(params, body).$promise.then(function (response) {
                $scope.sideList.vettori = response.list;
                initAddCheckModel($scope.sideList.vettori.length);
                invalidateItems('vettori');
            });
        };

        function loadClienti() {
            var params = {
                page_size: 10000
            };
            var body = [];
            recordFactory('anacli').filter(params, body).$promise.then(function (response) {
                $scope.sideList.clienti = response.list;
                initAddCheckModel($scope.sideList.clienti.length);
                invalidateItems('clienti');
            });
        };

        function loadAutomezzi() {
            var params = {
                page_size: 10000
            };
            var body = [];
            recordFactory('tabautomezzi').filter(params, body).$promise.then(function (response) {
                $scope.sideList.automezzi = response.list;
                initAddCheckModel($scope.sideList.automezzi.length);
                invalidateItems('automezzi');
            });
        };

        $scope.confirmSelectItems = function (filteredList,type) {
            $scope.closeSidebar();
            for (var i = 0; i < $scope.addCheckModel[type].length; i++) {
                if ($scope.addCheckModel[type][i]) {
                    var r = filteredList[i];
                    $scope.detailList[type].push(r);
                }
            }
            initRemCheckModel($scope.detailList[type].length,type);
        };

        $scope.selectAllRemCheck = function (type) {
            for (var i = 0; i < $scope.remCheckModel[type].length; i++) {
                $scope.remCheckModel[type][i] = true;
            }
        };

        $scope.unselectAllRemCheck = function (type) {
            for (var i = 0; i < $scope.remCheckModel[type].length; i++) {
                $scope.remCheckModel[type][i] = false;
            }
        };

        function initAddCheckModel(length,type) {
            $scope.addCheckModel[type] = [];
            for (var i = 0; i < length; i++) {
                $scope.addCheckModel[type].push(false);
            }
        };

        function initRemCheckModel(length,type) {
            $scope.remCheckModel[type] = [];
            for (var i = 0; i < length; i++) {
                $scope.remCheckModel[type].push(false);
            }
        };

        function getLastRow(list){
            var maxRiga = 0;
            list.forEach(function(item){
                if(item.riga>maxRiga){
                    maxRiga = item.riga;
                }
            });
        };

        $scope.openSidebar = function (type) {
            switch(type){
                case 'agenti':
                    $scope.sidebarIndex = $scope.SIDEBAR.AGENTI;
                    break;      
                case 'vettori':
                    $scope.sidebarIndex = $scope.SIDEBAR.VETTORI;
                    break;
                case 'clienti':
                    $scope.sidebarIndex = $scope.SIDEBAR.CLIENTI;
                    break;
                case 'automezzi':
                    $scope.sidebarIndex = $scope.SIDEBAR.AUTOMEZZI;
                    break;
            }
            var sidebar = angular.element(document.getElementById('list-sidebar'));
            initAddCheckModel(type);
            sidebar.addClass('open');
            centerPage.addClass('center-open');
            $scope.isSidebarOpened = true;
            if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass('open')) {
                overlay.addClass('active');
            } else {
                overlay.removeClass('active');
            }
        };

        $scope.closeSidebar = function () {
            var sidebar = angular.element(document.getElementById('list-sidebar'));
            sidebar.removeClass('open');
            centerPage.removeClass('center-open');
            $scope.isSidebarOpened = false;
            if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass('open')) {
                overlay.addClass('active');
            } else {
                overlay.removeClass('active');
            }
        };

        $scope.clearSiderbar = function () {
            $scope.closeSidebar();
        };

        $scope.selectAllAddCheck = function (array,type) {
            for (var i = 0; i < $scope.addCheckModel[type].length; i++) {
                $scope.addCheckModel[type][i] = true;
            }
        };

        $scope.unselectAllAddCheck = function (array,type) {
            for (var i = 0; i < $scope.addCheckModel[type].length; i++) {
                $scope.addCheckModel[type][i] = false;
            }
        };

        $scope.removeItems = function (type) {
            var count = $scope.remCheckModel[type].length;
            var removed = 0;
            for (var i = 0; i < $scope.remCheckModel[type].length; i++) {
                if ($scope.remCheckModel[type][i]) {
                    $scope.detailList[type].splice(i - removed, 1);
                    removed++;
                }
            }
            count -= removed;
            initRemCheckModel(count,type);
        };

        function init() {
            getUtenteLogin();
            eggsFormFactory.addLookup($scope.lookup, 'fornitoreid', 'anafor', 'forcodice', 'forragsoc');
            eggsFormFactory.addLookup($scope.lookup, 'agerifid', 'ageana', 'codice', 'ragsoc');
            eggsFormFactory.addLookup($scope.lookup, 'tibobollatveid', 'tabtipobolla', 'codice', 'descrizione');
            eggsFormFactory.addLookup($scope.lookup, 'magazzinoid', 'maganag', 'magcod', 'magdes');
            eggsFormFactory.addLookup($scope.lookup, 'clienteid', 'anacli', 'clicodice', 'cliragsoc');
            eggsFormFactory.addLookup($scope.lookup, 'contoincassoid', 'cgpconti', 'pcover', 'pcoconto');
            recordFactory('tracciati').filter({ page_size: 1000 }, []).$promise.then(function (data) {
                data.list.forEach(function (item) {
                    $scope.enum.tracciato.push({ label: item.descrizione, value: item.codice });
                });
                if (angular.isDefined($routeParams.id) && $routeParams.id !== 'new') {
                    getRecord($routeParams.id);
                    getAgenti($routeParams.id);
                    getVettori($routeParams.id);
                    getClienti($routeParams.id);
                    getAutomezzi($routeParams.id);
                }
                else {
                    $scope.record = { attivo: 'S' };
                }
            });
        };

        init();

    });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:cartCompositionCtrl
 * @description
 * # cartCompositionCtrl
 * Controller of the ictportal.lm
 *
 * Antonio: [SIX-3266] Aggiungere un parametro allo StartPage della funzione. Se il parametro è = true allora il sistema si comporta come ora solo che effettua un controllo in fase di inserimento kit al carrello. Se il kit risulta già associato ad un carrello non può essere ri-assegnato, compare messaggio di errore. Se il paramentro è = false allora all’ingresso nella funzione il pulsante nuovo carrello è disattivato, posso solo richiamare un carrello esistente ed associare kit senza il controllo di cui sopra. In questo modo dovrei riuscire a mettere a menù due funzioni, una “composizione carrello” ed una seconda “spostamento carrello”.
 * Questo parametro è stato chiamato 'move'
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/cart/composition', {
                templateUrl: 'lm/cartComposition/cartComposition.html',
                controller: 'cartCompositionCtrl'
            })
    })
    .controller('cartCompositionCtrl', function ($scope, toaster, $location, $routeParams, serialKitLMFactory, $timeout, $filter,
        COMPONENT_READ_MODE, SCAN_KIND, dbFilterFactory, recordFactory, eggsFormFactory, $log, localStorageService,
        localeFactory) {

        var msg = {
            error_title: "Error",
            warning: "Warning",
            no_match_found: "No match found",
            invalid_kit_state: "Invalid kit state"
        };
        var cartCompositionMsg = {
            cart_selected_title: "Cart selected",
            cart_selected_msg: "Serial kits will be linked to cart with barcode {{barcode}}",
            cart_not_found_title: "Cart not found",
            cart_not_found_msg: "No serial kit associated do cart with barcode {{barcode}}",
            printer_unreachable_msg: "It was not possibile lo reach the printer",
            kit_already_associated_to_cart: "Kit already linked to a cart",
            kit_added_to_cart: "Kit added to cart with barcode",
            kit_removal_failure: "It's not possibile to remove the kit",
            kit_not_on_cart: "Serial kit is not on selected cart",
            kit_removed_from_cart: "Kit removed from cart with barcode"
        };
        $scope.TAB = {
            CART: 1,
            KIT: 2
        };
        $scope.activeTab = $scope.TAB.CART;
        $scope.serialKitList = [];
        $scope.settings = {};
        $scope.labelPrinted = false;
        $scope.addMode = true;
        $scope.jsFilter = '';
        $scope.userId = undefined;
        $scope.params = {
            pageNumber: 1,
            pageSize: 15,
            filters: []
        };
        $scope.cartReaderMode = COMPONENT_READ_MODE.BARCODE;
        $scope.compReaderMode = COMPONENT_READ_MODE.CODE;

        var allowedKitStatusList = [];

        var queryWithBarcode = [
          {
            "column": "bom b",
            "value": "t.bom_id = b.id",
            "relation": "JOIN",
            "kind": "b.id AS bom_id"
          },
          {
            "column": "product p",
            "value": "b.item_id = p.id",
            "relation": "JOIN",
            "kind": "p.description AS product_description, p.code AS product_code"
          },
          {
            "column": "product_type y",
            "value": "p.product_type_id = y.id",
            "relation": "JOIN",
            "kind": "y.description AS product_type_description, y.code AS product_type_code"
          }
        ];

        var queryWithUnicode = [
          {
            "column": "bom b",
            "value": "t.bom_id = b.id",
            "relation": "JOIN",
            "kind": "b.id AS bom_id"
          },
          {
            "column": "product p",
            "value": "b.item_id = p.id",
            "relation": "JOIN",
            "kind": "p.description AS product_description, p.code AS product_code"
          },
          {
            "column": "product_type y",
            "value": "p.product_type_id = y.id",
            "relation": "JOIN",
            "kind": "y.description AS product_type_description, y.code AS product_type_code"
          },
          {
            "column": "serial_kit_det skd",
            "value": "skd.serial_kit_id = t.id",
            "relation": "JOIN",
            "kind": "skd.id"
          }, {
            "column": "component c",
            "value": "c.id = skd.component_id",
            "relation": "JOIN",
            "kind": "c.unicode as component_unicode"
          }
        ];

        $scope.readCartCode = function (read) {
            if ($scope.activeTab === $scope.TAB.CART) {
                // Verifica se il carrello esiste e recupera i serial kit già presenti.
                var filters = [
                    {
                        "column": "bom b",
                        "value": "t.bom_id = b.id",
                        "relation": "JOIN",
                        "kind": "b.id AS bom_id"
                    },
                    {
                        "column": "product p",
                        "value": "b.item_id = p.id",
                        "relation": "JOIN",
                        "kind": "p.description AS product_description, p.code AS product_code"
                    },
                    {
                        "column": "product_type y",
                        "value": "p.product_type_id = y.id",
                        "relation": "JOIN",
                        "kind": "y.description AS product_type_description, y.code AS product_type_code"
                    }
                ];
                filters = filters.concat(dbFilterFactory.getStringFilter('envelope', read.read));
                recordFactory('serial_kit').filter({ page_size: 10000 }, filters)
                    .$promise.then(function (data) {
                        if (data.list && data.list.length > 0) {
                            localeFactory.translateReplace('cart_composition.cart_selected_msg', {barcode: read.read}).then(function(msg){
                                toaster.pop('success', cartCompositionMsg.cart_selected_title, msg);
                            })
                            $scope.cart = read.read;
                            reset(data.list);
                            $scope.activeTab = $scope.TAB.KIT;
                        }
                        else {
                            localeFactory.translateReplace('cart_composition.cart_not_found_msg', {barcode: read.read}).then(function(msg){
                                toaster.pop('error', cartCompositionMsg.cart_not_found_title, msg);
                            })
                        }
                    });
            }
        };

        function reset(cartKits) {
            $scope.serialKitList.length = 0;
            $scope.serialKitList = $scope.serialKitList.concat(cartKits);
        }

        $scope.setAddMode = function (value) {
            if (value != $scope.addMode) {
                $scope.addMode = value;
            }
        };

        // Se c'è, recupero la stampante di default per la workstation corrente
        function getWorkstationPrinter() {
            var workstation = localStorageService.get('workstation');
            if (workstation) {
                var payload = { workstation: workstation };
                serialKitLMFactory.getWsPrinter(payload).$promise.then(function (response) {
                    $scope.settings.label_printer_id = response.printer;
                    eggsFormFactory.loadLookupData($scope.lookup, $scope.settings);
                });
            }
        };

        $scope.generateBarcode = function () {
            serialKitLMFactory.getCartBarcode({ dummy: true }).$promise.then(function (response) {
                if (response.success) {
                    $scope.cart = response.barcode;
                    $scope.printBarcode();
                }
            });
        };

        $scope.printBarcode = function () {
            var payload = {
                barcode: $scope.cart,
                printer: $scope.lookup.label_printer_id.obj.code
            };
            serialKitLMFactory.printCartBarcode(payload).$promise
            .then(function (response) {
                $scope.activeTab = $scope.TAB.KIT;
                reset([]);
            })
            .catch(function(e) {
                toaster.pop('warning', msg.warning, cartCompositionMsg.printer_unreachable_msg);
            });
        };

        $scope.readComponentCode = function (read) {
            if ($scope.activeTab === $scope.TAB.KIT) {
                if ($scope.addMode) {
                    addKit(read);
                }
                else {
                    removeKit(read);
                }
            }
        };

        function addKit(read) {
            console.log("add Kit with read: " + read.read);
            if (getSerialKitIndexFromBarcode(read.read)===-1) {
                var baseFilters = queryWithBarcode;
                var filters = baseFilters.concat(dbFilterFactory.getStringFilter('barcode', read.read));
                recordFactory('serial_kit').filter({ page_size: 10000 }, filters).$promise.then(function (data) {
                  if (data.list) {
                    // se ho trovato dei serial kit
                    if(data.list.length > 0) {
                        addRecordToSerialKitList(data.list[0], read);
                    } else {
                        // se NON ho trovato serial kit, risolvo gli UNICODE
                        var componentFilters = queryWithUnicode;
                        componentFilters = componentFilters.concat(dbFilterFactory.getStringFilter('c.unicode', read.read));
                        recordFactory('serial_kit').filter({ page_size: 1, sort_order: 'desc' }, componentFilters).$promise.then(function (data) {
                        if(data.list && data.list.length > 0){
                            console.log("Barcode Kit to add " + data.list[0].barcode + " from unicode " + read.read);
                            addRecordToSerialKitList(data.list[0], read);
                        }
                        else{
                            toaster.pop('error', msg.error_title, msg.no_match_found);
                        }
                      });
                    }
                  }
                });
            }
        };

        function addRecordToSerialKitList (serialKit, read) {
          $log.info(serialKit);
          if (!isValidKitStatus(serialKit)) {
            toaster.pop('error', msg.error_title, msg.invalid_kit_state);
          }
          else if (serialKit.envelope != $scope.cart) {
            var item = { read: read };
            // Verifica componente già letto
            if (item.read.type === SCAN_KIND.BARCODE && item.read.read === serialKit.barcode) {
              item.serialKit = serialKit;
            }
            else if (item.read.type === SCAN_KIND.MANUAL && item.read.read === serialKit.barcode) {
              item.serialKit = serialKit;
              item.read.type = SCAN_KIND.BARCODE;
            }
            serialKit.added = true;
            serialKit.removed = false;
            if(!$scope.moveCartMode){
                if(angular.isDefined(serialKit.envelope)){
                    toaster.pop('error', msg.error_title, cartCompositionMsg.kit_already_associated_to_cart);
                    return;
                }
            }
            // controllo per evitare che le chiamate asincrone aggirino il primo controllo getSerialKitIndexFromBarcode()
            // quindi prima di fare una push controllo che una chiamata non abbia già popolato il mio array con lo stesso serialKit
            if (getSerialKitIndexFromBarcode(serialKit.barcode)===-1){

              // Per ora ne salvo una alla volta, ma è tutto predisposto per salvare in canna più serial kit. Vediamo che dice Ste
              serialKitLMFactory.setMotherEnvelope({ envelope: $scope.cart, serial_kit_list: [serialKit.id] }).$promise.then(function (data) {
                $log.info("Saved serial kit with MotherEnvelope -> id " + serialKit.id);
                toaster.pop('success', cartCompositionMsg.kit_added_to_cart, serialKit.barcode);
                $scope.serialKitList.push(serialKit);

              });
            } else {
              $log.info("Kit already saved in list (no setMotherEnvelope) -> id " + serialKit.id);
            }
          }
        }

        function removeKit(read) {
            console.log("remove Kit with read: " + read.read);
            var serialKit = null;
            var baseFilters = queryWithBarcode;
            var filters = baseFilters.concat(dbFilterFactory.getStringFilter('barcode', read.read));
            recordFactory('serial_kit').filter({ page_size: 10000 }, filters).$promise.then(function (data) {
              if (data.list) {
                // se ho trovato dei serial kit
                if(data.list.length > 0) {
                  serialKit = data.list[0];
                  deleteSerialKitFromList(serialKit);
                } else {
                  // se NON ho trovato serial kit, risolvo l'UNICODE
                  var componentFilters = queryWithUnicode;
                  componentFilters = componentFilters.concat(dbFilterFactory.getStringFilter('c.unicode', read.read));
                  recordFactory('serial_kit').filter({ page_size: 1, sort_order: 'desc' }, componentFilters).$promise.then(function (data) {
                    if(data.list && data.list.length > 0){
                      serialKit = data.list[0];
                      console.log("Barcode Kit to remove " + serialKit.barcode + " from unicode " + read.read);
                      deleteSerialKitFromList(serialKit);
                    }
                  });
                }
              }
            });
        };

        function deleteSerialKitFromList(serialKit) {
          var index = getSerialKitIndexFromBarcode(serialKit.barcode);
          if (index===-1) {
            toaster.pop('error', cartCompositionMsg.kit_removal_failure, cartCompositionMsg.kit_not_on_cart);
          }
          else {
            var serialKitFound = $scope.serialKitList[index];
            $scope.serialKitList.splice(index, 1);
            // Per ora ne salvo una alla volta, ma è tutto predisposto per salvare in canna più serial kit. Vediamo che dice Ste
            serialKitLMFactory.clearMotherEnvelope({ envelope: $scope.cart, serial_kit_list: [serialKitFound.id] }).$promise.then(function (data) {
              $log.info("Saved serial kit without MotherEnvelope -> id " + serialKitFound.id);
              toaster.pop('success', cartCompositionMsg.kit_removed_from_cart, serialKit.barcode);
            });
          }
        };

        function getSerialKitIndexFromBarcode(barcode) {
            var i;
            var found = false;
            for (i = 0; i < $scope.serialKitList.length; i++) {
                if ($scope.serialKitList[i].barcode === barcode) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                i = -1;
            }
            return i;
        };

        function isValidKitStatus(serialKit) {
            var result = false;
            if (serialKit && allowedKitStatusList.length > 0) {
                result = allowedKitStatusList.includes(serialKit.status);
            }
            return result;
        };

        function initLookups() {
            $scope.lookup = {};
            eggsFormFactory.addLookup($scope.lookup, 'label_printer_id', 'label_printer', 'code', 'description');
            $scope.mappingLoaded = true;
        };

        function reinit() {
            $scope.printer = false;
            $scope.packagingError = undefined;
            $scope.generatedBarcode = undefined;
            $scope.compList = [];
            $scope.cart = undefined;
        };

        $scope.goToNewCart = function(){
            reinit();
            $scope.activeTab = $scope.TAB.CART;
        };

        function getTranslations(){
            localeFactory.loadTranslation('cart_composition')
            .then(function() {
                localeFactory.translateMsg(msg);
                localeFactory.translateMsg(cartCompositionMsg, 'cart_composition');
            });
        };

        function init() {
            getTranslations();
            initLookups();
            getWorkstationPrinter();
            var move = $location.search().move;
            $scope.moveCartMode = angular.isDefined(move) && (move==='false');
            // [SIXLM-564] aggiunta elenco stati ammessi tramite parametro URL
            if ($routeParams.kitStatus) {
                allowedKitStatusList = $routeParams.kitStatus.split(',').
                    map(function(status) {
                        return status.trim();
                    });
            } else {
                // default a confezionato
                allowedKitStatusList = ["PACKED"];
            }
        };

        //___ main ___
        init();

    });

/**
 * Created by Rita Beltrami on 26/06/17.
 */
'use strict';

angular.module('ictportal.lm')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/six/component/detail', {
          templateUrl: 'lm/component/component_detail.html',
          controller: 'ComponentCtrl'
        })
        .when('/six/component/detail/:id', {
          templateUrl: 'lm/component/component_detail.html',
          controller: 'ComponentCtrl'
        })
  })
  .controller('ComponentCtrl', function ($scope, $log, recordFactory, $routeParams, $location,
                                          eggsFormFactory, toaster, dbFilterFactory, 
                                          authFactory, $q, $window,  $rootScope, schemaFactory) {

    $scope.pageTitle = 'Dettaglio componente';
    $scope.readOnly = true;                
    $scope.customer = {};
    $scope.enum = {
        special_use: [
          {
            name: 'Muletto',
            value: 'COURTESY'
          }
        ]            
    };      
    $scope.statix = {
      path: '',
      model: undefined
    };

    $scope.initStatix = function(path,model){
      $rootScope.$broadcast('statix:clean');
      $scope.statix.path = path;
      $scope.statix.model = model;
    };

    function initLookups() {
      $scope.lookup = { };
      $scope.customerLookup = {};
      for (var key in $scope.sf.schema.properties) {
        var prop = $scope.sf.schema.properties[key];
        if (prop.format === 'lookup') {
          eggsFormFactory.addLookup($scope.lookup, key, prop.entity_id, 'code', 'description');
        }
      }
      // adding custom mappings
      eggsFormFactory.addLookup($scope.customerLookup, 'customer_id', 'customer', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'product_id', 'product', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'employee_id', 'human_resource', 'matriculation', 'surname,name');
      eggsFormFactory.addLookup($scope.lookup, 'lot_id', 'lot', 'code', 'description');
      $scope.mappingLoaded = true;
    };

    function initDates() {
      $scope.dateFields = [];
      $scope.sf.form[0].items[0].tabs.forEach(function (tab) {
        tab.items.forEach(function (item) {
          if (item.type === 'datepicker') {
            $scope.dateFields.push(item.key[0]);
          }
        });
      });
    };

    function getComponentHistory(){
      var payload = {
        page_size: 10000,
        show_revision: false,
        sort_fields: 'operation_date',
        sort_order: 'desc'
      };
      var filters = dbFilterFactory.getNumberFilter('component_id',$scope.element.id);
      filters = filters.concat(dbFilterFactory.getCustomFilter("( status='S' OR status='ACCD' OR status='W' OR status='E' OR status='L' OR status='SW' OR status='C'  )"));
      recordFactory('component_status').filter(payload, filters)
          .$promise.then(function(data) {
            $log.info(data);
            $rootScope.$broadcast('sixComponentStatusGrid:dataLoaded','component_status',data.list);
      });
    };

    function getComponent(id) {
      recordFactory('component').byId({ id: id }).$promise.then(function (response) {
        $scope.element = response;
        eggsFormFactory.convertDates($scope.element, $scope.dateFields);
        $log.info($scope.element);
        eggsFormFactory.loadLookupData($scope.lookup, $scope.element);
        $rootScope.$broadcast('sixCheckbox:reload');
        getComponentHistory();
        $scope.initStatix($scope.element.unicode,{});
      });
    };

    function checkPermissions() {
      var profilingKey = 'XVERSUS_COMPONENT';
      var permission = authFactory.getPermissions(profilingKey);
      $scope.isUploadAllowed = permission.UPLOAD;
      $scope.isDeleteUploadAllowed = permission.DELETE_UPLOAD;
      // TODO: gestire exec?
    }

    function init() {
      schemaFactory().getCode({ id: 'component' }).$promise.then(function (data) {
        $scope.sf = data;
        initLookups();
        initDates();
        if (angular.isDefined($routeParams.id)) {
          getComponent($routeParams.id);
        }
      });
      checkPermissions();
    };

    init();

  });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:ComponentListCtrl
 * @description
 * # ComponentListCtrl
 * Controller of the ictportal.lm
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/component/list', {
                templateUrl: 'lm/component/component_list.html',
                controller: 'ComponentListCtrl'
            })
            .when('/component/list/:customer', {
                templateUrl: 'lm/component/component_list.html',
                controller: 'ComponentListCtrl'
            })
    })
    .filter('mapBoolean', function () {
        var genderHash = {
            1: 'Sì',
            2: 'No'
        };

        return function (input) {
            if (!input) {
                return '';
            } else {
                return genderHash[input];
            }
        };
    })
    .controller('ComponentListCtrl', function ($scope, $routeParams, $location, toaster, $q, dbFilterFactory,
        recordFactory, schemaFactory, uiGridConstants, $log, authFactory) {
        $scope.schemaFound = false;
        $scope.lockCustomer = false;
        $scope.list = {};
        $scope.customerFilter = []; // Filtro da applicare alla lookup sugli ospedali
        $scope.currentDestinationFilter = []; // Filtro da applicare sulle righe della tabella
        $scope.employeeCustomerFilter = []; // Filtro da applicare sulla lookup dei dipendenti
        $scope.renderTable = false;
        $scope.record = {
            model: {},
            lookup: {},
            dates: []
        };
        $scope.params = {
            pageNumber: 1,
            pageSize: 15,
            code: 'component',
            filters: []
        };
        $scope.viewGridOptions = { appScopeProvider: $scope};
        $scope.advFilter = {
            filter: {},
            list: []
        };

        $scope.lookup = {
            customer_id: {
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            },
            product_id: {
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            },
            size_id: {
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            },
            employee_id: {
                filter: dbFilterFactory.getStringFilter('discriminator', 'EMP'),
                obj: undefined,
                mapping: {
                    code: 'matriculation',
                    description: 'surname,name'
                }
            },
            lot_id: {
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'code,description'
                }
            },
            current_destination_id: {
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'code,description'
                }
            }
        };
        $scope.lookup.employee_id.filter.push({
            "column": "customer_destination c",
            "value": "t.destination_id = c.id",
            "relation": "JOIN",
            "kind": "c.customer_id"
        });

        $scope.$watchGroup(['advFilter.filter.barcode',
                            'advFilter.filter.customer_id',
                            'advFilter.filter.product_id',
                            'advFilter.filter.size_id',
                            'advFilter.filter.employee_id',
                            'advFilter.filter.lot_id',
                            'advFilter.filter.current_destination_id'], function () {
            $scope.applyFilter();
        });

        function joinTableWithCustomerDestination(){
            $scope.advFilter.list = $scope.advFilter.list.concat([
                {
                    "column": "human_resource h",
                    "value": "t.employee_id = h.id",
                    "relation": "JOIN",
                    "kind": "h.destination_id"
                },
                {
                    "column": "customer_destination c",
                    "value": "h.destination_id = c.id",
                    "relation": "JOIN",
                    "kind": "c.customer_id"
                }
            ]);
        };

        $scope.applyFilter = function () {
            $scope.advFilter.list.length = 0;
            if ($scope.advFilter.filter.barcode) {
                var f = dbFilterFactory.getLikeFilter('t.barcode', $scope.advFilter.filter.barcode);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.customer_id) {
                joinTableWithCustomerDestination();
                var f = dbFilterFactory.getNumberFilter('customer_id', $scope.advFilter.filter.customer_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if($scope.currentDestinationFilter.length>0){
                $scope.advFilter.list = $scope.advFilter.list.concat($scope.currentDestinationFilter);
            }
            if ($scope.advFilter.filter.product_id) {
                var f = dbFilterFactory.getNumberFilter('product_id', $scope.advFilter.filter.product_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.size_id) {
                var f = dbFilterFactory.getNumberFilter('size_id', $scope.advFilter.filter.size_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.lot_id) {
                var f = dbFilterFactory.getNumberFilter('lot_id', $scope.advFilter.filter.lot_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.employee_id) {
                var f = dbFilterFactory.getNumberFilter('employee_id', $scope.advFilter.filter.employee_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.current_destination_id) {
                var f = dbFilterFactory.getNumberFilter('current_destination_id', $scope.advFilter.filter.current_destination_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }

            $log.info($scope.advFilter.list);
            $scope.renderTable = false;
            $scope.getData();
        };

        function readLookups() {
            for (var key in $scope.schema.properties) {
                var prop = $scope.schema.properties[key];
                if (prop.format === 'lookup') {
                    $scope.record.lookup[key] = {
                        mapping: prop.mapping,
                        obj: {},
                        entity: prop.entity_id
                    };
                }
            }
        };

        function loadLookupCols() {
            // Raggruppo assieme i record che fanno riferimento ad una stessa entità (es. tutti quelli con customer_id=123)
            // In questo modo risolvo l'entità una volta sola per tutti.
            var lookupMap = {};
            $scope.lookupCols.forEach(function (lookup) {
                var field = lookup.field;
                lookupMap[field] = {};
                $scope.list.list.forEach(function (record) {
                    var id = record[field];
                    if (id) {
                        if(!lookupMap[field][id]){
                            lookupMap[field][id] = [];
                        }
                        lookupMap[field][id].push(record);
                    }
                });
            });
            // Recupero da DB i dati e li assegno ai rispettivi record.
            $scope.lookupCols.forEach(function (lookup) {
                for(var id in lookupMap[lookup.field]){
                    recordFactory(lookup.entity).byId({ id: id })
                        .$promise.then(function (data) {
                            data['model'] = { description: '' };
                            var tokens = lookup.mapping.description.split(',');
                            tokens.forEach(function (term) {
                                if (data[term]) {
                                    data['model'].description += data[term] + ' ';
                                }
                            });
                            data['model'].description = data['model'].description.trim();
                            lookupMap[lookup.field][data.id].forEach(function(record){
                                record[lookup.field + '_obj'] = data;
                            });
                        });
                }
            });
        };

        function readDates() {
            $scope.form[0].items[0].tabs.forEach(function (tab) {
                tab.items.forEach(function (item) {
                    if (item.type === 'datepicker') {
                        var t1 = $scope.record.dates;
                        var t2 = item.key[0];
                        $scope.record.dates.push(item.key[0]);
                    }
                });
            });
        };

        function loadDates() {
            $scope.record.dates.forEach(function (field) {
                $scope.list.list.forEach(function (record) {
                    if (record[field]) {
                        record[field] = new Date(record[field]);
                    }
                });
            });
        };

        /* Devo fare così perchè una vista ad elenco dei componenti ce l'ho anche in pagina dipendente ma le colonne da visualizzare sono diverse */
        function setColumns(data){
            data.columnDefs = [
                {
                    name: "Unicode",
                    field: "unicode"
                },
                {
                    name: "Barcode",
                    field: "barcode"
                },
                {
                    name: "Articolo",
                    field: "product_id"
                },
                {
                    name: "Taglia",
                    field: "size_id"
                },
                {
                    name: "Stato",
                    field: "status"
                }
            ];
        };

        function initGridColumns() {
            $scope.lookupCols = [];
            schemaFactory().getCode({ id: 'component' }).$promise.then(
                function (data) {
                    //data= {"code":"component","description":"Component","columnDefs":[{"name":"Componente","field":"product_id"},{"name":"Barcode","field":"barcode"},{"name":"Taglia","field":"size_id"},{"name":"Stato","field":"status"},{"name":"Bloccato","field":"locked"}],"schema":{"title":"component","type":"object","properties":{"last_modified_user_id":{"title":"Last_modified_user_id","type":"number","check":false,"format":"lookup","entity_id":"users","mapping":{"code":"codice","description":"descrizione"}},"expiration_date":{"title":"Expiration_date","type":"string","check":false},"employee_id":{"title":"Employee_id","type":"number","check":false,"format":"lookup","entity_id":"human_resource","mapping":{"code":"codice","description":"descrizione"}},"weight":{"title":"Weight","type":"string","check":false},"barcode":{"title":"Barcode","type":"string","check":true,"enableFiltering":false,"enableSorting":false},"location":{"title":"Location","type":"string","check":false},"unicode":{"title":"Unicode","type":"string","check":true},"created_date":{"title":"Created_date","type":"string","check":false,"enableFiltering":false,"enableSorting":false},"customer_order_row_id":{"title":"Customer_order_row_id","type":"number","check":false,"format":"lookup","entity_id":"customer_order_row","mapping":{"code":"codice","description":"descrizione"}},"supplier_id":{"title":"Supplier_id","type":"number","check":false,"format":"lookup","entity_id":"supplier","mapping":{"code":"codice","description":"descrizione"}},"next_qc":{"title":"Next_qc","type":"string","check":false},"size_id":{"title":"Size_id","type":"number","check":true,"format":"lookup","entity_id":"tab_size","mapping":{"code":"code","description":"description"}},"qc_period":{"title":"Qc_period","type":"string","check":false},"lot_id":{"title":"Lot_id","type":"number","check":false,"format":"lookup","entity_id":"lot","mapping":{"code":"code","description":"code,description"}},"packaging_plant_id":{"title":"Packaging_plant_id","type":"number","check":false,"format":"lookup","entity_id":"plant","mapping":{"code":"codice","description":"descrizione"}},"container_id":{"title":"Container_id","type":"number","check":false,"format":"lookup","entity_id":"container","mapping":{"code":"codice","description":"descrizione"}},"locked":{"title":"Locked","type":"string","check":true,"enableFiltering":false,"enableSorting":false},"assignment_type":{"title":"Assignment_type","type":"string","check":false},"order_plant_id":{"title":"Order_plant_id","type":"number","check":false,"format":"lookup","entity_id":"plant","mapping":{"code":"codice","description":"descrizione"}},"production_status":{"title":"Production_status","type":"string","check":false},"version":{"title":"Version","type":"string","check":false},"order_proc_status":{"title":"Order_proc_status","type":"string","check":false},"agreement_id":{"title":"Agreement_id","type":"number","check":false,"format":"lookup","entity_id":"agreement","mapping":{"code":"codice","description":"descrizione"}},"created_user_id":{"title":"Created_user_id","type":"number","check":false,"format":"lookup","entity_id":"users","mapping":{"code":"codice","description":"descrizione"}},"divcod":{"title":"Divcod","type":"string","check":false,"enableFiltering":false,"enableSorting":false},"current_plant_id":{"title":"Current_plant_id","type":"number","check":false,"format":"lookup","entity_id":"plant","mapping":{"code":"codice","description":"descrizione"}},"note":{"title":"Note","type":"string","check":false},"wash_num":{"title":"Wash_num","type":"string","check":false},"current_component_status_id":{"title":"Current_component_status_id","type":"number","check":true,"format":"lookup","entity_id":"component_status","mapping":{"code":"code","description":"description"}},"delivery_note_item_id":{"title":"Delivery_note_item_id","type":"number","check":false,"format":"lookup","entity_id":"shipment_item","mapping":{"code":"codice","description":"descrizione"}},"status":{"title":"status","type":"string","check":true,"format":"enum"},"last_operation_date":{"title":"Last_operation_date","type":"string","check":false},"last_modified_date":{"title":"Last_modified_date","type":"string","check":false},"product_id":{"title":"Product_id","type":"number","check":true,"format":"lookup","entity_id":"product","mapping":{"code":"code","description":"description"},"enableFiltering":false,"enableSorting":false},"plant_id":{"title":"Plant_id","type":"number","check":true,"format":"lookup","entity_id":"plant","mapping":{"code":"codice","description":"descrizione"}},"current_destination_id":{"title":"Current_destination_id","type":"number","check":false,"format":"lookup","entity_id":"customer_destination","mapping":{"code":"codice","description":"descrizione"}},"shipment_destination":{"title":"Shipment_destination","type":"number","check":false,"format":"lookup","entity_id":"customer_destination","mapping":{"code":"codice","description":"descrizione"}},"azcod":{"title":"Azcod","type":"string","check":true},"ster_num":{"title":"Ster_num","type":"string","check":false},"current_product":{"title":"Current_product","type":"number","check":true,"format":"lookup","entity_id":"product","mapping":{"code":"codice","description":"descrizione"}},"color_id":{"title":"Color_id","type":"number","check":false,"format":"lookup","entity_id":"color","mapping":{"code":"codice","description":"descrizione"}},"next_wash":{"title":"Next_wash","type":"string","check":false},"control_reason_id":{"title":"Control_reason_id","type":"number","check":true,"format":"lookup","entity_id":"control_reason","mapping":{"code":"code","description":"description"},"enableFiltering":false,"enableSorting":false},"special_use":{"title":"Special_use","type":"string","check":false,"format":"enum"}},"required":["barcode","current_product","plant_id","product_id"]},"form":[{"type":"fieldset","items":[{"type":"tabs","tabs":[{"title":"Base","items":[{"key":["created_date"],"type":"datepicker","title":"Created_date","required":false},{"key":["divcod"],"type":"string","title":"Divcod","required":false},{"key":["last_modified_date"],"type":"datepicker","title":"Last_modified_date","required":false},{"key":["barcode"],"type":"string","title":"Barcode","required":true},{"key":["expiration_date"],"type":"datepicker","title":"Expiration_date","required":false},{"key":["last_operation_date"],"type":"datepicker","title":"Last_operation_date","required":false},{"key":["locked"],"type":"eggscheckbox","title":"Locked","required":false},{"key":["note"],"type":"string","title":"Note","required":false},{"key":["order_proc_status"],"type":"string","title":"Order_proc_status","required":false},{"key":["production_status"],"type":"string","title":"Production_status","required":false},{"key":["status"],"type":"select","title":"Status","required":false,"titleMap":[{"name":"Nuovo","value":"N"},{"name":"Conforme","value":"C"},{"name":"Non conforme","value":"NC"},{"name":"Piegato","value":"F"},{"name":"Confezionato","value":"P"},{"name":"Spedito reparto","value":"S"},{"name":"Rientrato","value":"E"},{"name":"Dismesso","value":"A"},{"name":"Usato","value":"U"},{"name":"Lavato","value":"L"},{"name":"Lavaggio speciale","value":"SW"},{"name":"Sartoria","value":"T"},{"name":"Guardaroba","value":"W"},{"name":"Spedito lavanderia","value":"SL"},{"name":"Spedito guardaroba","value":"SWA"},{"name":"Sporco guardaroba","value":"DWA"},{"name":"Spedito CL","value":"PCW"},{"name":"Disperso","value":"LOST"},{"name":"Accettato reparto","value":"ACCD"},{"name":"Spedibile guard.","value":"SHPBLW"},{"name":"Spedibile rep.","value":"SHPBLD"},{"name":"Sterilizzato","value":"ST"}]},{"key":["ster_num"],"type":"string","title":"Ster_num","required":false},{"key":["unicode"],"type":"string","title":"Unicode","required":false},{"key":["version"],"type":"string","title":"Version","required":false},{"key":["wash_num"],"type":"string","title":"Wash_num","required":false},{"key":["created_user_id"],"type":"sixlookup","title":"Created_user_id","required":false},{"key":["last_modified_user_id"],"type":"sixlookup","title":"Last_modified_user_id","required":false},{"key":["agreement_id"],"type":"sixlookup","title":"Agreement_id","required":false},{"key":["control_reason_id"],"type":"sixlookup","title":"Control_reason_id","required":false,"entity_id":"control_reason"},{"key":["current_component_status_id"],"type":"sixlookup","title":"Current_component_status_id","required":false,"entity_id":"component_status"},{"key":["current_destination_id"],"type":"sixlookup","title":"Current_destination_id","required":false},{"key":["current_plant_id"],"type":"sixlookup","title":"Current_plant_id","required":false},{"key":["current_product"],"type":"sixlookup","title":"Current_product","required":true},{"key":["customer_order_row_id"],"type":"sixlookup","title":"Customer_order_row_id","required":false},{"key":["delivery_note_item_id"],"type":"sixlookup","title":"Delivery_note_item_id","required":false},{"key":["employee_id"],"type":"sixlookup","title":"Employee_id","required":false},{"key":["lot_id"],"type":"sixlookup","title":"Lot_id","required":false},{"key":["order_plant_id"],"type":"sixlookup","title":"Order_plant_id","required":false},{"key":["packaging_plant_id"],"type":"sixlookup","title":"Packaging_plant_id","required":false},{"key":["plant_id"],"type":"sixlookup","title":"Plant_id","required":true},{"key":["product_id"],"type":"sixlookup","title":"Product_id","required":true},{"key":["shipment_destination"],"type":"sixlookup","title":"Shipment_destination","required":false},{"key":["size_id"],"type":"sixlookup","title":"Size_id","required":false,"entity_id":"tab_size"},{"key":["supplier_id"],"type":"sixlookup","title":"Supplier_id","required":false},{"key":["assignment_type"],"type":"string","title":"Assignment_type","required":false},{"key":["qc_period"],"type":"string","title":"Qc_period","required":false},{"key":["next_qc"],"type":"datepicker","title":"Next_qc","required":false},{"key":["next_wash"],"type":"datepicker","title":"Next_wash","required":false},{"key":["color_id"],"type":"sixlookup","title":"Color_id","required":false},{"key":["container_id"],"type":"sixlookup","title":"Container_id","required":false},{"key":["weight"],"type":"string","title":"Weight","required":false},{"key":["special_use"],"type":"select","title":"Special_use","required":false,"titleMap":[{"name":"Muletto","value":"COURTESY"}]},{"key":["location"],"type":"string","title":"Location","required":false},{"title":"status","type":"uiselect","key":["status"],"titleMap":[{"name":"","value":""}]}]}]}]}]};
                    if (data.schema) {
                        setColumns(data);
                        $scope.sf = data;
                        if (data.schema && data.form) {
                            $scope.schema = data.schema;
                            $scope.form = data.form;
                            readLookups();
                            readDates();
                        }
                        if (data.schema || data.form) $scope.schemaFound = true;
                        if (data.columnDefs) {
                            $scope.viewGridOptions.columnDefs = [];
                            $scope.viewGridOptions.columnDefs.push({
                                displayName: '',
                                field: 'id',
                                width: 34,
                                enableCellEdit: false,
                                enableFiltering: false,
                                enableSorting: false,
                                cellTemplate:
                                '<div class="ui-grid-cell-contents" style="text-align: center">' +
                                '<button ng-click="grid.appScope.viewDetail(row.entity)" class="btn btn-xs btn-primary">' +
                                '<span class="fa fa-search"></span>' +
                                '</button>' +
                                '</div>'
                            });
                            data.columnDefs.forEach(function (item) {
                                item.enableFiltering = getEnableFiltering(item);
                                item.filters = [{
                                    type: 'text',
                                    condition: uiGridConstants.filter.CONTAINS,
                                    placeholder: '',
                                    kind: 'string'
                                }];
                                if ($scope.record.lookup[item.field]) {
                                    var prop = data.schema.properties[item.field];
                                    item.filters = [{
                                        type: 'lookup',
                                        condition: uiGridConstants.filter.CONTAINS,
                                        placeholder: '',
                                        kind: 'string',
                                        schema: prop,
                                        join: {
                                            column: prop.entity_id,
                                            value: 't.' + prop.title + ' = ' + prop.entity_id + '.id',
                                            relation: 'JOIN',
                                            kind: ''
                                        }
                                    }];
                                    var lookup = $scope.record.lookup[item.field];
                                    lookup.field = item.field;
                                    item.field = item.field + '_obj.model.description';
                                    item.enableSorting = false;
                                    $scope.lookupCols.push(lookup);
                                }
                                else if (isDate(item.field)) {
                                    item.filters = [
                                        {
                                            type: 'date',
                                            relation: '>=',
                                            placeholder: 'da...',
                                            kind: 'date',
                                            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
                                        },
                                        {
                                            type: 'date',
                                            relation: '<=',
                                            placeholder: 'a...',
                                            kind: 'date',
                                            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
                                        }
                                    ];
                                    item.cellTemplate = '<div class="ui-grid-cell-contents">{{ row.entity.' + item.field + ' | date:\'dd/MM/yyyy\' }}</div>'
                                }
                                else if (isBoolean(item.field)) {
                                    var options = [{
                                        value: 'S',
                                        label: 'Sì'
                                    }, {
                                        value: 'N',
                                        label: 'No'
                                    }];
                                    item.filter = {
                                        type: uiGridConstants.filter.SELECT
                                    };
                                    item.editDropdownOptionsArray = options;
                                    item.filter.selectOptions = options.map(function (obj) {
                                        var rObj = { 'value': obj.value, 'label': obj.label };
                                        return rObj;
                                    });
                                    item.cellTemplate = '<div class="ui-grid-cell-contents"><span ng-if="row.entity.' + item.field + '===\'S\'" >Sì</span><span ng-if="row.entity.' + item.field + '!==\'S\'" >No</span></div>'
                                }
                                else if(isEnum(item.field)){
                                    var options = getTitleMap(item.field);
                                    item.filter = {
                                        type: uiGridConstants.filter.SELECT
                                    };
                                    item.editDropdownOptionsArray = options;
                                    item.filter.selectOptions = options.map(function(obj) {
                                        var rObj = {'value': obj.value, 'name': obj.label};
                                        return rObj;
                                    });
                                    item.cellTemplate = '<div class="ui-grid-cell-contents">';
                                    options.forEach(function(opt){
                                        item.cellTemplate += '<span ng-if="row.entity.' + item.field + '===\'' + opt.value + '\'" >' + opt.name + '</span>';
                                    });
                                    item.cellTemplate += '</div>';
                                }
                                $scope.viewGridOptions.columnDefs.push(item)
                            });
                        };
                    }
                    // Default
                    else {
                        setDefaultColumns();
                    }
                }
            )
            .catch(function(){
                setDefaultColumns();
            });
        };

        function setDefaultColumns(){
            $scope.viewGridOptions.columnDefs = [];
            $scope.viewGridOptions.columnDefs.push({
                displayName: '',
                field: 'id',
                width: 34,
                enableCellEdit: true,
                enableFiltering: false,
                enableSorting: false,
                cellTemplate:
                '<div class="ui-grid-cell-contents" style="text-align: center">' +
                '<button ng-click="grid.appScope.viewDetail(row.entity)" class="btn btn-xs btn-primary">' +
                '<span class="fa fa-search"></span>' +
                '</button>' +
                '</div>'
            });
            $scope.viewGridOptions.columnDefs.push({
                displayName: capitalize($routeParams.code),
                field: 'model.code',
                enableFiltering: true,
                filters: [{
                    type: 'text',
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: '',
                    kind: 'string'
                }]
            });
            $scope.viewGridOptions.columnDefs.push({
                displayName: 'Description',
                field: 'model.description',
                enableFiltering: true,
                filters: [{
                    type: 'text',
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: '',
                    kind: 'string'
                }]
            });
        }

        function getEnableFiltering(item) {
            return false;
        };

        function getTitleMap(field){
            var titleMap = [];
            for(var i=0; i<$scope.form[0].items[0].tabs.length; i++){
                var tab = $scope.form[0].items[0].tabs[i];
                var index = tab.items.findIndex(function(e) { return e.key[0] == field; });
                if(index>=0){
                    if(tab.items[index].titleMap){
                        titleMap = tab.items[index].titleMap;
                    }
                    break;
                }
            }
            return titleMap;
        };

        function isEnum(field){
            var isAnEnum = false;
            if($scope.sf.schema.properties[field]){
                isAnEnum = $scope.sf.schema.properties[field].format==='enum';
            }
            return isAnEnum;
        };

        function isDate(field) {
            var isADate = false;
            for (var i = 0; i < $scope.form[0].items[0].tabs.length; i++) {
                var tab = $scope.form[0].items[0].tabs[i];
                var index = tab.items.findIndex(function (e) { return e.key[0] == field; });
                if (index >= 0) {
                    isADate = (tab.items[index].type === 'datepicker');
                    break;
                }
            }
            return isADate;
        };

        function isBoolean(field) {
            var isABoolean = false;
            for (var i = 0; i < $scope.form[0].items[0].tabs.length; i++) {
                var tab = $scope.form[0].items[0].tabs[i];
                var index = tab.items.findIndex(function (e) { return e.key[0] == field; });
                if (index >= 0) {
                    isABoolean = (tab.items[index].type === 'eggscheckbox');
                    break;
                }
            }
            return isABoolean;
        };

        // [SIX-3374] - La funzione componenti xVersus deve fare vedere solo componenti associati a dipendenti dei reparti a cui l'utente è abilitato.
        function getCustomerDestinationImplicitFilters() {
            var authData = authFactory.getAuthData();
            if($scope.authDests === undefined){
              $scope.authDests = authData.filters.customer_destination?authData.filters.customer_destination:[];
              if($scope.authDests.length>0){
                $scope.authDests[0].value = $scope.authDests[0].value.substring(0, $scope.authDests[0].value.length - 1)
                $scope.authDests[0].value = $scope.authDests[0].value + " OR t.id is null)"
                dbFilterFactory.changeCustomAlias('e',$scope.authDests[0],'destination_id');
              }
            }

            return $scope.authDests;
        }

        $scope.getData = function () {
            var payload = {
                page: $scope.params.pageNumber,
                page_size: $scope.params.pageSize,
                code: $scope.params.code,
                description: $scope.params.description,
                show_revision: false,
                sort_fields: ($scope.params.sortFields?$scope.params.sortFields:'barcode'),
                sort_order: $scope.params.sortOrder
            };
            var filters = [
                {
                    "column": "product d",
                    "value": "t.product_id = d.id",
                    "relation": "JOIN",
                    "kind": "d.description AS product_desc"
                },
                {
                    "column": "human_resource e",
                    "value": "t.employee_id = e.id",
                    "relation": "JOIN",
                    "kind": "e.destination_id"
                }
            ];
            var implicitDestFilter = getCustomerDestinationImplicitFilters()
            if (implicitDestFilter.length > 0){
              filters = filters.concat(implicitDestFilter);
              filters = filters.concat(dbFilterFactory.getCustomFilter("(t.employee_id is not null OR (t.employee_id is null and t.status = 'A'))"))
            }

            if($scope.divcod){
              filters = filters.concat(dbFilterFactory.getCustomFilter("(t.divcod IN ("+$scope.divcod+") OR t.divcod is null)"));
            }
            // SIXLM-158 : i componenti dismessi non venivano visualizzati in quanto employee_id è null

            filters = filters.concat($scope.advFilter.list);
            // "mostrare solo componenti in stato spedito reparto o accettato reparto"
            recordFactory('component').filter(payload, filters)
                .$promise.then(function (data) {
                    $scope.viewGridOptions.totalItems = data.totalResults;
                    $scope.list.totalResults = data.totalResults;
                    $scope.list.list = data.list;
                    if ($scope.lookupCols.length > 0) {
                        loadLookupCols();
                    }
                    if ($scope.record.dates.length > 0) {
                        loadDates();
                    }
              $scope.renderTable = true;

            });
        };

        function capitalize(s) {
            return s && s[0].toUpperCase() + s.slice(1);
        };

        $scope.viewDetail = function (value) {
            $location.path('/six/component/detail/' + value.id);
        };

        function getCustomer(id) {
            recordFactory('customer').byId({ id: id })
                .$promise.then(function (data) {
                    $scope.lookup.customer_id.obj = data;
                    $scope.advFilter.filter.customer_id = id;
                });
        };

        // Se poi ho in GET l'id di uno specifico nosocomio, filtro solo su quello e blocco la selezione di altri ospedali.
        function getCustomerFilter(){
            // Recupero l'elenco delle destinazioni possibili per l'operatore
            var authData = authFactory.getAuthData();
            var customerDestinationQuery = '';
            var currentDestinationQuery = '';
            var customerQuery = ''; // Query da applicare alla lookup sugli ospedali
            var employeeCustomerQuery = ''; // Query da applicare sulle righe della tabella e sulla lookup dei dipendenti
            if(authData && authData.info && authData.info.authorizations){
                authData.info.authorizations.destinations.forEach(function(destinationId){
                    customerDestinationQuery += 'id=' + destinationId + ' OR ';
                    currentDestinationQuery += 'current_destination_id=' + destinationId + ' OR ';
                });
            }
            if(customerDestinationQuery.length>0){
                $scope.lockCustomer = true; // Blocco la lookup sull'ospedale finché non ho caricato il filtro
                customerDestinationQuery = customerDestinationQuery.slice(0,-4);
                customerDestinationQuery = '(' + customerDestinationQuery + ')';
                currentDestinationQuery = currentDestinationQuery.slice(0,-4);
                currentDestinationQuery = '(' + currentDestinationQuery + ')';
                $scope.lookup.current_destination_id.filter = dbFilterFactory.getCustomFilter(customerDestinationQuery);
                $scope.currentDestinationFilter = dbFilterFactory.getCustomFilter(currentDestinationQuery);
                var filter = dbFilterFactory.getCustomFilter(customerDestinationQuery);
                recordFactory('customer_destination').filter({page_size:10000},filter)
                    .$promise.then(function (data){
                        // Ottengo la lista dei distinti nosocomi possibili per l'operatore
                        var list = [];
                        data.list.forEach(function(item){
                            if(list.indexOf(item.customer_id)==-1){
                                list.push(item.customer_id);
                            }
                        });
                        list.forEach(function(customerId){
                            customerQuery += 'id=' + customerId + ' OR ';
                            employeeCustomerQuery += 'c.customer_id=' + customerId + ' OR ';
                        })
                        if(customerQuery.length>0){
                            customerQuery = customerQuery.slice(0,-4);
                            customerQuery = '(' + customerQuery + ')';
                            employeeCustomerQuery = employeeCustomerQuery.slice(0,-4);
                            employeeCustomerQuery = '(' + employeeCustomerQuery + ')';
                            $scope.customerFilter = $scope.customerFilter.concat(dbFilterFactory.getCustomFilter(customerQuery));
                            $scope.employeeCustomerFilter = $scope.employeeCustomerFilter.concat(dbFilterFactory.getCustomFilter(employeeCustomerQuery));
                            $scope.lookup.employee_id.filter = $scope.lookup.employee_id.filter.concat(dbFilterFactory.getCustomFilter(employeeCustomerQuery));
                        }
                        $scope.lockCustomer = false;
                        $scope.applyFilter();
                    });
            }
        };

        function init() {
            $scope.divcod = authFactory.getAuthData().info.divCod;
            initGridColumns();
            // Se l'utente è abilitato solo a certi ospedali, filtro tutti i dati di conseguenza.
            // Se poi ho in GET l'id di uno specifico nosocomio, filtro solo su quello e blocco la selezione di altri ospedali.
            if ($routeParams.customer) {
                $scope.lockCustomer = true;
                $scope.lookup.employee_id.filter = $scope.lookup.employee_id.filter.concat(dbFilterFactory.getNumberFilter('c.customer_id', parseInt($routeParams.customer)));
                getCustomer(parseInt($routeParams.customer));
            }
            else{
                getCustomerFilter();
            }

        };

        //___ main ___
        init();

    });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:ReintegroDisimessiCtrl
 * @description
 * # ReintegroDismessiCtrl
 * Controller of the ictportal.lm
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/component/reintegro', {
                templateUrl: 'lm/component/reintegrodismessi.html',
                controller: 'ReintegroDismessiCtrl'
            })
    })
    .controller('ReintegroDismessiCtrl', function ($scope, $routeParams, $location, toaster, $q, dbFilterFactory,
        recordFactory, schemaFactory, sixGridPaginationConstants, uiGridConstants, $log, authFactory, componentFactory, $uibModal) {

      $scope.customerFilter = [];
      $scope.list = {};
      $scope.destinations = [];
      $scope.customers = [];

      $scope.viewGridOptions = { appScopeProvider: $scope};

      $scope.params = {
        pageNumber: 1,
        pageSize: 15,
        code: 'component',
        filters: []
      };

      $scope.advFilter = {
        filter: {},
        list: []
      };

      $scope.record = {
        model: {},
        lookup: {},
        dates: []
      };

      $scope.lookup = {
        customer_id: {
          obj: undefined,
          mapping: {
            code: 'code',
            description: 'description'
          }
        },
        product_id: {
          obj: undefined,
          mapping: {
            code: 'code',
            description: 'description'
          }
        }
      }

      $scope.$watchGroup([
        'advFilter.filter.customer_id',
        'advFilter.filter.product_id'
        ], function () {
        $scope.applyFilter();
      });

      $scope.applyFilter = function(){
        $scope.advFilter.list.length = 0;
        if ($scope.advFilter.filter.customer_id) {
          var f = dbFilterFactory.getNumberFilter('cd.customer_id', $scope.advFilter.filter.customer_id);
          $scope.advFilter.list = $scope.advFilter.list.concat(f);
        }
        if ($scope.advFilter.filter.product_id) {
          var f = dbFilterFactory.getNumberFilter('product_id', $scope.advFilter.filter.product_id);
          $scope.advFilter.list = $scope.advFilter.list.concat(f);
        }
        $scope.getData();
      };

      var commonFilters = [];
      var initCommonFilters = function () {
        commonFilters = commonFilters.concat(dbFilterFactory.getCustomFilter("(t.divcod = " + divcod + " OR t.divcod IS NULL)"));
        commonFilters = commonFilters.concat(dbFilterFactory.getCustomFilter("t.status = 'A'"));
        commonFilters = commonFilters.concat(dbFilterFactory.getCustomFilter(" (t.special_use IS NULL OR t.special_use IN ('NORMAL', 'GENERIC'))"));
      };

      $scope.getData = function () {
        var payload = {
          page: $scope.params.pageNumber,
          page_size: $scope.params.pageSize,
          code: $scope.params.code,
          description: $scope.params.description,
          show_revision: false,
          sort_fields: ($scope.params.sortFields ? $scope.params.sortFields : 'p.code'),
          sort_order: $scope.params.sortOrder
        };
        var filters = [
          {
            "column": "product p",
            "value": "t.product_id = p.id",
            "relation": "JOIN",
            "kind": "p.description AS product_desc, p.code AS product_code"
          },
          {
            "column": "customer_destination cd",
            "value": "t.shipment_destination = cd.id",
            "relation": "JOIN"
          },
          {
            "column": "tab_size s",
            "value": "t.size_id = s.id",
            "relation": "LEFT JOIN",
            "kind": "s.code AS size_code"
          }
        ];
        if($scope.advFilter.list.length !== 0){
          filters = filters.concat($scope.advFilter.list);
        } else {
          if($scope.destinations.length !== 0){
            filters = filters.concat(dbFilterFactory.getCustomFilter("t.shipment_destination in ("+$scope.destinations+")"))
          }
        }
        filters = filters.concat(commonFilters).concat($scope.params.filters);
        recordFactory('component').aggregation(payload, {
          filters: filters,
          fields: ['p.code as product_code', 'p.description as product_desc', 's.code as size_code'],
          operations: [{
            function: "count",
            argument: "t.id",
            alias: "count_dismessi"
          }]
        })
          .$promise.then(function (data) {
          $scope.viewGridOptions.totalItems = data.totalResults;
          $scope.list.totalResults = data.totalResults;
          $scope.list.list = data.list;
        });
      };

      function initColumns () {
        $scope.viewGridOptions.columnDefs = [];
        $scope.viewGridOptions.columnDefs.push({
          displayName: "Codice",
          field: 'product_code',
          width : '***',
          enableFiltering: true,
          filters: [{
            type: sixGridPaginationConstants.filterType.TEXT,
            condition: uiGridConstants.filter.CONTAINS,
            placeholder: '',
            kind: 'string',
            aliasResolver: 'p.code'
          }]
        });
        $scope.viewGridOptions.columnDefs.push({
          displayName: 'Descrizione',
          field: 'product_desc',
          width: '*****',
          enableFiltering: true,
          filters: [{
            type: sixGridPaginationConstants.filterType.TEXT,
            condition: uiGridConstants.filter.CONTAINS,
            placeholder: '',
            kind: 'string',
            aliasResolver: 'p.description'
          }]
        });
        $scope.viewGridOptions.columnDefs.push({
          displayName: 'Taglia',
          field: 'size_code',
          width : '**',
          enableFiltering: true,
          filters: [{
            type: sixGridPaginationConstants.filterType.TEXT,
            condition: uiGridConstants.filter.CONTAINS,
            placeholder: '',
            kind: 'string',
            aliasResolver: 's.code'
          }]
        });
        $scope.viewGridOptions.columnDefs.push({
          displayName: 'Dismessi',
          field: 'count_dismessi',
          width : '**',
          enableFiltering: false
        });
        $scope.viewGridOptions.columnDefs.push({
          displayName: '',
          field: 'quantity',
          width : '*',
          enableCellEdit: true,
          enableFiltering: false,
          enableSorting: false,
          cellTemplate:
            '<div class="ui-grid-cell-contents" style="text-align: center">'+
              //'<input id="val/>"' +
            '<input type="number"   ng-model="MODEL_COL_FIELD"' +
            '        min=0 max="{{row.entity.count_dismessi}}" />' +
            '</div>'
        });
        $scope.viewGridOptions.columnDefs.push({
          displayName: '',
          field: 'confirm',
          width: '*',
          enableCellEdit: true,
          enableFiltering: false,
          enableSorting: false,
          cellTemplate:
            '<div class=row" style="text-align: center">' +
            '<button ng-click="grid.appScope.openModal(row.entity)" class="btn btn-xs btn-primary">' +
            '<span class="fa fa-send"></span>' +
            '</button>' +
            '</div>'
        });
      }

      var logError = function logError(ex) {
        $log.log(ex);
        toaster.pop('error', msg.error, msg.server_comunication_error);
      };

      $scope.openModal = function (row) {
        if(!row.quantity || row.quantity <= 0 || row.quantity > row.count_dismessi){
          toaster.pop('error', 'Quantità non valida');
          row.quantity = null;
        } else {
          $scope.row = row;
          $scope.confirm = $uibModal.open({
              animation: true,
              scope: $scope,
              templateUrl: 'lm/component/reintegro-dismessi-confirm.html',
              size: '1000'
          });
        }
      };

      function sendData() {
        var params = {
          page: 1,
          page_size: $scope.row.quantity,
          sort_fields: 't.last_operation_date',
          sort_order: 'asc'
        };
        var componentFilter = [
          {
            "column": "product p",
            "value": "t.product_id = p.id",
            "relation": "JOIN",
            "finer": "INNER"
          }, {
            "column": "customer_destination cd",
            "value": "t.shipment_destination = cd.id",
            "relation": "JOIN",
            "finer": "INNER"
          }
        ];
        if (typeof $scope.row.size_code !== "undefined") {
          componentFilter.push({
            "column": "tab_size s",
            "value": "t.size_id = s.id",
            "relation": "JOIN",
            "finer": "INNER"
          });
          componentFilter = componentFilter.concat(dbFilterFactory.getCustomFilter("s.code = '" + $scope.row.size_code + "'"));
        } else {
          componentFilter = componentFilter.concat(dbFilterFactory.getCustomFilter("t.size_id IS NULL"));
        }
        componentFilter = componentFilter.concat($scope.advFilter.list);
        componentFilter = componentFilter.concat(dbFilterFactory.getCustomFilter("p.code = '" + $scope.row.product_code + "'"))
        componentFilter = componentFilter.concat(commonFilters);
        recordFactory('component').filter(params, componentFilter).$promise.then(function (data) {
          if (data) {
            var componentDtos = [];
            var component = {};
            data.list.map(function (c) {
              component.barcode = c.barcode;
              component.savedComponent = null;
              component.azcod = azcod;
              component.divcod = divcod;
              component.status = 'RI';
              componentDtos = componentDtos.concat(component)
              component = {};
            })
          }
          componentFactory.updateComponents({}, componentDtos).$promise.then(function (response) {
              if (response.success) {
                toaster.pop('success', 'Reintegro effettuato', '');
                $scope.getData();
              } else {
                console.error(response.message);
                toaster.pop('error', "Errore nella chiamata a Six", response.message);
              }
            }).catch(function (ex) {
            logError(ex)
          });
        })
      }

      $scope.ok = function () {
        sendData()
        $scope.row = null;
        $scope.confirm.close();
      };

      $scope.cancel = function () {
        $scope.confirm.close();
      };

      function getCustomerFilter () {
        var auth = authFactory.getAuthData();
        if(auth.info && auth.info.authorizations){
          $scope.destinations = auth.info.authorizations.destinations.join()
        }
        var filterDest = []
        filterDest = filterDest.concat(dbFilterFactory.getCustomFilter("id IN ("+$scope.destinations+")"));
        recordFactory('customer_destination').filter({ page_size: 10000 }, filterDest).$promise.then(function(data){
          if(data.list){
            data.list.map(function (cd){
              if ($scope.customers.indexOf(cd.customer_id) === -1){
                $scope.customers = $scope.customers.concat(cd.customer_id);
              }
            })
          }
          $scope.customerFilter = $scope.customerFilter.concat(dbFilterFactory.getCustomFilter("id IN ("+$scope.customers.join()+")"))
          $scope.applyFilter();
        })
      }

      var azcod = -1;
      var divcod = -1;

      function init() {
        azcod = authFactory.getAuthData().info.azCod;
        divcod = authFactory.getAuthData().info.divCod;
        initCommonFilters();
        initColumns();
        //getCustomerFilter();
      }

      //___ main ___
      init();
});

'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:ComponentCheckerCtrl
 * @description
 * # ComponentCheckerCtrl
 * Controller of the ictportal.lm
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/component/checker', {
                templateUrl: 'lm/componentChecker/component_checker.html',
                controller: 'ComponentCheckerCtrl'
            })
    })
    .controller('ComponentCheckerCtrl', function ($scope, $routeParams, $location, toaster, $q, dbFilterFactory,
        recordFactory, schemaFactory, uiGridConstants, $log, authFactory) {

        $scope.list = {};
        $scope.pagedList = {}
        $scope.barcode_unicode = "";
        $scope.validItemsCount = 0;
        $scope.params = {
            pageNumber: 1,
            pageSize: 10,
            code: 'component',
            filters: []
        };
        function rowColor(grid, row, col, rowRenderIndex, colRenderIndex) {
          if (!row.entity.product_code)
            return 'row_not_found';
        }
        $scope.viewGridOptions = { appScopeProvider: $scope,
          enableGridMenu: true,
          exporterMenuPdf: true,
          exporterMenuAllData: true,
          exporterPdfDefaultStyle: {fontSize: 9},
          exporterPdfTableStyle: {margin: [-20, 0, 0, 0]},
          exporterPdfTableHeaderStyle: {fontSize: 10, bold: true, italics: true, color: 'red'},
          exporterPdfHeader: { text: "Controllo capi/pacchi", style: 'headerStyle' },
          exporterPdfCustomFormatter: function ( docDefinition ) {
            docDefinition.styles.headerStyle = { fontSize: 18, alignment: 'center', bold: true };
            return docDefinition;
          }};
        $scope.getData = function (){
          if($scope.list.list){
            $scope.pagedList.list = $scope.list.list.slice(($scope.params.pageNumber - 1) * $scope.params.pageSize, ($scope.params.pageNumber * $scope.params.pageSize));
          }
        }

        $scope.status = {
          "N" : "NUOVO",
          "NC" : "NON CONFORME",
          "P" : "CONFEZIONATO",
          "S" : "SPEDITO",
          "E" : "RIENTRATO",
          "A" : "DISMESSO",
          "L" : "LAVATO",
          "SWA" : "SPEDITO GUARDAROBA",
          "DWA" : "SPORCO GUARDAROBA",
          "LOST" : "DISPERSO",
          "ACCD" : "ACCETTATO REPARTO",
          "SHPBLW" : "SPEDIBILE GUARDAROBA",
          "SHPBLD" : "SPEDIBILE REPARTO",
          "ST" : "STERILIZZATO",
          "RI" : "REINTEGRATO",
          "D" : "DEPOSITO",
          "SD" : "SPEDITO A DEPOSITO",
          "SHPBLDEP" : "SPEDIBILE A DEPOSITO",
          "C" : "CONFORME",
          "CDS" : "CAMBIO DI STABILIMENTO",
          "U" : "USATO",
          "T" : "SARTORIA"
        }

        function setDefaultColumns(){
            $scope.viewGridOptions.columnDefs = [];
            $scope.viewGridOptions.columnDefs.push({
              displayName: 'Unicode',
              field: 'unicode',
              translate : 'true',
              enableFiltering : false,
              width : '**',
              cellClass : rowColor
            });
            $scope.viewGridOptions.columnDefs.push({
              displayName: 'Barcode',
              field: 'barcode',
              translate : 'true',
              enableFiltering : false,
              width : '*',
              cellClass : rowColor
            });
            $scope.viewGridOptions.columnDefs.push({
              displayName: 'Articolo',
              field: 'product_description',
              translate : 'true',
              cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.product_code}} {{row.entity.product_description}}</div>',
              enableFiltering : false,
              width : '**',
              cellClass : rowColor
            });
            $scope.viewGridOptions.columnDefs.push({
              displayName: 'Stato',
              field: 'status',
              translate : 'true',
              enableFiltering : false,
              width : '*',
              cellClass : rowColor
            });
            $scope.viewGridOptions.columnDefs.push({
              displayName: 'Dipendente',
              field: 'emp_matriculation',
              translate : 'true',
              enableFiltering : false,
              width : '*',
              cellClass : rowColor
            });
            $scope.viewGridOptions.columnDefs.push({
              displayName: 'Dest. dipendente',
              field: 'emp_dest_code',
              translate : 'true',
              enableFiltering : false,
              width : '*',
              cellClass : rowColor
            });
            $scope.viewGridOptions.columnDefs.push({
              displayName: 'Dest. spedizione',
              field: 'shipment_code',
              translate : 'true',
              enableFiltering : false,
              width : '*',
              cellClass : rowColor
            });
            $scope.viewGridOptions.columnDefs.push({
              displayName: 'Dest. corrente',
              field: 'current_dest_code',
              translate : 'true',
              enableFiltering : false,
              width : '*',
              cellClass : rowColor
            });
            $scope.viewGridOptions.columnDefs.push({
              displayName: 'Divisione',
              field: 'current_div',
              translate : 'true',
              enableFiltering : false,
              width : '*',
              cellClass : rowColor
            });
            $scope.viewGridOptions.columnDefs.push({
              displayName: 'Note',
              field: 'row_note',
              translate : 'true',
              enableFiltering : false,
              width : '*',
              cellClass : rowColor
            });
        }

        $scope.onRead = function (code) {
            if(code){
              var alreadyReadUnicode = false;
              var alreadyReadBarcode = false;
              if($scope.list.list && $scope.list.list.length > 0){
                $scope.list.list.map(function (e){
                  if(e.unicode === code && alreadyReadUnicode === false){
                    alreadyReadUnicode = true
                  }
                  if(e.barcode === code && alreadyReadBarcode === false){
                    alreadyReadBarcode = true
                  }
                })
              }
              if(alreadyReadUnicode && !alreadyReadBarcode){
                toaster.pop('error', 'Unicode già letto')
              } else if (alreadyReadBarcode && !alreadyReadUnicode){
                toaster.pop('error', 'Barcode già letto')
              } else if (alreadyReadBarcode && alreadyReadUnicode){
                toaster.pop('error', 'unicode/barcode già letto')
              } else {
                var filter =[
                  {
                    "column": "product p",
                    "value": "t.product_id = p.id",
                    "relation": "JOIN",
                    "kind": "p.code as product_code, p.description AS product_description"
                  },
                  {
                    "column": "human_resource hr",
                    "value": "t.employee_id = hr.id",
                    "relation": "JOIN",
                    "kind": "hr.matriculation as emp_matriculation"
                  },
                  {
                    "column": "customer_destination hrcd",
                    "value": "hr.destination_id = hrcd.id",
                    "relation": "JOIN",
                    "kind": "hrcd.code as emp_dest_code"
                  },
                  {
                    "column": "customer_destination ship",
                    "value": "t.shipment_destination = ship.id",
                    "relation": "JOIN",
                    "kind": "ship.code as shipment_code"
                  },
                  {
                    "column": "customer_destination cd",
                    "value": "t.current_destination_id = cd.id",
                    "relation": "JOIN",
                    "kind": "cd.code as current_dest_code"
                  },
                  {
                    "column": "division d",
                    "value": "t.divcod = d.divcod",
                    "relation": "JOIN",
                    "kind": "d.description as current_div"
                  }
                ];
                filter = filter.concat(dbFilterFactory.getCustomFilter("(t.barcode='" + code + "' OR t.unicode='" + code + "')"))
                filter = filter.concat(dbFilterFactory.getCustomFilter("t.divcod = '" + $scope.divcod + "'"))
                recordFactory('component').filter({}, filter)
                  .$promise.then(function (comp){

                  if(comp != null && comp.list.length > 0){
                    $scope.viewGridOptions.totalItems = ($scope.viewGridOptions.totalItems ? $scope.viewGridOptions.totalItems : 0) + comp.totalResults;
                    $scope.list.totalResults = ($scope.list.totalResults ? $scope.list.totalResults : 0) + comp.totalResults;
                    $scope.validItemsCount += comp.totalResults;
                    if(comp.list.length > 1){
                      comp.list.map(function (e){
                        e.row_note = "CHIP DOPPIO"
                        e.status = $scope.status[e.status];
                      })
                    }
                    comp.list.map(function (e){
                      if($scope.status[e.status]){
                        e.status = $scope.status[e.status];
                      }
                    })
                    if($scope.list.list){
                      $scope.list.list = $scope.list.list.concat(comp.list);
                    } else {
                      $scope.list.list = comp.list;
                    }
                  } else {
                    $scope.viewGridOptions.totalItems = ($scope.viewGridOptions.totalItems ? $scope.viewGridOptions.totalItems : 0) + 1;
                    $scope.list.totalResults = ($scope.list.totalResults ? $scope.list.totalResults : 0) + 1;
                    var empty = [{"unicode": code,
                                  "barcode": code,
                                 "product_description": "Componente non trovato"}];
                    if($scope.list.list){
                      $scope.list.list = $scope.list.list.concat(empty);
                    } else {
                      $scope.list.list = empty;
                    }


                  }
                  $scope.params.pageNumber = Math.floor(($scope.viewGridOptions.totalItems ? $scope.viewGridOptions.totalItems : 0 ) / $scope.params.pageSize)
                    + (($scope.viewGridOptions.totalItems ? $scope.viewGridOptions.totalItems : 0 ) % $scope.params.pageSize === 0 ? 0 : 1);
                  $scope.getData();
                })
              }

            }

        };

        function init() {
            $scope.divcod = authFactory.getAuthData().info.divCod;
            setDefaultColumns();

        };

        //___ main ___
        init();

    });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:PackagingSerialKitCtrl
 * @description
 * # PackagingSerialKitCtrl
 * Controller of the ictportal.lm
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/component/workflow', {
                templateUrl: 'lm/componentStatusWorkflow/componentStatusWorkflow.html',
                controller: 'ComponentStatusWorkflow'
            })
    })
    .controller('ComponentStatusWorkflow', function ($scope, matrixParFactory, workflowFactory, toaster, $log, sixCoreFactory) {

        $scope.tableData = {};
        $scope.tableHead = [];
        var matrixParWorkflow = {};
        $scope.codeToString = {
            "N": "Nuovo",
            "C": "Conforme",
            "NC": "Non conforme",
            "F": "Piegato",
            "P": "Confezionato",
            "S": "Spedito",
            "E": "Rientrato",
            "A": "Dismesso",
            "U": "Usato",
            "L": "Lavato",
            "SW": "Lavaggio speciale",
            "T": "Sartoria",
            "W": "Guardaroba",
            "SL": "Spedito lavanderia",
            "SWA": "Spedito guardaroba",
            "DWA": "Sporco guardaroba",
            "PCW": "Spedito CL",
            "LOST": "Disperso",
            "ACCD": "Accettato Reparto",
            "SHPBLW": "Spedibile guard.",
            "SHPBLD": "Spedibile rep.",
            "ST": "Sterilizzato",
            "RI": "Reintegrato",
            "D": "Deposito",
            "DD": "Sporco deposito",
            "SD": "Spedito deposito",
            "CDS": "Cambio stabilimento",
            "WIP": "In lavorazione",
            "SHPBLDEP": "Spedibile deposito"
        };

        //Get map to know change status (permitted or no permitted)
        function getTableData() {
            workflowFactory.getAllComponentStatusTransition().$promise.then(function(data){
                $scope.tableData = data;
            });
        }

        //Switch status values on click
        $scope.switchStatusValue = function($event) {
            var elementId = $event.currentTarget.id;
            var split = elementId.split('-');
            var rowStatus = split[0];
            var columnCurrentStatus = split[1];
            $scope.tableData[rowStatus][columnCurrentStatus] = !$scope.tableData[rowStatus][columnCurrentStatus];
        };

        //Save new matrix par values
        $scope.saveMatrixPar = function() {
            var jsonTableData = JSON.stringify($scope.tableData);
            workflowFactory.generateComponentStatusValue(jsonTableData).$promise.then(function(data){
                var matrixParNewValue = JSON.stringify(data);
                matrixParWorkflow.value = matrixParNewValue;
                matrixParFactory.save(matrixParWorkflow).$promise.then(function(data){
                    toaster.pop('success','Dati salvati');
                    $scope.reloadMatrixPar();
                });
            });
        };

        //Reload matrix par values
        $scope.reloadMatrixPar = function() {
            matrixParFactory.refresh().$promise.then(function(data1){
                workflowFactory.reloadComponentWorkflow().$promise.then(function(data2){
                    sixCoreFactory.reloadComponentStatusMap().$promise.then(function(data3){
                        getTableData();
                        toaster.pop('success','Reload completato');
                    });
                });
            });
        };


        function init() {
            //get all possible status for component
            workflowFactory.getComponentStatusList().$promise.then(function(data){
                $scope.tableHead = data;
            });

            //Get matrix par that rapresents the change status permitted
            matrixParFactory.getMatrixPar({key: 'components.workflow', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}).$promise.then(function(data){
                matrixParWorkflow = data;
            });

            getTableData();
        };


        //___ main ___
        init();

    });

'use strict';

/**
 * @name ictportal.lm.controller:wardToDestPianaPrintCtrl
 * @description Visualizza la stampa di una distinta di consegna a reparto
 * @author Rita Beltrami
 *
 * 02/07/2019
 *
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/shipment/components/print/:id', {
                templateUrl: 'lm/components-shipment/components-shipment-print.html',
                controller: 'ComponentsShipmentPrintCtrl',
            })
            .when('/lm/shipment/components/print/:id/:shipmentTypeCode', {
              templateUrl: 'lm/components-shipment/components-shipment-print.html',
              controller: 'ComponentsShipmentPrintCtrl',
            })
    })
    .controller('ComponentsShipmentPrintCtrl', function ($scope, localeFactory, $location, authFactory, $routeParams) {


        $scope.goToList = function() {
            var path = '/lm/shipment/components';
            if($routeParams.shipmentTypeCode) {
                path = path + '/' + $routeParams.shipmentTypeCode;
            }
            $location.url(path);
        }

        /**
         * First called function.
         */
        function init() {
            var username = authFactory.getAuthData().authId;
            $scope.reportParameters = {
                "p_shipment_id": $routeParams.id,
                "p_user": username,
                "printWeight" : false,
                "printCompDet" : false
            };
        };

        //___ main ___
        init();

    });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.core.controller:ComponentsShipmentCtrl
 **
 * # ComponentsShipmentCtrl
 * Controller of the ictportal.tnt
 *
 */
angular.module('ictportal.tnt')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/shipment/components', {
                templateUrl: 'lm/components-shipment/components-shipment.html',
                controller: 'ComponentsShipmentCtrl',
            })
            .when('/lm/shipment/components/:shipmentTypeCode', {
              templateUrl: 'lm/components-shipment/components-shipment.html',
              controller: 'ComponentsShipmentCtrl'
            })
    })
    .controller('ComponentsShipmentCtrl', function ($scope, recordFactory, $routeParams, $location, tntGoodsInwardService, tntInventorySrv,
                                                authFactory, $rootScope, parseSchemaService, $uibModal, dbFilterFactory, localeFactory, $q,
                                                matrixParFactory, shipmentDocumentFactory, toaster, eggsFormFactory, $log, COMPONENT_READ_MODE, $filter) {
        var msg = {
            "error": "Error",
            "destination": "Customer destination",
            // "inventory_date": "Inventory date",
            // "kit_status": "Kit status",
            // "inventoried": "Inventoried",
            "op_completed_success": "Operation completed",
            "server_comunication_error": "Server communication error"
        };

        $scope.unicodesList = [];
        $scope.shipmentType = null;
        $scope.destination = null;
        $scope.agreement = null;
        $scope.productMap = {};
        $scope.compReaderMode = COMPONENT_READ_MODE.UNICODE;
        $scope.enableResolveButton = false;
        $scope.showTable = false;
        $scope.enableCreateButton = false;
        $scope.shipmentTypeFilter = [];
        $scope.agreementItemParent = false;
        $scope.validAgreementProducts = [];
        $scope.record = {
            lookup: {},
            dates: []
        };
        $scope.advFilter = {
            filter: {},
            list: []
        };
        $scope.confirmEnabled = false;

      $scope.$watchGroup(['shipmentType',
          'destination', 'productMap', 'agreement'], function () {
          $scope.enableCreateButton = $scope.shipmentType != null
            && $scope.destination != null
            && $scope.agreement != null
            && Object.keys($scope.productMap).length > 0;
          Object.keys($scope.productMap).map(function (e){
            if($scope.productMap[e].inAgreement === false){
              $scope.enableCreateButton = false;
            }
          })
        }
      );

      $scope.$watchGroup(['destination'], function () {

          $scope.agreementFilter = []
          $scope.agreement = null;
          $scope.lookup.agreement_id.obj = {};
          if($scope.destination){
            $scope.agreementFilter = $scope.agreementFilter.concat(dbFilterFactory.getCustomFilter("t.customer_id = "+$scope.lookup.destination_id.obj.customer_id))
            $scope.agreementFilter = $scope.agreementFilter.concat(dbFilterFactory.getCustomFilter(getValidityQuery('t')))
          }
        }

      );

      $scope.$watchGroup(['agreement'], function (newVal, oldVal) {
        if(newVal !== oldVal){
          $scope.getAgreementItems();
        }
      });


      function isNewRead(read){
        var alreadyRead = $filter('filter')($scope.unicodesList, {read: {read: read.read} });
        return (alreadyRead.length===0);
      };

      function getTimestamp(day) {
        var m = (day.getMonth()+1);
        var mStr = (m<10)?('0'+m.toString()):m.toString();
        var d = (day.getDate());
        var dStr = (d<10)?('0'+d.toString()):d.toString();
        var timestamp = day.getFullYear() + '-' + mStr + '-' +dStr;
        return timestamp;
      }

      function getValidityQuery(table) {
        var timestamp = getTimestamp(new Date());
        var query = '(' + table + '.start_validity_date <= \'' + timestamp +
          '\' AND (' + table + '.end_validity_date IS NULL OR ' + table + '.end_validity_date>\'' + timestamp + '\') )';

        return query;
      }

      $scope.readComponentCode = function(read) {
          if(isNewRead(read.read)){
            $scope.unicodesList.push(read.read)
            if($scope.destination != null && $scope.agreement != null){
              $scope.enableResolveButton = true;
            } else {
              $scope.enableResolveButton = false;
            }
            console.log(read.read);
          }
      }

      $scope.removeReads = function (prod_id){
        var readsToRemove = $scope.productMap[prod_id].unicodes;
        readsToRemove.map(function(r){
          var index = $scope.unicodesList.indexOf(r);
          if(index > -1){
            $scope.unicodesList.splice(index, 1);
          }
        })
        if($scope.unicodesList.length > 0){
          $scope.resolveComponents()
        } else {
          $scope.showTable = false;
          $scope.enableResolveButton = false
        }

      }

      $scope.resetReads = function(){
        $scope.unicodesList = [];
        $scope.productMap = {};
        $scope.showTable = false;
        $scope.enableResolveButton = false;
      }

      $scope.resolveComponents = function(){
        if($scope.unicodesList.length < 1){
          toaster.pop('error', 'Nessuna lettura da risolvere');
          return;
        }
        var baseFilters = [{
          "column": "product p",
          "value": "t.product_id = p.id",
          "relation": "JOIN",
          "kind": "p.id as prod_id, p.code AS prod_code, p.description AS prod_des, p.parent_product_id AS parent_prod_id"
        }]
        var codeList = "";
        $scope.unicodesList.map(function (code){
          codeList = codeList + "'"+code+"', ";
        })
        codeList = codeList.substring(0, codeList.length - 2);
        console.log(codeList);
        baseFilters = baseFilters.concat(dbFilterFactory.getCustomFilter("t.unicode IN (" + codeList + ")"))
        recordFactory('component').filter({page_size:10000}, baseFilters)
          .$promise.then(function(data) {
          if(data.list && data.list.length>0){
            $scope.productMap = {};
            data.list.map(function (c){
              var prod = c.prod_code + " - " + c.prod_des;
              if($scope.productMap[c.prod_id]){
                $scope.productMap[c.prod_id].ids.push(c.id);
                $scope.productMap[c.prod_id].unicodes.push(c.unicode);
              } else {
                var prodForAgreement = $scope.agreementItemParent === true ? c.parent_prod_id : c.prod_id
                $scope.productMap[c.prod_id] = {
                  prod: prod,
                  ids : [],
                  unicodes : [],
                  inAgreement : $scope.validAgreementProducts.indexOf(prodForAgreement) > -1
                };
                $scope.productMap[c.prod_id].ids.push(c.id);
                $scope.productMap[c.prod_id].unicodes.push(c.unicode);
              }
            })
            console.log($scope.productMap);
            $scope.showTable = Object.keys($scope.productMap).length > 0;
          }
        });
      }

      $scope.getAgreementItems = function(){
        var baseFilters = dbFilterFactory.getCustomFilter("t.agreement_id = " + $scope.agreement)
        baseFilters = baseFilters.concat(dbFilterFactory.getCustomFilter(getValidityQuery('t')))
        recordFactory('agreement_item').filter({page_size:10000}, baseFilters)
          .$promise.then(function(data) {
          $scope.validAgreementProducts = [];
          if(data.list && data.list.length>0){
            data.list.map(function(ai) {
              $scope.validAgreementProducts.push(ai.product_id);
            })
          }
          if(Object.keys($scope.productMap).length > 0){
            $scope.resolveComponents();
          }
        });

      }


      $scope.createDdt = function () {
          var prodCompMap = {};
          angular.forEach($scope.productMap, function(value, key){
            prodCompMap[key] = value.ids;
          })
          var agreement = $scope.agreement ? $scope.agreement : null; //non se serva, ma nel dubbio...
          var payload = {
            shipment_type_id : $scope.shipmentType,
            destination_id : $scope.destination,
            agreement_id : agreement,
            components_map : prodCompMap
          }
          console.log(payload);
          shipmentDocumentFactory.createCustomerShipmentDocumentForComponents({}, payload).$promise.then(function (data) {
            console.log(data);
            if (data.status == 'ok') {
              toaster.pop('success', "Documento creato con successo");
              goToPrint(data.result['ddt'].id);
            } else {
              toaster.pop('error', 'Documento non creato')
            }
          });
      }

      function goToPrint(shipmentDocumentId) {
        var path = '/lm/shipment/components/print' + '/' + shipmentDocumentId
        if($routeParams.shipmentTypeCode) {
          path = path + '/' + $routeParams.shipmentTypeCode;
        }
        $location.url(path);
      }


        function initLookups() {
            $scope.lookup = {};
            eggsFormFactory.addLookup($scope.lookup, 'destination_id', 'customer_destination', 't.code', 't.description');
            eggsFormFactory.addLookup($scope.lookup, 'shipment_type_id', 'shipment_type', 't.code', 't.description');
            eggsFormFactory.addLookup($scope.lookup, 'agreement_id', 'agreement', 't.num', 't.description');
        };

        $rootScope.$on('$translateRefreshEnd', function () {
            $q.all({
                general: localeFactory.translateMsg(msg)
            })
            .then(function (data) {
                $scope.functionTitle = "Spedizione componenti";
                // translateGridColumns();
            })
            .catch(function (error) { $log.error(error); });
        });

        function init() {
            // localeFactory.loadTranslation('inventory');
            initLookups();
            if($routeParams.shipmentTypeCode){
              $scope.shipmentTypeFilter = $scope.shipmentTypeFilter.concat(dbFilterFactory.getStringFilter('t.code', $routeParams.shipmentTypeCode))
            }
            // initGridColumns();
            $scope.destinationFilter = [];
            $scope.agreementFilter = [];
            matrixParFactory.getValueOrDefault({key: 'endowmentService.isAgreementItemParent', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}, {defaultValue: "false"}).$promise
              .then(function(data) {
                if(data && data.result && data.result.value === "true") {
                  $scope.agreementItemParent = true;
                }
            })
            // var authData = authFactory.getAuthData();
            // if (authData.filters.customer_destination && authData.filters.customer_destination.length > 0) {
            //   $scope.destinationFilter = authData.filters.customer_destination;
            // }
        }

        //___ main ___
        init();

    });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.core.controller:ConfirmOrderLog80Ctrl
 **
 * # ConfirmOrderLog80Ctrl
 * Controller of the ictportal.tnt
 *
 */
angular.module('ictportal.tnt')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/log80/confirmorders', {
                templateUrl: 'lm/confirm-order-log80/confirm-order-log80.html',
                controller: 'ConfirmOrderLog80Ctrl'
            })
    })
    .controller('ConfirmOrderLog80Ctrl', function ($scope, recordFactory, $routeParams, $location, tntGoodsInwardService, tntInventorySrv,
                                                authFactory, $rootScope, parseSchemaService, $uibModal, dbFilterFactory, localeFactory, $q,
                                                matrixParFactory, shipmentDocumentFactory, toaster, eggsFormFactory, $log) {
        var msg = {
            "error": "Error",
            "destination": "Customer destination",
            // "inventory_date": "Inventory date",
            // "kit_status": "Kit status",
            // "inventoried": "Inventoried",
            "op_completed_success": "Operation completed",
            "server_comunication_error": "Server communication error"
        };

        $scope.result = {};
        $scope.resultSec = {};
        $scope.record = {
            lookup: {},
            dates: []
        };
        $scope.params = {
            pageNumber: 1,
            pageSize: 15,
            code: 'component',
            filters: []
        };
        $scope.paramsSec = {
          pageNumber: 1,
          pageSize: 15,
          code: 'component',
          filters: []
        };
        $scope.advFilter = {
            filter: {},
            list: []
        };
        $scope.confirmEnabled = false;
        var selectedRows = [];


        $scope.sixRowSelectionChangedCallback = function(row, col, event){
            selectedRows = row.grid.selection.selectedCount;
            if (selectedRows <= 0) {
              $scope.confirmEnabled = false;
            } else {
              $scope.confirmEnabled = true;
            }
            console.log("selezionate "+selectedRows+" righe");
        };

        $scope.sixBulkSelectionCallback = function(scope, rows, evt) {
            selectedRows = $scope.viewGridOptions.gridApi.selection.getSelectedRows();
            if (selectedRows.length <= 0) {
                $scope.confirmEnabled = false;
            } else {
                $scope.confirmEnabled = true;
                if (selectedRows.length === $scope.viewGridOptions.appScopeProvider.params.pageSize) {
                    toaster.pop('warn', 'ATTENZIONE! Selezionate solamente le righe della prima pagina');
                }
            }
            console.log("selezionate "+selectedRows.length+" righe");

        };

        $scope.viewGridOptions = {
            appScopeProvider: $scope,
            enableFiltering: true,
            multiSelect: true,
            enableRowHeaderSelection: true,
            enableRowSelection: true,
            rowSelectionChanged: $scope.sixRowSelectionChangedCallback,
            rowSelectionChangedBatch: $scope.sixBulkSelectionCallback,
            enablePaginationControls: true
        };

      $scope.viewGridOptionsSec = {
        appScopeProvider: $scope,
        enableFiltering: true,
        enablePaginationControls: true
      };

        $scope.$watchGroup(['advFilter.filter.destination_id',
          'advFilter.filter.customer_id', 'pianaOrderType'], function () {
                $scope.applyFilter();
            }
        );

        $scope.applyFilter = function () {
            $scope.advFilter.list.length = 0;
            if ($scope.advFilter.filter.destination_id) {
                var f = dbFilterFactory.getNumberFilter('co.customer_destination', $scope.advFilter.filter.destination_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.customer_id) {
                var f = dbFilterFactory.getNumberFilter('co.customer_id', $scope.advFilter.filter.customer_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            $scope.getData();
        };

        var initGridColumns = function () {
            $scope.lookupCols = [];
            $scope.viewGridOptions.columnDefs = [];
            var dateFormat = "dd/MM/yyyy"
            $scope.viewGridOptions.columnDefs.push({
                name: "Cliente",
                field: "customer_code",
                translation: 'customer',
                width: '**',
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.customer_code }} - {{ row.entity.customer_description }}</div>',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Destinazione",
                field: "destination_code",
                translation: 'destination',
                width: '**',
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.destination_code }} - {{ row.entity.destination_description }}</div>',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
              name: "Numero",
              field: "customer_order_number",
              translation: 'numero',
              width: '*',
              cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.customer_order_number}} - {{ row.entity.customer_order_date | date:\'' + dateFormat + '\' }}</div>',
              enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Data Consegna",
                field: "customer_order_delivery_date",
                translation: 'delivery_date',
                width: '*',
              cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.customer_order_delivery_date | date:\'' + dateFormat + '\' }}</div>',
                enableFiltering: false
            });

            $scope.viewGridOptionsSec.columnDefs = $scope.viewGridOptions.columnDefs;
        };

      function getTimestamp(day) {
        var m = (day.getMonth()+1);
        var mStr = (m<10)?('0'+m.toString()):m.toString();
        var d = (day.getDate());
        var dStr = (d<10)?('0'+d.toString()):d.toString();
        var timestamp = day.getFullYear() + '-' + mStr + '-' +dStr;
        return timestamp;
      }

      function getValidityQuery(table) {
        var timestamp = getTimestamp(new Date());
        var query = '(' + table + '.start_validity_date IS NULL OR ' + table + '.start_validity_date <= \'' + timestamp +
          '\' AND (' + table + '.end_validity_date IS NULL OR ' + table + '.end_validity_date>\'' + timestamp + '\') )';

        return query;
      }

        $scope.getData = function() {
            var payload = {
                page_size: 9999
            };
            var filters = [{
              "column": "customer_order co",
              "value": "t.customer_order_id = co.id",
              "relation": "JOIN"
            },
              {
                "column": "customer c",
                "value": "co.customer_id = c.id",
                "relation": "JOIN"
            },
            {
                "column": "customer_destination cd",
                "value": "co.customer_destination = cd.id",
                "relation": "JOIN",
                "kind": "cd.id as destination_id "
            },
              {
                "column": "ordertype ot",
                "value": "co.type_id = ot.id",
                "relation": "JOIN",
                "kind": "ot.shipment_type_id as shipment_type_id"
              },
              {
                "column": "endowment e",
                "value": "(cd.id = e.destination_id AND e.type = 'PIANA')",
                "relation": "LEFT JOIN"
              },
              {
                "column": "endowment_item ei",
                "value": "ei.endowment_id = e.id AND ei.product_id=t.item_id",
                "relation": "LEFT JOIN",
                "kind": "ei.no_chip as no_chip"
              }
            ];
            filters = filters.concat($scope.advFilter.list);
            filters = filters.concat(dbFilterFactory.getCustomFilter("co.status in ('TO_DISPATCH', 'DISPATCHABLE')"))
            filters = filters.concat(dbFilterFactory.getCustomFilter(getValidityQuery('e')));
            filters = filters.concat(dbFilterFactory.getCustomFilter(getValidityQuery('ei')));
            var validRowsArgument = "CASE WHEN (t.status = 'DISPATCHABLE' OR (ei.no_chip = 'T' AND ot.code = '"+ $scope.pianaOrderType +"') ) THEN 1 ELSE 0 END"
          recordFactory('customer_order_row').aggregation(payload, {
            filters: filters,
            fields: ['c.code as customer_code', 'c.description as customer_description', 'cd.code as destination_code', 'cd.description as destination_description', 'co.id as customer_order_id',
            'co.co_number as customer_order_number', 'co.delivery_date as customer_order_delivery_date', 'cd.send_in_transit as send_in_transit', 'co.co_date as customer_order_date'],
            operations: [{
              function: "sum",
              argument: validRowsArgument,
              alias: "valid_rows"
            },
              {
                function: "sum",
                argument: "CASE WHEN (t.status = 'TO_DISPATCH' OR t.status = 'DISPATCHABLE') THEN 1 ELSE 0 END",
                alias: "total_rows"
              }

              ]
          }).$promise.then(function (data){
            $scope.result.list = []
            $scope.viewGridOptions.totalItems = 0;
            $scope.resultSec.list = [];
            $scope.viewGridOptionsSec.totalItems = 0;
            if(data != null && data.list.length > 0){
                data.list.map(function (r){
                  if(r.valid_rows === r.total_rows){
                    $scope.result.list = $scope.result.list.concat(r);
                  } else {
                    $scope.resultSec.list = $scope.resultSec.list.concat(r);
                  }
                })

              $scope.viewGridOptions.totalItems = $scope.result.list.length;
              $scope.viewGridOptionsSec.totalItems = $scope.resultSec.list.length;
            }
            })
        };

      $scope.confirmSelected = function () {
        var currentRows = $scope.viewGridOptions.gridApi.selection.getSelectedRows()
        var orderIds = currentRows.map(function (order) {
          return order.customer_order_id;
        })
        shipmentDocumentFactory.createCustomerShipmentDocumentLog80({}, orderIds).$promise.then(function (data) {
          console.log(data);
          if (data.status == 'ok') {
            toaster.pop('success', "ordini evasi con successo");
            $scope.getData();
          } else {
            toaster.pop('error', 'ordini non evasi')
          }
        });
      }

        var logError = function logError(ex) {
            $log.log(ex);
            toaster.pop('error', msg.error, msg.server_comunication_error);
        };

        function translateGridColumns() {
            $scope.viewGridOptions.columnDefs.forEach(function (col) {
                if (col.translation) {
                    if (confirm_orders_log80_msg[col.translation]) {
                        col.name = confirm_orders_log80_msg[col.translation];
                    }
                    else {
                        col.name = msg[col.translation];
                    }
                }
            });
        };

        function initLookups() {
            $scope.lookup = {};
            eggsFormFactory.addLookup($scope.lookup, 'destination_id', 'customer_destination', 't.code', 't.description');
            eggsFormFactory.addLookup($scope.lookup, 'customer_id', 'customer', 't.code', 't.description');
        };

        $rootScope.$on('$translateRefreshEnd', function () {
            $q.all({
                general: localeFactory.translateMsg(msg)
            })
            .then(function (data) {
                $scope.functionTitle = "Conferma ordini log80";
                // translateGridColumns();
            })
            .catch(function (error) { $log.error(error); });
        });

        function init() {
            // localeFactory.loadTranslation('inventory');
            matrixParFactory.getValueOrDefault({key: 'pianaLog80OrderTypeCode', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'},
              {defaultValue: " "}).$promise.then(function (data) {
              $scope.pianaOrderType = data.result.value;
            })

            initLookups();
            initGridColumns();
            $scope.destinationFilter = [];
            var authData = authFactory.getAuthData();
            if (authData.filters.customer_destination && authData.filters.customer_destination.length > 0) {
              $scope.destinationFilter = authData.filters.customer_destination;
            }
        }

        //___ main ___
        init();

    });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.core.controller:DdtStatusChangeCtrl
 **
 * # DdtStatusChangeCtrl
 * Controller of the ictportal.tnt
 *
 * AL MOMENTO PASSA LE BOLLE IN SENT_TO_SAP, MA SI PUO ADATTARE A PASSARLE IN UNO STATO A SCELTA DELL'UTENTE
 *
 *
 */
angular.module('ictportal.tnt')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/ddt/status/change', {
                templateUrl: 'lm/ddt-status-change/ddt-status-change.html',
                controller: 'DdtStatusChangeCtrl'
            })
    })
    .controller('DdtStatusChangeCtrl', function ($scope, recordFactory, $routeParams, $location, tntGoodsInwardService, tntInventorySrv,
                                                authFactory, $rootScope, parseSchemaService, $uibModal, dbFilterFactory, localeFactory, $q,
                                                matrixParFactory, shipmentDocumentFactory, toaster, eggsFormFactory, $log) {
        var msg = {
            "error": "Error",
            "destination": "Customer destination",
            // "inventory_date": "Inventory date",
            // "kit_status": "Kit status",
            // "inventoried": "Inventoried",
            "op_completed_success": "Operation completed",
            "server_comunication_error": "Server communication error"
        };

        $scope.result = {};
        $scope.record = {
            lookup: {},
            dates: []
        };
        $scope.params = {
            pageNumber: 1,
            pageSize: 15,
            code: 'component',
            filters: []
        };

        $scope.advFilter = {
            filter: {},
            list: []
        };
        $scope.confirmEnabled = false;
        var selectedRows = [];

      $scope.modal = {
        title: 'Conferma cambio stato',
        message: 'Sei sicuro di voler mettere i ddt selezionati in "Passato a sap"?'
      };

      $scope.enum = {
        state: [
          {
            name: 'Da evadere',
            value: 'TO_DISPATCH'
          },{
            name: 'Evaso',
            value: 'DISPATCHED'
          },{
            name: 'Accettato',
            value: 'RECEIVED'
          },{
            name: 'Sospeso',
            value: 'PENDING'
          }
        ]
      };


        $scope.sixRowSelectionChangedCallback = function(row, col, event){
            selectedRows = row.grid.selection.selectedCount;
            if (selectedRows <= 0) {
              $scope.confirmEnabled = false;
            } else {
              $scope.confirmEnabled = true;
            }
            console.log("selezionate "+selectedRows+" righe");
        };

        $scope.sixBulkSelectionCallback = function(scope, rows, evt) {
            selectedRows = $scope.viewGridOptions.gridApi.selection.getSelectedRows();
            if (selectedRows.length <= 0) {
                $scope.confirmEnabled = false;
            } else {
                $scope.confirmEnabled = true;
                if (selectedRows.length === $scope.viewGridOptions.appScopeProvider.params.pageSize) {
                    toaster.pop('warn', 'ATTENZIONE! Selezionate solamente le righe della prima pagina');
                }
            }
            console.log("selezionate "+selectedRows.length+" righe");

        };

        $scope.viewGridOptions = {
            appScopeProvider: $scope,
            enableFiltering: true,
            multiSelect: true,
            enableRowHeaderSelection: true,
            enableRowSelection: true,
            rowSelectionChanged: $scope.sixRowSelectionChangedCallback,
            rowSelectionChangedBatch: $scope.sixBulkSelectionCallback,
            enablePaginationControls: true
        };


        // $scope.$watchGroup(['advFilter.filter.destination_id',
        //   'advFilter.filter.customer_id', 'advFilter.filter.from_number', 'advFilter.filter.to_number'], function () {
        //         $scope.applyFilter();
        //     }
        // );

        $scope.reset = function () {
          $scope.advFilter.filter.destination_id = null;
          $scope.lookup.destination_id.obj = {};
          $scope.advFilter.filter.customer_id = null;
          $scope.lookup.customer_id.obj = {};
          $scope.advFilter.filter.shipment_type_id = null;
          $scope.lookup.shipment_type_id.obj = {};
          $scope.advFilter.filter.from_number = null;
          $scope.advFilter.filter.to_number = null;
          $scope.advFilter.filter.number = null;
          $scope.advFilter.filter.from_date = null;
          $scope.advFilter.filter.to_date = null;
          $scope.advFilter.filter.date = null;
          $scope.advFilter.filter.bar = "";
          $scope.applyFilter();

        }

        $scope.applyFilter = function () {
            $scope.advFilter.list.length = 0;
            if ($scope.advFilter.filter.destination_id) {
                var f = dbFilterFactory.getNumberFilter('t.customer_destination', $scope.advFilter.filter.destination_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.customer_id) {
                var f = dbFilterFactory.getNumberFilter('t.customer_id', $scope.advFilter.filter.customer_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.shipment_type_id) {
              var f = dbFilterFactory.getNumberFilter('t.type_id', $scope.advFilter.filter.shipment_type_id);
              $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.from_number) {
              var f = dbFilterFactory.getCustomFilter("t.ddt_number >= "+ $scope.advFilter.filter.from_number);
              $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.to_number) {
              var f = dbFilterFactory.getCustomFilter("t.ddt_number <= "+ $scope.advFilter.filter.to_number);
              $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
          if ($scope.advFilter.filter.number) {
            var f = dbFilterFactory.getCustomFilter("t.ddt_number = "+ $scope.advFilter.filter.number);
            $scope.advFilter.list = $scope.advFilter.list.concat(f);
          }
          if ($scope.advFilter.filter.from_date) {
            var f = dbFilterFactory.getDateFilter('t.ddt_date', $scope.advFilter.filter.from_date, '>=');
            $scope.advFilter.list = $scope.advFilter.list.concat(f);
          }
          if ($scope.advFilter.filter.to_date) {
            var f = dbFilterFactory.getDateFilter('t.ddt_date', $scope.advFilter.filter.to_date, '<=')
            $scope.advFilter.list = $scope.advFilter.list.concat(f);
          }
          if ($scope.advFilter.filter.date) {
            var f = dbFilterFactory.getDateFilter('t.ddt_date', $scope.advFilter.filter.date, '=')
            $scope.advFilter.list = $scope.advFilter.list.concat(f);
          }
          if ($scope.advFilter.filter.state) {
            var f = dbFilterFactory.getCustomFilter("t.state = '"+ $scope.advFilter.filter.state +"'");
            $scope.advFilter.list = $scope.advFilter.list.concat(f);
          }
          if ($scope.advFilter.filter.bar) {
            var f = dbFilterFactory.getCustomFilter("t.bar = '"+ $scope.advFilter.filter.bar +"'");
            $scope.advFilter.list = $scope.advFilter.list.concat(f);
          }
            $scope.getData();
        };

        var initGridColumns = function () {
            $scope.lookupCols = [];
            $scope.viewGridOptions.columnDefs = [];
            var dateFormat = "dd/MM/yyyy"
            $scope.viewGridOptions.columnDefs.push({
                name: "Cliente",
                field: "customer_code",
                translation: 'customer',
                width: '**',
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.customer_code }} - {{ row.entity.customer_desc }}</div>',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
              name: "Cliente di fatturazione",
              field: "invoicing_customer_code",
              translation: 'customer',
              width: '*',
              // cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.customer_code }} - {{ row.entity.customer_description }}</div>',
              enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Destinazione",
                field: "destination_code",
                translation: 'destination',
                width: '**',
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.destination_code }} - {{ row.entity.destination_desc }}</div>',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
              name: "Numero",
              field: "ddt_number",
              translation: 'numero',
              width: '*',
              enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
              name: "Barra",
              field: "bar",
              translation: 'barra',
              width: '*',
              enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Data",
                field: "ddt_date",
                translation: 'date',
                width: '*',
              cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.ddt_date | date:\'' + dateFormat + '\' }}</div>',
              enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
              name: "Data Consegna",
              field: "delivery_date",
              translation: 'delivery_date',
              width: '*',
              cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.delivery_date | date:\'' + dateFormat + '\' }}</div>',
              enableFiltering: false
            });
          $scope.viewGridOptions.columnDefs.push({
            name: "Stato",
            field: "state",
            translation: 'state',
            width: '*',
            enableFiltering: false
          });
        };

      function getTimestamp(day) {
        var m = (day.getMonth()+1);
        var mStr = (m<10)?('0'+m.toString()):m.toString();
        var d = (day.getDate());
        var dStr = (d<10)?('0'+d.toString()):d.toString();
        var timestamp = day.getFullYear() + '-' + mStr + '-' +dStr;
        return timestamp;
      }


        $scope.getData = function() {
            var payload = {
              page: $scope.params.pageNumber,
              page_size: $scope.params.pageSize,
              code: $scope.params.code,
              description: $scope.params.description,
              sort_fields: ['ddt_date', 'ddt_number'],
              sort_order: 'desc'
            };
            var filters = [{
              "column": "customer c",
              "value": "t.customer_id = c.id",
              "relation": "JOIN",
              "kind" : "c.code as customer_code, c.description as customer_desc"
            },
              {
                "column": "customer ic",
                "value": "t.invoicing_customer_id = ic.id",
                "relation": "JOIN",
                "kind" : "ic.code as invoicing_customer_code, ic.description as invoicing_customer_desc"
              },
            {
                "column": "customer_destination cd",
                "value": "t.customer_destination = cd.id",
                "relation": "JOIN",
                "kind": "cd.code as destination_code, cd.description destination_desc "
            },
              {
                "column": "shipment_type st",
                "value": "t.type_id = st.id",
                "relation": "JOIN"
              }];
            filters = filters.concat($scope.advFilter.list);
            filters = filters.concat(dbFilterFactory.getCustomFilter("t.state NOT IN ('SENT_TO_SAP', 'CANCELED', 'SAP_CLOSED')"))
            filters = filters.concat(dbFilterFactory.getCustomFilter("t.discriminator = 'CUSTOMER'"));
          recordFactory('shipment').filter(payload, filters).$promise.then(function (data){
            $scope.result.list = []
            $scope.viewGridOptions.totalItems = 0;
            if(data != null && data.list.length > 0){
              data.list.forEach(function (e) {
                $scope.enum.state.map(function (s) {
                  if (e.state == s.value) {
                    e.state = s.name;
                  }
                })
              });
              $scope.result.list = data.list
              $scope.result.totalResult = data.totalResults;
              $scope.viewGridOptions.totalItems = data.totalResults;
            }
            })
        };

      $scope.confirmSelected = function () {
        var currentRows = $scope.viewGridOptions.gridApi.selection.getSelectedRows()
        var ids = currentRows.map(function (ddt) {
          return ddt.id;
        })
        var total = ids.length;
        var updated = 0;
        var a = [];
        var payload_update = {
          "state": 'SENT_TO_SAP'
        };
        ids.forEach(function (id){
          a.push(
            recordFactory('shipment').update({id: id}, payload_update).$promise.then(function (resUpdate) {
              if (resUpdate && resUpdate.updated == 1) {
                updated = updated + 1;
              }
            })
          )
        })
        Promise.all(a).then(function () {
          if (updated > 0) {
            toaster.pop('success', 'Salvataggio completato', 'Salvataggio eseguito con successo per '+updated+' ddt su '+total);
          } else {
            toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
          }
          $scope.getData();
        });

      }


        function translateGridColumns() {
            $scope.viewGridOptions.columnDefs.forEach(function (col) {
                if (col.translation) {
                    if (confirm_orders_log80_msg[col.translation]) {
                        col.name = confirm_orders_log80_msg[col.translation];
                    }
                    else {
                        col.name = msg[col.translation];
                    }
                }
            });
        };

        $scope.confirm = function() {
          if (!$scope.modal) {
            alert('Modal not found');
          }
          else {
            $scope.modal.callback = $scope.confirmSelected.bind(null);
            $rootScope.$broadcast('sixConfirmModal_open');
          }
        };

        function initLookups() {
            $scope.lookup = {};
            eggsFormFactory.addLookup($scope.lookup, 'destination_id', 'customer_destination', 't.code', 't.description');
            eggsFormFactory.addLookup($scope.lookup, 'customer_id', 'customer', 't.code', 't.description');
            eggsFormFactory.addLookup($scope.lookup, 'shipment_type_id', 'shipment_type', 't.code', 't.description');
        };

        $rootScope.$on('$translateRefreshEnd', function () {
            $q.all({
                general: localeFactory.translateMsg(msg)
            })
            .then(function (data) {
                $scope.functionTitle = "Passaggio ddt a SAP";
                // translateGridColumns();
            })
            .catch(function (error) { $log.error(error); });
        });

        function init() {
            // localeFactory.loadTranslation('inventory');

            initLookups();
            initGridColumns();
            $scope.destinationFilter = [];
            var authData = authFactory.getAuthData();
            if (authData.filters.customer_destination && authData.filters.customer_destination.length > 0) {
              $scope.destinationFilter = authData.filters.customer_destination;
            }
            $scope.shipmentTypeFilter = [];
            $scope.shipmentTypeFilter = $scope.shipmentTypeFilter.concat(dbFilterFactory.getCustomFilter("type = 'SALE'"))

        }

        //___ main ___
        init();

    });

/**
 * @ngdoc function
 * @name ictportal.lm.controller:DryCleaningLabelPrintCtrl
 * @description Dry cleaning - Dirty acceptance (SIXLM-374)
 * @author Rita Beltrami
 *
 * created on 24/04/2019
 * # DryCleaningLabelPrintCtrl
 * Controller of the ictportal.lm
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/dry/cleaning/dirty/acceptance', {
                templateUrl: 'lm/dryCleaningDirtyAcceptance/dry-cleaning-dirty-acceptance.html',
                controller: 'DryCleaningDirtyAcceptanceCtrl'
            })
    })
    .controller('DryCleaningDirtyAcceptanceCtrl', function ($scope, dryCleaningFactory,
            toaster, localeFactory, authFactory, $location, $q, COMPONENT_READ_MODE,
            recordFactory, dbFilterFactory, workflowFactory, componentService, matrixParFactory,
            $http, $timeout, APP_URL) {

        $scope.promises = {};
        var NEW_STATUS = 'SHPBLW'; // Spedibile guardaroba
        var pageBundle = 'dry_cleaning';
        var NON_SPECIFICATO = "";
        var NSId = undefined;
        $scope.compReaderMode = COMPONENT_READ_MODE.BARCODE;
        $scope.componentMap = {};
        var admittedStatusList = [];
        $scope.productFilter = [];
        $scope.result = {
            list: []
        };
        $scope.settings = {
            quantity: 1,
            disableConfirm: true,
            saving: false
        };
        var msg = {
            error: 'Error',
            operation_completed: "Salvataggio completato"
        };
        var page_msg = {
            "COMPONENT_NOT_FOUND": "Component not found/missing endowment",
            "COMPONENT_ALREADY_READ": "Component already read",
            "INVALID_STATUS_TRANSITION": "Component status ({{status}}) is not valid",
            "MISSING_COMPONENT_ID": "Missing component id",
            "MISSING_PRODUCT_ID": "Missing product id",
            "MISSING_STATUS": "Missing status",
            "PRODUCT_NOT_FOUND": "Product not found",
            "TRANSITION_NOT_ALLOWED": "Status transition not allowed"
        };
        $scope.record = {
            lookup: {},
            dates: [],
            model: {}
        };

        function checkPermissions() {
            var profilingKey = 'DRY_CLEANING_DIRTY_ACCEPTANCE_FUNCTION';
            var permission = authFactory.getPermissions(profilingKey);
            if (!permission.EXEC) {
                $location.path('forbidden').search({ key: profilingKey });
            }
        };

        function getTimestamp(day) {
            var m = (day.getMonth()+1);
            var mStr = (m<10)?('0'+m.toString()):m.toString();
            var d = (day.getDate());
            var dStr = (d<10)?('0'+d.toString()):d.toString();
            var timestamp = day.getFullYear() + '-' + mStr + '-' +dStr;
            return timestamp;
          }

        function getValidityQuery(table) {
            var timestamp = getTimestamp(new Date());
            var query = '(' + table + '.start_validity_date <= \'' + timestamp +
            '\' AND (' + table + '.end_validity_date IS NULL OR ' + table + '.end_validity_date>\'' + timestamp + '\') )';

            return query;
        }

        function getEndowmentFilter() {
            var filter = [
              {
                "column": "endowment e",
                "value": "t.shipment_destination = e.destination_id OR hr.destination_id = e.destination_id",
                "relation": "JOIN",
                "kind": "e.id AS endowment_id"
              },
              {
                "column": "endowment_item ei",
                "value": "ei.endowment_id = e.id",
                "relation": "JOIN",
                "kind": "ei.product_id AS ei_product_id"
              }
            ];
            var typeFilter = dbFilterFactory.getStringFilter('e.type', "PIANA");
            var valFilter_e = dbFilterFactory.getCustomFilter(getValidityQuery('e'));
            var valFilter_ei = dbFilterFactory.getCustomFilter(getValidityQuery('ei'));
            filter = filter.concat(typeFilter, valFilter_e, valFilter_ei);

            return filter;
        }

        function isNewRead(read) {
            // _ necessary because otherwise numeric barcode break the watch
            var result = ($scope.componentMap['_' + read.read]);
            return (result != undefined);
        };

        $scope.readBarcode = function (read) {
            if (isNewRead(read)) {
                $scope.lastRead = read.read;
                toaster.pop('error', msg.error, page_msg.COMPONENT_ALREADY_READ);
            }
            else {
              var filter = [
                {
                  "column": "human_resource hr",
                  "value": "t.patient_id = hr.id",
                  "relation": "JOIN",
                  "kind": "hr.validity_end as hr_validity_end, hr.name as hr_name, hr.surname as hr_surname, hr.barcode as hr_arm"
                },
                {
                  "column": "customer_destination cd",
                  "value": "hr.destination_id=cd.id",
                  "relation": "JOIN",
                },
                {
                  "column": "customer cu",
                  "value": "cd.customer_id=cu.id",
                  "relation": "JOIN",
                  "kind": "cu.code AS customer_code, cu.description AS customer_desc"
                }
              ];
                filter = filter.concat(dbFilterFactory.getStringFilter('t.barcode', read.read));
                filter = filter.concat(getEndowmentFilter());
                recordFactory('component').filter({page_size: 1000}, filter).$promise
                    .then(function (data) {
                        if (data.totalResults > 0) {
                            var c = data.list[0];
                            if(admittedStatusList.indexOf(c.status)>-1) {
                                $scope.lastRead = read.read;
                                addComponent(c);
                                if(c.hr_validity_end != null){
                                  toaster.pop('warning', 'Ospite dimesso')
                                }
                                var productIds = data.list.map(function(o){return o.ei_product_id});
                                $scope.productFilter.length = 0;
                                $scope.productFilter = $scope.productFilter.concat(dbFilterFactory.getInFilter("t.id", productIds));
                            }
                            else {
                                var sString = componentService.getStatusTranslation(c.status).toUpperCase();
                                localeFactory.translateReplace(pageBundle + '.INVALID_STATUS_TRANSITION', {status: sString}).then(function(transl){
                                    toaster.pop('error', msg.error, transl);
                                })
                            }
                        }
                        else {
                            toaster.pop('error', msg.error, page_msg.COMPONENT_NOT_FOUND);
                        }
                    })
                    .catch(function () {
                        toaster.pop('error', msg.error, msg.server_comunication_error);
                    })
            }
        }

        $scope.removeComponent = function(barcode) {
            delete $scope.componentMap[barcode];
            checkDisableConfirm();
        }

        function addComponent(c) {
          var prodFilter = [];
          var prod = undefined;
          prodFilter = prodFilter.concat(dbFilterFactory.getCustomFilter("t.id = " + c.product_id))
          recordFactory('product').filter({page_size: 1000}, prodFilter).$promise
            .then(function (data) {
              if (data.totalResults > 0) {
                prod = data.list[0];
                prod.model.code = data.list[0].code;
                prod.model.description = data.list[0].description;
              }
              // delete c['product_id'];
              // _ necessary because otherwise numeric barcodes break the watch
              var oldMap = $scope.componentMap;
              $scope.componentMap = {};
              $scope.componentMap['_' + c.barcode] = {
                component: c,
                product: {
                  obj: prod,
                  mapping: {
                    code: 'code',
                    description: 'description'
                  },
                  table: 'product'
                },
                status: {
                  loading: false,
                  saved: false,
                  message: undefined
                }
              };
              for( var e in oldMap){
                $scope.componentMap[e] = oldMap[e];
              }
              checkDisableConfirm();
            })

        }

        $scope.confirm = function () {
            $scope.promises = {};
            for (var _barcode in $scope.componentMap) {
                var item = $scope.componentMap[_barcode];
                if(!item.status.saved) {
                  var disc = null;
                  var hrId = null;
                  if(item.component.patient_id){
                    disc = "PAT"
                    hrId = item.component.patient_id
                  } else if (item.component.employee_id){
                    disc = "EMP"
                    hrId = item.component.employee_id
                  }
                    item.status = {
                        loading: true,
                        saved: false,
                        message: undefined
                    };
                    var payload = {
                        component_id: item.component.id,
                        component_note: item.component.note,
                        product_id: item.product.obj.id,
                        status: NEW_STATUS,
                        discriminator: disc,
                        hrId: hrId
                    };
                    $scope.promises[_barcode] = dryCleaningFactory.changeStatusAndProduct({}, payload).$promise;
                    var property = 'promises.' + _barcode + '.$$state';
                    var pwatcher = $scope.$watch(property, function (newValue, oldValue) {
                        onNewResponse();
                    }, true);
                }
            }
            checkDisableConfirm();
        }

        function onNewResponse(){
            var changedBarcode = undefined;
            var result = undefined;
            for (var _barcode in $scope.promises) {
                if($scope.promises[_barcode].$$state.status===1) {
                    changedBarcode = _barcode;
                    result = $scope.promises[_barcode].$$state.value;
                    break;
                }
            }
            if(changedBarcode) {
                var targetItem = $scope.componentMap[changedBarcode];
                targetItem.status.loading = false;
                delete $scope.promises[changedBarcode];
                if(result.status==='ok') {
                    targetItem.status.saved = true;
                    targetItem.status.message = undefined;
                    checkDisableConfirm();
                }
                else {
                    targetItem.status.message = page_msg[result.messages[0].code];
                    if(!targetItem.status.message) {
                        targetItem.status.message = result.messages[0].message;
                    }
                }
            }
        }

        $scope.lookupChanged = function (barcode) {
            var property = 'componentMap.' + barcode + '.component.product_id';
            var watcher = $scope.$watch(property, function (newValue, oldValue) {
                checkDisableConfirm();
                if (newValue) {
                    watcher();
                }
            }, true);
        }

        $scope.lookupCleared = function () {
            $scope.settings.disableConfirm = true;
        }

        function checkDisableConfirm() {
          var allSpecified = true;

          for (var _barcode in $scope.componentMap) {
            if($scope.componentMap[_barcode].product.obj === undefined){
              allSpecified = false;
            } else {
              if($scope.componentMap[_barcode].product.obj.code === NON_SPECIFICATO){
                allSpecified = false;
              }
            }
          }

            $scope.settings.disableConfirm = $scope.settings.saving || (JSON.stringify($scope.componentMap) === '{}') || isSomeProductMissing() || nothingToSave() || !allSpecified;
        }

        function isSomeProductMissing() {
            var result = false;
            for (var _barcode in $scope.componentMap) {
                if ($scope.componentMap[_barcode].component.product_id == undefined) {
                    result = true;
                    break;
                }
            }
            return result;
        }

        function nothingToSave() {
            var somethingToSave = false;
            for (var _barcode in $scope.componentMap) {
                if ($scope.componentMap[_barcode].status.loading == false && $scope.componentMap[_barcode].status.saved == false) {
                    somethingToSave = true;
                    break;
                }
            }
            return !somethingToSave;
        }

        $scope.reset = function () {
            $scope.componentMap = {};
            $scope.productFilter.length = 0;
            checkDisableConfirm();
        }

        $scope.goToJsfComponentLabelPrint = function () {
          var barcodes = Object.values($scope.componentMap)
            .map(function (_) { return _.component; })
            .map(function (_) { return _.barcode; });
          if (barcodes.length) {
            // init before start edit
            var tmpIframe = document.createElement('iframe');
            tmpIframe.style.display = 'none';
            tmpIframe.src = APP_URL + '/?jsfAction=' + 'componentLabelPrintFunction.startPage';
            tmpIframe.onload = function () {
              $timeout(function () {
                $http.post(APP_URL + '/rest/util/invoke-method/com.eggsweb.production.function.ComponentLabelPrintFunction/startEditByBarcodes', {
                  args: [ $scope.showComponentLabelPrintLinkMultiple ? barcodes : [$scope.lastRead] ],
                  argsTypes: ['java.util.List']
                }).then(function () {
                  $http.post(APP_URL + '/rest/util/invoke-method/com.eggsweb.production.function.ComponentLabelPrintFunction/setSkipOneReset', {
                    args: [true]
                  }).then(function () {
                    $location.path('jsf').search({jsfAction: 'componentLabelPrintFunction.startPage'});
                  });
                });
              }, 2000);
            };
            document.body.append(tmpIframe);
          } else {
            $location.path('jsf').search({jsfAction: 'componentLabelPrintFunction.startPage'});
          }
        }

        $scope.goToJsfQualityCheck = function () {
          var components = Object.values($scope.componentMap);
          if (components.length) {
            var barcodes = components
              .map(function (_) { return _.component; })
              .map(function (_) { return _.barcode; });
            $http.post(APP_URL + '/rest/util/invoke-method/com.eggsweb.production.function.ProcessingLMFunction/setLastRead', {
              args: [$scope.lastRead]
            })
              .then(function () {
                $http.post(APP_URL + '/rest/util/invoke-method/com.eggsweb.production.function.ProcessingLMFunction/setCompReadListToAddAfterChoosenReason', {
                  args: [ $scope.showQualityCheckLinkMultiple ? barcodes : [$scope.lastRead] ],
                  argsTypes: ['java.util.List']
                })
                  .then(function () {
                    $location.path('jsf').search({jsfAction: 'processingLMFunction.startPage'});
                  });
              });
          } else {
            $location.path('jsf').search({jsfAction: 'processingLMFunction.startPage'});
          }
        }

        function getAdmittedStatuses() {
            workflowFactory.getComponentStatusPredecessors({ param1: NEW_STATUS }).$promise
                .then(function (data) {
                    admittedStatusList = data.result;
                })
        }

        function init() {
            $scope.reset();
            checkPermissions();
            getAdmittedStatuses();
            matrixParFactory.getMatrixPar({key: 'defaultPatientArticleCode', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}).
            $promise.then(function(data){
              if (data.value) {
                NON_SPECIFICATO = data.value;
                var nsfilter = [];
                nsfilter = nsfilter.concat(dbFilterFactory.getCustomFilter("t.code = '"+ NON_SPECIFICATO+"'"))
                recordFactory('product').filter({page_size: 1000}, nsfilter).$promise
                  .then(function (data) {
                    if (data.totalResults > 0) {
                      NSId = data.list[0].id;
                    }
                  })
              }
            });
            localeFactory.loadTranslation('component');
            localeFactory.loadTranslation(pageBundle)
                .then(function () {
                    $q.all({
                        general: localeFactory.translateMsg(msg),
                        specific: localeFactory.translateMsg(page_msg, pageBundle)
                    });
                });

            matrixParFactory.getValueOrDefault({key: 'showComponentLabelPrintLink', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}, {defaultValue: 'false'}).$promise
                .then(function (data) {
                    $scope.showComponentLabelPrintLink = data.result.value === 'true';
                });
            matrixParFactory.getValueOrDefault({key: 'showComponentLabelPrintLink.multiple', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}, {defaultValue: 'false'}).$promise
                .then(function (data) {
                    $scope.showComponentLabelPrintLinkMultiple = data.result.value === 'true';
                });
            matrixParFactory.getValueOrDefault({key: 'showQualityCheckLink', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}, {defaultValue: 'false'}).$promise
                .then(function (data) {
                    $scope.showQualityCheckLink = data.result.value === 'true';
                });
            matrixParFactory.getValueOrDefault({key: 'showQualityCheckLink.multiple', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}, {defaultValue: 'false'}).$promise
                .then(function (data) {
                    $scope.showQualityCheckLinkMultiple = data.result.value === 'true';
                });
        }

        init();

    });

/**
 * @ngdoc function
 * @name ictportal.lm.controller:dirty-acceptance
 * @description Dry cleaning - Label print (SIXLM-373)
 * @author Rita Beltrami
 * 
 * created on 23/04/2019
 * # DryCleaningLabelPrintCtrl
 * Controller of the ictportal.lm
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/dry/cleaning/label/print', {
                templateUrl: 'lm/dryCleaningLabelPrint/dry-cleaning-label-print.html',
                controller: 'DryCleaningLabelPrintCtrl'
            })
    })
    .controller('DryCleaningLabelPrintCtrl', function ($scope, eggsFormFactory,
        toaster, localeFactory, authFactory, $location, $q, serialKitLMFactory,
        localStorageService, dryCleaningFactory, recordFactory, dbFilterFactory,
        componentFactory) {

        var pageBundle = 'dry_cleaning';
        $scope.result = {
            list: []
        };
        $scope.settings = {
            checkAll: false,
            quantity: 1,
            disableConfirm: true,
            saving: false
        };
        var msg = {
            error: 'Error',
            operation_completed: "Salvataggio completato",
            operation_completed_success: "Salvataggio completato con successo. Stampa in corso."
        };
        var page_msg = {
            "no_destination_for_customer": "No customer destination found for selected customer",
            "multiple_destinations_for_customer": "Multiple customer destinations found for selected customer. The first one will be used.",
            "MISSING_QUANTITY": "Missing quantity",
            "INVALID_QUANTITY": "Quantity must be a positive number",
            "MISSING_CUSTOMER": "Missing customer",
            "MISSING_DESTINATION": "Missing customer destination",
            "MISSING_PRINTER": "Missing printer",
            "CREATION_ERROR": "Error during component creation",
            "BARCODE_ERROR": "Error during barcodes generation",
            "FAKE_PRODUCT_CODE_NOT_FOUND": "Error retrieving 'component.fakeTmpComponentProduct' key from matrixPar",
            "PRODUCT_NOT_FOUND": "Temporary product not found",
            "MISSING_COMPONENTS_IDS": "Missing components ids",
            "MAKE_LABEL_ERROR": "Error filling the label"
        };
        var authData = authFactory.getAuthData();
        $scope.record = {
            lookup: {},
            dates: [],
            model: {}
        };

        $scope.printByIds = function() {
            var payload = {
                component_ids: $scope.getSelectedComponents().map(function(c) { return c.id; }),
                printer_id: $scope.record.model.printer_id,
                label_matrixpar_key: "specificLabelForPrinter.ENTRATA"
            };
            componentFactory.printById({}, payload).$promise.then(function (data) {
                if (data.status == 'ok') {
                    console.log(data);
                    toaster.pop('success', msg.operation_completed, msg.operation_completed_success);
                }
                else {
                    eggsFormFactory.logServerException(data, pageBundle);
                }
            });
        }

        $scope.getSelectedComponents = function() {
            return $scope.result.list.filter(function(c) { return c.checked == true; });
        }

        $scope.createAndPrint = function () {
            var payload = {
                quantity: $scope.settings.quantity,
                customer_id: $scope.record.model.customer_id,
                destination_id: $scope.record.model.customer_destination_id,
                printer_id: $scope.record.model.printer_id
            };
            dryCleaningFactory.createAndPrint({}, payload).$promise.then(function (data) {
                if (data.status == 'ok') {
                    console.log(data);
                    $scope.result = angular.extend({}, data.result);
                    toaster.pop('success', msg.operation_completed, msg.operation_completed_success);
                }
                else {
                    eggsFormFactory.logServerException(data, pageBundle);
                }
            });
        };

        function checkPermissions() {
            var profilingKey = 'DRY_CLEANING_LABEL_PRINT_FUNCTION';
            var permission = authFactory.getPermissions(profilingKey);
            if (!permission.EXEC) {
                $location.path('forbidden').search({ key: profilingKey });
            }
        };

        function getCustomerImplicitFilters() {
            return authData.filters.customer;
        };

        $scope.$watch('record.model.customer_id',
            function (newValue, oldValue) {
                if (newValue && newValue != oldValue) {
                    getCustomerDestination(newValue);
                }
                else if(!newValue) {
                    $scope.record.model.customer_destination_id = undefined;
                }
            }
        )

        function getCustomerDestination(customerId) {
            var destFilter = dbFilterFactory.getNumberFilter('t.customer_id', customerId);
            recordFactory('customer_destination').filter({}, destFilter).$promise
            .then(function(data) {
                if(data.totalResults<=0){
                    toaster.pop('error', msg.error, page_msg.no_destination_for_customer);
                }
                else {
                    if(data.totalResults>1) {
                        toaster.pop('warning', msg.warning, page_msg.multiple_destinations_for_customer + ' (' + data.list[0].description + ').' );
                    }
                    $scope.record.model.customer_destination_id = data.list[0].id;
                    console.log('Customer destination:');
                    console.log(data.list[0]);
                }    
            });
        }

        $scope.$watchGroup(['settings.quantity', 'record.model.customer_id', 'record.model.customer_destination_id', 'record.model.printer_id'], function (newValue, oldValue) {
            $scope.settings.disableConfirm = $scope.settings.saving || !$scope.settings.quantity || $scope.settings.quantity <= 0 || !$scope.record.model.customer_id || !$scope.record.model.printer_id|| !$scope.record.model.customer_destination_id;
        });

        $scope.selectAll = function() {
            $scope.result.list.forEach(function(item) {
                item.checked = $scope.settings.checkAll;
            });
        }

        // Se c'è, recupero la stampante di default per la workstation corrente
        function getWorkstationPrinter() {
            var workstation = localStorageService.get('workstation');
            if (workstation) {
                var payload = { workstation: workstation };
                serialKitLMFactory.getWsPrinter(payload).$promise.then(function (response) {
                    $scope.record.model.printer_id = response.printer;
                    eggsFormFactory.loadLookupData($scope.record.lookup, $scope.record.model);
                });
            }
        };

        function initLookups() {
            eggsFormFactory.addLookup($scope.record.lookup, 'customer_id', 'customer', 'code', 'description');
            eggsFormFactory.addLookup($scope.record.lookup, 'printer_id', 'label_printer', 'code', 'description');
        }

        function init() {
            checkPermissions();
            initLookups();
            $scope.customerFilter = getCustomerImplicitFilters();
            getWorkstationPrinter();
            localeFactory.loadTranslation(pageBundle)
                .then(function () {
                    $q.all({
                        general: localeFactory.translateMsg(msg),
                        specific: localeFactory.translateMsg(page_msg, pageBundle)
                    });
                });
        }

        init();

    });

/**
 * @ngdoc function
 * @description Dry cleaning patient
 * @author Rita Beltrami
 *
 * created on 23/04/2020
 * # DryCleaningPatientLabelPrintCtrl
 * Controller of the ictportal.lm
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/dry/cleaning/patient/label/print', {
                templateUrl: 'lm/dryCleaningPatientLabelPrint/dry-cleaning-patient-label-print.html',
                controller: 'DryCleaningPatientLabelPrintCtrl'
            })
    })
    .controller('DryCleaningPatientLabelPrintCtrl', function ($scope, eggsFormFactory,
        toaster, localeFactory, authFactory, $location, $q, serialKitLMFactory,
        localStorageService, dryCleaningFactory, recordFactory, dbFilterFactory,
        componentFactory) {

        var pageBundle = 'dry_cleaning';
        $scope.customer_id = null;
        $scope.customer_code = null;
        $scope.customer_desc = null;
        $scope.result = {
            list: []
        };
        $scope.settings = {
            checkAll: false,
            quantity: 0,
            disableConfirm: true,
            saving: false
        };
        var msg = {
            error: 'Error',
            operation_completed: "Salvataggio completato",
            operation_completed_success: "Salvataggio completato con successo. Stampa in corso."
        };
        var page_msg = {
            "no_destination_for_customer": "No customer destination found for selected customer",
            "multiple_destinations_for_customer": "Multiple customer destinations found for selected customer. The first one will be used.",
            "MISSING_QUANTITY": "Missing quantity",
            "INVALID_QUANTITY": "Quantity must be a positive number",
            "MISSING_DESTINATION": "Missing customer destination",
            "MISSING_PRINTER": "Missing printer",
            "CREATION_ERROR": "Error during component creation",
            "BARCODE_ERROR": "Error during barcodes generation",
            "FAKE_PRODUCT_CODE_NOT_FOUND": "Error retrieving 'component.fakeTmpComponentProduct' key from matrixPar",
            "PRODUCT_NOT_FOUND": "Temporary product not found",
            "MISSING_COMPONENTS_IDS": "Missing components ids",
            "MAKE_LABEL_ERROR": "Error filling the label",
            "PATIENT_NOT_FOUND": "Error: patient not found",
            "MISSING_PATIENT": "Missing patient"
        };
        $scope.record = {
            lookup: {},
            dates: [],
            model: {}
        };

        $scope.fromBarcode = null;
        $scope.toBarcode = null;

        $scope.printByIds = function() {
            var payload = {
                component_ids: $scope.getSelectedComponents().map(function(c) { return c.id; }),
                printer_id: $scope.record.model.printer_id,
                label_matrixpar_key: "specificLabelForPrinter.ENTRATA",
                label_code: null
            };
            if($scope.record.lookup.label_id.obj){
              payload.label_code = $scope.record.lookup.label_id.obj.code;
            }
            componentFactory.printById({}, payload).$promise.then(function (data) {
                if (data.status == 'ok') {
                    console.log(data);
                    toaster.pop('success', msg.operation_completed, msg.operation_completed_success);
                }
                else {
                    eggsFormFactory.logServerException(data, pageBundle);
                }
            });
        }

        $scope.getSelectedComponents = function() {
            return $scope.result.list.filter(function(c) { return c.checked == true; });
        }

        $scope.createAndPrint = function () {
            var payload = {
                quantity: $scope.settings.quantity,
                destination_id: $scope.record.model.customer_destination_id,
                printer_id: $scope.record.model.printer_id,
                label_matrixpar_key: "specificLabelForPrinter.ENTRATA",
                label_id: null,
                parent_id: $scope.record.model.parent_destination
            };
            if($scope.record.lookup.label_id.obj){
              payload.label_code = $scope.record.lookup.label_id.obj.code;
            }
            if($scope.record.lookup.hr_id.obj.discriminator === "PAT"){
              payload.patient_id = $scope.record.model.hr_id;
              dryCleaningFactory.createAndPrintPatient({}, payload).$promise.then(function (data) {
                if (data.status == 'ok') {
                  console.log(data);
                  $scope.result.list = $scope.result.list.concat(data.result.list);
                  loadBarcodes($scope.record.lookup.hr_id.obj);
                  toaster.pop('success', msg.operation_completed, msg.operation_completed_success);
                }
                else {
                  eggsFormFactory.logServerException(data, pageBundle);
                }
              });
            } else if($scope.record.lookup.hr_id.obj.discriminator === "EMP"){
              payload.employee_id = $scope.record.model.hr_id;
              payload.customer_id = $scope.record.model.customer_id;
              dryCleaningFactory.createAndPrint({}, payload).$promise.then(function (data) {
                if (data.status == 'ok') {
                  console.log(data);
                  $scope.result.list = $scope.result.list.concat(data.result.list);
                  loadBarcodes($scope.record.lookup.hr_id.obj);
                  toaster.pop('success', msg.operation_completed, msg.operation_completed_success);
                }
                else {
                  eggsFormFactory.logServerException(data, pageBundle);
                }
              });
            }

        };

        function checkPermissions() {
            var profilingKey = 'DRY_CLEANING_LABEL_PRINT_FUNCTION';
            var permission = authFactory.getPermissions(profilingKey);
            if (!permission.EXEC) {
                $location.path('forbidden').search({ key: profilingKey });
            }
        };

        $scope.$watch('record.lookup.hr_id.obj',
            function (newValue, oldValue) {
                if (newValue && newValue != oldValue) {
                    getCustomerDestination(newValue.destination_id);
                    loadBarcodes($scope.record.lookup.hr_id.obj);
                }
                else if(!newValue) {
                    $scope.record.model.customer_destination_id = undefined;
                    $scope.record.model.customer_id = undefined;
                    $scope.customer_code = null;
                    $scope.customer_desc = null;
                }
            }
        )

        $scope.refreshList = function() {
          if ($scope.record.lookup.hr_id.obj){
            loadBarcodes($scope.record.lookup.hr_id.obj);
          }
        }

        function getCustomerDestination(customerDestinationId) {
            var destFilter = [{
              "column": "receiver_type rt",
              "value": "t.receiver_type_id = rt.id",
              "relation": "JOIN",
              "kind" : "rt.code as rt_code"
            }];
            destFilter = destFilter.concat(dbFilterFactory.getNumberFilter('t.id', customerDestinationId));
            recordFactory('customer_destination').filter({}, destFilter).$promise
            .then(function(data) {
                $scope.record.model.customer_destination_id = data.list[0].id;
                if(data.list[0].rt_code === "GUA"){
                  $scope.record.model.parent_destination = data.list[0].id;
                } else {
                  $scope.record.model.parent_destination = data.list[0].parent ? data.list[0].parent : null;
                }

                $scope.record.model.customer_id = data.list[0].customer_id;
                console.log('Customer destination:');
                console.log(data.list[0]);
                getCustomer()
            });
        }

      function getCustomer() {
        if($scope.record.model.customer_id){
          var custFilter = dbFilterFactory.getNumberFilter('t.id', $scope.record.model.customer_id);
          recordFactory('customer').filter({}, custFilter).$promise
            .then(function(data) {
              if(data.list.length > 0){
                $scope.customer_code = data.list[0].code;
                $scope.customer_desc = data.list[0].description;
              }
            });
        }
      }

        function checkBarcode(barcode, from, to) {
          if(from && to){
            return barcode >= from && barcode <= to;
          }
          if(from && !to){
            return barcode >= from;
          }
          if(!from && to){
            return barcode <= to;
          }
          return true;
        }

        function loadBarcodes(hr) {
          var compFilter = [
            {
              "column": "product p",
              "value": "t.product_id = p.id",
              "relation": "JOIN",
              "kind": "p.code as product_code, p.description product_description"
            }
          ];
          if($scope.record.lookup.hr_id.obj.discriminator === "PAT"){
            compFilter = compFilter.concat(dbFilterFactory.getNumberFilter('t.patient_id', hr.id));
          } else {
            compFilter = compFilter.concat(dbFilterFactory.getNumberFilter('t.employee_id', hr.id));
          }

          recordFactory('component').filter({page_size: 10000}, compFilter).$promise
            .then(function(data) {
              $scope.result.list = []
              if(data.list && data.list.length > 0) {
                data.list.map(function (e){
                  var entry = {
                    id : e.id,
                    barcode : e.barcode,
                    product_code : e.product_code,
                    product_description : e.product_description
                  }
                  if(checkBarcode(entry.barcode, $scope.fromBarcode, $scope.toBarcode)){
                    $scope.result.list = $scope.result.list.concat(e);
                  }
                })
                $scope.result.list.sort(function(a,b){
                  return a.barcode.localeCompare(b.barcode);
                });
              }
              $scope.settings.checkAll = false;
              $scope.selectAll();
            });
        }

        $scope.$watchGroup(['settings.quantity', 'record.model.hr_id', 'record.model.customer_destination_id', 'record.model.printer_id'], function (newValue, oldValue) {
            $scope.settings.disableConfirm = $scope.settings.saving || !$scope.settings.quantity || $scope.settings.quantity <= 0 || !$scope.record.model.hr_id || !$scope.record.model.printer_id|| !$scope.record.model.customer_destination_id;
        });

      $scope.$watchGroup(['fromBarcode', 'toBarcode'], function (newValue, oldValue) {

      });

        $scope.selectAll = function() {
            $scope.result.list.forEach(function(item) {
                item.checked = $scope.settings.checkAll;
            });
        }

        // Se c'è, recupero la stampante di default per la workstation corrente
        function getWorkstationPrinter() {
            var workstation = localStorageService.get('workstation');
            if (workstation) {
                var payload = { workstation: workstation };
                serialKitLMFactory.getWsPrinter(payload).$promise.then(function (response) {
                    $scope.record.model.printer_id = response.printer;
                    eggsFormFactory.loadLookupData($scope.record.lookup, $scope.record.model);
                });
            }
        };

        function initLookups() {
            eggsFormFactory.addLookup($scope.record.lookup, 'hr_id', 'human_resource', 'matriculation', 'surname,name');
            eggsFormFactory.addLookup($scope.record.lookup, 'printer_id', 'label_printer', 'code', 'description');
            eggsFormFactory.addLookup($scope.record.lookup, 'label_id', 'label', 'code', 'description');
        }

        function init() {
            checkPermissions();
            initLookups();
            $scope.humanResourceFilter = dbFilterFactory.getCustomFilter("discriminator in ('PAT', 'EMP')");
            getWorkstationPrinter();
            localeFactory.loadTranslation(pageBundle)
                .then(function () {
                    $q.all({
                        general: localeFactory.translateMsg(msg),
                        specific: localeFactory.translateMsg(page_msg, pageBundle)
                    });
                });
        }

        init();

    });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.core.controller:DryCleaningSyncCtrl
 * @description Function to select ShipmentDocuments to be syncronized with EGGS
 * @author Rita Beltrami
 * created on 08/07/2019
 * # DryCleaningSyncCtrl
 * Controller of the ictportal.core
 */
angular.module('ictportal.core')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/dry/cleaning/sync', {
                templateUrl: 'lm/dryCleaningSync/dry-cleaning-sync.html',
                controller: 'DryCleaningSyncCtrl'
            })
    })
    .controller('DryCleaningSyncCtrl', function ($scope, recordFactory, $location, shipmentDocumentService, authFactory,
                                                      parseSchemaService, dbFilterFactory, localeFactory, toaster, 
                                                      eggsFormFactory, shipmentDocumentFactory, eggsSyncFactory) {
        var pageBundle = 'shipment';
        var msg = {
            error: 'Errore',
            success: "Successo",
            warning: "Attenzione",
            server_comunication_error: "Errore di comunicazione con il server"
        };                                       
        var shipment_msg = {
            integration_type: "Order from",
            ddt_number: "Shipment number",
            date: "Date",
            bar:  "Bar",
            customer_code: "Cust. code",
            destination: "Destination",
            delivery_date: "Delivery date",
            invoicing_customer: "Billing cust.",
            customer_description: "Cust. corporate",
            SYNC_SUCCESS:"Sincronizzazione completata con successo",
            SYNC_WARNING:"Sincronizzazione completata con errori",
            SYNC_ERROR:"Sincronizzazione fallita"
            };  
        $scope.result = {};
        var authData = authFactory.getAuthData();
        $scope.record = {
            lookup: {}, // Per questa pagina non serve, la lascio un attimo mentre penso a come standardizzare il più possibile le pagine
            dates: ['date', 'delivery_date']
        };
        $scope.params = {
            pageNumber: 1,
            pageSize: 15,
            code: 'component',
            filters: []
        };
        $scope.advFilter = {
            filter: {},
            list: []
        };
        $scope.enum = {};


        // ATTENZIONE: non spostare da qui
        $scope.sixRowSelectionChangedCallback = function(row, col, event){
            if(row.isSelected && row.entity.send_to_master!=='T') {
                console.log("Set send_to_master='T'");
                setSendToMaster(row.entity.id,true);
            }
            else if(!row.isSelected && row.entity.send_to_master=='T') {
                console.log("Set send_to_master='F'");
                setSendToMaster(row.entity.id,false);
            }
        };

        $scope.rowSelectionChangedBatchCallback = function(rows){
            var payload = {
                shipment_document_id_list: []
            };
            rows.forEach(function(row){

                if(row.isSelected && row.entity.send_to_master!=='T') {
                    payload.send_to_master = true;
                    payload.shipment_document_id_list.push(row.entity.id);
                }
                else if(!row.isSelected && row.entity.send_to_master=='T') {
                    payload.send_to_master = false;
                    payload.shipment_document_id_list.push(row.entity.id);
                }
            });
            if(payload.shipment_document_id_list.length>0) {
                setSendToMasterBatch(payload);
            }
          };

        $scope.viewGridOptions = { 
            appScopeProvider: $scope,
            multiSelect: true,
            enableRowHeaderSelection: true,
            enableRowSelection: true,
            rowSelectionChanged: $scope.sixRowSelectionChangedCallback,
            rowSelectionChangedBatch: $scope.rowSelectionChangedBatchCallback
        };

        // Quando mi arrivano i dati da BE, evidenzio le righe che hanno il flag send_to_master attivo.
        function checkSelected() {
            $scope.result.list.forEach(function(ddt){
                if(ddt.send_to_master=='T') {
                    $scope.viewGridOptions.gridApi.selection.selectRow(ddt); // questo scatena l'evento sixRowSelectionChangedCallback
                }
            }); 
        }

        // Chiama SIX e imposta il flag send_to_master sul DDT
        function setSendToMaster(documentId, active) {
            var payload = {
                shipment_document_id: documentId,
                send_to_master: active
            };
            shipmentDocumentFactory.setSendToMaster({},payload).$promise.then(function(data){
                if (data.status == 'ok') {
                    confirmUpdateSendToMaster(data.result.shipment_document_id,data.result.send_to_master);
                }
                else {
                    eggsFormFactory.logServerException(data, pageBundle);
                }
            });
        }

        function confirmUpdateSendToMaster(shipment_document_id, send_to_master) {
            var ddt = $scope.result.list.find(function(item){
                return item.id===shipment_document_id;
            }); 
            ddt.send_to_master = send_to_master?'T':'F';
        }

        // Chiama SIX e imposta il flag send_to_master su tutti i DDT indicati
        function setSendToMasterBatch(payload) {
            shipmentDocumentFactory.setSendToMasterBatch({},payload).$promise.then(function(data){
                if (data.status == 'ok') {
                    data.result.shipment_document_id_list.forEach(function(item) {
                        confirmUpdateSendToMaster(item, data.result.send_to_master);
                    });
                }
                else {
                    eggsFormFactory.logServerException(data, pageBundle);
                }
            });
        }

        $scope.$watchGroup(['advFilter.filter.barcode',
            'advFilter.filter.ddt_number',
            'advFilter.filter.bar',
            'advFilter.filter.ddt_date_from',
            'advFilter.filter.ddt_date_to',
            'advFilter.filter.delivery_date',
            'advFilter.filter.customer_id',
            'advFilter.filter.customer_destination',
            'advFilter.filter.invoicing_customer_id',
            'advFilter.filter.type_id',
            'advFilter.filter.state',
            'advFilter.filter.integration_type'], function () {
                $scope.applyFilter();
            });

        $scope.applyFilter = function () {
            $scope.advFilter.list.length = 0;
            if ($scope.advFilter.filter.barcode) {
                var f = dbFilterFactory.getLikeFilter('t.barcode', $scope.advFilter.filter.barcode);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.ddt_number) {
                var f = dbFilterFactory.getNumberFilter('t.ddt_number', $scope.advFilter.filter.ddt_number);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.bar) {
                var f = dbFilterFactory.getLikeFilter('t.bar', $scope.advFilter.filter.bar);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.ddt_date_from) {
                var f = dbFilterFactory.getDateFilter('t.ddt_date', $scope.advFilter.filter.ddt_date_from, '>=');
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.ddt_date_to) {
                var f = dbFilterFactory.getDateFilter('t.ddt_date', $scope.advFilter.filter.ddt_date_to, '<=');
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.delivery_date) {
                var f = dbFilterFactory.getDateFilter('t.delivery_date', $scope.advFilter.filter.delivery_date);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.customer_id) {
                var f = dbFilterFactory.getNumberFilter('t.customer_id', $scope.advFilter.filter.customer_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.customer_destination) {
                var f = dbFilterFactory.getNumberFilter('t.customer_destination', $scope.advFilter.filter.customer_destination);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.invoicing_customer_id) {
                var f = dbFilterFactory.getNumberFilter('t.invoicing_customer_id', $scope.advFilter.filter.invoicing_customer_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.type_id) {
                var f = dbFilterFactory.getNumberFilter('t.type_id', $scope.advFilter.filter.type_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.state) {
                var f = dbFilterFactory.getStringFilter('t.state', $scope.advFilter.filter.state);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.integration_type) {
                var f = [{
                    "column": "customer_order co",
                    "value": "t.customer_order_id = c.id",
                    "relation": "JOIN",
                    "kind": "co.integration_type"
                }];
                f = f.concat(dbFilterFactory.getStringFilter('co.integration_type', $scope.advFilter.filter.integration_type));
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            $scope.getData();
        };

        function initGridColumns() {
            $scope.lookupCols = [];
            $scope.viewGridOptions.columnDefs = [];
            var dateFormat = localeFactory.getDateFormat();
            $scope.viewGridOptions.columnDefs.push({
                name: 'Cod. cliente',
                field: "customer_code",
                translation: 'customer_code', 
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Ragione sociale cliente",
                field: "customer_description",
                translation: 'customer_description',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Cliente fatt.",
                field: "invoicing_customer_description",
                translation: 'invoicing_customer',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: 'Destinazione',
                cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.customer_destination_code}} - {{row.entity.customer_destination_description}}</div>',
                translation: 'destination',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "DDT Number",
                field: "ddt_number",
                translation: 'ddt_number',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Barra",
                field: "bar",
                translation: 'bar',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Data",
                field: "ddt_date",
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.ddt_date | date:\'' + dateFormat + '\' }}</div>',
                translation: 'date',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Data consegna",
                field: "delivery_date",
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.delivery_date | date:\'' + dateFormat + '\' }}</div>',
                translation: 'delivery_date',
                enableFiltering: false
            });
        };

        $scope.getData = function () {
            var payload = {
                page: $scope.params.pageNumber,
                page_size: $scope.params.pageSize,
                code: $scope.params.code,
                description: $scope.params.description,
                show_revision: false,
                sort_fields: ($scope.params.sortFields ? $scope.params.sortFields : 'created_date'),
                sort_order: $scope.params.sortOrder
            };
            // Qui scrivo i filtri obbligatori, quelli 'avanzati' li accodo 
            var filters = [
                {
                    "column": "customer c",
                    "value": "t.customer_id = c.id",
                    "relation": "JOIN",
                    "kind": "c.code AS customer_code, c.description AS customer_description"
                },
                {
                    "column": "customer i",
                    "value": "t.invoicing_customer_id = i.id",
                    "relation": "JOIN",
                    "kind": "i.code AS invoicing_customer_code"
                },
                {
                    "column": "customer_destination cd",
                    "value": "t.customer_destination = cd.id",
                    "relation": "JOIN",
                    "kind": "cd.code AS customer_destination_code, cd.description AS customer_destination_description"
                }
            ];
            // per i ddt di resto, discriminator = CUSTRETURN
            filters = filters.concat(dbFilterFactory.getStringFilter('t.discriminator', 'CUSTOMER'));
            filters = filters.concat(dbFilterFactory.getNullableFilter('t.master_id', 'IS NULL'));
            filters = filters.concat($scope.advFilter.list);
            recordFactory('shipment').filter(payload, filters)
                .$promise.then(function (data) {
                    $scope.viewGridOptions.totalItems = data.totalResults;
                    $scope.result.totalResults = data.totalResults;
                    $scope.result.list = data.list;
                    setTimeout(function(){ checkSelected(); }, 100);
                    if ($scope.record.dates.length > 0) {
                        parseSchemaService.loadDates($scope.record, $scope.result);
                    }
                });
        };

        $scope.launchSync = function (entities) {
            var payload = {
                entity_list: entities
            };
            eggsSyncFactory.syncEntities({},payload).$promise.then(function(data){
                if (data.result && data.result.success) {
                    if (data.status == "warnings") {
                        toaster.pop('warning', msg.warning, shipment_msg.SYNC_WARNING);
                    } else {
                        toaster.pop('success', msg.success, shipment_msg.SYNC_SUCCESS);
                    }
                } else {
                    toaster.pop('error', msg.error, shipment_msg.SYNC_ERROR);
                }
                if (data.messages) {
                    console.error(data.messages);
                }
                if (entities == "CUSTOMER_SHIPMENT") {
                    $scope.getData();
                }
            });
        };

        $scope.viewDetail = function (value) {
            $location.path('/core/shipmentdocument/detail/' + value.id);
        };

        $scope.goToNew = function(){
            $location.path('/core/shipmentdocument/detail');
        };

        function initFilters(){
            // Filtro da applicare alla lookup sul tipo
            $scope.shipmentTypeFilter = dbFilterFactory.getStringFilter('type', 'SALE')
                                        .concat(dbFilterFactory.getNullableFilter('validity_end', 'IS NULL'));
            $scope.customerFilter = authData.filters.customer; // Filtro da applicare alla lookup sugli ospedali
            $scope.shipmentDestinationFilter = authData.filters.customer_destination; // Filtro da applicare sulle righe della tabella
            $scope.employeeCustomerFilter = []; // Filtro da applicare sulla lookup dei dipendenti
        }; 

        function translateGridColumns(){
            $scope.viewGridOptions.columnDefs.forEach(function(col){
                if(col.translation) {
                    col.name = shipment_msg[col.translation];
                }
            });
        };

        function initLookups() {
            $scope.lookup = {};
            eggsFormFactory.addLookup($scope.lookup, 'customer_id', 'customer', 'code', 'description');
            eggsFormFactory.addLookup($scope.lookup, 'customer_destination', 'customer_destination', 'code', 'description');
            eggsFormFactory.addLookup($scope.lookup, 'invoicing_customer_id', 'customer', 'code', 'description');
            eggsFormFactory.addLookup($scope.lookup, 'type_id', 'shipment_type', 'code', 'description');
        };

        function checkPermissions() {
            var profilingKey = 'DRY_CLEANING_SYNC';
            $scope.permission = authFactory.getPermissions(profilingKey);
            if(!$scope.permission.EXEC) {
                $location.path('forbidden').search({key: profilingKey});
            }
        };

        function init() {
            initGridColumns();
            checkPermissions();
            localeFactory.loadTranslation(pageBundle).then(function() {
                localeFactory.translateMsg(shipment_msg, 'shipment').then(function(){
                    translateGridColumns();
                });
            });
            initLookups();
            initFilters();
            $scope.enum = shipmentDocumentService.enum;
        };

        //___ main ___
        init();

    });
/**
 * @ngdoc function
 * @name ictportal.lm.controller:DryCleaningWashingCtrl
 * @description Dry cleaning - Washing (SIXLM-375)
 * @author Rita Beltrami
 * 
 * User must select a printer. Then, he can read component barcodes. Once read,
 * component (if exist and all data are consistent), component status is changed
 * to shippable. After that, a label is printed.
 * 
 * created on 30/04/2019
 * # DryCleaningWashingCtrl
 * Controller of the ictportal.lm
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/dry/cleaning/washing', {
                templateUrl: 'lm/dryCleaningWashing/dry-cleaning-washing.html',
                controller: 'DryCleaningWashingCtrl'
            })
    })
    .controller('DryCleaningWashingCtrl', function ($scope, componentFactory,
        toaster, localeFactory, authFactory, $location, $q, COMPONENT_READ_MODE,
        recordFactory, dbFilterFactory, workflowFactory, componentService,
        eggsFormFactory, localStorageService, serialKitLMFactory) {

        $scope.promises = {};
        var NEW_STATUS = 'SHPBLW'; // Spedibile
        var pageBundle = 'dry_cleaning';
        $scope.compReaderMode = COMPONENT_READ_MODE.BARCODE;
        $scope.componentMap = {};
        var admittedStatusList = [];
        $scope.result = {
            list: []
        };
        $scope.settings = {
            quantity: 1,
            disableReader: true,
            saving: false
        };
        var msg = {
            error: 'Error',
            operation_completed: "Salvataggio completato"
        };
        var page_msg = {
            "COMPONENT_NOT_FOUND": "Component not found",
            "COMPONENT_ALREADY_READ": "Component already read",
            "INVALID_STATUS_TRANSITION": "Component status ({{status}}) is not valid",
            "MISSING_COMPONENT_ID": "Missing component id",
            "MISSING_PRODUCT_ID": "Missing product id",
            "MISSING_STATUS": "Missing status",
            "PRODUCT_NOT_FOUND": "Product not found",
            "TRANSITION_NOT_ALLOWED": "Status transition not allowed",
            "MAKE_LABEL_ERROR": "Error filling the label",
            "MISSING_SHIPMENT_DESTINATION": "Missing shipment destination on component"
        };
        $scope.record = {
            lookup: {},
            dates: [],
            model: {}
        };

        $scope.printById = function(id) {
            var payload = {
                component_ids: [id],
                printer_id: $scope.record.model.printer_id,
                //label_code: "LAVAGGIO"
                label_matrixpar_key: "specificLabelForPrinter.LAVAGGIO"
            };
            componentFactory.printById({}, payload).$promise.then(function (data) {
                if (data.status == 'ok') {
                    console.log(data);
                    toaster.pop('success', msg.operation_completed, msg.operation_completed_success);
                }
                else {
                    eggsFormFactory.logServerException(data, pageBundle);
                }
            });
        }

        // Se c'è, recupero la stampante di default per la workstation corrente
        function getWorkstationPrinter() {
            var workstation = localStorageService.get('workstation');
            if (workstation) {
                var payload = { workstation: workstation };
                serialKitLMFactory.getWsPrinter(payload).$promise.then(function (response) {
                    $scope.record.model.printer_id = response.printer;
                    eggsFormFactory.loadLookupData($scope.record.lookup, $scope.record.model);
                });
            }
        }

        $scope.$watch('record.model.printer_id',
            function (newValue, oldValue) {
                if (newValue && newValue != oldValue) {
                    $scope.settings.disableReader = false;
                }
                else if(!newValue) {
                    $scope.settings.disableReader = true;
                }
            }
        )

        function initLookups() {
            eggsFormFactory.addLookup($scope.record.lookup, 'printer_id', 'label_printer', 'code', 'description');
        }

        function checkPermissions() {
            var profilingKey = 'DRY_CLEANING_WASHING_FUNCTION';
            var permission = authFactory.getPermissions(profilingKey);
            if (!permission.EXEC) {
                $location.path('forbidden').search({ key: profilingKey });
            }
        };

        function isNewRead(read) {
            // _ necessary because otherwise numeric barcode break the watch
            var result = ($scope.componentMap['_' + read.read]);
            return (result != undefined);
        };

        $scope.readBarcode = function (read) {
            if (isNewRead(read)) {
                toaster.pop('error', msg.error, page_msg.COMPONENT_ALREADY_READ);
            }
            else {
                recordFactory('component').filter({}, dbFilterFactory.getStringFilter('barcode', read.read)).$promise
                    .then(function (data) {
                        if (data.totalResults > 0) {
                            var c = data.list[0];
                            if(admittedStatusList.indexOf(c.status)>-1) {
                                handleComponent(c);
                            }
                            else {
                                var sString = componentService.getStatusTranslation(c.status).toUpperCase();
                                localeFactory.translateReplace(pageBundle + '.INVALID_STATUS_TRANSITION', {status: sString}).then(function(transl){
                                    toaster.pop('error', msg.error, transl);
                                })
                            }
                        }
                        else {
                            toaster.pop('error', msg.error, page_msg.COMPONENT_NOT_FOUND);
                        }
                    })
                    .catch(function () {
                        toaster.pop('error', msg.error, msg.server_comunication_error);
                    })
            }
        }

        /**
         * A new component has been read: try to change its status and print a label.
         * @param {*} c Component 
         */
        function handleComponent(c) {
            if(c.shipment_destination) {
                addComponent(c);
                changeComponentStatus(c).then(function() {
                    printComponentLabel(c);
                });
            }
            else {
                toaster.pop('error', msg.error, page_msg.MISSING_SHIPMENT_DESTINATION);
            }
        }

        function addComponent(c) {
            // _ necessary because otherwise numeric barcodes break the watch
            $scope.componentMap['_' + c.barcode] = {
                component: c,
                status: {
                    loading: true,
                    saved: false,
                    message: undefined 
                }
            };
        }

        function changeComponentStatus(c) {
            var deferred = $q.defer();
            var payload = {
                component_id: c.id,
                status: NEW_STATUS
            };
            componentFactory.changeStatus({}, payload).$promise.then(function(response) {
                console.log(response);
                var item = $scope.componentMap['_' + c.barcode];
                item.status.loading = false;
                if(response.status==='ok') {
                    item.status.saved = true;
                    item.status.message = 'OK';
                }
                else {
                    item.status.message = page_msg[result.messages[0].code];
                }
                deferred.resolve();
            },
            function(err) {
                console.error(err);
                deferred.reject();
            });
            return deferred.promise;
        }

        function printComponentLabel(c) {
            $scope.printById(c.id);
        }

        $scope.reset = function () {
            $scope.componentMap = {};
        }

        function getAdmittedStatuses() {
            workflowFactory.getComponentStatusPredecessors({ param1: NEW_STATUS }).$promise
                .then(function (data) {
                    admittedStatusList = data.result;
                    console.log("Admitted statuses: " + admittedStatusList);
                })
        }

        function init() {
            $scope.reset();
            checkPermissions();
            initLookups();
            getWorkstationPrinter();
            getAdmittedStatuses();
            localeFactory.loadTranslation('component');
            localeFactory.loadTranslation(pageBundle)
                .then(function () {
                    $q.all({
                        general: localeFactory.translateMsg(msg),
                        specific: localeFactory.translateMsg(page_msg, pageBundle)
                    });
                });
        }

        init();

    });

/**
 * Created by Rita Beltrami on 21/06/17.
 */
'use strict';

angular.module('ictportal.lm')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/six/employee/detail', {
          templateUrl: 'lm/employee/employee_detail.html',
          controller: 'EmployeeCtrl'
        })
        .when('/six/employee/detail/:id', {
          templateUrl: 'lm/employee/employee_detail.html',
          controller: 'EmployeeCtrl'
        })
  })
  .controller('EmployeeCtrl', function ($scope, $log, recordFactory, $routeParams, $location,
                                          eggsFormFactory, toaster, dbFilterFactory, 
                                          authFactory, $q, $window,  $rootScope, schemaFactory) {

    $scope.pageTitle = 'Dettaglio dipendente';
    $scope.readOnly = true;
    $scope.componentDetailLink = 'six/component/detail';
    $scope.enum = {
        sex: [
          {
            name: 'Femmina',
            value: 'F'
          },
          {
            name: 'Maschio',
            value: 'M'
          }
        ]            
    };                     
    $scope.customer = {};

    function initLookups() {
      $scope.lookup = { };
      $scope.customerLookup = {};
      for (var key in $scope.sf.schema.properties) {
        var prop = $scope.sf.schema.properties[key];
        if (prop.format === 'lookup') {
          eggsFormFactory.addLookup($scope.lookup, key, prop.entity_id, 'code', 'description');
        }
      }
      // adding custom mappings
      eggsFormFactory.addLookup($scope.customerLookup, 'customer_id', 'customer', 'code', 'description');
      $scope.mappingLoaded = true;
    };

    function initDates() {
      $scope.dateFields = [];
      $scope.sf.form[0].items[0].tabs.forEach(function (tab) {
        tab.items.forEach(function (item) {
          if (item.type === 'datepicker') {
            $scope.dateFields.push(item.key[0]);
          }
        });
      });
    };

    // L'ospedale dipende dal reparto
    $scope.$watch('lookup.destination_id.obj',
        function(newValue, oldValue) {
          if($scope.customerLookup){
            if(newValue && newValue.customer_id){
              recordFactory('customer').byId({ id: newValue.customer_id }).$promise.then(function (response) {
                $scope.customerLookup.customer_id.obj = response;
              });
            }
            else{
              $scope.customerLookup.customer_id.obj = undefined;
            }
          }
        }
    );

    $scope.backToEmployees = function(){
      $location.path('human_resource/list/employee');
    };

    function getEmployeeHistory(){
      var payload = {
        page_size: 10000,
        show_revision: false,
        sort_fields: 'operation_date',
        sort_order: 'desc'
      };
      var filters = [{
        column: 'human_resource h',
        value: 't.operator_id = h.id',
        relation: 'JOIN',
        kind: 'h.matriculation'
      },
      {
        column: 'customer_destination d',
        value: 't.destination_id = d.id',
        relation: 'JOIN',
        kind: 'd.customer_id'
      }];
      filters = filters.concat(dbFilterFactory.getNumberFilter('employee_id',$scope.element.id));
      recordFactory('employee_history').filter(payload, filters)
          .$promise.then(function(data) {
            $log.info(data);
            $rootScope.$broadcast('sixDetailGrid:dataLoaded','employee_history',data.list);
      });
    };

    function getEmployeeComponents(){
      var payload = {
        page_size: 10000
      };
      var filters = [{
        column: 'component_status cs',
        value: 't.current_component_status_id = cs.id',
        relation: 'JOIN',
        kind: 'cs.status'
      }];
      filters = filters.concat(dbFilterFactory.getNumberFilter('t.employee_id',$scope.element.id));
      recordFactory('component').filter(payload, filters)
          .$promise.then(function(data) {
            $log.info(data);
            $rootScope.$broadcast('sixDetailGrid:dataLoaded','component',data.list);
      });
    };

    function getEmployee(id) {
      recordFactory('human_resource').byId({ id: id }).$promise.then(function (response) {
        $scope.element = response;
        eggsFormFactory.convertDates($scope.element, $scope.dateFields);
        $log.info($scope.element);
        eggsFormFactory.loadLookupData($scope.lookup, $scope.element);
        $rootScope.$broadcast('sixCheckbox:reload');
        getEmployeeHistory();
        getEmployeeComponents();
      });
    };

    function init() {
      schemaFactory().getCode({ id: 'human_resource' }).$promise.then(function (data) {
        $scope.sf = data;
        initLookups();
        initDates();
        if (angular.isDefined($routeParams.id)) {
          getEmployee($routeParams.id);
        }
      });
    };

    init();

  });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:EmployeeListCtrl
 * @description
 * # EmployeeListCtrl
 * Controller of the ictportal.lm
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/human_resource/list/:discriminator', {
                templateUrl: 'lm/employee/employee_list.html',
                controller: 'EmployeeListCtrl'
            })
            .when('/human_resource/list/:discriminator/:customer', {
                templateUrl: 'lm/employee/employee_list.html',
                controller: 'EmployeeListCtrl'
            })
    })
    .filter('mapBoolean', function () {
        var genderHash = {
            1: 'Sì',
            2: 'No'
        };

        return function (input) {
            if (!input) {
                return '';
            } else {
                return genderHash[input];
            }
        };
    })
    .controller('EmployeeListCtrl', function ($scope, $routeParams, $location, toaster, $q, dbFilterFactory,
        recordFactory, schemaFactory, uiGridConstants, $log, authFactory) {
        $scope.discriminator = $routeParams.discriminator;
        $scope.schemaFound = false;
        $scope.lockCustomer = false;
        $scope.list = {};
        $scope.employeeDestinationFilter = [];
        $scope.record = {
            model: {},
            lookup: {},
            dates: []
        };
        $scope.params = {
            pageNumber: 1,
            pageSize: 15,
            code: 'human_resource',
            filters: []
        };
        $scope.viewGridOptions = { appScopeProvider: $scope };
        $scope.advFilter = {
            filter: {},
            list: []
        };

        $scope.lookup = {
            employee_id: {
                filter: dbFilterFactory.getStringFilter('discriminator', 'EMP'),
                obj: undefined,
                mapping: {
                    code: 'matriculation',
                    description: 'surname,name'
                }
            },
            customer_id: {
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            },
            destination_id: {
                filter: [],
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            },
            customer_cost_center_id: {
                filter: [],
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            },
            delivery_destination_id: {
                filter: [],
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            }
        };
        // Aggiungo eventualmente alle lookup dei join che mi servono per poi filtrare i risultati.
        $scope.lookup.employee_id.filter.push({
            "column": "customer_destination d",
            "value": "t.destination_id = d.id",
            "relation": "JOIN",
            "kind": "d.customer_id"
        });

        function getCustomer(id) {
            recordFactory('customer').byId({ id: id })
                .$promise.then(function (data) {
                    $scope.lookup.customer_id.obj = data;
                    $scope.advFilter.filter.customer_id = id;
                });
        };

        $scope.$watchGroup(['advFilter.filter.customer_id', 
                            'advFilter.filter.employee_id',
                            'advFilter.filter.destination_id',
                            'advFilter.filter.customer_cost_center_id',
                            'advFilter.filter.delivery_destination_id',], function () {
            $scope.applyFilter();
        });

        $scope.applyFilter = function () {
            $scope.advFilter.list.length = 0;
            if ($scope.advFilter.filter.customer_id) {
                var f = dbFilterFactory.getNumberFilter('customer_id', $scope.advFilter.filter.customer_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            else if($scope.employeeDestinationFilter.length>0){
                $scope.advFilter.list = $scope.advFilter.list.concat($scope.employeeDestinationFilter);
            }
            if ($scope.advFilter.filter.employee_id) {
                var f = dbFilterFactory.getNumberFilter('t.id', $scope.advFilter.filter.employee_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.destination_id) {
                var f = dbFilterFactory.getNumberFilter('destination_id', $scope.advFilter.filter.destination_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.customer_cost_center_id) {
                var f = dbFilterFactory.getNumberFilter('t.customer_cost_center_id', $scope.advFilter.filter.customer_cost_center_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.delivery_destination_id) {
                var f = dbFilterFactory.getNumberFilter('t.delivery_destination_id', $scope.advFilter.filter.delivery_destination_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }

            $log.info($scope.advFilter.list);
            $scope.getData();
        };

        function readLookups() {
            for (var key in $scope.schema.properties) {
                var prop = $scope.schema.properties[key];
                if (prop.format === 'lookup') {
                    $scope.record.lookup[key] = {
                        mapping: prop.mapping,
                        obj: {},
                        entity: prop.entity_id
                    };
                }
            }
        };

        function loadLookupCols() {
            // Raggruppo assieme i record che fanno riferimento ad una stessa entità (es. tutti quelli con customer_id=123)
            // In questo modo risolvo l'entità una volta sola per tutti.
            var lookupMap = {};
            $scope.lookupCols.forEach(function (lookup) {
                var field = lookup.field;
                lookupMap[field] = {};
                $scope.list.list.forEach(function (record) {
                    var id = record[field];
                    if (id) {
                        if(!lookupMap[field][id]){
                            lookupMap[field][id] = [];
                        }
                        lookupMap[field][id].push(record);
                    }
                });
            });
            // Recupero da DB i dati e li assegno ai rispettivi record.
            $scope.lookupCols.forEach(function (lookup) {
                for(var id in lookupMap[lookup.field]){
                    recordFactory(lookup.entity).byId({ id: id })
                        .$promise.then(function (data) {
                            data['model'] = { description: '' };
                            var tokens = lookup.mapping.description.split(',');
                            tokens.forEach(function (term) {
                                if (data[term]) {
                                    data['model'].description += data[term] + ' ';
                                }
                            });
                            data['model'].description = data['model'].description.trim();
                            lookupMap[lookup.field][data.id].forEach(function(record){
                                record[lookup.field + '_obj'] = data;
                            });
                        });
                }
            });
        };

        function readDates() {
            $scope.form[0].items[0].tabs.forEach(function (tab) {
                tab.items.forEach(function (item) {
                    if (item.type === 'datepicker') {
                        var t1 = $scope.record.dates;
                        var t2 = item.key[0];
                        $scope.record.dates.push(item.key[0]);
                    }
                });
            });
        };

        function loadDates() {
            $scope.record.dates.forEach(function (field) {
                $scope.list.list.forEach(function (record) {
                    if (record[field]) {
                        record[field] = new Date(record[field]);
                    }
                });
            });
        };

        function initGridColumns() {
            $scope.lookupCols = [];
            schemaFactory().getCode({ id: 'human_resource' }).$promise.then(
                function (data) {
                    if (data.schema) {
                        $scope.sf = data;
                        if (data.schema && data.form) {
                            $scope.schema = data.schema;
                            $scope.form = data.form;
                            readLookups();
                            readDates();
                        }
                        if (data.schema || data.form) $scope.schemaFound = true;
                        if (data.columnDefs) {
                            $scope.viewGridOptions.columnDefs = [];
                            $scope.viewGridOptions.columnDefs.push({
                                displayName: '',
                                field: 'id',
                                width: 34,
                                enableCellEdit: false,
                                enableFiltering: false,
                                enableSorting: false,
                                cellTemplate:
                                '<div class="ui-grid-cell-contents" style="text-align: center">' +
                                '<button ng-click="grid.appScope.viewDetail(row.entity)" class="btn btn-xs btn-primary">' +
                                '<span class="fa fa-search"></span>' +
                                '</button>' +
                                '</div>'
                            });
                            data.columnDefs.forEach(function (item) {
                                item.enableFiltering = getEnableFiltering(item);
                                item.filters = [{
                                    type: 'text',
                                    condition: uiGridConstants.filter.CONTAINS,
                                    placeholder: '',
                                    kind: 'string'
                                }];
                                if ($scope.record.lookup[item.field]) {
                                    var prop = data.schema.properties[item.field];
                                    item.filters = [{
                                        type: 'lookup',
                                        condition: uiGridConstants.filter.CONTAINS,
                                        placeholder: '',
                                        kind: 'string',
                                        schema: prop,
                                        join: {
                                            column: prop.entity_id,
                                            value: 't.' + prop.title + ' = ' + prop.entity_id + '.id',
                                            relation: 'JOIN',
                                            kind: ''
                                        }
                                    }];
                                    var lookup = $scope.record.lookup[item.field];
                                    lookup.field = item.field;
                                    item.field = item.field + '_obj.model.description';
                                    item.enableSorting = false;
                                    $scope.lookupCols.push(lookup);
                                }
                                else if (isDate(item.field)) {
                                    item.filters = [
                                        {
                                            type: 'date',
                                            relation: '>=',
                                            placeholder: 'da...',
                                            kind: 'date',
                                            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
                                        },
                                        {
                                            type: 'date',
                                            relation: '<=',
                                            placeholder: 'a...',
                                            kind: 'date',
                                            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
                                        }
                                    ];
                                    item.cellTemplate = '<div class="ui-grid-cell-contents">{{ row.entity.' + item.field + ' | date:\'dd/MM/yyyy\' }}</div>'
                                }
                                else if (isBoolean(item.field)) {
                                    var options = [{
                                        value: 'S',
                                        label: 'Sì'
                                    }, {
                                        value: 'N',
                                        label: 'No'
                                    }];
                                    item.filter = {
                                        type: uiGridConstants.filter.SELECT
                                    };
                                    item.editDropdownOptionsArray = options;
                                    item.filter.selectOptions = options.map(function (obj) {
                                        var rObj = { 'value': obj.value, 'label': obj.label };
                                        return rObj;
                                    });
                                    item.cellTemplate = '<div class="ui-grid-cell-contents"><span ng-if="row.entity.' + item.field + '===\'S\'" >Sì</span><span ng-if="row.entity.' + item.field + '!==\'S\'" >No</span></div>'
                                }
                                $scope.viewGridOptions.columnDefs.push(item)
                            });
                        };
                    }
                    // Default
                    else {
                        $scope.viewGridOptions.columnDefs = [];
                        $scope.viewGridOptions.columnDefs.push({
                            displayName: '',
                            field: 'id',
                            width: 34,
                            enableCellEdit: true,
                            enableFiltering: false,
                            enableSorting: false,
                            cellTemplate:
                            '<div class="ui-grid-cell-contents" style="text-align: center">' +
                            '<button ng-click="grid.appScope.viewDetail(row.entity)" class="btn btn-xs btn-primary">' +
                            '<span class="fa fa-search"></span>' +
                            '</button>' +
                            '</div>'
                        });
                        $scope.viewGridOptions.columnDefs.push({
                            displayName: capitalize($routeParams.code),
                            field: 'model.code',
                            enableFiltering: true,
                            filters: [{
                                type: 'text',
                                condition: uiGridConstants.filter.CONTAINS,
                                placeholder: '',
                                kind: 'string'
                            }]
                        });
                        $scope.viewGridOptions.columnDefs.push({
                            displayName: $routeParams.description.split(',').reduce(function (a, b) { return a + capitalize(b) + ' '; }, '').trim(),
                            field: 'model.description',
                            enableFiltering: true,
                            filters: [{
                                type: 'text',
                                condition: uiGridConstants.filter.CONTAINS,
                                placeholder: '',
                                kind: 'string'
                            }]
                        });
                    }
                }
            );
        };

        function getEnableFiltering(item) {
            /*var schemaItem = $scope.sf.schema.properties[item.field];
            var enable = !(schemaItem.enableFiltering === false);
            return enable;*/
            return false;
        };

        function isDate(field) {
            var isADate = false;
            for (var i = 0; i < $scope.form[0].items[0].tabs.length; i++) {
                var tab = $scope.form[0].items[0].tabs[i];
                var index = tab.items.findIndex(function (e) { return e.key[0] == field; });
                if (index >= 0) {
                    isADate = (tab.items[index].type === 'datepicker');
                    break;
                }
            }
            return isADate;
        };

        function isBoolean(field) {
            var isABoolean = false;
            for (var i = 0; i < $scope.form[0].items[0].tabs.length; i++) {
                var tab = $scope.form[0].items[0].tabs[i];
                var index = tab.items.findIndex(function (e) { return e.key[0] == field; });
                if (index >= 0) {
                    isABoolean = (tab.items[index].type === 'eggscheckbox');
                    break;
                }
            }
            return isABoolean;
        };

        // Per particolari entità 
        function getDiscriminatorFilters() {
            var filters = [];
            if ($scope.sf && $scope.sf.filters) {
                if ($scope.sf.filters[$scope.discriminator]) {
                    filters = $scope.sf.filters[$scope.discriminator];
                }
                else if ($scope.sf.filters.all) {
                    filters = $scope.sf.filters.all;
                }
            }
            return filters;
        };

        $scope.getData = function () {
            var payload = {
                page: $scope.params.pageNumber,
                page_size: $scope.params.pageSize,
                code: $scope.params.code,
                description: $scope.params.description,
                show_revision: false,
                sort_fields: ($scope.params.sortFields?$scope.params.sortFields:'surname'),
                sort_order: $scope.params.sortOrder
            };
            var filters = [{
                "column": "t.discriminator",
                "value": "EMP",
                "relation": "=",
                "kind": "string"
            },
            {
                "column": "customer_destination d",
                "value": "t.destination_id = d.id",
                "relation": "JOIN",
                "kind": "d.customer_id"
            }
            ];
            filters = filters.concat($scope.advFilter.list);
            recordFactory('human_resource').filter(payload, filters)
                .$promise.then(function (data) {
                    $scope.viewGridOptions.totalItems = data.totalResults;
                    $scope.list.totalResults = data.totalResults;
                    $scope.list.list = data.list;
                    if ($scope.lookupCols.length > 0) {
                        loadLookupCols();
                    }
                    if ($scope.record.dates.length > 0) {
                        loadDates();
                    }
                });
        };

        function capitalize(s) {
            return s && s[0].toUpperCase() + s.slice(1);
        };

        $scope.viewDetail = function (value) {
            if ($scope.sf.detailPath) {
                $location.path($scope.sf.detailPath + '/' + value.id);
            }
            else {
                $location.path('record/detail/' + $routeParams.type + '/' + value.id);
            }
        };

        function getCustomer(id) {
            recordFactory('customer').byId({ id: id })
                .$promise.then(function (data) {
                    $scope.lookup.customer_id.obj = data;
                    $scope.advFilter.filter.customer_id = id;
                });
        };

        // Alcuni utenti possono vedere solo certi reparti, e di conseguenza solo certi clienti (ospedali). 
        // In base alle abilitazioni utente, qui creo i filtri per limitare i risultati dei vari elementi della pagina. 
        //
        // Pesco tutte le destinazioni abilitate per l'utente (molte lookup vanno filtrate per destination_id)
        // Per ognuna delle destinazioni ottenute, guardo quali sono i diversi customer e i diversi customer_cost_center che posso abilitare all'utente
        //
        function getCustomerFilter(){
            $scope.customerFilter = []; // Filtro da applicare alla lookup sugli ospedali
            $scope.employeeDestinationFilter = []; // Filtro da applicare sulle righe della tabella per filtrare in base alla destinazione
            // Recupero l'elenco delle destinazioni possibili per l'operatore
            var authData = authFactory.getAuthData();
            var customerDestinationQuery = ''; // Query per trovare le customer_destination abilitate per il cliente. Usata per filtrare ospedali e varie lookup.
            var customerCostCenterQuery = ''; // Query da applicare alla lookup dei centri di costo
            var customerQuery = ''; // Query da applicare alla lookup sugli ospedali
            var employeeCustomerQuery = ''; // Query da applicare sulla lookup dei dipendenti
            var employeeDestinationQuery = ''; // Query da applicare sulle righe della tabella
            if(authData && authData.info && authData.info.authorizations){
                authData.info.authorizations.destinations.forEach(function(destinationId){
                    customerDestinationQuery += 'id=' + destinationId + ' OR ';
                    employeeDestinationQuery += 'destination_id=' + destinationId + ' OR ';
                });
            }
            if(customerDestinationQuery.length>0){
                $scope.lockCustomer = true; // Blocco la lookup sull'ospedale finché non ho caricato il filtro
                customerDestinationQuery = customerDestinationQuery.slice(0,-4);
                customerDestinationQuery = '(' + customerDestinationQuery + ')';
                employeeDestinationQuery = employeeDestinationQuery.slice(0,-4);
                employeeDestinationQuery = '(' + employeeDestinationQuery + ')';
                var filter = dbFilterFactory.getCustomFilter(customerDestinationQuery);
                $scope.employeeDestinationFilter = $scope.employeeDestinationFilter.concat(dbFilterFactory.getCustomFilter(employeeDestinationQuery));
                $scope.lookup.destination_id.filter = $scope.lookup.destination_id.filter.concat(dbFilterFactory.getCustomFilter(customerDestinationQuery));
                $scope.lookup.delivery_destination_id.filter = $scope.lookup.delivery_destination_id.filter.concat(dbFilterFactory.getCustomFilter(customerDestinationQuery));
                recordFactory('customer_destination').filter({page_size:10000},filter)
                    .$promise.then(function (data){
                        // Ottengo la lista dei distinti nosocomi
                        var customerIdList = [];
                        data.list.forEach(function(item){
                            if(item.customer_id && customerIdList.indexOf(item.customer_id)==-1){
                                customerIdList.push(item.customer_id);
                            }
                        });
                        // Compongo il filtro per i customer
                        customerIdList.forEach(function(customerId){
                            customerQuery += 'id=' + customerId + ' OR ';
                            employeeCustomerQuery += 'd.customer_id=' + customerId + ' OR ';
                            customerCostCenterQuery += 'customer_id=' + customerId + ' OR ';
                        })
                        if(customerQuery.length>0){
                            customerQuery = customerQuery.slice(0,-4);
                            customerQuery = '(' + customerQuery + ')';
                            employeeCustomerQuery = employeeCustomerQuery.slice(0,-4);
                            employeeCustomerQuery = '(' + employeeCustomerQuery + ')';
                            customerCostCenterQuery = customerCostCenterQuery.slice(0,-4);
                            customerCostCenterQuery = '(' + customerCostCenterQuery + ')';
                            $scope.customerFilter = $scope.customerFilter.concat(dbFilterFactory.getCustomFilter(customerQuery));
                            $scope.lookup.employee_id.filter = $scope.lookup.employee_id.filter.concat(dbFilterFactory.getCustomFilter(employeeCustomerQuery));
                            $scope.lookup.customer_cost_center_id.filter = $scope.lookup.customer_cost_center_id.filter.concat(dbFilterFactory.getCustomFilter(customerCostCenterQuery));
                        }
                        // Sblocco le lookup
                        $scope.lockCustomer = false;
                        $scope.applyFilter();
                    });
            }
        };

        function init() {
            initGridColumns();
            // Se l'utente è abilitato solo a certi ospedali, filtro tutti i dati di conseguenza.
            // Se poi ho in GET l'id di uno specifico nosocomio, filtro solo su quello e blocco la selezione di altri ospedali.
            if ($routeParams.customer) {
                $scope.lockCustomer = true;
                $scope.lookup.employee_id.filter = $scope.lookup.employee_id.filter.concat(dbFilterFactory.getNumberFilter('d.customer_id', parseInt($routeParams.customer)));
                getCustomer(parseInt($routeParams.customer));
            }
            else{
                getCustomerFilter();
            }
        };

        //___ main ___
        init();

    });
'use strict';


angular.module('ictportal.lm')
.config(function ($routeProvider) {
    $routeProvider
        .when('/endowmentplan/:id', {
            templateUrl: 'lm/endowmentplan/endowmentplan.html',
            controller: 'EndowmentplanCtrl'
        })
})
    .factory('planEndowmentFactory', function (APP_URL, $resource) {
      return $resource(APP_URL + '/rest/lm/endowmentplan/:id', {}, {
        select: {method: 'GET' /*, isArray: true*/},
        update: {method: 'POST'}
      });
    })
/**
 * @ngdoc function
 * @name ictportal.lm.EndowmentplanCtrl
 * @description
 * # EndowmentplanCtrl
 * Controller of the sixEmmaApp
 */
  .controller('EndowmentplanCtrl', function ($scope, $routeParams, $log, planEndowmentFactory) {

    $scope.times = [];


    //console.log('$routeParams.id '+$routeParams.id);

    $scope.getPreparationDetail = function (preparationSelected) {
      $scope.selected = preparationSelected;
      $scope.existingPreparation = false;
      $scope.preparationDate = new Date();
      $scope.times = [];
      if(preparationSelected != null) {
        $scope.existingPreparation = true;
        $scope.preparationDate.setHours(preparationSelected.hours);
        $scope.preparationDate.setMinutes(preparationSelected.minutes);
        $scope.selected.deliveries.forEach(function(value) {
          var appDate = new Date();
          appDate.setHours(value.hours);
          appDate.setMinutes(value.minutes);
          $scope.times.push(appDate)
        });
        $scope.calcPercentage();
      }
    };

    $scope.preparationTotal = function (preparation) {
      var totalNumber = 0;
      for(var i=0; i<preparation.deliveries.length; i++){
        totalNumber = totalNumber + preparation.deliveries[i].value;
      }
      return totalNumber;
    };

    $scope.timeToString = function (hour, minute) {
      var time ='';
      if (hour >= 10) {
        time = hour;
      } else {
        time = '0'+hour;
      }
      time = time+':';
      if (minute >= 10) {
        time = time+minute;
      } else {
        time = time+'0'+minute;
      }
      return time;
    };

    $scope.calcPercentage = function () {
      $scope.percentage = $scope.calcTotal();
      if ($scope.percentage != $scope.max) {
        $scope.type = 'warning'
      } else {
        $scope.type = 'success'
      }
    };

    $scope.calcTotal = function(){
      var totalNumber = 0;
      for(var i=0; i< $scope.selected.deliveries.length; i++){
        totalNumber = totalNumber + $scope.selected.deliveries[i].value;
      }
      return totalNumber;
    };

    $scope.deleteDelivery = function (delivery) {
      var index = $scope.selected.deliveries.indexOf(delivery);
      if (index > -1) {
        $scope.selected.deliveries.splice(index, 1);
      }
    };

    $scope.selectDay = function(day, occurrence) {
      occurrence.dow = day.value;
    };

    $scope.selectMode = function(day, preparation) {
      preparation.mode = day.value;
    };

    $scope.applyTime = function (occurrence, date) {
      occurrence.hours = date.getHours();
      occurrence.minutes = date.getMinutes()
    };

    $scope.dayName = function (dayValue) {
      var dayName= '';
      $scope.daysOfTheWeek.forEach(function(value) {
        if(value.value == dayValue) {
          dayName = value.name;
        }
      });
      return dayName;
    };

    $scope.modeName = function (modeValue) {
      var preparationName= '';
      $scope.preparationModes.forEach(function(value) {
        if(value.value == modeValue) {
          preparationName = value.name;
        }
      });
      return preparationName;
    };


    $scope.createPreparation = function () {
      $scope.selected = {
          "dow":"MONDAY",
          "hours" : 9,
          "minutes": 0,
          "mode":"DIRT_IMMED",
          "deliveries":[{
            "dow" : "MONDAY",
            "hours" : 9,
            "minutes": 0,
            "value":100
          }]
      };
      $scope.preparationDate = new Date();
      $scope.existingPreparation = false;
      var appDate = new Date();
      $scope.times.push(appDate);
      $scope.calcPercentage();
    };

    $scope.createDelivery = function () {
      var delivery = {
        "dow" : "MONDAY",
        "hours" : 0,
        "minutes": 0,
        "value" : 0
      };
      $scope.selected.deliveries.push(delivery);
      var appDate = new Date();
      delivery.hours = appDate.getHours();
      delivery.minutes = appDate.getMinutes();
      console.log("$scope.times" +$scope.times);
      $scope.times.push(appDate)
    };

    $scope.unselectRecord = function () {
      $scope.getPreparationDetail();
    };

    $scope.confirmPreparation = function () {
      if (!$scope.existingPreparation) {
        $scope.model.preparations.push($scope.selected);
      }
      $scope.unselectRecord();
    };

//Cancellazione da lista
      $scope.deletePreparationFromList = function (index) {
          $log.info('dovrei eliminare '+index);
          $scope.model.preparations.splice(index, 1);

      };

    //Cancellazione da dettaglio (nascondo, non mi piace)
    $scope.deletePreparation = function () {
      if ($scope.existingPreparation) {
        $scope.model.preparations.splice($scope.model.preparations.indexOf($scope.selected), 1);
      }
      $scope.unselectRecord();
    };

    $scope.delete = function (version){

    };

      $scope.save = function() {
          planEndowmentFactory.update({id: $routeParams.id}, $scope.model).$promise.then(function (response) {
              if (response.errors){
                  ///$scope.errorsRetrievingCounter(response.errors);
                  console.log('error '+response);
                  return;
              }
              $log.info('saved: ' + $scope.model);
              $scope.exit();
          });
      };

    $scope.exit = function(){
      window.history.back();
    };

    $scope.max=100;
    $scope.daysOfTheWeek=[
      { name:'Lunedì',
        value:'MONDAY'
      },
      { name:'Martedì',
        value:'TUESDAY'
      },
      { name:'Mercoledì',
        value:'WEDNESDAY'
      },
      { name:'Giovedì',
        value:'THURSDAY'
      },
      { name:'Venerdì',
        value:'FRIDAY'
      },
      { name:'Sabato',
        value:'SATURDAY'
      },
      { name:'Domenica',
        value:'SUNDAY'
      }
    ];

    $scope.preparationModes=[
      { name:'Sporco',
        value:'DIRT_IMMED'
      },
      { name:'Sporco posticipato',
        value:'DIRT_POST'
      },
      { name:'Riattestazione dotazione',
        value:'ENDOW_RESTORE'}
    ];

    $scope.model={};
    planEndowmentFactory.select({id: $routeParams.id}).$promise.then(function (response) {
      if (response.errors){
        ///$scope.errorsRetrievingCounter(response.errors);
        console.log('error');
        return;
      }
      $scope.model=response;
    });
/*
    $scope.model= {

      preparations: [
        {
          dow: 'MONDAY',
          hours: 9,
          minutes: 0,
          mode: 'DIRT_POST',
          deliveries: [
            {
              dow: 'MONDAY',
              hours: 9,
              minutes: 0,
              value: 33
            },
            {
              dow: 'MONDAY',
              hours: 19,
              minutes: 0,
              value: 33
            },
            {
              dow: 'TUESDAY',
              hours: 12,
              minutes: 0,
              value: 20
            },
            {
              dow: 'TUESDAY',
              hours: 15,
              minutes: 0,
              value: 1
            }
          ]
        },
        {
          dow: 'MONDAY',
          hours: 17,
          minutes: 0,
          mode: 'DIRT_IMMED',
          deliveries: [
            {
              dow: 'MONDAY',
              hours: 19,
              minutes: 0,
              value: 100
            }
          ]
        },
        {
          dow: 'TUESDAY',
          hours: 12,
          minutes: 0,
          mode: 'DIRT_IMMED',
          deliveries: [
            {
              dow: 'TUESDAY',
              hours: 19,
              minutes: 0,
              value: 100
            }
          ]
        },
        {
          dow: 'WEDNESDAY',
          hours: 15,
          minutes: 0,
          mode: 'ENDOW_RESTORE',
          deliveries: [
            {
              dow: 'WEDNESDAY',
              hours: 19,
              minutes: 0,
              value: 100
            }
          ]
        }
      ]
    };
    */
  });

'use strict';

/**
 * @ngdoc factory
 * @name ictportal.theme.abgPackerFactory
 * @description
 * # abgPackerFactory
 */
angular.module('ictportal.theme')
    .factory('abgPackerFactory', function ($resource, ABNORMAL_URL) {
        return $resource(ABNORMAL_URL + '/api/packer/api/:verb/:verb2/:id', {}, {
            getOrdersToDipatch: { method: 'POST', isArray: false, params: { verb: 'orders' } },
            getSinglePackOrders: { method: 'POST', isArray: false, params: { verb: 'single-pack-orders' } },
            getOrderDetail: { method: 'POST', isArray: false, params: { verb: 'orderdetail', id: '@id'} },
            dispatchPackOffline: { method: 'POST', isArray: true, params: { verb: 'dispatch', id: 'pack'} },
            removeOrder: {method: 'GET', isArray: false, params: { verb: 'order', verb2:'remove', id: '@id'}}
        });
    });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.componentFactory
 * @description
 * # componentFactory
 * Factory in ictportal.lm
 */
angular.module('ictportal.lm')
  .factory('componentFactory', function (SIX_URL, $resource) {
      return $resource(SIX_URL + '/rest/component/:verb/:param1/:param2/:param3', {}, {
        createComponent:    {method: 'PUT', isArray: false},
        updateComponents:   {method: 'POST', isArray: false, params: {verb: 'update', param1: 'components'}},
        massiveUpdateReorderLost:   {method: 'POST', isArray: false, params: {verb: 'massive-update', param1: 'components'}},
        updateAndReorderComponents:   {method: 'POST', isArray: false, params: {verb: 'update-reorder'}},
        printById: {method: 'POST',  isArray: false,   params: {verb: 'print', param1: '_id'}},
        printByUnicode: {method: 'POST',  isArray: false,   params: {verb: 'print', param1: '_unicode'}},
        printByBarcode: {method: 'POST',  isArray: false,   params: {verb: 'print', param1: '_barcode'}},
        changeStatus: {method: 'PUT',  isArray: false,   params: {verb: 'status', param1: '_change'}}
      });
  });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.componentUpdateFactory
 * @description
 * # rebaserFactory
 * Factory in the sixEmmaApp.
 */
angular.module('ictportal.lm')
  .factory('componentUpdateFactory', function (SIX_URL, $resource) {
      return $resource(SIX_URL + '/rest/ls/:verb/:plantCode/:status/:shipmentCode', {}, {
        update: {method: 'POST',  isArray: false,   params: {verb: 'readfeig', plantCode: '@plantCode', status: '@status'}},
        setShipment: {method: 'POST',  isArray: false,   params: {verb: 'setshipmentdestination', plantCode: '@plantCode', status: '@status', shipment: '@shipmentCode'}}
      });
  });

  /** 
   * 
   * http://localhost:8080/six/rest/ls/readfeig/33/SHPBLW
   * 
   * {
	    "reads": [{"read": "E2801160600002068E9ADDA1"}]
     }
   * 
   */

  /** 
     * 
     * http://localhost:8080/six/rest/ls/setshipmentdestination/33/SHPBLW/GRMAU
     * 
     * {
        "reads": [{"read": "E2801160600002068E9ADDA1"}]
      }
    * 
    */



'use strict';

/**
 * @ngdoc service
 * @name ictportal.dryCleaningFactory
 * @description
 * # dryCleaningFactory
 */
angular.module('ictportal.lm')
  .factory('dryCleaningFactory', function (SIX_URL, $resource) {
      return $resource(SIX_URL + '/rest/component/dry/cleaning/:verb/:id/:param1/:param2', {}, {
        createAndPrint: {method: 'POST',  isArray: false,   params: {verb: '_create'}},
        createAndPrintPatient: {method: 'POST',  isArray: false,   params: {verb: 'patient', param1: '_create'}},
        changeStatusAndProduct: {method: 'PUT',  isArray: false,   params: {verb: 'status', param1: 'product', param2: '_change'}}
      });
  });
'use strict';

/**
 * @ngdoc factory
 * @name ictportal.eggsSyncFactory
 * @description
 * # eggsSyncFactory
 */
angular.module('ictportal.lm')
  .factory('eggsSyncFactory', function (SIX_URL, $resource) {
      return $resource(SIX_URL + '/rest/eggs-sync/:verb/:id/:param1/:param2', {}, {
        syncEntities: {method: 'POST',  isArray: false,   params: {verb: 'entities'}}
      });
  });
'use strict';

/**
 * @ngdoc service
 * @name ictportal.employeeFactory
 * @description
 * # employeeFactory
 * Factory in ictportal.lm
 */
angular.module('ictportal.lm')
  .factory('employeeFactory', function (SIX_URL, $resource) {
      return $resource(SIX_URL + '/rest/employee/:verb/:param1/:param2/:param3', {}, {
        updateOrCreateEmployee:         {method: 'PUT', isArray: false},
        coupleComponent:                {method: 'POST', isArray: false, params: {verb: 'component', param1: 'couple'}},
        decoupleComponent:              {method: 'POST', isArray: false, params: {verb: 'component', param1: 'decouple'}},
        updateEndowmentBestMatch:       {method: 'POST', isArray: false, params: {verb: 'endowment', param1: 'best-match'}},
        loadEndowment:                  {method: 'POST', isArray: false, params: {verb: 'load', param1: 'endowment'}},
      });
  });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.packFactory
 * @description
 * # packFactory
 * Factory in ictportal.lm
 */
angular.module('ictportal.lm')
  .factory('packFactory', function (SIX_URL, $resource) {
      return $resource(SIX_URL + '/rest/pack/:verb/:param1/:param2/:param3', {}, {
        packSingleComponent:          {method: 'POST', isArray: false, params: {verb: 'single', param1: 'component'}}
      });
  });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.patientFactory
 * @description
 * # patientFactory
 * Factory in ictportal.lm
 */
angular.module('ictportal.lm')
  .factory('patientFactory', function (SIX_URL, $resource) {
      return $resource(SIX_URL + '/rest/patient/:verb/:param1/:param2/:param3', {}, {
        updateOrCreatePatient:  {method: 'PUT', isArray: false},
        deletePatient:          {method: 'POST', isArray: false, params: {verb: 'delete'}},
        coupleComponent:        {method: 'POST', isArray: false, params: {verb: 'component', param1: 'couple'}},
        decoupleComponent:      {method: 'POST', isArray: false, params: {verb: 'component', param1: 'decouple'}},
        acceptPatientDirt:      {method: 'POST', isArray: false, params: {verb: 'dirt', param1: 'accept'}}
      });
  });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.rebaserFactory
 * @description
 * # rebaserFactory
 * Factory in the sixEmmaApp.
 */
angular.module('ictportal.lm')
  .factory('rebaserFactory', function (SIX_URL, $resource) {
      return $resource(SIX_URL + '/rest/rebaser/:verb/:id', {}, {
        update: {method: 'POST',  isArray: false,   params: {verb: 'setrawdata', id: '@id'}},
        returnMissingItem: {method: 'POST',  isArray: false,   params: {verb: 'missingitem'}},
        returnPatientMissingItem: {method: 'POST',  isArray: false,   params: {verb: 'patientmissingitem'}}
      });
  });
'use strict';

/**
 * @ngdoc service
 * @name ictportal.serialKitLMFactory
 * @description
 * # serialKitLMFactory
 * Factory in the sixEmmaApp.
 */
angular.module('ictportal.lm')
  .factory('serialKitLMFactory', function (SIX_URL, $resource) {
      return $resource(SIX_URL + '/rest/serialkitlm/:verb/:id/:param1/:param2/:param3', {}, {
        packaging:            {method: 'POST', isArray: false, params: {verb: 'packaging'}},
        printing:             {method: 'POST', isArray: false, params: {verb: 'print_kit_label'}},
        getWsPrinter:         {method: 'POST', isArray: false, params: {verb: 'get_ws_printer'}},
        printCartBarcode:     {method: 'POST', isArray: false, params: {verb: 'print_cart_barcode'}},
        printSetLabel:        {method: 'POST', isArray: false, params: {verb: 'print_set_label'}},
        getCartBarcode:       {method: 'POST', isArray: false, params: {verb: 'get_cart_barcode'}},
        getSetBarcode:        {method: 'POST', isArray: false, params: {verb: 'get_set_barcode'}},
        setMotherEnvelope:    {method: 'POST', isArray: false, params: {verb: 'mother_envelope', param1: 'set'}},
        clearMotherEnvelope:  {method: 'POST', isArray: false, params: {verb: 'mother_envelope', param1: 'clear'}},
        setParentBom:         {method: 'POST', isArray: false, params: {verb: 'parent_bom', param1: 'set'}},
      });
  });

'use strict';

/**
 * @ngdoc factory
 * @name ictportal.theme.wardToDestConfFactory
 * @description
 */
angular.module('ictportal.lm')
  .factory('wardToDestConfFactory', function ($resource, SIX_URL) {
    return $resource(SIX_URL + '/rest/wardtodest/conf/:verb/:id/:param1/:param2/:param3', {}, {
        getRows:              {method: 'POST', isArray: false, params: {verb: 'rows', param1:'_get'}},
    });
  });

'use strict';

/**
 * @ngdoc factory
 * @name ictportal.theme.wardToDestPianaFactory
 * @description
 * @author Rita Beltrami
 * 
 * 21/05/2019
 * 
 */
angular.module('ictportal.lm')
  .factory('wardToDestPianaFactory', function ($resource, SIX_URL) {
    return $resource(SIX_URL + '/rest/wardtodest/piana/:verb/:id/:param1/:param2/:param3', {}, {
        getRows:              {method: 'POST', isArray: false, params: {verb: 'rows', param1:'_get'}},
        getDirtyAmount:       {method: 'PUT', isArray: false, params: {verb: '_dirty'}},
        getDirtyAmountJob:    {method: 'POST', isArray: false, params: {verb: '_dirty'}},
        validateComponent:    {method: 'POST', isArray: false, params: {verb: 'validate', param1:'_component'}},
        validatePack:         {method: 'POST', isArray: false, params: {verb: 'validate', param1:'_pack'}}
    });
  });

'use strict';

/**
 * @ngdoc factory
 * @name ictportal.theme.zucchettiFactory
 * @description
 * # zucchettiFactory
 */
angular.module('ictportal.theme')
  .factory('zucchettiFactory', function ($resource, ABNORMAL_URL) {
    return function() {
      return $resource(ABNORMAL_URL + '/api/zucchetti/:type/:verb', {}, {
        getLockerStock:    {method: 'GET',  isArray: false,   params: {type: 'locker', verb: '_stock'}}
      });
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:guestsRebaserCtrl
 * @description
 * # guestsRebaserCtrl
 * Controller of the ictportal.lm
 *
 *
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/rebaser/guests/:id', {
                templateUrl: 'lm/guestsRebaser/guestsrebaser.html',
                controller: 'guestsRebaserCtrl'
            })
    })
    .filter('reverse', function() {
        return function(items) {
          return items.slice().reverse();
        };
      })
    .controller('guestsRebaserCtrl', function ($scope, toaster, COMPONENT_READ_MODE, dbFilterFactory, recordFactory, $rootScope, $timeout, rebaserFactory, componentUpdateFactory, $routeParams, $uibModal) {

            $scope.compReaderMode = COMPONENT_READ_MODE.CODE; // modalità di lettura dei componenti: sia barcode, che unicode

            /***** look up *****/

            $scope.wardrobe = { list: []};  // lista dei guardaroba selezionabili
            $scope.ward = { list: []};  // lista dei reparti selezionabili
            $scope.employee = { list: []};  // lista dei dipendenti selezionabili
            $scope.productCategory = { list: []}; // lista dei nuclei (inizialmente tutti, poi devo filtrare quelli selezionabili)

            /***** elementi selezionati *****/

            $scope.selected = {};           // elementi selezionati sulla pagina html
            $scope.element = undefined;     // ricompositore scaricato

            /***** stato ricompositore *****/

            $scope.matrixData = {};         // ricompositore
            $scope.matrixWardrobe = {};     // guardaroba di destinazione
            $scope.matrixStructure = {};    // struttura del ricompositore: criteri delle celle...
                                            // se una cella è di un dipendente o contiene componenti di articolo/taglia

            /***** modalità di gestione *****/

            $scope.type = 'TABLE';      // tipo visualizzazione
            $scope.mode = {value: 'INSERT'};     // alla lettura del componente dice se eliminare o aggiungere
            $scope.load = true;         // modalità carico/scarico
            $scope.unloadGarment = { type: 'INDIVIDUAL'};

            /***** variabili di appoggio *****/

            $scope.codeList = [];       // lista componenti aggiunti in questa sessione (ha effettivamente senso?)
            $scope.lastInsertedCell = undefined; // ultima cella popolata
            $scope.alreadyInsertedCell = undefined; // ultima cella già caricata
            $scope.lastReadCodes = [];  // buffer per visualizzare gli ultimi componenti letti (per il frontend)

            /***** variabili per lo scarico del ricompositore *****/

            $scope.unloadMap = undefined;
            $scope.unloadList = undefined;
            $scope.unloadKey = undefined;
            $scope.componentShippableStatus = 'SHPBLW';

            /***** variabili per la parte di "COMPONENTI MANCANTI" *****/

            $scope.missingComponents = {
                employeeList: []
            };



            /***** TODO: parte da mettere a posto *****/

            $scope.infoCell = {
                e_name: undefined,
                e_surname: undefined,
                e_matr: undefined,
                cde_id: undefined,
                cde_cd: undefined,
                cde_de: undefined,
                cd_id: undefined,
                cd_cd: undefined,
                cd_de: undefined,
                p_cd: undefined,
                p_de: undefined,
                sz_cd: undefined,
                sz_de: undefined,
                content: undefined
            };


            function enrichCellContent (cell) {
                $scope.infoCell.content = undefined;
                if(cell){
                    $scope.infoCell.content = {
                        full: cell.full,
                        sz: cell.sz,
                        comp: []
                    };
                    for(var i = 0; i < cell.comp.length; i++){
                        var filters = [{
                                "column": "product p",
                                "value": "t.product_id = p.id",
                                "relation": "JOIN",
                                "kind": "p.description as product_description, p.code as product_code"
                            }, {
                                "column": "tab_size ts",
                                "value": "t.size_id = ts.id",
                                "relation": "JOIN",
                                "kind": "ts.code as size_code, ts.description as size_description"
                            }
                        ];
                        filters = filters.concat(dbFilterFactory.getCustomFilter('(t.unicode=\'' + cell.comp[i] + '\' OR t.barcode=\'' + cell.comp[i] + '\')'));
                        recordFactory('component').filter({page_size:1}, filters).$promise.then(function(data) {
                            if(data && data.list[0]){
                                $scope.infoCell.content.comp.push(data.list[0]);
                            }
                        });
                    }
                }
            };


            $scope.getInfoFromCell = function (r, cell) {
                var key = findKeyFromCell (r,cell);
                $scope.infoCell = {};
                enrichCellContent(cell);
                if(key){
                    var ids = key.split("#");
                    if(ids.length == 1){ // componente personalizzato
                        // compilo il dipendente

                        var filters = [
                            {
                                "column": "customer_destination cd", // reparto del paziente
                                "value": "t.destination_id = cd.id",
                                "relation": "JOIN",
                                "kind": "cd.description as customer_destination_emp_description, cd.code as customer_destination_emp_code, cd.id as customer_destination_emp_id"
                            },
                            {
                                "column": "customer_destination del",   // punto di consegna del paziente
                                "value": "t.delivery_destination_id = del.id",
                                "relation": "JOIN",
                                "kind": "del.code as delivery_code, del.description as delivery_description, del.id as delivery_id"
                            },
                            {
                                "column": "product_category pc",   // nucleo
                                "value": "cd.prod_category_id = pc.id",
                                "relation": "JOIN",
                                "kind": "pc.code as prod_category_code, pc.description as prod_category_description, pc.id as prod_category_id"
                            },
                            {
                                "column": "customer_destination wardrobe",   // guardaroba legato al reparto del paziente
                                "value": "cd.parent = wardrobe.id",
                                "relation": "JOIN",
                                "kind": "wardrobe.code as wardrobe_emp_code, wardrobe.description as wardrobe_emp_description, wardrobe.id as wardrobe_emp_id"
                            },
                            {
                                "column": "customer ce",    // cliente del paziente
                                "value": "cd.customer_id = ce.id",
                                "relation": "JOIN",
                                "kind": "ce.code as customer_code, ce.description as customer_description, ce.id as customer_id"
                            }
                        ];
                        filters = filters.concat(dbFilterFactory.getCustomFilter('(t.id = ' + ids[0] + ')'));
                        recordFactory('human_resource').filter({page_size:10}, filters).$promise.then(function(data) {
                            if(data && data.list && data.list[0]){
                                $scope.infoCell.e_name = data.list[0].name;
                                $scope.infoCell.e_surname = data.list[0].surname;
                                $scope.infoCell.e_matr = data.list[0].matriculation;
                                // reparto paziente
                                $scope.infoCell.cde_id = data.list[0].customer_destination_emp_id;
                                $scope.infoCell.cde_cd = data.list[0].customer_destination_emp_code;
                                $scope.infoCell.cde_de = data.list[0].customer_destination_emp_description;
                                // nucleo paziente
                                $scope.infoCell.product_cat_id = data.list[0].prod_category_id;
                                $scope.infoCell.product_cat_cd = data.list[0].prod_category_code;
                                $scope.infoCell.product_cat_de = data.list[0].prod_category_description;
                                // punto di consegna paziente
                                $scope.infoCell.delivery_id = data.list[0].delivery_id;
                                $scope.infoCell.delivery_cd = data.list[0].delivery_code;
                                $scope.infoCell.delivery_de = data.list[0].delivery_description;
                            }
                        });
                    } else if (ids.length == 3) { // componente non personalizzato
                        // compilo la destinazione cliente, l'articolo e la taglia
                        var filter = dbFilterFactory.getCustomFilter('(id=' + ids[0] + ')');
                        recordFactory('customer_destination').filter({page_size:10}, filter).$promise.then(function(data) {
                            if(data && data.list && data.list[0]){
                                $scope.infoCell.cd_id = data.list[0].id;
                                $scope.infoCell.cd_cd = data.list[0].code;
                                $scope.infoCell.cd_de = data.list[0].description;
                            }
                        });
                        var filter = dbFilterFactory.getCustomFilter('(id=' + ids[1] + ')');
                        recordFactory('product').filter({page_size:10}, filter).$promise.then(function(data) {
                            if(data && data.list && data.list[0]){
                                $scope.infoCell.p_cd = data.list[0].code;
                                $scope.infoCell.p_de = data.list[0].description;
                            }
                        });
                        if(ids[2] != '*'){  // compilo la taglia
                            var filter = dbFilterFactory.getCustomFilter('(id=' + ids[2] + ')');
                            recordFactory('tab_size').filter({page_size:10}, filter).$promise.then(function(data) {
                                if(data && data.list && data.list[0]){
                                    $scope.infoCell.sz_cd = data.list[0].code;
                                    $scope.infoCell.sz_de = data.list[0].description;
                                }
                            });
                        } else {
                            $scope.infoCell.sz_cd = '*';
                            $scope.infoCell.sz_de = 'Varie taglie presenti contemporaneamente';
                        }
                    }
                }
            };

            /***** fine parte da mettere a posto *****/


            /***** scarico *****/

            function compare(a, b) {
                var codeA = a.delivery_cd.toUpperCase();
                var codeB = b.delivery_cd.toUpperCase();

                var comparison = 0;
                if (codeA > codeB) {
                    comparison = 1;
                } else if (codeA < codeB) {
                    comparison = -1;
                }
                return comparison;
            };

            // scarico della personalizzata
            $scope.$watch('selected.productCategory', function(newV, oldV) {
                if(newV != oldV && newV) {
                    delete $scope.selected.ward;
                    delete $scope.selected.employee;
                    $scope.unloadMap = undefined;
                    $scope.unloadList = undefined;
                    $scope.unloadKey = undefined;
                    var listOrdered = [];
                    var exit = 0;
                    for (var item in $scope.matrixStructure) {
                        listOrdered.push($scope.matrixStructure[item].data);
                    }

                    /** ********************* */
                    listOrdered.sort(compare);
                    /** ********************* */

                    for (var item in listOrdered){
                        if(listOrdered[item].product_cat_id && !exit){
                            if(listOrdered[item].product_cat_id.toString() == newV.product_cat_id.toString()){
                                // ciclo sulla matrixStructure
                                for (var row in $scope.matrixStructure) {
                                    if($scope.matrixStructure[row].data == listOrdered[item]){
                                        if(!$scope.unloadMap){
                                            $scope.unloadMap = {};
                                        }
                                        // lista di celle con un criterio che posso scaricare
                                        $scope.unloadMap[row] = $scope.matrixStructure[row].list;
                                        exit = 1;
                                    }
                                }
                            }
                        }

                    }
                    /** PARTE AL MOMENTO SOSTITUITA ....
                    // devo ottenere tutte le celle di pazienti il cui nucleo è uguale a quello selezionato
                    for (var row in $scope.matrixStructure) {
                        if($scope.matrixStructure[row].data && $scope.matrixStructure[row].data.product_cat_id
                            && $scope.matrixStructure[row].data.product_cat_id.toString() == newV.product_cat_id.toString()){
                                if(!$scope.unloadMap){
                                    $scope.unloadMap = {};
                                }
                                // lista di celle con un criterio che posso scaricare
                                $scope.unloadMap[row] = $scope.matrixStructure[row].list;
                        }
                    }
                    */
                    if($scope.unloadMap){ // se ci sono celle da scaricare, le carico in memoria...
                        for(var row in $scope.unloadMap){
                            if(!$scope.unloadList){
                                $scope.unloadList = [];
                                $scope.unloadList = $scope.matrixStructure[row].list;
                                $scope.unloadKey = row;
                            }
                        }
                    } else {
                        console.log('non ci sono celle disponibili per il criterio selezionato');
                    }
                }
            });

            // scarico della personalizzata
            $scope.$watch('selected.ward', function(newV, oldV) {
                if(newV != oldV && newV) {
                    delete $scope.selected.employee;
                    $scope.unloadMap = undefined;
                    $scope.unloadList = undefined;
                    $scope.unloadKey = undefined;
                    // devo ottenere tutte le celle di dipendente il cui reparto è uguale a quello selezionato
                    for (var row in $scope.matrixStructure) {
                        if($scope.matrixStructure[row].data && $scope.matrixStructure[row].data.cde_id
                            && $scope.matrixStructure[row].data.cde_id.toString() == newV.cd_id.toString()){
                                if(!$scope.unloadMap){
                                    $scope.unloadMap = {};
                                }
                                // lista di celle con un criterio che posso scaricare
                                $scope.unloadMap[row] = $scope.matrixStructure[row].list;
                        }
                    }
                    if($scope.unloadMap){ // se ci sono celle da scaricare, le carico in memoria...
                        for(var row in $scope.unloadMap){
                            if(!$scope.unloadList){
                                $scope.unloadList = [];
                                $scope.unloadList = $scope.matrixStructure[row].list;
                                $scope.unloadKey = row;
                            }
                        }
                    } else {
                        console.log('non ci sono celle disponibili per il criterio selezionato');
                    }
                }
            });


            // scarico della personalizzata
            $scope.$watch('selected.employee', function(newV, oldV) {
                if(newV != oldV && newV) {
                    $scope.unloadMap = undefined;
                    $scope.unloadList = undefined;
                    $scope.unloadKey = undefined;
                    // devo ottenere tutte le celle il cui dipedente è uguale a quello selezionato
                    for (var row in $scope.matrixStructure) {
                        if($scope.matrixStructure[row].data && $scope.matrixStructure[row].data.e_id
                            && $scope.matrixStructure[row].data.e_id.toString() == newV.id.toString()){
                                if(!$scope.unloadMap){
                                    $scope.unloadMap = {};
                                }
                                // lista di celle con un criterio che posso scaricare
                                $scope.unloadMap[row] = $scope.matrixStructure[row].list;
                        }
                    }
                    if($scope.unloadMap){ // se ci sono celle da scaricare, le carico in memoria...
                        for(var row in $scope.unloadMap){
                            if(!$scope.unloadList){
                                $scope.unloadList = [];
                                $scope.unloadList = $scope.matrixStructure[row].list;
                                $scope.unloadKey = row;
                            }
                        }
                    } else {
                        console.log('non ci sono celle disponibili per il criterio selezionato');
                    }
                }
            });


            // scarico della NON personalizzata
            $scope.$watch('selected.wardrobe', function(newV, oldV) {
                if(newV != oldV && newV) {
                    $scope.unloadMap = undefined;
                    $scope.unloadList = undefined;
                    $scope.unloadKey = undefined;

                    $scope.matrixWardrobe = $scope.selected.wardrobe;
                    // devo trovare tutte le celle che contengono non personalizzata con questo guardaroba impostato
                    for (var row in $scope.matrixStructure) {
                        var n = row.indexOf(newV.UUID.toString());
                        if(n > -1){
                            if(!$scope.unloadMap){
                                $scope.unloadMap = {};
                            }
                            // lista di celle con un criterio che posso scaricare
                            $scope.unloadMap[row] = $scope.matrixStructure[row].list;
                        }
                    }
                    if($scope.unloadMap){ // se ci sono celle da scaricare, le carico in memoria...
                        for(var row in $scope.unloadMap){
                            if(!$scope.unloadList){
                                $scope.unloadList = [];
                                $scope.unloadList = $scope.matrixStructure[row].list;
                                $scope.unloadKey = row;
                            }
                        }
                    } else {
                        console.log('non ci sono celle disponibili per il criterio selezionato');
                    }
                }
            });


            $scope.$watch('unloadGarment.type', function(newV, oldV) {
                if(newV != oldV) {
                    delete $scope.selected.wardrobe;
                    delete $scope.selected.ward;
                    delete $scope.selected.employee;
                    delete $scope.selected.productCategory;
                    $scope.unloadMap = undefined;
                    $scope.unloadList = undefined;
                    $scope.unloadKey = undefined;
                }
            });


            // Lettura di un componente in fase di scarico
            $scope.readUnloadComponent = function (read) {
                var filters = buildComponentFilter(read);
                recordFactory('component').filter({page_size:10}, filters).$promise.then(function(data) {
                    if(data.list && data.list.length > 0){
                        var comp = data.list[0];

                        var found = false;
                        // devo cercare il componente nel seguente array di celle: unloadList = [{r: 'a', c: 0}]
                        // inizializzato prima quando sono stati impostati i filtri di ricerca
                        for(var i = 0; i < $scope.unloadList.length; i++){
                            var r = $scope.unloadList[i].r;
                            var c = $scope.unloadList[i].c;
                            if($scope.matrixData[r] && $scope.matrixData[r][c] && $scope.matrixData[r][c].comp) {
                                $scope.matrixData[r][c].comp.forEach( function (iterator){
                                    if(iterator == comp.barcode){
                                        found = true;
                                    }
                                });
                            }
                        }
                        if(!found){
                            // se non c'è in quell'array allora non può essere scaricato
                            toaster.pop('error', 'Componente non scaricabile', 'Il componente non è presente sulla riga che si sta scaricando.');
                        } else {
                            // componente da eliminare dal ricompositore (true: perchè devo metterlo in stato spedibile)
                            componentFoundToDelete(comp, true, true);
                            //devo tenere aggiornate anche $scope.unloadMap e $scope.unloadList
                            if($scope.unloadList.length == 0){
                                delete $scope.unloadMap[$scope.unloadKey]; // ho scaricato tutto -> quindi elimino
                                $scope.unloadList = undefined;
                                $scope.unloadKey = undefined;
                                // se ci sono altre celle scaricabili le carico
                                for(var row in $scope.unloadMap){
                                    if(!$scope.unloadList){
                                        $scope.unloadList = [];
                                        $scope.unloadList = $scope.matrixStructure[row].list;
                                        $scope.unloadKey = row;
                                    }
                                }
                            }
                        }
                    } else {
                        // componente non trovato
                        toaster.pop('error', 'Componente non trovato', 'Verificare anagrafica');
                        $scope.unloadComponent = undefined;
                    }
                });
            };


            /***** carico *****/


            // ritorna una cella ESISTENTE CON SPAZIO per contenere componenti
            function findFreeCell(key) {
                var ret = undefined;
                var cellList = undefined;
                if($scope.matrixStructure[key] && $scope.matrixStructure[key].list){
                    cellList = $scope.matrixStructure[key].list;
                }
                if(cellList){
                    cellList.forEach( function (cell){
                        // cell ha proprietà r: "a" (riga), c: 0 (colonna)
                        if($scope.matrixData[cell.r]
                            && $scope.matrixData[cell.r][cell.c]
                            && !$scope.matrixData[cell.r][cell.c].full
                            && $scope.matrixData[cell.r][cell.c].sz > $scope.matrixData[cell.r][cell.c].comp.length){
                                ret = cell;
                        }
                    });
                }
                return ret;
            };



            // dato il componente ritorna la cella nella quale è contenuto
            function findCellFromComponent (component) {
                var cell = undefined;
                for(var j in $scope.matrixData){
                    for(var i = 0; i < $scope.matrixData[j].length; i++){
                        for(var c = 0; c < $scope.matrixData[j][i].comp.length; c++){
                            if(component == $scope.matrixData[j][i].comp[c]) {
                                cell = {
                                    r: j,
                                    c: i
                                };
                            }
                        }
                    }
                }
                return cell;
            }



            // cerca la cella date le coordinate
            function findCellFromCoordinates (r,c) {
                var cell = undefined;
                if($scope.matrixData && $scope.matrixData[r][c]){
                    cell = $scope.matrixData[r][c];
                }
                return cell;
            }



            // dato un array di celle ed il componente ritorna la chiave
            function findKeyFromCell (r,c) {
                var cell = undefined;
                var key = undefined;
                if(c.comp[0]) {
                    cell = findCellFromComponent(c.comp[0]);
                }
                if(cell){
                    for (var row in $scope.matrixStructure) {
                        for (var i = 0; i < $scope.matrixStructure[row].list.length; i++) {
                            if($scope.matrixStructure[row].list[i].r == cell.r && $scope.matrixStructure[row].list[i].c == cell.c){
                                key = row;
                            }
                        }
                    }
                }
                return key;
            }



            // dalle coordinate comunica se la cella è utilizzata o meno
            function isUsedCell(coord){ // coord -> r: "a" (riga), c: 0 (colonna)
                for (var row in $scope.matrixStructure) {
                    for (var i = 0; i < $scope.matrixStructure[row].list.length; i++) {
                        if($scope.matrixStructure[row].list[i].r == coord.r && $scope.matrixStructure[row].list[i].c == coord.c){
                            return true;
                        }
                    }
                }
                return false;
            }



            // ritorna prima cella LIBERA (vuota, non utilizzata da nessuno) del ricompositore
            function createCell() {
                var ret = undefined;
                for(var j = 0; j < $scope.element.column_number; j++){
                    for(var k in $scope.matrixData) {
                        ret = {r: k, c: j}
                        if(!isUsedCell(ret)){
                            return ret;
                        }
                    }
                }
                return undefined;
            };



            // costruisce la chiave per cercare le celle
            function buildKeyCell(component) {
                var key = undefined;
                if(component){
                    if(component.special_use == 'INDIVIDUAL' && component.employee_id){
                        key = component.employee_id.toString();
                    } else {
                        key =
                            (component.shipment_destination != null? component.shipment_destination.toString() : '*')
                            + '#' + component.product_id.toString()
                            + '#' + (component.size_id != null? component.size_id.toString() : '*');
                    }
                }
                return key;
            };



            // controlla se il componente è già stato aggiunto in questa sessione
            // in modo da velocizza il processamento
            function getIndexFromId(id) {
                var i;
                var found = false;
                for (i = 0; i < $scope.codeList.length; i++) {
                    if ($scope.codeList[i] === id) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    i = -1;
                }
                return i;
            };



            /*
            *   ritorna TRUE se è possibile aggiungere il componente al ricompositore
            *  - un componente personalizzato può essere aggiunto se:
            *   il cliente sul reparto del paziente corrisponde al cliente del guardaroba selezionato
            *  - un componente NON personalizzato ad un paziente NON può essere aggiunto
            */
           function checkComponent(component) {
                if(component){
                    // personalizzato ad un paziente...
                    if(component.special_use == 'INDIVIDUAL' && component.employee_id){
                        if($scope.selected.wardrobe.customer_id == component.customer_id){
                            return true;
                        } else {
                            toaster.pop('error', 'Componente pers. non associabile', 'Il cliente dell ospite è differente dal cliente del guardaroba selezionato');
                            return false;
                        }
                    } else {
                        // non personalizzato...
                        toaster.pop('error', 'Componente non associato ad un ospite', 'Componente non leggibile sul ricompositore ospiti perchè non personalizzato');
                        return false;

                    }
                }
                return false;
            };



            // mostro l'errore
            function componentNotFound () {
                toaster.pop('error', 'Componente non trovato', 'Verificare anagrafica');
            }



            // filtro per ottenere il componente e tutte le informazioni necessarie
            function buildComponentFilter (read) {
                var filters = [{
                        "column": "product p",  // articolo del componente
                        "value": "t.product_id = p.id",
                        "relation": "JOIN",
                        "kind": "p.description as product_description, p.code as product_code"
                    },
                    {
                        "column": "tab_size ts",    // taglia del componente
                        "value": "t.size_id = ts.id",
                        "relation": "JOIN",
                        "kind": "ts.code as size_code, ts.description as size_description"
                    },
                    {
                        "column": "human_resource hr",  // paziente associato al componente (se personalizzato)
                        "value": "t.patient_id = hr.id",
                        "relation": "JOIN",
                        "kind": "hr.matriculation as employee_matriculation, hr.name as employee_name, hr.surname as employee_surname, hr.id as employee_id"
                    },
                    {
                        "column": "customer_destination cde",   // reparto del paziente
                        "value": "hr.destination_id = cde.id",
                        "relation": "JOIN",
                        "kind": "cde.code as customer_destination_emp_code, cde.description as customer_destination_emp_description, cde.id as customer_destination_emp_id"
                    },
                    {
                        "column": "customer_destination del",   // punto di consegna del paziente
                        "value": "hr.delivery_destination_id = del.id",
                        "relation": "JOIN",
                        "kind": "del.code as delivery_code, del.description as delivery_description, del.id as delivery_id"
                    },
                    {
                        "column": "product_category pc",   // nucleo
                        "value": "cde.prod_category_id = pc.id",
                        "relation": "JOIN",
                        "kind": "pc.code as prod_category_code, pc.description as prod_category_description, pc.id as prod_category_id"
                    },
                    {
                        "column": "customer_destination wardrobe",   // guardaroba legato al reparto del paziente
                        "value": "cde.parent = wardrobe.id",
                        "relation": "JOIN",
                        "kind": "wardrobe.code as wardrobe_emp_code, wardrobe.description as wardrobe_emp_description, wardrobe.id as wardrobe_emp_id"
                    },
                    {
                        "column": "customer ce",    // cliente del paziente
                        "value": "cde.customer_id = ce.id",
                        "relation": "JOIN",
                        "kind": "ce.code as customer_code, ce.description as customer_description, ce.id as customer_id"
                    },
                    {
                        "column": "customer_destination cds",   // destinazione di spedizione del componente
                        "value": "t.shipment_destination = cds.id",
                        "relation": "JOIN",
                        "kind": "cds.code as customer_destination_code, cds.description as customer_destination_description, cds.id as customer_destination_id"
                    }
                ];
                filters = filters.concat(dbFilterFactory.getCustomFilter('(t.unicode=\'' + read.read + '\' OR t.barcode=\'' + read.read + '\')'));
                return filters;
            }



            // eliminazione del componente dalla matrice, viene controllata
            // se deve essere pulita anche la struttura di appoggio dove mi segno le celle
            // -> isShippableComponent TRUE: il componente quando viene scaricato e quindi eliminato
            // dalla matrice viene portato in stato spedibile guardaroba
            function componentFoundToDelete (c, isShippableComponent, isPossibleToSetFreeCell) {
                var comp = c;
                // elimino dall'array dei letti
                var index = getIndexFromId(comp.id);
                if(index > -1){
                    $scope.codeList.splice(index, 1);
                }
                // svuoto dove salvo l'ultimo comp. inserito
                $scope.lastInsertedCell = undefined;
                $scope.alreadyInsertedCell = undefined;
                // costruisco la chiave
                var key = buildKeyCell(comp);
                // data la chiave cerco le celle
                var cellList = undefined;
                if($scope.matrixStructure[key] && $scope.matrixStructure[key].list){
                    cellList = $scope.matrixStructure[key].list;
                }
                var cellToClear = undefined;
                // cerco e tolgo il componente dalla cella
                if(cellList){
                    cellList.forEach( function (cell){
                        if($scope.matrixData[cell.r] && $scope.matrixData[cell.r][cell.c]){
                            for (var i = 0; i < $scope.matrixData[cell.r][cell.c].comp.length; i++) {
                                if ($scope.matrixData[cell.r][cell.c].comp[i] == comp.barcode) {
                                    $scope.matrixData[cell.r][cell.c].comp.splice(i, 1);
                                    // se il num. di componenti < size: la cella è potenzialmente libera
                                    //TODO: come gestire il caso in cui è l'operatore ad identificare la cella come vuota
                                    if($scope.matrixData[cell.r][cell.c].comp.length < $scope.matrixData[cell.r][cell.c].sz && isPossibleToSetFreeCell){
                                        $scope.matrixData[cell.r][cell.c].full = 0;
                                    }
                                    // se la lunghezza = 0 -> mi segno la cella da liberare
                                    if($scope.matrixData[cell.r][cell.c].comp.length == 0){
                                        cellToClear = {r: cell.r, c: cell.c}
                                    }
                                }
                            }
                        }
                    });
                    // se necessario devo eliminare la cella dalla struttura (se vuota)
                    if(cellToClear){
                        var del = false;
                        // variabile 'delete' che mi dice se eliminare o meno la voce dalla struttura
                        for (var i = 0; i < $scope.matrixStructure[key].list.length; i++) {
                            if ($scope.matrixStructure[key].list[i].r == cellToClear.r && $scope.matrixStructure[key].list[i].c == cellToClear.c) {
                                $scope.matrixStructure[key].list.splice(i, 1);
                                if($scope.matrixStructure[key].list.length == 0){
                                    del = true;
                                }
                            }
                        }
                        if(del){
                            delete $scope.matrixStructure[key];
                            // devo eliminare o il reparto o il dipendente

                            if(comp.special_use == 'INDIVIDUAL') {
                                // provo ad eliminare il dipendente
                                var employeeIndex = -1;
                                var employeeFound = false;
                                for (var i = 0; i < $scope.employee.list.length; i++) {
                                    if($scope.employee.list[i].id.toString() == key){
                                        employeeIndex = i;
                                        employeeFound = true;
                                    }
                                }
                                if(employeeFound){
                                    $scope.employee.list.splice(employeeIndex, 1);
                                }

                                /** IO QUESTA PARTE NON LA ELIMINIREI PERCHE' SE PIU PAZIENTI PUNTANO ALLO STESSO REPARTO SON CAZZI...
                                var wardIndex = -1;
                                var wardFound = false;
                                for (var i = 0; i < $scope.ward.list.length; i++) {
                                    if($scope.ward.list[i].cd_id.toString() == comp.customer_destination_emp_id){
                                        wardIndex = i;
                                        wardFound = true;
                                    }
                                }
                                if(wardFound){
                                    $scope.ward.list.splice(wardIndex, 1);
                                }
                                */
                            }
                        }
                    }
                    //TODO: prova di salvataggio
                    var savePromise = saveRebaser();
                    savePromise.then(function (data) {
                        if(data && data.result == 'ok') {
                            console.log('salvataggio avvenuto correttamente');
                            // occorre anche impostare il componente in stato spedibile

                            if(isShippableComponent){
                                var jsonRead = {
                                    reads: [{read: comp.unicode}]
                                };
                                if(!comp.divcod){
                                    toaster.pop('error', 'Impossibile aggiornare stato componente: divisione non impostata sul componente');
                                } else {
                                    /**
                                    componentUpdateFactory.update({status: $scope.componentShippableStatus, plantCode: comp.divcod}, jsonRead).$promise.then(function (data) {
                                        console.log('ok update storico componente: ' + comp.barcode);
                                    }
                                    ).catch(function (data) {
                                        console.log('error update storico componente: ' + comp.barcode);
                                    });
                                    */

                                    // fix on the fly, se non c'è definito un guardaroba, allora spedisco alla customer_destination del patient, for lavasplendor
                                    var shipDestCode = null;
                                    if(c.wardrobe_emp_code){
                                        shipDestCode = c.wardrobe_emp_code;
                                    } else {
                                        shipDestCode = c.customer_destination_emp_code;
                                    }

                                    componentUpdateFactory.setShipment({status: $scope.componentShippableStatus, plantCode: comp.divcod, shipmentCode: shipDestCode}, jsonRead).$promise.then(function (data) {
                                        console.log('ok update storico componente: ' + c.barcode);
                                    }).catch(function (data) {
                                        toaster.pop('error', 'Errore in fase di salvataggio componente');
                                    });

                                }
                            } else {
                                console.log('Componente da non mettere in stato spedibile.')
                            }
                        } else {
                            toaster.pop('error', 'Errore durante il salvataggio del ricompositore');
                        }
                    });
                } else {
                    toaster.pop('error', 'Componente non dissociabile dal ricompositore');
                }
            }



            function deleteComponent (read) {
                var filters = buildComponentFilter(read);
                recordFactory('component').filter({page_size:10}, filters).$promise.then(function(data) {
                    if(data.list && data.list.length > 0){
                        toaster.pop('info', 'Componente letto: ' + data.list[0].barcode, '');
                        // componente trovato, lo elimino (false: perchè non devo metterlo in stato spedibile)
                        componentFoundToDelete(data.list[0], false, true);
                    } else {
                        // componente non trovato
                        componentNotFound();
                    }
                });
            };



            /*
            *   inserisce il componente nella cella passata
            *   - se sono in insertMode, devo segnarmi la cella nella struttura
            *   - se NON sono in insertMode, vuol dire che è già stata segnata come "utilizzata" per un certo criterio
            *
            *   cell avrà due proprietà r: "a" (riga), c: 0 (colonna)
            */
            function insertCell(component, cell, insertMode) {
                // elimino la pulsazione sull'ultima cella aggiornata
                if($scope.lastInsertedCell){
                    $scope.matrixData[$scope.lastInsertedCell.r][$scope.lastInsertedCell.c].pulse = false;
                }
                $scope.matrixData[cell.r][cell.c].comp.push(component.barcode);
                // segno la cella come piena se i componenti hanno raggiunto la dimensione fissata
                $scope.matrixData[cell.r][cell.c].full = $scope.matrixData[cell.r][cell.c].full
                    || ($scope.matrixData[cell.r][cell.c].sz == $scope.matrixData[cell.r][cell.c].comp.length);
                $scope.matrixData[cell.r][cell.c].pulse = true; // pulsazione sulla cella
                $scope.lastInsertedCell = cell;                 // ultimo componente inserito
                $scope.codeList.push(component.id);
                if(insertMode) {
                    var key = buildKeyCell(component);
                    var cellList = undefined;

                    if($scope.matrixStructure[key] && $scope.matrixStructure[key].list){
                        cellList = $scope.matrixStructure[key].list;
                    }

                    if(cellList){
                        // se trovo una lista di celle posso fare una push
                        $scope.matrixStructure[key].list.push(cell);
                    } else {
                        // altrimenti instanzio una lista
                        $scope.matrixStructure[key] = {};
                        $scope.matrixStructure[key].list = [];
                        $scope.matrixStructure[key].list.push(cell);
                    }
                    // PARTE DI CARICAMENTO DATI
                    // se non ho già caricato i dati li carico
                    if(!$scope.matrixStructure[key].data){
                        var ids = key.split("#");
                        if(ids.length == 1){
                            // è personalizzato: compilo il dipendente
                            $scope.matrixStructure[key].data = {
                                e_id: component.employee_id,
                                e_name: component.employee_name,
                                e_surname: component.employee_surname,
                                e_matr: component.employee_matriculation,
                                cde_id: component.customer_destination_emp_id,
                                cde_cd: component.customer_destination_emp_code,
                                cde_de: component.customer_destination_emp_description,
                                product_cat_id: component.prod_category_id,
                                product_cat_cd: component.prod_category_code,
                                product_cat_de: component.prod_category_description,
                                delivery_id: component.delivery_id,
                                delivery_cd: component.delivery_code,
                                delivery_de: component.delivery_description
                            };
                            // aggiungo il dipendente ad un array di dipendenti caricati (da poter visualizzare in fase di scarico)
                            var insertEmployeeInUnloadList = true;
                            for(var emp in $scope.employee.list){
                                if(emp.id == component.employee_id){
                                    insertEmployeeInUnloadList = false;
                                }
                            }
                            if(insertEmployeeInUnloadList) {
                                $scope.employee.list.push({
                                    id: component.employee_id,
                                    name: component.employee_name,
                                    surname: component.employee_surname,
                                    matr: component.employee_matriculation,
                                    cd_id: component.customer_destination_emp_id,
                                    cd_cd: component.customer_destination_emp_code,
                                    cd_de: component.customer_destination_emp_description,
                                    product_cat_id: component.prod_category_id,
                                    product_cat_cd: component.prod_category_code,
                                    product_cat_de: component.prod_category_description,
                                    delivery_id: component.delivery_id,
                                    delivery_cd: component.delivery_code,
                                    delivery_de: component.delivery_description
                                });
                            }

                            var insertWardInUnloadList = true;
                            for(var emp in $scope.ward.list){
                                if(emp.customer_destination_id == component.customer_destination_emp_id){
                                    insertWardInUnloadList = false;
                                }
                            }
                            if(insertWardInUnloadList) {
                                $scope.ward.list.push({
                                    cd_id: component.customer_destination_emp_id,
                                    cd_cd: component.customer_destination_emp_code,
                                    cd_de: component.customer_destination_emp_description
                                });
                            }

                            var insertProductCategoryInUnloadList = true;
                            for(var pc in $scope.productCategory.list){
                                if(pc.prod_category_id == component.prod_category_id){
                                    insertProductCategoryInUnloadList = false;
                                }
                            }
                            if(insertProductCategoryInUnloadList) {
                                $scope.productCategory.list.push({
                                    product_cat_id: component.prod_category_id,
                                    product_cat_cd: component.prod_category_code,
                                    product_cat_de: component.prod_category_description
                                });
                            }

                        } else if (ids.length == 3) {
                            // non personalizzato: compilo articolo, dest., taglia
                            $scope.matrixStructure[key].data = {
                                cd_cd: component.customer_destination_emp_code,
                                cd_de: component.customer_destination_emp_description,
                                p_cd: component.product_code,
                                p_de: component.product_description
                            };
                            if(ids[2] != '*'){
                                $scope.matrixStructure[key].data.sz_cd = component.size_code;
                                $scope.matrixStructure[key].data.sz_de = component.size_description;
                            } else {
                                $scope.matrixStructure[key].data.sz_cd = '*';
                                $scope.matrixStructure[key].data.sz_de = 'Varie taglie presenti contemporaneamente';
                            }
                        }
                    }
                }
            }



            // controllo il componente se è conforme, e lo aggiungo al ricompositore
            function componentFoundToInsert (c) {
                // controllo componente
                if(checkComponent(c)){
                    var index = getIndexFromId(c.id);
                    // se non è già stato letto lo processo

                    //data la chiave devo controllare se il componente è già stato inserito precedentemente
                    var keySearch = buildKeyCell(c);
                    var found = false;
                    $scope.alreadyInsertedCell = undefined;
                    var cellList = undefined;
                    if($scope.matrixStructure[keySearch] && $scope.matrixStructure[keySearch].list){
                        cellList = $scope.matrixStructure[keySearch].list;
                    }
                    if(cellList){
                        cellList.forEach( function (cell){
                            // cell ha proprietà r: "a" (riga), c: 0 (colonna)
                            if($scope.matrixData[cell.r] && $scope.matrixData[cell.r][cell.c] && $scope.matrixData[cell.r][cell.c].comp){
                                for (var i = 0; i < $scope.matrixData[cell.r][cell.c].comp.length; i++) {
                                    if ($scope.matrixData[cell.r][cell.c].comp[i] == c.barcode) {
                                        found = true;
                                        $scope.alreadyInsertedCell = cell;
                                    }
                                }
                            }
                        });
                    }

                    if(index===-1 && !found){
                        $scope.alreadyInsertedCell = undefined;
                        // costruisco la chiave
                        var key = buildKeyCell(c);
                        // data la chiave ritorna una cella in grado di contenere il componente (con spazio)
                        var cell = findFreeCell(key);
                        if(cell){
                            // aggiungo alla cella trovata se esiste
                            insertCell(c, cell, false);
                        } else {
                            // ricerca di una cella vuota/libera
                            var newCell = createCell();
                            if(newCell){
                                // aggiungo alla cella nuova appena trovata
                                insertCell(c, newCell, true);
                            } else {
                                toaster.pop('error', 'Celle esaurite', 'Non ci sono celle disponibili da utlizzare');
                            }
                        }
                        //TODO: prova di salvataggio
                        var savePromise = saveRebaser();
                        savePromise.then(function (data) {
                            if(data && data.result == 'ok') {
                                console.log('salvataggio avvenuto correttamente');
                            } else {
                                toaster.pop('error', 'Errore durante il salvataggio del ricompositore');
                            }
                        });
                    } else {
                        toaster.pop('error', 'Componente già associato nel ricompositore');
                    }
                } else {
                    toaster.pop('error', 'Componente non posizionabile', 'Verificare anagrafica');
                }
            }

            function isLocked(component) {
                var result = component.locked == 'T';
                return result;
            }

            // inserimento di un componente, cerco la sua anagrafica
            function insertComponent (read) {
                var filters = buildComponentFilter(read);
                recordFactory('component').filter({page_size:10}, filters).$promise.then(function(data) {
                        if(data.list && data.list.length > 0){
                            var component = data.list[0];
                            toaster.pop('info', 'Componente letto: ' + data.list[0].barcode, '');
                            if(isLocked(component)) {
                                showLockedModal(component);
                                if($scope.lastReadCodes.length < 1){
                                    $scope.lastReadCodes.push({
                                        found: true,
                                        locked: true,
                                        read: data.list[0].barcode,
                                        ts: read.ts,
                                        comp: undefined
                                    });
                                } else {
                                    $scope.lastReadCodes.shift();
                                    $scope.lastReadCodes.push({
                                        found: true,
                                        locked: true,
                                        read: read,
                                        ts: read.ts,
                                        comp: undefined
                                    });
                                }
                            }
                            else{
                                // componente trovato -> proseguo nell'aggiunta
                                componentFoundToInsert(component);
                                // **** buffer inserimenti (per ora lo tengo di dimensione 1)
                                if($scope.lastReadCodes.length < 1){
                                    $scope.lastReadCodes.push({
                                        found: true,
                                        locked: false,
                                        read: component.barcode,
                                        ts: read.ts,
                                        comp: component
                                    });
                                } else {
                                    $scope.lastReadCodes.shift();
                                    $scope.lastReadCodes.push({
                                        found: true,
                                        locked: false,
                                        read: component.barcode,
                                        ts: read.ts,
                                        comp: component
                                    });
                                }
                                // **** fine buffer inserimenti
                            }
                        } else {
                            // componente non trovato
                            componentNotFound();
                            // **** buffer inserimenti (per ora lo tengo di dimensione 1)
                            if($scope.lastReadCodes.length < 1){
                                $scope.lastReadCodes.push({
                                    found: false,
                                    locked: false,
                                    read: data.list[0].barcode,
                                    ts: read.ts,
                                    comp: undefined
                                });
                            } else {
                                $scope.lastReadCodes.shift();
                                $scope.lastReadCodes.push({
                                    found: false,
                                    locked: false,
                                    read: read,
                                    ts: read.ts,
                                    comp: undefined
                                });
                            }
                            // **** fine buffer inserimenti
                        }
                });
            };

            // Lettura di un componente in fase di carico: lo controlla e viene aggiunto/eliminato al/dal ricompositore
            $scope.readLoadComponent = function (read) {
                if($scope.mode.value == 'INSERT'){
                    insertComponent(read);
                } else {
                    deleteComponent(read);
                }
            };

            function showLockedModal(component) {
                $scope.lockedComponent = component;
                $timeout(function() {
                    $rootScope.$broadcast('lockedModalCtrl_open');
                }, 0);
            };

            // bottone: segno la cella come piena
            $scope.saveCellAsFull = function (r, c, component) {
                if (angular.isDefined(r) && angular.isDefined(c)) {
                    $scope.matrixData[r][c].full = 1;
                    // elimino il componente appena letto dalla cella (false: perchè non devo metterlo in stato spedibile)
                    componentFoundToDelete(component, false, false);
                    // cerco una cella nuova e aggiungo il componente
                    componentFoundToInsert(component);
                }
            }



            // 'ANNULLA': elimina l'ultimo inserimento (false: perchè non devo metterlo in stato spedibile)
            $scope.undoInsertComponent = function (component) {
                componentFoundToDelete(component, false, true);
            };



            // costruzione struttura del ricompositore
            function build(rows, columns, cellQty) {
                var ret = {};
                if(rows && columns && cellQty) {
                    if( rows < 26 ) {
                        for(var i = 0 ; i < rows; i++){
                            var chr = String.fromCharCode(97 + i); // key: riga
                            ret[chr] = []; // array con le colonne
                            for(var j = 0 ; j < columns; j++){
                                // building and push cell
                                var cell = {
                                    comp: [],
                                    full: 0,
                                    sz: cellQty
                                };
                                ret[chr].push(cell);
                            }
                        }
                    } else {
                        toaster.pop('error', 'Errore durante la costruzione del ricompositore', 'Numero massimo di righe consentite: 25');
                        // perchè se no le lettere dell'alfabeto non basterebbero...
                    }
                } else {
                    toaster.pop('error', 'Errore durante la costruzione del ricompositore', 'Verificare anagrafica');
                    // se non sono stati impostati i 3 valori necessari...
                }
                return ret;
            };



            // imposta la modalità di visualizzazione del carico
            // (imposta automaticamente anche la modalità di utilizzo)
            $scope.setType = function (type) {
                $scope.setLoad(true);
                $scope.type = type;

                // pulisco le variabili se arrivo dallo scarico
                $scope.unloadMap = undefined;
                $scope.unloadList = undefined;
                $scope.unloadKey = undefined;
            };



            // imposta la modalità di utilizzo: true (carico), false (scarico)
            $scope.setLoad = function (bool) {
                if($scope.load != bool){
                    // se cambio modalità sbianco le lookup
                    delete $scope.selected.wardrobe;
                    delete $scope.selected.ward;
                    delete $scope.selected.employee;
                    delete $scope.selected.productCategory;
                    $scope.unloadMap = undefined;
                    $scope.unloadList = undefined;
                    $scope.unloadKey = undefined;
                }
                $scope.load = bool;
            }



            // stampa una descrizione del capo (solo di front-end)
            $scope.getType = function (component_type) {
                $scope.setLoad(true);
                switch (component_type) {
                    case 'INDIVIDUAL':
                        return 'Capo personalizzato';
                        break;
                    case 'GENERIC':
                        return 'Capo non personalizzato';
                        break;
                    default:
                        return '';
                        break;
                }
            };



            // stampa una lista di celle (solo di front-end)
            $scope.printArray = function (v) {
                var ret = '';
                for (var i = 0; i < v.length; i++) {
                    ret = ret+'<span class="label label-default">' + v[i].r.toUpperCase() + v[i].c.toString() + '</span> ';
                }
                return ret;
            };



            // stampa il totale dei componenti per una lista di celle (solo di front-end)
            $scope.printComponentNumbers = function (v) {
                var ret = 0;
                // v: è l'array di celle che mi salvo nella matrixStructure
                for (var i = 0; i < v.length; i++) {
                    // riga: v[i].r, colonna: v[i].c, ricomp: $scope.matrixData
                    ret = ret + $scope.matrixData[v[i].r][v[i].c].comp.length;
                }
                return ret;
            }

            // stampa il totale dei componenti per una lista di celle (solo di front-end)
            $scope.printComponentNumbersForSingleCell = function (r, c) {
                var ret = $scope.matrixData[r][c].comp.length;
                return ret;
            }

            // funzione per stampare il numero di colonne sulla tabella (solo di front-end)
            $scope.range = function(count){
                var ratings = [];
                for (var i = 0; i < count; i++) { ratings.push(i); }
                return ratings;
            };



            // deselezione guardaroba corrente
            $scope.resetWardrobe = function () {
                delete $scope.selected.wardrobe;
                $scope.matrixWardrobe = {};
                $scope.unloadMap = undefined;
                $scope.unloadList = undefined;
                $scope.unloadKey = undefined;
            };

            // deselezione nuclep corrente
            $scope.resetProductCategory = function () {
                delete $scope.selected.productCategory;
                $scope.unloadMap = undefined;
                $scope.unloadList = undefined;
                $scope.unloadKey = undefined;
            };

            // deselezione reparto corrente
            $scope.resetWard = function () {
                delete $scope.selected.ward;
                $scope.unloadMap = undefined;
                $scope.unloadList = undefined;
                $scope.unloadKey = undefined;
            };

            // deselezione dipendente corrente
            $scope.resetEmployee = function () {
                delete $scope.selected.employee;
                $scope.unloadMap = undefined;
                $scope.unloadList = undefined;
                $scope.unloadKey = undefined;
            };


            // svuota il ricompositore
            $scope.setEmpty = function () {
                // imposto il carico
                $scope.setLoad(true);
                // svuoto il ricompositore e la struttura di appoggio
                $scope.matrixData = build($scope.element.row_number,$scope.element.column_number, $scope.element.quantity);
                $scope.matrixStructure = {};
                // svuoto tutte le strutture di appoggio
                $scope.codeList = [];
                $scope.lastInsertedCell = undefined;
                $scope.lastReadCodes = [];
                $scope.ward = { list: []};  // lista dei reparti selezionabili (anche questa va svuotata)
                $scope.employee = { list: []};  // lista dei dipendenti selezionabili (anche questa va svuotata)
                $scope.productCategory = { list: []};  // lista dei nuclei selezionabili (anche questa va svuotata)
                //TODO: prova di salvataggio
                var savePromise = saveRebaser();
                savePromise.then(function (data) {
                    if(data && data.result == 'ok') {
                        console.log('salvataggio avvenuto correttamente');
                    } else {
                        toaster.pop('error', 'Errore durante il salvataggio del ricompositore');
                    }
                });
            };



            // inizializzazione lista guardaroba
            function initWardrobes () {
                var filters = [
                    {
                        "column": "receiver_type rt",
                        "value": "t.receiver_type_id = rt.id",
                        "relation": "JOIN",
                        "kind": "rt.id AS receiver_type_id"
                    },
                    {
                        "column": "rt.code",
                        "value": "GUA",
                        "relation": "=",
                        "kind": "string"
                    },
                ];
                recordFactory('customer_destination').filter({ page_size: 10000 }, filters).$promise.then(function (data) {
                    if (data.list && data.list.length > 0) {
                        $scope.wardrobe.list = data.list;
                    } else {
                        $scope.wardrobe.list = [];
                    }
                });
            }


            // inizializzione lista reparti
            function initWards () {
                var filters = [
                    {
                        "column": "receiver_type rt",
                        "value": "t.receiver_type_id = rt.id",
                        "relation": "JOIN",
                        "kind": "rt.id AS receiver_type_id"
                    },
                    {
                        "column": "rt.code",
                        "value": "REP",
                        "relation": "=",
                        "kind": "string"
                    },
                ];
                recordFactory('customer_destination').filter({ page_size: 10000 }, filters).$promise.then(function (data) {
                    if (data.list && data.list.length > 0) {
                        $scope.ward.list = data.list;
                    } else {
                        $scope.ward.list = [];
                    }
                });
            }



            // confronto se è stato modificato il numero di righe o di colonne
            // se le righe o le colonne sono state modificate, verifico se devo sbiancare o meno la matrice
            function checkIntegrityRebaser(json) {
                var rowNumberJson = 0;
                var colNumberJson = 0;
                // conto le righe e le colonne
                for(var i in json.matrixData){
                    rowNumberJson++;
                    // al momento non saprei come controllare meglio la lunghezza...
                    if(colNumberJson < json.matrixData[i].length){
                        colNumberJson = json.matrixData[i].length;
                    }
                }
                // in tutti i casi riempio comunque la struttura della matrice
                if(rowNumberJson == $scope.element.row_number && colNumberJson == $scope.element.column_number){
                    $scope.matrixData = json.matrixData;
                    $scope.matrixStructure = json.matrixStructure;

                    /** init guardaroba selezionato */
                    $scope.matrixWardrobe = json.matrixWardrobe;
                    $scope.selected.wardrobe = json.matrixWardrobe;
                    /****************************** */

                    if(json.w_list){
                        $scope.ward.list = json.w_list;
                    } else {
                        $scope.ward.list = [];
                    }
                    if(json.e_list){
                        $scope.employee.list = json.e_list;
                    } else {
                        $scope.employee.list = [];
                    }
                    if(json.pc_list){
                        $scope.productCategory.list = json.pc_list;
                    } else {
                        $scope.productCategory.list = [];
                    }
                } else {
                    $scope.matrixData = build($scope.element.row_number,$scope.element.column_number, $scope.element.quantity);
                    $scope.matrixStructure = {};
                }
            }



            // recupero del ricompositore
            function getRebaser (id) {
                recordFactory('rebaser').byId({id: id}).$promise.then(function (data) {
                    if(data) {
                        $scope.element = data;
                        // costruisco la matrice dei dati vuota
                        if(!$scope.element.rawdata){
                            $scope.matrixData = build($scope.element.row_number,$scope.element.column_number, $scope.element.quantity);
                            $scope.matrixStructure = {};
                        } else {
                            // costruisco la matrice dei dati dal JSON
                            var json = JSON.parse($scope.element.rawdata);
                            // controllo l'integrità dei dati
                            checkIntegrityRebaser(json);
                        }
                    } else {
                        toaster.pop('error', 'Errore durante il recupero del ricompositore', 'Verificare anagrafica');
                    }
                });
            };



            /*************** VIS. CAPI MANCANTI **************/

            $scope.initMissingComponents = function () {
                console.log("------ init page missing components ------------");
                var comps = [];
                if($scope.matrixData) {
                    for(var j in $scope.matrixData){
                        for(var i = 0; i < $scope.matrixData[j].length; i++){
                            comps = comps.concat($scope.matrixData[j][i].comp);
                        }
                    }
                }
                console.log("--------- COMPONENTS IN MATRIX -------------------");
                console.log(comps);
                var compsArrayToSend = "";
                var i = 0;
                for (var j = 0; j < comps.length; j++){
                    if(j == 0){
                        compsArrayToSend += "" + comps[j] + "";
                    } else {
                        compsArrayToSend += ",";
                        compsArrayToSend += "" + comps[j] + "";
                    }
                }
                compsArrayToSend += "";
                var json = {
                    unicodes: compsArrayToSend,
                    shipment_destination: $scope.matrixWardrobe.id.toString(),
                    status: "L,E,WIP"
                };
                rebaserFactory.returnPatientMissingItem(json).$promise.then(function (data) {
                    console.log("--------- MISSING ITEMS -------------------");
                    console.log(data);
                    if(data.result){
                        $scope.missingComponents.list = data.result;
                    }
                });
            }


            /*************************************************/

            // salvataggio del ricompositore
            function saveRebaser () {
                $scope.element.rawdata = {
                    matrixData: $scope.matrixData,
                    matrixStructure: $scope.matrixStructure,
                    matrixWardrobe: $scope.matrixWardrobe,
                    e_list: $scope.employee.list,
                    w_list: $scope.ward.list,
                    pc_list: $scope.productCategory.list
                };
                var jsonString = JSON.stringify($scope.element.rawdata); // viene salvato solamente lo stato
                return rebaserFactory.update({id: $scope.element.id}, jsonString).$promise;
            };



            // initLookups(): Inizializza le lookup su guardaroba e reparti
            function initLookups(){
                initWardrobes();
                //initWards();
            };



            function init() {
                initLookups();
                if(angular.isDefined($routeParams.id)){
                    getRebaser($routeParams.id);
                }
            };

            //___ main ___
            init();
    });

'use strict';

/**
 * 11/01/2019
 * @author Rita Beltrami
 * @name ictportal.lm.controller:HighVisibilityAttachmentsCtrl
 * @description SIXLM-234 per componenti ad alta visibilità.
 * # HighVisibilityAttachmentsCtrl
 * Controller of the ictportal.lm
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/highVisibility/component/attachments', {
                templateUrl: 'lm/highVisibilityComponent/high_visibility_component_attachments.html',
                controller: 'HighVisibilityAttachmentsCtrl'
            })
    })
    .controller('HighVisibilityAttachmentsCtrl', function ($scope, $location, dbFilterFactory,
        recordFactory, uiGridConstants, $log, authFactory, localeFactory, sixGridPaginationConstants, $rootScope) {
        $scope.list = {};
        $scope.customerFilter = []; // Filtro da applicare alla lookup sugli ospedali
        $scope.shipmentDestinationImplicitFilter = []; // Filtro da applicare sulle righe della tabella
        $scope.shipmentDestinationFilter = []; // Filtro da applicare alla lookup dei reparti
        $scope.employeeFilter = []; // Filtro da applicare sulla lookup dei dipendenti
        $scope.record = {
            model: {},
            lookup: {},
            dates: []
        };
        $scope.disable = {
            customer: false
        };
        $scope.customersList = [];
        $scope.params = {
            pageNumber: 1,
            pageSize: 15,
            code: 'component',
            filters: []
        };
        $scope.selected = {};

        $scope.viewGridOptions = { 
            appScopeProvider: $scope,
            multiSelect: false,
            enableRowHeaderSelection: false,
            enableRowSelection: false,
            rowSelectionChanged: $scope.rowSelectionChangedCallback
        };
        var from = new Date();
        from.setDate(from.getDate() - 1);
        $scope.advFilter = {
            filter: {
                dateFrom: from,
                dateTo: new Date()
            },
            list: []
        };
        $scope.attachments = {
            show: false,
            selItem: undefined,
            model: {}
        };

        $scope.lookup = {
            customer_id: {
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            },
            customer_destination_id: {
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            },
            product_id: {
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            },
            size_id: {
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            },
            employee_id: {
                filter: dbFilterFactory.getStringFilter('discriminator', 'EMP'),
                obj: undefined,
                mapping: {
                    code: 'matriculation',
                    description: 'surname,name'
                }
            }
        };
        $scope.lookup.employee_id.filter.push({
            "column": "customer_destination c",
            "value": "t.destination_id = c.id",
            "relation": "JOIN",
            "kind": "c.customer_id"
        });

       $scope.msg = {
            "attachments": "Attachments",
            "washes": "Washes",
            "customer_destination_REP": "Ward",
            "unicode": "Unicode",
            "detail": "Detail",
            "barcode": "Barcode",
            "product": "Product",
            "size": "Size",
            "operator": "Operator",
            "date": "Date"
        };
        $scope.component_msg = {
            "N":"Nuovo",
            "C":"Conforme",
            "NC":"Non conforme",
            "F":"Piegato",
            "P":"Confezionato",
            "S":"Spedito",
            "E":"Rientrato",
            "WIP":"In lavorazione",
            "A":"Dismesso",
            "U":"Usato",
            "L":"Lavato",
            "SW":"Lavaggio speciale",
            "T":"Sartoria",
            "W":"Guardaroba",
            "SL":"Spedito lavanderia",
            "SWA":"Spedito guardaroba",
            "DWA":"Sporco guardaroba",
            "PCW":"Spedito CL",
            "LOST":"Disperso",
            "ACCD":"Accettato reparto",
            "SHPBLW":"Spedibile guard.",
            "SHPBLD":"Spedibile rep."
        };

        $scope.$watchGroup(['advFilter.filter.barcode',
            'advFilter.filter.unicode',
            'advFilter.filter.customer_id',
            'advFilter.filter.customer_destination_id',
            'advFilter.filter.product_id',
            'advFilter.filter.size_id',
            'advFilter.filter.employee_id',
            'advFilter.filter.dateFrom',
            'advFilter.filter.dateTo',
            'advFilter.filter.employee_id'
        ], function () {
            $scope.applyFilter();
        });

        $scope.viewAttachments = function (item) {
            $scope.attachments.show = true;
            $scope.attachments.selItem = item;
        }

        $scope.viewDetail = function (item) {
            $scope.attachments.show = false;
            $rootScope.$broadcast('highVisibilityComponentHistoryModalCtrl_open', item);
        }

        $scope.applyFilter = function () {
            $scope.advFilter.list.length = 0;
            if ($scope.advFilter.filter.barcode) {
                var f = dbFilterFactory.getLikeFilter('c.barcode', $scope.advFilter.filter.barcode);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.unicode) {
                var f = dbFilterFactory.getLikeFilter('c.unicode', $scope.advFilter.filter.unicode);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.customer_id) {
                var f = dbFilterFactory.getNumberFilter('customer_id', $scope.advFilter.filter.customer_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.customer_destination_id) {
                var f = dbFilterFactory.getNumberFilter('t.shipment_destination', $scope.advFilter.filter.customer_destination_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            else if ($scope.shipmentDestinationImplicitFilter.length > 0) {
                $scope.advFilter.list = $scope.advFilter.list.concat($scope.shipmentDestinationImplicitFilter);
            }
            if ($scope.advFilter.filter.product_id) {
                var f = dbFilterFactory.getNumberFilter('product_id', $scope.advFilter.filter.product_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.size_id) {
                var f = dbFilterFactory.getNumberFilter('size_id', $scope.advFilter.filter.size_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.employee_id) {
                var f = dbFilterFactory.getNumberFilter('t.employee_id', $scope.advFilter.filter.employee_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.dateFrom) {
                var f = dbFilterFactory.getDateFilter('t.operation_date', $scope.advFilter.filter.dateFrom, ">=");
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.dateTo) {
                var f = dbFilterFactory.getDateFilter('t.operation_date', $scope.advFilter.filter.dateTo, "<=");
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }

            $log.info($scope.advFilter.list);
            $scope.getData();
        };

        $scope.translateValue = function (value) {
            return $scope.msg[value];
        }

        function initGridColumns() {
            $scope.viewGridOptions.columnDefs = [];
            var dateFormat = localeFactory.getDateFormat();
            $scope.viewGridOptions.columnDefs.push({
                displayName: '',
                field: 'id',
                width: 34,
                enableCellEdit: false,
                enableFiltering: false,
                enableSorting: false,
                cellTemplate:
                    '<div class="ui-grid-cell-contents" style="text-align: center">' +
                    '<button ng-click="grid.appScope.viewDetail(row.entity)" class="btn btn-xs btn-primary" title="Dettaglio">' +
                    '<span class="fa fa-search"></span>' +
                    '</button>' +
                    '</div>'
            });
            $scope.viewGridOptions.columnDefs.push({
                displayName: '',
                field: 'id',
                width: 34,
                enableCellEdit: false,
                enableFiltering: false,
                enableSorting: false,
                cellTemplate:
                    '<div class="ui-grid-cell-contents" style="text-align: center">' +
                    '<button ng-click="grid.appScope.viewAttachments(row.entity)" class="btn btn-xs btn-primary" title="Allegati">' +
                    '<span class="fa fa-file"></span>' +
                    '</button>' +
                    '</div>'
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Unicode",
                field: "unicode",
                width: 200,
                translation: 'unicode',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Barcode",
                field: "barcode",
                width: 130,
                translation: 'barcode',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: 'Product',
                field: 'product_code',
                translation: 'product',
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.product_code }} - {{ row.entity.product_description }}</div>',
                enableFiltering: false,
                filters: [{
                    type: sixGridPaginationConstants.filterType.TEXT,
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: '',
                    kind: 'string',
                    aliasResolver: 'product.code,product.description'
                }]
            });
            $scope.viewGridOptions.columnDefs.push({
                name: 'Size',
                field: 'size',
                translation: 'size',
                width: 80,
                enableFiltering: false,
                filters: [{
                    type: sixGridPaginationConstants.filterType.TEXT,
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: '',
                    kind: 'string',
                    aliasResolver: 's.description'
                }]
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Wash count",
                field: "wash_num",
                translation: 'washes',
                width: 100,
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: 'Destination',
                field: 'destination_code',
                translation: 'customer_destination_REP',
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.destination_code }} - {{ row.entity.destination_description }}</div>',
                enableFiltering: false,
                filters: [{
                    type: sixGridPaginationConstants.filterType.TEXT,
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: '',
                    kind: 'string',
                    aliasResolver: 'cd.code,cd.description'
                }]
            });
            $scope.viewGridOptions.columnDefs.push({
                name: 'Operator',
                field: 'name',
                translation: 'operator',
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.name }} - {{ row.entity.surname }}</div>',
                enableFiltering: false,
                filters: [{
                    type: sixGridPaginationConstants.filterType.TEXT,
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: '',
                    kind: 'string',
                    aliasResolver: 'e.name,e.surname'
                }]
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Read",
                field: "operation_date",
                translation: 'date',
                width: 100,
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.operation_date | date:\'' + dateFormat + '\' }}</div>',
                enableFiltering: false
            });
        };

        $scope.getData = function () {
            var payload = {
                page: $scope.params.pageNumber,
                page_size: $scope.params.pageSize,
                code: $scope.params.code,
                description: $scope.params.description,
                show_revision: false,
                sort_fields: $scope.params.sortFields ? $scope.params.sortFields : undefined,
                sort_order: $scope.params.sortOrder
            };
            var filters = [
                {
                    "column": "component c",
                    "value": "c.id = t.component_id",
                    "relation": "JOIN",
                    "kind": "c.barcode AS barcode, c.unicode AS unicode, c.wash_num AS wash_num"
                },
                {
                    "column": "product p",
                    "value": "c.product_id = p.id",
                    "relation": "JOIN",
                    "kind": "p.code AS product_code,p.description AS product_description"
                },
                {
                    "column": "tab_size s",
                    "value": "c.size_id = s.id",
                    "relation": "JOIN",
                    "kind": "s.description AS size"
                },
                {
                    "column": "human_resource e",
                    "value": "c.employee_id = e.id",
                    "relation": "JOIN",
                    "kind": "e.name, e.surname"
                },
                {
                    "column": "customer_destination cd",
                    "value": "t.shipment_destination = cd.id",
                    "relation": "JOIN",
                    "kind": "cd.code AS destination_code, cd.description AS destination_description"
                }
            ].concat(dbFilterFactory.getCustomFilter("(c.divcod=" + authFactory.getAuthData().info.divCod +" OR c.divcod is null)"))
                .concat(getShipmentDestinationImplicitFilters())
                .concat($scope.advFilter.list)
                .concat(dbFilterFactory.getStringFilter("t.status", "W"));
            recordFactory('component_status').filter(payload, filters)
                .$promise.then(function (data) {
                    $scope.viewGridOptions.totalItems = data.totalResults;
                    $scope.list.totalResults = data.totalResults;
                    $scope.list.list = data.list;
                });
        };

        function translateGridColumns() {
            $scope.viewGridOptions.columnDefs.forEach(function (col) {
                if (col.translation) {
                    if ($scope.msg[col.translation]) {
                        col.displayName = $scope.msg[col.translation];
                    }
                }
            });
        }

        function getShipmentDestinationImplicitFilters() {
            var filters = [];
            var implicit = angular.copy($scope.authData.filters.customer_destination);
            implicit.forEach(function(f) {
                dbFilterFactory.changeCustomAlias('t',f,'shipment_destination')
                filters.push(f);
            });
            return filters;
        }
        
        function getShipmentDestinationFilters() {
            var filters = [];
            var implicit = angular.copy($scope.authData.filters.customer_destination);
            implicit.forEach(function(f) {
                dbFilterFactory.changeCustomAlias('t',f,'id')
                filters.push(f);
            });
            return filters;
        }

        // Se poi ho in GET l'id di uno specifico nosocomio, filtro solo su quello e blocco la selezione di altri ospedali.
        function getCustomerFilter() {
            // Recupero l'elenco dei clienti possibili per l'operatore
            $scope.authData = authFactory.getAuthData();
            var filter = $scope.authData.filters.customer.slice(0);
            if(filter.length==1) {
                var customerId = filter[0].value.substring(7,filter[0].value.length-1);
                $scope.advFilter.filter.customer_id = customerId;
            }
            return filter;
        };

        // Solo operatori degli ospedali abilitati sull'utente
        function getEmployeeFilter() {
            $scope.authData = authFactory.getAuthData();
            var filter = $scope.lookup.employee_id.filter;
            var copy = JSON.parse(JSON.stringify($scope.authData.filters.customer));
            copy.forEach(function(f){
                dbFilterFactory.changeCustomAlias('c',f,'customer_id');
                filter.push(f);
            })
            return filter;
        };


        $scope.selectCustomerIfUnique = function() {
            if($scope.customersList.length==1) {
                $scope.lookup.customer_id.obj = $scope.customersList[0];
                $scope.disable.customer = true;
            }
        }

        $rootScope.$on('$translateRefreshEnd', function () {
            localeFactory.translateMsg($scope.component_msg, 'component');
            localeFactory.translateMsg($scope.msg).then(function(){
                translateGridColumns();
            });
        });

        function checkPermissions() {
            var profilingKey = 'HIGH_VISIBILITY_ATTACHMENTS';
            var permission = authFactory.getPermissions(profilingKey);
            if(!permission.EXEC) {
                $location.path('forbidden').search({key: profilingKey});
            }
        }

        $scope.reset = function() {
            
            var from = new Date();
            from.setDate(from.getDate() - 1);
            $scope.advFilter.filter.dateFrom = from;
            $scope.advFilter.filter.dateTo = new Date();          
            $scope.advFilter.filter.barcode = undefined;
            $scope.advFilter.filter.unicode = undefined;
            $scope.advFilter.filter.customer_id = undefined;
            $scope.advFilter.filter.customer_destination_id = undefined;
            $scope.advFilter.filter.product_id = undefined;
            $scope.advFilter.filter.size_id = undefined;
            $scope.advFilter.filter.employee_id = undefined;
            $scope.$broadcast('clearLookUp');
            $scope.applyFilter();
        }

        function init() {
            checkPermissions();
            initGridColumns();
            localeFactory.loadTranslation('component');
            $scope.customerFilter = getCustomerFilter();
            $scope.employeeFilter = getEmployeeFilter();
            $scope.shipmentDestinationFilter = getShipmentDestinationFilters();
        };

        //___ main ___
        init();

    });

/**
 * Created by Rita Beltrami on 26/06/17.
 */
'use strict';

angular.module('ictportal.lm')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/highVisibility/component/detail', {
          templateUrl: 'lm/highVisibilityComponent/high_visibility_component_detail.html',
          controller: 'HighVisibilityComponentCtrl'
        })
        .when('/highVisibility/component/detail/:id', {
          templateUrl: 'lm/highVisibilityComponent/high_visibility_component_detail.html',
          controller: 'HighVisibilityComponentCtrl'
        })
  })
  .controller('HighVisibilityComponentCtrl', function ($scope, $log, recordFactory, $routeParams, $location,
                                          eggsFormFactory, toaster, dbFilterFactory, 
                                          authFactory, $q, $window,  $rootScope, schemaFactory) {

    $scope.pageTitle = 'Dettaglio componente';
    $scope.readOnly = true;                
    $scope.customer = {};
    $scope.enum = {
        special_use: [
          {
            name: 'Muletto',
            value: 'COURTESY'
          },
          {
            name: 'Generico',
            value: 'GENERIC'
          },
          {
            name: 'Personalizzato',
            value: 'INDIVIDUAL'
          }
        ]                    
    };      
    $scope.statix = {
      path: '',
      model: undefined
    };

    $scope.initStatix = function(path,model){
      $rootScope.$broadcast('statix:clean');
      $scope.statix.path = path;
      $scope.statix.model = model;
    };

    function initLookups() {
      $scope.lookup = { };
      $scope.customerLookup = {};
      for (var key in $scope.sf.schema.properties) {
        var prop = $scope.sf.schema.properties[key];
        if (prop.format === 'lookup') {
          eggsFormFactory.addLookup($scope.lookup, key, prop.entity_id, 'code', 'description');
        }
      }
      // adding custom mappings
      eggsFormFactory.addLookup($scope.customerLookup, 'customer_id', 'customer', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'product_id', 'product', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'employee_id', 'human_resource', 'matriculation', 'surname,name');
      eggsFormFactory.addLookup($scope.lookup, 'lot_id', 'lot', 'code', 'description');
      $scope.mappingLoaded = true;
    };

    function initDates() {
      $scope.dateFields = [];
      $scope.sf.form[0].items[0].tabs.forEach(function (tab) {
        tab.items.forEach(function (item) {
          if (item.type === 'datepicker') {
            $scope.dateFields.push(item.key[0]);
          }
        });
      });
    };

    function getComponentHistory(){
      var payload = {
        page_size: 10000,
        show_revision: false,
        sort_fields: 'operation_date',
        sort_order: 'desc'
      };
      var filters = dbFilterFactory.getNumberFilter('component_id',$scope.element.id);
      filters = filters.concat(dbFilterFactory.getCustomFilter("( status='S' OR status='ACCD' OR status='W' OR status='E' OR status='L' OR status='SW' OR status='C'  )"));
      recordFactory('component_status').filter(payload, filters)
          .$promise.then(function(data) {
            $log.info(data);
            $rootScope.$broadcast('sixComponentStatusGrid:dataLoaded','component_status',data.list);
      });
    };

    function getComponent(id) {
      recordFactory('component').byId({ id: id }).$promise.then(function (response) {
        $scope.element = response;
        eggsFormFactory.convertDates($scope.element, $scope.dateFields);
        $log.info($scope.element);
        eggsFormFactory.loadLookupData($scope.lookup, $scope.element);
        $rootScope.$broadcast('sixCheckbox:reload');
        getComponentHistory();
        $scope.initStatix($scope.element.unicode,{});
      });
    };

    function checkPermissions() {
      var profilingKey = 'HIGH_VISIBILITY_COMPONENT';
      var permission = authFactory.getPermissions(profilingKey);
      $scope.isUploadAllowed = permission.UPLOAD;
      $scope.isDeleteAllowed = permission.DELETE;
    }

    function init() {
      fetch('/lm/highVisibilityComponent/component_schema_form.json')
      .then(function(response) {
          return response.json();})
      .then(function(data) {
        $scope.sf = data;
        initLookups();
        initDates();
        if (angular.isDefined($routeParams.id)) {
          getComponent($routeParams.id);
        }
      });
      checkPermissions();
    };

    init();

  });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:HighVisibilityComponentListCtrl
 * @description
 * # HighVisibilityComponentListCtrl
 * Controller of the ictportal.lm
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/highVisibility/component/list', {
                templateUrl: 'lm/highVisibilityComponent/high_visibility_component_list.html',
                controller: 'HighVisibilityComponentListCtrl'
            })
            .when('/highVisibility/component/list/:customer', {
                templateUrl: 'lm/highVisibilityComponent/high_visibility_component_list.html',
                controller: 'HighVisibilityComponentListCtrl'
            })
    })
    .filter('mapBoolean', function () {
        var genderHash = {
            1: 'Sì',
            2: 'No'
        };

        return function (input) {
            if (!input) {
                return '';
            } else {
                return genderHash[input];
            }
        };
    })
    .controller('HighVisibilityComponentListCtrl', function ($scope, $routeParams, $location, toaster, $q, dbFilterFactory,
        recordFactory, schemaFactory, uiGridConstants, $log, authFactory) {
        $scope.schemaFound = false;
        $scope.lockCustomer = false;
        $scope.list = {};
        $scope.customerFilter = []; // Filtro da applicare alla lookup sugli ospedali
        $scope.currentDestinationFilter = []; // Filtro da applicare sulle righe della tabella
        $scope.employeeCustomerFilter = []; // Filtro da applicare sulla lookup dei dipendenti
        $scope.record = {
            model: {},
            lookup: {},
            dates: []
        };
        $scope.params = {
            pageNumber: 1,
            pageSize: 15,
            code: 'component',
            filters: []
        };
        $scope.viewGridOptions = { 
            appScopeProvider: $scope,
            enablePagination: true,
            enablePaginationControls: true
        };
        $scope.advFilter = {
            filter: {},
            list: []
        };

        $scope.lookup = {
            customer_id: {
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            },
            product_id: {
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            },
            size_id: {
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            },
            employee_id: {
                filter: dbFilterFactory.getStringFilter('discriminator', 'EMP'),
                obj: undefined,
                mapping: {
                    code: 'matriculation',
                    description: 'surname,name'
                }
            },
            lot_id: {
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'code,description'
                }
            },
            current_destination_id: {
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'code,description'
                }
            }
        };

        $scope.lookup.employee_id.filter.push({
            "column": "customer_destination c",
            "value": "t.destination_id = c.id",
            "relation": "JOIN",
            "kind": "c.customer_id"
        });

        $scope.reset = function() {
            $scope.advFilter.filter = {};
            $scope.advFilter.list.length = 0;
            $scope.$broadcast('clearLookUp');
        }

        $scope.$watchGroup(['advFilter.filter.barcode',
                            'advFilter.filter.unicode',
                            'advFilter.filter.customer_id', 
                            'advFilter.filter.product_id', 
                            'advFilter.filter.size_id', 
                            'advFilter.filter.employee_id', 
                            'advFilter.filter.lot_id',
                            'advFilter.filter.current_destination_id'], function () {
            $scope.applyFilter();
        });

        function joinTableWithCustomerDestination(){
            $scope.advFilter.list = $scope.advFilter.list.concat([
                {
                    "column": "human_resource h",
                    "value": "t.employee_id = h.id",
                    "relation": "JOIN",
                    "kind": "h.destination_id"
                },
                {
                    "column": "customer_destination c",
                    "value": "h.destination_id = c.id",
                    "relation": "JOIN",
                    "kind": "c.customer_id"
                }
            ]);
        };

        $scope.applyFilter = function () {
            $scope.advFilter.list.length = 0;
            if ($scope.advFilter.filter.barcode) {
                var f = dbFilterFactory.getLikeFilter('t.barcode', $scope.advFilter.filter.barcode);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.unicode) {
                var f = dbFilterFactory.getLikeFilter('t.unicode', $scope.advFilter.filter.unicode);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.customer_id) {
                joinTableWithCustomerDestination();
                var f = dbFilterFactory.getNumberFilter('customer_id', $scope.advFilter.filter.customer_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if($scope.currentDestinationFilter.length>0){
                $scope.advFilter.list = $scope.advFilter.list.concat($scope.currentDestinationFilter);
            }
            if ($scope.advFilter.filter.product_id) {
                var f = dbFilterFactory.getNumberFilter('product_id', $scope.advFilter.filter.product_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.size_id) {
                var f = dbFilterFactory.getNumberFilter('size_id', $scope.advFilter.filter.size_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.lot_id) {
                var f = dbFilterFactory.getNumberFilter('lot_id', $scope.advFilter.filter.lot_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.employee_id) {
                var f = dbFilterFactory.getNumberFilter('employee_id', $scope.advFilter.filter.employee_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.current_destination_id) {
                var f = dbFilterFactory.getNumberFilter('current_destination_id', $scope.advFilter.filter.current_destination_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }

            $log.info($scope.advFilter.list);
            $scope.getData();
        };

        function readLookups() {
            for (var key in $scope.schema.properties) {
                var prop = $scope.schema.properties[key];
                if (prop.format === 'lookup') {
                    $scope.record.lookup[key] = {
                        mapping: prop.mapping,
                        obj: {},
                        entity: prop.entity_id
                    };
                }
            }
        };

        function loadLookupCols() {
            // Raggruppo assieme i record che fanno riferimento ad una stessa entità (es. tutti quelli con customer_id=123)
            // In questo modo risolvo l'entità una volta sola per tutti.
            var lookupMap = {};
            $scope.lookupCols.forEach(function (lookup) {
                var field = lookup.field;
                lookupMap[field] = {};
                $scope.list.list.forEach(function (record) {
                    var id = record[field];
                    if (id) {
                        if(!lookupMap[field][id]){
                            lookupMap[field][id] = [];
                        }
                        lookupMap[field][id].push(record);
                    }
                });
            });
            // Recupero da DB i dati e li assegno ai rispettivi record.
            $scope.lookupCols.forEach(function (lookup) {
                for(var id in lookupMap[lookup.field]){
                    recordFactory(lookup.entity).byId({ id: id })
                        .$promise.then(function (data) {
                            data['model'] = { description: '' };
                            var tokens = lookup.mapping.description.split(',');
                            tokens.forEach(function (term) {
                                if (data[term]) {
                                    data['model'].description += data[term] + ' ';
                                }
                            });
                            data['model'].description = data['model'].description.trim();
                            lookupMap[lookup.field][data.id].forEach(function(record){
                                record[lookup.field + '_obj'] = data;
                            });
                        });
                }
            });
        };
        
        function readDates() {
            $scope.form[0].items[0].tabs.forEach(function (tab) {
                tab.items.forEach(function (item) {
                    if (item.type === 'datepicker') {
                        var t1 = $scope.record.dates;
                        var t2 = item.key[0];
                        $scope.record.dates.push(item.key[0]);
                    }
                });
            });
        };

        function loadDates() {
            $scope.record.dates.forEach(function (field) {
                $scope.list.list.forEach(function (record) {
                    if (record[field]) {
                        record[field] = new Date(record[field]);
                    }
                });
            });
        };

        /* Devo fare così perchè una vista ad elenco dei componenti ce l'ho anche in pagina dipendente ma le colonne da visualizzare sono diverse */
        function setColumns(data){
            data.columnDefs = [
                {
                    name: "Unicode",
                    field: "unicode"
                },
                {
                    name: "Barcode",
                    field: "barcode"
                },
                {
                    name: "Articolo",
                    field: "product_id"
                },
                {
                    name: "Taglia",
                    field: "size_id"
                },
                {
                    name: "Stato",
                    field: "status"
                }
            ];
        };

        function initGridColumns() {
            $scope.lookupCols = [];
            fetch('/lm/highVisibilityComponent/component_schema_form.json')
            .then(function(response) {
                return response.json();})
            .then(function(json) {
                        setColumns(json);
                        $scope.sf = json;
                        if ($scope.sf.schema && $scope.sf.form) {
                            $scope.schema = $scope.sf.schema;
                            $scope.form = $scope.sf.form;
                            readLookups();
                            readDates();
                        }
                        if ($scope.sf.schema || $scope.sf.form) $scope.schemaFound = true;
                        if ($scope.sf.columnDefs) {
                            $scope.viewGridOptions.columnDefs = [];
                            $scope.viewGridOptions.columnDefs.push({
                                displayName: '',
                                field: 'id',
                                width: 34,
                                enableCellEdit: false,
                                enableFiltering: false,
                                enableSorting: false,
                                cellTemplate:
                                '<div class="ui-grid-cell-contents" style="text-align: center">' +
                                '<button ng-click="grid.appScope.viewDetail(row.entity)" class="btn btn-xs btn-primary">' +
                                '<span class="fa fa-search"></span>' +
                                '</button>' +
                                '</div>'
                            });
                            $scope.sf.columnDefs.forEach(function (item) {
                                item.enableFiltering = false;
                                item.filters = [{
                                    type: 'text',
                                    condition: uiGridConstants.filter.CONTAINS,
                                    placeholder: '',
                                    kind: 'string'
                                }];
                                if ($scope.record.lookup[item.field]) {
                                    var prop = $scope.sf.schema.properties[item.field];
                                    item.filters = [{
                                        type: 'lookup',
                                        condition: uiGridConstants.filter.CONTAINS,
                                        placeholder: '',
                                        kind: 'string',
                                        schema: prop,
                                        join: {
                                            column: prop.entity_id,
                                            value: 't.' + prop.title + ' = ' + prop.entity_id + '.id',
                                            relation: 'JOIN',
                                            kind: ''
                                        }
                                    }];
                                    var lookup = $scope.record.lookup[item.field];
                                    lookup.field = item.field;
                                    item.field = item.field + '_obj.model.description';
                                    item.enableSorting = false;
                                    $scope.lookupCols.push(lookup);
                                }
                                else if (isDate(item.field)) {
                                    item.filters = [
                                        {
                                            type: 'date',
                                            relation: '>=',
                                            placeholder: 'da...',
                                            kind: 'date',
                                            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
                                        },
                                        {
                                            type: 'date',
                                            relation: '<=',
                                            placeholder: 'a...',
                                            kind: 'date',
                                            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
                                        }
                                    ];
                                    item.cellTemplate = '<div class="ui-grid-cell-contents">{{ row.entity.' + item.field + ' | date:\'dd/MM/yyyy\' }}</div>'
                                }
                                else if (isBoolean(item.field)) {
                                    var options = [{
                                        value: 'S',
                                        label: 'Sì'
                                    }, {
                                        value: 'N',
                                        label: 'No'
                                    }];
                                    item.filter = {
                                        type: uiGridConstants.filter.SELECT
                                    };
                                    item.editDropdownOptionsArray = options;
                                    item.filter.selectOptions = options.map(function (obj) {
                                        var rObj = { 'value': obj.value, 'label': obj.label };
                                        return rObj;
                                    });
                                    item.cellTemplate = '<div class="ui-grid-cell-contents"><span ng-if="row.entity.' + item.field + '===\'S\'" >Sì</span><span ng-if="row.entity.' + item.field + '!==\'S\'" >No</span></div>'
                                }
                                else if(isEnum(item.field)){
                                    var options = getTitleMap(item.field);
                                    item.filter = { 
                                        type: uiGridConstants.filter.SELECT
                                    };
                                    item.editDropdownOptionsArray = options;
                                    item.filter.selectOptions = options.map(function(obj) { 
                                        var rObj = {'value': obj.value, 'name': obj.label};
                                        return rObj;
                                    });
                                    item.cellTemplate = '<div class="ui-grid-cell-contents">';
                                    options.forEach(function(opt){
                                        item.cellTemplate += '<span ng-if="row.entity.' + item.field + '===\'' + opt.value + '\'" >' + opt.name + '</span>';
                                    });
                                    item.cellTemplate += '</div>';
                                }
                                $scope.viewGridOptions.columnDefs.push(item)
                            });
                        };
                }
            )
        };

        function getTitleMap(field){
            var titleMap = [];
            for(var i=0; i<$scope.form[0].items[0].tabs.length; i++){
                var tab = $scope.form[0].items[0].tabs[i];
                var index = tab.items.findIndex(function(e) { return e.key[0] == field; });
                if(index>=0){
                    if(tab.items[index].titleMap){
                        titleMap = tab.items[index].titleMap;
                    }
                    break;
                }
            }
            return titleMap;
        };

        function isEnum(field){
            var isAnEnum = false;
            if($scope.sf.schema.properties[field]){
                isAnEnum = $scope.sf.schema.properties[field].format==='enum';
            }
            return isAnEnum;
        };

        function isDate(field) {
            var isADate = false;
            for (var i = 0; i < $scope.form[0].items[0].tabs.length; i++) {
                var tab = $scope.form[0].items[0].tabs[i];
                var index = tab.items.findIndex(function (e) { return e.key[0] == field; });
                if (index >= 0) {
                    isADate = (tab.items[index].type === 'datepicker');
                    break;
                }
            }
            return isADate;
        };

        function isBoolean(field) {
            var isABoolean = false;
            for (var i = 0; i < $scope.form[0].items[0].tabs.length; i++) {
                var tab = $scope.form[0].items[0].tabs[i];
                var index = tab.items.findIndex(function (e) { return e.key[0] == field; });
                if (index >= 0) {
                    isABoolean = (tab.items[index].type === 'eggscheckbox');
                    break;
                }
            }
            return isABoolean;
        };

        // [SIX-3374] - La funzione componenti xVersus deve fare vedere solo componenti associati a dipendenti dei reparti a cui l'utente è abilitato.
        function getCustomerDestinationImplicitFilters() {
            var authData = authFactory.getAuthData();
            var filter = authData.filters.customer_destination?authData.filters.customer_destination:[];
            if(filter.length>0){
                dbFilterFactory.changeCustomAlias('e',filter[0],'destination_id');
            }
            return filter;
        }

        $scope.getData = function () {
            var payload = {
                page: $scope.params.pageNumber,
                page_size: $scope.params.pageSize,
                code: $scope.params.code,
                description: $scope.params.description,
                show_revision: false,
                sort_fields: $scope.params.sortFields ? $scope.params.sortFields : undefined,
                sort_order: $scope.params.sortOrder
            };
            var filters = [
                {
                    "column": "product d",
                    "value": "t.product_id = d.id",
                    "relation": "JOIN",
                    "kind": "d.description AS product_desc"
                },
                {
                    "column": "human_resource e",
                    "value": "t.employee_id = e.id",
                    "relation": "JOIN",
                    "kind": "e.destination_id"
                }
            ].concat(dbFilterFactory.getCustomFilter("(t.divcod=" + authFactory.getAuthData().info.divCod +" OR t.divcod is null)"))
             .concat(getCustomerDestinationImplicitFilters())
             .concat($scope.advFilter.list);
            // "mostrare solo componenti in stato spedito reparto o accettato reparto"
            recordFactory('component').filter(payload, filters)
                .$promise.then(function (data) {
                    $scope.viewGridOptions.totalItems = data.totalResults;
                    $scope.list.totalResults = data.totalResults;
                    $scope.list.list = data.list;
                    if ($scope.lookupCols.length > 0) {
                        loadLookupCols();
                    }
                    if ($scope.record.dates.length > 0) {
                        loadDates();
                    }
                });
        };

        $scope.viewDetail = function (value) {
            $location.path('/highVisibility/component/detail/' + value.id);
        };

        function getCustomer(id) {
            recordFactory('customer').byId({ id: id })
                .$promise.then(function (data) {
                    $scope.lookup.customer_id.obj = data;
                    $scope.advFilter.filter.customer_id = id;
                });
        };

        // Se poi ho in GET l'id di uno specifico nosocomio, filtro solo su quello e blocco la selezione di altri ospedali.
        function getCustomerFilter(){
            // Recupero l'elenco delle destinazioni possibili per l'operatore
            var authData = authFactory.getAuthData();
            var customerDestinationQuery = '';
            var currentDestinationQuery = '';
            var customerQuery = ''; // Query da applicare alla lookup sugli ospedali
            var employeeCustomerQuery = ''; // Query da applicare sulle righe della tabella e sulla lookup dei dipendenti
            if(authData && authData.info && authData.info.authorizations){
                authData.info.authorizations.destinations.forEach(function(destinationId){
                    customerDestinationQuery += 'id=' + destinationId + ' OR ';
                    currentDestinationQuery += 'current_destination_id=' + destinationId + ' OR ';
                });
            }
            if(customerDestinationQuery.length>0){
                $scope.lockCustomer = true; // Blocco la lookup sull'ospedale finché non ho caricato il filtro
                customerDestinationQuery = customerDestinationQuery.slice(0,-4);
                customerDestinationQuery = '(' + customerDestinationQuery + ')';
                currentDestinationQuery = currentDestinationQuery.slice(0,-4);
                currentDestinationQuery = '(' + currentDestinationQuery + ')';
                $scope.lookup.current_destination_id.filter = dbFilterFactory.getCustomFilter(customerDestinationQuery);
                $scope.currentDestinationFilter = dbFilterFactory.getCustomFilter(currentDestinationQuery);
                var filter = dbFilterFactory.getCustomFilter(customerDestinationQuery);
                recordFactory('customer_destination').filter({page_size:10000},filter)
                    .$promise.then(function (data){
                        // Ottengo la lista dei distinti nosocomi possibili per l'operatore
                        var list = [];
                        data.list.forEach(function(item){
                            if(list.indexOf(item.customer_id)==-1){
                                list.push(item.customer_id);
                            }
                        });
                        list.forEach(function(customerId){
                            customerQuery += 'id=' + customerId + ' OR ';
                            employeeCustomerQuery += 'c.customer_id=' + customerId + ' OR ';
                        })
                        if(customerQuery.length>0){
                            customerQuery = customerQuery.slice(0,-4);
                            customerQuery = '(' + customerQuery + ')';
                            employeeCustomerQuery = employeeCustomerQuery.slice(0,-4);
                            employeeCustomerQuery = '(' + employeeCustomerQuery + ')';
                            $scope.customerFilter = $scope.customerFilter.concat(dbFilterFactory.getCustomFilter(customerQuery));
                            $scope.employeeCustomerFilter = $scope.employeeCustomerFilter.concat(dbFilterFactory.getCustomFilter(employeeCustomerQuery));
                            $scope.lookup.employee_id.filter = $scope.lookup.employee_id.filter.concat(dbFilterFactory.getCustomFilter(employeeCustomerQuery));
                        }
                        $scope.lockCustomer = false;
                        $scope.applyFilter();
                    });
            }
        };

        function init() {
            initGridColumns();
            // Se l'utente è abilitato solo a certi ospedali, filtro tutti i dati di conseguenza.
            // Se poi ho in GET l'id di uno specifico nosocomio, filtro solo su quello e blocco la selezione di altri ospedali.
            if ($routeParams.customer) {
                $scope.lockCustomer = true;
                $scope.lookup.employee_id.filter = $scope.lookup.employee_id.filter.concat(dbFilterFactory.getNumberFilter('c.customer_id', parseInt($routeParams.customer)));
                getCustomer(parseInt($routeParams.customer));
            }
            else{
                getCustomerFilter();
            }
        };

        //___ main ___
        init();

    });
'use strict';

angular.module('ictportal.theme')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/inventoryreport', {
        templateUrl: 'lm/inventoryReport/inventory-report.html',
        controller: 'InventoryReportCtrl'
      })
  })
  .controller('InventoryReportCtrl', function (APP_URL, $scope, $log, authFactory, $routeParams, recordFactory, eggsFormFactory, dbFilterFactory, $window, $interval, matrixParFactory) {

    $scope.record = {
      lookup: {},
      dates: [],
      model: {}
    };
    $scope.customerFilter = [];
    //$scope.customerImplicitFilter = [];
    $scope.billCustomerFilter = [];
    $scope.wardFilter = [];
    $scope.productFilter = [];
    $scope.kibanaUrl = "";
    $scope.url = "";
    $scope.first = "";
    $scope._g = "";
    $scope._g1 = "";
    $scope._g2 = "";
    $scope._g3 = "";
    $scope._a = "";
    $scope._a1 = "";
    $scope._a2 = "";
    $scope.negate = false;
    $scope.firstFilter = true;
    $scope.dashboard = "";
    $scope.inventoryDash = false;
    $scope.intervalDash = false;
    $scope.intervalFilter = "";
    $scope.partType = undefined
    $scope.customTitle = "";

    $scope.selectedTime = "Tutte";
    $scope.times = ['Tutte', '<5', '<15','<30', '<60', '<90', '<180', '>=180']


    $scope.customerQuery = "";
    $scope.wardQuery = "";
    $scope.productQuery = "";

    $scope.onCustomerChange = function () {
      if ($scope.record.lookup.customer.obj) {
        recordFactory('customer').filter({ page_size: 10000 }, dbFilterFactory.getStringFilter('t.code', $scope.record.lookup.customer.obj.code) ).$promise
          .then(function (data) {
            if(data.totalResults===1){
              $scope.record.model.customer = data.list[0];
              $scope.record.lookup.customer.obj = data.list[0];
              if(data.list[0].bill_to_customer_id){
                recordFactory('customer').filter({page_size: 100}, dbFilterFactory.getCustomFilter("t.id = "+ data.list[0].bill_to_customer_id)).$promise
                  .then(function (b){
                    if(b.totalResults===1){
                      $scope.record.lookup.billCustomer.obj = b.list[0]
                    }
                  })
              }
            }
          })
          .catch(function(ex){});
        $scope.productFilter.length = 0;
        $scope.wardFilter.length = 0;
        $scope.productFilter = [];
        $scope.wardFilter = [];

        if($scope.userDest){
          $scope.wardFilter = $scope.wardFilter.concat(dbFilterFactory.getCustomFilter(
            "id IN ("+$scope.userDest+") " + "AND receiver_type_id in (SELECT id FROM receiver_type WHERE code = 'REP'"+ ($scope.inventoryDash ? " OR code = 'GUA')" : ")") +
            "AND customer_id ="+$scope.record.lookup.customer.obj.id
          ))
        } else {
          $scope.wardFilter = $scope.wardFilter.concat(dbFilterFactory.getCustomFilter(
            "customer_id ="+$scope.record.lookup.customer.obj.id + " AND receiver_type_id in (SELECT id FROM receiver_type WHERE code = 'REP'"+ ($scope.inventoryDash ? " OR code = 'GUA')" : ")")
          ))
        }

        $scope.findValidAgreementProds($scope.record.lookup.customer.obj.id)

      }
      else {
        $scope.record.model.customer = undefined;
        $scope.record.lookup.customer.obj = undefined;
        $scope.productFilter.length = 0;
        $scope.wardFilter.length = 0;
        $scope.productFilter = [];
        $scope.wardFilter = [];

        if($scope.userDest){

          $scope.wardFilter = $scope.wardFilter.concat(dbFilterFactory.getCustomFilter("id IN ("+ $scope.userDest +") " +
            + "AND receiver_type_id in (SELECT id FROM receiver_type WHERE code = 'REP'"+ ($scope.inventoryDash ? " OR code = 'GUA')" : ")") ))
        } else {
          $scope.wardFilter = $scope.wardFilter.concat(dbFilterFactory.getCustomFilter("receiver_type_id in (SELECT id FROM receiver_type WHERE code = 'REP'"+ ($scope.inventoryDash ? " OR code = 'GUA')" : ")")))
        }

        $scope.productFilter = $scope.productFilter.concat(dbFilterFactory.getCustomFilter("parent_product_id is not null"))
      }
      if($scope.partType){
        $scope.productFilter = $scope.productFilter.concat(dbFilterFactory.getCustomFilter("part_type_id IN (SELECT id FROM part_type WHERE code = '"+$scope.partType+"')"));
      }
    }

    $scope.findValidAgreementProds = function(customerId){
      var prods = [];
      var today = new Date();
      if(customerId){
        var filter = dbFilterFactory.getCustomFilter("customer_id = " + customerId + " AND (end_validity_date >= to_date('"+
          today.getFullYear().toString() +"-" + $scope.formatNumber(today.getMonth() + 1)+"-"+$scope.formatNumber(today.getDate())+"', 'yyyy-MM-dd') OR end_validity_date is null)")
        recordFactory('agreement').filter({ page_size: 10000 }, filter ).$promise.then(function (a){
          if(a.list.length > 0){
            a.list.map(function (data){
              recordFactory('agreement_item').filter({page_size: 1000000}, dbFilterFactory.getCustomFilter("agreement_id = " + data.id)).$promise.then(function(ai){
                if(ai.list.length > 0){
                  ai.list.map(function(item){
                    if(prods.indexOf(item.product_id) < 0){
                      prods = prods.concat(item.product_id)
                    }
                  })
                  $scope.productFilter = $scope.productFilter.concat(dbFilterFactory.getCustomFilter("parent_product_id IN (" + prods.join() + ")"))
                }
              })

            })

          }

        })
      }
    }


    $scope.onBillCustomerChange = function () {
      if ($scope.record.lookup.billCustomer.obj) {
        recordFactory('customer').filter({ page_size: 10000 }, dbFilterFactory.getStringFilter('code', $scope.record.lookup.billCustomer.obj.code) ).$promise
          .then(function (data) {
            if(data.totalResults===1){
              $scope.record.model.billCustomer = data.list[0];
              $scope.record.lookup.billCustomer.obj = data.list[0];
            }
          })
          .catch(function(ex){});
        $scope.wardFilter.length = 0;
        $scope.wardFilter = [];
        $scope.customerFilter.length = 0;
        $scope.customerFilter = [];

        if($scope.userDest){

          $scope.wardFilter = $scope.wardFilter.concat(dbFilterFactory.getCustomFilter(
            "receiver_type_id in (SELECT id FROM receiver_type WHERE code = 'REP'"+ ($scope.inventoryDash ? " OR code = 'GUA')" : ")")  +
            "AND id in (" + $scope.userDest + ") " +
            "AND customer_id IN (SELECT id FROM customer WHERE bill_to_customer_id = "+ $scope.record.lookup.billCustomer.obj.id + ")"
          ))
        } else {
          $scope.wardFilter = $scope.wardFilter.concat(dbFilterFactory.getCustomFilter(
            "receiver_type_id in (SELECT id FROM receiver_type WHERE code = 'REP'"+ ($scope.inventoryDash ? " OR code = 'GUA')" : ")") +
            "AND customer_id IN (SELECT id FROM customer WHERE bill_to_customer_id = "+ $scope.record.lookup.billCustomer.obj.id + ")"
          ))
        }
        $scope.customerFilter = $scope.customerFilter.concat(dbFilterFactory.getCustomFilter("bill_to_customer_id = "+ $scope.record.lookup.billCustomer.obj.id))

      }
      else {
        $scope.record.model.billCustomer = undefined;
        //$scope.record.model.ward = undefined;

        $scope.record.lookup.billCustomer.obj = undefined;
        //$scope.record.lookup.ward.obj = undefined;
        $scope.wardFilter.length = 0;
        $scope.wardFilter = [];
        $scope.customerFilter.length = 0;
        $scope.customerFilter = [];
        if($scope.record.lookup.customer.obj){
          $scope.wardFilter = $scope.wardFilter.concat(dbFilterFactory.getCustomFilter("customer_id = "+ $scope.record.lookup.customer.obj.id ))
        }
        if($scope.userDest){
          $scope.wardFilter = $scope.wardFilter.concat(dbFilterFactory.getCustomFilter("id IN ("+ $scope.userDest+")" ))
          $scope.billCustomerFilter = $scope.billCustomerFilter.concat(dbFilterFactory.getCustomFilter("id IN (SELECT bill_to_customer_id FROM customer " +
            "WHERE id IN (SELECT customer_id FROM customer_destination WHERE id IN ("+$scope.userDest+")))"))
        }
      }
    }

    $scope.onWardChange = function () {
      if ($scope.record.lookup.ward.obj) {
        recordFactory('customer_destination').filter({ page_size: 10000 }, dbFilterFactory.getStringFilter('code', $scope.record.lookup.ward.obj.code) ).$promise
          .then(function (data) {
            if(data.totalResults===1){
              $scope.record.model.ward = data.list[0];
              $scope.record.lookup.ward.obj = data.list[0];
              if(data.list[0].customer_id){
                recordFactory('customer').filter({page_size: 1000}, dbFilterFactory.getCustomFilter("t.id = "+data.list[0].customer_id)).$promise
                  .then(function (c){
                    if(c.totalResults === 1 ){
                      $scope.record.model.customer = data.list[0];
                      $scope.record.lookup.customer.obj = c.list[0]
                      $scope.onCustomerChange();
                    }
                  })
              }
            }
          })
          .catch(function(ex){});

      }
      else {
        $scope.record.model.ward = undefined;
        $scope.record.lookup.ward.obj = undefined;
      }
    }

    $scope.billCustomerSelected = function () {
      return !$scope.record.model.billCustomer;
    }

    $scope.customerSelected = function () {
      return !$scope.record.model.customer;
    }

    $scope.resetFilters = function () {
      $scope.record.model.customer = null;
      $scope.record.model.billCustomer = null;
      $scope.record.model.product = undefined;
      $scope.record.model.ward = undefined;
      $scope.record.lookup.customer.obj = {};
      $scope.record.lookup.billCustomer.obj = {};
      $scope.record.lookup.product.obj = {};
      $scope.record.lookup.ward.obj = {};
      $scope.customerFilter.length = 0;
      $scope.customerFilter = [];
      $scope.billCustomerFilter.length = 0;
      $scope.billCustomerFilter = [];
      $scope.wardFilter.length = 0;
      $scope.wardFilter = [];
      initFilters();
      $scope.selectedTime = "Tutte";
      $scope.negate = false;
      $scope.to_date = new Date();
      $scope.to_date = $scope.to_date.addDays(-1);
      $scope.from_date = new Date();
      $scope.from_date.setFullYear($scope.from_date.getFullYear()-2);

      $scope.updateUrl();
    }

    function initFilters(){
      $scope.userDest = authFactory.getAuthData().info.authorizations.destinations.toString();
      //$scope.div = authFactory.getAuthData().info.divCod;
      if($scope.userDest){ //FIXME: messo solo per testare, magari toglierlo prima di buttarlo in produzione
        $scope.customerFilter = $scope.customerFilter.concat(dbFilterFactory.getCustomFilter("id IN (SELECT distinct customer_id FROM customer_destination WHERE id in (" + $scope.userDest +"))") );

        $scope.billCustomerFilter = $scope.billCustomerFilter.concat(dbFilterFactory.getCustomFilter("id IN (SELECT bill_to_customer_id FROM customer " +
          "WHERE id IN (SELECT customer_id FROM customer_destination WHERE id IN ("+$scope.userDest+")))"))
        $scope.wardFilter = $scope.wardFilter.concat(dbFilterFactory.getCustomFilter("id IN ("+ $scope.userDest +")" +
         " AND receiver_type_id in (SELECT id FROM receiver_type WHERE code = 'REP'"+ ($scope.inventoryDash ? " OR code = 'GUA')" : ")")))
      }

      $scope.wardFilter = $scope.wardFilter
        .concat(dbFilterFactory.getCustomFilter("receiver_type_id in (SELECT id FROM receiver_type WHERE code = 'REP'"+ ($scope.inventoryDash ? " OR code = 'GUA')" : ")")));
      $scope.productFilter = $scope.productFilter.concat(dbFilterFactory.getCustomFilter("parent_product_id is not null"));
      if($scope.partType){
        $scope.productFilter = $scope.productFilter.concat(dbFilterFactory.getCustomFilter("part_type_id IN (SELECT id FROM part_type WHERE code = '"+$scope.partType+"')"));
      }
    }

    function initLookups() {
      eggsFormFactory.addLookup($scope.record.lookup, 'customer',  'customer',             'code',     'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'billCustomer',  'customer', 'code',     'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'ward',   'customer_destination', 'code',     'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'product',   'product', 'code',     'description');

      $scope.to_date = new Date();
      $scope.to_date = $scope.to_date.addDays(-1);
      $scope.from_date = new Date();
      $scope.from_date.setFullYear($scope.from_date.getFullYear()-2);

    }

    $scope.stringEncoder = function(value){
      var encoded = value.replace(/</g, "%3C");
      encoded = encoded.replace(/ /g, "%20");
      encoded = encoded.replace(/{/g, "%7B");
      encoded = encoded.replace(/"/g, "%22");
      encoded = encoded.replace(/\[/g, "%5B");
      encoded = encoded.replace(/}/g, "%7D");
      encoded = encoded.replace(/]/g, "%5D");
      return encoded

    }

    $scope.stringDecoder = function(value){
      var encoded = value.replace(/%3C/g, "<");
      encoded = encoded.replace(/%20/g, " ");
      encoded = encoded.replace(/%7B/g, "{");
      encoded = encoded.replace(/%22/g, "\"");
      encoded = encoded.replace(/%5B/g, "[");
      encoded = encoded.replace(/%7D/g, "}");
      encoded = encoded.replace(/%5D/g, "]");
      return encoded

    }

    $scope.encodeFilter = function (field,code,value){
      var formattedValue;
      var formattedCode;
      if(value){
        formattedValue = value.replace(/%/g,"%25");
        formattedValue = formattedValue.replace(/ /g,"%20");
        formattedValue = formattedValue.replace(/\//g, "%2F");
        formattedValue = formattedValue.replace(/'/g, "!'");
        formattedValue = formattedValue.replace(/\+/g, "%2B");

        if(code) {
          formattedCode = code.replace(/%/g, "%25");
          formattedCode = formattedCode.replace(/ /g, "%20");
          formattedCode = formattedCode.replace(/\//g, "%2F");
          formattedCode = formattedCode.replace(/\+/g, "%2B");
        }

         if(field === "current_customer_destination_description" || field === "product_description"){
           formattedValue = formattedCode + "%20-%20" + formattedValue;
         }

        var negateValue = "f";
        if(field === "current_customer_destination_description" && $scope.negate === true){
          negateValue = "t";
        }
        if($scope.firstFilter === true){
          $scope.firstFilter=false;
          return "('$state':(store:globalState),meta:(alias:!n,disabled:!f,index:'39631cc0-5266-11ea-8163-115bb2e6baac',key:"+field+".keyword,negate:!"+negateValue+",params:(query:'"+formattedValue+"'),type:phrase,value:'"+formattedValue+"'),query:(match:("+field+".keyword:(query:'"+formattedValue+"',type:phrase))))"
        } else {
          return ",('$state':(store:globalState),meta:(alias:!n,disabled:!f,index:'39631cc0-5266-11ea-8163-115bb2e6baac',key:"+field+".keyword,negate:!"+negateValue+",params:(query:'"+formattedValue+"'),type:phrase,value:'"+formattedValue+"'),query:(match:("+field+".keyword:(query:'"+formattedValue+"',type:phrase))))"
        }
      } else if (field === "clifatt_code" && code) {
        if(code) {
          formattedCode = code.replace(/%/g, "%25");
          formattedCode = formattedCode.replace(/ /g, "%20");
          formattedCode = formattedCode.replace(/\//g, "%2F");
          formattedCode = formattedCode.replace(/\+/g, "%2B");
        }
        if($scope.firstFilter === true){
          $scope.firstFilter=false;
          return "('$state':(store:globalState),meta:(alias:!n,disabled:!f,index:'39631cc0-5266-11ea-8163-115bb2e6baac',key:"+field+".keyword,negate:!f,params:(query:'"+formattedCode+"'),type:phrase,value:'"+formattedCode+"'),query:(match:("+field+".keyword:(query:'"+formattedCode+"',type:phrase))))"
        } else {
          return ",('$state':(store:globalState),meta:(alias:!n,disabled:!f,index:'39631cc0-5266-11ea-8163-115bb2e6baac',key:"+field+".keyword,negate:!f,params:(query:'"+formattedCode+"'),type:phrase,value:'"+formattedCode+"'),query:(match:("+field+".keyword:(query:'"+formattedCode+"',type:phrase))))"
        }
      } else {
        return "";
      }
    }

    $scope.encodePartType = function (){
      if($scope.firstFilter === true){
        $scope.firstFilter=false;
        return "('$state':(store:globalState),meta:(alias:!n,disabled:!f,index:'39631cc0-5266-11ea-8163-115bb2e6baac',key:part_type_code.keyword,negate:!f,params:(query:'"+$scope.partType+"'),type:phrase,value:'"+$scope.partType+"'),query:(match:(part_type_code.keyword:(query:'"+$scope.partType+"',type:phrase))))"
      } else {
        return ",('$state':(store:globalState),meta:(alias:!n,disabled:!f,index:'39631cc0-5266-11ea-8163-115bb2e6baac',key:part_type_code.keyword,negate:!f,params:(query:'"+$scope.partType+"'),type:phrase,value:'"+$scope.partType+"'),query:(match:(part_type_code.keyword:(query:'"+$scope.partType+"',type:phrase))))"      }
    }

    $scope.encodeTimeFilter = function(value){
      var filter = "";
      if(value === ">=180"){
        filter = "('$state':(store:globalState),meta:(alias:'>= 180',disabled:!f,index:'39631cc0-5266-11ea-8163-115bb2e6baac',key:query,negate:!f,type:custom,value:'{\"bool\":{\"must\":[],\"filter\":[{\"bool\":{\"should\":[{\"range\":{\"days_diff\":{\"gte\":180}}}],\"minimum_should_match\":1}}],\"should\":[],\"must_not\":[]}}'),query:(bool:(filter:!((bool:(minimum_should_match:1,should:!((range:(days_diff:(gte:180))))))),must:!(),must_not:!(),should:!())))"

      } else {
        var timeIndex = $scope.times.indexOf(value);
        var previousTime = $scope.times[timeIndex-1]
        if(previousTime === "Tutte"){
          previousTime = "<0"
        }
        var time = value.substring(1);
        previousTime = previousTime.substring(1);
        filter = "('$state':(store:globalState),meta:(alias:'<"+time+" GG',disabled:!f,index:'39631cc0-5266-11ea-8163-115bb2e6baac',key:query,negate:!f,type:custom,value:'{\"bool\":{\"must\":[],\"filter\":[{\"bool\":{\"filter\":[{\"bool\":{\"should\":[{\"range\":{\"days_diff\":{\"gte\":"+previousTime+"}}}],\"minimum_should_match\":1}},{\"bool\":{\"should\":[{\"range\":{\"days_diff\":{\"lt\":"+time+"}}}],\"minimum_should_match\":1}}]}}],\"should\":[],\"must_not\":[]}}'),query:(bool:(filter:!((bool:(filter:!((bool:(minimum_should_match:1,should:!((range:(days_diff:(gte:"+previousTime+")))))),(bool:(minimum_should_match:1,should:!((range:(days_diff:(lt:"+time+")))))))))),must:!(),must_not:!(),should:!())))"

      }
      filter = $scope.stringEncoder(filter)
      if($scope.firstFilter === false){
        return ","+filter;
      } else {
        return filter;
      }
    }

    $scope.formatNumber = function(n){
      if(n>0 && n<10){
        return "0"+n.toString();
      } else {
        return n.toString();
      }
    }

    $scope.encodeIntervalFilter = function(from_date, to_date){
      if(from_date != null && to_date != null){
        var tmpDate = to_date.addDays(1)
        return "from:'"+from_date.getFullYear().toString()+"-"+$scope.formatNumber(from_date.getMonth()+1)+"-"+$scope.formatNumber(from_date.getDate())+
          "',to:'"+tmpDate.getFullYear().toString()+"-"+$scope.formatNumber(tmpDate.getMonth()+1)+"-"+$scope.formatNumber(tmpDate.getDate())+"'";

      }
    }

    $scope.setDestLookups = function (code, description, isNegated){
      description = description.replace("!", "''")
      var filters = dbFilterFactory.getStringFilter('description', description)
        .concat(dbFilterFactory.getStringFilter('code', code));
      recordFactory('customer_destination').filter({ page_size: 10000 }, filters ).$promise
        .then(function (cd) {
          if(cd.totalResults > 0 ){
            $scope.negate = isNegated;
            $scope.record.model.ward = cd.list[0].id;
            var prevDest = $scope.record.lookup.ward.obj;
            $scope.record.lookup.ward.obj = cd.list[0];
            $scope.record.lookup.ward.obj.model.code = cd.list[0].code;
            $scope.record.lookup.ward.obj.model.description = cd.list[0].description;
            if(!prevDest ||(prevDest.id !== $scope.record.lookup.ward.obj.id)){
              $scope.onWardChange();
            }

          }
        })
        .catch(function(ex){});
    }

    $scope.setProdLookup = function (code, description){
      var filters = dbFilterFactory.getStringFilter('description', description)
        .concat(dbFilterFactory.getStringFilter('code', code))
      recordFactory('product').filter({ page_size: 10000 }, filters ).$promise
        .then(function (data) {
          if(data.totalResults > 0){
            $scope.record.model.product = data.list[0];
            $scope.record.lookup.product.obj = data.list[0];
            $scope.record.lookup.product.obj.model.code = data.list[0].code;
            $scope.record.lookup.product.obj.model.description = data.list[0].description;
          }
        })
        .catch(function(ex){});
    }

    $scope.setCustomerLookup = function (description){
      recordFactory('customer').filter({ page_size: 10000 }, dbFilterFactory.getStringFilter('description', description) ).$promise
        .then(function (data) {
          if(data.totalResults > 0){
            $scope.record.model.customer = data.list[0];
            var prevCust = $scope.record.lookup.customer.obj;
            $scope.record.lookup.customer.obj = data.list[0];
            $scope.record.lookup.customer.obj.model.code = data.list[0].code;
            $scope.record.lookup.customer.obj.model.description = data.list[0].description;
            if(!prevCust ||(prevCust.id !== $scope.record.lookup.customer.obj.id)){
              $scope.onCustomerChange();
            }
          }
        })
        .catch(function(ex){});
    }

    $scope.setBillCustomerLookup = function (code){
      code=code.replace(/'/g, "")
      recordFactory('customer').filter({ page_size: 10000 }, dbFilterFactory.getStringFilter('code', code) ).$promise
        .then(function (data) {
          if(data.totalResults > 0){
            $scope.record.model.billCustomer = data.list[0];
            var prevBill = $scope.record.lookup.billCustomer.obj;
            $scope.record.lookup.billCustomer.obj = data.list[0];
            $scope.record.lookup.billCustomer.obj.model.code = data.list[0].code;
            $scope.record.lookup.billCustomer.obj.model.description = data.list[0].description;
          }
        })
        .catch(function(ex){});
    }

    $scope.setTimeLookup = function(value){
      $scope.selectedTime = value;
    }

    $scope.parseFilters = function (filters) {
      filters.map(function (f){
        var wardFilter = f.split("key:current_customer_destination_description");
        var negateFilter = "";
        var isNegated = false;
        if(wardFilter.length > 1){
          wardFilter = wardFilter[1];
          wardFilter = wardFilter.split(",value:");
          negateFilter = wardFilter[0];
          negateFilter = negateFilter.split("negate:!")
          negateFilter = negateFilter[1].split(",params")
          if(negateFilter[0] === "t"){
            isNegated = true;
          }
          wardFilter = wardFilter[1];
          wardFilter = wardFilter.split("),")[0];
          wardFilter = wardFilter.replace(/'/g, "");
          wardFilter = wardFilter.replace(/%20/g, " ");
          wardFilter = wardFilter.replace(/%2B/g, "+");
          wardFilter = wardFilter.split(" - ");
          var wcode = "";
          var wdesc = "";
          if(wardFilter.length > 2){
            wcode = wardFilter[0];
            wardFilter.splice(0,1);
            wdesc = wardFilter.join(" - ");
          } else {
            wcode = wardFilter[0];
            wdesc = wardFilter[1];
          }


          $scope.setDestLookups(wcode, wdesc, isNegated)
        }

        var prodFilter = f.split("key:product_description");
        if(prodFilter.length > 1){
          prodFilter = prodFilter[1];
          prodFilter = prodFilter.split(",value:'")[1];
          prodFilter = prodFilter.split("'),")[0];
          prodFilter = prodFilter.replace(/%20/g, " ");
          prodFilter = prodFilter.replace(/%2F/g, "/")
          prodFilter = prodFilter.replace(/%25/g, "%")
          prodFilter = prodFilter.replace(/%2B/g, "+")
          prodFilter = prodFilter.split(" - ");
          var pcode = "";
          var pdesc = "";
          if(prodFilter.length > 2){
            pcode = prodFilter[0];
            prodFilter.splice(0,1);
            pdesc = prodFilter.join(" - ");
          } else {
            pcode = prodFilter[0];
            pdesc = prodFilter[1];
          }
          $scope.setProdLookup(pcode, pdesc)
        }

        var customerFilter = f.split("key:customer_description");
        if(customerFilter.length > 1){
          customerFilter = customerFilter[1];
          customerFilter = customerFilter.split(",value:'")[1];
          customerFilter = customerFilter.split("'),")[0];
          var cdesc = customerFilter.replace(/%20/g, " ");
          cdesc = cdesc.replace(/%2F/g, "/")
          cdesc = cdesc.replace(/%25/g, "%")
          cdesc = cdesc.replace(/%2B/g, "+")
          $scope.setCustomerLookup(cdesc)
        }

        var billCustomerFilter = f.split("key:clifatt_code");
        if(billCustomerFilter.length > 1){
          billCustomerFilter = billCustomerFilter[1];
          billCustomerFilter = billCustomerFilter.split(",value:'")[1];
          billCustomerFilter = billCustomerFilter.split("'),")[0];
          var bccode = billCustomerFilter.replace(/%20/g, " ");
          bccode = bccode.replace(/%2F/g, "/")
          bccode = bccode.replace(/%25/g, "%")
          bccode = bccode.replace(/%2B/g, "+")
          $scope.setBillCustomerLookup(bccode)
        }

        var dispersi = f.split("alias:'%3E%3D%20180'");
        if(dispersi.length > 1){
          $scope.setTimeLookup(">=180");
        }

        var time = f.split("alias:'%3C")
        if(time.length>1){
          time = time[1];
          time = time.split("%20GG")[0];
          time = "<"+time
          $scope.setTimeLookup(time);
        }
      })
    }

    $scope.retrieveDate = function(datetime){
      datetime = datetime.split("-")
      if(datetime.length === 3){
        return datetime
      }
    }

    $scope.decodeInterval = function (interval){
      interval = interval.split("',to:'");
      var from = interval[0];
      var to = interval[1];

      if(from && to){
        to = to.substring(0, to.length-1);
        if(to.split("T").length >1){
          to = to.split("T")[0];
          to = $scope.retrieveDate(to);
          $scope.to_date = new Date (parseInt(to[0]), parseInt(to[1])-1, parseInt(to[2]));
        } else {
          to = $scope.retrieveDate(to);
          $scope.to_date = new Date (parseInt(to[0]), parseInt(to[1])-1, parseInt(to[2])-1);
        }

        from = from.split("from:'")[1]
        if(from.split("T").length > 1){
          from = from.split("T")[0];
          from = $scope.retrieveDate(from);
          $scope.from_date = new Date (parseInt(from[0]), parseInt(from[1])-1, parseInt(from[2])+1);
        } else {
          from = $scope.retrieveDate(from);
          $scope.from_date = new Date (parseInt(from[0]), parseInt(from[1])-1, parseInt(from[2]));
        }


      }

    }


    $scope.updateFilters = function (url){
      var _a = url.split("&_a");
      var _g = _a[0];
      _a = _a[1];
      var interval = "";
      _g = _g.split("_g=(")[1];
      if((_g.split("filters:!(")).length === 1){
        _g = "filters:!("+_g;
      }
      _g = _g.substring(0, _g.length-1)
      _g = _g.split(",time:(");
      interval = _g[1];
      interval = interval.substring(0, interval.length-1);
      $scope.decodeInterval(interval);
      _g = _g[0];
      _g = _g.split("),refreshInterval")[0];
      _g = _g.split("filters:!(")[1];
      var filtersPlus = _a.split(",filters:!(")[1]
      var stringfilters = filtersPlus.split("),fullScreenMode:")[0]
      var n = (stringfilters.match(/\$state/g) || []).length;
      if(n>0){ //ho almeno un filtro
        var filters = stringfilters.split(",(")
        if(filters.length > 1){
          filters.map(function(f){
            var index = filters.indexOf(f);
            if(index > 0){
              filters[index] = "(" + filters[index];
            }
          })
        }
        $scope.parseFilters(filters);
      } else {
        var ng = (_g.match(/\$state/g) || []).length;
        if(ng>0){
          var gfilters = _g.split(",(")
          if(gfilters.length > 1){
            gfilters.map(function(f){
              var index = gfilters.indexOf(f);
              if(index > 0){
                gfilters[index] = "(" + gfilters[index];
              }
            })
          }
          $scope.parseFilters(gfilters);
        }
      }

    }

    $scope.updateUrl = function () {
      var newUrl = "";
      $scope.firstFilter = true;
      newUrl = $scope.first + $scope._g1;
      if($scope.record.lookup.customer && $scope.record.lookup.customer.obj){
        newUrl = newUrl + $scope.encodeFilter("customer_description", $scope.record.lookup.customer.obj.code,  $scope.record.lookup.customer.obj.description)
      }
      if($scope.record.lookup.billCustomer && $scope.record.lookup.billCustomer.obj){
        newUrl = newUrl + $scope.encodeFilter("clifatt_code", $scope.record.lookup.billCustomer.obj.code,  null)
      }
      if($scope.record.lookup.ward && $scope.record.lookup.ward.obj){
        newUrl = newUrl + $scope.encodeFilter("current_customer_destination_description", $scope.record.lookup.ward.obj.code, $scope.record.lookup.ward.obj.description)
      }
      if($scope.record.lookup.product && $scope.record.lookup.product.obj){
        newUrl = newUrl + $scope.encodeFilter("product_description",  $scope.record.lookup.product.obj.code, $scope.record.lookup.product.obj.description)
      }
      if($scope.partType){
        newUrl = newUrl + $scope.encodePartType();
      }

      if($scope.selectedTime !== "Tutte" && $scope.times.indexOf($scope.selectedTime)>0){
        newUrl = newUrl + $scope.encodeTimeFilter($scope.selectedTime)
      }
      newUrl = newUrl + $scope._g2;

      if($scope.intervalDash){
        newUrl = newUrl + $scope.encodeIntervalFilter($scope.from_date, $scope.to_date);
      }

      newUrl = newUrl + $scope._a1 +  $scope._a2;

      $window.frames[0].location.href = newUrl;
    }

    $scope.initializeFixed = function (url) {
      var splitted = url.split("&_g=(");
      $scope.first = splitted[0];
      $scope.dashboard = $scope.first.split("dashboard/")[1];
      $scope.dashboard = $scope.dashboard.split("?")[0];
      var left = "&_g=(filters:!(),"+splitted[1];
      splitted = left.split("))&_a");
      $scope._g = splitted[0];
      $scope._a = "))&_a"+splitted[1];
      var _gSplitted = $scope._g.split("filters:!(");
      $scope._g1=_gSplitted[0]+"filters:!(";
      $scope._g2=_gSplitted[1];
      $scope._g3 = $scope._g2.split("time:(");
      $scope._g2 = $scope._g3[0]+"time:("
      $scope.intervalFilter = $scope._g3[1];
      var _aSplitted = $scope._a.split("filters:!(")
      $scope._a1 = _aSplitted[0]+"filters:!(";
      $scope._a2 = _aSplitted[1];
      $scope.initializedFixedValues = true;
      $scope.updateUrl();
    }

    $scope.setDashboardVariables = function(){
      var controls = parseInt($routeParams.controls)
      if(controls === 1){
        $scope.inventoryDash = true;
      } else if (controls === 2){
        $scope.intervalDash = true;
      } else {
        $scope.inventoryDash = true;
      }
      if($routeParams.parttype){
        $scope.partType=$routeParams.parttype
      }

      if($routeParams.title){
        $scope.customTitle = $routeParams.title
      } else {
        if(controls === 1 ){
          matrixParFactory.getValueOrDefault({key: 'inventoryReport.dashboard1', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'},
            {defaultValue: "Report Inventario Default 1"}).$promise.then(function (data){
            $scope.customTitle = data.result.value;
          })
        }

        if(controls === 2 ){
          matrixParFactory.getValueOrDefault({key: 'inventoryReport.dashboard2', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'},
            {defaultValue: "Report Inventario Default 2"}).$promise.then(function (data){
            $scope.customTitle = data.result.value;
          })
        }
      }
    }


    $interval(function (){
      $scope.kibanaUrl = $window.frames[0].location.href;
    },2000)

    $scope.$watch('kibanaUrl', function (newValue, oldValue){
      if(oldValue !== newValue){
        if($scope.first !== "" && newValue.toString().split("&_a").length > 1 && $scope.initializedFixedValues){
          $scope.updateFilters(newValue)
        }
        if($scope.first === "" && newValue.toString().split("&_a").length > 1 && !$scope.initializedFixedValues){
          $scope.initializeFixed(newValue);
        }


      }
    })

    $scope.$watchGroup([
      'record.lookup.customer.obj',
      'record.lookup.billCustomer.obj',
      'record.lookup.ward.obj',
      'record.lookup.product.obj',
      'negate',
      'selectedTime',
      'from_date',
      'to_date'
    ], function () {
      if($scope.first !== ""){
        $scope.updateUrl();
      }
    });


    $scope.getKibanaURL = function () {
      if (authFactory.getAuthData() == null)
      {
        console.log('auth data null');
        return '';
      }
      $scope.url = $routeParams.url;
      return $scope.url
    };

    function init(){
      $scope.setDashboardVariables()
      initFilters();
      initLookups();
      $scope.initializedFixedValues = false;

    }

    init();

  });


/**
 * @ngdoc function
 * @name ictportal.lm:LockerProductAssociation
 * @description Creazione/modifica anagrafica dotazione armadietti
 */
angular.module('ictportal.lm')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/lm/locker/products', {
        templateUrl: 'lm/lockerProductAssociation/lockerProductAssociation.html',
        controller: 'LockerProductAssociationCtrl'
      })
  })
  .controller('LockerProductAssociationCtrl', function ($scope, localeFactory, dbFilterFactory, $q, zucchettiFactory, toaster, eggsFormFactory, recordFactory, $log, matrixParFactory) {

    var CONTROL_REASON_GROUP_MATRIX_PAR = 'sixZucchettiArmToSync';
    var CONTROL_REASON_GROUP = ['ARMPULITO', 'ARMZOC'];
    $scope.quantity;
    $scope.currentId = null;
    $scope.enableSave = false;
    $scope.disableSize = true;
    $scope.sizeFilter = dbFilterFactory.getCustomFilter("t.size_type_id is not null");
    var pageBundle = 'locker_stock';
    var msg = {};
    var page_msg = {
      "product_code": "Product code",
      "product_description": "Product description",
      "size_label": "Size",
      "product_label": "Product",
      "count": "Quantity",
      "no_unicode_found": "Locker does not contain anything",
      "total_amount": "Total"
    };

    $scope.record = {
      lookup: {},
      model: {}
    };

    $scope.viewGridOptions = {
      appScopeProvider: $scope,
      enableFiltering: true,
      columnDefs: [],
      data: [],
      paginationPageSize: 15,
      enableGridMenu: true,
      exporterMenuPdf: true,
      exporterMenuAllData: true,
      exporterPdfDefaultStyle: {fontSize: 9},
      exporterPdfTableStyle: {margin: [-20, 0, 0, 0]},
      exporterPdfTableHeaderStyle: {fontSize: 10, bold: true, italics: true, color: 'red'},
      exporterPdfHeader: { text: "Dotazione Armadio ", style: 'headerStyle' },
      exporterPdfCustomFormatter: function ( docDefinition ) {
        docDefinition.styles.headerStyle = { fontSize: 18, alignment: 'center', bold: true };
        return docDefinition;
      }
    };

    function initGridColumns() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        field: 'codice_articolo',
        translation: 'product_code'
      });
      $scope.viewGridOptions.columnDefs.push({
        field: 'descrizione_articolo',
        translation: 'product_description'
      });
      $scope.viewGridOptions.columnDefs.push({
        field: 'taglia',
        translation: 'size_label'
      });
      $scope.viewGridOptions.columnDefs.push({
        field: "dotazione",
        translation: 'total_amount',
        enableFiltering: false
      })
      $scope.viewGridOptions.columnDefs.push({
        name: '',
        field: ' ',
        width: 50,
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
          '<div class=row" style="text-align: center">' +
          '<button ng-click="grid.appScope.delete(row.entity)" class="btn btn-xs btn-danger"><span class="fa fa-trash"></span></button>&nbsp;&nbsp;&nbsp;' +
          '</div>'
      });
    }

    function initLookups() {
      eggsFormFactory.addLookup($scope.record.lookup, 'control_reason_id', 'control_reason', 't.code', 't.description');
      eggsFormFactory.addLookup($scope.record.lookup, 'product_id', 'product', 't.code', 't.description');
      eggsFormFactory.addLookup($scope.record.lookup, 'size_id', 'tab_size', 't.code', 't.description');
    }

    $scope.getData = function (){
        $scope.viewGridOptions.data.length = 0;
        var gridFilter = [{
          "column": "tab_size ts",
          "value": "t.size_id = ts.id",
          "relation": "JOIN",
          "kind": "ts.description as taglia"
        },
          {
            "column": "product p",
            "value": "t.product_id = p.id",
            "relation": "JOIN",
            "kind": "p.code as codice_articolo, p.description as descrizione_articolo"
          }].concat(dbFilterFactory.getCustomFilter("t.locker_id = "+ $scope.record.lookup.control_reason_id.obj.id));
        recordFactory('locker_product').filter({page_size: 10000}, gridFilter).$promise.then(function (response) {
          if(response && response.list && response.list.length > 0){
            var entries = [];
            response.list.map(function(e){
              var entry = {
                codice_articolo : e.codice_articolo,
                descrizione_articolo : e.descrizione_articolo,
                taglia : e.taglia,
                dotazione : e.quantity
              }
              entries = entries.concat(entry)
            })
            $scope.viewGridOptions.data = $scope.viewGridOptions.data.concat(entries);
            $scope.viewGridOptions.exporterPdfHeader.text = $scope.record.lookup.control_reason_id.obj.code + " - "+$scope.record.lookup.control_reason_id.obj.description;
          }
        })
      }

    $scope.$watchGroup(['record.lookup.control_reason_id.obj', 'record.lookup.product_id.obj', 'record.lookup.size_id.obj'], function () {
      if($scope.record.lookup.control_reason_id.obj && $scope.record.lookup.product_id.obj && $scope.record.lookup.size_id.obj){
        var lockerproductfilter = dbFilterFactory.getCustomFilter("t.locker_id = " + $scope.record.lookup.control_reason_id.obj.id);
        lockerproductfilter = lockerproductfilter.concat(dbFilterFactory.getCustomFilter("t.product_id = " + $scope.record.lookup.product_id.obj.id));
        lockerproductfilter = lockerproductfilter.concat(dbFilterFactory.getCustomFilter("t.size_id = " + $scope.record.lookup.size_id.obj.id));
        recordFactory('locker_product').filter({page_size: 10000}, lockerproductfilter).$promise.then(function (response) {
          if(response && response.list && response.list.length > 0){
            $scope.quantity = response.list[0].quantity;
            $scope.currentId = response.list[0].id;
            $scope.enableSave = true;
          } else {
            $scope.quantity = 0;
            $scope.currentId = null;
            $scope.enableSave = true;
          }
        })
      } else {
        $scope.enableSave = false;
      }

      if($scope.record.lookup.product_id.obj){
        $scope.sizeFilter = dbFilterFactory.getCustomFilter("t.size_type_id = "+ $scope.record.lookup.product_id.obj.size_type_id)
        $scope.disableSize = false;
      } else {
        $scope.sizeFilter = dbFilterFactory.getCustomFilter("t.size_type_id is not null");
        $scope.disableSize = true;
      }

      if($scope.record.lookup.control_reason_id.obj){
        $scope.getData();
      } else {
        $scope.viewGridOptions.data.length = 0;
      }
    })

    $scope.$watch('quantity', function (){
      $scope.checkSave();
    })

    $scope.delete = function (entity){
      var delFilter = [
        {
          "column": "tab_size ts",
          "value": "t.size_id = ts.id",
          "relation": "JOIN"
        },{
          "column": "product p",
          "value": "t.product_id = p.id",
          "relation": "JOIN"
        }
      ]
      delFilter = delFilter.concat(dbFilterFactory.getCustomFilter("p.code = '"+entity.codice_articolo+"'"))
      delFilter = delFilter.concat(dbFilterFactory.getCustomFilter("ts.code = '"+entity.taglia+"'"))
      delFilter = delFilter.concat(dbFilterFactory.getCustomFilter("t.locker_id = "+$scope.record.lookup.control_reason_id.obj.id))
      recordFactory('locker_product').filter(delFilter).$promise.then(function (data){
        if(data.list && data.list.length > 0){
          recordFactory('locker_product').delete({id: data.list[0].id}).$promise.then( function (r) {
            if(r.result === 1){
              toaster.pop('success','Associazione cancellata','Operazione completata con successo');
            }
            else{
              toaster.pop('Error','Eliminazione fallita','Si è verificato un errore');
            }
            $scope.getData();
          });
        } else {
          toaster.pop('Error','Eliminazione fallita','Associazione da rimuovere non trovata');
        }
      })

    }

    $scope.save = function (){
      if($scope.currentId == null){
        var payload_new = {
          "locker_id": $scope.record.lookup.control_reason_id.obj.id,
          "product_id": $scope.record.lookup.product_id.obj.id,
          "size_id": $scope.record.lookup.size_id.obj ? $scope.record.lookup.size_id.obj.id : null,
          "quantity": $scope.quantity
        }
        recordFactory('locker_product').create(payload_new).$promise.then(function (res){
          if (res.id) {
            toaster.pop('success', 'Associazione armadio-prodotto creata')
            console.log(res);
            $scope.getData();
          } else {
            toaster.pop('error', 'Errore nella creazione dell associazione');
          }
        });
      } else {
        var payload_update = {
          "quantity": $scope.quantity
        }
        recordFactory('locker_product').update({id: $scope.currentId}, payload_update).$promise.then(function (res) {
          if(!res){
            toaster.pop('error', 'Errore nell aggiornamento dell associazione');
          } else {
            toaster.pop('success', 'Associazione armadio-prodotto aggiornata');
            $scope.getData();
          }
        })
      }
    }

    $scope.checkSave = function (){
      $scope.enableSave =  ($scope.record.lookup.control_reason_id.obj && $scope.record.lookup.product_id.obj && $scope.record.lookup.size_id.obj && $scope.quantity > 0 )
    }

    function initControlReasonFilter() {
      // recupero Gruppi Causale ammessi da MatrixPar
      var body = [{
        "column": "code",
        "value": "SELECT regexp_split_to_table(encode(lo_get(mpa.value::INT), 'escape'), ',') AS code FROM matrix_par_appl mpa WHERE matrix_key = '" + CONTROL_REASON_GROUP_MATRIX_PAR + "'",
        "relation": "=",
        "kind": "in"
      }];
      recordFactory('control_reason_group').filter({page_size: 10000}, body).$promise.then(function (response) {
        if (response && response.list && response.list.length > 0) {
          CONTROL_REASON_GROUP = response.list.map(function (e) {
            return e.code;
          });
          $log.info('Control reason group allowed: ' + CONTROL_REASON_GROUP);
          $scope.controlReasonFilter = [{
            "column": "control_reason_group g",
            "value": "t.control_reason_group = g.id",
            "relation": "JOIN"
          }].concat(dbFilterFactory.getInFilter('g.code', CONTROL_REASON_GROUP));
        }
      });
    }

    function initProductFilter(){
      $scope.productFilter = [];
      matrixParFactory.getValueOrDefault({key: 'zucchettiProductCodes', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'},
        {defaultValue: ""}).$promise.then(function(data){
          if(data.result && data.result.value && data.result.value !== ""){
            var resArray = data.result.value.split(",");
            var formattedCodes = "";
            resArray.map(function(c){
              formattedCodes = formattedCodes + "'" + c + "',";
            })
            formattedCodes = formattedCodes.slice(0,-1);
            $scope.productFilter = $scope.productFilter.concat(dbFilterFactory.getCustomFilter("t.code IN ("+ formattedCodes + ")"))
          } else {
            matrixParFactory.getValueOrDefault({key: 'productTypeGeneric', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'},
              {defaultValue: "13"}).$promise.then(function(data){
              if(data.result){
                $scope.productFilter = [{
                  "column": "product_type pt",
                  "value": "t.product_type_id = pt.id",
                  "relation": "JOIN"
                }].concat(dbFilterFactory.getStringFilter('pt.code', data.result.value));
              }
            })
          }

      })

    }

    function translateGridColumns() {
      $scope.viewGridOptions.columnDefs.forEach(function (col) {
        if (col.translation) {
          col.name = page_msg[col.translation];
          col.displayName = page_msg[col.translation];
        }
      });
    }

    function init() {
      localeFactory.loadTranslation(pageBundle)
        .then(function(){
          $q.all({
            general: localeFactory.translateMsg(msg),
            specific: localeFactory.translateMsg(page_msg, pageBundle)
          }).then(function(){
            initGridColumns();
            translateGridColumns();
            initControlReasonFilter();
            initProductFilter();
            initLookups();
          })
        })
        .catch(function(ex){});
    }

    init();

  });

/**
 * @ngdoc function
 * @name ictportal.lm:LockerStockCtrl
 * @description Integrazione con armadietti intelligenti Pacifico
 * @author Rita Beltrami
 *
 * created on 23/01/2019
 * # LockerStockCtrl
 * Controller of the ictportal.lm
 */
angular.module('ictportal.lm')
  .config(function ($routeProvider) {
      $routeProvider
      .when('/lm/locker/stock', {
        templateUrl: 'lm/lockerStock/lockerStock.html',
        controller: 'LockerStockCtrl'
      })
  })
  .controller('LockerStockCtrl', function ($scope, localeFactory, dbFilterFactory, $q, zucchettiFactory, toaster, eggsFormFactory, recordFactory, $log) {

    var CONTROL_REASON_GROUP_MATRIX_PAR = 'sixZucchettiArmToSync';
    var CONTROL_REASON_GROUP = ['ARMPULITO', 'ARMZOC'];
    var CONTROL_REASON_CODE_PREFIX = 'ARM_';
    var pageBundle = 'locker_stock';
    var msg = {};
    var page_msg = {
      "product_code": "Product code",
      "product_description": "Product description",
      "product_size": "Product size",
      "count": "Quantity",
      "no_unicode_found": "Locker does not contain anything",
      "total_amount": "Total",
      "diff": "Difference"
    };
    $scope.unknownList = [];
    $scope.record = {
      lookup: {},
      model: {}
    };
    $scope.viewGridOptions = {
      appScopeProvider: $scope,
      enableFiltering: true,
      columnDefs: [],
      data: [],
      paginationPageSize: 15,
      enableGridMenu: true,
      exporterMenuPdf: true,
      exporterMenuAllData: true,
      exporterPdfDefaultStyle: {fontSize: 9},
      exporterPdfTableStyle: {margin: [-20, 0, 0, 0]},
      exporterPdfTableHeaderStyle: {fontSize: 10, bold: true, italics: true, color: 'red'},
      exporterPdfHeader: { text: "Giacenza Armadio", style: 'headerStyle' },
      exporterPdfCustomFormatter: function ( docDefinition ) {
        docDefinition.styles.headerStyle = { fontSize: 18, alignment: 'center', bold: true };
        return docDefinition;
      }
    };

    function initGridColumns() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
          field: 'codice_articolo',
          translation: 'product_code'
      });
      $scope.viewGridOptions.columnDefs.push({
        field: 'descrizione_articolo',
        translation: 'product_description'
      });
      $scope.viewGridOptions.columnDefs.push({
        field: 'taglia',
        translation: 'product_size'
      });
      $scope.viewGridOptions.columnDefs.push({
          field: "giacenza",
          translation: 'count',
          enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
          field: "dotazione",
          translation: 'total_amount',
          enableFiltering: false
      })
      $scope.viewGridOptions.columnDefs.push({
        field: "differenza",
        translation: 'diff',
        enableFiltering: false
      })
  };

    function initLookups() {
      eggsFormFactory.addLookup($scope.record.lookup, 'control_reason_id', 'control_reason', 't.code', 't.description');
    }

    $scope.$watch('record.lookup.control_reason_id.obj', function (newValue) {
      $scope.viewGridOptions.data.length = 0;
      $scope.unknownList.length = 0;
      if (newValue) {
        // Non ho ben capito come abbiano deciso di mappare gli armadietti in Pacifico...
        var nodeId = $scope.record.lookup.control_reason_id.obj.code.substring( (CONTROL_REASON_CODE_PREFIX.length), ($scope.record.lookup.control_reason_id.obj.code.length) );
        if(nodeId=="") {
            nodeId = $scope.record.lookup.control_reason_id.obj.code;
        }
        zucchettiFactory().getLockerStock({ node: nodeId }).$promise
          .then(function (resp) {
            if(resp.result==='Ok'){
              var entries = [];
              resp.data.content.map(function(e){
                var entry = {
                  codice_articolo : e.code,
                  descrizione_articolo: e.description,
                  taglia : e.size,
                  giacenza : e.count,
                  dotazione : e.total
                }
                entries = entries.concat(entry)
              })
              $scope.viewGridOptions.data = $scope.viewGridOptions.data.concat(entries);
              $scope.unknownList = $scope.unknownList.concat(resp.data.unknown);
              $scope.viewGridOptions.data.map(function (e){
                 e.differenza = e.dotazione - e.giacenza;
               })
              $scope.viewGridOptions.paginationPageSize = $scope.viewGridOptions.data.length
              $scope.viewGridOptions.exporterPdfHeader.text = $scope.record.lookup.control_reason_id.obj.code + " - "+$scope.record.lookup.control_reason_id.obj.description;
              if($scope.viewGridOptions.data.length==0 && $scope.unknownList.length==0) {
                toaster.pop('warning', page_msg.no_unicode_found);
              }
            }
          })
          .catch(function(ex){});
        // PER TEST LOCALE
        // var c = [{"codice_articolo": "SOR000008", "descrizione_articolo" : "CASACCA COLLO V SCIALLATO", "taglia": "M", "giacenza": "7", "dotazione": "10"},
        //   {"codice_articolo": "SOR000008", "descrizione_articolo" : "CASACCA COLLO V SCIALLATO", "taglia": "S", "giacenza": "9", "dotazione": "11"},
        //   {"codice_articolo": "SOR000008", "descrizione_articolo" : "CASACCA COLLO V SCIALLATO", "taglia": "XXL", "giacenza": "10", "dotazione": "12"}]
        // $scope.viewGridOptions.data = $scope.viewGridOptions.data.concat(c);
        // $scope.viewGridOptions.paginationPageSize = $scope.viewGridOptions.data.length
        //
        // $scope.viewGridOptions.data.map(function (e){
        //   e.differenza = e.dotazione - e.giacenza;
        // })
      }
    })

    function initControlReasonFilter() {
      // recupero Gruppi Causale ammessi da MatrixPar
      var body = [{
        "column": "code",
        "value": "SELECT regexp_split_to_table(encode(lo_get(mpa.value::INT), 'escape'), ',') AS code FROM matrix_par_appl mpa WHERE matrix_key = '" + CONTROL_REASON_GROUP_MATRIX_PAR + "'",
        "relation": "=",
        "kind": "in"
      }];
      recordFactory('control_reason_group').filter({page_size: 10000}, body).$promise.then(function (response) {
        if (response && response.list && response.list.length > 0) {
          CONTROL_REASON_GROUP = response.list.map(function (e) {
            return e.code;
          });
          $log.info('Control reason group allowed: ' + CONTROL_REASON_GROUP);
          $scope.controlReasonFilter = [{
            "column": "control_reason_group g",
            "value": "t.control_reason_group = g.id",
            "relation": "JOIN",
            "kind": "g.id"
          }].concat(dbFilterFactory.getInFilter('g.code', CONTROL_REASON_GROUP));
        }
      });
    }

    function translateGridColumns() {
      $scope.viewGridOptions.columnDefs.forEach(function (col) {
          if (col.translation) {
            col.name = page_msg[col.translation];
            col.displayName = page_msg[col.translation];
          }
      });
    }

    function init() {
      localeFactory.loadTranslation(pageBundle)
        .then(function(){
          $q.all({
              general: localeFactory.translateMsg(msg),
              specific: localeFactory.translateMsg(page_msg, pageBundle)
          })
          .then(function(){
            initGridColumns();
            translateGridColumns();
          })
          .catch(function(ex){});
        })
        .catch(function(ex){});
      initControlReasonFilter();
      initLookups();
    }

    init();

  });

'use strict';

angular.module('ictportal.tnt')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/lm/magazzino/giacenza', {
        templateUrl: 'lm/magazzino/vis-giacenza.html',
        controller: 'VisGiacenzaCtrl'
      })
  })
  .controller('VisGiacenzaCtrl',function($scope, $timeout, $routeParams, $location, $filter, localeFactory, recordFactory, eggsFormFactory, dbFilterFactory, authFactory, matrixParFactory){

    $scope.preselectSupplier = false;
    $scope.viewGridOptions = {
      enableRowSelection: true,
      enableFullRowSelection: true,
      exporterMenuPdf: true,
      exporterPdfDefaultStyle: {fontSize: 9},
      exporterPdfTableStyle: {margin: [-20, 0, 0, 0]},
      exporterPdfTableHeaderStyle: {fontSize: 10, bold: true, italics: true, color: 'red'},
      exporterPdfHeader: { text: "Giacenze Magazzino", style: 'headerStyle' },
      exporterPdfCustomFormatter: function ( docDefinition ) {
        docDefinition.styles.headerStyle = { fontSize: 18, alignment: 'center', bold: true };
        return docDefinition;
      },
      enableFiltering: false,
      useExternalSorting: true,
      appScopeProvider: $scope,
      columnDefs: [
        {
        field: 'facility_description',
        displayName: 'Magazzino',
        headerCellFilter: 'translate',
          cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.facility_code}} - {{row.entity.facility_description}}</div>',
        width: '*'
      },{
        field: 'product_code',
        displayName: 'Codice Articolo',
        headerCellFilter: 'translate',
          width: 150
      },{
          field: 'product_description',
          displayName: 'Descrizione Articolo',
          headerCellFilter: 'translate',
          width: '**'
        },{
        field: 'count',
        displayName: 'Giacenza',
        width: 100
      }]
    };

    $scope.filters = {};
    $scope.aggs = [];

    $scope.aggregations =[
      {
        key: 'customer',
        description: 'Cliente',
        fields: ['c.code AS customer_code', 'c.description AS customer_description'],
        columns: [{
          field: 'customer_description',
          displayName: 'Cliente',
          headerCellFilter: 'translate'
        }]
      },{
        key: 'destination',
        description: 'Destinazione',
        fields: ['cd.code AS destination_code', 'cd.description AS destination_description'],
        columns: [{
          field: 'destination_code',
          displayName: 'Destinazione',
          headerCellFilter: 'translate'
        }]
      },{
        key: 'lot',
        description: 'Lotti',
        fields: ['l.code AS lot_code', 'l.description AS lot_description'],
        columns: [{
          field: 'lot_description',
          displayName: 'Lotti',
          headerCellFilter: 'translate'
        }]
      },{
        key: 'supplier',
        description: 'Fornitore',
        fields: ['s.code AS supplier_code', 's.description AS supplier_description'],
        columns: [{
          field: 'supplier_description',
          displayName: 'Fornitore',
          headerCellFilter: 'translate'
        }]
      },{
        key: 'color',
        description: 'Colore',
        fields: ['co.code AS color_code', 'co.description AS color_description'],
        columns: [{
          field: 'color_description',
          displayName: 'Colore',
          headerCellFilter: 'translate'
        }]
      },{
        key: 'size',
        description: 'Taglia',
        fields: ['si.code AS size_code', 'si.description AS size_description'],
        columns: [{
          field: 'size_description',
          displayName: 'Taglia',
          headerCellFilter: 'translate'
        }]
      }
    ];
    $scope.mainFilters = [
      {
        column: 'facility f',
        value: 't.facility_id = f.id',
        relation: 'LEFT JOIN'
      },{
        column: 'customer_destination cd',
        value: 'cd.id = t.destination_id',
        relation: 'LEFT JOIN',

      },{
        column: 'product p',
        value: 't.product_id = p.id',
        relation: 'LEFT JOIN',

      },{
        column: 'part_type pt',
        value: 'p.part_type_id = pt.id',
        relation: 'LEFT JOIN',

      },{
        column: 'supplier s',
        value: 't.supplier_id = s.id',
        relation: 'LEFT JOIN',

      },{
        column: 'customer c',
        value: 'cd.customer_id = c.id',
        relation: 'LEFT JOIN',

      },{
        column: 'inventory_item_detail iid',
        value: 'iid.inventory_item_id = t.id',
        relation: 'LEFT JOIN',

      },{
        column: 'color co',
        value: 'iid.color_id = co.id',
        relation: 'LEFT JOIN',

      },{
        column: 'tab_size si',
        value: 'iid.size_id = si.id',
        relation: 'LEFT JOIN',

      },{
        column: 'lot l',
        value: 't.lot_id = l.id',
        relation: 'LEFT JOIN',

      }
    ];
    $scope.supplierFilters = [];

    $scope.getData = function(params) {
      console.log('Loading grid', params);
      var filters = $scope.mainFilters
        .concat(buildAggs()).concat(buildFilters($scope.filters));

      var queryParameters = buildQueryParameters($scope.viewGridOptions, params);
      var f = {
        filters: filters,
        fields: ['f.code AS facility_code', 'f.description AS facility_description', 'p.code AS product_code', 'p.description AS product_description'].concat(buildFields()),
        operations:[{
          function: 'sum',
          argument: 'coalesce(iid.quantity_on_hand_diff, 0)',
          alias: 'count'
        }]
      }
      recordFactory('inventory_item').aggregation(queryParameters, f)
        .$promise.then(function (data) {
        $scope.viewGridOptions.totalItems = data.totalResults;
        $scope.viewGridOptions.data = data.list;
      });
    };

    $scope.aggsRequestChanged = function(){
      $scope.viewGridOptions.gridApi.pagination.seek(1);
      $timeout(function(){
        setGridColumns();
        $scope.requestChanged();
      }, 50);
    }

    var bufferedRequest;
    $scope.requestChanged = function(params){
      $scope.selectedRow = null;
      if (bufferedRequest) $timeout.cancel(bufferedRequest);
      if (params){
        bufferedRequest = $timeout($scope.getData, 500, true, params);
      } else {
        bufferedRequest = $timeout($scope.getData, 500);
      }
    };


    function buildQueryParameters(grid, params) {
      if (params) {
        var queryParameters = {
          page: params.pageNumber,
          page_size: params.pageSize,
          sort_fields: params.sortFields,
          sort_order: params.sortOrder
        };
        if (angular.isString(queryParameters.sort_fields) && queryParameters.sort_fields.length === 0) {
          delete queryParameters.sort_fields;
        }
        if (angular.isString(queryParameters.sort_order) && queryParameters.sort_order.length === 0) {
          delete queryParameters.sort_order;
        }
        return queryParameters;
      }
      var gridApi = grid.gridApi,
        sorting = (gridApi.grid.getColumnSorting() || []).pop() || {};
      return {
        page: gridApi.pagination.getPage(),
        page_size: grid.paginationPageSize,
        sort_fields: sorting.field,
        sort_order: (sorting.sort && sorting.sort.direction)
      };

    }

    function setGridColumns() {
      var aggsCol = [];
      angular.forEach($scope.aggs, function(value) {
        this.push.apply(this, value.columns || []);
      }, aggsCol);
      Array.prototype.splice.apply($scope.viewGridOptions.columnDefs, [3, $scope.viewGridOptions.columnDefs.length - 4].concat(aggsCol));
    };

    function buildAggs() {
      var joins = [];
      angular.forEach($scope.aggs, function(value) {
        this.push.apply(this, value.joins || []);
      }, joins);
      return joins;
    };

    function buildFields() {
      var fields = [];
      angular.forEach($scope.aggs, function(value) {
        this.push.apply(this, value.fields || []);
      }, fields);
      return fields;
    };

    function buildFilters(filterObj) {
      var filters = [];
      angular.forEach(filterObj, function(value, key) {
        if (!value) return;
        switch (key) {
          case 'toDate':
            this.push.apply(this, dbFilterFactory.getDateFilter('iid.effective_date', value, '<='));
            break;
          case 'facility':
            this.push.apply(this, dbFilterFactory.getNumberFilter('t.facility_id', value));
            break;
          case 'destination':
            this.push.apply(this, dbFilterFactory.getNumberFilter('t.destination_id', value));
            break;
          case 'supplier':
            this.push.apply(this, dbFilterFactory.getNumberFilter('t.supplier_id', value));
            break;
          case 'product':
            this.push.apply(this, dbFilterFactory.getNumberFilter('t.product_id', value));
            break;
          case 'customer':
            this.push.apply(this, dbFilterFactory.getNumberFilter('c.id', value));
            break;
          case 'lot':
            this.push.apply(this, dbFilterFactory.getNumberFilter('t.lot_id', value));
            break;
          case 'color':
            this.push.apply(this, dbFilterFactory.getNumberFilter('iid.color_id', value));
            break;
          case 'size':
            this.push.apply(this, dbFilterFactory.getNumberFilter('iid.size_id', value));
            break;
          case 'partType':
            this.push.apply(this, dbFilterFactory.getNumberFilter('p.part_type_id', value));
            break;
          default:
            console.debug('Unknown filter ',key,value);
            break;
        }
      }, filters);
      return filters;
    };


    // function checkPermissions() {
    //   var profilingKey = 'TNT_WAREHOUSE_STORAGE_FUNCTION';
    //   var permission = authFactory.getPermissions(profilingKey);
    //   if(!permission.EXEC) {
    //     $location.path('forbidden').search({key: profilingKey});
    //   }
    // };

    (function(){
      // checkPermissions();
      $scope.$watch('filters', function(newValue, oldValue){
        if (newValue == oldValue) return;
        $scope.requestChanged();
      }, true);
      localeFactory.loadTranslation('warehouse_storage');
      $scope.lookup = {};
      eggsFormFactory.addLookup($scope.lookup, 'facility', 'facility', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'product', 'product', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'lot', 'lot', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'supplier', 'supplier', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'customer', 'customer', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'destination', 'customer_destination', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'color', 'color', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'size', 'tab_size', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'partType', 'part_type', 'code', 'description');
    })();
  });

'use strict';

angular.module('ictportal.lm')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/lm/moveToDestination', {
        templateUrl: 'lm/moveToDestination/move-to-destination.html',
        controller: 'MoveToDestinationCtrl'
      })
  })
  .controller('MoveToDestinationCtrl', function ($scope, dryCleaningFactory, toaster, localeFactory, authFactory, $location, $q, COMPONENT_READ_MODE,
                                                 recordFactory, dbFilterFactory, eggsFormFactory) {

    $scope.hrList = [];
    $scope.billToCustomerId = undefined;
    $scope.disableConfirm = true;
    var pageBundle = 'dry_cleaning';
    $scope.operator = null;
    $scope.authData = null;
    $scope.record = {
      lookup: {},
      dates: [],
      model: {}
    };

    function getBillToCustomer() {
      var customerId = $scope.record.lookup.toDest.obj.customer_id;
      if (customerId) {
        var filter = dbFilterFactory.getCustomFilter("t.id = " + customerId);
        recordFactory('customer').filter({}, filter).$promise.then(function (result) {
          if (result && result.list && result.list[0].bill_to_customer_id) {
            $scope.billToCustomerId = result.list[0].bill_to_customer_id;
          }
        });
      }

    }

    $scope.$watch('record.lookup.fromDest.obj',
      function (newValue, oldValue) {
        if (newValue && newValue != oldValue) {
          $scope.hrList = [];
          $scope.getData();
        } else if (!newValue) {
          $scope.record.model.fromDest = undefined;
        }
      }
    )

    $scope.$watch('record.lookup.toDest.obj',
      function (newValue, oldValue) {
        if (newValue && newValue != oldValue) {
          getBillToCustomer();
          if ($scope.record.lookup.fromDest) {
            $scope.disableConfirm = false;
          }
        } else if (!newValue) {
          $scope.billToCustomerId = undefined;
          $scope.disableConfirm = true;
        }
      }
    )

    $scope.getData = function () {
      if ($scope.record.lookup.fromDest) {
        var filter = dbFilterFactory.getCustomFilter("t.destination_id = " + $scope.record.lookup.fromDest.obj.id)
        recordFactory('human_resource').filter({page_size: 1000}, filter).$promise.then(function (data) {
          if (data && data.list.length > 0) {
            data.list.map(function (e) {
              var entry = {
                id: e.id,
                matricola: e.matriculation,
                nome: e.name,
                cognome: e.surname,
                discriminante: e.discriminator,
                sex: e.sex,
                work_task_id: e.work_task_id,
                badge: e.badge
              }
              $scope.hrList = $scope.hrList.concat(entry);
            })
          }
        })
        if ($scope.hrList.length > 0) {
          $scope.disableConfirm = false;
        }
      }
      $scope.disableConfirm = true;
    }

    $scope.updateHistory = function (hr) {
      var historyParams = {
        operation_date: new Date().setSeconds(0, 0),
        sex: hr.sex,
        bill_to_customer_id: $scope.billToCustomerId,
        destination_id: $scope.record.lookup.toDest.obj.id,
        employee_id: hr.id,
        badge: hr.badge,
        work_task_id: hr.work_task_id,
        operator_id: $scope.operator.id
      }
      return recordFactory('employee_history').create(historyParams).$promise
    }

    $scope.updateId = function (hr, param) {
      var deferred = $q.defer();
      recordFactory('human_resource').update({id: hr.id}, param).$promise.then(function () {
        var historyParams = {
          operation_date: new Date().toLocaleString("en-US", {timeZone: 'Europe/Rome'}),
          sex: hr.sex,
          bill_to_customer_id: $scope.billToCustomerId,
          destination_id: $scope.record.lookup.toDest.obj.id,
          employee_id: hr.id,
          badge: hr.badge,
          work_task_id: hr.work_task_id,
          operator_id: $scope.operator.id
        }
        recordFactory('employee_history').create(historyParams).$promise.then(function (result) {
          deferred.resolve(result);
        })
      })
      return deferred.promise;
    }

    $scope.confirm = function () {
      if ($scope.record.lookup.fromDest.obj && $scope.record.lookup.toDest.obj && $scope.record.lookup.fromDest.obj.id !== $scope.record.lookup.toDest.obj.id && $scope.hrList) {
        var promiseArray = [];
        var param = {
          destination_id: $scope.record.lookup.toDest.obj.id,
          bill_to_customer_id: $scope.billToCustomerId,
          last_modified_date: new Date(),
          last_modified_user_id: $scope.authData.info.userId
        };

        $scope.hrList.map(function (hr) {
          promiseArray.push($scope.updateId(hr, param))
        })
        $q.all(promiseArray).then(function () {
          toaster.pop('success', 'Operazione completata')
          $scope.hrList = [];
          $scope.getData();
        })
      }
    }

    function initLookups() {
      eggsFormFactory.addLookup($scope.record.lookup, 'fromDest', 'customer_destination', 'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'toDest', 'customer_destination', 'code', 'description');
    }

    function getOperator(userId, divcod) {
      var opFilter = dbFilterFactory.getCustomFilter("t.user_id = " + userId)
      opFilter = opFilter.concat(dbFilterFactory.getCustomFilter("(t.divcod = " + divcod + " OR t.divcod is null)"))
        .concat(dbFilterFactory.getCustomFilter("t.discriminator = 'HRES'"))
      recordFactory('human_resource').filter({}, opFilter).$promise.then(function (result) {
        $scope.operator = result.list[0]
      })
    }

    function init() {
      $scope.authData = authFactory.getAuthData();
      getOperator($scope.authData.info.userId, $scope.authData.info.divCod)
      initLookups();
      localeFactory.loadTranslation(pageBundle);
    }

    init();

  });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:PackSingleComponentDetailCtrl
 * @description
 * @author Rita Beltrami
 * created on 26/06/2019
 * Creates packs with a single component and dispatch them on a customer_order calling ABG Packer.
 * # PackSingleComponentDetailCtrl
 * Controller of the ictportal.lm
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/packsinglecomponent/detail/:orderId/:customerId/:destinationId/:coNumber', {
                templateUrl: 'lm/packSingleComponent/packSingleComponent_detail.html',
                controller: 'PackSingleComponentDetailCtrl'
            })
    })
    .controller('PackSingleComponentDetailCtrl', function ($scope, abgPackerFactory, $location, $routeParams,
                                                        packFactory, dbFilterFactory, localeFactory, eggsFormFactory, recordFactory,
                                                        $rootScope, toaster, $window, COMPONENT_READ_MODE, ABNORMAL_URL) {

        $window.onbeforeunload = function () {
          sganciaDalPacker();
          $window.onbeforeunload = undefined;
        };

        $scope.$on('$locationChangeStart', function () {
          sganciaDalPacker();
          $window.onbeforeunload = undefined;
        });

        var page_bundle = "pack_single";
        var msg = {};
        var page_msg = {
            "single_pack_detail_dispatch_title": "Single component pack creation: order ",
            "component_not_found": "Component not found",
            "wrong_status_component": "Invalid component status",
            "component_not_for_single_pack": "Product not sold in single packs",
            "pack_dispatched": "Pack with barcode {barcode} dispatched on order",
            "pack_already_read_in_order": "Pack already read in a order"
        };  $scope.record = {
            lookup: {},
            model: {}
        };
        $scope.compReaderMode = COMPONENT_READ_MODE.CODE;
        $scope.record = {
            lookup: {},
            model: {},
            filter: {}
        };
        $scope.viewGridOptions = { appScopeProvider: $scope };
        $scope.components = [];
        $scope.orderRows = [];
        $scope.alertMessage;

        $scope.items =[];

      var availableOrderRow = function (itemId) {
        var i;
        for (i = 0; i < $scope.orderRows.length; i++) {
          if ($scope.orderRows[i].prod_id === itemId && $scope.orderRows[i].dispatched_amount < $scope.orderRows[i].stock_amount) {
            return true;
          }
        }
        return false;
      };

      $scope.onRead = function (read) {
        var unicode = read.read;
        var found = $scope.items.find(function (element) {
          return element.unicode === unicode;
        });
        if (!found) {
          var filters = [{
            column: 'product p',
            value: 't.product_id = p.id',
            relation: 'JOIN',
            kind: 'p.id as item_id, p.code as item_code'
          }];
          filters = filters.concat(dbFilterFactory.getCustomFilter("unicode='" + unicode + "'"));
          recordFactory('component').filter({page_size: 1}, filters).$promise.then(function (res) {
            if(res && res.totalResults === 1 && res.list[0].item_id) {
              var itemCode = res.list[0].item_code;
              if (availableOrderRow(res.list[0].item_id)) {
                $scope.items.push({unicode: unicode});
                var unicodes = [unicode];
                packFactory.packSingleComponent({}, unicodes).$promise.then(function (data) {
                  if (data.status == 'ok') {
                    if (data) {
                      for (var unicode in data.result) {
                        handlePackComponentResponse(unicode, data.result[unicode]);
                      }
                    }
                  } else {
                    eggsFormFactory.logServerException(data, pageBundle);
                  }
                });
              } else {
                localeFactory.translateReplace(page_bundle + '.row_completed', {value:itemCode}).then(function (translatedMsg) {
                  showResult(unicode, translatedMsg, 'WARNING');
                });
              }
            } else {
              localeFactory.translateReplace(page_bundle + '.component_not_found', {}).then(function (translatedMsg) {
                showResult(unicode, translatedMsg, 'WARNING');
              });
            }
          });
        } else {
          localeFactory.translateReplace(page_bundle + '.pack_already_read', {}).then(function (translatedMsg) {
            showResult(unicode, translatedMsg, 'WARNING');
          });
        }
      };

      var sgancioInCorso = false;
      function sganciaDalPacker() {
          if ($routeParams.orderId !== undefined && sgancioInCorso === false) {
            navigator.sendBeacon(ABNORMAL_URL + '/api/packer/api/order/remove/' + $routeParams.orderId, {});
            // sgancioInCorso = true;
            // abgPackerFactory.removeOrder({id: $routeParams.orderId}, {}).$promise.then(function (data) {
            //   if (data.result !== 'OK') {
            //     toaster.pop("error", "Errore durante lo sgancio dell'ordine dal packer");
            //   } else {
            //     $routeParams.orderId = undefined;
            //   }
            //   sgancioInCorso = false;
            //});
          }
      };

        $scope.closeOrderAndBack = function () {
          //metto prodstatus a NEW
          sganciaDalPacker();
          $window.history.back();
        };

        function showResult(unicode, message, status) {
            var item = {
                unicode: unicode,
                result: message,
                error: (status==='ERROR'),
                warning: (status==='WARNING'),
                success: (status==='SUCCESS')
            };
            $scope.components.unshift(item);
        }

        function handlePackComponentResponse(unicode, packResult) {
            if(packResult.error) {
              if (page_msg[packResult.error] !== undefined) {
                var valuesObj = (packResult.value !== undefined && packResult.value !== null) ? {value : packResult.value} : {};
                localeFactory.translateReplace(page_bundle + '.' + packResult.error, valuesObj).then(function (translatedMsg) {
                  showResult(unicode, translatedMsg, 'ERROR');
                });
              } else {
                showResult(unicode, packResult.error, 'ERROR');
              }

            }
            else {
                tryToDispatchPack(packResult.id, packResult.barcode, unicode);
            }
        }

        function tryToDispatchPack(packId, packBarcode, unicode) {
            var payload = {
                orderId: parseInt($routeParams.orderId),
                packIds: [packId]
            };
            abgPackerFactory.dispatchPackOffline({}, payload).$promise.then(function(data) {
                data.forEach(function(item) {
                    if(item.result=='OK') {
                        localeFactory.translateReplace(page_bundle + '.pack_dispatched', {barcode: packBarcode}).then(function (translatedMsg) {
                            showResult(unicode, translatedMsg, 'SUCCESS');
                        });
                        getOrderDetail();
                    }
                    else {
                        showResult(unicode, item.message, 'WARNING');
                    }
                });
            });
        }

        function initLookups() {
            eggsFormFactory.addLookup($scope.record.lookup, 'customer', 'customer', 'code', 'description');
            eggsFormFactory.addLookup($scope.record.lookup, 'customer_destination', 'customer_destination', 'code', 'description');
        }

        function getOrderDetail() {
            abgPackerFactory.getOrderDetail({id: $routeParams.orderId},{}).$promise.then(
                function (data) {
                    $scope.orderRows.length = 0;
                    $scope.orderRows = data.rows.filter(function(cor) {
                        return (cor.quantity_included==1 && cor.no_chip==='F');
                    });
                    $scope.orderRows.forEach(function(cor) {
                        cor.progress = (cor.dispatched_amount*100)/cor.stock_amount;
                    });
                    checkOrderStatus();
                },
                function() {
                    console.error('Errore di comunicazione con il packer. Verificare la configurazione di a-b-normal.');
                }
            );
        }

        // TODO: traduci i messaggi
        function checkOrderStatus() {
            if($scope.orderRows.length==0) {
                $scope.alertMessage  = "L'ordine selezionato non contiene articoli venduti a pacchi singoli";
            }
            else {
                var completed = true;
                for(var i=0; i<$scope.orderRows.length; i++) {
                    var cor = $scope.orderRows[i];
                    if(cor.dispatched_amount<cor.stock_amount) {
                        completed = false;
                        break;
                    }
                }
                if(completed) {
                    $scope.alertMessage = "Tutte le righe a pacco singolo sono evadibili";
                }
            }
        }

        $scope.goToList = function() {
            sganciaDalPacker();
            $location.path('lm/packsinglecomponent/list');
        };

        function checkParams() {
            if($routeParams.orderId) {
                getOrderDetail();
            }
            if($routeParams.customerId) {
                $scope.record.model.customer = $routeParams.customerId;
                $scope.record.filter.customer = dbFilterFactory.getNumberFilter('t.id', $routeParams.customerId);
            }
            if($routeParams.destinationId) {
                $scope.record.model.customer_destination = $routeParams.destinationId;
                $scope.record.filter.customer_destination = dbFilterFactory.getNumberFilter('t.id', $routeParams.destinationId);
            }
        }

        function init() {
            localeFactory.loadTranslation(page_bundle);
            initLookups();
            checkParams();
        };

        $rootScope.$on('$translateRefreshEnd', function () {
            localeFactory.translateMsg(page_msg, page_bundle).then(function(){
                $scope.title = page_msg.single_pack_detail_dispatch_title + ' ' + $routeParams.coNumber;
            });
        });

        //___ main ___
        init();

    });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:PackSingleComponentListCtrl
 * @description
 * @author Rita Beltrami
 * created on 24/06/2019
 * # PackSingleComponentListCtrl
 * Controller of the ictportal.lm
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/packsinglecomponent/list', {
                templateUrl: 'lm/packSingleComponent/packSingleComponent_list.html',
                controller: 'PackSingleComponentListCtrl'
            })
    })
    .controller('PackSingleComponentListCtrl', function ($scope, abgPackerFactory, $location, authFactory,
                                                      parseSchemaService, dbFilterFactory, localeFactory, eggsFormFactory, $log) {

        var page_bundle = "pack_single";
        var authData = authFactory.getAuthData();

        $scope.destinationsAllowed = [];
        $scope.customersAllowed = [];
        $scope.ordersList = [];
        $scope.viewGridOptions = { appScopeProvider: $scope };
        $scope.advFilter = {
            filter: {}
        };

        $scope.reset = function() {
            $scope.advFilter.filter = {};
            $scope.$broadcast('clearLookUp');
            $scope.getData();
        }

        $scope.$watchGroup([
            'advFilter.filter.co_number',
            'advFilter.filter.delivery_date',
            'advFilter.filter.customer_id',
            'advFilter.filter.customer_destination_id'], function () {
                $scope.applyFilter();
            });

        $scope.applyFilter = function () {
            $log.info('applyFilter');
            var visibleOrders = $scope.ordersList.filter(function(o) {
                var isVisible = true;
                if ($scope.advFilter.filter.co_number) {
                    isVisible &= (o.co_number.toString().indexOf($scope.advFilter.filter.co_number)>=0);
                }
                if ($scope.advFilter.filter.delivery_date) {
                    var d1 = $scope.advFilter.filter.delivery_date;
                    var d2 = new Date(o.del_date);
                    isVisible &= (d1.getDate()==d2.getDate()) && (d1.getMonth()==d2.getMonth()) && (d1.getFullYear()==d2.getFullYear());
                }
                if ($scope.advFilter.filter.customer_id) {
                    isVisible &= (o.cust_id===$scope.advFilter.filter.customer_id);
                }
                if ($scope.advFilter.filter.customer_destination_id) {
                    isVisible &= (o.dest_id===$scope.advFilter.filter.customer_destination_id);
                }
                return isVisible;
            });
            $scope.viewGridOptions.data = visibleOrders;
        };

        function initGridColumns() {
            $scope.lookupCols = [];
            $scope.viewGridOptions.columnDefs = [];
            var dateFormat = localeFactory.getDateFormat();
            $scope.viewGridOptions.columnDefs.push(parseSchemaService.getEditCol());
            $scope.viewGridOptions.columnDefs.push({
                name: 'Numero',
                field: "co_number",
                displayName: 'number',
                headerCellFilter: 'translate',
                enableFiltering: false,
                width: 80
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Cliente",
                field: "cust_desc",
                displayName: 'customer',
                headerCellFilter: 'translate',
                cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.cust_code}} - {{row.entity.cust_desc }}</div>',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Destinazione",
                field: "dest_desc",
                displayName: 'customer_destination',
                headerCellFilter: 'translate',
                cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.dest_code}} - {{row.entity.dest_desc }}</div>',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Data cons.",
                field: "del_date",
                displayName: 'pack_single.delivery_date',
                headerCellFilter: 'translate',
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.del_date | date:\'' + dateFormat + '\' }}</div>',
                enableFiltering: false,
                width: 120
            });
        };

        function filterAllowed(data) {
          if ($scope.customersAllowed && $scope.customersAllowed.length > 0) {
            data = data.filter(function (e) {
              return $scope.customersAllowed.includes(e.cust_id);
            });
          }
          if ($scope.destinationsAllowed && $scope.destinationsAllowed.length > 0) {
            data = data.filter(function (e) {
              return $scope.destinationsAllowed.includes(e.dest_id);
            });
          }
          return data;
        }

        $scope.getData = function () {
            $scope.ordersList.length = 0;
            abgPackerFactory.getSinglePackOrders({},{})
                .$promise.then(function (data) {
                    data.orders = filterAllowed(data.orders);
                    $scope.viewGridOptions.totalItems = data.orders.length;
                    $scope.viewGridOptions.data = data.orders;
                    $scope.ordersList = $scope.ordersList.concat(data.orders);
                },
                function() {
                    console.error('Errore di comunicazione con il packer. Verificare la configurazione di a-b-normal.');
                });
        };

        $scope.viewDetail = function (value) {
            var selectedOrder = $scope.ordersList.filter(function(o) {
                return o.id===value.id;
            }).shift();
            $location.path('/lm/packsinglecomponent/detail/' + selectedOrder.id + '/'+ selectedOrder.cust_id + '/'+ selectedOrder.dest_id + '/'+ selectedOrder.co_number + '/');
        };

        function initFilters(){
            $scope.customerFilter = authData.filters.customer;
            $scope.shipmentDestinationFilter = authData.filters.customer_destination;
        };

        function initLookups() {
            $scope.lookup = {};
            eggsFormFactory.addLookup($scope.lookup, 'customer', 'customer', 'code', 'description');
            eggsFormFactory.addLookup($scope.lookup, 'customer_destination', 'customer_destination', 'code', 'description');
        };

        // Per ora non usato perché anche la vecchia funzione non era profilata. Chiedere al consulente...
        function checkPermissions() {
            // var profilingKey = 'PACK_SINGLE_COMPONENT_FUNCTION';
            // $scope.permission = authFactory.getPermissions(profilingKey);
            // if(!$scope.permission.EXEC) {
            //     $location.path('forbidden').search({key: profilingKey});
            // }
            // else if(!$scope.permission.DETAIL) {
            //     $scope.viewGridOptions.columnDefs.splice(0, 1);
            // }
          $scope.destinationsAllowed = authData.info.authorizations.destinations;
          $scope.customersAllowed = authData.info.authorizations.customers;
        }

        function init() {
            initGridColumns();
            checkPermissions();
            localeFactory.loadTranslation(page_bundle);
            initLookups();
            initFilters();
        };

        //___ main ___
        init();

    });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:PackagingSerialKitCtrl
 * @description
 * # PackagingSerialKitCtrl
 * Controller of the ictportal.lm
 * 
 * Per filtrare su determinati tipi articolo:
 * http://localhost:9000/#/packaging/serialKit?type=KITP&type=KIT&type=PIA
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/packaging/serialKit', {
                templateUrl: 'lm/packagingSerialKit/packagingSerialKit.html',
                controller: 'PackagingSerialKitCtrl'
            })
    })
    .controller('PackagingSerialKitCtrl', function ($scope, $filter, authFactory, toaster, $location, serialKitLMFactory,
                    COMPONENT_READ_MODE, SCAN_KIND, dbFilterFactory, recordFactory, eggsFormFactory, $log,
                    localStorageService, matrixParFactory) {
                 
        $scope.STEP = {
            BOM_SELECTION: {
                index: 1,
                message: 'Seleziona un articolo',
                progress: 30
            },
            PACKAGING: {
                index: 2,
                message: 'Seleziona i componenti da inserire nel kit',
                progress: 60
            } 
        };
        $scope.modeAuto = true;
        $scope.bomsList = [];
        $scope.compList = [];
        $scope.readList = [];
        $scope.settings = {};
        $scope.enablePreviousStep = false;
        $scope.enableNextStep = false;
        $scope.labelPrinted = false;
        $scope.jsFilter = '';
        $scope.userId = undefined;
        $scope.printerCode = undefined;
        $scope.params = {
            pageNumber: 1,
            pageSize: 100,
            filters: []
        };
        $scope.compReaderMode = COMPONENT_READ_MODE.CODE;
        $scope.progress = {
            percent: 0,
            message: 'Caricamento...'
        };
        $scope.packagingError = undefined;
        var allowedComponentStatuses = [];

        function updateNavigationButtons(){
            $scope.enablePreviousStep = false;
            $scope.enableNextStep = false;
            switch($scope.step){
                case $scope.STEP.BOM_SELECTION:
                    $scope.enablePreviousStep = false;
                    $scope.enableNextStep = false;
                    break;
                case $scope.STEP.PACKAGING:
                    $scope.enablePreviousStep = true;
                    $scope.enableNextStep = isSerialKitComplete();
                    break;   
            }
        };

        $scope.nextStep = function () {
            if($scope.step===$scope.STEP.PACKAGING){
                $scope.createSerialKit();
            }
            else{
                doNextStep();
            }
        };

        function doNextStep(){
            if ($scope.step.index < $scope.stepList.length) {
                var i;
                for (i = 0; i < $scope.stepList.length; i++) {
                    if ($scope.stepList[i] === $scope.step) {
                        break;
                    }
                }
                $scope.step = $scope.stepList[i + 1];
                setProgress($scope.step);
                updateNavigationButtons();
            }
        };

        function setProgress(step){
            $scope.progress.message = step.message;
            $scope.progress.percent = step.progress;
        };

        $scope.previousStep = function () {
            if ($scope.step.index > 1) {
                var i;
                for (i = $scope.stepList.length; i > 0; i--) {
                    if ($scope.stepList[i] === $scope.step) {
                        break;
                    }
                }
                $scope.step = $scope.stepList[i - 1];
            }
            if($scope.step===$scope.STEP.BOM_SELECTION){
                $scope.bomDet = undefined;
                $scope.bom = undefined;
                $scope.compList.length = 0;
                $scope.readList.length = 0;
            }
            setProgress($scope.step);
            updateNavigationButtons();
        };

        $scope.selectBom = function(bom){
            $scope.compList.length = 0;
            $scope.readList.length = 0;
            if(bom){
                $scope.bom = bom;
                // Recupera righe bom
                var filters =  [
                    {
                        "column": "product p",
                        "value": "t.item_id = p.id",
                        "relation": "JOIN",
                        "kind": "p.description, p.code"
                    }
                ];
                filters = filters.concat(dbFilterFactory.getNumberFilter('bom_id', bom.id));
                var payload = {
                    page: 1,
                    page_size: 10000,
                    show_revision: false,
                    sort_fields: 'sequence_index'
                };
                recordFactory('bom_det').filter(payload, filters)
                    .$promise.then(function (data) {
                        $scope.bomDet = data.list;
                        $scope.bomDet.forEach(function(bomDetElement){
                            bomDetElement.read = 0;
                        });
                        $scope.nextStep();
                    });
            }
        };

        $scope.getBoms = function () {
            var payload = {
                page: $scope.params.pageNumber,
                page_size: $scope.params.pageSize,
                show_revision: false
            };
            var filters = [
                {
                    "column": "product p",
                    "value": "t.item_id = p.id",
                    "relation": "JOIN",
                    "kind": "p.description AS product_description, p.code AS product_code"
                },
                {
                    "column": "product_type y",
                    "value": "p.product_type_id = y.id",
                    "relation": "JOIN",
                    "kind": "y.description AS product_type_description, y.code AS product_type_code"
                }
            ];
            // Eventualmente, filtro solo su certi tipi articolo (parametro in get, vedi descrizione funzione in alto)
            var types = $location.search().type; 
            if(types){
                if(angular.isArray(types)){
                    var productTypeQuery = '(';
                    types.forEach(function(product_type_code){
                        productTypeQuery += 'y.code=\'' + product_type_code + '\' OR ';
                    });
                    productTypeQuery = productTypeQuery.substr(0, productTypeQuery.length-4) + ')';
                    filters = filters.concat(dbFilterFactory.getCustomFilter(productTypeQuery));
                }
                else{
                    filters = filters.concat(dbFilterFactory.getStringFilter('y.code',types));
                }
            }
            // Filtro per validità
            var today = new Date();
            var date = '\'' + today.getFullYear() + '-';
            if(today.getMonth()<9){
                date += '0';
            }
            date += ( (today.getMonth()+1) + '-');
            if(today.getDate()<10){
                date += '0';
            }
            date += (today.getDate() + '\'');
            var validityQuery = '(t.validity_end is null OR t.validity_end>' + date + ')';
            filters = filters.concat(dbFilterFactory.getCustomFilter(validityQuery));
            filters = filters.concat($scope.params.filters);
            recordFactory('bom').filter(payload, filters)
                .$promise.then(function (data) {
                    setProgress($scope.step);
                    $scope.bomsList = data.list;
                });
        };

        function isNewRead(read){
            var alreadyRead = $filter('filter')($scope.readList, {read: {read: read.read} });
            var result = (alreadyRead.length===0);
            return result; 
        };

        $scope.readComponentCode = function(read){
            if($scope.step===$scope.STEP.PACKAGING && isNewRead(read)){
                var filters = [{
                    "column": "product p",
                    "value": "t.product_id = p.id",
                    "relation": "JOIN",
                    "kind": "p.description"
                }];
                switch(read.type){
                    case SCAN_KIND.BARCODE:
                        toaster.pop('info', 'Lettura barcode', read.read);
                        filters = filters.concat(dbFilterFactory.getStringFilter('barcode',read.read));
                        break;
                    case SCAN_KIND.RFID:
                        toaster.pop('info', 'Lettura unicode', read.read);
                        filters = filters.concat(dbFilterFactory.getStringFilter('unicode',read.read));
                        break;
                    case SCAN_KIND.MANUAL:
                        toaster.pop('info', 'Lettura codice', read.read);
                        filters = filters.concat(dbFilterFactory.getCustomFilter('(unicode=\'' + read.read + '\' OR barcode=\'' + read.read + '\')'));
                        break;
                }
                recordFactory('component').filter({page_size:10000}, filters)
                    .$promise.then(function(data) {
                        if(data.list && data.list.length>0){
                            var component = data.list[0];
                            $log.info(component);
                            var item = {read: read};
                            // Verifico lo stato del componente
                            if(!isValidComponentStatus(component)){
                                toaster.pop('error', 'Errore', 'Il componente si trova in uno stato non valido');
                            }
                            else{
                                // Verifica componente già letto
                                if(item.read.type===SCAN_KIND.BARCODE && item.read.read===component.barcode){
                                    item.component = component;
                                }
                                else if(item.read.type===SCAN_KIND.RFID && item.read.read===component.unicode){
                                    item.component = component;
                                }
                                else if(item.read.type===SCAN_KIND.MANUAL && item.read.read===component.unicode){
                                    item.component = component;
                                    item.read.type = SCAN_KIND.RFID;
                                }
                                else if(item.read.type===SCAN_KIND.MANUAL && item.read.read===component.barcode){
                                    item.component = component;
                                    item.read.type = SCAN_KIND.BARCODE;
                                }
                                // Cerco l'articolo corrispondente nella distinta base
                                var bomDetElement = $filter('filter')($scope.bomDet, {item_id: component.product_id});
                                if(bomDetElement && bomDetElement.length>0){
                                    if(bomDetElement[0].read===bomDetElement[0].amount){
                                        toaster.pop('error', 'Errore', 'Questo componente eccede la quantità prevista per il SerialKit');
                                    }
                                    else if(!isValidComponentOrder(component)){
                                        toaster.pop('error', 'Lettura fuori sequenza', 'La lettura effettuata non rispetta l\'ordine previsto dalla distinta base');
                                    }
                                    else{    
                                        bomDetElement[0].read++;
                                        $scope.readList.push(item);
                                        $scope.compList.push(component);
                                        updateNavigationButtons();
                                        if($scope.modeAuto && isSerialKitComplete() && $scope.settings.label_printer_id){
                                            $scope.createSerialKit();
                                        }
                                    }
                                }
                                else{
                                    toaster.pop('warning', 'Tipo articolo non previsto', 'Questo tipo di articolo non è previsto dalla distinta base');
                                }
                            }
                        }
                        else{
                            toaster.pop('error', 'Componente non trovato', 'Verificare anagrafica');
                        }
                });
            }
        };

        /**
         * Se richiesto dalla bom (seq_check_enabled) i componenti devono essere letti in un ordine ben preciso.
         */
        function isValidComponentOrder(component){
            var isValid = true;
            if($scope.bom.seq_check_enabled==='T'){
                for(var i=0; i<$scope.bomDet.length; i++){
                    var bomDetElement = $scope.bomDet[i];
                    if(component.product_id===bomDetElement.item_id){
                        isValid = true;
                        break;
                    }
                    else if(bomDetElement.amount!==bomDetElement.read){
                        isValid = false;
                        break;
                    }
                }
            }
            return isValid;
        };

        /**
         * Posso accettare solo i componenti che si trovino in un determinato stato.
         * I passaggi di stato ammessi sono definiti mediante matrixpar.
         */
        function isValidComponentStatus(component){
            var result = false;
            if(allowedComponentStatuses.length>0){
                result = (allowedComponentStatuses.indexOf(component.status)!=-1);
            }
            return result;
        };

        $scope.createSerialKit = function(){
            $scope.packagingError = undefined;
            $scope.generatedBarcode = undefined;
            var payload = {
                bomId: $scope.bom.id,
                packagingOperatorId: $scope.userId,
                componentsList: []
            };
            $scope.compList.forEach(function(comp){
                payload.componentsList.push(comp.id);
            });
            serialKitLMFactory.packaging(payload).$promise.then(function(response) {
                $log.info(response);
                if(response.success){
                    $scope.generatedBarcode = response.barcode;
                    $scope.printLabel();
                }
                else{
                    updateNavigationButtons();
                    $scope.packagingError = "Si è verificato un errore durante la fase di confezionamento";
                    if(response.message){
                        $scope.packagingError = $scope.packagingError + '. (' + response.message + ')';   
                    }
                }
            });
        };  

        function isSerialKitComplete(){
            var result = angular.isDefined($scope.bomDet);
            if($scope.bomDet){
                $scope.bomDet.forEach(function(det){
                    result &= (det.amount===det.read);
                });
                if($scope.packagingError){
                    result = false;
                }
            }
            return result;
        };

        function getOperator(){
            var username = authFactory.getAuthData().authId;
            var filters = [{
                "column": "human_resource o",
                "value": "o.user_id = t.id",
                "relation": "JOIN",
                "kind": "o.id AS operator_id"
            }];
            filters = filters.concat(dbFilterFactory.getStringFilter("username",username));
            recordFactory('users').filter({page_size:10000}, filters)
                .$promise.then(function(data) {
                    if(data.list && data.list.length>0){
                        $scope.userId = data.list[0].operator_id;
                    }
                });
        };

        $scope.goToSerialKitPackaging = function(){
            reinit();
        };

        // Se c'è, recupero la stampante di default per la workstation corrente
        function getWorkstationPrinter(){
            var workstation = localStorageService.get('workstation');
            if(workstation){
                var payload = { workstation: workstation };
                serialKitLMFactory.getWsPrinter(payload).$promise.then(function(response) {
                    $scope.settings.label_printer_id = response.printer;
                    eggsFormFactory.loadLookupData($scope.lookup, $scope.settings);
                });
            }
        };

        $scope.printLabel = function(){
            var payload = { 
                barcode: $scope.generatedBarcode,
                printer: $scope.lookup.label_printer_id.obj.code
            };
            serialKitLMFactory.printing(payload).$promise.then(function(response) {
                $scope.labelPrinted = true;
                $scope.progress = {
                    percent: 100,
                    message: 'Creazione kit completata'
                };
                if($scope.modeAuto){
                    resetPackaging();
                }
            });
        };

        function resetPackaging(){
            $scope.compList.length = 0;
            $scope.readList.length = 0;
            $scope.generatedBarcode = undefined;
            $scope.enableNextStep = false;
            $scope.labelPrinted = false;
            $scope.bomDet.forEach(function(bomDetElement){
                bomDetElement.read = 0;
            });
            $scope.progress = {
                percent: $scope.STEP.PACKAGING.progress,
                message: $scope.STEP.PACKAGING.message
            };
        };

        function reinit(){
            $scope.printer = false;
            $scope.enablePreviousStep = false;
            $scope.enableNextStep = false;
            $scope.labelPrinted = false;
            $scope.packagingError = undefined;
            $scope.generatedBarcode  = undefined;
            $scope.bomsList.length = 0;
            $scope.compList = [];
            $scope.readList = [];
            $scope.bom = undefined;
            $scope.progress = {
                percent: 0,
                message: 'Caricamento...'
            };
            $scope.step = $scope.STEP.BOM_SELECTION;
            $scope.stepList = [];
            for(var key in $scope.STEP){
                $scope.stepList.push($scope.STEP[key]);
            }
            $scope.getBoms();
        };

        function initLookups() {
            $scope.lookup = { };
            eggsFormFactory.addLookup($scope.lookup, 'label_printer_id', 'label_printer', 'code', 'description');
            $scope.mappingLoaded = true;
        };

        function getMatrixParWorkflow(){
            //Get matrix par that rapresent the change status permitted
            matrixParFactory.getMatrixPar({key: 'components.workflow', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}).$promise.then(function(data){
                var matrix = JSON.parse(data.value);
                if(matrix){
                    for(var key in matrix){
                        var array = matrix[key];
                        if(array.indexOf('P')!=-1){
                            allowedComponentStatuses.push(key);
                        }
                    }
                }
            });
        }

        function init() {
            getMatrixParWorkflow();
            $scope.step = $scope.STEP.BOM_SELECTION;
            $scope.stepList = [];
            for(var key in $scope.STEP){
                $scope.stepList.push($scope.STEP[key]);
            }
            initLookups();
            getWorkstationPrinter();
            getOperator();
            $scope.getBoms();
        };

        //___ main ___
        init();

    });

/**
 * Created by Mattia Freda on 16/11/18.
 */
'use strict';

angular.module('ictportal.lm')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/patient/detail', {
          templateUrl: 'lm/patient/patient_detail.html',
          controller: 'PatientCtrl'
        })
        .when('/patient/detail/:id', {
          templateUrl: 'lm/patient/patient_detail.html',
          controller: 'PatientCtrl'
        })
  })
  .controller('PatientCtrl', function ($scope, $log, recordFactory, $routeParams, $location,
                                          eggsFormFactory, toaster, dbFilterFactory, patientFactory, localeFactory,
                                          authFactory, $q, $window,  $rootScope, schemaFactory, matrixParFactory) {

	var msg = {
		success: "Success",
		error: "Error",
		warning: "Warning",
		server_comunication_error: "Server communication error"
	};
	var patientMsg = {
    patient_saved: "Patient saved",
    patient_deleted: "Patient deleted",
    component_decoupled: "Component decoupled with patient"
	};

    $scope.pageTitle = 'Dettaglio ospite';
    $scope.element = {};
    $scope.readOnly = true;
    $scope.componentDetailLink = 'six/component/detail';
    $scope.renderComponents = false;
    $scope.renderHead = false;
    $scope.deleteEnabled = false;
    $scope.enum = {
        sex: [
          {
            name: 'Femmina',
            value: 'F'
          },
          {
            name: 'Maschio',
            value: 'M'
          }
        ],
        status: [

        ]
    };
    $scope.customer = {};
    $scope.editMode = true;
    $scope.components = {};
    $scope.allComponents = {};
    var selectedRows = [];
    $scope.params = {
      pageNumber: 1,
      pageSize: 15,
      filters: []
    };

    $scope.sixRowSelectionChangedCallback = function(row, col, event){
      selectedRows = row.grid.api.selection.getSelectedRows();
      $scope.deleteEnabled = selectedRows.length > 0;
      console.log("selezionate " + selectedRows.length + " righe");
    };

    $scope.sixBulkSelectionCallback = function(scope, rows, evt) {
      if(scope.length > 0) {
        selectedRows = scope[0].grid.api.selection.getSelectedRows();
        if (selectedRows.length === $scope.viewGridOptions.appScopeProvider.params.pageSize) {
          toaster.pop('warn', 'ATTENZIONE! Selezionate solamente le righe della prima pagina');
        }
        $scope.deleteEnabled = selectedRows.length > 0;
        console.log("selezionate " + selectedRows.length + " righe");
      }
    };

    $scope.viewGridOptions = { appScopeProvider: $scope,
                                multiSelect: true,
                                enableRowHeaderSelection: true,
                                enableRowSelection: true,
                                rowSelectionChanged: $scope.sixRowSelectionChangedCallback,
                                rowSelectionChangedBatch: $scope.sixBulkSelectionCallback,};
    $scope.modal = {
        title: 'Conferma disassociazione',
        message: 'Sei sicuro di voler disassociare il capo?'
    };
    var statusEnum = {};
    $scope.repFilter = [];
    $scope.pdcFilter = [];

    function initLookups() {
      $scope.lookup = { };
      $scope.customerLookup = {};
      for (var key in $scope.sf.schema.properties) {
        var prop = $scope.sf.schema.properties[key];
        if (prop.format === 'lookup') {
          eggsFormFactory.addLookup($scope.lookup, key, prop.entity_id, 't.code', 't.description');
        }
      }
      // adding custom mappings
      eggsFormFactory.addLookup($scope.customerLookup, 'customer_id', 'customer', 'code', 'description');
      $scope.mappingLoaded = true;
    };

    function initDates() {
      $scope.dateFields = [];
      $scope.sf.form[0].items[0].tabs.forEach(function (tab) {
        tab.items.forEach(function (item) {
          if (item.type === 'datepicker') {
            $scope.dateFields.push(item.key[0]);
          }
        });
      });
    };

    $scope.$watch('customerLookup.customer_id.obj', function() {
        var typeFilter = [{
            "column": "receiver_type rt",
            "value": "t.receiver_type_id = rt.id",
            "relation": "JOIN",
            "kind": "rt.code AS type_code"
        }];
        $scope.repFilter = typeFilter.concat(dbFilterFactory.getInFilter('rt.code', ['REP', 'GUA']));
        if ($scope.customerLookup && $scope.customerLookup.customer_id.obj) {
            $scope.repFilter = $scope.repFilter.concat(dbFilterFactory.getNumberFilter('t.customer_id', $scope.customerLookup.customer_id.obj.id));
        }
    });

    // L'ospedale dipende dal reparto
    $scope.$watch('lookup.destination_id.obj',
        function(newValue, oldValue) {
            if($scope.customerLookup){
            $scope.customerLookup.customer_id.filter = [];
            if(newValue && newValue.customer_id){
              recordFactory('customer').byId({ id: newValue.customer_id }).$promise.then(function (response) {
                $scope.customerLookup.customer_id.obj = response;
                $scope.customerLookup.customer_id.filter = $scope.customerLookup.customer_id.filter.concat(dbFilterFactory.getNumberFilter('t.id', newValue.customer_id));
              });
            }
            else{
              $scope.customerLookup.customer_id.obj = undefined;
            }
          }
        }
    );


    function loadStatusEnum() {
      fetch('/translation/it/component.json')
        .then(function(response) {
            return response.json();})
        .then(function(json) {
          statusEnum = json.component;
        });
    }

    var initGridColumns = function () {
      $scope.lookupCols = [];
      var dateFormat = localeFactory.getDateFormat();
      $scope.viewGridOptions.componentColumnDefs = [];
      //$scope.viewGridOptions.componentColumnDefs.push(parseSchemaService.getEditCol());
      // COLONNE COMPONENTI
      // $scope.viewGridOptions.componentColumnDefs.push({
      //   displayName: '',
      //   field: 'id',
      //   width: 60,
      //   cellTemplate: '<button ng-click="grid.appScope.decoupleComponent(row.entity.id)" class="btn btn-xl btn-info equal-margin-left-right"><span class="fa fa-trash"></span></button>',
      //   enableFiltering: false
      // });
      $scope.viewGridOptions.componentColumnDefs.push({
        displayName: 'Barcode',
        field: 'barcode',
        //width: 60,
        enableFiltering: false
      });
      $scope.viewGridOptions.componentColumnDefs.push({
        displayName: 'Unicode',
        field: 'unicode',
        enableFiltering: false
      });
      $scope.viewGridOptions.componentColumnDefs.push({
        displayName: 'Articolo',
        field: 'description',
        enableFiltering: false
      });
      $scope.viewGridOptions.componentColumnDefs.push({
        displayName: 'Stato',
        field: 'status',
        cellTemplate: '<div class="ui-grid-cell-contents">{{ grid.appScope.enumStatus(row.entity.status) }}</div>',
        enableFiltering: false
      });
      $scope.viewGridOptions.componentColumnDefs.push({
        name: "Data creazione",
        field: "created_date",
        translation: 'date',
        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.created_date | date:\'' + dateFormat + '\' }}</div>',
        enableFiltering: false
      });
      // COLONNE STORICO
      $scope.viewGridOptions.historyColumnDefs = [];
      //$scope.viewGridOptions.historyColumnDefs.push(parseSchemaService.getEditCol());
      $scope.viewGridOptions.historyColumnDefs.push({
        displayName: 'Operatore',
        field: 'matriculation',
        enableFiltering: false
      });
      $scope.viewGridOptions.historyColumnDefs.push({
        name: "Data operazione",
        field: "operation_date",
        translation: 'date',
        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.operation_date | date:\'' + dateFormat + '\' }}</div>',
        enableFiltering: false
      });
      $scope.viewGridOptions.historyColumnDefs.push({
        displayName: 'AUSL',
        field: 'ausl_code',
        enableFiltering: false
      });
      $scope.viewGridOptions.historyColumnDefs.push({
        displayName: 'Reparto',
        field: 'destination_code',
        enableFiltering: false
      });
    };

    $scope.enumStatus = function(key) {
      return statusEnum[key];
    }

    $scope.decoupleComponents = function() {
        if (!$scope.modal) {
            alert('Modal not found');
        }
        else {
            $scope.modal.callback = doDecoupleComponents.bind(null);
            $rootScope.$broadcast('sixConfirmModal_open');
        }
    };

    $scope.decoupleAllComponents = function() {
      if (!$scope.modal) {
        alert('Modal not found');
      }
      else {
        $scope.modal.callback = doDecoupleAllComponents.bind(null);
        $rootScope.$broadcast('sixConfirmModal_open');
      }
    };

    function doDecoupleComponents() {
      var azcod = authFactory.getAuthData().info.azCod;
      var divcod = authFactory.getAuthData().info.divCod;
      var componentIds = selectedRows.map(function (r){
        return r.id
      })
      var patientDto = {'associatedComponentsIds': componentIds,
              'azcod': azcod,
              'divcod': divcod};

      patientFactory.decoupleComponent({},patientDto).$promise
      .then(function(response) {
          if(response.success) {
              toaster.pop('success', msg.success, patientMsg.component_decoupled);

              // refresh della griglia
              $scope.getPatientComponents();
          }
          else {
              toaster.pop('error', msg.error, response.message);
          }
      });
    }

    function doDecoupleAllComponents() {
      var azcod = authFactory.getAuthData().info.azCod;
      var divcod = authFactory.getAuthData().info.divCod;
      var payload = {
        page_size: 99999
      };
      var filters = [{
        column: 'component_status cs',
        value: 't.current_component_status_id = cs.id',
        relation: 'JOIN',
        kind: 'cs.status'
      },
        {
          column: 'product p',
          value: 't.product_id = p.id',
          relation: 'JOIN',
          kind: 'p.description'
        }];
      filters = filters.concat(dbFilterFactory.getNumberFilter('t.patient_id',$scope.element.id));
      recordFactory('component').filter(payload, filters)
        .$promise.then(function(data) {
        $log.info(data);
        $scope.allComponents.totalResults = data.totalResults;
        $scope.allComponents.list = data.list;
        var componentsIds = $scope.allComponents.list.map(function (c) { return c.id})
        var patientDto = {'associatedComponentsIds': componentsIds,
          'azcod': azcod,
          'divcod': divcod};

        patientFactory.decoupleComponent({},patientDto).$promise
          .then(function(response) {
            if(response.success) {
              toaster.pop('success', msg.success, patientMsg.component_decoupled);

              // refresh della griglia
              $scope.getPatientComponents();
            }
            else {
              toaster.pop('error', msg.error, response.message);
            }
          });
      });

    }

    $scope.backToPatients = function(){
      $location.path('patient/list');
    };

    $scope.getPatientHistory = function(){
      var payload = {
        page_size: 10000,
        show_revision: false,
        sort_fields: 'operation_date',
        sort_order: 'desc'
      };
      var filters = [{
        column: 'human_resource h',
        value: 't.operator_id = h.id',
        relation: 'JOIN',
        kind: 'h.matriculation'
      },
      {
        column: 'customer c',
        value: 't.bill_to_customer_id = c.id',
        relation: 'JOIN',
        kind: 'c.code as ausl_code'
      },
      {
        column: 'customer_destination d',
        value: 't.destination_id = d.id',
        relation: 'JOIN',
        kind: 'd.code as destination_code'
      }];
      filters = filters.concat(dbFilterFactory.getNumberFilter('t.patient_id',$scope.element.id));
      recordFactory('patient_history').filter(payload, filters)
          .$promise.then(function(data) {
            $log.info(data);
            $scope.history.totalResults = data.totalResults;
            $scope.history.list = data.list;
            //$rootScope.$broadcast('sixDetailGrid:dataLoaded','patient_history',data.list);
      });
    };

    $scope.getPatientComponents = function(){
      var payload = {
        page: $scope.params.pageNumber,
        page_size: $scope.params.pageSize
      };
      var filters = [{
        column: 'component_status cs',
        value: 't.current_component_status_id = cs.id',
        relation: 'JOIN',
        kind: 'cs.status'
      },
      {
        column: 'product p',
        value: 't.product_id = p.id',
        relation: 'JOIN',
        kind: 'p.description'
      }];
      filters = filters.concat(dbFilterFactory.getNumberFilter('t.patient_id',$scope.element.id));
      recordFactory('component').filter(payload, filters)
          .$promise.then(function(data) {
            $log.info(data);
            $scope.viewGridOptions.totalItems = data.totalResults;
            $scope.components.totalResults = data.totalResults;
            $scope.components.list = data.list;
            $scope.renderComponents = true;
            //$rootScope.$broadcast('sixDetailGrid:dataLoaded','component',data.list);
      });
    };

    function getPatient(id) {
      recordFactory('human_resource').byId({ id: id }).$promise.then(function (response) {
        $scope.element = response;
        eggsFormFactory.convertDates($scope.element, $scope.dateFields);
        $log.info($scope.element);
        eggsFormFactory.loadLookupData($scope.lookup, $scope.element);
        $rootScope.$broadcast('sixCheckbox:reload');
        //$scope.getPatientHistory();
        $scope.getPatientComponents();
        $scope.renderHead = true;
      });
    };

    $scope.save = function(){
      var azcod = authFactory.getAuthData().info.azCod;
      var divcod = authFactory.getAuthData().info.divCod;
      var patientDto = {'matriculation': $scope.element.matriculation,
                  'surname': $scope.element.surname,
                  'name': $scope.element.name,
                  'barcode': $scope.element.barcode,
                  'customerMatriculation': $scope.element.customer_matriculation,
                  'sex': $scope.element.sex,
                  'billToCustomerCode': ($scope.lookup.bill_to_customer_id.obj) ? $scope.lookup.bill_to_customer_id.obj.code : null,
                  'customerCode': ($scope.customerLookup.customer_id.obj) ? $scope.customerLookup.customer_id.obj.code : null,
                  'destinationCode': ($scope.lookup.destination_id.obj) ? $scope.lookup.destination_id.obj.code : null,
                  'deliveryDestinationCode': ($scope.lookup.delivery_destination_id.obj) ? $scope.lookup.delivery_destination_id.obj.code : null,
                  'validityEnd': $scope.element.validity_end,
                  'note': $scope.element.note,
                  'azcod': azcod,
                  'divcod': divcod};
      patientFactory.updateOrCreatePatient({},patientDto).$promise
      .then(function(response) {
          if(response.success) {
              toaster.pop('info', msg.success, patientMsg.patient_saved);
          }
          else {
              toaster.pop('error', msg.error, response.message);
          }
        }).catch(function(ex){ logError(ex) });
    }

    $scope.delete = function(){
      var azcod = authFactory.getAuthData().info.azCod;
      var divcod = authFactory.getAuthData().info.divCod;
      var payload = {
        page_size: 99999
      };
      var filters = [{
        column: 'component_status cs',
        value: 't.current_component_status_id = cs.id',
        relation: 'JOIN',
        kind: 'cs.status'
      },
        {
          column: 'product p',
          value: 't.product_id = p.id',
          relation: 'JOIN',
          kind: 'p.description'
        }];
      filters = filters.concat(dbFilterFactory.getNumberFilter('t.patient_id',$scope.element.id));
      recordFactory('component').filter(payload, filters)
        .$promise.then(function(data) {
        $log.info(data);
        $scope.allComponents.totalResults = data.totalResults;
        $scope.allComponents.list = data.list;
        var componentsIds = $scope.allComponents.list.map(function (c) { return c.id})
        var patientDto = {'id': $scope.element.id,
          'azcod': azcod,
          'divcod': divcod,
          'associatedComponentsIds': componentsIds};
        patientFactory.deletePatient({},patientDto).$promise
          .then(function(response) {
            if(response.success) {
              toaster.pop('info', msg.success, patientMsg.patient_deleted);
              $scope.backToPatients();
            }
            else {
              toaster.pop('error', msg.error, response.message);
            }
          }).catch(function(ex){ logError(ex) });
      });

    }

    function getTranslations(){
      localeFactory.loadTranslation('patient')
      .then(function() {
          localeFactory.translateMsg(msg);
          localeFactory.translateMsg(patientMsg, 'patient');
      });
    };


    function init() {
      schemaFactory().getCode({ id: 'human_resource' }).$promise.then(function (data) {
        // !WORKAROUND!
        fetch('/lm/patient/human_resource.json')
        .then(function(response) {
            return response.json();})
        .then(function(json) {
            data=json;

        $scope.sf = data;
        getTranslations();
        var typeFilter = [{
            "column": "receiver_type rt",
            "value": "t.receiver_type_id = rt.id",
            "relation": "JOIN",
            "kind": "rt.code AS type_code"
        }];
        $scope.repFilter = typeFilter.concat(dbFilterFactory.getInFilter('rt.code', ['REP', 'GUA']));
        var mxParDelTypeCode = 'PDC';
        // [SIXLM-137] aggiunto filtro sul tipo punto di consegna tramite matrix par
        matrixParFactory.getMatrixPar({key: 'deliveryDestinationTypeCode', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}).$promise.then(function(data){
            if (data.value) {
                mxParDelTypeCode = data.value;
            }
            $scope.pdcFilter = typeFilter.concat(dbFilterFactory.getStringFilter('rt.code', mxParDelTypeCode));
        });
        initLookups();
        initDates();
          loadStatusEnum();
          initGridColumns();
        if (angular.isDefined($routeParams.id)) {
          getPatient($routeParams.id);
        } else {
          $scope.renderHead = true;
        }


      })
      });
    };

    init();

  });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:PatientListCtrl
 * @description
 * # PatientListCtrl
 * Controller of the ictportal.lm
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/patient/list', {
                templateUrl: 'lm/patient/patient_list.html',
                controller: 'PatientListCtrl'
            })
            .when('/patient/list/:customer', {
                templateUrl: 'lm/patient/patient_list.html',
                controller: 'PatientListCtrl'
            })
    })
    .filter('mapBoolean', function () {
        var genderHash = {
            1: 'Sì',
            2: 'No'
        };

        return function (input) {
            if (!input) {
                return '';
            } else {
                return genderHash[input];
            }
        };
    })
    .controller('PatientListCtrl', function ($scope, $routeParams, $location, toaster, $q, dbFilterFactory,
        recordFactory, schemaFactory, uiGridConstants, $log, authFactory, matrixParFactory) {
        $scope.discriminator = 'patient';
        $scope.schemaFound = false;
        $scope.lockCustomer = false;
        $scope.list = {};
        $scope.patientDestinationFilter = [];

        $scope.record = {
            model: {},
            lookup: {},
            dates: []
        };
        $scope.params = {
            pageNumber: 1,
            pageSize: 15,
            code: 'human_resource',
            filters: []
        };
        $scope.viewGridOptions = { appScopeProvider: $scope };
        $scope.advFilter = {
            filter: {},
            list: []
        };

        $scope.lookup = {
            patient_id: {
                filter: dbFilterFactory.getStringFilter('discriminator', 'PAT'),
                obj: undefined,
                mapping: {
                    code: 'matriculation',
                    description: 'surname,name'
                }
            },
            customer_id: {
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            },
            destination_id: {
                filter: [],
                obj: undefined,
                mapping: {
                    code: 't.code',
                    description: 't.description'
                }
            },
            delivery_destination_id: {
                filter: [],
                obj: undefined,
                mapping: {
                    code: 't.code',
                    description: 't.description'
                }
            }
        };
        // Aggiungo eventualmente alle lookup dei join che mi servono per poi filtrare i risultati.
        $scope.lookup.patient_id.filter.push({
            "column": "customer_destination d",
            "value": "t.destination_id = d.id",
            "relation": "JOIN",
            "kind": "d.customer_id"
        });

        $scope.$watch('lookup.customer_id.obj', function() {
            var typeFilter = [{
                "column": "receiver_type rt",
                "value": "t.receiver_type_id = rt.id",
                "relation": "JOIN",
                "kind": "rt.code AS type_code"
            }];
            $scope.lookup.destination_id.filter = typeFilter.concat(dbFilterFactory.getInFilter('rt.code', ['REP', 'GUA']));
            if ($scope.lookup.customer_id.obj) {
                $scope.lookup.destination_id.filter = $scope.lookup.destination_id.filter.concat(dbFilterFactory.getNumberFilter('t.customer_id', $scope.lookup.customer_id.obj.id));
            }
        });

        $scope.$watch('lookup.destination_id.obj', function() {
            $scope.lookup.customer_id.filter = [];
            $scope.lookup.patient_id.filter = dbFilterFactory.getStringFilter('t.discriminator', 'PAT');
            if ($scope.lookup.destination_id.obj) {
                $scope.lookup.customer_id.filter = $scope.lookup.customer_id.filter.concat(dbFilterFactory.getNumberFilter('t.id', $scope.lookup.destination_id.obj.customer_id));
                $scope.lookup.patient_id.filter = $scope.lookup.patient_id.filter.concat(dbFilterFactory.getNumberFilter('t.destination_id', $scope.lookup.destination_id.obj.id));
            }
        });

        $scope.$watchGroup(['advFilter.filter.customer_id',
                            'advFilter.filter.patient_id',
                            'advFilter.filter.destination_id',
                            'advFilter.filter.customer_matriculation',
                            'advFilter.filter.delivery_destination_id',
                            'advFilter.filter.matriculation'], function () {
            $scope.applyFilter();
        });

        $scope.applyFilter = function () {
            $scope.advFilter.list.length = 0;
            if ($scope.advFilter.filter.customer_id) {
                var f = dbFilterFactory.getNumberFilter('customer_id', $scope.advFilter.filter.customer_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            else if($scope.patientDestinationFilter.length>0){
                $scope.advFilter.list = $scope.advFilter.list.concat($scope.patientDestinationFilter);
            }
            if ($scope.advFilter.filter.patient_id) {
                var f = dbFilterFactory.getNumberFilter('t.id', $scope.advFilter.filter.patient_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.destination_id) {
                var f = dbFilterFactory.getNumberFilter('destination_id', $scope.advFilter.filter.destination_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.delivery_destination_id) {
                var f = dbFilterFactory.getNumberFilter('t.delivery_destination_id', $scope.advFilter.filter.delivery_destination_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.matriculation) {
                var f = dbFilterFactory.getLikeFilter('t.matriculation', $scope.advFilter.filter.matriculation);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.customer_matriculation) {
                var f = dbFilterFactory.getLikeFilter('t.customer_matriculation', $scope.advFilter.filter.customer_matriculation);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }

            $log.info($scope.advFilter.list);
            $scope.getData();
        };

        function readLookups() {
            for (var key in $scope.schema.properties) {
                var prop = $scope.schema.properties[key];
                if (prop.format === 'lookup') {
                    $scope.record.lookup[key] = {
                        mapping: prop.mapping,
                        obj: {},
                        entity: prop.entity_id
                    };
                }
            }
        };

        function loadLookupCols() {
            // Raggruppo assieme i record che fanno riferimento ad una stessa entità (es. tutti quelli con customer_id=123)
            // In questo modo risolvo l'entità una volta sola per tutti.
            var lookupMap = {};
            $scope.lookupCols.forEach(function (lookup) {
                var field = lookup.field;
                lookupMap[field] = {};
                $scope.list.list.forEach(function (record) {
                    var id = record[field];
                    if (id) {
                        if(!lookupMap[field][id]){
                            lookupMap[field][id] = [];
                        }
                        lookupMap[field][id].push(record);
                    }
                });
            });
            // Recupero da DB i dati e li assegno ai rispettivi record.
            $scope.lookupCols.forEach(function (lookup) {
                for(var id in lookupMap[lookup.field]){
                    recordFactory(lookup.entity).byId({ id: id })
                        .$promise.then(function (data) {
                            data['model'] = { description: '' };
                            var tokens = lookup.mapping.description.split(',');
                            tokens.forEach(function (term) {
                                if (data[term]) {
                                    data['model'].description += data[term] + ' ';
                                }
                            });
                            data['model'].description = data['model'].description.trim();
                            lookupMap[lookup.field][data.id].forEach(function(record){
                                record[lookup.field + '_obj'] = data;
                            });
                        });
                }
            });
        };

        function readDates() {
            $scope.form[0].items[0].tabs.forEach(function (tab) {
                tab.items.forEach(function (item) {
                    if (item.type === 'datepicker') {
                        var t1 = $scope.record.dates;
                        var t2 = item.key[0];
                        $scope.record.dates.push(item.key[0]);
                    }
                });
            });
        };

        function loadDates() {
            $scope.record.dates.forEach(function (field) {
                $scope.list.list.forEach(function (record) {
                    if (record[field]) {
                        record[field] = new Date(record[field]);
                    }
                });
            });
        };

        function initGridColumns() {
            $scope.lookupCols = [];
            schemaFactory().getCode({ id: 'human_resource' }).$promise.then(
                function (data) {
                    // !WORKAROUND!
                    fetch('/lm/patient/human_resource.json')
                    .then(function(response) {
                        return response.json();})
                    .then(function(json) {
                        data=json;

                    if (data.schema) {
                        $scope.sf = data;
                        if (data.schema && data.form) {
                            $scope.schema = data.schema;
                            $scope.form = data.form;
                            readLookups();
                            readDates();
                        }
                        if (data.schema || data.form) $scope.schemaFound = true;
                        if (data.columnDefs) {
                            $scope.viewGridOptions.columnDefs = [];
                            $scope.viewGridOptions.columnDefs.push({
                                displayName: '',
                                field: 'id',
                                width: 34,
                                enableCellEdit: false,
                                enableFiltering: false,
                                enableSorting: false,
                                cellTemplate:
                                '<div class="ui-grid-cell-contents" style="text-align: center">' +
                                '<button ng-click="grid.appScope.viewDetail(row.entity)" class="btn btn-xs btn-primary">' +
                                '<span class="fa fa-search"></span>' +
                                '</button>' +
                                '</div>'
                            });
                            data.columnDefs.forEach(function (item) {
                                item.enableFiltering = getEnableFiltering(item);
                                item.filters = [{
                                    type: 'text',
                                    condition: uiGridConstants.filter.CONTAINS,
                                    placeholder: '',
                                    kind: 'string'
                                }];
                                if ($scope.record.lookup[item.field]) {
                                    var prop = data.schema.properties[item.field];
                                    item.filters = [{
                                        type: 'lookup',
                                        condition: uiGridConstants.filter.CONTAINS,
                                        placeholder: '',
                                        kind: 'string',
                                        schema: prop,
                                        join: {
                                            column: prop.entity_id,
                                            value: 't.' + prop.title + ' = ' + prop.entity_id + '.id',
                                            relation: 'JOIN',
                                            kind: ''
                                        }
                                    }];
                                    var lookup = $scope.record.lookup[item.field];
                                    lookup.field = item.field;
                                    item.field = item.field + '_obj.model.description';
                                    item.enableSorting = false;
                                    $scope.lookupCols.push(lookup);
                                }
                                else if (isDate(item.field)) {
                                    item.filters = [
                                        {
                                            type: 'date',
                                            relation: '>=',
                                            placeholder: 'da...',
                                            kind: 'date',
                                            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
                                        },
                                        {
                                            type: 'date',
                                            relation: '<=',
                                            placeholder: 'a...',
                                            kind: 'date',
                                            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
                                        }
                                    ];
                                    item.cellTemplate = '<div class="ui-grid-cell-contents">{{ row.entity.' + item.field + ' | date:\'dd/MM/yyyy\' }}</div>'
                                }
                                else if (isBoolean(item.field)) {
                                    var options = [{
                                        value: 'S',
                                        label: 'Sì'
                                    }, {
                                        value: 'N',
                                        label: 'No'
                                    }];
                                    item.filter = {
                                        type: uiGridConstants.filter.SELECT
                                    };
                                    item.editDropdownOptionsArray = options;
                                    item.filter.selectOptions = options.map(function (obj) {
                                        var rObj = { 'value': obj.value, 'label': obj.label };
                                        return rObj;
                                    });
                                    item.cellTemplate = '<div class="ui-grid-cell-contents"><span ng-if="row.entity.' + item.field + '===\'S\'" >Sì</span><span ng-if="row.entity.' + item.field + '!==\'S\'" >No</span></div>'
                                }
                                $scope.viewGridOptions.columnDefs.push(item)
                            });
                        };
                    }
                    // Default
                    else {
                        $scope.viewGridOptions.columnDefs = [];
                        $scope.viewGridOptions.columnDefs.push({
                            displayName: '',
                            field: 'id',
                            width: 34,
                            enableCellEdit: true,
                            enableFiltering: false,
                            enableSorting: false,
                            cellTemplate:
                            '<div class="ui-grid-cell-contents" style="text-align: center">' +
                            '<button ng-click="grid.appScope.viewDetail(row.entity)" class="btn btn-xs btn-primary">' +
                            '<span class="fa fa-search"></span>' +
                            '</button>' +
                            '</div>'
                        });
                        /* $scope.viewGridOptions.columnDefs.push({
                            displayName: capitalize($routeParams.code),
                            field: 'model.code',
                            enableFiltering: true,
                            filters: [{
                                type: 'text',
                                condition: uiGridConstants.filter.CONTAINS,
                                placeholder: '',
                                kind: 'string'
                            }]
                        });
                        $scope.viewGridOptions.columnDefs.push({
                            displayName: $routeParams.description.split(',').reduce(function (a, b) { return a + capitalize(b) + ' '; }, '').trim(),
                            field: 'model.description',
                            enableFiltering: true,
                            filters: [{
                                type: 'text',
                                condition: uiGridConstants.filter.CONTAINS,
                                placeholder: '',
                                kind: 'string'
                            }]
                        }); */
                    }});
                }
            );
        };

        function getEnableFiltering(item) {
            /*var schemaItem = $scope.sf.schema.properties[item.field];
            var enable = !(schemaItem.enableFiltering === false);
            return enable;*/
            return false;
        };

        function isDate(field) {
            var isADate = false;
            for (var i = 0; i < $scope.form[0].items[0].tabs.length; i++) {
                var tab = $scope.form[0].items[0].tabs[i];
                var index = tab.items.findIndex(function (e) { return e.key[0] == field; });
                if (index >= 0) {
                    isADate = (tab.items[index].type === 'datepicker');
                    break;
                }
            }
            return isADate;
        };

        function isBoolean(field) {
            var isABoolean = false;
            for (var i = 0; i < $scope.form[0].items[0].tabs.length; i++) {
                var tab = $scope.form[0].items[0].tabs[i];
                var index = tab.items.findIndex(function (e) { return e.key[0] == field; });
                if (index >= 0) {
                    isABoolean = (tab.items[index].type === 'eggscheckbox');
                    break;
                }
            }
            return isABoolean;
        };

        $scope.getData = function () {
            var payload = {
                page: $scope.params.pageNumber,
                page_size: $scope.params.pageSize,
                code: $scope.params.code,
                description: $scope.params.description,
                show_revision: false,
                sort_fields: ($scope.params.sortFields?$scope.params.sortFields:'surname'),
                sort_order: $scope.params.sortOrder
            };
            var filters = [{
                "column": "t.discriminator",
                "value": "PAT",
                "relation": "=",
                "kind": "string"
            },
            {
                "column": "customer_destination d",
                "value": "t.destination_id = d.id",
                "relation": "JOIN",
                "kind": "d.customer_id"
            }
            ];
            filters = filters.concat($scope.advFilter.list);
            recordFactory('human_resource').filter(payload, filters)
                .$promise.then(function (data) {
                    $scope.viewGridOptions.totalItems = data.totalResults;
                    $scope.list.totalResults = data.totalResults;
                    $scope.list.list = data.list;
                    if ($scope.lookupCols.length > 0) {
                        loadLookupCols();
                    }
                    if ($scope.record.dates.length > 0) {
                        loadDates();
                    }
                });
        };

        function capitalize(s) {
            return s && s[0].toUpperCase() + s.slice(1);
        };

        $scope.goToNew = function () {
            var path = '/patient/detail';
            if ($scope.sf.detailPath) {
                path = $scope.sf.detailPath;
            }
            $location.path(path);
        };

        $scope.viewDetail = function (value) {
            if ($scope.sf.detailPath) {
                $location.path($scope.sf.detailPath + '/' + value.id);
            }
            else {
                $location.path('record/detail/' + $routeParams.type + '/' + value.id);
            }
        };

        function getCustomer(id) {
            recordFactory('customer').byId({ id: id })
                .$promise.then(function (data) {
                    $scope.lookup.customer_id.obj = data;
                    $scope.advFilter.filter.customer_id = id;
                });
        };

        // Alcuni utenti possono vedere solo certi reparti, e di conseguenza solo certi clienti (ospedali).
        // In base alle abilitazioni utente, qui creo i filtri per limitare i risultati dei vari elementi della pagina.
        //
        // Pesco tutte le destinazioni abilitate per l'utente (molte lookup vanno filtrate per destination_id)
        // Per ognuna delle destinazioni ottenute, guardo quali sono i diversi customer che posso abilitare all'utente
        //
        function getCustomerFilter(){
            $scope.lookup.customer_id.filter = []; // Filtro da applicare alla lookup sugli ospedali
            $scope.patientDestinationFilter = []; // Filtro da applicare sulle righe della tabella per filtrare in base alla destinazione
            // Recupero l'elenco delle destinazioni possibili per l'operatore
            var authData = authFactory.getAuthData();
            var customerDestinationQuery = ''; // Query per trovare le customer_destination abilitate per il cliente. Usata per filtrare ospedali e varie lookup.
            var customerQuery = ''; // Query da applicare alla lookup sugli ospedali
            var patientCustomerQuery = ''; // Query da applicare sulla lookup dei dipendenti
            var patientDestinationQuery = ''; // Query da applicare sulle righe della tabella
            if(authData && authData.info && authData.info.authorizations){
                authData.info.authorizations.destinations.forEach(function(destinationId){
                    customerDestinationQuery += 'id=' + destinationId + ' OR ';
                    patientDestinationQuery += 'destination_id=' + destinationId + ' OR ';
                });
            }
            if(customerDestinationQuery.length>0){
                $scope.lockCustomer = true; // Blocco la lookup sull'ospedale finché non ho caricato il filtro
                customerDestinationQuery = customerDestinationQuery.slice(0,-4);
                customerDestinationQuery = '(' + customerDestinationQuery + ')';
                patientDestinationQuery = patientDestinationQuery.slice(0,-4);
                patientDestinationQuery = '(' + patientDestinationQuery + ')';
                var filter = dbFilterFactory.getCustomFilter(customerDestinationQuery);
                $scope.patientDestinationFilter = $scope.patientDestinationFilter.concat(dbFilterFactory.getCustomFilter(patientDestinationQuery));
                $scope.lookup.destination_id.filter = $scope.lookup.destination_id.filter.concat(dbFilterFactory.getCustomFilter(customerDestinationQuery));
                $scope.lookup.delivery_destination_id.filter = $scope.lookup.delivery_destination_id.filter.concat(dbFilterFactory.getCustomFilter(customerDestinationQuery));
                recordFactory('customer_destination').filter({page_size:10000},filter)
                    .$promise.then(function (data){
                        // Ottengo la lista dei distinti nosocomi
                        var customerIdList = [];
                        data.list.forEach(function(item){
                            if(item.customer_id && customerIdList.indexOf(item.customer_id)==-1){
                                customerIdList.push(item.customer_id);
                            }
                        });
                        // Compongo il filtro per i customer
                        customerIdList.forEach(function(customerId){
                            customerQuery += 'id=' + customerId + ' OR ';
                            patientCustomerQuery += 'd.customer_id=' + customerId + ' OR ';
                        })
                        if(customerQuery.length>0){
                            customerQuery = customerQuery.slice(0,-4);
                            customerQuery = '(' + customerQuery + ')';
                            patientCustomerQuery = patientCustomerQuery.slice(0,-4);
                            patientCustomerQuery = '(' + patientCustomerQuery + ')';
                            $scope.lookup.customer_id.filter = $scope.lookup.customer_id.filter.concat(dbFilterFactory.getCustomFilter(customerQuery));
                            $scope.lookup.patient_id.filter = $scope.lookup.patient_id.filter.concat(dbFilterFactory.getCustomFilter(patientCustomerQuery));
                        }
                        // Sblocco le lookup
                        $scope.lockCustomer = false;
                        $scope.applyFilter();
                    });
            }
        };

        function init() {
            initGridColumns();
            $scope.lookup.patient_id.filter = dbFilterFactory.getStringFilter('t.discriminator', 'PAT');
            var typeFilter = [{
                "column": "receiver_type rt",
                "value": "t.receiver_type_id = rt.id",
                "relation": "JOIN",
                "kind": "rt.code AS type_code"
            }];
            $scope.lookup.destination_id.filter = typeFilter.concat(dbFilterFactory.getInFilter('rt.code', ['REP', 'GUA']));
            var mxParDelTypeCode = 'PDC';
            // [SIXLM-137] aggiunto filtro sul tipo punto di consegna tramite matrix par
            matrixParFactory.getMatrixPar({key: 'deliveryDestinationTypeCode', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}).$promise.then(function(data){
                if (data.value) {
                    mxParDelTypeCode = data.value;
                }
                $scope.lookup.delivery_destination_id.filter = typeFilter.concat(dbFilterFactory.getStringFilter('rt.code', mxParDelTypeCode));
            });
            // Se l'utente è abilitato solo a certi ospedali, filtro tutti i dati di conseguenza.
            // Se poi ho in GET l'id di uno specifico nosocomio, filtro solo su quello e blocco la selezione di altri ospedali.
            if ($routeParams.customer) {
                $scope.lockCustomer = true;
                $scope.lookup.patient_id.filter = $scope.lookup.patient_id.filter.concat(dbFilterFactory.getNumberFilter('d.customer_id', parseInt($routeParams.customer)));
                getCustomer(parseInt($routeParams.customer));
            }
            else{
                getCustomerFilter();
            }
        };

        //___ main ___
        init();

    });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:rebaserCtrl
 * @description
 * # rebaserCtrl
 * Controller of the ictportal.lm
 *
 *
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/rebaser/:id', {
                templateUrl: 'lm/rebaser/rebaser.html',
                controller: 'rebaserCtrl'
            })
    })
    .filter('reverse', function() {
        return function(items) {
          return items.slice().reverse();
        };
      })
    .controller('rebaserCtrl', function ($scope, toaster, COMPONENT_READ_MODE, dbFilterFactory, recordFactory, $rootScope,
                                         $timeout, rebaserFactory, componentUpdateFactory, $routeParams, $uibModal, eggsFormFactory, authFactory) {

            $scope.compReaderMode = COMPONENT_READ_MODE.CODE; // modalità di lettura dei componenti: sia barcode, che unicode

            /***** look up *****/
            $scope.lookup = {};
            $scope.wardrobe = { list: []};  // lista dei guardaroba selezionabili
            $scope.ward = { list: []};  // lista dei reparti selezionabili
            $scope.employee = { list: []};  // lista dei dipendenti selezionabili

            /***** elementi selezionati *****/

            $scope.selected = {};           // elementi selezionati sulla pagina html
            $scope.element = undefined;     // ricompositore scaricato

            /***** stato ricompositore *****/

            $scope.matrixData = {};         // ricompositore
            $scope.matrixWardrobe = {};     // guardaroba di destinazione
            $scope.matrixStructure = {};    // struttura del ricompositore: criteri delle celle...
                                            // se una cella è di un dipendente o contiene componenti di articolo/taglia

            /***** modalità di gestione *****/

            $scope.type = 'TABLE';      // tipo visualizzazione
            $scope.mode = {value: 'INSERT'};     // alla lettura del componente dice se eliminare o aggiungere
            $scope.load = true;         // modalità carico/scarico
            $scope.unloadGarment = { type: 'GENERIC'};

            /***** variabili di appoggio *****/

            $scope.codeList = [];       // lista componenti aggiunti in questa sessione (ha effettivamente senso?)
            $scope.lastInsertedCell = undefined; // ultima cella popolata
            $scope.alreadyInsertedCell = undefined; // ultima cella già caricata
            $scope.lastReadCodes = [];  // buffer per visualizzare gli ultimi componenti letti (per il frontend)

            /***** variabili per lo scarico del ricompositore *****/

            $scope.unloadMap = undefined;
            $scope.unloadList = undefined;
            $scope.unloadKey = undefined;
            $scope.componentShippableStatus = 'SHPBLW';


            /***** variabili per la parte di "COMPONENTI MANCANTI" *****/

            $scope.missingComponents = {
                list: []
            };

            /***** TODO: parte da mettere a posto *****/

            $scope.infoCell = {
                e_name: undefined,
                e_surname: undefined,
                e_matr: undefined,
                cde_id: undefined,
                cde_cd: undefined,
                cde_de: undefined,
                cd_id: undefined,
                cd_cd: undefined,
                cd_de: undefined,
                p_cd: undefined,
                p_de: undefined,
                sz_cd: undefined,
                sz_de: undefined,
                content: undefined
            };


            function enrichCellContent (cell) {
                $scope.infoCell.content = undefined;
                if(cell){
                    $scope.infoCell.content = {
                        full: cell.full,
                        sz: cell.sz,
                        comp: []
                    };
                    for(var i = 0; i < cell.comp.length; i++){
                        var filters = [{
                                "column": "product p",
                                "value": "t.product_id = p.id",
                                "relation": "JOIN",
                                "kind": "p.description as product_description, p.code as product_code"
                            }, {
                                "column": "tab_size ts",
                                "value": "t.size_id = ts.id",
                                "relation": "JOIN",
                                "kind": "ts.code as size_code, ts.description as size_description"
                            }
                        ];
                        filters = filters.concat(dbFilterFactory.getCustomFilter('(t.unicode=\'' + cell.comp[i] + '\' OR t.barcode=\'' + cell.comp[i] + '\')'));
                        recordFactory('component').filter({page_size:1}, filters).$promise.then(function(data) {
                            if(data && data.list[0]){
                                $scope.infoCell.content.comp.push(data.list[0]);
                            }
                        });
                    }
                }
            };


            $scope.getInfoFromCell = function (r, cell) {
                var key = findKeyFromCell (r,cell);
                $scope.infoCell = {};
                enrichCellContent(cell);
                if(key){
                    var ids = key.split("#");
                    if(ids.length == 1){ // componente personalizzato
                        // compilo il dipendente
                        var filter = dbFilterFactory.getCustomFilter('(id=' + ids[0] + ')');
                        recordFactory('human_resource').filter({page_size:10}, filter).$promise.then(function(data) {
                            if(data && data.list && data.list[0]){
                                $scope.infoCell.e_name = data.list[0].name;
                                $scope.infoCell.e_surname = data.list[0].surname;
                                $scope.infoCell.e_matr = data.list[0].matriculation;
                                $scope.infoCell.cde_id = data.list[0].customer_destination_emp_id;
                                $scope.infoCell.cde_cd = data.list[0].customer_destination_emp_code;
                                $scope.infoCell.cde_de = data.list[0].customer_destination_emp_description;
                            }
                        });
                    } else if (ids.length == 3) { // componente non personalizzato
                        // compilo la destinazione cliente, l'articolo e la taglia
                        var filter = dbFilterFactory.getCustomFilter('(id=' + ids[0] + ')');
                        recordFactory('customer_destination').filter({page_size:10}, filter).$promise.then(function(data) {
                            if(data && data.list && data.list[0]){
                                $scope.infoCell.cd_id = data.list[0].id;
                                $scope.infoCell.cd_cd = data.list[0].code;
                                $scope.infoCell.cd_de = data.list[0].description;
                            }
                        });
                        var filter = dbFilterFactory.getCustomFilter('(id=' + ids[1] + ')');
                        recordFactory('product').filter({page_size:10}, filter).$promise.then(function(data) {
                            if(data && data.list && data.list[0]){
                                $scope.infoCell.p_cd = data.list[0].code;
                                $scope.infoCell.p_de = data.list[0].description;
                            }
                        });
                        if(ids[2] != '*'){  // compilo la taglia
                            var filter = dbFilterFactory.getCustomFilter('(id=' + ids[2] + ')');
                            recordFactory('tab_size').filter({page_size:10}, filter).$promise.then(function(data) {
                                if(data && data.list && data.list[0]){
                                    $scope.infoCell.sz_cd = data.list[0].code;
                                    $scope.infoCell.sz_de = data.list[0].description;
                                }
                            });
                        } else {
                            $scope.infoCell.sz_cd = '*';
                            $scope.infoCell.sz_de = 'Varie taglie presenti contemporaneamente';
                        }
                    }
                }
            };

            /***** fine parte da mettere a posto *****/


            /***** scarico *****/


            // scarico della personalizzata
            $scope.$watch('selected.ward', function(newV, oldV) {
                if(newV != oldV && newV) {
                    $scope.unloadMap = undefined;
                    $scope.unloadList = undefined;
                    $scope.unloadKey = undefined;
                    // devo ottenere tutte le celle di dipendente il cui reparto è uguale a quello selezionato
                    for (var row in $scope.matrixStructure) {
                        if($scope.matrixStructure[row].data && $scope.matrixStructure[row].data.cde_id
                            && $scope.matrixStructure[row].data.cde_id.toString() == newV.cd_id.toString()){
                                if(!$scope.unloadMap){
                                    $scope.unloadMap = {};
                                }
                                // lista di celle con un criterio che posso scaricare
                                $scope.unloadMap[row] = $scope.matrixStructure[row].list;
                        }
                    }
                    if($scope.unloadMap){ // se ci sono celle da scaricare, le carico in memoria...
                        for(var row in $scope.unloadMap){
                            if(!$scope.unloadList){
                                $scope.unloadList = [];
                                $scope.unloadList = $scope.matrixStructure[row].list;
                                $scope.unloadKey = row;
                            }
                        }
                    } else {
                        console.log('non ci sono celle disponibili per il criterio selezionato');
                    }
                }
            });


            // scarico della personalizzata
            $scope.$watch('selected.employee', function(newV, oldV) {
                if(newV != oldV && newV) {
                    $scope.unloadMap = undefined;
                    $scope.unloadList = undefined;
                    $scope.unloadKey = undefined;
                    // devo ottenere tutte le celle il cui dipedente è uguale a quello selezionato
                    for (var row in $scope.matrixStructure) {
                        if($scope.matrixStructure[row].data && $scope.matrixStructure[row].data.e_id
                            && $scope.matrixStructure[row].data.e_id.toString() == newV.id.toString()){
                                if(!$scope.unloadMap){
                                    $scope.unloadMap = {};
                                }
                                // lista di celle con un criterio che posso scaricare
                                $scope.unloadMap[row] = $scope.matrixStructure[row].list;
                        }
                    }
                    if($scope.unloadMap){ // se ci sono celle da scaricare, le carico in memoria...
                        for(var row in $scope.unloadMap){
                            if(!$scope.unloadList){
                                $scope.unloadList = [];
                                $scope.unloadList = $scope.matrixStructure[row].list;
                                $scope.unloadKey = row;
                            }
                        }
                    } else {
                        console.log('non ci sono celle disponibili per il criterio selezionato');
                    }
                }
            });


            // scarico della NON personalizzata
            $scope.$watch('selected.wardrobe', function(newV, oldV) {
                if(newV != oldV && newV) {
                    $scope.unloadMap = undefined;
                    $scope.unloadList = undefined;
                    $scope.unloadKey = undefined;

                    $scope.matrixWardrobe = $scope.selected.wardrobe;
                    // devo trovare tutte le celle che contengono non personalizzata con questo guardaroba impostato
                    for (var row in $scope.matrixStructure) {
                        var n = row.indexOf(newV.toString());
                        if(n > -1){
                            if(!$scope.unloadMap){
                                $scope.unloadMap = {};
                            }
                            // lista di celle con un criterio che posso scaricare
                            $scope.unloadMap[row] = $scope.matrixStructure[row].list;
                        }
                    }
                    if($scope.unloadMap){ // se ci sono celle da scaricare, le carico in memoria...
                        for(var row in $scope.unloadMap){
                            if(!$scope.unloadList){
                                $scope.unloadList = [];
                                $scope.unloadList = $scope.matrixStructure[row].list;
                                $scope.unloadKey = row;
                            }
                        }
                    } else {
                        console.log('non ci sono celle disponibili per il criterio selezionato');
                    }
                }
            });


            $scope.$watch('unloadGarment.type', function(newV, oldV) {
                if(newV != oldV) {
                    delete $scope.selected.wardrobe;
                    delete $scope.selected.ward;
                    delete $scope.selected.employee;
                    $scope.unloadMap = undefined;
                    $scope.unloadList = undefined;
                    $scope.unloadKey = undefined;
                }
            });


            // Lettura di un componente in fase di scarico
            $scope.readUnloadComponent = function (read) {
                var filters = buildComponentFilter(read);
                recordFactory('component').filter({page_size:10}, filters).$promise.then(function(data) {
                    if(data.list && data.list.length > 0){
                        var comp = data.list[0];

                        var found = false;
                        // devo cercare il componente nel seguente array di celle: unloadList = [{r: 'a', c: 0}]
                        // inizializzato prima quando sono stati impostati i filtri di ricerca
                        for(var i = 0; i < $scope.unloadList.length; i++){
                            var r = $scope.unloadList[i].r;
                            var c = $scope.unloadList[i].c;
                            if($scope.matrixData[r] && $scope.matrixData[r][c] && $scope.matrixData[r][c].comp) {
                                $scope.matrixData[r][c].comp.forEach( function (iterator){
                                    if(iterator == comp.barcode){
                                        found = true;
                                    }
                                });
                            }
                        }
                        if(!found){
                            // se non c'è in quell'array allora non può essere scaricato
                            toaster.pop('error', 'Componente non scaricabile', 'Il componente non è presente sulla riga che si sta scaricando.');
                        } else {
                            // componente da eliminare dal ricompositore (true: perchè devo metterlo in stato spedibile)
                            componentFoundToDelete(comp, true);
                            //devo tenere aggiornate anche $scope.unloadMap e $scope.unloadList
                            if($scope.unloadList.length == 0){
                                delete $scope.unloadMap[$scope.unloadKey]; // ho scaricato tutto -> quindi elimino
                                $scope.unloadList = undefined;
                                $scope.unloadKey = undefined;
                                // se ci sono altre celle scaricabili le carico
                                for(var row in $scope.unloadMap){
                                    if(!$scope.unloadList){
                                        $scope.unloadList = [];
                                        $scope.unloadList = $scope.matrixStructure[row].list;
                                        $scope.unloadKey = row;
                                    }
                                }
                            }
                        }
                    } else {
                        // componente non trovato
                        toaster.pop('error', 'Componente non trovato', 'Verificare anagrafica');
                        $scope.unloadComponent = undefined;
                    }
                });
            };


            /***** carico *****/


            // ritorna una cella ESISTENTE CON SPAZIO per ospitare componenti
            function findFreeCell(key) {
                var ret = undefined;
                var cellList = undefined;
                if($scope.matrixStructure[key] && $scope.matrixStructure[key].list){
                    cellList = $scope.matrixStructure[key].list;
                }
                if(cellList){
                    cellList.forEach( function (cell){
                        // cell ha proprietà r: "a" (riga), c: 0 (colonna)
                        if($scope.matrixData[cell.r]
                            && $scope.matrixData[cell.r][cell.c]
                            && !$scope.matrixData[cell.r][cell.c].full
                            && $scope.matrixData[cell.r][cell.c].sz > $scope.matrixData[cell.r][cell.c].comp.length){
                                ret = cell;
                        }
                    });
                }
                return ret;
            };



            // dato il componente ritorna la cella nella quale è contenuto
            function findCellFromComponent (component) {
                var cell = undefined;
                for(var j in $scope.matrixData){
                    for(var i = 0; i < $scope.matrixData[j].length; i++){
                        for(var c = 0; c < $scope.matrixData[j][i].comp.length; c++){
                            if(component == $scope.matrixData[j][i].comp[c]) {
                                cell = {
                                    r: j,
                                    c: i
                                };
                            }
                        }
                    }
                }
                return cell;
            }



            // cerca la cella date le coordinate
            function findCellFromCoordinates (r,c) {
                var cell = undefined;
                if($scope.matrixData && $scope.matrixData[r][c]){
                    cell = $scope.matrixData[r][c];
                }
                return cell;
            }



            // dato un array di celle ed il componente ritorna la chiave
            function findKeyFromCell (r,c) {
                var cell = undefined;
                var key = undefined;
                if(c.comp[0]) {
                    cell = findCellFromComponent(c.comp[0]);
                }
                if(cell){
                    for (var row in $scope.matrixStructure) {
                        for (var i = 0; i < $scope.matrixStructure[row].list.length; i++) {
                            if($scope.matrixStructure[row].list[i].r == cell.r && $scope.matrixStructure[row].list[i].c == cell.c){
                                key = row;
                            }
                        }
                    }
                }
                return key;
            }



            // dalle coordinate comunica se la cella è utilizzata o meno
            function isUsedCell(coord){ // coord -> r: "a" (riga), c: 0 (colonna)
                for (var row in $scope.matrixStructure) {
                    for (var i = 0; i < $scope.matrixStructure[row].list.length; i++) {
                        if($scope.matrixStructure[row].list[i].r == coord.r && $scope.matrixStructure[row].list[i].c == coord.c){
                            return true;
                        }
                    }
                }
                return false;
            }



            // ritorna prima cella LIBERA (vuota, non utilizzata da nessuno) del ricompositore
            function createCell() {
                var ret = undefined;
                for(var j = 0; j < $scope.element.column_number; j++){
                    for(var k in $scope.matrixData) {
                        ret = {r: k, c: j}
                        if(!isUsedCell(ret)){
                            return ret;
                        }
                    }
                }
                return undefined;
            };



            // costruisce la chiave per cercare le celle
            function buildKeyCell(component) {
                var key = undefined;
                if(component){
                    if(component.special_use == 'INDIVIDUAL' && component.employee_id){
                        key = component.employee_id.toString();
                    } else {
                        key =
                            (component.shipment_destination != null? component.shipment_destination.toString() : '*')
                            + '#' + component.product_id.toString()
                            + '#' + (component.size_id != null? component.size_id.toString() : '*');
                    }
                }
                return key;
            };



            // controlla se il componente è già stato aggiunto in questa sessione
            // in modo da velocizza il processamento
            function getIndexFromId(id) {
                var i;
                var found = false;
                for (i = 0; i < $scope.codeList.length; i++) {
                    if ($scope.codeList[i] === id) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    i = -1;
                }
                return i;
            };



            /*
            *   ritorna TRUE se è possibile aggiungere il componente al ricompositore
            *  - un componente personalizzato può essere aggiunto se:
            *   il cliente sul reparto del dipendente corrisponde al cliente del guardaroba selezionato
            *  - un componente NON personalizzato può essere aggiunto se:
            *   la destinazione di spedizione del componente è uguale al guardaroba selezionato
            */
           function checkComponent(component) {
                if(component){
                    // personalizzato...
                    if(component.special_use == 'INDIVIDUAL' && component.employee_id){
                        if($scope.lookup.wardrobe.obj.customer_id == component.customer_id){
                            return true;
                        } else {
                            toaster.pop('error', 'Componente pers. non associabile', 'Il cliente sul reparto del dipendente è differente dal cliente del guardaroba selezionato');
                            return false;
                        }
                    } else {
                        // non personalizzato...
                        if(component.shipment_destination && component.shipment_destination == $scope.selected.wardrobe){
                            return true;
                        } else {
                            toaster.pop('error', 'Componente non pers. non associabile', 'Destinazione di sped. sul componente differente dal guardaroba selezionato');
                            return false;
                        }
                    }
                }
                return false;
            };



            // mostro l'errore
            function componentNotFound () {
                toaster.pop('error', 'Componente non trovato', 'Verificare anagrafica');
            }



            // filtro per ottenere il componente e tutte le informazioni necessarie
            function buildComponentFilter (read) {
                var filters = [{
                        "column": "product p",  // articolo del componente
                        "value": "t.product_id = p.id",
                        "relation": "JOIN",
                        "kind": "p.description as product_description, p.code as product_code"
                    },
                    {
                        "column": "tab_size ts",    // taglia del componente
                        "value": "t.size_id = ts.id",
                        "relation": "JOIN",
                        "kind": "ts.code as size_code, ts.description as size_description"
                    },
                    {
                        "column": "human_resource hr",  // dipendente associato al dipendente (se personalizzato)
                        "value": "t.employee_id = hr.id",
                        "relation": "JOIN",
                        "kind": "hr.matriculation as employee_matriculation, hr.name as employee_name, hr.surname as employee_surname"
                    },
                    {
                        "column": "customer_destination cde",   // reparto del dipendente
                        "value": "hr.destination_id = cde.id",
                        "relation": "JOIN",
                        "kind": "cde.code as customer_destination_emp_code, cde.description as customer_destination_emp_description, cde.id as customer_destination_emp_id"
                    },
                    {
                        "column": "customer ce",    // cliente del dipendente
                        "value": "cde.customer_id = ce.id",
                        "relation": "JOIN",
                        "kind": "ce.code as customer_code, ce.description as customer_description, ce.id as customer_id"
                    },
                    {
                        "column": "customer_destination cds",   // destinazione di spedizione del componente
                        "value": "t.shipment_destination = cds.id",
                        "relation": "JOIN",
                        "kind": "cds.code as customer_destination_code, cds.description as customer_destination_description, cds.id as customer_destination_id"
                    }
                ];
                filters = filters.concat(dbFilterFactory.getCustomFilter('(t.unicode=\'' + read.read + '\' OR t.barcode=\'' + read.read + '\')'));
                return filters;
            }



            // eliminazione del componente dalla matrice, viene controllata
            // se deve essere pulita anche la struttura di appoggio dove mi segno le celle
            // -> isShippableComponent TRUE: il componente quando viene scaricato e quindi eliminato
            // dalla matrice viene portato in stato spedibile guardaroba
            function componentFoundToDelete (c, isShippableComponent) {
                var comp = c;
                // elimino dall'array dei letti
                var index = getIndexFromId(comp.id);
                if(index > -1){
                    $scope.codeList.splice(index, 1);
                }
                // svuoto dove salvo l'ultimo comp. inserito
                $scope.lastInsertedCell = undefined;
                $scope.alreadyInsertedCell = undefined;
                // costruisco la chiave
                var key = buildKeyCell(comp);
                // data la chiave cerco le celle
                var cellList = undefined;
                if($scope.matrixStructure[key] && $scope.matrixStructure[key].list){
                    cellList = $scope.matrixStructure[key].list;
                }
                var cellToClear = undefined;
                // cerco e tolgo il componente dalla cella
                if(cellList){
                    cellList.forEach( function (cell){
                        if($scope.matrixData[cell.r] && $scope.matrixData[cell.r][cell.c]){
                            for (var i = 0; i < $scope.matrixData[cell.r][cell.c].comp.length; i++) {
                                if ($scope.matrixData[cell.r][cell.c].comp[i] == comp.barcode) {
                                    $scope.matrixData[cell.r][cell.c].comp.splice(i, 1);
                                    // se il num. di componenti < size: la cella è potenzialmente libera
                                    //TODO: come gestire il caso in cui è l'operatore ad identificare la cella come vuota
                                    if($scope.matrixData[cell.r][cell.c].comp.length < $scope.matrixData[cell.r][cell.c].sz){
                                        $scope.matrixData[cell.r][cell.c].full = 0;
                                    }
                                    // se la lunghezza = 0 -> mi segno la cella da liberare
                                    if($scope.matrixData[cell.r][cell.c].comp.length == 0){
                                        cellToClear = {r: cell.r, c: cell.c}
                                    }
                                }
                            }
                        }
                    });
                    // se necessario devo eliminare la cella dalla struttura (se vuota)
                    if(cellToClear){
                        var del = false;
                        // variabile 'delete' che mi dice se eliminare o meno la voce dalla struttura
                        for (var i = 0; i < $scope.matrixStructure[key].list.length; i++) {
                            if ($scope.matrixStructure[key].list[i].r == cellToClear.r && $scope.matrixStructure[key].list[i].c == cellToClear.c) {
                                $scope.matrixStructure[key].list.splice(i, 1);
                                if($scope.matrixStructure[key].list.length == 0){
                                    del = true;
                                }
                            }
                        }
                        if(del){
                            delete $scope.matrixStructure[key];
                            // devo eliminare o il reparto o il dipendente

                            if(comp.special_use == 'INDIVIDUAL') {
                                // provo ad eliminare il dipendente
                                var employeeIndex = -1;
                                var employeeFound = false;
                                for (var i = 0; i < $scope.employee.list.length; i++) {
                                    if($scope.employee.list[i].id.toString() == key){
                                        employeeIndex = i;
                                        employeeFound = true;
                                    }
                                }
                                if(employeeFound){
                                    $scope.employee.list.splice(employeeIndex, 1);
                                }


                                var wardIndex = -1;
                                var wardFound = false;
                                for (var i = 0; i < $scope.ward.list.length; i++) {
                                    if($scope.ward.list[i].cd_id.toString() == comp.customer_destination_emp_id){
                                        wardIndex = i;
                                        wardFound = true;
                                    }
                                }
                                if(wardFound){
                                    $scope.ward.list.splice(wardIndex, 1);
                                }
                            }
                        }
                    }
                    //TODO: prova di salvataggio
                    var savePromise = saveRebaser();
                    savePromise.then(function (data) {
                        if(data && data.result == 'ok') {
                            console.log('salvataggio avvenuto correttamente');
                            // occorre anche impostare il componente in stato spedibile

                            if(isShippableComponent){
                                var jsonRead = {
                                    reads: [{read: comp.barcode}]
                                };
                                if(!comp.divcod){
                                    toaster.pop('error', 'Impossibile aggiornare stato componente: divisione non impostata sul componente');
                                } else {
                                    componentUpdateFactory.update({status: $scope.componentShippableStatus, plantCode: comp.divcod}, jsonRead).$promise.then(function (data) {
                                        console.log('ok update storico componente: ' + comp.barcode);
                                    }
                                    ).catch(function (data) {
                                        console.log('error update storico componente: ' + comp.barcode);
                                    });
                                }
                            } else {
                                console.log('Componente da non mettere in stato spedibile.')
                            }
                        } else {
                            toaster.pop('error', 'Errore durante il salvataggio del ricompositore');
                        }
                    });
                } else {
                    toaster.pop('error', 'Componente non dissociabile dal ricompositore');
                }
            }



            function deleteComponent (read) {
                var filters = buildComponentFilter(read);
                recordFactory('component').filter({page_size:10}, filters).$promise.then(function(data) {
                    if(data.list && data.list.length > 0){
                        toaster.pop('info', 'Letto comp. in eliminazione: ' + data.list[0].barcode, '');
                        // componente trovato, lo elimino (false: perchè non devo metterlo in stato spedibile)
                        componentFoundToDelete(data.list[0], false);
                    } else {
                        // componente non trovato
                        componentNotFound();
                    }
                });
            };



            /*
            *   inserisce il componente nella cella passata
            *   - se sono in insertMode, devo segnarmi la cella nella struttura
            *   - se NON sono in insertMode, vuol dire che è già stata segnata come "utilizzata" per un certo criterio
            *
            *   cell avrà due proprietà r: "a" (riga), c: 0 (colonna)
            */
            function insertCell(component, cell, insertMode) {
                // elimino la pulsazione sull'ultima cella aggiornata
                if($scope.lastInsertedCell){
                    $scope.matrixData[$scope.lastInsertedCell.r][$scope.lastInsertedCell.c].pulse = false;
                }
                $scope.matrixData[cell.r][cell.c].comp.push(component.barcode);
                // segno la cella come piena se i componenti hanno raggiunto la dimensione fissata
                $scope.matrixData[cell.r][cell.c].full = $scope.matrixData[cell.r][cell.c].full
                    || ($scope.matrixData[cell.r][cell.c].sz == $scope.matrixData[cell.r][cell.c].comp.length);
                $scope.matrixData[cell.r][cell.c].pulse = true; // pulsazione sulla cella
                $scope.lastInsertedCell = cell;                 // ultimo componente inserito
                $scope.codeList.push(component.id);
                if(insertMode) {
                    var key = buildKeyCell(component);
                    var cellList = undefined;

                    if($scope.matrixStructure[key] && $scope.matrixStructure[key].list){
                        cellList = $scope.matrixStructure[key].list;
                    }

                    if(cellList){
                        // se trovo una lista di celle posso fare una push
                        $scope.matrixStructure[key].list.push(cell);
                    } else {
                        // altrimenti instanzio una lista
                        $scope.matrixStructure[key] = {};
                        $scope.matrixStructure[key].list = [];
                        $scope.matrixStructure[key].list.push(cell);
                    }
                    // PARTE DI CARICAMENTO DATI
                    // se non ho già caricato i dati li carico
                    if(!$scope.matrixStructure[key].data){
                        var ids = key.split("#");
                        if(ids.length == 1){
                            // è personalizzato: compilo il dipendente
                            $scope.matrixStructure[key].data = {
                                e_id: component.employee_id,
                                e_name: component.employee_name,
                                e_surname: component.employee_surname,
                                e_matr: component.employee_matriculation,
                                cde_id: component.customer_destination_emp_id,
                                cde_cd: component.customer_destination_emp_code,
                                cde_de: component.customer_destination_emp_description
                            };
                            // aggiungo il dipendente ad un array di dipendenti caricati (da poter visualizzare in fase di scarico)
                            var insertEmployeeInUnloadList = true;
                            for(var emp in $scope.employee.list){
                                if(emp.id == component.employee_id){
                                    insertEmployeeInUnloadList = false;
                                }
                            }
                            if(insertEmployeeInUnloadList) {
                                $scope.employee.list.push({
                                    id: component.employee_id,
                                    name: component.employee_name,
                                    surname: component.employee_surname,
                                    matr: component.employee_matriculation,
                                    cd_id: component.customer_destination_emp_id,
                                    cd_cd: component.customer_destination_emp_code,
                                    cd_de: component.customer_destination_emp_description
                                });
                            }

                            var insertWardInUnloadList = true;
                            for(var emp in $scope.ward.list){
                                if(emp.customer_destination_id == component.customer_destination_emp_id){
                                    insertWardInUnloadList = false;
                                }
                            }
                            if(insertWardInUnloadList) {
                                $scope.ward.list.push({
                                    cd_id: component.customer_destination_emp_id,
                                    cd_cd: component.customer_destination_emp_code,
                                    cd_de: component.customer_destination_emp_description
                                });
                            }

                        } else if (ids.length == 3) {
                            // non personalizzato: compilo articolo, dest., taglia
                            $scope.matrixStructure[key].data = {
                                cd_cd: component.customer_destination_emp_code,
                                cd_de: component.customer_destination_emp_description,
                                p_cd: component.product_code,
                                p_de: component.product_description
                            };
                            if(ids[2] != '*'){
                                $scope.matrixStructure[key].data.sz_cd = component.size_code;
                                $scope.matrixStructure[key].data.sz_de = component.size_description;
                            } else {
                                $scope.matrixStructure[key].data.sz_cd = '*';
                                $scope.matrixStructure[key].data.sz_de = 'Varie taglie presenti contemporaneamente';
                            }
                        }
                    }
                }
            }



            // controllo il componente se è conforme, e lo aggiungo al ricompositore
            function componentFoundToInsert (c) {
                // controllo componente
                if(checkComponent(c)){
                    console.log('Inserimento: ' + c.unicode + ' criteri sulla dest. di sped. soddisfatti, è possibile agg. il componente');
                    var index = getIndexFromId(c.id);
                    // se non è già stato letto lo processo

                    //data la chiave devo controllare se il componente è già stato inserito precedentemente
                    var keySearch = buildKeyCell(c);
                    var found = false;
                    $scope.alreadyInsertedCell = undefined;
                    var cellList = undefined;
                    if($scope.matrixStructure[keySearch] && $scope.matrixStructure[keySearch].list){
                        cellList = $scope.matrixStructure[keySearch].list;
                    }
                    if(cellList){
                        cellList.forEach( function (cell){
                            // cell ha proprietà r: "a" (riga), c: 0 (colonna)
                            if($scope.matrixData[cell.r] && $scope.matrixData[cell.r][cell.c] && $scope.matrixData[cell.r][cell.c].comp){
                                for (var i = 0; i < $scope.matrixData[cell.r][cell.c].comp.length; i++) {
                                    if ($scope.matrixData[cell.r][cell.c].comp[i] == c.barcode) {
                                        found = true;
                                        $scope.alreadyInsertedCell = cell;
                                    }
                                }
                            }
                        });
                    }

                    if(index===-1 && !found){
                        $scope.alreadyInsertedCell = undefined;
                        // costruisco la chiave
                        var key = buildKeyCell(c);
                        // data la chiave ritorna una cella in grado di ospitare il componente (con spazio)
                        var cell = findFreeCell(key);
                        if(cell){
                            // aggiungo alla cella trovata se esiste
                            insertCell(c, cell, false);
                        } else {
                            // ricerca di una cella vuota/libera
                            var newCell = createCell();
                            if(newCell){
                                // aggiungo alla cella nuova appena trovata
                                insertCell(c, newCell, true);
                            } else {
                                toaster.pop('error', 'Celle esaurite', 'Non ci sono celle disponibili da utlizzare');
                            }
                        }
                        //TODO: prova di salvataggio
                        var savePromise = saveRebaser();
                        savePromise.then(function (data) {
                            if(data && data.result == 'ok') {
                                console.log('salvataggio avvenuto correttamente');
                            } else {
                                toaster.pop('error', 'Errore durante il salvataggio del ricompositore');
                            }
                        });
                    } else {
                        toaster.pop('error', 'Componente già associato nel ricompositore');
                    }
                } else {
                    console.log('Inserimento: ' + c.unicode + ' criteri sulla dest. di sped. NON soddisfatti');
                    toaster.pop('error', 'Componente non posizionabile', 'Verificare anagrafica');
                }
            }

            function isLocked(component) {
                var result = component.locked == 'T';
                return result;
            }

            // inserimento di un componente, cerco la sua anagrafica
            function insertComponent (read) {
                var filters = buildComponentFilter(read);
                console.log('Inserimento ' + read.read + ' chiamata per risolvere componente');
                recordFactory('component').filter({page_size:10}, filters).$promise.then(function(data) {
                        if(data.list && data.list.length > 0){
                            var component = data.list[0];
                            console.log('Inserimento ' + read.read + ' trovato componente su DB');
                            toaster.pop('info', 'Letto comp. in inserimento: ' + data.list[0].barcode, '');
                            if(isLocked(component)) {
                                showLockedModal(component);
                                if($scope.lastReadCodes.length < 1){
                                    $scope.lastReadCodes.push({
                                        found: true,
                                        locked: true,
                                        read: data.list[0].barcode,
                                        ts: read.ts,
                                        comp: undefined
                                    });
                                } else {
                                    $scope.lastReadCodes.shift();
                                    $scope.lastReadCodes.push({
                                        found: true,
                                        locked: true,
                                        read: read,
                                        ts: read.ts,
                                        comp: undefined
                                    });
                                }
                            }
                            else{
                                console.log('Inserimento ' + read.read + ' non è LOCKED, proseguo inserimento...');
                                // componente trovato -> proseguo nell'aggiunta
                                componentFoundToInsert(component);
                                // **** buffer inserimenti (per ora lo tengo di dimensione 1)
                                if($scope.lastReadCodes.length < 1){
                                    $scope.lastReadCodes.push({
                                        found: true,
                                        locked: false,
                                        read: component.barcode,
                                        ts: read.ts,
                                        comp: component
                                    });
                                } else {
                                    $scope.lastReadCodes.shift();
                                    $scope.lastReadCodes.push({
                                        found: true,
                                        locked: false,
                                        read: component.barcode,
                                        ts: read.ts,
                                        comp: component
                                    });
                                }
                                // **** fine buffer inserimenti
                            }
                        } else {
                            console.log('Inserimento ' + read.read + ' NON trovato su DB');
                            // componente non trovato
                            componentNotFound();
                            // **** buffer inserimenti (per ora lo tengo di dimensione 1)
                            if($scope.lastReadCodes.length < 1){
                                $scope.lastReadCodes.push({
                                    found: false,
                                    locked: false,
                                    read: data.list[0].barcode,
                                    ts: read.ts,
                                    comp: undefined
                                });
                            } else {
                                $scope.lastReadCodes.shift();
                                $scope.lastReadCodes.push({
                                    found: false,
                                    locked: false,
                                    read: read,
                                    ts: read.ts,
                                    comp: undefined
                                });
                            }
                            // **** fine buffer inserimenti
                        }
                });
            };

            // Lettura di un componente in fase di carico: lo controlla e viene aggiunto/eliminato al/dal ricompositore
            $scope.readLoadComponent = function (read) {
                if($scope.mode.value == 'INSERT'){
                    console.log('Inizio inserimento: ' + read.read + " modalità: " + $scope.mode.value);
                    insertComponent(read);
                } else {
                    console.log('Inizio eliminazione: ' + read.read + " modalità: " + $scope.mode.value);
                    deleteComponent(read);
                }
            };

            function showLockedModal(component) {
                $scope.lockedComponent = component;
                $timeout(function() {
                    $rootScope.$broadcast('lockedModalCtrl_open');
                }, 0);
            };

            // bottone: segno la cella come piena
            $scope.saveCellAsFull = function (r, c, component) {
                if (angular.isDefined(r) && angular.isDefined(c)) {
                    $scope.matrixData[r][c].full = 1;
                    // elimino il componente appena letto dalla cella (false: perchè non devo metterlo in stato spedibile)
                    componentFoundToDelete(component, false);
                    // cerco una cella nuova e aggiungo il componente
                    componentFoundToInsert(component);
                }
            }



            // 'ANNULLA': elimina l'ultimo inserimento (false: perchè non devo metterlo in stato spedibile)
            $scope.undoInsertComponent = function (component) {
                console.log('ANNULLA: eliminazione del componente letto ' + component.unicode)
                componentFoundToDelete(component, false);
            };



            // costruzione struttura del ricompositore
            function build(rows, columns, cellQty) {
                var ret = {};
                if(rows && columns && cellQty) {
                    if( rows < 26 ) {
                        for(var i = 0 ; i < rows; i++){
                            var chr = String.fromCharCode(97 + i); // key: riga
                            ret[chr] = []; // array con le colonne
                            for(var j = 0 ; j < columns; j++){
                                // building and push cell
                                var cell = {
                                    comp: [],
                                    full: 0,
                                    sz: cellQty
                                };
                                ret[chr].push(cell);
                            }
                        }
                    } else {
                        toaster.pop('error', 'Errore durante la costruzione del ricompositore', 'Numero massimo di righe consentite: 25');
                        // perchè se no le lettere dell'alfabeto non basterebbero...
                    }
                } else {
                    toaster.pop('error', 'Errore durante la costruzione del ricompositore', 'Verificare anagrafica');
                    // se non sono stati impostati i 3 valori necessari...
                }
                return ret;
            };



            // imposta la modalità di visualizzazione del carico
            // (imposta automaticamente anche la modalità di utilizzo)
            $scope.setType = function (type) {
                $scope.setLoad(true);
                $scope.type = type;

                // pulisco le variabili se arrivo dallo scarico
                $scope.unloadMap = undefined;
                $scope.unloadList = undefined;
                $scope.unloadKey = undefined;
            };



            // imposta la modalità di utilizzo: true (carico), false (scarico)
            $scope.setLoad = function (bool) {
                if($scope.load != bool){
                    // se cambio modalità sbianco le lookup
                    delete $scope.selected.wardrobe;
                    delete $scope.selected.ward;
                    delete $scope.selected.employee;
                    $scope.unloadMap = undefined;
                    $scope.unloadList = undefined;
                    $scope.unloadKey = undefined;
                }
                $scope.load = bool;
            }



            // stampa una descrizione del capo (solo di front-end)
            $scope.getType = function (component_type) {
                $scope.setLoad(true);
                switch (component_type) {
                    case 'INDIVIDUAL':
                        return 'Capo personalizzato';
                        break;
                    case 'GENERIC':
                        return 'Capo non personalizzato';
                        break;
                    default:
                        return '';
                        break;
                }
            };



            // stampa una lista di celle (solo di front-end)
            $scope.printArray = function (v) {
                var ret = '';
                for (var i = 0; i < v.length; i++) {
                    ret = ret+'<span class="label label-default">' + v[i].r.toUpperCase() + v[i].c.toString() + '</span> ';
                }
                return ret;
            };



            // stampa il totale dei componenti per una lista di celle (solo di front-end)
            $scope.printComponentNumbers = function (v) {
                var ret = 0;
                // v: è l'array di celle che mi salvo nella matrixStructure
                for (var i = 0; i < v.length; i++) {
                    // riga: v[i].r, colonna: v[i].c, ricomp: $scope.matrixData
                    ret = ret + $scope.matrixData[v[i].r][v[i].c].comp.length;
                }
                return ret;
            }

            // stampa il totale dei componenti per una lista di celle (solo di front-end)
            $scope.printComponentNumbersForSingleCell = function (r, c) {
                var ret = $scope.matrixData[r][c].comp.length;
                return ret;
            }

            // funzione per stampare il numero di colonne sulla tabella (solo di front-end)
            $scope.range = function(count){
                var ratings = [];
                for (var i = 0; i < count; i++) { ratings.push(i); }
                return ratings;
            };



            // deselezione guardaroba corrente
            $scope.resetWardrobe = function () {
                $scope.selected.wardrobe = undefined;
                $scope.matrixWardrobe = {};
                $scope.unloadMap = undefined;
                $scope.unloadList = undefined;
                $scope.unloadKey = undefined;
            };

            // deselezione reparto corrente
            $scope.resetWard = function () {
                delete $scope.selected.ward;
                $scope.unloadMap = undefined;
                $scope.unloadList = undefined;
                $scope.unloadKey = undefined;
            };

            // deselezione dipendente corrente
            $scope.resetEmployee = function () {
                delete $scope.selected.employee;
                $scope.unloadMap = undefined;
                $scope.unloadList = undefined;
                $scope.unloadKey = undefined;
            };


            // svuota il ricompositore
            $scope.setEmpty = function () {
                // imposto il carico
                $scope.setLoad(true);
                // svuoto il ricompositore e la struttura di appoggio
                $scope.matrixData = build($scope.element.row_number,$scope.element.column_number, $scope.element.quantity);
                $scope.matrixStructure = {};
                // svuoto tutte le strutture di appoggio
                $scope.codeList = [];
                $scope.lastInsertedCell = undefined;
                $scope.lastReadCodes = [];
                $scope.ward = { list: []};  // lista dei reparti selezionabili (anche questa va svuotata)
                $scope.employee = { list: []};  // lista dei dipendenti selezionabili (anche questa va svuotata)
                //TODO: prova di salvataggio
                var savePromise = saveRebaser();
                savePromise.then(function (data) {
                    if(data && data.result == 'ok') {
                        console.log('salvataggio avvenuto correttamente');
                    } else {
                        toaster.pop('error', 'Errore durante il salvataggio del ricompositore');
                    }
                });
            };



            // inizializzazione lista guardaroba
            function initWardrobes () {
                var filters = [
                    {
                        "column": "receiver_type rt",
                        "value": "t.receiver_type_id = rt.id",
                        "relation": "JOIN",
                        "kind": "rt.id AS receiver_type_id"
                    },
                    {
                        "column": "rt.code",
                        "value": "GUA",
                        "relation": "=",
                        "kind": "string"
                    },
                ];
                recordFactory('customer_destination').filter({ page_size: 10000 }, filters).$promise.then(function (data) {
                    if (data.list && data.list.length > 0) {
                        $scope.wardrobe.list = data.list;
                    } else {
                        $scope.wardrobe.list = [];
                    }
                });
            }



            // inizializzione lista reparti
            function initWards () {
                var filters = [
                    {
                        "column": "receiver_type rt",
                        "value": "t.receiver_type_id = rt.id",
                        "relation": "JOIN",
                        "kind": "rt.id AS receiver_type_id"
                    },
                    {
                        "column": "rt.code",
                        "value": "REP",
                        "relation": "=",
                        "kind": "string"
                    },
                ];
                recordFactory('customer_destination').filter({ page_size: 10000 }, filters).$promise.then(function (data) {
                    if (data.list && data.list.length > 0) {
                        $scope.ward.list = data.list;
                    } else {
                        $scope.ward.list = [];
                    }
                });
            }



            // confronto se è stato modificato il numero di righe o di colonne
            // se le righe o le colonne sono state modificate, verifico se devo sbiancare o meno la matrice
            function checkIntegrityRebaser(json) {
                var rowNumberJson = 0;
                var colNumberJson = 0;
                // conto le righe e le colonne
                for(var i in json.matrixData){
                    rowNumberJson++;
                    // al momento non saprei come controllare meglio la lunghezza...
                    if(colNumberJson < json.matrixData[i].length){
                        colNumberJson = json.matrixData[i].length;
                    }
                }
                // in tutti i casi riempio comunque la struttura della matrice
                if(rowNumberJson == $scope.element.row_number && colNumberJson == $scope.element.column_number){
                    $scope.matrixData = json.matrixData;
                    $scope.matrixStructure = json.matrixStructure;

                    /** init guardaroba selezionato */
                    $scope.matrixWardrobe = json.matrixWardrobe;
                    $scope.selected.wardrobe = json.matrixWardrobe;
                    /****************************** */

                    if(json.w_list){
                        $scope.ward.list = json.w_list;
                    } else {
                        $scope.ward.list = [];
                    }
                    if(json.e_list){
                        $scope.employee.list = json.e_list;
                    } else {
                        $scope.employee.list = [];
                    }
                } else {
                    $scope.matrixData = build($scope.element.row_number,$scope.element.column_number, $scope.element.quantity);
                    $scope.matrixStructure = {};
                }
            }



            // recupero del ricompositore
            function getRebaser (id) {
                recordFactory('rebaser').byId({id: id}).$promise.then(function (data) {
                    if(data) {
                        $scope.element = data;
                        // costruisco la matrice dei dati vuota
                        if(!$scope.element.rawdata){
                            $scope.matrixData = build($scope.element.row_number,$scope.element.column_number, $scope.element.quantity);
                            $scope.matrixStructure = {};
                        } else {
                            // costruisco la matrice dei dati dal JSON
                            var json = JSON.parse($scope.element.rawdata);
                            // controllo l'integrità dei dati
                            checkIntegrityRebaser(json);
                        }
                    } else {
                        toaster.pop('error', 'Errore durante il recupero del ricompositore', 'Verificare anagrafica');
                    }
                });
            };


            /*************** VIS. CAPI MANCANTI **************/


            $scope.initMissingComponents = function () {
                console.log("------ init page missing components ------------");
                var comps = [];
                if($scope.matrixData) {
                    for(var j in $scope.matrixData){
                        for(var i = 0; i < $scope.matrixData[j].length; i++){
                            comps = comps.concat($scope.matrixData[j][i].comp);
                        }
                    }
                }
                console.log("--------- COMPONENTS IN MATRIX -------------------");
                console.log(comps);
                var compsArrayToSend = "";
                var i = 0;
                for (var j = 0; j < comps.length; j++){
                    if(j == 0){
                        compsArrayToSend += "" + comps[j] + "";
                    } else {
                        compsArrayToSend += ",";
                        compsArrayToSend += "" + comps[j] + "";
                    }
                }
                compsArrayToSend += "";
                var json = {
                    unicodes: compsArrayToSend,
                    shipment_destination: $scope.matrixWardrobe.id.toString(),
                    status: "L,E,WIP"
                };
                rebaserFactory.returnMissingItem(json).$promise.then(function (data) {
                    console.log("--------- MISSING ITEMS -------------------");
                    console.log(data);
                    if(data.result){
                        $scope.missingComponents.list = data.result;
                    }
                });
            }



            /*************************************************/


            // salvataggio del ricompositore
            function saveRebaser () {
                $scope.element.rawdata = {
                    matrixData: $scope.matrixData,
                    matrixStructure: $scope.matrixStructure,
                    matrixWardrobe: $scope.matrixWardrobe,
                    e_list: $scope.employee.list,
                    w_list: $scope.ward.list
                };
                var jsonString = JSON.stringify($scope.element.rawdata); // viene salvato solamente lo stato
                return rebaserFactory.update({id: $scope.element.id}, jsonString).$promise;
            };



            // initLookups(): Inizializza le lookup su guardaroba e reparti
            function initLookups(){
              $scope.wardrobeFilter = [
                {
                  "column": "receiver_type rt",
                  "value": "t.receiver_type_id = rt.id",
                  "relation": "JOIN",
                  "kind": "rt.id AS receiver_type_id"
                },
                {
                  "column": "rt.code",
                  "value": "GUA",
                  "relation": "=",
                  "kind": "string"
                }
              ];
              if($scope.authData.info.divCod != null){
                $scope.wardrobeFilter = $scope.wardrobeFilter.concat(dbFilterFactory.getCustomFilter("(t.divcod = " + $scope.authData.info.divCod + " OR t.divcod IS NULL)"));
              }
              if($scope.authData.filters.customer_destination.length > 0){
                $scope.wardrobeFilter = $scope.wardrobeFilter.concat($scope.authData.filters.customer_destination[0]);
              }
              eggsFormFactory.addLookup($scope.lookup, 'wardrobe', 'customer_destination', 't.code', 't.description');
              // $scope.wardFilter = [
              //   {
              //     "column": "receiver_type rt",
              //     "value": "t.receiver_type_id = rt.id",
              //     "relation": "JOIN",
              //     "kind": "rt.id AS receiver_type_id"
              //   },
              //   {
              //     "column": "rt.code",
              //     "value": "REP",
              //     "relation": "=",
              //     "kind": "string"
              //   }
              // ];
              // if($scope.authData.info.divCod != null){
              //   $scope.wardFilter = $scope.wardFilter.concat(dbFilterFactory.getCustomFilter("(t.divcod = " + $scope.authData.info.divCod + " OR t.divcod IS NULL)"));
              // }
              // if($scope.authData.filters.customer_destination.length > 0){
              //   $scope.wardFilter = $scope.wardFilter.concat($scope.authData.filters.customer_destination[0]);
              // }
              // eggsFormFactory.addLookup($scope.lookup, 'ward', 'customer_destination', 't.code', 't.description');
              // initWardrobes();
                //initWards();
            };



            function init() {
              $scope.authData = authFactory.getAuthData()
              console.log($scope.authData)

              initLookups();
              if(angular.isDefined($routeParams.id)){
                getRebaser($routeParams.id);
              }
            };

            //___ main ___
            init();
    });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:ReorderLostCtrl
 * @description Funzione di riordino componenti dispersi
 * # ReorderLostCtrl
 * Controller of the ictportal.lm
 *
 */
angular.module('ictportal.lm')
.config(function ($routeProvider) {
    $routeProvider
    .when('/reorder/lost', {
        templateUrl: 'lm/reorderLost/reorderLost.html',
        controller: 'ReorderLostCtrl'
    })
})
.filter('roundup', function () {
    return function (value) {
        return Math.ceil(value);
    };
})
.controller('ReorderLostCtrl', function ($scope, $rootScope, $q, $translate, $window,
    localeFactory, authFactory, dbFilterFactory, matrixParFactory, componentFactory,
    tntReorderSrv, recordFactory, toaster, sixGridPaginationConstants, $location, uiGridConstants, $log, eggsFormFactory) {

        $scope.title = 'reorder.reorder_lost_title';
        $scope.result = {};
        $scope.resultNoEnd = {};
        $scope.productFilter = [];
        $scope.wardrobeFilter = [];
        $scope.destinationFilter = [];
        $scope.renderTable = false;
        $scope.firstTable = true;
        $scope.renderTableNoEnd = false;
        $scope.firstTableNoEnd = true;
        $scope.params = {
            pageNumber: 1,
            pageSize: 15,
            filters: []
        };
        $scope.advFilter = {
            filter: {},
            list: []
        };
        $scope.orderEnabled = false;
        var selectedRows = [];

        $scope.noEnd = false;

        $scope.sixRowSelectionChangedCallback = function(row, col, event){
            selectedRows = row.grid.api.selection.getSelectedRows();
            console.log("selezionate "+selectedRows.length+" righe")
            $scope.orderEnabled = selectedRows.length > 0;
        };

        $scope.sixBulkSelectionCallback = function(scope, rows, evt) {
          // selectedRows = $scope.viewGridOptions.gridApi.selection.getSelectedRows();
          if(scope.length > 0){
            selectedRows = scope[0].grid.api.selection.getSelectedRows();
            console.log("selezionate "+selectedRows.length+" righe")
          }
          if (selectedRows.length === $scope.viewGridOptions.appScopeProvider.params.pageSize) {
            toaster.pop('warn', 'ATTENZIONE! Selezionate solamente le righe della prima pagina');
          }
          // $scope.sixRowSelectionChangedCallback(undefined, undefined, undefined);
          $scope.orderEnabled = selectedRows.length > 0;
        };

        $scope.viewGridOptions = { appScopeProvider: $scope,
            enableFiltering: false,
            multiSelect: true,
            enableSelectAll: true,
            enableRowHeaderSelection: true,
            enableRowSelection: true,
            rowSelectionChanged: $scope.sixRowSelectionChangedCallback,
            rowSelectionChangedBatch: $scope.sixBulkSelectionCallback,
            enablePaginationControls: true,
        };

        $scope.viewGridOptionsNoEnd = { appScopeProvider: $scope,
          enableFiltering: false,
          multiSelect: false,
          enableRowHeaderSelection: false,
          enableRowSelection: false,
          enablePaginationControls: true,
        };


        var _MS_PER_DAY = 1000 * 60 * 60 * 24;

        function dateDiffInDays(from, to) {
            var utc1 = Date.UTC(from.getFullYear(), from.getMonth(), from.getDate());
            var utc2 = Date.UTC(to.getFullYear(), to.getMonth(), to.getDate());

            return Math.floor((utc2 - utc1) / _MS_PER_DAY);
        }

        $scope.$watch('advFilter.filter.lostBefore',
          function () {
            $scope.firstTable = true;
            $scope.firstTableNoEnd = true;
            $scope.params.pageNumber = 1;
            $scope.applyFilter();
          }
        );

        $scope.$watchGroup([
          'advFilter.filter.product',
          'advFilter.filter.wardrobe',
          'advFilter.filter.destination'
        ], function () {
          $scope.firstTable = true;
          $scope.firstTableNoEnd = true;
          $scope.params.pageNumber = 1;
          $scope.applyFilter();
        });

        $scope.applyFilter = function () {
          $scope.advFilter.list.length = 0;

          if ($scope.advFilter.filter.lostBefore) {
            var from = new Date($scope.advFilter.filter.lostBefore);
            var to = new Date();
            if (from <= to) {
              $scope.advFilter.filter.daysBefore = dateDiffInDays(from, to);
              var nextDay = $scope.advFilter.filter.lostBefore.addDays(1);
              $scope.advFilter.list = $scope.advFilter.list.concat(dbFilterFactory.getDateFilter('operation_date', nextDay, '<='));
            } else {
              toaster.pop('error', msg.error, page_msg.past_lost_before);
              $scope.resetPage();
            }
          }

          if ($scope.advFilter.filter.product) {
            var f = dbFilterFactory.getNumberFilter('t.product_id', $scope.advFilter.filter.product);
            $scope.advFilter.list = $scope.advFilter.list.concat(f);
          } else {
            var f = dbFilterFactory.getCustomFilter("p.part_type_id IN (SELECT id FROM part_type where code = 'PIANA')");
            $scope.advFilter.list = $scope.advFilter.list.concat(f);
          }
          if ($scope.advFilter.filter.wardrobe) {
            var f = dbFilterFactory.getNumberFilter('t.shipment_destination', $scope.advFilter.filter.wardrobe);
            $scope.advFilter.list = $scope.advFilter.list.concat(f);
          }

          if ($scope.advFilter.filter.destination) {
            var f = dbFilterFactory.getNumberFilter('t.current_destination_id', $scope.advFilter.filter.destination);
            $scope.advFilter.list = $scope.advFilter.list.concat(f);
          }

          $scope.getData();
          $scope.getDataNoEnd();
        };

        $scope.searchLost = function () {
            if ($scope.advFilter.filter.daysBefore >= 0) {
                var today = new Date();
                var before = today.setDate(today.getDate()-$scope.advFilter.filter.daysBefore);
                $scope.advFilter.filter.lostBefore = new Date(before);
            } else {
                toaster.pop('error', msg.error, page_msg.negative_days_before);
                $scope.resetPage();
            }
        }

        var getGridColums = function () {
          var columnDefs = [];
          columnDefs.push({
            field: "product_code",
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.product_code }} - {{ row.entity.product_description }}</div>',
            translation: 'product',
            width: '500',
            exportCelRowFormat: function(v) { return v.product_code +' - '+ v.product_description; },
            filters: [{
              type: sixGridPaginationConstants.filterType.TEXT,
              condition: uiGridConstants.filter.CONTAINS,
              placeholder: '',
              kind: 'string',
              aliasResolver: 'p.description,p.code'
            }]
          });
          columnDefs.push({
            field: "shipment_dest_code",
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.shipment_dest_code }} - {{ row.entity.shipment_dest_des }}</div>',
            translation: 'wardrobe',
            exportCelRowFormat: function(v) { return v.shipment_dest_code +' - '+ v.shipment_dest_des; },
            filters: [{
              type: sixGridPaginationConstants.filterType.TEXT,
              condition: uiGridConstants.filter.CONTAINS,
              placeholder: '',
              kind: 'string',
              aliasResolver: 'sd.description,sd.code'
            }]
          });
          columnDefs.push({
            field: "current_dest_code",
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.current_dest_code }} - {{ row.entity.current_dest_des }}</div>',
            translation: 'destination',
            exportCelRowFormat: function(v) { return v.current_dest_code +' - '+ v.current_dest_des; },
            filters: [{
              type: sixGridPaginationConstants.filterType.TEXT,
              condition: uiGridConstants.filter.CONTAINS,
              placeholder: '',
              kind: 'string',
              aliasResolver: 'cd.description,cd.code'
            }]
          });
          columnDefs.push({
            field: "quantity",
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.quantity }} ({{ row.entity.quantity_included }} qta.conf.)</div>',
            enableFiltering: false,
            width: 150,
            translation: 'quantity'
          });
          /* $scope.viewGridOptions.columnDefs.push({
              name: 'Boxes',
              field: "boxes",
              width: 150,
              enableCellEdit: true,
              translation: 'boxes'
          }); */

          return columnDefs;
        };

        var initGridColumns = function () {
            $scope.viewGridOptions.columnDefs = getGridColums();
            $scope.viewGridOptionsNoEnd.columnDefs = getGridColums();
        };

        function translateGridColumns() {
            $scope.viewGridOptions.columnDefs.forEach(function (col) {
                if (col.translation) {
                    if (page_msg[col.translation]) {
                        col.name = page_msg[col.translation];
                        col.displayName = page_msg[col.translation];
                    }
                    else {
                        col.name = msg[col.translation];
                        col.displayName = msg[col.translation];
                    }
                }
            });
        };

        $rootScope.$on('$translateRefreshEnd', function () {
            $q.all({
                general: localeFactory.translateMsg(msg),
                specific: localeFactory.translateMsg(page_msg, pageBundle)
            })
                .then(function (data) {
                    initGridColumns();
                    translateGridColumns();
                })
                .catch(function (error) { $log.error(error); });
        });


        function getTimestamp(day) {
            var m = (day.getMonth()+1);
            var mStr = (m<10)?('0'+m.toString()):m.toString();
            var d = (day.getDate());
            var dStr = (d<10)?('0'+d.toString()):d.toString();
            var timestamp = day.getFullYear() + '-' + mStr + '-' +dStr;
            return timestamp;
          }

        function getValidityQuery(table) {
            var timestamp = getTimestamp(new Date());
            var query = '(' + table + '.start_validity_date <= \'' + timestamp +
            '\' AND (' + table + '.end_validity_date IS NULL OR ' + table + '.end_validity_date>\'' + timestamp + '\') )';

            return query;
        }

        $scope.getData = function(api) {
          var having_cond = [{
            column: "count(distinct (e.start_validity_date <= '2019-09-10'AND (e.end_validity_date IS NULL OR e.end_validity_date>'2019-09-10') )" +
              "  AND (ei.start_validity_date <= '2019-09-10' AND (ei.end_validity_date IS NULL OR ei.end_validity_date>'2019-09-10') ))",
            kind: "number",
            relation: ">",
            value: "0"
          }];
          if( $scope.firstTable){
            $scope.renderTable = false;
          }
          $scope.getDataTemplate(having_cond).then(function (data) {
            $scope.viewGridOptions.totalItems = data.totalResults;
            $scope.result.totalResults = data.totalResults;
            $scope.result.list = data.list;
            $scope.renderTable = true
            $scope.firstTable = false;
          });
        };

        $scope.getDataNoEnd = function(api) {
          var having_cond = [{
            column: "count(distinct (e.start_validity_date <= '2019-09-10'AND (e.end_validity_date IS NULL OR e.end_validity_date>'2019-09-10') )" +
              "  AND (ei.start_validity_date <= '2019-09-10' AND (ei.end_validity_date IS NULL OR ei.end_validity_date>'2019-09-10') ))",
            kind: "number",
            relation: "<=",
            value: "0"
          }];
          if( $scope.firstTableNoEnd){
            $scope.renderTableNoEnd = false;
          }
          $scope.getDataTemplate(having_cond).then(function (data) {
            $scope.viewGridOptionsNoEnd.totalItems = data.totalResults;
            $scope.resultNoEnd.totalResults = data.totalResults;
            $scope.resultNoEnd.list = data.list;
            $scope.renderTableNoEnd = true;
            $scope.firstTableNoEnd = false;
          });
        };

        $scope.getDataTemplate = function (having_cond) {
          var p = $q.defer();
            if ($scope.advFilter.filter.lostBefore) {
              var payload = {
                  page: $scope.params.pageNumber,
                  page_size: $scope.params.pageSize,
                  code: $scope.params.code,
                  description: $scope.params.description,
                  show_revision: false,
                  //sort_fields: ($scope.params.sortFields ? $scope.params.sortFields : 'operation_date'),
                  sort_order: $scope.params.sortOrder
              };
              matrixParFactory.getValueOrDefault({key: 'endowmentService.isAgreementItemParent', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'},
              {defaultValue: "false"}).$promise.then(function(data){
              var aiProductFilter = "ai.product_id = p.id";
              if (data.result.value == 'true') aiProductFilter = "ai.product_id = p.parent_product_id";
              var filters = [
                  {
                      "column": "component_status cs",
                      "value": "t.current_component_status_id = cs.id",
                      "relation": "JOIN",
                      "kind": "cs.operation_date, cs.status"
                  },
                  {
                      "column": "product p",
                      "value": "t.product_id = p.id",
                      "relation": "JOIN",
                      "kind": "p.description AS product_description, p.code AS product_code, p.quantity_included AS quantity_included"
                  },
                  {
                      "column": "customer_destination sd",
                      "value": "t.shipment_destination = sd.id",
                      "relation": "JOIN",
                      "kind": "sd.description AS shipment_dest_des, sd.code AS shipment_dest_code"
                  },
                  {
                      "column": "customer_destination cd",
                      "value": "t.current_destination_id = cd.id",
                      "relation": "JOIN",
                      "kind": "cd.description AS current_dest_des, cd.code AS current_dest_code"
                  },
                  {
                      "column": "customer c",
                      "value": "cd.customer_id = c.id",
                      "relation": "JOIN",
                      "kind": "c.description AS customer_des, c.code AS customer_code"
                  },
                  {
                      "column": "agreement a",
                      "value": "a.customer_id = c.id",
                      "relation": "JOIN",
                      "kind": "a.num AS agreement_num, a.description AS agreement_des"
                  },
                  {
                      "column": "agreement_item ai",
                      "value": "ai.agreement_id = a.id AND " + aiProductFilter,
                      "relation": "JOIN",
                      "kind": "ai.id"
                  },
                  {
                    "column": "endowment e",
                    "value": "e.destination_id = cd.id",
                    "relation": "LEFT JOIN",
                    "kind": "ei.id"
                  },
                  {
                    "column": "endowment_item ei",
                    "value": "ei.product_id = p.id AND ei.endowment_id = e.id",
                    "relation": "LEFT JOIN",
                    "kind": "ei.id"
                  }
              ].concat(dbFilterFactory.getStringFilter('t.status', 'LOST'));  // FIXME: usare t.status? (più performante)

              var azcod = authFactory.getAuthData().info.azCod;
              var divcod = authFactory.getAuthData().info.divCod;
              filters = filters.concat(dbFilterFactory.getNumberFilter('t.azcod', azcod));
              filters = filters.concat(dbFilterFactory.getNumberFilter('t.divcod', divcod));

              filters = filters.concat(dbFilterFactory.getCustomFilter(getValidityQuery('a')));
              filters = filters.concat(dbFilterFactory.getCustomFilter(getValidityQuery('ai')));

              filters = filters.concat($scope.advFilter.list);
              // filters = filters.concat($scope.params.filters); // aggancio i filtri sopra alle colonne

              p.resolve(recordFactory('component').aggregation(payload, {
                  filters: filters,
                  fields: ['p.description AS product_description', 'p.code AS product_code', 'p.quantity_included AS quantity_included',
                      'sd.description AS shipment_dest_des', 'sd.code AS shipment_dest_code',
                      'cd.description AS current_dest_des', 'cd.code AS current_dest_code',
                      'a.num AS agreement_num', 'a.description AS agreement_des',
                      'p.id AS p_id', 'sd.id AS sd_id', 'cd.id AS cd_id', 'a.id AS a_id'],
                  operations: [{
                      function: "count",
                      argument: "distinct t.id",
                      alias: "quantity"
                  },
                    {
                      function: "count",
                      argument: "distinct (e.start_validity_date <= '2019-09-10'AND (e.end_validity_date IS NULL OR e.end_validity_date>'2019-09-10') )" +
                        "  AND (ei.start_validity_date <= '2019-09-10' AND (ei.end_validity_date IS NULL OR ei.end_validity_date>'2019-09-10') )",
                      alias: "endowment"
                    }],
                  having_cond: having_cond
              }).$promise)
              });

              return p.promise;
            }

          p.resolve({totalResults: 0, list: [] });
          return p.promise
        };


        $scope.saveOrder = function () {
            if (!$scope.orderType) {
                toaster.pop('error', msg.error, page_msg.missing_order_type);
            } else {
            var lostBefore = new Date();
            lostBefore = $scope.advFilter.filter.lostBefore.addDays(1);
            if (lostBefore == null) {
                toaster.pop('error', msg.error, page_msg.lost_before_not_set);
                return;
            }
            // 1) raggruppamento righe per guardaroba
            var wardrobeRows = [];
            selectedRows.forEach(function(r) {
                this[r.sd_id] || wardrobeRows.push(this[r.sd_id] = []);
                this[r.sd_id].push(r);
            }, Object.create(null));
            var azcod = authFactory.getAuthData().info.azCod;
            var divcod = authFactory.getAuthData().info.divCod;
            var payload = {
                page_size: -1
            }
            // 2) creazione ordini per ogni guardaroba
            wardrobeRows.forEach(function(wardrobe) {
                var destination = {"id": wardrobe[0].sd_id, "is_wardrobe": true};
                var rows = [];
                var priority = null;
                var yourOrder = null;
                var yourOrderDate = null;
                var note = null;
                var productQtyInc = new Map();
                wardrobe.forEach(function (row) {
                    var rowIdx = rows.findIndex(function(o){return o.product.id==row.p_id;});
                    // raggruppamento per articolo
                    if (rowIdx != -1) {
                        rows[rowIdx].stock_amount += row.quantity;
                    } else {
                        rows.push({"product": {"id": row.p_id},
                            "stock_amount": row.quantity,
                            "agreement": {"id": row.a_id},
                            "current_dest": {"id": row.cd_id}});
                        productQtyInc.set(row.p_id, row.quantity_included);
                    }
                });
                // [SIXLM-240] la quantità delle righe d'ordine viene arrotondata per quantità confezione
                rows.forEach(function(row) {
                    var actualQty = row.stock_amount;
                    var qtyInc = productQtyInc.get(row.product.id);
                    var packs = Math.floor(actualQty/qtyInc);
                    if ((actualQty % qtyInc) > 0) {
                        row.stock_amount = (packs * qtyInc) + qtyInc;
                    }
                });

              var product_ids = wardrobe.map(function(r) { return r.p_id; });
              var agreement_ids = wardrobe.map(function(r) { return r.a_id; });
              var curr_dest_ids = wardrobe.map(function(r) { return r.cd_id; });
              var filters = [{
                "column": "component_status cs",
                "value": "t.current_component_status_id = cs.id",
                "relation": "JOIN",
                "kind": "cs.operation_date, cs.status"
              },
                {
                  "column": "customer_destination sd",
                  "value": "t.shipment_destination = sd.id",
                  "relation": "JOIN",
                  "kind": "sd.id AS sd_id"
                },
                {
                  "column": "customer_destination cd",
                  "value": "t.current_destination_id = cd.id",
                  "relation": "JOIN",
                  "kind": "cd.id AS cd_id"
                },
                {
                  "column": "agreement a",
                  "value": "a.customer_id = cd.customer_id",
                  "relation": "JOIN",
                  "kind": "a.id AS a_id"
                }].concat(dbFilterFactory.getStringFilter('t.status', 'LOST'))  // FIXME: cs.status?
                .concat(dbFilterFactory.getNumberFilter('t.azcod', azcod))
                .concat(dbFilterFactory.getNumberFilter('t.divcod', divcod))
                .concat(dbFilterFactory.getNumberFilter('t.shipment_destination', destination.id))
                .concat(dbFilterFactory.getInFilter('t.current_destination_id', curr_dest_ids))
                .concat(dbFilterFactory.getInFilter('t.product_id', product_ids))
                .concat(dbFilterFactory.getInFilter('a.id', agreement_ids))
                .concat(dbFilterFactory.getDateFilter('operation_date', lostBefore, '<='));
              // recupero il dettaglio dei singoli componenti
              recordFactory('component').filter(payload, filters)
                .$promise.then(function (data) {
                // 3) ogni componente passa in stato "STATUS_REINTEGRATED"
                // e ne vengono vuotati i campi "shipment_destination", "current_destination_id" e "agreement_id"
                if(data.list && data.list.length>0){
                  var oldComps = {};
                  var orderRequest = {
                    customer_destination: destination.id,
                    type: $scope.orderType.id,
                    priority: priority,
                    note: note,
                    vostro_ordine: yourOrder,
                    data_vostro_ordine: yourOrderDate,
                    row_list: rows.map(function (e) {
                      return {
                        product_id: e.product.id,
                        stock_amount: e.stock_amount,
                        agreement_id: e.agreement.id
                      };
                    })
                  }
                  var componentsDto = {
                    "ids": [],
                    "status": "RI", // stato reintegrato
                    "shipment_destination_code": "",
                    "current_destination_code": "",
                    "agreement_number": "",
                    "azcod": azcod,
                    "divcod": divcod,
                    "customer_order_request": orderRequest
                  };
                  data.list.forEach(function (comp) {
                    componentsDto.ids.push(comp.id)

                  });
                    componentFactory.updateAndReorderComponents({},componentsDto).$promise
                      .then(function(response) {
                        if(response.success) {
                          console.log(response.message);
                          toaster.pop('success', 'Componenti aggiornati e ordini creati', '')

                          // aggiorno la griglia
                          var processed = wardrobe.map(function(r) { return r.$$hashKey; });
                          $scope.result.list = $scope.result.list.filter(
                            function(o) {
                              return processed.indexOf(o.$$hashKey) == -1;
                            }
                          );
                          $scope.firstTable = true;
                          $scope.firstTableNoEnd = true;
                          $scope.getData();
                          $scope.getDataNoEnd();
                        } else {
                          console.log(response)
                          console.error(response.message);
                          toaster.pop('error', msg.error, response.message);
                        }
                      }).catch(function(ex){ logError(ex) });
                }
              });

            });
            }
        };

        var logError = function logError(ex) {
            $log.log(ex);
            toaster.pop('error', msg.error, msg.server_comunication_error);
        };

        $scope.resetPage = function () {
            $scope.advFilter.filter.lostBefore = null;
            $scope.advFilter.filter.daysBefore = null;
            $scope.advFilter.filter.product = undefined;
            $scope.lookup.product.obj = {};
            $scope.advFilter.filter.wardrobe = undefined;
            $scope.lookup.wardrobe.obj = {};
            $scope.advFilter.filter.destination = undefined;
            $scope.lookup.destination.obj = {};

        }

        $scope.displayMessages = function (messages) {
            angular.forEach(messages, function (notification) {
                var params = {};
                if (notification.params) {
                    notification.params.forEach(function (p, index) {
                        params['p' + index] = p;
                    });
                }
                var key = 'reorder.' + notification.code;
                localeFactory.translateReplace(key, params).then(function (translatedMsg) {
                    var message = (translatedMsg === key) ? notification.message : translatedMsg;
                    var status = notification.status.toLowerCase();
                    toaster.pop(status, msg[status], message);
                });
            });
        };

        function checkPermissions() {
            var profilingKey = 'REORDER_LOST_FUNCTION';
            var permission = authFactory.getPermissions(profilingKey);
            if(!permission.EXEC) {
                $location.path('forbidden').search({key: profilingKey});
            }
        };

        var pageBundle = 'reorder';
        var msg = {};
        var page_msg = {"product": 'Articolo',
            "quantity": 'Quantità',
            "boxes": 'Colli',
            "wardrobe": 'Guardaroba',
            "destination": 'Destinazione',
            "agreement": 'Contratto',
            "missing_order_type": "Tipo d'ordine non configurato, contatta l'amministratore",
            "lost_before_not_set": "Filtro data dispersi non impostato!",
            "past_lost_before": "La data non può essere nel futuro",
            "negative_days_before": "Il numero di giorni deve essere maggiore o uguale a 0"
        };

        function initLookups() {
          $scope.lookup = {};
          eggsFormFactory.addLookup($scope.lookup, 'product', 'product', 'code', 'description');
          eggsFormFactory.addLookup($scope.lookup, 'wardrobe', 'customer_destination', 'code', 'description');
          eggsFormFactory.addLookup($scope.lookup, 'destination', 'customer_destination', 'code', 'description');
        };

        function init() {
            $scope.productFilter = $scope.productFilter.concat(dbFilterFactory.getCustomFilter("t.part_type_id IN (SELECT id FROM part_type where code = 'PIANA')"))
            $scope.wardrobeFilter = dbFilterFactory.getCustomFilter("t.divcod = '" + authFactory.getAuthData().info.divCod + "'")
            initLookups();
            if (localStorage.getItem('firstLoad')) {
            localeFactory.loadTranslation(pageBundle)
            .then(function () {
                $translate(['error', 'server_comunication_error', 'op_completed_success', 'order_created'])
                .then(function (data) {
                    msg = data;
                }, function (error) {
                    console.error(error);
                })
                .finally(function () {
                    checkPermissions();
                    // [SIXLM-240] il tipo ordine per riordino dispersi viene parametrizzato
                    var orderTypeCode = undefined;
                    matrixParFactory.getMatrixPar({key: 'lostReorderTypeCode', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}).
                    $promise.then(function(data){
                        if (data.value) {
                            orderTypeCode = data.value;
                        }
                        tntReorderSrv.loadOrderType(orderTypeCode).then(function (data) {
                            $scope.orderType = data;
                        }).catch($scope.displayMessages);
                    });
                });
            });
            }
        }
        init();

        (function()
        {
            if (window.localStorage)
            {
                if (!localStorage.getItem('firstLoad'))
                {
                    localStorage['firstLoad'] = true;
                    window.location.reload();
                }
                else
                    localStorage.removeItem('firstLoad');
            }
        })();
    });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:setCompositionCtrl
 * @description
 * # setCompositionCtrl
 * Controller of the ictportal.lm
 * 
 * Per filtrare su determinati tipi articolo:
 * http://localhost:9000/#/set/composition?type=KITP&type=KIT&type=PIA
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/set/composition', {
                templateUrl: 'lm/setComposition/setComposition.html',
                controller: 'setCompositionCtrl'
            })
    })
    .controller('setCompositionCtrl', function ($scope, toaster, $location, serialKitLMFactory, $timeout, $filter,
        COMPONENT_READ_MODE, SCAN_KIND, dbFilterFactory, recordFactory, eggsFormFactory, $log, localStorageService,
        $q, $rootScope, localeFactory) {

        var msg = {
            error_title: "Error",
            warning: "Warning",
            no_match_found: "No match found",
            invalid_kit_state: "Invalid kit state"
        };            
        var setCompositionMsg = {
            set_selected_title: "Set selected",
            set_selected_msg: "Serial kits will be linked to set with barcode {{barcode}}",
            set_not_found_title: "Set not found",
            set_not_found_msg: "No serial kit associated do set with barcode {{barcode}}",
            printer_unreachable_msg: "It was not possibile lo reach the printer",
            kit_already_associated_to_set: "Kit already linked to a set",
            kit_added_to_set: "Kit added to set with barcode",
            kit_removal_failure: "It's not possibile to remove the kit",
            kit_not_on_set: "Serial kit is not on selected set",
            kit_removed_from_set: "Kit removed from set with barcode"
        };
        $scope.TAB = {
            SET: 1,
            KIT: 2
        };
        $scope.activeTab = $scope.TAB.SET;
        $scope.serialKitList = [];
        $scope.bomsList = [];
        $scope.compList = [];
        $scope.settings = {};
        $scope.printerCode = '';
        $scope.labelPrinted = false;
        $scope.addMode = true;
        $scope.jsFilter = '';
        $scope.userId = undefined;
        $scope.params = {
            pageNumber: 1,
            pageSize: 100,
            filters: []
        };
        $scope.compReaderMode = COMPONENT_READ_MODE.CODE;

        var queryWithBarcode = [
          {
            "column": "bom b",
            "value": "t.bom_id = b.id",
            "relation": "JOIN",
            "kind": "b.id AS bom_id"
          },
          {
            "column": "product p",
            "value": "b.item_id = p.id",
            "relation": "JOIN",
            "kind": "p.description AS product_description, p.code AS product_code"
          },
          {
            "column": "product_type y",
            "value": "p.product_type_id = y.id",
            "relation": "JOIN",
            "kind": "y.description AS product_type_description, y.code AS product_type_code"
          }
        ];

        var queryWithUnicode = [
          {
            "column": "bom b",
            "value": "t.bom_id = b.id",
            "relation": "JOIN",
            "kind": "b.id AS bom_id"
          },
          {
            "column": "product p",
            "value": "b.item_id = p.id",
            "relation": "JOIN",
            "kind": "p.description AS product_description, p.code AS product_code"
          },
          {
            "column": "product_type y",
            "value": "p.product_type_id = y.id",
            "relation": "JOIN",
            "kind": "y.description AS product_type_description, y.code AS product_type_code"
          },
          {
            "column": "serial_kit_det skd",
            "value": "skd.serial_kit_id = t.id",
            "relation": "JOIN",
            "kind": "skd.id"
          }, {
            "column": "component c",
            "value": "c.id = skd.component_id",
            "relation": "JOIN",
            "kind": "c.unicode as component_unicode"
          }
        ];


        $scope.setAddMode = function (value) {
            if (value != $scope.addMode) {
                $scope.addMode = value;
            }
        };

        // Se c'è, recupero la stampante di default per la workstation corrente
        function getWorkstationPrinter() {
            var workstation = localStorageService.get('workstation');
            if (workstation) {
                var payload = { workstation: workstation };
                serialKitLMFactory.getWsPrinter(payload).$promise.then(function (response) {
                    $scope.settings.label_printer_id = response.printer;
                    recordFactory('printer').byId($scope.settings.label_printer_id).$promise.then(function(printer){
                        $scope.printerCode = printer.code;
                    });
                    //eggsFormFactory.loadLookupData($scope.lookup, $scope.settings);
                });
            }
        };

        function generateBarcode() {
            var deferred = $q.defer();
            serialKitLMFactory.getSetBarcode({ dummy: true }).$promise.then(function (response) {
                if (response.success) {
                    $scope.set = response.barcode;
                }
                else {
                    toaster.pop('error', msg.error_title, response.message);
                }
                deferred.resolve();
            });
            return deferred.promise;
        };

        $scope.printBarcode = function () {
            var payload = {
                printer: $scope.printerCode,
                set_code: $scope.bom.product_code,
                set_desc: $scope.bom.product_description,
                barcode: $scope.set,
                prod_date: $scope.prodLabelDate,
                expir_date: $scope.expirLabelDate
            };
            serialKitLMFactory.printSetLabel(payload).$promise
            .then(function (response) {
                if (response.success) {
                    $scope.goToNewSet();
                } else {
                    toaster.pop('error', msg.error_title, response.error);
                }
            })
            .catch(function(e) {
                toaster.pop('warning', msg.warning, setCompositionMsg.printer_unreachable_msg);
            });
        };

        $scope.readComponentCode = function (read) {
            if ($scope.activeTab === $scope.TAB.KIT) {
                if ($scope.addMode) {
                    addKit(read);
                }
                else {
                    removeKit(read);
                }
            }
        };

        function addKit(read) {
            if (getSerialKitIndexFromBarcode(read.read)===-1) {
                var baseFilters = queryWithBarcode;
                var filters = baseFilters.concat(dbFilterFactory.getStringFilter('barcode', read.read))
                    // il kit non deve appartenere a nessun altro set
                    .concat(dbFilterFactory.getNullableFilter('envelope', 'IS NULL'));
                recordFactory('serial_kit').filter({ page_size: 10000 }, filters).$promise.then(function (data) {
                  if (data.list) {
                    // se ho trovato dei serial kit
                    if(data.list.length > 0) {
                        addRecordToSerialKitList(data.list[0], read);
                    } else {
                        // se NON ho trovato serial kit, risolvo gli UNICODE
                        var componentFilters = queryWithUnicode;
                        componentFilters = componentFilters.concat(dbFilterFactory.getStringFilter('c.unicode', read.read));
                        recordFactory('serial_kit').filter({ page_size: 1, sort_order: 'desc' }, componentFilters).$promise.then(function (data) {
                        if(data.list && data.list.length > 0){
                            addRecordToSerialKitList(data.list[0], read);
                        }
                        else{
                            toaster.pop('error', msg.error_title, msg.no_match_found);
                        }
                      });
                    }
                  }
                });
            }
        };

        function addRecordToSerialKitList (serialKit, read) {
          $log.info(serialKit);
          if (!isValidKitStatus(serialKit)) {
            toaster.pop('error', msg.error_title, msg.invalid_kit_state);
          }
          else {
            var item = { read: read };
            // Verifica componente già letto
            if (item.read.type === SCAN_KIND.BARCODE && item.read.read === serialKit.barcode) {
              item.serialKit = serialKit;
            }
            else if (item.read.type === SCAN_KIND.MANUAL && item.read.read === serialKit.barcode) {
              item.serialKit = serialKit;
              item.read.type = SCAN_KIND.BARCODE;
            }
            serialKit.added = true;
            serialKit.removed = false;
            // controllo per evitare che le chiamate asincrone aggirino il primo controllo getSerialKitIndexFromBarcode()
            // quindi prima di fare una push controllo che una chiamata non abbia già popolato il mio array con lo stesso serialKit
            if (getSerialKitIndexFromBarcode(serialKit.barcode)===-1){
                recordFactory('bom').byId(serialKit.bom_id).$promise.then(function(kitBom){
                    var bomDetElement = $filter('filter')($scope.bomDet, {item_id: kitBom.item_id});
                    if(bomDetElement && bomDetElement.length>0){
                        if(bomDetElement[0].read===bomDetElement[0].amount){
                            toaster.pop('error', msg.error_title, 'Questo kit eccede la quantità prevista per il set');
                        }
                        // controllo anche venga rispettato l'eventuale ordine delle componenti nel bom
                        else if(isValidComponentOrder(kitBom.item_id)) {  
                            $scope.serialKitList.push(serialKit);
                            bomDetElement[0].read++;
                            toaster.pop('success', setCompositionMsg.kit_added_to_set, serialKit.barcode);
                        }
                    }
                });
            }
          }
        }

        function isValidComponentOrder(item_id){
            var isValid = true;
            if($scope.bom.seq_check_enabled==='T'){
                for(var i=0; i<$scope.bomDet.length; i++){
                    var bomDetElement = $scope.bomDet[i];
                    if(item_id===bomDetElement.item_id){
                        isValid = true;
                        break;
                    }
                    else if(bomDetElement.amount!==bomDetElement.read){
                        isValid = false;
                        break;
                    }
                }
            }
            return isValid;
        };

        function removeKit(read) {
            var serialKit = null;
            var baseFilters = queryWithBarcode;
            var filters = baseFilters.concat(dbFilterFactory.getStringFilter('barcode', read.read));
            recordFactory('serial_kit').filter({ page_size: 10000 }, filters).$promise.then(function (data) {
              if (data.list) {
                // se ho trovato dei serial kit
                if(data.list.length > 0) {
                  serialKit = data.list[0];
                  deleteSerialKitFromList(serialKit);
                } else {
                  // se NON ho trovato serial kit, risolvo l'UNICODE
                  var componentFilters = queryWithUnicode;
                  componentFilters = componentFilters.concat(dbFilterFactory.getStringFilter('c.unicode', read.read));
                  recordFactory('serial_kit').filter({ page_size: 1, sort_order: 'desc' }, componentFilters).$promise.then(function (data) {
                    if(data.list && data.list.length > 0){
                      serialKit = data.list[0];
                      deleteSerialKitFromList(serialKit);
                    }
                  });
                }
              }
            });
        };

        function deleteSerialKitFromList(serialKit) {
          var index = getSerialKitIndexFromBarcode(serialKit.barcode);
          if (index===-1) {
            toaster.pop('error', setCompositionMsg.kit_removal_failure, setCompositionMsg.kit_not_on_set);
          }
          else {
            var serialKitFound = $scope.serialKitList[index];
            recordFactory('bom').byId(serialKitFound.bom_id).$promise.then(function(kitBom){
                var bomDetElement = $filter('filter')($scope.bomDet, {item_id: kitBom.item_id});
                $scope.serialKitList.splice(index, 1);
                bomDetElement[0].read--;
                toaster.pop('success', setCompositionMsg.kit_removed_from_set, serialKit.barcode);
                /* serialKitLMFactory.clearMotherEnvelope({ envelope: $scope.set, serial_kit_list: [serialKitFound.id] }).$promise.then(function (data) {
                $log.info("Saved serial kit " + serialKitFound.id);
                }); */
            });
          }
        };

        function getSerialKitIndexFromBarcode(barcode) {
            var i;
            var found = false;
            for (i = 0; i < $scope.serialKitList.length; i++) {
                if ($scope.serialKitList[i].barcode === barcode) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                i = -1;
            }
            return i;
        };

        function isValidKitStatus(serialKit) {
            var result = false;
            if (serialKit) {
                switch (serialKit.status) {
                    case 'PACKED':
                        result = true;
                        break;
                    case 'STERILIZED':
                        result = true;
                        break;
                    default:
                        result = false;
                }
            }
            return result;
        };

        function initLookups() {
            $scope.lookup = {};
            eggsFormFactory.addLookup($scope.lookup, 'label_printer_id', 'label_printer', 'code', 'description');
            $scope.mappingLoaded = true;
        };

        function reinit() {
            $scope.printer = false;
            $scope.packagingError = undefined;
            $scope.generatedBarcode = undefined;
            $scope.compList = [];
            $scope.set = undefined;
            $scope.bomDet = undefined;
            $scope.serialKitList.length = 0;
            $scope.prodLabelDate = undefined;
            $scope.expirLabelDate = undefined;
            $scope.getBoms();
        };

        $scope.goToNewSet = function(){
            reinit();
            $scope.activeTab = $scope.TAB.SET;
        };

        function getTranslations(){
            localeFactory.loadTranslation('set_composition')
            .then(function() {
                localeFactory.translateMsg(msg);
                localeFactory.translateMsg(setCompositionMsg, 'set_composition');
            });
        };

        $scope.getBoms = function () {
            var payload = {
                page: $scope.params.pageNumber,
                page_size: $scope.params.pageSize,
                show_revision: false
            };
            var filters = [
                {
                    "column": "product p",
                    "value": "t.item_id = p.id",
                    "relation": "JOIN",
                    "kind": "p.description AS product_description, p.code AS product_code"
                },
                {
                    "column": "product_type y",
                    "value": "p.product_type_id = y.id",
                    "relation": "JOIN",
                    "kind": "y.description AS product_type_description, y.code AS product_type_code"
                }
            ];
            // Eventualmente, filtro solo su certi tipi articolo (parametro in get, vedi descrizione funzione in alto)
            var types = $location.search().type;
            if(types){
                if(angular.isArray(types)){
                    var productTypeQuery = '(';
                    types.forEach(function(product_type_code){
                        productTypeQuery += 'y.code=\'' + product_type_code + '\' OR ';
                    });
                    productTypeQuery = productTypeQuery.substr(0, productTypeQuery.length-4) + ')';
                    filters = filters.concat(dbFilterFactory.getCustomFilter(productTypeQuery));
                }
                else{
                    filters = filters.concat(dbFilterFactory.getStringFilter('y.code',types));
                }
            }
            // Filtro per validità
            var today = new Date();
            var date = '\'' + today.getFullYear() + '-';
            if(today.getMonth()<9){
                date += '0';
            }
            date += ( (today.getMonth()+1) + '-');
            if(today.getDate()<10){
                date += '0';
            }
            date += (today.getDate() + '\'');
            var validityQuery = '(t.validity_end is null OR t.validity_end>' + date + ')';
            filters = filters.concat(dbFilterFactory.getCustomFilter(validityQuery));
            filters = filters.concat($scope.params.filters);
            recordFactory('bom').filter(payload, filters)
                .$promise.then(function (data) {
                    $scope.bomsList = data.list;
                });
        };

        $scope.selectBom = function(bom){
            $scope.compList.length = 0;
            if(bom){
                $scope.bom = bom;
                // Recupera righe bom
                var filters =  [
                    {
                        "column": "product p",
                        "value": "t.item_id = p.id",
                        "relation": "JOIN",
                        "kind": "p.description, p.code"
                    }
                ];
                filters = filters.concat(dbFilterFactory.getNumberFilter('bom_id', bom.id));
                var payload = {
                    page: 1,
                    page_size: 10000,
                    show_revision: false,
                    sort_fields: 'sequence_index'
                };
                recordFactory('bom_det').filter(payload, filters)
                    .$promise.then(function (data) {
                        $scope.bomDet = data.list;
                        $scope.bomDet.forEach(function(bomDetElement){
                            bomDetElement.read = 0;
                        });
                        $scope.nextStep();
                    });
            }
        };

        $scope.nextStep = function () {
            if ($scope.settings.label_printer_id) {
                $scope.activeTab = $scope.TAB.KIT;
            } else {
                $rootScope.$broadcast('sixPrintModalCtrl_open');
            }
        };

        $scope.onConfirmSelectPrinter = function(code) {
            $scope.printerCode = code;
            $scope.activeTab = $scope.TAB.KIT;
        }

        Array.prototype.getMin = function(attrib) {
            return this.reduce(function(prev, curr){ 
                return prev[attrib] < curr[attrib] ? prev : curr; 
            });
         }

        $scope.printSetLabel = function() {
            // generazione barcode set
            generateBarcode().then(function () {
                var kit_ids = $scope.serialKitList.reduce(function(ids, item){
                    ids.push(item.id);
                    return ids;
                }, []);
                // set campo envelope kit
                serialKitLMFactory.setMotherEnvelope({ envelope: $scope.set, serial_kit_list: kit_ids }).$promise.then(function (response) {
                    if (response.success) {
                        // set campo parent bom kit
                        serialKitLMFactory.setParentBom({ parent_bom: $scope.bom.id, serial_kit_list: kit_ids }).$promise.then(function (response) {
                            if (response.success) {
                                $log.info("Saved serial kit " + kit_ids);
                
                                // calcolo date produzione e scadenza
                                $scope.prodLabelDate = $scope.serialKitList.getMin('created_date').created_date;
                                $scope.expirLabelDate = $scope.serialKitList.getMin('expiration_date').expiration_date;
                
                                // stampa etichetta e ritorno a tab nuovo set
                                $scope.printBarcode();
                            }
                            else {
                                toaster.pop('error', msg.error_title, response.message);
                            }
                        }); 
                    }
                    else {
                        toaster.pop('error', msg.error_title, response.message);
                    }
                });
            });
                
        }


        function init() {
            getTranslations();
            //initLookups();
            getWorkstationPrinter();
            $scope.getBoms();
        };

        //___ main ___
        init();

    });

angular.module('ictportal.lm')
  .service('inventoryItemSrv', function ($q, recordFactory, dbFilterFactory) {

    var service = {};

    function newElem(inventoryItemBody, inventoryItemDetailBody) {
      var deferred = $q.defer();
      var response = {
        inventoryItem: null,
        inventoryItemDetail: null
      };
      recordFactory('inventory_item').create(inventoryItemBody).$promise.then(function (resIns) {
        if (resIns.id) {
          response.inventoryItem = resIns.id;
          inventoryItemDetailBody.inventory_item_id = response.inventoryItem;
          recordFactory('inventory_item_detail').create(inventoryItemDetailBody).$promise.then(function (resInsIID) {
            if (resInsIID.id) {
              response.inventoryItemDetail = resInsIID.id;
              deferred.resolve(response);
            }
          });
        }
      });
      return deferred.promise;
    }

    service.newFromGoodsInwardRow = function (gi, gir) {
      var createdDate = new Date();
      var inventoryItemBody = {
        'azcod': gi.azcod,
        'divcod': gi.divcod,
        'created_date': createdDate,
        'created_user_id': gi.created_user_id,
        'facility_id': gi.wharehouse_id,
        'product_id': gir.item_id,
        'supplier_id': gi.supplier_id
      };
      var inventoryItemDetailBody = {
        'discriminator': 'NORM', // CONST
        'azcod': gi.azcod,
        // 'divcod': gi.divcod, // non presente ?
        'created_date': createdDate,
        'created_user_id': gi.created_user_id,
        'effective_date': gi.rec_date ? new Date(Date.parse(gi.rec_date)) : null,
        'doc_date': gi.dn_date ? new Date(Date.parse(gi.dn_date)) : null,
        'doc_number': gi.dn_number,
        'quantity_on_hand_diff': gir.stock_amount,
        'inventory_item_id': null,
        'inventory_reason_id': gi.inventory_reason_id,
        'color_id': gir.color_id,
        'size_id': gir.size_id
      };
      return newElem(inventoryItemBody, inventoryItemDetailBody);
    };

    service.newFromInventoryCollected = function (ic) {
      var createdDate = new Date();
      var inventoryItemBody = {
        'azcod': ic.azcod,
        'divcod': ic.divcod,
        'created_date': createdDate,
        'created_user_id': ic.created_user_id,
        'facility_id': ic.facility_id,
        'product_id': ic.product_id
      };
      var inventoryItemDetailBody = {
        'discriminator': 'NORM', // CONST
        'azcod': ic.azcod,
        // 'divcod': gi.divcod, // non presente ?
        'created_date': createdDate,
        'created_user_id': ic.created_user_id,
        'effective_date': ic.effective_date,
        'quantity_on_hand_diff': ic.quantity_on_hand_diff,
        'inventory_item_id': null,
        'inventory_reason_id': ic.inventory_reason_id,
        'color_id': ic.color_id,
        'size_id': ic.size_id
      };
      return newElem(inventoryItemBody, inventoryItemDetailBody);
    };

    service.newFromGoodsInwardRowCanceled = function (gi, gir, reasonId) {
      var createdDate = new Date();
      var inventoryItemBody = {
        'azcod': gi.azcod,
        'divcod': gi.divcod,
        'created_date': createdDate,
        'created_user_id': gi.created_user_id,
        'facility_id': gi.wharehouse_id,
        'product_id': gir.item_id,
        'supplier_id': gi.supplier_id
      };
      var inventoryItemDetailBody = {
        'discriminator': 'NORM', // CONST
        'azcod': gi.azcod,
        // 'divcod': gi.divcod, // non presente ?
        'created_date': createdDate,
        'created_user_id': gi.created_user_id,
        'effective_date': createdDate,
        'doc_date': gi.dn_date ? new Date(Date.parse(gi.dn_date)) : null,
        'doc_number': gi.dn_number,
        'quantity_on_hand_diff': -gir.stock_amount,
        'inventory_item_id': null,
        'inventory_reason_id': reasonId,
        'color_id': gir.color_id,
        'size_id': gir.size_id
      };
      return newElem(inventoryItemBody, inventoryItemDetailBody);
    };

    service.updateQuantity = function (girID, body) {
      var filter = [];
      var deferred = $q.defer();
      // recuper il movimento
      var queryParams = {page: 1, pageSize: 1, sort_fields: 'id', sort_order: 'desc'};
      filter = filter.concat(dbFilterFactory.getNumberFilter('goods_inward_row_id', girID));
      recordFactory('goods_inward_mov').filter(queryParams, filter).$promise.then(function (res) {
        if (res && res.list && res.list.length > 0) {
          // aggiorno inv. item detail quantity
          recordFactory('inventory_item_detail').update({id: res.list[0].inventory_item_id}, body).$promise.then(function (resUpdate) {
            deferred.resolve(resUpdate);
          });
        }
      });
      return deferred.promise;
    };

    return service;
  });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.core.controller:WardToDestComponentsDetailCtrl
 */
angular.module('ictportal.tnt')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/wardtodest/components/detail/:destinationId', {
                templateUrl: 'lm/wardToDestComponents/ward-to-dest-components-detail.html',
                controller: 'WardToDestComponentsDetailCtrl',
            })
    })
    .controller('WardToDestComponentsDetailCtrl', function ($scope, recordFactory, $routeParams, $location, tntGoodsInwardService, tntInventorySrv,
                                                authFactory, $rootScope, parseSchemaService, $uibModal, dbFilterFactory, localeFactory, $q,
                                                matrixParFactory, shipmentDocumentFactory, toaster, eggsFormFactory, $log, COMPONENT_READ_MODE, $filter) {
        var msg = {
            "error": "Error",
            "destination": "Customer destination",
            // "inventory_date": "Inventory date",
            // "kit_status": "Kit status",
            // "inventoried": "Inventoried",
            "op_completed_success": "Operation completed",
            "server_comunication_error": "Server communication error"
        };

        $scope.unicodesList = [];
        $scope.shipmentType = null;
        $scope.shipmentTypeId = null;
        $scope.productMap = {};
        $scope.compReaderMode = COMPONENT_READ_MODE.UNICODE;
        $scope.enableResolveButton = false;
        $scope.showTable = false;
        $scope.enableCreateButton = false;
        $scope.destinationId = null;
        $scope.destination = null;

        $scope.confirmEnabled = false;

      $scope.$watchGroup(['productMap'], function () {
          $scope.enableCreateButton = $scope.shipmentType != null
            && $scope.destination != null
            && Object.keys($scope.productMap).length > 0
        }
      );


      function isNewRead(read){
        var alreadyRead = $filter('filter')($scope.unicodesList, {read: {read: read.read} });
        return (alreadyRead.length===0);
      };


      $scope.readComponentCode = function(read) {
          if(isNewRead(read.read)){
            $scope.unicodesList.push(read.read)
            $scope.enableResolveButton = true;
            console.log(read.read);
          }
      }

      $scope.resetReads = function(){
        $scope.unicodesList = [];
        $scope.productMap = {};
        $scope.showTable = false;
        $scope.enableResolveButton = false;
      }

      $scope.resolveComponents = function(){
        var baseFilters = [{
          "column": "product p",
          "value": "t.product_id = p.id",
          "relation": "JOIN",
          "kind": "p.id as prod_id, p.code AS prod_code, p.description AS prod_des"
        }]
        var codeList = "";
        $scope.unicodesList.map(function (code){
          codeList = codeList + "'"+code+"', ";
        })
        codeList = codeList.substring(0, codeList.length - 2);
        console.log(codeList);
        baseFilters = baseFilters.concat(dbFilterFactory.getCustomFilter("t.unicode IN (" + codeList + ")"))
        recordFactory('component').filter({page_size:10000}, baseFilters)
          .$promise.then(function(data) {
          if(data.list && data.list.length>0){
            $scope.productMap = {};
            data.list.map(function (c){
              var prod = c.prod_code + " - " + c.prod_des;
              if($scope.productMap[c.prod_id]){
                $scope.productMap[c.prod_id].ids.push(c.id);
              } else {
                $scope.productMap[c.prod_id] = {prod: prod, ids : []};
                $scope.productMap[c.prod_id].ids.push(c.id);
              }
            })
            console.log($scope.productMap);
          }
          if(Object.keys($scope.productMap).length > 0){
            $scope.showTable = true;
          }
        });
      }

      $scope.goToList = function() {
        $location.url('/lm/wardtodest/components/list' + ($scope.destination.parent != null ? '/'+ $scope.destination.parent: ''));
      }


        $scope.createDdt = function () {
          var prodCompMap = {};
          angular.forEach($scope.productMap, function(value, key){
            prodCompMap[key] = value.ids;
          })
            var payload = {
              shipment_type_id : $scope.shipmentTypeId,
              destination_id : $scope.destinationId,
              agreement_id : null,
              components_map : prodCompMap
            }
            console.log(payload);
            shipmentDocumentFactory.createCustomerShipmentDocumentUnified({}, payload).$promise.then(function (data) {
              console.log(data);
              if (data.status == 'ok') {
                toaster.pop('success', "Documento creato con successo");
                goToPrint(data.result['ddt'].id);
              } else {
                toaster.pop('error', 'Documento non creato')
              }
            });

      }

      function goToPrint(shipmentDocumentId) {
        var path = '/lm/wardtodest/components/print' + '/' + shipmentDocumentId
        if($routeParams.shipmentTypeCode) {
          path = path + '/' + $routeParams.shipmentTypeCode;
        }
        $location.url(path);
      }


        $rootScope.$on('$translateRefreshEnd', function () {
            $q.all({
                general: localeFactory.translateMsg(msg)
            })
            .then(function (data) {
                $scope.functionTitle = "Consegna a reparto unificata";
                // translateGridColumns();
            })
            .catch(function (error) { $log.error(error); });
        });

        function init() {
            if($routeParams.destinationId){
              $scope.destinationId = $routeParams.destinationId
              recordFactory("customer_destination").byId({id: $scope.destinationId}).$promise.then(function(data) {
                if(data.id) {
                  $scope.destination = data;
                }
                else {
                  toaster.pop('error', 'Destinazione con id : '+ $routeParams.destinationId + 'non trovata');
                }
              });
            } else {
              toaster.pop('error', 'Destinazione mancante')
            }
            matrixParFactory.getValueOrDefault({key: 'wardToDestComponents.shipmentTypeCode', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'},
              {defaultValue: "REP_GEN"}).$promise.then(function(data){
              if (data.result && data.result.value) {
                recordFactory('shipment_type').filter({}, dbFilterFactory.getStringFilter('code', data.result.value)).$promise.then(function (st) {
                  if (st.totalResults == 0) {
                    toaster.pop('error', 'Tipo ddt con codice : '+ $routeParams.data.result.value + 'non trovato')
                  }
                  else {
                    $scope.shipmentType = st.list[0];
                    $scope.shipmentTypeId = st.list[0].id;
                  }
                })
              }
            });
        }

        //___ main ___
        init();

    });

'use strict';

/**
 * @name ictportal.lm.controller:wardToDestComponentsListCtrl

 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/wardtodest/components/list', {
                templateUrl: 'lm/wardToDestComponents/ward-to-dest-components-list.html',
                controller: 'wardToDestComponentsListCtrl'
            })
            .when('/lm/wardtodest/components/list/:wardrobeId', {
                templateUrl: 'lm/wardToDestComponents/ward-to-dest-components-list.html',
                controller: 'wardToDestComponentsListCtrl'
            })
    })
    .controller('wardToDestComponentsListCtrl', function ($scope, dbFilterFactory, recordFactory, eggsFormFactory,
        localeFactory, authFactory, $location, $q, customerDestinationFactory, $routeParams) {

        var pageBundle = 'ward_to_dest_piana';
        var msg = {
            error: 'Errore',
            operation_completed: "Salvataggio completato"
        };

        var page_msg = {};

        $scope.record = {
            lookup: {},
            model: {}
        };


        $scope.settings = {
            firstLoaded: false,
            isWardrobeReadonly: true,
            ddtLoaded: false
        };
        $scope.destsByWardrobe = {};
        $scope.destinationsList = [];
        $scope.visibleDestinationsList = [];
        $scope.wardrobesFilter = [];


        /**
         * Retrieves a list of all customer destinations of type 'REP' filtered by divcod
         */
        function getDestinations() {
            var filters = authFactory.getAuthData().filters.customer_destination
            .concat([
                {
                    column: 'receiver_type r',
                    value: 't.receiver_type_id = r.id',
                    relation: 'JOIN',
                    kind: 'r.code AS receiver_type_code'
                },{
                column: 'customer_destination gua',
                value: 't.parent = gua.id',
                relation: 'JOIN',
                kind: 'gua.id as wardrobe_id, gua.code AS wardrobe_code, gua.description AS wardrobe_description'
              }
            ])
            .concat(dbFilterFactory.getNumberFilter('t.divcod', authFactory.getAuthData().info.divCod))
            .concat(dbFilterFactory.getStringFilter('r.code', 'REP'))
            if($scope.record.model.customer_destination_id) {
                filters = filters.concat(dbFilterFactory.getNumberFilter('t.parent', $scope.record.model.customer_destination_id));
            }
            var params = {
              page_size: 100000
            };
            recordFactory('customer_destination').filter(params, filters)
                .$promise.then(function (data) {
                    $scope.destinationsList.length = 0;
                    $scope.destinationsList = $scope.destinationsList.concat(data.list);
                    getVisibleDestinationsList();
                    groupDestinationsByWardrobe();
                });
        }

        function getUnique(arr){
            return arr.filter(function(e,i) {return (arr.indexOf(e) >= i); });
        }


        /**
         * Filter on customer destinations of type wardrobe allowed (implicit filter) for current user.
         */
        function getWardrobesFilter() {
            var destIds = authFactory.getAuthData().info.authorizations.destinations;
            $scope.wardrobesFilter = [{
                column: 'receiver_type r',
                value: 't.receiver_type_id = r.id',
                relation: 'JOIN',
                kind: 'r.code AS receiver_type_code'
            }
            ]
            .concat(dbFilterFactory.getStringFilter('r.code', 'GUA'));
            if(destIds.length>0) {
                // calls six to obtain, given a list of destinations, related wardrobes
                customerDestinationFactory.allowedWardrobes({},destIds).$promise.then(function(data) {
                    $scope.wardrobesFilter = $scope.wardrobesFilter.concat(dbFilterFactory.getInFilter('t.id', data.result));
                    // If only one wardrobe is allowed, preselect it
                    $scope.settings.isWardrobeReadonly = (data.result.length<=1);
                    if(data.result.length==1) {
                        $scope.record.model.customer_destination_id = data.result[0];
                    }
                    else {
                        tryPreselectLastWardrobe();
                    }
                });
            }
            else {
                $scope.settings.isWardrobeReadonly = false;
                tryPreselectLastWardrobe();
            }
        }

        /**
         * Se come parametro di url mi passano l'id di un guardaroba, lo preseleziono.
         */
        function tryPreselectLastWardrobe() {
            if($routeParams.wardrobeId) {
                $scope.record.model.customer_destination_id = parseInt($routeParams.wardrobeId);
                recordFactory("customer_destination").byId({id: $scope.record.model.customer_destination_id}).$promise.then(function(data) {
                    if(data.id) {
                        $scope.record.lookup.customer_destination_id.obj = data;
                        getDestinations()
                    }
                    else {
                        console.log('error', 'Invalid wardrobe id '+ $routeParams.wardrobeId);
                    }
                });
            } else {
              getDestinations();
            }
        }

        /**
         * To speed up the page, given the list of all valid destinations, some filters are only obtained by filtering data via javascript.
         */
        function getVisibleDestinationsList() {
            $scope.visibleDestinationsList.length = 0;
            // Filter by destination description
            var validDestinations = (!$scope.record.model.destination)?$scope.destinationsList:$scope.destinationsList.filter(function(d) {
                return d.description.toLowerCase().includes($scope.record.model.destination.toLowerCase());
            });

            // Display survivors on screen
            $scope.visibleDestinationsList = $scope.visibleDestinationsList.concat(validDestinations);
        }

        $scope.$watch('record.model.customer_destination_id', function (newVal, oldVal) {
          if(newVal != oldVal){
            getDestinations();
          }
        });

        $scope.$watch('record.model.destination', function (newVal, oldVal) {
            if(newVal != oldVal){
              getVisibleDestinationsList();
              groupDestinationsByWardrobe();
            }
        });

        function groupDestinationsByWardrobe() {
            $scope.destsByWardrobe = {};
            var grouped = sixObjectLib.groupArray($scope.visibleDestinationsList, ['wardrobe_description']);
            grouped.forEach(function(group) {
                var key = group[0].wardrobe_id?group[0].wardrobe_id:0;
                $scope.destsByWardrobe[key] = {
                    description: group[0].wardrobe_description? group[0].wardrobe_code + ' - ' + group[0].wardrobe_description : '-',
                    destinations: group
                }
            });
        }

        $scope.goToDestinationDetail = function (id) {

            var path = '/lm/wardtodest/components/detail/' + id;
            $location.path(path);
        };

        function initLookups() {
            eggsFormFactory.addLookup($scope.record.lookup, 'customer_destination_id', 'customer_destination', 't.code', 't.description');
        };

        function init() {
            initLookups();
            getWardrobesFilter();
            localeFactory.loadTranslation(pageBundle)
                .then(function () {
                    $q.all({
                        general: localeFactory.translateMsg(msg),
                        specific: localeFactory.translateMsg(page_msg, pageBundle)
                    });
                });
        };

        //___ main ___
        init();
    });

'use strict';

/**
 * @name ictportal.lm.controller:wardToDestComponentsPrintCtrl
 * @description Visualizza la stampa di una distinta di consegna a reparto
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/wardtodest/components/print/:id', {
                templateUrl: 'lm/wardToDestComponents/ward-to-dest-components-print.html',
                controller: 'wardToDestComponentsPrintCtrl',
            })
            .when('/lm/wardtodest/components/print/:id/:wardobeId', {
                templateUrl: 'lm/wardToDestComponents/ward-to-dest-components-print.html',
                controller: 'wardToDestComponentsPrintCtrl',
            })
    })
    .controller('wardToDestComponentsPrintCtrl', function ($scope, localeFactory, $location, authFactory, $routeParams) {

        var pageBundle = 'ward_to_dest_conf';

        $scope.goToList = function() {
            var path = '/lm/wardtodest/components/list';
            if($routeParams.wardobeId) {
                path = path + '/' + $routeParams.wardobeId;
            }
            $location.url(path);
        }

        /**
         * First called function.
         */
        function init() {
            localeFactory.loadTranslation(pageBundle);
            var username = authFactory.getAuthData().authId;
            $scope.reportParameters = {
                "p_shipment_id": $routeParams.id,
                "p_user": username
            };
        };

        //___ main ___
        init();

    });

'use strict';

/**
 * @name ictportal.lm.controller:wardToDestConfDetailCtrl
 * @description Spedizione a reparto confezionata banalizzata: pagina di dettaglio.
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/wardtodestconf/detail/:destinationId/:timestamp', {
                templateUrl: 'lm/wardToDestConf/ward-to-dest-conf-detail.html',
                controller: 'wardToDestConfDetailCtrl',
                resolve: {
                    job: function ($route) { $route.current.params.job = false; }
                }
            })
            .when('/lm/wardtodestconf/detail/:destinationId/:timestamp/:debug', {
                templateUrl: 'lm/wardToDestConf/ward-to-dest-conf-detail.html',
                controller: 'wardToDestConfDetailCtrl',
                resolve: {
                    job: function ($route) { $route.current.params.job = false; }
                }
            })
            .when('/lm/wardtodestconf/detailjob/:destinationId/:timestamp', {
                templateUrl: 'lm/wardToDestConf/ward-to-dest-conf-detail.html',
                controller: 'wardToDestConfDetailCtrl',
                resolve: {
                    job: function ($route) { $route.current.params.job = true; }
                }
            })
    })
    .controller('wardToDestConfDetailCtrl', function ($scope, dbFilterFactory, recordFactory, $q,
        localeFactory, authFactory, $location, $routeParams, wardToDestConfFactory, uiGridConstants,
        toaster, workflowFactory, eggsFormFactory, shipmentDocumentFactory, endowmentFactory,
        customerShipmentDocumentFactory, componentService, healthFactory, matrixParFactory) {

        var date = new Date();
        var deliveryDate = new Date();
        var shipmentDocumentTypeCode = undefined;
        var codesMap = {};
        var isFirstAccess = true;
        var pageBundle = 'ward_to_dest_conf';
        var msg = {
            error: 'Errore',
            operation_completed: "Salvataggio completato",
            server_comunication_error: "Errore di comunicazione con il server"
        };
        var page_msg = {
            "DIRTY": "Sporco",
            "DAILY_NEED": "Consegna giornaliera",
            "RESTORE_ENDOWMENT": "Ripristino dotazione",
            "MISSING_PRODUCT_ID": "Articolo mancante",
            "MISSING_CUSTOMER_DESTINATION_ID": "Destinazione non trovata",
            "COMPONENT_NOT_FOUND": "Componente o pacco non trovato",
            "COMPONENT_ALREADY_READ": "Componente o pacco già letto ",
            "INVALID_STATUS_TRANSITION": "Il componente di unicode {{unicode}} si trova in uno stato non valido ({{status}})",
            "INVALID_STATUS": "Componente in stato sbagliato",
            "INVALID_PRODUCT": "Articolo non presente in dotazione",
            "INVALID_PRODUCT_SIZE": "Articolo/Taglia non presente in dotazione",
            "COMPONENT_STATUS_ERROR": "Stato componente non trovato",
            "PACK_STATUS_ERROR": "Stato pacco non valido ",
            "PACK_COMPONENTS_STATUS_ERROR": "Il pacco contiene componenti in stato non valido",
            "MISSING_PACK_ID": "Id pacco mancante",
            "MISSING_STATUS": "Stato di destinazione mancante",
            "MISSING_CUSTOMER_DESTINATION": "Destinazione mancante",
            "MISSING_SHIPMENT_TYPE": "Tipo DDT mancante",
            "MISSING_STATE": "Stato mancante",
            "MISSING_PRODUCT": "Articolo mancante",
            "MISSING_STOCK_AMOUNT": "Quantità mancante su riga",
            "MISSING_QUANTITY_INCLUDED": "Quantità per conf. mancante",
            "MISSING_SK": "Riferimento a kit, pacco o componente mancante",
            "DDT_MENU": "Menu DDT non trovato",
            "NO_ORDER_TYPE_CONFIGURED": "Nessun tipo di riordino autorizzato. Verifica i permessi del tuo utente",
            "MISSING_ALTERNATIVE_TYPE": "Tipo DDT a reparto non impostato sul cliente",
            "SAVE_DOCUMENT_ERROR": "Errore durante il salvataggio del documento",
            "MISSING_TO_SUM_AMOUNT": "Quantità da segnare a saldo mancante",
            "CUSTOMER_DESTINATION_NOT_FOUND": "Destinazione non trovata",
            "PRODUCT_NOT_FOUND": "Articolo non trovato",
            "ERROR_SAVE_COMPONENT": "Errore durante il salvataggio di un componente",
            "ERROR_SAVE_PACK": "Errore durante il salvataggio di un pacco",
            "NOTHING_TO_SAVE": "Non ci dati da salvare. Modificare le quantità da spedire e riprovare.",
            "INVALID_DELIVERY_DATE": "Data di consegna non valida",
            "ROW_FULL": "Dotazione per articolo/taglia già reintegrata",
            "SHIPMENT_TYPE_NOT_FOUND": "Parametro di sistema \"DIRTY_READ_DEST_RETURN_SHIPMENT_TYPE\" (tipo DDT rientro sporco a reparto) non impostato",
            "COMPONENT_INDIVIDUAL": "Componente personalizzato"
        };
        $scope.record = {
            model: {},
            lookup: {}
        };


        function isNewRead(code) {
            var result = codesMap[code];
            return (result != undefined);
        };

        // Funzione invocata dal code-reader
        $scope.onRead = function (code) {
            if (isNewRead(code)) {
                console.warn("Componente già letto");
                toaster.pop('error', msg.error, page_msg.COMPONENT_ALREADY_READ + code);
            }
            else {
              recordFactory('component').filter({}, dbFilterFactory.getCustomFilter("(barcode='" + code + "' OR unicode='" + code + "')")).$promise
                .then(function (responses) {
                  if (responses.totalResults > 0) {
                    var component = responses.list[0];
                    var row = $scope.gridOptions.data.find(function (r) { return (r.product_id === component.product_id && r.size_id === component.size_id) });
                    if(!row){
                      toaster.pop('error', msg.error, page_msg.INVALID_PRODUCT_SIZE);
                    } else if(row.restore < 1){
                      toaster.pop('error', msg.error, page_msg.ROW_FULL);
                    } else if (component.special_use === "INDIVIDUAL") {
                      toaster.pop('error', msg.error, page_msg.COMPONENT_INDIVIDUAL);
                    } else if (component.status !== "W"){
                      toaster.pop('error', msg.error, page_msg.INVALID_STATUS);
                    } else { //tutto ok
                      codesMap[component.unicode] = true;
                      codesMap[component.barcode] = true;
                      row.components_list = row.components_list.concat(component.id);
                      var uniqueComponentsList = getUnique(row.components_list);
                      row.components_list.length = 0;
                      row.components_list = row.components_list.concat(uniqueComponentsList);
                      row.stock_amount += 1;
                      $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
                    }
                  } else {
                    toaster.pop('error', msg.error, page_msg.COMPONENT_NOT_FOUND);
                  }
                })
            }
        }

        function isValidProduct(c) {
            if ($scope.admittedProductsList.indexOf(c.product_id) > -1) {
                return true;
            }
            else {
                toaster.pop('error', page_msg.INVALID_PRODUCT);
                return false;
            }
        }


        /**
         * Rimuove elementi duplicati da un array.
         */
        function getUnique(arr){
            return arr.filter(function(e,i) {return (arr.indexOf(e) >= i); });
        }


        $scope.$watch('record.lookup.customer_destination_id.obj', function (newVal, oldVal) {
            if (newVal && !oldVal) {
                $scope.componentDestStatus = 'ACCD';
                $scope.shipmentDocumentDestStatus = 'RECEIVED';
                matrixParFactory.getValueOrDefault({key: 'wardtodestconf.shipmentTypeCode', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}, {defaultValue: "09"}).$promise
                  .then(function(data) {
                    shipmentDocumentTypeCode = data.result.value;
                    if(!shipmentDocumentTypeCode) {
                      toaster.pop('error', msg.error, msg.MISSING_ALTERNATIVE_TYPE);
                    }
                })

                if (isFirstAccess) {
                  isFirstAccess = false;
                // $scope.gridOptions.columnDefs[COL_DIRTY].visible = $scope.record.model.reorderMode == 'DIRTY';
                  $scope.gridApi.grid.refresh();
                  if ($scope.gridOptions.data.length == 0) {
                    getRows($routeParams.destinationId);
                } else {
                  $scope.gridOptions.data.forEach(function (item) {
                    updateAmount(item);
                  });
                  $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
                }
              }
            }
        });

        function afterCellEdit(rowEntity, colDef) {
          $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
        }

        // Solo le righe di non chippata sono modificabili manualmente
        var cellEditable = function ($scope) {
            return $scope.row.entity.no_chip;
        }

        var templateEditable = function(){
            return '<div class="ui-grid-cell-contents" ng-class="grid.appScope.getEditableCellClass(row) ? \'row-completed\' : \'\'"><span>{{row.entity.stock_amount}}</span>  <i ng-if="row.entity.no_chip" class="fa fa-pencil"></i></div>';
        }

        $scope.getEditableCellClass = function(row) {
          return (row.entity.stock_amount >= row.entity.amount);
        };

        // Configurazione della griglia
        $scope.gridOptions = {
            enableCellEdit: false,
            enableFiltering: true,
            useExternalPagination: false,
            useExternalSorting: false,
            paginationPageSizes: [15, 30, 50, 100, 1000, 10000],
            paginationPageSize: 15,
            onRegisterApi: function (gridApi) {
                $scope.gridApi = gridApi;
                gridApi.edit.on.afterCellEdit($scope, afterCellEdit);
            },
            appScopeProvider: $scope,
            rowTemplate: 'tnt/reorder/endowments/row.tmpl.html',
            columnDefs: [
                { // Codice 0
                    displayName: 'code',
                    field: 'product_code',
                    headerCellFilter: 'translate',
                    width: '*',
                    cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, rowRenderIndex); },
                    cellTemplate: '<div class="ui-grid-cell-contents" style="text-align:left;">{{row.entity.product_code}}</div>',
                }, { // Descrizione 1
                    displayName: 'description',
                    headerCellFilter: 'translate',
                    field: 'product_description',
                    width: '***',
                    cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, rowRenderIndex); },
                    cellTemplate: '<div class="ui-grid-cell-contents" style="text-align:left;">{{row.entity.product_description}}</div>',
                }, { //  taglia 2
                    displayName: 'ward_to_dest_conf.size',
                    headerCellFilter: 'translate',
                    field: 'size_code',
                    enableFiltering: true,
                    cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.size_code}}</div>',
                    cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, rowRenderIndex); },
                    width: '*'
                },
              {  // Qta letta 3
                displayName: 'ward_to_dest_conf.amount_read',
                enableSorting: false,
                enableColumnMenu: false,
                headerCellFilter: 'translate',
                field: 'stock_amount',
                enableFiltering: false,
                enableCellEdit: true,
                cellEditableCondition: cellEditable,
                cellTemplate: templateEditable,
                cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, rowRenderIndex); },
                width: '*'
              },{ // Dotazione - giacenza
                    displayName: 'ward_to_dest_conf.restore',
                    headerCellFilter: 'translate',
                    field: 'restore',
                    cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, rowRenderIndex); },
                    enableFiltering: false,
                    width: '*'
                }, { // Dotazione 5
                    displayName: 'ward_to_dest_conf.endowment',
                    headerCellFilter: 'translate',
                    field: 'endowment',
                    cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, rowRenderIndex); },
                    enableFiltering: false,
                    width: '*'
                },{ // Progress
                    displayName: 'ward_to_dest_conf.progress',
                    headerCellFilter: 'translate',
                    field: 'endowment',
                    cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, rowRenderIndex); },
                    cellTemplate: '<div class="progress" style="margin-bottom: 0; margin-top: 5px; margin-left: 5px; margin-right: 5px;"> <div class="progress-bar" role="progressbar" ng-style="{ \'width\': row.entity.stock_amount*100/row.entity.restore + \'%\' }"></div> </div>',
                    enableFiltering: false,
                    width: '**'
                }
            ]
        };

        // Recupera le righe di dotazione
        function getRows(destinationId) {
            var payload = {
                customer_destination_id: destinationId
            };
            wardToDestConfFactory.getRows({}, payload).$promise.then(function (data) {
                if (data.status == 'ok') {
                    if (data.result) {
                        $scope.gridOptions.data = data.result;
                        $scope.admittedProductsList = data.result.map(function (item) { return item.product_id; });
                        console.log(data.result);
                    }

                    obfuscateNoChipRows();
                }
                else {
                    eggsFormFactory.logServerException(data, pageBundle);
                }
            });
        }

        function obfuscateNoChipRows(){
          $scope.gridOptions.data.forEach(function (row) {
            if (row.no_chip) {
              row.balance = '-';
              row.wardrobe_amount = '-';
              row.destination_components = '-';
            }
          });
        }

        function getCellClass(row, rowRenderIndex) {
            var cellClass = (row.entity.stock_amount >= row.entity.amount) ? 'row-completed' : 'force-bg-white';
            return cellClass;
        }

        function updateAmount(item) {
            var toRestore = item.endowment - item.destination_components;
            item.amount = toRestore > 0 ? toRestore : 0;
        }

        // Verifica se l'utente ha i permessi di visualizzare la pagina
        function checkPermissions() {
            var profilingKey = 'WARD_TO_DEST_PIANA';
            var permission = authFactory.getPermissions(profilingKey);
            if (!permission.EXEC) {
                $location.path('forbidden').search({ key: profilingKey });
            }
        };

        /**
         * Is there something to save?
         */
        $scope.trySave = function() {
            var validRows = $scope.gridOptions.data.filter(function (r) { return r.stock_amount>0; });
            if(validRows.length==0) {
                toaster.pop('warning', page_msg.NOTHING_TO_SAVE);
            }
            else {
                save();
            }
        }

        /**
         * Saves and then goes to DDT delivery note report.
         */
        $scope.saveAndPrint = function() {
            $scope.printAfterSave = true;
            $scope.trySave();
        }

        /**
         * 1 save created document
         * 2 update balance
         * 3 redirect to created document
         */

        function getDatetime() {
          healthFactory.dateTime({}, document).$promise.then(function (data) {
            if (data.status === 'ok')
              date = data['date-time'];
          });
        }

        function save() {
          var document = {
              customer_destination_id: $routeParams.destinationId,
              type_code: shipmentDocumentTypeCode,
              state: $scope.shipmentDocumentDestStatus,
              //update_endowment: true, /* serve per dire al backend se aggiornare le relative righe in dotazione */
              //update_shipment_custreturn: true, /* serve per dire al backend se aggiornare i relativi ddt di reso */
              shipment_items: getShipmentItems(),
              date: date,
              delivery_date: deliveryDate,
            };
            shipmentDocumentFactory.createCustomerShipmentDocument({}, document).$promise.then(function (data) {
                console.log(data);
                if (data.status == 'ok') {
                    localeFactory.translateReplace(pageBundle + '.created_ddt', {barcode: data.result.barcode}).then(function(transl){
                        toaster.pop('success', transl);
                        if (data.result) {
                          goToResult(data.result.id);
                        }
                    });
                }
                else {
                    eggsFormFactory.logServerException(data, pageBundle);
                    console.log(data.status + ", " + data["messages"][0]["message"]);
                }
            });
        }

        function beep() {
            console.log("Play beep sound!");
            var snd = new Audio("data:audio/wav;base64,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");
            snd.play();
        }

        /**
         * Creates the objects to send to SIX.
         */
        function getShipmentItems() {
          // Righe che hanno delle quantità da consegnare
          var validRows = $scope.gridOptions.data.filter(function (r) { return r.stock_amount>0; });
          //  Compilazione righe del DDT
          var list = validRows
            .map(function (item) {
              return {
                stock_amount: item.stock_amount,
                // to_be_delivered: item.amount,
                // endowment: item.endowment,
                // ward_amount: noDash(item.destination_components),
                // wardrobe_amount: noDash(item.wardrobe_amount),
                // dirty: item.dirty,
                // balance: noDash(item.balance),
                item_id: item.product_id,
                size_id: item.size_id,
                shipment_item_sk: getShipmentItemsSk(item),
              };
            });

            return list;
        }

        function noDash(e) {
          return e === '-' ? 0 : e;
        }

        /**
         * Creates the objects to send to SIX.
         */
        function getShipmentItemsSk(row) {
            var list = [];
            row.components_list.forEach(function(id) {
                list.push({
                    component: id
                });
            });
            return list;
        }

        function goToResult(shipmentDocumentId) {
            if($scope.printAfterSave) {
                goToPrint(shipmentDocumentId);
            }
            else {
                $scope.goToList();
            }
        }

        function goToPrint(shipmentDocumentId) {
            $location.url('/lm/wardtodestpiana/print/' + shipmentDocumentId + '/' + $scope.record.lookup.customer_destination_id.obj.parent);
        }

        $scope.goToList = function() {
            $location.url('/lm/wardtodestconf/list/' + $scope.record.lookup.customer_destination_id.obj.parent);
        }


        /**
         * Initializes six-lookup objects.
         */
        function initLookups() {
            eggsFormFactory.addLookup($scope.record.lookup, 'customer_destination_id', 'customer_destination', 't.code', 't.description');
            $scope.customerDestinationFilter = [{
                "column": "customer c",
                "value": "t.customer_id = c.id",
                "relation": "JOIN",
                "kind": "c.alternative_shipment_type_id"
            }].concat(dbFilterFactory.getNumberFilter('t.id', $routeParams.destinationId));
        };

        /**
         * Get delivery date from url timestamp param.
         */
        function getDeliveryDate(deliveryTimestamp) {
            try {
                deliveryDate = new Date(Number(deliveryTimestamp));
            }
            catch(err) {
                console.log(err);
                console.warn('La data di consegna è un parametro dell\'url di questa pagina');
                toaster.pop('error', page_msg.INVALID_DELIVERY_DATE);
            }
        }

        /**
         * First called function.
         */
        function init() {
            initLookups();
            checkPermissions();
            localeFactory.loadTranslation(pageBundle)
                .then(function () {
                    $q.all({
                        general: localeFactory.translateMsg(msg),
                        specific: localeFactory.translateMsg(page_msg, pageBundle)
                    }).then(function () {
                        localeFactory.loadTranslation('component');
                    });
                    getDeliveryDate($routeParams.timestamp);
                });
        }

        //___ main ___
        init();

    });

'use strict';

/**
 * @name ictportal.lm.controller:wardToDestConfListCtrl
 * @description Spedizione a reparto confezionata banalizzata
 *
 * 17/05/2019
 *
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/wardtodestconf/list', {
                templateUrl: 'lm/wardToDestConf/ward-to-dest-conf-list.html',
                controller: 'wardToDestConfListCtrl'
            })
            .when('/lm/wardtodestconf/list/:wardrobeId', {
                templateUrl: 'lm/wardToDestConf/ward-to-dest-conf-list.html',
                controller: 'wardToDestConfListCtrl'
            })
    })
    .controller('wardToDestConfListCtrl', function ($scope, dbFilterFactory, recordFactory, eggsFormFactory,
        localeFactory, authFactory, $location, $q, customerDestinationFactory, $routeParams) {

        var pageBundle = 'ward_to_dest_conf';
        var msg = {
            error: 'Errore',
            operation_completed: "Salvataggio completato"
        };

        var page_msg = {};
       /**
        * 17/10/2019 | Aggiunto if alla lookup, se il localStorage è settato allora passo la data presente al suo interno
        * se non è settato, mi ritorna la data corrente.
        */

        $scope.record = {
            lookup: {},
            model: {
                delivery_date: new Date()
            }
        };

        if(localStorage.getItem("selectedDate")) {
          $scope.record.model.delivery_date = new Date(localStorage.getItem("selectedDate"));
        }

        $scope.settings = {
            firstLoaded: false,
            isWardrobeReadonly: true,
            ddtLoaded: false
        };
        $scope.pathsIds = [];
        $scope.pathList = {};
        $scope.destinationsList = [];
        $scope.visibleDestinationsList = [];
        $scope.wardrobesFilter = [];
        $scope.pathFilter = [];

        function detDeliveryDateFilterQuery() {
            var v = $scope.record.model.delivery_date.getDay() + 1 ;
            return "(w.monday=" + v + " OR w.tuesday=" + v + " OR w.wednesday=" + v + " OR w.thursday=" + v + " OR w.friday="  + v + " OR w.saturday=" + v + " OR w.sunday=" + v +")";
        }

        /**
         * Retrieves a list of all customer destinations of type 'REP' filtered by divcod, parent wardrobe and selected path and delivery date.
         */
        function getDestinations() {
            // On DB delivery dates are represented as numbers from 1 (sunday) do 7 (saturday)
            var filters = authFactory.getAuthData().filters.customer_destination
            .concat([
                {
                    column: 'path p',
                    value: 't.path_id = p.id',
                    relation: 'JOIN',
                    kind: 'p.id AS path_id, p.description AS path_description'
                },
                {
                    column: 'receiver_type r',
                    value: 't.receiver_type_id = r.id',
                    relation: 'JOIN',
                    kind: 'r.code AS receiver_type_code'
                },
                {
                    column: 'supply_week_plan w',
                    value: 't.id = w.customer_destination',
                    relation: 'JOIN',
                    kind: 'w.id AS wplan_id'
                },
              {
                column: 'endowment e',
                value: 'e.destination_id = t.id',
                relation: 'JOIN',
              }
            ])
            .concat(dbFilterFactory.getNumberFilter('t.divcod', authFactory.getAuthData().info.divCod))
            .concat(dbFilterFactory.getStringFilter('r.code', 'REP'))
            .concat(dbFilterFactory.getStringFilter('e.type', 'VEST_GEN'))
            .concat(dbFilterFactory.getCustomFilter(detDeliveryDateFilterQuery()));
            if($scope.record.model.customer_destination_id) {
                filters = filters.concat(dbFilterFactory.getNumberFilter('t.parent', $scope.record.model.customer_destination_id));
            }
            var params = {
              page_size: 100000
            };
            recordFactory('customer_destination').filter(params, filters)
                .$promise.then(function (data) {
                    $scope.destinationsList.length = 0;
                    $scope.destinationsList = $scope.destinationsList.concat(data.list);
                    getAlreadyDeliveredDestinations();
                    getVisibleDestinationsList();
                    groupDestinationsByPath();
                    updatePathFilter();
                });
        }

        function getUnique(arr){
            return arr.filter(function(e,i) {return (arr.indexOf(e) >= i); });
        }

        function resetAlreadyDeliveredDestinations() {
            if($scope.destinationsList.length>0) {
                $scope.destinationsList.map(function(item) { {
                    item.alreadyDelivered = false;
                } });
            }
        }

        // TODO: queste query iniziano a essere troppo complesse, meglio sarebbe iniziare a fare degli endpoint su six per avere maggiore leggibilità.
        /**
         * Verifico a quali destinazioni ho già fatto una spedizione oggi per mostrare o meno il camioncino.
         */
        function getAlreadyDeliveredDestinations() {
            if($scope.destinationsList.length>0) {
                resetAlreadyDeliveredDestinations();
                $scope.settings.ddtLoaded = false;
                var customerDestinationIds = $scope.destinationsList.map(function(item) { return item.id });
                var params = {
                    page_size: 100000
                };
                var midnight = $scope.record.model.delivery_date;

                midnight.setHours(0,0,0,0);
                var filters = dbFilterFactory.getInFilter('t.customer_destination', customerDestinationIds)
                                .concat(dbFilterFactory.getDateFilter('t.delivery_date', midnight, '>='));
                recordFactory('shipment').filter(params, filters)
                    .$promise.then(function (data) {
                        $scope.settings.ddtLoaded = true;
                        var deliveredDestinations = getUnique(data.list.map(function(item) { return item.customer_destination }));
                        $scope.destinationsList.map(function(item) { {
                            item.alreadyDelivered = (deliveredDestinations.indexOf(item.id)===-1)?false:true;
                        } });
                    });
            }
            else {
                $scope.settings.ddtLoaded = true;
            }
        }

        /**
         * Filter on customer destinations of type wardrobe allowed (implicit filter) for current user.
         */
        function getWardrobesFilter() {
            var destIds = authFactory.getAuthData().info.authorizations.destinations;
            $scope.wardrobesFilter = [{
                column: 'receiver_type r',
                value: 't.receiver_type_id = r.id',
                relation: 'JOIN',
                kind: 'r.code AS receiver_type_code'
            }]
            .concat(dbFilterFactory.getStringFilter('r.code', 'GUA'));
            if(destIds.length>0) {
                // calls six to obtain, given a list of destinations, related wardrobes
                customerDestinationFactory.allowedWardrobes({},destIds).$promise.then(function(data) {
                    $scope.wardrobesFilter = $scope.wardrobesFilter.concat(dbFilterFactory.getInFilter('t.id', data.result));
                    // If only one wardrobe is allowed, preselect it
                    $scope.settings.isWardrobeReadonly = (data.result.length<=1);
                    if(data.result.length==1) {
                        $scope.record.model.customer_destination_id = data.result[0];
                    }
                    else {
                        tryPreselectLastWardrobe();
                    }
                });
            }
            else {
                $scope.settings.isWardrobeReadonly = false;
                tryPreselectLastWardrobe();
            }
        }

        /**
         * Se come parametro di url mi passano l'id di un guardaroba, lo preseleziono.
         */
        function tryPreselectLastWardrobe() {
            if($routeParams.wardrobeId) {
                $scope.record.model.customer_destination_id = parseInt($routeParams.wardrobeId);
                recordFactory("customer_destination").byId({id: $scope.record.model.customer_destination_id}).$promise.then(function(data) {
                    if(data.id) {
                        $scope.record.lookup.customer_destination_id.obj = data;
                        getDestinations()
                    }
                    else {
                        console.log('error', 'Invalid wardrobe id '+ $routeParams.wardrobeId);
                    }
                });
            } else {
              getDestinations();
            }
        }

        /**
         * To speed up the page, given the list of all valid destinations, some filters are only obtained by filtering data via javascript.
         */
        function getVisibleDestinationsList() {
            $scope.visibleDestinationsList.length = 0;
            // Filter by destination description
            var validDestinations = (!$scope.record.model.destination)?$scope.destinationsList:$scope.destinationsList.filter(function(d) {
                return d.description.toLowerCase().includes($scope.record.model.destination.toLowerCase());
            });
            // Filter by path
            validDestinations = (!$scope.record.model.path_id)?validDestinations:validDestinations.filter(function(d) {
                return (d.path_id===$scope.record.model.path_id);
            });
            // Display survivors on screen
            $scope.visibleDestinationsList = $scope.visibleDestinationsList.concat(validDestinations);
        }

        $scope.$watch('record.model.customer_destination_id', function (newVal, oldVal) {
          if(newVal != oldVal){
            getDestinations();
          }
        });

        $scope.$watch('record.model.delivery_date', function (newVal, oldVal) {
          if(newVal != oldVal){
            getDestinations();
          }
        });

        $scope.$watch('record.model.destination', function (newVal, oldVal) {
            if(newVal != oldVal){
              getVisibleDestinationsList();
              groupDestinationsByPath();
              updatePathFilter();
            }
        });

        $scope.$watch('record.model.path_id', function (newVal, oldVal) {
            if(newVal != oldVal){
              getVisibleDestinationsList();
              groupDestinationsByPath();
              updatePathFilter();
            }
        });

        function updatePathFilter() {
            $scope.pathFilter.length = 0;
            if($scope.pathsIds && $scope.pathsIds.length>0) {
                $scope.pathFilter = $scope.pathFilter.concat(dbFilterFactory.getInFilter("t.id", $scope.pathsIds));
            }
        }

        function groupDestinationsByPath() {
            $scope.pathList = {};
            var grouped = sixObjectLib.groupArray($scope.visibleDestinationsList, ['path_description']);
            $scope.pathsIds.length = 0;
            grouped.forEach(function(group) {
                var key = group[0].path_id?group[0].path_id:0;
                $scope.pathsIds.push(key);
                $scope.pathList[key] = {
                    description: group[0].path_description,
                    destinations: group
                }
            });
        }

        $scope.goToDestinationDetail = function (id) {
            //vado ad inserire (se non esiste ancora) oppure vado a sovrascrivere la data selezionata dall'utente all'interno di localStorage selectedDate
            localStorage.setItem("selectedDate", $scope.record.model.delivery_date);

            var path = '/lm/wardtodestconf/detail/' + id + '/' + $scope.record.model.delivery_date.getTime();
            $location.path(path);
        };

        function checkPermissions() {
            var profilingKey = 'WARD_TO_DEST_PIANA'; //FIXME
            var permission = authFactory.getPermissions(profilingKey);
            if (!permission.EXEC) {
                $location.path('forbidden').search({ key: profilingKey });
            }
        };

        function initLookups() {
            eggsFormFactory.addLookup($scope.record.lookup, 'customer_destination_id', 'customer_destination', 't.code', 't.description');
            eggsFormFactory.addLookup($scope.record.lookup, 'path_id', 'path', 'code', 'description');
        };

        function init() {
            initLookups();
            checkPermissions();
            getWardrobesFilter();
            localeFactory.loadTranslation(pageBundle)
                .then(function () {
                    $q.all({
                        general: localeFactory.translateMsg(msg),
                        specific: localeFactory.translateMsg(page_msg, pageBundle)
                    });
                });
        };

        //___ main ___
        init();
    });

'use strict';

/**
 * @name ictportal.lm.controller:wardToDestPianaPrintCtrl
 * @description Visualizza la stampa di una distinta di consegna a reparto
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/wardtodestconf/print/:id', {
                templateUrl: 'lm/wardToDestConf/ward-to-dest-conf-print.html',
                controller: 'wardToDestConfPrintCtrl',
            })
            .when('/lm/wardtodestconf/print/:id/:wardobeId', {
                templateUrl: 'lm/wardToDestConf/ward-to-dest-conf-print.html',
                controller: 'wardToDestConfPrintCtrl',
            })
    })
    .controller('wardToDestConfPrintCtrl', function ($scope, localeFactory, $location, authFactory, $routeParams) {

        var pageBundle = 'ward_to_dest_conf';

        $scope.goToList = function() {
            var path = '/lm/wardtodestconf/list';
            if($routeParams.wardobeId) {
                path = path + '/' + $routeParams.wardobeId;
            }
            $location.url(path);
        }

        /**
         * First called function.
         */
        function init() {
            localeFactory.loadTranslation(pageBundle);
            var username = authFactory.getAuthData().authId;
            $scope.reportParameters = {
                "p_shipment_id": $routeParams.id,
                "p_user": username
            };
        };

        //___ main ___
        init();

    });

'use strict';

/**
 * @name ictportal.lm.controller:wardToDestPianaDetailCtrl
 * @description Vecchia spedizione a reparto rifatta in angular: pagina di dettaglio.
 * @author Rita Beltrami
 *
 * 17/05/2019
 *
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/wardtodestpiana/detail/:destinationId/:timestamp', {
                templateUrl: 'lm/wardToDestPiana/ward-to-dest-piana-detail.html',
                controller: 'wardToDestPianaDetailCtrl',
                resolve: {
                    job: function ($route) { $route.current.params.job = false; }
                }
            })
            .when('/lm/wardtodestpiana/detail/:destinationId/:timestamp/:debug', {
                templateUrl: 'lm/wardToDestPiana/ward-to-dest-piana-detail.html',
                controller: 'wardToDestPianaDetailCtrl',
                resolve: {
                    job: function ($route) { $route.current.params.job = false; }
                }
            })
            .when('/lm/wardtodestpiana/detailjob/:destinationId/:timestamp', {
                templateUrl: 'lm/wardToDestPiana/ward-to-dest-piana-detail.html',
                controller: 'wardToDestPianaDetailCtrl',
                resolve: {
                    job: function ($route) { $route.current.params.job = true; }
                }
            })
    })
    .controller('wardToDestPianaDetailCtrl', function ($scope, dbFilterFactory, recordFactory, $q,
        localeFactory, authFactory, $location, $routeParams, wardToDestPianaFactory, uiGridConstants,
        toaster, workflowFactory, eggsFormFactory, shipmentDocumentFactory, endowmentFactory,
        customerShipmentDocumentFactory, componentService, healthFactory) {

        var date = new Date();
        $scope.deliveryDate = new Date();
        var shipmentDocumentTypeId = undefined;
        var codesMap = {};
        var COL_CODE = 0;
        var COL_DESCRIPTION = 1;
        var COL_AMOUNT_READ = 2;
        var COL_TO_BE_DELIVERED = 3;
        var COL_WARD_AMOUNT = 4;
        var COL_ENDOWMENT = 5;
        var COL_WARDROBE_AMOUNT = 6;
        var COL_DIRTY = 7;
        var COL_BALANCE = 8;
        var invertedColumnsOrder = false;
        $scope.alreadyDelivered = false;
        var pageBundle = 'ward_to_dest_piana';
        var msg = {
            error: 'Errore',
            operation_completed: "Salvataggio completato",
            server_comunication_error: "Errore di comunicazione con il server"
        };
        var page_msg = {
            "DIRTY": "Sporco",
            "DAILY_NEED": "Consegna giornaliera",
            "RESTORE_ENDOWMENT": "Ripristino dotazione",
            "MISSING_PRODUCT_ID": "Articolo mancante",
            "MISSING_CUSTOMER_DESTINATION_ID": "Destinazione non trovata",
            "COMPONENT_NOT_FOUND": "Componente o pacco non trovato",
            "COMPONENT_ALREADY_READ": "Componente o pacco già letto ",
            "INVALID_STATUS_TRANSITION": "Il componente di unicode {{unicode}} si trova in uno stato non valido ({{status}})",
            "INVALID_PRODUCT": "Articolo non presente in dotazione",
            "COMPONENT_STATUS_ERROR": "Stato componente non trovato",
            "PACK_STATUS_ERROR": "Stato pacco non valido ",
            "PACK_COMPONENTS_STATUS_ERROR": "Il pacco contiene componenti in stato non valido",
            "MISSING_PACK_ID": "Id pacco mancante",
            "MISSING_STATUS": "Stato di destinazione mancante",
            "MISSING_CUSTOMER_DESTINATION": "Destinazione mancante",
            "MISSING_SHIPMENT_TYPE": "Tipo DDT mancante",
            "MISSING_STATE": "Stato mancante",
            "MISSING_PRODUCT": "Articolo mancante",
            "MISSING_STOCK_AMOUNT": "Quantità mancante su riga",
            "MISSING_QUANTITY_INCLUDED": "Quantità per conf. mancante",
            "MISSING_SK": "Riferimento a kit, pacco o componente mancante",
            "DDT_MENU": "Menu DDT non trovato",
            "NO_ORDER_TYPE_CONFIGURED": "Nessun tipo di riordino autorizzato. Verifica i permessi del tuo utente",
            "MISSING_ALTERNATIVE_TYPE": "Tipo DDT a reparto non impostato sul cliente",
            "SAVE_DOCUMENT_ERROR": "Errore durante il salvataggio del documento",
            "MISSING_TO_SUM_AMOUNT": "Quantità da segnare a saldo mancante",
            "CUSTOMER_DESTINATION_NOT_FOUND": "Destinazione non trovata",
            "PRODUCT_NOT_FOUND": "Articolo non trovato",
            "ERROR_SAVE_COMPONENT": "Errore durante il salvataggio di un componente",
            "ERROR_SAVE_PACK": "Errore durante il salvataggio di un pacco",
            "NOTHING_TO_SAVE": "Non ci dati da salvare. Modificare le quantità da spedire e riprovare.",
            "INVALID_DELIVERY_DATE": "Data di consegna non valida",
            "SHIPMENT_TYPE_NOT_FOUND": "Parametro di sistema \"DIRTY_READ_DEST_RETURN_SHIPMENT_TYPE\" (tipo DDT rientro sporco a reparto) non impostato"
        };
        $scope.record = {
            model: {reorderMode: 'DIRTY'},
            lookup: {}
        };
        $scope.enum = {
            reorderMode: [
                {
                    name: 'Sporco',
                    value: 'DIRTY'
                },
                {
                    name: 'Consegna giornaliera',
                    value: 'DAILY_NEED'
                },
                {
                    name: 'Ripristino dotazione',
                    value: 'RESTORE_ENDOWMENT'
                }
            ]
        };

        function isNewRead(code) {
            var result = codesMap[code];
            return (result != undefined);
        };

        // Funzione invocata dal code-reader
        $scope.onRead = function (code) {
            if (isNewRead(code)) {
                console.warn("Componente già letto");
                toaster.pop('error', msg.error, page_msg.COMPONENT_ALREADY_READ + code);
            }
            else {
                var promises = {
                    component: recordFactory('component').filter({}, dbFilterFactory.getCustomFilter("(barcode='" + code + "' OR unicode='" + code + "')")).$promise,
                    pack: recordFactory('pack').filter({}, dbFilterFactory.getStringFilter("barcode", code)).$promise
                };
                $q.all(promises).then(function (responses) {
                    if (responses.component.totalResults > 0) {
                        handleComponent(responses.component.list[0]);
                    }
                    else if (responses.pack.totalResults > 0) {
                        handlePack(responses.pack.list[0]);
                    }
                    else {
                        toaster.pop('error', msg.error, page_msg.COMPONENT_NOT_FOUND);
                    }
                })
            }
        }

        $scope.changeOrder = function (record) {
          if (invertedColumnsOrder === false && record.reorderMode === 'DAILY_NEED') {
            swapGridColumns(COL_ENDOWMENT, COL_WARDROBE_AMOUNT);
            invertedColumnsOrder = true;
          } else if (invertedColumnsOrder === true && record.reorderMode !== 'DAILY_NEED'){
            swapGridColumns(COL_ENDOWMENT, COL_WARDROBE_AMOUNT);
            invertedColumnsOrder = false;
          }
        };

        function swapGridColumns(a, b) {
          var temp = $scope.gridOptions.columnDefs[a];
          $scope.gridOptions.columnDefs[a] = $scope.gridOptions.columnDefs[b];
          $scope.gridOptions.columnDefs[b] = temp;
        }

        function isValidComponentStatus(c) {
            if ($scope.admittedStatusList.indexOf(c.status) > -1) {
                return true;
            }
            else {
                var sString = componentService.getStatusTranslation(c.status).toUpperCase();
                localeFactory.translateReplace(pageBundle + '.INVALID_STATUS_TRANSITION',
                  { status: sString, unicode: c.unicode }).then(function (transl) {
                    toaster.pop('error', msg.error, transl);
                })
                return false;
            }
        }

        function isValidProduct(c) {
            if ($scope.admittedProductsList.indexOf(c.product_id) > -1) {
                return true;
            }
            else {
                toaster.pop('error', page_msg.INVALID_PRODUCT);
                return false;
            }
        }

        function handleComponent(c) {
            console.log(c);
            if (isValidComponentStatus(c) && isValidProduct(c)) {
                var payload = {
                    id: c.id,
                    status: $scope.componentDestStatus
                };
                wardToDestPianaFactory.validateComponent({}, payload).$promise.then(function (data) {
                  if (data.messages != null){
                    data.messages.barcode = c.barcode;
                  }
                  onValidationDone(data);
                });
            }
        }

        function handlePack(p) {
            console.log(p);
            if (isValidProduct(p)) {
                var payload = {
                    id: p.id,
                    status: $scope.componentDestStatus,
                };
                wardToDestPianaFactory.validatePack({}, payload).$promise.then(
                  function (data) {
                    if (data.messages != null){
                      data.messages.barcode = p.barcode;
                    }
                    onValidationDone(data);
                });
            }
        }

        /**
         * Rimuove elementi duplicati da un array.
         */
        function getUnique(arr){
            return arr.filter(function(e,i) {return (arr.indexOf(e) >= i); });
        }

        /**
         * Il pacco o il componente letto erano ok. Incremento le quantità sulla riga.
         * @param {*} data
         */
        function onValidationDone(data) {
            console.log("onValidationDone:");
            console.log(data);
            if (data.status == 'ok') {
                data.result.component_codes_list.forEach(function (c) {
                    codesMap[c] = true;
                });
                data.result.pack_barcode_list.forEach(function (c) {
                    codesMap[c] = true;
                });
                var row = $scope.gridOptions.data.find(function (r) { return r.product_id === data.result.product_id });
                var prevPacksCount = row.packs_list.length;
                row.packs_list = row.packs_list.concat(data.result.pack_id_list);
                row.components_list = row.components_list.concat(data.result.no_pack_component_id_list);

                // FIX: rimuovo eventuali duplicati (orribile, ma urgente)
                var uniquePackList = getUnique(row.packs_list);
                row.packs_list.length = 0;
                row.packs_list = row.packs_list.concat( uniquePackList );

                var uniqueComponentsList = getUnique(row.components_list);
                row.components_list.length = 0;
                row.components_list = row.components_list.concat( uniqueComponentsList );

                row.stock_amount = row.components_list.length + row.packs_list.length * row.quantity_included;
                $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);

                // Il cliente ha richiesto un segnale acustico all'aggiunta di un nuovo pacco.
                var nextPacksCount = row.packs_list.length;
                if(prevPacksCount!=nextPacksCount) {
                    beep();
                }
            }
            else {
              toaster.pop('error', msg.error, page_msg.PACK_STATUS_ERROR + data.messages.barcode);
              //eggsFormFactory.logServerException(data, pageBundle);
            }
        }

        // Recupero gli stati ammessi per i componenti che andrò a leggere
        function getAdmittedStatuses(destStatus) {
            workflowFactory.getComponentStatusPredecessors({ param1: destStatus }).$promise
                .then(function (data) {
                    $scope.admittedStatusList = data.result;
                    var log = $scope.admittedStatusList.join(", ");
                    console.log('Components admitted statuses: ' + log);
                }).catch(function () {
                    toaster.pop('error', msg.error, msg.server_comunication_error);
                });
        }

        // Verifico se la destinazione ha il flag "send_in_transit" attivo
        $scope.$watch('record.lookup.customer_destination_id.obj', function (newVal, oldVal) {
            if (newVal && !oldVal) {
                $scope.componentDestStatus = $scope.record.lookup.customer_destination_id.obj.send_in_transit === 'T' ? 'S' : 'ACCD';
                $scope.shipmentDocumentDestStatus = $scope.record.lookup.customer_destination_id.obj.send_in_transit === 'T' ? 'TO_DISPATCH':'RECEIVED';
                shipmentDocumentTypeId = newVal.alternative_shipment_type_id;
                if(!shipmentDocumentTypeId) {
                    toaster.pop('error', msg.error, msg.MISSING_ALTERNATIVE_TYPE);
                }
                getAdmittedStatuses($scope.componentDestStatus);
                checkDelivery($scope.record.lookup.customer_destination_id.obj, $scope.deliveryDate, shipmentDocumentTypeId);
            }
        });

        function afterCellEdit(rowEntity, colDef) {
            if (rowEntity.quantity_included == 0) {
                toaster.pop('error', msg.error, page_msg.MISSING_QUANTITY_INCLUDED);
                rowEntity.stock_amount = 0;
            } /*else {  // [SIXLM-508] ATM non è richiesto l'arrotondamento per pacco
                var packsCount = normalizedNumberOfPackages(rowEntity.stock_amount, rowEntity.quantity_included, rowEntity.rounding_mode);
                rowEntity.stock_amount = packsCount * rowEntity.quantity_included;
            }*/
            $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
        }

        // Solo le righe di non chippata sono modificabili manualmente
        var cellEditable = function ($scope) {
            return $scope.row.entity.no_chip;
        }

        var templateEditable = function(){
            return '<div class="ui-grid-cell-contents" ng-class="grid.appScope.getEditableCellClass(row) ? \'row-completed\' : \'\'"><i class="fa fa-spinner fa-spin" ng-if="grid.appScope.showRowSpinner(row)"></i><span>{{row.entity.stock_amount}}</span>  <i ng-if="row.entity.no_chip" class="fa fa-pencil"></i></div>';
        }

        $scope.getEditableCellClass = function(row) {
          return (row.entity.stock_amount >= row.entity.amount);
        };

        // Configurazione della griglia
        $scope.gridOptions = {
            enableCellEdit: false,
            enableFiltering: true,
            useExternalPagination: false,
            useExternalSorting: false,
            paginationPageSizes: [15, 30, 50, 100, 1000, 10000],
            paginationPageSize: 15,
            onRegisterApi: function (gridApi) {
                $scope.gridApi = gridApi;
                gridApi.edit.on.afterCellEdit($scope, afterCellEdit);
            },
            appScopeProvider: $scope,
            rowTemplate: 'tnt/reorder/endowments/row.tmpl.html',
            columnDefs: [
                { // Codice 0
                    displayName: 'code',
                    field: 'product_code',
                    headerCellFilter: 'translate',
                    width: '*',
                    cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, rowRenderIndex); },
                    cellTemplate: '<div class="ui-grid-cell-contents" style="text-align:left;"><i class="fa fa-spinner fa-spin" ng-if="!row.entity.loaded"></i>{{row.entity.product_code}}</div>',
                    minWidth: '50'
                }, { // Descrizione 1
                    displayName: 'description',
                    headerCellFilter: 'translate',
                    field: 'product_description',
                    width: '*',
                    cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, rowRenderIndex); },
                    cellTemplate: '<div class="ui-grid-cell-contents" style="text-align:left;"><i class="fa fa-spinner fa-spin" ng-if="!row.entity.loaded"></i>{{row.entity.product_description}}</div>',
                    minWidth: '100'
                }, {  // Qta letta 2
                    displayName: 'ward_to_dest_piana.amount_read',
                    enableSorting: false,
                    enableColumnMenu: false,
                    headerCellFilter: 'translate',
                    field: 'stock_amount',
                    enableFiltering: false,
                    enableCellEdit: true,
                    cellEditableCondition: cellEditable,
                    cellTemplate: templateEditable,
                    cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, rowRenderIndex); },
                    width: '100'
                }, { //  Qta da cons.  + pacchi da cons (colonna con valori unificati) 3 tbd è acronimo di: to_be_delivered
                    displayName: 'ward_to_dest_piana.amountTbd_packsTbd',
                    headerCellFilter: 'translate',
                    field: 'amountTbd_packsTbd',
                    enableFiltering: false,
                    cellTemplate: '<div class="ui-grid-cell-contents"><i class="fa fa-spinner fa-spin" ng-if="grid.appScope.showRowSpinner(row)"></i><span ng-if="!grid.appScope.showRowSpinner(row)">{{row.entity.amount}} ({{row.entity.packs}})</span></div>',
                    cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, rowRenderIndex); },
                    width: '140'
                },{ // Giacenza reparto 4
                    displayName: 'ward_to_dest_piana.stock_amount',
                    headerCellFilter: 'translate',
                    field: 'destination_components',
                    cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, rowRenderIndex); },
                    enableFiltering: false,
                    width: '105'
                }, { // Dotazione 5
                    displayName: 'ward_to_dest_piana.endowment',
                    headerCellFilter: 'translate',
                    field: 'endowment',
                    cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, rowRenderIndex); },
                    enableFiltering: false,
                    width: '105'
                }, { // Giacenza a Guardaroba 6
                    displayName: 'ward_to_dest_piana.wardrobe_amount',
                    headerCellFilter: 'translate',
                    field: 'wardrobe_amount',
                    cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, rowRenderIndex); },
                    enableFiltering: false,
                    width: '105'
                }, {  // Sporco 7
                    displayName: 'dirty',
                    enableSorting: false,
                    enableColumnMenu: false,
                    headerCellFilter: 'translate',
                    field: 'dirty',
                    enableFiltering: false,
                    cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, rowRenderIndex); },
                    cellTemplate: '<div class="ui-grid-cell-contents"><i class="fa fa-spinner fa-spin" ng-if="!row.entity.loaded"></i>{{row.entity.dirty}}</div>',
                    width: '80'
                }, { // Saldo (saldo + forza a saldo - colonne unificate) 8
                    displayName: 'ward_to_dest_piana.balance_ftb', //aggiunta traduzione in IT e ES
                    headerCellFilter: 'translate',
                    cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) { return getCellClass(row, rowRenderIndex); },
                    field: 'balance_ftb', //ftb è acronimo per force to balance, richiamando il nome originale della colonna forza saldo che è stata eliminata.
                    cellTemplate: '<div class="ui-grid-cell-contents" style="padding:3px;" ><i class="fa fa-spinner fa-spin" ng-if="!row.entity.loaded"></i>{{row.entity.balance}}</div>',
                    enableFiltering: false,
                    width: '130'
                }
            ]
        };

        $scope.showRowSpinner  = function(row) {
            return ($scope.record.model.reorderMode == 'DIRTY') && (!row.entity.loaded);
        }

        /**
         * If debug mode, displays two more columns.
         */
        function activateDebug() {
            $scope.gridOptions.columnDefs.push({
                displayName: 'QTAxPACCO',
                field: 'quantity_included',
                enableFiltering: false
            });
        }

        // Recupera le righe di dotazione
        function getRows(destinationId) {
            var payload = {
                customer_destination_id: destinationId
            };
            wardToDestPianaFactory.getRows({}, payload).$promise.then(function (data) {
                if (data.status == 'ok') {
                    if (data.result) {
                        $scope.gridOptions.data = data.result;
                        $scope.admittedProductsList = data.result.map(function (item) { return item.product_id; });
                        console.log(data.result);
                    }
                    // New way summing DDT rows
                    if($routeParams.job){
                        getDirtyAmountJob();
                    }
                    // Old way with join on component_status
                    else{
                        getDirtyAmount();
                    }
                    obfuscateNoChipRows();
                }
                else {
                    eggsFormFactory.logServerException(data, pageBundle);
                }
            });
        }

        // Recupera la quantità di componenti letti sporchi sommando le righe dei DDT reso reparto in stato 'TO_DISPATCH'
        function getDirtyAmountJob() {
            var payload = {
                customer_destination_id: $routeParams.destinationId,
                product_id_list: $scope.gridOptions.data.map(function(item) { return item.product_id })
            };
            wardToDestPianaFactory.getDirtyAmountJob({}, payload).$promise.then(function (data) {
                $scope.gridOptions.data.forEach(function (row) {
                    row.loaded = true;
                    row.dirty = data.result[row.product_id];
                    updateAmount(row);
                });
                $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
                getDatetime();
            });
        }

        // Recupera la quantità di componenti letti sporchi dall'ultima consegna
        function getDirtyAmount() {
            var payload = {
                customer_destination_id: $routeParams.destinationId,
                product_id_list: $scope.gridOptions.data.map(function(item) { return item.product_id }),
                endowment_item_id_list: $scope.gridOptions.data.map(function(item) { return item.endowment_item_id })
            };
            wardToDestPianaFactory.getDirtyAmount({}, payload).$promise.then(function (data) {
                $scope.gridOptions.data.forEach(function (row) {
                    row.loaded = true;
                    row.dirty = data.result[row.product_id];
                    updateAmount(row);
                });
                $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
                getDatetime();
            });
        }

        function obfuscateNoChipRows(){
          $scope.gridOptions.data.forEach(function (row) {
            if (row.no_chip) {
              row.balance = '-';
              row.wardrobe_amount = '-';
              row.destination_components = '-';
            }
          });
        }

        function getCellClass(row, rowRenderIndex) {
            var cellClass = (row.entity.stock_amount >= row.entity.amount) ? 'row-completed' : 'force-bg-white';
            return cellClass;
        }

        var isFirstAccess = true;
        $scope.$watch('record.model.reorderMode', function (newVal, oldVal) {
        /**
         * newVal && newVal != oldVal - questa era la precedente condizione che serviva quando nella select con modalita di riordino era impostata di default vuota.
         * Ora il cliente ha richiesto che all'apertura della pagina si mostri a video la tabella del riordino impostata sullo SPORCO (DIRTY)
        */
          if (isFirstAccess || newVal != oldVal) {
            isFirstAccess = false;
            $scope.gridOptions.columnDefs[COL_DIRTY].visible = $scope.record.model.reorderMode == 'DIRTY';
            $scope.gridApi.grid.refresh();
            if ($scope.gridOptions.data.length == 0) {
              getRows($routeParams.destinationId);
            } else {
              $scope.gridOptions.data.forEach(function (item) {
                updateAmount(item);
              });
              $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
            }
           }
        });

        function updateAmount(item) {
            if ($scope.record.model.reorderMode == 'DIRTY') {
                var sum = item.dirty + item.balance;
                item.amount = (sum>0)?sum:0;
            }
            else if ($scope.record.model.reorderMode == 'DAILY_NEED') {
                item.amount = item.daily_need_amount;
            }
            else { // RESTORE_ENDOWMENT
                var toRestore = item.endowment - item.destination_components;
                item.amount = toRestore > 0 ? toRestore : 0;
            }
            item.packs = normalizedNumberOfPackages(item.amount, item.quantity_included, item.rounding_mode);
            item.amount = item.packs * item.quantity_included;
        }

        // Verifica se l'utente ha i permessi di visualizzare la pagina
        function checkPermissions() {
            var profilingKey = 'WARD_TO_DEST_PIANA';
            var permission = authFactory.getPermissions(profilingKey);
            if (!permission.EXEC) {
                $location.path('forbidden').search({ key: profilingKey });
            }
            if (!permission.SHOW_DAILY_NEED) {
                $scope.enum.reorderMode = $scope.enum.reorderMode.filter(function(value){
                    return value.value != "DAILY_NEED";
                });
            }
            if (!permission.SHOW_DIRTY) {
                $scope.enum.reorderMode = $scope.enum.reorderMode.filter(function(value){
                    return value.value != "DIRTY";
                });
            }
            if (!permission.SHOW_ENDOW_RESTORE) {
                $scope.enum.reorderMode = $scope.enum.reorderMode.filter(function(value){
                    return value.value != "RESTORE_ENDOWMENT";
                });
            }
            if ($scope.enum.reorderMode.length == 1) {
                $scope.record.model.reorderMode = $scope.enum.reorderMode[0].value;
            }
            if ($scope.enum.reorderMode.length == 0) {
                toaster.pop('warning', page_msg.NO_ORDER_TYPE_CONFIGURED);
            }
        };

        function normalizedNumberOfPackages(amountToPutInPacks, quantityIncluded, roundingMode) {
            var result = 0;
            if (quantityIncluded && quantityIncluded > 0) {
                result = amountToPutInPacks / quantityIncluded;
            }
            // Arrotondo
            if (roundingMode == 'UP') {
                result = Math.ceil(result);
            }
            else if (roundingMode == 'DOWN') {
                result = Math.floor(result);
            }
            else {
                result = Math.round(result);
            }
            return result;
        }

        /**
         * Is there something to save?
         */
        $scope.trySave = function() {
            var validRows = $scope.gridOptions.data.filter(function (r) { return r.stock_amount>0; });
            if(validRows.length==0) {
                toaster.pop('warning', page_msg.NOTHING_TO_SAVE);
            }
            else {
                save();
            }
        }

        /**
         * Saves and then goes to DDT delivery note report.
         */
        $scope.saveAndPrint = function() {
            $scope.printAfterSave = true;
            $scope.trySave();
        }

        /**
         * 1 save created document
         * 2 update balance
         * 3 redirect to created document
         */

        function getDatetime() {
          healthFactory.dateTime({}, document).$promise.then(function (data) {
            if (data.status === 'ok')
              date = data['date-time'];
          });
        }

        function save() {
          var document = {
              customer_destination_id: $routeParams.destinationId,
              type_id: shipmentDocumentTypeId,
              state: $scope.shipmentDocumentDestStatus,
              update_endowment: true, /* serve per dire al backend se aggiornare le relative righe in dotazione */
              update_shipment_custreturn: true, /* serve per dire al backend se aggiornare i relativi ddt di reso */
              shipment_items: getShipmentItems(),
              date: date,
              delivery_date: $scope.deliveryDate,
            };
            shipmentDocumentFactory.createCustomerShipmentDocument({}, document).$promise.then(function (data) {
                console.log(data);
                if (data.status == 'ok') {
                    localeFactory.translateReplace(pageBundle + '.created_ddt', {barcode: data.result.barcode}).then(function(transl){
                        toaster.pop('success', transl);
                        if (data.result) {
                          goToResult(data.result.id);
                        }
                    });
                }
                else {
                    eggsFormFactory.logServerException(data, pageBundle);
                    console.log(data.status + ", " + data["messages"][0]["message"]);
                }
            });
        }

        function beep() {
            console.log("Play beep sound!");
            var snd = new Audio("data:audio/wav;base64,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");
            snd.play();
        }

        /**
         * Creates the objects to send to SIX.
         */
        function getShipmentItems() {
            // Righe che hanno delle quantità da consegnare
            var validRows = $scope.gridOptions.data.filter(function (r) { return r.stock_amount>0; });
            // Modalità di consegna salvata sul campo note
            var reorderModeStr = '';
            $scope.enum.reorderMode.forEach(function (en) {
                if(en.value == $scope.record.model.reorderMode) {
                    reorderModeStr = en.name;
                }
            });
            //  Compilazione righe del DDT
          var list = validRows
            .map(function (item) {
              return {
                reorder_mode: $scope.record.model.reorderMode,
                stock_amount: item.stock_amount,
                to_be_delivered: item.amount,
                endowment: item.endowment,
                ward_amount: noDash(item.destination_components),
                wardrobe_amount: noDash(item.wardrobe_amount),
                dirty: item.dirty,
                balance: noDash(item.balance),
                item_id: item.product_id,
                shipment_item_sk: getShipmentItemsSk(item),
              };
            });

            return list;
        }

        function noDash(e) {
          return e === '-' ? 0 : e;
        }

        /**
         * Creates the objects to send to SIX.
         */
        function getShipmentItemsSk(row) {
            var list = [];
            // Adding components not belonging to any pack
            row.components_list.forEach(function(id) {
                list.push({
                    component: id
                });
            });
            // Adding packs
            row.packs_list.forEach(function(id) {
                list.push({
                    pack: id
                });
            });
            return list;
        }

        function goToResult(shipmentDocumentId) {
            if($scope.printAfterSave) {
                goToPrint(shipmentDocumentId);
            }
            else {
                $scope.goToList();
            }
        }

        function goToPrint(shipmentDocumentId) {
            $location.url('/lm/wardtodestpiana/print/' + shipmentDocumentId + '/' + $scope.record.lookup.customer_destination_id.obj.parent);
        }

        $scope.goToList = function() {
            $location.url('/lm/wardtodestpiana/list/' + $scope.record.lookup.customer_destination_id.obj.parent);
        }

        /**
         * Redirects to created document.
         */
        function goToCreatedCustomerDDT(id) {
            var filters = dbFilterFactory.getCustomFilter("function_id in (select id from functions where jsf_action='#{shipmentController.startPage}')");
            recordFactory('menu').filter({}, filters).$promise.then(function (data) {
                if (data.totalResults > 0) {
                    var functionCode = data.list[0].menu_key;
                    $location.url('jsf?functionCode=' + functionCode + '&selectedId=' + id);
                }
                else {
                    toaster.pop('error', msg.error, page_msg.DDT_MENU);
                }
            });
        }

        /**
         * Initializes six-lookup objects.
         */
        function initLookups() {
            eggsFormFactory.addLookup($scope.record.lookup, 'customer_destination_id', 'customer_destination', 't.code', 't.description');
            $scope.customerDestinationFilter = [{
                "column": "customer c",
                "value": "t.customer_id = c.id",
                "relation": "JOIN",
                "kind": "c.alternative_shipment_type_id"
            }].concat(dbFilterFactory.getNumberFilter('t.id', $routeParams.destinationId));
        };

        /**
         * Get delivery date from url timestamp param.
         */
        function getDeliveryDate(deliveryTimestamp) {
            try {
                $scope.deliveryDate = new Date(Number(deliveryTimestamp));
            }
            catch(err) {
                console.log(err);
                console.warn('La data di consegna è un parametro dell\'url di questa pagina');
                toaster.pop('error', page_msg.INVALID_DELIVERY_DATE);
            }
        }

        $scope.getTimestamp = function (day){
          var m = (day.getMonth()+1);
          var mStr = (m<10)?('0'+m.toString()):m.toString();
          var d = (day.getDate());
          var dStr = (d<10)?('0'+d.toString()):d.toString();
          var timestamp = day.getFullYear() + '-' + mStr + '-' +dStr;
          return timestamp;
        }

        function checkDelivery(destination, date, shipmentType){
          if(destination && date && shipmentType){
            var filter = dbFilterFactory.getStringFilter('t.discriminator', 'CUSTOMER');
            filter = filter.concat(dbFilterFactory.getNumberFilter('t.customer_destination', destination.id))
            filter = filter.concat(dbFilterFactory.getDateFilter('t.delivery_date', date, '='))
            filter = filter.concat(dbFilterFactory.getNumberFilter('t.type_id', shipmentType))
            recordFactory('shipment').filter({}, filter)
              .$promise.then(function (data) {
                if(data.totalResults > 0){
                  $scope.alreadyDelivered = true;
                }
            });
          } else {
            toaster.pop('error', "Missing destination/date/shipmentType");
          }
        }

        /**
         * First called function.
         */
        function init() {
            initLookups();
            checkPermissions();
            localeFactory.loadTranslation(pageBundle)
                .then(function () {
                    $q.all({
                        general: localeFactory.translateMsg(msg),
                        specific: localeFactory.translateMsg(page_msg, pageBundle)
                    }).then(function () {
                        $scope.enum.reorderMode.forEach(function (en) {
                            en.name = page_msg[en.value];
                        });
                        localeFactory.loadTranslation('component');
                    });
                    getDeliveryDate($routeParams.timestamp);
                });
            if ($routeParams.debug) {
                activateDebug();
            }
        }

        //___ main ___
        init();

    });

'use strict';

/**
 * @name ictportal.lm.controller:wardToDestPianaListCtrl
 * @description Vecchia spedizione a reparto rifatta in angular: pagina di selezione reparto.
 * @author Rita Beltrami
 *
 * 17/05/2019
 *
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/wardtodestpiana/list', {
                templateUrl: 'lm/wardToDestPiana/ward-to-dest-piana-list.html',
                controller: 'wardToDestPianaListCtrl'
            })
            .when('/lm/wardtodestpiana/list/:wardrobeId', {
                templateUrl: 'lm/wardToDestPiana/ward-to-dest-piana-list.html',
                controller: 'wardToDestPianaListCtrl'
            })
    })
    .controller('wardToDestPianaListCtrl', function ($scope, dbFilterFactory, recordFactory, eggsFormFactory,
        localeFactory, authFactory, $location, $q, customerDestinationFactory, $routeParams) {

        var pageBundle = 'ward_to_dest_piana';
        var msg = {
            error: 'Errore',
            operation_completed: "Salvataggio completato"
        };

        var page_msg = {};
       /**
        * 17/10/2019 | Aggiunto if alla lookup, se il localStorage è settato allora passo la data presente al suo interno
        * se non è settato, mi ritorna la data corrente.
        */

        $scope.record = {
            lookup: {},
            model: {
                delivery_date: new Date()
            }
        };

        if(localStorage.getItem("selectedDate")) {
          $scope.record.model.delivery_date = new Date(localStorage.getItem("selectedDate"));
        }

        $scope.settings = {
            firstLoaded: false,
            isWardrobeReadonly: true,
            ddtLoaded: false
        };
        $scope.pathsIds = [];
        $scope.pathList = {};
        $scope.destinationsList = [];
        $scope.visibleDestinationsList = [];
        $scope.wardrobesFilter = [];
        $scope.pathFilter = [];

        function detDeliveryDateFilterQuery() {
            var v = $scope.record.model.delivery_date.getDay() + 1 ;
            return "(w.monday=" + v + " OR w.tuesday=" + v + " OR w.wednesday=" + v + " OR w.thursday=" + v + " OR w.friday="  + v + " OR w.saturday=" + v + " OR w.sunday=" + v +")";
        }

        /**
         * Retrieves a list of all customer destinations of type 'REP' filtered by divcod, parent wardrobe and selected path and delivery date.
         */
        function getDestinations() {
            // On DB delivery dates are represented as numbers from 1 (sunday) do 7 (saturday)
            var filters = authFactory.getAuthData().filters.customer_destination
            .concat([
                {
                    column: 'path p',
                    value: 't.path_id = p.id',
                    relation: 'JOIN',
                    kind: 'p.id AS path_id, p.description AS path_description'
                },
                {
                    column: 'receiver_type r',
                    value: 't.receiver_type_id = r.id',
                    relation: 'JOIN',
                    kind: 'r.code AS receiver_type_code'
                },
                {
                    column: 'supply_week_plan w',
                    value: 't.id = w.customer_destination',
                    relation: 'JOIN',
                    kind: 'w.id AS wplan_id'
                }
            ])
            .concat(dbFilterFactory.getNumberFilter('t.divcod', authFactory.getAuthData().info.divCod))
            .concat(dbFilterFactory.getStringFilter('r.code', 'REP'))
            .concat(dbFilterFactory.getCustomFilter(detDeliveryDateFilterQuery()));
            if($scope.record.model.customer_destination_id) {
                filters = filters.concat(dbFilterFactory.getNumberFilter('t.parent', $scope.record.model.customer_destination_id));
            }
            var params = {
              page_size: 100000
            };
            recordFactory('customer_destination').filter(params, filters)
                .$promise.then(function (data) {
                    $scope.destinationsList.length = 0;
                    $scope.destinationsList = $scope.destinationsList.concat(data.list);
                    getAlreadyDeliveredDestinations();
                    getVisibleDestinationsList();
                    groupDestinationsByPath();
                    updatePathFilter();
                });
        }

        function getUnique(arr){
            return arr.filter(function(e,i) {return (arr.indexOf(e) >= i); });
        }

        function resetAlreadyDeliveredDestinations() {
            if($scope.destinationsList.length>0) {
                $scope.destinationsList.map(function(item) { {
                    item.alreadyDelivered = false;
                } });
            }
        }

        // TODO: queste query iniziano a essere troppo complesse, meglio sarebbe iniziare a fare degli endpoint su six per avere maggiore leggibilità.
        /**
         * Verifico a quali destinazioni ho già fatto una spedizione oggi per mostrare o meno il camioncino.
         */
        function getAlreadyDeliveredDestinations() {
            if($scope.destinationsList.length>0) {
                resetAlreadyDeliveredDestinations();
                $scope.settings.ddtLoaded = false;
                var customerDestinationIds = $scope.destinationsList.map(function(item) { return item.id });
                var params = {
                    page_size: 100000
                };
                var midnight = $scope.record.model.delivery_date;

                midnight.setHours(0,0,0,0);
                var filters = dbFilterFactory.getInFilter('t.customer_destination', customerDestinationIds)
                                .concat(dbFilterFactory.getDateFilter('t.delivery_date', midnight, '>='));
                recordFactory('shipment').filter(params, filters)
                    .$promise.then(function (data) {
                        $scope.settings.ddtLoaded = true;
                        var deliveredDestinations = getUnique(data.list.map(function(item) { return item.customer_destination }));
                        $scope.destinationsList.map(function(item) { {
                            item.alreadyDelivered = (deliveredDestinations.indexOf(item.id)===-1)?false:true;
                        } });
                    });
            }
            else {
                $scope.settings.ddtLoaded = true;
            }
        }

        /**
         * Filter on customer destinations of type wardrobe allowed (implicit filter) for current user.
         */
        function getWardrobesFilter() {
            var destIds = authFactory.getAuthData().info.authorizations.destinations;
            $scope.wardrobesFilter = [{
                column: 'receiver_type r',
                value: 't.receiver_type_id = r.id',
                relation: 'JOIN',
                kind: 'r.code AS receiver_type_code'
            }]
            .concat(dbFilterFactory.getStringFilter('r.code', 'GUA'));
            if(destIds.length>0) {
                // calls six to obtain, given a list of destinations, related wardrobes
                customerDestinationFactory.allowedWardrobes({},destIds).$promise.then(function(data) {
                    $scope.wardrobesFilter = $scope.wardrobesFilter.concat(dbFilterFactory.getInFilter('t.id', data.result));
                    // If only one wardrobe is allowed, preselect it
                    $scope.settings.isWardrobeReadonly = (data.result.length<=1);
                    if(data.result.length==1) {
                        $scope.record.model.customer_destination_id = data.result[0];
                    }
                    else {
                        tryPreselectLastWardrobe();
                    }
                });
            }
            else {
                $scope.settings.isWardrobeReadonly = false;
                tryPreselectLastWardrobe();
            }
        }

        /**
         * Se come parametro di url mi passano l'id di un guardaroba, lo preseleziono.
         */
        function tryPreselectLastWardrobe() {
            if($routeParams.wardrobeId) {
                $scope.record.model.customer_destination_id = parseInt($routeParams.wardrobeId);
                recordFactory("customer_destination").byId({id: $scope.record.model.customer_destination_id}).$promise.then(function(data) {
                    if(data.id) {
                        $scope.record.lookup.customer_destination_id.obj = data;
                        getDestinations()
                    }
                    else {
                        console.log('error', 'Invalid wardrobe id '+ $routeParams.wardrobeId);
                    }
                });
            } else {
              getDestinations();
            }
        }

        /**
         * To speed up the page, given the list of all valid destinations, some filters are only obtained by filtering data via javascript.
         */
        function getVisibleDestinationsList() {
            $scope.visibleDestinationsList.length = 0;
            // Filter by destination description
            var validDestinations = (!$scope.record.model.destination)?$scope.destinationsList:$scope.destinationsList.filter(function(d) {
                return d.description.toLowerCase().includes($scope.record.model.destination.toLowerCase());
            });
            // Filter by path
            validDestinations = (!$scope.record.model.path_id)?validDestinations:validDestinations.filter(function(d) {
                return (d.path_id===$scope.record.model.path_id);
            });
            // Display survivors on screen
            $scope.visibleDestinationsList = $scope.visibleDestinationsList.concat(validDestinations);
        }

        $scope.$watch('record.model.customer_destination_id', function (newVal, oldVal) {
          if(newVal != oldVal){
            getDestinations();
          }
        });

        $scope.$watch('record.model.delivery_date', function (newVal, oldVal) {
          if(newVal != oldVal){
            getDestinations();
          }
        });

        $scope.$watch('record.model.destination', function (newVal, oldVal) {
            if(newVal != oldVal){
              getVisibleDestinationsList();
              groupDestinationsByPath();
              updatePathFilter();
            }
        });

        $scope.$watch('record.model.path_id', function (newVal, oldVal) {
            if(newVal != oldVal){
              getVisibleDestinationsList();
              groupDestinationsByPath();
              updatePathFilter();
            }
        });

        function updatePathFilter() {
            $scope.pathFilter.length = 0;
            if($scope.pathsIds && $scope.pathsIds.length>0) {
                $scope.pathFilter = $scope.pathFilter.concat(dbFilterFactory.getInFilter("t.id", $scope.pathsIds));
            }
        }

        function groupDestinationsByPath() {
            $scope.pathList = {};
            var grouped = sixObjectLib.groupArray($scope.visibleDestinationsList, ['path_description']);
            $scope.pathsIds.length = 0;
            grouped.forEach(function(group) {
                var key = group[0].path_id?group[0].path_id:0;
                $scope.pathsIds.push(key);
                $scope.pathList[key] = {
                    description: group[0].path_description,
                    destinations: group
                }
            });
        }

        $scope.goToDestinationDetail = function (id) {
            //vado ad inserire (se non esiste ancora) oppure vado a sovrascrivere la data selezionata dall'utente all'interno di localStorage selectedDate
            localStorage.setItem("selectedDate", $scope.record.model.delivery_date);

            var path = '/lm/wardtodestpiana/detail/' + id + '/' + $scope.record.model.delivery_date.getTime();
            $location.path(path);
        };

        function checkPermissions() {
            var profilingKey = 'WARD_TO_DEST_PIANA';
            var permission = authFactory.getPermissions(profilingKey);
            if (!permission.EXEC) {
                $location.path('forbidden').search({ key: profilingKey });
            }
        };

        function initLookups() {
            eggsFormFactory.addLookup($scope.record.lookup, 'customer_destination_id', 'customer_destination', 't.code', 't.description');
            eggsFormFactory.addLookup($scope.record.lookup, 'path_id', 'path', 'code', 'description');
        };

        function init() {
            initLookups();
            checkPermissions();
            getWardrobesFilter();
            localeFactory.loadTranslation(pageBundle)
                .then(function () {
                    $q.all({
                        general: localeFactory.translateMsg(msg),
                        specific: localeFactory.translateMsg(page_msg, pageBundle)
                    });
                });
        };

        //___ main ___
        init();
    });

'use strict';

/**
 * @name ictportal.lm.controller:wardToDestPianaPrintCtrl
 * @description Visualizza la stampa di una distinta di consegna a reparto
 * @author Rita Beltrami
 * 
 * 02/07/2019
 * 
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/lm/wardtodestpiana/print/:id', {
                templateUrl: 'lm/wardToDestPiana/ward-to-dest-piana-print.html',
                controller: 'wardToDestPianaPrintCtrl',
            })
            .when('/lm/wardtodestpiana/print/:id/:wardobeId', {
                templateUrl: 'lm/wardToDestPiana/ward-to-dest-piana-print.html',
                controller: 'wardToDestPianaPrintCtrl',
            })
    })
    .controller('wardToDestPianaPrintCtrl', function ($scope, localeFactory, $location, authFactory, $routeParams) {

        var pageBundle = 'ward_to_dest_piana';

        $scope.goToList = function() {
            var path = '/lm/wardtodestpiana/list';
            if($routeParams.wardobeId) {
                path = path + '/' + $routeParams.wardobeId;
            }
            $location.url(path);
        }

        /**
         * First called function.
         */
        function init() {
            localeFactory.loadTranslation(pageBundle);
            var username = authFactory.getAuthData().authId;
            $scope.reportParameters = {
                "p_shipment_id": $routeParams.id,
                "p_user": username
            };
        };

        //___ main ___
        init();

    });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ActivityCtrls
 * @description
 * # ActivityCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/activity', {
            templateUrl: 'plan/activity/activity_list.html',
            controller: 'ActivityCtrl'
        })
        .when('/activity/detail', {
            templateUrl: 'plan/activity/activity_detail.html',
            controller: 'ActivityCtrl'
        })
        .when('/activity/detail/:id', {
            templateUrl: 'plan/activity/activity_detail.html',
            controller: 'ActivityCtrl'
        })
  })
  .controller('ActivityCtrl', function ($scope, activityFactory, $log, $routeParams, $location, $window, toaster, uiGridConstants, authFactory, dialogService) {

    $scope.activity = { model:{} };
    $scope.description = "";

    // Funzioni specifiche per vista paginata ---------------------------------------------
    $scope.activitiesList = {};
    $scope.params = {
      pageNumber: 1,
      pageSize: 15,
      filters: {}
    };
    $scope.viewGridOptions = {};

    function initGridColumns() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 34,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents" style="text-align: center">' +
            '<a ng-href="#/activity/detail/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' +
              '<span class="fa fa-search"></span>' +
            '</a>' +
          '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice',
        field: 'model.code',
        enableFiltering:true,
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descrizione',
        field: 'model.description',
        enableFiltering:true,
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
    }

    $scope.getData = function () {
        var payload = {
          page: $scope.params.pageNumber,
          page_size: $scope.params.pageSize,
          show_revision: false
        };
        activityFactory.getActivitiesListFiltered(payload, $scope.params.filters)
            .$promise.then(function(data) {
                $scope.activitiesList.totalResults = data.totalResults;
                $scope.activitiesList.list = data.list;
        });
    };

    $scope.getActivitiesList = function () {
      var payload = {
            page: $scope.params.pageNumber,
            page_size: $scope.params.pageSize
      };
      activityFactory.getActivitiesListFiltered(payload, $scope.params.filters)
        .$promise.then(function(data) {
            $scope.activitiesList.totalResults = data.totalResults;
            $scope.activitiesList.list = data.list;
      });
    };
    // FINE - Funzioni specifiche per vista paginata ---------------------------------------------


    $scope.refreshDescription = function(description) {
      if(description) {
        $scope.activity.model.description = angular.copy(description);
      }
    };

    $scope.saveForm = function() {
      if($scope.activity.model.code && $scope.activity.model.description) {
        if ($scope.activity.version) {
          activityFactory.updateActivity({id: $scope.activity.model.code}, $scope.activity)
            .$promise.then(function() {
              $window.history.back();
            });
        } else {
          activityFactory.saveActivity($scope.activity.model)
            .$promise.then(function() {
              $window.history.back();
            });
        }
      }
      else{
          toaster.pop('error', 'Errore', 'Descrizione obbligatoria');
      }
    };

    $scope.goToNewActivity = function () {
        $location.path('activity/detail');
    };

    $scope.getActivityById = function(id){
      activityFactory.getActivityByUUID({uuid: id}).$promise.then(function (data) {
            $scope.activity = data;
            $scope.description = data.model.description;
        });
    };

    $scope.delete = function (version) {
      dialogService.confirmDialog('Eliminare l\'attività ' + $scope.activity.model.code + ' - ' + $scope.activity.model.description + '?',
        function () {
          activityFactory.deleteActivity({id: version}).$promise.then(function() {
              $window.history.back();
          });
        }
      );
    };

    //___ main ___
    if($routeParams.id) {
        if($routeParams.id != 'new'){
            $scope.getActivityById($routeParams.id);
        }
    }
    else{
        initGridColumns();
    }



    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'activity';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };

  });

'use strict';

/**
 * @author Rita Beltrami
 * @ngdoc function
 * @name sixEmmaApp.controller:DashboardassetCtrl
 * @description
 * # DashboardassetCtrl
 * Controller of the Assets project dashboard
 */
angular.module('emma.plan')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/asset', {
            templateUrl: 'theme/dashboard/dashboard.html',
            controller: 'DashboardAssetCtrl'
        })
  })
  .controller('DashboardAssetCtrl', function ($scope, $log, dashboardAssetFactory, authFactory) {

    //__params__
    var logInfo = true;
    var config = [];
    $scope.pos1 = [];
    $scope.pos2 = [];
    $scope.pos3 = [];
    $scope.widgetClass = "panel-widge";

    function userInfo(){
        if($scope.isLoggedIn()){
          var authData = authFactory.getAuthData();
          return authData;
        }else{
          return;
        }
    };

    config = [
        {   // Ultimi ODL inseriti
            "maxData": 5, //TODO: gestire
            "widgetApi": "dashboard/odl/list",
            "title": "Ultimi ODL inseriti",
            "skin": "primary",
            "widgetType": "widget-simple-list",
            "position": "pos-2",
            "buttons": [
                {
                    "icon": "fa fa-plus",
                    "label": "Genera nuovo ODL",
                    "link": "odl/new"
                }
            ]
        },
        {   // Gestisci ODL
            "widgetApi": "dashboard/odl/list",
            "title": "ODL assegnati a te",
            "skin": "success",
            "widgetType": "widget-label-list",
            "position": "pos-1",
            "buttons": [
                {
                    "icon": "fa fa-folder-open-o",
                    "label": "Gestisci ODL",
                    "link": "odl"
                }
            ]
        },
        {   // ODL in scadenza
            "widgetApi": "dashboard/odl/list",
            "title": "ODL in scadenza",
            "icon": "fa fa-envelope",
            "widgetType": "widget-timeline",
            "position": "pos-3",
        },
        {   // Statistiche ODL
            "widgetApi": "dashboard/odl/donut",
            "title": "Statistiche ODL",
            "skin": "warning",
            "widgetType": "widget-donut",
            "position": "pos-1"
        },
        {   // Profilo utente
            "title": "Profilo utente",
            "skin": "info",
            "widgetType": "widget-user",
            "position": "pos-2",
            "data": [
                {
                    "user": userInfo().info.name + " "+ userInfo().info.surname,
                    "group": userInfo().authId,
                    "avatar": "avatar.png",
                    "buttons": [
                    {
                        "icon": "icon-bell",
                        "label": "Notifiche",
                        "link": "notification",
                        "hasBadge": false
                    },
                    {
                        "icon": "icon-logout",
                        "label": "Logout",
                        "link": "#",
                        "hasBadge": false
                    }
                    ]
                }
            ],
        },
    ];

  /*
    function toDonutItem(item) {
        item.data = [
            {label: "1", value: 20, color: $scope.app.color.primary, description: 'Pippo'},
            {label: "2", value: 50, color: $scope.app.color.info, description: 'Pluto'},
            {label: "3", value: 30, color: $scope.app.color.warning, description: 'Paperino'}
        ];
    }
  */


    function convertToDonutFormat(item) {
        item.appColor = item.color;
        switch (item.color) {
            case "primary":
                item.color = $scope.app.color.primary;
                break;
            case "info":
                item.color = $scope.app.color.info;
                break;
            case "success":
                item.color = $scope.app.color.success;
                break;
            case "light":
                item.color = $scope.app.color.light;
                break;
            case "dark":
                item.color = $scope.app.color.dark;
                break;
            case "danger":
                item.color = $scope.app.color.danger;
                break;
            case "warning":
                item.color = $scope.app.color.warning;
                break;
            default:
                break;
        }
    };

    function createWidget(item) {
        // Retrieves data from the backend
        if(angular.isDefined(item.widgetApi)){
            item.data = [];
                dashboardAssetFactory(item.widgetApi).query()
                    .$promise.then(function(data) {
                      if(data && data.list) {
                        for (var i = 0; i < data.list.length; i++) {
                          if (item.widgetType == "widget-donut") {
                            convertToDonutFormat(data.list[i]);
                          }
                          item.data.push(data.list[i]);
                        }
                      }
                });
        }
        // Sets widget to the right position.
        switch (item.position){
            case 'pos-1':
                $scope.pos1.push(item);
                break;
            case 'pos-2':
                $scope.pos2.push(item);
                break;
            case 'pos-3':
                $scope.pos3.push(item);
                break;
            default:
                $log.info("Posizione widget sconosciuta");
        }
    }

    $scope.getDynamic = function(item) {
      return undefined;
    };


    $scope.initDashboard = function(){
        for (var i=0; i<config.length; i++) {
            createWidget(config[i]);
        }
    };

    //__main__
    $scope.initDashboard();

});

'use strict';

angular.module('emma.plan').controller('issueDetailsCtrl',
  ['$scope', '$log', 'issueFactory', 'notificationFactory', 'toaster',
    function ($scope, $log, issueFactory, notificationFactory, toaster) {
      /**** CONSTANTS ****/

      var PATH_ISSUE_SCHEMA = 'issue/schema';
      var PATH_ISSUE_RECORD = 'issue/record';

      var STABLE = 'stable', SNAP='snap';

      $scope.commissionDependent = true;
      $scope.schemaIssueDefined = false;
      $scope.typeName = 'issue';

      if(angular.isUndefined($scope.sxShowWatchers)) { $scope.sxShowWatchers = true; }
      if(angular.isUndefined($scope.sxShowReferencesAssignee)) { $scope.sxShowReferencesAssignee = true; }
      if(angular.isUndefined($scope.sxShowResponsableList)) { $scope.sxShowResponsableList = true; }
      if(angular.isUndefined($scope.sxShowCustomerInfo)) { $scope.sxShowCustomerInfo = false; }

      // Gestione allegati
      $scope.attachments = [];
      function readAttachments(modelList){
        $scope.attachments.splice(0,$scope.attachments.length);
        for(var i=0; i<modelList.length; i++){
          $scope.attachments.push(modelList[i]);
        }
      }
      function writeAttachments(modelList){
        modelList.splice(0,modelList.length);
        for(var i=0; i<$scope.attachments.length; i++){
          modelList.push($scope.attachments[i]);
        }
      }
      $scope.updAttachments = function(){
        writeAttachments($scope.sxIssue.model.attachments);
        issueFactory(PATH_ISSUE_RECORD).update({id: $scope.sxIssue.version}, $scope.sxIssue);
      };

      $scope.isSnapshot = function() {
        return $scope.historyMode == SNAP;
      };

      /*** PARTE ISSUE ***/

      $scope.getIssueById = function (itemId) {
        if(itemId == 'new'){
          $scope.isNew = true;
        } else{
          $scope.isNew = false;
          issueFactory(PATH_ISSUE_RECORD + "/_uuid/" + itemId).getUUID().$promise.then(function (response) {
            if(response){
              $scope.sxIssue = response;
              // TO FIX: vedere come risolvere la gestione delle date
              fixDates();
              // FINE DELLA PARTE DA FIXARE
              $scope.getNotificationsList();
              if(angular.isUndefined($scope.sxIssue.model.attachments)){
                $scope.sxIssue.model.attachments = [];
              }
              readAttachments($scope.sxIssue.model.attachments);
            }
          });
        }
      };

      $scope.getSchemaIssue = function(){
        issueFactory(PATH_ISSUE_SCHEMA).schemaOrDefault().$promise.then(function (data) {
          if(data.model){
            $scope.schemaIssueDefined = true;
            $scope.sxSchema = data.model;
          } else{
            $scope.schemaIssueDefined = false;
            toaster.pop('error', 'Errore caricamento pagina', 'Nessun modello salvato per il tipo \'segnalazione\'.');
          }
        });
      };

      $scope.sendMessage = function(){
        $location.path('wysiwyg');
      };

      function setBodyText(notification){
        var model = notification.model;
        if(angular.isDefined(model)){
          var bodyHtml = model.body;
          if(angular.isDefined(bodyHtml)){
            bodyHtml = "<div>" + bodyHtml + "</div>";
            var bodyText = $(bodyHtml).text();
            model.bodyAsText = bodyText;
          }
        }
      }

      $scope.getNotificationsList = function() {
        var payload = {
          page: 1,
          pageSize: 10000,
          UUID: $scope.sxIssue.UUID,
          index: 'six_issue'
        };
        notificationFactory().getListFiltered(payload)
          .$promise.then(function(data) {
          $scope.notifications = data.list;
          if($scope.notifications != null && !($scope.notifications.isDefined)){
            for(var i=0; i<$scope.notifications.length; i++){
              var notification = $scope.notifications[i];
              setBodyText(notification);
              notification.color = 'b-l-warning';
              notification.href = "#/notification/" + notification.version;
            }
          }
        });
      };

      function fixDates() {
        if($scope.sxIssue.date_insertion != null){ $scope.sxIssue.date_insertion = new Date($scope.sxIssue.date_insertion);}
        if($scope.sxIssue.date_handling != null){ $scope.sxIssue.date_handling = new Date($scope.sxIssue.date_handling);}
        if($scope.sxIssue.date_requested != null){ $scope.sxIssue.date_requested = new Date($scope.sxIssue.date_requested);}
        if($scope.sxIssue.date_closing != null){ $scope.sxIssue.date_closing = new Date($scope.sxIssue.date_closing);}
      }

      $scope.getMessage = function () {
        if(angular.isDefined($scope.sxIssue.model.type_id) && angular.isDefined($scope.sxIssue.model.record_id)){
          var promise = notificationFactory().getMailReceiver($scope.sxIssue).$promise;
          promise.then(function (response) {
            $scope.objMail = {
              title: 'Apertura Segnalazione su asset: ' + $scope.sxIssue.model.type_id.description + ' - ' + $scope.sxIssue.model.record_id.description,
              receiver: formatMailReceiver(response),
              message: '<h2>Apertura segnalazione su asset: ' + $scope.sxIssue.model.type_id.description + ' - ' + $scope.sxIssue.model.record_id.description +' </h2>' +
              '<br/>' +
              '<p style="font-size:12px">Dati tipo elem. tecnologico: (cod.) '+ getText($scope.sxIssue.model.type_id, 'code') + ' - (descr.) ' + getText($scope.sxIssue.model.type_id, 'description') + '</p>' +
              '<p style="font-size:12px">Dati elem. tecnologico: (cod.) '+ getText($scope.sxIssue.model.record_id, 'code') + ' - (descr.) ' + getText($scope.sxIssue.model.record_id, 'description') + '</p>' +
              '<p style="font-size:12px">Tipo segnalazione: ' + getText($scope.sxIssue.model.issuetype_id, 'description') + '</p>' +
              '<p style="font-size:12px">Servizio richiesto: ' + getText($scope.sxIssue.model.service_id, 'description') + '</p>' +
              '<p style="font-size:12px">Priorità: ' + getText($scope.sxIssue.model.priority_id, 'description') + '</p>' +
              '<p style="font-size:12px">Descrizione segnalazione: ' + getText($scope.sxIssue.model, 'description') + '</p><br/>' +
              '<p style="font-size:12px">Note aggiuntive: ' + getText($scope.sxIssue.model, 'note') + '</p>'
            }
          });
        } else {
          toaster.pop('error', 'Errore', 'Creazione della mail precompilata non riuscita.');
        }
      };

      function getText(ref, element){
        if(angular.isDefined(ref) && ref != null){
          if(angular.isDefined(ref[element]) && ref[element] != null){
            return ref[element];
          }
        }
        return '';
      }

      function formatMailReceiver (array) { /* from array to formatted string with comma */
        if(angular.isDefined(array.result)){
          if(array.result.length != 0){
            var strConcat = '';
            for(var i = 0; i < array.result.length; i++){
              if(i == 0){
                strConcat = array.result[i];
              } else {
                strConcat = strConcat + ', ' + array.result[i];
              }
            }
            return strConcat;
          } else {
            return '';
          }
        } else {
          return '';
        }
      }

      function _init() {
        // schema
        if (!$scope.sxSchema) {
          $scope.getSchemaIssue();
        }

        // issue
        if ($scope.sxIssue) {
          fixDates();
        } else if ($scope.sxUuid) {
          $scope.getIssueById($scope.sxUuid);
        } else {
          toaster.pop('error', 'Errore', 'Non è stata trovata nessuna issue');
        }
      }

      $scope.$watchGroup(['sxIssue', 'sxUuid'], function(newVal, oldVal) {
        if(newVal[0] || newVal[1]) {
          _init();
        }
      });
    }
  ]
);

/**
 * @ngdoc directive
 * @name sixEmmaApp.directive:issueTab
 * @description
 * # issueTab
 */
angular.module('emma.plan')
  .directive('issueDetails', function () {
    return {
      templateUrl: 'plan/directives/issuedetails.html',
      restrict: 'E',
      scope: {
        sxUuid: '=?',
        sxIssue: '=?',
        sxSchema: '=?',
        sxShowCustomerInfo: '=?',
        sxShowWatchers: '=?',           // parametro per mostrare i watchers, se non definito -> i watchers vengono mostrati
        sxShowReferencesAssignee: '=?', // parametro per mostrare i tecnici/assegnatari, se non definito -> i watchers vengono mostrati
        sxShowResponsableList: '=?'     // parametro per mostrare la lista dei contatti dei "responsabili da poter contattare"
        
      },
      controller: 'issueDetailsCtrl'
    };
  });

'use strict';

angular.module('emma.plan').controller('issueTabCtrl',
  ['$scope', '$log', 'issueFactory', 'toaster', 'dialogService',
    function ($scope, $log, issueFactory, toaster, dialogService) {

      if(angular.isUndefined($scope.sxShowStatus)) {
        $scope.sxShowStatus = true;
      }
      if(angular.isUndefined($scope.sxShowButtons)) {
        $scope.sxShowButtons = true;
      }

      $scope.list = [];

      function nextStates (array) {
        /** restituisce gli stati possibili futuri in base a quello corrente **/
        /** FIX ME  ==> questo è un CABLONE DA TOGLIERE legato al workflow di default **/
        var resultArray = [];
        if($scope.sxStatus == 'OPEN'){
          angular.forEach(array, function (obj){
            if(obj.code == 'ABORT' || obj.code == 'IN_SERVICE' || obj.code == 'SUSPENDED'){ resultArray.push(obj);}
          });
          return resultArray;
        } else if($scope.sxStatus == 'ABORT'){
          angular.forEach(array, function (obj){
            if(obj.code == 'OPEN'){ resultArray.push(obj);}
          });
          return resultArray;
        } else if($scope.sxStatus == 'IN_SERVICE'){
          angular.forEach(array, function (obj){
            if(obj.code == 'SUSPENDED' || obj.code == 'ABORT' || obj.code == 'CLOSED'){ resultArray.push(obj);}
          });
          return resultArray;
        } else if($scope.sxStatus == 'SUSPENDED'){
          angular.forEach(array, function (obj){
            if(obj.code == 'ABORT' || obj.code == 'IN_SERVICE'){ resultArray.push(obj);}
          });
          return resultArray;
        } else if($scope.sxStatus == 'CLOSED'){
          angular.forEach(array, function (obj){
            if(obj.code == 'OPEN'){ resultArray.push(obj);}
          });
          return resultArray;
        } else {
          return resultArray;
        }
      }

      function enrichStatuses () {
        /** arricchisce dinamicamente i bottoni con le label e le class **/
        /** FIX ME  ==> questo è un CABLONE DA TOGLIERE legato al workflow di default **/
        angular.forEach($scope.list, function (obj){
          if(obj.code == 'OPEN'){
            obj.description = 'Aperto';
            obj.class = 'btn btn-sm btn-bg btn-info';
          } else if(obj.code == 'IN_SERVICE'){
            obj.description = 'Metti in servizio';
            obj.class = 'btn btn-sm btn-bg btn-primary';
          } else if(obj.code == 'ABORT'){
            obj.description = 'Annulla';
            obj.class = 'btn btn-sm btn-bg btn-danger';
          } else if(obj.code == 'CLOSED'){
            obj.description = 'Chiudi';
            obj.class = 'btn btn-sm btn-bg btn-info';
          } else if(obj.code == 'SUSPENDED'){
            obj.description = 'Sospendi';
            obj.class = 'btn btn-sm btn-bg btn-primary';
          }
        });
      }

      $scope.getStatuses = function() { /* chiamata per recuperare gli stati */
        issueFactory($scope.sxBasePath + '/record/_states').show().$promise.then(function(response){
          if(response.result){
            $scope.list = [];
            var indexObjToDelete = null;
            angular.forEach(response.result, function (obj){ /* delete item from array */
              if(obj.code == $scope.sxStatus){
                indexObjToDelete = response.result.indexOf(obj);
              }
            });
            if(!indexObjToDelete) {
              response.result.splice(indexObjToDelete, 1);
            }
            $scope.list = nextStates(response.result); /* return array with future states from current */
            enrichStatuses(); /* enrich list with CSS style */
          }
        });
      };

      $scope.statusNoteDialog = function (code) {
        dialogService.fillTextField('Note per passaggio di stato',
          function (status_note) {
            $scope.setOperation(code, status_note);
          });
      };

      $scope.setOperation = function(code, status_note) {
        console.log("UUID: " + $scope.sxUuid + " --> passa a: " + code);
        if(status_note != ""){
          $scope.sxObject.status_note = status_note;
        }
        issueFactory($scope.sxBasePath + '/record').setStatus({status: code}, $scope.sxObject).$promise.then(function(response){
          if(response.status == code){
            $scope.sxObject.status = response.status;
            $scope.sxObject.version = response.version;
            if(response.date_handling) {
              $scope.sxObject.date_handling = new Date(response.date_handling);
            }
            if(response.date_closing) {
              $scope.sxObject.date_closing = new Date(response.date_closing);
            }
            $scope.getStatuses(); /* bisogna aggiornare i bottoni */
          } else {
            toaster.pop('error', 'Errore', 'Passaggio di stato fallito');
          }
        });
      };

      $scope.$watch('sxStatus', function(newVal, oldVal) {
        if(newVal) {
          $scope.getStatuses();
        }
      });
    }
  ]
);

/**
 * @ngdoc directive
 * @name sixEmmaApp.directive:issueTab
 * @description
 * # issueTab
 */
angular.module('emma.plan')
  .directive('issueTab', function () {
    return {
      template:
        '<div class="input-group has-button m-t" style="width: 100%; display: inline;">' +
          '<div style="display: inline; margin-left: 30px; margin-right: 30px;" ng-show="sxShowStatus">' +
            '<a class="btn btn-sm btn-bg btn-default font-bold">{{sxStatus}}</a>' +
          '</div>' +
          '<div ng-repeat="button in list track by $index" style="width: 6%; display: inline; margin-left: 2px; margin-right: 2px;" ng-show="sxShowButtons">' +
            '<a ng-click="statusNoteDialog(button.code)" class="{{button.class}}">{{button.description}}</a>'+
          '</div>' +
        '</div>',
      restrict: 'E',
      scope: {
        sxObject: '=',
        sxBasePath: '=',
        sxStatus: '=',
        sxShowStatus: '=?',
        sxShowButtons: '=?',
        sxUuid: '='
      },
      controller: 'issueTabCtrl'
    };
  });

'use strict';

angular.module('emma.plan').controller('odlTabCtrl',
  ['$scope', '$log', 'odlFactory', 'toaster', 'dialogService',
    function ($scope, $log, odlFactory, toaster, dialogService) {

      if(angular.isUndefined($scope.sxShowStatus)) {
        $scope.sxShowStatus = true;
      }
      if(angular.isUndefined($scope.sxShowButtons)) {
        $scope.sxShowButtons = true;
      }

      $scope.list = [];

      function nextStatus (array) {
        /** restituisce gli stati possibili futuri in base a quello corrente **/
        /** FIX ME  ==> questo è un CABLONE DA TOGLIERE legato al workflow di default **/
        var resultArray = [];
        if($scope.sxStatus == 'OPEN'){
          angular.forEach(array, function (obj){
            if(obj.code == 'ABORT' || obj.code == 'IN_SERVICE' || obj.code == 'SUSPENDED'){ resultArray.push(obj);}
          });
          return resultArray;
        } else if($scope.sxStatus == 'ABORT'){
          angular.forEach(array, function (obj){
            if(obj.code == 'OPEN'){ resultArray.push(obj);}
          });
          return resultArray;
        } else if($scope.sxStatus == 'IN_SERVICE'){
          angular.forEach(array, function (obj){
            if(obj.code == 'SUSPENDED' || obj.code == 'ABORT' || obj.code == 'CLOSED'){ resultArray.push(obj);}
          });
          return resultArray;
        } else if($scope.sxStatus == 'SUSPENDED'){
          angular.forEach(array, function (obj){
            if(obj.code == 'ABORT' || obj.code == 'IN_SERVICE'){ resultArray.push(obj);}
          });
          return resultArray;
        } else if($scope.sxStatus == 'CLOSED'){
          angular.forEach(array, function (obj){
            if(obj.code == 'OPEN'){ resultArray.push(obj);}
          });
          return resultArray;
        } else {
          return resultArray;
        }
      }

      function enrichStatuses () {
        /** arricchisce dinamicamente i bottoni con le label e le class **/
        /** FIX ME  ==> questo è un CABLONE DA TOGLIERE legato al workflow di default **/
        angular.forEach($scope.list, function (obj){
          if(obj.code == 'OPEN'){
            obj.description = 'Aperto';
            obj.class = 'btn btn-sm btn-bg btn-info';
          } else if(obj.code == 'IN_SERVICE'){
            obj.description = 'Metti in servizio';
            obj.class = 'btn btn-sm btn-bg btn-primary';
          } else if(obj.code == 'ABORT'){
            obj.description = 'Annulla';
            obj.class = 'btn btn-sm btn-bg btn-danger';
          } else if(obj.code == 'CLOSED'){
            obj.description = 'Chiudi';
            obj.class = 'btn btn-sm btn-bg btn-info';
          } else if(obj.code == 'SUSPENDED'){
            obj.description = 'Sospendi';
            obj.class = 'btn btn-sm btn-bg btn-primary';
          }
        });
      }

      $scope.getStatuses = function() { /* chiamata per recuperare gli stati */
        odlFactory().statuses().$promise.then(function(response){
          if(response.result){
            $scope.list = [];
            var indexObjToDelete = null;
            angular.forEach(response.result, function (obj){ /* delete item from array */
              if(obj.code == $scope.sxStatus){
                indexObjToDelete = response.result.indexOf(obj);
              }
            });
            if(!indexObjToDelete) {
              response.result.splice(indexObjToDelete, 1);
            }
            $scope.list = nextStatus(response.result); /* return array with future states from current */
            enrichStatuses(); /* enrich list with CSS style */
          }
        });
      };

      $scope.statusNoteDialog = function (code) {
        dialogService.fillTextField('Note per passaggio di stato',
          function (status_note) {
            $scope.setOperation(code, status_note);
          });
      };

      $scope.setOperation = function(code, status_note) {
        console.log("UUID: " + $scope.sxUuid + " --> passa a: " + code);
        if(status_note != ""){
          $scope.sxObject.status_note = status_note;
        }
        odlFactory().setStatus({status: code}, $scope.sxObject).$promise.then(function(response){
          if(response.status == code){
            $scope.sxObject.status = response.status;
            $scope.sxObject.version = response.version;
            if(response.date_handling) {
              $scope.sxObject.date_handling = new Date(response.date_handling);
            }
            if(response.date_closing) {
              $scope.sxObject.date_closing = new Date(response.date_closing);
            }
            $scope.getStatuses(); /* bisogna aggiornare i bottoni */
            if($scope.sxCallback && angular.isFunction($scope.sxCallback)) {
              $scope.sxCallback();
            }
          } else {
            toaster.pop('error', 'Errore', 'Passaggio di stato fallito');
          }
        });
      };

      $scope.$watch('sxStatus', function(newVal, oldVal) {
        if(newVal) {
          $scope.getStatuses();
        }
      });
    }
  ]
);

/**
 * @ngdoc directive
 * @name sixEmmaApp.directive:odlTab
 * @description
 * # odlTab
 */
angular.module('emma.plan')
  .directive('odlTab', function () {
    return {
      template:
        '<div class="input-group has-button" style="width: 100%; display: inline;">' +
          '<div style="display: inline; margin-left: 30px; margin-right: 30px;" ng-show="sxShowStatus">' +
            '<a class="btn btn-sm btn-bg btn-default font-bold">{{sxStatus}}</a>' +
          '</div>' +
          '<div ng-repeat="button in list track by $index" style="width: 6%; display: inline; margin-left: 2px; margin-right: 2px;" ng-show="sxShowButtons">' +
            '<a ng-click="statusNoteDialog(button.code)" class="{{button.class}}">{{button.description}}</a>' +
          '</div>' +
        '</div>',
      restrict: 'E',
      scope: {
        sxObject: '=',
        sxBasePath: '=',
        sxStatus: '=',
        sxUuid: '=',
        sxShowStatus: '=?',
        sxShowButtons: '=?',
        sxCallback: '&'
      },
      controller: 'odlTabCtrl'
    };
  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.activityFactory
 * @description
 * # activityFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan')
  .factory('activityFactory', function (PLAN_URL, $resource) {
      return $resource(PLAN_URL + '/api/activity/:verb/:id/:uuid', {}, {
        getActivityById:            {method: 'GET'},
        getActivitiesList:          {method: 'GET',     params: {verb: '_list'}},
        getActivitiesListFiltered:  {method: 'POST',    params: {verb: '_search'}},
        deleteActivity:             {method: 'DELETE',  params: {verb: '_delete'}},
        updateActivity:             {method: 'PUT',     params: {verb: '_update'}},
        saveActivity:               {method: 'POST',    params: {verb: '_save'}},
        getActivityByUUID:          {method: 'GET',     params: {verb: '_uuid'}}
      });
  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.issueFactory
 * @description
 * # issueFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan')
  .factory('issueFactory', function (PLAN_URL, APP_URL, $resource) {
    return function(entity, param1) {
      return $resource(PLAN_URL + '/api/'+entity+'/:verb/:id/:param1', {}, {
        query:  {method: 'GET', isArray: false},
        search: {method: 'POST', isArray: false, params: {verb: '_search'}},
        searchWithOdl: {method: 'POST', isArray: false, params: {verb: '_searchwithodl'}},
        select: {method: 'GET', isArray: true},
        create: {method: 'POST'},
        show:   {method: 'GET'},
        update: {method: 'PUT', params: {id: '@id'}},
        delete: {method: 'DELETE', params: {id: '@id'}},
        schemaOrDefault: {method: 'GET', params: {verb: '_codeordefault'}},
        callCenter: {method: 'GET', params: {verb: '_callcenter'}},
        getId: {method: 'GET', params: {verb: '_id', id: '@id'}},
        getUUID: {method: 'GET', params: {verb: '_current'}},
        getByCode: {method: 'GET', params: {verb: '_code', id: '@id'}},
        setStatus: {method: 'POST', params: {verb: '_setcurrentstate', version: '@version'}},
        byID:   {method: 'GET', isArray: false, params: {verb: '_id'}, ignoreLoadingBar: true},
        getTimeline:   {method: 'GET', isArray: false, params: {verb: '_uuid', param1: param1}},
        getSchemaInTimeline:   {method: 'GET', isArray: false, params: {verb: '_uuid'}}
      });
    };
  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.odlFactory
 * @description
 * # odlFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan')
  .factory('odlFactory', function (PLAN_URL, $resource) {
    return function(entity, param1) {
      return $resource(PLAN_URL + '/api/odl/:entity/:verb/:id/:code/:param1', {}, {
        //ODl
        getOdlById:     {method: 'GET',     url: PLAN_URL + '/api/odl/record/:id'},
        getOdlByUUID:   {method: 'GET',     url: PLAN_URL + '/api/odl/_uuid/:uuid/_current'},
        getOdlList:     {method: 'GET'},
        search:           {method: 'POST', isArray: false, params: {verb: '_search'}},
        searchAggregated: {method: 'POST', isArray: false, params: {verb: '_aggregated', id: '_search'}},
        createOdl:      {method: 'POST',    url: PLAN_URL + '/api/odl'},
        bulkClose:      {method: 'POST',    url: PLAN_URL + '/api/odl/_bulk/_close'},
        updateOdl:      {method: 'PUT',     url: PLAN_URL + '/api/odl/:id', params: {id: '@id'}},
        bulkUpdateOdl:  {method: 'PUT',     url: PLAN_URL + '/api/odl/_bulk/_update'},
        deletePlanOdl:  {method: 'DELETE',  url: PLAN_URL + '/api/odl/_delete/:id', params: {id: '@id'}},
        deleteIssueOdl: {method: 'DELETE',  url: PLAN_URL + '/api/odl/:id', params: {id: '@id'}},
        getAssetsList:  {method: 'GET',     url: PLAN_URL + '/api/plan/odl/asset/_list/:id', params: {id: '@id'}},
        setStatus:      {method: 'POST',    params: {verb: '_setcurrentstatus', status: '@status', version: '@version'}},
        statuses:       {method: 'GET',     params: {verb: '_statuses'}},

        getIssueNotAssigned: {method: 'GET', url: PLAN_URL + '/api/odl/_issueunassigned'},

        // ODL SCHEMA
        getOdlSchema:       {method: 'GET',     params: {entity: 'schema', verb: '_codeordefault'}},
        getOdlSchemaList:   {method: 'GET',     params: {entity: 'schema' }},
        getOdlSchemaByCode: {method: 'GET',     params: {entity: 'schema', verb: '_code' }},
        getOdlSchemaById:   {method: 'GET',     params: {entity: 'schema', verb: '_id' }},
        getOdlSchemaByUUID: {method: 'GET',     params: {entity: 'schema', verb: '_uuid' }},
        deleteOdlSchema:    {method: 'DELETE',  params: {entity: 'schema' }},
        updateOdlSchema:    {method: 'PUT',     params: {entity: 'schema' }},
        createOdlSchema:    {method: 'POST',    params: {entity: 'schema' }},

        // TIMELINE
        getTimeline:   {method: 'GET', isArray: false, params: {verb: '_uuid', param1: param1}},
        getSchemaInTimeline:   {method: 'GET', isArray: false, params: {entity: 'schema', verb: '_uuid'}}
      });
    };
  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.planFactory
 * @description
 * # planFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan')
  .factory('planFactory', function (PLAN_URL, $resource, APP_URL) {
    return function(entity) {
      return $resource(PLAN_URL + '/api/'+entity+'/:id', {}, {
        getPlansList:           {method: 'GET',     url: PLAN_URL + '/api/plan/_list'},
        getPlanListFiltered:    {method: 'POST',    url: PLAN_URL + '/api/plan/_search'},
        getPlanByUUID:          {method: 'GET',     url: PLAN_URL + '/api/plan/_uuid/:id/_current'},
        getSimulationTargets:   {method: 'POST',    url: PLAN_URL + '/api/plan/_simulation/_targets'},
        deletePlan:             {method: 'DELETE',  url: PLAN_URL + '/api/plan/_delete/:id', params: {id: '@id'}},
        updatePlan:             {method: 'PUT',     url: PLAN_URL + '/api/plan/_update/:id', params: {id: '@id'}},
        savePlan:               {method: 'POST',    url: PLAN_URL + '/api/plan/_save'},
        generateOdl:            {method: 'POST',    url: PLAN_URL + '/api/plan/_generate'},

        // Da lasciare: servono per lookup
        query:                  {method: 'GET'},
        search:                 {method: 'POST'},
        show:                   {method: 'GET'}
      });
    };
  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.planOdlFactory
 * @description
 * # planOdlFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan')
  .factory('planOdlFactory', function (PLAN_URL, $resource) {
    return function(entity) {
      return $resource(PLAN_URL + '/api/'+entity+'/:id', {}, {
        search:                 {method: 'POST',    url: PLAN_URL + '/api/plan/odl/_search'},
        getOldEvents:           {method: 'POST',    url: PLAN_URL + '/api/plan/odl/_events'},
        getGeneratedOdlList:    {method: 'GET',     url: PLAN_URL + '/api/plan/odl/_list/' + entity},
        getPlanOdlList:         {method: 'GET',     url: PLAN_URL + '/api/plan/odl/_list/'},
        getPlanning:            {method: 'GET',     url: PLAN_URL + '/api/plan/odl/_planning/'},
        deletePlanOdlList:      {method: 'DELETE',  url: PLAN_URL + '/api/plan/odl/_delete/:id', params: {id: '@id'}}
      });
    };
  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.taskFactory
 * @description
 * # taskFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan')
  .factory('taskFactory', function (PLAN_URL, $resource, DATA_SET_URL) {
      return $resource(PLAN_URL + '/api/task/:verb/:id/:uuid', {}, {
        getTaskById:            {method: 'GET'},
        getTaskByUUID:          {method: 'GET',     params: {verb: '_uuid'}},
        getTasksList:           {method: 'GET',     params: {verb: '_list'}},
        getTasksListFiltered:   {method: 'POST',    params: {verb: '_search'}},
        deleteTask:             {method: 'DELETE',  params: {verb: '_delete'}},
        updateTask:             {method: 'PUT',     params: {verb: '_update'}},
        saveTask:               {method: 'POST',    params: {verb: '_save'}},
        getGantt:               {method: 'GET',     params: {verb: '_gantt'}}
      });

  });

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.treePlanConfigFactory
 * @description
 * # treePlanConfigFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan')
  .factory('treePlanConfigFactory', function (DATA_SET_URL, $resource) {
    return $resource(DATA_SET_URL + '/api/configuration/:verb/:type/:id/:typecode/:recordcode/:servicecode', {}, {
      getConfigurationById:   {method: 'GET',     params: {verb: '_id'}},
      createConfiguration:       {method: 'POST',    params: {id: '@id'}},
      updateConfiguration:       {method: 'PUT',     params: {id: '@id'}},
      deleteConfiguration:       {method: 'DELETE',  params: {id: '@id'}},
      /* chiamate per ottenere le configurazioni */
      getSupplierFiltered:       {method: 'POST',     params: {verb: '_supplier', type: '_filtered'}},
      getSupplierDefault:        {method: 'POST',     params: {verb: '_supplier', type: '_default'}},
      getCompanyFiltered:        {method: 'POST',     params: {verb: '_company', type: '_filtered'}},
      getCompanyDefault:         {method: 'POST',     params: {verb: '_company', type: '_default'}},
      getTechnicianExternalFiltered:  {method: 'POST',     params: {verb: '_operator', type: '_filtered'}},
      getTechnicianExternalDefault:   {method: 'POST',     params: {verb: '_operator', type: '_default'}},
      getHeadCommissionFiltered: {method: 'POST',     params: {verb: '_operator', type: '_filtered'}},
      getHeadCommissionDefault:  {method: 'POST',     params: {verb: '_operator', type: '_default'}},
      getMaintainerFiltered:     {method: 'POST',     params: {verb: '_operator', type: '_filtered'}},
      getMaintainerDefault:      {method: 'POST',     params: {verb: '_operator', type: '_default'}},
      getOperatorFiltered:       {method: 'POST',     params: {verb: '_operator', type: '_filtered'}},
      getOperatorDefault:        {method: 'POST',     params: {verb: '_operator', type: '_default'}},
      getResponsable:            {method: 'POST',     params: {verb: '_responsable'}},
      getCompleteConfiguration:  {method: 'POST', params: {verb: '_configuration'}},


      getConfigurationIssue:  {method: 'POST',    params: {verb: '_configuration'}}, // callcenter
      getConfigurationOdl:  {method: 'POST',      params: {verb: '_configuration'}}    // odl
    });
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:CallcenterCtrl
 * @description
 * # CallcenterCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/callcenter_detail/:id', {
        templateUrl: 'plan/issue/callcenter_detail.html',
        controller: 'CallcenterCtrl'
      })
      .when('/callcenter_list', {
        templateUrl: 'plan/issue/callcenter_list.html',
        controller: 'CallcenterCtrl'
      });
  })
  .controller('CallcenterCtrl', function ($routeParams, $scope, issueFactory, recordFactory, $location, notificationFactory, $log, toaster, treePlanConfigFactory, $q, localStorageService,
                                          authFactory, uiGridConstants, issueToOdl, odlFactory, $timeout, errorService, lookupFactory, $route, counterFactory, userFactory) {

    var PATH_ISSUE_RECORD = 'issue/record';
    var PATH_CALLCENTER_LIST = 'callcenter_list';
    var PATH_CALLCENTER_DETAIL = 'callcenter_detail';
    var PATH_ISSUE_SCHEMA = 'issue/schema';

    $scope.issueName = 'issue';

    $scope.counterNameRichiedente = 'richiedente'; /* sono i codici per andare ad ottenere i relativi contatori di SIX */
    $scope.counterNameOperatore = 'operatore';
    $scope.counterNameIssue = 'issue';

    /**  VARIABILI  **/

    $scope.loadingSixMail = true;

    $scope.bool_watch_internal = true;
    $scope.bool_watch_external = false;

    $scope.responsibleList = [];

    $scope.watcher = {user: '', mail: ''};

    $scope.openSchemaReporter = false;
    $scope.commissionDependentReporter = true;
    $scope.schemaIssueDefined = false;
    var now = new Date();
    $scope.issueList = {list: []};
    $scope.autoResizeParams = {autoresize: true, minHeight: 200, marginTop: 260};
    $scope.gridAppCallbacks = {};

    $scope.data = {
      date_insertion: now,
      date_requested: now,
      date_handling: null,
      date_closing: null,
      references_assignee: {  // oggetto per contenere i riferimenti a: tecnici, assegnatari, fornitore...
        secretariat_id: null,
        technicianexternal_id: null
      },
      watchers: {
        external: [],
        internal: []
      },
      reporter_id: null,
      model: {
        type_id : null,
        record_id : null,
        service_id: null,
        attachments: []
      }
    };

    if(localStorageService.get('issue_bool')) {
      $scope.bool = localStorageService.get('issue_bool');
    } else {
      $scope.bool = {
        allIssues: true
      };
    }

    /** VARIABILI FILTRAGGIO LOOK UP */

    $scope.supervisorExternalFilter = { 'model.typeoperator' : 'tecnico_esterno' };
    $scope.secretariatFilter = {};

    $scope.configurationIssue = {}; /* oggetto per salvare la configurazione corrente definita sul tree */

    $scope.params = {
      pageNumber: 1,
      pageSize: 100,
      totalItems: 0,
      filters: {}
    };

    // Gestione allegati
    $scope.attachments = [];
    function readAttachments(modelList){
      if(angular.isDefined(modelList)) {
        $scope.attachments.splice(0, $scope.attachments.length);
        for (var i = 0; i < modelList.length; i++) {
          $scope.attachments.push(modelList[i]);
        }
      }
    }
    function writeAttachments(modelList){
        if(angular.isDefined(modelList)) {
          modelList.splice(0, modelList.length);
          for (var i = 0; i < $scope.attachments.length; i++) {
            modelList.push($scope.attachments[i]);
          }
        }
    }
    $scope.updAttachments = function(){
        writeAttachments($scope.data.model.attachments);
        issueFactory(PATH_ISSUE_RECORD).update({id: $scope.data.version}, $scope.data);
    };

    /**  GESTIONE DELLA GRID  **/

    $scope.viewGridOptions = {
      enableSorting: true,
      enableGridMenu: true,
      exporterCsvColumnSeparator: ';',
      exporterSuppressColumns: [ 'id', 'odl' ],
      exporterMenuPdf: false,
      enableFiltering: true,
      // columnDef: [],
      enableColumnResizing: true,
      paginationPageSizes: [100, 250, 500, 1000, 10000],
      paginationPageSize: 100,
      totalItems: 0,
      useExternalPagination: true,
      // rowHeight: 50,
      // data: 'issueList.list',
      useExternalFiltering: true,
      multiSelect: true,
      enableRowHeaderSelection: true,
      enableRowSelection: true,
      enableHorizontalScrollbar: 1
    };

    $scope.getColumns = function(){
      getColumnOrDefault();
      return $scope.columnDefs;
    };

    function getColumnOrDefault() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 34,
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
        '<div class="ui-grid-cell-contents" style="text-align: center">' +
        '<a ng-href="#/callcenter_detail/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' +
        '<span class="fa fa-search"></span>' +
        '</a>' +
        '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice Segnalaz.',
        field: 'model.code',
        enableFiltering:true,
        width: 150,
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'ODL committente',
        field: 'model.odl_commit',
        enableFiltering:true,
        width: 150,
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descrizione',
        field: 'model.description',
        enableFiltering:true,
        width: 300,
        cellTooltip: function(row) {
          return row.entity.model.description;
        },
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo asset',
        field: 'model.type_id.description',
        enableFiltering:true,
        width: 150,
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Asset',
        field: 'model.record_id.description',
        enableFiltering:true,
        width: 150,
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS, //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data richiesta',
        field: 'date_requested',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        enableFiltering:true,
        width: 100,
        filters: [
          {
            type: 'date',
            relation: 'gte',
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: 'date',
            relation: 'lte',
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Stato',
        field: 'status',
        enableFiltering:true,
        width: 100,
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Note',
        field: 'model.note',
        enableFiltering:true,
        width: 500,
        cellTooltip: function(row) {
            return row.entity.model.note;
          },
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS, //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Richiedente',
        field: 'reporter_id.description',
        enableFiltering:true,
        width: 150,
        filters:[{
          type: 'sixlookup',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Utente di inserimento',
        field: 'user',
        enableFiltering:true,
        width: 200,
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Odl asscociati',
        field: 'odl',
        enableFiltering:false,
        width: 200,
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate:
        '<div class="ui-grid-cell-contents" style="vertical-align:middle;text-align:center; height: 50px">' +
          '{{grid.appScope.show_odl_ref(row.entity.odl)}}' +
        '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Gen. ODL',
        field: 'odl',
        width: 80,
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        enableColumnMenu: false,
        cellTemplate:
        '<div class="ui-grid-cell-contents" ng-if="grid.appScope.show_generate_odl(row.entity.status)" style="vertical-align:middle;text-align:center;">' + // N.B. show_generate_odl() deve essere passata alla sixgridpagination tramite l'attributo 'grid-app-callbacks'
        '<button type="button" class="btn btn-xs btn-primary" ng-click="grid.appScope.generate_odl(row.entity.UUID)">' +  // N.B. generate_odl() deve essere passata alla sixgridpagination tramite l'attributo 'grid-app-callbacks'
        '<i class="fa fa-magic"></i>' +
        '</button>' +
        '</div>'
      });
    }

    $scope.getCurrentUserOperator = function() {
      $scope.currentUserOperator = undefined;
      var currentUser = authFactory.getAuthData().authId;
      var filters = {};
      filters['model.username'] = {
        type: '_exact',
        key: 'model.username',
        value: currentUser
      };
      return recordFactory('operatore').search({page_size: 1, show_revision: false}, filters).$promise.then(function(data) {
        if(errorService.handleError(data) && data.list && data.list.length > 0) {
          $scope.currentUserOperator = data.list[0];
        } else {
          toaster.pop('error', 'Errore', 'Operatore corrispondente all\'utente \''+ currentUser +'\' non trovato');
        }
        return $scope.currentUserOperator;
      });
    };

    $scope.getCurrentUserIssueList = function() {
      if(!$scope.currentUserOperator || !$scope.currentUserOperator.UUID) {
        $scope.getCurrentUserOperator().then(function(operator) {
          $scope.getIssueList();
        })
      } else {
        $scope.getIssueList();
      }
    };


    $scope.clicked = function () {
      console.log("click");
    };
    $scope.gridAppCallbacks['clicked'] = $scope.clicked;

    $scope.show_odl_ref = function (array) { // costruisco una stringa da stampare partendo da un array di codici di ODL
      var str = '';
      for(var i = 0; i < array.length; i++){
        if(i == 0){
          str = array[i];
        } else {
          str = str + ', ' + array[i];
        }
      }
      return str;
    };
    $scope.gridAppCallbacks['show_odl_ref'] = $scope.show_odl_ref; // da passare alla sixgridpagination per caricare correttamente il template della colonna "Genera ODL"

    $scope.getIssueList = function () {
      var filters = angular.copy($scope.params.filters);
      if($scope.currentUserOperator && $scope.currentUserOperator.UUID && !$scope.bool.allIssues) {
        if(!filters['user']) {
          filters['user'] = sixFiltersLib.exact('user', $scope.currentUserOperator.model.username, sixFiltersLib.CONSTRAINTS.OR);
        }
        filters['supervisorExternal_id'] = sixFiltersLib.exact('references_assignee.supervisorExternal_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
        filters['secretariat_id'] = sixFiltersLib.exact('references_assignee.secretariat_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
        filters['reporter_id'] = sixFiltersLib.exact('references_assignee.reporter_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
      }

      issueFactory(PATH_ISSUE_RECORD).searchWithOdl({query: $scope.queryParam, page_size: $scope.params.pageSize, show_revision: false}, filters).$promise.then(function(data) {
        $scope.params.totalItems = data.totalResults;
        $scope.viewGridOptions.totalItems = data.totalResults;
        $scope.issueList.totalResults = data.totalResults;
        $scope.issueList.list = data.list;
      });
    };

    $scope.newIssueByCallcenter = function () {
      $location.path(PATH_CALLCENTER_DETAIL + '/new');
    };

    $scope.back = function(){
      $location.path(PATH_CALLCENTER_LIST);
    };

    $scope.refresh = function (){
      // $route.reload();
      $scope.getCurrentUserIssueList();
    };

    $scope.validate = function (generateOdl) {
      var form = document.forms['detailForm'];
      if (form) {
        $scope.$broadcast('schemaFormValidate');
        $timeout(function() { _checkValidation(generateOdl); }, 100);
      }
    };

    function _checkValidation(generateOdl) {
      var form = document.forms['detailForm'];
      var invElements = angular.element(form.getElementsByClassName("ng-invalid"));
      if(!$scope.data.model.record_id || !$scope.data.model.type_id) {
        toaster.pop('error', 'Dati mancanti', 'Dati obbligatori mancanti: TIPO, ASSET');
      }
      else if (invElements.length > 0) {
        toaster.pop('error', 'Dati mancanti', 'Dati obbligatori mancanti');
      }
      else {
        if(generateOdl) { // genero anche l'odl
          _update().then(
            function (resp) {   // succeeded
              toaster.pop('success', 'Salvataggio riuscito', 'Salvataggio riuscito correttamente');
              $scope.generate_odl(resp.UUID);
            },
            function(error) {   // rejected
              toaster.pop('error', 'Errore', 'Errore durante il salvataggio: ' + error);
            }
          );
        }
        else { // non genero l'odl: torno alla lista
          _update().then(
            function (resp) {   // succeeded
              // $scope.back();
              toaster.pop('success', 'Salvataggio riuscito', 'Salvataggio riuscito correttamente');
              $scope.data.version = resp.version;
              $location.path('callcenter_detail/'+resp.UUID);
            },
            function(error) {   // rejected
              toaster.pop('error', 'Errore', 'Errore durante il salvataggio: ' + error);
            }
          );
        }
      }
    }

    function _update() {
      if(!$scope.data.version) { /* se è nuovo */
        return counterFactory.next({code: $scope.counterNameIssue}).$promise.then(function (response) {
          if (response.errors) {
            $scope.errorsRetrievingCounter(response.errors);
            var deferred = $q.defer();
            deferred.reject('Errore nel recupero del contatore per la generazione del codice segnalazione');
            return deferred.promise;
          }
          else {
            $scope.data.model.code = response.next;
            if (!$scope.data.model.description) {
              $scope.data.model.description = $scope.data.model.code + ' - ' + $scope.data.model.type_id.description + ' - ' + $scope.data.model.record_id.description;
            }
            writeAttachments($scope.data.model.attachments);
            return issueFactory(PATH_ISSUE_RECORD).create({commissionDependent: $scope.commissionDependent}, $scope.data).$promise;
          }
        });
      } else{ /* se è già versionato */
        if(angular.isUndefined($scope.data.model.attachments)){
            writeAttachments($scope.data.model.attachments);
        }
        return issueFactory(PATH_ISSUE_RECORD).update({id: $scope.data.version}, $scope.data).$promise;
      }
    }

    $scope.show_generate_odl = function(status) {
      return (status == 'OPEN' || status == 'IN_SERVICE');
    };
    $scope.gridAppCallbacks['show_generate_odl'] = $scope.show_generate_odl; // da passare alla sixgridpagination per caricare correttamente il template della colonna "Genera ODL"

    $scope.generate_odl = function(issueId){
      issueFactory(PATH_ISSUE_RECORD + "/_uuid/" + issueId).getUUID().$promise.then(function (response) {
        if(response){
          issueToOdl.push(response);
          $location.path('/odl/new', false);
        }
      });
    };
    $scope.gridAppCallbacks['generate_odl'] = $scope.generate_odl; // da passare alla sixgridpagination per caricare correttamente il template della colonna "Genera ODL"

    $scope.getIssueById = function (itemId) {
      if(itemId == 'new'){
        $scope.isNew = true;
        $scope.getSchemaIssue();
        /* scarico il codice della segnalazione dal contatore di SIX */
        counterFactory.current({code: $scope.counterNameIssue}).$promise.then(function (response) {
          if (response.errors){
            $scope.errorsRetrievingCounter(response.errors);
            $window.history.back();
            return;
          }
          $scope.data.model.code = (parseInt(response.current)+1).toString();
        });
      } else {
        $scope.isNew = false;
        issueFactory(PATH_ISSUE_RECORD + "/_uuid/" + itemId).getUUID().$promise.then(function (response) {
          if(response){
            $scope.data = response;
            /* ho cambiato la posizione per ottenere lo schema della issue altrimenti non si riusciva ad inizializzare la lookup */
            $scope.getSchemaIssue();

            $scope.currentIssueRef = sixObjectLib.recordToHisRef($scope.data);
            /** TO FIX: vedere come risolvere la gestione delle date */
            if($scope.data.date_insertion != null){ $scope.data.date_insertion = new Date($scope.data.date_insertion);}
            if($scope.data.date_handling != null){ $scope.data.date_handling = new Date($scope.data.date_handling);}
            if($scope.data.date_closing != null){ $scope.data.date_closing = new Date($scope.data.date_closing);}
            if($scope.data.date_requested != null){ $scope.data.date_requested = new Date($scope.data.date_requested);}
            $scope.getNotificationsList();
            $scope.getOdlList();
            if(angular.isUndefined($scope.data.model.attachments)){
              $scope.data.model.attachments = [];
            }
            readAttachments($scope.data.model.attachments);
          }
        });
      }
    };

    $scope.getSchemaIssue = function(){
      issueFactory(PATH_ISSUE_SCHEMA).callCenter().$promise.then(function (data) {
        if(data.model){
          $scope.schemaIssueDefined = true;
          $scope.configCurrentSchema = angular.copy(data);
          $scope.schema = data.model.schema;
          $scope.form = data.model.form;
          $scope.columnDefs = data.model.columnDefs;
        } else {
          $scope.schemaIssueDefined = false;
        }
      });
    };

    $scope.getWar = function(entity){
        return $scope.schema.properties[entity].war;
    };

    $scope.getType = function(modelItem) {
      if(modelItem.type == 'datepicker'){
        return 'date';
      }
      else{
        return modelItem.type;
      }
    };

    function setBodyText(notification){
      var model = notification.model;
      if(angular.isDefined(model)){
        var bodyHtml = model.body;
        if(angular.isDefined(bodyHtml)){
          bodyHtml = "<div>" + bodyHtml + "</div>";
          var bodyText = $(bodyHtml).text();
          model.bodyAsText = bodyText;
        }
      }
    }

    $scope.getNotificationsList = function() {
      var payload = {
        page: 1,
        pageSize: 10000,
        UUID: $scope.data.UUID,
        //index: 'six_issue',
        typeNotification: 'issue',
        list: null
      };
      notificationFactory().getListFiltered(payload)
        .$promise.then(function(data) {
        $scope.notifications = data.list;
        if($scope.notifications != null && !($scope.notifications.isDefined)){
          for(var i=0; i<$scope.notifications.length; i++){
            var notification = $scope.notifications[i];
            setBodyText(notification);
            notification.color = 'b-l-warning';
            notification.href = "#/notification/" + notification.version;
          }
        }
      });
    };

    $scope.getOdlList = function(){
      $scope.odlList = [];
      var payload = {
            query: "issue_id.code=" + $scope.data.model.code,
            page: 1,
            pageSize: 10000,
            history: false
        };
      odlFactory().getOdlList(payload).$promise.then(function(data) {
        $scope.odlList = data.list;
      });
    };

    /* $watch per pulire il campo record quando cancello il tipo */
    $scope.$watch('data.model.type_id', function (newValue, oldValue) {
      if(newValue != oldValue && oldValue != undefined){
        $scope.data.model.record_id = null;
      }
    });


    $scope.getConfiguration = function () {
      if($scope.data.model.type_id && $scope.data.model.record_id && $scope.data.model.service_id) {
        var payload = {
          type_id: $scope.data.model.type_id,
          record_id: $scope.data.model.record_id,
          service_id: $scope.data.model.service_id,
          response: {}
        };
        treePlanConfigFactory.getCompleteConfiguration(payload).$promise.then(function (data) {
          if (data.response != null) {
            toaster.pop('success', 'Successo', 'Caricamento configurazione associata effettuato');
            $scope.configurationIssue = data.response;
            if($scope.configurationIssue.responsable.length > 0) {
              $scope.responsableList = $scope.configurationIssue.responsable;
            } else {$scope.responsableList = [];}
            if($scope.configurationIssue.secretariat.default.secretariat_id) {
              $scope.data.references_assignee.secretariat_id = $scope.configurationIssue.secretariat.default.secretariat_id;
            }
            if($scope.configurationIssue.supervisorExternal.default.operator_id) {
              $scope.data.references_assignee.supervisorExternal_id = $scope.configurationIssue.supervisorExternal.default.operator_id;
            }
            if($scope.configurationIssue.secretariat.filtered.length > 0) {
              $scope.secretariatFilter = getFilter($scope.secretariatFilter, $scope.configurationIssue.secretariat.filtered);
            }
            if($scope.configurationIssue.supervisorExternal.filtered.length > 0) {
              $scope.supervisorExternalFilter = getFilter($scope.supervisorExternalFilter, $scope.configurationIssue.supervisorExternal.filtered);
            }
          }
        });
      } else {
        toaster.pop('error', 'Errore', 'Controllare i valori tipo asset, asset e servizio');
      }
    };

    $scope.toggleAllIssues = function() {
      $scope.bool.allIssues = !$scope.bool.allIssues;
      localStorageService.set('issue_bool', $scope.bool);
      $scope.refresh();
    };



    if($routeParams.id) {
      $scope.getIssueById($routeParams.id);
    } else {
      // $scope.getIssueList();
      $scope.getColumns();
    }




    /******** gestione timeline **************/

    $scope.modelDataInTimeline = {};
    $scope.schemaDataInTimeline = {};
    $scope.formDataInTimeline = {};
    $scope.timeline = [];
    $scope.entity = 'issue/record';

    $scope.getTimeline = function () {
      if (angular.isDefined($scope.entity) && angular.isDefined($scope.data.UUID)) {
        $scope.buildTimeline($scope.entity, $scope.data.UUID);
      }
    };

    $scope.buildTimeline = function (entity, UUID, version) {
      $scope.entity = entity;
      $scope.timeline = issueFactory(entity, UUID).getTimeline().$promise.then(function (data) {
        $scope.timeline = data.list;
        if (angular.isDefined(version)) {
          $scope.modelDataInTimeline['version'] = version;
        }
      });
    };

    $scope.getModelDetail = function (version) {
      issueFactory($scope.entity, version).byID({id: version}).$promise.then(function (data) {
        $scope.currentDataInTimeline = data;
        $scope.modelDataInTimeline.version = data.version;
        if(angular.isUndefined(data.dataOut) || data.dataOut==null){
          data.dataOut = "_current";
        }
        console.log('Call center: model.code -> callcenter, type -> schema, UUID -> '+$scope.configCurrentSchema.UUID);
        issueFactory(PATH_ISSUE_SCHEMA).getSchemaInTimeline({id: $scope.configCurrentSchema.UUID, param1: data.dataOut}).$promise.then(function (response) {
          if(response.model){
            $scope.showDetail = true;
            $scope.schemaDataInTimeline = response.model.schema;
            $scope.formDataInTimeline = response.model.form;
          }
        });
      });
    };

    /******** funzioni di utility ***********/

    $scope.getMessage = function () {   /* creazione testo mail */
      var searchInit = {
        search: {  obj: {'username':authFactory.getAuthData().authId}  },
        init: { authId: true,  email: true }
      };
      if(angular.isDefined($scope.data.model.type_id) && angular.isDefined($scope.data.model.record_id)){
        $scope.loadingSixMail = true;
        var promiseMailReceiver = notificationFactory().getMailReceiver($scope.data).$promise;
        var promiseMailUser = userFactory.getMail(searchInit).$promise;

        Promise.all([promiseMailReceiver, promiseMailUser]).then(function (response) {  // response[0] = promiseMailReceiver, response[1] = promiseMailUser
          $scope.loadingSixMail = false;
          $scope.objMail = {
            title: 'Apertura Segnalazione su asset: (tipo) ' + $scope.data.model.type_id.description + ' - (elemento) ' + $scope.data.model.record_id.description,
            to: formatMailReceiver(response[0]),
            cc: formatMailCc(response[1].list[0].email),
            message: 'Apertura segnalazione su asset: ' + $scope.data.model.type_id.description + ' - ' + $scope.data.model.record_id.description +'\n' +
            '\n' +
            'Dati tipo elem. tecnologico: (cod.) '+ getText($scope.data.model.type_id, 'code') + ' - (descr.) ' + getText($scope.data.model.type_id, 'description') + '\n' +
            'Dati elem. tecnologico: (cod.) '+ getText($scope.data.model.record_id, 'code') + ' - (descr.) ' + getText($scope.data.model.record_id, 'description') + '\n' +
            'Tipo segnalazione: ' + getText($scope.data.model.issuetype_id, 'description') + '\n' +
            'Servizio richiesto: ' + getText($scope.data.model.service_id, 'description') + '\n' +
            'Priorità: ' + getText($scope.data.model.priority_id, 'description') + '\n' +
            'Descrizione segnalazione: ' + getText($scope.data.model, 'description') + '\n\n' +
            'Note aggiuntive: ' + getText($scope.data.model, 'note') + '\n'
          }
        });
      } else {
        toaster.pop('error', 'Errore', 'Creazione della mail precompilata non riuscita.');
      }
    };

    $scope.setBoolWatchInternal = function (){
      $scope.bool_watch_internal = true;
      $scope.bool_watch_external = false;
    };

    $scope.setBoolWatchExternal = function (){
      $scope.bool_watch_internal = false;
      $scope.bool_watch_external = true;
    };

    $scope.addWatcher = function () {
      if($scope.bool_watch_internal){ /* se è interno */
        if($scope.watcher.user != null && include($scope.data.watchers.internal, $scope.watcher.user) == false){
          $scope.data.watchers.internal.push($scope.watcher.user);
        }
        $scope.watcher.user = null;
      } else if ($scope.bool_watch_external){ /* se è esterno */
        if($scope.watcher.mail != null){
          $scope.data.watchers.external.push($scope.watcher.mail);
        }
        $scope.watcher.mail = null;
      }
    };

    $scope.addWatcherFromLookUp = function (lookUp) {
      if(angular.isDefined(lookUp) && lookUp != null){
        copyInWatchers(lookUp);
      }
    };

    $scope.deleteWatcher = function (array, toDelete){
      var index = array.indexOf(toDelete);
      if (index > -1) {
        array.splice(index, 1);
      }
    };

    function include(arr,obj) {
      var bool = false;
      for(var i = 0; i < arr.length; i++){
        if(obj.code == arr[i].code){
          bool = true;
        }
      }
      return bool;
    }

    function copyInWatchers(obj){
      var bool = false;
      for(var i = 0; i < $scope.data.watchers.internal.length; i++){
        if(obj.code == $scope.data.watchers.internal[i].code){
          bool = true;
        }
      }
      if(bool == false){
        $scope.data.watchers.internal.push(obj);
      }
    }

    function getFilter(filter, array){
      var string = '';
      array.forEach(function (item, index) {
        if(index == 0){
          string = item.UUID;
        } else {
          string = string +','+ item.UUID;
        }
        filter['UUID'] = string;
      });
      return filter;
    }

    function getText(ref, element){
      if(angular.isDefined(ref) && ref != null){
        if(angular.isDefined(ref[element]) && ref[element] != null){
          return ref[element];
        }
      }
      return '';
    }

    function formatMailReceiver (array) { /* from array to formatted string with comma */
      if(angular.isDefined(array.result)){
        if(array.result.length != 0){
          var strConcat = '';
          for(var i = 0; i < array.result.length; i++){
            if(i == 0){
              strConcat = array.result[i];
            } else {
              strConcat = strConcat + ', ' + array.result[i];
            }
          }
          return strConcat;
        } else {
          return '';
        }
      } else {
        return '';
      }
    }

    function formatMailCc (UserMailSix) {
      if(UserMailSix){
        return UserMailSix;
      } else {
        return null;
      }
    }


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'issue/record';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:IssueCtrl
 * @description
 * # IssueCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/issue', {
        templateUrl: 'plan/issue/issue.html',
        controller: 'IssueCtrl'
      })
      .when('/issue/:id', {
        templateUrl: 'plan/issue/issuedetail_edit.html',
        controller: 'IssueCtrl'
      })
      .when('/issue/page/:number', {
        templateUrl: 'plan/issue/issue.html',
        controller: 'IssueCtrl'
      })
      .when('/newissue', {
        templateUrl: 'plan/issue/tree_issue.html',
        controller: 'IssueCtrl'
      })
      .when('/newissuenotree', {
        templateUrl: 'plan/issue/issuedetail_new.html',
        controller: 'IssueCtrl'
      })
  })
  .controller('IssueCtrl', function ($scope, authFactory, $routeParams, $log, $window, baseFactory, notificationFactory, issueFactory, modelFactory, schemaFactory, treeFactory,
                                     modelIconService, $location, toaster, issueToOdl, uiGridConstants, $timeout, $route) {

    /**** CONSTANTS ****/

    var PATH_ISSUE_SCHEMA = 'issue/schema';
    var PATH_ISSUE_RECORD = 'issue/record';

    var TREE = 'tree';      // endpoint per i tree
    var PREFIX = 'def';     // prefisso del code del tree nell'indice
    var TREETYPE = 'definition';
    var STABLE = 'stable', SNAP='snap';

    var currentCommission = authFactory.getAuthData().info.commissions.current;

    $scope.commissionDependent = true;

    $scope.schemaIssueDefined = false;

    $scope.typeName = 'issue';

    $scope.usersList = [];

    $scope.showRecordsList = true;  // flag per mostrare/nascondere la lista dei record
    $scope.showTree = true;         // flag per mostrare/nascondere il tree

    $scope.searchInput = {text: undefined};  // Oggetto che contiene i filtri di ricerca
    $scope.queryParam = '';
    $scope.uiGridFiltersQuery = '';

    $scope.tree = {
      wrapper: {model: {nodes: [], type: TREETYPE}},    // wrapper che arriva dall'endpoint che fornisce l'albero richiesto
      structure: {}   // struttura dell'albero creata tramite il tree configurator
    };

    $scope.treeCollapsed = false;

    $scope.records = {
      list: [],           // lista non filtrata delle entity ammesse nel nodo selezionato
      filteredList: []   // lista delle entity ammesse filtrata (serve a evitare problemi con drag&drop sotto paginazione)
    };

    // Record da aggiungere "inline" da questa pagina
    $scope.record = {
      wrapper: {},      // wrapper che arriva dall'endpoint che fornisce l'albero richiesto
      type: {},         // tipo di record (schemaCode)
      model: {},        // valorizzazione del record
      schema: {},
      form: {},
      version: undefined,
      parent: undefined // nodo in cui si sta cercando di aggiungere il record
    };

    $scope.selected = {
      treeNode: undefined,  // Nodo dell'albero correntemente selezionato
      records: []           // Record correntemente selezionati (selezione multipla)
    };

    $scope.dropdownList = {
      roots: [],   // Lista delle radici che è possibile creare ex-novo
      nodes: []   // Lista dei nodi che è possibile creare ex-novo in base all'elemento del tree selezionato
    };

    var sortFields;
    var sortDirection;

    var paginationOptions = {
      pageNumber: 1,
      pageSize: 10
    };

    $scope.viewGridOptions = {
      enableSorting: true,
      enableGridMenu: true,
      exporterCsvColumnSeparator: ';',
      exporterSuppressColumns: [ 'id' ],
      exporterMenuPdf: false,
      enableFiltering: true,
      columnDef: [],
      enableColumnResizing: true,
      paginationPageSizes: [10, 15, 20, 30, 40, 50],
      paginationPageSize: 10,
      useExternalPagination: true,
      data: 'issueList.list',
      onRegisterApi: onRegisterApi,
      useExternalFiltering: true,
      multiSelect: true,
      enableRowHeaderSelection: true,
      enableRowSelection: true
    };

    // Gestione allegati
    $scope.attachments = [];
    function readAttachments(modelList){
        $scope.attachments.splice(0,$scope.attachments.length);
        for(var i=0; i<modelList.length; i++){
            $scope.attachments.push(modelList[i]);
        }
    }
    function writeAttachments(modelList){
        modelList.splice(0,modelList.length);
        for(var i=0; i<$scope.attachments.length; i++){
            modelList.push($scope.attachments[i]);
        }
    }
    $scope.updAttachments = function(){
        writeAttachments($scope.data.model.attachments);
        issueFactory(PATH_ISSUE_RECORD).update({id: $scope.data.version}, $scope.data);
    };

    /*** PARTE GRID ***/

    $scope.getColumns = function(){
      getColumnOrDefault();
      return $scope.columnDefs;
    };

    function getColumnOrDefault() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 34,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
        '<div class="ui-grid-cell-contents" style="text-align: center">' +
        '<a ng-href="#/issue/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' +
        '<span class="fa fa-search"></span>' +
        '</a>' +
        '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo',
        field: 'model.type_id.description',
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Asset',
        field: 'model.record_id.description',
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS, //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descrizione',
        field: 'model.description',
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS, //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Stato',
        field: 'status',
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data Inserimento',
        field: 'date_insertion',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        enableFiltering:false,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data richiesta',
        field: 'date_requested',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        enableFiltering:false,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data presa in carico',
        field: 'date_handling',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        enableFiltering:false,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data chiusura',
        field: 'date_closing',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        enableFiltering:false,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
    }

    var getPage = function() {
      $scope.viewGridOptions.totalItems = $scope.issueList.totalResults;
      var firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
      $scope.viewGridOptions.data = $scope.viewGridOptions.data.slice(firstRow, firstRow + paginationOptions.pageSize);
    };

    function onRegisterApi(gridApi) {
      $scope.gridApi = gridApi;
      gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
        paginationOptions.pageNumber = newPage;
        paginationOptions.pageSize = pageSize;
        $scope.updatePagination();
      });
      gridApi.core.on.filterChanged($scope, filterChangedCallback);
      gridApi.core.on.sortChanged($scope, sortChangedCallback);
      $scope.gridApi.core.refresh();
    }

    $scope.isSnapshot = function() {
      return $scope.historyMode == SNAP;
    };

    $scope.updatePagination =  function () {
      //$scope.viewGridOptions.totalItems = $scope.issueList.totalResults;
      $scope.getIssueList();
    };

    function sortChangedCallback(scope, sortColumns) {
      console.log(scope);
      console.log(sortColumns);
      sortFields = '';
      sortDirection = '';
      var sep = '';
      sortColumns.forEach(function(col) {
        sortFields += sep + col.field;
        sortDirection += sep + col.sort.direction;
        sep = ',';
      });
      $scope.getIssueList();
    }

    function filterChangedCallback() {
      $scope.uiGridFiltersQuery = {};
      $scope.viewGridOptions.columnDefs.forEach(function(col){
        console.log('filters '+col.filters);
        if (col.filters) {
          col.filters.forEach(function (filter) {
            var term = filter.term;
            var field = col.field;

            if (term && term != '') {
              $scope.uiGridFiltersQuery[field] = '*'+term+'*';
            }
          });
        }
        // Timeout per evitare rimbalzi di chiamate.
        if (angular.isDefined($scope.filterTimeout)) {
          $timeout.cancel($scope.filterTimeout);
        }
        $scope.filterTimeout = $timeout(function () {
          console.log($scope.uiGridFiltersQuery);
          $scope.updatePagination();
        }, 200);
      });
    }

    /*** PARTE TREE ***/

    // Cpmparatore di oggetti record
    var record2RecordComparator = function(node1, node2) {
      if (node1.version === node2.version) {
        return true;
      }
      return false;
    };

    // Seleziona un nodo dell'albero
    $scope.selectNode = function (node) {
      if (node === undefined) {
        $scope.unselectRecord();
        $scope.dropdownList.nodes = angular.copy($scope.dropdownList.roots);
        $scope.showTree = true;
        $scope.showRecordsList = true;
      }
      else {
        $scope.selected.treeNode = node;
        $scope.data.model.record_id = sixObjectLib.recordToHisRef(node);
        schemaFactory().byCode({id: $scope.data.model.record_id.type}).$promise.then(function (response) {
          if(response){
            //$scope.data.model.type_id = response;
            $scope.data.model.type_id = {
              UUID: response.UUID,
              code: response.model.code,
              description: response.model.description,
              type: 'schema'
            };
          }
        });
      }
    };

    // Necessario per evitare deselezione (solo a livello html) del nodo selezionato ogni volta che viene
    // ridisegnato l'albero (i riferimenti cambiano)
    $scope.isNodeSelected = function (node) {
      if ($scope.selected.treeNode && node) {
        return record2RecordComparator(node, $scope.selected.treeNode);
      }
      return false;
    };

    // Recuper l'icona del model da menu
    $scope.getModelIcon = function (modelName) {
      var icon = modelIconService.getModelIcon(modelName) || 'fa fa-list';
      return icon;
    };

    // Recupera un tree salvato
    $scope.getTree = function () {
      treeFactory.getTreeDefinition().$promise.then(function (data) {
        if (data.version) {
          $scope.tree.wrapper = data;
        }
        else {
          $scope.tree.wrapper = {model: { nodes: [], type: TREETYPE }};
        }
      })
    };

    // (De)Comprime i rami dell'albero
    $scope.toggleNode = function (scope) {
      scope.toggle();
    };

    $scope.toggleAll = function() {
      var scope = angular.element(document.getElementById("tree1-root")).scope();
      if($scope.treeCollapsed === false) {
        scope.collapseAll();
        $scope.treeCollapsed = true;
      }
      else {
        scope.expandAll();
        $scope.treeCollapsed = false;
      }
    };

    // Deseleziona il nodo selezionato
    $scope.unselectRecord = function () {
      $scope.record = {
        wrapper: {},
        type: {},
        version: undefined,
        schema: {},
        model: {},
        form: {},
        parent: $scope.tree.wrapper.model
      };
      $scope.selected.treeNode = undefined;
      $scope.selected.records = [];
      $scope.updateFilteredList();
    };

    /*** PARTE ISSUE ***/

    var now = new Date();

    $scope.data = {
      date_insertion: now,
      date_requested: now,
      date_handling: null,
      date_closing: null,
      references_assignee: {  // oggetto per contenere i riferimenti a: tecnici, assegnatari, fornitore...
        secretariat_id: null,
        technicianexternal_id: null
      },
      watchers: {
        external: [],
        internal: []
      },
      reporter_id: null,
      model: {
        type_id : null,
        record_id : null,
        service_id: null,
        attachments: []
      }
    };


    $scope.newIssue = function () {
        $location.path('newissue');
    };

    $scope.refresh = function () {
      $route.reload();
    };

    $scope.back = function () {
      $location.path('issue');
    };

    function leftPad(number, targetLength) {
      var output = number.toString() + '';
      while (output.length < targetLength) {
        output = '0' + output;
      }
      return output;
    }

    function wildcards(queryParam) {
      if (queryParam == null || queryParam == '') return queryParam;
      return queryParam+'*';
    }

    function getQuery(){
      return $scope.queryParam;
    }

    $scope.getIssueList = function () {
       issueFactory(PATH_ISSUE_RECORD).search({query: getQuery(),
         page: paginationOptions.pageNumber, page_size: paginationOptions.pageSize, show_revision: false},  $scope.uiGridFiltersQuery).$promise.then(function(data) {
         $scope.issueList = data;
         getPage();
       });
    };

    $scope.update = function () {
      if ($scope.isNew){  /* se la segnalazione è nuova */
        if($scope.data.model.record_id && $scope.data.model.type_id){
          $scope.data.model.code = (
              $scope.data.date_insertion.valueOf()).toString()+'_'+leftPad($scope.data.date_insertion.getHours(),2)+leftPad($scope.data.date_insertion.getMinutes(),2)
              +'_'+$scope.data.model.type_id.code
              +'_'+$scope.data.model.record_id.code;
        } else{
          toaster.pop('error', 'Errore Inserimento', 'Non sono stati riempiti tutti i campi necessari: TIPO, ASSET');
        }
      }
      upd();
    };

    function upd(){
      if($scope.isNew){
          $scope.data.model.attachments = [];
          writeAttachments($scope.data.model.attachments);
        issueFactory(PATH_ISSUE_RECORD).create({commissionDependent: $scope.commissionDependent}, $scope.data).$promise.then(function () {
          $log.info('saving: '+$scope.data.model.code);
          $location.path('/issue', false);
        });
      } else{
        if(angular.isUndefined($scope.data.model.attachments)){
            writeAttachments($scope.data.model.attachments);
        }
        issueFactory(PATH_ISSUE_RECORD).update({id: $scope.data.version}, $scope.data).$promise.then(function () {
          $log.info('updating id: '+$scope.data.version);
          $location.path('/issue', false);
        });
      }
    }

    $scope.generate_odl = function(){
      issueToOdl.push($scope.data);
      $location.path('/odl/new', false);
    };

    $scope.generate_odl_from_list = function(issueId){
      issueFactory(PATH_ISSUE_RECORD).getId({id: issueId}).$promise.then(function (response) {
        if(response){
          issueToOdl.push(response);
          $location.path('/odl/new', false);
        }
      });
    };

    $scope.getIssueById = function (itemId) {
      if(itemId == 'new'){
        $scope.isNew = true;
      } else{
        $scope.isNew = false;
        issueFactory(PATH_ISSUE_RECORD + "/_uuid/" + itemId).getUUID().$promise.then(function (response) {
          if(response){
            $scope.data = response;
            // TO FIX: vedere come risolvere la gestione delle date
            if($scope.data.date_insertion != null){ $scope.data.date_insertion = new Date($scope.data.date_insertion);}
            if($scope.data.date_handling != null){ $scope.data.date_handling = new Date($scope.data.date_handling);}
            if($scope.data.date_requested != null){ $scope.data.date_requested = new Date($scope.data.date_requested);}
            if($scope.data.date_closing != null){ $scope.data.date_closing = new Date($scope.data.date_closing);}
            // FINE DELLA PARTE DA FIXARE
            $scope.getNotificationsList();
            if(angular.isUndefined($scope.data.model.attachments)){
                $scope.data.model.attachments = [];
            }
            readAttachments($scope.data.model.attachments);
          }
        });
      }
    };

    $scope.getSchemaIssue = function(){
      issueFactory(PATH_ISSUE_SCHEMA).schemaOrDefault().$promise.then(function (data) {
        if(data.model){
          $scope.schemaIssueDefined = true;
          $scope.config = angular.copy(data);
          $scope.schema = data.model.schema;
          $scope.form = data.model.form;
          $scope.columnDefs = data.model.columnDefs;
        } else{
          $scope.schemaIssueDefined = false;
          toaster.pop('error', 'Errore caricamento pagina', 'Nessun modello salvato per il tipo \'segnalazione\'.');
        }
      });
    };

    function pad(value, char, length) {
      return (value.toString().length < length) ? pad(char+value, char, length):value;
    }

    $scope.sendMessage = function(){
        $location.path('wysiwyg');
    };

    function setBodyText(notification){
        var model = notification.model;
        if(angular.isDefined(model)){
            var bodyHtml = model.body;
            if(angular.isDefined(bodyHtml)){
                bodyHtml = "<div>" + bodyHtml + "</div>";
                var bodyText = $(bodyHtml).text();
                model.bodyAsText = bodyText;
            }
        }
    }

    $scope.getNotificationsList = function() {
        var payload = {
            page: 1,
            pageSize: 10000,
            UUID: $scope.data.UUID,
            index: 'six_issue'
        };
        notificationFactory().getListFiltered(payload)
          .$promise.then(function(data) {
          $scope.notifications = data.list;
          if($scope.notifications != null && !($scope.notifications.isDefined)){
            for(var i=0; i<$scope.notifications.length; i++){
              var notification = $scope.notifications[i];
              setBodyText(notification);
              notification.color = 'b-l-warning';
              notification.href = "#/notification/" + notification.version;
            }
          }
        });
    };

    /* $watch per pulire il campo record quando cancello il tipo */
    $scope.$watch('data.model.type_id', function (newValue, oldValue) {
      if(newValue != oldValue && oldValue != undefined){
        $scope.data.model.record_id = null;
      }
    });

    $scope.getSchemaIssue();

    if($routeParams.id) {
      $scope.getIssueById($routeParams.id);
    } else {
      $scope.isNew = true;
      $scope.getTree();
      $scope.getIssueList();
      $scope.getColumns();
    }


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'issue/record';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:IssueconfiguratorCtrl
 * @description
 * # IssueconfiguratorCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/issueconfigurator', {
        templateUrl: 'plan/issue/issueconfigurator_list.html',
        controller: 'IssueconfiguratorCtrl'
      })
      .when('/issueconfigurator/page/:number', {
        templateUrl: 'plan/issue/issueconfigurator_list.html',
        controller: 'IssueconfiguratorCtrl'
      })
      .when('/issueconfigurator/:id', {
        templateUrl: 'plan/issue/issueconfigurator_detail.html',
        controller: 'IssueconfiguratorCtrl'
      })
  })
  .controller('IssueconfiguratorCtrl', function ($scope, $routeParams, $location, $log, $window, issueFactory,
                                                 commissionFactory, schemaFactory, toaster, authFactory, dialogService) {

    var PATH_ISSUE_SCHEMA = 'issue/schema';
    var PATH_ISSUE_CONFIG = 'issueconfigurator';

    $scope.typeName = 'issue';

    $scope.bool = { /* contenitore per le variabili booleane */
      isNew: false,
      isCross: false,
      isCallCenter: false,
      confModel: false
    };

    $scope.commissionDependent = true;

    $scope.commissionCode = '';

    $scope.commissions = [];

    $scope.commissionsSelected = {codes: []};

    $scope.selected = {}; /* contenitore del dato */

    $scope.form = {};

    $scope.model = {};

    $scope.schema = {};

    $scope.property = {};

    $scope.checked = {};

    $scope.uiselectMap = {};

    $scope.itemTypeMap =  {};

    $scope.pageSize = 10;

    $scope.status = {
      isFirstOpen: true,
      isFirstDisabled: false
    };

    $scope.modeltypeList = schemaFactory().lookupList({page_size: 1000});

    $scope.addProperty = function() {
      /* aggiungo una proprietà allo Schema e al Form */
      if(angular.isDefined($scope.property.key)) {
        var p = {
          title: angular.copy($scope.property.title),
          type: angular.copy($scope.property.type),
          check: false
        };
        if($scope.property.format){
          p.format = angular.copy($scope.property.format);
        }
        if(p.type == 'date'){
          p.type = 'string';
          p.format = 'date';
        }
        if(p.type == 'array'){
          p.items = {type: angular.copy($scope.property.items_type)}; // default
          if($scope.property.items_type === 'date') { // se è una data è diverso...
            p.items = {type: 'string', format: 'date'};
          }
        }
        $scope.selected.model.schema.properties[$scope.property.key] = p;
        var item = {
          title: angular.copy($scope.property.title),
          type: null,
          key: [angular.copy($scope.property.key)]
        };
        if(p.format){
          if (p.format == 'date'){
            item.type = 'datepicker';
          } else if (p.format == 'enum'){
            item.type = 'uiselect';
            item.titleMap = [];
          } else if (p.format == 'lookup'){
            item.type = 'sixlookup';
          }
        } else if(p.type == 'string'){
          item.type = 'text';
        } else if(p.type == 'number' || p.type == 'integer'){
          item.type = 'number';
        } else if(p.type == 'boolean'){
          item.type = 'checkbox';
        } else if(p.type == 'array') {
          item.type = 'uiselectmultiple';
          item.titleMap = [];
        } else {  // default
          item.type = angular.copy(p.type);
        }
        for(var i in $scope.selected.model.form[0].items) {
          if($scope.selected.model.form[0].items[i].tabs) {
            $scope.selected.model.form[0].items[i].tabs[0].items.push(item);
          }
        }
      }
      $scope.getUiselectMap();
      $scope.clearNewCol();
      $scope.updateScope();
    };

    $scope.updateScope = function() {
      $scope.schema = angular.fromJson(angular.copy($scope.selected.model.schema));
      $scope.form = [angular.fromJson(angular.copy($scope.selected.model.form[0]))];
      $scope.columnDefs = angular.fromJson(angular.copy($scope.selected.model.columnDefs));
      $scope.formChanged();
    };

    $scope.clearNewCol = function(){
      /* pulisco la riga di inserimento di nuove proprietà */
      $scope.property.key = '';
      $scope.property.title = '';
      delete $scope.property.type;
      delete $scope.property.format;
    };

    $scope.getItemType = function(key){
      console.log(valueSchema);
      if(valueSchema.type != 'array'){
        return valueSchema.type;
      } else {
        return valueSchema.items.type;
      }
    };

    $scope.addItemOnArray = function(key, newItem){
      if(newItem != undefined && newItem != null){
        newItem.name = newItem.name.toString();
        if($scope.itemTypeMap[key] == 'integer'){
          if(parseInt(newItem.name)){
            newItem.value = parseInt(newItem.name);
            newItem.name = newItem.value.toString(); /* nel caso ci dovesse essere un cast, torno a sovrascrivere il name */
          } else{
            return;
          }
        } else if($scope.itemTypeMap[key] == 'number'){
          if(parseFloat(newItem.name)){
            newItem.value = parseFloat(newItem.name);
          } else{
            return;
          }
        } else{
          newItem.value = newItem.name.toString().replace(/\s/g, '_').toLowerCase();
        }
        for(var i in $scope.selected.model.form[0].items) {
          if($scope.selected.model.form[0].items[i].tabs) {
            $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
              if(key == item.key[0]){
                item.titleMap.push(newItem);
              }
            });
          }
        }
        this.newItem = null;
        $scope.updateScope();
      }
    };

    $scope.deleteItemOnArray = function(key, obj){
      for(var i in $scope.selected.model.form[0].items) {
        if($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            if(key == item.key[0]){
              for (var j = item.titleMap.length; j--; ) {
                if (item.titleMap[j].value == obj.value) {
                  item.titleMap.splice(j, 1);
                }
              }
            }
          });
        }
      }
      this.newItem = null;
      $scope.updateScope();
    };

    $scope.deleteProperty = function(keyToDelete) {
      delete $scope.selected.model.schema.properties[keyToDelete];
      for (var i = $scope.selected.model.columnDefs.length; i--; ) {
        if ($scope.selected.model.columnDefs[i].field == keyToDelete) $scope.selected.model.columnDefs.splice(i, 1);
      }
      // ...elimino sempre dalla form
      for (var i = $scope.selected.model.form[0].items.length; i--; ) {
        if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == keyToDelete) {
          $scope.selected.model.form[0].items.splice(i, 1);
        }
        // Scorro anche i tabs
        if($scope.selected.model.form[0].items[i].tabs) {
          for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
            for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
              if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == keyToDelete) {
                $scope.selected.model.form[0].items[i].tabs[j].items.splice(k, 1);
              }
            }
          }
        }
      }
      $scope.updateScope();
    };

    $scope.formChanged = function() {
      $scope.aceModel = JSON.stringify(angular.copy($scope.selected), null, '\t');
    };

    $scope.refreshLookup = function(key,entity_id) {
      $scope.chargeAceModel();
      for (var i = $scope.selected.model.form[0].items.length; i--;) {
        if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == key) {
          $scope.selected.model.form[0].items[i].entity_id = angular.copy(entity_id);
        }
        // Scorro anche i tabs
        if($scope.selected.model.form[0].items[i].tabs) {
          for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
            for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
              if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == key) $scope.selected.model.form[0].items[i].tabs[j].items[k].entity_id = angular.copy(entity_id);
            }
          }
        }
      }
      $scope.selected.model.schema.properties[key].entity_id = angular.copy(entity_id);
      $scope.updateScope();
    };

    $scope.refreshBasePath = function(key, basePath){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].basePath = angular.copy(basePath);
      $scope.updateScope();
    };

    $scope.refreshWar = function(key, war){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].war = angular.copy(war);
      $scope.updateScope();
    };

    $scope.refreshFiltered = function(key, filtered){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].filtered = angular.copy(filtered);
      $scope.updateScope();
    };

    $scope.refreshFilterSourceField = function(key, filterSourceField){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].filterSourceField = angular.copy(filterSourceField);
      $scope.updateScope();
    };

    $scope.refreshFilterDestField = function(key, filterDestField){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].filterDestField = angular.copy(filterDestField);
      $scope.updateScope();
    };

    $scope.refreshTitleForm = function(title) {
      $scope.chargeAceModel();
      $scope.selected.model.form[0].title = angular.copy(title);
      $scope.updateScope();
    };

    $scope.chargeAceModel = function() {
      var defaultData = angular.fromJson(angular.copy($scope.aceModel));
      if(defaultData) {
        $scope.selected = defaultData;
        $scope.schema = angular.fromJson(defaultData.model.schema);
        $scope.form = angular.fromJson(defaultData.model.form);
        $scope.columnDefs = angular.fromJson(defaultData.model.columnDefs);
      }
    };

    $scope.changeColumnDefs = function (key, value) {
      var item = {name: value.title, field: key};
      var map = new Map();
      angular.forEach($scope.selected.model.columnDefs, function (v) {
        map[v.field] = angular.copy(v);
      });
      if(value.check){
        map[item.field] = angular.copy(item);
        if(value.width == '' || value.width == null) {
          delete $scope.selected.model.schema.properties[key].width;
        }
      }
      else{
        delete map[item.field];
        delete $scope.selected.model.schema.properties[key].width;
        $scope.selected.model.schema.properties[key].enableFiltering = false;
        $scope.selected.model.schema.properties[key].enableSorting = false;
      }
      $scope.selected.model.columnDefs=[];
      for(var it in map) {
        var app = {name: map[it].name, field: map[it].field};
        $scope.selected.model.columnDefs.push(app);
      }
      $scope.updateScope();
    };

    $scope.aceLoaded = function() {
      var defaultModel = {
        model: {
          schema: {
            type: "object",
            title: "",
            properties: {
              code: {
                title: "Codice",
                type: "string",
                check: true
              },
              description: {
                title: "Descrizione",
                type: "string",
                check: true
              }
            },
            required: [
              "code",
              "description"
            ]},
          form:[
            {
              type: "fieldset",
              items: [
                {
                  type: "tabs",
                  tabs: [
                    {
                      title: "Campi",
                      items: [
                        {
                          key: ["code"],
                          title: "Codice",
                          required: true,
                          type: "text"
                        },
                        {
                          key: ["description"],
                          title: "Descrizione",
                          required: true,
                          type: "textarea",
                          placeholder: "Inserire qui la descrizione della segnalazione..."
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          columnDefs:[
            {
              "field": "code",
              "name": "Codice"
            },
            {
              "field": "description",
              "name": "Descrizione"
            }
          ]
        }
      };
      $scope.aceModel = JSON.stringify(defaultModel, null, '\t');
      $scope.chargeAceModel();
      $scope.title = angular.copy($scope.selected.model.form[0].title);
    };

    $scope.getUiselectMap = function(){
      $scope.uiselectMap = {};
      $scope.itemTypeMap  = {};
      for(var i in $scope.selected.model.form[0].items) {
        if($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].type;
            if($scope.selected.model.schema.properties[item.key[0]].type == 'array'){
              $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].items.type;
            }
            if(item.type == 'uiselect' || item.type == 'uiselectmultiple'){
              var blankObject = {
                name: '',
                value: ''
              };
              $scope.uiselectMap[item.key[0]] = addSelectedValue(item.titleMap, blankObject); /* aggiunto un elemento vuoto all'array per consentire il deselezionamento */
            }
          });
        }
      }
    };

    function addSelectedValue(array, obj) {
      var blankValuePresent = false;
      array.forEach(function (item) {
        if(item.value == obj.value && item.name == obj.name){
          blankValuePresent = true;
        }
      });
      if(blankValuePresent == false){
        array.push(obj);
      }
      return array;
    }

    $scope.isInheritable = function(type){
      return (type == 'number' || type == 'integer' || type == 'string' || type == 'boolean' || type == 'lookup');
    };

    /**********************/
    /***** FIX SCHEMA *****/
    /**********************/

    $scope.fixSchemaFormModel = function() {
      for(var i in $scope.selected.model.form[0].items) {
        if($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            if(item.type == 'uiselect'){
              $scope.selected.model.schema.properties[item.key[0]].format = 'enum';
            }
            if(item.type == 'uiselectmultiple'){
              $scope.selected.model.schema.properties[item.key[0]].type = 'array';
            }
          });
        }
      }
    };

    /****************/
    /***** FORM *****/
    /****************/

    $scope.newFieldForm = {};
    $scope.newTab = {
      title: "",
      items: []
    };

    $scope.addTab = function(container){
      if(!container.tabs) {
        container.tabs = [];
      }
      if(container.type !== 'tabs') {
        container.type = 'tabs';
      }
      var toAdd = angular.copy($scope.newTab);
      $log.log(container);
      container.tabs.push(toAdd);
      $log.log(container);
      $scope.updateScope();
      $scope.newTab = {
        title: "",
        items: []
      };
    };

    $scope.addFieldToTab = function(tab){
      if(!tab.items) {
        tab.items = [];
      }
      var toAdd = angular.copy($scope.newFieldForm);
      if($scope.newFieldForm.type === '' || $scope.newFieldForm.type === 'formula' || $scope.newFieldForm.type === 'inherited') {
        delete toAdd.type;
      }
      /* key è da cambiare in un array */
      toAdd.key = [];
      toAdd.key.push($scope.newFieldForm.key);
      /* se è una lookup, e se ha definito il campo entity_id nello schema, ci attacco anche l'entity_id */
      if(toAdd.type == 'sixlookup' && $scope.schema.properties[$scope.newFieldForm.key]['entity_id']){
        toAdd['entity_id'] = $scope.schema.properties[$scope.newFieldForm.key]['entity_id'];
      }
      tab.items.push(toAdd);
      $scope.updateScope();
      $scope.newFieldForm = {
        key: [],
        title: "",
        required: false,
        type: "text"
      };
    };

    $scope.removeTabOrField = function(key, container){
      container.splice(key, 1);
      $log.log(container);
      $scope.updateScope();
    };

    $scope.swapUp = function(key, collection) {
      if(key > 0) {
        var tmp = collection[key];
        collection[key] = collection[key-1];
        collection[key-1] = tmp;
      }
      $scope.updateScope();
    };

    $scope.swapDown = function(key, collection) {
      if(key < collection.length-1) {
        var tmp = collection[key];
        collection[key] = collection[key+1];
        collection[key+1] = tmp;
      }
      $scope.updateScope();
    };

    $scope.updateField = function(field) {
      if(field.type === '') {
        delete field.type;
      }
      $scope.updateScope();
    };

    $scope.$watchGroup(['commissionDependent', 'history'], function() {
      if($scope.commissionDependent === true) {
        $scope.history = true;
      }
      if($scope.selected.model){
        $scope.selected.model.history = $scope.history;
        $scope.selected.model.commissionDependent = $scope.commissionDependent;
        $scope.updateScope();
      }
    });

    $scope.pageChanged = function () {
      $location.path('/issueconfigurator/page/'+$scope.issueConfiguratorList.currentPage, false);
      $scope.issueConfiguratorList = issueFactory(PATH_ISSUE_SCHEMA).query({query: $scope.queryParam, page: $scope.issueConfiguratorList.currentPage});
    };

    $scope.printCommission = function (commission_array) {
      var result = '';
      var pos = 0;
      if(commission_array != null){
        angular.forEach(commission_array, function(value){
          if(pos == 0){
            result = value;
          } else{
            result = value +', '+ result;
          }
          pos++;
        });
      }
      return result;
    };

    $scope.updateCode = function() {
      if($scope.bool.isCross == true){
        $scope.commissionCode = 'default';
        $scope.commissionsSelected.codes = [];
      } else{
        $scope.commissionCode = '';
      }
    };

    $scope.setCallCenter = function(){
      /* impostare le varaibili per salvare la configurazione per il call center */
      if($scope.bool.isCallCenter == true){
        $scope.commissionCode = 'callcenter';
        $scope.commissionsSelected.codes = [];
      } else{
        $scope.commissionCode = '';
      }
    };

    $scope.setConfModel = function() {
      $scope.bool.confModel = true;
      $scope.bool.isCross = false;
      $scope.bool.isCallCenter = false;
      delete $scope.selected.version;
      $scope.commissionsSelected.codes = [];
      $scope.commissionCode = '';
    };

    $scope.newIssueConfig = function () {
      $location.path(PATH_ISSUE_CONFIG+'/new');
    };

    $scope.refresh = function () {
      $location.path(PATH_ISSUE_CONFIG);
    };

    $scope.back = function(){
      $location.path(PATH_ISSUE_CONFIG);
    };

    $scope.delete = function(){
      dialogService.confirmDialog('Eliminare la configurazione?',
        function () {
          issueFactory(PATH_ISSUE_SCHEMA).delete({id: $scope.selected.version}).$promise.then(function (response) {
            $scope.back();
          });
        }
      );
    };

    $scope.setCommissionSelected = function(){
      angular.forEach($scope.selected.model.commission, function( value_cm_string){
        var index = null;
        angular.forEach($scope.commissions, function(value_cm_obj){
         if(value_cm_string == value_cm_obj.code){
           index = $scope.commissions.indexOf(value_cm_obj);
           $scope.commissionsSelected.codes.push(value_cm_obj);
           $scope.commissions.splice(index,1);
         }
        });
      });
    };

    $scope.setBooleanFlag = function (){
      if($scope.selected.model){
        if($scope.selected.model.code == 'default'){
          $scope.bool.isCross = true;
        } else if ($scope.selected.model.code == 'callcenter'){
          $scope.bool.isCallCenter = true;
        }
      }
    };

    $scope.getIssueConfigurationById = function (code) {
      issueFactory(PATH_ISSUE_SCHEMA+'/_code/'+code).show().$promise.then(function(response){
        if(response.model){
          $scope.selected = angular.copy(response);
          $scope.commissionCode = $scope.selected.model.code;
          $scope.setCommissionSelected();
          $scope.setBooleanFlag();
          $scope.updateScope();
        }
      });
    };

    $scope.getIssueConfigurationList = function () {
      issueFactory(PATH_ISSUE_SCHEMA).query({query: $scope.queryParam, pageSize: $scope.pageSize}).$promise.then(function(response) {
        $scope.issueConfiguratorList = response;
      });
    };

    $scope.getCommission = function(){
      commissionFactory().getCommissionsList().$promise.then(function (response){
        if(response.list.length){
          $scope.commissions = response.list;
        }
      });
    };

    $scope.create = function(){
      issueFactory(PATH_ISSUE_SCHEMA).create($scope.aceModel)
        .$promise.then(function() {
        toaster.pop('success', 'Creazione avvenuta con successo', 'Salvataggio corretto');
        $scope.back();
      });
    };

    $scope.update = function(){
      issueFactory(PATH_ISSUE_SCHEMA).update({id: $scope.selected.version}, $scope.aceModel)
        .$promise.then(function() {
        toaster.pop('success', 'Update effettuato con successo', 'Update corretta');
        $scope.back();
      });
    };

    $scope.saveForm = function() {
      $scope.chargeAceModel();
      $scope.selected.model.code = $scope.commissionCode;
      if($scope.bool.isCross || $scope.bool.isCallCenter){
        /* se è cross non serve riempire il vettore delle commesse */
        $scope.selected.model.commission = null;
        $scope.selected.model.commissionDependent = false;
        $scope.formChanged(); /* aggiorno l'aceModel */
        if($scope.selected.version){
          $scope.update();
        } else {
          $scope.create();
        }
      } else{
        /* riempio il vettore delle commesse */
        $scope.selected.model.commission = [];
        angular.forEach($scope.commissionsSelected.codes, function(obj){
          $scope.selected.model.commission.push(obj.code);
        });
        $scope.formChanged(); /* aggiorno l'aceModel */
        if($scope.bool.confModel){ /* create obbligatoria */
          $scope.create();
        } else{
          if($scope.selected.version){
            $scope.update();
          } else {
            $scope.create();
          }
        }
      }
    };

    if($routeParams.id) {
      if($routeParams.id !== 'new'){
        $scope.bool.isNew = false;
        commissionFactory().getCommissionsList().$promise.then(function (response){
          if(response.list.length){
            $scope.commissions = response.list;
            $scope.getIssueConfigurationById($routeParams.id);
          }
        });
      } else{
        $scope.bool.isNew = true;
        $scope.getCommission();
      }
    } else {
      $scope.getIssueConfigurationList();
    }


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'issue/schema';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:OdlCtrl
 * @description
 * # OdlCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/odl', {
        templateUrl: 'plan/odl/odl_list.html',
        controller: 'OdlCtrl'
      })
      .when('/odl/:id', {
        templateUrl: 'plan/odl/odl_detail.html',
        controller: 'OdlCtrl'
      })
  })
  .controller('OdlCtrl', function ($scope, modelFactory, authFactory, odlFactory, notificationFactory, $routeParams, $log, $window, errorService, localStorageService,
                                   modelIconService, $location, treePlanConfigFactory, taskFactory, issueFactory, lookupFactory, dialogService, ngDialog,
                                   toaster, $filter, issueToOdl, uiGridConstants, $timeout, $route, counterFactory, userFactory, recordFactory, sixGridPaginationConstants) {
    /**** CONSTANTS ****/

    var currentCommission = authFactory.getAuthData().info.commissions.current;

    $scope.counterNameOdl = 'odl';

    $scope.odlRef = null;
    $scope.queryParam = '';
    $scope.uiGridFiltersQuery = '';

    $scope.loadingSixMail = true;

    $scope.commissionDependent = true;

    $scope.schemaOdlDefined = false;

    $scope.typeName = 'odl';

    $scope.issue = {}; /* ci salvo tutto il dato della segnalazione a cui faccio riferimento */

    $scope.notifications;

    if(localStorageService.get('odl_bool')) {
      $scope.bool = localStorageService.get('odl_bool');
    } else {
      $scope.bool = {
        allOdl: true,
        hidePlan: false
      };
    }

    $scope.odlList = {list: []};

    $scope.params = {
      pageNumber: 1,
      pageSize: 100,
      filters: {}
    };

    $scope.autoResizeParams = {
      enabled: true,
      minHeight: 200,
      marginTop: 290
    };


    // Gestione allegati
    $scope.attachments = [];
    function readAttachments(modelList){
        $scope.attachments.splice(0,$scope.attachments.length);
        for(var i=0; i<modelList.length; i++){
            $scope.attachments.push(modelList[i]);
        }
    }
    function writeAttachments(modelList){
        modelList.splice(0,modelList.length);
        for(var i=0; i<$scope.attachments.length; i++){
            modelList.push($scope.attachments[i]);
        }
    }

    /**  VARIABILI  **/

    $scope.bool_watch_internal = true;
    $scope.bool_watch_external = false;
    $scope.watcher = {  user: '', mail: ''};

    $scope.issueRefreshed = {
      bool: false,
      filter: {}
    };

    $scope.init = true;   // per prima inizializzazione controller (altrimenti si incasina la watch su $scope.data.model.type_id che pulisce $scope.data.model.record_id)


    /*** PARTE ODL ***/

    var now = new Date();

    $scope.data = {
      status: 'OPEN',
      generated_by: 'issue',
      issue_id: undefined,
      date_insertion: now,
      date_requested: now,
      date_handling: now,
      date_closing: undefined,
      references_assignee: {  // oggetto per contenere i riferimenti a: tecnici, assegnatari, fornitore...
        supplier_id: undefined,
        company_id: undefined,
        headmanCommission_id: undefined,
        technicianCommission_id: [],
        maintainer_id: [],
        supervisorExternal_id: undefined,
        supervisorInternal_id: undefined
      },
      watchers: {
        external: [],
        internal: []
      },
      // reporter_id: null, -> qua il riferimento non serve
      model:{
        code: undefined, /* da riempire automaticamente */
        description: undefined,
        type_id : undefined,
        record_id : undefined,
        service_id: undefined,
        attachments: []
      }
    };

    /** VARIABILI FILTRAGGIO LOOK UP */

    $scope.technicianCommissionFilter = { 'typeoperator_id' : sixFiltersLib.exact('model.typeoperator_id.code', 'tecnico_commessa') };
    $scope.headmanCommissionFilter = { 'typeoperator_id' : sixFiltersLib.exact('model.typeoperator_id.code', 'capo_commessa') };
    $scope.supervisorExternalFilter = { 'typeoperator_id' : sixFiltersLib.exact('model.typeoperator_id.code', 'tecnico_esterno') };
    $scope.supervisorInternalFilter = { 'typeoperator_id' : sixFiltersLib.exact('model.typeoperator_id.code', 'tecnico_commessa') };
    $scope.maintainerFilter = { 'typeoperator_id' : sixFiltersLib.exact('model.typeoperator_id.code', 'manutentore') };
    $scope.companyFilter = {};
    $scope.supplierFilter = {};

    $scope.configurationOdl = {}; /* oggetto per salvare la configurazione corrente definita sul tree */

    /** PARTE PER LA LOOKUP MULTIPLA SUGLI ASSEGNATARI  */
    $scope.technicianCommissionList = [];
    $scope.technicianCommissionListEffective = [];

    function operatorNotSelected (lookUpRef) {
      var bool = true;
      for(var i = 0; i < $scope.data.references_assignee.technicianCommission_id.length; i++){
        if($scope.data.references_assignee.technicianCommission_id[i].UUID == lookUpRef.UUID){
          bool = false;
        }
      }
      return bool;
    }

    $scope.getTechnicianCommissionList = function () {
      $scope.technicianCommissionList = [];
      $scope.technicianCommissionListEffective = [];
      var query = {query: "", history: false};
      if(angular.isDefined($scope.technicianCommissionFilter)){
        lookupFactory('/six-data-set/api/','record/operatore/_lookup').search(query, $scope.technicianCommissionFilter).$promise.then(function(resp) {
          if(angular.isDefined(resp) && resp.hasOwnProperty('list')) {
            for(var i = 0; i < resp.list.length; i++){
              var operatorLookUp = formattedLookUpOperator(resp.list[i]);
              $scope.technicianCommissionList.push(operatorLookUp);
              if(operatorNotSelected(operatorLookUp)){
                $scope.technicianCommissionListEffective.push(operatorLookUp);
              }
            }
          }
        });
      }
    };

    $scope.getTechnicianCommissionList();

    $scope.gridAppCallbacks = {};

    $scope.viewGridOptions = {
      enableSorting: true,
      enableGridMenu: true,
      exporterCsvColumnSeparator: ';',
      exporterSuppressColumns: [ 'id', 'timeline' ],
      exporterMenuPdf: false,
      enableFiltering: true,
      enableColumnResizing: true,
      paginationPageSizes: [100, 250, 500, 1000, 10000],
      paginationPageSize: 100,
      useExternalPagination: true,
      useExternalFiltering: true,
      multiSelect: true,
      enableRowHeaderSelection: true,
      enableRowSelection: true,
      enableHorizontalScrollbar: 1
    };

    $scope.newOdl = function () {
        $location.path('odl/new');
    };

    $scope.refresh = function () {
      // $route.reload();
      $scope.getColumns();
      $scope.getCurrentUserOdlList();
    };

    $scope.goToOdlList = function () {
      $location.path('odl');
    };

    $scope.goToIssue = function () {
      $location.path('callcenter_detail/'+$scope.data.issue_id.UUID);
    };

    $scope.getColumns = function(){
      getColumnOrDefault();
      return $scope.columnDefs;
    };

    function getColumnOrDefault() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 34,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents" style="text-align: center">' +
            '<a ng-href="#/odl/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' +
              '<span class="fa fa-search"></span>' +
            '</a>' +
          '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice ODL',
        field: 'model.code',
        enableFiltering: true,
        width: 150,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Titolo',
        field: 'model.title',
        enableFiltering: true,
        width: 300,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo asset',
        field: 'model.type_id',
        cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.model.type_id.description}}</div>',
        enableFiltering: true,
        width: 100,
        filters:[{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Asset',
        field: 'model.record_id',
        cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.model.record_id.description}} ({{row.entity.model.record_id.code}})</div>',
        enableFiltering: true,
        width: 150,
        filters:[{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo asset target (qta)',
        field: 'model.target_type_id',
        cellTemplate:
          '<div class="ui-grid-cell-contents" ng-if="!row.entity.is_aggregated">-</div>' +
          '<div class="ui-grid-cell-contents" ng-if="row.entity.is_aggregated">{{row.entity.model.target_type_id.description}} ({{row.entity.model.record_id.children_count}})</div>',
        enableFiltering: true,
        width: 150,
        filters:[{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descrizione',
        field: 'model.description',
        enableFiltering: true,
        width: 500,
        cellTooltip: function(row) {
          return row.entity.model.description;
        },
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Stato',
        field: 'status',
        enableFiltering: true,
        width: 100,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data generazione',
        field: 'dataIn',
        type: 'date',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        width: 100,
        enableFiltering: true,
        filters: [
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data pianifica',
        field: 'date_requested',
        type: 'date',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        width: 100,
        enableFiltering: true,
        filters: [
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Utente generazione',
        field: 'user',
        cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.user}}</div>',
        enableFiltering: true,
        width: 100,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });

      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice generazione programmata',
        field: 'model.generation_tag',
        enableFiltering: true,
        width: 150,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Timeline',
        field: 'timeline',
        width: 106,
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents" style="vertical-align:middle;text-align:center;">' +
            '<a ng-href="#/timeline/odl/record/{{row.entity.UUID}}">' +
              '<button type="button" class="btn btn-xs btn-primary">' +
                '<i class="fa fa-history"></i>' +
              '</button>' +
            '</a>' +
          '</div>'
      });
    }

    $scope.getCurrentUserOperator = function() {
      $scope.currentUserOperator = undefined;
      var currentUser = authFactory.getAuthData().authId;
      var filters = {};
      filters['model.username'] = {
        type: '_exact',
        key: 'model.username',
        value: currentUser
      };
      return recordFactory('operatore').search({page_size: 1, show_revision: false}, filters).$promise.then(function(data) {
        if(errorService.handleError(data) && data.list && data.list.length > 0) {
          $scope.currentUserOperator = data.list[0];
        } else {
          toaster.pop('error', 'Errore', 'Operatore corrispondente all\'utente \''+ currentUser +'\' non trovato');
        }
        return $scope.currentUserOperator;
      });
    };

    $scope.getCurrentUserOdlList = function() {
      if(!$scope.currentUserOperator || !$scope.currentUserOperator.UUID) {
        $scope.getCurrentUserOperator().then(function(operator) {
          $scope.getOdlList();
        })
      } else {
        $scope.getOdlList();
      }
    };

    $scope.getOdlList = function () {
      var filters = angular.copy($scope.params.filters);
      if($scope.currentUserOperator && $scope.currentUserOperator.UUID && !$scope.bool.allOdl) {
        if(!filters['user']) {
          filters['user'] = sixFiltersLib.exact('user', $scope.currentUserOperator.model.username, sixFiltersLib.CONSTRAINTS.OR);
        }
        filters['headmanCommission_id'] = sixFiltersLib.exact('references_assignee.headmanCommission_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
        filters['technicianCommission_id'] = sixFiltersLib.in('references_assignee.technicianCommission_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
        filters['maintainer_id'] = sixFiltersLib.in('references_assignee.maintainer_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
        filters['supervisorInternal_id'] = sixFiltersLib.exact('references_assignee.supervisorInternal_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
        filters['supervisorExternal_id'] = sixFiltersLib.exact('references_assignee.supervisorExternal_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
      }

      if($scope.bool.hidePlan) {
        filters['generated_by'] = sixFiltersLib.not('generated_by', 'plan');
      } else {
        delete filters['generated_by'];
      }

      var payload = {
        page: $scope.params.pageNumber,
        page_size: $scope.params.pageSize,
        show_revision: false,
        commission: currentCommission.code
      };

      odlFactory().search(payload, filters).$promise.then(function(data) {
          $scope.odlList.totalResults = data.totalResults;
          $scope.odlList.list = data.list;
      });
    };

    $scope.validate = function () {
      if($scope.data.generated_by == 'issue'){
        var form = document.forms['detailForm'];
        if (form) {
          $scope.$broadcast('schemaFormValidate');
          setTimeout(function () {
            var invElements = angular.element(form.getElementsByClassName("ng-invalid"));
            if (invElements.length > 0) {
              toaster.pop('error', 'Errore', 'Dati obbligatori mancanti.');
            }
            else {
              $scope.update();
            }
          }, 500);
        }
      } else if ($scope.data.generated_by == 'plan') {
        // per ora non faccio nessun controllo sugli odl che arrivano dalla PIANIFICATA...
      }
    };

    $scope.update = function () {
      if(!$scope.data.version){ /* se è nuovo */
        if($scope.data.model.record_id && $scope.data.model.type_id){
          counterFactory.next({code: $scope.counterNameOdl}).$promise.then(function (response) {
            if (response.errors){
              $scope.errorsRetrievingCounter(response.errors);
              return;
            }
            $scope.data.model.code = response.next;
            if(!$scope.data.model.description){
              $scope.data.model.description = $scope.data.model.code+' - '+$scope.data.model.type_id.description+ ' - '+$scope.data.model.record_id.description;
            }
            writeAttachments($scope.data.model.attachments);
            odlFactory().createOdl({commissionDependent: $scope.commissionDependent}, $scope.data).$promise.then(function (response) {
              // $scope.goToOdlList();
              $location.path('odl/'+response.UUID);
            });
          });
        } else{
          toaster.pop('error', 'Errore Inserimento', 'Non sono stati riempiti tutti i campi necessari: TIPO, ASSET');
        }
      } else{ /* se è già versionato */
        if(angular.isDefined($scope.data.model.attachments)){
          writeAttachments($scope.data.model.attachments);
        }
        odlFactory().updateOdl({id: $scope.data.version}, $scope.data).$promise.then(function (resp) {
          $scope.data.version = resp.version;
          toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
        });
      }
    };

    $scope.updAttachments = function(){
      writeAttachments($scope.data.model.attachments);
      if($scope.isNew){
        odlFactory().createOdl({commissionDependent: $scope.commissionDependent}, $scope.data).$promise.then(function () {
          $log.info('saving: '+$scope.version);
        });
      } else{
        odlFactory().updateOdl({id: $scope.data.version}, $scope.data).$promise.then(function (resp) {
          $scope.data.version = resp.version;
          $log.info('updating id: '+$scope.data.version);
        });
      }
    };

    $scope.delete = function (idToDelete) {
      dialogService.confirmDialog('Eliminare l\'ODL?',
        function () {
          $log.info('deleting id:' + idToDelete);
          if (($scope.data.generated_by == 'plan') && (angular.isDefined($scope.data.model.parent_record_id))) {
            odlFactory().deletePlanOdl({id: idToDelete}).$promise.then(function () {
              $scope.getOdlList();
              $location.path('/odl', false);
            });
          }
          else {
            odlFactory().deleteIssueOdl({id: idToDelete}).$promise.then(function () {
              $scope.getOdlList();
              $location.path('/odl', false);
            });
          }
        }
      );
    };

    $scope.getOdlById = function (itemUUID) {
      if(itemUUID == 'new'){
        $scope.isNew = true;
        $scope.getSchemaOdl();
        counterFactory.current({code: $scope.counterNameOdl}).$promise.then(function (response) {
          if (response.errors){
            $scope.errorsRetrievingCounter(response.errors);
            $window.history.back();
            return;
          }
          $scope.data.model.code = (parseInt(response.current)+1).toString();
        });
      } else{
        $scope.isNew = false;
        odlFactory().getOdlByUUID({uuid: itemUUID}).$promise.then(function (response) {
          if(response){
            $scope.data = response;
            if(!$scope.data.references_assignee) {  // se non c'è lo inizializzo per evitare che le lookup vadano in errore
              $scope.data.references_assignee = {
                supplier_id: undefined,
                company_id: undefined,
                headmanCommission_id: undefined,
                technicianCommission_id: [],
                maintainer_id: [],
                supervisorExternal_id: undefined,
                supervisorInternal_id: undefined
              };
            }

            /* ho cambiato la posizione per ottenere lo schema dell'odl altrimenti non si riusciva ad inizializzare la lookup */
            $scope.getSchemaOdl();

            $scope.currentOdlRef = sixObjectLib.recordToHisRef($scope.data);
            /** TO FIX: vedere come risolvere la gestione delle date */
            if($scope.data.date_requested){ $scope.data.date_requested = new Date($scope.data.date_requested);}
            if($scope.data.date_insertion){ $scope.data.date_insertion = new Date($scope.data.date_insertion);}
            if($scope.data.date_handling){ $scope.data.date_handling = new Date($scope.data.date_handling);}
            if($scope.data.date_closing){ $scope.data.date_closing = new Date($scope.data.date_closing);}
            if($scope.data.dataIn){ $scope.data.dataIn = new Date($scope.data.dataIn);}
            $scope.getNotificationsList();

            if(angular.isUndefined($scope.data.model.attachments)){
              $scope.data.model.attachments = [];
            }
            readAttachments($scope.data.model.attachments);
          }
        });
      }
    };

    $scope.getSchemaOdl = function(){
      odlFactory().getOdlSchema().$promise.then(function (data) {
        if(data.model){
          $scope.schemaOdlDefined = true;
          $scope.configCurrentSchema = angular.copy(data);
          $scope.schema = data.model.schema;
          $scope.form = data.model.form;
          $scope.columnDefs = data.model.columnDefs;
          $scope.model = {};
        } else{
          $scope.schemaOdlDefined = false;
          toaster.pop('error', 'Errore caricamento pagina', 'Nessun modello salvato per il tipo \'odl\'.');
        }
      });
    };

    $scope.massiveClosingOdl = function() {
      var odlList = $scope.params.gridApi.selection.getSelectedRows();
      if(odlList && odlList.length > 0) {
        var dateClosingDialog = ngDialog.openConfirm({
          name: 'dateClosingDialog',
          closeByDocument: false,
          showClose: true,
          template: '' +
          '<div style="text-align:center"><i class="fa fa fa-calendar"></i> Inserire la data di chiusura</div><br>' +
          '<div style="text-align:left">' +
            ' da calendario:' +
            '<input class="form-control" id="input_dialog_date" type="date" ng-model="date">' +
          '</div>' +
          '<div style="text-align:left">' +
            ' o da num. giorni lavorativi:' +
            '<input class="form-control" id="input_dialog_days" type="number" ng-model="days">' +
          '</div>' +
          '<div style="text-align:center">' +
            '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm()">OK</button>' +
          '</div>',
          plain: true,
          className: 'ngdialog-theme-default ngdialog-theme-custom'
        });

        dateClosingDialog.then(
          function () { // success
            var type = '';
            var value = null;
            if (document.getElementById("input_dialog_date").value) {
              value = document.getElementById("input_dialog_date").value;
              type = 'date';
            }
            if (document.getElementById("input_dialog_days").value) {
              value = document.getElementById("input_dialog_days").value;
              type = 'days';
            }
            var daysVar = null;
            var dateVar = null;
            if (type == 'days') {
              daysVar = parseInt(value);
            }
            if (type == 'date') {
              dateVar = new Date(value);
            }
            var payload = {
              odlList: odlList,
              typeClosingOdl: type,
              daysClosingValue: daysVar,
              dateClosingValue: dateVar
            };
            odlFactory().bulkClose(payload).$promise.then(function (data) {
              if (errorService.handleError(data)) {
                if (data.hasErrors || data.hasWarnings) {
                  dialogService.serviceResponse('Esito', data, false);
                }
              }
              $scope.getOdlList();
            });
          },
          function (resp) {}   // reject
        );
      } else {
        toaster.pop('warning', 'Nessuna selezione', 'Nessun ODL selezionato');
      }
    };


    function setBodyText(notification){
        var model = notification.model;
        if(angular.isDefined(model)){
            var bodyHtml = model.body;
            if(angular.isDefined(bodyHtml)){
                bodyHtml = "<div>" + bodyHtml + "</div>";
                var bodyText = $(bodyHtml).text();
                model.bodyAsText = bodyText;
            }
        }
    }

    $scope.getNotificationsList = function() {
        var payload = {
          page: 1,
          pageSize: 10000,
          UUID: $scope.data.UUID,
          //index: 'six_odl',
          typeNotification: 'odl',
          list: null
        };
        notificationFactory().getListFiltered(payload).$promise.then(function(data) {
          $scope.notifications = data.list;
          if($scope.notifications) {
            for (var i = 0; i < $scope.notifications.length; i++) {
              var notification = $scope.notifications[i];
              setBodyText(notification);
              notification.color = 'b-l-warning';
              notification.href = "#/notification/" + notification.version;
            }
          }
        });
    };

    $scope.showAssetsList = function(){
        if(angular.isUndefined($scope.assetsList)){
            var payload = {
                page: 1,
                pageSize: 10000,
                code: $scope.data.model.code,
                sortFields: "model.record_id.description",
                sortDirections: "asc",
                id: $scope.data.model.code
            };
            odlFactory().getAssetsList(payload)
                .$promise.then(function(data) {
                    $scope.assetsList = data.list;
            });
        }
    };


    /* $watch per popolare i campi dipendenti dalla segnalazione */
    $scope.$watch(function() { return $scope.data.issue_id }, function(newVal, oldVal) {
      $scope.issue = undefined;
      if(angular.isDefined(newVal) && newVal != null) {
        issueFactory("issue/record/_uuid/" + $scope.data.issue_id.UUID).getUUID().$promise.then(function (response) {
          if(angular.isDefined(response.model)){
            $scope.issue = response;
            $scope.issueRefreshed.bool = true;
            if($scope.issue.date_requested){ $scope.issue.date_requested = new Date($scope.issue.date_requested);}
            if($scope.issue.date_insertion){ $scope.issue.date_insertion = new Date($scope.issue.date_insertion);}
            if($scope.issue.date_handling){ $scope.issue.date_handling = new Date($scope.issue.date_handling);}
            if($scope.issue.date_closing){ $scope.issue.date_closing = new Date($scope.issue.date_closing);}
            if($scope.issue.date_handling != null){
              $scope.data.date_insertion = $scope.issue.date_handling;
            }
            $scope.data.model.type_id = $scope.issue.model.type_id;
            $scope.data.model.record_id = $scope.issue.model.record_id;
            $scope.data.model.service_id = $scope.issue.model.service_id;
            $scope.data.model.priority_id = $scope.issue.model.priority_id;
            $scope.data.model.activity_id = $scope.issue.model.activity_id;
            $scope.data.model.odltype_id = $scope.issue.model.issuetype_id;
            $scope.data.model.description = $scope.issue.model.note;
            /* imposto anche la descrizione dell'ordine di lavoro */
            if(!$scope.data.model.description || $scope.data.model.description == '') {
              $scope.data.model.description =
                $scope.data.model.code + ' - ' +
                $scope.data.model.type_id.description + ' - ' +
                $scope.data.model.record_id.description;
            }
          }
        });
      }
    });

    $scope.$watch('issueRefreshed.bool' , function (newVal, oldVal) {
      if(newVal != oldVal) {
        if(newVal == true) {
          odlFactory().getIssueNotAssigned().$promise.then(function(data) {
            if (errorService.handleError(data)) {
              if (data.hasErrors || data.hasWarnings) {
                dialogService.serviceResponse('Esito', data, false);
              }
            }
            if(data.result){
              if(data.result.length > 0) {
                delete $scope.issueRefreshed.filter;
                var filterStr = '';
                angular.forEach(data.result, function(value) {
                  if(value.UUID){
                    if(filterStr == ''){
                      filterStr = value.UUID;
                    } else {
                      filterStr = filterStr + ', ' + value.UUID;
                    }
                  }
                });
                $scope.issueRefreshed.filter = {'UUID' : filterStr}
              }
            }
          });
        } else {
          $scope.issueRefreshed.filter = {};
        }
      }
    });

    $scope.$watch('data.model.type_id', function (newVal, oldVal) {
      if(newVal != oldVal && $scope.issueRefreshed.bool == false && $scope.init !== true){
        $scope.data.model.record_id = null;
      }
      if(newVal) {
        $scope.init = false;  // prima inizializzazione eseguita
      }
      $scope.issueRefreshed.bool = false;
    });

    $scope.getConfiguration = function () {
      if($scope.data.model.type_id && $scope.data.model.record_id && $scope.data.model.service_id) {
        var payload = {
          type_id: $scope.data.model.type_id,
          record_id: $scope.data.model.record_id,
          service_id: $scope.data.model.service_id,
          response: {}
        };
        treePlanConfigFactory.getCompleteConfiguration(payload).$promise.then(function (data) {
          if (data.response != null) {
            toaster.pop('success', 'Successo', 'Caricamento configurazione associata effettuato');
            $scope.configurationOdl = data.response;

            if($scope.configurationOdl.responsable && $scope.configurationOdl.responsable.length > 0) {
              $scope.responsableList = $scope.configurationOdl.responsable;
            }
            else {
              $scope.responsableList = [];
            }
            if($scope.configurationOdl.company.default.company_id) {
              $scope.data.references_assignee.company_id = $scope.configurationOdl.company.default.company_id;
            }
            if($scope.configurationOdl.company.filtered && $scope.configurationOdl.company.filtered.length > 0) {
              $scope.companyFilter = getFilter($scope.companyFilter, $scope.configurationOdl.company.filtered);
            }
            if($scope.configurationOdl.supplier.default.supplier_id) {
              $scope.data.references_assignee.supplier_id = $scope.configurationOdl.supplier.default.supplier_id;
            }
            if($scope.configurationOdl.supplier.filtered && $scope.configurationOdl.supplier.filtered.length > 0) {
              $scope.supplierFilter = getFilter($scope.supplierFilter, $scope.configurationOdl.supplier.filtered);
            }
            if($scope.configurationOdl.headmanCommission.default.operator_id) {
              $scope.data.references_assignee.headmanCommission_id = $scope.configurationOdl.headmanCommission.default.operator_id;
            }
            if($scope.configurationOdl.headmanCommission.filtered && $scope.configurationOdl.headmanCommission.filtered.length > 0) {
              $scope.headmanCommissionFilter = getFilter($scope.headmanCommissionFilter, $scope.configurationOdl.headmanCommission.filtered);
            }
            if($scope.configurationOdl.supervisorExternal.default.operator_id) {
              $scope.data.references_assignee.supervisorExternal_id = $scope.configurationOdl.supervisorExternal.default.operator_id;
            }
            if($scope.configurationOdl.supervisorExternal.filtered && $scope.configurationOdl.supervisorExternal.filtered.length > 0) {
              $scope.supervisorExternalFilter = getFilter($scope.supervisorExternalFilter, $scope.configurationOdl.supervisorExternal.filtered);
            }
            if($scope.configurationOdl.supervisorInternal.default.operator_id) {
              $scope.data.references_assignee.supervisorInternal_id = $scope.configurationOdl.supervisorInternal.default.operator_id;
            }
            if($scope.configurationOdl.supervisorInternal.filtered && $scope.configurationOdl.supervisorInternal.filtered.length > 0) {
              $scope.supervisorInternalFilter = getFilter($scope.supervisorInternalFilter, $scope.configurationOdl.supervisorInternal.filtered);
            }
            if($scope.configurationOdl.technicianCommission.default.operator_id.length > 0){
              $scope.data.references_assignee.technicianCommission_id = $scope.configurationOdl.technicianCommission.default.operator_id;
            }
            if($scope.configurationOdl.technicianCommission.filtered && $scope.configurationOdl.technicianCommission.filtered.length > 0) {
              $scope.technicianCommissionFilter = getFilter($scope.technicianCommissionFilter, $scope.configurationOdl.technicianCommission.filtered);
            }
            if($scope.configurationOdl.maintainer.default.operator_id.length > 0){
              $scope.data.references_assignee.maintainer_id = $scope.configurationOdl.maintainer.default.operator_id;
            }
            if($scope.configurationOdl.maintainer.filtered && $scope.configurationOdl.maintainer.filtered.length > 0) {
              $scope.maintainerFilter = getFilter($scope.maintainerFilter, $scope.configurationOdl.maintainer.filtered);
            }
          }
        });
      } else {
        toaster.pop('error', 'Errore', 'Controllare i valori tipo asset, asset e servizio');
      }
    };

    $scope.toggleHidePlan = function() {
      $scope.bool.hidePlan = !$scope.bool.hidePlan;
      localStorageService.set('odl_bool', $scope.bool);
      $scope.refresh();
    };

    $scope.toggleAllOdl = function() {
      $scope.bool.allOdl = !$scope.bool.allOdl;
      localStorageService.set('odl_bool', $scope.bool);
      $scope.refresh();
    };

    if($routeParams.id) {
      $scope.issue = issueToOdl.pop();
      if(angular.isDefined($scope.issue)) {
        $scope.data.issue_id = sixObjectLib.recordToHisRef($scope.issue);
      }
      $scope.getOdlById($routeParams.id);
    } else {
      // $scope.getOdlList();
      $scope.getColumns();
    }



    /******** gestione timeline **************/

    $scope.modelDataInTimeline = {};
    $scope.schemaDataInTimeline = {};
    $scope.formDataInTimeline = {};
    $scope.timeline = [];
    $scope.entity = 'odl/record';

    $scope.getTimeline = function () {
      if (angular.isDefined($scope.entity) && angular.isDefined($scope.data.UUID)) {
        $scope.buildTimeline($scope.entity, $scope.data.UUID);
      }
    };

    $scope.buildTimeline = function (entity, UUID, version) {
      $scope.entity = entity;
      $scope.timeline = odlFactory().getTimeline({id: UUID}).$promise.then(function (data) {
        $scope.timeline = data.list;
        if (angular.isDefined(version)) {
          $scope.modelDataInTimeline['version'] = version;
        }
      });
    };

    $scope.getModelDetail = function (version) {
      odlFactory().getOdlById({id: version}).$promise.then(function (data) {
        $scope.currentDataInTimeline = data;
        $scope.modelDataInTimeline.version = data.version;
        if(angular.isUndefined(data.dataOut) || data.dataOut==null){
          data.dataOut = "_current";
        }
        console.log('type -> schema, UUID -> '+$scope.configCurrentSchema.UUID);
        odlFactory().getSchemaInTimeline({id: $scope.configCurrentSchema.UUID, param1: data.dataOut}).$promise.then(function (response) {
          if(response.model){
            $scope.showDetail = true;
            $scope.schemaDataInTimeline = response.model.schema;
            $scope.formDataInTimeline = response.model.form;
          }
        });
      });
    };



    /******** funzioni di utility ***********/

    $scope.getMessage = function () {   /* creazione testo mail */
      var searchInit = {
         search: {  obj: {'username':authFactory.getAuthData().authId}  },
         init: { authId: true,  email: true }
      };
      if(angular.isDefined($scope.data.model.type_id) && angular.isDefined($scope.data.model.record_id)){
        var promiseMailReceiver = notificationFactory().getMailReceiver($scope.data).$promise;
        var promiseMailUser = userFactory.getMail(searchInit).$promise;
        $scope.loadingSixMail = true;

        Promise.all([promiseMailReceiver, promiseMailUser]).then(function (response) {  // response[0] = promiseMailReceiver, response[1] = promiseMailUser
          $scope.loadingSixMail = false;
          $scope.objMail = {
            title: 'Apertura ordine di lavoro su asset: (tipo) ' + $scope.data.model.type_id.description + ' - (elemento) ' + $scope.data.model.record_id.description,
            to: formatMailReceiver(response[0]),
            cc: formatMailCc(response[1].list[0].email),
            message: 'Apertura ordine di lavoro su asset: ' + $scope.data.model.type_id.description + ' - ' + $scope.data.model.record_id.description +'\n' +
            'Codice: ' + getText($scope.data.model, 'code') + '\n' +
            '\n' +
            'Dati tipo elem. tecnologico: (cod.) '+ getText($scope.data.model.type_id, 'code') + ' - (descr.) ' + getText($scope.data.model.type_id, 'description') + '\n' +
            'Dati elem. tecnologico: (cod.) '+ getText($scope.data.model.record_id, 'code') + ' - (descr.) ' + getText($scope.data.model.record_id, 'description') + '\n' +
            'Descrizione: ' + getText($scope.data.model, 'description') + '\n' +
            'Servizio da eseguire: ' + getText($scope.data.model.service_id, 'description') + '\n' +
            'Compito: ' + getText($scope.data.model.task_id, 'description') + '\n' +
            'Priorità: ' + getText($scope.data.model.priority_id, 'description') + '\n' +
            'Note aggiuntive: ' + getText($scope.data.model, 'note') + '\n'
          }
        });
      } else {
        toaster.pop('error', 'Errore', 'Creazione della mail precompilata non riuscita.');
      }
    };

    function pad(value, char, length) {
      return (value.toString().length < length) ? pad(char+value, char, length):value;
    }

    $scope.setBoolWatchInternal = function (){
      $scope.bool_watch_internal = true;
      $scope.bool_watch_external = false;
    };

    $scope.setBoolWatchExternal = function (){
      $scope.bool_watch_internal = false;
      $scope.bool_watch_external = true;
    };

    $scope.addWatcher = function () {
      if($scope.bool_watch_internal){ /* se è interno */
        if($scope.watcher.user != null && include($scope.data.watchers.internal, $scope.watcher.user) == false){
          $scope.data.watchers.internal.push($scope.watcher.user);
        }
        $scope.watcher.user = null;
      } else if ($scope.bool_watch_external){ /* se è esterno */
        if($scope.watcher.mail != null){
          $scope.data.watchers.external.push($scope.watcher.mail);
        }
        $scope.watcher.mail = null;
      }
    };

    $scope.addWatcherFromLookUp = function (lookUp) {
      if(angular.isDefined(lookUp) && lookUp != null){
        if(angular.isArray(lookUp)) {
          for(var i = 0; i < lookUp.length; i++){
            copyInWatchers(lookUp[i]);
          }
        } else {
          copyInWatchers(lookUp);
        }
      }
    };

    $scope.addAllTechnicianCommissionFromLookUp = function (lookup) {
      for(var i = 0; i < $scope.data.references_assignee.technicianCommission_id.length; i++){
        copyInWatchers($scope.data.references_assignee.technicianCommission_id[i]);
      }
    };

    $scope.deleteWatcher = function (array, toDelete){
      var index = array.indexOf(toDelete);
      if (index > -1) {
        array.splice(index, 1);
      }
    };

    function include(arr,obj) {
      var bool = false;
      for(var i = 0; i < arr.length; i++){
        if(obj.code == arr[i].code){
          bool = true;
        }
      }
      return bool;
    }

    function copyInWatchers(obj){
      var bool = false;
      for(var i = 0; i < $scope.data.watchers.internal.length; i++){
        if(obj.code == $scope.data.watchers.internal[i].code){
          bool = true;
          toaster.pop('warning', 'Già presente', 'Watcher già presente');
        }
      }
      if(bool == false){
        $scope.data.watchers.internal.push(obj);
      }
    }

    function formattedLookUpOperator(obj) {
      var objRef = {
        type: 'operatore',
        code: obj.model.code,
        description: obj.model.description,
        UUID: obj.UUID
      };
      return objRef;
    }

    function getFilter(filter, array){
      var filterRet;
      if(!filter){
        filterRet = {};
      } else {
        filterRet = filter;
      }
      var string = '';
      array.forEach(function (item, index) {
        if(index == 0){
          string = item.UUID;
        } else {
          string = string +','+ item.UUID;
        }
        filterRet['UUID'] = string;
      });
      return filterRet;
    }

    function getText(ref, element){
      if(angular.isDefined(ref) && ref != null){
        if(angular.isDefined(ref[element]) && ref[element] != null){
          return ref[element];
        }
      }
      return '';
    }

    function formatMailReceiver (array) { /* from array to formatted string with comma */
      if(angular.isDefined(array.result)){
        if(array.result.length != 0){
          var strConcat = '';
          for(var i = 0; i < array.result.length; i++){
            if(i == 0){
              strConcat = array.result[i];
            } else {
              strConcat = strConcat + ', ' + array.result[i];
            }
          }
          return strConcat;
        } else {
          return '';
        }
      } else {
        return '';
      }
    }

    function formatMailCc (UserMailSix) {
      if(UserMailSix){
         return UserMailSix;
      } else {
        return null;
      }
    }

    $scope.getType = function(modelItem) {
      if(modelItem.type == 'datepicker'){
        return 'date';
      }
      else{
        return modelItem.type;
      }
    };


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'odl';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:OdlconfiguratorCtrl
 * @description
 * # OdlconfiguratorCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/odlconfigurator', {
        templateUrl: 'plan/odl/odlconfigurator_list.html',
        controller: 'OdlconfiguratorCtrl'
      })
      .when('/odlconfigurator/page/:number', {
        templateUrl: 'plan/odl/odlconfigurator_list.html',
        controller: 'OdlconfiguratorCtrl'
      })
      .when('/odlconfigurator/:id', {
        templateUrl: 'plan/odl/odlconfigurator_detail.html',
        controller: 'OdlconfiguratorCtrl'
      })
  })
  .controller('OdlconfiguratorCtrl', function ($scope, $routeParams, $location, $log, $window, odlFactory,
                                               schemaFactory, commissionFactory, toaster, authFactory, dialogService) {

    var PATH_ODL_CONFIG = 'odlconfigurator';

    $scope.bool = { /* contenitore per le variabili booleane */
      isNew: false,
      isCross: false,
      confModel: false
    };

    $scope.commissionDependent = true;

    $scope.commissionCode = '';

    $scope.commissions = [];

    $scope.commissionsSelected = {codes: []};

    $scope.selected = {}; /* contenitore */

    $scope.form = {};

    $scope.model = {};

    $scope.schema = {};

    $scope.property = {};

    $scope.checked = {};

    $scope.uiselectMap = {};

    $scope.itemTypeMap =  {};

    $scope.pageSize = 10;

    $scope.status = {
      isFirstOpen: true,
      isFirstDisabled: false
    };

    $scope.modeltypeList = schemaFactory().lookupList({page_size: 1000});

    $scope.addProperty = function() {
      /* aggiungo una proprietà allo Schema e al Form */
      if(angular.isDefined($scope.property.key)) {
        var p = {
          title: angular.copy($scope.property.title),
          type: angular.copy($scope.property.type),
          check: false
        };
        if($scope.property.format){
          p.format = angular.copy($scope.property.format);
        }
        if(p.type == 'date'){
          p.type = 'string';
          p.format = 'date';
        }
        if(p.type == 'array'){
          p.items = {type: angular.copy($scope.property.items_type)}; // default
          if($scope.property.items_type === 'date') { // se è una data è diverso...
            p.items = {type: 'string', format: 'date'};
          }
        }
        $scope.selected.model.schema.properties[$scope.property.key] = p;
        var item = {
          title: angular.copy($scope.property.title),
          type: null,
          key: [angular.copy($scope.property.key)]
        };
        if(p.format){
          if (p.format == 'date'){
            item.type = 'datepicker';
          } else if (p.format == 'enum'){
            item.type = 'uiselect';
            item.titleMap = [];
          } else if (p.format == 'lookup'){
            item.type = 'sixlookup';
          }
        } else if(p.type == 'string'){
          item.type = 'text';
        } else if(p.type == 'number' || p.type == 'integer'){
          item.type = 'number';
        } else if(p.type == 'boolean'){
          item.type = 'checkbox';
        } else if(p.type == 'array') {
          item.type = 'uiselectmultiple';
          item.titleMap = [];
        } else {  // default
          item.type = angular.copy(p.type);
        }
        for(var i in $scope.selected.model.form[0].items) {
          if($scope.selected.model.form[0].items[i].tabs) {
            $scope.selected.model.form[0].items[i].tabs[0].items.push(item);
          }
        }
      }
      $scope.getUiselectMap();
      $scope.clearNewCol();
      $scope.updateScope();
    };

    $scope.updateScope = function() {
      $scope.schema = angular.fromJson(angular.copy($scope.selected.model.schema));
      $scope.form = [angular.fromJson(angular.copy($scope.selected.model.form[0]))];
      $scope.columnDefs = angular.fromJson(angular.copy($scope.selected.model.columnDefs));
      $scope.formChanged();
    };


    $scope.clearNewCol = function(){
      /* pulisco la riga di inserimento di nuove proprietà */
      $scope.property.key = '';
      $scope.property.title = '';
      delete $scope.property.type;
      delete $scope.property.format;
    };

    $scope.getItemType = function(key){
      if(valueSchema.type != 'array'){
        return valueSchema.type;
      } else {
        return valueSchema.items.type;
      }
    };

    $scope.addItemOnArray = function(key, newItem){
      if(newItem != undefined && newItem != null){
        newItem.name = newItem.name.toString();
        if($scope.itemTypeMap[key] == 'integer'){
          if(parseInt(newItem.name)){
            newItem.value = parseInt(newItem.name);
            newItem.name = newItem.value.toString(); /* nel caso ci dovesse essere un cast, torno a sovrascrivere il name */
          } else{
            return;
          }
        } else if($scope.itemTypeMap[key] == 'number'){
          if(parseFloat(newItem.name)){
            newItem.value = parseFloat(newItem.name);
          } else{
            return;
          }
        } else{
          newItem.value = newItem.name.toString().replace(/\s/g, '_').toLowerCase();
        }
        for(var i in $scope.selected.model.form[0].items) {
          if($scope.selected.model.form[0].items[i].tabs) {
            $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
              if(key == item.key[0]){
                item.titleMap.push(newItem);
              }
            });
          }
        }
        this.newItem = null;
        $scope.updateScope();
      }
    };

    $scope.deleteItemOnArray = function(key, obj){
      for(var i in $scope.selected.model.form[0].items) {
        if($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            if(key == item.key[0]){
              for (var j = item.titleMap.length; j--; ) {
                if (item.titleMap[j].value == obj.value) {
                  item.titleMap.splice(j, 1);
                }
              }
            }
          });
        }
      }
      this.newItem = null;
      $scope.updateScope();
    };

    $scope.deleteProperty = function(keyToDelete) {
      delete $scope.selected.model.schema.properties[keyToDelete];
      for (var i = $scope.selected.model.columnDefs.length; i--; ) {
        if ($scope.selected.model.columnDefs[i].field == keyToDelete) $scope.selected.model.columnDefs.splice(i, 1);
      }
      // ...elimino sempre dalla form
      for (var i = $scope.selected.model.form[0].items.length; i--; ) {
        if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == keyToDelete) {
          $scope.selected.model.form[0].items.splice(i, 1);
        }
        // Scorro anche i tabs
        if($scope.selected.model.form[0].items[i].tabs) {
          for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
            for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
              if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == keyToDelete) {
                $scope.selected.model.form[0].items[i].tabs[j].items.splice(k, 1);
              }
            }
          }
        }
      }
      $scope.updateScope();
    };

    $scope.formChanged = function() {
      $scope.aceModel = JSON.stringify(angular.copy($scope.selected), null, '\t');
    };

    $scope.refreshLookup = function(key,entity_id) {
      $scope.chargeAceModel();
      for (var i = $scope.selected.model.form[0].items.length; i--;) {
        if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == key) {
          $scope.selected.model.form[0].items[i].entity_id = angular.copy(entity_id);
        }
        // Scorro anche i tabs
        if($scope.selected.model.form[0].items[i].tabs) {
          for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
            for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
              if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == key) $scope.selected.model.form[0].items[i].tabs[j].items[k].entity_id = angular.copy(entity_id);
            }
          }
        }
      }
      $scope.selected.model.schema.properties[key].entity_id = angular.copy(entity_id);
      $scope.updateScope();
    };

    $scope.refreshBasePath = function(key, basePath){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].basePath = angular.copy(basePath);
      $scope.updateScope();
    };

    $scope.refreshWar = function(key, war){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].war = angular.copy(war);
      $scope.updateScope();
    };

    $scope.refreshFiltered = function(key, filtered){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].filtered = angular.copy(filtered);
      $scope.updateScope();
    };

    $scope.refreshFilterSourceField = function(key, filterSourceField){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].filterSourceField = angular.copy(filterSourceField);
      $scope.updateScope();
    };

    $scope.refreshFilterDestField = function(key, filterDestField){
      $scope.chargeAceModel();
      $scope.selected.model.schema.properties[key].filterDestField = angular.copy(filterDestField);
      $scope.updateScope();
    };

    $scope.refreshTitleForm = function(title) {
      $scope.chargeAceModel();
      $scope.selected.model.form[0].title = angular.copy(title);
      $scope.updateScope();
    };

    $scope.chargeAceModel = function() {
      var defaultData = angular.fromJson(angular.copy($scope.aceModel));
      if(defaultData) {
        $scope.selected = defaultData;
        $scope.schema = angular.fromJson(defaultData.model.schema);
        $scope.form = angular.fromJson(defaultData.model.form);
        $scope.columnDefs = angular.fromJson(defaultData.model.columnDefs);
      }
    };

    $scope.changeColumnDefs = function (key, value) {
      var item = {name: value.title, field: key};
      var map = new Map();
      angular.forEach($scope.selected.model.columnDefs, function (v) {
        map[v.field] = angular.copy(v);
      });
      if(value.check){
        map[item.field] = angular.copy(item);
        if(value.width == '' || value.width == null) {
          delete $scope.selected.model.schema.properties[key].width;
        }
      }
      else{
        delete map[item.field];
        delete $scope.selected.model.schema.properties[key].width;
        $scope.selected.model.schema.properties[key].enableFiltering = false;
        $scope.selected.model.schema.properties[key].enableSorting = false;
      }
      $scope.selected.model.columnDefs=[];
      for(var it in map) {
        var app = {name: map[it].name, field: map[it].field};
        $scope.selected.model.columnDefs.push(app);
      }
      $scope.updateScope();
    };

    $scope.aceLoaded = function() {
      var defaultModel = {
        model: {
          schema: {
            type: "object",
            title: "",
            properties: {
              code: {
                title: "Codice",
                type: "string",
                check: true
              },
              description: {
                title: "Descrizione",
                type: "string",
                check: true
              }
            },
            required: [
              "code",
              "description"
            ]},
          form:[
            {
              type: "fieldset",
              items: [
                {
                  type: "tabs",
                  tabs: [
                    {
                      title: "Odl",
                      items: [
                        {
                          key: ["code"],
                          title: "Codice",
                          required: true,
                          type: "text"
                        },
                        {
                          key: ["description"],
                          title: "Descrizione",
                          required: true,
                          type: "textarea",
                          placeholder: "Testo di descrizione..."
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          columnDefs:[
            {
              "field": "code",
              "name": "Codice"
            },
            {
              "field": "description",
              "name": "Descrizione"
            }
          ]
        }
      };
      $scope.aceModel = JSON.stringify(defaultModel, null, '\t');
      $scope.chargeAceModel();
      $scope.title = angular.copy($scope.selected.model.form[0].title);
    };

    $scope.getUiselectMap = function(){
      $scope.uiselectMap = {};
      $scope.itemTypeMap  = {};
      for(var i in $scope.selected.model.form[0].items) {
        if($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].type;
            if($scope.selected.model.schema.properties[item.key[0]].type == 'array'){
              $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].items.type;
            }
            if(item.type == 'uiselect' || item.type == 'uiselectmultiple'){
              var blankObject = {
                name: '',
                value: ''
              };
              $scope.uiselectMap[item.key[0]] = addSelectedValue(item.titleMap, blankObject); /* aggiunto un elemento vuoto all'array per consentire il deselezionamento */
            }
          });
        }
      }
    };

    function addSelectedValue(array, obj) {
      var blankValuePresent = false;
      array.forEach(function (item) {
        if(item.value == obj.value && item.name == obj.name){
          blankValuePresent = true;
        }
      });
      if(blankValuePresent == false){
        array.push(obj);
      }
      return array;
    }

    $scope.isInheritable = function(type){
      return (type == 'number' || type == 'integer' || type == 'string' || type == 'boolean' || type == 'lookup');
    };


    /**********************/
    /***** FIX SCHEMA *****/
    /**********************/

    $scope.fixSchemaFormModel = function() {
      for(var i in $scope.selected.model.form[0].items) {
        if($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            if(item.type == 'uiselect'){
              $scope.selected.model.schema.properties[item.key[0]].format = 'enum';
            }
            if(item.type == 'uiselectmultiple'){
              $scope.selected.model.schema.properties[item.key[0]].type = 'array';
            }
          });
        }
      }
    };

    /****************/
    /***** FORM *****/
    /****************/

    $scope.newFieldForm = {};
    $scope.newTab = {
      title: "",
      items: []
    };


    $scope.addTab = function(container){
      if(!container.tabs) {
        container.tabs = [];
      }
      if(container.type !== 'tabs') {
        container.type = 'tabs';
      }
      var toAdd = angular.copy($scope.newTab);
      $log.log(container);
      container.tabs.push(toAdd);
      $log.log(container);
      $scope.updateScope();
      $scope.newTab = {
        title: "",
        items: []
      };
    };


    $scope.addFieldToTab = function(tab){
      if(!tab.items) {
        tab.items = [];
      }
      var toAdd = angular.copy($scope.newFieldForm);
      if($scope.newFieldForm.type === '' || $scope.newFieldForm.type === 'formula' || $scope.newFieldForm.type === 'inherited') {
        delete toAdd.type;
      }
      /* key è da cambiare in un array */
      toAdd.key = [];
      toAdd.key.push($scope.newFieldForm.key);
      /* se è una lookup, e se ha definito il campo entity_id nello schema, ci attacco anche l'entity_id */
      if(toAdd.type == 'sixlookup' && $scope.schema.properties[$scope.newFieldForm.key]['entity_id']){
        toAdd['entity_id'] = $scope.schema.properties[$scope.newFieldForm.key]['entity_id'];
      }
      tab.items.push(toAdd);
      $log.log(tab);
      $scope.updateScope();
      $scope.newFieldForm = {
        key: [],
        title: "",
        required: false,
        type: "text"
      };
    };


    $scope.removeTabOrField = function(key, container){
      container.splice(key, 1);
      $log.log(container);
      $scope.updateScope();
    };


    $scope.swapUp = function(key, collection) {
      if(key > 0) {
        var tmp = collection[key];
        collection[key] = collection[key-1];
        collection[key-1] = tmp;
      }
      $scope.updateScope();
    };


    $scope.swapDown = function(key, collection) {
      if(key < collection.length-1) {
        var tmp = collection[key];
        collection[key] = collection[key+1];
        collection[key+1] = tmp;
      }
      $scope.updateScope();
    };


    $scope.updateField = function(field) {
      if(field.type === '') {
        delete field.type;
      }
      $scope.updateScope();
    };


    $scope.$watchGroup(['commissionDependent', 'history'], function() {
      if($scope.commissionDependent === true) {
        $scope.history = true;
      }
      if($scope.selected){
        if($scope.selected.model){
          $scope.selected.model.history = $scope.history;
          $scope.selected.model.commissionDependent = $scope.commissionDependent;
          $scope.updateScope();
        }
      }
    });

    $scope.pageChanged = function () {
      $location.path('/odlconfigurator/page/'+$scope.odlConfiguratorList.currentPage, false);
      $scope.odlConfiguratorList = odlFactory().getOdlSchemaList({query: $scope.queryParam, page: $scope.odlConfiguratorList.currentPage});
    };

    $scope.printCommission = function (commission_array) {
      var result = '';
      var pos = 0;
      if(commission_array != null){
        angular.forEach(commission_array, function(value){
          if(pos == 0){
            result = value;
          } else{
            result = value +', '+ result;
          }
          pos++;
        });
      }
      return result;
    };

    $scope.updateCode = function() {
      if($scope.bool.isCross == true){
        $scope.commissionCode = 'default';
        $scope.commissionsSelected.codes = [];
      } else{
        $scope.commissionCode = '';
      }
    };

    $scope.setConfModel = function() {
      $scope.bool.confModel = true;
      $scope.bool.isCross = false;
      delete $scope.selected.version;
      $scope.commissionsSelected.codes = [];
      $scope.commissionCode = '';
    };

    $scope.newOdl = function () {
      $location.path(PATH_ODL_CONFIG + '/new');
    };

    $scope.refresh = function () {
      console.log('refresh');
      $location.path(PATH_ODL_CONFIG);
    };

    $scope.back = function() {
      $location.path(PATH_ODL_CONFIG);
    };

    $scope.delete = function () {
      dialogService.confirmDialog('Eliminare la configurazione?',
        function () {
          odlFactory().deleteOdlSchema({id: $scope.selected.version}).$promise.then(function () {
            $scope.back();
          });
        }
      );
    };

    $scope.setCommissionSelected = function(){
      angular.forEach($scope.selected.model.commission, function( value_cm_string){
        var index = null;
        angular.forEach($scope.commissions, function(value_cm_obj){
          if(value_cm_string == value_cm_obj.code){
            index = $scope.commissions.indexOf(value_cm_obj);
            $scope.commissionsSelected.codes.push(value_cm_obj);
            $scope.commissions.splice(index,1);
          }
        });
      });
    };

    $scope.setBooleanFlag = function (){
      if($scope.selected.model){
        if($scope.selected.model.code == 'default'){
          $scope.bool.isCross = true;
        }
      }
    };

    $scope.getOdlConfigurationById = function (UUID) {
      odlFactory().getOdlSchemaByUUID({id: UUID}).$promise.then(function(response){
        if(response.model){
          $scope.selected = angular.copy(response);
          $scope.commissionCode = $scope.selected.model.code;
          $scope.setCommissionSelected();
          $scope.setBooleanFlag();
          $scope.updateScope();
        }
      });
    };

    $scope.getOdlConfigurationList = function () {
      odlFactory().getOdlSchemaList({query: $scope.queryParam, pageSize: $scope.pageSize}).$promise.then(function(response) {
        $scope.odlConfiguratorList = response;
      });
    };

    $scope.getCommission = function(){
      commissionFactory().getCommissionsList().$promise.then(function (response){
        if(response.list){
          $scope.commissions = response.list;
        }
      });
    };

    $scope.create = function(){
      odlFactory().createOdlSchema($scope.aceModel)
        .$promise.then(function() {
        toaster.pop('success', 'Creazione avvenuta con successo', 'Salvataggio corretto');
        $scope.back();
      });
    };

    $scope.update = function(){
      odlFactory().updateOdlSchema({id: $scope.selected.version}, $scope.aceModel)
        .$promise.then(function() {
        toaster.pop('success', 'Update effettuato con successo', 'Update corretta');
        $scope.back();
      });
    };

    $scope.saveForm = function() {
      $scope.chargeAceModel();
      $scope.selected.model.code = $scope.commissionCode;
      if($scope.bool.isCross){
        /* se è cross non serve riempire il vettore delle commesse */
        $scope.selected.model.commission = null;
        $scope.selected.model.commissionDependent = false;
        $scope.formChanged(); /* aggiorno l'aceModel */
        if($scope.selected.version){
          $scope.update();
        } else {
          $scope.create();
        }
      } else{
        /* riempio il vettore delle commesse */
        $scope.selected.model.commission = [];
        angular.forEach($scope.commissionsSelected.codes, function(obj){
          $scope.selected.model.commission.push(obj.code);
        });
        $scope.formChanged(); /* aggiorno l'aceModel */
        if($scope.bool.confModel){ /* create obbligatoria */
          $scope.create();
        } else{
          if($scope.selected.version){
            $scope.update();
          } else {
            $scope.create();
          }
        }
      }
    };

    if($routeParams.id) {
      if($routeParams.id !== 'new'){
        $scope.bool.isNew = false;
        commissionFactory().getCommissionsList().$promise.then(function (response){
          if(response.list.length){
            $scope.commissions = response.list;
          }
          $scope.getOdlConfigurationById($routeParams.id);
        });
      } else{
        $scope.bool.isNew = true;
        $scope.getCommission();
      }
    } else {
      $scope.getOdlConfigurationList();
    }


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'odl/schema';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:PlanCtrl
 * @description Controller for planned tasks
 * # PlanCtrl
 */
angular.module('emma.plan')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/plan/detail', {
            templateUrl: 'plan/plan/plan_detail.html',
            controller: 'PlanCtrl'
        })
        .when('/plan/detail/:id', {
            templateUrl: 'plan/plan/plan_detail.html',
            controller: 'PlanCtrl'
        })
  })
  .controller('PlanCtrl', function ($scope, $log, $location, dialogService, $routeParams, toaster, $window, $rootScope, loadingBarService,
                                    authFactory, planFactory, cronExpressionFactory, planOdlFactory, recordFactory, schemaFactory) {

    // var ungroupedTargetsList = [];
    var PREFIX = 'def';
    var loadCount = 0;
    var overlay = angular.element(document.getElementsByClassName('list-sidebar-overlay')[0]);
    var centerPage = angular.element(document.getElementsByClassName('center-page')[0]);

    $scope.taskObj = {};
    // Gestione allegati
    function clearAttachments(){
        $scope.attachments = [];
        $scope.hasAttachments = false;
    }
    clearAttachments();
    function readAttachments(modelList){
        $scope.attachments.splice(0,$scope.attachments.length);
        $scope.hasAttachments = ( modelList && (modelList.length>1 || modelList[0].nodes.length>0 ) );
        if( $scope.hasAttachments ){
            for(var i=0; i<modelList.length; i++){
                $scope.attachments.push(modelList[i]);
            }
        }
    }
    function writeAttachments(modelList){
        modelList.splice(0,modelList.length);
        for(var i=0; i<$scope.attachments.length; i++){
            modelList.push($scope.attachments[i]);
        }
    }

    $scope.EVERY = {
        WEEK : 'week_1',
        MONTH: 'month_1',
        MONTHx2 : 'month_2',
        MONTHx3 : 'month_3',
        MONTHx4 : 'month_4',
        MONTHx6 : 'month_6',
        YEAR: 'year_1',
        YEARx2: 'year_2',
        YEARx3: 'year_3',
        YEARx4: 'year_4',
        YEARx5: 'year_5',
        YEARx6: 'year_6'
    };

    $scope.REPETITION = {
        WEEKLY: 'week',
        MONTHLY: 'month',
        ANNUAL: 'year'
    };

    $scope.DAY_OF_MONTH = {
        FIRST: "1",
        MIDDLE: "15"
    };

    $scope.STEP = {
        DESCRIPTION: 1,
        SIMULATION: 2,
        GENERATION: 3
    };

    $scope.DAY_OF_WEEK = {
        MON: 'MON',
        TUE: 'TUE',
        WEN: 'WED',
        THU: 'THU',
        FRI: 'FRI',
        SAT: 'SAT',
        SUN: 'SUN'
    };

    $scope.MONTH_OF_YEAR = {
        JAN: '1',
        FEB: '2',
        MAR: '3',
        APR: '4',
        MAY: '5',
        JUNE: '6',
        JULY: '7',
        AUG: '8',
        SEPT: '9',
        OCT: '10',
        NOV: '11',
        DEC: '12'
    };

    $scope.simulationParams = {
        date_from: new Date(),
        date_to: new Date(),
        expression: ""
    };
    $scope.simulationParams.date_to.setMonth($scope.simulationParams.date_from.getMonth() + 6);

    $scope.step = $scope.STEP.DESCRIPTION;
    $scope.popupTo = { opened: false};
    $scope.popupFrom = { opened: false};
    $scope.planAssetsId = [];
    $scope.planAssets = []; // Panel
    $scope.availableAssets = []; // Sidebar
    $scope.filteredAssets = [];
    $scope.addCheckModel = [];
    $scope.remCheckModel = [];
    $scope.generatedOdl = [];
    $scope.assetFilter = "";
    $scope.description = "";
    $scope.commissionCode = authFactory.getAuthData().info.commissions.current.code;
    $scope.planOptions = {};
    $scope.planOptions.generateOverParent = false;
    $scope.planOptions.specifyAssets = false;
    $scope.planOptions.modelChanged = false;
    $scope.disablePlanOptions = true;
    $scope.frequencyDetail = false;
    $scope.isFreqTipeChanged = false;
    $scope.isSidebarOpened = false;
    $scope.simulationOk = false;
    $scope.isRangeChanged = false;
    $scope.searchFilterObj = {};
    $scope.searchFilterArray = [];

    $scope.ganttOptions = {
        toDate: new Date(),
        fromDate: new Date(),
        viewScale : "week",
        freqLabel: "Mensile"
    };

    $scope.ganttData = [
        {
            name: 'Risultato della simulazione',
            tasks: []
        }
    ];

    $scope.tooltipContent = '{{getFromLabel()}}';

    $scope.dateOptions = {
        formatYear: 'yyyy',
        minDate: new Date()
    };

    $scope.plan = {
        model: {
            frequency: {
                type: $scope.EVERY.MONTH,
                dayOfMonth: $scope.DAY_OF_MONTH.FIRST,
                dayOfWeek: $scope.DAY_OF_WEEK.MON,
                monthOfYear: $scope.MONTH_OF_YEAR.JAN
            },
            custom_activities: [],
            search_filter:{
                json_object: "{}",
                json_array: "[]",
                description: ""
            }
        }
    };

    $scope.openToPicker = function(){
        $scope.popupTo.opened = true;
    };

    $scope.openFromPicker = function(){
        $scope.popupFrom.opened = true;
    };

    $scope.isWeekly = function(){
        var result = false;
        if(angular.isDefined($scope.plan.model.frequency.type)){
            var type = $scope.plan.model.frequency.type;
            result = (type.indexOf($scope.REPETITION.WEEKLY) != -1);
        }
        return result;
    };

    $scope.isMonthly = function(){
        var result = false;
        if(angular.isDefined($scope.plan.model.frequency.type)){
            var type = $scope.plan.model.frequency.type;
            result = (type.indexOf($scope.REPETITION.MONTHLY) != -1);
        }
        return result;
    };

    $scope.isAnnual = function(){
        var result = false;
        if(angular.isDefined($scope.plan.model.frequency.type)){
            var type = $scope.plan.model.frequency.type;
            result = (type.indexOf($scope.REPETITION.ANNUAL) != -1);
        }
        return result;
    };

    $scope.toggleFrequencyDetail = function(){
        $scope.frequencyDetail = !$scope.frequencyDetail;
    };

    $scope.closeFrequencyDetail = function(){
        $scope.frequencyDetail = false;
    };

    function initAddCheckModel(length){
        $scope.addCheckModel = [];
        for(var i=0; i<length; i++){
            $scope.addCheckModel.push(false);
        }
    }

    function initRemCheckModel(length){
        $scope.remCheckModel = [];
        for(var i=0; i<length; i++){
            $scope.remCheckModel.push(false);
        }
    }

    function fullLoaded(){
        var result = true;
        if($scope.plan.version){
            if(loadCount<$scope.loadCountRef){
                loadCount++;
                result = false;
            }
        }
        return result;
    }

    $scope.closeSidebar = function() {
      var sidebar = angular.element(document.getElementById('list-sidebar'));
      sidebar.removeClass('open');
      centerPage.removeClass('center-open');
      $scope.isSidebarOpened = false;
      if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass('open')) {
        overlay.addClass('active');
      } else {
        overlay.removeClass('active');
      }
    };

    $scope.openSidebar = function() {
      var sidebar = angular.element(document.getElementById('list-sidebar'));
      initAddCheckModel();
      sidebar.addClass('open');
      centerPage.addClass('center-open');
      $scope.isSidebarOpened = true;
      if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass('open')) {
        overlay.addClass('active');
      } else {
        overlay.removeClass('active');
      }
    };

    $scope.selectAsset = function(){
        $scope.openSidebar();
        if( ($scope.availableAssets.length==0) || $scope.planOptions.modelChanged){
            $scope.planOptions.modelChanged = false;
            $scope.loadAssets();
        }
        invalidatePlanAssets();
    };

    $scope.confirmSelectAssets = function(){
        $scope.closeSidebar();
        for(var i=0; i<$scope.addCheckModel.length; i++){
            if($scope.addCheckModel[i]){
                var r = $scope.filteredAssets[i];
                if($scope.planAssets.indexOf(r) == -1) {
                    $scope.planAssets.push(r);
                }
            }
        }
        initRemCheckModel($scope.planAssets.length);
    };

    $scope.loadAssets = function() {
        var entity;
        var filter;
        if($scope.planOptions.generateOverParent){
            if(angular.isDefined($scope.plan.model.target_model_type)){
                entity = $scope.plan.model.target_model_type.code;
                filter = {};
            }
            else{
                entity = $scope.plan.model.model_type.code;
                filter = $scope.searchFilterObj;
            }
        }
        else{
            entity = $scope.plan.model.model_type.code;
            filter = $scope.searchFilterObj;
        }
        recordFactory(entity).filter({page_size: 10000},filter).$promise.then(function (data) {
            $scope.availableAssets = data.list;
            initAddCheckModel($scope.availableAssets.length);
        });
    };

    function invalidatePlanAssets(){
        var plan;
        $scope.planAssetsId = [];
        for(var i=0; i<$scope.planAssets.length; i++){
            plan = $scope.planAssets[i];
            $scope.planAssetsId.push(plan.UUID);
        }
    }

    $scope.isDisabledAsset = function(UUID){
        var result;
        if($scope.planAssetsId.indexOf(UUID) == -1) {
            result = false;
        }
        else{
            result = true;
        }
        return result;
    };

    $scope.removeAsset = function(){
        var count = $scope.remCheckModel.length;
        var removed = 0;
        for(var i=0; i<$scope.remCheckModel.length; i++){
            if($scope.remCheckModel[i]){
                $scope.planItems.splice(i-removed, 1);
                removed++;
            }
        }
        count -= removed;
        initRemCheckModel(count);
    };

    $scope.clearSiderbar = function(){
        $scope.closeSidebar();
        $scope.planOptions.modelChanged = true;
    };

    $scope.$watch('plan.model.model_type',
      function(newValue, oldValue) {
          if( (newValue!=oldValue) && fullLoaded() ) {
              $scope.closeSidebar();
              $scope.planOptions.modelChanged = true;
              var disable = true;
              if($scope.loadingFilter){
                $scope.loadingFilter = false;
              }
              else{
                $scope.emptyFilter();
              }
              if(angular.isDefined(newValue) ){
                disable = false;
                $scope.updateSearchTerms();
              }
              if(angular.isDefined($scope.plan.model.target_model_type) || $scope.planAssets.length>0){
                  if($scope.prompt){
                    dialogService.confirmDialog('Modificando la selezione verranno invalidati i dati sottostanti. Continuare?',
                    function () {
                        $scope.plan.model.target_model_type = undefined;
                        $scope.planAssets = [];
                        $scope.planOptions.generateOverParent = false;
                        $scope.planOptions.specifyAssets = false;
                    },
                    function (){
                        $scope.plan.model.model_type = oldValue;
                        $scope.prompt = false;
                    });
                  }
                  else{
                    $scope.prompt = true;
                  }
              }
              else{
                  if(disable){
                    $scope.planOptions.generateOverParent = false;
                    $scope.planOptions.specifyAssets = false;
                    $scope.closeSidebar();
                    $scope.availableAssets = [];
                  }
              }
              $scope.disablePlanOptions =  disable;
          }
      }
    );

    $scope.$watch('plan.model.target_model_type',
      function(newValue, oldValue) {
          if( (newValue!=oldValue) && fullLoaded() ){
              $scope.closeSidebar();
              $scope.planOptions.modelChanged = true;

              if(newValue.UUID==$scope.plan.model.model_type.UUID){
                dialogService.alert('Asset di generazione e aggregazione non possono essere uguali', 4000);
                setTimeout(function() {
                        $scope.plan.model.target_model_type = oldValue;
                    }, 50);
                //$scope.plan.model.target_model_type = oldValue;
              }

              if($scope.planAssets.length>0){
                  if($scope.prompt){
                        dialogService.confirmDialog('Modificando la selezione verranno invalidati i dati sottostanti. Continuare?',
                        function () {
                            $scope.planAssets = [];
                            $scope.planOptions.specifyAssets = false;
                        },
                        function (){
                            $scope.plan.model.target_model_type = oldValue;
                            $scope.prompt = false;
                        });
                  }
                  else{
                      $scope.prompt = true;
                  }
              }

          }
      }
    );

    $scope.checkFreqTypeChanged = function(){
        if($scope.isFreqTipeChanged){
            $scope.isFreqTipeChanged = false;
            // necessario passare attraverso la creazione di una nuova data, altrimenti il modello
            // non si aggiona.
            // ref: https://github.com/angular/angular.js/issues/13001
            // It is because the code doesn't change the date but the content of the date, therefore the input doesn't "see" that the object is changed. You must assign a new date to the model when you change it from the code and everything will run fine.
            var newDate = new Date();
            newDate.setDate($scope.simulationParams.date_from.getDate());
            newDate.setMonth($scope.simulationParams.date_from.getMonth());
            newDate.setFullYear($scope.simulationParams.date_from.getFullYear());
            var N = 12;
            if($scope.isWeekly()){
                newDate.setDate($scope.simulationParams.date_from.getDate() + N*7);
            }
            else if($scope.isMonthly()){
                newDate.setMonth($scope.simulationParams.date_from.getMonth() + N);
            }
            else{
                newDate.setFullYear($scope.simulationParams.date_from.getFullYear() + N);
            }
            $scope.simulationParams.date_to = newDate;
        }
    };

    $scope.$watch('planOptions.generateOverParent',
        function(newValue, oldValue) {
            if( (newValue==false) && (newValue!=oldValue) && (angular.isDefined($scope.plan.model.target_model_type)) && ($scope.planAssets.length>0) ){
                dialogService.confirmDialog('Modificando la selezione verranno invalidati i dati sottostanti. Continuare?',
                function () {
                    $scope.planAssets = [];
                    $scope.planOptions.specifyAssets = false;
                    $scope.planOptions.modelChanged = true;
                }

                ,
                function (){
                    $scope.planOptions.generateOverParent = oldValue;
                    $scope.prompt = false;
                });
            }
        }
    );

    $scope.$watch('plan.model.frequency.type',
      function(newValue, oldValue) {
        if( angular.isDefined(newValue) ){
            $scope.isFreqTipeChanged = true;
        }
      }
    );

    $scope.$watch('taskObj.obj',
      function(newValue, oldValue) {
        if(newValue!=oldValue){
            if(angular.isDefined($scope.taskObj.obj)){
                readAttachments($scope.taskObj.obj.model.attachments);
            }
            else{
                clearAttachments();
            }
            $scope.plan.model.task_activities = [];
            if( angular.isDefined(newValue) ){
                // Compilo la lista delle attività.
                if( angular.isDefined($scope.taskObj.obj.model) && $scope.taskObj.obj.model.activities ){
                    for(var i=0; i<$scope.taskObj.obj.model.activities.length; i++){
                         $scope.plan.model.task_activities.push($scope.taskObj.obj.model.activities[i]);
                    }
                }
            }
        }
      }
    );

    $scope.showSimulationWarning = function(){
        var warning = false;
        if(angular.isDefined($scope.simulationEvents)){
            warning = ($scope.ganttOptions.fromDate != $scope.simulationParams.date_from) || ($scope.ganttOptions.toDate != $scope.simulationParams.date_to);
        }
        return warning;
    };

    function validateForm() {
        var isValid = true;
        if(angular.isUndefined($scope.plan.model.code)){
            toaster.pop('error', 'Errore', 'Codice obbligatorio');
            isValid = false;
        }
        else if(angular.isUndefined($scope.plan.model.description)){
            toaster.pop('error', 'Errore', 'Descrizione obbligatoria');
            isValid = false;
        }
        else if(angular.isUndefined($scope.plan.model.task_id)){
            toaster.pop('error', 'Errore', 'Selezionare un compito');
            isValid = false;
        }
        else if(angular.isUndefined($scope.plan.model.model_type)){
            toaster.pop('error', 'Errore', 'Selezionare il tipo di asset su cui generare la programmata');
            isValid = false;
        }
        else if(angular.isUndefined($scope.plan.model.service_id)){
            toaster.pop('error', 'Errore', 'Selezionare un servizio');
            isValid = false;
        }
        else if(angular.isUndefined($scope.plan.model.priority_id)){
            toaster.pop('error', 'Errore', 'Selezionare una priorità');
            isValid = false;
        }
        // else if(angular.isUndefined($scope.plan.model.user_input_name)){
        //     toaster.pop('error', 'Errore', 'Indicare il nome dell\'utente di inserimento');
        //     isValid = false;
        // }
        // else if(angular.isUndefined($scope.plan.model.user_input_surname)){
        //     toaster.pop('error', 'Errore', 'Indicare il cognome dell\'utente di inserimento');
        //     isValid = false;
        // }
        return isValid;
    }

    function validateSimulation(askForGeneration) {
        var isValid = true;
        if(angular.isUndefined($scope.simulationParams.date_from) || ($scope.simulationParams.date_from==null) ){
            toaster.pop('error', 'Errore', 'Selezionare una data iniziale su cui generare la programmata');
            isValid = false;
        }
        else if(angular.isUndefined($scope.simulationParams.date_to) || ($scope.simulationParams.date_to==null) ){
            toaster.pop('error', 'Errore', 'Selezionare una data finale su cui generare la programmata');
            isValid = false;
        }
        else if($scope.simulationParams.date_to < $scope.simulationParams.date_from){
            toaster.pop('error', 'Errore', 'La data finale non può essere antecedente alla data di partenza');
            isValid = false;
        }
        if(askForGeneration){
            if($scope.simulationEvents.list.length==0){
                toaster.pop('error', 'Errore', 'Nessun evento corrisponde ai criteri di ricerca');
                isValid = false;
            }
            else if($scope.simulationTargets.list.length==0){
                toaster.pop('error', 'Errore', 'Nessun asset corrisponde ai criteri di ricerca');
                isValid = false;
            }
        }
        return isValid;
    }

    $scope.stepBack = function(){
        switch($scope.step){
            case $scope.STEP.DESCRIPTION:
                $location.path('/plan');
                break;
            case $scope.STEP.SIMULATION:
                $scope.step = $scope.STEP.DESCRIPTION;
                break;
            case $scope.STEP.GENERATION:
                $scope.step = $scope.STEP.SIMULATION;
                break;
        }
    };

    $scope.goToSimulation = function(){
        if(validateForm()){
            $scope.simulationOk = false;
            $scope.simulationEvents = undefined;
            $scope.simulationTargets = undefined;
            $scope.checkFreqTypeChanged();
            $scope.step = $scope.STEP.SIMULATION;
            $scope.closeSidebar();
        }
    };

    $scope.goToGeneration = function(){
        if(validateSimulation(true)){
            $scope.saveForm();
            $scope.step = $scope.STEP.GENERATION;
            $scope.generateOdlList();
        }
    };

    $scope.goToPlanOdlList = function(){
        $location.path('/plan/odl/' + $scope.plan.UUID);
    };

    // Eseguo una serie di operazioni preliminari al salvataggio.
    $scope.saveForm = function() {
      if(validateForm()){
        // Tolgo gli spazi dal code
        $scope.plan.model.code = $scope.plan.model.code.replace(/ /g, '_');
        // Recupero la cronExpression aggiornata
        var payload = {
            frequency: $scope.plan.model.frequency.type,
            day_of_month: $scope.plan.model.frequency.dayOfMonth,
            day_of_week: $scope.plan.model.frequency.dayOfWeek,
            month_of_year: $scope.plan.model.frequency.monthOfYear
        };
        cronExpressionFactory.getCronExpression(payload).$promise.then(function (data) {
            $scope.plan.model.frequency.cronExpression = data.result;
            // Voglio generare su un padre?
            if(!$scope.planOptions.generateOverParent){
                $scope.plan.model.target_model_type = undefined;
            }
            // Compilo la lista degli specifici asset
            $scope.plan.model.assets = [];
            if($scope.planOptions.specifyAssets){
                for(var i=0; i<$scope.planAssets.length; i++){
                    var asset =  $scope.planAssets[i];
                    $scope.plan.model.assets.push(asset);
                }
            }
            // Scrivo gli allegati.
            $scope.plan.model.attachments = [];
            writeAttachments($scope.plan.model.attachments);
            // Converto il filtro in stringa, altrimenti elasticsearch si arrabbia per via dei "."
            $scope.plan.model.search_filter.json_object = JSON.stringify($scope.searchFilterObj);
            $scope.plan.model.search_filter.json_array = JSON.stringify($scope.searchFilterArray);
            // Salvo o aggiorno.
            if ($scope.plan.version) {
                $scope.updatePlan();
            }
            else{
                $scope.savePlan();
            }
        });
      }
    };

    function printOnGantt(date, isNew){
        var task = {
            name: '',
            from: date,
            to: date
        };
        if(isNew){
            task.color = $scope.app.color.info;
            $scope.ganttData[0].tasks.push(task);
        }
        else{
            task.color = $scope.app.color.warning;
            $scope.ganttData[1].tasks.push(task);
        }
    }

    $scope.simulate = function(){
        if(validateSimulation(false)){
            // Before simulate, retrieve the cronExpression
            var payload = {
                frequency: $scope.plan.model.frequency.type,
                day_of_month: $scope.plan.model.frequency.dayOfMonth,
                day_of_week: $scope.plan.model.frequency.dayOfWeek,
                month_of_year: $scope.plan.model.frequency.monthOfYear
            };
            cronExpressionFactory.getCronExpression(payload).$promise.then(function (data) {
                $scope.simulationParams.expression = data.result;
                $log.info($scope.simulationParams.expression);
                $scope.isRangeChanged = false;
                // Ready for simulation
                $scope.getSimulationEvents();
                $scope.getSimulationTargets();
            });
        }
    };

    $scope.getSimulationEvents = function(){
        // preparo il gantt
        $scope.ganttData[0].tasks = [];
        if($scope.isWeekly()){
            $scope.ganttOptions.viewScale = "day";
        }
        else if($scope.isMonthly()){
            $scope.ganttOptions.viewScale = "week";
        }
        else{
            $scope.ganttOptions.viewScale = "month";
        }
        var freqSelect = angular.element(document.getElementById('frequencySelect'));

        $scope.ganttOptions.freqLabel = freqSelect.find('option:selected').text();
        $scope.ganttOptions.fromDate = $scope.simulationParams.date_from;
        $scope.ganttOptions.toDate = $scope.simulationParams.date_to;

        // eseguo e stampo la simulazione
        $scope.simulationParams.date_from.setHours(0,0,0,0);
        $scope.simulationParams.date_to.setHours(23,59,59,999);
        $scope.simulationParams.plan_uuid = $scope.plan.UUID;

        var payload = JSON.parse(JSON.stringify($scope.simulationParams));
        payload.date_from = new Date($scope.simulationParams.date_from.getTime());
        payload.date_from.setDate($scope.simulationParams.date_from.getDate()-1);

        cronExpressionFactory.getSimulationEvents(payload).$promise.then(function (data) {
            $scope.simulationEvents = data;
            if(angular.isDefined(data.list)){
                $scope.simulationOk = true;
                for(var i=0; i<data.list.length; i++){
                    printOnGantt(data.list[i],true);
                }
            }
        });

        getOldEvents();
    };

    function getOldEvents(){
        planOdlFactory().getOldEvents($scope.simulationParams).$promise.then(function (data) {
            if(data.list.length>0){
                if($scope.ganttData.length<2){
                    var newRow = {
                        name: 'Vecchi ODL',
                        tasks: []
                    };
                    $scope.ganttData.push(newRow);
                }
                for(var i=0; i<data.list.length; i++){
                    printOnGantt(data.list[i],false);
                }
            }
        });
    }

    $scope.selectAllAddCheck = function(array){
        for(var i=0; i<$scope.addCheckModel.length; i++){
            $scope.addCheckModel[i] = true;
        }
    };

    $scope.unselectAllAddCheck  = function(array){
        for(var i=0; i<$scope.addCheckModel.length; i++){
            $scope.addCheckModel[i] = false;
        }
    };

    $scope.selectAllRemCheck = function(array){
        for(var i=0; i<$scope.remCheckModel.length; i++){
            $scope.remCheckModel[i] = true;
        }
    };

    $scope.unselectAllRemCheck  = function(array){
        for(var i=0; i<$scope.remCheckModel.length; i++){
            $scope.remCheckModel[i] = false;
        }
    };

    $scope.initGenerationTag = function() {
        var now = new Date();
        var yyyy = now.getFullYear();
        var MM = now.getMonth()+1; // getMonth() is zero-based
        var dd  = now.getDate();
        var hh = now.getUTCHours();
        var mm = now.getUTCMinutes();
        var dateString = dd + "/" + MM + "/" + yyyy;
        var timeString = hh + ":" + mm;
        $scope.generationTag = authFactory.getAuthData().authId + " " + dateString + " " + timeString;
    };

    $scope.getSimulationTargets = function(){
        var payload = {
            model_type: $scope.plan.model.model_type.code
        };
        if( $scope.planOptions.generateOverParent && angular.isDefined( $scope.plan.model.target_model_type)){
            payload.target_model_type = $scope.plan.model.target_model_type.code;
        }
        if( $scope.planOptions.specifyAssets && ($scope.planAssets.length>0) ){
            payload.assets = $scope.planAssets;
        }
        if( $scope.searchFilterArray.length>0 ){
            payload.filter = $scope.searchFilterObj;
        }
        loadingBarService.start('Simulazione ODL ...');
        planFactory().getSimulationTargets(payload).$promise.then(function (data) {
            $scope.simulationTargets = data;
            // rimuovo i doppioni
            if( (data.count_grouped>0) && (data.count!=data.count_grouped) ){
                var array = [];
                var prevId = "";
                for(var i=0; i<data.list.length; i++){
                    if(data.list[i].parent_id.UUID==prevId){
                        array.push(i);
                    }
                    prevId = data.list[i].parent_id.UUID;
                }
                var offset = 0;
                for(var i=0; i<array.length; i++){
                    var index = array[i];
                    data.list.splice( index-offset, 1 );
                    offset++;
                }
            }
            loadingBarService.stop();
        });
    };

    $scope.delete = function (version) {
      dialogService.confirmDialog('Eliminare la programmata ' + $scope.plan.model.code + ' - ' + $scope.plan.model.description + '?',
        function () {
          planFactory().deletePlan({id: version}).$promise.then(function () {
            $location.path('/plan');
          });
        }
      );
    };

    $scope.getPlanById = function(id){
        $scope.emptyFilter();
        planFactory().getPlanByUUID({id: id}).$promise.then(function (data) {
            $scope.plan = data;
            $log.info(data);
            // Riconverto da stringa a oggetto.
            var tempObj = $.parseJSON($scope.plan.model.search_filter.json_object);
            for (var key in tempObj) {
                $scope.searchFilterObj[key] = tempObj[key];
            }
            var tempArray = $.parseJSON($scope.plan.model.search_filter.json_array);
            $scope.searchFilterArray.length = 0;
            for (var i=0; i<tempArray.length; i++) {
                $scope.searchFilterArray.push(tempArray[i]);
            }
            $scope.loadingFilter = true;
            // Estrapolo i dati che mi servono per l'interfaccia.
            $scope.loadCountRef = angular.isDefined($scope.plan.model.target_model_type)?1:0;
            $scope.disablePlanOptions = angular.isUndefined(data.model.model_type);
            $scope.planOptions.generateOverParent = angular.isDefined(data.model.target_model_type);
            $scope.planOptions.specifyAssets = angular.isDefined(data.model.assets) && (data.model.assets.length>0);

            for(var i=0; i<data.model.assets.length; i++){
                var asset =  data.model.assets[i];
                $scope.planAssets.push(asset);
            }
            initRemCheckModel($scope.planAssets.length);
        });
    };

    $scope.updatePlan = function(){
        planFactory().updatePlan({id: $scope.plan.model.code}, $scope.plan)
            .$promise.then(function(data) {
              toaster.pop('success', 'Aggiornamento completato', 'Salvataggio eseguito correttamente');
            });
    };

    $scope.savePlan = function(){
        planFactory().savePlan($scope.plan.model)
            .$promise.then(function(data) {
              toaster.pop('success', 'Salvataggio completato', 'Salvataggio eseguito correttamente');
              $location.path('/plan/detail/' + data.UUID);
            });
    };

    $scope.generateOdlList = function(){
        if($scope.plan.model.attachments.length==0){
            var defaultAttachment = {
                "id": 0,
                "title": "Documenti",
                "folder": true,
                "readonly": true,
                "nodes": []
            };
            $scope.plan.model.attachments.push(defaultAttachment);
        }
        var payload = {
            simulation_id: $scope.simulationTargets.simulation_id,
            plan: $scope.plan,
            events: $scope.simulationEvents.list,
            generation_tag: $scope.generationTag
        };
        $log.info(payload);
        $scope.generationDone = false;
        $scope.realOdlCount = 0;
        planFactory().generateOdl(payload)
            .$promise.then(function(data) {
                $scope.affectedAssets = data.children_assets_count;
                $scope.affectedEvents = data.events_count;
                $scope.realOdlCount = data.total_results;
                $scope.generationDone = true;
                $scope.getGeneratedOdlList(data.generation_code);
        });
    };

    $scope.getGeneratedOdlList = function(generationCode){
        var payload = {
                page: 1,
                pageSize: 10000,
                sortFields: "date_requested",
                sortDirections: "asc"
            };
        planOdlFactory(generationCode).getGeneratedOdlList(payload)
            .$promise.then(function(data) {
                $scope.generatedOdl = data.list;
        });
    };

    // Gestione sixSearchTerms
    $scope.sxSearchTerms = {
        id: 'filter-search',
        open: false,
        type_id: undefined,
        type_obj: undefined
    };
    $scope.toggleSearchTerms = function(){
        $rootScope.$broadcast('sixSidebar:open', {id: $scope.sxSearchTerms.id});
    };
    $scope.updateSearchTerms = function(){
        schemaFactory().byCode({id: $scope.plan.model.model_type.code}).$promise.then(function (data) {
            $scope.sxSearchTerms.type_id = $scope.plan.model.model_type;
            $scope.sxSearchTerms.type_obj = data;
        });
    };
    $scope.onFilterChanged = function(){
        $scope.planAssets = [];
        $scope.planOptions.specifyAssets = false;
    };
    $scope.isEmptyFilter = function(){
        return Object.keys( $scope.searchFilterObj).length === 0;
    };
    $scope.emptyFilter = function(){
        for (var key in $scope.searchFilterObj) {
            delete $scope.searchFilterObj[key];
        }
        $scope.plan.model.search_filter.description = '';
    };

    $(document).ready(function() {
      $('.list-sidebar-overlay').on('click', function() {
        $(this).removeClass('active');
        $('#list-sidebar').removeClass('open');
      });
    });

    //___ main ___
    $scope.prompt = true;
    if($routeParams.id) {
        if($routeParams.id != 'new'){
            $scope.prompt = false;
            $scope.initGenerationTag();
            $scope.getPlanById($routeParams.id);
        }
    }


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'plan';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };

});

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:PlanCtrl
 * @description Controller for planned tasks
 * # PlanCtrl
 */
angular.module('emma.plan')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/plan', {
            templateUrl: 'plan/plan/plan_list.html',
            controller: 'PlanListCtrl'
        })
  })
  .controller('PlanListCtrl', function ($scope, $log, $location, planFactory, uiGridConstants, authFactory) {
    $scope.planList = {};
    $scope.params = { queryParam: '', filterQuery: '' };
    $scope.viewGridOptions = {};

    var DEFAULT_SORT_FIELD = 'model.code';
    function defaultSort() {
        return ($scope.sortFields)?$scope.sortFields:DEFAULT_SORT_FIELD;
    }

    var DEFAULT_SORT_ORDER= 'asc';
    function defaultSortOrder() {
        return ($scope.sortOrder)?$scope.sortOrder:DEFAULT_SORT_ORDER;
    }

    var getPage = function() {
      $scope.viewGridOptions.totalItems = $scope.planList.totalResults;
      var firstRow = ($scope.params.pageNumber - 1) * $scope.params.pageSize;
      var lastRow = (firstRow + $scope.params.pageSize);
      $scope.viewGridOptions.data = $scope.viewGridOptions.data.slice(firstRow, lastRow);
    };

    function initGridColumns() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 34,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents" style="text-align: center">' +
            '<a ng-href="#/plan/detail/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' +
              '<span class="fa fa-search"></span>' +
            '</a>' +
          '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice',
        field: 'model.code',
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descrizione',
        field: 'model.description',
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Filtro',
        field: 'model.search_filter.description_short',
        enableFiltering:false,
        cellTemplate:
          '<div class="ui-grid-cell-contents" style="text-align: center" ng-bind-html="row.entity.model.search_filter.description_short"></div>',
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'ODL',
        field: 'odl',
        width: 50,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents" style="text-align: center">' +
            '<a ng-href="#/plan/odl/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' +
              '<span class="fa fa-tasks"></span>' +
            '</a>' +
          '</div>'
      });
    }

    $scope.getData = function () {
        var payload = {
          query: $scope.params.queryParam,
          page: $scope.params.pageNumber,
          page_size: $scope.params.pageSize,
          sort_fields: defaultSort(),
          sort_order: defaultSortOrder(),
          show_revision: false
        };
        planFactory().getPlanListFiltered(payload, $scope.params.filterQuery)
            .$promise.then(function(data) {
                $scope.planList.totalResults = data.totalResults;
                $scope.planList.list = data.list;
                getPage();
        });
    };

    $scope.getPlanList = function () {
      var payload = {
        query: '',
        page: $scope.params.pageNumber,
        page_size: $scope.params.pageSize
      };
      planFactory().getPlansList(payload).$promise.then(function(data) {
            $scope.planList.totalResults = data.totalResults;
            $scope.planList.list = data.list;
            getPage();
      });
    };

    $scope.goToNewPlan= function(){
        $location.path('plan/detail/new');
    };

    $scope.goToGantt = function(){
        $location.path('task/gantt');
    };

    //__main__
    initGridColumns();


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'plan';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:PlanodlCtrl
 * @description
 * # PlanodlCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/plan/odl/:id', {
            templateUrl: 'plan/plan/plan_odl.html',
            controller: 'PlanOdlCtrl'
        })
  })
  .controller('PlanOdlCtrl', function ($scope, uiGridConstants, $log, planOdlFactory, $routeParams, $location, planFactory, authFactory, sixGridPaginationConstants) {
    $scope.planId;

    // Funzioni specifiche per vista paginata ---------------------------------------------
    $scope.odlList = {};
    $scope.params = { queryParam: '', filterQuery: '' };
    $scope.viewGridOptions = {};

    var DEFAULT_SORT_FIELD = 'date_requested';
    function defaultSort() {
        var result = ($scope.sortFields)?$scope.sortFields:DEFAULT_SORT_FIELD;
        return result;
    }

    var DEFAULT_SORT_ORDER= 'asc';
    function defaultSortOrder() {
        var result = ($scope.sortOrder)?$scope.sortOrder:DEFAULT_SORT_ORDER;
        return result;
    }

    var getPage = function() {
      $scope.viewGridOptions.totalItems = $scope.odlList.totalResults;
      var firstRow = ($scope.params.pageNumber - 1) * $scope.params.pageSize;
      var lastRow = (firstRow + $scope.params.pageSize);
      $scope.viewGridOptions.data = $scope.viewGridOptions.data.slice(firstRow, lastRow);
    };

    function initGridColumns() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 34,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents" style="text-align: center">' +
            '<a ng-href="#/odl/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' +
              '<span class="fa fa-search"></span>' +
            '</a>' +
          '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Asset',
        field: 'model.record_id',
        cellTemplate: '<div class="ui-grid-cell ui-grid-cell-contents"><span ng-if="grid.getCellValue(row, col)">{{grid.getCellValue(row, col).code}} - {{grid.getCellValue(row, col).description}}</span></div>',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Titolo',
        field: 'model.title',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Stato',
        field: 'status',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Elemento tecnologico',
        field: 'model.record_type_id.description',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Generato per',
        field: 'model.target_type_id.description',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice generazione',
        field: 'model.generation_tag',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Utente generazione',
        field: 'user',
        enableFiltering:true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data generazione',
        field: 'dataIn',
        type: 'date',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        width: 100,
        enableFiltering:true,
        filters:[
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data pianifica',
        field: 'date_requested',
        type: 'date',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        width: 100,
        enableFiltering:true,
        filters:[
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
    }

    $scope.getData = function () {
        var payload = {
          query: $scope.params.queryParam,
          page: $scope.params.pageNumber,
          page_size: $scope.params.pageSize,
          sort_fields: defaultSort(),
          sort_order: defaultSortOrder(),
          show_revision: false
        };
        $scope.params.filters["plan_id.UUID"] = sixFiltersLib.exact('plan_id.UUID', $scope.planId);
        planOdlFactory().search(payload, $scope.params.filters)
            .$promise.then(function(data) {
                $scope.odlList.totalResults = data.totalResults;
                $scope.odlList.list = data.list;
                getPage();
        });
    };

    $scope.getOdlList = function () {
      var payload = {
            query: '',
            page: $scope.params.pageNumber,
            pageSize: $scope.params.pageSize,
            planId: $scope.planId,
            sortFields: "date_requested",
            sortDirections: "asc"
      };
      planOdlFactory().getPlanOdlList(payload, $scope.params.filters)
        .$promise.then(function(data) {
            $scope.odlList.totalResults = data.totalResults;
            $scope.odlList.list = data.list;
            getPage();
      });
    };

    $scope.getPlanById = function(id){
        planFactory().getPlanByUUID({id: id}).$promise.then(function (data) {
            $scope.plan = data;
            $scope.frequency = getFrequencyDescription(data.model.frequency.type);
        });
    };

    function getFrequencyDescription(type) {
        var description = "";
        switch(type){
            case 'week_1': description = "Settimanale"; break;
            case 'month_1': description = "Mensile"; break;
            case 'month_2': description = "Bimestrale"; break;
            case 'month_3': description = "Trimestrale"; break;
            case 'month_4': description = "Quadrimestrale"; break;
            case 'month_6': description = "Semestrale"; break;
            case 'year_1': description = "Annuale"; break;
            case 'year_2': description = "Biennale"; break;
            case 'year_3': description = "Triennale"; break;
            case 'year_4': description = "Quadriennale"; break;
            case 'year_5': description = "Quinquennale"; break;
            case 'year_6': description = "ogni 6 anni"; break;
        }
        return description;
    }

    // FINE - Funzioni specifiche per vista paginata ---------------------------------------------

    $scope.goToPlan = function(){
        $location.path('plan/detail/' + $scope.planId);
    };

    $scope.goToReplan = function(){
        $location.path('plan/replan/' + $scope.planId);
    };

    $scope.deleteOdlList = function (query) {
      var payload = {
            planId: $scope.planId
        };
      planOdlFactory().deletePlanOdlList(payload)
        .$promise.then(function(data) {
            $location.path('plan');
      });
    };

    //___main___
    if($routeParams.id) {
        $scope.planId = $routeParams.id;
        $scope.getPlanById($scope.planId);
    }
    initGridColumns();


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'plan/odl';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };

  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:PlanReplanCtrl
 * @description
 * # PlanReplanCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/plan/replan/:id', {
            templateUrl: 'plan/plan/plan_replan.html',
            controller: 'PlanReplanCtrl'
        })
  })
  .controller('PlanReplanCtrl', function ($scope, $log, planOdlFactory, $routeParams, $location, planFactory, odlFactory, authFactory) {
    $scope.planId;

    // Funzioni specifiche per vista paginata ---------------------------------------------
    $scope.odlList = {};
    $scope.popup = { opened: false};

    $scope.dateOptions = {
        formatYear: 'yyyy',
        minDate: new Date()
    };

    function getPlanById(id){
        planFactory().getPlanByUUID({id: id}).$promise.then(function (data) {
            $scope.plan = data;
            $scope.frequency = getFrequencyDescription(data.model.frequency.type);
        });
    };

    function getFrequencyDescription(type) {
        var description = "";
        switch(type){
            case 'week_1': description = "Settimanale"; break;
            case 'month_1': description = "Mensile"; break;
            case 'month_2': description = "Bimestrale"; break;
            case 'month_3': description = "Trimestrale"; break;
            case 'month_4': description = "Quadrimestrale"; break;
            case 'month_6': description = "Semestrale"; break;
            case 'year_1': description = "Annuale"; break;
            case 'year_2': description = "Biennale"; break;
            case 'year_3': description = "Triennale"; break;
            case 'year_4': description = "Quadriennale"; break;
            case 'year_5': description = "Quinquennale"; break;
            case 'year_6': description = "ogni 6 anni"; break;
        }
        return description;
    }

    $scope.goToPlan = function(){
        $location.path('plan/detail/' + $scope.planId);
    }

    $scope.checkAllDay = function(dayIndex) {
        var dailyItem = $scope.dayCheckList[dayIndex];
        for(var i=0; i<dailyItem.odlCheckItems.length; i++){
            dailyItem.odlCheckItems[i].isChecked = dailyItem.isChecked;
        }
    }

    $scope.isEditing = function(dayIndex) {
        var isEditing = false;
        var dailyItem = $scope.dayCheckList[dayIndex];
        for(var i=0; i<dailyItem.odlCheckItems.length; i++){
            if(dailyItem.odlCheckItems[i].isChecked){
                isEditing = true;
                break;
            }
        }
        return isEditing;
    }

    $scope.selectDate = function(dayIndex){
        var dailyItem = $scope.dayCheckList[dayIndex];
        for(var i=0; i<dailyItem.odlCheckItems.length; i++){
            if(dailyItem.odlCheckItems[i].isChecked){
                dailyItem.odlCheckItems[i].newDate = dailyItem.newDate;
                dailyItem.odlCheckItems[i].isChecked = false;
                dailyItem.odlCheckItems[i].canUndo = true;
            }
        }
        dailyItem.isChecked = false;
    }

    $scope.undoOdlItem = function(checkItem){
        checkItem.newDate=undefined;
        checkItem.canUndo=false;
    };

    function getPlanning() {
      var payload = {
            query: '',
            page: 1,
            page_size: 10000,
            plan_id: $scope.planId,
            sort_fields: "date_requested",
            sort_order: "asc"
      };
      planOdlFactory().getPlanning(payload)
        .$promise.then(function(data) {
            $scope.planning = data.list;
            $scope.odlCheckList = [];
            $scope.dayCheckList = [];
            var count = 0;
            for(var i=0; i<$scope.planning.length; i++){
                var daily = {
                    isChecked: false,
                    dayIndex: i,
                    odlCheckItems: [],
                    newDate: new Date($scope.planning[i].date_requested),
                    popup: {opened: false}
                };
                var day = $scope.planning[i];
                for(var j=0; j<day.list.length; j++){
                    var item = {
                        isChecked: false,
                        dayIndex: i,
                        innerIndex: j,
                        odlIndex: count,
                        canUndo: false
                    };
                    day.list[j].temp_index = count;
                    $scope.odlCheckList.push(item);
                    daily.odlCheckItems.push(item);
                    count++;
                }
                $scope.dayCheckList.push(daily);
            }
      });
    }

    $scope.save = function() {
        var index = 0;
        var payload = {list: []};
        for(var i=0; i<$scope.planning.length; i++){
            var day = $scope.planning[i];
            for(var j=0; j<day.list.length; j++){
                var checkItem = $scope.odlCheckList[index];
                if(angular.isDefined(checkItem.newDate)){
                    var odl = day.list[checkItem.innerIndex];
                    odl.date_requested = checkItem.newDate;
                    delete day.list[j].temp_index;
                    payload.list.push(odl);
                }
                index++;
            }
        }
        if(payload.list.length>0){
            odlFactory().bulkUpdateOdl(payload).$promise.then(function(data) {
                $location.path('plan/odl/' + $scope.planId);
            });
        }
        else{
            $location.path('plan/odl/' + $scope.planId);
        }
    }

    //___main___
    if($routeParams.id) {
        $scope.planId = $routeParams.id;
        getPlanById($scope.planId);
        getPlanning($scope.planId);
    }


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'plan/odl';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };
  });

'use strict';

/**
 * @ngdoc factory
 * @name sixEmmaApp.issueToOdl
 * @description
 * # issueToOdl
 * Service in the sixEmmaApp.
 */
angular.module('emma.plan')
  .service('issueToOdl', function () {

    var issueToOdl = {
      issueList: []
    };

    issueToOdl.push = function (obj) {
      this.issueList.push(obj);
    };

    issueToOdl.pop = function () {
      return this.issueList.pop();
    };

    return issueToOdl;


  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:TaskCtrl
 * @description
 * # TaskCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/task/detail', {
            templateUrl: 'plan/task/task_detail.html',
            controller: 'TaskCtrl'
        })
        .when('/task/detail/:id', {
            templateUrl: 'plan/task/task_detail.html',
            controller: 'TaskCtrl'
        })
  })
  .controller('TaskCtrl', function ($scope, taskFactory, activityFactory, $log, $routeParams, $location, $window, toaster, authFactory, dialogService) {

    $scope.isSidebarOpened = false;
    var sidebar = angular.element(document.getElementById('list-sidebar'));
    var overlay = angular.element(document.getElementsByClassName('list-sidebar-overlay')[0]);
    var centerPage = angular.element(document.getElementsByClassName('center-page')[0]);

    $scope.taskActivitiesId = [];
    $scope.taskActivities = []; // Panel
    $scope.availableActivities = []; // Sidebar
    $scope.addCheckModel = [];
    $scope.remCheckModel = [];
    $scope.filteredActivities = [];
    $scope.newTask = true;
    $scope.task = { model:{ attachments:[] } };
    $scope.activityFilter = "";
    $scope.description = "";

    // Gestione allegati
    $scope.attachments = [];
    function readAttachments(modelList){
        $scope.attachments.splice(0,$scope.attachments.length);
        if(modelList) {
          for (var i = 0; i < modelList.length; i++) {
            $scope.attachments.push(modelList[i]);
          }
        }
    }
    function writeAttachments(modelList){
        modelList.splice(0,modelList.length);
        for(var i=0; i<$scope.attachments.length; i++){
            modelList.push($scope.attachments[i]);
        }
    }
    $scope.updAttachments = function(){
        writeAttachments($scope.task.model.attachments);
        taskFactory.updateTask({id: $scope.task.model.code}, $scope.task);
    };

    function invalidateTaskActivities(){
        var task;
        $scope.taskActivitiesId = [];
        for(var i=0; i<$scope.taskActivities.length; i++){
            task = $scope.taskActivities[i];
            $scope.taskActivitiesId.push(task.UUID);
        }
    }

    $scope.isDisabledActivity = function(UUID){
        var result;
        if($scope.taskActivitiesId.indexOf(UUID) == -1) {
            result = false;
        }
        else{
            result = true;
        }
        return result;
    };

    $scope.selectActivity = function(){
        $scope.openSidebar();
        if($scope.availableActivities.length==0){
            $scope.loadActivities();
        }
        invalidateTaskActivities();
    };

    $scope.removeActivity = function(){
        var count = $scope.remCheckModel.length;
        var removed = 0;
        for(var i=0; i<$scope.remCheckModel.length; i++){
            if($scope.remCheckModel[i]){
                $scope.taskActivities.splice(i-removed, 1);
                removed++;
            }
        }
        count -= removed;
        initRemCheckModel(count);
    };

    $scope.confirmSelectActivities = function(){
        $scope.closeSidebar();
        for(var i=0; i<$scope.addCheckModel.length; i++){
            if($scope.addCheckModel[i]){
                var r = $scope.filteredActivities[i];
                if($scope.taskActivities.indexOf(r) == -1) {
                    $scope.taskActivities.push(r);
                }
            }
        }
        initRemCheckModel();
    };

    function initAddCheckModel(length){
        $scope.addCheckModel = [];
        for(var i=0; i<length; i++){
            $scope.addCheckModel.push(false);
        }
    }

    function initRemCheckModel(length){
        $scope.remCheckModel = [];
        for(var i=0; i<length; i++){
            $scope.remCheckModel.push(false);
        }
    }

    $scope.loadActivities = function() {
        activityFactory.getActivitiesList({page_size: 10000, page: 1}).$promise.then(function (data) {
            $scope.availableActivities = data.list;
            initAddCheckModel($scope.availableActivities.length);
        });
    };

    $scope.toggleSidebar = function() {
      if($scope.isSidebarOpened) {
        $scope.closeSidebar();
      }
      else{
        $scope.openSidebar();
      }
    };

    $scope.closeSidebar = function() {
      sidebar.removeClass('open');
      centerPage.removeClass('center-open');
      $scope.isSidebarOpened = false;
      if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass('open')) {
        overlay.addClass('active');
      } else {
        overlay.removeClass('active');
      }
    };

    $scope.openSidebar = function() {
      initAddCheckModel();
      sidebar.addClass('open');
      centerPage.addClass('center-open');
      $scope.isSidebarOpened = true;
      if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass('open')) {
        overlay.addClass('active');
      } else {
        overlay.removeClass('active');
      }
    };

    $scope.refreshDescription = function(description) {
      if(description) {
        $scope.task.model.description = angular.copy(description);
      }
    };

    function fillActivitiesList(){
        $scope.task.model.activities = [];
        for(var i=0; i<$scope.taskActivities.length; i++){
            var activity = $scope.taskActivities[i];
            var ref;
            if(angular.isDefined(activity.model)){
                ref = sixObjectLib.recordToHisRef($scope.taskActivities[i]);
            }
            else{
                ref = activity;
            }
            $scope.task.model.activities.push(ref);
        }
    }

    $scope.saveForm = function() {
      if($scope.task.model.code && $scope.task.model.description) {
        fillActivitiesList();
        if ($scope.task.version) {
          taskFactory.updateTask({id: $scope.task.model.code}, $scope.task)
            .$promise.then(function() {
              $window.history.back();
            });
        } else {
          writeAttachments($scope.task.model.attachments);
          taskFactory.saveTask($scope.task.model)
            .$promise.then(function() {
              $window.history.back();
            });
        }
      }
      else{
          toaster.pop('error', 'Errore', 'Descrizione obbligatoria');
      }
    };

    $scope.getTaskByUUID = function(id){
      taskFactory.getTaskByUUID({uuid: id}).$promise.then(function (data) {
            $scope.task = data;
            $log.info(data);
            $scope.description = $scope.task.model.description;
            readAttachments($scope.task.model.attachments);
            for(var i=0; i<$scope.task.model.activities.length; i++){
               $scope.taskActivities.push($scope.task.model.activities[i]);
            }
        });
    };

    $scope.delete = function (version) {
      dialogService.confirmDialog('Eliminare il compito ' + $scope.task.model.code + ' - ' + $scope.task.model.description + '?',
        function () {
          taskFactory.deleteTask({id: version}).$promise.then(function() {
              $window.history.back();
          });
        }
      );
    };

    $(document).ready(function() {
      $('.list-sidebar-overlay').on('click', function() {
        $(this).removeClass('active');
        $('#list-sidebar').removeClass('open');
      });
    });

    //___ main ___
    if($routeParams.id) {
        if($routeParams.id != 'new'){
            $scope.getTaskByUUID($routeParams.id);
        }
    }


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'task';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };

  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:TaskganttCtrl
 * @description
 * # TaskganttCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan')
  .config(function ($routeProvider) {
      $routeProvider
          .when('/task/gantt', {
                templateUrl: 'plan/task/task_gantt.html',
                controller: 'TaskGanttCtrl'
          })
  })
  .controller('TaskGanttCtrl', function ($scope, $log, $filter, $location, taskFactory, authFactory, localStorageService, modelIconService) {

      $scope.opt = {
          open: false,
          viewScale: "day",
          fromDate: new Date(),
          toDate: new Date(),
          filterRow: '',
          assetFilter: {}
      };
      $scope.opt.toDate.setDate($scope.opt.toDate.getDate() + 30);

      if(localStorageService.get('taskgantt.gantt_options')) {
        var tmp = localStorageService.get('taskgantt.gantt_options');
        var fromStr = '' + tmp.fromDate;
        var toStr = '' + tmp.toDate;
        tmp.fromDate = new Date(fromStr);
        tmp.toDate = new Date(toStr);
        $scope.opt = tmp;
      }

      $scope.commissionCode = authFactory.getAuthData().info.commissions.current.code;

    $scope.tooltipContent = '<strong>{{task.model.description}}</strong></br>' +
    '{{task.model.status}}<br/>' +
    '<small>' +
    '{{getFromLabel()}}' +
    '</small>';

    $scope.treeContent = '<div title="{{row.model.entity}}" ng-click="collapse(this)" ng-dblclick="expand(this)"><span class="entity-icon hidden text-info-dker">{{row.model.entity}}</span> &nbsp;{{row.model.name}}</div>';

    $scope.options = {};

    $scope.registerApi = function(api) {
        $scope.api = api;

        api.core.on.ready($scope, function () {
            // Call API methods and register events.
        });

        api.directives.on.new($scope, function(directiveName, directiveScope, element) {
            if (directiveName === 'ganttTask') {
                element.bind('click', function(event) {
                    event.stopPropagation();
                    taskClickEvent('task-click', directiveScope.task);
                });
            }
            });
    };

    // Event handler
    var taskClickEvent = function(eventName, task) {
        $location.path("odl/" + task.model.id);
        $scope.$apply();
    };

    $scope.load = function() {
        $scope.data = $scope.ganttData;
    };

    $scope.reload = function() {
        $scope.getGanttData();
    };

    // Etichetta e contenuto colonne.
    //$scope.tableColumns = ['model.frequency'];
    //$scope.tableHeaders = {'model.frequency': 'Frequenza'};
    $scope.tableColumns = [];

    // Etichetta e contenuto tree.
    $scope.treeHeader = "Compito";

    $scope.toggleArrow = function(){
        $scope.opt.open = !$scope.opt.open;
    };

    $scope.collapseAll = function () {
        $scope.$broadcast('angular-ui-tree:collapse-all');
    };

    $scope.expandAll = function () {
        $scope.$broadcast('angular-ui-tree:expand-all');
    };

    $scope.goToNewTask = function(){
        $location.path('task/detail');
    };

    $scope.clearAssetFilter = function(){
        $scope.opt.assetFilter = {};
        $scope.opt.filterRow = '';
        $scope.getGanttData();
    };

    $scope.$watch('opt.fromDate',
      function(newValue, oldValue) {
          if( (newValue!=oldValue) ){
              $scope.getGanttData();
          }
      }
    );

    $scope.$watch('opt.toDate',
      function(newValue, oldValue) {
          if( (newValue!=oldValue) ){
              $scope.getGanttData();
          }
      }
    );

    $scope.$watch('opt.open',
      function(newValue, oldValue) {
          if( (newValue!=oldValue) ){
              $scope.opt.open = newValue;
              localStorageService.set('taskgantt.gantt_options', $scope.opt);
          }
      }
    );

    $scope.$watch('opt.filterRow',
      function(newValue, oldValue) {
          if( (newValue!=oldValue) ){
              localStorageService.set('taskgantt.gantt_options', $scope.opt);
          }
      }
    );

    $scope.printModelIcons = function(){
        var array = $('.entity-icon');
        for(var i=0; i<array.length; i++){
            var target = $(array[i]);
            var entity = target.html();
            target.addClass($scope.getModelIcon(entity));
            target.html('');
            target.removeClass('hidden');
        }
    };

    $scope.getModelIcon = function (modelName) {
      var icon = modelIconService.getModelIcon(modelName) || 'fa fa-list';
      return icon;
    };

    $scope.getGanttData = function(){
        // Compose payload
        var payload = {};
        payload.date_from = new Date($scope.opt.fromDate.getTime());
        payload.date_from.setDate($scope.opt.fromDate.getDate()-1);
        payload.date_to = new Date($scope.opt.toDate.getTime());
        payload.date_to.setDate($scope.opt.toDate.getDate()+1);
        // Add filters
        if(angular.isDefined($scope.opt.assetFilter.description)){
            payload.asset_description = $scope.opt.assetFilter.description;
        }
        if(angular.isDefined($scope.opt.assetFilter.code)){
            payload.asset_code = $scope.opt.assetFilter.code;
        }
        if(angular.isDefined($scope.opt.assetFilter.type_id)){
            payload.asset_type = $scope.opt.assetFilter.type_id.code;
        }
        // Call endpoint
        taskFactory.getGantt(payload)
            .$promise.then(function(data) {
                $scope.ganttData = data.list;
                setTimeout(function () {
                    $scope.api.rows.refresh();
                    $scope.printModelIcons();
                }, 500);
        });
        localStorageService.set('taskgantt.gantt_options', $scope.opt);
    };

    $scope.getGanttData();


    var RESOURCE_NAME = 'task';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };

  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:TaskCtrl
 * @description
 * # TaskCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/task', {
            templateUrl: 'plan/task/task_list.html',
            controller: 'TaskListCtrl'
        })
  })
  .controller('TaskListCtrl', function ($scope, taskFactory, $log, $routeParams, $location, uiGridConstants, authFactory) {
    $scope.tasksList = {};
    $scope.params = {
      pageNumber: 1,
      pageSize: 15,
      filters: {}
    };
    $scope.viewGridOptions = {};

    function initGridColumns() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 34,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents" style="text-align: center">' +
            '<a ng-href="#/task/detail/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' +
              '<span class="fa fa-search"></span>' +
            '</a>' +
          '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice',
        field: 'model.code',
        enableFiltering:true,
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descrizione',
        field: 'model.description',
        enableFiltering:true,
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
    }

    $scope.getData = function () {
        var payload = {
          page: $scope.params.pageNumber,
          page_size: $scope.params.pageSize,
          show_revision: false
        };
        taskFactory.getTasksListFiltered(payload, $scope.params.filters)
            .$promise.then(function(data) {
                $scope.tasksList.totalResults = data.totalResults;
                $scope.tasksList.list = data.list;
        });
    };

    $scope.getTasksList = function () {
      var payload = {
            page: $scope.params.pageNumber,
            page_size: $scope.params.pageSize
      };
      taskFactory.getTasksListFiltered(payload, $scope.params.filters)
        .$promise.then(function(data) {
            $scope.tasksList.totalResults = data.totalResults;
            $scope.tasksList.list = data.list;
      });
    };

    $scope.goToNewTask = function(){
        $location.path('task/detail');
    };

    $scope.goToGantt = function(){
        $location.path('task/gantt');
    };

    //__main__
    initGridColumns();


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'task';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:EggsCtrl
 * @description
 * # EggsCtrl
 * Controller of the sixEmmaApp
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/welcome/:id', {
        templateUrl: 'theme/abnormal/abnormal.html',
        controller: 'ABNormalCtrl',
        controllerAs: 'eggs'
      })
  })
  .controller('ABNormalCtrl', function ($scope, $sce, $routeParams, $location, APP_URL, sixFrameFactory) {
    $scope.debug = false;
    $scope.function = {
      action: $routeParams.id
    };
    $scope.EggsURL = $sce.trustAsResourceUrl(APP_URL + '/FirstS');
    $scope.jsfurl = null;

    $scope.submit = function () {
      var action = document.getElementById("action");
      action.value = $scope.function.action;
      var el = document.getElementById("submit");
      el.click();
      $location.search({ loaded: 'true' });
    };

    // SIX
    $scope.getJsfURL = function () {
      return sixFrameFactory.getJsfURL($scope.jsfurl);
    };

    function init() {
      $scope.submit();
    };

    init();

  });

'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:AdminCtrl
 * @description
 * # AdminCtrl
 * Controller of the emma.theme
 */
angular.module('ictportal.theme')
.config(function ($routeProvider) {
  $routeProvider
  .when('/admin/:page', {
        templateUrl: 'theme/admin/admin.html',
        controller: 'AdminCtrl'
      });
  })
  .controller('AdminCtrl', function (APP_URL, $scope, $rootScope, authFactory, $routeParams, ENV, DEV, ADMIN_URL) {

    var authData = authFactory.getAuthData();
    $scope.isEggs = ( $rootScope.systems) && $rootScope.systems.isEggs;
    $scope.page = $routeParams.page;

    $scope.getAdminURL = function () {
      var params = '';
      if(authData){
        params = '?username=' + authData.authId + '&nextPage=';
      }
      if($routeParams.page) {
        params = params + $routeParams.page;
      } else {
        params = params + 'admin';
      }
      if(DEV) {
        return APP_URL + params;
      } else {
        return ADMIN_URL + params;
      }
    };
    
  });


'use strict';

/**
 * @ngdoc overview
 * @name sixEmmaApp
 * @description
 * # sixEmmaApp
 *
 * Main module of the application.
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/cas/postauth', {
        templateUrl: 'theme/auth/postauth.html',
        controller: 'PostAuthCtrl'
      })
  })
  .controller('PostAuthCtrl', function ($scope, $routeParams, $rootScope, authFactory, recordFactory, schemaFactory, counterFactory, $location, $http, $log, ENV) {

    $log.log('PostAuthCtrl');

    function createNewOperator(authData) {
      var filters = {
        'model.username': sixFiltersLib.exact('model.username', authData.authId)
      };

      recordFactory('operatore').search(filters).$promise.then(function(resp) {
        $log.info('------ operator ------');
        $log.info(resp);
        $log.info('----------------------');

        // Creo l'operatore solo se non esiste già un operatore con lo username loggato
        if(!resp.list || resp.list.length == 0) {
          var newOp = {};
          newOp.description = authData.info.name + ' ' + authData.info.surname;
          newOp.mail = authData.info.mail;
          newOp.username = authData.authId;

          schemaFactory().byUUID({id: 'operatore'}).$promise.then(function (schemaResp) {
            if (!schemaResp.model) {
              dialogService.alert('Non è stato definito un modello per l\'entità operatore', 4000);
              return;
            }
            /* ***** Search filters ***** */
            if(schemaResp.model.selfGeneratedCode){
              var selfGeneratedCode = schemaResp.model.selfGeneratedCode;

              counterFactory.next({code: selfGeneratedCode.codeNameSix}).$promise.then(function (counterResp) {
                if (counterResp.errors){
                  $log.error('Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + counterResp.errors.error);
                  toaster.pop('error', 'Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + counterResp.errors.error);
                } else {
                  newOp.code = counterResp.next;

                  var payload = {
                    page: 1,
                    page_size: 1,
                    cross: true,
                    history: false
                  };
                  var filters = {
                    role: sixFiltersLib.in('model.ldap_groups.code', authData.authPermission)
                  };
                  sysConfigFactory('rolemapping').search(payload, filters).$promise.then(function(result) {
                    if(result && result.list.length > 0) {
                      newOp.typeoperator_id = result.list[0].model.emma_role_id;
                    } else {
                      $log.error('Mapping per il ruolo \''+ authData.authPermission +'\' non trovato');
                    }

                    $log.info('------ new operator ------');
                    $log.info(newOp);
                    $log.info('--------------------------');

                    recordFactory('operatore').create(newOp).$promise.then(function(respOp) {
                      $log.info('------ create operator ------');
                      $log.info(respOp);
                      $log.info('-----------------------------');
                    });
                  });

                }

              });
            }
          });
        }
      });
    }

    $http.get('emmacas/postauth/'+ENV).success(function(data, status) {
      $log.log(status);
      $log.log(data);
      $scope.response = data;

      if (!data.info || !data.info.commissions || !data.info.commissions.current){
        return;
      }

      if(ENV == 'asset') {
        createNewOperator(data);
      }

      $log.info(data);
      authFactory.setAuthData(data);
      $location.path('/home');
    }).error(function(error) {
      $log.log(error);
    });

  });

/**
 * Created by Rita on 18/07/17.
 */

angular.module('ictportal.theme')
.config(function ($routeProvider) {
    $routeProvider
        .when('/bookmarks', {
            templateUrl: 'theme/bookmarks/bookmarks.html',
            controller: 'BookmarksCtrl'
        })
})
.controller('BookmarksCtrl', function ($scope, $routeParams, $log, authFactory, sixFrameFactory, $location) {

    $scope.jsfurl = null;
    var authData = undefined;
        
    $scope.getJsfURL = function () {
        return sixFrameFactory.getJsfURL($scope.jsfurl);
    };

    function displayBookmarks(){
        $scope.bookmarks = authFactory.getAuthData().bookmarks;
        authData.navigation.push({
            root: 'bookmarks',
            menuItem: undefined,
            menuItemsList: authFactory.getAuthData().bookmarks
        });
    };

    function redirect(path){
        $location.path(path);
    };

    function init(){
        authData = authFactory.getAuthData();
        if(authData){
            if(authData.navigation.length>0){
                var lastNav = authData.navigation[authData.navigation.length-1];
                if(lastNav.root!='bookmarks'){
                    redirect(lastNav.root);
                }
                else{
                    displayBookmarks();
                }
            }
            else{
                displayBookmarks();
            }
        }
    };

    init();
});
/**
 * Created by Matteo Negri on 18/07/17.
 */

angular.module('ictportal.theme')
.config(function ($routeProvider) {
    $routeProvider
        .when('/bookmarks/home', {
            templateUrl: 'theme/bookmarkshome/bookmarkshome.html',
            controller: 'BookmarksCtrl'
        })
})
.controller('BookmarksCtrl', function ($scope, localeFactory, authFactory, sixFrameFactory, $location, recordFactory, dbFilterFactory) {

    $scope.jsfurl = null;
    var authData = undefined;
    $scope.editing = false;
        
    $scope.getJsfURL = function () {
        return sixFrameFactory.getJsfURL($scope.jsfurl);
    };

    function displayBookmarks(){
        $scope.bookmarks = authFactory.getAuthData().bookmarks;
        $scope.bookmarks.forEach(function(b) {
            b.newDescription = b.description;
        });
        authData.navigation.push({
            root: 'bookmarks',
            menuItem: undefined,
            menuItemsList: authFactory.getAuthData().bookmarks
        });
    };

    function redirect(path){
        $location.path(path);
    };

    // Enter editing mode
    $scope.startEdit = function() {
        $scope.editing = true;
    }

    // Save new bookmarks descriptions
    $scope.stopEdit = function() {
        $scope.editing = false;
        var bookmarksToUpdate = [];
        $scope.bookmarks.forEach(function(b) {
            if(b.description!==b.newDescription) {
                bookmarksToUpdate.push(b);
                
            }
        });
        if(bookmarksToUpdate.length>0) {
            updateBookmarksDescription(bookmarksToUpdate);
        }
    }

    // Save on DB
    function updateBookmarksDescription(bookmarks) {
        var filter = [{
                    "column": "functions f",
                    "value": "f.id = t.funzione_id",
                    "relation": "JOIN",
                    "kind": "f.codice, f.angular_path"
                  }].concat(dbFilterFactory.getStringFilter('utente_id', authData.info.userId.toString(), '='))
                    .concat(dbFilterFactory.getCustomFilter(getCodeQuery(bookmarks)));
        recordFactory('preferred').filter(JSON.stringify(filter)).$promise.then(function (data){
            for(var i=0; i<data.list.length; i++) {
                for(var j=0; j< bookmarks.length; j++) {
                    var preferred = data.list[i];
                    var bookmark = bookmarks[j];
                    if(preferred.descrizione==bookmark.description) {
                        recordFactory('preferred').update({id: preferred.id}, {descrizione: bookmark.newDescription});
                        bookmark.description = bookmark.newDescription;
                        break;
                    }
                }
            }
        });
    }

    // Composes a query necessary to load from DB needed functions information starting from a bookmark.
    function getCodeQuery(bookmarks) {
        var functionCodes = [];
        var angularPaths = [];
        bookmarks.forEach(function(b) {
            if (b.code.includes('functionCode')) {
                functionCodes.push("'" + getParameterByName('functionCode', b.code) + "'");
            }
            else {
                angularPaths.push("'" + b.code + "'");
            }
        });
        var functionCodeQuery = undefined;
        if(functionCodes.length>0) {
            functionCodeQuery = ' f.codice IN (' + functionCodes.join(",") + ') ';
        }
        var angularPathQuery = undefined;
        if(angularPaths.length>0) {
            angularPathQuery = ' f.angular_path IN (' + angularPaths.join(",") + ') ';
        }
        var codeQuery = '';
        if(functionCodeQuery && !angularPathQuery ) {
            codeQuery = functionCodeQuery;
        }
        else if(!functionCodeQuery && angularPathQuery ) {
            codeQuery = angularPathQuery;
        }
        else {
            codeQuery = functionCodeQuery + ' OR ' + angularPathQuery;
        }
        return codeQuery;
    }

    // Exit editing mode.
    $scope.undoEdit = function() {
        $scope.editing = false;
        $scope.bookmarks.forEach(function(b) {
            b.newDescription = b.description;
        });
    }

    // Extract code from function code.
    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    function init(){
        localeFactory.loadTranslation('portal');
        authData = authFactory.getAuthData();
        if(authData){
            if(authData.navigation.length>0){
                var lastNav = authData.navigation[authData.navigation.length-1];
                if(lastNav.root!='bookmarks'){
                    redirect(lastNav.root);
                }
                else{
                    displayBookmarks();
                }
            }
            else{
                displayBookmarks();
            }
        }
    };

    init();
});
'use strict';

/**
 * @ngdoc function
 * @name myNewProjectApp.controller:ChangeUserCtrl
 * @description
 * # ChangeUserCtrl
 * Controller of the myNewProjectApp
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/changeuser', {
        templateUrl: 'theme/changeuser/changeuser.html',
        controller: 'ChangeUserCtrl'
      });
  })
  .controller('ChangeUserCtrl', function (APP_URL, $scope, $location, $log, dbBaseFactory, authFactory, dialogService, $http) {

  $scope.data = null;
  $scope.searchString = '';

  $scope.searchUsers = function () {
    $scope.showTimeline = false;
      dbBaseFactory('user').search(
          {
              'search':{
                  'obj': {
                      'searchString' : $scope.searchString,
                      'attivo':'T'
                  }
              },
              'init':
              {
                  'username':true,
                  'surname':true,
                  'name':true,
                  'email':true
              }
          }
        /*{query: getQuery(), page: paginationOptions.pageNumber, pageSize: paginationOptions.pageSize,
            sortFields: defaultSort(), history: $scope.isSnapshot()
        }*/
    ).$promise.then(function(result) {
          $scope.data = result;
        //getPage();
    });
  };

  //copia e incolla da login.js
  $scope.changeUser = function (user) {
      console.log('switch to '+user);
      $scope.errors = false;
      dialogService.loading('login');
      $http.post(APP_URL + '/rest/auth/loginas/'+user, user).then(function (data, status) {
          dialogService.stopLoading();
          if (data.status === 200) {
              if (!data.data.info || !data.data.info.commissions || !data.data.info.commissions.current){
                  dialogService.stopLoading();
                  console.log('piovono madonne');
                  dialogService.alert('Non sono state configurate commesse per l\'utente selezionato', 4000);
                  return;
              }
              authFactory.setAuthData(data.data);
              $location.path('/changeuser');
          }            // Redirect etc.
          else{
              $scope.errors = true;
              dialogService.alert('Errore di accesso', 4000);
          }
      }, function () {
          // Error handling
          $scope.errors = true;
          dialogService.alert('Errore di accesso', 4000);
      });
      dialogService.stopLoading();
  };

  $scope.isCurrent = function(username){
      return username === authFactory.getAuthData().authId;
  };


   $scope.searchUsers();
  });

'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:CommissionCtrl
 * @description
 * # CommissionCtrl
 * Controller of the emma.theme
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/commission', {
        templateUrl: 'theme/commission/commission_list.html',
        controller: 'CommissionCtrl'
      })
      .when('/commission/page/:number', {
        templateUrl: 'theme/commission/commission_list.html',
        controller: 'CommissionCtrl'
      })
      .when('/commission/:id', {
        templateUrl: 'theme/commission/commission_detail.html',
        controller: 'CommissionCtrl'
      });
  })
  .controller('CommissionCtrl', function ($scope, $routeParams, $rootScope, $location, $log, $window, commissionFactory,
                                          counterFactory, $route, authFactory, loginFactory, dialogService) {

    $scope.typeName='commission';
    $scope.counterName='commission';
    $scope.pageSize=10;
    $scope.data = {selected: ""};

    $scope.addCommission = function(){
        $location.path('commission/new');
    };

    $scope.refresh = function(){
        $location.path('commission');
    };

    $scope.changeCommission = function(commission){
      var switchProfileElement = {
        selected : {
          type:'',
          cod: 0,
          code: commission.code,
          description: commission.description,
          items: [{
            type:'commission',
            cod: 0,
            code: commission.code,
            description: commission.description
          }]
        }
      };
      dialogService.loading('Cambio commessa '+authFactory.getAuthData().info.commissions.current.code +' <i class="fa fa-angle-double-right"></i> '+commission.code);
      loginFactory.switch(switchProfileElement).$promise.then(function (response) {
        authFactory.setAuthData(response);
        $route.reload();
        dialogService.stopLoading();
      });
    };

    $scope.getData = function () {
      var payload = {
          query: $scope.queryParam,
          page_size: $scope.pageSize
      };
      commissionFactory().getCommissionsList(payload).$promise.then(function(response) {
        $scope.data = response;
      });
    };

    $scope.pageChanged = function (page) {
      if (!page){
        page = $scope.data.currentPage;
      }
      $location.path('/'+$scope.typeName+'/page/'+page, false);
      var payload = {
          page: page,
          query: $scope.queryParam,
          page_size: $scope.pageSize
      };
      commissionFactory().getCommissionsList(payload).$promise.then(function(response) {
        $scope.data = response;
      });
    };

    $scope.errorsRetrievingCounter = function(errors){
      $log.error('impossibile recuperare il contatore '+JSON.stringify(errors));
      $rootScope.$broadcast('topPanel', {messages : errors});
    };

    $scope.update = function () {
      if ($scope.isNew){
        $log.info('sto facendo una commission nuova, confermo contatore');
          counterFactory.next({code: $scope.counterName}).$promise.then(function (response) {
            if (response.errors){
              $scope.errorsRetrievingCounter(response.errors);
              return;
            }
            $scope.data.selected.code = response.next;
            upd();
          });
      }else{
        upd();
      }
    };

    function upd(){
      commissionFactory().saveCommission($scope.data.selected).$promise.then(function() {
        $log.info('saving: '+$scope.data.selected);
        $window.history.back();
      });
    }

    $scope.deleteWithDialog = function (idToDelete) {
      dialogService.confirmDialog('Eliminare la commessa?',
        function () {
          $scope.delete(idToDelete);
        });
    };

    $scope.delete = function (idToDelete) {
      $log.info('deleting id:' +idToDelete);
      commissionFactory().deleteCommission({id: idToDelete}).$promise.then(function() {
        $scope.getData();
        $window.history.back();
      });
    };

    $scope.getCommissionById = function (itemId) {
      //console.log('currentpage '+$scope.data.currentPage);
      $scope.isNew = false;
      commissionFactory().getCommissionByCode({code: itemId}).$promise.then(function (response) {
        $scope.data = {selected: response};
        if ($routeParams.id == 'new'){
          $scope.isNew = true;
          counterFactory.current({code: $scope.counterName}).$promise.then(function (response) {
            if (response.errors){
              $scope.errorsRetrievingCounter(response.errors);
              $window.history.back();
              return;
            }
            $log.info('sto facendo una commission nuova '+response+ ' ' +JSON.stringify(response));
            $scope.data.selected.code = parseInt(response.current)+1;
          });
        }
      });
    };

    if($routeParams.id) {
      $scope.getCommissionById($routeParams.id);
    } else if($routeParams.number) {
      $scope.pageChanged($routeParams.number);
    }else {
      $scope.getData();
    }


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'commission';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };

  });

(function (window, document) {
    'use strict';

    // attach sixDateLib as a property of window
    var sixDateLib = window.sixDateLib || (window.sixDateLib = {});

    // BEGIN API

    function getLocale() {
        return {
            'decimal': '.',
            'thousands': ',',
            'grouping': [3],
            'currency': ['$', ''],
            'dateTime': '%a %b %e %X %Y',
            'date': '%d/%m/%Y',
            'time': '%H:%M:%S',
            'periods': ['AM', 'PM'],
            'days': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            'shortDays': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            'months': ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
            'shortMonths': ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic']
        };
    }

    function getMonthIndex(name) {
        return getLocale().months.indexOf(name);
    }

    function getMonthName(n) {
        return getLocale().months[n];
    }

    function getMonthShortName(n) {
        return getLocale().shortMonths[n];
    }

    function getMonths() {
      return getLocale().months;
    }

    function getStartOfDay(date){
      var result = new Date(date.getTime());
      result.setHours(0,0,0,0);
      return result;
    };

    function getEndOfDay(date){
      var result = new Date(date.getTime());
      result.setHours(23,59,59,999);
      return result;
    };

    function getYearsInPeriod(fromDate, toDate) {
      //var start = $filter('date')(fromDate, 'yyyy');
      //var end = $filter('date')(toDate, 'yyyy');
      var start = fromDate.getFullYear();
      var end = toDate.getFullYear();
      var list = [];
      for(var y = start ; y <= end ; y++) {
        list.push(y);
      }
      return list;
    }

    Date.prototype.addDays = function(days) {
      var dat = new Date(this.valueOf());
      dat.setDate(dat.getDate() + days);
      return dat;
    };

    function getMonthsInPeriod(fromDate, toDate) {
      var from = new Date(fromDate);
      var to = new Date(toDate);
      var list = [];
      for(var i = 0; i < countMonthsInPeriod(from, to); i++){
        var dateItem = new Date(from.getFullYear(), from.getMonth()+i, 1);
        list.push(dateItem);
      }
      return list;
    }

    function countMonthsInPeriod(from, to) {
      return (to.getFullYear() * 12 + to.getMonth()) - (from.getFullYear() * 12 + from.getMonth()) + 1;
    }

    function getDatesInPeriod(startDate, stopDate) {
      var dateArray = new Array();
      var currentDate = startDate;
      while (currentDate <= stopDate) {
        dateArray.push( new Date (currentDate) );
        currentDate = currentDate.addDays(1);
      }
      return dateArray;
    }

    //Month is 0 based
    function daysNumberInMonth(year, month) {
      return new Date(year, month+1, 0).getDate();
    }

    function getDateStringFormattedFromDate(date){
      // from type date return a string formatted as: yyyy-MM-dd
      return date.getFullYear()
        + '-' + ('0' + (date.getMonth() + 1)).slice(-2)
        + '-' + ('0' + date.getDate()).slice(-2);
    }

  /**
   * Converte un oggetto java Instant in una data javascript
   * @param dateAsInstant oggetto in formato {epochSecond: <sec>, nano: <nano>}
   * @returns {Date}
   */
    function fixDatesAsInstant(dateAsInstant) {
      var utcSeconds = dateAsInstant.epochSecond;
      var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
      d.setUTCSeconds(utcSeconds);
      return d;
    }

    /**
     * Cerca gli oggetti java Instant tra le varie properties dell'oggetto passato e li converte in date javascript
     * @param obj
     */
    function fixObjDates(obj) {
      angular.forEach(obj, function(value, key) {
        if(value instanceof Object) {
          if(value.hasOwnProperty('epochSecond') && value.hasOwnProperty('nano')) { // trovata la nostra data in formato java Instant
            var d = fixDatesAsInstant(value);
            obj[key] = d;
          } else {
            fixObjDates(value);
          }
        }
      });
    }

    /**
     * Fixa le date java Instant di un array di oggetti che arriva dal backend.
     * Accetta una lista di oggetti o un oggetto singolo, e ne converte gli attributi java Instant in date javascript
     * @param objList: lista di oggetti o oggetto singolo
     */
    function fixDates(objList) {
      var list = [].concat(objList);
      angular.forEach(list, function(obj) {
        fixObjDates(obj);
      });
    }

    function getTimezone(date){
        var offset = date.getTimezoneOffset();
        offset = -(offset/60);
        return offset;
    };

    function stringToDate(_date,_format,_delimiter)
    {
      var formatLowerCase=_format.toLowerCase();
      var formatItems=formatLowerCase.split(_delimiter);
      var dateItems=_date.split(_delimiter);
      var monthIndex=formatItems.indexOf("mm");
      var dayIndex=formatItems.indexOf("dd");
      var yearIndex=formatItems.indexOf("yyyy");
      var month=parseInt(dateItems[monthIndex]);
      month-=1;
      var formatedDate = new Date(dateItems[yearIndex],month,dateItems[dayIndex]);
      return formatedDate.setHours(0,0,0,0);
    }

    // END API

    // publish external API by extending sixDateLib
    function publishExternalAPI(sixDateLib) {
        angular.extend(sixDateLib, {
            'getMonthIndex': getMonthIndex,
            'getMonthShortName': getMonthShortName,
            'getMonthName': getMonthName,
            'getYearsInPeriod': getYearsInPeriod,
            'getMonthsInPeriod': getMonthsInPeriod,
            'getDatesInPeriod': getDatesInPeriod,
            'daysNumberInMonth': daysNumberInMonth,
            'getMonths': getMonths,
            'countMonthsInPeriod': countMonthsInPeriod,
            'getDateStringFormattedFromDate': getDateStringFormattedFromDate,
            'fixDatesAsInstant': fixDatesAsInstant,
            'fixObjDates': fixObjDates,
            'fixDates': fixDates,
            'getTimezone': getTimezone,
            'getStartOfDay': getStartOfDay,
            'getEndOfDay': getEndOfDay,
            'stringToDate': stringToDate
        });
    }

    publishExternalAPI(sixDateLib);

})(window, document);

(function (window, document) {
  'use strict';

  // attach sixExportLib as a property of window
  var sixExportLib = window.sixExportLib || (window.sixExportLib = {});

  // BEGIN API

  function buildColumnsFromGrid(gridApi, $filter) {
    var columns = [];
    gridApi.grid.options.columnDefs.forEach(function(col) {
      if (!col.field) return;
      if (col.headerCellFilter && $filter && col.headerCellFilter) {
        columns.push({ 
          key: col.field, 
          transform: col.exportCelFormat,
          rowTransform: col.exportCelRowFormat,
          name: $filter(col.headerCellFilter)(col.displayName) 
        });
        return;
      }
      var colName = col.displayName ? col.displayName : (col.name ? col.name : col.field);
      columns.push({ key: col.field, transform: col.exportCelFormat, rowTransform: col.exportCelRowFormat, name: colName });
    });
    return columns;
  }

  function exportXLSXVisibleRowsGrid(gridApi, filename, $filter) {
    var columns = buildColumnsFromGrid(gridApi, $filter);
    var filtered = gridApi.grid.rows.filter(function(o) { return o.visible; });
    var rows = filtered.map(function(r) { return r.entity; }); // Entities extracted from the GridRow array
    exportXLSX(columns, rows, filename);
  }

  function exportXLSXAllRowsGrid(gridApi, filename) {
    var columns = buildColumnsFromGrid(gridApi);
    var rows = gridApi.grid.rows.map(function(r) { return r.entity; }); // Entities extracted from the GridRow array
    exportXLSX(columns, rows, filename);
  }

  function exportXLSXRowsGrid(gridApi, promise, filename) {
    var columns = buildColumnsFromGrid(gridApi);
    promise.then(function(response) {
      var list;
      if(angular.isArray(response)) {
        list = response;
      }
      if(response && response.list) {
        list = response.list;
      }
      exportXLSX(columns, list, filename);
    });
  }

  /*
    Esempio columns:
    columns = [
      {key: 'instant', name: 'Data', transform: function(v) { return (v && v.epochSecond)?new Date(v.epochSecond*1000):new Date(v) }},
                                     rowTransform: function(v) { return v.product_code +' - '+ v.product_description; }},
      {key: 'model.code', name: 'Codice'},
      {key: 'status', name: 'Stato'},
      {key: 'messages[0].text', name: 'Messaggio'}
    ];
  */

  function exportXLSX(columns, rows, filename, showLookupDescription) {
    var sheet = {};

    filename = filename || 'export';
    if(angular.isUndefined(showLookupDescription)) { showLookupDescription = false; }

    var i = 0;
    columns.forEach(function (col) {
      var loc = XLSX.utils.encode_cell({r: 0, c: i});
      sheet[loc] = {
        v: col.name
      };
      i += 1;
    });

    var endLoc;
    rows.forEach(function (row, ri) {
      ri +=1;
      columns.forEach(function (col, ci) {
        var loc = XLSX.utils.encode_cell({r: ri, c: ci});
        if(angular.isDefined(Object.byString(row, col.key))) {
          var value = Object.byString(row, col.key);
          if(angular.isFunction(col.transform)) { 
              value = col.transform(value); 
          } else if(angular.isFunction(col.rowTransform)) { 
              value = col.rowTransform(row); 
          }
          // if value is a lookup i can't return an object in a XLSX cell -> value must be a string: code + " - " + description
          if(value && angular.isDefined(value.UUID)) {
            if(showLookupDescription) {
              value = value.code + " - " + value.description;
            } else {
              value = value.code;
            }
          }
          // if value is an array i can't return the classic format in a XLSX cell -> value must be a string like: "[\"string1\", \"string2\"]"
          // se è il campo commessa non va formattato come un array
          if(isExportableArray(value) && col.key != 'commission'){
            var newValue = "[";
            value.forEach(function (string, index){
              if(index == 0){
                newValue = newValue + "\"" + string + "\"" ;
              } else {
                newValue = newValue + "," + "\"" + string + "\"" ;
              }
            });
            newValue = newValue + "]";
            value = newValue; // salvo la nuova stringa formattata nella variabile value
          }
          // previene la stampa di valori null o di array [null]
          if(angular.isUndefined(value) || value == null){
            value = "";
          }
          sheet[loc] = {
            v: value,
            t: angular.isNumber(value)? 'n' : 's'
          };
        }
        endLoc = loc;
      });
    });

    sheet['!ref'] = XLSX.utils.encode_range({ s: 'A1', e: endLoc });

    var workbook = {
      SheetNames: ['Sheet1'],
      Sheets: {
        Sheet1: sheet
      }
    };

    var wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' };
    var wbout = XLSX.write(workbook, wopts);

    saveAs(new Blob([s2ab(wbout)], {type: ""}), filename + ".xlsx");
  }

  function isExportableArray(value) {
    var isExp = false;
    // evita che vengano analizzati dati che non sono array o che sono array senza elementi, oppure sono array nella forma [null]
    if(value && Array.isArray(value) && value.length > 0 && value.indexOf(null) == -1){
      isExp = true;
    }
    return isExp;
  }

  function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }

  Object.byString = function(o, s) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];
      if (k in o) {
        o = o[k];
      } else {
        return;
      }
    }
    return o;
  };

  // END API

  // publish external API by extending sixExportLib
  function publishExternalAPI(sixExportLib) {
      angular.extend(sixExportLib, {
          'exportXLSXVisibleRowsGrid' : exportXLSXVisibleRowsGrid,
          'exportXLSXAllRowsGrid'     : exportXLSXAllRowsGrid,
          'exportXLSXRowsGrid'        : exportXLSXRowsGrid,
          'exportXLSX'                : exportXLSX
      });
  }

  publishExternalAPI(sixExportLib);

})(window, document);

/**
 * Created by Stefano Poli on 06/12/16.
 */

/**
 * Libreria per la costruzione dei filtri da passare al backend.
 * Endpoint di default su backend implementato dalla classe
 *   it.ictgroup.six.framework.index.service.AbstractIndexService
 * progetto six-elastic
 */

(function (window, document) {
    'use strict';

    // attach sixDateLib as a property of window
    var sixFiltersLib = window.sixFiltersLib || (window.sixFiltersLib = {});

    var FILTER_TYPE = {
      RANGE:    '_range',
      MISSING:  '_missing',
      NOT:      '_not',
      IN:       '_in',
      TEXT:     '_text',
      EXACT:    '_exact',
      BOOL:     '_bool'
    };

    var FILTER_REL = {
      LESS_THAN:              'lt',
      LESS_THAN_OR_EQUAL:     'lte',
      GREATER_THAN:           'gt',
      GREATER_THAN_OR_EQUAL:  'gte',
      EQUAL:                  'eq'
    };

    var CONSTRAINTS = {
      AND:  'and',
      OR:   'or'
    };

    // BEGIN API

    /*
     {
       type: "_range",
       key: <attributo da cercare>,
       lt|lte:  <valore limite massimo escluso/incluso>    e/o
       gt|gte:  <valore limite minimo escluso/incluso>     oppure
       eq|equal|equals: <valore>
     }
     */

    function range(key, lt, gt, eq, includeBounds, constraint) {
      if (angular.isUndefined(includeBounds)) { includeBounds = false; }

      // oggetto filtro generico
      var obj = _buildMap(key, undefined, FILTER_TYPE.RANGE, constraint);

      // elimino l'attributo 'value' che qui non serve
      delete obj.value;

      // aggiungo attributi specifici del filtro '_range'
      if (lt) {
        var k = includeBounds ? FILTER_REL.LESS_THAN_OR_EQUAL : FILTER_REL.LESS_THAN;
        obj[k] = lt;
      }
      if (gt) {
        var k = includeBounds ? FILTER_REL.GREATER_THAN_OR_EQUAL : FILTER_REL.GREATER_THAN;
        obj[k] = gt;
      }
      if (eq) {
        obj[FILTER_REL.EQUAL] = eq;
      }
      return obj;
    }

    function rangeEq(key, eq, constraint) {
      return range(key, undefined, undefined, eq, true, constraint);
    }

    function rangeLt(key, lt, constraint) {
      return range(key, lt, undefined, undefined, false, constraint);
    }

    function rangeGt(key, gt, constraint) {
      return range(key, undefined, gt, undefined, false, constraint);
    }

    function rangeLte(key, lte, constraint) {
      return range(key, lte, undefined, undefined, true, constraint);
    }

    function rangeGte(key, gte, constraint) {
      return range(key, undefined, gte, undefined, true, constraint);
    }

    function updateRange(key, value, relation, filter, constraint) {
      if(!_checkConstant(FILTER_REL, relation)) {
        throw new Error('Invalid filter relation type ' + relation);
      } else {
        if (!filter || filter == {}) {
          switch (relation) {
            case FILTER_REL.LESS_THAN:
              filter = rangeLt(key, value, constraint);
              break;
            case FILTER_REL.LESS_THAN_OR_EQUAL:
              filter = rangeLte(key, value, constraint);
              break;
            case FILTER_REL.GREATER_THAN:
              filter = rangeGt(key, value, constraint);
              break;
            case FILTER_REL.GREATER_THAN_OR_EQUAL:
              filter = rangeGte(key, value, constraint);
              break;
            case FILTER_REL.EQUAL:
              filter = rangeEq(key, value, constraint);
              break;
            default:
              throw new Error('Invalid filter relation type ' + relation);
          }
        }
        filter[relation] = value;
        return filter;
      }
    }

    function missing(key, constraint) {
      return _buildMap(key, value, FILTER_TYPE.MISSING, constraint);
    }

    function not(key, value, constraint) {
      return _buildMap(key, value, FILTER_TYPE.NOT, constraint);
    }

    function _in(key, value, constraint) {
      return _buildMap(key, value, FILTER_TYPE.IN, constraint);
    }

    function text(key, value, constraint) {
      return _buildMap(key, value, FILTER_TYPE.TEXT, constraint);
    }

    function exact(key, value, constraint) {
      return _buildMap(key, value, FILTER_TYPE.EXACT, constraint);
    }

    function bool(key, value, constraint) {
      return _buildMap(key, value, FILTER_TYPE.BOOL, constraint);
    }


    // utils
    /*
     {
       type: ["_range"|"_missing"|"_not"|"_in"|"_text"|"_exact"|"_bool"|"_boolean"]
       key: <attributo da cercare>,
       value: <valore da cercare>,      tranne per "_missing"
       contraint: <or|and>
     }
     */

    function _buildMap(key, value, type, constraint) {
      constraint = constraint || CONSTRAINTS.AND;

      if(!_checkConstant(CONSTRAINTS, constraint)) {
        throw new Error('Invalid filter constraint type ' + constraint);
      }
      if(!_checkConstant(FILTER_TYPE, type)) {
        throw new Error('Invalid filter type ' + type);
      }

      return {
        type: type,
        key: key,
        value: value,
        constraint: constraint
      };
    }

    function _checkConstant(constantsObj, value) {
      for(var key in constantsObj) {
        if(constantsObj[key] === value) {
          return true;
        }
      }
      return false;
    }

    // END API

    // publish external API by extending sixDateLib
    function publishExternalAPI(sixFiltersLib) {
        angular.extend(sixFiltersLib, {
          'FILTER_REL':   FILTER_REL,
          'CONSTRAINTS':  CONSTRAINTS,

          'range':        range,
          'updateRange':  updateRange,
          'rangeEq':      rangeEq,
          'rangeLt':      rangeLt,
          'rangeLte':     rangeLte,
          'rangeGt':      rangeGt,
          'rangeGte':     rangeGte,
          'missing':      missing,
          'not':          not,
          'in':           _in,
          'text':         text,
          'exact':        exact,
          'bool':         bool
        });
    }

    publishExternalAPI(sixFiltersLib);

})(window, document);

(function (window) {
    'use strict';

    // attach sixMatrixLib as a property of window
    var sixMatrixLib = window.sixMatrixLib || (window.sixMatrixLib = {});

    // BEGIN API
    function getTimes(n) {
      var list = [];
      for(var i = 0 ; i < n ; i++) {
        list.push(i);
      }
      return list;
    }

    /** Function di utility; usare getInitializedMatrix() **/
    // initValue, matrix, [... dimensions]
    function recursiveInitMatrix() {
      var initValue = arguments[0];
      var matrix = arguments[1];

      if(arguments.length === 2) {
        matrix = initValue;
        return matrix;
      }

      // Recupero la dimensione da scorrere
      var dim = arguments[2];
      if(!Array.isArray(dim)) {
        dim = getTimes(dim);
      }

      if(arguments.length === 3) {
        dim.forEach(function (item) {
          matrix[item] = angular.copy(initValue);
        });
        return matrix;
      }

      var otherDims = [].slice.call(arguments, 3);
      dim.forEach(function (item) {
        matrix[item] = [];
        var args = [initValue, matrix[item]].concat(otherDims);
        matrix[item] = recursiveInitMatrix.apply(null, args);
      });
      return matrix;
    }

    /*
     * Inizializza una matrice n dimensionale.
     * Da richiamare con i parametri:
     * - initValue: valore di inizializzazione
     * - dim1: dimensione di riga
     * - dim2: dimensione di colonna
     * - dim3: 3° dimensione
     * - dim4: 4° dimensione
     * - ...
     *
     * le dimensioni 'dim' possono essere array contenenti i valori delle chiavi di dimensione, oppure numeri che indicano la dimensione.
     * Casi d'uso:
     *
     * - var matrix = getInitializedMatrix(0, 10, 10, 5) => matrix è una matrice 3-dimensionale (10x10x5) le cui celle sono inizializzate con il valore 0
     * - var matrix = getInitializedMatrix(8, [5, 8], 3) => matrix è una matrice 2-dimensionale (2x3) le cui celle sono inizializzate con il valore 8;
     *   la matrice risultante è la seguente:
     *
     *      [0]  [1]  [2]  <- chiavi di colonna
     *   [5] 8    8    8
     *   [8] 8    8    8
     *    ^
     *    |
     * chiavi di riga
     */
    /**
     * @param {Object} [initValue]
     * @param {...Array.<T> | number} [dim]
     * @return {Array.<T>}
     **/
    function getInitializedMatrix() {
      var args = [arguments[0], []];
      for(var i = 1 ; i < arguments.length ; i++) {
        args.push(arguments[i]);
      }
      return recursiveInitMatrix.apply(null, args);
    }
    // END API

    // publish external API by extending sixMatrixLib
    function publishExternalAPI(sixMatrixLib) {
        angular.extend(sixMatrixLib, {
            'getInitializedMatrix': getInitializedMatrix
        });
    }

    publishExternalAPI(sixMatrixLib);

})(window, document);

(function (window) {
    'use strict';

    // attach sixObjectLib as a property of window
    var sixObjectLib = window.sixObjectLib || (window.sixObjectLib = {});

    // BEGIN API

    /*
    * Converte un oggetto flat in oggetti innestati. Ad esempio:
    * flat = {
    *   code;
    *   model.code;
    *   model.type;
    *   model.status;
    * }
    *
    * nested = {
    *   code;
    *   model = {
    *     code;
    *     type;
    *     status;
    *   }
    * }
    */
    var flatToNested = function(flat, nested) {
      if(!nested) { nested = {}; }
      for(var key in flat) {
        var splittedKey = key.split('.');
        if(splittedKey.length > 1) {
          var tmp = {};
          tmp[key.substr(key.indexOf('.') + 1)] = flat[key];
          nested[splittedKey[0]] = flatToNested(tmp, nested[splittedKey[0]]);
        }
        else {
          nested[key] = flat[key];
        }
      }
      return nested;
    };

    /**
     * Converte un record nella sua rappresentazione "lookup"/"riferimento"
     *
     * Es:
     * "zonatermica_id": {
         "type": "zonatermica",
         "code": "ancona",
         "description": "Ancona",
         "UUID": "ancona"
      }
     */

    var recordToHisRef = function(obj){
      if(angular.isUndefined(obj) || obj === null) {
        return null;
      }
      var ref = {};
      if (obj.UUID &&
          obj.model.code &&
          //obj.model.description &&
          obj.schemaCode){
          ref.type = obj.schemaCode;
          ref.UUID = obj.UUID;
          ref.code = obj.model.code;
          ref.description = obj.model.description;
      }else{
          console.log('recordToHisRef: WRONG FORMAT. One or more fields missing '+JSON.stringify(obj));
          return null;
      }
      return ref;
    };

   /**
    * Controlla se un oggetto è vuoto. Un oggetto obj è vuoto se:
    * - obj === null
    * - obj === undefined
    * - obj === {}
    * - obj === []
    * @param obj
    * @returns {boolean}
    */
    var isEmpty = function(obj) {
      if(angular.isUndefined(obj) || obj === null || obj === {} || obj === []) {
        return true;
      }
      for(var k in obj) {
        if(obj.hasOwnProperty(k)) {
          return false;
        }
      }
      return true;
    };

    /**
     * Restituisce un array che rappresenta la differenza tra due array.
     * Es: diffArray([1, 2, 3, 4, 5, 6, 7], [3, 2, 1, 4, 5]);    // return [6, 7]
     * @param arr1
     * @param arr2
     */
    function diffArray(arr1, arr2) {
      return arr1.concat(arr2).filter(function (val) {
        if (arr1.includes(val) && !arr2.includes(val))
          return val;
      });
    }

    /**
     * Restituisce un array che rappresenta la differenza simmetrica tra due array.
     * Es: symmetricDiffArray([1, 2, 3, 7], [3, 2, 1, 4, 5]);    // return [7, 4, 5]
     * @param arr1
     * @param arr2
     */
    function symmetricDiffArray(arr1, arr2) {
      return arr1.concat(arr2).filter(function (val) {
        if (!(arr1.includes(val) && arr2.includes(val)))
          return val;
      });
    }

    /**
     * Restituisce un array che rappresenta l'intersezione tra due array.
     * Es: intersectArray([1, 2, 3, 7], [6, 4, 5]);    // return [1, 2, 3, 7, 6, 4, 5]
     * @param arr1
     * @param arr2
     */
    function intersectArray(arr1, arr2) {
      return arr1.concat(arr2).filter(function (val) {
        if (arr1.includes(val) && arr2.includes(val))
          return val;
      });
    }

   /**
    * Restituisce un ID generato con lettere, cifre e caratteri speciali (-_) casuali
    * @param allowDigits: abilita le cifre
    * @param allowBars: abilita i caratteri - e _
    * @returns {string}
    */
    function makeId(allowDigits, allowBars) {
      var text = '';
      allowDigits = angular.isDefined(allowDigits) ? allowDigits : true;
      allowBars = angular.isDefined(allowBars) ? allowBars : true;
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
      if(allowDigits) {
        possible += '0123456789'
      }
      if(allowBars) {
        possible += '-_'
      }

      for( var i=0; i < 10; i++ )
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    }

   /**
    * Restituisce un GUID autogenerato
    * @returns {string}
    */
    function makeGUID() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
    }

    // Aggrega gli elementi dell'array sulla base dell'elenco di proprietà passate come parametro (array di stringhe)
    Array.prototype.groupByProperties = function (properties) {
      var arr = this;
      var groups = [];
      for(var i = 0, len = arr.length; i<len; i+=1){
        var obj = arr[i];
        if(groups.length == 0){
            groups.push([obj]);
        }
        else{
          var equalGroup = false;
          for(var a = 0, glen = groups.length; a<glen;a+=1){
            var group = groups[a];
            var equal = true;
            var firstElement = group[0];
            properties.forEach(function(property){

              if(firstElement[property] instanceof Date && obj[property] instanceof Date) {
                if((firstElement[property]).getTime() !== (obj[property]).getTime()) {
                  equal = false;
                }
              } else if(firstElement[property] !== obj[property]){
                equal = false;
              }

            });
            if(equal){
              equalGroup = group;
            }
          }
          if(equalGroup){
            equalGroup.push(obj);
          }
          else {
            groups.push([obj]);
          }
        }
      }
      return groups;
  }

  function groupArray(flatArray, propertiesArray) {
    return flatArray.groupByProperties(propertiesArray);
  }

    // END API

    // publish external API by extending sixObjectLib
    function publishExternalAPI(sixObjectLib) {
        angular.extend(sixObjectLib, {
            'flatToNested'      : flatToNested,
            'recordToHisRef'    : recordToHisRef,
            'isEmpty'           : isEmpty,
            'diffArray'         : diffArray,
            'symmetricDiffArray': symmetricDiffArray,
            'intersectArray'    : intersectArray,
            'makeId'            : makeId,
            'makeGUID'          : makeGUID,
            'groupArray'        : groupArray
        });
    }

    publishExternalAPI(sixObjectLib);

})(window, document);

(function (window) {
    'use strict';

    // attach sixServiceMessageLib as a property of window
    var sixServiceMessageLib = window.sixServiceMessageLib || (window.sixServiceMessageLib = {});

    // BEGIN API

    var emulateLogServiceMessage = function(msg, success, warning, error, code) {
      var status = success ? 'SUCCESS' : (warning ? 'WARNING' : 'ERROR');
      var message = {
        status: status,
        code: code,
        message: msg,
        success: success,
        warning: warning,
        error: error
      };
      return message;
    };

    var emulateServiceResponse = function(messages) {
      var response = {
        messages: [],
        errors: false,
        warnings: false
      };
      messages.forEach(function(msg) {
        response.messages.push(msg);
        if(msg.error) { response.errors = true; }
        if(msg.warning) { response.warnings = true; }
      });
      return response;
    };

    // END API

    // publish external API by extending sixObjectLib
    function publishExternalAPI(sixServiceMessageLib) {
        angular.extend(sixServiceMessageLib, {
            'emulateLogServiceMessage': emulateLogServiceMessage,
            'emulateServiceResponse': emulateServiceResponse
        });
    }

    publishExternalAPI(sixServiceMessageLib);

})(window, document);

(function (window, document) {
  'use strict';

  // attach sixStringLib as a property of window
  var sixStringLib = window.sixStringLib || (window.sixStringLib = {});

  // BEGIN API

  /*
   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
   */
  var defaultDiacriticsRemovalap = [
    { 'base': 'A', 'letters': '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F' },
    { 'base': 'AA', 'letters': '\uA732' },
    { 'base': 'AE', 'letters': '\u00C6\u01FC\u01E2' },
    { 'base': 'AO', 'letters': '\uA734' },
    { 'base': 'AU', 'letters': '\uA736' },
    { 'base': 'AV', 'letters': '\uA738\uA73A' },
    { 'base': 'AY', 'letters': '\uA73C' },
    { 'base': 'B', 'letters': '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181' },
    { 'base': 'C', 'letters': '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E' },
    { 'base': 'D', 'letters': '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779' },
    { 'base': 'DZ', 'letters': '\u01F1\u01C4' },
    { 'base': 'Dz', 'letters': '\u01F2\u01C5' },
    { 'base': 'E', 'letters': '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E' },
    { 'base': 'F', 'letters': '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B' },
    { 'base': 'G', 'letters': '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E' },
    { 'base': 'H', 'letters': '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D' },
    { 'base': 'I', 'letters': '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197' },
    { 'base': 'J', 'letters': '\u004A\u24BF\uFF2A\u0134\u0248' },
    { 'base': 'K', 'letters': '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2' },
    { 'base': 'L', 'letters': '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780' },
    { 'base': 'LJ', 'letters': '\u01C7' },
    { 'base': 'Lj', 'letters': '\u01C8' },
    { 'base': 'M', 'letters': '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C' },
    { 'base': 'N', 'letters': '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4' },
    { 'base': 'NJ', 'letters': '\u01CA' },
    { 'base': 'Nj', 'letters': '\u01CB' },
    { 'base': 'O', 'letters': '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C' },
    { 'base': 'OI', 'letters': '\u01A2' },
    { 'base': 'OO', 'letters': '\uA74E' },
    { 'base': 'OU', 'letters': '\u0222' },
    { 'base': 'OE', 'letters': '\u008C\u0152' },
    { 'base': 'oe', 'letters': '\u009C\u0153' },
    { 'base': 'P', 'letters': '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754' },
    { 'base': 'Q', 'letters': '\u0051\u24C6\uFF31\uA756\uA758\u024A' },
    { 'base': 'R', 'letters': '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782' },
    { 'base': 'S', 'letters': '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784' },
    { 'base': 'T', 'letters': '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786' },
    { 'base': 'TZ', 'letters': '\uA728' },
    { 'base': 'U', 'letters': '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244' },
    { 'base': 'V', 'letters': '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245' },
    { 'base': 'VY', 'letters': '\uA760' },
    { 'base': 'W', 'letters': '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72' },
    { 'base': 'X', 'letters': '\u0058\u24CD\uFF38\u1E8A\u1E8C' },
    { 'base': 'Y', 'letters': '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE' },
    { 'base': 'Z', 'letters': '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762' },
    { 'base': 'a', 'letters': '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250' },
    { 'base': 'aa', 'letters': '\uA733' },
    { 'base': 'ae', 'letters': '\u00E6\u01FD\u01E3' },
    { 'base': 'ao', 'letters': '\uA735' },
    { 'base': 'au', 'letters': '\uA737' },
    { 'base': 'av', 'letters': '\uA739\uA73B' },
    { 'base': 'ay', 'letters': '\uA73D' },
    { 'base': 'b', 'letters': '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253' },
    { 'base': 'c', 'letters': '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184' },
    { 'base': 'd', 'letters': '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A' },
    { 'base': 'dz', 'letters': '\u01F3\u01C6' },
    { 'base': 'e', 'letters': '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD' },
    { 'base': 'f', 'letters': '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C' },
    { 'base': 'g', 'letters': '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F' },
    { 'base': 'h', 'letters': '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265' },
    { 'base': 'hv', 'letters': '\u0195' },
    { 'base': 'i', 'letters': '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131' },
    { 'base': 'j', 'letters': '\u006A\u24D9\uFF4A\u0135\u01F0\u0249' },
    { 'base': 'k', 'letters': '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3' },
    { 'base': 'l', 'letters': '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747' },
    { 'base': 'lj', 'letters': '\u01C9' },
    { 'base': 'm', 'letters': '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F' },
    { 'base': 'n', 'letters': '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5' },
    { 'base': 'nj', 'letters': '\u01CC' },
    { 'base': 'o', 'letters': '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275' },
    { 'base': 'oi', 'letters': '\u01A3' },
    { 'base': 'ou', 'letters': '\u0223' },
    { 'base': 'oo', 'letters': '\uA74F' },
    { 'base': 'p', 'letters': '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755' },
    { 'base': 'q', 'letters': '\u0071\u24E0\uFF51\u024B\uA757\uA759' },
    { 'base': 'r', 'letters': '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783' },
    { 'base': 's', 'letters': '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B' },
    { 'base': 't', 'letters': '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787' },
    { 'base': 'tz', 'letters': '\uA729' },
    { 'base': 'u', 'letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289' },
    { 'base': 'v', 'letters': '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C' },
    { 'base': 'vy', 'letters': '\uA761' },
    { 'base': 'w', 'letters': '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73' },
    { 'base': 'x', 'letters': '\u0078\u24E7\uFF58\u1E8B\u1E8D' },
    { 'base': 'y', 'letters': '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF' },
    { 'base': 'z', 'letters': '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763' }
  ];

  var diacriticsMap = {};
  for (var i = 0; i < defaultDiacriticsRemovalap.length; i++) {
    var letters = defaultDiacriticsRemovalap[i].letters;
    for (var j = 0; j < letters.length; j++) {
      diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
    }
  }

  // "what?" version ... http://jsperf.com/diacritics/12
  function removeDiacritics(str) {
    return str.replace(/[^\u0000-\u007E]/g, function (a) {
      return diacriticsMap[a] || a;
    });
  }

  // END API

  // publish external API by extending sixDateLib
  function publishExternalAPI(sixStringLib) {
    angular.extend(sixStringLib, {
      'removeDiacritics': removeDiacritics,
      'capitalize': capitalize
    });
  }

  function capitalize(s) {
    return s && s[0].toUpperCase() + s.slice(1);
  }

  publishExternalAPI(sixStringLib);

})(window, document);

'use strict';

/**
 * @ngdoc function
 * @name myNewProjectApp.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the myNewProjectApp
 */
angular.module('ictportal.theme')
  .controller('AppCtrl', function ($scope, $location, $window, $http, authFactory, ENV, $rootScope) {

    $scope.logout = function() {
      authFactory.logout();
      $location.path("/login");
    };

    $scope.app = {
      name: '',
      version: '2.0.0',
      bestemmia:'yes',
      showCommissions: true,
      showNotifications: true,
      // for chart colors
      color: {
        primary: '#7266ba',
        info:    '#23b7e5',
        success: '#27c24c',
        warning: '#fad733',
        danger:  '#f05050',
        light:   '#e8eff0',
        dark:    '#3a3f51',
        black:   '#1c2b36'
      },
      settings: {
        themeID: 1,
        navbarHeaderColor: 'bg-black',
        navbarCollapseColor: 'bg-white-only',
        asideColor: 'bg-black',
        headerFixed: true,
        asideFixed: false,
        asideFolded: false,
        asideDock: false,
        container: false
      },
      notifications:{
        link:"#/notification"
      },
      profileCustomer: false,
      homepage: '/'
    };
    var authData = authFactory.getAuthData();
    $scope.app.touch = authData && authData.options.touch;
    
    $scope.userInfo = function(){
      if(authFactory.isAuthenticated()){
        if (authData.options === undefined) {
          //default
          authData.options = {
            admin: false,
            config: false,
            revokeAdmin: false,
            touch: false
          };
        }
        return authData;
      }else{
        return;
      }
    }; 

    $scope.companyName = function(){
      if(authData && authData.eggs){
        return authData.info.companyName;
      }else{
        return undefined
      }
    }
        
    if(authData && authData.eggs && authData.six){
      document.title = 'SIX';
    }
    if(authData && authData.eggs){
      document.title = 'EGGS';
    }
    if(authData && authData.six){
      document.title = 'SIX';                        
    }

    $scope.profileItems = [
      {
        type: 'commission',
        icon: 'fa fa-money',
        label: 'Commessa'
      }
    ];

    if($scope.app.homepage=='consip'){
      var customer = {
        type: 'customer',
        icon: 'fa fa-user',
        label: 'Cliente'
      };
      $scope.profileItems.push(customer);
    }

    $scope.$watch('app.settings', function(){
      if( $scope.app.settings.asideDock  &&  $scope.app.settings.asideFixed ){
        // aside dock and fixed must set the header fixed.
        $scope.app.settings.headerFixed = true;
      }
      // save to local storage
      //$localStorage.settings = $scope.app.settings;
    }, true);

    // angular translate
    $scope.lang = { isopen: false };
    $scope.langs = {en:'English', de_DE:'German', it_IT:'Italian'};
    //$scope.selectLang = $scope.langs[$translate.proposedLanguage()] || "English";
    $scope.selectLang = "Italian";
    $scope.setLang = function(langKey, $event) {
      // set the current lang
      $scope.selectLang = $scope.langs[langKey];
      // You can change the language during runtime
      //$translate.use(langKey);
      $scope.lang.isopen = !$scope.lang.isopen;
    };

    function isSmartDevice( $window )
    {
      // Adapted from http://www.detectmobilebrowsers.com
      var ua = $window['navigator']['userAgent'] || $window['navigator']['vendor'] || $window['opera'];
      // Checks for iOs, Android, Blackberry, Opera Mini, and Windows mobile devices
      return (/iPhone|iPod|iPad|Silk|Android|BlackBerry|Opera Mini|IEMobile/).test(ua);
    }

    $scope.getPermission = function() {
      if(authFactory.getAuthData()) {
        var permission = authFactory.getAuthData().authPermission;
        return 'ICTUser' === permission || 'ICTAdmin' === permission || 'EMAdmin' === permission
          || 'SuperAdmin' === permission || 'Admin' === permission
          || 'emma-SuperAdmin' === permission || 'asset-SuperAdmin' === permission || 'consip-SuperAdmin' === permission
          || 'emma-Admin' === permission || 'asset-Admin' === permission || 'consip-Admin' === permission;
      }
      return false;
    };

    function loadBowerInfos() {
      $http.get('meta/manifest.json').then(
        function(response) {    // success
          if(!response.status || response.status == 200) {
            $scope.app.version = response.data.version;
          }
        }
      );
    }

    loadBowerInfos();


  });

'use strict';

/* Controllers */
var app = angular.module('ictportal.theme');
  // bootstrap controller
  app.controller('AccordionDemoCtrl', ['$scope', function($scope) {
    $scope.oneAtATime = true;

    $scope.groups = [
      {
        title: 'Accordion group header - #1',
        content: 'Dynamic group body - #1'
      },
      {
        title: 'Accordion group header - #2',
        content: 'Dynamic group body - #2'
      }
    ];

    $scope.items = ['Item 1', 'Item 2', 'Item 3'];

    $scope.addItem = function() {
      var newItemNo = $scope.items.length + 1;
      $scope.items.push('Item ' + newItemNo);
    };

    $scope.status = {
      isFirstOpen: true,
      isFirstDisabled: false
    };
  }])
  ;
  app.controller('AlertDemoCtrl', ['$scope', function($scope) {
    $scope.alerts = [
      { type: 'success', msg: 'Well done! You successfully read this important alert message.' },
      { type: 'info', msg: 'Heads up! This alert needs your attention, but it is not super important.' },
      { type: 'warning', msg: 'Warning! Best check yo self, you are not looking too good...' }
    ];

    $scope.addAlert = function() {
      $scope.alerts.push({type: 'danger', msg: 'Oh snap! Change a few things up and try submitting again.'});
    };

    $scope.closeAlert = function(index) {
      $scope.alerts.splice(index, 1);
    };
  }])
  ;
  app.controller('ButtonsDemoCtrl', ['$scope', function($scope) {
    $scope.singleModel = 1;

    $scope.radioModel = 'Middle';

    $scope.checkModel = {
      left: false,
      middle: true,
      right: false
    };
  }])
  ;
  app.controller('CarouselDemoCtrl', ['$scope', function($scope) {
    $scope.myInterval = 5000;
    var slides = $scope.slides = [];
    $scope.addSlide = function() {
      slides.push({
        image: 'img/c' + slides.length + '.jpg',
        text: ['Carousel text #0','Carousel text #1','Carousel text #2','Carousel text #3'][slides.length % 4]
      });
    };
    for (var i=0; i<4; i++) {
      $scope.addSlide();
    }
  }])
  ;
  app.controller('DropdownDemoCtrl', ['$scope', function($scope) {
    $scope.items = [
      'The first choice!',
      'And another choice for you.',
      'but wait! A third!'
    ];

    $scope.status = {
      isopen: false
    };

    $scope.toggled = function(open) {
      //console.log('Dropdown is now: ', open);
    };

    $scope.toggleDropdown = function($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.status.isopen = !$scope.status.isopen;
    };
  }])
  ;
  app.controller('ModalInstanceCtrl', ['$scope', '$modalInstance', 'items', function($scope, $modalInstance, items) {
    $scope.items = items;
    $scope.selected = {
      item: $scope.items[0]
    };

    $scope.ok = function () {
      $modalInstance.close($scope.selected.item);
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };
  }])
  ;
  app.controller('ModalDemoCtrl', ['$scope', '$modal', '$log', function($scope, $modal, $log) {
    $scope.items = ['item1', 'item2', 'item3'];
    $scope.open = function (size) {
      var modalInstance = $modal.open({
        templateUrl: 'myModalContent.html',
        controller: 'ModalInstanceCtrl',
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });

      modalInstance.result.then(function (selectedItem) {
        $scope.selected = selectedItem;
      }, function () {
        $log.info('Modal dismissed at: ' + new Date());
      });
    };
  }])
  ;
  app.controller('PaginationDemoCtrl', ['$scope', '$log', function($scope, $log) {
    $scope.totalItems = 64;
    $scope.currentPage = 4;

    $scope.setPage = function (pageNo) {
      $scope.currentPage = pageNo;
    };

    $scope.pageChanged = function() {
      $log.info('Page changed to: ' + $scope.currentPage);
    };

    $scope.maxSize = 5;
    $scope.bigTotalItems = 175;
    $scope.bigCurrentPage = 1;
  }])
  ;
  app.controller('PopoverDemoCtrl', ['$scope', function($scope) {
    $scope.dynamicPopover = 'Hello, World!';
    $scope.dynamicPopoverTitle = 'Title';
  }])
  ;
  app.controller('ProgressDemoCtrl', ['$scope', function($scope) {
    $scope.max = 200;

    $scope.random = function() {
      var value = Math.floor((Math.random() * 100) + 1);
      var type;

      if (value < 25) {
        type = 'success';
      } else if (value < 50) {
        type = 'info';
      } else if (value < 75) {
        type = 'warning';
      } else {
        type = 'danger';
      }

      $scope.showWarning = (type === 'danger' || type === 'warning');

      $scope.dynamic = value;
      $scope.type = type;
    };
    $scope.random();

    $scope.randomStacked = function() {
      $scope.stacked = [];
      var types = ['success', 'info', 'warning', 'danger'];

      for (var i = 0, n = Math.floor((Math.random() * 4) + 1); i < n; i++) {
          var index = Math.floor((Math.random() * 4));
          $scope.stacked.push({
            value: Math.floor((Math.random() * 30) + 1),
            type: types[index]
          });
      }
    };
    $scope.randomStacked();
  }])
  ;
  app.controller('TabsDemoCtrl', ['$scope', function($scope) {
    $scope.tabs = [
      { title:'Dynamic Title 1', content:'Dynamic content 1' },
      { title:'Dynamic Title 2', content:'Dynamic content 2', disabled: true }
    ];
  }])
  ;
  app.controller('RatingDemoCtrl', ['$scope', function($scope) {
    $scope.rate = 7;
    $scope.max = 10;
    $scope.isReadonly = false;

    $scope.hoveringOver = function(value) {
      $scope.overStar = value;
      $scope.percent = 100 * (value / $scope.max);
    };
  }])
  ;
  app.controller('TooltipDemoCtrl', ['$scope', function($scope) {
    $scope.dynamicTooltip = 'Hello, World!';
    $scope.dynamicTooltipText = 'dynamic';
    $scope.htmlTooltip = 'I\'ve been made <b>bold</b>!';
  }])
  ;
  app.controller('TypeaheadDemoCtrl', ['$scope', '$http', function($scope, $http) {
    $scope.selected = undefined;
    $scope.states = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Dakota', 'North Carolina', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
    // Any function returning a promise object can be used to load values asynchronously
    $scope.getLocation = function(val) {
      return $http.get('http://maps.googleapis.com/maps/api/geocode/json', {
        params: {
          address: val,
          sensor: false
        }
      }).then(function(res){
        var addresses = [];
        angular.forEach(res.data.results, function(item){
          addresses.push(item.formatted_address);
        });
        return addresses;
      });
    };
  }])
  ;
  app.controller('DatepickerDemoCtrl', ['$scope', function($scope) {
    $scope.today = function() {
      $scope.dt = new Date();
    };
    $scope.today();

    $scope.clear = function () {
      $scope.dt = null;
    };

    // Disable weekend selection
    $scope.disabled = function(date, mode) {
      return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
    };

    $scope.toggleMin = function() {
      $scope.minDate = $scope.minDate ? null : new Date();
    };
    $scope.toggleMin();

    $scope.open = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.opened = true;
    };

    $scope.dateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      class: 'datepicker'
    };

    $scope.initDate = new Date('2016-15-20');
    $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    $scope.format = $scope.formats[0];
  }])
  ;
  app.controller('TimepickerDemoCtrl', ['$scope', function($scope) {
    $scope.mytime = new Date();

    $scope.hstep = 1;
    $scope.mstep = 15;

    $scope.options = {
      hstep: [1, 2, 3],
      mstep: [1, 5, 10, 15, 25, 30]
    };

    $scope.ismeridian = true;
    $scope.toggleMode = function() {
      $scope.ismeridian = ! $scope.ismeridian;
    };

    $scope.update = function() {
      var d = new Date();
      d.setHours( 14 );
      d.setMinutes( 0 );
      $scope.mytime = d;
    };

    $scope.changed = function () {
      //console.log('Time changed to: ' + $scope.mytime);
    };

    $scope.clear = function() {
      $scope.mytime = null;
    };
  }]);

'use strict';

/**
 * @ngdoc function
 * @name myNewProjectApp.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the myNewProjectApp
 */
angular.module('ictportal.theme')
  .controller('MainCtrl', function ($scope, $location, $log, authFactory, EGGS_URL, $sce) {

    $scope.needSSO = authFactory.getAuthData() && authFactory.getAuthData().info && authFactory.getAuthData().info.config ? authFactory.getAuthData().info.config.needSSO : false;

    $scope.EggsURL = $sce.trustAsResourceUrl(EGGS_URL + '/FirstS');

  });

'use strict';

/**
 * @ngdoc function
 * @author Rita Beltrami 29/04/2016
 * @name emma.theme.controller:NoticeCtrl
 * @description
 * # NotificationCtrl
 * Controller to display notifications.
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/notification', {
            templateUrl: 'theme/notification/notification_list.html',
            controller: 'NotificationCtrl'
        })
        .when('/notification/:id', {
            templateUrl: 'theme/notification/notification_detail.html',
            controller: 'NotificationCtrl'
        })
  })
  .controller('NotificationCtrl', function ($scope, $log, notificationFactory, $routeParams, $location) {
        $scope.notifications;
        $scope.data;
        $scope.currentPage = 1;
        $scope.pageSize = 10;
        $scope.ISSUE_INDEX = "six_issue";
        $scope.ODL_INDEX = "six_odl";

        function setBodyText(notification){
            var model = notification.model;
            if(angular.isDefined(model)){
                var bodyHtml = model.body;
                if(angular.isDefined(bodyHtml)){
                    bodyHtml = "<div>" + bodyHtml + "</div>";
                    var bodyText = $(bodyHtml).text();
                    model.bodyAsText = bodyText;
                }
            }
        }

        function setColor(notification){
            var model = notification.model;
            if(angular.isDefined(model) && angular.isDefined(model.record_id)){
                if(angular.isUndefined(model.record_id.index)){
                    notification.color = 'b-l-light';
                }
                else{
                    var index = ""; index = model.record_id.index;
                    if(angular.equals(index, $scope.ISSUE_INDEX)){
                        notification.color = 'b-l-primary';
                    }
                    else if(angular.equals(index, $scope.ODL_INDEX)){
                        notification.color = 'b-l-warning';
                    }
                }
            }
        }

        function setHref(notification){
            notification.href = "#/notification/" + notification.version;
        }

        $scope.getNotificationsList = function() {
            if($scope.app.homepage=='asset'){
                var payload = {
                    page: $scope.currentPage,
                    pageSize: $scope.pageSize
                };
                notificationFactory().getList(payload)
                    .$promise.then(function(data) {
                        $log.info(data);
                        $scope.data = data;
                        $scope.notifications = data.list;
                        for(var i=0; i<$scope.notifications.length; i++){
                            var notification = $scope.notifications[i];
                            setBodyText(notification);
                            setColor(notification);
                            setHref(notification);
                        }
                });
            }
        }

        $scope.getNotificationById = function(id) {
            var payload = {
                id: id
            };
            notificationFactory().getEmailById(payload)
                .$promise.then(function(data) {
                    $log.info(data);
                    $scope.notification = data.email;
            });
        }

        $scope.goToIssue = function(){
            $location.path('issue/' + $scope.notification.model.record_id.UUID);
        }

        $scope.goToOdl = function(){
            $location.path('odl/' + $scope.notification.model.record_id.UUID);
        }

        $scope.goToWysiwyg = function(){
            $location.path('wysiwyg');
        }

        $scope.pageChanged = function () {
            $scope.getNotificationsList();
        };

        //__main__
        if($routeParams.id) {
            $scope.getNotificationById($routeParams.id);
        }else {
            $scope.getNotificationsList();
        }
  });

'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:WysiwygCtrl
 * @description
 * # WysiwygCtrl
 * Controller of the emma.theme
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/wysiwyg', {
            templateUrl: 'theme/wysiwyg.html',
            controller: 'WysiwygCtrl'
        })
  })
  .controller('WysiwygCtrl', function ($scope) {
      /*
    $scope.receiver = "no-reply@ict-group.it";

    $scope.title = "Titolo di esempio";

    $scope.message = "<p style=\"text-align: center;\">" +
                    " <img title=\"TinyMCE Logo\" src=\"//www.tinymce.com/images/glyph-tinymce@2x.png\" alt=\"TinyMCE Logo\" width=\"110\" height=\"97\" />" +
                    "</p>" +
                    "<h1 style=\"text-align: center;\">Welcome to the TinyMCE editor demo!</h1>"+
                    "<h2>Got questions or need help?</h2>" +
                    "<ul>" +
                        "<li>Our <a href=\"http://www.tinymce.com/docs/\">documentation</a> is a great resource for learning how to configure TinyMCE.</li>" +
                        "<li>Have a specific question? Visit the <a href=\"http://community.tinymce.com/forum/\">Community Forum</a>.</li> "+
                        "<li>We also offer enterprise grade support as part of <a href=\"www.tinymce.com/pricing\">TinyMCE Enterprise</a>.</li>" +
                    "</ul>";

    $scope.initTinyMce = function(){
        tinymce.init({
            selector: 'textarea',
            theme: 'modern',
            width: 600,
            height: 300,
            plugins: [
                'advlist autolink link image lists charmap print preview hr anchor pagebreak',
                'searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime nonbreaking',
                'save table contextmenu directionality template paste textcolor'
            ],
            content_css: [
                '//www.tinymce.com/css/codepen.min.css'
            ],
            toolbar: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link | print preview fullpage | forecolor backcolor',
            menu: {
                file: {title: 'File', items: 'print'},
                edit: {title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall'},
                insert: {title: 'Insert', items: 'link hr'},
                view: {title: 'View', items: 'preview'},
                format: {title: 'Format', items: 'bold italic underline strikethrough superscript subscript | formats'},
                table: {title: 'Table', items: 'inserttable tableprops deletetable | cell row column'},
                tools: {title: 'Tools', items: 'spellchecker code'}
            },
            language_url : '/resources/tinymce/languages/it.js',
            language: 'it'
        });
    }

    $scope.save = function(){

    }

    $scope.sendEmail = function(){

    }

    $scope.initTinyMce();
  */

  });

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:EggsCtrl
 * @description
 * # EggsCtrl
 * Controller of the sixEmmaApp
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/eggs/:id', {
          templateUrl: 'theme/eggs/eggs.html',
          controller: 'EggsCtrl',
          controllerAs: 'eggs'
        })
  })
  .controller('EggsCtrl', function ($scope, $http, $sce, $routeParams, $timeout, $location, authFactory, APP_URL, $rootScope) {
    var MAX_HISTORY = 5;
    var authData = authFactory.getAuthData();
    $scope.functionHistory = [];
    $scope.debug = false;
    $scope.function = {
      //action: '150.350.100'
      action: $routeParams.id
    };
    $scope.EggsURL = $sce.trustAsResourceUrl(APP_URL + '/FirstS');

    function getHistory(){
      if (authData && angular.isDefined(authData.info) && angular.isDefined(authData.info.history)){
        //se viene ricaricato il browser recupero l'history
        authData.info.history.forEach(function(item){
          var found = false;
          var i=0
          for(; i<$scope.functionHistory.length; i++){
            if($scope.functionHistory[i].route===item.route){
              found = true;
              break;
            }
          }
          if(found){
            $scope.functionHistory = $scope.functionHistory.splice(i,0);
          }
          $scope.functionHistory.push(item);
        });
        $scope.functionHistory.length = MAX_HISTORY;
  
        $scope.extern = [];
        $scope.functionHistory.forEach(function(item){
          if(item.route.indexOf('ext') !== -1){
            $scope.extern.push({
              id: item.$$hashKey,
              route: item.route
            });
          }
        });
      };
    };

    $scope.changeRoute = function(item){
      var tokens = item.route.split("ext");
      if(tokens.length===1){
        $location.url( '/' + item.route);
      }
      else{
        var el = angular.element(document.getElementById(item.$$hashKey));
        window.location.href = el[0].href;
      }
    };

    $scope.submit = function() {
      var action = document.getElementById("action");
      action.value = $scope.function.action;
        var el = document.getElementById("submit");
        el.click();
        $location.search({loaded: 'true'});
      };

    $scope.$on('eggsEvent', function() {
          $scope.submit();
          $location.search({loaded: 'true'});
    });

    function init(){
      getHistory();
      $scope.submit();
    };

    init();
  
  });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.controller:ExtCtrl
 * @ExtCtrl
 * # JsfctrlCtrl
 * Controller of the ictportal
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/ext', {
          templateUrl: 'theme/ext/ext.html',
          controller: 'ExtCtrl'
        })
  })
  .controller('ExtCtrl', function (APP_URL, $scope, $log, authFactory, $routeParams, $location, HISTORY) {
    var MAX_HISTORY = 5;
    var authData = authFactory.getAuthData();
    $scope.showHistory = HISTORY;
    $scope.functionHistory = [];
    if (angular.isDefined(authData.info) && angular.isDefined(authData.info.history)){
      //se viene ricaricato il browser recupero l'history
      authData.info.history.forEach(function(item){
        var found = false;
        var i=0
        for(; i<$scope.functionHistory.length; i++){
          if($scope.functionHistory[i].route===item.route){
            found = true;
            break;
          }
        }
        if(found){
          $scope.functionHistory = $scope.functionHistory.splice(i,0);
        }
        $scope.functionHistory.push(item);
      });
      $scope.functionHistory.length = MAX_HISTORY;

      $scope.extern = [];
      $scope.functionHistory.forEach(function(item){
        if(item.route.indexOf('ext') !== -1){
          $scope.extern.push({
            id: item.$$hashKey,
            route: item.route
          });
        }
      });
    };

    $scope.changeRoute = function(item){
      var tokens = item.route.split("ext");
      if(tokens.length===1){
        $location.path( '/' + item.route);
      }
      else{
        var el = angular.element(document.getElementById(item.$$hashKey));
        window.location.href = el[0].href;
      }
    };

    function random(seed) {
      var x = Math.sin(seed) * 10000;
      return x - Math.floor(x);
    }
    function pseudoguid(){
      return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0,3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
    }
    function S4(seed) {
      if (!seed) seed = (new Date()).getSeconds();
      return (((1+random(seed))*0x10000)|0).toString(16).substring(1);
    }
    $scope.getExtURL = function () {
        if (authFactory.getAuthData() == null)
        {
            console.log('JsfCtrl auth data null');
            return '';
        }
        return $routeParams.url;
      };
  });


'use strict';

/**
 * @ngdoc directive
 * @name myNewProjectApp.directive:back
 * @description
 * # back
 */
angular.module('ictportal.theme')
  .directive('back', function($window) {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                elem.bind('click', function () {
                    $window.history.back();
                });
            }
        };
    });

'use strict';

/**
 * @ngdoc directive
 * @name myNewProjectApp.directive:confirmClick
 * @description
 * # confirmClick
 * A generic confirmation for risky actions.
 * Usage: Add attributes:
 * * ng-confirm-message="Are you sure?"
 * * ng-confirm-click="takeAction()" function
 * * ng-confirm-condition="mustBeEvaluatedToTrueForTheConfirmBoxBeShown" expression
 */
angular.module('ictportal.theme')
  .directive('ngConfirmClick', function () {
    return {
		restrict: 'A',
		link: function(scope, element, attrs) {
			element.bind('click', function() {
				var condition = scope.$eval(attrs.ngConfirmCondition);
				if(condition){
					var message = attrs.ngConfirmMessage;
					if (message && confirm(message)) {
						scope.$apply(attrs.ngConfirmClick);
					}
				}
				else{
					scope.$apply(attrs.ngConfirmClick);
				}
			});
		}
	}
  });

/**
 * Created by stefano on 15/12/16.
 */

angular.module('ictportal.theme').directive("dateValidation", function($log, $q) {
  return {
    restrict: "A",
    replace: false,
    require: "ngModel",

    link: function ($scope, $element, $attrs, ctrl) {
      ctrl.$parsers.unshift(checkDate);
      ctrl.$formatters.unshift(checkDate);

      function checkDate(value) {
        var valid = angular.isDate(value);
        $log.log(valid);
        if(valid) {
          ctrl.$setValidity('date', true);
        } else {
          ctrl.$setValidity('date', false);
        }
        return value;
      }

      ctrl.$validators.temporal = function(modelValue, viewValue) {
        var valid = true;
        if($attrs.isBefore) {
          var beforeDate = new Date($attrs.isBefore.replace(/"/g, ''));
          if(angular.isDate(beforeDate)) {
            valid = valid && (modelValue.getTime() <= beforeDate.getTime());
          }
        }
        if($attrs.isAfter) {
          var afterDate = new Date($attrs.isAfter.replace(/"/g, ''));
          if(angular.isDate(afterDate)) {
            valid = valid && (modelValue.getTime() >= afterDate.getTime());
          }
        }
        return valid;
      };
    }
  };
});

angular.module('ictportal.theme')
  .directive('setNgAnimate', ['$animate', function ($animate) {
    return {
        link: function ($scope, $element, $attrs) {
            $scope.$watch( function() {
                return $scope.$eval($attrs.setNgAnimate, $scope);
            }, function(valnew, valold){
                $animate.enabled(!!valnew, $element);
            });
        }
    };
  }]);

'use strict';

angular.module('ictportal.theme').directive('sixAttachments', ['$log', '$window', function($log, $window) {
  return {
    template: '<iframe ng-src="{{ url | trustAsResourceUrl }}" width="100%" height="1024px" style="border: none;"></iframe>',
    restrict: 'E',
    controller: function($scope) {
      var BASE = '/six/app/#/statix?path=';
      $scope.url = '';
      refreshUrl($scope.path);
      console.log($scope.path);
      console.log($scope.url);

      $scope.$watch(function() { return $scope.path; }, function(newVal, oldVal) {
        refreshUrl($scope.path);
        $log.log($scope.url);
      });

      function refreshUrl (path) {
        $scope.url = BASE+path;
      }
    },
    /*link: function(scope, element, attrs) {
      element.on('load', function(){
        // var iFrameHeight = element[0].contentWindow.document.body.scrollHeight + 'px';
        var iFrameHeight = $window.innerHeight + 'px';
        var iFrameWidth = '100%';
        element.css('width', iFrameWidth);
        element.css('height', iFrameHeight);
        $log.log('iFrameHeight = ' + iFrameHeight);
        $log.log('iFrameWidth = ' + iFrameWidth);
      })
    },*/
    scope: {
      path: '='
    }
  }
}])

'use strict';

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixSelect
 * @description
 * # sixSelect
 */
angular.module('ictportal.theme')
  .directive('sixConsipTimingLed', function () {
    return {
      template:
        '<i class="fa fa-circle text-muted m-r-xs m-l-sm" ng-if="sxValue==0" ng-attr-title="{{sxDescription}}"></i>' +
        '<i class="fa fa-circle text-success m-r-xs m-l-sm" ng-if="sxValue==1" ng-attr-title="{{sxDescription}}"></i>' +
        '<i class="fa fa-circle text-warning m-r-xs m-l-sm" ng-if="sxValue==2" ng-attr-title="{{sxDescription}}"></i>' +
        '<i class="fa fa-circle text-danger m-r-xs m-l-sm" ng-if="sxValue==3" ng-attr-title="{{sxDescription}}"></i>',
      restrict: 'E',
      scope: {
        sxValue: '=',
        sxDescription: '=?'
      }
    };
  });

'use strict';

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixCopy
 * @description
 * # sixcopy
 *
 * Parametri della iteratorCopy:
 * scKey: campo per il binding
 * scDuplicate: destinazioni dove copiare i valori dalla 'key'
 * scModel: modello alla quale agganciare la $watch
 * scDoc: variabile contenente il documento dove andare a copiare il valore di destinazione -> bisogna specificare in value.copyTo l'indirizzo completo
 *
 */


angular.module('ictportal.theme')
  .directive('sixCopy', function () {
    return {
      template: '<div></div>',
      scope: {
        scKey: '=',
        scDuplicate: '=',
        scModel: '=',
        scDoc: '='
      },
      restrict: 'E',
      link: function postLink(scope, log, element, attrs) {

        Object.navDocByString = function(o, s) {
          s = s.replace(/\[(\w+)\]/g, '.$1');
          s = s.replace(/^\./, '');
          var a = s.split('.');
          for (var i = 0, n = a.length - 1; i < n; ++i) {
            var k = a[i];
            if (k in o) {
              o = o[k];
            } else {
              return;
            }
          }
          return o;
        };

        function fieldToFill (path) {
          var a = path.split('.');
          var fieldToFill = a[a.length - 1];
          return fieldToFill;
        }

        scope.$watch(function(){return scope.scModel[scope.scKey];}, function() {
          if(angular.isDefined(scope.scModel[scope.scKey])){
            if(angular.isDefined(scope.scDuplicate)){
              angular.forEach(scope.scDuplicate, function(value){
                Object.navDocByString(scope.scDoc, value)[fieldToFill(value)] = scope.scModel[scope.scKey];
              });
            }
          }
        });
      }
    };
  });

'use strict';

/*

 http://bl.ocks.org/dbuezas/9306799
 */

angular.module('ictportal.theme').controller('sixDonutChartCtrl',
    ['$scope', '$log',


      function ($scope, $log) {

        $scope.sxXAxisFormat = $scope.sxXAxisFormat || '%B';
        $scope.sxXAxisTicks = $scope.sxXAxisTicks || undefined;
        $scope.sxInterpolate = $scope.sxInterpolate || 'monotone';
        $scope.sxShowPoints = $scope.sxShowPoints || false;
        $scope.sxChartType = $scope.sxChartType || 'line';
        $scope.sxChartWidth = $scope.sxChartWidth || 460;
        $scope.sxChartHeight = $scope.sxChartHeight || 300;


        $scope.showGraph = function(){

            var donutSelector = '#donutGraph'+$scope.sxId;

            if (!document.getElementById('donutGraph'+$scope.sxId))
            {
                console.log(donutSelector+' still undefined'); //se viene invocata troppo presto
                return;
            }

          var svg = d3.select(donutSelector)
              .append("svg")
              .append("g");
         $scope.svg = svg;
          svg.append("g")
              .attr("class", "slices");
          svg.append("g")
              .attr("class", "labels");
          svg.append("g")
              .attr("class", "lines");

          var width = $scope.sxChartWidth,
              height = $scope.sxChartHeight,
              radius = Math.min(width, height) / 2;
            $scope.radius = radius;

          var pie = d3.layout.pie()
              .sort(null)
              .value(function(d) {
                return d.value;
              });
            $scope.pie= pie;
          var arc = d3.svg.arc()
              .outerRadius(radius * 0.8)
              .innerRadius(radius * 0.4);

            $scope.arc = arc;
          var outerArc = d3.svg.arc()
              .innerRadius(radius * 0.9)
              .outerRadius(radius * 0.9);
            $scope.outerArc = outerArc;
          svg.attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

          var key = function(d){ return d.data.label; };
        $scope.key = key;
          var color = d3.scale.ordinal()
              .domain(["Metano", "Elettricità", "Gpl", "Gasolio", "Totale", "elit", "sed", "do", "eiusmod", "tempor", "incididunt"])
              .range(["#98abc5", "#8a89a6", "#7b6888", "#6b486b", "#e4eaec", "#d0743c", "#ff8c00"]);
        $scope.color = color;

          function randomData (){
            var labels = color.domain();
            return labels.map(function(label){
              return { label: label, value: Math.random() }
            });
          }

          $scope.change($scope.sxGraphData);

          d3.select(".randomize")
              .on("click", function(){
                $scope.change(randomData());
              });
        };

          $scope.change = function (data) {

              /* ------- PIE SLICES -------*/
              var slice = $scope.svg.select(".slices").selectAll("path.slice")
                  .data($scope.pie(data), $scope.key);

              slice.enter()
                  .insert("path")
                  .style("fill", function(d) {
                      var sliceColor = $scope.color(d.data.label);
                      if(angular.isDefined(d.data.color)){
                        sliceColor = d.data.color;
                      }
                      return sliceColor;//$scope.color(d.data.label);
                    })
                  .attr("class", "slice");

              slice
                  .transition().duration(1000)
                  .attrTween("d", function(d) {
                      this._current = this._current || d;
                      var interpolate = d3.interpolate(this._current, d);
                      this._current = interpolate(0);
                      return function(t) {
                          return $scope.arc(interpolate(t));
                      };
                  });

              slice.exit()
                  .remove();

              /* ------- TEXT LABELS -------*/

              var text = $scope.svg.select(".labels").selectAll("text")
                  .data($scope.pie(data), $scope.key);

              text.enter()
                  .append("text")
                  .attr("dy", ".35em")
                  .text(function(d) {
                      return d.data.label;
                  });

              function midAngle(d){
                  return d.startAngle + (d.endAngle - d.startAngle)/2;
              }


              text.transition().duration(1000)
                  .attrTween("transform", function(d) {
                      this._current = this._current || d;
                      var interpolate = d3.interpolate(this._current, d);
                      this._current = interpolate(0);
                      return function(t) {
                          var d2 = interpolate(t);
                          var pos = $scope.outerArc.centroid(d2);
                          pos[0] = $scope.radius * (midAngle(d2) < Math.PI ? 1 : -1);
                          return "translate("+ pos +")";
                      };
                  })
                  .styleTween("text-anchor", function(d){
                      this._current = this._current || d;
                      var interpolate = d3.interpolate(this._current, d);
                      this._current = interpolate(0);
                      return function(t) {
                          var d2 = interpolate(t);
                          return midAngle(d2) < Math.PI ? "start":"end";
                      };
                  });

              text.exit()
                  .remove();

              /* ------- SLICE TO TEXT POLYLINES -------*/

              var polyline = $scope.svg.select(".lines").selectAll("polyline")
                  .data($scope.pie(data), $scope.key);

              polyline.enter()
                  .append("polyline");

              polyline.transition().duration(1000)
                  .attrTween("points", function(d){
                      this._current = this._current || d;
                      var interpolate = d3.interpolate(this._current, d);
                      this._current = interpolate(0);
                      return function(t) {
                          var d2 = interpolate(t);
                          var pos = $scope.outerArc.centroid(d2);
                          pos[0] = $scope.radius * 0.95 * (midAngle(d2) < Math.PI ? 1 : -1);
                          return [$scope.arc.centroid(d2), $scope.outerArc.centroid(d2), pos];
                      };
                  });

              polyline.exit()
                  .remove();

              $scope.showing = true;
          };



      $scope.showing = false;
        $scope.$watchCollection(
            function(scope) {
                return scope.sxGraphData.concat([scope.sxXAxisFormat, scope.sxXAxisTicks, scope.sxInterpolate, scope.sxShowPoints, scope.sxChartType])
            },
          function(newValue, oldValue) {
              if(newValue!=oldValue){
                if ($scope.showing){
                    $scope.change($scope.sxGraphData);
                }else {

                    setTimeout(function() {
                        $scope.showGraph();
                    }, 50);
                }
              }
          }
        );


      }
    ]
);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixMultiSeriesLineChart
 * @description
 * # sixMultiSeriesLineChart
 */
angular.module('ictportal.theme')
  .directive('sixDonutChart', ['$log', function ($log) {
    return {
      template:
      '<style>'+
      'svg {'+
        'width: 100%;'+
        'height: 100%;'+
        '}'+
      'path.slice{'+
        'stroke-width:2px;'+
        '}'+
      'polyline{'+
        'opacity: .3;'+
        'stroke: black;'+
        'stroke-width: 2px;'+
        '  fill: none;'+
        '}'+
        '</style>'+
      '<div id="donutGraph{{sxId}}" class="six-donut-chart-area"></div>',
      restrict: 'E',
      scope: {
        sxGraphData: '=',
        sxId: '=?', //da usare se si vogliono mettere più grafici! style="height:300px; width:460px"
        sxYAxisLegend: '=?',
        sxXAxisFormat: '=?',
        sxXAxisTicks: '=?',
        sxHideToolbar: '=?',
        sxGraphTitle: '=?',
        sxSeriesColors: '=?',
        sxShowPoints: '=?',
        sxInterpolate: '=?', // basis (default), linear , step-after, etc... http://www.d3noob.org/2013/01/smoothing-out-lines-in-d3js.html
        sxChartType: '=?', // line, bar
        sxChartWidth: '=?',
        sxChartHeight: '=?'
      },
      controller: 'sixDonutChartCtrl'
    };
  }]);

'use strict';


angular.module('ictportal.theme').controller('sixFormulaCtrl',
  ['$scope', '$log', 'formulaFactory',
    function ($scope, $log, formulaFactory) {

      var UPDATE_EVT = 'UPDATE_FORMULA';

      $log.log('--- sixformula --- ' + $scope.formulaId);

      $scope.itemSelected = '';
      $scope.output = null;

      $scope.getListWrapper = function () {
        formulaFactory.getFormulasList({query: $scope.queryParam}).$promise.then(function(data) {
          $scope.listWrapper = data;
        });
      };

      $scope.getFormula = function () {
        formulaFactory.getFormulaById({id: $scope.formulaId}).$promise.then(function (data) {
          $scope.itemSelected = data.formula;
          $scope.calculate();
        });
      };

      $scope.calculate = function() {
        var obj = {
          formula: $scope.itemSelected,
          value: $scope.params
        };
        formulaFactory.getCalculationResult(obj).$promise.then(function(data) {
          $scope.output = data.result;
          if($scope.fieldType === 'number') {
            $scope.ngModel = parseFloat($scope.output);
          }
          else if($scope.fieldType === 'integer') {
            $scope.ngModel = parseInt($scope.output);
          }
          else {
            $scope.ngModel = $scope.output;
          }
          console.log($scope.output);
        });
      };

      $scope.$on(UPDATE_EVT, function(newVal, oldVal) {
        $scope.calculate();
      });

      $scope.$watch(function() {return $scope.params;}, function(newVal, oldVal) {
        $scope.$broadcast(UPDATE_EVT);
      });

      $scope.getFormula();
    }
  ]
);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixLookup
 * @description
 * # sixLookup
 */
angular.module('ictportal.theme')
  .directive('sixFormula', ['$log','formulaFactory', function ($log, formulaFactory) {
    return {
      template: "<div class=\"form-group\" ng-class=\"{'has-error': hasError()}\">" +
          "<div class=\"input-group has-button\" style=\"width: 100%\">" +
            "<span class=\"input-group-addon\" ng-if=\"fieldAddonLeft\">{{fieldAddonLeft}}</span>" +
            "<input type=\"text\" class=\"form-control\" ng-model=\"ngModel\" readonly>" +
            "<span class=\"input-group-addon\" ng-if=\"fieldAddonRight\">{{fieldAddonRight}}</span>" +
          "</div>" +
          "<div ng-if=\"showDebug === 'true'\">" +
            "<input type=\"checkbox\" ng-model=\"sxDebug\"><span style=\"font-size:smaller;color:lightslategray\">debug</span></input>" +
            "<div ng-if=\"sxDebug\" style=\"font-size:smaller; color:lightslategray\">" +
              "model: {{ngModel}}<br/>" +
              "type: {{sxType}}<br/>" +
              "list: {{list}}<br/>" +
              "object: {{object}}" +
            "</div>" +
          "</div>" +
        "</div>",
      restrict: 'E',
      scope: {
        ngModel: '=',
        params: '=?',
        formulaId: '=',
        fieldType: '=',
        fieldAddonLeft: '=?',
        fieldAddonRight: '=?'
      },
      controller: 'sixFormulaCtrl'
    };
  }]);

'use strict';

angular.module('ictportal.theme')
.directive('sixIframe', function () {
    return {

        template: '<iframe ng-src="{{$ctrl.url | trustAsResourceUrl}}" width="{{$ctrl.sxWidth}}" height="{{$ctrl.sxHeight}}" scrolling="{{$ctrl.sxScroll}}" frameborder="{{$ctrl.sxFrameborder}}"><iframe>',

        transclude: false,
        bindToController: {
            sxUrl: '@',     //url non string
            sxParams: '<?', // string -> "key:value, key:value" oppure un json {'key':'value', 'key':'value'}
            sxReport: '=?', // string --> nome del report es "production/modXM1122.rptdesign"
            sxWidth: '=?', //string
            sxHeight: '=?', //string
            sxScroll: '=?', //string
            sxFrameborder: '=?', //string
        },
        controller: 'sixIframeController',
        controllerAs: '$ctrl'
    };
})

.controller('sixIframeController', function ($scope, $q, $location, matrixParFactory, authFactory) {

    if(this.sxReport == undefined){throw new Error('sx-report can\'t be undefined')}  
    this.sxUrl = this.sxUrl || "ips/frameset";
    this.sxWidth = this.sxWidth ? this.sxWidth : '100%';
    this.sxHeight = this.sxHeight ? this.sxHeight : '100%';
    this.sxScroll = this.sxScroll ? this.sxScroll : 'no';
    this.sxFrameborder = this.sxFrameborder ? this.sxFrameborder : '0';
    // Se non ho definito l'host lo attacco
    var url = (this.sxUrl.indexOf('http') >= 0) ? this.sixUrl : ($location.protocol() + '://'+ $location.host() +':'+  $location.port() + '/' + this.sxUrl);
    var url = (url.indexOf('?') >= 0) ? url : url + '?';
    
    var authData = authFactory.getAuthData();
    var azCod = authData.info.azCod;
    var divCod = authData.info.divCod;

    var promises = {
        baseBirtReport: getBirtReportBase(azCod, divCod),
        defualtParamsBirtReport: getBirtReportDefaultParams(azCod, divCod)
    };

    // Valuto le risposte
    $q.all(promises).then(function (responses) {
        var urlParams = "__report=" + responses.baseBirtReport + $scope.$ctrl.sxReport + responses.defualtParamsBirtReport + "&";
        url = url + urlParams;
        if($scope.$ctrl.sxParams){
            if (typeof $scope.$ctrl.sxParams === 'string' ){
                var params = $scope.$ctrl.sxParams.split(",");
            
                params.forEach(function (par) {
                    var key = (par.substring(0, par.indexOf(':'))).trim();
                    var value = (par.substring((par.indexOf(':')+1), par.length)).trim();
                    url += key + '=' + value + '&';
                });
            }else{
                var tokens = [];
                for(var key in $scope.$ctrl.sxParams) {
                    tokens.push(key + '=' + $scope.$ctrl.sxParams[key]);
                }
                /*$scope.$ctrl.sxParams.forEach(function(param){
                    var key = Object.keys(param)[0];
                    tokens.push(key + '=' + param[key]);
                });*/
                url += tokens.join('&');
            }
            $scope.$ctrl.url = url;
        }
        else{
            $scope.$ctrl.url = this.sxUrl
        }
    });
        
    function getBirtReportBase(azCod, divCod) {
        var deferred = $q.defer();

        matrixParFactory.getValueOrDefault({key: 'birt.report.base', d1: azCod, d2: divCod, d3: '*', d4: '*', d5: '*'}, {defaultValue: "/reports"}).$promise.then(function(data){
            deferred.resolve(data.result.value);
        });

        return deferred.promise;
    }

    function getBirtReportDefaultParams(azCod, divCod) {
        var deferred = $q.defer();

        matrixParFactory.getValueOrDefault({key: 'birt.report.defaultParams', d1: azCod, d2: divCod, d3: '*', d4: '*', d5: '*'}, {defaultValue: "&__format=PDF"}).$promise.then(function(data){
            deferred.resolve(data.result.value);
        });

        return deferred.promise;
    }
    
})

'use strict';

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixiterator
 * @description
 * # sixiterator
 *
 * Parametri della iteratorCopy:
 * siAttribute: stringa con il nome del campo da cercare nello schema
 * siSchema: schema
 * siModel: variabile alla quale agganciare la $watch
 * siDoc: variabile contenente il documento dove andare a copiare il valore di destinazione -> bisogna specificare in value.copyTo l'indirizzo completo
 * key: campo per il binding
 * value.copyTo[]: destinazioni dove copiare i valori dalla 'key'
 *
 */


angular.module('ictportal.theme')
  .directive('sixIteratorCopy', function () {
    return {
      template: '<div ng-repeat="(key, value) in fieldsToCopy">' +
                    '<six-copy sc-model="siModel" sc-key="key" sc-duplicate="value.copyTo" sc-doc="siDoc"></six-copy>' +
                '</div>',
      restrict: 'E',
      scope: {
        siSchema: '=',
        siAttribute: '=',
        siModel: '=',
        siDoc: '='
      },
      link: function postLink(scope, element, attrs) {
        scope.fieldsToCopy = {};

        scope.$watch('siSchema', function () {
          if(angular.isDefined(scope.siSchema)){
            angular.forEach(scope.siSchema.properties, function (p, pKey){
              if(angular.isDefined(p[scope.siAttribute])){
                scope.fieldsToCopy[pKey] = scope.siSchema.properties[pKey];
              }
            });
          }
        });
      }
    };
  });

'use strict';

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixSelect
 * @description
 * # sixSelect
 */
angular.module('ictportal.theme')
  .directive('sixLoadingPlaceHolder', function () {
    return {
      template:
        '<div ng-if="sxModel.show" style="height:{{sxHeight}}">'+
            '<div class="loadingPlaceholder progress-bar-striped active"'+
                ' role="progressbar"'+
                ' aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"'+
                ' ng-style="{width: percent + '%'}" aria-valuetext="100%"'+
                ' style="width: 100%;height:100%;text-align:center;vertical-align: middle;line-height: {{sxHeight}}; ">'+
            '<span class="ng-binding ng-scope" style="font-size:xx-large">'+
              '<i class="fa fa-error" ng-if="sxModel.error" style="margin-right: 10px"></i> ' +
              '<i class="fa fa-warning" ng-if="sxModel.warn" style="margin-right: 10px"></i> ' +
              '<i class="fa fa-info" ng-if="sxModel.info" style="margin-right: 10px"></i> ' +
              '<i class="fa fa-refresh fa-spin" ng-if="!sxModel.info && !sxModel.warn && !sxModel.error" style="margin-right: 10px"></i> ' +
            '{{sxModel.message}}</span>'+
        '</div></div>',
      restrict: 'E',
      scope: {
        sxHeight: '=',
        /*sxLoading: '=',
        sxLoadingMessage: '=',*/
        sxModel: '='
      }
    };
  });
angular.module('ictportal.theme')
    .directive('sixLoadingSmall', function () {
        return {
            template:
            '<span ng-if="sxFor === undefined"><i class="fa fa-refresh fa-spin text-muted m-r-sm"></i></span>',
            restrict: 'E',
            scope: {
                sxFor: '='
            }
        };
    });

'use strict';


angular.module('ictportal.theme').controller('sixLookupCtrl',
    ['$scope', '$log', 'baseFactory', 'lookupFactory', 'dbFilterFactory', 'ABNORMAL_URL', 'SCRAMBLED_URL', '$timeout',
      function ($scope, $log, baseFactory, lookupFactory, dbFilterFactory, ABNORMAL_URL, SCRAMBLED_URL, $timeout) {

        // Default
        if(angular.isUndefined($scope.sxHistory)) { $scope.sxHistory = false; }
        if(angular.isUndefined($scope.sxShowDescription)) { $scope.sxShowDescription = false; }
        if(angular.isUndefined($scope.sxClosable)){$scope.sxClosable = true;}
        $scope.sxDescriptionClass = $scope.sxDescriptionClass || 'font-bold';
        $scope.sxPlaceholder = $scope.sxPlaceholder || 'Enter...';
        $scope.doDisable = false;
        if($scope.sxRelational){
          if(angular.isUndefined($scope.sxMapping)){ $scope.sxMapping = 'mapping'; }
          if(angular.isUndefined($scope.sxField)){ $scope.sxMapping = 'obj'; }
        }

        if(angular.isDefined($scope.sxWar)){
            $scope.sxWarUrl = $scope.sxWar + '/api/';
            $scope.sxBasePath = $scope.sxBasePath;
        }
        else{
            if($scope.sxRelational){
              $scope.sxWarUrl = ABNORMAL_URL + '/api/';
              if($scope.sxDatabase==='eggs') {
                $scope.sxWarUrl = SCRAMBLED_URL + '/api/';
              } 
                
              if($scope.sxMock){
                $scope.sxWarUrl += 'mock/';
              }
            }
            else{
              $scope.sxWarUrl = ABNORMAL_URL + '/api/';
            }
            $scope.sxBasePath = $scope.sxBasePath || 'record';
        }

        function buildPathLookup(basePath, type) {
          // basePath/type/lookup
          //$log.log('sx-base-path ' + basePath + ' ; sx-type ' + type);

          var path = '';
          if(angular.isDefined(basePath)) {
            path += basePath;
          }
          if(angular.isDefined(type)) {
            path += '/' + type;
          }
          //path += '/_lookup';
          //$log.info('builded lookup path: ' + path);
          return path;
        }

        function buildPathSelect(basePath, type, uuid) {
          // basePath/type/lookup
          //$log.log('sx-base-path ' + basePath + ' ; sx-type ' + type);

          var path = '';
          if(angular.isDefined(basePath)) {
            path += basePath;
          }
          if(angular.isDefined(type)) {
            path += '/' + type;
          }
          if(angular.isUndefined(uuid)) {
            $log.error('lookup: selected uuid is undefined!!');
          }
          path += '/_uuid/' + uuid + '/_current';
          //$log.info('builded lookup selected path: ' + path);
          return path;
        }

        $scope.refreshData = function(search){
          $scope.list = [];
          var path = buildPathLookup($scope.sxBasePath, $scope.sxType);
          var prefix = '';
          if (angular.isDefined($scope.sxSearchPrefix) && angular.isDefined($scope.sxSearchPrefix)) {
            prefix = $scope.sxSearchPrefix;
          }
          var toLower = angular.isUndefined(search) ? prefix : (prefix + search).toLowerCase();
          var query = {query: toLower, history: $scope.sxHistory, page_size: 250};
          
          if($scope.sxRelational){
            if($scope.ngModel){
              query['code'] = $scope.ngModel[$scope.sxMapping].code;
              query['description'] = $scope.ngModel[$scope.sxMapping].description;
              query['UUID'] = $scope.ngModel[$scope.sxMapping].UUID;
              if($scope.sxSortFields){
                query['sort_fields'] = '';
                $scope.sxSortFields.forEach(function(field){
                  query['sort_fields'] += field + ',';  
                });
                query['sort_fields'] = query['sort_fields'].slice(0, -1);
              }
            }
          }

          if (angular.isDefined($scope.sxFilter)) {
            lookupFactory($scope.sxWarUrl,path).search(query, $scope.sxFilter).$promise.then(function(resp) {
              if(angular.isDefined(resp) && resp.hasOwnProperty('list')) {
                $scope.list = resp.list;
                if($scope.sxPreselectIfOne && $scope.list.length==1) {
                  $scope.select($scope.list[0]);
                  $scope.doDisable = true;
                }
                if($scope.sxOnRefresh){
                  $timeout(function() {
                    if($scope.sxRefreshList){
                      $scope.sxRefreshList.length = 0;
                      $scope.sxRefreshList.push.apply($scope.sxRefreshList,$scope.list);
                    }
                    $scope.sxOnRefresh({search: toLower});
                  });
                }
              }
            });
          } else {
            lookupFactory($scope.sxWarUrl,path).search(query,[]).$promise.then(function(resp) {
              if(angular.isDefined(resp) && resp.hasOwnProperty('list')) {
                $scope.list = resp.list;
                if($scope.sxOnRefresh){
                  $timeout(function() {
                    if($scope.sxRefreshList){
                      $scope.sxRefreshList.length = 0;
                      $scope.sxRefreshList.push.apply($scope.sxRefreshList,$scope.list);
                    }
                    $scope.sxOnRefresh({search: toLower});
                  });
                }
              }
            });
          }
        };

        $scope.setRequiredValid = function(valid){
          if($scope.sxRequired){
            if(valid){
              $timeout(function() {
                  var test = $('#' + $scope.sxRequiredId + '  input');
                    $('#' + $scope.sxRequiredId + ' input').attr("required",false);
              });
            }
            else{
              $timeout(function() {
                  var test = $('#' + $scope.sxRequiredId + ' input');
                    $('#' + $scope.sxRequiredId + '  input').attr("required",true);
              });
            }
          }
        };

        $scope.select = function (item){
          if($scope.sxRelational){
            var ref = {
              type: $scope.sxType,
              code: item.model.code,
              description: item.model.description,
              UUID: item.UUID
            };
            $scope.setValue(item);
            $scope.sxId = item.UUID;
            $scope.object = ref;
            if(item){
              $scope.setRequiredValid(true);
            }
          }
          else{
            var ref = {
              type: $scope.sxType,
              code: item.model.code,
              description: item.model.description,
              UUID: item.UUID
            };
            $scope.setValue(ref);
            $scope.loadObject();
          }
          if($scope.sxOnSelect){
            $scope.sxOnSelect();
          }
        };

        $scope.setValue = function(value){
          if(angular.isUndefined($scope.sxField)){
            $scope.ngModel = value;
          } else {
            $scope.ngModel[$scope.sxField] = value;
          }

        };

        $scope.getValue = function(){
          if(angular.isUndefined($scope.sxField)){
            return $scope.ngModel;
          } else {
            return $scope.ngModel[$scope.sxField];
          }
        };

        $scope.setObject = function(obj){
          if(!$scope.sxRelational){
            $scope.object = (angular.isDefined(obj) && obj.hasOwnProperty('model')) ?  obj.model : undefined;
            if($scope.hasOwnProperty('sxObject')) {
              $scope.sxObject = obj;
            }
          }
          else{
            if(!obj){
              $scope.object = undefined;
            }
          }
          $scope.setRequiredValid(angular.isDefined($scope.object));
        };

        $scope.loaded = false;

        $scope.loadObject = function(){
          $scope.setObject(undefined);
          if ($scope.getValue()) {
            var path = buildPathSelect($scope.sxBasePath, $scope.sxType, $scope.getValue().UUID);
            lookupFactory($scope.sxWarUrl,path).query().$promise.then(function (response) {
              $scope.setObject(response);
            });
          }
        };

        $scope.clearSelect = function() {
          $scope.setValue(undefined);
          $scope.setObject(undefined);
          $scope.setRequiredValid(false);
          $scope.sxId = null;
          $scope.refreshData();
          if($scope.sxOnClear){
            $scope.sxOnClear();
          }
        };

        $scope.$watch(function(scope) {
          if(angular.isUndefined($scope.sxField) || angular.isUndefined(scope.ngModel)){
            return scope.ngModel;
          } else {
            return scope.ngModel[$scope.sxField];
          }
        },
          function(newValue, oldValue) {
            if($scope.sxRelational){
              if(newValue){
                $scope.setRequiredValid(true);
                $scope.object = angular.extend({
                  code: getCode(newValue),
                  description: getDescription(newValue),
                  type: $scope.sxType,
                  UUID: $scope.sxId
                }, newValue.model);
              }
              else{
                $scope.setRequiredValid(false);
              }
            }
            else{
              $scope.loadObject();
            }
          }
        );

        // Eventually removes "t." at the beginning of string.
        function fixTString(input) {
          return (input && input.substring(0,2)=='t.')?input.substring(2):input;         
        }

        function getCode(newValue){
          var codeField = fixTString($scope.ngModel[$scope.sxMapping].code);
          return newValue[codeField];
        }

        function getDescription(newValue){
          var descriptionField = $scope.ngModel[$scope.sxMapping].description;
          var description = '';
          var tokens = descriptionField.split(",");
          tokens.forEach(function(field){
            var descField = fixTString(field);
            if(newValue[descField]){
              description += (newValue[descField] + ' ');
            }
          });
          return description;
        }

        $scope.$watchGroup(['sxType', 'sxFilter'],
          function(newValue, oldValue) {
            $scope.refreshData();
            $scope.setRequiredValid();
          }
        );

        $scope.$on('refreshLookUp', function(){
          $scope.refreshData();
        });

        $scope.$on('clearLookUp', function(event, onlyMatch, id){
          if(!onlyMatch){
            $scope.clearSelect();
          }
          else if(id===$scope.sxClearId){
            $scope.clearSelect();
          }
        });

      }

    ]
);

/**
 * @ngdoc directive
 * @name ictportal.theme.directive:sixLookup
 * @description
 * # sixLookup
 */
angular.module('ictportal.theme')
  .directive('sixLookup', ['$log','lookupFactory', function ($log, lookupFactory) {
    return {
      template:
      '<div class="input-group has-button" id="{{sxRequiredId}}" style="width: 100%">' +
        '<ui-select ng-model="ngModel" theme="bootstrap" on-select="select($item, $model)" ng-disabled="sxDisabled || doDisable" reset-search-input="true">' +
        '<ui-select-match class="ui-select-match" placeholder="{{sxPlaceholder}}"><span ng-if="object.description">{{object.description}}</span><span ng-if="!object.description">{{object.code}}</span></ui-select-match>'+
          '<ui-select-choices class="ui-select-choices" repeat="item in list track by $index" refresh="refreshData($select.search)" refresh-delay="0">'+
            '<div ng-bind-html="item.model.description | highlight: $select.search"></div>'+
            '<small ng-hide="sxHideCode" ng-bind-html="item.model.code | highlight: $select.search"></small>'+
          '</ui-select-choices>' +
        '</ui-select>' +
        '<span class="input-group-btn" ng-if="sxClosable == true">' +
          '<button type="button" class="btn btn-bg btn-default" ng-click="clearSelect()" ng-disabled="sxDisabled"><i class="fa fa-times"></i></button>' +
        '</span>' +
      '</div>' +
      '<div ng-if="sxShowDescription === true" class="{{sxDescriptionClass}}">' +
        '{{object.description}}' +
      '</div>' +
      '<div ng-if="showDebug"><input type="checkbox" ng-model="sxDebug"><span style="font-size:smaller;color:lightslategray">debug</span>' +
      '<div ng-if="sxDebug" style="font-size:smaller; color:lightslategray">' +
      'model: {{ngModel}}<br/>' +
      'type: {{sxType}}<br/>' +
      'list: {{list}}<br/>' +
      'object: {{object}}</div></div>',
      restrict: 'E',
      scope: {
        ngModel: '=',
        sxBasePath: '=?', //nome dell'endpoint rest
        sxType: '=', //tipo 'entity'
        sxField: '=?', //nome del campo nell'oggetto che mi referenzia
        sxObject: '=?', //nome del campo in cui salvare l'intero oggetto selezionato
        showDebug: '=?',
        sxDebug: '=?',
        sxHistory: '=?',
        sxSearchPrefix: '=?',
        sxShowDescription: '=?',
        sxFilter: '=?',
        sxDisabled: '=?',
        sxPlaceholder: '@',
        sxWar: '=?',
        sxDatabase: '=?',
        sxClosable: '=?', // per abilitare o meno il pulsante per pulire la lookup
        sxOnSelect: '&?', // funzione scatenata alla selezione di una opzione
        sxOnClear: '&?',  // funzione scatenata alla pressione del tasto X
        sxOnRefresh: '&?', // funzione scatenata quando viene ricaricato l'elenco delle opzioni disponibili 
        sxRefreshList: '=?', // lista di tutte le opzioni presenti nella lookup
        sxClearId: '=?',
        sxRelational: '=?', // true se si sta usando un db relazionale
        sxMapping: '=?',
        sxId: '=?',
        sxRequiredId: '@', // Per abilitare il readonly completare entrambi i campi
        sxRequired: '=?', 
        sxHideCode: '=?', // true se si vuole nascondere il 'codice' delle opzioni disponibili
        sxSortFields: '=?', // campi in base ai quali ordinare i dati
        sxMock: '=?',  // Solo per dati mockati su eggs
        sxPreselectIfOne: "=?" // Se true e ho un'opzione sola, la preseleziono (comodo per i filtri impliciti)
      },
      controller: 'sixLookupCtrl'
    };
  }]);

'use strict';

function makeId() {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

  for( var i=0; i < 10; i++ )
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}

angular.module('ictportal.theme').controller('sixLookup2Ctrl',
    ['$scope', '$rootScope', '$log', 'baseFactory', 'schemaFactory', 'dialogService', 'recordFactory', 'lookupFactory', 'counterFactory', 'toaster', '$q', 'ABNORMAL_URL', '$filter', '$timeout',
      function ($scope, $rootScope, $log, baseFactory, schemaFactory, dialogService, recordFactory, lookupFactory, counterFactory, toaster, $q, ABNORMAL_URL, $filter, $timeout) {

        /**** VARIABLES INIT *****/

        var lastSelectedObj = undefined;

        $scope.filter = {};
        $scope.vars = {
          schema:               {},     // schema del tipo di record selezionato
          form:                 {},     // form del tipo di record selezionato
          schemaLoaded:         false,  // indica se è stato caricato o meno lo schema del tipo di record
          commissionDependent:  false,  // true=inserisce la commessa ; false=toglie la commessa
          customerDependent:    false,  // true=inserisce il cliente ; false=toglie il cliente
          historyMode:          false,  // true=SNAP ; false=STABLE
          insertMode:           false,  // indica se è abilitata la modalità di inserimento "al volo" di un nuovo record
          selfGeneratedCode: {          // indica se il codice è da auto-generare (flag) e quale è il nome del contatore di six
            codeNameSix: '',
            active: false
          },
          listLoaded: false,
          totalItems: 0,
          page: 1
        };

        $scope.sxId = $scope.sxId || makeId();
        if(angular.isUndefined($scope.sxObject)) { $scope.sxObject = {}; }                // oggetto completo da restituire al chimante della six-lookup-2
        if(angular.isUndefined($scope.sxFilter)) { $scope.sxFilter = undefined; }         // filtri per il backend
        if(angular.isUndefined($scope.sxHistory)) { $scope.sxHistory = false; }           // mostra/nasconde i dati storicizzati
        if(angular.isUndefined($scope.sxShowDescription)) { $scope.sxShowDescription = false; }
        if(angular.isUndefined($scope.sxShowDetails)) { $scope.sxShowDetails = false; }   // visualizza/nasconde il tab dei dettagli
        if(angular.isUndefined($scope.sxShowFilters)) { $scope.sxShowFilters = false; }   // visualizza/nasconde il tab dei filtri
        if(angular.isUndefined($scope.sxPinnable)) { $scope.sxPinnable = false; }         // indica se la sidebar può essere bloccata o meno
        if(angular.isUndefined($scope.sxVisible)) { $scope.sxVisible = false; }           // indica se la sidebar è visibile o meno
        if(angular.isUndefined($scope.sxMultiple)) { $scope.sxMultiple = false; }         // indica se la lookup deve gestire valori multipli o singoli
        if(angular.isUndefined($scope.sxCompact)) { $scope.sxCompact = false; }           // indica se la lookup deve essere visualizzata in modalità compatta o con sidebar
        $scope.sxPageSize         = $scope.sxPageSize || 50;                              // dimensione pagina della lista caricata
        $scope.sxBasePath         = $scope.sxBasePath || 'record';                        // base path per le chiamate al backend
        $scope.sxDescriptionClass = $scope.sxDescriptionClass || 'font-bold';
        $scope.sxPosition         = $scope.sxPosition || 'left';                                    // posizione della sidebar (left|right)
        $scope.sxDimension        = $scope.sxDimension || 'l';                                      // dimensione della sidebar (s|m|l)
        $scope.valueToShow        = undefined;                                                      // valore selezionato da mostrare nella input text della lookup se singola
        $scope.sxPinned           = isMultiple();   // indica se la sidebar è bloccata o meno (inizializzata qui)
        $scope.sxPrefill          = $scope.sxPrefill;

        $scope.fullTmpObj = undefined;  // oggetto mostrato nel tab 'details'

        // info di paginazione mostrati in lista
        $scope.start  = 0;
        $scope.end    = 0;

        /* ***** Search filters ***** */
        $scope.sxSearchTerms = {
          id: $scope.sxId+'_filter-search',
          open: false,
          type_id: undefined,
          type_obj: undefined
        };
        resetSxFilters();

        if(angular.isDefined($scope.sxWar)){
          $scope.sxWarUrl = 'api/' + $scope.sxWar + '/api/';
        }
        else{
          $scope.sxWarUrl = ABNORMAL_URL + '/api/';
          $scope.sxBasePath = $scope.sxBasePath || 'record';
        }

        setPlaceholder();   // inizializzo il placeholder da mostrare


        /**** LOOKUP PATH FUNCTIONS *****/

        function buildPathLookup(basePath, type) {
          // basePath/type/lookup
          var path = '';
          if(angular.isDefined(basePath)) {
            if(path!= '' && path.slice(-1) != '/') path += '/';
            path += basePath;
          }
          if(angular.isDefined(type)) {
            if(path!= '' && path.slice(-1) != '/') path += '/';
            path += type;
          }
          if(path!= '' && path.slice(-1) != '/') path += '/';
          path += '_lookup';
          return path;
        }

        function buildPathSelect(basePath, type, uuid) {
          // basePath/type/lookup
          var path = '';
          if(angular.isDefined(basePath)) {
            if(path!= '' && path.slice(-1) != '/') path += '/';
            path += basePath;
          }
          // if(angular.isUndefined($scope.sxWar)){
          //   path += '/';
          // }
          if(angular.isDefined(type)) {
            if(path!= '' && path.slice(-1) != '/') path += '/';
            path += type;
          }
          if(angular.isUndefined(uuid)) {
            $log.error('lookup: selected uuid is undefined!!');
          }
          if(path!= '' && path.slice(-1) != '/') path += '/';
          path += '_uuid/' + uuid + '/_current';
          return path;
        }


        /**** LIST FUNCTIONS *****/

        $scope.getListForTags = function(query) {
          return refreshList(query);
        };

        function refreshList(search){
          var deferred = $q.defer();
          $scope.vars.listLoaded = false;
          $scope.list = [];
          var path = buildPathLookup($scope.sxBasePath, $scope.sxType);
          var prefix = '';
          if (angular.isDefined($scope.sxSearchPrefix) && angular.isDefined($scope.sxSearchPrefix)) {
            prefix = $scope.sxSearchPrefix;
          }
          var toLower = angular.isUndefined(search) ? prefix : (prefix + search).toLowerCase();
          var query = {query: toLower, history: $scope.sxHistory, page: $scope.vars.page, page_size: $scope.sxPageSize};

          // filtri da sxFilter e sxSearchFilters
          var filters = $scope.sxFilter;
          if (angular.isDefined(filters) && filters != null && $scope.searchFilterArray.length > 0) {
            angular.merge(filters, $scope.searchFilterObj);
          } else if($scope.searchFilterArray.length > 0) {
            filters = $scope.searchFilterObj;
          }

          var promise;
          if (angular.isDefined(filters) && filters != null) {
            promise = lookupFactory($scope.sxWarUrl,path).search(query, filters).$promise;
          } else {
            promise = lookupFactory($scope.sxWarUrl,path).query(query).$promise;
          }

          promise.then(function(resp) {
            $scope.vars.listLoaded = true;
            if(angular.isDefined(resp) && resp.hasOwnProperty('list')) {
              $scope.list = resp.list.map(function(i) { return buildRef(i) });
              $scope.vars.totalItems = resp.totalResults;
              // if($scope.vars.totalItems == 1) {  // se è l'unico risultato lo preseleziono
              //   $scope.select($scope.list[0], false);
              // }
            } else {
              $scope.vars.totalItems = 0;
            }

            // info di paginazione mostrate in lista
            $scope.start = $scope.sxPageSize * ($scope.vars.page - 1) + 1;
            var min = Math.min($scope.sxPageSize, $scope.list.length);
            $scope.end = min + ($scope.sxPageSize * ($scope.vars.page - 1));

            deferred.resolve($scope.list);
          });

          return deferred.promise;
        }



        /**** VALUE FUNCTIONS *****/

        function buildRef(item) {
          var typeRef = null;
          if(item.schemaCode){
            typeRef = item.schemaCode;
          } else {
            typeRef = $scope.sxType;
          }
          return {
            type: typeRef,
            code: item.model.code,
            description: item.model.description,
            UUID: item.UUID
          };
        }

        function addOrSetValue(value){
          if(isMultiple()) {
            if($scope.sxField) {
              checkAndAdd($scope.ngModel[$scope.sxField], value);
            } else {
              checkAndAdd($scope.ngModel, value);
            }
          } else {
            if($scope.sxField) {
              $scope.ngModel[$scope.sxField] = value;
            } else {
              $scope.ngModel = value;
            }
          }
          setPlaceholder();
        }

        function setValueToShow(value) {
          if(value) {
            if($scope.sxItemTemplate) {
              $scope.valueToShow = $scope.evaluateTemplate($scope.sxItemTemplate, value);
            } else {
              $scope.valueToShow = value.code + ' - ' + $filter('cut')(value.description, true, 100, '...');
            }
          } else {
            $scope.valueToShow = undefined;
          }
        }

        function checkAndAdd(list, value) {
          var found = list.some(function (el) {
            return el.UUID === value.UUID;
          });
          if (!found) { list.push(value); }
        }

        function unsetValue() {
          if(angular.isUndefined($scope.sxField)){
            if(isMultiple()) {
              $scope.ngModel = [];
            } else {
              $scope.ngModel = undefined;
              setValueToShow($scope.ngModel);
            }
          } else{
            if(isMultiple()) {
              $scope.ngModel[$scope.sxField] = [];
            } else {
              $scope.ngModel[$scope.sxField] = undefined;
              setValueToShow($scope.ngModel[$scope.sxField]);
            }
          }
          setPlaceholder();
        }

        function getValue(){
          if($scope.ngModel && $scope.sxField){
            return $scope.ngModel[$scope.sxField];
          } else {
            return $scope.ngModel;
          }
        }

        $scope.toggleSelect = function(item) {
          $scope.undoNewRecord();
          if($scope.isItemSelected(item)) {
            $scope.unselect(item);
          } else {
            $scope.select(item);
          }
        };

        $scope.select = function (item, autoclose) {
          autoclose = angular.isDefined(autoclose) ? autoclose : true;
          $scope.undoNewRecord();
          $scope.vars.insertMode = false;
          var tmp = item;
          if(item.model) {
            tmp = buildRef(item);
          }
          addOrSetValue(tmp);
          goToTab('list');
          if(!$scope.sxPinned && autoclose) {
            closeLookup();
          }
        };

        $scope.unselect = function(item) {
          $scope.vars.insertMode = false;
          if(isMultiple()) {
            var idx = getValue().findIndex(function(v) { return v.UUID === item.UUID; });
            if (idx > -1) {
              getValue().splice(idx, 1);
            }
          } else {
            unsetValue();
          }
        };

        $scope.clearSelect = function() {
          unsetValue();
          unsetObject();
          refreshList($scope.filter.text);
        };

        $scope.isItemSelected = function(item) {
          var selectedValue = getValue();
          if(selectedValue && isMultiple()) {
            var found = false;
            selectedValue.forEach(function(i) {
              found |= (i.UUID == item.UUID);
            });
            return found;
          } else if(selectedValue) {
            return selectedValue.UUID == item.UUID;
          }
          return false;
        };


        /**** OBJECT FUNCTIONS *****/

        function addOrSetFullObj(obj) {
          lastSelectedObj = $scope.fullTmpObj;
          if(isMultiple()) {
            $scope.sxObject[obj.UUID] = obj;
          } else {
            $scope.sxObject = obj;
            $scope.fullTmpObj = obj;
          }
        }

        function unsetObject() {
          if(isMultiple()) {
            $scope.sxObject = {};
          } else {
            $scope.sxObject = undefined;
          }
        }

        function loadAllFullObjs() {
          unsetObject();
          var val = getValue();
          if (!isMultiple() && val) {  // lookup singola
            loadSingleFullObj(val).then(function (response) {
              addOrSetFullObj(response);
            });
          } else if (val && angular.isArray(val)) { // lookup multipla
            var promises = [];
            val.forEach(function(v) {
              promises.push(loadSingleFullObj(v));
            });
            $q.all(promises).then(function (responses) {
              responses.forEach(function(resp) {
                addOrSetFullObj(resp);
              });
            });
          }
        }

        function loadSingleFullObj(ref) {
          var path = buildPathSelect($scope.sxBasePath, $scope.sxType, ref.UUID);
          return lookupFactory($scope.sxWarUrl,path).query().$promise;
        }


        /**** NEW DYNAMIC RECORD ****/

        $scope.addNewRecord = function() {
          $scope.fullTmpObj = undefined;
          var newRecord = { model: {}};
          if($scope.sxPrefill) {
            newRecord = angular.copy($scope.sxPrefill);
          }
          $scope.vars.insertMode = true;
          if($scope.vars.selfGeneratedCode.active == true){
            counterFactory.current({code: $scope.vars.selfGeneratedCode.codeNameSix}).$promise.then(function (response) {
              if (response.errors){
                toaster.pop('error', 'Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + response.errors.error);
              } else {
                newRecord.model.code = (parseInt(response.current)+1).toString();
                $scope.fullTmpObj = newRecord;
              }
            });
          } else {
            $scope.fullTmpObj = newRecord;
          }
          goToTab('details');
          $scope.$broadcast('schemaFormRedraw');
        };

        $scope.undoNewRecord = function() {
          $scope.vars.insertMode = false;
          $scope.fullTmpObj = $scope.sxObject;
          goToTab('list');
        };

        $scope.updateRecord = function() {
          // gestione code tramite contatore di SIX, confermo il codice...
          // FIXME per ora funziona perchè lo schema viene caricato in tempo (prima), ma occhio alle temporizzazioni...
          // FIXME ...se lo schema viene caricato in ritardo per problemi di rete e l'utente fa in tempo a cliccare su '+' per generare un nuovo record, il codice non viene autocompilato
          if($scope.vars.selfGeneratedCode.active == true){
            counterFactory.next({code: $scope.vars.selfGeneratedCode.codeNameSix}).$promise.then(function (response) {
              if (response.errors){
                toaster.pop('error', 'Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + response.errors.error);
              } else {
                if(!$scope.fullTmpObj.model.code){ // se è ancora vuoto lo riempio
                  $scope.fullTmpObj.model.code = response.next; // se è nuovo, confermo il codice...
                }
              }
              _update();
            });
          } else {
            _update();
          }
        };

        function _update() {
          if(angular.isDefined($scope.fullTmpObj) && angular.isDefined($scope.fullTmpObj.model) && angular.isDefined($scope.sxType)){
            var params = {
              commission_dependent: $scope.vars.commissionDependent,
              customer_dependent:   $scope.vars.customerDependent,
              history:              $scope.vars.historyMode
            };
            recordFactory($scope.sxType).create(params, $scope.fullTmpObj.model).$promise.then(function(data) {
              refreshList($scope.filter.text);
              $scope.select(data);
            });
          }
        }


        /**** TABS NAVIGATION ****/

        function goToTab(tabName) {
          angular.element(document.querySelector('#'+$scope.sxId+'_tab-s-filters')).removeClass('active');
          angular.element(document.querySelector('#'+$scope.sxId+'_tab-s-list')).removeClass('active');
          angular.element(document.querySelector('#'+$scope.sxId+'_tab-s-details')).removeClass('active');
          angular.element(document.querySelector('#'+$scope.sxId+'_tab-filters')).removeClass('active');
          angular.element(document.querySelector('#'+$scope.sxId+'_tab-list')).removeClass('active');
          angular.element(document.querySelector('#'+$scope.sxId+'_tab-details')).removeClass('active');

          angular.element(document.querySelector('#'+$scope.sxId+'_tab-s-'+tabName)).addClass('active');
          angular.element(document.querySelector('#'+$scope.sxId+'_tab-'+tabName)).addClass('active');
        }

        $scope.viewItemDetails = function(item) {
          $scope.undoNewRecord();
          loadSingleFullObj(item).then(function(resp) {
            $scope.fullTmpObj = resp;
          });
          goToTab('details');
        };

        $scope.filtersTabEnabled = function() {
          return $scope.sxShowFilters == true;
        };

        $scope.detailsTabEnabled = function() {
          return $scope.sxShowDetails == true || $scope.sxAdd == true;
        };



        /**** SCHEMA FUNCTIONS ****/

        // FIXME sarebbe corretto far recuperare lo schema puntando all'endpoint corretto... ad es. six-plan per lo schema delle issue
        function loadSchema() {
          if($scope.vars.schemaLoaded == false && $scope.sxType) {
            schemaFactory().byUUID({id: $scope.sxType}).$promise.then(function (data) {
              if (!data.model) {
                dialogService.alert('Non è stato definito un modello per l\'entità ' + $scope.sxType, 4000);
                $scope.vars.schemaLoaded = false;
                return;
              }
              /* ***** Search filters ***** */
              $scope.sxSearchTerms.type_id = data;
              $scope.sxSearchTerms.type_obj = data;

              $scope.vars.schema = data.model.schema;
              $scope.vars.form = data.model.form;
              $scope.vars.commissionDependent = data.model.commissionDependent;
              $scope.vars.customerDependent = data.model.customerDependent;
              $scope.vars.historyMode = data.model.history;
              if(data.model.selfGeneratedCode){
                $scope.vars.selfGeneratedCode = data.model.selfGeneratedCode;
              }

              $scope.vars.schemaLoaded = true;
            });
          }
        }


        /**** WATCHERS *****/

        $scope.$watchCollection(function(scope) {
            if(angular.isDefined(scope.ngModel)) {
              if (angular.isUndefined($scope.sxField)) {
                return scope.ngModel;
              } else {
                return scope.ngModel[$scope.sxField];
              }
            }
          },
          function(newValue, oldValue) {
            loadAllFullObjs();

            if(!isMultiple()) {
              if ($scope.ngModel && $scope.sxField) {
                setValueToShow($scope.ngModel[$scope.sxField]);
              } else if($scope.ngModel) {
                setValueToShow($scope.ngModel);
              } else {
                setValueToShow();
              }
            }
          }
        );

        $scope.$watch('sxType', function(newValue) {
            setPlaceholder();
            if(isListToLoad()) {
              refreshList($scope.filter.text);
              if(newValue && newValue != undefined && ($scope.detailsTabEnabled() || $scope.filtersTabEnabled())) {
                $scope.vars.schemaLoaded = false;  // type cambiato!!
                resetSxFilters();
                loadSchema();
              }
            }
          }
        );

        $scope.$watchCollection('sxFilter', function(newValue, oldValue) {
            if(newValue != oldValue && isListToLoad()) {
              refreshList($scope.filter.text);
            }
          }
        );

        $scope.$watch('filter.text', function(newVal, oldVal) {
          $scope.vars.page = 1;
          if(isListToLoad()) {
            refreshList($scope.filter.text);
          }
        });

        $scope.$watch('vars.page', function(newVal, oldVal) {
          if(isListToLoad()) {
            refreshList($scope.filter.text);
          }
        });

        $scope.$watch('sxVisible', function(newVal, oldVal) {
          // chiudo tuttle le altre lookup e passo il mio id per comunicare che devo restare aperta solo io
          if(newVal === true && oldVal != true) {
            $rootScope.$broadcast('closeSixLookup2', {id: $scope.sxId});
          }
          if(isListToLoad()) {
            refreshList($scope.filter.text);
            if ($scope.detailsTabEnabled() || $scope.filtersTabEnabled()) {
              $scope.vars.schemaLoaded = false;  // type cambiato!!
              resetSxFilters();
              loadSchema();
            }
          }
        });

        $rootScope.$on('closeSixLookup2', function($event, args) {
          if(args && args.id != $scope.sxId) {  // se non ho lanciato io il broadcast mi chiudo
            closeLookup();
          }
        });


        /**** FILTERS FUNCTIONS ****/

        $scope.onFilterChanged = function() {
          refreshList($scope.filter.text);
          goToTab('list');
        };

        $scope.clearSearchFn = function() {
          $scope.filter.text = '';
        };

        function resetSxFilters() {
          $scope.searchFilterObj = {};
          $scope.searchFilterArray = [];
          $scope.sxSearchTerms.open = false;
          $scope.sxSearchTerms.type_id = undefined;
          $scope.sxSearchTerms.type_obj = undefined;
        }


        /**** OTHER ****/

        function isMultiple() {
          return ($scope.sxMultiple === true || $scope.sxMultiple === 'true');
        }

        $scope.isMultiple = isMultiple;

        function isListToLoad() {
          return $scope.sxVisible || $scope.sxCompact;
        }

        $scope.onFocusItCB = function() {
          if(!$scope.sxDisabled) {
            $scope.sxVisible = true;
          }
        };

        function closeLookup() {
          $scope.sxVisible = false;
          // emptyList();
        }

        function emptyList() {
          $scope.list = [];
          $scope.vars.page = 1;
          $scope.vars.totalItems = 0;
        }

        function setPlaceholder() {
          if($scope.sxEmptyPlaceholder) {
            $scope.emptyPlaceholder = $scope.sxEmptyPlaceholder;
          } else {
            $scope.emptyPlaceholder = ($scope.sxTitle || $scope.sxType || 'Seleziona').toLowerCase() + '...';
          }

          if(!$scope.ngModel || !$scope.ngModel[$scope.sxField] || $scope.ngModel[$scope.sxField].length == 0) {
            $scope.placeholder = $scope.emptyPlaceholder;
          } else if($scope.sxPlaceholder) {
            $scope.placeholder = $scope.sxPlaceholder;
          } else {
            $scope.placeholder = ($scope.sxTitle || $scope.sxType || 'Seleziona').toLowerCase() + '...';
          }
        }

        $scope.evaluateTemplate = function(template, item) {
          var evaluated = template.replace(/\{\{item\.(.*?)}\}/g, function(match, token) {
            return item[token];
          });
          return evaluated;
        };
      }

    ]
);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixLookup
 * @description
 * # sixLookup
 */
angular.module('ictportal.theme')
  .directive('sixLookup2', ['$log','baseFactory', function ($log, baseFactory) {
    return {
      templateUrl: 'theme/directives/templates/sixlookup2.html',
      restrict: 'E',
      scope: {
        sxId: '@',
        ngModel: '=',
        sxBasePath: '=?', //nome dell'endpoint rest
        sxType: '=?', //tipo 'entity'
        sxField: '=?', //nome del campo nell'oggetto che mi referenzia
        sxObject: '=?', //nome del campo in cui salvare l'intero oggetto selezionato
        sxHistory: '=?',
        sxSearchPrefix: '=?',
        sxShowDescription: '=?',
        sxFilter: '=?',
        sxDisabled: '=?',
        sxPlaceholder: '=?',      // placeholder mostrato quando la selezione è vuota (viene sempre mostrato in caso di selezione multipla)
        sxEmptyPlaceholder: '=?', // placeholder mostrato quando la selezione multipla è vuota
        sxTitle: '=?',
        sxPosition: '=?',   // posizione della sidebar: 'left'/'right'
        sxDimension: '=?',  // dimensione sidebar: 's'/'m'/'l'
        sxAdd: '=?',
        sxShowDetails: '=?',
        sxShowFilters: '=?',
        sxPinnable: '=?',
        sxVisible: '=?',
        sxMultiple: '@',
        sxPageSize: '=?',
        sxCompact: '=?',     // modalità compatta (a tendina) o con sidebar
        sxPrefill: '=?',
        sxItemTemplate: '=?',   // template degli elementi da mostrare in lista. Es. <span>{{item.description}} ({{item.code}})</span>
        sxItemTemplateUrl: '=?'
      },
      transclude: true,
      controller: 'sixLookup2Ctrl'
    };
  }]);

'use strict';


angular.module('ictportal.theme').controller('sixMonthPickerCtrl',
    ['$scope', '$log',
      function ($scope, $log) {

        $scope.getMonths = function() {
          var months = sixDateLib.getMonths();
          return months;
        };

        $scope.previousMonth = function() {
          if(sixDateLib.getMonthIndex($scope.ngModel) > 0){
            var prevMonth = sixDateLib.getMonthIndex($scope.ngModel) - 1;
            $scope.ngModel = sixDateLib.getMonthName(prevMonth);
          }
        };

        $scope.nextMonth = function() {
          if(sixDateLib.getMonthIndex($scope.ngModel) < 11){
            var prevMonth = sixDateLib.getMonthIndex($scope.ngModel) + 1;
            $scope.ngModel = sixDateLib.getMonthName(prevMonth);
          }
        };
      }
    ]
);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixLookup
 * @description
 * # sixLookup
 */
angular.module('ictportal.theme')
  .directive('sixMonthPicker', function () {
    return {
      template:
        '<div class="input-group">' +
          '<a ng-click="previousMonth()" class="btn btn-default btn-sm">' +
            '<i class="fa fa-angle-left pull-left"></i>' +
          '</a>' +
          '<select ng-model="ngModel" class="btn btn-default btn-sm">' +
            '<option ng-repeat="m in getMonths()" value="{{m}}" ng-selected="ngModel == m">{{m}}</option>' +
          '</select>' +
          '<a ng-click="nextMonth()" class="btn btn-default btn-sm">' +
            '<i class="fa fa-angle-right pull-left"></i>' +
          '</a>' +
        '</div>',
      restrict: 'E',
      scope: {
        ngModel: '=',
        sxChange: '&'
      },
      controller: 'sixMonthPickerCtrl'
    };
  });

'use strict';

/*
 http://jsfiddle.net/PW48M/
 http://bl.ocks.org/mbostock/3884955
 heatmap http://bl.ocks.org/oyyd/859fafc8122977a3afd6


 [ES: dati

 {"date":"2013-12-31T23:00:00.000Z",
 "Consuntivo":"8",
 "Storico":"8",}

 {"date":"2014-01-01T23:00:00.000Z",
 "Consuntivo":"9",
 "Storico":"8",

 {"date":"2014-01-02T23:00:00.000Z",
 "Consuntivo":"8",
 "Storico":"8",
 "Consuntivo (cum.)":"0.1588021778584392",
 "Storico (cum.)":"0.24525547445255477"},
 ...etc

 */

angular.module('ictportal.theme').controller('sixMultiSeriesLineChartCtrl',
    ['$scope', '$log', 'SaveAs', '$window',

      function ($scope, $log, SaveAs, $window) {


        var w = angular.element($window);
        w.bind('resize', function () {
          console.log('resizing graph');
          $scope.showGraph();
        });


        $scope.dateAxisFormats = [
          {name: 'HH:mm:ss', value: '%H:%M:%S'},
          {name: 'dd/MM/yy', value: '%d/%m/%Y'},
          {name: 'dd/MM', value: '%d/%m'},
          {name: 'dd', value: '%d'},
          {name: 'MM', value: '%b'},
          {name: 'MMMM', value: '%B'},
          {name: 'MM yy', value: '%b %y'},
          {name: 'MMMM yy', value: '%B %y'},
          {name: 'MMMM yyyy', value: '%B %Y'}
        ];

        //linear – Normal line (jagged).
        //step-before – a stepping graph alternating between vertical and horizontal segments.
        //step-after - a stepping graph alternating between horizontal and vertical segments.
        //basis - a B-spline, with control point duplication on the ends (that's the one above).
        //basis-open - an open B-spline; may not intersect the start or end.
        //basis-closed - a closed B-spline, with the start and the end closed in a loop.
        //bundle - equivalent to basis, except a separate tension parameter is used to straighten the spline. This could be really cool with varying tension.
        //cardinal - a Cardinal spline, with control point duplication on the ends. It looks slightly more 'jagged' than basis.
        //cardinal-open - an open Cardinal spline; may not intersect the start or end, but will intersect other control points. So kind of shorter than 'cardinal'.
        //cardinal-closed - a closed Cardinal spline, looped back on itself.
        //monotone - cubic interpolation that makes the graph only slightly smoother.

        $scope.interpolationTypes = [
          {name: 'linear', value: 'linear'},
          {name: 'step-before', value: 'step-before'},
          {name: 'step-after', value: 'step-after'},
          {name: 'basis', value: 'basis'},
          {name: 'basis-open', value: 'basis-open'},
          {name: 'basis-closed', value: 'basis-closed'},
          {name: 'bundle', value: 'bundle'},
          {name: 'cardinal', value: 'cardinal'},
          {name: 'cardinal-open', value: 'cardinal.open'},
          {name: 'cardinal-closed', value: 'cardinal-closed'},
          {name: 'monotone', value: 'monotone'}
        ];

        $scope.chartTypes = [
          {name: 'line', value: 'line'},
          {name: 'bar', value: 'bar'}
        ];

        $scope.sxXAxisFormat = $scope.sxXAxisFormat || '%B';
        $scope.sxXAxisTicks = $scope.sxXAxisTicks || undefined;
        $scope.sxInterpolate = $scope.sxInterpolate || 'monotone';
        $scope.sxShowPoints = $scope.sxShowPoints || false;
        $scope.sxChartType = $scope.sxChartType || 'line';


        (function() {
            d3.legend = function(g) {
                g.each(function() {
                    var g= d3.select(this),
                        items = {},
                        svg = d3.select(g.property("nearestViewportElement")),
                        legendPadding = g.attr("data-style-padding") || 5,
                        lb = g.selectAll(".legend-box").data([true]),
                        li = g.selectAll(".legend-items").data([true]);

                    lb.enter().append("rect").classed("legend-box",true);
                    li.enter().append("g").classed("legend-items",true);

                    svg.selectAll("[data-legend]").each(function() {
                        var self = d3.select(this);
                        items[self.attr("data-legend")] = {
                            pos : self.attr("data-legend-pos") || this.getBBox().y,
                            color : self.attr("data-legend-color") != undefined ? self.attr("data-legend-color") : self.style("fill") != 'none' ? self.style("fill") : self.style("stroke")
                        }
                    });

                    items = d3.entries(items).sort(function(a,b) {
                            //return a.value.pos-b.value.pos}
                            return a.name < b.name;
                        }
                    );


                    li.selectAll("text")
                      .data(items,function(d) { return d.key})
                      .call(function(d) { d.enter().append("text")})
                      .call(function(d) { d.exit().remove()})
                      .attr("y",function(d,i) { return i+"em"})
                      .attr("x","1em")
                      .text(function(d) { ;return d.key});

                    li.selectAll("circle")
                      .data(items,function(d) { return d.key})
                      .call(function(d) { d.enter().append("circle")})
                      .call(function(d) { d.exit().remove()})
                      .attr("cy",function(d,i) { return i-0.25+"em"})
                      .attr("cx",0)
                      .attr("r","0.4em")
                      .style("fill",function(d) { return d.value.color});

                    // Reposition and resize the box
                    var lbbox = li[0][0].getBBox();
                    lb.attr("x",(lbbox.x-legendPadding))
                      .attr("y",(lbbox.y-legendPadding))
                      .attr("height",(lbbox.height+2*legendPadding))
                      .attr("width",(lbbox.width+2*legendPadding))
                      .style("fill", "none")
                });
                return g
            }
        })();


        $scope.showGraph = function(){
          var containerWidth = 1024;

          //console.log(document.getElementById('graphPlaceholder'+$scope.sxId));
          var placeholder =document.getElementById('graphPlaceholder'+$scope.sxId);
          if (placeholder!= null && !angular.isUndefined(placeholder)
              && !angular.isUndefined(placeholder.parentElement)
              && !angular.isUndefined(placeholder.parentElement.parentElement)){

            containerWidth = placeholder.parentElement.parentElement.clientWidth;
            if (containerWidth < 200){
              containerWidth = 1024;
            }
            //console.log('containerWidth:'+containerWidth);
          }

          var margin = {top: 20, right: 80, bottom: 30, left: 50},
              width = containerWidth - margin.left - margin.right,
              height = $scope.sxHeight>0?$scope.sxHeight:200 ;

          var parseDate = d3.time.format("%Y%m%d").parse;

          var myFormatter = d3.time.format = d3.locale({
            "decimal": ".",
            "thousands": ",",
            "grouping": [3],
            "currency": ["€", ""],
            "dateTime": "%a %b %e %X %Y",
            "date": "%d/%m/%Y",
            "time": "%H:%M:%S",
            "periods": ["AM", "PM"],
            "days": ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
            "shortDays": ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
            "months": ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
            "shortMonths": ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"]
          });

          d3.time.format = myFormatter.timeFormat;

          var data = $scope.sxGraphData;
          if (angular.isUndefined(data) || !data || data == {}){
            $log.error("No graphData");
            return;
          }

          var x = d3.time.scale()
              .range([0, width]);

          var y = d3.scale.linear()
              .range([height, 0]);

          var color = d3.scale.category10();

          if ($scope.sxSeriesColors) {
              //es: color.range(["#1044EE", "#10BB99", "red"]);
              //es: v. daydegree.html
              color.range($scope.sxSeriesColors);
          }
          var xAxis = d3.svg.axis()
              .scale(x)
              .orient("bottom")
              .tickFormat(myFormatter.timeFormat($scope.sxXAxisFormat))
              .ticks($scope.sxXAxisTicks);

          var yAxis = d3.svg.axis()
              .scale(y)
              .orient("left");

          var line = d3.svg.line()
              .interpolate($scope.sxInterpolate)
              .x(function(d) { return x(d.date); })
              .y(function(d) { return y(d.value); });

          d3.select("#ddGraph"+$scope.sxId).remove();

          var svg = d3.select("#graphPlaceholder"+$scope.sxId).append("svg")
              .attr("id", "ddGraph"+$scope.sxId)
              .attr("width", "100%"/*width + margin.left + margin.right*/)
              .attr("height", height + margin.top + margin.bottom)
              .append("g")
              .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

          color.domain(d3.keys(data[0]).filter(function(key) { return key !== "date"; }));

          var pointsMap = color.domain().map(function(name, i) {
            return {
              name: name,
              values: data.map(function(d) {
                return {seriesIdx: i, name: name, date: d.date, value: +d[name]};
              })
            };
          });

          var xExtent = d3.extent(data, function(d) { return d.date; });
          var nxExtent = [d3.time.day.offset(xExtent[0], -20), d3.time.day.offset(xExtent[1], 20)];
          x.domain(nxExtent);
          //x.domain(d3.extent(data, function(d) { return d.date; }));

          y.domain([
            0,
            d3.max(pointsMap, function(c) { return d3.max(c.values, function(v) { return v.value; }); })
          ]);

          svg.append("g")
              .attr("class", "xaxis")
              .attr("transform", "translate(0," + height + ")")
              .call(xAxis);

          svg.append("g")
              .attr("class", "xaxis")
              .call(yAxis)
              .append("text")
              .attr("transform", "rotate(-90)")
              .attr("y", 6)
              .attr("dy", ".71em")
              .style("text-anchor", "end")
              .text($scope.sxYAxisLegend);

          var point = svg.selectAll(".point")
              .data(pointsMap)
              .enter().append("g")
              .attr("class", "point");

          var tip = d3.tip()
            .attr('class', 'd3-tip')
            .offset([-10, 0])
            .html(function (d) {
              return "<strong style='color:" + color(d.name) + "'>" + d.name.split(' ')[0] + ": </strong> <span>" + parseFloat(Math.round(d.value * 1000) / 1000).toFixed(3) + "</span>";
            });

          if (svg[0][0]) {
            svg.call(tip);
          }else{
            return; //non so bene a cosa serve questo controllo... ma evita eccezioni
          }

          switch($scope.sxChartType) {
            case 'line': // Line chart
              point.append("path")
                .attr("class", "line")
                .attr("d", function(d) { return line(d.values); })
                .attr("data-legend",function(d) { return d.name})
                .style("fill", "none")
                .style("stroke", function(d) { return color(d.name); })
                .on("mouseover", function(d) {
                  d3.select(this).style("opacity", 1);
                  var lines = $('.line').not(this);     //select all the rest of the lines, except the one you are hovering on and drop their opacity
                  d3.selectAll(lines)
                    .style("opacity", 0.2);
                })
                .on("mouseout", function(d) {
                  var lines = $('.line');     //select all the rest of the lines, except the one you are hovering on and drop their opacity
                  d3.selectAll(lines)
                    .style("opacity", 1);
                });

              // Tooltip
              if($scope.sxShowPoints === true) {
                // Disegna i pallini in corrispondenza dei punti
                // http://bl.ocks.org/ChrisJamesC/5896521/943f325deacb4a533e086d56478c1e76b6c6b4bd
                point.append("g").selectAll("circle")
                  .data(function (d) { return d.values; })
                  .enter()
                  .append("circle")
                  .attr("class", "circle")
                  .attr("r", 4)
                  .attr("cx", function (dd) { return x(dd.date) })
                  .attr("cy", function (dd) { return y(dd.value) })
                  .attr("fill", function (dd) { return color(dd.name); })
                  .attr("stroke", function (dd) { return color(dd.name); })
                  // Tooltip stuff after this [https://github.com/Caged/d3-tip]
                  .on("mouseover", tip.show)
                  .on("mouseout", tip.hide);
                };

                point.append("text")
                  .datum(function(d) { return {name: d.name, value: d.values[d.values.length - 1]}; })
                  .attr("transform", function(d) { return "translate(" + x(d.value.date) + "," + y(d.value.value) + ")"; })
                  .attr("x", 3)
                  .attr("dy", ".35em")
                  .text(function(d) { return d.name; });
              break;

            case 'bar': // Bar chart [http://bl.ocks.org/mbostock/3887051]
              var barWidth = ((width-150) / data.length) / pointsMap.length;
              var offset = (pointsMap.length%2!==0)?barWidth/2:0;

              point.selectAll("rect")
                .data(function (d) { return d.values; })
                .enter().append("rect")
                .attr("data-legend",function(d) { return d.name})
                .attr("class", function(d) { return "rect_"+ d.seriesIdx; })
                .attr("x", function (d) { return x(d.date) - d.seriesIdx * barWidth + offset; })
                .attr("y", function (d) { return y(d.value); })
                .attr("width", function (d) { return barWidth; })
                .attr("height", function (d) { return height - y(d.value); })
                .style("fill", function (d) { return color(d.name); })
                .on("mouseover", function(d) {
                  d3.select(this).style("opacity", 1);
                  var thisClass = d3.select(this).attr("class");
                  var bars = $("[class^=rect]").not($("[class^="+thisClass+"]"));     //select all the rest of the bars, except the one you are hovering on and drop their opacity
                  d3.selectAll(bars)
                    .style("opacity", 0.2);
                  tip.show(d);
                })
                .on("mouseout", function(d) {
                  var bars = $('[class^=rect]');     //select all the rest of the bars, except the one you are hovering on and drop their opacity
                  d3.selectAll(bars)
                    .style("opacity", 1);
                  tip.hide(d);
                });
              break;
          }



          var legend = svg.append("g")
              .attr("class","legend")
              .attr("transform","translate(50,30)")
              .style("font-size","9px")
              .call(d3.legend);
        };


        $(function() {
          $("#btnSave").click(function() {

            var svg = document.getElementById("ddGraph"+$scope.sxId).outerHTML;
            var options = { type: "data:image/svg+xml;base64" };
            SaveAs.download(svg, 'graph.svg', options);

            canvg('canvas', document.getElementById("ddGraph"+$scope.sxId).innerHTML, { forceRedraw: true, ignoreAnimation: true })
            html2canvas( [ document.getElementById("canvas") ], {
              onrendered: function(canvas) {
                document.body.appendChild(canvas);
              }
            });

          });
        });


        $scope.$watchCollection(
          function(scope) {
            if(angular.isDefined(scope.sxGraphData)){
              return scope.sxGraphData.concat([scope.sxXAxisFormat, scope.sxXAxisTicks, scope.sxInterpolate, scope.sxShowPoints, scope.sxChartType]);
            } else {
              return null;
            }
          },
          function(newValue, oldValue) {
            //$log.debug('reloading graph ' + $scope.sxId);
            $scope.showGraph();
          }
        );

        $scope.selectXAxisFormat = function(f) {
          $scope.sxXAxisFormat = f.value;
        };

        $scope.selectInterpolationType = function(t) {
          $scope.sxInterpolate = t.value;
        };

        $scope.selectChartType = function(t) {
          $scope.sxChartType = t.value;
        };

        $scope.formatForwardMapping = function(name, list) {
          var result;
          list.forEach(function(item) {
            if(item.name === name) {
              result = item.value;
            }
          });
          return result;
        };

        $scope.formatBackwardMapping = function(value, list) {
          var result;
          list.forEach(function(item) {
            if(item.value === value) {
              result = item.name;
            }
          });
          return result;
        };

        $scope.togglePoints = function() {
          $scope.sxShowPoints = !$scope.sxShowPoints;
        };
      }
    ]
);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixMultiSeriesLineChart
 * @description
 * # sixMultiSeriesLineChart
 */
angular.module('ictportal.theme')
  .directive('sixMultiSeriesLineChart', ['$log', function ($log) {
    return {
      template:
      '<style>#graphPlaceholder{{sxId}} {font: 10px monospace;}' +
        '.axis path, .axis line {fill: none; stroke: #000; shape-rendering: crispEdges;}'+
        '.x.axis path {display: none;}'+
        '.line {fill: none; stroke: steelblue;stroke-width: 2.0px;}' +
        //'.line:hover {stroke-width: 4.0px;}' +
        '.legend rect { fill:white; stroke:black; opacity:0.4; }' +
        '.custom-toolbar { margin-left: 0 }' +
        '.custom-navbar { min-height: 25px !important }' +
        '.custom-navbar-nav > li > a { padding: 8px 15px 8px 0px}' +
        '.custom-navbar-form { margin: 3px 15px 3px 0px}' +
        '.circle { fill-opacity: 0.2; }' +
        '.circle:hover { fill-opacity: 1; }' +
        '.d3-tip {                    ' +
        '  line-height: 1;            ' +
        '  font-weight: bold;         ' +
        '  padding: 12px;             ' +
        '  background: rgba(0, 0, 0, 0.8); ' +
        '  color: #fff;               ' +
        '  border-radius: 2px;        ' +
        '}                            ' +
        /* Creates a small triangle extender for the tooltip */
        'd3-tip:after {               ' +
        '  box-sizing: border-box;    ' +
        '  display: inline;           ' +
        '  font-size: 10px;           ' +
        '  width: 100%;               ' +
        '  line-height: 1;            ' +
        '  color: rgba(0, 0, 0, 0.8); ' +
        '  content: "p";          ' +
        '  position: absolute;        ' +
        '  text-align: center;        ' +
        '}                            ' +
        /* Style northward tooltips differently */
        'd3-tip.n:after {             ' +
        '  margin: -1px 0 0 0;        ' +
        '  top: 100%;                 ' +
        '  left: 0;                   ' +
        '}                            ' +
      '</style>'+
      '<nav class="navbar navbar-default custom-navbar" ng-show="sxHideToolbar !== \'true\' && sxGraphData && sxGraphData.length">' +
        '<div class="navbar-collapse custom-toolbar" id="toolbar">' +
          '<ul class="nav navbar-nav custom-navbar-nav">' +

            <!-- Asse x -->
            '<li>' +
              '<a href class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">' +
                '<i class="fa fa-arrows-h icon text-primary-dker"></i>' +
                '<span class="font-bold">: </span>' +
                '<span class="pull-right text-muted">' +
                  '<i class="fa fa-fw fa-angle-down text"></i>' +
                '</span>' +
                '<span class="font-bold">{{formatBackwardMapping(sxXAxisFormat, dateAxisFormats)}}</span>' +
              '</a>' +
              '<ul class="dropdown-menu">' +
                '<li ng-repeat="f in dateAxisFormats">' +
                  '<a href ng-click="selectXAxisFormat(f)">{{f.name}}</a>' +
                '</li>' +
              '</ul>' +
            '</li>' +
            <!-- Asse x: end -->

            <!-- Chart type -->
            '<li>' +
              '<a href class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">' +
                '<i class="fa fa-bar-chart icon text-success-dker"></i>' +
                '<span class="font-bold">: </span>' +
                '<span class="pull-right text-muted">' +
                  '<i class="fa fa-fw fa-angle-down text"></i>' +
                '</span>' +
                '<span class="font-bold">{{formatBackwardMapping(sxChartType, chartTypes)}}</span>' +
              '</a>' +
              '<ul class="dropdown-menu">' +
                '<li ng-repeat="t in chartTypes">' +
                  '<a href ng-click="selectChartType(t)">{{t.name}}</a>' +
                '</li>' +
              '</ul>' +
            '</li>' +
            <!-- Chart type: end -->

            <!-- Interpolation -->
            '<li>' +
              '<a href class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">' +
                '<i class="fa fa-line-chart icon text-info-dker"></i>' +
                '<span class="font-bold">: </span>' +
                '<span class="pull-right text-muted">' +
                  '<i class="fa fa-fw fa-angle-down text"></i>' +
                '</span>' +
                '<span class="font-bold">{{formatBackwardMapping(sxInterpolate, interpolationTypes)}}</span>' +
              '</a>' +
              '<ul class="dropdown-menu">' +
                '<li ng-repeat="t in interpolationTypes">' +
                  '<a href ng-click="selectInterpolationType(t)">{{t.name}}</a>' +
                '</li>' +
              '</ul>' +
            '</li>' +
            <!-- Interpolation: end -->

            <!-- Show Points -->
            '<li>' +
              '<a href ng-click="togglePoints()">' +
                '<i class="fa fa-fw fa-square-o icon" ng-if="!sxShowPoints"></i>' +
                '<i class="fa fa-fw fa-check-square-o icon" ng-if="sxShowPoints"></i>' +
                '<span class="font-bold"> Punti</span>' +
              '</a>' +
            '</li>' +
            <!-- Show Points: end -->

          '</ul>' +

          <!-- Asse x: ticks -->
          '<form class="navbar-form navbar-left custom-navbar-form" role="search">' +
            '<div class="input-group input-group-sm"> ' +
              '<span class="font-bold input-group-addon" id="basic-addon1">X Ticks</span>' +
              '<input style="width:75px; height: 30px" type="number" ng-model="sxXAxisTicks" class="form-control text-xs" maxlength="3"></input>' +
            '</div>' +
          '</form>' +
          <!-- Asse x ticks: end -->

          '<ul class="nav navbar-nav custom-navbar-nav navbar-left">' +
            '<li><input type="button" id="btnSave" class="btn btn-default btn-sm" value="Save"/></li>' +
          '</ul>' +

          '<ul class="nav navbar-nav custom-navbar-nav navbar-right">' +
            '<li><a href><span class="font-bold">{{sxGraphTitle}}</span></a></li>' +
          '</ul>' +
        '</div>' +
      '</nav>' +
      '<div id="graphPlaceholder{{sxId}}" ng-show="sxGraphData && sxGraphData.length"></div>' +
      '<canvas id="canvas" width=1200 height=350 style="display: none"></canvas>',
      restrict: 'E',
      scope: {
        sxGraphData: '=',
        sxId: '@', //da usare se si vogliono mettere più grafici!
        sxYAxisLegend: '=?',
        sxXAxisFormat: '=?',
        sxXAxisTicks: '=?',
        sxHideToolbar: '=?',
        sxGraphTitle: '@',
        sxSeriesColors: '=?',
        sxShowPoints: '=?',
        sxInterpolate: '=?', // basis (default), linear , step-after, etc... http://www.d3noob.org/2013/01/smoothing-out-lines-in-d3js.html
        sxChartType: '=?', // line, bar
        sxHeight: '=?'
      },
      controller: 'sixMultiSeriesLineChartCtrl'
    };
  }]);

'use strict';

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixPagination
 * @description
 * # sixPagination
 */
angular.module('ictportal.theme')
  .directive('sixPagination', function ($filter) {
    return {
      template: '<uib-pagination total-items="totalItems" ng-model="ngModel" items-per-page="itemsPerPage" max-size="maxSize" boundary-links="true" class="pagination-sm" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination>',
      restrict: 'E',
      scope: {
        ngModel: '=',
        totalItems: '=',
        maxSize: '=',
        itemsPerPage: '='
        //items: '=',
        //filterName: '@',
        //updateEvt: '=',
        //watchEvt: '='
      },
      link: function (scope, element, attrs) {
        //// $watch search to update pagination
        //scope.$watch('updateEvt', function (newVal, oldVal) {
        //  scope.filtered = $filter(scope.filterName)(scope.items, newVal);
        //  scope.totalItems = scope.filtered.length;
        //  //scope.maxSize = Math.ceil(scope.totalItems / scope.itemsPerPage);
        //  scope.ngModel = 1;
        //}, true);
        //
        //scope.$on('watchEvt', function (newVal, oldVal) {
        //  scope.filtered = $filter(scope.filterName)(scope.items, newVal);
        //  scope.totalItems = scope.filtered.length;
        //  //scope.maxSize = Math.ceil(scope.totalItems / scope.itemsPerPage);
        //  scope.ngModel = 1;
        //});
      }
    };
  });

'use strict';

 
/**
 * @ngdoc directive
 * @name emma.theme.directive:sixRecordSidebar
 * @description
 * # sixRecordSidebar
 *
 * <six-sidebar lookup-model="contatoreType" lookup-type="'schema'" lookup-field="'tipo_id'" lookup-filter="contatoreTypeFilter" ng-model="contatore.contatore_id" custom-class="'custom-sidebar'"></six-sidebar>
 */
angular.module('ictportal.theme')
  .directive('sixRecordSidebar', function () {
    return {
      template: '' +
      '<style type="text/css">' +
        '.floating-button {' +
          'position: fixed;' +
          'opacity: 0.5;' +
          'overflow: hidden;' +
          'text-align: center;' +
          'z-index: 99999999;' +
          'background-color: #1199C4;' +
          'color: #eeeeee;' +
          'width: 25px;' +
          'height: 25px;' +
          'padding-top: 2px;' +
          'border-top-right-radius: 10px;' +
          'border-bottom-right-radius: 10px;' +
          '-webkit-transition: all 0.5s ease-in-out;' +
          '-moz-transition: all 0.5s ease-in-out;' +
          '-ms-transition: all 0.5s ease-in-out;' +
          '-o-transition: all 0.5s ease-in-out;' +
          'transition: all 0.5s ease-in-out;' +
        '}' +
        '.selected {' +
          'background-color: #11c7f5 !important;' +
        '} ' +
      '</style> ' +
      '<div class="list-sidebar-overlay"></div> ' +
        '<aside id="list-sidebar" class="list-sidebar list-sidebar-default open list-sidebar-stacked {{customClass}}" role="navigation"> ' +
          '<div class="m-xs"> ' +
            '<six-lookup ng-model="lookupModel" sx-type="lookupType" sx-field="lookupField" sx-filter="lookupFilter" sx-placeholder="\'Tipo...\'" <!--sx-base-path="lookupBasePath"-->></six-lookup> ' +
          '</div> ' +
          '<ul class="nav list-sidebar-nav"> ' +
            '<li ng-if="!recordList || recordList.length == 0"> ' +
              '<a> ' +
                '<span ng-if="lookupModel && lookupModel[lookupField] && lookupModel[lookupField].description">Nessun {{lookupModel[lookupField].description}} caricato</span> ' +
                '<span ng-if="!lookupModel || !lookupModel[lookupField] || !lookupModel[lookupField].description">Selezionare un tipo di record</span> ' +
              '</a> ' +
            '</li> ' +
            '<span ng-if="recordList && recordList.length > 0"> ' +
              '<li> ' +
                '<div class="form-group m-l-xs m-r-xs"> ' +
                  '<six-search-form ng-model="recordSearchText.text" placeholder="Filtra..." hide-search-btn></six-search-form> ' +
                '</div> ' +
              '</li> ' +
              '<li ng-repeat="record in recordList | filter:recordSearchText.text"> ' +
                '<a ng-click="selectRecord(record.UUID, record.model.code, record.model.description)" title="{{record.model.code}} - {{record.model.description}}" ng-class="{\'selected\': isRecordSelected(record.UUID)}"> ' +
                  '{{record.model.code}} - {{record.model.description}} ' +
                '</a> ' +
              '</li> ' +
            '</span> ' +
          '</ul> ' +
        '</aside> ' +
        '<div class="list-sidebar-toggle floating-button" ng-click="toggleSidebar()"> ' +
          '<i ng-class="{\'fa fa-times\': isSidebarOpened==true, \'fa fa-bars\': isSidebarOpened==false}"></i> ' +
        '</div>',
      restrict: 'E',
      scope: {
        ngModel: '=',
        lookupType: '=',
        lookupBasePath: '=',
        lookupModel: '=',
        lookupField: '=',
        lookupFilter: '=',
        customClass: '='
      },
      link: function postLink(scope, element, attrs) {
        $(document).ready(function() {
          $('.list-sidebar-overlay').on('click', function() {
            $(this).removeClass('active');
            $('#list-sidebar').removeClass('open');
          });
        });
      },
      controller: function($scope, $element, baseFactory, $log) {
        $scope.isSidebarOpened = angular.element(document.getElementById('list-sidebar')).hasClass('open');
        $scope.recordList = [];

        $scope.lookupBasePath = $scope.lookupBasePath || 'record';

        $scope.loadRecords = function() {
          if($scope.lookupModel && $scope.lookupModel[$scope.lookupField] && $scope.lookupModel[$scope.lookupField].code) {
            $scope.recordList = baseFactory('record/'+$scope.lookupModel[$scope.lookupField].code+'/_lookup').select({pageSize: 1000});
          }
        };

        $scope.selectRecord = function(uuid, code, description) {
          if(uuid) {
            $scope.ngModel = {type: $scope.lookupModel[$scope.lookupField].code, UUID: uuid, code: code, description: description};
          }
        };

        $scope.isRecordSelected = function(uuid) {
          if($scope.ngModel) {
            return $scope.ngModel.UUID === uuid;
          }
          return false;
        };

        $scope.toggleSidebar = function() {
          var sidebar = angular.element(document.getElementById('list-sidebar'));
          var overlay = angular.element(document.getElementsByClassName('list-sidebar-overlay')[0]);

          sidebar.toggleClass('open');
          $scope.isSidebarOpened = sidebar.hasClass('open');
          if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass('open')) {
            overlay.addClass('active');
          } else {
            overlay.removeClass('active');
          }
        };

        $scope.$watchCollection(function() { return $scope.lookupModel; }, function( newValue, oldValue ) {
          $scope.recordList = [];
          if(newValue) {
            $scope.loadRecords();
          }
        });
      }
    };
  });

'use strict';

/**
 * @ngdoc directive
 * @name emma.theme.directive:searchForm
 * @description
 * # searchForm
 */
angular.module('ictportal.theme')
  .directive('sixSearchForm', function () {
    return {
      templateUrl: 'theme/directives/templates/sixsearchform.html',
      restrict: 'E',
      scope: {
        ngModel: '=',
        placeholder: '@',
        hideSearchBtn: '@',
        hideClearBtn: '@',
        cstKeyupFn: '&keyupFn',   // Custom keyup function
        cstClearFn: '&clearFn',   // Custom clear function
        cstSearchFn: '&searchFn',  // Custom search function
        cstOnChangeFn: '&changeFn'  // Custom change function
      },
      link: function postLink(scope, element, attrs) {
        if (!attrs.hasOwnProperty('hideSearchBtn')) {
          scope.hideSearchBtn = 'false';
        }
        if (!attrs.hasOwnProperty('hideClearBtn')) {
          scope.hideClearBtn = 'false';
        }
      },
      controller: function($scope, $element){
        $scope.keyupFn = function() {
          $scope.showClearBtn = Boolean($scope.ngModel) && ($scope.hideClearBtn === 'false');
          if($scope.cstKeyupFn) {
            $scope.cstKeyupFn();
          }
        };

        $scope.clearSearchFn = function() {
          $scope.ngModel = "";
          $scope.showClearBtn = false;
          if($scope.cstClearFn) {
            $scope.cstClearFn();
          }
        };

        $scope.searchFn = function() {
          if($scope.cstSearchFn) {
            $scope.cstSearchFn();
          }
        };

        $scope.changeFn = function() {
          if($scope.cstOnChangeFn) {
            $scope.cstOnChangeFn();
          }
        };
      }
    };
  });

'use strict';

angular.module('ictportal.theme').controller('sixSelectCtrl',
  ['$scope', '$log', function ($scope, $log) {

    $scope.object;
    if(angular.isUndefined($scope.sxShowDescription)) { $scope.sxShowDescription = false; }
    $scope.sxDescriptionClass = $scope.sxDescriptionClass || 'font-bold';

    $scope.select = function (item) {
      $scope.object = item;
      $scope.ngModel = item;
      if($scope.sxSelect) {
        $scope.sxSelect();
      }
    };

    $scope.clearSelect = function () {
      $scope.select(undefined);
      if($scope.sxClearSelect) {
        $scope.sxClearSelect();
      }
    };

    $scope.getSelectMatch = function(obj) {
      if(angular.isUndefined(obj)) { return undefined; }
      if(angular.isUndefined(obj.description)) { return obj.code; }
      if(!angular.isUndefined(obj.description)) { return obj.description; }
      return undefined;
    };

    $scope.$watch(function() { return $scope.ngModel; }, function(newValue, oldValue) {
      // TODO va bene commentare? altrimenti non si riesce a sbiancare la lookup dall'esterno...
      //if(newValue) {
        $scope.object = $scope.ngModel;
      //}
    });
}]);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixSelect
 * @description
 * # sixSelect
 */
angular.module('ictportal.theme')
  .directive('sixSelect', function () {
    return {
      template:
      '<div class="input-group has-button" style="width: 100%">' +
        '<ui-select ng-model="ngModel" theme="bootstrap" on-select="select($item)" reset-search-input="false" ng-disabled="sxDisabled">' +
          '<ui-select-match class="ui-select-match" placeholder="Enter...">{{getSelectMatch(object)}}</ui-select-match>' +
          '<ui-select-choices class="ui-select-choices" repeat="item in sxItemList track by $index">' +
            '<div ng-bind-html="item.description | highlight: $select.search"></div>' +
            '<small ng-bind-html="item.code | highlight: $select.search"></small>' +
          '</ui-select-choices>' +
        '</ui-select>' +
        '<span class="input-group-btn">' +
          '<button type="button" class="btn btn-bg btn-default" ng-click="clearSelect()" ng-disabled="sxDisabled"><i class="fa fa-times"></i></button>' +
        '</span>' +
      '</div>' +
      '<div ng-if="sxShowDescription === true" class="{{sxDescriptionClass}}">' +
        '{{ngModel.description}}' +
      '</div>',
      restrict: 'E',
      scope: {
        ngModel: '=',
        sxItemList: '=',
        sxShowDescription: '=?',
        sxDescriptionClass: '=?',
        sxSelect: '&',
        sxClearSelect: '&',
        sxDisabled: '=?'
      },
      controller: 'sixSelectCtrl'
    };
  });

'use strict';


angular.module('ictportal.theme').controller('sixSelect2Ctrl',
    ['$scope', '$rootScope', '$log', 'baseFactory', 'schemaFactory', 'dialogService', 'recordFactory', 'lookupFactory', 'counterFactory', 'toaster', '$q', '$filter', 'DATA_SET_URL',
      function ($scope, $rootScope, $log, baseFactory, schemaFactory, dialogService, recordFactory, lookupFactory, counterFactory, toaster, $q, $filter, DATA_SET_URL) {

        /**** VARIABLES INIT *****/

        if(angular.isUndefined($scope.sxObject)) { $scope.sxObject = {}; }                // oggetto completo da restituire al chimante della six-lookup-2
        if(angular.isUndefined($scope.sxClearable)) { $scope.sxClearable = true; }
        if(angular.isUndefined($scope.sxPinnable)) { $scope.sxPinnable = false; }         // indica se la sidebar può essere bloccata o meno
        if(angular.isUndefined($scope.sxVisible)) { $scope.sxVisible = false; }           // indica se la sidebar è visibile o meno
        if(angular.isUndefined($scope.sxMultiple)) { $scope.sxMultiple = false; }         // indica se la lookup deve gestire valori multipli o singoli
        if(angular.isUndefined($scope.sxPlaceholder)) { $scope.sxPlaceholder = ($scope.sxTitle || $scope.sxType || 'Seleziona').toLowerCase() + '...'; }
        if(angular.isUndefined($scope.sxEmptyPlaceholder)) { $scope.sxEmptyPlaceholder = $scope.sxPlaceholder; }
        if(angular.isUndefined($scope.sxRequired)) { $scope.sxRequired = false; }
        $scope.sxKey              = $scope.sxKey || 'key';                  // nome dell'attributo che funge da key
        $scope.sxDescription      = $scope.sxDescription || 'description';  // nome dell'attributo che funge da description
        $scope.sxDescriptionClass = $scope.sxDescriptionClass || 'font-bold';
        $scope.sxPosition         = $scope.sxPosition || 'left';  // posizione della sidebar (left|right)
        $scope.sxDimension        = $scope.sxDimension || 'l';    // dimensione della sidebar (s|m|l)
        $scope.valueToShow        = undefined;                    // valore selezionato da mostrare nella input text della lookup se singola
        $scope.sxPinned           = isMultiple();                 // indica se la sidebar è bloccata o meno (inizializzata qui)
        $scope.sxMaxSelected      = $scope.sxMaxSelected || -1;   // indica il limite di elementi selezionabili se isMultiple = true (infiniti quando sxMaxSelected <= 0)

        $scope.filter = { text: '' };


        setPlaceholder();   // inizializzo il placeholder da mostrare

        // $scope.sxList = [
        //   { key: key, description: description }
        // ];

        /**** LIST FUNCTIONS *****/

        function refreshList() {
          var deferred = $q.defer();
          deferred.resolve($scope.sxList);
          return deferred.promise;
        }

        function isEmpty () {   // se il campo è multiplo e con lunghezza pari a zero, o se è singolo e null/undefined
          var model = $scope.ngModel;
          if($scope.sxField) {
            model = $scope.ngModel[$scope.sxField]
          }

          return (
            (isMultiple() && model.length == 0) ||
            (!isMultiple() && (model == null || model == undefined))
          );
        }

        /**** VALUE FUNCTIONS *****/

        function addOrSetValue(value){
          if(isMultiple()) {
            if($scope.sxField) {
              checkAndAdd($scope.ngModel[$scope.sxField], value);
            } else {
              checkAndAdd($scope.ngModel, value);
            }
          } else {
            if($scope.sxField) {
              $scope.ngModel[$scope.sxField] = value;
            } else {
              $scope.ngModel = value;
            }
          }
          setPlaceholder();
        }

        function setValueToShow(value) {
          if(value) {
            if($scope.sxItemTemplate) {
              $scope.valueToShow = $scope.evaluateTemplate($scope.sxItemTemplate, value);
            } else {
              $scope.valueToShow = (value[$scope.sxKey] ? value[$scope.sxKey] + ' - ' : '') + $filter('cut')(value[$scope.sxDescription], true, 100, '...');
            }
          } else {
            $scope.valueToShow = undefined;
          }
        }

        function checkAndAdd(list, value) {
          if($scope.sxMaxSelected > 0  && list.length == $scope.sxMaxSelected) {
              $log.debug('max selected item reached! ' + list.length + ' (max is )' + $scope.sxMaxSelected);
              toaster.pop('error', 'Limite raggiunto', 'Limite massimo di elementi selezionabili raggiunto (' + $scope.sxMaxSelected + ')');
          } else {
            var found = list.some(function (el) {
              return el[$scope.sxKey] === value[$scope.sxKey];
            });
            if (!found) {
              list.push(value);
            }
          }
        }

        function unsetValue() {
          var changed = true;
          if(angular.isUndefined($scope.sxField)){
            changed = !isCleanValue($scope.ngModel);
            if(isMultiple()) {
              $scope.ngModel = [];
            } else {
              $scope.ngModel = undefined;
              setValueToShow($scope.ngModel);
            }
          } else{
            changed = !isCleanValue($scope.ngModel[$scope.sxField]);
            if(isMultiple()) {
              $scope.ngModel[$scope.sxField] = [];
            } else {
              $scope.ngModel[$scope.sxField] = undefined;
              setValueToShow($scope.ngModel[$scope.sxField]);
            }
          }
          setPlaceholder();
          return changed;
        }

        function isCleanValue(val) {
          if (angular.isArray(val)) {
            return val.length == 0;
          }
          return angular.isUndefined(val) || val == null;
        }

        function getValue(){
          if($scope.ngModel && $scope.sxField){
            return $scope.ngModel[$scope.sxField];
          } else {
            return $scope.ngModel;
          }
        }

        $scope.toggleSelect = function(item) {
          if($scope.isItemSelected(item)) {
            $scope.unselect(item);
          } else {
            $scope.select(item);
          }
        };

        $scope.select = function (item) {
          addOrSetValue(item);
          if(!$scope.sxPinned) {
            closeLookup();
          }
          if(angular.isDefined($scope.sxOnSelect) && angular.isFunction($scope.sxOnSelect)) {
            $scope.sxOnSelect({item: item}); //callback
          }
        };

        $scope.unselect = function(item) {
          if(isMultiple()) {
            var idx = getValue().findIndex(function(v) { return v[$scope.sxKey] === item[$scope.sxKey]; });
            if (idx > -1) {
              getValue().splice(idx, 1);
            }
          } else {
            unsetValue();
          }
          if(angular.isDefined($scope.sxOnSelect)){
            $scope.sxOnSelect();
          }
        };

        $scope.selectAll = function() {
          $filter('filter')($scope.sxList, $scope.filter.text).forEach(function(item) {
            $scope.select(item);
          });
        };

        $scope.unselectAll = function() {
          $scope.clearSelect();
        };

        $scope.clearSelect = function() {
          if(!$scope.sxDisabled) {
            var changed = unsetValue();
            refreshList();
            if (changed && angular.isDefined($scope.sxOnSelect)) {
              $scope.sxOnSelect();
            }
          }
        };

        $scope.isItemSelected = function(item) {
          var selectedValue = getValue();
          if(selectedValue && isMultiple()) {
            var found = false;
            selectedValue.forEach(function(i) {
              found |= (i[$scope.sxKey] == item[$scope.sxKey]);
            });
            return found;
          } else if(selectedValue) {
            return selectedValue[$scope.sxKey] == item[$scope.sxKey];
          }
          return false;
        };



        /**** WATCHERS *****/

        $scope.$watchCollection(function(scope) {
            if(angular.isDefined(scope.ngModel)) {
              if (angular.isUndefined($scope.sxField)) {
                return scope.ngModel;
              } else {
                return scope.ngModel[$scope.sxField];
              }
            }
          },
          function(newValue, oldValue) {
            if(!isMultiple()) {
              if ($scope.ngModel && $scope.sxField) {
                setValueToShow($scope.ngModel[$scope.sxField]);
              } else if($scope.ngModel) {
                setValueToShow($scope.ngModel);
              } else {
                setValueToShow();
              }
            }
          }
        );

        $scope.$watch('sxVisible', function(newVal, oldVal) {
          // chiudo tuttle le altre lookup e passo il mio id per comunicare che devo restare aperta solo io
          if(newVal === true && oldVal != true) {
            $rootScope.$broadcast('closeSixLookup2', {id: $scope.sxId});
          }
        });

        $rootScope.$on('closeSixLookup2', function($event, args) {
          if(args && args.id != $scope.sxId) {  // se non ho lanciato io il broadcast mi chiudo
            closeLookup();
          }
        });

        $rootScope.$on('SchemaFormValidate', function() {
          if($scope.sxRequired && isEmpty()) {
            $scope.ngInvalid = true;
            $scope.ngValid = false;
          } else if ($scope.sxRequired && !isEmpty()){
            $scope.ngInvalid = false;
            $scope.ngValid = true;
          }
        });


        /**** FILTERS FUNCTIONS ****/

        $scope.clearSearchFn = function() {
          $scope.filter.text = '';
        };


        /**** OTHER ****/

        $scope.onFocusItCB = function() {
          if(!$scope.sxDisabled) {
            $scope.sxVisible = true;
          }
        };

        function closeLookup() {
          $scope.sxVisible = false;
        }

        function isMultiple() {
          return ($scope.sxMultiple === true || $scope.sxMultiple === 'true');
        }

        $scope.isMultiple = isMultiple;

        $scope.showKey = function() {
          return ($scope.sxShowKey === true || $scope.sxShowKey === 'true');
        };

        function setPlaceholder() {
          if(!$scope.ngModel || !$scope.ngModel[$scope.sxField] || $scope.ngModel[$scope.sxField].length == 0) {
            $scope.placeholder = $scope.sxEmptyPlaceholder;
          } else {
            $scope.placeholder = $scope.sxPlaceholder;
          }
        }

        /**** TEMPLATE ****/

        $scope.evaluateTemplate = function(template, item) {
          return template.replace(/{{item\.(.*?)}}/g, function(match, token) {
            var tokens = token.split('.');
            return _evaluateTemplate(item, tokens);
          });
        };

        function _evaluateTemplate(item, tokens) {
          if(!tokens || tokens.length == 0) {
            return item;
          } else {
            return _evaluateTemplate(item[tokens[0]], tokens.slice(1));
          }
        }
      }

    ]
);

/**
 * @ngdoc directive
 * @name ictportal.theme.directive:sixLookup
 * @description
 * # sixLookup
 */
angular.module('ictportal.theme')
  .directive('sixSelect2', ['$log','baseFactory', function ($log, baseFactory) {
    return {
      templateUrl: 'theme/directives/templates/sixselect2.html',
      restrict: 'E',
      scope: {
        sxId: '@',
        ngModel: '=',
        sxField: '=?', //nome del campo nell'oggetto che mi referenzia (FIXME sembra non funzionare se sxMultiple = true)
        showDebug: '=?',
        sxDebug: '=?',
        sxSearchPrefix: '=?',
        sxKey: '=?',          // nome dell'attributo che funge da key
        sxDescription: '=?',  // nome dell'attributo che funge da description
        sxDisabled: '=?',
        sxPlaceholder: '=?',      // placeholder mostrato quando la selezione è vuota (viene sempre mostrato in caso di selezione multipla)
        sxEmptyPlaceholder: '=?', // placeholder mostrato quando la selezione multipla è vuota
        sxTitle: '=?',
        sxPosition: '=?',   // posizione della sidebar: 'left'/'right'
        sxDimension: '=?',  // dimensione sidebar: 's'/'m'/'l'
        sxPinnable: '=?',
        sxVisible: '=?',
        sxMultiple: '@',
        sxMaxSelected: '@?',  // limite massimo di elementi selezionabili se isMultiple=true (infiniti quando sxMaxSelected <= 0)
        sxList: '=',
        sxClearable: '=?',
        sxCompact: '=?',
        sxOnSelect: '&?',
        sxRequired: '=?',
        sxItemTemplate: '=?',
        sxItemTemplateUrl: '=?'
      },
      transclude: true,
      controller: 'sixSelect2Ctrl'
    };
  }]);

'use strict';

angular.module('ictportal.theme').controller('sixSelectStatusCtrl',
  function ($scope, baseFactory, $log) {

    $scope.object;

    $scope.sxItemList = [];

    $scope.getAvailableStates = function (){
      baseFactory('issue/record/_states').show().$promise.then(function (response) {
        $scope.sxItemList = response.result;
      });
    };

    if(angular.isUndefined($scope.sxShowDescription)) { $scope.sxShowDescription = false; }
    $scope.sxDescriptionClass = $scope.sxDescriptionClass || 'font-bold';

    $scope.getAvailableStates();

    $scope.select = function (item) {
      $scope.object = item.code;
      $scope.ngModel = item.code;
      if($scope.sxSelect) {
        $scope.sxSelect();
      }
    };

    $scope.clearSelect = function () {
      $scope.select(undefined);
      if($scope.sxClearSelect) {
        $scope.sxClearSelect();
      }
    };

    $scope.getSelectMatch = function(obj) {
      if(angular.isUndefined(obj)) { return undefined; }
      // if(angular.isUndefined(obj.description)) { return obj.code; }
      // if(!angular.isUndefined(obj.description)) { return obj.description; }
      return obj;
    };

    $scope.$watch(function() { return $scope.ngModel; }, function(newValue, oldValue) {
      // TODO va bene commentare? altrimenti non si riesce a sbiancare la lookup dall'esterno...
      //if(newValue) {
        $scope.object = $scope.ngModel;
      //}
    });
});

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixSelectStatus
 * @description
 * # sixSelectStatus
 */
angular.module('ictportal.theme')
  .directive('sixSelectStatus', function () {
    return {
      template:
      '<div class="input-group has-button" style="width: 100%">' +
        '<ui-select ng-model="ngModel" theme="bootstrap" on-select="select($item)" reset-search-input="false" ng-disabled="sxDisabled">' +
          '<ui-select-match class="ui-select-match" placeholder="Enter...">{{getSelectMatch(object)}}</ui-select-match>' +
          '<ui-select-choices class="ui-select-choices" repeat="item in sxItemList track by $index">' +
            '<div ng-bind-html="item.code | highlight: $select.search"></div>' +
            '<small ng-bind-html="item.code | highlight: $select.search"></small>' +
          '</ui-select-choices>' +
        '</ui-select>' +
        '<span class="input-group-btn">' +
          '<button type="button" class="btn btn-bg btn-default" ng-click="clearSelect()" ng-disabled="sxDisabled"><i class="fa fa-times"></i></button>' +
        '</span>' +
      '</div>' +
      '<div ng-if="sxShowDescription === true" class="{{sxDescriptionClass}}">' +
        '{{ngModel.description}}' +
      '</div>',
      restrict: 'E',
      scope: {
        ngModel: '=',
        sxItemList: '=?',
        sxShowDescription: '=?',
        sxDescriptionClass: '=?',
        sxSelect: '&',
        sxClearSelect: '&',
        sxDisabled: '=?'
      },
      controller: 'sixSelectStatusCtrl'
    };
  });

'use strict';

angular.module('ictportal.theme').controller('sixSelectUserCtrl',
  function ($scope, dbBaseFactory, $log) {

    $scope.object;

    $scope.sxItemList = [];

    $scope.getUsers = function (){
      dbBaseFactory('user').search(
        {
          'search':{
            'obj': {
              'searchString' : $scope.searchString,
              'attivo':'T'
            }
          },
          'init':
          {
            'username':true,
            'surname':true,
            'name':true,
            'email':true
          }
        }
        /*{query: getQuery(), page: paginationOptions.pageNumber, pageSize: paginationOptions.pageSize,
         sortFields: defaultSort(), history: $scope.isSnapshot()
         }*/
      ).$promise.then(function(result) {
        $scope.sxItemList = result.list;
      });

    };

    if(angular.isUndefined($scope.sxShowDescription)) { $scope.sxShowDescription = false; }
    $scope.sxDescriptionClass = $scope.sxDescriptionClass || 'font-bold';

    $scope.getUsers();

    $scope.select = function (item) {
      $scope.object = item;
      $scope.ngModel = item;
      console.log(item);
      if($scope.sxSelect) {
        $scope.sxSelect();
      }
    };

    $scope.clearSelect = function () {
      $scope.select(undefined);
      if($scope.sxClearSelect) {
        $scope.sxClearSelect();
      }
    };

    $scope.getSelectMatch = function(obj) {
      if(angular.isUndefined(obj) || obj == null) { return undefined; }
      return obj.username;
    };

    $scope.$watch(function() { return $scope.ngModel; }, function(newValue, oldValue) {
      // TODO va bene commentare? altrimenti non si riesce a sbiancare la lookup dall'esterno...
      //if(newValue) {
        $scope.object = $scope.ngModel;
      //}
    });
});

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixSelectUser
 * @description
 * # sixSelectuser
 */
angular.module('ictportal.theme')
  .directive('sixSelectUser', function () {
    return {
      template:
      '<div class="input-group has-button" style="width: 100%">' +
        '<ui-select ng-model="ngModel" theme="bootstrap" on-select="select($item)" reset-search-input="false" ng-disabled="sxDisabled">' +
          '<ui-select-match class="ui-select-match" placeholder="Enter...">{{getSelectMatch(object)}}</ui-select-match>' +
          '<ui-select-choices class="ui-select-choices" repeat="item in sxItemList track by $index">' +
            '<div ng-bind-html="item.surname | highlight: $select.search"></div> ' +
            '<small ng-bind-html="item.surname | highlight: $select.search"></small> <small ng-bind-html="item.name | highlight: $select.search"></small>' +
          '</ui-select-choices>' +
        '</ui-select>' +
        '<span class="input-group-btn">' +
          '<button type="button" class="btn btn-bg btn-default" ng-click="clearSelect()" ng-disabled="sxDisabled"><i class="fa fa-times"></i></button>' +
        '</span>' +
      '</div>' +
      '<div ng-if="sxShowDescription === true" class="{{sxDescriptionClass}}">' +
        '{{ngModel.description}}' +
      '</div>',
      restrict: 'E',
      scope: {
        ngModel: '=',
        sxItemList: '=?',
        sxShowDescription: '=?',
        sxDescriptionClass: '=?',
        sxSelect: '&',
        sxClearSelect: '&',
        sxDisabled: '=?'
      },
      controller: 'sixSelectUserCtrl'
    };
  });

'use strict';


angular.module('ictportal.theme').controller('sixSendEmailCtrl',
  ['$scope', 'notificationFactory', 'salAttachmentsFactory', '$log', 'toaster', function ($scope, notificationFactory, salAttachmentsFactory, $log, toaster) {



        $scope.getAttachmentsList = function(){
          salAttachmentsFactory.search({id: null}).$promise.then(function (response) {
            if(response.list){
              response.list.forEach(function (currentItem){
                var objectId = currentItem.model.object_id.replace('workspace://SpacesStore/', '$WorkspaceSpacesStore$');
                $scope.attachmentsList.push({key: objectId, description: currentItem.model.title});
              });
            } else {
              $scope.attachmentsList = [];
            }
          });
        };

        $scope.initTinyMce = function(){
            window.tinymce.dom.Event.domLoaded = true;
            tinymce.init({
                selector: 'textarea#message',
                theme: 'modern',
                /*width: 600,*/
                height: 300,
                plugins: [
                    'advlist autolink link image lists charmap print preview hr anchor pagebreak',
                    'searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime nonbreaking',
                    'save table contextmenu directionality template paste textcolor'
                ],
                /*content_css: [
                    '//www.tinymce.com/css/codepen.min.css'
                ],*/
                toolbar: 'insertfile undo redo | fontsizeselect fontselect styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link | print preview fullpage | forecolor backcolor',
                menu: {
                    file: {title: 'File', items: 'print'},
                    edit: {title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall'},
                    insert: {title: 'Insert', items: 'link hr'},
                    view: {title: 'View', items: 'preview'},
                    format: {title: 'Format', items: 'bold italic underline strikethrough superscript subscript | formats'},
                    table: {title: 'Table', items: 'inserttable tableprops deletetable | cell row column'},
                    tools: {title: 'Tools', items: 'spellchecker code'}
                },
                language_url : '/theme/attachments/it.conf',
                language: 'it',
                force_br_newlines : false,
                force_p_newlines : false,
                forced_root_block : ''
            });
            if (tinymce.editors.length>0) {
                tinymce.execCommand('mceFocus', true, "message");
                tinymce.execCommand('mceRemoveEditor',true, "message");
                tinymce.execCommand('mceAddEditor',true, "message");
            }
        };

        $scope.save = function(){

        };

        $scope.sendEmail = function(){
          $scope.message = tinyMCE.activeEditor.getContent({format : 'raw'});
          var payload = {
               to: $scope.to,
               cc: $scope.cc,
               subject: $scope.title,
               body: $scope.message,
               type_mail: $scope.sxTypeMail,
               record_id: $scope.sxRecordId,
               alfresco_attachments: null
          };
          if($scope.attachments.selected.length > 0){
            $scope.attachments.selected.forEach(function(element, index) {
              if(index == 0){
                payload.alfresco_attachments = element.key;
              } else {
                payload.alfresco_attachments = payload.alfresco_attachments + ',' + element.key;
              }
            });
          }
          notificationFactory().sendEmail(payload).$promise.then(function(response) {
                  toaster.pop('success', 'Eseguito', 'Email inviata con successo');
          })
        };

        function isInit(data){
          return ((angular.isDefined(data) && data != null));
        }

        $scope.$watchGroup(['sxBodyMail', 'sxToMail'], function() {
          if(isInit($scope.sxBodyMail) && isInit($scope.sxToMail)){
            $scope.message = $scope.sxBodyMail;
            $scope.to = $scope.sxToMail;
            if($scope.sxTitleMail){
              $scope.title = $scope.sxTitleMail;
            }
            if($scope.sxCcMail){
              $scope.cc = $scope.sxCcMail;
            }
            $scope.init();
          }
        });

        $scope.init = function(){
            setTimeout(function() {
                $scope.initTinyMce();
            }, 50);
        };


        $scope.attachmentsList = [];
        $scope.attachments = {selected: []};

        $scope.to = "";
        $scope.cc = "";
        $scope.title = "Titolo di esempio";
        $scope.message = "Messaggio di esempio";
        if(angular.isUndefined($scope.sxAlfrescoAttachments)) {
          $scope.sxAlfrescoAttachments = false;
        } else {
          if($scope.sxAlfrescoAttachments){
            $scope.getAttachmentsList();
          }
        }
    } // End of controller function
  ]
);



/**
 * @ngdoc directive
 * @author Rita Beltrami 27/04/2016
 * @name emma.theme.directive:sixSendEmail
 * @description Form to send emails
 * # sixSendEmail
 */
angular.module('ictportal.theme')
  .directive('sixSendEmail', function () {
    return {
      template: '<div id="tinymce_id">' +
                    '<row>' +
                        '<div class="form-group schema-form-text">' +
                            '<label for="receiver">Destinatari</label>' +
                            '<input type="text" placeholder="" class="form-control" id="receiver" ng-model="to" >' +
                        '</div>' +
                    '</row>' +
                    '<row>' +
                    '<div class="form-group schema-form-text">' +
                    '<label for="cc">Cc</label>' +
                    '<input type="text" placeholder="" class="form-control" id="cc" ng-model="cc" >' +
                    '</div>' +
                    '</row>' +
                    '<row>' +
                        '<div class="form-group schema-form-text">' +
                            '<label for="title">Titolo</label>' +
                            '<input type="text" placeholder="" class="form-control" id="title" ng-model="title" >' +
                        '</div>' +
                    '</row>' +
                    '<row ng-if="sxAlfrescoAttachments == true">' +
                      '<div class="form-group schema-form-text">' +
                        '<label for="title">Allegati</label>' +
                            // '<six-lookup-2 sx-id="attachments"' +
                            // 'sx-base-path="\'record\'"' +
                            // 'sx-type="\'salattachment\'"' +
                            // 'sx-title="\'Allegati\'"' +
                            // 'ng-model="attachments"' +
                            // 'sx-field="\'selected\'"' +
                            // 'sx-show-filters="true"' +
                            // 'sx-show-details="true"' +
                            // 'sx-add="true"' +
                            // 'sx-multiple="true">' +
                            // '</six-lookup-2>' +
                            '<six-select-2 sx-id="attachments"' +
                            'sx-list="attachmentsList"' +
                            'sx-title="\'Allegati...\'"' +
                            'ng-model="attachments"' +
                            'sx-field="\'selected\'"' +
                            'sx-multiple="true"' +
                            'sx-show-key="false">' +
                            '</six-select-2>' +
                      '</div>' +
                    '</row>' +
                    '<ng-transclude></ng-transclude>' +
                    '<row>' +
                        '<div class="form-group schema-form-text">' +
                            '<label for="message">Messaggio</label>' +
                            '<textarea ng-model="message" id="message"></textarea>' +
                        '</div>' +
                    '</row>' +
                    '<row>' +
                        '<div class="pull-right">' +
                            '<button ng-click="sendEmail()" type="button" class="btn btn-info pull-right">' +
                                '<i class="fa fa-envelope"></i>&nbsp;Invia' +
                            '</button>' +
                        '</div>' +
                    '</row>' +
                '</div>',
      transclude: true,
      scope: {
        sxRecordId: '=?',
        sxTypeMail: '=?',
        sxTitleMail: '=?',  // titolo del messaggio
        sxBodyMail: '=?',   // contenuto del messaggio
        sxToMail: '=?',     // destinatari
        sxCcMail: '=?',      // destinatari in cc
        sxAlfrescoAttachments: '=?' // riferimenti agli oggetti allegati
      },
      controller: 'sixSendEmailCtrl'
    };
  });

'use strict';

function makeId() {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

  for( var i=0; i < 10; i++ )
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixSidebar
 * @description
 * # sixSidebar
 *
 * Di default, quando si clicca sul contenuto della sidebar (se questa non è pinnata - sxPinned=true), la sidebar si chiude.
 * Per fare in modo che il click su un elemento causi la chiusura automatica, inserire l'attributo 'six-sidebar-autoclose=true'.
 * Es. <input id="filter" type="search" class="form-control" placeholder="Filtra..." ng-model="filter.text" six-sidebar-autoclose="false">
 */
angular.module('ictportal.theme')
  .directive('sixSidebar', function () {
    return {
      templateUrl: 'theme/directives/templates/sixsidebar.html',
      restrict: 'E',
      scope: {
        sxId: '@',          // id della sidebar
        sxTitle: '=?',      // titolo della sidebar
        sxShowTitle: '=?',  // titolo della sidebar
        sxClass: '@?',      // ulteriori classi custom da aggiungere alla sidebar
        sxPosition: '@?',   // posizione della sidebar: 'left'/'right'
        sxDimension: '@?',  // dimensione sidebar: 's'/'m'/'l'
        sxPinned: '=?',     // stato della sidebar (pinned/unpinned)
        sxOpened: '=?',     // stato della sidebar (aperta/chiusa)
        sxClosable: '@?',   // mostra/nasconde il pulsante per chiudere la sidebar
        sxPinnable: '@?'    // mostra/nasconde il pulsante per 'pinnare' la sidebar
      },
      transclude: true,
      link: function postLink(scope, element, attrs) {
        scope.sxId = scope.sxId || makeId();

        $(document).ready(function() {
          var PINNED_CLASS = 'sidebar-pinned';
          var OPENED_CLASS = 'open';
          var opened = (scope.sxOpened === true || scope.sxOpened === 'true');
          var pinned = (scope.sxPinned === true || scope.sxPinned === 'true');

          var sidebar = angular.element(document.getElementById(scope.sxId));
          opened ? sidebar.addClass(OPENED_CLASS) : sidebar.removeClass(OPENED_CLASS);
          pinned ? sidebar.addClass(PINNED_CLASS) : sidebar.removeClass(PINNED_CLASS);

          // moving the content (constructor class) to the right or left
          if(opened && pinned) {
            var constructors = angular.element(document.getElementsByClassName('constructor'));
            constructors.addClass('sixsidebar-' + scope.sxDimension + '-' + scope.sxPosition + '-padded');
          }

          function smartCloseSidebar() {
            if(scope.sxPinned !== true && scope.sxPinned !== 'true') {
              scope.$apply(scope.closeSidebar);
            }
          }
          $('.list-sidebar-overlay').on('click', smartCloseSidebar);
        });

        $(window).resize(function() {
          var sidebar = angular.element(document.getElementById(scope.sxId));
          var height = $(window).height() - sidebar.prop('offsetTop');
          sidebar.css('height', height + 'px')
        });
      },
      controller: function($scope, $element, baseFactory, $log, $rootScope, $timeout) {

        // CONSTANTS
        var PINNED_CLASS  = 'sidebar-pinned';
        var OPENED_CLASS  = 'open';
        var OVERLAY_CLASS = 'list-sidebar-overlay';

        // VARIABLES
        $scope.sxPosition   = $scope.sxPosition || 'left';
        $scope.sxDimension  = $scope.sxDimension || 'm';
        $scope.sxClass      = $scope.sxClass || '';
        $scope.sxPinned     = angular.isUndefined($scope.sxPinned) ? false : ($scope.sxPinned === true || $scope.sxPinned === 'true');
        $scope.sxOpened     = angular.isUndefined($scope.sxOpened) ? true : ($scope.sxOpened === true || $scope.sxOpened === 'true');
        $scope.sxClosable   = angular.isUndefined($scope.sxClosable) ? true : ($scope.sxClosable === true || $scope.sxClosable === 'true');
        $scope.sxPinnable   = angular.isUndefined($scope.sxPinnable) ? true : ($scope.sxPinnable === true || $scope.sxPinnable === 'true');
        $scope.sxShowTitle  = angular.isUndefined($scope.sxShowTitle) ? true : ($scope.sxShowTitle === true || $scope.sxShowTitle === 'true');

        // INIT
        $element.addClass('sidebar-'+$scope.sxDimension+'-'+$scope.sxPosition);



        //***************************//
        //**** SHOW/HIDE SIDEBAR ****//
        //***************************//

        $scope.toggleSidebar = function() {
          var sidebar = angular.element(document.getElementById($scope.sxId));
          var overlay = angular.element(document.getElementsByClassName(OVERLAY_CLASS)[0]);

          sidebar.toggleClass(OPENED_CLASS);
          $element.toggleClass(OPENED_CLASS);
          $scope.sxOpened = sidebar.hasClass(OPENED_CLASS);
          if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass(OPENED_CLASS)) {
            overlay.addClass('active');
          } else {
            overlay.removeClass('active');
          }

          // move the content (constructor class) to the right or left
          if(sidebar.hasClass(PINNED_CLASS)) {
            var constructors = angular.element(document.getElementsByClassName('constructor'));
            constructors.toggleClass('sixsidebar-' + $scope.sxDimension + '-' + $scope.sxPosition + '-padded');
          }
        };

        $scope.openSidebar = function() {
          var sidebar = angular.element(document.getElementById($scope.sxId));
          var overlay = angular.element(document.getElementsByClassName(OVERLAY_CLASS)[0]);

          sidebar.addClass(OPENED_CLASS);
          $element.addClass(OPENED_CLASS);
          $scope.sxOpened = sidebar.hasClass(OPENED_CLASS);
          if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass(OPENED_CLASS)) {
            overlay.addClass('active');
          } else {
            overlay.removeClass('active');
          }

          // move the content (constructor class) to the right or left
          if(sidebar.hasClass(PINNED_CLASS)) {
            deferFunction(function() {  // per evitare che la chiusura di un'altra sidebar (es. sixlookup2) tolga la classe css dopo che l'ho inserita io (=> verrrebbe così spostato il content in modo errato)
              var constructors = angular.element(document.getElementsByClassName('constructor'));
              constructors.addClass('sixsidebar-' + $scope.sxDimension + '-' + $scope.sxPosition + '-padded');
            });
          }
        };

        $rootScope.$on( 'sixSidebar:toggle', function(event, param) {
            if(param.id==$scope.sxId){
                $scope.toggleSidebar();
            }
        });

        $rootScope.$on( 'sixSidebar:open', function(event, param) {
            if(param.id==$scope.sxId){
                $scope.openSidebar();
            }
        });

        $rootScope.$on( 'sixFramework:toggle-profile', function(event, param) {
            if($scope.sxPosition=='right'){
                $scope.closeSidebar();
            }
        });

        $scope.closeSidebar = function() {
          var sidebar = angular.element(document.getElementById($scope.sxId));
          var overlay = angular.element(document.getElementsByClassName(OVERLAY_CLASS)[0]);

          sidebar.removeClass(OPENED_CLASS);
          $element.removeClass(OPENED_CLASS);
          $scope.sxOpened = sidebar.hasClass(OPENED_CLASS);
          if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass(OPENED_CLASS)) {
            overlay.addClass('active');
          } else {
            overlay.removeClass('active');
          }

          // move the content (constructor class) to the right or left
          if(sidebar.hasClass(PINNED_CLASS)) {
            var constructors = angular.element(document.getElementsByClassName('constructor'));
            constructors.removeClass('sixsidebar-' + $scope.sxDimension + '-' + $scope.sxPosition + '-padded');
          }
        };

        $scope.smartCloseSidebar = function($event) {
          if($scope.sxPinned !== true && checkAutoclose($event.target)) {
            $scope.closeSidebar();
          }
        };

        function checkAutoclose(elem) {
          var autoclose = elem.attributes['six-sidebar-autoclose'];
          if(angular.isUndefined(autoclose)) {
            return false;
          }
          return autoclose.value != 'false';
        }



        //************************//
        //**** UN/PIN SIDEBAR ****//
        //************************//

        $scope.togglePinnedSidebar = function() {
          var sidebar = angular.element(document.getElementById($scope.sxId));
          sidebar.toggleClass(PINNED_CLASS);
          $element.toggleClass(PINNED_CLASS);
          $scope.sxPinned = sidebar.hasClass(PINNED_CLASS);

          var constructors = angular.element(document.getElementsByClassName('constructor'));
          constructors.toggleClass('sixsidebar-'+ $scope.sxDimension + '-' + $scope.sxPosition + '-padded');
        };

        $scope.pinSidebar = function() {
          var sidebar = angular.element(document.getElementById($scope.sxId));
          sidebar.addClass(PINNED_CLASS);
          $element.addClass(PINNED_CLASS);
          $scope.sxPinned = sidebar.hasClass(PINNED_CLASS);

          // move the content (constructor class) to the right or left
          var constructors = angular.element(document.getElementsByClassName('constructor'));
          constructors.addClass('sixsidebar-'+ $scope.sxDimension + '-' + $scope.sxPosition + '-padded');
        };

        $scope.unpinSidebar = function() {
          var sidebar = angular.element(document.getElementById($scope.sxId));
          sidebar.removeClass(PINNED_CLASS);
          $element.removeClass(PINNED_CLASS);
          $scope.sxPinned = sidebar.hasClass(PINNED_CLASS);

          // move the content (constructor class) to the right or left
          var constructors = angular.element(document.getElementsByClassName('constructor'));
          constructors.removeClass('sixsidebar-'+ $scope.sxDimension + '-' + $scope.sxPosition + '-padded');
        };



        //******************//
        //**** WATCHERS ****//
        //******************//

        $scope.$watch(function() {return $scope.sxOpened;}, function(newVal, oldVal) {
          if(newVal === true && oldVal !== true) {
            $scope.openSidebar();
          } else if(newVal === false && oldVal === true) {
            $scope.closeSidebar();
          }
        });

        $scope.$watch(function() {return $scope.sxPinned;}, function(newVal, oldVal) {
          if(newVal === true && oldVal !== true) {
            $scope.pinSidebar();
          } else if(newVal === false && oldVal === true) {
            $scope.unpinSidebar();
          }
        });



        //****************//
        //**** OTHERS ****//
        //****************//

        function deferFunction(fn) {
          $timeout(function() {
            fn();
          }, Math.floor(Math.random()*20));
        }


        // Forzo il ridimensionamento della sidebar in base all'offset 'top'
        $(window).trigger('resize');
      }
    };
  });

'use strict';


angular.module('ictportal.theme').controller('sixYearPickerCtrl',
    ['$scope',
      function ($scope) {

        var plusMinus = $scope.sxPlusMinus || 5;
        var low = (new Date()).getFullYear() - plusMinus;
        var high = (new Date()).getFullYear() + plusMinus;

        $scope.getYears = function() {
          var years = [];
          for (var i = low; i < high; i++) {
            years.push(i);
          }
          return years;
        };

        $scope.previousYear = function() {
          $scope.ngModel = $scope.ngModel - 1;
          if ($scope.ngModel <= low){
            low = low - plusMinus;
          }
        };

        $scope.nextYear = function() {
          $scope.ngModel = parseInt($scope.ngModel) + 1;
          if ($scope.ngModel >= high){
            high = high + plusMinus;
          }
        };

        $scope.parseModel = function() {
          $scope.ngModel = parseInt($scope.ngModel);
          if($scope.sxChange) {
            $scope.sxChange();
          }
        };
      }
    ]
);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixYearPicker
 * @description
 * # sixYearPicker
 */
angular.module('ictportal.theme')
  .directive('sixYearPicker', function () {
    return {
      template:
        '<style>' +
        'six-year-picker select{' +
            'min-height:29px;' +
            'min-width:70px;' +
        '}' +
        '.six-year-picker-select-bg{' +
            'min-height:34px !important;' +
            'min-width:80px !important;' +
        '}' +
        'six-year-picker .pick-btn-left{' +
            'right:-1px;' +
        '}' +
        '</style>' +
        '<div class="input-group has-button" style="width: 100%">' +
          '<span>{{labelYear}} </span><span class="input-group-btn pick-btn-left"><a ng-click="previousYear()" class="btn btn-default" ng-class="{\'btn-sm\': !sxBig, \'btn-bg\': sxBig}">' +
            '<i class="fa fa-angle-left pull-left"></i>' +
          '</a></span>' +
          '<select ng-model="ngModel" class="btn btn-default" ng-class="{\'btn-sm\': !sxBig, \'six-year-picker-select-bg\': sxBig}" ng-change="parseModel()" style="width: 100%">' +
            '<option ng-repeat="y in getYears()" value="{{y}}" ng-selected="ngModel == y">{{y}}</option>' +
          '</select>' +
          '<span class="input-group-btn pick-btn-right"><a ng-click="nextYear()" class="btn btn-default" ng-class="{\'btn-sm\': !sxBig, \'btn-bg\': sxBig}">' +
            '<i class="fa fa-angle-right pull-left"></i>' +
          '</a></span>' +
        '</div>',
      restrict: 'E',
      scope: {
        ngModel: '=',
        sxPlusMinus: '=',
        sxChange: '&',
        sxBig: '=',
        labelYear: '@?'
      },
      controller: 'sixYearPickerCtrl'
    };
  });

'use strict';

/**
 * @ngdoc directive
 * @name emma.theme.directive:tooltip
 * @description
 * # tooltip
 */
angular.module('ictportal.theme')
  .directive('tooltip', function(){
    return {
      restrict: 'A',
      link: function(scope, element, attrs){
        $(element).hover(function(){
          // on mouseenter
          $(element).tooltip('show');
        }, function(){
          // on mouseleave
          $(element).tooltip('hide');
        });
      }
    };
});

angular.module('ictportal.theme')
  .directive('uiButterbar', ['$rootScope', '$anchorScroll', function($rootScope, $anchorScroll) {
     return {
      restrict: 'AC',
      template:'<span class="bar"></span>',
      link: function(scope, el, attrs) {
        el.addClass('butterbar hide');
        scope.$on('$stateChangeStart', function(event) {
          $anchorScroll();
          el.removeClass('hide').addClass('active');
        });
        scope.$on('$stateChangeSuccess', function( event, toState, toParams, fromState ) {
          event.targetScope.$watch('$viewContentLoaded', function(){
            el.addClass('hide').removeClass('active');
          })
        });
      }
     };
  }]);

angular.module('ictportal.theme')
  .directive('uiFocus', function($timeout, $parse) {
    return {
      link: function(scope, element, attr) {
        var model = $parse(attr.uiFocus);
        scope.$watch(model, function(value) {
          if(value === true) {
            $timeout(function() {
              element[0].focus();
            });
          }
        });
        element.bind('blur', function() {
           scope.$apply(model.assign(scope, false));
        });
      }
    };
  });

 angular.module('ictportal.theme')
  .directive('uiFullscreen', ['uiLoad', 'JQ_CONFIG', '$document', '$window', function(uiLoad, JQ_CONFIG, $document, $window) {
    return {
      restrict: 'AC',
      template:'<i class="fa fa-expand fa-fw text"></i><i class="fa fa-compress fa-fw text-active"></i>',
      link: function(scope, el, attr) {
        el.addClass('hide');
        uiLoad.load(JQ_CONFIG.screenfull).then(function(){
          // disable on ie11
          if (screenfull.enabled && !navigator.userAgent.match(/Trident.*rv:11\./)) {
            el.removeClass('hide');
          }
          el.on('click', function(){
            var target;
            attr.target && ( target = $(attr.target)[0] );
            screenfull.toggle(target);
          });
          $document.on(screenfull.raw.fullscreenchange, function () {
            if(screenfull.isFullscreen){
              el.addClass('active');
            }else{
              el.removeClass('active');
            }
          });
        });
      }
    };
  }]);

'use strict';

/**
 * 0.1.1
 * General-purpose jQuery wrapper. Simply pass the plugin name as the expression.
 *
 * It is possible to specify a default set of parameters for each jQuery plugin.
 * Under the jq key, namespace each plugin by that which will be passed to ui-jq.
 * Unfortunately, at this time you can only pre-define the first parameter.
 * @example { jq : { datepicker : { showOn:'click' } } }
 *
 * @param ui-jq {string} The $elm.[pluginName]() to call.
 * @param [ui-options] {mixed} Expression to be evaluated and passed as options to the function
 *     Multiple parameters can be separated by commas
 * @param [ui-refresh] {expression} Watch expression and refire plugin on changes
 *
 * @example <input ui-jq="datepicker" ui-options="{showOn:'click'},secondParameter,thirdParameter" ui-refresh="iChange">
 */
angular.module('ui.jq', ['ui.load']).
  value('uiJqConfig', {}).
  directive('uiJq', ['uiJqConfig', 'JQ_CONFIG', 'uiLoad', '$timeout', function uiJqInjectingFunction(uiJqConfig, JQ_CONFIG, uiLoad, $timeout) {

  return {
    restrict: 'A',
    compile: function uiJqCompilingFunction(tElm, tAttrs) {

      if (!angular.isFunction(tElm[tAttrs.uiJq]) && !JQ_CONFIG[tAttrs.uiJq]) {
        throw new Error('ui-jq: The "' + tAttrs.uiJq + '" function does not exist');
      }
      var options = uiJqConfig && uiJqConfig[tAttrs.uiJq];

      return function uiJqLinkingFunction(scope, elm, attrs) {

        function getOptions(){
          var linkOptions = [];

          // If ui-options are passed, merge (or override) them onto global defaults and pass to the jQuery method
          if (attrs.uiOptions) {
            linkOptions = scope.$eval('[' + attrs.uiOptions + ']');
            if (angular.isObject(options) && angular.isObject(linkOptions[0])) {
              linkOptions[0] = angular.extend({}, options, linkOptions[0]);
            }
          } else if (options) {
            linkOptions = [options];
          }
          return linkOptions;
        }

        // If change compatibility is enabled, the form input's "change" event will trigger an "input" event
        if (attrs.ngModel && elm.is('select,input,textarea')) {
          elm.bind('change', function() {
            elm.trigger('input');
          });
        }

        // Call jQuery method and pass relevant options
        function callPlugin() {
          $timeout(function() {
            elm[attrs.uiJq].apply(elm, getOptions());
          }, 0, false);
        }

        function refresh(){
          // If ui-refresh is used, re-fire the the method upon every change
          if (attrs.uiRefresh) {
            scope.$watch(attrs.uiRefresh, function() {
              callPlugin();
            });
          }
        }

        if ( JQ_CONFIG[attrs.uiJq] ) {
          uiLoad.load(JQ_CONFIG[attrs.uiJq]).then(function() {
            callPlugin();
            refresh();
          }).catch(function() {
            
          });
        } else {
          callPlugin();
          refresh();
        }
      };
    }
  };
}]);
angular.module('ictportal.theme')
  .directive('uiModule', ['MODULE_CONFIG','uiLoad', '$compile', function(MODULE_CONFIG, uiLoad, $compile) {
    return {
      restrict: 'A',
      compile: function (el, attrs) {
        var contents = el.contents().clone();
        return function(scope, el, attrs){
          el.contents().remove();
          uiLoad.load(MODULE_CONFIG[attrs.uiModule])
          .then(function(){
            $compile(contents)(scope, function(clonedElement, scope) {
              el.append(clonedElement);
            });
          });
        }
      }
    };
  }]);

angular.module('ictportal.theme')
  .directive('uiNav', ['$timeout', function($timeout) {
    return {
      restrict: 'AC',
      link: function(scope, el, attr) {
        var _window = $(window),
        _mb = 768,
        wrap = $('.app-aside'),
        next,
        backdrop = '.dropdown-backdrop';
        // unfolded
        el.on('click', 'a', function(e) {
          next && next.trigger('mouseleave.nav');
          var _this = $(this);
          _this.parent().siblings( ".active" ).toggleClass('active');
          _this.next().is('ul') &&  _this.parent().toggleClass('active') &&  e.preventDefault();
          // mobile
          _this.next().is('ul') || ( ( _window.width() < _mb ) && $('.app-aside').removeClass('show off-screen') );
        });

        // folded & fixed
        el.on('mouseenter', 'a', function(e){
          next && next.trigger('mouseleave.nav');
          $('> .nav', wrap).remove();
          if ( !$('.app-aside-fixed.app-aside-folded').length || ( _window.width() < _mb ) || $('.app-aside-dock').length) return;
          var _this = $(e.target)
          , top
          , w_h = $(window).height()
          , offset = 50
          , min = 150;

          !_this.is('a') && (_this = _this.closest('a'));
          if( _this.next().is('ul') ){
             next = _this.next();
          }else{
            return;
          }

          _this.parent().addClass('active');
          top = _this.parent().position().top + offset;
          next.css('top', top);
          if( top + next.height() > w_h ){
            next.css('bottom', 0);
          }
          if(top + min > w_h){
            next.css('bottom', w_h - top - offset).css('top', 'auto');
          }
          next.appendTo(wrap);

          next.on('mouseleave.nav', function(e){
            $(backdrop).remove();
            next.appendTo(_this.parent());
            next.off('mouseleave.nav').css('top', 'auto').css('bottom', 'auto');
            _this.parent().removeClass('active');
          });

          $('.smart').length && $('<div class="dropdown-backdrop"/>').insertAfter('.app-aside').on('click', function(next){
            next && next.trigger('mouseleave.nav');
          });

        });

        wrap.on('mouseleave', function(e){
          next && next.trigger('mouseleave.nav');
          $('> .nav', wrap).remove();
        });
      }
    };
  }]);

angular.module('ictportal.theme')
  .directive('uiScrollTo', ['$location', '$anchorScroll', function($location, $anchorScroll) {
    return {
      restrict: 'AC',
      link: function(scope, el, attr) {
        el.on('click', function(e) {
          $location.hash(attr.uiScrollTo);
          $anchorScroll();
        });
      }
    };
  }]);

angular.module('ictportal.theme')
  .directive('uiShift', ['$timeout', function($timeout) {
    return {
      restrict: 'A',
      link: function(scope, el, attr) {
        // get the $prev or $parent of this el
        var _el = $(el),
            _window = $(window),
            prev = _el.prev(),
            parent,
            width = _window.width()
            ;

        !prev.length && (parent = _el.parent());

        function sm(){
          $timeout(function () {
            var method = attr.uiShift;
            var target = attr.target;
            _el.hasClass('in') || _el[method](target).addClass('in');
          });
        }

        function md(){
          parent && parent['prepend'](el);
          !parent && _el['insertAfter'](prev);
          _el.removeClass('in');
        }

        (width < 768 && sm()) || md();

        _window.resize(function() {
          if(width !== _window.width()){
            $timeout(function(){
              (_window.width() < 768 && sm()) || md();
              width = _window.width();
            });
          }
        });
      }
    };
  }]);

angular.module('ictportal.theme')
  .directive('uiToggleClass', ['$timeout', '$document', function($timeout, $document) {
    return {
      restrict: 'AC',
      link: function(scope, el, attr) {
        el.on('click', function(e) {
          e.preventDefault();
          var classes = attr.uiToggleClass.split(','),
              targets = (attr.target && attr.target.split(',')) || Array(el),
              key = 0;
          angular.forEach(classes, function( _class ) {
            var target = targets[(targets.length && key)];
            ( _class.indexOf( '*' ) !== -1 ) && magic(_class, target);
            $( target ).toggleClass(_class);
            key ++;
          });
          $(el).toggleClass('active');

          function magic(_class, target){
            var patt = new RegExp( '\\s' +
                _class.
                  replace( /\*/g, '[A-Za-z0-9-_]+' ).
                  split( ' ' ).
                  join( '\\s|\\s' ) +
                '\\s', 'g' );
            var cn = ' ' + $(target)[0].className + ' ';
            while ( patt.test( cn ) ) {
              cn = cn.replace( patt, ' ' );
            }
            $(target)[0].className = $.trim( cn );
          }
        });
      }
    };
  }]);

// thanks to https://github.com/Joiler/ui-grid-edit-datepicker

var app = angular.module('ui.grid.edit');

app.directive('uiGridEditDatepicker', ['$timeout', '$document', 'uiGridConstants', 'uiGridEditConstants', function($timeout, $document, uiGridConstants, uiGridEditConstants) {
  return {
    template: function(element, attrs) {
      var html = '<div class="datepicker-wrapper" ><input type="text" uib-datepicker-popup datepicker-options="datepickerOptions" datepicker-append-to-body="true" is-open="isOpen" ng-model="datePickerValue" ng-change="changeDate($event)" ng-keydown="editDate($event)" popup-placement="auto top"/></div>';
      return html;
    },
    require: ['?^uiGrid', '?^uiGridRenderContainer'],
    scope: true,
    compile: function() {
      return {
        pre: function($scope, $elm, $attrs) {
          if ($attrs.datepickerOptions){
            if ($scope.col.grid.appScope[$attrs.datepickerOptions]){
              $scope.datepickerOptions = $scope.col.grid.appScope[$attrs.datepickerOptions];
            }
          }
        },
        post: function($scope, $elm, $attrs, controllers) {
          var setCorrectPosition = function() {
            var gridElement = $('.ui-grid-viewport');
            var gridPosition = {
              width: gridElement.outerWidth(),
              height: gridElement.outerHeight(),
              offset: gridElement.offset()
            };

            var cellElement = $($elm);
            var cellPosition = {
              width: cellElement.outerWidth(),
              height: cellElement.outerHeight(),
              offset: cellElement.offset()
            };

            var datepickerElement = $('body > .dropdown-menu, body > div > .dropdown-menu');
            var datepickerPosition = {
              width: datepickerElement.outerWidth(),
              height: datepickerElement.outerHeight()
            };

            var setCorrectTopPositionInGrid = function() {
              var topPosition;
              var freePixelsOnBottom = gridPosition.height - (cellPosition.offset.top - gridPosition.offset.top) - cellPosition.height;
              var freePixelsOnTop = gridPosition.height - freePixelsOnBottom - cellPosition.height;
              var requiredPixels = (datepickerPosition.height - cellPosition.height) / 2;
              if (freePixelsOnBottom >= requiredPixels && freePixelsOnTop >= requiredPixels) {
                topPosition = cellPosition.offset.top - requiredPixels + 10;
              } else if (freePixelsOnBottom >= requiredPixels && freePixelsOnTop < requiredPixels) {
                topPosition = cellPosition.offset.top - freePixelsOnTop + 10;
              } else {
                topPosition = gridPosition.height - datepickerPosition.height + gridPosition.offset.top - 20;
              }
              return topPosition;
            };

            var setCorrectTopPositionInWindow = function() {
              var topPosition;
              var windowHeight = window.innerHeight - 10;

              var freePixelsOnBottom = windowHeight - cellPosition.offset.top;
              var freePixelsOnTop = windowHeight - freePixelsOnBottom - cellPosition.height;
              var requiredPixels = (datepickerPosition.height - cellPosition.height) / 2;
              if (freePixelsOnBottom >= requiredPixels && freePixelsOnTop >= requiredPixels) {
                topPosition = cellPosition.offset.top - requiredPixels;
              } else if (freePixelsOnBottom >= requiredPixels && freePixelsOnTop < requiredPixels) {
                topPosition = cellPosition.offset.top - freePixelsOnTop;
              } else {
                topPosition = windowHeight - datepickerPosition.height - 10;
              }
              return topPosition;
            };


            var newOffsetValues = {};

            var isFreeOnRight = (gridPosition.width - (cellPosition.offset.left - gridPosition.offset.left) - cellPosition.width) > datepickerPosition.width;
            if (isFreeOnRight) {
              newOffsetValues.left = cellPosition.offset.left + cellPosition.width;
            } else {
              newOffsetValues.left = cellPosition.offset.left - datepickerPosition.width;
            }

            if (datepickerPosition.height < gridPosition.height) {
              newOffsetValues.top = setCorrectTopPositionInGrid();
            } else {
              newOffsetValues.top = setCorrectTopPositionInWindow();
            }

            datepickerElement.offset(newOffsetValues);
            datepickerElement.css("visibility", "visible");
          };

          $timeout(function() {
            setCorrectPosition();
          }, 0);



          $scope.datePickerValue = new Date($scope.row.entity[$scope.col.field]);
          $scope.isOpen = true;
          var uiGridCtrl = controllers[0];
          var renderContainerCtrl = controllers[1];

          var onWindowClick = function (evt) {
            var classNamed = angular.element(evt.target).attr('class');
            if (classNamed) {
              var inDatepicker = (classNamed.indexOf('datepicker-calendar') > -1);
              if (!inDatepicker && evt.target.nodeName !== "INPUT") {
                $scope.stopEdit(evt);
              }
            }
            else {
              $scope.stopEdit(evt);
            }
          };

          var onCellClick = function (evt) {
            angular.element(document.querySelectorAll('.ui-grid-cell-contents')).off('click', onCellClick);
            $scope.stopEdit(evt);
          };

          $scope.editDate = function(evt) {
            if (evt.keyCode > 48){
              $scope.datePickerValue = new Date($scope.row.entity[$scope.col.field]);
            }
          };

          $scope.changeDate = function (evt) {
            if (angular.isDate($scope.datePickerValue)) {
              $scope.row.entity[$scope.col.field] = $scope.datePickerValue;
              $scope.stopEdit(evt);
            } else {
              $scope.datePickerValue = new Date($scope.row.entity[$scope.col.field]);
            }
          };

          $scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT, function () {
            if (uiGridCtrl.grid.api.cellNav) {
              uiGridCtrl.grid.api.cellNav.on.navigate($scope, function (newRowCol, oldRowCol) {
                $scope.stopEdit();
              });
            } else {
              angular.element(document.querySelectorAll('.ui-grid-cell-contents')).on('click', onCellClick);
            }
            angular.element(window).on('click', onWindowClick);
          });

          $scope.$on('$destroy', function () {
            angular.element(window).off('click', onWindowClick);
            $('body > .dropdown-menu, body > div > .dropdown-menu').remove();
          });

          $scope.stopEdit = function(evt) {
            $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
          };

          $elm.on('keydown', function(evt) {
            switch (evt.keyCode) {
              case uiGridConstants.keymap.ESC:
                evt.stopPropagation();
                $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
                break;
            }
            if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
              evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
              if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
                $scope.stopEdit(evt);
              }
            } else {
              switch (evt.keyCode) {
                case uiGridConstants.keymap.ENTER:
                case uiGridConstants.keymap.TAB:
                  evt.stopPropagation();
                  evt.preventDefault();
                  $scope.stopEdit(evt);
                  break;
              }
            }
            return true;
          });
        }
      };
    }
  };
}]);

/**
 * Created by stefano on 15/12/16.
 */


angular.module('ictportal.theme').directive("uniqueValidation", function(errorService, recordFactory, $log, $q, $injector) {
  return {
    restrict: "A",
    require: "ngModel",

    link: function ($scope, $element, $attrs, ctrl) {
      ctrl.$asyncValidators.unique = function(modelValue, viewValue) {
        var factoryName = $attrs.uniqueValidation || 'recordFactory';
        var factoryParams = $attrs.factoryParams;
        var factoryMethodName = $attrs.factoryMethodName || 'unique';
        var isSchemaForm = angular.isDefined($attrs.sfSchema) && angular.isDefined($attrs.sfForm) && angular.isDefined($attrs.sfModel);
        var field = $attrs.uniqueField || 'model.code';

        $log.log('uniqueValidation using factory ' + factoryName + ' method ' + factoryMethodName + ' (factory-params: ' + factoryParams + ')' + ' on field ' + field);

        var factory = $injector.get(factoryName);
        var deferred = $q.defer();

        if(!viewValue || viewValue.length < 3) {
          $log.log('length < 3');
          deferred.resolve();
        } else {
          var promise;
          if(factoryParams) {
            promise = factory(factoryParams)[factoryMethodName]({param1: field, param2: viewValue}).$promise;
          } else {
            promise = factory[factoryMethodName]({param1: field, param2: viewValue}).$promise;
          }
          promise.then(function (resp) {
            if (errorService.handleError(resp)) {
              if (resp.result == true) {
                $log.log(field + ' unique');
                deferred.resolve();
              } else {
                $log.log(field + ' NOT unique');
                deferred.reject();

                if(isSchemaForm) {
                  var splitted = field.split('.');
                  var sfBroadcastName = 'schemaForm.error.' + splitted[splitted.length-1];
                  $scope.$broadcast(sfBroadcastName, 'unique', 'Non univoco');
                }
              }
            } else {
              $log.log('error');
              deferred.resolve();
            }
          });
        }

        return deferred.promise;
      };
    }
  };
});

'use strict';

/**
 * @ngdoc directive
 * @name emma.theme.directive:xlsxreader
 * @description
 * # xlsxreader
 */
angular.module('ictportal.theme')
  .directive('xlsxreader', function () {
    return {
      scope: {
        opts: '='
      },
      link: function ($scope, $elm, $attrs) {
        $elm.on('change', function (changeEvent) {
          var reader = new FileReader();

          reader.onload = function (evt) {
            $scope.$apply(function () {
              var data = evt.target.result;
              var workbook = XLSX.read(data, {type: 'binary'});
              var headerNames = XLSX.utils.sheet_to_json( workbook.Sheets[workbook.SheetNames[0]], { header: 1 })[0];
              var data = XLSX.utils.sheet_to_json( workbook.Sheets[workbook.SheetNames[0]]);

              // Creazione automatica colonne in una ui-grid
              if($scope.opts){
                $scope.opts.columnDefs = [];
                headerNames.forEach(function (h) {
                  $scope.opts.columnDefs.push({ field: h });
                });
                $scope.opts.xlsData = data; //da preprocessare
                //$scope.opts.data = data;
              }
              $scope.$emit('fileSelected',changeEvent.target.files,data,XLSX);
              //$rootScope.$broadcast('goodsInwardFile:fileChanged',this); 

              $elm.val(null);
            });
          };

          reader.readAsBinaryString(changeEvent.target.files[0]);
        });
      }
    }
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.alfrescoFactory
 * @description
 * # alfrescoFactory
 */
angular.module('ictportal.theme')
  .factory('alfrescoFactory', function ($resource, ALFRESCO_URL) {
      return $resource(ALFRESCO_URL + '/api/alfresco' + '/:verb/:id', {}, {
        listFiles:  {method: 'GET', isArray: false, params: {verb: '_list'}},
        fileExists: {method: 'GET', isArray: false, params: {verb: '_exists'}}
      });
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.commissionFactory
 * @description
 * # commissionFactory
 * Factory in the emma.theme.
 */
angular.module('ictportal.theme')
  .factory('commissionFactory', function (APP_URL, $resource) {
    return function(entity) {
      return $resource(APP_URL + '/rest/commission/:verb/:id/:code', {}, {
        getCommissionsList:           {method: 'GET', params: {verb: '_list', sort_fields: 'code', sort_order: 'asc'}},
        getCommissionsSelectList:     {method: 'GET', isArray: false, params: {verb: '_select', sort_fields: 'code', sort_order: 'asc', page_size: 10000}},
        saveCommission:         {method: 'POST'},
        deleteCommission:       {method: 'DELETE'},
        getCommissionByCode:    {method: 'GET',     params: {verb: '_code'} }
      });
    };
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.counter
 * @description
 * # counter
 * Factory in the emma.theme.
 */
angular.module('ictportal.theme')
  .factory('counterFactory', function (APP_URL, $resource) {
    return $resource(APP_URL + '/rest/counter/:op/:code', {}, {
      next: { method: 'GET', params: {op: 'next'}, isArray: false },
      current: { method: 'GET', params: {op: 'current'}, isArray: false }
    });
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.cronExpressionFactory
 * @description
 * # cronExpressionFactory
 * Factory in the emma.theme.
 */
angular.module('ictportal.theme')
  .factory('cronExpressionFactory', function (APP_URL, $resource) {
      return $resource(APP_URL + '/rest/cron/:verb', {}, {
        getSimulationEvents:    {method: 'POST',    params: {verb: '_events'}},
        getCronExpression:      {method: 'POST',    params: {verb: '_expression'}}
      });
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.dashboardAssetFactory
 * @description
 * # dashboardAssetFactory
 * Factory in the emma.theme.
 */
angular.module('ictportal.theme')
  .factory('dashboardAssetFactory', function (PLAN_URL, $resource) {
    return function(entity) {
      return $resource(PLAN_URL + '/api/'+entity+'/:id', {}, {
        query: {method: 'GET', isArray: false}
      });
    };
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.dashboardEmmaFactory
 * @description
 * # dashboardEmmaFactory
 * Factory in the emma.theme.
 */
angular.module('ictportal.theme')
  .factory('dashboardEmmaFactory', function (ENERGY_URL, $resource) {
    return function(entity) {
      return $resource(ENERGY_URL + '/api/'+entity+'/:id', {}, {
        getConfig: {method: 'GET',     url: ENERGY_URL + '/api/dashboard/_config'}
      });
    };
  });

'use strict';

/**
 * Created by Rita Beltrami on 07/12/2016
 * 
 * @ngdoc factory
 * @name ictportal.icteggs.dbFilterFactory
 * @description Factory contenente la logica per creare filtri a db. E' una sql injection orrificante, ma Ricky dixit, quindi va bene così ^^
 * # dbFilterFactory
 * Factory in the ictportal.theme.
 */
angular.module('ictportal.theme')
  .factory('dbFilterFactory', function () {

    var filterFactory = {};

    filterFactory.getDateFilter = function(col, day, rel){
      var f = [];
      if(rel){
        var timestamp = getTimestamp(day);
        f.push({
          column: col,
          value: timestamp,
          relation: rel,
          kind: 'date'
        });
      }
      else{
        var start = sixDateLib.getEndOfDay(day);
        var end = new Date(start.getTime());
        end.setDate(end.getDate() + 1);
        f.push({
          column: col,
          value: start,
          relation: '>=',
          kind: 'date'
        });
        f.push({
          column: col,
          value: end,
          relation: '<=',
          kind: 'date'
        });
      }
      return f;
    };

    /**
     * es:dbFilterFactory.getLikeFilter('t.barcode','00%');
     * @param {*} col Nome della colonna.
     * @param {*} val Valore, di tipo stringa.
     */
    filterFactory.getLikeFilter = function(col, val){
      var f = [];
      f.push({
        column: col,
        value: val,
        relation: 'LIKE',
        kind: 'string'
      });
      return f;
    };

    /**
     * es:dbFilterFactory.getStringFilter('t.barcode','0020145569746');
     * @param {*} col Nome della colonna.
     * @param {*} val Valore, di tipo stringa.
     */
    filterFactory.getStringFilter = function(col, val, rel){
      var f = [];
      if(rel){
        f.push({
          column: col,
          value: val,
          relation: rel,
          kind: 'string'
        });
      }
      else{
        f.push({
        column: col,
        value: val,
        relation: '=',
        kind: 'string'
      });
      }
      return f;
    };

    /**
     * es: dbFilterFactory.getNumberFilter('product_id', $scope.advFilter.filter.product_id);
     * @param {*} col Nome della colonna.
     * @param {*} val Valore, di tipo numerico.
     */
    filterFactory.getNumberFilter = function(col, val){
      var f = [];
      f.push({
        column: col,
        value: val.toString(),
        relation: '=',
        kind: 'number'
      });
      return f;
    };

    /**
     * es: filters.concat(dbFilterFactory.getCustomFilter("( status='S' OR status='ACCD' OR status='W' )"));
     * @param {*} query Query sql che andrà in AND con le altre condizioni.
     */
    filterFactory.getCustomFilter = function(query){
      var f = [];
      f.push({
        column: '',
        value: query,
        relation: '',
        kind: 'custom'
      });
      return f;
    };

    /**
     * es: dbFilterFactory.getValidityFilter(new Date());
     * es: dbFilterFactory.getValidityFilter(new Date(),'end_validity');
     * @param {*} date Data con cui fare il confronto.
     * @param {*} endValidityColumnName Nome della colonna che contiene l'informazione sulla data fine validità.
     */
    filterFactory.getValidityFilter = function(date, endValidityColumnName){
      var col = endValidityColumnName?endValidityColumnName:'end_validity_date';
      var f = [];
      var timestamp = getTimestamp(date);
      var query = '(t.start_validity_date <= \'' + timestamp + '\' AND (t.' + col + ' IS NULL OR t.' + col + '>\'' + timestamp + '\') )';
      f.push({
        column: '',
        value: query,
        relation: '',
        kind: 'custom'
      });
      return f;
    };

    /**
     * es: dbFilterFactory.getNullableFilter('validity_end', 'IS NULL');
     * @param {*} col Nome della colonna
     * @param {*} rel Relazione 'IS NULL' o 'IS NOT NULL'
     */
    filterFactory.getNullableFilter = function(col, rel){
      var f = [];
      f.push({
        column: col,
        value: '',
        relation: rel,
        kind: 'nullable'
      });
      return f;
    };

    filterFactory.changeCustomAlias = function(alias,filter,column){
      if(filter && filter.value) {
        filter.value = filter.value.split('t.').join(alias+'.');
        if(column){
          filter.value = filter.value.split('.id').join('.'+column);
        }
      }
    };

    // A partire da una data javascript, crea una data che vada bene per le query (per ora postgres).
    function getTimestamp(day){
      var m = (day.getMonth()+1);
      var mStr = (m<10)?('0'+m.toString()):m.toString();
      var d = (day.getDate());
      var dStr = (d<10)?('0'+d.toString()):d.toString();
      var timestamp = day.getFullYear() + '-' + mStr + '-' +dStr;
      return timestamp;
    }

    /**
     * es: compose or query starting from string array. Eg. ("( status='S' OR status='ACCD' OR status='W' )"));
     * @param {*} field Field interested by condition.
     * @param {*} values List of values
     */
    filterFactory.getOrQuery = function(field, values){
      if(values.length>0) {
        var query = " (";
        values.forEach(function(value) {
            query = query + field + "='" + value + "' OR ";
        })
        query = query.slice(0,-4) + ")";
        return query;
      }
      return " (1=1) ";
    };

    /**
     * Creates a "IN" query
     * @param {*} col Column you want to query on.
     * @param {*} valArray Array of possibile values.
     */
    filterFactory.getInFilter = function(col, valArray) {
      var val = valArray.map(function(item) { return "'" + item +"'" }).join(',');
      var f = [{
        column: col,
        value: val,
        relation: '=',
        kind: 'in'
      }];
      return f;
    };

    return filterFactory;
  });

'use strict';

/**
 * Created by Rita Beltrami on 26/05/2017
 * 
 * @ngdoc factory
 * @name ictportal.theme.eggsFormFactory
 * @description
 * # authFactory
 * Factory in the ictportal.theme.
 */
angular.module('ictportal.theme')
  .factory('eggsFormFactory', function (recordFactory, $rootScope, localeFactory, toaster) {

    var formFactory = {};

    var msg = {
      error: 'Error',
      warning: 'Warning',
      success: 'Success',
      info: 'Information'
    };

    $rootScope.$on('$translateRefreshEnd', function () {
      localeFactory.translateMsg(msg);
    });

    formFactory.addCheckbox = function(checkbox,field,yes,no){
      if(angular.isUndefined(yes)){
        yes = 'S';
      }
      if(angular.isUndefined(no)){
        no = 'N';
      }
      checkbox[field] = {};
      checkbox[field][yes] = true; 
      checkbox[field][no] = false;
    };

    function getLookup(lookup, record, field, table){
      if(record[field]){
        recordFactory(table).byId({id: record[field]})
          .$promise.then(function (data) {
            lookup[field].obj = data;
          });
      }
    };

    formFactory.loadLookupData = function(lookup, record) {
      for(var key in lookup){
        getLookup(lookup, record, key,lookup[key].table)
      }
    };

    formFactory.addLookup = function(lookup, field, table, code, description){
      lookup[field] = {
        obj: undefined,
        mapping: {
          code: code,
          description: description
        },
        table: table
      };
    };

    formFactory.removeUUID = function(record) {
      delete record['UUID'];
      return record;
    };

    formFactory.convertDates = function(record, list) {
      list.forEach(function(key) {
        if(record[key]){
          record[key] = new Date(record[key]);
          record[key].setHours(sixDateLib.getTimezone(record[key]),0,0,0);
        }
      })
      return record;
    };

    formFactory.restore = function(record) {
      delete record['UUID'];
      var list = ['dtins','dtvar','datainserimento'];
      list.forEach(function(key){
        if(record[key]){
          record[key] = new Date(record[key]);
        }
      })
      return record;
    };

    /**
     * Lancia un toaster che visualizza il messaggio ricevuto dal server.
     * @param {*} data Risposta del server
     * @param {*} bundle Nome del file in cui trovare la traduzione del messaggio (es.: "check_in")
     */
    formFactory.logServerException = function(data, bundle) {
      var messages = [];
      angular.forEach(data.messages, function(notification) {
        var params = {};
        notification.params.forEach(function(p,index){
          params['p'+ index] = p;
        });
        var key = bundle + '.' + notification.code;
        localeFactory.translateReplace(key, params).then(function(translatedMsg) {
          if(notification.status=='SEVERE'){
            notification.status = 'ERROR'; // toaster non supporta 'severe'
          }
          var message = (translatedMsg===key)?notification.message:translatedMsg; 
          messages.push(message);
          var status = notification.status.toLowerCase();
          var title = msg[status]; // Se la sposti, attenzione a questo
          toaster.pop(status, title, message);
        })
      });
      return messages;
    };
    
    return formFactory;
  });

'use strict';

/**
 * Created by Rita Beltrami on 07/12/2016
 * 
 * @ngdoc factory
 * @name ictportal.icteggs.eggsImplicitFilterFactory
 * @description Factory contenente la logica per creare filtri impliciti a partire dai dati di login di EGGS
 * # eggsImplicitFilterFactory
 * Factory in the ictportal.theme.
 */
angular.module('ictportal.theme')
  .factory('eggsImplicitFilterFactory', function () {

    var filterFactory = {};

    filterFactory.getImplicitFilters = function(qualifications){
      var implicitFilters = {
        taboperatori: {
            GRU: [],
            STG: [],
            FIL: [],
            CCO: [],
            PRL: [],
            QUA: [],
            CCN: []
        },
        tabccosto: {
            CCO: []
        } 
      };
      if(qualifications){
        qualifications.forEach(function (item){
          switch(item.tipo){
            case 'GRU':{
              var f = 'gruppoId=' + item.valore;
              implicitFilters.taboperatori.GRU.push(f);
              break;
            }
            case 'STG':{
              var f = 'sottogruppoid=' + item.valore;
              implicitFilters.taboperatori.STG.push(f);
              break;
            }
            case 'FIL':{
              var f = 'contrFilialeId=' + item.valore;
              implicitFilters.taboperatori.FIL.push(f);
              break;
            }
            case 'CCO':{
              var f = 'divisioneCommId=' + item.valore;
              implicitFilters.taboperatori.CCO.push(f);
              var d = 'id=' + item.valore;
              implicitFilters.tabccosto.CCO.push(d);
              break;
            }
            case 'PRL':{
              var f = 'provlavoroId=' + item.valore;
              implicitFilters.taboperatori.PRL.push(f);
              break;
            }
            case 'QUA':{
              var f = 'qualificaId=' + item.valore;
              implicitFilters.taboperatori.QUA.push(f);
              break;
            }
            case 'CCN':{
              var f = 'contrlavanagId=' + item.valore;
              implicitFilters.taboperatori.CCN.push(f);
              break;
            }
          }
        });
      }
      setQueryTaboperatori(implicitFilters);
      setQueryTabccosto(implicitFilters);
      return implicitFilters;
    };

    function setQueryTaboperatori(implicitFilters){
      var query = '';
      for(var key in implicitFilters.taboperatori){
        if(implicitFilters.taboperatori[key].length>0){
          query += '(' 
          implicitFilters.taboperatori[key].forEach(function(item){
            query += item + ' OR ';
          });
          query = query.slice(0, -4);
          query += ') AND '; 
        }
      }
      if(query.length===0){
        implicitFilters.taboperatori = [];
      }
      else{
        query = query.slice(0, -5);
        implicitFilters.taboperatori = [{
          column: '',
          value: query,
          relation: '',
          kind: 'custom'
        }];
      }
    };

    function setQueryTabccosto(implicitFilters){
      var query = '';
      for(var key in implicitFilters.tabccosto){
        if(implicitFilters.tabccosto[key].length>0){
          query += '(' 
          implicitFilters.tabccosto[key].forEach(function(item){
            query += item + ' OR ';
          });
          query = query.slice(0, -4);
          query += ') AND '; 
        }
      }
      if(query.length===0){
        implicitFilters.tabccosto = [];
      }
      else{
        query = query.slice(0, -5);
        implicitFilters.tabccosto = [{
          column: '',
          value: query,
          relation: '',
          kind: 'custom'
        }];
      }
    };

    return filterFactory;
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.baseFactory
 * @description
 * # baseFactory
 * Factory in the emma.theme.
 */
angular.module('ictportal.theme')
  .factory('evalFactory', function (ENERGY_URL, $resource) {
      return $resource(ENERGY_URL + '/api/eval/:verb/:id/:param1/:param2/:param3', {}, {
        evalConsumption:  {method: 'GET',   isArray: false, params: {verb: 'consumption'}},
        evalBudget:       {method: 'GET',   isArray: false, params: {verb: 'budget'}},
        budgetAndEval:    {method: 'POST',  isArray: false, params: {verb: 'budgetandeval'}},
        analisys:         {method: 'GET',   isArray: false, params: {verb: 'analisys'}}
      });
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.groupFactory
 * @description
 * # groupFactory
 * Factory in the emma.theme.
 */
angular.module('ictportal.theme')
  .factory('groupFactory', function (APP_URL, $resource) {
      return $resource(APP_URL + '/rest/group/:verb/:id/:uuid', {}, {
        getGroup:               {method: 'GET',     params: {verb: '_list'}},
        getGroupsList:          {method: 'GET',     params: {verb: '_relations'}},
        getModelsList:          {method: 'GET',     params: {verb: 'domain.model'}},
        saveKey:                {method: 'POST'}
        //deleteGroup:             {method: 'DELETE',  params: {verb: '_delete'}},
        //updateGroup:             {method: 'PUT',     params: {verb: '_update'}},
        //saveGroup:               {method: 'POST',    params: {verb: '_save'}},
        //getGroupByUUID:          {method: 'GET',     params: {verb: '_uuid'}}
      });
  });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.theme.matrixParFactory
 * @description
 * # matrixParFactory
 * Factory in the ictportal.theme.
 */
angular.module('ictportal.theme')
  .factory('matrixParFactory', function (APP_URL, $resource) {
      return $resource(APP_URL + '/rest/matrix/:key/:d1/:d2/:d3/:d4/:d5', {}, {
        getMatrixPar:               {method: 'GET'}, // ricerca secca a DB con chiave passata
        getValueOrDefault:          {method: 'POST'}, // stessa logica del BE che va in "best match"
        save:                       {method: 'POST'},
        refresh:                    {method: 'GET', params: {key: 'refresh'}, transformResponse: function (data) {return data;}}
      });
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.groupFactory
 * @description
 * # groupFactory
 * Factory in the emma.theme.
 */
angular.module('ictportal.theme')
  .factory('moduleInfoFactory', function ($resource, DEV) {
    return function(MODULE_URL, api) {
      api = api || 'api';
      return $resource(MODULE_URL + '/' + api + '/meta/:verb/:param1/:param2/:param3', {}, {
        info: { method: 'GET', params: {verb: '_info'} }
      });
    }
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.notificationFactory
 * @description
 * # notificationFactory
 * Factory in the emma.theme.
 */
angular.module('ictportal.theme')
  .factory('notificationFactory', function (PLAN_URL, $resource) {
    return function(entity) {
      return $resource(PLAN_URL + '/api/notification/:type/:verb/:id/:param1', {}, {
        sendEmail:      {method: 'POST',    params: {type: 'mail', verb: '_send'} },
        getList:        {method: 'POST',    params: {type: 'mail', verb: '_list'} },
        getEmailById:   {method: 'POST',    params: {type: 'mail', verb: '_detail'} },
        getListFiltered:{method: 'POST',    params: {type: 'mail', verb: '_list', param1: '_filtered'}},
        getMailReceiver:{method: 'POST',    params: {type: 'issue', verb: '_mailreceiver'}}
      });
    };
  });




'use strict';

/**
 * @ngdoc service
 * @name ictportal.theme.recordFactory
 * @description
 * # recordFactory
 */
angular.module('ictportal.theme')
  .factory('recordFactory', function ($resource, ABNORMAL_URL, SCRAMBLED_URL) {
    return function(entity, db) {
      var url = ABNORMAL_URL;
      if(db==='eggs'){
        url = SCRAMBLED_URL;
      }
      return $resource(url + '/api/record/' + entity + '/:verb/:id/:param1', {}, {
        query:          {method: 'GET',   isArray: false},
        store:          {method: 'POST',  isArray: false},
        aggregation:    {method: 'POST',  isArray: false,   params: {verb: 'aggs'}},
        filter:         {method: 'POST',  isArray: false,   params: {verb: '_filter'}},
        byId:           {method: 'GET',   isArray: false,   params: {verb: '_id', id: '@id'}},
        create:         {method: 'POST',  isArray: false,   params: {verb: '_save'}},
        update:         {method: 'POST',  isArray: false,   params: {verb: '_update', id: '@id'}},
        delete:         {method: 'DELETE',isArray: false,   params: {id: '@id'}},
        deleteByField:  {method: 'DELETE',isArray: false,   params: {id: '@id', param1: '@param1'}}
      });
    };
  });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.theme.sixCoreFactory
 * @description
 * # sixCoreFactory
 * Factory in the ictportal.theme.
 */
angular.module('ictportal.theme')
  .factory('sixCoreFactory', function (APP_URL, $resource) {
      return $resource(APP_URL + '/rest/V0.1/:verb/:param1/:param2/:param3', {}, {
        reloadComponentStatusMap:        {method: 'GET', params: {verb: 'component', param1: 'map', param2: 'reload'} }
      });
  });

'use strict';

/**
 * Created by Rita Beltrami on 22/03/2018
 * 
 * @ngdoc factory
 * @name ictportal.icteggs.sixImplicitFilterFactory
 * @description Factory contenente la logica per creare filtri impliciti a partire dai dati di login di SIX
 * # sixImplicitFilterFactory
 * Factory in the ictportal.theme.
 */
angular.module('ictportal.theme')
    .factory('sixImplicitFilterFactory', function () {

        var filterFactory = {};

        filterFactory.getImplicitFilters = function (authorizations) {

            var implicitFilters = {};
            if (authorizations) {
                setDestinationsFilter(authorizations, implicitFilters);
                setFacilitiesFilter(authorizations, implicitFilters);
                setCustomersFilter(authorizations, implicitFilters);
                setContainersFilter(authorizations, implicitFilters);
                setSuppliersFilter(authorizations, implicitFilters);
                setCustomerCostCentersFilter(authorizations, implicitFilters);
            }
            return implicitFilters;
        }

        function setFacilitiesFilter(authorizations, implicitFilters) {
            if (authorizations.facilities && authorizations.facilities.length > 0) {
                var query = '(';
                authorizations.facilities.forEach(function (id) {
                    query = query + ' t.id=' + id + ' OR ';
                });
                query = query.slice(0, -4);
                query += ')';
                implicitFilters.facility = [{
                    column: '',
                    value: query,
                    relation: '',
                    kind: 'custom'
                }];
            }
            else {
                implicitFilters.facility = [];
            }
        }

        function setDestinationsFilter(authorizations, implicitFilters) {
            if (authorizations.destinations && authorizations.destinations.length > 0) {
                var query = '(';
                authorizations.destinations.forEach(function (id) {
                    query = query + ' t.id=' + id + ' OR ';
                });
                query = query.slice(0, -4);
                query += ')';
                implicitFilters.customer_destination = [{
                    column: '',
                    value: query,
                    relation: '',
                    kind: 'custom'
                }];
            }
            else {
                implicitFilters.customer_destination = [];
            }
        }

        function setCustomersFilter(authorizations, implicitFilters) {
            if (authorizations.customers && authorizations.customers.length > 0) {
                var query = '(';
                authorizations.customers.forEach(function (id) {
                    query = query + ' t.id=' + id + ' OR ';
                });
                query = query.slice(0, -4);
                query += ')';
                implicitFilters.customer = [{
                    column: '',
                    value: query,
                    relation: '',
                    kind: 'custom'
                }];
            }
            else {
                implicitFilters.customer = [];
            }
        }

        function setContainersFilter(authorizations, implicitFilters) {
            if (authorizations.containers && authorizations.containers.length > 0) {
                var query = '(';
                authorizations.containers.forEach(function (id) {
                    query = query + ' t.id=' + id + ' OR ';
                });
                query = query.slice(0, -4);
                query += ')';
                implicitFilters.container = [{
                    column: '',
                    value: query,
                    relation: '',
                    kind: 'custom'
                }];
            }
            else {
                implicitFilters.container = [];
            }
        };

        function setSuppliersFilter(authorizations, implicitFilters) {
            if (authorizations.suppliers && authorizations.suppliers.length > 0) {
                var query = '(';
                authorizations.suppliers.forEach(function (id) {
                    query = query + ' t.id=' + id + ' OR ';
                });
                query = query.slice(0, -4);
                query += ')';
                implicitFilters.supplier = [{
                    column: '',
                    value: query,
                    relation: '',
                    kind: 'custom'
                }];
            }
            else {
                implicitFilters.supplier = [];
            }
        }

        function setCustomerCostCentersFilter(authorizations, implicitFilters) {
            if (authorizations.customerCostCenters && authorizations.customerCostCenters.length > 0) {
                var query = '(';
                authorizations.customerCostCenters.forEach(function (id) {
                    query = query + ' t.id=' + id + ' OR ';
                });
                query = query.slice(0, -4);
                query += ')';
                implicitFilters.customer_cost_center = [{
                    column: '',
                    value: query,
                    relation: '',
                    kind: 'custom'
                }];
            }
            else {
                implicitFilters.customer_cost_center = [];
            }
        }

        return filterFactory;
    });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.theme.statixFactory
 * @description
 * # statixFactory
 */
angular.module('ictportal.theme')
  .factory('statixFactory', function ($resource) {
    return function(staticBase) {
      return $resource(staticBase + '/:verb/', {}, {
        ls: {method: 'GET', params: {path: '@path', verb:'ls'}, isArray: true},
        delete: {method: 'DELETE', params: {path: '@path', verb:'delete'}, isArray: false}
      });
    }
  });

/**
 * Created by luca on 18/10/16.
 */

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.user
 * @description
 * # user
 * Factory in the emma.theme.
 */
angular.module('ictportal.theme')
  .factory('userFactory', function (APP_URL, $resource) {
    return $resource(APP_URL + '/rest/user/:verb', {}, {
      getMail: {  method: 'POST', params: {verb: 'search'}}
    });
  });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.theme.workflowFactory
 * @description
 * # workflowFactory
 * Factory in the ictportal.theme.
 */
angular.module('ictportal.theme')
  .factory('workflowFactory', function (APP_URL, $resource) {
      return $resource(APP_URL + '/rest/workflow/:type/:verb/:param1', {}, {
        getAllComponentStatusTransition:        {method: 'GET', isArray: false, params: {type: 'component', verb: 'checktransition'}},
        getComponentStatusList:                 {method: 'GET', isArray: true, params: {type: 'component', verb: 'list'}},
        generateComponentStatusValue:           {method: 'POST', isArray: false, params: {type: 'component', verb: 'generatematrixparstatus'}},
        reloadComponentWorkflow:                {method: 'GET', isArray: false, params: {type: 'component', verb: 'relaod'}},
        getSerialKitStatusPredecessors:         {method: 'GET', isArray: false, params: {type: 'serialkit', verb: 'predecessors'}},
        getComponentStatusPredecessors:         {method: 'GET', isArray: false, params: {type: 'component', verb: 'predecessors'}}
      });
  });

/**
 * Created by stefano on 08/03/17.
 *
 * Il filtro 'cut' consente di visualizzare le stringhe fino ad un limite massimo di caratteri.
 * Es. text='abcdefghilmnopqrstuvz'
 *     {{text | cut:true:10:'...'}} visualizza 'abcdefghil...'
 */

angular.module('ictportal.theme').filter('cut', function () {
  return function (value, wordwise, max, tail) {
    if (!value) return '';

    max = parseInt(max, 10);
    if (!max) return value;
    if (value.length <= max) return value;

    value = value.substr(0, max);
    if (wordwise) {
      var lastspace = value.lastIndexOf(' ');
      if (lastspace !== -1) {
        //Also remove . and , so its gives a cleaner result.
        if (value.charAt(lastspace-1) === '.' || value.charAt(lastspace-1) === ',') {
          lastspace = lastspace - 1;
        }
        value = value.substr(0, lastspace);
      }
    }

    return value + (tail || '...');
  };
});

//mediaApp.filter('capitalize', function() {
//    return function(input, scope) {
//        if (input!=null)
//            return input.substring(0,1).toUpperCase()+input.substring(1);
//    }
//});

angular.module('ictportal.theme')

    //USO: {{m|monthName}} --> m=0 -> Gennaio
    .filter('monthName', function () {
        return function (input, scope) {
            return sixDateLib.getMonthName(input);
        };
    })

    //USO: {{m|monthShortName}} --> m=0 -> Gen
    .filter('monthShortName', function () {
        return function (input, scope) {
            return sixDateLib.getMonthShortName(input);
        };
    })
;

'use strict';

/**
 * @ngdoc filter
 * @name emma.theme.filter:startfrom
 * @function
 * @description
 * # startfrom
 * Filter in the emma.theme.
 */
angular.module('ictportal.theme')
  .filter('startFrom', function () {
    return function (input, start) {
      if (input) {
        start = +start;
        var filtered = input.slice(start);
        return filtered;
      }
      return [];
    };
  });

'use strict';

/**
 * @ngdoc filter
 * @name emma.theme.filter:trustAsResourceUrl
 * @function
 * @description
 * # trustAsResourceUrl
 * Filter in the emma.theme.
 */
angular.module('ictportal.theme')
  .filter('trustAsResourceUrl', function ($sce) {
    return function (input) {
      return $sce.trustAsResourceUrl(input);
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.theme:ForbiddenCtrl
 * @description Pages to be redirected on when user is not allowed to enter previous selected link.
 * # ForbiddenCtrl
 */
angular.module('ictportal.theme')
    
.config(function ($routeProvider) {
    $routeProvider.when('/forbidden', {
        templateUrl: 'theme/forbidden/forbidden.html',
        controller: 'ForbiddenCtrl'
    })
})

.controller('ForbiddenCtrl', function (localeFactory) {
    localeFactory.loadTranslation('portal');
});
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:GroupDetailCtrl
 * @description
 * # GroupDetailCtrl
 * Controller of the emma.theme
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/group/detail/:id', {
            templateUrl: 'theme/group/group_detail.html',
            controller: 'GroupDetailCtrl'
        })
  })
  .controller('GroupDetailCtrl', function ($scope, $rootScope, groupFactory, $log, $location, $routeParams, commissionFactory, schemaFactory, treeFactory, toaster) {
    $scope.modelsList = [];
    $scope.group = {};
    $scope.TEMP_NEW = 'TEMP';

    // Gestione sixSearchTerms
    $scope.searchResult = [];
    $scope.searchFilterObj = {};
    $scope.sxSearchTerms = {
        id: 'group-search',
        showSelectSchema: true,
        open: false,
        type_id: undefined,
        type_obj: undefined
    };

    $scope.toggleSearchTerms = function(){
        $rootScope.$broadcast('sixSidebar:open', {id: $scope.sxSearchTerms.id});
    };

    $scope.onFilterChanged = function(){
        if(angular.isDefined($scope.sxSearchTerms.type_id)){
            var key = $scope.sxSearchTerms.type_id.UUID;
            $scope.group[key] = JSON.parse(JSON.stringify(emptyKey));
            $scope.group[key].id.domain.domain1 = $scope.group.id;
            $scope.group[key].id.key = key;
            $scope.group[key].value = JSON.stringify($scope.searchFilterObj);
        }
        for (var key in $scope.sxSearchTerms.type_id) {
            delete $scope.sxSearchTerms.type_id[key];
        }
        delete $scope.group[$scope.TEMP_NEW];
    };

    $scope.isEmptyFilter = function(){
        return Object.keys( $scope.searchFilterObj).length === 0;
    };

    $scope.emptyFilter = function(){
        for (var key in $scope.searchFilterObj) {
            delete $scope.searchFilterObj[key];
        }
    };
    //---
    $scope.addAssetDetail = function(){
        $scope.group[$scope.TEMP_NEW] = JSON.parse(JSON.stringify(emptyKey));
        $scope.group[$scope.TEMP_NEW].id.key = 'Seleziona un modello';
        $scope.emptyFilter();
        $scope.toggleSearchTerms();
    };

    var emptyKey = {
        id: {
            domain: {
                domain1: "*",
                domain2: "*",
                domain3: "*",
                domain4: "*",
                domain5: "*"
            }
            // key
        }
        // value
    };

    $scope.getModelsList = function () {
        groupFactory.getModelsList().$promise.then(function(data) {
            $scope.modelsList = data.listModel;
            $log.info("___getModelsList___");
            $log.info(data);
        });
    };

    $scope.getModels = function(id){
        groupFactory.getModelsList().$promise.then(function(data) {
            $scope.modelsList = data.listModel;
            $log.info("___getModels___");
            $log.info(data);
            for(var i=0; i<$scope.modelsList.length; i++){
                var model = $scope.modelsList[i];
                $scope.group[model.name] = JSON.parse(JSON.stringify(emptyKey));
                $scope.group[model.name].id.key = model.name;
            }

            if(angular.isDefined(id)){
                $scope.getGroup(id);
            }
        });
    }

    $scope.getGroup = function(id) {
        $scope.group.id = id;
        var payload = {
            id: $scope.group.id
        };
        groupFactory.getGroup(payload).$promise.then(function(data) {
            $log.info("___getGroup___");
            $log.info(data);
            for(var i=0; i<data.list.length; i++){
                var key = data.list[i].id.key;
                if(angular.isDefined($scope.group[key])){
                    $scope.group[key].value = data.list[i].value;
                    $scope.group[key].id.domain.domain1 = data.list[i].id.domain.domain1;
                    $scope.group[key].id.domain.domain2 = data.list[i].id.domain.domain2;
                    $scope.group[key].id.domain.domain3 = data.list[i].id.domain.domain3;
                    $scope.group[key].id.domain.domain4 = data.list[i].id.domain.domain4;
                    $scope.group[key].id.domain.domain5 = data.list[i].id.domain.domain5;
                }
            }
            $scope.loadCommissions();
            $scope.loadTreeEntities();
        });
    }

    $scope.getCommissions = function(){
        $scope.commissionsSelected = {items: []};
        commissionFactory().getCommissionsList({pageSize: 10000}).$promise.then(function(response) {
            if(response.list){
                $scope.commissions = response.list;
            }
        });
    };

    $scope.loadCommissions = function(){
        if(angular.isDefined($scope.group.commission) && angular.isDefined($scope.group.commission.value)){
            var tokens = $scope.group.commission.value.split(";");
            for(var i=0; i<tokens.length; i++){
                commissionFactory().getCommissionByCode({code: tokens[i]}).$promise.then(function(response) {
                    $scope.commissionsSelected.items.push(response);
                })
            }
        }
    };

    $scope.getTreeEntities = function(){
         $scope.schemasSelected = {items: []};
         treeFactory.nodeSchemasList({pageSize: 10000}).$promise.then(function(response){
            if(response.list){
                $scope.schemas = response.list;
            }
         });
    };

    $scope.loadTreeEntities = function(){
        if(angular.isDefined($scope.group.tree) && angular.isDefined($scope.group.tree.value)){
            var tokens = $scope.group.tree.value.split(";");
            for(var i=0; i<tokens.length; i++){
                schemaFactory().byCode({id: tokens[i]}).$promise.then(function(response){
                    $scope.schemasSelected.items.push(response);
                });
            }
        }
    };

    $scope.saveForm = function () {
        if(angular.isUndefined($scope.group.id || $scope.group.id=='')){
            toaster.pop('error', 'Errore', 'Inserire un nome per il gruppo');
        }
        else{
            // commission
            $scope.group.commission.value = '';
            for(var i=0; i<$scope.commissionsSelected.items.length; i++){
                if($scope.group.commission.value!=''){
                    $scope.group.commission.value += ';';
                }
                $scope.group.commission.value += $scope.commissionsSelected.items[i].code;
            }
            groupFactory.saveKey($scope.group.commission).$promise.then(function(response){
                var test = response;
            });
            // tree
            $scope.group.tree.value = '';
            for(var i=0; i<$scope.schemasSelected.items.length; i++){
                if($scope.group.tree.value!=''){
                    $scope.group.tree.value += ';';
                }
                $scope.group.tree.value += $scope.schemasSelected.items[i].model.code;
            }
            groupFactory.saveKey($scope.group.tree).$promise.then(function(response){
                var test = response;
            });
            // Altre entry
            if(angular.isDefined($scope.group[$scope.TEMP_NEW])){
                delete $scope.group[$scope.TEMP_NEW];
            }
            for (var key in $scope.group) {
                if($scope.isAssetEntry($scope.group[key])){
                    groupFactory.saveKey($scope.group[key]);
                }
            }
        }
    };

    $scope.isAssetEntry = function(group){
        var result = true;
        if(angular.isUndefined(group.id)){
            result = false;
        }
        else if(group.id.key=='commission'){
            result = false;
        }
        else if(group.id.key=='tree'){
            result = false;
        }
        return result;
    };

    $scope.removeGroup = function(key){
        delete $scope.group[key];
    };

    //__main__
    if($routeParams.id) {
        if($routeParams.id != 'new'){
            $scope.isNew = false;
            $scope.getModels($routeParams.id);
        }
        else{
            $scope.isNew = true;
            $scope.getModels();
        }
    }
    $scope.getCommissions();
    $scope.getTreeEntities();

  });

'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:GroupListCtrl
 * @description
 * # GroupListCtrl
 * Controller of the emma.theme
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/group', {
            templateUrl: 'theme/group/group_list.html',
            controller: 'GroupListCtrl'
        })
  })
  .controller('GroupListCtrl', function ($scope, groupFactory, $log, $location) {
    $scope.groupsList = {};

    $scope.getGroupsList = function () {
      groupFactory.getGroupsList().$promise.then(function(data) {
            $scope.groupsList = data.list;
      });
    };

    $scope.goToNewGroup = function(){
        $location.path('group/detail');
    };

    //__main__
    $scope.getGroupsList();
  });

/**
 * Created by Rita on 18/07/17.
 */

angular.module('ictportal.theme')
.config(function ($routeProvider) {
    $routeProvider
        .when('/ict/font', {
            templateUrl: 'theme/ict-font/ict-font.html',
            controller: 'IctFronCtrl'
        })
})
.controller('IctFronCtrl', function ($scope) {
    $scope.font = [
        { icon: "icon1-accetazione"},
        { icon: "icon1-autoclave"},
        { icon: "icon1-dirty-ferri"},
        { icon: "icon1-ferri"},
        { icon: "icon1-garments"},
        { icon: "icon1-packaging"},
        { icon: "icon1-pieghatura"},
        { icon: "icon1-qualita"},
        { icon: "icon1-shipment"},
        { icon: "icon1-warehouse"},
        { icon: "icon1-washing"},
        { icon: "icon1-reception"},
        { icon: "icon1-packaging-box"},
        { icon: "icon1-storage"},
        { icon: "icon1-drop"},
        { icon: "icon1-quality"},
        { icon: "icon1-sterilization"}
    ];
});
'use strict';

/**
 * @ngdoc function
 * @name ictportal.controller:ExtCtrl
 * @ExtCtrl
 * # JsfctrlCtrl
 * Controller of the ictportal
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/jasper', {
          templateUrl: 'theme/jasper/jasper.html',
          controller: 'JasperCtrl'
        })
  })
  .controller('JasperCtrl', function (APP_URL, $scope, $log, authFactory, $routeParams, $location, HISTORY) {
    var MAX_HISTORY = 5;
    var authData = authFactory.getAuthData();
    $scope.showHistory = HISTORY;
    $scope.functionHistory = [];
    if (angular.isDefined(authData.info) && angular.isDefined(authData.info.history)){
      //se viene ricaricato il browser recupero l'history
      authData.info.history.forEach(function(item){
        var found = false;
        var i=0
        for(; i<$scope.functionHistory.length; i++){
          if($scope.functionHistory[i].route===item.route){
            found = true;
            break;
          }
        }
        if(found){
          $scope.functionHistory = $scope.functionHistory.splice(i,0);
        }
        $scope.functionHistory.push(item);
      });
      $scope.functionHistory.length = MAX_HISTORY;

      $scope.extern = [];
      $scope.functionHistory.forEach(function(item){
        if(item.route.indexOf('jasper') !== -1){
          $scope.extern.push({
            id: item.$$hashKey,
            route: item.route
          });
        }
      });
    };

    $scope.changeRoute = function(item){
      var tokens = item.route.split("jasper");
      if(tokens.length===1){
        $location.path( '/' + item.route);
      }
      else{
        var el = angular.element(document.getElementById(item.$$hashKey));
        window.location.href = el[0].href;
      }
    };

    function random(seed) {
      var x = Math.sin(seed) * 10000;
      return x - Math.floor(x);
    }
    function pseudoguid(){
      return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0,3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
    }
    function S4(seed) {
      if (!seed) seed = (new Date()).getSeconds();
      return (((1+random(seed))*0x10000)|0).toString(16).substring(1);
    }
    $scope.getExtURL = function () {
        if (authFactory.getAuthData() == null)
        {
            console.log('JsfCtrl auth data null');
            return '';
        }
        return $routeParams.url + "&userId=" + authFactory.getAuthData().info.userId + "&divcod=" + authFactory.getAuthData().info.divCod;
      };
  });


'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:JsfctrlCtrl
 * @description
 * # JsfctrlCtrl
 * Controller of the sixEmmaApp
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/jsf', {
          templateUrl: 'theme/jsf/jsf.html',
          controller: 'JsfCtrl'
        })
  })
  .controller('JsfCtrl', function (APP_URL, $scope, sixFrameFactory, $routeParams, $rootScope, $location, authFactory) {

        $scope.jsfurl = null;

        var MAX_HISTORY = 5;
        var authData = authFactory.getAuthData();
        $scope.functionHistory = [];
        $scope.debug = false;
        $scope.function = {
        //action: '150.350.100'
        action: $routeParams.id
        };


        function getHistory(){
        if (authData && angular.isDefined(authData.info) && angular.isDefined(authData.info.history)){
            //se viene ricaricato il browser recupero l'history
            authData.info.history.forEach(function(item){
            var found = false;
            var i=0
            for(; i<$scope.functionHistory.length; i++){
                if($scope.functionHistory[i].route===item.route){
                found = true;
                break;
                }
            }
            if(found){
                $scope.functionHistory = $scope.functionHistory.splice(i,0);
            }
            $scope.functionHistory.push(item);
            });
            $scope.functionHistory.length = MAX_HISTORY;

            $scope.extern = [];
            $scope.functionHistory.forEach(function(item){
            if(item.route.indexOf('ext') !== -1){
                $scope.extern.push({
                id: item.$$hashKey,
                route: item.route
                });
            }
            });
        };
        };

        $scope.getShowJsfToolbar = function() {
            return $rootScope.showJsfToolbar;
        }

        $rootScope.$on('$locationChangeStart', function (event, current, previous) {
            console.log("Previous URL" +previous);
            var fromEggs = previous.indexOf('eggs')>0;
            var toSix = current.indexOf('jsf')>0;
            var isShowToolbar = fromEggs && toSix;
            var siblings = false;
            if (current.indexOf('&t=1')>0) {
                siblings = current.replace('&t=1', '') == previous;
            }
            if(previous != current && !siblings) {
                $rootScope.showJsfToolbar = isShowToolbar;
            }

            //comunico anche all'iframe il cambio di url
            var iframe = document.getElementById("jsfFrame");
            if (!iframe){
              return;
            }
            var iframeWindow = iframe.contentWindow;
            if (iframeWindow.onlocationchange){
              iframeWindow.onlocationchange(current, previous);
            }
        });

        $scope.changeRoute = function(item){
        var tokens = item.route.split("ext");
        if(tokens.length===1){
            $location.url( '/' + item.route);
        }
        else{
            var el = angular.element(document.getElementById(item.$$hashKey));
            window.location.href = el[0].href;
        }
        };

        $scope.getJsfURL = function () {
            return sixFrameFactory.getJsfURL($scope.jsfurl ||
              ($routeParams && $routeParams.jsfAction && (APP_URL + '/?jsfAction=' + $routeParams.jsfAction)));
        };

        $scope.getLogoutUrl = function () {
            return APP_URL + '/logout.jsp?noredirect=true';
        };

        function init(){
            getHistory();
        };

        init();

    });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.theme.controller:LandingCtrl
 * @description
 * # LandingCtrl
 * Application landing page. It handles redirection to specific pages.
 */
angular.module('ictportal.theme')
    .controller('LandingCtrl', function ($scope, $rootScope, APP_URL, $location, localStorageService, authFactory) {

        function init(){
            if($scope.app){
                if($scope.app.touch){
                    $location.path('bookmarks');
                }
                else{
                    var authData = authFactory.getAuthData();
                    if(authData && authData.eggs && authData.six){
                        $location.path('welcome/0');
                    }
                    else if(authData && authData.eggs){
                        $location.path('eggs/0');
                    }
                    else if(authData && authData.six){
                        if(authData.bookmarks && authData.bookmarks.length>0) {
                            $location.path('bookmarks/home');
                        }
                        else {
                            $location.path('jsf');
                        }
                     }
                    else{
                        $location.path('');
                    }

                }
            }
        };

        init();
    });
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:LoginCtrl
 * @description
 * # LoginCtrl
 * Controller of the emma.theme
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
    $routeProvider
    .when('/fakelogin', {
          templateUrl: 'theme/login/fakelogin.html',
          controller: 'FakeLoginCtrl'
        });
  })
  .controller('FakeLoginCtrl', function LoginCtrl(APP_URL, $rootScope, $scope, $http, $location, authFactory, recordFactory, counterFactory, sysConfigFactory, schemaFactory, $log, ENV) {

    $scope.profiles = [
      { user: 'polist', role: 'SuperAdmin' },
      { user: 'emil', role: 'ICTUser' },
      { user: 'dummy', role: 'Dummy' }
    ];

    function createNewOperator(authData) {
      var filters = {
        'model.username': sixFiltersLib.exact('model.username', authData.authId)
      };

      recordFactory('operatore').search(filters).$promise.then(function(resp) {
        $log.info('------ operator ------');
        $log.info(resp);
        $log.info('----------------------');

        // Creo l'operatore solo se non esiste già un operatore con lo username loggato
        if(!resp.list || resp.list.length == 0) {
          var newOp = {};
          newOp.description = authData.info.name + ' ' + authData.info.surname;
          newOp.mail = authData.info.mail;
          newOp.username = authData.authId;

          schemaFactory().byUUID({id: 'operatore'}).$promise.then(function (schemaResp) {
            if (!schemaResp.model) {
              dialogService.alert('Non è stato definito un modello per l\'entità operatore', 4000);
              return;
            }
            /* ***** Search filters ***** */
            if(schemaResp.model.selfGeneratedCode){
              var selfGeneratedCode = schemaResp.model.selfGeneratedCode;

              counterFactory.next({code: selfGeneratedCode.codeNameSix}).$promise.then(function (counterResp) {
                if (counterResp.errors){
                  $log.error('Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + counterResp.errors.error);
                  toaster.pop('error', 'Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + counterResp.errors.error);
                } else {
                  newOp.code = counterResp.next;

                  var payload = {
                    page: 1,
                    page_size: 1,
                    cross: true,
                    history: false
                  };
                  var filters = {
                    role: sixFiltersLib.in('model.ldap_groups.code', authData.authPermission)
                  };
                  sysConfigFactory('rolemapping').search(payload, filters).$promise.then(function(result) {
                    if(result && result.list.length > 0) {
                      newOp.typeoperator_id = result.list[0].model.emma_role_id;
                    } else {
                      $log.error('Mapping per il ruolo \''+ authData.authPermission +'\' non trovato');
                    }

                    $log.info('------ new operator ------');
                    $log.info(newOp);
                    $log.info('--------------------------');

                    recordFactory('operatore').create(newOp).$promise.then(function(respOp) {
                      $log.info('------ create operator ------');
                      $log.info(respOp);
                      $log.info('-----------------------------');
                    });
                  });

                }

              });
            }
          });
        }
      });
    }

    $scope.login = function(profile) {
      $http.get('emmacas/fakepostauth/'+profile.user+'/'+ENV).success(function(data, status) {
        $log.info(status);
        $log.info(data);
        $scope.response = data;

        if (!data.info || !data.info.commissions || !data.info.commissions.current){
          return;
        }

        if(ENV == 'asset') {
          createNewOperator(data);
        }

        authFactory.setAuthData(data);
        $location.path('/home');
      }).error(function(error) {
        $log.log(error);
      });
    };

  });

'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:LoginCtrl
 * @description
 * # LoginCtrl
 * Controller of the emma.theme
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/login', {
        templateUrl: 'theme/login/login.html',
        controller: 'LoginCtrl'
      })
      .when('/logout', {
        template: '<br/>',
        controller: 'LogoutCtrl'
      });
  })
  .controller('LogoutCtrl', function LogoutCtrl($location, $log, authFactory) {
    authFactory.logout();
    $location.path("/login");
  })
  .controller('LoginCtrl', function LoginCtrl(LOGIN_URL, APP_URL, EGGS_URL, $rootScope, $scope, $http, $location, $log, SCRAMBLED_URL, ABNORMAL_URL,
                                              loginFactory, authFactory, dialogService, localStorageService, recordFactory, $q, localeFactory, $cookies, dbFilterFactory, matrixParFactory, wsfactory, $routeParams,
                                              $timeout) {
    document.title = 'LOGIN';
    $scope.workstation = {};
    $scope.workstation.code = localStorageService.get('workstation');
    $scope.workstation.editing = false;
    $scope.autoProfile = false;
    $scope.selected = {};
    $scope.companies = [];
    $scope.touch = false;
    $scope.isEggs = false;
    $scope.isSix = false;

    $scope.isFormInvalid = function(user){
      var result = angular.isUndefined(user) || !(user.username) || !(user.password) || !($scope.selected.company);
      return result;
    };

    $scope.login = function (user) {
      if(!user.password){
        user.password = "$$Barcode";
      }
      $rootScope['systems'] = { isSix: false, isEggs: false};
      $scope.errors = false;
      dialogService.loading('login');
      user['azcod'] = $scope.selected.company.code.toString();
      $http.post(ABNORMAL_URL + '/api/login', user).success(function (data, status, headers, config) {
        if (status === 200) {
          data['options'] = { config: false };

          $rootScope.systems.isEggs = data.eggs;
          $rootScope.systems.isSix = data.six;

          if($rootScope.systems.isEggs && !$rootScope.systems.isSix){
            loginEggs(data, user);
          }
          if($rootScope.systems.isSix && !$rootScope.systems.isEggs){
            loginSix(data, user);
          }
          if($rootScope.systems.isSix && $rootScope.systems.isEggs){
            loginSixEggs(data, user);
          }

          if(!$rootScope.systems.isSix && !$rootScope.systems.isEggs){
            $scope.errors = true;
            dialogService.stopLoading();
          }

        }    
        else {
            user.password = "";
          $scope.errors = true;
          dialogService.stopLoading();
        }
      }).error(function () {
        // Error handling
        $scope.errors = true;
        dialogService.stopLoading();
      });
    };

    function loginEggs(data, user){
      $log.info('loginEggs');
      // Attenzione: questo andava bene per HR. Verificare per altri progetti
      data['profile'] = { cod: '1', code: '1', description: 'ICT', isAdmin: (data.profile.code === "Amministratori"), isHR: (data.profile.code === "SVRU"), items: [{ code: 'ICT', description: 'ICT', items: null }] };
      data.info.companyName = $scope.selected.company.description.toString();
      authFactory.setAuthData(data);
      $http.post(EGGS_URL + '/api/auth/login', user).success(function (body, status, headers, config) {
        if (status === 200) {
          dialogService.stopLoading();
          $location.path("/");
        }
      });
    };

    function loginSix(data, user){
      $log.info('loginSix');

      authFactory.setAuthData(data);
      localStorage.setItem('touch', $scope.touch);

      if($scope.touch != checkCookieTouch()){
        $cookies.put('touch', $scope.touch);
      }

      if(data.profiles.length>1 || data.profiles[0].items.length>1){
        // Rimando alla pagina (che sono poi sempre io) di selezione stabilimento
        dialogService.stopLoading();
        $location.path("/");
      }
      else if(data.profiles[0].items.length===1){
        $scope.autoProfile = true;
        $scope.switchProfile(data.profiles[0], data.profiles[0].items[0]);
      }
      else{
        //TODO: gestire il caso senza divisioni
        //$scope.switchProfileTest(data.profiles[0]);
      }
      // if(!$scope.autoProfile || $scope.errors){
        dialogService.stopLoading();
      // }
    };

    function loginSixEggs(data, user){
      $http.post(EGGS_URL + '/api/auth/login', user).success(function (body, status, headers, config) {
        if (status === 200) {
          authFactory.setAuthData(data);

          localStorage.setItem('touch', $scope.touch);
          if($scope.touch != checkCookieTouch()){
            $cookies.put('touch', $scope.touch);
          }

          if(data.profiles.length>1 || data.profiles[0].items.length>1){
            // Rimando alla pagina (che sono poi sempre io) di selezione stabilimento
            $location.path("/");
          }
          else if(data.profiles[0].items.length===1){
            $scope.autoProfile = true;
            $scope.switchProfile(data.profiles[0], data.profiles[0].items[0]);
          }
          else{
            //TODO: gestire il caso senza divisioni
            //$scope.switchProfileTest(data.profiles[0]);
          }
          if(!$scope.autoProfile || $scope.errors){
            dialogService.stopLoading();
          }
        }
      });
    };

    function isApp(){
      $http.get(ABNORMAL_URL + '/api/is/app').success(function (body, status, headers, config) {
        if (status === 200) {
          $scope.isEggs = body.eggs;
          $scope.isSix = body.six;
        }
      });
    };

    $scope.gotoPassword = function(){
      $location.path('password');
    }

    $scope.switchProfile = function (profile, subprofile) {
      var switchProfileElement = {
        selected: {
          cod: profile.cod,
          code: profile.code,
          description: profile.description,
          items: [
            {
              cod: subprofile.cod,
              code: subprofile.code,
              description: subprofile.description
            }
          ]
        }
      };
      if(!$scope.autoProfile){
        dialogService.loading('Cambio profilo: ' + subprofile.description);
      }
      loginFactory.switchprofile(switchProfileElement).$promise.then(function (response) {
        var prevAuth = authFactory.getAuthData();
        response.menu = prevAuth.menu;
        response.six = prevAuth.six;
        response.eggs = prevAuth.eggs;
        authFactory.setAuthData(response);
        if(response.bookmarks.length===0 && authFactory.getAuthData().info.userId) {
          loadRuolo();
        }
        else{
          $location.path("/");
          dialogService.stopLoading();
        }
      });
    };

    //GET RUOLO START
    function loadRuolo(){
      var authdata = authFactory.getAuthData();
      var filter = dbFilterFactory.getStringFilter('user_id', authdata.info.userId.toString(), '=');
      recordFactory('profile').filter(JSON.stringify(filter))
      .$promise.then(function (prof){

        var type_id = prof.list[0].type_id;
        recordFactory('profile_type').byId({ id: type_id }).$promise.then(function (response) {

          matrixParFactory.getValueOrDefault({key: 'bookmarks', d1: '*', d2: '*', d3: response.name, d4: '*', d5: '*'}, {}).$promise.then(function(data){

            if(data.result.value) {

              var bookmarks = JSON.parse(data.result.value);
              authdata.bookmarks = bookmarks;
              authFactory.setAuthData(authdata);
            }

            $location.path("/");
            dialogService.stopLoading();
          });
        });
      });
    }
    //GET RUOLO END


    $scope.getProfiles = function () {
      var data = authFactory.getAuthData();
      if (!angular.isUndefined(data) && data.hasOwnProperty('authToken')) {
        return data.profiles;
      }
      return null;
    };

    $scope.wsClick = function () {
      if ($scope.workstation.editing) {
        localStorageService.set('workstation', $scope.workstation.code);
        $scope.workstation.editing = false;
        $scope.checkWs();
      } else {
        $scope.workstation.editing = true;
      }
    };

    $scope.checkWs = function () {
      if ($scope.workstation.code) {
        matrixParFactory.getValueOrDefault({key: 'login.badge.withWorkstation', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}, {defaultValue: 'false'}).$promise.then(function(resp){
          if (resp.result.value === 'true') {
            $http.get(APP_URL + '/rest/devices/url/' + $scope.workstation.code).success(function (data) {
              wsfactory.open(data.url);
            });
          }
        });
      } else {
        $scope.workstation.error = '';
      }
    };

    $scope.$on( 'wsfactory:newMessage', function(event, param) {
      if(param){
          $log.info(param);
          param = JSON.parse(param);
          if(param.reads != null && param.reads.length != null && param.reads.length >0){
            console.log(param.reads[0].read);
            var user = {};
            user['username']="$$barcode";
            user['password']=param.reads[0].read;
            $scope.login(user);
          }
      }
    });

    function getCompanies(){
      $scope.companies.length = 0;
      var promises = [
        recordFactory('societa', 'eggs').query({page_size: 10000}).$promise,
        recordFactory('company', 'six').query({page_size: 10000}).$promise
      ];

      $q.allSettled(promises).then(function(data){
        // aziende eggs
        if(data[0].state==='fulfilled' && data[0].value.list){
          data[0].value.list.forEach(function(item){
            if(item.idsocieta) {
              $scope.companies.push({
                code: item.idsocieta,
                description: item.ragsoc
              });
            } else if(item.idSocieta) {
              $scope.companies.push({
                code: item.idSocieta,
                description: item.ragSoc
              });
            }

          });
        }
        // aziende six
        else if(data[1].state==='fulfilled' && data[1].value.list){
          data[1].value.list.forEach(function(item){
            $scope.companies.push({
              code: item.azcod,
              description: item.rag_soc
            });
          });
        }
        // concatenazione dei risultati ottenuti
        if($scope.companies.length==1){
          $scope.selected.company = $scope.companies[0];
        }
      });
    };

    $scope.changeTouch = function() {
      if($scope.touch){
        $scope.touch = false;
      }
      else{
        $scope.touch = true;
      }
    }

    function checkCookieTouch() {
      var touch = $cookies.get('touch');
      return touch === 'true' ? true : false;
    }

    function workstationFromQueryParams() {
      if (angular.isDefined($routeParams.workstation)) {
        $scope.workstation.code = $routeParams.workstation;
        localStorageService.set('workstation', $scope.workstation.code);
      }
    }

    function init() {
      isApp();
      $scope.touch = checkCookieTouch();
      workstationFromQueryParams();
      $scope.checkWs();
      localeFactory.detectLanguage();
      getCompanies();
      $timeout(function () {
        window.angular.element('#username').focus();
      }, 100);
    }

    init();

  });


angular.module('ictportal.theme')
    
.config(function ($routeProvider) {
    $routeProvider.when('/message', {
        templateUrl: 'theme/message/message.html',
        controller: 'messageCtrl'
    })
})

.controller('messageCtrl', function ($scope, msgFactory, authFactory, recordFactory, $q, toaster, $rootScope) {

    $scope.selection = {
      project: [],
      message: '',
      selectAll: true,
      level: 'normal'
    };

    var user = null;

    $rootScope.$on('msgFactory:newMessage',function(event, data){
        $scope.data = data;
    })

    function init() {
        getLoginUser().then(function(data){user = data.nome +' '+data.cognome});
    }
    
    function getLoginUser (){
      var deferred = $q.defer();
      var result = undefined;
      var authData = authFactory.getAuthData();
      if(authData){
        var payload = {
            code: 'username',
            description: 'username',
            query: authData.authId
        };
        recordFactory('users').query(payload)
          .$promise.then(function (data){
              if(data.totalResults>0){
                result = data.list[0];
                deferred.resolve(result);
              }
              else{
                  toaster.pop('warning','Attenzione','Utente di login non trovato');
              }
          });
      }
      return deferred.promise;
    };
    
    $scope.broadcast = function () {
        var message = {
            from: user,
            message: $scope.selection.message,
            project: '_all',
            icon: 'Chat-2.svg',
            level: $scope.selection.level
          };

        msgFactory.sendMsg(message);
    }

    init();
});
'use strict';

/**
 * @ngdoc service
 * @name ictportal.theme.modelFactory
 * @description
 * # modelFactory
 * Factory in the ictportal.theme.
 */
angular.module('ictportal.theme')
  .factory('modelFactory', function (DATA_SET_URL, $resource) {
    return $resource(DATA_SET_URL + '/api/model/:type/:id', {}, {
      query:  { method: 'GET', params: {type: '@type'}, isArray: false },
      create: { method: 'POST', params: {type: '@type'}},
      show:   { method: 'GET' },
      update: { method: 'PUT', params: {type: '@type', id: '@id'} },
      delete: { method: 'DELETE', params: {type: '@type', id: '@id'}}
    });
  });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.theme.controller:ModeltypeCtrl
 * @description
 * # ModeltypeCtrl
 * Controller of the ictportal.theme
 */
angular.module('ictportal.theme')
.config(function ($routeProvider) {
    $routeProvider
      .when('/modeltype/list/:db', {
        templateUrl: 'theme/modeltype/modeltype_list.html',
        controller: 'ModeltypeCtrl'
      })
      .when('/modeltype/detail/:db/:entity', {
        templateUrl: 'theme/modeltype/modeltype_detail.html',
        controller: 'ModeltypeCtrl'
      })
  })
  .controller('ModeltypeCtrl', function ($scope, $routeParams, $location, $log, $window, formulaFactory, $filter,
                                         schemaFactory, uiGridConstants, sixGridPaginationConstants, toaster, $q,
                                         localeFactory, $rootScope, eggsFormFactory, recordFactory) {
    var FUNCTIONS_TABLE = 'functions';
    var PROGRESS_STEP = 50;
    var RENDERING_TIME = 25;
    var msg = {
      save_completed: 'Salvataggio completato',
      op_completed_success: 'Operazione completata con successo',
      warning: 'Attenzione'
    };                     
    var modeltype_msg = {
      no_table_found: 'Non è stata trovata nessuna tabella con questo nome'
    };                
    $scope.database = 'six';                                      
    $scope.lookup = {};
    $scope.element = {}; // TODO: COMPLETARE
    $scope.form = {};
    $scope.model = {};
    $scope.schema = {};
    $scope.property = {};
    $scope.checked = {};
    $scope.uiselectMap = {};
    $scope.itemTypeMap =  {};
    $scope.customDetailPath = false;
    $scope.showStdPanel = false;
    $scope.ignoreDivcod = false;
    $scope.ignoreAzcod = false;
    $scope.generating = false;
    $scope.translate = false;
    $scope.modifyTable = false;
    $scope.readOnly = false;
    $scope.progress = {
      total: 0,
      loaded: 0
    };

    $scope.newItemArray = {
      record_id: {}
    };

    $scope.status = {
      isFirstOpen: true,
      isFirstDisabled: false
    };

    $scope.selfGeneratedCode = {
      codeNameSix: '',
      active: false
    };

    $scope.type = { list: [], totalResults: 0 };

    $scope.params = {
      pageNumber: 1,
      pageSize: 15,
      totalItems: 0,
      queryParam: undefined,
      filters: []
    };

    $scope.gridAppCallbacks = {};

    $scope.viewGridOptions = {
      enableSorting: true,
      enableFiltering: true,
      columnDefs: [],
      data: 'type.list',
      enableColumnResizing: true,
      paginationPageSize: $scope.params.pageSize
    };

    function initGridColumns(){
      $scope.viewGridOptions.columnDefs = [
        {
          displayName: '',
          field: 'id',
          width: 34,
          enableCellEdit: true,
          enableFiltering: false,
          enableSorting: false,
          cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' +
              '<a ng-href="#/modeltype/detail/' + $scope.database + '/{{row.entity.description}}" class="btn btn-xs btn-primary">' +
                '<span class="fa fa-search"></span>' +
              '</a>' +
            '</div>'
        },
        {
          displayName: 'Codice',
          field: 'model.code',
          enableFiltering:true,
          filters:[{
            type: sixGridPaginationConstants.filterType.TEXT,
            condition: uiGridConstants.filter.CONTAINS, //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
            placeholder: ''
          }]
        },
        {
          displayName: 'Descrizione',
          field: 'model.description',
          enableFiltering: true,
          filters: [{
            type: sixGridPaginationConstants.filterType.TEXT,
            condition: uiGridConstants.filter.CONTAINS,
            placeholder: ''
          }]
        }
      ];
    };

    $scope.newModel = function(){
        $location.path('modeltype/' + $scope.typeName+ '/new');
    };

    $scope.debug = function(){
        $scope.jsonshow;
    };

    $scope.refresh = function(){
        $scope.getType();
        $location.path('modeltype/' + $scope.typeName);
    };

    $scope.getFormulaList = function () {
      formulaFactory.getFormulasList({query: $scope.queryParam, page_size: 1000}).$promise.then(function(data) {
        $scope.formulaList = data.list;
      });
    };

    $scope.getType = function () {
      schemaFactory($scope.database).list().$promise.then(function(result) {
        $scope.type.list = result.list || [];
        $scope.type.totalResults = $scope.type.list.length;
        $scope.progress.total = $scope.type.list.length;
      });
    };

    $scope.pageList = function () {
      $location.path('/modeltype/' + $scope.database + '/' +$scope.typeName, false);
    };

    $rootScope.$on('$translateRefreshEnd', function () {
      localeFactory.translateMsg(msg);
      localeFactory.translateMsg(modeltype_msg, 'modeltype');
    });
    
    function init(){
      localeFactory.loadTranslation('modeltype');
      var CODE_FIELD = 'codice';
      if($routeParams.db){
        $scope.database = $routeParams.db;   
        FUNCTIONS_TABLE = ($scope.database==='six')?'functions':'funzioni';
        CODE_FIELD = ($scope.database==='six')?'codice':'descrizione';
      }                                   
      eggsFormFactory.addLookup($scope.lookup, 'function_id', FUNCTIONS_TABLE, CODE_FIELD, 'descrizione');
      if($routeParams.entity) {
        $scope.typeName = $routeParams.entity;        
      }
      else{
        initGridColumns();        
        $scope.chargeAceModel();
        $scope.getType();
      }
    };

    $scope.saveForm = function() {
      if($scope.type.selected.model.code && $scope.type.selected.model.description) {
        var toSave = JSON.parse($scope.aceModel);
        toSave.model.database = $scope.database;
        linkMenuFunction(toSave);
        schemaFactory($scope.database).setCode({id: $scope.code},toSave.model)
          .$promise.then(function() {
            $scope.isNewModel = false;
            toaster.pop('success', msg.save_completed, msg.op_completed_success);
          });
      }
    };

    function linkMenuFunction(sf){
      if($scope.lookup.function_id.obj){
        //__________________________________________________________________ EGGS 
        if($scope.database==='eggs'){
          // Salvo il riferimento alla funzione nel modello dello schemaform
          var functionModel = {
            code: $scope.lookup.function_id.obj.descrizione,
            description: $scope.lookup.function_id.obj.descrizione,
            UUID: $scope.lookup.function_id.obj.id,
            type: FUNCTIONS_TABLE,
          };
          sf.model.function_id = functionModel;
          // salvo il link al record nella tabella funzioni
          var model = {
            portal: 'S',
            angular_path: 'record/eggs/list/' + $scope.type.selected.model.code,
            funzione: 'record/eggs/list/' + $scope.type.selected.model.code
          };
          recordFactory(FUNCTIONS_TABLE, $scope.database).update({id: functionModel.UUID}, model)
            .$promise.then(function(data){
              if(data.updated){
                toaster.pop('success','Operazione completata','Operazione completata con successo');
                $window.history.back();
              }
              else{
                toaster.pop('error','Errore','Si è verificato un errore durante il salvataggio');
              }
            });
        }
        //__________________________________________________________________ SIX
        else{
          // Salvo il riferimento alla funzione nel modello dello schemaform
          var functionModel = {
            code: $scope.lookup.function_id.obj.codice,
            description: $scope.lookup.function_id.obj.descrizione,
            UUID: $scope.lookup.function_id.obj.id,
            type: FUNCTIONS_TABLE,
          };
          sf.model.function_id = functionModel;
          // salvo il link al record nella tabella funzioni
          $scope.lookup.function_id.obj.jsf_action = 'record/list/' + $scope.type.selected.model.code;
          $scope.lookup.function_id.obj.angular_path = 'record/list/' + $scope.type.selected.model.code;
          delete $scope.lookup.function_id.obj['UUID'];
          delete $scope.lookup.function_id['model'];
          recordFactory(FUNCTIONS_TABLE, $scope.database).update({id: functionModel.UUID}, $scope.lookup.function_id.obj)
            .$promise.then(function(data){
              if(data.updated){
                toaster.pop('success','Operazione completata','Operazione completata con successo');
                $window.history.back();
              }
              else{
                toaster.pop('error','Errore','Si è verificato un errore durante il salvataggio');
              }
            });
        }
      }
    };

    function loadMenuFunction(sf){
      if(sf.function_id){
        recordFactory(FUNCTIONS_TABLE, $scope.database).byId({id: sf.function_id.UUID})
          .$promise.then(function (data) {
            $scope.lookup['function_id'].obj = data;
          });
      }
    };

    $scope.delete = function (idToDelete) {
      schemaFactory($scope.database).delete({id: idToDelete}).$promise.then(function() {
        $window.history.back();
      });
    };

    $scope.generateAll = function(){
      $scope.generating = true;
      $scope.progress.loaded = 0;
      setTimeout(generateFromTo(0,PROGRESS_STEP),RENDERING_TIME);
    };

    function generateFromTo(from, to){
      // 1) VERIFICO SE LO SCHEMA ESISTE GIA' OPPURE NO
      var myPromises = {};
      var divf = 100/$scope.progress.total;
      for(var i=from; i<to; i++){
        var schema = $scope.type.list[i];
        if(!schema || i>=$scope.progress.total){
          $scope.generating = false;
          break;
        }
        myPromises[schema.description] = schemaFactory($scope.database).getCode({id: schema.description}).$promise;
      }
      $q.all(myPromises).then(function(responses) {
        for(var code in responses){
          var resp = responses[code];
          if(resp.code){
            $log.info(i + " " + code + " : exists");
            $scope.progress.loaded++;
            $scope.progress.perc = Math.round($scope.progress.loaded*divf);
            if($scope.progress.loaded<$scope.progress.total && $scope.progress.loaded===to){
              setTimeout(generateFromTo($scope.progress.loaded,$scope.progress.loaded+PROGRESS_STEP),RENDERING_TIME);
            }
          }
          else{
            $log.info(i + " " + code + " : missing");
            // 2) SE NON ESISTE LO GENERO
            schemaFactory($scope.database).generate({ id: code }).$promise.then(function(data){
              var newSchemaForm = angular.copy(data);
              newSchemaForm.model.database = $scope.database;
              newSchemaForm.form = [
                          {
                            type: "fieldset",
                            items: [
                              {
                                type: "tabs",
                                tabs: [
                                  {
                                    title: "Base",
                                    items: data.form
                                  }
                                ]
                              }
                            ]
                          }
                        ];
              // 3) PREIMPOSTO ALCUNE VISUALIZZAZIONI DI DEFAULT
              setStandardFormTypes(newSchemaForm);
              // 4) SALVO IL RISULATO OTTENUTO
              schemaFactory($scope.database).setCode({id: data.code},newSchemaForm).$promise.then(function() {
                  $scope.progress.loaded++;
                  $scope.progress.perc = Math.round($scope.progress.loaded*divf);
                  if($scope.progress.loaded<$scope.progress.total && $scope.progress.loaded===to){
                    setTimeout(generateFromTo($scope.progress.loaded,$scope.progress.loaded+PROGRESS_STEP),RENDERING_TIME);
                  }
                });
            });
          }
        }
      });
    };

    function setStandardFormTypes(sf){
      // Le lookup sono sempre rappresentate con delle sixlookup
      for(var key in sf.schema.properties){
        if(sf.schema.properties[key].format==='lookup'){
          var item = getFormItem(sf.form[0],key);
          item.type = 'sixlookup';
        }
      }
      // Questi campi fanno riferimento alla tab utenti (o users), che non ha code e description
      if(sf.schema.properties.utinsid){
        sf.schema.properties.utinsid.mapping.code = 'username';
        sf.schema.properties.utinsid.mapping.description = 'nome,cognome';
      }
      if(sf.schema.properties.utvarid){
        sf.schema.properties.utvarid.mapping.code = 'username';
        sf.schema.properties.utvarid.mapping.description = 'nome,cognome';
      }
      if(sf.schema.properties.created_user_id && sf.schema.properties.created_user_id.mapping){
        sf.schema.properties.created_user_id.mapping.code = 'username';
        sf.schema.properties.created_user_id.mapping.description = 'nome,cognome';
      }
      if(sf.schema.properties.last_modified_user_id && sf.schema.properties.last_modified_user_id.mapping){
        sf.schema.properties.last_modified_user_id.mapping.code = 'username';
        sf.schema.properties.last_modified_user_id.mapping.description = 'nome,cognome';
      }
    };

    $scope.generateForm = function() {
      schemaFactory($scope.database).generate({ id: $scope.code }).$promise.then(function(data){
        if(data.columnDefs.length===0){
          toaster.pop('warning', msg.warning, modeltype_msg.no_table_found);
        }
        else{
          $scope.chargeAceModel();
          $scope.type.selected.model = data;
          $scope.schema = $scope.type.selected.model.schema;
          $scope.form = [
                          {
                            type: "fieldset",
                            items: [
                              {
                                type: "tabs",
                                tabs: [
                                  {
                                    title: "Base",
                                    items: []
                                  }
                                ]
                              }
                            ]
                          }
                        ];
          $scope.type.selected.model.form.forEach(function(item){
            $scope.form[0].items[0].tabs[0].items.push(item);
          });
          $scope.type.selected.model.form = $scope.form;
          // 3) PREIMPOSTO ALCUNE VISUALIZZAZIONI DI DEFAULT
          setStandardFormTypes($scope.type.selected.model);
          $scope.code = $scope.type.selected.model.code;
          $scope.description = $scope.type.selected.model.description;
          $scope.title = $scope.description;
          $scope.updateScope();
        }
      });
    };

    $scope.addProperty = function() {
      if(angular.isDefined($scope.property.key)) {
        var p = {
          title: $scope.property.title,
          type: $scope.property.type,
          check: false
        };
        if($scope.property.format){
          p.format = $scope.property.format;
        }
        if(p.type == 'date'){
          p.type = 'string';
          p.format = 'date';
        }
        if(p.type == 'array'){
          p.items = {type: $scope.property.items_type}; // default
          if($scope.property.items_type === 'date') { // se è una data è diverso...
            p.items = {type: 'string', format: 'date'};
          }
        }
        if($scope.property.inherited){
          if($scope.property.inherited == true){
            p.format = 'inherit';
            p.field = '';
            p.record = '';
            if($scope.property.format){
              p.field_inherit_type = $scope.property.format;
              if($scope.property.format == 'enum'){
                delete p.enum;
              }
            }
            if(p.type == 'integer'){
              p.type = 'number';
            }
          }
        }
        $scope.type.selected.model.schema.properties[$scope.property.key] = p;
        var item = {
          title: angular.copy($scope.property.title),
          type: null,
          key: [angular.copy($scope.property.key)]
        };
        if(p.format){
          if (p.format == 'date'){
            item.type = 'datepicker';
          } else if (p.format == 'time'){
            item.type = 'timepicker';
          } else if (p.format == 'datetime'){
            item.type = 'datetimepicker';
          } else if (p.format == 'enum'){
            item.type = 'uiselect';
            item.titleMap = [];
          } else if (p.format == 'lookup'){
            item.type = 'sixlookup';
          } else if (p.format == 'formula'){
            item.type = 'sixformula';
          } else if (p.format == 'inherit'){
            item.type = 'sixinherit';
          } else if (p.format == 'eggscheckbox'){
            item.type = 'eggscheckbox';
          }
        } else if(p.type == 'string'){
          item.type = 'text';
        } else if(p.type == 'number' || p.type == 'integer'){
          item.type = 'number';
        } else if(p.type == 'boolean'){
          item.type = 'checkbox';
        } else if(p.type == 'array') {
          item.type = 'uiselectmultiple';
          item.titleMap = [];
        } else {  // default
          item.type = angular.copy(p.type);
        }
        for(var i in $scope.type.selected.model.form[0].items) {
          if($scope.type.selected.model.form[0].items[i].tabs) {
            $scope.type.selected.model.form[0].items[i].tabs[0].items.push(item);
          }
        }
      }
      $scope.getUiselectMap();
      $scope.clearNewCol();
      $scope.updateScope();
    };

    $scope.updateScope = function() {
      if($scope.type.selected && $scope.type.selected.model.schema && $scope.type.selected.model.form && $scope.type.selected.model.columnDefs){
        $scope.schema = angular.fromJson(angular.copy($scope.type.selected.model.schema));
        $scope.form = [angular.fromJson(angular.copy($scope.type.selected.model.form[0]))];
        $scope.columnDefs = angular.fromJson(angular.copy($scope.type.selected.model.columnDefs));
        $scope.formChanged();
      }
      $scope.formChanged();
    };

    $scope.clearNewCol = function(){
      $scope.property.key = '';
      $scope.property.title = '';
      delete $scope.property.type;
      delete $scope.property.format;
      delete $scope.property.inherited;
    };

    $scope.getItemType = function(key){
      console.log(valueSchema);
      if(valueSchema.type != 'array'){
        return valueSchema.type;
      } else {
        return valueSchema.items.type;
      }
    };

    $scope.addItemOnArray = function(key, newItem){
      if(newItem != undefined && newItem != null){
        newItem.name = newItem.name.toString();
        if($scope.itemTypeMap[key] == 'integer'){
          if(parseInt(newItem.name)){
            newItem.value = parseInt(newItem.name);
            newItem.name = newItem.value.toString(); /* nel caso ci dovesse essere un cast, torno a sovrascrivere il name */
          } else{
            return;
          }
        } else if($scope.itemTypeMap[key] == 'number'){
          if(parseFloat(newItem.name)){
            newItem.value = parseFloat(newItem.name);
          } else{
            return;
          }
        } else{
          newItem.value = newItem.name.toString().replace(/\s/g, '_');//.toLowerCase();
        }
        for(var i in $scope.type.selected.model.form[0].items) {
          if($scope.type.selected.model.form[0].items[i].tabs) {
            $scope.type.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
              if(key == item.key[0]){
                item.titleMap.push(newItem);
              }
            });
          }
        }
        this.newItem = null;
        $scope.updateScope();
      }
    };

    $scope.deleteItemOnArray = function(key, obj){
      for(var i in $scope.type.selected.model.form[0].items) {
        if($scope.type.selected.model.form[0].items[i].tabs) {
          $scope.type.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            if(key == item.key[0]){
              for (var j = item.titleMap.length; j--; ) {
                if (item.titleMap[j].value == obj.value) {
                  item.titleMap.splice(j, 1);
                }
              }
            }
          });
        }
      }
      this.newItem = null;
      $scope.updateScope();
    };

    $scope.addRefOnArray = function(key, ref) {
      var newItem = {};
      if(ref.record_id != undefined && ref.record_id != null){
        newItem.value = ref.record_id.code;
        newItem.name = ref.record_id.description;
        $scope.addItemOnArray(key, newItem);
      }
    };

    $scope.deleteProperty = function(keyToDelete) {
      delete $scope.type.selected.model.schema.properties[keyToDelete];
      for (var i = $scope.type.selected.model.columnDefs.length; i--; ) {
        if ($scope.type.selected.model.columnDefs[i].field == keyToDelete) $scope.type.selected.model.columnDefs.splice(i, 1);
      }
      for (var i = $scope.type.selected.model.form[0].items.length; i--; ) {
        if ($scope.type.selected.model.form[0].items[i].key && $scope.type.selected.model.form[0].items[i].key[0] == keyToDelete) {
          $scope.type.selected.model.form[0].items.splice(i, 1);
        }
        // Scorro anche i tabs
        if($scope.type.selected.model.form[0].items[i].tabs) {
          for (var j = $scope.type.selected.model.form[0].items[i].tabs.length; j--;) {
            for (var k = $scope.type.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
              if ($scope.type.selected.model.form[0].items[i].tabs[j].items[k].key[0] == keyToDelete) {
                $scope.type.selected.model.form[0].items[i].tabs[j].items.splice(k, 1);
              }
            }
          }
        }
      }
      $scope.updateScope();
    };

    $scope.formChanged = function() {
      $scope.aceModel = JSON.stringify(angular.copy($scope.type.selected), null, '\t');
    };

    $scope.refreshLookupCode = function(key, code){
      $scope.type.selected.model.schema.properties[key].mapping.code = code;
      $scope.updateScope();
    };

    $scope.refreshLookupDescr = function(key, description){
      $scope.type.selected.model.schema.properties[key].mapping.description = description;
      $scope.updateScope();
    };

    $scope.refreshCode = function(code) {
      $scope.chargeAceModel();
      $scope.type.selected.model.code = angular.copy(code);
      $scope.updateScope();
    };

    $scope.refreshDescription = function(description) {
      $scope.chargeAceModel();
      if(description) {
        $scope.type.selected.model.description = angular.copy(description);
        if($scope.isNewModel){
          $scope.code = sixStringLib.removeDiacritics(description);
          // Per six i nomi delle tabelle possono avere degli underscore
          //$scope.code = $scope.code.replace(/[^\w]|_/g, '').replace(/^(\d)(.*)/, '_$1$2').toLowerCase();
          $scope.code = $scope.code.replace(/[^\w]|/g, '').replace(/^(\d)(.*)/, '_$1$2').toLowerCase();
          $scope.type.selected.model.code = angular.copy($scope.code);
        }
      }
      $scope.updateScope();
    };

    $scope.refreshLookup = function(key,entity_id) {
      $scope.chargeAceModel();
      for (var i = $scope.type.selected.model.form[0].items.length; i--;) {
        if ($scope.type.selected.model.form[0].items[i].key && $scope.type.selected.model.form[0].items[i].key[0] == key) {
          $scope.type.selected.model.form[0].items[i].entity_id = angular.copy(entity_id);
        }
        // Scorro anche i tabs
        if($scope.type.selected.model.form[0].items[i].tabs) {
          for (var j = $scope.type.selected.model.form[0].items[i].tabs.length; j--;) {
            for (var k = $scope.type.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
              if ($scope.type.selected.model.form[0].items[i].tabs[j].items[k].key[0] == key) $scope.type.selected.model.form[0].items[i].tabs[j].items[k].entity_id = angular.copy(entity_id);
            }
          }
        }
      }
      $scope.type.selected.model.schema.properties[key].entity_id = angular.copy(entity_id);
      $scope.updateScope();
    };

    $scope.updateTitle = function(field){
      var index = $scope.type.selected.model.columnDefs.findIndex(function(e) { return e.field == field.key[0]; });
      if(index>=0){
        $scope.type.selected.model.columnDefs[index].name = field.title;
      }
      $scope.updateScope();
    };

    $scope.refreshFormula = function(key,formula_id) {
      $scope.chargeAceModel();
      $scope.type.selected.model.schema.properties[key].formula_id = angular.copy(formula_id);
      $scope.updateScope();
    };

    $scope.refreshFormulaParams = function(key,formula_params){
      $scope.chargeAceModel();
      $scope.type.selected.model.schema.properties[key].formula_params = angular.copy(formula_params);
      $scope.updateScope();
    };

    $scope.refreshBasePath = function(key, basePath){
      $scope.chargeAceModel();
      $scope.type.selected.model.schema.properties[key].basePath = angular.copy(basePath);
      $scope.updateScope();
    };

    $scope.refreshWar = function(key, war){
      $scope.chargeAceModel();
      $scope.type.selected.model.schema.properties[key].war = angular.copy(war);
      $scope.updateScope();
    };

    $scope.refreshInheritRecord = function(key, record){
      $scope.chargeAceModel();
      $scope.type.selected.model.schema.properties[key].record = angular.copy(record);
      $scope.updateScope();
    };

    $scope.refreshInheritField = function(key, field){
      $scope.chargeAceModel();
      $scope.type.selected.model.schema.properties[key].field = angular.copy(field);
      $scope.updateScope();
    };

    $scope.refreshFiltered = function(key, filtered){
      $scope.chargeAceModel();
      $scope.type.selected.model.schema.properties[key].filtered = angular.copy(filtered);
      $scope.updateScope();
    };

    $scope.refreshFilterSourceField = function(key, filterSourceField){
      $scope.chargeAceModel();
      $scope.type.selected.model.schema.properties[key].filterSourceField = angular.copy(filterSourceField);
      $scope.updateScope();
    };

    $scope.refreshFilterDestField = function(key, filterDestField){
      $scope.chargeAceModel();
      $scope.type.selected.model.schema.properties[key].filterDestField = angular.copy(filterDestField);
      $scope.updateScope();
    };

    $scope.chargeAceModel = function() {
      var defaultData = angular.fromJson(angular.copy($scope.aceModel));
      if(defaultData) {
        $scope.type = {selected: defaultData};
        $scope.schema = angular.fromJson(defaultData.model.schema);
        $scope.form = angular.fromJson(defaultData.model.form);
        $scope.columnDefs = angular.fromJson(defaultData.model.columnDefs);
        defaultData.model.database = $scope.database;
      }
    };

    $scope.changeColumnDefs = function (key, value) {
      var item = {name: value.title, field: key};
      var map = new Map();
      angular.forEach($scope.type.selected.model.columnDefs, function (v) {
        map[v.field] = angular.copy(v);
      });
      if(value.check){
        map[item.field] = angular.copy(item);
        if(value.width == '' || value.width == null) {
          delete $scope.type.selected.model.schema.properties[key].width;
        }
      }
      else{
        delete map[item.field];
        delete $scope.type.selected.model.schema.properties[key].width;
        $scope.type.selected.model.schema.properties[key].enableFiltering = false;
        $scope.type.selected.model.schema.properties[key].enableSorting = false;
      }
      $scope.type.selected.model.columnDefs=[];
      for(var it in map) {
        var app = {name: map[it].name, field: map[it].field};
        $scope.type.selected.model.columnDefs.push(app);
      }
      $scope.updateScope();
    };

    $scope.setDefault = function(key, value){
      if(value._default == '' || value._default == null ){
        delete $scope.type.selected.model.schema.properties[key]._default;
      } 
      $scope.updateScope();
  }

    $scope.aceLoaded = function(_editor) {
      var defaultModel = {
        model: {
          schema: {type: "object",
            title: "",
            properties: {
              code: {
                title: "Codice",
                type: "string",
                check: true
              },
              description: {
                title: "Descrizione",
                type: "string",
                check: true
              }
            },
            required: [
              "code",
              "description"
            ]},
          form:[
              {
                type: "fieldset",
                items: [
                  {
                    type: "tabs",
                    tabs: [
                      {
                        title: "Dati Base",
                        items: [
                          {
                            key: ["code"],
                            title: "Codice",
                            required: true,
                            type: "text"
                          },
                          {
                            key: ["description"],
                            title: "Descrizione",
                            required: true,
                            type: "text"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
          columnDefs:[
            {
              "field": "code",
              "name": "Codice"
            },
            {
              "field": "description",
              "name": "Descrizione"
            }
          ]
        }
      };
      $scope.aceModel = JSON.stringify(defaultModel, null, '\t');
      $scope.chargeAceModel();
      $scope.title = angular.copy($scope.type.selected.model.form[0].title);
      schemaFactory($scope.database).getCode({id: $routeParams.entity}).$promise.then(function (data) {
        if(Object.keys(data).filter( function(key){return !key.startsWith("$")}).length){
          $scope.type = {
            selected: { 
              model: angular.copy(data) 
            } 
          };
        }
          $scope.customDetailPath = angular.isDefined(data.detailPath);
          $scope.showStdPanel = angular.isDefined(data.showStdPanel) && (data.showStdPanel===true);
          $scope.ignoreAzcod = angular.isDefined(data.ignoreAzcod) && (data.ignoreAzcod===true);
          $scope.ignoreDivcod = angular.isDefined(data.ignoreDivcod) && (data.ignoreDivcod===true);
          $scope.translate = angular.isDefined(data.translate) && (data.translate===true);
          $scope.readOnly = angular.isDefined(data.readOnly) && (data.readOnly===true);          
          $scope.isNewModel = !data.code;
          loadMenuFunction(data);
          $scope.fixSchemaFormModel();
          $scope.schema = angular.copy($scope.type.selected.model.schema);
          $scope.form = angular.copy($scope.type.selected.model.form);
          $scope.code = angular.copy($scope.type.selected.model.code);
          //delete $scope.type.selected.model.schema.properties[key].default;
          $scope.description = angular.copy($scope.type.selected.model.description);
          if($scope.type.selected.model.form){
            $scope.title = angular.copy($scope.type.selected.model.form[0].title);
          }
          if($scope.type.selected.model.columnDefs && ($scope.type.selected.model.columnDefs.length != 0)) {
            $scope.columnDefs = angular.copy($scope.type.selected.model.columnDefs);
          } else {
            $scope.columnDefs= [
              { name:'Codice', field: 'code' },
              { name:'Descrizione', field: 'description' }
            ];
            $scope.type.selected.model.columnDefs = angular.copy($scope.columnDefs);
          }
          angular.forEach($scope.columnDefs, function (value) {
            if($scope.type.selected && $scope.type.selected.model && $scope.type.selected.model.schema && $scope.type.selected.model.schema.properties[value.field]){
              $scope.type.selected.model.schema.properties[value.field].check = true;
            }
          });
          $scope.schema = angular.copy($scope.type.selected.model.schema);
          $scope.aceModel = JSON.stringify($scope.type.selected, null, '\t');
          $scope.model = {};
          $scope.history = angular.copy($scope.type.selected.model.history);
          $scope.attachmentManagement = angular.copy($scope.type.selected.model.attachmentManagement);
          $scope.getUiselectMap();
      });
    };

    $scope.getUiselectMap = function(){
      if($scope.type.selected && $scope.type.selected.model && $scope.type.selected.model.form && $scope.type.selected.model.form[0]){
        $scope.uiselectMap = {};
        $scope.itemTypeMap  = {};
        for(var i in $scope.type.selected.model.form[0].items) {
          if($scope.type.selected.model.form[0].items[i].tabs) {
            $scope.type.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
              if(item.type !== 'fieldset') {
                $scope.itemTypeMap[item.key[0]] = $scope.type.selected.model.schema.properties[item.key[0]].type;
                if ($scope.type.selected.model.schema.properties[item.key[0]].type == 'array') {
                  $scope.itemTypeMap[item.key[0]] = $scope.type.selected.model.schema.properties[item.key[0]].items.type;
                }
  
                if (item.type == 'uiselect' || item.type == 'uiselectmultiple') {
                  var blankObject = {
                    name: '',
                    value: ''
                  };
                  $scope.uiselectMap[item.key[0]] = addSelectedValue(item.titleMap, blankObject);
                  /* aggiunto un elemento vuoto all'array per consentire il deselezionamento */
                }
              }
            });
          }
        }
        console.log($scope.itemTypeMap);
      }
    };

    function addSelectedValue(array, obj) {
      var blankValuePresent = false;
      array.forEach(function (item) {
        if(item.value == obj.value && item.name == obj.name){
          blankValuePresent = true;
        }
      });
      if(blankValuePresent == false){
        array.push(obj);
      }
      return array;
    }

    $scope.isInheritable = function(type){
      return (type == 'number' || type == 'integer' || type == 'string' || type == 'boolean' || type == 'lookup');
    };

    /**********************/
    /***** FIX SCHEMA *****/
    /**********************/

    $scope.fixSchemaFormModel = function() {
      if($scope.type.selected.model.form){
        for(var i in $scope.type.selected.model.form[0].items) {
          if($scope.type.selected.model.form[0].items[i].tabs) {
            $scope.type.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
              if($scope.type.selected.model.schema.properties[item.key[0]]){
                if(item.type == 'uiselect'){
                  $scope.type.selected.model.schema.properties[item.key[0]].format = 'enum';
                }
                if(item.type == 'uiselectmultiple'){
                  $scope.type.selected.model.schema.properties[item.key[0]].type = 'array';
                }
              }
            });
          }
        }
      }
    };

    /****************/
    /***** FORM *****/
    /****************/
    $scope.newFieldForm = {};
    $scope.newTab = {
      title: "",
      items: []
    };

    $scope.addTab = function(container){
      if(!container.tabs) {
        container.tabs = [];
      }
      if(container.type !== 'tabs') {
        container.type = 'tabs';
      }
      var toAdd = angular.copy($scope.newTab);
      $log.log(container);
      container.tabs.push(toAdd);
      $log.log(container);
      $scope.updateScope();
      $scope.newTab = {
        title: "",
        items: []
      };
    };

    $scope.addFieldToTab = function(tab){
      if(!tab.items) {
        tab.items = [];
      }
      var toAdd = angular.copy($scope.newFieldForm);
      if($scope.newFieldForm.type === '' || $scope.newFieldForm.type === 'formula' || $scope.newFieldForm.type === 'inherited') {
        delete toAdd.type;
      }
      /* key è da cambiare in un array */
      toAdd.key = [];
      toAdd.key.push($scope.newFieldForm.key);
      /* se è una lookup, e se ha definito il campo entity_id nello schema, ci attacco anche l'entity_id */
      if(toAdd.type == 'sixlookup' && $scope.schema.properties[$scope.newFieldForm.key]['entity_id']){
        toAdd['entity_id'] = $scope.schema.properties[$scope.newFieldForm.key]['entity_id'];
      }
      tab.items.push(toAdd);
      $scope.updateScope();
      $scope.newFieldForm = {
        key: [],
        title: "",
        required: false,
        type: "text"
      };
    };

    $scope.removeTabOrField = function(key, container){
      container.splice(key, 1);
      $log.log(container);
      $scope.updateScope();
    };

    $scope.swapUp = function(key, collection) {
      if(key > 0) {
        var tmp = collection[key];
        collection[key] = collection[key-1];
        collection[key-1] = tmp;
      }
      $scope.updateScope();
    };

    $scope.swapDown = function(key, collection) {
      if(key < collection.length-1) {
        var tmp = collection[key];
        collection[key] = collection[key+1];
        collection[key+1] = tmp;
      }
      $scope.updateScope();
    };

    $scope.updateField = function(field) {
      if(field.type === '') {
        delete field.type;
      }
      $scope.updateScope();
    };

    // quando spunto la checkbox relativa al campo obbligatorio,
    // oltre ad aggiorname il form (automaticamente tramite ng-model),
    // aggiorno anche l'array 'required' nello schema
    $scope.updateRequiredField = function (field) {
      if(field.required == true){
        $scope.type.selected.model.schema.required.push(field.key[0])
      } else {
        var i = $scope.type.selected.model.schema.required.indexOf(field.key[0]);
        if(i != -1) {
          $scope.type.selected.model.schema.required.splice(i, 1);
        }
      }
      $scope.updateScope();
    };

    $scope.$watch('customDetailPath', function(newValue) {
      if($scope.type.selected && !newValue){
        delete $scope.type.selected['detailPath'];
      }
      $scope.updateScope();
    });

    $scope.$watch('showStdPanel', function(newValue) {
      if($scope.type.selected){
        $scope.type.selected.model.showStdPanel = $scope.showStdPanel;
        $scope.updateScope();
      }
    });

    $scope.$watch('ignoreAzcod', function(newValue) {
      if($scope.type.selected){
        $scope.type.selected.model.ignoreAzcod = $scope.ignoreAzcod;
        $scope.updateScope();
      }
    });

    $scope.$watch('ignoreDivcod', function(newValue) {
      if($scope.type.selected){
        $scope.type.selected.model.ignoreDivcod = $scope.ignoreDivcod;
        $scope.updateScope();
      }
    });

    $scope.$watch('translate', function(newValue) {
      if($scope.type.selected){
        $scope.type.selected.model.translate = $scope.translate;
        $scope.updateScope();
      }
    });

    $scope.setReadOnly = function (){
      $scope.type.selected.model.readOnly = $scope.readOnly;
      $scope.updateScope();
  }

  $scope.refreshDetailPath = function(value){
    $scope.updateScope();
  };

    function getFormItem(form,key){
      var formItem = undefined;
      form.items[0].tabs.forEach(function(tab){
        for(var i=0; i<tab.items.length; i++){
          var item = tab.items[i];
          if(item.key[0] === key){
            formItem = item;
            break;
          }
        }
      });
      return formItem;
    };

    $scope.getTranslation = function(){
      $scope.toBeTranslated = localeFactory.getToBeTranslatedSchema(JSON.parse($scope.aceModel).model);
    };

    $scope.refreshFormat = function(key,format){
      var schemaItem = $scope.type.selected.model.schema.properties[key];
      var formItem = getFormItem($scope.type.selected.model.form[0],key);
      switch(format){
        case 'enum':
          schemaItem.format = 'enum';
          delete schemaItem['mapping'];
          delete formItem['entity_id'];
          formItem.type = 'uiselect';
          formItem.titleMap = [];
          $scope.uiselectMap[key] = formItem.titleMap;
          break;
        case 'lookup':
          schemaItem.format = 'lookup';
          formItem.type = 'sixlookup';
          formItem.entity_id = schemaItem.entity_id;
          delete formItem['titleMap'];
          break;
        default:
          delete schemaItem['format'];
          delete schemaItem['mapping'];
          delete formItem['titleMap'];
          delete formItem['entity_id'];
      }
      
      $scope.type.selected.model.schema.properties[key] = schemaItem;
      $scope.updateScope();
    };

    init();

  });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.theme.baseFactory
 * @description
 * # baseFactory
 * Factory in the ictportal.theme.
 */
angular.module('ictportal.theme')
  .factory('schemaFactory', function ($resource, ABNORMAL_URL, SCRAMBLED_URL) {
    return function(db) {
      var url = ABNORMAL_URL;
      if(db==='eggs'){
        url = SCRAMBLED_URL;
      }
      return $resource(url + '/api/schema/:verb/:id/:param1/:param2', {}, {
        query:  {method: 'GET', isArray: false},
        lookupList: {method: 'GET', isArray: false, params: {verb: '_lookup', res_mode: 'list'}},
        setCode: {method: 'POST',  isArray: false,   params: {verb: '_code'}},
        getCode:   {method: 'GET',   isArray: false,   params: {verb: '_code', id: '@id'}},
        getSchema:   {method: 'GET', isArray: false, params: {verb: '_uuid'}},
        generate:   {method: 'GET', isArray: false, params: {verb: '_generate'}},
        delete: {method: 'DELETE', params: {id: '@id'}},
        search: {method: 'POST', isArray: false, params: {verb: '_search'}},
        list:     {method: 'GET',   isArray: false,   params: {verb: '_list'}}
      });
    };
  });

angular.module('ictportal.theme')
    .config(function ($routeProvider) {
        $routeProvider.when('/password', {
            templateUrl: 'theme/password/password.html',
            controller: 'passwordCtrl'
        })
    })
    .controller('passwordCtrl', function ($scope, $http, $location,
                                        ngDialog, EGGS_AUTH_URL) {
        $scope.username = undefined;
        $scope.oldPsw = undefined;
        $scope.newPsw = undefined;
        $scope.newPsw_2 = undefined; 
        $scope.modal = {};

        function changePassword(body){
            $http.post(EGGS_AUTH_URL+'/cambiopwd', body).then(function(resp){
                if (resp.data && resp.data.codice == "200"){
                    changePasswordSix()
                }else{
                    if(resp.data && resp.data.descrizione){
                        alert(resp.data.descrizione, 'danger'); //mostro gli errori restituiti dal BE
                    }else{
                        alert("Ops! Qualcosa è andato storto durante il salvataggio.", 'danger');
                    }
                    console.error(resp);
                }
            }, function(error){
                alert("Ops! Qualcosa è andato storto durante il salvataggio.", 'danger');
                console.error(error);
            });
        }

        function changePasswordSix() {
            var body = {
                username : $scope.username,
                password_old : $scope.oldPsw,
                password_new : $scope.newPsw,
                password_confirm : $scope.newPsw_2
            };

            console.log('BODY SIX');
            console.log(body);

            $http.post('/six/rest/auth/password/_change', body).then(function(resp){
                if (resp.data.status == "ok"){
                    $scope.oldPsw = undefined;
                    $scope.newPsw = undefined;
                    $scope.newPsw_2 = undefined;
                    $scope.username = undefined;
                    alert("Password modificata con successo.", 'success');
                }else{
                    if(resp.data && resp.data.descrizione){
                        alert(resp.data.descrizione, 'danger'); //mostro gli errori restituiti dal BE
                    }else{
                        alert("Ops! Qualcosa è andato storto durante il salvataggio.", 'danger');
                    }
                    console.error(resp);
                }
            }, function(error){
                alert("Ops! Qualcosa è andato storto durante il salvataggio.", 'danger');
                console.error(error);
            });
        }

        $scope.back = function(){
            $location.path("login");
        }

        $scope.showModal = function () {
            if ($scope.oldPsw && $scope.newPsw && $scope.newPsw_2) {
                if ($scope.newPsw === $scope.newPsw_2) {
                    if ($scope.oldPsw !== $scope.newPsw) {
                        $scope.modal.title = 'Conferma Modifica';
                        $scope.modal.message = 'L\'operazione selezionata modificherà la password attuale, continuare?';
                        var body = {
                            oldPwd: $scope.oldPsw,
                            newPwd: $scope.newPsw,
                            username: $scope.username
                        }
                        confirmDialog(    
                            'Confermi di voler modificare la tua password?',
                            changePassword.bind(null, body),
                            undefined
                        );
                    } else {
                        $scope.newPsw = undefined;
                        $scope.newPsw_2 = undefined;
                        alert('La password inserita coincide con quella esistente', 'warning');
                    }
                } else {
                    $scope.newPsw = undefined;
                    $scope.newPsw_2 = undefined;
                    alert('Le due password non coincidono', 'warning');
                }
            } else {
                alert('Alcuni campi non sono stati compilati', 'warning');
            }
        }
        
        function confirmDialog(message, functionY, functionN){
            var alertDialog= ngDialog.openConfirm({
            name: 'alertDialog',
            closeByDocument: false,
            showClose: true,
            template: ''+
            '<div style="text-align:center">' + message + '</div><br>' +
                '<div style="text-align:center">' +
                '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="closeThisDialog()">Annulla</button>' +
                '<button style="alignment: center; margin: 10px" type="button" class="btn btn-info" ng-click="confirm()">Conferma</button>' +
                '</div>' +
            ''+
            '',
            plain:true,
            className: 'ngdialog-theme-default ngdialog-theme-custom'
            });
    
            alertDialog.then(
            function(resp) {
                console.log(resp);
                if(angular.isFunction(functionY)) {
                functionY();
                }
            },
            function(resp) {
                console.log(resp);
                if(angular.isFunction(functionN)) {
                functionN();
                }
            });
        };

        function alert(message, dialogType){
            var icon = dialogType;
            if (icon == 'danger'){
                icon = 'warning';
            } else if (icon == 'success'){
                icon = 'check';
            }
            var alertDialog= ngDialog.open({
                name: 'loadingDialog',
                closeByDocument: true,
                showClose: true,
                template: ''+
                '<div style="text-align:center"><i class="fa fa-' + icon + '" style="font-size:large"></i>&nbsp; ' + message + '</div><br>' +
                '<div style="text-align:center">' +
                    '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="closeThisDialog()">OK</button>' +
                '</div>' +
                ''+
                '',
                plain:'true',
                className: 'ngdialog-theme-default ngdialog-theme-custom' + (dialogType ? ' ngdialog-theme-' + dialogType : '')
            });
        };
    });


angular.module('ictportal.theme')
    
.config(function ($routeProvider) {
    $routeProvider.when('/profile', {
        templateUrl: 'theme/profile/profile.html',
        controller: 'profileCtrl'
    })
})

.controller('profileCtrl', function ($scope, $log, authFactory, dbFilterFactory, recordFactory, loginFactory, toaster, $rootScope) {

    $scope.username = undefined;
    $scope.oldPsw = undefined;
    $scope.newPsw = undefined;
    $scope.newPsw_2 = undefined; 
    var loginData = undefined;
    var isEggs = undefined;
    $scope.modal = {};

    function init() {
        getUserData();
        capsLockWarn()
    };

    function capsLockWarn(){
        document.addEventListener( 'keydown', function( event ) {
            var caps = event.getModifierState && event.getModifierState('CapsLock');
            if(caps){
                $scope.showWarn = true;
            }else{
                $scope.showWarn = false;
            }
        });
    }

    function getUserData(){
        var authData = authFactory.getAuthData();
        $scope.username = authData.authId;
        isEggs = authData.eggs;
        getLoginData(authData.authId);
    }

    function getLoginData (username){
        var params = {page_size: 1};
        var body = [{"column": "username", "value": username, "relation": "=", "kind": "string"}]
        recordFactory('utenti').filter(params, body).$promise.then(function(data){
            loginData = data.list[0];
        })
    }

    function changePassword(userId, psw){
        var updateField = {password: psw}
        recordFactory('utenti').update({id: userId}, updateField).$promise.then(function(){
           toaster.pop('success', 'Salvataggio Completato', 'Password modificata con successo');
           $scope.oldPsw = undefined;
           $scope.newPsw = undefined;
           $scope.newPsw_2 = undefined;
           getUserData();  
        });
    }

    $scope.showModal = function (){
        if(loginData && isEggs){
            if($scope.oldPsw && $scope.newPsw && $scope.newPsw_2){
                if($scope.oldPsw === loginData.password){
                    if($scope.newPsw === $scope.newPsw_2){
                        if($scope.oldPsw !== $scope.newPsw){
                            $scope.modal.title = 'Conferma Modifica';
                            $scope.modal.message = 'L\'operazione selezionata modificherà la password attuale, continuare?';
                            $scope.modal.callback = changePassword.bind(null, loginData.id, $scope.newPsw);
                            $rootScope.$broadcast('sixConfirmModal_open');
                        }else{
                            $scope.newPsw = undefined;
                            $scope.newPsw_2 = undefined;
                            toaster.pop('error', 'Errore', 'La password inserita coincide con quella esistente');
                        }
                    }else{
                        $scope.newPsw = undefined;
                        $scope.newPsw_2 = undefined;
                        toaster.pop('error', 'Errore', 'La password inserita non coincide');                        
                    }
                }else{
                    toaster.pop('error', 'Errore', 'Password account errata');
                }
            }else{
                toaster.pop('error', 'Errore', 'Campo mancante');                
            }
        }else{
            $log.error('Missing Or Wrong Login Data', loginData)
        }
    }

    init();
});
'use strict';

/**
 * @ngdoc function
 * @name ictportal.theme.controller:RecordEggsCtrl
 * @description
 * # RecordEggsCtrl
 * Controller of the ictportal.theme
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
    $routeProvider
        .when('/record/eggs/detail/:type/:id', {
          templateUrl: 'theme/record/record_detail.html',
          controller: 'RecordEggsCtrl'
        })
  })
  .filter('notStdFilter', function() {
    return function(items) {
        var filtered = [];

        angular.forEach(items, function(item) {
            if(     (item.key[0]!=='utinsid')
                &&  (item.key[0]!=='dtins')
                &&  (item.key[0]!=='utvarid')
                &&  (item.key[0]!=='dtvar')
                &&  (item.key[0]!=='attivo')
                &&  (item.key[0]!=='valido')
                ){
                filtered.push(item);
            }
        });

        return filtered;
    }
  })
  .controller('RecordEggsCtrl', function ($scope, $routeParams, $location, $log, toaster, $q, 
                                      $rootScope, recordFactory, schemaFactory, 
                                      $timeout, authFactory, eggsFormFactory) {                       
    $scope.database = 'eggs';                                    
    $scope.record = {
        model: {},
        lookup: {
            utinsid:{
                mapping: {
                    code: 'username', description: 'nome,cognome'
                }
            },
            utvarid:{
                mapping: {
                    code: 'username', description: 'nome,cognome'
                }
            }
        },
        dates: []
    };
    $scope.schema = {};
    $scope.modal = {
        title: 'Conferma eliminazione',
        message: 'Sei sicuro di voler eliminare l\'elemento corrente?'
    };
    $scope.schemaFound = false;
    $scope.showStdPanel = true;

    function loadLookupData() {
       var promises = {};
       for(var key in $scope.record.lookup){
            var lookup = $scope.record.lookup[key];
            if(angular.isDefined($scope.record.model[key])){
                promises[key] = recordFactory(lookup.entity, $scope.database).byId({ id: $scope.record.model[key]}).$promise;
                var combinedPromise = $q.all(promises);
                combinedPromise.then(function(responses) {
                    for(var key in $scope.record.lookup){
                        $scope.record.lookup[key].obj = responses[key];
                    };
                });
            }
        }
    };

    function clearLookups() {
        for(var key in $scope.record.lookup){
            var lookup = $scope.record.lookup[key];
            lookup.obj = {};
        }
    };

    function readLookups() {
        for(var key in $scope.sf.schema.properties){
            var prop = $scope.sf.schema.properties[key];
            if(prop.format==='lookup'){
                if(!prop.mapping){
                    prop.mapping = {
                                code: 'codice',
                                description: 'descrizione',
                                UUID: 'id'
                            };
                }
                $scope.record.lookup[key] = {
                    mapping: prop.mapping,
                    obj: {},
                    entity: prop.entity_id
                };
            }
        }
    };

    function readDates(){
        $scope.sf.form[0].items[0].tabs.forEach(function(tab){
            tab.items.forEach(function(item){
                if(item.type==='datepicker'){
                    var t1 = $scope.record.dates;
                    var t2 = item.key[0];
                    $scope.record.dates.push(item.key[0]);
                }
            });
        });
    };

    function loadDates(){
        $scope.record.dates.forEach(function(field){
            $scope.list.list.forEach(function(record){
                if(record[field]){
                    record[field] = new Date(record[field]);
                }
            });
        });
    };

    $scope.deleteRecord = function(){    
        $scope.clickDel = true;    
        $scope.modal.callback = $scope.doDeleteRecord;
        $rootScope.$broadcast('sixConfirmModal:open');  
    };

    $scope.doDeleteRecord = function(){
        if($scope.record.model.id && $scope.clickDel){
            $scope.clickDel = false;
            recordFactory($routeParams.type, $scope.database).delete({id: $scope.record.model.id})
                .$promise.then(function(data){
                    toaster.pop('success', 'Elemento eliminato', 'Operazione completata con successo');
                    $scope.goToList();
                });
        }
    };

    function customValidation(){
        var result = true;
        if($routeParams.type==='destinatariemailcontestazioni'){
            // TODO (eventualmentw)
        }
        return result;
    };

    $scope.onSubmit = function(recordDetail){
        var form = recordDetail;
        if(form.$valid && customValidation()){
            var document = {};
            $scope.sf.form[0].items[0].tabs.forEach(function(tab){
                tab.items.forEach(function(item){
                    var field = item.key[0];
                    document[field] = $scope.record.model[field];
                });
            });
            if($scope.record.model.azcod){
                document['azcod'] = $scope.record.model.azcod;
            }
            if($scope.record.model.id){
                fillUtvaridDtvar(document);
                eggsFormFactory.convertDates(document,$scope.dateFields);
                recordFactory($routeParams.type, $scope.database).update({id: $scope.record.model.id},document)
                    .$promise.then(function(data){
                        showSaveResult(data);
                    });
            }
            else{
                fillUtinsidDtins(document);
                fillAzCode(document);
                recordFactory($routeParams.type, $scope.database).create(document)
                    .$promise.then(function(data){
                        showSaveResult(data);
                    });
            }
        }
    };

    $scope.saveRecord = function() {
        $timeout(function() {
            angular.element('#submitForm').trigger('click');
        });
    };

    function showSaveResult(data) {
        if(!data.query && !data.updated){
            toaster.pop('error', 'Errore', 'Salvataggio non riuscito');
        }
        else{
            toaster.pop('success', 'Salvataggio completato', 'Operazione completata con successo');
            $scope.goToList();
        }
    };

    function fillAzCode(document){
      if($scope.sf.schema.properties['azcod']){
        document.azcod = authFactory.getAuthData().info.azCod;  
      }
    };

    function fillUtvaridDtvar(document){
      if($scope.sf.schema.properties['utvarid']){
          if($scope.loginUser){
            document.utvarid = $scope.loginUser.id;
          }
      }
      if($scope.sf.schema.properties['dtvar']){
          if($scope.loginUser){
            document.dtvar = new Date();
          }
      }
    };

    function fillUtinsidDtins(document){
      if($scope.sf.schema.properties['utinsid']){
          if($scope.loginUser){
            document.utinsid = $scope.loginUser.id;
          }
      }
      if($scope.sf.schema.properties['dtins']){
          if($scope.loginUser){
            document.dtins = new Date();
          }
      }
    };

    $scope.goToList = function(){
        $location.path('record/eggs/list/' + $routeParams.type);
    };

    function getSchema(){
        $scope.stdItems = {};
        $scope.dateFields = [];
        schemaFactory($scope.database).getCode({id: $routeParams.type}).$promise.then(
            function(data) {
                $scope.sf = data;
                $scope.showStdPanel = $scope.sf.showStdPanel;
                $scope.sf.form[0].items[0].tabs[0].items.forEach(function(item){
                    if(item.type==='sixlookup' && ! item.entity_id){
                        item.entity_id = $scope.sf.schema.properties[item.key[0]].entity_id;
                        if($scope.sf.showStdPanel && item.key[0]==='utinsid'){
                            $scope.stdItems.utinsid = item;
                        }
                        else if( $scope.sf.showStdPanel && item.key[0]==='utvarid'){
                            $scope.stdItems.utvarid = item;
                        }
                    }
                    if(item.type==='datepicker'){
                        $scope.dateFields.push(item.key[0]);
                        if($scope.sf.showStdPanel && item.key[0]==='dtvar'){
                            $scope.stdItems.dtvar = item;
                        }
                        else if( $scope.sf.showStdPanel && item.key[0]==='dtins'){
                            $scope.stdItems.dtins = item;
                        }
                    }
                });
                if($scope.sf.schema.attivo){
                    $scope.label = {active: 'Attivo'};
                }
                $scope.title = data.description;
                readLookups();
                readDates();
                getRecord();
            }
        );
    };

    function getUtenteLogin(){
        var user = authFactory.getAuthData();
        var payloadUtente = {
            code: 'username',
            description: 'username',
            query: user.authId
        };
        recordFactory('utenti', $scope.database).query(payloadUtente)
            .$promise.then(function (data){
                if(data.totalResults>0){
                    $scope.loginUser = data.list[0];
                }
                else{
                    toaster.pop('warning','Attenzione','Utente di login non trovato');
                }
            });
    };

    $scope.$watch('record.model.attivo', function(newVal,oldVal){
        if(newVal==='N'){
            $scope.record.model.valido = new Date();
        }
        else {
            delete $scope.record.model['valido'];
        }
    });

    function getRecord(){
        if($routeParams.id==='new'){
            loadLookupData();
            if($scope.sf.schema.properties['attivo']){
                $scope.record.model.attivo = 'S';    
            }
        }
        else{
            if(!$scope.schemaFound) {
                $scope.schema.properties = {};
                $scope.form = [];
                recordFactory($routeParams.type, $scope.database).byId({id: $routeParams.id}).$promise.then(function(entity){
                    $log.info(entity);
                    var keys = Object.keys(entity)
                                .filter(function(key) {return (key !== '$$hashKey' && key !== '$promise' && key !== '$resolved' && key !== 'model' && key !== 'UUID' && key !== 'azcod')})
                                .filter(function(key) {return key.slice(-2) !== 'id'}).sort();
                    for(var k in keys) {
                        $scope.schema.properties[keys[k]] = {
                            title: keys[k].toUpperCase(),
                            type: 'string'
                        };
                        $scope.form.push({
                            key: keys[k],
                            htmlClass: 'col-lg-4'
                        });
                    };
                    for(var key in entity){
                        $scope.record.model[key] = entity[key];
                    }
                    loadLookupData();
                     $scope.dateFields.forEach(function(field){
                        if($scope.record.model[field]){
                            $scope.record.model[field] = new Date($scope.record.model[field]);
                        }
                    });
                    $rootScope.$broadcast('sixCheckbox:reload'); 
                });
            };
        }
    };

    function init(){
        getUtenteLogin();
        getSchema();
    };

    //___ main ___
    init();
    
  });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.theme.controller:RecordListCtrl
 * @description
 * # RecordCtrl
 * Controller of the ictportal.theme
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
    $routeProvider
        .when('/record/list/:type', {
            templateUrl: 'theme/record/record_list.html',
            controller: 'RecordListCtrl',
            resolve: {
                database: function ($route) { $route.current.params.database = 'six'; }
            }
        })
        // es: type="human_resources" discriminator="employee"
        .when('/record/list/:type/:discriminator', {
            templateUrl: 'theme/record/record_list.html',
            controller: 'RecordListCtrl',
            resolve: {
                database: function ($route) { $route.current.params.database = 'six'; }
            }
        })
        .when('/record/eggs/list/:type', {
            templateUrl: 'theme/record/record_list.html',
            controller: 'RecordListCtrl',
            resolve: {
                database: function ($route) { $route.current.params.database = 'eggs'; }
            }
        })
  })
  .filter('mapBoolean', function() {
    var genderHash = {
        1: 'Sì',
        2: 'No'
    };
    
    return function(input) {
        if (!input){
            return '';
        } else {
            return genderHash[input];
        }
    };
  })
  .controller('RecordListCtrl', function ($scope, $routeParams, $location, toaster, authFactory, 
                                          recordFactory, schemaFactory, localeFactory, parseSchemaService) {                                                                  
    $scope.typeName = $routeParams.type;
    $scope.pageTitle = $routeParams.type;
    $scope.discriminator = $routeParams.discriminator;
    $scope.result = {};
    $scope.lookupCols = [];
    $scope.record = {
        lookup: {},
        dates: []
    };
    $scope.params = {
      pageNumber: 1,
      pageSize: 15,
      code: $routeParams.type,
      filters: []
    };
    $scope.viewGridOptions = { appScopeProvider: $scope };
    var ignore = {
        azcod: false,
        divcod: false
    };

    function initGridColumns() {
        schemaFactory($scope.database).getCode({id: $routeParams.type}).$promise.then(
            function(sf) {
                if(Object.keys(sf).filter( function(key){return !key.startsWith("$")}).length){
                    if(sf.description) $scope.pageTitle = sf.description;
                    localeFactory.translateSchema(sf).then(function(data){
                        if(data.schema){ 
                            $scope.sf = data;     
                            if($scope.sf.ignoreAzcod) ignore.azcod = true;               
                            if($scope.sf.ignoreDivcod) ignore.divcod = true;
                            if ($scope.sf.schema && $scope.sf.form) {
                                parseSchemaService.readLookups($scope.sf, $scope.record);
                                parseSchemaService.readDates($scope.sf, $scope.record);
                            }
                            if ($scope.sf.columnDefs) {
                                parseSchemaService.getColumnDefinitions($scope.sf, $scope.viewGridOptions, $scope.record, $scope.lookupCols);
                            };
                            if ($scope.sf.code) $scope.typeName = $scope.sf.code;
                        }
                    });
                }
            }
        );
    };
 
    // Per particolari entità (ad esempio human_resource)
    function getDiscriminatorFilters() {
        var filters = [];
        if($scope.sf && $scope.sf.filters){
            if($scope.sf.filters[$scope.discriminator]){
                filters = $scope.sf.filters[$scope.discriminator];
            }
            else if($scope.sf.filters.all){
                filters = $scope.sf.filters.all;
            }
        }
        return filters;
    };

    $scope.getData = function () {
        var payload = {
          page: $scope.params.pageNumber,
          page_size: $scope.params.pageSize,
          code: $scope.params.code,
          description: $scope.params.description,
          show_revision: false,
          sort_fields: $scope.params.sortFields,
          sort_order: $scope.params.sortOrder
        };
        var filters = $scope.params.filters.concat(getDiscriminatorFilters());
        if(!$scope.sf.schema.properties.azcod){
            ignore.azcod = true;
        }
        if(!$scope.sf.schema.properties.divcod){
            ignore.divcod = true;
        }
        filters = filters.concat(authFactory.getAuthFilters($scope.typeName, ignore.azcod, ignore.divcod ));
        recordFactory($scope.typeName, $scope.database).filter(payload, filters)
            .$promise.then(function(data) {
                $scope.viewGridOptions.totalItems = data.totalResults;
                $scope.result.totalResults = data.totalResults;
                $scope.result.list = data.list;
                if ($scope.lookupCols.length > 0) {
                    parseSchemaService.loadLookupCols($scope.lookupCols, data);
                }
                if($scope.record.dates.length>0){
                    parseSchemaService.loadDates($scope.record, $scope.result);
                }
        });
    };

    $scope.viewDetail = function(value) {
        if($scope.sf.detailPath){
            $location.path($scope.sf.detailPath + '/' + value.id);
        }
        else{
            if($scope.database==='eggs'){
                $location.path('record/eggs/detail/' + $scope.typeName+ '/' + value.id);
            }
            else {
                $location.path('record/detail/' + $scope.typeName+ '/' + value.id);
            }
        }
    };

    $scope.newRecord = function(){
        if($scope.sf.detailPath){
            $location.path($scope.sf.detailPath + '/new');
        }
        else {
            if($scope.database==='eggs'){
                $location.path('record/eggs/detail/' + $scope.typeName + '/new');
            }
            else{
                $location.path('record/detail/' + $scope.typeName + '/new');
            }
        }
    };

    function init(){
        $scope.database = $routeParams.database;
        var fileName = 'schemaform' + $scope.database;
        localeFactory.loadTranslation(fileName);
        initGridColumns()
    };

    //___ main ___
    init();

  });
'use strict';

/**
 * @ngdoc function
 * @name ictportal.theme.controller:RecordCtrl
 * @description
 * # RecordCtrl
 * Controller of the ictportal.theme
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
    $routeProvider
        .when('/record/detail/:type/:id', {
          templateUrl: 'theme/record/record_detail.html',
          controller: 'RecordSixCtrl'
        })
  })
  // Questo filtro serve per non far vedere nella tab i seguenti campi, in modo da poterli eventualmente isolare in un pannello a parte.
  .filter('notStdFilter', function() {
    return function(items) {
        var filtered = [];

        angular.forEach(items, function(item) {
            if(     (item.key[0]!=='created_user_id')
                &&  (item.key[0]!=='created_date')
                &&  (item.key[0]!=='last_modified_user_id')
                &&  (item.key[0]!=='last_modified_date')
                &&  (item.key[0]!=='divcod')
                &&  (item.key[0]!=='version')
                ){
                filtered.push(item);
            }
        });

        return filtered;
    }
  })
  .controller('RecordSixCtrl', function ($scope, $routeParams, $location, $log, toaster, $q, 
                                      $rootScope, recordFactory, schemaFactory, localeFactory,
                                      $timeout, authFactory, eggsFormFactory) {                       

    $scope.DATABASE = 'six';                                    
    $scope.record = {
        model: {},
        lookup: {
            created_user_id:{
                mapping: {
                    code: 'username', description: 'nome,cognome'
                }
            },
            last_modified_use_id:{
                mapping: {
                    code: 'username', description: 'nome,cognome'
                }
            }
        },
        dates: []
    };
    $scope.hideTabs = false;
    $scope.schema = {};
    $scope.modal = {
        title: 'Conferma eliminazione',
        message: 'Sei sicuro di voler eliminare l\'elemento corrente?'
    };
    $scope.schemaFound = false;
    $scope.showStdPanel = true;
    var userData = null;

    function loadLookupData() {
       var promises = {};
       for(var key in $scope.record.lookup){
            var lookup = $scope.record.lookup[key];
            if(angular.isDefined($scope.record.model[key])){
                promises[key] = recordFactory(lookup.entity).byId({ id: $scope.record.model[key]}).$promise;
                var combinedPromise = $q.all(promises);
                combinedPromise.then(function(responses) {
                    for(var key in $scope.record.lookup){
                        $scope.record.lookup[key].obj = responses[key];
                    };
                });
            }
        }
    };

    function clearLookups() {
        for(var key in $scope.record.lookup){
            var lookup = $scope.record.lookup[key];
            lookup.obj = {};
        }
    };

    function readLookups() {
        for(var key in $scope.sf.schema.properties){
            var prop = $scope.sf.schema.properties[key];
            if(prop.format==='lookup'){
                if(!prop.mapping){
                    prop.mapping = {
                                code: 'code',
                                description: 'description',
                                UUID: 'id'
                            };
                }
                $scope.record.lookup[key] = {
                    mapping: prop.mapping,
                    obj: {},
                    entity: prop.entity_id
                };
            }
        }
    };

    function readDates(){
        $scope.sf.form[0].items[0].tabs.forEach(function(tab){
            tab.items.forEach(function(item){
                if(item.type==='datepicker'){
                    var t1 = $scope.record.dates;
                    var t2 = item.key[0];
                    $scope.record.dates.push(item.key[0]);
                }
            });
        });
    };

    function loadDates(){
        $scope.record.dates.forEach(function(field){
            $scope.list.list.forEach(function(record){
                if(record[field]){
                    record[field] = new Date(record[field]);
                }
            });
        });
    };

    $scope.deleteRecord = function(){   
        if(!$scope.readOnly){
            $scope.clickDel = true;    
            $scope.modal.callback = $scope.doDeleteRecord();
            $rootScope.$broadcast('sixConfirmModal:open');  
        } 
    };

    $scope.doDeleteRecord = function(){
        if($scope.record.model.id && $scope.clickDel){
            $scope.clickDel = false;
            recordFactory($routeParams.type).delete({id: $scope.record.model.id})
                .$promise.then(function(data){
                    toaster.pop('success', 'Elemento eliminato', 'Operazione completata con successo');
                    $scope.goToList();
                });
        }
    };

    function customValidation(){
        var result = true;
        if($routeParams.type==='destinatariemailcontestazioni'){
            // TODO (eventualmente)
        }
        return result;
    };

    $scope.onSubmit = function(recordDetail){
        var form = recordDetail;
        if(form.$valid && customValidation() && !$scope.readOnly){
            var document = {};
            $scope.sf.form[0].items[0].tabs.forEach(function(tab){
                tab.items.forEach(function(item){
                    var field = item.key[0];
                    document[field] = $scope.record.model[field];
                });
            });
            if($scope.record.model.azcod){
                document['azcod'] = $scope.record.model.azcod;
            }
            if($scope.record.model.id){
                fillEditingUsers(document);
                eggsFormFactory.convertDates(document,$scope.dateFields);
                recordFactory($routeParams.type).update({id: $scope.record.model.id},document)
                    .$promise.then(function(data){
                        showSaveResult(data);
                    });
            }
            else{
                fillEditingDates(document);
                fillAzCode(document);
                fillDivCode(document);
                recordFactory($routeParams.type).create(document)
                    .$promise.then(function(data){
                        showSaveResult(data);
                    });
            }
        }
    };

    $scope.saveRecord = function() {
        if(!$scope.readOnly){
            $timeout(function() {
                angular.element('#submitForm').trigger('click');
            });
        }else{
            toaster.error('Salvataggio disabilitato', 'Errore')
        }
    };

    function showSaveResult(data) {
        if(!(data.query || data.updated) ){
            toaster.pop('error', 'Errore', 'Salvataggio non riuscito');
        }
        else{
            toaster.pop('success', 'Salvataggio completato', 'Operazione completata con successo');
            $scope.goToList();
        }
    };

    function fillAzCode(document){
      if($scope.sf.schema.properties['azcod']){
        document.azcod = authFactory.getAuthData().info.azCod;  
      }
    };

    function fillDivCode(document){
        if($scope.sf.schema.properties['divcod']){
          document.divcod = authFactory.getAuthData().info.divCod;  
        }
    };

    function fillEditingUsers(document){
      if($scope.sf.schema.properties['last_modified_user_id']){
        document.last_modified_user_id = userData.id;
      }
      if($scope.sf.schema.properties['last_modified_date']){
        document.last_modified_date = new Date();
      }
    };

    function fillEditingDates(document){
        var tmo = authFactory.getAuthData();
      if($scope.sf.schema.properties['created_user_id']){
        document.created_user_id = userData.id;
      }
      if($scope.sf.schema.properties['created_date']){
        document.created_date = new Date();
      }
    };

    $scope.goToList = function(){
        $location.path('record/list/' + $routeParams.type);
    };

    function getSchema(){
        $scope.stdItems = {};
        $scope.dateFields = [];
        schemaFactory().getCode({id: $routeParams.type}).$promise.then(
            function(schema) {
                if(Object.keys(schema).filter( function(key){return !key.startsWith("$")}).length){
                    $scope.readOnly = (schema.readOnly && $routeParams.id != 'new');
                    $scope.pageTitle = schema.description ? schema.description : schema.code;
                    if(schema.translate){
                        localeFactory.translateSchema(schema).then(function(data){
                            feedSchema(data);
                            readLookups();
                            readDates();
                            getRecord();
                        });
                    }else{
                        feedSchema(schema);
                        readLookups();
                        readDates();
                        getRecord();
                    }
                }
            }
        );
    };

    function fillDefault() {
        for (var prop in $scope.sf.schema.properties) {
            var field = $scope.sf.schema.properties[prop];
            if (field._default) {
                if (field.type == 'boolean') {
                    if(field._default !== "true" && field._default !== 'false') {
                        $scope.record.model[prop] = false;
                    } else {
                        $scope.record.model[prop] = JSON.parse(field._default);
                    }
                } else if( field.format == 'date'){
                    $scope.record.model[prop] = new Date(field._default)
                }else {
                    $scope.record.model[prop] = field._default;
                }
            }
        }
    }

    function feedSchema(data){
        $scope.sf = data;
        $scope.hideTabs = $scope.sf.form[0].items[0].tabs.length==1; // Se ho solo un tab, non lo faccio nemmeno vedere
        $scope.showStdPanel = $scope.sf.showStdPanel;
        $scope.sf.form[0].items[0].tabs[0].items.forEach(function(item){
            if(item.type==='sixlookup' && ! item.entity_id){
                item.entity_id = $scope.sf.schema.properties[item.key[0]].entity_id;
                if($scope.sf.showStdPanel && item.key[0]==='created_user_id'){
                    $scope.stdItems.created_user_id = item;
                }
                else if( $scope.sf.showStdPanel && item.key[0]==='last_modified_user_id'){
                    $scope.stdItems.last_modified_user_id = item;
                }
            }
            if(item.type==='datepicker'){
                $scope.dateFields.push(item.key[0]);
                if($scope.sf.showStdPanel && item.key[0]==='last_modified_date'){
                    $scope.stdItems.last_modified_date = item;
                }
                else if( $scope.sf.showStdPanel && item.key[0]==='created_date'){
                    $scope.stdItems.created_date = item;
                }
            }
        });
        if($scope.sf.schema.attivo){
            $scope.label = {active: 'Attivo'};
        }
    }

    $scope.$watch('record.model.attivo', function(newVal,oldVal){
        if(newVal==='N'){
            $scope.record.model.valido = new Date();
        }
        else {
            delete $scope.record.model['valido'];
        }
    });

    function getRecord(){
        if($routeParams.id==='new'){
            loadLookupData();
            if($scope.sf.schema.properties['attivo']){
                $scope.record.model.attivo = 'S';    
            }
        }
        else{
            if(!$scope.schemaFound) {
                $scope.schema.properties = {};
                $scope.form = [];
                recordFactory($routeParams.type).byId({id: $routeParams.id}).$promise.then(function(entity){
                    $log.info(entity);
                    var keys = Object.keys(entity)
                                .filter(function(key) {return (key !== '$$hashKey' && key !== '$promise' && key !== '$resolved' && key !== 'model' && key !== 'UUID' && key !== 'azcod')})
                                .filter(function(key) {return key.slice(-2) !== 'id'}).sort();
                    for(var k in keys) {
                        if (!isNaN(k)) {
                            $scope.schema.properties[keys[k]] = {
                                title: keys[k].toUpperCase(),
                                type: 'string'
                            };
                            $scope.form.push({
                                key: keys[k],
                                htmlClass: 'col-lg-4'
                            });
                        }
                    };
                    for(var key in entity){
                        $scope.record.model[key] = entity[key];
                    }
                    loadLookupData();
                    $scope.dateFields.forEach(function(field){
                        if($scope.record.model[field]){
                            $scope.record.model[field] = new Date($scope.record.model[field]);
                        }
                    });
                    $rootScope.$broadcast('sixCheckbox:reload'); 
                    fillDefault(); 
                });
            };
        }
    };

    function getLoginUser (){
        var deferred = $q.defer();
        var result = undefined;
        var authData = authFactory.getAuthData();
        if(authData){
          var payload = {
              code: 'username',
              description: 'username',
              query: authData.authId
          };
          recordFactory('users').query(payload)
            .$promise.then(function (data){
                if(data.totalResults>0){
                  result = data.list[0];
                  deferred.resolve(result);
                }
                else{
                    toaster.pop('warning','Attenzione','Utente di login non trovato');
                }
            });
        }
        return deferred.promise;
      };

    function init(){
        localeFactory.loadTranslation('schemaformsix');
        getSchema();
        getLoginUser().then(function(data){
            userData = data;
        }) 
    };

    //___ main ___
    init();
    
  });
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:ReportCtrl
 * @description
 * # ReportCtrl
 * Controller of the emma.theme
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/report', {
        templateUrl: 'theme/report/report_analysis.html',
        controller: 'ReportCtrl',
        controllerAs: 'report'
      })
  })
  .controller('ReportCtrl', function ($log, $scope, $route, $http, authFactory, baseFactory, budgetFactory, energyCarrierFactory, errorService, dialogService, SaveAs, APP_URL, ENERGY_URL, $sce, toaster) {

    $scope.contatoreTypeFilter = { 'model.code' : 'contatoreacqua,contatoreelettricita,contatoregas,contatoregpl,serbatoioinpressione,serbatoiopressioneatmosferica,contatoreteleriscaldamento,contatoreteleraffreddamento'};
    $scope.vector = {};
    $scope.type = {};
    $scope.compare = {
      what1 : undefined,
      what2 : undefined
    };

    $scope.period = {
      dateFrom: new Date(new Date().getFullYear(), 0, 1),
      dateTo: new Date(new Date().getFullYear(), 11, 31)
    };

    $scope.compareType = [
      {
        code: 'budget',
        description: 'Budget'
      },
      {
        code: 'consumptive',
        description: 'Consuntivo'
      },
      {
        code: 'season',
        description: 'Stagionale'
      }
    ];

    $scope.budget = {
      searchCode: []
    };

    $scope.ids = {
      searchCode: []
    };

    $scope.commission = {
      searchCode: []
    };

    $scope.availableBudgetCodes = [];
    $scope.availableCommissionCodes = [];
    $scope.availableIdCodes = [];

    function createDateFrom() {
      return $scope.period.dateFrom.getFullYear() + '-' + ('0' + ($scope.period.dateFrom.getMonth() + 1)).slice(-2) + '-' + ('0' + $scope.period.dateFrom.getDate()).slice(-2);
    }

    function createDateTo() {
      return $scope.period.dateTo.getFullYear() + '-' + ('0' + ($scope.period.dateTo.getMonth() + 1)).slice(-2) + '-' + ('0' + $scope.period.dateTo.getDate()).slice(-2);
    }

    function checkDates(){
     if( $scope.period.dateFrom == null || $scope.period.dateTo == null){
       return false;
     }else{
       if($scope.period.dateFrom > $scope.period.dateTo){
         return false;
       }
     }
     return true;
    }

    $scope.getAvailableCommissionCodes = function () {
      var resp = [];
      authFactory.getAuthData().info.commissions.list.forEach(function(item) {
        if(isAlreadySelectedCommission(item.code) === false) {
          resp.push(item);
        }
      });
      return resp;
    };

    function isAlreadySelectedCommission(code) {
      if($scope.commission.searchCode) {
        for(var i in $scope.commission.searchCode) {
          if($scope.commission.searchCode[i] && $scope.commission.searchCode[i].code === code) {
            return true;
          }
        }
      }
      return false;
    }

    $scope.getAvailableBudgetCodes = function () {
      if(checkDates()){
        var query = {
          from: createDateFrom(),
          to: createDateTo()
        };
        if($scope.commission.searchCode.length != 0) {
          $scope.commission.searchCode.forEach(function(item) {
            if(angular.isUndefined(query.commission)){
              query.commission = item.code;
            } else{
              query.commission = query.commission + ',' + item.code;
            }
          });
        }
        return budgetFactory.budgetCodesFromCommissions(query).$promise.then(function (response) {
          var resp = [];
          if (response.hasOwnProperty('list') && response.list.length) {
            response.list.forEach(function(item) {
              if(isAlreadySelectedBudget(item.UUID) === false) {
                resp.push(item);
              }
            });
          }
          return resp;
        });
      }
    };

    function isAlreadySelectedBudget(uuid) {
      if($scope.budget.searchCode) {
        for(var i in $scope.budget.searchCode) {
          if($scope.budget.searchCode[i] && $scope.budget.searchCode[i].UUID === uuid) {
            return true;
          }
        }
      }
      return false;
    }

    function updateContatoreTypeFilter() {
      if($scope.vector.id) {
          energyCarrierFactory.schemas({id: $scope.vector.id.UUID}).$promise.then(function (response) {
          if (errorService.handleError(response)) {
            $scope.contatoreTypeFilter = { 'model.code' : response.list.join() };
          } else {
            toaster.pop('error', 'Errore', 'Errore durante il recupero dei modelli');
          }
        });
      }
    }

    $scope.getAvailableIdCodes = function () {
      var query = {
        from: createDateFrom(),
        to: createDateTo()
      };
      if(angular.isDefined($scope.type.id)) {
        query.type = $scope.type.id.UUID;
      }
      if($scope.commission.searchCode.length != 0) {
        $scope.commission.searchCode.forEach(function(item) {
          if(angular.isUndefined(query.commission)){
            query.commission = item.code;
          } else{
            query.commission = query.commission + ',' + item.code;
          }
        });
      }
      if($scope.budget.searchCode.length != 0){
        $scope.budget.searchCode.forEach(function (item){
          if(angular.isUndefined(query.budget)){
            query.budget = item.UUID;
          } else{
            query.budget = query.budget + "," + item.UUID;
          }
        });
      }
      return budgetFactory.recordIdsFromBudgets(query).$promise.then(function (response) {
        var resp = [];
        if (response.hasOwnProperty('records') && response.records.length) {
          response.records.forEach(function(item) {
            if(isAlreadySelectedId(item.uuid) === false) {
              resp.push(item);
            }
          });
        }
        return resp;
      });
    };


    function isAlreadySelectedId(uuid) {
      if($scope.ids.searchCode) {
        for(var i in $scope.ids.searchCode) {
          if($scope.ids.searchCode[i] && $scope.ids.searchCode[i].uuid === uuid) {
            return true;
          }
        }
      }
      return false;
    }


    $scope.$watchGroup(['commission.searchCode','period.dateFrom','period.dateTo'],
      function(newValue, oldValue) {
        if (newValue != oldValue){
          $scope.getAvailableBudgetCodes().then(function (list) {
            $scope.availableBudgetCodes = list;
          });
        }
      }
    );

    $scope.$watchGroup(['budget.searchCode','type.id'],
      function(newValue, oldValue) {
        if (newValue != oldValue){
          $scope.getAvailableIdCodes().then(function (list) {
            $scope.availableIdCodes = list;
          });
        }
      }
    );

    $scope.$watch('vector.id', function(newVal) {
      if(newVal) {
        updateContatoreTypeFilter();
      }
    });

    
    var REPORT_BASE_DIR = "reports/EMMA/";
    var REPORT_API_BASE = "http://172.29.151.99:8080" + ENERGY_URL + "/api/report/";
    //var REPORT_API_BASE = "http://docker0.ict-group.it:7878/six/rest/report/";
    var REPORT_QUERY_BASE = "&net.sf.jasperreports.json.source=" + REPORT_API_BASE;
    
    
    $scope.generateReport = function (reportPath, query, reportName) {
      console.log("generation report " + query);
      dialogService.loading('Generazione report in corso');
      $http.post(APP_URL + '/rest/report/generate',
        {
          path: reportPath,
          query: query
        },
        {
          responseType: 'arraybuffer'
        }).success(function (data, status, headers, config) {
        dialogService.stopLoading();
        var options = {type: 'application/pdf'};
        SaveAs.download(data, reportName + '.pdf', options);
      }).error(function (data, status, headers, config) {
        dialogService.stopLoading();
        toaster.pop('error', "Errore", 'Errore generazione report');
        // called asynchronously if an error occurs
        // or server returns response with an error status.
      });
    };

    $scope.availableCommissionCodes = $scope.getAvailableCommissionCodes();

    $scope.reloadPage = function(){
      $route.reload();
    };

    $scope.clearVariable = function(){
      $scope.contatoreTypeFilter = { 'model.code' : 'contatoreacqua,contatoreelettricita,contatoregas,contatoregpl,serbatoioinpressione,serbatoiopressioneatmosferica,contatoreteleriscaldamento,contatoreteleraffreddamento'};
      $scope.budget.searchCode = [];
      $scope.ids.searchCode = [];
      $scope.vector = {};
      $scope.type = {};
      $scope.compare = {
        what1 : undefined,
        what2 : undefined
      };
    };

    $scope.generateBudgetReport = function (reportFile, energyVector, recordTypes, records, endPoint) {
      if(checkDates()){
        var from = createDateFrom();
        var to = createDateTo();
        var reportName;
        var what1 = {
          code: null,
          description: null
        };
        var what2 = {
          code: null,
          description: null
        };
        var vector = {
          UUID: null,
          code: null,
          description: null,
          type: null
        };
        var types = {
          UUID: null,
          code: null,
          description: null,
          type: null
        };
        var commissions = 'null';
        var budgets = 'null';
        var budgetsCode = 'null';
        var ids = 'null';
        var idsCode = 'null';
        if($scope.commission.searchCode.length != 0){
          $scope.commission.searchCode.forEach(function (item){
            if(commissions != 'null'){
              commissions = commissions + "," + item.code;
            } else{
              commissions = item.code;
            }
          });
        }
        if($scope.budget.searchCode.length != 0){
          $scope.budget.searchCode.forEach(function (item){
            if(budgets != 'null'){
              budgets = budgets + "," + item.UUID;
              budgetsCode = budgetsCode + "," + item.code;
            } else{
              budgets = item.UUID;
              budgetsCode = item.code;
            }
          });
        }
        if(angular.isDefined($scope.compare.what1)){
          what1 = $scope.compare.what1;
        }
        if(angular.isDefined($scope.compare.what2)){
          what2 = $scope.compare.what2;
        }
        if(angular.isDefined(energyVector.id)){
          vector = energyVector.id;
        }
        if(angular.isDefined(recordTypes.id)){
          types = recordTypes.id;
        }
        if(records.length != 0){
          records.forEach(function (item){
            if(ids != 'null'){
              ids = ids + "," + item.uuid;
              idsCode = idsCode + "," + item.code;
            } else{
              ids = item.uuid;
              idsCode = item.code;
            }
          });
        }
        var query = REPORT_QUERY_BASE;
        var filters = from + "::" + to + "::" + what1.description + "::" + what2.description + "::" + commissions + "::" + budgetsCode + "::"+ vector.description + "::" + types.description + "::" + idsCode;

        if(endPoint == 'generic'){
          query = query + endPoint + "/"+ from + "/" + to + "/" + what1.code + "/" + what2.code + "/" + commissions + "/" + budgets + "/" + vector.UUID + "/" + types.UUID + "/" + ids + "/" + filters;
          reportName = 'Report_analisi';
        }else if(endPoint == 'cusum'){
          query = query + endPoint + "/"+ from + "/" + to  + "/" + commissions + "/" + budgets + "/" + vector.UUID + "/" + types.UUID + "/" + ids + "/" + filters;
          reportName = 'Report_cusum';
        }
        $scope.generateReport(REPORT_BASE_DIR + reportFile, query, reportName);
      }else{
        toaster.pop('error', 'Errore', 'Errore nell\'inserimento delle date');
      }
    };

    $scope.generateBudgetReportGraphLines = function () {
      $scope.generateBudgetReport("Analisi_generale_lines.pdf", {}, {}, [], "generic");
    };

    $scope.generateBudgetReportGraphBars = function () {
      $scope.generateBudgetReport("Analisi_generale_bars.pdf", {}, {}, [], "generic");
    };

    $scope.generateBudgetCounterReportGraphLines = function () {
      $scope.generateBudgetReport("Analisi_generale_lines.pdf", $scope.vector, $scope.type, $scope.ids.searchCode, "generic");
    };

    $scope.generateBudgetCounterReportGraphBars = function () {
      $scope.generateBudgetReport("Analisi_generale_bars.pdf", $scope.vector, $scope.type, $scope.ids.searchCode, "generic");
    };

    $scope.generateCusum = function () {
      $scope.generateBudgetReport("Cusum.pdf", $scope.vector, $scope.type, $scope.ids.searchCode, "cusum");
    };

    /***** Data ready events *****/

    var DATA_READY_EVENT = 'dataReady';

    $scope.$on(DATA_READY_EVENT, function (event) {
      setTimeout(function () { // evita che venga richiamato troppo velocemente (altrimenti si accavalla a showLoadingMessage)
        dialogService.hideLoadingMessage();
      }, 200);
    });


    // URL per iframe

    //$scope.JASPER_URL = 'http://172.29.2.15:7979/jasperserver';
    //$scope.reportUnit = '/reports/EMMA/Analisi_generale_bars';
    //$scope.parentFolderUri = '/reports/EMMA';
    //$scope.j_username = 'jasperadmin';
    //$scope.j_password = 'jasperadmin';
    //$scope.jasperParams = '_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&theme=embed';
    //$scope.reportUrl = function () {
    //  return $sce.trustAsResourceUrl($scope.JASPER_URL + '/flow.html?' + $scope.jasperParams
    //    + '&j_username=' + $scope.j_username + '&j_password=' + $scope.j_password
    //    + '&ParentFolderUri=' + $scope.parentFolderUri + '&reportUnit=' + $scope.reportUnit);
    //};


    var reportUrlVar = '';
    $scope.reportUrl = function () {
      return $sce.trustAsResourceUrl(reportUrlVar);
    };

    $scope.generateReportUrl = function () {
      dialogService.loading('Generazione report in corso');

      var query = {};
      query.parent_folder_uri = '/reports/EMMA';
      query.report_unit = '/reports/EMMA/Analisi_generale_bars';
      query.query = 'net.sf.jasperreports.json.source=' + REPORT_API_BASE;

      baseFactory('report/generate/url').search(query).$promise.then(function (response) {
        if (errorService.handleError(response)) {
          reportUrlVar = response.url;
        }
        dialogService.stopLoading();
      });
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:ReportCtrl
 * @description
 * # ReportCtrl
 * Controller of the emma.theme
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/report/daydegree', {
        templateUrl: 'theme/report/report_daydegree.html',
        controller: 'ReportDayDegreeCtrl',
        controllerAs: 'reportdaydegree'
      })
  })
  .controller('ReportDayDegreeCtrl', function ($log, $scope, $http, authFactory, baseFactory, dialogService, SaveAs, APP_URL) {

    var currentCommission = authFactory.getAuthData().info.commissions.current;

    $scope.report = {};

    $scope.fromYearPicker = {
      year: (new Date().getFullYear()).toString()
    };

    $scope.zonatermica = {};

      var REPORT_BASE_DIR = "reports/EMMA/";
      var REPORT_API_BASE = "http://"+location.host+""+APP_URL+"/rest/report/";
      //var REPORT_API_BASE = "http://docker0.ict-group.it:7878/six/rest/report/";
      var REPORT_QUERY_BASE = "&net.sf.jasperreports.json.source="+REPORT_API_BASE;

    $scope.generateDayDegreeReport = function () {
      dialogService.loading('Generazione report in corso');
      //var query = REPORT_QUERY_BASE + "chart/analysis/" + currentCommission.code + "/" + $scope.fromYearPicker.year + "/" + $scope.report.budget.UUID;
      var query = REPORT_QUERY_BASE + "daydegree/"+currentCommission.code+"/"+$scope.fromYearPicker.year+"/"+$scope.zonatermica.zonatermica_id.UUID;
        console.log("generating report "+ query);
      $http.post(APP_URL + '/rest/report/generate',
        {
          path: REPORT_BASE_DIR+"Gg_lines.pdf",
          query: query
        },
        { responseType: 'arraybuffer' }).
      then(function(data, status, headers, config) {
        dialogService.stopLoading();
        var options = { type: 'application/pdf' };
        SaveAs.download(data, 'daydegree.pdf', options);
      }, function(data, status, headers, config) {
        dialogService.stopLoading();
        toaster.pop('error', "Errore", 'Errore generazione report');
        // called asynchronously if an error occurs
        // or server returns response with an error status.
      });
    };

    /***** Data ready events *****/

    var DATA_READY_EVENT = 'dataReady';

    $scope.$on(DATA_READY_EVENT, function(event) {
      setTimeout(function() { // evita che venga richiamato troppo velocemente (altrimenti si accavalla a showLoadingMessage)
        dialogService.hideLoadingMessage();
      }, 200);
    });
  });


angular.module('ictportal.theme')
.config(function ($routeProvider) {
    $routeProvider
        .when('/roles-bookmarks-generator', {
            templateUrl: 'theme/roles-bookmarks-generator/roles-bookmarks-generator.html',
            controller: 'BookmarksRolesCtrl'
        })
})
.controller('BookmarksRolesCtrl', function ($scope, authFactory, sixFrameFactory, recordFactory, matrixParFactory) {

    $scope.jsfurl = null;
    $scope.menu = [];
    $scope.json = [];
    $scope.roles = [];
    $scope.roleHasPref = true;
    
        
    $scope.getJsfURL = function () {
        return sixFrameFactory.getJsfURL($scope.jsfurl);
    };

    $scope.pushJson = function (description, code) {
        if(!checkExist(code)){
            $scope.json.push({ "code" : code, "description" : description });
        }
    }

    $scope.spliceJson = function (code) {
        if(checkExist(code)) {
            var index = $scope.json.findIndex(function (x){
                return  x.code === code;
              });
            $scope.json.splice(index, 1);
        }
    }

    $scope.loadRole = function() {
        matrixParFactory.getValueOrDefault({key: 'bookmarks', d1: '*', d2: '*', d3: $scope.selectedRole, d4: '*', d5: '*'}, {}).$promise.then(function(data){
            if(data.result.value) {
                $scope.roleHasPref = true;
                $scope.json = JSON.parse(data.result.value);
            }
            else{
                $scope.roleHasPref = false;
                $scope.json = [];
            }
          });
    }

    function checkExist(code){
       var index = $scope.json.findIndex(function (x){
        return  x.code === code;
      });
       return index >= 0 ? true : false;
    }

    function loadAllFunctions(){
        var menu = authFactory.getAuthData().menu;
        $scope.menu = menu;
    }

    function loadRoles() {
        recordFactory('profile_type').query({page_size: 10000}).$promise.then(function (response) {
            $scope.roles = response.list;
        });
    }

    function init(){
        loadAllFunctions();
        loadRoles();
    };

    init();
});
'use strict';

/**
 * @ngdoc service
 * @name ictportal.authFactory
 * @description
 * # authFactory
 * Factory in the ictportal.
 */
angular.module('ictportal')
  .factory('authFactory', function ($rootScope, localStorageService, dbFilterFactory, md5, ENV, CAS, eggsImplicitFilterFactory, sixImplicitFilterFactory) {

    var authInStore = {};
    if(CAS) {
      authInStore = {};
    } else {
      authInStore = localStorageService.get(ENV + '_authData');
    }

    var authFactory = {
      authData: authInStore || undefined
    };

    authFactory.setAuthData = function (authData) {
      if(!authData.info){
        authData.info = {};
      }
      this.authData = {
        authId: authData.authId,
        authToken: authData.authToken,
        authPermission: authData.authPermission,
        menu: authData.menu,
        info: authData.info,
        user: authData.user,
        bookmarks: authData.bookmarks,
        options: authData.options,
        profile: authData.profile,
        profiles: authData.profiles,
        navigation: [],
        lang: authData.lang,
        md5: '',
        six: authData.six,
        eggs: authData.eggs,
        permission: {
          six: {}
        }
      };
      // QUI DOVE SET TOUCH
      this.authData.options.touch = (localStorage.getItem('touch') === 'true');
      if(authData.info){
        var filtersEggs = eggsImplicitFilterFactory.getImplicitFilters(authData.info.abilitazioni);
        var filtersSix = sixImplicitFilterFactory.getImplicitFilters(authData.info.authorizations);
        this.authData.filters = angular.extend(filtersSix,filtersEggs);
      }
      if(authData.profile){
        this.authData.info.azCod = authData.profile.cod;
        if(authData.profile.items && authData.profile.items.length){
          this.authData.info.divCod = authData.profile.items[0].cod;
        }
      }
      if(CAS) {
        authInStore = this.authData;
      } else {
        localStorageService.set(ENV+'_authData', this.authData);
      }
      $rootScope.$broadcast('authChanged');
    };

    authFactory.clearNavigation = function(){
      if(this.authData){
        if(this.authData.navigation){
          this.authData.navigation.length = 0;
        }
        else{
          this.authData.navigation = [];
        }
      }
    };

    authFactory.getAuthFilters = function (entity, ignoreAzcod, ignoreDivcod) {
      var filters = [];
      if (this.authData && this.authData.profile && !ignoreAzcod) {
        filters = filters.concat(dbFilterFactory.getNumberFilter('t.azcod', this.authData.info.azCod));
        if (this.authData.info.divCod && !ignoreDivcod) {
          var query = '( t.divcod=' + this.authData.info.divCod + ' OR t.divcod IS NULL )'
          filters = filters.concat(dbFilterFactory.getCustomFilter(query));
        }
      }
      return filters;
      // TODO: gestire filtri impliciti
    };

    authFactory.getAuthSupplierFilters = function (entity) {
      entity = (typeof entity === "undefined") ? 't.id' : entity;
      var filters = [];
      var authorizations = this.authData && this.authData.info && this.authData.info.authorizations;
      if (authorizations && authorizations.suppliers && authorizations.suppliers.length > 0) {
        if (authorizations.suppliers.length > 1) {
          var availableIds = authorizations.suppliers.join(',');
          filters = filters.concat(dbFilterFactory.getCustomFilter(entity + " IN (" + availableIds + ")"));
        } else if (authorizations.suppliers.length === 1) {
          filters = filters.concat(dbFilterFactory.getNumberFilter(entity, authorizations.suppliers[0]));
        }
      }
      return filters;
    }

    authFactory.getAuthDestinationFilters = function (entity) {
      entity = (typeof entity === "undefined") ? 't.id' : entity;
      var filters = [];
      var authorizations = this.authData && this.authData.info && this.authData.info.authorizations;
      if (authorizations && authorizations.destinations && authorizations.destinations.length > 0) {
        if (authorizations.destinations.length > 1) {
          var availableIds = authorizations.destinations.join(',');
          filters = filters.concat(dbFilterFactory.getCustomFilter(entity + " IN (" + availableIds + ")"));
        } else if (authorizations.destinations.length === 1) {
          filters = filters.concat(dbFilterFactory.getNumberFilter(entity, authorizations.destinations[0]));
        }
      }
      return filters;
    }

    authFactory.getLoginUser = function(){
      var deferred = $q.defer();
      var result = undefined;
      if(this.authData){
        var payload = {
            code: 'username',
            description: 'username',
            query: this.authData.authId
        };
        recordFactory('users').query(payload)
          .$promise.then(function (data){
              if(data.totalResults>0){
                result = data.list[0];
                deferred.resolve(result);
              }
              else{
                  toaster.pop('warning','Attenzione','Utente di login non trovato');
              }
          });
      }
      return deferred.promise;
    };

    authFactory.getAuthData = function () {
      return this.authData;
    };

    authFactory.isAuthenticated = function () {
      var data = this.getAuthData();
      if (!angular.isUndefined(data)) {
        return data.hasOwnProperty('authToken');
      }
      return false;
    };

    authFactory.logout = function () {
      this.authData = undefined;
      if(CAS) {
        authInStore = {};
      } else {
        localStorageService.remove(ENV+'_authData');
        localStorage.removeItem('touch');
      }
      console.log('*** LOGOUT');
    };

    authFactory.isWritePermAllowed = function (resourceKey) {
      return this.checkPerm(resourceKey, 'NEW');
    };

    authFactory.isDeletePermAllowed = function(resourceKey) {
      return this.checkPerm(resourceKey, 'DELETE');
    };

    authFactory.checkPerm = function(resourceKey, opKey) {
      var perms = this.getAuthData().info.operations[resourceKey];
      for(var k in perms) {
        var p = perms[k];
        if(p.name === opKey) {
          return p.permitted;
        }
      }
      return false;
    };

    authFactory.getPermissions = function(resourceKey) {
      var operations = this.authData.info.operations;
      var perms = this.authData.info.operations[resourceKey]?this.authData.info.operations[resourceKey]:{};
      return perms;
    }

    authFactory.isProfileChoosen = function () {
          var data = this.getAuthData();
          if (!angular.isUndefined(data)) {
              if(data.profiles && data.profiles.length == 1 && data.profiles[0].items && data.profiles[0].items.length == 0) {
                data.profile = data.profiles[0];
              }
              return data.hasOwnProperty('authToken') && data.profile;
          }
          return false;
      };

    authFactory.getCurrentCustomer = function(){
        var customer = undefined;
        if(angular.isDefined(this.authData) && angular.isDefined(this.authData.profile)){
            this.authData.profile.items.forEach(function(item){
                if(item.type==='customer'){
                    customer = item;
                }
            });
        }
        return customer;
    };

    return authFactory;
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.authHttpRequestInterceptor
 * @description
 * # authHttpRequestInterceptor
 * Factory in the emma.theme.
 */
angular.module('ictportal')
  .service('authHttpRequestInterceptor', function ($log, $rootScope, authFactory) {
    var service = this;

    service.request = function(config) {
        if (authFactory.isAuthenticated()) {
            config.headers = config.headers || {};
            config.headers['auth-id'] = authFactory.getAuthData().authId;
            config.headers['auth-token'] = authFactory.getAuthData().authToken;
            config.headers['auth-md5'] = authFactory.getAuthData().md5;
        }
        return config;
    };

    service.responseError = function(response) {
        if (response.status === 401 || response.status === 415) {
            $rootScope.$broadcast('unauthorized');
            if(response.headers('www-authenticate').indexOf('invalid_token') != -1) {
                authFactory.logout();
            }
        }
        return response;
    };
});

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.baseFactory
 * @description
 * # baseFactory
 * Factory in the emma.theme.
 */
angular.module('ictportal.theme')
  .factory('baseFactory', function (APP_URL, $resource) {
    return function(entity) {
      return $resource(APP_URL + '/rest/'+entity+'/:verb/:id', {}, {
        query:  {method: 'GET', isArray: false},
        search: {method: 'POST', isArray: false},
        filter: {method: 'POST', isArray: true},
        select: {method: 'GET', isArray: true},
        create: {method: 'POST'},
        bulk:   {method: 'POST', isArray: true},
        show:   {method: 'GET'},
        update: {method: 'PUT', params: {id: '@id'}},
        delete: {method: 'DELETE', params: {id: '@id'}}
      });
    };
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.baseFactory
 * @description
 * # baseFactory
 * Factory in the emma.theme.
 */
angular.module('ictportal.theme')
  .factory('dbBaseFactory', function (APP_URL, $resource) {
    return function(entity) {
      return $resource(APP_URL + '/rest/'+entity+'/search/:id', {}, {//FIXME: togliere search
        //query: {method: 'GET', isArray: false},
        search: {method: 'POST', isArray: false}
        /*select: {method: 'GET', isArray: true}
        create: {method: 'POST'},
        bulk: {method: 'POST', isArray: true},
        show: {method: 'GET'},
        update: {method: 'PUT', params: {id: '@id'}},
        delete: {method: 'DELETE', params: {id: '@id'}}*/
      });
    };
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.dialogService
 * @description
 * # dialogService
 * Service in the emma.theme.
 */
angular.module('ictportal.theme')
  .service('dialogService', function (ngDialog, $rootScope, $filter, $log) {
//http://ngmodules.org/modules/ngDialog
//v. http://likeastore.github.io/ngDialog/#


    /* ************************ */
    /* **** LOADING DIALOG **** */
    /* ************************ */

    this.loadingDialog;
    this.loadingMessageShowedNr = 0;

    this.loading = function(message) {
      this.loadingDialog= ngDialog.open({
          name: 'loadingDialog',
          closeByDocument: false,
          showClose: false,
          template: '<div class="progress">'+
          '<div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%">'+
          '<span class="sr-only">100% Complete</span>'+
          '</div>'+
          '</div><div style="text-align:center"><i class="fa fa-refresh fa-spin" style="font-size:large"></i>&nbsp; '+message+'</div>',
          plain:'true',
          /*controller: 'FirstDialogCtrl',*///<-- si potrebbe usare un ctrl per fare cose più fiche... tipo progressbar che va avanti
          className: 'ngdialog-theme-default ngdialog-theme-custom'
      });
      return this.loadingDialog.id;
    };

    this.stopLoading = function() {
        ngDialog.close(this.loadingDialog.id);
    };

    this.showLoadingMessage = function(message) {
      if(this.loadingMessageShowedNr <= 0) {
        this.loading(message);
      }
      this.loadingMessageShowedNr++;
    };

    this.hideLoadingMessage = function(forceHideAll) {
      this.loadingMessageShowedNr--;
      if(forceHideAll === true || this.loadingMessageShowedNr <= 0) {
        this.stopLoading();
        this.loadingMessageShowedNr = 0;
      }
    };



    /* ************************ */
    /* **** GENERIC ALERT  **** */
    /* ************************ */

    this.alert = function(message, duration){
      var alertDialog= ngDialog.open({
          name: 'loadingDialog',
          closeByDocument: true,
          showClose: true,
          template: ''+
          '<div style="text-align:center"><i class="fa fa-warning" style="font-size:large"></i>&nbsp; '+message+'</div>',
          plain:'true',
          /*controller: 'FirstDialogCtrl',*///<-- si potrebbe usare un ctrl per fare cose più fiche... tipo progressbar che va avanti
          className: 'ngdialog-theme-default ngdialog-theme-custom'
      });

      function setTimeOutWithClosure(id, duration){
          var id = id;
          setTimeout(function() {
              ngDialog.close(id);}, duration)
      }
      setTimeOutWithClosure(alertDialog.id, duration);
    };



    /* ************************ */
    /* **** GENERIC DIALOG **** */
    /* ************************ */

    /*
     * type:
     *   success
     *   info
     *   warning
     *   danger
     * bodyTextAlign:
     *   left
     *   center
     *   right
     */

    this.DIALOG_TYPE = {
      SUCCESS:  'success',
      INFO:     'info',
      WARNING:  'warning',
      DANGER:   'danger'
    };

    this.BODY_ALIGNMENT = {
      LEFT:   'left',
      CENTER: 'center',
      RIGHT:  'right'
    };

    this.genericDialog;

    this.dialog = function(title, content, type, duration, discreet, bodyTextAlign) {
      var icon;

      type = type || 'info';
      duration = duration || 5000;
      discreet = discreet || false;
      bodyTextAlign = bodyTextAlign || 'center';

      this.genericDialog = ngDialog.open({
        name: 'dialog',
        closeByDocument: true,
        showClose: true,
        template: '' +
          '<strong><span class="ngdialog-icon"></span></strong>' +
          '<div style="text-align: center;">' +
            '<div><strong>' + title + '</strong></div>' +
            '<div style="margin: 10px 5px 5px 5px; text-align: ' + bodyTextAlign + ';">' + content + '</div>' +
          '</div>',
        plain: true,
        /*overlay: !discreet,*/ // Non lo uso altrimenti non mette l'overlay che consente di chiudere la dialog premendo su qualsiasi punto del background => lo faccio fuori con la trasparenza nel css
        /*controller: 'FirstDialogCtrl',*///<-- si potrebbe usare un ctrl per fare cose più fiche... tipo progressbar che va avanti
        className: 'ngdialog-theme-default' + (type ? ' ngdialog-theme-' + type : '') + (discreet ? ' discreet' : '')
      });

      function setTimeOutWithClosure(id, duration){
        var idToClose = id;
        setTimeout(function() {
          if(ngDialog.isOpen(idToClose)) {  // nel caso fosse stata chiusa manualmente, ngDialog.close(id, value) mi chiuderebbe tutte le altre dialog aperte
            ngDialog.close(idToClose, 'close!');
          }
        }, duration)
      }
      setTimeOutWithClosure(this.genericDialog.id, duration);
    };



    /* ************************************** */
    /* **** DIALOG WITH CUSTOM TEMPLATE  **** */
    /* ************************************** */

    this.templDialog;

    /**
     *
     * @param template template da mostrare nella dialog
     * @param type info (default), success, warning, danger
     * @param scope oggetto contenente le variabili utilizzate all'interno del template
     * @param opts ulteriori opzioni da passare alla ngDialog.open()
     * @param duration durata della dialog (defualt: -1 ms => illimitata)
     * @param discreet indica se mostrare un popup al centro della pagina (false, default) o una barra in alto (true)
     */
    this.templateDialog = function(template, type, scope, opts, duration, discreet, width) {
      type = type || 'info';
      duration = duration || -1;
      discreet = discreet || false;

      var dialogScope = $rootScope.$new();
      angular.extend(dialogScope, scope);

      var options = opts || {};
      options.template = template;
      options.scope = dialogScope;
      if(angular.isUndefined(options.name)) {
        options.name = 'templateDialog';
      }
      if(angular.isUndefined(options.closeByDocument)) {
        options.closeByDocument = true;
      }
      if(angular.isUndefined(options.showClose)) {
        options.showClose = true;
      }
      if(angular.isUndefined(options.plain)) {
        options.plain = true;   // N.B. se true si aspetta direttamente una stringa contenente il template, se false si aspetta un html esterno o un template definito in <script type="text/ng-template">
      }
      if(angular.isUndefined(options.className)) {
        options.className = 'ngdialog-theme-default' + (type ? ' ngdialog-theme-' + type : '');
      }
      if(discreet) {
        options.className += ' discreet';
      }
      if(width) {
        options.width = width;
      }

      this.templDialog = ngDialog.open(options);

      function setTimeOutWithClosure(id, duration) {
        var idToClose = id;
        setTimeout(function() {
          if(ngDialog.isOpen(idToClose)) {  // nel caso fosse stata chiusa manualmente, ngDialog.close(id, value) mi chiuderebbe tutte le altre dialog aperte
            ngDialog.close(idToClose, 'close!');
          }
        }, duration)
      }
      setTimeOutWithClosure(this.templDialog.id, duration);

      return this.templDialog;
    };



    /* ************************ */
    /* **** CONFIRM DIALOG **** */
    /* ************************ */

    this.confirmDialog = function(message, functionY, functionN){
      var alertDialog= ngDialog.openConfirm({
        name: 'alertDialog',
        closeByDocument: false,
        showClose: true,
        template: ''+
        '<div style="text-align:center"><i class="fa fa-exclamation-triangle"></i>&nbsp; ' + message + '</div><br>' +
          '<div style="text-align:center">' +
            '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm()">Si</button>' +
              '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="closeThisDialog()">No</button>' +
          '</div>' +
        ''+
        '',
        plain:true,
        className: 'ngdialog-theme-default ngdialog-theme-custom'
      });

      alertDialog.then(function(resp) {
        console.log(resp);
        if(angular.isFunction(functionY)) {
          functionY();
        }
      }, function(resp) {
        console.log(resp);
        if(angular.isFunction(functionN)) {
          functionN();
        }
      });
    };



    /* ********************************************************* */
    /* **** DIALOG RESPONSE FROM BACKEND (ServiceResponse)  **** */
    /* ********************************************************* */

    /**
     * Mostra una tabella contenente i log dal backend (LogServiceMessage)
     */
    this.serviceResponse = function(title, resp, hideSuccesses, width) {
      hideSuccesses = hideSuccesses || false;
      width = width || '60%';
      var dialogScope = $rootScope.$new();
      dialogScope.hideSuccesses = hideSuccesses;
      dialogScope.resp = resp;
      dialogScope.exportFn = this.exportXLSX;
      dialogScope.totals = {};
      resp.messages = resp.messages || [];
      if(hideSuccesses) { resp.messages = ($filter('filter')(resp.messages, {success: false})); }
      dialogScope.totals.tot = resp.messages.length;
      dialogScope.totals.errors = ($filter('filter')(resp.messages, {error: true})).length;
      dialogScope.totals.warnings = ($filter('filter')(resp.messages, {warning: true})).length;
      dialogScope.totals.successes = ($filter('filter')(resp.messages, {success: true})).length;
      dialogScope.columns = [
        {key: 'instant', name: 'Data', transform: function(v) { return (v && v.epochSecond)?new Date(v.epochSecond*1000):new Date(v) }},
        {key: 'code', name: 'Codice'},
        {key: 'status', name: 'Stato'},
        {key: 'message', name: 'Messaggio'}
      ];
      this.messagesDialog = ngDialog.open({
        name: 'loadingDialog',
        closeByDocument: false,
        showClose: true,
        template: '' +
        '<script type="text/ng-template" id="messages-table.html">' +
          '<table class="tinyTable">' +
            '<tr>' +
              '<th style="min-width: 15%">Stato</th>' +
              '<th style="min-width: 15%">Codice</th>' +
              '<th style="min-width: 70%">Messaggio</th>' +
            '</tr>' +
            '<tr ng-repeat="r in filtered = (resp.messages | filter: {error: config.errors, warning: config.warnings, success: config.successes})" ng-if="resp.messages && resp.messages.length>0">' +
              '<td ng-class="{\'text-success\': r.success, \'text-warning-dker\': r.warning, \'text-danger-dker\': r.error}">{{r.status}}</td>' +
              '<td>{{r.code}}</td>' +
              '<td>{{r.message}}</td>' +
            '</tr>' +
            '<tr ng-if="!filtered || filtered.length==0">' +
              '<td colspan="3">' +
                '<span ng-if="config.all">Nessun messaggio</span>' +
                '<span ng-if="config.errors">Nessun errore</span>' +
                '<span ng-if="config.warnings">Nessun warning</span>' +
                '<span ng-if="config.successes">Nessun successo</span>' +
              '</td>' +
            '</tr>' +
          '</table>' +
        '</script>' +

        '<div style="font-size: small"><strong>' + title + '</strong></div>' +
        '<div style="float: right; margin-top: 10px; margin-right: 15px"><a class="btn btn-xs btn-default" ng-click="exportFn(columns, resp.messages)"><span class="fa fa-download"></span> Esporta xlsx</a></div>' +

        '<uib-tabset>' +
          '<uib-tab ng-click="config={all:true}">' +
            '<uib-tab-heading>' +
              '<span class="fa fa-bars text-info-dker"></span> Tutti ({{totals.tot}})' +
            '</uib-tab-heading>' +
            '<div ng-include="\'messages-table.html\'"></div>' +
          '</uib-tab>' +

          '<uib-tab ng-click="config={errors:true}">' +
            '<uib-tab-heading>' +
              '<span class="fa fa-exclamation-circle text-danger-dker"></span> Errori ({{totals.errors}})' +
            '</uib-tab-heading>' +
            '<div ng-include="\'messages-table.html\'"></div>' +
          '</uib-tab>' +

          '<uib-tab ng-click="config={warnings:true}">' +
            '<uib-tab-heading>' +
              '<span class="fa fa-exclamation-triangle text-warning-dker"></span> Warnings ({{totals.warnings}})' +
            '</uib-tab-heading>' +
            '<div ng-include="\'messages-table.html\'"></div>' +
          '</uib-tab>' +

          '<uib-tab ng-click="config={successes:true}" ng-if="!hideSuccesses">' +
            '<uib-tab-heading>' +
              '<span class="fa fa-check-circle-o text-success-dker"></span> Successi ({{totals.successes}})' +
            '</uib-tab-heading>' +
            '<div ng-include="\'messages-table.html\'"></div>' +
          '</uib-tab>' +
        '</uib-tabset>',
        plain: true,
        className: 'ngdialog-theme-default',
        width: width,
        scope: dialogScope
      });
      return this.messagesDialog.id;
    };



    /* ******************** */
    /* **** EXPORT XLS **** */
    /* ******************** */

    this.exportXLSX = function(columns, rows) {
      var sheet = {};

      var i = 0;
      columns.forEach(function (col) {
        var loc = XLSX.utils.encode_cell({r: 0, c: i});
        sheet[loc] = {
          v: col.name
        };
        i += 1;
      });

      var endLoc;
      rows.forEach(function (row, ri) {
        ri +=1;
        columns.forEach(function (col, ci) {
          var loc = XLSX.utils.encode_cell({r: ri, c: ci});
          if(angular.isDefined(row[col.key])) {
            var value = row[col.key];
            if(angular.isFunction(col.transform)) { value = col.transform(value); }
            sheet[loc] = {
              v: value,
              t: 's'
            };
          }
          endLoc = loc;
        });
      });

      sheet['!ref'] = XLSX.utils.encode_range({ s: 'A1', e: endLoc });

      var workbook = {
        SheetNames: ['Sheet1'],
        Sheets: {
          Sheet1: sheet
        }
      };

      var wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' };
      var wbout = XLSX.write(workbook, wopts);

      saveAs(new Blob([s2ab(wbout)], {type: ""}), "messages.xlsx");
    };

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }



    /* *************** */
    /* **** OTHER **** */
    /* *************** */

    // FIXME verificare se è possibile spostarlo su issue e odl per evitare di "sporcare" la dialogService con funzioni specifiche

    this.fillTextField = function (message, functionY, functionN) {
      var alertDialog= ngDialog.openConfirm({
        name: 'alertDialog',
        closeByDocument: false,
        showClose: true,
        template: ''+
        '<div style="text-align:center"><i class="fa fa-exclamation-triangle"></i>&nbsp; ' + message + '</div><br>' +
        '<div style="text-align:center"><textarea id="status_note" rows="4" class="col-md-12" ng-model="note"></textarea></div>' +
        '<div style="text-align:center">' +
        '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm()">Salva</button>' +
        // '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="closeThisDialog()">No</button>' +
        '</div>' +
        ''+
        '',
        plain:true,
        className: 'ngdialog-theme-default ngdialog-theme-custom'
      });

      alertDialog.then(function(resp) {
        console.log(resp);
        var note = "";
        if(document.getElementById("status_note").value){
          note = document.getElementById("status_note").value;
        }
        if(angular.isFunction(functionY)) {
          functionY(note);
        }
      }, function(resp) {
        console.log(resp);
        if(angular.isFunction(functionN)) {
          functionN(note);
        }
      });
    };
  }
);

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.errorService
 * @description
 * Service in the emma.theme.
 */
angular.module('ictportal.theme')
  .service('errorService', function (dialogService, toaster) {

    this.handleError = function(backendResponse, showErrorPopup) {
        if (backendResponse.hasOwnProperty('status')
            && backendResponse.status>=500) {
            if (backendResponse.hasOwnProperty('message')) {
              showErrorPopup === true && toaster.pop('error', "Errore", backendResponse.message);
              return false;
            }
            if (backendResponse.hasOwnProperty('developerMessage') && showErrorPopup === true) {
              showErrorPopup === true && toaster.pop('error', "Errore", backendResponse.developerMessage);
              return false;
            }
        }
        return true;
    }

  });

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.loadingBarService
 * @description
 * # loadingBarService
 * Service in the emma.theme.
 */
angular.module('ictportal.theme')
  .service('loadingBarService', function (cfpLoadingBar, dialogService) {

    this.start = function(message) {
      cfpLoadingBar.start();
      if(angular.isDefined(message)) {
        angular.element(document.getElementById('loading-bar-spinner')).addClass('custom-loading-bar-spinner');
        document.getElementById('loading-bar-spinner').innerHTML = '<div class="spinner-icon"></div> ' + message;
      } else {
        angular.element(document.getElementById('loading-bar-spinner')).removeClass('custom-loading-bar-spinner');
        document.getElementById('loading-bar-spinner').innerHTML = '<div class="spinner-icon"></div>';
      }
    };

    this.stop = function(response, title) {
      title = title || 'Esito';
      angular.element(document.getElementById('loading-bar-spinner')).removeClass('custom-loading-bar-spinner');
      document.getElementById('loading-bar-spinner').innerHTML = '<div class="spinner-icon"></div>';
      cfpLoadingBar.complete();
      if(angular.isDefined(response)) {
        dialogService.serviceResponse(title, response);
      }
    };
  });


'use strict';

/**
 * @ngdoc service
 * created on 07/11/2016
 * @author Rita Beltrami
 * @name emma.theme.localeFactory
 * @description Inserisco qui la logica di gestione di lingue e traduzioni.
 */
angular.module('ictportal')
  .constant('SF_COMMON_TRANSLATIONS', [
      'code', 
      'description', 
      'last_modified_user_id',
      'created_date',
      'validity_end',
      'version',
      'created_user_id',
      'divcod',
      'last_modified_date',
      'azcod'
    ])
  .factory('localeFactory', function ($translate, $translatePartialLoader, $q, SF_COMMON_TRANSLATIONS) {

    var localeFactory = {};

    /** 
     * Carica i file di traduzione standard, più quello specificato dal parametro 'part'
     * Es. part='pippo' => carico il file translation/en/pippo.json
     */
    localeFactory.loadTranslation = function (part) {
      var lang =  $translate.use();
      // Carico i file comuni
      if(!$translatePartialLoader.isPartLoaded('portal', 'en')){
        $translatePartialLoader.addPart('portal'); 
      }
      if(!$translatePartialLoader.isPartLoaded('portal', lang)){
        $translatePartialLoader.addPart('portal'); 
      }
      // Carico i file per le pagine specifiche
      if( part) {
        if (angular.isArray(part)) {
          part.forEach(function (value) {
            if (!$translatePartialLoader.isPartLoaded(value, lang)){
              $translatePartialLoader.addPart(value);
            }
          });
        } else if (!$translatePartialLoader.isPartLoaded(part, lang)){
          $translatePartialLoader.addPart(part);
        }
      }
      // Asincrono. Emette $translateRefreshStart e $translateRefreshEnd
      return $translate.refresh();
    };

    /** 
     * Dato un oggetto di chiavi, assegna i corrispettivi valori. 
     * Se viene specificato il parametro part, alle chiavi viene assegnato il relativo prefisso.
     */
    localeFactory.translateMsg = function (msg, part) {
      var deferred = $q.defer();
      var promises = {};
      var prefix = part?(part + '.'):'';
      for(var key in msg){
        promises[prefix+key] =  $translate(prefix+key);
      }
      $q.allSettled(promises).then(function(values) {
        var promisesPortal = {};
        var doPromisePortal = false;
        for(var key in msg){
          if(values[prefix+key].state==='fulfilled'){
            msg[key] = values[prefix+key].value;
          }
          else {
            // Fallback su portal.json --> array promesse
            promisesPortal[key] = $translate(key);
            doPromisePortal = true;
          }
        }
        // Fallback su portal.json --> risolve promesse
        if(doPromisePortal) {
          $q.allSettled(promisesPortal).then(function(values) {
            for(var key in values){
              if(values[key].state==='fulfilled'){
                msg[key] = values[key].value;
              }
            }
            deferred.resolve(msg);
          })
        }
        else {
          deferred.resolve(msg);
        }
      })
      return deferred.promise;
    };

    /** 
     * Traduce uno schema_form 
     */
    localeFactory.translateSchema = function(sf){
      var _this = this;
      var deferred = $q.defer();
      var prefix = sf.code + '.';
      var map = {}; 
      var promises = {};
      var keys = [];
      var entityDescriptionKey = prefix + sf.code;
      
      keys.push(entityDescriptionKey);
      for(var key in sf.schema.properties){
        if(!_this.isCommonSfTranslation(key)){
          keys.push(prefix + key);
        }
        else{
          keys.push(key);
        }
      }

      // TODO: aggiungere titoli tab e altre varie ed eventuali
      keys.forEach(function(key){
        promises[key] =  $translate(key);
      });

      $q.allSettled(promises).then(function(values) {
        // Traduco il titolo, ossia il nome dell'entità
        sf.description = values[entityDescriptionKey].value;
        // Traduco i singoli elementi del form
        sf.form[0].items[0].tabs[0].items.forEach(function(item){
          var entry = _this.isCommonSfTranslation(item.key[0])?item.key[0]:(prefix + item.key[0]);
          if(values[entry].state==='fulfilled'){
            item.title = values[entry].value;
          }
        });
        // Traduco le colonne 
       sf.columnDefs.forEach(function(col){
          var entry = _this.isCommonSfTranslation(col.field)?col.field:(prefix + col.field);
          if(values[entry].state==='fulfilled'){
            col.name = values[entry].value;
          }
        });
        deferred.resolve(sf);
      })

      return deferred.promise;
    };

    localeFactory.getDateFormat = function() {
      var format = 'dd/MM/yyyy';
      return format;
    };

    localeFactory.getDateTimeFormat = function() {
      var format = 'dd/MM/yyyy hh:mm';
      return format;
    };

    localeFactory.getToBeTranslatedSchema = function(sf){
      var _this = this;
      var entity = sf.code;
      var toBeTranslated = {};
      toBeTranslated[entity] = {};
      toBeTranslated[entity][entity] = sixStringLib.capitalize(entity);
      for(var key in sf.schema.properties){
        if(!_this.isCommonSfTranslation(key)){
          toBeTranslated[entity][key] = sixStringLib.capitalize(key);
        }
      }
      return toBeTranslated;
    };

    /**
     * Traduce una stringa applicando anche delle sostituzioni dinamiche di valori.
     * key = chiave di traduzione, es. "Ciao {{param1}}"
     * valuesObj = json con parametri, es. { param1: "pippo"}
     * 
     * Ritorna una $promise
     */
    localeFactory.translateReplace = function(key, valuesObj){
      return $translate(key, valuesObj);
    };

    /**
     * I campi "common" sono quelli che hanno un po' tutte le entità, come codice, descrizione, ecc. 
     */
    localeFactory.isCommonSfTranslation = function(key){
      var result = (-1 !== SF_COMMON_TRANSLATIONS.indexOf(key));
      return result;
    };

    /** 
     * Capisce e setta qual è la lingua impostata nel browser 
     */
    localeFactory.detectLanguage = function(){
        var lang = navigator.languages[0];
        if(lang.startsWith('en')){
          lang = 'en';
          $translate.use(lang);
        }
        else if(lang.startsWith('it')){
          lang = 'it';
          $translate.use(lang);
        }
        else if(lang.startsWith('de')){
          lang = 'de';
          $translate.use(lang);
        }
        else if(lang.startsWith('es')){
          lang = 'es';
          $translate.use(lang);
        }
        else if(lang.startsWith('tr')){
          lang = 'tr';
          $translate.use(lang);
        }
        $translatePartialLoader.addPart('portal');
        $translate.refresh();
        return lang;
      };

    localeFactory.detectLanguage();

    return localeFactory;
  });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.theme.loginFactory
 * @description
 * # loginFactory
 * Factory in the ictportal.theme.
 */
angular.module('ictportal.theme')
  .factory('loginFactory', function (APP_URL, $resource) {
    //cambiare la switch commission, fare una loginfactory.
    //    usare in sixframeworkcontroller e in login.js (controller)
    //loginfactory per fare la login e la switch
    //poi i due controller usano i dati di login

    return $resource(APP_URL + '/rest/auth/:op/:commission/:username', {}, {
      switch: { method: 'POST', params: { op: 'switch' }, isArray: false },
      switchprofile: { method: 'POST', params: { op: 'switchprofile' }, isArray: false },
      getMenu: { method: 'GET', params: { op: 'menu' }, isArray: true }
    });
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.lookupFactory
 * @description
 * # lookupFactory
 * Factory supergenerica per essere richiamata dalle lookup. Può puntare ai vari war.
 */
angular.module('ictportal.theme')
  .factory('lookupFactory', function ($resource) {
    return function(url, entity) {
      return $resource(url+entity+'/:verb/:id', {}, {
        query:  {method: 'GET', isArray: false},
        search: {method: 'POST', isArray: false, params: {verb: '_filter', page_size: 250}}
      });
    };
  });

(function () {
	'use strict';

	angular.module('ictportal')
		.factory('msgFactory', msgFactory)
		.run(function (msgFactory, authFactory) {
			msgFactory._startDefault(); //registro subito sui canali predefiniti
			var authData = authFactory.getAuthData();
			msgFactory._init(authData);
		})

	/** @ngInject */
	function msgFactory($websocket, $rootScope, $location, $resource, ABNORMAL_URL) {
		console.log('msgFactory');
		// Open a WebSocket connection
		//var ws = $websocket('ws://'+$location.host()+':'+$location.port()+WS_URL);
		var ws = $websocket($location.protocol().replace("http", "ws")+'://'+$location.host()+':'+$location.port()+'/api/ws');
		//var ws = $websocket('ws://' + 'docker0.ict-group.it:92' + '/api/ws');

		//var ws = $websocket('wss://echo.websocket.org');

		var collection = [];
		var defaultChannels = ['_all'];
		var _authData;

		var _init = function(authData){ //private method
			_authData = authData;
		}

		var ping = function(ch) {
			defaultChannels.forEach(function (ch) {
				ws.send({ project: ch });
			})
		}
	
		var _startDefault = function () { //private method
			ws.onOpen(function () {
				console.log('msgFactory connection open');
				defaultChannels.forEach(function (ch) {
					ws.send({ project: ch });
					console.log('msgFactory registered channel: ', ch);
				})
				setInterval(ping, 30000);
			});
		};

		ws.onMessage(function (message) {
			collection.push(JSON.parse(message.data));
			$rootScope.$broadcast('msgFactory:newMessage', collection);
			console.log('msgFactory recived message', message.data);
		});

		ws.onError(function (event) {
			console.log('msgFactory connection Error', event);
		});

		ws.onClose(function (event) {
			console.log('msgFactory connection closed', event);

		});

		var registerChannel = function (code) {
			ws.send({ project: code });
		};

		function notifyFactory() {
			return $resource(ABNORMAL_URL + '/api/notify/ws', {}, {
				post: { method: 'POST', isArray: false },
				get: { method: 'GET', isArray: false }
			});
		}

		var sendMsg = function (message) {
			if (angular.isString(message)) {
				notifyFactory().post(message);
			}
			else if (angular.isObject(message)) {
				var tmp = (JSON.stringify(message));
				notifyFactory().post(tmp);
			}
		};

		var getStatus = function () {
			return ws.readyState;
		}

		var methods = {
			collection: collection,
			getStatus: getStatus,
			sendMsg: sendMsg,
			registerChannel: registerChannel,
			_startDefault: _startDefault, //private
			_init: _init //private
		};

		return methods;
	}

})();

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.modelIconService
 * @description
 * # modelIconService
 * Service in the emma.theme.
 */
angular.module('ictportal.theme')
  .service('modelIconService', function (localStorageService, authFactory) {
    // AngularJS will instantiate a singleton by calling "new" on this function

    // var iconsMap = localStorageService.get('iconsMap');
    var iconsMap = undefined;

    // Carica le icone in base a quelle da menu
    this.loadModelIcons = function(parent) {
      for (var index in parent.children) {
        var child = parent.children[index];
        if (child.code && child.icon) {
          var splitted = child.code.split("/");
          if (splitted && splitted[splitted.length - 1]) {
            iconsMap[splitted[splitted.length - 1]] = child.icon;
          }
        }
        this.loadModelIcons(child);
      }
      return iconsMap;
    };

    this.getModelIcon = function(modelName) {
      return iconsMap[modelName];
    };

    if(!iconsMap) {
      iconsMap = {};
      this.loadModelIcons({children: authFactory.getAuthData().menu});
      // localStorageService.set('iconsMap', iconsMap);
    }
  });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.theme.notificationService
 * @description
 * # notificationService
 * Service in the ictportal.theme.
 */
angular.module('ictportal.theme')
  .service('notificationService', function ($rootScope) {

    this.push = function(notif) {
      $rootScope.$broadcast('notification:push', notif);
    };

    this.clear = function() {
      $rootScope.$broadcast('notification:clear');
    };
  });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.parseSchemaService
 * @description
 * # parseSchemaService
 * Service in the ictportal
 */
angular.module('ictportal')
    .service('parseSchemaService', function(recordFactory, localeFactory, uiGridConstants, $rootScope) {

    var msg = {
        yes: 'Yes',
        no: 'No'
    };   

    this.readLookups = function(schemaForm, record) {
        for(var key in schemaForm.schema.properties){
            var prop = schemaForm.schema.properties[key];
            if(prop.format==='lookup'){
                record.lookup[key] = {
                    mapping: prop.mapping,
                    obj: {},
                    entity: prop.entity_id
                };
            }
        }
    };

    this.readDates = function(schemaForm, record) {
        schemaForm.form[0].items[0].tabs.forEach(function(tab) {
            tab.items.forEach(function(item){
                if(item.type==='datepicker'){
                    var t1 = record.dates;
                    var t2 = item.key[0];
                    record.dates.push(item.key[0]);
                }
            });
        });
    };

    this.loadDates = function(record, result){
        record.dates.forEach(function(field){
            if(result.list){
                result.list.forEach(function(item){
                    if(item[field]){
                        item[field] = new Date(item[field]);
                    }
                });
            }
        });
    };

    this.isEnum = function(schemaForm, field){
        var isAnEnum = false;
        if(schemaForm.schema.properties[field]){
            isAnEnum = schemaForm.schema.properties[field].format==='enum';
        }
        return isAnEnum;
    };

    this.getTitleMap = function(schemaForm, field){
        var titleMap = [];
        for(var i=0; i<schemaForm.form[0].items[0].tabs.length; i++){
            var tab = schemaForm.form[0].items[0].tabs[i];
            var index = tab.items.findIndex(function(e) { return e.key[0] == field; });
            if(index>=0){
                if(tab.items[index].titleMap){
                    titleMap = tab.items[index].titleMap;
                }
                break;
            }
        }
        return titleMap;
    };

    this.getEnableFiltering = function(schemaForm, item){
        var schemaItem = schemaForm.schema.properties[item.field];
        var enable = !(schemaItem.enableFiltering===false);
        return enable;
    };

    this.getDateFormat = function(schemaForm, field){
        var format = '';
        for(var i=0; i<schemaForm.form[0].items[0].tabs.length; i++){
            var tab = schemaForm.form[0].items[0].tabs[i];
            var index = tab.items.findIndex(function(e) { return e.key[0] == field; });
            if(index>=0){
                switch(tab.items[index].type){
                    case 'datetimepicker':
                        format = 'dd/MM/yyyy hh:mm';
                        break;
                    case 'timepicker':
                        format = 'hh:mm:ss';
                        break;
                    default:
                        format = 'dd/MM/yyyy';
                        break;
                }
                break;
            }
        }
        return format;
    };

    this.isDate = function(schemaForm, field){
        var isADate = false;
        for(var i=0; i<schemaForm.form[0].items[0].tabs.length; i++){
            var tab = schemaForm.form[0].items[0].tabs[i];
            var index = tab.items.findIndex(function(e) { return e.key[0] == field; });
            if(index>=0){
                isADate = ( (tab.items[index].type === 'datepicker') || (tab.items[index].type === 'timepicker') || (tab.items[index].type === 'datetimepicker') ) ;
                break;
            }
        }
        return isADate;
    };

    this.isBoolean = function(schemaForm, field){
        var isABoolean = false;
        for(var i=0; i<schemaForm.form[0].items[0].tabs.length; i++){
            var tab = schemaForm.form[0].items[0].tabs[i];
            var index = tab.items.findIndex(function(e) { return e.key[0] == field; });
            if(index>=0){
                isABoolean = (tab.items[index].type === 'eggscheckbox');
                break;
            }
        }
        return isABoolean;
    };
    
    this.loadLookupCols = function(lookupColsArray, result) {
        // Raggruppo assieme i record che fanno riferimento ad una stessa entità (es. tutti quelli con customer_id=123)
        // In questo modo risolvo l'entità una volta sola per tutti.
        var lookupMap = {};
        lookupColsArray.forEach(function (lookup) {
            var field = lookup.field;
            lookupMap[field] = {};
            if(result.list){
                result.list.forEach(function (record) {
                    var id = record[field];
                    if (id) {
                        if(!lookupMap[field][id]){
                            lookupMap[field][id] = [];
                        }
                        lookupMap[field][id].push(record);
                    }
                });
            }
        });
        // Recupero da DB i dati e li assegno ai rispettivi record.
        lookupColsArray.forEach(function (lookup) {
            for(var id in lookupMap[lookup.field]){
                recordFactory(lookup.entity).byId({ id: id })
                    .$promise.then(function (data) {
                        data['model'] = { description: '' };
                        var tokens = lookup.mapping.description.split(',');
                        tokens.forEach(function (term) {
                            if (data[term]) {
                                data['model'].description += data[term] + ' ';
                            }
                        });
                        data['model'].description = data['model'].description.trim();
                        lookupMap[lookup.field][data.id].forEach(function(record){
                            record[lookup.field + '_obj'] = data;
                        });
                    });
            }
        });
    };

    this.getLookupCol = function(schemaForm, record, lookupCols, item){
        var prop = schemaForm.schema.properties[item.field];
        item.filters = [{
            type: 'lookup',
            condition: uiGridConstants.filter.CONTAINS,
            placeholder: '',
            kind: 'string',
            schema: prop,
            join: {
                column: prop.entity_id,
                value: 't.' + prop.title + ' = ' + prop.entity_id + '.id',
                relation: 'JOIN',
                kind: ''
            }
        }];
        var lookup = record.lookup[item.field];
        lookup.field = item.field;
        item.field = item.field + '_obj.model.description';
        lookupCols.push(lookup); 
    };

    this.getBooleanCol = function(msg, item){
        var options = [{
            value: 'S',
            label: msg.yes
        }, {
            value: 'N',
            label: msg.no
        }];
        item.filter = { 
            type: uiGridConstants.filter.SELECT
        };
        item.editDropdownOptionsArray = options;
        item.filter.selectOptions = options.map(function(obj) { 
            var rObj = {'value': obj.value, 'label': obj.label};
            return rObj;
        });
        item.cellTemplate = '<div class="ui-grid-cell-contents"><span ng-if="row.entity.' + item.field + '===\'S\'" >Sì</span><span ng-if="row.entity.' + item.field + '!==\'S\'" >No</span></div>'
    };

    this.getEditCol = function(){
        var item = {
            displayName: '',
            field: 'id',
            width: 34,
            enableCellEdit: false,
            enableFiltering: false,
            enableSorting: false,
            cellTemplate:
            '<div class="ui-grid-cell-contents" style="text-align: center">' +
                '<button ng-click="grid.appScope.viewDetail(row.entity)" class="btn btn-xs btn-primary">' +
                '<span class="fa fa-search"></span>' +
                '</button>' +
            '</div>'
        };
        return item;
    };

    this.getEnumCol = function(schemaForm, item){
        var _this = this;
        var options = _this.getTitleMap(schemaForm, item.field);
        item.filter = { 
            type: uiGridConstants.filter.SELECT
        };
        item.editDropdownOptionsArray = options;
        item.filter.selectOptions = options.map(function(obj) { 
            var rObj = {'value': obj.value, 'name': obj.label};
            return rObj;
        });
        item.cellTemplate = '<div class="ui-grid-cell-contents">';
        options.forEach(function(opt){
            item.cellTemplate += '<span ng-if="row.entity.' + item.field + '===\'' + opt.value + '\'" >' + opt.name + '</span>';
        });
        item.cellTemplate += '</div>';
    };

    this.getDateCol = function(schemaForm, item){
        var _this = this;
        item.filters = [
            {
                type: 'date',
                relation: '>=',
                placeholder: 'da...',
                kind: 'date',
                condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
            },
            {
                type: 'date',
                relation: '<=',
                placeholder: 'a...',
                kind: 'date',
                condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
            }
        ];
        var format = _this.getDateFormat(schemaForm, item.field);
        item.cellTemplate = '<div class="ui-grid-cell-contents">{{ row.entity.' + item.field + ' | date:\'' + format +  '\' }}</div>'
    };

    this.getColumnDefinitions = function(schemaForm, viewGridOptions, record, lookupCols){
        var _this = this;
        viewGridOptions.columnDefs = [];
        viewGridOptions.columnDefs.push(_this.getEditCol());
        schemaForm.columnDefs.forEach(function(item) {
            item.enableFiltering = _this.getEnableFiltering(schemaForm, item);
            item.filters = [{
                type: 'text',
                condition: uiGridConstants.filter.CONTAINS,
                placeholder: '',
                kind: 'string'
            }];
            if(record.lookup[item.field]){
                _this.getLookupCol(schemaForm, record, lookupCols, item);
            }
            else if(_this.isDate(schemaForm, item.field)){
                _this.getDateCol(schemaForm, item);
            }
            else if(_this.isBoolean(schemaForm, item.field)){
                _this.getBooleanCol(msg, item);
            }
            else if(_this.isEnum(schemaForm, item.field)){
                _this.getEnumCol(schemaForm, item);
            }
            viewGridOptions.columnDefs.push(item)
        });
    };

    $rootScope.$on('$translateRefreshEnd', function () {
        localeFactory.translateMsg(msg);
    });

  });
'use strict';

/**
 * @ngdoc factory
 * @name emma.theme.pipeConfigurationTree
 * @description
 * # pipeConfigurationTree
 * Service in the emma.theme.
 */
angular.module('ictportal.theme')
  .service('pipeConfigurationTree', function () {

    var pipeConfigurationTree = {
      treeIdToConfig : {
        list: []
      },
      treeObjToConfig: {
        list: []
      }
    };

    pipeConfigurationTree.pushTreeIdToConfig = function (id) {
        this.treeIdToConfig.list.push(id);
    };

    pipeConfigurationTree.popTreeIdToConfig = function () {
      return this.treeIdToConfig.list.pop();
    };



    pipeConfigurationTree.pushTreeObjToConfig = function (obj) {
      this.treeObjToConfig.list.push(obj);
    };

    pipeConfigurationTree.popTreeObjToConfig = function () {
      return this.treeObjToConfig.list.pop();
    };

    return pipeConfigurationTree;
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.sessionFactory
 * @description
 * # sessionFactory
 * Factory in the emma.theme.
 */
angular.module('ictportal.theme')
  .factory('sessionFactory', function ($rootScope, $log) {

    var sessionFactory = {
      sessionData: {}
    };

    sessionFactory.setSessionData = function (sessionData) {
      this.sessionData = {
        currentDate: sessionData.currentDate
      };
      $log.info(sessionData.currentDate);
      $rootScope.$broadcast('sessionChanged');
    };

    sessionFactory.getSessionData = function () {
      return this.sessionData;
    };

    return sessionFactory;
  });

'use strict';

/**
 * @author Rita Beltrami 
 * @ngdoc service
 * @name emma.theme.sixFrameFactory
 * @description
 * # sixFrameFactory
 * Handles retrival of six jsf frame url.
 */
angular.module('ictportal.theme')
  .factory('sixFrameFactory', function (authFactory, localStorageService, $routeParams, APP_URL, $location) {

    var sixFrameFactory = {};

    function random(seed) {
        var x = Math.sin(seed) * 10000;
        return x - Math.floor(x);
    }

    function pseudoguid() {
      return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() +S4()).toLowerCase();
    }

    function S4(seed) {
      if (!seed) seed = (new Date()).getSeconds();
      // Chiedere esattamente a Ste a cosa serve.
      // Ste ha detto che serviva per risolvere problemi di refresh alle pagine. In realtà ne dava più di quelli che risolveva.
      //return (((1 + random(seed)) * 0x10000) | 0).toString(16).substring(1);
      return 1;
    }

    sixFrameFactory.getJsfURL = function (jsfurl) {
        if (authFactory.getAuthData() == null) {
            console.log('JsfCtrl auth data null');
            return '';
        }
        if (jsfurl != null) {
            return jsfurl;
        }

        //me lo salvo per rilevare un cambio di profilo e richiamare la loginPortal e ri-inizializzare lo UserLoginController su six
        var previousProfile = localStorageService.get('jsf.previousProfile');

        var params = '?username=' + authFactory.getAuthData().authId + '';
        var changedProfile = !(previousProfile && (previousProfile.items.length == 0 || (
            previousProfile.items.length != 0 && authFactory.getAuthData().profile.items != 0 && JSON.stringify(previousProfile.items[0].cod) === JSON.stringify(authFactory.getAuthData().profile.items[0].cod))));
        if (changedProfile) {
            console.log('changed profile');
        }
        if ($routeParams.functionCode && !changedProfile) {
            params = params + '&functionCode=' + $routeParams.functionCode;
            if($routeParams.selectedId) {
                params = params + '&selectedId=' + $routeParams.selectedId;
            }
            if($routeParams.code) {
                params = params + '&code=' + $routeParams.code;
            }
            $location.search('t', S4()); // Da lasciare assolutamente, altrimenti si creano inspiegabili problemi alla navigazione (se esco da una jsf, ho problemi a rientrare).
            jsfurl = APP_URL + params;
        } else if ($routeParams.nextPage && !changedProfile) {
            params = params + '&nextPage=' + $routeParams.nextPage;
            jsfurl = APP_URL + params;
        } else {
            params = params + 'home';
            var parser = document.createElement('a');///fixme: ??
            parser.href = APP_URL;

            var authData = authFactory.getAuthData();

            var workstation = localStorageService.get('workstation');

            var url = APP_URL +
                    '/loginPortal.jsp?authId=' + authData.authId +
                    '&authToken=' + authData.authToken +
                    '&functionCode=' + //sbianco
                    '&selectedId=' +   
                    '&code=' +   
                    (workstation == null ? '' : '&workstation=' + workstation) +
                    (authData.profile ? '&azCod=' + authData.profile.cod : '') +
                    (authData.profile.items.length != 0 && authData.profile.items[0].cod ? '&divCod=' + authData.profile.items[0].cod : '')
                ;
            console.log(url);
            jsfurl = url;
            localStorageService.set('jsf.previousProfile', authData.profile);
        }
        return jsfurl;
    };

    return sixFrameFactory;
  });

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.wsfactory
 * @description
 * # wsfactory
 * Factory in the emma.theme.
 */
angular.module('ictportal.theme')
  .factory('wsfactory', function (APP_URL, $websocket, $rootScope) {
    //var dataStream = $websocket('ws://'+APP_URL.split('http://')[1]+'/testendpoint');
    //var dataStream = $websocket('ws://localhost:8080/six/testendpoint');
    var dataStreamArray = []; // {url: , dataStream: }
//dataStream.filter(function(e) { return e.url=='fsfdf' }).shift();

    var collection = [];

    var connect = function (url) {
      var dataStream = getDataStreamByUrl(url);
      if (!isConnected(dataStream)) {
        if (dataStream) {
          // rimuovo dataStream scaduto
          var index = dataStreamArray.indexOf({url: url, dataStream: dataStream});
          dataStreamArray.splice(index, 1);
        }
        dataStream = $websocket(url);
        dataStreamArray.push({url: url, dataStream: dataStream});
        dataStream.onMessage(function (message) {
          var bodyJson = JSON.parse(message.data);
          // Notifiche
          if (bodyJson.type == 'notifymessage') {
            bodyJson.action = 'templateDialog';
            $rootScope.$broadcast('notification:push', bodyJson);
          }
          else {
            collection.push(bodyJson);
            $rootScope.$broadcast('wsfactory:newMessage', message.data);
          }
        });
      }
    };

    var disconnect = function(url){
      var dataStream = getDataStreamByUrl(url);
      if(dataStream){
        dataStream.close();
      }
    };

    var sendMessage = function(url, jsonMessage){
      var dataStream = getDataStreamByUrl(url);
      if(dataStream){
        dataStream.send(JSON.stringify(jsonMessage));
      }
    };

    var isConnected = function(dataStream){
      var result = angular.isDefined(dataStream) && angular.isDefined(dataStream.socket) && (dataStream.socket.readyState===1);
      return result;
    };

    var getDataStreamByUrl = function(url) {
      // Cerco websocket dato url 
      var data = dataStreamArray.filter(function(e) { return e.url == url }).shift();
      if (data) {
        return data.dataStream;
      }
      return undefined;
    }

    var methods = {
      collection: collection,
      get: function (url) {
        var dataStream = getDataStreamByUrl(url);
        dataStream.send(JSON.stringify({ action: 'get' }));
      },
      open: connect,
      send: sendMessage,
      close: disconnect
    };

    return methods;
  });
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:SysinfoCtrl
 * @description
 * # SysinfoCtrl
 * Controller of the emma.theme
 */
angular.module('ictportal.theme')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/adminchiam', {  // retrocompatibilità
        templateUrl: 'theme/sysinfo/sysinfo.html',
        controller: 'SysinfoCtrl'
      })
      .when('/sysinfo', {
        templateUrl: 'theme/sysinfo/sysinfo.html',
        controller: 'SysinfoCtrl'
      })
  })
  .controller('SysinfoCtrl', function (APP_URL, $scope, authFactory, $routeParams, baseFactory, sysinfoFactory,
                                          errorService, dialogService, toaster, moduleInfoFactory, $http, $log, loadingBarService,
                                          localStorageService) {

    $scope.modelType = {};
    $scope.params = {};
    $scope.messages = [];
    $scope.calls = [];

    $scope.advancedStatus = {open: false};

    $scope.selected = {};
    $scope.selected.httpAction = {key: 'get', description: 'GET'};
    $scope.selected.module = {key: 'six', description: 'six'};

    $scope.httpActionsList = [
      {key: 'get', description: 'GET'},
      {key: 'post', description: 'POST'},
      {key: 'put', description: 'PUT'},
      {key: 'delete', description: 'DELETE'}
    ];

    $scope.modulesList = [
      {key: 'six', description: 'six'}
    ];

    $scope.path = { path: '' };

    $scope.go = function() {
      $log.debug('Esecuzione di ' + $scope.path.path);
      // dialogService.pushLoading($scope.path.path + '...');
      loadingBarService.start($scope.path.path + ' ...');

      var call = {
        module: angular.copy($scope.selected.module.key),
        path: angular.copy($scope.path.path),
        start: new Date(),
        end: '-'
      };
      $scope.calls.push(call);

      var promise;
      switch($scope.selected.httpAction.key) {
        case 'get':
          promise = sysinfoFactory($scope.selected.module.key, $scope.path.path).get().$promise;
          break;
        case 'post':
          promise = sysinfoFactory($scope.selected.module.key, $scope.path.path).post().$promise;
          break;
        case 'put':
          promise = sysinfoFactory($scope.selected.module.key, $scope.path.path).put().$promise;
          break;
        case 'delete':
          promise = sysinfoFactory($scope.selected.module.key, $scope.path.path).delete().$promise;
          break;
        default:
          promise = sysinfoFactory($scope.selected.module.key, $scope.path.path).get().$promise;
          break;
      }

      promise.then(function(response) {
        call.end = new Date();
        call.duration = call.end.getTime() - call.start.getTime();
        call.status = 'OK';
        call.response = response;
        $scope.response = response;
        $scope.messages = response.messages;

        if(!isServiceResponseObject($scope.response)) {
          if(response.status === 'ok') {
            toaster.pop('success', 'Eseguito', 'Eseguito con successo');
          } else {
            var msg = '';
            if(angular.isDefined($scope.messages) === true && angular.isArray($scope.messages) === true) {
              msg = 'Problemi rilevati: ' + $scope.messages.length;
            } else {
              msg = 'La richiesta potrebbe essere andata in timeout: controllare i log del server';
            }
            toaster.pop('warning', 'Attenzione', msg);
          }
        }

        loadingBarService.stop(response, $scope.path.path + ': messaggi');
      }).catch(function(error) {
        // error
        call.end = new Date();
        call.duration = call.end.getTime() - call.start.getTime();
        call.status = 'ERROR';
        $log.error('Impossibile completare l\'operazione ' + $scope.path.path, error);
        loadingBarService.stop();
        toaster.pop('error', 'Errore', 'Impossibile completare l\'operazione ' + $scope.path.path);
      });
    };

    $scope.$watchCollection('selected', function(newVal, oldVal) {
      buildPath();
    });

    $scope.$watch('params.path', function(newVal, oldVal) {
      buildPath();
    });

    $scope.$watch('params.query', function(newVal, oldVal) {
      buildPath();
    });

    function buildPath() {
      $scope.path.path = '';

      if($scope.params.path) {
        $scope.path.path += '/' + $scope.params.path;
      }
      if($scope.params.query) {
        $scope.path.path += '?' + $scope.params.query;
      }
    }

    $scope.showResponse = function(response) {
      dialogService.serviceResponse('Esito', response);
    };

    function isServiceResponseObject(response) {
      return angular.isDefined(response) && response !== null && angular.isObject(response)
        && response.hasOwnProperty('status')
        && response.hasOwnProperty('result')
        && response.hasOwnProperty('messages')
        && response.hasOwnProperty('hasErrors')
        && response.hasOwnProperty('hasWarnings');
    }


    // VERSIONING

    $scope.frontEndInfo = {};

    $scope.loadFrontEndInfo = function() {
      $scope.frontEndInfo = {
        title: 'ICT FrontEnd',
        vendor: 'it.ictgroup',
        version: '-',
        revision: '-',
        builddate: '-',
        builprofile: '-',
        cipipelineid: '-',
        cibuildid: '-'
      };
      $http.get('manifest.json').then(
        function(response) {    // success
          if(!response.status || response.status == 200) {
            $scope.frontEndInfo = response.data;
            getModuleInfo($scope.frontEndInfo.installedmodules);
          }
        }
      );
    };

    $scope.modulesInfo = {};

    function getModuleInfo(modules) {
      modules.forEach(function(module) {
        var api = 'api';
        if(module == 'six') { api = 'rest'; }
        moduleInfoFactory(module, api).info().$promise.then(function(response) {
          $scope.modulesInfo[module] = response;
        });
      });
    }

    $scope.showDepsVersion = function(module) {
      var dialogScope = {
        info: module
      };
      var opts = {
        name: 'moduleDepsInfosDialog',
        closeByDocument: true,
        plain: false
      };
      dialogService.templateDialog('moduleDepsInfos.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false, '500px');
    };

    $scope.loadFrontEndInfo();
  });


'use strict';

// Default:
// {
//   'get':    {method:'GET'},
//   'save':   {method:'POST'},
//   'query':  {method:'GET', isArray:true},
//   'remove': {method:'DELETE'},
//   'delete': {method:'DELETE'}
// }

/**
 * @ngdoc service
 * @name emma.theme.baseFactory
 * @description
 * # baseFactory
 * Factory in the emma.theme.
 */
angular.module('ictportal.theme')
  .factory('sysinfoFactory', function (APP_URL, ENERGY_URL, DATA_SET_URL, PLAN_URL, CONSIP_URL, $resource) {
    return function(module, resource) {
      var base;
      switch(module) {
        case 'six-data-set':
          base = DATA_SET_URL+'/api';
          break;
        case 'six-energy':
          base = ENERGY_URL+'/api';
          break;
        case 'six-plan':
          base = PLAN_URL+'/api';
          break;
        case 'six-consip':
          base = CONSIP_URL+'/api';
          break;
        default:
          base: APP_URL+'/rest';
      }
      return $resource(base+'/'+resource+'/:verb/:p1/:p2/:p3/:p4/:p5/:p6', {}, {
        get:    {method: 'GET',     isArray: false},
        post:   {method: 'POST',    isArray: false},
        put:    {method: 'PUT',     isArray: false},
        delete: {method: 'DELETE',  isArray: false}
      });
    };
  });

/**
 * Created by stefano on 15/12/16.
 */

angular.module('emma.consip')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/test', {
        templateUrl: 'theme/test/test.html',
        controller: 'TestCtrl'
      })
  })
  .controller('TestCtrl', function ($scope, $routeParams, $timeout, recordFactory, $q, errorService, $log) {

    $scope.model = {};




    $scope.form = [
      {
        "type": "fieldset",
        "items": [
          {
            "tabs": [
              {
                "title": "Dati Base",
                "items": [
                  {
                    "title": "Codice",
                    "type": "text",
                    "key": [
                      "code"
                    ],
                    "required": true
                  },
                  {
                    "title": "Descrizione",
                    "type": "text",
                    "key": [
                      "description"
                    ],
                    "validationMessage": {
                      "unique": "Non univoco"
                    },
                    "$asyncValidators": {
                      "unique": function(value) {
                        var deferred = $q.defer();
                        recordFactory('edificio').unique({param1: 'model.description', param2: value}).$promise.then(function (resp) {
                          if (errorService.handleError(resp)) {
                            if (resp.result == true) {
                              $log.log(value + ' unique');
                              deferred.resolve();
                            } else {
                              $log.log(value + ' NOT unique');
                              deferred.reject();
                            }
                          } else {
                            $log.log('error');
                            deferred.resolve();
                          }
                        });
                        return deferred.promise;
                      }
                    },
                    "required": true
                  }
                ]
              },
              {
                "title": "Dati Funzionamento",
                "items": [
                  {
                    "title": "Codice",
                    "type": "text",
                    "key": [
                      "code"
                    ],
                    "required": true
                  },
                  {
                    "title": "Descrizione",
                    "type": "text",
                    "key": [
                      "description"
                    ],
                    "required": true
                  }
                ]
              }
            ],
            "type": "tabs"
          }
        ]
      }
    ];




    $scope.schema = {
        "type": "object",
        "title": "",
        "properties": {
          "code": {
            "check": true,
            "title": "Codice",
            "type": "string"
          },
          "description": {
            "check": true,
            "title": "Descrizione",
            "type": "string"
          }
        },
        "required": [
          "code",
          "description"
        ]
      };
  });

/**
 * Created by Rita on 20/07/17.
 */

angular.module('ictportal.theme')
.config(function ($routeProvider) {
    $routeProvider
        .when('/touchmenu', {
            templateUrl: 'theme/touchmenu/touchmenu.html',
            controller: 'TouchMenuCtrl'
        })
})
.controller('TouchMenuCtrl', function ($scope, $routeParams, $log, authFactory, sixFrameFactory, $location, localeFactory) {

    $scope.jsfurl = null;
    $scope.menu = [];  
    $scope.history = [];
    var authData = undefined;

    $scope.getJsfURL = function () {
        return sixFrameFactory.getJsfURL($scope.jsfurl);
    };

    $scope.goBack = function(){
        authData.navigation.pop();
        // Torno al menu principale
        $scope.openMainMenu();
    };

    $scope.goToBookmarks = function(){
        authFactory.clearNavigation();
        $location.path('bookmarks');
    };

    $scope.openSubmenu = function(menuItem){
        setMenu(menuItem.children);
        authData.navigation.push({
            root: 'touchmenu',
            menuItem: menuItem,
            menuItemsList: $scope.menu.slice(0)
        });
        updateHistory();
    };

    function setMenu(menuItemsList){
        $scope.menu.length = 0;
        $scope.menu = $scope.menu.concat(menuItemsList);
    };

    $scope.openMainMenu = function(){
        setMenu(authFactory.getAuthData().menu);
        authFactory.clearNavigation();
        authData.navigation.push({
            root: 'touchmenu',
            menuItem: undefined,
            menuItemsList: authFactory.getAuthData().menu
        });
        updateHistory();
    };

    function updateHistory(){
        $scope.history.length = 0;
        authData.navigation.forEach(function(item){
            $scope.history.push(item);
        });
    };

    function init(){
        authData = authFactory.getAuthData();
        if(authData){ 
            if(authData.navigation.length>0){
                var lastNav = authData.navigation[authData.navigation.length-1];
                if(lastNav.menuItem){
                    for(var i=0; i<(authData.navigation.length); i++){
                        $scope.history.push(authData.navigation[i].menuItem);
                    }
                    setMenu(lastNav.menuItemsList);
                }
                else{
                    $scope.openMainMenu();
                }
            }
            else{
                $scope.openMainMenu();
            }
        }
    };

    init();
});
angular.module('ictportal.theme')
.config(['$translateProvider', function ($translateProvider) {

    $translateProvider.useLoader('$translatePartialLoader', {
        urlTemplate: '/translation/{lang}/{part}.json'
    });
   
    $translateProvider.useSanitizeValueStrategy('escape');
    $translateProvider.useLocalStorage();
    $translateProvider.fallbackLanguage('en');
    $translateProvider.preferredLanguage('en');
  }]);
/**
 * @ngdoc function
 * @name ictportal.tnt.controller:TntCheckInCtrl
 * @description Check-in TNT (SIX-3240)
 * @author Rita Beltrami
 * 
 * @param è possibile specificare un parametro "code" che fissa una specifica customer destination
 * @param è possibile specificare un parametro "chooseDest" per consentire all'operatore di scegliere una destinazione
 * 
 * created on 15/05/2018
 * # TntCheckInCtrl
 * Controller of the ictportal.tnt
 */
angular.module('ictportal.tnt')
.config(function ($routeProvider) {
    $routeProvider
        .when('/tnt/checkin', {
            templateUrl: 'tnt/check-in/check-in.html',
            controller: 'TntCheckInCtrl'
        })
        .when('/tnt/checkin/:code', {
            templateUrl: 'tnt/check-in/check-in.html',
            controller: 'TntCheckInCtrl'
        })
        .when('/tnt/checkin/:chooseDest', {
            templateUrl: 'tnt/check-in/check-in.html',
            controller: 'TntCheckInCtrl'
        })
})
.controller('TntCheckInCtrl', function ($scope, recordFactory, $routeParams, $location,
    toaster, dbFilterFactory, localeFactory, eggsFormFactory,
    authFactory, checkInFactory, $q, COMPONENT_READ_MODE,
    uiGridConstants, matrixParFactory, workflowFactory) {

    var portalBundle = 'portal';
    var pageBundle = 'check_in';
    var todaySql = "'" + getTimestamp(new Date()) + "'";
    $scope.element = {};
    $scope.settings = {
        canRead: false,
        isSaving: false,
        idDestinationReadonly: false,
        manualMode: false,
        amount: 1,
        consumeAllBox: false,
        kitBasicFilter: [{
            column: 'bom b',
            value: 't.bom_id = b.id',
            relation: 'JOIN',
            kind: 'b.item_id'
        }]
    };
    $scope.readerMode = COMPONENT_READ_MODE.BARCODE;
    $scope.chooseDest = true;
    var shipmentDestId = undefined;
    var msg = {
        error: 'Error',
        operation_completed: "Operation completed",
        operation_completed_success: "Operation successfully completed",
        server_comunication_error: "Server communication error",
        product: 'Product',
        barcode: 'Barcode',
        quantity: 'Quantity',
        date: 'Date'
    };
    var page_msg = {
        MISSING_BARCODE: "Barcode not found",
        MISSING_CUSTOMER_DESTINATION: "Customer destination not found",
        PROCESSING_ERROR: "Error during check in",
        SERIAL_KIT_NOT_FOUND: "Serial kit not found",
        WRONG_DESTINATION: "Wrong customer destination",
        SERIAL_KIT_EXPIRED: "Expired serial kit",
        CONTROL_REASON_NOT_FOUND: "Control reason not found",
        CONSUMED_KIT: "Serial kit already consumed",
        WRONG_KIT_STATUS: "Wrong serial kit status",
        CHECK_IN_AMOUNT_ERROR: "Checked in amount higher than box quantity",
        customer_cost_center: "Customer cost center",
        quantity_left: "Quantity left",
        operation_date: "Operation date",
        box_completed: "Box empty for barcode \"{{barcode}}\"",
        product_group_not_found: "Product group for disposable products not found",
        MISSING_QUANTITY: "Missing quantity"
    };
    var customerLookupChange = false;
    var customerDestinationLookupChange = false;
    var authData = authFactory.getAuthData();
    $scope.record = {
        lookup: {},
        dates: [],
        model: {}
    };
    $scope.viewGridOptions = {
        enableSorting: true,
        appScopeProvider: $scope,
        enableFiltering: false,
        enableGridMenu: true,
        exporterMenuPdf: false,
        paginationPageSize: 20,
        useExternalPagination: true,
        data: [],
        columnDefs: [],
        onRegisterApi: onRegisterApiCallback
    };
    var dateTimeFormat = localeFactory.getDateTimeFormat();
    $scope.failedGridOptions = {
        enableSorting: true,
        appScopeProvider: $scope,
        enableFiltering: false,
        enableGridMenu: false,
        exporterMenuPdf: false,
        expandableRowHeight: 100,
        paginationPageSize: 10000,
        enablePaginationControls: false,
        useExternalPagination: true,
        data: [],
        columnDefs:[{
            field: 'barcode',
            displayName: 'Barcode',
            cellTemplate: '<div class="bg-danger"><div class="ui-grid-cell-contents">{{ row.entity.barcode }}</div></div>',
            headerCellFilter: 'translate'
        },{
            field: 'envelope',
            displayName: 'Cartone',
            cellTemplate: '<div class="bg-danger"><div class="ui-grid-cell-contents">{{ row.entity.envelope }}</div></div>',
            headerCellFilter: 'translate'
        },{
            field: 'kit_product',
            displayName: 'Articolo',
            cellTemplate: '<div class="bg-danger"><div class="ui-grid-cell-contents">{{ row.entity.product_code }} - {{ row.entity.product_des }}</div></div>',
            headerCellFilter: 'translate'
        },{
            field: 'customer_cost_center',
            displayName: 'Centro di costo cliente',
            cellTemplate: '<div class="bg-danger"><div class="ui-grid-cell-contents">{{ row.entity.customer_cost_center.code }} - {{ row.entity.customer_cost_center.description }}</div></div>',
            headerCellFilter: 'translate'
        },{
            field: 'operation_date',
            displayName: 'Data operazione',
            cellTemplate: '<div class="bg-danger"><div class="ui-grid-cell-contents">{{ row.entity.operation_date | date:\'' + dateTimeFormat + '\' }}</div></div>',
            headerCellFilter: 'translate'
        }],
        onRegisterApi: onRegisterApiCallback
    };
    $scope.customerDestinationFilter = [];
    $scope.customerFilter = [];
    $scope.cdcFilter = dbFilterFactory.getCustomFilter(' (t.validity_end IS NULL OR t.validity_end>' + todaySql + ')')
        .concat(authData.filters.customer_cost_center);
    $scope.productFilter = [];
    $scope.serialKitFilter = [];

    function onRegisterApiCallback(gridApi) {
        $scope.gridApi = gridApi;
    }

    $scope.resetData = function () {
        $scope.viewGridOptions.data.length = 0;
        $scope.settings.serial_kit_id = undefined;
        $scope.record.lookup.serial_kit_id.obj = {};
        $scope.settings.canRead = false;
        $scope.customerFilter.length = 0;
        $scope.cdcFilter.length = 0;
        $scope.cdcFilter = $scope.cdcFilter.concat(dbFilterFactory.getCustomFilter(' (t.validity_end IS NULL OR t.validity_end>' + todaySql + ')'))
            .concat(authData.filters.customer_cost_center);
        $scope.customerFilter = $scope.customerFilter.concat(getCustomerImplicitFilters());
        $scope.customerDestinationFilter.length = 0;
        $scope.customerDestinationFilter = $scope.customerDestinationFilter.concat(getCustomerDestinationImplicitFilters());
        $scope.serialKitFilter.length = 0;
        // Stefy: "Se nelle destinazioni dell'utente ho 1 solo reparto devo comunque sceglierlo. Dato che è uno tanto vale sceglierlo già in partenza"
        if (authData.info.authorizations.destinations.length == 1) {
            $scope.settings.idDestinationReadonly = true;
            $scope.record.model.customer_destination_id = authData.info.authorizations.destinations[0];
            $scope.record.model.customer_id = authData.info.authorizations.customers[0];
            eggsFormFactory.loadLookupData($scope.record.lookup, $scope.record.model);
        }
    }

    function initLookups() {
        eggsFormFactory.addLookup($scope.record.lookup, 'customer_id', 'customer', 'code', 'description');
        eggsFormFactory.addLookup($scope.record.lookup, 'customer_destination_id', 'customer_destination', 'code', 'description');
        eggsFormFactory.addLookup($scope.record.lookup, 'customer_cost_center_id', 'customer_cost_center', 'code', 'description');
        eggsFormFactory.addLookup($scope.record.lookup, 'product_id', 'product', 'code', 'description');
        eggsFormFactory.addLookup($scope.record.lookup, 'serial_kit_id', 'serial_kit', 'barcode', 'barcode');
    }

    function getCustomerImplicitFilters() {
        var filter = authData.filters.customer;
        return filter;
    }

    function getCustomerDestinationImplicitFilters() {
        var filter = authData.filters.customer_destination;
        // [SIX-3503] al fine di consentire check-in direttamente in guardaroba, viene rilassato il filtro sulle destinazioni ammesse
        //filter = filter.concat(dbFilterFactory.getNullableFilter('parent', 'IS NOT NULL')); // al filtro implicito, aggiungo il fatto che posso vedere SOLO reparti
        return filter;
    }

    $scope.onCustomerSelectCallback = function () {
        customerLookupChange = true;
    }

    $scope.onCustomerDestinationSelectCallback = function () {
        customerDestinationLookupChange = true;
    }

    function getTimestamp(day) {
        var m = (day.getMonth() + 1);
        var mStr = (m < 10) ? ('0' + m.toString()) : m.toString();
        var d = (day.getDate());
        var dStr = (d < 10) ? ('0' + d.toString()) : d.toString();
        var timestamp = day.getFullYear() + '-' + mStr + '-' + dStr;
        return timestamp;
    }

    $scope.$watch('record.lookup.customer_id.obj', function (newValue, oldValue) {
        if (newValue && newValue.id) {
            $scope.cdcFilter.length = 0;
            $scope.cdcFilter = $scope.cdcFilter.concat(dbFilterFactory.getCustomFilter("(t.customer_id = " + newValue.id + " OR t.customer_id is null)"))
                .concat(dbFilterFactory.getCustomFilter(' (t.validity_end IS NULL OR t.validity_end>' + todaySql + ')'))
                .concat(authData.filters.customer_cost_center);
            $scope.customerDestinationFilter.length = 0;
            $scope.customerDestinationFilter = $scope.customerDestinationFilter.concat(getCustomerDestinationImplicitFilters());
            $scope.customerDestinationFilter = $scope.customerDestinationFilter.concat(dbFilterFactory.getNumberFilter('customer_id', newValue.id));
            recordFactory('customer_destination').filter({ page_size: 10000 }, dbFilterFactory.getNumberFilter('customer_id', newValue.id)).$promise
            .then(function (data) {
                if (data.totalResults === 1) {
                    $scope.record.model.customer_destination_id = data.list[0].id;
                    $scope.record.lookup.customer_destination_id.obj = data.list[0];
                }
            })
            .catch(function (ex) { });
        }
        else {
            $scope.record.model.customer_destination_id = undefined;
            $scope.record.lookup.customer_destination_id.obj = {};
            $scope.customerDestinationFilter.length = 0;
            $scope.customerDestinationFilter = $scope.customerDestinationFilter.concat(getCustomerDestinationImplicitFilters());
            $scope.settings.canRead = false;
        }
    })

    $scope.$watch('record.lookup.customer_destination_id.obj', function (newValue, oldValue) {
        // Se hanno selezionato una destinazione, carico in automatico l'ospedale
        if (customerDestinationLookupChange) {
            customerDestinationLookupChange = false;
            if (newValue && newValue.id) {
                recordFactory('customer').byId({ id: newValue.customer_id }).$promise
                .then(function (data) {
                    $scope.record.model.customer_id = data.id;
                    $scope.record.lookup.customer_id.obj = data;
                })
                .catch(function (ex) {
                    console.error(ex);
                });
            }
            else {
                $scope.resetData();
            }
        }
        if ($scope.record.lookup.customer_destination_id && $scope.record.lookup.customer_destination_id.obj && $scope.record.lookup.customer_destination_id.obj.id) {
            $scope.settings.canRead = true;
        }
    })

    $scope.$watch('record.lookup.customer_cost_center_id.obj', function (newValue, oldValue) {
        if (newValue && newValue.id) {
            if (newValue.customer_id) {
                recordFactory('customer').byId({ id: newValue.customer_id }).$promise
                .then(function (data) {
                    $scope.record.model.customer_id = data.id;
                    $scope.record.lookup.customer_id.obj = data;
                })
                .catch(function (ex) {
                    console.error(ex);
                });
            }
            if (!$scope.chooseDest) {
                $scope.settings.canRead = true;
            }
        } else {
            if (!$scope.chooseDest) {
                $scope.settings.canRead = false;
            }
        }
    })

    function fetchShipmentDest(barcode) {
        var deferred = $q.defer();
        // se l'operatore non può scegliere la destinazione recupero quella di spedizione sul kit
        if (!$scope.chooseDest && !shipmentDestId) {
            recordFactory('serial_kit').filter({}, dbFilterFactory.getStringFilter('barcode', barcode)).$promise
            .then(function (data) {
                if (data.totalResults >= 0) {
                    shipmentDestId = data.list[0].shipment_destination;
                    deferred.resolve();
                }
                else {
                    toaster.pop('error', msg.error, page_msg.SERIAL_KIT_NOT_FOUND);
                }
            })
            .catch(function (ex) {
                console.error(ex);
                toaster.pop('error', msg.error, page_msg.server_comunication_error);
            });
        } else {
            deferred.resolve();
        }

        return deferred.promise;
    }

    function loadFailed(barcode, errors) {
        var filters = [{
            column: 'bom b',
            value: 't.bom_id = b.id',
            relation: 'JOIN'
        },{
            column: 'product p',
            value: 'b.item_id = p.id',
            relation: 'JOIN',
            kind: 'p.code AS product_code, p.description AS product_des'
        }];
        filters = filters.concat(dbFilterFactory.getStringFilter('barcode', barcode));
        recordFactory('serial_kit').filter({}, filters).$promise
        .then(function (data) {
            if (data && data.list.length > 0) {
                var rowData = data.list[0];
                rowData.customer_cost_center = {
                    code: $scope.record.lookup.customer_cost_center_id.obj.code,
                    description: $scope.record.lookup.customer_cost_center_id.obj.description
                };
                rowData.operation_date = new Date();
                rowData.subGridOptions = {
                    columnDefs: [{
                        name: "Errori",
                        field: "error",
                        translation: 'errors',
                        enableFiltering: false
                    }],
                    data: errors ? errors.map(function(e){return {error: e};}) : null,
                    disableRowExpandable: !errors || errors.length == 0,
                    minRowsToShow: 1
                };
                $scope.failedGridOptions.data.unshift(rowData);
                if ($scope.gridApi) {
                    $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ROW);
                }
            }
        });
    }

    /**
     * Funzione che effettua il check-in vero e proprio
     * @param {*} barcode  Barcode di scatola del kit
     * @param {*} amount Quantità di "sparate" da conteggiare
     */
    function checkInBarcode(barcode, amount, _shipmentDestId) {
        if (!$scope.settings.isSaving) {
            fetchShipmentDest(barcode).then(function () {
                $scope.settings.isSaving = true;
                var payload = angular.copy($scope.record.model);
                delete payload['customer_id'];
                payload.barcode = barcode;
                payload.quantity = amount;
                payload.customer_destination_id = _shipmentDestId;
                if ($scope.chooseDest && $scope.record.lookup.customer_destination_id.obj) {
                    payload.customer_destination_id = $scope.record.lookup.customer_destination_id.obj.id;
                }
                if (!$scope.chooseDest && shipmentDestId) {
                    payload.customer_destination_id = shipmentDestId;
                    shipmentDestId = undefined;
                }
                if ($scope.record.lookup.customer_cost_center_id.obj) {
                    payload.customer_cost_center_id = $scope.record.lookup.customer_cost_center_id.obj.id;
                }
                checkInFactory.checkInTnt({}, payload).$promise
                .then(function (data) {
                    if (data.status == 'ok') {
                        if (data.result.serial_kit.status === 'CONSUMED') {
                            localeFactory.translateReplace(pageBundle + '.box_completed', { barcode: data.result.barcode })
                            .then(function (transl) {
                                toaster.pop('warning', msg.operation_completed, transl);
                            });
                        }
                        else {
                            toaster.pop('success', msg.operation_completed, msg.operation_completed_success);
                        }
                        $scope.viewGridOptions.data.unshift(data.result);
                        if ($scope.gridApi) {
                            $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ROW);
                        }
                    }
                    else {
                        var errors = eggsFormFactory.logServerException(data, pageBundle);
                        loadFailed(barcode, errors);
                    }
                    $scope.settings.isSaving = false;
                })
                .catch(function (ex) {
                    console.error(ex);
                    $scope.settings.isSaving = false;
                    toaster.pop('error', msg.error, msg.server_comunication_error);
                });
            });
        }
    }

    /**
     * Evento scatenato alla pressione del tasto conferma.
     */
    $scope.checkInMultiple = function () {
        checkInBarcode($scope.record.lookup.serial_kit_id.obj.barcode, $scope.settings.amount);
    }

    /**
     * Evento scatenato alla lettura di un barcode
     */
    $scope.readBarcode = function (read) {
        getBarcodeType(read.read).then(function (info) {
            var type = info.type;
            shipmentDestId = info.dest_id;
            if (type === BarcodeType.SINGLE_KIT) {
                if ($scope.settings.consumeAllBox === true) {
                    checkInAllKits(info.envelope)
                } else {
                    checkInBarcode(read.read, 1)
                }
            } else if (type === BarcodeType.CARTONE_CON_KIT) {
                checkInAllKits(read.read)
            }
            //vecchia gestione
            else {
                var amount = 1; // Di default, una sparata corrisponde a una bustina
                if ($scope.settings.consumeAllBox === true) {
                    recordFactory('serial_kit').filter({}, dbFilterFactory.getStringFilter('barcode', read.read)).$promise
                    .then(function (data) {
                        if (data.totalResults >= 0) {
                            shipmentDestId = data.list[0].shipment_destination;
                            checkInBarcode(read.read, data.list[0].check_in_amount);
                        } else {
                            toaster.pop('error', msg.error, page_msg.SERIAL_KIT_NOT_FOUND);
                        }
                    })
                    .catch(function (ex) {
                        console.error(ex);
                        toaster.pop('error', msg.error, page_msg.server_comunication_error);
                    });
                } else {
                    checkInBarcode(read.read, amount);
                }
            }
        });
    }

    function fixDestination(code) {
        $scope.settings.idDestinationReadonly = true;
        recordFactory('customer_destination').filter({}, dbFilterFactory.getStringFilter('code', code)).$promise.then(function (data) {
            if (data.totalResults == 0) {
                localeFactory.translateReplace('check_in.customer_destination_not_found', { code: code }).then(function (transl) {
                    toaster.pop('error', msg.error, transl);
                });
            }
            else {
                angular.extend($scope.record.lookup.customer_destination_id.obj, data.list[0]);
                $scope.record.model.customer_destination_id = data.list[0].id;
                $scope.record.model.customer_id = data.list[0].customer_id;
                eggsFormFactory.loadLookupData($scope.record.lookup, $scope.record.model);
            }
        }).catch(function (ex) {
            console.error(ex);
            toaster.pop('error', msg.error, msg.server_comunication_error);
        });
    }

    function translateGridColumns() {
        $scope.viewGridOptions.columnDefs.forEach(function (col) {
            if (col.translation) {
                if (page_msg[col.translation]) {
                    col.displayName = page_msg[col.translation];
                    //col.name = page_msg[col.translation];
                }
                else {
                    col.displayName = msg[col.translation];
                    //col.name = msg[col.translation];
                }
            }
        });
        if ($scope.gridApi) {
            $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
        }
    }

    var initGridColumns = function () {
        $scope.lookupCols = [];
        $scope.viewGridOptions.columnDefs.push({
            name: 'Barcode',
            field: 'barcode',
            width: 140,
            cellClass: cellClassFormatter,
            translation: 'barcode'
        });
        $scope.viewGridOptions.columnDefs.push({
            name: 'Cartone',
            field: 'envelope',
            width: 140,
            cellClass: cellClassFormatter,
            translation: 'envelope'
        });
        $scope.viewGridOptions.columnDefs.push({
            name: 'Product',
            field: 'item_id',
            cellClass: cellClassFormatter,
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.item.code }} - {{ row.entity.item.description }}</div>',
            translation: 'product'
        });
        $scope.viewGridOptions.columnDefs.push({
            name: 'Customer cost center',
            field: 'customer_cost_center_id',
            cellClass: cellClassFormatter,
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.customer_cost_center.code }} - {{ row.entity.customer_cost_center.description }}</div>',
            translation: 'customer_cost_center'
        });
        $scope.viewGridOptions.columnDefs.push({
            name: "Quantity",
            field: "quantity",
            cellClass: cellClassFormatter,
            width: 100,
            translation: 'quantity'
        });
        $scope.viewGridOptions.columnDefs.push({
            name: "Quantity left",
            field: "serial_kit.check_in_amount",
            cellClass: cellClassFormatter,
            width: 100,
            translation: 'quantity_left'
        });
        $scope.viewGridOptions.columnDefs.push({
            name: "Operation date",
            field: "operation_date",
            translation: 'operation_date',
            cellClass: cellClassFormatter,
            width: 140,
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.operation_date | date:\'' + dateTimeFormat + '\' }}</div>',
        });
    }

    function cellClassFormatter(grid, row, col, rowRenderIndex, colRenderIndex) {
        var classes = '';
        if (row.entity.serial_kit.status === 'CONSUMED') {
            classes += ' warningRead';
        }
        return classes;
    }

    var BarcodeType = {
        SINGLE_KIT: 'SINGLE_KIT',
        CARTONE_CON_KIT: 'CARTONE_CON_KIT',
        SOLO_CARTONE: 'SOLO_CARTONE',
        BARCODE_NON_TROVATO: 'BARCODE_NON_TROVATO'
    }

    function getBarcodeType(barcode) {
        var defer = $q.defer();
        recordFactory('serial_kit').filter({}, dbFilterFactory.getStringFilter('barcode', barcode)).$promise
        .then(function (res) {
            if (res.list.length > 0) {
                var r = res.list[0];
                if (r.envelope === undefined || r.envelope === r.barcode) {
                    defer.resolve({ type: BarcodeType.SOLO_CARTONE, dest_id: r.shipment_destination })
                } else {
                    defer.resolve({ type: BarcodeType.SINGLE_KIT, envelope: r.envelope, dest_id: r.shipment_destination })
                }
            } else {
                recordFactory('serial_kit').filter({}, dbFilterFactory.getStringFilter('envelope', barcode)).$promise
                    .then(function (res) {
                        if (res.list.length > 0) {
                            defer.resolve({ type: BarcodeType.CARTONE_CON_KIT, dest_id: res.list[0].shipment_destination })
                        } else {
                            defer.resolve({ type: BarcodeType.BARCODE_NON_TROVATO })
                        }
                    });
            }
        });
        return defer.promise;
    }

    function checkInAllKits(envelope) {
        recordFactory('serial_kit').filter({}, dbFilterFactory.getStringFilter('envelope', envelope, "=")).$promise
        .then(function (res) {
            var kits = res.list;
            for (var i = 0; i < kits.length; i++) {
                var kit = kits[i];
                var shipmentDestId = kit.shipment_destination;
                checkInBarcode(kit.barcode, 1, shipmentDestId)
            }
        });
    }

    $scope.$watch('record.lookup.serial_kit_id.obj',
        function (newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                $scope.settings.amount = newValue.check_in_amount;
            }
        }
    )

    /**
     * Posso selezionare un barcode di kit solo dopo aver selezionato articolo e destinazione
     */
    $scope.$watchGroup(['settings.product_id', 'record.model.customer_destination_id'], function (newValue, oldValue) {
        if (newValue && oldValue && newValue[0] != oldValue[0] && newValue[1] != oldValue[1]) {
            $scope.serialKitFilter.length = 0;
            $scope.serialKitFilter = $scope.serialKitFilter.concat($scope.settings.kitBasicFilter);
            if (newValue[0] && newValue[1]) {
                $scope.serialKitFilter = $scope.serialKitFilter.concat(dbFilterFactory.getNumberFilter('b.item_id', $scope.settings.product_id));
                $scope.serialKitFilter = $scope.serialKitFilter.concat(dbFilterFactory.getNumberFilter('t.customer_destination', $scope.record.model.customer_destination_id));
            } else {
                $scope.settings.serial_kit_id = undefined;
                $scope.serialKitFilter = $scope.serialKitFilter.concat(dbFilterFactory.getNumberFilter('b.item_id', -1));
            }
            eggsFormFactory.loadLookupData($scope.settings.lookup, $scope.settings.model);
        }
    });

    $scope.toggleInsertionMode = function () {
        $scope.settings.manualMode = !$scope.settings.manualMode;
    }

    function initProductFilter() {
        matrixParFactory.getMatrixPar({ key: 'tntProductGroup', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*' }).$promise.then(function (response) {
            if (response.value) {
                var codes = response.value.trim().split(",");
                $q.all({
                    productGroups: recordFactory('product_group').filter({}, dbFilterFactory.getCustomFilter(dbFilterFactory.getOrQuery('code', codes))).$promise,
                    predecessorsStatuses: workflowFactory.getSerialKitStatusPredecessors({ param1: 'CONSUMED' }).$promise
                })
                .then(function (data) {
                    if (data.productGroups && data.productGroups.totalResults > 0) {
                        // compongo il filtro per productGroup per i product
                        var tntProductGroupIds = [];
                        data.productGroups.list.forEach(function (item) {
                            tntProductGroupIds.push(item.id);
                        });
                        $scope.productFilter.length = 0;
                        $scope.productFilter = $scope.productFilter.concat(dbFilterFactory.getCustomFilter(dbFilterFactory.getOrQuery('product_group_id', tntProductGroupIds)));
                        // compongo il filtro per stati "predecessori" per i kit ( a questo aggiungerò altri filtri )
                        if (data.predecessorsStatuses.result) {
                            var query = '';
                            data.predecessorsStatuses.result.forEach(function (s) {
                                query += " status='" + s + "' OR";
                            })
                            query = query.slice(0, -3);
                            query = '(' + query + ')';
                            $scope.settings.kitBasicFilter = $scope.settings.kitBasicFilter.concat(dbFilterFactory.getCustomFilter(query));
                        }
                    }
                    else {
                        toaster.pop("error", msg.error, page_msg.product_group_not_found);
                    }
                })
                .catch(function () { toaster.pop('error', msg.error, msg.server_comunication_error); });
            }
        }).catch(function () { toaster.pop('error', msg.error, msg.server_comunication_error); });
    }

    function checkPermissions() {
        var profilingKey = 'TNT_CHECK_IN_FUNCTION';
        var permission = authFactory.getPermissions(profilingKey);
        if (!permission.EXEC) {
            $location.path('forbidden').search({ key: profilingKey });
        }
    };

    function init() {
        initGridColumns();
        checkPermissions();
        localeFactory.loadTranslation(pageBundle)
        .then(function () {
            $q.all({
                general: localeFactory.translateMsg(msg),
                specific: localeFactory.translateMsg(page_msg, pageBundle)
            })
                .then(function (data) {
                    translateGridColumns();
                })
                .catch(function (ex) { console.error(ex); });
        })
        .catch(function (ex) { console.error(ex); });
        initLookups();
        $scope.productFilter = $scope.productFilter.concat(dbFilterFactory.getNumberFilter('product_group_id', -1));
        $scope.serialKitFilter = $scope.serialKitFilter.concat(dbFilterFactory.getNumberFilter('item_id', -1));
        initProductFilter();
        if ($routeParams.code) {
            fixDestination($routeParams.code);
        }
        if ($routeParams.chooseDest == "true" || $routeParams.chooseDest == "false") {
            $scope.chooseDest = $routeParams.chooseDest == "true";
        }
        $scope.resetData();
    }

    init();

});

'use strict';

angular.module('ictportal.tnt')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/tnt/depotstorage/list', {
        templateUrl: 'tnt/depot-storage/depot-storage-list.html',
        controller: 'DepotStorageListCtrl'
      });
  })
  .controller('DepotStorageListCtrl', function ($scope, $timeout, $routeParams, $location, $filter, localeFactory, recordFactory, eggsFormFactory, dbFilterFactory, authFactory, matrixParFactory, $q, $rootScope, $log) {

    var msg = {
      "error": "Error",
      "destination": "Customer destination",
      "inventory_date": "Inventory date",
      "op_completed_success": "Operation completed",
      "server_comunication_error": "Server communication error"
    };
    var status_msg = {
      "STERILIZED": "Sterilized",
      "SENT_WARDROBE": "Sent Wardrobe",
      "WARDROBE": "Wardrobe",
      "ACCEPTED": "Accepted",
      "LOST": "Lost",
      "INVALIDATED": "Invalidated",
      "NEW": "New",
      "SENT": "Sent",
      "CONSUMED": "Consumed"
    };
    $scope.enum = {
      status: [
        {
          name: 'Consumed',
          value: 'CONSUMED'
        },{
          name: 'Sent',
          value: 'SENT'
        },{
          name: 'New',
          value: 'NEW'
        },{
          name: 'Invalidate',
          value: 'INVALIDATED'
        },{
          name: 'Lost',
          value: 'LOST'
        },{
          name: 'Sent_wardrobe',
          value: 'SENT_WARDROBE'
        },{
          name: 'Sterilized',
          value: 'STERILIZED'
        }, {
          name: 'Wardrobe',
          value: 'WARDROBE'
        }, {
          name: 'Accepted',
          value: 'ACCEPTED'
        }
      ]
    };
    $scope.preselectSupplier = false;
    $scope.viewGridOptions = {
      enableRowSelection: true,
      enableFullRowSelection: true,
      rowSelectionChanged: viewDetail,
      enableFiltering: false,
      useExternalSorting: true,
      appScopeProvider: $scope,
      columnDefs: [
        {
          name: 'detail',
          displayName: '',
          width: 34,
          enableColumnResizing: false,
          enableColumnMenu: false,
          enableSorting: false,
          cellTemplate:
            '<div class="ui-grid-cell-contents" style="text-align: center">' +
            ' <button class="btn btn-xs btn-primary">' +
            '  <span class="fa fa-list-ul"></span>' +
            ' </button>' +
            '</div>'
        },
        {
          field: 'code',
          displayName: 'product',
          headerCellFilter: 'translate',
          width: '*'
        }, {
          field: 'description',
          displayName: 'description',
          headerCellFilter: 'translate',
          width: '**'
        }, {
          field: 'supplier_description',
          displayName: 'supplier',
          headerCellFilter: 'translate',
          width: '*'
        },
        {
          field: 'count',
          displayName: 'depot_storage.count',
          headerCellFilter: 'translate',
          width: 100
        }]
    };

    $scope.detailGridOptions = {
      paginationPageSize: 10,
      paginationPageSizes: [10, 15],
      useExternalPagination: false,
      useExternalSorting: true,
      enableFiltering: false,
      columnDefs: resetDetailGridColumns()
    };
    $scope.filters = {};
    $scope.aggs = [];

    var dateFormat = localeFactory.getDateFormat();
    var dateFilter = $filter('date');

    $scope.aggregations = [
      {
        key: 'destination',
        description: 'Destinazioni',
        fields: ['cd.code AS depot_code', 'cd.description AS depot_description', 'd.min_amount as min_amount'],
        columns: [{
          field: 'depot_description',
          displayName: 'depot_storage.depot',
          cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.depot_code}} - {{row.entity.depot_description}}</div>',
          headerCellFilter: 'translate',
          width: '**'
        }, {
          field: 'min_amount',
          displayName: 'depot_storage.min_amount',
          headerCellFilter: 'translate'
        }]
      }, {
        key: 'expiration_date',
        description: 'Data scadenza',
        fields: ['t.expiration_date'],
        columns: [{
          field: 'expiration_date',
          displayName: 'expiration_date',
          headerCellFilter: 'translate',
          exportCelFormat: function (ms) {
            return dateFilter(ms, dateFormat);
          },
          cellFilter: 'date:"' + localeFactory.getDateFormat() + '"',
          width: '*'
        }]
      }, {
        key: 'lot',
        description: 'Lotti',
        joins: [{
          column: 'lot l',
          value: 't.production_lot_id = l.id',
          relation: 'JOIN'
        }],
        fields: ['l.code AS lot_code', 't.production_lot_id'],
        columns: [{
          field: 'lot_code',
          displayName: 'depot_storage.lot',
          headerCellFilter: 'translate'
        }]
      }, {
        key: 'status',
        description: 'Stato',
        fields: ['t.status as kit_status'],
        columns: [{
          field: 'kit_status',
          displayName: 'depot_storage.status',
          headerCellFilter: 'translate'
        }]
      }
    ];

    $scope.mainFilters = [
      {
        column: 'customer_destination cd',
        value: 'cd.id = t.customer_destination',
        relation: 'JOIN',
        kind: 'cd.code as depot_code'
      },
      {
        column: 'supplier s',
        value: 't.supplier = s.id',
        relation: 'JOIN'
      }, {
        column: 'bom b',
        value: 't.bom_id = b.id',
        relation: 'JOIN'
      }, {
        column: 'product p',
        value: 'b.item_id = p.id',
        relation: 'JOIN'
      },
      {
        column: 'endowment e',
        value: '(e.destination_id = cd.id and (e.type = \'DEP_MONOUSO\' or e.type = \'MONOUSO\') and (e.end_validity_date is null or e.end_validity_date > now()))',
        relation: 'left outer JOIN'
      }, {
        column: 'endowment_item ei',
        value: '(p.id = ei.product_id and ei.endowment_id = e.id and (ei.end_validity_date is null or ei.end_validity_date > now()))',
        relation: 'left outer JOIN'
      }, {
        column: '(SELECT p.id AS p_id, cd.id AS cd_id, sum(ei.minamount) AS min_amount\n' +
          'FROM endowment_item ei\n' +
          'JOIN endowment e ON ei.endowment_id = e.id\n' +
          'JOIN product p ON ei.product_id = p.id\n' +
          'JOIN customer_destination cd ON e.destination_id = cd.id\n' +
          'WHERE (e.type = \'DEP_MONOUSO\' or e.type = \'MONOUSO\')\n' +
          'AND (e.end_validity_date is null or e.end_validity_date > now())\n' +
          'AND (ei.end_validity_date is null or ei.end_validity_date > now())\n' +
          'GROUP BY p.id, cd.id) d',
        value: ('d.p_id = p.id AND d.cd_id = cd.id'),
        relation: 'LEFT JOIN'
      }
    ];

    $scope.productFilters = [{
      column: 'product_group pg',
      value: 't.product_group_id = pg.id',
      relation: 'JOIN',
      kind: 'pg.code AS product_group_code'
    }];

    $scope.lotFilters = [];
    $scope.depotFilters = [];
    $scope.supplierFilters = [];

    $scope.getData = function (params) {
      var filters = $scope.mainFilters
        .concat(buildAggs()).concat(buildFilters($scope.filters));

      var queryParameters = buildQueryParameters($scope.viewGridOptions, params);
      recordFactory('serial_kit').aggregation(queryParameters, {
        filters: filters,
        fields: ['p.code', 'p.description', 'p.id AS product_id', 'p.identification as identification',
          's.description as supplier_description', 's.id as supplier', 't.status as kit_status'].concat(buildFields()),
        operations: [{
          function: 'sum',
          argument: 't.check_in_amount',
          alias: 'count'
        }
        ]
      })
        .$promise.then(function (data) {
        $scope.viewGridOptions.totalItems = data.totalResults;
        if (data.list && data.list.length > 0) {
          data.list.forEach(function (e) {
            $scope.enum.status.map(function (s) {
              if (e.kit_status == s.value) {
                e.kit_status = s.name;
              }
            })
          });
        }
        $scope.viewGridOptions.data = data.list;
      });
    };

    function resetDetailGridColumns() {
      return [{
        name: 'envelope',
        field: 'envelope',
        displayName: 'Cartone',
        headerCellFilter: 'translate'
      }, {
        name: 'barcode',
        field: 'barcode',
        displayName: 'Barcode',
        headerCellFilter: 'translate'
      }, {
        name: 'expiration_date',
        field: 'expiration_date',
        displayName: 'expiration_date',
        headerCellFilter: 'translate',
        cellFilter: 'date:"' + localeFactory.getDateFormat() + '"',
        exportCelFormat: function (ms) {
          return dateFilter(ms, dateFormat);
        }
      }, {
        name: 'destination',
        field: 'destination',
        displayName: 'depot_storage.depot',
        headerCellFilter: 'translate'
      }, {
        name: 'lot',
        field: 'lot',
        displayName: 'depot_storage.lot',
        headerCellFilter: 'translate'
      },{
        name: 'status',
        field: 'status',
        displayName: 'depot_storage.status',
        headerCellFilter: 'translate'
      }, {
        name: 'check_in_amount',
        field: 'check_in_amount',
        displayName: 'depot_storage.count',
        headerCellFilter: 'translate'
      }];
    }

    $scope.aggsRequestChanged = function () {
      $scope.viewGridOptions.gridApi.pagination.seek(1);
      $timeout(function () {
        refreshDetailGridColumns();
        setGrigColumns();
        $scope.requestChanged();
      }, 50);
    };

    var bufferedRequest;
    $scope.requestChanged = function (params) {
      $scope.selectedRow = null;
      if (bufferedRequest) $timeout.cancel(bufferedRequest);
      if (params) {
        bufferedRequest = $timeout($scope.getData, 500, true, params);
      } else {
        bufferedRequest = $timeout($scope.getData, 500);
      }
    };

    function refreshDetailGridColumns() {
      $scope.detailGridOptions.columnDefs = resetDetailGridColumns();
      $scope.aggs.map(function (agg) {
        $scope.detailGridOptions.columnDefs.map(function (col) {
          if (agg.key === col.field) {
            $scope.detailGridOptions.columnDefs.splice($scope.detailGridOptions.columnDefs.indexOf(col), 1);
          }
        });
      });
    }

    function viewDetail(row) {
      if (!row.isSelected) {
        $scope.selectedRow = null;
        return;
      }
      $scope.selectedRow = row.entity;
      $scope.detailGridOptions.paginationPageSize = $scope.selectedRow.count;
      $scope.detailGridOptions.gridApi.pagination.seek(1);
      $scope.loadDetail(undefined, $scope.selectedRow);
    }

    $scope.loadDetail = function (params, row) {
      refreshDetailGridColumns();
      var queryParameters = buildQueryParameters($scope.detailGridOptions, params);
      var filters = $scope.mainFilters.concat([{
        column: 'lot l',
        value: 't.production_lot_id = l.id',
        relation: 'JOIN',
        kind: 'l.code AS lot_code'
      }
      ]).concat(buildFilters($scope.filters)).concat(buildFilters(row));
      recordFactory('serial_kit').filter(queryParameters, filters).$promise.then(function (res) {
        res = res.list.map(function (data) {
          $scope.enum.status.map(function (s) {
            if (data.status === s.value) {
              data.status = s.name;
            }
          })
          return {
            envelope: data.envelope,
            barcode: data.barcode,
            destination: data.depot_code,
            last_packing_date: data.last_packing_date,
            product_code: data.product_code,
            product_description: data.product_description,
            lot: data.lot_code,
            expiration_date: data.expiration_date,
            supplier_code: data.supplier_code,
            status: data.status,
            check_in_amount: data.check_in_amount
          };
        });
        return {
          totalResults: res.length,
          list: res
        };
      }).then(function (data) {
        $scope.detailGridOptions.data = data.list;
        $scope.detailGridOptions.totalItems = data.totalResults;
        $scope.detailGridOptions.paginationPageSize = data.totalResults > $scope.viewGridOptions.paginationPageSize ? data.totalResults : $scope.viewGridOptions.paginationPageSize;
      });
    };

    $scope.$watch('filters', function (newValue, oldValue) {
      if (newValue == oldValue) return;
      $scope.requestChanged();
    }, true);

    function buildQueryParameters(grid, params) {
      if (params) {
        var queryParameters = {
          page: params.pageNumber,
          page_size: params.pageSize,
          sort_fields: params.sortFields,
          sort_order: params.sortOrder
        };
        if (angular.isString(queryParameters.sort_fields) && queryParameters.sort_fields.length == 0) {
          delete queryParameters.sort_fields;
        }
        if (angular.isString(queryParameters.sort_order) && queryParameters.sort_order.length == 0) {
          delete queryParameters.sort_order;
        }
        return queryParameters;
      }
      var gridApi = grid.gridApi,
        sorting = (gridApi.grid.getColumnSorting() || []).pop() || {};
      return {
        page: gridApi.pagination.getPage(),
        page_size: grid.paginationPageSize,
        sort_fields: sorting.field,
        sort_order: (sorting.sort && sorting.sort.direction)
      };
    }

    function setGrigColumns() {
      var aggsCol = [];
      angular.forEach($scope.aggs, function (value) {
        this.push.apply(this, value.columns || []);
      }, aggsCol);
      Array.prototype.splice.apply($scope.viewGridOptions.columnDefs, [4, $scope.viewGridOptions.columnDefs.length - 5].concat(aggsCol));
    }

    function buildAggs() {
      var joins = [];
      angular.forEach($scope.aggs, function (value) {
        this.push.apply(this, value.joins || []);
      }, joins);
      return joins;
    }

    function buildFields() {
      var fields = [];
      angular.forEach($scope.aggs, function (value) {
        this.push.apply(this, value.fields || []);
      }, fields);
      return fields;
    }

    function buildFilters(filterObj) {
      var filters = [];
      angular.forEach(filterObj, function (value, key) {
        if (!value) return;
        switch (key) {
          case 'date_from':
            this.push.apply(this, dbFilterFactory.getDateFilter('expiration_date', value, '>='));
            break;
          case 'date_to':
            this.push.apply(this, dbFilterFactory.getDateFilter('expiration_date', value, '<='));
            break;
          case 'expiration_date':
            this.push.apply(this, dbFilterFactory.getDateFilter('expiration_date', new Date(value), '='));
            break;
          case 'depot_id':
            this.push.apply(this, dbFilterFactory.getNumberFilter('cd.id', value));
            break;
          case 'production_lot_id':
            this.push.apply(this, dbFilterFactory.getNumberFilter('t.production_lot_id', value));
          case 'supplier':
            this.push.apply(this, dbFilterFactory.getNumberFilter(key, value));
            break;
          case 'product_id':
            this.push.apply(this, dbFilterFactory.getNumberFilter('p.id', value));
            break;
          case 'status':
            this.push.apply(this, dbFilterFactory.getCustomFilter('t.status = \''+ value + "\'"));
            break;
          default:
            console.debug('Unknown filter ', key, value);
            break;
        }
      }, filters);
      return filters;
    }

    function checkPermissions() {
      var profilingKey = 'TNT_WAREHOUSE_STORAGE_FUNCTION'; //FIXME: andrebbe create un entry apposta, ora usa la stessa della pagina "Magazzino Monouso"
      var permission = authFactory.getPermissions(profilingKey);
      if (!permission.EXEC) {
        $location.path('forbidden').search({key: profilingKey});
      }
    }

    function initFilters() {
      var authFilter = authFactory.getAuthFilters();
      $scope.mainFilters = $scope.mainFilters
        .concat(authFilter)
        .concat(authFactory.getAuthSupplierFilters('s.id'))
        .concat(authFactory.getAuthDestinationFilters('cd.id'));
      $scope.supplierFilters = $scope.supplierFilters
        .concat(authFilter)
        .concat(authFactory.getAuthSupplierFilters());
      $scope.depotFilters = $scope.depotFilters
        .concat(authFilter)
        .concat(authFactory.getAuthDestinationFilters());
      $scope.lotFilters = $scope.lotFilters
        .concat(authFilter);
       // PRODUCT GROUP FILTER
      matrixParFactory.getMatrixPar({
        key: 'tntProductGroup',
        d1: '*',
        d2: '*',
        d3: '*',
        d4: '*',
        d5: '*'
      }).$promise.then(function (response) {
        if (response.value) {
          var codes = response.value.trim().split(",");
          if (codes.length > 0) {
            var query = dbFilterFactory.getOrQuery('pg.code', codes);
            $scope.productFilters = $scope.productFilters.concat(dbFilterFactory.getCustomFilter(query));
            $scope.supplierFilters = $scope.supplierFilters.concat(dbFilterFactory.getCustomFilter("t.id in (select t.id from supplier t LEFT JOIN product_supplier ps ON t.id = ps.supplier_id LEFT JOIN product p ON ps.product_id = p.id LEFT JOIN product_group pg ON p.product_group_id = pg.id where " + query + ")"));
          }
        }
      }).catch(angular.identity);
    }

    function initLookup() {
      $scope.lookup = {};
      eggsFormFactory.addLookup($scope.lookup, 'depot_id', 'customer_destination', 't.code', 't.description');
      eggsFormFactory.addLookup($scope.lookup, 'product_id', 'product', 't.code', 't.description');
      eggsFormFactory.addLookup($scope.lookup, 'lot_id', 'lot', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'supplier', 'supplier', 't.code', 't.description');
    }

    $rootScope.$on('$translateRefreshEnd', function () {
      $q.all({
        general: localeFactory.translateMsg(msg),
        specific: localeFactory.translateMsg(status_msg, 'depot_storage').then(function () {
          $scope.enum.status.forEach(function (en) {
            en.name = status_msg[en.value];
            //console.log(en.name, en.value);
          });
        })
      }).catch(function (error) {
        $log.error(error);
      });
    });

    function init() {
      if (angular.isDefined($routeParams.status)) {
        console.log('preselect kit status:' + $routeParams.status);
        $scope.filters = {
          status: $routeParams.status
        }
      }
      localeFactory.loadTranslation('depot_storage');
      checkPermissions();
      initFilters();
      initLookup();
    }

    //___ main ___
    init();
  });

'use strict';

angular.module('ictportal.tnt').controller('tntWizardEndowmentCtrl', function ($scope, recordFactory, sixFactory, $q,
                                                                               $uibModal, authFactory, APP_URL,
                                                                               $location, customerOrderFactory,
                                                                               matrixParFactory, sixGridPaginationConstants,
                                                                               uiGridConstants, toaster, endowmentFactory) {

  $scope.tabs = {
    TAB_CUSTOMER: 1,
    TAB_AGREEMENT: 2,
    TAB_PRODUCT_UPDATE: 3,
    TAB_DEST: 4,
    END_SUCCESS: 5
  };

  $scope.tabs.activeTab = $scope.tabs.TAB_CUSTOMER;

  $scope.params = {
    filters: []
  };

  $scope.indietro = function() {
    $scope.tabs.activeTab -= 1;
  };


  /* CUSTOMER */

  $scope.getCustomerList = function(params) {
    var payload = {};
    if (params){
      payload = {
        page: params.pageNumber,
        page_size: params.pageSize,
        code: params.code,
        description:params.description,
        show_revision: false,
        sort_order: params.sortOrder
      };
    }

    recordFactory('customer').filter(payload, params.filters || []).$promise.then(function (data) {
      $scope.customerGridOptions.totalItems = data.totalResults;
      $scope.customerGridOptions.data = data.list;
    });

  };

  $scope.customerGridOptions = {
    columnDefs: [
      {
        field: 'code',
        name: 'Codice',
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: '',
          kind: 'string',
          aliasResolver: 'code'
        }]
      },
      {
        field: 'description',
        name: 'Descrizione',
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: '',
          kind: 'string',
          aliasResolver: 'description'
        }]
      }
    ],
    multiSelect: false,
    enableRowHeaderSelection: false,
    enableRowSelection: false,
    appScopeProvider: $scope,
    data: [],
    rowTemplate: '<div ng-click="grid.appScope.customerSelected(row)" ' +
      'ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ' +
      'ng-class="col.colIndex()" ui-grid-cell></div>',
  };

  $scope.customerSelected = function(row) {
    $scope.customer = row.entity;
    $scope.tabs.activeTab = $scope.tabs.TAB_AGREEMENT;
    $scope.getAgreementList({pageNumber: 1, pageSize: 15});
  };

  /* AGREEMENT */

  $scope.getAgreementList = function(params) {
    var payload = {};
    if (params){
      payload = {
        startRow: (params.pageNumber - 1) * params.pageSize,
        pageSize: params.pageSize,
        customer: $scope.customer.code,
        onlyTnt: true
      };
    }

    sixFactory.agreement(payload).$promise.then(function (data) {
      $scope.agreementGridOptions.totalItems = data.count;
      $scope.agreementGridOptions.data = data.items;
    });

  };

  $scope.confermaContratti = function() {
    $scope.selectedAgreements = $scope.agreementGridOptions.gridApi.selection.getSelectedRows();
    if ($scope.selectedAgreements.length === 0){
      toaster.pop('error', 'Selezionare almento un contratto');
      return;
    }
    $scope.getProductList();
    $scope.tabs.activeTab = $scope.tabs.TAB_PRODUCT_UPDATE;
  };

  $scope.agreementGridOptions = {
    columnDefs: [
      {
        field: 'num',
        name: 'Codice'
      },
      {
        field: 'description',
        name: 'Descrizione'
      }
    ],
    multiSelect: true,
    enableRowHeaderSelection: true,
    enableRowSelection: true,
    enableFiltering: false,
    appScopeProvider: $scope,
    data: [],
  };

  /* PRODUCT */
  var ARTICOLO_DUPLICATO = 'Articolo presente in più contratti';
  function setProductErrors(p){
    if (!p.qta || !p.parent || !p.supplier || !p.productSupplierCode){
      p.errors = 'Dati mancanti';
    }

    var duplicates = $scope.getDuplicatesProducts();

    if (duplicates.includes(p.code)){
      p.errors = ARTICOLO_DUPLICATO;
    }
  }

  $scope.getProductList = function(params) {
    $scope.products = $scope.selectedAgreements.map(function (a) {
      a.items.forEach(function (i) {
        i.agreement_desc = a.description;
        i.customer = a.customer;
      });
      return a.items;
    }).flat().filter(function (i) {
      var ok = true;
      if (params === undefined){
        return ok;
      }
      for (var f_ = 0; f_ < params.filters.length; f_++){
        var f = params.filters[f_];
        if (!i.hasOwnProperty(f.column)){
          ok = false;
        } else {
          ok = ok && String(i[f.column]).toUpperCase().includes(String(f.value).toUpperCase());
        }
      }
      return ok;
    });
    $scope.products.forEach(function (p) {
      setProductErrors(p);
    });
    $scope.productGridOptions.totalItems = $scope.products.length;
    $scope.productGridOptions.data = $scope.products;

  };

  $scope.productGridOptions = {
    columnDefs: [
      {
        field: 'agreement_desc',
        name: 'Contratto',
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: '',
          kind: 'string',
        }]
      },
      {
        field: 'code',
        name: 'Codice',
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: '',
          kind: 'string',
        }]
      },
      {
        field: 'description',
        name: 'Descrizione',
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: '',
          kind: 'string',
        }]
      },
      {
        field: 'qta',
        name: 'Quantità',
        enableCellEdit: true,
        filters:[{
          type: sixGridPaginationConstants.filterType.NUMBER,
          condition: uiGridConstants.filter.EQUAL,
          placeholder: '',
          kind: 'number',
        }]
      },
      {
        field: 'parent',
        name: 'Articolo padre',
        enableCellEdit: true,
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: '',
          kind: 'string',
        }]
      },
      {
        field: 'supplierDesc',
        name: 'Fornitore',
        enableCellEdit: false,
        //cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.supplier}} - {{row.entity.supplierDesc}}</div>',
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: '',
          kind: 'string',
        }]
      },
      {
        field: 'productSupplierCode',
        name: 'Codice Articolo Fornitore',
        enableCellEdit: true,
        editableCellTemplate: '<input type="text" maxlength="25" ui-grid-editor ng-value="row.entity.productSupplierCode" ng-model="row.entity.productSupplierCode"/>',
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: '',
          kind: 'string',
        }]
      },
      {
        field: 'productCustomerCode',
        name: 'Codice Articolo cliente',
        enableCellEdit: true,
        editableCellTemplate: '<input type="text" maxlength="10" ui-grid-editor ng-value="row.entity.productCustomerCode" ng-model="row.entity.productCustomerCode"/>',
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: '',
          kind: 'string',
        }]
      },
      {
        field: 'errors',
        name: 'Errori',
        cellTemplate: '<div ng-class="{ \'alert alert-warning ui-grid-cell-contents alert-no-padding\': grid.appScope.isWarn(row), \'alert alert-danger alert-no-padding\': grid.appScope.isErr(row)}">{{row.entity.errors}}</div>',
        filters:[{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: '',
          kind: 'string',
        }]
      }
    ],
    data: [],
    enableFiltering: true,
    appScopeProvider: $scope,
  };

  $scope.isWarn = function(row) {
    return row.entity.errors === ARTICOLO_DUPLICATO;
  };

  $scope.isErr = function(row) {
    return row.entity.errors !== undefined && row.entity.errors !== ARTICOLO_DUPLICATO;
  };

  $scope.salvaProdotti = function () {
    var promises = [];
    $scope.prodottiAvantiEnabled = false;
    $scope.productGridOptions.data.forEach(function (p) {
      var prom = sixFactory.updateProductTNT({}, p).$promise.then(function (data) {
        p.errors = undefined;
        if (data.success === false){
          p.errors = data.message;
        } else {
          setProductErrors(p);
        }
      });
      promises.push(prom);
    });
    $q.all(promises).then(function () {
      if ($scope.productGridOptions.data.map(function (p) {
        return p.errors;
      }).filter(function (el) {
        return el !== undefined && el !== ARTICOLO_DUPLICATO;
      }).length === 0) {
        $scope.prodottiAvantiEnabled = true;
      }
    });
  };

  $scope.avantiProdotti = function () {
    $scope.getDestList();
    $scope.tabs.activeTab = $scope.tabs.TAB_DEST;
  };

  /* DESTINATION */

  var colDefsCommon = [
    {
      field: 'code',
      name: 'Dettaglio',
      cellTemplate:
        '<div class="ui-grid-cell-contents" style="text-align: center">' +
        '<button ng-click="grid.appScope.destDetail(row.entity.code)" class="btn btn-xs btn-primary">' +
        '<span class="fa fa-search"></span>' +
        '</button>' +
        '</div>'
    },
    {
      field: 'code',
      name: 'Codice',
      filters:[{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: '',
        kind: 'string',
      }]

    },
    {
      field: 'description',
      name: 'Descrizione',
      filters:[{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: '',
        kind: 'string',
      }]
    },
    {
      field: 'receiverType',
      name: 'Tipo',
      filters:[{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: '',
        kind: 'string',
      }]
    },
    {
      field: 'container',
      name: 'Contenitore',
      filters:[{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: '',
        kind: 'string',
      }]
    },
    {
      field: 'parent',
      name: 'Destinazione Madre',
      filters:[{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: '',
        kind: 'string',
      }]
    },
    {
      field: 'barcode',
      name: 'Barcode',
      filters:[{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: '',
        kind: 'string',
      }]
    }
  ];

  var columnsDestWithCheck = [
    {
      field: 'dotazione',
      name: '',
      cellTemplate: '<button class="btn btn-primary btn-sm" ng-click="grid.appScope.inserisciDot(row.entity)">Inserisci Dotazione</button>'
    }
  ].concat(colDefsCommon);

  $scope.destGridOptions = {
    columnDefs: columnsDestWithCheck,
    data: [],
    appScopeProvider: $scope,
  };

  $scope.destErrorGridOptions = {
    columnDefs: colDefsCommon,
    data: [],
    appScopeProvider: $scope
  };

  $scope.confermaDest = function() {
    $scope.tabs.activeTab = $scope.tabs.END_SUCCESS;
  };

  $scope.nuovaDest = function() {
    //show popup
    $scope.jsf = -1;
    var modal =$uibModal.open({
      animation: true,
      scope: $scope,
      templateUrl: 'tnt/endowment-wizard/customer-destination-popup.html',
      size: '1000'
    });

    //ricarica tabelle
    modal.closed.then(function () {
      $scope.getDestList();
    });
  };

  $scope.destDetail = function(code){
    //show popup
    $scope.jsf = code;
    var modal =$uibModal.open({
      animation: true,
      scope: $scope,
      templateUrl: 'tnt/endowment-wizard/customer-destination-popup.html',
      size: '1000'
    });

    //ricarica tabelle
    modal.closed.then(function () {
      $scope.getDestList();
    });
  };

  $scope.getJsfURL = function() {
    var jsfurl;
    if (authFactory.getAuthData() === null) {
      console.log('JsfCtrl auth data null');
      return '';
    }
    var params = '?username=' + authFactory.getAuthData().authId + '';
    var actionParams = $scope.jsf === -1 ? ('\'' + $scope.customer.code + '\'') : ('\'' + $scope.customer.code + '\', \'' + $scope.jsf + '\'');
    var action = '"customerDestinationController.startPage('  + actionParams + ')"';
    params += '&jsfAction=' + action;
    jsfurl = APP_URL + params;
    return jsfurl;
  };

  $scope.getDestList = function (paramsFilter) {
    sixFactory.dest({customer: $scope.customer.code}).$promise.then(function (data) {
      if (data.status === 'OK'){
        //filtro errori
        var errors = data.items.filter(function (d) {
          return d.receiverType === undefined ||
            (d.receiverType === 'REP' && d.parent === undefined);
        });

        var buoni = data.items.filter(function (d) {
          return !errors.includes(d);
        });

        var dep = buoni.filter(function(d){
          return d.receiverType === 'DEP'
        })

        var gua = buoni.filter(function (d) {
          return d.receiverType === 'GUA';
        });

        var rep = buoni.filter(function (d) {
          return d.receiverType === 'REP';
        });

        gua.forEach(function (g) {
          g.subGridOptions = {
            columnDefs: columnsDestWithCheck,
            data: [],
            minRowsToShow: 2,
            appScopeProvider: $scope
          };
        });

          dep.forEach(function (g) {
            g.subGridOptions = {
              columnDefs: columnsDestWithCheck,
              data: [],
              minRowsToShow: 2,
              appScopeProvider: $scope
            };
        });

        rep.forEach(function (r) {
          var g = gua.filter(function (g) {
            return g.code === r.parent;
          });

          if (g.length === 0){
            errors.push(r);
          } else {
            g[0].subGridOptions.data.push(r);
          }
        });

        //set grid
        var dests = gua.concat(dep)
        var final = dests.filter(function (i) {
          var ok = true;
          if (paramsFilter === undefined){
            return ok;
          }
          for (var f_ = 0; f_ < paramsFilter.filters.length; f_++){
            var f = paramsFilter.filters[f_];
            if (!i.hasOwnProperty(f.column)){
              ok = false;
            } else {
              ok = ok && String(i[f.column]).toUpperCase().includes(String(f.value).toUpperCase());
            }
          }
          return ok;
        });
        $scope.destGridOptions.totalItems = final.length;
        $scope.destGridOptions.data = final;

        //set error grid
        $scope.destErrorGridOptions.totalItems = errors.length;
        $scope.destErrorGridOptions.data = errors;
      }
    });
  };


  $scope.inserisciDot = function (dest) {
    var obj = {
      validity_date: new Date(),
      customer_id: $scope.customer.id,
      customer_destination_id: dest.id,
      type: dest.receiverType === 'DEP'? 'DEP_MONOUSO' : 'MONOUSO'
    };
    endowmentFactory.getSimple({}, obj).$promise.then(function (data) {
      if (data.result) {
        dest.saved = true;
        //salvo dotazione nello scope
        $scope.end = {
          dest: dest,
          destCode: dest.code,
          type: dest.receiverType === 'DEP'? 'DEP_MONOUSO' : 'MONOUSO',
          enableOrder: false,
          inizioValidita: new Date(data.result.start_validity_date),
          fineValidita: new Date(data.result.end_validity_date),
          budgetFrequency: data.result.budget_frequency,
          budgetRecovery: data.result.budget_recovery ? 'true' : 'false',
          items: data.result.items.map(function (i) {
            return {
              product: i.product.code,
              productDesc: i.product.description,
              dataInizio: i.start_validity_date,
              dataFine: i.end_validity_date,
              scortaMin: i.minamount,
              budget: i.budget,
              minLot: i.minlot,
              tracked: i.tracked,
              reorderType: i.reorder_type,
              agreement_id: i.agreement.id,
              agreement_desc: i.agreement.description,
              alreadyPresent: true,
            };
          })
        };
      } else {
        dest.saved = false;
        $scope.end = {
          dest: dest,
          enableOrder: true,
          destCode: dest.code,
          inizioValidita: new Date(),
          type: dest.receiverType === 'DEP'? 'DEP_MONOUSO' : 'MONOUSO',
          items: [],
          fineValidita: new Date($scope.selectedAgreements.sort(function(a,b){return a.endValidityDate - b.endValidityDate})[0].endValidityDate),
        };
      }
      // mostro popup dotazione passando scope
      $scope.actualEnd = $uibModal.open({
        animation: true,
        scope: $scope,
        templateUrl: 'tnt/endowment-wizard/endowment-popup.html',
        size: '1000'
      });
    });
  };

  /* ENDOWMENT */

  $scope.deleteEndRow = function(row,grid) {
    var i = grid.appScope.end.items.indexOf(row.entity);
    grid.appScope.end.items.splice(i, 1);
  };

  var endowmentColumns =  [
    {
      field: 'product',
      name: 'Cancella',
      cellTemplate: '<button ng-if="row.entity.alreadyPresent === false" ng-click="grid.appScope.deleteEndRow(row, grid)">Cancella</button>'
    },
    {field: 'product',
      name: 'Prodotto',
      filters:[{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: '',
        kind: 'string',
      }],
      cellTemplate: '<select ng-if="row.entity.alreadyPresent === false" ng-model="row.entity.productString" ng-change="grid.appScope.endChangedRow(row.entity)">' +
        '<option ng-repeat="item in row.entity.itemsList" value="{{item}}">' +
        '{{item.code}} - {{item.description}} - {{item.agreement_desc}}' +
        '</option>' +
        '</select>' +
        '<div class="ui-grid-cell-contents" ng-if="row.entity.alreadyPresent === true">{{row.entity.product}} - {{row.entity.productDesc}}</div>'
    },
    {
      field: 'agreement_desc',
      name: 'Contratto',
      filters:[{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: '',
        kind: 'string',
      }]
    },
    {
      field: 'dataInizio',
      name: 'Inizio Validità',
      enableCellEdit: true,
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy\'',
      filters:[{
        type: sixGridPaginationConstants.filterType.DATE,
        condition: uiGridConstants.filter.EXACT,
        placeholder: '',
        kind: 'string',
      }]
    },
    {
      field: 'dataFine',
      name: 'Fine Validità',
      enableCellEdit: true,
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy\'',
      filters:[{
        type: sixGridPaginationConstants.filterType.DATE,
        condition: uiGridConstants.filter.EXACT,
        placeholder: '',
        kind: 'string',
      }]
    },
    {
      field: 'scortaMin',
      name: 'Scorta Minima',
      enableCellEdit: true,
      type: 'number',
      filters:[{
        type: sixGridPaginationConstants.filterType.NUMBER,
        condition: uiGridConstants.filter.EXACT,
        placeholder: '',
        kind: 'string',
      }]
    },
    {
      field: 'budget',
      name: 'Budget',
      enableCellEdit: true,
      type: 'number',
      filters:[{
        type: sixGridPaginationConstants.filterType.NUMBER,
        condition: uiGridConstants.filter.EXACT,
        placeholder: '',
        kind: 'string',
      }]
    },
    {
      field: 'minLot',
      name: 'Lotto minimo',
      enableCellEdit: true,
      type: 'number',
      filters:[{
        type: sixGridPaginationConstants.filterType.NUMBER,
        condition: uiGridConstants.filter.EXACT,
        placeholder: '',
        kind: 'string',
      }]
    },
    {
      field: 'reorderType',
      name: 'Modalità Riordino',
      enableCellEdit: false,
      cellTemplate: '<select ng-model="row.entity.reorderType">' +
        '<option value="MANUAL">Manuale</option>' +
        '<option value="CONSUMED">Consumato</option>' +
        '<option value="MINSTOCK">Scorta Minima</option>' +
        '</select>',
      filters:[{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: '',
        kind: 'string',
      }]
    },
    {
      field: 'tracked',
      name: 'Tracciato',
      enableCellEdit: true,
      type: 'boolean',
      cellTemplate: '<input type="checkbox" ng-model="row.entity.tracked"/>',
      filters:[{
        type: sixGridPaginationConstants.filterType.CHECKBOX,
        condition: uiGridConstants.filter.EXACT,
        placeholder: '',
        kind: 'string',
      }]
    }
    ];

  $scope.endChangedRow = function(rowEnt){
    var selecctedProd = JSON.parse(rowEnt.productString);
    rowEnt.agreement_desc = selecctedProd.agreement_desc;
    rowEnt.product = selecctedProd.code;
    rowEnt.agreement_id = selecctedProd.agreement_id;
    var fineProd = new Date(selecctedProd.dataFine);
    rowEnt.dataFine = fineProd < $scope.end.fineValidita ? fineProd : $scope.end.fineValidita;
  };

  $scope.addEndowmentItem = function (end) {
    var remains = $scope.getRemainsProduct(end);
    if (remains.length === 0){
      toaster.pop("error", "Non vi sono altri articoli disponibili nei contratti");
      return;
    }
    var newItem = {
      alreadyPresent: false,
      itemsList: remains,
      dataInizio: new Date(end.inizioValidita),
      dataFine: new Date(end.fineValidita),
      reorderType: 'MANUAL',
      tracked: true
    };
    end.items.push(newItem);
    $scope.getEndowmentItems(end);
  };

  $scope.getDuplicatesProducts = function() {
    var allCodes = $scope.agreementGridOptions.data.map(function (a) {
      return a.items.map(function (i) {
        return i.code;
      });
    }).flat();

    return allCodes.filter(function (c, index) {
      return allCodes.indexOf(c) !== index;
    });
  }

  $scope.getRemainsProduct = function(end) {
    var already = end.items.map(function (i) {
      return {product: i.product, agreement: i.agreement_id};
    });

    //Non si possono inserire articoli presenti in più contratti SIXLM-539
    var duplicates = $scope.getDuplicatesProducts();

    return $scope.selectedAgreements.map(function (a) {
      return a.items.map(function (i) {
        return {product: i.code, agreement: a.id, agreement_desc: a.description, dataFine: a.endValidityDate, item:i};
      });
    }).flat().filter(function (p) {
      return !duplicates.includes(p.product);
    })
      .filter(function (p) {
      var exist = false
      for (var index in already){
        var pa = already[index];
        if (pa.product === p.product){
          exist = true;
          break;
        }
      }

      return !exist;
    }).map(function (p) {
      var res = p.item;
      res.agreement_desc = p.agreement_desc;
      res.agreement_id = p.agreement;
      res.dataFine = p.dataFine

      return res;
    });
  };

  $scope.getItemsListFromAgreement = function (agr) {
    return $scope.selectedAgreements.filter(function (a) {
      return a.num === agr;
    })[0].items;
  };

  $scope.getEndowmentItems = function (end, params) {
    var filtered = end.items.filter(function (i) {
      var ok = true;
      if (params === undefined || params.filters === undefined){
        return ok;
      }
      for (var f_ = 0; f_ < params.filters.length; f_++){
        var f = params.filters[f_];
        if (!i.hasOwnProperty(f.column)){
          ok = false;
        } else {
          ok = ok && String(i[f.column]).toUpperCase().includes(String(f.value).toUpperCase());
        }
      }
      return ok;
    });
    end.gridOptions.data = filtered;
    end.gridOptions.totalItems = filtered.length;
  };

  $scope.salvaEndowment = function (end) {
    delete end.errors;
    sixFactory.saveEndowment({}, end).$promise.then(function (data) {
      if (data.success){
        end.saved = true;
        toaster.pop('success', 'dotazione salvata');
      } else {
        end.saved = false;
        end.errors = data.error;
      }
    });
  };

  $scope.getGridOptionsEnd = function (end) {
    if (end.gridOptions === undefined){
      end.gridOptions = {
        columnDefs: endowmentColumns,
        data: [],
        appScopeProvider: $scope,
      };
    }

    return end.gridOptions;
  };

  /* ORDERS */

  function firstMulti(base, multi) {
    var packages = Math.ceil(base / (multi || 1));
    return packages * (multi || 1);
  }

  function afterCellEdit(rowEntity, colDef){
    if (colDef.field === 'stock_amount'){
      var packages = Math.ceil(rowEntity.stock_amount / (rowEntity.productQta || 1));
      rowEntity.stock_amount = packages * (rowEntity.productQta || 1);
    }

  }

  $scope.fine = function () {
    $scope.tabs.activeTab = $scope.tabs.END_SUCCESS;
  };

  $scope.confermaOrdine = function(order) {
    order.row_list = order.row_list.filter(function (row) {
      return row.stock_amount !== undefined && row.stock_amount !== 0;
    });
    order.row_list.forEach(function (row) {
      row.billing_amount = row.stock_amount;
    });
    customerOrderFactory.create({}, order).$promise.then(function (data) {
      if (data.status !== 'ok'){
        data.messages.forEach(function (m) {
          toaster.pop('error', m.message);
        });
      } else {
        toaster.pop("success","Ordine correttamente creato");
        $scope.actualOrd.close();
        $scope.actualEnd.close();
      }
    });
  };

  $scope.generaOrdini = function (e) {
    $scope.orderErrors = [];
    var destination = e.dest;
    var typeKey;
    switch(e.dest.receiverType){
      case 'REP':
        typeKey = 'tntReorderWardrobeOrderType';
        break;
      case 'GUA':
        typeKey = 'tntReorderPlantOrderType';
        break;
    }
    matrixParFactory.getMatrixPar({key: typeKey, d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}).$promise
      .then(function(data){
        var type = data.value;
        var obj = {
          validity_date: new Date(),
          customer_id: $scope.customer.id,
          customer_destination_id: destination.id,
          type: 'BUDGET'
        };
        endowmentFactory.getSimple({}, obj).$promise.then(function (data) {
          if (data.result) {
            var e = {
              dest: destination,
              destCode: destination.code,
              inizioValidita: new Date(data.result.start_validity_date),
              fineValidita: new Date(data.result.end_validity_date),
              budgetFrequency: data.result.budget_frequency,
              budgetRecovery: data.result.budget_recovery ? 'true' : 'false',
              items: data.result.items.map(function (i) {
                return {
                  product: i.product.code,
                  product_id: i.product.id,
                  productDesc: i.product.description,
                  productQta: i.product.quantity_included,
                  dataInizio: i.start_validity_date != undefined ? new Date(i.start_validity_date) : undefined,
                  dataFine: i.end_validity_date != undefined ? new Date(i.end_validity_date) : undefined,
                  scortaMin: i.minamount,
                  budget: i.budget,
                  minLot: i.minlot,
                  reorderType: i.reorder_type,
                  agreement_id: i.agreement.id,
                  agreement_desc: i.agreement.description,
                  alreadyPresent: true,
                };
              })
            };
            var rows = e.items.filter(function (ei) {
              return (ei.dataInizio === undefined || ei.dataInizio.getTime() <= new Date().getTime())
                && (ei.dataFine === undefined || ei.dataFine.getTime() >= new Date().getTime());
            })
              .map(function (ei) {
                return {
                  product_code: ei.product,
                  product_desc: ei.productDesc,
                  product_id: ei.product_id,
                  productQta: ei.productQta,
                  min_amount: ei.scortaMin,
                  stock_amount: firstMulti(ei.scortaMin || 0, ei.productQta || 1),
                  billing_amount: ei.scortaMin,
                  agreement_id: ei.agreement_id,
                };
              });
            var order = {
              customer_destination: destination.id,
              customer_dest_code: destination.code,
              customer_dest_desc: destination.description,
              type_code: type,
              row_list: rows
            };
            $scope.orderToCompile = order;
            $scope.gridOptionsOrd = {
              data: order.row_list,
              columnDefs: [
                {
                  field: 'product_code',
                  name: 'Articolo',
                  enableCellEdit: false,
                  cellTemplate: '<span>{{row.entity.product_code}} - {{row.entity.product_desc}}</span>',
                  type: 'string'
                },
                {
                  field: 'min_amount',
                  name: 'Scorta Min',
                  enableCellEdit: false,
                  type: 'number'
                },
                {
                  field: 'stock_amount',
                  name: 'Quantità Ordine',
                  enableCellEdit: true,
                  type: 'number'
                }
              ],
              appScopeProvider: $scope,
              onRegisterApi: function(gridApi) {
                gridApi.edit.on.afterCellEdit($scope, afterCellEdit);
              },
            };
            $scope.actualOrd = $uibModal.open({
              animation: true,
              scope: $scope,
              templateUrl: 'tnt/endowment-wizard/order-popup.html',
              size: '1000'
            });
          }
        });
      });
  };

});

angular.module('ictportal.tnt').config(function ($routeProvider) {
  $routeProvider
    .when('/tnt/wizardendowment', {
      templateUrl: 'tnt/endowment-wizard/wizard.html',
      controller: 'tntWizardEndowmentCtrl',
    });
});

'use strict';

/**
 * @ngdoc factory
 * @name ictportal.tntGoodsInwardFactory
 * @author Rita Beltrami
 * created on 09/01/2018
 * # tntGoodsInwardFactory
 * Factory in the ictportal.
 */
angular.module('ictportal.tnt')
    .factory('tntGoodsInwardFactory', function (SIX_URL, $resource) {
        return $resource(SIX_URL + '/rest/tnt/goodsinward/:verb/:param1/:param2/:param3', {}, {
            saveOrUpdateGoodsInward:    { method: 'POST', isArray: false },
            saveOrUpdateGoodsInwardList:{ method: 'POST', isArray: true, params: {verb: 'save-list'} },
            saveOrUpdateGoodsInwardRow: { method: 'POST', isArray: false, params: {verb: 'row'} },
            addBox:                     { method: 'POST', isArray: false, params: {verb: 'row', param1: 'box', param2: 'add'} },
            editRow:                    { method: 'PUT',  isArray: false, params: {verb: 'row', param1: 'edit' } },
            completeDispatch:           { method: 'POST', isArray: false, params: {verb: 'row', param1: 'dispatch'} },
            readEan128:                 { method: 'POST', isArray: false, params: {verb: 'ean128'} },
            printSerialKitLabel:        { method: 'POST', isArray: false, params: {verb: 'print', param1: 'serialkit'} },
            printRowLabel:              { method: 'POST', isArray: false, params: {verb: 'print', param1: 'row'} },
            createNewLot:               { method: 'GET',  isArray: false, params: {verb: 'create', param1: 'lot'} },
            isKitExpiring:              { method: 'POST', isArray: false, params: {verb: 'expiring' } },
            associateKitEnvelope:       { method: 'POST', isArray: false, params: {verb: 'associate-kit-envelope'}},
            acceptGoodsInward:          { method: 'POST', isArray: false, params: {verb: 'accept'}}
        });
    });

'use strict';

angular.module('ictportal.tnt')
    .factory('tntInventoryFactory', function (SIX_URL, $resource) {
        return $resource(SIX_URL + '/rest/tnt/inventory/:verb/:action', {}, {
            confirm:                { method: 'POST', isArray: false, params: {verb: 'confirm'} },
            updateHistory:          { method: 'POST', isArray: false, params: {verb: 'update-history'} },
            getNotTrackedSerialKit: { method: 'POST', params: {verb: 'get_not_tracked_serial_kit'} },
            confirmLost:            { method: 'POST', isArray: false, params: {verb: 'confirm', action: 'losts'} },
            finalize:               { method: 'POST', isArray: false, params: {verb: 'confirm', action: 'finalize'} },
            delete:                 { method: 'POST', isArray: false, params: {verb: 'confirm-delete'}}
        });
    });

'use strict';

/**
 * @ngdoc service
 * @name ictportal.tnt.tntReturnSerialKitFactory
 * @description
 * # tntReturnSerialKitFactory
 * Factory in the ictportal.tnt.
 */
angular.module('ictportal.tnt')
  .factory('tntReturnSerialKitFactory', function (APP_URL, $resource) {
      return $resource(APP_URL + '/rest/tnt/returnserialkit/:verb/:id/:param1/:param2/:param3', {}, {
        tntReturnSerialKit:       {method: 'POST', isArray: false}
      });
  });

angular.module('ictportal.tnt')
.config(function ($routeProvider) {
    $routeProvider
    .when('/tnt/inventory', {
        templateUrl: 'tnt/inventory/inventory.html',
        controller: 'InventoryCtrl'
    })
})
.controller('InventoryCtrl', function ($scope, $translate, $window, $uibModal, $filter,
                                        recordFactory, dbFilterFactory, eggsFormFactory, localeFactory,
                                        tntInventorySrv, toaster, COMPONENT_READ_MODE, uiGridConstants) {

        var dateFormat = localeFactory.getDateFormat();
        var dateFilter = $filter('date');
        $scope.destination = {};
        $scope.viewSettings = {
            gridViewLot: false,
            readerMode: COMPONENT_READ_MODE.BARCODE
        };

        $scope.$watch('lookup.customer_destination_id.obj', function(){
            if ($scope.lookup.customer_destination_id.obj && $scope.lookup.customer_destination_id.obj.id) {
                recordFactory('customer_destination').filter({}, dbFilterFactory.getNumberFilter('t.id', $scope.lookup.customer_destination_id.obj.id))
                .$promise.then(function (data) {
                    if (data && data.list.length > 0) {
                        $scope.destination.selected = data.list[0];
                        $scope.destinationChange();
                    }
                });
            }
        });

        $scope.grid = {
            enableFiltering: false,
            useExternalPagination: false,
            useExternalSorting: false,
            enablePaginationControls: false,
            data:[],
            columnDefs: [
                {
                    displayName: 'code',
                    headerCellFilter: 'translate',
                    field: 'code'
                }, {
                    displayName: 'description',
                    headerCellFilter: 'translate',
                    field: 'description'
                }, {
                    displayName: 'inventory.packs',
                    headerCellFilter: 'translate',
                    field: 'packs'
                }, {
                    displayName: 'inventory.storage_amount',
                    headerCellFilter: 'translate',
                    field: 'storage'
                }
            ]
        };


        $scope.missingGrid = {
            paginationPageSize: 10,
            paginationPageSizes: [10, 15],
            useExternalPagination: true,
            useExternalSorting: true,
            enableGridMenu: true,
            gridMenuTitleFilter: $translate,
            data: [],
            onRegisterApi: function(gridApi) {
                gridApi.pagination.on.paginationChanged($scope, $scope.missingAmount);
                gridApi.core.on.sortChanged($scope, $scope.missingAmount);
                $scope.missingGridApi = gridApi;
            },
            gridMenuCustomItems: [
                {
                    title: 'Export Excel',
                    action: function ($event) {
                        sixExportLib.exportXLSXVisibleRowsGrid($scope.missingGridApi, 'download', $filter);
                    },
                    order: 210
                }
            ],
            columnDefs: [
                {
                    displayName: 'code',
                    headerCellFilter: 'translate',
                    field: 'code'
                }, {
                    displayName: 'description',
                    headerCellFilter: 'translate',
                    field: 'description'
                }, {
                    displayName: 'inventory.missing_packs',
                    headerCellFilter: 'translate',
                    field: 'packs'
                }, {
                    displayName: 'inventory.missing_storage_amount',
                    headerCellFilter: 'translate',
                    field: 'product_storage'
                }
            ]
        };

        $scope.gridNotTracked = {
          paginationPageSize: 10,
          paginationPageSizes: [10, 15],
          data: [],
          multiSelect: true,
          enableRowHeaderSelection: true,
          enableRowSelection: true,
          onRegisterApi: function(gridApi) {
            gridApi.pagination.on.paginationChanged($scope, $scope.initGridNotTracked);
            gridApi.core.on.sortChanged($scope, $scope.initGridNotTracked);
            this.gridApi = gridApi;
            $scope.gridNotTrackedApi = gridApi;
          },
          columnDefs: [
            {
              displayName: 'code',
              headerCellFilter: 'translate',
              field: 'code'
            }, {
              displayName: 'description',
              headerCellFilter: 'translate',
              field: 'description'
            }, {
              displayName: 'inventory.storage_amount',
              headerCellFilter: 'translate',
              field: 'product_storage'
            }
          ]
        };

        function afterCellEdit(rowEntity, colDef) {
          if (colDef.field === 'packs_to_invent') {
            rowEntity.sk_to_invent = rowEntity.packs_to_invent * rowEntity.product_qta;
          }
          if (colDef.field === 'sk_to_invent') {
            rowEntity.packs_to_invent = (rowEntity.sk_to_invent % rowEntity.product_qta) === 0 ? (rowEntity.sk_to_invent / rowEntity.product_qta) : (Math.ceil(rowEntity.sk_to_invent / rowEntity.product_qta));
            rowEntity.sk_to_invent = rowEntity.packs_to_invent * rowEntity.product_qta;
          }
          $scope.gridApiNoTrackInv.core.notifyDataChange(uiGridConstants.dataChange.ALL);
        }

        $scope.gridNotTrackedInv = {
          paginationPageSize: 10,
          paginationPageSizes: [10, 15],
          data: [],
          onRegisterApi: function (gridApi) {
            $scope.gridApiNoTrackInv = gridApi;
            gridApi.edit.on.afterCellEdit($scope, afterCellEdit);
          },
          columnDefs: [
            {
              displayName: 'code',
              headerCellFilter: 'translate',
              field: 'code'
            }, {
              displayName: 'description',
              headerCellFilter: 'translate',
              field: 'description'
            }, {
              displayName: 'inventory.packs_to_invent',
              headerCellFilter: 'translate',
              field: 'packs_to_invent',
              type: 'number',
              cellClass: 'editable',
              enableCellEdit: true
            }, {
              displayName: 'inventory.sk_to_invent',
              headerCellFilter: 'translate',
              field: 'sk_to_invent',
              type: 'number',
              cellClass: 'editable',
              enableCellEdit: true
            }, {
              displayName: 'inventory.storage_amount',
              headerCellFilter: 'translate',
              field: 'product_storage'
            }
          ]
        }

        $scope.gridNotTrackedEnd = {
          paginationPageSize: 10,
          paginationPageSizes: [10, 15],
          data: [],
          onRegisterApi: function(gridApi) {
            gridApi.pagination.on.paginationChanged($scope, $scope.initGridNotTrackedEnd);
            gridApi.core.on.sortChanged($scope, $scope.initGridNotTrackedEnd);
            this.gridApi = gridApi;
            $scope.gridNotTrackedEndApi = gridApi;
          },
          multiSelect: true,
          enableRowHeaderSelection: true,
          enableRowSelection: true,
          columnDefs: [
            {
              displayName: 'code',
              headerCellFilter: 'translate',
              field: 'code'
            }, {
              displayName: 'description',
              headerCellFilter: 'translate',
              field: 'description'
            }, {
              displayName: 'inventory.storage_amount',
              headerCellFilter: 'translate',
              field: 'product_storage'
            }
          ]
        };

        function getAlreadyInInv(){
          return $scope.gridNotTrackedInv.data.map(function (r) {
            return r.code;
          });
        }

        $scope.addNoTrack = function(grid){
          grid.gridApi.selection.getSelectedRows().forEach(function (i) {
            i.packs_to_invent = 0;
            i.sk_to_invent = 0;
            $scope.gridNotTrackedInv.data.push(i);
            $scope.gridNotTrackedInv.totalItems += 1;
          });

          $scope.initGridNotTracked();
          $scope.initGridNotTrackedEnd();
        };

        $scope.initGridNotTrackedEnd = function() {
          var alreadyInInv = getAlreadyInInv();
          var queryPearameters = buildQueryParameters($scope.gridNotTrackedEnd, $scope.gridNotTrackedEndApi);
          tntInventorySrv.getNotTrackedProduct($scope.destination.selected, queryPearameters, true, alreadyInInv)
            .then(function (data) {
              if (data && data.list) {
                $scope.gridNotTrackedEnd.data = data.list;
                $scope.gridNotTrackedEnd.totalItems = data.totalResults;
              }
            });
        };

        $scope.initGridNotTracked = function() {
          var alreadyInInv = getAlreadyInInv();
          var queryPearameters = buildQueryParameters($scope.gridNotTracked, $scope.gridNotTrackedApi);
          tntInventorySrv.getNotTrackedProduct($scope.destination.selected, queryPearameters, false, alreadyInInv)
            .then(function (data) {
              if (data && data.list) {
                $scope.gridNotTracked.data = data.list;
                $scope.gridNotTracked.totalItems = data.totalResults;
              }
            });

        };

        $scope.destinationChange = function() {
            $scope.reads = [];
            $scope.serialKits = [];
            $scope.grid.data.length = 0;

            //inizializzazione griglia materiale non tracciato
            $scope.initGridNotTracked();
            $scope.initGridNotTrackedEnd();
        }

        $scope.readBarcode = function (read, deleteMode) {
            $scope.viewSettings.viewMissing = false;
            var index = $scope.reads.indexOf(read);
            if (deleteMode) {
                if (index >= 0) {
                    $scope.reads.splice(index, 1);
                    for(var i = $scope.serialKits.length-1; i >= 0; i--) {
                        if ($scope.serialKits[i].barcode == read || $scope.serialKits[i].envelope == read) {
                          $scope.serialKits.splice(i,1);
                        }
                    }
                    groupSerialKit();
                } else {
                    $scope.displayMessages([{
                        status: 'warnings',
                        code: 'SERIAL_KIT_NOT_READED',
                        message: 'Serial kit has never been read'
                    }])
                }
            } else {
                if (index < 0) {
                    $scope.reads.unshift(read);
                    tntInventorySrv.loadSerialKit(read)
                    .then(function(data){
                        if (data.list && data.list.length) {
                          if (data.list.length === 1 && $scope.serialKits.map(function (el) {
                            return el.barcode;
                          }).includes(data.list[0].barcode)){
                            //kit già letto tramite cartone non lo aggiungo e rimuovo la lettura
                            var index = $scope.reads.indexOf(read);
                            $scope.reads.splice(index, 1);
                            return;
                          }
                          $scope.serialKits = $scope.serialKits.concat(data.list);
                            groupSerialKit();
                        } else {
                            $scope.displayMessages([{
                                status: 'warnings',
                                code: 'SERIAL_KIT_NOT_FOUND',
                                message: 'Serial kit not found'
                            }]);
                        }
                    });
                }
            }
        }

        function groupSerialKit() {
            var grouped = {};
            $scope.serialKits.forEach(function(sk, index) {
                var key = sk.product_id;
                if ($scope.viewSettings.gridViewLot) {
                    key += '_'+sk.production_lot_id;
                }
                var row = grouped[key] || (grouped[key] = {
                    id: sk.product_id,
                    code: sk.product_code,
                    description: sk.product_description,
                    supplier: sk.supplier,
                    lot_description: sk.lot_description,
                    expiration_date: sk.expiration_date,
                    storage: 0,
                    packs: 0,
                    envelopes: new Set()
                });
                row.envelopes.add(sk.envelope || sk.barcode);
                row.order = index;
                row.storage += sk.check_in_amount;
                row.packs = row.envelopes.size;
            });
            var rows = Object.values(grouped);
            rows.sort(function(o1, o2) {
                return o2.order - o1.order;
            });
            $scope.grid.data.length = 0;
            $scope.grid.data.push.apply($scope.grid.data, rows);
        }

        $scope.toggleGridView = function(){

            if ($scope.viewSettings.gridViewLot) {
                $scope.grid.columnDefs.splice(2,0,{
                    displayName: 'lot',
                    headerCellFilter: 'translate',
                    field: 'lot_description'
                },{
                    field: 'expiration_date',
                    displayName: 'expiration_date',
                    headerCellFilter: 'translate',
                    exportCelFormat: function(ms){  return dateFilter(ms, dateFormat); },
                    cellFilter: 'date:"'+localeFactory.getDateFormat()+'"'
                });
                $scope.missingGrid.columnDefs.splice(2,0,{
                    displayName: 'lot',
                    headerCellFilter: 'translate',
                    field: 'lot_description'
                },{
                    field: 'expiration_date',
                    displayName: 'expiration_date',
                    headerCellFilter: 'translate',
                    exportCelFormat: function(ms){  return dateFilter(ms, dateFormat); },
                    cellFilter: 'date:"'+localeFactory.getDateFormat()+'"'
                });

            } else {
                $scope.grid.columnDefs.splice(2,2);
                $scope.missingGrid.columnDefs.splice(2,2);
            }
            $scope.missingAmount();
            groupSerialKit();
        }

        $scope.missingAmount = function(){
            if ($scope.viewSettings.viewMissing) {
                var queryPearameters = buildQueryParameters($scope.missingGrid, $scope.missingGridApi);
                tntInventorySrv.loadDestinationStorage($scope.destination.selected, queryPearameters, $scope.reads, $scope.viewSettings.gridViewLot)
                .then(function(data){
                    $scope.missingGrid.data.length = 0;
                    if (data && data.list) {
                        $scope.missingGrid.data = data.list;
                        $scope.missingGrid.totalItems = data.totalResults;
                    } else if(data.totalResults == 0) {
                        $scope.viewSettings.viewMissing = false;
                        $scope.displayMessages([{
                            status: 'info',
                            code: 'NOTHING_MISSED',
                            message: 'All boxes have been read'
                        }]);
                    }
                    console.log('Loaded missing',data.totalResults);
                }, function(err){
                    toaster.pop('error', msg.error, msg.server_comunication_error);
                })
            } else {
                $scope.missingGridApi.pagination.seek(1);
            }
        }

        function buildQueryParameters(grid, gridApi) {
            var sorting = ((gridApi && gridApi.grid.getColumnSorting()) || []).pop() || {};
            return {
                page: (gridApi &&  gridApi.pagination.getPage()) || 1,
                page_size: grid.paginationPageSize,
                sort_fields: sorting.field,
                sort_order: (sorting.sort && sorting.sort.direction)
            };

        }

        $scope.displayMessages = function(messages){
            angular.forEach(messages, function (notification) {
                var params = {};
                if (notification.params) {
                    notification.params.forEach(function (p, index) {
                        params['p' + index] = p;
                    });
                }
                var key = 'inventory.' + notification.code;
                localeFactory.translateReplace(key, params).then(function (translatedMsg) {
                    var message = (translatedMsg === key) ? notification.message : translatedMsg;
                    var status = notification.status.toLowerCase();
                    toaster.pop(status, msg[status], message);
                });
            });
        };

        $scope.exportInventory = function(callback, missingDataP){
            return tntInventorySrv.export($scope.destination.selected, $scope.serialKits, missingDataP)
              .then(callback || angular.identity,function(err){
                  toaster.pop('error', msg.error, msg.server_comunication_error);
              });
        }

        $scope.confirm = function(){
            tntInventorySrv.getDestinationMissingAmount($scope.destination.selected.id, $scope.serialKits.map(function(s) { return s.id; }), null)
            .then(function(missingAmount){
                var notTrackedRead = 0;
                var notTrackedMissing = 0;
                $scope.gridNotTrackedInv.data.forEach(function (r) {
                    notTrackedRead += r.packs_to_invent;
                    notTrackedMissing += (r.packs - r.packs_to_invent);
                });
                $uibModal.open({
                    templateUrl: 'inventoryConfirm.html',
                    size: 'sm',
                    controller: function($scope, $uibModalInstance, recap){
                        $scope.recap = recap;

                        $scope.ok = function () {
                            $uibModalInstance.close();
                        };

                        $scope.cancel = function () {
                            $uibModalInstance.dismiss();
                        };

                    },
                    resolve: {
                        recap: function () {
                            return {
                                read:  $scope.serialKits.length + notTrackedRead,
                                moved: $scope.serialKits.filter(function(s) {
                                    return s.customer_destination != $scope.destination.selected.id;
                                }).length,
                                missing: (missingAmount - notTrackedRead) < 0 ? 0 : (missingAmount - notTrackedRead)
                            };
                        }
                    }
                }).result.then(function () {
                  //TODO recupero barcode fittizi non tracciati e li leggo prima della conferma
                  tntInventorySrv.getNotTrackedSk($scope.gridNotTrackedInv.data, $scope.destination.selected.id).then(function (res) {
                    if (res.status === 'ok'){
                      $scope.serialKits = $scope.serialKits.concat(res.result.data);
                    } else {
                      toaster.pop('errore', 'Errore nell\'inventario dei kit non tracciati');
                    }
                    var missingDataP = tntInventorySrv.loadDestinationMissing($scope.destination.selected, $scope.serialKits.map(function (s) {
                      return s.id;
                    }));
                    missingDataP.then(function (missing) {
                      tntInventorySrv.confirm($scope.destination.selected, $scope.serialKits)
                        .then(function (data) {
                          if (data.status == 'ok') {
                            // [SIXLM-540] tracciamento informazioni stato kit
                            tntInventorySrv.updateHistory($scope.destination.selected, $scope.serialKits, data.result.losts)
                              .then(function (data) {
                                if (data.status == 'ok') {
                                  // Per esportare in xlsx scommentare le righe
                                  // $scope.exportInventory(function () {
                                  //   $window.history.back();
                                  // }, missingDataP);
                                  $scope.destinationChange();
                                } else {
                                  $scope.displayMessages(data.messages);
                                }
                              }, $scope.displayMessages);
                          } else {
                            $scope.displayMessages(data.messages);
                          }
                        }, $scope.displayMessages);
                    }, function (err) {
                      toaster.pop('error', msg.error, msg.server_comunication_error);
                    });
                  });
                }, angular.identity);
            }, $scope.displayMessages);
        };

        var msg = {};
        function init() {
            $scope.lookup = {};
            eggsFormFactory.addLookup($scope.lookup, 'customer_destination_id', 'customer_destination', 't.code', 't.description');
            localeFactory.loadTranslation('inventory')
            .then(function () {
                $translate(['error', 'server_comunication_error'])
                .then(function (data) {
                    msg = data;
                }, function (error) {
                    console.error(error);
                }).catch($scope.displayMessages);
            });
        }
        init();
    });

/**
 * @ngdoc function
 * @name ictportal.tnt.controller:TntRetunSerialKitCtrl
 * @description Gestione resi TNT (SIX-3241)
 * @author Rita Beltrami
 * 
 * @param è possibile specificare un parametro "code" che fissa una specifica customer destination
 * 
 * created on 23/05/2018
 * # TntRetunSerialKitCtrl
 * Controller of the ictportal.tnt
 */
angular.module('ictportal.tnt')
  .config(function ($routeProvider) {
      $routeProvider
      .when('/tnt/return/serialkit', {
        templateUrl: 'tnt/return-serial-kit/return-serial-kit.html',
        controller: 'TntRetunSerialKitCtrl'
      })
  })
  .controller('TntRetunSerialKitCtrl', function ($scope, $log, recordFactory, $location, 
                                          toaster, authFactory, tntReturnSerialKitFactory, dbFilterFactory,
                                         $q, COMPONENT_READ_MODE, $filter, localeFactory, eggsFormFactory,
                                          uiGridConstants, matrixParFactory, workflowFactory, serialKitService) {
                                         
    var portalBundle = 'portal';
    var pageBundle = 'return_serial_kit';
    $scope.element = {};
    $scope.settings = {
      isSaving: false,
      configLoaded: false,
      customerId: null
    };
    $scope.controlReasonList = [];
    $scope.readerMode = COMPONENT_READ_MODE.BARCODE;
    var msg = {
      "error": 'Error',
      "operation_completed": "Operation completed",
      "operation_completed_success": "Operation successfully completed",
      "server_comunication_error": "Server communication error",
      "product": 'Product',
      "barcode": 'Barcode',
      "quantity": 'Quantity',
      "date": 'Date',
      "info": "Information",
      "supplier": "Supplier",
      "status": "Status",
      "expiration_date": "Expiration date",
      "lot": "Lot",
      "warehouse": "Warehouse"
    };
    var page_msg = {
      "return_serial_kit": "Goods return",
      "MISSING_BARCODE": "Barcode not found",
      "SERIAL_KIT_NOT_FOUND": "Serial kit not found",
      "production_date": "Production date",
      "no_control_reason_found": "No valid control reason found",
      "incoherent_customer": "Incoherent customer",
      "incoherent_customer_msg": "Selected serial kits belong to different customers.",
      "MISSING_ID_LIST": "Missing or empty list of kit IDs",
      "CONTROL_REASON_NOT_FOUND": "Control reason not found",
      "EXPIRED_WARD_NOT_FOUND": "Control reason \"Expired wardrobe\" not found",
      "EXPIRED_DEST_NOT_FOUND": "Control reason \"Expired ward\" not found",
      "ERROR_MATRIX_CONTROL_REASON": "Error reading matrix par",
      "SK_NOT_FOUND": "Error while retrieving serial kit. Some not found.",
      "SHIPMENT_TYPE_NOT_FOUND": "Shipment document type not found",
      "MISSING_INVENTORY_REASON": "Inventory reason not found on selected shipment document type",
      "MISSING_FACILITY": "Facility reason not found on selected shipment document type",
      "INVALIDATING_ERROR": "Error while retrieving serial kits",
      "DDT_ERROR": "Error while creating shipment document",
      "AGREEMENT_ITEM_NOT_FOUND": "No valid agreement item found"
    };
    $scope.record = {
      lookup: {},
      dates: [],
      model: {}
    };
    
    var onRegisterApiCallback = function (gridApi) {
      $scope.gridApi = gridApi;
    }

    $scope.viewGridOptions = {
      enableSorting: true,
      appScopeProvider: $scope,
      enableFiltering: false,
      enableGridMenu: true,
      exporterMenuPdf: false,
      expandableRowHeight: 180,
      enableRowSelection: false,
      paginationPageSize: 10000,
      useExternalPagination: true,
      enableRowHeaderSelection: false,
      data: [],
      columnDefs: [],
      onRegisterApi: onRegisterApiCallback
    };
    var admittedStatusList = [];

    var readSerialKitIds = [];

    $scope.resetData = function() {
      $scope.viewGridOptions.data.length = 0;
    }

    $scope.canRead = function(){
      var result = !$scope.settings.isSaving && $scope.settings.configLoaded && angular.isDefined($scope.settings.controlReason);
      return result;
    }

    /**
     * Evento scatenato alla lettura di un barcode
     */
    $scope.readBarcode = function (read) {
      if($scope.canRead()){
        var filter = [
          {
            column: 'bom b',
            value: 't.bom_id = b.id',
            relation: 'JOIN',
            kind: 'b.item_id'
          },
          {
            column: 'product p',
            value: 'b.item_id = p.id',
            relation: 'JOIN',
            kind: 'p.code AS product_code,p.description AS product_description'
          },
          {
            column: 'supplier s',
            value: 't.supplier = s.id',
            relation: 'JOIN',
            kind: 's.description AS supplier_description'
          },
          {
            column: 'container c',
            value: 't.container_id = c.id',
            relation: 'JOIN',
            kind: 'c.description AS container_description'
          },
          {
            column: 'customer_destination cd',
            value: 't.customer_destination = cd.id',
            relation: 'JOIN',
            kind: 'cd.customer_id AS customer_id'
          }
        ];
        filter = filter.concat(dbFilterFactory.getStringFilter('t.barcode',read.read));
        recordFactory('serial_kit').filter({},filter).$promise
          .then(function(data){
            if(data.totalResults>0){
              var serialKit = data.list[0];
              // stato del kit ammesso?
              if(admittedStatusList.indexOf(serialKit.status)==-1){
                var statusTrans = $filter('filter')($scope.enum.status, {value: serialKit.status });
                localeFactory.translateReplace('return_serial_kit.invalid_kit_status', {barcode: serialKit.barcode, status: statusTrans[0].name}).then(function(transl){
                  toaster.pop('error',msg.error,transl);
                })
              }
              else{
                var alreadyRead = $filter('filter')($scope.viewGridOptions.data, {barcode: serialKit.barcode });
                // è una nuova lettura
                if(alreadyRead.length===0){
                  if($scope.settings.customerId===null) {
                    $scope.settings.customerId = serialKit.customer_id;
                  }
                  // Customer incoerente tra i vari kit (non saprei a chi intestare il DDT...)
                  if(serialKit.customer_id!=$scope.settings.customerId){
                    toaster.pop('error',page_msg.incoherent_customer,page_msg.incoherent_customer_msg);
                  }
                  // Tutto ok, aggiungo il kit alla lista
                  else{
                    $scope.viewGridOptions.data.push(data.list[0]);
                    readSerialKitIds.push(serialKit.id);
                  }
                }
                // ho già letto questo kit
                else{
                  localeFactory.translateReplace('return_serial_kit.barcode_already_read', {barcode: serialKit.barcode}).then(function(transl){
                    toaster.pop('info',msg.info,transl);
                  })
                }
              }
            }
            else{
              toaster.pop('error',msg.error,page_msg.SERIAL_KIT_NOT_FOUND);
            }
          })
          .catch(function(){
            toaster.pop('error',msg.error,page_msg.server_comunication_error);
          })
      }
    }

    $scope.invalidateSerialKits = function() {
      var jsonPayload = {
        serial_kit_ids: readSerialKitIds
      };
      tntReturnSerialKitFactory.tntReturnSerialKit( {param1: $scope.settings.controlReason.code}, jsonPayload).$promise.then(function(data){
        if(data.status=='ok') {
          toaster.pop('success', 'Invalidazione serial kit avvenuta con successo.');
          $scope.resetData();
          if(data.result){
            goToCreatedReturnDDT(data.result);
          }
        }
        else{
          eggsFormFactory.logServerException(data, pageBundle);
        }
      });
    }

    // Redirigo verso la pagina del DDT appena creato.
    function goToCreatedReturnDDT(id){
      var filters = dbFilterFactory.getCustomFilter("function_id in (select id from functions where jsf_action='#{customerReturnShipmentDocumentFunction.startPage}')");
      recordFactory('menu').filter({},filters).$promise.then(function(data){
        if(data.totalResults>0){
          var functionCode = data.list[0].menu_key;
          $location.url('jsf?functionCode=' + functionCode + '&selectedId=' + id);
        }
        else{
          toaster.pop('error', msg.error, 'DDT menu not found');
        }
      });
    }

    function translateGridColumns(){
      $scope.viewGridOptions.columnDefs.forEach(function(col){
        if(col.translation) {
          if(page_msg[col.translation]){
            col.displayName = page_msg[col.translation];
          }
          else{
            col.displayName = msg[col.translation];
          }
        }
      });
      if($scope.gridApi) {
        $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
      }
    }

    var initGridColumns = function () {
      $scope.lookupCols = [];
      var dateFormat = localeFactory.getDateFormat();
      $scope.viewGridOptions.columnDefs.push({
        name: 'Barcode',
        field: 'barcode',
        width: 140,
        translation: 'barcode'
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Product',
        field: 'item_id',
        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.product_code }} - {{ row.entity.product_description }}</div>',
        translation: 'product'
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Supplier',
        field: 'supplier_description',
        translation: 'supplier'
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Status',
        field: 'status',
        translation: 'status',
        cellTemplate: '<div class="ui-grid-cell-contents">{{ grid.appScope.getStatusTranslation( row.entity.status ) }}</div>',
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Warehouse',
        field: 'container_description',
        translation: 'warehouse'
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Production date',
        field: 'last_packing_date',
        width: 100,
        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.last_packing_date | date:\'' + dateFormat + '\' }}</div>',
        translation: 'production_date',
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Expiration date',
        field: 'expiration_date',
        width: 100,
        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.expiration_date | date:\'' + dateFormat + '\' }}</div>',
        translation: 'expiration_date'
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Lot',
        field: 'note',
        translation: 'lot'
      });
    }

    $scope.getStatusTranslation = function(status){
        return serialKitService.getStatusTranslation(status); 
    }

    $scope.selectReason = function(controlReason){
      $scope.settings.controlReason = controlReason;
    }

    function getAdmittedStatuses(){
      var deferred = $q.defer();
      workflowFactory.getSerialKitStatusPredecessors({param1: 'INVALIDATED'}).$promise
        .then(function(data){
          admittedStatusList = data.result;
          deferred.resolve(true);
      }).catch(function(){ 
        toaster.pop('error', msg.error, msg.server_comunication_error); 
        deferred.reject(false);
      });
      return deferred.promise;
    }    

    function getControlReasons(){
      var deferred = $q.defer();
      matrixParFactory.getMatrixPar({key: 'tntReturnSerialKit.reasonGroupCode', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}).$promise.then(function(response){                
        if(response.value){
          var filter = [
            {
            "column": "control_reason_group g",
            "value": "t.control_reason_group = g.id",
            "relation": "JOIN",
            "kind": "g.code AS control_reason_group_code"
            }
          ];
          filter = filter.concat(dbFilterFactory.getStringFilter('g.code',response.value));
          recordFactory('control_reason').filter({},filter).$promise
            .then(function(data){
              if(data.totalResults>0){
                $scope.controlReasonList = $scope.controlReasonList.concat(data.list);
                deferred.resolve(true);
              }
              else{
                toaster.pop('error',msg.error,page_msg.no_control_reason_found);
                deferred.reject(false);
              }
            })
            .catch(function(){
              toaster.pop('error',msg.error,page_msg.server_comunication_error);
              $log.error('Non riesco a trovare causali di reso valide.');
              deferred.reject(false);
            })
        }
      })
      .catch(function(){
        toaster.pop('error',msg.error,page_msg.server_comunication_error);
        $log.error('Non sono riuscito a leggere il parametro di matrix par tntReturnSerialKit.reasonGroupCode, che mi dice il gruppo di causali di reso che devo considerare.');
        deferred.reject(false);
      });
      return deferred.promise;
    }

    function initConfiguration(){
      var promises = [
        getAdmittedStatuses(),
        getControlReasons()
      ];
      $q.all(promises).then(function(responses){
        $scope.settings.configLoaded = true;
        for(var i=0; i<responses.length; i++){
          $scope.settings.configLoaded = $scope.settings.configLoaded && responses[i];
        }
      })
    }

    function checkPermissions() {
      var profilingKey = 'TNT_RETURN_SERIAL_KIT_FUNCTION';
      var permission = authFactory.getPermissions(profilingKey);
      if(!permission.EXEC) {
          $location.path('forbidden').search({key: profilingKey});
      }
  };

    function init() {
      $scope.enum = serialKitService.enum;
      initGridColumns();
      checkPermissions();
      localeFactory.loadTranslation('serialkit');
      localeFactory.loadTranslation(pageBundle)
        .then(function(){
          $q.all({
              general: localeFactory.translateMsg(msg),
              specific: localeFactory.translateMsg(page_msg, pageBundle)
          })
          .then(function(data){
            translateGridColumns();
          })
          .catch(function(ex){});
        })
        .catch(function(ex){});  
      initConfiguration();
      $scope.resetData();
    }

    init();

  });
angular.module('ictportal.tnt')
.service('tntDestinationSrv', function ($q, authFactory, recordFactory, dbFilterFactory, matrixParFactory) {

    var destinationTypes = $q.all({
        ward: matrixParFactory
        .getMatrixPar({ key:'receiverTypeService.finalDestination', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*' })
        .$promise,
        wardrobe: matrixParFactory
        .getMatrixPar({ key:'receiverTypeService.wardrobe', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*' })
        .$promise
    });

    var service = {};

    service.isWardrobe = function(destination) {
        if (!destination) return false;
        if (angular.isObject(destination)) {
            return service.isWardrobe(destination.receiver_type_code);
        }
        return destinationTypes.then(function(data){
            return destination == data.wardrobe.value;
        }, function(){
            return false;
        })
    };

    service.loadDestination = function(destinationCode) {
        console.log('Customer destination filter', destinationCode);
        if (destinationCode) {
            return $q.all([
                destinationTypes,
                recordFactory('customer_destination').filter({},
                    [{
                        column: 'receiver_type rt',
                        value: 't.receiver_type_id = rt.id',
                        relation: 'JOIN',
                        kind: 'rt.code as receiver_type_code'
                    }].concat(dbFilterFactory.getStringFilter('t.code', destinationCode)))
                    .$promise
                ])
                .then(function (results) {
                    var data = results[1];
                    if (data.list.length > 0) {
                        data.list[0].is_wardrobe = (data.list[0].receiver_type_code == results[0].wardrobe.value);
                        return data.list[0];

                    } else {
                        throw [{
                            status: 'error',
                            code: 'destination_not_found',
                            message: 'Cannot find customer destination',
                            params: [destinationCode]
                        }];
                    }
                });
            }
            return $q.reject([{
                status: 'error',
                code: 'missing_destination',
                message: 'Missing customer destination',
                params: []
            }]);
        };

        service.loadImplicitWard =function(){
            var authData = authFactory.getAuthData();
            var authorizations = authData && authData.info && authData.info.authorizations;
            if (authorizations && authorizations.destinations && authorizations.destinations.length > 0) {
                return destinationTypes.then(function(data){
                    return recordFactory('customer_destination').filter(
                        {page_size: authorizations.destinations.length},
                        [{
                            column: 'receiver_type rt',
                            value: 't.receiver_type_id = rt.id',
                            relation: 'JOIN'
                        }]
                        .concat(dbFilterFactory.getCustomFilter("t.id IN ("+authorizations.destinations.join(',')+")"))
                        .concat(dbFilterFactory.getStringFilter('rt.code', data.ward.value))
                    )
                    .$promise
                    .then(function(data){
                        if (data && data.list && data.list.length > 0) return data.list;
                        throw [{
                            status: 'error',
                            code: 'missing_ward',
                            message: 'Missing customer ward'
                        }];
                    }, function(err) {
                        console.error(err);
                        throw [{
                            status: 'error',
                            code: 'missing_ward',
                            message: 'Missing customer ward'
                        }];
                    })
                }, function(err){
                    throw [{
                        status: 'error',
                        code: 'server_comunication_error',
                        message: 'Server comunication error'
                    }];
                });
            }
            return destinationTypes.then(function(data){
                return recordFactory('customer_destination').filter(
                    {page_size: 2000}, // fix temporanea, la soluzione è usare le lookup
                    [{
                        column: 'receiver_type rt',
                        value: 't.receiver_type_id = rt.id',
                        relation: 'JOIN'
                    }]
                    .concat(dbFilterFactory.getStringFilter('rt.code', data.ward.value))
                )
                .$promise
                .then(function(data){
                    if (data && data.list && data.list.length > 0) return data.list;
                    throw [{
                        status: 'error',
                        code: 'missing_ward',
                        message: 'Missing customer ward'
                    }];
                }, function(err) {
                    console.error(err);
                    throw [{
                        status: 'error',
                        code: 'missing_ward',
                        message: 'Missing customer ward'
                    }];
                })
            }, function(err){
                throw [{
                    status: 'error',
                    code: 'server_comunication_error',
                    message: 'Server comunication error'
                }];
            });
        }

        service.loadImplicitDestination = function(destinationType){
            return destinationTypes.then(function(data){
                var receiverType = destinationType;
                var typeFilter = undefined;
                if (receiverType) {
                    Object.keys(data).forEach(function(key,index) {
                        if (destinationType == key) receiverType = data[key].value;
                    });
                    typeFilter = dbFilterFactory.getStringFilter('rt.code', receiverType);
                }
                var authData = authFactory.getAuthData();
                var authorizations = authData && authData.info && authData.info.authorizations;
                if (authorizations && authorizations.destinations && authorizations.destinations.length > 0) {
                    var wardrobeCode = data.wardrobe.value;
                    var filters = [{
                        column: 'receiver_type rt',
                        value: 't.receiver_type_id = rt.id',
                        relation: 'JOIN',
                        kind: 'rt.code as receiver_type_code'
                    }]
                    .concat(dbFilterFactory.getCustomFilter("t.id IN ("+authorizations.destinations.join(',')+")"));
                    if (receiverType) filters = filters.concat(typeFilter);
                    return recordFactory('customer_destination').filter(
                        {page_size: authorizations.destinations.length},
                        filters
                    )
                    .$promise
                    .then(function(data){
                        if (data && data.list && data.list.length > 0) {
                            data.list.forEach(function(part, index) {
                                this[index].is_wardrobe = (this[index].receiver_type_code == wardrobeCode);
                            }, data.list);
                            return data.list;
                        }
                        throw [{
                            status: 'error',
                            code: 'missing_destination',
                            message: 'No customer destination found',
                            params: []
                        }];
                    }, function(err) {
                        console.error(err);
                        throw [{
                            status: 'error',
                            code: 'missing_destination',
                            message: 'No customer destination found',
                            params: []
                        }];
                    })
                } else {
                    var wardrobeCode = data.wardrobe.value;
                    var filters = [{
                        column: 'receiver_type rt',
                        value: 't.receiver_type_id = rt.id',
                        relation: 'JOIN',
                        kind: 'rt.code as receiver_type_code'
                    }]
                    if (receiverType) filters = filters.concat(typeFilter);
                    return recordFactory('customer_destination').filter(
                        {page_size: -1},
                        filters
                    )
                    .$promise
                    .then(function(data){
                        if (data && data.list && data.list.length > 0) {
                            data.list.forEach(function(part, index) {
                                this[index].is_wardrobe = (this[index].receiver_type_code == wardrobeCode);
                            }, data.list);
                            return data.list;
                        }
                        throw [{
                            status: 'error',
                            code: 'missing_destination',
                            message: 'No customer destination found',
                            params: []
                        }];
                    }, function(err) {
                        console.error(err);
                        throw [{
                            status: 'error',
                            code: 'missing_destination',
                            message: 'No customer destination found',
                            params: []
                        }];
                    })
                }
            }, function(err){
                throw [{
                    status: 'error',
                    code: 'server_comunication_error',
                    message: 'Server comunication error',
                    params: []
                }];
            });
        }

        return service;
    });

'use strict';

/**
 * @ngdoc factory
 * @name ictportal.goodsInwardService
 * @description Factory with common variables and methods to handle goods_inward.
 * @author Rita Beltrami
 * created on 09/01/2018
 * # goodsInwardService
 * Factory in the ictportal.
 */
angular.module('ictportal.tnt')
  .service('tntGoodsInwardService', function ($log, $rootScope, toaster, localeFactory, recordFactory, $q, dbFilterFactory, matrixParFactory) {

    var goods_inward_msg = {
        CLOSED: 'Closed',
        DISPATCHED: 'Dispatched',
        TO_DISPATCH: 'To dispatch'
    };

    var msg = {
        error: 'Error',
        server_comunication_error: "Errore di comunicazione con il server"
    };

    var tntGoodsInwardService = {
        enum: {
            status: [
                {
                    name: 'Dispatched',
                    value: 'DISPATCHED'
                },
                {
                    name: 'To dispatch',
                    value: 'TO_DISPATCH'
                },
                {
                    name: 'Closed',
                    value: 'CLOSED'
                }
            ],
            insertionMode: [
                {
                    name: 'Barcode Cartone',
                    value: 'BARCODE'
                },
                {
                  name: 'QRcode Confezione',
                  value: 'QRCODE'
                },
                {
                    name: 'Multiplo (Creazione Confezioni)',
                    value: 'MULTIPLE'
                }//,
                // {
                //     name: 'Creazione Kit',
                //     value: 'CREAZIONE_KIT'
                // }
            ]
        }
    };

    tntGoodsInwardService.loadTntGoodsInwardType  = function(){
        var deferred = $q.defer();
        matrixParFactory.getMatrixPar({key: 'tntGoodsInward.typeCode', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}).$promise.then(function(response){
           if(response.value){
                recordFactory('goods_inward_type').filter({},dbFilterFactory.getStringFilter('code',response.value)).$promise
                .then(function(data){
                    if(data && data.totalResults>0){
                      deferred.resolve(data.list[0].id);
                    }
                })
                .catch(function(){
                  toaster.pop('error',msg.error,msg.file_server_comunication_error);
                  deferred.reject(undefined);
                  $log.error('Errore durante il recupero del tipo ricevimento merce di default');
                });
           }
        }).catch(function(){
          toaster.pop('error',msg.error,msg.file_server_comunication_error);
          deferred.reject(undefined);
          $log.error('Errore durante il recupero del tipo ricevimento merce di default');
        });
        return deferred.promise;
    }

    tntGoodsInwardService.loadTntGoodsInwardInventoryReason  = function(){
        var deferred = $q.defer();
        matrixParFactory.getMatrixPar({key: 'tntGoodsInward.inventoryReasonCode', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}).$promise.then(function(response){
           if(response.value){
                recordFactory('inventory_reason').filter({},dbFilterFactory.getStringFilter('code',response.value)).$promise
                .then(function(data){
                    if(data && data.totalResults>0){
                      deferred.resolve(data.list[0].id);
                    }
                })
                .catch(function(){
                  toaster.pop('error',msg.error,msg.file_server_comunication_error);
                  deferred.reject(undefined);
                  $log.error('Errore durante il recupero del tipo ricevimento merce di default');
                });
           }
        }).catch(function(){
          toaster.pop('error',msg.error,msg.file_server_comunication_error);
          deferred.reject(undefined);
          $log.error('Errore durante il recupero del tipo ricevimento merce di default');
        });
        return deferred.promise;
    }

    tntGoodsInwardService.loadDepotReceiverType  = function(){
        var deferred = $q.defer();
        matrixParFactory.getValueOrDefault({key: 'receiverTypeService.depot', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'},
            {defaultValue: "DEP"}).$promise.then(function(data){
                deferred.resolve(data.result.value);
        }).catch(function(){
          toaster.pop('error',msg.error,msg.file_server_comunication_error);
          deferred.reject(undefined);
          $log.error('Errore durante il recupero del tipo destinazione per deposito');
        });
        return deferred.promise;
    }

    // given a specific code, returns related warehouse id
    tntGoodsInwardService.loadWarehouse = function (code) {
        var filter = dbFilterFactory.getStringFilter('code', code);
        var deferred = $q.defer();
        recordFactory('facility').filter({}, filter).$promise
            .then(function (data) {
                if (data.totalResults == 0) {
                    localeFactory.translateReplace('goods_inward.warehouse_not_found', { code: code }).then(function (transl) {
                        toaster.pop('error', msg.error, transl);
                        deferred.reject(undefined);
                    });
                }
                else {
                    deferred.resolve(data.list[0].id);
                }
            })
            .catch(function () {
                deferred.reject(undefined);
            })
        return deferred.promise;
    }

    // given a specific code, returns related depot id
    tntGoodsInwardService.loadDepot = function (code) {
        var filter = dbFilterFactory.getStringFilter('t.code', code);
        var deferred = $q.defer();
        tntGoodsInwardService.loadDepotReceiverType().then(function(value){
            filter = filter.concat({
                column: 'receiver_type rt',
                value: 't.receiver_type_id = rt.id',
                relation: 'JOIN',
                kind: 'rt.code as type_code'
            });
            filter = filter.concat(dbFilterFactory.getStringFilter('rt.code',value));
            recordFactory('customer_destination').filter({}, filter).$promise
            .then(function (data) {
                if (data.totalResults == 0) {
                    localeFactory.translateReplace('goods_inward.depot_not_found', { code: code }).then(function (transl) {
                        toaster.pop('error', msg.error, transl);
                        deferred.reject(undefined);
                    });
                }
                else {
                    deferred.resolve(data.list[0].id);
                }
            })
            .catch(function () {
                deferred.reject(undefined);
            });
        });
        return deferred.promise;
    };

    tntGoodsInwardService.loadSupplier = function (code) {
      var filter = [];
      var deferred = $q.defer();
       filter = filter.concat({
          column: 'customer c',
          value: 't.id = c.supplier_id',
          relation: 'JOIN',
          kind: 't.description as supplier_desc'
        });
        filter = filter.concat({
          column: 'customer_destination cd',
          value: 'cd.customer_id = c.id',
          relation: 'JOIN',
        });
        filter = filter.concat(dbFilterFactory.getStringFilter('cd.code',code));
        recordFactory('supplier').filter({}, filter).$promise
          .then(function (data) {
            if (data.totalResults > 0) {
              deferred.resolve(data.list[0].id);
            } else {
              deferred.resolve(undefined);
            }
          });
      return deferred.promise;
    };

    tntGoodsInwardService.isSupplier = function (depotCode) {
      var deferred = $q.defer();
      matrixParFactory.getMatrixPar({
        key: 'shipmentToDispatchLMFunction.supplierDepots',
        d1: '*',
        d2: '*',
        d3: '*',
        d4: '*',
        d5: '*'
      }).$promise
        .then(function (data) {
          if (data && data.value) {
            deferred.resolve(data.value.split(',').indexOf(depotCode) !== -1);
          } else {
            deferred.resolve(false);
          }
        });
      return deferred.promise;
    };

    $rootScope.$on('$translateRefreshEnd', function () {
        localeFactory.translateMsg(msg);
        localeFactory.translateMsg(goods_inward_msg, 'goods_inward').then(function(){
            tntGoodsInwardService.enum.status.forEach(function(en){
                en.name = goods_inward_msg[en.value];
            });
        });
    });

    return tntGoodsInwardService;
  });

angular.module('ictportal.tnt')
.service('tntInventorySrv', function ($q, $interpolate, $filter, localeFactory,
    authFactory, recordFactory, dbFilterFactory, tntInventoryFactory, matrixParFactory, tntWarehouseSrv, serialKitService) {

        var fileNameExport = $interpolate('inventory-{{code}}-{{date | date:"yy-MM-dd"}}.xlsx');
        var dateFormat = localeFactory.getDateFormat();
        var dateFilter = $filter('date');
        var tntProducGroup = matrixParFactory
        .getMatrixPar({ key:'tntProductGroup', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*' })
        .$promise;

        var service = {};

        service.loadInventoryControlReason  = function(){
            var deferred = $q.defer();
            matrixParFactory.getValueOrDefault({key: 'controlReason.inventoryReasonCode', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'},
                {defaultValue: "inventory"}).$promise.then(function(data){
                    deferred.resolve(data.result.value);
            }).catch(function(){
              toaster.pop('error',msg.error,msg.file_server_comunication_error);
              deferred.reject(undefined);
              $log.error('Errore durante il recupero della causale di controllo per inventario');
            });
            return deferred.promise;
        }

        service.loadDestinationStorage = function (destination, queryParams, serialKit, aggrByLot) {
            if (destination && destination.id) {
                var filters = [{
                    column: 'bom b',
                    value: 't.bom_id = b.id',
                    relation: 'JOIN'
                }, {
                    column: 'product p',
                    value: 'b.item_id = p.id',
                    relation: 'JOIN'
                }]
                .concat(dbFilterFactory.getCustomFilter("t.status NOT IN ('CONSUMED','INVALIDATED','LOST','NEW')"))
                .concat(dbFilterFactory.getNumberFilter('t.customer_destination', destination.id));
                var fields = ['p.id', 'p.code', 'p.description'];
                if (aggrByLot) {
                    filters = filters.concat([{
                        column: 'lot l',
                        value: 't.production_lot_id = l.id',
                        relation: 'JOIN'
                    }]);
                    fields = fields.concat(['t.expiration_date', 'l.description as lot_description'])
                }
                if (serialKit && serialKit.length) {
                    filters = filters.concat(dbFilterFactory.getCustomFilter("t.barcode NOT IN ('"+serialKit.join("','")+"')"))
                }
                return recordFactory('serial_kit').aggregation(queryParams, {
                    filters: filters,
                    fields: fields,
                    operations: [{
                        function: "sum",
                        argument: "t.check_in_amount",
                        alias: "product_storage"
                    },{
                        function: "count",
                        argument: "t.id",
                        alias: "packs"
                    }]
                }).$promise;
            }
            return $q.reject([{
                status: 'error',
                code: 'missing_destination',
                message: 'Missing destination'
            }]);
        };


        service.getNotTrackedProduct = function(destination, queryParams, onlyEnd, alreadySelected){
          if (destination && destination.id) {
            return tntProducGroup.then(function(matrixPar){
              var codes = matrixPar.value.trim().split(",");
              var filters = [
                {
                  column: 'product_group pg',
                  value: 't.product_group_id = pg.id',
                  relation: 'JOIN'
                },
                {
                  column: 'customer_destination cd',
                  value: 'cd.id = ' + destination.id,
                  relation: 'full outer JOIN'
                },
                {
                  column: 'endowment e',
                  value: '(e.destination_id = cd.id and e.type = \'MONOUSO\')',
                  relation: 'left outer JOIN'
                },
                {
                  column: 'endowment_item ei',
                  value: '(t.id = ei.product_id and ei.endowment_id = e.id)',
                  relation: 'left outer JOIN'
                },
                {
                  column: 'bom b',
                  value: 't.id = b.item_id',
                  relation: 'left outer JOIN'
                },
                {
                  column: 'serial_kit sk',
                  value: '(b.id = sk.bom_id and sk.customer_destination = cd.id AND sk.status <> \'LOST\')',
                  relation: 'left outer JOIN'
                },
                {
                  column: 'pg.code',
                  value: "'" + codes.join("','") + "'",
                  kind: 'in'
                },
                {
                  column: '',
                  value: "t.code not in('" + alreadySelected.join("','") + "')",
                  kind: 'custom'
                },
                {
                  column: '',
                  value: '(ei.tracked is false or t.identification = 3)',
                  kind: 'custom'
                }
              ];
              if (onlyEnd) {
                filters = filters.concat([
                  {
                    column: 'ei.tracked',
                    value: 'false',
                    relation: '=',
                    kind: 'boolean'
                  }
                ]);
              } else {
                filters = filters.concat([
                  {
                    column: '',
                    value: '(ei.tracked is null or ei.tracked = true)',
                    relation: '',
                    kind: 'custom'
                  }
                ]);
              }
              return recordFactory('product').aggregation(queryParams, {
                filters: filters,
                fields: ['t.id', 't.code', 't.description', 't.quantity_included product_qta', 'ei.tracked'],
                operations: [{
                  function: "sum",
                  argument: "sk.check_in_amount",
                  alias: "product_storage"
                },{
                  function: "count",
                  argument: "sk.id",
                  alias: "packs"
                }]
              }).$promise;
            });
          }
        };

        service.getDestinationMissingAmount = function(destination, serialKit, startDate) {
            if (destination) {
                return tntProducGroup.then(function(matrixPar){
                    var codes = matrixPar.value.trim().split(",");
                    var filters = [{
                        column: 'bom b',
                        value: 't.bom_id = b.id',
                        relation: 'JOIN'
                    },{
                        column: 'product p',
                        value: 'b.item_id = p.id',
                        relation: 'JOIN',
                        kind: 'p.code as product_code, p.id as product_id, p.description as product_description'
                    },{
                        column: 'product_group pg',
                        value: 'p.product_group_id = pg.id',
                        relation: 'JOIN'
                    },
                      {
                        column: 'serial_kit_status sks',
                        value: 'sks.id = t.current_serial_kit_status_id',
                        relation: 'JOIN'
                      }]
                    .concat(dbFilterFactory.getCustomFilter("t.status NOT IN ('CONSUMED','INVALIDATED','LOST','NEW')"))
                    .concat(dbFilterFactory.getCustomFilter( dbFilterFactory.getOrQuery('pg.code', codes) ))
                    .concat(dbFilterFactory.getNumberFilter('t.customer_destination', destination) );
                    if(startDate != null){
                      filters = filters.concat(dbFilterFactory.getDateFilter('sks.operation_date', startDate, '<'));
                    }
                    if (serialKit && serialKit.length > 0) {
                        filters = filters.concat(dbFilterFactory.getCustomFilter("t.id NOT IN ("+serialKit.join(",")+")"))
                    }
                    return recordFactory('serial_kit').filter({ page_size: 100000 }, filters).$promise.then(function(data){
                        if (data && data.list) {
                            return data.list.length;
                        }
                        return $q.reject([{
                            status: 'error',
                            code: 'server_comunication_error',
                            message: 'Server error'
                        }]);
                    });
                });
            }
            return $q.reject([{
                status: 'error',
                code: 'missing_destination',
                message: 'Missing destination'
            }]);
        };

        service.getKitsFromInventory = function(inventories){
            var filters = [{
              column: 'inventory_archive_detail iad',
              value: 't.id = iad.serial_kit_id',
              relation: 'JOIN',
            },{
              column: 'inventory_archive ia',
              value: 'iad.inventory_archive = ia.id',
              relation: 'JOIN',
            }]
              .concat(dbFilterFactory.getCustomFilter("ia.processed = 'F'"));
            if (inventories && inventories.length > 0) {
              filters = filters.concat(dbFilterFactory.getCustomFilter("ia.id IN ("+inventories.join(",")+")"))
            }
            return recordFactory('serial_kit').filter({ page_size: 100000 }, filters).$promise.then(function(data){
                return data;
              })
        };

        service.loadDestinationMissing = function (destination, serialKit) {
            if (destination && destination.id) {
                return tntProducGroup.then(function(matrixPar){
                    var codes = matrixPar.value.trim().split(",");
                    var filters = [{
                        column: 'bom b',
                        value: 't.bom_id = b.id',
                        relation: 'JOIN'
                    }, {
                        column: 'product p',
                        value: 'b.item_id = p.id',
                        relation: 'JOIN',
                        kind: 'p.code as product_code, p.id as product_id, p.description as product_description'
                    },{
                        column: 'lot l',
                        value: 't.production_lot_id = l.id',
                        relation: 'JOIN',
                        kind: 'l.code as lot_code'
                    },{
                        column: 'supplier s',
                        value: 't.supplier = s.id',
                        relation: 'JOIN',
                        kind: 's.description as supplier'
                    },{
                        column: 'product_group pg',
                        value: 'p.product_group_id = pg.id',
                        relation: 'JOIN'
                    }]
                    .concat(dbFilterFactory.getCustomFilter("t.status NOT IN ('CONSUMED','INVALIDATED','LOST')"))
                    .concat(dbFilterFactory.getCustomFilter( dbFilterFactory.getOrQuery('pg.code', codes) ))
                    .concat(dbFilterFactory.getNumberFilter('t.customer_destination', destination.id));
                    if (serialKit && serialKit.length) {
                        filters = filters.concat(dbFilterFactory.getCustomFilter("t.id NOT IN ("+serialKit.join(",")+")"))
                    }
                    return paginationSk(filters, 1, []);
                });
            }
            return $q.reject([{
                status: 'error',
                code: 'missing_destination',
                message: 'Missing destination'
            }]);
        }

        var pageSize = 100;
        function paginationSk(filters, page, serialKits) {
            return recordFactory('serial_kit').filter({ page_size: pageSize, page: page }, filters)
            .$promise.then(function(data){
                if (data && data.list) {
                    serialKits.push.apply(serialKits, data.list);
                    if (data.list.length == pageSize) return paginationSk(filters, page + 1, serialKits);
                    return serialKits;
                }
                throw [{
                    status: 'error',
                    code: 'server_comunication_error',
                    message: 'Server error'
                }];
            });
        }

        service.loadSerialKit = function (barcode) {
            if (barcode) {
                return tntProducGroup.then(function(matrixPar) {
                    var codes = matrixPar.value.trim().split(",");
                    var filters = [{
                        column: 'bom b',
                        value: 't.bom_id = b.id',
                        relation: 'JOIN'
                    }, {
                        column: 'product p',
                        value: 'b.item_id = p.id',
                        relation: 'JOIN',
                        kind: 'p.code as product_code, p.id as product_id, p.description as product_description'
                    },{
                        column: 'product_group pg',
                        value: 'p.product_group_id = pg.id',
                        relation: 'JOIN'
                    },{
                        column: 'lot l',
                        value: 't.production_lot_id = l.id',
                        relation: 'JOIN',
                        kind: 'l.code as lot_description'
                    },{
                        column: 'supplier s',
                        value: 't.supplier = s.id',
                        relation: 'JOIN',
                        kind: 's.description as supplier'
                    }]
                    .concat(dbFilterFactory.getCustomFilter('(t.barcode = \''+barcode+'\' OR t.envelope = \''+barcode+'\')'))
                    .concat(dbFilterFactory.getCustomFilter( dbFilterFactory.getOrQuery('pg.code', codes) ))
                    .concat(dbFilterFactory.getStringFilter('status', 'CONSUMED', '<>'));
                    return recordFactory('serial_kit').filter({ page_size: -1 }, filters).$promise;
                });
            }
            return $q.reject([{
                status: 'error',
                code: 'missing_parcode',
                message: 'Missing barcode'
            }]);
        }

        service.export = function(destination, serialKits, missingDataP) {
            var workbook =  {
                SheetNames: [],
                Sheets: {}
            };

            var skData = serialKits.map(function(s){
                return [
                    s.barcode, s.envelope, serialKitService.getStatusTranslation(s.status), s.product_code, s.product_description, s.supplier,
                    new Date(s.expiration_date), s.lot_description, s.check_in_amount
                ];
            });
            skData.unshift(['Barcode', 'Cartone', 'Stato precedente', 'Codice prodotto', 'Descrizione Prodotto', 'Fornitore',
            'Data di scadenza', 'Lotto', 'Qnt. Inclusa']);
            appendSheet(workbook, getSheet(skData), "Letti");

            var movedSk = serialKits.filter(function(s) { return s.customer_destination != destination.id; });
            var otherDestination = {};
            movedSk.forEach(function(s){
                otherDestination[s.customer_destination] = 1;
            });

            var promises = [];
            if(missingDataP) {
              promises.push(missingDataP);
            } else {
              promises.push(service.loadDestinationMissing(destination,serialKits.map(function(s) { return s.id; })));
            }
            if (Object.keys(otherDestination) != null && Object.keys(otherDestination).length > 0) {
              promises.push(tntWarehouseSrv.loadDestination(Object.keys(otherDestination)));
            }

            return $q.all(promises)
            .then(function(results){
                var missingData = results[0].map(function(s){
                    return [
                        s.barcode, s.envelope, serialKitService.getStatusTranslation(s.status), s.product_code,
                        s.product_description, s.supplier,
                        new Date(s.expiration_date), s.lot_code, s.check_in_amount
                    ];
                });
                missingData.unshift(['Barcode', 'Cartone', 'Stato precedente', 'Codice prodotto', 'Descrizione Prodotto', 'Fornitore',
                'Data di scadenza', 'Lotto', 'Qnt. Inclusa']);
                appendSheet(workbook, getSheet(missingData), "Persi");

                if (results && results.length > 0 && results[1] && results[1].list && results[1].list.length > 0) {
                  results[1].list.forEach(function(w){ otherDestination[w.id] = w; });
                }

                movedSk = movedSk.map(function(s){
                    return [
                        s.barcode, s.envelope, serialKitService.getStatusTranslation(s.status), s.product_code, s.product_description, s.supplier,
                        new Date(s.expiration_date), s.lot_code, s.check_in_amount,
                        otherDestination[s.customer_destination].code, otherDestination[s.customer_destination].description
                    ];
                });
                movedSk.unshift(['Barcode', 'Cartone', 'Stato precedente', 'Codice prodotto', 'Descrizione Prodotto', 'Fornitore',
                'Data di scadenza', 'Lotto', 'Qnt. Inclusa', 'Codice magazzino', 'Magazzino']);
                appendSheet(workbook, getSheet(movedSk), "Spostati");

                var wbout = XLSX.write(workbook, { bookType: 'xlsx', bookSST: false, type: 'binary' });
                saveAs(new Blob([s2ab(wbout)], {type: ""}), fileNameExport({ code: destination.code, date: new Date()}));
                return true;
            });
        }

        service.getNotTrackedSk = function(list, destination) {
          return tntInventoryFactory.getNotTrackedSerialKit({customer_destination_id: destination}, list).$promise;
        }

        service.confirm = function(destination, serialKits, workstation){
            return tntInventoryFactory.confirm({},{
                destination_id: destination.id,
                workstation_id: workstation,
                creation_date: new Date(),
                serial_kits: serialKits.map(function(s) {
                    return { id: s.id, barcode: s.barcode };
                })
            }).$promise;
        }

        service.finalize = function(destination, inventories, workstation){
            return tntInventoryFactory.finalize({},{
                destination_id: destination.id,
                workstation_id: workstation,
                finalize_date: new Date(),
                inventories: inventories
            }).$promise;
        }

        service.confirmDelete = function(inventories){
          return tntInventoryFactory.delete({},{
            inventories: inventories
          }).$promise
        }

        service.updateHistory = function(destination, serialKits, lostKits, workstation){
            var allKits = serialKits.map(function(s) {
                return { id: s.id, barcode: s.barcode };
            });
            allKits = allKits.concat(lostKits);
            return tntInventoryFactory.updateHistory({},{
                destination_id: destination.id,
                workstation_id: workstation,
                creation_date: new Date(),
                serial_kits: allKits
            }).$promise;
        }

        function getSheet(data){
            var ws = {};
            var range = {s: {c:10000000, r:10000000}, e: {c:0, r:0}};
            data.forEach(function(row, R) {
                row.forEach(function(cellValue, C){
                    if(typeof cellValue === 'undefined') return;
                    if(range.s.r > R) range.s.r = R;
                    if(range.s.c > C) range.s.c = C;
                    if(range.e.r < R) range.e.r = R;
                    if(range.e.c < C) range.e.c = C;
                    if(cellValue === null) return;
                    var cell = { v: cellValue };
                    if(typeof cell.v === 'number') cell.t = 'n';
                    else if(typeof cell.v === 'boolean') cell.t = 'b';
                    else if(cell.v instanceof Date) {
                        cell.t = 's';
                        cell.z =  dateFormat
                        cell.v = dateFilter(cell.v, dateFormat);
                    }
                    else cell.t = 's';
                    var cell_ref = XLSX.utils.encode_cell({ c: C, r: R });
                    ws[cell_ref] = cell;
                });
            });
            if(range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
            return ws;
        }

        function appendSheet(wb, ws, name) {
            if(!name) for(var i = 1; i <= 0xFFFF; ++i) if(wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
            if(!name) throw new Error("Too many worksheets");
            if(wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
            wb.SheetNames.push(name);
            wb.Sheets[name] = ws;
        }

        function s2ab(s) {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
        }

        return service;
    });

'use strict';

angular.module('ictportal.tnt')
.service('tntReorderSrv', function ($q, matrixParFactory, profilePermissionFactory, authFactory,
    endowmentFactory, customerOrderFactory, checkInFactory, recordFactory, dbFilterFactory, toaster) {

        var orderTypes = $q.all({
            ward: matrixParFactory
            .getMatrixPar({ key: 'tntReorderWardrobeOrderType', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*' })
            .$promise,
            wardrobe: matrixParFactory
            .getMatrixPar({ key: 'tntReorderPlantOrderType', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*' })
            .$promise
        });

        var service = {};

        service.loadWardOrderType = function () {
            return loadOrderType('ward');
        };

        service.loadWardrobeOrderType = function () {
            return loadOrderType('wardrobe');
        };

        service.loadOrderType = function (orderType) {
            console.log('Order type', orderType);
            if (orderType) {
                return recordFactory("ordertype").filter(
                    {},
                    [{
                        column: 'shipment_type s',
                        value: 's.id = t.shipment_type_id',
                        relation: 'JOIN',
                        kind: 's.slash as ddt_slash'
                    }].concat(dbFilterFactory.getStringFilter('t.code', orderType))
                )
                .$promise.then(function (data) {
                    if (data.list.length > 0) {
                        return data.list[0];
                    } else {
                        console.error('Cannot find order type', orderType);
                        throw [{
                            status: 'error',
                            code: 'order_type_not_found',
                            message: 'Cannot find order type',
                            params: [orderType]
                        }];
                    }
                })
            }
            return $q.reject([{
                status: 'error',
                code: 'missing_order_type',
                message: 'Missing order type',
                params: []
            }]);
        };

        service.loadEndowments = function (destination, copysMode) {
            var request = {
                validity_date: new Date(),
                customer_id: destination.customer_id,
                type: 'BUDGET',
                customer_destination_id: destination.id,
                copys_mode: copysMode
            };

            if (destination.is_wardrobe) {
                return endowmentFactory.get({}, request).$promise.then(loadWardrobeEndowments);
            } else {
                return endowmentFactory.get({}, request).$promise.then(loadWardEndowments);
            }
        };

        service.loadDestinationStorage = function (wardrobeId, productIds) {
            var filters = [{
                column: 'bom b',
                value: 't.bom_id = b.id',
                relation: 'JOIN'
            }, {
                column: 'product p',
                value: 'b.item_id = p.id',
                relation: 'JOIN'
            }]
            .concat(dbFilterFactory.getCustomFilter("t.status NOT IN ('CONSUMED','INVALIDATED','LOST')"))
            .concat(dbFilterFactory.getCustomFilter('p.id IN (' + productIds.join(',') + ')'))
            .concat(dbFilterFactory.getNumberFilter('t.customer_destination', wardrobeId));
            return recordFactory('serial_kit').aggregation({ page_size: productIds.length }, {
                filters: filters,
                fields: ['p.id'],
                operations: [{
                    function: "sum",
                    argument: "t.check_in_amount",
                    alias: "product_storage"
                }]
            }).$promise;
        }

        service.loadWardrobeSent = function (wardrobeId, dateFilter, productIds) {
            var filters = [{
                column: 'shipment s',
                value: 't.shipment_item = s.id',
                relation: 'JOIN'
            }, {
                column: 'customer_destination cd',
                value: 's.customer_destination = cd.id',
                relation: 'JOIN'
            }]
            .concat(dbFilterFactory.getStringFilter('s.discriminator', 'CUSTOMER'))
            .concat(dbFilterFactory.getDateFilter('s.ddt_date', dateFilter.from, '>='))
            .concat(dbFilterFactory.getDateFilter('s.ddt_date', dateFilter.to, '<='))
            .concat(dbFilterFactory.getStringFilter('t.state', 'CANCELED', '<>'))
            .concat(dbFilterFactory.getCustomFilter('t.item_id IN (' + productIds.join(',') + ')'))
            .concat(dbFilterFactory.getNumberFilter('cd.parent', wardrobeId));
            return recordFactory('shipment_item').aggregation({ page_size: productIds.length }, {
                filters: filters,
                fields: ['t.item_id'],
                operations: [{
                    function: "sum",
                    argument: "stock_amount",
                    alias: "product_sent"
                }]
            }).$promise;
        }

        /**
         * Given a ward, loads parent wardrobe.
         */
        service.getWardrobe = function(wardrobeId) {
            return recordFactory('customer_destination').byId({ id: wardrobeId }).$promise;
        }

        service.loadTotalWardBudget = function (wardrobeId, productIds) {
            var filters = [{
                column: 'endowment e',
                value: 'e.id = t.endowment_id',
                relation: 'JOIN'
            }, {
                column: 'customer_destination cd',
                value: 'e.destination_id = cd.id',
                relation: 'JOIN'
            }]
            .concat(dbFilterFactory.getValidityFilter(new Date()))
            .concat(dbFilterFactory.getCustomFilter('t.product_id IN (' + productIds.join(',') + ')'))
            .concat(dbFilterFactory.getNumberFilter('cd.parent', wardrobeId))
            .concat(dbFilterFactory.getStringFilter('e.type', "BUDGET"));
            return recordFactory('endowment_item').aggregation({ page_size: productIds.length }, {
                filters: filters,
                fields: ['t.product_id'],
                operations: [{
                    function: "sum",
                    argument: "t.budget",
                    alias: "budget"
                }]
            }).$promise
        }

        service.loadConsumed = function (destinationId, productIds) {
            var filters = dbFilterFactory.getStringFilter('status', 'NEW')
            .concat(dbFilterFactory.getCustomFilter('item_id IN (' + productIds.join(',') + ')'))
            .concat(dbFilterFactory.getNumberFilter('customer_destination_id', destinationId));
            return recordFactory('serial_kit_check_in').aggregation({ page_size: productIds.length }, {
                filters: filters,
                fields: ['item_id'],
                operations: [{
                    function: "sum",
                    argument: "quantity",
                    alias: "consumed"
                }]
            }).$promise
        }

        service.getDateFilter = function (frequency) {
            switch (frequency) {
                case 'MONTHLY':
                return { from: moment().startOf('month').toDate(), to: moment().endOf('month').toDate() };
                case 'THREE_MONTHS':
                return { from: moment().startOf('quarter').toDate(), to: moment().endOf('quarter').toDate() };
                case 'SIX_MONTHS':
                if (moment().month() > 5) {
                    return { from: moment().startOf('year').add(6, 'months').startOf('month').toDate(), to: moment().endOf('year').toDate() };
                } else {
                    return { from: moment().startOf('year').toDate(), to: moment().add(5, 'months').endOf('month').toDate() };
                }
                case 'YEARLY':
                return { from: moment().startOf('year').toDate(), to: moment().endOf('year').toDate() };
                default:
                throw "Unknown frequency";
            }
        }

        service.validateSupplierOrder = function(yourOrder, yourOrderDate) {
            var outcome = true;
            // trim
            if (yourOrder) {
              yourOrder = yourOrder.trim();
            } else {
              toaster.pop('error', 'Errore', 'Ordine fornitore vuoto : valorizzarlo per procedere ');
              return false;
            }
            // se compilati, i campi del vostroordine devono essere entrambi valorizzati
            if ((yourOrder && !yourOrderDate) ||
                (!yourOrder && yourOrderDate)) {
                    toaster.pop('error', 'Errore', 'Compilare entrambi i campi dell\'ordine fornitore');
                    outcome = false;
            } else {
                var today = new Date();
                today.setHours(0,0,0,0);
                // data vostroordine deve essere passata
                if (yourOrderDate > today) {
                    toaster.pop('error', 'Errore', 'La data ordine fornitore non può essere futura');
                    outcome = false;
                }
            }
            return outcome;
        }

        function truncateVostroOrdineIfNecessary(yourOrder) {
            var maxLength = 20;
            var vostroOrdine = yourOrder;
            if(vostroOrdine && vostroOrdine.length>maxLength) {
                vostroOrdine = yourOrder.substring(0, 19);
            }
            return vostroOrdine;
        }

        service.saveOrder = function (destination, orderType, priority, rows, yourOrder, yourOrderDate, note, orderReference, orderReferenceDate) {
            var vostroOrdine = truncateVostroOrdineIfNecessary(yourOrder);

            var orderRequest = {
                customer_destination: destination.id,
                type: orderType.id,
                priority: priority,
                note: note,
                vostro_ordine: vostroOrdine,
                data_vostro_ordine: yourOrderDate,
                order_reference: orderReference,
                order_reference_date: orderReferenceDate,
                row_list: rows.map(function (e) {
                    return {
                        product_id: e.product.id,
                        stock_amount: e.stock_amount,
                        agreement_id: e.agreement.id
                    };
                })
            }
            if (!destination.is_wardrobe) {
                var prodIds = rows.filter(function (r) { return r.reorder_type == 'CONSUMED'; })
                .map(function (r) { return r.product.id; });
                if (prodIds.length > 0) {
                    return checkInFactory.checkReordered({ param2: destination.id }, prodIds).$promise
                    .then(function (data) {
                        if (data.status == 'ok') {
                            return customerOrderFactory.create({}, orderRequest).$promise
                        }
                        return data;
                    })
                }
            }
            return customerOrderFactory.create({}, orderRequest).$promise;
        }

        function loadWardrobeEndowments(data) {
            if ((data.status == 'ok' || data.status == 'warnings') && data.result.items.length > 0) {
                var productIds = [],
                destination_id = data.result.destination_id;
                data.result.items.forEach(function (item) {
                    productIds.push(item.product.id);
                });
                return $q.all([
                    service.loadDestinationStorage(destination_id, productIds),
                    service.loadWardrobeSent(destination_id, service.getDateFilter(data.result.budget_frequency), productIds),
                    service.loadTotalWardBudget(destination_id, productIds)
                ])
                .then(function (results) {
                    var storageMap = {};
                    if (results[0].list) {
                        results[0].list.forEach(function (item) {
                            storageMap[item.id] = item.product_storage;
                        });
                    }
                    var sentMap = {};
                    if (results[1].list) {
                        results[1].list.forEach(function (item) {
                            sentMap[item.item_id] = item.product_sent;
                        });
                    }
                    var budgetMap = {};
                    if (results[2].list) {
                        results[2].list.forEach(function (item) {
                            budgetMap[item.product_id] = item.budget;
                        });
                    }
                    data.result.items.forEach(function (item) {
                        item.consumed_amount = sentMap[item.product.id] || 0;
                        item.storage_amount = storageMap[item.product.id] || 0;
                        item.ward_budget = budgetMap[item.product.id] || 0;
                        item.residual_budget = item.ward_budget - item.consumed_amount;
                    });
                    return data;
                });
            }
            return data;
        }

        function loadWardEndowments(data) {
            if ((data.status == 'ok' || data.status == 'warnings') && data.result.items.length > 0) {
                var productIds = [],
                destinationId = data.result.destination_id;
                data.result.items.forEach(function (item) {
                    productIds.push(item.product.id);
                });
                return $q.all([
                    service.loadDestinationStorage(destinationId, productIds),
                    service.loadConsumed(destinationId, productIds)])
                    .then(function (results) {
                        var storageMap = {};
                        if (results[0].list) {
                            results[0].list.forEach(function (item) {
                                storageMap[item.id] = item.product_storage;
                            });
                        }
                        var consumedMap = {};
                        if (results[1].list) {
                            results[1].list.forEach(function (item) {
                                consumedMap[item.item_id] = -item.consumed; // negato poiché il consumato a db è salvato in negativo
                            });
                        }
                        data.result.items.forEach(function (item) {
                            item.consumed_amount = consumedMap[item.product.id] || 0;
                            item.storage_amount = storageMap[item.product.id] || 0;
                            item.residual_budget = item.available;
                            // max packages
                            if (item.residual_budget <= 0 || item.residual_budget < item.minlot) {
                                item.max_packages = 0;
                            } else {
                                item.max_packages = Math.floor(item.residual_budget / Math.max(item.product.quantity_included, 1))
                            }
                            // min packages
                            if (item.reorder_type == 'CONSUMED' && item.consumed_amount) {
                                item.min_packages = Math.ceil(item.consumed_amount / Math.max(item.product.quantity_included, 1))
                            } else {
                                item.min_packages = 0;
                            }
                        });
                        return data;
                    });
                }
                return data;
            }

            function loadOrderType(key) {
                return orderTypes.then(function (data) {
                    return service.loadOrderType(data[key].value);
                }, function (err) {
                    throw [{
                        status: 'error',
                        code: 'missing_order_type',
                        message: 'Missing order type',
                        params: []
                    }]
                });
            }

            return service;
        });

angular.module('ictportal.tnt')
.service('tntWarehouseSrv', function ($q, authFactory, recordFactory, dbFilterFactory, tntGoodsInwardService) {
    
    var service = {};
    
    service.loadImplicitWarehouses = function () {
        var authData = authFactory.getAuthData();
        var authorizations = authData && authData.info && authData.info.authorizations;
        // [SIXLM-457] invece dei magazzini vengono utilizzati i contenitori associati alle destinazioni impostate sull'utente
        var filters = [{
            column: 'customer_destination cd',
            value: 'cd.container_id = t.id',
            relation: 'JOIN'
        },
        {
            column: 'container_type ct',
            value: 't.container_type_id = ct.id',
            relation: 'JOIN'
        }].concat(dbFilterFactory.getStringFilter('ct.code', 'TNT'));
        if (authorizations && authorizations.destinations && authorizations.destinations.length > 0) {
            filters = filters.concat(dbFilterFactory.getCustomFilter("cd.id IN (" + authorizations.destinations.join(',') + ")"));
        }
        return recordFactory('container').filter({ page_size: 1000 }, filters).$promise
        .then(function (data) {
            if (data && data.list && data.list.length > 0) return data.list;
            throw [{
                status: 'error',
                code: 'missing_warehouse',
                message: 'Missing warehouse'
            }];
        }, function (err) {
            console.error(err);
            throw [{
                status: 'error',
                code: 'missing_warehouse',
                message: 'Missing warehouse'
            }];
        });
    };

    service.loadWarehouse = function(ids) {
        if (angular.isArray(ids)) {
            if (ids.length == 0) return $q.resolve({ list:[], pageSize: 0, totalResults: 0 });
            return recordFactory('container')
            .filter({page_size: ids.length}, dbFilterFactory.getCustomFilter('t.id IN ('+ids.join(',')+')'))
            .$promise;
        } else if (angular.isNumber(ids)) {
            return recordFactory('container').byId({id: ids}).$promise;
        }
    }

    service.loadAvailableDepots = function () {
        var depotFilter = [];
        var authData = authFactory.getAuthData();
        if (authData.filters.customer_destination && authData.filters.customer_destination.length > 0) {
            depotFilter = depotFilter.concat(authData.filters.customer_destination);
        }
        return tntGoodsInwardService.loadDepotReceiverType().then(function(value){
            var filter = [{
                column: 'receiver_type rt',
                value: 't.receiver_type_id = rt.id',
                relation: 'JOIN',
                kind: 'rt.code as type_code'
            }];
            depotFilter = depotFilter.concat(filter.concat(dbFilterFactory.getStringFilter('rt.code',value)));
            return recordFactory('customer_destination').filter({ page_size: 1000 }, depotFilter).$promise
            .then(function (data) {
                if (data && data.list && data.list.length > 0) return data.list;
                throw [{
                    status: 'error',
                    code: 'no_depot',
                    message: 'No depot found'
                }];
            }, function (err) {
                console.error(err);
                throw [{
                    status: 'error',
                    code: 'no_depot',
                    message: 'No depot found'
                }];
            });
        });        
    };
   
    return service;
});
'use strict';

angular.module('ictportal.tnt')
.config(function ($routeProvider) {
    $routeProvider
    .when('/tnt/warehousestorage/list', {
        templateUrl: 'tnt/warehouse-storage/warehouse-storage-list.html',
        controller: 'WarehouseStorageListCtrl'
    })
})
.controller('WarehouseStorageListCtrl',function($scope, $timeout, $routeParams, $location, $filter, localeFactory, recordFactory, eggsFormFactory, dbFilterFactory, authFactory, matrixParFactory){
    
    $scope.preselectSupplier = false;
    $scope.viewGridOptions = {
        enableRowSelection: true,
        enableFullRowSelection: true,
        rowSelectionChanged: viewDetail,
        enableFiltering: false,
        useExternalSorting: true,
        appScopeProvider: $scope,
        columnDefs: [{
            name:'detail',
            displayName: '',
            width: 34,
            enableColumnResizing: false,
            enableColumnMenu: false,
            enableSorting: false,
            cellTemplate:
            '<div ng-if="row.entity.tracked || row.entity.identification !== 3" class="ui-grid-cell-contents" style="text-align: center">' +
            ' <button class="btn btn-xs btn-primary">' +
            '  <span class="fa fa-list-ul"></span>' +
            ' </button>' +
            '</div>'
        },{
            field: 'code',
            displayName: 'product',
            headerCellFilter: 'translate',
            width: '*'
        },{
            field: 'description',
            displayName: 'description',
            headerCellFilter: 'translate',
            width: '**'
        },{
            field: 'supplier_description',
            displayName: 'supplier',
            headerCellFilter: 'translate',
            width: '**'
        },{
            field: 'packs',
            displayName: 'warehouse_storage.packs',
            headerCellFilter: 'translate',
            width: 100
        },{
            field: 'count',
            displayName: 'warehouse_storage.count',
            headerCellFilter: 'translate',
            width: 100
        }]
    };
    $scope.detailGridOptions = {
        paginationPageSize: 10,
        paginationPageSizes: [10, 15],
        useExternalPagination: false,
        useExternalSorting: true,
        enableFiltering: false,
        columnDefs:[{
            field: 'envelope',
            displayName: 'Cartone',
            headerCellFilter: 'translate'
        },{
            field: 'expiration_date',
            displayName: 'expiration_date',
            headerCellFilter: 'translate',
            cellFilter: 'date:"'+localeFactory.getDateFormat()+'"',
            exportCelFormat: function(ms){  return dateFilter(ms, dateFormat); }
        },{
            field: 'warehouse',
            displayName: 'warehouse',
            headerCellFilter: 'translate'
        },{
            field: 'lot_code',
            displayName: 'warehouse_storage.lot',
            headerCellFilter: 'translate'
        },{
            field: 'check_in_amount',
            displayName: 'quantity',
            headerCellFilter: 'translate'
        }]
    };
    $scope.filters = {};
    $scope.aggs = [];
    
    var dateFormat = localeFactory.getDateFormat();
    var dateFilter = $filter('date');
    $scope.aggregations =[
        {
            key: 'warehouse', 
            description: 'Magazzini',
            fields: ['c.description AS warehouse_description', 'cd.container_id'],
            columns: [{
                field: 'warehouse_description',
                displayName: 'warehouse',
                headerCellFilter: 'translate'
            }]
        },{ 
            key: 'expiration_date', 
            description: 'Data scadenza',
            fields: ['t.expiration_date'],
            columns: [{
                field: 'expiration_date',
                displayName: 'expiration_date',
                headerCellFilter: 'translate',
                exportCelFormat: function(ms){  return dateFilter(ms, dateFormat); },
                cellFilter: 'date:"'+localeFactory.getDateFormat()+'"',
                width: '*'
            }]
        },{
            key: 'lot', 
            description: 'Lotti',
            joins: [{
                column: 'lot l',
                value: 't.production_lot_id = l.id',
                relation: 'JOIN'
            }],
            fields: ['l.code AS lot_code', 't.production_lot_id'],
            columns: [{
                field: 'lot_code',
                displayName: 'warehouse_storage.lot',
                headerCellFilter: 'translate'
            }]
        }
    ];
    $scope.mainFilters = [
        {
            column: 'container c',
            value: 't.container_id = c.id',
            relation: 'JOIN'
        },{
            column: 'customer_destination cd',
            value: 'cd.container_id = c.id',
            relation: 'JOIN'
        },{
            column: 'container_type ct',
            value: 'c.container_type_id = ct.id',
            relation: 'JOIN',
            kind: 'c.description as warehouse'
        },{
            column: 'supplier s',
            value: 't.supplier = s.id',
            relation: 'JOIN'
        },{
            column: 'bom b',
            value: 't.bom_id = b.id',
            relation: 'JOIN'
        },{
            column: 'product p',
            value: 'b.item_id = p.id',
            relation: 'JOIN'
        },{
            column: 'endowment e',
            value: '(e.destination_id = cd.id and e.type = \'MONOUSO\')',
            relation: 'left outer JOIN'
        },{
            column: 'endowment_item ei',
            value: '(p.id = ei.product_id and ei.endowment_id = e.id)',
            relation: 'left outer JOIN'
        }
    ].concat(dbFilterFactory.getCustomFilter("t.status NOT IN ('CONSUMED','INVALIDATED','LOST')"));
    $scope.containerFilters = [{
        column: 'customer_destination cd',
        value: 'cd.container_id = t.id',
        relation: 'JOIN'
    },{
        column: 'container_type ct',
        value: 't.container_type_id = ct.id',
        relation: 'JOIN'
    }];
    $scope.productFilters = [{
        column: 'product_group pg',
        value: 't.product_group_id = pg.id',
        relation: 'JOIN',
        kind: 'pg.code AS product_group_code'
    }];
    $scope.supplierFilters = [];

    $scope.getData = function(params) {
        console.log('Loading grid', params);
        var filters = $scope.mainFilters
        .concat(buildAggs()).concat(buildFilters($scope.filters));
        
        var queryParameters = buildQueryParameters($scope.viewGridOptions, params);
        recordFactory('serial_kit').aggregation(queryParameters, {
            filters: filters,
            fields: ['p.code','p.description', 'p.id AS product_id', 'p.identification as identification',
              's.description as supplier_description', 's.id as supplier'].concat(buildFields()),
            operations:[{
                function: 'sum',
                argument: 't.check_in_amount',
                alias: 'count'
            },{
                function: 'count',
                argument: 'distinct coalesce(t.envelope, t.barcode)',
                alias: 'packs'
            },{
              function: 'bool_or',
              argument: 'ei.tracked',
              alias: 'tracked'
            }]
        })
        .$promise.then(function (data) {
            $scope.viewGridOptions.totalItems = data.totalResults;
            $scope.viewGridOptions.data = data.list;
        });
    };
    
    $scope.aggsRequestChanged = function(){
        $scope.viewGridOptions.gridApi.pagination.seek(1);
        $timeout(function(){
            setGrigColumns();
            $scope.requestChanged();
        }, 50);
    }
    
    var bufferedRequest;
    $scope.requestChanged = function(params){
        $scope.selectedRow = null;
        if (bufferedRequest) $timeout.cancel(bufferedRequest);
        if (params){
            bufferedRequest = $timeout($scope.getData, 500, true, params);
        } else {
            bufferedRequest = $timeout($scope.getData, 500);
        }
    };
    
    function viewDetail (row) {
        if (!row.isSelected || !row.entity.tracked) {
            $scope.selectedRow = null;
            return;
        }
        $scope.selectedRow = row.entity;
        $scope.detailGridOptions.paginationPageSize = $scope.selectedRow.count;
        $scope.detailGridOptions.gridApi.pagination.seek(1);
        $scope.loadDetail(undefined, $scope.selectedRow);
    };
    
    $scope.loadDetail = function(params, row) {
        var queryParameters = buildQueryParameters($scope.detailGridOptions, params);
        var filters = $scope.mainFilters.concat([{
            column: 'lot l',
            value: 't.production_lot_id = l.id',
            relation: 'JOIN',
            kind: 'l.code AS lot_code'
          },
          {
            column: 'cd.container_id',
            value: '',
            relation: 'IS NOT NULL',
            kind: 'nullable'
          }]).concat(buildFilters($scope.filters)).concat(buildFilters(row));
        console.log('Load Detail', queryParameters, row);
        recordFactory('serial_kit').filter(queryParameters, filters).$promise.then(function (data) {
          //quelli con envelope a null sono cartononi senza figli
          var cartoni = data.list.filter(function (e) {
            return e.envelope == null
          });
          var con_figli = data.list.filter(function (e) {
            return e.envelope != null
          });
          con_figli = sixObjectLib.groupArray(con_figli, ['envelope']);
          //aggiungo a quelli coi figli quelli senza figli come se avessere figli = []
          con_figli = con_figli.concat(cartoni.map(function (e) {
            return [e]
          }));
          con_figli = con_figli.map(function (data) {
            return {
              //la busta madre è quella settata o il barcode nel caso sia null, poichè nella vecchia gestione non veniva settata
              envelope: data[0].envelope == null ? data[0].barcode : data[0].envelope,
              warehouse: data[0].warehouse,
              last_packing_date: data[0].last_packing_date,
              product_code: data[0].product_code,
              product_description: data[0].product_description,
              lot_code: data[0].lot_code,
              expiration_date: data[0].expiration_date,
              supplier_code: data[0].supplier_code,
              status: data[0].status,
              kitAssociati: data[0].envelope === data[0].barcode || data[0].envelope == null ? 0 : data.length,
              check_in_amount: data.length === 1 ? data[0].check_in_amount : data.reduce(function (total, e) {
                return total + e.check_in_amount
              }, 0),
              subGridOptions: {
                columnDefs: initSubGridColumns(),
                data: data[0].envelope === data[0].barcode || data[0].envelope == null ? null : data,
                disableRowExpandable: data[0].envelope === data[0].barcode || data[0].envelope == null,
                minRowsToShow: 2
              }
            }
          });
          return {
            totalResults: con_figli.length,
            list: con_figli
          }
        }).then(function (data) {
            $scope.detailGridOptions.data = data.list;
            $scope.detailGridOptions.totalItems = data.totalResults;
            console.log('Loaded detail',data.totalResults);
        });
    }

  var initSubGridColumns = function () {
    var columnDefs = [];
    var dateFormat = localeFactory.getDateFormat();
    columnDefs.push({
      name: "Cartone",
      field: "envelope",
      translation: 'envelope',
      width: 100,
      enableFiltering: false
    });
    columnDefs.push({
      name: "Kit",
      field: "barcode",
      translation: 'kit',
      width: 100,
      enableFiltering: false
    });
    columnDefs.push({
      name: "Data Produzione",
      field: "last_packing_date",
      translation: 'production_date',
      width: 100,
      cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.last_packing_date | date:\'' + dateFormat + '\' }}</div>',
      enableFiltering: false
    });
    columnDefs.push({
      name: "Data Scadenza",
      field: "expiration_date",
      translation: 'expiration_date',
      width: 100,
      cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.expiration_date | date:\'' + dateFormat + '\' }}</div>',
      enableFiltering: false
    });
    columnDefs.push({
      name: "Quantità",
      field: "check_in_amount",
      translation: 'quantity',
      width: 100,
      enableFiltering: false
    });
    return columnDefs;
  };

    function buildQueryParameters(grid, params) {
        if (params) {
            var queryParameters = {
                page: params.pageNumber, 
                page_size: params.pageSize,
                sort_fields: params.sortFields,
                sort_order: params.sortOrder
            };
            if (angular.isString(queryParameters.sort_fields) && queryParameters.sort_fields.length == 0) {
                delete queryParameters.sort_fields;
            }
            if (angular.isString(queryParameters.sort_order) && queryParameters.sort_order.length == 0) {
                delete queryParameters.sort_order;
            }
            return queryParameters;
        }
        var gridApi = grid.gridApi,
        sorting = (gridApi.grid.getColumnSorting() || []).pop() || {};
        return {
            page: gridApi.pagination.getPage(),
            page_size: grid.paginationPageSize,
            sort_fields: sorting.field,
            sort_order: (sorting.sort && sorting.sort.direction)
        };
        
    }
    
    function setGrigColumns() {
        var aggsCol = [];
        angular.forEach($scope.aggs, function(value) {
            this.push.apply(this, value.columns || []);
        }, aggsCol);
        Array.prototype.splice.apply($scope.viewGridOptions.columnDefs, [4, $scope.viewGridOptions.columnDefs.length - 6].concat(aggsCol));
    };
    
    function buildAggs() {
        var joins = [];
        angular.forEach($scope.aggs, function(value) {
            this.push.apply(this, value.joins || []);
        }, joins);
        return joins;
    };
    
    function buildFields() {
        var fields = [];
        angular.forEach($scope.aggs, function(value) {
            this.push.apply(this, value.fields || []);
        }, fields);
        return fields;
    };
    
    function buildFilters(filterObj) {
        var filters = [];
        angular.forEach(filterObj, function(value, key) {
            if (!value) return;
            switch (key) {
                case 'date_from':
                this.push.apply(this, dbFilterFactory.getDateFilter('expiration_date', value, '>='));
                break;
                case 'date_to':
                this.push.apply(this, dbFilterFactory.getDateFilter('expiration_date', value, '<='));
                break;
                case 'expiration_date':
                this.push.apply(this, dbFilterFactory.getDateFilter('expiration_date', new Date(value), '='));
                break;
                case 'container_id':
                this.push.apply(this, dbFilterFactory.getNumberFilter('cd.container_id', value));
                break;
                case 'production_lot_id':
                case 'supplier':
                this.push.apply(this, dbFilterFactory.getNumberFilter(key, value));
                break;
                case 'product_id':
                this.push.apply(this, dbFilterFactory.getNumberFilter('p.id', value));
                break;
                default:
                console.debug('Unknown filter ',key,value);
                break;
            }
        }, filters);
        return filters;
    };
    
    
    function checkPermissions() {
        var profilingKey = 'TNT_WAREHOUSE_STORAGE_FUNCTION';
        var permission = authFactory.getPermissions(profilingKey);
        if(!permission.EXEC) {
            $location.path('forbidden').search({key: profilingKey});
        }
    };

    (function(){
        checkPermissions();
        // ROUTE FILTERS
        if ($routeParams.containers){
            var containerTypes = $routeParams.containers.split(',').filter(function(t) {
                return t.length > 0;
            });
            var containerTypeFilter;
            if (containerTypes.length > 1) {
                containerTypeFilter = dbFilterFactory.getCustomFilter("ct.code IN ('"+containerTypes.join("','")+"')");
            } else if (containerTypes.length == 1) {
                containerTypeFilter = dbFilterFactory.getStringFilter('ct.code', containerTypes[0]);
            }
            $scope.mainFilters = $scope.mainFilters.concat(containerTypeFilter);
            $scope.containerFilters = $scope.containerFilters.concat(containerTypeFilter);
            console.log('Container type filter', containerTypes);
        }
        // PRODUCT GROUP FILTER
        matrixParFactory.getMatrixPar({ key: 'tntProductGroup', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*' }).$promise.then(function (response) {
            if (response.value) {
                var codes = response.value.trim().split(",");
                if(codes.length>0) {
                    var query = dbFilterFactory.getOrQuery('pg.code', codes);
                    $scope.productFilters = $scope.productFilters.concat(dbFilterFactory.getCustomFilter(query));
                    $scope.supplierFilters = $scope.supplierFilters.concat(dbFilterFactory.getCustomFilter("t.id in (select t.id from supplier t LEFT JOIN product_supplier ps ON t.id = ps.supplier_id LEFT JOIN product p ON ps.product_id = p.id LEFT JOIN product_group pg ON p.product_group_id = pg.id where " + query + ")"));
                }
            }
        }).catch(angular.identity);
        // IMPLICIT FILTERS
        var authData = authFactory.getAuthData();
        var authorizations = authData && authData.info && authData.info.authorizations;
        // [SIXLM-457] invece dei magazzini vengono utilizzati i contenitori associati alle destinazioni impostate sull'utente
        if (authorizations && authorizations.destinations && authorizations.destinations.length > 0) {
            console.log('CONTAINER IDS', authorizations.destinations);
            if (authorizations.destinations.length > 1) {
                var availableIds = authorizations.destinations.join(',');
                $scope.mainFilters = $scope.mainFilters.concat(dbFilterFactory.getCustomFilter("cd.id IN ("+availableIds+")"));
                $scope.containerFilters = $scope.containerFilters.concat(dbFilterFactory.getCustomFilter("cd.id IN ("+availableIds+")"));
            } else if (authorizations.destinations.length == 1) {
                $scope.mainFilters = $scope.mainFilters.concat(dbFilterFactory.getNumberFilter('cd.id', authorizations.destinations[0]));
                $scope.containerFilters = $scope.containerFilters.concat(dbFilterFactory.getNumberFilter('cd.id', authorizations.destinations[0]));
            }
        }
        if (authorizations && authorizations.suppliers && authorizations.suppliers.length > 0) {
            console.log('SUPPLIERS IDS', authorizations.suppliers);
            if (authorizations.suppliers.length > 1) {
                var availableIds = authorizations.suppliers.join(',');
                $scope.mainFilters = $scope.mainFilters.concat(dbFilterFactory.getCustomFilter("t.supplier IN ("+availableIds+")"));
                $scope.supplierFilters = $scope.supplierFilters.concat(dbFilterFactory.getCustomFilter("id IN ("+availableIds+")"));
            } else if (authorizations.suppliers.length == 1) {
                $scope.mainFilters = $scope.mainFilters.concat(dbFilterFactory.getNumberFilter('t.supplier', authorizations.suppliers[0]));
                $scope.supplierFilters = $scope.supplierFilters.concat(dbFilterFactory.getNumberFilter('t.id', authorizations.suppliers[0]));
                $scope.preselectSupplier = true;
            }
        }
        $scope.$watch('filters', function(newValue, oldValue){
            if (newValue == oldValue) return;
            $scope.requestChanged();
        }, true);
        localeFactory.loadTranslation('warehouse_storage');
        $scope.lookup = {};
        eggsFormFactory.addLookup($scope.lookup, 'container_id', 'container', 't.code', 't.description');
        eggsFormFactory.addLookup($scope.lookup, 'product_id', 'product', 't.code', 't.description');
        eggsFormFactory.addLookup($scope.lookup, 'lot_id', 'lot', 'code', 'description');
        eggsFormFactory.addLookup($scope.lookup, 'supplier', 'supplier', 't.code', 't.description');
    })();
});

'use strict';

/**
 * @ngdoc function
 * @name ictportal.ttr.sterilization:SerialKitSterilizedCtrl
 * @description TTR stampa etichetta serial kit sterilizzati
 * @author Anna Salvato
 * 
 * created on 06/09/2018
 * # SerialKitSterilizedCtrl
 * Controller of the ictportal.ttr
 */
angular.module('ictportal.ttr')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/ttr/sterilization/serialkit/list/:productGroup', { // possibilità di filtrare per gruppo merceologico (productGroup)
          templateUrl: 'ttr/sterilization/serialkit-sterilized-list.html',
          controller: 'SerialKitSterilizedCtrl',
        })
        .when('/ttr/sterilization/serialkit/list', {
          templateUrl: 'ttr/sterilization/serialkit-sterilized-list.html',
          controller: 'SerialKitSterilizedCtrl',
        })
  })
  .controller('SerialKitSterilizedCtrl', function ($scope, $rootScope, $routeParams, toaster, authFactory,
                dbFilterFactory, recordFactory, localeFactory, sixGridPaginationConstants, uiGridConstants, 
                serialKitFactory, localStorageService, serialKitLMFactory, $location) {
    
    // inizializzazione varibili 
    $scope.localeMessages;
    $scope.serialKitsSterilizedTableData = {};
    $scope.viewSterilizedKitGridParams = {
      pageNumber: 1,
      pageSize: 15,
      sortOrder: 'desc',
      filters: []
    };
    $scope.viewSterilizedKitGridOptions = {
      appScopeProvider: $scope,
      enablePaginationControls: true
    };

    var workstationPrinter = undefined;
    var printMode;
    var selectedKitBarcode;
    var kitAlreadyPrinted = [];
    var filters = [
      {
          "column": "bom b",
          "value": "t.bom_id = b.id",
          "relation": "JOIN",
          "kind": "b.id AS bom_id"
      },
      {
          "column": "product p",
          "value": "b.item_id = p.id",
          "relation": "JOIN",
          "kind": "p.description AS product_description, p.code AS product_code"
      },
      {
          "column": "product_group pg",
          "value": "p.product_group_id = pg.id",
          "relation": "JOIN",
          "kind": "pg.code AS product_group_code"
      },
      {
        "column": "prod_order_det pod",
        "value": "t.prod_order_det_id = pod.id",
        "relation": "JOIN",
        "kind": "pod.id AS pod_id"
      },
      {
        "column": "prod_order po",
        "value": "pod.prod_order_id = po.id",
        "relation": "JOIN",
        "kind": "po.num, po.year AS prod_order_year"
      }
    ];


    function init() {
      initColumnDefGrids(); // init column
      localeFactory.loadTranslation('serialkit_sterilized').then(function (){
          localeFactory.translateMsg({
              function_title : 'Serial Kit Sterilizzati',
              table_head_barcode_inv : "Barcode",
              table_head_product_code : "Codice Articolo",
              table_head_product_desc : "Descrizione Articolo",
              table_head_prod_order : "Ordine di Produzione",
              success : "Stampa avvenuta",
              generic_error : "Errore, riprovare",
              operation_completed : "Stampa avvenuta corretamente",
              error_title : "Errore",
              empty_barcode : "Nessun barcode inserito",
              error_barcode_not_valid : "Nessun serial kit con barcode inserito",
              error_status_not_valid : "Il serial kit deve essere in stato STERILIZZATO",
              error_product_group_not_valid : "Il gruppo merceologico del kit non è ammesso",
              empty_label_code : "Codice etichetta vuoto",
              error_invalid_label_code : "Codice etichetta non valido"
          }, 'serialkit_sterilized').then(function(data) { 
            $scope.localeMessages = data;
            translateGridColumns();
        });
      });
      checkPermissions();
      // [SIXLM-64] parametro utilizzo modale obbligatoria
      if (["true", "yes", "y"].includes($routeParams.useModal)) {
          workstationPrinter = undefined;
      } else {
        getWorkstationPrinter();
      }
    }

    function checkPermissions() {
      var profilingKey = 'TTR_SERIAL_KIT_STERILIZED_FUNCTION';
      var permission = authFactory.getPermissions(profilingKey);
      if(!permission.EXEC) {
        $location.path('forbidden').search({key: profilingKey});
      }
    };

    function translateGridColumns() {
      $scope.viewSterilizedKitGridOptions.columnDefs.forEach(function (col) {
          if (col.translation) {
            col.name = $scope.localeMessages[col.translation];
          }
      });
    };

    // init column grid
    function initColumnDefGrids() {
      $scope.viewSterilizedKitGridOptions.columnDefs = [
        {
          displayName: '',
          field: 'id',
          width: 34,
          enableCellEdit: false,
          enableFiltering: false,
          enableSorting: false,
          cellTemplate:
          '<div class="ui-grid-cell-contents" style="text-align: center">' +
              '<button ng-click="grid.appScope.printKitLabelSecondary(row.entity.barcode)" class="btn btn-xs btn-primary" title="Stampa">' +
              '<span class="fa fa-print"></span>' +
              '</button>' +
          '</div>'
        },
        {
          translation: 'table_head_barcode_inv',
          field: 'barcode',
          enableFiltering: true,
          filters: [{
              type: sixGridPaginationConstants.filterType.TEXT,
              condition: uiGridConstants.filter.CONTAINS,
              placeholder: '',
              kind: 'string'
          }]
        },
        {
          translation: 'table_head_product_code',
          field: 'product_code',
          enableFiltering: true,
          filters: [{
              type: sixGridPaginationConstants.filterType.TEXT,
              condition: uiGridConstants.filter.CONTAINS,
              placeholder: '',
              kind: 'string',
              aliasResolver: 'p.code'
          }]
        },
        {
          translation: 'table_head_product_desc',
          field: 'product_description',
          enableFiltering: true,
          filters: [{
              type: sixGridPaginationConstants.filterType.TEXT,
              condition: uiGridConstants.filter.CONTAINS,
              placeholder: '',
              kind: 'string',
              aliasResolver: 'p.description'
          }]
        },
        {
          translation: 'table_head_prod_order',
          field: 'num',
          cellTemplate:'<div class="ui-grid-cell-contents"><span ng-if="row.entity.num">{{row.entity.num}} / {{row.entity.prod_order_year}}</span></div>',
          enableFiltering: true,
          //sixFilteringCallback:$scope.onFilterStepCallback,
          filters: [{
              type: sixGridPaginationConstants.filterType.NUMBER,
              condition: sixGridPaginationConstants.filterRel.EQUAL,
              placeholder: '',
              kind: 'number'
          }]
        }
      ];
    }
    
    // recupero serial kit in stato sterilizzato (usato per la visualizzazione in tabella)
    $scope.retrieveSerialKitSterilized = function () {
      var payload = {
          page: $scope.viewSterilizedKitGridParams.pageNumber,
          page_size: $scope.viewSterilizedKitGridParams.pageSize,
          sort_fields: ($scope.viewSterilizedKitGridParams.sortFields?$scope.viewSterilizedKitGridParams.sortFields:'barcode'),
          sort_order: $scope.viewSterilizedKitGridParams.sortOrder
      };
      var serialKitFilter = filters.concat(dbFilterFactory.getStringFilter('t.status', 'STERILIZED'))
                                  .concat($scope.viewSterilizedKitGridParams.filters); // aggancio i filtri sopra alle colonne
      if ($routeParams.productGroup != null) { // aggangio il product group se definito (definibile da start page)
        serialKitFilter = serialKitFilter.concat(dbFilterFactory.getStringFilter('pg.code', $routeParams.productGroup));
      }

      recordFactory('serial_kit').filter(payload, serialKitFilter)
          .$promise.then(function (data) {
            $scope.serialKitsSterilizedTableData.list = data.list;
            $scope.serialKitsSterilizedTableData.totalResults = data.totalResults;
            $scope.viewSterilizedKitGridParams.totalItems = data.totalResults;
          });
    }

    function getWorkstationPrinter() {
        var workstation = localStorageService.get('workstation');
        if (workstation) {
            var payload = { workstation: workstation };
            serialKitLMFactory.getWsPrinter(payload).$promise.then(function (response) {
                workstationPrinter = response.printer;
            });
        }
    };

    // stampa etichetta serial kit sterilizzato - preparazione dati per popup selezione stampante
    $scope.printKitLabelSecondary = function(barcode){
        selectedKitBarcode = barcode; // id del serial kit selezionato
        printMode = 'SK_SEC_LB'; // stampa etichetta secondaria
        // [SIXLM-64] se configurata uso la stampante associata alla workstation
        if (workstationPrinter) {
            $scope.onConfirmPrintLabel(null);
        } else {
            $rootScope.$broadcast('sixPrintModalCtrl_open'); // apertura popup selezione stampante
        }
    }
     
    // stampa etichetta serial kit sterilizzato - stampa dovuta al click su conferma nel popup di selezione stampante
    $scope.onConfirmPrintLabel = function (printerCode) {
      var payload = {
          barcode: selectedKitBarcode,
          printerCode: printerCode, // codice stampante selezionata
          labelPrintCode: printMode // codice etichetta da stampare
      };
      if ($routeParams.productGroup != null) { // aggangio il productGroup se definito (definible da start page)
        payload.productGroup = $routeParams.productGroup;
      }
      serialKitFactory.printLabel({}, payload).$promise
      .then(function (response) {
          if (!response.success) {
              toaster.pop('error', $scope.localeMessages.error_title, $scope.localeMessages[response.errorMessageKey]);
              kitAlreadyPrinted = kitAlreadyPrinted.filter(function(e){return e != selectedKitBarcode});
          }
          else {
              toaster.pop('success',$scope.localeMessages.success, $scope.localeMessages.operation_completed);
              if (printerCode != null) {
                kitAlreadyPrinted = kitAlreadyPrinted.filter(function(e){return e != selectedKitBarcode});
              }
          }
      })
      .catch(function(){
          toaster.pop('error', $scope.localeMessages.error_title, $scope.localeMessages.generic_error);
          kitAlreadyPrinted = kitAlreadyPrinted.filter(function(e){return e != selectedKitBarcode});
        });
    }

    $scope.onCancelPrintLabel = function () {
        kitAlreadyPrinted = kitAlreadyPrinted.filter(function(e){return e != selectedKitBarcode});
    }

    // Reader barcode serial kit - stampa etichetta kit letto (solo se e' in stato STERILIZZATO ed eventualmente del product group specificato, contrallato dal BE)
    $scope.readSerialKitCode = function(read) {
        if (read.read) {
            // [SIXLM-64] per evitare stampe multiple dello stesso kit memorizzo quelli già stampati
            serialKitFactory.getKitFields({}, {barcode: read.read}).$promise
            .then(function (response) {
                if (!response.success) {
                    toaster.pop('error', $scope.localeMessages.error_title, $scope.localeMessages[response.errorMessageKey]);
                }
                else {
                    var barcode = response.fields.barcode;
                    if (!kitAlreadyPrinted.find(function(e) { return e == barcode; })) {
                        kitAlreadyPrinted.push(barcode);
                        $scope.printKitLabelSecondary(read.read);
                    } else {
                        console.log("serial kit " + barcode + " già stampato, ricaricare la pagina per rilanciare la stampa");
                    }
                }
            })
            .catch(function(){
                toaster.pop('error', $scope.localeMessages.error_title, $scope.localeMessages.generic_error);
            });
        }
    };

    // init page
    init();

  });
'use strict';

/**
 * @ngdoc function
 * @name ictportal.core.controller:ImportEndowmentCtrl
 * @description
 * # ImportEndowmentCtrl
 * Controller of the ictportal.core
 */
angular.module('ictportal.core')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/import/endowment', {
        templateUrl: 'core/import/endowment/endowment_import.html',
        controller: 'ImportEndowmentCtrl'
      });
  })
  .controller('ImportEndowmentCtrl', function ($scope, $location, endowmentFactory, localeFactory, dialogService, toaster, $timeout) {

    $scope.localeMessages;
    $scope.isEntitySelected = false;
    $scope.showErrorRows = false;
    $scope.elapsedImportTime;
    $scope.successImport = false;
    $scope.executeImport = false;
    $scope.errorMessageImportKey;
    $scope.errorBudgetDestinationFromMonouso = [];
    var enableTypeImport = [];
    var columnsNameReadable = {};
    var mapFrequencyBudgetInExit = {}; // per convertire le stringhe che ritorna il BE nelle stringhe leggibili da visualizzare all'utente (per le dotazioni in erorre non importate)
    var mapReorderTypeBudgetInExit = {}; // per convertire le stringhe che ritorna il BE nelle stringhe leggibili da visualizzare all'utente (per le dotazioni in errore non importate)

    // Opzioni ui-grid
    $scope.gridOptions = {
      importerDataAddCallback: function (grid, newObjects) {
        // $scope.data = $scope.data.concat( newObjects ); //questa in realtà non viene chiamata... la direttiva xlsx non scatena l'evento..
      },
      onRegisterApi: function (gridApi) {
        $scope.gridApi = gridApi;
      }
    };

    $scope.reportGridOptions = {
      enableSorting: true,
      exporterMenuPdf: false,
      paginationPageSizes: [10, 20, 30],
      paginationPageSize: 10,
      useExternalPagination: false,
    };

    // Colonne che mi aspetto siano presenti nell'excel (vale l'ORDINE DI INSERIMENTO delle colonne)
    var convertColumnsNameBudgetMonouso = ["endowmentType", "startValidityDate", "endValidityDate", "destinationCode", "customerCode",
      "budgetFrequency", "budgetRecovery", "productCode", "itemStartValidityDate", "itemEndValidityDate",
      "reorderType", "budget", "minAmount", "minLot", "tracked"];
    var convertColumnsNameConfezionata = ["customerCode","destinationCode","workTaskCode","sex","employeeMatriculation","productCode","amount"];
    var convertColumnsNamePiana = ["endowmentType", "customerCode","destinationCode","startValidityDate", "endValidityDate",
        "productCode","itemStartValidityDate", "itemEndValidityDate","amount","spareAmount","workingAmount","dailyNeedAmount",
        "noChip", "lotItem"];
    var convertColumnsNameTTR = [
      "endowmentType",
      "customerCode",
      "destinationCode",
      "startValidityDate",
      "endValidityDate",
      "productCode",
      "amount",
      "spareAmount",
      "workingAmount",
      "noChip",
      "lotItem"
    ];

    // Eventuali enum che hanno una etichetta a video per l'utente ma il sistema si aspetta diversamente
    var mapToConvertFrequencyBudget = {
      "MENSILE": "MONTHLY",
      "TRIMESTRALE": "THREE_MONTHS",
      "SEMESTRALE": "SIX_MONTHS",
      "ANNUALE": "YEARLY"
    };
    var mapToConvertReorderTypeBudget = {
      "CONSUMATO": "CONSUMED",
      "MANUALE": "MANUAL",
      "SCORTA MINIMA": "MINSTOCK"
    };

    var enables = ['SI', 'si', 's', 'true'];
    var disables = ['NO', 'no', 'n', 'false'];


    function init() {

      if($location.search().type != null) {
        enableTypeImport = $location.search().type;
      }
      localeFactory.detectLanguage();

      localeFactory.loadTranslation('import_endowment').then(function () {
        localeFactory.translateMsg({
          function_title: 'Import Dotazione',
          function_title_generic: 'Import',
          select_excel_file: 'Selezionare File Excel',
          column_row_num: 'Num riga',
          column_row_num_title: 'Numero di riga nel file exel che non è stata importata',
          import_success: 'Import eseguito',
          error_import_003: 'Tipo di import dotazione non valido.',
          error_import_004: 'Errore durante l\'esecuzione dell\'import. Riprovare.',
          download_template_budget: 'Template BUDGET',
          download_template_monouso: 'Template MONOUSO',
          download_template_confezionata: 'Template CONFEZIONATA',
          download_template_piana: 'Template PIANA',
          download_template_ttr: 'Template TTR',
          import_budget: 'Import BUDGET',
          import_monouso: 'Import MONOUSO',
          import_confezionata: 'Import CONFEZIONATA',
          import_piana: 'Import PIANA',
          import_ttr: 'Import TTR',
          import_all_success: 'Tutte le dotazioni sono state importate correttamente',
          import_elapsed_time: 'Tempo di esecuzione import: ',
          import_error_rows: 'Di seguito sono riportare le righe non importate con relativo messaggio di errore',
          import_error_monouso_budget: 'Per le destinazioni seguenti non è stato possibile generare il relativo BUDGET: ',
          missing_required_parameters: 'Parametri obbligatori mancanti',
          missing_billToCustomerCode: 'Nessun cliente di fatturazione collegato al cliente inserito',
          missing_destinationCode: 'Nessuna destinazione inserita',
          inconsistent_destinationCode: 'Il cliente selezionato ed il cliente impostato sulla destinazione inserita non sono coerenti.',
          inconsistent_endValidityDate: 'La data di fine validità della dotazione è precedente rispetto la data di inizio valdità',
          inconsistent_itemEndValidityDate: 'La data di fine validità del prodotto di dotazione è precedente rispoetto la data di inizio valdità',
          inconsistent_product: 'Il prodotto inserito non fa parte del gruppo merceologico di TNT.',
          invalid_format_date: 'Una delle date inserite non è nel formato corretto. Possibile formato: dd/MM/yyyy.',
          invalid_endowmentType: 'Nessuna corrispondenza trovata con il tipo di dotazione inserito',
          invalid_customerCode: 'Nessuna corrispondenza trovata con il codice cliente inserito',
          invalid_destinationCode: 'Nessuna corrispondenza trovata con il codice destinazione inserito',
          invalid_productCode: 'Nessuna corrispondenza trovata con il codice articolo inserito',
          invalid_budgetFrequency: 'Nessuna corrispondenza trovata con il codice frequenza budget inserito',
          invalid_budgetRecovery: 'Valore di recupero budget non valido. Inserirlo SI/NO.',
          invalid_reorderType: 'Nessuna corrispondenza trovata con il codice tipo riordino inserito',
          invalid_sex: 'Nessuna corrispondenza trovata con il codice sesso inserito',
          invalid_serviceLevelCode: 'Nessuna corrispondenza trovata con il codice livello di servizio',
          invalid_employeeMatriculation: 'Nessuna corrispondenza trovata con il codice matricola dipendente inserito',
          invalid_workTaskCode: 'Nessuna corrispondenza trovata con il codice qualifica inserito',
          invalid_agreement: 'Nessun contratto valido trovato per il cliente e prodotto inserito',
          more_agreements: 'Articolo associato a più contratti',
          endowmentType_not_supported: 'Tipo dotazione non trattato da flusso di import',
          error_on_save: 'Errore in fase di salvataggio',
          error_on_save_monouso: 'Errore durante la creazione del MONOUSO associato',
          empty_field: 'Campo vuoto'
        }, 'import_endowment').then(function (data) {
          $scope.localeMessages = data;
        });
      });
    }

    $scope.reset = function () {
      $scope.gridOptions.data = [];
      $scope.gridOptions.columnDefs = [];
      $scope.errorBudgetDestinationFromMonouso = [];
      $scope.isEntitySelected = false;
      $scope.showErrorRows = false;
      $scope.successImport = false;
      $scope.executeImport = false;
      $scope.errorMessageImportKey = "";
      $scope.elapsedImportTime = 0;
    };

    //dati caricati da xls
    $scope.$watch(function () {
      return $scope.gridOptions.xlsData;
    },
      function (newValue, oldValue) {
        if (newValue && newValue.length > 0) {
          $scope.isEntitySelected = angular.isDefined(newValue);
          if (!$scope.isEntitySelected) {
            $scope.reset();
          }
          $scope.gridOptions.data = $scope.gridOptions.xlsData;
          $scope.gridOptions.data.splice(0, 1);
          var width = $scope.gridOptions.columnDefs.length>10?120:undefined;
          for (var i = 0; i < $scope.gridOptions.columnDefs.length; i++) {
            $scope.gridOptions.columnDefs[i].width = width;
          }
        }
      }
    );

    /**
     * Avoid blank spaces errors.
     * @param {Object} row Excel row data
     */
    function trimRowData(row) {
      Object.keys(row).forEach(function(k) {
        if(row[k] && (typeof row[k] === 'string')) {
          row[k] = row[k].trim();
        }
      });
    };

    /**
     * Esegue le operazioni preliminari all'import dei dati (validazioni, conversioni, ecc.).
     * @param {String} endowmentType Tipo di dotazione.
     * @retun {JsArray} Ritorna un array di json da passare al backend.
     */
    function prepareData(endowmentType) {
      var newData = [];
      columnsNameReadable = {};
      mapFrequencyBudgetInExit = {}; // per converitre le stringhe che ritorna il BE nelle stringhe leggibili da visualizzare all'utente (per le dotazioni in erorre non importate)
      mapReorderTypeBudgetInExit = {}; // per converitre le stringhe che ritorna il BE nelle stringhe leggibili da visualizzare all'utente (per le dotazioni in errore non importate)
      for (var rowCount = 0; rowCount < $scope.gridOptions.data.length; rowCount++) {
        var oldRowJson = $scope.gridOptions.data[rowCount];
        trimRowData(oldRowJson);
        var newRowJson = {};
        for (var columnCount = 0; columnCount < $scope.gridOptions.columnDefs.length; columnCount++) {
          var columnName = $scope.gridOptions.columnDefs[columnCount].field;
          var value = oldRowJson[columnName];
          var columnCorrectKey;
          // Eventuale conversione enum
          if (endowmentType == 'monouso') {
            var columnCorrectKey = convertColumnsNameBudgetMonouso[columnCount];
            if (columnCorrectKey == 'budgetFrequency') {
              if (!value) {
                toaster.pop('error', $scope.localeMessages.error, $scope.localeMessages.empty_field + ' (budgetFrequency)');
                return [];
              }
              var convert = mapToConvertFrequencyBudget[value.toUpperCase()]; // per convertire le stringhe leggibili nelle stringhe che servono al BE
              mapFrequencyBudgetInExit[convert] = value;
              value = convert;
            }
            if (columnCorrectKey == 'reorderType') {
              if (!value) {
                toaster.pop('error', $scope.localeMessages.error, $scope.localeMessages.empty_field + ' (reorderType)');
                newData = [];
                return [];
              }
              var convert = mapToConvertReorderTypeBudget[value.toUpperCase()]; // per convertire le stringhe leggibili nelle stringhe che servono al BE
              mapReorderTypeBudgetInExit[convert] = value;
              value = convert;
            }
          }
          if (endowmentType == 'confezionata') {
            var columnCorrectKey = convertColumnsNameConfezionata[columnCount];
          }
          if (endowmentType == 'piana') {
            var columnCorrectKey = convertColumnsNamePiana[columnCount];
            if (columnCorrectKey == 'noChip') {
                if (enables.includes(value)) value = false;
                if (disables.includes(value)) value = true;
            }
            if (columnCorrectKey == 'lotItem') {
                if (enables.includes(value)) value = true;
                if (disables.includes(value)) value = false;
            }
          }
          if (endowmentType == 'ttr') {
            var columnCorrectKey = convertColumnsNameTTR[columnCount];
            if (columnCorrectKey == 'noChip') {
                if (enables.includes(value)) value = false;
                if (disables.includes(value)) value = true;
            }
            if (columnCorrectKey == 'lotItem') {
                if (enables.includes(value)) value = true;
                if (disables.includes(value)) value = false;
            }
          }
          columnsNameReadable[columnCorrectKey] = columnName;
          newRowJson[columnCorrectKey] = value;
        }
        newData.push(newRowJson);
      }
      return newData;
    }

    $scope.isEnabledImportType = function (endowmentType) {
        if (enableTypeImport == null || enableTypeImport.length <= 0 || enableTypeImport.indexOf(endowmentType) >= 0) {
          return true;
        }
        return false;
    }

    /**
     * Prepara i dati, li spedisce al backend e mostra il risultato.
     * @param {String} endowmentType Tipo di dotazione.
     */
    $scope.importData = function (endowmentType) {
      dialogService.showLoadingMessage('Importazione...');

      // preparo i dati con key come richiesto
      var newData = prepareData(endowmentType);
      if (newData.length==0) {
        // Si è verificato un errore. Non chiamo nemmeno il backend.
        $timeout(function() {
          dialogService.stopLoading();
        },1000);
      }
      else {
        endowmentFactory.endowmentImportList({ type: endowmentType }, newData).$promise.then(function (data) {
          if (data.failRowsEndowment && data.failRowsEndowment.length > 0) {
            $scope.gridOptions.columnDefs.splice(0, 0, {
              field: 'errorMessage',
              cellTemplate: "<div class=\"ui-grid-cell-contents\" style=\"background-color:red; color:white; text-align:center; width: 100% !important; border-bottom: 1px solid white\" title=\"{{\'import_endowment.\'.concat(COL_FIELD) | translate}}\"><i class=\"fa fa-exclamation m-r\"></i><b>{{\'import_endowment.\'.concat(COL_FIELD) | translate}}</b></div>",
              headerCellTemplate: "<div></div>"
            });
            $scope.gridOptions.columnDefs.splice(1, 0, {
              field: 'rowErrorNumber',
              width: '40',
              cellTemplate: "<div class=\"ui-grid-cell-contents\" type1=\"{{COL_FIELD}}\" style=\"color:red; text-align:center; font-weight: bold; border-bottom: 1px solid white;\">{{COL_FIELD+2}}</div>",
              headerCellTemplate: "<div style=\"color:white;\" title=\"{{\'import_endowment.column_row_num_title\' | translate}}\">{{\'import_endowment.column_row_num\' | translate}}</div>"
            });
            $scope.gridOptions.data = data.failRowsEndowment;
            $scope.showErrorRows = true;
          }
          else {
            $scope.gridOptions.data = []; // all success
          }

          // Ripristino i nomi leggibili
          $scope.gridOptions.data = traslateColumnsAsHumanFriendly(endowmentType);

          // Error or success?
          displayResult(data);
          $scope.errorBudgetDestinationFromMonouso = data.destinationCodeMonousoError;

          dialogService.stopLoading();
        });
      }
    };

    /**
     * Translates from DB to user friendly column names.
     */
    function traslateColumnsAsHumanFriendly(endowmentType) {
      var readablewData = [];
      for (var rowCount = 0; rowCount < $scope.gridOptions.data.length; rowCount++) {
        var beRowJson = $scope.gridOptions.data[rowCount];
        var readablewRowJson = {};
        for (var beColumnKey in beRowJson) {
          var value = beRowJson[beColumnKey];
          var readbleColumnName = columnsNameReadable[beColumnKey];
          if (endowmentType == 'monouso') {
            if (beColumnKey == 'budgetFrequency') {
              var convert = mapFrequencyBudgetInExit[value]; // per convertire le stringhe leggibili nelle stringhe che servono al BE
              value = convert;
            }
            if (beColumnKey == 'reorderType') {
              var convert = mapReorderTypeBudgetInExit[value]; // per convertire le stringhe leggibili nelle stringhe che servono al BE
              value = convert;
            }
          }
          if (readbleColumnName == null || readbleColumnName == '') {
            readablewRowJson[beColumnKey] = value;
          }
          else {
            readablewRowJson[readbleColumnName] = value;
          }
        }
        readablewData.push(readablewRowJson);
      }
      return readablewData;
    }

    /**
     * Error or success?
     * @param {*} data Response from backend
     */
    function displayResult(data) {
      if (data.code) {
        if (data.code == '003' || data.code == '004') {
          $scope.successImport = false;
          $scope.errorMessageImportKey = "error_import_" + data.code;
        }
        else {
          $scope.successImport = true;
        }
        $scope.executeImport = true;
        $scope.elapsedImportTime = data.elapsedTime;
      }
    }

    /**
     * File download
     */
    $scope.downloadTemplate = function (endowmentType) {
      var link = document.createElement("a");
      link.download = 'endowment_template.xlsx';
      link.href = 'endowment_import_template_' + endowmentType + '.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    // Init at page load
    init();

  });

'use strict';

/**
 * Created by Rita Beltrami on 27/09/18
 * @ngdoc component
 * @name ictportal.ferri:autoclaveCycleValidationModal
 * @description Modal window for choosing an equipment autoclave reason
 * # autoclaveCycleValidationModal
 */
angular.module('ictportal.theme').component('autoclaveCycleValidationModal',{
      restrict: 'E',
      controller: 'autoclaveCycleValidationModalCtrl',
      bindings: {
        sxOnConfirm: '&',
        sxEquipmentReasonFilter: '=',
        sxMsg: '='
      }
  });

'use strict';

angular.module('ictportal.theme').controller('autoclaveCycleValidationModalCtrl', function ($scope, $rootScope, $uibModal, eggsFormFactory, dbFilterFactory,
                                                                                              recordFactory, toaster) {
  var $ctrl = this;
  $ctrl.record = {
    lookup: {}
  };
  $ctrl.controlReasonsList = [];
  $ctrl.modalInstance;

  $ctrl.selectIfUnique = function() {
    if($ctrl.controlReasonsList.length==1) {
      $ctrl.record.lookup.equipment_reason_id.obj = $ctrl.controlReasonsList[0];
    }
  }

  $ctrl.readReasonBarcode = function(read) {
    readBarcodeEquipmentReason(read.read);
  }

  $rootScope.$on('autoclaveCycleValidationModalCtrl_open', function () {
    $ctrl.modalInstance = showModalConfirm();
    $ctrl.modalInstance.result.then(function (confirmed) {
      var result = angular.copy($ctrl.record.lookup.equipment_reason_id.obj);
      $ctrl.record.lookup.equipment_reason_id.obj = {};
      $scope.$broadcast('clearLookUp',true, 'equipment_reason_id');
      if (confirmed) {
        confirm(result);
      }
    });
  });

  /**
   * Tramite il barcode reader leggo il barcode della causale di conformità del ciclo.
   * @param {*} barcode barcode della causale di conformità del ciclo
   */
  function readBarcodeEquipmentReason(barcode) {
    var filter = angular.copy($ctrl.sxEquipmentReasonFilter)
                    .concat(dbFilterFactory.getStringFilter('t.barcode', barcode));

    recordFactory('equipment_reason').filter(filter).$promise
        .then(function(data) {
            // Se non ho alcun risultato restituisco errore
            if (data.totalResults <= 0) {
                toaster.error($ctrl.sxMsg.error, $ctrl.sxMsg.error_wash_reason_not_found); 
            }
            else {
                $ctrl.record.lookup.equipment_reason_id.obj = data.list[0].id;
                confirm(data.list[0]);
            }
        }
    );
  }

  function showModalConfirm() {
    var modalInstance = $uibModal.open({
      animation: true,
      scope: $scope,
      templateUrl: 'ferri/autoclave-cycle-validation/autoclave-cycle-validation-modal/autoclave-cycle-validation-modal.html'
    });
    return modalInstance;
  };

  function confirm(equipmentObj) {
    $ctrl.sxOnConfirm({equipmentReason: equipmentObj});
    $ctrl.modalInstance.dismiss();
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  }

  function initLookups() {
    eggsFormFactory.addLookup($ctrl.record.lookup, 'equipment_reason_id',      'equipment_reason',      'code',     'description');
  };

  $ctrl.$onInit = function () {
    initLookups();
  };

});
'use strict';

/**
 * Created by Rita Beltrami on 27/09/18
 * @ngdoc component
 * @name ictportal.ferri:washingCycleValidationModal
 * @description Modal window for choosing an equipment washing reason
 * # washingCycleValidationModal
 */
angular.module('ictportal.theme').component('washingCycleValidationModal',{
      restrict: 'E',
      controller: 'washingCycleValidationModalCtrl',
      bindings: {
        sxOnConfirm: '&',
        sxEquipmentReasonFilter: '=',
        sxMsg: '='
      }
  });

'use strict';

angular.module('ictportal.theme').controller('washingCycleValidationModalCtrl', function ($scope, $rootScope, $uibModal, eggsFormFactory, dbFilterFactory,
                                                                                              recordFactory, toaster) {
  var $ctrl = this;
  $ctrl.record = {
    lookup: {}
  };
  $ctrl.controlReasonsList = [];
  $ctrl.modalInstance;

  $ctrl.selectIfUnique = function() {
    if($ctrl.controlReasonsList.length==1) {
      $ctrl.record.lookup.equipment_reason_id.obj = $ctrl.controlReasonsList[0];
    }
  }

  $ctrl.readReasonBarcode = function(read) {
    readBarcodeEquipmentReason(read.read);
  }

  $rootScope.$on('washingCycleValidationModalCtrl_open', function () {
    $ctrl.modalInstance = showModalConfirm();
    $ctrl.modalInstance.result.then(function (confirmed) {
      var result = angular.copy($ctrl.record.lookup.equipment_reason_id.obj);
      $ctrl.record.lookup.equipment_reason_id.obj = {};
      $scope.$broadcast('clearLookUp',true, 'equipment_reason_id');
      if (confirmed) {
        confirm(result);
      }
    });
  });

  /**
   * Tramite il barcode reader leggo il barcode della causale di conformità del ciclo.
   * @param {*} barcode barcode della causale di conformità del ciclo
   */
  function readBarcodeEquipmentReason(barcode) {
    var filter = angular.copy($ctrl.sxEquipmentReasonFilter)
                    .concat(dbFilterFactory.getStringFilter('t.barcode', barcode));

    recordFactory('equipment_reason').filter(filter).$promise
        .then(function(data) {
            // Se non ho alcun risultato restituisco errore
            if (data.totalResults <= 0) {
                toaster.error($ctrl.sxMsg.error, $ctrl.sxMsg.error_wash_reason_not_found); 
            }
            else {
                $ctrl.record.lookup.equipment_reason_id.obj = data.list[0].id;
                confirm(data.list[0]);
            }
        }
    );
  }

  function showModalConfirm() {
    var modalInstance = $uibModal.open({
      animation: true,
      scope: $scope,
      templateUrl: 'ferri/washing-cycle-validation/washing-cycle-validation-modal/washing-cycle-validation-modal.html'
    });
    return modalInstance;
  };

  function confirm(equipmentObj) {
    $ctrl.sxOnConfirm({equipmentReason: equipmentObj});
    $ctrl.modalInstance.dismiss();
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  }

  function initLookups() {
    eggsFormFactory.addLookup($ctrl.record.lookup, 'equipment_reason_id',      'equipment_reason',      'code',     'description');
  };

  $ctrl.$onInit = function () {
    initLookups();
  };

});
'use strict'

/**
 * @ngdoc function
 * @name ictportal.hpe.controller:HpeControlReportProductionDetailCtrl
 * @description Pagina di dettaglio dei Report di Controllo Produzione
 * @author Mattia Freda
 *
 * created on 01/10/2018
 * # HpeControlReportProductionDetailCtrl
 * Controller of the ictportal.hpe
 */
angular.module('ictportal.hpe')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/qs/controlreportproduction/detail', {
          templateUrl: 'hpe/control-report-production/detail/control-report-production-detail.html',
          controller: 'HpeControlReportProductionDetailCtrl'
        })
        .when('/qs/controlreportproduction/detail/:id', {
          templateUrl: 'hpe/control-report-production/detail/control-report-production-detail.html',
          controller: 'HpeControlReportProductionDetailCtrl'
        })
  })
  .controller('HpeControlReportProductionDetailCtrl', function ($scope, $log, recordFactory, $routeParams, $location, $filter,
                                          eggsFormFactory, toaster, dbFilterFactory, localeFactory, hpeControlReportProductionFactory, 
                                          authFactory, $q, sixFrameFactory, APP_URL) {
    
    $scope.readOnly = false;
    $scope.showStdPanel = true;
    $scope.enum = {};
    var pageBundle = 'control_report_production';
    var msg = {
      "error": "Error",
      "operation_completed": "Operation completed",
      "operation_completed_success": "Operation successfully completed",
      "server_comunication_error": "Server communication error"
    };
    var page_msg = {
      "MISSING_VALIDITY_DATE": "Validity date missing",
      "MISSING_CUSTOMER": "Customer missing",
      "MISSING_PRODUCTION_ORDER": "Production order missing",
      "MISSING_PRODUCT": "Product missing",
      "MISSING_REVISION": "Revision missing",
      "MISSING_BILLING_MODE": "Billing mode missing",
      "MISSING_TASK": "Task missing",
      "NO_OPERATOR": "No operator found",
      "NO_CONTROL_PLAN": "No suitable control plan found",
      "SAVE_EXCEPTION": "Error while saving"
    };

    var enums = {
      billing_mode: [
          {
              name: 'Pezzo singolo',
              value: 'SINGLE'
          },
          {
              name: 'Lotto di pezzi',
              value: 'LOT'
          }
        ]
    };

    $scope.record = {
      lookup: {},
      model: {}
    };
    $scope.selected = {
      editing: false,
      row: {},
	};
	
	$scope.transient = {};
  $scope.revisionFilter = [];
  
	$scope.jsfurl = null;
  $scope.functionCode = undefined;
  $scope.editMode = false;

    $scope.$watchGroup(['transient.product_id'], 
        function () {
			$scope.applyFilter();
		}
	);

    $scope.applyFilter = function () {
        if ($scope.transient.product_id) {
            $scope.revisionFilter = dbFilterFactory.getNumberFilter('product_id', $scope.transient.product_id);
        }
    };
    
    function initLookups() {
      $scope.lookup = {};
      eggsFormFactory.addLookup($scope.lookup, 'customer_id', 'customer', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'production_order_id', 'prod_order', 'code', 'code');
      eggsFormFactory.addLookup($scope.lookup, 'product_id', 'product', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'task_id', 'task', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'revision_id', 'revision', 'code', 'description');
    }

    function getControlReportProduction(id) {
      /* recordFactory('control_report').byId({ id: id }).$promise.then(function (response) {
        loadDocument(response);
      }); */
    }

    function loadDocument(model){
      angular.extend($scope.transient,model);
      eggsFormFactory.convertDates($scope.transient, $scope.record.dates);
      $log.info($scope.transient);
      eggsFormFactory.loadLookupData($scope.record.lookup, $scope.transient);
    }

    $scope.goToList= function(){
      var path = '/qs/controlreportproduction/list';
      $location.path(path);
    }

    $scope.save = function(){
    
      hpeControlReportProductionFactory.saveOrUpdateControlReportProduction({},$scope.transient).$promise
      .then(function(response){
        if(response.success){
          if(angular.isUndefined($routeParams.id)){
            var path = '/qs/controlreportproduction/list';
            $location.path(path);
          }
          else {
            loadDocument(response.model);
          }
          toaster.pop('success', msg.operation_completed, msg.operation_completed_success);
        }
        else {
          toaster.pop('error', msg.error, page_msg[response.error_message]);
        }
      })
      .catch(function(ex){ logError(ex) })
    }

    $scope.delete = function(){

      var reportId = {"id": $routeParams.id};    
      hpeControlReportProductionFactory.deleteControlReportProduction({},reportId).$promise
      .then(function(response){
        if(response.success){
          var path = '/qs/controlreportproduction/list';
          $location.path(path);
          toaster.pop('success', msg.operation_completed, msg.operation_completed_success);
        }
        else {
          toaster.pop('error', msg.error, page_msg[response.error_message]);
        }
      })
      .catch(function(ex){ logError(ex) })
    }

    var logError = function logError(ex){
      toaster.pop('error', msg.error, msg.server_comunication_error);
    }
   

    function init() {
      getFunctionCode();
      localeFactory.loadTranslation(pageBundle)
        .then(function(){
          $q.all({
            general: localeFactory.translateMsg(msg),
            specific: localeFactory.translateMsg(page_msg, pageBundle)
          })
          .then(function(data){})
          .catch(function(ex){});
        })
        .catch(function(ex){});
      
      if (angular.isDefined($routeParams.id)) {
        //getControlReportProduction($routeParams.id);
        $scope.editMode = true;
      }
      
      initLookups();
      
      //checkPermissions();

      $scope.enum = enums;
    }

    function checkPermissions() {
      var profilingKey = 'HPE_CONTROL_REPORT_PROD_FUNCTION';
      var permission = authFactory.getPermissions(profilingKey);
      if(!permission.EXEC) {
          $location.path('forbidden').search({key: profilingKey});
      }
      else {
          $scope.isNewAllowed = permission.NEW;
          $scope.isDetailAllowed = permission.DETAIL;
          $scope.isUpdateAllowed = permission.UPDATE;

          if(!permission.DETAIL) {
            $location.path('forbidden').search({key: profilingKey});
          }

      }
    };

    function getFunctionCode() {
      var filters = dbFilterFactory.getCustomFilter("function_id in (select id from functions where jsf_action='#{controlReportProductionFunction.startPage()}')");
      recordFactory('menu').filter({},filters).$promise.then(function(data) {
        if(data.totalResults>0) {
          $scope.functionCode = data.list[0].menu_key;
        }
        else {
          toaster.pop('error', msg.error, 'RCP menu not found');
        }
      });
    }
  
    $scope.getJsfURL = function () {
        return getJsfURL($routeParams.id, $scope.functionCode);
    };

    function S4(seed) {
      if (!seed) seed = (new Date()).getSeconds();
      return 1;
    }

    function getJsfURL(selectedId, functionCode) {
      var jsfurl;
        if (authFactory.getAuthData() == null) {
            console.log('JsfCtrl auth data null');
            return '';
        }
        var params = '?username=' + authFactory.getAuthData().authId + '';
        var changedProfile = false;
        if (functionCode && !changedProfile) {
            params = params + '&functionCode=' + functionCode;
            if(selectedId) {
                params = params + '&selectedId=' + selectedId;
            }
            $location.search('t', S4()); // Da lasciare assolutamente, altrimenti si creano inspiegabili problemi alla navigazione (se esco da una jsf, ho problemi a rientrare).
            jsfurl = APP_URL + params;
        }
        return jsfurl;
    };


    init();

  });
'use strict';

/**
 * @ngdoc function
 * @name ictportal.hpe.controller:HpeControlReportProductionListCtrl
 * @description Pagina di lista dei Report di Controllo Produzione
 * @author Mattia Freda
 *
 * created on 27/09/2018
 * # HpeControlReportProductionListCtrl
 * Controller of the ictportal.hpe
 *
 */
angular.module('ictportal.hpe')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/qs/controlreportproduction/list', {
                templateUrl: 'hpe/control-report-production/list/control-report-production-list.html',
                controller: 'HpeControlReportProductionListCtrl'
            })
    })
    .controller('HpeControlReportProductionListCtrl', function ($scope, recordFactory, $routeParams, $location, authFactory,
                                                $rootScope, parseSchemaService, schemaFactory, dbFilterFactory, localeFactory, $q,
                                                toaster, eggsFormFactory, $localstorage) {
        var pageBundle = 'control_report_production';
        var msg = {};
        var page_msg = {
            "number": "Numero",
            "code": "Codice",
            "control_plan": "Piani di controllo",
            "product": "Articolo",
            "revision": "Revisione",
            "customer": "Cliente",
            "production_order": "Commessa",
            "billing_mode": "Tipo consuntivazione"
        };

        var myBar = 'RCP';
        var KEY_LOCAL_STORAGE = 'control-report-production-list-filter';
        var KEY_LOCAL_STORAGE_BIS = 'control-report-production-list-filter2';
        var enums = {
            billing_mode: [
                {
                    name: 'Pezzo singolo',
                    value: 'SINGLE'
                },
                {
                    name: 'Lotto di pezzi',
                    value: 'LOT'
                }
            ]
        };

        $scope.result = {};
        $scope.revisionFilter = []; // Filtro da applicare alla lookup sulla revisione
        $scope.record = {
            lookup: {},
            dates: []
        };
        $scope.params = {
            pageNumber: 1,
            pageSize: 15,
            filters: []
        };
        $scope.viewGridOptions = { appScopeProvider: $scope, enableFiltering: false };
        $scope.advFilter = {
            filter: {},
            list: []
        };
        $scope.enum = {};

        $scope.$watchGroup(['advFilter.filter.validity_date',
            'advFilter.filter.customer_id',
            'advFilter.filter.production_order_id',
            'advFilter.filter.product_id',
            'advFilter.filter.revision_id',
            'advFilter.filter.billing_mode',
            'advFilter.filter.working_area_id',
            'advFilter.filter.task_id'
        ], function () {
                $scope.applyFilter();
            }
        );

        $scope.applyFilter = function () {
            $scope.advFilter.list.length = 0;
            if ($scope.advFilter.filter.validity_date) {
                var f = dbFilterFactory.getDateFilter('t.report_date', $scope.advFilter.filter.validity_date, '=');
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.customer_id) {
                var f = dbFilterFactory.getNumberFilter('t.customer_id', $scope.advFilter.filter.customer_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.production_order_id) {
                var f = dbFilterFactory.getNumberFilter('t.production_order_id', $scope.advFilter.filter.production_order_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.product_id) {
                var f = dbFilterFactory.getNumberFilter('t.product_id', $scope.advFilter.filter.product_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
                $scope.revisionFilter = dbFilterFactory.getNumberFilter('product_id', $scope.advFilter.filter.product_id);
            }
            if ($scope.advFilter.filter.revision_id) {
                var f = dbFilterFactory.getNumberFilter('t.revision_id', $scope.advFilter.filter.revision_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.billing_mode) {
                var f = dbFilterFactory.getStringFilter('t.billing_mode', $scope.advFilter.filter.billing_mode);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.working_area_id) {
              var f = dbFilterFactory.getNumberFilter('t.working_area_id', $scope.advFilter.filter.working_area_id);
              $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.task_id) {
                var f = dbFilterFactory.getNumberFilter('cp.task_id', $scope.advFilter.filter.task_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            $scope.getData();
        };

        var initGridColumns = function () {
            $scope.lookupCols = [];
            $scope.viewGridOptions.columnDefs = [];
            $scope.viewGridOptions.columnDefs.push({
                displayName: '',
                field: 'id',
                width: 34,
                enableCellEdit: false,
                enableFiltering: false,
                enableSorting: false,
                cellTemplate:
                '<div class="ui-grid-cell-contents" style="text-align: center">' +
                    '<button ng-click="grid.appScope.viewDetail(row.entity)" class="btn btn-xs btn-primary">' +
                    '<span class="fa fa-search"></span>' +
                    '</button>' +
                '</div>'
            });
            $scope.viewGridOptions.columnDefs.push({
                name: 'Number',
                field: "number",
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.number}} / {{ row.entity.bar}}</div>',
                translation: 'number'
            });
            $scope.viewGridOptions.columnDefs.push({
                name: 'Code',
                field: "code",
                translation: 'code'
            });
            /* $scope.viewGridOptions.columnDefs.push({
                name: 'Validity date',
                field: "report_date",
                cellFilter: "date:'dd/MM/yyyy'",
                translation: 'validity_date'
            }); */
            $scope.viewGridOptions.columnDefs.push({
                name: 'Control plan',
                field: "control_plan_code",
                translation: 'control_plan'
            });
            $scope.viewGridOptions.columnDefs.push({
                name: 'Product',
                field: "product_code",
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.product_code}} - {{ row.entity.product_description}}</div>',
                translation: 'product'
            });
            $scope.viewGridOptions.columnDefs.push({
                name: 'Revision',
                field: "revision_code",
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.revision_code}} - {{ row.entity.revision_description}}</div>',
                translation: 'revision'
            });
            $scope.viewGridOptions.columnDefs.push({
                name: 'Customer',
                field: "customer_code",
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.customer_code}} - {{ row.entity.customer_description}}</div>',
                translation: 'customer'
            });
            $scope.viewGridOptions.columnDefs.push({
                name: 'Production order',
                field: "production_order_number",
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.production_order_code}} ({{ row.entity.production_order_number}}/{{ row.entity.production_order_year}})</div>',
                translation: 'production_order'
            });
            $scope.viewGridOptions.columnDefs.push({
                name: 'Billing mode',
                field: "billing_mode",
                translation: 'billing_mode'
            });
        };

        $scope.getData = function () {
            var payload = {
                page: $scope.params.pageNumber,
                page_size: $scope.params.pageSize,
                code: $scope.params.code,
                description: $scope.params.description,
                show_revision: false,
                sort_fields: ($scope.params.sortFields ? $scope.params.sortFields : 'created_date'),
                sort_order: $scope.params.sortOrder
            };
            var filters = [
                {
                    "column": "customer c",
                    "value": "t.customer_id = c.id",
                    "relation": "JOIN",
                    "kind": "c.description AS customer_description, c.code AS customer_code"
                },
                {
                    "column": "control_plan cp",
                    "value": "t.control_plan_id = cp.id",
                    "relation": "JOIN",
                    "kind": "cp.code AS control_plan_code"
                },
                {
                    "column": "product p",
                    "value": "t.product_id = p.id",
                    "relation": "JOIN",
                    "kind": "p.description AS product_description, p.code AS product_code"
                },
                {
                    "column": "revision r",
                    "value": "t.revision_id = r.id",
                    "relation": "JOIN",
                    "kind": "r.description AS revision_description, r.code AS revision_code"
                },
                {
                    "column": "prod_order po",
                    "value": "t.production_order_id = po.id",
                    "relation": "JOIN",
                    "kind": "po.code AS production_order_code, po.num AS production_order_number, po.year AS production_order_year"
                }
            ].concat(dbFilterFactory.getStringFilter('t.bar', myBar));
            filters = filters.concat($scope.advFilter.list);

            recordFactory('control_report').filter(payload, filters)
                .$promise.then(function (data) {
                    $scope.viewGridOptions.totalItems = data.totalResults;
                    $scope.result.totalResults = data.totalResults;
                    $scope.result.list = data.list;
                });
        };

        $scope.viewDetail = function (value) {
            $localstorage.setObject(KEY_LOCAL_STORAGE, $scope.lookup);
            $localstorage.setObject(KEY_LOCAL_STORAGE_BIS, $scope.advFilter.filter);
            var path = '/qs/controlreportproduction/detail/' + value.id;
            $location.path(path);
            // apertura pagina dettaglio JSF
            //goToCreatedRCP(value.id);
        };

        function goToCreatedRCP(id){
            var filters = dbFilterFactory.getCustomFilter("function_id in (select id from functions where jsf_action='#{controlReportProductionFunction.startPage()}')");
            recordFactory('menu').filter({},filters).$promise.then(function(data){
              if(data.totalResults>0){
                var functionCode = data.list[0].menu_key;
                $location.url('jsf?functionCode=' + functionCode + '&selectedId=' + id);
              }
              else{
                toaster.pop('error', msg.error, 'RCP menu not found');
              }
            });
          }

        $scope.goToNew = function () {
            $localstorage.setObject(KEY_LOCAL_STORAGE, $scope.lookup);
            $localstorage.setObject(KEY_LOCAL_STORAGE_BIS, $scope.advFilter.filter);
            var path = '/qs/controlreportproduction/detail';
            $location.path(path);
        };

        function translateGridColumns() {
            $scope.viewGridOptions.columnDefs.forEach(function (col) {
                if (col.translation) {
                    if (page_msg[col.translation]) {
                        col.name = page_msg[col.translation];
                    }
                    else {
                        col.name = msg[col.translation];
                    }
                }
            });
        };

        function initLookups() {
            $scope.lookup = {};
            eggsFormFactory.addLookup($scope.lookup, 'customer_id', 'customer', 'code', 'description');
            eggsFormFactory.addLookup($scope.lookup, 'production_order_id', 'prod_order', 'code', 'code');
            eggsFormFactory.addLookup($scope.lookup, 'product_id', 'product', 'code', 'description');
            eggsFormFactory.addLookup($scope.lookup, 'revision_id', 'revision', 'code', 'description');
            eggsFormFactory.addLookup($scope.lookup, 'working_area_id', 'working_area', 'code', 'description');
            eggsFormFactory.addLookup($scope.lookup, 'task_id', 'task', 'code', 'description');
        }

        function initFilters(state, state2){
            // Filtro da applicare alla lookup sulla revisione
            // if ($scope.advFilter.filter.product_id) {
            //     $scope.revisionFilter = dbFilterFactory.getNumberFilter('product_id', $scope.advFilter.filter.product_id);
            // }
          if (state !== null) {
            console.log('restore previous filters');
            $scope.lookup = state;
          }
          if (state2 !== null) {
            $scope.advFilter.filter = state2;
            if($scope.advFilter.filter.validity_date){
              $scope.advFilter.filter.validity_date = new Date($scope.advFilter.filter.validity_date);
            }
            console.log($scope.advFilter.filter)
          }
        }

        $rootScope.$on('$translateRefreshEnd', function () {
            $q.all({
                general: localeFactory.translateMsg(msg),
                specific: localeFactory.translateMsg(page_msg, pageBundle)
            })
                .then(function (data) {
                    translateGridColumns();
                })
                .catch(function (error) { $log.error(error); });
        });

        $scope.reset = function() {
          $scope.advFilter.filter = {};
          $scope.$broadcast('clearLookUp');
          $scope.$broadcast('clearEnums');
          $scope.getData();
          $localstorage.remove(KEY_LOCAL_STORAGE);
          $localstorage.remove(KEY_LOCAL_STORAGE_BIS);
        }

        function checkPermissions() {
            var profilingKey = 'HPE_CONTROL_REPORT_PROD_FUNCTION';
            var permission = authFactory.getPermissions(profilingKey);
            if(!permission.EXEC) {
                $location.path('forbidden').search({key: profilingKey});
            }
            else {
                $scope.isNewAllowed = permission.NEW;
            }
        };

        function init() {
            var previous_state = $localstorage.getObject(KEY_LOCAL_STORAGE);
            var previous_state2 = $localstorage.getObject(KEY_LOCAL_STORAGE_BIS);
            localeFactory.loadTranslation(pageBundle);
            initGridColumns();
            initLookups();
            initFilters(previous_state, previous_state2);
            //checkPermissions();
            $scope.enum = enums;
        }

        //___ main ___
        init();

    });

'use strict';

/**
 * Created by Esmeralda TUPI on 06/06/17.
 */
angular.module('ictportal.icteggs').controller('operatoriDocumentiCtrl', function ($scope, eggsFormFactory, dbFilterFactory, schemaFactory, recordFactory) {
    var $ctrl = this;
    $ctrl.sxCorList = [];
    $scope.enum = {
        presentazione: [
            {
                label: 'SI',
                value: 'S'
            },
            {
                label: 'NO',
                value: 'N'
            },
            {
                label: 'Esente',
                value: 'E'
            }
        ],
        tipo: [
            {
                label: 'Generico',
                value: 'G'
            },
            {
                label: 'Idoenita',
                value: 'I'
            },
            {
                label: 'Soggiorno',
                value: 'S'
            },
            {
                label: 'Alloggio',
                value: 'A'
            }
        ],
        statussoggiorno: [
            {
                label: 'PERMESSO',
                value: 'PE'
            },
            {
                label: 'Cancellato (CARTA)',
                value: 'CA'
            },
            {
                label: 'IN RINNOVO',
                value: 'RI'
            },
            {
                label: 'IN ATTESA DI PERMESSO',
                value: 'AT'
            },
             {
                label: 'CARTA PERMANENTE',
                value: 'CP'
            },
             {
                label: 'ALTRO PROVVEDIMENTO',
                value: 'AP'
            },
             {
                label: 'PERMESSO DI SOGGIORNO CE PER SOGG. LUNGO PERIODO',
                value: 'CL'
            }
        ]
    };
    function initLookups() {
        $ctrl.lookup = {};
        eggsFormFactory.addLookup($ctrl.lookup, 'tipodocumentoid', 'tabtipodoc', 'codice', 'descrizione');
        eggsFormFactory.addLookup($ctrl.lookup, 'questurapermessoid', 'tabprov', 'codice', 'descrizione');
         eggsFormFactory.addLookup($ctrl.lookup, 'tipopermessoid', 'tabtipopermessosogg', 'codice', 'descrizione');
          eggsFormFactory.addLookup($ctrl.lookup, 'comuneid', 'tabcomuni', 'codice', 'descrizione');
          eggsFormFactory.addLookup($ctrl.lookup, 'provid', 'tabprov', 'codice', 'descrizione');
         
    };
    $scope.undo = function () {
        $ctrl.sxShow = false;
        if ($ctrl.sxCloseCallback) {
            $ctrl.sxCloseCallback();
        }
    };
    function saveDocumenti(item) {
        if (!item.id) {
            item.riga = $ctrl.sxList.length + 1,
                item.operatoreid = $ctrl.sxOperatoreId
           recordFactory('operatoridocumenti').create(item).$promise.then(function (data) {
            
                 alert("saved");
            });
        }
        else {
            recordFactory('operatoridocumenti').update({ id: item.id }, item).$promise.then(function (data) {
               alert("updated");
            });
        }
        $scope.sxShow = false;
    };
    
    function validate() {
        var result = true;
        // TODO
        return result;
    };
    $scope.save = function () {
        if (validate()) {
            saveDocumenti($scope.operatoredoc);

            $scope.sxShow = false;
            if ($ctrl.sxCloseCallback) {
                $ctrl.sxCloseCallback();
            }
        }
    };
   function getTipo() {
       //todo
  };
  

    this.$onInit = function () {
        if (!$ctrl.sxList) {
            $ctrl.sxList = [{}];
        }
 $ctrl.sxCorList.length = 0;
    $ctrl.sxCorList.push();

        $scope.operatoredoc = $ctrl.sxModel;
        $scope.documenti = $ctrl.sxList;
        initLookups();
        eggsFormFactory.loadLookupData($ctrl.lookup, $scope.operatoredoc);
        getTipo();

    };


});




'use strict';

/**
 * Created by Esmeralda TUPI on 06/06/17.
 * @ngdoc component
 * @name ictportal.icteggs:OperatoriDocumenti
 */
angular.module('ictportal.icteggs').component('operatoriDocumenti', {
    restrict: 'E',
    controller: 'operatoriDocumentiCtrl',
    templateUrl: 'icteggs/taboperatori/operatoridocumenti/operatoridocumenti.html',
    bindings: {
        sxOperatoreId: '=',
        sxModel: '=?',
        sxList: '=?',
        sxListc: '=?',
        sxShow: '=',
        sxDelete: '=',
        sxModal: '=?',
        sxCloseCallback: '&'
    }
});

'use strict';

/**
 * Created by Rita Beltrami on 29/05/17.
 */
angular.module('ictportal.icteggs').controller('operatoriFamiliariDetrCtrl', function ($scope, eggsFormFactory, dbFilterFactory, schemaFactory, $routeParams,
  recordFactory, toaster, $rootScope) {
  var $ctrl = this;
  $ctrl.sxCorList = [];
  var totalCors = 0;
  var savedCors = 0;
  var saveSuccess = true;
  $scope.checkFields = ['detrazionedalavoro', 'conviventeinitalia', 'acarico', 'assegnofamiliare'];
  $scope.enum = {
    rapportoparentela: [
      {
        label: 'Coniuge',
        value: 'C'
      },
      {
        label: 'Figlio',
        value: 'F'
      },
      {
        label: 'Altro',
        value: 'A'
      }
    ],
    sesso: [
      {
        label: 'Maschio',
        value: 'M'
      },
      {
        label: 'Femmina',
        value: 'F'
      }
    ],
  };

  $scope.addNuovo = function (row) {
    $ctrl.sxCorList.push({});
  };

  function tryDelete() {
    $ctrl.sxDelete = false;
    if (!$ctrl.sxModal) {
      alert('Modal not found');
    }
    else {
      $ctrl.sxModal.title = 'Conferma eliminazione';
      $ctrl.sxModal.message = 'Sei sicuro di voler eliminare il record selezionato?';
      $ctrl.sxModal.callback = $scope.doDelete;
      $rootScope.$broadcast('sixConfirmModal:open');
    }
  };

  $scope.doDelete = function () {
    alert('La vediamo dopo');
    // TODO
  };

  function initCheckboxes() {
    $scope.checkbox = {};
    $scope.checkFields.forEach(function (field) {
      eggsFormFactory.addCheckbox($scope.checkbox, field);
    });
  };

  function initLookups() {
    $ctrl.lookup = {};
    eggsFormFactory.addLookup($ctrl.lookup, 'cittanascitaid', 'tabcomuni', 'codice', 'descrizione');
  };

  function validate() {
    var result = true;
    // TODO
    return result;
  };

  $scope.save = function () {
    if (validate()) {
      saveOperatoriFamiliariDetr($scope.operatoredetr);
    }
  };

  $scope.undo = function () {
    $ctrl.sxShow = false;
    if ($ctrl.sxCloseCallback) {
      $ctrl.sxCloseCallback();
    }
  };

  function saveOperatoriFamiliariDetr(item) {
    totalCors = $ctrl.sxCorList.length;
    savedCors = 0;
    saveSuccess = true;
    if (!item.id) {
      item.riga = $ctrl.sxList.length + 1;
      item.operatoreid = $ctrl.sxOperatoreId;
      if (!item.detrazionedalavoro) {
        item.detrazionedalavoro = 'N';
      }
      recordFactory('operatorifamiliaridetr').create(item).$promise.then(function (data) {
        saveSuccess &= angular.isDefined(data.id);
        checkSavingCompleted();
        $ctrl.sxCorList.forEach(function (row) {
          saveOperatoriFamiliariDetrCor(row);
        })
      });
    }
    else {
      recordFactory('operatorifamiliaridetr').update({ id: item.id }, item).$promise.then(function (data) {
        saveSuccess &= angular.isDefined(data.query);
        checkSavingCompleted();
        $ctrl.sxCorList.forEach(function (row) {
          saveOperatoriFamiliariDetrCor(row);
        })
      });
    }
    $scope.sxShow = false;
  };

  function checkSavingCompleted(){
    if(savedCors>=totalCors){
      $scope.sxShow = false;
      if(saveSuccess){
        toaster.pop('success', 'Salvataggio completato', 'Operazione completata');
      }
      else{
        toaster.pop('error', 'Si è verificato un errore', 'Operazione fallita. Si prega di riprovare.');
      }
      if ($ctrl.sxCloseCallback) {
        $ctrl.sxCloseCallback();
      }
    }
  };

  function saveOperatoriFamiliariDetrCor(item) {
    if (!item.id) {
      item.riga = $ctrl.sxCorList.length + 1;
      item.familiaridetrazioniid = $ctrl.sxModel.id;
      if (!item.conviventeinitalia) {
        item.conviventeinitalia = 'N';
      }
      if (!item.acarico) {
        item.acarico = 'N';
      }
      if (!item.assegnofamiliare) {
        item.assegnofamiliare = 'N';
      }
      recordFactory('operatorifamiliaridetrcor').create(item).$promise.then(function (data) {
        saveSuccess &= angular.isDefined(data.id);
        savedCors++;
        checkSavingCompleted();
      });
      $ctrl.sxCorList.push(item);
    }
    else {
      recordFactory('operatorifamiliaridetrcor').update({ id: item.id }, item).$promise.then(function (data) {
        saveSuccess &= angular.isDefined(data.query);
        savedCors++;
        checkSavingCompleted();
      });
    }
  };

  function getFamiliariDetrazioniCor() {
    if ($ctrl.sxModel.id) {
      var params = {
        page: 1,
        page_size: 10000
      };
      var filter = dbFilterFactory.getNumberFilter('familiaridetrazioniid', $ctrl.sxModel.id);
      recordFactory('operatorifamiliaridetrcor').filter(params, filter)
        .$promise.then(function (data) {
          $ctrl.sxCorList = $ctrl.sxCorList.concat(data.list.map(eggsFormFactory.restore));
        });
    }
  };

  this.$onInit = function () {
    if (!$ctrl.sxList) {
      $ctrl.sxList = [{}];
    }
    $ctrl.sxCorList.length = 0;
    $ctrl.sxCorList.push();

    $scope.operatoredetr = $ctrl.sxModel;
    $scope.familiariDetrazioni = $ctrl.sxList;
    $scope.familiariDetrazioniCor = [];
    getFamiliariDetrazioniCor();
    initCheckboxes();
    initLookups();
    eggsFormFactory.loadLookupData($ctrl.lookup, $scope.operatoredetr);
    if ($ctrl.sxDelete) {
      tryDelete();
    }
  };

});







'use strict';

/**
 * Created by Rita Beltrami on 29/05/17.
 * @ngdoc component
 * @name ictportal.icteggs:OperatoriFamiliariDetr
 */
angular.module('ictportal.icteggs').component('operatoriFamiliariDetr', {
  restrict: 'E',
  controller: 'operatoriFamiliariDetrCtrl',
  templateUrl: 'icteggs/taboperatori/operatorifamiliaridetr/operatorifamiliaridetr.html',
  bindings: {
    sxOperatoreId: '=',
    sxModel: '=?',
    sxList: '=?',
    sxListc: '=?',
    sxShow: '=',
    sxDelete: '=',
    sxModal: '=?',
    sxCloseCallback: '&'
  }
});


'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:EmployeeComponentMatchCtrl
 * @description Funzione di associazione capi (non) personalizzati dipendente
 * # EmployeeComponentMatchCtrl
 * Controller of the ictportal.lm
 *
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/employee/component/match', {
                templateUrl: 'lm/employee/employeeComponentMatch/employeeComponentMatch.html',
                controller: 'EmployeeComponentMatchCtrl'
            })
            .when('/employee/component/match/:specialUse', {
                templateUrl: 'lm/employee/employeeComponentMatch/employeeComponentMatch.html',
                controller: 'EmployeeComponentMatchCtrl'
            })
    })
    .controller('EmployeeComponentMatchCtrl', function ($scope, $rootScope, $routeParams, $filter, authFactory, toaster, employeeFactory,  matrixParFactory,
                    COMPONENT_READ_MODE, SCAN_KIND, dbFilterFactory, recordFactory, eggsFormFactory, $q, $log, localeFactory) {

        var msg = {
            success: "Success",
            error: "Error",
            warning: "Warning",
            cannot_match: "Cannot match",
            server_comunication_error: "Server communication error"
        };
        var componentMatchMsg = {
            component_match_title: "Employee generic garment association",
            component_match_alt_title: "Employee individual garment association",
            component_invalid_status: "The component has an invalid status",
            component_product_mismatch: "The component does not correspond to the selected product",
            blank_size: "Endowment product has no size",
            component_wrong_size: "The garment has a wrong size",
            employee_product_det_full: "The quantity required in the endowment has been reached",
            component_saved: "Component saved",
            component_not_saved: "Unable to save component",
            component_coupled: "Component coupled with employee",
            component_decoupled: "Component decoupled with employee",
            component_not_found: "No component/pack associated to barcode {{barcode}}",
            component_already_coupled: "Garment already coupled with another employee",
            unknown_special_use: "Personalizzazione non riconosciuta",
            missing_azcod: "Missing AZCOD",
            missing_divcod: "Missing DIVCOD"
        };
        $scope.localeMessages = {};
        $scope.pageTitle = undefined;
        $scope.specialUse = "GENERIC";

        $scope.enum = {
            sex: [
              {
                name: 'Femmina',
                value: 'F'
              },
              {
                name: 'Maschio',
                value: 'M'
              }
            ],
        };
        $scope.element = {};
        $scope.read = {};
        $scope.employeeId = undefined;
        $scope.employeeMatriculation = undefined;

        $scope.modeAuto = true;
        $scope.compList = [];
        $scope.readList = [];
        $scope.epdList = [];
        $scope.matchList = [];
        $scope.settings = {};
        $scope.userId = undefined;
        $scope.params = {
            pageNumber: 1,
            pageSize: 100,
            filters: []
        };
        $scope.advFilter = {
            filter: {},
            list: []
        };
        $scope.productFilter = [];
        $scope.compReaderMode = COMPONENT_READ_MODE.CODE;
        $scope.modal = {
            title: 'Conferma disassociazione',
            message: 'Sei sicuro di voler disassociare il capo?'
        };
        $scope.packagingError = undefined;
        $scope.empFilter = [];
        $scope.repFilter = [];
        $scope.matchEnabled = false;
        var allowedComponentStatuses = [];
        var packCurrQty = {};
        var component = null;
        var componentId = undefined;
        var componentBarcode = undefined;

        $scope.$watch('lookup.customer_id.obj', function() {
          if ($scope.lookup.customer_id.obj) {
            $scope.repFilter = dbFilterFactory.getCustomFilter("t.customer_id = "+$scope.lookup.customer_id.obj.id)
            $scope.empFilter = $scope.defaultEmpFilter;
            $scope.empFilter = $scope.empFilter.concat(dbFilterFactory.getCustomFilter("cd.customer_id = "+$scope.lookup.customer_id.obj.id))
            if ($scope.lookup.destination_id.obj) {
              $scope.empFilter = $scope.empFilter.concat(dbFilterFactory.getCustomFilter("cd.id = "+$scope.lookup.destination_id.obj.id))
            }
          } else {
            $scope.lookup.customer_id.obj = undefined;
            $scope.empFilter = $scope.defaultEmpFilter;
            $scope.repFilter = [];
          }
        });

      $scope.$watch('lookup.destination_id.obj', function() {
        if ($scope.lookup.destination_id.obj) {
          $scope.empFilter = $scope.defaultEmpFilter;
          $scope.empFilter = $scope.empFilter.concat(dbFilterFactory.getCustomFilter("cd.id = "+$scope.lookup.destination_id.obj.id))
          if ($scope.lookup.customer_id.obj) {
            $scope.empFilter = $scope.empFilter.concat(dbFilterFactory.getCustomFilter("cd.customer_id = "+$scope.lookup.customer_id.obj.id))
          }
        } else {
          $scope.lookup.destination_id.obj = undefined;
          $scope.empFilter = $scope.defaultEmpFilter;
          if ($scope.lookup.customer_id.obj) {
            $scope.empFilter = $scope.empFilter.concat(dbFilterFactory.getCustomFilter("cd.customer_id = "+$scope.lookup.customer_id.obj.id))
          }
        }

      });

        $scope.$watch('lookup.employee_id.obj', function() {
            $scope.epdList = [];
            $scope.matchList = [];
            if ($scope.lookup.employee_id.obj) {
                $scope.element = $scope.lookup.employee_id.obj;
                // var f = dbFilterFactory.getNumberFilter('id', $scope.element.destination_id);
                // recordFactory('customer_destination').filter({page_size: 1000, code: 'code', description: 'description'}, f)
                // .$promise.then(function (data) {
                //     if (data.list) {
                //         $scope.lookup.destination_id.obj = data.list[0];
                //         $scope.employeeId = $scope.element.id;
                //         $scope.employeeMatriculation = $scope.element.matriculation;
                //     }
                //
                //     $scope.getEmployeeComponents();
                // });
              $scope.employeeId = $scope.element.id;
              $scope.employeeMatriculation = $scope.element.matriculation;
              $scope.getEmployeeComponents();
            } else {
                $scope.lookup.destination_id.obj = undefined;
                $scope.employeeId = undefined;
                $scope.employeeMatriculation = undefined;
                $scope.element = null;
            }
        });

        $scope.getEmployeeProductDets = function(){
            var payload = {
              page_size: 10000
            };
            var filters = [{
                column: 'product p',
                value: 't.product_id = p.id',
                relation: 'JOIN',
                kind: 'p.code AS prod_code, p.description AS prod_des'
            },
            {
                column: 'tab_size s',
                value: 't.size_id = s.id',
                relation: 'JOIN',
                kind: 's.code AS size_code, s.description AS size_des'
            }];
            filters = filters.concat(getEndowmentValidityFilter());
            var azcod = authFactory.getAuthData().info.azCod;
            var divcod = authFactory.getAuthData().info.divCod;
            var employeeDto = {'id': $scope.employeeId,
                    'azcod': azcod,
                    'divcod': divcod};
            // [SIXLM-381] viene forzato l'aggiornamento del best match sulla dotazione
            employeeFactory.updateEndowmentBestMatch({},employeeDto).$promise
            .then(function(response) {
                if(response.success) {
                    // quindi viene utilizzata la dotazione presente sul dipendente
                    filters = filters.concat(dbFilterFactory.getNumberFilter('e.id',$scope.element.endowment_id));

                    filters = filters.concat(dbFilterFactory.getNumberFilter('t.employee_id',$scope.employeeId));
                    recordFactory('employee_product_det').filter(payload, filters)
                        .$promise.then(function(data) {
                            $log.info(data);
                            if (data.list) {
                                data.list.forEach(function(e) {
                                    var match_amount = $scope.matchList.filter(function(m){
                                        return (m.product_code==e.prod_code && m.size_description==e.size_des); }).length;
                                    if (match_amount == 0) {
                                        match_amount = $scope.matchList.filter(function(m){
                                            return (m.product_code==e.prod_code && !e.size_des); }).length;
                                    }
                                    $scope.epdList.push({'id': e.id,
                                        'product_code': e.prod_code,
                                        'product_description': e.prod_des,
                                        'size_description': e.size_des,
                                        'endowment_qty': e.item_amount,
                                        'remaining_qty': e.item_amount - match_amount});
                                });
                                var outOfEndowment = {};
                                $scope.matchList.map(function (m) {
                                  var matchEpd = $scope.epdList.filter(function(e){
                                    return (m.product_code==e.product_code && m.size_description==e.size_description); }).length;
                                  if(matchEpd === 0){ //fuori dotazione
                                    var ps = m.product_code+"-"+m.size_description;
                                    if(!outOfEndowment[ps]){
                                      outOfEndowment[ps] = {c : m, q: 1};
                                    } else {
                                      outOfEndowment[ps].q = outOfEndowment[ps].q + 1;
                                    }
                                  }
                                })
                                if(outOfEndowment !== []){
                                  Object.keys(outOfEndowment).map(function (key){
                                    var current = outOfEndowment[key]
                                    $scope.epdList.push({'id': null,
                                      'product_code': current.c.product_code,
                                      'product_description': current.c.product_description,
                                      'size_description': current.c.size_description,
                                      'endowment_qty': current.q,
                                      'remaining_qty': 'FUORI DOTAZIONE'});
                                  })
                                }
                            }
                        });
                    }
                });
        };

        $scope.getEmployeeComponents = function(){
            var payload = {
                page_size: 10000
            };
            var filters = [{
                column: 'product p',
                value: 't.product_id = p.id',
                relation: 'JOIN',
                kind: 'p.code AS prod_code, p.description AS prod_des'
            },
            {
                column: 'tab_size s',
                value: 't.size_id = s.id',
                relation: 'JOIN',
                kind: 's.code AS size_code, s.description AS size_des'
            }];
            filters = filters.concat(dbFilterFactory.getNumberFilter('t.employee_id',$scope.employeeId));
            recordFactory('component').filter(payload, filters)
                .$promise.then(function(data) {
                    $log.info(data);
                    if (data.list) {
                        data.list.forEach(function(e) {
                            $scope.matchList.push({'id': e.id,
                                'barcode': e.barcode,
                                'unicode': e.unicode,
                                'product_code': e.prod_code,
                                'product_description': e.prod_des,
                                'size_description': e.size_des,
                                'employee_matriculation': $scope.employeeMatriculation});
                        });
                      var azcod = authFactory.getAuthData().info.azCod;
                      var divcod = authFactory.getAuthData().info.divCod;
                      var employeeDto = {'id': $scope.employeeId,
                        'azcod': azcod,
                        'divcod': divcod};
                      employeeFactory.loadEndowment({}, employeeDto).$promise.then(function(){
                          $scope.getEmployeeProductDets();
                        })
                    }
                });
        };

        function getTimestamp(day) {
            var m = (day.getMonth()+1);
            var mStr = (m<10)?('0'+m.toString()):m.toString();
            var d = (day.getDate());
            var dStr = (d<10)?('0'+d.toString()):d.toString();
            var timestamp = day.getFullYear() + '-' + mStr + '-' +dStr;
            return timestamp;
          }

        function getValidityQuery(table) {
            var timestamp = getTimestamp(new Date());
            var query = '(' + table + '.start_validity_date <= \'' + timestamp +
            '\' AND (' + table + '.end_validity_date IS NULL OR ' + table + '.end_validity_date>\'' + timestamp + '\') )';

            return query;
        }

        function getEndowmentValidityFilter() {
            var filter = [
                {
                    "column": "endowment_item ei",
                    "value": "p.id = ei.product_id",
                    "relation": "JOIN",
                    "kind": "ei.amount AS item_amount"
                },
                {
                    "column": "endowment e",
                    "value": "ei.endowment_id = e.id",
                    "relation": "JOIN",
                    "kind": "e.id AS endowment_id"
                }
            ];
            var valFilter_e = dbFilterFactory.getCustomFilter(getValidityQuery('e'));
            var valFilter_ei = dbFilterFactory.getCustomFilter(getValidityQuery('ei'));
            filter = filter.concat(valFilter_e, valFilter_ei);

            return filter;
        }


        function validateComponent(component) {
            var outcome = false;
            var cmpSize = true;
            var outOfEndow = false;
            // verifico il componente corrisponda ad un articolo in dotazione
            if ($scope.epdList.filter(function(e){ return e.product_code==component.prod_code; }).length === 0) { //articolo non in dotazione
                toaster.pop('error', msg.error, componentMatchMsg.component_product_mismatch);
            } else {
                // verifico il componente abbia la taglia corretta
                if ($scope.epdList.filter(function(e){ // articolo e taglia presenti (sia in dotazione che non) (1)
                    return (e.product_code==component.prod_code && e.size_description==component.size_des);
                    }).length === 0) {
                        //caso 2 : articolo con taglia non specificata
                        //caso 3 : articolo con taglia diversa -> posso metterlo fuori dotazione
                        if ($scope.epdList.filter(function(e){ //articolo in dotazione con taglia non specificata (2)
                            return (e.product_code==component.prod_code && !e.size_description);
                            }).length > 0) {
                                cmpSize = false;
                                toaster.pop('warning', msg.warning, componentMatchMsg.blank_size);
                        }
                        else { //articolo con taglia diversa -> lo metto fuori dotazione (3)
                            toaster.pop('error', msg.error, componentMatchMsg.component_wrong_size);
                            // return outcome;
                            outOfEndow = true;
                        }
                }
                // verifico ci siano ancora capi mancanti da associare
                if (cmpSize) {
                    var packKey = component.prod_code+component.size_des;
                    if (!(packCurrQty[packKey] > 0)) packCurrQty[packKey] = 1;
                    if ($scope.epdList.filter(function(e){
                      return (e.product_code==component.prod_code &&
                        ((e.size_description==component.size_des && e.remaining_qty > 0 && packCurrQty[packKey] <= e.remaining_qty) //(1) in dotaz
                        || (e.size_description==component.size_des && e.remaining_qty === 'FUORI DOTAZIONE') //(1) fuori dotaz
                        || outOfEndow)); //(3) fuori dotazione da aggiunger
                        }).length === 0)  {
                            toaster.pop('error', msg.error, componentMatchMsg.employee_product_det_full);
                        } else {
                          if(hasRemaining(component, packKey)){
                            packCurrQty[packKey]++;
                            outcome = true;
                          } else {
                            toaster.pop('error', msg.error, componentMatchMsg.employee_product_det_full);
                          }
                        }
                } else {
                    var packKey = component.prod_code;
                    if (!(packCurrQty[packKey] > 0)) packCurrQty[packKey] = 1;
                    if (!$scope.epdList.filter(function(e){
                        return (e.product_code==component.prod_code && !e.size_description
                            && e.remaining_qty > 0 && packCurrQty[packKey] <= e.remaining_qty);
                        }).length > 0) {
                            toaster.pop('error', msg.error, componentMatchMsg.employee_product_det_full);
                        } else {
                            packCurrQty[packKey]++;
                            outcome = true;
                        }
                }
            }

            return outcome;
        }

        function hasRemaining(component, packKey){
          var productEpds = $scope.epdList.filter(function(e){
            return (e.product_code === component.prod_code);
          })

          var remaining = 0;
          productEpds.map(function(epd){
            if(epd.remaining_qty === 'FUORI DOTAZIONE'){
              remaining = remaining - epd.endowment_qty;
            } else {
              remaining = remaining + epd.remaining_qty;
            }
          })

          return remaining > 0;
        }

        function validateAndCouplePack(pack, baseFilters){
            var filter = [{
                "column": "pack_row pr",
                "value": "pr.pack_id = " + pack.id,
                "relation": "JOIN",
                "kind": "pr.component_id"
            }];
            filter = filter.concat(baseFilters).concat(dbFilterFactory.getNumberFilter('t.id', 'pr.component_id'));
            recordFactory('component').filter({page_size:10000}, filter)
            .$promise.then(function(data) {
                if(data.list && data.list.length>0){
                    var valid = true;
                    // validazione
                    data.list.forEach(function(comp){
                        if (validateComponent(comp)) {
                            $log.info(comp);
                        } else {
                            valid = false;
                        }
                    });
                    // abbinamento
                    if (valid) {
                        $scope.matchEnabled = true;
                        data.list.forEach(function(comp){
                            component = comp;
                            componentId = comp.id;
                            componentBarcode = comp.barcode;
                            $scope.coupleComponent(component);
                        });
                    }
                }
            });
        }

        function isNewRead(read){
            var alreadyRead = $filter('filter')($scope.readList, {read: {read: read.read} });
            var result = (alreadyRead.length===0);
            return result;
        };

        $scope.readComponentCode = function(read){
            if(isNewRead(read)){
                var baseFilters = [{
                    "column": "product p",
                    "value": "t.product_id = p.id",
                    "relation": "JOIN",
                    "kind": "p.code AS prod_code, p.description AS prod_des"
                },
                {
                    "column": 'tab_size s',
                    "value": 't.size_id = s.id',
                    "relation": 'JOIN',
                    "kind": 's.code AS size_code, s.description AS size_des'
                }];
                var filters = baseFilters;
                switch(read.type){
                    case SCAN_KIND.BARCODE:
                        toaster.pop('info', 'Lettura barcode', read.read);
                        filters = filters.concat(dbFilterFactory.getStringFilter('barcode',read.read));
                        $scope.read.barcode = read.read;
                        break;
                    case SCAN_KIND.RFID:
                        toaster.pop('info', 'Lettura unicode', read.read);
                        filters = filters.concat(dbFilterFactory.getStringFilter('unicode',read.read));
                        $scope.read.unicode = read.read;
                        break;
                    case SCAN_KIND.MANUAL:
                        toaster.pop('info', 'Lettura codice', read.read);
                        filters = filters.concat(dbFilterFactory.getCustomFilter('(unicode=\'' + read.read + '\' OR barcode=\'' + read.read + '\')'));
                        $scope.read.unicode = read.read;
                        break;
                }
                $scope.read.type = read.type;
                packCurrQty = {};
                recordFactory('component').filter({page_size:10000}, filters)
                    .$promise.then(function(data) {
                        if(data.list && data.list.length>0){
                            component = data.list[0];
                            // aggiunta lettura pacchi
                            var filter = [{
                                "column": "pack_row pr",
                                "value": "pr.component_id = " + component.id,
                                "relation": "JOIN",
                                "kind": "pr.pack_id"
                            }];
                            filter = filter.concat(dbFilterFactory.getNumberFilter('t.id', 'pr.pack_id'));
                            recordFactory('pack').filter({page_size:10000}, filter)
                            .$promise.then(function(data) {
                                if(data.list && data.list.length>0){
                                    var pack = data.list[0];
                                    validateAndCouplePack(pack, baseFilters);
                                } else {
                                if (validateComponent(component)) {
                                $log.info(component);
                                var item = {read: read};
                                // Verifico lo stato del componente
                                // [SIXLM-352] ATM il controllo sullo stato viene bypassato
                                /*if(!isValidComponentStatus(component)){
                                    toaster.pop('error', msg.error, componentMatchMsg.component_invalid_status);
                                }
                                else{
                                }*/
                                // Verifica componente già letto
                                if(item.read.type===SCAN_KIND.BARCODE && item.read.read===component.barcode){
                                    item.component = component;
                                }
                                else if(item.read.type===SCAN_KIND.RFID && item.read.read===component.unicode){
                                    item.component = component;
                                }
                                else if(item.read.type===SCAN_KIND.MANUAL && item.read.read===component.unicode){
                                    item.component = component;
                                    item.read.type = SCAN_KIND.RFID;
                                }
                                else if(item.read.type===SCAN_KIND.MANUAL && item.read.read===component.barcode){
                                    item.component = component;
                                    item.read.type = SCAN_KIND.BARCODE;
                                }

                                componentId = component.id;
                                componentBarcode = component.barcode;
                                $scope.matchEnabled = true;
                                $scope.coupleComponent(component);
                                }
                                }
                            });
                            } else {
                                // aggiunta lettura pacchi
                                var codeFilter = dbFilterFactory.getStringFilter('barcode',read.read);
                                recordFactory('pack').filter({page_size:10000}, codeFilter)
                                .$promise.then(function(data) {
                                    if(data.list && data.list.length>0){
                                        var pack = data.list[0];
                                        validateAndCouplePack(pack, baseFilters);
                                    } else {
                                        localeFactory.translateReplace('employee.component_not_found', {barcode: read.read}).
                                            then(function(transl){
                                                toaster.pop('error', msg.error, transl);
                                        });
                                    }
                                });
                            }
                    });
            }
        };

        /**
         * Posso accettare solo i componenti che si trovino in un determinato stato.
         * I passaggi di stato ammessi sono definiti mediante matrixpar.
         */
        function isValidComponentStatus(component){
            var result = false;
            if(allowedComponentStatuses.length>0){
                result = (allowedComponentStatuses.indexOf(component.status)!=-1);
            }
            return result;
        };

        function getMatrixParWorkflow(){
            //Get matrix par that rapresent the change status permitted
            matrixParFactory.getMatrixPar({key: 'components.workflow', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}).$promise.then(function(data){
                var matrix = JSON.parse(data.value);
                if(matrix){
                    for(var key in matrix){
                        var array = matrix[key];
                        if(array.indexOf('P')!=-1){
                            allowedComponentStatuses.push(key);
                        }
                    }
                }
            });
        };

        $scope.coupleComponent = function(comp) {
            var azcod = authFactory.getAuthData().info.azCod;
            var divcod = authFactory.getAuthData().info.divCod;
            var matchDto = {'id': $scope.employeeId,
                    'componentId': comp.id,
                    'compSpecialUse': $scope.specialUse,
                    'azcod': azcod,
                    'divcod': divcod};
            employeeFactory.coupleComponent({},matchDto).$promise
            .then(function(response) {
                if(response.success) {
                    toaster.pop('success', msg.success, componentMatchMsg.component_coupled);
                    $scope.matchEnabled = false;

                    // aggiorno quantità mancanti dotazione
                    var idx = $scope.epdList.findIndex(function(e) {
                        return (e.product_code == comp.prod_code && e.size_description==comp.size_des);
                    });
                    if (idx == -1) {
                        idx = $scope.epdList.findIndex(function(e) {
                            return (e.product_code == comp.prod_code && !e.size_description);
                        });
                    }
                    if (idx != -1) $scope.epdList[idx].remaining_qty--;

                    // popolo l'elenco delle associazioni
                    $scope.matchList.push({'id': comp.id,
                                    'barcode': comp.barcode,
                                    'unicode': comp.unicode,
                                    'product_code': comp.prod_code,
                                    'product_description': comp.prod_des,
                                    'size_description': comp.size_des,
                                    'employee_matriculation': $scope.employeeMatriculation});
                    $scope.epdList = [];
                    $scope.getEmployeeProductDets();
                }
                else {
                    toaster.pop('error', msg.error, componentMatchMsg[response.message.toLowerCase()]);
                }
            }).catch(function(ex){ logError(ex) });
        }

        var logError = function logError(ex) {
            $log.log(ex);
            toaster.pop('error', msg.error, msg.server_comunication_error);
        }

        $scope.decoupleComponent = function(id) {
            if (!$scope.modal) {
                alert('Modal not found');
            }
            else {
                $scope.modal.callback = doDecoupleComponent.bind(null, id);
                $rootScope.$broadcast('sixConfirmModal_open');
            }
        };

        function doDecoupleComponent(id) {
            var azcod = authFactory.getAuthData().info.azCod;
            var divcod = authFactory.getAuthData().info.divCod;
            var employeeDto = {'componentId': id,
                    'azcod': azcod,
                    'divcod': divcod};

            employeeFactory.decoupleComponent({},employeeDto).$promise
            .then(function(response) {
                if(response.success) {
                    toaster.pop('success', msg.success, componentMatchMsg.component_decoupled);

                    var delComp = $scope.matchList.find(function(e) {
                        return e.id == id;
                    });
                    // aggiorno quantità mancanti dotazione
                    var idx = $scope.epdList.findIndex(function(e) {
                        return (e.product_code == delComp.product_code && e.size_description==delComp.size_description);
                    });
                    if (idx == -1) {
                        idx = $scope.epdList.findIndex(function(e) {
                            return (e.product_code == delComp.product_code && !e.size_description);
                        });
                    }
                    if (idx != -1) {
                      if($scope.epdList[idx].remaining_qty === 'FUORI DOTAZIONE'){ //era un componente non in dotazione
                        if($scope.epdList[idx].endowment_qty > 1){
                          $scope.epdList[idx].endowment_qty--;
                        } else {
                          $scope.epdList.splice(idx, 1);
                        }

                      } else {
                        $scope.epdList[idx].remaining_qty++
                      }
                    };
                    // rimuovo il componente dall'elenco delle associazioni
                    $scope.matchList = $scope.matchList.filter(function(e) {
                        return e.id != id;
                    });
                }
                else {
                    toaster.pop('error', msg.error, response.message);
                }
            });
        }


        function getOperator(){
            var username = authFactory.getAuthData().authId;
            var filters = [{
                "column": "human_resource o",
                "value": "o.user_id = t.id",
                "relation": "JOIN",
                "kind": "o.id AS operator_id"
            }];
            filters = filters.concat(dbFilterFactory.getStringFilter("username",username));
            recordFactory('users').filter({page_size:10000}, filters)
                .$promise.then(function(data) {
                    if(data.list && data.list.length>0){
                        $scope.userId = data.list[0].operator_id;
                    }
                });
        };

        function initLookups() {
            $scope.lookup = { };
            eggsFormFactory.addLookup($scope.lookup, 'employee_id', 'human_resource', 'matriculation', 'name,surname');
            eggsFormFactory.addLookup($scope.lookup, 'destination_id', 'customer_destination', 'code', 'description');
            eggsFormFactory.addLookup($scope.lookup, 'customer_id', 'customer', 'code', 'description');
            $scope.mappingLoaded = true;
        };

        function getTranslations(){
            localeFactory.loadTranslation('employee')
            .then(function() {
                localeFactory.translateMsg(msg, 'employee');
                localeFactory.translateMsg(componentMatchMsg, 'employee').then(function (data) {
                    $scope.localeMessages = data;
                    $scope.pageTitle = $scope.localeMessages.component_match_title;
                    // aggiunta parametro personalizzazione componente
                    if ($routeParams.specialUse) {
                        $scope.specialUse = $routeParams.specialUse.toUpperCase();
                        if ($scope.specialUse == "INDIVIDUAL")
                            $scope.pageTitle = $scope.localeMessages.component_match_alt_title;
                    }
                });
            });
        };

        function init() {
            getTranslations();
            //getMatrixParWorkflow();
            getOperator();
            var todaySql = "'" + getTimestamp(new Date()) + "'";
            $scope.empFilter = [{
              "column": "customer_destination cd",
              "value": "t.destination_id = cd.id",
              "relation": "JOIN",
              "kind": "cd.id as dest_id, cd.code as dest_code, cd.description as dest_description"
            },{
              "column": "customer c",
              "value": "cd.customer_id = c.id",
              "relation": "JOIN",
              "kind": "c.id as dest_customer_id, c.code as dest_customer_code, c.description as dest_customer_description"
            }];
            $scope.empFilter = $scope.empFilter.concat(dbFilterFactory.getCustomFilter('(t.validity_end is null OR t.validity_end > ' + todaySql + ')'));
            $scope.empFilter = $scope.empFilter.concat(dbFilterFactory.getStringFilter('t.discriminator', 'EMP'));
            $scope.userDest = authFactory.getAuthData().info.authorizations.destinations.toString();
            if($scope.userDest) {
              $scope.empFilter = $scope.empFilter.concat(dbFilterFactory.getCustomFilter("t.destination_id IN (SELECT id FROM customer_destination WHERE id in (" + $scope.userDest + ") OR parent in (" + $scope.userDest + "))"));
            }
            $scope.defaultEmpFilter = $scope.empFilter;
            var typeFilter = [{
                "column": "receiver_type rt",
                "value": "t.receiver_type_id = rt.id",
                "relation": "JOIN",
                "kind": "rt.code AS type_code"
            }];
            //$scope.repFilter = typeFilter.concat(dbFilterFactory.getInFilter('rt.code', ['REP', 'GUA']));
            initLookups();
        };

        //___ main ___
        init();

    });

'use strict';

angular.module('ictportal.lm')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/lm/goodsinward/detail', {
        templateUrl: 'lm/goodsInward/detail/goods-inward-detail.html',
        controller: 'lmGoodsInwardCtrl'
      })
      .when('/lm/goodsinward/detail/:id', {
        templateUrl: 'lm/goodsInward/detail/goods-inward-detail.html',
        controller: 'lmGoodsInwardCtrl'
      });
  })
  .controller('lmGoodsInwardCtrl', function ($scope, $log, recordFactory, $routeParams, $location, $filter, eggsFormFactory,
                                             toaster, dbFilterFactory, localeFactory, authFactory, $q, $rootScope, inventoryItemSrv) {

    $scope.readOnly = false;
    $scope.newRecord = false;
    $scope.result = {};
    $scope.enum = {
      status: [
        {
          name: 'Dispatched',
          value: 'DISPATCHED'
        }, {
          name: 'To dispatch',
          value: 'TO_DISPATCH'
        }, {
          name: 'Closed',
          value: 'CLOSED'
        }, {
          name: 'Canceled',
          value: 'CANCELED'
        }
      ]
    };
    $scope.params = {
      pageNumber: 1,
      pageSize: 15,
      totalItems: 0,
      filters: []
    };
    $scope.viewGridOptions = {
      appScopeProvider: $scope,
      enableFiltering: false,
      enableOrdering: true,
      exporterMenuPdf: true,
      exporterPdfDefaultStyle: {fontSize: 9},
      exporterPdfTableStyle: {margin: [-20, 0, 0, 0]},
      exporterPdfTableHeaderStyle: {fontSize: 10, bold: true, italics: true, color: 'red'},
      exporterPdfHeader: { text: "Ricevimento Merce", style: 'headerStyle' },
      exporterPdfCustomFormatter: function ( docDefinition ) {
        docDefinition.styles.headerStyle = { fontSize: 18, alignment: 'center', bold: true };
        return docDefinition;
      }
    };
    var pageBundle = 'goods_inward';
    var msg = {
      "error": "Error",
      "operation_completed": "Operation completed",
      "operation_completed_success": "Operation successfully completed",
      "server_comunication_error": "Server communication error"
    };
    var page_msg = {
      "MISSING_ITEM": "Missing product",
      "MISSING_DATA_HEADER": "Missing data in the header",
      "MISSING_SUPPLIER": "Supplier missing",
      "MISSING_STATUS": "Status missing",
      "MISSING_DATE": "Date missing",
      "SAVE_EXCEPTION": "Error while saving",
      "INVALID_REASON": "Invalid inventory reason",
      "customer_destination_not_found": "Customer destination not found",
      "missing_customer_destination": "Missing customer destination",
      "goods_inward_wardrobe": "Wardrobe goods inward",
      "goods_inward": "Goods inward",
      "DISPATCHED": "Dispatched",
      "TO_DISPATCH": "To Dispatch",
      "CLOSED": "Closed",
      "CANCELED": "Canceled",
      "row_index": "Row Index",
      "expiration_date": "Expiration Date",
      "stock_amount": "Stock Amount",
      "product_desc": "Product",
      "lot_desc": "Lot",
      "color_desc": "Color",
      "size_desc": "Size"
    };
    $scope.record = {
      lookup: {},
      dates: ['int_date', 'rec_date', 'dn_date'],
      model: {}
    };
    $scope.tabs = {
      activeTab: 0,
      TAB_HEAD: 0,
      TAB_ROWS: 1
    };
    $scope.supplierFilter = [];
    $scope.supplierItemFilter = [];
    $scope.colorFilter = [];
    $scope.sizeFilter = [];
    var authData = authFactory.getAuthData();

    function initLookups() {
      // goods_inward
      eggsFormFactory.addLookup($scope.record.lookup, 'supplier_id', 'supplier', 'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'type_id', 'goods_inward_type', 'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'wharehouse_id', 'facility', 'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'inventory_reason_id', 'inventory_reason', 'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'created_user_id', 'users', 'username', 'username');
      eggsFormFactory.addLookup($scope.record.lookup, 'last_modified_user_id', 'users', 'username', 'username');
      // goods_inward_row
      // eggsFormFactory.addLookup($scope.record.lookup, 'lot_id', 'lot', 'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'item_id', 'product', 'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'supplier_item_id', 'product_supplier', 'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'size_id', 'tab_size', 'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'color_id', 'color', 'code', 'description');
    }

    $scope.$watch('record.lookup.type_id.obj', function (newValue) {
      if ($scope.newRecord === true) {
        // se il record è già inserito facility e reason immutabili
        if (newValue) {
          if (newValue.wharehouse_id) {
            recordFactory('facility').byId({id: newValue.wharehouse_id}).$promise.then(function (data) {
              $scope.record.lookup.wharehouse_id.obj = data;
            });
          }
          if (newValue.inventory_reason_id) {
            recordFactory('inventory_reason').byId({id: newValue.inventory_reason_id}).$promise.then(function (data) {
              $scope.record.lookup.inventory_reason_id.obj = data;
            });
          }
        }
      }
    });

    $scope.$watch('record.lookup.supplier_id.obj', function (newValue) {
      if (newValue) {
        $scope.supplierItemFilter = dbFilterFactory.getNumberFilter('supplier_id', parseInt(newValue.id));
      }
    });

    $scope.$watch('record.lookup.item_id.obj', function (newValue, oldValue) {
      if($scope.record.lookup.supplier_id.obj) {
        $scope.supplierItemFilter = dbFilterFactory.getNumberFilter('supplier_id', $scope.record.lookup.supplier_id.obj.id);
      }
      if (newValue) {
        // filtro taglia e colore
        $scope.sizeFilter = dbFilterFactory.getNumberFilter('size_type_id', $scope.record.lookup.item_id.obj.size_type_id ? $scope.record.lookup.item_id.obj.size_type_id : -1);
        $scope.colorFilter = dbFilterFactory.getNumberFilter('color_type_id', $scope.record.lookup.item_id.obj.color_type_id ? $scope.record.lookup.item_id.obj.color_type_id : -1);
        // caricamento articolo fornitore
        if (!$scope.record.lookup.supplier_item_id.obj || $scope.record.lookup.supplier_item_id.obj.product_id !== newValue.id) {
          $scope.supplierItemFilter = $scope.supplierItemFilter.concat(dbFilterFactory.getNumberFilter('product_id', parseInt(newValue.id)));
          recordFactory('product_supplier').filter({}, $scope.supplierItemFilter).$promise.then(function (data) {
            if (data && data.list && data.list.length > 0) {
              recordFactory('product_supplier').byId({id: data.list[0].id}).$promise.then(function (datares) {
                $scope.record.lookup.supplier_item_id.obj = datares;
              });
            }
          });
        }
      }
    });

    $scope.$watch('record.lookup.supplier_item_id.obj', function (newValue, oldValue) {
      if (newValue) {
        recordFactory('product').byId({id: newValue.product_id}).$promise.then(function (data) {
          $scope.record.lookup.item_id.obj = data;
        });
      }
    });

    function loadDocument(model) {
      $scope.readOnly = model.status !== 'TO_DISPATCH';
      angular.extend($scope.record.model, model);
      eggsFormFactory.convertDates($scope.record.model, $scope.record.dates);
      eggsFormFactory.loadLookupData($scope.record.lookup, $scope.record.model);
    }

    function getGoodsInwardDocument(id) {
      recordFactory('goods_inward').byId({id: id}).$promise.then(function (response) {
        loadDocument(response);
      });
    }

    $scope.goToList = function () {
      $location.path('/lm/goodsinward/list').search('tab', 0);
    };

    function initGridColumns() {
      $scope.viewGridOptions.columnDefs = [];
      var dateFormat = localeFactory.getDateFormat();
      $scope.viewGridOptions.columnDefs.push({
        name: '#',
        width: '*',
        field: "row_index",
        // translation: 'row_index',
        enableFiltering: false
      });
      // $scope.viewGridOptions.columnDefs.push({
      //   width: '**',
      //   field: "expiration_date",
      //   translation: 'expiration_date',
      //   cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.expiration_date | date:\'' + dateFormat + '\' }}</div>',
      //   enableFiltering: false
      // });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Articolo',
        width: '*****',
        field: 'product_description',
        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.product_code }} - {{ row.entity.product_description }}</div>',
        translation: 'product_desc',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Taglia',
        width: '***',
        field: "size_description",
        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.size_code }} - {{ row.entity.size_description }}</div>',
        translation: 'size_desc',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Colore',
        width: '***',
        field: "color_description",
        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.color_code }} - {{ row.entity.color_description }}</div>',
        translation: 'color_desc',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Quantità',
        width: '*',
        field: "stock_amount",
        translation: 'stock_amount',
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center"><input type="number" ng-model="MODEL_COL_FIELD" step="1" ng-disabled="grid.appScope.readOnly"></div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: '##',
        width: '*',
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
          '<div class=row" style="text-align: center">' +
          '<button ng-click="grid.appScope.modifyQuantity(row.entity)" class="btn btn-xs btn-primary" ng-disabled="grid.appScope.readOnly">' +
          '<span class="fa fa-send"></span>' +
          '</button>' +
          '</div>'
      });

      // $scope.viewGridOptions.columnDefs.push({
      //   width: '*****',
      //   field: "lot_description",
      //   cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.lot_code }} - {{ row.entity.lot_description }}</div>',
      //   translation: 'lot_desc',
      //   enableFiltering: false
      // });
      // $scope.viewGridOptions.columnDefs.push({
      //   width: '*',
      //   displayName: '',
      //   field: 'id',
      //   cellTemplate: '<button ng-click="grid.appScope.resetQuantity(row.entity.id)" class="btn btn-xl btn-danger equal-margin-left-right"><span class="fa fa-trash"></span></button>',
      //   enableFiltering: false
      // });
    }

    function translateGridColumns() {
      $scope.viewGridOptions.columnDefs.forEach(function (col) {
        if (col.translation) {
          if (page_msg[col.translation]) {
            col.name = page_msg[col.translation];
          } else {
            col.name = msg[col.translation];
          }
        }
      });
    }

    $scope.getData = function () {
      var payload = {
        page: $scope.params.pageNumber,
        page_size: $scope.params.pageSize,
        code: $scope.params.code,
        description: $scope.params.description,
        show_revision: false,
        sort_fields: ($scope.params.sortFields ? $scope.params.sortFields : 'row_index'),
        sort_order: ($scope.params.sortOrder ? $scope.params.sortOrder : 'asc')
      };
      var filters = [
        {
          "column": "product p",
          "value": "t.item_id = p.id",
          "relation": "JOIN",
          "kind": "p.code as product_code, p.description as product_description"
        }, {
          //   "column": "lot l",
          //   "value": "t.lot_id = l.id",
          //   "relation": "JOIN",
          //   "kind": "l.code as lot_code, l.description as lot_description",
          // }
          "column": "color co",
          "value": "t.color_id = co.id",
          "relation": "JOIN",
          "kind": "co.code as color_code, co.description as color_description"
        }, {
          "column": "tab_size s",
          "value": "t.size_id = s.id",
          "relation": "JOIN",
          "kind": "s.code as size_code, s.description as size_description"
        }
      ];
      if ($scope.params.filters && $scope.params.filters.length > 0) {
        filters = filters.concat($scope.params.filters);
        recordFactory('goods_inward_row').filter(payload, filters).$promise.then(function (data) {
          $scope.viewGridOptions.totalItems = data.totalResults;
          $scope.result.totalResults = data.totalResults;
          $scope.result.list = data.list;
        });
      }
    };

    function prepareGoodsInwardToSave(lastIndex) {
      var d = new Date();
      var y = d.getFullYear();
      var element = {
        "azcod": authData.info.azCod,
        "divcod": authData.info.divCod,
        "created_date": d,
        "created_user_id": authData.info.userId,
        "supplier_id": $scope.record.lookup.supplier_id.obj.id,
        "wharehouse_id": $scope.record.lookup.wharehouse_id.obj.id,
        "inventory_reason_id": $scope.record.lookup.inventory_reason_id.obj.id,
        "type_id": $scope.record.lookup.type_id.obj.id,
        "int_date": d,
        "int_number": lastIndex,
        "int_year": y,
        "status": $scope.record.model.status,
        "dn_number": $scope.record.model.dn_number,
        "dn_date": $scope.record.model.dn_date ? new Date(Date.parse($scope.record.model.dn_date)) : null,
        "reference": $scope.record.model.reference,
        "rec_date": $scope.record.model.rec_date ? new Date(Date.parse($scope.record.model.rec_date)) : null,
        "bem": $scope.record.model.bem
      }
      return element;
    }

    function prepareGoodsInwardRowToSave(rowIndex) {
      var element = {
        "goods_inward_id": $scope.record.model.id,
        "row_index": rowIndex,
        "item_id": $scope.record.lookup.item_id.obj.id,
        "type": 'AMOUNT',
        "color_id": $scope.record.lookup.color_id.obj ? $scope.record.lookup.color_id.obj.id : null,
        "size_id": $scope.record.lookup.size_id.obj ? $scope.record.lookup.size_id.obj.id : null,
        // "lot_id": $scope.record.lookup.lot_id.obj ? $scope.record.lookup.lot_id.obj.id : null,
        // "expiration_date": $scope.record.model.expiration_date ? new Date(Date.parse($scope.record.model.expiration_date)) : null,
        "stock_amount": $scope.record.model.stock_amount,
        "billing_amount": $scope.record.model.stock_amount
      }
      return element;
    }

    function prepareGoodsInwardToUpdate() {
      var element = {
        "last_modified_date": new Date(),
        "last_modified_user_id": authData.info.userId,
        "status": $scope.record.model.status,
        "dn_number": $scope.record.model.dn_number,
        "dn_date": $scope.record.model.dn_date ? new Date(Date.parse($scope.record.model.dn_date)) : null,
        "reference": $scope.record.model.reference,
        "rec_date": $scope.record.model.rec_date ? new Date(Date.parse($scope.record.model.rec_date)) : null,
        "bem": $scope.record.model.bem
      }
      return element;
    }

    $scope.modifyQuantity = function(e) {
      if (e.stock_amount >= 0 ) {
        e.stock_amount = e.stock_amount === 0 ? null : e.stock_amount;
        var body = {
          // "last_modified_date": new Date(),
          // "last_modified_user_id": authData.info.userId,
          "stock_amount": e.stock_amount,
          "billing_amount": e.stock_amount
        };
        recordFactory('goods_inward_row').update({id: e.id}, body).$promise.then(function (resUpdate) {
          if (resUpdate && resUpdate.updated == 1) {
            var element = {
              "quantity_on_hand_diff": e.stock_amount,
              "last_modified_date": new Date(),
              "last_modified_user_id": authData.info.userId
            };
            inventoryItemSrv.updateQuantity(e.id, element).then(function (resUpdateInv) {
              if (resUpdateInv && resUpdateInv.updated == 1) {
                toaster.pop('success', msg.operation_completed_success);
                $scope.getData();
              } else {
                toaster.pop('error', msg.error, msg.error);
              }
            });
          } else {
            toaster.pop('error', msg.error, msg.error);
          }
        });
      }
    }


    function preSave() {
      if (!$scope.record.lookup.wharehouse_id.obj || !$scope.record.lookup.inventory_reason_id.obj || !$scope.record.lookup.type_id.obj || !$scope.record.lookup.supplier_id.obj) {
        toaster.pop('error', msg.error, msg.MISSING_DATA_HEADER);
        return false;
      } else return true;
    }

    function updateHead(status) {
      var e = prepareGoodsInwardToUpdate();
      if (typeof status !== 'undefined') {
        e.status = status;
      }
      recordFactory('goods_inward').update({id: $scope.record.model.id}, e).$promise.then(function (resUpdate) {
        if (resUpdate && resUpdate.updated == 1) {
          toaster.pop('success', msg.operation_completed_success);
        } else {
          toaster.pop('error', msg.error, msg.error);
        }
      })
    }

    $scope.confirm = function () {
      if (!preSave())
        return;
      if ($scope.record.model.id) {
        updateHead('DISPATCHED');
        $scope.goToList();
      }
    }

    $scope.save = function () {
      if (!preSave())
        return;
      if ($scope.record.model.id) {
        updateHead();
      } else {
        // inserimento nuovo goods_inward
        var queryParams = {
          page: 1,
          pageSize: 1,
          sort_fields: 'int_number',
          sort_order: 'desc'
        };
        // recupero l'ultimo numero
        recordFactory('goods_inward').filter(queryParams, []).$promise.then(function (data) {
          var lastIndex = 0;
          if (data && data.list && data.list.length > 0) {
            lastIndex = data.list[0].int_number;
          }
          lastIndex++;
          recordFactory('goods_inward').create(prepareGoodsInwardToSave(lastIndex)).$promise.then(function (res) {
            if (res.id) {
              queryParams.sort_fields = 'created_date';
              // recupero l'id dell'elemento appena salvato
              recordFactory('goods_inward').filter(queryParams, dbFilterFactory.getNumberFilter('int_number', lastIndex)).$promise.then(function (resId) {
                var path = '/lm/goodsinward/list/';
                if (resId && resId.list) {
                  path = "/lm/goodsinward/detail/" + resId.list[0].id;
                  $location.path(path).search('tab', 1);
                }
                $location.path(path);
              });
            } else {
              toaster.pop('error', msg.error, msg.error);
            }
          });
        });
      }
    };

    $scope.saveRow = function () {
      if (!$scope.record.lookup.item_id.obj) {
        toaster.pop('error', msg.error, page_msg.MISSING_ITEM);
        return;
      }
      var rowIndex = 0;
      if ($scope.result.list) {
        $scope.result.list.forEach(function (item) {
          if (item.row_index > rowIndex) {
            rowIndex = item.row_index;
          }
        });
      }
      ++rowIndex;
      var gir = prepareGoodsInwardRowToSave(rowIndex);
      var gi = prepareGoodsInwardToSave(null);
      inventoryItemSrv.newFromGoodsInwardRow(gi, gir).then(function (ids) {
        if (ids && ids.inventoryItem != null && ids.inventoryItemDetail) {
          recordFactory('goods_inward_row').create(gir).$promise.then(function (res) {
            if (res.id) {
              // goods_inward_inserita, recupero l'id
              var queryParams = { page: 1, pageSize: 1, sort_fields: 'id', sort_order: 'desc' };
              var filter = [];
              filter = filter.concat(dbFilterFactory.getNumberFilter('goods_inward_id', gir.goods_inward_id));
              filter = filter.concat(dbFilterFactory.getNumberFilter('row_index', gir.row_index));
              recordFactory('goods_inward_row').filter(queryParams, filter).$promise.then(function (resId) {
                if (resId && resId.list) {
                  var mov = {
                    'goods_inward_row_id': resId.list[0].id,
                    'inventory_item_id': ids.inventoryItemDetail
                  };
                  recordFactory('goods_inward_mov').create(mov).$promise.then(function () {
                    //toaster.pop('success', msg.operation_completed_success);
                    $scope.getData();
                  });
                } else {
                  toaster.pop('error', msg.error, msg.error);
                }
              });
            } else {
              toaster.pop('error', msg.error, msg.error);
            }
          });
        } else {
          toaster.pop('error', msg.error, msg.error);
        }
      });
    }

    function initializeGoodsInward() {
      $scope.record.model.int_date = new Date();
      $scope.record.model.rec_date = new Date();
      $scope.record.model.status = 'TO_DISPATCH' // default
      $scope.newRecord = true;
    }

    $rootScope.$on('$translateRefreshEnd', function () {
      $q.all({
        general: localeFactory.translateMsg(msg),
        specific: localeFactory.translateMsg(page_msg, pageBundle)
      })
        .then(function () {
          $scope.functionTitle = page_msg.goods_inward;
          $scope.enum.status.forEach(function (en) {
            en.name = page_msg[en.value];
          });
          translateGridColumns();
          // export pdf
          $scope.viewGridOptions.exporterPdfHeader.text = page_msg.goods_inward;
        })
        .catch(function (error) {
          $log.error(error);
        });
    });

    $scope.isNewAllowed = false;
    $scope.isUpdateAllowed = false;
    function checkPermissions() {
      var profilingKey = 'LM_GOODS_INWARD_FUNCTION';
      var permission = authFactory.getPermissions(profilingKey);
      if(!permission.EXEC) {
        $location.path('forbidden').search({key: profilingKey});
      } else {
        $scope.isNewAllowed = permission.NEW;
        $scope.isUpdateAllowed = permission.UPDATE;
      }
    }

    function init() {
      checkPermissions();
      localeFactory.loadTranslation(pageBundle);
      initGridColumns();
      if ($routeParams && (typeof $routeParams.id !== 'undefined')) {
        getGoodsInwardDocument($routeParams.id);
        $scope.params.filters = $scope.params.filters.concat(dbFilterFactory.getNumberFilter('t.goods_inward_id', $routeParams.id));
        if (typeof $routeParams.tab !== 'undefined') {
          $scope.tabs.activeTab = parseInt($routeParams.tab);
        }
        $scope.newRecord = false;
      } else {
        initializeGoodsInward();
      }
      initLookups();
    }

    //___ main ___
    init();

  });

'use strict';

angular.module('ictportal.lm')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/lm/goodsinward/list', {
        templateUrl: 'lm/goodsInward/list/goods-inward-list.html',
        controller: 'lmGoodsInwardListCtrl'
      });
  })
  .controller('lmGoodsInwardListCtrl', function ($scope, recordFactory, $routeParams, $location, authFactory, $rootScope,
                                                 parseSchemaService, dbFilterFactory, localeFactory, $q, toaster, eggsFormFactory,
                                                 $log, inventoryItemSrv, matrixParFactory, dialogService) {
    $scope.result = {};
    $scope.cancelInventoryReason = null;
    $scope.record = {
      lookup: {},
      dates: ['dn_date', 'int_date']
    };
    $scope.params = {
      pageNumber: 1,
      pageSize: 15,
      code: 'component',
      filters: []
    };
    $scope.viewGridOptions = {appScopeProvider: $scope};
    $scope.advFilter = {
      filter: {},
      list: []
    };
    $scope.enum = {
      status: [
        {
          name: 'Evaso',
          value: 'DISPATCHED'
        }, {
          name: 'Da evadere',
          value: 'TO_DISPATCH'
        }, {
          name: 'Chiuso',
          value: 'CLOSED'
        }, {
          name: 'Annullato',
          value: 'CANCELED'
        }
      ]
    };

    var msg = {
      "date": "Date",
      "number": "Number",
      "supplier": "Supplier",
      "warehouse": "Warehouse"
    };

    var goods_inward_msg = {
      "supplier_code": "Supplier code",
      "supplier_ddt_number": "Supplier DDT number",
      "supplier_ddt_date": "Supplier DDT date",
      "error_retrieving_destination": "Error retrieving customer destination",
      "destination_not_found": "Customer destination not found",
      "facility_not_set_destination": "Warehouse not set on customer destination",
      "goods_inward_wardrobe": "Wardrobe goods inward",
      "goods_inward": "Goods inward",
      "reference": "Reference",
      "DISPATCHED": "Dispatched",
      "TO_DISPATCH": "To Dispatch",
      "CLOSED": "Closed",
      "CANCELED": "Canceled",
      "inward_date": "Record date",
      "operation_completed_success" : "Operation completed successfully",
      "status" : "status"
    };

    $scope.$watchGroup([
      'advFilter.filter.facility_id',
      'advFilter.filter.supplier_id',
      'advFilter.filter.type_id',
      'advFilter.filter.dn_number',
      'advFilter.filter.rec_date_from',
      'advFilter.filter.rec_date_to',
      'advFilter.filter.dn_date'
    ], function () {
      $scope.applyFilter();
    });

    $scope.applyFilter = function () {
      $scope.advFilter.list.length = 0;
      if ($scope.advFilter.filter.facility_id) {
        $scope.advFilter.list = $scope.advFilter.list.concat(dbFilterFactory.getNumberFilter('t.wharehouse_id', $scope.advFilter.filter.facility_id));
      }
      if ($scope.advFilter.filter.supplier_id) {
        $scope.advFilter.list = $scope.advFilter.list.concat(dbFilterFactory.getNumberFilter('t.supplier_id', $scope.advFilter.filter.supplier_id));
      }
      if ($scope.advFilter.filter.type_id) {
        $scope.advFilter.list = $scope.advFilter.list.concat(dbFilterFactory.getNumberFilter('t.type_id', $scope.advFilter.filter.type_id));
      }
      if ($scope.advFilter.filter.dn_number) {
        $scope.advFilter.list = $scope.advFilter.list.concat(dbFilterFactory.getNumberFilter('t.dn_number', $scope.advFilter.filter.dn_number));
      }
      if ($scope.advFilter.filter.rec_date_from) {
        $scope.advFilter.list = $scope.advFilter.list.concat(dbFilterFactory.getDateFilter('t.rec_date', $scope.advFilter.filter.rec_date_from, '>='));
      }
      if ($scope.advFilter.filter.rec_date_to) {
        $scope.advFilter.list = $scope.advFilter.list.concat(dbFilterFactory.getDateFilter('t.rec_date', $scope.advFilter.filter.rec_date_to, '<='));
      }
      if ($scope.advFilter.filter.dn_date) {
        $scope.advFilter.list = $scope.advFilter.list.concat(dbFilterFactory.getDateFilter('t.dn_date', $scope.advFilter.filter.dn_date, '='));
      }
      $scope.getData();
    };

    var initGridColumns = function () {
      $scope.viewGridOptions.columnDefs = [];
      var dateFormat = localeFactory.getDateFormat();
      if($scope.isDetailAllowed) {
        $scope.viewGridOptions.columnDefs.push(parseSchemaService.getEditCol());
      }
      $scope.viewGridOptions.columnDefs.push({
        name: '#',
        width: '*',
        field: "int_number",
        //translation: 'number',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Data Riceviemnto',
        width: '*',
        field: "rec_date",
        translation: 'inward_date',
        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.rec_date | date:\'' + dateFormat + '\' }}</div>',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Magazzino',
        width: '***',
        field: "facility_description",
        translation: 'warehouse',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Fornitore',
        width: '**',
        field: "supplier_description",
        translation: 'supplier',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Data DDT',
        width: '*',
        field: "dn_date",
        translation: 'supplier_ddt_date',
        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.dn_date | date:\'' + dateFormat + '\' }}</div>',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Numero DDT',
        width: '*',
        field: "dn_number",
        translation: 'supplier_ddt_number',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'BEM',
        width: '**',
        field: "bem",
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Stato',
        width: '**',
        field: "status",
        translation: 'status',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 40,
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents" style="text-align: center">' +
          '<button ng-click="grid.appScope.cancelRow(row.entity)" class="btn btn-xs btn-danger" ng-disabled="grid.appScope.isRowCanceled(row.entity)">' +
          '<span class="fa fa-window-close"></span>' +
          '</button>' +
          '</div>'
      })
    };

    function translateGridColumns() {
      $scope.viewGridOptions.columnDefs.forEach(function (col) {
        if (col.translation) {
          if (goods_inward_msg[col.translation]) {
            col.name = goods_inward_msg[col.translation];
          } else {
            col.name = msg[col.translation];
          }
        }
      });
    }

    $scope.getData = function () {
      var payload = {
        page: $scope.params.pageNumber,
        page_size: $scope.params.pageSize,
        code: $scope.params.code,
        description: $scope.params.description,
        show_revision: false,
        sort_fields: ($scope.params.sortFields ? $scope.params.sortFields : 'int_number'),
        sort_order: ($scope.params.sortOrder ? $scope.params.sortOrder : 'desc')
      };
      var filters = [
        {
          "column": "supplier s",
          "value": "t.supplier_id = s.id",
          "relation": "JOIN",
          "kind": "s.description AS supplier_description",
          "finer": "INNER"
        },
        {
          "column": "facility w",
          "value": "t.wharehouse_id = w.id",
          "relation": "JOIN",
          "kind": "w.id as facility_id, w.code as facility_code, w.description as facility_description",
          "finer": "INNER"
        }
      ];
      filters = filters.concat($scope.advFilter.list);
      recordFactory('goods_inward').filter(payload, filters).$promise.then(function (data) {
        //FINCHE QUALCUNO NON SCOPRIRA COME FARLO AUTOMATICAMENTE
        data.list.forEach(function (e) {
          $scope.enum.status.map(function (s) {
            if (e.status == s.value) {
              e.status = s.name;
            }
          })
        });
        $scope.viewGridOptions.totalItems = data.totalResults;
        $scope.result.totalResults = data.totalResults;
        $scope.result.list = data.list;
      });
    };

    $scope.viewDetail = function (value) {
      $location.path('/lm/goodsinward/detail/' + value.id);
    };

    $scope.isRowCanceled = function(row){
      return row.status === "CANCELED";
    }

    $scope.cancelRow = function (value) {
      dialogService.confirmDialog('Annullare il ricevimento?',
        function () {
          recordFactory('goods_inward').update({id: value.id}, {"status": "CANCELED"}).$promise.then(function (gi) {
            if (gi && gi.updated == 1) {
              var giFilter = dbFilterFactory.getNumberFilter('t.goods_inward_id', gi.id)
              recordFactory('goods_inward_row').filter({page_size: 100}, giFilter).$promise.then(function (girList) {
                if(girList && girList.list.length > 0){
                  var promises = []
                  girList.list.map(function (gir){
                    promises.push(inventoryItemSrv.newFromGoodsInwardRowCanceled(value, gir, $scope.cancelInventoryReason))
                  })
                  $q.all(promises).then(function(responses) {
                    toaster.pop('success', goods_inward_msg.operation_completed_success);
                    $scope.getData();
                  });
                }
              })
            } else {
              toaster.pop('error', msg.error, msg.error);
            }
          });
        });

    };

    $scope.goToNew = function () {
      $location.path('/lm/goodsinward/detail');
    };

    $rootScope.$on('$translateRefreshEnd', function () {
      $q.all({
        general: localeFactory.translateMsg(msg),
        specific: localeFactory.translateMsg(goods_inward_msg, 'goods_inward')
      })
        .then(function (data) {
          $scope.functionTitle = goods_inward_msg.goods_inward;
          $scope.enum.status.forEach(function (en) {
            en.name = goods_inward_msg[en.value];
          });
          translateGridColumns();
        })
        .catch(function (error) {
          $log.error(error);
        });
    });

    function initLookups() {
      $scope.lookup = {};
      eggsFormFactory.addLookup($scope.lookup, 'supplier_id', 'supplier', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'facility_id', 'facility', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'type_id', 'goods_inward_type', 'code', 'description');
    }

    $scope.isNewAllowed = false;
    $scope.isDetailAllowed = false;
    function checkPermissions() {
      var profilingKey = 'LM_GOODS_INWARD_FUNCTION';
      var permission = authFactory.getPermissions(profilingKey);
      if(!permission.EXEC) {
        $location.path('forbidden').search({key: profilingKey});
      } else {
        $scope.isNewAllowed = permission.NEW;
        $scope.isDetailAllowed = permission.DETAIL;
      }
    }

    function init() {
      checkPermissions();
      localeFactory.loadTranslation('goods_inward');
      initLookups();
      initGridColumns();
      matrixParFactory.getValueOrDefault({key: 'cancelGoodsInWardReasonCode', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}, {defaultValue: "03"}).$promise
        .then(function(data){

        if(data && data.result && data.result.value) {
          var reasonCode = data.result.value;
          var reasonCodeFilter = [];
          reasonCodeFilter = dbFilterFactory.getStringFilter('code', reasonCode);
          recordFactory('inventory_reason').filter({}, reasonCodeFilter).$promise.then(function (ir) {
            if(ir && ir.list.length > 0){
              $scope.cancelInventoryReason = ir.list[0].id;
            }
          })
        }
        else {
          toaster.pop('error', $scope.localeMessages.error_title, 'inventory_reason_missing');
        }
      });
    }

    //___ main ___
    init();

  });

'use strict';

/**
 * Created by Rita Beltrami on 04/02/19
 * @ngdoc component
 * @name ictportal.ferri:highVisibilityComponentHistoryModal
 * @description Modal window for viewing short component history
 * # highVisibilityComponentHistoryModal
 */
angular.module('ictportal.theme').component('highVisibilityComponentHistoryModal',{
      restrict: 'E',
      controller: 'highVisibilityComponentHistoryModalCtrl',
      bindings: {
        sxMsg: '='
      }
  });

'use strict';

angular.module('ictportal.theme').controller('highVisibilityComponentHistoryModalCtrl', function ($scope, $rootScope, $uibModal, eggsFormFactory, dbFilterFactory,
                                                                                              recordFactory, localeFactory) {
  var $ctrl = this;
  $ctrl.modalInstance;
  $ctrl.list = {};

  $rootScope.$on('highVisibilityComponentHistoryModalCtrl_open', function (evt, component) {
    getData(component.component_id);
    $ctrl.component = component;
    $ctrl.modalInstance = showModalConfirm();
  });

  function showModalConfirm() {
    var modalInstance = $uibModal.open({
      animation: true,
      scope: $scope,
      templateUrl: 'lm/highVisibilityComponent/high-visibility-component-history-modal/high-visibility-component-history-modal.html'
    });
    return modalInstance;
  };

  function confirm(equipmentObj) {
    $ctrl.modalInstance.dismiss();
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  }

  function getData(componentId) {
    var payload = {
      page: 1,
      page_size: -1,
      code: 'status',
      description: 'status',
      show_revision: false,
      sort_order: "none"
    };
    recordFactory('component_status').filter(payload, dbFilterFactory.getNumberFilter("component_id", componentId))
      .$promise.then(function (data) {
        var dateFormat = localeFactory.getDateTimeFormat();
        data.list = data.list.sort(function(a,b){
          var c = new Date(a.operation_date);
          var d = new Date(b.operation_date);
          return d-c;
        });
        data.list.forEach(function(item)  {
          item.status_str = $ctrl.sxMsg[item.status];
          item.operation_date_str = moment(item.operation_date).format(dateFormat.toUpperCase());
        });
        $ctrl.list.list = data.list;
      });
  };

  $ctrl.$onInit = function () {
  };

});
'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:PatientComponentMatchCtrl
 * @description Funzione di associazione capo-ospite
 * # PatientComponentMatchCtrl
 * Controller of the ictportal.lm
 *
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/patient/component/match', {
                templateUrl: 'lm/patient/patientComponentMatch/patientComponentMatch.html',
                controller: 'PatientComponentMatchCtrl'
            })
    })
    .controller('PatientComponentMatchCtrl', function ($scope, $rootScope, $filter, authFactory, toaster, patientFactory, componentFactory,  matrixParFactory,
                    COMPONENT_READ_MODE, SCAN_KIND, dbFilterFactory, recordFactory, eggsFormFactory, $q, $log, localeFactory) {

        var msg = {
            success: "Success",
            error: "Error",
            warning: "Warning",
            cannot_match: "Cannot match",
            server_comunication_error: "Server communication error"
        };
        var componentMatchMsg = {
            patient_registered: "Patient registered",
            patient_saved: "Patient saved",
            patient_not_saved: "Unable to save patient",
            component_invalid_status: "The component has an invalid status",
            component_product_mismatch: "The component does not correspond to the selected product",
            component_saved: "Component saved",
            component_not_saved: "Unable to save component",
            component_coupled: "Component coupled with patient",
            component_decoupled: "Component decoupled with patient",
            component_not_found: "No component associated to barcode {{barcode}}",
            component_already_coupled: "Garment already coupled with another patient",
            missing_name: "Missing patient name",
            missing_surname: "Missing patient surname",
            missing_sex: "Missing patient sex",
            missing_destination: "Missing patient ward",
            missing_azcod: "Missing AZCOD",
            missing_divcod: "Missing DIVCOD"
        };

        $scope.STEP = {
            NEW_PATIENT: {
                index: 1,
                message: 'Seleziona o registra un nuovo ospite',
                progress: 33
            },
            PICK_PRODUCT: {
                index: 2,
                message: 'Seleziona l\'articolo da associare all ospite',
                progress: 67
            },
            COUPLE_COMPONENT: {
                index: 3,
                message: 'Leggi barcode componente',
                progress: 100
            }
        };
        $scope.enum = {
            sex: [
              {
                name: 'Femmina',
                value: 'F'
              },
              {
                name: 'Maschio',
                value: 'M'
              }
            ],
            wear: [
              {
                name: 'Nuovo',
                value: 'NEW'
              },
              {
                name: 'Leggermente usurato',
                value: 'LIGHT'
              },
              {
                name: 'Usurato',
                value: 'WORN'
              },
              {
                name: 'Molto usurato',
                value: 'HEAVY'
              },
              {
                name: 'Inutilizzabile',
                value: 'UNUSABLE'
              }
            ],
            color: [],
            size: []
        };
        $scope.element = {};
        $scope.read = {};
        $scope.patientId = undefined;
        $scope.patientMatriculation = undefined;
        $scope.wear = {};
        $scope.color = {};
        $scope.size = {};
        $scope.componentNote = null;

        $scope.modeAuto = true;
        $scope.compList = [];
        $scope.readList = [];
        $scope.matchList = [];
        $scope.settings = {};
        $scope.enablePreviousStep = false;
        $scope.enableNextStep = false;
        $scope.userId = undefined;
        $scope.params = {
            pageNumber: 1,
            pageSize: 100,
            filters: []
        };
        $scope.advFilter = {
            filter: {},
            list: []
        };
        $scope.productFilter = [];
        $scope.compReaderMode = COMPONENT_READ_MODE.CODE;
        $scope.progress = {
            percent: 0,
            message: 'Caricamento...'
        };
        $scope.modal = {
            title: 'Conferma disassociazione',
            message: 'Sei sicuro di voler disassociare il capo?'
        };
        $scope.packagingError = undefined;
        $scope.patientError = undefined;
        $scope.patFilter = [];
        $scope.repFilter = [];
        $scope.pdcFilter = [];
        $scope.matchEnabled = false;
        var allowedComponentStatuses = [];
        var componentId = undefined;
        var componentBarcode = undefined;

        function updateNavigationButtons(){
            $scope.enablePreviousStep = false;
            $scope.enableNextStep = false;
            switch($scope.step){
                case $scope.STEP.NEW_PATIENT:
                    $scope.enablePreviousStep = false;
                    $scope.enableNextStep = false;
                    break;
                case $scope.STEP.PICK_PRODUCT:
                    $scope.enablePreviousStep = true;
                    break;
            }
        };

        $scope.$watchGroup(['element.destination_id'
        ], function () {
                $scope.applyFilter();
            }
        );

        $scope.$watch('lookup.product_id.obj', function() {
            if ($scope.step == $scope.STEP.COUPLE_COMPONENT && !$scope.lookup.product_id.obj) {
                $scope.previousStep();
            } else if ($scope.step != $scope.STEP.NEW_PATIENT && $scope.lookup.product_id.obj) {
                $scope.enum.color.length = 0;
                $scope.enum.size.length = 0;
                if ($scope.lookup.product_id.obj.color_type_id) {
                    var f = dbFilterFactory.getNumberFilter('color_type_id', $scope.lookup.product_id.obj.color_type_id);
                    recordFactory('color').filter({page_size: 1000}, f)
                    .$promise.then(function (data) {
                        if (data.list) {
                            data.list.forEach(function(e) {
                                $scope.enum.color.push({
                                    name: e.description,
                                    value: e.id
                                });
                            });
                        }
                    });
                }
                if ($scope.lookup.product_id.obj.size_type_id) {
                    var f = dbFilterFactory.getNumberFilter('size_type_id', $scope.lookup.product_id.obj.size_type_id);
                    recordFactory('tab_size').filter({page_size: 1000}, f)
                    .$promise.then(function (data) {
                        if (data.list) {
                            data.list.forEach(function(e) {
                                $scope.enum.size.push({
                                    name: e.description,
                                    value: e.id
                                });
                            });
                        }
                    });
                }

                doNextStep();
            }
        });

        $scope.$watch('lookup.patient_id.obj', function() {
            if ($scope.lookup.patient_id.obj) {
                $scope.element = $scope.lookup.patient_id.obj;
                var f = dbFilterFactory.getNumberFilter('id', $scope.element.destination_id);
                recordFactory('customer_destination').filter({page_size: 1000, code: 'code', description: 'description'}, f)
                .$promise.then(function (data) {
                    if (data.list) {
                        $scope.lookup.destination_id.obj = data.list[0];
                        $scope.patientId = $scope.element.id;
                        $scope.patientMatriculation = $scope.element.matriculation;
                    }

                    $scope.getPatientComponents();

                    doNextStep();
                });
            }
        });

        $scope.getPatientComponents = function(){
            var payload = {
              page_size: 10000
            };
            var filters = [{
              column: 'product p',
              value: 't.product_id = p.id',
              relation: 'JOIN',
              kind: 'p.code AS prod_code, p.description AS prod_des'
            }];
            filters = filters.concat(dbFilterFactory.getNumberFilter('t.patient_id',$scope.patientId));
            recordFactory('component').filter(payload, filters)
                .$promise.then(function(data) {
                    $log.info(data);
                    if (data.list) {
                        data.list.forEach(function(e) {
                            $scope.matchList.push({'id': e.id,
                                'barcode': e.barcode,
                                'product_code': e.prod_code,
                                'product_description': e.prod_des,
                                'patient_matriculation': $scope.patientMatriculation});
                        });
                    }
                });
          };

        function getTimestamp(day) {
            var m = (day.getMonth()+1);
            var mStr = (m<10)?('0'+m.toString()):m.toString();
            var d = (day.getDate());
            var dStr = (d<10)?('0'+d.toString()):d.toString();
            var timestamp = day.getFullYear() + '-' + mStr + '-' +dStr;
            return timestamp;
          }

        function getValidityQuery(table) {
            var timestamp = getTimestamp(new Date());
            var query = '(' + table + '.start_validity_date <= \'' + timestamp +
            '\' AND (' + table + '.end_validity_date IS NULL OR ' + table + '.end_validity_date>\'' + timestamp + '\') )';

            return query;
        }

        $scope.applyFilter = function () {
            $scope.advFilter.list.length = 0;
            // filtro sugli articoli a contratto del cliente per il reparto selezionato
            var filters = [
                {
                    "column": "agreement_item ai",
                    "value": "t.id = ai.product_id",
                    "relation": "JOIN",
                    "kind": "ai.id AS product_id"
                },
                {
                    "column": "agreement a",
                    "value": "ai.agreement_id = a.id",
                    "relation": "JOIN",
                    "kind": "a.id AS agreement_id"
                },
                {
                    "column": "customer c",
                    "value": "a.customer_id = c.id",
                    "relation": "JOIN",
                    "kind": "c.id AS customer_id"
                },
                {
                    "column": "customer_destination cd",
                    "value": "c.id = cd.customer_id",
                    "relation": "JOIN",
                    "kind": "cd.id AS customer_destination_id"
                }
            ];
            $scope.advFilter.list = filters;
            if ($scope.element.destination_id) {
                // FIXME (dare in pasto ad a-b-normal l'intero filtro non funziona...)
                //var f = dbFilterFactory.getNumberFilter('cd.id', $scope.element.destination_id);

                // !WORKAROUND! (senza filters su a, c e cd)
                //var f = dbFilterFactory.getCustomFilter('ai.agreement_id in (select a.id from agreement a join customer c ON a.customer_id = c.id join customer_destination cd ON c.id = cd.customer_id where cd.id = '+ $scope.element.destination_id +')');

                // filtri intervalli validità
                var valFilter_a = dbFilterFactory.getCustomFilter(getValidityQuery('a'));
                var valFilter_ai = dbFilterFactory.getCustomFilter(getValidityQuery('ai'));

                // !WORKAROUND! (alternativo)
                var f = dbFilterFactory.getNumberFilter('cd.id', $scope.element.destination_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f)
                    .concat(valFilter_a).concat(valFilter_ai);
                var payload = {
                    page_size: 1000,
                };
                recordFactory('product').filter(payload, $scope.advFilter.list)
                .$promise.then(function (data) {
                    var product_ids = data.list.map(
                        function(e) {
                            return e.id;
                        }
                    );
                    // [SIXLM-137] se nei contratti sono presenti gli articoli padre vengono considerati solo i figli
                    matrixParFactory.getValueOrDefault({key: 'endowmentService.isAgreementItemParent', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'},
                        {defaultValue: "false"}).$promise.then(function(data){
                            if (data.result.value == 'true') $scope.productFilter = dbFilterFactory.getInFilter('parent_product_id', product_ids);
                            else $scope.productFilter = dbFilterFactory.getInFilter('id', product_ids);
                    });
                });
            }
        };

        function checkRequiredFields() {
            if (!$scope.element.name) {
                $scope.patientError = componentMatchMsg.missing_name;
                return false;
            }
            if (!$scope.element.surname) {
                $scope.patientError = componentMatchMsg.missing_surname;
                return false;
            }
            if (!$scope.element.sex) {
                $scope.patientError = componentMatchMsg.missing_sex;
                return false;
            }
            if (!$scope.element.destination_id) {
                $scope.patientError = componentMatchMsg.missing_destination;
                return false;
            }

            return true;
        }

        $scope.setPatient = function () {
            if (checkRequiredFields()) {
                toaster.pop('success', msg.success, componentMatchMsg.patient_registered);
                doNextStep();
            } else {
                toaster.pop('error', msg.error, $scope.patientError);
            }
        };

        function doNextStep(){
            if ($scope.step.index < $scope.stepList.length) {
                var i;
                for (i = 0; i < $scope.stepList.length; i++) {
                    if ($scope.stepList[i] === $scope.step) {
                        break;
                    }
                }
                $scope.step = $scope.stepList[i + 1];
                setProgress($scope.step);
                updateNavigationButtons();
            }
        };

        function setProgress(step){
            $scope.progress.message = step.message;
            $scope.progress.percent = step.progress;
        };

        $scope.previousStep = function () {
            $scope.step = $scope.STEP.NEW_PATIENT;
            $scope.bomDet = undefined;
            $scope.bom = undefined;
            $scope.compList.length = 0;
            $scope.readList.length = 0;
            $scope.matchList.length = 0;
            //$scope.element = {};
            $scope.read = {};
            $scope.patientId = undefined;
            $scope.patientMatriculation = undefined;
            $scope.wear.code = undefined;
            $scope.color.id = undefined;
            $scope.size.id = undefined;
            setProgress($scope.step);
            updateNavigationButtons();
        };


        function isNewRead(read){
            var alreadyRead = $filter('filter')($scope.readList, {read: {read: read.read} });
            var result = (alreadyRead.length===0);
            return result;
        };

        $scope.readComponentCode = function(read){
            if($scope.step===$scope.STEP.COUPLE_COMPONENT && isNewRead(read)){
                var filters = [{
                    "column": "product p",
                    "value": "t.product_id = p.id",
                    "relation": "JOIN",
                    "kind": "p.description"
                }];
                switch(read.type){
                    case SCAN_KIND.BARCODE:
                        toaster.pop('info', 'Lettura barcode', read.read);
                        filters = filters.concat(dbFilterFactory.getStringFilter('barcode',read.read));
                        $scope.read.barcode = read.read;
                        break;
                    case SCAN_KIND.RFID:
                        toaster.pop('info', 'Lettura unicode', read.read);
                        filters = filters.concat(dbFilterFactory.getStringFilter('unicode',read.read));
                        $scope.read.unicode = read.read;
                        break;
                    case SCAN_KIND.MANUAL:
                        toaster.pop('info', 'Lettura codice', read.read);
                        filters = filters.concat(dbFilterFactory.getCustomFilter('(unicode=\'' + read.read + '\' OR barcode=\'' + read.read + '\')'));
                        $scope.read.unicode = read.read;
                        break;
                }
                $scope.read.type = read.type;
                recordFactory('component').filter({page_size:10000}, filters)
                    .$promise.then(function(data) {
                        if(data.list && data.list.length>0){
                            var component = data.list[0];
                            // verifico il componente corrisponda all'articolo selezionato
                            if (component.product_id != $scope.lookup.product_id.obj.id) {
                                toaster.pop('error', msg.error, componentMatchMsg.component_product_mismatch);
                            } else {
                            $log.info(component);
                            var item = {read: read};
                            // Verifico lo stato del componente
                            if(!isValidComponentStatus(component)){
                                toaster.pop('error', msg.error, componentMatchMsg.component_invalid_status);
                            }
                            else{
                                // Verifica componente già letto
                                if(item.read.type===SCAN_KIND.BARCODE && item.read.read===component.barcode){
                                    item.component = component;
                                }
                                else if(item.read.type===SCAN_KIND.RFID && item.read.read===component.unicode){
                                    item.component = component;
                                }
                                else if(item.read.type===SCAN_KIND.MANUAL && item.read.read===component.unicode){
                                    item.component = component;
                                    item.read.type = SCAN_KIND.RFID;
                                }
                                else if(item.read.type===SCAN_KIND.MANUAL && item.read.read===component.barcode){
                                    item.component = component;
                                    item.read.type = SCAN_KIND.BARCODE;
                                }

                                componentId = component.id;
                                componentBarcode = component.barcode;
                            }
                        }
                        }
                        else {
                            componentId = undefined;
                            componentBarcode = undefined;
                        }
                        $scope.matchEnabled = true;
                        $scope.coupleComponent();
                    });
            }
        };

        /**
         * Posso accettare solo i componenti che si trovino in un determinato stato.
         * I passaggi di stato ammessi sono definiti mediante matrixpar.
         */
        function isValidComponentStatus(component){
            var result = false;
            if(allowedComponentStatuses.length>0){
                result = (allowedComponentStatuses.indexOf(component.status)!=-1);
            }
            return result;
        };

        function getMatrixParWorkflow(){
            //Get matrix par that rapresent the change status permitted
            matrixParFactory.getMatrixPar({key: 'components.workflow', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}).$promise.then(function(data){
                var matrix = JSON.parse(data.value);
                if(matrix){
                    for(var key in matrix){
                        var array = matrix[key];
                        if(array.indexOf('P')!=-1){
                            allowedComponentStatuses.push(key);
                        }
                    }
                }
            });
        };


        function createPatient(patientDto) {
            var deferred = $q.defer();
            // creo un paziente solo se ne ho registrato uno nuovo (STEP.NEW_PATIENT)
            if (!$scope.patientId) {
                patientFactory.updateOrCreatePatient({},patientDto).$promise
                .then(function(response) {
                    if(response.success) {
                        $scope.patientId = response.patient_id;
                        $scope.patientMatriculation = response.patient_matriculation;
                        toaster.pop('success', msg.success, componentMatchMsg.patient_saved);

                        deferred.resolve();
                    }
                    else {
                        toaster.pop('error', msg.error, response.message);
                    }
                })
                .catch(function(ex){ logError(ex) });
            } else {
                deferred.resolve();
            }

            return deferred.promise;
        }

        function createComponent(componentDto) {
            var deferred = $q.defer();
            // creo un componente solo se non ne ho già letto uno esistente
            if (!componentId) {
                componentFactory.createComponent({},componentDto).$promise
                .then(function(response) {
                    if(response.success) {
                        toaster.pop('success', msg.success, componentMatchMsg.component_saved);
                        componentId = response.component_id;
                        componentBarcode = response.component_barcode;

                        deferred.resolve();
                    }
                    else {
                        toaster.pop('error', msg.error, response.message);
                    }
                })
                .catch(function(ex){ logError(ex) });
            } else {
                deferred.resolve();
            }

            return deferred.promise;
        }

        $scope.coupleComponent = function() {
            var azcod = authFactory.getAuthData().info.azCod;
            var divcod = authFactory.getAuthData().info.divCod;
            // 1) censimento paziente
            var patientDto = {'matriculation': $scope.element.matriculation,
                    'name': $scope.element.name,
                    'surname': $scope.element.surname,
                    'sex': $scope.element.sex,
                    'destinationCode': $scope.lookup.destination_id.obj.code,
                    'deliveryDestinationCode': ($scope.lookup.delivery_destination_id.obj) ? $scope.lookup.delivery_destination_id.obj.code : null,
                    'badge': $scope.element.badge,
                    'barcode': $scope.element.barcode,
                    'customerMatriculation': $scope.element.customer_matriculation,
                    'azcod': azcod,
                    'divcod': divcod};

            createPatient(patientDto).then(function() {
                // 2) censimento componente letto
                var componentDto = {'product_code': $scope.lookup.product_id.obj.code,
                            'barcode': $scope.read.barcode,
                            'unicode': $scope.read.unicode,
                            'wear': $scope.wear.code,
                            'color_id': $scope.color.id,
                            'size_id': $scope.size.id,
                            'note': $scope.componentNote,
                            'azcod': azcod,
                            'divcod': divcod};
                createComponent(componentDto).then(function() {
                    // 3) associazione componente-paziente
                    var matchDto = {'id': $scope.patientId,
                            'componentId': componentId,
                            'azcod': azcod,
                            'divcod': divcod};
                    patientFactory.coupleComponent({},matchDto).$promise
                    .then(function(response) {
                        if(response.success) {
                            toaster.pop('success', msg.success, componentMatchMsg.component_coupled);
                            $scope.matchEnabled = false;

                            // popolo l'elenco delle associazioni
                            $scope.matchList.push({'id': componentId,
                                            'barcode': componentBarcode,
                                            'product_code': $scope.lookup.product_id.obj.code,
                                            'product_description': $scope.lookup.product_id.obj.description,
                                            'patient_matriculation': $scope.patientMatriculation});
                        }
                        else {
                            toaster.pop('error', msg.error, componentMatchMsg[response.message.toLowerCase()]);
                        }
                    }).catch(function(ex){ logError(ex) });
                });
            });
        }

        var logError = function logError(ex) {
            $log.log(ex);
            toaster.pop('error', msg.error, msg.server_comunication_error);
        }

        $scope.decoupleComponent = function(id) {
            if (!$scope.modal) {
                alert('Modal not found');
            }
            else {
                $scope.modal.callback = doDecoupleComponent.bind(null, id);
                $rootScope.$broadcast('sixConfirmModal_open');
            }
        };

        function doDecoupleComponent(id) {
            var azcod = authFactory.getAuthData().info.azCod;
            var divcod = authFactory.getAuthData().info.divCod;
            var patientDto = {'componentId': id,
                    'azcod': azcod,
                    'divcod': divcod};

            patientFactory.decoupleComponent({},patientDto).$promise
            .then(function(response) {
                if(response.success) {
                    toaster.pop('success', msg.success, componentMatchMsg.component_decoupled);

                    // rimuovo il componente dall'elenco delle associazioni
                    $scope.matchList = $scope.matchList.filter(function(e) {
                        return e.id != id;
                    });
                }
                else {
                    toaster.pop('error', msg.error, response.message);
                }
            });
        }


        function getOperator(){
            var username = authFactory.getAuthData().authId;
            var filters = [{
                "column": "human_resource o",
                "value": "o.user_id = t.id",
                "relation": "JOIN",
                "kind": "o.id AS operator_id"
            }];
            filters = filters.concat(dbFilterFactory.getStringFilter("username",username));
            recordFactory('users').filter({page_size:10000}, filters)
                .$promise.then(function(data) {
                    if(data.list && data.list.length>0){
                        $scope.userId = data.list[0].operator_id;
                    }
                });
        };


        function reinit(){
            $scope.element = {};
            $scope.read = {};
            $scope.patientId = undefined;
            $scope.patientMatriculation = undefined;
            $scope.wear = {};
            $scope.componentNote = null;
            $scope.printer = false;
            $scope.enablePreviousStep = false;
            $scope.enableNextStep = false;
            $scope.packagingError = undefined;
            $scope.patientError = undefined;
            $scope.generatedBarcode  = undefined;
            $scope.compList = [];
            $scope.readList = [];
            $scope.matchList = [];
            $scope.bom = undefined;
            $scope.advFilter = {
                filter: {},
                list: []
            };
            $scope.productFilter = [];
            $scope.progress = {
                percent: 0,
                message: 'Caricamento...'
            };
            $scope.step = $scope.STEP.NEW_PATIENT;
            $scope.stepList = [];
            for(var key in $scope.STEP){
                $scope.stepList.push($scope.STEP[key]);
            }
            $scope.patFilter = [];
            $scope.repFilter = [];
            $scope.pdcFilter = [];
            $scope.matchEnabled = false;
        };

        function initLookups() {
            $scope.lookup = { };
            eggsFormFactory.addLookup($scope.lookup, 'patient_id', 'human_resource', 'customer_matriculation', 'name,surname');
            eggsFormFactory.addLookup($scope.lookup, 'destination_id', 'customer_destination', 't.code', 't.description');
            eggsFormFactory.addLookup($scope.lookup, 'delivery_destination_id', 'customer_destination', 't.code', 't.description');
            eggsFormFactory.addLookup($scope.lookup, 'product_id', 'product', 'code', 'description');
            $scope.mappingLoaded = true;
        };

        function getTranslations(){
            localeFactory.loadTranslation('patient')
            .then(function() {
                localeFactory.translateMsg(msg, 'patient');
                localeFactory.translateMsg(componentMatchMsg, 'patient');
            });
        };

        function init() {
            getMatrixParWorkflow();
            getTranslations();
            $scope.step = $scope.STEP.NEW_PATIENT;
            setProgress($scope.step);
            $scope.stepList = [];
            for(var key in $scope.STEP){
                $scope.stepList.push($scope.STEP[key]);
            }
            getOperator();
            $scope.patFilter = $scope.patFilter.concat(dbFilterFactory.getStringFilter('t.discriminator', 'PAT'));
            var typeFilter = [{
                "column": "receiver_type rt",
                "value": "t.receiver_type_id = rt.id",
                "relation": "JOIN",
                "kind": "rt.code AS type_code"
            }];
            $scope.repFilter = typeFilter.concat(dbFilterFactory.getInFilter('rt.code', ['REP', 'GUA']));
            var mxParDelTypeCode = 'PDC';
            // [SIXLM-137] aggiunto filtro sul tipo punto di consegna tramite matrix par
            matrixParFactory.getMatrixPar({key: 'deliveryDestinationTypeCode', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}).$promise.then(function(data){
                if (data.value) {
                    mxParDelTypeCode = data.value;
                }
                $scope.pdcFilter = typeFilter.concat(dbFilterFactory.getStringFilter('rt.code', mxParDelTypeCode));
            });
            initLookups();
        };

        //___ main ___
        init();

    });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:patientDirtAcceptanceCtrl
 * @description
 * # patientDirtAcceptanceCtrl
 * Controller of the ictportal.lm
 *
 * Per filtrare su determinati clienti:
 * http://localhost:9000/#/patient/dirt?customer=AUSLTO2&customer=C93494
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/patient/dirt/:status', {
                templateUrl: 'lm/patient/patientDirtAcceptance/patientDirtAcceptance.html',
                controller: 'patientDirtAcceptanceCtrl'
            })
    })
    .controller('patientDirtAcceptanceCtrl', function ($scope, $routeParams, toaster, patientFactory, $filter, $location,
        COMPONENT_READ_MODE, SCAN_KIND, dbFilterFactory, recordFactory, eggsFormFactory, $log, authFactory,
        $q, matrixParFactory, localeFactory) {

        var msg = {
            error: "Error",
            warning: "Warning",
        };
        var patientDirtAcceptanceMsg = {
            invalid_component_status: "Il componente si trova in uno stato non valido",
            out_of_order_reading: "La lettura effettuata non rispetta l\'ordine previsto dalla distinta base",
            no_patient_match: "Nessun ospite associato al capo",
            customer_mismatch: "Questo articolo non è associato al cliente selezionato",
            component_not_found: "Componente non trovato, verificare l\'anagrafica",
            dirt_accepted: "Sporco accettato correttamente"
        };

        $scope.readList = [];
        $scope.compList = [];
        $scope.userId = undefined;
        $scope.params = {
            pageNumber: 1,
            pageSize: 100,
            filters: []
        };
        $scope.urlCustomer = false;
        $scope.compReaderMode = COMPONENT_READ_MODE.CODE;
        $scope.acceptedStatus = undefined;
        var allowedComponentStatuses = [];

        var baseProductDataFilter = [
            {
                "column": "product p",
                "value": "t.product_id = p.id",
                "relation": "JOIN",
                "kind": "p.code as product_code, p.description as product_description"
            },
            {
                "column": "material m",
                "value": "p.material_id = m.id",
                "relation": "JOIN",
                "kind": "m.code as material_code, m.description as material_description"
            },
            {
                "column": "prod_wash_reason pwr",
                "value": "p.id = pwr.product_id",
                "relation": "JOIN",
                "kind": "pwr.admittedwashingreasons_id"
            },
            {
                "column": "equipment_reason er",
                "value": "pwr.admittedwashingreasons_id = er.id",
                "relation": "JOIN",
                "kind": "er.code as wash_code"
            }
        ];

        var basePatientCustomerFilter = [
            {
                "column": "customer_destination cd",
                "value": "t.destination_id = cd.id",
                "relation": "JOIN",
                "kind": "cd.id AS customer_destination_id"
            },
            {
                "column": "customer c",
                "value": "cd.customer_id = c.id",
                "relation": "JOIN",
                "kind": "c.code AS customer_code"
            }
        ];


        function isNewRead(read){
            var alreadyRead = $filter('filter')($scope.readList, {read: {read: read.read} });
            var result = (alreadyRead.length===0);
            return result;
        };

        $scope.readComponentCode = function(read){
            var productDataFilter = baseProductDataFilter;
            var patientCustomerFilter = basePatientCustomerFilter;
            if(isNewRead(read)){
                switch(read.type){
                    case SCAN_KIND.BARCODE:
                        toaster.pop('info', 'Lettura barcode', read.read);
                        productDataFilter = productDataFilter.concat(dbFilterFactory.getStringFilter('t.barcode',read.read));
                        break;
                    case SCAN_KIND.RFID:
                        toaster.pop('info', 'Lettura unicode', read.read);
                        productDataFilter = productDataFilter.concat(dbFilterFactory.getStringFilter('t.unicode',read.read));
                        break;
                    case SCAN_KIND.MANUAL:
                        toaster.pop('info', 'Lettura codice', read.read);
                        productDataFilter = productDataFilter.concat(dbFilterFactory.getCustomFilter('(t.unicode=\'' + read.read + '\' OR t.barcode=\'' + read.read + '\')'));
                        break;
                }
                recordFactory('component').filter({page_size:10000}, productDataFilter)
                    .$promise.then(function(data) {
                        if(data.list && data.list.length>0){
                            var component = data.list[0];
                            var wash_codes = data.list.map(
                                function(e) {
                                    return e.wash_code;
                                }
                            );
                            component.wash_codes = wash_codes;
                            $log.info(component);
                            var item = {read: read};
                            // Verifico lo stato del componente
                            if(!isValidComponentStatus(component)){
                                toaster.pop('error', msg.error, patientDirtAcceptanceMsg.invalid_component_status);
                            }
                            else{
                                // Verifica componente già letto
                                if(item.read.type===SCAN_KIND.BARCODE && item.read.read===component.barcode){
                                    item.component = component;
                                }
                                else if(item.read.type===SCAN_KIND.RFID && item.read.read===component.unicode){
                                    item.component = component;
                                }
                                else if(item.read.type===SCAN_KIND.MANUAL && item.read.read===component.unicode){
                                    item.component = component;
                                    item.read.type = SCAN_KIND.RFID;
                                }
                                else if(item.read.type===SCAN_KIND.MANUAL && item.read.read===component.barcode){
                                    item.component = component;
                                    item.read.type = SCAN_KIND.BARCODE;
                                }
                                // controllo il cliente dell'ospite associato al componente
                                if (component.patient_id) {
                                    patientCustomerFilter = patientCustomerFilter.concat(dbFilterFactory.getNumberFilter('t.id', component.patient_id));
                                    // caso base: filtro tramite lookup
                                    if ($scope.lookup.customer_id.obj) {
                                        patientCustomerFilter = patientCustomerFilter.concat(
                                            dbFilterFactory.getStringFilter('c.code', $scope.lookup.customer_id.obj.code));
                                    } else {
                                        // nel caso i filtri siano passati come parametri URL
                                        var codes = $location.search().customer;
                                        if(codes){
                                            if(angular.isArray(codes)){
                                                patientCustomerFilter = patientCustomerFilter.concat(dbFilterFactory.getInFilter('c.code', codes));
                                            }
                                            else{
                                                patientCustomerFilter = patientCustomerFilter.concat(dbFilterFactory.getStringFilter('c.code', codes));
                                            }
                                        }
                                    }
                                    recordFactory('human_resource').filter({}, patientCustomerFilter)
                                    .$promise.then(function(data) {
                                        if(data.list && data.list.length>0){
                                            var patientDto = {'componentId': component.id,
                                                    'acceptDirtStatus': $scope.acceptedStatus,
                                                    'azcod': authFactory.getAuthData().info.azCod,
                                                    'divcod': authFactory.getAuthData().info.divCod};
                                            // accettazione sporco paziente
                                            patientFactory.acceptPatientDirt({},patientDto).$promise
                                            .then(function(response) {
                                                if(response.success) {
                                                    toaster.pop('success', msg.success, patientDirtAcceptanceMsg.dirt_accepted);

                                                    $scope.readList.push(item);
                                                    component.customer_code = data.list[0].customer_code;
                                                    $scope.compList.push(component);
                                                }
                                                else {
                                                    toaster.pop('error', msg.error, response.message);
                                                }
                                            });
                                        }
                                        else{
                                            toaster.pop('warning', msg.warning, patientDirtAcceptanceMsg.customer_mismatch);
                                        }
                                    });
                                } else {
                                    toaster.pop('error', msg.error, patientDirtAcceptanceMsg.no_patient_match);
                                }
                            }
                        }
                        else{
                            toaster.pop('error', msg.error, patientDirtAcceptanceMsg.component_not_found);
                        }
                });
            }
        };

        /**
         * Se richiesto dalla bom (seq_check_enabled) i componenti devono essere letti in un ordine ben preciso.
         */
        function isValidComponentOrder(component){
            var isValid = true;
            if($scope.bom.seq_check_enabled==='T'){
                for(var i=0; i<$scope.bomDet.length; i++){
                    var bomDetElement = $scope.bomDet[i];
                    if(component.product_id===bomDetElement.item_id){
                        isValid = true;
                        break;
                    }
                    else if(bomDetElement.amount!==bomDetElement.read){
                        isValid = false;
                        break;
                    }
                }
            }
            return isValid;
        };

        /**
         * Posso accettare solo i componenti che si trovino in un determinato stato.
         * I passaggi di stato ammessi sono definiti mediante matrixpar.
         */
        function isValidComponentStatus(component){
            var result = true;
            if(allowedComponentStatuses.length>0){
                result = (allowedComponentStatuses.indexOf(component.status)!=-1);
            }
            return result;
        };


        function initLookups() {
            $scope.lookup = {};
            eggsFormFactory.addLookup($scope.lookup, 'customer_id', 'customer', 'code', 'description');
            $scope.mappingLoaded = true;
        };


        function getTranslations(){
            localeFactory.loadTranslation('patient')
            .then(function() {
                localeFactory.translateMsg(msg);
                localeFactory.translateMsg(patientDirtAcceptanceMsg, 'patient');
            });
        };

        function getMatrixParWorkflow(){
            //Get matrix par that rapresent the change status permitted
            matrixParFactory.getMatrixPar({key: 'components.workflow', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}).$promise.then(function(data){
                var matrix = JSON.parse(data.value);
                if(matrix && $scope.acceptedStatus){
                    for(var key in matrix){
                        var array = matrix[key];
                        if(array.indexOf($scope.acceptedStatus)!=-1){
                            allowedComponentStatuses.push(key);
                        }
                    }
                }
            });
        }


        function init() {
            // [SIXLM-138] parametrizzazione dello stato dei componenti all'accettazione
            if ($routeParams.status) {
                $scope.acceptedStatus = $routeParams.status;
            } else $scope.acceptedStatus = 'E';  // default a "Rientrato"
            // ATM il workflow viene bypassato
            //getMatrixParWorkflow();
            getTranslations();
            initLookups();

            if ($location.search().customer) {
                $scope.urlCustomer = true;
            }
        };

        //___ main ___
        init();

    });

'use strict';

/**
 * Created by Rita Beltrami on 09/10/18
 * @ngdoc component
 * @name ictportal.ferri:lockedModalCtrl
 * @description Modal window that informs rebase user that selected component is locked.
 * # lockedModalCtrl
 */
angular.module('ictportal.theme').component('lockedModal',{
      restrict: 'E',
      controller: 'lockedModalCtrl',
      bindings: {
        sxOnConfirm: '&',
        sxComponent: '='
      }
  });

'use strict';

angular.module('ictportal.theme').controller('lockedModalCtrl', function ($scope, $rootScope, $uibModal, recordFactory, $q) {
  var $ctrl = this;
  $ctrl.controlReason = {};

  $rootScope.$on('lockedModalCtrl_open', function () {
    getControlReason().then(function () {
      var modalInstance = showModalConfirm();
      modalInstance.result.then(function (confirmed) {
        if (confirmed) {
          modalInstance.dismiss();
          $('body').removeClass('modal-open');
          $('.modal-backdrop').remove();
        }
      });
    });
  });

  function getControlReason() {
    var deferred = $q.defer();
    $ctrl.controlReason = {};
    if ($ctrl.sxComponent && $ctrl.sxComponent.control_reason_id) {
      recordFactory('control_reason').byId({ id: $ctrl.sxComponent.control_reason_id }).$promise
        .then(function (data) {
          $ctrl.controlReason = angular.extend($ctrl.controlReason, data);
          deferred.resolve();
        });
    }
    else {
      deferred.reject();
    }
    return deferred.promise;
  }

  function showModalConfirm() {
    var modalInstance = $uibModal.open({
      animation: true,
      scope: $scope,
      templateUrl: 'lm/rebaser/locked-modal/locked-modal.html'
    });
    return modalInstance;
  };

});
/**
 * Created by Rita Beltrami on 26/06/17.
 */
'use strict';

angular.module('ictportal.lm')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/xversus/component/detail', {
          templateUrl: 'lm/xversus/component/component_detail.html',
          controller: 'ComponentXVersusCtrl'
        })
        .when('/xversus/component/detail/:id', {
          templateUrl: 'lm/xversus/component/component_detail.html',
          controller: 'ComponentXVersusCtrl'
        })
  })
  .controller('ComponentXVersusCtrl', function ($scope, $log, recordFactory, $routeParams,
                                          eggsFormFactory, dbFilterFactory, $rootScope, 
                                          schemaFactory, authFactory) {

    $scope.pageTitle = 'Dettaglio componente';
    $scope.readOnly = true;                
    $scope.customer = {};
    $scope.enum = {
        special_use: [
          {
            name: 'Muletto',
            value: 'COURTESY'
          }
        ]            
    };      
    $scope.statix = {
      path: '',
      model: undefined
    };

    $scope.initStatix = function(path,model){
      $rootScope.$broadcast('statix:clean');
      $scope.statix.path = path;
      $scope.statix.model = model;
    };

    function initLookups() {
      $scope.lookup = { };
      $scope.customerLookup = {};
      for (var key in $scope.sf.schema.properties) {
        var prop = $scope.sf.schema.properties[key];
        if (prop.format === 'lookup') {
          eggsFormFactory.addLookup($scope.lookup, key, prop.entity_id, 'code', 'description');
        }
      }
      // adding custom mappings
      eggsFormFactory.addLookup($scope.customerLookup, 'customer_id', 'customer', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'product_id', 'product', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'employee_id', 'human_resource', 'matriculation', 'surname,name');
      eggsFormFactory.addLookup($scope.lookup, 'lot_id', 'lot', 'code', 'description');
      $scope.mappingLoaded = true;
    };

    function initDates() {
      $scope.dateFields = [];
      $scope.sf.form[0].items[0].tabs.forEach(function (tab) {
        tab.items.forEach(function (item) {
          if (item.type === 'datepicker') {
            $scope.dateFields.push(item.key[0]);
          }
        });
      });
    };

    function getComponentHistory(){
      var payload = {
        page_size: 10000,
        show_revision: false,
        sort_fields: 'operation_date',
        sort_order: 'desc'
      };
      var filters = dbFilterFactory.getNumberFilter('component_id',$scope.element.id);
      filters = filters.concat(dbFilterFactory.getCustomFilter("( status='S' OR status='ACCD' OR status='W' OR status='E' OR status='L' OR status='SW' OR status='C'  )"));
      recordFactory('component_status').filter(payload, filters)
          .$promise.then(function(data) {
            $log.info(data);
            $rootScope.$broadcast('sixComponentStatusGrid:dataLoaded','component_status',data.list);
      });
    };

    function getComponent(id) {
      recordFactory('component').byId({ id: id }).$promise.then(function (response) {
        $scope.element = response;
        eggsFormFactory.convertDates($scope.element, $scope.dateFields);
        $log.info($scope.element);
        eggsFormFactory.loadLookupData($scope.lookup, $scope.element);
        $rootScope.$broadcast('sixCheckbox:reload');
        getComponentHistory();
        $scope.initStatix($scope.element.unicode,{});
      });
    };

    function checkPermissions() {
      var profilingKey = 'XVERSUS_COMPONENT';
      var permission = authFactory.getPermissions(profilingKey);
      $scope.isUploadAllowed = permission.UPLOAD;
      $scope.isDeleteUploadAllowed = permission.DELETE_UPLOAD;
      // TODO: gestire exec?
    }

    function init() {
      schemaFactory().getCode({ id: 'component' }).$promise.then(function (data) {
        $scope.sf = data;
        initLookups();
        initDates();
        if (angular.isDefined($routeParams.id)) {
          getComponent($routeParams.id);
        }
        checkPermissions();
      });
    };

    init();

  });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:ComponentXVersusListCtrl
 * @description
 * # ComponentXVersusListCtrl
 * Controller of the ictportal.lm
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/xversus/component/list', {
                templateUrl: 'lm/xversus/component/component_list.html',
                controller: 'ComponentXVersusListCtrl'
            })
            .when('/xversus/component/list/:customer', {
                templateUrl: 'lm/xversus/component/component_list.html',
                controller: 'ComponentXVersusListCtrl'
            })
    })
    .filter('mapBoolean', function () {
        var genderHash = {
            1: 'Sì',
            2: 'No'
        };

        return function (input) {
            if (!input) {
                return '';
            } else {
                return genderHash[input];
            }
        };
    })
    .controller('ComponentXVersusListCtrl', function ($scope, $routeParams, $location, toaster, $q, dbFilterFactory,
        recordFactory, schemaFactory, uiGridConstants, $log, authFactory) {
            $scope.schemaFound = false;
            $scope.lockCustomer = false;
            $scope.list = {};
            $scope.customerFilter = []; // Filtro da applicare alla lookup sugli ospedali
            $scope.currentDestinationFilter = []; // Filtro da applicare sulle righe della tabella
            $scope.employeeCustomerFilter = []; // Filtro da applicare sulla lookup dei dipendenti
            $scope.record = {
                model: {},
                lookup: {},
                dates: []
            };
            $scope.params = {
                pageNumber: 1,
                pageSize: 15,
                code: 'component',
                filters: []
            };
            $scope.viewGridOptions = { appScopeProvider: $scope };
            $scope.advFilter = {
                filter: {},
                list: []
            };

            $scope.lookup = {
                customer_id: {
                    obj: undefined,
                    mapping: {
                        code: 'code',
                        description: 'description'
                    }
                },
                product_id: {
                    obj: undefined,
                    mapping: {
                        code: 'code',
                        description: 'description'
                    }
                },
                size_id: {
                    obj: undefined,
                    mapping: {
                        code: 'code',
                        description: 'description'
                    }
                },
                employee_id: {
                    filter: dbFilterFactory.getStringFilter('discriminator', 'EMP'),
                    obj: undefined,
                    mapping: {
                        code: 'matriculation',
                        description: 'surname,name'
                    }
                },
                lot_id: {
                    obj: undefined,
                    mapping: {
                        code: 'code',
                        description: 'code,description'
                    }
                },
                current_destination_id: {
                    obj: undefined,
                    mapping: {
                        code: 'code',
                        description: 'code,description'
                    }
                }
            };
            $scope.lookup.employee_id.filter.push({
                "column": "customer_destination c",
                "value": "t.destination_id = c.id",
                "relation": "JOIN",
                "kind": "c.customer_id"
            });

            $scope.$watchGroup(['advFilter.filter.barcode',
                                'advFilter.filter.customer_id',
                                'advFilter.filter.product_id',
                                'advFilter.filter.size_id',
                                'advFilter.filter.employee_id',
                                'advFilter.filter.lot_id',
                                'advFilter.filter.current_destination_id'], function () {
                $scope.applyFilter();
            });

            function joinTableWithCustomerDestination(){
                $scope.advFilter.list = $scope.advFilter.list.concat([
                    {
                        "column": "human_resource h",
                        "value": "t.employee_id = h.id",
                        "relation": "JOIN",
                        "kind": "h.destination_id"
                    },
                    {
                        "column": "customer_destination c",
                        "value": "h.destination_id = c.id",
                        "relation": "JOIN",
                        "kind": "c.customer_id"
                    }
                ]);
            };

            $scope.applyFilter = function () {
                $scope.advFilter.list.length = 0;
                if ($scope.advFilter.filter.barcode) {
                    var f = dbFilterFactory.getLikeFilter('t.barcode', $scope.advFilter.filter.barcode);
                    $scope.advFilter.list = $scope.advFilter.list.concat(f);
                }
                if ($scope.advFilter.filter.customer_id) {
                    joinTableWithCustomerDestination();
                    var f = dbFilterFactory.getNumberFilter('customer_id', $scope.advFilter.filter.customer_id);
                    $scope.advFilter.list = $scope.advFilter.list.concat(f);
                }
                if($scope.currentDestinationFilter.length>0){
                    $scope.advFilter.list = $scope.advFilter.list.concat($scope.currentDestinationFilter);
                }
                if ($scope.advFilter.filter.product_id) {
                    var f = dbFilterFactory.getNumberFilter('product_id', $scope.advFilter.filter.product_id);
                    $scope.advFilter.list = $scope.advFilter.list.concat(f);
                }
                if ($scope.advFilter.filter.size_id) {
                    var f = dbFilterFactory.getNumberFilter('size_id', $scope.advFilter.filter.size_id);
                    $scope.advFilter.list = $scope.advFilter.list.concat(f);
                }
                if ($scope.advFilter.filter.lot_id) {
                    var f = dbFilterFactory.getNumberFilter('lot_id', $scope.advFilter.filter.lot_id);
                    $scope.advFilter.list = $scope.advFilter.list.concat(f);
                }
                if ($scope.advFilter.filter.employee_id) {
                    var f = dbFilterFactory.getNumberFilter('employee_id', $scope.advFilter.filter.employee_id);
                    $scope.advFilter.list = $scope.advFilter.list.concat(f);
                }
                if ($scope.advFilter.filter.current_destination_id) {
                    var f = dbFilterFactory.getNumberFilter('current_destination_id', $scope.advFilter.filter.current_destination_id);
                    $scope.advFilter.list = $scope.advFilter.list.concat(f);
                }

                $log.info($scope.advFilter.list);
                $scope.getData();
            };

            function readLookups() {
                for (var key in $scope.schema.properties) {
                    var prop = $scope.schema.properties[key];
                    if (prop.format === 'lookup') {
                        $scope.record.lookup[key] = {
                            mapping: prop.mapping,
                            obj: {},
                            entity: prop.entity_id
                        };
                    }
                }
            };

            function loadLookupCols(dataList) {
                // Raggruppo assieme i record che fanno riferimento ad una stessa entità (es. tutti quelli con customer_id=123)
                // In questo modo risolvo l'entità una volta sola per tutti.
                var promises = [];
                var lookupMap = {};
                $scope.lookupCols.forEach(function (lookup) {
                    var field = lookup.field;
                    lookupMap[field] = {};
                    dataList.forEach(function (record) {
                        var id = record[field];
                        if (id) {
                            if(!lookupMap[field][id]){
                                lookupMap[field][id] = [];
                            }
                            lookupMap[field][id].push(record);
                        }
                    });
                });
                // Recupero da DB i dati e li assegno ai rispettivi record.
                $scope.lookupCols.forEach(function (lookup) {
                    for(var id in lookupMap[lookup.field]){
                        var p = recordFactory(lookup.entity).byId({ id: id })
                            .$promise.then(function (data) {
                                data['model'] = { description: '' };
                                var tokens = lookup.mapping.description.split(',');
                                tokens.forEach(function (term) {
                                    if (data[term]) {
                                        data['model'].description += data[term] + ' ';
                                    }
                                });
                                data['model'].description = data['model'].description.trim();
                                lookupMap[lookup.field][data.id].forEach(function(record){
                                    record[lookup.field + '_obj'] = data;
                                });
                            });
                        promises.push(p);
                    }
                });
                return $q.all(promises);
            };

            function readDates() {
                $scope.form[0].items[0].tabs.forEach(function (tab) {
                    tab.items.forEach(function (item) {
                        if (item.type === 'datepicker') {
                            var t1 = $scope.record.dates;
                            var t2 = item.key[0];
                            $scope.record.dates.push(item.key[0]);
                        }
                    });
                });
            };

            function loadDates(dataList) {
                $scope.record.dates.forEach(function (field) {
                    dataList.forEach(function (record) {
                        if (record[field]) {
                            record[field] = new Date(record[field]);
                        }
                    });
                });
            };

            /* Devo fare così perchè una vista ad elenco dei componenti ce l'ho anche in pagina dipendente ma le colonne da visualizzare sono diverse */
            function setColumns(data){
                data.columnDefs = [
                    {
                        name: "Unicode",
                        field: "unicode"
                    },
                    {
                        name: "Barcode",
                        field: "barcode"
                    },
                    {
                        name: "Articolo",
                        field: "product_id"
                    },
                    {
                        name: "Taglia",
                        field: "size_id"
                    },
                    {
                        name: "Stato",
                        field: "status"
                    }
                ];
            };

            function initGridColumns() {
                $scope.lookupCols = [];
                schemaFactory().getCode({ id: 'component' }).$promise.then(
                    function (data) {
                        //data= {"code":"component","description":"Component","columnDefs":[{"name":"Componente","field":"product_id"},{"name":"Barcode","field":"barcode"},{"name":"Taglia","field":"size_id"},{"name":"Stato","field":"status"},{"name":"Bloccato","field":"locked"}],"schema":{"title":"component","type":"object","properties":{"last_modified_user_id":{"title":"Last_modified_user_id","type":"number","check":false,"format":"lookup","entity_id":"users","mapping":{"code":"codice","description":"descrizione"}},"expiration_date":{"title":"Expiration_date","type":"string","check":false},"employee_id":{"title":"Employee_id","type":"number","check":false,"format":"lookup","entity_id":"human_resource","mapping":{"code":"codice","description":"descrizione"}},"weight":{"title":"Weight","type":"string","check":false},"barcode":{"title":"Barcode","type":"string","check":true,"enableFiltering":false,"enableSorting":false},"location":{"title":"Location","type":"string","check":false},"unicode":{"title":"Unicode","type":"string","check":true},"created_date":{"title":"Created_date","type":"string","check":false,"enableFiltering":false,"enableSorting":false},"customer_order_row_id":{"title":"Customer_order_row_id","type":"number","check":false,"format":"lookup","entity_id":"customer_order_row","mapping":{"code":"codice","description":"descrizione"}},"supplier_id":{"title":"Supplier_id","type":"number","check":false,"format":"lookup","entity_id":"supplier","mapping":{"code":"codice","description":"descrizione"}},"next_qc":{"title":"Next_qc","type":"string","check":false},"size_id":{"title":"Size_id","type":"number","check":true,"format":"lookup","entity_id":"tab_size","mapping":{"code":"code","description":"description"}},"qc_period":{"title":"Qc_period","type":"string","check":false},"lot_id":{"title":"Lot_id","type":"number","check":false,"format":"lookup","entity_id":"lot","mapping":{"code":"code","description":"code,description"}},"packaging_plant_id":{"title":"Packaging_plant_id","type":"number","check":false,"format":"lookup","entity_id":"plant","mapping":{"code":"codice","description":"descrizione"}},"container_id":{"title":"Container_id","type":"number","check":false,"format":"lookup","entity_id":"container","mapping":{"code":"codice","description":"descrizione"}},"locked":{"title":"Locked","type":"string","check":true,"enableFiltering":false,"enableSorting":false},"assignment_type":{"title":"Assignment_type","type":"string","check":false},"order_plant_id":{"title":"Order_plant_id","type":"number","check":false,"format":"lookup","entity_id":"plant","mapping":{"code":"codice","description":"descrizione"}},"production_status":{"title":"Production_status","type":"string","check":false},"version":{"title":"Version","type":"string","check":false},"order_proc_status":{"title":"Order_proc_status","type":"string","check":false},"agreement_id":{"title":"Agreement_id","type":"number","check":false,"format":"lookup","entity_id":"agreement","mapping":{"code":"codice","description":"descrizione"}},"created_user_id":{"title":"Created_user_id","type":"number","check":false,"format":"lookup","entity_id":"users","mapping":{"code":"codice","description":"descrizione"}},"divcod":{"title":"Divcod","type":"string","check":false,"enableFiltering":false,"enableSorting":false},"current_plant_id":{"title":"Current_plant_id","type":"number","check":false,"format":"lookup","entity_id":"plant","mapping":{"code":"codice","description":"descrizione"}},"note":{"title":"Note","type":"string","check":false},"wash_num":{"title":"Wash_num","type":"string","check":false},"current_component_status_id":{"title":"Current_component_status_id","type":"number","check":true,"format":"lookup","entity_id":"component_status","mapping":{"code":"code","description":"description"}},"delivery_note_item_id":{"title":"Delivery_note_item_id","type":"number","check":false,"format":"lookup","entity_id":"shipment_item","mapping":{"code":"codice","description":"descrizione"}},"status":{"title":"status","type":"string","check":true,"format":"enum"},"last_operation_date":{"title":"Last_operation_date","type":"string","check":false},"last_modified_date":{"title":"Last_modified_date","type":"string","check":false},"product_id":{"title":"Product_id","type":"number","check":true,"format":"lookup","entity_id":"product","mapping":{"code":"code","description":"description"},"enableFiltering":false,"enableSorting":false},"plant_id":{"title":"Plant_id","type":"number","check":true,"format":"lookup","entity_id":"plant","mapping":{"code":"codice","description":"descrizione"}},"current_destination_id":{"title":"Current_destination_id","type":"number","check":false,"format":"lookup","entity_id":"customer_destination","mapping":{"code":"codice","description":"descrizione"}},"shipment_destination":{"title":"Shipment_destination","type":"number","check":false,"format":"lookup","entity_id":"customer_destination","mapping":{"code":"codice","description":"descrizione"}},"azcod":{"title":"Azcod","type":"string","check":true},"ster_num":{"title":"Ster_num","type":"string","check":false},"current_product":{"title":"Current_product","type":"number","check":true,"format":"lookup","entity_id":"product","mapping":{"code":"codice","description":"descrizione"}},"color_id":{"title":"Color_id","type":"number","check":false,"format":"lookup","entity_id":"color","mapping":{"code":"codice","description":"descrizione"}},"next_wash":{"title":"Next_wash","type":"string","check":false},"control_reason_id":{"title":"Control_reason_id","type":"number","check":true,"format":"lookup","entity_id":"control_reason","mapping":{"code":"code","description":"description"},"enableFiltering":false,"enableSorting":false},"special_use":{"title":"Special_use","type":"string","check":false,"format":"enum"}},"required":["barcode","current_product","plant_id","product_id"]},"form":[{"type":"fieldset","items":[{"type":"tabs","tabs":[{"title":"Base","items":[{"key":["created_date"],"type":"datepicker","title":"Created_date","required":false},{"key":["divcod"],"type":"string","title":"Divcod","required":false},{"key":["last_modified_date"],"type":"datepicker","title":"Last_modified_date","required":false},{"key":["barcode"],"type":"string","title":"Barcode","required":true},{"key":["expiration_date"],"type":"datepicker","title":"Expiration_date","required":false},{"key":["last_operation_date"],"type":"datepicker","title":"Last_operation_date","required":false},{"key":["locked"],"type":"eggscheckbox","title":"Locked","required":false},{"key":["note"],"type":"string","title":"Note","required":false},{"key":["order_proc_status"],"type":"string","title":"Order_proc_status","required":false},{"key":["production_status"],"type":"string","title":"Production_status","required":false},{"key":["status"],"type":"select","title":"Status","required":false,"titleMap":[{"name":"Nuovo","value":"N"},{"name":"Conforme","value":"C"},{"name":"Non conforme","value":"NC"},{"name":"Piegato","value":"F"},{"name":"Confezionato","value":"P"},{"name":"Spedito reparto","value":"S"},{"name":"Rientrato","value":"E"},{"name":"Dismesso","value":"A"},{"name":"Usato","value":"U"},{"name":"Lavato","value":"L"},{"name":"Lavaggio speciale","value":"SW"},{"name":"Sartoria","value":"T"},{"name":"Guardaroba","value":"W"},{"name":"Spedito lavanderia","value":"SL"},{"name":"Spedito guardaroba","value":"SWA"},{"name":"Sporco guardaroba","value":"DWA"},{"name":"Spedito CL","value":"PCW"},{"name":"Disperso","value":"LOST"},{"name":"Accettato reparto","value":"ACCD"},{"name":"Spedibile guard.","value":"SHPBLW"},{"name":"Spedibile rep.","value":"SHPBLD"},{"name":"Sterilizzato","value":"ST"}]},{"key":["ster_num"],"type":"string","title":"Ster_num","required":false},{"key":["unicode"],"type":"string","title":"Unicode","required":false},{"key":["version"],"type":"string","title":"Version","required":false},{"key":["wash_num"],"type":"string","title":"Wash_num","required":false},{"key":["created_user_id"],"type":"sixlookup","title":"Created_user_id","required":false},{"key":["last_modified_user_id"],"type":"sixlookup","title":"Last_modified_user_id","required":false},{"key":["agreement_id"],"type":"sixlookup","title":"Agreement_id","required":false},{"key":["control_reason_id"],"type":"sixlookup","title":"Control_reason_id","required":false,"entity_id":"control_reason"},{"key":["current_component_status_id"],"type":"sixlookup","title":"Current_component_status_id","required":false,"entity_id":"component_status"},{"key":["current_destination_id"],"type":"sixlookup","title":"Current_destination_id","required":false},{"key":["current_plant_id"],"type":"sixlookup","title":"Current_plant_id","required":false},{"key":["current_product"],"type":"sixlookup","title":"Current_product","required":true},{"key":["customer_order_row_id"],"type":"sixlookup","title":"Customer_order_row_id","required":false},{"key":["delivery_note_item_id"],"type":"sixlookup","title":"Delivery_note_item_id","required":false},{"key":["employee_id"],"type":"sixlookup","title":"Employee_id","required":false},{"key":["lot_id"],"type":"sixlookup","title":"Lot_id","required":false},{"key":["order_plant_id"],"type":"sixlookup","title":"Order_plant_id","required":false},{"key":["packaging_plant_id"],"type":"sixlookup","title":"Packaging_plant_id","required":false},{"key":["plant_id"],"type":"sixlookup","title":"Plant_id","required":true},{"key":["product_id"],"type":"sixlookup","title":"Product_id","required":true},{"key":["shipment_destination"],"type":"sixlookup","title":"Shipment_destination","required":false},{"key":["size_id"],"type":"sixlookup","title":"Size_id","required":false,"entity_id":"tab_size"},{"key":["supplier_id"],"type":"sixlookup","title":"Supplier_id","required":false},{"key":["assignment_type"],"type":"string","title":"Assignment_type","required":false},{"key":["qc_period"],"type":"string","title":"Qc_period","required":false},{"key":["next_qc"],"type":"datepicker","title":"Next_qc","required":false},{"key":["next_wash"],"type":"datepicker","title":"Next_wash","required":false},{"key":["color_id"],"type":"sixlookup","title":"Color_id","required":false},{"key":["container_id"],"type":"sixlookup","title":"Container_id","required":false},{"key":["weight"],"type":"string","title":"Weight","required":false},{"key":["special_use"],"type":"select","title":"Special_use","required":false,"titleMap":[{"name":"Muletto","value":"COURTESY"}]},{"key":["location"],"type":"string","title":"Location","required":false},{"title":"status","type":"uiselect","key":["status"],"titleMap":[{"name":"","value":""}]}]}]}]}]};
                        if (data.schema) {
                            setColumns(data);
                            $scope.sf = data;
                            if (data.schema && data.form) {
                                $scope.schema = data.schema;
                                $scope.form = data.form;
                                readLookups();
                                readDates();
                            }
                            if (data.schema || data.form) $scope.schemaFound = true;
                            if (data.columnDefs) {
                                $scope.viewGridOptions.columnDefs = [];
                                $scope.viewGridOptions.columnDefs.push({
                                    displayName: '',
                                    field: 'id',
                                    width: 34,
                                    enableCellEdit: false,
                                    enableFiltering: false,
                                    enableSorting: false,
                                    cellTemplate:
                                    '<div class="ui-grid-cell-contents" style="text-align: center">' +
                                    '<button ng-click="grid.appScope.viewDetail(row.entity)" class="btn btn-xs btn-primary">' +
                                    '<span class="fa fa-search"></span>' +
                                    '</button>' +
                                    '</div>'
                                });
                                data.columnDefs.forEach(function (item) {
                                    item.enableFiltering = getEnableFiltering(item);
                                    item.filters = [{
                                        type: 'text',
                                        condition: uiGridConstants.filter.CONTAINS,
                                        placeholder: '',
                                        kind: 'string'
                                    }];
                                    if ($scope.record.lookup[item.field]) {
                                        var prop = data.schema.properties[item.field];
                                        item.filters = [{
                                            type: 'lookup',
                                            condition: uiGridConstants.filter.CONTAINS,
                                            placeholder: '',
                                            kind: 'string',
                                            schema: prop,
                                            join: {
                                                column: prop.entity_id,
                                                value: 't.' + prop.title + ' = ' + prop.entity_id + '.id',
                                                relation: 'JOIN',
                                                kind: ''
                                            }
                                        }];
                                        var lookup = $scope.record.lookup[item.field];
                                        lookup.field = item.field;
                                        item.field = item.field + '_obj.model.description';
                                        item.enableSorting = false;
                                        $scope.lookupCols.push(lookup);
                                    }
                                    else if (isDate(item.field)) {
                                        item.filters = [
                                            {
                                                type: 'date',
                                                relation: '>=',
                                                placeholder: 'da...',
                                                kind: 'date',
                                                condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
                                            },
                                            {
                                                type: 'date',
                                                relation: '<=',
                                                placeholder: 'a...',
                                                kind: 'date',
                                                condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
                                            }
                                        ];
                                        item.cellTemplate = '<div class="ui-grid-cell-contents">{{ row.entity.' + item.field + ' | date:\'dd/MM/yyyy\' }}</div>'
                                    }
                                    else if (isBoolean(item.field)) {
                                        var options = [{
                                            value: 'S',
                                            label: 'Sì'
                                        }, {
                                            value: 'N',
                                            label: 'No'
                                        }];
                                        item.filter = {
                                            type: uiGridConstants.filter.SELECT
                                        };
                                        item.editDropdownOptionsArray = options;
                                        item.filter.selectOptions = options.map(function (obj) {
                                            var rObj = { 'value': obj.value, 'label': obj.label };
                                            return rObj;
                                        });
                                        item.cellTemplate = '<div class="ui-grid-cell-contents"><span ng-if="row.entity.' + item.field + '===\'S\'" >Sì</span><span ng-if="row.entity.' + item.field + '!==\'S\'" >No</span></div>'
                                    }
                                    else if(isEnum(item.field)){
                                        var options = getTitleMap(item.field);
                                        item.filter = {
                                            type: uiGridConstants.filter.SELECT
                                        };
                                        item.editDropdownOptionsArray = options;
                                        item.filter.selectOptions = options.map(function(obj) {
                                            var rObj = {'value': obj.value, 'name': obj.label};
                                            return rObj;
                                        });
                                        item.cellTemplate = '<div class="ui-grid-cell-contents">';
                                        options.forEach(function(opt){
                                            item.cellTemplate += '<span ng-if="row.entity.' + item.field + '===\'' + opt.value + '\'" >' + opt.name + '</span>';
                                        });
                                        item.cellTemplate += '</div>';
                                    }
                                    $scope.viewGridOptions.columnDefs.push(item)
                                });
                            };
                        }
                        // Default
                        else {
                            setDefaultColumns();
                        }
                    }
                )
                .catch(function(){
                    setDefaultColumns();
                });
            };

            function setDefaultColumns(){
                $scope.viewGridOptions.columnDefs = [];
                $scope.viewGridOptions.columnDefs.push({
                    displayName: '',
                    field: 'id',
                    width: 34,
                    enableCellEdit: true,
                    enableFiltering: false,
                    enableSorting: false,
                    cellTemplate:
                    '<div class="ui-grid-cell-contents" style="text-align: center">' +
                    '<button ng-click="grid.appScope.viewDetail(row.entity)" class="btn btn-xs btn-primary">' +
                    '<span class="fa fa-search"></span>' +
                    '</button>' +
                    '</div>'
                });
                $scope.viewGridOptions.columnDefs.push({
                    displayName: capitalize($routeParams.code),
                    field: 'model.code',
                    enableFiltering: true,
                    filters: [{
                        type: 'text',
                        condition: uiGridConstants.filter.CONTAINS,
                        placeholder: '',
                        kind: 'string'
                    }]
                });
                $scope.viewGridOptions.columnDefs.push({
                    displayName: 'Description',
                    field: 'model.description',
                    enableFiltering: true,
                    filters: [{
                        type: 'text',
                        condition: uiGridConstants.filter.CONTAINS,
                        placeholder: '',
                        kind: 'string'
                    }]
                });
            }

            function getEnableFiltering(item) {
                return false;
            };

            function getTitleMap(field){
                var titleMap = [];
                for(var i=0; i<$scope.form[0].items[0].tabs.length; i++){
                    var tab = $scope.form[0].items[0].tabs[i];
                    var index = tab.items.findIndex(function(e) { return e.key[0] == field; });
                    if(index>=0){
                        if(tab.items[index].titleMap){
                            titleMap = tab.items[index].titleMap;
                        }
                        break;
                    }
                }
                return titleMap;
            };

            function isEnum(field){
                var isAnEnum = false;
                if($scope.sf.schema.properties[field]){
                    isAnEnum = $scope.sf.schema.properties[field].format==='enum';
                }
                return isAnEnum;
            };

            function isDate(field) {
                var isADate = false;
                for (var i = 0; i < $scope.form[0].items[0].tabs.length; i++) {
                    var tab = $scope.form[0].items[0].tabs[i];
                    var index = tab.items.findIndex(function (e) { return e.key[0] == field; });
                    if (index >= 0) {
                        isADate = (tab.items[index].type === 'datepicker');
                        break;
                    }
                }
                return isADate;
            };

            function isBoolean(field) {
                var isABoolean = false;
                for (var i = 0; i < $scope.form[0].items[0].tabs.length; i++) {
                    var tab = $scope.form[0].items[0].tabs[i];
                    var index = tab.items.findIndex(function (e) { return e.key[0] == field; });
                    if (index >= 0) {
                        isABoolean = (tab.items[index].type === 'eggscheckbox');
                        break;
                    }
                }
                return isABoolean;
            };

            // [SIX-3374] - La funzione componenti xVersus deve fare vedere solo componenti associati a dipendenti dei reparti a cui l'utente è abilitato.
            function getCustomerDestinationImplicitFilters() {
                var authData = authFactory.getAuthData();
                var filter = authData.filters.customer_destination?authData.filters.customer_destination:[];
                if(filter.length>0){
                    dbFilterFactory.changeCustomAlias('e',filter[0],'destination_id');
                }
                return filter;
            }

            $scope.getData = function () {
                var payload = {
                    page: $scope.params.pageNumber,
                    page_size: $scope.params.pageSize,
                    code: $scope.params.code,
                    description: $scope.params.description,
                    show_revision: false,
                    sort_fields: ($scope.params.sortFields?$scope.params.sortFields:'barcode'),
                    sort_order: $scope.params.sortOrder
                };
                var filters = buildFilters();
                // "mostrare solo componenti in stato spedito reparto o accettato reparto"
                recordFactory('component').filter(payload, filters)
                    .$promise.then(function (data) {
                        $scope.viewGridOptions.totalItems = data.totalResults;
                        $scope.list.totalResults = data.totalResults;
                        $scope.list.list = data.list;
                        if ($scope.lookupCols.length > 0) {
                            loadLookupCols($scope.list.list);
                        }
                        if ($scope.record.dates.length > 0) {
                            loadDates($scope.list.list);
                        }
                    });
            };

            $scope.getAllData = function () {
              var payload = {
                page: 1,
                page_size: $scope.list.totalResults,
                code: $scope.params.code,
                description: $scope.params.description,
                show_revision: false,
                sort_fields: ($scope.params.sortFields?$scope.params.sortFields:'barcode'),
                sort_order: $scope.params.sortOrder
              };
              var filters = buildFilters();
              // "mostrare solo componenti in stato spedito reparto o accettato reparto"
              var p = $q.defer();
              recordFactory('component').filter(payload, filters).$promise.then(function (data) {
                if ($scope.record.dates.length > 0) {
                  loadDates(data.list);
                }
                if ($scope.lookupCols.length > 0) {
                  loadLookupCols(data.list).then(function() { p.resolve(data); });
                } else {
                  p.resolve(data);
                }
              });
              return p.promise;
            };

            function buildFilters() {
              var filters = [
                {
                  "column": "product d",
                  "value": "t.product_id = d.id",
                  "relation": "JOIN",
                  "kind": "d.description AS product_desc"
                },
                {
                  "column": "human_resource e",
                  "value": "t.employee_id = e.id",
                  "relation": "JOIN",
                  "kind": "e.destination_id"
                }
              ];
              filters = filters.concat(getCustomerDestinationImplicitFilters());
              filters = filters.concat($scope.advFilter.list);
              return filters;
            }

            function capitalize(s) {
                return s && s[0].toUpperCase() + s.slice(1);
            };

            $scope.viewDetail = function (value) {
                $location.path('/xversus/component/detail/' + value.id);
            };

            function getCustomer(id) {
                recordFactory('customer').byId({ id: id })
                    .$promise.then(function (data) {
                        $scope.lookup.customer_id.obj = data;
                        $scope.advFilter.filter.customer_id = id;
                    });
            };

            // Se poi ho in GET l'id di uno specifico nosocomio, filtro solo su quello e blocco la selezione di altri ospedali.
            function getCustomerFilter(){
                // Recupero l'elenco delle destinazioni possibili per l'operatore
                var authData = authFactory.getAuthData();
                var customerDestinationQuery = '';
                var currentDestinationQuery = '';
                var customerQuery = ''; // Query da applicare alla lookup sugli ospedali
                var employeeCustomerQuery = ''; // Query da applicare sulle righe della tabella e sulla lookup dei dipendenti
                if(authData && authData.info && authData.info.authorizations){
                    authData.info.authorizations.destinations.forEach(function(destinationId){
                        customerDestinationQuery += 'id=' + destinationId + ' OR ';
                        currentDestinationQuery += 'current_destination_id=' + destinationId + ' OR ';
                    });
                }
                if(customerDestinationQuery.length>0){
                    $scope.lockCustomer = true; // Blocco la lookup sull'ospedale finché non ho caricato il filtro
                    customerDestinationQuery = customerDestinationQuery.slice(0,-4);
                    customerDestinationQuery = '(' + customerDestinationQuery + ')';
                    currentDestinationQuery = currentDestinationQuery.slice(0,-4);
                    currentDestinationQuery = '(' + currentDestinationQuery + ')';
                    $scope.lookup.current_destination_id.filter = dbFilterFactory.getCustomFilter(customerDestinationQuery);
                    $scope.currentDestinationFilter = dbFilterFactory.getCustomFilter(currentDestinationQuery);
                    var filter = dbFilterFactory.getCustomFilter(customerDestinationQuery);
                    recordFactory('customer_destination').filter({page_size:10000},filter)
                        .$promise.then(function (data){
                            // Ottengo la lista dei distinti nosocomi possibili per l'operatore
                            var list = [];
                            data.list.forEach(function(item){
                                if(list.indexOf(item.customer_id)==-1){
                                    list.push(item.customer_id);
                                }
                            });
                            list.forEach(function(customerId){
                                customerQuery += 'id=' + customerId + ' OR ';
                                employeeCustomerQuery += 'c.customer_id=' + customerId + ' OR ';
                            })
                            if(customerQuery.length>0){
                                customerQuery = customerQuery.slice(0,-4);
                                customerQuery = '(' + customerQuery + ')';
                                employeeCustomerQuery = employeeCustomerQuery.slice(0,-4);
                                employeeCustomerQuery = '(' + employeeCustomerQuery + ')';
                                $scope.customerFilter = $scope.customerFilter.concat(dbFilterFactory.getCustomFilter(customerQuery));
                                $scope.employeeCustomerFilter = $scope.employeeCustomerFilter.concat(dbFilterFactory.getCustomFilter(employeeCustomerQuery));
                                $scope.lookup.employee_id.filter = $scope.lookup.employee_id.filter.concat(dbFilterFactory.getCustomFilter(employeeCustomerQuery));
                            }
                            $scope.lockCustomer = false;
                            $scope.applyFilter();
                        });
                }
            };

            function init() {
                initGridColumns();
                // Se l'utente è abilitato solo a certi ospedali, filtro tutti i dati di conseguenza.
                // Se poi ho in GET l'id di uno specifico nosocomio, filtro solo su quello e blocco la selezione di altri ospedali.
                if ($routeParams.customer) {
                    $scope.lockCustomer = true;
                    $scope.lookup.employee_id.filter = $scope.lookup.employee_id.filter.concat(dbFilterFactory.getNumberFilter('c.customer_id', parseInt($routeParams.customer)));
                    getCustomer(parseInt($routeParams.customer));
                }
                else{
                    getCustomerFilter();
                }
            };

            //___ main ___
            init();

        });

/**
 * Created by Rita Beltrami on 21/06/17.
 */
'use strict';

angular.module('ictportal.lm')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/xversus/employee/detail', {
          templateUrl: 'lm/xversus/employee/employee_detail.html',
          controller: 'EmployeeXVersusCtrl'
        })
        .when('/xversus/employee/detail/:id', {
          templateUrl: 'lm/xversus/employee/employee_detail.html',
          controller: 'EmployeeXVersusCtrl'
        })
  })
  .controller('EmployeeXVersusCtrl', function ($scope, $log, recordFactory, $routeParams, $location,
                                          eggsFormFactory, toaster, dbFilterFactory, 
                                          authFactory, $q, $window,  $rootScope, schemaFactory) {

    $scope.pageTitle = 'Dettaglio dipendente';
    $scope.readOnly = true;
    $scope.componentDetailLink = 'xversus/component/detail';
    $scope.enum = {
        sex: [
          {
            name: 'Femmina',
            value: 'F'
          },
          {
            name: 'Maschio',
            value: 'M'
          }
        ]            
    };                     
    $scope.customer = {};

    function initLookups() {
      $scope.lookup = { };
      $scope.customerLookup = {};
      for (var key in $scope.sf.schema.properties) {
        var prop = $scope.sf.schema.properties[key];
        if (prop.format === 'lookup') {
          eggsFormFactory.addLookup($scope.lookup, key, prop.entity_id, 'code', 'description');
        }
      }
      // adding custom mappings
      eggsFormFactory.addLookup($scope.customerLookup, 'customer_id', 'customer', 'code', 'description');
      $scope.mappingLoaded = true;
    };

    function initDates() {
      $scope.dateFields = [];
      $scope.sf.form[0].items[0].tabs.forEach(function (tab) {
        tab.items.forEach(function (item) {
          if (item.type === 'datepicker') {
            $scope.dateFields.push(item.key[0]);
          }
        });
      });
    };

    // L'ospedale dipende dal reparto
    $scope.$watch('lookup.destination_id.obj',
        function(newValue, oldValue) {
          if($scope.customerLookup){
            if(newValue && newValue.customer_id){
              recordFactory('customer').byId({ id: newValue.customer_id }).$promise.then(function (response) {
                $scope.customerLookup.customer_id.obj = response;
              });
            }
            else{
              $scope.customerLookup.customer_id.obj = undefined;
            }
          }
        }
    );

    $scope.backToEmployees = function(){
      $location.path('xversus/human_resource/list/employee');
    };

    function getEmployeeHistory(){
      var payload = {
        page_size: 10000,
        show_revision: false,
        sort_fields: 'operation_date',
        sort_order: 'desc'
      };
      var filters = [{
        column: 'human_resource h',
        value: 't.operator_id = h.id',
        relation: 'JOIN',
        kind: 'h.matriculation'
      },
      {
        column: 'customer_destination d',
        value: 't.destination_id = d.id',
        relation: 'JOIN',
        kind: 'd.customer_id'
      }];
      filters = filters.concat(dbFilterFactory.getNumberFilter('employee_id',$scope.element.id));
      recordFactory('employee_history').filter(payload, filters)
          .$promise.then(function(data) {
            $log.info(data);
            $rootScope.$broadcast('sixDetailGrid:dataLoaded','employee_history',data.list);
      });
    };

    function getEmployeeComponents(){
      var payload = {
        page_size: 10000
      };
      var filters = [{
        column: 'component_status cs',
        value: 't.current_component_status_id = cs.id',
        relation: 'JOIN',
        kind: 'cs.status'
      }];
      filters = filters.concat(dbFilterFactory.getNumberFilter('t.employee_id',$scope.element.id));
      recordFactory('component').filter(payload, filters)
          .$promise.then(function(data) {
            $log.info(data);
            $rootScope.$broadcast('sixDetailGrid:dataLoaded','component',data.list);
      });
    };

    function getEmployee(id) {
      recordFactory('human_resource').byId({ id: id }).$promise.then(function (response) {
        $scope.element = response;
        eggsFormFactory.convertDates($scope.element, $scope.dateFields);
        $log.info($scope.element);
        eggsFormFactory.loadLookupData($scope.lookup, $scope.element);
        $rootScope.$broadcast('sixCheckbox:reload');
        getEmployeeHistory();
        getEmployeeComponents();
      });
    };

    function init() {
      schemaFactory().getCode({ id: 'human_resource' }).$promise.then(function (data) {
        $scope.sf = data;
        initLookups();
        initDates();
        if (angular.isDefined($routeParams.id)) {
          getEmployee($routeParams.id);
        }
      });
    };

    init();

  });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.lm.controller:EmployeeListCtrl
 * @description
 * # EmployeeListCtrl
 * Controller of the ictportal.lm
 */
angular.module('ictportal.lm')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/xversus/human_resource/list/:discriminator', {
                templateUrl: 'lm/xversus/employee/employee_list.html',
                controller: 'EmployeeListXVersusCtrl'
            })
            .when('/xversus/human_resource/list/:discriminator/:customer', {
                templateUrl: 'lm/xversus/employee/employee_list.html',
                controller: 'EmployeeListXVersusCtrl'
            })
    })
    .filter('mapBoolean', function () {
        var genderHash = {
            1: 'Sì',
            2: 'No'
        };

        return function (input) {
            if (!input) {
                return '';
            } else {
                return genderHash[input];
            }
        };
    })
    .controller('EmployeeListXVersusCtrl', function ($scope, $routeParams, $location, toaster, $q, dbFilterFactory,
        recordFactory, schemaFactory, uiGridConstants, $log, authFactory) {
        $scope.discriminator = $routeParams.discriminator;
        $scope.schemaFound = false;
        $scope.lockCustomer = false;
        $scope.list = {};
        $scope.employeeDestinationFilter = [];
        $scope.record = {
            model: {},
            lookup: {},
            dates: []
        };
        $scope.params = {
            pageNumber: 1,
            pageSize: 15,
            code: 'human_resource',
            filters: []
        };
        $scope.viewGridOptions = { appScopeProvider: $scope };
        $scope.advFilter = {
            filter: {},
            list: []
        };

        $scope.lookup = {
            employee_id: {
                filter: dbFilterFactory.getStringFilter('discriminator', 'EMP'),
                obj: undefined,
                mapping: {
                    code: 'matriculation',
                    description: 'surname,name'
                }
            },
            customer_id: {
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            },
            destination_id: {
                filter: [],
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            },
            customer_cost_center_id: {
                filter: [],
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            },
            delivery_destination_id: {
                filter: [],
                obj: undefined,
                mapping: {
                    code: 'code',
                    description: 'description'
                }
            }
        };
        // Aggiungo eventualmente alle lookup dei join che mi servono per poi filtrare i risultati.
        $scope.lookup.employee_id.filter.push({
            "column": "customer_destination d",
            "value": "t.destination_id = d.id",
            "relation": "JOIN",
            "kind": "d.customer_id"
        });

        function getCustomer(id) {
            recordFactory('customer').byId({ id: id })
                .$promise.then(function (data) {
                    $scope.lookup.customer_id.obj = data;
                    $scope.advFilter.filter.customer_id = id;
                });
        };

        $scope.$watchGroup(['advFilter.filter.customer_id',
                            'advFilter.filter.employee_id',
                            'advFilter.filter.destination_id',
                            'advFilter.filter.customer_cost_center_id',
                            'advFilter.filter.delivery_destination_id',], function () {
            $scope.applyFilter();
        });

        $scope.applyFilter = function () {
            $scope.advFilter.list.length = 0;
            if ($scope.advFilter.filter.customer_id) {
                var f = dbFilterFactory.getNumberFilter('customer_id', $scope.advFilter.filter.customer_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            else if($scope.employeeDestinationFilter.length>0){
                $scope.advFilter.list = $scope.advFilter.list.concat($scope.employeeDestinationFilter);
            }
            if ($scope.advFilter.filter.employee_id) {
                var f = dbFilterFactory.getNumberFilter('t.id', $scope.advFilter.filter.employee_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.destination_id) {
                var f = dbFilterFactory.getNumberFilter('destination_id', $scope.advFilter.filter.destination_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.customer_cost_center_id) {
                var f = dbFilterFactory.getNumberFilter('t.customer_cost_center_id', $scope.advFilter.filter.customer_cost_center_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.delivery_destination_id) {
                var f = dbFilterFactory.getNumberFilter('t.delivery_destination_id', $scope.advFilter.filter.delivery_destination_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }

            $log.info($scope.advFilter.list);
            $scope.getData();
        };

        function readLookups() {
            for (var key in $scope.schema.properties) {
                var prop = $scope.schema.properties[key];
                if (prop.format === 'lookup') {
                    $scope.record.lookup[key] = {
                        mapping: prop.mapping,
                        obj: {},
                        entity: prop.entity_id
                    };
                }
            }
        };

        function loadLookupCols(dataList) {
            // Raggruppo assieme i record che fanno riferimento ad una stessa entità (es. tutti quelli con customer_id=123)
            // In questo modo risolvo l'entità una volta sola per tutti.
            var promises = [];
            var lookupMap = {};
            $scope.lookupCols.forEach(function (lookup) {
                var field = lookup.field;
                lookupMap[field] = {};
                dataList.forEach(function (record) {
                    var id = record[field];
                    if (id) {
                        if(!lookupMap[field][id]){
                            lookupMap[field][id] = [];
                        }
                        lookupMap[field][id].push(record);
                    }
                });
            });
            // Recupero da DB i dati e li assegno ai rispettivi record.
            $scope.lookupCols.forEach(function (lookup) {
                for(var id in lookupMap[lookup.field]){
                    var p = recordFactory(lookup.entity).byId({ id: id })
                        .$promise.then(function (data) {
                            data['model'] = { description: '' };
                            var tokens = lookup.mapping.description.split(',');
                            tokens.forEach(function (term) {
                                if (data[term]) {
                                    data['model'].description += data[term] + ' ';
                                }
                            });
                            data['model'].description = data['model'].description.trim();
                            lookupMap[lookup.field][data.id].forEach(function(record){
                                record[lookup.field + '_obj'] = data;
                            });
                        });
                    promises.push(p);
                }
            });
            return $q.all(promises);
        };

        function readDates() {
            $scope.form[0].items[0].tabs.forEach(function (tab) {
                tab.items.forEach(function (item) {
                    if (item.type === 'datepicker') {
                        var t1 = $scope.record.dates;
                        var t2 = item.key[0];
                        $scope.record.dates.push(item.key[0]);
                    }
                });
            });
        };

        function loadDates(dataList) {
            $scope.record.dates.forEach(function (field) {
                dataList.forEach(function (record) {
                    if (record[field]) {
                        record[field] = new Date(record[field]);
                    }
                });
            });
        };

        function initGridColumns() {
            $scope.lookupCols = [];
            schemaFactory().getCode({ id: 'human_resource' }).$promise.then(
                function (data) {
                    if (data.schema) {
                        $scope.sf = data;
                        if (data.schema && data.form) {
                            $scope.schema = data.schema;
                            $scope.form = data.form;
                            readLookups();
                            readDates();
                        }
                        if (data.schema || data.form) $scope.schemaFound = true;
                        if (data.columnDefs) {
                            $scope.viewGridOptions.columnDefs = [];
                            $scope.viewGridOptions.columnDefs.push({
                                displayName: '',
                                field: 'id',
                                width: 34,
                                enableCellEdit: false,
                                enableFiltering: false,
                                enableSorting: false,
                                cellTemplate:
                                '<div class="ui-grid-cell-contents" style="text-align: center">' +
                                '<button ng-click="grid.appScope.viewDetail(row.entity)" class="btn btn-xs btn-primary">' +
                                '<span class="fa fa-search"></span>' +
                                '</button>' +
                                '</div>'
                            });
                            data.columnDefs.forEach(function (item) {
                                item.enableFiltering = getEnableFiltering(item);
                                item.filters = [{
                                    type: 'text',
                                    condition: uiGridConstants.filter.CONTAINS,
                                    placeholder: '',
                                    kind: 'string'
                                }];
                                if ($scope.record.lookup[item.field]) {
                                    var prop = data.schema.properties[item.field];
                                    item.filters = [{
                                        type: 'lookup',
                                        condition: uiGridConstants.filter.CONTAINS,
                                        placeholder: '',
                                        kind: 'string',
                                        schema: prop,
                                        join: {
                                            column: prop.entity_id,
                                            value: 't.' + prop.title + ' = ' + prop.entity_id + '.id',
                                            relation: 'JOIN',
                                            kind: ''
                                        }
                                    }];
                                    var lookup = $scope.record.lookup[item.field];
                                    lookup.field = item.field;
                                    item.field = item.field + '_obj.model.description';
                                    item.enableSorting = false;
                                    $scope.lookupCols.push(lookup);
                                }
                                else if (isDate(item.field)) {
                                    item.filters = [
                                        {
                                            type: 'date',
                                            relation: '>=',
                                            placeholder: 'da...',
                                            kind: 'date',
                                            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
                                        },
                                        {
                                            type: 'date',
                                            relation: '<=',
                                            placeholder: 'a...',
                                            kind: 'date',
                                            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
                                        }
                                    ];
                                    item.cellTemplate = '<div class="ui-grid-cell-contents">{{ row.entity.' + item.field + ' | date:\'dd/MM/yyyy\' }}</div>'
                                }
                                else if (isBoolean(item.field)) {
                                    var options = [{
                                        value: 'S',
                                        label: 'Sì'
                                    }, {
                                        value: 'N',
                                        label: 'No'
                                    }];
                                    item.filter = {
                                        type: uiGridConstants.filter.SELECT
                                    };
                                    item.editDropdownOptionsArray = options;
                                    item.filter.selectOptions = options.map(function (obj) {
                                        var rObj = { 'value': obj.value, 'label': obj.label };
                                        return rObj;
                                    });
                                    item.cellTemplate = '<div class="ui-grid-cell-contents"><span ng-if="row.entity.' + item.field + '===\'S\'" >Sì</span><span ng-if="row.entity.' + item.field + '!==\'S\'" >No</span></div>'
                                }
                                $scope.viewGridOptions.columnDefs.push(item)
                            });
                        };
                    }
                    // Default
                    else {
                        $scope.viewGridOptions.columnDefs = [];
                        $scope.viewGridOptions.columnDefs.push({
                            displayName: '',
                            field: 'id',
                            width: 34,
                            enableCellEdit: true,
                            enableFiltering: false,
                            enableSorting: false,
                            cellTemplate:
                            '<div class="ui-grid-cell-contents" style="text-align: center">' +
                            '<button ng-click="grid.appScope.viewDetail(row.entity)" class="btn btn-xs btn-primary">' +
                            '<span class="fa fa-search"></span>' +
                            '</button>' +
                            '</div>'
                        });
                        $scope.viewGridOptions.columnDefs.push({
                            displayName: capitalize($routeParams.code),
                            field: 'model.code',
                            enableFiltering: true,
                            filters: [{
                                type: 'text',
                                condition: uiGridConstants.filter.CONTAINS,
                                placeholder: '',
                                kind: 'string'
                            }]
                        });
                        $scope.viewGridOptions.columnDefs.push({
                            displayName: $routeParams.description.split(',').reduce(function (a, b) { return a + capitalize(b) + ' '; }, '').trim(),
                            field: 'model.description',
                            enableFiltering: true,
                            filters: [{
                                type: 'text',
                                condition: uiGridConstants.filter.CONTAINS,
                                placeholder: '',
                                kind: 'string'
                            }]
                        });
                    }
                }
            );
        };

        function getEnableFiltering(item) {
            /*var schemaItem = $scope.sf.schema.properties[item.field];
            var enable = !(schemaItem.enableFiltering === false);
            return enable;*/
            return false;
        };

        function isDate(field) {
            var isADate = false;
            for (var i = 0; i < $scope.form[0].items[0].tabs.length; i++) {
                var tab = $scope.form[0].items[0].tabs[i];
                var index = tab.items.findIndex(function (e) { return e.key[0] == field; });
                if (index >= 0) {
                    isADate = (tab.items[index].type === 'datepicker');
                    break;
                }
            }
            return isADate;
        };

        function isBoolean(field) {
            var isABoolean = false;
            for (var i = 0; i < $scope.form[0].items[0].tabs.length; i++) {
                var tab = $scope.form[0].items[0].tabs[i];
                var index = tab.items.findIndex(function (e) { return e.key[0] == field; });
                if (index >= 0) {
                    isABoolean = (tab.items[index].type === 'eggscheckbox');
                    break;
                }
            }
            return isABoolean;
        };

        $scope.getData = function () {
            var payload = {
                page: $scope.params.pageNumber,
                page_size: $scope.params.pageSize,
                code: $scope.params.code,
                description: $scope.params.description,
                show_revision: false,
                sort_fields: ($scope.params.sortFields?$scope.params.sortFields:'surname'),
                sort_order: $scope.params.sortOrder
            };
            var filters = buildFilters();
            recordFactory('human_resource').filter(payload, filters)
                .$promise.then(function (data) {
                    $scope.viewGridOptions.totalItems = data.totalResults;
                    $scope.list.totalResults = data.totalResults;
                    $scope.list.list = data.list;
                    if ($scope.lookupCols.length > 0) {
                        loadLookupCols($scope.list.list);
                    }
                    if ($scope.record.dates.length > 0) {
                        loadDates($scope.list.list);
                    }
                });
        };

        $scope.getAllData = function () {
          var payload = {
            page: 1,
            page_size: $scope.list.totalResults,
            code: $scope.params.code,
            description: $scope.params.description,
            show_revision: false,
            sort_fields: ($scope.params.sortFields?$scope.params.sortFields:'surname'),
            sort_order: $scope.params.sortOrder
          };
          var filters = buildFilters();
          var p = $q.defer();
          recordFactory('human_resource').filter(payload, filters)
            .$promise.then(function (data) {
            if ($scope.record.dates.length > 0) {
              loadDates(data.list);
            }
            if ($scope.lookupCols.length > 0) {
              loadLookupCols(data.list).then(function() { p.resolve(data); });
            } else {
              p.resolve(data);
            }
          });
          return p.promise;
        };

        function buildFilters() {
          var filters = [{
            "column": "t.discriminator",
            "value": "EMP",
            "relation": "=",
            "kind": "string"
          },
            {
              "column": "customer_destination d",
              "value": "t.destination_id = d.id",
              "relation": "JOIN",
              "kind": "d.customer_id"
            }
          ];
          filters = filters.concat($scope.advFilter.list);
          return filters;
        }

        function capitalize(s) {
            return s && s[0].toUpperCase() + s.slice(1);
        };

        $scope.viewDetail = function (value) {
            $location.path('/xversus/employee/detail/' + value.id);
        };

        function getCustomer(id) {
            recordFactory('customer').byId({ id: id })
                .$promise.then(function (data) {
                    $scope.lookup.customer_id.obj = data;
                    $scope.advFilter.filter.customer_id = id;
                });
        };

        // Alcuni utenti possono vedere solo certi reparti, e di conseguenza solo certi clienti (ospedali).
        // In base alle abilitazioni utente, qui creo i filtri per limitare i risultati dei vari elementi della pagina.
        //
        // Pesco tutte le destinazioni abilitate per l'utente (molte lookup vanno filtrate per destination_id)
        // Per ognuna delle destinazioni ottenute, guardo quali sono i diversi customer e i diversi customer_cost_center che posso abilitare all'utente
        //
        function getCustomerFilter(){
            $scope.customerFilter = []; // Filtro da applicare alla lookup sugli ospedali
            $scope.employeeDestinationFilter = []; // Filtro da applicare sulle righe della tabella per filtrare in base alla destinazione
            // Recupero l'elenco delle destinazioni possibili per l'operatore
            var authData = authFactory.getAuthData();
            var customerDestinationQuery = ''; // Query per trovare le customer_destination abilitate per il cliente. Usata per filtrare ospedali e varie lookup.
            var customerCostCenterQuery = ''; // Query da applicare alla lookup dei centri di costo
            var customerQuery = ''; // Query da applicare alla lookup sugli ospedali
            var employeeCustomerQuery = ''; // Query da applicare sulla lookup dei dipendenti
            var employeeDestinationQuery = ''; // Query da applicare sulle righe della tabella
            if(authData && authData.info && authData.info.authorizations){
                authData.info.authorizations.destinations.forEach(function(destinationId){
                    customerDestinationQuery += 'id=' + destinationId + ' OR ';
                    employeeDestinationQuery += 'destination_id=' + destinationId + ' OR ';
                });
            }
            if(customerDestinationQuery.length>0){
                $scope.lockCustomer = true; // Blocco la lookup sull'ospedale finché non ho caricato il filtro
                customerDestinationQuery = customerDestinationQuery.slice(0,-4);
                customerDestinationQuery = '(' + customerDestinationQuery + ')';
                employeeDestinationQuery = employeeDestinationQuery.slice(0,-4);
                employeeDestinationQuery = '(' + employeeDestinationQuery + ')';
                var filter = dbFilterFactory.getCustomFilter(customerDestinationQuery);
                $scope.employeeDestinationFilter = $scope.employeeDestinationFilter.concat(dbFilterFactory.getCustomFilter(employeeDestinationQuery));
                $scope.lookup.destination_id.filter = $scope.lookup.destination_id.filter.concat(dbFilterFactory.getCustomFilter(customerDestinationQuery));
                $scope.lookup.delivery_destination_id.filter = $scope.lookup.delivery_destination_id.filter.concat(dbFilterFactory.getCustomFilter(customerDestinationQuery));
                recordFactory('customer_destination').filter({page_size:10000},filter)
                    .$promise.then(function (data){
                        // Ottengo la lista dei distinti nosocomi
                        var customerIdList = [];
                        data.list.forEach(function(item){
                            if(item.customer_id && customerIdList.indexOf(item.customer_id)==-1){
                                customerIdList.push(item.customer_id);
                            }
                        });
                        // Compongo il filtro per i customer
                        customerIdList.forEach(function(customerId){
                            customerQuery += 'id=' + customerId + ' OR ';
                            employeeCustomerQuery += 'd.customer_id=' + customerId + ' OR ';
                            customerCostCenterQuery += 'customer_id=' + customerId + ' OR ';
                        })
                        if(customerQuery.length>0){
                            customerQuery = customerQuery.slice(0,-4);
                            customerQuery = '(' + customerQuery + ')';
                            employeeCustomerQuery = employeeCustomerQuery.slice(0,-4);
                            employeeCustomerQuery = '(' + employeeCustomerQuery + ')';
                            customerCostCenterQuery = customerCostCenterQuery.slice(0,-4);
                            customerCostCenterQuery = '(' + customerCostCenterQuery + ')';
                            $scope.customerFilter = $scope.customerFilter.concat(dbFilterFactory.getCustomFilter(customerQuery));
                            $scope.lookup.employee_id.filter = $scope.lookup.employee_id.filter.concat(dbFilterFactory.getCustomFilter(employeeCustomerQuery));
                            $scope.lookup.customer_cost_center_id.filter = $scope.lookup.customer_cost_center_id.filter.concat(dbFilterFactory.getCustomFilter(customerCostCenterQuery));
                        }
                        // Sblocco le lookup
                        $scope.lockCustomer = false;
                        $scope.applyFilter();
                    });
            }
        };

        function init() {
            initGridColumns();
            // Se l'utente è abilitato solo a certi ospedali, filtro tutti i dati di conseguenza.
            // Se poi ho in GET l'id di uno specifico nosocomio, filtro solo su quello e blocco la selezione di altri ospedali.
            if ($routeParams.customer) {
                $scope.lockCustomer = true;
                $scope.lookup.employee_id.filter = $scope.lookup.employee_id.filter.concat(dbFilterFactory.getNumberFilter('d.customer_id', parseInt($routeParams.customer)));
                getCustomer(parseInt($routeParams.customer));
            }
            else{
                getCustomerFilter();
            }
        };

        //___ main ___
        init();

    });

/**
 * Created by luca on 15/03/17.
 */

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:IssuePortalCtrl
 * @description
 * # IssuePortalCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/portal/issue', {
        templateUrl: 'plan/portal/issue/issue_list.html',
        controller: 'IssuePortalCtrl'
      })
      .when('/portal/issue/:id', {
        templateUrl: 'plan/portal/issue/issue_detail.html',
        controller: 'IssuePortalCtrl'
      })
  })
  .controller('IssuePortalCtrl', function ($scope, authFactory, $routeParams, $log, $q, $window, baseFactory, notificationFactory,
                                           issueFactory, modelFactory, schemaFactory, modelIconService, $location, toaster,
                                           issueToOdl, uiGridConstants, $timeout, $route, recordFactory, counterFactory, treePlanConfigFactory) {

    /**** CONSTANTS ****/

    var PATH_ISSUE_RECORD = 'issue/record';

    var STABLE = 'stable', SNAP='snap';

    $scope.commissionDependent = true;
    $scope.schemaIssueDefined = false;
    $scope.typeName = 'issue';

    $scope.searchInput = {text: undefined};  // Oggetto che contiene i filtri di ricerca
    $scope.queryParam = '';
    $scope.uiGridFiltersQuery = '';
    $scope.counterNameIssue = 'issue';

    var sortFields;
    var sortDirection;

    var paginationOptions = {
      pageNumber: 1,
      pageSize: 10
    };

    $scope.viewGridOptions = {
      enableSorting: true,
      enableGridMenu: true,
      exporterCsvColumnSeparator: ';',
      exporterSuppressColumns: [ 'id' ],
      exporterMenuPdf: false,
      enableFiltering: true,
      columnDef: [],
      enableColumnResizing: true,
      paginationPageSizes: [10, 15, 20, 30, 40, 50],
      paginationPageSize: 10,
      useExternalPagination: true,
      data: 'issueList.list',
      onRegisterApi: onRegisterApi,
      useExternalFiltering: true,
      multiSelect: true,
      enableRowHeaderSelection: true,
      enableRowSelection: true
    };

    /*** PARTE GESTIONE ALLEGATI ***/

    $scope.attachments = [];
    function readAttachments(modelList){
      $scope.attachments.splice(0,$scope.attachments.length);
      for(var i=0; i<modelList.length; i++){
        $scope.attachments.push(modelList[i]);
      }
    }
    function writeAttachments(modelList){
      modelList.splice(0,modelList.length);
      for(var i=0; i<$scope.attachments.length; i++){
        modelList.push($scope.attachments[i]);
      }
    }
    $scope.updAttachments = function(){
      writeAttachments($scope.data.model.attachments);
      issueFactory(PATH_ISSUE_RECORD).update({id: $scope.data.version}, $scope.data);
    };

    /*** PARTE GRID ***/

    function getColumnOrDefault() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 34,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
        '<div class="ui-grid-cell-contents" style="text-align: center">' +
        '<a ng-href="#/portal/issue/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' +
        '<span class="fa fa-search"></span>' +
        '</a>' +
        '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo',
        field: 'model.type_id.description',
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Asset',
        field: 'model.record_id.description',
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS, //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descrizione',
        field: 'model.description',
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS, //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Stato',
        field: 'status',
        enableFiltering:true,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data Inserimento',
        field: 'date_insertion',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        enableFiltering:false,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data richiesta',
        field: 'date_requested',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        enableFiltering:false,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data presa in carico',
        field: 'date_handling',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        enableFiltering:false,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data chiusura',
        field: 'date_closing',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        enableFiltering:false,
        filters:[{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
    }

    var getPage = function() {
      $scope.viewGridOptions.totalItems = $scope.issueList.totalResults;
      var firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
      $scope.viewGridOptions.data = $scope.viewGridOptions.data.slice(firstRow, firstRow + paginationOptions.pageSize);
    };

    function onRegisterApi(gridApi) {
      $scope.gridApi = gridApi;
      gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
        paginationOptions.pageNumber = newPage;
        paginationOptions.pageSize = pageSize;
        $scope.updatePagination();
      });
      gridApi.core.on.filterChanged($scope, filterChangedCallback);
      gridApi.core.on.sortChanged($scope, sortChangedCallback);
      $scope.gridApi.core.refresh();
    }

    $scope.isSnapshot = function() {
      return $scope.historyMode == SNAP;
    };

    $scope.updatePagination =  function () {
      $scope.getIssueList();
    };

    function sortChangedCallback(scope, sortColumns) {
      console.log(scope);
      console.log(sortColumns);
      sortFields = '';
      sortDirection = '';
      var sep = '';
      sortColumns.forEach(function(col) {
        sortFields += sep + col.field;
        sortDirection += sep + col.sort.direction;
        sep = ',';
      });
      $scope.getIssueList();
    }

    function filterChangedCallback() {
      $scope.uiGridFiltersQuery = {};
      $scope.viewGridOptions.columnDefs.forEach(function(col){
        console.log('filters '+col.filters);
        if (col.filters) {
          col.filters.forEach(function (filter) {
            var term = filter.term;
            var field = col.field;

            if (term && term != '') {
              $scope.uiGridFiltersQuery[field] = '*'+term+'*';
            }
          });
        }
        // Timeout per evitare rimbalzi di chiamate.
        if (angular.isDefined($scope.filterTimeout)) {
          $timeout.cancel($scope.filterTimeout);
        }
        $scope.filterTimeout = $timeout(function () {
          console.log($scope.uiGridFiltersQuery);
          $scope.updatePagination();
        }, 200);
      });
    }

    /*** PARTE ISSUE ***/

    var now = new Date();

    var PORTAL_ISSUE_GENERIC = '/portal/issue';
    var PORTAL_ISSUE_NEW = '/portal/issue/new';
    var PORTAL_ODL_NEW = '/portal/odl/new';

    $scope.data = {
      date_insertion: now,          // data inserimento readonly
      date_requested: undefined,         // le date le tengo ma le metto a null per conformità con il passato...
      date_handling: undefined,
      date_closing: undefined,
      references_assignee: {        // oggetto per contenere i riferimenti a: tecnici, assegnatari, fornitore...
        secretariat_id: undefined,       // segreteria...
        supervisorExternal_id: undefined // responsabile esterno...
      },
      watchers: {
        external: [],
        internal: []
      },
      reporter_id: undefined,            // richiedente: utente loggato...
      model: {
        type_id : undefined,             // tipo asset
        record_id : undefined,           // asset
        attachments: []             // allegati...
      }
    };


    $scope.newIssue = function () {
      $location.path(PORTAL_ISSUE_NEW);
    };

    $scope.refresh = function () {
      $route.reload();
    };

    $scope.back = function () {
      $location.path(PORTAL_ISSUE_GENERIC);
    };

    $scope.sendMessage = function(){
      $location.path('wysiwyg');
    };

    $scope.goToIssueList = function () {
      $location.path(PORTAL_ISSUE_GENERIC, false);
    };

    $scope.goToOdlNew = function () {
      $location.path(PORTAL_ODL_NEW, false);
    };

    $scope.getIssueList = function () {
      var payload = {
        query: $scope.queryParam,
        page: paginationOptions.pageNumber,
        page_size: paginationOptions.pageSize,
        show_revision: false
      };
      issueFactory(PATH_ISSUE_RECORD).search(payload,  $scope.uiGridFiltersQuery).$promise.then(function(data) {
        $scope.issueList = data;
        getPage();
      });
    };

    /* salvataggio della segnalazione, se è nuova -> viene mandata anche la mail, poi si torna nella pagina di lista */
    $scope.update = function () {
      if($scope.data.model.record_id && $scope.data.model.type_id){
        _update().then(
          function (resp) {   // succeeded
            if(resp.model){
              toaster.pop('success', 'Salvataggio riuscito', 'Salvataggio riuscito correttamente per la segnalaz. ' + resp.model.code);
              if($scope.isNew){
                sendMailOpenIssue(resp);
              }
              $scope.goToIssueList();
            }
          },
          function(error) {   // rejected
            toaster.pop('error', 'Errore', 'Errore durante il salvataggio per la segnalaz. inserita ' + error);
          }
        );
      } else{
        toaster.pop('error', 'Errore Inserimento', 'Non sono stati riempiti tutti i campi necessari: Tipo Asset, Asset');
      }
    };


    function _update() {
      if($scope.isNew) { /* se è nuovo */
        return counterFactory.next({code: $scope.counterNameIssue}).$promise.then(function (response) {
          if (response.errors) {
            $scope.errorsRetrievingCounter(response.errors);
            var deferred = $q.defer();
            deferred.reject('Errore nel recupero del contatore per la generazione del codice segnalazione');
            return deferred.promise;
          } else {
            $scope.data.model.code = response.next;
            if (!$scope.data.model.description) {
              $scope.data.model.description = $scope.data.model.code + ' - ' + $scope.data.model.type_id.description + ' - ' + $scope.data.model.record_id.description;
            }
            $scope.data.model.attachments = [];
            writeAttachments($scope.data.model.attachments);
            return issueFactory(PATH_ISSUE_RECORD).create({commissionDependent: $scope.commissionDependent}, $scope.data).$promise;
          }
        });
      } else{
        if(angular.isUndefined($scope.data.model.attachments)){
          writeAttachments($scope.data.model.attachments);
        }
        return issueFactory(PATH_ISSUE_RECORD).update({id: $scope.data.version}, $scope.data).$promise;
      }
    }


    /* funzione per abilitare il tasto 'genera ODL' */
    $scope.show_generate_odl = function(status) {
      return (status == 'OPEN' || status == 'IN_SERVICE');
    };

    /* funzione per generare l'ODL collegato, apre una pipe per inviare i dati */
    $scope.generate_odl = function(){
      issueToOdl.push($scope.data);
      $scope.goToOdlNew();
    };

    $scope.generate_odl_from_list = function(issueId){
      issueFactory(PATH_ISSUE_RECORD).getId({id: issueId}).$promise.then(function (response) {
        if(response){
          issueToOdl.push(response);
          $scope.goToOdlNew();
        }
      });
    };

    $scope.getIssueById = function (itemId) {
      issueFactory(PATH_ISSUE_RECORD + "/_uuid/" + itemId).getUUID().$promise.then(function (response) {
        if(response){
          $scope.data = response;
          // TO FIX: vedere come risolvere la gestione delle date
          if($scope.data.date_insertion != null){ $scope.data.date_insertion = new Date($scope.data.date_insertion);}
          if($scope.data.date_handling != null){ $scope.data.date_handling = new Date($scope.data.date_handling);}
          if($scope.data.date_requested != null){ $scope.data.date_requested = new Date($scope.data.date_requested);}
          if($scope.data.date_closing != null){ $scope.data.date_closing = new Date($scope.data.date_closing);}
          $scope.getNotificationsList();
          if(angular.isUndefined($scope.data.model.attachments)){
            $scope.data.model.attachments = [];
          }
          readAttachments($scope.data.model.attachments);
        }
      });
    };

    function pad(value, char, length) {
      return (value.toString().length < length) ? pad(char+value, char, length):value;
    }

    function setBodyText(notification){
      var model = notification.model;
      if(angular.isDefined(model)){
        var bodyHtml = model.body;
        if(angular.isDefined(bodyHtml)){
          bodyHtml = "<div>" + bodyHtml + "</div>";
          var bodyText = $(bodyHtml).text();
          model.bodyAsText = bodyText;
        }
      }
    }

    /* funzione per costruire il testo della mail, senza stampare valori null o undefined */
    function getText(ref, element){
      if(angular.isDefined(ref) && ref != null){
        if(angular.isDefined(ref[element]) && ref[element] != null){
          return ref[element];
        }
      }
      return '';
    }

    /* funzione per mandare mail AUTOMATICA a segreteria e resp. esterno dopo l'inserimento di una segnalazione */
    function sendMailOpenIssue (responseResultSave) {
      if($scope.data.references_assignee.secretariat_id != null || $scope.data.references_assignee.supervisorExternal_id != null){
        var toList = [];
        var promises = {};
        if($scope.data.references_assignee.secretariat_id){
          promises.secretariat_id =
            recordFactory($scope.data.references_assignee.secretariat_id.type).byUUID({id: $scope.data.references_assignee.secretariat_id.UUID}).$promise;
        }
        if($scope.data.references_assignee.supervisorExternal_id){
          promises.supervisorExternal_id =
            recordFactory($scope.data.references_assignee.supervisorExternal_id.type).byUUID({id: $scope.data.references_assignee.supervisorExternal_id.UUID}).$promise;
        }
        var combinedPromise = $q.all(promises);
        combinedPromise.then(function(responses) {
          if(responses.secretariat_id && responses.secretariat_id.model){
            if(responses.secretariat_id.model['mail']){
              toList.push(responses.secretariat_id.model.mail);
            }
          }
          if(responses.supervisorExternal_id && responses.supervisorExternal_id.model){
            if(responses.supervisorExternal_id.model['mail']){
              toList.push(responses.supervisorExternal_id.model.mail);
            }
          }
          if(toList.length > 0){
            var toListStr = toList.toString();
            var ccListStr = null;
            var subject = 'Apertura segnalazione su ' + $scope.data.model.type_id.description + ' - ' + $scope.data.model.record_id.description;
            var ref = sixObjectLib.recordToHisRef(responseResultSave);
            var httpLink = 'http://'+ $location.$$host +':' + $location.$$port + '/#' + PORTAL_ISSUE_GENERIC + '/' + responseResultSave.UUID;
            var message =
              'Apertura segnalazione su asset: ' + $scope.data.model.type_id.description + ' - ' + $scope.data.model.record_id.description + '\n\n' +
              'codice segnalazione: ' + $scope.data.model.code  + ' , indirizzo: ' + httpLink + '\n\n' +
              'Dati tipo elemento tecnologico: (cod.) '+ getText($scope.data.model.type_id, 'code') + ' - (descr.) ' + getText($scope.data.model.type_id, 'description') + '\n' +
              'Dati elemento tecnologico: (cod.) '+ getText($scope.data.model.record_id, 'code') + ' - (descr.) ' + getText($scope.data.model.record_id, 'description') + '\n' +
              'Tipo segnalazione: ' + getText($scope.data.model.issuetype_id, 'description') + '\n' +
              'Servizio richiesto: ' + getText($scope.data.model.service_id, 'description') + '\n' +
              'Priorità: ' + getText($scope.data.model.priority_id, 'description') + '\n' +
              'Oggetto segnalazione: ' + getText($scope.data.model, 'object') + '\n\n' +
              'Note aggiuntive: ' + getText($scope.data.model, 'notes') + '\n';
            var mail = {
              to:        toListStr,
              cc:        ccListStr,
              subject:   subject,
              body:      message,
              type_mail: 'issue',
              record_id: ref,
              alfresco_attachments: null
            };
            notificationFactory().sendEmail(mail).$promise.then(function() {
              toaster.pop('success', 'Eseguito', 'Email inviata con successo');
            })
          } else {
            toaster.pop('error', 'Errore invio mail', 'Campo destinatari mail vuoto per segreteria e responsabile esterno selezionati');
          }
        });
      } else {
        toaster.pop('error', 'Errore invio mail', 'Campo destinatari mail vuoto per segreteria e responsabile esterno selezionati');
      }
    }

    $scope.getNotificationsList = function() {
      var payload = {
        page: 1,
        pageSize: 10000,
        UUID: $scope.data.UUID,
        index: 'six_issue'
      };
      notificationFactory().getListFiltered(payload)
        .$promise.then(function(data) {
        $scope.notifications = data.list;
        if($scope.notifications != null && !($scope.notifications.isDefined)){
          for(var i=0; i<$scope.notifications.length; i++){
            var notification = $scope.notifications[i];
            setBodyText(notification);
            notification.color = 'b-l-warning';
            notification.href = "#/notification/" + notification.version;
          }
        }
      });
    };

    /* $watch per pulire il campo record quando cancello il tipo */
    $scope.$watch('data.model.type_id', function (newValue, oldValue) {
      if(newValue != oldValue && oldValue != undefined){
        $scope.data.model.record_id = null;
      }
    });

    function initIssue(){ // $scope.data.reporter_id e $scope.data.model.priority_id
      var userFilter = {  'model.username': sixFiltersLib.exact('model.username', authFactory.getAuthData().authId)};
      recordFactory('operatore').search(userFilter).$promise.then(function(resp) {
        if(resp.list || resp.list.length == 1) {
          $scope.data.reporter_id = sixObjectLib.recordToHisRef(resp.list[0]);
        }
      });
      var priorityFilter = {  'model.code': sixFiltersLib.exact('model.code', 'normale')};
      recordFactory('priorita').search(priorityFilter).$promise.then(function(resp) {
        if(resp.list || resp.list.length == 1) {
          $scope.data.model.priority_id = sixObjectLib.recordToHisRef(resp.list[0]);
        }
      });
    }

    function getSchemaIssue(){
      issueFactory('issue/schema').schemaOrDefault().$promise.then(function (response) {
        if(response.model){
          $scope.schemaIssueDefined = true;
          $scope.schema = response.model.schema;
          $scope.form = response.model.form;
        } else{
          $scope.schemaIssueDefined = false;
          $scope.schema = {};
          $scope.form = {};
          toaster.pop('error', 'Errore caricamento pagina', 'Nessun modello salvato per il tipo \'segnalazione\'.');
        }
      });
    }

    /*** PARTE CONFIGURAZIONE ***/

    /* $watch per scaricare la configurazione */
    $scope.$watch('data.model.service_id', function (newValue, oldValue) {
      if(newValue != oldValue && $scope.data.model.type_id && $scope.data.model.record_id){
        // scarico la configurazione...
        var payload = {
          type_id: $scope.data.model.type_id,
          record_id: $scope.data.model.record_id,
          service_id: $scope.data.model.service_id,
          response: {}
        };
        treePlanConfigFactory.getCompleteConfiguration(payload).$promise.then(function (responseConfiguration) {
          if(responseConfiguration.response){
            console.log(responseConfiguration.response);
          }
        });
      }
    });


    /*** PARTE INIZIALIZZAZIONE DELLA PAGINA  ***/

    getSchemaIssue();

    if($routeParams.id) {
      if($routeParams.id != 'new'){
        $scope.isNew = false;
        $scope.getIssueById($routeParams.id);
      } else {
        $scope.isNew = true;
        initIssue();
      }
    } else {
      $scope.getIssueList();
      getColumnOrDefault();
    }



    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'issue/record';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };
  });

/**
 * Created by luca on 16/03/17.
 */

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:OdlPortalCtrl
 * @description
 * # OdlPortalCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/portal/odl', {
        templateUrl: 'plan/portal/odl/odl_list.html',
        controller: 'OdlPortalCtrl'
      })
      .when('/portal/odl/:id', {
        templateUrl: 'plan/portal/odl/odl_detail.html',
        controller: 'OdlPortalCtrl'
      })
  })
  .controller('OdlPortalCtrl', function ($scope, modelFactory, authFactory, odlFactory, notificationFactory, $routeParams, $log, $window, errorService,
                                   modelIconService, $location, treePlanConfigFactory, taskFactory, issueFactory, lookupFactory, dialogService, ngDialog,
                                   toaster, $filter, issueToOdl, uiGridConstants, $timeout, $route, counterFactory, userFactory, recordFactory, $q) {
    /**** CONSTANTS ****/

    var currentCommission = authFactory.getAuthData().info.commissions.current;

    $scope.counterNameOdl = 'odl';

    $scope.odlRef = null;
    $scope.queryParam = '';
    $scope.uiGridFiltersQuery = '';

    $scope.loadingSixMail = true;

    $scope.commissionDependent = true;

    $scope.schemaOdlDefined = false;

    $scope.typeName = 'odl';

    $scope.issue = {}; /* ci salvo tutto il dato della segnalazione a cui faccio riferimento */

    $scope.notifications = [];
    $scope.popupRequested = { opened: false};

    $scope.bool = {
      allOdl: true,
      hidePlan: false
    };

    $scope.odlList = {list: []};

    $scope.params = {
      pageNumber: 1,
      pageSize: 100,
      filters: {}
    };

    $scope.autoResizeParams = {
      enabled: true,
      minHeight: 200,
      marginTop: 290
    };


    // Gestione allegati
    $scope.attachments = [];
    function readAttachments(modelList){
      $scope.attachments.splice(0,$scope.attachments.length);
      for(var i=0; i<modelList.length; i++){
        $scope.attachments.push(modelList[i]);
      }
    }
    function writeAttachments(modelList){
      modelList.splice(0,modelList.length);
      for(var i=0; i<$scope.attachments.length; i++){
        modelList.push($scope.attachments[i]);
      }
    }

    /**  VARIABILI  **/

    $scope.bool_watch_internal = true;
    $scope.bool_watch_external = false;
    $scope.watcher = {  user: '', mail: ''};

    $scope.issueRefreshed = {
      bool: false,
      filter: {}
    };

    $scope.init = true;   // per prima inizializzazione controller (altrimenti si incasina la watch su $scope.data.model.type_id che pulisce $scope.data.model.record_id)


    /*** PARTE ODL ***/

    var now = new Date();

    $scope.data = {
      status: 'OPEN',
      generated_by: 'issue',
      issue_id: undefined,         // riferimento alla segnalazione: type, UUID, code, description
      date_insertion: now,
      date_requested: now,    // data richiesta: ??? non so se tenerla così o se metterla a null ???
      date_handling: now,     // ??? non so se tenerla così o se metterla a null ???
      date_closing: undefined,     // data chiusura
      references_assignee: {  // oggetto per contenere i riferimenti a: tecnici, assegnatari, fornitore...
        supplier_id: undefined,    // Fornitore
        company_id: undefined,     // Azienda assegnataria
        headmanCommission_id: undefined,   // Capo commessa
        technicianCommission_id: [],  // Tecnico di commessa
        maintainer_id: [],            // Manutentori
        supervisorExternal_id: undefined,  // Responsabile esterno
        supervisorInternal_id: undefined   // Responsabile interno
      },
      watchers: {
        external: [],
        internal: []
      },
      model: {
        attachments: []
      }
    };

    /** VARIABILI FILTRAGGIO LOOK UP */

    $scope.technicianCommissionFilter = { 'model.typeoperator' : 'tecnico_commessa' };
    $scope.headmanCommissionFilter = { 'model.typeoperator' : 'capo_commessa' };
    $scope.supervisorExternalFilter = { 'model.typeoperator' : 'tecnico_esterno' };
    $scope.supervisorInternalFilter = { 'model.typeoperator' : 'tecnico_commessa' };
    $scope.maintainerFilter = { 'model.typeoperator' : 'manutentore' };
    $scope.companyFilter = {};
    $scope.supplierFilter = {};

    $scope.configurationOdl = {}; /* oggetto per salvare la configurazione corrente definita sul tree */

    /** PARTE PER LA LOOKUP MULTIPLA SUGLI ASSEGNATARI  */
    $scope.technicianCommissionList = [];
    $scope.technicianCommissionListEffective = [];


    function operatorNotSelected (lookUpRef) {
      var bool = true;
      for(var i = 0; $scope.data.references_assignee.technicianCommission_id && i < $scope.data.references_assignee.technicianCommission_id.length; i++){
        if($scope.data.references_assignee.technicianCommission_id[i].UUID == lookUpRef.UUID){
          bool = false;
        }
      }
      return bool;
    }

    $scope.getTechnicianCommissionList = function () {
      $scope.technicianCommissionList = [];
      $scope.technicianCommissionListEffective = [];
      var query = {query: "", history: false};
      if(angular.isDefined($scope.technicianCommissionFilter)){
        lookupFactory('/six-data-set/api/','record/operatore/_lookup').search(query, $scope.technicianCommissionFilter).$promise.then(function(resp) {
          if(angular.isDefined(resp) && resp.hasOwnProperty('list')) {
            for(var i = 0; i < resp.list.length; i++){
              var operatorLookUp = formattedLookUpOperator(resp.list[i]);
              $scope.technicianCommissionList.push(operatorLookUp);
              if(operatorNotSelected(operatorLookUp)){
                $scope.technicianCommissionListEffective.push(operatorLookUp);
              }
            }
          }
        });
      }
    };

    $scope.getTechnicianCommissionList();


    $scope.viewGridOptions = {
      enableSorting: true,
      enableGridMenu: true,
      exporterCsvColumnSeparator: ';',
      exporterSuppressColumns: [ 'id', 'timeline' ],
      exporterMenuPdf: false,
      enableFiltering: true,
      enableColumnResizing: true,
      paginationPageSizes: [100, 250, 500, 1000, 10000],
      paginationPageSize: 100,
      useExternalPagination: true,
      useExternalFiltering: true,
      multiSelect: true,
      enableRowHeaderSelection: true,
      enableRowSelection: true,
      enableHorizontalScrollbar: 1
    };

    $scope.newOdl = function () {
      $location.path('/portal/odl/new');
    };

    $scope.refresh = function () {
      $scope.getCurrentUserOdlList();
    };

    $scope.goToOdlList = function () {
      $location.path('/portal/odl');
    };

    $scope.goToIssue = function () {
      $location.path('/portal/issue/'+$scope.data.issue_id.UUID);
    };

    $scope.openRequestedPicker = function(){
      $scope.popupRequested.opened = true;
    };

    $scope.getColumns = function(){
      getColumnOrDefault();
      return $scope.columnDefs;
    };

    function getColumnOrDefault() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 34,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
        '<div class="ui-grid-cell-contents" style="text-align: center">' +
        '<a ng-href="#portal/odl/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' +
        '<span class="fa fa-search"></span>' +
        '</a>' +
        '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice ODL',
        field: 'model.code',
        enableFiltering:true,
        width: 150,
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Titolo',
        field: 'model.title',
        enableFiltering:true,
        width: 300,
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo asset',
        field: 'model.type_id.description',
        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.model.type_id.description}} - {{row.entity.model.type_id.code}}</div>',
        enableFiltering:true,
        width: 150,
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Asset',
        field: 'model.record_id.description',
        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.model.record_id.description}} - {{row.entity.model.record_id.code}}</div>',
        enableFiltering:true,
        width: 150,
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS, //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descrizione',
        field: 'model.description',
        enableFiltering:true,
        width: 500,
        cellTooltip: function(row) {
          return row.entity.model.description;
        },
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Stato',
        field: 'status',
        enableFiltering:true,
        width: 100,
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data generazione',
        field: 'dataIn',
        type: 'date',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        width: 100,
        enableFiltering:true,
        filters: [
          {
            type: 'date',
            relation: 'gte',
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: 'date',
            relation: 'lte',
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data pianifica',
        field: 'date_requested',
        type: 'date',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        width: 100,
        enableFiltering:true,
        filters: [
          {
            type: 'date',
            relation: 'gte',
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          },
          {
            type: 'date',
            relation: 'lte',
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }
        ]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Utente generazione',
        field: 'user',
        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.user}}</div>',
        enableFiltering:true,
        width: 200,
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });

      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice generazione programmata',
        field: 'model.generation_tag',
        enableFiltering:true,
        width: 150,
        filters:[{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Timeline',
        field: 'timeline',
        width: 106,
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
        '<div class="ui-grid-cell-contents" style="vertical-align:middle;text-align:center;">' +
        '<a ng-href="#/timeline/odl/record/{{row.entity.UUID}}">' +
        '<button type="button" class="btn btn-xs btn-primary">' +
        '<i class="fa fa-history"></i>' +
        '</button>' +
        '</a>' +
        '</div>'
      });
    }

    // function getQuery(){
    //   var separator;
    //   if (!$scope.queryParam || $scope.queryParam.trim() == ''||
    //     !$scope.uiGridFiltersQuery || $scope.uiGridFiltersQuery == '') {
    //     separator = '';
    //   }else{
    //     separator = ' & ';
    //   }
    //   if($scope.uiGridFiltersQuery.includes("asset_description")){
    //      var firstSeparator = $scope.uiGridFiltersQuery.indexOf("&");
    //      if(firstSeparator==-1){
    //         var recordQuery = $scope.uiGridFiltersQuery.replace("asset_description", "record_id.description");
    //         var parentQuery = $scope.uiGridFiltersQuery.replace("asset_description", "parent_record_id.description");
    //         $scope.uiGridFiltersQuery = recordQuery;
    //      }
    //      else{
    //         var descriptionQuery = $scope.uiGridFiltersQuery.substring(0, firstSeparator);
    //         var remainingQuery = $scope.uiGridFiltersQuery.substring(firstSeparator, $scope.uiGridFiltersQuery.length);
    //         descriptionQuery = descriptionQuery.trim();
    //         var recordQuery = descriptionQuery.replace("asset_description", "record_id.description");
    //         var parentQuery = descriptionQuery.replace("asset_description", "parent_record_id.description");
    //         $scope.uiGridFiltersQuery = recordQuery + " " + remainingQuery;
    //      }
    //   }
    //   var q = $scope.queryParam + separator + $scope.uiGridFiltersQuery;
    //   console.log(q);
    //   return q;
    // }

    $scope.getCurrentUserOperator = function() {
      $scope.currentUserOperator = undefined;
      var currentUser = authFactory.getAuthData().authId;
      var filters = {};
      filters['model.username'] = {
        type: '_exact',
        key: 'model.username',
        value: currentUser
      };
      return recordFactory('operatore').search({page_size: 1, show_revision: false}, filters).$promise.then(function(data) {
        if(errorService.handleError(data) && data.list && data.list.length > 0) {
          $scope.currentUserOperator = data.list[0];
        } else {
          toaster.pop('error', 'Errore', 'Operatore corrispondente all\'utente \''+ currentUser +'\' non trovato');
        }
        return $scope.currentUserOperator;
      });
    };

    $scope.getCurrentUserOdlList = function() {
      if(!$scope.currentUserOperator || !$scope.currentUserOperator.UUID) {
        $scope.getCurrentUserOperator().then(function(operator) {
          $scope.getOdlList();
        })
      } else {
        $scope.getOdlList();
      }
    };

    $scope.getOdlList = function () {
      var filters = angular.copy($scope.params.filters);
      if($scope.currentUserOperator && $scope.currentUserOperator.UUID && !$scope.bool.allOdl) {
        filters['user'] = {
          type: '_exact',
          key: 'user',
          value: $scope.currentUserOperator.model.username,
          constraint: 'or'
        };
        filters['references_assignee.headmanCommission_id.UUID'] = {
          type: '_exact',
          key: 'references_assignee.headmanCommission_id.UUID',
          value: $scope.currentUserOperator.UUID,
          constraint: 'or'
        };
        filters['references_assignee.technicianCommission_id.UUID'] = {
          type: '_in',
          key: 'references_assignee.technicianCommission_id.UUID',
          value: $scope.currentUserOperator.UUID,
          constraint: 'or'
        };
        filters['references_assignee.maintainer_id.UUID'] = {
          type: '_in',
          key: 'references_assignee.maintainer_id.UUID',
          value: $scope.currentUserOperator.UUID,
          constraint: 'or'
        };
        filters['references_assignee.supervisorInternal_id.UUID'] = {
          type: '_exact',
          key: 'references_assignee.supervisorInternal_id.UUID',
          value: $scope.currentUserOperator.UUID,
          constraint: 'or'
        };
        filters['references_assignee.supervisorExternal_id.UUID'] = {
          type: '_exact',
          key: 'references_assignee.supervisorExternal_id.UUID',
          value: $scope.currentUserOperator.UUID,
          constraint: 'or'
        };
      }

      if($scope.bool.hidePlan) {
        filters['generated_by'] = {
          type: '_not',
          key: 'generated_by',
          value: 'plan'
        };
      } else {
        delete filters['generated_by'];
      }

      odlFactory().search({//query:getQuery(),
        page: $scope.params.pageNumber, page_size: $scope.params.pageSize, show_revision: false,
        hide_plan: $scope.bool.hidePlan, commission: currentCommission.code}, filters).$promise.then(function(data) {
        $scope.odlList.totalResults = data.totalResults;
        $scope.odlList.list = data.list;
      });
    };

    $scope.validate = function () {
      if($scope.data.generated_by == 'issue'){
        var form = document.forms['detailForm'];
        if (form) {
          $scope.$broadcast('schemaFormValidate');
          setTimeout(function () {
            var invElements = angular.element(form.getElementsByClassName("ng-invalid"));
            if (invElements.length > 0) {
              toaster.pop('error', 'Errore', 'Dati obbligatori mancanti.');
            }
            else {
              $scope.update();
            }
          }, 500);
        }
      } else if ($scope.data.generated_by == 'plan') {
        // per ora non faccio nessun controllo sugli odl che arrivano dalla PIANIFICATA...
      }
    };

    $scope.update = function () {
      if($scope.data.model.record_id && $scope.data.model.type_id){
        _update().then(
          function (resp) {   // succeeded
            if(resp.model){
              $scope.data = resp;
              toaster.pop('success', 'Salvataggio riuscito', 'Salvataggio riuscito correttamente per l\'odl ' + $scope.data.model.code);
              if($scope.isNew){
                sendMailOpenOdl(resp);
              }
            }
          },
          function(error) {   // rejected
            toaster.pop('error', 'Errore', 'Errore durante il salvataggio per l\'odl inserito ' + error);
          }
        );
      } else{
        toaster.pop('error', 'Errore Inserimento', 'Non sono stati riempiti tutti i campi necessari: Tipo Asset, Asset');
      }
    };


    function _update() {
      if($scope.isNew) { /* se è nuovo */
        return counterFactory.next({code: $scope.counterNameOdl}).$promise.then(function (response) {
          if (response.errors) {
            $scope.errorsRetrievingCounter(response.errors);
            var deferred = $q.defer();
            deferred.reject('Errore nel recupero del contatore per la generazione del codice dell\'odl');
            return deferred.promise;
          } else {
            $scope.data.model.code = response.next;
            if (!$scope.data.model.description) {
              $scope.data.model.description = $scope.data.model.code + ' - ' + $scope.data.model.type_id.description + ' - ' + $scope.data.model.record_id.description;
            }
            $scope.data.model.attachments = [];
            writeAttachments($scope.data.model.attachments);
            return odlFactory().createOdl({commissionDependent: $scope.commissionDependent}, $scope.data).$promise;
          }
        });
      } else {
        if(angular.isUndefined($scope.data.model.attachments)){
          writeAttachments($scope.data.model.attachments);
        }
        return odlFactory().updateOdl({id: $scope.data.version}, $scope.data).$promise;
      }
    }

    $scope.updAttachments = function(){
      writeAttachments($scope.data.model.attachments);
      if($scope.isNew){
        odlFactory().createOdl({commissionDependent: $scope.commissionDependent}, $scope.data).$promise.then(function () {
          $log.info('saving: '+$scope.version);
        });
      } else{
        odlFactory().updateOdl({id: $scope.data.version}, $scope.data).$promise.then(function () {
          $log.info('updating id: '+$scope.data.version);
        });
      }
    };

    $scope.delete = function (idToDelete) {
      dialogService.confirmDialog('Eliminare l\'ODL?',
        function () {
          $log.info('deleting id:' + idToDelete);
          if (($scope.data.generated_by == 'plan') && (angular.isDefined($scope.data.model.parent_record_id))) {
            odlFactory().deletePlanOdl({id: idToDelete}).$promise.then(function () {
              $scope.getOdlList();
              $location.path('/portal/odl', false);
            });
          }
          else {
            odlFactory().deleteIssueOdl({id: idToDelete}).$promise.then(function () {
              $scope.getOdlList();
              $location.path('/portal/odl', false);
            });
          }
        }
      );
    };

    $scope.getOdlById = function (itemUUID) {
      if(itemUUID == 'new'){
        $scope.isNew = true;
        getSchemaOdl();
        getCurrentUser($scope.data.user);
        counterFactory.current({code: $scope.counterNameOdl}).$promise.then(function (response) {
          if (response.errors){
            $scope.errorsRetrievingCounter(response.errors);
            $window.history.back();
            return;
          }
          $scope.data.model.code = (parseInt(response.current)+1).toString();
        });
      } else{
        $scope.isNew = false;
        odlFactory().getOdlByUUID({uuid: itemUUID}).$promise.then(function (response) {
          if(response){
            $scope.data = response;
            /* ho cambiato la posizione per ottenere lo schema dell'odl altrimenti non si riusciva ad inizializzare la lookup */
            getSchemaOdl();
            getCurrentUser($scope.data.user);

            $scope.currentOdlRef = sixObjectLib.recordToHisRef($scope.data);
            /** TO FIX: vedere come risolvere la gestione delle date */
            if($scope.data.date_requested){ $scope.data.date_requested = new Date($scope.data.date_requested);}
            if($scope.data.date_insertion){ $scope.data.date_insertion = new Date($scope.data.date_insertion);}
            if($scope.data.date_handling){ $scope.data.date_handling = new Date($scope.data.date_handling);}
            if($scope.data.date_closing){ $scope.data.date_closing = new Date($scope.data.date_closing);}
            $scope.getNotificationsList();

            if(angular.isUndefined($scope.data.model.attachments)){
              $scope.data.model.attachments = [];
            }
            readAttachments($scope.data.model.attachments);
          }
        });
      }
    };

    function getCurrentUser(userInfo){
      var userFilter = {};
      if(userInfo){
        userFilter = {  'model.username': sixFiltersLib.exact('model.username', userInfo)};
      } else {
        userFilter = {  'model.username': sixFiltersLib.exact('model.username', authFactory.getAuthData().authId)};
      }
      recordFactory('operatore').search(userFilter).$promise.then(function(resp) {
        if(resp.list || resp.list.length == 1) {
          $scope.cacheVariable = {  loggedUser: sixObjectLib.recordToHisRef(resp.list[0]) };
        }
      });
    }

    function getSchemaOdl() {
      odlFactory().getOdlSchema().$promise.then(function (response) {
        if(response.model){
          $scope.schemaOdlDefined = true;
          $scope.schema = response.model.schema;
          $scope.form = response.model.form;
        } else{
          $scope.schemaOdlDefined = false;
          $scope.schema = {};
          $scope.form = {};
          toaster.pop('error', 'Errore caricamento pagina', 'Nessun modello salvato per il tipo \'odl\'.');
        }
      });
    }

    $scope.massiveClosingOdl = function() {
      var odlList = $scope.params.gridApi.selection.getSelectedRows();
      if(odlList && odlList.length > 0) {
        var dateClosingDialog = ngDialog.openConfirm({
          name: 'dateClosingDialog',
          closeByDocument: false,
          showClose: true,
          template: '' +
          '<div style="text-align:center"><i class="fa fa fa-calendar"></i> Inserire la data di chiusura</div><br>' +
          '<div style="text-align:left">' +
          ' da calendario:' +
          '<input class="form-control" id="input_dialog_date" type="date" ng-model="date">' +
          '</div>' +
          '<div style="text-align:left">' +
          ' o da num. giorni lavorativi:' +
          '<input class="form-control" id="input_dialog_days" type="number" ng-model="days">' +
          '</div>' +
          '<div style="text-align:center">' +
          '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm()">OK</button>' +
          '</div>',
          plain: true,
          className: 'ngdialog-theme-default ngdialog-theme-custom'
        });

        dateClosingDialog.then(
          function () { // success
            var type = '';
            var value = null;
            if (document.getElementById("input_dialog_date").value) {
              value = document.getElementById("input_dialog_date").value;
              type = 'date';
            }
            if (document.getElementById("input_dialog_days").value) {
              value = document.getElementById("input_dialog_days").value;
              type = 'days';
            }
            var daysVar = null;
            var dateVar = null;
            if (type == 'days') {
              daysVar = parseInt(value);
            }
            if (type == 'date') {
              dateVar = new Date(value);
            }
            var payload = {
              odlList: odlList,
              typeClosingOdl: type,
              daysClosingValue: daysVar,
              dateClosingValue: dateVar
            };
            odlFactory().bulkClose(payload).$promise.then(function (data) {
              if (errorService.handleError(data)) {
                if (data.hasErrors || data.hasWarnings) {
                  dialogService.serviceResponse('Esito', data, false);
                }
              }
              $scope.getOdlList();
            });
          },
          function (resp) {}   // reject
        );
      } else {
        toaster.pop('warning', 'Nessuna selezione', 'Nessun ODL selezionato');
      }
    };


    function setBodyText(notification){
      var model = notification.model;
      if(angular.isDefined(model)){
        var bodyHtml = model.body;
        if(angular.isDefined(bodyHtml)){
          bodyHtml = "<div>" + bodyHtml + "</div>";
          var bodyText = $(bodyHtml).text();
          model.bodyAsText = bodyText;
        }
      }
    }

    $scope.getNotificationsList = function() {
      var payload = {
        page: 1,
        pageSize: 10000,
        UUID: $scope.data.UUID,
        //index: 'six_odl',
        typeNotification: 'odl',
        list: null
      };
      notificationFactory().getListFiltered(payload).$promise.then(function(data) {
        $scope.notifications = data.list;
        if($scope.notifications) {
          for (var i = 0; i < $scope.notifications.length; i++) {
            var notification = $scope.notifications[i];
            setBodyText(notification);
            notification.color = 'b-l-warning';
            notification.href = "#/notification/" + notification.version;
          }
        }
      });
    };

    $scope.showAssetsList = function(){
      if(angular.isUndefined($scope.assetsList)){
        var payload = {
          page: 1,
          pageSize: 10000,
          code: $scope.data.model.code,
          sortFields: "model.record_id.description",
          sortDirections: "asc",
          id: $scope.data.model.code
        };
        odlFactory().getAssetsList(payload)
          .$promise.then(function(data) {
          $scope.assetsList = data.list;
        });
      }
    };


    /* $watch per popolare i campi dipendenti dalla segnalazione */
    $scope.$watch(function() { return $scope.data.issue_id }, function(newVal, oldVal) {
      $scope.issue = undefined;
      if(angular.isDefined(newVal) && newVal != null) {
        issueFactory("issue/record/_uuid/" + $scope.data.issue_id.UUID).getUUID().$promise.then(function (response) {
          if(angular.isDefined(response.model)){
            $scope.issue = response;
            $scope.issueRefreshed.bool = true;
            if($scope.issue.date_requested){ $scope.issue.date_requested = new Date($scope.issue.date_requested);}
            if($scope.issue.date_insertion){ $scope.issue.date_insertion = new Date($scope.issue.date_insertion);}
            if($scope.issue.date_handling){ $scope.issue.date_handling = new Date($scope.issue.date_handling);}
            if($scope.issue.date_closing){ $scope.issue.date_closing = new Date($scope.issue.date_closing);}
            if($scope.issue.date_handling != null){
              $scope.data.date_insertion = $scope.issue.date_handling;
            }
            $scope.data.model.type_id = $scope.issue.model.type_id;
            $scope.data.model.record_id = $scope.issue.model.record_id;
            $scope.data.model.service_id = $scope.issue.model.service_id;
            $scope.data.model.priority_id = $scope.issue.model.priority_id;
            $scope.data.model.activity_id = $scope.issue.model.activity_id;
            $scope.data.model.odltype_id = $scope.issue.model.issuetype_id;
            $scope.data.model.description = $scope.issue.model.object;
          }
        });
      }
    });

    $scope.$watch('issueRefreshed.bool' , function (newVal, oldVal) {
      if(newVal != oldVal) {
        if(newVal == true) {
          odlFactory().getIssueNotAssigned().$promise.then(function(data) {
            if (errorService.handleError(data)) {
              if (data.hasErrors || data.hasWarnings) {
                dialogService.serviceResponse('Esito', data, false);
              }
            }
            if(data.result){
              if(data.result.length > 0) {
                delete $scope.issueRefreshed.filter;
                var filterStr = '';
                angular.forEach(data.result, function(value) {
                  if(value.UUID){
                    if(filterStr == ''){
                      filterStr = value.UUID;
                    } else {
                      filterStr = filterStr + ', ' + value.UUID;
                    }
                  }
                });
                $scope.issueRefreshed.filter = {'UUID' : filterStr}
              }
            }
          });
        } else {
          $scope.issueRefreshed.filter = {};
        }
      }
    });

    $scope.$watch('data.model.type_id', function (newVal, oldVal) {
      if(newVal != oldVal && $scope.issueRefreshed.bool == false && $scope.init !== true){
        $scope.data.model.record_id = null;
      }
      if(newVal) {
        $scope.init = false;  // prima inizializzazione eseguita
      }
      $scope.issueRefreshed.bool = false;
    });

    $scope.getConfiguration = function () {
      if($scope.data.model.type_id && $scope.data.model.record_id && $scope.data.model.service_id) {
        var payload = {
          type_id: $scope.data.model.type_id,
          record_id: $scope.data.model.record_id,
          service_id: $scope.data.model.service_id,
          response: {}
        };
        treePlanConfigFactory.getCompleteConfiguration(payload).$promise.then(function (data) {
          if (data.response != null) {
            toaster.pop('success', 'Successo', 'Caricamento configurazione associata effettuato');
            $scope.configurationOdl = data.response;
          }
        });
      } else {
        toaster.pop('error', 'Errore', 'Controllare i valori tipo asset, asset e servizio');
      }
    };

    if($routeParams.id) {
      $scope.issue = issueToOdl.pop();
      if(angular.isDefined($scope.issue)) {
        $scope.data.issue_id = sixObjectLib.recordToHisRef($scope.issue);
      }
      $scope.getOdlById($routeParams.id);
    } else {
      $scope.getColumns();
    }



    /******** gestione timeline **************/

    $scope.modelDataInTimeline = {};
    $scope.schemaDataInTimeline = {};
    $scope.formDataInTimeline = {};
    $scope.timeline = [];
    $scope.entity = 'odl/record';

    $scope.getTimeline = function () {
      if (angular.isDefined($scope.entity) && angular.isDefined($scope.data.UUID)) {
        $scope.buildTimeline($scope.entity, $scope.data.UUID);
      }
    };

    $scope.buildTimeline = function (entity, UUID, version) {
      $scope.entity = entity;
      $scope.timeline = odlFactory().getTimeline({id: UUID}).$promise.then(function (data) {
        $scope.timeline = data.list;
        if (angular.isDefined(version)) {
          $scope.modelDataInTimeline['version'] = version;
        }
      });
    };

    $scope.getModelDetail = function (version) {
      odlFactory().getOdlById({id: version}).$promise.then(function (data) {
        $scope.currentDataInTimeline = data;
        $scope.modelDataInTimeline.version = data.version;
        if(angular.isUndefined(data.dataOut) || data.dataOut==null){
          data.dataOut = "_current";
        }
        console.log('type -> schema, UUID -> '+$scope.schema.UUID);
        odlFactory().getSchemaInTimeline({id: $scope.schema.UUID, param1: data.dataOut}).$promise.then(function (response) {
          if(response.model){
            $scope.showDetail = true;
            $scope.schemaDataInTimeline = response.model.schema;
            $scope.formDataInTimeline = response.model.form;
          }
        });
      });
    };



    /******** funzioni di utility ***********/

    $scope.getMessage = function () {   /* creazione testo mail */
      var searchInit = {
        search: {  obj: {'username':authFactory.getAuthData().authId}  },
        init: { authId: true,  email: true }
      };
      if(angular.isDefined($scope.data.model.type_id) && angular.isDefined($scope.data.model.record_id)){
        var promiseMailReceiver = notificationFactory().getMailReceiver($scope.data).$promise;
        var promiseMailUser = userFactory.getMail(searchInit).$promise;
        $scope.loadingSixMail = true;

        Promise.all([promiseMailReceiver, promiseMailUser]).then(function (response) {  // response[0] = promiseMailReceiver, response[1] = promiseMailUser
          $scope.loadingSixMail = false;
          $scope.objMail = {
            title: 'Apertura ordine di lavoro su asset: ' + $scope.data.model.type_id.description + ' - ' + $scope.data.model.record_id.description,
            to: formatMailReceiver(response[0]),
            cc: formatMailCc(response[1].list[0].email),
            message: 'Apertura ordine di lavoro su asset: ' + $scope.data.model.type_id.description + ' - ' + $scope.data.model.record_id.description +'\n' +
            'codice odl: ' + getText($scope.data.model, 'code') + '\n\n' +
            'Dati tipo elemento tecnologico: (cod.) '+ getText($scope.data.model.type_id, 'code') + ' - (descr.) ' + getText($scope.data.model.type_id, 'description') + '\n' +
            'Dati elemento tecnologico: (cod.) '+ getText($scope.data.model.record_id, 'code') + ' - (descr.) ' + getText($scope.data.model.record_id, 'description') + '\n' +
            'Segnalazione di riferimento: (cod.) ' + getText($scope.data.issue_id, 'code') + ' - (descr.) ' + getText($scope.data.issue_id, 'description') + '\n' +
            'Titolo: ' + getText($scope.data.model, 'description') + '\n\n' +
            'Tipo ordine di lavoro: ' + getText($scope.data.model.odltype_id, 'description') + '\n' +
            'Servizio richiesto: ' + getText($scope.data.model.service_id, 'description') + '\n' +
            'Priorità: ' + getText($scope.data.model.priority_id, 'description') + '\n'
          }
        });
      } else {
        toaster.pop('error', 'Errore', 'Creazione della mail precompilata non riuscita.');
      }
    };

    function pad(value, char, length) {
      return (value.toString().length < length) ? pad(char+value, char, length):value;
    }


    /* funzione per mandare mail automatica a segreteria e resp. esterno dopo l'inserimento di una segnalazione */
    function sendMailOpenOdl (responseResultSave) {
      // la mail di apertura deve essere mandata in automatico ai watchers... da vedere come saranno poi definiti sul dato
      if(true){
        var toList = [];
        var promises = {};
        // devo controllare tutti i campi dei watchers e poi lanciare X promises
        if(responseResultSave.references_assignee.supplier_id){
          promises.supplier_id = recordFactory(responseResultSave.references_assignee.supplier_id.type)
            .byUUID({id: responseResultSave.references_assignee.supplier_id.UUID}).$promise;
        }
        var combinedPromise = $q.all(promises);
        combinedPromise.then(function(responses) {
          if(responses.supplier_id && responses.supplier_id.model){
            if(responses.supplier_id.model['mail']){ toList.push(responses.supplier_id.model.mail);}
          }
          if(toList.length > 0){
            var toListStr = toList.toString();
            var ccListStr = null;
            var subject = 'Apertura ordine di lavoro su ' + responseResultSave.model.type_id.description + ' - ' + responseResultSave.model.record_id.description;
            var ref = sixObjectLib.recordToHisRef(responseResultSave);
            var httpLink = 'http://'+ $location.$$host +':' + $location.$$port + '/#' + '/portal/odl' + '/' + responseResultSave.UUID;
            var message =
              'Apertura ordine di lavoro su asset: ' + responseResultSave.model.type_id.description + ' - ' + responseResultSave.model.record_id.description + '\n\n' +
              'codice odl: ' + responseResultSave.model.code  + ' , indirizzo odl: ' + httpLink + '\n\n' +
              'Dati tipo elemento tecnologico: (cod.) '+ getText(responseResultSave.model.type_id, 'code') + ' - (descr.) ' + getText(responseResultSave.model.type_id, 'description') + '\n' +
              'Dati elemento tecnologico: (cod.) '+ getText(responseResultSave.model.record_id, 'code') + ' - (descr.) ' + getText(responseResultSave.model.record_id, 'description') + '\n' +
              'Segnalazione di riferimento: (cod.) ' + getText(responseResultSave.issue_id, 'code') + ' - (descr.) ' + getText(responseResultSave.issue_id, 'description') + '\n' +
              'Titolo: ' + getText(responseResultSave.model, 'description') + '\n\n' +
              'Tipo ordine di lavoro: ' + getText(responseResultSave.model.odltype_id, 'description') + '\n' +
              'Servizio richiesto: ' + getText(responseResultSave.model.service_id, 'description') + '\n' +
              'Priorità: ' + getText(responseResultSave.model.priority_id, 'description') + '\n';
            var mail = {
              to:        toListStr,
              cc:        ccListStr,
              subject:   subject,
              body:      message,
              type_mail: 'odl',
              record_id: ref,
              alfresco_attachments: null
            };
            notificationFactory().sendEmail(mail).$promise.then(function() {
              toaster.pop('success', 'Eseguito', 'Email inviata con successo');
              $location.path('/portal/odl/'+responseResultSave.UUID); // così fa schifo... con calma lo tolgo...
            })
          } else {
            toaster.pop('error', 'Errore invio mail', 'Campo destinatari mail vuoto');
            $location.path('/portal/odl/'+responseResultSave.UUID); // così fa schifo... con calma lo tolgo...
          }
        });
      } else {
        toaster.pop('error', 'Errore invio mail', 'Campo destinatari mail vuoto');
        $location.path('/portal/odl/'+responseResultSave.UUID); // così fa schifo... con calma lo tolgo...
      }
    }

    $scope.setBoolWatchInternal = function (){
      $scope.bool_watch_internal = true;
      $scope.bool_watch_external = false;
    };

    $scope.setBoolWatchExternal = function (){
      $scope.bool_watch_internal = false;
      $scope.bool_watch_external = true;
    };

    $scope.addWatcher = function () {
      if($scope.bool_watch_internal){ /* se è interno */
        if($scope.watcher.user != null && include($scope.data.watchers.internal, $scope.watcher.user) == false){
          $scope.data.watchers.internal.push($scope.watcher.user);
        }
        $scope.watcher.user = null;
      } else if ($scope.bool_watch_external){ /* se è esterno */
        if($scope.watcher.mail != null){
          $scope.data.watchers.external.push($scope.watcher.mail);
        }
        $scope.watcher.mail = null;
      }
    };

    $scope.addWatcherFromLookUp = function (lookUp) {
      if(angular.isDefined(lookUp) && lookUp != null){
        if(angular.isArray(lookUp)) {
          for(var i = 0; i < lookUp.length; i++){
            copyInWatchers(lookUp[i]);
          }
        } else {
          copyInWatchers(lookUp);
        }
      }
    };

    $scope.addAllTechnicianCommissionFromLookUp = function (lookup) {
      for(var i = 0; i < $scope.data.references_assignee.technicianCommission_id.length; i++){
        copyInWatchers($scope.data.references_assignee.technicianCommission_id[i]);
      }
    };

    $scope.deleteWatcher = function (array, toDelete){
      var index = array.indexOf(toDelete);
      if (index > -1) {
        array.splice(index, 1);
      }
    };

    function include(arr,obj) {
      var bool = false;
      for(var i = 0; i < arr.length; i++){
        if(obj.code == arr[i].code){
          bool = true;
        }
      }
      return bool;
    }

    function copyInWatchers(obj){
      var bool = false;
      for(var i = 0; i < $scope.data.watchers.internal.length; i++){
        if(obj.code == $scope.data.watchers.internal[i].code){
          bool = true;
          toaster.pop('warning', 'Già presente', 'Watcher già presente');
        }
      }
      if(bool == false){
        $scope.data.watchers.internal.push(obj);
      }
    }

    function formattedLookUpOperator(obj) {
      var objRef = {
        type: 'operatore',
        code: obj.model.code,
        description: obj.model.description,
        UUID: obj.UUID
      };
      return objRef;
    }

    function getFilter(filter, array){
      var filterRet;
      if(filter == null){
        filterRet = {};
      } else {
        filterRet = filter;
      }
      var string = '';
      array.forEach(function (item, index) {
        if(index == 0){
          string = item.UUID;
        } else {
          string = string +','+ item.UUID;
        }
        filterRet['UUID'] = string;
      });
      return filterRet;
    }

    function getText(ref, element){
      if(angular.isDefined(ref) && ref != null){
        if(angular.isDefined(ref[element]) && ref[element] != null){
          return ref[element];
        }
      }
      return '';
    }

    function formatMailReceiver (array) { /* from array to formatted string with comma */
      if(angular.isDefined(array.result)){
        if(array.result.length != 0){
          var strConcat = '';
          for(var i = 0; i < array.result.length; i++){
            if(i == 0){
              strConcat = array.result[i];
            } else {
              strConcat = strConcat + ', ' + array.result[i];
            }
          }
          return strConcat;
        } else {
          return '';
        }
      } else {
        return '';
      }
    }

    function formatMailCc (UserMailSix) {
      if(UserMailSix){
        return UserMailSix;
      } else {
        return null;
      }
    }

    $scope.getType = function(modelItem) {
      if(modelItem.type == 'datepicker'){
        return 'date';
      }
      else{
        return modelItem.type;
      }
    };


    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'odl';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };
  });

'use strict';

/**
 * Created by Rita Beltrami on 21/07/16.
 */
angular.module('ictportal.theme').controller('sixCheckboxCtrl', function ($scope, $rootScope) {
    var ctrl = this;
    $scope.value = false;
    $scope.sxField = ctrl.sxField;
    $scope.sxModel = ctrl.sxModel || undefined;
    $scope.sxMapping = ctrl.sxMapping || undefined;
    $scope.sxLabel = ctrl.sxLabel || '';
    $scope.sxClass = ctrl.sxClass || '';
    var T = 'S';
    var F = 'N';

    function init(){
        for(var value in $scope.sxMapping){
            if($scope.sxMapping[value]===true){
                T = value;
            }
            else{
                F = value;
            }
        }
        $scope.value = ($scope.sxModel[$scope.sxField]===T);
    };

    $scope.onValueChanged = function(){
        $scope.sxModel[$scope.sxField] = ($scope.value===true)?T:F;
    };

    $rootScope.$on( 'sixCheckbox:reload', function(event,param) {
        $scope.value = ($scope.sxModel[$scope.sxField]===T);
    });

    init();
  });







'use strict';

/**
 * Created by Rita Beltrami on 25/05/17.
 * @ngdoc component
 * @name emma.theme.component:sixCheckbox
 * @description Checkbox with char mapping
 * # sixCheckbox
 */
angular.module('ictportal.theme').component('sixCheckbox',{
      restrict: 'E',
      controller: 'sixCheckboxCtrl',
      templateUrl: 'theme/components/sixcheckbox/sixcheckbox.html',
      bindings: {
        sxField: '@',
        sxModel: '=?',
        sxMapping: '=?',
        sxLabel: '@',
        sxClass: '=?'
      },
      link: function postLink(scope, element, attrs) {

      }
  });


'use strict';

/**
 * Created by Rita Beltrami on 25/07/17.
 */

angular.module('ictportal.theme')
  .constant('COMPONENT_READ_MODE', {
    UNICODE: 'unicode',
    BARCODE: 'barcode',
    CODE: 'barcode_unicode',
    BADGE: 'badge'
  })
  .constant('SCAN_KIND', {
    RFID: 'R',
    BARCODE: 'B',
    BADGE: 'BB',
    MANUAL: 'M'
  })
  .controller('sixCodeReaderCtrl', function ($scope, $log, wsfactory, matrixParFactory, recordFactory, COMPONENT_READ_MODE, SCAN_KIND, dbFilterFactory, localStorageService, $window) {
    var ctrl = this;
    $scope.sxOptions = ctrl.sxOptions || undefined;
    $scope.sxOnRead = ctrl.sxOnRead || undefined;
    $scope.sxReadMode = $scope.sxReadMode || COMPONENT_READ_MODE.CODE;
    $scope.sxDisabled = ctrl.sxDisabled;
    $scope.sxFocus = ctrl.sxFocus || false;
    $scope.sxEscape128 = ctrl.sxEscape128 || false;
    $scope.ean128Separator = '|';
    $scope.ean128Prefix = ']C1';
    // $scope.sxPause = angular.isDefined(ctrl.sxPause) ? ctrl.sxPause : !$scope.workstation;
    $scope.sxAllowPause = angular.isDefined(ctrl.sxAllowPause) ? ctrl.sxAllowPause : false;

    function compliantRead(read) {
      var canRead = false;
      switch ($scope.sxReadMode) {
        case COMPONENT_READ_MODE.BARCODE:
          canRead = (read.type === SCAN_KIND.BARCODE);
          break;
        case COMPONENT_READ_MODE.UNICODE:
          canRead = (read.type === SCAN_KIND.RFID);
          break;
        case COMPONENT_READ_MODE.BADGE:
          canRead = (read.type === SCAN_KIND.BADGE);
          break;
        case COMPONENT_READ_MODE.CODE:
          canRead = (read.type === SCAN_KIND.BARCODE) || (read.type === SCAN_KIND.RFID);
          break;
      }
      return canRead;
    };

    $scope.$on( 'wsfactory:newMessage', function(event, param) {
        $log.info(param);
        if(!$scope.sxPause && param){
            param = JSON.parse(param);
            param.reads.forEach(function(read){
                if(compliantRead(read)){
                  read.read = read.read.replace(/[\u001D]/ig, $scope.ean128Separator);  // carattere di controllo letto da alien
                  $scope.doReadCode(read);
                }
            });
        }
    });

    $scope.manualReadCode = function(){
      if($scope.input){
        $scope.doReadCode({read: $scope.input, ts: new Date(), type: 'M'});
        $scope.input = undefined;
      }
    };

    $scope.doReadCode = function (read) {
      if($scope.sxOnRead){
        read.ts = new Date(read.ts);
        if($scope.sxEscape128) {
          read.read = escapeEan128(read.read);
        }
        $scope.sxOnRead({read: read});
      }
    };

    function escapeEan128(code) {
      if(code.startsWith($scope.ean128Prefix)) {
        code = code.substring($scope.ean128Prefix.length);
      }
      code = code.split($scope.ean128Separator).join('');
      return code;
    }

    $scope.$watchCollection(
      function(scope) {
        $scope.sxDisabled = scope.$ctrl.sxDisabled;
      },
      function(newValue, oldValue) {
          if(newValue){

          }
      }
    )

    function init() {
      $scope.workstation = localStorageService.get('workstation');
      $scope.sxPause = angular.isDefined(ctrl.sxPause) ? ctrl.sxPause : !$scope.workstation;
      if ($scope.workstation) {
        var filters = dbFilterFactory.getStringFilter('codice', $scope.workstation);
        recordFactory('workstation').filter({ page_size: 10000 }, filters)
          .$promise.then(function (data) {
            if (data && data.list && data.list.length > 0) {
              // es. 'ws://docker0.ict-group.it:8666/clients/WS-01'
              var ws = data.list[0];
              wsfactory.open(ws.websocket_url);
            }
            else {
              $log.warn('No workstations found for code ' + $scope.workstation);
            }
          });
          matrixParFactory.getValueOrDefault({key: 'ean128.function', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}, {defaultValue: "|"}).$promise.then(function(data){
            $scope.ean128Separator = data.result.value;
          });
      }
      else {
        $log.warn('No workstations found in localstorage');
      }
      if($scope.sxFocus){
        var readerInput = $window.document.getElementById("readerInput");
        readerInput.focus();
      }
    }

    init();
  });







'use strict';

/**
 * Created by Rita on 25/07/17.
 * @ngdoc component
 * @name ictportal.theme.component:sixCodeReader
 * @description Component listening to a web socket. It can read barcode/unicode/badge.
 * # sixCodeReader
 *
 * TODO: questo component sarebbe da riscrivere un po' meglio. Per questioni di tempo, ricalca molto la lookup, ma non mi piace per niente.
 */
angular.module('ictportal.theme').component('sixCodeReader', {
  restrict: 'E',
  controller: 'sixCodeReaderCtrl',
  templateUrl: 'theme/components/sixcodereader/sixcodereader.html',
  bindings: {
    sxOnRead: '&',
    sxReadMode: '=?',
    sxDisabled: '=',
    sxEscape128: '=',
    sxPause: '=?',
    sxAllowPause: '=?',
    sxFocus: '='
  }
});


'use strict';

/**
 * Created by Rita Beltrami on 17/07/17.
 */

angular.module('ictportal.theme').controller('sixComponentStatusGridCtrl', function ($scope, recordFactory, dbFilterFactory,
                                                                                    $log,schemaFactory, $filter, uiGridConstants,$rootScope,$location) {
    var ctrl = this;
    $scope.getData = ctrl.getDataCallback;
    ctrl.sxDetailButton = ctrl.sxDetailLink?true:false;

    $scope.schemaFound = false;
    $scope.list = { list: []};
    $scope.record = {
        model: {},
        lookup: {},
        dates: []
    };
    $scope.params = {
      pageNumber: 1,
      pageSize: 15,
      code: ctrl.sxEntity,
      filters: []
    };
    $scope.viewGridOptions = {};
    var isListLoaded = false;

    function readLookups() {
        for(var key in $scope.schema.properties){
            var prop = $scope.schema.properties[key];
            if(prop.format==='lookup'){
                $scope.record.lookup[key] = {
                    mapping: prop.mapping,
                    obj: {},
                    entity: prop.entity_id
                };
            }
        }
    };

    function loadLookupCols() {
        $scope.lookupCols.forEach(function(lookup){
            var field = lookup.field;
            $scope.list.list.forEach(function(record){
                var id = record[field];
                if( id ){
                    recordFactory(lookup.entity).byId({ id: id })
                        .$promise.then(function(data){
                            data['model'] = { description:'' };
                            var tokens = lookup.mapping.description.split(',');
                            tokens.forEach(function(term){
                                if(data[term]){
                                    data['model'].description += data[term] + ' ';
                                }
                            });
                            data['model'].description = data['model'].description.trim();
                            record[field+'_obj'] = data;
                            record['xversus_status_reason'] = getXVersusStatusReason(record); 
                        });
                }
            });
        });
    };

    function getXVersusStatusReason(record){
        var options = getTitleMap('status');
        var xversusStatusReason = '';
        if(record['status']) {
            for(var i=0; i<options.length; i++){
                if(options[i].value===record['status']){
                    xversusStatusReason = options[i].name;
                    break;
                }
            }
        }
        if(record['reason_id_obj']){
            for(var i=0; i<$scope.eligibleReasons.length; i++){ 
                if($scope.eligibleReasons[i].code===record['reason_id_obj'].code){
                    xversusStatusReason = xversusStatusReason + ' - ' +  record['reason_id_obj'].model.description;
                    break;
                }
            }
        }
        return xversusStatusReason;
    };

    function readDates(){
        $scope.form[0].items[0].tabs.forEach(function(tab){
            tab.items.forEach(function(item){
                if(item.type==='datepicker'){
                    var t1 = $scope.record.dates;
                    var t2 = item.key[0];
                    $scope.record.dates.push(item.key[0]);
                }
            });
        });
    };

    function loadDates(){
        $scope.record.dates.forEach(function(field){
            $scope.list.list.forEach(function(record){
                if(record[field]){
                    record[field] = new Date(record[field]);
                }
            });
        });
    };

    $scope.viewDetail = function (value) {
        if (ctrl.sxDetailLink) {
            $location.path(ctrl.sxDetailLink + '/' + value.id);
        }
    };

    function initGridColumns() {
        $scope.lookupCols = [];
        schemaFactory().getCode({id: ctrl.sxEntity}).$promise.then(
            function(data) {
                if(data.schema){ 
                    $scope.sf = data;
                    if (data.schema && data.form) {
                        $scope.schema = data.schema;
                        $scope.form = data.form;
                        readLookups();
                        readDates();
                    }
                    if (data.schema || data.form) $scope.schemaFound = true;
                    if (data.columnDefs) {
                        $scope.viewGridOptions.appScopeProvider = $scope;
                        $scope.viewGridOptions.columnDefs = [
                            {
                                enableFiltering: false, 
                                field: "operation_date",
                                name: "Data/ora",
                                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.operation_date | date:\'dd/MM/yyyy hh:mm\' }}</div>'
                            },
                            {
                                enableFiltering: false,
                                name: "Stato",
                                field: "xversus_status_reason"
                            },
                            {
                                enableFiltering: false,
                                field: "operator_id_obj.model.description",
                                name: "Operatore"
                            },
                            {
                                enableFiltering: false,
                                field: "employee_id_obj.model.description",
                                name: "Dipendente"
                            }
                        ];
                        var lookupReason = $scope.record.lookup['reason_id'];
                        lookupReason.field = 'reason_id';
                        $scope.lookupCols.push(lookupReason);
                        var lookupOperator = $scope.record.lookup['operator_id'];
                        lookupOperator.field = 'operator_id';
                        $scope.lookupCols.push(lookupOperator);
                        var lookupEmployee = $scope.record.lookup['employee_id'];
                        lookupEmployee.field = 'employee_id';
                        $scope.lookupCols.push(lookupEmployee);
                    };
                    if (data.description) $scope.typeName = data.description;
                    if(isListLoaded===true){
                        if ($scope.lookupCols.length > 0) {
                            loadLookupCols();
                        }
                        if($scope.record.dates.length>0){
                            loadDates();
                        }
                    } 
                }
            }
        );
    };

    function getEnableFiltering(item){
        return false;
    };

    function getDateFormat(field){
        var format = '';
        for(var i=0; i<$scope.form[0].items[0].tabs.length; i++){
            var tab = $scope.form[0].items[0].tabs[i];
            var index = tab.items.findIndex(function(e) { return e.key[0] == field; });
            if(index>=0){
                switch(tab.items[index].type){
                    case 'datetimepicker':
                        format = 'dd/MM/yyyy hh:mm';
                        break;
                    case 'timepicker':
                        format = 'hh:mm:ss';
                        break;
                    default:
                        format = 'dd/MM/yyyy';
                        break;

                }
                break;
            }
        }
        return format;
    };

    function isDate(field){
        var isADate = false;
        for(var i=0; i<$scope.form[0].items[0].tabs.length; i++){
            var tab = $scope.form[0].items[0].tabs[i];
            var index = tab.items.findIndex(function(e) { return e.key[0] == field; });
            if(index>=0){
                isADate = ( (tab.items[index].type === 'datepicker') || (tab.items[index].type === 'timepicker') || (tab.items[index].type === 'datetimepicker') ) ;
                break;
            }
        }
        return isADate;
    };

    function isBoolean(field){
        var isABoolean = false;
        for(var i=0; i<$scope.form[0].items[0].tabs.length; i++){
            var tab = $scope.form[0].items[0].tabs[i];
            var index = tab.items.findIndex(function(e) { return e.key[0] == field; });
            if(index>=0){
                isABoolean = (tab.items[index].type === 'eggscheckbox');
                break;
            }
        }
        return isABoolean;
    };

    function isEnum(field){
        var isAnEnum = false;
        if($scope.sf.schema.properties[field]){
            isAnEnum = $scope.sf.schema.properties[field].format==='enum';
        }
        return isAnEnum;
    };

    function getTitleMap(field){
        var titleMap = [];
        for(var i=0; i<$scope.form[0].items[0].tabs.length; i++){
            var tab = $scope.form[0].items[0].tabs[i];
            var index = tab.items.findIndex(function(e) { return e.key[0] == field; });
            if(index>=0){
                if(tab.items[index].titleMap){
                    titleMap = tab.items[index].titleMap;
                }
                break;
            }
        }
        return titleMap;
    };

    $scope.getData = function () {
        ctrl.getDataCallback();
    };

    // Carico l'elenco delle causali valide e visualizzo i dati
    $rootScope.$on( 'sixComponentStatusGrid:dataLoaded', function(event,param,list) {
        if(param===ctrl.sxEntity && list){
            var filters = [{
                column: 'control_reason_group g',
                value: 't.control_reason_group = g.id',
                relation: 'JOIN',
                kind: 'g.code'
            }];
            filters = filters.concat(dbFilterFactory.getStringFilter('g.code','XVERSUS'));
            recordFactory('control_reason').filter({page_size:10000}, filters)
                .$promise.then(function(data) {
                    $scope.eligibleReasons = data.list;
                    isListLoaded = true;
                    $scope.viewGridOptions.totalItems = list.length;
                    $scope.list.totalResults = list.length;
                    $scope.list.list.length = 0;
                    $scope.list.list = $scope.list.list.concat(list);
                    if ($scope.lookupCols.length > 0) {
                        loadLookupCols();
                    }
                    if($scope.record.dates.length>0){
                        loadDates();
                    }
                });
        }
    });
 
    function capitalize(s){
        return s && s[0].toUpperCase() + s.slice(1);
    };

    function init(){
        initGridColumns();    
    };

    //___ main ___
    init();
});







'use strict';

/**
 * Created by Rita Beltrami on 17/07/17.
 * @ngdoc component
 * @name emma.theme.component:sixDetailGrid
 * @description
 * # sixDetailGrid
 */
angular.module('ictportal.theme').component('sixComponentStatusGrid',{
      restrict: 'E',
      controller: 'sixComponentStatusGridCtrl',
      templateUrl: 'theme/components/sixcomponentstatusgrid/sixcomponentstatusgrid.html',
      bindings: {
        getDataCallback: '&',
        sxEntity: '@',
        sxDetailLink: '='
      }
  });


'use strict';


angular.module('ictportal.theme').controller('sixDatePickerCtrl', function ($scope, $log) {
  this.status = {
    opened: false
  };

  if(angular.isUndefined(this.sxDisabled)) {
    this.sxDisabled = false;
  }

  this.format = this.format || 'dd/MM/yyyy';

  this.dateOptions = this.dateOptions || {};
  if(angular.isUndefined(this.dateOptions.formatYear)) {
    this.dateOptions.formatYear = 'yyyy';
  }
  if(angular.isUndefined(this.dateOptions.startingDay)) {
    this.dateOptions.startingDay = 1;
  }

  this.open = function($event) {
    this.status.opened = true;
  };
});

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixDatePicker
 * @description
 * # sixDatePicker
 */
angular.module('ictportal.theme').component('sixDatePicker', {
    transclude: true,
    controller: 'sixDatePickerCtrl',
    templateUrl: 'theme/components/sixdatepicker/sixdatepicker.html',
    restrict: 'E',
    bindings: {
      ngModel: '=',
      name: '@',
      dateOptions: '=?',
      format: '=?',
      sxDisabled: '=?',
      placeholder: '@'
    }
});

'use strict';


angular.module('ictportal.theme').controller('sixDateTimePickerCtrl', function ($scope, $log) {

  this.isOpen = false;
  this.dateOptions = this.dateOptions || {};
  this.timePickerOptions = this.timePickerOptions || { showMeridian: false };
  if(angular.isUndefined(this.sxDisabled)) { this.sxDisabled = false; }
  if(angular.isUndefined(this.enableDate)) { this.enableDate = true; }
  if(angular.isUndefined(this.enableTime)) { this.enableTime = true; }
  if(angular.isUndefined(this.format)) {
    this.format = '';
    var sep = '';
    if(this.enableDate) {
      this.format += sep + 'dd/MM/yyyy';
      sep = ' ';
    }
    if(this.enableTime) {
      this.format += sep + 'HH:mm';
    }
  }

  this.buttonBar = {
    show: true,
      now: {
      show: true,
        text: 'Adesso',
        cls: 'btn-sm btn-bg btn-info'
    },
    today: {
      show: true,
        text: 'Oggi',
        cls: 'btn-sm btn-bg btn-info'
    },
    clear: {
      show: true,
        text: 'Cancella',
        cls: 'btn-sm btn-bg btn-danger'
    },
    date: {
      show: true,
        text: 'Data',
        cls: 'btn-sm btn-default'
    },
    time: {
      show: true,
        text: 'Ora',
        cls: 'btn-sm btn-default'
    },
    close: {
      show: true,
        text: 'Chiudi',
        cls: 'btn-sm btn-default'
    }
  };

  this.openCalendar = function(e) {
    e.preventDefault();
    e.stopPropagation();

    this.isOpen = true;
  };
});

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixDateTimePicker
 * @description
 * # sixDateTimePicker
 */
angular.module('ictportal.theme').component('sixDateTimePicker', {
    transclude: true,
    controller: 'sixDateTimePickerCtrl',
    templateUrl: 'theme/components/sixdatetimepicker/sixdatetimepicker.html',
    restrict: 'E',
    bindings: {
      ngModel: '=',
      name: '@',
      format: '=?',
      dateOptions: '=?',        // https://angular-ui.github.io/bootstrap/#/datepicker
      timePickerOptions: '=?',  // https://angular-ui.github.io/bootstrap/#/timepicker
      enableDate: '=?',
      enableTime: '=?',
      sxDisabled: '=?'
    }
});

'use strict';

/**
 * Created by Rita Beltrami on 21/06/17.
 */

angular.module('ictportal.theme').controller('sixDetailGridCtrl', function ($scope, recordFactory, $log,schemaFactory, uiGridConstants,$rootScope,$location) {
    var ctrl = this;
    $scope.getData = ctrl.getDataCallback;
    ctrl.sxDetailButton = ctrl.sxDetailLink?true:false;

    $scope.schemaFound = false;
    $scope.list = { list: []};
    $scope.record = {
        model: {},
        lookup: {},
        dates: []
    };
    $scope.params = {
      pageNumber: 1,
      pageSize: 15,
      code: ctrl.sxEntity,
      filters: []
    };
    $scope.viewGridOptions = {};
    var isListLoaded = false;

    function readLookups() {
        for(var key in $scope.schema.properties){
            var prop = $scope.schema.properties[key];
            if(prop.format==='lookup'){
                $scope.record.lookup[key] = {
                    mapping: prop.mapping,
                    obj: {},
                    entity: prop.entity_id
                };
            }
        }
    };

    function loadLookupCols() {
            // Raggruppo assieme i record che fanno riferimento ad una stessa entità (es. tutti quelli con customer_id=123)
            // In questo modo risolvo l'entità una volta sola per tutti.
            var lookupMap = {};
            $scope.lookupCols.forEach(function (lookup) {
                var field = lookup.field;
                lookupMap[field] = {};
                $scope.list.list.forEach(function (record) {
                    var id = record[field];
                    if (id) {
                        if(!lookupMap[field][id]){
                            lookupMap[field][id] = [];
                        }
                        lookupMap[field][id].push(record);
                    }
                });
            });
            // Recupero da DB i dati e li assegno ai rispettivi record.
            $scope.lookupCols.forEach(function (lookup) {
                for(var id in lookupMap[lookup.field]){
                    recordFactory(lookup.entity).byId({ id: id })
                        .$promise.then(function (data) {
                            data['model'] = { description: '' };
                            var tokens = lookup.mapping.description.split(',');
                            tokens.forEach(function (term) {
                                if (data[term]) {
                                    data['model'].description += data[term] + ' ';
                                }
                            });
                            data['model'].description = data['model'].description.trim();
                            lookupMap[lookup.field][data.id].forEach(function(record){
                                record[lookup.field + '_obj'] = data;
                            });
                        });
                }
            });
        };

    function readDates(){
        $scope.form[0].items[0].tabs.forEach(function(tab){
            tab.items.forEach(function(item){
                if(item.type==='datepicker'){
                    var t1 = $scope.record.dates;
                    var t2 = item.key[0];
                    $scope.record.dates.push(item.key[0]);
                }
            });
        });
    };

    function loadDates(){
        $scope.record.dates.forEach(function(field){
            $scope.list.list.forEach(function(record){
                if(record[field]){
                    record[field] = new Date(record[field]);
                }
            });
        });
    };

    $scope.viewDetail = function (value) {
        if (ctrl.sxDetailLink) {
            $location.path(ctrl.sxDetailLink + '/' + value.id);
        }
    };

    function initGridColumns() {
        $scope.lookupCols = [];
        schemaFactory().getCode({id: ctrl.sxEntity}).$promise.then(
            function(data) {
                if(data.schema){ 
                    $scope.sf = data;
                    if (data.schema && data.form) {
                        $scope.schema = data.schema;
                        $scope.form = data.form;
                        readLookups();
                        readDates();
                    }
                    if (data.schema || data.form) $scope.schemaFound = true;
                    if (data.columnDefs) {
                        $scope.viewGridOptions.appScopeProvider = $scope;
                        $scope.viewGridOptions.columnDefs = [];
                        if(ctrl.sxDetailButton){
                            $scope.viewGridOptions.columnDefs.push({
                                displayName: '',
                                field: 'id',
                                width: 34,
                                enableCellEdit: false,
                                enableFiltering: false,
                                enableSorting: false,
                                cellTemplate:
                                '<div class="ui-grid-cell-contents" style="text-align: center">' +
                                    '<button ng-click="grid.appScope.viewDetail(row.entity)" class="btn btn-xs btn-primary">' +
                                    '<span class="fa fa-search"></span>' +
                                    '</button>' +
                                '</div>'
                            });
                        }
                        data.columnDefs.forEach(function(item) {
                            item.enableFiltering = getEnableFiltering(item);
                            item.filters = [{
                                type: 'text',
                                condition: uiGridConstants.filter.CONTAINS,
                                placeholder: '',
                                kind: 'string'
                            }];
                            if($scope.record.lookup[item.field]){
                                var prop = data.schema.properties[item.field];
                                item.filters = [{
                                    type: 'lookup',
                                    condition: uiGridConstants.filter.CONTAINS,
                                    placeholder: '',
                                    kind: 'string',
                                    schema: prop,
                                    join: {
                                        column: prop.entity_id,
                                        value: 't.' + prop.title + ' = ' + prop.entity_id + '.id',
                                        relation: 'JOIN',
                                        kind: ''
                                    }
                                }];
                                var lookup = $scope.record.lookup[item.field];
                                lookup.field = item.field;
                                item.field = item.field + '_obj.model.description';
                                $scope.lookupCols.push(lookup);
                            }
                            else if(isDate(item.field)){
                                item.filters = [
                                    {
                                        type: 'date',
                                        relation: '>=',
                                        placeholder: 'da...',
                                        kind: 'date',
                                        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
                                    },
                                    {
                                        type: 'date',
                                        relation: '<=',
                                        placeholder: 'a...',
                                        kind: 'date',
                                        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
                                    }
                                ];
                                var format = getDateFormat(item.field);
                                item.cellTemplate = '<div class="ui-grid-cell-contents">{{ row.entity.' + item.field + ' | date:\'' + format +  '\' }}</div>'
                            }
                            else if(isBoolean(item.field)){
                                var options = [{
                                    value: 'S',
                                    name: 'Sì'
                                }, {
                                    value: 'N',
                                    name: 'No'
                                }];
                                item.filter = { 
                                    type: uiGridConstants.filter.SELECT
                                };
                                item.editDropdownOptionsArray = options;
                                item.filter.selectOptions = options.map(function(obj) { 
                                    var rObj = {'value': obj.value, 'name': obj.name};
                                    return rObj;
                                });
                                item.cellTemplate = '<div class="ui-grid-cell-contents"><span ng-if="row.entity.' + item.field + '===\'S\'" >Sì</span><span ng-if="row.entity.' + item.field + '!==\'S\'" >No</span></div>'
                            }
                            else if(isEnum(item.field)){
                                var options = getTitleMap(item.field);
                                item.filter = { 
                                    type: uiGridConstants.filter.SELECT
                                };
                                item.editDropdownOptionsArray = options;
                                item.filter.selectOptions = options.map(function(obj) { 
                                    var rObj = {'value': obj.value, 'name': obj.label};
                                    return rObj;
                                });
                                item.cellTemplate = '<div class="ui-grid-cell-contents">';
                                options.forEach(function(opt){
                                    item.cellTemplate += '<span ng-if="row.entity.' + item.field + '===\'' + opt.value + '\'" >' + opt.name + '</span>';
                                });
                                item.cellTemplate += '</div>';
                            }
                            $scope.viewGridOptions.columnDefs.push(item)
                        });
                    };
                    if (data.description) $scope.typeName = data.description;
                    if(isListLoaded===true){
                        if ($scope.lookupCols.length > 0) {
                            loadLookupCols();
                        }
                        if($scope.record.dates.length>0){
                            loadDates();
                        }
                    }
                }
            }
        );
    };

    function getEnableFiltering(item){
        return false;
    };

    function getDateFormat(field){
        var format = '';
        for(var i=0; i<$scope.form[0].items[0].tabs.length; i++){
            var tab = $scope.form[0].items[0].tabs[i];
            var index = tab.items.findIndex(function(e) { return e.key[0] == field; });
            if(index>=0){
                switch(tab.items[index].type){
                    case 'datetimepicker':
                        format = 'dd/MM/yyyy hh:mm';
                        break;
                    case 'timepicker':
                        format = 'hh:mm:ss';
                        break;
                    default:
                        format = 'dd/MM/yyyy';
                        break;

                }
                break;
            }
        }
        return format;
    };

    function isDate(field){
        var isADate = false;
        for(var i=0; i<$scope.form[0].items[0].tabs.length; i++){
            var tab = $scope.form[0].items[0].tabs[i];
            var index = tab.items.findIndex(function(e) { return e.key[0] == field; });
            if(index>=0){
                isADate = ( (tab.items[index].type === 'datepicker') || (tab.items[index].type === 'timepicker') || (tab.items[index].type === 'datetimepicker') ) ;
                break;
            }
        }
        return isADate;
    };

    function isBoolean(field){
        var isABoolean = false;
        for(var i=0; i<$scope.form[0].items[0].tabs.length; i++){
            var tab = $scope.form[0].items[0].tabs[i];
            var index = tab.items.findIndex(function(e) { return e.key[0] == field; });
            if(index>=0){
                isABoolean = (tab.items[index].type === 'eggscheckbox');
                break;
            }
        }
        return isABoolean;
    };

    function isEnum(field){
        var isAnEnum = false;
        if($scope.sf.schema.properties[field]){
            isAnEnum = $scope.sf.schema.properties[field].format==='enum';
        }
        return isAnEnum;
    };

    function getTitleMap(field){
        var titleMap = [];
        for(var i=0; i<$scope.form[0].items[0].tabs.length; i++){
            var tab = $scope.form[0].items[0].tabs[i];
            var index = tab.items.findIndex(function(e) { return e.key[0] == field; });
            if(index>=0){
                if(tab.items[index].titleMap){
                    titleMap = tab.items[index].titleMap;
                }
                break;
            }
        }
        return titleMap;
    };

    $scope.getData = function () {
        ctrl.getDataCallback();
    };

    $rootScope.$on( 'sixDetailGrid:dataLoaded', function(event,param,list) {
        if(param===ctrl.sxEntity && list){
            isListLoaded = true;
            $scope.viewGridOptions.totalItems = list.length;
            $scope.list.totalResults = list.length;
            $scope.list.list.length = 0;
            $scope.list.list = $scope.list.list.concat(list);
            if ($scope.lookupCols.length > 0) {
                loadLookupCols();
            }
            if($scope.record.dates.length>0){
                loadDates();
            }
        }
    });
 
    function capitalize(s){
        return s && s[0].toUpperCase() + s.slice(1);
    };

    function init(){
        initGridColumns();    
    };

    //___ main ___
    init();
});







'use strict';

/**
 * Created by Rita Beltrami on 21/06/17.
 * @ngdoc component
 * @name emma.theme.component:sixDetailGrid
 * @description
 * # sixDetailGrid
 */
angular.module('ictportal.theme').component('sixDetailGrid',{
      restrict: 'E',
      controller: 'sixDetailGridCtrl',
      templateUrl: 'theme/components/sixdetailgrid/sixdetailgrid.html',
      bindings: {
        getDataCallback: '&',
        sxEntity: '@',
        sxDetailLink: '='
      }
  });


'use strict';

/**
 * Created by Esmeralda on 25/05/17.
 */
angular.module('ictportal.theme').controller('sixEnumCtrl', function ($scope, $filter, $log) {
    var ctrl = this;
    $scope.selected = {
        obj: {}
    };
    $scope.sxField = ctrl.sxField;
    $scope.sxModel = ctrl.sxModel || undefined;
    $scope.sxOptions = ctrl.sxOptions || undefined;
    $scope.sxOnChange = ctrl.sxOnChange || undefined;
    $scope.sxDisabled = ctrl.sxDisabled || false;
    $scope.sxReadonly = ctrl.sxReadonly || false;
    $scope.sxClosable = angular.isUndefined(ctrl.sxClosable)?true:ctrl.sxClosable;

    function init(){
        var item = $filter('filter')($scope.sxOptions, {value: $scope.sxModel[$scope.sxField] }, true);
        if(item.length===0) {
            $log.error("six-enum: nessuna corrispondenza trovata per il valore '" + $scope.sxModel[$scope.sxField] + "'");
        }
        $scope.selected.obj = item[0];
    };

    $scope.$watchCollection(
        function(scope) {
            if(angular.isUndefined($scope.sxField) || angular.isUndefined(scope.sxModel)){
                return scope.sxModel;
            } else {
                return scope.sxModel[$scope.sxField];
            }
        },
        function(newValue, oldValue) {
            if(newValue){
                for(var i=0; i<$scope.sxOptions.length; i++){
                    var opt = $scope.sxOptions[i];
                    if(opt && opt.value===newValue){
                        $scope.selected.obj = opt;
                        break; 
                    }
                }
            }
            else{
                $scope.selected.obj = undefined;
            }
        }
    );

    $scope.onValueChanged = function(selOpt){
        $scope.sxModel[$scope.sxField] = (selOpt)?selOpt.value:undefined;
        if($scope.sxOnChange){
            $scope.sxOnChange();
        }
    };

    $scope.clearSelect = function($event) {
        $event.stopPropagation(); 
        $scope.selected.obj = undefined;
        $scope.onValueChanged($scope.selected.obj);
    };

    init();
  });







'use strict';

/**
 * Created by Esmeralda on 25/05/17.
 * @ngdoc component
 * @name emma.theme.component:sixEnum
 * @description Checkbox with char mapping
 * # sixEnum
 */
angular.module('ictportal.theme').component('sixEnum',{
      restrict: 'E',
      controller: 'sixEnumCtrl',
      templateUrl: 'theme/components/sixenum/sixenum.html',
      bindings: {
        sxField: '@',
        sxModel: '=?',
        sxOptions: '=?',
        sxOnChange: '&',
        sxDisabled: '=?',
        sxReadonly: '=?',
        sxClosable: '=?' // per abilitare o meno il pulsante per pulire l'enum
      },
      link: function postLink(scope, element, attrs) {

      }
  });


(function () {
  'use strict';

  angular.module('ictportal.theme')
    .controller('SixFeedCtrl', SixFeedCtrl);

  /** @ngInject */
  function SixFeedCtrl($scope, $rootScope, msgFactory) {
    $rootScope.feedCount = 0;
    $scope.messages = [];

    function init() {

    };

    function getText(feed) {
      var text = '<strong>' + feed.from + ':' + '</strong>&nbsp;' + feed.msg;
      return text//$sce.trustAsHtml(text);    
    };

    function getTime(timestamp) {
      var time = '';
      var now = new Date();
      var diffMs = (now - timestamp);
      var diffDays = Math.floor(diffMs / 86400000); // days
      var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
      var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
      if (diffMins <= 0) {
        time = 'Adesso';
      }
      else if (diffHrs <= 0) {
        var minStr = (diffMins === 1) ? ' minuto' : ' minuti';
        time = diffMins + minStr + ' fa';
      }
      else if (diffDays <= 0) {
        var hrsStr = (diffHrs === 1) ? ' ora' : ' ore';
        time = diffHrs + hrsStr + ' fa';
      }
      else {
        var daysStr = (diffDays === 1) ? ' giorno' : ' giorni';
        time = diffDays + daysStr + ' fa';
      }
      return time;
    };

    $scope.clearFeeds = function () {
      $rootScope.feedCount = 0;
      $scope.messages.forEach(function (feed) {
        feed.time = getTime(feed.timestamp);
      });
    };

    $scope.deleteFeeds = function () {
      $scope.messages.length = 0;
      msgFactory.collection.length = 0;
    };

    $rootScope.$on('msgFactory:newMessage', function (event, param) {
      for (var i = $scope.messages.length; i < msgFactory.collection.length; i++) {
        var feed = msgFactory.collection[i];
        var newMessage = {
          text: getText(feed),
          icon: feed.icon,
          level: feed.level,
          project: feed.project,
          from: feed.from,
          timestamp: new Date()
        };
        $scope.messages.unshift(newMessage);
        $rootScope.feedCount++;
      }
    });

    init();

  }
})();
/**
 * @author Rita Beltrami
 * created on 23.03.2017
 */
(function () {
  'use strict';

  angular.module('ictportal.theme')
  .component('sixFeed',{
    restrict: 'E',
    templateUrl: 'theme/components/sixfeed/sixFeed.html',
    controller: 'SixFeedCtrl',
    replace: true
  })

})();


'use strict';

/**
 * Created by Rita Beltrami on 22/06/16.
 */


angular.module('ictportal.theme').constant('sixGridPaginationConstants', {
  filterType: {
    TEXT:           'text',
    DATE:           'date',
    NUMBER:         'number',
    SELECT:         'select',
    SELECTMULTIPLE: 'selectmultiple',
    CHECKBOX:       'checkbox',
    SIXLOOKUP:      'sixlookup'
  },
  filterRel: {
    LESS_THAN:              'lt',
    LESS_THAN_OR_EQUAL:     'lte',
    GREATER_THAN:           'gt',
    GREATER_THAN_OR_EQUAL:  'gte',
    EQUAL:                  'eq'
  }
});


angular.module('ictportal.theme').controller('sixGridPaginationController', function ($scope, $filter, $translate, sixGridPaginationConstants, $timeout) {
    var filterTimeout = undefined;
    var ctrl = this;
    $scope.getData = ctrl.getDataCallback;
    $scope.getAllData = ctrl.getAllDataCallback;
    $scope.getList = ctrl.getListCallback || ctrl.getDataCallback;
    $scope.itemsList = ctrl.itemsList;
    $scope.params = ctrl.params || {};

    var defaultOptions = {
        data: (ctrl.itemsList)?'itemsList.list' : [],
        onRegisterApi: onRegisterApi,
        columnDef: [],
        enableGridMenu: true,
        gridMenuTitleFilter: $translate,
        exporterCsvColumnSeparator: ';',
        gridMenuCustomItems: [
          {
            title: 'Export pag. xls',
            action: function ($event) {
                exportVisibles();
            },
            order: 220
          }
        ],
        exporterMenuPdf: false,
        exporterMenuCsv: false,
        enableCellEdit: false,
        enableSorting: true,
        enableFiltering: true,
        enableColumnResizing: true,
        paginationPageSizes: [10, 15, 20, 30, 40, 50, 100, 1000, 10000],
        paginationPageSize: 15,
        useExternalPagination: true,
        useExternalFiltering: true,
        multiSelect: false,
        enableRowHeaderSelection: false,
        enableRowSelection: false,
        lang: 'it',
        rowHeight: 33,
        minRowsToShow: 15
    };

    $scope.viewGridOptions = angular.extend(defaultOptions, ctrl.gridOptions);

    // Aggiungo l'opzione per esportare tutti i dati senza paginazione (se mi viene passata la funzione per recuperarli...)
    if(angular.isFunction($scope.getAllData)) {
      $scope.viewGridOptions.gridMenuCustomItems.push({
        title: 'Export xls',
        action: function ($event) {
          exportAll();
        },
        order: 210
      });
    }

    // For binding
    ctrl.gridOptions = $scope.viewGridOptions;

    // Opzioni griglia.
    if (angular.isDefined(ctrl.columnDefs)){
        $scope.viewGridOptions.columnDefs = ctrl.columnDefs;
    }

    $scope.params.pageNumber = 1;
    $scope.params.pageSize = $scope.viewGridOptions.paginationPageSize;

    function onRegisterApi(gridApi) {
        if(gridApi.pagination){
            gridApi.pagination.on.paginationChanged($scope, pageChangedCallback);
        }
        gridApi.core.on.filterChanged($scope, filterChangedCallback);
        gridApi.core.on.sortChanged($scope, sortChangedCallback);
        if (angular.isFunction(ctrl.gridOptions.rowSelectionChanged)) {
            gridApi.selection.on.rowSelectionChanged($scope, ctrl.gridOptions.rowSelectionChanged);
        }
        if (angular.isFunction(ctrl.gridOptions.rowSelectionChangedBatch)) {
            gridApi.selection.on.rowSelectionChangedBatch($scope, ctrl.gridOptions.rowSelectionChangedBatch);
        }
        $scope.params.gridApi = gridApi;
        $scope.viewGridOptions.gridApi = gridApi;
        setHeightToPageSize();
    }

    function pageChangedCallback(newPage, pageSize) {
        console.log("Paged change");
        $scope.params.pageNumber = newPage;
        $scope.params.pageSize = pageSize;
        setHeightToPageSize();
        $scope.getList({$params: $scope.params});
    }

    function sortChangedCallback(scope, sortColumns) {
        $scope.params.sortFields = '';
        $scope.params.sortOrder = '';
        var sep = '';
        sortColumns.forEach(function(col) {
            $scope.params.sortFields += sep + col.field;
            $scope.params.sortOrder += sep + col.sort.direction;
            sep = ',';
        });
        $scope.getData({$params: $scope.params});
    }

    function filterChangedCallback() {
        $scope.params.filterQuery = {};
        if ($scope.params.filters === undefined){
          $scope.params.filters = [];
        }
        $scope.params.filters.length = 0;
        $scope.viewGridOptions.columnDefs.forEach(function (col) {
            if (col.filters) {
                col.filters.forEach(function (filter) {
                    var term = filter.term;
                    var field = col.field;

                    if (angular.isDefined(col.sixFilteringCallback)) {
                        term = col.sixFilteringCallback(term);
                    }

                    if (term && term != '') {
                        var item = {
                            column: field,
                            value: term,
                            relation: '=',
                            kind: filter.kind
                        };
                        if (filter.relation) {
                            item.relation = filter.relation;
                        }
                        if (filter.kind === 'string') {
                            item.relation = 'LIKE';
                        }
                        if (filter.aliasResolver) {
                            // Questo mi serve se ho fatto dei select pippo as pluto:
                            // a video stampo pippo ma nella query serve pluto sennò scala si offende
                            var tokens = filter.aliasResolver.split(",");
                            if(tokens.length==0){
                                item.column = tokens[0];
                            }
                            else{
                                var query = '(';
                                tokens.forEach(function(t){
                                    query += t + ' ILIKE \'%' + term + '%\' OR ';
                                });
                                query = query.slice(0, -4);
                                query += ')';
                                var item = {
                                    column: '',
                                    value: query,
                                    relation: '',
                                    kind: 'custom'
                                };
                            }
                        }

                        if (filter.type === 'lookup') {
                            addLookupFilters(filter, term);
                        }
                        else {
                            $scope.params.filters.push(item);
                        }

                    }
                });
            }
        });
        // Timeout per evitare rimbalzi di chiamate.
        if (angular.isDefined(filterTimeout)) {
            $timeout.cancel(filterTimeout);
        }
        filterTimeout = $timeout(function () {
            $scope.getData({$params: $scope.params});
        }, 200);
    }

    function addLookupFilters(filter,term){
        $scope.params.filters.push(filter.join);
        var array = [];
        if(filter.schema.mapping.code){
            array.push(filter.schema.mapping.code);
        }
        if(filter.schema.mapping.description){
            var tokens = filter.schema.mapping.description.split(",");
            tokens.forEach(function(t){
                array.push(t);
            });
        }
        var query = '(';
        array.forEach(function(t){
            query += filter.schema.entity_id + '.' + t + ' ILIKE \'%' + term + '%\' OR ';
        });
        query = query.slice(0, -4);
        query += ')';
        var item = {
            column: '',
            value: query,
            relation: '',
            kind: 'custom'
        };
        $scope.params.filters.push(item);
    };

    // ***** EXPORT ***** //

    function exportVisibles() {
      sixExportLib.exportXLSXVisibleRowsGrid($scope.params.gridApi, 'download', $filter);
    }

    function exportAll() {
      if(angular.isFunction($scope.getAllData)) {
        sixExportLib.exportXLSXRowsGrid($scope.params.gridApi, $scope.getAllData(), 'export');
      } else {
        console.log('get-all-data-allback attribute is not a function: exporting only grid known rows');
        sixExportLib.exportXLSXAllRowsGrid($scope.params.gridApi, 'export');
      }
    }

    // ***** RESIZE GRID ***** //

    function setHeightToPageSize(extra) {
        var height = $scope.params.pageSize * $scope.viewGridOptions.rowHeight;
        if ($scope.viewGridOptions.enablePaginationControls != false) {
            height += 154; // space for pagination
        }
        if (extra) {
          height += extra;
        }
        $scope.params.gridApi.grid.gridHeight = height;
      }

    //__main__
    if (!ctrl.lazyInit) $scope.getList({$params: $scope.params});
});



'use strict';

/**
 * Created by Rita Beltrami on 22/06/16.
 * @ngdoc component
 * @name emma.theme.component:sixGridPagination
 * @description
 * # sixGridPagination
 */
angular.module('ictportal.theme').component('sixGridPagination',{
      restrict: 'E',
      controller: 'sixGridPaginationController',
      templateUrl: 'theme/components/sixgridpagination/sixgridpagination.html',
      bindings: {
        getDataCallback: '&',  // on sort or filter change or serch input key-up event (if showGlobalSearch is true)
        getListCallback: '&?', // on update pagination event and on initialization. Deafult === getDataCallback
        getAllDataCallback: '&?',
        gridOptions: '=',
        itemsList: '=?', // deprecated use gridOptions.data
        columnDefs: '=?', // deprecated use gridOptions.columnDefs
        params: '=',
        showGlobalSearch: '=',
        lazyInit: '@' // set to true for skip initial loading
      }
  });


'use strict';

/**
 * Created by Filippo Muzzini on 05/07/19.
 */


angular.module('ictportal.theme').constant('sixGridPaginationExpandableConstants', {
  filterType: {
    TEXT:           'text',
    DATE:           'date',
    NUMBER:         'number',
    SELECT:         'select',
    SELECTMULTIPLE: 'selectmultiple',
    CHECKBOX:       'checkbox',
    SIXLOOKUP:      'sixlookup'
  },
  filterRel: {
    LESS_THAN:              'lt',
    LESS_THAN_OR_EQUAL:     'lte',
    GREATER_THAN:           'gt',
    GREATER_THAN_OR_EQUAL:  'gte',
    EQUAL:                  'eq'
  }
});


angular.module('ictportal.theme').controller('sixGridPaginationExpandableController', function ($scope, $filter, $translate, sixGridPaginationExpandableConstants, $timeout) {
    var filterTimeout = undefined;
    var ctrl = this;
    $scope.getData = ctrl.getDataCallback;
    $scope.getAllData = ctrl.getAllDataCallback;
    $scope.getList = ctrl.getListCallback || ctrl.getDataCallback;
    $scope.itemsList = ctrl.itemsList;
    $scope.params = ctrl.params || {};

    var defaultOptions = {
        data: (ctrl.itemsList)?'itemsList.list' : [],
        onRegisterApi: onRegisterApi,
        columnDef: [],
        enableGridMenu: true,
        gridMenuTitleFilter: $translate,
        exporterCsvColumnSeparator: ';',
        gridMenuCustomItems: [
          {
            title: 'Export pag. xls',
            action: function ($event) {
                exportVisibles();
            },
            order: 220
          }
        ],
        exporterMenuPdf: false,
        exporterMenuCsv: false,
        enableCellEdit: false,
        enableSorting: true,
        enableFiltering: true,
        enableColumnResizing: true,
        paginationPageSizes: [10, 15, 20, 30, 40, 50, 100, 1000, 10000],
        paginationPageSize: 15,
        useExternalPagination: true,
        useExternalFiltering: true,
        multiSelect: false,
        enableRowHeaderSelection: false,
        enableRowSelection: false,
        lang: 'it',
        rowHeight: 33,
        minRowsToShow: 15,
        expandableRowTemplate: '<div ui-grid="row.entity.subGridOptions" ui-grid-resize-columns></div>',
    };

    $scope.viewGridOptions = angular.extend(defaultOptions, ctrl.gridOptions);

    // Aggiungo l'opzione per esportare tutti i dati senza paginazione (se mi viene passata la funzione per recuperarli...)
    if(angular.isFunction($scope.getAllData)) {
      $scope.viewGridOptions.gridMenuCustomItems.push({
        title: 'Export xls',
        action: function ($event) {
          exportAll();
        },
        order: 210
      });
    }

    // For binding
    ctrl.gridOptions = $scope.viewGridOptions;

    // Opzioni griglia.
    if (angular.isDefined(ctrl.columnDefs)){
        $scope.viewGridOptions.columnDefs = ctrl.columnDefs;
    }

    $scope.params.pageNumber = 1;
    $scope.params.pageSize = $scope.viewGridOptions.paginationPageSize;

    function onRegisterApi(gridApi) {
        if(gridApi.pagination){
            gridApi.pagination.on.paginationChanged($scope, pageChangedCallback);
        }
        gridApi.core.on.filterChanged($scope, filterChangedCallback);
        gridApi.core.on.sortChanged($scope, sortChangedCallback);
        if (angular.isFunction(ctrl.gridOptions.rowSelectionChanged)) {
            gridApi.selection.on.rowSelectionChanged($scope, ctrl.gridOptions.rowSelectionChanged);
        }
        if (angular.isFunction(ctrl.gridOptions.rowSelectionChangedBatch)) {
            gridApi.selection.on.rowSelectionChangedBatch($scope, ctrl.gridOptions.rowSelectionChangedBatch);
        }
        $scope.params.gridApi = gridApi;
        $scope.viewGridOptions.gridApi = gridApi;
        setHeightToPageSize();
    }

    function pageChangedCallback(newPage, pageSize) {
        console.log("Paged change");
        $scope.params.pageNumber = newPage;
        $scope.params.pageSize = pageSize;
        setHeightToPageSize();
        $scope.getList({$params: $scope.params});
    }

    function sortChangedCallback(scope, sortColumns) {
        $scope.params.sortFields = '';
        $scope.params.sortOrder = '';
        var sep = '';
        sortColumns.forEach(function(col) {
            $scope.params.sortFields += sep + col.field;
            $scope.params.sortOrder += sep + col.sort.direction;
            sep = ',';
        });
        $scope.getData({$params: $scope.params});
    }

    function filterChangedCallback() {
        $scope.params.filterQuery = {};
        if ($scope.params.filters === undefined){
          $scope.params.filters = [];
        }
        $scope.params.filters.length = 0;
        $scope.viewGridOptions.columnDefs.forEach(function (col) {
            if (col.filters) {
                col.filters.forEach(function (filter) {
                    var term = filter.term;
                    var field = col.field;

                    if (angular.isDefined(col.sixFilteringCallback)) {
                        term = col.sixFilteringCallback(term);
                    }

                    if (term && term != '') {
                        var item = {
                            column: field,
                            value: term,
                            relation: '=',
                            kind: filter.kind
                        };
                        if (filter.relation) {
                            item.relation = filter.relation;
                        }
                        if (filter.kind === 'string') {
                            item.relation = 'LIKE';
                        }
                        if (filter.aliasResolver) {
                            // Questo mi serve se ho fatto dei select pippo as pluto:
                            // a video stampo pippo ma nella query serve pluto sennò scala si offende
                            var tokens = filter.aliasResolver.split(",");
                            if(tokens.length==0){
                                item.column = tokens[0];
                            }
                            else{
                                var query = '(';
                                tokens.forEach(function(t){
                                    query += t + ' ILIKE \'%' + term + '%\' OR ';
                                });
                                query = query.slice(0, -4);
                                query += ')';
                                var item = {
                                    column: '',
                                    value: query,
                                    relation: '',
                                    kind: 'custom'
                                };
                            }
                        }

                        if (filter.type === 'lookup') {
                            addLookupFilters(filter, term);
                        }
                        else {
                            $scope.params.filters.push(item);
                        }

                    }
                });
            }
        });
        // Timeout per evitare rimbalzi di chiamate.
        if (angular.isDefined(filterTimeout)) {
            $timeout.cancel(filterTimeout);
        }
        filterTimeout = $timeout(function () {
            $scope.getData({$params: $scope.params});
        }, 200);
    }

    function addLookupFilters(filter,term){
        $scope.params.filters.push(filter.join);
        var array = [];
        if(filter.schema.mapping.code){
            array.push(filter.schema.mapping.code);
        }
        if(filter.schema.mapping.description){
            var tokens = filter.schema.mapping.description.split(",");
            tokens.forEach(function(t){
                array.push(t);
            });
        }
        var query = '(';
        array.forEach(function(t){
            query += filter.schema.entity_id + '.' + t + ' ILIKE \'%' + term + '%\' OR ';
        });
        query = query.slice(0, -4);
        query += ')';
        var item = {
            column: '',
            value: query,
            relation: '',
            kind: 'custom'
        };
        $scope.params.filters.push(item);
    };

    // ***** EXPORT ***** //

    function exportVisibles() {
      sixExportLib.exportXLSXVisibleRowsGrid($scope.params.gridApi, 'download', $filter);
    }

    function exportAll() {
      if(angular.isFunction($scope.getAllData)) {
        sixExportLib.exportXLSXRowsGrid($scope.params.gridApi, $scope.getAllData(), 'export');
      } else {
        console.log('get-all-data-allback attribute is not a function: exporting only grid known rows');
        sixExportLib.exportXLSXAllRowsGrid($scope.params.gridApi, 'export');
      }
    }

    // ***** RESIZE GRID ***** //

    function setHeightToPageSize(extra) {
        var height = $scope.itemsList.length * $scope.viewGridOptions.rowHeight;
        console.log(height)
        if ($scope.viewGridOptions.enablePaginationControls != false) {
            height += 154; // space for pagination
        }
        if (extra) {
          height += extra;
        }
        $scope.params.gridApi.grid.gridHeight = height;
      }

    //__main__
    if (!ctrl.lazyInit) $scope.getList({$params: $scope.params});
});



'use strict';

/**
 * Created by Filippo Muzzini on 05/07/19.
 * @ngdoc component
 * @name emma.theme.component:sixGridPagination
 * @description
 * # sixGridPagination
 */
angular.module('ictportal.theme').component('sixGridPaginationExpandable',{
      restrict: 'E',
      controller: 'sixGridPaginationExpandableController',
      templateUrl: 'theme/components/sixgridpaginationexpandable/sixgridpaginationexpandable.html',
      bindings: {
        getDataCallback: '&',  // on sort or filter change or serch input key-up event (if showGlobalSearch is true)
        getListCallback: '&?', // on update pagination event and on initialization. Deafult === getDataCallback
        getAllDataCallback: '&?',
        gridOptions: '=',
        itemsList: '=?', // deprecated use gridOptions.data
        columnDefs: '=?', // deprecated use gridOptions.columnDefs
        params: '=',
        showGlobalSearch: '=',
        lazyInit: '@' // set to true for skip initial loading
      }
  });


'use strict';

/**
 * Created by Rita Beltrami on 05/09/16.
 */
angular.module('ictportal.theme').controller('sixProfileController', function ($scope, $rootScope, authFactory, loginFactory, dialogService, $route, SIDE_PROFILE) {

    var ctrl = this;

    $scope.sxId = "six-profile";
    $scope.sxTitle = "Profilo";
    $scope.sxOpened = false;

    $scope.tabHeaderList = ctrl.sxProfileItems;

    function init(){
       // Ho tolto filtri, li rimuovo anche dal local storage
       if($scope.tabHeaderList.length<$scope.userInfo().profile.items.length){
            var reset = [];
            $scope.switchProfile($scope.userInfo().profile.items[0],reset);
       }
    }

    $scope.isLoggedIn = function() {
        return authFactory.isAuthenticated();
    };

    $scope.userInfo = function(){
        if($scope.isLoggedIn()){
            var authData = authFactory.getAuthData();
            if (authData.options === undefined) {
                //default
                authData.options = {
                    admin: false,
                    config: false,
                    revokeAdmin: false,
                    touch: false
                };
            }
            return authData;
        }else{
            return;
        }
    };

    function getSelectedDescription(type, currentProfiles){
        var description = '';
        for(var i=0; i<currentProfiles.length; i++){
            if(currentProfiles[i].type===type){
                description = currentProfiles[i].description;
                break;
            }
        };
        return description;
    };

    function selectProfile(item, currentProfiles){
        var found = false;
        if(currentProfiles===null){
            currentProfiles = [];
        }
        for(var i=0; i<currentProfiles.length; i++){
            if(currentProfiles[i].type===item.type){
                currentProfiles[i] = item;
                found = true;
                break;
            }
        };
        if(!found){
            currentProfiles.push(item);
        }
        return currentProfiles;
    }

    $scope.isItemSelected = function(item){
        var isSelected = false;
        var profileItems = $scope.userInfo().profile.items;
        if(profileItems.length>0){
            profileItems.forEach(function(p){
                if( (p.type===item.type) && (p.code===item.code) ) {
                    isSelected = true;
                }
            });
        }
        return isSelected;
    };

    $scope.switchProfile = function(item, currentProfiles){
        dialogService.loading('Cambio profilo <i class="fa fa-angle-double-right"></i> '+ item.description);

        currentProfiles = selectProfile(item, currentProfiles);

        var description = '';
        var i=0;
        $scope.tabHeaderList.forEach(function(element){
            // Non serve a niente, solo per eventuale debug del backend.
            var label = (getSelectedDescription(element.type, currentProfiles));
            if(label!==''){
                description += " [" + i + "] " + label;
            }
            i++;
        });

        var commissionCode = '';
        for(var i=0; i<currentProfiles.length; i++){
            if(currentProfiles[i].type==='commission'){
                commissionCode = currentProfiles[i].code;
                break;
            }
        };

        var switchProfileElement = {
          selected : {
            type:'',
            cod: 0,
            code: commissionCode,
            description: description,
            items: currentProfiles
          }
        };

        loginFactory.switch(switchProfileElement).$promise.then(function (response) {
          authFactory.setAuthData(response);
          $route.reload();
          loadData();
          dialogService.stopLoading();
        });
    };

    $rootScope.$on('sixFramework:close-profile', function(event, param) {
        $scope.sxOpened = false;
    });

    $rootScope.$on('sixFramework:toggle-profile', function(event, param) {
        if(SIDE_PROFILE){
            $scope.sxOpened = !$scope.sxOpened;
            if($scope.sxOpened){
                loadData();
            }
        }
    });

    function loadData(){
        $('#sx-profile-tab-headers').find("li").removeClass('active');
        $('#sx-profile-tab-headers').find("li").first().addClass('active');
        var authInfo = $scope.userInfo();
        if(angular.isDefined(authInfo) && angular.isDefined($scope.tabHeaderList)){
            $scope.tabBodyList = [];
            $scope.tabHeaderList.forEach(function (item) {
                var type = item.type;
                var body = {};
                if(angular.isDefined(type)){
                    var body = {
                        label: item.label,
                        type: type,
                        list: getItemsList(authInfo, type),
                        current: getCurrentItem(authInfo, type),
                        filter: ''
                    };
                    $scope.tabBodyList.push(body);
                }
            });
        }
    }

    function getItemsList(authInfo, type){
        var list = [];
        if(angular.isDefined(authInfo.profiles)){
            authInfo.profiles.forEach(function(item){
                if(type===item.type){
                    list.push(item);
                }
            });
        }
        return list;
    };

    function getCurrentItem(authInfo, type){
        var result = undefined;
        var list = authInfo.profile.items;
        if(angular.isDefined(list)){
            for(var i=0; i<list.length; i++){
                if(type===list[i].type){
                    result = list[i];
                    break;
                }
            }
        }
        return result;
    };

    //___main___
    init();

});







'use strict';

/**
 * Created by Rita Beltrami on 05/09/16.
 * @ngdoc component
 * @name emma.theme.component:sixProfile
 * @description Panel to handle the selection of current applicaction profile
 * (i.e. selezione commessa/cliente correnti)
 * # sixSearchSingleTerm
 */
angular.module('ictportal.theme').component('sixProfile',{
      restrict: 'E',
      controller: 'sixProfileController',
      templateUrl: 'theme/components/sixprofile/sixprofile.html',
      bindings: {
        sxProfileItems: '='
      },
      link: function postLink(scope, element, attrs) {

      }
  });


'use strict';

/**
 * Created by Rita Beltrami on 21/07/16.
 */
angular.module('ictportal.theme').controller('sixSearchFiltersController', function ($scope, lookupFactory, DATA_SET_URL) {

    var ctrl = this;
    $scope.searchResult = ctrl.sxList;
    $scope.sxOpen = ctrl.sxOpen;
    $scope.sxId = ctrl.sxId;
    $scope.sxModel = ctrl.sxModel || undefined;
    $scope.sxFilterOnly = ctrl.sxFilterOnly || false;
    $scope.sxFilter = ctrl.sxFilter;
    $scope.sxOnFilterChanged = ctrl.sxOnFilterChanged;
    $scope.sxOnListChanged = ctrl.sxOnListChanged;
    $scope.loading = true;
    $scope.showSelectModel = ctrl.sxShowSelectSchema | angular.isUndefined(ctrl.sxModel);


    $scope.$watchCollection('sxOpen.open',
        function(newValue, oldValue) {
            //alert(test);
        }
    );

    $scope.params = {
        type_id: {},
        type_obj: $scope.def,
        attributes: [],
        attributes_unfiltered: [],
        terms:[
            {
                attribute_obj: {},
                attribute_rel: 'equal'
            }
        ]
    };

    $scope.$watchCollection('sxModel.type_obj',
        function(newValue, oldValue) {
            $scope.params.type_id = $scope.sxModel.type_id;
            $scope.params.type_obj = $scope.sxModel.type_obj;
            $scope.showSelectModel = ctrl.sxShowSelectSchema | angular.isUndefined(ctrl.sxModel);
        }
    );

    $scope.addSearchTerm = function(){
        var term = {
            attribute_obj: {},
            attribute_rel: 'equal'
        };
        $scope.params.terms.push(term);
    };

    // Se cambia il modello di riferimento, parso l'oggetto (schema-form) per compilare la lista dei possibili attributi su cui filtrare.
    $scope.$watchCollection('params.type_obj',
        function(newValue, oldValue) {
          if (newValue){
            loadAttributesListFromSchemaForm(newValue);
            initFilters();
          }
        }
    );

    function loadAttributesListFromSchemaForm(newValue){
        $scope.setValue(undefined);
        $scope.setObject(undefined);
        $scope.params.attributes = [];
        $scope.params.attributes_unfiltered = [];
        if(angular.isDefined(newValue) && angular.isDefined(newValue.model)){
            for(var q=0; q<newValue.model.form.length; q++){
                var form = newValue.model.form[q];
                for(var i=0; i<form.items.length; i++){
                    var its = form.items[i];
                    parseFormItems(its,newValue.model.schema.properties);
                }
            }
        }
    }

    function parseFormItems(its,properties) {
        for(var j=0; j<its.tabs.length; j++){
            var tab = its.tabs[j];
            for(var k=0; k<tab.items.length; k++){
                var item = tab.items[k];
                if(item.type!='sixinherit' && item.type!='array'){
                    $scope.params.attributes_unfiltered.push(item);
                    $scope.params.attributes = $scope.params.attributes_unfiltered.slice(0, $scope.params.attributes_unfiltered.length);
                }
            }
        }
    }

    $scope.setValue = function(value){
        for(var i=0; i<$scope.params.terms.length; i++){
            $scope.params.terms[i].attribute_value = value;
        }
    };

    $scope.setObject = function(obj){
        for(var i=0; i<$scope.params.terms.length; i++){
            $scope.params.terms[i].attribute_obj = obj;
        }
    };

    $scope.clearSelect = function() {
        $scope.setValue(undefined);
        $scope.setObject(undefined);
        $scope.refreshData();
    };

    function getPath(){
        var path = 'record' + '/' + $scope.params.type_id.UUID + '/_lookup';
        return path;
    }

    function getWarUrl(){
        var url = DATA_SET_URL + '/api/';
        return url;
    }

    function getPayload() {
        var payload = {
          page: 1,
          page_size: 10000,
          show_revision: false

        };
        return payload;
    }

    function fillFilter(filter, i) {
      if(angular.isDefined($scope.params.terms[i].attribute_obj) && angular.isDefined($scope.params.terms[i].attribute_value)){
        var attribute = 'model.' + $scope.params.terms[i].attribute_obj.key[0];

        switch($scope.params.terms[i].attribute_obj.type){
          case 'text':
          case 'uiselectmultiple':
            var value = $scope.params.terms[i].attribute_value;
            if (value && value != '') {
              filter[attribute] = sixFiltersLib.text(attribute, '*'+value+'*');
            }
            break;
          case 'datepicker':
          case 'number':
            var value = $scope.params.terms[i].attribute_value;
            if (value && value != '') {
              var f = filter[attribute];
              filter[key] = sixFiltersLib.updateRange(attribute, value, $scope.params.terms[i].attribute_rel, f);
            }

            break;
          case 'checkbox':
            var value = $scope.params.terms[i].attribute_value;
            filter[attribute] = sixFiltersLib.bool(attribute, value);
            break;
          case 'sixlookup':
            var value = $scope.params.terms[i].attribute_value.UUID;
            attribute += '.UUID';
            filter[attribute] = sixFiltersLib.text(attribute, value);

            break;
          case 'uiselect':
            var value = $scope.params.terms[i].attribute_value.value;
            filter[attribute] = sixFiltersLib.text(attribute, value);
            break;
          default:
            break;
        }
      }
      return filter;
    }

    function fillFilterDescription(filter, i) {
        var attribute;
        var rel = '=';
        var value;
        if(angular.isDefined($scope.params.terms[i].attribute_obj) && angular.isDefined($scope.params.terms[i].attribute_value)){
           attribute = $scope.params.terms[i].attribute_obj.title;

            switch($scope.params.terms[i].attribute_obj.type){
                case 'text':
                case 'uiselectmultiple':
                case 'checkbox':
                    value = $scope.params.terms[i].attribute_value;
                    break;
                case 'uiselect':
                    value = $scope.params.terms[i].attribute_value.name;
                    break;
                case 'datepicker':
                case 'number':
                    switch($scope.params.terms[i].attribute_rel){
                        case "lt":
                            rel = "&lt;";
                            break;
                        case "lte":
                            rel = "&le;";
                            break;
                        case "gt":
                            rel = "&gt;";
                            break;
                        case "gte":
                            rel = "&ge;";
                            break;
                    }
                    value = $scope.params.terms[i].attribute_value;
                    break;
                case 'sixlookup':
                    value = $scope.params.terms[i].attribute_value.description;
                    break;
                default:
                    break;
            }
            var obj = {
                attribute:  attribute,
                relation:   rel,
                value:      String(value)
            };
            ctrl.sxFilterDescriptionLong.push(obj);
            ctrl.sxFilterDescriptionShort += attribute  + rel + value + "; ";
        }
    }

    function fillSxFilter(filter){
        // Filtro vero e proprio
        if(angular.isDefined($scope.sxFilter)){
            for (var key in $scope.sxFilter) {
                delete $scope.sxFilter[key];
            }
            for (var key in filter) {
                $scope.sxFilter[key] = filter[key];
            }
        }
        // Descrizione parlante
        if($scope.params.terms.length>0){
            ctrl.sxFilterDescriptionLong = [];
            ctrl.sxFilterDescriptionShort = "";
            for(var i=0; i<$scope.params.terms.length; i++){
                fillFilterDescription(filter,i);
            }
        }
        else{
            ctrl.sxFilterDescriptionLong = [];
            ctrl.sxFilterDescriptionShort = "";
        }
        $scope.sxOnFilterChanged();
    }

    function fillSxModel(){
        if( ctrl.sxShowSelectSchema ){
            $scope.sxModel.type_id = JSON.parse(JSON.stringify($scope.params.type_id));
            $scope.sxModel.type_obj = JSON.parse(JSON.stringify($scope.params.type_obj));
        }
    }

    $scope.getFiltersList = function(){
        var filter = {};
        // Compongo il mio filtro interno per la ricerca
        for(var i=0; i<$scope.params.terms.length; i++){
            fillFilter(filter,i);
        }
        // Se il modello è stato scelto da me, ripasso indietro anche la sua descrizione.
        fillSxModel();
        // Compongo il filtro da ripassare all'esterno a chi mi sta chiamando
        fillSxFilter(filter);
        return filter;
    };

    $scope.search = function() {
        $scope.searchResult.length = 0;
        lookupFactory(getWarUrl(),getPath()).search(getPayload(), $scope.getFiltersList()).$promise.then(function(data) {
            if(angular.isDefined(data) && data.hasOwnProperty('list')) {
                for(var i=0; i<data.list.length; i++){
                    $scope.searchResult.push(data.list[i]);
                }
                $scope.sxOnListChanged();
            }
        });
    };

    function isEmpty(obj){
        return Object.keys(obj).length === 0;
    }

    function initFilters(){
        // Può essere che da fuori mi siano stai impostati dei filtri di default da applicare...
        if($scope.loading){
            // probabilmente ha più senso salvare proprio tutto l'oggetto come lo vuole la direttiva
            if(angular.isDefined(ctrl.sxFilterInit)){
                $scope.params.terms = ctrl.sxFilterInit;
            }
        }
        else{
            $scope.loading = false;
        }
    }

  });







'use strict';

/**
 * Created by Rita Beltrami on 21/07/16.
 * @ngdoc component
 * @name emma.theme.component:sixSearchTerms
 * @description Advanced search con multiple fields
 * # sixSearchTerms
 */
angular.module('ictportal.theme').component('sixSearchFilters',{
      restrict: 'E',
      controller: 'sixSearchFiltersController',
      templateUrl: 'theme/components/sixsearchfilters/sixsearchfilters.html',
      bindings: {
        sxList: '=',
        sxOpen: '=',
        sxId: '@',
        sxModel: '=?',
        sxFilterOnly: '=',
        sxFilter: "=",
        sxFilterDescription: "=?",
        sxFilterDescriptionLong: "=?",
        sxFilterDescriptionShort: "=?",
        sxFilterInit: "=",
        sxOnFilterChanged: "&",
        sxOnListChanged: "&",
        sxShowSelectSchema: "="
      },
      link: function postLink(scope, element, attrs) {

      }
  });


'use strict';

/**
 * Created by Rita Beltrami on 21/07/16.
 */
angular.module('ictportal.theme').controller('sixSearchSingleTermController', function ($scope) {

    var ctrl = this;
    $scope.params = ctrl.sxParams;
    $scope.filter = ctrl.sxFilter;
    $scope.index = ctrl.sxPosition;
    $scope.ngModel = $scope.params.terms[$scope.index].attribute_obj ;

    $scope.dateOptions = {
        formatYear: 'yyyy',
        opened: false
    };

    $scope.setValue = function(value){
        $scope.params.terms[$scope.index].attribute_value = value;
    };

    $scope.setObject = function(obj){
        $scope.params.terms[$scope.index].attribute_obj = obj;
    };

    $scope.clearSelect = function() {
        $scope.setValue(undefined);
        $scope.setObject(undefined);
        $scope.refreshData();
    };

    $scope.selectAttribute = function (item){
        $scope.setObject(item);
        $scope.setValue(undefined);
    };

    $scope.isRel = function() {
        var isARelation = false;
        if(angular.isDefined($scope.params.terms[$scope.index].attribute_obj)){
            switch($scope.params.terms[$scope.index].attribute_obj.type){
                case 'datepicker':
                case 'number':
                    isARelation = true;
                    break;
                default:
                isARelation = false;
            }
        }
        return isARelation;
    };

    $scope.selectAttributeValue = function (item){
        $scope.params.terms[$scope.index].attribute_value = item;
    };

    $scope.removeTerm = function () {
        $scope.params.terms.splice($scope.index, 1);
    };

    $scope.refreshData = function(search){
        $scope.params.attributes = [];
        if(angular.isUndefined(search)){
            $scope.params.attributes = $scope.params.attributes_unfiltered.slice(0, $scope.params.attributes_unfiltered.length);
        }
        else{
            var toLower = search.toLowerCase();
            for(var i=0; i<$scope.params.attributes_unfiltered.length; i++){
                var title = $scope.params.attributes_unfiltered[i].title.toLowerCase(); ;
                if(title.indexOf(toLower) > -1){
                    $scope.params.attributes.push($scope.params.attributes_unfiltered[i]);
                }
            }
        }
    };

  });







'use strict';

/**
 * Created by Rita Beltrami on 21/07/16.
 * @ngdoc component
 * @name emma.theme.component:sixSearchSingleTerm
 * @description Single line of advanced search form
 * # sixSearchSingleTerm
 */
angular.module('ictportal.theme').component('sixSearchSingleTerm',{
      restrict: 'E',
      controller: 'sixSearchSingleTermController',
      templateUrl: 'theme/components/sixsearchsingleterm/sixsearchsingleterm.html',
      bindings: {
        onRemove: '&',
        sxParams: '=',
        sxPosition: '=',
        sxFilter: '='
      },
      link: function postLink(scope, element, attrs) {

      }
  });


'use strict';

/**
 * Created by Rita Beltrami on 21/07/16.
 */
angular.module('ictportal.theme').controller('sixSearchTermsController', function ($scope, lookupFactory, DATA_SET_URL) {

    var ctrl = this;
    $scope.searchResult = ctrl.sxList;
    $scope.sxOpen = ctrl.sxOpen;
    $scope.sxId = ctrl.sxId;
    $scope.sxModel = ctrl.sxModel || undefined;
    $scope.sxFilterOnly = ctrl.sxFilterOnly || false;
    $scope.sxFilter = ctrl.sxFilter;
    $scope.sxOnFilterChanged = ctrl.sxOnFilterChanged;
    $scope.sxOnListChanged = ctrl.sxOnListChanged;
    $scope.loading = true;
    $scope.showSelectModel = ctrl.sxShowSelectSchema | angular.isUndefined(ctrl.sxModel);


    $scope.$watchCollection('sxOpen.open',
        function(newValue, oldValue) {
            //alert(test);
        }
    );

    $scope.params = {
        type_id: {},
        type_obj: $scope.def,
        attributes: [],
        attributes_unfiltered: [],
        terms:[
            {
                attribute_obj: {},
                attribute_rel: 'equal'
            }
        ]
    };

    $scope.$watchCollection('sxModel.type_obj',
        function(newValue, oldValue) {
            $scope.params.type_id = $scope.sxModel.type_id;
            $scope.params.type_obj = $scope.sxModel.type_obj;
            $scope.showSelectModel = ctrl.sxShowSelectSchema | angular.isUndefined(ctrl.sxModel);
        }
    );

    $scope.addSearchTerm = function(){
        var term = {
            attribute_obj: {},
            attribute_rel: 'equal'
        };
        $scope.params.terms.push(term);
    }

    // Se cambia il modello di riferimento, parso l'oggetto (schema-form) per compilare la lista dei possibili attributi su cui filtrare.
    $scope.$watchCollection('params.type_obj',
        function(newValue, oldValue) {
          if (newValue != oldValue){
            loadAttributesListFromSchemaForm(newValue);
            initFilters();
          }
        }
    );

    function loadAttributesListFromSchemaForm(newValue){
        $scope.setValue(undefined);
        $scope.setObject(undefined);
        $scope.params.attributes = [];
        $scope.params.attributes_unfiltered = [];
        if(angular.isDefined(newValue) && angular.isDefined(newValue.model)){
            for(var q=0; q<newValue.model.form.length; q++){
                var form = newValue.model.form[q];
                for(var i=0; i<form.items.length; i++){
                    var its = form.items[i];
                    parseFormItems(its,newValue.model.schema.properties);
                }
            }
        }
    };

    function parseFormItems(its,properties) {
        for(var j=0; j<its.tabs.length; j++){
            var tab = its.tabs[j];
            for(var k=0; k<tab.items.length; k++){
                var item = tab.items[k];
                if(item.type!='sixinherit' && item.type!='array'){
                    $scope.params.attributes_unfiltered.push(item);
                    $scope.params.attributes = $scope.params.attributes_unfiltered.slice(0, $scope.params.attributes_unfiltered.length);
                }
            }
        }
    }

    $scope.setValue = function(value){
        for(var i=0; i<$scope.params.terms.length; i++){
            $scope.params.terms[i].attribute_value = value;
        }
    }

    $scope.setObject = function(obj){
        for(var i=0; i<$scope.params.terms.length; i++){
            $scope.params.terms[i].attribute_obj = obj;
        }
    }

    $scope.clearSelect = function() {
        $scope.setValue(undefined);
        $scope.setObject(undefined);
        $scope.refreshData();
    };

    function getPath(){
        var path = 'record' + '/' + $scope.params.type_id.UUID + '/_lookup';
        return path;
    }

    function getWarUrl(){
        var url = DATA_SET_URL + '/api/';
        return url;
    }

    function getPayload() {
        var payload = {
          page: 1,
          page_size: 10000,
          show_revision: false

        };
        return payload;
    }

    /* Compongo il filtro per eseguire la query */
    function fillFilter(filter, i) {
        if(angular.isDefined($scope.params.terms[i].attribute_obj) && angular.isDefined($scope.params.terms[i].attribute_value)){
            var attribute = 'model.' + $scope.params.terms[i].attribute_obj.key[0];

            switch($scope.params.terms[i].attribute_obj.type){
                case 'text':
                case 'uiselectmultiple':
                    var value = $scope.params.terms[i].attribute_value;
                    if (value && value != '') {
                        filter[attribute] = '*'+value+'*';
                    }
                    break;
                case 'datepicker':
                case 'number':
                    var value = $scope.params.terms[i].attribute_value;
                    if (value && value != '') {
                        filter['_range'] = {
                            key: attribute,
                            relation: $scope.params.terms[i].attribute_rel,
                            value: value
                        };
                    }
                    break;
                case 'checkbox':
                    var value = $scope.params.terms[i].attribute_value;
                    filter[attribute] = value;
                    break;
                case 'sixlookup':
                    var value = $scope.params.terms[i].attribute_value.UUID;
                    attribute += '.UUID';
                    filter[attribute] = value;
                    break;
                case 'uiselect':
                    var value = $scope.params.terms[i].attribute_value.value;
                    filter[attribute] = value;
                    break;
                default:
                    break;
            }
        }
        return filter;
    }

    function fillFilterDescription(filter, i) {
        var attribute;
        var rel = '=';
        var value;
        if(angular.isDefined($scope.params.terms[i].attribute_obj) && angular.isDefined($scope.params.terms[i].attribute_value)){
           attribute = $scope.params.terms[i].attribute_obj.title;

            switch($scope.params.terms[i].attribute_obj.type){
                case 'text':
                case 'uiselectmultiple':
                case 'checkbox':
                    value = $scope.params.terms[i].attribute_value;
                    break;
                case 'uiselect':
                    value = $scope.params.terms[i].attribute_value.name;
                    break;
                case 'datepicker':
                case 'number':
                    switch($scope.params.terms[i].attribute_rel){
                        case "lt":
                            rel = "&lt;";
                            break;
                        case "lte":
                            rel = "&le;";
                            break;
                        case "gt":
                            rel = "&gt;";
                            break;
                        case "gte":
                            rel = "&ge;";
                            break;
                    }
                    value = $scope.params.terms[i].attribute_value;
                    break;
                case 'sixlookup':
                    value = $scope.params.terms[i].attribute_value.description;
                    break;
                default:
                    break;
            }
            var obj = {
                attribute:  attribute,
                relation:   rel,
                value:      String(value)
            };
            ctrl.sxFilterDescriptionLong.push(obj);
            ctrl.sxFilterDescriptionShort += attribute  + rel + value + "; ";
        }
    }

    function fillSxFilter(filter){
        // Filtro vero e proprio
        if(angular.isDefined($scope.sxFilter)){
            for (var key in $scope.sxFilter) {
                delete $scope.sxFilter[key];
            }
            for (var key in filter) {
                $scope.sxFilter[key] = filter[key];
            }
        }
        // Descrizione parlante
        if($scope.params.terms.length>0){
            ctrl.sxFilterDescriptionLong = [];
            ctrl.sxFilterDescriptionShort = "";
            for(var i=0; i<$scope.params.terms.length; i++){
                fillFilterDescription(filter,i);
            }
        }
        else{
            ctrl.sxFilterDescriptionLong = [];
            ctrl.sxFilterDescriptionShort = "";
        }
        $scope.sxOnFilterChanged();
    }

    function fillSxModel(){
        if( ctrl.sxShowSelectSchema ){
            $scope.sxModel.type_id = JSON.parse(JSON.stringify($scope.params.type_id));
            $scope.sxModel.type_obj = JSON.parse(JSON.stringify($scope.params.type_obj));
        }
    };

    $scope.getFiltersList = function(){
        var filter = {};
        // Compongo il mio filtro interno per la ricerca
        for(var i=0; i<$scope.params.terms.length; i++){
            fillFilter(filter,i);
        }
        // Se il modello è stato scelto da me, ripasso indietro anche la sua descrizione.
        fillSxModel();
        // Compongo il filtro da ripassare all'esterno a chi mi sta chiamando
        fillSxFilter(filter);
        return filter;
    }

    $scope.search = function() {
        $scope.searchResult.length = 0;
        lookupFactory(getWarUrl(),getPath()).search(getPayload(), $scope.getFiltersList()).$promise.then(function(data) {
            if(angular.isDefined(data) && data.hasOwnProperty('list')) {
                for(var i=0; i<data.list.length; i++){
                    $scope.searchResult.push(data.list[i]);
                }
                $scope.sxOnListChanged();
            }
        });
    }

    function isEmpty(obj){
        return Object.keys(obj).length === 0;
    }

    function initFilters(){
        // Può essere che da fuori mi siano stai impostati dei filtri di default da applicare...
        if($scope.loading){
            // probabilmente ha più senso salvare proprio tutto l'oggetto come lo vuole la direttiva
            if(angular.isDefined(ctrl.sxFilterInit)){
                $scope.params.terms = ctrl.sxFilterInit;
            }
        }
        else{
            $scope.loading = false;
        }
    }

  });







'use strict';

/**
 * Created by Rita Beltrami on 21/07/16.
 * @ngdoc component
 * @name emma.theme.component:sixSearchTerms
 * @description Advanced search con multiple fields
 * # sixSearchTerms
 */
angular.module('ictportal.theme').component('sixSearchTerms',{
      restrict: 'E',
      controller: 'sixSearchTermsController',
      templateUrl: 'theme/components/templates/sixsearchterms.html',
      bindings: {
        sxList: '=',
        sxOpen: '=',
        sxId: '@',
        sxModel: '=?',
        sxFilterOnly: '=',
        sxFilter: "=",
        sxFilterDescription: "=?",
        sxFilterDescriptionLong: "=?",
        sxFilterDescriptionShort: "=?",
        sxFilterInit: "=",
        sxOnFilterChanged: "&",
        sxOnListChanged: "&",
        sxShowSelectSchema: "="
      },
      link: function postLink(scope, element, attrs) {

      }
  });


'use strict';

/**
 * Created by Rita Beltrami on 22/06/16.
 */
angular.module('ictportal.theme').controller('sixTreeAttachmentsController', function ($scope, FileUploader, authFactory) {

    // variabile per riabilitare tutte le funzionalità di cancellazione ecc.!
    $scope.fullMode = false;

    var ctrl = this;
    $scope.nodes = ctrl.nodes;

    if(angular.isDefined(ctrl.sxReadonly) && ctrl.sxReadonly){
        $scope.sxReadonly = true;
    }
    else{
        $scope.sxReadonly = false;
    }

    var defaultAttachment = {
                "id": 0,
                "title": "Documenti",
                "folder": true,
                "readonly": true,
                "nodes": []
            };
    if(angular.isUndefined(ctrl.nodes)){
        ctrl.nodes = [];
        $scope.nodes = ctrl.nodes;
    }
    if($scope.nodes.length==0){
        $scope.nodes.push(defaultAttachment);
    }

    // var DESTINATION = "/Sites/emma/documentLibrary/" + authFactory.getAuthData().info.commissions.current.code;
    var DESTINATION = "/Sites/emma/" + authFactory.getAuthData().info.commissions.current.code;
    $scope.DOWNLOAD_URL = "/six-alfresco/api/alfresco/";

    var uploader = $scope.uploader = new FileUploader({
                                            url: 'six-alfresco/upload',
                                            formData: [
                                                {destination: DESTINATION}
                                            ]
                                        });

    // Variabili temporanee per salvare lo stato del componente.
    $scope.opt={dragEnabled: true};
    $scope.edit={};
    $scope.upload={show:false};

     // Tree tree callbacks
    $scope.treeOptions = {
      // Richiamata quando si cerca di trascinare un nodo in un punto dell'albero:
      // controlla se la destinazione può accettare il nodo
      accept: function(sourceNodeScope, destNodesScope, destIndex) {
        var destNode = $scope.tree;
        if(destNodesScope.$nodeScope != undefined) {  // per evitare errori nel log
          destNode = destNodesScope.$nodeScope.$modelValue;
        }
        var sourceNode = sourceNodeScope.$modelValue;
        // il nodo è ammesso se è previsto nella struttura del tree e non è già stato inserito
        return isChildAllowed(sourceNodeScope.$modelValue, destNode);
      },
      beforeDrag: function(sourceNodeScope) {
        return $scope.isWritePermAllowed();
      },
      dropped: function(event){
          //var destBrothers = event.dest.nodesScope.$modelValue;
          //sortNodes(destBrothers);
          doSave();
      }
    };

    // TODO: fixme
    function sortNodes(nodes){
        var firstFolderIndex = -1;
        for(var i=0; i<nodes.length; i++){
            if(nodes[i].folder){
                firstFolderIndex = i;
                break;
            }
        }
        if(firstFolderIndex>=0){
            var moveMeIndex = [];
            for(var i=0; i<nodes.length; i++){
                if( (!nodes[i].folder) && i>firstFolderIndex){
                    moveMeIndex.push(i);
                }
            }
            if(moveMeIndex.length>0){
                var moveMeNode = [];
                for(var i=0; i<moveMeIndex.length; i++){
                    var index = moveMeIndex[i];
                    moveMeNode.push(JSON.parse(JSON.stringify(nodes[index])));
                }
                for(var i=moveMeIndex.length-1; i>=0; i--){
                    var index = moveMeIndex[i];
                    nodes.splice(index, 1);
                }
                for(var i=0; i<moveMeNode.length; i++){
                    nodes.splice(firstFolderIndex,0,moveMeNode[i]);
                }
            }
        }
    }

    var isChildAllowed = function(node, parent) {
      // solo le cartelle possono contenere altri nodi.
      var result = false;
      if(angular.isDefined(parent)){
          if(parent.folder){
            result = true;
          }
      }
      return result;
    };

    $scope.undoUpload = function(){
        $scope.upload = {show: false};
        uploader.clearQueue();
    }

    function addUploadedFileToTree(fileItem){
        var nodeData = $scope.upload.nodeData;
        nodeData.nodes.push({
            id: nodeData.id * 10 + nodeData.nodes.length,
            title: fileItem.file.name,
            folder: false,
            readonly: false,
            user: authFactory.getAuthData().authId,
            date: new Date(),
            destination: DESTINATION,
            object_id: fileItem.objectId,
            nodes: []
        });
        doSave();
    }

    $scope.newFileNode = function (scope) {
        var nodeData = scope.$modelValue;
        $scope.upload={
            show: true,
            started: false,
            completed: false,
            nodeData: nodeData
        };
    };

    $scope.newFolderNode = function (scope) {
        var nodeData = scope.$modelValue;
        nodeData.nodes.push({
            id: nodeData.id * 10 + nodeData.nodes.length,
            title: 'Nuova cartella ' + '.' + (nodeData.nodes.length + 1),
            folder: true,
            readonly: false,
            nodes: []
        });
        doSave();
    };

    $scope.stopEditing = function(){
        if($scope.opt.dragEnabled  == false){
            $scope.opt.dragEnabled  = true;
            $scope.edit.writeSpan.hide();
            $scope.edit.readSpan.show();
        }
    };

    $scope.renameNode = function(obj){
        if($scope.opt.dragEnabled  == false){
            $scope.stopEditing();
        }
        else{
            $scope.opt.dragEnabled  = false;
            var parent = $(obj.target).parents( "div:first" );
            var writeSpan = parent.find('.file-title-write');
            var readSpan = parent.find('.file-title-read');
            $scope.edit.writeSpan = writeSpan;
            $scope.edit.readSpan = readSpan;
            $scope.edit.writeSpan.show();
            $scope.edit.readSpan.hide();
        }
    }

    $scope.confirmRename = function(obj){
        $scope.stopEditing();
        doSave();
    }

    $scope.removeFile = function(scope) {
      scope.remove();
      // TODO: rimuovere anche da ALFRESCO
      doSave();
    };

    $scope.removeFolder = function(scope) {
      $scope.emptyFolder(scope, false);
      scope.remove();
      doSave();
    };

    $scope.emptyFolder = function(scope, mustSave){
        var nodeData = scope.$modelValue;
        // TODO: rimuovere anche da ALFRESCO
        for(var i=0; i<nodeData.nodes.length; i++){
            var fileNode = nodeData.nodes[i];
            // rimuovi da ALFRESCO...
        }
        nodeData.nodes = [];
        if(mustSave){
            doSave();
        }
    }

    function doSave(){
        ctrl.nodes = $scope.nodes;
        ctrl.saveCallback();
    }

    function printUploadError(errorMessage){
        if(angular.isUndefined($scope.upload.errors)){
            $scope.upload.errors = [];
        }
        $scope.upload.errors.push(errorMessage);
    }

     /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'tree';

    $scope.isWritePermAllowed = function() {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };

    $scope.isDeletePermAllowed = function() {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };


    /** ***********************************
     * Uploader callbacks
     * ***********************************/
        uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
            console.info('onWhenAddingFileFailed', item, filter, options);
        };
        uploader.onAfterAddingFile = function(fileItem) {
            $scope.upload.completed = false;
            $scope.upload.started = false;
            console.info('onAfterAddingFile', fileItem);
        };
        uploader.onAfterAddingAll = function(addedFileItems) {
            $scope.upload.completed = false;
            $scope.upload.started = false;
            console.info('onAfterAddingAll', addedFileItems);
        };
        uploader.onBeforeUploadItem = function(item) {
            $scope.upload.started = true;
            console.info('onBeforeUploadItem', item);
        };
        uploader.onProgressItem = function(fileItem, progress) {
            console.info('onProgressItem', fileItem, progress);
        };
        uploader.onProgressAll = function(progress) {
            console.info('onProgressAll', progress);
        };
        uploader.onSuccessItem = function(fileItem, response, status, headers) {
            if(angular.isDefined(response.ERROR)){
                printUploadError(response.ERROR);
            }
            else{
                fileItem.objectId = response.objectId;
                addUploadedFileToTree(fileItem);
            }
            console.info('onSuccessItem', fileItem, response, status, headers);
        };
        uploader.onErrorItem = function(fileItem, response, status, headers) {
            printUploadError("Errore nel caricamento del file " + fileItem.file.name);
            console.info('onErrorItem', fileItem, response, status, headers);
        };
        uploader.onCancelItem = function(fileItem, response, status, headers) {
            console.info('onCancelItem', fileItem, response, status, headers);
        };
        uploader.onCompleteItem = function(fileItem, response, status, headers) {
            console.info('onCompleteItem', fileItem, response, status, headers);
        };
        uploader.onCompleteAll = function() {
            $scope.upload.completed = true;
            console.info('onCompleteAll');
        };

  });







'use strict';

/**
 * Created by Rita Beltrami on 22/06/16.
 * @ngdoc component
 * @name emma.theme.component:sixTreeAttachments
 * @description
 * # sixTreeAttachments
 */
angular.module('ictportal.theme').component('sixTreeAttachments',{
      restrict: 'E',
      controller: 'sixTreeAttachmentsController',
      templateUrl: 'theme/components/sixtreeattachments/sixtreeattachments.html',
      bindings: {
        saveCallback: '&',
        sxReadonly: '=?',
        nodes: '='
      },
      link: function postLink(scope, element, attrs) {
      }

  });


/**
 * Created by Riccardo Merolla on 02/05/15.
 */

'use strict';

angular.module('ictportal.theme').controller('sixFrameworkController',
  ['$scope', '$rootScope', '$location', '$log', '$route', 'authFactory', 'loginFactory', 'dialogService', 'localStorageService', 'recordFactory', 'dbFilterFactory', '$interval', '$filter', 'notificationFactory', 'matrixParFactory', 'wsfactory',
    function ($scope, $rootScope, $location, $log, $route, authFactory, loginFactory, dialogService, localStorageService, recordFactory, dbFilterFactory, $interval, $filter, notificationFactory, matrixParFactory, wsfactory) {

      $scope.workstation = {};
      $scope.workstation.code = localStorageService.get('workstation');

      $scope.mainBarLogout = false;

      $scope.$on('six-menu-item-selected-event', function (evt, data) {
        $scope.routeString = data.route;
      });

      $scope.menuClass = function(page) {
        var current = $location.path().substring(1);
        return page === current ? "active" : "";
      };

      $scope.isLoggedIn = function() {
        return authFactory.isAuthenticated();
      };

      $scope.logout = function() {
        authFactory.logout();
        $location.url($location.path("/login"));
      };

      $scope.toggleSidebar = function(){
          if(angular.isUndefined($rootScope.isSidebarOpen)){
            $rootScope.isSidebarOpen = false;
          }
          else{
            $rootScope.isSidebarOpen = !$rootScope.isSidebarOpen;
          }
          $rootScope.$broadcast('toggle-sidebar');
      };

      $scope.userInfo = function(){
        if($scope.isLoggedIn()){
          var authData = authFactory.getAuthData();
          if (authData.options === undefined) {
            //default
            authData.options = {
              admin: false,
              config: false,
              revokeAdmin: false,
              touch: false
            };
          }
          return authData;
        }else{
          return;
        }
      };

      matrixParFactory.getValueOrDefault({key: 'portal.mainBarLogout', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'},
        {defaultValue: null}).$promise.then(function(data){
          if (data.result && data.result.value) {
            $scope.mainBarLogout = data.result.value == "true";
          }
      });

      $scope.status = {
        isFirstOpen: true,
        isFirstDisabled: false
      };

      $scope.toggleToolbar = function(){
        $rootScope.$broadcast('toggle-toolbar');
      };

      $scope.switchProfile = function (profile, subprofile) {
        var switchProfileElement = {
          selected : {
            cod: profile.cod,
            code: profile.code,
            description: profile.description,
            items: [
              {
                cod: subprofile.cod,
                code: subprofile.code,
                description: subprofile.description
              }
            ]

          }
        };
        dialogService.loading('Cambio profilo: '+subprofile.description);
        loginFactory.switchprofile(switchProfileElement).$promise.then(function (response) {
          authFactory.setAuthData(response);
          dialogService.stopLoading();
          $route.reload();
        });
      };

      $scope.toggleProfileElement = function(){
        $rootScope.$broadcast('sixFramework:toggle-profile');
      };

      $scope.closeProfileElement = function(){
        $rootScope.$broadcast('sixFramework:close-profile');
      };

      $scope.oneAtATime = true;

      $scope.$on("$locationChangeSuccess", function (event, next, current) {
        $scope.bookmarkStar = "fa fa-star-o";
        if(checkBookmarks()){
          $scope.bookmarkStar = "fa fa-star";
        }
      });


      $scope.gestioneBookmarks = function(){

        // CHECK SE USA QUELLI DI RUOLO SE NO VA AVANTI SE NO ESEGUE LA PRIMA CREAZIONE
        var authdata = authFactory.getAuthData();
        var filter = dbFilterFactory.getStringFilter('utente_id', authdata.info.userId.toString(), '=');
        recordFactory('preferred').filter(JSON.stringify(filter))
        .$promise.then(function (pref){

          if(pref.list.length === 0){
            // QUELLI DI RUOLO
            bookmarksLoop(authdata.bookmarks, 0, function() {
              bookmarksCore(authdata);
            })
          }
          else {
            bookmarksCore(authdata);
          }

        });
      };

      $scope.isBookmarskHomePage = function() {
        var pageCode = getPageCode();
        if (pageCode && pageCode == 'bookmarks/home') {
          return true;
        }
        return false;
      }

      function bookmarksLoop(bookmarks, aindex, callback){
        if(aindex < bookmarks.length){
          var payload;
          if(getParameterByName('functionCode', bookmarks[aindex].code)) {
            payload = {
              code: 'codice',
              description: 'codice',
              query: getParameterByName('functionCode', bookmarks[aindex].code)
            }
          }
          else {
            payload = {
              code: 'angular_path',
              description: 'angular_path',
              query: bookmarks[aindex].code
            }
          }

          recordFactory('functions').query(payload)
            .$promise.then(function (data){
                var function_id;
                var descrizione;

                //non posso prendere il primo, perchè la query esegue un like?
                for (var index = 0; index < data.list.length; index++) {
                  if(payload.code === 'codice') {
                    if(data.list[index].codice === payload.query){
                      function_id = data.list[index].id;
                      descrizione = data.list[index].descrizione;
                    }
                  }
                  else {
                    //se angular prendo il primo
                    function_id = data.list[0].id;
                    descrizione = data.list[0].descrizione;
                  }
                }

                var ordine = authFactory.getAuthData().bookmarks.length + 1;
                var userId = authFactory.getAuthData().info.userId;

                var document = {
                  descrizione: descrizione,
                  ordine: ordine,
                  funzione_id: function_id,
                  utente_id: userId
                }

                recordFactory('preferred').create(document)
                .$promise.then(function(data){
                    bookmarksLoop(bookmarks, ++aindex, callback);
                });

            });
        }
        else{
          callback();
        }
      }

      function bookmarksCore(authData) {
        if(!checkBookmarks()){
          // DA CREARE
          var code = getPageCode();

          var payload;
          if($location.$$search.functionCode) {
            payload = {
              code: 'codice',
              description: 'codice',
              query: $location.$$search.functionCode
            }
          }
          else {
            payload = {
              code: 'angular_path',
              description: 'angular_path',
              query: code
            }
          }

          recordFactory('functions').query(payload)
            .$promise.then(function (data){
                var function_id;
                var descrizione;

                //non posso prendere il primo, perchè la query esegue un like?
                for (var index = 0; index < data.list.length; index++) {
                  if(payload.code === 'codice') {
                    if(data.list[index].codice === payload.query){
                      function_id = data.list[index].id;
                      descrizione = data.list[index].descrizione;
                    }
                  }
                  else {
                    //se angular prendo il primo
                    function_id = data.list[0].id;
                    descrizione = data.list[0].descrizione;
                  }
                }

                var ordine = authFactory.getAuthData().bookmarks.length + 1;
                var userId = authFactory.getAuthData().info.userId;

                var document = {
                  descrizione: descrizione,
                  ordine: ordine,
                  funzione_id: function_id,
                  utente_id: userId
                }

                recordFactory('preferred').create(document)
                .$promise.then(function(data){
                    //aggiungere bookmark nel local storage
                    var bookmark = {
                      code: code,
                      description: document.descrizione
                    }
                    addBookmarkToLocaleStorage(bookmark);
                    $scope.bookmarkStar = "fa fa-star";
                });

            });
        }
        else {
          //ELIMINA DAI PREFERITI

          var code = getPageCode();

          var payload;
          if($location.$$search.functionCode) {
            payload = {
              code: 'codice',
              description: 'codice',
              query: $location.$$search.functionCode
            }
          }
          else {
            payload = {
              code: 'angular_path',
              description: 'angular_path',
              query: code
            }
          }

          recordFactory('functions').query(payload)
            .$promise.then(function (data){
                var function_id;

                for (var index = 0; index < data.list.length; index++) {
                  if(payload.code === 'codice') {
                    if(data.list[index].codice === payload.query){
                      function_id = data.list[index].id;
                    }
                  }
                  else {
                    //se angular prendo il primo
                    function_id = data.list[0].id;
                  }
                }

                var filter = dbFilterFactory.getStringFilter('funzione_id',function_id.toString(), '=');
                filter = filter.concat(dbFilterFactory.getStringFilter('utente_id', authData.info.userId.toString(), '='));

                recordFactory('preferred').filter(JSON.stringify(filter))
                .$promise.then(function (pref){
                  if(pref.list.length > 0) {
                    var toDelete = pref.list[0];
                    if(toDelete){
                      recordFactory('preferred').delete({id: toDelete.id})
                      .$promise.then(function(data){
                        removeBookmarkToLocaleStorage(code);
                        $scope.bookmarkStar = "fa fa-star-o";
                      });
                    }
                  }
                });
            });
        }
      }

      function addBookmarkToLocaleStorage(newBookmark){
        var authdata  = authFactory.getAuthData();
        authdata.bookmarks.push(newBookmark);
        authFactory.setAuthData(authdata);
      }

      function removeBookmarkToLocaleStorage(code){
        var authdata  = authFactory.getAuthData();
        var index = authdata.bookmarks.map(function(e) { return e.code; }).indexOf(code);
        authdata.bookmarks.splice(index, 1);
        authFactory.setAuthData(authdata);
      }

      function getPageCode() {
        var code = '';
        if($location.$$search.functionCode) {
          code = 'jsf?functionCode=' + $location.$$search.functionCode;
        }
        else{
          var first_char = decodeURIComponent($location.$$url).charAt(0);
          code = first_char === '/' ? decodeURIComponent($location.$$url).replace('/','').split('?')[0] : decodeURIComponent($location.$$url);
        }
        return code;
      }

      // controllo se è nei preferiti (in authData)
      function checkBookmarks() {

        var code = getPageCode();

        var bookmarks  = authFactory.getAuthData().bookmarks;

        var preferito = bookmarks.filter(function(bookmark){
          return bookmark.code === code;
        })

        var result = preferito.length > 0 ? true : false;

        return result;

      };

      function initBookmark() {
        $scope.eggs = authFactory.getAuthData().eggs;
        $scope.bookmarkStar = "fa fa-star-o";
        if(checkBookmarks()){
          $scope.bookmarkStar = "fa fa-star";
        }
      }

      initBookmark();

      function getParameterByName(name, url) {
          if (!url) url = window.location.href;
          name = name.replace(/[\[\]]/g, '\\$&');
          var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
              results = regex.exec(url);
          if (!results) return null;
          if (!results[2]) return '';
          return decodeURIComponent(results[2].replace(/\+/g, ' '));
      }


	// NOTIFICHE
    function initNotify() {
        var workstationCode = localStorageService.get('workstation');
        if (workstationCode) {
            matrixParFactory.getValueOrDefault({key: 'abnormal.url', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}, {defaultValue: null}).$promise.then(function(data){
                if (data.result && data.result.value) {
                    var abNormalUrl = data.result.value;
                    var wsUrl;
                    if (abNormalUrl.startsWith("http"))  {
                        wsUrl = abNormalUrl.replace(/^.*?:\/\//g,"ws://");
                    }
                    else {
                        wsUrl = "ws://" + abNormalUrl;
                    }
                    var notifyProject = 'notify_'+workstationCode;
                    wsUrl = wsUrl + '/api/ws'
                    wsfactory.open(wsUrl);
                    wsfactory.send(wsUrl, {'project': notifyProject});
                    window.setInterval(function() {
                        wsfactory.send(wsUrl, { 'project': 'ping' });
                        console.log('ping ws ' + wsUrl);
                    }, 60000);
                }
            });
        }
    }

    initNotify();

    $scope.now = new Date();

    $interval(function() {
        $scope.now = new Date();
    }, 30000);  // 30 secondi

    $scope.notifications = [];

    $scope.clearNotifications = function() {
        $scope.notifications.length = 0;
    };

    $scope.removeNotification = function(n) {
        var idx = $scope.notifications.indexOf(n);
        $log.debug('Removing notification', n, idx);
        if(idx > -1) $scope.notifications.splice(idx, 1);
    };

    $scope.myDialog = {};
    $scope.showNotificationDetails = function(n) {
        n.$read = true;
        $log.debug('n.action -> ', n.action);
        $log.debug('n.url -> ', n.url);
        $log.debug('n.params -> ', n.params);
        $log.debug('n.data -> ', n.data);
        switch(n.action) {
            case 'link':
                if(n.params) {
                localStorageService.set('params', n.params);
                }
                if(n.url) {
                var locPath = $location.path().replace(/^(\/)*/, '').replace(/(\/)*$/, '');
                var nUrl = n.url.replace(/^(\/)*/, '').replace(/(\/)*$/, '');
                if(locPath == nUrl) {
                    $route.reload();
                } else {
                    $location.path(n.url);
                }
                }
                break;
            case 'dialog':
                dialogService.dialog(n.object, n.msg, n.type);
                break;
            case 'templateDialog':
                var dialogScope = { n: n , readNotification: readNotification};
                var template = n.template || '' +
                    '<span class="font-bold ngdialog-icon"></span>' +
                    '<div style="text-align: center;">' +
                        '<div style="margin: 10px 5px 5px 5px; text-align: center;" ng-bind-html="n.msg"></div>' +
                        '<div class="text-sm font-italic text-muted">' +
                            '<span ng-if="n.time">{{n.time | date: "dd/MM/yyyy HH:mm:ss"}} </span>' +
                            '<span ng-if="n.from">#{{n.from}}#</span>' +
                        '</div>' +
                        '<div class="text-sm font-italic text-muted">' +
                        '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="readNotification(n)"> LETTO </button>' +
                        '</div>' +
                    '</div>';
                $scope.myDialog[n.from] = dialogService.templateDialog(template, n.level, dialogScope, {showClose: false, closeByDocument: false});
                break;
            case 'serviceResponse':
                dialogService.serviceResponse(n.message, n.data, false);
                break;
        }
    };

    var readNotification = function(notification) {
        var metadata = notification.metadata.split(',');
        var payloadReadNotify = {
            area: notification.area,
            notificationId: notification.from,
            productId: metadata[0],
            serialKitId: metadata[1]
        }
        notificationFactory.readNotification({}, payloadReadNotify).$promise.then(function(data){
            console.log("data notification read: ", data);
            $scope.myDialog[notification.from].close();
        });
    }

    $scope.$on('notification:push', function (evt, data) {
        console.log("notification push");
        data.$read = false;
        data.$tooltip = '';
        if(data.time) {
            data.$tooltip = '[' + $filter('date')(data.time, 'dd/MM/yyyy HH:mm:ss') + '] ';
        }
        data.$tooltip += data.message;
        $scope.notifications.splice(0, 0, data);  // metto in testa
        $scope.showNotificationDetails(data);
    });

    $scope.$on('notification:clear', function (evt, data) {
        $scope.clearNotifications();
    });

}
]
).filter("elapsedTime", function($filter, $log) {
return function(date, from) {
	if (!date) return;
	var time = Date.parse(date),
		difference = (Date.parse(from)) - time;

	// Seconds (e.g. 32s)
	difference /= 1000;
	// if (difference < 60) return Math.floor(difference)+'s';
	if (difference < 60) return 'Alcuni secondi fa';

	// Minutes (e.g. 12m)
	difference /= 60;
	if (difference < 60) {
		var timeUnit = Math.floor(difference) > 1 ? 'minuti' : 'minuto';
		return Math.floor(difference)+' ' + timeUnit + ' fa';
	}

	// Hours (e.g. 5h)
	difference /= 60;
	if (difference < 24) {
		var timeUnit = Math.floor(difference) > 1 ? 'ore' : 'ora';
		return Math.floor(difference)+' ' + timeUnit + ' fa';
	}

	// Date (e.g. Dec 2)
	return $filter('date')(time, 'MMM d');
	}
}
);

/**
 * Created by Riccardo Merolla on 02/05/15.
 */

'use strict';

angular.module('ictportal.theme').directive('sixFramework', function() {
  return {
    transclude: true,
    bindToController: {
        title: '=',
        logo: '@',
        app: '=',
        commissions: '@',
        logoutLabel: '@',
        menuTemplate: '@',
        feedTemplate: '@'

    },
    link: function postLink(scope, element, attrs) {
        if (attrs.hasOwnProperty('emma')) {
          scope.emma = 'true';
        }
    },
    
    controller: 'sixFrameworkController',
    controllerAs: "$ctrl",
    templateUrl: 'theme/directives/six-framework/sixFrameworkTemplate.html'

  };
});

/**
 * Created by Riccardo Merolla on 02/05/15.
 */

'use strict';

angular.module('ictportal.theme').controller('sixMenuController',
  ['$scope', '$rootScope', '$location', '$log', 'authFactory', 'filterFilter', '$filter',
    function ($scope, $rootScope, $location, $log, authFactory, filterFilter, $filter) {

      $scope.functionQuickList;
      $scope.functionHistory;

      $scope.search = {value:''};

      this.setActiveElement = function (el) {
        $scope.activeElement = el;
      };

      this.getActiveElement = function () {
        return $scope.activeElement;
      };

      this.setRoute = function (route) {
        $rootScope.$broadcast('six-menu-item-selected-event', {
          route: route
        });
      };

      $scope.searchKeyPressed = function() {
        var filteredFunctions = filterFilter($scope.functionQuickList, $scope.search.value);
        var matchingFunction = filteredFunctions[0];
        simulateClick(matchingFunction);
        if(matchingFunction){
          doAddToHistory(matchingFunction.description, matchingFunction.icon, matchingFunction.code);
        }
      };

      function simulateClick(funct){
        //var url = funct.code.indexOf('http:')==0? funct.code:'/#/' + funct.code;
        var url = funct.code;
        $location.url(url);
        $scope.clearSearch();
      }

      $scope.leftMenuClass = function(page) {
        var current = $location.path().substring(1);
        return page === current ? "active" : "";
      };

      $scope.isLoggedIn = function() {
        return authFactory.isAuthenticated();
      };

      $scope.logout = function() {
        authFactory.logout();
        $location.path("/login");
      };

      $scope.menu = function() {
        var authData = authFactory.getAuthData();
        if(angular.isDefined(authData) && authData.hasOwnProperty('menu')) {
          if (!angular.isDefined($scope.functionQuickList)){
            $scope.functionQuickList = [];
            var menu = authData.menu;
            var menuCopy = angular.copy(menu);
            menuCopy.forEach(function (value) {
              value.children.forEach(function (item) {
                item.parent = value.description;
                if(item.children){
                  item.children.forEach(function (child) {
                    child.parent = item.description;
                  });
                  $scope.functionQuickList = $scope.functionQuickList.concat(item.children);
                }
              });
              $scope.functionQuickList = $scope.functionQuickList.concat(value.children);
            });
          }
          if (angular.isDefined(authData.info) &&
              angular.isDefined(authData.info.history)){
            //se viene ricaricato il browser recupero l'history
            $scope.functionHistory = authData.info.history;
          }else{
            $scope.functionHistory = [];
          }

          return authData.menu;
        }
        return null;
      };

      $scope.userInfo = function(){
        if($scope.isLoggedIn()){
          var authData = authFactory.getAuthData();
          return authData;
        }else{
          return;
        }
      };

      $scope.status = {
        isFirstOpen: true,
        isFirstDisabled: false
      };

      $scope.clearSearch = function(){
        $scope.search.value = '';
      };

      $scope.go = function(url){
        //console.log("goooo "+$scope.search);
        $scope.search.value = '';
        //console.log('url '+url);
        $location.path(url);
        console.log('functionHistory '+url);
      };
      //ng-click="$event.preventDefault();clearSearch();$location.href=item.code"

      function doAddToHistory(label, icon, route){
        $scope.functionHistory = $filter('filter')($scope.functionHistory, {route: '!'+route});
        $scope.functionHistory.splice(0, 0, {
          'label':label,
          'icon':icon,
          'route':route
        });
        $scope.functionHistory = $scope.functionHistory.slice(0, 10);
        //manipolo direttamente l'authData per metterci l'history, forse non è il massimo dell'eleganza
        var authData = authFactory.getAuthData();
        authData.info.history = $scope.functionHistory;//salvo sotto info
        authFactory.setAuthData(authData);
      };

      this.addToHistory = function(label, icon, route){
        doAddToHistory(label, icon, route);
      };

      $scope.oneAtATime = true;
    }


  ]
);

/**
 * Created by Riccardo Merolla on 02/05/15.
 */

'use strict';

angular.module('ictportal.theme').directive('sixMenu', function () {
  return {
    transclude: true,
    scope: {
      title: '@'
    },
    templateUrl: 'theme/directives/six-menu/sixMenuTemplate.html',
    controller: 'sixMenuController',
    controllerAs: "$ctrl",
    link: function (scope, el, attr) {
      scope.$watch(
        function () { return $('.transcluded six-menu-item').length; },
        function (newValue, oldValue) {
          if (newValue !== oldValue) {
            scope.transcludedSubMenuItems = newValue;
          }
        }
      );
    }
  };
});

/**
 * Created by Riccardo Merolla on 02/05/15.
 */

'use strict';

angular.module('ictportal.theme').directive('sixMenuItem', function () {
  return {
    require: '^sixMenu',
    scope: {
      label: '@',
      icon: '@',
      route: '@'
    },
    controller: 'sixMenuController',
    templateUrl: 'theme/directives/six-menu/sixMenuItemTemplate.html',
    link: function (scope, el, attr, ctrl) {

      scope.isActive = function () {
        return el === ctrl.getActiveElement();
      };

      el.on('click', function (evt) {
        //evt.stopPropagation();
       // evt.preventDefault();
        scope.$apply(function () {
          ctrl.setActiveElement(el);
          ctrl.setRoute(scope.route);
        });
      });
      
      scope.clicked = function(){
        ctrl.addToHistory(scope.label, scope.icon, scope.route);
      }
    }
  };
});

'use strict';
/**
 * @ngdoc function
 * @description
 * # SixStatixCtrl
 * Controller che interagisce con statix (progetto Steffy Formaggi scritto in vertex) per gestire file su filesytem remoto.
 */

angular.module('ictportal.theme')
  .controller('SixStatixCtrl', function ($scope, $location, $log, statixFactory, $rootScope) {
        $scope.statixBase = '';
        $scope.formActionUrl = $scope.statixBase+"/upload";
        $scope.statixUrl = $location.protocol() + '://'+ $location.host() +':'+  $location.port() + '/static/';
        $scope.ls = [];
        $scope.tabs = {
            activeTab: 0
        };
        $scope.selected = null;
        $scope.showUploadForm = false;

        $scope.select = function (sel) {
            if($scope.hasPreview(sel)){
                $scope.selected = sel;
                $scope.tabs.activeTab = 2;
            }
        };

        $scope.delete = function (f, index) {
            statixFactory($scope.statixBase).delete({path: f.relUrl})
                .$promise.then(function(data){
                    if(data.success==true){
                        if($scope.ngModel.attachments) {
                            $scope.ngModel.attachments.splice(index,1);
                        }
                        $scope.ls.splice(index,1);
                        $log.info($scope.ngModel.attachments);
                        $rootScope.$broadcast('statix:update');
                    }
                    else{
                        $log.error(data);
                    }
            });
        };

        $scope.hasPreview = function(f){
            var result = $scope.showFrame(f) || $scope.showImg(f);
            return result;
        };

        $scope.tabUploadShow = function(){
            $scope.showUploadForm = true;
        }

        $scope.showFrame = function (f) {
            if (f == null) return false;
            var filename = f.name.toLowerCase();
            return filename.endsWith(".pdf");
        };

        $scope.showImg = function (f) {
            if (f == null) return false;
            var filename = f.name.toLowerCase();
            return filename.endsWith(".png")
                || filename.endsWith(".jpg")
                || filename.endsWith(".jpeg");
        };

        $scope.showDownload = function (f) {
            if (f == null) return false;
            return !showImg(f) && !showFrame(f);
        };

        $scope.refresh = function() {
            statixFactory($scope.statixBase).ls({path: $scope.path}).$promise.then(function(data){
                $scope.ls = data;
                if($scope.sortByName && $scope.ls) {
                    $scope.ls.sort(alphabetical);
                }
            });
            $scope.selected = null;
        }

        function alphabetical(A, B) {
            if (A.name < B.name){
                return -1;
            } else if (A.name > B.name){
                return  1;
            } else{
                return 0;
            }
        }

        $scope.$watch('path', function (value, oldValue) {
          if(value !== oldValue && value != null && value !== ""){
            $scope.refresh();
          }
        });

        $scope.iframeLoadedCallBack = function(){
            $scope.showUploadFrame = true;
            statixFactory($scope.statixBase).ls({path: $scope.path})
                .$promise.then(function(data){
                    if($scope.ngModel){
                        $scope.ngModel.attachments = [];
                        $scope.ls = data;
                        if($scope.sortByName && $scope.ls) {
                            $scope.ls.sort(alphabetical);
                        }
                        data.forEach(function(f){
                            $scope.ngModel.attachments.push(f);
                        });
                        $log.info('$scope.ngModel.attachments');
                        $log.info($scope.ngModel.attachments);
                        $rootScope.$broadcast('statix:update');
                    }
            });
        };

        $rootScope.$on('statix:clean', function(event, args) {
            angular.forEach(
                angular.element("input[type='file']"),
                function(inputElem) {
                    angular.element(inputElem).val(null);
                }
            );
            $scope.showUploadFrame = false;
            $scope.tabs.activeTab = 0;
        });

    }
);

/**
 * @author Rita Beltrami
 * created on 19.10.2016
 */
(function () {
  'use strict';


  angular.module('ictportal.theme')
  .filter('trustAsResourceUrl', function ($sce) {
    return function (input) {
      return $sce.trustAsResourceUrl(input);
    };
  });



  angular.module('ictportal.theme')
      .directive('sixStatix', sixStatix);

  /** @ngInject */
  function sixStatix() {
    return {
      restrict: 'E',
      scope: {
        path: '=',
        ngModel: '=',
        sortByName: '=', // ordina per nome file
        showUpload: '=',  // mostra/nasconde il caricamento dei file
        showPreview: '=', // mostra/nasconde la preview
        showDelete: '='  // mostra/nasconde la possibilità di cancellare i file
      },
      controller: 'SixStatixCtrl',
      templateUrl: 'theme/directives/six-statix/six-statix.html',
    };
  };



  angular.module('ictportal.theme')
      .directive('iframeOnload', iframeOnload);

  /** @ngInject */
  function iframeOnload() {
    return {
      scope: {
          callBack: '&iframeOnload'
      },
      link: function(scope, element, attrs){
          element.on('load', function(){
              return scope.callBack();
          })
      }
    };
  };

})();
/**
 * Created by Rita Beltrami on 11/04/16.
 */

'use strict';

angular.module('ictportal.theme').controller('sixToolbarButtonController', 
    ['$scope', '$log', '$element',
    function ($scope, $log, $element) {
        
      $scope.callback = function () {
          if(!$scope.sxDisabled){
            $scope.toolbarFunction();   
          }
      }
        
      $scope.noLabel = angular.isUndefined($scope.label);
    }

  ]
);

/**
 * Created by Rita Beltrami on 11/04/16.
 */

'use strict';

angular.module('ictportal.theme').directive('sixToolbarButton', function () {
  return {
    transclude: false,
    scope: {
      label: '@',
      icon: '@',
      iconStacked: '@',
      iconDisabled: '@',
      iconStackedDisabled: '@',
      iconCondition: '=',
      sxDisabled: '=',
      btnClass: '@',
      toolbarFunction: '&',
      btnTitle: '@'
    },
    controller: 'sixToolbarButtonController',
    templateUrl: 'theme/directives/six-toolbar/sixToolbarButtonTemplate.html',
    link: function (scope, el, attr, ctrl) {
              
    }
  };
});

/**
 * Created by Rita Beltrami on 08/04/16.
 */

'use strict';

angular.module('ictportal.theme').controller('sixToolbarController', 
    ['$scope', '$rootScope', '$log', '$element', '$transclude', 
    function ($scope, $rootScope, $log, $element, $transclude) {
        
      /* Sidebar open or close status */
      if(angular.isUndefined($rootScope.isSidebarOpen)){
        $scope.sidebarExpanded = true; 
      }
      else{
        $scope.sidebarExpanded = $rootScope.isSidebarOpen;    
      } 
        
      $scope.$on('toggle-sidebar', function (evt, data) {
        $scope.sidebarExpanded = !$scope.sidebarExpanded;
      });
      
      /* Elements transclusion */
      $transclude(function(transEl) {
        var items = [];
        var buttons = [];
        for(var i=0; i<transEl.length; i++){
            if(transEl[i].tagName=='SIX-TOOLBAR-ITEM'){
                items.push(transEl[i]);    
            }
            else {
                buttons.push(transEl[i]);    
            } 
        }
        var itemsContainer = $element.find('.six-toolbar-items-container');
        itemsContainer.append(items);
        var buttonsContainer = $element.find('.six-toolbar-buttons-container');
        buttonsContainer.append(buttons);
      });


    }

  ]
);

/**
 * Created by Riccardo Merolla on 07/03/16.
 */

'use strict';

angular.module('ictportal.theme').directive('sixToolbar', function () {
  return {
    transclude: true,
    scope: {
      title: '=',
      staticTitle: '@'
    },
    controller: 'sixToolbarController',
    templateUrl: 'theme/directives/six-toolbar/sixToolbarTemplate.html',
    link: function (scope, el, attr) {

    }
  };
});

/**
 * Created by Rita Beltrami on 08/04/16.
 */

'use strict';

angular.module('ictportal.theme').controller('sixToolbarItemController', 
    ['$scope', '$log', '$element', '$transclude', 
    function ($scope, $log, $element, $transclude) {
        
      $scope.callback = function () {
          if(!$scope.sxDisabled){
            $scope.toolbarFunction();   
          }
      }
      
        
      /* Elements transclusion */
      $transclude(function(transEl) {
          
          if(transEl.length){
            $scope.hasTranscluded = true;
          }

      });


    }

  ]
);

/**
 * Created by Riccardo Merolla on 07/03/16.
 */

'use strict';

angular.module('ictportal.theme').directive('sixToolbarItem', function () {
  return {
    transclude: true,
    scope: {
      label: '@',
      labelDisabled: '@',
      labelCondition: '=',
      labelClass: '@',
      icon: '@',
      iconDisabled: '@',
      iconCondition: '=',
      sxDisabled: '=',
      toolbarFunction: '&'
    },
    controller: 'sixToolbarItemController',
    templateUrl: 'theme/directives/six-toolbar/sixToolbarItemTemplate.html',
    link: function (scope, el, attr, ctrl) {
              
    }
  };
});

'use strict';

/**
 * Created by Rita Beltrami on 21/11/16.
 * @ngdoc component
 * @name ictportal.theme.component:sixConfirmModal
 * @description
 * # sixConfirmModal
 */
angular.module('ictportal.theme').component('sixConfirmModal',{
      restrict: 'E',
      controller: 'sixConfirmModalCtrl',
      bindings: {
        sxTitle: '=',
        sxMessage: '=',
        sxOnConfirm: '='
      }
  });


'use strict';

/**
 * Created by Rita Beltrami on 21/11/16.
 */
angular.module('ictportal.theme').controller('sixConfirmModalCtrl', function ($scope, $rootScope, $uibModal) {
    $scope.$ctrl = this;

    $rootScope.$on( 'sixConfirmModal_open', function(event, next, current) {
      var modalInstance = showModalConfirm();
      modalInstance.result.then(function (confirmed) {
        if(confirmed){
          $scope.$ctrl.sxOnConfirm();
          modalInstance.dismiss();
          $('body').removeClass('modal-open');
          $('.modal-backdrop').remove();    
        }
      });
    });

    function showModalConfirm() {
      var modalInstance = $uibModal.open({
        animation: true,
        scope: $scope,
        templateUrl: 'theme/modals/six-confirm-modal/six-confirm-modal.html'
      });
      return modalInstance;
    };

});
'use strict';

/**
 * Created by Rita Beltrami on 20/03/18
 * @ngdoc component
 * @name ictportal.theme.component:sixPrintModal
 * @description Modal window for choosing a printer and confirm label printing
 * # sixPrintModal
 */
angular.module('ictportal.theme').component('sixPrintModal',{
      restrict: 'E',
      controller: 'sixPrintModalCtrl',
      bindings: {
        sxTitle: '=',
        sxOnConfirm: '&',
        sxOnCancel: '&'
      }
  });

'use strict';

angular.module('ictportal.theme').controller('sixPrintModalCtrl', function ($scope, $rootScope, $uibModal, localStorageService, eggsFormFactory, serialKitLMFactory) {
  var $ctrl = this;
  $ctrl.settings = {};
  $ctrl.lookup = {};

  $rootScope.$on('sixPrintModalCtrl_open', function () {
    var modalInstance = showModalConfirm();
    modalInstance.result.then(function (confirmed) {
      if (confirmed) {
        $ctrl.sxOnConfirm({code: $ctrl.lookup.label_printer_id.obj.code});
        modalInstance.dismiss();
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
      } else {
        $ctrl.sxOnCancel();
      }
    });
  });

  function showModalConfirm() {
    var modalInstance = $uibModal.open({
      animation: true,
      scope: $scope,
      templateUrl: 'theme/modals/six-print-modal/six-print-modal.html'
    });
    return modalInstance;
  };

  // Se c'è, recupero la stampante di default per la workstation corrente
  function getWorkstationPrinter() {
    var workstation = localStorageService.get('workstation');
    if (workstation) {
      var payload = { workstation: workstation };
      /* serialKitLMFactory.getWsPrinter(payload).$promise.then(function (response) {
        $ctrl.settings.label_printer_id = response.printer;
        eggsFormFactory.loadLookupData($ctrl.lookup, $ctrl.settings);
      }); */
    }
  };

  function initLookups() {
    eggsFormFactory.addLookup($ctrl.lookup, 'label_printer_id', 'label_printer', 'code', 'description');
  };

  $ctrl.$onInit = function () {
    initLookups();
    getWorkstationPrinter();
  };

});
'use strict';

/**
 * @ngdoc function
 * @name ictportal.core.controller:GoodsInwardAcceptCtrl
 * @description
 * @author Mattia Freda
 *
 * @param depotCode è OBBLIGATORIO passare alla pagina il codice del deposito per cui accettare la merce
 *
 * created on 20/12/2019
 * # GoodsInwardAcceptCtrl
 * Controller of the ictportal.tnt
 *
 */
angular.module('ictportal.tnt')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/tnt/goodsinward/accept/:depotCode', {
                templateUrl: 'tnt/goods-inward/accept/goods-inward-accept.html',
                controller: 'GoodsInwardAcceptCtrl'
            })
    })
    .controller('GoodsInwardAcceptCtrl', function ($scope, recordFactory, $routeParams, $location, tntGoodsInwardService, tntGoodsInwardFactory,
                                                authFactory, $rootScope, parseSchemaService, matrixParFactory, dbFilterFactory, localeFactory, $q,
                                                toaster, eggsFormFactory, $log) {
        var msg = {
            "error": "Error",
            "date": "Date",
            "number": "Number",
            "supplier": "Supplier",
            "op_completed_success": "Operation completed",
            "server_comunication_error": "Server communication error"
        };
        var goods_inward_msg = {
            "supplier_code": "Supplier code",
            "supplier_ddt_number": "Supplier DDT number",
            "supplier_ddt_date": "Supplier DDT date",
            "reference": "Reference",
            "error_retrieving_destination": "Error retrieving customer destination",
            "destination_not_found": "Customer destination not found",
            "goods_inward_accept": "Goods inward reception",
            "accepted_kit_count": "{{kitCount}} kits accepted"
        };
        var depotFilter = undefined;
        $scope.depotId = undefined;
        $scope.preselectSupplier = false;
        $scope.result = {};
        $scope.supplierFilters = []; // Lookup filter
        $scope.supplierImplicitFilter = []; // Table filter on supplier
        $scope.record = {
            lookup: {},
            dates: ['dn_date', 'int_date']
        };
        $scope.params = {
            pageNumber: 1,
            pageSize: 15,
            code: 'component',
            sortOrder: 'desc',
            filters: []
        };
        $scope.advFilter = {
            filter: {},
            list: []
        };
        $scope.enum = {};
        $scope.acceptEnabled = false;
        var selectedRows = [];

        $scope.sixRowSelectionChangedCallback = function(row, col, event){
            selectedRows = row.grid.api.selection.getSelectedRows();
            $scope.acceptEnabled = selectedRows.length > 0;
            console.log("selezionate " + selectedRows.length + " righe");
        };

        $scope.sixBulkSelectionCallback = function(scope, rows, evt) {
            // selectedRows = $scope.viewGridOptions.gridApi.selection.getSelectedRows();
          if(scope.length > 0) {
            selectedRows = scope[0].grid.api.selection.getSelectedRows();
            if (selectedRows.length === $scope.viewGridOptions.appScopeProvider.params.pageSize) {
              toaster.pop('warn', 'ATTENZIONE! Selezionate solamente le righe della prima pagina');
            }
            $scope.acceptEnabled = selectedRows.length > 0;
            console.log("selezionate " + selectedRows.length + " righe");
          }
        };

        $scope.viewGridOptions = {
            appScopeProvider: $scope,
            enableFiltering: true,
            multiSelect: true,
            enableRowHeaderSelection: true,
            enableRowSelection: true,
            rowSelectionChanged: $scope.sixRowSelectionChangedCallback,
            rowSelectionChangedBatch: $scope.sixBulkSelectionCallback,
            enablePaginationControls: true
        };

        $scope.$watchGroup(['advFilter.filter.supplier_id',
            'advFilter.filter.dn_number',
            'advFilter.filter.reference',
            'advFilter.filter.dn_date_from',
            'advFilter.filter.dn_date_to',
            'advFilter.filter.status'], function () {
                $scope.applyFilter();
            }
        );

        $scope.applyFilter = function () {
            $scope.advFilter.list.length = 0;
            if ($scope.advFilter.filter.supplier_id) {
                var f = dbFilterFactory.getNumberFilter('t.supplier_id', $scope.advFilter.filter.supplier_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.dn_number) {
                var f = dbFilterFactory.getNumberFilter('t.dn_number', $scope.advFilter.filter.dn_number);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.reference) {
                var f = dbFilterFactory.getLikeFilter('t.reference', $scope.advFilter.filter.reference);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.dn_date_from) {
                var f = dbFilterFactory.getDateFilter('t.dn_date', $scope.advFilter.filter.dn_date_from, '>=');
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.dn_date_to) {
                var f = dbFilterFactory.getDateFilter('t.dn_date', $scope.advFilter.filter.dn_date_to, '<=');
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.status) {
                var f = dbFilterFactory.getStringFilter('t.status', $scope.advFilter.filter.status);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            $scope.getData();
        };

        var initGridColumns = function () {
            $scope.lookupCols = [];
            $scope.viewGridOptions.columnDefs = [];
            var dateFormat = localeFactory.getDateFormat();
            if ($scope.isDetailAllowed) {
                $scope.viewGridOptions.columnDefs.push(parseSchemaService.getEditCol());
            }
            $scope.viewGridOptions.columnDefs.push({
                width: '*',
                name: "Numero",
                field: "int_number",
                translation: 'number',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                width: '**',
                name: "Data",
                field: "int_date",
                translation: 'date',
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.int_date | date:\'' + dateFormat + '\' }}</div>',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                width: '***',
                name: "Fornitore",
                field: "supplier_description",
                translation: 'supplier',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                width: '****',
                name: "Riferimento",
                field: "reference",
                translation: 'reference',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                width: '**',
                name: "Numero DDT",
                field: "dn_number",
                translation: 'supplier_ddt_number',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                width: '**',
                name: "Data DDT",
                field: "dn_date",
                translation: 'supplier_ddt_date',
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.dn_date | date:\'' + dateFormat + '\' }}</div>',
                enableFiltering: false
            });
        };

        $scope.getData = function () {
            var payload = {
                page: $scope.params.pageNumber,
                page_size: $scope.params.pageSize,
                code: $scope.params.code,
                description: $scope.params.description,
                show_revision: false,
                sort_fields: ($scope.params.sortFields ? $scope.params.sortFields : 'created_date'),
                sort_order: $scope.params.sortOrder
            };
            var filters = [
                {
                    "column": "supplier s",
                    "value": "t.supplier_id = s.id",
                    "relation": "JOIN",
                    "kind": "s.description AS supplier_description"
                }
            ];
            filters = filters.concat($scope.supplierImplicitFilter);
            // soli ricevimenti non ancora accettati
            filters = filters.concat(dbFilterFactory.getStringFilter('t.status',"TO_DISPATCH"));
            filters = filters.concat($scope.advFilter.list);
            recordFactory('goods_inward').filter(payload, filters).$promise.then(function (data) {
              $scope.viewGridOptions.totalItems = data.totalResults;
              $scope.result.totalResults = data.totalResults;
              $scope.result.list = data.list;
              if ($scope.record.dates.length > 0) {
                parseSchemaService.loadDates($scope.record, $scope.result);
              }
            });
        };

        $scope.acceptSelected = function () {
            if (selectedRows && selectedRows.length > 0) {
                var goodsInwardDto = [];
                selectedRows.forEach(function (row) {
                    goodsInwardDto.push({
                        "id": row.id,
                        'depot_id': $scope.depotId
                    });
                });
                tntGoodsInwardFactory.acceptGoodsInward({},goodsInwardDto).$promise
                .then(function(response) {
                    if(response.success) {
                        localeFactory.translateReplace('goods_inward.accepted_kit_count', {kitCount: response.count}).then(function(transl){
                            toaster.pop('success', msg.op_completed_success, transl);
                        });
                        // aggiorno la griglia
                        var processed = selectedRows.map(function(r) { return r.$$hashKey; });
                        $scope.result.list = $scope.result.list.filter(
                            function(o) {
                                return processed.indexOf(o.$$hashKey) == -1;
                            }
                        );
                    } else {
                        toaster.pop('error', msg.error, response.error_message);
                        console.error(response.error_message);
                    }
                }).catch(function(ex){ logError(ex) });
            }
        };

        var logError = function logError(ex) {
            $log.log(ex);
            toaster.pop('error', msg.error, msg.server_comunication_error);
        };

        $scope.viewDetail = function (value) {
            var path = '/tnt/goodsinward/detail/' + $scope.depotCode + '/' + value.id + '/accepting';
            $location.path(path);
        };

        function translateGridColumns() {
            $scope.viewGridOptions.columnDefs.forEach(function (col) {
                if (col.translation) {
                    if (goods_inward_msg[col.translation]) {
                        col.name = goods_inward_msg[col.translation];
                    }
                    else {
                        col.name = msg[col.translation];
                    }
                }
            });
        }

        function initLookups() {
            $scope.lookup = {};
            eggsFormFactory.addLookup($scope.lookup, 'supplier_id', 'supplier', 'code', 'description');
        }

        $rootScope.$on('$translateRefreshEnd', function () {
            $q.all({
                general: localeFactory.translateMsg(msg),
                specific: localeFactory.translateMsg(goods_inward_msg, 'goods_inward')
            })
            .then(function (data) {
                $scope.functionTitle = goods_inward_msg.goods_inward_accept;
                translateGridColumns();
            })
            .catch(function (error) { $log.error(error); });
        });

        function checkPermissions() {
            var profilingKey = 'TNT_GOODS_INWARD_ACCEPT';
            var permission = authFactory.getPermissions(profilingKey);
            if(!permission.EXEC) {
                $location.path('forbidden').search({key: profilingKey});
            }
            else {
                $scope.isDetailAllowed = permission.DETAIL;
                $scope.isUpdateAllowed = permission.UPDATE;
            }
        }

        /**
         * Filters suppliers selling TNT products that are allowed for this user
         */
        function getSupplierImplicitFilter() {
            // IMPLICIT FILTER
            var authData = authFactory.getAuthData();
            if(authData) {
                // Filter for getData()
                var copy = JSON.parse(JSON.stringify(authData.filters.supplier));
                copy.forEach(function(f){
                    dbFilterFactory.changeCustomAlias('s',f);
                    $scope.supplierImplicitFilter.push(f);
                });

                // Filter for lookup
                $scope.supplierFilters = $scope.supplierFilters.concat(authData.filters.supplier);
                $scope.preselectSupplier = authData.info && authData.info.authorizations && (authData.info.authorizations.suppliers.length==1);
            }
            // PRODUCT GROUP FILTER
            matrixParFactory.getMatrixPar({ key: 'tntProductGroup', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*' }).$promise.then(function (response) {
                if (response.value) {
                    var codes = response.value.trim().split(",");
                    if(codes.length>0) {
                        var query = dbFilterFactory.getOrQuery('pg.code', codes);
                        var customFilter = "t.id in (select t.id from supplier t LEFT JOIN product_supplier ps ON t.id = ps.supplier_id LEFT JOIN product p ON ps.product_id = p.id " +
                                            "LEFT JOIN product_group pg ON p.product_group_id = pg.id where " + query + ")";
                        $scope.supplierFilters = $scope.supplierFilters.concat(dbFilterFactory.getCustomFilter(customFilter));
                    }
                }
            }).catch(angular.identity);
        }

        function setDepot() {
          var deferred = $q.defer();
          $scope.depotCode = $routeParams.depotCode;
          // cerca solo il codice della customer destination, non verifica sia effettivamente un deposito
          var f = []
            .concat(dbFilterFactory.getStringFilter('t.code', $scope.depotCode))
            .concat(authFactory.getAuthDestinationFilters())
            .concat(authFactory.getAuthFilters())
          recordFactory('customer_destination').filter({}, f).$promise.then(function (data) {
            if (data && data.totalResults === 1) {
              deferred.resolve(data.list[0].id);
            } else {
              deferred.resolve(-1);
            }
          }).catch(function () {
            deferred.resolve(-1);
          });
          return deferred.promise;
        }

        function init() {
            localeFactory.loadTranslation('goods_inward');
            initLookups();
            checkPermissions();
            initGridColumns();
            getSupplierImplicitFilter();
            var promises = {
              depot: setDepot()
            }
            $q.all(promises).then(function (response) {
              if (response.depot === -1) {
                toaster.pop('error', msg.error, goods_inward_msg.destination_not_found);
                $scope.depotId = null;
              } else {
                $scope.depotId = response.depot;
              }
            });
            $scope.enum = tntGoodsInwardService.enum;
            console.log(">> goods-inward-accept.ctrl.js [" + $scope.depotCode + "]");
        }

        //___ main ___
        init();

    });


/**
 * @ngdoc function
 * @name ictportal.core.controller:GoodsInwardCtrl
 * @description Ricevimento merce TNT (SIX-3230)
 * @author Rita Beltrami
 *
 * @param depotCode è OBBLIGATORIO passare alla pagina il codice del deposito su cui caricare la merce.
 * @param wardrobeCode è OBBLIGATORIO nel caso di ricevimento merce direttamente IN GUARDAROBA
 *
 * created on 23/02/2018
 * # GoodsInwardCtrl
 * Controller of the ictportal.tnt
 */
angular.module('ictportal.tnt')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/tnt/goodsinward/detail/:depotCode', {
          templateUrl: 'tnt/goods-inward/detail/goods-inward-detail.html',
          controller: 'GoodsInwardCtrl',
          resolve: {
            mode: function ($route) { $route.current.params.wardobeMode = false; }
          }
        })
        .when('/tnt/goodsinward/detail/:depotCode/:id', {
          templateUrl: 'tnt/goods-inward/detail/goods-inward-detail.html',
          controller: 'GoodsInwardCtrl',
          resolve: {
            mode: function ($route) { $route.current.params.wardobeMode = false; }
          }
        })
        .when('/tnt/goodsinward/detail/:depotCode/:id/:editMode', {
          templateUrl: 'tnt/goods-inward/detail/goods-inward-detail.html',
          controller: 'GoodsInwardCtrl',
          resolve: {
            mode: function ($route) { $route.current.params.wardobeMode = false; }
          }
        })
        .when('/tnt/goodsinward/wardrobe/detail/:depotCode/:wardrobeCode', {
          templateUrl: 'tnt/goods-inward/detail/goods-inward-detail.html',
          controller: 'GoodsInwardCtrl',
          resolve: {
            mode: function ($route) { $route.current.params.wardobeMode = true; }
          }
        })
        .when('/tnt/goodsinward/wardrobe/detail/:depotCode/:wardrobeCode/:id', {
          templateUrl: 'tnt/goods-inward/detail/goods-inward-detail.html',
          controller: 'GoodsInwardCtrl',
          resolve: {
            mode: function ($route) { $route.current.params.wardobeMode = true; }
          }
        })
  })
  .controller('GoodsInwardCtrl', function ($scope, $log, recordFactory, $routeParams, $location, $filter, matrixParFactory,
                                          eggsFormFactory, toaster, dbFilterFactory, localeFactory, tntGoodsInwardFactory,
                                          authFactory, $q, $rootScope, schemaFactory, tntGoodsInwardService) {

    $scope.readOnly = false;
    $scope.showStdPanel = true;
    $scope.preselectSupplier = false;
    $scope.enum = {};
    $scope.isSupplier = false;
    var pageBundle = 'goods_inward';
    var msg = {
      "error": "Error",
      "operation_completed": "Operation completed",
      "operation_completed_success": "Operation successfully completed",
      "server_comunication_error": "Server communication error"
    };
    var page_msg = {
      "MISSING_SUPPLIER": "Supplier missing",
      "MISSING_STATUS": "Status missing",
      "MISSING_DATE": "Date missing",
      "MISSING_DEPOT": "Missing depot",
      "SAVE_EXCEPTION": "Error while saving",
      "INVALID_REASON": "Invalid inventory reason",
      "container_not_set": "Container non set for selected facility. Please set it before you continue.",
      "KIT_EXCEPTION": "Error while saving serial kit",
      "customer_destination_not_found": "Customer destination not found",
      "missing_customer_destination": "Missing customer destination",
      "goods_inward_wardrobe": "Wardrobe goods inward",
      "goods_inward": "Goods inward"
    };
    $scope.record = {
      lookup: {},
      dates: ['int_date', 'rec_date', 'dt_date'],
      model: {}
    };
    $scope.selected = {
      readOnly: false,
      editing: false,
      serialKit: {},
      row: {},
      customerDestination: {}
    };
    $scope.tabs = {
      activeTab: 0,
      TAB_HEAD: 0,
      TAB_ROWS: 1,
      TAB_ROW_DETAIL: 2
    };
    var initialRowCount = undefined;

    function initLookups() {
      eggsFormFactory.addLookup($scope.record.lookup, 'supplier_id',            'supplier',               'code',     'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'type_id',                'goods_inward_type',      'code',     'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'depot_id',               'customer_destination',   't.code',   't.description');
      eggsFormFactory.addLookup($scope.record.lookup, 'inventory_reason_id',    'inventory_reason',       'code',     'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'created_user_id',        'users',                  'username', 'username');
      eggsFormFactory.addLookup($scope.record.lookup, 'last_modified_user_id',  'users',                  'username', 'username');
    }

    function getGoodsInwardDocument(id) {
      recordFactory('goods_inward').byId({ id: id }).$promise.then(function (response) {
        loadDocument(response);
        // Se non ci sono righe già inserite, deve già aprirmi la pagina di inserimento di una nuova riga.
        $scope.tabs.activeTab = $scope.tabs.TAB_ROWS;
      });
    }

    $rootScope.$on('goodsInwardRows:loadedRows',function($event,args){
      if($scope.record.model.id && angular.isUndefined(initialRowCount)){
        initialRowCount = args;
        if(initialRowCount===0){
          $scope.addRow();
        }
      }
    })

    $rootScope.$on('goodsInward:savedRow',function($event,savedRow){
      if(savedRow && !$scope.selected.row.id){
        $scope.selected.row = savedRow;
      }
    })

    /**
     * Recupera la customer destination del guardaroba a partire dal codice passato come parametro della funzione.
     * @param {string} code  Codice del guardaroba.
     */
    function getCustomerDestination(code){
      if(!code){
        toaster.pop('error',msg.error,page_msg.missing_customer_destination);
      }
      else{
        recordFactory('customer_destination').filter({},dbFilterFactory.getStringFilter('code',code)).$promise
          .then(function(data){
            if(data.totalResults===0){
              localeFactory.translateReplace(pageBundle + '.customer_destination_not_found', {code: code}).then(function(transl){
                toaster.pop('error',msg.error,transl);
              })
            }
            else{
              angular.extend($scope.selected.customerDestination,data.list[0]);
            }
          })
          .catch(function(ex){ logError(ex) })
      }
    }

    function loadDocument(model){
      angular.extend($scope.record.model,model);
      if ($scope.record.model.status != "TO_DISPATCH") {
        $scope.selected.readOnly = true;
        $scope.selected.editing = false;
      }
      eggsFormFactory.convertDates($scope.record.model, $scope.record.dates);
      $log.info($scope.record.model);
      $scope.record.model.depot_id = $scope.record.model.destination_id;
      eggsFormFactory.loadLookupData($scope.record.lookup, $scope.record.model);
    }

    $scope.stopRowEditing = function(){
      $scope.selected.editing = false;
      $scope.tabs.activeTab = $scope.tabs.TAB_ROWS;
      $scope.selected.row = {};
      $rootScope.$broadcast('updateGiRowsList');
    }

    $scope.$watch('selected.row', function(newVal, oldVal) {
      if(newVal.id) {
        $scope.selected.editing = true;
        $scope.tabs.activeTab = $scope.tabs.TAB_ROW_DETAIL;
      }
      else if(oldVal && oldVal.id){
        $scope.selected.editing = false;
      }
    })

    $scope.addRow = function(){
      $scope.selected.editing = true;
      $scope.tabs.activeTab = $scope.tabs.TAB_ROW_DETAIL;
    }

    $scope.goToList= function(){
      var path;
      if ($routeParams.editMode == "accepting") {
        path = '/tnt/goodsinward/accept/' + $routeParams.depotCode;
      } else {
        if($routeParams.wardobeMode){
            path = '/tnt/goodsinward/wardrobe/list/' + $routeParams.wardrobeCode;
        }
        else{
            path = '/tnt/goodsinward/list/' + $routeParams.depotCode;
        }
      }
      $location.path(path);
    }

    $scope.save = function(){
      tntGoodsInwardFactory.saveOrUpdateGoodsInward({},$scope.record.model).$promise
      .then(function(response){
        if(response.success){
          if(angular.isUndefined($routeParams.id)){
            var path;
            if($routeParams.wardobeMode){
                path = '/tnt/goodsinward/wardrobe/detail/' + $routeParams.depotCode + '/' + $routeParams.wardrobeCode  + '/' + response.model.id;
            }
            else{
                path = '/tnt/goodsinward/detail/' + $routeParams.depotCode + '/' + response.model.id;
            }
            $location.path(path);
          }
          else{
            loadDocument(response.model);
          }
          toaster.pop('success', msg.operation_completed, msg.operation_completed_success);
        }
        else{
          toaster.pop('error', msg.error, page_msg[response.error_code]);
        }
      })
      .catch(function(ex){ logError(ex) })
    }

    var logError = function logError(ex){
      toaster.pop('error', msg.error, msg.server_comunication_error);
    }

    $scope.printRowLabel = function () {
      $scope.printMode = 'ROW';
      $rootScope.$broadcast('sixPrintModalCtrl_open');
    }

    $scope.printKitLabel = function (id, isIdKitButPrintEnvelope) {
      $scope.printMode = 'KIT';
      $scope.selected.serialKit.id = id;
      $scope.selected.serialKit.isIdKitButPrintEnvelope = isIdKitButPrintEnvelope;
      $rootScope.$broadcast('sixPrintModalCtrl_open');
    }

    $scope.onConfirmPrintLabel = function (printerCode) {
       var payload = {
        printerCode: printerCode
      };
      // stampo un singolo kit
      if($scope.printMode=='KIT'){
        payload.id = $scope.selected.serialKit.id;
        payload.envelope = $scope.selected.serialKit.isIdKitButPrintEnvelope;
        tntGoodsInwardFactory.printSerialKitLabel({},payload).$promise
        .then(function(response){
          if(!response.success){
            toaster.pop('error', msg.error, page_msg[response.error_code]);
          }
        })
        .catch(angular.identity);
      }
      // stampo tutti i kit della riga di ricevimento
      else{
        payload.id = $scope.selected.row.id;
        tntGoodsInwardFactory.printRowLabel({},payload).$promise
        .then(function(response){
          if(!response.success){
            toaster.pop('error', msg.error, page_msg[response.error_code]);
          }
        })
        .catch(angular.identity);
      }
    }

    /*
    data = oggi
    data ricevimento = oggi
    tipo = ricevimento monouso (da parametro su funzione)
    deposito = deposito stabilimento (da parametro su funzione)
    causale = acquisto (da parametro su funzione)
    stato = da evadere
    */
    function initializeGoodsInward() {
      $scope.record.model.int_date = new Date();
      $scope.record.model.rec_date = new Date();
      var myPromises = {
        depot:   tntGoodsInwardService.loadDepot($routeParams.depotCode),
        type:  tntGoodsInwardService.loadTntGoodsInwardType(),
        inventoryReason:  tntGoodsInwardService.loadTntGoodsInwardInventoryReason(),
        isSupplier: tntGoodsInwardService.isSupplier($routeParams.depotCode),
        supplier: tntGoodsInwardService.loadSupplier($routeParams.depotCode)
      };

      $q.all(myPromises).then(function(responses) {
        $scope.record.model.depot_id = responses.depot;
        $scope.record.model.type_id = responses.type;
        $scope.record.model.inventory_reason_id = responses.inventoryReason;
        $scope.isSupplier = responses.isSupplier;
        if ($scope.isSupplier) {
          $scope.record.model.supplier_id = responses.supplier;
        }
        eggsFormFactory.loadLookupData($scope.record.lookup, $scope.record.model);
      });
      $scope.record.model.status = 'TO_DISPATCH';
    }

    function init() {
      $scope.wardobeMode = $routeParams.wardobeMode;
      if($scope.wardobeMode && $routeParams.wardrobeCode){
        getCustomerDestination($routeParams.wardrobeCode);
      }
      localeFactory.loadTranslation(pageBundle)
        .then(function(){
          $q.all({
            general: localeFactory.translateMsg(msg),
            specific: localeFactory.translateMsg(page_msg, pageBundle)
          })
          .then(function(){
            $scope.functionTitle = $scope.wardrobeMode?page_msg.goods_inward_wardrobe:page_msg.goods_inward;
          })
          .catch(function(ex){});
        })
        .catch(function(ex){});
      $scope.enum = tntGoodsInwardService.enum;
      schemaFactory().getCode({ id: 'goods_inward' }).$promise.then(function (data) {
        $scope.sf = data;
        if (angular.isDefined($routeParams.id)) {
          getGoodsInwardDocument($routeParams.id);
        }
        else{
          initializeGoodsInward();
        }
      });
      initLookups();
      var authData = authFactory.getAuthData();
      $scope.inventoryReasonFilter = dbFilterFactory.getStringFilter('cli_for_flag','F');
      $scope.supplierFilter = authData.filters.supplier;
      //$scope.preselectSupplier = authData && authData.info && authData.info.authorizations && (authData.info.authorizations.suppliers.length==1);
      checkPermissions();
      if ($routeParams.editMode == "accepting") {
        $scope.selected.readOnly = true;
        $scope.selected.editing = false;
        $scope.tabs.activeTab = $scope.tabs.TAB_HEAD;
      }
    }

    function checkPermissions() {
      var profilingKey = 'TNT_GOODS_INWARD_FUNCTION';
      var permission = authFactory.getPermissions(profilingKey);
      if(!permission.EXEC) {
          $location.path('forbidden').search({key: profilingKey});
      }
      else {
          $scope.isNewAllowed = permission.NEW;
          $scope.isDetailAllowed = permission.DETAIL;
          $scope.isUpdateAllowed = permission.UPDATE;

          if(!permission.DETAIL) {
            $location.path('forbidden').search({key: profilingKey});
          }

      }
    }

    init();

  });

'use strict';

angular.module('ictportal.tnt')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/tnt/goodsinward/containerenvelope', {
        templateUrl: 'tnt/goods-inward/container-envelope-association/container-envelope-association.html',
        controller: 'tntContainerEnvelopeAssociationCtrl'
      });
  }).controller('tntContainerEnvelopeAssociationCtrl', function ($log, $scope, dbFilterFactory, localeFactory, recordFactory, tntGoodsInwardFactory, toaster) {

  $scope.packages = [];

  $scope.container = {
    id: undefined,
    code: undefined,
    description: undefined,
    loaded_quantity: undefined,
    max_quantity: undefined,
    end_validity: undefined
  };

  $scope.percent = 0;

  $scope.product = {
    id: undefined,
    code: undefined,
    description: undefined,
    quantityIncluded: undefined,
    packageQuantity: undefined
  };

  $scope.containerFull = false;
  $scope.confimIsDisabled = false;
  $scope.codeReaderIsDisabled = false;

  var filterOptions = {
    page_size: 1000,
    page: 1
  };

  var productionStatus = {
    packed: 'PACKED'
  };

  var msgType = {
    error: 'error',
    info: 'info',
    success: 'success'
  };

  var msg = {
    error: 'Error',
    info: 'Info',
    success: 'Success'
  };

  function getTimestamp(day) {
    var m = (day.getMonth() + 1);
    var mStr = (m < 10) ? ('0' + m.toString()) : m.toString();
    var d = (day.getDate());
    var dStr = (d < 10) ? ('0' + d.toString()) : d.toString();
    return day.getFullYear() + '-' + mStr + '-' + dStr;
  }

  function getValidityQuery(table) {
    return '(' + table + '.validity_end IS NULL OR ' + table + '.validity_end >\'' + getTimestamp(new Date()) + '\')';
  }

  function mapContainer(data) {
    $scope.container.id = data.id;
    $scope.container.end_validity = data.end_validity;
    $scope.container.max_quantity = data.load_units;
    $scope.container.description = data.description;
    $scope.container.code = data.code;
    $scope.container.barcode = data.barcode;
  }

  function mapProduct(data) {
    $scope.product.id = data.product_id;
    $scope.product.code = data.product_code;
    $scope.product.description = data.product_code + ' - ' + data.product_description;
    $scope.product.quantityIncluded = data.product_quantity_included;
    $scope.product.packageQuantity = data.product_package_quantity;
  }

  function checkContainerMaxQuantity() {
    if (angular.isDefined($scope.container.max_quantity)) {
      $scope.containerFull = ($scope.container.max_quantity <= $scope.container.loaded_quantity);
    } else {
      $scope.containerFull = false;
    }
  }

  function setPercentage() {
    if ($scope.container.max_quantity != null) {
      $scope.percent = ($scope.container.loaded_quantity * 100) / $scope.container.max_quantity;
    }
  }

  var skFilter = [
    {
      "column": "bom b",
      "value": "t.bom_id = b.id",
      "relation": "JOIN",
      "kind": "b.id AS bom_id"
    }, {
      "column": "product p",
      "value": "b.item_id = p.id",
      "relation": "JOIN",
      "kind": "p.id AS product_id, p.description AS product_description, p.code AS product_code, p.quantity_included AS product_quantity_included, p.package_quantity AS product_package_quantity"
    }];

  function setQuantity() {
    $scope.container.loaded_quantity = $scope.packages.length;
    checkContainerMaxQuantity();
    setPercentage();
  }

  function searchAndAddPackage(read, alreadyAdded) {
    var filter = [];
    // se cerco prima quelli già caricati nel container
    if (alreadyAdded) {
      filter = skFilter.concat(dbFilterFactory.getNumberFilter('container_id', $scope.container.id));
    } else {
      // se valorizzato il product mettere in join, altrimenti mapparlo e aggiungere i sk e mappare l'articolo
      filter = skFilter.concat(dbFilterFactory.getStringFilter('t.envelope', read));
      if ($scope.product.id != null) {
        filter = filter.concat(dbFilterFactory.getNumberFilter('p.id', $scope.product.id));
      }
    }
    recordFactory('serial_kit').filter(filterOptions, filter).$promise.then(function (data) {
      console.log(data);
      if (data && data.list && data.list.length > 0) {
        // TODO migliorare la scelta anziché prendere il primo
        if (angular.isUndefined($scope.product.id)) {
          mapProduct(data.list[0]);
        }
        mapKit(data, !alreadyAdded);
      } else {
        localeFactory.translateReplace('goods_inward.kit_not_valid').then(function (translation) {
          toaster.pop(msgType.error, msg.error, translation);
        });
      }
      setQuantity();
    });
  }

  function mapKit(data, removable) {
    // TODO check coerenza dati articoli
    console.log(removable);
    data.list.forEach(function (element) {
      var added = false;
      var tmp = {id: element.id, barcode: element.barcode};
      if ($scope.packages.length > 0) {
        for (var i = 0; i < $scope.packages.length; i++) {
          if ($scope.packages[i].barcode === element.envelope) {
            $scope.packages[i].sk.push(tmp);
            added = true;
            break;
          }
        }
      }
      if (added === false) {
        $scope.packages.push({
          barcode: element.envelope,
          removable: removable,
          sk: [tmp]
        });
      }
    });
  }

  $scope.readCode = function (read) {
    if (!$scope.container.id) {
      var filter = [];
      filter = filter.concat(dbFilterFactory.getStringFilter('barcode', read.read))
        .concat(dbFilterFactory.getCustomFilter(getValidityQuery('t'))); // default 't'
      recordFactory('container').filter(filterOptions, filter).$promise.then(function (data) {
        if (data && data.list && data.list.length > 0) {
          // TODO migliorare la scelta anziché prendere il primo
          mapContainer(data.list[0]);
          searchAndAddPackage(read.read, true);
        } else {
          localeFactory.translateReplace('goods_inward.container_not_valid').then(function (translation) {
            toaster.pop(msgType.error, msg.error, translation);
          });
        }
      });
    } else {
      searchAndAddPackage(read.read, false);
    }
  }

  function removePackFromList(current) {
    return $scope.packages.filter(function (value) {
      return (value.barcode !== current);
    });
  }

  $scope.removeElement = function (element) {
    var current = element.currentTarget.value;
    $scope.packages = removePackFromList(current);
    $scope.container.loaded_quantity = $scope.packages.length;
    setQuantity();
  };

  $scope.refreshList = function () {
    $scope.container = {};
    $scope.product.id = undefined;
    $scope.percent = 0;
    $scope.packages = [];
    $scope.confimIsDisabled = true;
    $scope.codeReaderIsDisabled = false;
  };

  $scope.confirmPack = function () {
    var n = 0;
    if ($scope.packages.length > 0) {
      var a = [];
      $scope.packages.forEach(function (pack) {
        console.log(pack);
        // se un pacco appena aggiunto
        if (pack.removable === true) {
          for(var i = 0; i < pack.sk.length; ++i)  {
            var param = {
              container_id: $scope.container.id,
              last_modified_date: new Date()
            };
            // TODO gestire l'aggiornamento in una singola transazione
            a.push(recordFactory('serial_kit').update({id: pack.sk[i].id}, param).$promise.then(function (res) {
              var updated = 0;
              if (!res) {
                localeFactory.translateReplace('goods_inward.PRODUCT_ERROR').then(function (translation) {
                  toaster.pop(msgType.error, msg.error, translation);
                });
              } else {
                updated = parseInt(res.updated);
              }
              n += updated;
            }));
          }
        }
      });
      Promise.all(a).then(function () {
        if (n > 0) {
          localeFactory.translateReplace('goods_inward.operation_executed').then(function (translation) {
            toaster.pop(msgType.success, msg.success, translation);
          });
        }
        $scope.refreshList();
      });
    }
  };

  function init() {
    $log.info('>>> tntContainerEnvelopeAssociationCtrl');
    localeFactory.loadTranslation('portal');
    localeFactory.loadTranslation('goods_inward');
  }

  //___ main ___
  init();

});

'use strict';

/**
 * Created by Rita Beltrami on 18/09/18
 * @ngdoc component
 * @name ictportal.tnt.component:EditGoodsInwardRowModalCtrl
 * @description Modal window for editing already existing goods inward row.
 * # EditGoodsInwardRowModalCtrl
 */
angular.module('ictportal.tnt').component('editGoodsInwardRowModal',{
      restrict: 'E',
      controller: 'EditGoodsInwardRowModalCtrl',
      bindings: {
        sxTitle: '=',
        sxOnConfirm: '&',
        sxMsg: '=' // translations
      }
  });

'use strict';

angular.module('ictportal.tnt').controller('EditGoodsInwardRowModalCtrl', function ($scope, toaster, $rootScope, $uibModal, 
                                                                                    $log, tntGoodsInwardFactory, $window) {
  var $ctrl = this;
  $ctrl.input = {};
  $ctrl.output = {};

  $rootScope.$on('editGoodsInwardDetail_open', function (evt, data) {
    angular.extend($ctrl.input, data);
    $ctrl.output = angular.copy($ctrl.input);
    $ctrl.modalInstance = showModalConfirm();
    $ctrl.modalInstance.result.then(function (confirmed) {
      if (confirmed) {
        $ctrl.editRow();
      }
    });
  })

  $ctrl.cannotSave = function() {
    var result = !$ctrl.output.expiration_date || !$ctrl.output.lot_code || !$ctrl.input.can_edit;
    return result;
  }

  $ctrl.editRow = function() {
    $ctrl.output.lot_code = $ctrl.output.lot_code.toUpperCase();
    if(!angular.equals($ctrl.input, $ctrl.output)) {
      $ctrl.output.update_lot = ($ctrl.input.lot_code!=$ctrl.output.lot_code);
      $ctrl.output.update_expiration_date = ($ctrl.input.expiration_date.getTime()!=$ctrl.output.expiration_date.getTime());
      $ctrl.output.update_production_date = ($ctrl.input.production_date.getTime()!=$ctrl.output.production_date.getTime());
      tntGoodsInwardFactory.editRow({},$ctrl.output).$promise
        .then(function(response){
          if(response.success) {
            toaster.pop('success', $ctrl.sxMsg.operation_completed, $ctrl.sxMsg.operation_completed_success);
            $window.location.reload();
          }
          else {
            $log.error(response);
            toaster.pop('error', $ctrl.sxMsg.error, $ctrl.sxMsg[response.error_code]); 
          }
        });
    }
    else {
      dismissModal();
    }
  }

  function dismissModal() {
    $ctrl.modalInstance.dismiss();
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  }

  function showModalConfirm() {
    var modalInstance = $uibModal.open({
      animation: true,
      scope: $scope,
      templateUrl: 'tnt/goods-inward/edit-goods-inward-row-modal/edit-goods-inward-row-modal.html'
    });
    return modalInstance;
  }

  $ctrl.$onInit = function () {
    
  }

});
'use strict';

/**
 * @ngdoc function
 * @name ictportal.core.controller:TntGoodsInwardFileUploadCtrl
 * @description Ricevimento merce tnt: caricamento dati da file (SIX-3230)
 * @author Rita Beltrami
 *
 * @param depotCode è OBBLIGATORIO passare alla pagina il codice del deposito su cui importare i serialkit.
 *
 * created on 05/03/2018
 * # TntGoodsInwardFileUploadCtrl
 * Controller of the ictportal.tnt
 */
angular.module('ictportal.tnt')
  .config(function ($routeProvider) {
      $routeProvider
        .when('/tnt/goodsinward/upload/:depotCode', {
          templateUrl: 'tnt/goods-inward/file-upload/file-upload.html',
          controller: 'TntGoodsInwardFileUploadCtrl'
        })
        .when('/tnt/goodsinward/wardrobe/upload/:wardrobeCode', {
          templateUrl: 'tnt/goods-inward/file-upload/file-upload.html',
          controller: 'TntGoodsInwardFileUploadCtrl'
        })
  })
  .controller('TntGoodsInwardFileUploadCtrl', function ($scope,  $routeParams, $location) {

    function init() {
        $scope.depotCode = $routeParams.depotCode;
        $scope.wardrobeCode = $routeParams.wardrobeCode;
    }

    $scope.goToList= function(){
      var path;
      if ($scope.depotCode) {
        path = '/tnt/goodsinward/list/' +  $scope.depotCode;
      } else {
        path = '/tnt/goodsinward/wardrobe/list/' + $scope.wardrobeCode;
      }
      $location.path(path);
    }

    $scope.downloadTemplate = function(fileName){
      var link = document.createElement("a");
      link.download = 'goodsinward_template.xls';
      link.href = fileName;
      link.click();
    }

    init();

  });

'use strict';

/**
 * @author Rita Beltrami
 * created on 03/03/2018
 * @description Componente per visualizzare il dettaglio di una riga di ricevimento merce (o crearne delle nuove).
 */
angular.module('ictportal.tnt').component('tntGoodsInwardRowDetail', {
    templateUrl: 'tnt/goods-inward/goods-inward-row-detail/goods-inward-row-detail.html',
    bindings: {        
        sxRowId: "<",
        sxShow: "<",
        sxReadOnly: "<",
        sxSupplierId: "<",
        sxGoodsInwardId: "<",
        sxCloseCallback: "&",
        sxPrintCallback: "&",
        sxDepot: "&"
    },
    controller: 'tntGoodsInwardRowDetailCtrl'
});


'use strict';

angular.module('ictportal.tnt').controller('tntGoodsInwardRowDetailCtrl', function ($log, recordFactory, sixGridPaginationConstants, $rootScope,
                                                                                eggsFormFactory, toaster, dbFilterFactory, localeFactory, COMPONENT_READ_MODE, $scope,
                                                                                $q, tntGoodsInwardService, uiGridConstants, tntGoodsInwardFactory,
                                                                                serialKitService, matrixParFactory, $location, authFactory) {
    var $ctrl = this;
    var calcBoxes = false;
    $ctrl.sxShow = angular.isDefined($ctrl.sxShow)?$ctrl.sxShow:true;
    $ctrl.sxReadOnly = angular.isDefined($ctrl.sxReadOnly)?$ctrl.sxReadOnly:true;
    $ctrl.result = {};
    var tntProductGroups = [];
    $ctrl.ean128Separator = '|';
    $ctrl.ean128Prefix = ']C1';
    $scope.disableLotAndDate = false;
    var msg = {
        error: "Error",
        warning: "Warning",
        operation_completed_success: "Operation successfully completed",
        operation_completed: "Operation completed",
        barcode: "Barcode",
        product: "Product",
        quantity: "Quantity",
        status: "Status",
        supplier: "Supplier"
    };
    var goods_inward_msg = {
        matching_product_not_found: "No product found matching selected supplier product",
        quantity_included_non_set: "Quantity included not set for product",
        SAVE_EXCEPTION: "Error while saving",
        MISSING_AMOUNT: "Missing quantity",
        MISSING_STOCK_AMOUNT: "Stock amount missing",
        MISSING_ITEM: "Product missing",
        MISSING_LOT: "Lot missing",
        MISSING_GOODS_INWARD: "Missing goods inward reference",
        MISSING_EXPIRATION_DATE: "Missing expiration date",
        MISSING_TYPE: "Missing type",
        MATRIX_PAR_EXCEPTION: "Parameter not found in matrix par",
        SK_EXCEPTION: "Error while creating box",
        GOODS_INWARD_ROW_NOT_FOUND: "Riga di ricevimento non trovata",
        lot: "Lot",
        production_date: "Production date",
        expiration_date: "Expiration date",
        MISSING_ROW_ID: "Missing row id",
        BARCODE_FORMAT: "Cannot read barcode, format error",
        missing_barcode_data: "Some information is missing or not present on database. Check them and retry.",
        changed_barcode_data: "Barcode data changed: no more compliant with selected goods inward row.",
        LOT_EXCEPTION: "Error during lot update",
        LOT_ERROR: "Lot not found",
        MISSING_CONTAINER: "Container non set for selected facility",
        incoherent_product_group: "Incoherent product group (not a TNT product)!",
        isExpired: "Expired: you cannot accept them. It is not possibile to check if goods are expiring.",
        QUANTITY_INCLUDED: "Invalid quantity included on product",
        envelope: "Cartone",
        kit: "Kit",
        duplicated_barcode: "Barcode già registrato"
    };

    var LOTTO_FITTIZIO = "LOTTO_FITTIZIO";

    $ctrl.selection = {};
    $ctrl.barcode = {
        pulse: false,
        message: undefined,
        stored: {}
    }
    $ctrl.readerMode = COMPONENT_READ_MODE.BARCODE;
    $ctrl.viewGridOptions = {
        appScopeProvider: $ctrl,
        paginationPageSize: 10,
        useExternalPagination: true,
        paginationPageSizes: [10]
    };
    $ctrl.record = {
        lookup: {}, // Per questa pagina non serve, la lascio un attimo mentre penso a come standardizzare il più possibile le pagine
        dates: ['expiration_date'],
        model: {}
    };
    $ctrl.params = {
        pageNumber: 1,
        pageSize: 15,
        filters: []
    };
    $ctrl.skData = {
        production_date: undefined
    }
    $ctrl.isSaving = false;
    $ctrl.supplierProductFilter = [];
    $ctrl.lotFilter = [];

    function resetData() {
        for(var key in $ctrl.record.lookup){
            $ctrl.record.lookup[key].obj = undefined;
        }
        for(var key in $ctrl.record.model){
            delete $ctrl.record.model[key];
        }
        $ctrl.barcode.pulse = false;
        $ctrl.isSaving = false;
        $ctrl.skData.production_date = undefined;
        $ctrl.skData.boxes = 0;
        $ctrl.sxRowId = undefined;
        emptyGrid();
    }

    function emptyGrid(){
        if($ctrl.result.list && $ctrl.result.list.length>0){
            $ctrl.result.totalResults = 0;
            if($ctrl.result.list){
                $ctrl.result.list.length = 0;
            }
            if($ctrl.params.gridApi){
                translateGridColumns($ctrl.viewGridOptions.columnDefs);
                $ctrl.params.gridApi.grid.modifyRows($ctrl.viewGridOptions.columnDefs);
                $ctrl.params.gridApi.core.refresh();
            }
        }
    }

    // Recupera un articolo dal suo codice e id fornitore
    function getProductFromSupplierProductCode(productCode) {
        var deferred = $q.defer();
        var filter = [{
            column: 'product p',
            value: 't.product_id = p.id',
            relation: 'JOIN',
            kind: 'p.code as product_code, p.description as product_description, p.quantity_included as quantity_included'
          }].concat(dbFilterFactory.getCustomFilter(" t.code=\'" + productCode + "\' OR t.num=\'" + productCode + "\' "))
            .concat(dbFilterFactory.getNumberFilter('t.supplier_id', $ctrl.sxSupplierId));
        recordFactory('product_supplier').filter({code: 'code', description: 'description'},filter).$promise
        .then(function(data){
            if(data.totalResults>0){
                $ctrl.record.model.supplier_item_id = data.list[0].id;
                $ctrl.record.lookup.supplier_item_id.obj = data.list[0];
                // Necessary for "canAddKit" method
                $ctrl.record.model.item_id = data.list[0].product_id;
                $ctrl.record.lookup.item_id.obj = {
                    id: data.list[0].product_id,
                    code: data.list[0].product_code,
                    description: data.list[0].product_description,
                    quantity_included: data.list[0].quantity_included
                };
                deferred.resolve(true);
            }
            else{
                localeFactory.translateReplace('goods_inward.product_not_found', {productCode: productCode}).then(function(transl){
                    toaster.pop('error', msg.error, transl);
                });
                clearArticle();
                deferred.resolve(false);
            }
        })
        .catch(function(){
            clearArticle();
            deferred.resolve(false);
        });
        return deferred.promise;
    }

    $ctrl.close = function(){
        resetData();
        if($ctrl.sxCloseCallback) {
            $ctrl.sxCloseCallback();
        }
    }

    // Interrogo il server per interpretare il barcode letto secondo la codifica EAN128
    $ctrl.readBarcode = function (read) {
      if(!$scope.isSaving) {
        var param = {barcode: read.read};
        if($ctrl.selection.mode==='QRCODE') {
          param = {plain: read.read};
        }
        tntGoodsInwardFactory.readEan128(param).$promise
          .then(function(response) {
            if (response.error_code) {
              // Se è tutto ok, creo un nuovo serial kit, altrimenti una nuova riga di ricevimento merci, sennò errore
              if($ctrl.record.model.id) {
                $ctrl.addBox(read.read);
              } else {
                  if ($ctrl.canAddKit()) {
                      $ctrl.barcode.pulse = false;
                      $ctrl.saveRow(read.read);
                  } else {
                      $ctrl.barcode.pulse = true;
                      $ctrl.barcode.message = goods_inward_msg.missing_barcode_data;
                  }
              }
            } else {
              parseEan128Barcode(response.data, read.read);
            }
          })
          .catch(angular.identity);
      }
    };

    function sameDate(d1,d2) {
        var d1 = new Date(d1);
        var d2 = new Date(d2);
        return (d1.getDate()==d2.getDate()) && (d1.getMonth()==d2.getMonth()) && (d1.getFullYear()==d2.getFullYear());
    }

    function dataChanged(barcodeData){
        var dataChanged =  false;
        if(!sameDate($ctrl.barcode.stored.dataScadenza,barcodeData.dataScadenza)){
            dataChanged = true;
            $ctrl.record.model.expiration_date = undefined;
        }
        if($ctrl.barcode.stored.lotto!=barcodeData.lotto){
            dataChanged = true;
            $ctrl.record.model.lot_id = undefined;
        }
        if( (barcodeData.content && $ctrl.barcode.stored.content!=barcodeData.content) || (barcodeData.gtin && $ctrl.barcode.stored.gtin!=barcodeData.gtin) ){
            dataChanged = true;
            $ctrl.record.lookup.supplier_item_id.obj = undefined;
            $ctrl.record.model.supplier_item_id = undefined;
        }
        return dataChanged;
    }

    function escapeEan128(code) {
        if(code.startsWith($ctrl.ean128Prefix)) {
            code = code.substring($ctrl.ean128Prefix.length);
        }
        code = code.split($ctrl.ean128Separator).join('');
        return code;
    }

    // Analizzo i dati letti da barcode
    function parseEan128Barcode(barcodeData, readBarcode) {
        $log.info(barcodeData);
        var escapedBarcode = escapeEan128(readBarcode);
        //trovo riga
        var dataScadenza = new Date(barcodeData.dataScadenza);
        var dataProduzione = new Date(barcodeData.dataProduzione);
        var lotto = barcodeData.lotto;
        var item = barcodeData.content || barcodeData.gtin;
        getRowIdFromData(dataScadenza, lotto, item).then(function (res) {
          $ctrl.sxRowId = res ? res.id : undefined;
          $ctrl.$onChanges({sxRowId: {currentValue: $ctrl.sxRowId}});
          //$ctrl.selection.mode = 'BARCODE';
          angular.element("six-code-reader")[0].focus();
          $ctrl.record.model.expiration_date = dataScadenza;
          $ctrl.skData.production_date = dataProduzione;
          $ctrl.record.model.lot_code = lotto;
          if (res){
            $ctrl.barcode.stored.content = item;
            $ctrl.barcode.stored.lotto = lotto;
            $ctrl.barcode.stored.dataScadenza = dataScadenza;
          }
          if($ctrl.sxRowId){
              // Ho già tutti i dati: controllo se non è cambiato nulla e, nel caso, aggiungo un collo
              if($ctrl.record.model){
                  if(dataChanged(barcodeData)){
                      $ctrl.barcode.pulse = true;
                      $ctrl.barcode.message = goods_inward_msg.changed_barcode_data;
                  }
                  else{
                      // Controllo non esista già un kit con questo barcode.
                      recordFactory('serial_kit').filter({}, dbFilterFactory.getStringFilter('barcode',escapedBarcode))
                          .$promise.then(function (data) {
                              if(data.totalResults>0){
                                  $ctrl.barcode.pulse = true;
                                  $ctrl.barcode.message = goods_inward_msg.duplicated_barcode;
                              }
                              else {
                                  $ctrl.barcode.pulse = false;
                                  $ctrl.addBox(escapeEan128(readBarcode));
                              }
                          });
                  }
              }
          }
          else{
              // Cerco di recuperare le entità che mi servono a seconda dei dati letti da barcode
              var promises = [];
              if(barcodeData.dataScadenza){
                  $ctrl.record.model.expiration_date = new Date(barcodeData.dataScadenza);
              }
              if(barcodeData.dataProduzione){
                  $ctrl.skData.production_date = new Date(barcodeData.dataProduzione);
              }
              if(barcodeData.lotto){
                  $ctrl.record.model.lot_code = barcodeData.lotto;
              }
              if(barcodeData.quantitaVariabile){
                  if($ctrl.record.lookup.item_id.obj && (barcodeData.quantitaVariabile != $ctrl.record.lookup.item_id.obj.quantity_included) ) {
                      localeFactory.translateReplace('goods_inward.inchoherent_qty', {productCode: $ctrl.record.lookup.item_id.obj.code})
                      .then(function(transl){
                          toaster.pop('error', msg.error, transl);
                      });
                  }
              }
              if(barcodeData.content){
                  promises.push(getProductFromSupplierProductCode(barcodeData.content));
              }
              else if(barcodeData.gtin) {
                  promises.push(getProductFromSupplierProductCode(barcodeData.gtin));
              }
              $q.all(promises).then(function(responses){
                  if($ctrl.canAddKit()) {
                      // Controllo non esista già un kit con questo barcode.
                      recordFactory('serial_kit').filter({}, dbFilterFactory.getStringFilter('barcode', escapedBarcode))
                          .$promise.then(function (data) {
                              if(data.totalResults>0){
                                  $ctrl.barcode.pulse = true;
                                  $ctrl.barcode.message = goods_inward_msg.duplicated_barcode;
                              }
                              else {
                                  $ctrl.barcode.pulse = false;
                                  barcodeData.barcode = escapedBarcode;
                                  $ctrl.saveRow(escapedBarcode);
                                  storeBarcode(barcodeData);
                              }
                          });
                  }
                  else{
                      $ctrl.barcode.pulse = true;
                      $ctrl.barcode.message = goods_inward_msg.missing_barcode_data;
                  }
              });
          }
        })
    }

    // Mi faccio una copia dei dati sensibili del barcode letto per eventuali confronti futuri
    function storeBarcode(barcodeData){
        $ctrl.barcode.stored.dataScadenza = barcodeData.dataScadenza;
        $ctrl.barcode.stored.dataProduzione = barcodeData.dataProduzione;
        $ctrl.barcode.stored.lotto = barcodeData.lotto;
        $ctrl.barcode.stored.content = barcodeData.content;
        $ctrl.barcode.stored.gtin = barcodeData.gtin;
    }

    function clearArticle(){
        $ctrl.record.model.supplier_item_id = undefined;
        $ctrl.record.lookup.supplier_item_id.obj = {};
        $ctrl.record.model.item_id = undefined;
        $ctrl.record.lookup.item_id.obj = {};
    }

    function translateGridColumns(columns){
      columns = columns || $ctrl.viewGridOptions.columnDefs;
        columns.forEach(function(col){
            if(col.translation) {
                if(goods_inward_msg[col.translation]){
                    col.name = goods_inward_msg[col.translation];
                }
                else{
                    col.name = msg[col.translation];
                }
            } else {
              col.name = col.displayName;
            }
        });
    };

    $ctrl.printSerialKit = function(serialKit){
        if($ctrl.sxPrintCallback){
            $ctrl.sxPrintCallback({
              id: serialKit.id,
              isIdKitButPrintEnvelope: $ctrl.selection.mode === "CREAZIONE_KIT" ? false : serialKit.isIdKitButPrintEnvelope,
              calcEan: $ctrl.selection.mode === "CREAZIONE_KIT"
            });
        }
    }

    $ctrl.getData = function () {
        var payload = {
            //page: $ctrl.params.pageNumber,
            page_size: -1,
            code: $ctrl.params.code,
            description: $ctrl.params.description,
            show_revision: false,
            sort_fields: $ctrl.params.sortFields,
            sort_order: $ctrl.params.sortOrder
        };
        var filters = [
            {
                column: 'bom b',
                value: 't.bom_id = b.id',
                relation: 'JOIN',
                kind: 'b.id as bom_id'
            },
            {
                column: 'product',
                value: 'b.item_id = product.id',
                relation: 'JOIN',
                kind: 'product.code as product_code, product.description as product_description'
            },
            {
                column: 'lot',
                value: 't.production_lot_id = lot.id',
                relation: 'JOIN',
                kind: 'lot.code as lot_code, lot.description as lot_description'
            },
            {
                column: 'supplier',
                value: 't.supplier = supplier.id',
                relation: 'JOIN',
                kind: 'supplier.code as supplier_code, supplier.description as supplier_description'
            }
        ];
        filters = filters.concat($ctrl.params.filters);
        if(!$ctrl.sxRowId){
            emptyGrid();
        }
        else {
            filters = filters.concat(dbFilterFactory.getNumberFilter('gi_row_id',$ctrl.sxRowId));
            recordFactory('serial_kit').filter(payload, filters).$promise.then(function (data) {
              $ctrl.viewGridOptions.totalItems = data.totalResults;
              $ctrl.result.totalResults = data.totalResults;
              var offset = $ctrl.params.pageSize * ($ctrl.params.pageNumber - 1);
              $ctrl.result.list = data.list.slice(offset, offset + $ctrl.params.pageSize);
              if ($ctrl.result.totalResults > 0) {
                $ctrl.skData.production_date = new Date($ctrl.result.list[0].last_packing_date);
                $ctrl.skData.boxes = $ctrl.result.list.length;
                $ctrl.barcode.stored.dataProduzione = $ctrl.skData.production_date;
              }
            });
              /*
              //quelli con envelope a null sono cartononi senza figli
              var cartoni = data.list.filter(function (e) {
                return e.envelope == null
              });
              var con_figli = data.list.filter(function (e) {
                return e.envelope != null
              });
              con_figli = sixObjectLib.groupArray(con_figli, ['envelope']);
              //aggiungo a quelli coi figli quelli senza figli come se avessere figli = []
              con_figli = con_figli.concat(cartoni.map(function (e) {
                return [e]
              }));
              con_figli = con_figli.map(function (data) {
                var status = new Set(data.map(function (el) {
                  return el.status;
                }));
                return {
                  //la busta madre è quella settata o il barcode nel caso sia null poichè nella vecchia gestione non veniva settata
                  envelope: data[0].envelope == null ? data[0].barcode : data[0].envelope,
                  id: data[0].id,
                  isIdKitButPrintEnvelope: data[0].envelope !== data[0].barcode,
                  last_packing_date: data[0].last_packing_date,
                  product_code: data[0].product_code,
                  product_description: data[0].product_description,
                  lot_code: data[0].lot_code,
                  expiration_date: data[0].expiration_date,
                  supplier_code: data[0].supplier_code,
                  supplier_description: data[0].supplier_description,
                  status: status.size > 1 ? "" : status.values().next().value,
                  kitAssociati: data[0].envelope === data[0].barcode || data[0].envelope == null ? 1 : data.length,
                  check_in_amount: data.length === 1 ? data[0].check_in_amount : data.reduce(function (total, e) {
                    return total + e.check_in_amount
                  }, 0),
                  subGridOptions: {
                    columnDefs: initSubGridColumns(),
                    data: data[0].envelope === data[0].barcode || data[0].envelope == null ? null : data,
                    disableRowExpandable: data[0].envelope === data[0].barcode || data[0].envelope == null,
                    minRowsToShow: 2
                  }
                }
              });
              con_figli.map(function (data) {
                translateGridColumns(data.subGridOptions.columnDefs);
              });
              return {
                  totalResults: con_figli.length,
                  list: con_figli
              }
            }).then(function (data) {
                $ctrl.viewGridOptions.totalItems = data.totalResults;
                $ctrl.result.totalResults = data.totalResults;
                var offset = $ctrl.params.pageSize*($ctrl.params.pageNumber-1);
                $ctrl.result.list = data.list.slice(offset, offset + $ctrl.params.pageSize);
                if($ctrl.result.totalResults>0){
                    $ctrl.skData.production_date = new Date($ctrl.result.list[0].last_packing_date);
                    $ctrl.skData.boxes = $ctrl.result.list.length;
                    $ctrl.barcode.stored.dataProduzione = $ctrl.skData.production_date;
                }
            });
            */
        }
    };

    var initGridColumns = function () {
      $ctrl.viewGridOptions.rowHeight = 33;
      $ctrl.viewGridOptions.columnDefs = initOneLevelGridColumns();
      /*
      $ctrl.viewGridOptions.columnDefs = initSubGridColumns();
      $ctrl.viewGridOptions.columnDefs.splice(1, 0, {
        displayName: 'Kit associati',
        field: 'kitAssociati',
        width: 70,
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false
      });
      $ctrl.viewGridOptions.columnDefs = $ctrl.viewGridOptions.columnDefs.filter(function (el) {
        return el["name"] !== "Kit"
      });
      */
    };

  var initOneLevelGridColumns = function () {
    var columnDefs = [];
    var dateFormat = localeFactory.getDateFormat();
    columnDefs.push({
      displayName: '',
      field: 'id',
      width: 35,
      enableCellEdit: false,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate:
        '<div class="ui-grid-cell-contents" style="text-align: center">' +
        '<button ng-click="grid.appScope.printSerialKit(row.entity)" class="btn btn-xs btn-primary" title="Stampa">' +
        '<span class="fa fa-print"></span>' +
        '</button>' +
        '</div>'
    });
    columnDefs.push({
      name: "Cartone",
      field: "envelope",
      translation: "envelope",
      enableFiltering: false
    });
    columnDefs.push({
      name: "Kit",
      field: "barcode",
      translation: 'kit',
      enableFiltering: false
    });
    columnDefs.push({
      name: 'Product',
      field: 'product_code',
      translation: 'product',
      cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.product_code }} - {{ row.entity.product_description }}</div>',
      enableFiltering:false,
      filters:[{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: '',
        kind: 'string',
        aliasResolver: 'product.code,product.description'
      }]
    });
    columnDefs.push({
      name: 'Lot',
      field: 'lot_code',
      translation: 'lot',
      enableFiltering:false,
      filters:[{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: '',
        kind: 'string',
        aliasResolver: 'lot.code'
      }]
    });
    columnDefs.push({
      name: "Production date",
      field: "last_packing_date",
      translation: 'production_date',
      width: 100,
      cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.last_packing_date | date:\'' + dateFormat + '\' }}</div>',
      enableFiltering: false
    });
    columnDefs.push({
      name: "Expiration date",
      field: "expiration_date",
      translation: 'expiration_date',
      width: 100,
      cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.expiration_date | date:\'' + dateFormat + '\' }}</div>',
      enableFiltering: false
    });
    columnDefs.push({
      name: "Quantity",
      field: "check_in_amount",
      translation: 'quantity',
      width: 100,
      enableFiltering: false
    });
    columnDefs.push({
      name: "Status",
      field: "status",
      translation: 'status',
      width: 100,
      enableFiltering: false,
      cellTemplate: '<div class="ui-grid-cell-contents">{{ grid.appScope.getStatusTranslation( row.entity.status ) || row.entity.status }}</div>'
    });
    return columnDefs;
  };
    /*
    var initSubGridColumns = function () {
        var columnDefs = [];
        var dateFormat = localeFactory.getDateFormat();
        columnDefs.push({
            displayName: '',
            field: 'id',
            width: 34,
            enableCellEdit: false,
            enableFiltering: false,
            enableSorting: false,
            cellTemplate:
            '<div class="ui-grid-cell-contents" style="text-align: center">' +
                '<button ng-click="grid.appScope.printSerialKit(row.entity)" class="btn btn-xs btn-primary" title="Stampa">' +
                '<span class="fa fa-print"></span>' +
                '</button>' +
            '</div>'
        });
        columnDefs.push({
        name: "Cartone",
        field: "envelope",
        translation: "barcode",
        width: 100,
        enableFiltering: false
      });
        columnDefs.push({
            name: "Kit",
            field: "barcode",
            translation: 'kit',
            width: 100,
            enableFiltering: false
        });
        columnDefs.push({
            name: 'Product',
            field: 'product_code',
            translation: 'product',
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.product_code }} - {{ row.entity.product_description }}</div>',
            enableFiltering:false,
            filters:[{
                type: sixGridPaginationConstants.filterType.TEXT,
                condition: uiGridConstants.filter.CONTAINS,
                placeholder: '',
                kind: 'string',
                aliasResolver: 'product.code,product.description'
            }]
        });
        columnDefs.push({
            name: 'Lot',
            field: 'lot_code',
            translation: 'lot',
            enableFiltering:false,
            filters:[{
                type: sixGridPaginationConstants.filterType.TEXT,
                condition: uiGridConstants.filter.CONTAINS,
                placeholder: '',
                kind: 'string',
                aliasResolver: 'lot.code'
            }]
        });
        columnDefs.push({
            name: "Production date",
            field: "last_packing_date",
            translation: 'production_date',
            width: 100,
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.last_packing_date | date:\'' + dateFormat + '\' }}</div>',
            enableFiltering: false
        });
        columnDefs.push({
            name: "Expiration date",
            field: "expiration_date",
            translation: 'expiration_date',
            width: 100,
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.expiration_date | date:\'' + dateFormat + '\' }}</div>',
            enableFiltering: false
        });
        columnDefs.push({
            name: "Quantity",
            field: "check_in_amount",
            translation: 'quantity',
            width: 100,
            enableFiltering: false
        });
        columnDefs.push({
            name: "Status",
            field: "status",
            translation: 'status',
            width: 100,
            enableFiltering: false,
            cellTemplate: '<div class="ui-grid-cell-contents">{{ grid.appScope.getStatusTranslation( row.entity.status ) || row.entity.status }}</div>'
        });
        columnDefs.push({
            name: 'Supplier',
            field: 'supplier_code',
            translation: 'supplier',
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.supplier_code }} - {{ row.entity.supplier_description }}</div>',
            enableFiltering:false,
            filters:[{
                type: sixGridPaginationConstants.filterType.TEXT,
                condition: uiGridConstants.filter.CONTAINS,
                placeholder: '',
                kind: 'string',
                aliasResolver: 'supplier.code,supplier.description'
            }]
        });
        return columnDefs;
    };
    */

    $ctrl.getStatusTranslation = function(status) {
        return serialKitService.getStatusTranslation(status);
    };

    function getLotId(){
      if ($ctrl.record.model.lot_code === undefined){
        toaster.pop("error", "Necessario Lotto") // TODO manage translation
      }
        var deferred = $q.defer();
        $ctrl.record.model.lot_code = $ctrl.record.model.lot_code.toUpperCase();
        var filter = dbFilterFactory.getStringFilter('code',$ctrl.record.model.lot_code);
        recordFactory('lot').filter({},filter).$promise
        .then(function(data){
            if(data.totalResults>0){
                deferred.resolve(data.list[0].id);
            }
            else{
                tntGoodsInwardFactory.createNewLot({param2: $ctrl.record.model.lot_code, param3: $ctrl.sxSupplierId}).$promise
                .then(function(response){
                    if(response.success){
                        deferred.resolve(response.id);
                    }
                })
                .catch(function(){ deferred.reject(-1); $log.error('Errore nella creazione del lotto');});
            }
        })
        .catch(function(){ deferred.reject(-1); $log.error('Errore nel recupero del lotto');});
        return deferred.promise;
    }

    function initLookups() {
        eggsFormFactory.addLookup($ctrl.record.lookup, 'item_id', 'product', 'code', 'description');
        eggsFormFactory.addLookup($ctrl.record.lookup, 'supplier_item_id', 'product_supplier', 'code', 'description');
    }

    // Ho un articolo fornitore: cerco l'articolo corrispondente (tabelle product_supplier -> product)
    $scope.$watch('$ctrl.record.lookup.supplier_item_id.obj', function(newValue, oldValue) {
            if(newValue) {
                if(!$ctrl.sxRowId){
                    $ctrl.record.model.item_id = newValue.product_id;
                    if(!$ctrl.record.model.item_id){
                        toaster.pop('error',msg.error,goods_inward_msg.matching_product_not_found);
                    }
                    else {
                        recordFactory('product').byId({id: $ctrl.record.model.item_id}).$promise.then(function (data) {
                            $ctrl.record.lookup.item_id.obj = data;
                            if(!$ctrl.record.lookup.item_id.obj.quantity_included) {
                                toaster.pop('error',msg.error,goods_inward_msg.quantity_included_non_set);
                            }
                            else {
                                $ctrl.skData.boxes = 1;
                                $ctrl.selection.amountToGenerate = $ctrl.skData.boxes*$ctrl.record.lookup.item_id.obj.quantity_included;
                                $ctrl.selection.boxesToGenerate = 1;
                                if(!$ctrl.skData.amountToGenerate && $ctrl.selection.amountToGenerate) {
                                    $ctrl.skData.amountToGenerate = $ctrl.selection.amountToGenerate;
                                }
                                setStockAmount($ctrl.skData.amountToGenerate);
                                $ctrl.skData.boxes = $ctrl.skData.boxes?($ctrl.skData.boxes+1):1;
                                getTracked($ctrl.record.lookup.item_id.obj.code).then(function (res) {
                                  $scope.disableLotAndDate = !res;
                              });
                            }
                        });
                    }
                }
                else {
                    recordFactory('product').byId({ id: $ctrl.record.model.item_id }).$promise.then(function (data) {
                        $ctrl.skData.boxes = 1;
                        $ctrl.selection.boxesToGenerate = 1;
                        setStockAmount($ctrl.skData.boxes * data.quantity_included);
                    });
                }
            }
            else{
                $ctrl.record.model.item_id = undefined;
                $ctrl.record.lookup.item_id.obj = {};
                $ctrl.skData.boxes = 0;
            }
        }
    )

    $scope.$watch('$ctrl.record.lookup.item_id.obj', function(newValue, oldValue) {
        if($ctrl.record.lookup.item_id.obj && calcBoxes){
            calcBoxes = false;
            if($ctrl.record.lookup.item_id.obj.quantity_included){
                $ctrl.skData.boxes = $ctrl.record.model.stock_amount / $ctrl.record.lookup.item_id.obj.quantity_included;
            }
            if(tntProductGroups.indexOf($ctrl.record.lookup.item_id.obj.product_group_id)==-1) {
                toaster.pop('warning', msg.warning, goods_inward_msg.incoherent_product_group);
            }
        }
    })

  $scope.$watch('$ctrl.skData.boxes', function (newValue) {
    var boxes = angular.isDefined(newValue) ? newValue : 1;
    if (boxes < 0) {
      boxes = 0;
      $ctrl.skData.boxes = boxes;
      $ctrl.selection.boxesToGenerate = boxes;
    } else if (boxes > $ctrl.selection.boxesToGenerate) {
      $ctrl.selection.boxesToGenerate = boxes;
      $ctrl.skData.boxes = boxes;
    }
    if ($ctrl.record.lookup.item_id && $ctrl.record.lookup.item_id.obj && $ctrl.record.lookup.item_id.obj.quantity_included) {
      setStockAmount(boxes * $ctrl.record.lookup.item_id.obj.quantity_included);
    } else {
      setStockAmount(0);
    }
  });

    function getRowDetail(id) {
        var filters = [{
            column: 'lot',
            value: 't.lot_id = lot.id',
            relation: 'JOIN',
            kind: 'lot.code as lot_code'
        },
        {
            column: 'product_supplier p',
            value: 't.item_id = p.product_id',
            relation: 'JOIN',
            kind: 'p.code as product_code'
        }].concat(dbFilterFactory.getNumberFilter('t.id',id));
        recordFactory('goods_inward_row').filter({},filters).$promise
        .then(function(data) {
            $ctrl.selection.isExistingRow = true;
            $ctrl.record.model = data.list[0];
            $ctrl.barcode.stored.dataScadenza = $ctrl.record.model.expiration_date;
            $ctrl.barcode.stored.lotto = $ctrl.record.model.lot_code;
            $ctrl.barcode.stored.content = $ctrl.record.model.product_code;
            $ctrl.barcode.stored.gtin = $ctrl.record.model.product_code;
            eggsFormFactory.convertDates($ctrl.record.model, $ctrl.record.dates);
            eggsFormFactory.loadLookupData($ctrl.record.lookup, $ctrl.record.model);
            calcBoxes = true;
            $ctrl.getData();
            getSupplierProduct($ctrl.record.model.item_id);
        })
        .catch(angular.identity);
    }

    // Assumiamo che per il tnt ci sia una relazione 1:1 tra articolo fornitore e articolo six.
    function getSupplierProduct(productId){
        var filter = dbFilterFactory.getNumberFilter('product_id',productId);
        recordFactory('product_supplier').filter({code: 'code', description: 'description'},filter).$promise
        .then(function(data) {
            if(data.totalResults>0){
                $ctrl.record.model.supplier_item_id = data.list[0].id;
                $ctrl.record.lookup.supplier_item_id.obj = data.list[0];
            }
        })
        .catch(angular.identity);
    }

    // Aggiunge un collo ad una riga di ricevimento già esistente.
  $ctrl.addBox = function (readBarcode) {
    $ctrl.isSaving = true;
    $ctrl.record.model.production_date = $ctrl.skData.production_date;
    $ctrl.record.model.goods_inward_id = $ctrl.sxGoodsInwardId;
    if ($ctrl.sxRowId) {
      $ctrl.record.model.id = $ctrl.sxRowId;
    }
    $ctrl.record.model.serial_kit_quantity = ($ctrl.selection.mode === 'MULTIPLE') ? $ctrl.skData.boxes : 1;
    $ctrl.record.model.serial_kit_quantity = ($ctrl.selection.mode === 'CREAZIONE_KIT') ? $ctrl.skData.amount : $ctrl.record.model.serial_kit_quantity;
    $ctrl.record.model.ignore_envelope = ($ctrl.selection.mode === 'QRCODE' || $ctrl.selection.mode === 'CREAZIONE_KIT');
    var payload = {};
    if (readBarcode) {
      payload.barcode = readBarcode;
    }
    tntGoodsInwardFactory.addBox(payload, $ctrl.record.model).$promise
      .then(function (response) {
        if (response.success) {
          $ctrl.skData.boxes_prev = $ctrl.skData.boxes_prev + $ctrl.record.model.serial_kit_quantity;
          $ctrl.record.model.stock_amount = response.model.stock_amount;
          $ctrl.skData.boxes = 1;
          toaster.pop('success', msg.operation_completed, msg.operation_completed_success);
          $ctrl.getData();
        } else {
          toaster.pop('error', msg.error, goods_inward_msg[response.error_code]);
        }
        $ctrl.isSaving = false;
        $ctrl.record.model.ignore_envelope = false;
      })
      .catch(function () {
        $ctrl.isSaving = false;
        $ctrl.record.model.ignore_envelope = false;
      });
  };

  function createNewGoodsInwardRow(readBarcode) {
    $ctrl.record.model.production_date = $ctrl.skData.production_date;
    $ctrl.record.model.goods_inward_id = $ctrl.sxGoodsInwardId;
    $ctrl.record.model.type = 'AMOUNT'; // Per ora unico valore possibile. Vedi GoodsInwardTypeHandler.java
    $ctrl.record.model.id = ($ctrl.sxRowId) ? $ctrl.sxRowId : undefined;
    $ctrl.record.model.ignore_envelope = ($ctrl.selection.mode === 'QRCODE' || $ctrl.selection.mode === 'CREAZIONE_KIT');
    var payload = {};
    if (readBarcode) {
      payload.barcode = readBarcode;
    }
    tntGoodsInwardFactory.saveOrUpdateGoodsInwardRow(payload, $ctrl.record.model).$promise
      .then(function (response) {
        if (response.success) {
          $ctrl.sxRowId = response.model.id;
          $rootScope.$broadcast('goodsInward:savedRow', response.model);
          $ctrl.selection.isExistingRow = true;
          setStockAmount(response.model.stock_amount);
          toaster.pop('success', msg.operation_completed, msg.operation_completed_success);
          $ctrl.getData();
        } else {
          toaster.pop('error', msg.error, goods_inward_msg[response.error_code]);
        }
        $ctrl.isSaving = false;
        $ctrl.record.model.ignore_envelope = false;
      })
      .catch(function (ex) {
        $ctrl.isSaving = false;
        $ctrl.record.model.ignore_envelope = false;
      })
  }

    // Salva una nuova riga di ricevimento merce.
    $ctrl.saveRow = function (readBarcode) {
        $ctrl.isSaving = true;
        getTracked($ctrl.record.lookup.item_id.obj.code).then(function (res) {
          if (res === false) {
            //SD20190828_TNT_V1 (punto 13) se non è definita si inserice lotto e data scadenza fittizi
            if ($ctrl.record.model.expiration_date === undefined || $ctrl.record.model.expiration_date.toString() === 'Invalid Date') {
              $ctrl.record.model.expiration_date = new Date(32535212400000);
            }
            if ($ctrl.record.model.lot_code === undefined) {
              $ctrl.record.model.lot_code = (LOTTO_FITTIZIO + "_" + $ctrl.record.lookup.item_id.obj.code.replace('/', '_')).substr(0, 30);
            }
          }

          // Il kit non deve essere già scaduto
          if($ctrl.record.model.expiration_date>=(new Date())) {
              // Ho già la riga di ricevimento, creo solo il kit
              if ($ctrl.sxRowId) {
                  $ctrl.addBox(readBarcode);
              }
              // Devo inserire anche la riga di ricevimento
              else {
                  getLotId().then(function (lotId) {
                      if (lotId > 0) {
                          $ctrl.record.model.lot_id = lotId;
                          createNewGoodsInwardRow(readBarcode);
                      }
                      else {
                          toaster.pop('error', msg.error, goods_inward_msg.LOT_EXCEPTION);
                      }
                  })
              }
          }
          else {
              toaster.pop('error', msg.error, goods_inward_msg.isExpired);
              $ctrl.isSaving = false;
              $ctrl.record.model.ignore_envelope = false;
          }
      })
    };

    // Validazione dati obbligatori.
    $ctrl.canAddKit = function(){
        var result = angular.isDefined($ctrl.record.lookup.item_id) && angular.isDefined($ctrl.record.lookup.item_id.obj);
        result = result && $ctrl.record.model.item_id;
        result = result && $ctrl.record.lookup.item_id.obj.quantity_included;
        //SD20190828_TNT_V1 (punto 13) lotto e data scadenza diventano facoltativi
        //result = result && $ctrl.record.model.lot_code;
        //result = result && $ctrl.record.model.expiration_date;
        result = result && $ctrl.skData.boxes > 0;
        return result;
    };

    this.$onChanges = function (changesObj) {
        if (changesObj.sxSupplierId) {
            // articoli fornitore e lotto sono filtrati sulla base del fornitore selezionato in testata
            $ctrl.supplierProductFilter.length = 0;
            $ctrl.lotFilter.length = 0;
            if(angular.isDefined(changesObj.sxSupplierId.currentValue)){
                $ctrl.supplierProductFilter = $ctrl.supplierProductFilter.concat(dbFilterFactory.getNumberFilter('supplier_id', changesObj.sxSupplierId.currentValue));
                $ctrl.lotFilter = $ctrl.lotFilter.concat(dbFilterFactory.getNumberFilter('supplier_id', changesObj.sxSupplierId.currentValue));
            }
        }
        if(changesObj.sxRowId) {
            $ctrl.selection.isExistingRow = angular.isDefined(changesObj.sxRowId.currentValue);
            if($ctrl.selection.isExistingRow){
                getRowDetail(changesObj.sxRowId.currentValue);
            }
            else{
                $ctrl.skData.boxes = 0;
            }
        }
        else {
            // Reset
            initSelection();
        }
    };

    function initSelection() {
        $ctrl.selection.isExistingRow = false;
        $ctrl.selection.mode = 'MULTIPLE';
        $ctrl.selection.amountToGenerate = 0;
        $ctrl.selection.boxesToGenerate = undefined;
    }

    function setStockAmount(value) {
        $ctrl.skData.amount = value;
        $ctrl.selection.amountToGenerate = $ctrl.skData.amount;
        if(!$ctrl.selection.isExistingRow){
            $ctrl.record.model.stock_amount = value;
            $ctrl.record.model.billing_amount = value;
            $ctrl.record.model.alt_amount = value;
        }
        else {
            $ctrl.skData.boxes_prev = $ctrl.record.model.stock_amount/$ctrl.record.lookup.item_id.obj.quantity_included;
        }
    }

    function loadTntProductGroups(){
        matrixParFactory.getMatrixPar({key: 'tntProductGroup', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}).$promise.then(function(response){
            if(response.value){
                var codes = response.value.trim().split(",");
                if(codes.length>0){
                    recordFactory('product_group').filter({},dbFilterFactory.getCustomFilter( dbFilterFactory.getOrQuery('code', codes) ) ).$promise
                    .then(function(data){
                        if(data && data.totalResults>0){
                            data.list.forEach(function(pg) { tntProductGroups.push(pg.id); });
                        }
                    })
                    .catch(angular.identity);
                }
                else {
                    alert('tntProductGroup not defined');
                }
            }
        }).catch(angular.identity);
    }

    function checkPermissions() {
        var profilingKey = 'TNT_GOODS_INWARD_FUNCTION';
        var permission = authFactory.getPermissions(profilingKey);
        if (!permission.EXEC) {
            $location.path('forbidden').search({ key: profilingKey });
        }
        else {
            $ctrl.isNewAllowed = permission.NEW;
            $ctrl.isDetailAllowed = permission.DETAIL;
            $ctrl.isUpdateAllowed = permission.UPDATE;

            if (!permission.DETAIL) {
                $location.path('forbidden').search({ key: profilingKey });
            }

        }
    };

    // I can edit a row only if all kits are all still sterilized.
    $ctrl.showEditRowModal = function() {
        var filters = dbFilterFactory.getNumberFilter('gi_row_id',$ctrl.sxRowId)
              .concat(dbFilterFactory.getStringFilter('status','STERILIZED','<>'));
        recordFactory('serial_kit').filter({page_size: 1000}, filters).$promise
            .then(function(data) {
                var payload = {
                    goods_inward_id:$ctrl.sxGoodsInwardId,
                    id: $ctrl.sxRowId,
                    expiration_date: $ctrl.record.model.expiration_date,
                    production_date: $ctrl.skData.production_date,
                    lot_code: $ctrl.record.model.lot_code,
                    can_edit: (data.totalResults==0)
                };
                $rootScope.$broadcast('editGoodsInwardDetail_open', payload);
            });
    };

    $ctrl.$onInit = function () {
        matrixParFactory.getValueOrDefault({key: 'ean128.function', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}, {defaultValue: "|"}).$promise.then(function(data){
            $ctrl.ean128Separator = data.result.value;
        });
        initSelection();
        checkPermissions();
        $ctrl.skEnum = serialKitService.enum;
        $ctrl.enum = tntGoodsInwardService.enum;
        loadTntProductGroups();
        localeFactory.loadTranslation('serialkit');
        localeFactory.loadTranslation('goods_inward')
            .then(function () {
                $q.all({
                    general: localeFactory.translateMsg(msg),
                    specific: localeFactory.translateMsg(goods_inward_msg, 'goods_inward')
                })
                .then(function (data) {
                    $ctrl.msgMerge = {};
                    angular.extend($ctrl.msgMerge, msg);
                    angular.extend($ctrl.msgMerge, goods_inward_msg);
                    translateGridColumns();
                })
                .catch(angular.identity);
            })
            .catch(angular.identity);
        initLookups();
        initGridColumns();
    }

   function getRowIdFromData(dataScadenza, lotto, item) {
     var defer = $q.defer();
     getProductFromSupplierProductCodeOnly(item).then(function (e) {
       var filters = [
         {
           column: 'lot l',
           value: 't.lot_id = l.id',
           relation: 'JOIN',
           kind: 'l.code as lot_code'
         }];
       filters = filters.concat(dbFilterFactory.getNumberFilter('item_id', $ctrl.record.model.item_id));
       filters = filters.concat(dbFilterFactory.getStringFilter('l.code', lotto));
       filters = filters.concat(dbFilterFactory.getDateFilter('expiration_date', dataScadenza, '='));
       filters = filters.concat(dbFilterFactory.getNumberFilter('goods_inward_id', $ctrl.sxGoodsInwardId));

       recordFactory('goods_inward_row').filter({page_size: 1}, filters).$promise.then(function (row) {
         if (row.list.length > 0){
           calcBoxes = true;
           defer.resolve({
             id: row.list[0].id,
             item_id: row.list[0].item_id,
             stock_amount: row.list[0].stock_amount,
             billing_amount: row.list[0].billing_amount
           })
         } else {
           defer.resolve(undefined);
         }

       });
     });

     return defer.promise;
   }

  function getProductFromSupplierProductCodeOnly(productCode) {
    var deferred = $q.defer();
    var filter = [{
      column: 'product p',
      value: 't.product_id = p.id',
      relation: 'JOIN',
      kind: 'p.code as product_code, p.description as product_description, p.quantity_included as quantity_included'
    }].concat(dbFilterFactory.getCustomFilter(" t.code=\'" + productCode + "\' OR t.num=\'" + productCode + "\' "))
      .concat(dbFilterFactory.getNumberFilter('t.supplier_id', $ctrl.sxSupplierId));
    recordFactory('product_supplier').filter({code: 'code', description: 'description'},filter).$promise
      .then(function(data){
        if(data.totalResults>0){
          $ctrl.record.model.supplier_item_id = data.list[0].id;
          $ctrl.record.lookup.supplier_item_id.obj = data.list[0];
          // Necessary for "canAddKit" method
          $ctrl.record.model.item_id = data.list[0].product_id;
          $ctrl.record.lookup.item_id.obj = {
            id: data.list[0].product_id,
            code: data.list[0].product_code,
            description: data.list[0].product_description,
            quantity_included: data.list[0].quantity_included
          };
          deferred.resolve(true);
        }
        else{
          localeFactory.translateReplace('goods_inward.product_not_found', {productCode: productCode}).then(function(transl){
            toaster.pop('error', msg.error, transl);
          });
          clearArticle();
          deferred.resolve(false);
        }
      })
      .catch(function(){
        clearArticle();
        deferred.resolve(false);
      });
    return deferred.promise;
  }

  var ean128Desc = {
    ARTICOLO: ["01", 14],
    LOTTO: ["10"],
    SCADENZA: ["17", 6],
    PEZZI: ["37"],
    PROGRESSIVO: ["91"]
  }

  function getEanField(field, value){
    var padded = "";
    if (ean128Desc[field][1]){
      padded = value.padStart(ean128Desc[field][1], "0");
    } else {
      padded = value;
    }
    return ean128Desc[field][0] + padded
  }

  $ctrl.createKits = function () {
    //cerco il progressivo del lotto a DB (prendo massimo + 1)
    getProgressivoLotto($ctrl.record.model.lot_code, $ctrl.sxSupplierId).then(function (res) {
      var next = 0;
      if (res.list && res.list > 0){
        next = max(res.list[0].map(function (e) {
          return e.index;
        }))
      }
      var serial_kit_list = [];
      for (var i=0; i<$ctrl.skData.amount; i++){
        //creo EAN
        var ean128 = getEanField('ARTICOLO', $ctrl.record.lookup.supplier_item_id.obj.code);
        ean128 = ean128 + getEanField('SCADENZA', yymmdd($ctrl.record.model.expiration_date));
        ean128 = ean128 + getEanField('LOTTO', $ctrl.record.model.lot_code);
        ean128 = ean128 + getEanField('PROGRESSIVO', (next+i).toString());

        serial_kit_list.push({
          barcode: ean128,
          envelope: null,
          quantity_included: 1
        })
      }

      // [SIXLM-545] per la modalità "creazione kit" la busta madre rimane invariata
      $ctrl.record.model.ignore_envelope = true;

      //chiamo la funzione per memorizzare la riga o aggiungere il kit a quella esistente
      if ($ctrl.sxRowId){
        $ctrl.addBox(ean128)
      } else {
        $ctrl.record.model.serial_kit_list = serial_kit_list;
        $ctrl.saveRow(ean128)
      }
    })
};

    function getTracked(code) {
      var deferred = $q.defer();
      var filter = [
        {
          column: 'endowment e',
          kind: '1',
          relation: 'JOIN',
          value: 't.endowment_id = e.id'
        },
        {
          column: 'customer_destination cd',
          kind: '1',
          relation: 'JOIN',
          value: 'e.destination_id = cd.id'
        },
        {
          column: 'product p',
          kind: '1',
          relation: 'JOIN',
          value: 't.product_id = p.id'
        },
        {
          column: 'p.code',
          kind: 'string',
          relation: '=',
          value: code
        },
        {
          column: 'cd.container_id',
          kind: 'number',
          relation: '=',
          value: $ctrl.sxDepot().toString(),
        }
      ];

      recordFactory('endowment_item').filter({},filter).$promise.then(function (data) {
        if (data.list && data.list.length > 0 && data.list[0].tracked === true) {
          deferred.resolve(true)
        } else {
          filter = [
            {
              column: 'code',
              kind: 'string',
              relation: '=',
              value: code
            }
          ]
          recordFactory('product').filter({},filter).$promise.then(function (data) {
            if (data.list && data.list.length > 0 && data.list[0].identification && data.list[0].identification === 3){
              deferred.resolve(false);
            } else {
              deferred.resolve(true);
            }
          });
        }
      })

      return deferred.promise;
    }

  function getProgressivoLotto(lotto, fornitore) {
    var filters = [
      {
        column: "goods_inward_row",
        kind: "null",
        relation: "JOIN",
        value: "t.id = goods_inward_row.goods_inward_id"
      },
      {
        column: "lot l",
        kind: "null",
        relation: "JOIN",
        value: "goods_inward_row.lot_id = l.id"
      },
      {
        column: "lot_row lr",
        kind: "lr.row_index as index",
        relation: "JOIN",
        value: "l.id = lr.lot_id"
      },
      {
        column: "l.code",
        kind: "string",
        relation: "=",
        value: lotto
      },
      {
        column: "t.supplier_id",
        kind: "number",
        relation: "=",
        value: fornitore.toString()
      }
    ];

    return recordFactory('goods_inward').filter({page_size: -1}, filters).$promise
  }

  function yymmdd(x) {
    var y = x.getFullYear().toString().substr(2,2);
    var m = (x.getMonth() + 1).toString();
    var d = x.getDate().toString();
    (d.length == 1) && (d = '0' + d);
    (m.length == 1) && (m = '0' + m);
    var yymmdd = y + m + d;
    return yymmdd;
  }

});

'use strict';

/**
 * @author Rita Beltrami
 * created on 03/03/2018
 * @description Componente per visualizzare il dettaglio di una riga di ricevimento merce (o crearne delle nuove).
 */
angular.module('ictportal.tnt').component('tntGoodsInwardRowDetailDispatch', {
    templateUrl: 'tnt/goods-inward/goods-inward-row-detail-dispatch/goods-inward-row-detail-dispatch.html',
    bindings: {        
        sxRowId: "<",
        sxShow: "<",
        sxSupplierId: "<",
        sxGoodsInwardId: "<",
        sxCloseCallback: "&",
        sxPrintCallback: "&",
        sxCustomerDestinationId: "<" // Se definito, consento la modalità in evasione. Filtro gli ordini per questa destinazione.
    },
    controller: 'tntGoodsInwardRowDetailDispatchCtrl'
});


'use strict';

angular.module('ictportal.tnt').controller('tntGoodsInwardRowDetailDispatchCtrl', function ($log, recordFactory, sixGridPaginationConstants,
                                                                                            eggsFormFactory, toaster, dbFilterFactory, localeFactory, COMPONENT_READ_MODE, $scope,
                                                                                            $q, tntGoodsInwardService, uiGridConstants, tntGoodsInwardFactory,
                                                                                            serialKitService, matrixParFactory) {
    var $ctrl = this;
    var calcBoxes = false;
    $ctrl.sxShow = angular.isDefined($ctrl.sxShow) ? $ctrl.sxShow : true;
    $ctrl.result = {};
    var tntProductGroups = [];
    var msg = {
        error: "Error",
        warning: "Warning",
        operation_completed_success: "Operation successfully completed",
        operation_completed: "Operation completed",
        barcode: "Barcode",
        product: "Product",
        quantity: "Quantity",
        status: "Status",
        supplier: "Supplier"
    };
    var goods_inward_msg = {
        matching_product_not_found: "No product found matching selected supplier product",
        quantity_included_non_set: "Quantity included not set for product",
        SAVE_EXCEPTION: "Error while saving",
        MISSING_AMOUNT: "Missing quantity",
        MISSING_STOCK_AMOUNT: "Stock amount missing",
        MISSING_ITEM: "Product missing",
        MISSING_LOT: "Lot missing",
        MISSING_GOODS_INWARD: "Missing goods inward reference",
        MISSING_EXPIRATION_DATE: "Missing expiration date",
        MISSING_TYPE: "Missing type",
        MATRIX_PAR_EXCEPTION: "Parameter not found in matrix par",
        SK_EXCEPTION: "Error while creating box",
        GOODS_INWARD_ROW_NOT_FOUND: "Riga di ricevimento non trovata",
        lot: "Lot",
        production_date: "Production date",
        expiration_date: "Expiration date",
        MISSING_ROW_ID: "Missing row id",
        BARCODE_FORMAT: "Cannot read barcode, format error",
        missing_barcode_data: "Some information is missing or not present on database. Check them and retry.",
        changed_barcode_data: "Barcode data changed: no more compliant with selected goods inward row.",
        LOT_EXCEPTION: "Error during lot update",
        LOT_ERROR: "Lot not found",
        MISSING_CONTAINER: "Container non set for selected facility",
        incoherent_product_group: "Incoherent product group (not a TNT product)!",
        isExpired: "Expired kits: you cannot accept them.",
        QUANTITY_INCLUDED: "Invalid quantity included on product",
        order_type_code_unset: "Param \"tntReorderPlantOrderType\" not set on matrix par",
        out_of_orders: "There are no dispatchable orders containing the article ",
        boxes_overflow:"Specified boxes amount exceeds ordered quantity, please modify an order"
    };
    $ctrl.selection = {
        isExistingRow: false,
        mode: 'MULTIPLE',
        customerOrderRows: [],
        customerOrderRowsToDispatch: [],
        amountToGenerate: 0,
        boxesToGenerate: undefined
    };
    $ctrl.boxesOverflow = false;
    $ctrl.barcode = {
        pulse: false,
        message: undefined,
        stored: {}
    }
    $ctrl.readerMode = COMPONENT_READ_MODE.BARCODE;
    $ctrl.viewGridOptions = {
        appScopeProvider: $ctrl
    };
    $ctrl.record = {
        lookup: {}, // Per questa pagina non serve, la lascio un attimo mentre penso a come standardizzare il più possibile le pagine
        dates: ['expiration_date'],
        model: {}
    };
    $ctrl.params = {
        pageNumber: 1,
        pageSize: 15,
        filters: []
    };
    $ctrl.skData = {
        production_date: undefined
    }
    $ctrl.isSaving = false;
    $ctrl.supplierProductFilter = [];
    $ctrl.lotFilter = [];
    $ctrl.dispatchedOrders = [];

    function resetData() {
        for (var key in $ctrl.record.lookup) {
            $ctrl.record.lookup[key].obj = undefined;
        }
        for (var key in $ctrl.record.model) {
            delete $ctrl.record.model[key];
        }
        $ctrl.barcode.pulse = false;
        $ctrl.isSaving = false;
        $ctrl.boxesOverflow = false;
        $ctrl.skData.production_date = undefined;
        $ctrl.skData.boxes = 0;
        $ctrl.skData.amount = 0;
        $ctrl.skData.boxes_prev = 0;
        $ctrl.dispatchedOrders.length = 0;
        emptyGrid();
    }

    function emptyGrid() {
        if ($ctrl.result.list && $ctrl.result.list.length > 0) {
            $ctrl.result.totalResults = 0;
            if ($ctrl.result.list) {
                $ctrl.result.list.length = 0;
            }
            if ($ctrl.params.gridApi) {
                $ctrl.params.gridApi.grid.modifyRows($ctrl.result.list);
                $ctrl.params.gridApi.core.refresh();
            }
        }
    }

    // Recupera un articolo dal suo codice e id fornitore
    function getProductFromSupplierProductCode(productCode) {
        var deferred = $q.defer();
        var filter = dbFilterFactory.getCustomFilter(" code=\'" + productCode + "\' OR num=\'" + productCode + "\' ");
        filter = filter.concat(dbFilterFactory.getNumberFilter('supplier_id', $ctrl.sxSupplierId));
        recordFactory('product_supplier').filter({}, filter).$promise
            .then(function (data) {
                if (data.totalResults > 0) {
                    $ctrl.record.model.supplier_item_id = data.list[0].id;
                    deferred.resolve(true);
                }
                else {
                    localeFactory.translateReplace('goods_inward.product_not_found', { productCode: productCode }).then(function (transl) {
                        toaster.pop('error', msg.error, transl);
                    });
                    deferred.resolve(false);
                }
            })
            .catch(function () {
                deferred.resolve(false);
            });
        return deferred.promise;
    }

    $ctrl.close = function () {
        resetData();
        if ($ctrl.sxCloseCallback) {
            $ctrl.sxCloseCallback();
        }
    }

    // Interrogo il server per interpretare il barcode letto secondo la codifica EAN128
    $ctrl.readBarcode = function (read) {
        if (!$scope.isSaving) {
            tntGoodsInwardFactory.readEan128({ barcode: read.read }).$promise
                .then(function (response) {
                    if (response.error_code) {
                        toaster.pop('error', msg.error, goods_inward_msg.BARCODE_FORMAT);
                    }
                    else {
                        parseBarcode(response.data);
                    }
                })
                .catch(angular.identity);
        }
    }

    function dataChanged(barcodeData) {
        var dataChanged = false;
        if ($ctrl.barcode.stored.dataScadenza != barcodeData.dataScadenza) {
            dataChanged = true;
            $ctrl.record.model.expiration_date = undefined;
        }
        if ($ctrl.barcode.stored.dataProduzione != barcodeData.dataProduzione) {
            dataChanged = true;
            $ctrl.skData.production_date = undefined;
        }
        if ($ctrl.barcode.stored.lotto != barcodeData.lotto) {
            dataChanged = true;
            $ctrl.record.lookup.lot_id.obj = undefined;
            $ctrl.record.model.lot_id = undefined;
        }
        if ($ctrl.barcode.stored.content != barcodeData.content || $ctrl.barcode.gtin != barcodeData.gtin) {
            dataChanged = true;
            $ctrl.record.lookup.supplier_item_id.obj = undefined;
            $ctrl.record.model.supplier_item_id = undefined;
        }
        return dataChanged;
    }

    // Analizzo i dati letti da barcode
    function parseBarcode(barcodeData) {
        $log.info(barcodeData);
        if ($ctrl.sxRowId) {
            // Ho già tutti i dati: controllo se non è cambiato nulla e, nel caso, aggiungo un collo
            if ($ctrl.record.model) {
                if (dataChanged(barcodeData)) {
                    $ctrl.barcode.pulse = true;
                    $ctrl.barcode.message = goods_inward_msg.changed_barcode_data;
                }
                else {
                    if ($ctrl.selection.customerOrderRows && $ctrl.selection.customerOrderRows.length > 0) {
                        // controllo il numero di colli da aggiungere non superi la somma delle quantità presenti nelle righe d'ordine
                        if ((($ctrl.selection.mode==='MULTIPLE')?$ctrl.skData.boxes:1) <= $ctrl.sumProperty($ctrl.selection.customerOrderRows, 'stock_boxes')) {
                            $ctrl.addBox();
                        }
                        else {
                            $ctrl.boxesOverflow = true;
                            toaster.pop('error', msg.error, goods_inward_msg.boxes_overflow);
                        }
                    }
                    else {
                        toaster.pop('error', msg.error, goods_inward_msg.out_of_orders.concat($ctrl.upload.detailData[idx].productCode));
                    }
                }
            }
        }
        else {
            // Cerco di recuperare le entità che mi servono a seconda dei dati letti da barcode
            var promises = [];
            if (barcodeData.dataScadenza) {
                $ctrl.record.model.expiration_date = new Date(barcodeData.dataScadenza);
            }
            if (barcodeData.dataProduzione) {
                $ctrl.skData.production_date = new Date(barcodeData.dataProduzione);
            }
            if (barcodeData.lotto) {
                $ctrl.record.model.lot_code = barcodeData.lotto;
            }
            if (barcodeData.quantitaVariabile) {
                if ($ctrl.record.lookup.item_id.obj && (barcodeData.quantitaVariabile != $ctrl.record.lookup.item_id.obj.quantity_included)) {
                    localeFactory.translateReplace('goods_inward.inchoherent_qty', { productCode: $ctrl.record.lookup.item_id.obj.code })
                        .then(function (transl) {
                            toaster.pop('error', msg.error, transl);
                        });
                }
            }
            if (barcodeData.content) {
                clearArticle();
                promises.push(getProductFromSupplierProductCode(barcodeData.content));
            }
            else if (barcodeData.gtin) {
                clearArticle();
                promises.push(getProductFromSupplierProductCode(barcodeData.gtin));
            }
            $q.all(promises).then(function (responses) {
                if ($ctrl.canAddKit()) {
                    $ctrl.barcode.pulse = false;
                    $ctrl.saveRow();
                    storeBarcode(barcodeData);
                }
                else {
                    $ctrl.barcode.pulse = true;
                    $ctrl.barcode.message = goods_inward_msg.missing_barcode_data;
                }
            });
        }
    }

    // Mi faccio una copia dei dati sensibili del barcode letto per eventuali confronti futuri
    function storeBarcode(barcodeData) {
        $ctrl.barcode.stored.dataScadenza = barcodeData.dataScadenza;
        $ctrl.barcode.stored.dataProduzione = barcodeData.dataProduzione;
        $ctrl.barcode.stored.lotto = barcodeData.lotto;
        $ctrl.barcode.stored.content = barcodeData.content;
        $ctrl.barcode.stored.gtin = barcodeData.gtin;
    }

    function clearArticle() {
        $ctrl.record.model.supplier_item_id = undefined;
        $ctrl.record.lookup.supplier_item_id.obj = {};
        $ctrl.record.model.item_id = undefined;
        $ctrl.record.lookup.item_id.obj = {};
    }

    function translateGridColumns() {
        $ctrl.viewGridOptions.columnDefs.forEach(function (col) {
            if (col.translation) {
                if (goods_inward_msg[col.translation]) {
                    col.name = goods_inward_msg[col.translation];
                }
                else {
                    col.name = msg[col.translation];
                }
            }
        });
    };

    $ctrl.printSerialKit = function (serialKit) {
        if ($ctrl.sxPrintCallback) {
            $ctrl.sxPrintCallback({ id: serialKit.id });
        }
    }

    $ctrl.getData = function () {
        var payload = {
            page: $ctrl.params.pageNumber,
            page_size: $ctrl.params.pageSize,
            code: $ctrl.params.code,
            description: $ctrl.params.description,
            show_revision: false,
            sort_fields: $ctrl.params.sortFields,
            sort_order: $ctrl.params.sortOrder
        };
        var filters = [
            {
                column: 'bom b',
                value: 't.bom_id = b.id',
                relation: 'JOIN',
                kind: 'b.id as bom_id'
            },
            {
                column: 'product',
                value: 'b.item_id = product.id',
                relation: 'JOIN',
                kind: 'product.code as product_code, product.description as product_description, product.quantity_included as quantity_included'
            },
            {
                column: 'lot',
                value: 't.production_lot_id = lot.id',
                relation: 'JOIN',
                kind: 'lot.code as lot_code, lot.description as lot_description'
            },
            {
                column: 'supplier',
                value: 't.supplier = supplier.id',
                relation: 'JOIN',
                kind: 'supplier.code as supplier_code, supplier.description as supplier_description'
            }
        ];
        filters = filters.concat($ctrl.params.filters);
        if (!$ctrl.sxRowId) {
            emptyGrid();
        }
        else {
            filters = filters.concat(dbFilterFactory.getNumberFilter('gi_row_id', $ctrl.sxRowId));
            recordFactory('serial_kit').filter(payload, filters)
                .$promise.then(function (data) {
                    $ctrl.viewGridOptions.totalItems = data.totalResults;
                    $ctrl.result.totalResults = data.totalResults;
                    $ctrl.result.list = data.list;
                    if ($ctrl.result.totalResults > 0) {
                        $ctrl.skData.production_date = new Date($ctrl.result.list[0].last_packing_date);
                    }
                });
        }
    };

    var initGridColumns = function () {
        $ctrl.viewGridOptions.columnDefs = [];
        var dateFormat = localeFactory.getDateFormat();
        $ctrl.viewGridOptions.columnDefs.push({
            displayName: '',
            field: 'id',
            width: 34,
            enableCellEdit: false,
            enableFiltering: false,
            enableSorting: false,
            cellTemplate:
                '<div class="ui-grid-cell-contents" style="text-align: center">' +
                '<button ng-click="grid.appScope.printSerialKit(row.entity)" class="btn btn-xs btn-primary" title="Stampa">' +
                '<span class="fa fa-print"></span>' +
                '</button>' +
                '</div>'
        });
        $ctrl.viewGridOptions.columnDefs.push({
            name: "Barcode",
            field: "barcode",
            translation: 'barcode',
            width: 100,
            enableFiltering: false
        });
        $ctrl.viewGridOptions.columnDefs.push({
            name: 'Product',
            field: 'product_code',
            translation: 'product',
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.product_code }} - {{ row.entity.product_description }}</div>',
            enableFiltering: false,
            filters: [{
                type: sixGridPaginationConstants.filterType.TEXT,
                condition: uiGridConstants.filter.CONTAINS,
                placeholder: '',
                kind: 'string',
                aliasResolver: 'product.code,product.description'
            }]
        });
        $ctrl.viewGridOptions.columnDefs.push({
            name: 'Lot',
            field: 'lot_code',
            translation: 'lot',
            enableFiltering: false,
            filters: [{
                type: sixGridPaginationConstants.filterType.TEXT,
                condition: uiGridConstants.filter.CONTAINS,
                placeholder: '',
                kind: 'string',
                aliasResolver: 'lot.code'
            }]
        });
        $ctrl.viewGridOptions.columnDefs.push({
            name: "Production date",
            field: "last_packing_date",
            translation: 'production_date',
            width: 100,
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.last_packing_date | date:\'' + dateFormat + '\' }}</div>',
            enableFiltering: false
        });
        $ctrl.viewGridOptions.columnDefs.push({
            name: "Expiration date",
            field: "expiration_date",
            translation: 'expiration_date',
            width: 100,
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.expiration_date | date:\'' + dateFormat + '\' }}</div>',
            enableFiltering: false
        });
        $ctrl.viewGridOptions.columnDefs.push({
            name: "Quantity",
            field: "quantity_included",
            translation: 'quantity',
            width: 100,
            enableFiltering: false
        });
        $ctrl.viewGridOptions.columnDefs.push({
            name: "Status",
            field: "status",
            translation: 'status',
            width: 100,
            enableFiltering: false,
            cellTemplate: '<div class="ui-grid-cell-contents">{{ grid.appScope.getStatusTranslation( row.entity.status ) }}</div>'
        });
        $ctrl.viewGridOptions.columnDefs.push({
            name: 'Supplier',
            field: 'supplier_code',
            translation: 'supplier',
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.supplier_code }} - {{ row.entity.supplier_description }}</div>',
            enableFiltering: false,
            filters: [{
                type: sixGridPaginationConstants.filterType.TEXT,
                condition: uiGridConstants.filter.CONTAINS,
                placeholder: '',
                kind: 'string',
                aliasResolver: 'supplier.code,supplier.description'
            }]
        });
    };

    $ctrl.getStatusTranslation = function(status){
        return serialKitService.getStatusTranslation(status); 
    }

    function getLotId() {
        var deferred = $q.defer();
        $ctrl.record.model.lot_code = $ctrl.record.model.lot_code.toUpperCase();
        var filter = dbFilterFactory.getStringFilter('code', $ctrl.record.model.lot_code);
        recordFactory('lot').filter({}, filter).$promise
            .then(function (data) {
                if (data.totalResults > 0) {
                    deferred.resolve(data.list[0].id);
                }
                else {
                    tntGoodsInwardFactory.createNewLot({ param2: $ctrl.record.model.lot_code, param3: $ctrl.sxSupplierId }).$promise
                        .then(function (response) {
                            if (response.success) {
                                deferred.resolve(response.id);
                            }
                        })
                        .catch(function () { deferred.reject(-1); $log.error('Errore nella creazione del lotto'); });
                }
            })
            .catch(function () { deferred.reject(-1); $log.error('Errore nel recupero del lotto'); });
        return deferred.promise;
    }

    function initLookups() {
        eggsFormFactory.addLookup($ctrl.record.lookup, 'item_id', 'product', 'code', 'description');
        eggsFormFactory.addLookup($ctrl.record.lookup, 'supplier_item_id', 'product_supplier', 'code', 'description');
    }

    // Ho un articolo fornitore: cerco l'articolo corrispondente (tabelle product_supplier -> product)
    $scope.$watch('$ctrl.record.lookup.supplier_item_id.obj', function (newValue, oldValue) {
        if (newValue) {
            if (!$ctrl.sxRowId) {
                $ctrl.record.model.item_id = newValue.product_id;
                if (!$ctrl.record.model.item_id) {
                    toaster.pop('error', msg.error, goods_inward_msg.matching_product_not_found);
                }
                else {
                    recordFactory('product').byId({ id: $ctrl.record.model.item_id }).$promise.then(function (data) {
                        $ctrl.record.lookup.item_id.obj = data;
                        if (!$ctrl.record.lookup.item_id.obj.quantity_included) {
                            toaster.pop('error', msg.error, goods_inward_msg.quantity_included_non_set);
                        }
                        else {
                            $ctrl.skData.boxes = 1;
                            setStockAmount($ctrl.skData.boxes * $ctrl.record.lookup.item_id.obj.quantity_included);
                        }
                    });
                }
            }
            else {
                recordFactory('product').byId({ id: $ctrl.record.model.item_id }).$promise.then(function (data) {
                    $ctrl.skData.boxes = 1;
                    setStockAmount($ctrl.skData.boxes * data.quantity_included);
                });
            }
        }
        else {
            $ctrl.record.model.item_id = undefined;
            $ctrl.record.lookup.item_id.obj = {};
            $ctrl.skData.boxes = 0;
        }
    }
    )

    $scope.$watch('$ctrl.record.lookup.item_id.obj', function (newValue, oldValue) {
        if ($ctrl.record.lookup.item_id.obj && $ctrl.record.lookup.item_id.obj.id) {
            if (calcBoxes) {
                calcBoxes = false;
                if ($ctrl.record.lookup.item_id.obj.quantity_included) {
                    $ctrl.skData.boxes = $ctrl.skData.amount / $ctrl.record.lookup.item_id.obj.quantity_included;
                }
                if ( tntProductGroups.indexOf($ctrl.record.lookup.item_id.obj.product_group_id)==-1 ) {
                    toaster.pop('warning', msg.warning, goods_inward_msg.incoherent_product_group);
                }
            }
            getCustomerOrderRows();
        }
        else {
            $ctrl.selection.customerOrderRows.length = 0;
        }
    })

    // Compone il filtro base per recuperare customer_order_row
    // A questo andrà aggiunto il filtro sul tipo di articolo.
    function getCorFilter() {
        var deferred = $q.defer();
        // Recupero da matrix par il tipo ordine corretto per ordini a stabilimento
        matrixParFactory.getMatrixPar({ key: 'tntReorderPlantOrderType', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*' }).$promise.then(function (response) {
            var orderTypeCode = response.value;
            if (orderTypeCode) {
                $ctrl.baseCorFilter = [{
                    "column": "customer_order co",
                    "value": "t.customer_order_id = co.id",
                    "relation": "JOIN",
                    "kind": "co.co_number as co_number, co.customer_destination as customer_destination_id"
                },
                {
                    "column": "ordertype ot",
                    "value": "co.type_id = ot.id",
                    "relation": "JOIN",
                    "kind": "ot.code as order_type_code"
                }];
                $ctrl.baseCorFilter = $ctrl.baseCorFilter.concat(dbFilterFactory.getNumberFilter('co.customer_destination', $ctrl.sxCustomerDestinationId));
                $ctrl.baseCorFilter = $ctrl.baseCorFilter.concat(dbFilterFactory.getStringFilter('t.status', 'TO_DISPATCH'));
                $ctrl.baseCorFilter = $ctrl.baseCorFilter.concat(dbFilterFactory.getStringFilter('ot.code', orderTypeCode));
                deferred.resolve();
            }
            else {
                toaster.pop('error', msg.error, goods_inward_msg.order_type_code_unset);
                deferred.reject();
            }
        }).catch(function () { deferred.reject(); });
        return deferred.promise;
    }

    function getCustomerOrderRows() {
        if (angular.isDefined($ctrl.baseCorFilter)) {
            doGetCustomerOrderRows();
        }
        else {
            getCorFilter().then(function () {
                doGetCustomerOrderRows();
            }).catch(angular.identity);
        }
    }

    function doGetCustomerOrderRows() {
        if ($ctrl.record.lookup.item_id.obj && $ctrl.record.lookup.item_id.obj.id) {
            var filters = $ctrl.baseCorFilter.concat(dbFilterFactory.getNumberFilter('t.item_id', $ctrl.record.lookup.item_id.obj.id));
            recordFactory('customer_order_row').filter({}, filters).$promise
                .then(function (data) {
                    $ctrl.selection.customerOrderRows.length = 0;
                    $ctrl.selection.customerOrderRows = $ctrl.selection.customerOrderRows.concat(data.list.map(boxConversion));
                    // aggiornamento info di tutte le righe d'ordine da evadere
                    $ctrl.orderDispatchChange();
                })
                .catch(angular.identity);
        }
    }

    function boxConversion(cor){
        if(angular.isUndefined(cor.generated_amount)){
            cor.generated_amount = 0;
        }
        cor.stock_boxes = cor.stock_amount/$ctrl.record.lookup.item_id.obj.quantity_included;
        cor.generated_boxes = cor.generated_amount/$ctrl.record.lookup.item_id.obj.quantity_included;
        return cor;
    }

    function getAmountToGenerate(total, cor) {
        var stockAmount = cor.stock_amount;
        var generatedAmount = cor.generated_amount ? cor.generated_amount : 0;
        return total + (stockAmount - generatedAmount);
    }

    // Fatto in modo un po' strano perché era già tutto predisposto per evadere, eventualmente, una lista di più ordini in un colpo solo.
    // Io credo ce lo chiederanno. In caso contrario, refactoring!
    //$ctrl.orderDispatchChange = function (row) {
    //    var corToDispatch = [row];
    $ctrl.orderDispatchChange = function () {
        var corToDispatch = $ctrl.selection.customerOrderRows;
        $ctrl.selection.amountToGenerate = corToDispatch.reduce(getAmountToGenerate, 0);
        $ctrl.selection.customerOrderRowsToDispatch.length = 0;
        $ctrl.selection.customerOrderRowsToDispatch = $ctrl.selection.customerOrderRowsToDispatch.concat(corToDispatch);
        $ctrl.selection.boxesToGenerate = ($ctrl.record.lookup.item_id.obj && $ctrl.record.lookup.item_id.obj.quantity_included) ? ($ctrl.selection.amountToGenerate / $ctrl.record.lookup.item_id.obj.quantity_included) : 0;
        $ctrl.selection.boxesToGenerateMsg = '(' + $ctrl.selection.boxesToGenerate + ' colli )';
        if($ctrl.selection.boxesToGenerate>0){
            $ctrl.skData.boxes = Math.min($ctrl.skData.boxes, $ctrl.selection.boxesToGenerate);
        }
        else{
            $ctrl.skData.boxes = 1;
        }
    }

    $scope.$watch('$ctrl.skData.boxes', function (newValue, oldValue) {
        var boxes = angular.isDefined(newValue) ? newValue : 1;
        if (boxes < 0) {
            boxes = 0;
            $ctrl.skData.boxes = boxes;
        }
        // rilassato il vincolo sul numero di colli da aggiungere
        /* else if(boxes > $ctrl.selection.boxesToGenerate ){
            if($ctrl.selection.boxesToGenerate==0) {
                boxes = 1;
            }
            else {
                boxes = $ctrl.selection.boxesToGenerate;
            }
            $ctrl.skData.boxes = boxes;
        } */
        if ($ctrl.record.lookup.item_id && $ctrl.record.lookup.item_id.obj && $ctrl.record.lookup.item_id.obj.quantity_included) {
            setStockAmount(boxes * $ctrl.record.lookup.item_id.obj.quantity_included);
        }
        else {
            setStockAmount(0);
        }
    })

    // Recupera da DB la riga di ricevimento merce corrente.
    function getRowDetail(id) {
        var filters = [{
            column: 'lot',
            value: 't.lot_id = lot.id',
            relation: 'JOIN',
            kind: 'lot.code as lot_code'
        }];
        filters = filters.concat(dbFilterFactory.getNumberFilter('t.id', id));
        recordFactory('goods_inward_row').filter({}, filters).$promise
            .then(function (data) {
                var response = data.list[0];
                $ctrl.selection.isExistingRow = true;
                $ctrl.record.model = response;
                eggsFormFactory.convertDates($ctrl.record.model, $ctrl.record.dates);
                $log.info($ctrl.record.model);
                eggsFormFactory.loadLookupData($ctrl.record.lookup, $ctrl.record.model);
                calcBoxes = true;
                $ctrl.getData();
                getSupplierProduct($ctrl.record.model.item_id);
            })
            .catch(angular.identity);
    }

    // Assumiamo che per il tnt ci sia una relazione 1:1 tra articolo fornitore e articolo six.
    function getSupplierProduct(productId) {
        var filter = dbFilterFactory.getNumberFilter('product_id', productId);
        recordFactory('product_supplier').filter({}, filter).$promise
            .then(function (data) {
                if (data.totalResults > 0) {
                    $ctrl.record.model.supplier_item_id = data.list[0].id;
                    $ctrl.record.lookup.supplier_item_id.obj = data.list[0];
                }
            })
            .catch(angular.identity);
    }
  
    // Aggiunge un collo ad una riga di ricevimento già esistente.
    $ctrl.addBox = function () {
        $ctrl.isSaving = true;
        $ctrl.record.model.production_date = $ctrl.skData.production_date;
        $ctrl.record.model.goods_inward_id = $ctrl.sxGoodsInwardId;
        if ($ctrl.sxRowId) {
            $ctrl.record.model.id = $ctrl.sxRowId;
        }
        $ctrl.record.model.order_row_list = [];
        var allowedFields = ['id', 'delivery_date', 'generated_boxes', 'generated_amount', 'stock_boxes', 'stock_amount'];
        $ctrl.selection.customerOrderRows.forEach(function(row) {
            var selRow = Object.keys(row)
            .filter(function(key) {
                        return allowedFields.includes(key);
                    })
            .reduce(function(obj, key) {
                        obj[key] = row[key];
                        return obj;
                    }, {});
            $ctrl.record.model.order_row_list.push(selRow);
        });
        $ctrl.record.model.serial_kit_quantity = ($ctrl.selection.mode==='MULTIPLE')?$ctrl.skData.boxes:1;
        tntGoodsInwardFactory.addBox({}, $ctrl.record.model).$promise
            .then(function (response) {
                if (response.success) {
                    $ctrl.boxesOverflow = false;
                    $ctrl.dispatchedOrders = $ctrl.dispatchedOrders.concat(response.dispatched_rows);
                    $ctrl.skData.boxes_prev = $ctrl.skData.boxes_prev + $ctrl.skData.boxes;
                    $ctrl.record.model.stock_amount = response.model.stock_amount;
                    $ctrl.skData.boxes = 1;
                    toaster.pop('success', msg.operation_completed, msg.operation_completed_success);
                    $ctrl.getData();
                    getCustomerOrderRows();
                }
                else {
                    toaster.pop('error', msg.error, goods_inward_msg[response.error_code]);
                }
                $ctrl.isSaving = false;
            })
            .catch(function () {
                $ctrl.isSaving = false;
            });
    }

    function createNewGoodsInwardRow() {
        $ctrl.record.model.production_date = $ctrl.skData.production_date;
        $ctrl.record.model.goods_inward_id = $ctrl.sxGoodsInwardId;
        $ctrl.record.model.type = 'AMOUNT'; // Per ora unico valore possibile. Vedi GoodsInwardTypeHandler.java
        if ($ctrl.sxRowId) {
            $ctrl.record.model.id = $ctrl.sxRowId;
        }
        if ($ctrl.selection.customerOrderRowsToDispatch[0]) {
            $ctrl.record.model.order_row_id = $ctrl.selection.customerOrderRowsToDispatch[0].id;
        }
        var p = tntGoodsInwardFactory.saveOrUpdateGoodsInwardRow({}, $ctrl.record.model).$promise;
        p.then(function (response) {
            if (response.success) {
                $ctrl.sxRowId = response.model.id;
                $ctrl.selection.isExistingRow = true;
                toaster.pop('success', msg.operation_completed, msg.operation_completed_success);
                $ctrl.getData();
                getCustomerOrderRows();
            }
            else {
                toaster.pop('error', msg.error, goods_inward_msg[response.error_code]);
            }
            $ctrl.isSaving = false;
            return response;
        })
        .catch(function (ex) {
            $ctrl.isSaving = false;
        });
        return p;
    }

    // Salva una nuova riga di ricevimento merce.
    $ctrl.saveRow = function () {
        $ctrl.isSaving = true;
        // Il kit non deve essere già scaduto
        if($ctrl.record.model.expiration_date>=(new Date())) {
            if (!$ctrl.sxRowId) {
                // Devo prima creare la riga di ricevimento
                getLotId().then(function (lotId) {
                    if (lotId > 0) {
                        $ctrl.record.model.lot_id = lotId;
                        createNewGoodsInwardRow().then(function(response) {
                            _addBox();
                        });
                    }
                    else {
                        toaster.pop('error', msg.error, goods_inward_msg.LOT_EXCEPTION);
                    }
                })
            } else {
                _addBox();
            }
        }
        else {
            toaster.pop('error', msg.error, goods_inward_msg.isExpired);
            $ctrl.isSaving = false;
        }
    }

    function _addBox() {
        // Quindi creo il kit
        if ($ctrl.selection.customerOrderRows && $ctrl.selection.customerOrderRows.length > 0) {
            // controllo il numero di colli da aggiungere non superi la somma delle quantità presenti nelle righe d'ordine
            if ((($ctrl.selection.mode==='MULTIPLE')?$ctrl.skData.boxes:1) <= $ctrl.sumProperty($ctrl.selection.customerOrderRows, 'stock_boxes')) {
                $ctrl.addBox();
            }
            else {
                $ctrl.boxesOverflow = true;
                toaster.pop('error', msg.error, goods_inward_msg.boxes_overflow);
            }
        }
        else {
            toaster.pop('error', msg.error, goods_inward_msg.out_of_orders.concat($ctrl.upload.detailData[idx].productCode));
        }
    }

    $ctrl.sumProperty = function(items, prop){
        return items.reduce( function(a, b){
            return a + b[prop];
        }, 0);
    };

    // Validazione dati obbligatori.
    $ctrl.canAddKit = function () {
        var result = angular.isDefined($ctrl.record.lookup.item_id) && angular.isDefined($ctrl.record.lookup.item_id.obj);
        result = result && $ctrl.record.model.item_id;
        result = result && $ctrl.record.lookup.item_id.obj.quantity_included;
        result = result && $ctrl.record.model.lot_code;
        result = result && $ctrl.record.model.expiration_date;
        result = result && $ctrl.skData.production_date;
        result = result && $ctrl.skData.boxes > 0;
        result = result && ($ctrl.selection.customerOrderRowsToDispatch.length > 0); // Ho selezionato almeno un ordine
        return result;
    }

    this.$onChanges = function (changesObj) {
        if (changesObj.sxSupplierId) {
            // articoli fornitore e lotto sono filtrati sulla base del fornitore selezionato in testata
            $ctrl.supplierProductFilter.length = 0;
            $ctrl.lotFilter.length = 0;
            if (angular.isDefined(changesObj.sxSupplierId.currentValue)) {
                $ctrl.supplierProductFilter = $ctrl.supplierProductFilter.concat(dbFilterFactory.getNumberFilter('supplier_id', changesObj.sxSupplierId.currentValue));
                $ctrl.lotFilter = $ctrl.lotFilter.concat(dbFilterFactory.getNumberFilter('supplier_id', changesObj.sxSupplierId.currentValue));
            }
        }
        if (changesObj.sxRowId) {
            $ctrl.selection.isExistingRow = angular.isDefined(changesObj.sxRowId.currentValue);
            if ($ctrl.selection.isExistingRow) {
                getRowDetail(changesObj.sxRowId.currentValue);
            }
            else {
                $ctrl.skData.boxes = 0;
            }
        }
    }

    function setStockAmount(value) {
        $ctrl.skData.amount = value;
        if(!$ctrl.selection.isExistingRow){
            $ctrl.record.model.stock_amount = value;
            $ctrl.record.model.billing_amount = value;
            $ctrl.record.model.alt_amount = value;
        }
        else {
            $ctrl.skData.boxes_prev = $ctrl.record.model.stock_amount/$ctrl.record.lookup.item_id.obj.quantity_included;
        }
    }

    function loadTntProductGroups() {
        matrixParFactory.getMatrixPar({key: 'tntProductGroup', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'}).$promise.then(function(response){                
            if(response.value){
                var codes = response.value.trim().split(",");
                if(codes.length>0){
                    recordFactory('product_group').filter({},dbFilterFactory.getCustomFilter( dbFilterFactory.getOrQuery('code', codes) ) ).$promise
                    .then(function(data){
                        if(data && data.totalResults>0){
                            data.list.forEach(function(pg) { tntProductGroups.push(pg.id); });
                        }
                    })
                    .catch(angular.identity);
                }
                else {
                    alert('tntProductGroup not defined');
                }
            } 
        }).catch(angular.identity);
    }

    $ctrl.$onInit = function () {
        $ctrl.skEnum = serialKitService.enum;
        $ctrl.enum = tntGoodsInwardService.enum;
        loadTntProductGroups();
        localeFactory.loadTranslation('serialkit');
        localeFactory.loadTranslation('goods_inward')
            .then(function () {
                $q.all({
                    general: localeFactory.translateMsg(msg),
                    specific: localeFactory.translateMsg(goods_inward_msg, 'goods_inward')
                })
                    .then(function (data) {
                        translateGridColumns();
                    })
                    .catch(angular.identity);
            })
            .catch(angular.identity);
        initLookups();
        initGridColumns();
    }

});

'use strict';

/**
 * @author Rita Beltrami
 * created on 03/03/2018
 * @description Componente per visualizzare le righe di un ricevimento merce tnt.
 */
angular.module('ictportal.tnt').component('tntGoodsInwardRows', {
    templateUrl: 'tnt/goods-inward/goods-inward-rows/goods-inward-rows.html',
    bindings: {        
        sxSelection: "=",
        sxGoodsInwardId: "<",
        sxShow: "<"
    },
    controller: 'tntGoodsInwardRowsCtrl'
});


'use strict';

angular.module('ictportal.tnt').controller('tntGoodsInwardRowsCtrl', function ($log, recordFactory, $filter, parseSchemaService, sixGridPaginationConstants,
                                                                                eggsFormFactory, toaster, dbFilterFactory, localeFactory, $rootScope,
                                                                                authFactory, $q, tntGoodsInwardService, uiGridConstants) {
    var $ctrl = this;
    $ctrl.sxShow = angular.isDefined($ctrl.sxShow)?$ctrl.sxShow:true;
    $ctrl.result = {};
    var msg = {
        quantity: "Quantity",
        product: "Product"
    };
    var goods_inward_msg = {
        expiration_date: "Expiration date",
        lot: "Lot",
        boxes: "Boxes",
        serial_kits: "Kits",
        GOODS_INWARD_ROW_NOT_FOUND: "Riga di ricevimento non trovata"
    };
    $ctrl.viewGridOptions = {
        appScopeProvider: $ctrl
    };
    $ctrl.record = {
        lookup: {}, // Per questa pagina non serve, la lascio un attimo mentre penso a come standardizzare il più possibile le pagine
        dates: ['expiration_date']
    };
    $ctrl.params = {
        pageNumber: 1,
        pageSize: 15,
        filters: []
    };
    $ctrl.lookup = {
        item_id: {
            obj: undefined,
            mapping: {
                code: 'code',
                description: 'description'
            }
        },
        lot_id: {
            obj: undefined,
            mapping: {
                code: 'code',
                description: 'code,description'
            }
        }
    };
    $ctrl.lookupCols = [];

    function translateGridColumns(){
        $ctrl.viewGridOptions.columnDefs.forEach(function(col){
            if(col.translation) {
                if(goods_inward_msg[col.translation]){
                    col.name = goods_inward_msg[col.translation];
                }
                else{
                    col.name = msg[col.translation];
                }
            }
        });
    };

    function loadLookupCols() {
        // Raggruppo assieme i record che fanno riferimento ad una stessa entità (es. tutti quelli con customer_id=123)
        // In questo modo risolvo l'entità una volta sola per tutti.
        var lookupMap = {};
        $ctrl.lookupCols.forEach(function (lookup) {
            var field = lookup.field;
            lookupMap[field] = {};
            $ctrl.list.list.forEach(function (record) {
                var id = record[field];
                if (id) {
                    if(!lookupMap[field][id]){
                        lookupMap[field][id] = [];
                    }
                    lookupMap[field][id].push(record);
                }
            });
        });
        // Recupero da DB i dati e li assegno ai rispettivi record.
        $ctrl.lookupCols.forEach(function (lookup) {
            for(var id in lookupMap[lookup.field]){
                recordFactory(lookup.entity).byId({ id: id })
                    .$promise.then(function (data) {
                        data['model'] = { description: '' };
                        var tokens = lookup.mapping.description.split(',');
                        tokens.forEach(function (term) {
                            if (data[term]) {
                                data['model'].description += data[term] + ' ';
                            }
                        });
                        data['model'].description = data['model'].description.trim();
                        lookupMap[lookup.field][data.id].forEach(function(record){
                            record[lookup.field + '_obj'] = data;
                        });
                    });
            }
        });
    };

    $ctrl.getData = function () {
        if($ctrl.sxGoodsInwardId){
            var payload = {
                page: $ctrl.params.pageNumber,
                page_size: $ctrl.params.pageSize,
                code: $ctrl.params.code,
                description: $ctrl.params.description,
                show_revision: false,
                sort_fields: ($ctrl.params.sortFields ? $ctrl.params.sortFields : 'row_index'),
                sort_order: $ctrl.params.sortOrder
            };
            var filters = [
                {
                    column: 'product',
                    value: 't.item_id = product.id',
                    relation: 'JOIN',
                    kind: 'product.code as product_code, product.description AS product_description, product.quantity_included AS quantity_included'
                },
                {
                    column: 'lot',
                    value: 't.lot_id = lot.id',
                    relation: 'JOIN',
                    kind: 'lot.code as lot_code'
                }
            ];
            filters = filters.concat($ctrl.params.filters);
            filters = filters.concat(dbFilterFactory.getNumberFilter('goods_inward_id',$ctrl.sxGoodsInwardId));
            recordFactory('goods_inward_row').filter(payload, filters).$promise
            .then(function (data) {
                $ctrl.viewGridOptions.totalItems = data.totalResults;
                $ctrl.result.totalResults = data.totalResults;
                $ctrl.result.list = data.list;
                $rootScope.$broadcast('goodsInwardRows:loadedRows', data.totalResults);
            });
        }
    };

    $ctrl.viewDetail = function(row){
        if($ctrl.sxSelection){
            $ctrl.sxSelection = row;
        }
    }

    var initGridColumns = function () {
        $ctrl.lookupCols = [];
        $ctrl.viewGridOptions.columnDefs = [];
        var dateFormat = localeFactory.getDateFormat();
        $ctrl.viewGridOptions.columnDefs.push({
            displayName: '',
            field: 'id',
            width: 34,
            enableCellEdit: false,
            enableFiltering: false,
            enableSorting: false,
            cellTemplate:
            '<div class="ui-grid-cell-contents" style="text-align: center">' +
                '<button ng-click="grid.appScope.viewDetail(row.entity)" class="btn btn-xs btn-primary">' +
                '<span class="fa fa-search"></span>' +
                '</button>' +
            '</div>'
        });
        $ctrl.viewGridOptions.columnDefs.push({
            name: 'Product',
            field: 'product_code',
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.product_code }} - {{ row.entity.product_description }}</div>',
            enableFiltering:true,
            translation: 'product',
            filters:[{
                type: sixGridPaginationConstants.filterType.TEXT,
                condition: uiGridConstants.filter.CONTAINS,
                placeholder: '',
                kind: 'string',
                aliasResolver: 'product.code,product.description'
            }]
        });
        $ctrl.viewGridOptions.columnDefs.push({
            name: 'Lot',
            field: 'lot_code',
            enableFiltering:true,
            translation: 'lot',
            filters:[{
                type: sixGridPaginationConstants.filterType.TEXT,
                condition: uiGridConstants.filter.CONTAINS,
                placeholder: '',
                kind: 'string',
                aliasResolver: 'lot.code'
            }]
        });
        $ctrl.viewGridOptions.columnDefs.push({
            name: "Expiration date",
            field: "expiration_date",
            translation: 'expiration_date',
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.expiration_date | date:\'' + dateFormat + '\' }}</div>',
            enableFiltering: false
        });
        $ctrl.viewGridOptions.columnDefs.push({
            name: "Boxes",
            field: "stock_amount",
            width: 120,
            translation: 'serial_kits',
            cellTemplate: '<div class="ui-grid-cell-contents" ng-if="row.entity.quantity_included">{{ (row.entity.stock_amount / row.entity.quantity_included) | number }}</div>',
            enableFiltering: false
        });
        $ctrl.viewGridOptions.columnDefs.push({
          name: "Quantity",
          field: "stock_amount",
          width: 120,
          translation: 'quantity',
          enableFiltering: false
        });
    };

    $rootScope.$on('updateGiRowsList',function(){
        $ctrl.getData();
    });

    this.$onChanges = function (changesObj) {
        if (changesObj.sxGoodsInwardId) {
            $ctrl.getData();
        }
    }

    $ctrl.$onInit = function() {
        localeFactory.loadTranslation('goods_inward')
        .then(function(){
            $q.all({
                general: localeFactory.translateMsg(msg),
                specific: localeFactory.translateMsg(goods_inward_msg, 'goods_inward')
            })
            .then(function(data){
                translateGridColumns();
            })
            .catch(angular.identity);
        })
        .catch(angular.identity);
        initGridColumns();
    };

});

'use strict';

/**
 * @author Rita Beltrami
 * created on 01/03/2018
 * @description Componente che consente di aprire un file excel contente righe di ricevimento merce tnt, validarlo e caricarlo. 
 * Messo in un componente, così se mi chiedono di spostarlo in un'altra pagina è più comodo.
 */
angular.module('ictportal.tnt').component('tntGoodsInwardUpload', {
    templateUrl: 'tnt/goods-inward/goods-inward-upload/goods-inward-upload.html',
    bindings: {        
        sxDepotCode: '@',
        sxWardrobeCode: '<'
    },
    controller: 'tntGoodsInwardUploadCtrl'
});


'use strict';

angular.module('ictportal.tnt').controller('tntGoodsInwardUploadCtrl',
                                            function ($log, recordFactory, $routeParams, $location, $filter,
                                            $scope, toaster, dbFilterFactory, localeFactory, eggsFormFactory,
                                            authFactory, $q,  tntGoodsInwardService, $rootScope, $timeout,
                                            matrixParFactory, tntGoodsInwardFactory, customerOrderFactory) {
    var $ctrl = this;

    var YEAR_PREFIX = (new Date()).getFullYear().toString().substring(0,2);
    $ctrl.record = { model: {} };
    $ctrl.print = { ids: [] };
    $ctrl.enum = {
        fileMode: [
            {
                name: 'Specificando i barcode',
                value: 'FROM_BARCODE'
            },
            {
                name: 'Specificando le confezioni',
                value: 'FROM_BOX'
            }
        ]
    };

    var msg = {
        "error": "Error",
        "warning": "Warning",
        "server_comunication_error": "Server communication error",
        "operation_completed": "Operation completed",
        "operation_completed_success": "Operation successfully completed",
        "lot": "lot"
    };

    var goods_inward_msg = {
        "SAVE_EXCEPTION": "Error while saving",
        "MISSING_AMOUNT": "Missing quantity",
        "MISSING_STOCK_AMOUNT": "Stock amount missing",
        "MISSING_ITEM": "Product missing",
        "MISSING_LOT": "Lot missing",
        "MISSING_GOODS_INWARD": "Missing goods inward reference",
        "MISSING_EXPIRATION_DATE": "Missing expiration date",
        "MISSING_TYPE": "Missing type",
        "MATRIX_PAR_EXCEPTION": "Parameter not found in matrix par",
        "SK_EXCEPTION": "Error while creating box",
        "LOT_EXCEPTION": "Error during lot update",
        "MISSING_SUPPLIER": "Supplier missing",
        "MISSING_STATUS": "Status missing",
        "MISSING_DATE": "Date missing",
        "MISSING_WAREHOUSE": "Warehouse missing",
        "MISSING_DEPOT": "Missing depot",
        "MISSING_REASON": "Reason missing",
        "INVALID_REASON": "Invalid inventory reason",
        "QUANTITY_INCLUDED": "Invalid quantity included on product",
        "MISSING_CONTAINER": "Container non set for selected facility.",
        "file_format_error": "Il file contiene dati in un formato non valido",
        "file_columns_error": "Il file selezionato presenta un numero di colonne diverso da quello previsto",
        "check_header_data": "Verificare i dati di testata",
        "file_incoherent": "File incoerente",
        "file_empty": "File vuoto",
        "file_empty_msg": "Spiacente, il file selezionato è vuoto.",
        "product_not_found": 'Articolo codice "productCode" non trovato',
        "too_much_product_found": 'Più articoli associati al codice "productCode"',
        "file_server_comunication_error": 'Errore di comunicazione con il server',
        "FROM_BARCODE": "Specificando i barcode",
        "FROM_BOX": "Specificando le confezioni",
        "DUPLICATED_LOTS": "Duplicated lot codes",
        "print_error": "Stampa non riuscita",
        "original_barcode": "Original barcode",
        "generated_barcode": "Original generated_barcode",
        "isExpired": "Expired kits: you cannot accept them.",
        "out_of_orders": "There are no dispatchable orders containing the article ",
        "boxes_overflow":"Specified boxes amount exceeds ordered quantity, please modify an order",
        "invalid_date_format": "Invalid date format"
    };

    $ctrl.viewGridOptionsBase = {
        enablePagination: false,
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        exporterMenuPdf: false,
        paginationPageSizes: [10, 20, 30],
        paginationPageSize: 10,
        useExternalPagination: false,
        appScopeProvider: $ctrl,
        enableGridMenu: true,
        exporterCsvColumnSeparator: ';'};

    $ctrl.viewGridKits = {
        onRegisterApi: function(gridApi){
            $ctrl.gridApi1 = gridApi;
        },
        gridMenuCustomItems: [
            {
              title: 'Export pag. xls',
              action: function ($event) {
                  sixExportLib.exportXLSXVisibleRowsGrid($ctrl.gridApi1, 'download', $filter);
              },
              order: 220
            }
          ],
        data: [],
        columnDefs: [
            {
                displayName: '',
                field: 'id',
                width: 34,
                enableCellEdit: false,
                enableFiltering: false,
                enableSorting: false,
                cellTemplate:
                '<div class="ui-grid-cell-contents" style="text-align: center">' +
                    '<button ng-click="grid.appScope.printKitLabel(row.entity.id)" class="btn btn-xs btn-primary" title="Stampa">' +
                    '<span class="fa fa-print"></span>' +
                    '</button>' +
                '</div>'
            },
            { displayName: 'Barcode originale', field: 'in_barcode', translation: 'original_barcode' },
            { displayName: 'Barcode generato', field: 'out_barcode', translation: 'generated_barcode' },
            { displayName: 'Lotto', field: 'lot', translation: 'lot'}
        ]
    };
    angular.extend($ctrl.viewGridKits, $ctrl.viewGridOptionsBase);

    $ctrl.viewGridAvailOrders = {
        onRegisterApi: function(gridApi){
            $ctrl.gridApi2 = gridApi;
        },
        gridMenuCustomItems: [
            {
              title: 'Export pag. xls',
              action: function ($event) {
                  sixExportLib.exportXLSXVisibleRowsGrid($ctrl.gridApi2, 'download', $filter);
              },
              order: 220
            }
          ],
        data: [],
        columnDefs: [
            {
                displayName: '',
                field: 'id',
                width: 34,
                enableCellEdit: false,
                enableFiltering: false,
                enableSorting: false,
                cellTemplate:
                '<div class="ui-grid-cell-contents" style="text-align: center">' +
                    '<button ng-click="grid.appScope.printAvailOrdersLabel(row.entity.id)" class="btn btn-xs btn-primary" title="Stampa">' +
                    '<span class="fa fa-print"></span>' +
                    '</button>' +
                '</div>'
            },
            { displayName: 'Articolo', field: 'item', translation: 'item' },
            { displayName: 'Colli da aggiungere', field: 'boxes_to_add', translation: 'boxes_to_add' },
            { displayName: 'Colli da evadere', field: 'boxes_to_dispatch', translation: 'boxes_to_dispatch'},
            { displayName: 'Delta colli', field: 'boxes_delta', translation: 'boxes_delta'},
            { displayName: 'Ordini da evadere', field: 'orders_to_dispatch', translation: 'orders_to_dispatch'}
        ]
    };
    angular.extend($ctrl.viewGridAvailOrders, $ctrl.viewGridOptionsBase);

    $ctrl.upload = {
        rows: [],
        headers: {},
        errorMsg: undefined,
        fileName: undefined,
        fileMode: 'FROM_BARCODE',
        loading: false,
        validated: false,
        validationMessage: undefined,
        errors: [],
        warnings: [],
        lineTotal: 0,
        lineCount: 0,
        headerData: {
            supplierCode: undefined,
            supplierBusinessName: undefined,
            supplierDDTNumber: undefined,
            supplierDDTDate: undefined,
            reference: undefined
        },
        detailData: [],
        model: {
            supplier: undefined,
            products: {}
        }
    };
    $ctrl.chooseDest = false;
    $ctrl.dispatchOrders = false;
    $ctrl.modal = {
        title: 'Evasione ordine cliente',
        message: 'Vuoi inviare il materiale direttamente al cliente?'
    };
    $ctrl.destinationLookups = {};
    $ctrl.shipmentDestinations = {};

    $ctrl.itemsOrderRows = {};
    $ctrl.boxesOverflow = false;
    $ctrl.dispatchedOrders = [];

    function resetUpload() {
        $ctrl.upload.length = 0;
        $ctrl.upload.headers = {};
        $ctrl.upload.errorMsg = undefined;
        $ctrl.upload.fileName = undefined;
        $ctrl.upload.loading = false;
        $ctrl.upload.validated = false;
        $ctrl.upload.validationMessage = undefined;
        $ctrl.upload.errors = [];
        $ctrl.upload.warnings = [];
        $ctrl.upload.rowsData = [];
        $ctrl.upload.lineTotal = 0;
        $ctrl.upload.lineCount = 0;
        $ctrl.upload.process = {
            todo: 0,
            done: 0
        };
        $ctrl.upload.headerData = {
            supplierCode: undefined,
            supplierBusinessName: undefined,
            supplierDDTNumber: undefined,
            supplierDDTDate: undefined,
            reference: undefined
        };
        $ctrl.upload.detailData = [];
        $ctrl.upload.model = {
            supplier: undefined,
            products: {}
        };
        $ctrl.viewGridKits.data.length = 0;
        $ctrl.viewGridAvailOrders.data.length = 0;
        $ctrl.itemsOrderRows = {};
        $ctrl.boxesOverflow = false;
        $ctrl.dispatchOrders = false;
        $ctrl.dispatchedOrders.length = 0;
        $ctrl.destinationLookups = {};
        $ctrl.shipmentDestinations = {};
        $ctrl.supplierOrders = {};
        $ctrl.supplierDates = {};
    }

    var COL_BARCODE = {
        SUPPLIER_DDT_NUMBER: 0,
        SUPPLIER_DDT_DATE: 1,
        REFERENCE: 2,
        SUPPLIER_CODE: 3,
        REAL_PROD_CODE: 4, // Codice Mediberg = Codice articolo
        QUANTITY: 5,
        BOXES: 6,
        PRODUCT_CODE: 7, // EAN 13 = Codice articolo fornitore
        EXPIRATION_DATE: 8,
        LOT: 9,
        PRODUCTION_DATE: 10,
        QUANTITY_INCLUDED: 11,
        PROGRESSIVE: 12,
        BARCODE: 13,
        BARCODE_SK: 14,

        COUNT: [14, 15] // Numero di colonne previste
    };

    var COL_BOXES = {
        SUPPLIER_CODE: 0,
        SUPPLIER_DDT_NUMBER: 1,
        SUPPLIER_DDT_DATE: 2,
        REFERENCE: 3,
        PRODUCT_CODE: 4,
        LOT: 5,
        PRODUCTION_DATE: 6,
        EXPIRATION_DATE: 7,
        BOXES: 8,

        COUNT: [9] // Numero di colonne previste
    };

    function getRowsData() {
        var rowsData = [];
        $ctrl.upload.rows.forEach(function(row) {
            var rowData = getHeaderData(row);
            rowData = angular.extend(rowData, getDetailData(row));
            rowsData.push(rowData);
        });
        return rowsData;
    }

    function getDetailData(row) {
        var COL = useBarcode()?COL_BARCODE:COL_BOXES;
        try {
            var detailData = {
                productCode: xlsValue(row, COL.PRODUCT_CODE),
                lot: xlsValue(row, COL.LOT),
                productionDate: xlsValue(row, COL.PRODUCTION_DATE),
                expirationDate: xlsValue(row, COL.EXPIRATION_DATE),
                boxes: parseNumber(row, COL.BOXES),
                barcode: xlsValue(row, COL.BARCODE),
            };
            if(useBarcode()) {
              detailData.quantityIncluded = parseNumber(row, COL.QUANTITY_INCLUDED);
            }
            var barcode_sk = xlsValue(row, COL.BARCODE_SK);
            for (var key in detailData) {
                detailData[key] = detailData[key].trim();
            }
            if (barcode_sk !== "" && barcode_sk !== undefined){
              detailData.barcode_sk = replaceAllStr(replaceAllStr(barcode_sk, '\n', ''), ' ', '').split(';')
                .map(function (e) { return e.trim()})
                .filter(function (e) {return e.length > 0});
            }
            return detailData;
        }
        catch (ex) {
            toaster.pop('error', msg.error, goods_inward_msg.file_format_error);
            $log.error('Riga malformata:');
            $log.error(row);
            $ctrl.upload.loading = false;
        }
    }

    function replaceAllStr(str, find, newOccurrence) {
      return str.split(find).join(newOccurrence);
    }


    function parseNumber(row, col) {
      var data = xlsValue(row, col);
      data = data.replace(/,/g, '');
      return data;
    }

    function getHeaderData(row) {
        var COL = useBarcode()?COL_BARCODE:COL_BOXES;
        var headerData = {
            supplierCode: xlsValue(row, COL.SUPPLIER_CODE),
            supplierDDTNumber: xlsValue(row, COL.SUPPLIER_DDT_NUMBER),
            supplierDDTDate: xlsValue(row, COL.SUPPLIER_DDT_DATE),
            reference: xlsValue(row, COL.REFERENCE)
        };
        for (var key in headerData) {
            headerData[key] = headerData[key].trim();
        }
        return headerData;
    }

    // Converto da stringa ai formati che mi servono
    function parseHeaderData(headerData) {
        try {
            // data DDT
            headerData.supplierDDTDate = stringToDate(headerData.supplierDDTDate);
        }
        catch (ex) {
            toaster.pop('error', msg.error, goods_inward_msg.file_format_error);
            $log.error('Riga incriminata:');
            $log.error(headerData);
            $ctrl.upload.loading = false;
        }
    }

    // DATE_FORMAT = YYMMDD or DD/MM/YYYY
    function stringToDate(_date) {
      var year, month, day;
      if(!_date){
        return new Date();
      }
      var splittedDate = _date.split("/");
      if(splittedDate.length === 1){ //YYMMDD
        year = parseInt(YEAR_PREFIX + _date.substring(0, 2));
        month = parseInt(_date.substring(2, 4));
        day = parseInt(_date.substring(4, 6));
      } else { // DD/MM/YYYY DD/MM/YY e combinazioni varie
        if(splittedDate[2].length === 4){
          year = parseInt(splittedDate[2]);
        } else {
          year = parseInt(YEAR_PREFIX + splittedDate[2]);
        }
        month = parseInt(splittedDate[1]);
        day = parseInt(splittedDate[0]);
      }
      month -= 1;
      return new Date(year, month, day, 0, 0, 0, 0);
    }

    function useBarcode() {
        return $ctrl.upload.fileMode==='FROM_BARCODE';
    }

    // Converto da stringa ai formati che mi servono
    function parseDetailData(detailData) {
        try {
            if(!useBarcode()) {
                // colli
                detailData.boxes = parseInt(detailData.boxes);
                if (detailData.boxes <= 0) {
                    localeFactory.translateReplace('goods_inward.file_invalid_boxes', {productCode: detailData.productCode}).then(function(transl){
                        logUploadWarning('fa fa-cubes',transl);
                    });
                }
            }
            else {
                detailData.quantityIncluded = parseInt(detailData.quantityIncluded);
                if (detailData.quantityIncluded <= 0) {
                    localeFactory.translateReplace('goods_inward.invalid_quantity_included', {barcode: detailData.barcode}).then(function(transl){
                        logUploadWarning('fa fa-cubes',transl);
                    });
                }

                if (detailData.barcode_sk != null && detailData.barcode_sk.length != detailData.quantityIncluded) {
                  localeFactory.translateReplace('goods_inward.invalid_quantity_sk', {barcode: detailData.barcode}).then(function(transl){
                    logUploadError('fa fa-cubes',transl);
                  });
                }
            }
            // data di produzione
            detailData.productionDate = stringToDate(detailData.productionDate);
            // data di scadenza
            detailData.expirationDate = stringToDate(detailData.expirationDate);

            if(isNaN(detailData.productionDate)) {
                logUploadError('fa fa-calendar', goods_inward_msg.invalid_date_format);
                $log.error('Formato data non valido "' + detailData.productionDate + '"');
            }
            if(isNaN(detailData.expirationDate)) {
                logUploadError('fa fa-calendar', goods_inward_msg.invalid_date_format);
                $log.error('Formato data non valido "' + detailData.expirationDate + '"');
            }
        }
        catch (ex) {
            toaster.pop('error', msg.error, goods_inward_msg.file_format_error);
            $log.error('Riga incriminata:');
            $log.error(detailData);
            $ctrl.upload.loading = false;
        }
    }

    function xlsValue(row, index) {
        var value = row[index];
        return value;
    }

    function isValidRowHeader(rowHeader) {
        for (var key in $ctrl.upload.headerData) {
            if ($ctrl.upload.headerData[key] != rowHeader[key]) {
                return false;
            }
        }
        return true;
    }

    $ctrl.printKitLabel = function (id) {
        $ctrl.print.ids.length = 0;
        if(id) {
            $ctrl.print.ids.push(id);
        }
        else {
            $ctrl.viewGridKits.data.forEach(function(item) {
                $ctrl.print.ids.push(item.id);
            });
        }
        $rootScope.$broadcast('sixPrintModalCtrl_open');
    }

    $ctrl.printAvailOrdersLabel = function (id) {
        $ctrl.print.ids.length = 0;
        if(id) {
            $ctrl.print.ids.push(id);
        }
        else {
            $ctrl.viewGridAvailOrders.data.forEach(function(item) {
                $ctrl.print.ids.push(item.id);
            });
        }
        $rootScope.$broadcast('sixPrintModalCtrl_open');
    }

    $ctrl.onConfirmPrintLabel = function (printerCode) {
        var payload = {
            printerCode: printerCode
        };
        $ctrl.print.ids.forEach(function(serialKitId) {
            payload.id = serialKitId;
            tntGoodsInwardFactory.printSerialKitLabel({}, payload).$promise
            .then(function (response) {
                if (!response.success) {
                    toaster.pop('error', msg.error, goods_inward_msg.print_error);
                }
                else {
                    toaster.pop('success', msg.operation_completed, goods_inward_msg.operation_completed_success);
                }
            })
            .catch(function(){
                toaster.pop('error', msg.error, goods_inward_msg.print_error);
            });
        });
    }

    function validateLotsOfFile() {
      var lotToDate = {};
      var errorsLot = {};
      $ctrl.upload.rowsData.forEach(function(row) {
        var date = lotToDate[row.lot];
        if (!date) {
          lotToDate[row.lot] = row.productionDate;
        } else if (date !== row.productionDate) {
          errorsLot[row.lot] = true;
        }
      });

      var errors = Object.keys(errorsLot);
      if (errors.length) {
        errors.forEach(function(lot) {
          localeFactory.translateReplace('goods_inward.file_lot_production_date',  { lot: lot })
            .then(function(transl) {
              logUploadError('fa fa-user', transl);
            });
        });
      }
      return errors.length === 0;
    }

    // Per estrapolare i dati, Tamarozzi ha detto di basarsi sull'ordine e non sul titolo delle colonne.
    function validateFile() {
        var COL = useBarcode()?COL_BARCODE:COL_BOXES;
        // 1) Devo avere il numero di colonne atteso (possono essere accettati diversi template)
        if ($ctrl.upload.headers.length in COL.COUNT) {
            toaster.pop('error', msg.error, goods_inward_msg.file_columns_error);
        }
        else {
            // 2) Deve esserci almeno qualche dato.
            if (angular.isDefined($ctrl.upload.rows) && $ctrl.upload.rows.length > 0 && $ctrl.upload.rows[0].length>0) {
                $ctrl.upload.rowsData = getRowsData();

                // Devo validare i lotti
                if (validateLotsOfFile()) {
                  // è possibile vengano specificati più rif.ordine nello stesso file
                  var rowsData = aggregateHeaderData();
                  $ctrl.upload.process.todo = rowsData.length;
                  $ctrl.upload.process.done = 0;
                  $ctrl.upload.rowsData.length = 0;
                  $ctrl.upload.lineTotal = 0;
                  $ctrl.upload.lineCount = 0;
                  rowsData.forEach(function(data) {
                      $ctrl.upload.lineTotal += data.length;
                      $ctrl.upload.headerData = {
                          supplierCode: data[0].supplierCode,
                          supplierDDTNumber: data[0].supplierDDTNumber,
                          supplierDDTDate: data[0].supplierDDTDate,
                          reference: data[0].reference,
                          row_count: data.length
                      };
                      if (isValidRowHeader($ctrl.upload.headerData)) {
                          $ctrl.upload.detailData = [];
                          data.forEach(function(detail) {
                              parseDetailData(detail);
                              $ctrl.upload.lineCount++;
                              $ctrl.upload.detailData.push(detail);
                          });
                          parseHeaderData($ctrl.upload.headerData);
                          if ($ctrl.upload.lineTotal === $ctrl.upload.lineCount) {
                              aggregateDetailData($ctrl.upload.detailData)
                              // 3) Verifico se i codici presenti nel file corrispondo ad entità presenti sul DB.
                              validateData($ctrl.upload.headerData, $ctrl.upload.detailData);
                              $ctrl.upload.rowsData.push({'header': angular.copy($ctrl.upload.headerData),
                                                          'rows': angular.copy($ctrl.upload.detailData)});
                          }
                          else {
                              $ctrl.upload.loading = false;
                          }
                      } else {
                          toaster.pop('error', goods_inward_msg.file_incoherent, goods_inward_msg.check_header_data);
                          $ctrl.upload.loading = false;
                      }
                  });
              }
            }
            else {
                toaster.pop('warn', goods_inward_msg.file_empty, goods_inward_msg.file_empty_msg);
                $ctrl.upload.loading = false;
            }
        }
    }

    $ctrl.confirmDispatch = function() {
        if (!$ctrl.modal) {
            alert('Modal not found');
        }
        else {
            $ctrl.modal.callback = showDispatchControls.bind(null);
            $rootScope.$broadcast('sixConfirmModal_open');
        }
    };

    function showDispatchControls() {
        $ctrl.dispatchOrders = true;
        addDestinationLookups();
    }

    function checkPermissions() {
        var profilingKey = 'TNT_GOODS_INWARD_FUNCTION';
        var permission = authFactory.getPermissions(profilingKey);
        if(!permission.EXEC) {
            $location.path('forbidden').search({key: profilingKey});
        }
        if(permission.DDT_DEST) {
            $ctrl.chooseDest = true;
        }
    };

    function aggregateHeaderData() {
        var aggregated = [];
        if(useBarcode()) {
            var aggregated = sixObjectLib.groupArray($ctrl.upload.rowsData, ['supplierCode', 'supplierDDTNumber', 'supplierDDTDate', 'reference']);
            $log.info(aggregated);
        }
        return aggregated;
    }

    function aggregateDetailData(detailData) {
        if(useBarcode()) {
            var aggregated = [];
            var grouped = sixObjectLib.groupArray(detailData, ['productCode', 'lot', 'productionDate', 'expirationDate']);
            grouped.forEach(function(group) {
                var goodsInwardRow = angular.copy(group[0]);
                delete goodsInwardRow['barcode'];
                goodsInwardRow.barcode = [];
                group.forEach(function(item) {
                    goodsInwardRow.barcode.push({
                      "barcode": item.barcode,
                      "barcode_sk": item.barcode_sk
                    });
                });
                aggregated.push(goodsInwardRow);
            })
            $log.info(aggregated);
            $ctrl.upload.detailData = aggregated;
        }
    }

    function gotSupplier(data) {
        var success = (data.totalResults > 0);
        if (success) {
            $ctrl.upload.model.supplier = data.list[0];
        }
        else {
            localeFactory.translateReplace('goods_inward.file_supplier_not_found', {supplierCode: $ctrl.upload.headerData.supplierCode}).then(function(transl){
                logUploadError('fa fa-user', transl);
            })
        }
        return success;
    }

    // Verifico che i codici corrispondano a codici di articoli fornitori esistenti.
    function gotProducts(productData, codesArray, detailData) {
        var success = false;
        if (productData.totalResults === codesArray.length) {
            success = true;
            productData.list.forEach(function (product) {
                $ctrl.upload.model.products[product.code] = product;
                // Controlla quantità
                if (!product.quantity_included) {
                    localeFactory.translateReplace('goods_inward.file_invalid_quantity_missing', {productCode: product.code}).then(function(transl){
                        logUploadError('fa fa-warning', transl);
                    })
                    success = false;
                }
                else {
                    // Controllo che le quantità include indicate nel file corrispondano con quelle in anagrafica.
                    var productRows = detailData.filter(function(item) { return (item.productCode==product.code)});
                    var errorRows = productRows.filter(function(item) {
                        return (item.quantityIncluded!=product.quantity_included)}
                    );
                    if(errorRows.length>0) {
                        localeFactory.translateReplace('goods_inward.file_invalid_quantity', {productCode: product.code, quantityIncluded: product.quantity_included}).then(function(transl){
                            logUploadError('fa fa-warning', transl);
                        })
                        success = false;
                    }
                }
            })
        }
        else {
            codesArray.forEach(function (code) {
              var n = $filter('filter')(productData.list, { code: code }).length;
                if ( n === 0) {
                    localeFactory.translateReplace('goods_inward.product_not_found', {productCode: code}).then(function(transl){
                        logUploadError('fa fa-times', transl);
                    })
                }
                if ( n > 1) {
                  localeFactory.translateReplace('goods_inward.too_much_product_found', {productCode: code}).then(function (transl) {
                    logUploadError('fa fa-times', transl);
                  })
                }
            });
        }
        return success;
    }

    // Controllo che non ci siano kit scaduti
    function validateExpirationDates(detailData) {
        var deferred = $q.defer();
        var today = new Date();
        var expired = detailData.filter(function(row) {
            var date = new Date(row.expirationDate);
            return (date<=today);
        });
        var validKits = true;
        if(expired.length>0) {
            validKits = false;
            logUploadError('fa fa-times', goods_inward_msg.isExpired);
        }
        deferred.resolve(validKits);
        return deferred.promise;
    }

    // Cerco i prodotti di quel fornitore con i codici indicati
    function validateProducts(detailData) {
        var deferred = $q.defer();

        // Compose filter
        var codesArray = [];
        var productsQuery = '';
        detailData.forEach(function (row) {
            if (codesArray.indexOf(row.productCode) === -1) {
                codesArray.push(row.productCode);
                productsQuery += ' t.code=\'' + row.productCode + '\' OR ';
            }
        });
        productsQuery = productsQuery.slice(0, -4);
        var productsFilter = [{
            column: 'product p',
            value: 't.product_id = p.id',
            relation: 'JOIN',
            kind: 'p.quantity_included,p.id as product_id, p.code as product_code, t.code as supplier_code'
        }]
        .concat(dbFilterFactory.getCustomFilter('(' + productsQuery + ')'))
        .concat(dbFilterFactory.getNumberFilter('t.supplier_id', $ctrl.upload.model.supplier.id));

        // Get result
        recordFactory('product_supplier').filter({page_size: 9999}, productsFilter).$promise.then(function(data) {
            deferred.resolve(gotProducts(data, codesArray, detailData));
        })
        .catch(function(){ deferred.reject(false) });

        return deferred.promise;
    }

    // Verifico di non aver già registrato questo DDT
    function gotDdtNumber(ddtNumberData, headerData) {
        var success = ddtNumberData.totalResults > 0;
        if (success) {
            localeFactory.translateReplace('goods_inward.file_duplicated_ddt', {supplierCode: headerData.supplierCode,
                ddtNumber: headerData.supplierDDTNumber}).then(function(transl){
                    logUploadError('fa fa-user', transl);
            })
        }
        return success;
    }

    // Cerco un altro DDT con questo numero per questo fornitore
    function validateDdtNumber(headerData) {
        var deferred = $q.defer();

        // Compose filter
        var goodsInwardFilter = dbFilterFactory.getNumberFilter('supplier_id', $ctrl.upload.model.supplier.id)
        .concat(dbFilterFactory.getNumberFilter('dn_number', headerData.supplierDDTNumber))
        .concat(dbFilterFactory.getNumberFilter('int_year', headerData.supplierDDTDate.getFullYear()));
        // Get result
        recordFactory('goods_inward').filter({}, goodsInwardFilter).$promise
        .then(function(data) {
            deferred.resolve(!gotDdtNumber(data, headerData));
        })
        .catch(function(){ deferred.reject(false) });

        return deferred.promise;
    }

    /** I dati sono validi se:
     * A - il fornitore indicato esiste
     * B - gli articoli indicati esistono
     * C - il DDT fornitore NON è già stato inserito
     * D - i kit non sono già scaduti
     */
    function validateData(headerData, detailData) {
        //console.log(headerData);
        //console.log(detailData.length);
        // A - Cerco il fornitore partendo dal codice
        recordFactory('supplier').filter({}, dbFilterFactory.getStringFilter('code', headerData.supplierCode)).$promise
        .then(function (supplierData) {
            if (gotSupplier(supplierData)) {
                // B - Cerco i prodotti di quel fornitore con i codici indicati
                // C - Cerco un altro DDT con questo numero per questo fornitore
                // D - i kit non sono già scaduti
                var promises = {
                    nothingExpired: validateExpirationDates(detailData),
                    areValidProducts: validateProducts(detailData),
                    isValidGoodsInward: validateDdtNumber(headerData)
                };

                // Valuto le risposte
                $q.all(promises).then(function (responses) {
                    $ctrl.upload.process.done++;
                    $ctrl.upload.validated = responses.areValidProducts && responses.isValidGoodsInward && responses.nothingExpired;
                    $ctrl.upload.loading = false;
                    if($ctrl.upload.validated){
                        localeFactory.translateReplace('goods_inward.file_uploaded_count', {rowCount: $ctrl.upload.lineCount}).then(function(transl){
                            $ctrl.upload.validationMessage = transl;
                        })
                        if ($ctrl.upload.process.done === $ctrl.upload.process.todo && $ctrl.chooseDest) {
                            $ctrl.confirmDispatch();
                        }
                    }
                })
                .catch(function (ex) {
                    logUploadError('fa fa-icon-cloud-upload', msg.file_server_comunication_error);
                });
            }
        })
        .catch(function (ex) {
            logUploadError('fa fa-icon-cloud-upload', msg.file_server_comunication_error);
        });
    }

    function logUploadError(icon, description, line) {
        toaster.pop('error', msg.error, description);
        $ctrl.upload.errors.push({ icon: icon, description: description });
        $ctrl.upload.loading = false;
    }

    function logUploadWarning(icon, description, line) {
        toaster.pop('warning', msg.warning, description);
        $ctrl.upload.warnings.push({ icon: icon, description: description });
    }

    $scope.$on( 'fileSelected', function(event,files) {
        resetUpload();
        var excelFile = files[0];
        $ctrl.upload.fileName = excelFile.name;
        var reader = new FileReader();
        $ctrl.upload.loading = true;
        reader.onload = function (evt) {
            var data = evt.target.result;
            var workbook = XLSX.read(data, {
                type: 'binary'
            });
            workbook.SheetNames.forEach(function (sheetName) {
                $ctrl.upload.rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });
                $ctrl.upload.headers = $ctrl.upload.rows.shift();
                if(!useBarcode()) { // il ricevimento con qta ha una riga in più di commento
                    $ctrl.upload.rows.shift();
                }
                $ctrl.upload.rows = $ctrl.upload.rows.filter(function (value, index, array) {
                    return (value.length > 0);
                });
                validateFile();
            });
        };
        reader.onerror = function (ex) {
            console.log(ex);
            $ctrl.upload.loading = false;
        };
        reader.readAsBinaryString(excelFile);
    });

    // Callback invocata alla selezione di un nuovo file.
    $ctrl.fileSelected = function (element) {
        resetUpload();
        $ctrl.$apply(function (scope) {
            var excelFile = element.files[0];
            $ctrl.upload.fileName = excelFile.name;
            var reader = new FileReader();
            $ctrl.upload.loading = true;
            reader.onload = function (evt) {
                var data = evt.target.result;
                var workbook = XLSX.read(data, {
                    type: 'binary'
                });
                workbook.SheetNames.forEach(function (sheetName) {
                    $ctrl.upload.headers = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], { header: 1 })[0];
                    $ctrl.upload.rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
                    validateFile();
                });
            };
            reader.onerror = function (ex) {
                $log.error(ex);
                $ctrl.upload.loading = false;
            };
            reader.readAsBinaryString(excelFile);
        });
    }

    // Compone il filtro base per recuperare customer_order_row
    // A questo andrà aggiunto il filtro sul tipo di articolo.
    function getCorFilter() {
        var deferred = $q.defer();
        // Recupero da matrix par il tipo ordine corretto per ordini a stabilimento
        matrixParFactory.getMatrixPar({ key: 'tntReorderPlantOrderType', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*' }).$promise.then(function (response) {
            var orderTypeCode = response.value;
            if (orderTypeCode) {
                $ctrl.baseCorFilter = [{
                    "column": "customer_order co",
                    "value": "t.customer_order_id = co.id",
                    "relation": "JOIN",
                    "kind": "co.co_number as co_number, co.customer_destination as customer_destination_id"
                },
                {
                    "column": "ordertype ot",
                    "value": "co.type_id = ot.id",
                    "relation": "JOIN",
                    "kind": "ot.code as order_type_code"
                }];
                $ctrl.baseCorFilter = $ctrl.baseCorFilter.concat(dbFilterFactory.getNumberFilter('co.customer_destination', $ctrl.sxCustomerDestinationId));
                $ctrl.baseCorFilter = $ctrl.baseCorFilter.concat(dbFilterFactory.getStringFilter('t.status', 'TO_DISPATCH'));
                $ctrl.baseCorFilter = $ctrl.baseCorFilter.concat(dbFilterFactory.getStringFilter('ot.code', orderTypeCode));
                deferred.resolve();
            }
            else {
                toaster.pop('error', msg.error, goods_inward_msg.order_type_code_unset);
                deferred.reject();
            }
        }).catch(function () { deferred.reject(); });
        return deferred.promise;
    }

    function getCustomerOrderRows(itemId) {
        if (angular.isDefined($ctrl.baseCorFilter)) {
            doGetCustomerOrderRows(itemId);
        }
        else {
            getCorFilter().then(function () {
                doGetCustomerOrderRows(itemId);
            }).catch(angular.identity);
        }
    }

    function doGetCustomerOrderRows(itemId) {
        if (itemId && $ctrl.itemsOrderRows[itemId] === undefined) {
            var filters = $ctrl.baseCorFilter.concat(dbFilterFactory.getNumberFilter('t.item_id', itemId));
            recordFactory('customer_order_row').filter({}, filters).$promise
            .then(function (data) {
                $ctrl.itemsOrderRows[itemId] = [];
                $ctrl.itemsOrderRows[itemId] = $ctrl.itemsOrderRows[itemId].concat(data.list);
            })
            .catch(angular.identity);
        }
    }

    $ctrl.confirmUpload = function(){
        var modelList = [];
        $ctrl.upload.rowsData.forEach(function(data) {
            var model = {
                status: 'TO_DISPATCH',
                int_date: new Date(),
                rec_date: new Date(),
                supplier_id: $ctrl.upload.model.supplier.id,
                dn_number: data.header.supplierDDTNumber,
                dn_date: data.header.supplierDDTDate,
                reference: data.header.reference,

                rows: []
            };
            data.rows.forEach(function(item){
                // calcolo quantità per le righe importate
                if(!useBarcode()) { // caso import COLLI
                    item.quantity = item.boxes * $ctrl.upload.model.products[item.productCode].quantity_included;
                }
                else { // caso import BARCODE
                    item.quantity = item.barcode.length * $ctrl.upload.model.products[item.productCode].quantity_included;
                }
                var row = {
                    expiration_date: item.expirationDate,
                    item_id: $ctrl.upload.model.products[item.productCode].product_id,
                    lot_code: item.lot,
                    alt_amount: item.quantity,
                    billing_amount: item.quantity,
                    stock_amount: item.quantity,
                    type: 'AMOUNT',
                    production_date: item.productionDate
                };
                if(useBarcode()) {
                //se non ho barcode sk sarà un kit per barcode, altrimenti un kit per barcode_sk
                    row.serial_kit_list = item.barcode.flatMap(function(b) {
                    if (b.barcode_sk != null && b.barcode_sk.length > 0) {
                        return b.barcode_sk.map(function (sk) {
                        return {
                            envelope: b.barcode,
                            barcode: sk,
                            quantity_included: 1
                        }
                        })
                    } else {
                        return {
                        envelope: b.barcode,
                        barcode : b.barcode,
                        };
                    }

                    });
                }
                // disaccoppio le righe in upload dalle corrispondenti righe d'ordine per evitare duplicati
                if($ctrl.sxWardrobeCode) {
                    getCustomerOrderRows(row.item_id);
                }
                model.rows.push(row);
            });
            $ctrl.record.model = angular.extend($ctrl.record.model, model);
            modelList.push(angular.copy($ctrl.record.model));
        });
        importFile(modelList);
    }

    $ctrl.setFileMode = function(mode) {
        $ctrl.upload.fileMode = mode;
    }

    $ctrl.setBoxFileMode = function() {
        $ctrl.upload.fileMode = 'BOX';
    }

    function compileRowsData(rows) {
        var rowsData = [];
        if (rows && rows.length > 0) {
            rowsData = rows.map(function (e) {
                return {
                    product_id: e.item_id,
                    stock_amount: e.stock_amount,
                    serial_kit_ids: e.serial_kit_list.map(function (kit) {
                        return kit.id;
                    })
                };
            });
        }
        return rowsData;
    }

    function importFile(modelList) {
        tntGoodsInwardFactory.saveOrUpdateGoodsInwardList({}, modelList).$promise.then(function(response){
        if(response[0].success){
        response.forEach(function(result) {
            var goodsInwardId = result.model.id;
            var orderReference = result.model.reference;
            var destination = $ctrl.shipmentDestinations[orderReference];
            toaster.pop('success', msg.operation_completed, msg.operation_completed_success);
            // Ricevimento in guardaroba
            if($scope.sxWardrobeCode) {
                $ctrl.record.model.rows.forEach(function (row, idx) {
                    if ($ctrl.itemsOrderRows[row.item_id] && $ctrl.itemsOrderRows[row.item_id].length > 0) {
                        $ctrl.completeDispatch(result, row, idx);
                    }
                    else {
                        toaster.pop('error', msg.error, goods_inward_msg.out_of_orders.concat($ctrl.upload.detailData[idx].productCode));
                    }
                });
            }
            // Ricevimento in deposito
            else {
                if (destination) {  // se viene selezionato un deposito di destinazione...
                    var goodsInwardDto = [{"id": goodsInwardId}];
                    // accettazione ricevimento merci
                    tntGoodsInwardFactory.acceptGoodsInward({},goodsInwardDto).$promise.then(function(response) {
                    if(response.success) {
                        matrixParFactory.getValueOrDefault({key: 'tntReorderPlantOrderType', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'},
                        {defaultValue: "07"}).$promise.then(function(data){
                        var orderTypeCode = data.result.value;
                        var orderRequest = {
                            customer_destination: destination,
                            type_code: orderTypeCode,
                            priority: 'NORMAL',
                            note: "",
                            vostro_ordine: $ctrl.supplierOrders[orderReference],
                            data_vostro_ordine: $ctrl.supplierDates[orderReference],
                            row_list: compileRowsData(result.model.rows)
                        };
                        // creazione ordine ed evasione con DDT
                        customerOrderFactory.createAndDispatch({}, orderRequest).$promise.then(function (data) {
                        console.log(data);
                        if (data.status == 'ok') {
                            data.result.forEach(function(e){
                                localeFactory.translateReplace('goods_inward.created_ddt', {barcode: e.shipment_barcode}).
                                then(function(transl){
                                    toaster.pop('success', transl);
                                });
                            });
                        } else {
                            eggsFormFactory.logServerException(data, 'goods_inward');
                        }
                    });
                    });
                    } else {
                        toaster.pop('error', msg.error, response.error_message);
                    }
                    });
                }
                if (result.changed_barcodes.length==0) {
                    $location.path('/tnt/goodsinward/detail/' + ($ctrl.sxWardrobeCode || $ctrl.sxDepotCode) + '/' + result.model.id);
                } else {
                    $ctrl.viewGridKits.data = $ctrl.viewGridKits.data.concat(result.changed_barcodes);
                    $timeout(function() {
                        if ($ctrl.gridApi) $ctrl.gridApi.core.refresh();
                    });
                }
            }
        });
        } else {
            toaster.pop('error', msg.error, goods_inward_msg[response[0].error_code]);
        }
        }).catch(function(ex){ toaster.pop('error', msg.error ,goods_inward_msg.SAVE_EXCEPTION); });
    }

    $ctrl.completeDispatch = function (response, row, idx) {
        $ctrl.record.model.production_date = row.production_date;
        $ctrl.record.model.goods_inward_id = response.model.id;
        var gir = response.model.rows.find(function(r) {return r.row_index === idx+1});
        if (gir) {
            $ctrl.record.model.id = gir.id;
        }
        var itemQtyInc = $ctrl.upload.model.products[$ctrl.upload.detailData[idx].productCode].quantity_included;
        $ctrl.record.model.order_row_list = [];
        var allowedFields = ['id', 'delivery_date', 'generated_boxes', 'generated_amount', 'stock_boxes', 'stock_amount'];
        $ctrl.itemsOrderRows[row.item_id].forEach(function(row) {
            row.generated_boxes = (row.generated_amount)?row.generated_amount/itemQtyInc:0;
            row.stock_boxes = (row.stock_amount)?row.stock_amount/itemQtyInc:0;
            var selRow = Object.keys(row)
            .filter(function(key) {
                return allowedFields.includes(key);
            })
            .reduce(function(obj, key) {
                obj[key] = row[key];
                return obj;
            }, {});
            $ctrl.record.model.order_row_list.push(selRow);
        });
        // controllo il numero di colli da aggiungere non superi la somma delle quantità presenti nelle righe d'ordine
        var boxesToAdd = useBarcode()?1:$ctrl.upload.detailData[idx].boxes;
        var boxesToDispatch = $ctrl.sumProperty($ctrl.itemsOrderRows[row.item_id], 'stock_boxes');
        if (boxesToAdd > boxesToDispatch) {
            $ctrl.boxesOverflow = true;
            var ordersToDispatch = $ctrl.itemsOrderRows[row.item_id].map(function(a) { return a.co_number });
            var avail = {'item': $ctrl.upload.detailData[idx].productCode,
                        'boxes_to_add': boxesToAdd,
                        'boxes_to_dispatch': boxesToDispatch,
                        'boxes_delta': (boxesToAdd - boxesToDispatch),
                        'orders_to_dispatch': ordersToDispatch};
            $ctrl.viewGridAvailOrders.data = $ctrl.viewGridAvailOrders.data.concat(avail);

            toaster.pop('error', msg.error, goods_inward_msg.boxes_overflow);
        }
        else {
            $ctrl.record.model.serial_kit_list = gir.serial_kit_list;
            tntGoodsInwardFactory.completeDispatch($ctrl.record.model).$promise
                .then(function (response) {
                    if (response.success) {
                        $ctrl.boxesOverflow = false;
                        $ctrl.dispatchedOrders = $ctrl.dispatchedOrders.concat(response.dispatched_rows);
                        toaster.pop('success', msg.operation_completed, msg.operation_completed_success);
                    }
                    else {
                        toaster.pop('error', msg.error, goods_inward_msg[response.error_code]);
                    }
                });
            }
    }

    $ctrl.sumProperty = function(items, prop){
        return items.reduce( function(a, b){
            return a + b[prop];
        }, 0);
    }

    function loadDepot() {
        if ($routeParams.depotCode) {
            tntGoodsInwardService.loadDepot($routeParams.depotCode).then(function(id){
                $ctrl.record.model.depot_id = id;
            });
        }
    }

    function addDestinationLookups() {
        $ctrl.destinationLookups = {};
        $ctrl.shipmentDestinations = {};
        $ctrl.upload.rowsData.forEach(function(data) {
            var tag = "destination_id_"+data.header.reference.replace(/\.|-/g, '_');
            eggsFormFactory.addLookup($ctrl.lookup, tag, 'customer_destination', 't.code', 't.description');
            $ctrl.destinationLookups[data.header.reference] = "$ctrl.lookup."+tag;
        });
    }

    function translateGridColumns(){
        $ctrl.viewGridKits.columnDefs.forEach(function (col) {
            if (col.translation) {
                if (goods_inward_msg[col.translation]) {
                    col.displayName = goods_inward_msg[col.translation];
                }
                else {
                    col.displayName = msg[col.translation];
                }
            }
        });
    }

    var logError = function logError(ex) {
        $log.log(ex);
        toaster.pop('error', msg.error, msg.server_comunication_error);
    }

    $ctrl.$onInit = function() {
        checkPermissions();
        var authData = authFactory.getAuthData();
        localeFactory.loadTranslation('goods_inward')
        .then(function(){
            if($ctrl.sxWardrobeCode) {
                recordFactory('customer_destination').filter({}, dbFilterFactory.getStringFilter("code",$ctrl.sxWardrobeCode).concat(dbFilterFactory.getNumberFilter('t.divcod', authData.info.divCod))).$promise
                    .then(function(data) {
                        $ctrl.sxCustomerDestinationId = data.list[0].id;
                    });
            }
            $q.all({
                general: localeFactory.translateMsg(msg),
                specific: localeFactory.translateMsg(goods_inward_msg, 'goods_inward')
            })
            .then(function(data){
                $ctrl.enum.fileMode.forEach(function(en){
                    en.name = data.specific[en.value];
                });
                loadDepot();
                translateGridColumns();
            })
            .catch(function(ex){ logError(ex); });
        })
        .catch(function(ex){ logError(ex); });
        resetUpload();
        $ctrl.lookup = {};
        $ctrl.destinationFilter = [];
        if (authData.filters.customer_destination && authData.filters.customer_destination.length > 0) {
            $ctrl.destinationFilter = authData.filters.customer_destination;
        }
        matrixParFactory.getValueOrDefault({key: 'receiverTypeService.wardrobe', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'},
        {defaultValue: "GUA"}).$promise.then(function(data){
            var filter = [{
                column: 'receiver_type rt',
                value: 't.receiver_type_id = rt.id',
                relation: 'JOIN',
                kind: 'rt.code as type_code'
            }];
            $ctrl.destinationFilter = $ctrl.destinationFilter.concat(filter.concat(dbFilterFactory.getStringFilter('rt.code',data.result.value)));
        }).catch(function(){
            toaster.pop('error', msg.error, msg.server_comunication_error);
        });
    };

});

'use strict';

angular.module('ictportal.tnt')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/tnt/goodsinward/kitenvelope', {
        templateUrl: 'tnt/goods-inward/kit-envelope-association/kit-envelope-association.html',
        controller: 'tntKitEnvelopeAssociationCtrl',
      });
  }).controller('tntKitEnvelopeAssociationCtrl', function ($log, $scope, dbFilterFactory, localeFactory, recordFactory, tntGoodsInwardFactory, toaster) {

  $scope.package = {
    barcode: undefined,
    lot: undefined,
    date: undefined,
    plainDate: undefined
  };

  $scope.product = {
    id: undefined,
    description: undefined,
    quantityIncluded: undefined,
    packageQuantity: undefined
  };

  $scope.serialKit = [];

  $scope.packageFull = false;
  $scope.confimIsDisabled = true;
  $scope.codeReaderIsDisabled = false;

  var filterOptions = {
    page_size: 1000,
    page: 1
  };

  var productionStatus = {
    packed: 'PACKED'
  };

  var msgType = {
    error: 'error',
    info: 'info',
    success: 'success'
  };

  var msg = {
    error: 'Error',
    info: 'Info',
    success: 'Success'
  };

  function checkConfirmButton() {
    if ($scope.product.id !== null) {
      if ($scope.product.packageQuantity == null) {
        $scope.confimIsDisabled = false;
      } else if ($scope.product.packageQuantity === $scope.serialKit.length) {
        $scope.codeReaderIsDisabled = true;
        $scope.confimIsDisabled = false;
        $scope.packageFull = true;
      } else {
        $scope.confimIsDisabled = true;
        $scope.codeReaderIsDisabled = false;
        $scope.packageFull = false;
      }
    }
  }

  function findProductBySkId(id) {
    var filter = [{
      "column": "bom b",
      "value": "b.item_id = t.id",
      "relation": "JOIN"
    }, {
      "column": "serial_kit sk",
      "value": "b.id = sk.bom_id",
      "relation": "JOIN"
    }];
    filter = filter.concat(dbFilterFactory.getNumberFilter('sk.id', id));
    return recordFactory('product').filter({}, filter).$promise.then(function (res) {
      var p = {};
      if (res.list && res.list.length > 0) {
        p.id = res.list[0].id;
        p.description = res.list[0].code + ' - ' + res.list[0].description;
        p.quantityIncluded = res.list[0].quantity_included;
        p.packageQuantity = res.list[0].package_quantity;
      } else {
        localeFactory.translateReplace('goods_inward.PRODUCT_ERROR').then(function (translation) {
          toaster.pop(msgType.error, msg.error, translation);
        });
      }
      return p;
    });
  }

  function checkProductAndAddSerialKit(sk) {
    findProductBySkId(sk.id).then(function (product) {
      if (product && (!$scope.product.id || $scope.product.id == product.id)
        && (!$scope.package.plainDate || !sk.expiration_date || $scope.package.plainDate === sk.expiration_date)) {
        $scope.serialKit.push({
          id: sk.id,
          barcode: sk.barcode,
          productionStatus: sk.production_status
        });
        if (!$scope.product.id) {
          $scope.product.id = product.id;
          $scope.product.description = product.description;
          $scope.product.packageQuantity = product.packageQuantity;
          $scope.product.quantityIncluded = product.quantityIncluded;
        }
        checkConfirmButton();
      } else {
        localeFactory.translateReplace('goods_inward.wrong_product').then(function (translation) {
          toaster.pop(msgType.error, msg.error, translation);
        });
      }
    });
  }

  function addElement(data, included) {
    if (data.list && data.list.length > 0) {
      var sk = data.list[0];
      var found = $scope.serialKit.find(function(element) {
        return element.id === sk.id;
      });
      if (!found) {
        checkProductAndAddSerialKit(sk);
      } else {
        localeFactory.translateReplace('goods_inward.already_packed').then(function (translation) {
          toaster.pop(msgType.error, msg.error, translation);
        });
      }
    } else if (included === false) {
      localeFactory.translateReplace('goods_inward.kit_not_valid').then(function (translation) {
        toaster.pop(msgType.error, msg.error, translation);
      });
    }
  }

  // included: se si tratta del kit da ricercare in automatico => se esiste un kit con barcode del cartone
  function searchAndAddKit(barcode, included) {
    var filter = [];
    if ($scope.package.lot !== undefined && $scope.package.lot !== null) {
      filter = [{
        column: 'lot l',
        value: 'l.id = t.production_lot_id',
        relation: 'JOIN'
      }, {
        value: '(l.code=\'' + $scope.package.lot + '\' OR l.code IS NULL)',
        kind: 'custom'
      }];
    }
    filter = filter.concat(dbFilterFactory.getStringFilter('barcode', barcode));
    recordFactory('serial_kit').filter(filterOptions, filter).$promise.then(function (data) {
      addElement(data, included);
    });
  }

  $scope.readKit = function (read) {
    if (!$scope.package.barcode) {
      tntGoodsInwardFactory.readEan128({plain: read.read}).$promise.then(function (res) {
        if (res) {
          var tmpBarcode = res.data.barcode;
          $scope.package.barcode = tmpBarcode;
          $scope.package.lot = res.data.lotto;
          if (res.data.dataScadenza !== null) {
            $scope.package.plainDate = res.data.dataScadenza;
            $scope.package.date = new Date($scope.package.plainDate).toLocaleDateString();
          }
          // search if already exists
          var filter = [];
          filter = filter.concat(dbFilterFactory.getStringFilter('envelope', tmpBarcode));
          recordFactory('serial_kit').filter(filterOptions, filter).$promise.then(function (data) {
            if (data && data.list && data.list.length > 0) {
              var i;
              var error = false;
              for (i = 0; i < data.list.length; ++i) {
                var item =  data.list[i];
                  checkProductAndAddSerialKit(item);
              }
              if(error) {
                $scope.refreshList();
                localeFactory.translateReplace('goods_inward.package_already_sent').then(function (translation) {
                  toaster.pop(msgType.error, msg.error, translation);
                });
              }
            } else {
              searchAndAddKit(tmpBarcode, true);
            }
          });
        } else {
          localeFactory.translateReplace('goods_inward.package_not_found').then(function (translation) {
            toaster.pop(msgType.error, msg.error, translation);
          });
        }
      });
    } else {
      searchAndAddKit(read.read, false);
    }
  };

  function removeKitFromPackage(currentId) {
    recordFactory('serial_kit').update({id: currentId}, {
      envelope: null
    }).$promise.then(function (res) {
      if (res) {
        localeFactory.translateReplace('goods_inward.kit_pack_remove').then(function (translation) {
          toaster.pop(msgType.success, msg.success, translation);
        });
      } else {
        localeFactory.translateReplace('goods_inward.PRODUCT_ERROR').then(function (translation) {
          toaster.pop(msgType.error, msg.error, translation);
        });
      }
    });
  }

  $scope.removeElement = function (element) {
    var currentId = element.currentTarget.value;
    var filtered = $scope.serialKit.filter(function (value, index, arr) {
      if(value.id == currentId && value.productionStatus == productionStatus.packed) {
        removeKitFromPackage(currentId);
      }
      return value.id != currentId;
    });
    $scope.serialKit = filtered;
    checkConfirmButton();
  };

  $scope.refreshList = function () {
    $scope.package = {};
    $scope.product.id = undefined;
    $scope.serialKit = [];
    $scope.confimIsDisabled = true;
    $scope.codeReaderIsDisabled = false;
  };

  $scope.confirmPack = function () {
    var n = 0;
    if ($scope.package.barcode && $scope.serialKit.length > 0) {
      var a = [];
      $scope.serialKit.forEach(function (element) {
        var param = {
          envelope: $scope.package.barcode,
          production_status: productionStatus.packed,
          last_modified_date: new Date()
        };
        // TODO gestire l'aggiornamento in una singola transazione
        a.push(recordFactory('serial_kit').update({id: element.id}, param).$promise.then(function (res) {
          var updated = 0;
          if (!res) {
            localeFactory.translateReplace('goods_inward.PRODUCT_ERROR').then(function (translation) {
              toaster.pop(msgType.error, msg.error, translation);
            });
          } else {
            updated = parseInt(res.updated);
          }
          n += updated;
        }));
      });
      Promise.all(a).then(function () {
        if (n > 0) {
          localeFactory.translateReplace('goods_inward.package_completed').then(function (translation) {
            toaster.pop(msgType.success, msg.success, translation);
          });
        }
        $scope.refreshList();
      });
    }
  };

  function init() {
    $log.info('>>> tntKitEnvelopeAssociationCtrl');
    localeFactory.loadTranslation('portal');
    localeFactory.loadTranslation('goods_inward');
  }

  //___ main ___
  init();

});

'use strict';

/**
 * @ngdoc function
 * @name ictportal.core.controller:GoodsInwardListCtrl
 * @description
 * @author Rita Beltrami
 *
 * @param depotCode è OBBLIGATORIO passare alla pagina il codice del deposito su cui caricare la merce
 * @param wardrobeCode è OBBLIGATORIO nel caso di ricevimento merce direttamente IN GUARDAROBA
 *
 * created on 23/02/2010
 * # GoodsInwardListCtrl
 * Controller of the ictportal.tnt
 *
 */
angular.module('ictportal.tnt')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/tnt/goodsinward/list/:depotCode', {
                templateUrl: 'tnt/goods-inward/list/goods-inward-list.html',
                controller: 'GoodsInwardListCtrl',
                resolve: {
                    wardrobeMode: function ($route) { $route.current.params.wardrobeMode = false; }
                }
            })
            .when('/tnt/goodsinward/wardrobe/list/:wardrobeCode', {
                templateUrl: 'tnt/goods-inward/list/goods-inward-list.html',
                controller: 'GoodsInwardListCtrl',
                resolve: {
                    wardrobeMode: function ($route) { $route.current.params.wardrobeMode = true; }
                }
            })
    })
    .controller('GoodsInwardListCtrl', function ($scope, recordFactory, $routeParams, $location, tntGoodsInwardService, authFactory,
                                                $rootScope, parseSchemaService, matrixParFactory, dbFilterFactory, localeFactory, $q,
                                                toaster, eggsFormFactory) {
        var msg = {
            "date": "Date",
            "number": "Number",
            "supplier": "Supplier"
        };
        var goods_inward_msg = {
            "supplier_code": "Supplier code",
            "supplier_ddt_number": "Supplier DDT number",
            "supplier_ddt_date": "Supplier DDT date",
            "reference": "Reference",
            "error_retrieving_destination": "Error retrieving customer destination",
            "destination_not_found": "Customer destination not found",
            "goods_inward_wardrobe": "Wardrobe goods inward",
            "goods_inward": "Goods inward"
        };
        $scope.isSupplier = false;
        $scope.preselectSupplier = false;
        $scope.result = {};
        $scope.supplierFilters = []; // Lookup filter
        $scope.supplierImplicitFilter = []; // Table filter on supplier
        $scope.destinationFilter = [];
        $scope.record = {
            lookup: {}, // Per questa pagina non serve, la lascio un attimo mentre penso a come standardizzare il più possibile le pagine
            dates: ['dn_date', 'int_date']
        };
        $scope.params = {
            pageNumber: 1,
            pageSize: 15,
            code: 'component',
            filters: []
        };
        $scope.viewGridOptions = { appScopeProvider: $scope };
        $scope.advFilter = {
            filter: {},
            list: []
        };
        $scope.enum = {};

        $scope.$watchGroup(['advFilter.filter.supplier_id',
            'advFilter.filter.dn_number',
            'advFilter.filter.reference',
            'advFilter.filter.dn_date_from',
            'advFilter.filter.dn_date_to',
            'advFilter.filter.status',
            'advFilter.filter.barcode'
        ], function () {
                $scope.applyFilter();
            });

        $scope.applyFilter = function () {
            $scope.advFilter.list.length = 0;
            if ($scope.advFilter.filter.supplier_id) {
                var f = dbFilterFactory.getNumberFilter('t.supplier_id', $scope.advFilter.filter.supplier_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.dn_number) {
                var f = dbFilterFactory.getNumberFilter('t.dn_number', $scope.advFilter.filter.dn_number);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.reference) {
                var f = dbFilterFactory.getLikeFilter('t.reference', $scope.advFilter.filter.reference);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.dn_date_from) {
                var f = dbFilterFactory.getDateFilter('t.dn_date', $scope.advFilter.filter.dn_date_from, '>=');
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.dn_date_to) {
                var f = dbFilterFactory.getDateFilter('t.dn_date', $scope.advFilter.filter.dn_date_to, '<=');
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.status) {
                var f = dbFilterFactory.getStringFilter('t.status', $scope.advFilter.filter.status);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if($scope.advFilter.filter.barcode) {
              var skfilter = [{
                "column": "goods_inward_row gir",
                "value": "t.id = gir.goods_inward_id",
                "relation": "JOIN"
              }, {
                "column": "serial_kit sk",
                "value": "gir.id = sk.gi_row_id",
                "relation": "JOIN"
              }];
              $scope.advFilter.list = $scope.advFilter.list.concat(skfilter);
              var f = dbFilterFactory.getStringFilter('sk.barcode', $scope.advFilter.filter.barcode);
              $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            $scope.getData();
        };

        var initGridColumns = function () {
            $scope.lookupCols = [];
            $scope.viewGridOptions.columnDefs = [];
            var dateFormat = localeFactory.getDateFormat();
            $scope.viewGridOptions.columnDefs.push(parseSchemaService.getEditCol());
            $scope.viewGridOptions.columnDefs.push({
                name: 'Number',
                field: "int_number",
                translation: 'number',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Date",
                field: "int_date",
                translation: 'date',
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.int_date | date:\'' + dateFormat + '\' }}</div>',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Fornitore",
                field: "supplier_description",
                translation: 'supplier',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "DDT Number",
                field: "dn_number",
                translation: 'supplier_ddt_number',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Reference",
                field: "reference",
                translation: 'reference',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "DDT Date",
                field: "dn_date",
                translation: 'supplier_ddt_date',
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.dn_date | date:\'' + dateFormat + '\' }}</div>',
                enableFiltering: false
            });
        };

        $scope.getData = function () {
            var payload = {
                page: $scope.params.pageNumber,
                page_size: $scope.params.pageSize,
                code: $scope.params.code,
                description: $scope.params.description,
                show_revision: false,
                sort_fields: ($scope.params.sortFields ? $scope.params.sortFields : 'int_number'),
                sort_order: 'desc'
            };
            // Qui scrivo i filtri obbligatori, quelli 'avanzati' li accodo
            var filters = [
                {
                    "column": "supplier s",
                    "value": "t.supplier_id = s.id",
                    "relation": "JOIN",
                    "kind": "s.description AS supplier_description"
                }
            ]
              .concat($scope.supplierImplicitFilter)
              .concat($scope.advFilter.list)
              .concat($scope.destinationFilter);
            recordFactory('goods_inward').filter(payload, filters).$promise.then(function (data) {
              $scope.viewGridOptions.totalItems = data.totalResults;
              $scope.result.totalResults = data.totalResults;
              $scope.result.list = data.list;
              if ($scope.record.dates.length > 0) {
                parseSchemaService.loadDates($scope.record, $scope.result);
              }
            });
        };

        $scope.viewDetail = function (value) {
            var path = '/tnt/goodsinward/detail/' + $scope.depotCode + '/' + value.id;
            if($scope.wardrobeMode){
                path = '/tnt/goodsinward/wardrobe/detail/' + $scope.depotCode + '/' + $routeParams.wardrobeCode + '/' + value.id;
            }
            $location.path(path);
        };

        $scope.goToNew = function () {
            var path = '/tnt/goodsinward/detail/' + $scope.depotCode;
            if($scope.wardrobeMode){
                path = '/tnt/goodsinward/wardrobe/detail/' + $scope.depotCode + '/' + $routeParams.wardrobeCode;
            }
            $location.path(path);
        };

        $scope.goFileUpload = function () {
            if($scope.wardrobeMode){
                $location.path('/tnt/goodsinward/wardrobe/upload/' + $scope.wardrobeCode);
            }
            else {
                $location.path('/tnt/goodsinward/upload/' + $scope.depotCode);
            }
        };

        function translateGridColumns() {
            $scope.viewGridOptions.columnDefs.forEach(function (col) {
                if (col.translation) {
                    if (goods_inward_msg[col.translation]) {
                        col.name = goods_inward_msg[col.translation];
                    }
                    else {
                        col.name = msg[col.translation];
                    }
                }
            });
        };

        function initLookups() {
            $scope.lookup = {};
            eggsFormFactory.addLookup($scope.lookup, 'supplier_id', 'supplier', 'code', 'description');
        };

        $rootScope.$on('$translateRefreshEnd', function () {
            $q.all({
                general: localeFactory.translateMsg(msg),
                specific: localeFactory.translateMsg(goods_inward_msg, 'goods_inward')
            })
                .then(function (data) {
                    $scope.functionTitle = $scope.wardrobeMode?goods_inward_msg.goods_inward_wardrobe:goods_inward_msg.goods_inward;
                    translateGridColumns();
                })
                .catch(function (error) { $log.error(error); });
        });

        /**
         * Is user allowed to visit this page?
         */
        function checkPermissions() {
            var profilingKey = 'TNT_GOODS_INWARD_FUNCTION';
            var permission = authFactory.getPermissions(profilingKey);
            if(!permission.EXEC) {
                $location.path('forbidden').search({key: profilingKey});
            }
            else {
                $scope.isNewAllowed = permission.NEW;
                $scope.isDetailAllowed = permission.DETAIL;
                $scope.isUpdateAllowed = permission.UPDATE;
            }
        };

        /**
         * Only suppliers that sell TNT products and that are allowed for this user.
         */
        function getSupplierImplicitFilter() {
            // IMPLICIT FILTER
            var authData = authFactory.getAuthData();
            if(authData) {
                // Filter for getData()
                var copy = JSON.parse(JSON.stringify(authData.filters.supplier));
                copy.forEach(function(f){
                    dbFilterFactory.changeCustomAlias('s',f);
                    $scope.supplierImplicitFilter.push(f);
                })

                // Filter for lookup
                $scope.supplierFilters = $scope.supplierFilters.concat(authData.filters.supplier);
                $scope.preselectSupplier = authData.info && authData.info.authorizations && (authData.info.authorizations.suppliers.length==1);
            }
            // PRODUCT GROUP FILTER
            matrixParFactory.getMatrixPar({ key: 'tntProductGroup', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*' }).$promise.then(function (response) {
                if (response.value) {
                    var codes = response.value.trim().split(",");
                    if(codes.length>0) {
                        var query = dbFilterFactory.getOrQuery('pg.code', codes);
                        $scope.supplierFilters = $scope.supplierFilters.concat(dbFilterFactory.getCustomFilter("t.id in (select t.id from supplier t LEFT JOIN product_supplier ps ON t.id = ps.supplier_id LEFT JOIN product p ON ps.product_id = p.id LEFT JOIN product_group pg ON p.product_group_id = pg.id where " + query + ")"));
                    }
                }
            }).catch(angular.identity);
        }

        function getDestinationFilter() {
          var deferred = $q.defer();
          var destinationCode = $routeParams.wardrobeCode || $routeParams.depotCode;
          var cdFilter = []
            .concat(dbFilterFactory.getStringFilter('t.code', destinationCode))
            .concat(authFactory.getAuthFilters())
            .concat(authFactory.getAuthDestinationFilters());
          recordFactory('customer_destination').filter({}, cdFilter).$promise.then(function (data) {
            if (data && data.totalResults === 1) {
              deferred.resolve(data.list[0].id);
            } else {
              deferred.resolve(-1);
            }
          }).catch(function () {
            deferred.resolve(-1);
          });
          return deferred.promise;
        }

        function init() {
            localeFactory.loadTranslation('goods_inward');
            checkPermissions();
            initLookups();
            initGridColumns();
            getSupplierImplicitFilter();
            $scope.enum = tntGoodsInwardService.enum;
            $scope.wardrobeMode = $routeParams.wardrobeMode;
            $scope.depotCode = $routeParams.depotCode;
            $scope.wardrobeCode = $routeParams.wardrobeCode;
            $scope.destinationFilter = dbFilterFactory.getNumberFilter('t.destination_id', -1);
            var myPromises = {
              destination: getDestinationFilter(),
              supplier: tntGoodsInwardService.isSupplier($scope.depotCode)
            }
            $q.all(myPromises).then(function (response) {
              $scope.isSupplier = response.supplier;
              if (response.destination === -1) {
                toaster.pop('error', msg.error, goods_inward_msg.destination_not_found);
                $scope.isNewAllowed = false;
              }
              $scope.destinationFilter = []
                .concat(authFactory.getAuthFilters())
                .concat(dbFilterFactory.getNumberFilter('t.destination_id', response.destination));
              $scope.getData();
            }).catch(function (ex) {
              toaster.pop('error', msg.error, goods_inward_msg.error_retrieving_destination);
            });
            console.log(">>> goods-inward-list.ctrl.js [" + $scope.depotCode + "]");
        }

        //___ main ___
        init();
    });

'use strict';

/**
 * @ngdoc function
 * @name ictportal.core.controller:FinalizeInventoryCtrl
 * @description
 * @author Mattia Freda
 *
 * @param destinationCode è FACOLTATIVO passare alla pagina il codice del deposito per cui finalizzare gli inventari
 *
 * created on 03/01/2020
 * # FinalizeInventoryCtrl
 * Controller of the ictportal.tnt
 *
 */
angular.module('ictportal.tnt')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/tnt/inventory/finalize', {
                templateUrl: 'tnt/inventory/finalize/finalize-inventory.html',
                controller: 'FinalizeInventoryCtrl'
            })
            .when('/tnt/inventory/finalize/:destinationCode', {
                templateUrl: 'tnt/inventory/finalize/finalize-inventory.html',
                controller: 'FinalizeInventoryCtrl'
            })
    })
    .controller('FinalizeInventoryCtrl', function ($scope, recordFactory, $routeParams, $location, tntGoodsInwardService, tntInventorySrv,
                                                authFactory, $rootScope, parseSchemaService, $uibModal, dbFilterFactory, localeFactory, $q,
                                                matrixParFactory, shipmentDocumentFactory, toaster, eggsFormFactory, $log) {
        var msg = {
            "error": "Error",
            "destination": "Customer destination",
            "inventory_date": "Inventory date",
            "kit_status": "Kit status",
            "inventoried": "Inventoried",
            "op_completed_success": "Operation completed",
            "server_comunication_error": "Server communication error"
        };
        var finalize_inventory_msg = {
            "finalize_inventory": "Manage inventories",
            "error_retrieving_destination": "Error retrieving customer destination",
            "destination_not_found": "Customer destination not found",
            "ddt_created": "Shipment {{kitCount}} created",
          "STERILIZED": "Sterilized",
          "SENT_WARDROBE": "Sent Wardrobe",
          "WARDROBE": "Wardrobe",
          "ACCEPTED": "Accepted",
          "LOST": "Lost",
          "INVALIDATED": "Invalidated",
          "NEW": "New",
          "SENT": "Sent",
          "CONSUMED": "Consumed"
        };
        $scope.result = {};
        $scope.record = {
            lookup: {},
            dates: ['start_date']
        };
        $scope.params = {
            pageNumber: 1,
            pageSize: 15,
            code: 'component',
            filters: []
        };
        $scope.advFilter = {
            filter: {},
            list: []
        };
        $scope.enum = {
          status: [
            {
              name: 'Consumed',
              value: 'CONSUMED'
            },{
              name: 'Sent',
              value: 'SENT'
            },{
              name: 'New',
              value: 'NEW'
            },{
              name: 'Invalidate',
              value: 'INVALIDATED'
            },{
              name: 'Lost',
              value: 'LOST'
            },{
              name: 'Sent_wardrobe',
              value: 'SENT_WARDROBE'
            },{
              name: 'Sterilized',
              value: 'STERILIZED'
            }, {
              name: 'Wardrobe',
              value: 'WARDROBE'
            }, {
              name: 'Accepted',
              value: 'ACCEPTED'
            }
          ]
        };
        $scope.deleteEnabled = false;
        var selectedRows = [];


        $scope.sixRowSelectionChangedCallback = function(row, col, event){
            selectedRows = row.grid.api.selection.getSelectedRows();
            if (selectedRows.length <= 0) {
              $scope.deleteEnabled = false;
            } else {
              $scope.deleteEnabled = true;
            }
            console.log("selezionate "+selectedRows.length+" righe");
        };

        $scope.sixBulkSelectionCallback = function(scope, rows, evt) {
            selectedRows = $scope.viewGridOptions.gridApi.selection.getSelectedRows();
            if (selectedRows.length <= 0) {
                $scope.deleteEnabled = false;
            } else {
                $scope.deleteEnabled = true;
                if (selectedRows.length === $scope.viewGridOptions.appScopeProvider.params.pageSize) {
                    toaster.pop('warn', 'ATTENZIONE! Selezionate solamente le righe della prima pagina');
                }
            }
            console.log("selezionate "+selectedRows.length+" righe");

        };

        $scope.viewGridOptions = {
            appScopeProvider: $scope,
            enableFiltering: true,
            multiSelect: true,
            enableRowHeaderSelection: true,
            enableRowSelection: true,
            rowSelectionChanged: $scope.sixRowSelectionChangedCallback,
            rowSelectionChangedBatch: $scope.sixBulkSelectionCallback,
            enablePaginationControls: true
        };
        $scope.detailGridOptions = {
            paginationPageSize: 10,
            paginationPageSizes: [10, 15],
            useExternalPagination: false,
            enablePaginationControls: true,
            useExternalSorting: false,
            enableFiltering: false,
            columnDefs:[{
                field: 'sk_envelope',
                displayName: 'Cartone',
                headerCellFilter: 'translate'
            },{
                field: 'sk_barcode',
                displayName: 'Confezione',
                headerCellFilter: 'translate'
            },{
                field: 'product_code',
                displayName: 'Articolo',
                headerCellFilter: 'translate'
            },{
              field: 'sk_status',
              displayName: 'Stato',
              headerCellFilter: 'translate'
            },{
                field: 'sk_expiration_date',
                displayName: 'expiration_date',
                headerCellFilter: 'translate',
                cellFilter: 'date:"'+localeFactory.getDateFormat()+'"',
                exportCelFormat: function(ms){  return dateFilter(ms, dateFormat); }
            }]
        };

        $scope.$watchGroup(['advFilter.filter.destination_id',
            'advFilter.filter.inv_date_from',
            'advFilter.filter.inv_date_to',
            'advFilter.filter.status',
            'advFilter.filter.barcode'], function () {
                $scope.applyFilter();
            }
        );

        $scope.applyFilter = function () {
            $scope.advFilter.list.length = 0;
            if ($scope.advFilter.filter.destination_id) {
                var f = dbFilterFactory.getNumberFilter('t.customer_destination_id', $scope.advFilter.filter.destination_id);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.inv_date_from) {
                var f = dbFilterFactory.getDateFilter('t.start_date', $scope.advFilter.filter.inv_date_from, '>=');
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.inv_date_to) {
                var filterDate = $scope.advFilter.filter.inv_date_to.addDays(1);
                var f = dbFilterFactory.getDateFilter('t.start_date', filterDate, '<=');
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.status) {
                var f = dbFilterFactory.getStringFilter('sk.status', $scope.advFilter.filter.status);
                $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            if ($scope.advFilter.filter.barcode) {
              var f = dbFilterFactory.getStringFilter('sk.barcode', $scope.advFilter.filter.barcode);
              $scope.advFilter.list = $scope.advFilter.list.concat(f);
            }
            $scope.getListData();
        };

        var initGridColumns = function () {
            $scope.lookupCols = [];
            $scope.viewGridOptions.columnDefs = [];
            var dateFormat = "dd/MM/yyyy HH:mm:ss"
            $scope.viewGridOptions.columnDefs.push({
                name:'detail',
                displayName: '',
                width: 34,
                enableColumnResizing: false,
                enableColumnMenu: false,
                enableSorting: false,
                enableFiltering: false,
                cellTemplate:
                '<div class="ui-grid-cell-contents" style="text-align: center">' +
                ' <button class="btn btn-xs btn-primary" ng-click="grid.appScope.viewDetail(row)">' +
                '  <span class="fa fa-list-ul"></span>' +
                ' </button>' +
                '</div>'
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Destinazione",
                field: "kit_destination",
                translation: 'destination',
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.destination_code }} - {{ row.entity.destination_des }}</div>',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Data inventario",
                field: "start_date",
                translation: 'inventory_date',
                cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.start_date | date:\'' + dateFormat + '\' }}</div>',
                enableFiltering: false
            });
            $scope.viewGridOptions.columnDefs.push({
                name: "Confezioni",
                field: "kit_count",
                translation: 'inventoried',
                width: 150,
                enableFiltering: false
            });
        };

        $scope.getData = function(addFilters, groupByFields) {
            var deferred = $q.defer();
            var payload = {
                page: $scope.params.pageNumber,
                page_size: $scope.params.pageSize,
                code: $scope.params.code,
                description: $scope.params.description,
                show_revision: false,
                sort_fields: 'start_date',
                sort_order: 'desc'
            };
            var filters = [{
                "column": "inventory_archive_detail det",
                "value": "t.id = det.inventory_archive",
                "relation": "JOIN",
                "kind": "det.serial_kit_id AS kit_id"
            },
            {
                "column": "serial_kit sk",
                "value": "det.serial_kit_id = sk.id",
                "relation": "JOIN",
                "kind": "sk.status AS kit_status"
            },
            {
                "column": "customer_destination cd",
                "value": "t.customer_destination_id = cd.id",
                "relation": "JOIN",
                "kind": "cd.code AS destination_code, cd.description AS destination_des"
            }];
            filters = filters.concat($scope.advFilter.list);
            filters = filters.concat(dbFilterFactory.getStringFilter('t.processed', "F"));
            filters = filters.concat(addFilters);
            deferred.resolve(recordFactory('inventory_archive').aggregation(payload, {
                filters: filters,
                fields: groupByFields,
                operations: [{
                    function: "count",
                    argument: "distinct sk.id",
                    alias: "kit_count"
                }]
            }).$promise);
            return deferred.promise;
        };

        $scope.getListData = function () {
            if ($scope.lookup.destination_id.obj) {
                var groupByFields = ['t.id', 't.start_date',
                    'cd.id AS destination_id', 'cd.code AS destination_code', 'cd.description AS destination_des'];
                var authData = authFactory.getAuthData();
                var destFilter = [];
                if (authData.filters.customer_destination && authData.filters.customer_destination.length > 0) {
                    destFilter = angular.copy(authData.filters.customer_destination[0]);
                    dbFilterFactory.changeCustomAlias('cd', destFilter);
                }
                $scope.getData(destFilter, groupByFields).then(function(data){
                    $scope.viewGridOptions.totalItems = data.totalResults;
                    $scope.result.totalResults = data.totalResults;
                    $scope.result.list = data.list;
                    if ($scope.record.dates.length > 0) {
                        parseSchemaService.loadDates($scope.record, $scope.result);
                    }
                    $scope.result.list.forEach(function(e){
                        var statusEnum = $scope.enum.status.filter(function(s){return s.value==e.kit_status});
                        if (statusEnum.length > 0) {
                            e.kit_status = statusEnum[0].name;
                        }
                    });
                });
            }
        }

        $scope.viewDetail = function(row) {
            if ($scope.selectedRow && $scope.selectedRow.$$hashKey === row.entity.$$hashKey) {
                $scope.selectedRow = undefined;
            } else {
                $scope.selectedRow = row.entity;
                $scope.getDetailData($scope.selectedRow);
            }
        };

      $scope.getDetailData = function(row) {
        if(row.id){
          var filters = [{
            column: 'serial_kit sk',
            value: 'sk.id = t.serial_kit_id',
            relation: 'JOIN',
            kind: 'sk.envelope as sk_envelope, sk.barcode as sk_barcode, sk.expiration_date as sk_expiration_date, sk.status as sk_status'
          },{
            column: 'bom b',
            value: 'sk.bom_id = b.id',
            relation: 'JOIN',
            kind: 'b.item_id AS bom_product'
          },{
            column: 'product p',
            value: 'b.item_id = p.id',
            relation: 'JOIN',
            kind: 'p.code AS product_code'
          }];
          filters = filters.concat(dbFilterFactory.getCustomFilter("t.inventory_archive = "+row.id));
          recordFactory('inventory_archive_detail').filter({ page_size: row.kit_count }, filters).$promise.then(function (data){
            if(data.list.length > 0){
              data.list.forEach(function (e) {
                $scope.enum.status.map(function (s) {
                  if (e.sk_status == s.value) {
                    e.sk_status = s.name;
                  }
                })
              });
              $scope.detailGridOptions.data = data.list;
              $scope.detailGridOptions.totalItems = data.totalResults;
            }
          })
        }
      }

        $scope.deleteSelected = function () {
          $uibModal.open({
            templateUrl: 'confirmDelete.html',
            size: 'sm',
            controller: function($scope, $uibModalInstance){
              $scope.ok = function () {
                $uibModalInstance.close();
              };
              $scope.cancel = function () {
                $uibModalInstance.dismiss();
              };
            }
          }).result.then(function () {
            var inventories = selectedRows.map(function(row){return {id: row.id};});
            tntInventorySrv.confirmDelete(inventories).then(function (response) {
              if(response.status == "ok") {
                toaster.pop('success', msg.op_completed_success);
                // aggiorno la griglia
                var processed = selectedRows.map(function(r) { return r.$$hashKey; });
                $scope.result.list = $scope.result.list.filter(
                  function(o) {return processed.indexOf(o.$$hashKey) == -1;}
                );
                $scope.deleteEnabled = false;
              } else {
                toaster.pop('error', msg.error, response.error_message);
                console.error(response.error_message);
              }
            }).catch(function(ex){ logError(ex) });
          });
        }

      $scope.finalizeSelected = function () {
        var rows = $scope.result.list;
        if (rows && rows.length > 0) {
          var destinationId = rows[0].destination_id;
          // recupero singoli kit inventariati
          var startDate = null;
          var archiveList = rows.map(function (row) {
            if(startDate == null ){
              startDate = row.start_date;
            } else {
              var min = new Date(startDate);
              var curr = new Date(row.start_date);
              if(curr < min){
                startDate = row.start_date;
              }
            }
            return row.id;
          });
          console.log(startDate);
          tntInventorySrv.getKitsFromInventory(archiveList).then(function (kitList) {
            var kitIdsList = (kitList.list || []).map(function (el) {
              return el.id;
            });
            tntInventorySrv.getDestinationMissingAmount(destinationId, kitIdsList, startDate)
              .then(function (missingAmount) {
                $uibModal.open({
                  templateUrl: 'finalizeConfirm.html',
                  size: 'sm',
                  controller: function ($scope, $uibModalInstance, recap) {
                    $scope.recap = recap;
                    $scope.ok = function () {
                      $uibModalInstance.close();
                    };
                    $scope.cancel = function () {
                      $uibModalInstance.dismiss();
                    };
                  },
                  resolve: {
                    recap: function () {
                      return {
                        read: kitIdsList.length,
                        missing: missingAmount
                      };
                    }
                  }
                }).result.then(function () {
                  var inventories = rows.map(function (row) {
                    return {id: row.id, start_date: row.start_date};
                  });
                  tntInventorySrv.finalize({id: destinationId}, inventories).then(function (response) {
                    if (response.status == "ok") {
                      toaster.pop('success', msg.op_completed_success);
                      // aggiorno la griglia
                      $scope.result.list = [];
                    } else {
                      toaster.pop('error', msg.error, response.error_message);
                      console.error(response.error_message);
                    }
                  }).catch(function (ex) {
                    logError(ex)
                  });
                });
              })
          });

        }
      };

        var logError = function logError(ex) {
            $log.log(ex);
            toaster.pop('error', msg.error, msg.server_comunication_error);
        };

        function translateGridColumns() {
            $scope.viewGridOptions.columnDefs.forEach(function (col) {
                if (col.translation) {
                    if (finalize_inventory_msg[col.translation]) {
                        col.name = finalize_inventory_msg[col.translation];
                    }
                    else {
                        col.name = msg[col.translation];
                    }
                }
            });
        };

        function initLookups() {
            $scope.lookup = {};
            eggsFormFactory.addLookup($scope.lookup, 'destination_id', 'customer_destination', 't.code', 't.description');
        };

        $rootScope.$on('$translateRefreshEnd', function () {
            $q.all({
                general: localeFactory.translateMsg(msg),
                specific: localeFactory.translateMsg(finalize_inventory_msg, 'inventory').then(function(){
                    $scope.enum.status.forEach(function(en){
                        en.name = finalize_inventory_msg[en.value];
                    });
                })
            })
            .then(function (data) {
                $scope.functionTitle = finalize_inventory_msg.finalize_inventory;
                translateGridColumns();
            })
            .catch(function (error) { $log.error(error); });
        });

        function checkPermissions() {
            var profilingKey = 'TNT_INVENTORY_FINALIZE';
            var permission = authFactory.getPermissions(profilingKey);
            if(!permission.EXEC) {
                $location.path('forbidden').search({key: profilingKey});
            }
            else {
                $scope.isDetailAllowed = permission.DETAIL;
                $scope.isUpdateAllowed = permission.UPDATE;
            }
        }

        function init() {
            localeFactory.loadTranslation('inventory');
            initLookups();
            checkPermissions();
            initGridColumns();
            $scope.destinationFilter = [];
            if ($routeParams.destinationCode) {
                $scope.destinationCode = $routeParams.destinationCode;
                $scope.destinationFilter = $scope.destinationFilter.concat(dbFilterFactory.getStringFilter('t.code',$scope.destinationCode));
            } else {
                var authData = authFactory.getAuthData();
                if (authData.filters.customer_destination && authData.filters.customer_destination.length > 0) {
                    $scope.destinationFilter = authData.filters.customer_destination;
                }
            }
        }

        //___ main ___
        init();

    });

angular.module('ictportal.tnt')
.controller('TntReorderEndowmentsCtrl', function ($scope, $translate, localeFactory) {

    $scope.gridFilter = {
        code: '',
        description: ''
    };
    $scope.translateMsg = {
        cell_min_stock: 'Min stock',
        cell_consumed: 'Consumed'
    };
    $scope.gridOptions = {
        enableCellEdit: false,
        enableFiltering: true,
        useExternalPagination: false,
        useExternalSorting: false,
        paginationPageSizes: [15, 30, 45, 100, 1000, 10000],
        paginationPageSize: 15,
        onRegisterApi: function(gridApi) {
            $scope.gridApi = gridApi;
            gridApi.edit.on.afterCellEdit($scope, afterCellEdit);
        },
        appScopeProvider: $scope,
        rowTemplate: 'tnt/reorder/endowments/row.tmpl.html',
        columnDefs: [
            {
                displayName: 'code',
                field: 'product.code',
                headerCellFilter: 'translate',
                width: '**',
                minWidth: '105'
            }, {
                displayName: 'description',
                headerCellFilter: 'translate',
                field: 'product.description',
                width: '****',
                minWidth: '105'
            },
          // {
          //       displayName: 'reorder.reorder_type',
          //       headerCellFilter: 'translate',
          //       cellFilter: 'translate',
          //       field: 'reorder_type',
          //       enableFiltering: false,
          //       cellTemplate: 'tnt/reorder/endowments/reorder-cell.tmpl.html',
          //       width: '250'
          //   },
          {
                displayName: 'quantity',
                enableSorting: false,
                enableColumnMenu: false,
                headerCellFilter: 'translate',
                field: 'stock_amount',
                enableFiltering: false,
                enableCellEdit: true,
                cellClass: 'editable-cell',
                width: '*'
            }, {
                displayName: 'reorder.boxes',
                enableSorting: false,
                enableColumnMenu: false,
                headerCellFilter: 'translate',
                field: 'package_amount',
                enableFiltering: false,
                enableCellEdit: true,
                cellClass: 'editable-cell',
                width: '*',
                editableCellTemplate: ($scope.isOverBudgetPermitted)?
                'tnt/reorder/endowments/admin-edit-cell.tmpl.html' : 'tnt/reorder/endowments/edit-cell.tmpl.html'
            }, {
                displayName: 'reorder.min_lot',
                headerCellFilter: 'translate',
                field: 'minlot',
                enableFiltering: false,
                width: '*'
            }, {
                displayName: 'reorder.to_be_delivered',
                headerCellFilter: 'translate',
                field: 'to_be_delivered',
                enableFiltering: false,
                width: '*'
            }, {
                displayName: 'reorder.delivered',
                headerCellFilter: 'translate',
                field: 'delivered',
                enableFiltering: false,
                width: '*'
            }, {
                displayName: 'reorder.storage_amount',
                headerCellFilter: 'translate',
                field: 'storage_amount',
                enableFiltering: false,
                width: '*'
            }
        ]
    };

    $scope.isOrderCreationDisabled = function() {
        if($scope.gridOptions.data) {
            return ($scope.gridOptions.data.filter(function (e) {
                return e.stock_amount > 0;
            }).length == 0);
        }
        else {
            return true;
        }
    }

    $scope.getReorderInfo = function(row) {
        switch (row.reorder_type) {
            case "MINSTOCK":
            return '('+$scope.translateMsg.cell_min_stock+': '+(row.minamount || 0)+')';
            case "CONSUMED":
            return '('+$scope.translateMsg.cell_consumed+': '+(row.consumed_amount || 0)+')';
            default:
            return null;
        }
    }

    $scope.computeAmount = function(){
        console.log('--- portale aggiornato!');
        if($scope.gridOptions.data) {
            $scope.gridOptions.data.forEach(function(item){
                switch (item.reorder_type) {
                    case "MINSTOCK":
                        var realAmount = (item.storage_amount || 0) + (item.to_be_delivered || 0);
                        item.stock_amount = Math.max(0, (item.minamount || 0) - realAmount);
                        break;
                    case "CONSUMED":
                        if ($scope.isWardrobe()) {
                            item.stock_amount = Math.max(0, (item.consumed_amount || 0) - (item.to_be_delivered || 0) - (item.delivered || 0) );
                        } else {
                            item.stock_amount = (item.consumed_amount || 0);
                        }
                        break;
                    default:
                        item.stock_amount = 0;
                    break;
                }

                item.package_amount = computePackageAmount(normalize(item.stock_amount, item.minlot), item.product.quantity_included);
                if (item.package_amount > item.max_packages) {
                    item.isOverBudget = true;
                    //item.package_amount = item.max_packages; // Rimosso SDV 20/02/2019
                    item.stock_amount = item.package_amount * (item.product.quantity_included || 1);
                    if (item.minlot!=null && item.stock_amount < item.minlot) {
                        item.stock_amount = 0;
                        item.package_amount = 0;
                    }
                } else {
                    item.stock_amount = item.package_amount * (item.product.quantity_included || 1);
                }

            });
        }
    }

    $scope.$on('$resetReorder',function(){
        $scope.customerOrder.supplierOrder = undefined;
        $scope.customerOrder.supplierOrderDate = undefined;
        $scope.customerOrder.orderNote = undefined;
        $scope.customerOrder.orderReference = undefined;
        $scope.customerOrder.orderReferenceDate = undefined;
        $scope.cleanAmount();
        $scope.orderForm.$setPristine(true);
    })

    $scope.$on('$clearAmount',function(){
        $scope.cleanAmount();
    })

    $scope.$on('$computeAmount',function(){
        $scope.computeAmount();
    })

    $scope.$on('$refreshGrid',function(){
        $scope.gridOptions.data = $scope.endowment.items;
        init();
    })

    $scope.cleanAmount = function(){
        if($scope.gridOptions.data) {
            $scope.gridOptions.data.forEach(function(item){
                item.stock_amount = 0;
                item.package_amount = 0;
                item.isOverBudget = false;
            });
        }
    }

    $scope.getTooltipMessage = function(row) {
        if ($scope.isWardrobe()){
            return 'reorder.tooltip_min_packages';
        }
        if ($scope.isOverBudgetPermitted) {
            if (row.package_amount > row.max_packages) {
                return 'reorder.tooltip_over_budget';
            }
            return 'reorder.tooltip_min_packages';
        }
        return row.max_packages == 0? 'reorder.tooltip_spent_budget' : 'reorder.tooltip_limit_packages';
    }

    function normalize(amount, minValue){
        if (angular.isNumber(minValue) && amount > 0) {
            return Math.max(minValue, amount);
        }
        return amount;
    }

    function computePackageAmount(amount, amountPerPackage) {
        if (angular.isNumber(amountPerPackage) && amount > 0) {
            return Math.ceil(amount / Math.max(amountPerPackage, 1));
        }
        return amount;
    }

    function afterCellEdit(rowEntity, colDef){
      if (colDef.field === 'package_amount'){
        var realAmount = normalize(rowEntity.package_amount * (rowEntity.product.quantity_included || 1), rowEntity.minlot);
        rowEntity.package_amount = computePackageAmount(realAmount, rowEntity.product.quantity_included);
        rowEntity.stock_amount = rowEntity.package_amount * (rowEntity.product.quantity_included || 1);
      } else if (colDef.field === 'stock_amount'){
        var packages = Math.ceil(rowEntity.stock_amount / (rowEntity.product.quantity_included || 1));

        rowEntity.stock_amount = packages * (rowEntity.product.quantity_included || 1);
        rowEntity.package_amount = packages;
      }

    }

    function init(){
        console.log("Initialize ReorderEndowmentsCtrl");
        localeFactory.loadTranslation('reorder')
        .then(function(){
            $translate(['reorder.cell_min_stock', 'reorder.cell_consumed', 'op_completed_success'])
            .then(function(data){
                console.log(data);
                angular.forEach(data, function(value, key){
                    this[key.split('.').pop()] = value;
                }, $scope.translateMsg);
            }, function(error){
                console.error(error);
            });
            $scope.computeAmount();
            if ($scope.isWardrobe()) {
                $scope.gridOptions.columnDefs.splice(5,0,{
                    displayName: 'reorder.residual_budget',
                    headerCellFilter: 'translate',
                    field: 'residual_budget',
                    enableFiltering: false,
                    width: '120'
                });
            } else {
                $scope.gridOptions.columnDefs.splice(5,0,
                //   {
                //     displayName: 'budget',
                //     headerCellFilter: 'translate',
                //     field: 'budget',
                //     enableFiltering: false,
                //     width: '90'
                // },
                  {
                    displayName: 'reorder.available',
                    headerCellFilter: 'translate',
                    field: 'residual_budget',
                    enableFiltering: false,
                    width: '120'
                });
            }
        })
        .catch(function (err) {
            console.error(err);
        });
    }

});

/**
 * @ngdoc directive
 * @name ictportal.tnt.directive:tntReorderEndowments
 * @description
 * # tntReorderEndowments
 */
angular.module('ictportal.tnt')
  .directive('tntReorderEndowments', ['$log', function ($log) {
    return {
      templateUrl: 'tnt/reorder/endowments/reorder-endowments.html',
      restrict: 'E',
      scope: {
        endowment: '=',
        customerOrder: '=',
        orderType: '=',
        isWardrobe: '&',
        onSaveOrder: '&',
        isOverBudgetPermitted: "="
      },
      controller: 'TntReorderEndowmentsCtrl'
    };
  }]);

angular.module('ictportal.tnt')
    .config(function ($routeProvider) {
        $routeProvider
            .when('/tnt/reorder', {
                templateUrl: 'tnt/reorder/plant/reorder-plant.html',
                controller: 'TntReorderPlantCtrl'
            })
    })
    // Riordino da guardaroba a stabilimento
    .controller('TntReorderPlantCtrl', function ($scope, $routeParams, $translate, localeFactory,
        recordFactory, tntReorderSrv, tntDestinationSrv, toaster, $window, authFactory, $location) {

        $scope.title = 'reorder.default_title';
        $scope.routeFilter = false;
        $scope.sel = {};
        $scope.destination = undefined;
        $scope.destinations = [];
        $scope.customerOrder = {
            priority: 'NORMAL'
        };
        $scope.endowment = {};
        var msg = {};

        $scope.destinationChange = function () {
            if ($scope.sel.dest) {
                $scope.destination = $scope.sel.dest;
                var orderTypePromise;
                if ($scope.destination.is_wardrobe) {
                    $scope.title = 'reorder.default_title';
                    orderTypePromise = tntReorderSrv.loadWardrobeOrderType();
                } else {
                    $scope.title = 'reorder.to_wardrobe_title';
                    orderTypePromise = tntReorderSrv.loadWardOrderType();
                }
                orderTypePromise.then(function (orderType) {
                    $scope.orderType = orderType;
                    $scope.loadData();
                }, $scope.displayMessages)
                .catch(function (err) {
                    $scope.displayMessages(err);
                });
            } else {
                $scope.title = 'reorder.default_title';
                $scope.destination = undefined;
            }
        }

        function checkPermissions() {
            var profilingKey = 'TNT_REORDER_FUNCTION';
            var permission = authFactory.getPermissions(profilingKey);
            if(!permission.EXEC) {
                $location.path('forbidden').search({key: profilingKey});
            }
            else {
                $scope.isOverBudgetPermitted = permission.OVER_BUDGET;
            }
        };

        $scope.clearAmount = function() {
            $scope.$broadcast('$clearAmount');
        };

        $scope.computeAmount = function() {
            $scope.$broadcast('$computeAmount');
        };

        $scope.loadData = function () {
            if ($scope.destination) {
                tntReorderSrv.loadEndowments($scope.destination, false)
                .then(function (data) {
                    if (data.status == 'ok' || data.status == 'warnings') {
                        angular.extend($scope.endowment,data.result);
                        $scope.$broadcast('$refreshGrid');
                        recordFactory('customer').byId({ id: $scope.endowment.customer_id })
                            .$promise.then(function (data) {
                                $scope.customerOrder.customer = data;
                            }, function (err) {
                                console.error(err);
                                toaster.pop('error', msg.error, msg.server_comunication_error);
                            });
                        $scope.displayMessages(data.messages.filter(function (m) { return m.status != 'SUCCESS'; }));
                    } else {
                        $scope.displayMessages(data.messages);
                    }
                })
                .catch(function (err) {
                    console.error(err);
                    toaster.pop('error', msg.error, msg.server_comunication_error);
                });
            }
        };

        $scope.saveOrder = function () {
            var rows = $scope.endowment.items
                .filter(function (e) { return e.stock_amount > 0; });
            if (tntReorderSrv.validateSupplierOrder($scope.customerOrder.supplierOrder, $scope.customerOrder.supplierOrderDate)) {
            tntReorderSrv.saveOrder($scope.destination, $scope.orderType,
                $scope.customerOrder.priority, rows, $scope.customerOrder.supplierOrder,
                $scope.customerOrder.supplierOrderDate, $scope.customerOrder.orderNote,
                $scope.customerOrder.orderReference, $scope.customerOrder.orderReferenceDate)
                .then(function (data) {
                    if (data.status == 'ok') {
                        $scope.$broadcast('$resetReorder');
                        data.result.forEach(function(e){
                            toaster.pop('success', msg.op_completed_success, msg.order_created + e.co_number);
                        });
                        $window.history.back();
                    } else {
                        $scope.displayMessages(data.messages);
                    }
                }, function (err) {
                    console.error(err);
                    toaster.pop('error', msg.error, msg.server_comunication_error);
                });
            }
        };

        $scope.isWardrobe = function () {
            return true; //$scope.destination.is_wardrobe;
        };

        $scope.displayMessages = function (messages) {
            angular.forEach(messages, function (notification) {
                var params = {};
                notification.params.forEach(function (p, index) {
                    params['p' + index] = p;
                });
                var key = 'reorder.' + notification.code;
                localeFactory.translateReplace(key, params).then(function (translatedMsg) {
                    var message = (translatedMsg === key) ? notification.message : translatedMsg;
                    var status = notification.status.toLowerCase();
                    toaster.pop(status, msg[status], message);
                });
            });
        };


        (function () {
            localeFactory.loadTranslation('reorder')
                .then(function () {
                    $translate(['error', 'server_comunication_error', 'op_completed_success', 'order_created'])
                        .then(function (data) {
                            msg = data;
                        }, function (error) {
                            console.error(error);
                        })
                        .finally(function () {
                            checkPermissions();
                            if ($routeParams.destination) {
                                $scope.routeFilter = true;
                                // ROUTE FILTER
                                tntDestinationSrv.loadDestination($routeParams.destination)
                                .then(function (data) {
                                    $scope.sel.dest = data;
                                    $scope.destinationChange();
                                })
                                .catch(function (err) {
                                    $scope.displayMessages(err);
                                });
                            } else {
                                $scope.routeFilter = false;
                                // IMPLICIT FILTER
                                tntDestinationSrv.loadImplicitDestination("wardrobe")
                                .then(function (data) {
                                    $scope.destinations = data;
                                    if (data.length == 1) {
                                        $scope.sel.dest = data[0];
                                        $scope.destinationChange();
                                    }
                                }).catch(function (err) {
                                    $scope.displayMessages(err);
                                });
                            }
                        });
                });
        }());

    });

angular.module('ictportal.tnt')
.config(function ($routeProvider) {
    $routeProvider
    .when('/tnt/reorderward', {
        templateUrl: 'tnt/reorder/ward/reorder-ward.html',
        controller: 'TntReorderWardCtrl',
        resolve: {
          copysMode: function ($route) { $route.current.params.copysMode = false; }
        }
    })
    // Abilita la modalità COPYS, che fa l'opposto dell'omonimo job: copia un ordine da guardaroba a stabilimento.
    // Serve per quegli ospedali in cui lo stabilimento non esiste, ma è solo un'entità fittizzia su six.
    // E' tutto come un normale riordino da reparto a guardaroba, ma nel momento del salvataggio modifico il tipo
    // ordine in "ordine a stabilimento" e modifico la destinazione dell'ordine da guardaroba a stabilimento.
    .when('/tnt/reorderward/copys', {
        templateUrl: 'tnt/reorder/ward/reorder-ward.html',
        controller: 'TntReorderWardCtrl',
        resolve: {
            copysMode: function ($route) { $route.current.params.copysMode = true; }
        }
    })
})
// Riordino da reparto a guardaroba
.controller('TntReorderWardCtrl', function ($scope, $translate, localeFactory, authFactory,
    tntDestinationSrv, tntReorderSrv, recordFactory, toaster, $window, $location, $routeParams) {

        $scope.copysMode = false;
        $scope.ward = {};
        $scope.parentWardrobe = undefined; // Guardaroba padre del reparto corrente. Serve solo in modalità copys

        $scope.wardChange = function () {
            $scope.endowment = {};
            $scope.customerOrder = {
                priority: 'NORMAL'
            };
            console.log('ward selected', $scope.ward.selected);
            if ($scope.ward.selected) {
                // In COPYS mode, load also parent wardrobe
                console.log('copys mode', $scope.copysMode);
                if($scope.copysMode) {
                    if($scope.ward.selected.parent) {
                        tntReorderSrv.getWardrobe($scope.ward.selected.parent).then(function(data) {
                            $scope.parentWardrobe = data;
                        });
                    }
                    else {
                        toaster.pop('error', msg.error, msg.missing_parent_wardrobe);
                    }
                }
                tntReorderSrv.loadEndowments($scope.ward.selected, $scope.copysMode)
                .then(function (data) {
                    if (data.status == 'ok' || data.status == 'warnings') {
                        angular.extend($scope.endowment,data.result);
                        $scope.$broadcast('$refreshGrid');
                        recordFactory('customer').byId({ id: $scope.endowment.customer_id })
                        .$promise.then(function (data) {
                            $scope.customerOrder.customer = data;
                        }, function (err) {
                            console.error(err);
                            toaster.pop('error', msg.error, msg.server_comunication_error);
                        });
                        $scope.displayMessages(data.messages.filter(function (m) { return m.status != 'SUCCESS'; }));
                    } else {
                        $scope.displayMessages(data.messages);
                    }
                })
                .catch(function (err) {
                    console.error(err);
                    toaster.pop('error', msg.error, msg.server_comunication_error);
                });
            }
        };

        $scope.clearAmount = function() {
            $scope.$broadcast('$clearAmount');
        };

        $scope.saveOrder = function () {
            var rows = $scope.endowment.items.filter(function (e) { return e.stock_amount > 0; });
            var orderDestination = $scope.copysMode?$scope.parentWardrobe:$scope.ward.selected;
            if (tntReorderSrv.validateSupplierOrder($scope.customerOrder.supplierOrder, $scope.customerOrder.supplierOrderDate)) {
            tntReorderSrv.saveOrder(orderDestination, $scope.orderType, $scope.customerOrder.priority, rows,
                $scope.customerOrder.supplierOrder, $scope.customerOrder.supplierOrderDate, $scope.customerOrder.orderNote,
                $scope.customerOrder.orderReference, $scope.customerOrder.orderReferenceDate)
            .then(function (data) {
                console.log(data);
                if (data.status == 'ok') {
                    $scope.$broadcast('$resetReorder');
                    data.result.forEach(function(e){
                        toaster.pop('success', msg.op_completed_success, msg.order_created + e.co_number);
                    });
                    $window.history.back();
                } else {
                    $scope.displayMessages(data.messages);
                }
            }, function (err) {
                console.error(err);
                toaster.pop('error', msg.error, msg.server_comunication_error);
            });
            }
        };

        $scope.isWardrobe = function () {
            return false;
        }

        $scope.displayMessages = function (messages) {
            angular.forEach(messages, function (notification) {
                var params = {};
                if (notification.params) {
                    notification.params.forEach(function (p, index) {
                        params['p' + index] = p;
                    });
                }
                var key = 'reorder.' + notification.code;
                localeFactory.translateReplace(key, params).then(function (translatedMsg) {
                    var message = (translatedMsg === key) ? notification.message : translatedMsg;
                    var status = notification.status.toLowerCase();
                    toaster.pop(status, msg[status], message);
                });
            });
        };

        function checkPermissions() {
            var profilingKey = 'TNT_REORDER_FUNCTION';
            var permission = authFactory.getPermissions(profilingKey);
            if(!permission.EXEC) {
                $location.path('forbidden').search({key: profilingKey});
            }
            else {
                $scope.isOverBudgetPermitted = permission.OVER_BUDGET;
            }
        };

        var msg = {};
        function init() {
            $scope.copysMode = $routeParams.copysMode;
            localeFactory.loadTranslation('reorder')
            .then(function () {
                $translate(['error', 'server_comunication_error', 'op_completed_success', 'order_created', 'missing_parent_wardrobe'])
                .then(function (data) {
                    msg = data;
                }, function (error) {
                    console.error(error);
                })
                .finally(function () {
                    checkPermissions();
                    $scope.title = $scope.copysMode?'reorder.from_ward_to_deposit_title':'reorder.to_wardrobe_title';
                    var orderTypePromise = $scope.copysMode?tntReorderSrv.loadWardrobeOrderType():tntReorderSrv.loadWardOrderType();
                    orderTypePromise.then(function (data) {
                        $scope.orderType = data;
                    }).catch($scope.displayMessages);
                    tntDestinationSrv.loadImplicitWard()
                    .then(function (data) {
                        $scope.wards = data;
                        if (data.length == 1) {
                            $scope.ward.selected = data[0];
                            $scope.wardChange();
                        }
                    }).catch($scope.displayMessages);
                });
            });
        }
        init();
    });

'use strict';

angular.module('ictportal.tnt')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/tnt/goodsinward/directdelivery/:dest', {
        templateUrl: 'tnt/goods-inward/direct-delivery/direct-delivery.html',
        controller: 'tntDirectDeliveryCtrl',
      });
  }).controller('tntDirectDeliveryCtrl', function ($log, $routeParams, $scope, authFactory, dbFilterFactory, localeFactory,
                                                   recordFactory, tntGoodsInwardFactory, toaster, healthFactory, $q) {

    $scope.lastPackage = {
      barcode: undefined,
      lot: undefined,
      date: undefined
    };

    $scope.package = [];

    $scope.confimIsDisabled = true;
    $scope.barcodeReaderIsDisabled = true;
    $scope.customerDestinationId = null;
    $scope.operatorId = null;

    var status = {
      NEW: 'NEW',
      STERILIZED: 'STERILIZED',
      PACKED: 'PACKED'
    };

    var msgType = {
      error: 'error',
      info: 'info',
      success: 'success'
    };

    var msg = {
      error: 'Error',
      info: 'Info',
      success: 'Success'
    };

    var filterOptions = {
      page_size: 1000,
      page: 1
    };

    $scope.readKit = function (read) {
      // TODO step evitabile, attendere conferma lettura barcode
      tntGoodsInwardFactory.readEan128({plain: read.read}).$promise.then(function (res) {
        if (res) {
          var found = $scope.package.find(function (element) {
            return element.barcode === res.data.barcode;
          });
          if (!found) {
            var filter = dbFilterFactory.getStringFilter('envelope', res.data.barcode);
            recordFactory('serial_kit').filter(filterOptions, filter).$promise.then(function (data) {
              if (data.list && data.list.length > 0) {
                var tmp = [];
                var error = [];
                data.list.forEach(function (element) {
                  if (element.production_status == status.PACKED && element.envelope != null && element.status == status.NEW) {
                    tmp.push({
                      id: element.id,
                      barcode: element.barcode,
                      productionStatus: element.production_status
                    });
                  } else {
                    error.push(element.id);
                  }
                });
                if (error.length === 0) {
                  $scope.lastPackage.barcode = res.data.barcode;
                  $scope.lastPackage.lot = res.data.lotto;
                  $scope.lastPackage.date = (res.data.dataScadenza !== null) ? new Date(res.data.dataScadenza).toLocaleDateString() : undefined;
                  $scope.package.push({barcode: res.data.barcode, sk: tmp});
                  $scope.confimIsDisabled = false;
                } else {
                  localeFactory.translateReplace('goods_inward.kit_wrong_state', {qty: error.length}).then(function (translation) {
                    toaster.pop(msgType.error, translation);
                  });
                }
              } else {
                localeFactory.translateReplace('goods_inward.package_not_found').then(function (translation) {
                  toaster.pop(msgType.error, translation);
                });
              }
            });
          }
        } else {
          localeFactory.translateReplace('goods_inward.package_not_found').then(function (translation) {
            toaster.pop(msgType.error, translation);
          });
        }
      });
    };

    $scope.removeElement = function (element) {
      var current = element.currentTarget.value;
      var filtered = $scope.package.filter(function (value, index, arr) {
        return value.barcode != current;
      });
      $scope.package = filtered;
      $scope.confimIsDisabled = $scope.package.length <= 0;
    };

    $scope.refreshList = function () {
      $scope.package = [];
      $scope.lastPackage.barcode = undefined;
      $scope.lastPackage.lot = undefined;
      $scope.lastPackage.date = undefined;
      $scope.confimIsDisabled = true;
    };

    function convertDate(date) {
      return date.toLocaleString("en-US", {
        timeZone: 'Europe/Rome'
      })
    }

    function updateKit(syncDate, newRow) {
      var deferred = $q.defer();
      recordFactory('serial_kit_status').create(newRow).$promise.then(function (res) {
        if (!res || !res.id) {
          localeFactory.translateReplace('goods_inward.SAVE_EXCEPTION').then(function (translation) {
            toaster.pop(msgType.error, translation);
          });
        } else {
          var param = {
            status: status.STERILIZED,
            last_modified_date: syncDate,
            customer_destination: $scope.customerDestinationId,
            current_serial_kit_status_id: res.id
          };
          recordFactory('serial_kit').update({id: newRow.serial_kit_id}, param).$promise.then(function (result) {
            deferred.resolve(result);
          });
        }
      });
      return deferred.promise;
    }

    // se un ricevimento ha tutti i kit in stato diverso da NEW passa in stato DISPATCHED
    // SELECT count(t.id) count, t.id, nested.div
    //   FROM goods_inward t
    //    JOIN goods_inward_row gir ON t.id = gir.goods_inward_id
    //    JOIN serial_kit sk ON gir.id = sk.gi_row_id
    //    JOIN (SELECT gi.id AS id, count(*) AS div
    //            FROM goods_inward gi
    //            JOIN goods_inward_row gir ON gi.id = gir.goods_inward_id
    //            JOIN serial_kit sk ON gir.id = sk.gi_row_id
    //            JOIN (SELECT DISTINCT gi.id AS id
    //               FROM goods_inward gi
    //               JOIN goods_inward_row gir ON gi.id = gir.goods_inward_id
    //               JOIN serial_kit sk ON gir.id = sk.gi_row_id
    //               WHERE sk.id IN (...)) giin ON giin.id = gi.id
    //            WHERE gi.status = 'TO_DISPATCH'
    //            AND sk.status <> 'NEW'
    //            GROUP BY gi.id) nested ON t.id = nested.id
    // GROUP BY t.id, nested.div
    // HAVING count(*) - nested.div = 0
    // ORDER BY t.id ASC
    // LIMIT 1000 OFFSET 0;
    function countClosedGoodsInward(ids) {
      var deferred = $q.defer();
      var nestedQuery = "SELECT gi.id as id, count(*) as div " +
        "FROM goods_inward gi JOIN goods_inward_row gir ON gi.id = gir.goods_inward_id JOIN serial_kit sk ON gir.id = sk.gi_row_id " +
        "JOIN (SELECT DISTINCT gi.id AS id FROM goods_inward gi JOIN goods_inward_row gir ON gi.id = gir.goods_inward_id JOIN serial_kit sk ON gir.id = sk.gi_row_id " +
        "WHERE sk.id IN (" + ids.join(',') + ")) giin ON giin.id = gi.id " +
        "WHERE gi.status = 'TO_DISPATCH' AND sk.status <> 'NEW'GROUP BY gi.id";
      var filters = [{
        'column': 'goods_inward_row gir',
        'value': 't.id = gir.goods_inward_id',
        'relation': 'JOIN'
      }, {
        'column': 'serial_kit sk',
        'value': 'gir.id = sk.gi_row_id',
        'relation': 'JOIN'
      }, {
        column: '(' + nestedQuery + ') nested',
        value: 't.id = nested.id',
        relation: 'JOIN'
      }];
      recordFactory('goods_inward').aggregation({page_size: 1000}, {
        filters: filters,
        fields: ['t.id', 'nested.div'],
        operations: [{
          function: "count",
          argument: "t.id",
          alias: "count"
        }],
        having_cond: [{
          column: "count(*)-nested.div",
          kind: "number",
          relation: "=",
          value: "0"
        }]
      }).$promise.then(function (data) {
        deferred.resolve(data);
      });
      return deferred.promise;
    }

    function updateAlreadyClosed(giList) {
      var p = {
        status: 'DISPATCHED',
        last_modified_date: new Date().toLocaleString("en-US", {timeZone: 'Europe/Rome'})
      };
      giList.forEach(function (gi) {
        recordFactory('goods_inward').update({id: gi.id}, p).$promise;
      });
    }

    $scope.confirmPack = function () {
      if ($scope.package.length > 0) {
        var p = healthFactory.dateTime({}, document).$promise.then(function (data) {
          return (data) ? new Date(data['date-time']) : new Date();
        });
        $q.all([p]).then(function (result) {
          var a = [];
          var n = 0;
          var syncDate = convertDate(result[0]);
          var skIdList = [];
          $scope.package.forEach(function (element) {
            var i;
            for (i = 0; i < element.sk.length; ++i) {
              skIdList.push(element.sk[i].id);
              var newRow = {
                serial_kit_id: element.sk[i].id,
                barcode: element.sk[i].barcode,
                previous_status: status.NEW,
                status: status.STERILIZED,
                production_status: element.sk[i].productionStatus,
                operation_date: syncDate,
                customer_destination_id: $scope.customerDestinationId,
                operator_id: $scope.operatorId
              };
              a.push(updateKit(syncDate, newRow).then(function (resUpdate) {
                n = (resUpdate) ? n + 1 : n;
              }));
            }
          });
          Promise.all(a).then(function () {
            if (n > 0) {
              localeFactory.translateReplace('goods_inward.kit_updated', {qty: n}).then(function (translation) {
                toaster.pop(msgType.success, translation);
              });
              countClosedGoodsInward(skIdList).then(function (data) {
                if (data && data.totalResults > 0) {
                  updateAlreadyClosed(data.list);
                }
              });
            }
            $scope.refreshList();
          });
        });
      }
    };

    function initCustomerDestination() {
      var filter = dbFilterFactory.getStringFilter('code', $routeParams.dest);
      recordFactory('customer_destination').filter({}, filter).$promise.then(function (res) {
        if (res && res.list.length > 0) {
          $scope.customerDestinationId = res.list[0].id;
          $scope.barcodeReaderIsDisabled = false;
        } else {
          localeFactory.translateReplace('goods_inward.customer_destination_not_found', {code: $routeParams.depotCode}).then(function (translation) {
            toaster.pop(msgType.error, translation);
          });
        }
      });
    }

    function getOperator() {
      var username = authFactory.getAuthData().authId;
      var filters = [{
        "column": "human_resource o",
        "value": "o.user_id = t.id",
        "relation": "JOIN",
        "kind": "o.id AS operator_id"
      }];
      filters = filters.concat(dbFilterFactory.getStringFilter("username", username));
      recordFactory('users').filter({page_size: 10000}, filters)
        .$promise.then(function (data) {
        if (data.list && data.list.length > 0) {
          $scope.operatorId = data.list[0].operator_id;
        }
      });
    }

    function init() {
      $log.info('>>> tntDirectDeliveryCtrl');
      localeFactory.loadTranslation('portal');
      localeFactory.loadTranslation('goods_inward');
      getOperator();
      initCustomerDestination();
    }

    //___ main ___
    init();

  }
);

'use strict';

angular.module('ictportal.lm')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/lm/inventorycollected/detail', {
        templateUrl: 'lm/inventory/collected/detail/inventory-collected-detail.html',
        controller: 'inventoryCollectedDetailCtrl'
      })
      .when('/lm/inventorycollected/detail/:id', {
        templateUrl: 'lm/inventory/collected/detail/inventory-collected-detail.html',
        controller: 'inventoryCollectedDetailCtrl'
      });
  })
  .controller('inventoryCollectedDetailCtrl', function ($scope, $log, recordFactory, $routeParams, $location, $filter, eggsFormFactory,
                                             toaster, dbFilterFactory, localeFactory, authFactory, $q, $rootScope, $uibModal) {

    $scope.readOnly = false;
    $scope.newRecord = false;
    $scope.isNewAllowed = false;
    $scope.isUpdateAllowed = false;
    $scope.colorFilter = [];
    $scope.sizeFilter = [];
    $scope.result = {
      totalResults: 0,
      list: []
    };
    $scope.viewGridOptions = {
      appScopeProvider: $scope,
      columnDefs: []
    };
    $scope.params = {
      pageNumber: 1,
      pageSize: 15,
      sortFields: 't.created_date',
      sortOrder : 'asc'
    };
    $scope.record = {
      lookup: {},
      model: {},
      filter: {
        fromDate: new Date(),
        toDate: new Date(),
        list: []
      },
    };
    $scope.row = null;
    var timestamp = new Date();
    var authData = authFactory.getAuthData();
    var msg = {
      'error': 'Error',
      'warehouse': 'Warehouse',
      'product': 'Product',
      'color': 'Color',
      'size': 'Size',
      'quantity': 'Quantity'
    };
    var pageMsg = {
      'title': 'Inventory',
      'missing_data': 'Missing data'
    };

    $scope.goToList = function () {
      $location.path('/lm/inventorycollected/list');
    };

    var initGridColumns = function () {
      $scope.viewGridOptions.columnDefs.push({
        name: 'Magazzino',
        width: '****',
        field: 'warehouse',
        translation: 'warehouse',
        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.facility_code }} - {{ row.entity.facility_description }}</div>',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Articolo',
        width: '****',
        field: 'product',
        translation: 'product',
        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.product_code }} - {{ row.entity.product_description }}</div>',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Taglia',
        width: '**',
        field: 'size',
        translation: 'size',
        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.size_code }} - {{ row.entity.size_description }}</div>',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Colore',
        width: '**',
        field: 'color',
        translation: 'color',
        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.color_code }} - {{ row.entity.color_description }}</div>',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        name: 'Quantità',
        width: '**',
        field: 'amount_detected',
        translation: 'quantity',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: '#',
        width: '*',
        translation: 'operation',
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
          '<div class=row" style="text-align: center">' +
          "<button ng-if=\"(row.entity.registered != 'T')\" ng-click=\"grid.appScope.delete(row.entity)\" class=\"btn btn-xs btn-danger\"><span class=\"fa fa-trash\"></span></button>" +
          "<button ng-if=\"(row.entity.registered == 'T')\" class=\"btn btn-xs btn-success\"><span class=\"fa fa-registered\"></span></button>" +
          '</div>'
      });
    };

    $scope.$watchGroup([
      'record.filter.fromDate',
      'record.filter.toDate'
    ], function () {
      $scope.applyFilter();
    });

    function getFormattedDate(myDate, days) {
      var inc = days ? days : 0;
      return "'" + myDate.getFullYear() + "-" + (myDate.getMonth() + 1) + "-" + (myDate.getDate() + inc) + "'";
    }

    function daysForward(myDate, inc) {
      return new Date(getFormattedDate(myDate, inc));
    }

    $scope.applyFilter = function () {
      $scope.record.filter.list.length = 0;
      if ($scope.record.filter.fromDate) {
        var f = dbFilterFactory.getDateFilter('t.created_date', $scope.record.filter.fromDate, '>=');
        $scope.record.filter.list = $scope.record.filter.list.concat(f);
      }
      if ($scope.record.filter.toDate) {
        var f = dbFilterFactory.getDateFilter('t.created_date', daysForward($scope.record.filter.toDate, 1), '<=');
        $scope.record.filter.list = $scope.record.filter.list.concat(f);
      }
      $scope.getData();
    };

    $scope.getData = function() {
      var queryParameters = {
        page: $scope.params.pageNumber,
        page_size: $scope.params.pageSize,
        sort_fields: $scope.params.sortFields,
        sort_order: $scope.params.sortOrder
      };
      var filters = [{
        column: 'facility f',
        value: 't.facility_id = f.id',
        relation: 'JOIN',
        kind: 'f.code facility_code, f.description facility_description'
      }, {
        column: 'product p',
        value: 't.product_id = p.id',
        relation: 'JOIN',
        kind: 'p.code product_code, p.description product_description'
      }, {
        column: 'color c',
        value: 't.color_id = c.id',
        relation: 'JOIN',
        kind: 'c.code color_code, c.description color_description'
      }, {
        column: 'tab_size s',
        value: 't.size_id = s.id',
        relation: 'JOIN',
        kind: 's.code size_code, s.description size_description'
      }, {
        column: 'registered',
        value: 'F',
        relation: '='
      }];
      filters = filters.concat($scope.record.filter.list);
      recordFactory('inventory_collected').filter(queryParameters, filters).$promise.then(function (data) {
          $scope.viewGridOptions.totalItems = data.totalResults;
          $scope.result.totalResults = data.totalResults;
          $scope.result.list = data.list;
      });
    };

    function prepareInventoryCollectedToSave() {
      var date = new Date();
      return {
        'azcod': authData.info.azCod,
        'divcod': authData.info.divCod,
        'created_date': date,
        'created_user_id': authData.info.userId,
        'first_collection_date': timestamp,
        'last_collection_date': date,
        'registered': 'F',
        'facility_id': $scope.record.model.warehouse,
        'product_id': $scope.record.model.product,
        'size_id': $scope.record.model.size,
        'color_id': $scope.record.model.color,
        'amount_detected': $scope.record.model.quantity
      };
    }

    $scope.saveRow = function() {
      // taglia e colore non obbligatori
      if ($scope.record.model.product && $scope.record.model.warehouse && $scope.record.model.quantity) {
        recordFactory('inventory_collected').create(prepareInventoryCollectedToSave()).$promise.then(function (res) {
          if (res.id) {
            $scope.getData();
          } else {
            toaster.pop('error', msg.error);
          }
        });
      } else {
        toaster.pop('error', msg.error, pageMsg.missing_data);
      }
    };

    $scope.delete = function (row) {
      $scope.row = row;
      $scope.confirm = $uibModal.open({
        animation: true,
        scope: $scope,
        templateUrl: 'lm/inventory/collected/deletion-confirm.html',
        size: '1000'
      });
    };

    function deleteData() {
      recordFactory('inventory_collected').delete({id: $scope.row.id}).$promise.then( function () {
        $scope.getData();
      });
    }

    function closeConfirm() {
      $scope.row = null;
      $scope.confirm.close();
    }
    $scope.ok = function () {
      deleteData();
      closeConfirm();
    };

    $scope.cancel = function () {
      closeConfirm();
    };

    $scope.$watch('record.lookup.product.obj', function (newValue) {
      if (newValue) {
        $scope.sizeFilter = dbFilterFactory.getNumberFilter('size_type_id', $scope.record.lookup.product.obj.size_type_id ? $scope.record.lookup.product.obj.size_type_id : -1);
        $scope.colorFilter = dbFilterFactory.getNumberFilter('color_type_id', $scope.record.lookup.product.obj.color_type_id ? $scope.record.lookup.product.obj.color_type_id : -1);
      }
    });

    function loadDocument(model) {
      angular.extend($scope.record.model, model);
      eggsFormFactory.loadLookupData($scope.record.lookup, $scope.record.model);
    }

    function getInventoryCollected(id) {
      recordFactory('inventory_collected').byId({id: id}).$promise.then(function (response) {
        loadDocument(response);
      });
    }

    function initLookups() {
      eggsFormFactory.addLookup($scope.record.lookup, 'product', 'product', 'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'warehouse', 'facility', 'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'color', 'color', 'code', 'description');
      eggsFormFactory.addLookup($scope.record.lookup, 'size', 'tab_size', 'code', 'description');
    }

    function checkPermissions() {
      var profilingKey = 'INVENTORY_COLLECTED_FUNCTION';
      var permission = authFactory.getPermissions(profilingKey);
      if(!permission.EXEC) {
        $location.path('forbidden').search({key: profilingKey});
      } else {
        $scope.isNewAllowed = permission.NEW;
        $scope.isUpdateAllowed = permission.UPDATE;
      }
    }

    function init() {
      checkPermissions();
      localeFactory.loadTranslation('inventory');
      initLookups();
      initGridColumns();
      if ($routeParams && (typeof $routeParams.id !== 'undefined')) {
        getInventoryCollected($routeParams.id);
        $scope.readOnly = true;
        $scope.newRecord = false;
      }
    }

    function translateGridColumns() {
      $scope.viewGridOptions.columnDefs.forEach(function (col) {
        if (col.translation) {
          if (pageMsg[col.translation]) {
            col.name = pageMsg[col.translation];
          } else {
            col.name = msg[col.translation];
          }
        }
      });
    }

    $rootScope.$on('$translateRefreshEnd', function () {
      $q.all({
        general: localeFactory.translateMsg(msg),
        specific: localeFactory.translateMsg(pageMsg, 'inventory')
      })
        .then(function () {
          $scope.functionTitle = pageMsg.title;
          translateGridColumns();
        })
        .catch(function (error) {
          $log.error(error);
        });
    });

    //___ main ___
    init();

  });

'use strict';

angular.module('ictportal.lm')
  .config(function ($routeProvider) {
    $routeProvider
      .when('/lm/inventorycollected/list', {
        templateUrl: 'lm/inventory/collected/list/inventory-collected-list.html',
        controller: 'inventoryCollectedListCtrl'
      });
  })
  .controller('inventoryCollectedListCtrl', function ($scope, $timeout, recordFactory, $routeParams, $location, authFactory, $rootScope,
                                                 parseSchemaService, dbFilterFactory, localeFactory, $q, toaster, eggsFormFactory,
                                                 $log, $uibModal, inventoryItemSrv) {
    $scope.params = {
      pageNumber: 1,
      pageSize: 15,
      sortFields: 't.created_date',
      sortOrder : 'asc'
    };
    $scope.result = {};
    $scope.viewGridOptions = {
      appScopeProvider: $scope,
      columnDefs: []
    };
    $scope.advFilter = {
      filter: {
        toDate: new Date(),
        type: 'all'
      },
      list: []
    };
    $scope.enum = {
      type: [
        {
          name: 'All',
          value: 'all'
        }, {
          name: 'Different',
          value: 'different'
        }, {
          name: 'Equal',
          value: 'equal'
        }
      ]
    };
    var authData = authFactory.getAuthData();
    var msg = {
      'warehouse': 'Warehouse',
      'product': 'Product',
      'color': 'Color',
      'size': 'Size',
      'quantity': 'Quantity',
      'operation_completed': 'Operation completed',
    };

    var pageMsg = {
      'title': 'Inventory',
      'stock': 'Stock',
      'all': 'All',
      'different': 'Different',
      'equal': 'Equal',
      'missing_reasons': 'The warehouse reasons for the following system parameters are missing',
      'missing_reason': 'Control reason not set'
    };

    $scope.$watchGroup([
      'advFilter.filter.facility',
      'advFilter.filter.product',
      'advFilter.filter.color',
      'advFilter.filter.size',
      'advFilter.filter.toDate',
      'advFilter.filter.type'
    ], function () {
      $scope.applyFilter();
    });

    $scope.applyFilter = function () {
      $scope.advFilter.list.length = 0;
      if ($scope.advFilter.filter.facility) {
        $scope.advFilter.list = $scope.advFilter.list.concat(dbFilterFactory.getNumberFilter('t.facility_id', $scope.advFilter.filter.facility));
      }
      if ($scope.advFilter.filter.product) {
        $scope.advFilter.list = $scope.advFilter.list.concat(dbFilterFactory.getNumberFilter('t.product_id', $scope.advFilter.filter.product));
      }
      if ($scope.advFilter.filter.color) {
        $scope.advFilter.list = $scope.advFilter.list.concat(dbFilterFactory.getNumberFilter('t.color_id', $scope.advFilter.filter.color));
      }
      if ($scope.advFilter.filter.size) {
        $scope.advFilter.list = $scope.advFilter.list.concat(dbFilterFactory.getNumberFilter('t.size_id', $scope.advFilter.filter.size));
      }
      $scope.getData();
    };

    var initGridColumns = function () {
      $scope.viewGridOptions.columnDefs.push({
        width: '****',
        name: 'Magazzino',
        field: 'facility_code',
        translation: 'warehouse',
        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.facility_code }} - {{ row.entity.facility_description }}</div>',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        width: '****',
        name: 'Articolo',
        field: 'product_code',
        translation: 'product',
        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.product_code }} - {{ row.entity.product_description }}</div>',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        width: '**',
        name: 'Taglia',
        field: 'size_code',
        translation: 'size',
        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.size_code }} - {{ row.entity.size_description }}</div>',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        width: '**',
        name: 'Colore',
        field: 'color_code',
        translation: 'color',
        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.color_code }} - {{ row.entity.color_description }}</div>',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        width: '*',
        name: 'Quantità',
        field: 'amount_detected',
        translation: 'quantity',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        width: '*',
        name: 'Giacenza',
        field: 'stock',
        translation: 'stock',
        enableFiltering: false
      });
      $scope.viewGridOptions.columnDefs.push({
        name: '',
        field: '#',
        width: '**',
        translation: 'operation',
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate:
          '<div class=row" style="text-align: center">' +
          '<button ng-click="grid.appScope.inventory(row.entity)" class="btn btn-xs btn-success"><span class="fa fa-check"></span></button>&nbsp;&nbsp;&nbsp;' +
          '<button ng-click="grid.appScope.correction(row.entity)" class="btn btn-xs btn-info"><span class="fa fa-times"></span></button>&nbsp;&nbsp;&nbsp;' +
          '<button ng-click="grid.appScope.delete(row.entity)" class="btn btn-xs btn-danger"><span class="fa fa-trash"></span></button>&nbsp;&nbsp;&nbsp;' +
          '</div>'
      });
    };

    function closeConfirm() {
      $scope.row = null;
      if($scope.confirm) {
        $scope.confirm.close();
      } else if($scope.correctionConfirm) {
        $scope.correctionConfirm.close();
      } else if ($scope.inventoryConfirm) {
        $scope.inventoryConfirm.close();
      }
    }

    function prepareInventoryCollected(reasonId, diff) {
      return {
        'azcod': authData.info.azCod,
        'divcod': authData.info.divCod,
        'created_user_id': authData.info.userId,
        'facility_id': $scope.row.facility_id,
        'product_id': $scope.row.product_id,
        'inventory_reason_id': reasonId,
        'color_id': $scope.row.color_id,
        'size_id': $scope.row.size_id,
        'quantity_on_hand_diff': diff,
        'effective_date': new Date(Date.parse($scope.advFilter.filter.toDate))
      };
    }

    function registeredBody() {
      return {
        'registered': 'T',
        'last_modified_date': new Date(),
        'last_modified_user_id': authData.info.userId
      };
    }

    $scope.inventory = function (row) {
      if (!$scope.reason.list[0].value || !$scope.reason.list[1].value) {
        closeConfirm();
        toaster.pop('error', msg.error, pageMsg.missing_reason);
      } else {
        $scope.row = row;
        $scope.inventoryConfirm = $uibModal.open({
          animation: true,
          scope: $scope,
          templateUrl: 'lm/inventory/collected/list/inventory-confirm.html',
          size: '1000'
        });
      }
    };

    $scope.doInventoryMov = function() {
      // Devo fare un doppio movimento di magazzino
      // il primo di chiusura: di quantità -(giacenza calcolata)
      // causale: INVENTORY_REASON_INVENTORY_CLOSE (1)
      // il secondo di apertura: con la quantità rilevata
      // INVENTORY_REASON_INVENTORY_OPEN (0)
      inventoryItemSrv.newFromInventoryCollected(prepareInventoryCollected($scope.reason.list[1].value, -$scope.row.stock)).then(function (ids) {
        if (ids && ids.inventoryItem != null && ids.inventoryItemDetail) {
          inventoryItemSrv.newFromInventoryCollected(prepareInventoryCollected($scope.reason.list[0].value, $scope.row.amount_detected)).then(function (ids2) {
            $log.info(ids2);
            if (ids2 && ids2.inventoryItem != null && ids2.inventoryItemDetail) {
              // inseriti i 2 movimenti settare a T (TRUE) il campo 'registered'
              recordFactory('inventory_collected').update({id: $scope.row.id}, registeredBody()).$promise.then(function (resUpdate) {
                $log.info(resUpdate);
                if (resUpdate && resUpdate.updated == 1) {
                  closeConfirm();
                  $scope.getData();
                  toaster.pop('success', msg.operation_completed);
                } else {
                  closeConfirm();
                  toaster.pop('error', msg.error, msg.error);
                }
              });
            } else {
              closeConfirm();
              toaster.pop('error', msg.error, msg.error);
            }
          });
        } else {
          closeConfirm();
          toaster.pop('error', msg.error, msg.error);
        }
      });
    };

    $scope.correction = function (row) {
      if (!$scope.reason.list[2].value || !$scope.reason.list[3].value) {
        closeConfirm();
        toaster.pop('error', msg.error, pageMsg.missing_reason);
      } else {
        $scope.row = row;
        $scope.correctionConfirm = $uibModal.open({
          animation: true,
          scope: $scope,
          templateUrl: 'lm/inventory/collected/list/correction-confirm.html',
          size: '1000'
        });
      }
    };

    $scope.doCorrectionMov = function () {
      // Devo fare un movimento magazzino solo di rettifica,
      // positiva se la giacenza rilevata è maggiore di quella calcolata, negativa altrimenti
      var diff = $scope.row.amount_detected - $scope.row.stock;
      // R+ 2: INVENTORY_REASON_POSITIVE_CORRECTION
      // R- 3: INVENTORY_REASON_NEGATIVE_CORRECTION
      var reasonId = (diff > 0) ? $scope.reason.list[2].value : $scope.reason.list[3].value;
      inventoryItemSrv.newFromInventoryCollected(prepareInventoryCollected(reasonId, diff)).then(function (ids) {
        if (ids && ids.inventoryItem != null && ids.inventoryItemDetail) {
          // inserito il movimento settare a T (TRUE) il campo 'registered'
          recordFactory('inventory_collected').update({id: $scope.row.id}, registeredBody()).$promise.then(function (resUpdate) {
            if (resUpdate && resUpdate.updated == 1) {
              closeConfirm();
              $scope.getData();
              toaster.pop('success', msg.operation_completed);
            } else {
              closeConfirm();
              toaster.pop('error', msg.error, msg.error);
            }
          });
        } else {
          closeConfirm();
          toaster.pop('error', msg.error, msg.error);
        }
      });
    };

    $scope.delete = function (row) {
      $scope.row = row;
      $scope.confirm = $uibModal.open({
        animation: true,
        scope: $scope,
        templateUrl: 'lm/inventory/collected/deletion-confirm.html',
        size: '1000'
      });
    };

    function deleteData() {
      recordFactory('inventory_collected').delete({id: $scope.row.id}).$promise.then( function () {
        $scope.getData();
      });
    }

    $scope.ok = function () {
      deleteData();
      closeConfirm();
    };

    $scope.cancel = function () {
      closeConfirm();
    };

    function translateGridColumns() {
      $scope.viewGridOptions.columnDefs.forEach(function (col) {
        if (col.translation) {
          if (pageMsg[col.translation]) {
            col.name = pageMsg[col.translation];
          } else {
            col.name = msg[col.translation];
          }
        }
      });
    }

    function getFormattedDate(myDate, days) {
      var inc = days ? days : 0;
      return "'" + myDate.getFullYear() + "-" + (myDate.getMonth() + 1) + "-" + (myDate.getDate() + inc) + "'";
    }

    $scope.getData = function () {
      var queryParameters = {
        page: $scope.params.pageNumber,
        page_size: $scope.params.pageSize,
        sort_fields: $scope.params.sortFields,
        sort_order: $scope.params.sortOrder
      };
      var nestedQuery = // only for bravehearts
        'SELECT sum(coalesce(iid.quantity_on_hand_diff, 0)) stock, ' +
        'f.id  AS fid, p.id  AS pid, co.id AS coid, si.id AS siid ' +
        'FROM inventory_item t ' +
        'LEFT JOIN facility f ON t.facility_id = f.id ' +
        'LEFT JOIN product p ON t.product_id = p.id ' +
        'LEFT JOIN inventory_item_detail iid ON iid.inventory_item_id = t.id ' +
        'LEFT JOIN color co ON iid.color_id = co.id ' +
        'LEFT JOIN tab_size si ON iid.size_id = si.id ' +
        'WHERE iid.effective_date <= ' + getFormattedDate($scope.advFilter.filter.toDate, 1) + ' ' +
        'GROUP BY f.id, p.id, co.id, si.id';
      var having = 'amount_detected - coalesce(nested.stock,0)';
      switch ($scope.advFilter.filter.type) {
        case 'different':
          having = having + ' != 0';
          break;
        case 'equal':
          having = having + ' = 0';
          break;
        default:
          having = '1=1';
      }
      var filters = [
        {
          column: 'facility f',
          value: 't.facility_id = f.id',
          relation: 'JOIN',
          kind: 'f.code facility_code, f.description facility_description'
        }, {
          column: 'product p',
          value: 't.product_id = p.id',
          relation: 'JOIN',
          kind: 'p.code product_code, p.description product_description'
        }, {
          column: 'color co',
          value: 't.color_id = co.id',
          relation: 'JOIN',
          kind: 'co.code color_code, co.description color_description'
        }, {
          column: 'tab_size si',
          value: 't.size_id = si.id',
          relation: 'JOIN',
          kind: 'si.code size_code, si.description size_description'
        }, {
          column: '(' + nestedQuery + ') nested',
          value: 'nested.fid = t.facility_id AND nested.pid = t.product_id ' +
            'AND (nested.coid = t.color_id OR (t.color_id IS NULL AND nested.coid IS NULL)) ' +
            'AND (nested.siid = t.size_id OR (t.size_id IS NULL AND nested.siid IS NULL))',
          relation: 'JOIN',
          kind: 'coalesce(nested.stock,0) stock'
        }
      ];
      filters = filters.concat($scope.advFilter.list).concat(dbFilterFactory.getCustomFilter(having)).concat(dbFilterFactory.getStringFilter('t.registered', 'F'));
      recordFactory('inventory_collected').filter(queryParameters, filters).$promise.then(function (data) {
        $scope.viewGridOptions.totalItems = data.totalResults;
        $scope.result.totalResults = data.totalResults;
        $scope.result.list = data.list;
      });
    };

    $scope.viewDetail = function (value) {
      $location.path('/lm/inventorycollected/detail/' + value.id);
    };

    $scope.goToNew = function () {
      $location.path('/lm/inventorycollected/detail');
    };

    $rootScope.$on('$translateRefreshEnd', function () {
      $q.all({
        general: localeFactory.translateMsg(msg),
        specific: localeFactory.translateMsg(pageMsg, 'inventory')
      })
        .then(function () {
          $scope.functionTitle = pageMsg.title;
          $scope.enum.type.forEach(function (val) {
            val.name = pageMsg[val.value];
          });
          translateGridColumns();
        })
        .catch(function (error) {
          $log.error(error);
        });
    });

    function initLookups() {
      $scope.lookup = {};
      eggsFormFactory.addLookup($scope.lookup, 'product', 'product', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'facility', 'facility', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'color', 'color', 'code', 'description');
      eggsFormFactory.addLookup($scope.lookup, 'size', 'tab_size', 'code', 'description');
    }

    $scope.isNewAllowed = false;
    $scope.isDetailAllowed = false;
    function checkPermissions() {
      var profilingKey = 'INVENTORY_COLLECTED_FUNCTION';
      var permission = authFactory.getPermissions(profilingKey);
      if(!permission.EXEC) {
        $location.path('forbidden').search({key: profilingKey});
      } else {
        $scope.isNewAllowed = permission.NEW;
        $scope.isDetailAllowed = permission.DETAIL;
      }
    }

    // key: nomi su ConfPar
    $scope.reason = {
      list: [{
        key: 'INVENTORY_REASON_INVENTORY_OPEN',
        value: null
      }, {
        key: 'INVENTORY_REASON_INVENTORY_CLOSE',
        value: null
      }, {
        key: 'INVENTORY_REASON_POSITIVE_CORRECTION',
        value: null
      },  {
        key: 'INVENTORY_REASON_NEGATIVE_CORRECTION',
        value: null
      }],
      message: ''
    };

    function getReasons() {
      var deferred = $q.defer();
      var b = [];
      $scope.reason.list.forEach(function (e) {
        b.push("'" + e.key + "'");
      });
      var nested = 'SELECT value AS value, name AS description FROM confpar cp WHERE cp.name IN (' + b + ')';
      var f = [{
        column: '(' + nested + ') confpar',
        value: 'confpar.value = t.code',
        kind: 'confpar.description as cp_key',
        relation: 'JOIN',
        finer: 'INNER'
      }];
      recordFactory('inventory_reason').filter({}, f).$promise.then(function (data) {
        if (data && data.list && data.list.length > 0) {
          data.list.forEach(function (e) {
            $scope.reason.list.forEach(function (k) {
              if (k.key == e.cp_key) {
                k.value = e.id;
              }
            });
          });
        }
        $scope.reason.list.forEach(function (e) {
          if (!e.value) {
            $scope.reason.message = $scope.reason.message + ' [' + e.key + ']';
          }
        });
        deferred.resolve($scope.reason);
      });
      return deferred.promise;
    }

    function init() {
      checkPermissions();
      localeFactory.loadTranslation('inventory');
      getReasons();
      initLookups();
      initGridColumns();
    }

    //___ main ___
    init();

  });

angular.module("ictportal").run(["$templateCache", function($templateCache) {$templateCache.put("404.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><title>Page Not Found :(</title><style>\n      ::-moz-selection {\n        background: #b3d4fc;\n        text-shadow: none;\n      }\n\n      ::selection {\n        background: #b3d4fc;\n        text-shadow: none;\n      }\n\n      html {\n        padding: 30px 10px;\n        font-size: 20px;\n        line-height: 1.4;\n        color: #737373;\n        background: #f0f0f0;\n        -webkit-text-size-adjust: 100%;\n        -ms-text-size-adjust: 100%;\n      }\n\n      html,\n      input {\n        font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n      }\n\n      body {\n        max-width: 500px;\n        _width: 500px;\n        padding: 30px 20px 50px;\n        border: 1px solid #b3b3b3;\n        border-radius: 4px;\n        margin: 0 auto;\n        box-shadow: 0 1px 10px #a7a7a7, inset 0 1px 0 #fff;\n        background: #fcfcfc;\n      }\n\n      h1 {\n        margin: 0 10px;\n        font-size: 50px;\n        text-align: center;\n      }\n\n      h1 span {\n        color: #bbb;\n      }\n\n      h3 {\n        margin: 1.5em 0 0.5em;\n      }\n\n      p {\n        margin: 1em 0;\n      }\n\n      ul {\n        padding: 0 0 0 40px;\n        margin: 1em 0;\n      }\n\n      .container {\n        max-width: 380px;\n        _width: 380px;\n        margin: 0 auto;\n      }\n\n      /* google search */\n\n      #goog-fixurl ul {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n      }\n\n      #goog-fixurl form {\n        margin: 0;\n      }\n\n      #goog-wm-qt,\n      #goog-wm-sb {\n        border: 1px solid #bbb;\n        font-size: 16px;\n        line-height: normal;\n        vertical-align: top;\n        color: #444;\n        border-radius: 2px;\n      }\n\n      #goog-wm-qt {\n        width: 220px;\n        height: 20px;\n        padding: 5px;\n        margin: 5px 10px 0 0;\n        box-shadow: inset 0 1px 1px #ccc;\n      }\n\n      #goog-wm-sb {\n        display: inline-block;\n        height: 32px;\n        padding: 0 10px;\n        margin: 5px 0 0;\n        white-space: nowrap;\n        cursor: pointer;\n        background-color: #f5f5f5;\n        background-image: -webkit-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        background-image: -moz-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        background-image: -ms-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        background-image: -o-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        *overflow: visible;\n        *display: inline;\n        *zoom: 1;\n      }\n\n      #goog-wm-sb:hover,\n      #goog-wm-sb:focus {\n        border-color: #aaa;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n        background-color: #f8f8f8;\n      }\n\n      #goog-wm-qt:hover,\n      #goog-wm-qt:focus {\n        border-color: #105cb6;\n        outline: 0;\n        color: #222;\n      }\n\n      input::-moz-focus-inner {\n        padding: 0;\n        border: 0;\n      }\n    </style></head><body><div class=\"container\"><img src=\"logo.png\"><h1>Not found <span>:(</span></h1><p>Sorry, but the page you were trying to view does not exist.</p><p>It looks like this was the result of either:</p><ul><li>a mistyped address</li><li>an out-of-date link</li></ul><script>\n        var GOOG_FIXURL_LANG = (navigator.language || \'\').slice(0,2),GOOG_FIXURL_SITE = location.host;\n      </script><script src=\"//linkhelp.clients.google.com/tbproxy/lh/wm/fixurl.js\"></script></div></body></html>");
$templateCache.put("index.html","<!doctype html><html class=\"no-js\"><head><meta charset=\"utf-8\"><title>ICT-PORTAL</title><meta name=\"description\" content=\"\"><meta name=\"viewport\" content=\"width=device-width, initial-scale=1, maximum-scale=1\"><meta name=\"google\" content=\"notranslate\"><link rel=\"stylesheet\" href=\"bower_components/pickadate/lib/themes/default.css\"><link rel=\"stylesheet\" href=\"bower_components/pickadate/lib/themes/default.date.css\"><link rel=\"stylesheet\" href=\"bower_components/pickadate/lib/themes/default.time.css\"><link rel=\"stylesheet\" href=\"bower_components/angular-ui-grid/ui-grid.css\"><link rel=\"stylesheet\" href=\"bower_components/angular-ui-grid/ui-grid.min.css\"><link rel=\"stylesheet\" href=\"bower_components/angular-ui-select/dist/select.css\"><link rel=\"stylesheet\" href=\"bower_components/angular-ui-tree/dist/angular-ui-tree.css\"><link rel=\"stylesheet\" href=\"bower_components/angularjs-toaster/toaster.css\"><link rel=\"stylesheet\" href=\"bower_components/animate.css/animate.css\"><link rel=\"stylesheet\" href=\"bower_components/bootstrap/dist/css/bootstrap.css\"><link rel=\"stylesheet\" href=\"bower_components/fontawesome/css/font-awesome.css\"><link rel=\"stylesheet\" href=\"bower_components/ngDialog/css/ngDialog.css\"><link rel=\"stylesheet\" href=\"bower_components/ngDialog/css/ngDialog-theme-default.css\"><link rel=\"stylesheet\" href=\"bower_components/simple-line-icons/css/simple-line-icons.css\"><link rel=\"stylesheet\" href=\"bower_components/seiyria-bootstrap-slider/dist/css/bootstrap-slider.css\"><link rel=\"stylesheet\" href=\"bower_components/angular-gantt/assets/angular-gantt.css\"><link rel=\"stylesheet\" href=\"bower_components/angular-gantt/assets/angular-gantt-plugins.css\"><link rel=\"stylesheet\" href=\"bower_components/angular-loading-bar/build/loading-bar.css\"><link rel=\"stylesheet\" href=\"bower_components/ng-tags-input/ng-tags-input.css\"></head><body class=\"{{$root.bodyClass}}\" id=\"scroll-top-target\" ng-app=\"ictportal\"><div ng-view=\"\" class=\"view-frame\" ng-if=\"$root.bodyClass == \'login-six\'\"></div><div ng-controller=\"AppCtrl\" data-ng-include=\"\'theme/app.html\'\" ng-class=\"{\'app-header-fixed\':app.settings.headerFixed, \'app-aside-fixed\':app.settings.asideFixed, \'app-aside-folded\':app.settings.asideFolded, \'app-aside-dock\':app.settings.asideDock, \'container\':app.settings.container, \'touch\':app.touch}\" class=\"app app-header-fixed\" ng-if=\"$root.bodyClass != \'login-six\'\"></div><script src=\"bower_components/jquery/dist/jquery.js\"></script><script src=\"bower_components/angular/angular.js\"></script><script src=\"bower_components/angular-animate/angular-animate.js\"></script><script src=\"bower_components/angular-bootstrap/ui-bootstrap-tpls.js\"></script><script src=\"bower_components/angular-cookies/angular-cookies.js\"></script><script src=\"bower_components/blob-polyfill/Blob.js\"></script><script src=\"bower_components/file-saver.js/FileSaver.js\"></script><script src=\"bower_components/angular-file-saver/src/file-saver.js\"></script><script src=\"bower_components/angular-i18n/angular-locale_it-it.js\"></script><script src=\"bower_components/angular-local-storage/dist/angular-local-storage.js\"></script><script src=\"bower_components/angular-resource/angular-resource.js\"></script><script src=\"bower_components/angular-route/angular-route.js\"></script><script src=\"bower_components/angular-sanitize/angular-sanitize.js\"></script><script src=\"bower_components/tv4/tv4.js\"></script><script src=\"bower_components/objectpath/lib/ObjectPath.js\"></script><script src=\"bower_components/angular-schema-form/dist/schema-form.js\"></script><script src=\"bower_components/angular-schema-form/dist/bootstrap-decorator.js\"></script><script src=\"bower_components/pickadate/lib/picker.js\"></script><script src=\"bower_components/pickadate/lib/picker.date.js\"></script><script src=\"bower_components/pickadate/lib/picker.time.js\"></script><script src=\"bower_components/angular-schema-form-datepicker/bootstrap-datepicker.min.js\"></script><script src=\"bower_components/angular-schema-form-sixformula/angular-schema-form-sixformula.min.js\"></script><script src=\"bower_components/angular-schema-form-sixlookup/angular-schema-form-sixlookup.js\"></script><script src=\"bower_components/angular-schema-form-sixinherit/angular-schema-form-sixinherit.min.js\"></script><script src=\"bower_components/angular-touch/angular-touch.js\"></script><script src=\"bower_components/angular-translate/angular-translate.js\"></script><script src=\"bower_components/angular-translate-loader-static-files/angular-translate-loader-static-files.js\"></script><script src=\"bower_components/angular-translate-storage-cookie/angular-translate-storage-cookie.js\"></script><script src=\"bower_components/angular-translate-storage-local/angular-translate-storage-local.js\"></script><script src=\"bower_components/ace-builds/src-min-noconflict/ace.js\"></script><script src=\"bower_components/ace-builds/src-min-noconflict/mode-json.js\"></script><script src=\"bower_components/angular-ui-ace/ui-ace.js\"></script><script src=\"bower_components/angular-ui-grid/ui-grid.js\"></script><script src=\"bower_components/angular-ui-grid/ui-grid.min.js\"></script><script src=\"bower_components/angular-ui-select/dist/select.js\"></script><script src=\"bower_components/angular-ui-tree/dist/angular-ui-tree.js\"></script><script src=\"bower_components/angular-websocket/angular-websocket.min.js\"></script><script src=\"bower_components/angularjs-toaster/toaster.js\"></script><script src=\"bower_components/bootstrap/dist/js/bootstrap.js\"></script><script src=\"bower_components/canvg/dist/canvg.bundle.js\"></script><script src=\"bower_components/canvg/dist/canvg.bundle.min.js\"></script><script src=\"bower_components/csv-js/csv.js\"></script><script src=\"bower_components/d3/d3.js\"></script><script src=\"bower_components/d3-tip/index.js\"></script><script src=\"bower_components/html2canvas/build/html2canvas.js\"></script><script src=\"bower_components/js-xlsx/dist/xlsx.full.min.js\"></script><script src=\"bower_components/ngDialog/js/ngDialog.js\"></script><script src=\"bower_components/screenfull/dist/screenfull.js\"></script><script src=\"bower_components/six-framework/dist/six-framework.js\"></script><script src=\"bower_components/six-menu/dist/six-menu.js\"></script><script src=\"bower_components/six-toolbar/dist/six-toolbar.js\"></script><script src=\"bower_components/seiyria-bootstrap-slider/dist/bootstrap-slider.js\"></script><script src=\"bower_components/angular-bootstrap-slider/slider.js\"></script><script src=\"bower_components/angular-ui-scroll/dist/ui-scroll.js\"></script><script src=\"bower_components/angular-ui-scrollpoint/dist/scrollpoint.js\"></script><script src=\"bower_components/angular-ui-event/dist/event.js\"></script><script src=\"bower_components/angular-ui-mask/dist/mask.js\"></script><script src=\"bower_components/angular-ui-validate/dist/validate.js\"></script><script src=\"bower_components/angular-ui-indeterminate/dist/indeterminate.js\"></script><script src=\"bower_components/angular-ui-uploader/dist/uploader.js\"></script><script src=\"bower_components/angular-ui-utils/index.js\"></script><script src=\"bower_components/angular-strap/dist/angular-strap.js\"></script><script src=\"bower_components/angular-strap/dist/angular-strap.tpl.js\"></script><script src=\"bower_components/angular-schema-form-dynamic-select/angular-schema-form-dynamic-select.min.js\"></script><script src=\"bower_components/angular-schema-form-multiple-sixlookup/angular-schema-form-multiple-sixlookup.js\"></script><script src=\"bower_components/angular-md5/angular-md5.js\"></script><script src=\"bower_components/qrcode-generator/js/qrcode.js\"></script><script src=\"bower_components/qrcode-generator/js/qrcode_UTF8.js\"></script><script src=\"bower_components/angular-qrcode/angular-qrcode.js\"></script><script src=\"bower_components/moment/moment.js\"></script><script src=\"bower_components/angular-moment/angular-moment.js\"></script><script src=\"bower_components/angular-gantt/assets/angular-gantt.js\"></script><script src=\"bower_components/angular-gantt/assets/angular-gantt-plugins.js\"></script><script src=\"bower_components/keycloak/dist/keycloak.js\"></script><script src=\"bower_components/angular-file-upload/dist/angular-file-upload.min.js\"></script><script src=\"bower_components/angular-loading-bar/build/loading-bar.js\"></script><script src=\"bower_components/ng-tags-input/ng-tags-input.js\"></script><script src=\"bower_components/pdfmake/build/pdfmake.js\"></script><script src=\"bower_components/pdfmake/build/vfs_fonts.js\"></script></body></html>");
$templateCache.put("theme/app.html","<div id=\"loading-bar-container\"></div><toaster-container></toaster-container><six-framework title=\"LM\" logo=\"/logo.gif\" commissions=\"true\" menu-template=\"theme/framework.menu.html\" feed-template=\"theme/framework.feed.html\" company-name=\"companyName\"><six-menu title=\"LM\"></six-menu></six-framework><six-profile sx-profile-items=\"profileItems\"></six-profile><div class=\"app-content\"><div ui-butterbar=\"\"></div><a href=\"\" class=\"off-screen-toggle hide\" ui-toggle-class=\"off-screen\" data-target=\".app-aside\"></a><div class=\"app-content-body fade-in-up\" autoscroll=\"true\" ng-view=\"\"></div></div><div class=\"app-footer b-t bg-light\"><span class=\"pull-right\">{{app.version}} <a href=\"\" ui-scroll-to=\"scroll-top-target\" class=\"m-l-sm text-muted\"><button class=\"btn\" id=\"scroll-top-button\"><i class=\"fa fa-arrow-up\"></i></button></a></span> <span class=\"app-copyright\">&copy; 2017 Copyright.</span></div>");
$templateCache.put("theme/framework.feed.html","<six-feed></six-feed>");
$templateCache.put("theme/framework.menu.html","<li><a href=\"#/\"><i class=\"fa fa-home\"></i> {{app.name}}: Home</a></li><li class=\"divider\"></li><li ng-if=\"userInfo().options.admin\"><a href=\"#/admin/admin\"><i class=\"fa fa-heartbeat\"></i> Admin</a></li><li ng-if=\"userInfo().options.config\"><a href=\"#/admin/config\"><i class=\"fa fa-cogs\"></i> Configura</a></li><li><a ng-if=\"userInfo().six\" href=\"#/admin/preferences\"><i class=\"fa fa-user\"></i> Preferenze</a></li><li><a ng-if=\"userInfo().eggs\" href=\"#/profile\"><i class=\"fa fa-user-o\"></i> Profilo</a></li><li ng-if=\"userInfo().options.revokeAdmin\"><a href=\"#/admin/logout\"><i class=\"fa fa-sign-out\"></i> Revoca admin</a></li><li ng-if=\"userInfo().options.admin\"><a href=\"#/modeltype/list/six\"><i class=\"fa fa-file-text\"></i> ModelType</a></li><li class=\"divider\"></li><li><a ng-click=\"logout()\"><i class=\"fa fa-sign-out\"></i> Logout</a></li>");
$templateCache.put("theme/main.html","<div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Home</h1><small class=\"text-muted\">Dashboard</small></div></div></div><div class=\"col-md-12 wrapper-md\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"panel wrapper\"><div class=\"row wrapper\"></div></div></div><div class=\"col-sm-6 connected\" ui-jq=\"sortable\" ui-options=\"{items:\'.panel\', handle:\'.panel-heading\', connectWith:\'.connected\'}\"><div class=\"panel panel-info\" draggable=\"true\"><div class=\"panel-heading\">Link rapidi</div><div class=\"list-group bg-white\"><a href=\"#/eggs/990.120\" class=\"list-group-item\"><i class=\"fa fa-fw fa-money\"></i> Consuntivazione operatori</a></div></div></div></div></div><div ng-if=\"needSSO\"><iframe src=\"{{EggsURL}}\" sandbox=\"allow-scripts\" style=\"display: none;\"></iframe></div><div ng-controller=\"JsfCtrl\"><iframe id=\"jsfFrame\" ng-src=\"{{ getJsfURL() | trustAsResourceUrl }}\" style=\"display: none;\"></iframe></div>");
$templateCache.put("theme/view404.html","<div class=\"col-md-12 wrapper-md\"><div class=\"container\"><img src=\"logo_w.png\"><h1>Not found <span>:(</span></h1><p>Sorry, but the page you were trying to view does not exist.</p><p>It looks like this was the result of either:</p><ul><li>a mistyped address</li><li>an out-of-date link</li></ul><script>\n      var GOOG_FIXURL_LANG = (navigator.language || \'\').slice(0,2),GOOG_FIXURL_SITE = location.host;\n    </script><script src=\"//linkhelp.clients.google.com/tbproxy/lh/wm/fixurl.js\"></script></div></div>");
$templateCache.put("theme/wysiwyg.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Invia messaggio</h1><small class=\"text-muted\">Composizione messaggio</small></div></div></div><div class=\"panel wrapper\"><div class=\"panel-body\"><six-send-email></six-send-email></div></div></div>");
$templateCache.put("consip/acquisitionstep/acquisitionstep_detail.html","<six-toolbar><six-toolbar-button label=\"Lista\" icon=\"fa fa-chevron-left\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" ng-confirm-message=\"Sei sicuro?\" ng-confirm-click=\"delete(selected.version)\" ng-confirm-condition=\"true\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Dettaglio Step di Acquisizione</h1></div></div></div><div class=\"panel wrapper\"><div class=\"panel-heading\"><div class=\"page-header-bleed-right\"><div class=\"actions\"><div class=\"row\"><form name=\"header\"><div class=\"form-group\"><label id=\"schema_id_key\" for=\"code\" class=\"col-md-1 control-label\">Codice</label><div class=\"col-md-12\"><input type=\"text\" class=\"form-control\" id=\"code\" placeholder=\"\" ng-model=\"selected.model.code\" name=\"code\" required=\"\" readonly=\"\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.code.$error.required\">Obbligatorio</span></div></div></div><div class=\"form-group\"><label id=\"schema_desc_key\" for=\"description\" class=\"col-md-1 control-label\">Descrizione</label><div class=\"col-md-12\"><input type=\"text\" class=\"form-control\" id=\"description\" placeholder=\"\" ng-model=\"selected.model.description\" name=\"description\" ng-keyup=\"refreshDescription(selected.model.description)\" required=\"\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.description.$error.required\">Obbligatorio</span></div></div></div><div class=\"form-group\"><div class=\"col-md-12\"><input type=\"checkbox\" id=\"attachment_management\" ng-model=\"attachmentManagement\" name=\"attachment_management\"> <label id=\"attachment_management_key\" for=\"attachment_management\" class=\"control-label\">Gestione allegati</label></div><div class=\"col-md-12\"><input type=\"checkbox\" id=\"custom_form\" ng-model=\"customForm\" name=\"custom_form\"> <label id=\"custom_form_key\" for=\"custom_form\" class=\"control-label\">Form custom</label></div></div></form></div></div></div></div><div class=\"panel-body\"><uib-tabset justified=\"true\"><uib-tab heading=\"Step\"><form name=\"myForm\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"model\" ng-submit=\"onSubmit(myForm)\"></form></uib-tab><uib-tab heading=\"Schema\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><div class=\"col-md-12 centered\"><b>SCHEMA</b></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><b>CODICE</b></div><div class=\"col-md-3\"><b>DESCRIZIONE</b></div><div class=\"col-md-1\"><b>TIPOLOGIA</b></div><div class=\"col-md-2\"><b>FORMATO</b></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><form name=\"propertyKeyForm\"><input class=\"form-control\" name=\"property_key\" placeholder=\"Codice...\" type=\"text\" ng-model=\"property.key\" pattern=\"^[a-zA-Z]+[\\w]*$\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"propertyKeyForm.property_key.$error.pattern\">Caratteri non consentiti</span></div></form></div></div><div class=\"col-md-3\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><input class=\"form-control\" placeholder=\"Descrizione\" type=\"text\" ng-model=\"property.title\"></div></div><div class=\"col-md-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.type\"><option></option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"boolean\">boolean</option><option value=\"date\">date</option><option value=\"array\">array</option></select></div></div><div class=\"col-md-2\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'string\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'number\' || property.type == \'integer\')\"><option></option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.items_type\" ng-if=\"(property.type == \'array\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"date\">date</option></select></div></div><div class=\"col-md-2\"><div ng-if=\"isInheritable(property.type)\"><label><input type=\"checkbox\" ng-model=\"property.inherited\"> Campo ereditato</label></div></div><div class=\"col-md-1\"><button ng-click=\"addProperty()\" class=\"btn btn-sm btn-info pull-right\"><span class=\"fa fa-plus\"></span> Add</button></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-repeat=\"(key, value) in selected.model.schema.properties\" style=\"align-content: center; padding-bottom: 0px;\"><div class=\"col-md-12 uniform-height\" style=\"align-content: center;\"><div class=\"col-md-1\"><a href=\"\" ng-click=\"status[key].open = !status[key].open\" id=\"btn_row_detail\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status[key].open, \'glyphicon-chevron-right\': !status[key].open}\"></i></a></div><div class=\"col-md-2\">{{ key }}</div><div class=\"col-md-3\">{{ value.title }}</div><div class=\"col-md-1\">{{ value.type }}</div><div class=\"col-md-2\"><span ng-if=\"value.format\">{{value.format}}</span> <span ng-if=\"value.type == \'array\' && value.items\">{{value.items.format}}</span></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"status[key].open\"><div class=\"col-md-12 uniform-height-2\" ng-if=\"value.format !== \'lookup\' && value.format !== \'formula\' && value.format !== \'enum\' && value.format !== \'inherit\' && value.type !== \'array\'\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-10\">{{value.format}}</div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">PROPAGA VALORE:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableCopyTo\" ng-change=\"refreshCopyToCheckbox(key, value.enableCopyTo)\"></div></div><div class=\"col-md-12\" ng-if=\"value.enableCopyTo == true\"><div class=\"col-md-2 uniform-height-2\">CAMPI DI DESTINAZIONE:</div><div class=\"col-md-10 uniform-height-2\"><input type=\"{{itemTypeMap[key]}}\" size=\"45\" name=\"new_item_name\" ng-model=\"newItem.name\"> <button ng-click=\"addItemCopyTo(key, newItem)\" class=\"btn btn-xs btn-info equal-margin-left-right\"><span class=\"fa fa-plus\"></span> Add</button></div><div class=\"col-md-10 col-md-offset-2\"><div class=\"col-md-12 override-padding-no-pad-left-right uniform-height-2\" ng-repeat=\"itemArray in value.copyTo track by $index\" ng-if=\"itemArray != \'\'\"><input type=\"text\" size=\"45\" name=\"item_name\" ng-model=\"itemArray\" disabled=\"\"> <button ng-click=\"deleteItemCopyTo(key,itemArray)\" class=\"btn btn-danger btn-xs btn-default equal-margin-left-right\"><i class=\"fa fa-trash\"></i></button></div></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'inherit\'\" ng-include=\"\'views/modeltype/detail_inherit.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'lookup\' && value.type != \'array\'\" ng-include=\"\'views/modeltype/detail_lookup.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'formula\'\" ng-include=\"\'views/modeltype/detail_formula.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'enum\'\" ng-include=\"\'views/modeltype/detail_enum.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.type === \'array\'\" ng-include=\"\'views/modeltype/detail_array.html\'\"></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ELIMINA:</div><div class=\"col-md-10\"><button ng-click=\"deleteProperty(key)\" class=\"btn btn-danger btn-xs btn-default\" ng-disabled=\"(key === \'code\' || key === \'description\')\"><i class=\"fa fa-trash\"></i></button></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">IN TABELLA:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.check\" ng-change=\"changeColumnDefs(key, value)\" ng-disabled=\"(key === \'code\' || key === \'description\')\"></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"value.check == true\"><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">LARGHEZZA (px):</div><div class=\"col-md-10\"><input type=\"text\" min=\"1\" step=\"1\" size=\"45\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"value.width\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ORDINAMENTO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableSorting\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FILTRAGGIO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableFiltering\" ng-change=\"changeColumnDefs(key, value)\"></div></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div></div></div></div></uib-tab><uib-tab heading=\"Form\"><table class=\"table table-striped\"><thead><th colspan=\"5\">FORM</th><tr><th colspan=\"5\"><div class=\"form-group\"><label for=\"title\" class=\"control-label\">Titolo</label><div class=\"\"><input type=\"text\" class=\"form-control\" id=\"title\" placeholder=\"\" ng-model=\"title\" name=\"title\" ng-keyup=\"refreshTitleForm(title)\"></div></div></th></tr><tr><td></td><td></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newTab.title\"></td><td><button ng-click=\"addTab(selected.model.form[0].items[0])\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th></th><th>POSIZIONE</th><th>TITOLO</th><th></th></tr></thead><tbody><tr ng-repeat-start=\"(key, tab) in selected.model.form[0].items[0].tabs\"><td><a href=\"\" ng-click=\"statusForm[key].open = !statusForm[key].open\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': statusForm[key].open, \'glyphicon-chevron-right\': !statusForm[key].open}\"></i></a></td><td><span class=\"btn btn-sm\" ng-click=\"swapUp(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key<=0\"><i class=\"fa fa-caret-up\"></i></span> {{key+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key>=selected.model.form[0].items[0].tabs.length-1\"><i class=\"fa fa-caret-down\"></i></span></td><td><input type=\"text\" ng-model=\"tab.title\" ng-disabled=\"(tab.key[0] == \'code\' || tab.key[0] == \'description\')\" ng-keyup=\"updateScope()\"></td><td><a ng-click=\"removeTabOrField(key, selected.model.form[0].items[0].tabs)\" class=\"btn btn-danger btn-xs btn-default\" id=\"btn_row_detail_form\"><i class=\"fa fa-trash\"></i></a></td></tr><tr ng-repeat-end=\"\" ng-show=\"statusForm[key].open\"><td></td><td colspan=\"3\" style=\"background-color:rgba(211, 211, 211, 0.38);\"><table class=\"table table-striped override-margin\"><tr><td></td><td><select ng-options=\"k as v.title for (k, v) in schema.properties\" ng-model=\"newFieldForm.key\"></select></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newFieldForm.title\"></td><td><input type=\"checkbox\" placeholder=\"Richiesto...\" ng-model=\"newFieldForm.required\"></td><td><select ng-model=\"newFieldForm.type\" ng-change=\"updateScope()\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><button ng-click=\"addFieldToTab(tab)\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th>POSIZIONE</th><th>CAMPO</th><th>TITOLO</th><th>REQUIRED</th><th>TIPO</th><th></th></tr><tr ng-repeat=\"(fieldKey, field) in tab.items\"><td class=\"override-width-200px\"><div><span class=\"btn btn-sm\" ng-click=\"swapUp(fieldKey, tab.items)\" ng-disabled=\"fieldKey<=0\"><i class=\"fa fa-caret-up\"></i></span> {{fieldKey+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(fieldKey, tab.items)\" ng-disabled=\"fieldKey>=tab.items.length-1\"><i class=\"fa fa-caret-down\"></i></span></div></td><td ng-if=\"!field.title\">{{field}}</td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"field.title\">{{field.key[0]}}</td><td ng-if=\"field.title\"><input type=\"text\" ng-model=\"field.title\" ng-keyup=\"updateScope()\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.required\" ng-change=\"updateScope()\"></td><td ng-if=\"field.title\"><select ng-model=\"field.type\" ng-change=\"updateField(field)\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><a ng-click=\"removeTabOrField(fieldKey, tab.items)\" class=\"btn btn-danger btn-xs btn-default\"><i class=\"fa fa-trash\"></i></a></td></tr></table></td></tr></tbody></table></uib-tab></uib-tabset></div><div class=\"panel-footer\"><div class=\"form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" data-toggle=\"collapse\" data-target=\"#json-collapse\" class=\"pull-left\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div></div></div><div class=\"row collapse\" id=\"json-collapse\"><div class=\"col-md-8\"><div class=\"panel-heading wrapper b-b b-light\"><h4 class=\"font-thin m-t-none m-b-none text-muted\">Dettaglio</h4></div><div style=\"margin-top:0px;\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'json\', firstLineNumber: 1, onLoad: aceLoaded, onChange: aceChanged }\" ng-model=\"aceModel\"></div><div class=\"panel-footer\"></div></div><div class=\"col-md-4\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{ model}}</pre></div></div></div></div></div>");
$templateCache.put("consip/acquisitionstep/acquisitionstep_list.html","<six-toolbar><six-toolbar-button label=\"Crea step\" icon=\"fa fa-plus\" toolbar-function=\"newStep()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista step di acquisizione</h1></div></div></div><div class=\"panel-body\"><table id=\"step_list\" class=\"table table-striped\"><thead><tr><th></th><th>CODICE</th><th>DESCRIZIONE</th></tr></thead><tbody><tr ng-repeat=\"item in stepList.list\"><td><a ng-href=\"#/acquisitionstep/{{item.UUID}}\" class=\"btn btn-default\"><span class=\"fa fa-search\"></span></a></td><td>{{ item.model.code }}</td><td>{{ item.model.description }}</td></tr><tr ng-hide=\"stepList.list.length\"><td><p class=\"text-center\">Nessun record recuperato</p></td></tr></tbody></table></div><div class=\"panel-footer\"><div class=\"row text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"stepList.totalResults\" ng-model=\"stepList.currentPage\" class=\"pagination-sm\" items-per-page=\"stepList.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div></div></div>");
$templateCache.put("consip/acquisitionstep/opf.html","<div ng-controller=\"OpfCtrl\"><div class=\"alert alert-danger\" ng-if=\"errorMsg\"><strong>Errore:</strong>{{errorMsg}}</div><div class=\"alert alert-danger\" ng-if=\"anagraphicError\"><strong>Errore:</strong>alcuni dei dati caricati nel file non hanno corrispondenza in anagrafica.</div><div><form name=\"{{opfId}}\" id=\"{{opfId}}\"><div ng-repeat=\"items in opfForm[0].items\"><uib-tabset class=\"tabs-left\"><uib-tab ng-repeat=\"tabs in items.tabs\"><uib-tab-heading>{{tabs.title}}</uib-tab-heading><div ng-if=\"(tabs.title===\'Opf\') || (tabs.title===\'Emissione\')\" ng-repeat=\"model_items in tabs.items\"><div ng-if=\"!(model_items.type == \'array\' || \'reporter_id\' == model_items.key[0])\" ng-init=\"iter = iter + 1\"><div class=\"form-group col-md-4\" ng-if=\"(\'sixlookup\' !== model_items.type) && (\'textarea\' !== model_items.type)\"><label class=\"control-label\">{{model_items.title}}</label><div class=\"input-group\" style=\"width: 100%\"><span class=\"input-group-addon\" id=\"sizing-addon-left\" ng-if=\"model_items.fieldAddonLeft\">{{model_items.fieldAddonLeft}}</span> <input class=\"sf-form-control form-control\" type=\"{{getInputType(model_items)}}\" step=\"any\" ng-model=\"data.model[model_items.key[0]]\" ng-required=\"model_items.required\" aria-describedby=\"sizing-addon\" ng-change=\"boolUpdate(model_items)\" ng-if=\"getInputType(model_items)!==\'textarea\'\" ng-readonly=\"model_items.key[0]===\'reserved_amount\'\"></div></div><div class=\"form-group col-md-4\" ng-if=\"(\'textarea\' == model_items.type)\"><label class=\"control-label\">{{model_items.title}}</label><div class=\"input-group\" style=\"width: 100%\"><textarea class=\"sf-form-control form-control\" ng-model=\"data.model[model_items.key[0]]\" ng-required=\"model_items.required\" aria-describedby=\"sizing-addon\" ng-change=\"boolUpdate(model_items)\"></textarea></div></div><div class=\"form-group col-md-4\" ng-if=\"\'sixlookup\' == model_items.type\"><label class=\"control-label\">{{model_items.title}}</label><six-lookup class=\"sf-form-control\" ng-model=\"data.model\" sx-type=\"model_items.entity_id\" sx-filter=\"getListFiltered(model_items.key[0])\" sx-field=\"model_items.key[0]\" sx-war=\"schema.properties[model_items.key[0]].war\" ng-required=\"model_items.required\"></six-lookup></div></div></div><div ng-if=\"(tabs.title===\'Sezione Economica\')\"><table class=\"table table-hover\"><thead><tr><th></th><th>Tot globale Canone</th><th>Tot globale ECanone</th><th>Tot compl. Contratto</th><th></th></tr></thead><tbody><tr><td>Acquisizione</td><td>{{opfModel.opf_totals.canone | currency}}</td><td>{{opfModel.opf_totals.extraCanone | currency}}</td><td>{{opfModel.opf_totals.complessivoExcel | currency}}</td><td></td></tr><tr ng-repeat=\"oat in opfAdditionalTotals\"><td>Atti aggiuntivi</td><td>{{oat.opf_totals.canone | currency}}</td><td>{{oat.opf_totals.extraCanone | currency}}</td><td>{{oat.opf_totals.complessivoExcel | currency}}</td><td><a ng-href=\"#/additionalacts/detail/{{oat.UUID}}\" class=\"btn btn-xs btn-primary\">{{oat.UUID}}</a></td></tr></tbody><tfoot ng-if=\"opfAdditionalTotals.length>0\"><tr><th></th><th>{{opfModel.opf_totals.canone + opfAdditionalTotalsSum.canone | currency }}</th><th>{{opfModel.opf_totals.extraCanone + opfAdditionalTotalsSum.extraCanone | currency }}</th><th>{{opfModel.opf_totals.complessivoExcel + opfAdditionalTotalsSum.complessivoExcel | currency }}</th><th></th></tr></tfoot></table><div class=\"row\"><div class=\"col col-md-12\"><div id=\"gridSe\" ui-grid=\"gridSeOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-cellnav=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\" ui-grid-auto-resize=\"\"></div></div></div><a href=\"\" class=\"btn btn-sm btn-info m-t pull-right\" ng-click=\"exportSe()\"><span class=\"fa fa-download\">XLS</span></a></div><div ng-if=\"(tabs.title===\'Dett.Val.Economici\')\"><table class=\"table table-hover\"><thead><tr><th></th><th>Tot globale Canone</th><th>Tot globale ECanone</th><th>Tot compl. Contratto</th><th></th></tr></thead><tbody><tr><td>Acquisizione</td><td>{{opfModel.opf_totals.canone | currency}}</td><td>{{opfModel.opf_totals.extraCanone | currency}}</td><td>{{opfModel.opf_totals.complessivoExcel | currency}}</td><td></td></tr><tr ng-repeat=\"oat in opfAdditionalTotals\"><td>Atti aggiuntivi</td><td>{{oat.opf_totals.canone | currency}}</td><td>{{oat.opf_totals.extraCanone | currency}}</td><td>{{oat.opf_totals.complessivoExcel | currency}}</td><td><a ng-href=\"#/additionalacts/detail/{{oat.UUID}}\" class=\"btn btn-xs btn-primary\">{{oat.UUID}}</a></td></tr></tbody><tfoot ng-if=\"opfAdditionalTotals.length>0\"><tr><th></th><th>{{opfModel.opf_totals.canone + opfAdditionalTotalsSum.canone | currency }}</th><th>{{opfModel.opf_totals.extraCanone + opfAdditionalTotalsSum.extraCanone | currency }}</th><th>{{opfModel.opf_totals.complessivoExcel + opfAdditionalTotalsSum.complessivoExcel | currency }}</th><th></th></tr></tfoot></table><div class=\"row wrapper\" ng-if=\"false\"><div class=\"col col-md-4\"><label class=\"control-label\">Tot globale Canone</label><div class=\"input-group\" style=\"width: 100%\"><input class=\"form-control\" type=\"number\" ng-model=\"opfModel.opf_totals.canone\" min=\"0\" step=\"0.01\" readonly=\"\"></div></div><div class=\"col col-md-4\"><label class=\"control-label\">Tot globale ECanone</label><div class=\"input-group\" style=\"width: 100%\"><input class=\"form-control\" type=\"number\" ng-model=\"opfModel.opf_totals.extraCanone\" min=\"0\" step=\"0.01\" readonly=\"\"></div></div><div class=\"col col-md-4\"><label class=\"control-label\">Tot compl. Contratto</label><div class=\"input-group\" style=\"width: 100%\"><input class=\"form-control\" type=\"number\" ng-model=\"opfModel.opf_totals.complessivoRicalcolato\" min=\"0\" step=\"0.01\" readonly=\"\"></div></div></div><div class=\"row\"><div class=\"col col-md-12\"><div id=\"gridDve\" ui-grid=\"gridDveOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-cellnav=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\" ui-grid-auto-resize=\"\"></div></div></div><a href=\"\" class=\"btn btn-sm btn-info m-t pull-right\" ng-click=\"exportDve()\"><span class=\"fa fa-download\">XLS</span></a></div><div ng-if=\"(tabs.title===\'Email\')\" ng-init=\"getMessage()\"><div class=\"row\"><div class=\"col col-md-12\"><div class=\"col-md-12\" ng-if=\"loadingSixMail == true\"><uib-progressbar class=\"progress-striped active\" type=\"info\"><i>Caricamento messaggio</i></uib-progressbar></div><six-send-email ng-if=\"loadingSixMail == false\" sx-title-mail=\"objMail.title\" sx-body-mail=\"objMail.message\" sx-to-mail=\"objMail.to\" sx-cc-mail=\"objMail.cc\" sx-type-mail=\"\'opf\'\" sx-record-id=\"opfRef\"></six-send-email></div></div></div><div ng-if=\"(tabs.title===\'Affidamenti Subappalti\')\"><div class=\"row wrapper\"><div class=\"col col-md-12\"><div class=\"alert alert-info\">Non ci sono elementi da visualizzare</div></div></div></div></uib-tab></uib-tabset></div></form></div></div>");
$templateCache.put("consip/acquisitionstep/pdi.html","<div ng-controller=\"PdiCtrl\"><div class=\"wrapper m-t-n-sm\"><form id=\"{{pdiId}}\" name=\"{{pdiId}}\"><div class=\"override-form-group override-checkbox\" sf-schema=\"pdiSchema\" sf-form=\"pdiForm\" sf-model=\"pdiModel\" update-six-formula=\"\"></div></form></div><div id=\"upload_div\" class=\"m-t-sm\"><div class=\"col col-md-12 wrapper\" ng-if=\"upload.errors.length>0\"><div class=\"alert alert-danger\"><strong>Caricamento FALLITO</strong><div ng-repeat=\"error in upload.errors\">{{error}}</div></div></div><input type=\"file\" id=\"fileUploadBtn\" nv-file-select=\"\" uploader=\"uploader\" class=\"inputfile\" style=\"display:none\"><div class=\"panel panel-default\" ng-if=\"upload.show\"><div class=\"panel-heading text-md\">Nuovo preventivo</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col col-md-6\"><label for=\"quote_date\" class=\"control-label\">Data creazione revisione</label><p class=\"input-group\" style=\"width:100%\"><input type=\"text\" name=\"toDate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"revision.date_emission\" is-open=\"upload.pupupEmissionOpened\" datepicker-options=\"dateOptions\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"upload.pupupEmissionOpened=!upload.pupupEmissionOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span> <span class=\"badge bg-danger badge-sm m-l-xs\" ng-hide=\"revision.date_emission\">Obbligatorio</span></p></div><div class=\"col col-md-6\"><label for=\"quote_date\" class=\"control-label\">Numero di revisione</label><div class=\"input-group\" style=\"width:100%\"><input name=\"quote_date\" type=\"text\" ng-model=\"revision.revision_number\" class=\"form-control\"></div><span class=\"badge bg-danger badge-sm m-l-xs\" ng-hide=\"revision.revision_number\">Obbligatorio</span></div></div></div><div class=\"panel-footer\"><div class=\"row\" ng-if=\"uploader.queue.length>0\"><div class=\"col col-md-12\" ng-show=\"!hasXls\"><div class=\"alert alert-danger\"><strong>Obbligatorio:</strong> inserire anche un preventivo in formato Excel</div></div></div><table class=\"table\"><thead><tr><th>Nome file</th><th ng-show=\"uploader.isHTML5\">Dimensione</th><th ng-show=\"uploader.isHTML5\">Avanzamento</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue\" ng-init=\"item.popupSendingOpened=false\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }} MB</td><td ng-show=\"uploader.isHTML5\"><div class=\"progress\" style=\"margin-bottom: 0;\"><div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ \'width\': item.progress + \'%\' }\"></div></div></td></tr><tr><th colspan=\"5\"><button class=\"btn btn-default\" ng-click=\"addQuote()\" ng-disabled=\"readonlyMode\"><span class=\"fa fa-plus\"></span> Aggiungi file</button> <button type=\"button\" class=\"btn btn-default btn-s\" ng-click=\"uploader.uploadAll()\" ng-disabled=\"confirmDisabled()\"><span class=\"fa fa-check\"></span> Conferma</button> <button type=\"button\" class=\"btn btn-default btn-s\" ng-click=\"undoUpload()\" ng-disabled=\"upload.started\"><span class=\"fa fa-undo\"></span> Annulla</button></th></tr></tbody></table></div></div></div><div id=\"uploaded_div\" class=\"wrapper m-t-n-lg\"><div class=\"alert alert-warning\" ng-if=\"upload.warnings.length>0\"><strong>Attenzione</strong><div ng-repeat=\"warning in upload.warnings\">{{warning}}</div></div><div ng-hide=\"(revisions.length>0) || (upload.show)\" class=\"alert alert-info\">Nessun preventivo trovato</div><div ng-show=\"revisions.length>0\"><div class=\"legend\"><span class=\"text-xs text-muted pull-right\"><i class=\"fa fa-circle text-warning m-r-xs m-l-sm\"></i> inserita <i class=\"fa fa-circle text-info m-r-xs\"></i> approvata <i class=\"fa fa-circle text-danger m-r-xs m-l-sm\"></i> rifiutata</span> <span style=\"clear:both\"></span></div><div class=\"pdi_element\" ng-repeat=\"revision in revisions track by $index\"><h4 class=\"pdi_title\" ng-if=\"differentFromPrevious($index)\"><i class=\"fa fa-circle text-warning\" ng-if=\"isInserted(revision,$index)\"></i> <i class=\"fa fa-circle text-danger\" ng-if=\"isRefused(revision,$index)\"></i> <i class=\"fa fa-circle text-info\" ng-if=\"isApproved(revision,$index)\"></i> Revisione <strong>{{ revision.revision_number }}</strong></h4><div class=\"row pdi_file_row\" ng-if=\"differentFromPrevious($index)\"><div class=\"col col-md-3\" ng-repeat=\"file in revision.files\"><div class=\"pdi_file\"><span class=\"pull-left thumb-sm\"><i class=\"fa fa-file-o fa-2x text-muted\"></i></span><div class=\"media-body\"><a ng-href=\"{{DOWNLOAD_URL}}{{transformObjectIdForBackend(file.object_id)}}\" target=\"_blank\" download=\"{{file.title}}\" class=\"h5\">{{file.title}}</a> <small class=\"block\">{{file.date_insertion | date:\'dd/MM/yyyy\'}}</small></div></div></div></div><div class=\"row\" style=\"font-weight:bold\" ng-if=\"differentFromPrevious($index)\"><div class=\"col-xs-2 col-sm-2 col-md-2\">Stato</div><div class=\"col-xs-2 col-sm-2 col-md-2\">Data creazione</div><div class=\"col-xs-2 col-sm-2 col-md-2\">Data approvazione</div><div class=\"col-xs-2 col-sm-2 col-md-2\">Data rifiuto</div><div class=\"col-xs-4 col-sm-4 col-md-4\">Azioni</div></div><div class=\"row\"><div class=\"col-xs-2 col-sm-2 col-md-2\"><span><span ng-if=\"isInserted(revision)\">Inserita</span> <span ng-if=\"isRefused(revision)\">Rifiutata</span> <span ng-if=\"isApproved(revision)\">Approvata</span></span></div><div class=\"col-xs-2 col-sm-2 col-md-2\"><span ng-if=\"!editing[$index]\">{{revision.date_emission | date:\'dd/MM/yyyy\'}}</span> <span ng-if=\"editing[$index]\"><p class=\"input-group\" ng-class=\"{\'has-error\': datesError}\" style=\"width:100%\" ng-if=\"revision.date_emission\"><input type=\"text\" ng-change=\"areDatesValid($index)\" name=\"toDate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"editData.date_emission\" is-open=\"upload.pupupEmissionOpened\" datepicker-options=\"dateOptions\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-class=\"{\'btn-danger\': datesError}\" ng-click=\"upload.pupupEmissionOpened=!upload.pupupEmissionOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></span></div><div class=\"col-xs-2 col-sm-2 col-md-2\"><span ng-if=\"!editing[$index]\">{{revision.date_approval | date:\'dd/MM/yyyy\'}}</span> <span ng-if=\"editing[$index]\"><p class=\"input-group\" ng-class=\"{\'has-error\': datesError}\" style=\"width:100%\" ng-if=\"revision.date_approval\"><input type=\"text\" ng-change=\"areDatesValid($index)\" name=\"toDate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"editData.date_approval\" is-open=\"upload.pupupApprovalOpened\" datepicker-options=\"dateOptions\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-class=\"{\'btn-danger\': datesError}\" ng-click=\"upload.pupupApprovalOpened=!upload.pupupApprovalOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></span></div><div class=\"col-xs-2 col-sm-2 col-md-2\"><span ng-if=\"!editing[$index]\">{{revision.date_refusal | date:\'dd/MM/yyyy\'}}</span> <span ng-if=\"editing[$index]\"><p class=\"input-group\" ng-class=\"{\'has-error\': datesError}\" style=\"width:100%\" ng-if=\"revision.date_refusal\"><input type=\"text\" ng-change=\"areDatesValid($index)\" name=\"toDate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"editData.date_refusal\" is-open=\"upload.pupupRefusalOpened\" datepicker-options=\"dateOptions\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-class=\"{\'btn-danger\': datesError}\" ng-click=\"upload.pupupRefusalOpened=!upload.pupupRefusalOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></span></div><div class=\"col-xs-4 col-sm-4 col-md-4\"><span ng-if=\"!isOld(revision)\"><button class=\"btn btn-default\" ng-click=\"approveQuote(revision, $index)\" ng-disabled=\"readonlyMode || isApproved(revision)\" ng-if=\"!editingMode\"><span class=\"fa fa-check text-info\"></span> Approva</button> <button class=\"btn btn-default\" ng-click=\"refuseQuote(revision, $index)\" ng-disabled=\"readonlyMode || isRefused(revision)\" ng-if=\"!editingMode\"><span class=\"fa fa-times text-danger\"></span> Rifiuta</button> <button class=\"btn btn-default\" ng-click=\"startEditQuote($index)\" ng-disabled=\"readonlyMode\" ng-if=\"!editingMode\"><span class=\"fa fa-pencil text-warning\"></span> Modifica</button> <button class=\"btn btn-default\" ng-click=\"stopEditQuote($index)\" ng-disabled=\"readonlyMode || datesError\" ng-if=\"editing[$index]\"><span class=\"fa fa-save text-success\"></span> Conferma</button> <button class=\"btn btn-default\" ng-click=\"undoEditQuote($index)\" ng-disabled=\"readonlyMode\" ng-if=\"editing[$index]\"><span class=\"fa fa-undo text-primary\"></span> Annulla</button></span></div></div></div></div></div><div id=\"upload_button_div\" ng-if=\"!upload.show\"><button class=\"btn btn-default\" ng-click=\"loadQuote()\" ng-disabled=\"readonlyMode\">Carica preventivo</button></div><div ng-if=\"alfrescoList\"><pre>{{alfrescoList | json}}</pre></div></div>");
$templateCache.put("consip/acquisitionwizard/acquisitionwizard_detail.html","<six-toolbar><six-toolbar-item label=\"Marca come NON ADERENTE\" icon=\"fa fa-ban text-primary-dker\" toolbar-function=\"setNotAdherent()\" sx-disabled=\"isWizardReadonly()\" ng-hide=\"isNotAdherent()\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" ng-if=\"!isAdditionalAct\" toolbar-function=\"backToList()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-chevron-left\" ng-if=\"isAdditionalAct\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Salva ordine\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"test()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\" sx-disabled=\"isWizardReadonly()\"></six-toolbar-button><six-toolbar-button label=\"Annulla step\" btn-class=\"btn-warning\" icon=\"fa fa-arrow-left\" toolbar-function=\"undoStep()\" sx-disabled=\"(maxActiveTab<1) || isWizardReadonly()\"></six-toolbar-button><six-toolbar-button label=\"Approva step\" btn-class=\"btn-info\" icon=\"fa fa-arrow-right\" toolbar-function=\"approveStep()\" sx-disabled=\"isApprovalLocked() || isWizardReadonly()\"></six-toolbar-button><six-toolbar-button label=\"Atti aggiuntivi\" btn-class=\"btn-primary-override\" icon=\"fa fa-plus\" toolbar-function=\"insertAdditionalActs()\" ng-if=\"!isAdditionalAct && (wizard.model.current_step.status==\'terminated\')\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-trash\" toolbar-function=\"delete()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar alert alert-warning\" ng-if=\"isNotAdherent()\"><strong>Cliente non aderente.</strong> Convenzione rifiutata in data {{wizard.adhesion_refusal_date | date}}</div><div class=\"col-md-12\" ng-class=\"{\'override-padding-toolbar\': !isNotAdherent()}\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-md-12\"><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"!isAdditionalAct\">Acquisizione <span ng-if=\"wizard.model.code\">cod. {{wizard.model.code}}</span> cliente {{wizard.model.client_id.description}}</h1><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"isAdditionalAct\">Atto aggiuntivo per il cliente {{wizard.model.client_id.description}}</h1></div></div></div><div class=\"panel-body\"><uib-tabset active=\"activeTab\"><uib-tab ng-repeat=\"tab in tabs track by $index\" index=\"$index\" disable=\"tab.disabled\"><uib-tab-heading>{{tab.title}}<six-consip-timing-led sx-value=\"getStepDocument($index+1).timing_status\"></six-consip-timing-led></uib-tab-heading><uib-tabset class=\"tabs-right\"><uib-tab><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Dati</uib-tab-heading><div class=\"row wrapper\" ng-if=\"!tab.customForm\"><form id=\"{{getId($index+1)}}\" name=\"{{getId($index+1)}}\"><div class=\"override-form-group override-checkbox\" sf-schema=\"tab.schema\" sf-form=\"tab.form\" sf-model=\"getModel($index+1)\" update-six-formula=\"\"></div><six-iterator-copy si-model=\"getModel($index+1)\" si-schema=\"tab.schema\" si-doc=\"wizard\" si-attribute=\"\'copyTo\'\"></six-iterator-copy></form></div><div class=\"row wrapper\" ng-if=\"tab.customForm\"><div ng-if=\"tab.code==\'pdi\' || tab.code==\'pditracciato\'\" ng-include=\"\'consip/acquisitionstep/pdi.html\'\"></div><div ng-if=\"tab.code==\'opf\' || tab.code==\'opftracciato\'\" ng-include=\"\'consip/acquisitionstep/opf.html\'\"></div></div></uib-tab><uib-tab ng-if=\"tab.attachmentManagement\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments nodes=\"tab.attachments\" save-callback=\"updAttachments($index)\"></six-tree-attachments></uib-tab></uib-tabset></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("consip/acquisitionwizard/acquisitionwizard_list.html","<six-toolbar><six-toolbar-item label=\"Plafond disponibile: {{plafond.available | currency}}\" icon=\"fa fa-credit-card text-info-dker\"></six-toolbar-item><six-toolbar-item label=\"Plafond sottoscritto: {{plafond.used | currency}}\" icon=\"fa fa-credit-card text-primary-dker\"></six-toolbar-item><six-toolbar-item label=\"Plafond residuo: {{plafond.remaining | currency}}\" icon=\"fa fa-credit-card {{plafond.remaining_class}}\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-check\" label=\"Nuova acquisizione\" btn-class=\"btn-info\" toolbar-function=\"newWizard()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Acquisizioni</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getWizardList()\" items-list=\"wizardList\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("consip/acquisitionwizard/acquisitionwizard_new.html","<six-toolbar><six-toolbar-button icon=\"fa fa-plus\" label=\"Conferma\" btn-class=\"btn-info\" toolbar-function=\"confirmNewWizard()\" sx-disabled=\"!validDefaultSettings\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Creazione nuova acquisizione</h1></div></div></div><div class=\"panel-body\"><label class=\"control-label\">Seleziona cliente</label><six-lookup ng-model=\"wizard\" sx-type=\"\'cliente\'\" sx-field=\"\'client_id\'\"></six-lookup></div></div></div>");
$templateCache.put("consip/acquisitionwizard/additionalacts_list.html","<six-toolbar><six-toolbar-item label=\"Plafond disponibile: {{plafond.available | currency}}\" icon=\"fa fa-credit-card text-info-dker\"></six-toolbar-item><six-toolbar-item label=\"Plafond sottoscritto: {{plafond.used | currency}}\" icon=\"fa fa-credit-card text-primary-dker\"></six-toolbar-item><six-toolbar-item label=\"Plafond residuo: {{plafond.remaining | currency}}\" icon=\"fa fa-credit-card {{plafond.remaining_class}}\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-plus\" label=\"Crea atto aggiuntivo\" btn-class=\"btn-info\" toolbar-function=\"newAdditionalAct()\" ng-if=\"sourceAcquisition\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-md-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Atti Aggiuntivi</h1><small ng-if=\"sourceAcquisition\"><span class=\"text-muted\">Atti aggiuntivi generati a partire dall\'acquisizione di codice</span> {{sourceAcquisition.UUID}} <span class=\"text-muted\">per il cliente</span>{{sourceAcquisition.model.client_id.description}}</small></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"actsList\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("consip/contract/contract.html","<six-toolbar><six-toolbar-item label=\"Plafond disponibile: {{plafond.available | currency}}\" icon=\"fa fa-credit-card text-info-dker\" ng-hide=\"!plafond_total\"></six-toolbar-item><six-toolbar-item label=\"Plafond sottoscritto: {{plafond.used | currency}}\" icon=\"fa fa-credit-card text-primary-dker\" ng-hide=\"!plafond_total\"></six-toolbar-item><six-toolbar-item label=\"Plafond residuo: {{plafond.remaining | currency}}\" icon=\"fa fa-credit-card {{plafond.remaining_class}}\" ng-hide=\"!plafond_total\"></six-toolbar-item><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-trash-o\" toolbar-function=\"delete()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"onSubmit(header)\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\" ng-hide=\"selected.version\"><h1 class=\"m-n font-thin h3 text-black\">Nuova Convenzione</h1></div><div class=\"col-sm-6 col-xs-12\" ng-show=\"selected.version\"><h1 class=\"m-n font-thin h3 text-black\">Convenzione</h1></div></div></div><div class=\"panel-body\"><form name=\"header\" ng-submit=\"onSubmit(header)\"><uib-tabset><uib-tab index=\"0\" heading=\"Dati\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"form-group col-md-6\"><label id=\"schema_id_key\" for=\"code\" class=\"control-label m-t-xxs\">Codice</label><div><input type=\"text\" class=\"form-control\" id=\"code\" placeholder=\"\" ng-model=\"selected.model.code\" name=\"code\" required=\"\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.code.$error.required\">Obbligatorio</span></div></div></div><div class=\"form-group col-md-6\"><label id=\"schema_desc_key\" for=\"description\" class=\"control-label m-t-xxs\">Descrizione</label><div><input type=\"text\" class=\"form-control\" id=\"description\" placeholder=\"\" ng-model=\"selected.model.description\" name=\"description\" required=\"\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.description.$error.required\">Obbligatorio</span></div></div></div><div class=\"form-group\"><div class=\"col-md-12\" ng-if=\"workflow.ref == \'\'\"><div uib-alert=\"\" class=\"alert-danger col-md-12\" style=\"display: flex\">Nessuna connessione al workflow</div></div><div ng-if=\"workflow.ref !== \'\'\"><div ng-repeat=\"items in form[0].items\"><div ng-repeat=\"tabs in items.tabs\"><div ng-repeat=\"model_items in tabs.items\"><div ng-if=\"model_items.type !== \'array\'\" ng-init=\"iter = iter + 1\"><div class=\"form-group col-md-6\" ng-if=\"(\'sixlookup\' !== model_items.type) && (model_items.key[0]!==\'plafond\')\"><label class=\"control-label m-t-xxs\">{{model_items.title}}</label><div class=\"input-group\" style=\"width: 100%\"><span class=\"input-group-addon\" id=\"sizing-addon-left\" ng-if=\"model_items.fieldAddonLeft\">{{model_items.fieldAddonLeft}}</span> <input class=\"form-control\" type=\"{{getInputType(model_items)}}\" step=\"any\" ng-model=\"selected.model[model_items.key[0]]\" aria-describedby=\"sizing-addon\" ng-change=\"boolUpdate(model_items)\" ng-if=\"getInputType(model_items)!==\'textarea\'\"> <textarea class=\"form-control\" ng-model=\"selected.model[model_items.key[0]]\" ng-if=\"getInputType(model_items)===\'textarea\'\" aria-describedby=\"sizing-addon\" ng-change=\"boolUpdate(model_items)\"></textarea> <span class=\"input-group-addon\" id=\"sizing-addon-right\" ng-if=\"model_items.fieldAddonRight\">{{model_items.fieldAddonRight}}</span></div></div><div class=\"form-group col-md-6\" ng-if=\"model_items.key[0]===\'plafond\'\"><label class=\"control-label m-t-xxs\">{{model_items.title}}</label><div class=\"input-group\" style=\"width: 100%\"><span class=\"input-group-addon\" id=\"sizing-addon-left\" ng-if=\"model_items.fieldAddonLeft\">{{model_items.fieldAddonLeft}}</span> <input class=\"form-control\" type=\"{{getInputType(model_items)}}\" step=\"any\" ng-model=\"selected.model[model_items.key[0]]\" aria-describedby=\"sizing-addon\" ng-change=\"boolUpdate(model_items)\" ng-if=\"getInputType(model_items)!==\'textarea\'\" ng-readonly=\"hasPlafondIntegrations()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"integratePlafond()\" ng-disabled=\"!isIntegrationEnabled()\" ng-hide=\"isPlafondEditing\" title=\"Aggiungi integrazioni\"><i class=\"fa fa-plus\"></i></button></span> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"saveIntegratePlafond()\" title=\"Salva\" ng-if=\"isPlafondEditing\"><i class=\"fa fa-save\"></i></button></span> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"undoIntegratePlafond()\" title=\"Annulla\" ng-if=\"isPlafondEditing\"><i class=\"fa fa-undo\"></i></button></span></div><div class=\"panel panel-default\" ng-if=\"hasPlafondIntegrations() || isPlafondEditing\"><table width=\"100%\" class=\"table\"><thead><tr><th></th><th>Valore</th><th>Data integrazione</th></tr></thead><tbody><tr><td>Valore iniziale</td><td>{{selected.model.plafond | currency}}</td><td></td></tr><tr ng-repeat=\"item in selected.model.plafond_integrations\"><td>Integrazione {{$index+1}}</td><td>{{item.value | currency}}</td><td>{{item.date | date}}</td></tr><tr ng-if=\"isPlafondEditing\"><td>Integrazione</td><td><input type=\"number\" ng-model=\"newPlafondIntegration.value\" step=\"0.01\"></td><td><input type=\"date\" ng-model=\"newPlafondIntegration.date\"></td></tr></tbody><thead><tr><th>Totale</th><th>{{plafond_total + newPlafondIntegration.value | currency}}</th><th></th></tr></thead></table></div></div><div class=\"form-group col-md-6\" ng-if=\"\'sixlookup\' == model_items.type && model_items.entity_id == \'workflow\'\"><label class=\"control-label m-t-xxs\">{{model_items.title}}</label><six-lookup ng-model=\"selected.model\" sx-type=\"model_items.entity_id\" sx-field=\"model_items.key[0]\" sx-disabled=\"lock\"></six-lookup></div></div></div></div></div></div></div></div></div></uib-tab><uib-tab index=\"1\" heading=\"Fasi\"><div class=\"col-md-12 form-group hr-margin-t\"><div class=\"row\"><div class=\"col-md-6\"><label class=\"control-label m-t-xxs\">Associazione fasi</label></div><div class=\"col-md-12 no-pad-l-r pad-list-t-b\" ng-repeat=\"row in arrayRet\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"col-md-6\"><six-lookup sx-disabled=\"lock\" ng-model=\"selected.model.steps[arrayIds[$index]]\" sx-type=\"\'acquisitionstep\'\" sx-field=\"\'step_id\'\" sx-war=\"\'six-consip\'\" sx-object=\"selectedStep.value\"></six-lookup></div></div></div></div></div></uib-tab><uib-tab index=\"2\" heading=\"Tempistiche\" ng-click=\"initFormuleDescriptors()\"><div class=\"col-md-12\"><div class=\"col-md-12 no-pad-l-r m-t-sm\"><div class=\"col-md-12 no-pad-l-r\" ng-show=\"workflowSelected(selected.model.workflow_id)\"><uib-tabset><uib-tab ng-click=\"setCurrentTab($index);\" ng-repeat=\"tab in arrayRet\" heading=\"{{tab.step_id.description}}\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"col-md-2\"><b>DATA INSERIMENTO</b></div><div class=\"col-md-2\"><b>DATA SCADENZA</b></div><div class=\"col-md-4\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"col-md-5 no-pad-l-r\"><b>TIPO GIORNI ACQ.</b></div><div class=\"col-md-7 no-pad-l-r\"><b>GIORNI ACQ.</b></div></div></div><div class=\"col-md-4\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"col-md-5 no-pad-l-r\"><b>TIPO GIORNI ATTI</b></div><div class=\"col-md-7 no-pad-l-r\"><b>GIORNI ATTI</b></div></div></div></div><div class=\"col-md-12 no-pad-l-r pad-list-t-b-15\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 no-pad-l-r\"><div class=\"col-md-2\"><select class=\"col-md-8 form-control\" ng-model=\"selected.model.steps[arrayIds[currentTab]].date_start\" ng-options=\"date.key[0] as date.title for date in dateStepArray[arrayIds[currentTab]]\"></select></div><div class=\"col-md-2\"><select class=\"col-md-8 form-control\" ng-model=\"selected.model.steps[arrayIds[currentTab]].date_end\" ng-options=\"date.key[0] as date.title for date in dateStepArray[arrayIds[currentTab]]\"></select></div><div class=\"col-md-4\"><div class=\"col-md-12 no-pad-l-r\" ng-init=\"setDefaultDays(arrayIds[currentTab])\"><div class=\"col-md-5 btn-group no-pad-l-r\"><label class=\"btn btn-default\" ng-model=\"selected.model.steps[arrayIds[currentTab]].type_days\" ng-change=\"refreshDays(arrayIds[currentTab])\" uib-btn-radio=\"\'number\'\" title=\"Numero giorni definito\"><i class=\"fa fa-sort-numeric-desc\" aria-hidden=\"true\"></i></label> <label class=\"btn btn-default\" ng-model=\"selected.model.steps[arrayIds[currentTab]].type_days\" ng-change=\"refreshDays(arrayIds[currentTab])\" uib-btn-radio=\"\'formula\'\" title=\"Numero giorni da formula\"><i class=\"fa fa-cogs\" aria-hidden=\"true\"></i></label> <label class=\"btn btn-default\" ng-model=\"selected.model.steps[arrayIds[currentTab]].type_days\" ng-change=\"refreshDays(arrayIds[currentTab])\" uib-btn-radio=\"\'nolimits\'\" title=\"Numero giorni illimitato\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></label></div><div class=\"col-md-7 no-pad-l-r\"><div class=\"col-md-12 no-pad-l-r\" ng-if=\"selected.model.steps[arrayIds[currentTab]].type_days != \'formula\'\"><input ng-disabled=\"selected.model.steps[arrayIds[currentTab]].type_days == \'nolimits\'\" ng-model=\"selected.model.steps[arrayIds[currentTab]].days\" class=\"form-control\" type=\"number\" min=\"0\" step=\"1\"></div><div class=\"col-md-12 no-pad-l-r\" ng-if=\"selected.model.steps[arrayIds[currentTab]].type_days == \'formula\'\"><select ng-model=\"selected.model.steps[arrayIds[currentTab]].formula_days\" ng-selected=\"selected.model.steps[arrayIds[currentTab]].formula_days == formula.code\" class=\"form-control\" ng-click=\"getParams(arrayIds[currentTab], \'formula_days\', \'params_days\')\" ng-options=\"formula.code as formula.description for formula in formulaList\"></select></div></div></div></div><div class=\"col-md-4\"><div class=\"col-md-12 no-pad-l-r\" ng-init=\"setDefaultDaysActs(arrayIds[currentTab])\"><div class=\"col-md-5 btn-group no-pad-l-r\"><label class=\"btn btn-default\" ng-model=\"selected.model.steps[arrayIds[currentTab]].type_days_acts\" ng-change=\"refreshDaysActs(arrayIds[currentTab])\" uib-btn-radio=\"\'number\'\" title=\"Numero giorni definito\"><i class=\"fa fa-sort-numeric-desc\" aria-hidden=\"true\"></i></label> <label class=\"btn btn-default\" ng-model=\"selected.model.steps[arrayIds[currentTab]].type_days_acts\" ng-change=\"refreshDaysActs(arrayIds[currentTab])\" uib-btn-radio=\"\'formula\'\" title=\"Numero giorni da formula\"><i class=\"fa fa-cogs\" aria-hidden=\"true\"></i></label> <label class=\"btn btn-default\" ng-model=\"selected.model.steps[arrayIds[currentTab]].type_days_acts\" ng-change=\"refreshDaysActs(arrayIds[currentTab])\" uib-btn-radio=\"\'nolimits\'\" title=\"Numero giorni illimitato\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></label></div><div class=\"col-md-7 no-pad-l-r\"><div class=\"col-md-12 no-pad-l-r\" ng-if=\"selected.model.steps[arrayIds[currentTab]].type_days_acts != \'formula\'\"><input ng-disabled=\"selected.model.steps[arrayIds[currentTab]].type_days_acts == \'nolimits\'\" ng-model=\"selected.model.steps[arrayIds[currentTab]].days_acts\" class=\"form-control\" type=\"number\" min=\"0\" step=\"1\"></div><div class=\"col-md-12 no-pad-l-r\" ng-if=\"selected.model.steps[arrayIds[currentTab]].type_days_acts == \'formula\'\"><select ng-model=\"selected.model.steps[arrayIds[currentTab]].formula_days_acts\" class=\"form-control\" ng-click=\"getParams(arrayIds[currentTab],\'formula_days_acts\', \'params_days_acts\')\" ng-options=\"formula.code as formula.description for formula in formulaList\"></select></div></div></div></div></div><div class=\"col-md-12 hr-margin-t\"><div class=\"col-md-5 no-pad-l-r\" ng-if=\"selected.model.steps[arrayIds[currentTab]].type_days == \'formula\'\"><h5><b>Parametri formula acquisizione</b></h5><div class=\"col-md-12 no-pad-l-r pnl-margin-l-r\"><textarea class=\"form-control\" rows=\"4\" ng-model=\"formuleStrBodyDays[arrayIds[currentTab]]\" disabled=\"\"></textarea></div><div ng-repeat=\"(key, value) in selected.model.steps[arrayIds[currentTab]].params_days\"><div class=\"col-md-12 no-pad-l-r pnl-margin-l-r\"><div class=\"col-md-1 no-pad-l-r cont-center\">{{key}}</div><div class=\"col-md-11 no-pad-l-r\"><input type=\"string\" class=\"form-control\" ng-model=\"selected.model.steps[arrayIds[currentTab]].params_days[key]\"></div></div></div></div><div class=\"no-pad-l-r\" ng-class=\"getFormattedParams(arrayIds[currentTab])\" ng-if=\"selected.model.steps[arrayIds[currentTab]].type_days_acts == \'formula\'\"><h5><b>Parametri formula atti aggiuntivi</b></h5><div class=\"col-md-12 no-pad-l-r pnl-margin-l-r\"><textarea class=\"form-control\" rows=\"4\" ng-model=\"formuleStrBodyDaysActs[arrayIds[currentTab]]\" disabled=\"\"></textarea></div><div ng-repeat=\"(key, value) in selected.model.steps[arrayIds[currentTab]].params_days_acts\"><div class=\"col-md-12 no-pad-l-r pnl-margin-l-r\"><div class=\"col-md-1 no-pad-l-r cont-center\">{{key}}</div><div class=\"col-md-11 no-pad-l-r\"><input type=\"string\" class=\"form-control\" ng-model=\"selected.model.steps[arrayIds[currentTab]].params_days_acts[key]\"></div></div></div></div></div></uib-tab></uib-tabset></div></div></div></uib-tab></uib-tabset></form></div></div></div>");
$templateCache.put("consip/contract/contractconfigurator_detail.html","<six-toolbar><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-trash-o\" toolbar-function=\"delete()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Dettaglio Configurazione</h1></div></div></div><div class=\"panel wrapper\"><div class=\"panel-heading\"><div class=\"page-header-bleed-right\"><div class=\"actions\"><div class=\"row\"><form name=\"header\"><div class=\"form-group\"><div class=\"col-md-4\"><label id=\"schema_id_key\" for=\"code\" class=\"col-md-1 control-label\">Codice</label> <input type=\"text\" class=\"form-control\" id=\"code\" placeholder=\"\" ng-model=\"code\" name=\"code\" required=\"\" readonly=\"\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.code.$error.required\">Obbligatorio</span></div></div></div><div class=\"form-group\"><div class=\"col-md-4\"><label id=\"schema_desc_key\" for=\"description\" class=\"col-md-1 control-label\">Descrizione</label> <input type=\"text\" class=\"form-control\" id=\"description\" placeholder=\"\" ng-model=\"description\" name=\"description\" ng-keyup=\"refreshDescription(description)\" required=\"\" readonly=\"\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.description.$error.required\">Obbligatorio</span></div></div></div><div class=\"form-group\"><div class=\"col-md-4 override-padding-no-pad-left-right\"><div class=\"col-md-12\"><label class=\"col-md-1 control-label\">Convenzione</label><div id=\"vectors_budget_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"commissionsSelected.codes\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\" ng-change=\"refreshCommission()\" ng-disabled=\"true\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una commessa...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in commissions\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div></div></div><div class=\"form-group\"><div class=\"col-md-12\"><input type=\"checkbox\" id=\"attachment_management\" ng-model=\"attachmentManagement\" name=\"attachment_management\"> <label id=\"attachment_management_key\" for=\"attachment_management\" class=\"control-label\">Gestione allegati</label></div></div></form></div></div></div></div><div class=\"panel-body\"><uib-tabset justified=\"true\"><uib-tab heading=\"Convenzione\"><form name=\"myForm\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"model\" ng-submit=\"onSubmit(myForm)\"></form></uib-tab><uib-tab heading=\"Schema\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><div class=\"col-md-12 centered\"><b>SCHEMA</b></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><b>CODICE</b></div><div class=\"col-md-3\"><b>DESCRIZIONE</b></div><div class=\"col-md-1\"><b>TIPOLOGIA</b></div><div class=\"col-md-2\"><b>FORMATO</b></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><form name=\"propertyKeyForm\"><input class=\"form-control\" name=\"property_key\" placeholder=\"Codice...\" type=\"text\" ng-model=\"property.key\" pattern=\"^[a-zA-Z]+[\\w]*$\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"propertyKeyForm.property_key.$error.pattern\">Caratteri non consentiti</span></div></form></div></div><div class=\"col-md-3\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><input class=\"form-control\" placeholder=\"Descrizione\" type=\"text\" ng-model=\"property.title\"></div></div><div class=\"col-md-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.type\"><option></option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"boolean\">boolean</option><option value=\"date\">date</option><option value=\"array\">array</option></select></div></div><div class=\"col-md-2\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'string\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'number\' || property.type == \'integer\')\"><option></option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.items_type\" ng-if=\"(property.type == \'array\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"date\">date</option></select></div></div><div class=\"col-md-2\"><div ng-if=\"isInheritable(property.type)\"><label><input type=\"checkbox\" ng-model=\"property.inherited\"> Campo ereditato</label></div></div><div class=\"col-md-1\"><button ng-click=\"addProperty()\" class=\"btn btn-sm btn-info pull-right\"><span class=\"fa fa-plus\"></span> Add</button></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-repeat=\"(key, value) in selected.model.schema.properties\" style=\"align-content: center; padding-bottom: 0px;\"><div class=\"col-md-12 uniform-height\" style=\"align-content: center;\"><div class=\"col-md-1\"><a href=\"\" ng-click=\"status[key].open = !status[key].open\" id=\"btn_row_detail\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status[key].open, \'glyphicon-chevron-right\': !status[key].open}\"></i></a></div><div class=\"col-md-2\">{{ key }}</div><div class=\"col-md-3\">{{ value.title }}</div><div class=\"col-md-1\">{{ value.type }}</div><div class=\"col-md-2\"><span ng-if=\"value.format\">{{value.format}}</span> <span ng-if=\"value.type == \'array\' && value.items\">{{value.items.format}}</span></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"status[key].open\"><div class=\"col-md-12 uniform-height-2\" ng-if=\"value.format !== \'lookup\' && value.format !== \'formula\' && value.format !== \'enum\' && value.format !== \'inherit\' && value.type !== \'array\'\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-10\">{{value.format}}</div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'inherit\'\" ng-include=\"\'dataset/modeltype/detail_inherit.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'lookup\' && value.type != \'array\'\" ng-include=\"\'dataset/modeltype/detail_lookup.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'formula\'\" ng-include=\"\'dataset/modeltype/detail_formula.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'enum\'\" ng-include=\"\'dataset/modeltype/detail_enum.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.type === \'array\'\" ng-include=\"\'dataset/modeltype/detail_array.html\'\"></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ELIMINA:</div><div class=\"col-md-10\"><button ng-click=\"deleteProperty(key)\" class=\"btn btn-danger btn-xs btn-default\" ng-disabled=\"(key === \'code\' || key === \'description\')\"><i class=\"fa fa-trash\"></i></button></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">IN TABELLA:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.check\" ng-change=\"changeColumnDefs(key, value)\" ng-disabled=\"(key === \'code\' || key === \'description\')\"></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"value.check == true\"><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">LARGHEZZA (px):</div><div class=\"col-md-10\"><input type=\"text\" min=\"1\" step=\"1\" size=\"45\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"value.width\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ORDINAMENTO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableSorting\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FILTRAGGIO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableFiltering\" ng-change=\"changeColumnDefs(key, value)\"></div></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div></div></div></div></uib-tab><uib-tab heading=\"Form\"><table class=\"table table-striped\"><thead><th colspan=\"5\">FORM</th><tr><th colspan=\"5\"><div class=\"form-group\"><label for=\"title\" class=\"control-label\">Titolo</label><div class=\"\"><input type=\"text\" class=\"form-control\" id=\"title\" placeholder=\"\" ng-model=\"title\" name=\"title\" ng-keyup=\"refreshTitleForm(title)\"></div></div></th></tr><tr><td></td><td></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newTab.title\"></td><td><button ng-click=\"addTab(selected.model.form[0].items[0])\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th></th><th>POSIZIONE</th><th>TITOLO</th><th></th></tr></thead><tbody><tr ng-repeat-start=\"(key, tab) in selected.model.form[0].items[0].tabs\"><td><a href=\"\" ng-click=\"statusForm[key].open = !statusForm[key].open\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': statusForm[key].open, \'glyphicon-chevron-right\': !statusForm[key].open}\"></i></a></td><td><span class=\"btn btn-sm\" ng-click=\"swapUp(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key<=0\"><i class=\"fa fa-caret-up\"></i></span> {{key+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key>=selected.model.form[0].items[0].tabs.length-1\"><i class=\"fa fa-caret-down\"></i></span></td><td><input type=\"text\" ng-model=\"tab.title\" ng-disabled=\"(tab.key[0] == \'code\' || tab.key[0] == \'description\')\" ng-keyup=\"updateScope()\"></td><td><a ng-click=\"removeTabOrField(key, selected.model.form[0].items[0].tabs)\" class=\"btn btn-danger btn-xs btn-default\" id=\"btn_row_detail_form\"><i class=\"fa fa-trash\"></i></a></td></tr><tr ng-repeat-end=\"\" ng-show=\"statusForm[key].open\"><td></td><td colspan=\"3\" style=\"background-color:rgba(211, 211, 211, 0.38);\"><table class=\"table table-striped override-margin\"><tr><td></td><td><select ng-options=\"k as v.title for (k, v) in schema.properties\" ng-model=\"newFieldForm.key\"></select></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newFieldForm.title\"></td><td><input type=\"checkbox\" placeholder=\"Richiesto...\" ng-model=\"newFieldForm.required\"></td><td><select ng-model=\"newFieldForm.type\" ng-change=\"updateScope()\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><button ng-click=\"addFieldToTab(tab)\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th>POSIZIONE</th><th>CAMPO</th><th>TITOLO</th><th>REQUIRED</th><th>TIPO</th><th></th></tr><tr ng-repeat=\"(fieldKey, field) in tab.items\"><td class=\"override-width-200px\"><div><span class=\"btn btn-sm\" ng-click=\"swapUp(fieldKey, tab.items)\" ng-disabled=\"fieldKey<=0\"><i class=\"fa fa-caret-up\"></i></span> {{fieldKey+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(fieldKey, tab.items)\" ng-disabled=\"fieldKey>=tab.items.length-1\"><i class=\"fa fa-caret-down\"></i></span></div></td><td ng-if=\"!field.title\">{{field}}</td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"field.title\">{{field.key[0]}}</td><td ng-if=\"field.title\"><input type=\"text\" ng-model=\"field.title\" ng-keyup=\"updateScope()\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.required\" ng-change=\"updateScope()\"></td><td ng-if=\"field.title\"><select ng-model=\"field.type\" ng-change=\"updateField(field)\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><a ng-click=\"removeTabOrField(fieldKey, tab.items)\" class=\"btn btn-danger btn-xs btn-default\"><i class=\"fa fa-trash\"></i></a></td></tr></table></td></tr></tbody></table></uib-tab></uib-tabset></div><div class=\"panel-footer\"><div class=\"form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" data-toggle=\"collapse\" data-target=\"#json-collapse\" class=\"pull-left\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div></div></div><div class=\"row collapse\" id=\"json-collapse\"><div class=\"col-md-8\"><div class=\"panel-heading wrapper b-b b-light\"><h4 class=\"font-thin m-t-none m-b-none text-muted\">Dettaglio</h4></div><div style=\"margin-top:0px;\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'json\', firstLineNumber: 1, onLoad: aceLoaded, onChange: aceChanged }\" ng-model=\"aceModel\"></div><div class=\"panel-footer\"></div></div><div class=\"col-md-4\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{ model}}</pre></div></div></div></div></div>");
$templateCache.put("consip/contract/contractconfigurator_list.html","<six-toolbar><six-toolbar-button label=\"Crea configurazione\" icon=\"fa fa-plus\" toolbar-function=\"newContract()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista configurazioni convenzioni</h1></div></div></div><div class=\"panel-body\"><table id=\"contract_list\" class=\"table table-striped\"><thead><tr><th></th><th>CODICE CONFIGURAZIONE</th><th>CONVENZIONE</th><th>DATA</th></tr></thead><tbody><tr ng-repeat=\"item in contractList.list\"><td><a ng-href=\"#/contractconfigurator/{{item.version}}\" class=\"btn btn-default\"><span class=\"fa fa-search\"></span></a></td><td>{{ item.model.code }}</td><td>{{ item.model.commission }}</td><td>{{ item.dataIn | date:\'dd/MM/yyyy\' }}</td></tr><tr ng-hide=\"contractList.list.length\"><td><p class=\"text-center\">Nessun record recuperato</p></td></tr></tbody></table></div><div class=\"panel-footer\"><div class=\"row text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"contractList.totalResults\" ng-model=\"contractList.currentPage\" class=\"pagination-sm\" items-per-page=\"contractList.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div></div></div>");
$templateCache.put("consip/order/order_detail.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-download\" label=\"XLS\" btn-class=\"btn-info\" toolbar-function=\"export()\" sx-disabled=\"viewGridOptions.data.length == 0\"></six-toolbar-button><six-toolbar-button label=\"Adeguamento ISTAT\" btn-class=\"btn-info\" icon=\"fa fa-percent\" toolbar-function=\"showIstatDialog()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-trash\" label=\"Elimina\" btn-class=\"btn-danger\" toolbar-function=\"bulkDelete()\" sx-disabled=\"viewGridOptions.data.length == 0\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Ordine {{wizard.model.client_id.description}}</h1></div></div></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col col-md-12\"><six-grid-pagination sx-id=\"issues\" get-list-callback=\"getSourceAcquisition()\" get-data-callback=\"getOrder()\" items-list=\"orderRows\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" auto-resize-params=\"autoResizeParams\" show-global-search=\"false\"></six-grid-pagination></div></div></div></div></div>");
$templateCache.put("consip/order/order_list.html","<div class=\"col-md-12 pad-t-15\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista ordini</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"wizardList\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("consip/pricelists/pricelist_detail.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-download\" label=\"XLS\" btn-class=\"btn-info\" toolbar-function=\"export()\" sx-disabled=\"viewGridOptions.data.length == 0 || !isAlreadyPresent\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-upload\" label=\"Importa\" btn-class=\"btn-success\" toolbar-function=\"import()\" sx-disabled=\"viewGridOptions.data.length == 0 || isAlreadyPresent || importingError\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-trash\" label=\"Elimina\" btn-class=\"btn-danger\" toolbar-function=\"delete()\" sx-disabled=\"viewGridOptions.data.length == 0 || !isAlreadyPresent\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Listino {{wizard.model.client_id.description}}</h1></div></div></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col col-md-12\"><div id=\"viewGrid\" ui-grid=\"viewGridOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-cellnav=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\" ui-grid-auto-resize=\"\"><div class=\"grid-msg-overlay\" ng-show=\"!viewGridOptions.data.length\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"viewGridOptions\" multiple=\"false\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("consip/sal/sal_configuration_detail.html","<six-toolbar><six-toolbar-item icon=\"fa fa-exclamation text-danger-dker\" label=\"Selezionare un cliente per abilitare il salvataggio\" ng-show=\"isCustomerMissing()\"></six-toolbar-item><six-toolbar-item label=\"{{currentCustomer.description}}\" ng-hide=\"isCustomerMissing()\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-trash\" label=\"Elimina\" btn-class=\"btn-danger\" toolbar-function=\"deleteSalConfiguration()\" sx-disabled=\"configurationIsNew()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-save\" label=\"Salva\" btn-class=\"btn-success\" sx-disabled=\"isCustomerMissing()\" toolbar-function=\"saveSalConfiguration()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-12 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Configurazione SAL commessa: {{currentContract.code}} - cliente {{currentCustomer.description}}</h1></div></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><label class=\"control-label\">Codice:</label> <input type=\"text\" ng-model=\"configuration.model.code\" class=\"form-control no-grey\" ng-required=\"true\"></div></div><div class=\"row wrapper\"><div class=\"col-md-3\"><label class=\"control-label\">Tipo:</label><six-select-2 sx-id=\"service_type\" sx-list=\"serviceTypeList\" sx-title=\"\'Tipo servizio\'\" ng-model=\"configuration.model\" sx-field=\"\'serviceType\'\" sx-multiple=\"false\" sx-show-key=\"false\"></six-select-2></div><div class=\"col-md-3\"><label class=\"control-label\">Edifici:</label><six-lookup-2 sx-id=\"assets\" sx-base-path=\"\'record\'\" sx-type=\"\'edificio\'\" sx-title=\"\'Edificio\'\" ng-model=\"configuration.model\" sx-field=\"\'assets\'\" sx-show-filters=\"true\" sx-show-details=\"true\" sx-multiple=\"true\"></six-lookup-2></div><div class=\"col-md-3\"><label class=\"control-label\">Gruppi servizio:</label><six-lookup-2 sx-id=\"service_groups\" sx-base-path=\"\'record\'\" sx-type=\"\'classeservizio\'\" sx-title=\"\'Gruppo servizio\'\" ng-model=\"configuration.model\" sx-field=\"\'serviceGroups\'\" sx-show-filters=\"true\" sx-show-details=\"true\" sx-multiple=\"true\"></six-lookup-2></div><div class=\"col-md-3\"><label class=\"control-label\">Servizi:</label><six-lookup-2 sx-id=\"service\" sx-base-path=\"\'record\'\" sx-type=\"\'servizio\'\" sx-title=\"\'Servizio\'\" ng-model=\"configuration.model\" sx-field=\"\'services\'\" sx-show-filters=\"true\" sx-show-details=\"true\" sx-multiple=\"true\"></six-lookup-2></div></div><div class=\"row wrapper\"><div class=\"col-md-8\"><label class=\"control-label\">Aggregazioni:</label><six-select-2 sx-id=\"aggregations\" sx-list=\"aggregationFields\" sx-title=\"\'Aggregazioni\'\" ng-model=\"configuration.model\" sx-field=\"\'aggregations\'\" sx-multiple=\"true\" sx-show-key=\"false\"></six-select-2></div></div></div></div>");
$templateCache.put("consip/sal/sal_detail.html","<six-toolbar><six-toolbar-item icon=\"fa fa-exclamation text-danger-dker\" label=\"Selezionare un cliente per abilitare il salvataggio\" ng-show=\"isCustomerMissing()\"></six-toolbar-item><six-toolbar-item label=\"{{currentCustomer.description}}\" ng-hide=\"isCustomerMissing()\"></six-toolbar-item><six-toolbar-item label=\"Esporta\" icon=\"fa fa-download text-info-dker\"><li><a href=\"\" ng-click=\"jasperReport(\'sal\', \'pdf\')\"><i class=\"fa fa-file-pdf-o text-success-dker\"></i> PDF</a></li><li><a href=\"\" ng-click=\"jsonReport()\"><i class=\"fa fa-file-code-o\"></i> JSON</a></li></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"goToSalList()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh\" label=\"Aggiorna\" btn-class=\"btn-info\" toolbar-function=\"getSal()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-download\" label=\"Esporta\" btn-class=\"btn-default\" toolbar-function=\"export()\" sx-disabled=\"salRows.list.length == 0\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-trash\" label=\"Elimina\" btn-class=\"btn-danger\" toolbar-function=\"deleteSal()\" sx-disabled=\"salRows.list.length == 0\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-12 col-xs-12 col-md-12\"><h1 class=\"m-n font-thin h3 text-black\">Cod. SAL: {{currentSalCode}} - Cliente: {{currentCustomer.description}}</h1></div></div></div><div class=\"panel-body\"><uib-tabset active=\"activeTab\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-table text-info-dker\"></span> Dati</uib-tab-heading><uib-tabset class=\"tabs-right\"><form name=\"form\"><div class=\"row wrapper\"><div class=\"col-md-12\"><div class=\"row padder-v-xs\"><div class=\"col-md-4\"><div class=\"control-group\"><label class=\"control-label\">Codice:</label> <input id=\"salCode\" name=\"salCode\" type=\"text\" ng-model=\"headerSalInformation.code\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-8\"><div class=\"control-group\"><label class=\"control-label\">Descrizione:</label> <input id=\"salDescription\" name=\"salDescription\" type=\"text\" ng-model=\"headerSalInformation.description\" class=\"form-control\" readonly=\"\"></div></div></div></div></div><div class=\"col-md-12\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><a data-toggle=\"collapse\" data-target=\"#collapseOne\" ng-click=\"filtersPan.open = !filtersPan.open\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': filtersPan.open, \'fa-angle-right\': !filtersPan.open}\"></i> Filtri report</h4></div></a><div id=\"collapseOne\" class=\"collapse\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-2 padder-v-xs\"><label class=\"control-label\">Tipo periodo:</label><six-select-2 sx-id=\"period_type\" sx-list=\"periodTypeList\" sx-title=\"\'Tipo periodo\'\" ng-model=\"periodType\" sx-field=\"\'selected\'\" sx-multiple=\"false\" sx-clearable=\"false\" sx-show-key=\"false\"></six-select-2></div><div class=\"col-md-4 padder-v-xs\"><div class=\"control-group\" ng-class=\"{\'has-error\': form.datePickerFrom.$invalid}\"><label class=\"control-label\">Periodo da:</label><six-date-time-picker name=\"datePickerFrom\" ng-model=\"datePicker.from\" date-options=\"dateOptionsFrom\" format=\"dateFormat\" ng-required=\"true\" date-validation=\"\" is-before=\"{{datePicker.to}}\"></six-date-time-picker><span ng-messages=\"form.datePickerFrom.$error\" class=\"error alert-b-r\" role=\"alert\"><span ng-message=\"date\">Data non valida</span> <span ng-message=\"temporal\">Intervallo non valido</span> <span ng-message=\"required\">Obbligatorio</span></span></div></div><div class=\"col-md-4 padder-v-xs\"><label class=\"control-label\">Periodo a:</label><six-date-time-picker name=\"datePickerTo\" ng-model=\"datePicker.to\" date-options=\"dateOptionsTo\" format=\"dateFormat\" sx-disabled=\"periodType.selected.key!=\'custom\'\" ng-required=\"true\" date-validation=\"\" is-after=\"{{datePicker.from}}\"></six-date-time-picker><span ng-messages=\"form.datePickerTo.$error\" class=\"error alert-b-r\" role=\"alert\"><span ng-message=\"date\">Data non valida</span> <span ng-message=\"temporal\">Intervallo non valido</span> <span ng-message=\"required\">Obbligatorio</span></span></div></div><div class=\"row\"><div class=\"col-md-4 padder-v-xs\"><label class=\"control-label\">Edifici:</label><six-lookup-2 sx-id=\"assets\" sx-base-path=\"\'record\'\" sx-type=\"\'edificio\'\" sx-title=\"\'Edificio\'\" ng-model=\"assets\" sx-field=\"\'selected\'\" sx-show-filters=\"true\" sx-show-details=\"true\" sx-add=\"true\" sx-multiple=\"true\"></six-lookup-2></div><div class=\"col-md-4 padder-v-xs\"><label class=\"control-label\">Gruppi servizio:</label><six-lookup-2 sx-id=\"service_groups\" sx-base-path=\"\'record\'\" sx-type=\"\'classeservizio\'\" sx-title=\"\'Gruppo servizio\'\" ng-model=\"serviceGroups\" sx-field=\"\'selected\'\" sx-show-filters=\"true\" sx-multiple=\"true\"></six-lookup-2></div><div class=\"col-md-4 padder-v-xs\"><label class=\"control-label\">Servizi:</label><six-lookup-2 sx-id=\"service\" sx-base-path=\"\'record\'\" sx-type=\"\'servizio\'\" sx-title=\"\'Servizio\'\" ng-model=\"services\" sx-field=\"\'selected\'\" sx-show-filters=\"true\" sx-multiple=\"true\"></six-lookup-2></div><div class=\"col-md-8 padder-v-xs\"><label class=\"control-label\">Aggregazioni:</label><six-select-2 sx-id=\"aggregations\" sx-list=\"aggregationFields\" sx-title=\"\'Aggregazioni\'\" ng-model=\"aggregations\" sx-field=\"\'selected\'\" sx-multiple=\"true\" sx-show-key=\"false\"></six-select-2></div></div></div></div></div></div></div></form><div class=\"row wrapper\"><div class=\"col col-md-12\"><six-grid-pagination sx-id=\"salrows\" get-list-callback=\"getSal()\" get-data-callback=\"getSal()\" get-all-data-callback=\"getAllSal()\" items-list=\"salRows\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" auto-resize-params=\"autoResizeParams\" show-global-search=\"false\"></six-grid-pagination></div></div><div class=\"panel-body\"><pre>{{result | json}}</pre></div></uib-tabset></uib-tab><uib-tab index=\"1\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Gestione documenti</uib-tab-heading><uib-tabset class=\"tabs-right\"><div id=\"upload_div\" class=\"m-t-sm\"><div class=\"col col-md-12 wrapper\" ng-if=\"upload.errors.length>0\"><div class=\"alert alert-danger\"><strong>Caricamento FALLITO</strong><div ng-repeat=\"error in upload.errors\">{{error}}</div></div></div><input type=\"file\" id=\"fileUploadBtn\" nv-file-select=\"\" uploader=\"uploader\" class=\"inputfile\" style=\"display:none\"><div class=\"panel panel-default\" ng-if=\"upload.show\"><div class=\"panel-footer\"><table class=\"table\"><thead><tr><th>Nome file</th><th ng-show=\"uploader.isHTML5\">Dimensione</th><th ng-show=\"uploader.isHTML5\">Avanzamento</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue\" ng-init=\"item.popupSendingOpened=false\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }} MB</td><td ng-show=\"uploader.isHTML5\"><div class=\"progress\" style=\"margin-bottom: 0;\"><div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ \'width\': item.progress + \'%\' }\"></div></div></td></tr><tr><th colspan=\"5\"><button class=\"btn btn-default\" ng-click=\"addQuote()\" ng-disabled=\"readonlyMode\"><span class=\"fa fa-plus\"></span> Aggiungi file</button> <button type=\"button\" class=\"btn btn-default btn-s\" ng-click=\"uploader.uploadAll()\"><span class=\"fa fa-check\"></span> Conferma</button> <button type=\"button\" class=\"btn btn-default btn-s\" ng-click=\"undoUpload()\" ng-disabled=\"upload.started\"><span class=\"fa fa-undo\"></span> Annulla</button></th></tr></tbody></table></div></div></div><div id=\"uploaded_div\" class=\"wrapper m-t-n-lg\"><div class=\"alert alert-warning\" ng-if=\"upload.warnings.length>0\"><strong>Attenzione</strong><div ng-repeat=\"warning in upload.warnings\">{{warning}}</div></div><div ng-hide=\"(attachmentsListDocument.length>0) || (upload.show)\" class=\"alert alert-info\">Nessun documento caricato</div><div><div class=\"pdi_element\"><div class=\"row pdi_file_row\"><div class=\"col col-md-12\" ng-repeat=\"file in attachmentsListDocument\"><h4 class=\"pdi_title\"><a ng-href=\"{{DOWNLOAD_URL}}{{file.object_id}}\" target=\"_blank\" download=\"{{file.title}}\" class=\"h5\">Nome documento: <strong>{{file.title}}</strong> <i class=\"fa fa-arrow-down\" aria-hidden=\"true\"></i></a></h4><div class=\"pdi_file col-md-12 override-padding-no-pad-left-right\"><span class=\"pull-left thumb-sm\"><i class=\"fa fa-file-o fa-2x text-muted\"></i></span><div class=\"col-md-2\"><div class=\"media-body\"><small class=\"block\">Data caricamento</small> <small class=\"block\">{{file.date_insertion | date:\'dd/MM/yyyy\'}}</small></div></div><div class=\"col-md-2\"><div class=\"media-body\"><small class=\"block\">Utente caricamento</small> <small class=\"block\">{{file.user}}</small></div></div></div></div></div></div></div></div><div id=\"upload_button_div\" ng-if=\"!upload.show\" class=\"col-md-12\"><button class=\"btn btn-default\" ng-click=\"loadQuote()\" ng-disabled=\"readonlyMode\">Carica</button></div></uib-tabset></uib-tab><uib-tab index=\"2\" disable=\"currentSalCode == null\" select=\"getMessage()\"><uib-tab-heading><span class=\"fa fa-envelope text-info-dker\"></span> Messaggi</uib-tab-heading><uib-tabset class=\"tabs-right\"><div class=\"col-md-12\" ng-if=\"loadingSixMail == true\"><uib-progressbar class=\"progress-striped active\" type=\"info\"><i>Caricamento messaggio</i></uib-progressbar></div><six-send-email ng-if=\"loadingSixMail == false\" sx-title-mail=\"objMail.title\" sx-body-mail=\"objMail.message\" sx-to-mail=\"objMail.to\" sx-cc-mail=\"objMail.cc\" sx-type-mail=\"\'sal\'\" sx-record-id=\"currentSalRef\" sx-alfresco-attachments=\"true\"></six-send-email></uib-tabset></uib-tab><uib-tab index=\"3\" disable=\"currentSalCode == null\" select=\"getNotificationsList()\"><uib-tab-heading><span class=\"icon-bell text-info-dker\"></span> Notifiche</uib-tab-heading><div ng-if=\"notifications.length==0\" class=\"alert alert-info\" role=\"alert\">Nessun messaggio inviato</div><ul class=\"list-group list-group-lg no-radius m-b-none m-t-n-xxs\"><li ng-repeat=\"notification in notifications\" class=\"list-group-item clearfix b-l-3x ng-scope\" ng-class=\"notification.color\"><span class=\"avatar thumb pull-left m-r\"><img ng-hide=\"notification.user\" ng-src=\"/images/avatar_system.png\"> <img ng-show=\"notification.user\" ng-src=\"/images/avatar_emil.png\"></span><div class=\"pull-right text-sm text-muted\"><span class=\"hidden-xs ng-binding\">{{notification.dataIn | date:\"dd/MM/yyyy\"}}</span></div><div class=\"clear\"><div><a class=\"text-md ng-binding\" ng-href=\"{{notification.href}}\"><span ng-show=\"notification.model.subject\">Oggetto: {{notification.model.subject}}</span> <span ng-show=\"notification.user\">da {{notification.user}}</span> <span ng-show=\"notification.model.to\">a {{notification.model.to}}</span></a></div><div class=\"text-ellipsis m-t-xs ng-binding\">{{notification.model.bodyAsText}}</div></div></li></ul></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("consip/sal/sal_list.html","<six-toolbar><six-toolbar-button icon=\"fa fa-plus\" label=\"Nuovo\" btn-class=\"btn-success\" toolbar-function=\"goToNewSal()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista SAL</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getListSal()\" get-list-callback=\"getListSal()\" items-list=\"listSalRows\" column-defs=\"viewGridListSalOptions.columnDefs\" grid-app-callbacks=\"gridAppCallbacks\" grid-options=\"viewGridListSalOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("consip/sal/sal_new.html","<style type=\"text/css\">\n  .ui-grid-row .toedit {\n    background-color: rgb(255, 255, 175) !important;\n  }\n  .ui-grid-row-dirty .ui-grid-cell {\n    color: rgb(0, 150, 0);\n  }\n  .highlight-row {\n    background-color: #00fcf3;\n    padding: 0 4px 0 4px;\n    border: thin solid lightblue;\n  }\n</style><script type=\"text/ng-template\" id=\"dialogTemplate.html\"><strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">ATTENZIONE</h4></div> <table align=\"center\" style=\"text-align: right;\"> <caption style=\"text-align: right\">{{allCount}} righe totali di cui:</caption> <tr><td>a canone:</td><td style=\"padding-left: 5px\">{{canoneCount}}</td></tr> <tr><td>extra-canone non modificate:</td><td style=\"padding-left: 5px\">{{notModifiedCount}}</td></tr> <tr><td>extra-canone con importo nullo:</td><td style=\"padding-left: 5px\">{{zeroAmountCount}}</td></tr> <tr><td>con residui negativi:</td><td style=\"padding-left: 5px\">{{errors}}</td></tr> <tr><td>già generate:</td><td style=\"padding-left: 5px\">{{alreadyGeneratedCount}}</td></tr> <tr><td>in sovrascrittura:</td><td style=\"padding-left: 5px\">{{inOverrideCount}}</td></tr> </table> <div class=\"row m-t\"> <div class=\"col-sm-12\" style=\"text-align: center\"> <i>N.B. le righe \"in sovrascrittura\" elimineranno le corrispondenti righe coinvolte in altri SAL già emessi</i> </div> </div> <div class=\"row m-t\"> <div class=\"col-sm-4\" style=\"text-align: center\"> <button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"saveAll(); closeThisDialog();\" ng-disabled=\"allToSaveCount==0\"><i class=\"fa fa-save\"></i> Salva tutto ({{allToSaveCount}})</button> </div> <div class=\"col-sm-4\" style=\"text-align: center\"> <button type=\"button\" class=\"btn btn-sm btn-warning\" ng-click=\"saveDirty(); closeThisDialog();\" ng-disabled=\"canoneToSaveCount+dirtyToSaveCount==0\"><i class=\"fa fa-save\"></i> Salva canone + mod. ({{canoneToSaveCount}}+{{dirtyToSaveCount}})</button> </div> <div class=\"col-sm-4\" style=\"text-align: center\"> <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"closeThisDialog()\"><i class=\"fa fa-undo\"></i> Annulla</button> </div> </div></script><script type=\"text/ng-template\" id=\"dialogOldRowTemplate.html\"><strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">Riga già generata</h4></div> <table class=\"tinyTable\"> <tr> <th>Cod. SAL</th> <th>Edificio</th> <th>Classe serv.</th> <th>Servizio</th> <th>Tipo serv.</th> <th>Data inizio</th> <th>Data fine</th> <th>Importo</th> <th>Totale</th> <th>Erogato</th> <th>Residuo</th> </tr> <tr> <td colspan=\"11\" class=\"head\">Vecchia riga</td> </tr> <tr ng-class=\"{\'highlight-row\': !newRow.override}\" role=\"button\" ng-click=\"newRow.override = false;\"> <td>{{oldRow.model.sal_code}}</td> <td>{{oldRow.model.asset_id.code}} - {{oldRow.model.asset_id.description}}</td> <td>{{oldRow.model.serviceclass_id.code}} - {{oldRow.model.serviceclass_id.description}}</td> <td>{{oldRow.model.service_id.code}} - {{oldRow.model.service_id.description}}</td> <td>{{oldRow.model.service_type}}</td> <td class=\"dateCell\">{{oldRow.model.start_date | date:\'dd/MM/yyyy\'}}</td> <td class=\"dateCell\">{{oldRow.model.end_date | date:\'dd/MM/yyyy\'}}</td> <td class=\"numberCell\">{{oldRow.model.amount | currency:\'€\':3}}</td> <td class=\"numberCell\">{{oldRow.model.total_amount | currency:\'€\':3}}</td> <td class=\"numberCell\">{{oldRow.model.provided_amount | currency:\'€\':3}}</td> <td class=\"numberCell\">{{oldRow.model.residual_amount | currency:\'€\':3}}</td> </tr> <tr> <td colspan=\"11\" class=\"head\">Nuova riga</td> </tr> <tr ng-class=\"{\'highlight-row\': newRow.override}\" role=\"button\" ng-click=\"newRow.override = true;\"> <td>{{newRow.model.sal_code}}</td> <td>{{newRow.model.asset_id.code}} - {{newRow.model.asset_id.description}}</td> <td>{{newRow.model.serviceclass_id.code}} - {{newRow.model.serviceclass_id.description}}</td> <td>{{newRow.model.service_id.code}} - {{newRow.model.service_id.description}}</td> <td>{{newRow.model.service_type}}</td> <td class=\"dateCell\">{{newRow.model.start_date | date:\'dd/MM/yyyy\'}}</td> <td class=\"dateCell\">{{newRow.model.end_date | date:\'dd/MM/yyyy\'}}</td> <td class=\"numberCell\">{{newRow.model.amount | currency:\'€\':3}}</td> <td class=\"numberCell\">{{newRow.model.total_amount | currency:\'€\':3}}</td> <td class=\"numberCell\">{{newRow.model.provided_amount | currency:\'€\':3}}</td> <td class=\"numberCell\">{{newRow.model.residual_amount | currency:\'€\':3}}</td> </tr> </table></script><six-toolbar><six-toolbar-item icon=\"fa fa-exclamation text-danger-dker\" label=\"Selezionare un cliente per abilitare la funzione\" ng-show=\"isCustomerMissing()\"></six-toolbar-item><six-toolbar-item label=\"{{currentCustomer.description}}\" ng-hide=\"isCustomerMissing()\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"goToSalList()\" ng-hide=\"isCustomerMissing()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-undo\" label=\"Reset\" btn-class=\"btn-info\" toolbar-function=\"resetSalRows()\" sx-disabled=\"salRows.list.length == 0\" ng-hide=\"isCustomerMissing()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-gears\" label=\"Crea\" btn-class=\"btn-success\" toolbar-function=\"create()\" sx-disabled=\"salRows.list.length > 0 || form.$invalid || !isSalGenerable\" ng-hide=\"isCustomerMissing()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-save\" label=\"Salva\" btn-class=\"btn-success\" toolbar-function=\"saveWithDialog()\" sx-disabled=\"salRows.list.length == 0\" ng-hide=\"isCustomerMissing()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\" ng-hide=\"isCustomerMissing()\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12 col-md-12\"><span class=\"error pull-right\" role=\"alert\" ng-if=\"!acquisition\">Impossibile recuperare le informazioni di contratto</span> <span class=\"error pull-right\" role=\"alert\" ng-if=\"acquisition && isSalGenerable\">Il contratto risulta NON attivo nelle date selezionate: data inizio contratto: {{acquisition.model.start_contract_date | date: \'dd/MM/yyyy\'}}, data fine contratto: {{acquisition.model.end_contract_date | date: \'dd/MM/yyyy\'}}</span><h1 class=\"m-n font-thin h3 text-black\">Creazione SAL cliente {{currentCustomer.description}}</h1>{{isSalGenerable}}</div></div></div><form name=\"form\" class=\"wrapper\"><div class=\"row\"><div class=\"col-md-2 padder-v-xs\"><label class=\"control-label\">Tipo periodo:</label><six-select-2 sx-id=\"period_type\" sx-list=\"periodTypeList\" sx-title=\"\'Tipo periodo\'\" ng-model=\"periodType\" sx-field=\"\'selected\'\" sx-multiple=\"false\" sx-clearable=\"false\" sx-show-key=\"false\"></six-select-2></div><div class=\"col-md-2 padder-v-xs\"><div class=\"control-group\" ng-class=\"{\'has-error\': getErrors(form.datePickerFrom)}\"><label class=\"control-label\">Periodo da:</label><six-date-time-picker name=\"datePickerFrom\" ng-model=\"datePicker.from\" date-options=\"dateOptionsFrom\" format=\"dateFormat\" ng-required=\"true\"></six-date-time-picker><span ng-messages=\"form.datePickerFrom.$error\" class=\"error alert-b-r\" role=\"alert\"><span ng-message=\"date\">Data non valida</span> <span ng-message=\"temporal\">Intervallo non valido</span> <span ng-message=\"required\">Obbligatorio</span></span></div></div><div class=\"col-md-2 padder-v-xs\"><div class=\"control-group\" ng-class=\"{\'has-error\': getErrors(form.datePickerTo)}\"><label class=\"control-label\">Periodo a:</label><six-date-time-picker name=\"datePickerTo\" ng-model=\"datePicker.to\" date-options=\"dateOptionsTo\" format=\"dateFormat\" sx-disabled=\"periodType.selected.key!=\'custom\'\" ng-required=\"true\"></six-date-time-picker><span ng-messages=\"form.datePickerTo.$error\" class=\"error alert-b-r\" role=\"alert\"><span ng-message=\"date\">Data non valida</span> <span ng-message=\"temporal\">Intervallo non valido</span> <span ng-message=\"required\">Obbligatorio</span></span></div></div><div class=\"col-md-6 padder-v-xs\"><div class=\"control-group\" ng-class=\"{\'has-error\': form.salCode.$invalid}\"><label class=\"control-label\">Codice:</label> <input id=\"salCode\" name=\"salCode\" type=\"text\" ng-model=\"salCode\" class=\"form-control\" ng-minlength=\"3\" ng-required=\"true\" ng-readonly=\"salRows.list.length>0\" unique-validation=\"salFactory\" unique-field=\"model.sal_code\"> <span ng-messages=\"form.salCode.$error\" class=\"error alert-b-r\" role=\"alert\"><span ng-message=\"required\">Il codice è obbligatorio</span> <span ng-message=\"unique\">Il codice è già stato utilizzato</span> <span ng-message=\"minlength\">Minimo 3 caretteri</span></span></div></div><div class=\"col-md-12 padder-v-xs\"><div class=\"control-group\" ng-class=\"{\'has-error\': form.salDescription.$invalid}\"><label class=\"control-label\">Descrizione:</label> <input id=\"salDescription\" name=\"salDescription\" type=\"text\" ng-model=\"salDescription\" class=\"form-control\" ng-minlength=\"3\" ng-required=\"true\" ng-readonly=\"salRows.list.length>0\"> <span ng-messages=\"form.salDescription.$error\" class=\"error alert-b-r\" role=\"alert\"><span ng-message=\"required\">La descrizione è obbligatoria</span> <span ng-message=\"unique\">La descrizione è già stata utilizzata</span> <span ng-message=\"minlength\">Minimo 3 caratteri</span></span></div></div></div><div class=\"row padder-v-xs\"><div class=\"col-md-4 padder-v-xs\"><label class=\"control-label\">Edifici:</label><six-lookup-2 sx-id=\"assets\" sx-base-path=\"\'record\'\" sx-type=\"\'edificio\'\" sx-title=\"\'Edificio\'\" sx-empty-placeholder=\"\'Tutti gli edifici\'\" ng-model=\"assets\" sx-field=\"\'selected\'\" sx-show-filters=\"true\" sx-show-details=\"true\" sx-multiple=\"true\"></six-lookup-2></div><div class=\"col-md-4 padder-v-xs\"><label class=\"control-label\">Gruppi servizio:</label><six-lookup-2 sx-id=\"service_groups\" sx-base-path=\"\'record\'\" sx-type=\"\'classeservizio\'\" sx-title=\"\'Gruppo servizio\'\" sx-empty-placeholder=\"\'Tutti i gruppi servizio\'\" ng-model=\"serviceGroups\" sx-field=\"\'selected\'\" sx-show-filters=\"true\" sx-show-details=\"true\" sx-multiple=\"true\"></six-lookup-2></div><div class=\"col-md-4 padder-v-xs\"><label class=\"control-label\">Servizi:</label><six-lookup-2 sx-id=\"service\" sx-base-path=\"\'record\'\" sx-type=\"\'servizio\'\" sx-title=\"\'Servizio\'\" sx-empty-placeholder=\"\'Tutti i servizi\'\" ng-model=\"services\" sx-field=\"\'selected\'\" sx-show-filters=\"true\" sx-show-details=\"true\" sx-multiple=\"true\"></six-lookup-2></div><div class=\"col-md-2 padder-v-xs\"><label class=\"control-label\">Tipo servizio:</label><six-select-2 sx-id=\"service_type\" sx-list=\"serviceTypeList\" sx-title=\"\'Tipo servizio\'\" ng-model=\"serviceType\" sx-field=\"\'selected\'\" sx-placeholder=\"\'Tutto\'\" sx-multiple=\"false\" sx-show-key=\"false\"></six-select-2></div><div class=\"col-md-2 padder-v-xs\"><label class=\"control-label\">Tipo riga:</label><six-select-2 sx-id=\"row_type\" sx-list=\"rowTypeList\" sx-title=\"\'Tipo riga\'\" ng-model=\"rowType\" sx-field=\"\'selected\'\" sx-placeholder=\"\'Tutto\'\" sx-multiple=\"false\" sx-show-key=\"false\"></six-select-2></div><div class=\"col-md-8 padder-v-xs\"><label class=\"control-label\">Aggregazioni:</label><six-select-2 sx-id=\"aggregations\" sx-list=\"aggregationFields\" sx-title=\"\'Aggregazioni\'\" sx-empty-placeholder=\"\'Nessuna\'\" ng-model=\"aggregations\" sx-field=\"\'selected\'\" sx-multiple=\"true\" sx-show-key=\"false\"></six-select-2></div></div></form></div><div class=\"panel panel-default constructor\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col col-md-12\"><div id=\"salrows_grid\" class=\"grid\" ui-grid=\"viewGridOptions\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\" ui-grid-move-columns=\"\" ui-grid-auto-resize=\"\" ui-grid-exporter=\"\" ui-grid-edit=\"\" ui-grid-row-edit=\"\" ui-grid-cellnav=\"\" external-scopes=\"clickHandler\"></div></div></div></div></div></div>");
$templateCache.put("core/avertShipment/avertShipment.html","<six-toolbar static-title=\"{{ \'avert_shipment\' | translate}}\"><six-toolbar-button label=\"Indietro\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"wrapper-md m-t-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3 col-lg-6\"><label>{{\"barcode\" | translate}}</label><six-code-reader sx-on-read=\"load(read.read)\"><six-code-reader></six-code-reader></six-code-reader></div></div></div></div><div class=\"alert alert-info\" ng-if=\"ddt\">{{\"read_msg\" | translate}} <strong>{{avertRequest.type | translate}}</strong> {{avertRequest.barcode}} <button type=\"button\" class=\"btn btn-danger btn-sm pull-right\" ng-click=\"avert()\">{{\"avert\" | translate}}</button></div><div class=\"alert alert-danger\" role=\"alert\" ng-if=\"error\"><span translate=\"\" translate-default=\"{{error.message}}\">{{error.error_code}}</span> <a href=\"\" class=\"pull-right\" ng-click=\"detail = !detail\" ng-hide=\"!error.message\"><i class=\"fa\" ng-class=\"{\'fa-chevron-down\':!detail ,\'fa-chevron-up\':detail}\" aria-hidden=\"true\"></i></a><div ng-if=\"detail\"><hr class=\"m-b-lg\">{{error.message}}</div></div><div class=\"panel panel-info\" ng-if=\"ddt\"><div class=\"panel-heading\"><h3 class=\"panel-title\">{{\"shipment\" | translate}}</h3></div><div class=\"panle-body\"><div class=\"row\"><div class=\"col-lg-12\"><dl class=\"dl-horizontal m-t-sm\"><dt>{{\"shipment.ddt_number\" | translate}}</dt><dd>{{ddt.number}}</dd><dt>{{\"barcode\" | translate}}</dt><dd>{{ddt.barcode}}</dd><dt>{{\"date\" | translate}}</dt><dd>{{ddt.date}}</dd><dt>{{\"state\" | translate}}</dt><dd>{{\"shipment.\" + ddt.state | translate}}</dd><dt>{{\"customer\" | translate}}</dt><dd>{{ddt.customerName}}</dd><dt>{{\"shipment.customer_description\" | translate}}</dt><dd>{{ddt.customerDestination}}</dd></dl></div></div></div></div></div>");
$templateCache.put("core/shipmentdocument/shipmentDocument_detail.html","<six-toolbar><six-toolbar-button label=\"{{ \'back\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"override-padding-toolbar\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"m-n font-thin\">{{ \"shipment_document\" | translate }}</h1></div></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><uib-tabset justified=\"false\" active=\"activeTab\" class=\"tab-container\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"tab-heading\">{{ \"tab_head\" | translate }}</span></uib-tab-heading><div ng-include=\"\'core/shipmentdocument/shipmentDocument_tabHead.html\'\" ng-if=\"element\"></div></uib-tab><uib-tab index=\"1\"><uib-tab-heading><span class=\"tab-heading\">{{ \"tab_rows\" | translate }}</span></uib-tab-heading><div ng-include=\"\'core/shipmentdocument/shipmentDocument_tabRows.html\'\"></div></uib-tab><uib-tab index=\"2\"><uib-tab-heading><span class=\"tab-heading\">{{ \"tab_footer\" | translate }}</span></uib-tab-heading><div ng-include=\"\'core/shipmentdocument/shipmentDocument_tabFooter.html\'\"></div></uib-tab></uib-tabset></div></div><div ng-include=\"\'theme/record/std_panel_six.html\'\" class=\"panel panel-default\"></div></div>");
$templateCache.put("core/shipmentdocument/shipmentDocument_list.html","<six-toolbar static-title=\"{{ \'shipment_document\' | translate }}\"><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"goBack()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-plus\" label=\"{{\'new\' | translate}}\" btn-class=\"btn-info\" toolbar-function=\"goToNew()\" ng-if=\"permission.NEW\"></six-toolbar-button></six-toolbar><div class=\"wrapper-md m-t-xxl\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3\"><label>{{ \"barcode\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"advFilter.filter.barcode\"></div><div class=\"col-md-3\"><label>{{ \"shipment.ddt_number\" | translate }}</label> <input type=\"number\" class=\"form-control\" ng-model=\"advFilter.filter.ddt_number\"></div><div class=\"col-md-3\"><label>{{ \"bar\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"advFilter.filter.bar\"></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">{{ \"state\" | translate }}</label><six-enum sx-model=\"advFilter.filter\" sx-field=\"state\" sx-options=\"enum.state\" sx-readonly=\"readOnly\"></six-enum></div><div class=\"col-md-3\"><label>{{ \"from_date\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.ddt_date_from\"></six-date-picker></div><div class=\"col-md-3\"><label>{{ \"to_date\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.ddt_date_to\"></six-date-picker></div><div class=\"col-md-3\"><label>{{ \"shipment.delivery_date\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.delivery_date\"></six-date-picker></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">{{ \"shipment.integration_type\" | translate }}</label><six-enum sx-model=\"advFilter.filter\" sx-field=\"integration_type\" sx-options=\"enum.integration_type\" sx-readonly=\"readOnly\"></six-enum></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">{{ \"customer\" | translate }}</label><six-lookup ng-model=\"lookup.customer_id\" sx-filter=\"customerFilter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.customer_id\" sx-type=\"\'customer\'\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">{{ \"destination\" | translate }}</label><six-lookup ng-model=\"lookup.customer_destination\" sx-filter=\"shipmentDestinationFilter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.customer_destination\" sx-type=\"\'customer_destination\'\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">{{ \"billing_customer\" | translate }}</label><six-lookup ng-model=\"lookup.invoicing_customer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.invoicing_customer_id\" sx-type=\"\'customer\'\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">{{ \"type\" | translate }}</label><six-lookup ng-model=\"lookup.type_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.type_id\" sx-type=\"\'shipment_type\'\" sx-relational=\"true\" sx-hide-code=\"true\"></six-lookup></div></div></div></div><div class=\"panel panel-default\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"result\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div>");
$templateCache.put("core/shipmentdocument/shipmentDocument_tabFooter.html","");
$templateCache.put("core/shipmentdocument/shipmentDocument_tabHead.html","<div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><div class=\"\"><label class=\"col-sm-4 control-label\" for=\"type_id\">{{ \"shipment.document_type\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.type_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"record.model.type_id\" sx-filter=\"shipmentTypeFilter\" sx-type=\"\'shipment_type\'\" sx-relational=\"true\" id=\"type_id\"></six-lookup></div></div></div><div class=\"col-md-6 form-group override-form-group\"><div><label class=\"col-sm-4 control-label\" for=\"barcode\">{{ \"barcode\" | translate }}</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"barcode\" ng-model=\"record.model.barcode\"></div><div class=\"col-sm-3\"><input type=\"text\" class=\"form-control\" id=\"id\" ng-model=\"record.model.id\"></div></div></div><div class=\"col-md-6 form-group override-form-group\"><div class=\"\"><label class=\"col-sm-4 control-label\" for=\"ddt_number\">{{ \"shipment.ddt_number\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" id=\"ddt_number\" ng-model=\"record.model.ddt_number\" readonly=\"\"></div></div></div><div class=\"col-md-6 form-group override-form-group\"><div class=\"\"><label class=\"col-sm-4 control-label\" for=\"bar\">{{ \"bar\" | translate }}</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" id=\"bar\" ng-model=\"record.model.bar\" readonly=\"\"></div></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\" for=\"ddt_date\">{{ \"shipment.ddt_date\" | translate }}</label><div class=\"col-sm-8\"><six-date-picker ng-model=\"record.model.ddt_date\" sx-disabled=\"readOnly\"></six-date-picker></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"state\" | translate }}</label><div class=\"col-sm-8\"><six-enum sx-model=\"record.model\" sx-field=\"state\" sx-options=\"enum.state\" sx-readonly=\"readOnly\"></six-enum></div></div><div class=\"col-md-6 form-group override-form-group\"><div class=\"\"><label class=\"col-sm-4 control-label\">{{ \"customer\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.customer_id\" sx-filter=\"customerFilter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"customer_id\" sx-type=\"\'customer\'\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"col-md-6 form-group override-form-group\"><div class=\"\"><label class=\"col-sm-4 control-label\">{{ \"billing_customer\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.invoicing_customer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"invoicing_customer_id\" sx-type=\"\'customer\'\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"col-md-6 form-group override-form-group\"><div class=\"\"><label class=\"col-sm-4 control-label\" for=\"agreement_id\">{{ \"contract\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.agreement_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"record.model.agreement_id\" sx-type=\"\'agreement\'\" sx-relational=\"true\" id=\"agreement_id\" sx-hide-code=\"true\"></six-lookup></div></div></div><div class=\"col-md-6 form-group override-form-group\"><div class=\"\"><label class=\"col-sm-4 control-label\" for=\"customer_destination\">{{ \"shipment.customer_destination\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.customer_destination\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"record.model.customer_destination\" sx-type=\"\'customer_destination\'\" sx-relational=\"true\" id=\"customer_destination\"></six-lookup></div></div></div><div class=\"col-md-6 form-group override-form-group\"><div class=\"\"><label class=\"col-sm-4 control-label\" for=\"customer_destination\">{{ \"shipment.warehouse\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.wharehouse_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"record.model.wharehouse_id\" sx-type=\"\'facility\'\" sx-relational=\"true\" id=\"wharehouse_id\"></six-lookup></div></div></div><div class=\"col-md-6 form-group override-form-group\"><div class=\"\"><label class=\"col-sm-4 control-label\" for=\"inventory_reason_id\">{{ \"shipment.inventory_reason\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.inventory_reason_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"record.model.inventory_reason_id\" sx-type=\"\'inventory_reason\'\" sx-relational=\"true\" id=\"inventory_reason_id\"></six-lookup></div></div></div><div class=\"col-md-6 form-group override-form-group\"><div class=\"\"><label class=\"col-sm-4 control-label\" for=\"zone_id\">{{ \"shipment.zone\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.zone_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"record.model.zone_id\" sx-type=\"\'zone\'\" sx-relational=\"true\" id=\"zone_id\"></six-lookup></div></div></div><div class=\"col-md-12 form-group override-form-group p-r-lg\"><label class=\"control-label col-md-2\">{{ \"shipment.receiver_zone\" | translate }}</label><div class=\"input-group col-md-10\"><textarea class=\"form-control\" ng-model=\"receiver_note\"></textarea></div></div><div class=\"col-md-12 form-group override-form-group p-r-lg\"><label class=\"control-label col-md-2\">{{ \"note\" | translate }}</label><div class=\"input-group col-md-10\"><textarea class=\"form-control\" ng-model=\"note\"></textarea></div></div></div>");
$templateCache.put("core/shipmentdocument/shipmentDocument_tabRows.html","");
$templateCache.put("dataset/export/export.html","<six-toolbar><six-toolbar-button label=\"Esporta Excel\" icon=\"fa fa-file-excel-o\" btn-class=\"btn-success\" ng-if=\"isEntitySelected\" toolbar-function=\"exportXLSX()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Esportazione dati</h1><small class=\"text-muted\">Esportazione dati anagrafici</small></div></div></div><div class=\"panel-body font-bold\"><div class=\"col-md-12 form-group no-pad-l-r\"><div class=\"col-md-12\"><input id=\"normal_export\" type=\"radio\" ng-model=\"typeExport\" value=\"export\"> <label for=\"normal_export\">Esportazione normale</label></div><div class=\"col-md-12\"><input id=\"import_export\" type=\"radio\" ng-model=\"typeExport\" value=\"exportToImport\"> <label for=\"import_export\">Esportazione per reimportazione</label></div></div><six-lookup-2 id=\"schema\" sx-base-path=\"\'schema\'\" ng-model=\"entity\" sx-field=\"\'type\'\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\" sx-page-size=\"10000\"></six-lookup-2></div><div class=\"panel-body\" ng-if=\"isEntitySelected\"><six-grid-pagination sx-id=\"exportlist\" get-data-callback=\"getExportList()\" get-list-callback=\"getExportList()\" items-list=\"exportList\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" show-global-search=\"false\"></six-grid-pagination></div></div></div>");
$templateCache.put("dataset/export/exportcross.html","<style type=\"text/css\">\n  six-toolbar-item .invisible-check{\n    visibility: hidden;\n  }\n</style><six-toolbar><six-toolbar-item label-condition=\"(typeExport == \'exportToImport\')\" label=\"Modo (NORMALE)\" label-disabled=\"Modo (REIMPORTAZIONE)\" icon=\"fa fa-upload icon text-info-dker\"><li><a ng-click=\"setTypeExport(\'export\')\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (typeExport == \'exportToImport\')}\"></i> Normale</a></li><li><a ng-click=\"setTypeExport(\'exportToImport\')\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (typeExport == \'export\')}\"></i> Reimportazione</a></li></six-toolbar-item><six-toolbar-item label-condition=\"findCross\" label=\"Commessa ({{currentCommission.code}})\" label-disabled=\"Commessa (TUTTE)\" icon=\"fa fa-money icon text-success-dker\"><li><a ng-click=\"setFindCross(false)\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': findCross}\"></i> Corrente ({{currentCommission.code}})</a></li><li><a ng-click=\"setFindCross(true)\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': !findCross}\"></i> Tutte</a></li></six-toolbar-item><six-toolbar-button label=\"Esporta Excel\" icon=\"fa fa-file-excel-o\" btn-class=\"btn-success\" ng-if=\"isEntitySelected\" toolbar-function=\"exportXLSX()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Esportazione dati cross</h1><small class=\"text-muted\">Esportazione dati anagrafici cross-commessa</small></div></div></div><div class=\"panel-body font-bold\"><six-lookup-2 id=\"schema\" sx-base-path=\"\'schema\'\" ng-model=\"entity\" sx-field=\"\'type\'\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\" sx-page-size=\"10000\"></six-lookup-2></div><div class=\"panel-body\" ng-if=\"isEntitySelected\"><six-grid-pagination sx-id=\"exportlist\" get-data-callback=\"getExportList()\" get-list-callback=\"getExportList()\" items-list=\"exportList\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" show-global-search=\"false\"></six-grid-pagination></div></div></div>");
$templateCache.put("dataset/formula/formula_detail.html","<style type=\"text/css\">\n  /* Modifiche per l\'impaginazione */\n  #formula-view .content-table{\n    border: 10px solid rgba(211, 211, 211, 0.38);\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n\n  #formula-view .content-acemodel {\n    height: 300px;\n  }\n\n  #formula-view .no-margin-bottom{\n    margin-bottom: 0px;\n  }\n\n  #formula-view .no-margin-top{\n    margin-top: 0px;\n  }\n</style><six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" ng-confirm-message=\"Sei sicuro?\" ng-confirm-click=\"delete(type.selected.version)\" ng-confirm-condition=\"true\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\" id=\"formula-view\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">DETTAGLIO FORMULA</h1></div></div></div><div class=\"panel-body\"><div class=\"col-md-12\"><div class=\"row wrapper\"><label class=\"col-md-2 control-label\">Codice:</label> <input id=\"code\" type=\"text\" class=\"col-md-10\" ng-model=\"model.code\" value=\"model.code\"></div><div class=\"row wrapper\"><label class=\"col-md-2 control-label\">Descrizione:</label> <input id=\"description\" type=\"text\" class=\"col-md-10\" ng-model=\"model.description\" value=\"model.description\"></div><div class=\"row wrapper margin-bottom\"><label class=\"col-md-2 control-label\">Formula:</label><div class=\"col-md-7 content-acemodel no-margin-top\" rows=\"4\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'javascript\', firstLineNumber: 1, }\" ng-model=\"model.formula\"></div><div class=\"col-md-3 content-table\"><table class=\"table table-striped no-margin-bottom\"><thead></thead><tbody ng-repeat=\"(key, value) in arrayFunction\"><tr><td><a href=\"\" ng-click=\"arrayFunction[key].check = !arrayFunction[key].check\" id=\"item\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': arrayFunction[key].check, \'glyphicon-chevron-right\': !arrayFunction[key].check}\"></i></a></td><td>{{value.key}}</td></tr><tr ng-show=\"arrayFunction[key].check == true\" class=\"background-color\"><td></td><td>{{value.description}}</td></tr></tbody></table></div></div><div class=\"row wrapper\"><label class=\"col-md-2 control-label\">Valori:</label> <input id=\"params\" name=\"params\" type=\"text\" class=\"col-md-8\" ng-model=\"params\" value=\"params\" placeholder=\"es: 31, 2, 4.56, 7.45\"> <button class=\"btn btn-success btn-sm center col-md-offset-1\" ng-click=\"calculate(params)\"><span class=\"fa fa-youtube-play\"></span> Calcola</button></div><div class=\"row wrapper\"><label class=\"col-md-2 control-label\">Risultato:</label> <input id=\"output\" type=\"text\" class=\"col-md-8\" ng-model=\"output\" value=\"output\"></div></div></div></div></div>");
$templateCache.put("dataset/formula/formula_list.html","<six-toolbar><six-toolbar-button label=\"Nuovo\" icon=\"fa fa-plus\" toolbar-function=\"newFormula()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"getListWrapper()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Formule</h1></div></div></div><div class=\"panel-body\"><div class=\"form-group\"><input ng-keyup=\"getListWrapper()\" class=\"form-control\" type=\"text\" ng-model=\"queryParam\" placeholder=\"Scrivere qui per filtrare la lista...\"></div><table id=\"modeltype_list\" class=\"table table-striped\"><thead><tr><th class=\"col-md-2\"></th><th class=\"col-md-2\">CODICE</th><th class=\"col-md-2\">DESCRIZIONE</th></tr></thead><tbody><tr ng-repeat=\"item in listWrapper.list\"><td><a ng-href=\"#/formula/{{item.code}}\" class=\"btn btn-default btn-sm\" id=\"btn_model_detail\"><span class=\"fa fa-pencil\"></span></a></td><td>{{item.code}}</td><td>{{item.description}}</td></tr><tr ng-hide=\"listWrapper.list.length\"><td colspan=\"10\"><p class=\"text-center\">Nessun risultato trovato</p></td></tr></tbody></table></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-lg-12 text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"listWrapper.totalResults\" ng-model=\"listWrapper.currentPage\" class=\"pagination-sm\" items-per-page=\"listWrapper.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" max-size=\"10\"></uib-pagination></div></div></div></div></div>");
$templateCache.put("dataset/import/import.html","<six-toolbar><six-toolbar-item label=\"Template\" icon=\"fa fa-download icon text-info-dker\" toolbar-function=\"schemaDefinitionToXlsx()\" ng-show=\"isEntitySelected\"></six-toolbar-item><six-toolbar-button label=\"Reset\" icon=\"fa fa-undo\" toolbar-function=\"reset()\"></six-toolbar-button><six-toolbar-button label=\"Importa\" icon=\"fa fa-upload\" toolbar-function=\"importData()\" btn-class=\"btn-success\" ng-if=\"isEntitySelected\" sx-disabled=\"prePercent<100 || importBusy || 100 === percent\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Importazione Dati</h1><small class=\"text-muted\">Importazione dati anagrafici</small></div></div></div><div class=\"panel-body\"><six-lookup-2 id=\"schema\" sx-base-path=\"\'schema\'\" ng-model=\"entity\" sx-field=\"\'type\'\" sx-compact=\"true\"></six-lookup-2><div style=\"font-size: xx-small\" ng-if=\"false\">{{schemaDefinition.model.schema.properties}}</div></div><div class=\"panel-body\" ng-if=\"isEntitySelected\"><div ui-grid=\"gridOptions\" class=\"grid\" ui-grid-resize-columns=\"\"><div class=\"grid-msg-overlay\" ng-show=\"!gridOptions.data.length\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"gridOptions\" multiple=\"false\"></div></div></div></div><div class=\"wrapper m-t\"><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">{{prePercent|number : 0}}%</span> <span class=\"hidden-folded ng-scope\">Verifica dati</span></div><div class=\"progress-s m-t-sm dk progress ng-isolate-scope\" value=\"{{prePercent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: prePercent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{prePercent|number : 0}}%;\"></div></div><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">{{percent|number : 0}}%</span> <span class=\"hidden-folded ng-scope\">Importazione</span></div><div class=\"progress-s m-t-sm dk progress ng-isolate-scope\" value=\"{{percent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{percent|number : 0}}%;\"></div></div></div><div id=\"messages\" class=\"wrapper m-t\" ng-if=\"reportMessages.length\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-heading\"><h4 class=\"panel-title\">Messaggi</h4></div><div class=\"panel-body\"><div class=\"col-md-12\"><div id=\"gridReport\" ui-grid=\"reportGridOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("dataset/rolemapping/mappingdetail.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"goToMappingList()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-save\" label=\"Salva\" btn-class=\"btn-success\" toolbar-function=\"update()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh\" label=\"Aggiorna\" btn-class=\"btn-info\" toolbar-function=\"getMapping()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-trash\" label=\"Elimina\" btn-class=\"btn-danger\" toolbar-function=\"deleteMapping()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-12 col-xs-12 col-md-12\"><h1 class=\"m-n font-thin h3 text-black\">Mapping</h1></div></div></div><div class=\"panel-body\"><div class=\"panel-body\"><div class=\"col-md-4 col-sm-4\"><label for=\"emma_role\" class=\"control-label\">Emma</label><six-lookup-2 id=\"emma_role\" sx-id=\"emma_role\" ng-model=\"mapping.model\" sx-type=\"\'ruolooperatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'emma_role_id\'\" sx-add=\"false\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-compact=\"true\"></six-lookup-2></div><div class=\"col-md-8 col-sm-8\"><label for=\"ldap_groups\" class=\"control-label\">LDAP</label><div class=\"input-group\" style=\"width:100%\"><tags-input class=\"form-control bootstrap\" style=\"width: 100%; padding: 0px !important;\" placeholder=\"Ldap...\" ng-model=\"mapping.model.ldap_groups\" key-property=\"code\" display-property=\"code\" add-on-space=\"true\" add-from-autocomplete-only=\"false\"></tags-input><span class=\"input-group-btn\"><a class=\"btn btn-default\" ng-click=\"clearLdapGroup()\"><i class=\"fa fa-times\"></i></a></span></div></div></div></div></div></div><pre>{{mapping | json}}</pre>");
$templateCache.put("dataset/rolemapping/mappinglist.html","<six-toolbar><six-toolbar-button icon=\"fa fa-plus\" label=\"Nuovo\" btn-class=\"btn-success\" toolbar-function=\"goToNewMapping()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh\" label=\"Aggiorna\" btn-class=\"btn-default\" toolbar-function=\"getList()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Mapping</h1><small>Pagina di gestione corrispondenze tra ruoli operatori e gruppi LDAP. Queste corrispondenze vengono utilizzate in fase di aggiunta automatica di un utente non ancora presente nell\'elenco di operatori di sistema.</small></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getList()\" get-list-callback=\"getList()\" items-list=\"rows\" column-defs=\"viewGridOptions.columnDefs\" grid-app-callbacks=\"gridAppCallbacks\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("dataset/timeline/timeline.html","<div class=\"hbox hbox-auto-xs hbox-auto-sm ng-scope\"><div class=\"col w-lg bg-light dk b-r bg-auto\" id=\"aside\"><div class=\"wrapper bg b-b\"><button class=\"btn btn-sm btn-default pull-right\" ui-toggle-class=\"timeline-center\" target=\".timeline\">Center</button> <span class=\"pull-right\">&nbsp;</span> <button back=\"\" type=\"button\" class=\"btn btn-default btn-sm pull-right\"><span class=\"glyphicon glyphicon-menu-left\"></span></button><h3 class=\"m-n font-thin\">Timeline</h3></div><div class=\"wrapper\"><form class=\"ng-pristine ng-valid\"><div class=\"form-group\"><label>Modello</label> <input type=\"text\" disabled=\"true\" placeholder=\"Modello\" class=\"input-sm form-control\" ng-model=\"entity\"></div><div class=\"form-group\"><label>UUID</label> <input type=\"text\" disabled=\"true\" placeholder=\"UUID\" class=\"input-sm form-control\" ng-model=\"timeline[0].UUID\"></div></form></div></div><div class=\"col\"><div class=\"wrapper\"><ul class=\"timeline\"><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">INIZIO</div></li><li ng-repeat=\"item in timeline\" class=\"tl-item\" ng-class-odd=\"\'tl-left\'\"><div class=\"tl-wrap\" ng-class=\"{\'b-success\': (model.version == item.version)}\"><span class=\"tl-date\">{{item.dataIn | date : format : timezone}}</span><div class=\"tl-content panel padder b-a\" ng-class=\"{\'bg-success\': (model.version == item.version)}\"><span class=\"arrow left pull-up hidden-left\" ng-class=\"{\'arrow-success\': (model.version == item.version)}\"></span> <span class=\"arrow right pull-up visible-left\" ng-class=\"{\'arrow-success\': (model.version == item.version)}\"></span><div class=\"text-lt m-b-sm\"><a ng-click=\"getModelDetail(item.version)\">{{item.model.code}}</a></div><div class=\"panel-body pull-in b-t b-light\"><span class=\"pull-right label\" ng-class=\"{\'bg-success\': (model.version == item.version), \'bg-info\': (model.version != item.version)}\">{{item.user}}</span></div><div class=\"panel-body pull-in b-t b-light\">{{item.model.description}}</div></div></div></li><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">FINE</div></li></ul></div></div><div class=\"col wrapper bg-white\" ng-if=\"showDetail\"><div sf-schema=\"schema\" sf-form=\"form\" sf-model=\"dataModel\"></div></div></div>");
$templateCache.put("dataset/tree/recorddetails.html","<div class=\"panel-body form-group\"><div ng-if=\"!selected.treeNode\" style=\"text-align: center\"><a class=\"btn btn-sm btn-default pull-right\" ng-click=\"toggleDetails()\"><i class=\"fa fa-angle-double-right text-danger-dker\"></i></a> Nessun nodo selezionato</div><div ng-if=\"selected.treeNode && !record.loaded\" style=\"text-align: center\"><i class=\"fa fa-spinner fa-2x fa-pulse fa-fw text-info-dker\" aria-hidden=\"true\"></i></div><div ng-if=\"typeDescription != \'Configurazione\' && selected.treeNode && record.loaded\"><form name=\"detailForm\" class=\"ng-pristine ng-valid\" ng-submit=\"onSubmitDetailForm(detailForm)\" ng-if=\"selected.treeNode\"><div class=\"panel wrapper\"><div class=\"clear m-b-xs\"><h1 class=\"font-thin h3 text-black pull-left\">{{typeDescription}}</h1><span class=\"pull-right\"><button type=\"submit\" class=\"btn btn-sm btn-success m-r\" id=\"btn_create_entity\" ng-disabled=\"isWriteRecordPermAllowed()===false\"><i class=\"glyphicon glyphicon-save\"></i> Salva</button> <a class=\"btn btn-sm btn-default\" id=\"btn_expand\" ng-click=\"toggleRightSidebarSize()\" title=\"Ridimensiona\"><i class=\"fa\" ng-class=\"{\'fa-expand\': rightSidebarSize==\'50\', \'fa-compress\': rightSidebarSize==\'100\'}\"></i></a> <a class=\"btn btn-sm btn-default\" id=\"btn_close\" ng-click=\"toggleDetails()\" title=\"Chiudi\"><i class=\"fa fa-angle-double-right text-danger-dker\"></i></a></span></div><div class=\"panel-body form-group\"><div sf-schema=\"record.schema\" sf-form=\"record.form\" sf-model=\"record.model\" class=\"pull-left col-md-12\"></div></div></div></form></div><div ng-if=\"typeDescription == \'Configurazione\' && selected.treeNode && record.loaded\"><div ng-controller=\"TreeplanconfigCtrl\" data-ng-include=\"\'dataset/tree/treeplanconfig.html\'\"></div></div></div>");
$templateCache.put("dataset/tree/recordlist.html","<script type=\"text/ng-template\" id=\"records_renderer.html\"><div class=\"tree-node\" ng-click=\"toggleRecordSelection(node)\" ng-class=\"{\'node_selected\': isRecordSelected(node)}\"> <div class=\"tree-node-content\"> <div class=\"pull-left model-icon\" ui-tree-handle> <span class=\"text-info-dker pull-right m-l-xs m-r-xs model-icon\" title=\"{{node.schemaCode}}\" data-placement=\"right\" data-original-title=\"{{node.schemaCode}}\" tooltip><i ng-class=\"getModelIcon(node.schemaCode)\"></i></span> </div> <div> <span>{{node.model.code}} - {{node.model.description}}</span> </div> </div> </div></script><div class=\"panel-body form-group\"><form class=\"ng-pristine ng-valid\"><div class=\"clear m-b\"><a class=\"btn btn-xs btn-default pull-left\" id=\"btn_close\" ng-click=\"toggleRecordsList()\" title=\"Chiudi\" data-placement=\"bottom\"><i class=\"fa fa-angle-double-left text-danger-dker\"></i></a> <a class=\"btn btn-xs btn-danger pull-right\" ng-click=\"unselectAllFromRecordsList()\"><i class=\"fa fa-square-o\"></i> Desel. tutto</a> <a class=\"btn btn-xs btn-success m-r-xs pull-right\" ng-click=\"selectAllFromRecordsList()\"><i class=\"fa fa-check-square-o\"></i> Sel. tutto</a></div><div class=\"form-group\"><six-search-form ng-model=\"searchInput.text\" placeholder=\"Cerca...\" hide-search-btn=\"\"></six-search-form></div><div ng-if=\"!records.loaded\" style=\"text-align: center\"><i class=\"fa fa-spinner fa-2x fa-pulse fa-fw text-info-dker\" aria-hidden=\"true\"></i></div><div ui-tree=\"recordsOptions\" id=\"tree2-root\" ng-if=\"records.loaded\"><ol ui-tree-nodes=\"\" ng-model=\"records.list\" id=\"records\"><li ng-repeat=\"node in records.list\" ui-tree-node=\"\" ng-include=\"\'records_renderer.html\'\" ng-show=\"isRecordVisible(node)\"></li></ol></div></form></div>");
$templateCache.put("dataset/tree/toolbar.html","<six-toolbar><six-toolbar-item label=\"Lista\" icon=\"fa fa-dedent icon text-info-dker\" icon-disabled=\"fa fa-fw fa-indent text-muted\" toolbar-function=\"toggleRecordsList()\" icon-condition=\"!showRecordsList\"></six-toolbar-item><six-toolbar-item label=\"Dettagli\" icon=\"fa fa-fw fa-edit icon text-info-dker\" icon-disabled=\"fa fa-fw fa-edit icon text-muted\" toolbar-function=\"toggleDetails()\" icon-condition=\"!showDetails\"></six-toolbar-item><six-toolbar-item label=\"Espandi tutto\" label-disabled=\"Comprimi tutto\" label-condition=\"!treeCollapsed\" icon=\"fa fa-fw fa-plus-square icon text-info-dker\" icon-disabled=\"fa fa-fw fa-minus-square icon text-info-dker\" toolbar-function=\"toggleAll()\" icon-condition=\"!treeCollapsed\"></six-toolbar-item><six-toolbar-item label=\"Home\" icon=\"glyphicon glyphicon-home icon text-success-dker\" toolbar-function=\"selectNode(undefined)\"></six-toolbar-item><six-toolbar-item label=\"Nodo\" icon=\"glyphicon glyphicon-leaf icon text-primary-dker\" sx-disabled=\"isWritePermAllowed()===false\"><li ng-show=\"!dropdownList.nodes.length\"><span class=\"m-sm\">Nessun nodo disp.</span></li><li ng-repeat=\"entity in dropdownList.nodes\"><a href=\"\" ng-click=\"getRecordDetail(false, entity.model.code)\">{{entity.model.description}}</a></li></six-toolbar-item><six-toolbar-item label=\"Root\" icon=\"glyphicon glyphicon-certificate icon text-info-dker\" sx-disabled=\"isWritePermAllowed()===false\"><li ng-show=\"!dropdownList.roots.length\"><span class=\"m-sm\">Nessun nodo disp.</span></li><li ng-repeat=\"entity in dropdownList.roots\"><a href=\"\" ng-click=\"getRecordDetail(true, entity.model.code)\">{{entity.model.description}}</a></li></six-toolbar-item><six-toolbar-item label=\"Aggiungi\" icon=\"fa fa-plus-circle text-warning-dker\" toolbar-function=\"addNodesToParent(selected.treeNode, selected.records)\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-item></six-toolbar>");
$templateCache.put("dataset/tree/tree.html","<style type=\"text/css\">\n  .custom-sidebar {\n    top: 100px;\n    z-index: 1031;\n    padding-bottom: 70px;\n  }\n  .override-top-sidebar {\n    top: 100px;\n  }\n  .floating-btn {\n    z-index: 999;\n  }\n  .floating-btn a {\n    color: #58666e;\n    background-color: #fff;\n  }\n</style><div ng-include=\"\'dataset/tree/toolbar.html\'\"></div><nav class=\"floating-btn\" mfb-menu=\"\" position=\"bl\" effect=\"zoomin\" label=\"Pannelli\" active-icon=\"fa fa-chevron-up\" resting-icon=\"fa fa-columns\" toggling-method=\"hover\"><button mfb-button=\"\" icon=\"fa fa-indent\" label=\"Nodi disponibili\" ng-click=\"toggleRecordsList()\"></button> <button mfb-button=\"\" icon=\"fa fa-edit\" label=\"Dettagli nodo\" ng-click=\"toggleDetails()\"></button></nav><six-sidebar sx-class=\"override-top-sidebar\" sx-id=\"records_sidebar\" sx-position=\"left\" sx-title=\"\'Nodi disponibili\'\" sx-dimension=\"l\" sx-opened=\"showRecordsList\" sx-pinned=\"true\" sx-show-title=\"false\"><div ng-include=\"\'dataset/tree/recordlist.html\'\"></div></six-sidebar><six-sidebar sx-class=\"override-top-sidebar\" sx-id=\"details_sidebar\" sx-position=\"right\" sx-title=\"\'Dettagli\'\" sx-dimension=\"{{rightSidebarSize}}\" sx-opened=\"showDetails\" sx-pinned=\"false\" sx-show-title=\"false\"><div ng-include=\"\'dataset/tree/recorddetails.html\'\"></div></six-sidebar><div class=\"constructor\"><div class=\"hbox hbox-auto-xs hbox-auto-sm override-padding-50-px\"><div class=\"wrapper\"><div class=\"panel panel-default\"><div ng-include=\"\'dataset/tree/treenode.html\'\"></div></div></div></div></div><div class=\"panel-footer\" ng-if=\"false\"><div class=\"row form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" class=\"pull-left\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div><div class=\"row\" collapse=\"!jsonshow\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{ tree.wrapper | json }}</pre></div></div></div>");
$templateCache.put("dataset/tree/treeconfigurator.html","<style>\n    .panel-tree{\n        margin-bottom: 0px;\n    }\n</style><script type=\"text/ng-template\" id=\"tree_renderer.html\"><div ui-tree-handle class=\"tree-node\" > <div class=\"tree-node-content\"> <div class=\"pull-left model-icon\"> <span class=\"text-info-dker pull-right m-l-xs m-r-xs model-icon\" tooltip=\"{{node.model.code}}\"><i ng-class=\"getModelIcon(node.model.code)\"></i></span> </div> <a class=\"btn btn-xs btn-default\" data-nodrag ng-click=\"toggle(this)\" ng-if=\"node.nodes.length>0\"> <span class=\"fa\" ng-class=\"{\'fa-plus\': collapsed, \'fa-minus\': !collapsed}\"></span> </a> {{node.model.description}} ({{node.model.code}}) <a class=\"pull-right btn btn-xs\" data-nodrag ng-confirm-message=\"Eliminare il nodo?\" ng-confirm-click=\"remove(this)\" ng-confirm-condition=true ng-if=\"isWritePermAllowed()===true\"> <span class=\"glyphicon glyphicon-remove text-danger-dker remove-tree-btn\"></span> </a> </div> </div> <ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\"> <li ng-repeat=\"node in node.nodes\" ui-tree-node ng-include=\"\'tree_renderer.html\'\"> </li> </ol></script><script type=\"text/ng-template\" id=\"entities_renderer.html\"><div ui-tree-handle class=\"tree-node\"> <div class=\"tree-node-content\"> <div class=\"pull-left model-icon\"> <span class=\"text-info-dker pull-right m-l-xs m-r-xs model-icon\" tooltip=\"{{node.model.code}}\"><i ng-class=\"getModelIcon(node.model.code)\"></i></span> </div> {{node.model.description}} ({{node.model.code}}) </div> </div> <div></div> <ol ui-tree-nodes=\"\" data-max-depth=\"1\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\"> <li ng-repeat=\"node in node.nodes\" ui-tree-node ng-include=\"\'entities_renderer.html\'\"> </li> </ol></script><six-toolbar><six-toolbar-item icon=\"fa fa-exclamation text-danger-dker\" label=\"Selezionare un cliente per abilitare il salvataggio\" ng-show=\"isCustomerMissing()\"></six-toolbar-item><six-toolbar-item label=\"{{currentCustomer.description}}\" ng-hide=\"isCustomerMissing()\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button></six-toolbar><div class=\"hbox hbox-auto-xs hbox-auto-sm ng-scope override-padding-50-px\"><div class=\"col w-xxl bg-light dk b-r bg-auto\" id=\"aside\"><div class=\"wrapper\"><form class=\"ng-pristine ng-valid\"><div class=\"form-group\"><six-search-form ng-model=\"entitySearch\" placeholder=\"Search\" hide-search-btn=\"\"></six-search-form></div><div ui-tree=\"entitiesOptions\" id=\"tree2-root\"><ol ui-tree-nodes=\"\" ng-model=\"entities.filteredList\" id=\"entities\"><li ng-repeat=\"node in entities.filteredList | filter: {model: {code: entitySearch, description: entitySearch}} | startFrom: (pagination.currentPage-1)*pagination.pageSize | limitTo: pagination.pageSize\" ui-tree-node=\"\" ng-include=\"\'entities_renderer.html\'\"></li></ol></div><div class=\"row text-center\"><six-pagination items=\"entities.list\" total-items=\"pagination.totalItems\" max-size=\"pagination.noOfPages\" items-per-page=\"pagination.pageSize\" ng-model=\"pagination.currentPage\" update-evt=\"entitySearch\" filter-name=\"filter\"></six-pagination></div></form></div></div><div class=\"col\"><div class=\"wrapper bg b-b\"><h3 class=\"m-n font-thin\">Albero</h3></div><div class=\"wrapper panel panel-tree\"><div ui-tree=\"treeOptions\" id=\"tree1-root\"><ol ui-tree-nodes=\"\" ng-model=\"tree.wrapper.model.nodes\" id=\"tree\"><li ng-repeat=\"node in tree.wrapper.model.nodes\" ui-tree-node=\"\" ng-include=\"\'tree_renderer.html\'\"></li></ol></div></div></div></div>");
$templateCache.put("dataset/tree/treenode.html","<script type=\"text/ng-template\" id=\"tree_renderer.html\"><div class=\"tree-node\" ng-click=\"selectNode(node)\" ng-class=\"{\'node_selected\': isNodeSelected(node)}\"> <div class=\"tree-node-content\"> <div class=\"pull-left model-icon\" style=\"width: 26px;\" > <span class=\"text-info-dker pull-right m-l-xs m-r-xs model-icon\" title=\"{{node.schemaCode}}\" data-placement=\"left\" data-original-title=\"{{node.schemaCode}}\" tooltip><i ng-class=\"getModelIcon(node.schemaCode)\"></i></span> </div> <div> <a class=\"btn btn-xs btn-default\" data-nodrag ng-click=\"toggleNode(this)\" ng-if=\"node.nodes.length>0\"> <span class=\"fa\" ng-class=\"{\'fa-plus\': collapsed, \'fa-minus\': !collapsed}\"></span> </a> {{node.model.code}} - {{node.model.description}} <span class=\"pull-right btn btn-xs\" data-nodrag ng-confirm-message=\"Eliminare il nodo?\" ng-confirm-click=\"removeTreeNode(this)\" ng-confirm-condition=true ng-if=\"isWritePermAllowed()===true\"><i class=\"fa fa-times text-danger-dker remove-tree-btn\"></i></span> </div> </div> </div> <ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\"> <li ng-repeat=\"node in node.nodes\" ui-tree-node ng-include=\"\'tree_renderer.html\'\" ng-show=\"isNodeVisible(node)\" /> </ol></script><div class=\"panel-body form-group\"><div class=\"form-group m-t-xs\"><six-search-form ng-model=\"searchInputInTree.text\" placeholder=\"Cerca...\" hide-search-btn=\"\"></six-search-form></div><div ng-if=\"!tree.loaded\" style=\"text-align: center\"><i class=\"fa fa-spinner fa-2x fa-pulse fa-fw text-info-dker\" aria-hidden=\"true\"></i></div><div ui-tree=\"treeOptions\" id=\"tree1-root\" ng-if=\"tree.loaded\" data-nodrop-enabled=\"\"><ol ui-tree-nodes=\"\" ng-model=\"tree.wrapper.model.nodes\" id=\"tree\"><li ng-repeat=\"node in tree.wrapper.model.nodes\" ui-tree-node=\"\" ng-include=\"\'tree_renderer.html\'\" ng-show=\"isNodeVisible(node)\"></li></ol></div></div>");
$templateCache.put("dataset/tree/treeplanconfig.html","<div class=\"white\"><div class=\"panel wrapper\"><h1 class=\"m-n font-thin h3 text-black pull-left\">Configurazione</h1><div class=\"panel-header pad-l-r-10 pull-right m-b-xl\"><button type=\"submit\" class=\"btn btn-sm btn-success m-r\" id=\"btn_create_entity\" ng-click=\"save()\"><i class=\"glyphicon glyphicon-save\"></i> Salva</button> <a class=\"btn btn-sm btn-default\" id=\"btn_expand\" ng-click=\"toggleRightSidebarSize()\" title=\"Ridimensiona\"><i class=\"fa\" ng-class=\"{\'fa-expand\': rightSidebarSize==\'50\', \'fa-compress\': rightSidebarSize==\'100\'}\"></i></a> <a class=\"btn btn-sm btn-default\" id=\"btn_close\" ng-click=\"toggleDetails()\" title=\"Chiudi\"><i class=\"fa fa-angle-double-right text-danger-dker\"></i></a></div><div class=\"panel-body no-pad-l-r override-padding-30-px\"><div class=\"col-md-12\"><uib-tabset active=\"active\"><uib-tab heading=\"Profilazione assegnatari\"><ng-include src=\"\'dataset/tree/treeplanconfig_assignee_row.html\'\"></ng-include></uib-tab><uib-tab heading=\"Assegnatari default\"><ng-include src=\"\'dataset/tree/treeplanconfig_default_row.html\'\"></ng-include></uib-tab><uib-tab heading=\"Contatti responsabili\"><ng-include src=\"\'dataset/tree/treeplanconfig_responsable_row.html\'\"></ng-include></uib-tab><uib-tab heading=\"Watchers\"><ng-include src=\"\'dataset/tree/treeplanconfig_watchers.html\'\"></ng-include></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("dataset/tree/treeplanconfig_assignee_row.html","<style type=\"text/css\">\n  table.treeplanconfig_table_ass {\n    width: 100%;\n  }\n\n  .treeplanconfig_table_ass th {\n    font-weight: bold;\n  }\n\n  .treeplanconfig_table_ass td, .treeplanconfig_table_ass th {\n    width: 13%;\n    padding: 0 2px 0 2px;\n  }\n\n  .treeplanconfig_table_ass td.record {\n    width: 34%;\n  }\n\n  .treeplanconfig_table_ass tr {\n    border-bottom: 1px solid #ddd;\n  }\n\n  .treeplanconfig_table_ass td.tools, .treeplanconfig_table_ass th.tools {\n    width: 70px;\n    overflow: hidden;\n    display: inline-block;\n    white-space: nowrap;\n    text-align: right;\n    padding: 0 2px 0 2px;\n  }\n</style><table class=\"treeplanconfig_table_ass\"><thead><tr><th>Servizio</th><th>Asset</th><th>Tipo profilaz.</th><th>Azienda</th><th>Tipo operatore</th><th>Record profilaz.</th><th class=\"tools\"><a class=\"btn pull-right\" ng-click=\"newAssignee=true\"><i class=\"fa fa-plus-circle\"></i></a></th></tr></thead><tbody><tr ng-repeat=\"assigneeRow in selected.model.configuration.assignee\"><td><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"assigneeRow\" sx-field=\"\'service_id\'\" sx-type=\"\'servizio\'\" sx-compact=\"true\" sx-disabled=\"crossService\" ng-if=\"assigneeRow.edit\"></six-lookup-2><div ng-if=\"!assigneeRow.edit\"><span>{{assigneeRow.service_id.description}}</span></div></td><td><six-lookup-2 sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"assigneeRow\" sx-field=\"\'type_id\'\" sx-disabled=\"crossType\" sx-item-template=\"\'{{item.description}}\'\" sx-page-size=\"10000\" sx-compact=\"true\" ng-if=\"assigneeRow.edit\"></six-lookup-2><div ng-if=\"!assigneeRow.edit\"><span>{{assigneeRow.type_id.description}}</span></div></td><td><six-lookup-2 ng-model=\"assigneeRow\" sx-base-path=\"\'schema\'\" sx-field=\"\'typeprofiling_id\'\" sx-filter=\"typeProfilingFilter\" sx-compact=\"true\" sx-page-size=\"10000\" sx-item-template=\"\'{{item.description}}\'\" ng-if=\"assigneeRow.edit\"></six-lookup-2><div ng-if=\"!assigneeRow.edit\"><span>{{assigneeRow.typeprofiling_id.description}}</span></div></td><td><div ng-if=\"assigneeRow.edit\"><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"assigneeRow\" sx-type=\"\'azienda\'\" sx-field=\"\'company_id\'\" sx-compact=\"true\" ng-if=\"assigneeRow.typeprofiling_id.code!=\'azienda\'\"></six-lookup-2><div style=\"width: 100%; padding-left: 10px\" ng-if=\"assigneeRow.typeprofiling_id.code==\'azienda\'\">-</div></div><div ng-if=\"!assigneeRow.edit\"><span>{{assigneeRow.company_id.description}}</span></div></td><td><div ng-if=\"assigneeRow.edit\"><six-select-2 sx-id=\"operatorType\" ng-model=\"assigneeRow\" sx-field=\"\'typeprofiling_filter\'\" sx-list=\"availableTypeOperatorList\" sx-show-key=\"false\" sx-compact=\"true\" sx-multiple=\"false\" ng-if=\"assigneeRow.typeprofiling_id.code==\'operatore\'\"></six-select-2><div style=\"width: 100%; padding-left: 10px\" ng-if=\"assigneeRow.typeprofiling_id.code!=\'operatore\'\">-</div></div><div ng-if=\"!assigneeRow.edit\"><span>{{assigneeRow.typeprofiling_filter.description}}</span></div></td><td class=\"record\"><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"assigneeRow\" sx-type=\"assigneeRow.typeprofiling_id.code\" sx-field=\"\'assignee_id\'\" sx-compact=\"true\" sx-filter=\"assigneeRow.typeprofiling_filter.filters\" sx-multiple=\"true\" ng-if=\"assigneeRow.edit\"></six-lookup-2><div ng-if=\"!assigneeRow.edit\"><span ng-repeat=\"a in assigneeRow.assignee_id track by $index\" ng-if=\"assigneeRow.assignee_id.length\">{{a.description}} ;</span> <span ng-if=\"!assigneeRow.assignee_id.length\">{{assigneeRow.assignee_id.description}}</span></div></td><td class=\"tools\"><a class=\"btn pull-right\" ng-click=\"deleteAssignee(assigneeRow)\" ng-if=\"!assigneeRow.edit\"><i class=\"fa fa-trash-o\"></i></a> <a class=\"btn pull-right\" ng-click=\"restoreHistory(assigneeRow)\" ng-if=\"assigneeRow.edit\"><i class=\"fa fa-history\"></i></a> <a class=\"btn\" ng-click=\"editRow(assigneeRow)\" ng-if=\"!assigneeRow.edit\"><i class=\"fa fa-pencil-square-o\"></i></a> <a class=\"btn\" ng-click=\"confirmRow(assigneeRow)\" ng-if=\"assigneeRow.edit\"><i class=\"fa fa-check-circle\"></i></a></td></tr><tr ng-show=\"newAssignee==true\"><td><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"insertNewRowAssignee\" sx-field=\"\'service_id\'\" sx-type=\"\'servizio\'\" sx-compact=\"true\" sx-disabled=\"crossService\"></six-lookup-2></td><td><six-lookup-2 sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"insertNewRowAssignee\" sx-field=\"\'type_id\'\" sx-disabled=\"crossType\" sx-item-template=\"\'{{item.description}}\'\" sx-page-size=\"10000\" sx-compact=\"true\"></six-lookup-2></td><td><six-lookup-2 ng-model=\"insertNewRowAssignee\" sx-base-path=\"\'schema\'\" sx-field=\"\'typeprofiling_id\'\" sx-filter=\"typeProfilingFilter\" sx-compact=\"true\" sx-page-size=\"10000\" sx-item-template=\"\'{{item.description}}\'\"></six-lookup-2></td><td><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"insertNewRowAssignee\" sx-type=\"\'azienda\'\" sx-field=\"\'company_id\'\" sx-compact=\"true\" ng-if=\"insertNewRowAssignee.typeprofiling_id.code!=\'azienda\'\"></six-lookup-2><div style=\"width: 100%; padding-left: 10px\" ng-if=\"insertNewRowAssignee.typeprofiling_id.code==\'azienda\'\">-</div></td><td><six-select-2 sx-id=\"operatorType\" ng-model=\"insertNewRowAssignee\" sx-field=\"\'typeprofiling_filter\'\" sx-list=\"availableTypeOperatorList\" sx-show-key=\"false\" sx-compact=\"true\" sx-multiple=\"false\" ng-if=\"insertNewRowAssignee.typeprofiling_id.code==\'operatore\'\"></six-select-2><div style=\"width: 100%; padding-left: 10px\" ng-if=\"insertNewRowAssignee.typeprofiling_id.code!=\'operatore\'\">-</div></td><td class=\"record\"><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"insertNewRowAssignee\" sx-type=\"insertNewRowAssignee.typeprofiling_id.code\" sx-field=\"\'assignee_id\'\" sx-compact=\"true\" sx-filter=\"insertNewRowAssignee.typeprofiling_filter.filters\" sx-multiple=\"true\"></six-lookup-2></td><td class=\"tools\"><a class=\"btn pull-right m-xs-l\" ng-click=\"newAssignee=false\"><i class=\"fa fa-history\"></i></a> <a class=\"btn\"><i class=\"fa fa-check-circle\" ng-click=\"addAssignee(insertNewRowAssignee)\"></i></a></td></tr></tbody></table>");
$templateCache.put("dataset/tree/treeplanconfig_default_row.html","<style type=\"text/css\">\n  table.treeplanconfig_table_def {\n    width: 100%;\n  }\n\n  .treeplanconfig_table_def th {\n    font-weight: bold;\n  }\n\n  .treeplanconfig_table_def td, .treeplanconfig_table_def th {\n    width: 16%;\n    padding: 0 2px 0 2px;\n  }\n\n  .treeplanconfig_table_def tr {\n    border-bottom: 1px solid #ddd;\n  }\n\n  .treeplanconfig_table_def td.tools, .treeplanconfig_table_def th.tools {\n    width: 70px;\n    overflow: hidden;\n    display: inline-block;\n    white-space: nowrap;\n    text-align: right;\n    padding: 0 2px 0 2px;\n  }\n</style><table class=\"treeplanconfig_table_def\"><thead><tr><th>Servizio</th><th>Asset</th><th>Tipo profilaz.</th><th>Azienda</th><th>Tipo operatore</th><th>Record profilaz.</th><th class=\"tools\"><a class=\"btn pull-right\" ng-click=\"newDefault=true\"><i class=\"fa fa-plus-circle\"></i></a></th></tr></thead><tbody><tr ng-repeat=\"defaultRow in selected.model.configuration.default\"><td><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"defaultRow\" sx-field=\"\'service_id\'\" sx-type=\"\'servizio\'\" sx-compact=\"true\" sx-disabled=\"crossService\" ng-if=\"defaultRow.edit\"></six-lookup-2><div ng-if=\"!defaultRow.edit\"><span>{{defaultRow.service_id.description}}</span></div></td><td><six-lookup-2 sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"defaultRow\" sx-field=\"\'type_id\'\" sx-disabled=\"crossType\" sx-item-template=\"\'{{item.description}}\'\" sx-page-size=\"10000\" sx-compact=\"true\" ng-if=\"defaultRow.edit\"></six-lookup-2><div ng-if=\"!defaultRow.edit\"><span>{{defaultRow.type_id.description}}</span></div></td><td><six-lookup-2 ng-model=\"defaultRow\" sx-base-path=\"\'schema\'\" sx-field=\"\'typeprofiling_id\'\" sx-filter=\"typeProfilingFilter\" sx-compact=\"true\" sx-page-size=\"10000\" sx-item-template=\"\'{{item.description}}\'\" ng-if=\"defaultRow.edit\"></six-lookup-2><div ng-if=\"!defaultRow.edit\"><span>{{defaultRow.typeprofiling_id.description}}</span></div></td><td><div ng-if=\"defaultRow.edit\"><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"defaultRow\" sx-type=\"\'azienda\'\" sx-field=\"\'company_id\'\" sx-compact=\"true\" ng-if=\"defaultRow.typeprofiling_id.code!=\'azienda\'\"></six-lookup-2><div style=\"width: 100%; padding-left: 10px\" ng-if=\"defaultRow.typeprofiling_id.code==\'azienda\'\">-</div></div><div ng-if=\"!defaultRow.edit\"><span>{{defaultRow.company_id.description}}</span></div></td><td><div ng-if=\"defaultRow.edit\"><six-select-2 sx-id=\"operatorType\" ng-model=\"defaultRow\" sx-field=\"\'typeprofiling_filter\'\" sx-list=\"availableTypeOperatorList\" sx-show-key=\"false\" sx-compact=\"true\" sx-multiple=\"false\" ng-if=\"defaultRow.typeprofiling_id.code==\'operatore\'\"></six-select-2><div style=\"width: 100%; padding-left: 10px\" ng-if=\"defaultRow.typeprofiling_id.code!=\'operatore\'\">-</div></div><div ng-if=\"!defaultRow.edit\"><span>{{defaultRow.typeprofiling_filter.description}}</span></div></td><td><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"defaultRow\" sx-type=\"defaultRow.typeprofiling_id.code\" sx-field=\"\'assignee_id\'\" sx-compact=\"true\" sx-filter=\"defaultRow.typeprofiling_filter.filters\" sx-multiple=\"{{defaultRow.typeprofiling_filter.key==\'manutentore\' || defaultRow.typeprofiling_filter.key==\'tecnico_commessa\'}}\" sx-add=\"false\" sx-show-details=\"false\" sx-show-filters=\"false\" ng-if=\"defaultRow.edit\"></six-lookup-2><div ng-if=\"!defaultRow.edit\"><span ng-repeat=\"a in defaultRow.assignee_id track by $index\" ng-if=\"defaultRow.assignee_id.length\">{{a.description}} ;</span> <span ng-if=\"!defaultRow.assignee_id.length\">{{defaultRow.assignee_id.description}}</span></div></td><td class=\"tools\"><a class=\"btn pull-right\" ng-click=\"deleteDefault(defaultRow)\" ng-if=\"!defaultRow.edit\"><i class=\"fa fa-trash-o\"></i></a> <a class=\"btn pull-right\" ng-click=\"restoreHistory(defaultRow)\" ng-if=\"defaultRow.edit\"><i class=\"fa fa-history\"></i></a> <a class=\"btn\" ng-click=\"editRow(defaultRow)\" ng-if=\"!defaultRow.edit\"><i class=\"fa fa-pencil-square-o\"></i></a> <a class=\"btn\" ng-click=\"confirmRow(defaultRow)\" ng-if=\"defaultRow.edit\"><i class=\"fa fa-check-circle\"></i></a></td></tr><tr ng-show=\"newDefault==true\"><td><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"insertNewRowDefault\" sx-field=\"\'service_id\'\" sx-type=\"\'servizio\'\" sx-compact=\"true\" sx-disabled=\"crossService\"></six-lookup-2></td><td><six-lookup-2 sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"insertNewRowDefault\" sx-field=\"\'type_id\'\" sx-disabled=\"crossType\" sx-item-template=\"\'{{item.description}}\'\" sx-page-size=\"10000\" sx-compact=\"true\"></six-lookup-2></td><td><six-lookup-2 ng-model=\"insertNewRowDefault\" sx-base-path=\"\'schema\'\" sx-field=\"\'typeprofiling_id\'\" sx-filter=\"typeProfilingFilter\" sx-compact=\"true\" sx-page-size=\"10000\" sx-item-template=\"\'{{item.description}}\'\"></six-lookup-2></td><td><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"insertNewRowDefault\" sx-type=\"\'azienda\'\" sx-field=\"\'company_id\'\" sx-compact=\"true\" ng-if=\"insertNewRowDefault.typeprofiling_id.code!=\'azienda\'\"></six-lookup-2><div style=\"width: 100%; padding-left: 10px\" ng-if=\"insertNewRowDefault.typeprofiling_id.code==\'azienda\'\">-</div></td><td><six-select-2 sx-id=\"operatorType\" ng-model=\"insertNewRowDefault\" sx-field=\"\'typeprofiling_filter\'\" sx-list=\"availableTypeOperatorList\" sx-show-key=\"false\" sx-compact=\"true\" sx-multiple=\"false\" ng-if=\"insertNewRowDefault.typeprofiling_id.code==\'operatore\'\"></six-select-2><div style=\"width: 100%; padding-left: 10px\" ng-if=\"insertNewRowDefault.typeprofiling_id.code!=\'operatore\'\">-</div></td><td><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"insertNewRowDefault\" sx-type=\"insertNewRowDefault.typeprofiling_id.code\" sx-field=\"\'assignee_id\'\" sx-compact=\"true\" sx-filter=\"insertNewRowDefault.typeprofiling_filter.filters\" sx-multiple=\"{{insertNewRowDefault.typeprofiling_filter.key==\'manutentore\' || insertNewRowDefault.typeprofiling_filter.key==\'tecnico_commessa\'}}\" sx-add=\"false\" sx-show-details=\"false\" sx-show-filters=\"false\"></six-lookup-2></td><td class=\"tools\"><a class=\"btn pull-right m-xs-l\" ng-click=\"newDefault=false\"><i class=\"fa fa-history\"></i></a> <a class=\"btn\"><i class=\"fa fa-check-circle\" ng-click=\"addDefault(insertNewRowDefault)\"></i></a></td></tr></tbody></table>");
$templateCache.put("dataset/tree/treeplanconfig_responsable_row.html","<style type=\"text/css\">\n  table.treeplanconfig_table_resp {\n    width: 100%;\n  }\n\n  .treeplanconfig_table_resp th {\n    font-weight: bold;\n  }\n\n  .treeplanconfig_table_resp td, .treeplanconfig_table_resp th {\n    width: 49%;\n    padding: 0 2px 0 2px;\n  }\n\n  .treeplanconfig_table_resp tr {\n    border-bottom: 1px solid #ddd;\n  }\n\n  .treeplanconfig_table_resp td.tools, .treeplanconfig_table_resp th.tools {\n    width: 70px;\n    overflow: hidden;\n    display: inline-block;\n    white-space: nowrap;\n    text-align: right;\n    padding: 0 2px 0 2px;\n  }\n</style><table class=\"treeplanconfig_table_resp\"><thead><tr><th>Nominativo</th><th>Contatti</th><th class=\"tools\"><a class=\"btn pull-right\" ng-click=\"newResponsable=true\"><i class=\"fa fa-plus-circle\"></i></a></th></tr></thead><tbody><tr ng-repeat=\"responsableRow in selected.model.configuration.responsable\"><td><input class=\"form-control\" placeholder=\"Cognome, nome\" type=\"text\" ng-model=\"responsableRow.name\" ng-disabled=\"!responsableRow.edit\"></td><td><input class=\"form-control\" placeholder=\"Mail, telefono, ...\" type=\"text\" ng-model=\"responsableRow.contacts\" ng-disabled=\"!responsableRow.edit\"></td><td class=\"tools\"><a class=\"btn pull-right\" ng-click=\"delete(selected.model.configuration.responsable, responsableRow)\" ng-if=\"!responsableRow.edit\"><i class=\"fa fa-trash-o\"></i></a> <a class=\"btn pull-right\" ng-click=\"restoreHistory(responsableRow)\" ng-if=\"responsableRow.edit\"><i class=\"fa fa-history\"></i></a> <a class=\"btn\" ng-click=\"editRow(responsableRow)\" ng-if=\"!responsableRow.edit\"><i class=\"fa fa-pencil-square-o\"></i></a> <a class=\"btn\" ng-click=\"confirmRow(responsableRow)\" ng-if=\"responsableRow.edit\"><i class=\"fa fa-check-circle\"></i></a></td></tr><tr ng-show=\"newResponsable==true\"><td><input class=\"form-control\" placeholder=\"Cognome, nome\" type=\"text\" ng-model=\"insertNewRowResponsable.name\"></td><td><input class=\"form-control\" placeholder=\"Mail, telefono, ...\" type=\"text\" ng-model=\"insertNewRowResponsable.contacts\"></td><td class=\"tools\"><a class=\"btn pull-right m-xs-l\" ng-click=\"newResponsable=false\"><i class=\"fa fa-history\"></i></a> <a class=\"btn\"><i class=\"fa fa-check-circle\" ng-click=\"addResponsable(insertNewRowResponsable)\"></i></a></td></tr></tbody></table>");
$templateCache.put("dataset/tree/treeplanconfig_watchers.html","<style type=\"text/css\">\n  table.treeplanconfig_watchers {\n    width: 100%;\n  }\n\n  .treeplanconfig_watchers th {\n    font-weight: bold;\n  }\n\n  .treeplanconfig_watchers td, .treeplanconfig_watchers th {\n    padding: 0 2px 0 2px;\n  }\n\n  .treeplanconfig_watchers tr {\n    border-bottom: 1px solid #ddd;\n  }\n\n  .treeplanconfig_watchers td.tools, .treeplanconfig_watchers th.tools {\n    width: 70px;\n    overflow: hidden;\n    display: inline-block;\n    white-space: nowrap;\n    text-align: right;\n    padding: 0 2px 0 2px;\n  }\n</style><table class=\"treeplanconfig_watchers\"><thead><tr><th>Operatore</th><th>Esterno</th><th>Nominativo</th><th>Contatti</th><th class=\"tools\"><a class=\"btn pull-right\" ng-click=\"newWatcher=true\"><i class=\"fa fa-plus-circle\"></i></a></th></tr></thead><tbody><tr ng-repeat=\"watcher in selected.model.configuration.watchers.internal\"><td><input type=\"radio\" disabled=\"\" ng-checked=\"watcher.UUID != undefined\"></td><td><input type=\"radio\" disabled=\"\" ng-checked=\"watcher.UUID == undefined\"></td><td><six-lookup-2 ng-model=\"watcher\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-compact=\"true\" sx-disabled=\"!watcher.edit\"></six-lookup-2></td><td></td><td class=\"tools\"><a class=\"btn pull-right\" ng-click=\"delete(selected.model.configuration.watchers.internal, watcher)\" ng-if=\"!watcher.edit\"><i class=\"fa fa-trash-o\"></i></a></td></tr><tr ng-repeat=\"watcher in selected.model.configuration.watchers.external\"><td><input type=\"radio\" disabled=\"\" ng-checked=\"watcher.UUID != undefined\"></td><td><input type=\"radio\" disabled=\"\" ng-checked=\"watcher.UUID == undefined\"></td><td></td><td><input class=\"form-control\" placeholder=\"Mail, telefono, ...\" type=\"text\" ng-model=\"watcher\" ng-disabled=\"!watcher.edit\"></td><td class=\"tools\"><a class=\"btn pull-right\" ng-click=\"delete(selected.model.configuration.watchers.external, watcher)\" ng-if=\"!watcher.edit\"><i class=\"fa fa-trash-o\"></i></a></td></tr><tr ng-show=\"newWatcher == true\"><td><input type=\"radio\" name=\"reference\" ng-model=\"insertNewWatcher.internal\" ng-init=\"insertNewWatcher.internal = true\" ng-value=\"true\" ng-change=\"insertNewWatcher.external = false\"></td><td><input type=\"radio\" name=\"reference\" ng-model=\"insertNewWatcher.external\" ng-init=\"insertNewWatcher.external = false\" ng-value=\"true\" ng-change=\"insertNewWatcher.internal = false\"></td><td><six-lookup-2 ng-model=\"insertNewWatcher\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'lookup\'\" sx-compact=\"true\" ng-show=\"insertNewWatcher.internal == true\"></six-lookup-2></td><td><input type=\"text\" ng-if=\"insertNewWatcher.external\" class=\"form-control\" placeholder=\"Mail, telefono, ...\" ng-model=\"insertNewWatcher.mail\"></td><td class=\"tools\"><a class=\"btn pull-right m-xs-l\" ng-click=\"newWatcher=false\"><i class=\"fa fa-history\"></i></a> <a class=\"btn\"><i class=\"fa fa-check-circle\" ng-click=\"addWatcher(insertNewWatcher)\"></i></a></td></tr></tbody></table>");
$templateCache.put("dataset/uom/uom_detail.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" sx-disabled=\"isDeletePermAllowed()===false\" toolbar-function=\"deleteWithDialog(type.selected.version)\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">CONVERSIONE UNITA\' DI MISURA</h1></div></div></div><div class=\"panel-body\"><uib-tabset><uib-tab index=\"0\"><uib-tab-heading>Dati</uib-tab-heading><div class=\"main col-lg-12\" style=\"padding-right: 0px;\"><div class=\"col-md-7\"><div class=\"row wrapper\"><div class=\"row\"><label for=\"vettore\" class=\"col-md-3 control-label\">Vettore energetico:</label><six-lookup id=\"vettore\" ng-model=\"model.record_id\" sx-type=\"\'vettoreenergetico\'\" sx-field=\"\'id\'\" class=\"col-md-6\"></six-lookup></div></div><div class=\"row wrapper\"><div class=\"row\"><label for=\"uom_from\" class=\"col-md-3 control-label\">Da:</label><six-lookup id=\"uom_from\" ng-model=\"model.uom_from\" sx-type=\"\'um\'\" sx-field=\"\'uom\'\" class=\"col-md-6\" sx-object=\"container_from.obj\"></six-lookup></div></div><div class=\"row wrapper\"><div class=\"row\"><label for=\"uom_to\" class=\"col-md-3 control-label\">A:</label><six-lookup id=\"uom_to\" ng-model=\"model.uom_to\" sx-type=\"\'um\'\" sx-field=\"\'uom\'\" class=\"col-md-6\" sx-object=\"container_to.obj\"></six-lookup></div></div><div class=\"row wrapper\"><div class=\"row\"><label for=\"uom_to\" class=\"col-md-3 control-label\">Nome variabile:</label><div class=\"col-md-6\"><input id=\"inputName\" type=\"text\" class=\"col-md-6 form-control\" ng-model=\"model.inputName\"></div></div></div><div class=\"row wrapper\"><div class=\"row\"><label class=\"col-md-3 control-label\">Formula:</label><div class=\"col-md-6\"><textarea ng-model=\"model.formula\" class=\"col-md-6 form-control\" rows=\"4\"></textarea></div></div></div><div class=\"row wrapper\"><div class=\"row\"><label class=\"control-label col-md-3\">Arrotondamento:</label><div class=\"col-md-6\"><select ng-model=\"model.rounding_mode\" class=\"col-md-6 form-control\"><option value=\"none\">Nessuno</option><option value=\"round\">Da 5 al valore superiore</option><option value=\"ceil\">Al valore superiore</option><option value=\"floor\">Al valore inferiore</option></select></div></div></div><div class=\"row wrapper\" ng-show=\"model.rounding_mode!=\'none\'\"><div class=\"row\"><label class=\"col-md-3 control-label\">N. cifre decimali:</label><div class=\"col-md-6\"><input id=\"precision\" type=\"number\" class=\"col-md-6 form-control\" min=\"0\" ng-model=\"model.precision\"></div></div></div></div><div class=\"col-md-5 override-padding-no-pad-left-right\"><div class=\"row wrapper\"><div class=\"panel panel-default\" id=\"panel1\"><a data-toggle=\"collapse\" data-target=\"#collapseOne\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i> Test conversione formula</h4></div></a><div id=\"collapseOne\" class=\"panel-collapse panel-heading collapse\"><div class=\"row wrapper\"><div class=\"row\"><label for=\"input\" class=\"col-md-2 control-label\">Input:</label><div class=\"col-md-6\"><input id=\"input\" type=\"text\" class=\"col-md-6 form-control\" ng-model=\"inputVal\"></div><div class=\"col-md-4\"><button ng-click=\"calculate(inputVal)\" class=\"btn btn-success btn-sm text-center col-md-offset-3\"><span class=\"fa fa-youtube-play\"></span> Calcola</button></div></div></div><div class=\"row wrapper\"><div class=\"row\"><label for=\"output\" class=\"col-md-2 control-label\">Risultato:</label><div class=\"col-md-6\"><input id=\"output\" type=\"text\" class=\"col-md-6 form-control\" ng-model=\"output\"></div></div></div></div></div></div></div></div></uib-tab><uib-tab index=\"1\"><uib-tab-heading>Parametri</uib-tab-heading><div class=\"main col-lg-12\"><div class=\"col-md-12 params-row\" ng-repeat=\"item in model.constant_params\"><div class=\"row wrapper\"><div class=\"row\"><label class=\"col-md-1 control-label\">Nome:</label><div class=\"col-md-4\"><input type=\"text\" class=\"col-md-12 form-control\" ng-model=\"item.name\"></div><label class=\"col-md-1 col-md-offset-1 control-label\">Valore:</label><div class=\"col-md-4\"><input class=\"col-md-12 form-control\" ng-model=\"item.value\" type=\"number\"></div><div class=\"col-md-1\" style=\"text-align: right;\"><button ng-click=\"deleteItemOnArray($index)\" class=\"btn btn-danger btn-md btn-default\"><i class=\"fa fa-trash\"></i></button></div></div></div></div><div class=\"col-md-12\"><div class=\"row wrapper\"><div class=\"row\"><div class=\"col-md-2 col-md-offset-10\"><button ng-click=\"appendToArray()\" type=\"button\" class=\"btn btn-default pull-right\"><i class=\"glyphicon glyphicon-plus\"></i> Aggiungi param.</button></div></div></div></div></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("dataset/uom/uom_list.html","<six-toolbar><six-toolbar-button label=\"Nuovo\" icon=\"fa fa-plus\" toolbar-function=\"newUom()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"getListWrapper()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">CONVERSIONE UNITA\' DI MISURA</h1></div></div></div><div class=\"panel-body\"><div class=\"form-group\"><input ng-keyup=\"getListWrapper()\" class=\"form-control\" type=\"text\" ng-model=\"queryParam\" placeholder=\"Scrivere qui per filtrare la lista...\"></div><table id=\"modeltype_list\" class=\"table table-striped\"><thead><tr><th class=\"col-md-2\"></th><th class=\"col-md-2\">Vettore</th><th class=\"col-md-2\">DA</th><th class=\"col-md-2\">A</th><th class=\"col-md-6\">FORMULA</th></tr></thead><tbody><tr ng-repeat=\"item in listWrapper.list\"><td><a ng-href=\"#/uom/{{item.code}}\" class=\"btn btn-default btn-sm\" id=\"btn_model_detail\"><span class=\"fa fa-pencil\"></span></a></td><td>{{ item.record_id.id.description}}</td><td>{{ item.uom_from.uom.description}}</td><td>{{ item.uom_to.uom.description}}</td><td>{{ item.formula }}</td></tr><tr ng-hide=\"listWrapper.list.length\"><td colspan=\"10\"><p class=\"text-center\">Nessun risultato trovato</p></td></tr></tbody></table></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-lg-12 text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"listWrapper.totalResults\" ng-model=\"listWrapper.currentPage\" class=\"pagination-sm\" items-per-page=\"listWrapper.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" max-size=\"10\"></uib-pagination></div></div></div></div></div>");
$templateCache.put("energy/budget/budget_detail.html","<style type=\"text/css\">\n  .hidden {\n    visibility: hidden;\n  }\n\n  .grid{\n    height: 800px;\n  }\n\n  .alignment{\n    padding-top: 28px;\n  }\n</style><six-toolbar><six-toolbar-item label=\"Valorizza\" icon=\"fa fa-files-o text-primary-dker\" toolbar-function=\"getData(true, false)\" ng-show=\"budget.budget_code\"></six-toolbar-item><six-toolbar-item label=\"Valorizza come consunt.\" icon=\"fa fa-files-o text-primary-dker\" toolbar-function=\"getData(true, true)\" ng-show=\"budget.budget_code\"></six-toolbar-item><six-toolbar-item label=\"Aggiungi voci\" icon=\"fa fa-plus text-info-dker\" toolbar-function=\"addVoices()\" ng-show=\"budget.budget_code\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" ng-click=\"goBack()\" ng-if=\"budget.budget_code\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"glyphicon glyphicon-save\" toolbar-function=\"update()\" ng-if=\"importingOperation === false && budget.searchCode.UUID\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" ng-if=\"budget.budget_code\" toolbar-function=\"deleteWithDialog(budget)\" sx-disabled=\"isDeletePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Nuovo\" btn-class=\"btn-info\" icon=\"fa fa-file\" toolbar-function=\"newBudget()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-md-8\"><h1 class=\"m-n font-thin h3 text-black\">BUDGET</h1><small class=\"text-muted\" ng-if=\"!budget.budget_code\">Dettaglio</small> <small class=\"text-muted\" ng-if=\"budget.budget_code\">{{budget.budget_code}}</small></div></div></div><div class=\"panel-body\" collapse=\"!isCollapsed\"><div class=\"col-md-12\"><div class=\"row form-group\"><div class=\"col-md-3\"><label id=\"code_label\" for=\"code\" class=\"control-label\">Codice</label> <input type=\"text\" id=\"code\" class=\"form-control\" ng-model=\"budget.budget_code\" ng-disabled=\"\'true\'\"></div><div class=\"col-md-3\"><label id=\"description_label\" for=\"description\" class=\"control-label\">Descrizione</label> <input type=\"text\" id=\"description\" class=\"form-control\" ng-model=\"budget.budget_description\"></div><div class=\"col-md-2\"><label id=\"year_label\" for=\"code\" class=\"control-label\">Anno</label> <input type=\"text\" id=\"year\" class=\"form-control\" ng-model=\"budget.year\" ng-disabled=\"\'true\'\"></div><div class=\"col-md-1\"><label id=\"default_label\" for=\"default\" class=\"control-label\">Default</label> <input type=\"checkbox\" id=\"default\" ng-model=\"budget.budget_default\" class=\"input-group\"></div><div class=\"col-md-3\"><label id=\"date_label\" for=\"default\" class=\"control-label\">Data di valorizzazione</label> <input class=\"form-control\" type=\"date\" ng-model=\"budget.eval_date\"></div></div></div><uib-tabset><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-money text-info-dker\"></span> Budget</uib-tab-heading><div class=\"row\"><div class=\"col-md-12\"><div id=\"gridDetail\" ui-grid=\"gridDetailOptions\" class=\"grid\" ui-grid-exporter=\"\" ui-grid-pinning=\"\" ui-grid-expandable=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\" ui-grid-auto-resize=\"\"></div></div></div><form class=\"wrapper m-t\"><div class=\"col-md-12\"><div class=\"row\" ng-if=\"percent > 0\"><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">{{percent | number : 0}}%</span> <span class=\"hidden-folded ng-scope\">Salvataggio</span></div><div class=\"progress-s m-t-sm dk progress ng-isolate-scope\" value=\"{{percent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{percent}}%;\"></div></div></div></div></form><div class=\"panel-body\"><div id=\"messages\" class=\"row m-t\" ng-if=\"reportMessages.length\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-heading\"><h4 class=\"panel-title\">Messaggi</h4></div><div class=\"panel-body\"><div class=\"col-md-12\"><div id=\"gridReport\" ui-grid=\"reportGridOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div></div></div></div></div></div></uib-tab><uib-tab index=\"1\"><uib-tab-heading><span class=\"fa fa-line-chart text-primary-dker\"></span> Grafici</uib-tab-heading><div class=\"col-md-12 m-t\" ng-class=\"{\'hidden\': !data.length}\"><six-multi-series-line-chart sx-graph-data=\"graphData\" sx-id=\"budgetGraph\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"Budget\"></six-multi-series-line-chart></div><div class=\"col-md-12 m-t\" ng-if=\"!data.length\"><div class=\"row\">Nessun grafico da mostrare</div></div></uib-tab><uib-tab index=\"2\"><uib-tab-heading><span class=\"fa fa-file-pdf-o text-warning-dker\"></span> Esportazioni</uib-tab-heading><div class=\"col-md-12 m-t\" ng-class=\"{\'hidden\': !data.length}\"><button ng-click=\"getPdf()\" class=\"btn btn-default btn-sm\" id=\"btn_pdf\"><span class=\"fa fa-file-pdf-o text-warning-dker\"></span> Scarica PDF</button> <button ng-click=\"getXlsx()\" class=\"btn btn-default btn-sm\" id=\"btn_xlsx\"><span class=\"fa fa-file-excel-o text-success-dker\"></span> Scarica XLSX</button> <button ng-click=\"getChart()\" class=\"btn btn-default btn-sm\" id=\"btn_chart\"><span class=\"fa fa-file-pdf-o text-danger-dker\"></span> Scarica Chart</button></div><div class=\"col-md-12 m-t\" ng-if=\"!data.length\"><div class=\"row\">Nessuna esportazione possibile</div></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("energy/budget/budget_eval.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" ng-click=\"goBack()\"></six-toolbar-button><six-toolbar-button label=\"Aggiorna\" btn-class=\"btn-info\" icon=\"fa fa-refresh\" toolbar-function=\"getData()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">ANALISI BUDGET</h1><small>{{budget.code}} - {{budget.description}} - {{budget.year}}</small></div></div></div><div class=\"row wrapper\"><div class=\"col-md-2\"><label class=\"control-label\">Da data:</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"datePicker.from\" is-open=\"statusFrom.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openFrom($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\"><label class=\"control-label\">A data:</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"datePicker.to\" is-open=\"statusTo.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openTo($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\"><label class=\"control-label\">Budget</label><six-select ng-model=\"budget\" sx-item-list=\"budgetList\"></six-select></div><div class=\"col-md-2\"><label for=\"type\" class=\"control-label\">Vettore energetico</label><six-lookup ng-model=\"vector\" sx-type=\"\'vettoreenergetico\'\" sx-field=\"\'id\'\"></six-lookup></div><div class=\"col-md-2\"><label id=\"type_label\" for=\"type\" class=\"control-label\">Tipo</label><six-lookup id=\"type\" sx-base-path=\"\'schema\'\" ng-model=\"type\" sx-field=\"\'id\'\" sx-filter=\"recordTypeFilter\"></six-lookup></div><div class=\"col-md-2\"><label id=\"contatoreId_label\" for=\"contatore_id\" class=\"control-label\">Contatore</label><six-lookup id=\"contatore_id\" ng-model=\"record\" sx-type=\"type.id.UUID\" sx-field=\"\'id\'\"></six-lookup></div></div><div class=\"panel-body\"><div class=\"col-md-12\"><six-loading-place-holder sx-model=\"loadingPlaceHolder\" sx-height=\"\'450px\'\"></six-loading-place-holder></div><div class=\"row wrapper\" ng-if=\"!loadingPlaceHolder.show\"><div class=\"col-md-12\" ng-if=\"data && data.length > 0\"><div style=\"overflow:scroll;\"><table class=\"detailTable table-hover\"><tr><th style=\"text-align: center; text-transform: none !important;\"></th><th ng-repeat=\"record in data\"><span ng-if=\"record.date\">{{record.date | date: \'MMM-yy\'}}</span> <span ng-if=\"!record.date\">Tot.</span></th></tr><tr><td>Budget [kWh]</td><td class=\"numberCell\" ng-repeat=\"record in data\"><span ng-if=\"record.bdg!==undefined\">{{record.bdg | number: 2}}</span> <span ng-if=\"!record.bdg===undefined\">-</span></td></tr><tr><td>Consuntivo [€]</td><td class=\"numberCell\" ng-repeat=\"record in data\"><span ng-if=\"record.consEval!==undefined\">{{record.consEval | number: 2}}</span> <span ng-if=\"!record.consEval===undefined\">-</span></td></tr><tr><td>Budget valorizzato [€]</td><td class=\"numberCell\" ng-repeat=\"record in data\"><span ng-if=\"record.bdgEval!==undefined\">{{record.bdgEval | number: 2}}</span> <span ng-if=\"!record.bdgEval===undefined\">-</span></td></tr><tr><td>Budget attualizzato [€]</td><td class=\"numberCell\" ng-repeat=\"record in data\"><span ng-if=\"record.bdgEvalConsLike!==undefined\">{{record.bdgEvalConsLike | number: 2}}</span> <span ng-if=\"!record.bdgEvalConsLike===undefined\">-</span></td></tr><tr><td>Fatt. revisione [€]</td><td class=\"numberCell\" ng-repeat=\"record in data\"><span ng-if=\"record.fattRevEuros!==undefined\">{{record.fattRevEuros | number: 2}}</span> <span ng-if=\"!record.fattRevEuros===undefined\">-</span></td></tr><tr><td>Fatt. revisione [%]</td><td class=\"numberCell\" ng-repeat=\"record in data\"><span ng-if=\"record.fattRevPerc!==undefined\">{{record.fattRevPerc | number: 2}}%</span> <span ng-if=\"!record.fattRevPerc===undefined\">-</span></td></tr><tr><td>Scostamento consuntivo [€]</td><td class=\"numberCell\" ng-repeat=\"record in data\"><span ng-if=\"record.consDiffEuros!==undefined\">{{record.consDiffEuros | number: 2}}</span> <span ng-if=\"!record.consDiffEuros===undefined\">-</span></td></tr><tr><td>Scostamento consuntivo [%]</td><td class=\"numberCell\" ng-repeat=\"record in data\"><span ng-if=\"record.consDiffPerc!==undefined\">{{record.consDiffPerc | number: 2}}%</span> <span ng-if=\"!record.consDiffPerc===undefined\">-</span></td></tr></table></div></div></div><div class=\"col-md-12 m-t\" ng-class=\"{\'hidden\': !graphData.length}\"><six-multi-series-line-chart sx-graph-data=\"graphData\" sx-id=\"data\" sx-y-axis-legend=\"\'Euro\'\" sx-graph-title=\"Valorizzazioni\"></six-multi-series-line-chart></div></div></div><div class=\"panel panel-default\" ng-if=\"reportMessages && reportMessages.length>0\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div id=\"reportGrid\" ui-grid=\"reportGridOptions\" class=\"grid\" ui-grid-resize-columns=\"\" ui-grid-auto-resize=\"\"></div></div></div></div></div></div>");
$templateCache.put("energy/budget/budget_list.html","<style type=\"text/css\">\n  .hidden {\n    visibility: hidden;\n  }\n\n  .grid{\n    height: 800px;\n  }\n\n  .alignment{\n    padding-top: 28px;\n  }\n\n  #btn_search{\n    margin-top: 8px;\n  }\n</style><six-toolbar><six-toolbar-item label=\"Valorizza\" icon=\"fa fa-files-o text-primary-dker\" toolbar-function=\"getData(true)\" ng-show=\"budget.budget_code\"></six-toolbar-item><six-toolbar-item label=\"Aggiungi voci\" icon=\"fa fa-plus text-info-dker\" toolbar-function=\"addVoices()\" ng-show=\"budget.budget_code\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" ng-click=\"unselectBudget()\" ng-if=\"budget.budget_code\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"glyphicon glyphicon-save\" toolbar-function=\"update()\" ng-if=\"importingOperation === false && budget.searchCode.UUID\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" ng-if=\"budget.budget_code\" toolbar-function=\"deleteWithDialog(budget)\" sx-disabled=\"isDeletePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Nuovo\" btn-class=\"btn-info\" icon=\"fa fa-plus\" toolbar-function=\"newBudget()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-md-8\"><h1 class=\"m-n font-thin h3 text-black\">BUDGET</h1><small class=\"text-muted\" ng-if=\"!budget.budget_code\">Lista</small></div></div></div><div class=\"panel-body\" collapse=\"isCollapsed\"><div class=\"row wrapper\"><div class=\"col-md-3\"><label id=\"tipo_label\" for=\"record_type\" class=\"control-label\">Tipo</label><six-lookup id=\"record_type\" sx-base-path=\"\'schema\'\" ng-model=\"record\" sx-field=\"\'type_id\'\"></six-lookup></div><div class=\"col-md-3\"><label id=\"contatoreId_label\" for=\"record_id\" class=\"control-label\">Record</label><six-lookup id=\"record_id\" ng-model=\"record\" sx-type=\"record.type_id.UUID\" sx-field=\"\'record_id\'\"></six-lookup></div><div class=\"col-md-3\"><label id=\"year_label\" for=\"year\" class=\"control-label\">Anno</label><six-year-picker id=\"year\" ng-model=\"year\" sx-big=\"true\" class=\"input-group\"></six-year-picker></div><div class=\"col-md-1\"><label for=\"btn_search\" class=\"control-label\"></label> <button ng-click=\"loadAvailableBudgetCodes()\" class=\"btn btn-info btn-sm pull-right\" id=\"btn_search\"><span class=\"fa fa-search\"></span> Cerca</button></div></div><div class=\"col-md-12\"><hr></div><div class=\"row\"><div class=\"col-md-12\"><div id=\"gridList\" ui-grid=\"gridListOptions\" class=\"grid\" ui-grid-resize-columns=\"\" ui-grid-auto-resize=\"\"></div></div></div></div></div></div>");
$templateCache.put("energy/budget/budget_new.html","<style type=\"text/css\">\n  .hidden {\n    visibility: hidden;\n  }\n</style><six-toolbar><six-toolbar-item label=\"Template\" icon=\"fa fa-download icon text-info-dker\" toolbar-function=\"downloadTemplate()\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Reset\" icon=\"fa fa-undo\" toolbar-function=\"reset()\" sx-disabled=\"importingOperation === false\"></six-toolbar-button><six-toolbar-button label=\"Importa\" icon=\"fa fa-upload\" toolbar-function=\"importData()\" btn-class=\"btn-success\" sx-disabled=\"importingOperation === false || percent === 100 || !budget.budget_code || !budget.eval_date || !data || data.length === 0\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-12 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">BUDGET</h1><small class=\"text-muted\">{{budget.searchCode.code}}</small></div></div></div><div class=\"panel wrapper\"><div class=\"panel-body\"><form class=\"wrapper m-t\"><div class=\"col-md-12\"><div class=\"row form-group\"><div class=\"col-md-3\"><label id=\"code_label\" for=\"code\" class=\"control-label\">Codice</label> <input type=\"text\" id=\"code\" class=\"form-control\" ng-model=\"budget.budget_code\" ng-disabled=\"budget.searchCode.UUID\" ng-pattern=\"CODE_PATTERN\" required=\"\"></div><div class=\"col-md-3\"><label id=\"description_label\" for=\"description\" class=\"control-label\">Descrizione</label> <input type=\"text\" id=\"description\" class=\"form-control\" ng-model=\"budget.budget_description\" ng-disabled=\"budget.searchCode.UUID\"></div><div class=\"col-md-1\"><label id=\"default_label\" for=\"default\" class=\"control-label\">Default</label> <input type=\"checkbox\" id=\"default\" ng-model=\"budget.budget_default\" class=\"input-group\" ng-disabled=\"budget.searchCode.UUID\"></div><div class=\"col-md-3\"><label id=\"date_label\" for=\"default\" class=\"control-label\">Data di valorizzazione</label> <input class=\"form-control\" type=\"date\" ng-model=\"budget.eval_date\" ng-disabled=\"budget.searchCode.UUID\"></div><div class=\"col-md-2\"><a href=\"/energy/attachments/template_budget.xls\" class=\"btn bg-info pull-right control-label hidden\" id=\"linkToTemplate\"><i class=\"fa fa-download\"></i> Template</a></div><div class=\"col-md-12\"><hr></div></div></div></form><div class=\"row wrapper\"><div class=\"col-md-12\"><div ui-grid=\"gridImportOptions\" class=\"grid\" ui-grid-resize-columns=\"\"><div class=\"grid-msg-overlay\" ng-show=\"!gridImportOptions.data.length\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"gridImportOptions\" multiple=\"false\"></div></div></div></div></div></div><div class=\"col-md-12\"><div class=\"wrapper m-t\"><div class=\"row\" ng-if=\"percent > 0\"><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">{{percent | number : 0}}%</span> <span class=\"hidden-folded ng-scope\">Salvataggio</span></div><div class=\"progress-s m-t-sm dk progress ng-isolate-scope\" value=\"{{percent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{percent}}%;\"></div></div></div></div></div></div><div class=\"panel-body\"><div id=\"messages\" class=\"row m-t\" ng-if=\"reportMessages.length\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-heading\"><h4 class=\"panel-title\">Messaggi</h4></div><div class=\"panel-body\"><div class=\"col-md-12\"><div id=\"gridReport\" ui-grid=\"reportGridOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("energy/budget/detail.html","<div class=\"col-md-12\"><div class=\"row\"><div class=\"col-sm-4\"><label>Tipo</label><p class=\"form-control-static\">{{detailSelected.record_type}}</p></div><div class=\"col-sm-6\"><label>Codice - Descrizione</label> <a href=\"{{detailSelected.record_url}}\"><p class=\"form-control-static\">{{detailSelected.record_code}} - {{detailSelected.record_description}}</p></a></div><div class=\"col-sm-2\"><label>Anno</label><p class=\"form-control-static\">{{detailSelected.anno}}</p></div></div></div><div class=\"col-md-12\"><hr></div><div class=\"col-md-12\"><table class=\"detailTable table-hover\"><tr><th style=\"text-align: center\" ng-repeat=\"column in detailSelected.subGridOptions.columnDefs\">{{column.name}}</th></tr><tr ng-repeat=\"data in detailSelected.subGridOptions.data | filter: \'!tot_std\'\"><td>{{data.record_code}}</td><td class=\"numberCell\" ng-repeat=\"month in [\'gennaio\', \'febbraio\', \'marzo\', \'aprile\', \'maggio\', \'giugno\', \'luglio\', \'agosto\', \'settembre\', \'ottobre\', \'novembre\', \'dicembre\']\">{{data[month] | number: 2}}</td><td class=\"numberCell\">{{data.tot | number: 2}}</td></tr><tr><td>Totale</td><td class=\"numberCell\" ng-repeat=\"month in [\'gennaio\', \'febbraio\', \'marzo\', \'aprile\', \'maggio\', \'giugno\', \'luglio\', \'agosto\', \'settembre\', \'ottobre\', \'novembre\', \'dicembre\']\"><b>{{detailSelected[month] | number: 2}}</b></td><td class=\"numberCell\"><b>{{detailSelected.tot | number: 2}}</b></td></tr></table></div><div class=\"col-md-12\"><hr></div><div class=\"col-md-12\"><table class=\"detailTable\"><tr><th style=\"text-align: center\">Fattore</th><th style=\"text-align: center\" ng-repeat=\"month in [\'gennaio\', \'febbraio\', \'marzo\', \'aprile\', \'maggio\', \'giugno\', \'luglio\', \'agosto\', \'settembre\', \'ottobre\', \'novembre\', \'dicembre\']\">{{month}}</th></tr><tr ng-repeat=\"data in detailSelected.subGridOptions.data | filter: \'!tot_std\'\"><td>{{data.record_code}}</td><td class=\"numberCell\" ng-repeat=\"month in [\'gennaio\', \'febbraio\', \'marzo\', \'aprile\', \'maggio\', \'giugno\', \'luglio\', \'agosto\', \'settembre\', \'ottobre\', \'novembre\', \'dicembre\']\"><slider ng-model=\"seasonFactor[data.record_code][month]\" orientation=\"vertical\" min=\"-1\" step=\"0.05\" max=\"1\" ng-change=\"\"></slider></td></tr></table></div><div class=\"col-md-12\"><hr></div>");
$templateCache.put("energy/budget/expandableRowTemplate.html","<div ui-grid=\"row.entity.subGridOptions\" ui-grid-resize-columns=\"\" style=\"height:240px;\"></div>");
$templateCache.put("energy/closure/closure.html","<div class=\"col-md-12 pad-t-15\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Wizard chiusura contatore</h1></div></div></div><div class=\"col-md-12 panel panel-default panel-body\"><div class=\"col-md-6\"><label class=\"m-t\">Tipo:</label><six-lookup id=\"record_type\" sx-base-path=\"\'schema\'\" ng-model=\"schema\" sx-field=\"\'id\'\"></six-lookup></div><div class=\"col-md-6\"><label class=\"m-t\">Contatore:</label><six-lookup id=\"record_id\" ng-model=\"record\" sx-type=\"schema.id.UUID\" sx-field=\"\'id\'\" sx-object=\"record.obj\"></six-lookup></div></div><div class=\"col-md-12 panel panel-default panel-body\"><div class=\"col-md-6\"><label class=\"m-t\">Codice:</label> <input type=\"text\" class=\"form-control\" readonly=\"\" value=\"{{record.obj.model.code}}\"></div><div class=\"col-md-6\"><label class=\"m-t\">Descrizione:</label> <input type=\"text\" class=\"form-control\" readonly=\"\" value=\"{{record.obj.model.description}}\"></div><div class=\"col-md-6\"><label class=\"m-t\">Stato:</label> <input type=\"text\" class=\"form-control\" readonly=\"\" value=\"{{record.obj.model.stato}}\"></div></div><div class=\"col-md-12 panel panel-default panel-body\" ng-if=\"record.obj && record.obj.model.stato===\'chiuso\'\"><div class=\"alert alert-warning\" role=\"alert\"><span class=\"font-bold\">ATTENZIONE</span>: il {{schema.id.description}} <span class=\"font-italic\">{{record.id.code}}</span> è già stato chiuso.</div></div><div class=\"col-md-12 panel panel-default panel-body\" ng-if=\"record.obj && record.obj.model.stato!==\'chiuso\'\"><label class=\"m-t\">Data chiusura:</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"datePicker.date\" is-open=\"dpStatus.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"dpOpen()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"m-t\" ng-if=\"schema.id.code\">Ultima lettura:</div><div ng-if=\"schema.id.code === \'contatoreelettricita\'\"><div class=\"col-md-3\"><label class=\"m-t\">F0:</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"read.f0\"> <span class=\"input-group-addon\">{{um.description}}</span></div></div><div class=\"col-md-3\"><label class=\"m-t\">F1:</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"read.f1\"> <span class=\"input-group-addon\">{{um.description}}</span></div></div><div class=\"col-md-3\"><label class=\"m-t\">F2:</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"read.f2\"> <span class=\"input-group-addon\">{{um.description}}</span></div></div><div class=\"col-md-3\"><label class=\"m-t\">F3:</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"read.f3\"> <span class=\"input-group-addon\">{{um.description}}</span></div></div></div><div ng-if=\"schema.id.code === \'contatoregas\'\"><div class=\"col-md-6\"><label class=\"m-t\">F0:</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"read.f0\"> <span class=\"input-group-addon\">{{um.description}}</span></div></div><div class=\"col-md-6\"><label class=\"m-t\">Correttore:</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"read.correttore\"> <span class=\"input-group-addon\">{{um.description}}</span></div></div></div><div ng-if=\"schema.id.code === \'serbatoioinpressione\' || schema.id.code === \'serbatoiopressioneatmosferica\'\"><div class=\"col-md-6\"><label class=\"m-t\">F0:</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"read.f0\"> <span class=\"input-group-addon\">{{um.description}}</span></div></div><div class=\"col-md-6\"><label class=\"m-t\">Scarico:</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"read.scarico\"> <span class=\"input-group-addon\">{{um.description}}</span></div></div></div><div ng-if=\"schema.id.code && schema.id.code !== \'contatoreelettricita\' && schema.id.code !== \'contatoregas\' && schema.id.code !== \'serbatoioinpressione\' && schema.id.code !== \'serbatoiopressioneatmosferica\'\"><div class=\"col-md-12\"><label class=\"m-t\">F0:</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"read.f0\"> <span class=\"input-group-addon\">{{um.description}}</span></div></div></div><button class=\"btn btn-info pull-right m-t\" ng-click=\"closeRecord()\" ng-disabled=\"!checkInputData()\">Chiudi</button></div></div></div>");
$templateCache.put("energy/consumptionanalysis/consumptionanalysis.html","<div id=\"loading-bar-container\"></div><script type=\"text/ng-template\" id=\"vector-detail.html\"><div class=\"panel-heading\"> <h4 class=\"panel-title font-bold\">{{vector.model.description}}</h4> </div> <div class=\"col-md-12\"> <six-loading-place-holder sx-model=\"vector.loadingPlaceHolder\" sx-height=\"\'450px\'\"></six-loading-place-holder> </div> <div class=\"row wrapper\" ng-if=\"!vector.loadingPlaceHolder.show\"> <div class=\"col-md-12\" ng-if=\"vector.cachedData.budget.toRender.list && vector.cachedData.budget.toRender.list.length > 0\"> <div style=\"overflow:scroll;\"> <table class=\"detailTable table-hover\"> <tr> <th style=\"text-align: center; text-transform: none !important;\"></th> <th ng-repeat=\"record in vector.cachedData.budget.toRender.list\">{{record.date | date: \'MMM-yy\'}}</th> <th>Tot.</th> </tr> <tr> <td>Budget [{{vector.model.um.description}}]</td> <td class=\"numberCell\" ng-repeat=\"record in vector.cachedData.budget.toRender.list\">{{record.budget | number: 3}}</td> <td class=\"numberCell\">{{vector.cachedData.budget.toRender.totalBudget | number: 3}}</td> </tr> <tr> <td>Consuntivo [{{vector.model.um.description}}]</td> <td class=\"numberCell\" ng-repeat=\"record in vector.cachedData.budget.toRender.list\">{{record.cons | number: 3}}</td> <td class=\"numberCell\">{{vector.cachedData.budget.toRender.totalConsumption | number: 3}}</td> </tr> <tr ng-if=\"currentVector != totVector && currentVector.model.code != \'elettricita\' && currentVector.model.code != \'tlr\' && currentVector.model.code != \'acqua\'\"> <td>Consuntivo [kWh]</td> <td class=\"numberCell\" ng-repeat=\"record in vector.cachedData.budget.list\">{{record.std.cons | number: 3}}</td> <td class=\"numberCell\">{{vector.cachedData.budget.totalConsumptionStd | number: 3}}</td> </tr> <tr> <td>Stagionalità [{{vector.model.um.description}}]</td> <td class=\"numberCell\" ng-repeat=\"record in vector.cachedData.budget.toRender.list\">{{record.season | number: 3}}</td> <td class=\"numberCell\">{{vector.cachedData.budget.toRender.season | number: 3}}</td> </tr> <tr> <td>&Delta; Stagionalità [{{vector.model.um.description}}]</td> <td class=\"numberCell\" ng-repeat=\"record in vector.cachedData.budget.toRender.list\">{{record.deltaSeason | number: 3}}</td> <td class=\"numberCell\">{{vector.cachedData.budget.toRender.deltaSeason | number: 3}}</td> </tr> <tr> <td>&Delta; Tecnico [{{vector.model.um.description}}]</td> <td class=\"numberCell\" ng-repeat=\"record in vector.cachedData.budget.toRender.list\">{{record.deltaTech | number: 3}}</td> <td class=\"numberCell\">{{vector.cachedData.budget.toRender.deltaTech | number: 3}}</td> </tr> <tr> <td>%</td> <td class=\"numberCell\" ng-repeat=\"record in vector.cachedData.budget.toRender.list\">{{record.percentage | number: 2}}</td> <td class=\"numberCell\">{{vector.cachedData.budget.toRender.percentage | number: 2}}</td> </tr> </table> </div> </div> </div> <div class=\"row wrapper\"> <div class=\"col-md-12\"> <six-multi-series-line-chart sx-id=\"graph_{{vector.model.code}}\" sx-graph-data=\"vector.cachedData.graphData\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"{{vector.model.description}}\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\', \'#EE2222\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart> </div> </div> <div class=\"row wrapper\"> <div class=\"col-md-12\"> <six-multi-series-line-chart sx-id=\"graph_cum_{{vector.model.code}}\" sx-graph-data=\"vector.cachedData.graphDataCumulative\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"{{vector.model.description}} - cumulato\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart> </div> </div></script><six-toolbar class=\"constructor\"><six-toolbar-item label=\"Vettori energetici\" btn-class=\"btn-info\" icon=\"fa fa-show\" toolbar-function=\"toggleSidebar()\"></six-toolbar-item><six-toolbar-item label=\"Bdg Snap\" btn-class=\"btn-success\" toolbar-function=\"loadBudgetSnapDate()\" icon=\"fa fa-bolt icon text-success-dker\"><li><a ng-click=\"createAllBudgetSnap()\">Ricrea bdg Snap (Tutti)</a></li><li><a>Filtri <span class=\"text-muted\">- {{filterBdgSnapDate | date: \"dd/MM/yyyy HH:mm:ss\"}}</span> <span class=\"btn btn-default btn-sm fa fa-trash\" href=\"\" ng-click=\"deleteBudgetSnap()\"></span> <span class=\"btn btn-default btn-sm fa fa-cogs\" href=\"\" ng-click=\"recreateBudgetSnap()\"></span></a></li><li ng-repeat=\"vector in allVectors\"><a>{{vector.model.description}} <span class=\"text-muted\">- {{vector.bdgSnapDate | date: \"dd/MM/yyyy HH:mm:ss\"}}</span> <span class=\"btn btn-default btn-sm fa fa-trash\" href=\"\" ng-click=\"deleteBudgetSnap(vector)\"></span> <span class=\"btn btn-default btn-sm fa fa-cogs\" href=\"\" ng-click=\"recreateBudgetSnap(vector)\"></span></a></li></six-toolbar-item><six-toolbar-item label=\"Z.T. Snap\" btn-class=\"btn-success\" icon=\"fa fa-bolt icon text-success-dker\"><li><a ng-click=\"createZtSnap()\">Crea ZT Snap</a></li><li><a ng-click=\"deleteZtSnap()\">Canc. ZT Snap</a></li><li><a ng-click=\"recreateZtSnap()\">Ricrea ZT Snap</a></li></six-toolbar-item><six-toolbar-item label=\"GG Snap\" btn-class=\"btn-success\" toolbar-function=\"loadDDSnapsDate()\" icon=\"fa fa-bolt icon text-success-dker\"><li><a ng-click=\"createAllDDSnap()\">Ricrea GG Snap (Tutti)</a></li><li><a>Filtri <span class=\"text-muted\">- {{filterDDSnapDate | date: \"dd/MM/yyyy HH:mm:ss\"}}</span> <span class=\"btn btn-default btn-sm fa fa-trash\" href=\"\" ng-click=\"deleteDDSnap()\"></span> <span class=\"btn btn-default btn-sm fa fa-cogs\" href=\"\" ng-click=\"recreateDDSnap()\"></span></a></li><li ng-repeat=\"vector in allVectors\"><a>{{vector.model.description}} <span class=\"text-muted\">- {{vector.ddSnapDate | date: \"dd/MM/yyyy HH:mm:ss\"}}</span> <span class=\"btn btn-default btn-sm fa fa-trash\" href=\"\" ng-click=\"deleteDDSnap(vector)\"></span> <span class=\"btn btn-default btn-sm fa fa-cogs\" href=\"\" ng-click=\"recreateDDSnap(vector)\"></span></a></li></six-toolbar-item><six-toolbar-item label=\"Consumi Snap\" btn-class=\"btn-success\" toolbar-function=\"loadConsumptionsSnapsDate()\" icon=\"fa fa-bolt icon text-success-dker\"><li><a ng-click=\"createAllConsumptionsSnap()\">Ricrea Consumi Snap (Tutti)</a></li><li><a>Filtri <span class=\"text-muted\">- {{filterConsumptionsSnapDate | date: \"dd/MM/yyyy HH:mm:ss\"}}</span> <span class=\"btn btn-default btn-sm fa fa-trash\" href=\"\" ng-click=\"deleteConsumptionsSnap()\"></span> <span class=\"btn btn-default btn-sm fa fa-cogs\" href=\"\" ng-click=\"recreateConsumptionsSnap()\"></span></a></li><li ng-repeat=\"vector in allVectors\"><a>{{vector.model.description}} <span class=\"text-muted\">- {{vector.consumptionsSnapDate | date: \"dd/MM/yyyy HH:mm:ss\"}}</span> <span class=\"btn btn-default btn-sm fa fa-trash\" href=\"\" ng-click=\"deleteConsumptionsSnap(vector)\"></span> <span class=\"btn btn-default btn-sm fa fa-cogs\" href=\"\" ng-click=\"recreateConsumptionsSnap(vector)\"></span></a></li></six-toolbar-item><six-toolbar-item label=\"Analisi cons. Snap\" btn-class=\"btn-success\" toolbar-function=\"loadConsAnalisysSnapsDate()\" icon=\"fa fa-bolt icon text-success-dker\"><li><a ng-click=\"createAllConsAnalisysSnap()\">Ricrea Analisi Snap (tutti)</a></li><li><a>Filtri <span class=\"text-muted\">- {{filterConsAnalisysSnapDate | date: \"dd/MM/yyyy HH:mm:ss\"}}</span> <span class=\"btn btn-default btn-sm fa fa-trash\" href=\"\" ng-click=\"deleteConsAnalisysSnap()\"></span> <span class=\"btn btn-default btn-sm fa fa-cogs\" href=\"\" ng-click=\"recreateConsAnalisysSnap()\"></span></a></li><li ng-repeat=\"vector in allVectors\"><a>{{vector.model.description}} <span class=\"text-muted\">- {{vector.consAnalisysSnapDate | date: \"dd/MM/yyyy HH:mm:ss\"}}</span> <span class=\"btn btn-default btn-sm fa fa-trash\" href=\"\" ng-click=\"deleteConsAnalisysSnap(vector)\"></span> <span class=\"btn btn-default btn-sm fa fa-cogs\" href=\"\" ng-click=\"recreateConsAnalisysSnap(vector)\"></span></a></li></six-toolbar-item><six-toolbar-button label=\"Stampa PDF\" btn-class=\"btn-default\" icon=\"fa fa-print\" toolbar-function=\"openDialogReport(\'pdf\')\"></six-toolbar-button><six-toolbar-button label=\"Stampa Excel\" btn-class=\"btn-default\" icon=\"fa fa-file-excel-o\" toolbar-function=\"openDialogReport(\'xlsx\')\"></six-toolbar-button><six-toolbar-button label=\"Ricalcola\" btn-class=\"btn-info\" icon=\"fa fa-square-o\" icon-disabled=\"fa fa-check-square-o\" icon-condition=\"forceReprocessing\" toolbar-function=\"toggleForceReprocessing()\"></six-toolbar-button><six-toolbar-button label=\"Aggiorna\" btn-class=\"btn-info\" icon=\"fa fa-refresh\" toolbar-function=\"loadVectors()\"></six-toolbar-button></six-toolbar><six-sidebar sx-id=\"vectors_sidebar\" sx-position=\"left\" sx-title=\"\'Vettori\'\" sx-dimension=\"s\" sx-opened=\"sidebar\"><ul id=\"list-sidebar-ul\" class=\"nav list-sidebar-nav\"><li class=\"m-l-xs m-r-xs\"><a ng-click=\"goToAnchor(\'top\')\">Top</a></li><li ng-repeat=\"vector in vectors\" class=\"m-l-xs m-r-xs\"><a ng-click=\"goToAnchor(vector.model.code+\'_details\')\" six-sidebar-autoclose=\"true\">{{vector.model.description}}</a></li></ul></six-sidebar><div id=\"top\" class=\"constructor\"><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">ANALISI CONSUMI</h1><small class=\"text-muted\" ng-if=\"budget.list && budget.list.length > 0\">Cod. Commessa ({{info.commissions.current.code}}): {{type.type_id.description}} - {{contatore.contatore_id.description}} - Cod. Budget: {{analisysHeaderInfos.budgets}} (Periodo: {{analisysHeaderInfos.period.from}} - {{analisysHeaderInfos.period.to}})</small> <small class=\"text-muted\" ng-if=\"!budget.list || budget.list.length <= 0\">Selezionare un budget</small></div></div></div><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"col-md-2\"><label class=\"control-label\">Vettore energetico</label><six-lookup-2 sx-id=\"vetten\" ng-model=\"vector\" sx-type=\"\'vettoreenergetico\'\" sx-field=\"\'id\'\" sx-object=\"currentVector\"></six-lookup-2></div><div class=\"col-md-2\"><label id=\"type_label\" class=\"control-label\">Tipo</label><six-lookup-2 sx-id=\"type\" sx-base-path=\"\'schema\'\" ng-model=\"type\" sx-title=\"\'Tipo\'\" sx-field=\"\'type_id\'\" sx-filter=\"contatoreTypeFilter\"></six-lookup-2></div><div class=\"col-md-2\"><label id=\"contatoreId_label\" class=\"control-label\">Contatore</label><six-lookup-2 sx-id=\"contatore\" ng-model=\"contatore\" sx-type=\"type.type_id.UUID\" sx-field=\"\'contatore_id\'\"></six-lookup-2></div><div class=\"col-md-2\"><label class=\"control-label\">Da data:</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"datePicker.from\" is-open=\"statusFrom.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openFrom($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\"><label class=\"control-label\">A data:</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"datePicker.to\" is-open=\"statusTo.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openTo($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\"><label for=\"search_budget_code\" class=\"control-label\">Budget</label><div id=\"search_budget_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"selectedBudgets.selected\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Enter...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableBudgetCodes\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div></div><div class=\"col-md-12\"><hr></div></div><div class=\"panel-body\" ng-repeat=\"vector in vectors\"><div class=\"row wrapper\"><div ng-include=\"\'vector-detail.html\'\" id=\"{{vector.model.code}}_details\"></div></div></div></div></div></div>");
$templateCache.put("energy/consumptionanalysis/consumptionanalysis_old.html","<six-toolbar><six-toolbar-button label=\"Ricalcola\" icon=\"fa fa-square-o\" icon-disabled=\"fa fa-check-square-o\" icon-condition=\"forceReprocessing\" toolbar-function=\"toggleForceReprocessing()\"></six-toolbar-button><six-toolbar-button label=\"Aggiorna\" btn-class=\"btn-info\" icon=\"fa fa-refresh\" toolbar-function=\"loadData(currentVector, true)\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">ANALISI CONSUMI</h1><small class=\"text-muted\" ng-if=\"budget.list && budget.list.length > 0\">Cod. Commessa ({{info.commissions.current.code}}): {{type.type_id.description}} - {{contatore.contatore_id.description}} - Cod. Budget: {{analisysHeaderInfos.budgets}} (Periodo: {{analisysHeaderInfos.period.from}} - {{analisysHeaderInfos.period.to}})</small> <small class=\"text-muted\" ng-if=\"!budget.list || budget.list.length <= 0\">Selezionare un budget</small></div></div></div><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"col-md-2\"><label for=\"type\" class=\"control-label\">Vettore energetico</label><six-lookup ng-model=\"vector\" sx-type=\"\'vettoreenergetico\'\" sx-field=\"\'id\'\" sx-object=\"currentVector\"></six-lookup></div><div class=\"col-md-2\"><label id=\"type_label\" for=\"type\" class=\"control-label\">Tipo</label><six-lookup id=\"type\" sx-base-path=\"\'schema\'\" ng-model=\"type\" sx-field=\"\'type_id\'\" sx-filter=\"contatoreTypeFilter\"></six-lookup></div><div class=\"col-md-2\"><label id=\"contatoreId_label\" for=\"contatore_id\" class=\"control-label\">Contatore</label><six-lookup id=\"contatore_id\" ng-model=\"contatore\" sx-type=\"type.type_id.UUID\" sx-field=\"\'contatore_id\'\"></six-lookup></div><div class=\"col-md-2\"><label class=\"control-label\">Da data:</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"datePicker.from\" is-open=\"statusFrom.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openFrom($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\"><label class=\"control-label\">A data:</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"datePicker.to\" is-open=\"statusTo.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openTo($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\"><label for=\"search_budget_code\" class=\"control-label\">Budget</label><div id=\"search_budget_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"selectedBudgets.selected\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Enter...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableBudgetCodes\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div></div><div class=\"col-md-12\"><hr></div><div class=\"col-md-12\"><six-loading-place-holder sx-model=\"loadingPlaceHolder\" sx-height=\"\'450px\'\"></six-loading-place-holder></div><div class=\"row wrapper\" ng-if=\"!loadingPlaceHolder.show\"><div class=\"col-md-12\" ng-if=\"!budget.toRender.list || budget.toRender.list.length === 0\">Nessun dato da mostrare</div><div class=\"col-md-12\" ng-if=\"budget.toRender.list && budget.toRender.list.length > 0\"><div style=\"overflow:scroll;\"><table class=\"detailTable table-hover\"><tr><th style=\"text-align: center; text-transform: none !important;\"></th><th ng-repeat=\"record in budget.toRender.list\">{{record.date | date: \'MMM-yy\'}}</th><th>Tot.</th></tr><tr><td>Budget [{{um}}]</td><td class=\"numberCell\" ng-repeat=\"record in budget.toRender.list\">{{record.budget | number: 3}}</td><td class=\"numberCell\">{{budget.toRender.totalBudget | number: 3}}</td></tr><tr><td>Consuntivo [{{um}}]</td><td class=\"numberCell\" ng-repeat=\"record in budget.toRender.list\">{{record.cons | number: 3}}</td><td class=\"numberCell\">{{budget.toRender.totalConsumption | number: 3}}</td></tr><tr ng-if=\"currentVector != totVector && currentVector.model.code != \'elettricita\' && currentVector.model.code != \'tlr\' && currentVector.model.code != \'acqua\'\"><td>Consuntivo [kWh]</td><td class=\"numberCell\" ng-repeat=\"record in budget.list\">{{record.std.cons | number: 3}}</td><td class=\"numberCell\">{{budget.totalConsumptionStd | number: 3}}</td></tr><tr><td>Stagionalità [{{um}}]</td><td class=\"numberCell\" ng-repeat=\"record in budget.toRender.list\">{{record.season | number: 3}}</td><td class=\"numberCell\">{{budget.toRender.season | number: 3}}</td></tr><tr><td>&Delta; Stagionalità [{{um}}]</td><td class=\"numberCell\" ng-repeat=\"record in budget.toRender.list\">{{record.deltaSeason | number: 3}}</td><td class=\"numberCell\">{{budget.toRender.deltaSeason | number: 3}}</td></tr><tr><td>&Delta; Tecnico [{{um}}]</td><td class=\"numberCell\" ng-repeat=\"record in budget.toRender.list\">{{record.deltaTech | number: 3}}</td><td class=\"numberCell\">{{budget.toRender.deltaTech | number: 3}}</td></tr><tr><td>%</td><td class=\"numberCell\" ng-repeat=\"record in budget.toRender.list\">{{record.percentage | number: 2}}</td><td class=\"numberCell\">{{budget.toRender.percentage | number: 2}}</td></tr></table></div></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><six-multi-series-line-chart sx-id=\"graph1\" sx-graph-data=\"graphData\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"Consumi\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\', \'#EE2222\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><six-multi-series-line-chart sx-id=\"graph2\" sx-graph-data=\"graphDataCumulative\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"Consumi cumulati\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart></div></div><div class=\"row wrapper\" ng-if=\"showJasper && !loadingPlaceHolder.show\"><div class=\"col-md-12\"><button ng-click=\"openAnalysisOne()\" class=\"btn btn-default btn-sm\" id=\"btn_chart\"><span class=\"fa fa-file-pdf-o text-danger-dker\"></span> Consuntivo consumi</button> <button ng-click=\"openAnalysisTwo()\" class=\"btn btn-default btn-sm\" id=\"btn_chart2\"><span class=\"fa fa-file-pdf-o text-danger-dker\"></span> Andamento Budget/Consuntivo</button> <button ng-click=\"openAnalysisThree()\" class=\"btn btn-default btn-sm\" id=\"btn_chart3\"><span class=\"fa fa-file-pdf-o text-danger-dker\"></span> Andamento Dei Fattori</button></div></div></div></div></div>");
$templateCache.put("energy/consumptionanalysis/consumptionanalysiscross.html","<div id=\"loading-bar-container\"></div><six-toolbar class=\"constructor\"><six-toolbar-button label=\"Stampa PDF\" btn-class=\"btn-default\" icon=\"fa fa-print\" toolbar-function=\"openDialogReport(\'pdf\')\"></six-toolbar-button><six-toolbar-button label=\"Stampa Excel\" btn-class=\"btn-default\" icon=\"fa fa-file-excel-o\" toolbar-function=\"openDialogReport(\'xlsx\')\"></six-toolbar-button></six-toolbar><six-sidebar sx-id=\"vectors_sidebar\" sx-position=\"left\" sx-title=\"\'Vettori\'\" sx-dimension=\"s\" sx-opened=\"sidebar\"><ul id=\"list-sidebar-ul\" class=\"nav list-sidebar-nav\"><li class=\"m-l-xs m-r-xs\"><a ng-click=\"goToAnchor(\'top\')\">Top</a></li><li ng-repeat=\"vector in vectors\" class=\"m-l-xs m-r-xs\"><a ng-click=\"goToAnchor(vector.model.code+\'_details\')\" six-sidebar-autoclose=\"true\">{{vector.model.description}}</a></li></ul></six-sidebar><div id=\"top\" class=\"constructor\"><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">ANALISI CONSUMI MULTICOMMESSA</h1></div></div></div><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"col-md-4\"><label class=\"control-label\">Commessa</label><six-select-2 sx-id=\"commission_list\" sx-list=\"commissionList\" sx-title=\"\'Commessa\'\" ng-model=\"commissions\" sx-field=\"\'selected\'\" sx-placeholder=\"\'commessa...\'\" sx-multiple=\"true\" sx-show-key=\"false\"></six-select-2></div><div class=\"col-md-2\"><label class=\"control-label\">Vettore energetico</label><six-lookup-2 sx-id=\"vetten\" ng-model=\"vector\" sx-type=\"\'vettoreenergetico\'\" sx-field=\"\'id\'\" sx-object=\"currentVector\"></six-lookup-2></div><div class=\"col-md-2\"><label id=\"type_label\" class=\"control-label\">Tipo</label><six-lookup-2 sx-id=\"type\" sx-base-path=\"\'schema\'\" ng-model=\"type\" sx-title=\"\'Tipo\'\" sx-field=\"\'type_id\'\" sx-filter=\"contatoreTypeFilter\"></six-lookup-2></div><div class=\"col-md-2\"><label class=\"control-label\">Da data:</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"datePicker.from\" is-open=\"statusFrom.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openFrom($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\"><label class=\"control-label\">A data:</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"datePicker.to\" is-open=\"statusTo.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openTo($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div></div></div></div>");
$templateCache.put("energy/consumptive/consumptive.html","<style type=\"text/css\">\n  .summaryTable {\n    width:100%;\n    border: 1px solid lightblue;\n  }\n  .summaryTable th {\n    text-align: center;\n  }\n  .summaryTable td {\n    width: 20%;\n    padding: 3px;\n    border: 1px solid lightgrey;\n    text-align: center;\n  }\n  .summaryTable td:first-child {\n    text-align: left;\n    background-color: #fafbfc;\n    font-weight: 800;\n  }\n  .resetRead {\n    background-color: rgba(81, 253, 0, 0.24) !important;\n    color: #58666e !important;\n  }\n  .warningRead {\n    background-color: rgb(239, 253, 80) !important;\n    color: #58666e !important;\n  }\n  .errorRead {\n    background-color: rgb(253, 90, 78) !important;\n    color: white !important;\n  }\n  .automaticRead {\n    background-color: rgb(218, 234, 255) !important;\n    color: #58666e !important;\n  }\n  .custom-sidebar {\n    top: 50px;\n    z-index: 1031;\n    padding-bottom: 70px;\n  }\n  .floating-button {\n    position: fixed;\n    opacity: 0.5;\n    overflow: hidden;\n    text-align: center;\n    z-index: 99999999;\n    background-color: #1199C4;\n    color: #eeeeee;\n    width: 25px;\n    height: 25px;\n    padding-top: 2px;\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n    -webkit-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);\n    -o-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);\n    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);\n    cursor: pointer;\n    /*-webkit-transition: all 0.5s ease-in-out;*/\n    /*-moz-transition: all 0.5s ease-in-out;*/\n    /*-ms-transition: all 0.5s ease-in-out;*/\n    /*-o-transition: all 0.5s ease-in-out;*/\n    /*transition: all 0.5s ease-in-out;*/\n  }\n\n  .padded {\n    margin-left: 280px;\n  }\n\n  .selected {\n    background-color: #11c7f5 !important;\n  }\n</style><script type=\"text/ng-template\" id=\"summary-view.html\"><table class=\"summaryTable\"> <tr> <th>Fascia</th> <th>Consumo</th> <th>€</th> <th>Giorni</th> <th>Cons. giorn. medio</th> </tr> <tr ng-repeat=\"(key, slot) in totalPeriodConsumptions\"> <td ng-if=\"key !== \'totale\'\">{{key}}</td> <td ng-if=\"key === \'totale\'\">Tot.</td> <td>{{slot | number: 3}}</td> <td> <span ng-if=\"totalEvaluatedPeriodConsumptions[key]\">{{totalEvaluatedPeriodConsumptions[key] | number: 2}}</span> <span ng-if=\"!totalEvaluatedPeriodConsumptions[key]\">-</span> </td> <td>{{totalPeriodDays}}</td> <td>{{slot/totalPeriodDays | number: 3}}</td> </tr> </table></script><script type=\"text/ng-template\" id=\"month-view.html\"><table style=\"width:100%\" class=\"m-t-xs m-b-xs\"> <thead> <tr> <th>Fascia</th> <th ng-repeat=\"day in getTimes(daysInMonth(selectedMonthDetail.year, selectedMonthDetail.month))\" class=\"dayCl\"> <div class=\"dayHeader\">{{day+1}}</div> </th> </tr> </thead> <tbody> <tr ng-repeat=\"(idx, consElem) in (dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][0]).slotted\"> <td>{{(dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][0]).slotted[idx].time_slot}}</td> <td ng-repeat=\"day in getTimes(daysInMonth(selectedMonthDetail.year, selectedMonthDetail.month))\" class=\"dayCl\" ng-class=\"{\'budget\': (dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).type === TYPE_BDG}\"> <span tooltip data-placement=\"top\" title=\"{{((dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).type === TYPE_BDG)?\'Da budget\':\'Da consuntivo\'}} ({{(dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).slotted[idx].consumption | number: 1}})\" ng-if=\"(dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).type !== undefined\"> {{(dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).slotted[idx].consumption | number: 0}} </span> <span tooltip data-placement=\"top\" title=\"No data\" ng-if=\"(dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).type === undefined\"> - </span> </td> </tr> <tr> <td>Totale</td> <td ng-repeat=\"day in getTimes(daysInMonth(selectedMonthDetail.year, selectedMonthDetail.month))\" class=\"dayCl\" ng-class=\"{\'budget\': (dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).type === TYPE_BDG}\"> <span tooltip data-placement=\"top\" title=\"{{((dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).type === TYPE_BDG)?\'Da budget\':\'Da consuntivo\'}} ({{(dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).total | number: 1}})\" ng-if=\"(dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).type !== undefined\"> {{(dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).total | number: 0}} </span> <span tooltip data-placement=\"top\" title=\"No data\" ng-if=\"(dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).type === undefined\"> - </span> </td> </tr> </tbody> </table></script><six-toolbar><six-toolbar-button btn-class=\"btn-default\" toolbar-function=\"goToUpdateRegistrationNumber()\" label=\"Sost. cont.\" icon=\"fa fa-upload\" sx-disabled=\"isWritePermAllowed()===false || isClosed() || !contatoreType.tipo_id || !contatore.contatore_id\"></six-toolbar-button><six-toolbar-button btn-class=\"btn-default\" toolbar-function=\"goToClosure()\" label=\"Chiudi cont.\" icon=\"fa fa-ban\" sx-disabled=\"isWritePermAllowed()===false || isClosed() || !contatoreType.tipo_id || !contatore.contatore_id\"></six-toolbar-button></six-toolbar><six-sidebar sx-id=\"list-sidebar\" sx-position=\"left\" sx-dimension=\"m\" sx-opened=\"isSidebarOpened\" sx-pinned=\"isPinned\"><div class=\"m-xs\"><six-lookup-2 ng-model=\"contatoreType\" sx-base-path=\"\'schema\'\" sx-field=\"\'tipo_id\'\" sx-filter=\"contatoreTypeFilter\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\" sx-placeholder=\"\'Tipo...\'\"></six-lookup-2></div><ul class=\"nav list-sidebar-nav\"><li ng-if=\"!recordList || recordList.length == 0\"><a><span ng-if=\"contatoreType && contatoreType.tipo_id && contatoreType.tipo_id.description\">Nessun {{contatoreType.tipo_id.description}} caricato</span> <span ng-if=\"!contatoreType || !contatoreType.tipo_id || !contatoreType.tipo_id.description\">Selezionare un tipo di contatore</span></a></li><span ng-if=\"recordList && recordList.length > 0\"><li><div class=\"form-group m-l-xs m-r-xs\"><six-search-form ng-model=\"recordSearchText.text\" placeholder=\"Filtra...\" hide-search-btn=\"\"></six-search-form></div></li><li ng-repeat=\"record in recordList | filter:recordSearchText.text\"><a ng-click=\"selectRecord(record.UUID, record.model.code, record.model.description)\" title=\"{{record.model.code}} - {{record.model.description}}\" ng-class=\"{\'selected\': isRecordSelected(record.UUID)}\">{{record.model.code}} - {{record.model.description}}</a></li></span></ul></six-sidebar><div class=\"list-sidebar-toggle floating-button\" ng-click=\"toggleSidebar()\" ng-class=\"{\'padded\': isSidebarOpened==true}\"><i ng-class=\"{\'fa fa-times\': isSidebarOpened==true, \'fa fa-bars\': isSidebarOpened==false}\"></i></div><div class=\"constructor\"><div class=\"wrapper override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-12 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">CONSUNTIVO</h1><h4 ng-if=\"contatoreType.tipo_id.description && contatore.contatore_id.code && contatore.contatore_id.description\">{{contatoreType.tipo_id.description}} - {{contatore.contatore_id.code}} - {{contatore.contatore_id.description}} <span ng-if=\"contatore.obj.model.stato\">- <span class=\"text-u-c\" ng-class=\"{\'text-danger\': contatore.obj.model.stato===\'chiuso\', \'text-success\': contatore.obj.model.stato===\'aperto\'}\">{{contatore.obj.model.stato}}</span></span></h4></div></div></div><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"row wrapper\" ng-if=\"isSidebarOpened==false\"><div class=\"col-md-3\">Tipo<six-lookup sx-id=\"type\" ng-model=\"contatoreType\" sx-base-path=\"\'schema\'\" sx-field=\"\'tipo_id\'\" sx-filter=\"contatoreTypeFilter\"></six-lookup></div><div class=\"col-md-3\">Contatore<six-lookup sx-id=\"contatore\" ng-model=\"contatore\" sx-type=\"contatoreType.tipo_id.UUID\" sx-field=\"\'contatore_id\'\" sx-object=\"contatore.obj\"></six-lookup></div></div><div class=\"col-md-2\">Da anno:<six-year-picker ng-model=\"fromYearPicker.year\" sx-plus-minus=\"20\"></six-year-picker></div><div class=\"col-md-2\">A anno:<six-year-picker ng-model=\"toYearPicker.year\" sx-plus-minus=\"20\"></six-year-picker></div><div class=\"col-md-3\">Budget<div id=\"search_budget_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"budget.searchCode\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Cerca...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableBudgetCodes\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-3\">Listino<six-lookup id=\"listino\" ng-model=\"priceList\" sx-base-path=\"\'pricelist\'\" sx-type=\"\'header\'\" sx-field=\"\'id\'\"></six-lookup></div></div><hr><uib-tabset><uib-tab><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Letture</uib-tab-heading><div class=\"col-md-12 m-t\" ng-if=\"!getTemplateUrl()\"><div class=\"row\">Selezionare un tipo di contatore</div></div><div class=\"col-md-12 m-t-sm\" ng-if=\"getTemplateUrl()\"><div class=\"row\"><div class=\"formGroup pull-left\"><a ng-href=\"{{getTemplateUrl()}}\" class=\"btn btn-default btn-sm\" ng-if=\"getTemplateUrl() && isWritePermAllowed()===true && !isClosed()\"><i class=\"fa fa-file-excel-o\"></i> Template</a></div><div class=\"formGroup col-md-3 col-md-offset-3\">Modalità <span ng-if=\"importingOperation\" class=\"text-info font-bold\">IMPORTAZIONE</span><span ng-if=\"!importingOperation\" class=\"text-info font-bold\">MODIFICA</span></div><div class=\"formGroup pull-right\"><button ng-click=\"loadReads()\" class=\"btn btn-default btn-sm\" ng-disabled=\"!contatore.contatore_id || importingOperation\"><span class=\"fa fa-refresh\"></span> Aggiorna</button> <button ng-click=\"addRead()\" class=\"btn btn-default btn-sm\" ng-disabled=\"!contatore.contatore_id || importingOperation || isWritePermAllowed() === false || isClosed()\"><span class=\"fa fa-plus\"></span> Aggiungi</button> <button ng-click=\"removeReads(gridApi.selection.getSelectedRows())\" class=\"btn btn-default btn-sm\" ng-disabled=\"!contatore.contatore_id || isDeletePermAllowed() === false\"><span class=\"fa fa-times\"></span> Rimuovi</button></div></div><div class=\"row m-t-sm\"><div class=\"col-md-6\"><span class=\"badge automaticRead\">Lett. prevista</span> <span class=\"badge resetRead\">Lett. di reset</span> <span class=\"badge warningRead\">Lett. con problemi</span> <span class=\"badge errorRead\">Lett. in errore</span></div></div><div class=\"row m-t-sm\"><div id=\"grid1\" ui-grid=\"viewGridOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-auto-resize=\"\" ui-grid-exporter=\"\" ui-grid-edit=\"\" ui-grid-row-edit=\"\" ui-grid-cellnav=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"><div class=\"grid-msg-overlay\" ng-show=\"!viewGridOptions.data.length && isWritePermAllowed()===true && !isClosed()\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"viewGridOptions\" multiple=\"false\"></div></div></div></div><div class=\"wrapper m-t\" ng-if=\"viewGridOptions.data.length\"><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">{{percent|number: 0}}%</span> <span class=\"hidden-folded ng-scope\">Salvataggio</span></div><div class=\"progress-s m-t-sm dk progress ng-isolate-scope\" value=\"{{percent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{percent|number: 0}}%;\"></div></div></div></div><div class=\"row\" ng-if=\"viewGridOptions.data.length && importingOperation\"><div class=\"formGroup pull-right\"><button ng-click=\"importData()\" class=\"btn btn-sm btn-success\" ng-disabled=\"isImportBusy === true || isAllOk === false || isWritePermAllowed() === false || isClosed()\">Importa</button> <button ng-click=\"resetGrid()\" class=\"btn btn-sm btn-default\">Reset</button></div></div></div></uib-tab><uib-tab><uib-tab-heading><span class=\"fa fa-cog text-success-dker\"></span> Consumi</uib-tab-heading><div class=\"col-md-12 m-t pull-right\"><div class=\"row\"><button type=\"button\" class=\"btn btn-default btn-sm m-r\" ng-confirm-message=\"Calcolare i consumi per tutta la commessa?\" ng-confirm-click=\"calcAllConsumptions(false)\" ng-confirm-condition=\"true\" title=\"Calcola tutti i consumi della commessa\" ng-disabled=\"!contatoreType.tipo_id || contatoreType.tipo_id.code === \'contatoreelettricita\' || isWritePermAllowed() === false || isClosed()\"><i class=\"fa fa-gears\"></i> Calc. commessa</button> <button type=\"button\" class=\"btn btn-default btn-sm m-r\" ng-confirm-message=\"Calcolare i consumi per TUTTE le commesse?\" ng-confirm-click=\"calcAllConsumptions(true)\" ng-confirm-condition=\"true\" title=\"Calcola tutti i consumi per tutte le commesse\" ng-disabled=\"!contatoreType.tipo_id || contatoreType.tipo_id.code === \'contatoreelettricita\' || isWritePermAllowed() === false || isClosed()\"><i class=\"fa fa-gears\"></i> Calc. tutte le commesse</button><div class=\"formGroup pull-right\"><button type=\"button\" ng-if=\"contatoreType.tipo_id.UUID === \'contatoreelettricita\'\" class=\"btn btn-default btn-sm m-r\" ng-click=\"goToImportConsumptions()\" ng-disabled=\"isWritePermAllowed() === false || isClosed()\"><i class=\"fa fa-upload\"></i> Importa</button> <button ng-click=\"deleteConsumptionsWithDialog()\" class=\"btn btn-danger btn-sm\" ng-disabled=\"!contatore.contatore_id || isDeletePermAllowed() === false\"><span class=\"fa fa-trash\"></span> Cancella</button></div></div></div><div class=\"col-md-12 m-t\" ng-if=\"!monthlyConsumptions.length\"><div class=\"row\">Nessun dato da mostrare</div></div><div class=\"col-md-12 m-t\" ng-if=\"monthlyConsumptions.length\"><div class=\"row\"><div ng-include=\"\'summary-view.html\'\" class=\"col-md-4\"></div><div class=\"col-md-2\"><label for=\"um\" class=\"control-label font-bold\">U.M.&nbsp;</label><six-lookup id=\"um\" ng-model=\"um\" sx-type=\"\'um\'\" sx-field=\"\'um\'\"></six-lookup></div><div class=\"formGroup pull-right m-r\"><div class=\"row m-t\"><button ng-click=\"loadConsumptions()\" class=\"btn btn-default btn-sm\" ng-disabled=\"!contatore.contatore_id\"><span class=\"fa fa-refresh\"></span> Aggiorna</button> <button ng-click=\"recalcConsumptions()\" class=\"btn btn-default btn-sm\" ng-disabled=\"!contatore.contatore_id || isWritePermAllowed() === false\"><span class=\"fa fa-gear\"></span> Ricalcola</button></div></div></div><div class=\"row m-t\"><table style=\"width:100%\" class=\"table-striped\"><thead><tr style=\"border-bottom: 1px solid lightblue\"><th>Anno</th><th ng-repeat=\"m in getTimes(12) track by $index\" class=\"monthCl\"><div class=\"dayHeader\"><span ng-class=\"{\'badge bg-info\': m===selectedMonthDetail.month}\">{{getMonthName($index)}}</span></div></th></tr></thead><tbody><tr ng-repeat-start=\"year in getYears(fromYearPicker.year, toYearPicker.year)\"><td><span ng-class=\"{\'badge bg-info\': year===selectedMonthDetail.year}\">{{year}}</span></td><td ng-repeat=\"m in getTimes(12) track by $index\" class=\"monthCl\"><a href=\"\" ng-click=\"toggleSelectMonth(year, m)\" ng-class=\"{\'disabled\': (monthlyConsumptions[year][m]).total === 0}\"><div><span class=\"badge\" ng-class=\"{\'consumption\': true, \'budget\': (monthlyConsumptions[year][m]).type === TYPE_BDG, \'partialMonth\': (monthlyConsumptions[year][m]).type === TYPE_MIXED, \'negativeConsumption\':(monthlyConsumptions[year][m]).total < 0}\" tooltip=\"\" data-placement=\"top\" title=\"{{getTooltip(monthlyConsumptions[year][m])}}\" ng-if=\"(monthlyConsumptions[year][m]).type !== undefined\">{{(monthlyConsumptions[year][m]).total | number: 1}}</span></div><div><span class=\"badge\" tooltip=\"\" data-placement=\"top\" title=\"No data\" ng-if=\"(monthlyConsumptions[year][m]).type === undefined\">-</span></div><div><span class=\"badge money\" tooltip=\"\" data-placement=\"top\" title=\"€\" ng-if=\"monthlyEvaluatedConsumptions[year][m] !== 0\">{{monthlyEvaluatedConsumptions[year][m] | number: 2}} €</span></div></a><div><span class=\"fa fa-chevron-up text-info\" ng-if=\"year===selectedMonthDetail.year && m===selectedMonthDetail.month\"></span></div></td></tr><tr ng-repeat=\"m in getTimes(12) track by $index\" ng-repeat-end=\"\" ng-if=\"year===selectedMonthDetail.year && m===selectedMonthDetail.month\"><td></td><td colspan=\"12\"><div ng-include=\"\'month-view.html\'\" class=\"month-detail\"></div></td></tr></tbody></table></div></div></uib-tab><uib-tab><uib-tab-heading><span class=\"fa fa-line-chart text-primary-dker\"></span> Grafici</uib-tab-heading><div class=\"col-md-12 m-t\" ng-if=\"!graph.graphData.length\"><div class=\"row\">Nessun grafico da mostrare</div></div><div class=\"col-md-12 m-t\" ng-if=\"monthlyConsumptions.length\"><div class=\"row\"><div ng-include=\"\'summary-view.html\'\" class=\"col-md-4\"></div></div><div class=\"row m-t-lg\"><six-multi-series-line-chart sx-graph-data=\"graph.graphData\" sx-id=\"consumptionsGraph\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"Consumi puntuali\" sx-interpolate=\"\'basis\'\"></six-multi-series-line-chart></div><div class=\"row m-t-lg\"><six-multi-series-line-chart sx-graph-data=\"graph.graphDataCum\" sx-id=\"consumptionsGraphCum\" sx-y-axis-legend=\"\'Consumi (cum)\'\" sx-graph-title=\"Consumi cumulati\" sx-interpolate=\"\'basis\'\"></six-multi-series-line-chart></div></div></uib-tab></uib-tabset></div><div class=\"panel-body\"><div id=\"messages\" class=\"row m-t\" ng-if=\"reportMessages.length\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-heading\"><h4 class=\"panel-title\">Messaggi</h4></div><div class=\"panel-body\"><div class=\"col-md-12\"><div id=\"gridReport\" ui-grid=\"reportGridOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("energy/consumptive/expandableRowTemplate.html","<div ui-grid=\"row.entity.model.subGridOptions\" ui-grid-edit=\"\" ui-grid-row-edit=\"\" ui-grid-cellnav=\"\" ui-grid-resize-columns=\"\" style=\"height:180px;\"></div>");
$templateCache.put("energy/consumptive/import.html","<div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">CONSUNTIVO</h1><small class=\"text-muted\">Importazione consumi</small></div><div class=\"col-sm-6 text-right hidden-xs\"><div class=\"inline m-r text-left\"><button back=\"\" type=\"button\" class=\"btn btn-default btn-sm pull-right\"><i class=\"icon-arrow-left\"></i> Back</button></div></div></div></div><div class=\"panel wrapper\"><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"formGroup pull-left\"><a href=\"/energy/attachments/template_elettrico_consumi.xls\" class=\"btn btn-default btn-sm\">Template <i class=\"fa fa-file-excel-o pull-right\"></i></a></div></div><div class=\"row wrapper\"><div id=\"grid1\" ui-grid=\"viewGridOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-cellnav=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"><div class=\"grid-msg-overlay\" ng-show=\"!viewGridOptions.data.length\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"viewGridOptions\" multiple=\"false\"></div></div></div></div><div class=\"wrapper m-t\" ng-if=\"viewGridOptions.data.length\"><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">{{percent|number: 0}}%</span> <span class=\"hidden-folded ng-scope\">Salvataggio</span></div><div class=\"progress-s m-t-sm dk progress ng-isolate-scope\" value=\"{{percent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{percent|number: 0}}%;\"></div></div></div></div><div class=\"row\" ng-if=\"viewGridOptions.data.length && importingOperation\"><div class=\"formGroup pull-right\"><button ng-click=\"importData()\" class=\"btn btn-sm btn-success\" ng-disabled=\"isImportBusy === true || isAllOk === false\">Importa</button> <button ng-click=\"resetGrid()\" class=\"btn btn-sm btn-default\">Reset</button></div></div></div><div class=\"panel-body\"><div id=\"messages\" class=\"row m-t\" ng-if=\"reportMessages.length\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-heading\"><h4 class=\"panel-title\">Messaggi</h4></div><div class=\"panel-body\"><div class=\"col-md-12\"><div id=\"gridReport\" ui-grid=\"reportGridOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div></div></div></div></div></div></div>");
$templateCache.put("energy/consumptive/importTemplate.html","<input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"viewGridOptions\" multiple=\"false\">");
$templateCache.put("energy/consumptive/import_multicommission.html","<style type=\"text/css\">\n  .errorRead {\n    background-color: rgb(253, 90, 78) !important;\n    color: white !important;\n  }\n</style><six-toolbar><six-toolbar-item ng-show=\"getTemplateUrl()\" label=\"Template\" icon=\"fa fa-download icon text-info-dker\" toolbar-function=\"downloadTemplate()\"></six-toolbar-item><six-toolbar-button label=\"Reset\" icon=\"fa fa-undo\" ng-if=\"viewGridOptions.data.length && importingOperation\" toolbar-function=\"resetGrid()\"></six-toolbar-button><six-toolbar-button label=\"Importa\" icon=\"fa fa-upload\" ng-if=\"viewGridOptions.data.length && importingOperation\" toolbar-function=\"importData()\" btn-class=\"btn-success\" sx-disabled=\"isImportBusy === true || isAllOk === false\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">CONSUNTIVO</h1></div></div></div><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"col-md-3\">Tipo<six-lookup id=\"tipo\" sx-base-path=\"\'schema\'\" ng-model=\"contatoreType\" sx-field=\"\'tipo_id\'\" sx-filter=\"contatoreTypeFilter\"></six-lookup></div></div><div class=\"row wrapper\"><div class=\"col-md-12 m-t\" ng-if=\"!getTemplateUrl()\"><div class=\"alert alert-info\" role=\"alert\">Selezionare un tipo di contatore.</div></div><div class=\"col-md-12 m-t-sm\" ng-if=\"getTemplateUrl()\"><div class=\"row hidden\"><div class=\"formGroup pull-left\"><a ng-href=\"{{getTemplateUrl()}}\" id=\"linkToTemplate\" class=\"btn btn-default btn-sm\" ng-if=\"getTemplateUrl()\">Template <i class=\"fa fa-file-excel-o pull-right\"></i></a></div></div><div class=\"row m-t-sm\"><div id=\"grid1\" ui-grid=\"viewGridOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-exporter=\"\" ui-grid-edit=\"\" ui-grid-row-edit=\"\" ui-grid-cellnav=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"><div class=\"grid-msg-overlay\" ng-show=\"!viewGridOptions.data.length\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"viewGridOptions\" multiple=\"false\"></div></div></div></div><div class=\"wrapper m-t\" ng-if=\"viewGridOptions.data.length\"><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">{{percent|number: 0}}%</span> <span class=\"hidden-folded ng-scope\">Salvataggio</span></div><div class=\"progress-s m-t-sm dk progress ng-isolate-scope\" value=\"{{percent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{percent|number: 0}}%;\"></div></div></div></div></div></div></div><div class=\"panel-body\"><div id=\"messages\" class=\"row m-t\" ng-if=\"reportMessages.length\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-heading\"><h4 class=\"panel-title\">Messaggi</h4></div><div class=\"panel-body\"><div class=\"col-md-12\"><div id=\"gridReport\" ui-grid=\"reportGridOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("energy/daydegrees/daydegree.html","<style type=\"text/css\">\n  #year-select{\n    height: 29px;\n    margin-right: -4px;\n    margin-left: -5px;\n  }\n\n  .dayClHead {\n    width: 3%;\n    text-align: center;\n  }\n  .dayCl {\n    text-align: right;\n    padding: 1px;\n  }\n  .dayCl input {\n    text-align: end;\n    color: black;\n    margin-left: 1px;\n    width: 98%;\n  }\n  input[type=number]::-webkit-inner-spin-button,\n  input[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  .dayClEmpty{\n    text-align: right;\n    color:lightgray;\n  }\n  .rCl{\n    text-align: right;\n    padding-left: 3px;\n    padding-right: 3px;\n  }\n  .dayHeader{\n    -webkit-transform: rotate(300deg);\n    -moz-transform: rotate(300deg);\n    -o-transform: rotate(300deg);\n    writing-mode: lr-tb;\n  }\n  .currMonthRow{\n    background-color: #bdf1c3 !important;\n  }\n  .seasonEnd{\n    border-bottom: 1px solid lightcoral;\n    border-right: 1px solid lightcoral;\n    /*box-shadow: 3px 2px 1px lightcoral;*/\n  }\n  .seasonStart{\n    border-top: 1px solid lightcoral;\n    border-left: 1px solid lightcoral;\n    /*box-shadow: -3px 2px 1px lightcoral;*/\n  }\n  .locDetailsTable{\n    width:100%;\n    border: 1px solid lightblue;\n  }\n  .locDetailsTable td{\n    padding: 3px;\n    border: 1px solid lightgrey;\n  }\n  .locDetailsTable th{\n    background-color: #DDE6E9;\n    padding: 3px;\n    border: 1px solid lightgrey;\n  }\n  .transTable td{\n    border: none\n  }\n  .dd-table tr{\n    border-top: 1px solid #e4edf8;\n  }\n  .inSeas{\n    /*background-color: #e4edf8;*/\n  }\n  .outSeas{\n    background-color: #f7f3f8;\n  }\n\n  #tipogg_label{\n    line-height: 37px;\n  }\n\n  #localita_label  {\n    float: left;\n    line-height: 35px;\n    margin-right: 15px;\n  }\n</style><six-toolbar><six-toolbar-button label=\"Importa\" icon=\"fa fa-upload\" toolbar-function=\"goToImportDD()\" btn-class=\"btn-success\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Stampa PDF\" icon=\"fa fa-print\" toolbar-function=\"printReport(\'pdf\')\" btn-class=\"btn-default\"></six-toolbar-button><six-toolbar-button label=\"Stampa Excel\" icon=\"fa fa-file-excel-o\" toolbar-function=\"printReport(\'xls\')\" btn-class=\"btn-default\"></six-toolbar-button><six-toolbar-button label=\"Aggiorna\" icon=\"fa fa-refresh\" toolbar-function=\"loadDD()\" btn-class=\"btn-info\"></six-toolbar-button><six-toolbar-button label=\"Cancella\" icon=\"fa fa-trash\" toolbar-function=\"delete()\" ng-if=\"zonatermica.model\" btn-class=\"btn-danger\" sx-disabled=\"isDeletePermAllowed()===false\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">GRADI GIORNO</h1></div></div></div><div class=\"panel-body\"><div class=\"col-md-6\"><div class=\"panel panel-default\" id=\"lookupLoc\"><div class=\"panel-heading\"><h5 class=\"panel-title\"><label id=\"localita_label\" for=\"zonatermica\" class=\"control-label\">Zona Termica</label><div style=\"width:300px !important; display:inline-block\"><six-lookup id=\"zonatermica\" ng-model=\"zonatermica\" sx-type=\"\'zonatermica\'\" sx-field=\"\'zonatermica_id\'\"></six-lookup></div></h5></div></div></div><div class=\"col-md-6\"><div class=\"panel panel-default\" id=\"commands1\"><div class=\"panel-heading\"><h5 class=\"panel-title\" id=\"tipogg_label\"><div class=\"row\"><div class=\"col col-md-6\">Tipo GG:&nbsp; <span ng-if=\"type==\'real\'\">Consuntivo anno</span> <span ng-if=\"type==\'hist\'\">Storico</span></div><div class=\"col col-md-6\" ng-if=\"type == \'real\'\"><button ng-click=\"previousYear()\" ng-disabled=\"bool.selectPeriod\" class=\"btn btn-default btn-sm\"><i class=\"fa fa-angle-left pull-left\"></i></button><select class=\"btn btn-default btn-sm\" id=\"year-select\" ng-model=\"selected.year\" convert-to-number=\"\"><option ng-repeat=\"y in getYears()\" value=\"{{y}}\" ng-selected=\"selected.year == y\">{{y}}</option></select><button ng-click=\"nextYear()\" ng-disabled=\"bool.selectPeriod\" class=\"btn btn-default btn-sm\"><i class=\"fa fa-angle-right pull-left\"></i></button></div></div></h5><div ng-if=\"type==\'real\'\"><div class=\"row\"><div class=\"col col-md-12\"><input type=\"checkbox\" ng-model=\"bool.selectPeriod\" class=\"wrapper-md\" ng-init=\"false\" ng-click=\"clearDates()\"> Visualizzazione periodo</div></div><div class=\"row wrapper-md\" ng-if=\"bool.selectPeriod\"><div class=\"col col-md-12\"><div class=\"col-md-5\"><label>Da</label> <input class=\"btn btn-default btn-sm\" type=\"date\" ng-model=\"period.dateFrom\"></div><div class=\"col-md-5\"><label>A</label> <input class=\"btn btn-default btn-sm\" type=\"date\" ng-model=\"period.dateTo\"></div><div class=\"col-md-2\"><button class=\"btn btn-info btn-sm\" ng-click=\"loadDD()\"><i class=\"fa fa-refresh\"></i> Aggiorna</button></div></div></div></div></div></div></div><div id=\"locDetail\" class=\"col-md-12\" ng-show=\"zonatermica.zonatermica_id != undefined\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><a data-toggle=\"collapse\" data-target=\"#collapseOne\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i> Dettagli Zona Termica {{detailPanel}}</h4></div></a><div id=\"collapseOne\" class=\"collapse\"><div class=\"panel-body\"><div class=\"col-md-8\"><table class=\"locDetailsTable\"><thead><tr><td></td><th>Zona T. corrente</th><th>Zona T. di riferimento</th></tr><tr><th>Nome</th><td>{{zonatermica.model.description}} (comune: {{comune.model.description}})</td><td>{{refZonaTermica.model.description}}</td></tr></thead><tr><th>Temperature<br>medie<br></th><td><div ng-repeat=\"t in zonatermica.model.temp_giorn_medie\">{{t.month}}: {{t.temp}}</div></td><td><div ng-repeat=\"t in refZonaTermica.model.temp_giorn_medie\">{{t.month}}: {{t.temp}}</div></td></tr><tr><th>Altitudine</th><td ng-if=\"zonatermica.model.altitude\">{{zonatermica.model.altitude}} m</td><td ng-if=\"!zonatermica.model.altitude\"><span ng-if=\"comune.model.altitude\">{{comune.model.altitude}} m (comune)</span></td><td><span ng-if=\"refZonaTermica.model.altitude\">{{refZonaTermica.model.altitude}} m</span></td></tr><tr><th>GG DPR</th><td ng-if=\"zonatermica.model.gg_stag_termica\">{{zonatermica.model.gg_stag_termica}}</td><td ng-if=\"!zonatermica.model.gg_stag_termica\"><span ng-if=\"comune.model.gg_stag_termica\">{{comune.model.gg_stag_termica}} (comune)</span></td><td>{{refZonaTermica.model.gg_stag_termica}}</td></tr><tr><th>Coefficiente C</th><td ng-if=\"zonatermica.model.c_coeff\">{{zonatermica.model.c_coeff}}</td><td ng-if=\"!zonatermica.model.c_coeff\"><span ng-if=\"comune.model.c_coeff\">{{comune.model.c_coeff}} (comune)</span></td><td>{{refZonaTermica.model.c_coeff}}</td></tr><tr><th>Gradiente termico</th><td ng-if=\"zonatermica.model.gradiente_vert_temp\">{{zonatermica.model.gradiente_vert_temp}}</td><td ng-if=\"!zonatermica.model.gradiente_vert_temp\"><span ng-if=\"provincia.model.gradiente_vert_temp\">{{provincia.model.gradiente_vert_temp}} (provincia)</span></td><td>{{refZonaTermica.model.gradiente_vert_temp}}</td></tr><tr><th>Zona climatica</th><td><span ng-if=\"comune.model.zona_climatica_id\">{{comune.model.zona_climatica_id.code}} (comune)</span></td><td>{{refZonaTermica.model.zona_climatica_id.code}}</td></tr></table><div style=\"font-size: xx-small\" ng-if=\"false\"><hr>{{zonatermica.model}}<hr>{{comune.model}}<hr>{{provincia.model}}</div></div><div class=\"col-md-4\"><div class=\"panel panel-default\" id=\"commands2\"><div class=\"panel-heading\"><h5 class=\"panel-title\"><i class=\"pull-right fa ng-scope fa-gears\"></i> Calcolo Gradi giorno</h5></div><div class=\"panel-body\"><span ng-if=\"refZonaTermica.model && zonatermica.model && type == \'real\'\"><button ng-click=\"calculateFromRef()\" class=\"btn btn-info {{refZonaTermica.model.code == zonatermica.model.code?\'disabled\':\'\'}}\" ng-disabled=\"isWritePermAllowed()===false || bool.selectPeriod===true\" style=\"width:100%\">Da Zona Termica di riferimento</button><br><br></span> <span ng-if=\"!refZonaTermica.model && zonatermica.model && type == \'real\'\">{{zonatermica.model.description}} non ha una Zona Termica di riferimento</span><div ng-if=\"zonatermica.model && referring.length>0 && type == \'real\'\"><div class=\"btn-group\" uib-dropdown=\"\" style=\"width:100%\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"calculateReferring()\" ng-disabled=\"isWritePermAllowed()===false || bool.selectPeriod===true\" style=\"width:85%\">Per Zone Termiche referenti &nbsp;</button> <button type=\"button\" class=\"btn btn-info dropdown-toggle\" uib-dropdown-toggle=\"\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"width:15%\"><b class=\"badge bg-info pull-right\">{{referring.length}}</b> <span class=\"caret\"></span> <span class=\"sr-only\">--</span></button><ul class=\"dropdown-menu\" role=\"menu\" uib-dropdown-toggle=\"\"><li><a href=\"\">Zone Termiche che fanno riferimento a {{zonatermica.model.description}}:</a></li><li class=\"divider\"></li><li ng-repeat=\"item in referring\"><a href=\"\" style=\"{{(item.model.code == zonatermica.model.code)?\'color:gray\':\'\'}}\">{{item.model.description}} <span style=\"font-size: xx-small; color:gray\">({{item.model.code}})</span></a></li></ul></div><br><br></div><div ng-if=\"zonatermica.model && type == \'real\'\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"calculateAllReferring()\" ng-disabled=\"isWritePermAllowed()===false || bool.selectPeriod===true\" style=\"margin-top: 10px; width:100%\">Per TUTTE le Zone Termiche &nbsp;</button></div><div ng-if=\"type == \'hist\'\"><button type=\"button\" class=\"btn btn-info\" ng-if=\"type == \'hist\'\" ng-click=\"tempToDD(true)\" ng-disabled=\"isWritePermAllowed()===false || bool.selectPeriod===true\" style=\"width:100%\">Da temp. normalizzato DPR</button> <label ng-if=\"false\" class=\"btn btn-sm btn-default ng-untouched ng-valid ng-dirty ng-valid-parse\" ng-model=\"normalized\" uib-btn-checkbox=\"\" aria-invalid=\"false\" style=\"width:29%\">Normalizza</label> <button type=\"button\" class=\"btn btn-default\" ng-if=\"type == \'hist\'\" ng-click=\"tempToDDAll()\" ng-disabled=\"isWritePermAllowed()===false || bool.selectPeriod===true\" style=\"margin-top: 10px; width:100%\">Ricalcola per TUTTE le ZT</button></div></div></div></div></div></div></div></div></div><uib-tabset ng-show=\"zonatermica.zonatermica_id != undefined\"><uib-tab><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Dati</uib-tab-heading><div id=\"ddTable\" class=\"col-md-12\"><div><form name=\"myForm\"><table style=\"width:100%\" class=\"dd-table\"><thead><tr style=\"border-bottom: 1px solid lightblue\"><th>Mese</th><th ng-repeat=\"d in getTimes(31) track by $index\" class=\"dayClHead\" ng-if=\"showDay($index)\"><div class=\"dayHeader\">{{$index+1}}</div></th><th class=\"rCl\" ng-if=\"type==\'real\'\" style=\"min-width:62px\"><button ng-click=\"editMonthsValues(false)\" ng-if=\"monthsValues == null || monthsValuesHist\" ng-disabled=\"(monthsValues!=null && monthsValuesHist) || isWritePermAllowed()===false\" class=\"btn btn-default btn-sm\" style=\"min-width:60px\"><i class=\"fa fa-edit\"></i>Tot.</button> <button ng-click=\"undoEditMonths()\" ng-if=\"monthsValues != null && !monthsValuesHist\" class=\"btn btn-default btn-sm\" style=\"max-width:25px\"><i class=\"fa fa-undo\"></i></button> <button ng-click=\"confirmEditMonthsWithDialog()\" ng-if=\"monthsValues != null && !monthsValuesHist\" class=\"btn btn-default btn-sm\" style=\"max-width:25px\"><i class=\"fa fa-check\"></i></button></th><th class=\"rCl\" ng-if=\"type==\'real\'\">Cum.</th><th class=\"rCl\" style=\"min-width:62px\"><button ng-if=\"type!=\'real\'\" ng-click=\"editMonthsValues(true)\" ng-disabled=\"monthsValues!=null && !monthsValuesHist || !(type===\'hist\') || isWritePermAllowed()===false\" class=\"btn btn-default btn-sm\" style=\"min-width:0px\"><i class=\"fa fa-edit\"></i>Tot. st</button> <span ng-if=\"type==\'real\'\">Tot. st</span> <button ng-click=\"undoEditMonths()\" ng-if=\"monthsValues != null && monthsValuesHist\" class=\"btn btn-default btn-sm\" style=\"max-width:25px\"><i class=\"fa fa-undo\"></i></button> <button ng-click=\"confirmEditMonthsWithDialog()\" ng-if=\"monthsValues != null && monthsValuesHist\" class=\"btn btn-default btn-sm\" style=\"max-width:25px\"><i class=\"fa fa-check\"></i></button></th><th class=\"rCl\">Cum. st.</th><th class=\"rCl\" ng-if=\"type==\'real\' && show.stats\">% su storico</th><th class=\"rCl\" ng-if=\"type==\'real\' && show.stats\">% cum. su stor.</th><th class=\"rCl\" ng-if=\"type==\'real\' && show.stats\">% su tot. stor.</th><th class=\"rCl\" ng-if=\"type==\'real\' && show.stats\">Previs.</th></tr></thead><tbody><tr ng-repeat=\"m in months\" class=\"{{editingMonth == m.indexMatrix ? \'currMonthRow\':\'\'}}\"><td><button ng-if=\"type==\'real\' && editingMonth != m.indexMatrix\" ng-click=\"editMonth(m.indexMatrix)\" ng-disabled=\"editingMonth != null || isWritePermAllowed()===false\" class=\"btn btn-default btn-sm\" style=\"min-width:70px; width: 85px\"><i class=\"fa fa-edit\"></i> {{m.descrMonth}}</button> <button ng-if=\"type==\'hist\' && editingMonth != m.indexMatrix\" ng-click=\"editMonth(m.indexMatrix)\" ng-disabled=\"editingMonth != null || isWritePermAllowed()===false\" class=\"btn btn-default btn-sm\" style=\"min-width:70px; width: 85px\"><i class=\"fa fa-edit\"></i> {{m.numMonth|monthShortName}}</button> <button ng-click=\"undoMonth(m.indexMatrix)\" ng-if=\"editingMonth == m.indexMatrix\" class=\"btn btn-default btn-sm\" style=\"min-width:30px\"><i class=\"fa fa-undo\"></i></button> <button ng-click=\"confirmMonthWithDialog(m.indexMatrix)\" ng-if=\"editingMonth == m.indexMatrix\" class=\"btn btn-default btn-sm\" style=\"min-width:30px\"><i class=\"fa fa-check\"></i></button></td><td ng-repeat=\"d in getTimes(31) track by $index\" ng-if=\"showDay($index)\" class=\"{{DrawInSeason(m, $index+1)?\'inSeas\':\'outSeas\'}} {{dataMatrix[m.indexMatrix][$index][type].value==0?\'dayClEmpty\':\'dayCl\'}} {{drawSeasonEnd(m, $index)?\'seasonEnd\':\'\'}} {{drawSeasonStart(m, $index)?\'seasonStart\':\'\'}}\"><span ng-if=\"editingMonth != m.indexMatrix\">{{dataMatrix[m.indexMatrix][$index][type].value | number:1}}</span> {{dataMatrix[m.indexMatrix][$index][type] == null?\'-\': \'\'}} <input name=\"{{m.indexMatrix+\'_\'+$index}}\" ng-if=\"dataMatrix[m.indexMatrix][$index][type] != null && editingMonth == m.indexMatrix\" ng-model=\"dataMatrix[m.indexMatrix][$index][type].value\" class=\"form-control ng-pristine ng-valid ng-touched\" type=\"number\" min=\"0\" tabindex=\"0\" aria-invalid=\"false\" style=\"height: 24px !important; padding: 2px\"></td><td class=\"rCl\" ng-if=\"type==\'real\'\"><span ng-if=\"monthsValues == null || monthsValuesHist\">{{dataTotals[m.indexMatrix].totReal | number:1}}</span> <span ng-if=\"monthsValues != null && ! monthsValuesHist\"><input name=\"{{m.indexMatrix}}\" ng-model=\"monthsValues[m.indexMatrix]\" class=\"form-control ng-pristine ng-valid ng-touched\" type=\"number\" min=\"0\" tabindex=\"0\" aria-invalid=\"false\" style=\"height: 24px !important; padding: 2px\"></span></td><td class=\"rCl\" ng-if=\"type==\'real\'\">{{dataTotals[m.indexMatrix].cumulReal | number:1}}</td><td class=\"rCl\"><span ng-if=\"monthsValues == null || !monthsValuesHist\">{{dataTotals[m.indexMatrix].totHist | number:1}}</span> <span ng-if=\"monthsValues != null && monthsValuesHist\"><input name=\"{{m.indexMatrix}}\" ng-model=\"monthsValues[m.indexMatrix]\" class=\"form-control ng-pristine ng-valid ng-touched\" type=\"number\" min=\"0\" tabindex=\"0\" aria-invalid=\"false\" style=\"height: 24px !important; padding: 2px\"></span></td><td class=\"rCl\">{{dataTotals[m.indexMatrix].cumulHist | number:1}}</td><td class=\"rCl\" ng-if=\"type==\'real\' && show.stats\">{{(dataTotals[m.indexMatrix].totReal - dataTotals[m.indexMatrix].totHist)*100/dataTotals[m.indexMatrix].totHist | number:1}}{{(dataTotals[m.indexMatrix].totReal)>0?\'%\':\'\'}}</td><td class=\"rCl\" ng-if=\"type==\'real\' && show.stats\">{{(dataTotals[m.indexMatrix].cumulReal)*100/dataTotals[months.length].totHist | number:1}}%</td><td class=\"rCl\" ng-if=\"type==\'real\' && show.stats\">{{(dataTotals[m.indexMatrix].totReal)*100/dataTotals[months.length].totHist | number:1}}%</td><td class=\"rCl\" ng-if=\"type==\'real\' && show.stats\">{{(1-(dataTotals[months.length].totHist - dataTotals[m.indexMatrix].cumulHist + dataTotals[m.indexMatrix].cumulReal)/dataTotals[months.length].totHist)*100| number:1}}%</td></tr><tr style=\"border-top: 1px solid lightblue\"><td></td><td ng-repeat=\"d in getTimes(31) track by $index\" ng-if=\"showDay($index)\"></td><td class=\"rCl\" ng-if=\"type==\'real\'\">{{dataTotals[months.length].totReal | number:1}}</td><td class=\"rCl\" ng-if=\"type==\'real\'\">{{dataTotals[months.length].cumulReal | number:1}}</td><td class=\"rCl\">{{dataTotals[months.length].totHist | number:1}}</td><td class=\"rCl\">{{dataTotals[months.length].cumulHist | number:1}}</td><td class=\"rCl\" ng-if=\"type==\'real\' && show.stats\"></td><td class=\"rCl\" ng-if=\"type==\'real\' && show.stats\"></td><td class=\"rCl\" ng-if=\"type==\'real\' && show.stats\"></td><td class=\"rCl\" ng-if=\"type==\'real\' && show.stats\"></td></tr></tbody></table><div class=\"btn-group\"><label class=\"btn btn-default ng-untouched ng-valid ng-dirty ng-valid-parse\" ng-model=\"show.firstHalf\" uib-btn-checkbox=\"\" tabindex=\"0\" aria-invalid=\"false\">1-15</label> <label class=\"btn btn-default ng-untouched ng-valid ng-dirty ng-valid-parse active\" ng-model=\"show.secondHalf\" uib-btn-checkbox=\"\" tabindex=\"0\" aria-invalid=\"false\">16-31</label> <label class=\"btn btn-default ng-untouched ng-valid ng-dirty ng-valid-parse active\" ng-model=\"show.stats\" uib-btn-checkbox=\"\" tabindex=\"0\" aria-invalid=\"false\" ng-if=\"type==\'real\'\">Statistiche</label></div></form></div></div></uib-tab><uib-tab><uib-tab-heading><span class=\"fa fa-line-chart text-info-dker\"></span> Grafici</uib-tab-heading><div class=\"col-md-12\"><six-multi-series-line-chart sx-id=\"graph1\" sx-graph-data=\"graphData\" sx-y-axis-legend=\"\'Gradi Giorno\'\" sx-graph-title=\"Gradi Giorno\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\']\"></six-multi-series-line-chart><six-multi-series-line-chart sx-id=\"graph2\" sx-graph-data=\"graphDataCum\" sx-y-axis-legend=\"\'Cumulativo GG\'\" sx-graph-title=\"Cumulativo GG\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\']\"></six-multi-series-line-chart></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("energy/daydegrees/importgg.html","<style>\n    .red{\n    color:red;\n    }\n\n    .customButton{\n    min-width: 100px;\n    color: #58666e !important;\n    background-color: #fcfdfd;\n    background-color: #fff;\n    border-color: #dee5e7;\n    border-bottom-color: #d8e1e3;\n    box-shadow: 0 1px 1px rgba(90, 90, 90, 0.1);\n    }\n\n    .smallHeader{\n    font-size:x-small;\n    }\n\n    .customButton:hover,\n    .customButton:focus,\n    .customButton:active,\n    .customButton.active,\n    .open .dropdown-toggle.btn-info {\n    color: #ffffff !important;\n    background-color: #8bd56c !important;\n    border-color: #1bd500 !important;\n    }\n\n    .customButton:active,\n    .customButton.active,\n    .open .dropdown-toggle.btn-info {\n    background-image: none;\n    }\n\n    .customButton.disabled,\n    .customButton[disabled],\n    fieldset[disabled] .customButton,\n    .customButton.disabled:hover,\n    .customButton[disabled]:hover,\n    fieldset[disabled] .customButton:hover,\n    .customButton.disabled:focus,\n    .customButton[disabled]:focus,\n    fieldset[disabled] .customButton:focus,\n    .customButton.disabled:active,\n    .customButton[disabled]:active,\n    fieldset[disabled] .customButton:active,\n    .customButton.disabled.active,\n    .customButton[disabled].active,\n    fieldset[disabled] .customButton.active {\n    color: #000000 !important;\n    background-color: #8bd56c;\n    border-color: #1bd500;\n    }\n\n    six-toolbar-item .fa-check{\n        margin-right: 8px;\n    }\n\n    six-toolbar-item .invisible-check{\n        visibility:hidden;\n    }\n\n    #help-panel{\n        margin-bottom:-20px;\n    }\n\n    #help-area{\n        font-family:monospace;\n        font-size:smaller;\n        width:100%;\n        height: 60px;\n    }\n</style><six-toolbar><six-toolbar-item label-condition=\"(period == \'month\')\" label=\"PERIODO (dati giornalieri)\" label-disabled=\"PERIODO (dati mensili)\" icon=\"fa fa-calendar icon text-success-dker\"><li><a href=\"\" ng-click=\"importByDay()\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (period == \'month\')}\"></i> Dati giornalieri</a></li><li><a href=\"\" ng-click=\"importByMonth()\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (period == \'day\')}\"></i> Dati mensili</a></li></six-toolbar-item><six-toolbar-item label-condition=\"(type == \'real\')\" label=\"RIEPILOGO (storico)\" label-disabled=\"RIEPILOGO (consuntivo)\" icon=\"fa fa-calendar-check-o icon text-success-dker\"><li><a href=\"\" ng-click=\"importHist()\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (type == \'real\')}\"></i> Storico</a></li><li><a href=\"\" ng-click=\"importReal()\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (type == \'hist\')}\"></i> Consuntivo</a></li></six-toolbar-item><six-toolbar-item label=\"Template\" icon=\"fa fa-download icon text-info-dker\" toolbar-function=\"downloadTemplate()\"></six-toolbar-item><six-toolbar-item label=\"Aiuto\" icon=\"fa fa-question icon text-danger-dker\" toolbar-function=\"toggleHelp()\"></six-toolbar-item><six-toolbar-button label=\"Con stagionalità\" icon=\"fa fa-square-o\" icon-disabled=\"fa fa-check-square-o\" icon-condition=\"season.considerSeasonality\" toolbar-function=\"toggleSeasonality()\"></six-toolbar-button><six-toolbar-button label=\"Reset\" icon=\"fa fa-undo\" toolbar-function=\"clearData()\" sx-disabled=\"!canUndo\"></six-toolbar-button><six-toolbar-button label=\"Importa\" icon=\"fa fa-upload\" toolbar-function=\"importDataWithDialog()\" btn-class=\"btn-success\" sx-disabled=\"!canImport\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 wrapper-md override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Importa Gradi Giorno</h1></div></div></div><div class=\"panel-body\" ng-if=\"showHelp\" id=\"help-panel\"><div class=\"bd-callout bd-callout-info\"><h4>Esempio di file</h4><textarea id=\"help-area\" read=\"\">\n\"Zona_Termica\",\"Anno\", \"Gen\", \"Feb\", \"Mar\", \"Apr\", \"Mag\", \"Giu\", \"Lug\", \"Ago\", \"Set\", \"Ott\", \"Nov\", \"Dic\"\n\"reggioemilia\",\"2014\", \"20\", \"20\", \"10\", \"0\", \"0\", \"0\", \"0\", \"5\", \"10\", \"20\", \"30\", \"30\"\n            </textarea></div></div><div class=\"panel-body\"><a id=\"linkToTemplate\" style=\"display:none\" href=\"/energy/attachments/importGG_{{period}}.xlsx\"></a><div ui-grid=\"gridOptions\" class=\"grid\" ui-grid-resize-columns=\"\"><div class=\"grid-msg-overlay\" ng-show=\"!gridOptions.data.length\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"gridOptions\" multiple=\"false\"></div></div></div></div></div></div></div>");
$templateCache.put("energy/measurements/measurement.html","<six-toolbar><six-toolbar-item disabled=\"runningDisabled\" label=\"START\" icon=\"fa fa-play icon text-success-dker\" toolbar-function=\"fight()\"></six-toolbar-item><six-toolbar-item disabled=\"stopDisabled\" label=\"STOP\" icon=\"fa fa-stop icon text-danger-dker\" toolbar-function=\"stopFight()\"></six-toolbar-item><six-toolbar-item disabled=\"resetDisabled\" label=\"RESET\" icon=\"fa fa-undo icon text-info-dker\" toolbar-function=\"resetFight()\"></six-toolbar-item></six-toolbar><div class=\"wrapper-md ng-scope override-padding-toolbar\"><div class=\"row\"><div class=\"col-md-5\"><div class=\"row row-sm text-center\"><div class=\"col-xs-6\"><div class=\"panel padder-v item\"><div class=\"h1 text-info font-thin h1\">{{dayCount}}</div><span class=\"text-muted text-xs\">Dati giornalieri</span><div class=\"top text-right w-full\"><i class=\"fa fa-caret-down text-warning m-r-sm\"></i></div></div></div><div class=\"col-xs-6\"><div class=\"panel padder-v item\"><div class=\"h1 text-info font-thin h1\">{{monthCount}}</div><span class=\"text-muted text-xs\">Dati mensili</span><div class=\"top text-right w-full\"><i class=\"fa fa-caret-down text-warning m-r-sm\"></i></div></div></div></div></div><div class=\"col-md-7\"><div class=\"panel wrapper\"><h4 class=\"font-thin m-t-none m-b text-muted\">Dati centraline</h4><six-multi-series-line-chart sx-id=\"graph1\" sx-graph-data=\"graphData\" sx-y-axis-legend=\"\'Rilevazione dati\'\" sx-graph-title=\"Dati acquisiti\" sx-x-axis-format=\"\'%H:%M:%S\'\"></six-multi-series-line-chart></div></div></div></div>");
$templateCache.put("energy/overridedates/overridedates.html","<style type=\"text/css\">\n  .margin {\n    margin-top: 3px;\n    margin-bottom: 3px;\n  }\n\n  .no_padding {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n</style><div class=\"col-md-12 pad-t-15\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-12 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">DATE STAGIONE TERMICA</h1></div></div></div><div class=\"panel-body\"><div class=\"col-md-12\"><div class=\"row wrapper\"><div class=\"row\"><div class=\"col-md-3\"><label id=\"tipo_label\" for=\"record_type\" class=\"control-label\">Tipo</label><six-lookup id=\"record_type\" sx-base-path=\"\'schema\'\" ng-model=\"record\" sx-field=\"\'type_id\'\" sx-disabled=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"contatoreId_label\" for=\"record_id\" class=\"control-label\">Record</label><six-lookup id=\"record_id\" ng-model=\"record\" sx-type=\"record.type_id.UUID\" sx-field=\"\'record_id\'\"></six-lookup></div><div class=\"col-md-6\"><div><div class=\"col-md-6\"><label>Data di inizio:</label></div><div class=\"col-md-6\"><label>Data di fine:</label></div></div><div class=\"margin\"><div class=\"col-md-6\"><six-date-picker ng-model=\"dates.in\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"addDate(dates.in, \'begin\')\" ng-disabled=\"isWritePermAllowed()===false\"><i class=\"fa fa-plus-circle\"></i></button></six-date-picker></div><div class=\"col-md-6\"><six-date-picker ng-model=\"dates.out\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"addDate(dates.out, \'end\')\" ng-disabled=\"isWritePermAllowed()===false\"><i class=\"fa fa-plus-circle\"></i></button></six-date-picker></div></div></div></div></div><div class=\"row wrapper\"><div class=\"row\"><div class=\"col-md-3 control-label\"><label>Data di inizio predefinita:</label></div><div class=\"col-md-3 control-label\"><label>Data di fine predefinita:</label></div></div><div class=\"row\"><div class=\"col-md-3\"><input class=\"form-control\" value=\"{{zonaClimatica.model.day_in}} {{zonaClimatica.model.month_in}}\" disabled=\"\"></div><div class=\"col-md-3\"><input class=\"form-control\" value=\"{{zonaClimatica.model.day_out}} {{zonaClimatica.model.month_out}}\" disabled=\"\"></div></div></div><div class=\"row wrapper\"><div class=\"row\"><div class=\"col-md-3 control-label\"><label>Elenco modifiche:</label></div></div><div id=\"gridDates\" ui-grid=\"gridDates\" class=\"grid col-md-12 no_padding\" ui-grid-resize-columns=\"\"></div></div></div></div></div></div>");
$templateCache.put("energy/perspective/detail.html","<div class=\"row\"><div class=\"col-sm-12\"><button ng-click=\"unselect()\" type=\"button\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-menu-left\"></span> Indietro</button></div></div><div class=\"col-md-12\"><hr></div><div class=\"row\"><div class=\"col-sm-12\"><tabset class=\"tab-container\"><tab heading=\"Dettaglio\"><div class=\"row\"><div class=\"col-sm-4\"><label for=\"code\">Codice</label> <input id=\"code\" name=\"code\" class=\"form-control\" ng-model=\"perspective.code\" disabled=\"\"></div><div class=\"col-sm-8\"><label for=\"description\">Descrizione</label> <input id=\"description\" name=\"description\" placeholder=\"\" class=\"form-control\" ng-model=\"perspective.description\" disabled=\"\"></div></div><div class=\"row\"><div class=\"col-sm-8\"><label for=\"type\">Tipologia</label> <input id=\"type\" name=\"type\" class=\"form-control\" ng-model=\"perspective.type.description\" disabled=\"\"></div><div class=\"col-sm-4\"><label for=\"year\">Anno</label> <input id=\"year\" name=\"description\" placeholder=\"\" class=\"form-control\" ng-model=\"perspective.year\" disabled=\"\"></div></div></tab><tab heading=\"Statistiche\"><div class=\"row\"><div class=\"col-md-12\"><six-loading-place-holder sx-model=\"loadingPlaceHolder\" sx-height=\"\'450px\'\"></six-loading-place-holder></div><div class=\"row wrapper\" ng-if=\"!loadingPlaceHolder.show\"><div class=\"col-md-12\" ng-if=\"!budget.list || budget.list.length === 0\">Nessun dato da mostrare</div><div class=\"col-md-12\" ng-if=\"budget.list && budget.list.length > 0\"><table class=\"detailTable table-hover\"><tr><th style=\"text-align: center\">U.M. [Kwh]</th><th ng-repeat=\"record in budget.list\">{{record.date | date: \'MMM\': \'+01:00\'}}</th><th>Tot.</th></tr><tr><td>Budget</td><td class=\"numberCell\" ng-repeat=\"record in budget.list\">{{record.budget | number: 3}}</td><td class=\"numberCell\">{{budget.totalBudget | number: 3}}</td></tr><tr><td>Consuntivo</td><td class=\"numberCell\" ng-repeat=\"record in budget.list\">{{record.consumption | number: 3}}</td><td class=\"numberCell\">{{budget.totalConsumption | number: 3}}</td></tr><tr><td>Stagionalità</td><td class=\"numberCell\" ng-repeat=\"record in budget.list\">{{record.season | number: 3}}</td><td class=\"numberCell\">{{budget.season | number: 3}}</td></tr><tr><td>&Delta; Stagionalità</td><td class=\"numberCell\" ng-repeat=\"record in budget.list\">{{record.deltaSeason | number: 3}}</td><td class=\"numberCell\">{{budget.deltaSeason | number: 3}}</td></tr><tr><td>&Delta; Tecnico</td><td class=\"numberCell\" ng-repeat=\"record in budget.list\">{{record.deltaTech | number: 3}}</td><td class=\"numberCell\">{{budget.deltaTech | number: 3}}</td></tr><tr><td>%</td><td class=\"numberCell\" ng-repeat=\"record in budget.list\">{{record.percentage | number: 2}}</td><td class=\"numberCell\">{{budget.percentage | number: 2}}</td></tr></table></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><six-multi-series-line-chart sx-id=\"graph1\" sx-graph-data=\"graphData\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"Consumi\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\', \'#EE2222\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><six-multi-series-line-chart sx-id=\"graph2\" sx-graph-data=\"graphDataCumulative\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"Consumi cumulati\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart></div></div></div></tab><tab heading=\"Prospettiva\"><div class=\"row wrapper\"><div class=\"col-sm-2 col-md-offset-10\"><button ng-click=\"generate()\" type=\"button\" class=\"btn btn-default btn-sm\"><i class=\"fa fa-cog\"></i> Genera Budget</button></div></div><div class=\"row\"><div class=\"col-md-12\" ng-if=\"perspective.list && perspective.list.length > 0\"><table class=\"detailTable table-hover\"><tr><th style=\"text-align: center\">U.M. [Kwh]</th><th ng-repeat=\"record in perspective.list\">{{record.date | date: \'MMM\': \'+01:00\'}}</th><th>Tot.</th></tr><tr><td>Budget Precedente</td><td class=\"numberCell\" ng-repeat=\"record in perspective.list\">{{record.oldBudget | number: 3}}</td><td class=\"numberCell\">{{perspective.totalOldBudget | number: 3}}</td></tr><tr ng-if=\"perspective.type.code !== \'PT001\'\"><td>&Delta; Tecnico</td><td class=\"numberCell\" ng-repeat=\"record in perspective.list\">{{record.deltaTech | number: 3}}</td><td class=\"numberCell\">{{perspective.deltaTech | number: 3}}</td></tr><tr><td>Budget Previsione</td><td class=\"numberCell\" ng-repeat=\"record in perspective.list\">{{record.budget | number: 3}}</td><td class=\"numberCell\">{{perspective.totalBudget | number: 3}}</td></tr><tr ng-if=\"perspective.type.code !== \'PT001\'\"><td>&Delta; Tecnico Previsoine %</td><td class=\"numberCell\" ng-repeat=\"i in [0,1,2,3,4,5,6,7,8,9,10,11]\">{{techFactor[i] * 100 | number: 2}}</td><td class=\"numberCell\"></td></tr><tr><td>Stagionalità</td><td class=\"numberCell\" ng-repeat=\"record in perspective.list\">{{record.season | number: 3}}</td><td class=\"numberCell\">{{perspective.season | number: 3}}</td></tr><tr><td>&Delta; Stagionalità %</td><td class=\"numberCell\" ng-repeat=\"record in perspective.list\">{{record.deltaSeason | number: 2}}</td><td class=\"numberCell\">{{perspective.deltaSeason | number: 2}}</td></tr><tr><td>Prospettiva</td><td class=\"numberCell\" ng-repeat=\"record in perspective.list\">{{record.perspective | number: 2}}</td><td class=\"numberCell\">{{perspective.totalPerspective | number: 3}}</td></tr></table></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><six-multi-series-line-chart sx-id=\"graph3\" sx-graph-data=\"graphPrev\" sx-y-axis-legend=\"\'Prospettiva\'\" sx-graph-title=\"Prospettiva\" sx-series-colors=\"[\'#1044EE\', \'#f9d21a\', \'#398439\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart></div></div><div class=\"row wrapper-md\"><table class=\"detailTable\"><tr><th>Prospettiva</th><th style=\"text-align: left\" ng-repeat=\"record in perspective.list\">{{record.date | date: \'MMM\': \'+01:00\'}}</th></tr><tr><td>Fattore Stagionale</td><td style=\"text-align: center\" ng-repeat=\"i in [0,1,2,3,4,5,6,7,8,9,10,11]\"><slider ng-model=\"seasonFactor[i]\" orientation=\"vertical\" min=\"-1\" step=\"0.05\" max=\"1\" ng-change=\"perspectiveComputation(budget, seasonFactor)\"></slider></td></tr><tr ng-if=\"perspective.type.code !== \'PT001\'\"><td>Fattore Tecnico</td><td style=\"text-align: center\" ng-repeat=\"i in [0,1,2,3,4,5,6,7,8,9,10,11]\"><slider ng-model=\"techFactor[i]\" orientation=\"vertical\" min=\"-1\" step=\"0.05\" max=\"1\" ng-change=\"perspectiveComputation(budget, seasonFactor)\"></slider></td></tr></table></div></tab></tabset></div></div>");
$templateCache.put("energy/perspective/perspective.html","<style>\n  .ui-grid-menu-button {\n   height: 30px;\n }\n</style><six-toolbar><six-toolbar-button ng-if=\"generatePerspectiveForm\" icon=\"fa fa-chevron-left\" toolbar-function=\"backToPerspective()\"></six-toolbar-button><six-toolbar-button ng-if=\"!generatePerspectiveForm\" label=\"Trova\" btn-class=\"btn-info\" icon=\"fa fa-search\" toolbar-function=\"loadPerspectiveList()\"></six-toolbar-button><six-toolbar-button ng-if=\"!generatePerspectiveForm\" label=\"Genera\" id=\"btn_new\" btn-class=\"btn-success\" icon=\"fa fa-plus\" toolbar-function=\"toggleNewPerspective()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-12 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Previsioni e Prospettive</h1><small class=\"text-muted\" ng-if=\"!generatePerspectiveForm\">Lista</small> <small class=\"text-muted\" ng-if=\"generatePerspectiveForm\">{{budget.budget_code}}</small></div></div></div><div class=\"wrapper\" collapse=\"isCollapsed\" ng-if=\"!generatePerspectiveForm\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"row\"><div class=\"col-xs-8 col-sm-6\"><six-year-picker id=\"year\" ng-model=\"searchFilter.year\" class=\"input-group\" label-year=\"Anno:\"></six-year-picker></div></div></div></div><div class=\"col-md-12\"><hr></div><div class=\"row\"><div class=\"col-md-12\"><div id=\"gridList\" ui-grid=\"gridListOptions\" class=\"grid\" ui-grid-resize-columns=\"\" ui-grid-exporter=\"\"></div></div></div></div></div><div class=\"wrapper\" collapse=\"!isCollapsed\" ng-if=\"!generatePerspectiveForm\"><div ng-if=\"isCollapsed\" data-ng-include=\"\'energy/perspective/detail.html\'\" class=\"panel-body\"></div></div><div class=\"wrapper-md\" ng-if=\"generatePerspectiveForm\"><uib-tabset class=\"tab-container\" active=\"step\"><uib-tab heading=\"Step 1\" disable=\"step!=1\" index=\"1\" select=\"percent=10\"><p class=\"m-b\">Wizard per la generazione di una nuova previsione e/o prospettiva di budget.</p><uib-progressbar value=\"percent\" class=\"progress-xs\" type=\"success\"></uib-progressbar><h4>Dati Base</h4><form name=\"step1\" class=\"form-validation\"><p>Codice:</p><input name=\"code\" class=\"form-control\" ng-model=\"perspective.code\" required=\"\"><p class=\"m-t\">Descrizione:</p><input name=\"description\" placeholder=\"\" class=\"form-control\" ng-model=\"perspective.description\" required=\"\"><div class=\"m-t m-b\"><button type=\"button\" class=\"btn btn-default btn-rounded\" ng-click=\"toggleNewPerspective()\">Annulla</button> <button type=\"submit\" ng-disabled=\"step1.$invalid\" class=\"btn btn-default btn-rounded\" ng-click=\"goToStep(2)\">Successivo</button></div></form></uib-tab><uib-tab heading=\"Step 2\" index=\"2\" disable=\"step!=2\" select=\"percent=30\"><form name=\"step2\" class=\"form-validation\"><p class=\"m-b\">Avanzamento</p><uib-progressbar value=\"percent\" class=\"progress-xs\" type=\"success\"></uib-progressbar><six-year-picker id=\"yearPerspective\" name=\"yearPerspective\" ng-model=\"perspective.year\" class=\"input-group\" label-year=\"Anno Previsione :\" sx-plus-minus=\"10\" required=\"\"></six-year-picker><label>Tipologia :</label><select class=\"form-control\" ng-model=\"perspective.type\" ng-options=\"t.description for t in perspectiveTemplate.template\" required=\"\"></select><div class=\"m-t m-b\"><button type=\"button\" class=\"btn btn-default btn-rounded\" ng-click=\"goToStep(1)\">Precedente</button> <button type=\"submit\" ng-disabled=\"step2.$invalid\" class=\"btn btn-default btn-rounded\" ng-click=\"goToStep(3)\">Successivo</button></div></form></uib-tab><uib-tab heading=\"Step 3\" disable=\"step!=3\" index=\"3\" select=\"percent=60\"><p class=\"m-b\">Tutte le informazioni necessarie sono state inserite.</p><uib-progressbar value=\"percent\" class=\"progress-xs\" type=\"success\"></uib-progressbar><p>Premere \"Genera\" per completare la procedura di generazione</p><div class=\"m-t m-b\"><button type=\"button\" class=\"btn btn-default btn-rounded\" ng-click=\"goToStep(2)\">Precedente</button> <button type=\"button\" class=\"btn btn-default btn-rounded\" ng-click=\"percent=100; createPerspective();\">Genera</button></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("energy/pricelist/importTemplate.html","<input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"gridDetailOptions\" multiple=\"false\">");
$templateCache.put("energy/pricelist/pricelist_component.html","<six-toolbar><six-toolbar-item label=\"Template\" icon=\"fa fa-download icon text-info-dker\" ng-show=\"mode.mode === \'import\'\" toolbar-function=\"createTemplate()\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Importa\" icon=\"fa fa-upload\" toolbar-function=\"importData()\" ng-if=\"mode.mode === \'import\'\" btn-class=\"btn-success\" sx-disabled=\"percent === 100 || isAllOk === false || !gridDetailOptions.data.length\"></six-toolbar-button><six-toolbar-button id=\"btn_search\" icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"loadData()\" sx-disabled=\"!selectedComponentType\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">{{type.descriptor.description}} - {{category.descriptor.description}}</h1><small class=\"text-muted\">Dettaglio</small></div></div></div><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"col-md-3\">Data:<p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"upperDate\" is-open=\"status.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-3\" ng-if=\"category.descriptor.fornitore_dependent === true\">Fornitore: <span class=\"font-bold\">{{fornitore.fornitore_id.code}}</span><six-lookup ng-model=\"fornitore\" sx-type=\"\'fornitore\'\" sx-field=\"\'fornitore_id\'\" sx-show-description=\"false\"></six-lookup></div></div><div class=\"row wrapper\" ng-if=\"category.descriptor.fornitore_dependent === false || fornitore.fornitore_id\"><uib-tabset ng-init=\"selectedComponentType=componentTypesList[0]\"><uib-tab ng-repeat=\"component in componentTypesList\" ng-click=\"tabSelected(component)\"><uib-tab-heading><span class=\"fa fa-puzzle-piece text-info-dker\"></span> {{component.code}}</uib-tab-heading><div class=\"wrapper pull-right\"><div class=\"btn-group\"><label class=\"btn btn-sm btn-default\" ng-model=\"mode.mode\" uib-btn-radio=\"\'show\'\" tooltip=\"Visualizza\" title=\"Visualizza\"><span class=\"fa fa-eye\"></span></label> <label class=\"btn btn-sm btn-default\" ng-model=\"mode.mode\" uib-btn-radio=\"\'import\'\" tooltip=\"Importa\" title=\"Importa\" ng-disabled=\"isWritePermAllowed()===false\"><span class=\"fa fa-upload\"></span></label></div><div class=\"m-l btn-group\"><button ng-click=\"addRecord()\" class=\"btn btn-default btn-sm\" ng-disabled=\"mode.mode === \'import\' || isWritePermAllowed()===false\"><span class=\"fa fa-plus\"></span> Aggiungi</button> <button ng-click=\"removeRecords()\" class=\"btn btn-default btn-sm\" ng-disabled=\"mode.mode === \'import\' || isWritePermAllowed()===false\"><span class=\"fa fa-times\"></span> Rimuovi</button></div></div><div class=\"wrapper\"><h1 class=\"m-b h3\">{{component.description}}</h1></div></uib-tab></uib-tabset><div id=\"gridList\" ui-grid=\"gridDetailOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 450px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\" ui-grid-edit=\"\" ui-grid-row-edit=\"\" ui-grid-cellnav=\"\" ui-grid-selection=\"\"><div class=\"grid-msg-overlay\" ng-show=\"!gridDetailOptions.data.length && mode.mode === \'import\'\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"gridDetailOptions\" multiple=\"false\"></div></div></div></div><div class=\"row m-t-lg\" ng-if=\"percent > 0\"><div class=\"col-md-12\"><form class=\"wrapper\"><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">{{percent | number : 0}}%</span> <span class=\"hidden-folded ng-scope\">Salvataggio</span></div><div class=\"progress-s m-t-sm dk progress ng-isolate-scope\" value=\"{{percent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{percent}}%;\"></div></div></form></div></div></div></div></div></div>");
$templateCache.put("energy/pricelist/pricelist_component_list.html","<div class=\"col-md-12\"><ol class=\"breadcrumb\"><li><a href=\"#/\">HOME</a></li><li>COMPONENTI LISTINO</li></ol><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">{{type.descriptor.description}} - {{category.descriptor.description}}</h1><small class=\"text-muted\">Lista</small></div><div class=\"wrapper pull-right\"><div class=\"inline m-r text-left\"><button ng-click=\"openDetails(\'_new_\')\" ng-disabled=\"!selectedComponentType\" class=\"btn btn-info btn-sm pull-right\"><span class=\"fa fa-file\"></span> Nuovo</button></div><div class=\"inline m-r text-left\"><button ng-click=\"loadGroupByFornitori()\" class=\"btn btn-info btn-sm pull-right\" id=\"btn_search\" ng-disabled=\"!selectedComponentType\"><span class=\"fa fa-refresh\"></span></button></div></div></div></div><div class=\"panel wrapper\"><div class=\"panel-body\"><div class=\"row wrapper\"><tabset ng-init=\"selectedComponentType=componentTypesList[0]\"><tab ng-repeat=\"component in componentTypesList\" ng-click=\"tabSelected(component)\"><tab-heading><span class=\"fa fa-puzzle-piece text-info-dker\"></span> {{component.code}}</tab-heading><div class=\"wrapper\"><h1 class=\"m-b h3\">{{component.description}}</h1></div></tab></tabset><div id=\"gridList\" ui-grid=\"gridListOptions\" class=\"grid\" style=\"height: 450px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div></div></div></div>");
$templateCache.put("energy/pricelist/pricelist_detail.html","<form name=\"form\"><six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"goBack()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveOrUpdate()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" ng-if=\"header.version\" toolbar-function=\"deleteWithDialog(header.version)\" sx-disabled=\"isDeletePermAllowed()===false\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><span ng-if=\"header.version\"><h1 class=\"m-n font-thin h3 text-black\">{{header.model.description}}</h1><small class=\"text-muted\">{{header.model.code}} [UUID: {{header.UUID}}]</small></span> <span ng-if=\"!header.version\"><h1 class=\"m-n font-thin h3 text-black\">NUOVO LISTINO</h1><small class=\"text-muted\">Dettaglio listino</small></span></div></div></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3\">Codice:<div class=\"input-group col-md-12\"><input type=\"text\" id=\"code\" name=\"code\" class=\"form-control\" ng-class=\"{\'bg-danger lt\': (form.$submitted && form.code.$error.required)}\" ng-model=\"header.model.code\" ng-disabled=\"header.version\" required=\"\"></div></div><div class=\"col-md-3\">Descrizione:<div class=\"input-group col-md-12\"><input type=\"text\" id=\"description\" name=\"description\" class=\"form-control col-md-12\" ng-model=\"header.model.description\" required=\"\"></div></div><div class=\"col-md-3\">Inizio validità: <input class=\"btn btn-default btn-sm col-md-12\" id=\"from\" type=\"date\" ng-model=\"header.model.from\" required=\"\"></div><div class=\"col-md-3\">Fine validità: <input class=\"btn btn-default btn-sm col-md-12\" id=\"to\" type=\"date\" ng-model=\"header.model.to\" required=\"\"></div></div><div class=\"row\"><div class=\"col-md-3\">Vettore<six-lookup id=\"tipo\" ng-model=\"header.model\" sx-type=\"\'vettoreenergetico\'\" sx-field=\"\'vettore_id\'\"></six-lookup></div><div class=\"col-md-3\">Fornitore<six-lookup id=\"provider\" ng-model=\"header.model\" sx-type=\"\'fornitore\'\" sx-field=\"\'fornitore_id\'\"></six-lookup></div></div><div class=\"row\"><div class=\"col-md-3\">Tipo<six-select id=\"type\" ng-model=\"header.model.type\" sx-item-list=\"types\" ng-show-description=\"\'false\'\" sx-disabled=\"!header.model.vettore_id\"></six-select></div></div><hr><div ng-if=\"showFixedPricesGrid()\"><h1 class=\"m-b m-t font-thin h3 text-black\">Tariffe:</h1><div id=\"slotsGridList\" ui-grid=\"pricesGridOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 350px\" ui-grid-edit=\"\" ui-grid-row-edit=\"\" ui-grid-cellnav=\"\" ui-grid-selection=\"\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div><div class=\"row\" ng-if=\"(header.model.type.code===\'monomia\' || header.model.type.code===\'binomia\') && header.model.vettore_id.code===\'gas\'\"><div class=\"col-md-3\">Delibera AEEG:<six-select ng-model=\"header.model.delibera_aeeg\" sx-item-list=\"deliberaAEEGList\" sx-show-description=\"false\"></six-select></div><div class=\"col-md-3\">PCS std.:<div class=\"input-group\"><ui-select tagging=\"\" tagging-label=\"(personalizzato)\" ng-model=\"header.model.pcs_std\" theme=\"bootstrap\" sortable=\"true\" ng-disabled=\"disabled\" on-select=\"$select.selected = onPcsStdSelect($item)\"><ui-select-match class=\"ui-select-match\" placeholder=\"Select...\">{{$select.selected}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in pcsStdList | filter:$select.search\">{{item}}</ui-select-choices></ui-select><span class=\"input-group-addon\">Mj/SMC</span></div></div></div></div></div></div></form>");
$templateCache.put("energy/pricelist/pricelist_list.html","<six-toolbar><six-toolbar-button label=\"Nuovo\" icon=\"fa fa-plus\" toolbar-function=\"newPricelist()\" btn-class=\"btn-info\" id=\"btn_item_create\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button></six-toolbar><form name=\"form\"><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><span ng-if=\"!header.version\"><h1 class=\"m-n font-thin h3 text-black\">LISTINI</h1><small class=\"text-muted\">Lista</small></span></div></div></div><div class=\"panel-body\"><div class=\"form-group\"><input ng-keyup=\"findPriceList()\" class=\"form-control\" type=\"text\" ng-model=\"queryParam\" placeholder=\"Scrivere qui per filtrare la lista...\"></div><div class=\"wrapper\"><div class=\"row\"><div id=\"gridList\" ui-grid=\"listGridOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 350px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\" ui-grid-auto-resize=\"\"></div></div></div></div></div></div></form>");
$templateCache.put("energy/pricelist/pricelist_sim.html","<style>\n    six-toolbar-item .fa-check{\n        margin-right: 8px;\n    }\n\n    six-toolbar-item .invisible-check{\n        visibility:hidden;\n    }\n</style><form name=\"form\"><six-toolbar><six-toolbar-item icon-condition=\"simType === ELETTRICITA\" label-condition=\"simType === ELETTRICITA\" label=\"Simulazione (GAS)\" label-disabled=\"Simulazione (ELETTRICO)\" icon-disabled=\"fa fa-bolt icon text-danger-dker\" icon=\"fa fa-cloud icon text-primary-dk\"><li><a href=\"\" ng-click=\"simulateElettric()\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (simType === GAS)}\"></i> Elettrico</a></li><li><a href=\"\" ng-click=\"simulateGas()\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': simType === ELETTRICITA}\"></i> Gas</a></li></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-save\" label=\"Salva\" btn-class=\"btn-success\" toolbar-function=\"saveOrUpdate();\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-3 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">SIMULAZIONE</h1><small class=\"text-muted\">{{simType}}</small></div></div></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3\">Codice:<div class=\"input-group\"><input type=\"text\" name=\"code\" class=\"form-control\" ng-class=\"{\'bg-danger lt\': (form.$submitted && form.code.$error.required)}\" ng-model=\"params.code\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-3\">Anno:<six-year-picker ng-model=\"params.year\" sx-plus-minus=\"20\"></six-year-picker></div><div class=\"col-md-3\">Mese:<six-month-picker ng-model=\"params.month\"></six-month-picker></div><div class=\"col-md-3\">Tipo simulazione:<six-select ng-model=\"params.algorithmType\" sx-item-list=\"algorithmTypes\" sx-show-description=\"false\"></six-select></div></div><div class=\"row\"><div class=\"col-md-3\">Vettore<six-lookup id=\"vettore\" ng-model=\"vettore\" sx-type=\"\'vettoreenergetico\'\" sx-field=\"\'id\'\" sx-disabled=\"\'true\'\"></six-lookup></div><div class=\"col-md-3\">Tipo contatore<six-lookup id=\"tipo\" sx-base-path=\"\'schema\'\" ng-model=\"params.contatoreType\" sx-field=\"\'id\'\" sx-filter=\"contatoreTypeFilter\" sx-disabled=\"!vettore.id\"></six-lookup></div><div class=\"col-md-3\">Contatore<six-lookup id=\"contatore\" ng-model=\"params.contatore\" sx-type=\"params.contatoreType.id.UUID\" sx-field=\"\'id\'\" sx-object=\"params.contatore.obj\" sx-disabled=\"!params.contatoreType.id\"></six-lookup></div><div class=\"col-md-3\">Fornitore<six-lookup id=\"fornitore\" ng-model=\"params.fornitore\" sx-type=\"\'fornitore\'\" sx-field=\"\'id\'\"></six-lookup></div></div><div class=\"m-t panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-body\"><a data-toggle=\"collapse\" data-target=\"#collapseOne\" ng-click=\"advancedStatus.open=!advancedStatus.open\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': advancedStatus.open, \'fa-angle-right\': !advancedStatus.open}\"></i> Avanzate</h4></div></a><div id=\"collapseOne\" class=\"panel-collapse collapse\"><div id=\"ee_params\" ng-if=\"simType===ELETTRICITA\"><div class=\"row\"><div class=\"col-md-3\">Comune: <span class=\"font-bold\">{{params.comune.id.code}}</span><six-lookup ng-model=\"params.comune\" sx-type=\"\'comune\'\" sx-field=\"\'id\'\" sx-object=\"params.comune.obj\" sx-show-description=\"false\"></six-lookup></div><div class=\"col-md-3\">Provincia: <span class=\"font-bold\">{{params.provincia.id.code}}</span><six-lookup ng-model=\"params.provincia\" sx-type=\"\'provincia\'\" sx-field=\"\'id\'\" sx-object=\"params.provincia.obj\" sx-show-description=\"false\" sx-disabled=\"\'true\'\"></six-lookup></div><div class=\"col-md-3\">Regione: <span class=\"font-bold\">{{params.regione.id.code}}</span><six-lookup ng-model=\"params.regione\" sx-type=\"\'regione\'\" sx-field=\"\'id\'\" sx-object=\"params.regione.obj\" sx-show-description=\"false\" sx-disabled=\"\'true\'\"></six-lookup></div></div><div class=\"row\"><div class=\"col-md-3\">Utenza: <span class=\"font-bold\">{{params.utenza.id.code}}</span><six-lookup ng-model=\"params.utenza\" sx-type=\"\'utenza\'\" sx-field=\"\'id\'\" sx-object=\"params.utenza.obj\" sx-show-description=\"false\"></six-lookup></div><div class=\"col-md-3\">Regime fiscale: <span class=\"font-bold\">{{params.regimeFiscale.id.code}}</span><six-lookup ng-model=\"params.regimeFiscale\" sx-type=\"\'regimefiscale\'\" sx-field=\"\'id\'\" sx-show-description=\"false\" sx-disabled=\"\'true\'\"></six-lookup></div></div><div class=\"row\"><div class=\"col-md-3\">Tensione: <span class=\"font-bold\">{{params.tensione.selected.code}}</span><six-select ng-model=\"params.tensione.selected\" sx-item-list=\"tensioneList\" sx-show-description=\"false\"></six-select></div><div class=\"col-md-3\">Livello tensione: <span class=\"font-bold\">{{params.livelloTensione.id.code}}</span><six-lookup ng-model=\"params.livelloTensione\" sx-type=\"\'classificazionetensione\'\" sx-field=\"\'id\'\" sx-show-description=\"false\" sx-disabled=\"\'true\'\"></six-lookup></div><div class=\"col-md-3\">Perdite:<div class=\"input-group col-md-6\"><span ng-if=\"params.perdite != undefined\" class=\"form-control\">{{params.perdite * 100}}</span> <span ng-if=\"params.perdite == undefined\" class=\"form-control\"></span> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"row\"><div class=\"col-md-3\">Potenza impegnata:<div class=\"input-group col-md-6\"><input type=\"number\" class=\"form-control\" ng-model=\"params.potenzaImpegnata\" step=\"1\"> <span class=\"input-group-addon\">kW</span></div></div><div class=\"col-md-3\">Potenza disponibile:<div class=\"input-group col-md-6\"><input type=\"number\" class=\"form-control\" ng-model=\"params.potenzaDisponibile\" step=\"1\"> <span class=\"input-group-addon\">kW</span></div></div><div class=\"col-md-3\"><div class=\"input-group col-md-6\">Potenza max.:<div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"params.potenzaMax\" step=\"1\"> <span class=\"input-group-addon\">kW</span></div></div></div></div><div class=\"row\"><div class=\"col-md-3\">N. contratto:<div class=\"input-group col-md-6\"><input type=\"text\" class=\"form-control\" ng-model=\"params.numContratto\" readonly=\"\"></div></div><div class=\"col-md-3\">Tipo contratto:<div class=\"input-group col-md-12\"><input type=\"text\" class=\"form-control\" ng-model=\"params.tipoContratto\" readonly=\"\"></div></div><div class=\"col-md-3\">Lettera comma 2.1 TIV:<div class=\"input-group col-md-6\"><input type=\"text\" class=\"form-control\" ng-model=\"params.tiv\" readonly=\"\"></div></div><div class=\"col-md-3\">Lettera comma 2.2 TIT:<div class=\"input-group col-md-6\"><input type=\"text\" class=\"form-control\" ng-model=\"params.tit\" readonly=\"\"></div></div><div class=\"col-md-3\">Spread:<div class=\"input-group col-md-6\"><input type=\"number\" class=\"form-control\" ng-model=\"params.spread\" step=\"0.000001\"> <span class=\"input-group-addon\">c€/kWh</span></div></div></div><div class=\"row panel wrapper\">Consumi [kWh]:<table><tr><td ng-repeat=\"month in getMonths()\">{{getMonthName(month)}}</td></tr><tr><td ng-repeat=\"month in getMonths()\"><input type=\"number\" class=\"form-control\" ng-model=\"params.consumptions[month]\" step=\"0.0001\"></td></tr></table></div></div><div id=\"gas_params\" ng-if=\"simType===GAS\"><div class=\"row\"><div class=\"col-md-3\">Comune: <span class=\"font-bold\">{{params.comune.id.code}}</span><six-lookup ng-model=\"params.comune\" sx-type=\"\'comune\'\" sx-field=\"\'id\'\" sx-object=\"params.comune.obj\" sx-show-description=\"false\"></six-lookup></div><div class=\"col-md-3\">Provincia: <span class=\"font-bold\">{{params.provincia.id.code}}</span><six-lookup ng-model=\"params.provincia\" sx-type=\"\'provincia\'\" sx-field=\"\'id\'\" sx-object=\"params.provincia.obj\" sx-show-description=\"false\" sx-disabled=\"\'true\'\"></six-lookup></div><div class=\"col-md-3\">Regione: <span class=\"font-bold\">{{params.regione.id.code}}</span><six-lookup ng-model=\"params.regione\" sx-type=\"\'regione\'\" sx-field=\"\'id\'\" sx-object=\"params.regione.obj\" sx-show-description=\"false\" sx-disabled=\"\'true\'\"></six-lookup></div><div class=\"col-md-3\">Ambito tariffario: <span class=\"font-bold\">{{params.ambitoTariffario.id.code}}</span><six-lookup ng-model=\"params.ambitoTariffario\" sx-type=\"\'ambitotariffario\'\" sx-field=\"\'id\'\" sx-show-description=\"false\" sx-disabled=\"\'true\'\"></six-lookup></div></div><div class=\"row\"><div class=\"col-md-3\">Classe misuratore: <input type=\"text\" class=\"form-control\" ng-model=\"params.classeMisuratore\"></div><div class=\"col-md-3\">Regime fiscale: <span class=\"font-bold\">{{params.regimeFiscale.id.code}}</span><six-lookup ng-model=\"params.regimeFiscale\" sx-type=\"\'regimefiscale\'\" sx-field=\"\'id\'\" sx-show-description=\"false\"></six-lookup></div><div class=\"col-md-3\">Tipologia cliente: <span class=\"font-bold\">{{params.tipologiaCliente.id.code}}</span><six-lookup ng-model=\"params.tipologiaCliente\" sx-type=\"\'tipologiacliente\'\" sx-field=\"\'id\'\" sx-show-description=\"false\"></six-lookup></div><div class=\"col-md-3\">Delibera AEEG: <span class=\"font-bold\">{{params.deliberaAEEG.code}}</span><six-select ng-model=\"params.deliberaAEEG\" sx-item-list=\"deliberaEEGList\" sx-show-description=\"false\"></six-select></div></div><div class=\"row\"><div class=\"col-md-3\">PCS std.:<input type=\"number\" class=\"form-control\" ng-model=\"params.pcsStd\" step=\"0.0001\"></div><div class=\"col-md-3\">PCS:<input type=\"number\" class=\"form-control\" ng-model=\"params.pcsSim\" step=\"0.0001\"></div></div><div class=\"row\"><div class=\"col-md-3\">Cg:<div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"params.cg\" step=\"0.000001\" required=\"\"> <span class=\"input-group-addon\">m<sup>3</sup>/gg</span></div></div><div class=\"col-md-3\">D:<div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"params.d\" step=\"0.000001\" required=\"\"> <span class=\"input-group-addon\">m</span></div></div><div class=\"col-md-3\">TF:<div class=\"input-group\"><input type=\"number\" name=\"tf\" class=\"form-control\" ng-model=\"params.tf\" step=\"0.000001\" required=\"\" readonly=\"\"> <span class=\"input-group-addon\">€/PDR/Mese</span></div></div></div><div class=\"row\"><div class=\"col-md-3\" ng-if=\"params.algorithmType.code!==\'fisso\'\">Spread:<div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"params.spread\" step=\"0.000001\"> <span class=\"input-group-addon\">c€/SMC</span></div></div><div class=\"col-md-3\" ng-if=\"params.algorithmType.code===\'fisso\'\">Fisso:<div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"params.fisso\" step=\"0.000001\"> <span class=\"input-group-addon\">c€/SMC</span></div></div></div><div class=\"row wrapper\">Consumi [SMC]:<table><tr><td ng-repeat=\"month in getMonths()\">{{getMonthName(month)}}</td></tr><tr><td ng-repeat=\"month in getMonths()\"><input type=\"number\" class=\"form-control\" ng-model=\"params.consumptions[month]\" step=\"0.0001\"></td></tr></table></div></div></div></div></div></div><div class=\"panel\"><div class=\"row panel-body\"><h1 class=\"m-b m-t font-thin h3 text-black\">Risultati simulazione:</h1><div class=\"row wrapper\">UM: <span class=\"font-bold well well-sm\">{{um}}</span> <button type=\"button\" class=\"btn btn-sm pull-right\" ng-click=\"simulate()\"><span class=\"fa fa-gear\"></span> Simula</button></div><div id=\"grid1\" ui-grid=\"gridOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 460px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div><div class=\"row panel-body\"><h1 class=\"m-b m-t font-thin h3 text-black\">Configurazioni salvate:</h1><div id=\"gridList\" ui-grid=\"listGridOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 350px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div><div class=\"row panel-body\"><h1 class=\"m-b m-t font-thin h3 text-black\">Listini salvati:</h1><div id=\"grid2\" ui-grid=\"priceListGridOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 350px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div></div></div></div></div></form>");
$templateCache.put("energy/readtemplate/readtemplate.html","<style type=\"text/css\">\n  .insert_padding {\n    padding: 15px;\n  }\n\n  .dimesion_grid{\n    height: 240px;\n  }\n\n  .readingsButton{\n      width:130px;\n      margin-left: 20px;\n  }\n</style><div class=\"col-md-12 override-padding-15-px\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-12 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">STAMPA LETTURE</h1></div></div></div><div class=\"panel-body\"><div class=\"col-md-12\"><div class=\"col-md-4\"><label id=\"contatoreId_label\" for=\"schema\" class=\"control-label\">Tipo</label><six-lookup id=\"schema\" ng-model=\"entity\" sx-field=\"\'type\'\" sx-base-path=\"\'schema\'\"></six-lookup></div><div class=\"col-md-3\"><label id=\"month_label\" for=\"month\" class=\"control-label\">Mese</label><six-month-picker id=\"month\" ng-model=\"month\" class=\"input-group\"></six-month-picker></div><div class=\"col-md-3\"><label id=\"year_label\" for=\"year\" class=\"control-label\">Anno</label><six-year-picker id=\"year\" ng-model=\"year\" class=\"input-group\"></six-year-picker></div><div class=\"col-md-12\"><hr></div><div class=\"row\"><div class=\"col-md-12\"><div ui-grid=\"gridOptions\" ui-grid-selection=\"\" ui-grid-exporter=\"\" class=\"grid dimesion_grid\"></div></div><div class=\"col-md-12 insert_padding\"><button ng-click=\"addToExportGridOptions()\" ng-disabled=\"gridApi.selection.getSelectedRows().length == 0\" class=\"btn btn-success pull-right control-label readingsButton\"><i class=\"fa fa-plus\"></i> Aggiungi righe</button> <button ng-click=\"clearGridOptions()\" ng-disabled=\"data.length == 0\" class=\"btn btn-danger pull-right control-label readingsButton\"><i class=\"fa fa-times\"></i> Svuota tabella</button></div><div class=\"col-md-3\"><label id=\"export_label\" for=\"schema\" class=\"control-label form-group\">Tabella per importazione Excel</label></div><div class=\"col-md-12\"><div ui-grid=\"exportGridOptions\" ui-grid-selection=\"\" ui-grid-exporter=\"\" class=\"grid dimesion_grid\"></div></div><div class=\"col-md-12 insert_padding\"><button ng-click=\"exportXLSX()\" ng-disabled=\"dataExport.length == 0\" class=\"btn btn-success pull-right control-label readingsButton\"><i class=\"fa fa-download\"></i> Esporta</button> <button ng-click=\"clearExportGridOptions()\" ng-disabled=\"dataExport.length == 0\" class=\"btn btn-danger pull-right control-label readingsButton\"><i class=\"fa fa-times\"></i> Svuota tabella</button></div></div></div></div></div></div>");
$templateCache.put("energy/updateregistrationnumber/updateregistrationnumber.html","<div class=\"col-md-12 pad-t-15\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Wizard cambio matricola contatore</h1></div></div></div><div class=\"col-md-12 panel panel-default panel-body\"><div class=\"wrapper-md\"><uib-tabset class=\"tab-container\"><uib-tab index=\"1\"><uib-tab-heading>Step 1</uib-tab-heading><h4>Dati Base</h4><form name=\"step1\" class=\"form-validation\"><p class=\"m-t\">Tipo:</p><six-lookup id=\"record_type\" sx-base-path=\"\'schema\'\" ng-model=\"record\" sx-field=\"\'type_id\'\"></six-lookup><p class=\"m-t\">Contatore:</p><six-lookup id=\"record_id\" ng-model=\"record\" sx-type=\"record.type_id.UUID\" sx-field=\"\'record_id\'\"></six-lookup><div class=\"m-t m-b\" ng-if=\"updates.record_id.type == \'contatoregas\'\"><p class=\"m-t\">Matricola:</p><input name=\"code\" class=\"form-control\" ng-model=\"updates.contatore.model.matricola\" required=\"\"></div><div class=\"m-t m-b\" ng-if=\"updates.record_id.type == \'contatoreacqua\' || updates.record_id.type == \'contatoreelettricita\' || updates.record_id.type == \'contatoreteleriscaldamento\' || updates.record_id.type == \'contatoreteleraffreddamento\'\"><p class=\"m-t\">Matricola:</p><input name=\"code\" class=\"form-control\" ng-model=\"updates.contatore.model.code\" required=\"\"></div><div class=\"m-t m-b\" ng-if=\"updates.contatore.model.description != undefined\"><p class=\"m-t\">Descrizione:</p><input name=\"description\" placeholder=\"\" class=\"form-control\" ng-model=\"updates.contatore.model.description\" disabled=\"\"></div></form></uib-tab><uib-tab index=\"2\"><uib-tab-heading>Step 2</uib-tab-heading><form name=\"step2\" class=\"form-validation\"><div class=\"m-t\"><label id=\"date_label\" class=\"control-label\">Data di cambio</label> <input class=\"form-control\" type=\"date\" ng-model=\"date.changingDate\"></div><div class=\"m-t\" ng-if=\"updates.record_id.type == undefined || updates.contatore.model == undefined\"><p>Nessun contatore selezionato</p></div><hr><div class=\"m-t\" ng-if=\"updates.record_id.type == \'contatoregas\'\"><p>Lettura vecchio contatore alla data di cambio:</p><input type=\"number\" step=\"any\" name=\"readOldLettura\" class=\"form-control\" ng-model=\"reads.readOld.lettura\" ng-required=\"updates.record_id.type == \'contatoregas\'\"><p ng-if=\"updates.contatore.model.correttore == false\">Correttore vecchio contatore:</p><p ng-if=\"updates.contatore.model.correttore == true\">Correttore vecchio contatore: (correttore obbligatorio)</p><input type=\"number\" step=\"any\" name=\"readOldCorrettore\" class=\"form-control\" ng-model=\"reads.readOld.correttore\" ng-required=\"updates.contatore.model.correttore == true\"><hr><p>Lettura nuovo contatore alla data di cambio:</p><input type=\"number\" step=\"any\" name=\"readNewLettura\" class=\"form-control\" ng-model=\"reads.readNew.lettura\" ng-required=\"updates.record_id.type == \'contatoregas\'\"><p ng-if=\"updates.contatore.model.correttore == false\">Correttore nuovo contatore:</p><p ng-if=\"updates.contatore.model.correttore == true\">Correttore nuovo contatore: (correttore obbligatorio)</p><input type=\"number\" step=\"any\" name=\"readNewCorrettore\" class=\"form-control\" ng-model=\"reads.readNew.correttore\" ng-required=\"updates.contatore.model.correttore == true\"></div><div class=\"m-t\" ng-if=\"updates.record_id.type == \'contatoreelettricita\'\"><p>Lettura vecchio contatore alla data di cambio:</p><p>Fascia 0:</p><input type=\"number\" step=\"any\" name=\"readOldLetturaF0\" class=\"form-control col-md-6\" ng-model=\"reads.readOld.lettura.f0\"><p>Fascia 1:</p><input type=\"number\" step=\"any\" name=\"readOldLetturaF1\" class=\"form-control col-md-6\" ng-model=\"reads.readOld.lettura.f1\"><p>Fascia 2:</p><input type=\"number\" step=\"any\" name=\"readOldLetturaF2\" class=\"form-control col-md-6\" ng-model=\"reads.readOld.lettura.f2\"><p>Fascia 3:</p><input type=\"number\" step=\"any\" name=\"readOldLetturaF3\" class=\"form-control col-md-6\" ng-model=\"reads.readOld.lettura.f3\"><hr><p>Lettura nuovo contatore alla data di cambio:</p><p>Fascia 0:</p><input type=\"number\" step=\"any\" name=\"readNewLetturaF0\" class=\"form-control col-md-6\" ng-model=\"reads.readNew.lettura.f0\"><p>Fascia 1:</p><input type=\"number\" step=\"any\" name=\"readNewLetturaF1\" class=\"form-control col-md-6\" ng-model=\"reads.readNew.lettura.f1\"><p>Fascia 2:</p><input type=\"number\" step=\"any\" name=\"readNewLetturaF2\" class=\"form-control col-md-6\" ng-model=\"reads.readNew.lettura.f2\"><p>Fascia 3:</p><input type=\"number\" step=\"any\" name=\"readNewLetturaF3\" class=\"form-control col-md-6\" ng-model=\"reads.readNew.lettura.f3\"></div><div class=\"m-t\" ng-if=\"updates.record_id.type == \'contatoreteleriscaldamento\' || updates.record_id.type == \'contatoreteleraffreddamento\'\"><p>Lettura vecchio contatore alla data di cambio:</p><input type=\"number\" step=\"any\" name=\"readOldLettura\" class=\"form-control\" ng-model=\"reads.readOld.lettura\" ng-required=\"updates.record_id.type == \'contatoreteleriscaldamento\' || updates.record_id.type == \'contatoreteleraffreddamento\'\"><hr><p>Lettura nuovo contatore alla data di cambio:</p><input type=\"number\" step=\"any\" name=\"readNewLettura\" class=\"form-control\" ng-model=\"reads.readNew.lettura\" ng-required=\"updates.record_id.type == \'contatoreteleriscaldamento\' || updates.record_id.type == \'contatoreteleraffreddamento\'\"></div></form></uib-tab><uib-tab index=\"3\"><uib-tab-heading>Step 3</uib-tab-heading><div ng-if=\"updates.record_id.type != undefined && updates.contatore.model != undefined && allDataInserted()\"><p class=\"m-b\">Tutte le informazioni necessarie sono state inserite.</p><p>Premere \"Procedi\" per completare la procedura di modifica.</p><div class=\"m-t m-b\"><button type=\"button\" class=\"btn btn-default btn-rounded\" ng-click=\"update()\">Procedi</button></div></div><div ng-if=\"updates.record_id.type == undefined || updates.contatore.model == undefined || !allDataInserted()\"><p class=\"m-b\">Non è possibile concludere l\'operazione in quanto non sono state inserite tutte le informazioni necessarie.</p></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("energy/zonatermica/zonatermica_detail.html","<style type=\"text/css\">\n  .form-group{\n    margin-bottom: 5px;\n  }\n\n  .dayHeader {\n    -webkit-transform: rotate(300deg);\n    -moz-transform: rotate(300deg);\n    -o-transform: rotate(300deg);\n    text-align: center;\n  }\n\n  .label-zt {\n    font-weight:bold;\n  }\n\n  .height-zt {\n    height: 80px;\n  }\n</style><script type=\"text/ng-template\" id=\"recordInfoTemplate.html\"><strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">INFO</h4></div> <div class=\"row m-t\"> <table align=\"center\" style=\"text-align: left;\"> <caption style=\"text-align: right; font-weight: bold\">Record</caption> <tr><td style=\"text-align: right; font-weight: bold\">Model code:</td><td style=\"padding-left: 5px\">{{record.model.code}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">UUID:</td><td style=\"padding-left: 5px\">{{record.UUID}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">version:</td><td style=\"padding-left: 5px\">{{record.version}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">creationDate:</td><td style=\"padding-left: 5px\">{{record.creationDate}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">dataIn:</td><td style=\"padding-left: 5px\">{{record.dataIn}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">dataOut:</td><td style=\"padding-left: 5px\">{{record.dataOut}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">commission:</td><td style=\"padding-left: 5px\">{{record.commission}}</td></tr> </table> <table align=\"center\" style=\"text-align: left;\"> <caption style=\"text-align: right; font-weight: bold\">Schema</caption> <tr><td style=\"text-align: right; font-weight: bold\">Model code:</td><td style=\"padding-left: 5px\">{{schema.code}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">UUID:</td><td style=\"padding-left: 5px\">{{schema.UUID}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">version:</td><td style=\"padding-left: 5px\">{{schema.version}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">creationDate:</td><td style=\"padding-left: 5px\">{{schema.creationDate}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">dataIn:</td><td style=\"padding-left: 5px\">{{schema.dataIn}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">dataOut:</td><td style=\"padding-left: 5px\">{{schema.dataOut}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">commission:</td><td style=\"padding-left: 5px\">{{schema.commission}}</td></tr> </table> </div></script><six-toolbar ng-if=\"showDetailView\"><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"onSubmit(detailForm)\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" sx-disabled=\"isDeletePermAllowed()===false\" toolbar-function=\"deleteWithDialog(type.selected.version)\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\" xmlns=\"http://www.w3.org/1999/html\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">{{typeDescription}} <a href=\"\" ng-click=\"showRecordInfo()\" class=\"m-l\"><i class=\"fa fa-info\"></i></a></h1><small>{{type.selected.model.code}} - {{type.selected.model.description}}</small></div></div></div><div class=\"panel-body\"><div collapse=\"!isCollapsed\" class=\"form-group .margin_bottom\" ng-class=\"{\'col-md-8\': showTimeline}\"><form name=\"detailForm\" ng-submit=\"onSubmit(detailForm)\"><div ng-repeat=\"items in form[0].items\"><div ng-repeat=\"tabs in items.tabs\"><div ng-repeat=\"model_items in tabs.items\"><div ng-if=\"model_items.type !== \'array\'\" ng-init=\"iter = iter + 1\"><div class=\"form-group col-md-4 height-zt\" ng-if=\"(\'sixlookup\' !== model_items.type) && (\'temp_giorn_medie\' !== model_items.key)\"><label class=\"control-label label-zt\" ng-if=\"\'temp_giorn_medie\' !== model_items.key[0]\">{{model_items.title}}</label><div class=\"input-group\"><span class=\"input-group-addon\" id=\"sizing-addon\" ng-if=\"model_items.fieldAddonLeft\">m</span> <input class=\"form-control\" ng-disabled=\"!disableModify\" type=\"{{model_items.type}}\" step=\"any\" ng-model=\"model[model_items.key[0]]\" ng-if=\"\'temp_giorn_medie\' !== model_items.key[0]\" aria-describedby=\"sizing-addon\" ng-change=\"boolUpdate(model_items)\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"disableModify=!disableModify\"><i class=\"fa fa-pencil\"></i></button></span></div><div>{{dataPrint(model_items.key[0])}}</div></div><div class=\"form-group col-md-4 height-zt\" ng-if=\"\'sixlookup\' == model_items.type && model_items.entity_id != \'comune\'\"><label class=\"control-label label-zt\">{{model_items.title}}</label><six-lookup ng-model=\"model\" sx-type=\"model_items.entity_id\" sx-field=\"model_items.key[0]\"></six-lookup></div><div class=\"form-group col-md-4 height-zt\" ng-if=\"\'sixlookup\' == model_items.type && model_items.entity_id == \'comune\'\"><label class=\"control-label label-zt\">{{model_items.title}}</label><six-lookup ng-model=\"model\" sx-type=\"model_items.entity_id\" sx-field=\"model_items.key[0]\" sx-object=\"comune\"></six-lookup></div></div></div></div></div><div class=\"form-group col-md-4 height-zt\"><label class=\"control-label label-zt\" for=\"zonaClimaticaLabel\">Zona Climatica (dal comune)</label> <input id=\"zonaClimaticaLabel\" disabled=\"\" class=\"form-control\" type=\"{{comune.model.zona_climatica_id.type}}\" ng-model=\"comune.model.zona_climatica_id.description\"></div><div class=\"form-group col-md-4 height-zt\"><label class=\"control-label label-zt\" for=\"gradVerticaleLabel\">Gradiente verticale Temp. (dalla provincia)</label> <input id=\"gradVerticaleLabel\" disabled=\"\" class=\"form-control\" type=\"{{provincia.model.gradiente_vert_temp.type}}\" ng-model=\"provincia.model.gradiente_vert_temp\"></div><uib-tabset class=\"col-md-12 hr-margin-t\"><div class=\"pull-right\"><button type=\"button\" ng-if=\"typeName == \'zonatermica\'\" class=\"btn btn-info btn-sm\" ng-click=\"calculateTempFromProv()\" ng-disabled=\"isWritePermAllowed()===false\"><i class=\"fa fa-gears\">Ricalcola</i></button></div><uib-tab><uib-tab-heading><label style=\"font-weight:bold\" class=\"control-label\">Temperature Giornaliere Medie</label></uib-tab-heading><div id=\"ddTable\"><div><form name=\"myForm\"><table style=\"width:100%;\" class=\"dd-table\"><thead><tr style=\"height: 80px; text-align: center; border-bottom: 1px solid lightblue\"><th>Mesi</th><th ng-repeat=\"d in getTimes(12) track by $index\" class=\"dayHeader\"><div>{{getMonthName($index)}}</div></th></tr></thead><tbody><tr style=\"height: 100px\"><td style=\"width: 100px;\"><table style=\"min-width: 140px; min-height: 46px;\"><td><div><div ng-if=\"editingMode == false\" style=\"text-align: right;\"><button ng-click=\"edit()\" ng-if=\"editingMode == false\" class=\"btn btn-default btn-sm\"><i class=\"fa fa-edit\"></i></button> Z. Termica [°C]:</div><div ng-if=\"editingMode == true\" style=\"text-align: right;\"><button ng-click=\"undo()\" ng-if=\"editingMode == true\" class=\"btn btn-default btn-sm\" style=\"min-width:60px\"><i class=\"fa fa-undo\"></i></button> <button ng-click=\"confirm()\" ng-if=\"editingMode == true\" class=\"btn btn-default btn-sm\" style=\"min-width:60px\"><i class=\"fa fa-check\"></i></button></div><div ng-if=\"provincia\" style=\"text-align: right;\">Provincia [°C]:</div></div></td></table></td><td ng-repeat=\"d in getTimes(12) track by $index\"><div style=\"width: 100%; text-align: center\"><input type=\"number\" step=\"any\" ng-model=\"model.temp_giorn_medie[$index].temp\" ng-disabled=\"editingMode == false\" style=\"width: 70%; text-align: center;\"></div><div ng-if=\"provincia\" class=\"control-label\" style=\"width: 100%; text-align: center\">{{mapProvTemp[$index].temp}}</div></td></tr></tbody></table></form></div></div></uib-tab></uib-tabset><div ng-repeat=\"alert in alerts\"><div class=\"alert alert-danger alert-dismissible\" role=\"alert\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button> <strong>Warning!</strong> {{alert.msg}}</div></div></form></div></div></div></div>");
$templateCache.put("energy/zonatermica/zonatermica_list.html","<style type=\"text/css\">\n  .form-group{\n    margin-bottom: 5px;\n  }\n\n  .dayHeader {\n    -webkit-transform: rotate(300deg);\n    -moz-transform: rotate(300deg);\n    -o-transform: rotate(300deg);\n    text-align: center;\n  }\n\n</style><six-toolbar ng-if=\"!showDetailView\"><six-toolbar-button label=\"Nuovo\" icon=\"fa fa-plus\" toolbar-function=\"new()\" id=\"btn_item_create\" sx-disabled=\"!isModelDefined || isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Check\" icon=\"fa fa-heartbeat\" toolbar-function=\"checkType()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\" xmlns=\"http://www.w3.org/1999/html\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">{{typeDescription}}</h1></div></div></div><div class=\"panel-body\"><div class=\"m-t-sm\"><six-grid-pagination get-data-callback=\"getType()\" get-list-callback=\"getType()\" items-list=\"type\" column-defs=\"viewGridOptions.columnDefs\" grid-app-callbacks=\"gridAppCallbacks\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div><div id=\"messages\" class=\"row m-t\" ng-if=\"messages.length\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-heading\"><div class=\"panel-title\"><button ng-click=\"tryFixAllProblems()\" type=\"button\" class=\"btn btn-default btn-sm pull-right\"><span class=\"fa fa-medkit\"></span> Fix all</button> Messaggi</div></div><div class=\"panel-body\"><div class=\"col-md-12\"><div id=\"gridReport\" ui-grid=\"reportGridOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\" ui-grid-move-columns=\"\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("ferri/autoclave-cycle-validation/autoclave-cycle-validation.html","<style>\n    .wrapper-md .icon {\n        float: right;\n        font-size: 30px;\n        margin: -6px;\n    }\n    .app:before {\n        background-color: #eceff4;\n    }\n    .app-content {\n        background-color: #eceff4;\n    }\n    .btn-dashboard {\n        padding: 30px;\n    }\n    .label-barcode {\n        float: left; \n        margin-right: 14px; \n        margin-top: 6px;\n    }\n</style><script type=\"text/ng-template\" id=\"helpTemplate.html\"><div class=\"text-base\"> <strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">{{ \"help\" | translate }}</h4></div> <div class=\"wrapper\"> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">{{ \"autoclave_cycle_validation.help_title\" | translate }}</h4></div> <p> {{ \"autoclave_cycle_validation.help_body1_1\" | translate }}<span class=\"font-bold\">{{ \"autoclave_cycle_validation.help_body1_2\" | translate }}</span> {{ \"autoclave_cycle_validation.help_body1_3\" | translate }} <ul> <li>{{ \"autoclave_cycle_validation.help_body1_li_1\" | translate }}</li> <li>{{ \"autoclave_cycle_validation.help_body1_li_2\" | translate }}</li> <li>{{ \"autoclave_cycle_validation.help_body1_li_3\" | translate }}</li> </ul> </p> <p> {{ \"autoclave_cycle_validation.help_body2_1\" | translate }} <span class=\"font-bold\">{{ \"autoclave_cycle_validation.help_body2_2\" | translate }}</span> {{ \"autoclave_cycle_validation.help_body2_3\" | translate }} <span class=\"font-bold\">{{ \"autoclave_cycle_validation.help_body2_4\" | translate }}</span> {{ \"autoclave_cycle_validation.help_body2_5\" | translate }} </p> <p> {{ \"autoclave_cycle_validation.help_body3_1\" | translate }} <span class=\"font-bold\">{{ \"autoclave_cycle_validation.help_body3_2\" | translate }}</span> {{ \"autoclave_cycle_validation.help_body3_3\" | translate }} (<span class=\"fa fa-search\"></span>). </p> </div></script><six-toolbar static-title=\"{{ \'autoclave_cycle_validation.autoclave-cycle-validation\' | translate }}\"><six-toolbar-button label=\"{{ \'exit\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"padder-md\"><div ng-if=\"showReport\"><div class=\"row\"><div class=\"col-md-3 col-md-offset-9\"><button class=\"btn btn-dashboard\" ng-click=\"reloadPage()\">{{ \"reload\" | translate }}</button></div></div><div class=\"row\" style=\"height:650px\"><six-iframe sx-report=\"\'production/modXM1123_afterValidation.rptdesign\'\" sx-params=\"reportParameters\"></six-iframe></div></div><div ng-hide=\"showReport\"><div class=\"row m-b\"><div class=\"col-md-3\"><label class=\"label-barcode\">{{ \"barcode\" | translate }}</label><six-code-reader sx-on-read=\"readCodeReader(read)\"></six-code-reader></div><div class=\"col-md-9 help\"><a href=\"\" ng-click=\"showHelpDialog()\"><i class=\"fa fa-question text-success-dker\"></i><span class=\"text-success-dker\">{{ \"help\" | translate }}</span></a></div></div><div class=\"row constructor\"><div class=\"col-md-12 fadeInUp\"><div class=\"widget widget-card\" style=\"display: block;\"><div class=\"panel\" ng-class=\"widgetClass\"><div class=\"panel-heading\"><div class=\"icon fa icon-doc\"></div>{{ \"autoclave_cycle_validation.autoclave-prod-order\" | translate }}</div><div class=\"panel panel-body no-padder\" style=\"min-height: 260px;\"><six-grid-pagination get-data-callback=\"loadProductionOrders()\" get-list-callback=\"loadProductionOrders()\" items-list=\"productionOrdersTableData\" column-defs=\"viewProductionOrdersGridOptions.columnDefs\" grid-options=\"viewProductionOrdersGridOptions\" params=\"viewProductionOrdersGridParams\"></six-grid-pagination></div></div></div></div><six-sidebar sx-id=\"detailPO\" class=\"\" sx-position=\"right\" sx-title=\"record.detail.currentProdOrderElement.code\" sx-dimension=\"l\" sx-opened=\"record.detail.showProdOrderDetail\" sx-pinnable=\"false\" sx-pinned=\"true\"><table class=\"table table-striped\"><thead><th>{{ \"barcode\" | translate }}</th><th>{{ \"product\" | translate }}</th></thead><tbody><tr ng-repeat=\"item in record.detail.currentProdOrderElementDetail\"><td class=\"{{getDetailRowStyleClass(item)}}\"><span>{{item.sk_barcode}}</span></td><td class=\"{{getDetailRowStyleClass(item)}}\"><span>{{item.product_code}}</span></td></tr></tbody></table></six-sidebar></div><div class=\"row\"><div class=\"col-md-4 animated fadeInUp\" ng-if=\"productionOrdersSelected.length>0 && hasAlreadyAutoclaveEquipmentAssociated == false\"><div class=\"widget widget-card\" style=\"display: block\"><div class=\"panel\" ng-class=\"widgetClass\"><div class=\"panel-heading\"><div class=\"icon icon1-autoclave\"></div>{{ \"autoclave_cycle_validation.autoclave-equipment\" | translate }}</div><div class=\"panel panel-body\" style=\"min-height: 260px;\"><div class=\"form-group\"><six-lookup ng-model=\"record.lookup.equipment_id\" sx-id=\"record.model.equipment_id\" sx-type=\"\'equipment\'\" sx-filter=\"filter.equipment\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-on-select=\"nextStepAfterEquipment()\" sx-on-clear=\"clearEquipmentLookup()\"></six-lookup></div></div></div></div></div><div class=\"col-md-4 animated fadeInUp\" ng-if=\"productionOrdersSelected.length>0 && record.model.equipment_id\"><div class=\"widget widget-card\" style=\"display: block;\"><div class=\"panel\" ng-class=\"widgetClass\"><div class=\"panel-heading\"><div class=\"icon icon1-sterilization\"></div>{{ \"autoclave_cycle_validation.validation\" | translate }}</div><div class=\"panel panel-body\"><div class=\"form-group\"><div class=\"col-md-12\"><button class=\"btn btn-dashboard {{isCompliant == true ? \'btn-active-success\' : \'\'}}\" ng-click=\"toggleConfirmCycleCompliant()\" ng-disabled=\"isOnlyBarcodeUse\">{{ \"autoclave_cycle_validation.button_cycle_compliant\" | translate }}</button></div><div class=\"col-md-12\"><button class=\"btn btn-dashboard {{isCompliant == false ? \'btn-active-error\' : \'\'}}\" ng-click=\"toggleConfirmCycleNotCompliant()\" ng-disabled=\"isOnlyBarcodeUse\">{{ \"autoclave_cycle_validation.button_cycle_not_compliant\" | translate }}</button></div></div></div></div></div></div></div></div></div></div><autoclave-cycle-validation-modal sx-on-confirm=\"confirmNotCompliantSterCycle(equipmentReason)\" sx-equipment-reason-filter=\"filter.equipment_reason_modal\" sx-msg=\"msgUnion\"></autoclave-cycle-validation-modal>");
$templateCache.put("ferri/dirtAcceptanceKit/dirtAcceptanceKit_list.html","<div class=\"page-title m-t-lg\"><h1 class=\"m-n font-thin\">{{localeMessages.function_title}}</h1></div><div class=\"wrapper-md\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3\"><label>Barcode</label><six-code-reader sx-on-read=\"readSerialKitCode(read)\" sx-read-mode=\"compReaderMode\"></six-code-reader></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">{{localeMessages.table_readkit_title}}</h1></div></div></div><div class=\"row\"><div class=\"col-md-12\"><six-grid-pagination get-data-callback=\"generateLatestSerialKitRead()\" get-list-callback=\"generateLatestSerialKitRead()\" items-list=\"serialKitsReadTableData\" column-defs=\"viewReadGridOptions.columnDefs\" grid-options=\"viewReadGridOptions\" params=\"viewReadGridParams\"></six-grid-pagination></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">{{localeMessages.table_consumedkit_title}}</h1></div></div></div><div class=\"row\"><div class=\"col-md-12\"><six-grid-pagination get-data-callback=\"generateConsumedKitsTableData()\" get-list-callback=\"generateConsumedKitsTableData()\" items-list=\"consumedKitsTableData\" column-defs=\"viewConsumedGridOptions.columnDefs\" grid-options=\"viewConsumedGridOptions\" params=\"viewConsumedGridParams\"></six-grid-pagination></div></div></div></div></div><div class=\"panel panel-default\"></div></div>");
$templateCache.put("ferri/washing-cycle-validation/washing-cycle-validation.html","<style>\n    .wrapper-md .icon {\n        float: right;\n        font-size: 30px;\n        margin: -6px;\n    }\n    .app:before {\n        background-color: #eceff4;\n    }\n    .app-content {\n        background-color: #eceff4;\n    }\n    .btn-dashboard {\n        padding: 30px;\n    }\n    .label-barcode {\n        float: left; \n        margin-right: 14px; \n        margin-top: 6px;\n    }\n</style><six-toolbar><six-toolbar-button label=\"{{ \'exit\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button></six-toolbar><script type=\"text/ng-template\" id=\"helpTemplate.html\"><div class=\"text-base\"> <strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">{{ \"help\" | translate }}</h4></div> <div class=\"wrapper\"> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">{{ \"washing_cycle_validation.help_title\" | translate}}</h4></div> <p> {{ \"washing_cycle_validation.help_body1_1\" | translate}}<span class=\"font-bold\">{{ \"washing_cycle_validation.help_body1_2\" | translate}}</span> {{ \"washing_cycle_validation.help_body1_3\" | translate}} <ul> <li>{{ \"washing_cycle_validation.help_body1_li_1\" | translate}}</li> <li>{{ \"washing_cycle_validation.help_body1_li_2\" | translate}}</li> <li>{{ \"washing_cycle_validation.help_body1_li_3\" | translate}}</li> </ul> </p> <p> {{ \"washing_cycle_validation.help_body2_1\" | translate}} <span class=\"font-bold\">{{ \"washing_cycle_validation.help_body2_2\" | translate}}</span> {{ \"washing_cycle_validation.help_body2_3\" | translate}} <span class=\"font-bold\">{{ \"washing_cycle_validation.help_body2_4\" | translate}}</span> {{ \"washing_cycle_validation.help_body2_5\" | translate}} </p> <p> {{ \"washing_cycle_validation.help_body3_1\" | translate}} <span class=\"font-bold\">{{ \"washing_cycle_validation.help_body3_2\" | translate}}</span> {{ \"washing_cycle_validation.help_body3_3\" | translate}} (<span class=\"fa fa-search\"></span>). </p> </div></script><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"page-title m-t-md\"><div class=\"row constructor\"><div class=\"col-md-9\"><h1 class=\"m-n font-thin\">{{ \"washing_cycle_validation.washing-cycle-validation\" | translate }}</h1></div><div class=\"col-md-3 help\"><a href=\"\" ng-click=\"showHelpDialog()\"><i class=\"fa fa-question text-success-dker\"></i><span class=\"text-success-dker\">{{ \"help\" | translate }}</span></a></div></div></div><div class=\"wrapper-md\"><div ng-if=\"showReport\"><div class=\"row\"><div class=\"col-md-3 col-md-offset-9\"><button class=\"btn btn-dashboard\" ng-click=\"reloadPage()\">{{ \"back\" | translate }}</button></div></div><div class=\"row\" style=\"height:650px\"><six-iframe sx-report=\"\'production/modXM1122.rptdesign\'\" sx-params=\"reportParameters\"></six-iframe></div></div><div ng-hide=\"showReport\"><div class=\"row\"><div class=\"col-md-3 m-b m-l\"><label class=\"label-barcode\">{{ \"barcode\" | translate }}</label><six-code-reader sx-on-read=\"readCodeReader(read)\"></six-code-reader></div></div><div class=\"row constructor\"><div class=\"col-md-12 fadeInUp\"><div class=\"widget widget-card\" style=\"display: block;\"><div class=\"panel\" ng-class=\"widgetClass\"><div class=\"panel-heading\"><div class=\"icon fa icon-doc\"></div>{{ \"washing_cycle_validation.washing-prod-order\" | translate }}</div><div class=\"panel panel-body no-padder\" style=\"min-height: 260px;\"><six-grid-pagination get-data-callback=\"loadProductionOrders()\" get-list-callback=\"loadProductionOrders()\" items-list=\"productionOrdersTableData\" column-defs=\"viewProductionOrdersGridOptions.columnDefs\" grid-options=\"viewProductionOrdersGridOptions\" params=\"viewProductionOrdersGridParams\"></six-grid-pagination></div></div></div></div><six-sidebar sx-id=\"detailPO\" class=\"\" sx-position=\"right\" sx-title=\"record.detail.currentProdOrderElement.code\" sx-dimension=\"l\" sx-opened=\"record.detail.showProdOrderDetail\" sx-pinnable=\"false\" sx-pinned=\"true\"><table class=\"table table-striped\"><thead><th>{{ \"type\" | translate }}</th><th>{{ \"barcode\" | translate }}</th></thead><tbody><tr ng-repeat=\"item in record.detail.currentProdOrderElementDetail\"><td class=\"{{getDetailRowStyleClass(item)}}\"><span ng-if=\"isProdOrderWashTypeContainer()\">{{ \"washing_cycle_validation.table_detail_type_container\" | translate }}</span> <span ng-if=\"!isProdOrderWashTypeContainer() && item.imbco_barcode != null\">{{ \"washing_cycle_validation.table_detail_type_imb\" | translate }}</span> <span ng-if=\"!isProdOrderWashTypeContainer() && item.sk_barcode != null\">{{ \"washing_cycle_validation.table_detail_type_kit\" | translate }}</span></td><td class=\"{{getDetailRowStyleClass(item)}}\"><span ng-if=\"item.imbco_barcode != null\">{{item.imbco_barcode}}</span> <span ng-if=\"item.sk_barcode != null\">{{item.sk_barcode}}</span></td></tr></tbody></table></six-sidebar></div><div class=\"row\"><div class=\"col-md-4 animated fadeInUp\" ng-if=\"productionOrdersSelected.length>0 && hasAlreadyWashingEquipmentAssociated == false\"><div class=\"widget widget-card\" style=\"display: block\"><div class=\"panel\" ng-class=\"widgetClass\"><div class=\"panel-heading\"><div class=\"icon icon1-washing\"></div>{{ \"washing_cycle_validation.washing-equipment\" | translate }}</div><div class=\"panel panel-body\" style=\"min-height: 260px;\"><div class=\"form-group\"><six-lookup ng-model=\"record.lookup.equipment_id\" sx-id=\"record.model.equipment_id\" sx-type=\"\'equipment\'\" sx-filter=\"filter.equipment\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-on-select=\"nextStepAfterEquipment()\" sx-on-clear=\"clearEquipmentLookup()\"></six-lookup></div></div></div></div></div><div class=\"col-md-4 animated fadeInUp\" ng-if=\"productionOrdersSelected.length>0 && record.model.equipment_id\"><div class=\"widget widget-card\" style=\"display: block;\"><div class=\"panel\" ng-class=\"widgetClass\"><div class=\"panel-heading\"><div class=\"icon icon1-sterilization\"></div>{{ \"washing_cycle_validation.validation\" | translate }}</div><div class=\"panel panel-body\"><div class=\"form-group\"><div class=\"col-md-12\"><button class=\"btn btn-dashboard {{isCompliant == true ? \'btn-active-success\' : \'\'}}\" ng-click=\"toggleConfirmCycleCompliant()\" ng-disabled=\"isOnlyBarcodeUse\">{{ \"washing_cycle_validation.button_cycle_compliant\" | translate }}</button></div><div class=\"col-md-12\"><button class=\"btn btn-dashboard {{isCompliant == false ? \'btn-active-error\' : \'\'}}\" ng-click=\"toggleConfirmCycleNotCompliant()\" ng-disabled=\"isOnlyBarcodeUse\">{{ \"washing_cycle_validation.button_cycle_not_compliant\" | translate }}</button></div></div></div></div></div></div></div></div></div></div><washing-cycle-validation-modal sx-on-confirm=\"confirmNotCompliantWashingCycle(equipmentReason)\" sx-equipment-reason-filter=\"filter.equipment_reason_modal\" sx-msg=\"msgUnion\"></washing-cycle-validation-modal>");
$templateCache.put("icteggs/ageana/ageana.html","<six-toolbar><six-toolbar-button label=\"Indietro\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" ng-click=\"goBack()\"></six-toolbar-button><six-toolbar-button label=\"Crea documento\" ng-if=\"!isUserReadonly && !isProvvedimento\" btn-class=\"btn-primary\" icon=\"fa fa-file\" toolbar-function=\"initReportTemplate()\" sx-disabled=\"!contestazione.id || !lookup.dipendente.obj || isContReadonly\"></six-toolbar-button><six-toolbar-button label=\"Vai al provvedimento\" ng-if=\"!isProvvedimento && contestazione.protocolloprovvedimento\" btn-class=\"btn-warning\" icon=\"fa fa-external-link-square\" toolbar-function=\"goToProvv()\"></six-toolbar-button><six-toolbar-button label=\"Trasforma\" ng-if=\"!isProvvedimento && !isUserReadonly\" btn-class=\"btn-info\" icon=\"fa fa-check\" toolbar-function=\"transform()\" sx-disabled=\"isTransformBtnDisabled()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" ng-if=\"!isProvvedimento && !isUserReadonly\" btn-class=\"btn-danger\" icon=\"fa fa-times\" sx-disabled=\"!contestazione.id || isContReadonly\" toolbar-function=\"delete()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\"></six-toolbar-button></six-toolbar><div class=\"page-title override-padding-toolbar\"><h1 class=\"m-n font-thin\">{{pageTitle}} <span ng-if=\"waitDelete\" class=\"fa fa-refresh fa-spin\"></span></h1></div><div class=\"wrapper-md\"><div class=\"panel panel-default\"><div class=\"panel-body\"><uib-tabset justified=\"false\" active=\"activeTab\" class=\"tab-container\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"tab-heading\">Base</span></uib-tab-heading><div ng-include=\"\'icteggs/ageana/base.html\'\"></div></uib-tab><uib-tab index=\"1\"><uib-tab-heading><span class=\"tab-heading\">Soci</span></uib-tab-heading><div ng-include=\"\'icteggs/ageana/soci.html\'\"></div></uib-tab><uib-tab index=\"2\"><uib-tab-heading><span class=\"tab-heading\">Tipo liq.</span></uib-tab-heading><div ng-include=\"\'icteggs/ageana/tipoliq.html\'\"></div></uib-tab></uib-tabset></div></div></div><six-confirm-modal sx-title=\"modal.title\" sx-message=\"modal.message\" sx-on-confirm=\"modal.callback\"></six-confirm-modal>");
$templateCache.put("icteggs/ageana/base.html","<div class=\"row\"><div class=\"col lg-12\"><six-checkbox sx-label=\"Esclusiva\" sx-field=\"esc\" sx-model=\"agente\" sx-mapping=\"checkbox.esc\"></six-checkbox></div></div>");
$templateCache.put("icteggs/ageana/soci.html","");
$templateCache.put("icteggs/ageana/tipoliq.html","");
$templateCache.put("icteggs/tabnotestnd/tabnotestnd.html","<six-toolbar><six-toolbar-button label=\"Indietro\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-times\" sx-disabled=\"!record.id\" toolbar-function=\"delete()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\"></six-toolbar-button></six-toolbar><div class=\"page-title override-padding-toolbar\"><div class=\"pull-right\" ng-if=\"record\"><div class=\"pull-left\"><six-checkbox sx-label=\"Attivo\" sx-model=\"record\" sx-field=\"attivo\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"pull-left m-t-sm m-l-lg m-r-sm\" ng-if=\"record.attivo===\'N\'\"><label class=\"control-label\">Valido fino al</label></div><div class=\"pull-left\" ng-if=\"record.attivo===\'N\'\"><six-date-picker ng-model=\"record.valido\"></six-date-picker></div></div><h1 class=\"m-n font-thin\">Tabella note standard</h1></div><div class=\"wrapper-md\" ng-if=\"record\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Codice</label> <input class=\"form-control\" placeholder=\"Codice\" ng-model=\"record.codice\" type=\"text\" ng-readonly=\"record.id\"></div></div><div class=\"col-md-8\"><div class=\"form-group\"><label>Descrizione</label> <input class=\"form-control\" placeholder=\"Descrizione\" ng-model=\"record.descrizione\" type=\"text\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Note Standard</label><six-enum sx-model=\"record\" sx-field=\"tiponote\" sx-options=\"enum.tiponote\"></six-enum></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Lingua</label><six-lookup ng-model=\"lookup.linguaid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"record.linguaid\" sx-type=\"\'lingua\'\" sx-placeholder=\"Seleziona lingua...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Destinazione</label> <input class=\"form-control\" placeholder=\"Destinazione\" ng-model=\"record.destinazione\" type=\"text\"></div></div></div><hr><div class=\"row\"><div class=\"col-xs-2 col-xs-offset-4\">Visualizza</div><div class=\"col-xs-2\">Stampa</div><div class=\"col-xs-2\">Commenti</div><div class=\"col-xs-2\">Evidenzia</div></div><div class=\"row\"><div class=\"col-xs-4\">Preventivi</div><div class=\"col-xs-2\"><six-enum sx-model=\"record\" sx-field=\"dest01v\" sx-options=\"enum.visualizza\"></six-enum></div><div class=\"col-xs-2\"><six-checkbox sx-label=\"\" sx-model=\"record\" sx-field=\"dest01s\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"col-xs-2\"><six-checkbox sx-label=\"\" sx-model=\"record\" sx-field=\"dest01c\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"col-xs-2\"></div></div><div class=\"row\"><div class=\"col-xs-4\">Ordini clienti</div><div class=\"col-xs-2\"><six-enum sx-model=\"record\" sx-field=\"dest02v\" sx-options=\"enum.visualizza\"></six-enum></div><div class=\"col-xs-2\"><six-checkbox sx-label=\"\" sx-model=\"record\" sx-field=\"dest02s\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"col-xs-2\"><six-checkbox sx-label=\"\" sx-model=\"record\" sx-field=\"dest02c\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"col-xs-2\"></div></div><div class=\"row\"><div class=\"col-xs-4\">DDT</div><div class=\"col-xs-2\"><six-enum sx-model=\"record\" sx-field=\"dest03v\" sx-options=\"enum.visualizza\"></six-enum></div><div class=\"col-xs-2\"><six-checkbox sx-label=\"\" sx-model=\"record\" sx-field=\"dest03s\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"col-xs-2\"><six-checkbox sx-label=\"\" sx-model=\"record\" sx-field=\"dest03c\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"col-xs-2\"><six-checkbox sx-label=\"\" sx-model=\"record\" sx-field=\"dest03e\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div></div><div class=\"row\"><div class=\"col-xs-4\">Fatture</div><div class=\"col-xs-2\"><six-enum sx-model=\"record\" sx-field=\"dest04v\" sx-options=\"enum.visualizza\"></six-enum></div><div class=\"col-xs-2\"><six-checkbox sx-label=\"\" sx-model=\"record\" sx-field=\"dest04s\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"col-xs-2\"><six-checkbox sx-label=\"\" sx-model=\"record\" sx-field=\"dest04c\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"col-xs-2\"></div></div><div class=\"row\"><div class=\"col-xs-4\">Corrispettivi</div><div class=\"col-xs-2\"><six-enum sx-model=\"record\" sx-field=\"dest05v\" sx-options=\"enum.visualizza\"></six-enum></div><div class=\"col-xs-2\"><six-checkbox sx-label=\"\" sx-model=\"record\" sx-field=\"dest05s\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"col-xs-2\"><six-checkbox sx-label=\"\" sx-model=\"record\" sx-field=\"dest05c\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"col-xs-2\"></div></div><div class=\"row\"><div class=\"col-xs-4\">Vendite a banco</div><div class=\"col-xs-2\"><six-enum sx-model=\"record\" sx-field=\"dest06v\" sx-options=\"enum.visualizza\"></six-enum></div><div class=\"col-xs-2\"><six-checkbox sx-label=\"\" sx-model=\"record\" sx-field=\"dest06s\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"col-xs-2\"><six-checkbox sx-label=\"\" sx-model=\"record\" sx-field=\"dest06c\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"col-xs-2\"></div></div><div class=\"row\"><div class=\"col-xs-4\">Ordini fornitori</div><div class=\"col-xs-2\"><six-enum sx-model=\"record\" sx-field=\"dest08v\" sx-options=\"enum.visualizza\"></six-enum></div><div class=\"col-xs-2\"><six-checkbox sx-label=\"\" sx-model=\"record\" sx-field=\"dest08s\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"col-xs-2\"><six-checkbox sx-label=\"\" sx-model=\"record\" sx-field=\"dest08c\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"col-xs-2\"></div></div><div class=\"row\"><div class=\"col-xs-4\">Richieste di acquisto</div><div class=\"col-xs-2\"><six-enum sx-model=\"record\" sx-field=\"dest11v\" sx-options=\"enum.visualizza\"></six-enum></div><div class=\"col-xs-2\"><six-checkbox sx-label=\"\" sx-model=\"record\" sx-field=\"dest11s\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"col-xs-2\"><six-checkbox sx-label=\"\" sx-model=\"record\" sx-field=\"dest11c\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"col-xs-2\"></div></div><hr><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label>Note</label> <textarea class=\"form-control\" rows=\"4\" ng-model=\"record.nota\"></textarea></div></div></div></div></div></div>");
$templateCache.put("icteggs/taboperatori/adeline.html","<div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"panel-heading\">Detaglio</div><div class=\"row\"><div class=\"col col-lg-2\"><div class=\"form-group\"><button type=\"button\" class=\"btn btn-secondary\" ng-click=\"\">Adeline Ass. <i class=\"fa fa-cogs\" aria-hidden=\"true\"></i></button></div></div><div class=\"col col-lg-2\"><div class=\"form-group\"><button type=\"button\" class=\"btn btn-secondary\" ng-click=\"\">Adeline Cess. <i class=\"fa fa-cogs\" aria-hidden=\"true\"></i></button></div></div><div class=\"col col-lg-2\"><div class=\"form-group\"><button type=\"button\" class=\"btn btn-secondary\" ng-click=\"\">Adeline Pro. <i class=\"fa fa-cogs\" aria-hidden=\"true\"></i></button></div></div><div class=\"col col-lg-2\"><div class=\"form-group\"><button type=\"button\" class=\"btn btn-secondary\" ng-click=\"\">Adeline Transf. <i class=\"fa fa-cogs\" aria-hidden=\"true\"></i></button></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Comunicazione</label><six-lookup ng-model=\"lookup.comunicazioneadlid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.comunicazioneadlid\" sx-type=\"\'tabcomunicazioneadl\'\" sx-placeholder=\"Seleziona Comunicazione...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Tipolog.contr.</label><six-lookup ng-model=\"lookup.tipologiacontrid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.tipologiacontrid\" sx-type=\"\'tabtipologiacontrattuale\'\" sx-placeholder=\"Seleziona Tipologia...\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Qualifica prof.</label><six-lookup ng-model=\"lookup.qualificaprofadlid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.qualificaprofadlid\" sx-type=\"\'tabqualificaprofadl\'\" sx-placeholder=\"Seleziona qualifica...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Ente previdenziale.</label><six-lookup ng-model=\"lookup.enteprevidenzialeid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.enteprevidenzialeid\" sx-type=\"\'tabenteprevidenziale\'\" sx-placeholder=\"Seleziona ente previdenziale...\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Tipo trasf.</label><six-lookup ng-model=\"lookup.tipotrasfid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.tipotrasfid\" sx-type=\"\'tabtipotrasformazione\'\" sx-placeholder=\"Seleziona tipo trasf...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Agevolazioni</label><six-lookup ng-model=\"lookup.agevolazioniid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.agevolazioniid\" sx-type=\"\'tabagevolazioni\'\" sx-placeholder=\"Seleziona Agevolazioni...\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Agevolazioni2</label><six-lookup ng-model=\"lookup.agevolazioni2id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.agevolazioni2id\" sx-type=\"\'tabagevolazioni\'\" sx-placeholder=\"Seleziona agevolazioni2...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Agevolazioni3</label><six-lookup ng-model=\"lookup.agevolazioni3id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.agevolazioni3id\" sx-type=\"\'tabagevolazioni\'\" sx-placeholder=\"Seleziona agevolazioni3...\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Ass forza magg.</label><ui-select ng-model=\"uiselect.assunzioneforzamagg\" theme=\"bootstrap\" reset-search-input=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Scegli...\">{{uiselect.assunzioneforzamagg.label}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in uiselect.options track by $index\"><div ng-bind-html=\"item.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Distacco parz</label><ui-select ng-model=\"uiselect.distaccoparziale\" theme=\"bootstrap\" reset-search-input=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Scegli...\">{{uiselect.distaccoparziale.label}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in uiselect.options track by $index\"><div ng-bind-html=\"item.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Dist. az est.</label><ui-select ng-model=\"uiselect.distaccoazestero\" theme=\"bootstrap\" reset-search-input=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Scegli...\">{{uiselect.distaccoazestero.label}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in uiselect.options track by $index\"><div ng-bind-html=\"item.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Data trasf.</label><six-date-picker ng-model=\"operatore.datatrasformazione\"></six-date-picker></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><label>ATECO</label><six-lookup ng-model=\"lookup.codificaatecoid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.codificaatecoid\" sx-type=\"\'tabcodificheateco\'\" sx-placeholder=\"Seleziona ATECO...\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Compenso</label> <input type=\"text\" class=\"form-control\" placeholder=\"compenso\" ng-model=\"operatore.compenso\"></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><button type=\"button\" class=\"btn btn-warning\" ng-click=\"\">Calcola Compenso <i class=\"fa fa-cogs\" aria-hidden=\"true\"></i></button></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Luogo lav prec</label><six-lookup ng-model=\"lookup.luogolavprecadelineid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.luogolavprecadelineid\" sx-type=\"\'tabsottogruppooper\'\" sx-placeholder=\"Seleziona luogo precedente di lavoro...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Comune lav prec.</label><six-lookup ng-model=\"lookup.comunelavprecadelineid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.comunelavprecadelineid\" sx-type=\"\'tabcomuni\'\" sx-placeholder=\"Seleziona comune precedente...\" sx-relational=\"true\"></six-lookup></div></div></div><span class=\"pull-left\"><button type=\"button\" class=\"btn btn-info\" icon=\"fa fa-backward\" ng-click=\"goBack()\">Indietro <i class=\"fa fa-backward\" aria-hidden=\"true\"></i></button></span> <span class=\"pull-right\"><button type=\"button\" class=\"btn btn-success\">Avanti <i class=\"fa fa-forward\" aria-hidden=\"true\"></i></button></span></div></div>");
$templateCache.put("icteggs/taboperatori/allegati.html","<div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"panel panel-info\"><div class=\"panel-heading\">Allegati</div><div class=\"panel-body\"><div class=\"row\"></div></div></div><div class=\"panel panel-info\"><div class=\"panel-heading\">Comunicazioni</div><div class=\"panel-body\"></div></div></div></div>");
$templateCache.put("icteggs/taboperatori/cedolini.html","<div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"panel-heading\">Detaglio</div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Anno</label> <input type=\"text\" class=\"form-control\" placeholder=\"Anno\"></div></div></div></div></div>");
$templateCache.put("icteggs/taboperatori/dati.html","<div class=\"row\"><div class=\"col-md-6\"><div class=\"row\"><div class=\"col col-lg-4\"><six-checkbox sx-label=\"Attivo\" sx-model=\"operatore\" sx-field=\"attivo\" sx-mapping=\"checkbox.attivo\"></six-checkbox></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Data fine</label><six-date-picker ng-model=\"operatore.contrinvalidodal\"></six-date-picker></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Data ass</label><six-date-picker ng-model=\"operatore.contrassunzione\"></six-date-picker></div></div></div><div class=\"row\"><div class=\"col col-lg-12\"><div class=\"form-group\"><label>Cognome</label> <input type=\"text\" class=\"form-control\" placeholder=\"Cognome\" ng-model=\"operatore.cognome\"></div></div></div><div class=\"row\"><div class=\"col col-lg-12\"><div class=\"form-group\"><label>Nome</label> <input type=\"text\" class=\"form-control\" placeholder=\"Nome\" ng-model=\"operatore.nome\"></div></div></div><div class=\"row\"><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Nato il</label><six-date-picker ng-model=\"operatore.dtnascita\"></six-date-picker></div></div><div class=\"col col-lg-8\"><div class=\"form-group\"><label>In</label><six-lookup ng-model=\"lookup.nazionenascitaid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.nazionenascitaid\" sx-type=\"\'tabnaz\'\" sx-placeholder=\"Seleziona nazione di nascita...\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col col-lg-8\"><div class=\"form-group\"><label>Comune nascita</label><six-lookup ng-model=\"lookup.comunenascitaid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.comunenascitaid\" sx-type=\"\'tabcomuni\'\" sx-placeholder=\"Seleziona comune di nascita...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Cod stato</label> <input type=\"text\" class=\"form-control\" placeholder=\"codice\"></div></div></div><div class=\"row\"><div class=\"col col-lg-12\"><div class=\"form-group\"><label>Cittadinanza</label><six-lookup ng-model=\"lookup.nazionecittadinanzaid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.nazionecittadinanzaid\" sx-type=\"\'tabnaz\'\" sx-placeholder=\"Seleziona citadinanza...\" sx-relational=\"true\"></six-lookup></div></div></div></div><div class=\"col-md-6\"><center><img id=\"item-display\" ng-src=\"{{ \'default-avatar.png\' }}\" img-src-err=\"default-avatar.png\" alt=\"Avatar\"></center></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Sesso</label><six-enum sx-model=\"operatore\" sx-field=\"sesso\" sx-options=\"enum.sesso\"></six-enum></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><label>St civile</label><six-enum sx-model=\"operatore\" sx-field=\"statocivile\" sx-options=\"enum.statocivile\"></six-enum></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Codice fiscale</label> <input type=\"text\" class=\"form-control\" placeholder=\"Codice fiscale\" ng-model=\"operatore.codicefiscale\"></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Cod.Fisc. calc.</label> <input type=\"text\" class=\"form-control\" placeholder=\"Cod.Fisc. calc.\" ng-model=\"operatore.codicefiscalecalc\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"panel panel-info\" ng-hide=\"hide==2\"><div class=\"panel-heading\">Residenza</div><div class=\"panel-body\"><button type=\"button\" class=\"btn btn-primary pull-right\" icon=\"fa fa-pencil-square-o\" ng-click=\"hide=1\">Cambia residenza <i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></button><div class=\"row\"><div class=\"col col-lg-12\"><div class=\"form-group\"><label>Comune</label><six-lookup ng-model=\"lookup.comuneid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.comuneid\" sx-type=\"\'tabcomuni\'\" sx-placeholder=\"Seleziona comune ..\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col col-lg-12\"><div class=\"form-group\"><label>Indirizzo</label> <input type=\"text\" class=\"form-control\" placeholder=\"Indirizzo\" ng-model=\"operatore.indirizzo\"></div></div></div><div class=\"row\"><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Cap</label> <input type=\"text\" class=\"form-control\" placeholder=\"Cap\" ng-model=\"operatore.cap\"></div></div><div class=\"col col-lg-8\"><div class=\"form-group\"><label>Provincia</label><six-lookup ng-model=\"lookup.provid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.provid\" sx-type=\"\'tabprov\'\" sx-placeholder=\"Seleziona provincia...\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Scala</label> <input type=\"text\" class=\"form-control\" placeholder=\"Scala\" ng-model=\"operatore.scala\"></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Interno</label> <input type=\"text\" class=\"form-control\" placeholder=\"Interno\" ng-model=\"operatore.interno\"></div></div></div></div></div><div class=\"panel panel-info\" ng-show=\"hide==2\"><div class=\"panel-heading\">Storico domicilio</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col col-lg-12\"><div class=\"form-group\"><label>domicilio</label></div></div></div></div></div></div><div class=\"col-md-6\"><div class=\"panel panel-info\" ng-hide=\"hide==1\"><div class=\"panel-heading\">Domicilio</div><div class=\"panel-body\"><button type=\"button\" class=\"btn btn-primary pull-right\" icon=\"fa fa-pencil-square-o\" ng-click=\"hide=2\">Cambia Domicilio <i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></button><div class=\"row\"><div class=\"col col-lg-12\"><div class=\"form-group\"><label>Presso</label> <input type=\"text\" class=\"form-control\" placeholder=\"presso\" ng-model=\"operatore.presso\"></div></div></div><div class=\"row\"><div class=\"col col-lg-12\"><div class=\"form-group\"><label>Comune</label><six-lookup ng-model=\"lookup.comunedomid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.comunedomid\" sx-type=\"\'tabcomuni\'\" sx-placeholder=\"Seleziona comune ..\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col col-lg-12\"><div class=\"form-group\"><label>Indirizzo</label> <input type=\"text\" class=\"form-control\" placeholder=\"Indirizzo\" ng-model=\"operatore.indirizzodom\"></div></div></div><div class=\"row\"><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Cap</label> <input type=\"text\" class=\"form-control\" placeholder=\"Cap\" ng-model=\"operatore.capdom\"></div></div><div class=\"col col-lg-8\"><div class=\"form-group\"><label>Provincia</label><six-lookup ng-model=\"lookup.provdomid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.provdomid\" sx-type=\"\'tabprov\'\" sx-placeholder=\"Seleziona provincia...\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Scala</label> <input type=\"text\" class=\"form-control\" placeholder=\"Scala\" ng-model=\"operatore.scaladom\"></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Interno</label> <input type=\"text\" class=\"form-control\" placeholder=\"Interno\" ng-model=\"operatore.internodom\"></div></div></div></div></div><div class=\"panel panel-info\" ng-show=\"hide==1\"><div class=\"panel-heading\">Storico residenza</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col col-lg-12\"><div class=\"form-group\"><label>Residenza</label></div></div></div></div></div></div></div>");
$templateCache.put("icteggs/taboperatori/dati2.html","<div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Qualifica</label><six-lookup ng-model=\"lookup.qualificaid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.qualificaid\" sx-type=\"\'tabqualifiche\'\" sx-placeholder=\"Seleziona qualifica...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col col-lg-2\"><div class=\"form-group\"><label>Data Inizio</label><six-date-picker ng-model=\"operatore.datainizio\" sx-disabled=\"isProvvReadonly\"></six-date-picker></div></div><div class=\"col col-lg-2\"><div class=\"form-group\"><label>N.Badge</label> <input type=\"text\" class=\"form-control\" placeholder=\"N.badge\" ng-model=\"operatore.numerobadge\"></div></div><div class=\"col col-lg-2\"><div class=\"form-group\"><label>Matricola DBF</label> <input type=\"text\" class=\"form-control\" placeholder=\"Matricola\" ng-model=\"operatore.matricola\"></div></div></div><div class=\"row\"><div class=\"col col-lg-8\"><div class=\"form-group\"><label>Luogo di lavoro</label><six-lookup ng-model=\"lookup.tabaziendaid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.tabaziendaid\" sx-type=\"\'tabazienda\'\" sx-placeholder=\"Seleziona luogo...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Cod INPS</label> <input type=\"text\" class=\"form-control\" placeholder=\"codice INPS\" ng-model=\"operatore.codinps\"></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Comune</label><six-lookup ng-model=\"lookup.contrcomuneid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.contrcomuneid\" sx-type=\"\'tabcomuni\'\" sx-placeholder=\"Seleziona comune...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Provincia</label><six-lookup ng-model=\"lookup.contrprovinciaid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.contrprovinciaid\" sx-type=\"\'tabprov\'\" sx-placeholder=\"Seleziona provincia...\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Telefono</label> <input type=\"text\" class=\"form-control\" placeholder=\"Telefono\" ng-model=\"operatore.tel\"></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Cell.aziendale</label> <input type=\"text\" class=\"form-control\" placeholder=\"Cell aziendale\" ng-model=\"operatore.cell\"></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Cellulare</label> <input type=\"text\" class=\"form-control\" placeholder=\"Cellulare\" ng-model=\"operatore.tel2\"></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Email</label> <input type=\"text\" class=\"form-control\" placeholder=\"email\" ng-model=\"operatore.email\"></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Utente</label><six-lookup ng-model=\"lookup.utenteid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.utenteid\" sx-type=\"\'utenti\'\" sx-placeholder=\"Seleziona utente...\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Tipo scolarità</label><six-enum sx-model=\"operatore\" sx-field=\"tipoqualificasco\" sx-options=\"enum.tipoqualificasco\"></six-enum></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Scolarità</label> <input type=\"text\" class=\"form-control\" placeholder=\"scolarità\" ng-model=\"qualificasco\"></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Anno titolo</label> <input type=\"text\" class=\"form-control\" placeholder=\"anno\" ng-model=\"operatore.annotitolostudio\"></div></div></div><div class=\"panel panel-info\"><div class=\"panel-heading\">Raggruppamenti</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Divisione</label><six-lookup ng-model=\"lookup.divisionecommid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.divisionecommid\" sx-type=\"\'tabccosto\'\" sx-placeholder=\"Seleziona divisione ..\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col col-lg-2\"><div class=\"form-group\"><label>Data</label><six-date-picker></six-date-picker></div></div><div class=\"col col-lg-3 col-lg-offset-1\"><div class=\"form-group\"><six-checkbox sx-label=\"Costo individuale\" sx-model=\"operatore\" sx-field=\"costoindividuale\" sx-mapping=\"checkbox.costoindividuale\"></six-checkbox></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Area</label><six-lookup ng-model=\"lookup.areaid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.areaid\" sx-type=\"\'tabarea\'\" sx-placeholder=\"Seleziona area ..\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col col-lg-2\"><div class=\"form-group\"><label>Data</label><six-date-picker></six-date-picker></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Specializz</label><six-lookup ng-model=\"lookup.specializzazioneid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.specializzazioneid\" sx-type=\"\'tabspecializzazione\'\" sx-placeholder=\"Seleziona specializz ..\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col col-lg-8\"><div class=\"form-group\"><label>Filiale</label><six-lookup ng-model=\"lookup.contrfilialeid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.contrfilialeid\" sx-type=\"\'tabfiliale\'\" sx-placeholder=\"Seleziona filiale...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Tipo costo</label> <input type=\"text\" class=\"form-control\" placeholder=\"tipo costo\" ng-model=\"operatore.costo\"></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Zona op</label><six-lookup ng-model=\"lookup.settoreid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.settoreid\" sx-type=\"\'tabsettore\'\" sx-placeholder=\"Seleziona zona operativa...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col col-lg-2\"><div class=\"form-group\"><label>CCNL</label> <input type=\"text\" class=\"form-control\" placeholder=\"CCNL\"></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>CCNL</label> <input type=\"text\" class=\"form-control\" placeholder=\"CCNL\"></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12 col-sm-12 m-t\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div><span class=\"pull-right\"><button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first\" ng-click=\"removeItems()\" ng-show=\"!isSidebarOpened\" ng-disabled=\"taskActivities.length==0\"><span class=\"fa fa-times\"></span>Rimuovi</button> <button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first\" ng-click=\"closeSidebar($scope.sidebarIndex)\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-times\"></span>Annulla</button> <button class=\"btn btn-sm btn-default\" ng-click=\"selectAllRemCheck()\" ng-show=\"!isSidebarOpened\" title=\"Seleziona tutti\"><span class=\"fa fa-square m-r-none\"></span></button> <button class=\"btn btn-sm btn-default\" ng-click=\"unselectAllRemCheck()\" ng-show=\"!isSidebarOpened\" title=\"Deseleziona tutti\"><span class=\"fa fa-square-o m-r-none\"></span></button></span> <span class=\"pull-right\"><button class=\"btn btn-sm btn-default add-remove-button\" ng-click=\"selectSalario()\" ng-show=\"!isSidebarOpened\"><span class=\"fa fa-plus\"></span>Aggiungi</button> <button class=\"btn btn-sm btn-default add-remove-button\" ng-click=\"confirmSelectItems()\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-check\"></span>Conferma</button></span><h4 class=\"override-h4-no-margin\">Tipi salario</h4><hr class=\"m-t\"></div><div><div ng-if=\"tipiSalarioOperatore.length==0\" class=\"alert alert-info\">Nessun valore selezionato</div><div class=\"row\" ng-repeat=\"item in tipiSalarioOperatore\"><div class=\"col-md-8\"><label class=\"checkbox i-checks m-b\"><input type=\"checkbox\" ng-model=\"remCheckModel[$index]\"><i></i>{{item.codice}} - {{item.model.description}}</label></div><div class=\"col-md-4\"><six-date-picker ng-model=\"item.model.date\"></six-date-picker></div></div></div></div></div></div></div>");
$templateCache.put("icteggs/taboperatori/documenti.html","<div class=\"panel panel-info\"><div class=\"panel-heading\">Documenti</div><div class=\"panel-body\"><div class=\"table-responsive\"><table ng-if=\"documenti.list.length>0\" class=\"table\"><tr ng-repeat=\"item in documenti.list\"><td><button type=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"selectDocumenti(item)\"><i class=\"fa fa-folder-open-o\"></i></button></td><td><button type=\"button\" class=\"btn btn-danger btn-block\" ng-click=\"removeDocumenti(item)\"><i class=\"fa fa-trash-o\"></i></button></td><td><six-lookup ng-model=\"lookup.tipodocumentoid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"item.tipodocumentoid\" sx-type=\"\'tabtipodoc\'\" sx-placeholder=\"Seleziona tipo documento...\" sx-relational=\"true\"></six-lookup></td><td><six-enum sx-model=\"item\" sx-field=\"presentazione\" sx-options=\"enum.presentazione\"></six-enum></td><td><six-date-picker ng-model=\"item.datascapresentazione\" sx-disabled=\"isProvvReadonly\">f</six-date-picker></td></tr></table><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"addDocumenti()\"><i class=\"fa fa-plus\"></i> Aggiungi Nuovo</button></div></div></div>");
$templateCache.put("icteggs/taboperatori/indennita.html","<div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"panel panel-info\"><div class=\"panel-heading\">Benefit</div><div class=\"panel-body\"><div class=\"row\"></div></div></div><div class=\"panel panel-info\"><div class=\"panel-heading\">Indennità</div><div class=\"panel-body\"></div></div></div></div>");
$templateCache.put("icteggs/taboperatori/inquadramento.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"col col-lg-8\"><div class=\"form-group\"><label>Data inizio</label><six-date-picker ng-model=\"operatore.contriniziolavoro\"></six-date-picker></div></div></div><div class=\"row\"><div class=\"col col-lg-8\"><div class=\"form-group\"><label>Causale licenz</label><six-lookup ng-model=\"lookup.contrcausalelicenziamentoid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.contrcausalelicenziamentoid\" sx-type=\"\'tabcausalelicenz\'\" sx-placeholder=\"Seleziona causa licenz...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Data licenz</label><six-date-picker></six-date-picker></div></div></div><div class=\"row\"><div class=\"col col-lg-8\"><div class=\"form-group\"><label>Pos INAIL</label><six-lookup ng-model=\"lookup.posinailid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.posinailid\" sx-type=\"\'tabposizioneinail\'\" sx-placeholder=\"Seleziona pos INAIL...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Num</label> <input type=\"text\" class=\"form-control\" placeholder=\"num\"></div></div></div><div class=\"row\"><div class=\"col col-lg-8\"><div class=\"form-group\"><label>Pos INPS</label><six-lookup ng-model=\"lookup.posinpsid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.posinpsid\" sx-type=\"\'tabposizioneinps\'\" sx-placeholder=\"Seleziona pos INPS...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Num</label> <input type=\"text\" class=\"form-control\" placeholder=\"num\"></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Livello assunz</label><six-lookup ng-model=\"lookup.contrlivelloassunzioneid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.contrlivelloassunzioneid\" sx-type=\"\'tablivello\'\" sx-placeholder=\"Seleziona livello assunz...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Mansione</label><six-lookup ng-model=\"lookup.contrmansioniid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.contrmansioniid\" sx-type=\"\'tabmansioni\'\" sx-placeholder=\"Seleziona mansione...\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Tariffa oraria</label> <input type=\"text\" class=\"form-control\"></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Tariffa oraria</label> <input type=\"text\" class=\"form-control\" ng-model=\"operatore.tariffaorariaparticolare\"></div></div></div><div class=\"row\"><div class=\"col col-lg-2\"><div class=\"form-group\"><label>Durata per. prova</label> <input type=\"text\" class=\"form-control\" placeholder=\"numero\" ng-model=\"operatore.contrdurataperiodoprova\"></div></div><div class=\"col col-lg-2\"><div class=\"form-group\"><label>Scegli</label><six-enum sx-model=\"operatore\" sx-options=\"enum.contrtipodurataprova\" sx-field=\"contrtipodurataprova\"></six-enum></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Scadenza periodo prova</label><six-date-picker ng-model=\"operatore.contrdatascadenzaperiodoprova\"></six-date-picker></div></div><div class=\"col col-lg-2\"><div class=\"form-group\"><label>Lavoro per. prova</label> <input type=\"text\" class=\"form-control\" placeholder=\"numero\" ng-model=\"operatore.lavoroperiodoprova\"></div></div><div class=\"col col-lg-2\"><div class=\"form-group\"><label>Scegli</label><six-enum sx-model=\"operatore\" sx-field=\"duratalavoroperiodoprova\" sx-options=\"enum.duratalavoroperiodoprova\"></six-enum></div></div></div><div class=\"row\"><div class=\"col col-lg-2\"><div class=\"form-group\"><six-checkbox sx-label=\"Disabile\" sx-model=\"operatore\" sx-mapping=\"checkbox.contrdisabile\" sx-field=\"contrdisabile\"></six-checkbox></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Disabile Dal</label><six-date-picker ng-model=\"operatore.contrdisabiledal\"></six-date-picker></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Disabile al(%)</label> <input type=\"text\" class=\"form-control\" ng-model=\"operatore.contrdisabilepercent\"></div></div><div class=\"col col-lg-2\"><div class=\"form-group\"><six-checkbox sx-label=\"Tutele crescenti\" sx-model=\"operatore\" sx-mapping=\"checkbox.tutelecrescenti\" sx-field=\"tutelecrescenti\"></six-checkbox></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>L 68/99 Numero</label> <input type=\"text\" class=\"form-control\" placeholder=\"numerolegge\" ng-model=\"operatore.numerolegge6899\"></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><label>D.nulla osta</label><six-date-picker ng-model=\"operatore.dtnullaostalegge6899\"></six-date-picker></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Cda ammisione</label><six-date-picker ng-model=\"operatore.cdaammissione\"></six-date-picker></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Cda recesso</label><six-date-picker ng-model=\"operatore.cdarecesso\"></six-date-picker></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div><span class=\"pull-right\"><button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first\" ng-click=\"removeItems2()\" ng-show=\"!isSidebarOpened\" ng-disabled=\"taskActivities.length==0\"><span class=\"fa fa-times\"></span>Rimuovi</button> <button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first\" ng-click=\"closeSidebar()\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-times\"></span>Annulla</button> <button class=\"btn btn-sm btn-default\" ng-click=\"selectAllRemCheck()\" ng-show=\"!isSidebarOpened\" title=\"Seleziona tutti\"><span class=\"fa fa-square m-r-none\"></span></button> <button class=\"btn btn-sm btn-default\" ng-click=\"unselectAllRemCheck()\" ng-show=\"!isSidebarOpened\" title=\"Deseleziona tutti\"><span class=\"fa fa-square-o m-r-none\"></span></button></span> <span class=\"pull-right\"><button class=\"btn btn-sm btn-default add-remove-button\" ng-click=\"selectAssunzione()\" ng-show=\"!isSidebarOpened\"><span class=\"fa fa-plus\"></span>Aggiungi</button> <button class=\"btn btn-sm btn-default add-remove-button\" ng-click=\"confirmSelectItems2()\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-check\"></span>Conferma</button></span><h4 class=\"override-h4-no-margin\">Livello di assunzione</h4><hr class=\"m-t\"></div><div><div ng-if=\"tipiAssunzione.length==0\" class=\"alert alert-info\">Nessun livello</div><div class=\"row\" ng-repeat=\"item2 in tipiAssunzione\"><div class=\"col-md-4\"><label class=\"checkbox i-checks m-b\"><input type=\"checkbox\" ng-model=\"remCheckModel[$index]\"><i></i>{{item2.model.code}} - {{item2.model.description}}</label></div><div class=\"col-md-4\"><six-date-time-picker ng-model=\"item2.model.date\"></six-date-time-picker></div><div class=\"col-md-4\"><six-date-time-picker ng-model=\"item2.model.date\"></six-date-time-picker></div></div></div></div></div></div><div class=\"col-md-6\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><six-checkbox sx-label=\"Appr\" sx-model=\"operatore\" sx-mapping=\"checkbox.appr\" sx-field=\"appr\"></six-checkbox></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Data fine form.</label><six-date-picker ng-model=\"operatore.dtfineformazione\"></six-date-picker></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><six-checkbox sx-label=\"Mob\" sx-model=\"operatore\" sx-mapping=\"checkbox.mob\" sx-field=\"mob\"></six-checkbox></div></div><div class=\"col col-lg-5 col-lg-offset-1\"><div class=\"form-group\"><six-checkbox sx-label=\"Legge 407/90\" sx-model=\"operatore\" sx-mapping=\"checkbox.legge40790\" sx-field=\"legge40790\"></six-checkbox></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><six-checkbox sx-label=\"Pass. Dir.\" sx-model=\"operatore\" sx-mapping=\"checkbox.passdir\" sx-field=\"passdir\"></six-checkbox></div></div><div class=\"col col-lg-5 col-lg-offset-1\"><div class=\"form-group\"><six-checkbox sx-label=\"Legge 381\" sx-model=\"operatore\" sx-mapping=\"checkbox.legge381\" sx-field=\"legge381\"></six-checkbox></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Tipo retribuz.</label><six-enum sx-model=\"operatore\" sx-field=\"tiporetribuzione\" sx-options=\"enum.tiporetribuzione\"></six-enum></div></div><div class=\"col col-lg-5 col-lg-offset-1\"><div class=\"form-group\"><six-checkbox sx-label=\"Legge 190/14\" sx-model=\"operatore\" sx-mapping=\"checkbox.legge19014\" sx-field=\"legge19014\"></six-checkbox></div></div></div><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Invio cedolino</label><six-enum sx-model=\"operatore\" sx-field=\"inviocedolino\" sx-options=\"enum.inviocedolino\"></six-enum></div></div><div class=\"col col-lg-5 col-lg-offset-1\"><div class=\"form-group\"><six-checkbox sx-label=\"Legge 208/15\" sx-model=\"operatore\" sx-mapping=\"checkbox.legge20815\" sx-field=\"legge20815\"></six-checkbox></div></div></div></div></div></div></div>");
$templateCache.put("icteggs/taboperatori/inquadramento2.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-info\"><div class=\"panel-heading\">Dati familiari e detrazioni</div><div class=\"panel-body\"><div class=\"table-responsive\"><table ng-if=\"familiariDetrazioni.list.length>0\" class=\"table\"><tr ng-repeat=\"item in familiariDetrazioni.list\"><td><button type=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"selectFamiliariDetrazioni(item)\"><i class=\"fa fa-folder-open-o\"></i></button></td><td><button type=\"button\" class=\"btn btn-danger btn-block\" ng-click=\"removeFamiliariDetrazioni(item)\"><i class=\"fa fa-trash-o\"></i></button></td><td><button type=\"button\" title=\"Duplica il record\" class=\"btn btn-info btn-block\"><i class=\"fa fa-files-o\" aria-hidden=\"true\"></i></button></td><td><input type=\"text\" class=\"form-control\" placeholder=\"Anno competenza\" ng-model=\"item.annocompetenza\"></td><td><input type=\"date\" class=\"form-control\" placeholder=\"data\" ng-model=\"item.datainserimento\"></td><td><input type=\"text\" class=\"form-control\" placeholder=\"detr\" ng-model=\"item.detrazionedalavoro\"></td></tr></table><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"addFamiliariDetrazioni()\"><i class=\"fa fa-plus\"></i> Aggiungi</button></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-info\"><div class=\"panel-heading\">Vecchi contratti</div><div class=\"panel-body\"><div class=\"table-responsive\"><table ng-if=\"vecchiContratti.list.length>0\" class=\"table\"><tr ng-repeat=\"item in vecchiContratti.list\"><td><button type=\"button\" title=\"Elimina il documento\" class=\"btn btn-danger btn-block\" ng-click=\"removeVecchiContratti(item)\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i></button></td><td><six-enum sx-model=\"item\" sx-field=\"contrtipocontratto\" sx-options=\"enum.contrtipocontratto\"></six-enum></td><td><six-date-picker ng-model=\"item.contrdatainiziosca\" sx-disabled=\"isProvvReadonly\">inizio</six-date-picker></td><td><six-date-picker ng-model=\"item.contrdatafinesca\" sx-disabled=\"isProvvReadonly\">f</six-date-picker></td><td><input type=\"text\" class=\"form-control\" placeholder=\"Durata\" ng-model=\"item.contrdurata\"></td><td><input type=\"text\" class=\"form-control\" placeholder=\"Azienda\" ng-model=\"item.questaazienda\"></td><td><six-lookup ng-model=\"lookup.motivazione\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.motivazione\" sx-type=\"\'tabmotivazionescadcontratto\'\" sx-placeholder=\"Seleziona motivazione...\" sx-relational=\"true\"></six-lookup></td></tr></table><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"addVecchiContratti()\"><i class=\"fa fa-plus\"></i> Aggiungi Vecchi Contratti</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"saveVecchi()\"><i class=\"fa fa-save\"></i> Save Vecchi Contratti</button></div></div></div></div></div><div class=\"row\"><div class=\"col col-lg-12\"><div class=\"form-group\"><label>Note</label> <textarea class=\"form-control\" placeholder=\"Note\" ng-model=\"operatore.note\" ng-readonly=\"isUserReadonly\"></textarea></div></div></div><div class=\"row\"><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Data</label><six-date-picker></six-date-picker></div></div><div class=\"col col-lg-8\"><div class=\"form-group\"><label>Comporto</label> <input type=\"text\" class=\"form-control\" placeholder=\"\"></div></div></div>");
$templateCache.put("icteggs/taboperatori/orari.html","<div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"panel panel-info\"><div class=\"panel-heading\">Orario da contratto</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col col-lg-2\"><div class=\"form-group\"><label>Valido dal</label><six-date-picker></six-date-picker></div></div></div><div class=\"row\"><div class=\"col col-lg-2\"><div class=\"form-group\"><label>Valido al</label><six-date-picker ng-model=\"operatore.datacontrato1\" sx-disabled=\"isProvvReadonly\"></six-date-picker></div></div></div></div></div><div class=\"row\"><div class=\"col col-lg-8\"><div class=\"form-group\"><label>Tipo orario</label><six-enum sx-model=\"operatore\" sx-options=\"enum.tipoorario\" sx-field=\"tipoorario\"></six-enum></div></div><div class=\"col col-lg-3 col-lg-offset-1\"><div class=\"form-group\"><six-checkbox sx-label=\"Turnista\" sx-model=\"operatore\" sx-mapping=\"checkbox.turnista\" sx-field=\"turnista\"></six-checkbox></div></div></div><div class=\"panel panel-info\"><div class=\"panel-heading\">Turni di lavoro</div><div class=\"panel-body\"></div></div></div></div>");
$templateCache.put("icteggs/taboperatori/riferimbanc.html","<div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Tipo pagamento</label><six-lookup ng-model=\"lookup.tipopagamentoid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.tipopagamentoid\" sx-type=\"\'tabtipopag\'\" sx-placeholder=\"Seleziona tipo pagamento...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col col-lg-6\"><div class=\"form-group\"><label>Banca</label><six-lookup ng-model=\"lookup.bancaid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.bancaid\" sx-type=\"\'cganaban\'\" sx-placeholder=\"Seleziona banca...\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"panel panel-info\"><div class=\"panel-heading\">Dati bancari</div><div class=\"panel-body\"></div></div><div class=\"panel panel-info\"><div class=\"panel-heading\">Crediti</div><div class=\"panel-body\"></div></div></div></div>");
$templateCache.put("icteggs/taboperatori/sind.html","<div class=\"row\"><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Data scadenza scelta</label><six-date-picker ng-model=\"operatore.datascadenzatfr\"></six-date-picker></div></div><div class=\"col col-lg-3 col-lg-offset-1\"><div class=\"form-group\"><six-checkbox sx-label=\"Usuf.L.104\" sx-model=\"operatore\" sx-mapping=\"checkbox.usufruisce104\" sx-field=\"usufruisce104\"></six-checkbox></div></div><div class=\"col col-lg-4\"><div class=\"form-group\"><label>Causale.L.104</label><six-lookup ng-model=\"lookup.causale104id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.causale104id\" sx-type=\"\'calcau\'\" sx-placeholder=\"Seleziona causale...\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"panel panel-default\"><div class=\"panel-info\"><div class=\"panel-heading\">TFR</div><div class=\"panel-body\"><div class=\"row\"></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-info\"><div class=\"panel-heading\">Deleghe</div><div class=\"panel-body\"></div></div></div><div class=\"panel panel-default\"><div class=\"panel-info\"><div class=\"panel-heading\">Deleghe sindacato</div><div class=\"panel-body\"></div></div></div>");
$templateCache.put("icteggs/taboperatori/taboperatori.html","<six-toolbar ng-if=\"selMode===mode.DEFAULT\"><six-toolbar-button label=\"Indietro\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-times\" toolbar-function=\"deleteOperatore()\" sx-disabled=\"!operatore.id\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveOperatore()\"></six-toolbar-button></six-toolbar><six-toolbar ng-if=\"selMode==!mode.DEFAULT\"><six-toolbar-button label=\"Indietro\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" toolbar-function=\"backToOp()\"></six-toolbar-button></six-toolbar><div class=\"list-sidebar-overlay\"></div><aside id=\"list-sidebar\" class=\"list-sidebar list-sidebar-default list-sidebar-stacked custom-six-sidebar\" role=\"navigation\"><div ng-if=\"sidebarIndex===SIDEBAR.TIPO_SALARIO\"><div class=\"panel sidebar-panel\"><button class=\"btn btn-info pull-left\" ng-click=\"closeSidebar()\"><span class=\"fa fa-times icon-only\"></span></button> <button class=\"btn btn-info pull-right\" ng-click=\"confirmSelectItems(tipiSalarioSideFiltered)\"><span class=\"fa fa-check icon-only\"></span></button><div class=\"panel-heading bg-info sidebar-heading\">Tipo salario</div></div><ul class=\"nav list-sidebar-nav\"><li><div class=\"form-group m-l-xs m-r-xs m-t-xs\"><six-search-form ng-model=\"tipiSalarioFilter\" placeholder=\"Filtra...\" hide-search-btn=\"\"></six-search-form><span class=\"input-group-btn\"><button class=\"btn btn-default btn-sm\" title=\"Seleziona tutti\" style=\"width:50%\" ng-click=\"selectAllAddCheck()\"><i class=\"fa fa-square\"></i> Seleziona tutti</button> <button class=\"btn btn-default btn-sm\" title=\"Deseleziona tutti\" style=\"width:50%\" ng-click=\"unselectAllAddCheck()\"><i class=\"fa fa-square-o\"></i> Deseleziona tutti</button></span></div></li><li ng-show=\"(tipiSalarioSideList.length==0)\" style=\"text-align:center\"><span style=\"width:100%;\">Nessun <strong>Tipo salario</strong> trovato</span></li><li ng-repeat=\"item in tipiSalarioSideList | filter:tipiSalarioFilter as tipiSalarioSideFiltered\" class=\"m-l-xs m-r-xs\"><label class=\"checkbox i-checks m-b-sx\"><input type=\"checkbox\" ng-model=\"addCheckModel[$index]\"><i></i>{{item.codice}} - {{item.model.description}}</label></li></ul></div><div ng-if=\"sidebarIndex===SIDEBAR.LIVELLO_ASSUNZIONE\"><div class=\"panel sidebar-panel\"><button class=\"btn btn-info pull-left\" ng-click=\"closeSidebar()\"><span class=\"fa fa-times icon-only\"></span></button> <button class=\"btn btn-info pull-right\" ng-click=\"confirmSelectItems2(tipiAssunzioneSideFiltered)\"><span class=\"fa fa-check icon-only\"></span></button><div class=\"panel-heading bg-info sidebar-heading\">Tipo Assunzione</div></div><ul class=\"nav list-sidebar-nav\"><li><div class=\"form-group m-l-xs m-r-xs m-t-xs\"><six-search-form ng-model=\"tipiAssunzioneFilter\" placeholder=\"Filtra...\" hide-search-btn=\"\"></six-search-form><span class=\"input-group-btn\"><button class=\"btn btn-default btn-sm\" title=\"Seleziona tutti\" style=\"width:50%\" ng-click=\"selectAllAddCheck()\"><i class=\"fa fa-square\"></i> Seleziona tutti</button> <button class=\"btn btn-default btn-sm\" title=\"Deseleziona tutti\" style=\"width:50%\" ng-click=\"unselectAllAddCheck()\"><i class=\"fa fa-square-o\"></i> Deseleziona tutti</button></span></div></li><li ng-show=\"(tipiAssunzioneSideList.length==0)\" style=\"text-align:center\"><span style=\"width:100%;\">Nessun <strong>Tipo assunzione</strong> trovato</span></li><li ng-repeat=\"item2 in tipiAssunzioneSideList | filter:tipiAssunzioneFilter as tipiAssunzioneSideFiltered\" class=\"m-l-xs m-r-xs\"><label class=\"checkbox i-checks m-b-sx\"><input type=\"checkbox\" ng-model=\"addCheckModel[$index]\"><i></i>{{item2.codice}} - {{item2.model.description}}</label></li></ul></div></aside><div class=\"page-title override-padding-toolbar\"><h1 class=\"m-n font-thin\">{{pageTitle}} <span ng-if=\"waitDelete\" class=\"fa fa-refresh fa-spin\"></span></h1></div><div class=\"wrapper-md\"><div class=\"panel panel-default\" ng-if=\"mappingLoaded\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label>Codice</label> <input class=\"form-control\" placeholder=\"Codice\" ng-model=\"operatore.codice\" type=\"text\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Cognome</label> <input class=\"form-control\" placeholder=\"Cognome\" ng-model=\"operatore.cognome\" type=\"text\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Nome</label> <input class=\"form-control\" placeholder=\"Nome\" ng-model=\"operatore.nome\" type=\"text\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Data cambio</label><six-date-picker ng-model=\"datacambio\"></six-date-picker></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label>Gruppo</label><six-lookup ng-model=\"lookup.gruppoid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"operatore.gruppoid\" sx-type=\"\'tabgruppooperatore\'\" sx-placeholder=\"Seleziona gruppo...\" sx-relational=\"true\"></six-lookup></div></div></div></div></div><div class=\"panel panel-default\" ng-if=\"mappingLoaded\"><div class=\"panel-body\"><operatori-familiari-detr ng-if=\"selMode===mode.FAMILIARI_DETR\" sx-show=\"familiariDetrazioni.showDetail\" sx-operatore-id=\"operatore.id\" sx-model=\"familiariDetrazioni.selected\" sx-list=\"familiariDetrazioni.list\" sx-delete=\"familiariDetrazioni.delete\" sx-close-callback=\"onFamiliariDetrazioniClose()\" sx-modal=\"modal\"></operatori-familiari-detr><operatori-documenti ng-if=\"selMode===mode.DOCUMENTI_PAGE\" sx-show=\"documenti.showDetail\" sx-operatore-id=\"operatore.id\" sx-model=\"documenti.selected\" sx-list=\"documenti.list\" sx-delete=\"documenti.delete\" sx-close-callback=\"onDocumentiClose()\" sx-modal=\"modal\"></operatori-documenti><uib-tabset justified=\"false\" active=\"activeTab\" class=\"tab-container tab-no-border\" ng-if=\"selMode===mode.DEFAULT\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"tab-heading\">Dati {{showComp.familiariDetrazioni}}</span></uib-tab-heading><div ng-include=\"\'icteggs/taboperatori/dati.html\'\"></div></uib-tab><uib-tab index=\"1\"><uib-tab-heading><span class=\"tab-heading\">Dati2</span></uib-tab-heading><div ng-include=\"\'icteggs/taboperatori/dati2.html\'\"></div></uib-tab><uib-tab index=\"2\"><uib-tab-heading><span class=\"tab-heading\">Inquadr.</span></uib-tab-heading><div ng-include=\"\'icteggs/taboperatori/inquadramento.html\'\"></div></uib-tab><uib-tab index=\"3\"><uib-tab-heading><span class=\"tab-heading\">Inquadr. 2</span></uib-tab-heading><div ng-include=\"\'icteggs/taboperatori/inquadramento2.html\'\"></div></uib-tab><uib-tab index=\"4\"><uib-tab-heading><span class=\"tab-heading\">Documenti</span></uib-tab-heading><div ng-include=\"\'icteggs/taboperatori/documenti.html\'\"></div></uib-tab><uib-tab index=\"5\"><uib-tab-heading><span class=\"tab-heading\">Riferim. bancari</span></uib-tab-heading><div ng-include=\"\'icteggs/taboperatori/riferimbanc.html\'\"></div></uib-tab><uib-tab index=\"6\"><uib-tab-heading><span class=\"tab-heading\">Orari</span></uib-tab-heading><div ng-include=\"\'icteggs/taboperatori/orari.html\'\"></div></uib-tab><uib-tab index=\"7\"><uib-tab-heading><span class=\"tab-heading\">Allegati</span></uib-tab-heading><div ng-include=\"\'icteggs/taboperatori/allegati.html\'\"></div></uib-tab><uib-tab index=\"8\"><uib-tab-heading><span class=\"tab-heading\">Indennità</span></uib-tab-heading><div ng-include=\"\'icteggs/taboperatori/indennita.html\'\"></div></uib-tab><uib-tab index=\"9\"><uib-tab-heading><span class=\"tab-heading\">Sind.-104</span></uib-tab-heading><div ng-include=\"\'icteggs/taboperatori/sind.html\'\"></div></uib-tab></uib-tabset></div></div></div><six-confirm-modal sx-title=\"modal.title\" sx-message=\"modal.message\" sx-on-confirm=\"modal.callback\"></six-confirm-modal>");
$templateCache.put("icteggs/tabumconvt/tabumconvt.html","<six-toolbar><six-toolbar-button label=\"Indietro\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-times\" sx-disabled=\"!record.id\" toolbar-function=\"delete()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\"></six-toolbar-button></six-toolbar><div class=\"page-title override-padding-toolbar\"><h1 class=\"m-n font-thin\">Conversione unità di misura</h1></div><div class=\"wrapper-md\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label>Codice</label> <input class=\"form-control\" placeholder=\"Codice\" ng-model=\"record.codice\" type=\"text\" ng-readonly=\"record.id\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><hr class=\"m-t\"><h4 class=\"override-h4-no-margin\">Parametri di Conversione</h4><div class=\"row m-t\"><div class=\"col-md-3\"><label>UM1</label> <input class=\"form-control\" ng-model=\"um1\" type=\"text\"></div><div class=\"col-md-3\"><label>UM2</label> <input class=\"form-control\" ng-model=\"um2\" type=\"text\"></div><div class=\"col-md-3\"><label>Operazione</label><six-enum sx-model=\"enum\" sx-field=\"first\" sx-options=\"enum.ope\" sx-on-change=\"invertOpe(\'first\')\"></six-enum></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Coefficiente</label> <input class=\"form-control\" placeholder=\"Coefficiente\" ng-model=\"coeff\" type=\"number\" step=\"0.1\"></div></div></div><div class=\"row\"><div class=\"col-md-3\"><input class=\"form-control\" ng-model=\"um2\" type=\"text\"></div><div class=\"col-md-3\"><input class=\"form-control\" ng-model=\"um1\" type=\"text\"></div><div class=\"col-md-3\"><six-enum sx-model=\"enum\" sx-field=\"second\" sx-options=\"enum.ope\" sx-on-change=\"invertOpe(\'second\')\"></six-enum></div><div class=\"col-md-3\"><div class=\"form-group\"><input class=\"form-control\" placeholder=\"Coefficiente\" ng-model=\"coeff\" type=\"number\" step=\"0.1\"></div></div></div></div></div></div></div></div>");
$templateCache.put("icteggs/tabvet/tabvet.html","<six-toolbar><six-toolbar-button label=\"Indietro\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Modifica password\" btn-class=\"btn-warning\" icon=\"fa fa-lock\" toolbar-function=\"editPwd()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-times\" sx-disabled=\"!record.id\" toolbar-function=\"delete()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\"></six-toolbar-button></six-toolbar><div class=\"list-sidebar-overlay\"></div><aside id=\"list-sidebar\" class=\"list-sidebar list-sidebar-default list-sidebar-stacked custom-six-sidebar list-sidebar-shadow\" role=\"navigation\"><div ng-include=\"\'icteggs/tabvet/tabvet_sidebar_agenti.html\'\"></div><div ng-include=\"\'icteggs/tabvet/tabvet_sidebar_vettori.html\'\"></div><div ng-include=\"\'icteggs/tabvet/tabvet_sidebar_clienti.html\'\"></div><div ng-include=\"\'icteggs/tabvet/tabvet_sidebar_automezzi.html\'\"></div></aside><div class=\"page-title override-padding-toolbar\"><div class=\"pull-right\" ng-if=\"record\"><div class=\"pull-left\"><six-checkbox sx-label=\"Attivo\" sx-model=\"record\" sx-field=\"attivo\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"pull-left m-t-sm m-l-lg m-r-sm\" ng-if=\"record.attivo===\'N\'\"><label class=\"control-label\">Valido fino al</label></div><div class=\"pull-left\" ng-if=\"record.attivo===\'N\'\"><six-date-picker ng-model=\"record.valido\"></six-date-picker></div></div><h1 class=\"m-n font-thin\">Tabella vettori</h1></div><div class=\"wrapper-md\" ng-if=\"record\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Codice</label> <input class=\"form-control\" placeholder=\"Codice\" ng-model=\"record.codice\" type=\"text\" ng-readonly=\"record.id\"></div></div><div class=\"col-md-8\"><div class=\"form-group\"><label>Descrizione</label> <input class=\"form-control\" placeholder=\"Descrizione\" ng-model=\"record.descrizione\" type=\"text\"></div></div></div><uib-tabset class=\"tabs-left\"><uib-tab><uib-tab-heading>Base</uib-tab-heading><div ng-include=\"\'icteggs/tabvet/tabvet_base.html\'\"></div></uib-tab><uib-tab><uib-tab-heading>Tentata vendita</uib-tab-heading><div ng-include=\"\'icteggs/tabvet/tabvet_vendita.html\'\"></div></uib-tab><uib-tab><uib-tab-heading>Tipi incassi</uib-tab-heading><div ng-include=\"\'icteggs/tabvet/tabvet_tipiincassi.html\'\"></div></uib-tab><uib-tab><uib-tab-heading>Automezzi</uib-tab-heading><div ng-include=\"\'icteggs/tabvet/tabvet_automezzi.html\'\"></div></uib-tab><uib-tab><uib-tab-heading>Conferenti</uib-tab-heading><div ng-include=\"\'icteggs/tabvet/tabvet_conferenti.html\'\"></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("icteggs/tabvet/tabvet_automezzi.html","<div class=\"row\"><div class=\"col-md-12 col-sm-12 m-t\"><div class=\"panel panel-default\"><div class=\"panel-body b-t b-t-4x b-primary\"><div><span class=\"pull-right\"><button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first\" ng-click=\"removeItems(\'automezzi\')\" ng-show=\"!isSidebarOpened\"><span class=\"fa fa-times\"></span>Rimuovi</button> <button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first\" ng-click=\"closeSidebar($scope.sidebarIndex)\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-times\"></span>Annulla</button> <button class=\"btn btn-sm btn-default\" ng-click=\"selectAllRemCheck(\'automezzi\')\" ng-show=\"!isSidebarOpened\" title=\"Seleziona tutti\"><span class=\"fa fa-square m-r-none\"></span></button> <button class=\"btn btn-sm btn-default\" ng-click=\"unselectAllRemCheck(\'automezzi\')\" ng-show=\"!isSidebarOpened\" title=\"Deseleziona tutti\"><span class=\"fa fa-square-o m-r-none\"></span></button></span> <span class=\"pull-right\"><button class=\"btn btn-sm btn-default add-remove-button\" ng-click=\"selectDetail(\'automezzi\')\" ng-show=\"!isSidebarOpened\"><span class=\"fa fa-plus\"></span>Aggiungi</button> <button class=\"btn btn-sm btn-default add-remove-button\" ng-click=\"confirmSelectItems()\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-check\"></span>Conferma</button></span><h4 class=\"override-h4-no-margin\">Automezzi</h4><hr class=\"m-t\"></div><div><div ng-if=\"detailList.automezzi.length==0\" class=\"alert alert-info\">Nessun valore selezionato</div><div class=\"row\" ng-repeat=\"item in detailList.automezzi\"><div class=\"col-md-12\"><label class=\"checkbox i-checks m-b-xs m-t-none\"><input type=\"checkbox\" ng-model=\"remCheckModel.automezzi[$index]\"><i></i>{{item.codice}} - {{item.descrizione}}</label></div></div></div></div></div></div></div>");
$templateCache.put("icteggs/tabvet/tabvet_base.html","<div class=\"row m-t-md\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Descrizione</label> <input class=\"form-control\" placeholder=\"Descrizione\" ng-model=\"record.descrizione1\" type=\"text\"></div></div><div class=\"col-md-1\"><div class=\"form-group\"><label>Partita IVA</label> <input class=\"form-control\" placeholder=\"ISO\" ng-model=\"record.iso\" type=\"text\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>&nbsp;</label> <input class=\"form-control\" placeholder=\"Partita IVA\" ng-model=\"record.piva\" type=\"text\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Nr. Iscr.Albo</label> <input class=\"form-control\" placeholder=\"Nr. Iscr.Albo\" ng-model=\"record.albo\" type=\"text\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Indirizzo</label> <input class=\"form-control\" placeholder=\"Indirizzo\" ng-model=\"record.indirizzo\" type=\"text\"></div></div><div class=\"col-md-1\"><div class=\"form-group\"><label>CAP</label> <input class=\"form-control\" placeholder=\"CAP\" ng-model=\"record.cap\" type=\"text\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Città</label> <input class=\"form-control\" placeholder=\"Città\" ng-model=\"record.citta\" type=\"text\"></div></div><div class=\"col-md-1\"><div class=\"form-group\"><label>Provincia</label> <input class=\"form-control\" placeholder=\"Provincia\" ng-model=\"record.provincia\" type=\"text\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Telefono</label> <input class=\"form-control\" placeholder=\"Telefono\" ng-model=\"record.telefono1\" type=\"text\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Fornitore</label><six-lookup ng-model=\"lookup.fornitoreid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"record.fornitoreid\" sx-type=\"\'anafor\'\" sx-placeholder=\"Seleziona fornitore...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Ag. di riferimento</label><six-lookup ng-model=\"lookup.agerifid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"record.agerifid\" sx-type=\"\'ageana\'\" sx-placeholder=\"Seleziona agente di riferimento...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Riferimento</label> <input class=\"form-control\" placeholder=\"Riferimento\" ng-model=\"record.riferimento\" type=\"text\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Tracciato file</label><div><six-enum sx-model=\"record\" sx-field=\"tracciato\" sx-options=\"enum.tracciato\"></six-enum></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Nome file tracciato</label> <input class=\"form-control\" placeholder=\"Nome file tracciato\" ng-model=\"record.nomeFiletracciato\" type=\"text\"></div></div></div>");
$templateCache.put("icteggs/tabvet/tabvet_conferenti.html","<div class=\"row m-t-md\"><div class=\"col-sm-6 col-md-2\"><div class=\"form-group\"><six-checkbox sx-label=\"Attiva conferenti\" sx-model=\"record\" sx-field=\"attivaConferimenti\"></six-checkbox></div></div><div class=\"col-sm-6 col-md-4\"><div class=\"form-group\"><label>Id terminale</label> <input class=\"form-control\" placeholder=\"identificativoTerminale\" ng-model=\"record.identificativoTerminale\" type=\"text\"></div></div></div>");
$templateCache.put("icteggs/tabvet/tabvet_sidebar_agenti.html","<div ng-if=\"sidebarIndex===SIDEBAR.AGENTI\"><div class=\"panel sidebar-panel\"><button class=\"btn btn-info pull-left\" ng-click=\"closeSidebar()\"><span class=\"fa fa-times icon-only\"></span></button> <button class=\"btn btn-info pull-right\" ng-click=\"confirmSelectItems(agentiSideFiltered,\'agenti\')\"><span class=\"fa fa-check icon-only\"></span></button><div class=\"panel-heading bg-info sidebar-heading\">Agenti</div></div><ul class=\"nav list-sidebar-nav\"><li><div class=\"form-group m-l-xs m-r-xs m-t-xs\"><six-search-form ng-model=\"agentiFilter\" placeholder=\"Filtra...\" hide-search-btn=\"\"></six-search-form><span class=\"input-group-btn\"><button class=\"btn btn-default btn-sm\" title=\"Seleziona tutti\" style=\"width:50%\" ng-click=\"selectAllAddCheck()\"><i class=\"fa fa-square\"></i> Seleziona tutti</button> <button class=\"btn btn-default btn-sm\" title=\"Deseleziona tutti\" style=\"width:50%\" ng-click=\"unselectAllAddCheck()\"><i class=\"fa fa-square-o\"></i> Deseleziona tutti</button></span></div></li><li ng-show=\"(sideList.agenti.length==0)\" style=\"text-align:center\"><span style=\"width:100%;\">Nessun <strong>agente</strong> trovato</span></li><li ng-repeat=\"item in sideList.agenti | filter:agentiFilter as agentiSideFiltered\" class=\"m-l-xs m-r-xs\" ng-hide=\"isDisabledItem(item.id,\'agenti\')\"><label class=\"checkbox i-checks m-b-sx\"><input type=\"checkbox\" ng-model=\"addCheckModel.agenti[$index]\"><i></i>{{item.codice}} - {{item.ragsoc}}</label></li></ul></div>");
$templateCache.put("icteggs/tabvet/tabvet_sidebar_automezzi.html","<div ng-if=\"sidebarIndex===SIDEBAR.AUTOMEZZI\"><div class=\"panel sidebar-panel\"><button class=\"btn btn-info pull-left\" ng-click=\"closeSidebar()\"><span class=\"fa fa-times icon-only\"></span></button> <button class=\"btn btn-info pull-right\" ng-click=\"confirmSelectItems(automezziSideFiltered,\'automezzi\')\"><span class=\"fa fa-check icon-only\"></span></button><div class=\"panel-heading bg-info sidebar-heading\">Automezzi</div></div><ul class=\"nav list-sidebar-nav\"><li><div class=\"form-group m-l-xs m-r-xs m-t-xs\"><six-search-form ng-model=\"automezziFilter\" placeholder=\"Filtra...\" hide-search-btn=\"\"></six-search-form><span class=\"input-group-btn\"><button class=\"btn btn-default btn-sm\" title=\"Seleziona tutti\" style=\"width:50%\" ng-click=\"selectAllAddCheck()\"><i class=\"fa fa-square\"></i> Seleziona tutti</button> <button class=\"btn btn-default btn-sm\" title=\"Deseleziona tutti\" style=\"width:50%\" ng-click=\"unselectAllAddCheck()\"><i class=\"fa fa-square-o\"></i> Deseleziona tutti</button></span></div></li><li ng-show=\"(sideList.automezzi.length==0)\" style=\"text-align:center\"><span style=\"width:100%;\">Nessun <strong>automezzo</strong> trovato</span></li><li ng-repeat=\"item in sideList.automezzi | filter:automezziFilter as automezziSideFiltered\" class=\"m-l-xs m-r-xs\" ng-hide=\"isDisabledItem(item.id,\'automezzi\')\"><label class=\"checkbox i-checks m-b-sx\"><input type=\"checkbox\" ng-model=\"addCheckModel.automezzi[$index]\"><i></i>{{item.codice}} - {{item.descrizione}}</label></li></ul></div>");
$templateCache.put("icteggs/tabvet/tabvet_sidebar_clienti.html","<div ng-if=\"sidebarIndex===SIDEBAR.CLIENTI\"><div class=\"panel sidebar-panel\"><button class=\"btn btn-info pull-left\" ng-click=\"closeSidebar()\"><span class=\"fa fa-times icon-only\"></span></button> <button class=\"btn btn-info pull-right\" ng-click=\"confirmSelectItems(clientiSideFiltered,\'clienti\')\"><span class=\"fa fa-check icon-only\"></span></button><div class=\"panel-heading bg-info sidebar-heading\">Clienti</div></div><ul class=\"nav list-sidebar-nav\"><li><div class=\"form-group m-l-xs m-r-xs m-t-xs\"><six-search-form ng-model=\"clientiFilter\" placeholder=\"Filtra...\" hide-search-btn=\"\"></six-search-form><span class=\"input-group-btn\"><button class=\"btn btn-default btn-sm\" title=\"Seleziona tutti\" style=\"width:50%\" ng-click=\"selectAllAddCheck()\"><i class=\"fa fa-square\"></i> Seleziona tutti</button> <button class=\"btn btn-default btn-sm\" title=\"Deseleziona tutti\" style=\"width:50%\" ng-click=\"unselectAllAddCheck()\"><i class=\"fa fa-square-o\"></i> Deseleziona tutti</button></span></div></li><li ng-show=\"(sideList.clienti.length==0)\" style=\"text-align:center\"><span style=\"width:100%;\">Nessun <strong>cliente</strong> trovato</span></li><li ng-repeat=\"item in sideList.clienti | filter:clientiFilter as clientiSideFiltered\" class=\"m-l-xs m-r-xs\" ng-hide=\"isDisabledItem(item.id,\'agenti\')\"><label class=\"checkbox i-checks m-b-sx\"><input type=\"checkbox\" ng-model=\"addCheckModel.clienti[$index]\"><i></i>{{item.clicodice}} - {{item.cliragsoc}}</label></li></ul></div>");
$templateCache.put("icteggs/tabvet/tabvet_sidebar_vettori.html","<div ng-if=\"sidebarIndex===SIDEBAR.VETTORI\"><div class=\"panel sidebar-panel\"><button class=\"btn btn-info pull-left\" ng-click=\"closeSidebar()\"><span class=\"fa fa-times icon-only\"></span></button> <button class=\"btn btn-info pull-right\" ng-click=\"confirmSelectItems(vettoriSideFiltered,\'vettori\')\"><span class=\"fa fa-check icon-only\"></span></button><div class=\"panel-heading bg-info sidebar-heading\">Agenti</div></div><ul class=\"nav list-sidebar-nav\"><li><div class=\"form-group m-l-xs m-r-xs m-t-xs\"><six-search-form ng-model=\"vettoriFilter\" placeholder=\"Filtra...\" hide-search-btn=\"\"></six-search-form><span class=\"input-group-btn\"><button class=\"btn btn-default btn-sm\" title=\"Seleziona tutti\" style=\"width:50%\" ng-click=\"selectAllAddCheck()\"><i class=\"fa fa-square\"></i> Seleziona tutti</button> <button class=\"btn btn-default btn-sm\" title=\"Deseleziona tutti\" style=\"width:50%\" ng-click=\"unselectAllAddCheck()\"><i class=\"fa fa-square-o\"></i> Deseleziona tutti</button></span></div></li><li ng-show=\"(sideList.vettori.length==0)\" style=\"text-align:center\"><span style=\"width:100%;\">Nessun <strong>vettore</strong> trovato</span></li><li ng-repeat=\"item in sideList.vettori | filter:vettoriFilter as vettoriSideFiltered\" class=\"m-l-xs m-r-xs\" ng-hide=\"isDisabledItem(item.id,\'agenti\')\"><label class=\"checkbox i-checks m-b-sx\"><input type=\"checkbox\" ng-model=\"addCheckModel.vettori[$index]\"><i></i>{{item.codice}} - {{item.descrizione}}</label></li></ul></div>");
$templateCache.put("icteggs/tabvet/tabvet_tipiincassi.html","<div class=\"row m-t-md\"><div class=\"col-sm-12\"><div class=\"panel panel-default\"><div class=\"panel-body b-t b-t-4x b-danger\"></div></div></div></div>");
$templateCache.put("icteggs/tabvet/tabvet_vendita.html","<style media=\"screen\" type=\"text/css\">\n    #docbar {\n        padding-top: 33px;\n        text-align: right;\n    }\n</style><div class=\"row m-t-md\"><div class=\"col-md-2 m-t-md\"><six-checkbox sx-label=\"Attiva tentata vendita\" sx-model=\"record\" sx-field=\"attivaTve\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"col-md-2 col-ms-offset-r\"><div class=\"form-group\" id=\"docbar\"><label>Barra documenti</label></div></div><div class=\"col-md-1\"><div class=\"form-group\"><label>DDT</label> <input class=\"form-control\" placeholder=\"DDT\" ng-model=\"record.barradoc\" type=\"text\"></div></div><div class=\"col-md-1\"><div class=\"form-group\"><label>Fatt.</label> <input class=\"form-control\" placeholder=\"\" ng-model=\"record.barrafat\" type=\"text\"></div></div><div class=\"col-md-1\"><div class=\"form-group\"><label>Buono</label> <input class=\"form-control\" placeholder=\"\" ng-model=\"record.barracon\" type=\"text\"></div></div><div class=\"col-md-1\"><div class=\"form-group\"><label>Ord.</label> <input class=\"form-control\" placeholder=\"\" ng-model=\"record.barraord\" type=\"text\"></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=\"form-group\"><label>Targa</label> <input class=\"form-control\" placeholder=\"Targa\" ng-model=\"record.targa\" type=\"text\"></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label>Tipo bolla TVE</label><six-lookup ng-model=\"lookup.tibobollatveid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"record.tibobollatveid\" sx-type=\"\'tabtipobolla\'\" sx-placeholder=\"Seleziona tipo bolla...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Magazzino viaggiante</label><six-lookup ng-model=\"lookup.magazzinoid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"record.magazzinoid\" sx-type=\"\'maganag\'\" sx-placeholder=\"Seleziona un magazzino...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Cliente</label><six-lookup ng-model=\"lookup.clienteid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"record.clienteid\" sx-type=\"\'anacli\'\" sx-placeholder=\"Seleziona un cliente...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Conto incasso</label><six-lookup ng-model=\"lookup.contoincassoid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"record.contoincassoid\" sx-type=\"\'cgpconti\'\" sx-placeholder=\"Seleziona un conto...\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col-sm-6 col-md-6 col-lg-4 m-t\"><div class=\"panel panel-default\"><div class=\"panel-body b-t b-t-4x b-info\"><div><span class=\"pull-right\"><button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first\" ng-click=\"removeItems(\'agenti\')\" ng-show=\"!isSidebarOpened\" ng-disabled=\"taskActivities.length==0\"><span class=\"fa fa-times\"></span>Rimuovi</button> <button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first\" ng-click=\"closeSidebar($scope.sidebarIndex)\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-times\"></span>Annulla</button> <button class=\"btn btn-sm btn-default\" ng-click=\"selectAllRemCheck(\'agenti\')\" ng-show=\"!isSidebarOpened\" title=\"Seleziona tutti\"><span class=\"fa fa-square m-r-none\"></span></button> <button class=\"btn btn-sm btn-default\" ng-click=\"unselectAllRemCheck(\'agenti\')\" ng-show=\"!isSidebarOpened\" title=\"Deseleziona tutti\"><span class=\"fa fa-square-o m-r-none\"></span></button></span> <span class=\"pull-right\"><button class=\"btn btn-sm btn-default add-remove-button\" ng-click=\"selectDetail(\'agenti\')\" ng-show=\"!isSidebarOpened\"><span class=\"fa fa-plus\"></span>Aggiungi</button> <button class=\"btn btn-sm btn-default add-remove-button\" ng-click=\"confirmSelectItems()\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-check\"></span>Conferma</button></span><h4 class=\"override-h4-no-margin\">Agenti</h4><hr class=\"m-t\"></div><div><div ng-if=\"detailList.agenti.length==0\" class=\"alert alert-info\">Nessun valore selezionato</div><div class=\"row\" ng-repeat=\"item in detailList.agenti\"><div class=\"col-md-12\"><label class=\"checkbox i-checks m-b-xs m-t-none\"><input type=\"checkbox\" ng-model=\"remCheckModel.agenti[$index]\"><i></i>{{item.codice}} - {{item.ragsoc}}</label></div></div></div></div></div></div><div class=\"col-sm-6 col-md-6 col-lg-4 m-t\"><div class=\"panel panel-default\"><div class=\"panel-body b-t b-t-4x b-success\"><div><span class=\"pull-right\"><button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first\" ng-click=\"removeItems(\'vettori\')\" ng-show=\"!isSidebarOpened\" ng-disabled=\"taskActivities.length==0\"><span class=\"fa fa-times\"></span>Rimuovi</button> <button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first\" ng-click=\"closeSidebar($scope.sidebarIndex)\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-times\"></span>Annulla</button> <button class=\"btn btn-sm btn-default\" ng-click=\"selectAllRemCheck(\'vettori\')\" ng-show=\"!isSidebarOpened\" title=\"Seleziona tutti\"><span class=\"fa fa-square m-r-none\"></span></button> <button class=\"btn btn-sm btn-default\" ng-click=\"unselectAllRemCheck(\'vettori\')\" ng-show=\"!isSidebarOpened\" title=\"Deseleziona tutti\"><span class=\"fa fa-square-o m-r-none\"></span></button></span> <span class=\"pull-right\"><button class=\"btn btn-sm btn-default add-remove-button\" ng-click=\"selectDetail(\'vettori\')\" ng-show=\"!isSidebarOpened\"><span class=\"fa fa-plus\"></span>Aggiungi</button> <button class=\"btn btn-sm btn-default add-remove-button\" ng-click=\"confirmSelectItems()\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-check\"></span>Conferma</button></span><h4 class=\"override-h4-no-margin\">Vettori</h4><hr class=\"m-t\"></div><div><div ng-if=\"detailList.vettori.length==0\" class=\"alert alert-info\">Nessun valore selezionato</div><div class=\"row\" ng-repeat=\"item in detailList.vettori\"><div class=\"col-md-12\"><label class=\"checkbox i-checks m-b-xs m-t-none\"><input type=\"checkbox\" ng-model=\"remCheckModel.vettori[$index]\"><i></i>{{item.codice}} - {{item.descrizione}}</label></div></div></div></div></div></div><div class=\"col-sm-6 col-md-6 col-lg-4 m-t\"><div class=\"panel panel-default\"><div class=\"panel-body b-t b-t-4x b-warning\"><div><span class=\"pull-right\"><button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first\" ng-click=\"removeItems(\'clienti\')\" ng-show=\"!isSidebarOpened\" ng-disabled=\"taskActivities.length==0\"><span class=\"fa fa-times\"></span>Rimuovi</button> <button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first\" ng-click=\"closeSidebar($scope.sidebarIndex)\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-times\"></span>Annulla</button> <button class=\"btn btn-sm btn-default\" ng-click=\"selectAllRemCheck(\'clienti\')\" ng-show=\"!isSidebarOpened\" title=\"Seleziona tutti\"><span class=\"fa fa-square m-r-none\"></span></button> <button class=\"btn btn-sm btn-default\" ng-click=\"unselectAllRemCheck(\'clienti\')\" ng-show=\"!isSidebarOpened\" title=\"Deseleziona tutti\"><span class=\"fa fa-square-o m-r-none\"></span></button></span> <span class=\"pull-right\"><button class=\"btn btn-sm btn-default add-remove-button\" ng-click=\"selectDetail(\'clienti\')\" ng-show=\"!isSidebarOpened\"><span class=\"fa fa-plus\"></span>Aggiungi</button> <button class=\"btn btn-sm btn-default add-remove-button\" ng-click=\"confirmSelectItems()\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-check\"></span>Conferma</button></span><h4 class=\"override-h4-no-margin\">Clienti</h4><hr class=\"m-t\"></div><div><div ng-if=\"detailList.clienti.length==0\" class=\"alert alert-info\">Nessun valore selezionato</div><div class=\"row\" ng-repeat=\"item in detailList.clienti\"><div class=\"col-md-12\"><label class=\"checkbox i-checks m-b-xs m-t-none\"><input type=\"checkbox\" ng-model=\"remCheckModel.clienti[$index]\"><i></i>{{item.clicodice}} - {{item.cliragsoc}}</label></div></div></div></div></div></div></div>");
$templateCache.put("lm/cartComposition/cartComposition.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"{{ \'back\' | translate }}\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">{{ \'cart_composition.cart_composition\' | translate }} <strong>{{cart}}</strong></h1></div></div></div><div class=\"wrapper\"><div class=\"panel-body\"><uib-tabset active=\"activeTab\"><uib-tab index=\"TAB.CART\"><uib-tab-heading><i class=\"icon icon1-warehouse text-info-dker\"></i> {{ \'cart_composition.cart_selection\' | translate }}</uib-tab-heading><div ng-include=\"\'lm/cartComposition/cartComposition_tabCart.html\'\" ng-if=\"activeTab == TAB.CART\"></div></uib-tab><uib-tab disable=\"!cart\" index=\"TAB.KIT\"><uib-tab-heading><i class=\"icon icon1-packaging text-primary-dker\"></i> {{ \'cart_composition.kit_adding_removal\' | translate }}</uib-tab-heading><div ng-include=\"\'lm/cartComposition/cartComposition_tabKit.html\'\" ng-if=\"activeTab == TAB.KIT\"></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("lm/cartComposition/cartComposition_tabCart.html","<div class=\"row m-t-md\"><div class=\"col-md-6\"><div><six-code-reader sx-on-read=\"readCartCode(read)\" sx-read-mode=\"cartReaderMode\"><six-code-reader></six-code-reader></six-code-reader></div></div><div class=\"col-md-6\"><six-lookup ng-if=\"!generatedBarcode\" ng-model=\"lookup.label_printer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"settings.label_printer_id\" sx-type=\"\'label_printer\'\" sx-placeholder=\"Seleziona stampante...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"row\"><div class=\"col-md-6\"><div ng-if=\"!cart\"><div class=\"alert alert-info m-t-md\">{{ \'cart_composition.no_cart_selected\' | translate }}</div></div><div ng-if=\"cart\"><div class=\"alert alert-success m-t-md\">{{ \'cart_composition.selected_cart_n\' | translate }} <strong>{{cart}}</strong></div></div></div><div class=\"col-md-3\"><div class=\"clearfix\"></div><br><button class=\"btn btn-dashboard\" ng-disabled=\"!settings.label_printer_id || moveCartMode\" ng-click=\"generateBarcode()\"><i class=\"icon icon1-warehouse\"></i><h3>{{ \'cart_composition.generate_and_print\' | translate }}</h3></button></div><div class=\"col-md-3\"><div class=\"clearfix\"></div><br><button class=\"btn btn-dashboard\" ng-disabled=\"!settings.label_printer_id || !cart\" ng-click=\"printBarcode()\"><i class=\"fa fa-print\"></i><h3>{{ \'cart_composition.print_againt\' | translate }}</h3></button></div></div>");
$templateCache.put("lm/cartComposition/cartComposition_tabKit.html","<style>\n    #remove-button {\n        background-color: white;\n        border-color: none;\n        min-height: 148px;\n    }\n    #remove-button i{\n      color: #f05050 !important;\n    }\n</style><div class=\"row wrapper\" ng-if=\"packagingError\"><div class=\"col-md-12\" ng-if=\"packagingError\"><div class=\"alert bg-danger\" ng-if=\"packagingError\">{{cart_composition.packagingError}}</div></div></div><div class=\"row wrapper\"><div class=\"col-md-2\"><button class=\"btn btn-dashboard m-b-none\" ng-click=\"setAddMode(true)\" id=\"add-button\" ng-class=\"{\'btn-pressed\': addMode}\"><i class=\"fa fa-plus\"></i><h3>{{ \'cart_composition.add_kit\' | translate }}</h3></button></div><div class=\"col-md-2\"><button class=\"btn btn-dashboard m-b-none\" ng-click=\"setAddMode(false)\" id=\"remove-button\" ng-class=\"{\'btn-pressed\': !addMode}\"><i class=\"fa fa-minus\"></i><h3>{{ \'cart_composition.remove_kit\' | translate }}</h3></button></div><div class=\"col-md-5\"><div ng-if=\"step===STEP.PACKAGING\" class=\"m-b-md\"><label>{{ \'kit_read\' | translate }}</label><six-code-reader sx-on-read=\"readComponentCode(read)\" sx-read-mode=\"compReaderMode\"><six-code-reader></six-code-reader></six-code-reader></div><div><h3>{{ \'cart_composition.mode\' | translate }} <strong ng-if=\"addMode\" class=\"text-success\">{{ \'cart_composition.addition\' | translate }} <i class=\"fa fa-plus\"></i></strong><strong class=\"text-danger\" ng-if=\"!addMode\">{{ \'cart_composition.removal\' | translate }} <i class=\"fa fa-minus\"></i></strong></h3></div></div><div class=\"col-md-1\" style=\"text-align:center\"><h3>{{ \'total\' | translate}}</h3><h1><strong class=\"text-dark\">{{serialKitList.length}}</strong></h1></div><div class=\"col-md-2\"><button class=\"btn btn-dashboard m-b-none\" ng-click=\"goToNewCart()\" style=\"padding:18px\"><i class=\"fa fa-cart-plus\"></i><h3>{{ \'cart_composition.new_cart\' | translate }}</h3></button></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><table class=\"table m-b-none\"><thead><tr><th>{{ \'barcode\' | translate }}</th><th>{{ \'cart_composition.product_code\' | translate }}</th><th>{{ \'cart_composition.product_description\' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"sk in serialKitList.slice().reverse()\"><td>{{sk.barcode}}</td><td>{{sk.product_code}}</td><td>{{sk.product_description}}</td></tr></tbody></table><div class=\"alert alert-info m-t-md\" ng-if=\"enableNextStep\"><span ng-if=\"!generatedBarcode\">{{ \'cart_composition.serial_kit_completed\' | translate }}</span> <span ng-if=\"generatedBarcode\">{{ \'cart_composition.created_with_barcode\' | translate }} <strong>{{generatedBarcode}}</strong></span></div></div></div>");
$templateCache.put("lm/component/component_detail.html","<six-toolbar title=\"pageTitle\"><six-toolbar-button label=\"Indietro\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"m-t-xl\"><div class=\"wrapper-md\"><uib-tabset justified=\"false\" active=\"activeTab\" class=\"tab-container\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"tab-heading\">Testata</span></uib-tab-heading><div ng-include=\"\'lm/component/component_tabHead.html\'\" ng-if=\"element\"></div></uib-tab><uib-tab index=\"1\"><uib-tab-heading><span class=\"tab-heading\">Storico</span></uib-tab-heading><div ng-include=\"\'lm/component/component_tabHistory.html\'\"></div></uib-tab><uib-tab index=\"2\"><uib-tab-heading><span class=\"tab-heading\">Allegati</span></uib-tab-heading><div ng-include=\"\'lm/component/component_tabAttachment.html\'\"></div></uib-tab></uib-tabset></div></div>");
$templateCache.put("lm/component/component_list.html","<six-toolbar title=\"\'Componenti\'\"></six-toolbar><div class=\"padder-md m-t-toolbar\"><div class=\"row\"><div class=\"col-md-3\"><label>Barcode</label> <input type=\"text\" class=\"form-control\" ng-model=\"advFilter.filter.barcode\"></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">Articolo</label><six-lookup ng-model=\"lookup.product_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.product_id\" sx-type=\"\'product\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">Taglia</label><six-lookup ng-model=\"lookup.size_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.size_id\" sx-type=\"\'tab_size\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-hide-code=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">Dipendente</label><six-lookup ng-model=\"lookup.employee_id\" sx-filter=\"lookup.employee_id.filter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.employee_id\" sx-type=\"\'human_resource\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-hide-code=\"true\" sx-sort-fields=\"[\'surname\',\'name\']\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">Presidio Uso DPI</label><six-lookup ng-model=\"lookup.customer_id\" sx-filter=\"customerFilter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.customer_id\" sx-type=\"\'customer\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-disabled=\"lockCustomer\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">Lotto</label><six-lookup ng-model=\"lookup.lot_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.lot_id\" sx-type=\"\'lot\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-hide-code=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">Sede di utilizzo DPI</label><six-lookup ng-model=\"lookup.current_destination_id\" sx-filter=\"lookup.current_destination_id.filter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.current_destination_id\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-hide-code=\"true\"></six-lookup></div></div></div><div class=\"wrapper-md\"><div class=\"panel panel-default\"><six-grid-pagination ng-if=\"sf && renderTable\" get-data-callback=\"getData()\" items-list=\"list\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div><div class=\"bg-light lter b-b wrapper-md\" ng-if=\"!(sf && renderTable)\" align=\"center\">CARICAMENTO COMPONENTI</div></div>");
$templateCache.put("lm/component/component_tabAttachment.html","<div class=\"row\"><div class=\"col-md-12\"><six-statix path=\"statix.path\" ng-model=\"statix.model\" show-upload=\"isUploadAllowed\" show-preview=\"false\" show-delete=\"isDeleteUploadAllowed\"></six-statix></div></div>");
$templateCache.put("lm/component/component_tabHead.html","<div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Barcode</label> <input type=\"text\" class=\"form-control\" placeholder=\"Barcode\" ng-model=\"element.barcode\" ng-readonly=\"readOnly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Unicode</label> <input type=\"text\" class=\"form-control\" placeholder=\"Unicode\" ng-model=\"element.unicode\" ng-readonly=\"readOnly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Lavaggi</label> <input type=\"number\" class=\"form-control\" ng-model=\"element.wash_num\" ng-readonly=\"readOnly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Articolo</label><six-lookup ng-model=\"lookup.product_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.product_id\" sx-type=\"\'product\'\" sx-placeholder=\"Seleziona articolo...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Colore</label><six-lookup ng-model=\"lookup.color_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.color_id\" sx-type=\"\'color\'\" sx-placeholder=\"Seleziona colore...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Dipendente</label><six-lookup ng-model=\"lookup.employee_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.employee_id\" sx-type=\"\'human_resource\'\" sx-placeholder=\"Seleziona dipendente...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Taglia</label><six-lookup ng-model=\"lookup.size_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.size_id\" sx-type=\"\'tab_size\'\" sx-placeholder=\"Seleziona taglia...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Lotto</label><six-lookup ng-model=\"lookup.lot_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.lot_id\" sx-type=\"\'lot\'\" sx-placeholder=\"Seleziona lotto...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Peso</label> <input type=\"number\" class=\"form-control\" ng-model=\"element.weight\" ng-readonly=\"readOnly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Uso</label><six-enum ng-if=\"element\" sx-model=\"element\" sx-field=\"special_use\" sx-options=\"enum.special_use\" sx-readonly=\"readOnly\"></six-enum></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Sede di utilizzo DPI</label><six-lookup ng-model=\"lookup.current_destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.current_destination_id\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona sede...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div></div>");
$templateCache.put("lm/component/component_tabHistory.html","<div class=\"row\"><div class=\"col-md-12\"><six-component-status-grid sx-entity=\"component_status\" sx-detail-button=\"false\"></six-component-status-grid></div></div>");
$templateCache.put("lm/component/reintegro-dismessi-confirm.html","<div class=\"modal-dialog modal-sm\"><div class=\"modal-content\"><div class=\"modal-body\"><h4>Confermi il reintegro di <b>{{ row.quantity }}</b> {{ row.product_desc }} - {{ row.product_code }} {{ (row.size_code) ? \'(tg. \'+ row.size_code+\')\' : \'\' }} ?</h4></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">OK</button> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Cancel</button></div></div></div>");
$templateCache.put("lm/component/reintegrodismessi.html","<six-toolbar title=\"\'Reintegro Dismessi\'\"></six-toolbar><div class=\"padder-md m-t-toolbar\"><div class=\"row\"><div class=\"col-md-5\"><label id=\"type_label\" class=\"control-label\">Cliente</label><six-lookup ng-model=\"lookup.customer_id\" sx-filter=\"customerFilter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.customer_id\" sx-type=\"\'customer\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-4\"><label id=\"type_label\" class=\"control-label\">Articolo</label><six-lookup ng-model=\"lookup.product_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.product_id\" sx-type=\"\'product\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"wrapper-md\"><div class=\"panel panel-default\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"list\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div>");
$templateCache.put("lm/componentChecker/component_checker.html","<style>\n  .row_not_found{\n    background-color: rgba(253, 110, 110) !important;\n  }\n\n  </style><six-toolbar title=\"\'Controllo capi/pacchi\'\"></six-toolbar><div class=\"padder-md m-t-toolbar\"><div class=\"row\"><div class=\"col col-md-4\"><label class=\"control-label\">Unicode/Barcode</label><six-code-reader sx-on-read=\"onRead(read.read)\" sx-allow-pause=\"true\"></six-code-reader></div><div class=\"col-md-7\"></div><div class=\"col col-md-1\"><h1>{{validItemsCount}}</h1></div></div></div><div class=\"wrapper-md\"><div class=\"panel panel-default\"><six-grid-pagination items-list=\"pagedList\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\" get-data-callback=\"getData()\"></six-grid-pagination></div></div>");
$templateCache.put("lm/componentStatusWorkflow/componentStatusWorkflow.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"Indietro\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Component Workflow</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-footer\"><button ng-click=\"saveMatrixPar()\" class=\"btn btn-m btn-primary m-r\" id=\"btn_create_entity\"><i class=\"glyphicon glyphicon-save\"></i> Salva</button> <button ng-click=\"reloadMatrixPar()\" class=\"btn btn-m btn-primary m-r\" id=\"btn_create_entity\"><i class=\"glyphicon glyphicon-refresh\"></i> Reload</button></div><div><table class=\"table m-b-none table-workflow\"><thead><tr><th></th><th ng-repeat=\"status in tableHead\" ng-class=\"{\'bg-info\': true}\" ng-attr-title=\"{{codeToString[status]}}\">{{status}}</th></tr></thead><tbody><tr ng-repeat=\"status in tableHead\"><th ng-class=\"{\'bg-info\': true}\" ng-attr-title=\"{{codeToString[status]}}\">{{status}}</th><td ng-repeat=\"isCurrentStatusValid in tableData[status] track by $index\" style=\"text-align: center;\"><a class=\"btn\" id=\"{{status}}-{{$index}}\" ng-click=\"switchStatusValue($event)\"><i class=\"fa fa-circle {{isCurrentStatusValid ? \'active\' : \'\'}}\"></i></a></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("lm/components-shipment/components-shipment-print.html","<six-toolbar static-title=\"{{ \'Stampa ddt\' | translate}}\"><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"{{ \'back\' | translate}}\" toolbar-function=\"goToList()\"></six-toolbar-button></six-toolbar><div class=\"wrapper override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\" style=\"height:650px\"><six-iframe sx-report=\"\'shipment_detail_report.rptdesign\'\" sx-params=\"reportParameters\"></six-iframe></div></div></div>");
$templateCache.put("lm/components-shipment/components-shipment.html","<six-toolbar title=\"functionTitle\"></six-toolbar><div class=\"wrapper-md m-t-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\" style=\"padding-bottom: 20px;\"><div class=\"col-md-4\"><label class=\"control-label\">{{ \"Tipo ddt\" | translate }}</label><six-lookup ng-model=\"lookup.shipment_type_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-preselect-if-one=\"true\" sx-id=\"shipmentType\" sx-type=\"\'shipment_type\'\" sx-filter=\"shipmentTypeFilter\" sx-relational=\"true\" sx-placeholder=\"Seleziona tipo ddt...\"></six-lookup></div><div class=\"col-md-4\"><label class=\"control-label\">{{ \"destination\" | translate }}</label><six-lookup ng-model=\"lookup.destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-preselect-if-one=\"false\" sx-id=\"destination\" sx-type=\"\'customer_destination\'\" sx-relational=\"true\" sx-placeholder=\"Seleziona una destinazione...\"></six-lookup></div><div class=\"col-md-4\"><label class=\"control-label\">{{ \"Contratto\" | translate }}</label><six-lookup ng-model=\"lookup.agreement_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"agreement\" sx-type=\"\'agreement\'\" sx-filter=\"agreementFilter\" sx-relational=\"true\" sx-placeholder=\"Seleziona un contratto...\"></six-lookup></div></div><div class=\"row\"><div class=\"col-md-6\"><six-code-reader sx-on-read=\"readComponentCode(read)\" sx-read-mode=\"compReaderMode\"><six-code-reader></six-code-reader></six-code-reader></div><div class=\"col-md-2\" style=\"font-size: 20px\">Chip letti : {{unicodesList.length}}</div><div class=\"col-md-4\"><button class=\"btn btn-default m-xs\" ng-click=\"resetReads()\">{{ \"Cancella letture\" | translate}}</button> <button class=\"btn btn-default m-xs\" ng-click=\"resolveComponents()\" ng-disabled=\"false\">{{ \"Risolvi letture\" | translate}}</button></div></div><div class=\"row\"><br></div><div class=\"row\" ng-show=\"showTable\"><div class=\"col-md-8\"><table class=\"table table-striped m-b-none\"><thead><tr><th class=\"col-md-6\">{{\'product\' | translate}}</th><th class=\"col-md-1\">{{\'quantity\' | translate}}</th><th class=\"col-md-1\"></th></tr></thead><tbody><tr ng-repeat=\"(prod_id, comps) in productMap\"><td><div>{{comps.prod}}</div></td><td><div>{{comps.ids.length}}</div></td><td><div ng-if=\"comps.inAgreement === false\" class=\"icon fa fa-exclamation-circle\"></div><button ng-if=\"comps.inAgreement === false\" class=\"icon fa fa-times\" ng-click=\"removeReads(prod_id)\"></button></td></tr></tbody></table></div><div class=\"col-md-4\"><br><button class=\"btn btn-default m-xs\" ng-click=\"createDdt()\" ng-disabled=\"!enableCreateButton\">{{ \"Crea e stampa\" | translate}}</button></div></div></div></div></div>");
$templateCache.put("lm/confirm-order-log80/confirm-order-log80.html","<six-toolbar title=\"functionTitle\"></six-toolbar><div class=\"wrapper-md m-t-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\" style=\"padding-bottom: 20px;\"><div class=\"col-md-4\"><label class=\"control-label\">{{ \"customer\" | translate }}</label><six-lookup ng-model=\"lookup.customer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-preselect-if-one=\"false\" sx-id=\"advFilter.filter.customer_id\" sx-type=\"\'customer\'\" sx-filter=\"destinationFilter\" sx-relational=\"true\" sx-placeholder=\"Seleziona un cliente...\"></six-lookup></div><div class=\"col-md-4\"><label class=\"control-label\">{{ \"destination\" | translate }}</label><six-lookup ng-model=\"lookup.destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-preselect-if-one=\"false\" sx-id=\"advFilter.filter.destination_id\" sx-type=\"\'customer_destination\'\" sx-filter=\"destinationFilter\" sx-relational=\"true\" sx-placeholder=\"Seleziona una destinazione...\"></six-lookup></div><div class=\"col-md-2\"><br><button class=\"btn btn-default m-xs\" ng-click=\"confirmSelected()\" ng-disabled=\"!confirmEnabled\"><i class=\"fa fa-shopping-cart\"></i> {{ \"conferma ordini\" | translate}}</button></div></div></div><div class=\"row\" align=\"center\" ng-show=\"result.list.length > 0\"><b>ORDINI EVADIBILI</b></div><div class=\"row\"><div class=\"col-lg-12\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"result\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\" ng-show=\"result.list.length > 0\"></six-grid-pagination></div></div><br><div class=\"row\" align=\"center\" ng-show=\"resultSec.list.length > 0\"><b>ORDINI NON EVADIBILI</b></div><div class=\"row\"><div class=\"col-lg-12\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"resultSec\" column-defs=\"viewGridOptionsSec.columnDefs\" grid-options=\"viewGridOptionsSec\" params=\"paramsSec\" ng-show=\"resultSec.list.length > 0\"></six-grid-pagination></div></div></div></div>");
$templateCache.put("lm/ddt-status-change/ddt-status-change.html","<six-toolbar title=\"functionTitle\"></six-toolbar><div class=\"wrapper-md m-t-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\" style=\"padding-bottom: 20px;\"><div class=\"col-md-3\"><label class=\"control-label\">{{ \"customer\" | translate }}</label><six-lookup ng-model=\"lookup.customer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-preselect-if-one=\"false\" sx-id=\"advFilter.filter.customer_id\" sx-type=\"\'customer\'\" sx-filter=\"destinationFilter\" sx-relational=\"true\" sx-placeholder=\"Seleziona un cliente...\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"destination\" | translate }}</label><six-lookup ng-model=\"lookup.destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-preselect-if-one=\"false\" sx-id=\"advFilter.filter.destination_id\" sx-type=\"\'customer_destination\'\" sx-filter=\"destinationFilter\" sx-relational=\"true\" sx-placeholder=\"Seleziona una destinazione...\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"status\" | translate }}</label><six-enum sx-model=\"advFilter.filter\" sx-field=\"state\" sx-options=\"enum.state\" sx-readonly=\"false\"></six-enum></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"Tipo ddt\" | translate }}</label><six-lookup ng-model=\"lookup.shipment_type_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-preselect-if-one=\"false\" sx-id=\"advFilter.filter.shipment_type_id\" sx-type=\"\'shipment_type\'\" sx-filter=\"shipmentTypeFilter\" sx-relational=\"true\" sx-placeholder=\"Selezionare tipo ddt\"></six-lookup></div></div><div class=\"row\" style=\"padding-bottom: 20px;\"><div class=\"col-md-2\"><label class=\"control-label\">{{ \"Da numero\" | translate }}</label> <input type=\"number\" class=\"form-control\" ng-model=\"advFilter.filter.from_number\"></div><div class=\"col-md-2\"><label class=\"control-label\">{{ \"A numero\" | translate }}</label> <input type=\"number\" class=\"form-control\" ng-model=\"advFilter.filter.to_number\"></div><div class=\"col-md-2\"><label>{{ \"Da data\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.from_date\"></six-date-picker></div><div class=\"col-md-2\"><label>{{ \"A data\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.to_date\"></six-date-picker></div><div class=\"col-md-1\"><label>{{ \"Barra\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"advFilter.filter.bar\"></div><div class=\"col-md-3\"><br><div class=\"row\"><div class=\"col-md-3\"><button class=\"btn btn-default m-xs\" ng-click=\"applyFilter()\">{{ \"Cerca\" | translate}}</button></div><div class=\"col-md-3\"><button class=\"btn btn-default m-xs\" ng-click=\"reset()\">{{ \"Reset\" | translate}}</button></div><div class=\"col-md-5\"><button class=\"btn btn-default m-xs\" ng-click=\"confirm()\" ng-disabled=\"!confirmEnabled\"><i class=\"fa fa-shopping-cart\"></i> {{ \"Passa a SAP\" | translate}}</button></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"result\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\" ng-show=\"result.list.length > 0\"></six-grid-pagination></div></div></div><six-confirm-modal sx-title=\"modal.title\" sx-message=\"modal.message\" sx-on-confirm=\"modal.callback\"></six-confirm-modal></div>");
$templateCache.put("lm/dryCleaningDirtyAcceptance/dry-cleaning-dirty-acceptance.html","<style>\n    .barcode-header {\n        background-color: #a5b3c7;\n        padding: 5px;\n        width: 100%;\n        padding-left: 9px;\n        color: white;\n        font: bold;\n    }\n</style><six-toolbar static-title=\"{{\'dry_cleaning.guest_clean_read\' | translate }}\"><six-toolbar-button label=\"{{ \'back\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"{{ \'reset\' | translate }}\" icon=\"fa fa-undo\" toolbar-function=\"reset()\"></six-toolbar-button><six-toolbar-button ng-if=\"showComponentLabelPrintLink\" label=\"{{ \'dry_cleaning.component_label_print\' | translate }}\" icon=\"fa fa-undo\" toolbar-function=\"goToJsfComponentLabelPrint()\"></six-toolbar-button><six-toolbar-button ng-if=\"showQualityCheckLink\" label=\"{{ \'dry_cleaning.quality_check\' | translate }}\" icon=\"fa fa-undo\" toolbar-function=\"goToJsfQualityCheck()\"></six-toolbar-button></six-toolbar><div class=\"override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"barcode\" | translate }}</label><six-code-reader sx-on-read=\"readBarcode(read)\" sx-read-mode=\"readerMode\" sx-focus=\"true\"></six-code-reader></div><div class=\"col-md-6 form-group override-form-group\"><button class=\"btn btn-primary\" style=\"width: 100%\" ng-click=\"confirm()\" ng-disabled=\"settings.disableConfirm\">{{ \"confirm\" | translate }}</button></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel panel-body\"><div class=\"barcode-header\">{{ \"dry_cleaning.read_barcodes\" | translate }}</div><table class=\"table table-striped m-b-none\"><thead><tr><th class=\"col-md-1\"></th><th class=\"col-md-1\">{{\'barcode\' | translate}}</th><th class=\"col-md-2\">{{\'customer\' | translate}}</th><th class=\"col-md-2\">{{\'dry_cleaning.guest\' | translate}}</th><th class=\"col-md-1\">{{\'dry_cleaning.arm\' | translate}}</th><th class=\"col-md-2\">{{\'note\' | translate}}</th><th class=\"col-md-2\">{{\'product\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"(barcode, item) in componentMap\"><td><i ng-if=\"item.status.loading\" class=\"fa fa-spinner fa-2x fa-pulse fa-fw text-info-dker\"></i> <i ng-if=\"item.status.saved\" class=\"fa fa-check fa-2x fa-fw text-success\"></i> <button ng-if=\"!item.status.loading && !item.status.saved\" class=\"btn btn-danger\" ng-click=\"removeComponent(barcode)\"><span class=\"fa fa-times\"></span></button></td><td><div>{{item.component.barcode}}</div><div class=\"text-danger\">{{item.status.message}}</div></td><td><div style=\"font-size: 20px;\">{{item.component.customer_code}} - {{item.component.customer_desc}}</div></td><td><div>{{item.component.hr_name}} - {{item.component.hr_surname}}</div></td><td><div style=\"font-size: 22px;\">{{item.component.hr_arm}}</div></td><td><input type=\"text\" ng-disabled=\"item.status.loading || item.status.saved\" class=\"form-control\" placeholder=\"{{\'note\' | translate}}\" ng-model=\"item.component.note\"></td><td><six-lookup ng-model=\"item.product\" sx-id=\"item.component.product_id\" sx-type=\"\'product\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-disabled=\"item.status.loading || item.status.saved\" sx-on-select=\"lookupChanged(barcode)\" sx-on-clear=\"lookupCleared()\" sx-filter=\"productFilter\"></six-lookup></td><td><i ng-if=\"item.product.obj.code == \'NS\'\" class=\"fa fa-exclamation-triangle fa-2x fa-fw\"></i></td></tr></tbody></table></div></div></div>");
$templateCache.put("lm/dryCleaningLabelPrint/dry-cleaning-label-print.html","<style>\n    .barcode-header {\n        background-color: #a5b3c7;\n        padding: 5px;\n        width: 100%;\n        padding-left: 9px;\n        color: white;\n        font:bold;\n    }\n    .p-r-md {\n        padding-right: 29px;\n    }\n    .barcode {\n        border: solid 1px #ccc;\n        line-height: 30px;\n        text-align: center;\n        margin-top: -1px;\n    }\n</style><six-toolbar static-title=\"{{\'dry_cleaning.label_print\' | translate }}\"><six-toolbar-button label=\"{{ \'back\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"{{ \'dry_cleaning.reprint_selected\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-print\" sx-disabled=\"getSelectedComponents().length==0\" toolbar-function=\"printByIds()\"></six-toolbar-button></six-toolbar><div class=\"override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"customer\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.customer_id\" sx-id=\"record.model.customer_id\" sx-type=\"\'customer\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"customerFilter\" sx-disabled=\"settings.idDestinationReadonly\"></six-lookup></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"quantity\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" ng-model=\"settings.quantity\" min=\"1\" step=\"1\"></div></div></div><div class=\"row padder\"><div class=\"col col-md-6 form-group override-form-group p-r-md\"><six-lookup ng-model=\"record.lookup.printer_id\" sx-id=\"record.model.printer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-placeholder=\"{{ \'select_printer\' | translate}}...\" sx-type=\"\'label_printer\'\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-6 form-group override-form-group\"><button class=\"btn btn-primary\" style=\"width: 100%\" ng-click=\"createAndPrint()\" ng-disabled=\"settings.disableConfirm\">{{ \"dry_cleaning.confirm_and_print\" | translate }}</button></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel panel-body\"><label class=\"i-checks\"><input type=\"checkbox\" ng-model=\"settings.checkAll\" ng-click=\"selectAll()\" ng-disabled=\"!result.list || result.list.length==0\"> <i></i> {{ \"dry_cleaning.select_all\" | translate }}</label><div class=\"barcode-header\">{{ \"dry_cleaning.generated_barcodes\" | translate }}</div><div ng-repeat=\"item in result.list\" class=\"col-md-3 barcode\"><label class=\"i-checks\"><input type=\"checkbox\" ng-model=\"item.checked\"> <i></i> {{item.barcode}}</label></div></div></div></div>");
$templateCache.put("lm/dryCleaningPatientLabelPrint/dry-cleaning-patient-label-print.html","<style>\n    .barcode-header {\n        background-color: #a5b3c7;\n        padding: 5px;\n        width: 100%;\n        padding-left: 9px;\n        color: white;\n        font:bold;\n    }\n    .p-r-md {\n        padding-right: 29px;\n    }\n    .barcode {\n        border: solid 1px #ccc;\n        line-height: 30px;\n        text-align: center;\n        margin-top: -1px;\n    }\n</style><six-toolbar static-title=\"{{\'dry_cleaning.label_print\' | translate }}\"><six-toolbar-button label=\"{{ \'back\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"{{ \'dry_cleaning.reprint_selected\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-print\" sx-disabled=\"getSelectedComponents().length==0\" toolbar-function=\"printByIds()\"></six-toolbar-button></six-toolbar><div class=\"override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-8 form-group override-form-group\"><label class=\"col-sm-3 control-label\">{{ \"dry_cleaning.emp_pat\" | translate }}</label><div class=\"col-sm-9\"><six-lookup ng-model=\"record.lookup.hr_id\" sx-id=\"record.model.hr_id\" sx-type=\"\'human_resource\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"humanResourceFilter\" sx-disabled=\"settings.idDestinationReadonly\"></six-lookup></div></div><div class=\"col-md-1 form-group override-form-group\"></div><div class=\"col-md-2 form-group override-form-group\"><button class=\"btn btn-primary\" style=\"width: 100%\" ng-click=\"refreshList()\">{{ \"dry_cleaning.reload_list\" | translate }}</button></div></div><div class=\"row\"><div class=\"col col-md-6 form-group override-form-group p-r-md\"><label class=\"col-sm-2 control-label\">{{ \"dry_cleaning.customer\" | translate }}</label><div class=\"col-sm-10\">{{customer_code}} - {{customer_desc}}</div></div><div class=\"col-md-3 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"dry_cleaning.from_barcode\" | translate }}</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"fromBarcode\"></div></div><div class=\"col-md-3 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"dry_cleaning.to_barcode\" | translate }}</label><div class=\"col-sm-8\"><input class=\"form-control\" ng-model=\"toBarcode\"></div></div></div><div class=\"row\"><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-3 control-label\">{{ \"dry_cleaning.printer\" | translate }}</label><div class=\"col-sm-9\"><six-lookup ng-model=\"record.lookup.printer_id\" sx-id=\"record.model.printer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-placeholder=\"{{ \'select_printer\' | translate}}...\" sx-type=\"\'label_printer\'\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-2 control-label\">{{ \"dry_cleaning.label\" | translate }}</label><div class=\"col-sm-10\"><six-lookup ng-model=\"record.lookup.label_id\" sx-id=\"record.model.label_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-placeholder=\"{{ \'select_label\' | translate}}...\" sx-type=\"\'label\'\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col-md-2 form-group override-form-group\"><button class=\"btn btn-primary\" style=\"width: 100%\" ng-click=\"createAndPrint()\" ng-disabled=\"settings.disableConfirm\">{{ \"dry_cleaning.confirm_and_print\" | translate }}</button></div><div class=\"col-md-2 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"quantity\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" ng-model=\"settings.quantity\" min=\"0\" step=\"1\"></div></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel panel-body\"><label class=\"i-checks\"><input type=\"checkbox\" ng-model=\"settings.checkAll\" ng-click=\"selectAll()\" ng-disabled=\"!result.list || result.list.length==0\"> <i></i> {{ \"dry_cleaning.select_all\" | translate }}</label><div class=\"barcode-header\">{{ \"dry_cleaning.generated_barcodes\" | translate }} <b>{{result.list.length}}</b></div><div ng-repeat=\"item in result.list\" class=\"col-md-3 barcode\"><label class=\"i-checks\"><input type=\"checkbox\" ng-model=\"item.checked\"> <i></i> {{item.barcode}} {{item.product_code}} - {{item.product_description}}</label></div></div></div></div>");
$templateCache.put("lm/dryCleaningSync/dry-cleaning-sync.html","<six-toolbar static-title=\"{{ \'shipment.select_for_sync\' | translate }}\"><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"{{\'back\' | translate}}\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-plus\" label=\"{{\'shipment.sync_DDT\' | translate}}\" btn-class=\"btn-info\" toolbar-function=\"launchSync(\'CUSTOMER_SHIPMENT\')\" ng-if=\"permission.UPDATE\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-plus\" label=\"{{\'shipment.sync_BASE\' | translate}}\" btn-class=\"btn-info\" toolbar-function=\"launchSync(\'BASE\')\" ng-if=\"permission.UPDATE\"></six-toolbar-button></six-toolbar><div class=\"wrapper-md m-t-xxl\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3\"><label>{{ \"barcode\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"advFilter.filter.barcode\"></div><div class=\"col-md-3\"><label>{{ \"shipment.ddt_number\" | translate }}</label> <input type=\"number\" class=\"form-control\" ng-model=\"advFilter.filter.ddt_number\"></div><div class=\"col-md-3\"><label>{{ \"bar\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"advFilter.filter.bar\"></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">{{ \"state\" | translate }}</label><six-enum sx-model=\"advFilter.filter\" sx-field=\"state\" sx-options=\"enum.state\" sx-readonly=\"readOnly\"></six-enum></div><div class=\"col-md-3\"><label>{{ \"from_date\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.ddt_date_from\"></six-date-picker></div><div class=\"col-md-3\"><label>{{ \"to_date\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.ddt_date_to\"></six-date-picker></div><div class=\"col-md-3\"><label>{{ \"shipment.delivery_date\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.delivery_date\"></six-date-picker></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">{{ \"shipment.integration_type\" | translate }}</label><six-enum sx-model=\"advFilter.filter\" sx-field=\"integration_type\" sx-options=\"enum.integration_type\" sx-readonly=\"readOnly\"></six-enum></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">{{ \"customer\" | translate }}</label><six-lookup ng-model=\"lookup.customer_id\" sx-filter=\"customerFilter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.customer_id\" sx-type=\"\'customer\'\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">{{ \"destination\" | translate }}</label><six-lookup ng-model=\"lookup.customer_destination\" sx-filter=\"shipmentDestinationFilter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.customer_destination\" sx-type=\"\'customer_destination\'\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">{{ \"billing_customer\" | translate }}</label><six-lookup ng-model=\"lookup.invoicing_customer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.invoicing_customer_id\" sx-type=\"\'customer\'\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">{{ \"type\" | translate }}</label><six-lookup ng-model=\"lookup.type_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.type_id\" sx-type=\"\'shipment_type\'\" sx-relational=\"true\" sx-hide-code=\"true\"></six-lookup></div></div></div></div><div class=\"panel panel-default\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"result\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div>");
$templateCache.put("lm/dryCleaningWashing/dry-cleaning-washing.html","<style>\n    .barcode-header {\n        background-color: #a5b3c7;\n        padding: 5px;\n        width: 100%;\n        padding-left: 9px;\n        color: white;\n        font: bold;\n    }\n</style><six-toolbar static-title=\"{{\'dry_cleaning.washing\' | translate }}\"><six-toolbar-button label=\"{{ \'back\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"{{ \'reset\' | translate }}\" icon=\"fa fa-undo\" toolbar-function=\"reset()\"></six-toolbar-button></six-toolbar><div class=\"override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"printer\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.printer_id\" sx-id=\"record.model.printer_id\" sx-type=\"\'label_printer\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\"></six-lookup></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"barcode\" | translate }}</label><six-code-reader sx-on-read=\"readBarcode(read)\" sx-read-mode=\"readerMode\" sx-disabled=\"settings.disableReader\"></six-code-reader></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel panel-body\"><div class=\"barcode-header\">{{ \"dry_cleaning.read_barcodes\" | translate }}</div><table class=\"table table-striped m-b-none\"><thead><tr><th class=\"col-md-1\"></th><th class=\"col-md-5\">Barcode</th><th>Risultato</th></tr></thead><tbody><tr ng-repeat=\"(barcode, item) in componentMap\"><td><i ng-if=\"item.status.loading\" class=\"fa fa-spinner fa-2x fa-pulse fa-fw text-info-dker\"></i> <button ng-if=\"item.status.saved\" class=\"btn btn-info\" ng-click=\"printById(item.component.id)\"><span class=\"fa fa-print\"></span></button></td><td><div>{{item.component.barcode}}</div></td><td><div ng-class=\"{\'text-danger\': !item.status.saved, \'text-success\': item.status.saved}\">{{item.status.message}}</div></td></tr></tbody></table></div></div></div>");
$templateCache.put("lm/employee/employee_detail.html","<six-toolbar title=\"pageTitle\"><six-toolbar-button label=\"Indietro\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"padder-md m-t-toolbar\"><uib-tabset justified=\"false\" active=\"activeTab\" class=\"tab-container\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"tab-heading\">Testata</span></uib-tab-heading><div ng-include=\"\'lm/employee/employee_tabHead.html\'\" ng-if=\"element\"></div></uib-tab><uib-tab index=\"1\"><uib-tab-heading><span class=\"tab-heading\">Storico</span></uib-tab-heading><div ng-include=\"\'lm/employee/employee_tabHistory.html\'\"></div></uib-tab><uib-tab index=\"2\"><uib-tab-heading><span class=\"tab-heading\">Componenti</span></uib-tab-heading><div ng-include=\"\'lm/employee/employee_tabComponents.html\'\"></div></uib-tab></uib-tabset></div>");
$templateCache.put("lm/employee/employee_list.html","<six-toolbar title=\"\'Dipendenti\'\"><six-toolbar-button label=\"Indietro\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"padder-md m-t-toolbar\"><div class=\"row\"><div class=\"col-md-4 m-t-xs\"><label id=\"type_label\" class=\"control-label\">Dipendente</label><six-lookup ng-model=\"lookup.employee_id\" sx-filter=\"lookup.employee_id.filter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.employee_id\" sx-type=\"\'human_resource\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-hide-code=\"true\" sx-sort-fields=\"[\'surname\',\'name\']\"></six-lookup></div><div class=\"col-md-4 m-t-xs\"><label id=\"type_label\" class=\"control-label\">Presidio Uso DPI</label><six-lookup ng-model=\"lookup.customer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.customer_id\" sx-type=\"\'customer\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-disabled=\"lockCustomer\" sx-filter=\"customerFilter\"></six-lookup></div><div class=\"col-md-4 m-t-xs\"><label id=\"type_label\" class=\"control-label\">Sede di utilizzo DPI</label><six-lookup ng-model=\"lookup.destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.destination_id\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-disabled=\"lockCustomer\" sx-filter=\"lookup.destination_id.filter\"></six-lookup></div><div class=\"col-md-4 m-t-xs\"><label id=\"type_label\" class=\"control-label\">U.O./Servizio di appartenenza</label><six-lookup ng-model=\"lookup.customer_cost_center_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.customer_cost_center_id\" sx-type=\"\'customer_cost_center\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-disabled=\"lockCustomer\" sx-filter=\"lookup.customer_cost_center_id.filter\"></six-lookup></div><div class=\"col-md-4 m-t-xs\"><label id=\"type_label\" class=\"control-label\">Punto di consegna dpi</label><six-lookup ng-model=\"lookup.delivery_destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.delivery_destination_id\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-disabled=\"lockCustomer\" sx-filter=\"lookup.delivery_destination_id.filter\"></six-lookup></div></div></div><div class=\"wrapper-md\"><div class=\"panel panel-default\"><six-grid-pagination ng-if=\"sf\" get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"list\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div>");
$templateCache.put("lm/employee/employee_tabComponents.html","<div class=\"row\"><div class=\"col-md-12\"><six-detail-grid sx-entity=\"component\" sx-detail-link=\"componentDetailLink\"></six-detail-grid></div></div>");
$templateCache.put("lm/employee/employee_tabHead.html","<div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Matricola sistema</label> <input type=\"text\" class=\"form-control\" placeholder=\"Matricola\" ng-model=\"element.matriculation\" ng-readonly=\"readOnly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Cognome</label> <input type=\"text\" class=\"form-control\" placeholder=\"Cognome\" ng-model=\"element.surname\" ng-readonly=\"readOnly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Nome</label> <input type=\"text\" class=\"form-control\" placeholder=\"Nome\" ng-model=\"element.name\" ng-readonly=\"readOnly\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Sesso</label><six-enum ng-if=\"element\" sx-model=\"element\" sx-field=\"sex\" sx-options=\"enum.sex\" sx-readonly=\"readOnly\"></six-enum></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Qualifica</label><six-lookup ng-model=\"lookup.work_task_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.work_task_id\" sx-type=\"\'work_task\'\" sx-placeholder=\"Seleziona qualifica...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>AUSL</label><six-lookup ng-model=\"lookup.bill_to_customer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.bill_to_customer_id\" sx-type=\"\'customer\'\" sx-placeholder=\"Seleziona AUSL...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Presidio Uso DPI</label><six-lookup ng-model=\"customerLookup.customer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"customer.id\" sx-type=\"\'customer\'\" sx-placeholder=\"Seleziona ospedale...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Sede di utilizzo dpi</label><six-lookup ng-model=\"lookup.destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.destination_id\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona reparto...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Assegnazione taglie</label><six-date-picker ng-model=\"element.first_size_assignment\" sx-disabled=\"readOnly\"></six-date-picker></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>U.O./Servizio di appartenenza</label><six-lookup ng-model=\"lookup.customer_cost_center_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.customer_cost_center_id\" sx-type=\"\'customer_cost_center\'\" sx-placeholder=\"Seleziona CdC...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Punto di consegna dpi</label><six-lookup ng-model=\"lookup.delivery_destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.delivery_destination_id\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona reparto...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Prima vestizione</label><six-date-picker ng-model=\"element.first_component_association\" sx-disabled=\"readOnly\"></six-date-picker></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Fine servizio</label><six-date-picker ng-model=\"element.validity_end\" sx-disabled=\"readOnly\"></six-date-picker></div></div><div class=\"col-md-8\"><div class=\"form-group\"><label>Note</label> <textarea class=\"sf-form-control form-control\" ng-model=\"element.note\" ng-disabled=\"readOnly\"></textarea></div></div></div>");
$templateCache.put("lm/employee/employee_tabHistory.html","<div class=\"row\"><div class=\"col-md-12\"><six-detail-grid sx-entity=\"employee_history\" sx-detail-button=\"false\"></six-detail-grid></div></div>");
$templateCache.put("lm/endowmentplan/endowmentplan.html","<div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Pianificazione avanzata</h1></div><div class=\"col-sm-6 text-right hidden-xs\"><div class=\"inline m-r text-left\" ng-hide=\"selected\"><a ng-click=\"exit()\" class=\"btn btn-default pull-left\" id=\"btn_exit\"><span class=\"glyphicon glyphicon-menu-left\"></span>Esci</a> <a ng-click=\"save()\" class=\"btn btn-success pull-left\" id=\"btn_save\" style=\"margin-left: 10px\"><span class=\"glyphicon glyphicon-save\"></span>Salva</a></div><div class=\"inline m-r text-left\" ng-show=\"selected\"><button ng-click=\"unselectRecord()\" type=\"button\" class=\"btn btn-default btn-sm pull-left\"><span class=\"glyphicon glyphicon-menu-left\"></span> Torna</button> <span class=\"pull-left\">&nbsp;</span> <button type=\"submit\" class=\"btn btn-success btn-sm pull-left\" ng-click=\"confirmPreparation()\" id=\"btn_create\"><span class=\"glyphicon glyphicon-save\"></span> Conferma</button> <span class=\"pull-left\" style=\"margin-left: 10px\">&nbsp;</span> <a ng-confirm-message=\"Confermare la cancellazione?\" ng-confirm-click=\"deletePreparation()\" ng-confirm-condition=\"true\" class=\"btn btn-danger btn-sm pull-right\"><span class=\"glyphicon glyphicon-trash\"></span> Cancella</a></div></div></div></div><div class=\"panel wrapper\"><div class=\"row\" ng-hide=\"selected\"><div class=\"form-group\" ng-if=\"false\"><a ng-click=\"exit()\" class=\"btn btn-default pull-left\" id=\"btn_exit_2\"><span class=\"glyphicon glyphicon-menu-left\"></span>Esci</a> <a ng-click=\"save()\" class=\"btn btn-success pull-left\" id=\"btn_save_2\" style=\"margin-left: 10px\"><span class=\"glyphicon glyphicon-save\"></span>Salva</a></div><div><table id=\"user_list\" class=\"table table-striped\"><thead><tr><th></th><th class=\"s\">Giorno</th><th class=\"s\">Ora</th><th class=\"s\">Tipo preparazione</th><th class=\"s\">Consegne</th><th class=\"s\">% consegnata</th><th></th></tr></thead><tbody><tr ng-repeat=\"m in model.preparations | filter:search\"><td><a ng-click=\"getPreparationDetail(m)\" class=\"btn btn-primary\" id=\"btn_user_detail\"><span class=\"glyphicon glyphicon-pencil\"></span></a></td><td>{{dayName(m.dow)}}</td><td>{{timeToString(m.hours, m.minutes)}}</td><td>{{modeName(m.mode)}}</td><td><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">Consegne <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"delivery in m.deliveries\">{{dayName(delivery.dow)}} {{timeToString(delivery.hours, delivery.minutes)}} - {{delivery.value | number}}%</li></ul></div></td><td><uib-progressbar max=\"max\" value=\"preparationTotal(m)\" style=\"box-shadow: 2px 2px 4px 0px #666666\"><span style=\"color:white; white-space:nowrap; font-size:14px\">{{preparationTotal(m)}}%</span></uib-progressbar></td><td><a ng-confirm-message=\"Confermare la cancellazione?\" ng-confirm-click=\"deletePreparationFromList($index)\" ng-confirm-condition=\"true\" class=\"btn btn-danger btn-sm pull-right\"><span class=\"glyphicon glyphicon-trash\"></span></a></td></tr><tr ng-hide=\"model.preparations.length\"><td colspan=\"6\"><p class=\"text-center\">Nessuna pianificazione inserita</p></td></tr><tr><td colspan=\"6\"><a ng-click=\"createPreparation()\" class=\"btn btn-primary pull-left\" id=\"btn_matrix_refresh\"><span class=\"glyphicon glyphicon-plus\"></span> Aggiungi Pianificazione</a></td></tr></tbody></table><div class=\"row text-center\"><pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"matrix.totalResults\" ng-model=\"matrix.currentPage\" class=\"pagination-sm\" items-per-page=\"matrix.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></pagination></div><hr><div ng-repeat=\"alert in alerts\"><div class=\"alert alert-danger alert-dismissible\" role=\"alert\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button> <strong>Warning!</strong> {{alert.msg}}</div></div></div></div><div class=\"row\" ng-if=\"selected\"><div class=\"col-sm-12\" ng-if=\"false\"><button ng-click=\"unselectRecord()\" type=\"button\" class=\"btn btn-default btn-sm pull-left\"><span class=\"glyphicon glyphicon-menu-left\"></span> Torna</button> <span class=\"pull-left\">&nbsp;</span> <button type=\"submit\" class=\"btn btn-success btn-sm pull-left\" ng-click=\"confirmPreparation()\"><span class=\"glyphicon glyphicon-save\"></span> Conferma</button> <a ng-confirm-message=\"Confermare la cancellazione?\" ng-confirm-click=\"deletePreparation()\" ng-confirm-condition=\"true\" class=\"btn btn-danger btn-sm pull-right\"><span class=\"glyphicon glyphicon-trash\"></span> Cancella</a></div><div class=\"col-sm-12\"><form class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"dt_day\">Giorno rientro</label><div class=\"col-md-10\"><button id=\"dt_day\" type=\"button\" class=\"btn dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"width: 90px; color:black;\">{{dayName(selected.dow)}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"day in daysOfTheWeek\"><a ng-bind=\"day.name\" ng-click=\"selectDay(day, selected)\"></a></li></ul></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">Ora</label><div class=\"col-md-10\"><uib-timepicker id=\"dt_time\" ng-model=\"preparationDate\" show-meridian=\"false\" show-spinners=\"false\" ng-change=\"applyTime(selected, preparationDate)\"></uib-timepicker></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"dt_mode\">Tipo preparazione</label><div class=\"col-md-10\"><button id=\"dt_mode\" type=\"button\" class=\"btn dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"width: 200px; color:black;\">{{modeName(selected.mode)}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"mode in preparationModes\"><a ng-bind=\"mode.name\" ng-click=\"selectMode(mode, selected)\"></a></li></ul></div></div><hr><uib-progressbar class=\"progress-striped active\" value=\"percentage\" type=\"{{type}}\" style=\"box-shadow: 2px 2px 4px 0px #666666\">{{percentage}}%</uib-progressbar><div class=\"form-group\"><table id=\"delivery_list\" class=\"table table-striped\"><thead><tr><th></th><th class=\"s\">Giorno</th><th class=\"s\">Ora</th><th class=\"s\">% consegna</th><th></th></tr></thead><tbody><tr ng-repeat=\"delivery in selected.deliveries\"><td class=\"btn-group\"><a ng-click=\"deleteDelivery(delivery)\" class=\"btn btn-danger btn-sm pull-left\"><span class=\"glyphicon glyphicon-trash\"></span></a></td><td><div class=\"btn-group\"><button type=\"button\" class=\"btn dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"width: 90px; color:black;\">{{dayName(delivery.dow)}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"day in daysOfTheWeek\"><a ng-bind=\"day.name\" ng-click=\"selectDay(day, delivery)\"></a></li></ul></div></td><td><uib-timepicker ng-model=\"times[$index]\" show-meridian=\"false\" show-spinners=\"false\" ng-change=\"applyTime(delivery, times[$index])\"></uib-timepicker></td><td><input type=\"number\" class=\"form-control\" ng-model=\"delivery.value\" max=\"100\" min=\"0\" ng-change=\"calcPercentage()\" title=\"Percentuale di consegna\"></td></tr><tr><td colspan=\"4\"><a ng-click=\"createDelivery()\" class=\"btn btn-primary pull-left\" id=\"btn_add_delivery\"><span class=\"glyphicon glyphicon-plus\"></span> Aggiungi Consegna</a></td></tr></tbody></table></div><div ng-repeat=\"alert in alerts\"><div class=\"alert alert-danger alert-dismissible\" role=\"alert\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button> <strong>Warning!</strong> {{alert.msg}}</div></div></form></div></div></div>");
$templateCache.put("lm/guestsRebaser/guestsrebaser.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"Esci\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-close\" label=\"Svuota\" btn-class=\"btn-danger\" toolbar-function=\"setEmpty()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-arrow-up\" label=\"Carico\" btn-class=\"btn-primary\" toolbar-function=\"setLoad(true)\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-arrow-down\" label=\"Scarico\" btn-class=\"btn-primary\" toolbar-function=\"setLoad(false)\"></six-toolbar-button></six-toolbar><div ng-if=\"load\"><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Carico: {{element.description}}</h1></div></div></div><ul class=\"nav nav-pills rebaser\"><six-toolbar-button icon=\"fa fa-table\" label=\"Vis. tabella\" btn-class=\"btn-default\" ng-class=\"{active: type == \'TABLE\'}\" toolbar-function=\"setType(\'TABLE\')\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-bars\" label=\"Vis. lista\" btn-class=\"btn-default\" ng-class=\"{active: type == \'LIST\'}\" toolbar-function=\"setType(\'LIST\')\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-user\" label=\"Capi Mancanti\" btn-class=\"btn-default\" ng-class=\"{active: type == \'MISSING_COMPONENTS\'}\" toolbar-function=\"setType(\'MISSING_COMPONENTS\')\" ng-click=\"initMissingComponents()\"></six-toolbar-button></ul><div class=\"clearfix\"></div><div class=\"panel-body\"><div ng-include=\"\'lm/guestsRebaser/load/guestsrebaser_load_panel.html\'\"></div></div></div></div></div><div ng-if=\"!load\"><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Scarico: {{element.description}}</h1></div></div></div><div class=\"panel-body\"><div ng-include=\"\'lm/guestsRebaser/unload/guestsrebaser_unload_panel.html\'\"></div></div></div></div></div><hr>");
$templateCache.put("lm/highVisibilityComponent/high_visibility_component_attachments.html","<six-toolbar><six-toolbar-button label=\"Indietro\" icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Reset\" icon=\"fa fa-undo\" toolbar-function=\"reset()\"></six-toolbar-button></six-toolbar><div class=\"constructor\"><div class=\"page-title m-t-md m-t-toolbar\"><h1 class=\"m-n font-thin\">Visualizza allegati</h1></div><six-sidebar sx-id=\"sidebar\" class=\"\" sx-position=\"right\" sx-title=\"translateValue(\'attachments\')\" sx-dimension=\"l\" sx-opened=\"attachments.show\" sx-pinnable=\"false\" sx-pinned=\"true\"><div class=\"col-xs-2\"><b>{{ \"barcode\" | translate }}</b></div><div class=\"col-xs-10\">{{attachments.selItem.barcode}}</div><div class=\"col-xs-2\"><b>{{ \"unicode\" | translate }}</b></div><div class=\"col-xs-10\">{{attachments.selItem.unicode}}</div><div class=\"col-xs-2\"><b>{{ \"product\" | translate }}</b></div><div class=\"col-xs-10\">{{attachments.selItem.product_description}}</div><br><div class=\"padder m-t-xxl\"><six-statix path=\"attachments.selItem.unicode\" ng-model=\"attachments.model\" show-upload=\"false\" show-preview=\"false\" show-delete=\"false\" sort-by-name=\"true\"></six-statix></div></six-sidebar><div class=\"padder-md\"><div class=\"row\"><div class=\"col-md-3\"><label>{{ \"barcode\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"advFilter.filter.barcode\"></div><div class=\"col-md-3\"><label>{{ \"unicode\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"advFilter.filter.unicode\"></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">{{ \"product\" | translate }}</label><six-lookup ng-model=\"lookup.product_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.product_id\" sx-type=\"\'product\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">{{ \"operator\" | translate }}</label><six-lookup ng-model=\"lookup.employee_id\" sx-filter=\"employeeFilter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.employee_id\" sx-type=\"\'human_resource\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-hide-code=\"true\" sx-sort-fields=\"[\'surname\',\'name\']\"></six-lookup></div></div><div class=\"row\"><div class=\"col-md-2\"><label id=\"type_label\" class=\"control-label\">{{ \"size\" | translate }}</label><six-lookup ng-model=\"lookup.size_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.size_id\" sx-type=\"\'tab_size\'\" sx-placeholder=\"\" sx-relational=\"true\" sx-hide-code=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">{{ \"customer\" | translate }}</label><six-lookup ng-model=\"lookup.customer_id\" sx-filter=\"customerFilter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.customer_id\" sx-refresh-list=\"customersList\" sx-type=\"\'customer\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-on-refresh=\"selectCustomerIfUnique()\" sx-disabled=\"disable.customer\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">{{ \"customer_destination_REP\" | translate }}</label><six-lookup ng-model=\"lookup.customer_destination_id\" sx-filter=\"shipmentDestinationFilter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.customer_destination_id\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-2\"><label>{{ \"from_date\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.dateFrom\"></six-date-picker></div><div class=\"col-md-2\"><label>{{ \"to_date\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.dateTo\"></six-date-picker></div></div></div><div class=\"wrapper-md\"><div class=\"panel panel-default\"><six-grid-pagination get-data-callback=\"applyFilter()\" get-list-callback=\"applyFilter()\" items-list=\"list\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div><high-visibility-component-history-modal sx-msg=\"component_msg\"></high-visibility-component-history-modal>");
$templateCache.put("lm/highVisibilityComponent/high_visibility_component_detail.html","<six-toolbar><six-toolbar-button label=\"Indietro\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"page-title override-padding-toolbar\"><h1 class=\"m-n font-thin\">{{pageTitle}} <span ng-if=\"waitDelete\" class=\"fa fa-refresh fa-spin\"></span></h1></div><div class=\"wrapper-md\"><uib-tabset justified=\"false\" active=\"activeTab\" class=\"tab-container\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"tab-heading\">Testata</span></uib-tab-heading><div ng-include=\"\'lm/highVisibilityComponent/high_visibility_component_tabHead.html\'\" ng-if=\"element\"></div></uib-tab><uib-tab index=\"1\"><uib-tab-heading><span class=\"tab-heading\">Allegati</span></uib-tab-heading><div ng-include=\"\'lm/highVisibilityComponent/high_visibility_component_tabAttachment.html\'\"></div></uib-tab></uib-tabset></div>");
$templateCache.put("lm/highVisibilityComponent/high_visibility_component_list.html","<six-toolbar><six-toolbar-button label=\"Indietro\" icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Reset\" icon=\"fa fa-undo\" toolbar-function=\"reset()\"></six-toolbar-button></six-toolbar><div class=\"page-title m-t-toolbar\"><h1 class=\"m-n font-thin\">Componenti</h1></div><div class=\"padder-md\"><div class=\"row\"><div class=\"col-md-3\"><label>Barcode</label> <input type=\"text\" class=\"form-control\" ng-model=\"advFilter.filter.barcode\"></div><div class=\"col-md-3\"><label>Unicode</label> <input type=\"text\" class=\"form-control\" ng-model=\"advFilter.filter.unicode\"></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">Articolo</label><six-lookup ng-model=\"lookup.product_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.product_id\" sx-type=\"\'product\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">Taglia</label><six-lookup ng-model=\"lookup.size_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.size_id\" sx-type=\"\'tab_size\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-hide-code=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">Dipendente</label><six-lookup ng-model=\"lookup.employee_id\" sx-filter=\"lookup.employee_id.filter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.employee_id\" sx-type=\"\'human_resource\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-hide-code=\"true\" sx-sort-fields=\"[\'surname\',\'name\']\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">Cliente</label><six-lookup ng-model=\"lookup.customer_id\" sx-filter=\"customerFilter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.customer_id\" sx-type=\"\'customer\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-disabled=\"lockCustomer\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">Lotto</label><six-lookup ng-model=\"lookup.lot_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.lot_id\" sx-type=\"\'lot\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-hide-code=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">Destinazione cliente</label><six-lookup ng-model=\"lookup.current_destination_id\" sx-filter=\"lookup.current_destination_id.filter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.current_destination_id\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-hide-code=\"true\"></six-lookup></div></div></div><div class=\"wrapper-md\"><div class=\"panel panel-default\"><six-grid-pagination ng-if=\"sf\" get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"list\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div>");
$templateCache.put("lm/highVisibilityComponent/high_visibility_component_tabAttachment.html","<div class=\"row\"><div class=\"col-md-12\"><six-statix path=\"statix.path\" ng-model=\"statix.model\" show-upload=\"isUploadAllowed\" show-preview=\"false\" show-delete=\"isDeleteAllowed\"></six-statix></div></div>");
$templateCache.put("lm/highVisibilityComponent/high_visibility_component_tabHead.html","<div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Barcode</label> <input type=\"text\" class=\"form-control\" placeholder=\"Barcode\" ng-model=\"element.barcode\" ng-readonly=\"readOnly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Unicode</label> <input type=\"text\" class=\"form-control\" placeholder=\"Unicode\" ng-model=\"element.unicode\" ng-readonly=\"readOnly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Lavaggi</label> <input type=\"number\" class=\"form-control\" ng-model=\"element.wash_num\" ng-readonly=\"readOnly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Articolo</label><six-lookup ng-model=\"lookup.product_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.product_id\" sx-type=\"\'product\'\" sx-placeholder=\"Seleziona articolo...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Colore</label><six-lookup ng-model=\"lookup.color_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.color_id\" sx-type=\"\'color\'\" sx-placeholder=\"Seleziona colore...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Dipendente</label><six-lookup ng-model=\"lookup.employee_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.employee_id\" sx-type=\"\'human_resource\'\" sx-placeholder=\"Seleziona dipendente...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Taglia</label><six-lookup ng-model=\"lookup.size_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.size_id\" sx-type=\"\'tab_size\'\" sx-placeholder=\"Seleziona taglia...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Lotto</label><six-lookup ng-model=\"lookup.lot_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.lot_id\" sx-type=\"\'lot\'\" sx-placeholder=\"Seleziona lotto...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Peso</label> <input type=\"number\" class=\"form-control\" ng-model=\"element.weight\" ng-readonly=\"readOnly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Uso</label><six-enum ng-if=\"element\" sx-model=\"element\" sx-field=\"special_use\" sx-options=\"enum.special_use\" sx-readonly=\"readOnly\"></six-enum></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Destinazione cliente</label><six-lookup ng-model=\"lookup.current_destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.current_destination_id\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona sede...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div></div>");
$templateCache.put("lm/inventoryReport/inventory-report.html","<div class=\"override-padding-toolbar\"><six-toolbar title=\"customTitle\"></six-toolbar><div class=\"row\"><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-2 control-label\">Cliente Fatturazione</label><div class=\"col-sm-10\"><six-lookup ng-model=\"record.lookup.billCustomer\" sx-id=\"record.model.billCustomer\" sx-type=\"\'customer\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"billCustomerFilter\" sx-on-select=\"onBillCustomerChange()\" sx-on-clear=\"onBillCustomerChange()\"></six-lookup></div></div><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-3 control-label\">Presidio</label><div class=\"col-sm-9\"><six-lookup ng-model=\"record.lookup.customer\" sx-id=\"record.model.customer\" sx-type=\"\'customer\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"customerFilter\" sx-on-select=\"onCustomerChange()\" sx-on-clear=\"onCustomerChange()\"></six-lookup></div></div><div class=\"col-md-3 form-group override-form-group\" ng-hide=\"!inventoryDash\"><label class=\"col-sm-5 control-label\">Fascia Temporale</label><div class=\"col-sm-7\"><select ng-model=\"selectedTime\" class=\"form-control\"><option ng-repeat=\"t in times\" value=\"{{t}}\">{{t}}</option></select></div></div></div><div class=\"row\"><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-2 control-label\">{{ \"product\" | translate }}</label><div class=\"col-sm-10\"><six-lookup ng-model=\"record.lookup.product\" sx-id=\"record.model.product\" sx-type=\"\'product\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"productFilter\"></six-lookup></div></div><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-3 control-label\">Destinazione</label><div class=\"col-sm-9\"><six-lookup ng-model=\"record.lookup.ward\" sx-id=\"record.model.ward\" sx-type=\"\'customer_destination\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"wardFilter\" sx-on-select=\"onWardChange()\" sx-on-clear=\"onWardChange()\"></six-lookup></div></div><div class=\"col-md-3 form-group override-form-group\"><div class=\"row\"><label class=\"col-sm-5 control-label\">Escludi destinazione</label><div class=\"col-sm-2\"><input type=\"checkbox\" ng-model=\"negate\"></div><div class=\"col-sm-3\"><button ng-click=\"resetFilters()\" class=\"btn btn-info btn-sm pull-right\"><span class=\"fa fa-redo\"></span>RESET</button></div></div></div></div><div class=\"row\"><div class=\"col-md-3 form-group override-form-group\" ng-hide=\"!intervalDash\"><label class=\"col-sm-2 control-label\">Da</label><div class=\"col-sm-10\"><six-date-picker id=\"date_from\" name=\"date_from\" ng-model=\"from_date\"></six-date-picker></div></div><div class=\"col-md-3 form-group override-form-group\" ng-hide=\"!intervalDash\"><label class=\"col-sm-2 control-label\">A</label><div class=\"col-sm-10\"><six-date-picker id=\"date_to\" name=\"date_to\" ng-model=\"to_date\"></six-date-picker></div></div></div><div><iframe id=\"kFrame\" src=\"{{ getKibanaURL() | trustAsResourceUrl }}\" width=\"100%\" height=\"1000\" frameborder=\"0\"></iframe></div></div>");
$templateCache.put("lm/lockerProductAssociation/lockerProductAssociation.html","<six-toolbar><six-toolbar-button label=\"{{ \'back\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"override-padding-toolbar\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"m-n font-thin\">{{ \"locker_stock.locker_product_association_title\" | translate }}</h1></div></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"locker_stock.locker\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.control_reason_id\" sx-id=\"record.model.control_reason_id\" sx-type=\"\'control_reason\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"controlReasonFilter\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"locker_stock.product_label\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.product_id\" sx-id=\"record.model.product_id\" sx-type=\"\'product\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"productFilter\" sx-sort-fields=\"[\'description\']\"></six-lookup></div></div><div class=\"col-md-1\"></div><div class=\"col-md-3\"><div class=\"row\"><label for=\"qty\" class=\"col-sm-3 control-label\">{{ \"locker_stock.total_amount\" | translate }}</label><div class=\"col-sm-3\"><input id=\"qty\" type=\"text\" class=\"input-md form-control\" ng-model=\"quantity\"></div><div class=\"col-sm-6\"><button type=\"submit\" class=\"btn btn-success btn-md\" ng-show=\"enableSave\" ng-click=\"save()\" id=\"btn_save\">{{ \"locker_stock.save_button\" | translate }}</button></div></div></div></div><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"locker_stock.size_label\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.size_id\" sx-id=\"record.model.size_id\" sx-type=\"\'tab_size\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"sizeFilter\" sx-disabled=\"disableSize\" sx-hide-code=\"true\"></six-lookup></div></div></div></div></div><div class=\"panel panel-default\" ng-show=\"viewGridOptions.data.length > 0\"><six-grid-pagination items-list=\"viewGridOptions.data\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\"></six-grid-pagination></div></div>");
$templateCache.put("lm/lockerStock/lockerStock.html","<six-toolbar><six-toolbar-button label=\"{{ \'back\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"override-padding-toolbar\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"m-n font-thin\">{{ \"locker_stock.locker_stock\" | translate }}</h1></div></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"locker_stock.locker\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.control_reason_id\" sx-id=\"record.model.control_reason_id\" sx-type=\"\'control_reason\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"controlReasonFilter\"></six-lookup></div></div><div class=\"col-md-6\" ng-if=\"unknownList.length>0\"><div class=\"alert alert-warning\" role=\"alert\">{{ \"locker_stock.warning_not_found\" | translate }} <span ng-repeat=\"unicode in unknownList\">{{unicode}}</span></div></div></div></div></div><div class=\"panel panel-default\" ng-show=\"viewGridOptions.data.length > 0\"><six-grid-pagination items-list=\"viewGridOptions.data\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\"></six-grid-pagination></div></div>");
$templateCache.put("lm/magazzino/vis-giacenza.html","<div class=\"page-title m-t-md\"><h1 class=\"m-n font-thin\">{{ \"Giacenze\" }}</h1></div><div class=\"wrapper-md\" ng-cloak=\"\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"Magazzino\" }}</label><six-lookup ng-model=\"lookup.facility\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'facility\'\" sx-id=\"filters.facility\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"Articolo\" }}</label><six-lookup ng-model=\"lookup.product\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'product\'\" sx-id=\"filters.product\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"Fornitore\" | translate }}</label><six-lookup ng-model=\"lookup.supplier\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'supplier\'\" sx-id=\"filters.supplier\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"Lotto\" }}</label><six-lookup ng-model=\"lookup.lot\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'lot\'\" sx-id=\"filters.lot\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"Destinazione\" }}</label><six-lookup ng-model=\"lookup.destination\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'customer_destination\'\" sx-id=\"filters.destination\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"Cliente\" }}</label><six-lookup ng-model=\"lookup.customer\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'customer\'\" sx-id=\"filters.customer\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"Colore\" }}</label><six-lookup ng-model=\"lookup.color\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'color\'\" sx-id=\"filters.color\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"Taglia\" }}</label><six-lookup ng-model=\"lookup.size\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'tab_size\'\" sx-id=\"filters.size\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-2 col-lg-2\"><label>{{ \"Alla data\" }}</label><six-date-picker ng-model=\"filters.toDate\"></six-date-picker></div><div class=\"col-md-2 col-lg-2\"><label>{{ \"Tipo parte\" }}</label><six-lookup ng-model=\"lookup.partType\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'part_type\'\" sx-id=\"filters.partType\" sx-relational=\"true\"></six-lookup></div></div><div class=\"row\"><div class=\"col-md-12\"><label>{{ \'warehouse_storage.aggregations\' | translate }}:</label><six-select-2 ng-model=\"aggs\" sx-multiple=\"true\" sx-compact=\"true\" sx-list=\"aggregations\" sx-on-select=\"aggsRequestChanged()\" sx-show-key=\"false\"></six-select-2></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"panel panel-default\"><six-grid-pagination get-data-callback=\"requestChanged($params)\" grid-options=\"viewGridOptions\"></six-grid-pagination></div></div></div></div>");
$templateCache.put("lm/moveToDestination/move-to-destination.html","<style>\n    .barcode-header {\n        background-color: #a5b3c7;\n        padding: 5px;\n        width: 100%;\n        padding-left: 9px;\n        color: white;\n        font: bold;\n    }\n</style><six-toolbar static-title=\"{{\'dry_cleaning.move_title\' | translate }}\"><six-toolbar-button label=\"{{ \'back\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"dry_cleaning.from_destination\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.fromDest\" sx-id=\"record.model.fromDest\" sx-type=\"\'customer_destination\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\"></six-lookup></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"dry_cleaning.to_destination\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.toDest\" sx-id=\"record.model.toDest\" sx-type=\"\'customer_destination\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><button class=\"btn btn-primary\" style=\"width: 100%\" ng-click=\"confirm()\" ng-disabled=\"disableConfirm\">{{ \"confirm\" | translate }}</button></div></div></div><div class=\"panel panel-default\"><div class=\"panel panel-body\"><table class=\"table table-striped m-b-none\"><thead><tr><th class=\"col-md-3\">{{\'Matricola\' | translate}}</th><th class=\"col-md-3\">{{\'Nome\' | translate}}</th><th class=\"col-md-3\">{{\'Cognome\' | translate}}</th><th class=\"col-md-3\">{{\'Discriminante\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"hr in hrList\"><td><div>{{hr.matricola}}</div></td><td><div>{{hr.nome}}</div></td><td><div>{{hr.cognome}}</div></td><td><div>{{hr.discriminante}}</div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("lm/packSingleComponent/packSingleComponent_detail.html","<style>\n    .alert-info {\n        font-size: 22px;\n    }\n</style><six-toolbar title=\"title\"><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"{{\'back\' | translate}}\" ng-click=\"closeOrderAndBack()\"></six-toolbar-button></six-toolbar><div class=\"override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-4\"><label class=\"control-label\">{{ \"unicode\" | translate }}</label><six-code-reader sx-on-read=\"onRead(read)\" sx-read-mode=\"readerMode\"></six-code-reader></div><div class=\"col-md-4\"><label class=\"control-label\">{{\'customer_destination\' | translate }}</label><six-lookup ng-model=\"record.lookup.customer\" sx-id=\"record.model.customer\" sx-type=\"\'customer\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-disabled=\"true\" sx-preselect-if-one=\"true\" sx-filter=\"record.filter.customer\"></six-lookup></div><div class=\"col-md-4\"><label class=\"control-label\">{{\'customer\' | translate }}</label><six-lookup ng-model=\"record.lookup.customer_destination\" sx-id=\"record.model.customer_destination\" sx-type=\"\'customer_destination\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-disabled=\"true\" sx-preselect-if-one=\"true\" sx-filter=\"record.filter.customer_destination\"></six-lookup></div></div></div></div><div class=\"alert alert-info\" ng-if=\"alertMessage\"><div class=\"row\"><div class=\"col-md-9\">{{alertMessage}}</div><div class=\"col-md-3 pull-right\"><div class=\"btn btn-default\" ng-click=\"goToList()\">{{ \"pack_single.back_to_list\" | translate }}</div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"panel panel-default\"><div class=\"barcode-header\">{{ \"pack_single.single_component_rows\" | translate }}</div><div class=\"panel-body\"><table class=\"table table-striped m-b-none\"><thead><tr><th>{{ \"product\" | translate }}</th><th class=\"col-md-5\">{{ \"pack_single.progress\" | translate }}</th><th class=\"col-md-1\"></th></tr></thead><tbody><tr ng-repeat=\"item in orderRows\"><td><div>{{item.prod_code}} - {{item.prod_desc}}</div><div class=\"text-danger\">{{item.status.message}}</div></td><td><div class=\"progress\" style=\"margin-bottom: 0;\"><div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ \'width\': item.progress + \'%\' }\"></div></div></td><td>{{item.dispatched_amount}}/{{item.stock_amount}}</td></tr></tbody></table></div></div></div><div class=\"col-md-6\"><div class=\"panel panel-default\"><div class=\"panel-body\"><table class=\"table table-striped m-b-none\"><thead><tr><th>{{ \"unicode\" | translate }}</th><th>{{ \"pack_single.result\" | translate }}</th></tr></thead><tbody><tr ng-repeat=\"item in components\"><td>{{item.unicode}}</td><td><div ng-class=\"{\'text-danger\': item.error, \'text-success\': item.success, \'text-warning-dker\': item.warning}\">{{item.result}}</div></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("lm/packSingleComponent/packSingleComponent_list.html","<six-toolbar static-title=\"{{ \'pack_single.single_pack_list_title\' | translate}}\"><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"{{\'back\' | translate}}\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Reset\" btn-class=\"btn-warning\" icon=\"fa fa-refresh\" toolbar-function=\"reset()\"></six-toolbar-button></six-toolbar><div class=\"wrapper-md m-t-xxl\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3\"><label>{{ \"number\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"advFilter.filter.co_number\"></div><div class=\"col-md-3\"><label>{{ \"pack_single.delivery_date\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.delivery_date\"></six-date-picker></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">{{ \"customer\" | translate }}</label><six-lookup ng-model=\"lookup.customer\" sx-filter=\"customerFilter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.customer_id\" sx-type=\"\'customer\'\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">{{ \"destination\" | translate }}</label><six-lookup ng-model=\"lookup.customer_destination\" sx-filter=\"shipmentDestinationFilter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.customer_destination_id\" sx-type=\"\'customer_destination\'\" sx-relational=\"true\"></six-lookup></div></div></div></div><div class=\"panel panel-default\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div>");
$templateCache.put("lm/packagingSerialKit/packagingSerialKit.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"Indietro\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"pull-right\"><label class=\"i-checks\"><input type=\"checkbox\" ng-model=\"modeAuto\"> <i></i> Modalità automatica</label></div><h1 class=\"m-n font-thin h3 text-black\">Confezionamento kit <strong ng-if=\"bom\" class=\"m-l\" style=\"text-transform:uppercase\">{{bom.product_description}}</strong></h1></div></div></div><div class=\"wrapper\"><div class=\"panel-body\"><h4 class=\"h4 m-b-md\">{{progress.message}}</h4><div class=\"progress-xs progress ng-isolate-scope\" value=\"progress.percent\" type=\"success\"><div class=\"progress-bar progress-bar-primary\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: progress.percent + \'%\'}\"></div></div><uib-tabset active=\"step.index\"><uib-tab disable=\"(step!=STEP.BOM_SELECTION)\" index=\"STEP.BOM_SELECTION.index\"><uib-tab-heading><i class=\"icon-note text-info-dker\"></i> Distinta base</uib-tab-heading><div ng-include=\"\'lm/packagingSerialKit/packagingSerialKit_tabBomSelection.html\'\"></div></uib-tab><uib-tab disable=\"(step!=STEP.PACKAGING)\" index=\"STEP.PACKAGING.index\"><uib-tab-heading><i class=\"icon icon1-packaging text-success-dker\"></i> Confezionamento</uib-tab-heading><div ng-include=\"\'lm/packagingSerialKit/packagingSerialKit_tabPackaging.html\'\"></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("lm/packagingSerialKit/packagingSerialKit_tabBomSelection.html","<div class=\"row m-t-md\"><div class=\"col-md-12\"><input class=\"form-control\" type=\"text\" ng-model=\"jsFilter\"></div></div><div class=\"row m-t-md\"><div class=\"col-md-4 col-sm-6\" ng-repeat=\"b in bomsList | filter:jsFilter\"><button class=\"btn btn-packaging\" ng-click=\"selectBom(b)\"><h3>{{b.product_code}}</h3><h3><strong>{{b.product_description}}</strong></h3></button></div></div>");
$templateCache.put("lm/packagingSerialKit/packagingSerialKit_tabPackaging.html","<div class=\"row wrapper\" ng-if=\"packagingError\"><div class=\"col-md-12\" ng-if=\"packagingError\"><div class=\"alert bg-danger\" ng-if=\"packagingError\">{{packagingError}}</div></div></div><div class=\"row wrapper\"><div class=\"col-md-9\"><table class=\"table m-b-none\"><thead><tr><th ng-if=\"bom.seq_check_enabled==\'T\'\" width=\"90px\">Sequenza</th><th>Articolo</th><th>Quantità richiesta</th><th>Quantità letta</th></tr></thead><tbody><tr ng-repeat=\"row in bomDet\" ng-class=\"{\'bg-info\': (row.read>0 && row.amount!==row.read) , \'bg-success\': row.amount===row.read}\"><td ng-if=\"bom.seq_check_enabled==\'T\'\">{{row.sequence_index}}</td><td>{{row.description}}</td><td>{{row.amount}}</td><td>{{row.read}}</td></tr></tbody></table><div class=\"alert alert-info m-t-md\" ng-if=\"enableNextStep\"><span ng-if=\"!generatedBarcode\">Serial kit completato</span> <span ng-if=\"generatedBarcode\">E\' stato creato un nuovo serial kit con barcode <strong>{{generatedBarcode}}</strong></span></div></div><div class=\"col-md-3\" ng-if=\"enableNextStep\"><button class=\"btn btn-dashboard\" ng-click=\"createSerialKit()\" ng-if=\"!generatedBarcode\" ng-disabled=\"!settings.label_printer_id\"><i class=\"fa fa-print\"></i><h3>Crea kit e stampa</h3></button><six-lookup ng-if=\"!generatedBarcode\" ng-model=\"lookup.label_printer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"settings.label_printer_id\" sx-type=\"\'label_printer\'\" sx-placeholder=\"Seleziona stampante...\" sx-relational=\"true\"></six-lookup><div ng-if=\"labelPrinted\"><button class=\"btn btn-dashboard\" ng-click=\"goToSerialKitPackaging()\"><i class=\"icon icon1-packaging\"></i><h3>Nuovo serial kit</h3></button></div><div ng-if=\"labelPrinted\"><button class=\"btn btn-dashboard\" ng-click=\"printLabel()\"><i class=\"fa fa-print\"></i><h3>Ristampa</h3></button></div></div><div class=\"col-md-3\" ng-if=\"!enableNextStep\"><h4 class=\"override-h4-no-margin\">Letture</h4><hr class=\"m-t\"><div ng-if=\"step===STEP.PACKAGING\" class=\"m-b-md\"><six-code-reader sx-on-read=\"readComponentCode(read)\" sx-read-mode=\"compReaderMode\"><six-code-reader></six-code-reader></six-code-reader></div><div class=\"list-group\"><div ng-repeat=\"item in readList\" class=\"list-group-item b-l-warning b-l-3x\"><span ng-click=\"deleteNote(note)\" class=\"pull-right text-muted hover-action\"><i class=\"fa fa-times\"></i></span> <span class=\"block text-ellipsis\">{{item.component.description}}</span> <small class=\"text-muted ng-binding\" ng-if=\"item.read.type===\'B\'\">Barcode: {{item.component.barcode}}</small> <small class=\"text-muted ng-binding\" ng-if=\"item.read.type===\'R\'\">Unicode: {{item.component.unicode}}</small></div></div></div></div>");
$templateCache.put("lm/patient/patient_detail.html","<six-toolbar><six-toolbar-button label=\"Indietro\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" toolbar-function=\"backToPatients()\"></six-toolbar-button><six-toolbar-button label=\"{{ \'save\' | translate }}\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\" ng-if=\"editMode\"></six-toolbar-button><six-toolbar-button label=\"{{ \'delete\' | translate }}\" btn-class=\"btn-danger\" icon=\"fa fa-times\" toolbar-function=\"delete()\" ng-if=\"editMode && element.id\"></six-toolbar-button></six-toolbar><div class=\"page-title override-padding-toolbar\"><h1 class=\"m-n font-thin\">{{pageTitle}} <span ng-if=\"waitDelete\" class=\"fa fa-refresh fa-spin\"></span></h1></div><div class=\"wrapper-md\"><uib-tabset justified=\"false\" active=\"activeTab\" class=\"tab-container\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"tab-heading\">Testata</span></uib-tab-heading><div ng-if=\"renderHead\" ng-include=\"\'lm/patient/patient_tabHead.html\'\"></div></uib-tab><uib-tab index=\"1\" ng-if=\"element.id\"><uib-tab-heading><span class=\"tab-heading\">Componenti</span></uib-tab-heading><div ng-include=\"\'lm/patient/patient_tabComponents.html\'\"></div></uib-tab></uib-tabset></div>");
$templateCache.put("lm/patient/patient_list.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" class=\"btn btn-xl pull-left-xs\" label=\"Esci\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-plus\" label=\"Nuovo\" class=\"btn btn-xl pull-left-xs\" btn-class=\"btn-info\" toolbar-function=\"goToNew()\"></six-toolbar-button></six-toolbar><div class=\"page-title m-t-toolbar\"><h1 class=\"m-n font-thin\">Ospiti</h1></div><div class=\"wrapper-md\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-4 m-t-xs\"><label id=\"guest_label\" class=\"control-label\">Ospite</label><six-lookup ng-model=\"lookup.patient_id\" sx-filter=\"lookup.patient_id.filter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.patient_id\" sx-type=\"\'human_resource\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-hide-code=\"true\" sx-sort-fields=\"[\'surname\',\'name\']\"></six-lookup></div><div class=\"col-md-4 m-t-xs\"><label id=\"customer_label\" class=\"control-label\">Cliente</label><six-lookup ng-model=\"lookup.customer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.customer_id\" sx-type=\"\'customer\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-disabled=\"lockCustomer\" sx-filter=\"lookup.customer_id.filter\"></six-lookup></div><div class=\"col-md-4 m-t-xs\"><label id=\"destination_label\" class=\"control-label\">Reparto</label><six-lookup ng-model=\"lookup.destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.destination_id\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-disabled=\"lockCustomer\" sx-filter=\"lookup.destination_id.filter\"></six-lookup></div><div class=\"col-md-4 m-t-xs\"><label id=\"matr_label\" class=\"control-label\">Matricola sistema</label> <input type=\"text\" class=\"form-control\" ng-model=\"advFilter.filter.matriculation\"></div><div class=\"col-md-4 m-t-xs\"><label id=\"customermatr_label\" class=\"control-label\">Matricola cliente</label> <input type=\"text\" class=\"form-control\" ng-model=\"advFilter.filter.customer_matriculation\"></div><div class=\"col-md-4 m-t-xs\"><label id=\"wardrobe_label\" class=\"control-label\">Punto di consegna</label><six-lookup ng-model=\"lookup.delivery_destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.delivery_destination_id\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-disabled=\"lockCustomer\" sx-filter=\"lookup.delivery_destination_id.filter\"></six-lookup></div></div></div></div><div class=\"panel panel-default\"><six-grid-pagination ng-if=\"sf\" get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"list\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div>");
$templateCache.put("lm/patient/patient_tabComponents.html","<div class=\"col-lg-6 text-center\"><button class=\"btn btn-default m-xs\" ng-disabled=\"!deleteEnabled\" ng-click=\"decoupleComponents()\"><i class=\"fa fa-check text-success\"></i> {{ \"DISSOCIA COMPONENTI SELEZIONATI\" | translate}}</button></div><div class=\"col-lg-6 text-center\"><button class=\"btn btn-default m-xs\" ng-click=\"decoupleAllComponents()\"><i class=\"fa fa-check text-success\"></i> {{ \"DISSOCIA TUTTI I COMPONENTI\" | translate}}</button></div><div class=\"row\" ng-if=\"element.id\"><div class=\"col-md-12\" ng-if=\"renderComponents\"><six-grid-pagination get-data-callback=\"getPatientComponents()\" get-list-callback=\"getPatientComponents()\" items-list=\"components\" column-defs=\"viewGridOptions.componentColumnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination><six-confirm-modal sx-title=\"modal.title\" sx-message=\"modal.message\" sx-on-confirm=\"modal.callback\"></six-confirm-modal></div></div>");
$templateCache.put("lm/patient/patient_tabHead.html","<div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Matricola sistema</label> <input type=\"text\" class=\"form-control\" placeholder=\"Matricola\" ng-model=\"element.matriculation\" ng-readonly=\"true\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Cognome</label> <input type=\"text\" class=\"form-control\" placeholder=\"Cognome\" ng-model=\"element.surname\" ng-readonly=\"!editMode\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Nome</label> <input type=\"text\" class=\"form-control\" placeholder=\"Nome\" ng-model=\"element.name\" ng-readonly=\"!editMode\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Matricola cliente</label> <input type=\"text\" class=\"form-control\" placeholder=\"Matricola cliente\" ng-model=\"element.customer_matriculation\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Sesso</label><six-enum sx-model=\"element\" sx-field=\"sex\" sx-options=\"enum.sex\" sx-readonly=\"!editMode\"></six-enum></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Armadio</label> <input type=\"text\" class=\"form-control\" placeholder=\"Nome\" ng-model=\"element.barcode\" ng-readonly=\"!editMode\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Cliente</label><six-lookup ng-model=\"customerLookup.customer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"customer.id\" sx-filter=\"customerLookup.customer_id.filter\" sx-type=\"\'customer\'\" sx-placeholder=\"Seleziona cliente...\" sx-relational=\"true\" sx-disabled=\"!editMode\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Reparto</label><six-lookup ng-model=\"lookup.destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.destination_id\" sx-filter=\"repFilter\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona reparto...\" sx-relational=\"true\" sx-disabled=\"!editMode\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Punto di consegna</label><six-lookup ng-model=\"lookup.delivery_destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.delivery_destination_id\" sx-filter=\"pdcFilter\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona punto di consegna...\" sx-relational=\"true\" sx-disabled=\"!editMode\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Fine servizio</label><six-date-picker ng-model=\"element.validity_end\" sx-disabled=\"!editMode\"></six-date-picker></div></div><div class=\"col-md-8\"><div class=\"form-group\"><label>Note</label> <textarea class=\"sf-form-control form-control\" ng-model=\"element.note\" ng-disabled=\"!editMode\"></textarea></div></div></div>");
$templateCache.put("lm/patient/patient_tabHistory.html","<div class=\"row\" ng-if=\"element.id\"><div class=\"col-md-12\"><six-grid-pagination get-data-callback=\"getPatientHistory()\" get-list-callback=\"getPatienthistory()\" items-list=\"history\" column-defs=\"viewGridOptions.historyColumnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div>");
$templateCache.put("lm/rebaser/rebaser.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"Esci\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-close\" label=\"Svuota\" btn-class=\"btn-danger\" toolbar-function=\"setEmpty()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-arrow-up\" label=\"Carico\" btn-class=\"btn-primary\" toolbar-function=\"setLoad(true)\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-arrow-down\" label=\"Scarico\" btn-class=\"btn-primary\" toolbar-function=\"setLoad(false)\"></six-toolbar-button></six-toolbar><div ng-if=\"load\"><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Carico: {{element.description}}</h1></div></div></div><ul class=\"nav nav-pills rebaser\"><six-toolbar-button icon=\"fa fa-table\" label=\"Vis. tabella\" btn-class=\"btn-default\" ng-class=\"{active: type == \'TABLE\'}\" toolbar-function=\"setType(\'TABLE\')\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-bars\" label=\"Vis. lista\" btn-class=\"btn-default\" ng-class=\"{active: type == \'LIST\'}\" toolbar-function=\"setType(\'LIST\')\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-user\" label=\"Capi Mancanti\" btn-class=\"btn-default\" ng-class=\"{active: type == \'MISSING_COMPONENTS\'}\" toolbar-function=\"setType(\'MISSING_COMPONENTS\')\" ng-click=\"initMissingComponents()\"></six-toolbar-button></ul><div class=\"clearfix\"></div><div class=\"panel-body\"><div ng-include=\"\'lm/rebaser/load/rebaser_load_panel.html\'\"></div></div></div></div></div><div ng-if=\"!load\"><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Scarico: {{element.description}}</h1></div></div></div><div class=\"panel-body\"><div ng-include=\"\'lm/rebaser/unload/rebaser_unload_panel.html\'\"></div></div></div></div></div><hr>");
$templateCache.put("lm/reorderLost/reorderLost.html","<six-toolbar static-title=\"{{ title | translate }}\"><six-toolbar-button label=\"{{ \'clear\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-eraser\" toolbar-function=\"resetPage()\"></six-toolbar-button><six-toolbar-button label=\"{{ \'reload\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-undo\" toolbar-function=\"getData()\"></six-toolbar-button></six-toolbar><div class=\"panel panel-default m-t-xxl\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-lg-3 col-md-3\"><label>{{ \"reorder.lost_before\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.lostBefore\"></six-date-picker></div><div class=\"col-md-3\"><label>{{ \"reorder.days_before\" | translate }}</label> <input type=\"number\" min=\"0\" ng-model=\"advFilter.filter.daysBefore\" class=\"form-control no-grey\" ng-required=\"false\"></div><div class=\"col-md-1 text-center\" style=\"padding-top: 20px\"><button class=\"btn btn-default m-xs\" ng-click=\"searchLost()\"><i class=\"fa fa-search\"></i> {{ \"reorder.search\" | translate }}</button></div></div><div class=\"row\"><div class=\"col-md-4\"><label id=\"type_label\" class=\"control-label\">Articolo</label><six-lookup ng-model=\"lookup.product\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.product\" sx-type=\"\'product\'\" sx-filter=\"productFilter\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-4\"><label id=\"type_label\" class=\"control-label\">Guardaroba</label><six-lookup ng-model=\"lookup.wardrobe\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.wardrobe\" sx-type=\"\'customer_destination\'\" sx-filter=\"wardrobeFilter\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-sort-fields=\"[\'code\']\"></six-lookup></div><div class=\"col-md-4\"><label id=\"type_label\" class=\"control-label\">Destinazione</label><six-lookup ng-model=\"lookup.destination\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.destination\" sx-type=\"\'customer_destination\'\" sx-filter=\"destinationFilter\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\"></six-lookup></div></div></div></div><div><div class=\"col-md-6\"><div class=\"row\"><span class=\"h4 m-r-xs\">In Dotazione</span> <span class=\"\"><label class=\"i-switch i-switch-md bg-danger\"><input type=\"checkbox\" ng-model=\"noEnd\"> <i></i></label></span> <span class=\"h4 m-l-xs\">Fuori Dotazione</span></div></div><br><div ng-if=\"!noEnd\"><div><div class=\"col-lg-12 text-center\"><button class=\"btn btn-default m-xs\" ng-disabled=\"!orderEnabled\" ng-click=\"saveOrder()\"><i class=\"fa fa-check text-success\"></i> {{\'reorder.create_order\' | translate}}</button></div></div><br><br><br><div><div ng-if=\"advFilter.filter.lostBefore && renderTable\" style=\"padding-top: 10px\"><six-grid-pagination get-data-callback=\"getData()\" items-list=\"result\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\" lazy-init=\"true\"></six-grid-pagination></div></div></div><div ng-if=\"noEnd\"><div ng-if=\"advFilter.filter.lostBefore && renderTableNoEnd\" style=\"padding-top: 10px\"><six-grid-pagination get-data-callback=\"getDataNoEnd()\" items-list=\"resultNoEnd\" column-defs=\"viewGridOptionsNoEnd.columnDefs\" grid-options=\"viewGridOptionsNoEnd\" params=\"params\" lazy-init=\"true\"></six-grid-pagination></div></div></div>");
$templateCache.put("lm/setComposition/setComposition.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"{{ \'back\' | translate }}\" back=\"\"></six-toolbar-button></six-toolbar><style>\n#remove-button {\n    background-color: white; \n    border-color: none; \n    min-height: 169px;\n}\n#remove-button i{\n  color: #f05050 !important;\n}\n</style><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">{{ \'set_composition.set_composition\' | translate }} <strong>{{set}}</strong></h1></div></div></div><div class=\"wrapper\"><div class=\"panel-body\"><uib-tabset active=\"activeTab\"><uib-tab index=\"TAB.SET\" disable=\"serialKitList.length>0\"><uib-tab-heading><i class=\"icon icon1-warehouse text-info-dker\"></i> {{ \'set_composition.set_selection\' | translate }}</uib-tab-heading><div ng-include=\"\'lm/setComposition/setComposition_tabSet.html\'\" ng-if=\"activeTab == TAB.SET\"></div></uib-tab><uib-tab disable=\"!set\" index=\"TAB.KIT\"><uib-tab-heading><i class=\"icon icon1-packaging text-primary-dker\"></i> {{ \'set_composition.kit_adding_removal\' | translate }}</uib-tab-heading><div ng-include=\"\'lm/setComposition/setComposition_tabKit.html\'\" ng-if=\"activeTab == TAB.KIT\"></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("lm/setComposition/setComposition_tabKit.html","<div class=\"row wrapper\" ng-if=\"packagingError\"><div class=\"col-md-12\" ng-if=\"packagingError\"><div class=\"alert bg-danger\" ng-if=\"packagingError\">{{set_composition.packagingError}}</div></div></div><div class=\"row wrapper\"><div class=\"col-md-9\"><h4>{{ bom.product_code }} - {{ bom.product_description }}</h4><table class=\"table m-b-none\"><thead><tr><th ng-if=\"bom.seq_check_enabled==\'T\'\" width=\"90px\">Sequenza</th><th>Articolo</th><th>Quantità richiesta</th><th>Quantità letta</th></tr></thead><tbody><tr ng-repeat=\"row in bomDet\" ng-class=\"{\'bg-info\': (row.read>0 && row.amount!==row.read) , \'bg-success\': row.amount===row.read}\"><td ng-if=\"bom.seq_check_enabled==\'T\'\">{{row.sequence_index}}</td><td>{{row.description}}</td><td>{{row.amount}}</td><td>{{row.read}}</td></tr></tbody></table></div></div><div class=\"row wrapper\"><div class=\"col-md-2\"><button class=\"btn btn-dashboard m-b-none\" ng-click=\"setAddMode(true)\" id=\"add-button\" ng-class=\"{\'btn-pressed\': addMode}\"><i class=\"fa fa-plus\"></i><h3>{{ \'set_composition.add_kit\' | translate }}</h3></button></div><div class=\"col-md-2\"><button class=\"btn btn-dashboard m-b-none\" ng-click=\"setAddMode(false)\" id=\"remove-button\" ng-class=\"{\'btn-pressed\': !addMode}\"><i class=\"fa fa-minus\"></i><h3>{{ \'set_composition.remove_kit\' | translate }}</h3></button></div><div class=\"col-md-5\"><div ng-if=\"step===STEP.PACKAGING\" class=\"m-b-md\"><label>{{ \'kit_read\' | translate }}</label><six-code-reader sx-on-read=\"readComponentCode(read)\" sx-read-mode=\"compReaderMode\"><six-code-reader></six-code-reader></six-code-reader></div><div><h3>{{ \'set_composition.mode\' | translate }} <strong ng-if=\"addMode\" class=\"text-success\">{{ \'set_composition.addition\' | translate }} <i class=\"fa fa-plus\"></i></strong><strong class=\"text-danger\" ng-if=\"!addMode\">{{ \'set_composition.removal\' | translate }} <i class=\"fa fa-minus\"></i></strong></h3></div></div><div class=\"col-md-1\" style=\"text-align:center\"><h3>{{ \'total\' | translate}}</h3><h1><strong class=\"text-dark\">{{serialKitList.length}}</strong></h1></div><div class=\"col-md-2\"><button class=\"btn btn-dashboard m-b-none\" ng-click=\"printSetLabel()\" style=\"padding:18px\" ng-disabled=\"serialKitList.length==0\"><i class=\"icon1-reception\"></i><h3>{{ \'set_composition.new_set\' | translate }}</h3></button></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><table class=\"table m-b-none\"><thead><tr><th>{{ \'barcode\' | translate }}</th><th>{{ \'set_composition.product_code\' | translate }}</th><th>{{ \'set_composition.product_description\' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"sk in serialKitList.slice().reverse()\"><td>{{sk.barcode}}</td><td>{{sk.product_code}}</td><td>{{sk.product_description}}</td></tr></tbody></table><div class=\"alert alert-info m-t-md\" ng-if=\"enableNextStep\"><span ng-if=\"!generatedBarcode\">{{ \'set_composition.serial_kit_completed\' | translate }}</span> <span ng-if=\"generatedBarcode\">{{ \'set_composition.created_with_barcode\' | translate }} <strong>{{generatedBarcode}}</strong></span></div></div></div>");
$templateCache.put("lm/setComposition/setComposition_tabSet.html","<div class=\"row m-t-md\"><div class=\"col-md-12\"><input class=\"form-control\" type=\"text\" ng-model=\"jsFilter\"></div></div><div class=\"row m-t-md\"><div class=\"col-md-4 col-sm-6\" ng-repeat=\"b in bomsList | filter:jsFilter\"><button class=\"btn btn-packaging\" ng-click=\"selectBom(b)\"><h3>{{b.product_code}}</h3><h3><strong>{{b.product_description}}</strong></h3></button></div></div><six-print-modal sx-title=\"\'Stampante etichetta\'\" sx-on-confirm=\"onConfirmSelectPrinter(code)\"></six-print-modal>");
$templateCache.put("lm/wardToDestComponents/ward-to-dest-components-detail.html","<six-toolbar static-title=\"Consegna a reparto unificata\"><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"{{ \'back\' | translate}}\" toolbar-function=\"goToList()\"></six-toolbar-button></six-toolbar><div class=\"wrapper-md m-t-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\" style=\"padding-bottom: 20px;\"><div class=\"col-md-6\"><six-code-reader sx-on-read=\"readComponentCode(read)\" sx-read-mode=\"compReaderMode\" sx-allow-pause=\"true\"><six-code-reader></six-code-reader></six-code-reader></div><div class=\"col-md-1\"></div><div class=\"col-md-5\" style=\"font-size: 25px\">Tipo ddt : {{shipmentType.code}} - {{shipmentType.description}}</div></div><div class=\"row\"><div class=\"col-md-2\" style=\"font-size: 30px\">Chip letti : {{unicodesList.length}}</div><div class=\"col-md-4\"><button class=\"btn btn-default m-xs\" ng-click=\"resetReads()\">{{ \"Cancella letture\" | translate}}</button> <button class=\"btn btn-default m-xs\" ng-click=\"resolveComponents()\" ng-disabled=\"!enableResolveButton\">{{ \"Risolvi letture\" | translate}}</button></div><div class=\"col-md-1\"></div><div class=\"col-md-5\" style=\"font-size: 25px\">Reparto : {{destination.code}} - {{destination.description}}</div></div><div class=\"row\"><br></div><div class=\"row\" ng-show=\"showTable\"><div class=\"col-md-8\"><table class=\"table table-striped m-b-none\"><thead><tr><th class=\"col-md-7\">{{\'product\' | translate}}</th><th class=\"col-md-1\">{{\'quantity\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"(prod_id, comps) in productMap\"><td><div>{{comps.prod}}</div></td><td><div>{{comps.ids.length}}</div></td></tr></tbody></table></div><div class=\"col-md-4\"><br><button class=\"btn btn-default m-xs\" ng-click=\"createDdt()\" ng-disabled=\"!enableCreateButton\">{{ \"Crea e stampa\" | translate}}</button></div></div></div></div></div>");
$templateCache.put("lm/wardToDestComponents/ward-to-dest-components-list.html","<style>\n    .wardrobe-header {\n        background-color: #a5b3c7;\n        padding: 5px;\n        width: 100%;\n        padding-left: 9px;\n        color: white;\n        font:bold;\n        margin-top: -15px;\n        margin-bottom: 15px;\n    }\n</style><six-toolbar static-title=\"{{ \'Spedizione a reparto unificata\' | translate}}\"><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"Esci\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"padder override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-4\"><label class=\"control-label\">{{ \"wardrobe\" | translate }}</label><six-lookup ng-model=\"record.lookup.customer_destination_id\" sx-id=\"record.model.customer_destination_id\" sx-type=\"\'customer_destination\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"wardrobesFilter\" sx-disabled=\"settings.isWardrobeReadonly\" sx-preselect-if-one=\"settings.isWardrobeReadonly\"></six-lookup></div><div class=\"col-md-4\"><label class=\"control-label\">{{ \"customer_destination_REP\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"record.model.destination\" id=\"destination\"></div></div></div></div><div ng-repeat=\"(wardKey, wardValue) in destsByWardrobe\" class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"wardrobe-header col-md-12\">{{wardValue.description}}</div><div class=\"padder\"><span ng-repeat=\"(destKey, destValue) in wardValue.destinations\"><button class=\"btn btn-default m-xs\" ng-click=\"goToDestinationDetail(destValue.id)\">{{destValue.description}}</button></span></div></div></div></div><div ng-if=\"visibleDestinationsList.length==0\" class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"alert alert-info\">{{ \"ward_to_dest_piana.no_match\" | translate }}</div></div></div></div>");
$templateCache.put("lm/wardToDestComponents/ward-to-dest-components-print.html","<six-toolbar static-title=\"{{ \'ward_to_dest_conf.print_ddt\' | translate}}\"><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"{{ \'back\' | translate}}\" toolbar-function=\"goToList()\"></six-toolbar-button></six-toolbar><div class=\"wrapper override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\" style=\"height:650px\"><six-iframe sx-report=\"\'/shipment_detail_report.rptdesign\'\" sx-params=\"reportParameters\"></six-iframe></div></div></div>");
$templateCache.put("lm/wardToDestConf/ward-to-dest-conf-detail.html","<style>\n.row-completed{\n  background-color: rgba(143, 235, 152) !important;\n}\n\n.force-bg-white {\n  background-color: #fdfdfd !important;\n}\n</style><six-toolbar static-title=\"{{ \'ward_to_dest_conf.ward_to_dest_conf\' | translate}}\"><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"{{ \'back\' | translate}}\" toolbar-function=\"goToList()\"></six-toolbar-button><six-toolbar-button label=\"{{ \'save\' | translate}}\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"trySave()\"></six-toolbar-button><six-toolbar-button label=\"{{ \'save_and_print\' | translate}}\" btn-class=\"btn-info\" icon=\"fa fa-print\" toolbar-function=\"saveAndPrint()\"></six-toolbar-button></six-toolbar><div class=\"wrapper override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col col-md-4\"><label class=\"control-label\">{{ \"code\" | translate }}</label><six-code-reader sx-on-read=\"onRead(read.read)\" sx-allow-pause=\"true\"></six-code-reader></div><div class=\"col col-md-4\"><label class=\"control-label\">{{ \"destination\" | translate }} | {{ \"ward_to_dest_conf.dept_code\" | translate }}: <b style=\"font-size:15px;\">{{record.lookup.customer_destination_id.obj.model.code}}</b></label><six-lookup ng-model=\"record.lookup.customer_destination_id\" sx-id=\"record.model.customer_destination_id\" sx-type=\"\'customer_destination\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-disabled=\"true\" sx-preselect-if-one=\"true\" sx-filter=\"customerDestinationFilter\"></six-lookup></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><div ng-style=\"{ \'height\': params.gridApi.grid.gridHeight}\" class=\"grid zoomDataGrid\" ui-grid=\"gridOptions\" ui-grid-multiple=\"\" ui-grid-resize-columns=\"\" ui-grid-edit=\"\" ui-grid-pagination=\"\" ui-grid-auto-resize=\"\" ui-grid-exporter=\"\" style=\"text-align:center; height: 580px\"></div></div></div></div>");
$templateCache.put("lm/wardToDestConf/ward-to-dest-conf-list.html","<style>\n    .wardrobe-header {\n        background-color: #a5b3c7;\n        padding: 5px;\n        width: 100%;\n        padding-left: 9px;\n        color: white;\n        font:bold;\n        margin-top: -15px;\n        margin-bottom: 15px;\n    }\n</style><six-toolbar static-title=\"{{ \'ward_to_dest_conf.ward_to_dest_conf\' | translate}}\"><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"Esci\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"padder override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3\"><label class=\"control-label\">{{ \"wardrobe\" | translate }}</label><six-lookup ng-model=\"record.lookup.customer_destination_id\" sx-id=\"record.model.customer_destination_id\" sx-type=\"\'customer_destination\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"wardrobesFilter\" sx-disabled=\"settings.isWardrobeReadonly\" sx-preselect-if-one=\"settings.isWardrobeReadonly\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"ward_to_dest_conf.delivery_date\" | translate }}</label><six-date-picker ng-model=\"record.model.delivery_date\" id=\"delivery_date\"></six-date-picker></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"ward_to_dest_conf.path\" | translate }}</label><six-lookup ng-model=\"record.lookup.path_id\" sx-id=\"record.model.path_id\" sx-type=\"\'path\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"pathFilter\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"customer_destination_REP\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"record.model.destination\" id=\"destination\"></div></div></div></div><div ng-repeat=\"(wardKey, wardValue) in pathList\" class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"wardrobe-header col-md-12\">{{wardValue.description}}</div><div class=\"padder\"><span ng-repeat=\"(destKey, destValue) in wardValue.destinations\"><button class=\"btn btn-default m-xs\" ng-click=\"goToDestinationDetail(destValue.id)\"><i class=\"fa fa-spinner fa-spin text-muted\" ng-if=\"!settings.ddtLoaded\"></i> <i class=\"icon1-shipment fa fa-info\" ng-if=\"settings.ddtLoaded && destValue.alreadyDelivered\"></i> {{destValue.description}}</button></span></div></div></div></div><div ng-if=\"visibleDestinationsList.length==0\" class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"alert alert-info\">{{ \"ward_to_dest_conf.no_match\" | translate }}</div></div></div></div>");
$templateCache.put("lm/wardToDestConf/ward-to-dest-conf-print.html","<six-toolbar static-title=\"{{ \'ward_to_dest_conf.print_ddt\' | translate}}\"><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"{{ \'back\' | translate}}\" toolbar-function=\"goToList()\"></six-toolbar-button></six-toolbar><div class=\"wrapper override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\" style=\"height:650px\"><six-iframe sx-report=\"\'sales/shipmentAsDestDelivery_report.rptdesign\'\" sx-params=\"reportParameters\"></six-iframe></div></div></div>");
$templateCache.put("lm/wardToDestPiana/ward-to-dest-piana-detail.html","<style>\n.row-completed{\n  background-color: rgba(143, 235, 152) !important;\n}\n\n.force-bg-white {\n  background-color: #fdfdfd !important;\n}\n</style><six-toolbar static-title=\"{{ \'ward_to_dest_piana.ward_to_dest_piana\' | translate}}\"><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"{{ \'back\' | translate}}\" toolbar-function=\"goToList()\"></six-toolbar-button><six-toolbar-button label=\"{{ \'save\' | translate}}\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"trySave()\"></six-toolbar-button><six-toolbar-button label=\"{{ \'save_and_print\' | translate}}\" btn-class=\"btn-info\" icon=\"fa fa-print\" toolbar-function=\"saveAndPrint()\"></six-toolbar-button></six-toolbar><div class=\"wrapper override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col col-md-4\"><label class=\"control-label\">{{ \"code\" | translate }}</label><six-code-reader sx-on-read=\"onRead(read.read)\" sx-allow-pause=\"true\" sx-disabled=\"!admittedStatusList || !admittedProductsList\"></six-code-reader></div><div class=\"col col-md-4\"><label class=\"control-label\">{{ \"ward_to_dest_piana.reorder_mode\" | translate }}</label><six-enum sx-model=\"record.model\" sx-on-change=\"changeOrder(record.model)\" sx-field=\"reorderMode\" sx-options=\"enum.reorderMode\" sx-readonly=\"readOnly\" sx-closable=\"false\"></six-enum></div><div class=\"col col-md-4\"><label class=\"control-label\">{{ \"destination\" | translate }} | {{ \"ward_to_dest_piana.dept_code\" | translate }}: <b style=\"font-size:15px;\">{{record.lookup.customer_destination_id.obj.model.code}}</b></label><six-lookup ng-model=\"record.lookup.customer_destination_id\" sx-id=\"record.model.customer_destination_id\" sx-type=\"\'customer_destination\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-disabled=\"true\" sx-preselect-if-one=\"true\" sx-filter=\"customerDestinationFilter\"></six-lookup></div></div><br><div class=\"row\" ng-if=\"alreadyDelivered\"><div class=\"col col-md-12\"><h4>CONSEGNA GIA\' EFFETTUATA PER LA DATA <b>{{getTimestamp(deliveryDate)}}</b> PER IL REPARTO <b>{{record.lookup.customer_destination_id.obj.code}} {{record.lookup.customer_destination_id.obj.description}}</b></h4></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><div ng-style=\"{ \'height\': params.gridApi.grid.gridHeight}\" class=\"grid zoomDataGrid\" ui-grid=\"gridOptions\" ui-grid-multiple=\"\" ui-grid-resize-columns=\"\" ui-grid-edit=\"\" ui-grid-pagination=\"\" ui-grid-auto-resize=\"\" ui-grid-exporter=\"\" style=\"text-align:center; height: 580px\"></div></div></div></div>");
$templateCache.put("lm/wardToDestPiana/ward-to-dest-piana-list.html","<style>\n    .wardrobe-header {\n        background-color: #a5b3c7;\n        padding: 5px;\n        width: 100%;\n        padding-left: 9px;\n        color: white;\n        font:bold;\n        margin-top: -15px;\n        margin-bottom: 15px;\n    }\n</style><six-toolbar static-title=\"{{ \'ward_to_dest_piana.ward_to_dest_piana\' | translate}}\"><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"Esci\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"padder override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3\"><label class=\"control-label\">{{ \"wardrobe\" | translate }}</label><six-lookup ng-model=\"record.lookup.customer_destination_id\" sx-id=\"record.model.customer_destination_id\" sx-type=\"\'customer_destination\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"wardrobesFilter\" sx-disabled=\"settings.isWardrobeReadonly\" sx-preselect-if-one=\"settings.isWardrobeReadonly\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"ward_to_dest_piana.delivery_date\" | translate }}</label><six-date-picker ng-model=\"record.model.delivery_date\" id=\"delivery_date\"></six-date-picker></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"ward_to_dest_piana.path\" | translate }}</label><six-lookup ng-model=\"record.lookup.path_id\" sx-id=\"record.model.path_id\" sx-type=\"\'path\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"pathFilter\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"customer_destination_REP\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"record.model.destination\" id=\"destination\"></div></div></div></div><div ng-repeat=\"(wardKey, wardValue) in pathList\" class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"wardrobe-header col-md-12\">{{wardValue.description}}</div><div class=\"padder\"><span ng-repeat=\"(destKey, destValue) in wardValue.destinations\"><button class=\"btn btn-default m-xs\" ng-click=\"goToDestinationDetail(destValue.id)\"><i class=\"fa fa-spinner fa-spin text-muted\" ng-if=\"!settings.ddtLoaded\"></i> <i class=\"icon1-shipment fa fa-info\" ng-if=\"settings.ddtLoaded && destValue.alreadyDelivered\"></i> {{destValue.description}}</button></span></div></div></div></div><div ng-if=\"visibleDestinationsList.length==0\" class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"alert alert-info\">{{ \"ward_to_dest_piana.no_match\" | translate }}</div></div></div></div>");
$templateCache.put("lm/wardToDestPiana/ward-to-dest-piana-print.html","<six-toolbar static-title=\"{{ \'ward_to_dest_piana.print_ddt\' | translate}}\"><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"{{ \'back\' | translate}}\" toolbar-function=\"goToList()\"></six-toolbar-button></six-toolbar><div class=\"wrapper override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\" style=\"height:650px\"><six-iframe sx-report=\"\'sales/shipmentAsDestDelivery_report.rptdesign\'\" sx-params=\"reportParameters\"></six-iframe></div></div></div>");
$templateCache.put("plan/activity/activity_detail.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" toolbar-function=\"delete(activity.version)\" sx-disabled=\"!activity.version || !isDeletePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\" ng-hide=\"activity.version\"><h1 class=\"m-n font-thin h3 text-black\">Nuova Attività</h1></div><div class=\"col-sm-6 col-xs-12\" ng-show=\"activity.version\"><h1 class=\"m-n font-thin h3 text-black\">Attività</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12 col-sm-12\"><label for=\"code\" class=\"control-label\">Codice</label><div class=\"input-group\" style=\"width:100%\"><input name=\"code\" type=\"text\" ng-model=\"activity.model.code\" class=\"form-control\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-12 col-sm-12 m-t\"><label for=\"description\" class=\"control-label\">Descrizione</label><div class=\"input-group\" style=\"width:100%\"><input name=\"description\" type=\"text\" ng-model=\"description\" ng-keyup=\"refreshDescription(description)\" required=\"\" class=\"form-control\"></div></div></div></div></div></div></div>");
$templateCache.put("plan/activity/activity_list.html","<six-toolbar><six-toolbar-button icon=\"fa fa-plus\" label=\"Nuova attività\" btn-class=\"btn-info\" toolbar-function=\"goToNewActivity()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Attività</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getActivitiesList()\" items-list=\"activitiesList\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("plan/directives/issuedetails.html","<div class=\"panel-body\"><uib-tabset class=\"tabs-right\"><uib-tab><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Dati</uib-tab-heading><div class=\"row m-b-xs\" ng-if=\"sxIssue.UUID\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"col-md-4 form-group\"><label class=\"control-label\">Stato segnalazione</label> <span disabled=\"true\" class=\"form-control\">{{sxIssue.status}}</span></div></div></div></div><div class=\"row m-b-xs\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"col-md-4 form-group\"><label class=\"control-label\">Tipo Asset</label><six-lookup-2 sx-id=\"issue-schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-title=\"\'Tipo asset\'\" ng-model=\"sxIssue.model\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\" sx-field=\"\'type_id\'\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-page-size=\"10000\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"issue-asset\" sx-base-path=\"\'record\'\" sx-title=\"\'Asset\'\" ng-model=\"sxIssue.model\" sx-type=\"sxIssue.model.type_id.UUID\" sx-field=\"\'record_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Richiedente</label><six-lookup-2 sx-id=\"issue-richiedente\" ng-model=\"sxIssue\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'reporter_id\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-prefill=\"{model: {typeoperator: \'richiedente\'}}\"></six-lookup-2></div></div></div></div><div class=\"row m-b\" ng-if=\"!sxShowCustomerInfo\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-dark\"><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data inserimento</label><six-date-time-picker name=\"date_insertion\" date-options=\"dateOptions\" ng-model=\"sxIssue.date_insertion\"></six-date-time-picker></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data richiesta</label><six-date-time-picker name=\"date_requested\" date-options=\"dateOptions\" ng-model=\"sxIssue.date_requested\"></six-date-time-picker></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data di presa in carico</label><six-date-time-picker name=\"date_handling\" date-options=\"dateOptions\" ng-model=\"sxIssue.date_handling\"></six-date-time-picker></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data chiusura</label><six-date-time-picker name=\"date_closing\" date-options=\"dateOptions\" ng-model=\"sxIssue.date_closing\"></six-date-time-picker></div></div></div></div><div class=\"row m-b\" ng-if=\"sxShowCustomerInfo\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"col-md-4 form-group\"><label class=\"control-label\">Data inserimento</label><six-date-time-picker name=\"date_insertion\" date-options=\"dateOptions\" ng-model=\"sxIssue.date_insertion\" sx-disabled=\"true\"></six-date-time-picker></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Responsabile esterno</label><six-lookup-2 sx-id=\"supervisorExternal_id\" ng-model=\"sxIssue.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'supervisorExternal_id\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Segreteria</label><six-lookup-2 sx-id=\"secretariat_id\" ng-model=\"sxIssue.references_assignee\" sx-type=\"\'segreteria\'\" sx-base-path=\"\'record\'\" sx-field=\"\'secretariat_id\'\" sx-show-details=\"true\"></six-lookup-2></div></div></div></div><div class=\"col-md-12 hr-margin\" ng-if=\"sxShowWatchers\"><div class=\"panel panel-default pnl-no-margin-t-b\" id=\"panel1\"><a data-toggle=\"collapse\" data-target=\"#issueCollapseOne\"><div class=\"panel-heading\"><h5 class=\"override-margin-top-bottom\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i> Watchers</h5></div></a><div id=\"issueCollapseOne\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"row col-md-12 no-pad-l-r\"><div class=\"col-md-6\" ng-if=\"sxIssue.watchers.internal.length != 0\"><h5>Watcher interni:</h5></div><div class=\"col-md-6\" ng-if=\"sxIssue.watchers.external.length != 0\"><h5>Watcher esterni:</h5></div></div><div class=\"row col-md-12 no-pad-l-r\"><div class=\"col-md-6\" ng-if=\"sxIssue.watchers.internal.length != 0\"><div class=\"col-md-12 no-pad-l-r margin-col-l\" ng-repeat=\"w in sxIssue.watchers.internal track by $index\"><div class=\"col-md-11 no-pad-l-r\"><six-lookup ng-model=\"w\" sx-type=\"w.type\" sx-base-path=\"\'record\'\" sx-disabled=\"true\" sx-closable=\"false\"></six-lookup></div></div></div><div class=\"col-md-6\" ng-if=\"sxIssue.watchers.external.length != 0\"><div class=\"col-md-12 no-pad-l-r margin-col-l\" ng-repeat=\"w in sxIssue.watchers.external\"><div class=\"col-md-11 no-pad-l-r\"><input type=\"email\" class=\"form-control\" ng-model=\"w\" disabled=\"\"></div></div></div></div></div></div></div></div></div><div class=\"col-md-12 hr-margin\" ng-if=\"sxShowReferencesAssignee\"><div class=\"panel panel-default pnl-no-margin-t-b\" id=\"panel2\"><a data-toggle=\"collapse\" data-target=\"#issueCollapseTwo\"><div class=\"panel-heading\"><h5 class=\"override-margin-top-bottom\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i> Tecnici - Assegnatari</h5></div></a><div id=\"issueCollapseTwo\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"col-md-4 form-group\"><h5>Tecnico esterno</h5><div class=\"col-md-11 no-pad-l-r\"><six-lookup-2 sx-id=\"technicianexternal_id\" ng-model=\"sxIssue.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'technicianexternal_id\'\" sx-add=\"true\" sx-filter=\"technicianexternalIdFilter\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div></div><div class=\"col-md-4 form-group\"><h5>Segreteria</h5><div class=\"col-md-11 no-pad-l-r\"><six-lookup-2 sx-id=\"secretariat_id\" ng-model=\"sxIssue.references_assignee\" sx-type=\"\'segreteria\'\" sx-base-path=\"\'record\'\" sx-field=\"\'secretariat_id\'\"></six-lookup-2></div></div></div></div></div></div></div><div class=\"col-md-12 hr-margin\" ng-if=\"sxShowResponsableList && responsableList.length > 0\"><div class=\"panel panel-default pnl-no-margin-t-b\" id=\"panel3\"><a data-toggle=\"collapse\" data-target=\"#collapseThree\"><div class=\"panel-heading\"><h5 class=\"override-margin-top-bottom\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i> Contatti responsabili</h5></div></a><div id=\"collapseThree\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"row col-md-12 no-pad-l-r\" ng-repeat=\"r in responsableList\"><div class=\"col-md-4 form-group\"><input type=\"text\" class=\"form-control\" ng-model=\"r.name\" disabled=\"\"></div><div class=\"col-md-4 form-group\"><input type=\"text\" class=\"form-control\" ng-model=\"r.contacts\" disabled=\"\"></div></div></div></div></div></div></div><div class=\"col-md-12 no-pad-l-r\"><form name=\"detailForm\"><div class=\"row wrapper\"><div class=\"override-form-group override-checkbox\" sf-schema=\"sxSchema.schema\" sf-form=\"sxSchema.form\" sf-model=\"sxIssue.model\"></div></div></form></div><div ng-if=\"!(schemaIssueDefined)\"><div class=\"wrapper\"><div class=\"row\"><label class=\"control-label\">Schema non definito</label></div></div></div></uib-tab><uib-tab disable=\"!sxIssue.version\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments nodes=\"attachments\" save-callback=\"updAttachments()\"></six-tree-attachments></uib-tab><uib-tab index=\"3\" disable=\"!sxIssue.version\"><uib-tab-heading><span class=\"fa fa-qrcode text-info-dker\"></span> QRCODE</uib-tab-heading><qrcode version=\"5\" error-correction-level=\"H\" size=\"274\" data=\"{{sxIssue.UUID}}\"></qrcode></uib-tab><uib-tab index=\"4\" disable=\"!sxIssue.version\"><uib-tab-heading><span class=\"icon-bell text-info-dker\"></span> Notifiche</uib-tab-heading><div ng-if=\"notifications.length==0\" class=\"alert alert-info\" role=\"alert\">Nessuna notifica</div><ul class=\"list-group list-group-lg no-radius m-b-none m-t-n-xxs\"><li ng-repeat=\"notification in notifications\" class=\"list-group-item clearfix b-l-3x ng-scope\" ng-class=\"notification.color\"><span class=\"avatar thumb pull-left m-r\"><img ng-hide=\"notification.user\" ng-src=\"/images/avatar_system.png\"> <img ng-show=\"notification.user\" ng-src=\"/images/avatar_emil.png\"></span><div class=\"pull-right text-sm text-muted\"><span class=\"hidden-xs ng-binding\">{{notification.dataIn | date:\"dd/MM/yyyy\"}}</span></div><div class=\"clear\"><div><a class=\"text-md ng-binding\" ng-href=\"{{notification.href}}\">{{notification.model.subject}}</a></div><div class=\"text-ellipsis m-t-xs ng-binding\">{{notification.model.bodyAsText}}</div></div></li></ul></uib-tab></uib-tabset></div>");
$templateCache.put("plan/issue/callcenter_detail.html","<six-toolbar><six-toolbar-item label=\"Segnalazione n. {{data.model.code}} - {{data.status}}\" ng-show=\"data.version\"></six-toolbar-item><six-toolbar-item label=\"Nuova segnalazione\" ng-show=\"!data.version\"></six-toolbar-item><six-toolbar-button label=\"Lista\" icon=\"fa fa-chevron-left\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Conf. default\" btn-class=\"btn-info\" icon=\"fa fa-gear\" toolbar-function=\"getConfiguration()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"validate()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Salva e genera ODL\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"validate(true)\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Genera ODL\" btn-class=\"btn-btn-default\" icon=\"fa fa-code-fork\" toolbar-function=\"generate_odl(data.UUID)\" sx-disabled=\"show_generate_odl(data.status) && !isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"!data.version\">Nuova segnalazione</h1><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"data.version\">Segnalazione n. <span class=\"m-l-xs\">{{data.model.code}}</span></h1></div><div class=\"col-sm-6 col-xs-12\"><issue-tab class=\"pull-right\" sx-object=\"data\" sx-base-path=\"\'issue\'\" sx-status=\"data.status\" sx-uuid=\"data.UUID\" sx-show-buttons=\"isWritePermAllowed()\"></issue-tab></div></div></div><div class=\"panel-body\"><uib-tabset class=\"tabs-right\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Dati</uib-tab-heading><div class=\"row m-b\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data inserimento</label><six-date-time-picker name=\"date_insertion\" date-options=\"dateOptions\" ng-model=\"data.date_insertion\"></six-date-time-picker></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data richiesta</label><six-date-time-picker name=\"date_requested\" date-options=\"dateOptions\" ng-model=\"data.date_requested\"></six-date-time-picker></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data di presa in carico</label><six-date-time-picker name=\"date_handling\" date-options=\"dateOptions\" ng-model=\"data.date_handling\"></six-date-time-picker></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data chiusura</label><six-date-time-picker name=\"date_closing\" date-options=\"dateOptions\" ng-model=\"data.date_closing\"></six-date-time-picker></div></div></div></div><div class=\"row m-b-xs\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"col-md-4 form-group\"><label class=\"control-label\">Tipo Asset</label><six-lookup-2 sx-id=\"issue-schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-title=\"\'Tipo asset\'\" ng-model=\"data.model\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\" sx-field=\"\'type_id\'\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-page-size=\"10000\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"issue-asset\" sx-base-path=\"\'record\'\" sx-title=\"\'Asset\'\" ng-model=\"data.model\" sx-type=\"data.model.type_id.UUID\" sx-field=\"\'record_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Richiedente</label><six-lookup-2 sx-id=\"issue-richiedente\" ng-model=\"data\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'reporter_id\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-prefill=\"{model: {typeoperator: \'richiedente\'}}\"></six-lookup-2></div></div></div><div class=\"col-md-12 hr-margin\"><div class=\"panel panel-default pnl-no-margin-t-b\" id=\"panel1\"><a data-toggle=\"collapse\" data-target=\"#collapseOne\"><div class=\"panel-heading\"><h5 class=\"override-margin-top-bottom\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i>Watchers</h5></div></a><div id=\"collapseOne\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"col-md-1 no-pad-l-r\"><h5>Aggiungi:</h5></div><form name=\"validationForm\"><div class=\"col-md-11\"><div class=\"col-md-1\"><input type=\"radio\" id=\"bool_watch_internal\" ng-checked=\"bool_watch_internal\" ng-click=\"setBoolWatchInternal()\"><label for=\"bool_watch_internal\" class=\"control-label\">Interno</label></div><div class=\"col-md-1\"><input type=\"radio\" id=\"bool_watch_external\" ng-checked=\"bool_watch_external\" ng-click=\"setBoolWatchExternal()\"><label for=\"bool_watch_external\" class=\"control-label\">Esterno</label></div></div><div class=\"row col-md-12 no-pad-l-r\"><div class=\"col-md-4 form-group\" ng-if=\"bool_watch_internal == true\"><six-lookup-2 ng-model=\"watcher\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'user\'\"><a class=\"btn btn-success\" ng-click=\"addWatcher()\"><span class=\"fa fa-plus\"></span></a></six-lookup-2></div><div class=\"col-md-4 form-group\" ng-if=\"bool_watch_external == true\"><span class=\"input-group has-button\"><input type=\"email\" name=\"inputMail\" class=\"form-control\" ng-model=\"watcher.mail\"> <span class=\"input-group-btn\"><a class=\"btn btn-success\" ng-click=\"addWatcher()\"><span class=\"fa fa-plus\"></span></a></span></span><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"validationForm.inputMail.$error.email\">Email non valida</span></div></div></div></form><div class=\"row col-md-12 no-pad-l-r\"><div class=\"col-md-6\" ng-if=\"data.watchers.internal.length != 0\"><label class=\"control-label\">Watcher interni:</label></div><div class=\"col-md-6\" ng-if=\"data.watchers.external.length != 0\"><label class=\"control-label\">Watcher esterni:</label></div></div><div class=\"row col-md-12 no-pad-l-r\"><div class=\"col-md-6\" ng-if=\"data.watchers.internal.length != 0\"><div class=\"col-md-12 no-pad-l-r margin-col-l\" ng-repeat=\"w in data.watchers.internal track by $index\"><span class=\"input-group has-button\"><six-lookup-2 ng-model=\"w\" sx-type=\"w.type\" sx-base-path=\"\'record\'\" sx-disabled=\"true\" sx-closable=\"false\"></six-lookup-2><span class=\"input-group-btn\"><a class=\"btn btn-danger\" ng-click=\"deleteWatcher(data.watchers.internal, w)\"><span class=\"fa fa-trash-o\"></span></a></span></span></div></div><div class=\"col-md-6\" ng-if=\"data.watchers.external.length != 0\"><div class=\"col-md-12 no-pad-l-r margin-col-l\" ng-repeat=\"w in data.watchers.external\"><span class=\"input-group has-button\"><input type=\"email\" class=\"form-control\" ng-model=\"w\" disabled=\"\"> <span class=\"input-group-btn\"><a class=\"btn btn-danger\" ng-click=\"deleteWatcher(data.watchers.external, w)\"><span class=\"fa fa-trash-o\"></span></a></span></span></div></div></div></div></div></div></div></div><div class=\"col-md-12 hr-margin\"><div class=\"panel panel-default pnl-no-margin-t-b\" id=\"panel2\"><a data-toggle=\"collapse\" data-target=\"#collapseTwo\"><div class=\"panel-heading\"><h5 class=\"override-margin-top-bottom\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i> Tecnici - Assegnatari</h5></div></a><div id=\"collapseTwo\" class=\"panel-collapse collapse in\"><div class=\"panel-body\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"col-md-4 form-group\"><label class=\"control-label\">Responsabile esterno</label><div class=\"col-md-11 no-pad-l-r\"><six-lookup-2 sx-id=\"supervisorExternal_id\" ng-model=\"data.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'supervisorExternal_id\'\" sx-add=\"true\" sx-filter=\"supervisorExternalFilter\" sx-show-details=\"true\" sx-show-filters=\"true\"><button class=\"btn btn-default\" ng-click=\"addWatcherFromLookUp(data.references_assignee.supervisorExternal_id)\"><i class=\"fa fa-envelope-o\"></i></button></six-lookup-2></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Segreteria</label><div class=\"col-md-11 no-pad-l-r\"><six-lookup-2 sx-id=\"secretariat_id\" ng-model=\"data.references_assignee\" sx-type=\"\'segreteria\'\" sx-base-path=\"\'record\'\" sx-field=\"\'secretariat_id\'\" sx-filter=\"secretariatFilter\" sx-show-details=\"true\"><button class=\"btn btn-default\" ng-click=\"addWatcherFromLookUp(data.references_assignee.secretariat_id)\"><i class=\"fa fa-envelope-o\"></i></button></six-lookup-2></div></div></div></div></div></div></div><div class=\"col-md-12 hr-margin\" ng-if=\"responsableList.length > 0\"><div class=\"panel panel-default pnl-no-margin-t-b\" id=\"panel3\"><a data-toggle=\"collapse\" data-target=\"#collapseThree\"><div class=\"panel-heading\"><h5 class=\"override-margin-top-bottom\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i> Contatti responsabili</h5></div></a><div id=\"collapseThree\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"row col-md-12 no-pad-l-r\" ng-repeat=\"r in responsableList\"><div class=\"col-md-12\"><div class=\"col-md-4 form-group\"><input type=\"text\" class=\"form-control\" ng-model=\"r.name\" disabled=\"\"></div><div class=\"col-md-4 form-group\"><input type=\"text\" class=\"form-control\" ng-model=\"r.contacts\" disabled=\"\"></div></div></div></div></div></div></div></div></div><div class=\"col-md-10 form-group s-f-height\" ng-if=\"data.UUID\"><label class=\"margin-col-l\">Codice</label> <input type=\"text\" class=\"form-control\" ng-model=\"data.model.code\" disabled=\"\"></div><div class=\"col-md-2 form-group s-f-height\" ng-if=\"data.UUID\"><label class=\"margin-col-l\">Utente inserimento</label> <input type=\"text\" class=\"form-control\" ng-model=\"data.user\" disabled=\"\"></div><div class=\"col-md-12 no-pad-l-r\"><form name=\"detailForm\"><div class=\"row wrapper\"><div class=\"override-form-group override-checkbox\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"data.model\"></div></div></form></div><div ng-if=\"!(schemaIssueDefined)\"><div class=\"wrapper\"><div class=\"row\"><label class=\"control-label\">Schema non definito</label></div></div></div></uib-tab><uib-tab index=\"1\" disable=\"!data.UUID\" select=\"getTimeline()\"><uib-tab-heading><span class=\"fa fa-history text-info-dker\"></span> Storico stati</uib-tab-heading><div class=\"col-md-12\"><div class=\"hbox hbox-auto-xs hbox-auto-sm ng-scope\"><div class=\"col col-md-4\"><div class=\"wrapper\"><ul class=\"timeline\"><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">INIZIO</div></li><li ng-repeat=\"item in timeline\" class=\"tl-item\" ng-class-odd=\"\'tl-left\'\"><div class=\"tl-wrap\" ng-class=\"{\'b-success\': (model.version == item.version)}\"><span class=\"tl-date\">{{item.dataIn | date : format : timezone}}</span><div class=\"tl-content panel padder b-a\" ng-class=\"{\'bg-success\': (model.version == item.version)}\"><span class=\"arrow left pull-up hidden-left\" ng-class=\"{\'arrow-success\': (model.version == item.version)}\"></span> <span class=\"arrow right pull-up visible-left\" ng-class=\"{\'arrow-success\': (model.version == item.version)}\"></span><div class=\"text-lt m-b-sm\"><a ng-click=\"getModelDetail(item.version)\">{{item.model.code}}</a></div><div class=\"panel-body pull-in b-t b-light\"><span class=\"pull-right label\" ng-class=\"{\'bg-success\': (model.version == item.version), \'bg-info\': (model.version != item.version)}\">{{item.user}}</span></div><div class=\"panel-body pull-in b-t b-light\">Stato: {{item.status}}</div><div class=\"panel-body pull-in b-t b-light\">Note: {{item.status_note}}</div></div></div></li><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">FINE</div></li></ul></div></div><div class=\"col wrapper bg-white\" ng-if=\"showDetail\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"row wrapper\"><div class=\"col-md-12\"><label class=\"control-label\">Stato</label><div class=\"col-md-12 no-pad-l-r\"><span disabled=\"true\" class=\"form-control\">{{currentDataInTimeline.status}}</span></div></div><div class=\"col-md-12\"><label class=\"control-label\">Note cambio di stato</label><div class=\"col-md-12 no-pad-l-r\"><textarea rows=\"4\" class=\"col-md-12\">{{currentDataInTimeline.status_note}}</textarea></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Tipo Asset</label><six-lookup-2 sx-id=\"issue-schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-title=\"\'Tipo asset\'\" ng-model=\"currentDataInTimeline.model\" sx-field=\"\'type_id\'\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"issue-asset\" sx-base-path=\"\'record\'\" sx-title=\"\'Asset\'\" ng-model=\"data.model\" sx-type=\"currentDataInTimeline.model.type_id.UUID\" sx-field=\"\'record_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Richiedente</label><div class=\"col-md-12 no-pad-l-r\"><six-lookup-2 sx-id=\"issue-richiedente\" ng-model=\"currentDataInTimeline\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'reporter_id\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Data inserimento</label><div class=\"col-md-12 no-pad-l-r\"><input type=\"datetime-local\" class=\"form-control\" ng-model=\"currentDataInTimeline.date_insertion\"></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Data richiesta</label><div class=\"col-md-12 no-pad-l-r\"><input type=\"datetime-local\" class=\"form-control\" ng-model=\"currentDataInTimeline.date_requested\"></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Data di presa in carico</label><div class=\"col-md-12 no-pad-l-r\"><input type=\"datetime-local\" class=\"form-control\" ng-model=\"currentDataInTimeline.date_handling\"></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Data chiusura</label><div class=\"col-md-12 no-pad-l-r\"><input type=\"datetime-local\" class=\"form-control\" ng-model=\"currentDataInTimeline.date_closing\"></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Responsabile esterno</label><div class=\"col-md-12 no-pad-l-r\"><six-lookup-2 sx-id=\"timeline-supervisorExternal_id\" ng-model=\"currentDataInTimeline.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'supervisorExternal_id\'\" sx-add=\"true\" sx-filter=\"supervisorExternalFilter\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Segreteria</label><div class=\"col-md-12 no-pad-l-r\"><six-lookup-2 sx-id=\"timeline-secretariat_id\" ng-model=\"currentDataInTimeline.references_assignee\" sx-type=\"\'segreteria\'\" sx-base-path=\"\'record\'\" sx-field=\"\'secretariat_id\'\"></six-lookup-2></div></div></div><div class=\"col-md-12\"><div sf-schema=\"schemaDataInTimeline\" sf-form=\"formDataInTimeline\" sf-model=\"currentDataInTimeline.model\"></div></div></div></div></div></div></uib-tab><uib-tab index=\"2\" disable=\"!data.version\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments nodes=\"attachments\" save-callback=\"updAttachments()\"></six-tree-attachments></uib-tab><uib-tab index=\"3\" disable=\"!data.version\" select=\"getMessage()\"><uib-tab-heading><span class=\"fa fa-envelope text-info-dker\"></span> Messaggio</uib-tab-heading><div class=\"col-md-12\" ng-if=\"loadingSixMail == true\"><uib-progressbar class=\"progress-striped active\" type=\"info\"><i>Caricamento messaggio</i></uib-progressbar></div><six-send-email ng-if=\"loadingSixMail == false\" sx-title-mail=\"objMail.title\" sx-body-mail=\"objMail.message\" sx-to-mail=\"objMail.to\" sx-cc-mail=\"objMail.cc\" sx-type-mail=\"\'issue\'\" sx-record-id=\"currentIssueRef\"></six-send-email></uib-tab><uib-tab index=\"4\" disable=\"!data.version\"><uib-tab-heading><span class=\"fa fa-qrcode text-info-dker\"></span> QRCODE</uib-tab-heading><qrcode version=\"5\" error-correction-level=\"H\" size=\"274\" data=\"{{data.UUID}}\"></qrcode></uib-tab><uib-tab index=\"5\" disable=\"!data.version\" select=\"getNotificationsList()\"><uib-tab-heading><span class=\"icon-bell text-info-dker\"></span> Notifiche</uib-tab-heading><div ng-if=\"notifications.length==0\" class=\"alert alert-info\" role=\"alert\">Nessuna notifica</div><ul class=\"list-group list-group-lg no-radius m-b-none m-t-n-xxs\"><li ng-repeat=\"notification in notifications\" class=\"list-group-item clearfix b-l-3x ng-scope\" ng-class=\"notification.color\"><span class=\"avatar thumb pull-left m-r\"><img ng-hide=\"notification.user\" ng-src=\"/images/avatar_system.png\"> <img ng-show=\"notification.user\" ng-src=\"/images/avatar_emil.png\"></span><div class=\"pull-right text-sm text-muted\"><span class=\"hidden-xs ng-binding\">{{notification.dataIn | date:\"dd/MM/yyyy\"}}</span></div><div class=\"clear\"><div><a class=\"text-md ng-binding\" ng-href=\"{{notification.href}}\"><span ng-show=\"notification.model.subject\">Oggetto: {{notification.model.subject}}</span> <span ng-show=\"notification.user\">da {{notification.user}}</span> <span ng-show=\"notification.model.to\">a {{notification.model.to}}</span></a></div><div class=\"text-ellipsis m-t-xs ng-binding\">{{notification.model.bodyAsText}}</div></div></li></ul></uib-tab><uib-tab index=\"6\" disable=\"!data.version\"><uib-tab-heading><span class=\"fa fa-tasks text-info-dker\"></span> ODL</uib-tab-heading><div><div ng-if=\"odlList.length==0\" class=\"alert alert-info\">Non ci sono ODL associati a questa segnalazione</div><div ng-if=\"odlList.length>0\"><div class=\"row wrapper\"><table class=\"table table-striped\"><thead><th></th><th>Asset</th><th>Titolo</th><th>Stato</th><th>Utente generazione</th><th>Data generazione</th><th>Data pianifica</th></thead><tbody><tr ng-repeat=\"item in odlList\"><td><a ng-href=\"#/odl/{{item.UUID}}\" class=\"btn btn-xs btn-primary\"><span class=\"fa fa-search\"></span></a></td><td>{{item.model.asset_description}}</td><td>{{item.model.title}}</td><td>{{item.status}}</td><td>{{item.model.user_input_name}} {{item.model.user_input_surname}}</td><td>{{item.dataIn |date }}</td><td>{{item.date_requested | date}}</td></tr></tbody></table></div></div></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("plan/issue/callcenter_list.html","<six-toolbar><six-toolbar-button label=\"Aggiungi segnalazione\" icon=\"fa fa-plus\" toolbar-function=\"newIssueByCallcenter()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Tutte\" icon=\"fa fa-square-o\" icon-disabled=\"fa fa-check-square-o\" icon-condition=\"bool.allIssues\" toolbar-function=\"toggleAllIssues();\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista segnalazioni - Call center</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination sx-id=\"issues\" get-data-callback=\"getCurrentUserIssueList()\" get-list-callback=\"getCurrentUserIssueList()\" items-list=\"issueList\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" grid-app-callbacks=\"gridAppCallbacks\" show-global-search=\"false\"></six-grid-pagination></div></div></div>");
$templateCache.put("plan/issue/issue.html","<six-toolbar><six-toolbar-button label=\"Aggiungi segnalazione\" icon=\"fa fa-plus\" toolbar-function=\"newIssue()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista segnalazioni</h1></div></div></div><div class=\"panel-body\"><div id=\"grid1\" ui-grid=\"viewGridOptions\" class=\"grid\" ui-grid-multiple=\"\" ui-grid-selection=\"\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\" ui-grid-auto-resize=\"\" ui-grid-exporter=\"\" external-scopes=\"clickHandler\"></div><div class=\"progress-xxs m-t-sm dk progress ng-isolate-scope\" value=\"{{percent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{percent}}%;\"></div></div></div></div></div>");
$templateCache.put("plan/issue/issueconfigurator_detail.html","<six-toolbar><six-toolbar-button label=\"Lista\" icon=\"fa fa-chevron-left\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Duplica\" btn-class=\"btn-primary\" icon=\"fa fa-files-o\" toolbar-function=\"setConfModel()\" ng-if=\"selected.version\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-trash-o\" toolbar-function=\"delete()\" sx-disabled=\"!isDeletePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Dettaglio Configurazione</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-heading\" style=\"background-color: transparent\"><div class=\"page-header-bleed-right\"><div class=\"actions\"><div class=\"row\"><form name=\"header\"><div class=\"form-group\"><div class=\"col-md-12\"><label class=\"control-label\">Codice:</label> <input type=\"text\" class=\"form-control\" ng-model=\"commissionCode\" ng-disabled=\"bool.isCross || bool.isCallCenter\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"!bool.isCross && !bool.isCallCenter\"><label class=\"col-md-1 control-label\">Commesse:</label><div class=\"col-md-12\"><div id=\"vectors_budget_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"commissionsSelected.codes\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una commessa...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in commissions\"><span ng-bind-html=\"item.code | highlight: $select.search\"></span> - <span ng-bind-html=\"item.description | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"col-md-12\"><input type=\"checkbox\" ng-model=\"bool.isCross\" name=\"cross_commission\" ng-click=\"updateCode()\"> <label class=\"control-label\">Imposta come configurazione di default per gli utenti (cross-commessa)</label></div><div class=\"col-md-12\"><input type=\"checkbox\" ng-model=\"bool.isCallCenter\" name=\"isCallCenter\" ng-click=\"setCallCenter()\"> <label class=\"control-label\">Imposta come configurazione del Call Center</label></div></div></form></div></div></div></div><div class=\"panel-body\"><uib-tabset justified=\"true\"><uib-tab heading=\"Preview\"><form name=\"myForm\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"model\" ng-submit=\"onSubmit(myForm)\"></form></uib-tab><uib-tab heading=\"Schema\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><div class=\"col-md-12 centered\"><b>SCHEMA</b></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><b>CODICE</b></div><div class=\"col-md-3\"><b>DESCRIZIONE</b></div><div class=\"col-md-1\"><b>TIPOLOGIA</b></div><div class=\"col-md-2\"><b>FORMATO</b></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><form name=\"propertyKeyForm\"><input class=\"form-control\" name=\"property_key\" placeholder=\"Codice...\" type=\"text\" ng-model=\"property.key\" pattern=\"^[a-zA-Z]+[\\w]*$\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"propertyKeyForm.property_key.$error.pattern\">Caratteri non consentiti</span></div></form></div></div><div class=\"col-md-3\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><input class=\"form-control\" placeholder=\"Descrizione\" type=\"text\" ng-model=\"property.title\"></div></div><div class=\"col-md-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.type\"><option></option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"boolean\">boolean</option><option value=\"date\">date</option><option value=\"array\">array</option></select></div></div><div class=\"col-md-2\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'string\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'number\' || property.type == \'integer\')\"><option></option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.items_type\" ng-if=\"(property.type == \'array\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"date\">date</option></select></div></div><div class=\"col-md-2\"><div ng-if=\"isInheritable(property.type)\"><label><input type=\"checkbox\" ng-model=\"property.inherited\"> Campo ereditato</label></div></div><div class=\"col-md-1\"><button ng-click=\"addProperty()\" class=\"btn btn-sm btn-info pull-right\"><span class=\"fa fa-plus\"></span> Add</button></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-repeat=\"(key, value) in selected.model.schema.properties\" style=\"align-content: center; padding-bottom: 0px;\"><div class=\"col-md-12 uniform-height\" style=\"align-content: center;\"><div class=\"col-md-1\"><a href=\"\" ng-click=\"status[key].open = !status[key].open\" id=\"btn_row_detail\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status[key].open, \'glyphicon-chevron-right\': !status[key].open}\"></i></a></div><div class=\"col-md-2\">{{ key }}</div><div class=\"col-md-3\">{{ value.title }}</div><div class=\"col-md-1\">{{ value.type }}</div><div class=\"col-md-2\"><span ng-if=\"value.format\">{{value.format}}</span> <span ng-if=\"value.type == \'array\' && value.items\">{{value.items.format}}</span></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"status[key].open\"><div class=\"col-md-12 uniform-height-2\" ng-if=\"value.format !== \'lookup\' && value.format !== \'formula\' && value.format !== \'enum\' && value.format !== \'inherit\' && value.type !== \'array\'\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-10\">{{value.format}}</div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'inherit\'\" ng-include=\"\'dataset/modeltype/detail_inherit.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'lookup\' && value.type != \'array\'\" ng-include=\"\'dataset/modeltype/detail_lookup.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'formula\'\" ng-include=\"\'dataset/modeltype/detail_formula.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'enum\'\" ng-include=\"\'dataset/modeltype/detail_enum.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.type === \'array\'\" ng-include=\"\'dataset/modeltype/detail_array.html\'\"></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ELIMINA:</div><div class=\"col-md-10\"><button ng-click=\"deleteProperty(key)\" class=\"btn btn-danger btn-xs btn-default\" ng-disabled=\"(key === \'code\' || key === \'description\')\"><i class=\"fa fa-trash\"></i></button></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">IN TABELLA:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.check\" ng-change=\"changeColumnDefs(key, value)\" ng-disabled=\"(key === \'code\' || key === \'description\')\"></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"value.check == true\"><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">LARGHEZZA (px):</div><div class=\"col-md-10\"><input type=\"text\" min=\"1\" step=\"1\" size=\"45\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"value.width\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ORDINAMENTO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableSorting\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FILTRAGGIO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableFiltering\" ng-change=\"changeColumnDefs(key, value)\"></div></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div></div></div></div></uib-tab><uib-tab heading=\"Form\"><table class=\"table table-striped\"><thead><th colspan=\"5\">FORM</th><tr><th colspan=\"5\"><div class=\"form-group\"><label for=\"title\" class=\"control-label\">Titolo</label><div class=\"\"><input type=\"text\" class=\"form-control\" id=\"title\" placeholder=\"\" ng-model=\"title\" name=\"title\" ng-keyup=\"refreshTitleForm(title)\"></div></div></th></tr><tr><td></td><td></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newTab.title\"></td><td><button ng-click=\"addTab(selected.model.form[0].items[0])\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th></th><th>POSIZIONE</th><th>TITOLO</th><th></th></tr></thead><tbody><tr ng-repeat-start=\"(key, tab) in selected.model.form[0].items[0].tabs\"><td><a href=\"\" ng-click=\"statusForm[key].open = !statusForm[key].open\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': statusForm[key].open, \'glyphicon-chevron-right\': !statusForm[key].open}\"></i></a></td><td><span class=\"btn btn-sm\" ng-click=\"swapUp(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key<=0\"><i class=\"fa fa-caret-up\"></i></span> {{key+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key>=selected.model.form[0].items[0].tabs.length-1\"><i class=\"fa fa-caret-down\"></i></span></td><td><input type=\"text\" ng-model=\"tab.title\" ng-disabled=\"(tab.key[0] == \'code\' || tab.key[0] == \'description\')\" ng-keyup=\"updateScope()\"></td><td><a ng-click=\"removeTabOrField(key, selected.model.form[0].items[0].tabs)\" class=\"btn btn-danger btn-xs btn-default\" id=\"btn_row_detail_form\"><i class=\"fa fa-trash\"></i></a></td></tr><tr ng-repeat-end=\"\" ng-show=\"statusForm[key].open\"><td></td><td colspan=\"3\" style=\"background-color:rgba(211, 211, 211, 0.38);\"><table class=\"table table-striped override-margin\"><tr><td></td><td><select ng-options=\"k as v.title for (k, v) in schema.properties\" ng-model=\"newFieldForm.key\"></select></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newFieldForm.title\"></td><td><input type=\"checkbox\" placeholder=\"Richiesto...\" ng-model=\"newFieldForm.required\"></td><td><select ng-model=\"newFieldForm.type\" ng-change=\"updateScope()\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><button ng-click=\"addFieldToTab(tab)\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th>POSIZIONE</th><th>CAMPO</th><th>TITOLO</th><th>REQUIRED</th><th>TIPO</th><th></th></tr><tr ng-repeat=\"(fieldKey, field) in tab.items\"><td class=\"override-width-200px\"><div><span class=\"btn btn-sm\" ng-click=\"swapUp(fieldKey, tab.items)\" ng-disabled=\"fieldKey<=0\"><i class=\"fa fa-caret-up\"></i></span> {{fieldKey+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(fieldKey, tab.items)\" ng-disabled=\"fieldKey>=tab.items.length-1\"><i class=\"fa fa-caret-down\"></i></span></div></td><td ng-if=\"!field.title\">{{field}}</td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"field.title\">{{field.key[0]}}</td><td ng-if=\"field.title\"><input type=\"text\" ng-model=\"field.title\" ng-keyup=\"updateScope()\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.required\" ng-change=\"updateScope()\"></td><td ng-if=\"field.title\"><select ng-model=\"field.type\" ng-change=\"updateField(field)\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><a ng-click=\"removeTabOrField(fieldKey, tab.items)\" class=\"btn btn-danger btn-xs btn-default\"><i class=\"fa fa-trash\"></i></a></td></tr></table></td></tr></tbody></table></uib-tab></uib-tabset></div><div class=\"panel-footer\"><div class=\"form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" class=\"pull-left\" data-toggle=\"collapse\" data-target=\"#json-collapse\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div></div><div class=\"row collapse\" id=\"json-collapse\" collapse=\"!jsonshow\"><div class=\"col-md-8\"><div class=\"panel no-border\"><div class=\"panel-heading wrapper b-b b-light\"><h4 class=\"font-thin m-t-none m-b-none text-muted\">Dettaglio</h4></div><div style=\"margin-top:0px;\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'json\', firstLineNumber: 1, onLoad: aceLoaded, onChange: aceChanged }\" ng-model=\"aceModel\"></div></div></div><div class=\"col-md-4\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{ model}}</pre></div></div></div></div></div></div>");
$templateCache.put("plan/issue/issueconfigurator_list.html","<six-toolbar><six-toolbar-button label=\"Crea modello segnalaz.\" icon=\"fa fa-plus\" toolbar-function=\"newIssueConfig()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista configurazioni segnalazioni</h1></div></div></div><div class=\"panel-body\"><div class=\"form-group\"><input ng-keyup=\"getData(queryParam)\" class=\"form-control\" type=\"text\" ng-model=\"queryParam\" placeholder=\"Type here to filter the list...\"></div><table id=\"issue_configurator_list\" class=\"table table-striped\"><thead><tr><th></th><th>CODICE CONFIGURAZIONE</th><th>COMMESSA</th><th>DATA</th></tr></thead><tbody><tr ng-repeat=\"item in issueConfiguratorList.list\"><td><a ng-href=\"#/issueconfigurator/{{item.UUID}}\" class=\"btn btn-default\" id=\"btn_issue_detail\"><span class=\"fa fa-search\"></span></a></td><td>{{ item.model.code }}</td><td>{{printCommission(item.model.commission)}}</td><td>{{ item.dataIn | date:\'dd/MM/yyyy\' }}</td></tr><tr ng-hide=\"issueConfiguratorList.list.length\"><td><p class=\"text-center\">Nessun record recuperato</p></td></tr></tbody></table></div><div class=\"panel-footer\"><div class=\"row text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"issueConfiguratorList.totalResults\" ng-model=\"issueConfiguratorList.currentPage\" class=\"pagination-sm\" items-per-page=\"issueConfiguratorList.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div></div></div>");
$templateCache.put("plan/issue/issuedetail_edit.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" label=\"Indietro\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" disabled=\"!(schemaIssueDefined)\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"update()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Segnalazione - Schermata di gestione</h1></div></div></div><div class=\"panel-body\"><uib-tabset class=\"tabs-right\"><uib-tab><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Dati</uib-tab-heading><div ng-if=\"schemaIssueDefined\"><div class=\"row wrapper\"><div class=\"col-md-4 only-margin-b\"><label class=\"control-label\">Tipo Asset</label><six-lookup-2 sx-base-path=\"\'schema\'\" sx-id=\"issue-schema\" sx-title=\"\'Tipo asset\'\" ng-model=\"data.model\" sx-field=\"\'type_id\'\"></six-lookup-2></div><div class=\"col-md-4 only-margin-b\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-base-path=\"\'record\'\" sx-id=\"issue-asset\" sx-title=\"\'Asset\'\" ng-model=\"data.model\" sx-type=\"data.model.type_id.UUID\" sx-field=\"\'record_id\'\"></six-lookup-2></div><div class=\"col-md-4 only-margin-b\"><label class=\"control-label\">Stato</label> <span disabled=\"true\" class=\"form-control\">{{data.status}}</span></div><div class=\"col-md-4 only-margin-b\"><h5>Data inserimento</h5><div class=\"col-md-12 no-pad-l-r\"><input type=\"date\" readonly=\"\" class=\"form-control\" ng-model=\"data.date_insertion\"></div></div><div class=\"col-md-4 only-margin-b\"><h5>Data richiesta</h5><div class=\"col-md-12 no-pad-l-r\"><input type=\"date\" readonly=\"\" class=\"form-control\" ng-model=\"data.date_requested\"></div></div><div class=\"col-md-4 only-margin-b\"><h5>Data di presa in carico</h5><div class=\"col-md-12 no-pad-l-r\"><input type=\"date\" readonly=\"\" class=\"form-control\" ng-model=\"data.date_handling\"></div></div><div class=\"col-md-4 only-margin-b\"><h5>Data chiusura</h5><div class=\"col-md-12 no-pad-l-r\"><input type=\"date\" readonly=\"\" class=\"form-control\" ng-model=\"data.date_closing\"></div></div><div class=\"col-md-12 only-margin-b\"><h5>Codice</h5><div class=\"col-md-12 no-pad-l-r\"><input type=\"text\" class=\"form-control\" ng-model=\"data.model.code\" disabled=\"\"></div></div><div class=\"col-md-12 only-margin-b\"><form name=\"detailForm2\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"data.model\"></form></div></div></div><div class=\"row wrapper\" ng-if=\"!(schemaIssueDefined)\"><label class=\"control-label\">Schema non definito &#x2192; Configurare prima il modello \'segnalazione\'</label></div></uib-tab><uib-tab><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments nodes=\"attachments\" save-callback=\"updAttachments()\"></six-tree-attachments></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("plan/issue/issuedetail_new.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Aggiungi\" btn-class=\"btn-success\" icon=\"fa fa-plus\" disabled=\"!(schemaIssueDefined)\" toolbar-function=\"update()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Inserimento Segnalazione</h1></div></div></div><div class=\"panel-body\"><div ng-if=\"schemaIssueDefined\"><div class=\"wrapper\"><div class=\"row\"><div class=\"col-md-6 m-t\"><label id=\"type_label\" for=\"type\" class=\"control-label\">Tipo Asset</label><six-lookup sx-base-path=\"\'schema\'\" id=\"type\" ng-model=\"data.model\" sx-field=\"\'type_id\'\"></six-lookup></div><div class=\"col-md-6 m-t\"><label id=\"record_label\" for=\"record\" class=\"control-label\">Asset</label><six-lookup sx-base-path=\"\'record\'\" id=\"record\" ng-model=\"data.model\" sx-type=\"data.model.type_id.UUID\" sx-field=\"\'record_id\'\"></six-lookup></div></div></div><form name=\"detailForm2\" class=\"wrapper\" ng-submit=\"onSubmitDetailForm(detailForm)\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"data.model\"></form></div><div ng-if=\"!(schemaIssueDefined)\"><div class=\"wrapper\"><div class=\"row\"><label class=\"control-label\">Schema non definito &#x2192; Configurare prima il modello \'segnalazione\'</label></div></div></div></div></div></div>");
$templateCache.put("plan/issue/tree_issue.html","<style type=\"text/css\">\n  .node_selected {\n    background-color: #acf4e0;\n  }\n\n  /* Aggiustamenti per non avere la toolbar sovrapposta */\n\n  .custom-padding {\n    padding-top: 50px;\n    padding-bottom: 50px;\n  }\n</style><script type=\"text/ng-template\" id=\"tree_renderer.html\"><div class=\"tree-node\" ng-click=\"selectNode(node)\" ng-class=\"{\'node_selected\': isNodeSelected(node)}\"> <div class=\"tree-node-content\"> <div class=\"pull-left model-icon\" style=\"width: 26px;\" ui-tree-handle> <span class=\"text-info-dker pull-right m-l-xs m-r-xs model-icon\" title=\"{{node.schemaCode}}\" data-placement=\"left\" data-original-title=\"{{node.schemaCode}}\" tooltip><i ng-class=\"getModelIcon(node.schemaCode)\"></i></span> </div> <div> <a class=\"btn btn-xs btn-default\" data-nodrag ng-click=\"toggleNode(this)\" ng-if=\"node.nodes.length>0\"> <span class=\"fa\" ng-class=\"{\'fa-plus\': collapsed, \'fa-minus\': !collapsed}\"></span> </a> {{node.model.code}} - {{node.model.description}} </div> </div> </div> <ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\"> <li ng-repeat=\"node in node.nodes | recordsSearchFilter: searchInputInTree.text\" ui-tree-node ng-include=\"\'tree_renderer.html\'\" /> </ol></script><div class=\"col-md-12 override-padding-15-px\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-12 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Segnalazioni</h1><h1></h1><a href=\"#/issue\">Vista elenco</a></div></div></div><div class=\"col-md-4\" ng-if=\"showTree\" style=\"padding-left: 0px !important\"><div class=\"panel wrapper\"><div class=\"panel-body form-group\"><div class=\"form-group m-t-xs\"><six-search-form ng-model=\"searchInputInTree.text\" placeholder=\"Cerca...\" hide-search-btn=\"\"></six-search-form></div><div ui-tree=\"treeOptions\" id=\"tree1-root\"><ol ui-tree-nodes=\"\" ng-model=\"tree.wrapper.model.nodes\" id=\"tree\"><li ng-repeat=\"node in tree.wrapper.model.nodes | recordsSearchFilter: searchInputInTree.text\" ui-tree-node=\"\" ng-include=\"\'tree_renderer.html\'\"></li></ol></div></div></div></div><div class=\"col-md-8\" style=\"padding-right: 0px !important\"><div class=\"panel wrapper\" ng-if=\"selected.treeNode\"><div class=\"\"><h1 class=\"m-n font-thin h3 text-black\">Inserimento Segnalazione</h1></div><div ng-if=\"schemaIssueDefined\" class=\"text-right hidden-xs\"><div class=\"inline m-r text-left\"><button ng-click=\"update()\" class=\"btn btn-success btn-sm pull-right\" id=\"btn_create\"><span class=\"fa fa-plus\"></span> Add</button></div></div><div ng-if=\"!(schemaIssueDefined)\" class=\"text-left\"><label class=\"control-label\">Schema non definito &#x2192; Configurare prima il modello \'segnalazione\'</label></div><form ng-if=\"schemaIssueDefined\" name=\"detailForm2\" ng-submit=\"onSubmitDetailForm(detailForm)\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"data.model\"></form></div></div><div class=\"panel-footer\" ng-if=\"false\"><div class=\"row form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" class=\"pull-left\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div><div class=\"row\" collapse=\"!jsonshow\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{ tree.wrapper | json }}</pre></div></div></div></div>");
$templateCache.put("plan/odl/odl_detail.html","<six-toolbar><six-toolbar-item label=\"ODL n. {{data.model.code}} - {{data.status}}\" ng-show=\"data.version\"></six-toolbar-item><six-toolbar-item label=\"Nuovo ODL\" ng-show=\"!data.version\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"goToOdlList()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" toolbar-function=\"delete(data.version)\" sx-disabled=\"!data.version || !isDeletePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Conf. default\" btn-class=\"btn-info\" icon=\"fa fa-gear\" toolbar-function=\"getConfiguration()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"validate()\" sx-disabled=\"!(schemaOdlDefined) || !isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"!data.version\">Nuovo ODL</h1><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"data.version\">ODL n. <span class=\"m-l-xs\">{{data.model.code}}</span></h1></div><div class=\"col-sm-6 col-xs-12\"><odl-tab class=\"pull-right\" sx-object=\"data\" sx-base-path=\"\'odl\'\" sx-status=\"data.status\" sx-uuid=\"data.UUID\" sx-show-buttons=\"isWritePermAllowed()\"></odl-tab></div></div></div><uib-tabset class=\"tabs-left\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> ODL</uib-tab-heading><div ng-if=\"data.generated_by==\'plan\'\" ng-include=\"\'plan/odl/odl_detail_plan.html\'\"></div><div ng-if=\"data.generated_by==\'issue\'\" ng-include=\"\'plan/odl/odl_detail_issue.html\'\"></div><div class=\"col-md-12\"><div class=\"panel panel-default pnl-no-margin-t-b\" id=\"panel1\"><a data-toggle=\"collapse\" data-target=\"#collapseOne\"><div class=\"panel-heading\"><h5 class=\"override-margin-top-bottom\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i> Watchers</h5></div></a><div id=\"collapseOne\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"col-md-1 no-pad-l-r\"><h5>Aggiungi:</h5></div><form name=\"validationForm\"><div class=\"col-md-11\"><div class=\"col-md-1\"><input type=\"radio\" ng-checked=\"bool_watch_internal\" ng-click=\"setBoolWatchInternal()\"> Interno</div><div class=\"col-md-1\"><input type=\"radio\" ng-checked=\"bool_watch_external\" ng-click=\"setBoolWatchExternal()\"> Esterno</div></div><div class=\"row col-md-12 no-pad-l-r\"><div class=\"col-md-4 form-group\" ng-if=\"bool_watch_internal == true\"><six-lookup ng-model=\"watcher\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'user\'\"></six-lookup></div><div class=\"col-md-4 form-group\" ng-if=\"bool_watch_external == true\"><input type=\"email\" name=\"inputMail\" class=\"form-control\" ng-model=\"watcher.mail\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"validationForm.inputMail.$error.email\">Email non valida</span></div></div><div class=\"col-md-1 form-group\"><button class=\"btn btn-default\" ng-click=\"addWatcher()\"><span class=\"fa fa-plus\"></span></button></div></div></form><div class=\"row col-md-12 no-pad-l-r\"><div class=\"col-md-6\" ng-if=\"data.watchers.internal.length != 0\"><h5>Watcher interni:</h5></div><div class=\"col-md-6\" ng-if=\"data.watchers.external.length != 0\"><h5>Watcher esterni:</h5></div></div><div class=\"row col-md-12 no-pad-l-r\"><div class=\"col-md-6\" ng-if=\"data.watchers.internal.length != 0\"><div class=\"col-md-12 no-pad-l-r margin-col-l\" ng-repeat=\"w in data.watchers.internal track by $index\"><six-lookup ng-model=\"w\" sx-type=\"w.type\" sx-base-path=\"\'record\'\" sx-disabled=\"true\" sx-closable=\"false\"><button class=\"btn btn-default\" ng-click=\"deleteWatcher(data.watchers.internal, w)\"><i class=\"fa fa-trash-o\"></i></button></six-lookup></div></div><div class=\"col-md-6\" ng-if=\"data.watchers.external.length != 0\"><div class=\"col-md-12 no-pad-l-r margin-col-l\" ng-repeat=\"w in data.watchers.external\"><div class=\"col-md-11 no-pad-l-r\"><input type=\"email\" class=\"form-control\" ng-model=\"w\" disabled=\"\"></div><div class=\"col-md-1\"><button class=\"btn btn-default\" ng-click=\"deleteWatcher(data.watchers.external, w)\"><i class=\"fa fa-trash-o\"></i></button></div></div></div></div></div></div></div></div></div><div class=\"col-md-12 hr-margin\"><div class=\"panel panel-default pnl-no-margin-t-b\" id=\"panel2\"><a data-toggle=\"collapse\" data-target=\"#collapseTwo\"><div class=\"panel-heading\"><h5 class=\"override-margin-top-bottom\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i> Tecnici - Assegnatari</h5></div></a><div id=\"collapseTwo\" class=\"panel-collapse collapse in\"><div class=\"panel-body\"><div class=\"col-md-4 form-group m-t\"><label class=\"control-label\">Fornitore</label><six-lookup-2 sx-id=\"supplier_id\" ng-model=\"data.references_assignee\" sx-type=\"\'fornitore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'supplier_id\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-filter=\"supplierFilter\"></six-lookup-2></div><div class=\"col-md-4 form-group m-t\"><label class=\"control-label\">Azienda assegnataria</label><six-lookup-2 sx-id=\"company_id\" ng-model=\"data.references_assignee\" sx-type=\"\'azienda\'\" sx-base-path=\"\'record\'\" sx-field=\"\'company_id\'\" sx-add=\"false\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-filter=\"companyFilter\"><button class=\"btn btn-default\" ng-click=\"addWatcherFromLookUp(data.references_assignee.company_id)\"><i class=\"fa fa-envelope-o\"></i></button></six-lookup-2></div><div class=\"col-md-4 form-group m-t\"><label class=\"control-label\">Capo commessa</label><six-lookup-2 sx-id=\"headmanCommission_id\" ng-model=\"data.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'headmanCommission_id\'\" sx-filter=\"headmanCommissionFilter\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\"><button class=\"btn btn-default\" ng-click=\"addWatcherFromLookUp(data.references_assignee.headmanCommission_id)\"><i class=\"fa fa-envelope-o\"></i></button></six-lookup-2></div><div class=\"col-md-4 form-group m-t\"><label class=\"control-label\">Responsabile interno</label><six-lookup-2 sx-id=\"supervisorInternal_id\" ng-model=\"data.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'supervisorInternal_id\'\" sx-filter=\"supervisorInternalFilter\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\"><button class=\"btn btn-default\" ng-click=\"addWatcherFromLookUp(data.references_assignee.supervisorInternal_id)\"><i class=\"fa fa-envelope-o\"></i></button></six-lookup-2></div><div class=\"col-md-4 form-group m-t\"><label class=\"control-label\">Responsabile esterno</label><six-lookup-2 sx-id=\"supervisorExternal_id\" ng-model=\"data.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'supervisorExternal_id\'\" sx-filter=\"supervisorExternalFilter\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\"><button class=\"btn btn-default\" ng-click=\"addWatcherFromLookUp(data.references_assignee.supervisorExternal_id)\"><i class=\"fa fa-envelope-o\"></i></button></six-lookup-2></div><div class=\"col-md-4 form-group m-t\"><label class=\"control-label\">Tecnico di commessa</label><six-lookup-2 sx-id=\"technicianCommission_id\" ng-model=\"data.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'technicianCommission_id\'\" sx-filter=\"technicianCommissionFilter\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-multiple=\"true\" sx-title=\"\'Tecnico\'\"><button class=\"btn btn-default\" ng-click=\"addWatcherFromLookUp(data.references_assignee.technicianCommission_id)\"><i class=\"fa fa-envelope-o\"></i></button></six-lookup-2></div><div class=\"col-md-4 form-group m-t\"><label class=\"control-label\">Manutentori</label><six-lookup-2 sx-id=\"maintainer_id\" ng-model=\"data.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'maintainer_id\'\" sx-filter=\"maintainerFilter\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-multiple=\"true\" sx-title=\"\'Manutentore\'\"><button class=\"btn btn-default\" ng-click=\"addWatcherFromLookUp(data.references_assignee.maintainer_id)\"><i class=\"fa fa-envelope-o\"></i></button></six-lookup-2></div></div></div></div></div><div class=\"col-md-12 hr-margin\" ng-if=\"responsableList.length > 0\"><div class=\"panel panel-default pnl-no-margin-t-b\" id=\"panel3\"><a data-toggle=\"collapse\" data-target=\"#collapseThree\"><div class=\"panel-heading\"><h5 class=\"override-margin-top-bottom\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i> Contatti responsabili</h5></div></a><div id=\"collapseThree\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"row col-md-12 no-pad-l-r\" ng-repeat=\"r in responsableList\"><div class=\"col-md-4 form-group\"><input type=\"text\" class=\"form-control\" ng-model=\"r.name\" disabled=\"\"></div><div class=\"col-md-4 form-group\"><input type=\"text\" class=\"form-control\" ng-model=\"r.contacts\" disabled=\"\"></div></div></div></div></div></div></div><div class=\"panel-body m-t-n\"><div ng-if=\"schemaOdlDefined\"><uib-tabset class=\"tabs-right\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Dati</uib-tab-heading><div class=\"col-md-12 form-group s-f-height\" ng-if=\"data.version\"><label class=\"control-label\">Codice</label> <input type=\"text\" class=\"form-control\" ng-model=\"data.model.code\" disabled=\"\"></div><div class=\"col-md-12 no-pad-l-r\"><form name=\"detailForm\"><div class=\"row wrapper\"><div class=\"override-form-group override-checkbox\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"data.model\"></div></div></form></div><div ng-if=\"!(schemaOdlDefined)\"><div class=\"wrapper\"><div class=\"row\"><label class=\"control-label\">Schema non definito &#x2192; Configurare prima il modello \'odl\'</label></div></div></div></uib-tab><uib-tab index=\"1\" disable=\"!data.UUID\" select=\"getTimeline()\"><uib-tab-heading><span class=\"fa fa-history text-info-dker\"></span> Storico stati</uib-tab-heading><div class=\"col-md-12\"><div class=\"hbox hbox-auto-xs hbox-auto-sm ng-scope\"><div class=\"col col-md-4\"><div class=\"wrapper\"><ul class=\"timeline\"><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">INIZIO</div></li><li ng-repeat=\"item in timeline\" class=\"tl-item\" ng-class-odd=\"\'tl-left\'\"><div class=\"tl-wrap\" ng-class=\"{\'b-success\': (model.version == item.version)}\"><span class=\"tl-date\">{{item.dataIn | date : \'dd/MM/yyyy HH:mm:ss\' : timezone}}</span><div class=\"tl-content panel padder b-a\" ng-class=\"{\'bg-success\': (model.version == item.version)}\"><span class=\"arrow left pull-up hidden-left\" ng-class=\"{\'arrow-success\': (model.version == item.version)}\"></span> <span class=\"arrow right pull-up visible-left\" ng-class=\"{\'arrow-success\': (model.version == item.version)}\"></span><div class=\"text-lt m-b-sm\"><a ng-click=\"getModelDetail(item.version)\">{{item.model.code}}</a></div><div class=\"panel-body pull-in b-t b-light\"><span class=\"pull-right label\" ng-class=\"{\'bg-success\': (model.version == item.version), \'bg-info\': (model.version != item.version)}\">{{item.user}}</span></div><div class=\"panel-body pull-in b-t b-light\">Stato: {{item.status}}</div><div class=\"panel-body pull-in b-t b-light\">Note: {{item.status_note}}</div></div></div></li><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">FINE</div></li></ul></div></div><div class=\"col wrapper bg-white\" ng-if=\"showDetail\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"row wrapper\"><div class=\"col-md-12\"><h5>Stato</h5><div class=\"col-md-12 no-pad-l-r\"><span disabled=\"true\" class=\"form-control\">{{currentDataInTimeline.status}}</span></div></div><div class=\"col-md-12\"><h5>Note cambio di stato</h5><div class=\"col-md-12 no-pad-l-r\"><textarea rows=\"4\" class=\"col-md-12\">{{currentDataInTimeline.status_note}}</textarea></div></div><div class=\"col-md-4 form-group\"><h5>Issue</h5><six-lookup sx-id=\"issue\" sx-base-path=\"\'issue\'\" sx-type=\"\'record\'\" ng-model=\"currentDataInTimeline\" sx-field=\"\'issue_id\'\" sx-war=\"\'six-plan\'\"></six-lookup></div><div class=\"col-md-4 form-group\"><h5>Tipo Asset</h5><six-lookup-2 sx-id=\"issue-schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-title=\"\'Tipo asset\'\" ng-model=\"currentDataInTimeline.model\" sx-field=\"\'type_id\'\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><h5>Asset</h5><six-lookup-2 sx-id=\"issue-asset\" sx-base-path=\"\'record\'\" sx-title=\"\'Asset\'\" ng-model=\"data.model\" sx-type=\"currentDataInTimeline.model.type_id.UUID\" sx-field=\"\'record_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><h5>Data inserimento</h5><div class=\"col-md-12 no-pad-l-r\"><input type=\"datetime-local\" class=\"form-control\" ng-model=\"currentDataInTimeline.date_insertion\"></div></div><div class=\"col-md-4 form-group\"><h5>Data richiesta</h5><div class=\"col-md-12 no-pad-l-r\"><input type=\"datetime-local\" class=\"form-control\" ng-model=\"currentDataInTimeline.date_requested\"></div></div><div class=\"col-md-4 form-group\"><h5>Data di presa in carico</h5><div class=\"col-md-12 no-pad-l-r\"><input type=\"datetime-local\" class=\"form-control\" ng-model=\"currentDataInTimeline.date_handling\"></div></div><div class=\"col-md-4 form-group\"><h5>Data chiusura</h5><div class=\"col-md-12 no-pad-l-r\"><input type=\"datetime-local\" class=\"form-control\" ng-model=\"currentDataInTimeline.date_closing\"></div></div></div><div class=\"col-md-12\"><div sf-schema=\"schemaDataInTimeline\" sf-form=\"formDataInTimeline\" sf-model=\"currentDataInTimeline.model\"></div></div></div></div></div></div></uib-tab><uib-tab index=\"2\" disable=\"!data.version\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments nodes=\"attachments\" save-callback=\"updAttachments()\"></six-tree-attachments></uib-tab><uib-tab index=\"3\" disable=\"!data.version\" select=\"getMessage()\"><uib-tab-heading><span class=\"fa fa-envelope text-info-dker\"></span> Messaggio</uib-tab-heading><div class=\"col-md-12\" ng-if=\"loadingSixMail == true\"><uib-progressbar class=\"progress-striped active\" type=\"info\"><i>Caricamento messaggio</i></uib-progressbar></div><six-send-email ng-if=\"loadingSixMail == false\" sx-title-mail=\"objMail.title\" sx-body-mail=\"objMail.message\" sx-to-mail=\"objMail.to\" sx-cc-mail=\"objMail.cc\" sx-type-mail=\"\'odl\'\" sx-record-id=\"currentOdlRef\"></six-send-email></uib-tab><uib-tab index=\"4\" disable=\"!data.version\"><uib-tab-heading><span class=\"fa fa-qrcode text-info-dker\"></span> QRCODE</uib-tab-heading><qrcode version=\"5\" error-correction-level=\"H\" size=\"274\" data=\"{{data.UUID}}\"></qrcode></uib-tab><uib-tab index=\"5\" disable=\"!data.version\" select=\"getNotificationsList()\"><uib-tab-heading><span class=\"icon-bell text-info-dker\"></span> Notifiche</uib-tab-heading><div ng-if=\"notifications.length==0\" class=\"alert alert-info\" role=\"alert\">Nessuna notifica</div><ul class=\"list-group list-group-lg no-radius m-b-none m-t-n-xxs\"><li ng-repeat=\"notification in notifications\" class=\"list-group-item clearfix b-l-3x ng-scope\" ng-class=\"notification.color\"><span class=\"avatar thumb pull-left m-r\"><img ng-hide=\"notification.user\" ng-src=\"/images/avatar_system.png\"> <img ng-show=\"notification.user\" ng-src=\"/images/avatar_emil.png\"></span><div class=\"pull-right text-sm text-muted\"><span class=\"hidden-xs ng-binding\">{{notification.dataIn | date:\"dd/MM/yyyy\"}}</span></div><div class=\"clear\"><div><a class=\"text-md ng-binding\" ng-href=\"{{notification.href}}\"><span ng-show=\"notification.model.subject\">Oggetto: {{notification.model.subject}}</span> <span ng-show=\"notification.user\">da {{notification.user}}</span> <span ng-show=\"notification.model.to\">a {{notification.model.to}}</span></a></div><div class=\"text-ellipsis m-t-xs ng-binding\">{{notification.model.bodyAsText}}</div></div></li></ul></uib-tab></uib-tabset></div></div></uib-tab><uib-tab index=\"1\" disable=\"!issue.version\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Segnalazione</uib-tab-heading><issue-details sx-issue=\"issue\"></issue-details></uib-tab></uib-tabset></div></div>");
$templateCache.put("plan/odl/odl_detail_issue.html","<div class=\"wrapper\"><div class=\"row m-b-xs\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data inserimento</label><p class=\"input-group\" style=\"width:100%\"><six-date-time-picker name=\"date_insertion\" ng-model=\"data.date_insertion\" date-options=\"dateOptions\" sx-disabled=\"true\"></six-date-time-picker></p></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data richiesta</label><p class=\"input-group\" style=\"width:100%\"><six-date-time-picker name=\"date_requested\" ng-model=\"data.date_requested\" date-options=\"dateOptions\"></six-date-time-picker></p></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data inizio lavori</label><p class=\"input-group\" style=\"width:100%\"><six-date-time-picker name=\"date_handling\" ng-model=\"data.date_handling\" date-options=\"dateOptions\"></six-date-time-picker></p></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data chiusura</label><p class=\"input-group\" style=\"width:100%\"><six-date-time-picker name=\"date_closing\" ng-model=\"data.date_closing\" date-options=\"dateOptions\"></six-date-time-picker></p></div></div></div></div><div class=\"row\"><div class=\"col-md-12 m-t\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"col-md-4 form-group format-h-odl\"><label class=\"control-label\">Segnalazione</label><six-lookup sx-id=\"issue\" sx-base-path=\"\'issue\'\" sx-type=\"\'record\'\" ng-model=\"data\" sx-field=\"\'issue_id\'\" sx-war=\"\'six-plan\'\" sx-filter=\"issueRefreshed.filter\"><button class=\"btn btn-default\" ng-click=\"goToIssue()\" ng-disabled=\"!data.issue_id\"><i class=\"fa fa-external-link\"></i></button></six-lookup><div class=\"col-md-12 no-pad-l-r\"><input type=\"checkbox\" ng-model=\"issueRefreshed.bool\">Filtra per segnalazioni non \"associate\"</div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Elemento tecnologico</label><six-lookup-2 sx-id=\"odl-schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"data.model\" sx-field=\"\'type_id\'\" sx-show-details=\"false\" sx-show-filters=\"false\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"asset\" sx-base-path=\"\'record\'\" sx-type=\"data.model.type_id.UUID\" ng-model=\"data.model\" sx-field=\"\'record_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div></div></div></div></div>");
$templateCache.put("plan/odl/odl_detail_plan.html","<div class=\"wrapper\"><div class=\"row\"><div class=\"col-md-6\"><h4>Parametri da Programmata</h4></div></div><div class=\"row\"><div class=\"col-md-3 m-t\"><label for=\"date_requested\" class=\"control-label\">Data pianifica</label><p class=\"input-group\" style=\"width:100%\"><six-date-time-picker id=\"date_requested\" name=\"date_requested\" ng-model=\"data.date_requested\" date-options=\"dateOptions\"></six-date-time-picker></p></div><div class=\"col-md-3 m-t\"><label for=\"dataIn\" class=\"control-label\">Data inserimento</label><p class=\"input-group\" style=\"width:100%\"><six-date-time-picker id=\"dataIn\" name=\"dataIn\" ng-model=\"data.dataIn\" date-options=\"dateOptions\" sx-disabled=\"true\"></six-date-time-picker></p></div><div class=\"col-md-3 m-t\"><label for=\"generationTag\" class=\"control-label\">Codice generazione</label><div class=\"input-group\" style=\"width:100%\"><input id=\"generationTag\" type=\"text\" value=\"{{data.model.generation_tag}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-3 m-t\"><label for=\"record_istatusd_type\" class=\"control-label\">Stato</label><div class=\"input-group\" style=\"width:100%\"><input id=\"record_istatusd_type\" type=\"text\" value=\"{{data.status}}\" class=\"form-control\" readonly=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-6 m-t\" ng-if=\"data.is_aggregated\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"col-md-8\"><label for=\"record_id\" class=\"control-label\">Asset</label><div class=\"input-group\" style=\"width:100%\"><input id=\"record_id\" type=\"text\" value=\"{{data.model.record_id.code}} - {{data.model.record_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-4\"><label for=\"record_id_type\" class=\"control-label\">Elemento tecnologico</label><div class=\"input-group\" style=\"width:100%\"><input id=\"record_id_type\" type=\"text\" value=\"{{data.model.type_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-8 m-t\"><label for=\"user\" class=\"control-label\">Generato per l\'elemento tecnologico</label><div class=\"input-group\" style=\"width:100%\"><input id=\"user\" type=\"text\" value=\"{{data.model.target_type_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-4 m-t\"><label class=\"control-label\"></label><div class=\"input-group\" style=\"width:100%\"><button class=\"btn btn-default m-t-xs\" style=\"width:100%\" ng-click=\"showAssetsList()\" data-toggle=\"collapse\" data-target=\"#assetsList\"><span class=\"fa fa-search\"></span> Asset ({{data.model.targets.length}})</button></div></div><div class=\"col-md-12 m-t collapse\" id=\"assetsList\"><h4 class=\"override-h4-no-margin\">Dettaglio asset</h4><hr class=\"m-t-sm\"><div class=\"m-t-n-sm\"><div ng-repeat=\"asset in data.model.targets\">{{asset.code}} - {{asset.description}}</div></div></div></div></div><div class=\"col-md-6 m-t\" ng-if=\"!data.is_aggregated\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"col-md-8\"><label for=\"record_id\" class=\"control-label\">Asset</label><div class=\"input-group\" style=\"width:100%\"><input name=\"record_id\" type=\"text\" value=\"{{data.model.record_id.code}} - {{data.model.record_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-4\"><label for=\"record_id_type\" class=\"control-label\">Tipo di Asset</label><div class=\"input-group\" style=\"width:100%\"><input name=\"record_id_type\" type=\"text\" value=\"{{data.model.record_type_id.description}}\" class=\"form-control\" readonly=\"\"></div></div></div></div><div class=\"col-md-6 m-t\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"col-md-8\"><label for=\"record_id\" class=\"control-label\">Compito</label><div class=\"input-group\" style=\"width:100%\"><input name=\"record_id\" type=\"text\" value=\"{{data.task_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-4\"><label class=\"control-label\"></label><div class=\"input-group\" style=\"width:100%\"><button class=\"btn btn-default m-t-xs\" style=\"width:100%\" data-toggle=\"collapse\" data-target=\"#activitiesList\"><span class=\"fa fa-search\"></span> Attività ({{data.task_activities.length}})</button></div></div><div class=\"col-md-12 m-t collapse\" id=\"activitiesList\"><h4 class=\"override-h4-no-margin\">Dettaglio attività</h4><hr class=\"m-t-sm\"><div class=\"m-t-n-sm\"><div ng-repeat=\"activity in data.task_activities\">{{activity.model.title}}</div></div></div></div></div></div></div>");
$templateCache.put("plan/odl/odl_list.html","<six-toolbar><six-toolbar-button label=\"Genera Odl\" icon=\"fa fa-plus\" toolbar-function=\"newOdl()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Chiudi Odl\" icon=\"fa fa-trash\" toolbar-function=\"massiveClosingOdl()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Tutti\" icon=\"fa fa-square-o\" icon-disabled=\"fa fa-check-square-o\" icon-condition=\"bool.allOdl\" toolbar-function=\"toggleAllOdl()\"></six-toolbar-button><six-toolbar-button label=\"Nascondi pianific.\" icon=\"fa fa-square-o\" icon-disabled=\"fa fa-check-square-o\" icon-condition=\"bool.hidePlan\" toolbar-function=\"toggleHidePlan()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista ODL</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination sx-id=\"odl\" get-data-callback=\"getCurrentUserOdlList()\" get-list-callback=\"getCurrentUserOdlList()\" items-list=\"odlList\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" auto-resize-params=\"autoResizeParams\" show-global-search=\"false\" grid-app-callbacks=\"gridAppCallbacks\"></six-grid-pagination></div></div></div>");
$templateCache.put("plan/odl/odlconfigurator_detail.html","<six-toolbar><six-toolbar-button label=\"Lista\" icon=\"fa fa-chevron-left\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Duplica\" btn-class=\"btn-primary\" icon=\"fa fa-files-o\" toolbar-function=\"setConfModel()\" ng-if=\"selected.version\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-trash-o\" toolbar-function=\"delete()\" sx-disabled=\"!isDeletePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Dettaglio Configurazione</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-heading\" style=\"background-color: transparent\"><div class=\"page-header-bleed-right\"><div class=\"actions\"><div class=\"row\"><form name=\"header\"><div class=\"form-group\"><div class=\"col-md-12\"><label class=\"control-label\">Codice:</label> <input type=\"text\" class=\"form-control\" ng-model=\"commissionCode\" ng-disabled=\"bool.isCross || bool.isCallCenter\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"!bool.isCross && !bool.isCallCenter\"><label class=\"col-md-1 control-label\">Commesse:</label><div class=\"col-md-12\"><div id=\"vectors_budget_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"commissionsSelected.codes\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una commessa...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in commissions\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div></div><div class=\"col-md-12\"><input type=\"checkbox\" ng-model=\"bool.isCross\" name=\"cross_commission\" ng-click=\"updateCode()\"> <label class=\"control-label\">Imposta come configurazione di default per gli utenti (cross-commessa)</label></div></div></form></div></div></div></div><div class=\"panel-body\"><uib-tabset justified=\"true\"><uib-tab heading=\"Preview\"><form name=\"myForm\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"model\" ng-submit=\"onSubmit(myForm)\"></form></uib-tab><uib-tab heading=\"Schema\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><div class=\"col-md-12 centered\"><b>SCHEMA</b></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><b>CODICE</b></div><div class=\"col-md-3\"><b>DESCRIZIONE</b></div><div class=\"col-md-1\"><b>TIPOLOGIA</b></div><div class=\"col-md-2\"><b>FORMATO</b></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><form name=\"propertyKeyForm\"><input class=\"form-control\" name=\"property_key\" placeholder=\"Codice...\" type=\"text\" ng-model=\"property.key\" pattern=\"^[a-zA-Z]+[\\w]*$\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"propertyKeyForm.property_key.$error.pattern\">Caratteri non consentiti</span></div></form></div></div><div class=\"col-md-3\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><input class=\"form-control\" placeholder=\"Descrizione\" type=\"text\" ng-model=\"property.title\"></div></div><div class=\"col-md-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.type\"><option></option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"boolean\">boolean</option><option value=\"date\">date</option><option value=\"array\">array</option></select></div></div><div class=\"col-md-2\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'string\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'number\' || property.type == \'integer\')\"><option></option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.items_type\" ng-if=\"(property.type == \'array\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"date\">date</option></select></div></div><div class=\"col-md-2\"><div ng-if=\"isInheritable(property.type)\"><label><input type=\"checkbox\" ng-model=\"property.inherited\"> Campo ereditato</label></div></div><div class=\"col-md-1\"><button ng-click=\"addProperty()\" class=\"btn btn-sm btn-info pull-right\"><span class=\"fa fa-plus\"></span> Add</button></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-repeat=\"(key, value) in selected.model.schema.properties\" style=\"align-content: center; padding-bottom: 0px;\"><div class=\"col-md-12 uniform-height\" style=\"align-content: center;\"><div class=\"col-md-1\"><a href=\"\" ng-click=\"status[key].open = !status[key].open\" id=\"btn_row_detail\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status[key].open, \'glyphicon-chevron-right\': !status[key].open}\"></i></a></div><div class=\"col-md-2\">{{ key }}</div><div class=\"col-md-3\">{{ value.title }}</div><div class=\"col-md-1\">{{ value.type }}</div><div class=\"col-md-2\"><span ng-if=\"value.format\">{{value.format}}</span> <span ng-if=\"value.type == \'array\' && value.items\">{{value.items.format}}</span></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"status[key].open\"><div class=\"col-md-12 uniform-height-2\" ng-if=\"value.format !== \'lookup\' && value.format !== \'formula\' && value.format !== \'enum\' && value.format !== \'inherit\' && value.type !== \'array\'\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-10\">{{value.format}}</div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'inherit\'\" ng-include=\"\'dataset/modeltype/detail_inherit.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'lookup\' && value.type != \'array\'\" ng-include=\"\'dataset/modeltype/detail_lookup.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'formula\'\" ng-include=\"\'dataset/modeltype/detail_formula.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'enum\'\" ng-include=\"\'dataset/modeltype/detail_enum.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.type === \'array\'\" ng-include=\"\'dataset/modeltype/detail_array.html\'\"></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ELIMINA:</div><div class=\"col-md-10\"><button ng-click=\"deleteProperty(key)\" class=\"btn btn-danger btn-xs btn-default\" ng-disabled=\"(key === \'code\' || key === \'description\')\"><i class=\"fa fa-trash\"></i></button></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">IN TABELLA:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.check\" ng-change=\"changeColumnDefs(key, value)\" ng-disabled=\"(key === \'code\' || key === \'description\')\"></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"value.check == true\"><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">LARGHEZZA (px):</div><div class=\"col-md-10\"><input type=\"text\" min=\"1\" step=\"1\" size=\"45\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"value.width\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ORDINAMENTO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableSorting\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FILTRAGGIO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableFiltering\" ng-change=\"changeColumnDefs(key, value)\"></div></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div></div></div></div></uib-tab><uib-tab heading=\"Form\"><table class=\"table table-striped\"><thead><th colspan=\"5\">FORM</th><tr><th colspan=\"5\"><div class=\"form-group\"><label for=\"title\" class=\"control-label\">Titolo</label><div class=\"\"><input type=\"text\" class=\"form-control\" id=\"title\" placeholder=\"\" ng-model=\"title\" name=\"title\" ng-keyup=\"refreshTitleForm(title)\"></div></div></th></tr><tr><td></td><td></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newTab.title\"></td><td><button ng-click=\"addTab(selected.model.form[0].items[0])\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th></th><th>POSIZIONE</th><th>TITOLO</th><th></th></tr></thead><tbody><tr ng-repeat-start=\"(key, tab) in selected.model.form[0].items[0].tabs\"><td><a href=\"\" ng-click=\"statusForm[key].open = !statusForm[key].open\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': statusForm[key].open, \'glyphicon-chevron-right\': !statusForm[key].open}\"></i></a></td><td><span class=\"btn btn-sm\" ng-click=\"swapUp(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key<=0\"><i class=\"fa fa-caret-up\"></i></span> {{key+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key>=selected.model.form[0].items[0].tabs.length-1\"><i class=\"fa fa-caret-down\"></i></span></td><td><input type=\"text\" ng-model=\"tab.title\" ng-disabled=\"(tab.key[0] == \'code\' || tab.key[0] == \'description\')\" ng-keyup=\"updateScope()\"></td><td><a ng-click=\"removeTabOrField(key, selected.model.form[0].items[0].tabs)\" class=\"btn btn-danger btn-xs btn-default\" id=\"btn_row_detail_form\"><i class=\"fa fa-trash\"></i></a></td></tr><tr ng-repeat-end=\"\" ng-show=\"statusForm[key].open\"><td></td><td colspan=\"3\" style=\"background-color:rgba(211, 211, 211, 0.38);\"><table class=\"table table-striped override-margin\"><tr><td></td><td><select ng-options=\"k as v.title for (k, v) in schema.properties\" ng-model=\"newFieldForm.key\"></select></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newFieldForm.title\"></td><td><input type=\"checkbox\" placeholder=\"Richiesto...\" ng-model=\"newFieldForm.required\"></td><td><select ng-model=\"newFieldForm.type\" ng-change=\"updateScope()\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><button ng-click=\"addFieldToTab(tab)\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th>POSIZIONE</th><th>CAMPO</th><th>TITOLO</th><th>REQUIRED</th><th>TIPO</th><th></th></tr><tr ng-repeat=\"(fieldKey, field) in tab.items\"><td class=\"override-width-200px\"><div><span class=\"btn btn-sm\" ng-click=\"swapUp(fieldKey, tab.items)\" ng-disabled=\"fieldKey<=0\"><i class=\"fa fa-caret-up\"></i></span> {{fieldKey+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(fieldKey, tab.items)\" ng-disabled=\"fieldKey>=tab.items.length-1\"><i class=\"fa fa-caret-down\"></i></span></div></td><td ng-if=\"!field.title\">{{field}}</td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"field.title\">{{field.key[0]}}</td><td ng-if=\"field.title\"><input type=\"text\" ng-model=\"field.title\" ng-keyup=\"updateScope()\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.required\" ng-change=\"updateScope()\"></td><td ng-if=\"field.title\"><select ng-model=\"field.type\" ng-change=\"updateField(field)\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><a ng-click=\"removeTabOrField(fieldKey, tab.items)\" class=\"btn btn-danger btn-xs btn-default\"><i class=\"fa fa-trash\"></i></a></td></tr></table></td></tr></tbody></table></uib-tab></uib-tabset></div><div class=\"panel-footer\"><div class=\"form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" class=\"pull-left\" data-toggle=\"collapse\" data-target=\"#json-collapse\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div></div><div class=\"row collapse\" id=\"json-collapse\" collapse=\"!jsonshow\"><div class=\"col-md-8\"><div class=\"panel no-border\"><div class=\"panel-heading wrapper b-b b-light\"><h4 class=\"font-thin m-t-none m-b-none text-muted\">Dettaglio</h4></div><div style=\"margin-top:0px;\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'json\', firstLineNumber: 1, onLoad: aceLoaded, onChange: aceChanged }\" ng-model=\"aceModel\"></div></div></div><div class=\"col-md-4\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{ model}}</pre></div></div></div></div></div></div>");
$templateCache.put("plan/odl/odlconfigurator_list.html","<six-toolbar><six-toolbar-button label=\"Crea modello ODL\" icon=\"fa fa-plus\" toolbar-function=\"newOdl()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Configurazioni ODL</h1></div></div></div><div class=\"panel-body\"><div class=\"form-group\"><input ng-keyup=\"getData(queryParam)\" class=\"form-control\" type=\"text\" ng-model=\"queryParam\" placeholder=\"Type here to filter the list...\"></div><table id=\"odl_configurator_list\" class=\"table table-striped\"><thead><tr><th></th><th>CODICE CONFIGURAZIONE</th><th>COMMESSA</th><th>DATA</th></tr></thead><tbody><tr ng-repeat=\"item in odlConfiguratorList.list\"><td><a ng-href=\"#/odlconfigurator/{{item.UUID}}\" class=\"btn btn-default\" id=\"btn_issue_detail\"><span class=\"fa fa-search\"></span></a></td><td>{{ item.model.code }}</td><td>{{printCommission(item.model.commission)}}</td><td>{{ item.dataIn | date:\'dd/MM/yyyy\' }}</td></tr><tr ng-hide=\"odlConfiguratorList.list.length\"><td><p class=\"text-center\">Nessun record recuperato</p></td></tr></tbody></table></div><div class=\"panel-footer\"><div class=\"row text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"odlConfiguratorList.totalResults\" ng-model=\"odlConfiguratorList.currentPage\" class=\"pagination-sm\" items-per-page=\"odlConfiguratorList.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div></div></div>");
$templateCache.put("plan/plan/plan_detail.html","<style type=\"text/css\">\n.center-open{\n    padding-left: 295px;\n}\n\n  .selected {\n    background-color: #11c7f5 !important;\n  }\n\n  #frequency-popup{\n      width: 100%;\n      margin-top: 6px;\n  }\n\n  #frequency-popup .title{\n      line-height: 36px;\n      font-size: 16px;\n      text-align: center;\n  }\n\n  .uib-clear{\n    display: none;\n  }\n\n  .transparent{\n      opacity: 0;\n  }\n\n  .list-sidebar-overlay.active {\n      visibility: hidden;\n  }\n</style><six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"stepBack()\"></six-toolbar-button><six-toolbar-button label=\"Salva programmata\" btn-class=\"btn-success\" icon=\"fa fa-save\" ng-hide=\"step!=STEP.DESCRIPTION\" toolbar-function=\"saveForm()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Elimina programmata\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" toolbar-function=\"delete(plan.version)\" ng-hide=\"(!plan.version || (step!=STEP.DESCRIPTION))\" sx-disabled=\"!isDeletePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Simula\" btn-class=\"btn-primary-override\" icon=\"icon-magic-wand\" ng-hide=\"(!plan.version || step!=STEP.DESCRIPTION)\" toolbar-function=\"goToSimulation()\"></six-toolbar-button><six-toolbar-button label=\"Salva e genera\" btn-class=\"btn-info\" icon=\"icon-rocket\" ng-hide=\"(!plan.version || step!=STEP.SIMULATION)\" toolbar-function=\"goToGeneration()\" sx-disabled=\"!simulationOk || !isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Riepilogo\" btn-class=\"btn-warning\" icon=\"icon-share-alt\" ng-hide=\"(!plan.version || step!=STEP.GENERATION)\" toolbar-function=\"goToPlanOdlList()\"></six-toolbar-button></six-toolbar><div class=\"list-sidebar-overlay\"></div><aside id=\"list-sidebar\" class=\"list-sidebar list-sidebar-default list-sidebar-stacked custom-six-sidebar\" role=\"navigation\"><div class=\"panel sidebar-panel\"><button class=\"btn btn-info pull-left\" ng-click=\"closeSidebar()\"><span class=\"fa fa-times icon-only\"></span></button> <button class=\"btn btn-info pull-right\" ng-click=\"confirmSelectAssets()\"><span class=\"fa fa-check icon-only\"></span></button><div class=\"panel-heading bg-info sidebar-heading\">Seleziona Asset</div></div><ul class=\"nav list-sidebar-nav\"><li><div class=\"form-group m-l-xs m-r-xs m-t-xs\"><six-search-form ng-model=\"assetFilter\" placeholder=\"Filtra...\" hide-search-btn=\"\"></six-search-form><span class=\"input-group-btn\"><button class=\"btn btn-default btn-sm\" title=\"Seleziona tutti\" style=\"width:50%\" ng-click=\"selectAllAddCheck()\"><i class=\"fa fa-square\"></i> Seleziona tutti</button> <button class=\"btn btn-default btn-sm\" title=\"Deseleziona tutti\" style=\"width:50%\" ng-click=\"unselectAllAddCheck()\"><i class=\"fa fa-square-o\"></i> Deseleziona tutti</button></span></div></li><li ng-show=\"availableAssets.length==0\" style=\"text-align:center\"><span style=\"width:100%;\">Nessun <strong>{{plan.model.model_type.description}}</strong> trovato</span></li><li ng-repeat=\"asset in availableAssets | filter:assetFilter as filteredAssets\" class=\"m-l-xs m-r-xs\"><label class=\"checkbox i-checks m-b-sx\" ng-hide=\"isDisabledAsset(asset.UUID)\"><input type=\"checkbox\" ng-model=\"addCheckModel[$index]\" ng-disabled=\"isDisabledActivity(isDisabledAsset.UUID)\"><i></i>{{asset.model.code}} - {{asset.model.description}}</label></li></ul></aside><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Attività Programmata</h1><small>Compito: {{plan.model.task_id.code}} - {{plan.model.task_id.description | cut:true:100:\'...\'}}</small></div></div></div><div class=\"wrapper\"><div class=\"panel-body\"><six-search-terms sx-filter=\"searchFilterObj\" sx-filter-description=\"plan.model.search_filter.description\" sx-filter-description-long=\"plan.model.search_filter.description_long\" sx-filter-description-short=\"plan.model.search_filter.description_short\" sx-filter-init=\"searchFilterArray\" sx-id=\"{{sxSearchTerms.id}}\" sx-open=\"sxSearchTerms.open\" sx-filter-only=\"true\" sx-model=\"sxSearchTerms\" sx-on-filter-changed=\"onFilterChanged()\"></six-search-terms><uib-tabset active=\"step\"><uib-tab disable=\"(step!=STEP.DESCRIPTION)\" index=\"STEP.DESCRIPTION\"><uib-tab-heading><i class=\"icon-note text-success-dker\"></i> Descrizione</uib-tab-heading><div class=\"row\"><div class=\"col-md-3 col-sm-12 m-t-xs\"><label for=\"code\" class=\"control-label\">Codice</label><div class=\"input-group\" style=\"width:100%\"><input id=\"code\" name=\"code\" type=\"text\" ng-model=\"plan.model.code\" class=\"form-control\" ng-readonly=\"plan.version\" required=\"\"></div></div><div class=\"col-md-9 col-sm-12 m-t-xs\"><label for=\"description\" class=\"control-label\">Descrizione</label><div class=\"input-group\" style=\"width:100%\"><input id=\"description\" name=\"description\" type=\"text\" ng-model=\"plan.model.description\" required=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-md-3 col-sm-12 m-t\"><label for=\"service\" class=\"control-label\">Servizio</label><div class=\"input-group\" style=\"width:100%\"><six-lookup id=\"service\" ng-model=\"plan.model\" sx-type=\"\'servizio\'\" sx-field=\"\'service_id\'\"></six-lookup></div></div><div class=\"col-md-3 col-sm-12 m-t\"><label for=\"priority\" class=\"control-label\">Priorità</label><div class=\"input-group\" style=\"width:100%\"><six-lookup id=\"priority\" ng-model=\"plan.model\" sx-type=\"\'priorita\'\" sx-field=\"\'priority_id\'\"></six-lookup></div></div></div><div class=\"row m-t\"><div class=\"col-md-6 m-t\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"form-group\"><label for=\"task\" class=\"control-label\">Compito</label><div class=\"input-group\" style=\"width:100%\"><six-lookup-2 id=\"task\" name=\"task\" sx-id=\"task\" sx-war=\"\'six-plan\'\" ng-model=\"plan.model\" sx-base-path=\"task\" sx-type=\"\'task\'\" sx-field=\"\'task_id\'\" sx-object=\"taskObj.obj\" sx-placeholder=\"\'Compito...\'\" required=\"\" aria-required=\"true\" sx-disabled=\"plan.version\"></six-lookup-2></div></div><div class=\"form-group\"><span class=\"pull-right\" ng-if=\"false\"><button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first\" ng-show=\"!isSidebarOpened\" ng-disabled=\"taskActivities.length==0\"><span class=\"fa fa-times\"></span>Rimuovi</button> <button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first\" ng-click=\"closeSidebar()\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-times\"></span>Annulla</button></span> <span class=\"pull-right\" ng-if=\"false\"><button class=\"btn btn-sm btn-default add-remove-button\" ng-click=\"loadPriorities()\" ng-show=\"!isSidebarOpened\"><span class=\"fa fa-plus\"></span>Aggiungi</button> <button class=\"btn btn-sm btn-default add-remove-button\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-check\"></span>Conferma</button></span><h4 class=\"override-h4-no-margin\">Attività</h4><hr class=\"m-t\"></div><div><label class=\"checkbox i-checks m-b\" ng-repeat=\"activity in plan.model.task_activities\">{{activity.description}}</label> <label class=\"checkbox i-checks m-b\" ng-repeat=\"activity in plan.model.custom_activities\"><input type=\"checkbox\"><i></i> <span class=\"i-checks\">{{activity.description}}</span></label></div><div class=\"form-group\" ng-if=\"hasAttachments\"><h4 class=\"override-h4-no-margin\">Allegati</h4><hr class=\"m-t\"><div class=\"m-l-n-sm m-t-n-lg\"><six-tree-attachments nodes=\"attachments\" sx-readonly=\"true\"></six-tree-attachments></div></div></div></div><div class=\"col-md-6 m-t\"><div class=\"list-group-item clearfix b-l-3x b-l-warning\"><div class=\"input-group\" style=\"width:100%\"><label for=\"frequencySelect\" class=\"control-label\">Frequenza</label><select name=\"frequencySelect\" id=\"frequencySelect\" class=\"form-control\" ng-model=\"plan.model.frequency.type\" ng-click=\"closeFrequencyDetail()\"><option label=\"Settimanale\" value=\"{{EVERY.WEEK}}\">Settimanale</option><option label=\"Mensile\" value=\"{{EVERY.MONTH}}\">Mensile</option><option label=\"Bimestrale\" value=\"{{EVERY.MONTHx2}}\">Bimestrale</option><option label=\"Trimestrale\" value=\"{{EVERY.MONTHx3}}\">Trimestrale</option><option label=\"Quadrimestrale\" value=\"{{EVERY.MONTHx4}}\">Quadrimestrale</option><option label=\"Semestrale\" value=\"{{EVERY.MONTHx6}}\">Semestrale</option><option label=\"Annuale\" value=\"{{EVERY.YEAR}}\">Annuale</option><option label=\"Biennale\" value=\"{{EVERY.YEARx2}}\">Biennale</option><option label=\"Triennale\" value=\"{{EVERY.YEARx3}}\">Triennale</option><option label=\"Quadriennale\" value=\"{{EVERY.YEARx4}}\">Quadriennale</option><option label=\"Quinquennale\" value=\"{{EVERY.YEARx5}}\">Quinquennale</option><option label=\"6 anni\" value=\"{{EVERY.YEARx6}}\">6 anni</option></select></div><div><div class=\"m-t\" id=\"weekly-detail\" ng-show=\"isWeekly()\"><div class=\"btn-group\" role=\"group\" aria-label=\"Giorno\"><button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.dayOfWeek\" uib-btn-radio=\"\'{{DAY_OF_WEEK.MON}}\'\">Lun</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.dayOfWeek\" uib-btn-radio=\"\'{{DAY_OF_WEEK.TUE}}\'\">Mar</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.dayOfWeek\" uib-btn-radio=\"\'{{DAY_OF_WEEK.WEN}}\'\">Mer</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.dayOfWeek\" uib-btn-radio=\"\'{{DAY_OF_WEEK.THU}}\'\">Gio</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.dayOfWeek\" uib-btn-radio=\"\'{{DAY_OF_WEEK.FRI}}\'\">Ven</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.dayOfWeek\" uib-btn-radio=\"\'{{DAY_OF_WEEK.SAT}}\'\">Sab</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.dayOfWeek\" uib-btn-radio=\"\'{{DAY_OF_WEEK.SUN}}\'\">Dom</button></div></div><div class=\"m-t\" id=\"monthly-detail\" ng-show=\"isMonthly() || isAnnual()\"><div class=\"btn-group\" role=\"group\" aria-label=\"Mese\"><button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.dayOfMonth\" uib-btn-radio=\"\'{{DAY_OF_MONTH.FIRST}}\'\">1° del mese</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.dayOfMonth\" uib-btn-radio=\"\'{{DAY_OF_MONTH.MIDDLE}}\'\">15 del mese</button></div></div><div class=\"m-t\" id=\"annual-detail\" ng-show=\"isAnnual()\"><div class=\"btn-group btn-group-sm\" role=\"group\" aria-label=\"Giorno\"><button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.JAN}}\'\">Gen</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.FEB}}\'\">Feb</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.MAR}}\'\">Mar</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.APR}}\'\">Apr</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.MAY}}\'\">Mag</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.JUNE}}\'\">Giu</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.JULY}}\'\">Lug</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.AUG}}\'\">Ago</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.SEPT}}\'\">Set</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.OCT}}\'\">Ott</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.NOV}}\'\">Nov</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.DEC}}\'\">Dic</button></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12 m-t\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"row\"><div class=\"col-md-4 col-sm-12 m-t-xs\"><label for=\"asset\" class=\"control-label\">Elemento tecnologico</label><div class=\"input-group\" style=\"width:100%\"><six-lookup ng-model=\"plan.model\" sx-base-path=\"\'tree/_flat\'\" sx-field=\"\'model_type\'\" sx-placeholder=\"\'Tipo...\'\" required=\"\" aria-required=\"true\"></six-lookup></div></div><div class=\"col-md-2 col-sm-12 m-t-xs\"><label for=\"asset\" class=\"control-label\" ng-class=\"{\'text-muted\': disablePlanOptions}\">Filtri applicati</label><div class=\"input-group\" style=\"width:100%\"><button class=\"btn btn-default\" ng-disabled=\"disablePlanOptions\" ng-click=\"toggleSearchTerms()\"><span class=\"fa fa-pencil-square-o\"></span> <span ng-if=\"isEmptyFilter()\">Aggiungi filtri</span> <span ng-if=\"!isEmptyFilter()\">Modifica filtri</span></button></div></div><div class=\"col-md-6 col-sm-12 m-t-xs\" ng-if=\"!isEmptyFilter()\"><div class=\"list-group-item clearfix\"><table class=\"filter_desc\"><tr ng-repeat=\"row in plan.model.search_filter.description_long\" class=\"filter_desc_row\"><td class=\"attr\">{{row.attribute}}</td><td class=\"rel\" ng-bind-html=\"row.relation\"></td><td class=\"val\">{{row.value}}</td></tr></table></div></div></div><div class=\"row\"><div class=\"col-md-4 col-sm-12 m-t\"><label class=\"checkbox i-checks m-b\" style=\"width:100%\"><input id=\"check-1\" type=\"checkbox\" ng-model=\"planOptions.generateOverParent\" ng-disabled=\"disablePlanOptions\"><i></i> <span class=\"i-checks\" ng-class=\"{\'text-muted\': disablePlanOptions}\">Genera su genitore</span></label></div><div class=\"col-md-8 col-sm-12 col-sm-12 m-t\" ng-show=\"planOptions.generateOverParent\"><label for=\"target-asset\" class=\"control-label\">Elemento tecnologico su cui generare gli ODL</label><div class=\"input-group\" style=\"width:100%\"><six-lookup ng-model=\"plan.model\" sx-base-path=\"\'tree/_parents\'\" sx-field=\"\'target_model_type\'\" sx-placeholder=\"\'Tipo...\'\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col-md-4 col-sm-12 m-t\"><label class=\"checkbox i-checks m-b\" style=\"width:100%\"><input id=\"check-2\" type=\"checkbox\" ng-model=\"planOptions.specifyAssets\" ng-click=\"clearSiderbar()\" ng-disabled=\"disablePlanOptions\"><i></i> <span class=\"i-checks\" ng-class=\"{\'text-muted\': disablePlanOptions}\">ODL su specifici asset</span></label></div><div class=\"col-md-8 col-sm-12 m-t\" ng-show=\"planOptions.specifyAssets\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div><span class=\"pull-right\"><button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first\" ng-click=\"removeAsset()\" ng-show=\"!isSidebarOpened\" ng-disabled=\"taskActivities.length==0\"><span class=\"fa fa-times\"></span>Rimuovi</button> <button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first\" ng-click=\"closeSidebar()\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-times\"></span>Annulla</button> <button class=\"btn btn-sm btn-default\" ng-click=\"selectAllRemCheck()\" ng-show=\"!isSidebarOpened\" title=\"Seleziona tutti\"><span class=\"fa fa-square m-r-none\"></span></button> <button class=\"btn btn-sm btn-default\" ng-click=\"unselectAllRemCheck()\" ng-show=\"!isSidebarOpened\" title=\"Deseleziona tutti\"><span class=\"fa fa-square-o m-r-none\"></span></button></span> <span class=\"pull-right\"><button class=\"btn btn-sm btn-default add-remove-button\" ng-click=\"selectAsset()\" ng-show=\"!isSidebarOpened\"><span class=\"fa fa-plus\"></span>Aggiungi</button> <button class=\"btn btn-sm btn-default add-remove-button\" ng-click=\"confirmSelectAssets()\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-check\"></span>Conferma</button></span><h4 class=\"override-h4-no-margin\">Dettaglio Asset</h4><hr class=\"m-t\"></div><div><div ng-if=\"planAssets.length==0\" class=\"alert alert-info\">Per tutti gli asset del tipo selezionato</div><label class=\"checkbox i-checks m-b\" ng-repeat=\"assets in planAssets\"><input type=\"checkbox\" ng-model=\"remCheckModel[$index]\"><i></i>{{assets.model.code}} - {{assets.model.description}}</label></div></div></div></div></div></div></div></div></uib-tab><uib-tab disable=\"(step!=STEP.SIMULATION)\" ng-click=\"checkFreqTypeChanged()\" index=\"STEP.SIMULATION\"><uib-tab-heading><i class=\"icon-magic-wand text-primary-dker\"></i> Simulazione</uib-tab-heading><div class=\"row\"><div class=\"col-md-3 col-sm-12 m-t-xs\"><label for=\"generationTag\" class=\"control-label\">Codice generazione</label><div class=\"input-group\" style=\"width:100%\"><input name=\"generationTag\" type=\"text\" ng-model=\"generationTag\" class=\"form-control\" required=\"\"></div></div><div class=\"col-md-3 col-sm-6 m-t-xs\"><label for=\"fromDate\" class=\"control-label\">Simula dal:</label><p class=\"input-group\" style=\"width:100%\"><input type=\"text\" name=\"fromDate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"simulationParams.date_from\" is-open=\"popupFrom.opened\" datepicker-options=\"dateOptions\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openFromPicker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-3 col-sm-6 m-t-xs\"><label for=\"toDate\" class=\"control-label\">al:</label><p class=\"input-group\" style=\"width:100%\"><input type=\"text\" name=\"toDate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"simulationParams.date_to\" is-open=\"popupTo.opened\" datepicker-options=\"dateOptions\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openToPicker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-3 col-sm-12 m-t-xs\"><label class=\"control-label\"></label><div class=\"input-group\" style=\"width:100%;margin-top:5px;\"><button class=\"btn btn-default\" ng-click=\"simulate()\"><span class=\"fa fa-gear\"></span> Avvia simulazione</button></div></div></div><div class=\"row wrapper\" ng-class=\"{\'transparent\': !simulationEvents}\"><h4 class=\"override-h4-no-margin pull-left\">Ripetizioni</h4><span class=\"text-muted pull-right\">( {{ganttOptions.fromDate | date}} / {{ganttOptions.toDate | date}} &nbsp;&nbsp;|&nbsp;&nbsp; {{ganttOptions.freqLabel}} )</span><hr><h5 ng-if=\"showSimulationWarning()\" class=\"text-warning\">Simulazione non aggiornata</h5><div id=\"gantt\" gantt=\"\" data=\"ganttData\" to-date=\"ganttOptions.toDate\" from-date=\"ganttOptions.fromDate\" daily=\"true\" view-scale=\"ganttOptions.viewScale\"><gantt-tooltips enabled=\"true\" date-format=\"\'DD/MM/YYYY\'\" content=\"tooltipContent\"></gantt-tooltips></div><div class=\"legend m-t\"><span class=\"text-xs text-muted pull-right\"><i class=\"fa fa-circle text-info m-r-xs m-l-sm\"></i> Nuovi ODL <i class=\"fa fa-circle text-warning m-r-xs\"></i> ODL già generati</span> <span style=\"clear:both\"></span></div></div><div class=\"row wrapper\" ng-if=\"simulationTargets\"><small class=\"pull-right text-muted\">Cod. simulazione: <span class=\"text-italic\">{{simulationTargets.simulation_id}}</span></small><h4 class=\"override-h4-no-margin pull-left\">Asset interessati</h4><hr><div ng-if=\"simulationTargets.count==0\"><div class=\"alert alert-info\">Nessun asset corrisponde ai criteri di ricerca.</div></div><div ng-if=\"simulationTargets.count>0\"><table class=\"table table-striped\" ng-if=\"simulationTargets.count_grouped==0\"><thead><th></th><th>{{plan.model.model_type.description}}</th></thead><tbody><tr ng-repeat=\"item in simulationTargets.list\"><td>{{$index+1}}</td><td>{{item.code}} - {{item.description}}</td></tr></tbody></table><table class=\"table table-striped\" ng-if=\"simulationTargets.count_grouped>0\"><thead><th></th><th ng-if=\"simulationTargets.count_grouped>0\">{{plan.model.target_model_type.description}}</th><th>Numero asset \"{{plan.model.model_type.description}}\" contenuti</th></thead><tbody><tr ng-repeat=\"item in simulationTargets.list\"><td>{{$index+1}}</td><td ng-if=\"simulationTargets.count_grouped>0\">{{item.code}} - {{item.description}}</td><td>{{item.children_count}}</td></tr></tbody></table></div></div></uib-tab><uib-tab disable=\"(step!=STEP.GENERATION)\" index=\"STEP.GENERATION\"><uib-tab-heading><i class=\"icon-rocket text-info-dker\"></i> Generazione ODL</uib-tab-heading><div class=\"row wrapper\" ng-hide=\"generationDone\"><div class=\"alert alert-info\"><i class=\"fa fa-refresh fa-spin\" style=\"font-size:large\"></i>Generazione ODL in corso. Attendere...</div></div><div class=\"row wrapper\" ng-if=\"generationDone\"><div ng-if=\"realOdlCount==0\"><div class=\"alert alert-danger\">Non è stato generato alcun ODL</div></div><div ng-if=\"realOdlCount>0\"><table class=\"table table-striped\"><thead><th></th><th>Asset</th><th>Titolo</th><th>Stato</th><th>Utente generazione</th><th>Data generazione</th><th>Data pianifica</th></thead><tbody><tr ng-repeat=\"item in generatedOdl\"><td><a ng-href=\"#/odl/{{item.UUID}}\" class=\"btn btn-xs btn-primary\"><span class=\"fa fa-search\"></span></a></td><td>{{item.model.type_id.description}} - {{item.model.record_id.description}} ({{item.model.record_id.code}})</td><td>{{item.model.title}}</td><td>{{item.status}}</td><td>{{item.user}}</td><td>{{item.dataIn |date }}</td><td>{{item.date_requested | date}}</td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col col-md-4\"><small class=\"text-muted pull-right\">Asset coinvolti: {{affectedAssets}}</small></div><div class=\"col col-md-4\"><small class=\"text-muted pull-right\">Ripetizioni per ogni ODL: {{affectedEvents}}</small></div><div class=\"col col-md-4\"><small class=\"text-muted pull-right\">ODL totali: {{generatedOdl.length}}</small></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("plan/plan/plan_list.html","<six-toolbar><six-toolbar-button icon=\"fa fa-calendar-check-o\" label=\"Gantt\" toolbar-function=\"goToGantt()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-plus\" label=\"Nuova programmata\" btn-class=\"btn-info\" toolbar-function=\"goToNewPlan()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Attività Programmate</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getPlanList()\" items-list=\"planList\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("plan/plan/plan_odl.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-calendar\" label=\"Visualizza programmata\" btn-class=\"btn-default\" toolbar-function=\"goToPlan()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-pencil\" label=\"Modifica date\" btn-class=\"btn-default\" toolbar-function=\"goToReplan()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Elimina tutti\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" sx-disabled=\"!isDeletePermAllowed()\" ng-confirm-message=\"Sei sicuro?\" ng-confirm-click=\"deleteOdlList()\" ng-confirm-condition=\"true\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista ODL generati</h1><small><span class=\"text-muted\">Compito:</span> <span>{{plan.model.task_id.code}} - {{plan.model.task_id.description}}</span> <span>&nbsp;&nbsp;&nbsp;</span> <span class=\"text-muted\">Frequenza:</span> <span>{{frequency}}</span></small></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getOdlList()\" items-list=\"odlList\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("plan/plan/plan_replan.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-calendar\" label=\"Visualizza programmata\" btn-class=\"btn-default\" toolbar-function=\"goToPlan()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-save\" label=\"Salva\" btn-class=\"btn-success\" toolbar-function=\"save()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Modifica date</h1><small><span class=\"text-muted\">Compito:</span> <span>{{plan.model.task_id.code}} - {{plan.model.task_id.description}}</span> <span>&nbsp;&nbsp;&nbsp;</span> <span class=\"text-muted\">Frequenza:</span> <span>{{frequency}}</span></small></div></div></div><div class=\"panel-body\" ng-init=\"rita=0\"><div ng-repeat=\"day in planning\"><div class=\"grouped_ist_element text-info\"><span class=\"grouped_ist_element_title\">{{ day.date_requested | date:\'dd/MM/yyyy\'}}</span></div><div class=\"row\" ng-if=\"isEditing($index)\"><div class=\"col-sm-5 m-b-xs m-t-xs\"><span class=\"input-group\" style=\"width:100%\"><input type=\"text\" name=\"toDate\" class=\"form-control\" ng-change=\"selectDate($index)\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"dayCheckList[$index].newDate\" is-open=\"dayCheckList[$index].popup.opened\" datepicker-options=\"dateOptions\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"dayCheckList[$index].popup.opened=!dayCheckList[$index].popup.opened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></span></div><div class=\"col-sm-4\"></div><div class=\"col-sm-3\"></div></div><div class=\"panel panel-default table-responsive\"><table class=\"table table-striped b-t b-light\"><thead><tr><th style=\"width:20px;\"><label class=\"i-checks m-b-none\"><input type=\"checkbox\" ng-click=\"checkAllDay($index)\" ng-model=\"dayCheckList[$index].isChecked\"><i></i></label></th><th>Asset</th><th>Elemento tecnologico</th><th>Nuova data</th><th style=\"width:30px;\"></th></tr></thead><tbody><tr ng-repeat=\"odl in day.list\" ng-init=\"checkItem=odlCheckList[odl.temp_index]\"><td><label class=\"i-checks m-b-none\"><input type=\"checkbox\" ng-model=\"checkItem.isChecked\"><i></i></label></td><td>{{odl.model.record_id.code}} - {{odl.model.record_id.description}}</td><td>{{odl.model.record_type_id.code}} - {{odl.model.record_type_id.description}}</td><td>{{checkItem.newDate | date:\'dd/MM/yyyy\'}}</td><td><i ng-if=\"checkItem.canUndo\" ng-click=\"undoOdlItem(checkItem)\" style=\"cursor:pointer\" class=\"fa fa-undo text-primary\"></i></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("plan/task/task_detail.html","<style type=\"text/css\">\n.center-open{\n    padding-left: 295px;\n}\n\n.selected {\n    background-color: #11c7f5 !important;\n}\n</style><six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" toolbar-function=\"delete(task.version)\" sx-disabled=\"!task.version || !isDeletePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"list-sidebar-overlay\"></div><aside id=\"list-sidebar\" class=\"list-sidebar list-sidebar-default list-sidebar-stacked custom-six-sidebar\" role=\"navigation\"><div class=\"panel sidebar-panel\"><button class=\"btn btn-info pull-left\" ng-click=\"closeSidebar()\"><span class=\"fa fa-times icon-only\"></span></button> <button class=\"btn btn-info pull-right\" ng-click=\"confirmSelectActivities()\"><span class=\"fa fa-check icon-only\"></span></button><div class=\"panel-heading bg-info sidebar-heading\">Seleziona Attività</div></div><ul class=\"nav list-sidebar-nav\"><li><div class=\"form-group m-l-xs m-r-xs m-t-xs\"><six-search-form ng-model=\"activityFilter\" placeholder=\"Filtra...\" hide-search-btn=\"\"></six-search-form></div></li><li ng-repeat=\"activity in availableActivities | filter:activityFilter as filteredActivities\" class=\"m-l-xs m-r-xs\"><label class=\"checkbox i-checks m-b-sx\" ng-hide=\"isDisabledActivity(activity.UUID)\"><input type=\"checkbox\" ng-model=\"addCheckModel[$index]\" ng-disabled=\"isDisabledActivity(activity.UUID)\"><i></i>{{activity.model.description}}</label></li></ul></aside><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\" ng-hide=\"task.version\"><h1 class=\"m-n font-thin h3 text-black\">Nuovo Compito</h1></div><div class=\"col-sm-6 col-xs-12\" ng-show=\"task.version\"><h1 class=\"m-n font-thin h3 text-black\">Compito</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-body\"><uib-tabset><uib-tab><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Dati</uib-tab-heading><div class=\"row\"><div class=\"col-md-12 col-sm-12\"><label for=\"code\" class=\"control-label\">Codice</label><div class=\"input-group\" style=\"width:100%\"><input id=\"code\" name=\"code\" type=\"text\" ng-model=\"task.model.code\" class=\"form-control\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-12 col-sm-12 m-t\"><label for=\"description\" class=\"control-label\">Descrizione</label><div class=\"input-group\" style=\"width:100%\"><textarea id=\"description\" name=\"description\" ng-model=\"description\" ng-keyup=\"refreshDescription(description)\" required=\"\" class=\"form-control\"></textarea></div></div></div><div class=\"row\"><div class=\"col-md-12 col-sm-12 m-t\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div><span class=\"pull-right\"><button class=\"btn btn-default add-remove-button add-remove-button-first\" ng-click=\"removeActivity()\" ng-show=\"!isSidebarOpened\" ng-disabled=\"taskActivities.length==0\"><span class=\"fa fa-times\"></span>Rimuovi</button> <button class=\"btn btn-default add-remove-button add-remove-button-first\" ng-click=\"closeSidebar()\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-times\"></span>Annulla</button></span> <span class=\"pull-right\"><button class=\"btn btn-default add-remove-button\" ng-click=\"selectActivity()\" ng-show=\"!isSidebarOpened\"><span class=\"fa fa-plus\"></span>Aggiungi</button> <button class=\"btn btn-default add-remove-button\" ng-click=\"confirmSelectActivities()\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-check\"></span>Conferma</button></span><h4 class=\"override-h4-no-margin\">Attività</h4><hr></div><div><label class=\"checkbox i-checks m-b\" ng-repeat=\"activity in taskActivities\"><input type=\"checkbox\" ng-model=\"remCheckModel[$index]\"><i></i>{{activity.model.description}}{{activity.description}}</label></div></div></div></div></div></uib-tab><uib-tab disable=\"!task.version\"><uib-tab-heading><span class=\"fa fa-book text-primary-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments nodes=\"attachments\" save-callback=\"updAttachments()\"></six-tree-attachments></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("plan/task/task_gantt.html","<style>\n.gantt-side {\n    min-width: 200px;\n}\n</style><six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"reload()\"></six-toolbar-button><six-toolbar-button id=\"test\" icon=\"fa fa-plus\" label=\"Nuovo compito\" toolbar-function=\"goToNewTask()\" btn-class=\"btn-info\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Calendario Compiti Programmati</h1></div></div></div><div class=\"panel-body\"><div class=\"panel panel-default\"><div class=\"panel-heading\" style=\"cursor:pointer;\" data-toggle=\"collapse\" data-target=\"#gantt-options-form\" ng-click=\"toggleArrow()\"><h4 class=\"panel-title\">Opzioni <i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': opt.open, \'fa-angle-right\': !opt.open}\"></i></h4></div><div id=\"gantt-options-form\" class=\"panel-body collapse\"><div class=\"row\"><div class=\"col-md-2 col-sm-6 m-t-xs\"><label class=\"control-label\">Da</label><div class=\"input-group\" style=\"width:100%\"><input type=\"date\" ng-model=\"opt.fromDate\" class=\"form-control\"></div></div><div class=\"col-md-2 col-sm-6 m-t-xs\"><label class=\"control-label\">A</label><div class=\"input-group\" style=\"width:100%\"><input type=\"date\" ng-model=\"opt.toDate\" class=\"form-control\"></div></div><div class=\"col-md-2 col-sm-6 m-t-xs\"><label for=\"viewScale\" class=\"control-label\">Dettaglio</label><select id=\"viewScale\" class=\"form-control ng-pristine ng-valid ng-touched\" ng-model=\"opt.viewScale\"><option label=\"giorno\" value=\"day\">giorno</option><option label=\"settimana\" value=\"week\">settimana</option><option label=\"mese\" value=\"month\">mese</option><option label=\"anno\" value=\"year\">anno</option></select></div><div class=\"col-md-4 col-sm-6 m-t-xs\"><label class=\"control-label\">Nodi</label><div class=\"btn-group btn-group-justified\"><a class=\"btn btn-default\" ng-click=\"expandAll()\">Espandi tutto</a> <a class=\"btn btn-default\" ng-click=\"collapseAll()\">Comprimi tutto</a></div></div><div class=\"col-md-2 col-sm-12 m-t-xs\"><label for=\"filter\" class=\"control-label\">Filtro compiti</label><div class=\"input-group\" style=\"width:100%\"><input type=\"text\" id=\"filter\" name=\"filter\" ng-model=\"opt.filterRow\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-md-3 col-sm-12 m-t\"><label for=\"assetFilterCode\" class=\"control-label\">Filtro codice asset</label><p class=\"input-group\" style=\"width:100%\"><input type=\"text\" id=\"assetFilterCode\" name=\"assetFilterCode\" class=\"form-control\" ng-model=\"opt.assetFilter.code\" ng-keyup=\"$event.keyCode == 13 && getGanttData()\"></p></div><div class=\"col-md-3 col-sm-12 m-t\"><label for=\"assetFilterDescr\" class=\"control-label\">Filtro nome asset</label><p class=\"input-group\" style=\"width:100%\"><input type=\"text\" id=\"assetFilterDescr\" name=\"assetFilterDescr\" class=\"form-control\" ng-model=\"opt.assetFilter.description\" ng-keyup=\"$event.keyCode == 13 && getGanttData()\"></p></div><div class=\"col-md-3 col-sm-12 m-t\"><label for=\"assetFilterType\" class=\"control-label\">Filtro elemento tecnologico</label><p class=\"input-group\" style=\"width:100%\"><six-lookup ng-model=\"opt.assetFilter\" id=\"assetFilterType\" name=\"assetFilterType\" sx-base-path=\"\'tree/_flat\'\" sx-field=\"\'type_id\'\" sx-placeholder=\"\'Tipo...\'\" required=\"\" aria-required=\"false\"></six-lookup></p></div><div class=\"col-md-1 col-sm-12 m-t\"><label class=\"control-label\"></label><p class=\"input-group m-t-xs\" style=\"width:100%\"><button class=\"btn btn-default\" name=\"assetFilterBtn\" ng-click=\"getGanttData()\"><i class=\"fa fa-search\"></i>Filtra asset</button></p></div><div class=\"col-md-1 col-sm-12 m-t\"><label class=\"control-label\"></label><p class=\"input-group m-t-xs\" style=\"width:100%\"><button class=\"btn btn-default\" name=\"assetFilterClear\" ng-click=\"clearAssetFilter()\"><i class=\"fa fa-times\"></i>Pulisci filtri</button></p></div></div></div></div><br><div class=\"legend\" ng-hide=\"ganttData.length==0\"><span class=\"text-xs text-muted pull-right\"><i class=\"fa fa-circle text-info m-r-xs\"></i> da completare <i class=\"fa fa-circle text-success m-r-xs m-l-sm\"></i> completato</span> <span style=\"clear:both\"></span></div><div gantt=\"\" options=\"options\" api=\"registerApi\" data=\"ganttData\" to-date=\"opt.toDate\" from-date=\"opt.fromDate\" daily=\"true\" view-scale=\"opt.viewScale\" filter-row=\"{\'name\': opt.filterRow}\" ng-hide=\"ganttData.length==0\"><gantt-table columns=\"tableColumns\" headers=\"tableHeaders\"><gantt-tree header=\"treeHeader\" keep-ancestor-on-filter-row=\"true\" content=\"treeContent\"></gantt-tree></gantt-table><gantt-tooltips enabled=\"true\" date-format=\"\'DD/MM/YYYY\'\" content=\"tooltipContent\"></gantt-tooltips><gantt-groups enabled=\"true\" display=\"group\"></gantt-groups></div><div ng-show=\"ganttData.length==0\"><div class=\"alert alert-info\">Nessun risultato trovato.</div></div></div></div></div>");
$templateCache.put("plan/task/task_list.html","<six-toolbar><six-toolbar-button icon=\"fa fa-calendar-check-o\" label=\"Gantt\" toolbar-function=\"goToGantt()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-plus\" label=\"Nuovo compito\" btn-class=\"btn-info\" toolbar-function=\"goToNewTask()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Compiti</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getTasksList()\" items-list=\"tasksList\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("theme/abnormal/abnormal.html","<script type=\"text/javascript\">\n\n  function analizeUrl(iframe) {\n    var url = iframe.contentWindow.location.href;\n    if (url.indexOf(\'menuTouch.jsf\') != -1 || url.indexOf(\'menuTouch.xhtml\') != -1) {\n      window.location.href = window.location.origin + \'#/bookmarks\';\n    }\n  }\n\n</script><div ng-show=\"debug\"><form name=\"MainForm\" id=\"MainForm\" action=\"/eggs/FirstS\" method=\"post\" target=\"eggsFrame\"><input type=\"hidden\" id=\"typReq\" name=\"typReq\" value=\"goFunction\"> <input type=\"text\" id=\"action\" name=\"action\" value=\"\"> <input type=\"hidden\" id=\"currWindow\" name=\"currWindow\" value=\"\"> <input type=\"hidden\" id=\"currJsp\" name=\"currJsp\" value=\"\"> <input type=\"hidden\" id=\"barPosX\" name=\"barPosX\" value=\"\"> <input type=\"hidden\" id=\"barPosY\" name=\"barPosY\" value=\"0\"> <input type=\"hidden\" id=\"menuBarPosY\" name=\"menuBarPosY\" value=\"\"> <input type=\"hidden\" id=\"barPosY1\" name=\"barPosY1\" value=\"0\"> <input type=\"hidden\" id=\"barPosY2\" name=\"barPosY2\" value=\"0\"> <input type=\"hidden\" id=\"barPosY3\" name=\"barPosY3\" value=\"\"> <input type=\"hidden\" id=\"barPosY4\" name=\"barPosY4\" value=\"\"> <input type=\"submit\" id=\"submit\" value=\"Submit\"></form></div><iframe id=\"eggsFrame\" name=\"eggsFrame\" width=\"0\" height=\"0\" frameborder=\"0\"></iframe><div ng-repeat=\"item in extern\" ng-hide=\"true\"><a ng-href=\"{{ item.route.indexOf(\'http:\')==0? item.route:\'#/\' + item.route }}\" id=\"{{item.id}}\"></a></div><iframe id=\"jsfFrame\" ng-src=\"{{ getJsfURL() | trustAsResourceUrl }}\" onload=\"if (typeof(resizeIframe) == \'function\'){analizeUrl(this)}\" width=\"99%\" height=\"800\" scrolling=\"no\" frameborder=\"0\"></iframe>");
$templateCache.put("theme/admin/admin.html","<div><iframe id=\"adminFrame\" ng-src=\"{{ getAdminURL() | trustAsResourceUrl }}\" width=\"100%\" height=\"1000\" frameborder=\"0\"></iframe></div>");
$templateCache.put("theme/auth/postauth.html","");
$templateCache.put("theme/bookmarks/bookmarks.html","<div class=\"panel breadcrumb\"><div class=\"breadcrumb-container\"><span><span class=\"breadcrumb-item\"><a href=\"\" class=\"btn-breadcrumb\">Bookmarks</a></span></span></div></div><div class=\"col-md-12 override-padding-toolbar\"><div class=\"col-md-3 col-sm-6\"><a ng-href=\"#/touchmenu\"><button class=\"btn btn-touchmenu\"><i class=\"fa fa-navicon\"></i><h3>Menu</h3></button></a></div><div class=\"col-md-3 col-sm-6\" ng-repeat=\"b in bookmarks\"><a ng-href=\"{{ b.code.indexOf(\'http:\')==0? b.code:\'#/\' + b.code }}\"><button class=\"btn btn-dashboard\"><i class=\"{{b.icon || \'fa fa-star\'}}\"></i><h3>{{b.description}}</h3></button></a></div></div><iframe id=\"jsfFrame\" ng-src=\"{{ getJsfURL() | trustAsResourceUrl }}\" width=\"99%\" height=\"600\" style=\"display:none;\" frameborder=\"0\"></iframe>");
$templateCache.put("theme/bookmarkshome/bookmarkshome.html","<style>\n    .card {\n        background: #fff;\n        border-radius: 2px;\n        margin-bottom: 30px;\n        width: 100%;\n        padding-top: 10px;\n        padding-bottom: 10px;\n    }\n\n    .favourite {\n        padding-top: 0px;\n    }\n\n    .dashboard-wrapper {\n        padding: 20px 20px;\n    }\n\n    .card-1 {\n        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05), 0 1px 0 rgba(0, 0, 0, 0.05);\n        transition: all 0.3s cubic-bezier(.25, .8, .25, 1);\n        border: 1px solid #FFF;\n    }\n\n    .card-1:hover i {\n      color: #17b2e2;\n    }\n    .card-1:hover h3 {\n      color: #17b2e2;\n    }\n    .card h3 {\n        color: #354052;\n        font-size: 18px;\n        margin-bottom: 0px;\n        margin-top: 5px;\n        transition: all 0.3s cubic-bezier(.25, .8, .25, 1);\n\n    }\n\n    .card i {\n        color: #67728c;\n        font-size: 25px;\n        margin-bottom: 0px;\n        transition: all 0.3s cubic-bezier(.25, .8, .25, 1);\n\n    }\n\n    .card-1:hover {\n        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05), 0 1px 0 rgba(0, 0, 0, 0.05);\n        border: 1px solid #ccc;\n\n    }\n\n    .app:before {\n        background-color: #eceff4;\n    }\n\n    .app-content {\n        background-color: #eceff4;\n    }\n\n    .background-image-holder {\n        height: calc(100vh - 50px); \n        box-shadow: 6px -3px 12px -5px inset rgba(0, 0, 0, 0.3);\n    }\n\n    .app-content-body {\n        padding-bottom: 0px !important;\n    }\n\n    h1.title {\n        font-size: 20px;\n        margin-bottom: 30px;\n    }\n\n    h1.title i {\n        font-size: 16px;\n        margin-right: 10px;\n\n    }\n\n    .no-margin {\n        margin: 0px;\n        padding: 0px;\n    }\n    .container-fluid {\n        margin: 0px;\n    }\n    .wrapper {\n        margin: 0px;\n        padding: 0px;\n    }\n\n    .btn {\n        margin-top: 15px;\n        text-align: right;\n        float: right;\n        border-radius: 4px;\n        padding: 6px 12px;\n        color: #FFF;\n        margin-left: 10px;\n    }\n\n    .button-edit {\n        background-color: #61b76a;\n    }\n\n    .button-save {\n        background-color: #46bae0;\n    }\n\n    .button-undo {\n        background-color: #3d5672;\n    }\n\n    .input-container{\n        margin-top: -20px;\n        margin-bottom: 20px;\n    }\n\n    @media (max-width: 991px) {\n        .background-image-holder {\n            display: none;\n        }\n    }\n</style><div class=\"wrapper favourite\"><div class=\"container-fluid no-margin\"><div class=\"col-md-8 col-lg-9\"><div class=\"dashboard-wrapper\"><div class=\"col-md-6\"><h1 class=\"title\"><i class=\"fa fa-star-o\"></i>{{\'starred\' | translate}}</h1></div><div class=\"col-md-6\"><div class=\"btn button-edit\" ng-click=\"startEdit()\" ng-if=\"!editing\"><i class=\"fa fa-pencil\"></i> {{\'edit\' | translate}}</div><div class=\"btn button-undo\" ng-click=\"undoEdit()\" ng-if=\"editing\"><i class=\"fa fa-undo\"></i> {{\'undo\' | translate}}</div><div class=\"btn button-save\" ng-click=\"stopEdit()\" ng-if=\"editing\"><i class=\"fa fa-check\"></i> {{\'save\' | translate}}</div></div><div class=\"clearfix\"></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-6 col-lg-4\" ng-repeat=\"b in bookmarks\"><div class=\"card card-1 clearfix\"><a ng-href=\"{{ b.code.indexOf(\'http:\')==0? b.code:\'#/\' + b.code }}\"><div class=\"padder-v item\" style=\"text-align: center\"><div class=\"h1 text-info font-thin\"><i class=\"{{b.icon || \'fa fa-star\' }}\"></i></div><h3>{{b.description}}</h3></div></a></div><div class=\"input-container\" ng-if=\"editing\"><input type=\"text\" class=\"form-control\" ng-model=\"b.newDescription\"></div></div></div></div><div class=\"background-image-holder col-md-4 col-lg-3\" style=\"-webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover; background-size: cover; background-image: -webkit-linear-gradient(rgba(58,87,114,0.95), rgba(53,187,213,0.95)),url(bg_login.jpg); background-image: linear-gradient(rgba(58,87,114,0.95), rgba(24,46,65,0.95)),url(bg_login.png); background-size: cover; background-position: center center;\"></div></div></div><iframe id=\"jsfFrame\" ng-src=\"{{ getJsfURL() | trustAsResourceUrl }}\" width=\"99%\" height=\"600\" style=\"display:none;\" frameborder=\"0\"></iframe>");
$templateCache.put("theme/changeuser/changeuser.html","<div class=\"col-md-12 pad-t-15\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Cambio utente</h1><small class=\"text-muted\">Dashboard</small></div></div></div><div class=\"panel-body\"><div class=\"form-group\"><input ng-keyup=\"searchUsers()\" class=\"form-control\" type=\"text\" ng-model=\"searchString\" placeholder=\"Scrivere qui per filtrare la lista...\"></div><table id=\"userList\" class=\"table table-striped\"><thead><tr><th></th><th>Username</th><th>Nome</th><th>Cognome</th><th>E-Mail</th></tr></thead><tbody><tr ng-repeat=\"item in data.list\"><td><a ng-click=\"changeUser(item.username)\" class=\"btn-sm btn-default\" id=\"btn_changeUser\" ng-hide=\"isCurrent(item.username)\"><span class=\"fa fa-play-circle icon text\"></span></a></td><td>{{ item.username }}</td><td>{{ item.surname }}</td><td>{{ item.name }}</td><td>{{ item.email }}</td></tr><tr ng-hide=\"data.list.length\"><td><p class=\"text-center\">No Data Found</p></td></tr></tbody></table></div></div></div>");
$templateCache.put("theme/commission/commission_detail.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"update()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" toolbar-function=\"deleteWithDialog(data.selected.code)\" sx-disabled=\"isDeletePermAllowed()===false\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Commesse</h1><small class=\"text-muted\">Dettaglio commessa</small></div></div></div><div class=\"panel-body\"><div class=\"row top12\"><div class=\"col-md-2\"><label id=\"code_label\" for=\"code\" class=\"control-label\">CODICE</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"form-control\" readonly=\"\" name=\"code\" id=\"code\" placeholder=\"\" ng-model=\"data.selected.code\"></div></div><div class=\"row top12\"><div class=\"col-md-2\"><label id=\"description_label\" for=\"description\" class=\"control-label\">DESCRIZIONE</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"form-control\" name=\"description\" id=\"description\" placeholder=\"\" ng-model=\"data.selected.description\"></div></div><div class=\"row top12\"><div class=\"col-md-2\"><label id=\"customer_label\" for=\"customer\" class=\"control-label\">CLIENTE</label></div><div class=\"col-md-10\"><six-lookup id=\"customer\" ng-model=\"data.selected\" sx-type=\"\'cliente\'\" sx-field=\"\'cliente\'\"></six-lookup></div></div><div class=\"row top12\"><div class=\"col-md-2\"><label id=\"sapCode_label\" for=\"code\" class=\"control-label\">CODICE SAP</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"form-control\" name=\"code\" id=\"sapCode\" placeholder=\"\" ng-model=\"data.selected.sapCode\"></div></div><div class=\"row top12\"><div class=\"col-md-2\"><label id=\"date_label\" for=\"date\" class=\"control-label\">DATA</label></div><div class=\"col-md-10\"><label id=\"data_key\" class=\"control-label\">{{data.selected.date | date:\'dd/MM/yyyy\'}}</label></div></div><div class=\"row top12\"><div class=\"col-md-10 col-md-offset-1\"><div style=\"display:inline-block;\"><uib-datepicker id=\"date\" ng-model=\"data.selected.date\" datepicker-mode=\"\'day\'\" min-mode=\"day\" class=\"well well-sm\"></uib-datepicker></div></div></div></div></div></div>");
$templateCache.put("theme/commission/commission_list.html","<six-toolbar><six-toolbar-button label=\"Aggiungi commessa\" icon=\"fa fa-plus\" toolbar-function=\"addCommission()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"commission()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Commesse</h1></div></div></div><div class=\"panel-body\"><div class=\"form-group\"><input ng-keyup=\"getData(queryParam)\" class=\"form-control\" type=\"text\" ng-model=\"queryParam\" placeholder=\"Scrivere qui la commessa per filtrare la lista...\"></div><table id=\"asset_list\" class=\"table table-striped\"><thead><tr><th></th><th>CODICE</th><th>DESCRIZIONE</th><th>DATA</th><th>SELEZIONA</th></tr></thead><tbody><tr ng-repeat=\"item in data.list\"><td><a ng-href=\"#/commission/{{item.code}}\" class=\"btn btn-default\" id=\"btn_commission_detail\"><span class=\"glyphicon glyphicon-pencil\"></span></a></td><td>{{ item.code }}</td><td>{{ item.description }}</td><td>{{ item.date | date:\'dd/MM/yyyy\'}}</td><td><a ng-click=\"changeCommission(item)\" class=\"btn btn-default\" id=\"btn_commission_select\"><span class=\"fa fa-long-arrow-left\"></span></a></td></tr><tr ng-hide=\"data.list.length\"><td><p class=\"text-center\">Nessun record recuperato</p></td></tr></tbody></table></div><div class=\"panel-footer\"><div class=\"row text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"data.totalResults\" ng-model=\"data.currentPage\" class=\"pagination-sm\" items-per-page=\"data.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div></div></div>");
$templateCache.put("theme/dashboard/dashboard.html","<div class=\"hbox hbox-auto-xs hbox-auto-sm ng-scope\" ng-init=\"app.settings.asideFolded = false; app.settings.asideDock = false;\"><div class=\"col\"><six-toolbar><six-toolbar-button label=\"Ricarica\" btn-class=\"btn-info\" icon=\"fa fa-cogs\" toolbar-function=\"reloadDashboard()\"></six-toolbar-button></six-toolbar><div class=\"wrapper-md ng-scope override-padding-toolbar\"><div class=\"row\"><div class=\"col-sm-12 col-md-6 connected\" id=\"center-1\" ui-jq=\"sortable\" ui-options=\"{items:\'.panel\', handle:\'.panel-heading\', connectWith:\'.connected\'}\"><div ng-repeat=\"item in pos1\" ng-include=\"\'theme/dashboard/widget_center_pos.html\'\"></div></div><div class=\"col-sm-12 col-md-6 connected\" id=\"center-2\" ui-jq=\"sortable\" ui-options=\"{items:\'.panel\', handle:\'.panel-heading\', connectWith:\'.connected\'}\"><div ng-repeat=\"item in pos2\" ng-include=\"\'theme/dashboard/widget_center_pos.html\'\"></div></div></div><div class=\"row\"><div ng-if=\"pos1.length==0\" class=\"col-sm-12 col-md-6 connected\" id=\"center-1\" ui-jq=\"sortable\" ui-options=\"{items:\'.panel\', handle:\'.panel-heading\', connectWith:\'.connected\'}\"><div ng-repeat=\"item in tmp1\" ng-include=\"\'theme/dashboard/widget_center_pos.html\'\"></div></div><div ng-if=\"pos1.length==0\" class=\"col-sm-12 col-md-6 connected\" id=\"center-2\" ui-jq=\"sortable\" ui-options=\"{items:\'.panel\', handle:\'.panel-heading\', connectWith:\'.connected\'}\"><div ng-repeat=\"item in tmp2\" ng-include=\"\'theme/dashboard/widget_center_pos.html\'\"></div></div></div><div class=\"row\"><div class=\"col-sm-12 col-md-12 connected\" ui-jq=\"sortable\" ui-options=\"{items:\'.panel\', handle:\'.panel-heading\', connectWith:\'.connected\'}\"><div ng-repeat=\"item in wide\" ng-include=\"\'theme/dashboard/widget_center_pos.html\'\"></div></div></div></div></div><div class=\"col w-md bg-white-only b-l bg-auto no-border-xs\" id=\"right-menu\" ng-if=\"pos3.length>0\"><div class=\"nav-tabs-alt\"><ul class=\"nav nav-tabs\" role=\"tablist\"><li ng-repeat=\"item in pos3\" ng-class=\"{\'active\': $index==0}\" ng-init=\"targetId=\'#tab-\'+($index+1)\"><a data-target=\"{{targetId}}\" role=\"tab\" data-toggle=\"tab\" ng-init=\"liClass=\'text-md text-muted wrapper-sm \'+item.icon\"><i class=\"{{liClass}}\"></i></a></li></ul></div><div class=\"tab-content\"><div ng-repeat=\"item in pos3\" role=\"tabpanel\" ng-init=\"tabId=\'tab-\'+($index+1)\" id=\"{{tabId}}\" class=\"tab-pane\" ng-class=\"{\'active\': $index==0}\" ng-include=\"\'theme/dashboard/widget_aside_pos.html\'\" <=\"\" div=\"\"></div></div></div></div>");
$templateCache.put("theme/dashboard/dashboardemma_old.html","<div ng-controller=\"ConsumptionAnalysisCtrl\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Home</h1><small class=\"text-muted\">Dashboard Emma</small></div><div class=\"col-sm-6 text-right hidden-xs\"><div class=\"inline m-r text-left\"><button type=\"button\" class=\"btn btn-info btn-sm pull-right\" ng-click=\"reload()\"><i class=\"fa fa-refresh\"></i> Aggiorna</button></div></div></div></div><div class=\"col-md-12 wrapper-md\"><div class=\"col-md-12 block panel padder-v\"><table class=\"homeTable table-hover\"><tr><th style=\"width: 25%\"><div class=\"col-sm-6\">Da data:<p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"dashYearsPicker.from\" is-open=\"statusFrom.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openFrom($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-sm-6\">A data:<p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"dashYearsPicker.to\" is-open=\"statusTo.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openTo($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></th><th class=\"numberCell\">Budget</th><th class=\"numberCell\">Consuntivo</th><th class=\"numberCell\">Stagionalità</th><th class=\"numberCell\">&Delta; Stagionalità</th><th class=\"numberCell\">&Delta; Tecnico</th><th class=\"numberCell\">%</th></tr><tr ng-repeat=\"vector in vectors\" class=\"{{currentVector==vector?\'text-black\':\'\'}}\" ng-if=\"getValues(vector).cons !== 0 || getValues(vector).budget !== 0 || vector.model.description == \'Totale\'\"><td class=\"text-center\"><a href=\"\" ng-click=\"setCurrentVector(vector)\" class=\"block item {{currentVector==vector?\'inShadow\':\'\'}}\" style=\"{{vector.model.color?\'background-color: \'+vector.model.color:\'background-color: #CCC\'}}\"><span class=\"{{currentVector==vector?\'text-white font-bold\':\'text-info-dker\'}} font-thin h3 block\" style=\"{{vector.model.text_color?\'color: \'+vector.model.text_color+\' !important\':\'\'}}\">{{vector.model.description}}<span ng-if=\"vector.model.um.code\">({{vector.model.um.code}})</span></span><div ng-if=\"false\"><span class=\"{{currentVector==vector?\'text-info\':\'text-info-dker\'}} font-thin h3 block\">{{vector.cachedData.budget.totalConsumption| number: 2}}</span> <span class=\"text-muted text-xs\">{{vector.model.description}} <span ng-if=\"vector.cachedData.budget.totalConsumptionStd\">({{vector.cachedData.budget.totalConsumptionStd| number: 2}} Kw/h)</span></span></div></a></td><td class=\"numberCell\">{{getValues(vector).budget | number: 2}}</td><td class=\"numberCell\">{{getValues(vector).cons | number: 2}}</td><td class=\"numberCell\">{{getValues(vector).season | number: 2}}</td><td class=\"numberCell\">{{getValues(vector).deltaSeason | number: 2}}</td><td class=\"numberCell\">{{getValues(vector).deltaTech | number: 2}}</td><td class=\"numberCell\">{{getValues(vector).percentage | number: 2}}</td></tr></table></div><div class=\"panel col-md-12 block\"><div class=\"col-lg-6\"><six-loading-place-holder sx-model=\"currentVector.loadingPlaceHolder\" sx-height=\"\'450px\'\"></six-loading-place-holder><six-multi-series-line-chart sx-id=\"graph1\" sx-graph-data=\"graphData\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"Consumi\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\', \'#EE2222\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart></div><div class=\"col-lg-6\"><six-loading-place-holder sx-model=\"currentVector.loadingPlaceHolder\" sx-height=\"\'450px\'\"></six-loading-place-holder><six-multi-series-line-chart sx-id=\"graph2\" sx-graph-data=\"graphDataCumulative\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"Consumi cumulati\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart></div></div><div class=\"col-md-5\" ng-if=\"false\"><div class=\"row row-sm text-center\"><div class=\"col-xs-12 block panel padder-v\"><six-year-picker ng-model=\"dashYearsPicker.from\"></six-year-picker></div><div ng-repeat=\"vector in vectors\" class=\"col-xs-6\"><a href=\"\" ng-click=\"setCurrentVector(vector)\" class=\"block panel padder-v {{currentVector==vector?\'\':\'bg-info lter\'}} item {{currentVector==vector?\'inShadow\':\'\'}}\"><span class=\"{{currentVector==vector?\'text-info\':\'text-white\'}} font-thin h1 block\">{{vector.cachedData.budget.totalConsumption| number: 2}}</span> <span class=\"text-muted text-xs\">{{vector.model.description}} <span ng-if=\"vector.cachedData.budget.totalConsumptionStd\">({{vector.cachedData.budget.totalConsumptionStd| number: 2}} Kw/h)</span></span> <span class=\"bottom text-right w-full h3\"><span class=\"text-success-dker font-thin\" ng-if=\"vector.cachedData.budget.budgetComparison<0\">{{vector.cachedData.budget.budgetComparison | number: 0}}%</span> <span class=\"text-danger font-thin h3\" ng-if=\"vector.cachedData.budget.budgetComparison>0\">+{{vector.cachedData.budget.budgetComparison | number: 0}}%</span></span> <span class=\"bottom text-left w-full\" ng-if=\"!vector.cachedData\"><i class=\"fa fa-refresh fa-spin text-muted m-r-sm\"></i></span></a></div><div class=\"col-xs-12 m-b-md\" ng-if=\"loadingPlaceHolder.show\"><six-loading-place-holder sx-model=\"loadingPlaceHolder\" sx-height=\"\'170px\'\"></six-loading-place-holder></div><div class=\"col-xs-12 m-b-md\"><div class=\"r bg-light dker item hbox no-border\" ng-if=\"!loadingPlaceHolder.show\"><div class=\"col w-xs v-middle hidden-md\"><i class=\"fa fa-money\" style=\"font-size: xx-large\"></i></div><div class=\"col dk padder-v r-r\"><div class=\"text-primary-dk font-thin h1\"><span>{{budget.totalBudget | number: 0}}</span></div><span class=\"text-muted text-xs\">Totale budget <span ng-if=\"budget.totalBudgetStd\">({{budget.totalBudgetStd | number: 0}} Kw/h)</span></span></div></div></div><div class=\"col-xs-12 m-b-md\"><div class=\"r bg-light dker item hbox no-border\" ng-if=\"!loadingPlaceHolder.show\"><div class=\"col w-xs v-middle hidden-md\"><i class=\"fa fa-search\" style=\"font-size: xx-large\"></i></div><div class=\"col dk padder-v r-r\"><div class=\"text-primary-dk font-thin h1\"><span>{{budget.totalConsumption | number: 0}}</span></div><span class=\"text-muted text-xs\">Totale consumi <span ng-if=\"budget.totalConsumptionStd\">({{budget.totalConsumptionStd | number: 0}} Kw/h)</span></span> <span class=\"bottom text-right w-full h3\"><span class=\"text-success-dker font-thin\" ng-if=\"budget.budgetComparison<0\">{{budget.budgetComparison | number: 2}}%</span> <span class=\"text-danger font-thin h3\" ng-if=\"budget.budgetComparison>0\">+{{budget.budgetComparison | number: 2}}%</span></span></div></div></div></div></div><div class=\"row\"><div class=\"col-md-9\" ng-if=\"false\"><div class=\"col-md-6\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"clearfix text-center m-t\"><div class=\"inline\"><six-donut-chart sx-id=\"\'donut1\'\" sx-graph-data=\"donutDataBudget\"></six-donut-chart></div></div></div><footer class=\"panel-footer bg-info text-center no-padder\"><div class=\"row no-gutter\"><div class=\"col-xs-6\"><div class=\"wrapper\"><span class=\"m-b-xs h3 block text-white\">Budget</span> <small class=\"text-muted\">{{dashYearsPicker.from}}</small></div></div><div class=\"col-xs-6 dk\"><div class=\"wrapper\"><span class=\"m-b-xs h3 block text-white\">{{vectors.totVector.cachedData.budget.totalBudget | number: 0}}<six-loading-small sx-for=\"vectors.totVector.cachedData.budget.totalBudget\"></six-loading-small></span> <small class=\"text-muted\">Kw/h</small></div></div></div></footer></div></div><div class=\"col-md-6\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"clearfix text-center m-t\"><div class=\"inline\"><six-donut-chart sx-id=\"\'donut2\'\" sx-graph-data=\"donutDataConsumption\"></six-donut-chart></div></div></div><footer class=\"panel-footer bg-info text-center no-padder\"><div class=\"row no-gutter\"><div class=\"col-xs-6\"><div class=\"wrapper\"><span class=\"m-b-xs h3 block text-white\">Consumi</span> <small class=\"text-muted\">{{dashYearsPicker.from}}</small></div></div><div class=\"col-xs-6 dk\"><div class=\"wrapper\"><span class=\"m-b-xs h3 block text-white\">{{vectors.totVector.cachedData.budget.totalConsumptionStd | number: 0}}<six-loading-small sx-for=\"vectors.totVector.cachedData.budget.totalConsumptionStd\"></six-loading-small></span> <small class=\"text-muted\">Kw/h</small></div></div></div></footer></div></div></div><div class=\"col-sm-3 connected\" ui-jq=\"sortable\" ui-options=\"{items:\'.panel\', handle:\'.panel-heading\', connectWith:\'.connected\'}\"><div class=\"panel panel-info\" draggable=\"true\"><div class=\"panel-heading\">Quick link</div><div class=\"list-group bg-white\"><a href=\"#/consumptionanalysis\" class=\"list-group-item\"><i class=\"fa fa-fw fa-money\"></i> Analisi consumi</a> <a href=\"#/consumptive/consumption\" class=\"list-group-item\"><i class=\"fa fa-fw fa-money\"></i> Consuntivo consumi</a> <a href=\"#/budget/view\" class=\"list-group-item\"><i class=\"fa fa-fw fa-money\"></i> Visualizza budget</a></div></div></div></div></div></div>");
$templateCache.put("theme/dashboard/widget_aside_pos.html","<div class=\"wrapper-md\"><div class=\"m-b text-md\">{{ item.title }}</div><div ng-if=\"item.widgetType==\'widget-timeline\'\" ng-init=\"data=item.data; aside=true\" ng-include=\"\'theme/dashboard/widget_timeline.html\'\"></div></div>");
$templateCache.put("theme/dashboard/widget_center_pos.html","<div draggable=\"true\" class=\"widget widget-card\" style=\"display: block;\" ng-init=\"myClass=\'bg-\'+item.skin\" ng-hide=\"item.hideWidget\"><div class=\"panel\" ng-class=\"widgetClass\"><div class=\"panel-heading {{myClass}}\">{{ item.title }}<span ng-if=\"getDynamic(item).subtitle\">- {{ getDynamic(item).subtitle }}</span></div><div><div ng-if=\"item.widgetType==\'widget-label-list\'\" ng-init=\"data=item.data\" ng-include=\"\'theme/dashboard/widget_labellist.html\'\"></div><div ng-if=\"item.widgetType==\'widget-simple-list\'\" ng-init=\"data=item.data\" ng-include=\"\'theme/dashboard/widget_simplelist.html\'\"></div><div ng-if=\"item.widgetType==\'widget-user\'\" ng-init=\"data=item.data[0]\" ng-include=\"\'theme/dashboard/widget_user.html\'\"></div><div ng-if=\"item.widgetType==\'widget-donut\'\" ng-init=\"data=item.data\" ng-include=\"\'templates/widget-donut.html\'\"></div><div ng-if=\"item.widgetType==\'widget-timeline\'\" ng-init=\"data=item.data\" ng-include=\"\'theme/dashboard/widget_timeline.html\'\"></div><div ng-if=\"item.widgetType==\'widget-consumptive\'\" ng-init=\"data=item.data\" ng-include=\"\'theme/dashboard/widget_consumptive.html\'\"></div><div ng-if=\"item.widgetType==\'widget-quicklink\'\" ng-init=\"data=item.data\" ng-include=\"\'theme/dashboard/widget_quicklink.html\'\"></div><div ng-if=\"item.widgetType==\'widget-consumptive-graph\'\" ng-init=\"data=item.data\" ng-include=\"\'theme/dashboard/widget_consumptive_graph.html\'\"></div></div><div class=\"panel-footer\" ng-if=\"item.buttons.length>0\"><a ng-repeat=\"b in item.buttons\" ng-href=\"#/{{b.link}}\"><button class=\"btn btn-default\"><span ng-class=\"b.icon\"></span> {{ b.label }}</button></a></div></div></div><script type=\"text/ng-template\" id=\"templates/widget-donut.html\"><six-donut-chart ng-init=\"chartId=\'donut\'+$index\" sx-id=\"chartId\" sx-graph-data=\"data\" sx-chart-width=\"200\" sx-chart-height=\"150\"> </six-donut-chart> <ul class=\"list-group no-radius\" style=\"margin-bottom:0px;\"> <li class=\"list-group-item\" ng-repeat=\"d in data\" ng-init=\"bgStyle={\'background-color\':d.color}\"> <span class=\"pull-right\"> {{ d.value }} </span> <span class=\"label donut-label\" ng-style=\"bgStyle\"> {{ d.label }} </span> {{ d.description }} </li> </ul></script>");
$templateCache.put("theme/dashboard/widget_consumptive.html","<div class=\"panel-body\" ng-click=\"selectWidget(data)\" ng-class=\"{\'selected\':isSelectedWidget(data)}\"><div class=\"row no-gutter\"><div class=\"col-xs-6 col-sm-4 col-md-6 col-lg-4 col-xl-2\"><div class=\"wrapper-sm\" ng-mouseenter=\"lightOn(1)\" ng-class=\"widgetEmmaClass[1]\" ng-mouseleave=\"lightOff(1)\"><span class=\"m-b-xs h3 block\"><i class=\"fa fa-refresh fa-spin\" ng-if=\"!data\"></i> {{data.budget | number: 2}}</span> <small class=\"text-muted\">Budget</small></div></div><div class=\"col-xs-6 col-sm-4 col-md-6 col-lg-4 col-xl-2\"><div class=\"wrapper-sm widget-emma-3\" ng-mouseenter=\"lightOn(3)\" ng-class=\"widgetEmmaClass[3]\" ng-mouseleave=\"lightOff(3)\"><span class=\"m-b-xs h3 block\"><i class=\"fa fa-refresh fa-spin\" ng-if=\"!data\"></i> {{data.cons | number: 2}}</span> <small class=\"text-muted\">Consuntivo</small></div></div><div class=\"row wrapper\" ng-if=\"data.showGraph\"><div class=\"col-md-12\"><six-multi-series-line-chart sx-id=\"graph_{{data.graph.id}}\" sx-graph-data=\"data.graph.graphData\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"{{title}}\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\', \'#EE2222\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart></div></div></div><div class=\"legend\"><span class=\"text-xs text-muted pull-right\">{{datePicker.from | date}} / {{datePicker.to | date}}</span> <span style=\"clear:both\"></span></div></div>");
$templateCache.put("theme/dashboard/widget_consumptive_graph.html","<div class=\"panel-body\"><div class=\"row no-gutter\"><div class=\"row wrapper\"><div class=\"col-md-12\"><six-multi-series-line-chart sx-id=\"graph\" sx-graph-data=\"widgetEmmaSelected.graph.graphData\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"{{widgetEmmaSelected.graph.title}}\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\', \'#EE2222\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><six-multi-series-line-chart sx-id=\"graph_cum\" sx-graph-data=\"widgetEmmaSelected.graph.graphDataCumulative\" sx-y-axis-legend=\"\'Consumi cum.\'\" sx-graph-title=\"{{widgetEmmaSelected.graph.title}} (cum.)\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\', \'#EE2222\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart></div></div></div><div class=\"legend\"><span class=\"text-xs text-muted pull-right\">{{datePicker.from | date}} / {{datePicker.to | date}}</span> <span style=\"clear:both\"></span></div></div>");
$templateCache.put("theme/dashboard/widget_donut.html","<six-donut-chart ng-init=\"chartId=\'donut\'+$index\" sx-id=\"chartId\" sx-graph-data=\"data\" sx-chart-width=\"200\" sx-chart-height=\"150\"></six-donut-chart><ul class=\"list-group no-radius\" style=\"margin-bottom:0px;\"><li class=\"list-group-item\" ng-repeat=\"d in data\" ng-init=\"bgStyle={\'background-color\':d.color}\"><span class=\"pull-right\">{{ d.value }}</span> <span class=\"label donut-label\" ng-style=\"bgStyle\">{{ d.label }}</span> {{ d.description }}</li></ul>");
$templateCache.put("theme/dashboard/widget_labellist.html","<div class=\"panel-body\"><div class=\"m-b\" ng-repeat=\"d in data\" ng-init=\"bgClass=\'bg-\'+d.color;arrowClass=\'arrow-\'+d.color\"><span class=\"label text-base pos-rlt m-r {{bgClass}}\"><i class=\"arrow right {{arrowClass}}\"></i> {{d.label}}</span> <a ng-href=\"#/{{d.link}}\">{{d.title}}</a></div></div>");
$templateCache.put("theme/dashboard/widget_quicklink.html","<div class=\"no-padder\"><div class=\"hbox text-center b-b b-light text-sm\"><a ng-repeat=\"d in data\" ng-href=\"{{d.link}}\" class=\"col padder-v text-muted\"><i class=\"{{d.icon}} block m-b-xs fa-2x\"></i> <span>{{d.label}}</span></a></div></div>");
$templateCache.put("theme/dashboard/widget_simplelist.html","<div class=\"panel-body\"><ul class=\"list-group list-group-sm list-group-sp list-group-alt auto m-t\"><li class=\"list-group-item\" ng-repeat=\"d in data\" ng-init=\"textClass=\'text-\'+d.color;\"><a ng-href=\"#/{{d.link}}\"><span class=\"text-muted\">{{ d.title }}</span> <span class=\"block text-md {{textClass}}\">{{ d.label }}</span></a></li></ul></div>");
$templateCache.put("theme/dashboard/widget_timeline.html","<div ng-class=\"{\'wrapper\': !aside}\"><div class=\"streamline b-l m-b\"><div class=\"sl-item b-l {{bClass}}\" ng-repeat=\"d in data\" ng-init=\"bClass=\'b-\'+d.color;\"><div class=\"m-l\"><div class=\"text-muted\">{{ d.label }}</div><a ng-href=\"#/{{d.link}}\"><p>{{ d.title }}</p></a></div></div></div></div>");
$templateCache.put("theme/dashboard/widget_user.html","<div class=\"panel-body\"><div class=\"clearfix text-center m-t\"><div class=\"inline\"><div class=\"easyPieChart\" style=\"width: 134px; height: 134px; line-height: 134px;\"><div class=\"thumb-xl\"><img ng-src=\"{{ data.avatar }}\" style=\"width:128px;height:128px;\" class=\"img-circle\" alt=\"avatar\"></div><canvas width=\"134\" height=\"134\"></canvas></div><div class=\"h4 m-t m-b-xs\">{{ data.user }}</div><small class=\"text-muted m-b\">{{ data.group }}</small></div></div></div><footer class=\"panel-footer bg-info text-center no-padder\"><div class=\"hbox text-center b-b b-light text-sm\"><a ng-repeat=\"b in data.buttons\" ng-href=\"#/{{b.link}}\" ng-init=\"iconClass=\'block m-b-xs fa-2x \' + b.icon\" class=\"col padder-v b-r b-light\"><i class=\"{{iconClass}}\"><span ng-show=\"b.hasBadge\" class=\"bell-badge badge bg-danger\">3</span></i> <span>{{b.label}}</span></a></div></footer>");
$templateCache.put("theme/eggs/eggs.html","<style>\n.app:before {\n  background-color: #FFFFFF;\n}\n</style><six-toolbar><six-toolbar-item ng-repeat=\"item in functionHistory track by $index\" ng-if=\"item.label\" label=\"{{ item.label }}\" icon=\"fa fa-window-restore text-primary\" toolbar-function=\"changeRoute(item)\"></six-toolbar-item></six-toolbar><div ng-show=\"debug\"><form name=\"MainForm\" id=\"MainForm\" action=\"/eggs/FirstS\" method=\"post\" target=\"eggsFrame\"><input type=\"hidden\" id=\"typReq\" name=\"typReq\" value=\"goFunction\"> <input type=\"text\" id=\"action\" name=\"action\" value=\"\"> <input type=\"hidden\" id=\"currWindow\" name=\"currWindow\" value=\"\"> <input type=\"hidden\" id=\"currJsp\" name=\"currJsp\" value=\"\"> <input type=\"hidden\" id=\"barPosX\" name=\"barPosX\" value=\"\"> <input type=\"hidden\" id=\"barPosY\" name=\"barPosY\" value=\"0\"> <input type=\"hidden\" id=\"menuBarPosY\" name=\"menuBarPosY\" value=\"\"> <input type=\"hidden\" id=\"barPosY1\" name=\"barPosY1\" value=\"0\"> <input type=\"hidden\" id=\"barPosY2\" name=\"barPosY2\" value=\"0\"> <input type=\"hidden\" id=\"barPosY3\" name=\"barPosY3\" value=\"\"> <input type=\"hidden\" id=\"barPosY4\" name=\"barPosY4\" value=\"\"> <input type=\"submit\" id=\"submit\" value=\"Submit\"></form></div><iframe id=\"eggsFrame\" style=\"padding-top:44px\" name=\"eggsFrame\" width=\"100%\" height=\"768\" frameborder=\"0\"></iframe><div ng-repeat=\"item in extern\" ng-hide=\"true\"><a ng-href=\"{{ item.route.indexOf(\'http:\')==0? item.route:\'#/\' + item.route }}\" id=\"{{item.id}}\"></a></div>");
$templateCache.put("theme/ext/ext.html","<six-toolbar ng-if=\"showHistory\"><six-toolbar-item ng-repeat=\"item in functionHistory track by $index\" ng-if=\"item.label\" label=\"{{ item.label }}\" icon=\"fa fa-window-restore text-primary\" toolbar-function=\"changeRoute(item)\"></six-toolbar-item></six-toolbar><div ng-class=\"{\'m-t-xxl\': showHistory}\"><iframe id=\"extFrame\" ng-src=\"{{ getExtURL() | trustAsResourceUrl }}\" width=\"100%\" height=\"1000\" frameborder=\"0\"></iframe></div><div ng-repeat=\"item in extern\" ng-hide=\"true\"><a ng-href=\"{{ item.route.indexOf(\'http:\')==0? item.route:\'#/\' + item.route }}\" id=\"{{item.id}}\"></a></div>");
$templateCache.put("theme/forbidden/forbidden.html","<style>\n    .app:before {\n        background-color: #eceff4;\n    }\n\n    .app-content {\n        background-color: #eceff4;\n    }\n</style><div class=\"col-md-12 wrapper-md\"><div class=\"container\"><div class=\"modal-center animated fadeInUp text-center forbidden-modal\"><div><img src=\"logo_w.png\"></div><p class=\"h2 m-t-lg m-b\">{{ \'ops\' | translate }}</p><div class=\"h4\">{{ \'forbidden_page\' | translate }}</div></div></div></div>");
$templateCache.put("theme/group/group_detail.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" disabled=\"!group.version\" ng-confirm-message=\"Sei sicuro?\" ng-confirm-click=\"delete(group.version)\" ng-confirm-condition=\"true\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\" ng-hide=\"group.id\"><h1 class=\"m-n font-thin h3 text-black\">Nuovo Gruppo</h1></div><div class=\"col-sm-6 col-xs-12\" ng-show=\"group.id\"><h1 class=\"m-n font-thin h3 text-black\">Dettaglio Gruppo</h1></div></div></div><six-search-terms sx-list=\"searchResult\" sx-id=\"{{sxSearchTerms.id}}\" sx-open=\"sxSearchTerms.open\" sx-model=\"sxSearchTerms\" sx-filter=\"searchFilterObj\" sx-show-select-schema=\"sxSearchTerms.showSelectSchema\" sx-on-filter-changed=\"onFilterChanged()\"></six-search-terms><div class=\"wrapper constructor\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"code\" class=\"control-label\">Nome</label><div class=\"input-group\" style=\"width:100%\"><input name=\"name\" type=\"text\" ng-model=\"group.id\" class=\"form-control\" ng-readonly=\"!isNew\"></div></div></div><div class=\"row\"><div class=\"col-md-6 m-t\"><label for=\"code\" class=\"control-label\">Commessa</label><div id=\"commissions\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"commissionsSelected.items\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una commessa...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in commissions\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-6 m-t\"><label for=\"description\" class=\"control-label\">Elementi del tree</label><div id=\"treeEntities\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"schemasSelected.items\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare un modello...\">{{$item.model.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in schemas\"><div ng-bind-html=\"item.model.description | highlight: $select.search\"></div><small ng-bind-html=\"item.model.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-6 m-t\" ng-repeat=\"g in group\" ng-if=\"isAssetEntry(g)\"><label for=\"description\" class=\"control-label\">{{g.id.key}}</label><div class=\"input-group\" style=\"width: 100%\"><input name=\"{{g.id.key}}\" type=\"text\" ng-model=\"g.value\" class=\"form-control\" readonly=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"editGroup(g)\"><i class=\"fa fa-pencil\"></i></button></span> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"removeGroup(g.id.key)\"><i class=\"fa fa-times\"></i></button></span></div></div></div><div class=\"row\"><div class=\"col-md-6 col-sm-12 m-t\"><div><button ng-click=\"addAssetDetail()\" class=\"btn btn-default\">Aggiungi dettaglio asset</button></div></div></div></div></div></div></div>");
$templateCache.put("theme/group/group_list.html","<six-toolbar><six-toolbar-button label=\"Aggiungi gruppo\" icon=\"fa fa-plus\" toolbar-function=\"goToNewGroup()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Gruppi</h1></div></div></div><div class=\"panel-body\"><table id=\"asset_list\" class=\"table table-striped\"><thead><tr><th></th><th>CODICE</th></tr></thead><tbody><tr ng-repeat=\"item in groupsList\"><td><a ng-href=\"#/group/detail/{{item}}\" class=\"btn btn-default\" id=\"btn_commission_detail\"><span class=\"glyphicon glyphicon-pencil\"></span></a></td><td>{{ item }}</td></tr><tr ng-hide=\"groupsList.length\"><td><p class=\"text-center\">Nessun gruppo recuperato</p></td></tr></tbody></table></div></div></div>");
$templateCache.put("theme/ict-font/ict-font.html","<style>\n.card {\n  background: #fff;\n  border-radius: 2px;\n  display: inline-block;\n  margin: 1rem;\n  position: relative;\n}\n\n.card-1 {\n  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\n  transition: all 0.3s cubic-bezier(.25,.8,.25,1);\n}\n\n.card-1:hover {\n  box-shadow: 0 7px 14px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);\n}\n\n</style><div class=\"page-title m-t-md\"><h1 class=\"m-n font-thin\"><b>ICT Font</b> by Matthias Gutsch <span class=\"fa fa-hearth\"></span></h1></div><div class=\"col-md-12 override-padding-toolbar\"><div class=\"col-xs-6 col-sm-3 col-md-2 col-2 col-lg-2 card card-1\" ng-repeat=\"f in font\"><div class=\"padder-v item\" style=\"text-align: center\"><div class=\"h1 text-info font-thin\"><i class=\"{{f.icon}}\"></i></div><span class=\"text-muted\">{{f.icon}}</span></div></div></div>");
$templateCache.put("theme/jasper/jasper.html","<six-toolbar ng-if=\"showHistory\"><six-toolbar-item ng-repeat=\"item in functionHistory track by $index\" ng-if=\"item.label\" label=\"{{ item.label }}\" icon=\"fa fa-window-restore text-primary\" toolbar-function=\"changeRoute(item)\"></six-toolbar-item></six-toolbar><div><iframe id=\"jasperFrame\" ng-src=\"{{ getExtURL() | trustAsResourceUrl }}\" width=\"100%\" height=\"1000\" frameborder=\"0\"></iframe></div><div ng-repeat=\"item in extern\" ng-hide=\"true\"><a ng-href=\"{{ item.route.indexOf(\'http:\')==0? item.route:\'#/\' + item.route }}\" id=\"{{item.id}}\"></a></div>");
$templateCache.put("theme/jsf/jsf.html","<script type=\"text/javascript\">\n\n    $(function () {\n        $(window).scroll(function () {\n            var docElement = $(document)[0].documentElement;\n            var winElement = $(window)[0];\n\n            if ((docElement.scrollHeight - winElement.innerHeight) == winElement.pageYOffset) {\n                var frame = $(\"#jsfFrame\")\n                frame.height(frame.height() + 100);\n            }\n        });\n    });\n\n    function resizeIframe(iframe) {\n        //prima facevo così (non funziona in caso di reload tra una jsf e l\'altra, se la prima è molto lunga e la seconda no, non fa resize e resta lunga\n        var iframeContentHeight = iframe.contentWindow.document.body.scrollHeight;\n        //questo sembra essere migliore:\n        var contentHeight = getContentHeight(iframe);\n        var windowHeight = jQuery(window).height();\n        //console.log(\"frame height: \"+iframeContentHeight+\" window height: \"+windowHeight+ \" content: \"+contentHeight);\n        var resizedHeight = iframeContentHeight > windowHeight ? iframeContentHeight : windowHeight;\n        if (contentHeight != undefined && resizedHeight > contentHeight) {\n            resizedHeight = contentHeight > windowHeight ? contentHeight : windowHeight; //sfrutto tutta la finestra, altrimenti con pannelli collapsible rischio la doppia scrollbar\n        }\n        iframe.height = resizedHeight + \"px\";\n    }\n\n    function getContentHeight(iframe) {\n        var x = iframe.contentWindow.document.getElementsByClassName(\'template-content\');\n        var contentHeight = null;\n        for (var i = 0; i < x.length; i++) {\n            contentHeight = jQuery(x[i]).height();\n        }\n        return contentHeight;\n    }\n\n    function getContentWidth(iframe) {\n        var x = iframe.contentWindow.document.getElementsByClassName(\'template-content\');\n        var contentWidth = null;\n        for (var i = 0; i < x.length; i++) {\n            contentWidth = jQuery(x[i]).width();\n        }\n        return contentWidth;\n    }\n\n    function getSixPage(url) {\n        var tokens = url.split(\'/\');\n        if (tokens.length > 0) {\n            var lastToken = tokens[tokens.length - 1];\n            tokens = lastToken.split(\'?\');\n            if (tokens[0]) {\n                console.log(\'>>>>>> \' + tokens[0]);\n            }\n        }\n    };\n\n    function analizeUrl(iframe) {\n        var url = iframe.contentWindow.location.href;\n        if (url.indexOf(\'menuTouch.jsf\') != -1 || url.indexOf(\'menuTouch.xhtml\') != -1) {\n            window.location.href = window.location.origin + \'#/bookmarks\';\n        }\n        getSixPage(url);\n    }\n\n</script><style>\n    .paddingToolbar {\n        padding-top: 49px !important;\n    }\n</style><six-toolbar ng-if=\"getShowJsfToolbar()\"><six-toolbar-item ng-repeat=\"item in functionHistory track by $index\" ng-if=\"item.label\" label=\"{{ item.label }}\" icon=\"fa fa-window-restore text-primary\" toolbar-function=\"changeRoute(item)\"></six-toolbar-item></six-toolbar><div ng-class=\"{\'paddingToolbar\': getShowJsfToolbar()}\"><iframe id=\"jsfFrame\" ng-src=\"{{ getJsfURL() | trustAsResourceUrl }}\" onload=\"if (typeof(resizeIframe) == \'function\'){resizeIframe(this);analizeUrl(this)}\" width=\"99%\" height=\"800\" scrolling=\"no\" frameborder=\"0\"></iframe></div>");
$templateCache.put("theme/landing/landing.html","");
$templateCache.put("theme/login/fakelogin.html","<div class=\"col-md-12 pad-t-15\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Login utente</h1><small class=\"text-muted\">seleziona un utente</small></div></div></div><div class=\"panel-body\"><div class=\"form-group\"><input ng-keyup=\"searchUsers()\" class=\"form-control\" type=\"text\" ng-model=\"searchString\" placeholder=\"Scrivere qui per filtrare la lista...\"></div><table id=\"userList\" class=\"table table-striped\"><thead><tr><th></th><th>Username</th><th>Ruolo</th></tr></thead><tbody><tr ng-repeat=\"item in profiles\"><td><a ng-click=\"login(item)\" class=\"btn-sm btn-default\" id=\"btn_changeUser\"><span class=\"fa fa-play-circle icon text\"></span></a></td><td>{{ item.user}}</td><td>{{ item.role }}</td></tr><tr ng-hide=\"profiles.length\"><td><p class=\"text-center\">No Data Found</p></td></tr></tbody></table></div></div></div>");
$templateCache.put("theme/login/login.html","<div><section id=\"content-login\" class=\"content-block-nopad content-login login-container\"><div class=\"image-container col-sm-7 col-xs-12 pull-right\"><div class=\"background-image-holder\" style=\"-webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover; background-size: cover; background-image: -webkit-linear-gradient(rgba(58,87,114,0.85), rgba(53,187,213,0.85)),url(bg_login.jpg); background-image: linear-gradient(rgba(58,87,114,0.85), rgba(24,46,65,0.85)),url(bg_login.jpg); background-size: cover; background-position: center center;\"></div></div><div class=\"container-fluid ng-scope\"><div class=\"row\"><div class=\"col-sm-5 col-xs-12 content pull-left\"><div class=\"col-md-8 col-md-offset-2\"><div ng-repeat=\"profile in getProfiles()\" ng-if=\"getProfiles()[0].items.length>1\"><div class=\"login clearfix\"><div class=\"panel-heading no-border bg-dark\"><span class=\"text-lt\">{{profile.description}}</span></div><div class=\"hbox text-center b-b b-light text-sm\"><a href=\"\" class=\"col padder-v text-muted b-r b-light\" ng-repeat=\"subprofile in profile.items\" ng-click=\"switchProfile(profile, subprofile)\"><i class=\"icon-pointer block m-b-xs fa-2x\"></i> <span>{{subprofile.description}}</span></a></div></div></div><div class=\"loginPanel\"><div ng-if=\"!getProfiles().length\"><div class=\"login\"><div class=\"client-image\"><img src=\"logo_w.png\" alt=\"Logo\" class=\"img-responsive\"></div><div class=\"clearfix\"></div><br><form name=\"form\" class=\"form-validation ng-pristine ng-valid-email ng-invalid ng-invalid-required\" ng-submit=\"login(user)\"><div class=\"form-group\"><input id=\"username\" type=\"text\" placeholder=\"username\" class=\"form-control ng-pristine ng-invalid ng-invalid-required ng-touched\" ng-model=\"user.username\" required=\"\" tabindex=\"1\" aria-required=\"true\" aria-invalid=\"true\"></div><div class=\"form-group\"><input type=\"password\" placeholder=\"password\" class=\"form-control ng-pristine ng-untouched ng-invalid\" ng-model=\"user.password\" tabindex=\"2\" aria-required=\"false\" aria-invalid=\"true\"></div><div class=\"form-group\" id=\"loginLookup\"><div class=\"input-group\" style=\"width: 100%\"><ui-select ng-model=\"selected.company\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"true\" ng-disabled=\"companies.length<2\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una società...\">{{$select.selected.description}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in companies\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><button type=\"submit\" class=\"btn btn-lg btn-login btn-block\" ng-disabled=\"form.$invalid || !selected.company.code|| !user.password\" tabindex=\"0\" aria-disabled=\"true\" disabled=\"disabled\">Log in</button> <button type=\"submit\" class=\"btn btn-lg btn-login btn-block\" ng-disabled=\"!selected.company.code || !user.username\" tabindex=\"0\" aria-disabled=\"true\" disabled=\"disabled\">barcode</button><div class=\"clearfix\"></div><br><div class=\"form-group touch-line\" style=\"width:50%;float:left;\"><label class=\"touch\"><input ng-change=\"changeTouch()\" type=\"checkbox\" placeholder=\"touch\" class=\"cb cb1 ng-pristine ng-untouched ng-invalid ng-invalid-required\" ng-model=\"touch\" tabindex=\"2\" aria-required=\"true\" aria-invalid=\"true\" ng-value=\"touch\"> <i></i></label><p>Touch</p></div><div class=\"form-group\" style=\"width:50%;float:left;padding-top: 4px;\"><i class=\"fa fa-desktop\" ng-style=\"{{workstation.error ? \'color:red\':\'\'}}\" title=\"{{workstation.error}}\" ng-click=\"wsClick()\"></i> <input ng-if=\"workstation.editing\" type=\"text\" placeholder=\"workstation\" class=\"no-border\" style=\"padding:2px; box-shadow: inset 0 0 8px rgba(0,0,0,0.5);\" ng-model=\"workstation.code\" ng-blur=\"wsClick()\"> <span ng-if=\"!workstation.editing && !workstation.error\">{{workstation.code}}</span> <span ng-if=\"!workstation.editing && workstation.error\"><i class=\"fa fa-warning\"></i>{{workstation.error}}</span></div></form><div class=\"clearfix\"></div><div class=\"text-danger\"><div ng-show=\"errors\" class=\"animated flash alert alert-danger\">Autenticazione fallita</div></div><div class=\"clearfix\"></div><div class=\"clearfix\" ng-if=\"isEggs\"><button class=\"btn btn-sm btn-info\" ng-click=\"gotoPassword()\">Cambio Password</button></div></div></div></div><div class=\"clearfix\"></div><div class=\"brand\"><a href=\"http://www.ict-group.it\"><img src=\"ict_small-white.png\" alt=\"ICT\"></a></div><iframe style=\"visibility: hidden\" id=\"logoutFrame\" ng-controller=\"JsfCtrl\" ng-src=\"{{ getLogoutUrl() | trustAsResourceUrl }}\" width=\"1px\" height=\"1px\" frameborder=\"0\"></iframe></div></div></div></div></section></div>");
$templateCache.put("theme/message/message.html","<div class=\"row\" style=\"margin:100px 100px\"><div class=\"col\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Broadcast Message</h3></div><div class=\"panel-body\"><div class=\"col-md-2\"><label for=\"multi_p\" style=\"font-weight: bold; font-size:14px\">Canale</label><div class=\"form-check\"><input id=\"defaultCheck1\" class=\"form-check-input\" type=\"checkbox\" ng-model=\"selection.selectAll\" disabled=\"\"> <label class=\"form-check-label\" for=\"defaultCheck1\">Seleziona Tutti</label></div></div><div class=\"col-md-4\"><label style=\"font-weight: bold; font-size:14px\">Tipo Messaggio</label><select class=\"form-control\" ng-model=\"selection.level\"><option value=\"normal\">Normal</option><option value=\"info\">Info</option><option value=\"success\">Success</option><option value=\"warning\">Warning</option></select></div><div class=\"col-md-6\"><label style=\"font-weight: bold; font-size:14px\">Messaggio</label> <textarea id=\"text-msg\" oninput=\'this.style.height = this.textLength > 0 ? this.scrollHeight+\"px\" : this.style.minHeight\' style=\"resize:vertical; height:32px; min-height:32px; overflow: hidden\" type=\"text\" class=\"form-control\" placeholder=\"Messaggio\" ng-model=\"selection.message\"></textarea><div><button style=\"margin-top: 15px; float:right\" type=\"button\" class=\"btn btn-primary\" ng-click=\"broadcast()\" title=\"Cerca\">Invia</button></div></div></div></div></div></div><div ng-repeat=\"(key, value) in data\">{{key}} {{value}}</div>");
$templateCache.put("theme/modeltype/detail_array.html","<div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-2\">{{value.items.type}}</div><div class=\"col-md-2\">NOME TABELLA:</div><div class=\"col-md-2\"><input class=\"override-full-width\" type=\"text\" ng-model=\"value.entity_id\" ng-keyup=\"refreshLookup(key, value.entity_id)\"></div></div><div class=\"col-md-12\"><div class=\"col-md-2\">VALORI DEFINITI:</div><div class=\"col-md-10 pnl-margin-l-r\" ng-if=\"value.items.type != \'lookup\'\"><div ng-if=\"value.items.format == \'date\'\"><input type=\"{{itemTypeMap[key]}}\" size=\"46\" ng-model=\"newItem.name\" placeholder=\"formato data: aaaa-mm-gg\"> <button ng-click=\"addItemOnArray(key, newItem)\" class=\"btn btn-success btn-xs btn-default equal-margin-left-right\"><i class=\"fa fa-plus\"></i></button></div><div ng-if=\"value.items.format != \'date\'\"><input type=\"{{itemTypeMap[key]}}\" size=\"46\" ng-model=\"newItem.name\"> <button ng-click=\"addItemOnArray(key, newItem)\" class=\"btn btn-success btn-xs btn-default equal-margin-left-right\"><i class=\"fa fa-plus\"></i></button></div></div><div class=\"col-md-10 col-md-offset-2 pnl-margin-l-r\" ng-if=\"value.items.type != \'lookup\'\"><div class=\"col-md-12 no-pad-l-r pnl-margin-l-r\" ng-repeat=\"itemArray in uiselectMap[key] track by $index\" ng-if=\"itemArray.name != \'\'\"><input type=\"text\" size=\"46\" name=\"item_name\" ng-model=\"itemArray.name\" disabled=\"\"> <button ng-click=\"deleteItemOnArray(key,itemArray)\" class=\"btn btn-danger btn-xs btn-default equal-margin-left-right\"><i class=\"fa fa-minus\"></i></button></div></div><div class=\"col-md-10 pnl-margin-l-r\" ng-if=\"value.items.type == \'lookup\'\"><div class=\"col-md-3 col-md-3-adapted no-pad-l-r\"><six-lookup ng-model=\"newItemArray\" sx-type=\"value.entity_id\" sx-field=\"\'record_id\'\"></six-lookup></div><button ng-click=\"addRefOnArray(key, newItemArray)\" class=\"btn btn-success btn-xs btn-default equal-margin-left-right\"><i class=\"fa fa-plus\"></i></button></div><div class=\"col-md-10 col-md-offset-2 pnl-margin-l-r\" ng-if=\"value.items.type == \'lookup\'\"><div class=\"col-md-12 no-pad-l-r pnl-margin-l-r\" ng-repeat=\"itemArray in uiselectMap[key] track by $index\" ng-if=\"itemArray.name != \'\'\"><input type=\"text\" size=\"46\" name=\"item_name\" ng-model=\"itemArray.name\" disabled=\"\"> <button ng-click=\"deleteItemOnArray(key,itemArray)\" class=\"btn btn-danger btn-xs btn-default equal-margin-left-right\"><i class=\"fa fa-minus\"></i></button></div></div></div>");
$templateCache.put("theme/modeltype/detail_date.html","<div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-10\">{{value.format}}</div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">PROPAGA VALORE:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableCopyTo\" ng-change=\"refreshCopyToCheckbox(key, value.enableCopyTo)\"></div></div><div class=\"col-md-12\" ng-if=\"value.enableCopyTo == true\"><div class=\"col-md-2 uniform-height-2\">CAMPI DI DESTINAZIONE:</div><div class=\"col-md-10 uniform-height-2\"><input type=\"{{itemTypeMap[key]}}\" size=\"45\" name=\"new_item_name\" ng-model=\"newItem.name\"> <button ng-click=\"addItemCopyTo(key, newItem)\" class=\"btn btn-xs btn-info equal-margin-left-right\"><span class=\"fa fa-plus\"></span> Add</button></div><div class=\"col-md-10 col-md-offset-2\"><div class=\"col-md-12 override-padding-no-pad-left-right uniform-height-2\" ng-repeat=\"itemArray in value.copyTo track by $index\" ng-if=\"itemArray != \'\'\"><input type=\"text\" size=\"45\" name=\"item_name\" ng-model=\"itemArray\" disabled=\"\"> <button ng-click=\"deleteItemCopyTo(key,itemArray)\" class=\"btn btn-danger btn-xs btn-default equal-margin-left-right\"><i class=\"fa fa-trash\"></i></button></div></div></div>");
$templateCache.put("theme/modeltype/detail_enum.html","<div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-2\"><select class=\"form-control\" ng-model=\"value.format\" ng-change=\"refreshFormat(key,value.format)\"><option></option><option value=\"lookup\">lookup</option><option value=\"enum\">enum</option></select></div></div><div class=\"col-md-12\"><div class=\"col-md-2 uniform-height-2\">VALORI DEFINITI:</div><div class=\"col-md-10 uniform-height-2 pnl-margin-l-r\"><input type=\"{{itemTypeMap[key]}}\" size=\"45\" name=\"new_item_name\" ng-model=\"newItem.name\"> <button ng-click=\"addItemOnArray(key, newItem)\" class=\"btn btn-xs btn-success equal-margin-left-right\"><i class=\"fa fa-plus\"></i></button></div><div class=\"col-md-10 col-md-offset-2\"><div class=\"col-md-12 no-pad-l-r uniform-height-2 pnl-margin-l-r\" ng-repeat=\"itemArray in uiselectMap[key] track by $index\" ng-if=\"itemArray.name != \'\'\"><input type=\"text\" size=\"45\" name=\"item_name\" ng-model=\"itemArray.name\" disabled=\"\"> <button ng-click=\"deleteItemOnArray(key,itemArray)\" class=\"btn btn-danger btn-xs btn-default equal-margin-left-right\"><i class=\"fa fa-minus\"></i></button></div></div></div>");
$templateCache.put("theme/modeltype/detail_formula.html","<div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FORMULA:</div><div class=\"col-md-2\"><select class=\"col-md-12\" ng-model=\"value.formula_id\" ng-change=\"refreshFormula(key, value.formula_id)\"><option ng-repeat=\"formula in formulaList\" ng-value=\"formula.code\" ng-selected=\"value.formula_id === formula.code\">{{formula.description}}</option></select></div><div class=\"col-md-2\">PARAEMTRI FORMULA:</div><div class=\"col-md-6\"><input class=\"override-full-width\" type=\"text\" ng-model=\"value.formula_params\" placeholder=\"esempio: potere_calorifico_sup\" ng-keyup=\"refreshFormulaParams(key, value.formula_params)\"></div></div>");
$templateCache.put("theme/modeltype/detail_inherit.html","<div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-2\">Campo Ereditato</div><div class=\"col-md-2\">CAMPO RIF. PADRE:</div><div class=\"col-md-2\"><input class=\"override-full-width\" type=\"text\" placeholder=\"esempio: model.remi...\" ng-model=\"value.record\" ng-keyup=\"refreshInheritRecord(key, value.record)\"></div><div class=\"col-md-2\">ATTRIBUTO DA EREDITARE:</div><div class=\"col-md-2\"><input class=\"override-full-width\" type=\"text\" placeholder=\"esempio: model.potere_calorifico_sup...\" ng-model=\"value.field\" ng-keyup=\"refreshInheritField(key, value.field)\"></div></div>");
$templateCache.put("theme/modeltype/detail_lookup.html","<div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-2\"><select class=\"form-control\" ng-model=\"value.format\" ng-change=\"refreshFormat(key,value.format)\"><option></option><option value=\"lookup\">lookup</option><option value=\"enum\">enum</option></select></div></div><div class=\"col-md-12 bd-callout\" style=\"margin: 5px 0\" ng-if=\"value.format===\'lookup\'\"><div class=\"header-sm\">LOOKUP</div><div class=\"row\"><div class=\"col-md-2\">NOME TABELLA:</div><div class=\"col-md-2\"><input class=\"override-full-width\" type=\"text\" ng-model=\"value.entity_id\" ng-keyup=\"refreshLookup(key, value.entity_id)\"></div><div class=\"col-md-2\">CODICE:</div><div class=\"col-md-2\"><input class=\"override-full-width\" type=\"text\" ng-model=\"value.mapping.code\" ng-keyup=\"refreshLookupCode(key, value.mapping.code)\"></div><div class=\"col-md-2\">DESCRIZIONE:</div><div class=\"col-md-2\"><input class=\"override-full-width\" type=\"text\" ng-model=\"value.mapping.description\" ng-keyup=\"refreshLookupDescr(key, value.mapping.description)\"></div></div></div><div class=\"col-md-12 bd-callout\" style=\"margin: 5px 0\" ng-if=\"value.format===\'lookup\'\"><div class=\"header-sm\">LOOKUP CONDIZIONATA</div><div class=\"row\"><div class=\"col-md-2\">FILTRATO:</div><div class=\"col-md-2\"><input type=\"checkbox\" ng-model=\"value.filtered\" ng-click=\"refreshFiltered(key, value.filtered)\"></div><div class=\"col-md-2\">VALORE SORGENTE:</div><div class=\"col-md-2\"><input class=\"override-full-width\" type=\"text\" placeholder=\"esempio: regione_id...\" ng-model=\"value.filterSourceField\" ng-keyup=\"refreshFilterSourceField(key, value.filterSourceField)\"><div class=\"row col-md-12\">Es.: attributo <span class=\"font-italic\">regione_id</span> di questo modello</div></div><div class=\"col-md-2\">CHIAVE MODELLO DEST.:</div><div class=\"col-md-2\"><input class=\"override-full-width\" type=\"text\" placeholder=\"esempio: model.regione_id...\" ng-model=\"value.filterDestField\" ng-keyup=\"refreshFilterDestField(key, value.filterDestField)\"><div class=\"row col-md-12\">Es.: attributo <span class=\"font-italic\">regione_id</span> del modello <span class=\"font-italic\">provincia</span></div></div></div></div>");
$templateCache.put("theme/modeltype/modeltype_detail.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"{{\'modeltype.generate\' | translate}}\" btn-class=\"btn-primary\" icon=\"fa fa-gear\" toolbar-function=\"generateForm()\" sx-disabled=\"!code\"></six-toolbar-button><six-toolbar-button label=\"{{\'save\' | translate}}\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\" ng-show=\"type.selected.model.code\"><h1 class=\"m-n font-thin h3 text-black\">{{type.selected.model.description}}</h1><small class=\"text-muted\">{{type.selected.model.code}}</small></div><div class=\"col-sm-6 col-xs-12\" ng-hide=\"type.selected.model.code\"><h1 class=\"m-n font-thin h3 text-black\">Modelli</h1><small class=\"text-muted\">Nuovo modello</small></div></div></div><div class=\"panel wrapper\"><div class=\"panel-heading\"><div class=\"page-header-bleed-right\"><div class=\"actions\"><div class=\"row\"><form name=\"header\"><div class=\"form-group\"><label id=\"schema_id_key\" for=\"code\" class=\"col-md-1 control-label\">Tabella</label><div class=\"col-md-12\"><input type=\"text\" class=\"form-control\" id=\"code\" placeholder=\"\" ng-model=\"code\" name=\"code\" required=\"\" ng-disabled=\"!modifyTable\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.code.$error.required\">Obbligatorio</span></div></div></div><div class=\"form-group\"><label id=\"schema_desc_key\" for=\"description\" class=\"col-md-1 control-label\">Descrizione</label><div class=\"col-md-12\"><input type=\"text\" class=\"form-control\" id=\"description\" placeholder=\"\" ng-model=\"description\" name=\"description\" ng-keyup=\"refreshDescription(description)\" required=\"\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.description.$error.required\">Obbligatorio</span></div></div></div><div class=\"form-group\"><div class=\"col-md-2 m-t-sm\"><div class=\"checkbox\"><label class=\"i-checks\"><input type=\"checkbox\" ng-model=\"customDetailPath\"><i></i> Percorso al dettaglio</label></div></div><div class=\"col-md-10 m-t-md\"><input type=\"text\" ng-if=\"customDetailPath\" class=\"form-control\" id=\"detailPath\" ng-keyup=\"refreshDetailPath(type.selected.model.detailPath)\" placeholder=\"Ad esempio: record/detail/entity\" ng-model=\"type.selected.model.detailPath\" name=\"detailPath\"></div></div><div class=\"form-group\"><div class=\"col-md-12\"><div class=\"checkbox\" style=\"margin-top:5px;\"><label class=\"i-checks\"><input type=\"checkbox\" ng-model=\"showStdPanel\"><i></i> Mostra pannello campi standard</label></div></div></div><div class=\"form-group\"><div class=\"col-md-4\"><div class=\"checkbox\" style=\"margin-top:5px;\"><label class=\"i-checks\"><input type=\"checkbox\" ng-model=\"ignoreAzcod\"><i></i> Non filtrare per azcod</label></div></div><div class=\"col-md-4\"><div class=\"checkbox\" style=\"margin-top:5px;\"><label class=\"i-checks\"><input type=\"checkbox\" ng-model=\"ignoreDivcod\"><i></i> Non filtrare per divcod</label></div></div><div class=\"col-md-4\"><div class=\"checkbox\" style=\"margin-top:5px;\"><label class=\"i-checks\"><input type=\"checkbox\" ng-model=\"translate\"><i></i> Abilita traduzione</label></div></div><div class=\"col-md-4\"><six-lookup ng-model=\"lookup.function_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"lookup.obj.id\" sx-type=\"\'funzioni\'\" sx-placeholder=\"Seleziona funzione...\" sx-relational=\"true\" sx-sort-fields=\"[\'descrizione\']\" sx-database=\"\'eggs\'\" sx-hide-code=\"true\" ng-if=\"database===\'eggs\'\"></six-lookup><six-lookup ng-model=\"lookup.function_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"lookup.obj.id\" sx-type=\"\'functions\'\" sx-placeholder=\"Seleziona funzione...\" sx-relational=\"true\" sx-sort-fields=\"[\'codice\']\" sx-database=\"\'six\'\" ng-if=\"database===\'six\'\"></six-lookup></div></div><div class=\"col-md-3\"><div class=\"checkbox\" style=\"margin-top:5px;\"><label class=\"i-checks\"><input type=\"checkbox\" ng-model=\"modifyTable\"><i></i> Modifica nome tabella</label></div></div><div class=\"col-md-3\"><div class=\"checkbox\" style=\"margin-top:5px;\"><label class=\"i-checks\"><input type=\"checkbox\" ng-change=\"setReadOnly()\" ng-model=\"readOnly\"><i></i>Dettaglio sola lettura</label></div></div></form></div></div></div></div><div class=\"panel-body\"><uib-tabset justified=\"true\"><uib-tab heading=\"Preview\"><form name=\"myForm\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"model\" ng-submit=\"onSubmit(myForm)\"></form></uib-tab><uib-tab heading=\"Schema\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><div class=\"col-md-12 centered\"><b>SCHEMA</b></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><b>CODICE</b></div><div class=\"col-md-3\"><b>DESCRIZIONE</b></div><div class=\"col-md-1\"><b>TIPOLOGIA</b></div><div class=\"col-md-2\"><b>FORMATO</b></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><form name=\"propertyKeyForm\"><input class=\"form-control\" name=\"property_key\" placeholder=\"Codice...\" type=\"text\" ng-model=\"property.key\" pattern=\"^[a-zA-Z]+[\\w]*$\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"propertyKeyForm.property_key.$error.pattern\">Caratteri non consentiti</span></div></form></div></div><div class=\"col-md-3\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><input class=\"form-control\" placeholder=\"Descrizione\" type=\"text\" ng-model=\"property.title\"></div></div><div class=\"col-md-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.type\"><option></option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"boolean\">boolean</option><option value=\"date\">date</option><option value=\"array\">array</option></select></div></div><div class=\"col-md-2\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'string\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'number\' || property.type == \'integer\')\"><option></option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.items_type\" ng-if=\"(property.type == \'array\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"date\">date</option></select></div></div><div class=\"col-md-2\"><div ng-if=\"isInheritable(property.type)\"><label><input type=\"checkbox\" ng-model=\"property.inherited\"> Campo ereditato</label></div></div><div class=\"col-md-1\"><button ng-click=\"addProperty()\" class=\"btn btn-sm btn-info pull-right\"><span class=\"fa fa-plus\"></span> Add</button></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-repeat=\"(key, value) in type.selected.model.schema.properties\" style=\"align-content: center; padding-bottom: 0px;\"><div class=\"col-md-12 uniform-height\" style=\"align-content: center;\"><div class=\"col-md-1\"><a href=\"\" ng-click=\"status[key].open = !status[key].open\" id=\"btn_row_detail\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status[key].open, \'glyphicon-chevron-right\': !status[key].open}\"></i></a></div><div class=\"col-md-2\">{{ key }}</div><div class=\"col-md-3\">{{ value.title }}</div><div class=\"col-md-1\">{{ value.type }}</div><div class=\"col-md-2\"><span ng-if=\"value.format\">{{value.format}}</span> <span ng-if=\"value.type == \'array\' && value.items\">{{value.items.format}}</span></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"status[key].open\"><div class=\"col-md-12 uniform-height-2\" ng-if=\"value.format !== \'lookup\' && value.format !== \'formula\' && value.format !== \'enum\' && value.format !== \'inherit\' && value.type !== \'array\'\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-2\"><select class=\"form-control\" ng-model=\"value.format\" ng-change=\"refreshFormat(key,value.format)\" ng-if=\"(value.type == \'number\' || value.type == \'string\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"enum\">enum</option></select></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'inherit\'\" ng-include=\"\'theme/modeltype/detail_inherit.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'lookup\' && value.type != \'array\'\" ng-include=\"\'theme/modeltype/detail_lookup.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'formula\'\" ng-include=\"\'theme/modeltype/detail_formula.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'enum\'\" ng-include=\"\'theme/modeltype/detail_enum.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.type === \'array\'\" ng-include=\"\'theme/modeltype/detail_array.html\'\"></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ELIMINA:</div><div class=\"col-md-10\"><button ng-click=\"deleteProperty(key)\" class=\"btn btn-danger btn-xs btn-default\" ng-disabled=\"(key === \'code\' || key === \'description\')\"><i class=\"fa fa-trash\"></i></button></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">IN TABELLA:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.check\" ng-change=\"changeColumnDefs(key, value)\" ng-disabled=\"(key === \'code\' || key === \'description\')\"></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"value.check == true\"><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">LARGHEZZA (px):</div><div class=\"col-md-10\"><input type=\"text\" min=\"1\" step=\"1\" size=\"45\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"value.width\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ORDINAMENTO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableSorting\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FILTRAGGIO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableFiltering\" ng-change=\"changeColumnDefs(key, value)\"></div></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">DEFAULT:</div><div class=\"col-md-10\"><input type=\"{{type.selected.model.schema.properties[key].type == \'number\' || type.selected.model.schema.properties[key].type == \'integer\' ? \'number\' : \'text\'}}\" ng-model=\"value._default\" ng-change=\"setDefault(key, value)\"></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div></div></div></div></uib-tab><uib-tab heading=\"Form\"><table class=\"table table-striped\"><tr><td colspan=\"2\">Nuovo tab:</td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newTab.title\"></td><td><button ng-click=\"addTab(type.selected.model.form[0].items[0])\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th></th><th>POSIZIONE</th><th>TITOLO</th><th></th></tr><tbody><tr ng-repeat-start=\"(key, tab) in type.selected.model.form[0].items[0].tabs\"><td><a href=\"\" ng-click=\"statusForm[key].open = !statusForm[key].open\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': statusForm[key].open, \'glyphicon-chevron-right\': !statusForm[key].open}\"></i></a></td><td><span class=\"btn btn-sm\" ng-click=\"swapUp(key, type.selected.model.form[0].items[0].tabs)\" ng-disabled=\"key<=0\"><i class=\"fa fa-caret-up\"></i></span> {{key+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(key, type.selected.model.form[0].items[0].tabs)\" ng-disabled=\"key>=type.selected.model.form[0].items[0].tabs.length-1\"><i class=\"fa fa-caret-down\"></i></span></td><td><input type=\"text\" ng-model=\"tab.title\" ng-disabled=\"(tab.key[0] == \'code\' || tab.key[0] == \'description\')\" ng-keyup=\"updateScope()\"></td><td><a ng-click=\"removeTabOrField(key, type.selected.model.form[0].items[0].tabs)\" class=\"btn btn-danger btn-xs btn-default\" id=\"btn_row_detail_form\"><i class=\"fa fa-trash\"></i></a></td></tr><tr ng-repeat-end=\"\" ng-show=\"statusForm[key].open\"><td></td><td colspan=\"3\" style=\"background-color:rgba(211, 211, 211, 0.38);\"><table class=\"table table-striped override-margin\"><tr><td></td><td><select ng-options=\"k as v.title for (k, v) in schema.properties\" ng-model=\"newFieldForm.key\"></select></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newFieldForm.title\"></td><td><input type=\"checkbox\" placeholder=\"Richiesto...\" ng-model=\"newFieldForm.required\"></td><td><select ng-model=\"newFieldForm.type\" ng-change=\"updateScope()\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"timepicker\">time</option><option value=\"datetimepicker\">datetime</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"eggscheckbox\">eggscheckbox</option><option value=\"uiselect\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><button ng-click=\"addFieldToTab(tab)\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th>POSIZIONE</th><th>CAMPO</th><th>TITOLO</th><th>REQUIRED</th><th>TIPO</th><th></th></tr><tr ng-repeat=\"(fieldKey, field) in tab.items\"><td class=\"override-width-200px\"><div><span class=\"btn btn-sm\" ng-click=\"swapUp(fieldKey, tab.items)\" ng-disabled=\"fieldKey<=0\"><i class=\"fa fa-caret-up\"></i></span> {{fieldKey+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(fieldKey, tab.items)\" ng-disabled=\"fieldKey>=tab.items.length-1\"><i class=\"fa fa-caret-down\"></i></span></div></td><td ng-if=\"!field.title\">{{field}}</td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"field.title\">{{field.key[0]}}</td><td ng-if=\"field.title\"><input type=\"text\" ng-model=\"field.title\" ng-keyup=\"updateTitle(field)\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.required\" ng-change=\"updateRequiredField(field)\"></td><td ng-if=\"field.title\"><select ng-model=\"field.type\" ng-change=\"updateField(field)\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"timepicker\">time</option><option value=\"datetimepicker\">datetime</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"eggscheckbox\">eggscheckbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><a ng-click=\"removeTabOrField(fieldKey, tab.items)\" class=\"btn btn-danger btn-xs btn-default\"><i class=\"fa fa-trash\"></i></a></td></tr></table></td></tr></tbody></table></uib-tab></uib-tabset></div><div class=\"panel-footer\"><div class=\"form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-change=\"debug()\" ng-model=\"jsonshow\" data-toggle=\"collapse\" data-target=\"#json-collapse\" class=\"pull-left\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div></div></div><div class=\"row collapse\" id=\"json-collapse\"><div class=\"col-md-8\"><div class=\"panel-heading wrapper b-b b-light\"><h4 class=\"font-thin m-t-none m-b-none text-muted\">Dettaglio</h4></div><div id=\"myModel\" style=\"margin-top:0px;\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'json\', firstLineNumber: 1, onLoad: aceLoaded, onChange: aceChanged }\" ng-model=\"aceModel\"></div><div class=\"panel-footer\"></div></div><div class=\"col-md-4\"><div class=\"list-group list-group-lg list-group-sp row\"><pre>{{ type.selected.model }}</pre></div><div class=\"row\" ngclipboard=\"\" data-clipboard-target=\"#toBeTranslated\"><pre ng-click=\"getTranslation()\" id=\"toBeTranslated\">{{toBeTranslated | json}}</pre></div><div class=\"row\" ngclipboard=\"\" data-clipboard-target=\"#aaa\"><pre id=\"aaa\">{{type.selected.model | json}}</pre></div></div></div></div></div>");
$templateCache.put("theme/modeltype/modeltype_list.html","<six-toolbar><six-toolbar-button label=\"Genera tutti\" icon=\"fa fa-gear\" btn-class=\"btn-primary\" toolbar-function=\"generateAll()\"></six-toolbar-button><six-toolbar-button label=\"Nuovo\" icon=\"fa fa-plus\" btn-class=\"btn-info\" toolbar-function=\"newModel()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">MODELLI TABELLE</h1><small class=\"text-muted\">Lista</small></div></div></div><div class=\"panel-body\"><div class=\"row\" ng-if=\"generating && (progress.total!==progress.loaded)\"><div class=\"col col-md-12\"><div class=\"active m-b-sm progress ng-isolate-scope\" value=\"dynamic\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"progress-bar-info\" role=\"progressbar\" ng-style=\"{ \'width\': progress.perc + \'%\' }\"><div class=\"progress-bar progress-bar-info\" ng-class=\"progress-bar-info\" role=\"progressbar\" ng-style=\"{ \'width\': progress.perc + \'%\' }\">Avanzamento... [{{progress.perc }}%]</div></div></div></div></div><div id=\"gridList\" ui-grid=\"viewGridOptions\" class=\"grid\" ui-grid-resize-columns=\"\" ui-grid-auto-resize=\"\"></div></div></div></div>");
$templateCache.put("theme/notification/notification_detail.html","<style>\n    .btn-primary{\n        background-color: #7266ba;\n        border-color: #5a4daa;\n    }\n\n    .btn-primary:hover{\n        background-color: #6254b2;\n        border-color: #5a4daa;\n    }\n</style><six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Vai alla segnalazione\" btn-class=\"btn-primary-override\" icon=\"fa fa-search\" toolbar-function=\"goToIssue()\" ng-if=\"notification.model.record_id.index==ISSUE_INDEX\"></six-toolbar-button><six-toolbar-button label=\"Vai all\'odl\" btn-class=\"btn-warning\" icon=\"fa fa-search\" toolbar-function=\"goToOdl()\" ng-if=\"notification.model.record_id.index==ODL_INDEX\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Dettaglio notifica</h1></div></div></div><div class=\"panel-body\"><div class=\"wrapper b-b\"><h2 class=\"font-thin m-n ng-binding\">{{notification.model.subject}}</h2></div><div class=\"wrapper b-b ng-binding\"><img ng-hide=\"notification.user\" class=\"img-circle thumb-xs m-r-sm\" ng-src=\"/images/avatar_system.png\"> <img ng-show=\"notification.user\" class=\"img-circle thumb-xs m-r-sm\" ng-src=\"/images/avatar_emil.png\"> Segnalazione inviata da <strong ng-hide=\"notification.user\">System</strong><strong>{{notification.user}}</strong> relativa a <strong ng-show=\"!notification.model.type_notification\">/</strong> <strong ng-show=\"notification.model.type_notification\">{{notification.model.type_notification}}</strong> e con destinatari: <strong ng-show=\"!notification.model.to\">/</strong> <strong ng-show=\"notification.model.to\">{{notification.model.to}}</strong> del {{notification.dataIn | date:\"dd/MM/yyyy\"}}</div><div class=\"wrapper ng-binding\" ng-bind-html=\"notification.model.body\"></div></div></div></div>");
$templateCache.put("theme/notification/notification_list.html","<six-toolbar><six-toolbar-button label=\"Nuovo messaggio\" btn-class=\"btn-info\" icon=\"fa fa-envelope\" toolbar-function=\"goToWysiwyg()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Notifiche</h1></div></div></div><div class=\"panel-body\"><div class=\"legend\" ng-if=\"notifications\"><span class=\"text-xs text-muted pull-right\"><i class=\"fa fa-circle text-primary m-r-xs\"></i> segnalazioni <i class=\"fa fa-circle text-warning m-r-xs m-l-sm\"></i> odl <i class=\"fa fa-circle text-light m-r-xs m-l-sm\"></i> altro</span> <span style=\"clear:both\"></span></div><ul class=\"list-group list-group-lg no-radius m-b-none m-t-n-xxs\"><li ng-repeat=\"notification in notifications\" class=\"list-group-item clearfix b-l-3x ng-scope\" ng-class=\"notification.color\"><span class=\"avatar thumb pull-left m-r\"><img ng-hide=\"notification.user\" ng-src=\"/images/avatar_system.png\"> <img ng-show=\"notification.user\" ng-src=\"/images/avatar_emil.png\"></span><div class=\"pull-right text-sm text-muted\"><span class=\"hidden-xs ng-binding\">{{notification.dataIn | date:\"dd/MM/yyyy\"}}</span></div><div class=\"clear\"><div><a class=\"text-md ng-binding\" ng-href=\"{{notification.href}}\">{{notification.model.subject}}</a></div><div class=\"text-ellipsis m-t-xs ng-binding\">{{notification.model.bodyAsText}}</div></div></li></ul><div class=\"text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"data.totalResults\" ng-model=\"currentPage\" class=\"pagination-sm\" items-per-page=\"pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div></div></div>");
$templateCache.put("theme/password/password.html","<style>\n    .back-btn {\n        border-radius: 100%;\n        width: 40px;\n        height: 40px;\n        margin-top: 50px;\n    }\n</style><div class=\"row\" style=\"margin:0 100px;\"><div class=\"col\"><button class=\"btn btn-default back-btn\" style=\"border-color: transparent !important;\" ng-click=\"back()\"><i class=\"fa fa-chevron-left\"></i></button><div class=\"panel panel-default\" style=\"margin-top: 50px;\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Gestione Password</h3></div><div class=\"panel-body\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Username</label> <input tabindex=\"1\" type=\"text\" class=\"form-control\" ng-model=\"username\" placeholder=\"Username\"></div><div class=\"form-group\"><label>Nuova Password</label> <input tabindex=\"3\" type=\"password\" class=\"form-control\" placeholder=\"Nuova Password\" ng-model=\"newPsw\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Password</label> <input tabindex=\"2\" type=\"password\" class=\"form-control\" placeholder=\"Password\" ng-model=\"oldPsw\"></div><div class=\"form-group\"><label>Conferma Password</label> <input tabindex=\"4\" type=\"password\" class=\"form-control\" placeholder=\"Conferma Password\" ng-model=\"newPsw_2\"></div><div class=\"col-md-12\"><button tabindex=\"5\" style=\"float:right\" type=\"button\" class=\"btn btn-info\" ng-click=\"showModal()\">Modifica</button></div></div></div></div></div></div>");
$templateCache.put("theme/profile/profile.html","<div class=\"row\" style=\"margin:100px 100px\"><div class=\"col\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Gestione Password</h3></div><div class=\"panel-body\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Username</label> <input tabindex=\"1\" type=\"text\" class=\"form-control\" ng-value=\"username\" disabled=\"\"></div><div class=\"form-group\"><label>Nuova Password</label> <input tabindex=\"3\" type=\"password\" class=\"form-control\" placeholder=\"Nuova Password\" ng-model=\"newPsw\"></div><div class=\"col-md-12\" ng-show=\"showWarn\"><span class=\"fa fa-exclamation-triangle\" style=\"color:red\">Capslock Attivo!</span></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Password</label> <input tabindex=\"2\" type=\"password\" class=\"form-control\" placeholder=\"Password\" ng-model=\"oldPsw\"></div><div class=\"form-group\"><label>Conferma Password</label> <input tabindex=\"4\" type=\"password\" class=\"form-control\" placeholder=\"Conferma Password\" ng-model=\"newPsw_2\"></div><div class=\"col-md-12\"><button tabindex=\"5\" style=\"float:right\" type=\"button\" class=\"btn btn-default\" ng-click=\"showModal()\">Modifica</button></div></div></div></div></div></div><six-confirm-modal sx-title=\"modal.title\" sx-message=\"modal.message\" sx-on-confirm=\"modal.callback()\"></six-confirm-modal>");
$templateCache.put("theme/record/record_detail.html","<style>\n  .tab-content{\n    padding-top:10px;\n  }\n</style><six-toolbar><six-toolbar-button label=\"\" btn-class=\"btn-default\" icon=\"fa fa-angle-left\" toolbar-function=\"goToList()\"></six-toolbar-button><six-toolbar-button label=\"{{\'delete\' | translate}}\" ng-if=\"record.model.id\" btn-class=\"btn-danger\" icon=\"fa fa-times\" toolbar-function=\"deleteRecord()\" sx-disabled=\"readOnly\"></six-toolbar-button><six-toolbar-button label=\"{{\'save\' | translate}}\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveRecord()\" sx-disabled=\"readOnly\"></six-toolbar-button></six-toolbar><div class=\"override-padding-toolbar\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"pull-right\"><div class=\"pull-left\" ng-if=\"sf.schema.properties.attivo\"><six-checkbox sx-label=\"Attivo\" sx-model=\"record.model\" sx-field=\"attivo\" sx-class=\"\'m-t-sm\'\"></six-checkbox></div><div class=\"pull-left m-t-sm m-l-lg m-r-sm\" ng-if=\"sf.schema.properties.attivo && record.model.attivo===\'N\'\"><label class=\"control-label\">Valido fino al</label></div><div class=\"pull-left\" ng-if=\"sf.schema.properties.attivo && record.model.attivo===\'N\'\"><six-date-picker ng-model=\"record.model.valido\"></six-date-picker></div></div><h1 class=\"m-n font-thin\">{{ pageTitle }}</h1></div></div></div><div><div class=\"panel panel-default\"><div class=\"panel-body\"><form name=\"recordDetail\" id=\"recordDetail\" ng-submit=\"onSubmit(recordDetail)\"><input type=\"submit\" id=\"submitForm\" class=\"hidden\"><div ng-repeat=\"items in sf.form[0].items\"><uib-tabset class=\"tabs-left\" ng-class=\"{\'hidden-sf-tabs\': hideTabs}\"><uib-tab ng-repeat=\"tabs in items.tabs\"><uib-tab-heading>{{tabs.title}}</uib-tab-heading><div ng-repeat=\"model_items in tabs.items | notStdFilter:model_items\"><div ng-if=\"!(model_items.type == \'array\' || \'reporter_id\' == model_items.key[0])\" ng-init=\"iter = iter + 1\"><div class=\"form-group override-form-group col-md-6\" ng-if=\"(\'sixlookup\' !== model_items.type) && (\'datepicker\' !== model_items.type) && (\'textarea\' !== model_items.type) && (\'uiselect\' !== model_items.type) && (\'eggscheckbox\' !== model_items.type)\"><label class=\"control-label col-md-4 no-margin\" ng-class=\"{\'font-bold\': model_items.required}\">{{model_items.title}}</label><div class=\"col-md-8\"><div class=\"input-group\" style=\"width:100%\"><span class=\"input-group-addon\" id=\"sizing-addon-left\" ng-if=\"model_items.fieldAddonLeft\">{{model_items.fieldAddonLeft}}</span> <input class=\"sf-form-control form-control\" type=\"{{model_items.type}}\" step=\"any\" ng-model=\"record.model[model_items.key[0]]\" ng-required=\"model_items.required\" aria-describedby=\"sizing-addon\" ng-change=\"boolUpdate(model_items)\" ng-if=\"getInputType(model_items)!==\'textarea\'\" ng-readonly=\"model_items.key[0]===\'reserved_amount\'\"></div></div></div><div class=\"form-group override-form-group col-md-6\" ng-if=\"(\'textarea\' == model_items.type)\"><label class=\"control-label col-md-4 no-margin\" ng-class=\"{\'font-bold\': model_items.required}\">{{model_items.title}}</label><div class=\"input-group col-md-8\"><textarea class=\"sf-form-control form-control\" ng-model=\"record.model[model_items.key[0]]\" ng-required=\"model_items.required\" aria-describedby=\"sizing-addon\" ng-change=\"boolUpdate(model_items)\"></textarea></div></div><div class=\"form-group override-form-group col-md-6\" ng-if=\"\'sixlookup\' == model_items.type\"><label class=\"control-label col-md-4 no-margin\" ng-class=\"{\'font-bold\': model_items.required}\">{{model_items.title}}</label><six-lookup class=\"sf-form-control col-md-8\" sx-relational=\"true\" ng-model=\"record.lookup[model_items.key[0]]\" sx-field=\"\'obj\'\" sx-id=\"record.model[model_items.key[0]]\" sx-mapping=\"\'mapping\'\" sx-type=\"model_items.entity_id\" sx-required=\"model_items.required\" sx-required-id=\"{{model_items.key[0]}}\" sx-database=\"database\"></six-lookup></div><div class=\"form-group override-form-group col-md-6\" ng-if=\"\'uiselect\' == model_items.type\"><label class=\"control-label col-md-4 no-margin\" ng-class=\"{\'font-bold\': model_items.required}\">{{model_items.title}}</label><div class=\"col-md-8\"><six-enum ng-if=\"record.model\" sx-model=\"record.model\" sx-field=\"{{model_items.key[0]}}\" sx-options=\"model_items.titleMap\"></six-enum></div></div><div class=\"form-group override-form-group col-md-6\" ng-if=\"\'datepicker\' == model_items.type\"><label class=\"control-label col-md-4 no-margin\" ng-class=\"{\'font-bold\': model_items.required}\">{{model_items.title}}</label><div class=\"col-md-8\"><six-date-picker ng-model=\"record.model[model_items.key[0]]\"></six-date-picker></div></div><div class=\"form-group override-form-group col-md-6\" ng-if=\"\'eggscheckbox\' == model_items.type\"><label class=\"control-label col-md-4 no-margin\">{{model_items.title}}</label><div class=\"col-md-8\"><six-checkbox class=\"checkbox\" sx-model=\"record.model\" sx-field=\"{{model_items.key[0]}}\"></six-checkbox></div></div></div></div></uib-tab></uib-tabset></div><div ng-if=\"DATABASE==\'six\'\" ng-include=\"\'theme/record/std_panel_six.html\'\" class=\"hidden\"></div><div ng-if=\"DATABASE==\'eggs\'\" ng-include=\"\'theme/record/std_panel_eggs.html\'\" class=\"hidden\"></div></form></div></div><div ng-if=\"DATABASE==\'six\'\" ng-include=\"\'theme/record/std_panel_six.html\'\" class=\"panel panel-default\"></div><div ng-if=\"DATABASE==\'eggs\'\" ng-include=\"\'theme/record/std_panel_eggs.html\'\" class=\"panel panel-default\"></div></div></div><six-confirm-modal sx-title=\"modal.title\" sx-message=\"modal.message\" sx-on-confirm=\"modal.callback\"></six-confirm-modal>");
$templateCache.put("theme/record/record_list.html","<style>\n  .tab-content{\n    padding-top:10px;\n  }\n</style><six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"{{\'create\' | translate}}\" btn-class=\"btn-info\" icon=\"fa fa-plus\" toolbar-function=\"newRecord()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"m-n font-thin\">{{ pageTitle }}</h1></div></div></div><div class=\"panel panel-default\"><six-grid-pagination ng-if=\"sf\" get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"result\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("theme/record/std_panel_eggs.html","<div ng-hide=\"!showStdPanel\" class=\"panel-body\"><div class=\"row\"><div class=\"form-group col-md-3\"><label class=\"control-label\">Utente di inserimento</label><six-lookup class=\"sf-form-control\" sx-relational=\"true\" ng-model=\"record.lookup.utinsid\" sx-field=\"\'obj\'\" sx-id=\"record.model.utinsid\" sx-mapping=\"\'mapping\'\" sx-type=\"\'utenti\'\" sx-required=\"stdItems.utinsid.required\" sx-required-id=\"utinsid\" sx-disabled=\"true\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\">Data inserimento</label><six-date-picker ng-model=\"record.model.dtins\" sx-disabled=\"true\"></six-date-picker></div><div class=\"form-group col-md-3\" ng-if=\"record.model.id\"><label class=\"control-label\">Utente di modifica</label><six-lookup class=\"sf-form-control\" sx-relational=\"true\" ng-model=\"record.lookup.utvarid\" sx-field=\"\'obj\'\" sx-id=\"record.model.utvarid\" sx-mapping=\"\'mapping\'\" sx-type=\"\'utenti\'\" sx-required=\"stdItems.utvarid.required\" sx-required-id=\"utvarid\" sx-disabled=\"true\"></six-lookup></div><div class=\"col-md-3\" ng-if=\"record.model.id\"><label class=\"control-label\">Data ultima modifica</label><six-date-picker ng-model=\"record.model.dtvar\" sx-disabled=\"true\"></six-date-picker></div></div></div>");
$templateCache.put("theme/record/std_panel_six.html","<div ng-hide=\"!showStdPanel\" class=\"panel-body\"><div class=\"row\"><div class=\"form-group col-md-3\"><label class=\"control-label\">Utente di inserimento</label><six-lookup class=\"sf-form-control\" sx-relational=\"true\" ng-model=\"record.lookup.created_user_id\" sx-field=\"\'obj\'\" sx-id=\"record.model.created_user_id\" sx-mapping=\"\'mapping\'\" sx-type=\"\'users\'\" sx-required=\"stdItems.created_user_id.required\" sx-required-id=\"created_user_id\" sx-disabled=\"true\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\">Data inserimento</label><six-date-picker ng-model=\"record.model.created_date\" sx-disabled=\"true\"></six-date-picker></div><div class=\"form-group col-md-3\" ng-if=\"record.model.id\"><label class=\"control-label\">Utente di modifica</label><six-lookup class=\"sf-form-control\" sx-relational=\"true\" ng-model=\"record.lookup.last_modified_user_id\" sx-field=\"\'obj\'\" sx-id=\"record.model.last_modified_user_id\" sx-mapping=\"\'mapping\'\" sx-type=\"\'users\'\" sx-required=\"stdItems.last_modified_user_id.required\" sx-required-id=\"last_modified_user_id\" sx-disabled=\"true\"></six-lookup></div><div class=\"col-md-3\" ng-if=\"record.model.id\"><label class=\"control-label\">Data ultima modifica</label><six-date-picker ng-model=\"record.model.last_modified_date\" sx-disabled=\"true\"></six-date-picker></div></div></div>");
$templateCache.put("theme/report/report_analysis.html","<div class=\"col-md-12 override-padding-15-px\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">ANALISI BUDGET/CONSUMI</h1></div></div></div><div class=\"panel-body\"><uib-tabset class=\"tab-container\"><uib-tab index=\"0\" ng-click=\"clearVariable()\"><uib-tab-heading>Generale</uib-tab-heading><div class=\"row\"><div class=\"col-md-12 wrapper-md\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"col-md-2\"><label class=\"control-label\">Da:</label> <input class=\"btn btn-default btn-sm col-md-12\" type=\"date\" ng-model=\"period.dateFrom\"></div><div class=\"col-md-2\"><label class=\"control-label\">A:</label> <input class=\"btn btn-default btn-sm col-md-12\" type=\"date\" ng-model=\"period.dateTo\"></div><div class=\"col-md-2\"><label for=\"general_commission_code\" class=\"control-label\">Commessa:</label><div id=\"general_commission_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"commission.searchCode\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Enter...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableCommissionCodes track by $index\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-2\"><label for=\"general_budget_code\" class=\"control-label\">Budget:</label><div id=\"general_budget_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"budget.searchCode\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Enter...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableBudgetCodes track by $index\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-2\"><label for=\"general_what_1\" class=\"control-label\">Confronta:</label><six-select id=\"general_what_1\" ng-model=\"compare.what1\" sx-item-list=\"compareType\" sx-show-description=\"false\"></six-select></div><div class=\"col-md-2\"><label for=\"general_what_2\" class=\"control-label\">Con:</label><six-select id=\"general_what_2\" ng-model=\"compare.what2\" sx-item-list=\"compareType\" sx-show-description=\"false\"></six-select></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><button ng-click=\"reloadPage()\" type=\"button\" class=\"btn btn-default btn-sm\"><i class=\"fa fa-refresh\"></i> Pulisci pagina</button></div><div class=\"col-md-12\"><hr></div><div class=\"col-md-6 col-md-offset-8\"><button ng-disabled=\"budget.searchCode.length == 0 || compare.what1 == isUndefinedOrNull || compare.what2 == isUndefinedOrNull\" ng-click=\"generateBudgetReportGraphLines()\" type=\"button\" class=\"btn btn-default\"><i class=\"fa fa-line-chart\"></i> Grafico a linee</button> <button ng-disabled=\"budget.searchCode.length == 0 || compare.what1 == isUndefinedOrNull || compare.what2 == isUndefinedOrNull\" ng-click=\"generateBudgetReportGraphBars()\" type=\"button\" class=\"btn btn-default\"><i class=\"fa fa-bar-chart\"></i> Grafico a barre</button></div></div></div></div></div></div></uib-tab><uib-tab index=\"1\" ng-click=\"clearVariable()\"><uib-tab-heading>Vettori Energ./Contatori</uib-tab-heading><div class=\"row\"><div class=\"col-md-12 wrapper-md\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"col-md-2\"><label class=\"control-label\">Da:</label> <input class=\"btn btn-default btn-sm col-md-12\" type=\"date\" ng-model=\"period.dateFrom\"></div><div class=\"col-md-2\"><label class=\"control-label\">A:</label> <input class=\"btn btn-default btn-sm col-md-12\" type=\"date\" ng-model=\"period.dateTo\"></div><div class=\"col-md-2\"><label for=\"vectors_commission_code\" class=\"control-label\">Commesse:</label><div id=\"vectors_commission_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"commission.searchCode\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Enter...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableCommissionCodes track by $index\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-2\"><label for=\"vectors_budget_code\" class=\"control-label\">Budget:</label><div id=\"vectors_budget_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"budget.searchCode\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Enter...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableBudgetCodes track by $index\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-2\"><label for=\"vectors_what_1\" class=\"control-label\">Confronta:</label><six-select id=\"vectors_what_1\" ng-model=\"compare.what1\" sx-item-list=\"compareType\" sx-show-description=\"false\"></six-select></div><div class=\"col-md-2\"><label for=\"vectors_what_2\" class=\"control-label\">Con:</label><six-select id=\"vectors_what_2\" ng-model=\"compare.what2\" sx-item-list=\"compareType\" sx-show-description=\"false\"></six-select></div></div><div class=\"row wrapper\"><div class=\"col-md-3\"><label class=\"control-label\" for=\"vectors_vettore_energetico\">Vettore:</label><six-lookup id=\"vectors_vettore_energetico\" ng-model=\"vector\" sx-type=\"\'vettoreenergetico\'\" sx-field=\"\'id\'\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\" for=\"vectors_contatore_type\">Tipo contatore:</label><six-lookup id=\"vectors_contatore_type\" sx-base-path=\"\'schema\'\" ng-model=\"type\" sx-field=\"\'id\'\" sx-filter=\"contatoreTypeFilter\" sx-disabled=\"!vector.id\"></six-lookup></div><div class=\"col-md-3\" ng-if=\"commission.searchCode.length <= 1\"><label class=\"control-label\" for=\"vectors_contatori\">Contatori:</label><div id=\"vectors_contatori\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"ids.searchCode\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Enter...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableIdCodes track by $index\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-3\" ng-if=\"commission.searchCode.length > 1\"><label class=\"control-label\" for=\"vectors_contatori\">Contatori: (con più commesse non è possibile confrontare singoli contatori)</label></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><button ng-click=\"reloadPage()\" type=\"button\" class=\"btn btn-default btn-sm\"><i class=\"fa fa-refresh\"></i> Pulisci pagina</button></div><div class=\"col-md-12\"><hr></div><div class=\"col-md-6 col-md-offset-8\"><button ng-disabled=\"budget.searchCode.length == 0 || compare.what1 == isUndefinedOrNull || compare.what2 == isUndefinedOrNull\" ng-click=\"generateBudgetCounterReportGraphLines()\" type=\"button\" class=\"btn btn-default\"><i class=\"fa fa-line-chart\"></i> Grafico a linee</button> <button ng-disabled=\"budget.searchCode.length == 0 || compare.what1 == isUndefinedOrNull || compare.what2 == isUndefinedOrNull\" ng-click=\"generateBudgetCounterReportGraphBars()\" type=\"button\" class=\"btn btn-default\"><i class=\"fa fa-bar-chart\"></i> Grafico a barre</button></div></div></div></div></div></div></uib-tab><uib-tab index=\"2\" ng-click=\"clearVariable()\"><uib-tab-heading>CUSUM</uib-tab-heading><div class=\"row\"><div class=\"col-md-12 wrapper-md\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"col-md-2\"><label class=\"control-label\">Da:</label> <input class=\"btn btn-default btn-sm col-md-12\" type=\"date\" ng-model=\"period.dateFrom\"></div><div class=\"col-md-2\"><label class=\"control-label\">A:</label> <input class=\"btn btn-default btn-sm col-md-12\" type=\"date\" ng-model=\"period.dateTo\"></div><div class=\"col-md-2\"><label for=\"cusum_commission_code\" class=\"control-label\">Commesse:</label><div id=\"cusum_commission_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"commission.searchCode\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Enter...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableCommissionCodes track by $index\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-2\"><label for=\"cusum_budget_code\" class=\"control-label\">Budget:</label><div id=\"cusum_budget_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"budget.searchCode\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Enter...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableBudgetCodes track by $index\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-2\"><label class=\"control-label\" for=\"cusum_vettore_energetico\">Vettore:</label><six-lookup id=\"cusum_vettore_energetico\" ng-model=\"vector\" sx-type=\"\'vettoreenergetico\'\" sx-field=\"\'id\'\"></six-lookup></div><div class=\"col-md-2\"><label class=\"control-label\" for=\"cusum_contatore_type\">Tipo contatore:</label><six-lookup id=\"cusum_contatore_type\" sx-base-path=\"\'schema\'\" ng-model=\"type\" sx-field=\"\'id\'\" sx-filter=\"contatoreTypeFilter\" sx-disabled=\"!vector.id\"></six-lookup></div></div><div class=\"row wrapper\"><div class=\"col-md-4\" ng-if=\"commission.searchCode.length <= 1\"><label class=\"control-label\" for=\"cusum_contatori\">Contatori:</label><div id=\"cusum_contatori\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"ids.searchCode\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Enter...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableIdCodes track by $index\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-4\" ng-if=\"commission.searchCode.length > 1\"><label class=\"control-label\" for=\"cusum_contatori\">Contatori: (con più commesse non è possibile confrontare singoli contatori)</label></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><button ng-click=\"reloadPage()\" type=\"button\" class=\"btn btn-default btn-sm\"><i class=\"fa fa-refresh\"></i> Pulisci pagina</button></div><div class=\"col-md-12\"><hr></div><div class=\"col-md-6 col-md-offset-10\"><button ng-disabled=\"budget.searchCode.length == 0\" ng-click=\"generateCusum()\" type=\"button\" class=\"btn btn-default\"><i class=\"fa fa-area-chart\"></i> Grafico CUSUM</button></div></div></div></div></div></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("theme/report/report_daydegree.html","<div class=\"col-md-12 override-padding-15-px\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">GRADI GIORNO</h1></div></div></div><div class=\"panel-body\"><div class=\"col-sm-12 no-padder\"><uib-tabset class=\"tab-container\"><uib-tab index=\"0\"><uib-tab-heading>Gradi Giorno</uib-tab-heading><div class=\"row\"><div class=\"col-md-12 wrapper-md\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"col-md-3\"><label for=\"zonatermica\" class=\"control-label\">Zona Termica</label><six-lookup id=\"zonatermica\" ng-model=\"zonatermica\" sx-type=\"\'zonatermica\'\" sx-field=\"\'zonatermica_id\'\"></six-lookup></div><div class=\"col-md-2\"><label id=\"data_from_key\" class=\"control-label\">Anno:</label><six-year-picker ng-model=\"fromYearPicker.year\" sx-big=\"true\"></six-year-picker></div></div><div class=\"col-md-12\"><hr></div><div class=\"col-md-1 col-md-offset-10\"><button ng-click=\"generateDayDegreeReport()\" type=\"button\" class=\"btn btn-default\"><i class=\"fa fa-cog\"></i> Genera</button></div></div></div></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("theme/roles-bookmarks-generator/roles-bookmarks-generator.html","<style>\n    .card {\n      background: #fff;\n      border-radius: 2px;\n      display: inline-block;\n      margin: 1rem;\n      position: relative;\n    }\n    \n    .card-1 {\n      box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\n      transition: all 0.3s cubic-bezier(.25,.8,.25,1);\n    }\n    \n    .card-1:hover {\n      box-shadow: 0 7px 14px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);\n    }\n    \n    </style><div class=\"page-title m-t-md\"><h1 class=\"m-n font-thin\"><b>Genera JSON Ruoli</b> <span class=\"fa fa-hearth\"></span></h1></div><div class=\"row\" style=\"padding:30px;\"><div class=\"col-md-6\"><div class=\"form-inline\"><div class=\"form-group mx-sm-3 mb-2\"><select ng-model=\"selectedRole\" ng-options=\"r.name as r.name for r in roles\"></select></div><button type=\"button\" class=\"btn btn-primary mb-2\" ng-click=\"loadRole()\">Carica</button></div><span class=\"label label-warning\" ng-if=\"!roleHasPref\">Nessun preferito assegnato a questo ruolo</span></div></div><div class=\"row\" style=\"padding:30px;\"><div class=\"col-md-6\"><div class=\"panel-group\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\" ng-repeat=\"m in menu\"><div class=\"panel panel-default\"><div class=\"panel-heading\" role=\"tab\" id=\"headingOne\"><h4 class=\"panel-title\"><a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseOne\" aria-expanded=\"true\" aria-controls=\"collapseOne\">{{m.description}}</a></h4></div><div id=\"collapseOne\" class=\"panel-collapse collapse in\" role=\"tabpanel\" aria-labelledby=\"headingOne\"><div class=\"panel-body\"><div class=\"list-group\"><button type=\"button\" class=\"list-group-item\" ng-click=\"pushJson(s.description, s.code)\" ng-repeat=\"s in m.children\">{{s.description}}</button></div></div></div></div></div></div><div class=\"col-md-6\"><textarea rows=\"5\" class=\"form-control\">{{json}}</textarea><br><div class=\"panel-group\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><h4 class=\"panel-title\">PREFERITI AGGIUNTI</h4></div></div></div><div class=\"list-group\"><button type=\"button\" class=\"list-group-item\" ng-click=\"spliceJson(s.code)\" ng-repeat=\"s in json\">{{s.description}}</button></div></div></div><iframe id=\"jsfFrame\" ng-src=\"{{ getJsfURL() | trustAsResourceUrl }}\" width=\"99%\" height=\"600\" style=\"display:none;\" frameborder=\"0\"></iframe>");
$templateCache.put("theme/sysinfo/sysinfo.html","<style type=\"text/css\">\n  .endpoint {\n    font-style: italic;\n    font-weight: bold;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding: 6px;\n    background-color: #F0FFE9;\n    border-radius: 5px 5px 5px 5px;\n  }\n  .endpoint:before {\n    content: \"REST endpoint: \";\n    font-style: normal;\n    font-weight: normal;\n  }\n  ul.resources li:before {\n    content: attr(method);\n    background-color: #fffea5;\n    margin-right: 10px;\n    color: grey;\n    font-weight: bold;\n    font-size: .8em;\n  }\n  .cursor-pointer {\n    cursor: pointer;\n  }\n</style><script type=\"text/ng-template\" id=\"testrest\"><div class=\"endpoint\">/six/rest/testrest</div> <h4 class=\"title\">Messages</h4> <ul> <li>messages?infosN={number}&successesN={number}&warningsN={number}&errorsN={number}&severesN={number}&result={text}&period={period} <ul> <li>period: PnDTnHnMn.nS (vedere https://docs.oracle.com/javase/8/docs/api/java/time/Duration.html#parse-java.lang.CharSequence-); es. P2DT3H4M15S</li> </ul> </li> </ul></script><script type=\"text/ng-template\" id=\"frontendInfo\"><h4> <div class=\"label label-success pull-left m-xs\"> <b>{{frontEndInfo.title}}</b><br> <i>{{frontEndInfo.vendor}}</i><br> v. {{frontEndInfo.version}}<br> Rev. {{frontEndInfo.revision | limitTo: 8}}<br> Built on {{frontEndInfo.builddate | date: \"yyyy-MM-dd HH:mm:ss\"}}<br> Build profile: {{frontEndInfo.buildprofile}}<br> CI pipeline: {{frontEndInfo.cipipelineid}}<br> CI build: {{frontEndInfo.cibuildid}}<br> </div> </h4></script><script type=\"text/ng-template\" id=\"moduleInfo\"><h4 ng-click=\"showDepsVersion(info)\" ng-class=\"{\'cursor-pointer\': info.deps}\"> <div class=\"label label-info pull-left m-xs wrapper-xs\"> <b>{{info.title}}</b><br> <i>{{info.vendor}}</i><br> v. {{info.version}}<br> Rev. {{info.gitSHA1 | limitTo : 8}} ({{info.gitbranch}})<br> Built on {{info.buildtime | date: \"yyyy-MM-dd HH:mm:ss\"}}<br> Build profile: {{info.buildprofile}}<br> CI pipeline: {{info.cipipelineid}}<br> CI build: {{info.cibuildid}}<br> </div> </h4></script><script type=\"text/ng-template\" id=\"moduleDepsInfos.html\"><div class=\"row\"> <h4 class=\"text-center\">Versione dipendenze per {{info.title}}</h4> <div ng-include=\"\'moduleInfo\'\" class=\"col-md-6\" ng-repeat=\"info in info.deps\"></div> </div></script><div class=\"constructor\"><div class=\"col-md-12\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"col-md-12\"><div ng-include=\"\'frontendInfo\'\"></div><div ng-include=\"\'moduleInfo\'\" ng-repeat=\"info in modulesInfo\"></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><uib-tabset class=\"tabs-left\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> REST</uib-tab-heading><div class=\"col-md-12\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\">Path params <input type=\"text\" class=\"form-control\" ng-model=\"params.path\"></div><div class=\"col-md-12\">Query params <input type=\"text\" class=\"form-control\" ng-model=\"params.query\"></div></div><div class=\"row m-t\"><div class=\"col-md-3\">HTTP Action<six-select-2 sx-id=\"httpAction\" ng-model=\"selected\" sx-field=\"\'httpAction\'\" sx-list=\"httpActionsList\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div><div class=\"col-md-3\">Module<six-select-2 sx-id=\"module\" ng-model=\"selected\" sx-field=\"\'module\'\" sx-list=\"modulesList\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div><div class=\"col-md-6\">Request<div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"path.path\"> <span class=\"input-group-btn\"><button ng-click=\"go()\" type=\"button\" class=\"btn btn-default\"><span class=\"fa fa-heartbeat\"></span> Go</button> <button ng-click=\"reset()\" type=\"button\" class=\"btn btn-default\"><span class=\"fa fa-times\"></span> Reset</button></span></div></div></div></div><div class=\"m-t panel-group\" id=\"accordion\" ng-if=\"selected.service\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-body\"><a data-toggle=\"collapse\" data-target=\"#collapseOne\" ng-click=\"advancedStatus.open=!advancedStatus.open\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': advancedStatus.open, \'fa-angle-right\': !advancedStatus.open}\"></i> Suggerimenti</h4></div></a><div id=\"collapseOne\" class=\"panel-collapse collapse\"><div ng-include=\"selected.service.key\"></div></div></div></div></div><div class=\"m-t panel-group\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><div class=\"panel-title\">Chiamate</div></div><div class=\"panel-body\"><table class=\"tinyTable\"><tr><th width=\"50px\">Nr.</th><th>Modulo</th><th>Path</th><th>Inizio</th><th>Fine</th><th>Durata</th><th width=\"100px\">Stato</th><th width=\"50px\">Esito</th></tr><tr ng-repeat=\"call in calls track by $index\"><td width=\"50px\" class=\"text-center\">{{$index}}</td><td>{{call.module}}</td><td>{{call.path}}</td><td>{{call.start | date:\'HH:mm:ss.sss\'}}</td><td>{{call.end | date:\'HH:mm:ss.sss\'}}</td><td>{{call.duration}} ms ({{call.duration/1000}} s)</td><td width=\"100px\" class=\"text-center\">{{call.status}}</td><td width=\"50px\" class=\"text-center\"><a ng-click=\"showResponse(call.response)\" ng-if=\"call.response\"><i class=\"fa fa-reply\"></i></a> <span ng-if=\"!call.response\">-</span></td></tr></table></div></div></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("theme/test/test.html","<div class=\"col-md-12 override-padding-toolbar\" xmlns=\"http://www.w3.org/1999/html\"><div class=\"panel panel-default\"><div class=\"panel-body\"><form name=\"detailForm\" ng-submit=\"onSubmit(detailForm)\"><div class=\"override-form-group override-checkbox\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"model\" update-six-formula=\"\"></div></form></div></div></div>");
$templateCache.put("theme/touchmenu/touchmenu.html","<div class=\"panel breadcrumb\"><div class=\"breadcrumb-container\"><span ng-repeat=\"item in history\"><span class=\"breadcrumb-item\" ng-if=\"!item.menuItem\" ng-class=\"{\'active\': $index===(history.length-1)}\" ng-click=\"openMainMenu(item)\"><a href=\"\" class=\"btn-breadcrumb\">Menu</a></span> <span class=\"breadcrumb-item\" ng-if=\"item.menuItem\" ng-class=\"{\'active\': $index===(history.length-1)}\"><a href=\"\" class=\"btn-breadcrumb\">{{item.menuItem.description}}</a></span> <span class=\"breadcrumb-item space\" ng-if=\"$index!==(history.length-1)\">//</span></span></div></div><div class=\"col-md-12 override-padding-toolbar\"><div class=\"col-md-3 col-sm-6\" ng-if=\"history.length===1\"><button class=\"btn btn-bookmarks\" ng-click=\"goToBookmarks()\"><i class=\"fa fa-star\"></i><h3>{{\'favorite\' | translate}}</h3></button></div><div class=\"col-md-3 col-sm-6\" ng-if=\"history.length>1\"><button class=\"btn btn-back\" ng-click=\"goBack()\"><i class=\"fa fa-arrow-circle-left\"></i><h3>{{\'back\' | translate}}</h3></button></div><div class=\"col-md-3 col-sm-6\" ng-repeat=\"menuItem in menu\"><button class=\"btn btn-dashboard\" ng-click=\"openSubmenu(menuItem)\" ng-if=\"menuItem.children.length>0\"><i class=\"fa fa-folder-o\" ng-if=\"!menuItem.thumbnail\"></i><h3>{{menuItem.description}}</h3></button> <a ng-href=\"{{ menuItem.code.indexOf(\'http:\')==0? menuItem.code:\'#/\' + menuItem.code }}\" ng-if=\"!(menuItem.children.length>0)\"><button class=\"btn btn-dashboard\"><i class=\"fa fa-check\" ng-if=\"!menuItem.thumbnail\"></i> <i class=\"{{menuItem.thumbnail}}\" ng-if=\"menuItem.thumbnail\"></i><h3>{{menuItem.description}}</h3></button></a></div></div><iframe id=\"jsfFrame\" ng-src=\"{{ getJsfURL() | trustAsResourceUrl }}\" width=\"99%\" height=\"600\" style=\"display:none;\" frameborder=\"0\"></iframe>");
$templateCache.put("tnt/check-in/check-in.html","<style type=\"text/css\">\n    .warningRead {\n      background-color: #ffe49a !important;\n      color: #58666e !important;\n    }\n</style><six-toolbar><six-toolbar-item label=\"{{\'check_in.insertion_mode\' | translate}}\" icon=\"fa fa-toggle-down text-info-dker\"><li><a ng-click=\"toggleInsertionMode()\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (settings.manualMode) }\"></i> {{\'barcode\' | translate}}</a></li><li><a ng-click=\"toggleInsertionMode()\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (!settings.manualMode) }\"></i> {{\'check_in.manual\' | translate}}</a></li></six-toolbar-item><six-toolbar-button label=\"{{ \'list\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"override-padding-toolbar\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"m-n font-thin\">{{ \"check_in.check_in_tnt\" | translate }}</h1></div></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"customer\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.customer_id\" sx-id=\"record.model.customer_id\" sx-type=\"\'customer\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"customerFilter\" sx-on-select=\"onCustomerSelectCallback()\" sx-on-clear=\"onCustomerSelectCallback()\" sx-disabled=\"settings.idDestinationReadonly\"></six-lookup></div></div><div class=\"col-md-6 form-group override-form-group\" ng-if=\"chooseDest\"><label class=\"col-sm-4 control-label\">{{ \"customer_destination_REP\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.customer_destination_id\" sx-id=\"record.model.customer_destination_id\" sx-type=\"\'customer_destination\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"customerDestinationFilter\" sx-disabled=\"settings.idDestinationReadonly\" sx-on-select=\"onCustomerDestinationSelectCallback()\" sx-on-clear=\"onCustomerDestinationSelectCallback()\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"check_in.customer_cost_center\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.customer_cost_center_id\" sx-id=\"record.model.customer_cost_center_id\" sx-type=\"\'customer_cost_center\'\" sx-filter=\"cdcFilter\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\"></six-lookup></div></div></div><div class=\"line line-dashed b-b line-lg pull-in m-t-none\"></div><div class=\"row\" ng-if=\"!settings.manualMode\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"barcode\" | translate }}</label><div class=\"col-sm-8\"><six-code-reader sx-on-read=\"readBarcode(read)\" sx-read-mode=\"readerMode\" sx-disabled=\"!settings.canRead\" sx-escape-128=\"true\"></six-code-reader></div></div><div class=\"col-md-6 form-group\"><label class=\"i-checks\"><input type=\"checkbox\" ng-model=\"settings.consumeAllBox\"> <i></i> {{\"check_in.consume_all_box\" | translate}}</label></div></div><div class=\"row\" ng-if=\"settings.manualMode\"><div class=\"col-md-4 form-group\"><label class=\"col-md-12 control-label\">{{ \"product\" | translate }}</label><div class=\"col-md-12\"><six-lookup ng-model=\"record.lookup.product_id\" sx-id=\"settings.product_id\" sx-type=\"\'product\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"productFilter\" sx-on-select=\"onProductSelectCallback()\"></six-lookup></div></div><div class=\"col-md-4 form-group\"><label class=\"col-md-12 control-label\">{{ \"barcode\" | translate }}</label><div class=\"col-md-12\"><six-lookup ng-model=\"record.lookup.serial_kit_id\" sx-id=\"settings.serial_kit_id\" sx-type=\"\'serial_kit\'\" sx-relational=\"true\" sx-disabled=\"!settings.product_id || !settings.canRead\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"serialKitFilter\" sx-on-select=\"onSerialKitSelectCallback()\" sx-hide-code=\"true\"></six-lookup></div></div><div class=\"col-md-2\"><label class=\"col-md-12 control-label\">{{ \"quantity\" | translate }}</label><div class=\"col-md-12\"><input type=\"number\" min=\"1\" step=\"1\" class=\"form-control\" ng-disabled=\"!settings.serial_kit_id\" ng-model=\"settings.amount\"></div></div><div class=\"col-md-2 form-group\"><label class=\"col-md-12 control-label\">{{ \"multiple_check_in\" | translate }}</label><div class=\"col-md-12\"><button class=\"btn btn-primary\" ng-click=\"checkInMultiple()\" ng-disabled=\"!settings.serial_kit_id || !(settings.amount>=0)\">{{ \"confirm\" | translate }}</button></div></div></div></div></div><div class=\"panel panel-default\" ng-show=\"failedGridOptions.data.length > 0\"><div class=\"alert alert-danger\"><label><b>Letture fallite:</b></label></div><six-grid-pagination-expandable grid-options=\"failedGridOptions\" lazy-init=\"true\"></six-grid-pagination-expandable></div><div class=\"panel panel-default\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"result\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div>");
$templateCache.put("tnt/depot-storage/depot-storage-list.html","<div class=\"page-title m-t-md\"><h1 class=\"m-n font-thin\">{{ \'depot_storage.title\' | translate }}</h1></div><div class=\"wrapper-md\" ng-cloak=\"\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"destination\" | translate }}</label><six-lookup ng-model=\"lookup.depot_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'customer_destination\'\" sx-id=\"filters.depot_id\" sx-filter=\"depotFilters\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"product\" | translate }}</label><six-lookup ng-model=\"lookup.product_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'product\'\" sx-id=\"filters.product_id\" sx-relational=\"true\" sx-filter=\"productFilters\"></six-lookup></div><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"supplier\" | translate }}</label><six-lookup ng-model=\"lookup.supplier\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-preselect-if-one=\"preselectSupplier\" sx-type=\"\'supplier\'\" sx-id=\"filters.supplier\" sx-filter=\"supplierFilters\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"depot_storage.lot\" | translate }}</label><six-lookup ng-model=\"lookup.lot_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'lot\'\" sx-id=\"filters.production_lot_id\" sx-filter=\"lotFilters\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3 col-lg-2\"><label>{{ \"depot_storage.expiration_date_from\" | translate }}</label><six-date-picker ng-model=\"filters.date_from\"></six-date-picker></div><div class=\"col-md-3 col-lg-2\"><label>{{ \"depot_storage.expiration_date_to\" | translate }}</label><six-date-picker ng-model=\"filters.date_to\"></six-date-picker></div><div class=\"col-md-4\"><label class=\"control-label\">{{ \"status\" | translate }}</label><six-enum sx-model=\"filters\" sx-field=\"status\" sx-options=\"enum.status\" sx-readonly=\"false\"></six-enum></div></div><div class=\"row\"><div class=\"col-md-12\"><label>{{ \'depot_storage.aggregations\' | translate }}:</label><six-select-2 ng-model=\"aggs\" sx-multiple=\"true\" sx-compact=\"true\" sx-list=\"aggregations\" sx-on-select=\"aggsRequestChanged()\" sx-show-key=\"false\"></six-select-2></div></div></div></div><div class=\"row\"><div class=\"col-lg-{{selectedRow? 6 : 12}}\"><div class=\"panel panel-default\"><six-grid-pagination get-data-callback=\"requestChanged($params)\" grid-options=\"viewGridOptions\"></six-grid-pagination></div></div><div class=\"col-lg-6\" ng-show=\"selectedRow\"><div class=\"panel panel-default\"><six-grid-pagination get-data-callback=\"loadDetail($params, selectedRow)\" grid-options=\"detailGridOptions\" lazy-init=\"true\"></six-grid-pagination></div></div></div></div>");
$templateCache.put("tnt/endowment-wizard/customer-destination-popup.html","<iframe ng-src=\"{{ getJsfURL() | trustAsResourceUrl }}\" height=\"100%\" width=\"100%\"></iframe>");
$templateCache.put("tnt/endowment-wizard/endowment-popup.html","<div class=\"col-sm-12\"><div class=\"col-sm-12\"><h3>Dotazione per destinazione {{end.dest.code}} - {{end.dest.description}}</h3><p>Inserire le righe di dotazione per la destinazione e premere SALVA DOTAZIONE. Se la dotazione è nuova sarà successivamente possibile creare l\'ordine associato.</p><div ng-show=\"end.errors\" class=\"error\">{{end.errors}}</div><div class=\"row\"><div class=\"form-group col-sm-6\"><label for=\"exampleInputEmail1\">Inizio validità</label><div class=\"clearfix\"></div><input id=\"dataInizioInput\" type=\"date\" class=\"form-control\" ng-model=\"end.inizioValidita\"></div><div class=\"form-group col-sm-6\"><label for=\"exampleInputEmail1\">Fine validità</label><div class=\"clearfix\"></div><input id=\"dataFineInput\" type=\"date\" class=\"form-control\" ng-model=\"end.fineValidita\"></div><div class=\"form-group col-sm-6\"><label for=\"exampleInputEmail1\">Frequenza Budget</label><div class=\"clearfix\"></div><select id=\"freq\" ng-model=\"end.budgetFrequency\"><option value=\"MONTHLY\">Mensile</option><option value=\"THREE_MONTHS\">Trimestrale</option><option value=\"SIX_MONTHS\">Semestrale</option><option value=\"YEARLY\">Annuale</option></select></div><div class=\"form-group col-sm-6\"><label for=\"exampleInputEmail1\">Riordino Budget</label><div class=\"clearfix\"></div><select id=\"recovery\" ng-model=\"end.budgetRecovery\"><option value=\"true\">Sì</option><option value=\"false\">No</option></select></div></div><button ng-click=\"addEndowmentItem(end)\" class=\"btn btn-primary btn-sm\">AGGIUNGI RIGA</button> <button ng-click=\"salvaEndowment(end)\" class=\"btn btn-primary btn-sm\">SALVA DOTAZIONE</button> <button ng-if=\"end.enableOrder && end.saved\" ng-click=\"generaOrdini(end)\" class=\"btn btn-success btn-sm\">GENERA ORDINE</button><div class=\"clearfix\"></div><br><six-grid-pagination get-data-callback=\"getEndowmentItems(end, $params)\" grid-options=\"getGridOptionsEnd(end)\"></six-grid-pagination></div></div>");
$templateCache.put("tnt/endowment-wizard/order-popup.html","<div class=\"col-sm-12\"><h3>Ordine per destinazione {{orderToCompile.customer_dest_code}} - {{orderToCompile.customer_dest_desc}}</h3><p>Compilare l\'ordine e cliccare CREA ORDINE</p><button ng-click=\"confermaOrdine(orderToCompile)\" class=\"btn btn-primary btn-sm\">CREA ORDINE</button><div class=\"clearfix\"></div><br><six-grid-pagination grid-options=\"gridOptionsOrd\"></six-grid-pagination></div>");
$templateCache.put("tnt/endowment-wizard/wizard.html","<six-toolbar static-title=\"{{ \'Wizard Dotazioni Monouso\' | translate}}\"><six-toolbar-button label=\"Indietro\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" ng-click=\"indietro()\"></six-toolbar-button><six-toolbar-button label=\"Esci\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button></six-toolbar><style>\n  .modal-1000 {\n    height: 1000px;\n    width: 1000px;\n  }\n\n  .modal-content {\n    width: 100%;\n    height: 100%;\n  }\n\n  .error {\n    color: red;\n  }\n\n  .productWarn {\n    background: yellow;\n  }\n\n  .productErr {\n    background: red;\n  }\n</style><div class=\"override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div ng-show=\"tabs.activeTab === tabs.TAB_CUSTOMER\"><div class=\"stepwizard\"><div class=\"stepwizard-row setup-panel\"><div class=\"stepwizard-step\"><a type=\"button\" class=\"btn btn-primary btn-circle\">1</a><p>CLIENTE</p></div><div class=\"stepwizard-step\"><a type=\"button\" class=\"btn btn-default btn-circle disabled-button\">2</a><p>CONTRATTO</p></div><div class=\"stepwizard-step\"><a type=\"button\" class=\"btn btn-default btn-circle disabled-button\">3</a><p>PRODOTTI</p></div><div class=\"stepwizard-step\"><a type=\"button\" class=\"btn btn-default btn-circle disabled-button\">4</a><p>DOTAZIONI</p></div></div></div><div class=\"alert alert-info alert-wizard text-center\">Seleziona il Cliente</div><six-grid-pagination get-data-callback=\"getCustomerList($params)\" grid-options=\"customerGridOptions\" get-list-callback=\"getCustomerList($params)\"></six-grid-pagination></div><div ng-show=\"tabs.activeTab === tabs.TAB_AGREEMENT\"><div class=\"stepwizard\"><div class=\"stepwizard-row setup-panel\"><div class=\"stepwizard-step\"><a type=\"button\" class=\"btn btn-primary btn-circle disabled-button\">1</a><p>CLIENTE</p></div><div class=\"stepwizard-step\"><a type=\"button\" class=\"btn btn-default btn-circle\">2</a><p>CONTRATTO</p></div><div class=\"stepwizard-step\"><a type=\"button\" class=\"btn btn-default btn-circle disabled-button\">3</a><p>PRODOTTI</p></div><div class=\"stepwizard-step\"><a type=\"button\" class=\"btn btn-default btn-circle disabled-button\">4</a><p>DOTAZIONI</p></div></div></div><div class=\"alert alert-info alert-wizard\"><div class=\"row\"><div class=\"col-sm-8\">Seleziona i contratti e premi CONFERMA contratti</div><div class=\"col-sm-4\"><button class=\"btn btn-sm btn-success pull-right\" ng-click=\"confermaContratti()\">CONFERMA CONTRATTI</button></div></div></div><div ng-show=\"agreementGridOptions.totalItems == 0\"><div class=\"alert alert-danger\">Il cliente non ha contratti</div></div><six-grid-pagination get-data-callback=\"getAgreementList($params)\" grid-options=\"agreementGridOptions\" lazy-init=\"true\"></six-grid-pagination></div><div ng-show=\"tabs.activeTab === tabs.TAB_PRODUCT_UPDATE\"><div class=\"stepwizard\"><div class=\"stepwizard-row setup-panel\"><div class=\"stepwizard-step\"><a type=\"button\" class=\"btn btn-primary btn-circle disabled-button\">1</a><p>CLIENTE</p></div><div class=\"stepwizard-step\"><a type=\"button\" class=\"btn btn-default btn-circle disabled-button\">2</a><p>CONTRATTO</p></div><div class=\"stepwizard-step\"><a type=\"button\" class=\"btn btn-default btn-circle\">3</a><p>PRODOTTI</p></div><div class=\"stepwizard-step\"><a type=\"button\" class=\"btn btn-default btn-circle disabled-button\">4</a><p>DOTAZIONI</p></div></div></div><div class=\"alert alert-info alert-wizard\"><div class=\"row\"><div class=\"col-sm-8\">Inserisci le informazioni mancanti dei prodotti e premi SALVA PRODOTTI, una volta finite le modifiche cliccare AVANTI</div><div class=\"col-sm-4\"><div class=\"btn-group pull-right\"><button ng-if=\"prodottiAvantiEnabled\" ng-click=\"avantiProdotti()\" class=\"btn btn-success btn-sm pull-right\">AVANTI</button> <button ng-click=\"salvaProdotti()\" class=\"btn btn-primary btn-sm pull-right\">SALVA PRODOTTI</button></div></div></div></div><six-grid-pagination get-data-callback=\"getProductList($params)\" grid-options=\"productGridOptions\" lazy-init=\"true\"></six-grid-pagination></div><div ng-show=\"tabs.activeTab === tabs.TAB_DEST\"><div class=\"stepwizard\"><div class=\"stepwizard-row setup-panel\"><div class=\"stepwizard-step\"><a type=\"button\" class=\"btn btn-primary btn-circle disabled-button\">1</a><p>CLIENTE</p></div><div class=\"stepwizard-step\"><a type=\"button\" class=\"btn btn-default btn-circle disabled-button\">2</a><p>CONTRATTO</p></div><div class=\"stepwizard-step\"><a type=\"button\" class=\"btn btn-default btn-circle disabled-button\">3</a><p>PRODOTTI</p></div><div class=\"stepwizard-step\"><a type=\"button\" class=\"btn btn-default btn-circle\">4</a><p>DOTAZIONI</p></div></div></div><div class=\"alert alert-info alert-wizard clearfix\"><p>Per aggiungere una nuova destinazione premere NUOVA DESTINAZIONE.<br>Per modificare una destinazione premere la lente d\'ingrandimento della colonna Dettaglio.<br>Per inserire la Dotazione relativa ad una Destinazione cliccare su \"Inserisci Dotazine\", dopo l\'inserimento sarà possibile creare l\'ordine associato.<br>Per espandere una riga e vedere le destinazioni figlie premere la freccia a lato della destinazione</p><div class=\"clearfix\"></div><br><button ng-click=\"confermaDest()\" class=\"btn btn-success btn-sm\">FINE</button> <button ng-click=\"nuovaDest()\" class=\"btn btn-primary btn-sm\">NUOVA DESTINAZIONE</button></div><div class=\"clearfix\"></div><br><div class=\"clearfix\"></div><div><six-grid-pagination-expandable get-data-callback=\"getDestList($params)\" grid-options=\"destGridOptions\" lazy-init=\"true\"></six-grid-pagination-expandable></div><br><div class=\"alert alert-danger\">Destinazioni con Errori</div><div class=\"clearfix\"></div><six-grid-pagination get-data-callback=\"getDestList($params)\" grid-options=\"destErrorGridOptions\" lazy-init=\"true\"></six-grid-pagination></div><div class=\"alert alert-success\" ng-if=\"tabs.activeTab === tabs.END_SUCCESS\"><div>Procedura completata correttamente</div></div></div></div></div>");
$templateCache.put("tnt/inventory/inventory.html","<style>\n    .delete .form-control {\n        border-color: red;\n        background-color:rgba(240,80, 80, .5);\n        \n    }\n\n    .editable {\n      background-color: #00fcf3 !important;\n    }\n</style><div class=\"page-title m-t-md\"><div class=\"row\"><div class=\"col-lg-2 col-md-3\"><h1 class=\"m-n font-thin\">{{ \'inventory.title\' | translate }}:</h1></div><div class=\"col-lg-6 col-md-9\"><six-lookup ng-change=\"destinationChange()\" ng-model=\"lookup.customer_destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'customer_destination\'\" sx-id=\"destination.id\" sx-relational=\"true\" sx-placeholder=\"Seleziona una destinazione...\"></six-lookup></div></div></div><div class=\"wrapper-md\" ng-cloak=\"\" ng-show=\"destination.selected\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-6 form-group\"><label class=\"col-sm-2 control-label\">{{ \"barcode\" | translate }}</label><div class=\"col-sm-10\" ng-class=\"{delete: delete}\"><six-code-reader sx-on-read=\"readBarcode(read.read, delete)\" sx-read-mode=\"viewSettings.readerMode\" sx-escape-128=\"true\"></six-code-reader></div></div><div class=\"col-md-6\"><div class=\"row\"><span class=\"h4 m-r-xs\">Aggiungi</span> <span class=\"\"><label class=\"i-switch i-switch-md bg-danger\"><input type=\"checkbox\" ng-model=\"delete\"> <i></i></label></span> <span class=\"h4 m-l-xs\">Elimina</span></div></div></div><div class=\"row\" ng-show=\"grid.data.length\"><div class=\"col-lg-12 m-b-xxs\"><a class=\"btn btn btn-default\" ng-click=\"confirm()\"><i class=\"fa fa-paper-plane-o\"></i> {{\'inventory.confirm\' | translate}}</a> <a class=\"btn btn btn-default\" ng-model=\"viewSettings.viewMissing\" ng-change=\"missingAmount()\" uib-btn-checkbox=\"\"><i class=\"fa fa-search-minus\"></i> {{\'inventory.missing\' | translate}}</a> <a class=\"btn btn btn-default\" ng-model=\"viewSettings.gridViewLot\" ng-change=\"toggleGridView()\" uib-btn-checkbox=\"\"><i class=\"fa fa-th-large\"></i> {{ \'inventory.group_by_lot\' | translate }}</a> <a class=\"btn btn btn-default\" ng-click=\"exportInventory()\"><i class=\"fa fa-th-large\"></i> {{ \'export\' | translate }}</a></div><div class=\"\" ng-class=\"{\'col-lg-12\': !viewSettings.viewMissing, \'col-lg-6\': viewSettings.viewMissing }\"><six-grid-pagination grid-options=\"grid\" lazy-init=\"true\"></six-grid-pagination></div><div class=\"col-lg-6\" ng-if=\"viewSettings.viewMissing\"><div class=\"grid\" ui-grid=\"missingGrid\" ui-grid-pagination=\"\" ui-grid-auto-resize=\"\" ui-grid-resize-columns=\"\"></div></div></div><div class=\"row\"><div class=\"col-lg-12 m-b-xxs\"><span>Merce non tracciata</span><a ng-show=\"gridNotTrackedInv.data.length\" class=\"btn btn-xs btn-default\" ng-click=\"confirm()\"><i class=\"fa fa-paper-plane-o\"></i> {{\'inventory.confirm\' | translate}}</a><six-grid-pagination grid-options=\"gridNotTrackedInv\" lazy-init=\"true\"></six-grid-pagination><span>Merce non tracciata in Dotazione</span><button ng-click=\"addNoTrack(gridNotTrackedEnd)\">Aggiungi</button><six-grid-pagination grid-options=\"gridNotTrackedEnd\" lazy-init=\"true\"></six-grid-pagination><span>Merce non tracciata fuori dotazione</span><button ng-click=\"addNoTrack(gridNotTracked)\">Aggiungi</button><six-grid-pagination grid-options=\"gridNotTracked\" lazy-init=\"true\"></six-grid-pagination></div></div></div></div><script type=\"text/ng-template\" id=\"inventoryConfirm.html\"><style> .modal-sm { width: 300px; } </style> <div class=\"modal-header\"> <h3 class=\"modal-title\">{{\'inventory.INVENTORY_MODAL_TITLE\' | translate}}</h3> </div> <div class=\"modal-body\"> <div class=\"list-group no-radius alt no-margin\"> <a class=\"list-group-item\" href=\"\"> <span class=\"badge bg-success\">{{recap.read}}</span> <i class=\"fa fa-eye fa-fw text-muted\"></i> {{\'inventory.BOXES_READ\' | translate}} </a> <a class=\"list-group-item\" href=\"\"> <span class=\"badge bg-warning\">{{recap.moved}}</span> <i class=\"fa fa-truck fa-fw text-muted\"></i> {{\'inventory.BOXES_MOVED\' | translate}} </a> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">{{\'confirm\' | translate}}</button> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">{{\'undo\' | translate}}</button> </div></script></div>");
$templateCache.put("tnt/return-serial-kit/return-serial-kit.html","<six-toolbar><six-toolbar-button label=\"{{ \'list\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"{{ \'return_serial_kit.invalidate_kits\' | translate }}\" btn-class=\"btn-success\" icon=\"fa fa-file\" toolbar-function=\"invalidateSerialKits()\"></six-toolbar-button></six-toolbar><div class=\"override-padding-toolbar\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"m-n font-thin\">{{ \"return_serial_kit.return_serial_kit\" | translate }}</h1></div></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><label class=\"control-label\">{{ \"return_serial_kit.control_reason\" | translate }}: <strong>{{settings.controlReason.description}}</strong></label></div><div class=\"col-md-12\"><span ng-repeat=\"cr in controlReasonList\"><button class=\"btn m-r-xs\" ng-class=\"{\'btn-default\': cr.id!==settings.controlReason.id, \'btn-primary\': cr.id===settings.controlReason.id}\" ng-click=\"selectReason(cr)\"><i ng-class=\"{\'fa fa-circle-o\': cr.id!==settings.controlReason.id, \'fa fa-circle\': cr.id===settings.controlReason.id}\"></i> {{cr.description}}</button></span></div></div><div class=\"line line-dashed b-b line-lg pull-in\"></div><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"barcode\" | translate }}</label><div class=\"col-sm-8\"><six-code-reader sx-on-read=\"readBarcode(read)\" sx-read-mode=\"readerMode\" sx-disabled=\"!canRead()\" sx-escape-128=\"true\"></six-code-reader></div></div></div></div></div><div class=\"panel panel-default\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"result\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div>");
$templateCache.put("tnt/warehouse-storage/warehouse-storage-list.html","<div class=\"page-title m-t-md\"><h1 class=\"m-n font-thin\">{{ \'warehouse_storage.title\' | translate }}</h1></div><div class=\"wrapper-md\" ng-cloak=\"\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"warehouse\" | translate }}</label><six-lookup ng-model=\"lookup.container_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'container\'\" sx-id=\"filters.container_id\" sx-filter=\"containerFilters\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"product\" | translate }}</label><six-lookup ng-model=\"lookup.product_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'product\'\" sx-id=\"filters.product_id\" sx-relational=\"true\" sx-filter=\"productFilters\"></six-lookup></div><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"supplier\" | translate }}</label><six-lookup ng-model=\"lookup.supplier\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-preselect-if-one=\"preselectSupplier\" sx-type=\"\'supplier\'\" sx-id=\"filters.supplier\" sx-filter=\"supplierFilters\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"warehouse_storage.lot\" | translate }}</label><six-lookup ng-model=\"lookup.lot_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'lot\'\" sx-id=\"filters.production_lot_id\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3 col-lg-2\"><label>{{ \"warehouse_storage.expiration_date_from\" | translate }}</label><six-date-picker ng-model=\"filters.date_from\"></six-date-picker></div><div class=\"col-md-3 col-lg-2\"><label>{{ \"warehouse_storage.expiration_date_to\" | translate }}</label><six-date-picker ng-model=\"filters.date_to\"></six-date-picker></div></div><div class=\"row\"><div class=\"col-md-12\"><label>{{ \'warehouse_storage.aggregations\' | translate }}:</label><six-select-2 ng-model=\"aggs\" sx-multiple=\"true\" sx-compact=\"true\" sx-list=\"aggregations\" sx-on-select=\"aggsRequestChanged()\" sx-show-key=\"false\"></six-select-2></div></div></div></div><div class=\"row\"><div class=\"col-lg-{{selectedRow? 6 : 12}}\"><div class=\"panel panel-default\"><six-grid-pagination get-data-callback=\"requestChanged($params)\" grid-options=\"viewGridOptions\"></six-grid-pagination></div></div><div class=\"col-lg-6\" ng-show=\"selectedRow\"><div class=\"panel panel-default\"><six-grid-pagination-expandable get-data-callback=\"loadDetail($params, selectedRow)\" grid-options=\"detailGridOptions\" lazy-init=\"true\"></six-grid-pagination-expandable></div></div></div></div>");
$templateCache.put("ttr/sterilization/serialkit-sterilized-list.html","<six-toolbar><six-toolbar-button label=\"{{\'back\' | translate}}\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"override-padding-toolbar\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"m-n font-thin\">{{ \"serialkit_sterilized.function_title\" | translate }}</h1></div></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><label class=\"col-sm-1 control-label\">{{ \"barcode\" | translate }}</label><div class=\"col-sm-4\"><six-code-reader sx-on-read=\"readSerialKitCode(read)\" sx-read-mode=\"compReaderMode\"></six-code-reader></div></div></div><div class=\"row m-t\"><div class=\"col-md-12\"><six-grid-pagination get-data-callback=\"retrieveSerialKitSterilized()\" get-list-callback=\"retrieveSerialKitSterilized()\" items-list=\"serialKitsSterilizedTableData\" column-defs=\"viewSterilizedKitGridOptions.columnDefs\" grid-options=\"viewSterilizedKitGridOptions\" params=\"viewSterilizedKitGridParams\"></six-grid-pagination></div></div></div></div><div ng-include=\"\'theme/record/std_panel_six.html\'\" class=\"panel panel-default\"></div><six-print-modal sx-title=\"\'Titolo\'\" sx-on-confirm=\"onConfirmPrintLabel(code)\" sx-on-cancel=\"onCancelPrintLabel()\"></six-print-modal></div>");
$templateCache.put("core/import/endowment/endowment_import.html","<six-toolbar title=\"localeMessages.function_title\"><six-toolbar-item label=\"{{\'download_template\' | translate}}\" icon=\"fa fa-file-excel-o\"><li ng-if=\"isEnabledImportType(\'monouso\')\"><a ng-click=\"downloadTemplate(\'monouso\')\"><i class=\"icon1-packaging text-success m-r\"></i> {{\'import_endowment.download_template_monouso\' | translate}}</a></li><li ng-if=\"isEnabledImportType(\'confezionata\')\"><a ng-click=\"downloadTemplate(\'confezionata\')\"><i class=\"fa fa-female text-info m-r\"></i> {{\'import_endowment.download_template_confezionata\' | translate}}</a></li><li ng-if=\"isEnabledImportType(\'piana\')\"><a ng-click=\"downloadTemplate(\'piana\')\"><i class=\"icon1-pieghatura text-primary m-r\"></i> {{\'import_endowment.download_template_piana\' | translate}}</a></li><li ng-if=\"isEnabledImportType(\'ttr\')\"><a ng-click=\"downloadTemplate(\'ttr\')\"><i class=\"icon1-autoclave text-primary m-r\"></i> {{\'import_endowment.download_template_ttr\' | translate}}</a></li></six-toolbar-item><six-toolbar-item label=\"{{\'import\' | translate}}\" icon=\"fa fa-upload\" ng-if=\"isEntitySelected && !executeImport\" sx-disabled=\"prePercent<100 || importBusy || 100 === percent\"><li ng-if=\"isEnabledImportType(\'monouso\')\"><a ng-click=\"importData(\'monouso\')\"><i class=\"icon1-packaging text-success m-r\"></i> {{\'import_endowment.import_monouso\' | translate}}</a></li><li ng-if=\"isEnabledImportType(\'confezionata\')\"><a ng-click=\"importData(\'confezionata\')\"><i class=\"fa fa-female text-info m-r\"></i> {{\'import_endowment.import_confezionata\' | translate}}</a></li><li ng-if=\"isEnabledImportType(\'piana\')\"><a ng-click=\"importData(\'piana\')\"><i class=\"icon1-pieghatura text-primary m-r\"></i> {{\'import_endowment.import_piana\' | translate}}</a></li><li ng-if=\"isEnabledImportType(\'ttr\')\"><a ng-click=\"importData(\'ttr\')\"><i class=\"icon1-autoclave text-primary m-r\"></i> {{\'import_endowment.import_ttr\' | translate}}</a></li></six-toolbar-item><six-toolbar-button label=\"Reset\" icon=\"fa fa-undo\" toolbar-function=\"reset()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">{{localeMessages.function_title_generic}}</h1><small class=\"text-muted\">{{localeMessages.function_title}}</small></div></div></div><div class=\"panel-body\"><div ng-if=\"executeImport\" ng-controller=\"AlertDemoCtrl\"><script type=\"text/ng-template\" id=\"alert.html\"><div ng-transclude></div></script><div uib-alert=\"\" template-url=\"alert.html\" class=\"alert alert-success\">{{localeMessages.import_success}}<br>{{localeMessages.import_elapsed_time}} {{elapsedImportTime | date: \'HH:mm:ss.sss\' : \'UTC\'}} [HH:mm:ss.sss]</div><div uib-alert=\"\" template-url=\"alert.html\" class=\"alert alert-warning\" ng-show=\"successImport && gridOptions.data.length\">{{localeMessages.import_error_rows}}</div><div uib-alert=\"\" template-url=\"alert.html\" class=\"alert alert-success\" ng-show=\"successImport && !gridOptions.data.length\">{{localeMessages.import_all_success}}</div><div uib-alert=\"\" template-url=\"alert.html\" class=\"alert alert-danger\" ng-show=\"!successImport\">{{\'import_endowment.\'+errorMessageImportKey | translate}}</div><div uib-alert=\"\" template-url=\"alert.html\" calss=\"alert alert-warning\" ng-show=\"errorBudgetDestinationFromMonouso.length\">{{localeMessages.import_error_monouso_budget}} {{errorBudgetDestinationFromMonouso}}</div></div><div ui-grid=\"gridOptions\" class=\"grid\" ng-show=\"!executeImport || gridOptions.data.length\" ui-grid-resize-columns=\"\"><div class=\"grid-msg-overlay\" ng-show=\"!gridOptions.data.length\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">{{localeMessages.select_excel_file}}</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"gridOptions\" multiple=\"false\"></div></div></div></div></div></div></div>");
$templateCache.put("ferri/autoclave-cycle-validation/autoclave-cycle-validation-modal/autoclave-cycle-validation-modal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">{{ \"autoclave_cycle_validation.autoclave-program\" | translate }}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-6 m-b\"><label class=\"label-barcode\">{{ \"barcode\" | translate }}</label><six-code-reader sx-on-read=\"$ctrl.readReasonBarcode(read)\"></six-code-reader></div></div><div class=\"row\"><div class=\"col col-md-12\"><six-lookup sx-on-refresh=\"$ctrl.selectIfUnique()\" sx-refresh-list=\"$ctrl.controlReasonsList\" sx-clear-id=\"\'equipment_reason_id\'\" ng-model=\"$ctrl.record.lookup.equipment_reason_id\" sx-type=\"\'equipment_reason\'\" sx-filter=\"$ctrl.sxEquipmentReasonFilter\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\"></six-lookup></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$close(false)\">{{ \"undo\" | translate }}</button> <button type=\"button\" class=\"btn btn-info\" ng-click=\"$close(true)\" ng-disabled=\"!$ctrl.record.lookup.equipment_reason_id.obj\">{{ \"confirm\" | translate }}</button></div></div>");
$templateCache.put("ferri/washing-cycle-validation/washing-cycle-validation-modal/washing-cycle-validation-modal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">{{ \"washing_cycle_validation.washing-program\" | translate }}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-6 m-b\"><label class=\"label-barcode\">{{ \"barcode\" | translate }}</label><six-code-reader sx-on-read=\"$ctrl.readReasonBarcode(read)\"></six-code-reader></div></div><div class=\"row\"><div class=\"col col-md-12\"><six-lookup sx-on-refresh=\"$ctrl.selectIfUnique()\" sx-refresh-list=\"$ctrl.controlReasonsList\" sx-clear-id=\"\'equipment_reason_id\'\" ng-model=\"$ctrl.record.lookup.equipment_reason_id\" sx-type=\"\'equipment_reason\'\" sx-filter=\"$ctrl.sxEquipmentReasonFilter\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\"></six-lookup></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$close(false)\">{{ \"undo\" | translate }}</button> <button type=\"button\" class=\"btn btn-info\" ng-click=\"$close(true)\" ng-disabled=\"!$ctrl.record.lookup.equipment_reason_id.obj\">{{ \"confirm\" | translate }}</button></div></div>");
$templateCache.put("hpe/control-report-production/list/control-report-production-list.html","<six-toolbar><six-toolbar-button icon=\"fa fa-plus\" label=\"{{\'new\' | translate}}\" btn-class=\"btn-info\" toolbar-function=\"goToNew()\"></six-toolbar-button><six-toolbar-button label=\"Reset\" icon=\"fa fa-undo\" toolbar-function=\"reset()\"></six-toolbar-button></six-toolbar><div class=\"page-title m-t-toolbar\"><h1 class=\"m-n font-thin\">{{ \"control_report_production.control_report_production\" | translate }}</h1></div><div class=\"wrapper-md\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3\"><label>{{ \"control_report_production.validity_date\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.validity_date\"></six-date-picker></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"control_report_production.customer\" | translate }}</label><six-lookup ng-model=\"lookup.customer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.customer_id\" sx-type=\"\'customer\'\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"control_report_production.production_order\" | translate }}</label><six-lookup ng-model=\"lookup.production_order_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.production_order_id\" sx-type=\"\'prod_order\'\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"control_report_production.product\" | translate }}</label><six-lookup ng-model=\"lookup.product_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.product_id\" sx-type=\"\'product\'\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"control_report_production.revision\" | translate }}</label><six-lookup ng-model=\"lookup.revision_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.revision_id\" sx-type=\"\'revision\'\" sx-relational=\"true\" sx-filter=\"revisionFilter\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"control_report_production.billing_mode\" | translate }}</label><six-enum sx-model=\"advFilter.filter\" sx-field=\"billing_mode\" sx-options=\"enum.billing_mode\"></six-enum></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"control_report_production.working_area\" | translate }}</label><six-lookup ng-model=\"lookup.working_area_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.working_area_id\" sx-type=\"\'working_area\'\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"control_report_production.task\" | translate }}</label><six-lookup ng-model=\"lookup.task_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.task_id\" sx-type=\"\'task\'\" sx-relational=\"true\"></six-lookup></div></div></div></div><div class=\"panel panel-default\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"result\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div>");
$templateCache.put("hpe/control-report-production/detail/control-report-production-detail.html","<six-toolbar><six-toolbar-button label=\"{{ \'list\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" toolbar-function=\"goToList()\"></six-toolbar-button><six-toolbar-button label=\"{{ \'save\' | translate }}\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\" ng-if=\"!editMode\"></six-toolbar-button><six-toolbar-button label=\"{{ \'delete\' | translate }}\" btn-class=\"btn-danger\" icon=\"fa fa-times\" toolbar-function=\"delete()\" ng-if=\"editMode\"></six-toolbar-button></six-toolbar><br><br><br><iframe id=\"jsfFrame\" ng-src=\"{{ getJsfURL() | trustAsResourceUrl }}\" width=\"99%\" height=\"2000\" scrolling=\"no\" frameborder=\"0\" ng-if=\"functionCode && editMode\"></iframe><div class=\"override-padding-toolbar\" ng-if=\"!editMode\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"m-n font-thin\">{{ \"control_report_production.control_report_production\" | translate }}</h1></div></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3\"><label>{{ \"control_report_production.validity_date\" | translate }}</label><six-date-picker ng-model=\"transient.validity_date\"></six-date-picker></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"control_report_production.customer\" | translate }}</label><six-lookup ng-model=\"lookup.customer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"transient.customer_id\" sx-type=\"\'customer\'\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"control_report_production.production_order\" | translate }}</label><six-lookup ng-model=\"lookup.production_order_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"transient.production_order_id\" sx-type=\"\'prod_order\'\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"control_report_production.product\" | translate }}</label><six-lookup ng-model=\"lookup.product_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"transient.product_id\" sx-type=\"\'product\'\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"control_report_production.revision\" | translate }}</label><six-lookup ng-model=\"lookup.revision_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"transient.revision_id\" sx-type=\"\'revision\'\" sx-relational=\"true\" sx-filter=\"revisionFilter\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"control_report_production.billing_mode\" | translate }}</label><six-enum sx-model=\"transient\" sx-field=\"billing_mode\" sx-options=\"enum.billing_mode\" sx-readonly=\"readOnly\"></six-enum></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"control_report_production.task\" | translate }}</label><six-lookup ng-model=\"lookup.task_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"transient.task_id\" sx-type=\"\'task\'\" sx-relational=\"true\"></six-lookup></div></div></div></div></div>");
$templateCache.put("icteggs/taboperatori/operatoridocumenti/operatoridocumenti.html","<div><span class=\"pull-right\"><button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first m-r-sm\" ng-click=\"undo()\"><span class=\"fa fa-save\"></span> Annulla</button> <button class=\"btn btn-sm btn-success add-remove-button add-remove-button-first m-r-sm\" ng-click=\"save()\"><span class=\"fa fa-save\"></span> Salva</button></span><h4 class=\"override-h4-no-margin\">Documenti</h4><hr class=\"m-t\"></div><div class=\"row\"><div class=\"col-lg-4\"><div class=\"form-group\"><label>Tipo documento</label><six-lookup ng-model=\"$ctrl.lookup.tipodocumentoid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"$ctrl.sxModel.tipodocumentoid\" sx-type=\"\'tabtipodoc\'\" sx-placeholder=\"Seleziona documento...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col-lg-4\"><div class=\"form-group\"><label>Presentazione</label><six-enum sx-model=\"$ctrl.sxModel\" sx-field=\"presentazione\" sx-options=\"enum.presentazione\"></six-enum></div></div><div class=\"col-lg-2\"><div class=\"form-group\"><label>Data scadenza presentazione</label><six-date-picker ng-model=\"$ctrl.sxModel.datascapresentazione\"></six-date-picker></div></div><div class=\"col-lg-2\"><div class=\"form-group\"><label>Tipo</label> <input type=\"text\" class=\"form-control\" placeholder=\"Tipo\" readonly=\"\"></div></div></div><div class=\"row\" ng-if=\"$ctrl.sxModel.tipo==\'I\'||$ctrl.sxModel.tipo==\'A\'\"><div class=\"col-lg-6\"><div class=\"form-group\"><label>Numero</label> <input type=\"text\" class=\"form-control\" placeholder=\"Numero\" ng-model=\"$ctrl.sxModel.numero\"></div></div><div class=\"col-lg-6\"><div class=\"form-group\"><label>Rilasciato da</label> <input type=\"text\" class=\"form-control\" placeholder=\"Numero\" ng-model=\"$ctrl.sxModel.ufficiorilascio\"></div></div></div><div ng-if=\"$ctrl.sxModel.tipo==\'S\'\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"form-group\"><label>Questura</label><six-lookup ng-model=\"$ctrl.lookup.questurapermessoid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"$ctrl.sxModel.questurapermessoid\" sx-type=\"\'tabprov\'\" sx-placeholder=\"Seleziona questura...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col-lg-6\"><div class=\"form-group\"><label>Numero</label> <input type=\"text\" class=\"form-control\" placeholder=\"Numero\" ng-model=\"$ctrl.sxModel.numero\"></div></div></div><div class=\"row\"><div class=\"col-lg-10\"><div class=\"form-group\"><label>Tipo permesso</label><six-lookup ng-model=\"$ctrl.lookup.tipopermessoid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"$ctrl.sxModel.tipopermessoid\" sx-type=\"\'tabtipopermessosogg\'\" sx-placeholder=\"Seleziona tipo permesso...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col-lg-1 col-offset-1\"><div class=\"form-group\"><six-checkbox sx-label=\"Ricevuta\" sx-model=\"$ctrl.sxModel\" sx-field=\"ricevuta\"></six-checkbox></div></div></div><div class=\"row\"><div class=\"col-lg-6\"><div class=\"form-group\"><label>Status</label><six-enum sx-model=\"$ctrl.sxModel\" sx-field=\"statussoggiorno\" sx-options=\"enum.statussoggiorno\"></six-enum></div></div><div class=\"col-lg-3\"><div class=\"form-group\"><six-checkbox sx-label=\"Suss.sist.allogg\" sx-model=\"$ctrl.sxModel\" sx-field=\"susssistallogg\"></six-checkbox></div></div><div class=\"col-lg-3\"><div class=\"form-group\"><six-checkbox sx-label=\"Imp. pag. rimpatrio\" sx-model=\"$ctrl.sxModel\" sx-field=\"imppagrimpatrio\"></six-checkbox></div></div></div></div><div class=\"row\" ng-if=\"$ctrl.sxModel.tipo\"><div class=\"col-lg-6\"><div class=\"form-group\"><label>Data rilascio</label><six-date-picker ng-model=\"$ctrl.sxModel.datarilascio\"></six-date-picker></div></div><div class=\"col-lg-6\"><div class=\"form-group\"><label>Data scadenza</label><six-date-picker ng-model=\"$ctrl.sxModel.datasca\"></six-date-picker></div></div></div><div ng-if=\"$ctrl.sxModel.tipo==\'A\'\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"form-group\"><label>Comune</label><six-lookup ng-model=\"$ctrl.lookup.comuneid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"$ctrl.sxModel.comuneid\" sx-type=\"\'tabcomuni\'\" sx-placeholder=\"Seleziona comune...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col-lg-6\"><div class=\"form-group\"><label>Indirizzo</label> <input type=\"text\" class=\"form-control\" placeholder=\"Indirizzo\" ng-model=\"$ctrl.sxModel.indirizzo\"></div></div></div><div class=\"row\"><div class=\"col-lg-2\"><div class=\"form-group\"><label>CAP</label> <input type=\"text\" class=\"form-control\" placeholder=\"cap\" ng-model=\"$ctrl.sxModel.cap\"></div></div><div class=\"col-lg-6\"><div class=\"form-group\"><label>Provincia</label><six-lookup ng-model=\"$ctrl.lookup.provid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"$ctrl.sxModel.prov\" sx-type=\"\'tabprov\'\" sx-placeholder=\"Seleziona provincia...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col-lg-2\"><div class=\"form-group\"><label>Numero persone</label> <input type=\"text\" class=\"form-control\" placeholder=\"Num.persone\" ng-model=\"$ctrl.sxModel.numpersidoneocarta\"></div></div><div class=\"col-lg-2\"><div class=\"form-group\"><label>Numero residenti</label> <input type=\"text\" class=\"form-control\" placeholder=\"Num.residenti\" ng-model=\"$ctrl.sxModel.numpersresidcarta\"></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"form-group\"><label>Note</label> <textarea class=\"form-control\" placeholder=\"Note\" ng-model=\"$ctrl.sxModel.note\"></textarea></div></div></div>");
$templateCache.put("icteggs/taboperatori/operatorifamiliaridetr/operatorifamiliaridetr.html","<div><span class=\"pull-right\"><button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first m-r-sm\" ng-click=\"undo()\"><span class=\"fa fa-save\"></span> Annulla</button> <button class=\"btn btn-sm btn-success add-remove-button add-remove-button-first m-r-sm\" ng-click=\"save()\"><span class=\"fa fa-save\"></span> Salva</button> <button class=\"btn btn-sm btn-info add-remove-button add-remove-button-first\" ng-click=\"addNuovo()\"><span class=\"fa fa-plus\"></span> Aggiungi</button></span><h4 class=\"override-h4-no-margin\">Detrazioni familiari</h4><hr class=\"m-t\"></div><div class=\"row\"><div class=\"col-lg-4\"><div class=\"form-group\"><six-checkbox sx-label=\"Detrazione da lavoro dipendente\" sx-model=\"$ctrl.sxModel\" sx-field=\"detrazionedalavoro\"></six-checkbox></div></div><div class=\"col-lg-4\"><div class=\"form-group\"><label>Data ins</label><six-date-picker ng-model=\"$ctrl.sxModel.datainserimento\"></six-date-picker></div></div><div class=\"col-lg-4\"><div class=\"form-group\"><label>Anno</label> <input type=\"number\" min=\"0\" step=\"1\" class=\"form-control\" placeholder=\"Anno competenza\" ng-model=\"$ctrl.sxModel.annocompetenza\"></div></div></div><div ng-repeat=\"item in $ctrl.sxCorList\"><div class=\"panel panel-info\"><div class=\"panel-heading\">Dati Familiari</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-lg-2\"><div class=\"form-group\"><label>Parentela</label><six-enum sx-model=\"item\" sx-field=\"rapportoparentela\" sx-options=\"enum.rapportoparentela\"></six-enum></div></div><div class=\"col-lg-2\"><div class=\"form-group\"><six-checkbox sx-label=\"Conv in Italia\" sx-model=\"item\" sx-field=\"conviventeinitalia\"></six-checkbox></div></div><div class=\"col-lg-2\"><div class=\"form-group\"><label>Nome</label> <input type=\"text\" class=\"form-control\" placeholder=\"Nome\" ng-model=\"item.nome\"></div></div><div class=\"col-lg-3\"><div class=\"form-group\"><label>Cognome</label> <input type=\"text\" class=\"form-control\" placeholder=\"Cognome\" ng-model=\"item.cognome\"></div></div><div class=\"col-lg-3\"><div class=\"form-group\"><label>Cod fiscale</label> <input type=\"text\" class=\"form-control\" placeholder=\"Cod fiscale\" ng-model=\"item.codicefiscale\"></div></div></div><div class=\"row\"><div class=\"col-lg-2\"><div class=\"form-group\"><label>Sesso</label><six-enum sx-model=\"item\" sx-field=\"sesso\" sx-options=\"enum.sesso\"></six-enum></div></div><div class=\"col-lg-1\"><div class=\"form-group\"><six-checkbox sx-label=\"A Carico\" sx-model=\"item\" sx-field=\"acarico\"></six-checkbox></div></div><div class=\"col-lg-1\"><div class=\"form-group\"><six-checkbox sx-label=\"Ass Fam.\" sx-model=\"item\" sx-field=\"assegnofamiliare\"></six-checkbox></div></div><div class=\"col-lg-2\"><div class=\"form-group\"><label>Dt nascita</label><six-date-picker ng-model=\"item.datanascita\"></six-date-picker></div></div><div class=\"col-lg-3\"><div class=\"form-group\"><label>Città di nascita</label><six-lookup ng-model=\"$ctrl.lookup.cittanascitaid\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"$ctrl.sxModel.cittanascitaid\" sx-type=\"\'tabcomuni\'\" sx-placeholder=\"Seleziona città di nascita...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col-lg-3\"><div class=\"form-group\"><label>%det</label> <input type=\"text\" class=\"form-control\" placeholder=\"percentuale detrazione\" ng-model=\"item.percentualedetrazione\"></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-6\"><button type=\"button\" class=\"btn btn-primary pull-right\" icon=\"fa fa-plus\" ng-click=\"addNuovo($ctrl.sxModel)\">Aggiungi Altri Dati <i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button></div></div>");
$templateCache.put("lm/employee/employeeComponentMatch/employeeComponentMatch.html","<six-toolbar title=\"pageTitle\"><six-toolbar-button icon=\"fa fa-chevron-left\" class=\"btn btn-xl pull-left-xs\" label=\"Esci\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"wrapper-md m-t-xxl\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Cliente</label><six-lookup ng-model=\"lookup.customer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.destination_id\" sx-filter=\"customerFilter\" sx-type=\"\'customer\'\" sx-placeholder=\"Seleziona cliente...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Reparto</label><six-lookup ng-model=\"lookup.destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.destination_id\" sx-filter=\"repFilter\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona reparto...\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Dipendente</label><six-lookup ng-model=\"lookup.employee_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.employee_id\" sx-filter=\"empFilter\" sx-type=\"\'human_resource\'\" sx-placeholder=\"Seleziona dipendente...\" sx-relational=\"true\"></six-lookup></div></div><div class=\"col-md-6\"><label class=\"control-label\">Lettore unicode</label><six-code-reader sx-on-read=\"readComponentCode(read)\" sx-read-mode=\"compReaderMode\" sx-disabled=\"!employeeId\"><six-code-reader></six-code-reader></six-code-reader></div></div><div class=\"row\"><div class=\"col-md-12 b-b b-b-3x b-b-info\" style=\"margin-top:20px; margin-bottom: 10px\"></div></div><div class=\"row\" ng-if=\"element\"><div class=\"col-md-12 b-b b-b-3x b-b-info\" style=\"margin-top:20px; margin-bottom: 10px; margin-left: 50px; font-size:large\"><div class=\"col-md-4\"><b>Dipendente</b> : {{element.name ? element.name : \'\'}} {{element.surname ? element.surname : \'\'}} - {{element.matriculation ? element.matriculation : \'\'}}</div><div class=\"col-md-4\"><b>Cliente</b> : {{element.dest_customer_code ? element.dest_customer_code : \'\'}} - {{element.dest_customer_description ? element.dest_customer_description : \'\'}}</div><div class=\"col-md-4\"><b>Reparto</b> : {{element.dest_code ? element.dest_code : \'\'}} - {{element.dest_description ? element.dest_description : \'\'}}</div></div></div><div class=\"row\"><div class=\"col-md-12 b-b b-b-3x b-b-info\" style=\"margin-top:20px; margin-bottom: 10px\"></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><table class=\"table m-b-none\"><thead><tr><th>{{ \'Codice articolo\' | translate }}</th><th>{{ \'Descrizione articolo\' | translate }}</th><th>{{ \'Taglia\' | translate }}</th><th>{{ \'Quantità\' | translate }}</th><th>{{ \'Mancanti\' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"e in epdList.slice().reverse() | orderBy : \'product_code\'\"><td>{{e.product_code}}</td><td>{{e.product_description}}</td><td>{{e.size_description}}</td><td>{{e.endowment_qty}}</td><td>{{e.remaining_qty}}</td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-md-12 b-b b-b-3x b-b-info\" style=\"margin-top:20px; margin-bottom: 10px\"></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><table class=\"table m-b-none\"><thead><tr><th></th><th>{{ \'Barcode\' | translate }}</th><th>{{ \'Unicode\' | translate }}</th><th>{{ \'Codice articolo\' | translate }}</th><th>{{ \'Descrizione articolo\' | translate }}</th><th>{{ \'Taglia\' | translate }}</th><th>{{ \'Matricola dipendente\' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"m in matchList.slice().reverse() | orderBy : \'product_code\'\"><td><button ng-click=\"decoupleComponent(m.id)\" class=\"btn btn-xl btn-info equal-margin-left-right\"><span class=\"fa fa-trash\"></span></button></td><td>{{m.barcode}}</td><td>{{m.unicode}}</td><td>{{m.product_code}}</td><td>{{m.product_description}}</td><td>{{m.size_description}}</td><td>{{m.employee_matriculation}}</td></tr></tbody></table></div></div></div></div><six-confirm-modal sx-title=\"modal.title\" sx-message=\"modal.message\" sx-on-confirm=\"modal.callback\"></six-confirm-modal></div>");
$templateCache.put("lm/goodsInward/detail/goods-inward-detail.html","<six-toolbar title=\"functionTitle\"><six-toolbar-button label=\"{{ \'list\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" toolbar-function=\"goToList()\"></six-toolbar-button><six-toolbar-button label=\"{{ \'save\' | translate }}\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\" sx-disabled=\"tabs.activeTab == 1 || !isUpdateAllowed || readOnly\"></six-toolbar-button><six-toolbar-button label=\"{{ \'confirm\' | translate }}\" btn-class=\"btn-info\" icon=\"fa fa-check\" toolbar-function=\"confirm()\" sx-disabled=\"tabs.activeTab == 1 || !isUpdateAllowed || readOnly || !record.model.id\"></six-toolbar-button></six-toolbar><div class=\"override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><uib-tabset justified=\"false\" active=\"tabs.activeTab\" class=\"tab-container\"><uib-tab index=\"tabs.TAB_HEAD\"><uib-tab-heading><span class=\"tab-heading\">{{ \"tab_head\" | translate }}</span></uib-tab-heading><div ng-include=\"\'lm/goodsInward/detail/goods-inward-tab-head.html\'\"></div></uib-tab><uib-tab index=\"tabs.TAB_ROWS\" disable=\"readOnly || !isNewAllowed\"><uib-tab-heading><span class=\"tab-heading\">{{ \"tab_rows\" | translate }}</span></uib-tab-heading><div ng-include=\"\'lm/goodsInward/detail/goods-inward-tab-row.html\'\"></div></uib-tab></uib-tabset></div></div><div ng-if=\"(params.filters && params.filters.length > 0)\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"result\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination><div ng-include=\"\'theme/record/std_panel_six.html\'\" class=\"panel panel-default\"></div></div></div>");
$templateCache.put("lm/goodsInward/detail/goods-inward-tab-head.html","<div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"supplier\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.supplier_id\" sx-id=\"record.model.supplier_id\" sx-type=\"\'supplier\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-required=\"true\" sx-disabled=\"record.model.id\" sx-filter=\"supplierFilter\" sx-preselect-if-one=\"preselectSupplier\"></six-lookup></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"type\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.type_id\" sx-id=\"record.model.type_id\" sx-type=\"\'goods_inward_type\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-disabled=\"record.model.id\" sx-required=\"true\"></six-lookup></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"warehouse\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.wharehouse_id\" sx-id=\"record.model.wharehouse_id\" sx-type=\"\'facility\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-disabled=\"record.model.id\" sx-required=\"true\"></six-lookup></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"causal\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.inventory_reason_id\" sx-id=\"record.model.inventory_reason_id\" sx-type=\"\'inventory_reason\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-disabled=\"record.model.id\" sx-required=\"true\"></six-lookup></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.supplier_ddt_date\" | translate }}</label><div class=\"col-sm-8\"><six-date-picker ng-model=\"record.model.dn_date\" required=\"\"></six-date-picker></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.supplier_ddt_number\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" ng-model=\"record.model.dn_number\"></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.inward_date\" | translate }}</label><div class=\"col-sm-8\"><six-date-picker ng-model=\"record.model.rec_date\" required=\"\"></six-date-picker></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.reference\" | translate }}</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" ng-model=\"record.model.reference\"></div></div><div ng-if=\"!newRecord\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"date\" | translate }}</label><div class=\"col-sm-8\"><six-date-picker ng-model=\"record.model.int_date\" sx-disabled=\"true\" required=\"\"></six-date-picker></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"number\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" ng-model=\"record.model.int_number\" readonly=\"\"></div></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"status\" | translate }}</label><div class=\"col-sm-8\"><six-enum sx-model=\"record.model\" sx-field=\"status\" sx-disabled=\"true\" sx-options=\"enum.status\" required=\"\"></six-enum></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">BEM</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" ng-model=\"record.model.bem\" maxlength=\"20\"></div></div></div>");
$templateCache.put("lm/goodsInward/detail/goods-inward-tab-row.html","<div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"product\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.item_id\" sx-id=\"record.model.item_id\" sx-type=\"\'product\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\"></six-lookup></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.supplier_product\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.supplier_item_id\" sx-id=\"record.model.supplier_item_id\" sx-type=\"\'product_supplier\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"supplierItemFilter\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.size_desc\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.size_id\" sx-id=\"record.model.size_id\" sx-type=\"\'tab_size\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"sizeFilter\" sx-disabled=\"!record.lookup.item_id.obj\"></six-lookup></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.color_desc\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.color_id\" sx-id=\"record.model.color_id\" sx-type=\"\'color\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"colorFilter\" sx-disabled=\"!record.lookup.item_id.obj\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.stock_amount\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" ng-model=\"record.model.stock_amount\"></div></div></div><div class=\"wrapper\" ng-if=\"isNewAllowed\"><button class=\"pull-right btn btn-sm btn-info m-t-n-xs m-l\" ng-click=\"saveRow()\">{{ \"goods_inward.add\" | translate }}</button></div>");
$templateCache.put("lm/goodsInward/list/goods-inward-list.html","<six-toolbar title=\"functionTitle\"><six-toolbar-button icon=\"fa fa-plus\" label=\"{{\'new\' | translate}}\" btn-class=\"btn-info\" toolbar-function=\"goToNew()\" sx-disabled=\"!isNewAllowed\"></six-toolbar-button></six-toolbar><div class=\"wrapper-md m-t-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-4\"><label>{{ \"warehouse\" | translate }}</label><six-lookup ng-model=\"lookup.facility_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-preselect-if-one=\"true\" sx-id=\"advFilter.filter.facility_id\" sx-type=\"\'facility\'\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-4\"><label class=\"control-label\">{{ \"supplier\" | translate }}</label><six-lookup ng-model=\"lookup.supplier_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-preselect-if-one=\"true\" sx-id=\"advFilter.filter.supplier_id\" sx-type=\"\'supplier\'\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-4\"><label class=\"control-label\">{{ \"type\" | translate }}</label><six-lookup ng-model=\"lookup.type_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-preselect-if-one=\"true\" sx-id=\"advFilter.filter.type_id\" sx-type=\"\'goods_inward_type\'\" sx-relational=\"true\"></six-lookup></div></div><div class=\"row\"><div class=\"col-md-4\"><label>{{ \"goods_inward.from_inward_date\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.rec_date_from\"></six-date-picker></div><div class=\"col-md-4\"><label>{{ \"goods_inward.to_inward_date\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.rec_date_to\"></six-date-picker></div></div><div class=\"row\"><div class=\"col-md-4\"><label>{{ \"goods_inward.supplier_ddt_date\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.dn_date\"></six-date-picker></div><div class=\"col-md-4\"><label class=\"control-label\">{{ \"goods_inward.supplier_ddt_number\" | translate }}</label> <input type=\"number\" step=\"1\" min=\"1\" class=\"form-control\" ng-model=\"advFilter.filter.dn_number\"></div></div></div></div><div class=\"panel panel-default\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"result\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div>");
$templateCache.put("lm/guestsRebaser/load/guestsrebaser_listMode.html","<table class=\"table table-striped\"><thead><tr><th>Ospite</th><th>Matricola</th><th>Nucleo</th><th>Reparto</th><th>Punto di Consegna</th><th>Elenco celle occupate</th><th>Totale capi</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in matrixStructure\"><td>{{matrixStructure[k].data.e_name}} {{matrixStructure[k].data.e_surname}}</td><td>{{matrixStructure[k].data.e_matr}}</td><td><b>{{matrixStructure[k].data.product_cat_cd}}</b> {{matrixStructure[k].data.product_cat_de}}</td><td><b>{{matrixStructure[k].data.cde_cd}}</b> {{matrixStructure[k].data.cde_de}}</td><td><b>{{matrixStructure[k].data.delivery_cd}}</b> {{matrixStructure[k].data.delivery_de}}</td><td ng-bind-html=\"printArray(v.list)\"></td><td>{{printComponentNumbers(v.list)}}</td></tr></tbody></table>");
$templateCache.put("lm/guestsRebaser/load/guestsrebaser_load_panel.html","<locked-modal sx-component=\"lockedComponent\"></locked-modal><div class=\"well clearfix\" ng-if=\"type != \'MISSING_COMPONENTS\'\"><div class=\"col-md-5 no-pad pull-left\"><div class=\"form-group\"><label class=\"col-md-3\">Guardaroba:</label><div class=\"col-md-9\"><div class=\"input-group\"><select class=\"form-control\" ng-model=\"selected.wardrobe\" ng-options=\"w as w.code + \' - \' + w.description for w in wardrobe.list\"></select><span class=\"input-group-btn\"><button class=\"btn btn-info rebaser-btn-close\" ng-click=\"resetWardrobe()\"><i class=\"fa fa-close\"></i></button></span></div></div></div><div class=\"form-group\" ng-if=\"selected.wardrobe\"><div class=\"clearfix\"></div><br><label class=\"col-md-3\">Modalità lettura:</label><div class=\"col-md-9\"><div class=\"btn-group-rebaser btn-group-justified\"><label class=\"btn btn-success rebaser btn-md col-md-6\" ng-model=\"mode.value\" uib-btn-radio=\"\'INSERT\'\">Aggiungi</label> <label class=\"btn btn-danger rebaser btn-md col-md-6\" ng-model=\"mode.value\" uib-btn-radio=\"\'DELETE\'\">Elimina</label></div></div><div class=\"clearfix\"></div></div><div class=\"form-group\" ng-if=\"selected.wardrobe\"><label class=\"col-md-3\">Lettura componente:</label><div class=\"col-md-9\"><six-code-reader sx-on-read=\"readLoadComponent(read)\" sx-read-mode=\"cartReaderMode\"><six-code-reader></six-code-reader></six-code-reader></div></div></div><div class=\"col-md-4 no-pad\" ng-repeat=\"c in lastReadCodes | reverse\" style=\"padding: 0px;\"><div ng-if=\"c.found && !c.locked\"><div class=\"col-md-6\" ng-if=\"alreadyInsertedCell == undefined && lastInsertedCell != undefined\"><button class=\"btn btn-rebaser-big green btn-block\" ng-click=\"saveCellAsFull(lastInsertedCell.r, lastInsertedCell.c, c.comp)\" id=\"remove-button\" ng-class=\"{\'btn-pressed\': !addMode}\">{{lastInsertedCell.r}}{{lastInsertedCell.c}}</button></div><div class=\"col-md-6\" ng-if=\"alreadyInsertedCell != undefined\"><button class=\"btn btn-rebaser-big blu btn-block\" id=\"remove-button\" data-toggle=\"modal\" data-target=\"#myModal\" popover-title=\"Contenuto\" uib-popover-template=\"resabser_cell_template\" popover-trigger=\"mouseenter\">{{alreadyInsertedCell.r}}{{alreadyInsertedCell.c}}</button></div><div class=\"col-md-6\" ng-if=\"lastInsertedCell != undefined || alreadyInsertedCell != undefined\"><button class=\"btn btn-rebaser-big btn-block\" ng-click=\"undoInsertComponent(c.comp)\" id=\"remove-button\" ng-class=\"{\'btn-pressed\': !addMode}\">ANNULLA</button></div></div></div><div class=\"col-md-3\" ng-if=\"lastReadCodes.length > 0\" ng-repeat=\"c in lastReadCodes | reverse\"><div ng-if=\"c.found && !c.locked\"><h3 style=\"margin-top: 0px;\">Barcode <b>{{c.comp.barcode}}</b></h3><hr style=\"margin-top: 10px; margin-bottom: 10px;\"><h4>{{getType(c.comp.special_use)}}</h4><hr style=\"margin-top: 10px; margin-bottom: 10px;\"><h4>Articolo: <b>{{c.comp.product_code}}</b> - {{c.comp.product_description}}</h4></div><div ng-if=\"!c.found\">Componente non trovato</div><div ng-if=\"c.locked\">Componente bloccato</div></div></div><div class=\"well clearfix\" ng-if=\"type == \'MISSING_COMPONENTS\'\"><div class=\"wrapper col-md-12\"><div ng-include=\"\'lm/guestsRebaser/load/guestsrebaser_missingComponents.html\'\"></div></div></div><div class=\"modal fade\" id=\"myModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Contenuto della cella</h4></div><div class=\"modal-body no-padding\"><div class=\"alert alert-warning clearfix\"><div class=\"col-md-12 no-pad\"><b>Ospite:</b> {{infoCell.e_matr}} - {{infoCell.e_name}} {{infoCell.e_surname}}</div><div class=\"col-md-12 no-pad\"><b>Nucleo:</b> <b>{{infoCell.product_cat_cd}}</b> - {{infoCell.product_cat_de}}</div><div class=\"col-md-12 no-pad\"><b>Reparto:</b> <b>{{infoCell.cde_cd}}</b> - {{infoCell.cde_de}}</div><div class=\"col-md-12 no-pad\"><b>P. di Consegna:</b> <b>{{infoCell.delivery_cd}}</b> - {{infoCell.delivery_de}}</div></div><div class=\"table-responsive\"><table class=\"table table-striped\"><tr ng-repeat=\"key in infoCell.content.comp\"><td width=\"20\"><i class=\"fa fa-flag\" aria-hidden=\"true\"></i></td><td>{{key.barcode}}</td><td>{{key.product_code}}</td><td>{{key.product_description}}</td><td>{{key.size_code}}</td></tr></table></div></div></div></div></div><div class=\"row\"><div class=\"wrapper col-md-12\" ng-if=\"type == \'TABLE\'\"><div ng-include=\"\'lm/guestsRebaser/load/guestsrebaser_tableMode.html\'\"></div></div><div class=\"wrapper\" ng-if=\"type == \'LIST\'\"><div ng-include=\"\'lm/guestsRebaser/load/guestsrebaser_listMode.html\'\"></div></div></div>");
$templateCache.put("lm/guestsRebaser/load/guestsrebaser_missingComponents.html","<div class=\"clearfix\"><table class=\"table table-striped\"><thead><tr><th>Ospite</th><th>Matricola</th><th>Nucleo</th><th>Reparto</th><th>Punto di Consegna</th><th>Capi mancanti</th></tr></thead><tbody><tr ng-repeat=\"i in missingComponents.list\"><td>{{i.patient_name}} {{i.patient_surname}}</td><td>{{i.patient_matriculation}}</td><td>{{i.product_category_code}} {{i.product_category_description}}</td><td>{{i.dest_code}} {{i.dest_description}}</td><td>{{i.delivery_code}} {{i.delivery_description}}</td><th>{{i.missing_count}}</th></tr></tbody></table></div>");
$templateCache.put("lm/guestsRebaser/load/guestsrebaser_tableMode.html","<div class=\"table-responsive\"><table class=\"table table-rebaser\"><tr><td></td><td class=\"table-number\" ng-repeat=\"n in range(element.column_number)\"><h4>{{$index}}</h4></td></tr><tr ng-repeat=\"(key, value) in matrixData\"><td>{{key.toUpperCase()}}</td><td ng-repeat=\"j in value\"><button class=\"btn btn-small btn-rebaser empty btn-block\" data-toggle=\"modal\" data-target=\"#myModal\" ng-click=\"getInfoFromCell(key,j)\" popover-title=\"Contenuto\" ng-class=\"{\'full\': j.full }\" uib-popover-template=\"resabser_cell_template\" popover-trigger=\"mouseenter\">{{j.sz - j.comp.length}}/{{j.sz}}</button></td></tr></table></div>");
$templateCache.put("lm/guestsRebaser/unload/guestsrebaser_unload_panel.html","<div class=\"well clearfix\"><div class=\"col-md-4 no-pad pull-left\"><div class=\"col-md-12\" ng-if=\"unloadGarment.type == \'INDIVIDUAL\'\" style=\"padding-top: 10px; padding-bottom: 10px;\"><label class=\"col-md-3\">Nucleo:</label><div class=\"col-md-9\"><div class=\"input-group\"><select class=\"form-control\" ng-model=\"selected.productCategory\" ng-options=\"p as p.product_cat_cd + \' - \' + p.product_cat_de for p in productCategory.list\"></select><span class=\"input-group-btn\"><button class=\"btn btn-info rebaser-btn-close\" ng-click=\"resetProductCategory()\"><i class=\"fa fa-close\"></i></button></span></div></div></div><div class=\"col-md-12\" ng-if=\"unloadGarment.type == \'INDIVIDUAL\'\" style=\"padding-top: 10px; padding-bottom: 10px;\"><label class=\"col-md-3\">Reparto:</label><div class=\"col-md-9\"><div class=\"input-group\"><select class=\"form-control\" ng-model=\"selected.ward\" ng-options=\"w as w.cd_cd + \' - \' + w.cd_de for w in ward.list\"></select><span class=\"input-group-btn\"><button class=\"btn btn-info rebaser-btn-close\" ng-click=\"resetWard()\"><i class=\"fa fa-close\"></i></button></span></div></div></div><div class=\"col-md-12\" ng-if=\"unloadGarment.type == \'INDIVIDUAL\'\" style=\"padding-top: 10px; padding-bottom: 10px;\"><label class=\"col-md-3\">Ospite:</label><div class=\"col-md-9\"><div class=\"input-group\"><select class=\"form-control\" ng-model=\"selected.employee\" ng-options=\"e as e.matr + \' - \' + e.name + \' \' + e.surname for e in employee.list\"></select><span class=\"input-group-btn\"><button class=\"btn btn-info rebaser-btn-close\" ng-click=\"resetEmployee()\"><i class=\"fa fa-close\"></i></button></span></div></div></div><div class=\"col-md-12\" style=\"padding-top: 10px; padding-bottom: 10px;\"><label class=\"col-md-3\">Lettura:</label><div class=\"col-md-9\"><six-code-reader sx-on-read=\"readUnloadComponent(read)\" sx-read-mode=\"cartReaderMode\"><six-code-reader></six-code-reader></six-code-reader></div></div></div><div class=\"col-md-8\" ng-if=\"unloadList == undefined && unloadMap == undefined && unloadKey == undefined\"><h3 style=\"margin-top: 10px;\">Non ci sono celle da scaricare con il criterio selezionato.</h3></div><div class=\"col-md-8\" ng-if=\"unloadList != undefined && unloadMap != undefined && unloadKey != undefined\"><h3 style=\"margin-top: 10px;\">Celle scaricabili:</h3></div><div class=\"col-md-8\" style=\"padding-top: 10px; padding-bottom: 10px;\"><div class=\"col-md-2\" ng-repeat=\"obj in matrixStructure[unloadKey].list\" style=\"padding-bottom: 10px;\"><div class=\"btn btn-danger btn-unload btn-block\">{{obj.r}}{{obj.c}} (Num. capi: {{printComponentNumbersForSingleCell(obj.r, obj.c)}})</div></div></div></div><div class=\"wrapper col-md-12\"><table class=\"table\"><thead><tr><th>Ospite</th><th>Matricola</th><th>Nucleo</th><th>Reparto</th><th>Punto di Consegna</th><th>Elenco celle occupate</th><th>Totale capi</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in matrixStructure\"><td ng-class=\"{ \'unloadrow\': (k == unloadKey)}\">{{matrixStructure[k].data.e_name}}<br>{{matrixStructure[k].data.e_surname}}</td><td ng-class=\"{ \'unloadrow\': (k == unloadKey)}\">{{matrixStructure[k].data.e_matr}}</td><td ng-class=\"{ \'unloadrow\': (k == unloadKey)}\"><b>{{matrixStructure[k].data.product_cat_cd}}</b> {{matrixStructure[k].data.product_cat_de}}</td><td ng-class=\"{ \'unloadrow\': (k == unloadKey)}\"><b>{{matrixStructure[k].data.cde_cd}}</b> {{matrixStructure[k].data.cde_de}}</td><td ng-class=\"{ \'unloadrow\': (k == unloadKey)}\"><b>{{matrixStructure[k].data.delivery_cd}}</b> {{matrixStructure[k].data.delivery_de}}</td><td ng-class=\"{ \'unloadrow\': (k == unloadKey)}\" ng-bind-html=\"printArray(v.list)\"></td><td ng-class=\"{ \'unloadrow\': (k == unloadKey)}\">{{printComponentNumbers(v.list)}}</td></tr></tbody></table></div>");
$templateCache.put("lm/highVisibilityComponent/high-visibility-component-history-modal/high-visibility-component-history-modal.html","<div class=\"modal-content\" style=\"margin-top: -100px\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">{{ \"component\" | translate }} {{$ctrl.component.unicode}}</h4></div><div class=\"modal-body\"><div class=\"table-responsive\" style=\"height: 350px\"><table class=\"table table-striped b-t b-light\"><thead><tr><th>{{\"status\" | translate}}</th><th>{{\"date\" | translate}}</th></tr></thead><tbody><tr ng-repeat=\"item in $ctrl.list.list\"><td><span class=\"text-ellipsis\">{{item.status_str}}</span></td><td><span class=\"text-ellipsis\">{{item.operation_date_str}}</span></td></tr></tbody></table></div></div></div>");
$templateCache.put("lm/inventory/collected/deletion-confirm.html","<div class=\"modal-dialog modal-sm\"><div class=\"modal-content\"><div class=\"modal-body\"><h4>Confermi la cancellazione di <b>{{ row.amount_detected }}</b> per {{ row.product_description }} ({{ row.product_code }}) in {{ row.facility_description }}?</h4></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">OK</button> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Cancel</button></div></div></div>");
$templateCache.put("lm/patient/patientComponentMatch/patientComponentMatch.html","<six-toolbar static-title=\"Associazione capo-ospite\"><six-toolbar-button icon=\"fa fa-chevron-left\" class=\"btn btn-xl pull-left-xs\" label=\"Esci\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 center-page m-t-toolbar\"><div class=\"panel panel-default\"><div class=\"wrapper\"><div class=\"panel-body\"><h4 class=\"h4 m-b-md\">{{progress.message}}</h4><div class=\"progress-xs progress ng-isolate-scope\" value=\"progress.percent\" type=\"success\"><div class=\"progress-bar progress-bar-primary\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: progress.percent + \'%\'}\"></div></div><div class=\"row\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Ospite</label><six-lookup ng-model=\"lookup.patient_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.patient_id\" sx-filter=\"patFilter\" sx-type=\"\'human_resource\'\" sx-placeholder=\"Seleziona ospite...\" sx-relational=\"true\" sx-disabled=\"step.index!==1\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Nome</label> <input type=\"text\" class=\"form-control\" placeholder=\"Nome\" ng-model=\"element.name\" ng-readonly=\"step.index!==1\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Cognome</label> <input type=\"text\" class=\"form-control\" placeholder=\"Cognome\" ng-model=\"element.surname\" ng-readonly=\"step.index!==1\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Sesso</label><six-enum ng-if=\"element\" sx-model=\"element\" sx-field=\"sex\" sx-options=\"enum.sex\" sx-readonly=\"step.index!==1\"></six-enum></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Reparto</label><six-lookup ng-model=\"lookup.destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.destination_id\" sx-filter=\"repFilter\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona reparto...\" sx-relational=\"true\" sx-disabled=\"step.index!==1\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Punto di consegna</label><six-lookup ng-model=\"lookup.delivery_destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.delivery_destination_id\" sx-filter=\"pdcFilter\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona punto di consegna...\" sx-relational=\"true\" sx-disabled=\"step.index!==1\"></six-lookup></div></div></div><div class=\"row\" style=\"margin-top:20px\"><button ng-click=\"setPatient()\" class=\"btn btn-xl btn-info equal-margin-left-right\" ng-disabled=\"step.index!==1\"><span class=\"fa fa-plus\"></span> CONFERMA</button> <button ng-click=\"previousStep()\" class=\"btn btn-xl btn-info equal-margin-left-right\" ng-disabled=\"step.index===1\"><span class=\"fa fa-chevron-left\"></span> INDIETRO</button></div></div><div class=\"row\"><div class=\"col-md-12 b-b b-b-3x b-b-info\" style=\"margin-top:20px; margin-bottom: 10px\"></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-3\"><label class=\"control-label\">Articolo a contratto</label><six-lookup ng-model=\"lookup.product_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-disabled=\"step.index===1\" sx-id=\"advFilter.filter.product_id\" sx-type=\"\'product\'\" sx-relational=\"true\" sx-filter=\"productFilter\"></six-lookup></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Usura</label><six-enum ng-if=\"element\" sx-model=\"wear\" sx-field=\"code\" sx-options=\"enum.wear\"></six-enum></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Colore</label><six-enum ng-if=\"element\" sx-model=\"color\" sx-field=\"id\" sx-options=\"enum.color\"></six-enum></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label>Taglia</label><six-enum ng-if=\"element\" sx-model=\"size\" sx-field=\"id\" sx-options=\"enum.size\"></six-enum></div></div></div><div class=\"row\"><div class=\"col-md-6\"><label class=\"control-label\">Lettore unicode</label><six-code-reader sx-on-read=\"readComponentCode(read)\" sx-read-mode=\"compReaderMode\" sx-disabled=\"step.index===1\"><six-code-reader></six-code-reader></six-code-reader></div></div><div class=\"row\" style=\"padding-top:20px\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Note</label> <textarea class=\"sf-form-control form-control\" ng-model=\"componentNote\"></textarea></div></div></div></div></div></div></div></div><div class=\"panel panel-default\"><div class=\"wrapper\"><div class=\"panel-body\"><div class=\"row padder\"><div class=\"col-md-12\"><table class=\"table m-b-none\"><thead><tr><th></th><th>{{ \'Barcode\' | translate }}</th><th>{{ \'Codice articolo\' | translate }}</th><th>{{ \'Descrizione articolo\' | translate }}</th><th>{{ \'Matricola ospite\' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"m in matchList.slice().reverse()\"><td><button ng-click=\"decoupleComponent(m.id)\" class=\"btn btn-xl btn-info equal-margin-left-right\"><span class=\"fa fa-trash\"></span></button></td><td>{{m.barcode}}</td><td>{{m.product_code}}</td><td>{{m.product_description}}</td><td>{{m.patient_matriculation}}</td></tr></tbody></table></div></div></div></div></div><six-confirm-modal sx-title=\"modal.title\" sx-message=\"modal.message\" sx-on-confirm=\"modal.callback\"></six-confirm-modal></div>");
$templateCache.put("lm/patient/patientDirtAcceptance/patientDirtAcceptance.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" class=\"btn btn-xl pull-left-xs\" label=\"Esci\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 center-page\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"page-title m-t-toolbar\"><h1 class=\"m-n font-thin h3 text-black\">{{ \'patient.dirt_fn_title\' | translate }}</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col col-md-6\"><div class=\"row wrapper\"><div class=\"col-md-7\"><div class=\"form-group\"><label>Cliente</label><six-lookup ng-model=\"lookup.customer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"customer.id\" sx-type=\"\'customer\'\" sx-placeholder=\"Seleziona cliente...\" sx-relational=\"true\" sx-disabled=\"urlCustomer\"></six-lookup></div></div></div><div class=\"row wrapper\"><div class=\"col-md-9\"><div class=\"m-b-md\"><label>{{ \'patient.reading\' | translate }}</label><six-code-reader sx-on-read=\"readComponentCode(read)\" sx-read-mode=\"compReaderMode\" sx-disabled=\"!lookup.customer_id.obj && !urlCustomer\"><six-code-reader></six-code-reader></six-code-reader></div></div></div></div><div class=\"col col-md-3 bg-success\" style=\"height: 150px\"><label class=\"m-n font-thick h5 text-black\" style=\"padding-top: 10px; padding-bottom: 15px\">Programmi lavaggio ultima lettura</label> <span ng-repeat=\"w in compList.slice(-1)[0].wash_codes\" style=\"padding-right: 1em; color: black\">{{ w }}</span></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><h1 class=\"m-n font-thin h4 text-black\" style=\"padding-bottom: 20px\">{{ \'patient.readings_list\' | translate }}</h1><table class=\"table m-b-none\"><thead><tr><th>Barcode</th><th>{{ \'patient.product_code\' | translate }}</th><th>{{ \'patient.product_description\' | translate }}</th><th>{{ \'patient.customer\' | translate }}</th><th>{{ \'patient.material_description\' | translate }}</th><th>{{ \'patient.wash_code\' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"c in compList.slice().reverse()\"><td>{{c.barcode}}</td><td>{{c.product_code}}</td><td>{{c.product_description}}</td><td>{{c.customer_code}}</td><td>{{c.material_description}}</td><td><span ng-repeat=\"w in c.wash_codes\" style=\"padding-right: 1em\">{{ w }}</span></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("lm/rebaser/load/rebaser_listMode.html","<table class=\"table table-striped\"><thead><tr><th>Operatore</th><th>Matricola</th><th>Destinazione</th><th>Prodotto</th><th>Misura</th><th>Elenco celle occupate</th><th>Totale capi</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in matrixStructure\"><td>{{matrixStructure[k].data.e_name}} {{matrixStructure[k].data.e_surname}}</td><td>{{matrixStructure[k].data.e_matr}}</td><td>{{matrixStructure[k].data.cd_cd}} {{matrixStructure[k].data.c_d_de}}</td><td>{{matrixStructure[k].data.p_cd}} - {{matrixStructure[k].data.p_de}}</td><td>{{matrixStructure[k].data.sz_cd}}</td><td ng-bind-html=\"printArray(v.list)\"></td><td>{{printComponentNumbers(v.list)}}</td></tr></tbody></table>");
$templateCache.put("lm/rebaser/load/rebaser_load_panel.html","<locked-modal sx-component=\"lockedComponent\"></locked-modal><div class=\"well clearfix\" ng-if=\"type != \'MISSING_COMPONENTS\'\"><div class=\"col-md-5 no-pad pull-left\"><div class=\"form-group\"><label class=\"col-md-3\">Guardaroba:</label><div class=\"col-md-9\"><six-lookup ng-model=\"lookup.wardrobe\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"selected.wardrobe\" sx-type=\"\'customer_destination\'\" sx-filter=\"wardrobeFilter\" sx-relational=\"true\" sx-placeholder=\"Seleziona guardaroba...\" sx-on-clear=\"resetWardrobe()\"></six-lookup></div></div><div class=\"form-group\" ng-if=\"selected.wardrobe\"><div class=\"clearfix\"></div><br><label class=\"col-md-3\">Modalità lettura:</label><div class=\"col-md-9\"><div class=\"btn-group-rebaser btn-group-justified\"><label class=\"btn btn-success rebaser btn-md col-md-6\" ng-model=\"mode.value\" uib-btn-radio=\"\'INSERT\'\">Aggiungi</label> <label class=\"btn btn-danger rebaser btn-md col-md-6\" ng-model=\"mode.value\" uib-btn-radio=\"\'DELETE\'\">Elimina</label></div></div><div class=\"clearfix\"></div></div><div class=\"form-group\" ng-if=\"selected.wardrobe\"><label class=\"col-md-3\">Lettura componente:</label><div class=\"col-md-9\"><six-code-reader sx-on-read=\"readLoadComponent(read)\" sx-read-mode=\"cartReaderMode\"><six-code-reader></six-code-reader></six-code-reader></div></div></div><div class=\"col-md-4 no-pad\" ng-repeat=\"c in lastReadCodes | reverse\" style=\"padding: 0px;\"><div ng-if=\"c.found && !c.locked\"><div class=\"col-md-6\" ng-if=\"alreadyInsertedCell == undefined && lastInsertedCell != undefined\"><button class=\"btn btn-rebaser-big green btn-block\" ng-click=\"saveCellAsFull(lastInsertedCell.r, lastInsertedCell.c, c.comp)\" id=\"remove-button\" ng-class=\"{\'btn-pressed\': !addMode}\">{{lastInsertedCell.r}}{{lastInsertedCell.c}}</button></div><div class=\"col-md-6\" ng-if=\"alreadyInsertedCell != undefined\"><button class=\"btn btn-rebaser-big blu btn-block\" id=\"remove-button\" data-toggle=\"modal\" data-target=\"#myModal\" popover-title=\"Contenuto\" uib-popover-template=\"resabser_cell_template\" popover-trigger=\"mouseenter\">{{alreadyInsertedCell.r}}{{alreadyInsertedCell.c}}</button></div><div class=\"col-md-6\" ng-if=\"lastInsertedCell != undefined || alreadyInsertedCell != undefined\"><button class=\"btn btn-rebaser-big btn-block\" ng-click=\"undoInsertComponent(c.comp)\" id=\"remove-button\" ng-class=\"{\'btn-pressed\': !addMode}\">ANNULLA</button></div></div></div><div class=\"col-md-3\" ng-if=\"lastReadCodes.length > 0\" ng-repeat=\"c in lastReadCodes | reverse\"><div ng-if=\"c.found && !c.locked\"><h3 style=\"margin-top: 0px;\">Barcode <b>{{c.comp.barcode}}</b></h3><hr style=\"margin-top: 10px; margin-bottom: 10px;\"><h4>{{getType(c.comp.special_use)}}</h4><hr style=\"margin-top: 10px; margin-bottom: 10px;\"><h4>Articolo: <b>{{c.comp.product_code}}</b> - {{c.comp.product_description}}</h4></div><div ng-if=\"!c.found\">Componente non trovato</div><div ng-if=\"c.locked\">Componente bloccato</div></div></div><div class=\"well clearfix\" ng-if=\"type == \'MISSING_COMPONENTS\'\"><div class=\"wrapper col-md-12\"><div ng-include=\"\'lm/rebaser/load/rebaser_missingComponents.html\'\"></div></div></div><div class=\"modal fade\" id=\"myModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Contenuto della cella</h4></div><div class=\"modal-body no-padding\"><div class=\"alert alert-warning clearfix\"><div class=\"col-md-12 no-pad\"><b>Dipendente:</b> {{infoCell.e_matr}} - {{infoCell.e_name}} {{infoCell.e_surname}}</div><div class=\"col-md-12 no-pad\"><b>Dest. cliente:</b> {{infoCell.cd_cd}} - {{infoCell.cd_de}}</div><div class=\"col-md-12 no-pad\"><b>Articolo:</b> {{infoCell.p_cd}} - {{infoCell.p_de}}</div></div><div class=\"table-responsive\"><table class=\"table table-striped\"><tr ng-repeat=\"key in infoCell.content.comp\"><td width=\"20\"><i class=\"fa fa-flag\" aria-hidden=\"true\"></i></td><td>{{key.barcode}}</td><td>{{key.product_code}}</td><td>{{key.product_description}}</td><td>{{key.size_code}}</td></tr></table></div></div></div></div></div><div class=\"row\"><div class=\"wrapper col-md-12\" ng-if=\"type == \'TABLE\'\"><div ng-include=\"\'lm/rebaser/load/rebaser_tableMode.html\'\"></div></div><div class=\"wrapper\" ng-if=\"type == \'LIST\'\"><div ng-include=\"\'lm/rebaser/load/rebaser_listMode.html\'\"></div></div></div>");
$templateCache.put("lm/rebaser/load/rebaser_missingComponents.html","<div class=\"clearfix\"><table class=\"table table-striped\"><thead><tr><th>Operatore</th><th>Matricola</th><th>Destinazione</th><th>Prodotto</th><th>Misura</th><th>Capi mancanti</th></tr></thead><tbody><tr ng-repeat=\"i in missingComponents.list\"><td>{{i.employee_name}} {{i.employee_surname}}</td><td>{{i.employee_matriculation}}</td><td>{{i.customer_destination_emp_code}} {{i.customer_destination_emp_description}}</td><td>{{i.product_code}} {{i.product_description}}</td><td>{{i.size_code}}</td><th>{{i.missing_count}}</th></tr></tbody></table></div>");
$templateCache.put("lm/rebaser/load/rebaser_tableMode.html","<div class=\"table-responsive\"><table class=\"table table-rebaser\"><tr><td></td><td class=\"table-number\" ng-repeat=\"n in range(element.column_number)\"><h4>{{$index}}</h4></td></tr><tr ng-repeat=\"(key, value) in matrixData\"><td>{{key.toUpperCase()}}</td><td ng-repeat=\"j in value\"><button class=\"btn btn-small btn-rebaser empty btn-block\" data-toggle=\"modal\" data-target=\"#myModal\" ng-click=\"getInfoFromCell(key,j)\" popover-title=\"Contenuto\" ng-class=\"{\'full\': j.full }\" uib-popover-template=\"resabser_cell_template\" popover-trigger=\"mouseenter\">{{j.sz - j.comp.length}}/{{j.sz}}</button></td></tr></table></div>");
$templateCache.put("lm/rebaser/locked-modal/locked-modal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\"><i class=\"fa fa-warning m-r\"></i>Capo bloccato</h4></div><div class=\"modal-body no-padding\"><div class=\"alert alert-danger clearfix\"><div class=\"row\"><div class=\"col-md-12\"><b>Barcode:</b> {{$ctrl.sxComponent.barcode}}</div><div class=\"col-md-12\"><b>Articolo:</b> {{$ctrl.sxComponent.product_code}} - {{$ctrl.sxComponent.product_description}}</div><div class=\"col-md-12\"><b>Causale di bloccaggio:</b> {{$ctrl.controlReason.code}} - {{$ctrl.controlReason.description}}</div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"$close(true)\">OK</button></div></div>");
$templateCache.put("lm/rebaser/unload/rebaser_unload_panel.html","<div class=\"well clearfix\"><div class=\"col-md-6 no-pad pull-left\"><div class=\"col-md-12\" style=\"padding-top: 10px; padding-bottom: 10px;\"><label class=\"col-md-2\">Scarico:</label><div class=\"col-md-10\"><div class=\"btn-group-rebaser btn-group-justified\"><label class=\"btn btn-primary rebaser btn-md col-md-6\" ng-model=\"unloadGarment.type\" uib-btn-radio=\"\'GENERIC\'\">Non personalizzata</label> <label class=\"btn btn-primary rebaser btn-md col-md-6\" ng-model=\"unloadGarment.type\" uib-btn-radio=\"\'INDIVIDUAL\'\">Personalizzata</label></div></div></div><div class=\"col-md-12\" ng-if=\"unloadGarment.type == \'GENERIC\'\" style=\"padding-top: 10px; padding-bottom: 10px;\"><label class=\"col-md-3\">Guardaroba:</label><div class=\"col-md-9\"><six-lookup ng-model=\"lookup.wardrobe\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"selected.wardrobe\" sx-type=\"\'customer_destination\'\" sx-filter=\"wardrobeFilter\" sx-relational=\"true\" sx-placeholder=\"Seleziona guardaroba...\" sx-on-clear=\"resetWardrobe()\"></six-lookup></div></div><div class=\"col-md-12\" ng-if=\"unloadGarment.type == \'INDIVIDUAL\'\" style=\"padding-top: 10px; padding-bottom: 10px;\"><label class=\"col-md-3\">Reparto:</label><div class=\"col-md-9\"><div class=\"input-group\"><select class=\"form-control\" ng-model=\"selected.ward\" ng-options=\"w as w.cd_cd + \' - \' + w.cd_de for w in ward.list\"></select><span class=\"input-group-btn\"><button class=\"btn btn-info rebaser-btn-close\" ng-click=\"resetWard()\"><i class=\"fa fa-close\"></i></button></span></div></div></div><div class=\"col-md-12\" ng-if=\"unloadGarment.type == \'INDIVIDUAL\'\" style=\"padding-top: 10px; padding-bottom: 10px;\"><label class=\"col-md-3\">Dipendente:</label><div class=\"col-md-9\"><div class=\"input-group\"><select class=\"form-control\" ng-model=\"selected.employee\" ng-options=\"e as e.matr + \' - \' + e.name + \' \' + e.surname for e in employee.list\"></select><span class=\"input-group-btn\"><button class=\"btn btn-info rebaser-btn-close\" ng-click=\"resetEmployee()\"><i class=\"fa fa-close\"></i></button></span></div></div></div><div class=\"col-md-12\" style=\"padding-top: 10px; padding-bottom: 10px;\"><label class=\"col-md-3\">Lettura:</label><div class=\"col-md-9\"><six-code-reader sx-on-read=\"readUnloadComponent(read)\" sx-read-mode=\"cartReaderMode\"><six-code-reader></six-code-reader></six-code-reader></div></div></div><div class=\"col-md-6\" ng-if=\"unloadList == undefined && unloadMap == undefined && unloadKey == undefined\"><h3 style=\"margin-top: 10px;\">Non ci sono celle da scaricare con il criterio selezionato.</h3></div><div class=\"col-md-8\" ng-if=\"unloadList != undefined && unloadMap != undefined && unloadKey != undefined\"><h3 style=\"margin-top: 10px;\">Celle scaricabili:</h3></div><div class=\"col-md-8\" style=\"padding-top: 10px; padding-bottom: 10px;\"><div class=\"col-md-4\" ng-repeat=\"obj in matrixStructure[unloadKey].list\"><div class=\"btn btn-danger btn-unload btn-md-4\">{{obj.r}}{{obj.c}} (Num. capi: {{printComponentNumbersForSingleCell(obj.r, obj.c)}})</div></div></div></div><div class=\"wrapper col-md-12\"><table class=\"table\"><thead><tr><th>Dipendente</th><th>Matricola</th><th>Reparto</th><th>Destinazione</th><th>Prodotto</th><th>Misura</th><th>Elenco celle occupate</th><th>Totale capi</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in matrixStructure\"><td ng-class=\"{ \'unloadrow\': (k == unloadKey)}\">{{matrixStructure[k].data.e_name}}<br>{{matrixStructure[k].data.e_surname}}</td><td ng-class=\"{ \'unloadrow\': (k == unloadKey)}\">{{matrixStructure[k].data.e_matr}}</td><td ng-class=\"{ \'unloadrow\': (k == unloadKey)}\"><strong>{{matrixStructure[k].data.cde_cd}}</strong><br>{{matrixStructure[k].data.cde_de}}</td><td ng-class=\"{ \'unloadrow\': (k == unloadKey)}\">{{matrixStructure[k].data.cd_cd}} {{matrixStructure[k].data.cd_de}}</td><td ng-class=\"{ \'unloadrow\': (k == unloadKey)}\">{{matrixStructure[k].data.p_cd}} - {{matrixStructure[k].data.p_de}}</td><td ng-class=\"{ \'unloadrow\': (k == unloadKey)}\">{{matrixStructure[k].data.sz_cd}}</td><td ng-class=\"{ \'unloadrow\': (k == unloadKey)}\" ng-bind-html=\"printArray(v.list)\"></td><td ng-class=\"{ \'unloadrow\': (k == unloadKey)}\">{{printComponentNumbers(v.list)}}</td></tr></tbody></table></div>");
$templateCache.put("lm/xversus/component/component_detail.html","<six-toolbar title=\"pageTitle\"><six-toolbar-button label=\"Indietro\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"m-t-xl\"><div class=\"panel panel-default\"><div class=\"panel-body\"><uib-tabset justified=\"false\" active=\"activeTab\" class=\"tab-container\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"tab-heading\">Testata</span></uib-tab-heading><div ng-include=\"\'lm/xversus/component/component_tabHead.html\'\" ng-if=\"element\"></div></uib-tab><uib-tab index=\"1\"><uib-tab-heading><span class=\"tab-heading\">Storico</span></uib-tab-heading><div ng-include=\"\'lm/xversus/component/component_tabHistory.html\'\"></div></uib-tab><uib-tab index=\"2\"><uib-tab-heading><span class=\"tab-heading\">Allegati</span></uib-tab-heading><div ng-include=\"\'lm/xversus/component/component_tabAttachment.html\'\"></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("lm/xversus/component/component_list.html","<six-toolbar title=\"\'Componenti\'\"></six-toolbar><div class=\"wrapper-md m-t-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3\"><label>Barcode</label> <input type=\"text\" class=\"form-control\" ng-model=\"advFilter.filter.barcode\"></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">Articolo</label><six-lookup ng-model=\"lookup.product_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.product_id\" sx-type=\"\'product\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">Taglia</label><six-lookup ng-model=\"lookup.size_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.size_id\" sx-type=\"\'tab_size\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-hide-code=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">Dipendente</label><six-lookup ng-model=\"lookup.employee_id\" sx-filter=\"lookup.employee_id.filter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.employee_id\" sx-type=\"\'human_resource\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-hide-code=\"true\" sx-sort-fields=\"[\'surname\',\'name\']\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">Presidio Uso DPI</label><six-lookup ng-model=\"lookup.customer_id\" sx-filter=\"customerFilter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.customer_id\" sx-type=\"\'customer\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-disabled=\"lockCustomer\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">Lotto</label><six-lookup ng-model=\"lookup.lot_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.lot_id\" sx-type=\"\'lot\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-hide-code=\"true\"></six-lookup></div><div class=\"col-md-3\"><label id=\"type_label\" class=\"control-label\">Sede di utilizzo DPI</label><six-lookup ng-model=\"lookup.current_destination_id\" sx-filter=\"lookup.current_destination_id.filter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.current_destination_id\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-hide-code=\"true\"></six-lookup></div></div></div></div><div class=\"panel panel-default\"><six-grid-pagination ng-if=\"sf\" get-data-callback=\"getData()\" get-list-callback=\"getData()\" get-all-data-callback=\"getAllData()\" items-list=\"list\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div>");
$templateCache.put("lm/xversus/component/component_tabAttachment.html","<div class=\"row\"><div class=\"col-md-12\"><six-statix path=\"statix.path\" ng-model=\"statix.model\" show-upload=\"isUploadAllowed\" show-preview=\"false\" show-delete=\"isDeleteUploadAllowed\"></six-statix></div></div>");
$templateCache.put("lm/xversus/component/component_tabHead.html","<div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Barcode</label> <input type=\"text\" class=\"form-control\" placeholder=\"Barcode\" ng-model=\"element.barcode\" ng-readonly=\"readOnly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Unicode</label> <input type=\"text\" class=\"form-control\" placeholder=\"Unicode\" ng-model=\"element.unicode\" ng-readonly=\"readOnly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Lavaggi</label> <input type=\"number\" class=\"form-control\" ng-model=\"element.wash_num\" ng-readonly=\"readOnly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Articolo</label><six-lookup ng-model=\"lookup.product_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.product_id\" sx-type=\"\'product\'\" sx-placeholder=\"Seleziona articolo...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Colore</label><six-lookup ng-model=\"lookup.color_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.color_id\" sx-type=\"\'color\'\" sx-placeholder=\"Seleziona colore...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Dipendente</label><six-lookup ng-model=\"lookup.employee_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.employee_id\" sx-type=\"\'human_resource\'\" sx-placeholder=\"Seleziona dipendente...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Taglia</label><six-lookup ng-model=\"lookup.size_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.size_id\" sx-type=\"\'tab_size\'\" sx-placeholder=\"Seleziona taglia...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Lotto</label><six-lookup ng-model=\"lookup.lot_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.lot_id\" sx-type=\"\'lot\'\" sx-placeholder=\"Seleziona lotto...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Peso</label> <input type=\"number\" class=\"form-control\" ng-model=\"element.weight\" ng-readonly=\"readOnly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Uso</label><six-enum ng-if=\"element\" sx-model=\"element\" sx-field=\"special_use\" sx-options=\"enum.special_use\" sx-readonly=\"readOnly\"></six-enum></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Sede di utilizzo DPI</label><six-lookup ng-model=\"lookup.current_destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.current_destination_id\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona sede...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div></div>");
$templateCache.put("lm/xversus/component/component_tabHistory.html","<div class=\"row\"><div class=\"col-md-12\"><six-component-status-grid sx-entity=\"component_status\" sx-detail-button=\"false\"></six-component-status-grid></div></div>");
$templateCache.put("lm/xversus/employee/employee_detail.html","<six-toolbar title=\"pageTitle\"><six-toolbar-button label=\"Indietro\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"padder-md m-t-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><uib-tabset justified=\"false\" active=\"activeTab\" class=\"tab-container\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"tab-heading\">Testata</span></uib-tab-heading><div ng-include=\"\'lm/xversus/employee/employee_tabHead.html\'\" ng-if=\"element\"></div></uib-tab><uib-tab index=\"1\"><uib-tab-heading><span class=\"tab-heading\">Storico</span></uib-tab-heading><div ng-include=\"\'lm/xversus/employee/employee_tabHistory.html\'\"></div></uib-tab><uib-tab index=\"2\"><uib-tab-heading><span class=\"tab-heading\">Componenti</span></uib-tab-heading><div ng-include=\"\'lm/xversus/employee/employee_tabComponents.html\'\"></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("lm/xversus/employee/employee_list.html","<six-toolbar title=\"\'Dipendenti\'\"><six-toolbar-button label=\"Indietro\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"wrapper-md m-t-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-4 m-t-xs\"><label id=\"type_label\" class=\"control-label\">Dipendente</label><six-lookup ng-model=\"lookup.employee_id\" sx-filter=\"lookup.employee_id.filter\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.employee_id\" sx-type=\"\'human_resource\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-hide-code=\"true\" sx-sort-fields=\"[\'surname\',\'name\']\"></six-lookup></div><div class=\"col-md-4 m-t-xs\"><label id=\"type_label\" class=\"control-label\">Presidio Uso DPI</label><six-lookup ng-model=\"lookup.customer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.customer_id\" sx-type=\"\'customer\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-disabled=\"lockCustomer\" sx-filter=\"customerFilter\"></six-lookup></div><div class=\"col-md-4 m-t-xs\"><label id=\"type_label\" class=\"control-label\">Sede di utilizzo DPI</label><six-lookup ng-model=\"lookup.destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.destination_id\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-disabled=\"lockCustomer\" sx-filter=\"lookup.destination_id.filter\"></six-lookup></div><div class=\"col-md-4 m-t-xs\"><label id=\"type_label\" class=\"control-label\">U.O./Servizio di appartenenza</label><six-lookup ng-model=\"lookup.customer_cost_center_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.customer_cost_center_id\" sx-type=\"\'customer_cost_center\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-disabled=\"lockCustomer\" sx-filter=\"lookup.customer_cost_center_id.filter\"></six-lookup></div><div class=\"col-md-4 m-t-xs\"><label id=\"type_label\" class=\"control-label\">Punto di consegna dpi</label><six-lookup ng-model=\"lookup.delivery_destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"advFilter.filter.delivery_destination_id\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona un valore...\" sx-relational=\"true\" sx-disabled=\"lockCustomer\" sx-filter=\"lookup.delivery_destination_id.filter\"></six-lookup></div></div></div></div><div class=\"panel panel-default\"><six-grid-pagination ng-if=\"sf\" get-data-callback=\"getData()\" get-list-callback=\"getData()\" get-all-data-callback=\"getAllData()\" items-list=\"list\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div>");
$templateCache.put("lm/xversus/employee/employee_tabComponents.html","<div class=\"row\"><div class=\"col-md-12\"><six-detail-grid sx-entity=\"component\" sx-detail-link=\"componentDetailLink\"></six-detail-grid></div></div>");
$templateCache.put("lm/xversus/employee/employee_tabHead.html","<div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Matricola sistema</label> <input type=\"text\" class=\"form-control\" placeholder=\"Matricola\" ng-model=\"element.matriculation\" ng-readonly=\"readOnly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Cognome</label> <input type=\"text\" class=\"form-control\" placeholder=\"Cognome\" ng-model=\"element.surname\" ng-readonly=\"readOnly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Nome</label> <input type=\"text\" class=\"form-control\" placeholder=\"Nome\" ng-model=\"element.name\" ng-readonly=\"readOnly\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Sesso</label><six-enum ng-if=\"element\" sx-model=\"element\" sx-field=\"sex\" sx-options=\"enum.sex\" sx-readonly=\"readOnly\"></six-enum></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Qualifica</label><six-lookup ng-model=\"lookup.work_task_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.work_task_id\" sx-type=\"\'work_task\'\" sx-placeholder=\"Seleziona qualifica...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>AUSL</label><six-lookup ng-model=\"lookup.bill_to_customer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.bill_to_customer_id\" sx-type=\"\'customer\'\" sx-placeholder=\"Seleziona AUSL...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Presidio Uso DPI</label><six-lookup ng-model=\"customerLookup.customer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"customer.id\" sx-type=\"\'customer\'\" sx-placeholder=\"Seleziona ospedale...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Sede di utilizzo dpi</label><six-lookup ng-model=\"lookup.destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.destination_id\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona reparto...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Assegnazione taglie</label><six-date-picker ng-model=\"element.first_size_assignment\" sx-disabled=\"readOnly\"></six-date-picker></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>U.O./Servizio di appartenenza</label><six-lookup ng-model=\"lookup.customer_cost_center_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.customer_cost_center_id\" sx-type=\"\'customer_cost_center\'\" sx-placeholder=\"Seleziona CdC...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Punto di consegna dpi</label><six-lookup ng-model=\"lookup.delivery_destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"element.delivery_destination_id\" sx-type=\"\'customer_destination\'\" sx-placeholder=\"Seleziona reparto...\" sx-relational=\"true\" sx-disabled=\"readOnly\"></six-lookup></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Prima vestizione</label><six-date-picker ng-model=\"element.first_component_association\" sx-disabled=\"readOnly\"></six-date-picker></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Fine servizio</label><six-date-picker ng-model=\"element.validity_end\" sx-disabled=\"readOnly\"></six-date-picker></div></div><div class=\"col-md-8\"><div class=\"form-group\"><label>Note</label> <textarea class=\"sf-form-control form-control\" ng-model=\"element.note\" ng-disabled=\"readOnly\"></textarea></div></div></div>");
$templateCache.put("lm/xversus/employee/employee_tabHistory.html","<div class=\"row\"><div class=\"col-md-12\"><six-detail-grid sx-entity=\"employee_history\" sx-detail-button=\"false\"></six-detail-grid></div></div>");
$templateCache.put("plan/portal/issue/issue_detail.html","<six-toolbar><six-toolbar-item label=\"Segnalazione n. {{data.model.code}} - {{data.status}}\" ng-show=\"data.version\"></six-toolbar-item><six-toolbar-item label=\"Nuova segnalazione\" ng-show=\"!data.version\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Aggiungi\" btn-class=\"btn-success\" icon=\"fa fa-plus\" disabled=\"!(schemaIssueDefined)\" toolbar-function=\"update()\" sx-disabled=\"!isWritePermAllowed()\" ng-if=\"!data.UUID\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" disabled=\"!(schemaIssueDefined)\" toolbar-function=\"update()\" sx-disabled=\"!isWritePermAllowed()\" ng-if=\"data.UUID\"></six-toolbar-button><six-toolbar-button label=\"Genera ODL\" btn-class=\"btn-btn-default\" icon=\"fa fa-cogs\" toolbar-function=\"generate_odl(data.UUID)\" sx-disabled=\"show_generate_odl(data.status) && !isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"!data.version\">Nuova segnalazione</h1><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"data.version\">Segnalazione n. <span class=\"m-l-xs\">{{data.model.code}}</span></h1></div><div class=\"col-sm-6 col-xs-12\" ng-if=\"data.version\"><issue-tab class=\"pull-right\" sx-object=\"data\" sx-base-path=\"\'issue\'\" sx-status=\"data.status\" sx-uuid=\"data.UUID\" sx-show-buttons=\"false\"></issue-tab></div></div></div><div class=\"panel-body\"><uib-tabset class=\"tabs-right\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Dati</uib-tab-heading><div ng-if=\"schemaIssueDefined\"><div class=\"row m-b-xs\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"col-md-4 form-group\"><label class=\"control-label\">Tipo Asset</label><six-lookup-2 sx-id=\"issue-schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-title=\"\'Tipo asset\'\" ng-model=\"data.model\" sx-item-template=\"\'{{item.description}}\'\" sx-field=\"\'type_id\'\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-page-size=\"10000\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"issue-asset\" sx-base-path=\"\'record\'\" sx-title=\"\'Asset\'\" ng-model=\"data.model\" sx-type=\"data.model.type_id.UUID\" sx-field=\"\'record_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Richiedente</label><six-lookup-2 sx-id=\"issue-richiedente\" ng-model=\"data\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'reporter_id\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-prefill=\"{model: {typeoperator: \'richiedente\'}}\"></six-lookup-2></div></div></div></div><div class=\"row m-b\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"col-md-4 form-group\"><label class=\"control-label\">Data inserimento</label><six-date-time-picker name=\"date_insertion\" date-options=\"dateOptions\" ng-model=\"data.date_insertion\" sx-disabled=\"true\"></six-date-time-picker></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Responsabile esterno</label><six-lookup-2 sx-id=\"supervisorExternal_id\" ng-model=\"data.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'supervisorExternal_id\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Segreteria</label><six-lookup-2 sx-id=\"secretariat_id\" ng-model=\"data.references_assignee\" sx-type=\"\'segreteria\'\" sx-base-path=\"\'record\'\" sx-field=\"\'secretariat_id\'\" sx-show-details=\"true\"></six-lookup-2></div></div></div></div><div class=\"col-md-4 form-group s-f-height\" ng-if=\"data.UUID\"><label class=\"margin-col-l\">Codice</label> <input type=\"text\" class=\"form-control\" ng-model=\"data.model.code\" disabled=\"\"></div><div class=\"col-md-8 form-group s-f-height\" ng-if=\"data.UUID\"><label class=\"margin-col-l\">Descrizione</label> <input type=\"text\" class=\"form-control\" ng-model=\"data.model.description\" disabled=\"\"></div><div class=\"col-md-12 no-pad-l-r\"><form name=\"detailForm\" ng-submit=\"onSubmitDetailForm(detailForm)\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"data.model\"></form></div></div><div ng-if=\"!(schemaIssueDefined)\"><div class=\"wrapper\"><div class=\"row\"><label class=\"control-label\">Schema non definito &#x2192; Configurare prima il modello \'segnalazione\'</label></div></div></div></uib-tab><uib-tab index=\"1\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments nodes=\"attachments\" save-callback=\"updAttachments()\"></six-tree-attachments></uib-tab><uib-tab index=\"2\" select=\"getNotificationsList()\"><uib-tab-heading><span class=\"icon-bell text-info-dker\"></span> Notifiche</uib-tab-heading><div ng-if=\"notifications.length==0\" class=\"alert alert-info\" role=\"alert\">Nessuna notifica</div><ul class=\"list-group list-group-lg no-radius m-b-none m-t-n-xxs\"><li ng-repeat=\"notification in notifications\" class=\"list-group-item clearfix b-l-3x ng-scope\" ng-class=\"notification.color\"><span class=\"avatar thumb pull-left m-r\"><img ng-hide=\"notification.user\" ng-src=\"/images/avatar_system.png\"> <img ng-show=\"notification.user\" ng-src=\"/images/avatar_emil.png\"></span><div class=\"pull-right text-sm text-muted\"><span class=\"hidden-xs ng-binding\">{{notification.dataIn | date:\"dd/MM/yyyy\"}}</span></div><div class=\"clear\"><div><a class=\"text-md ng-binding\" ng-href=\"{{notification.href}}\"><span ng-show=\"notification.model.subject\">Oggetto: {{notification.model.subject}}</span> <span ng-show=\"notification.user\">da {{notification.user}}</span> <span ng-show=\"notification.model.to\">a {{notification.model.to}}</span></a></div><div class=\"text-ellipsis m-t-xs ng-binding\">{{notification.model.bodyAsText}}</div></div></li></ul></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("plan/portal/issue/issue_list.html","<six-toolbar><six-toolbar-button label=\"Aggiungi segnalazione\" icon=\"fa fa-plus\" toolbar-function=\"newIssue()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista segnalazioni</h1></div></div></div><div class=\"panel-body\"><div id=\"grid1\" ui-grid=\"viewGridOptions\" class=\"grid\" ui-grid-multiple=\"\" ui-grid-selection=\"\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\" ui-grid-auto-resize=\"\" ui-grid-exporter=\"\" external-scopes=\"clickHandler\"></div><div class=\"progress-xxs m-t-sm dk progress ng-isolate-scope\" value=\"{{percent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{percent}}%;\"></div></div></div></div></div>");
$templateCache.put("plan/portal/odl/odl_detail.html","<six-toolbar><six-toolbar-item label=\"ODL n. {{data.model.code}} - {{data.status}}\" ng-show=\"data.version\"></six-toolbar-item><six-toolbar-item label=\"Nuovo ODL\" ng-show=\"!data.version\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"goToOdlList()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" toolbar-function=\"delete(data.version)\" sx-disabled=\"!data.version || !isDeletePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"validate()\" sx-disabled=\"!(schemaOdlDefined) || !isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"!data.version\">Nuovo ODL</h1><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"data.version\">ODL n. <span class=\"m-l-xs\">{{data.model.code}}</span></h1></div><div class=\"col-sm-6 col-xs-12\" ng-if=\"data.version\"><odl-tab class=\"pull-right\" sx-object=\"data\" sx-base-path=\"\'odl\'\" sx-status=\"data.status\" sx-uuid=\"data.UUID\" sx-show-buttons=\"false\"></odl-tab></div></div></div><uib-tabset class=\"tabs-left\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> ODL</uib-tab-heading><div ng-if=\"data.generated_by==\'plan\'\" ng-include=\"\'plan/portal/odl/odl_detail_plan.html\'\"></div><div ng-if=\"data.generated_by==\'issue\'\" ng-include=\"\'plan/portal/odl/odl_detail_issue.html\'\"></div><div class=\"panel-body m-t-n\"><div ng-if=\"schemaOdlDefined\"><uib-tabset class=\"tabs-right\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Dati</uib-tab-heading><div class=\"col-md-12 form-group s-f-height\" ng-if=\"data.version\"><h5 class=\"margin-col-l\">Codice</h5><div class=\"col-md-12 no-pad-l-r\"><input type=\"text\" class=\"form-control\" ng-model=\"data.model.code\" disabled=\"\"></div></div><div class=\"col-md-12 no-pad-l-r\"><form name=\"detailForm\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"data.model\"></form></div><div ng-if=\"!(schemaOdlDefined)\"><div class=\"wrapper\"><div class=\"row\"><label class=\"control-label\">Schema non definito &#x2192; Configurare prima il modello \'odl\'</label></div></div></div></uib-tab><uib-tab index=\"1\" disable=\"!data.UUID\" select=\"getTimeline()\"><uib-tab-heading><span class=\"fa fa-history text-info-dker\"></span> Storico stati</uib-tab-heading><div class=\"col-md-12\"><div class=\"hbox hbox-auto-xs hbox-auto-sm ng-scope\"><div class=\"col col-md-4\"><div class=\"wrapper\"><ul class=\"timeline\"><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">INIZIO</div></li><li ng-repeat=\"item in timeline\" class=\"tl-item\" ng-class-odd=\"\'tl-left\'\"><div class=\"tl-wrap\" ng-class=\"{\'b-success\': (model.version == item.version)}\"><span class=\"tl-date\">{{item.dataIn | date : \'dd/MM/yyyy HH:mm:ss\' : timezone}}</span><div class=\"tl-content panel padder b-a\" ng-class=\"{\'bg-success\': (model.version == item.version)}\"><span class=\"arrow left pull-up hidden-left\" ng-class=\"{\'arrow-success\': (model.version == item.version)}\"></span> <span class=\"arrow right pull-up visible-left\" ng-class=\"{\'arrow-success\': (model.version == item.version)}\"></span><div class=\"text-lt m-b-sm\"><a ng-click=\"getModelDetail(item.version)\">{{item.model.code}}</a></div><div class=\"panel-body pull-in b-t b-light\"><span class=\"pull-right label\" ng-class=\"{\'bg-success\': (model.version == item.version), \'bg-info\': (model.version != item.version)}\">{{item.user}}</span></div><div class=\"panel-body pull-in b-t b-light\">Stato: {{item.status}}</div><div class=\"panel-body pull-in b-t b-light\">Note: {{item.status_note}}</div></div></div></li><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">FINE</div></li></ul></div></div><div class=\"col wrapper bg-white\" ng-if=\"showDetail\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"row wrapper\"><div class=\"col-md-12\"><h5>Stato</h5><div class=\"col-md-12 no-pad-l-r\"><span disabled=\"true\" class=\"form-control\">{{currentDataInTimeline.status}}</span></div></div><div class=\"col-md-12\"><h5>Note cambio di stato</h5><div class=\"col-md-12 no-pad-l-r\"><textarea rows=\"4\" class=\"col-md-12\">{{currentDataInTimeline.status_note}}</textarea></div></div><div class=\"col-md-4 form-group\"><h5>Issue</h5><six-lookup sx-id=\"issue\" sx-base-path=\"\'issue\'\" sx-type=\"\'record\'\" ng-model=\"currentDataInTimeline\" sx-field=\"\'issue_id\'\" sx-war=\"\'six-plan\'\"></six-lookup></div><div class=\"col-md-4 form-group\"><h5>Tipo Asset</h5><six-lookup-2 sx-id=\"issue-schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-title=\"\'Tipo asset\'\" ng-model=\"currentDataInTimeline.model\" sx-field=\"\'type_id\'\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><h5>Asset</h5><six-lookup-2 sx-id=\"issue-asset\" sx-base-path=\"\'record\'\" sx-title=\"\'Asset\'\" ng-model=\"data.model\" sx-type=\"currentDataInTimeline.model.type_id.UUID\" sx-field=\"\'record_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><h5>Data inserimento</h5><div class=\"col-md-12 no-pad-l-r\"><input type=\"datetime-local\" class=\"form-control\" ng-model=\"currentDataInTimeline.date_insertion\"></div></div><div class=\"col-md-4 form-group\"><h5>Data richiesta</h5><div class=\"col-md-12 no-pad-l-r\"><input type=\"datetime-local\" class=\"form-control\" ng-model=\"currentDataInTimeline.date_requested\"></div></div><div class=\"col-md-4 form-group\"><h5>Data di presa in carico</h5><div class=\"col-md-12 no-pad-l-r\"><input type=\"datetime-local\" class=\"form-control\" ng-model=\"currentDataInTimeline.date_handling\"></div></div><div class=\"col-md-4 form-group\"><h5>Data chiusura</h5><div class=\"col-md-12 no-pad-l-r\"><input type=\"datetime-local\" class=\"form-control\" ng-model=\"currentDataInTimeline.date_closing\"></div></div></div><div class=\"col-md-12\"><div sf-schema=\"schemaDataInTimeline\" sf-form=\"formDataInTimeline\" sf-model=\"currentDataInTimeline.model\"></div></div></div></div></div></div></uib-tab><uib-tab index=\"2\" disable=\"!data.version\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments nodes=\"attachments\" save-callback=\"updAttachments()\"></six-tree-attachments></uib-tab><uib-tab index=\"3\" disable=\"!data.version\" select=\"getMessage()\"><uib-tab-heading><span class=\"fa fa-envelope text-info-dker\"></span> Messaggio</uib-tab-heading><div class=\"col-md-12\" ng-if=\"loadingSixMail == true\"><uib-progressbar class=\"progress-striped active\" type=\"info\"><i>Caricamento messaggio</i></uib-progressbar></div><six-send-email ng-if=\"loadingSixMail == false\" sx-title-mail=\"objMail.title\" sx-body-mail=\"objMail.message\" sx-to-mail=\"objMail.to\" sx-cc-mail=\"objMail.cc\" sx-type-mail=\"\'odl\'\" sx-record-id=\"currentOdlRef\"></six-send-email></uib-tab><uib-tab index=\"4\" disable=\"!data.version\"><uib-tab-heading><span class=\"fa fa-qrcode text-info-dker\"></span> QRCODE</uib-tab-heading><qrcode version=\"5\" error-correction-level=\"H\" size=\"274\" data=\"{{data.UUID}}\"></qrcode></uib-tab><uib-tab index=\"5\" disable=\"!data.version\" select=\"getNotificationsList()\"><uib-tab-heading><span class=\"icon-bell text-info-dker\"></span> Notifiche</uib-tab-heading><div ng-if=\"notifications.length==0\" class=\"alert alert-info\" role=\"alert\">Nessuna notifica</div><ul class=\"list-group list-group-lg no-radius m-b-none m-t-n-xxs\"><li ng-repeat=\"notification in notifications\" class=\"list-group-item clearfix b-l-3x ng-scope\" ng-class=\"notification.color\"><span class=\"avatar thumb pull-left m-r\"><img ng-hide=\"notification.user\" ng-src=\"/images/avatar_system.png\"> <img ng-show=\"notification.user\" ng-src=\"/images/avatar_emil.png\"></span><div class=\"pull-right text-sm text-muted\"><span class=\"hidden-xs ng-binding\">{{notification.dataIn | date:\"dd/MM/yyyy\"}}</span></div><div class=\"clear\"><div><a class=\"text-md ng-binding\" ng-href=\"{{notification.href}}\"><span ng-show=\"notification.model.subject\">Oggetto: {{notification.model.subject}}</span> <span ng-show=\"notification.user\">da {{notification.user}}</span> <span ng-show=\"notification.model.to\">a {{notification.model.to}}</span></a></div><div class=\"text-ellipsis m-t-xs ng-binding\">{{notification.model.bodyAsText}}</div></div></li></ul></uib-tab></uib-tabset></div></div></uib-tab><uib-tab index=\"1\" disable=\"!issue.version\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Segnalazione</uib-tab-heading><issue-details sx-issue=\"issue\" sx-show-watchers=\"false\" sx-show-references-assignee=\"false\" sx-show-responsable-list=\"false\" sx-show-customer-info=\"true\"></issue-details></uib-tab></uib-tabset></div></div>");
$templateCache.put("plan/portal/odl/odl_detail_issue.html","<div class=\"wrapper\"><div class=\"row m-b-xs\"><div class=\"col-md-12 m-t\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"col-md-4 form-group format-h-odl\"><label class=\"control-label\">Segnalazione</label><six-lookup sx-id=\"issue\" sx-base-path=\"\'issue\'\" sx-type=\"\'record\'\" ng-model=\"data\" sx-field=\"\'issue_id\'\" sx-war=\"\'six-plan\'\" sx-filter=\"issueRefreshed.filter\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-disabled=\"true\"><button class=\"btn btn-default\" ng-click=\"goToIssue()\" ng-disabled=\"!data.issue_id\"><i class=\"fa fa-external-link\"></i></button></six-lookup><div class=\"col-md-12 no-pad-l-r\"><input type=\"checkbox\" ng-model=\"issueRefreshed.bool\" ng-disabled=\"true\">Filtra per segnalazioni non \"associate\"</div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Elemento tecnologico</label><six-lookup-2 sx-id=\"odl-schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"data.model\" sx-field=\"\'type_id\'\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-disabled=\"true\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"asset\" sx-base-path=\"\'record\'\" sx-type=\"data.model.type_id.UUID\" ng-model=\"data.model\" sx-field=\"\'record_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-disabled=\"true\"></six-lookup-2></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"col-md-4 form-group\"><label class=\"control-label\">Data richiesta</label><p class=\"input-group\" style=\"width:100%\"><six-date-time-picker name=\"date_requested\" ng-model=\"data.date_requested\" date-options=\"dateOptions\" sx-disabled=\"true\"></six-date-time-picker></p></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Data chiusura</label><p class=\"input-group\" style=\"width:100%\"><six-date-time-picker name=\"date_closing\" ng-model=\"data.date_closing\" date-options=\"dateOptions\" sx-disabled=\"true\"></six-date-time-picker></p></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Utente di inserimento</label><six-lookup-2 sx-id=\"logged-user\" ng-model=\"cacheVariable\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'loggedUser\'\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-disabled=\"true\"></six-lookup-2></div></div></div></div></div>");
$templateCache.put("plan/portal/odl/odl_detail_plan.html","<div class=\"wrapper\"><h4>Parametri da Programmata</h4><div class=\"row\"><div class=\"col-md-3 m-t\"><label for=\"dateRequested\" class=\"control-label\">Data pianifica</label><p class=\"input-group\" style=\"width:100%\"><input type=\"text\" name=\"dateRequested\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"data.date_requested\" is-open=\"popupRequested.opened\" datepicker-options=\"dateOptions\" clear-text=\"Cancella\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openRequestedPicker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-3 m-t\"><label for=\"dateRequested\" class=\"control-label\">Data inserimento</label><p class=\"input-group\" style=\"width:100%\"><input type=\"text\" name=\"dateRequested\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"date_in\" clear-text=\"Cancella\" close-text=\"Chiudi\" current-text=\"Oggi\" readonly=\"\"></p></div><div class=\"col-md-3 m-t\"><label for=\"record_istatusd_type\" class=\"control-label\">Stato</label><div class=\"input-group\" style=\"width:100%\"><input name=\"status\" type=\"text\" value=\"{{data.status}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-3 m-t\"><label for=\"generatioTag\" class=\"control-label\">Codice generazione</label><div class=\"input-group\" style=\"width:100%\"><input name=\"status\" type=\"text\" value=\"{{data.model.generation_tag}}\" class=\"form-control\" readonly=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-6 m-t\" ng-if=\"data.is_aggregated\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"col-md-8\"><label for=\"record_id\" class=\"control-label\">Asset</label><div class=\"input-group\" style=\"width:100%\"><input name=\"record_id\" type=\"text\" value=\"{{data.model.parent_record_id.code}} - {{data.model.parent_record_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-4\"><label for=\"record_id_type\" class=\"control-label\">Elemento tecnologico</label><div class=\"input-group\" style=\"width:100%\"><input name=\"record_id_type\" type=\"text\" value=\"{{data.model.parent_type_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-8 m-t\"><label for=\"record_id\" class=\"control-label\">Generato per l\'elemento tecnologico</label><div class=\"input-group\" style=\"width:100%\"><input name=\"record_id\" type=\"text\" value=\"{{data.model.type_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-4 m-t\"><label class=\"control-label\"></label><div class=\"input-group\" style=\"width:100%\"><button class=\"btn btn-default m-t-xs\" style=\"width:100%\" ng-click=\"showAssetsList()\" data-toggle=\"collapse\" data-target=\"#assetsList\"><span class=\"fa fa-search\"></span> Dettaglio asset</button></div></div><div class=\"col-md-12 m-t collapse\" id=\"assetsList\"><h4 class=\"override-h4-no-margin\">Dettaglio asset</h4><hr class=\"m-t-sm\"><div class=\"m-t-n-sm\"><div ng-repeat=\"asset in assetsList\">{{asset.code}} - {{asset.description}}</div></div></div></div></div><div class=\"col-md-6 m-t\" ng-if=\"!data.is_aggregated\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"col-md-8\"><label for=\"record_id\" class=\"control-label\">Asset</label><div class=\"input-group\" style=\"width:100%\"><input name=\"record_id\" type=\"text\" value=\"{{data.model.record_id.code}} - {{data.model.record_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-4\"><label for=\"record_id_type\" class=\"control-label\">Tipo di Asset</label><div class=\"input-group\" style=\"width:100%\"><input name=\"record_id_type\" type=\"text\" value=\"{{data.model.record_id.type}}\" class=\"form-control\" readonly=\"\"></div></div></div></div><div class=\"col-md-6 m-t\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"col-md-8\"><label for=\"record_id\" class=\"control-label\">Compito</label><div class=\"input-group\" style=\"width:100%\"><input name=\"record_id\" type=\"text\" value=\"{{data.task_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-4\"><label class=\"control-label\"></label><div class=\"input-group\" style=\"width:100%\"><button class=\"btn btn-default m-t-xs\" style=\"width:100%\" data-toggle=\"collapse\" data-target=\"#activitiesList\"><span class=\"fa fa-search\"></span> Dettaglio attività</button></div></div><div class=\"col-md-12 m-t collapse\" id=\"activitiesList\"><h4 class=\"override-h4-no-margin\">Dettaglio attività</h4><hr class=\"m-t-sm\"><div class=\"m-t-n-sm\"><div ng-repeat=\"activity in data.task_activities\">{{activity.model.title}}</div></div></div></div></div></div></div>");
$templateCache.put("plan/portal/odl/odl_list.html","<six-toolbar><six-toolbar-button label=\"Genera Odl\" icon=\"fa fa-plus\" toolbar-function=\"newOdl()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Chiudi Odl\" icon=\"fa fa-trash\" toolbar-function=\"massiveClosingOdl()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Tutti\" icon=\"fa fa-square-o\" icon-disabled=\"fa fa-check-square-o\" icon-condition=\"bool.allOdl\" toolbar-function=\"bool.allOdl=!bool.allOdl; refresh();\"></six-toolbar-button><six-toolbar-button label=\"Nascondi pianific.\" icon=\"fa fa-square-o\" icon-disabled=\"fa fa-check-square-o\" icon-condition=\"bool.hidePlan\" toolbar-function=\"bool.hidePlan=!bool.hidePlan; refresh();\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista odl</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination sx-id=\"odl\" get-data-callback=\"getCurrentUserOdlList()\" get-list-callback=\"getCurrentUserOdlList()\" items-list=\"odlList\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" auto-resize-params=\"autoResizeParams\" show-global-search=\"false\"></six-grid-pagination></div></div></div>");
$templateCache.put("theme/components/sixcheckbox/sixcheckbox.html","<div class=\"checkbox {{sxClass}}\"><label class=\"i-checks\"><input type=\"checkbox\" ng-model=\"value\" ng-change=\"onValueChanged()\"><i></i> {{sxLabel}}</label></div>");
$templateCache.put("theme/components/sixcodereader/sixcodereader.html","<div class=\"input-group\"><input id=\"readerInput\" type=\"text\" class=\"form-control\" ng-model=\"input\" ng-keyup=\"$event.keyCode == 13 && manualReadCode()\" ng-disabled=\"sxDisabled\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"manualReadCode()\" ng-disabled=\"!input || input.length===0\"><i class=\"fa fa-check\"></i></button> <button class=\"codereader\" ng-class=\"{\'btn btn-play\': !sxPause, \'btn btn-pause\': sxPause}\" type=\"button\" ng-click=\"sxPause=!sxPause\" ng-show=\"sxAllowPause\" ng-disabled=\"!workstation\" title=\"{{!workstation ? \'Nessuna workstation impostata\' : \'\'}}\"><i class=\"codereader\" ng-class=\"{\'fa fa-play \': sxPause, \'fa fa-pause\': !sxPause}\"></i></button></span></div>");
$templateCache.put("theme/components/sixcomponentstatusgrid/sixcomponentstatusgrid.html","<six-grid-pagination ng-if=\"sf\" get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"list\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination>");
$templateCache.put("theme/components/sixdatepicker/sixdatepicker.html","<div class=\"has-feedback\"><input name=\"{{$ctrl.name}}_input\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{$ctrl.format}}\" ng-model=\"$ctrl.ngModel\" is-open=\"$ctrl.status.opened\" datepicker-options=\"$ctrl.dateOptions\" ng-click=\"$ctrl.open($event)\" close-text=\"{{ \'close\' | translate }}\" current-text=\"{{ \'today\' | translate }}\" clear-text=\"{{ \'clear\' | translate }}\" datepicker-append-to-body=\"true\" popup-placement=\"auto bottom\" ng-disabled=\"$ctrl.sxDisabled\" placeholder=\"{{$ctrl.placeholder}}\"> <a class=\"form-control-feedback\" ng-click=\"$ctrl.open($event)\" ng-disabled=\"$ctrl.sxDisabled\"><i class=\"glyphicon glyphicon-calendar\"></i></a> <span class=\"input-group-btn\"><span ng-transclude=\"\"></span></span></div>");
$templateCache.put("theme/components/sixdatetimepicker/sixdatetimepicker.html","<div class=\"form-group has-feedback\"><div class=\"input-group\" style=\"width: 100%\"><input type=\"text\" class=\"form-control\" ng-click=\"$ctrl.openCalendar($event, prop)\" datetime-picker=\"{{$ctrl.format}}\" datepicker-options=\"$ctrl.dateOptions\" timepicker-options=\"$ctrl.timePickerOptions\" button-bar=\"$ctrl.buttonBar\" enable-time=\"$ctrl.enableTime\" enable-date=\"$ctrl.enableDate\" ng-model=\"$ctrl.ngModel\" is-open=\"$ctrl.isOpen\" ng-disabled=\"$ctrl.sxDisabled\"> <a class=\"form-control-feedback\" ng-click=\"$ctrl.openCalendar($event, prop)\" ng-disabled=\"$ctrl.sxDisabled\"><i class=\"glyphicon glyphicon-calendar\"></i></a></div><span class=\"input-group-btn\"><span ng-transclude=\"\"></span></span></div>");
$templateCache.put("theme/components/sixdetailgrid/sixdetailgrid.html","<six-grid-pagination ng-if=\"sf\" get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"list\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination>");
$templateCache.put("theme/components/sixenum/sixenum.html","<div class=\"input-group has-button\" style=\"width: 100%\"><ui-select ng-model=\"selected.obj\" theme=\"bootstrap\" reset-search-input=\"true\" on-select=\"onValueChanged($select.selected)\" ng-disabled=\"sxDisabled || sxReadonly\"><ui-select-match class=\"ui-select-match\" placeholder=\"\">{{selected.obj.name}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in sxOptions track by $index\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select><span class=\"input-group-btn\" ng-if=\"sxClosable == true\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"clearSelect($event)\" ng-disabled=\"sxDisabled\"><i class=\"fa fa-times\"></i></button></span></div>");
$templateCache.put("theme/components/sixfeed/sixFeed.html","<style>\n  .info{\n    background-color: yellow \n  }\n  .success{\n    background-color: green \n\n  }\n  .warning{\n    background-color: red \n  }\n  .panel-footer {\n    padding: 10px 15px !important;\n  }\n  .list-group{\n    margin-bottom: 0px;\n  }\n</style><div class=\"list-group\"><a href=\"\" class=\"media list-group-item\" ng-repeat=\"msg in messages\"><span class=\"pull-left thumb-sm\"><img ng-src=\"{{\'images/\' + msg.icon}}\" alt=\"...\" class=\"img-circle\"></span> <span class=\"media-body block m-b-none\"><span ng-bind-html=\"msg.text\"></span><br><small class=\"text-muted\"><i>{{ msg.time }}</i></small></span></a></div><div class=\"panel-footer text-sm\"><a href=\"\" class=\"pull-right\"><i class=\"fa fa-cog\"></i></a> <a href=\"#notes\" data-toggle=\"class:show animated fadeInRight\">Visualizza tutte le notifiche</a></div>");
$templateCache.put("theme/components/sixgridpagination/sixgridpagination.html","<div class=\"form-group\" ng-if=\"$ctrl.showGlobalSearch\"><input ng-keyup=\"$ctrl.getDataCallback()\" class=\"form-control\" type=\"text\" ng-model=\"$ctrl.params.queryParam\" placeholder=\"Type here to filter the list...\"></div><div ui-i18n=\"{{$ctrl.gridOptions.lang}}\"><div ng-style=\"{ \'height\': params.gridApi.grid.gridHeight }\" class=\"grid\" ui-grid=\"$ctrl.gridOptions\" ui-grid-multiple=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\" ui-grid-edit=\"\" ui-grid-pagination=\"\" ui-grid-auto-resize=\"\" ui-grid-exporter=\"\"></div></div>");
$templateCache.put("theme/components/sixgridpaginationexpandable/sixgridpaginationexpandable.html","<div class=\"form-group\" ng-if=\"$ctrl.showGlobalSearch\"><input ng-keyup=\"$ctrl.getDataCallback()\" class=\"form-control\" type=\"text\" ng-model=\"$ctrl.params.queryParam\" placeholder=\"Type here to filter the list...\"></div><div ui-i18n=\"{{$ctrl.gridOptions.lang}}\"><div ng-style=\"{ \'height\': params.gridApi.grid.gridHeight }\" class=\"grid\" ui-grid=\"$ctrl.gridOptions\" ui-grid-multiple=\"\" ui-grid-expandable=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\" ui-grid-edit=\"\" ui-grid-pagination=\"\" ui-grid-auto-resize=\"\" ui-grid-exporter=\"\"></div></div>");
$templateCache.put("theme/components/sixprofile/sixprofile.html","<style type=\"text/css\">\n.profile-current{\n    padding-bottom: 10px;\n    text-align: center;\n}\n</style><six-sidebar sx-id=\"sxId\" class=\"sixlookup2\" sx-position=\"right\" sx-title=\"sxTitle\" sx-dimension=\"l\" sx-opened=\"sxOpened\" sx-pinnable=\"false\"><div class=\"nav-tabs-alt\" ng-if=\"tabHeaderList.length>1\"><ul class=\"nav nav-tabs\" role=\"tablist\" id=\"sx-profile-tab-headers\"><li ng-repeat=\"h in tabHeaderList\" ng-init=\"targetId=\'#tab-\'+($index+1)\"><a data-target=\"{{targetId}}\" role=\"tab\" data-toggle=\"tab\" class=\"text-md text-muted\"><i class=\"{{h.icon}} wrapper-sm\"></i> {{h.label}}</a></li></ul></div><div class=\"tab-content\"><div ng-repeat=\"b in tabBodyList\" role=\"tabpanel\" ng-init=\"tabId=\'tab-\'+($index+1)\" id=\"{{tabId}}\" class=\"tab-pane\" ng-class=\"{\'active\': $index===0}\"><ul class=\"nav list-sidebar-nav\"><li ng-if=\"b.current.code\"><h4 class=\"profile-current\">{{b.current.description}}</h4></li><li><div class=\"form-group m-l-xs m-r-xs m-t-xs\"><six-search-form ng-model=\"b.filter\" placeholder=\"Filtra...\" hide-search-btn=\"\"></six-search-form></div></li><li ng-repeat=\"item in b.list | filter:b.filter\" class=\"m-l-xs m-r-xs\" ng-class=\"{\'disabled commission-disabled\': isItemSelected(item)}\" title=\"{{item.code}} - {{item.description}}\"><a ng-if=\"isItemSelected(item)\">{{item.description | limitTo:40}}{{item.description > 40 ? \'...\' : \'\'}}&nbsp;<i class=\"fa fa-long-arrow-left\" style=\"font-size:smaller;margin-left:20px\"></i></a> <a ng-if=\"!isItemSelected(item)\" href=\"\" ng-click=\"switchProfile(item, userInfo().profile.items)\">{{item.description | limitTo:40}}{{item.description > 40 ? \'...\' : \'\'}}</a></li></ul></div></div></six-sidebar>");
$templateCache.put("theme/components/sixsearchfilters/sixsearchfilters.html","<div class=\"row wrapper\"><div class=\"col-md-6\"><a class=\"btn btn-default\" style=\"width:100%\" ng-click=\"addSearchTerm()\"><i class=\"fa fa-plus\"></i>Aggiungi filtro</a></div><div class=\"col-md-6\" six-sidebar-autoclose=\"true\"><a ng-if=\"!sxFilterOnly\" class=\"btn btn-default\" style=\"width:100%\" ng-click=\"search()\" six-sidebar-autoclose=\"false\"><i class=\"fa fa-search\"></i>Cerca</a> <a ng-if=\"sxFilterOnly\" class=\"btn btn-default\" style=\"width:100%\" ng-click=\"getFiltersList()\" six-sidebar-autoclose=\"false\"><i class=\"fa fa-check\"></i>Conferma</a></div></div><div class=\"row wrapper\" ng-if=\"showSelectModel\" style=\"margin-top: -30px;\"><div class=\"col-md-12 m-t\"><label id=\"type_label\" class=\"control-label\">Modello</label><six-lookup sx-id=\"type\" sx-base-path=\"\'schema\'\" ng-model=\"params\" sx-title=\"\'Tipo\'\" sx-field=\"\'type_id\'\" sx-object=\"params.type_obj\"></six-lookup></div></div><div class=\"list-group wrapper\" style=\"margin-top: -15px;\"><six-search-single-term sx-params=\"params\" ng-repeat=\"term in params.terms track by $index\" sx-position=\"$index\"></six-search-single-term></div>");
$templateCache.put("theme/components/sixsearchsingleterm/sixsearchsingleterm.html","<style type=\"text/css\">\n    .sx-sst .attr{\n        width: 87%;\n    }\n    .sx-sst .val{\n        width: 100%;\n    }\n    .sx-sst .val-rel{\n        width: 82%;\n    }\n    .sx-sst .val-no-rel{\n        width: 100%;\n    }\n    .sx-sst .caret{\n        margin-left: 6px;\n    }\n</style><div class=\"list-group-item b-l-info b-l-3x hover-anchor hover sx-sst\"><span ng-click=\"removeTerm()\" class=\"pull-right text-muted hover-action\" role=\"button\" tabindex=\"0\"><i class=\"fa fa-times\"></i></span> <span class=\"block attr\"><ui-select ng-model=\"ngModel\" theme=\"bootstrap\" on-select=\"selectAttribute($item)\" ng-disabled=\"sxDisabled\" reset-search-input=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Seleziona un attributo...\"><span ng-if=\"params.terms[index].attribute_obj.title\">{{params.terms[index].attribute_obj.title}}</span></ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in params.attributes track by $index\" refresh=\"refreshData($select.search)\" refresh-delay=\"index\"><div>{{item.title | highlight: $select.search}} ({{item.type | highlight: $select.search}})</div></ui-select-choices></ui-select></span> <span class=\"block m-t-xs val\"><span class=\"input-group-bt pull-left\" ng-if=\"isRel()\"><select class=\"form-control\" ng-model=\"params.terms[index].attribute_rel\"><option value=\"lt\">&lt;</option><option value=\"lte\">&le;</option><option value=\"equal\">=</option><option value=\"gte\">&ge;</option><option value=\"gt\">&gt;</option></select></span> <span><div class=\"input-group val-no-rel\" ng-if=\"params.terms[index].attribute_obj.type==\'text\'\"><input name=\"text\" type=\"text\" ng-model=\"params.terms[index].attribute_value\" class=\"form-control\"></div><div class=\"input-group val-no-rel\" style=\"width:100%\" ng-if=\"params.terms[index].attribute_obj.type==\'uiselectmultiple\'\"><input name=\"text\" type=\"text\" ng-model=\"params.terms[index].attribute_value\" class=\"form-control\"></div><div class=\"input-group val-rel\" ng-if=\"params.terms[index].attribute_obj.type==\'number\'\"><input name=\"number\" type=\"number\" ng-model=\"params.terms[index].attribute_value\" class=\"form-control\"></div><div class=\"input-group val-no-rel\" style=\"width:100%\" ng-if=\"params.terms[index].attribute_obj.type==\'sixlookup\'\"><six-lookup id=\"record_id\" ng-model=\"params.terms[index]\" sx-type=\"params.terms[index].attribute_obj.entity_id\" sx-field=\"\'attribute_value\'\"></six-lookup></div><div class=\"input-group val-no-rel\" style=\"width:100%\" ng-if=\"params.terms[index].attribute_obj.type==\'checkbox\'\"><input type=\"checkbox\" ng-model=\"params.terms[index].attribute_value\">{{params.terms[index].attribute_obj.title}}</div><div class=\"input-group val-rel\" style=\"width:100%\" ng-if=\"params.terms[index].attribute_obj.type==\'datepicker\'\"><p class=\"input-group\" style=\"width:100%\"><input type=\"text\" name=\"datepicker\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"params.terms[index].attribute_value\" is-open=\"pickerOptions.opened\" datepicker-options=\"pickerOptions\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><a class=\"btn btn-default\" ng-click=\"pickerOptions.opened=!pickerOptions.opened\"><i class=\"glyphicon glyphicon-calendar\"></i></a></span></p></div><div class=\"input-group val-no-rel\" style=\"width:100%\" ng-if=\"params.terms[index].attribute_obj.type==\'uiselect\'\"><ui-select ng-model=\"ngModel\" theme=\"bootstrap\" on-select=\"selectAttributeValue($item)\" ng-disabled=\"sxDisabled\" reset-search-input=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Seleziona un valore...\"><span ng-if=\"params.terms[index].attribute_value.name\">{{params.terms[index].attribute_value.name}}</span><span ng-if=\"!params.terms[index].attribute_value.name\">{{params.terms[index].attribute_value.value}}</span></ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in params.terms[index].attribute_obj.titleMap track by $index\"><div>{{item.name | highlight: $select.search}} <span ng-if=\"item.value\">({{item.value | highlight: $select.search}})</span></div></ui-select-choices></ui-select></div></span></span></div>");
$templateCache.put("theme/components/sixsearchterms/sixsearchterms.html","<six-sidebar sx-id=\"{{sxId}}\" class=\"sixlookup2\" sx-position=\"right\" sx-title=\"params.type_obj.model.description\" sx-dimension=\"l\" sx-opened=\"sxOpen\" sx-pinnable=\"false\"><div class=\"row wrapper\"><div class=\"col-md-6\"><a class=\"btn btn-default\" style=\"width:100%\" ng-click=\"addSearchTerm()\"><i class=\"fa fa-plus\"></i>Aggiungi filtro</a></div><div class=\"col-md-6\" six-sidebar-autoclose=\"true\"><a ng-if=\"!sxFilterOnly\" class=\"btn btn-default\" style=\"width:100%\" ng-click=\"search()\" six-sidebar-autoclose=\"true\"><i class=\"fa fa-search\"></i>Cerca</a> <a ng-if=\"sxFilterOnly\" class=\"btn btn-default\" style=\"width:100%\" ng-click=\"getFiltersList()\" six-sidebar-autoclose=\"true\"><i class=\"fa fa-check\"></i>Conferma</a></div></div><div class=\"row wrapper\" ng-if=\"showSelectModel\" style=\"margin-top: -30px;\"><div class=\"col-md-12 m-t\"><label id=\"type_label\" class=\"control-label\">Modello</label><six-lookup sx-id=\"type\" sx-base-path=\"\'schema\'\" ng-model=\"params\" sx-title=\"\'Tipo\'\" sx-field=\"\'type_id\'\" sx-object=\"params.type_obj\"></six-lookup></div></div><div class=\"list-group wrapper\" style=\"margin-top: -15px;\"><six-search-single-term sx-params=\"params\" ng-repeat=\"term in params.terms track by $index\" sx-position=\"$index\"></six-search-single-term></div></six-sidebar>");
$templateCache.put("theme/components/sixtreeattachments/sixtreeattachments.html","<style type=\"text/css\">\n.folder{\n    font-weight: bold;\n}\n.file{\n    margin-left: 16px;\n}\n.folder-node{\n    display: inline-block;\n    padding: 6px 12px;\n    margin-bottom: 0;\n    font-size: 14px;\n    font-weight: normal;\n    line-height: 1.42857143;\n    white-space: nowrap;\n    vertical-align: middle;\n    -ms-touch-action: manipulation;\n    touch-action: manipulation;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    border: 1px solid transparent;\n    border-radius: 4px;\n    \n    color: #58666e;\n}\n.file-node{\n    color: #587180;\n}\n.file-node:hover{\n    color: #3c4c56;\n}\n.folder-node:hover{  \n    color: #232735;\n}\n.folder-buttons{\n    margin-left: 16px;\n}\n.folder-buttons .btn{\n    color: #a6a8b1;\n}\n.file-title-write input{\n    width: 50%;\n}\n.my-drop-zone { border: dotted 3px lightgray; }\n.nv-file-over { border: dotted 3px #7266ba; }\n</style><div class=\"row\" ng-if=\"upload.show\"><div class=\"col-md-3\"><h4>Seleziona file</h4><div><input type=\"file\" nv-file-select=\"\" uploader=\"uploader\"></div><br><h4>Oppure</h4><div ng-show=\"uploader.isHTML5\"><div nv-file-drop=\"\" class=\"well my-drop-zone\" nv-file-over=\"\" uploader=\"uploader\">Trascina qui</div></div></div><div class=\"col-md-9\" style=\"margin-bottom: 40px\"><h4>Aggiungi alla cartella <i>{{upload.nodeData.title}}</i></h4><table class=\"table\"><thead><tr><th width=\"50%\">Nome</th><th ng-show=\"uploader.isHTML5\">Dimensione</th><th ng-show=\"uploader.isHTML5\">Avanzamento</th><th>Stato</th><th>Azioni</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }} MB</td><td ng-show=\"uploader.isHTML5\"><div class=\"progress\" style=\"margin-bottom: 0;\"><div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ \'width\': item.progress + \'%\' }\"></div></div></td><td class=\"text-center\"><span ng-show=\"item.isSuccess\"><i class=\"glyphicon glyphicon-ok\"></i></span> <span ng-show=\"item.isCancel\"><i class=\"glyphicon glyphicon-ban-circle\"></i></span> <span ng-show=\"item.isError\"><i class=\"glyphicon glyphicon-remove\"></i></span></td><td nowrap=\"\"><button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"item.upload()\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\"><span class=\"glyphicon glyphicon-upload\"></span> Carica</button> <button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"item.cancel()\" ng-disabled=\"!item.isUploading\"><span class=\"glyphicon glyphicon-ban-circle\"></span> Annulla</button> <button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"item.remove()\" ng-disabled=\"item.isSuccess || item.isUploading\"><span class=\"glyphicon glyphicon-trash\"></span> Rimuovi</button></td></tr></tbody></table><div><div>Avanzamento:<div class=\"progress\" style=\"\"><div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ \'width\': uploader.progress + \'%\' }\" style=\"width: 0%;\"></div></div></div><button type=\"button\" class=\"btn btn-success btn-s\" ng-click=\"uploader.uploadAll()\" ng-disabled=\"!uploader.getNotUploadedItems().length\"><span class=\"glyphicon glyphicon-upload\"></span> Carica tutti</button> <button type=\"button\" class=\"btn btn-warning btn-s\" ng-click=\"uploader.cancelAll()\" ng-disabled=\"!uploader.isUploading\" disabled=\"disabled\"><span class=\"glyphicon glyphicon-ban-circle\"></span> Annulla tutti</button><button type=\"button\" class=\"btn btn-danger btn-s\" ng-click=\"uploader.clearQueue()\" ng-disabled=\"!uploader.getNotUploadedItems().length\"><span class=\"glyphicon glyphicon-trash\"></span> Rimuovi tutti</button></div></div></div><br><div class=\"row\" ng-if=\"upload.show\"><div class=\"col col-md-12 wrapper\" ng-if=\"upload.errors\"><div class=\"alert alert-danger\"><strong>ERRORE</strong><div ng-repeat=\"error in upload.errors\">{{error}}</div></div></div><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-default btn-s\" ng-click=\"undoUpload()\" ng-disabled=\"!upload.completed\"><span class=\"fa fa-check\"></span> Chiudi</button> <button type=\"button\" class=\"btn btn-default btn-s\" ng-click=\"undoUpload()\" ng-disabled=\"upload.started\"><span class=\"fa fa-undo\"></span> Annulla</button></div></div><div ng-if=\"!upload.show\"><div ui-tree=\"treeOptions\" id=\"tree1-root\" data-drag-enabled=\"opt.dragEnabled\"><ol ui-tree-nodes=\"\" ng-model=\"nodes\" id=\"tree\"><li ng-repeat=\"node in nodes\" ui-tree-node=\"\" ng-include=\"\'tree_renderer.html\'\"></li></ol></div></div><script type=\"text/ng-template\" id=\"tree_renderer.html\"><!-- FILE --> <div ui-tree-handle class=\"tree-node file-node\" ng-if=\"!node.folder\"> <div class=\"tree-node-content\"> <span class=\"file file-title-read\" ng-click=\"stopEditing()\"> {{node.title}} </span> <span class=\"file file-title-write\" style=\"display:none;\"> <input type=\"text\" ng-model=\"node.title\" ng-keypress=\"($event.which === 13)?confirmRename($event):0\"/> </span> <!-- pulsanti --> <a ng-if=\"fullMode && !sxReadonly\" class=\"pull-right btn btn-xs\" data-nodrag> <span class=\"glyphicon glyphicon-remove text-danger-dker remove-tree-btn\" title=\"Elimina file\" ng-confirm-message=\"Eliminare il file?\" ng-confirm-click=\"removeFile(this)\" ng-confirm-condition=true ng-if=\"isWritePermAllowed()===true\"></span> </a> <a ng-if=\"fullMode && !sxReadonly\" class=\"pull-right btn btn-xs\" data-nodrag> <span class=\"fa fa-edit text-info-dker remove-tree-btn\" title=\"Rinomina file\" ng-click=\"renameNode($event)\"></span> </a> <a ng-if=\"!sxReadonly\" class=\"pull-right btn btn-xs\" ng-href=\"{{DOWNLOAD_URL}}{{node.object_id}}\" target=\"_blank\" download=\"{{node.title}}\" data-nodrag> <span class=\"glyphicon glyphicon-arrow-down text-primary remove-tree-btn\" title=\"Scarica file\" ></span> </a> </div> </div> <!-- FOLDER --> <div ui-tree-handle class=\"tree-node folder-node\" ng-if=\"node.folder\"> <div class=\"tree-node-content\"> <div data-nodrag > <span ng-click=\"toggle(this)\" class=\"fa text-info-dker m-l-xs m-r-xs \" ng-class=\"{\'fa-folder\': collapsed, \'fa-folder-open\': !collapsed}\"></span> <span ng-click=\"toggle(this)\" class=\"folder\"> {{node.title}} </span> <span class=\"file file-title-write\" style=\"display:none;\"> <input type=\"text\" ng-model=\"node.title\" ng-keypress=\"($event.which === 13)?confirmRename($event):0\"/> </span> <!-- pulsanti --> <span class=\"folder-buttons\" ng-if=\"!sxReadonly\"> <a class=\"btn btn-xs\" data-nodrag > <span class=\"fa fa-plus-square remove-tree-btn folder-add\" ng-click=\"newFolderNode(this)\" title=\"Crea nuova cartella\" ng-class=\"{\'text-success-dker\':hovering1}\" ng-mouseenter=\"hovering1=true\" ng-mouseleave=\"hovering1=false\"></span> </a> <a class=\"btn btn-xs\" ng-if=\"!node.readonly && fullMode\" data-nodrag> <span class=\"fa fa-trash remove-tree-btn folder-remove\" title=\"Rimuovi cartella\" ng-class=\"{\'text-warning-dker\':hovering2}\" ng-mouseenter=\"hovering2=true\" ng-mouseleave=\"hovering2=false\" ng-confirm-message=\"Eliminare la cartella e tutti i suoi file?\" ng-confirm-click=\"removeFolder(this)\" ng-confirm-condition=true ></span> </a> <a class=\"btn btn-xs\" ng-if=\"!node.readonly\" data-nodrag> <span class=\"fa fa-edit remove-tree-btn folder-remove\" title=\"Rinomina cartella\" ng-class=\"{\'text-info-dker\':hovering4}\" ng-mouseenter=\"hovering4=true\" ng-mouseleave=\"hovering4=false\" ng-click=\"renameNode($event)\"></span> </a> <a class=\"btn btn-xs\" ng-if=\"fullMode\" data-nodrag> <span class=\"glyphicon glyphicon-remove remove-tree-btn\" title=\"Svuota cartella\" ng-class=\"{\'text-danger-dker\':hovering5}\" ng-mouseenter=\"hovering5=true\" ng-mouseleave=\"hovering5=false\" ng-confirm-message=\"Eliminare tutti i file presenti nella cartella?\" ng-confirm-click=\"emptyFolder(this, true)\" ng-confirm-condition=true></span> </a> <a class=\"btn btn-xs\" data-nodrag ng-click=\"newFileNode(this)\"> <span class=\"fa fa-plus remove-tree-btn\" title=\"Carica file\" ng-class=\"{\'text-success\':hovering3}\" ng-mouseenter=\"hovering3=true\" ng-mouseleave=\"hovering3=false\"></span> </a> </span> </div> </div> </div> <!-- TREE --> <ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\"> <li ng-repeat=\"node in node.nodes\" ui-tree-node ng-include=\"\'tree_renderer.html\'\"> </li> </ol></script>");
$templateCache.put("theme/directives/six-framework/sixFrameworkTemplate.html","<div ng-hide=\"!isLoggedIn()\" class=\"app-header navbar\" ng-class=\"{\'touch\': userInfo().options.touch}\"><div class=\"navbar-header\"><button class=\"pull-right visible-xs dk\" ui-toggle-class=\"show\" data-target=\".navbar-collapse\"><i class=\"glyphicon glyphicon-cog\"></i></button> <button class=\"pull-right visible-xs\" ui-toggle-class=\"off-screen\" data-target=\".app-aside\" ui-scroll-to=\"app\"><i class=\"glyphicon glyphicon-align-justify\"></i></button><a href=\"#/\" class=\"navbar-brand text-lt\"><img src=\"logo_small.png\" alt=\".\" class=\"hidden-folded\"> <img src=\"logo_icon.png\" alt=\".\" ng-class=\"{\'hidden\': !app.settings.asideFolded}\"> <span class=\"hidden-folded m-l-xs\">{{app.name}}</span></a></div><div class=\"collapse pos-rlt navbar-collapse box-shadow bg-info dker\"><div class=\"nav navbar-nav hidden-xs\"><a href=\"\" class=\"btn no-shadow navbar-btn toggle-side-menu-btn\" ng-click=\"toggleSidebar();app.settings.asideFolded = !app.settings.asideFolded\" ng-if=\"!userInfo().options.touch\"><i class=\"fa {{app.settings.asideFolded ? \'fa-indent\' : \'fa-dedent\'}} fa-fw\"></i></a><a href=\"\" class=\"btn no-shadow navbar-btn user-profile-btn\" ui-toggle-class=\"show\" target=\"#aside-user\" ng-if=\"!userInfo().options.touch\"><i class=\"icon-user fa-fw\"></i></a></div><ul class=\"nav navbar-nav navbar-right\"><li class=\"dropdown\" is-open=\"false\"><a ng-if=\"!eggs && !isBookmarskHomePage()\" ng-click=\"gestioneBookmarks()\" href=\"\"><i class=\"{{bookmarkStar}}\"></i></a></li><li class=\"dropdown\" uib-dropdown=\"\" ng-if=\"app.showNotifications == true && $ctrl.feedTemplate\"><a href=\"\" class=\"dropdown-toggle\" ng-click=\"toggleToolbar();closeProfileElement()\" uib-dropdown-toggle=\"\"><i class=\"icon-bell fa-fw\"></i> <span class=\"visible-xs-inline\">Notifiche</span> <span ng-if=\"feedCount>0\" class=\"badge badge-sm up bg-danger pull-right-xs\">{{feedCount}}</span></a><div class=\"dropdown-menu w-md animated fadeInRight\"><div class=\"panel bg-white\"><div class=\"panel-heading b-light bg-light\"><strong>Hai <span>{{feedCount || 0}}</span> nuove notifiche</strong></div><ng-include src=\"$ctrl.feedTemplate\"></ng-include></div></div></li><li class=\"dropdown\" is-open=\"false\" uib-dropdown=\"\" ng-if=\"workstation.code\"><a href=\"\" class=\"dropdown-toggle\" uib-dropdown-toggle=\"\"><i class=\"fa fa-desktop\"></i>&nbsp; {{workstation.code}}</a><ul class=\"dropdown-menu animated fadeInRight\" ng-if=\"false\"><li class=\"wrapper b-b m-b-sm bg-light m-t-n-xs\"><div><p>Eventualmente qui si potrebbere mettere la scelta della ws</p></div></li><li></li></ul></li><li class=\"dropdown\" is-open=\"false\" uib-dropdown=\"\" ng-if=\"!emma\"><a href=\"\" class=\"dropdown-toggle\" ng-click=\"toggleProfileElement()\" uib-dropdown-toggle=\"\"><i class=\"fa fa-home\"></i>&nbsp; {{userInfo().profile.description}} - {{userInfo().profile.items[0].description}}</a><ul class=\"dropdown-menu animated fadeInRight\" role=\"menu\" ng-repeat=\"p in userInfo().profiles\"><li class=\"wrapper bg-info\"><i class=\"fa fa-home\"></i> {{p.description}}</li><li ng-repeat=\"sp in p.items\"><a tabindex=\"-1\" href=\"\" ng-click=\"switchProfile(p, sp)\">{{sp.description}}</a></li></ul></li><li class=\"dropdown\" ng-if=\"emma\"><a href=\"\" ng-click=\"toggleProfileElement()\"><span ng-repeat=\"item in userInfo().profile.items\"><span><i class=\"fa fa-money m-l-xs\" ng-if=\"item.type===\'commission\'\"></i> <i class=\"fa fa-user m-l-xs\" ng-if=\"item.type===\'customer\'\"></i> {{item.description}}</span></span></a></li><li class=\"hidden-xs\" ng-if=\"false\"><a ui-fullscreen=\"\"></a></li><li class=\"dropdown\" uib-dropdown=\"\"><a href=\"\" class=\"dropdown-toggle clear\" ng-click=\"toggleToolbar();closeProfileElement()\" uib-dropdown-toggle=\"\"><i class=\"fa fa-user\"></i> <span class=\"hidden-sm\">{{userInfo().info.name}} {{userInfo().info.surname}} ({{userInfo().authId}})</span> <b class=\"caret\"></b></a><ul class=\"dropdown-menu animated fadeInRight w\" role=\"menu\"><li><a href=\"#/\"><i class=\"fa fa-home\"></i> {{app.name}}: Home</a></li><li class=\"divider\"></li><li ng-if=\"userInfo().options.admin\"><a href=\"#/admin/admin\"><i class=\"fa fa-heartbeat\"></i> Admin</a></li><li ng-if=\"userInfo().options.config\"><a href=\"#/admin/config\"><i class=\"fa fa-cogs\"></i> Configura</a></li><li><a href=\"#/admin/preferences\"><i class=\"fa fa-user\"></i> Preferenze</a></li><li><a href=\"http://www.ict-group.it\" target=\"_blank\"><i class=\"fa fa-user\"></i> About</a></li><li ng-if=\"userInfo().options.revokeAdmin\"><a href=\"#/admin/logout\"><i class=\"fa fa-sign-out\"></i> Revoca admin</a></li><li ng-if=\"userInfo().options.admin\"><a href=\"#/modeltype/list/six\"><i class=\"fa fa-file-text\"></i> ModelType</a></li><li ng-if=\"!mainBarLogout\" class=\"divider\"></li><li ng-if=\"!mainBarLogout\"><a ng-click=\"logout()\"><i class=\"fa fa-sign-out\"></i> Logout</a></li></ul></li><li ng-if=\"mainBarLogout\"><a ng-click=\"logout()\"><i class=\"fa fa-sign-out\"></i> Logout</a></li><div class=\"ict-icon pull-right\"><a href=\"http://www.ict-group.it\" target=\"_blank\"><img src=\"ict-avatar.png\" alt=\"...\"></a></div></ul></div></div><div ng-transclude=\"\"></div>");
$templateCache.put("theme/directives/six-menu/sixMenuItemTemplate.html","<li ng-class=\"leftMenuClass(route)\"><a ng-href=\"{{ route.indexOf(\'http:\')==0? route:\'#/\' + route }}\" ng-click=\"clicked()\"><i class=\"{{icon}}\"></i>{{ label }}</a></li>");
$templateCache.put("theme/directives/six-menu/sixMenuTemplate.html","<div class=\"app-aside hidden-xs bg-light dker b-r\" ng-controller=\"AppCtrl\"><style>\n    .form-control-feedback-with-events {\n      pointer-events: auto;\n    }\n    .form-control-feedback-with-events:hover {\n      cursor:pointer;\n    }\n    .selected-menu a{\n      font-weight: bold !important;\n      position: relative;\n      left: 10px;\n      color:#0d3349;\n      font-size: larger;\n    }\n  </style><div class=\"aside-wrap\"><div class=\"navi-wrap\"><div class=\"clearfix hidden-xs text-center hide\" id=\"aside-user\"><div class=\"dropdown wrapper\" uib-dropdown=\"\"><a ui-sref=\"app.page.profile\"><span class=\"thumb-lg w-auto-folded avatar m-t-sm\"><img src=\"avatar.png\" class=\"img-full\" alt=\"...\"></span></a> <a href=\"\" class=\"dropdown-toggle hidden-folded\" uib-dropdown-toggle=\"\"><span class=\"clear\"><span class=\"block m-t-sm\"><strong class=\"font-bold text-lt\">{{userInfo().info.name}} {{userInfo().info.surname}}</strong> <b class=\"caret\"></b></span> <span class=\"text-muted text-xs block\">{{userInfo().authId}}</span></span></a><ul class=\"dropdown-menu animated fadeInRight w hidden-folded\"><li class=\"wrapper b-b m-b-sm bg-info m-t-n-xs\"><span class=\"arrow top hidden-folded arrow-info\"></span><div id=\"aside-welcome\">Benvenuto!</div></li><li><a ng-href=\"{{app.notifications.link}}\"><span ng-if=\"false\" class=\"badge bg-danger pull-right\">3</span>Notifiche</a></li><li class=\"divider\"></li><li><a ng-click=\"logout()\">Logout</a></li></ul></div><div class=\"line dk hidden-folded\"></div></div><a ng-click=\"clearSearch()\" class=\"glyphicon glyphicon-remove\" style=\"color:red\" ng-if=\"false\">aaaa</a><nav ui-nav=\"\" class=\"navi clearfix\"><ul class=\"nav hidden-folded\"><li class=\"padder m-t m-b-sm text-muted text-xs\"><div class=\"form-group has-feedback\"><input class=\"form-control\" id=\"searchMenuInput\" type=\"text\" ng-model=\"search.value\" placeholder=\"Cerca funzione...\" ng-keypress=\"$event.which === 13 && searchKeyPressed()\"> <i class=\"glyphicon glyphicon-search form-control-feedback\" ng-if=\"search.value==\'\'\"></i> <i class=\"glyphicon glyphicon-remove form-control-feedback form-control-feedback-with-events\" style=\"color:lightcoral\" ng-click=\"clearSearch()\" onclick=\"jQuery(\'#searchMenuInput\').focus()\" ng-if=\"search.value!=\'\'\"></i></div></li><six-menu-item ng-if=\"search.value!=\'\' && search!=\'\'\" ng-repeat=\"subitem in functionQuickList | filter: search.value | limitTo: 20\" label=\"{{ subitem.description }}\" icon=\"{{subitem.icon}}\" class=\"{{$index==0?\'selected-menu\':\'\'}}\" route=\"{{ subitem.code }}\" ng-click=\"clearSearch()\"></six-menu-item><li ng-if=\"search.value!=\'\'\" ng-show=\"functionQuickList.length && (functionQuickList | filter: search.value).length > 20\" href=\"\" class=\"padder m-t m-b-sm text-muted text-xs\"><span>...</span></li><li ng-hide=\"(functionQuickList | filter: search.value).length\" class=\"padder m-t m-b-sm text-muted text-xs\"><span class=\"pull-left thumb-sm\"><span class=\"fa-stack fa-lg\"><i class=\"fa fa-circle fa-stack-2x text-info\"></i> <i class=\"fa fa-ban fa-stack-1x text-white\"></i></span></span> <span class=\"clear\"><span>Nessuna funzione trovata</span> <small class=\"text-muted clear text-ellipsis\"></small></span></li></ul><ul class=\"nav\" ng-if=\"search.value == \'\'\"><li class=\"hidden-folded padder m-t m-b-sm text-muted text-xs\" ng-if=\"false\"><span>Navigation</span></li><li ng-show=\"transcludedSubMenuItems\"><a href=\"\" class=\"auto\"><span class=\"pull-right text-muted\"><i class=\"fa fa-fw fa-angle-right text\"></i> <i class=\"fa fa-fw fa-angle-down text-active\"></i></span> <i class=\"fa fa-play-circle icon text\"></i> <i class=\"fa fa-play-circle icon text-active\" style=\"color:#286090\"></i> <span class=\"font-bold\">{{title}}</span></a><ul ng-transclude=\"\" class=\"transcluded nav nav-sub dk\"></ul></li><li><a href=\"\" class=\"auto\"><span class=\"pull-right text-muted\"><i class=\"fa fa-fw fa-angle-right text\"></i> <i class=\"fa fa-fw fa-angle-down text-active\"></i></span> <i class=\"fa fa-history icon text\"></i> <i class=\"fa fa-history icon text-active\" style=\"color:#286090\"></i> <span class=\"font-bold\">CRONOLOGIA</span></a><ul class=\"nav nav-sub dk\"><li class=\"nav-sub-header\"><a href=\"\"><span>CRONOLOGIA</span></a></li><six-menu-item ng-repeat=\"subitem in functionHistory\" label=\"{{ subitem.label }}\" icon=\"{{subitem.icon}}\" route=\"{{ subitem.route }}\"></six-menu-item></ul></li><li ng-repeat=\"item in menu()\"><a href=\"\" class=\"auto\"><span class=\"pull-right text-muted\"><i class=\"fa fa-fw fa-angle-right text\"></i> <i class=\"fa fa-fw fa-angle-down text-active\"></i></span> <i class=\"fa fa-play-circle icon text\"></i> <i class=\"fa fa-play-circle icon text-active\" style=\"color:#286090\"></i> <span class=\"font-bold\">{{ item.description }}</span></a><ul class=\"nav nav-sub dk\"><li class=\"nav-sub-header\"><a href=\"\"><span>{{ item.description }}</span></a></li><div ng-repeat=\"subitem in item.children\"><div ng-if=\"subitem.children\"><a href=\"\" class=\"auto\"><span class=\"pull-right text-muted\"><i class=\"fa fa-fw fa-angle-right text\"></i> <i class=\"fa fa-fw fa-angle-down text-active\"></i></span> <i class=\"fa fa-play-circle icon text\"></i> <i class=\"fa fa-play-circle icon text-active\" style=\"color:#286090\"></i> <span class=\"font-bold\">{{ subitem.description }}</span></a><ul class=\"nav nav-sub dk\"><li class=\"nav-sub-header\"><a href=\"\"><span>{{ subitem.description }}</span></a></li><six-menu-item ng-repeat=\"subsubitem in subitem.children\" label=\"{{ subsubitem.description }}\" icon=\"{{subsubitem.icon}}\" route=\"{{ subsubitem.code }}\"></six-menu-item></ul></div><six-menu-item ng-if=\"!subitem.children\" label=\"{{ subitem.description }}\" icon=\"{{subitem.icon}}\" route=\"{{ subitem.code }}\"></six-menu-item></div></ul></li></ul></nav><div class=\"wrapper m-t\" ng-if=\"false\"><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">60%</span> <span class=\"hidden-folded\">Milestone</span></div><progressbar value=\"60\" class=\"progress-xxs m-t-sm dk\" type=\"info\"></progressbar><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">35%</span> <span class=\"hidden-folded\">Release</span></div><progressbar value=\"35\" class=\"progress-xxs m-t-sm dk\" type=\"primary\"></progressbar></div></div></div></div><div ng-if=\"false\" ng-hide=\"!isLoggedIn()\" class=\"col-sm-3 col-md-2 col-sm-pull-9 col-md-pull-10 sidebar-pf sidebar-pf-left\" style=\"min-height: 1007px;\"><accordion close-others=\"oneAtATime\"><accordion-group is-open=\"status.isFirstOpen\" ng-show=\"transcludedSubMenuItems\"><accordion-heading>{{title}}</accordion-heading><ul ng-transclude=\"\" class=\"transcluded nav nav-pills nav-stacked\"></ul></accordion-group><accordion-group ng-repeat=\"item in menu()\"><accordion-heading>{{ item.description }}</accordion-heading><ul class=\"nav nav-pills nav-stacked\"><six-menu-item ng-repeat=\"subitem in item.children\" label=\"{{ subitem.description }}\" icon=\"{{subitem.icon}}\" route=\"{{ subitem.code }}\"></six-menu-item></ul></accordion-group></accordion></div>");
$templateCache.put("theme/directives/six-statix/six-statix.html","<style>\n  .thumbList {\n    padding: 0 0 0 0;\n    margin: 0 0 0 0;\n  }\n\n  .thumbList li {\n    list-style: none;\n    margin-bottom: 25px;\n  }\n\n  button.btn.btn-sidebar {\n    color: #fff;\n    border: solid 1px #ffffff;\n  }\n\n  button.btn.btn-icon {\n    line-height: 0px;\n  }\n</style><div ng-if=\"showPre\"></div><div ng-if=\"!showUpload && !showPreview\"><div ng-include=\"\'theme/directives/six-statix/tab-list.tpl.html\'\"></div></div><uib-tabset active=\"tabs.activeTab\" ng-if=\"showUpload || showPreview\"><uib-tab index=\"0\"><uib-tab-heading ng-click=\"refresh()\">Elenco</uib-tab-heading><div ng-include=\"\'theme/directives/six-statix/tab-list.tpl.html\'\"></div></uib-tab><uib-tab index=\"1\" select=\"tabUploadShow()\" ng-if=\"showUpload\"><uib-tab-heading>Carica</uib-tab-heading><div ng-include=\"\'theme/directives/six-statix/tab-upload.tpl.html\'\"></div></uib-tab><uib-tab index=\"2\" class=\"hidden\" ng-if=\"showPreview\"><uib-tab-heading>Anteprima</uib-tab-heading><div ng-include=\"\'theme/directives/six-statix/tab-preview.tpl.html\'\"></div></uib-tab></uib-tabset>");
$templateCache.put("theme/directives/six-statix/tab-list.tpl.html","<div class=\"row\"><div class=\"col col-md-12 m-b\"><input class=\"form-control\" type=\"text\" ng-model=\"search\" placeholder=\"Cerca...\" style=\"width:100%\"></div></div><div class=\"row\"><div ng-if=\"ls.length < 1\" class=\"col-sm-12 thumbColumn wrapper\"><div class=\"alert alert-info\">Nessun allegato disponibile</div></div><div ng-if=\"ls.length > 0\" class=\"col-sm-12 thumbColumn\"><ul class=\"thumbList\"><li ng-repeat=\"f in ls | filter:search\"><div class=\"m-t-sm m-b-sm\"><a ng-href=\"{{ statixUrl + f.relUrl }}\" class=\"m-r-xs\" download=\"{{ f.name }}\"><button class=\"btn btn-primary btn-icon\"><span class=\"fa fa-download\"></span></button></a> <a ng-click=\"select(f)\" class=\"m-r-xs\" id=\"btn_user_detail\" ng-if=\"showPreview\"><button class=\"btn btn-primary btn-icon\" ng-disabled=\"!hasPreview(f)\"><span class=\"fa fa-search\"></span></button></a> <a ng-click=\"delete(f, $index)\" class=\"m-r-xs\" id=\"btn_user_detail\" ng-if=\"showDelete\"><button class=\"btn btn-primary btn-icon\"><span class=\"fa fa-times\"></span></button></a> {{ f.name }}</div></li></ul></div></div>");
$templateCache.put("theme/directives/six-statix/tab-preview.tpl.html","<div class=\"row\"><div class=\"col col-md-12 m-b\"><label for=\"name\">Anteprima</label></div></div><div class=\"row m-b-sm\"><div class=\"col col-md-12 preview\"><a ng-if=\"selected != null\" ng-href=\"{{ statixUrl + selected.relUrl }}\" class=\"m-r-xs\" download=\"{{ selected.name }}\"><button class=\"btn btn-primary btn-icon\"><span class=\"fa fa-download\"></span></button></a> {{ selected.name }}<br></div></div><div class=\"row\"><div class=\"col col-md-12\"><div class=\"frameBackground\"><iframe ng-if=\"showFrame(selected)\" ng-src=\"{{ selected.relUrl | trustAsResourceUrl}}\" style=\"width:100%; height:600px; border:1px solid lightgray\"></iframe></div><img ng-if=\"showImg(selected)\" ng-src=\"{{ statixUrl + selected.relUrl }}\" alt=\"img\" style=\"width:100%; border: 1px solid lightgray\"></div></div>");
$templateCache.put("theme/directives/six-statix/tab-upload.tpl.html","<div ng-if=\"showUploadForm\"><form action=\"{{statixBase.value + \'/upload\' | trustAsResourceUrl}}\" target=\"uploadFrame\" method=\"post\" enctype=\"multipart/form-data\"><div class=\"row\"><div class=\"col col-md-12 form-group\"><label for=\"name\">Carica un file:</label> <input id=\"name\" type=\"file\" name=\"file\" class=\"btn btn-default\" style=\"width:100%\"></div></div><div class=\"row\"><div class=\"col col-md-12\"><button type=\"submit\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-archive\"></i>Invia</button> <span><span class=\"wait-indicator\" ng-if=\"loading\"><i class=\"fa fa-refresh fa-spin\"></i></span></span> <input id=\"path\" name=\"path\" type=\"hidden\" value=\"{{path}}\"><br></div></div><div class=\"row\"><div class=\"col col-md-12\"><div class=\"frameBackground\" ng-show=\"showUploadFrame\"><iframe id=\"uploadFrame\" name=\"uploadFrame\" style=\"min-height:200px;width:100%;border:1px solid lightgray\" iframe-onload=\"iframeLoadedCallBack()\"></iframe></div></div></div></form></div>");
$templateCache.put("theme/directives/six-toolbar/sixToolbarButtonTemplate.html","<li><div class=\"inline m-r text-left stb-content\"><button class=\"btn btn-default btn-sm {{btnClass}}\" href=\"\" ng-click=\"callback()\" ng-disabled=\"sxDisabled\" ng-class=\"{\'btn-stacked-icon\': iconStacked}\" title=\"{{btnTitle}}\"><span ng-if=\"!iconStacked\"><span class=\"{{icon}}\" ng-hide=\"iconCondition\" ng-class=\"{\'icon-only\': noLabel}\"></span> <span class=\"{{iconDisabled}}\" ng-show=\"iconCondition\" ng-class=\"{\'icon-only\': noLabel}\"></span></span> <span class=\"fa-stack fa-sm\" ng-if=\"iconStacked\"><span class=\"{{icon}}\" ng-hide=\"iconCondition\" ng-class=\"{\'icon-only\': noLabel}\"></span> <span class=\"{{iconDisabled}}\" ng-show=\"iconCondition\" ng-class=\"{\'icon-only\': noLabel}\"></span> <span class=\"{{iconStacked}}\" ng-hide=\"iconCondition\" ng-class=\"{\'icon-only\': noLabel}\"></span> <span class=\"{{iconStackedDisabled}}\" ng-show=\"iconCondition\" ng-class=\"{\'icon-only\': noLabel}\"></span></span> <span>{{ label }}</span></button></div></li>");
$templateCache.put("theme/directives/six-toolbar/sixToolbarItemTemplate.html","<li><a href=\"\" ng-disabled=\"sxDisabled\" ng-click=\"callback()\" class=\"six-toolbar-item-a dropdown\" ng-class=\"{\'six-toolbar-item-enabled\': isEnabled}\" data-toggle=\"dropdown\" role=\"button\" aria-expanded=\"false\"><span class=\"pull-right text-muted\" ng-show=\"hasTranscluded\"><i class=\"fa fa-fw fa-angle-down text\"></i></span> <i class=\"{{icon}}\" ng-hide=\"iconCondition\" ng-class=\"{\'six-toolbar-item-disabled\': sxDisabled}\"></i> <i class=\"{{iconDisabled}}\" ng-show=\"iconCondition\" ng-class=\"{\'six-toolbar-item-disabled\': sxDisabled}\"></i> <span class=\"font-bold {{labelClass}}\" ng-hide=\"labelCondition\" ng-class=\"{\'six-toolbar-item-disabled\': sxDisabled}\">{{ label }}</span> <span class=\"font-bold {{labelClass}}\" ng-show=\"labelCondition\" ng-class=\"{\'six-toolbar-item-disabled\': sxDisabled}\">{{ labelDisabled }}</span></a><ul ng-class=\"{\'dropdown-menu\': hasTranscluded}\" ng-show=\"!sxDisabled\" ng-transclude=\"\"></ul></li>");
$templateCache.put("theme/directives/six-toolbar/sixToolbarTemplate.html","<style type=\"text/css\">\n  /* Aggiustamenti per non sovrascrivere la navbar di default in alto */\n\n  .custom-toolbar {\n    top: 50px;\n    border-bottom: solid 1px #dee5e7;\n    background-color: #f6f8f8;\n  }\n\n  six-toolbar-item {\n    position: relative;\n    display: block;\n    padding: 15px 15px;\n    text-decoration: none;\n    float: left;\n  }\n\n  six-toolbar-item .dropdown-menu {\n    margin-top: 0px;\n  }\n\n  six-toolbar-button {\n    float: left;\n  }\n\n  six-toolbar-button .stb-content {\n    vertical-align: middle;\n    display: inline-block;\n    margin-top: 5px;\n    margin-bottom: 5px;\n  }\n\n  six-toolbar-button .icon-only {\n    line-height: 1.428571;\n  }\n\n  six-toolbar-button .icon-padded .icon-only {\n    padding-left: 4px;\n  }\n\n  six-toolbar-button:first-child .stb-content {\n    margin-left: 15px;\n  }\n\n  .six-toolbar-item-a {\n    color: #777;\n  }\n\n  .six-toolbar-item-disabled {\n    color: #777 !important;\n    opacity: 0.5;\n  }\n\n  six-toolbar-item .disabled {\n    color: #777 !important;\n    opacity: 0.5;\n  }\n\n\n  @media (min-width: 768px) {\n    .toolbar-default {\n      left: 200px;\n      height: 50px;\n      overflow: hidden !important;\n\n    }\n\n    six-toolbar-item li {\n      display: block;\n      margin-top: 0px;\n      position: relative;\n      z-index: 10;\n    }\n\n    six-toolbar-item li.open {\n      display: block !important;\n      margin-top: 0px !important;\n      position: relative !important;\n      z-index: 10 !important;\n    }\n\n    six-toolbar-item li.open>.dropdown-menu {\n      overflow: visible !important;\n      z-index: 1000;\n      position: fixed !important;\n      display: block !important;\n      top: 88px !important;\n      left: auto !important;\n      right: auto !important;\n\n    }\n\n\n    .six-toolbar-items-container li.open ul.dropdown-menu li {\n      height: auto !important;\n      overflow: visible !important;\n    }\n\n    .toolbar-large {\n      left: 60px;\n    }\n\n    #six_toolbar {\n      margin-left: 0px;\n    }\n\n    six-toolbar-button .stb-content {\n      margin-top: 10px;\n      margin-bottom: 0px;\n    }\n\n  }\n\n  six-toolbar-button .btn-stacked-icon {\n    padding: 0 10px;\n    height: 30px;\n  }\n</style><nav class=\"navbar navbar-default navbar-fixed-top custom-toolbar\" ng-class=\"{\'toolbar-default\': sidebarExpanded, \'toolbar-large\': !sidebarExpanded}\"><div class=\"container-fluid\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#six_toolbar\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"collapse navbar-collapse\" id=\"six_toolbar\"><div class=\"col-sm-5\"><h3 class=\"title\">{{title}} {{staticTitle}}</h3></div><div class=\"col-sm-7\"><ul class=\"nav navbar-nav content navbar-right six-toolbar-items-container six-toolbar-buttons-container\"></ul></div></div></div></nav>");
$templateCache.put("theme/directives/templates/sixlookup2.html","<style type=\"text/css\">\n  .no-grey {\n    background-color: #fff !important;\n  }\n\n  .adapt-margin-content {\n    margin-right: 0px;\n    margin-left: 0px;\n  }\n\n  .form-group {\n    margin-bottom: 0px;\n  }\n\n  .align-content {\n    text-align: right;\n  }\n\n  .help-block {\n    margin-bottom: 0px;\n  }\n\n  .custom-elem {\n    padding: 3px 5px 3px 5px;\n    display: block;\n    overflow: hidden;\n  }\n\n  .custom-elem:hover {\n    color: #212121;\n    background-color: #e0e0e0;\n  }\n\n  .custom-elem span {\n    min-width: 25px;\n    display: block;\n    overflow: hidden;\n    -webkit-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);\n    -o-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);\n    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);\n  }\n\n  .custom-elem span i {\n    text-align: center;\n  }\n\n  .custom-elem span:hover {\n    cursor: pointer;\n  }\n\n  .sixlookup-item-selected:before {\n    content: \"\\f00c\";\n    font-family: FontAwesome;\n    font-style: normal;\n    font-weight: normal;\n    text-decoration: inherit;\n    float: left;\n    /*--adjust as necessary--*/\n    color: #000;\n    /*font-size: 18px;*/\n    padding: 0em 0.5em;\n    /*position: absolute;*/\n    /*top: 10px;*/\n    /*left: 0;*/\n  }\n\n  .sixlookup-item-selected {\n    background-color: #11c7f5 !important;\n    color: #FFFFFF;\n  }\n\n  .sixlookup-value {\n    width: 100%;\n    overflow: hidden;\n    display: inline-block;\n    text-overflow: ellipsis;\n  }\n\n  .form-control > .host {\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n\n  .form-control > .host > .tags {\n    border: 0px;\n    box-shadow: none;\n  }\n\n  tags-input.form-control {\n    height: auto;\n  }\n</style><six-sidebar sx-id=\"{{sxId}}_sb\" class=\"sixlookup2\" sx-position=\"{{sxPosition}}\" sx-title=\"sxTitle || sxType\" sx-dimension=\"{{sxDimension}}\" sx-opened=\"sxVisible\" sx-pinnable=\"sxPinnable\" sx-pinned=\"sxPinned\"><div class=\"nav-tabs-alt\"><ul class=\"nav nav-tabs\" style=\"margin: 0px;\" role=\"tablist\" id=\"{{sxId}}_lk-tab-headers\"><li id=\"{{sxId}}_tab-s-filters\" ng-if=\"filtersTabEnabled()\"><a data-target=\"#{{sxId}}_tab-filters\" role=\"tab\" data-toggle=\"tab\" class=\"text-md text-muted\"><span><i class=\"fa fa-filter m-l-xs\"></i> Filtri</span></a></li><li id=\"{{sxId}}_tab-s-list\" class=\"active\"><a data-target=\"#{{sxId}}_tab-list\" role=\"tab\" data-toggle=\"tab\" class=\"text-md text-muted\"><span><i class=\"fa fa-list m-l-xs\"></i> Lista</span></a></li><li id=\"{{sxId}}_tab-s-details\" ng-if=\"detailsTabEnabled()\"><a data-target=\"#{{sxId}}_tab-details\" role=\"tab\" data-toggle=\"tab\" class=\"text-md text-muted\"><span><i class=\"fa fa-info m-l-xs\"></i> Dettagli</span></a></li><li class=\"pull-right\" ng-if=\"sxAdd==true\"><a class=\"text-md\" ng-click=\"addNewRecord(true)\" title=\"Aggiungi\" ng-if=\"vars.insertMode==false\"><span><i class=\"fa fa-plus-circle m-l-xs\"></i></span></a> <a class=\"text-md\" ng-click=\"undoNewRecord(true)\" title=\"Annulla\" ng-if=\"vars.insertMode==true\"><span><i class=\"fa fa-undo m-l-xs\"></i></span></a></li></ul></div><div class=\"tab-content\"><div role=\"tabpanel\" id=\"{{sxId}}_tab-filters\" class=\"tab-pane\" ng-if=\"filtersTabEnabled()\"><div ng-if=\"vars.schemaLoaded == true\"><six-search-filters sx-filter=\"searchFilterObj\" sx-filter-init=\"searchFilterArray\" sx-id=\"{{sxId}}_tab-filters-f\" sx-open=\"sxSearchTerms.open\" sx-filter-only=\"true\" sx-on-filter-changed=\"onFilterChanged()\" sx-model=\"sxSearchTerms\"></six-search-filters></div><div ng-if=\"vars.schemaLoaded == false\"><div class=\"row wrapper adapt-margin-content\">Dati non disponibili</div></div></div><div role=\"tabpanel\" id=\"{{sxId}}_tab-list\" class=\"tab-pane active\"><ul class=\"nav list-sidebar-nav\"><div class=\"row wrapper adapt-margin-content\" ng-if=\"!sxType && list.length == 0\"><a>Nessun tipo di asset impostato</a></div><span ng-if=\"sxType || (!sxType && list.length > 0)\"><li><div class=\"form-group m-l-xs m-r-xs\"><div class=\"input-group has-button\" style=\"width: 100%\"><input id=\"{{sxId}}-filter\" type=\"search\" class=\"form-control\" placeholder=\"Filtra...\" ng-model=\"filter.text\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"clearSearchFn()\"><i class=\"fa fa-times\"></i></button></span></div></div></li><li ng-if=\"!vars.listLoaded\"><div style=\"text-align: center\"><i class=\"fa fa-spinner fa-2x fa-pulse fa-fw text-info-dker\" aria-hidden=\"true\"></i></div></li><span ng-if=\"vars.listLoaded\"><li class=\"row wrapper adapt-margin-content\" ng-if=\"!list || list.length == 0\"><a>Nessun {{sxType}} disponibile</a></li><li ng-repeat=\"item in list\"><span class=\"custom-elem\"><span class=\"pull-right text-center b-l b-r\" ng-click=\"viewItemDetails(item)\" title=\"Dettagli\" six-sidebar-autoclose=\"false\" ng-if=\"detailsTabEnabled()\"><i class=\"fa fa-info\"></i></span> <span ng-click=\"toggleSelect(item)\" title=\"{{item.code}} - {{item.description}}\" six-sidebar-autoclose=\"true\" ng-class=\"{\'sixlookup-item-selected\': isItemSelected(item)}\"><span ng-if=\"!sxItemTemplate && !sxItemTemplateUrl\">{{item.code}} - {{item.description | cut:true:50:\'...\'}}</span><ng-include ng-if=\"!sxItemTemplate && sxItemTemplateUrl\" src=\"sxItemTemplateUrl\"></ng-include><span ng-if=\"sxItemTemplate\" ng-bind-html=\"evaluateTemplate(sxItemTemplate, item)\"></span></span></span></li></span></span></ul><div class=\"m-t\" style=\"text-align: center\"><div class=\"text-muted\">{{start}} - {{end}} di {{vars.totalItems}}</div><uib-pagination total-items=\"vars.totalItems\" ng-model=\"vars.page\" items-per-page=\"50\" max-size=\"5\" boundary-links=\"true\" class=\"pagination-sm\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div><div role=\"tabpanel\" id=\"{{sxId}}_tab-details\" class=\"tab-pane\" ng-if=\"detailsTabEnabled()\"><div ng-if=\"vars.schemaLoaded == true && (vars.insertMode == true || fullTmpObj.UUID)\"><div class=\"row wrapper adapt-margin-content align-content\" ng-if=\"vars.insertMode == true\"><span class=\"pull-left form-group\"><input type=\"checkbox\" id=\"commission_dependent\" ng-model=\"vars.commissionDependent\" name=\"commission_dependent\"> <label id=\"schema_commission_key\" for=\"commission_dependent\" class=\"control-label\">Relativo a commessa</label></span> <a ng-click=\"updateRecord()\" class=\"btn btn-success btn-sm\" id=\"btn_item_create\"><i class=\"fa fa-floppy-o\"></i> Salva</a></div><div class=\"m-r pull-right\" ng-if=\"vars.insertMode == false\"><a ng-click=\"select(fullTmpObj)\" class=\"btn btn-success btn-sm\" id=\"btn_item_select\"><i class=\"fa fa-check\"></i> Seleziona</a></div><div class=\"row wrapper adapt-margin-content\"><div sf-schema=\"vars.schema\" sf-form=\"vars.form\" sf-model=\"fullTmpObj.model\" update-six-formula=\"\" compact-lookup=\"\"></div><a class=\"btn btn-sm\" ng-click=\"fullTmpObj.model.typeoperator=\'richiedente\'\"></a> {{fullTmpObj}}</div></div><div ng-if=\"vars.schemaLoaded == false || (vars.insertMode == false && !fullTmpObj.UUID)\"><div class=\"row wrapper adapt-margin-content\">Dati non disponibili</div></div></div></div></six-sidebar><script type=\"text/ng-template\" id=\"lookup-custom-template\"><span title=\"{{data.code}} - {{data.description}}\"> <small ng-bind-html=\"$highlight($getDisplayText())\"></small> - <small ng-bind-html=\"$highlight(data.description)\"></small> </span></script><script type=\"text/ng-template\" id=\"lookup-tag-template\"><span title=\"{{data.code}} - {{data.description}}\"> <span ng-bind=\"$getDisplayText()\"></span> <a class=\"remove-button\" ng-click=\"$removeTag()\" ng-bind=\"::$$removeTagSymbol\"></a> </span></script><div class=\"input-group has-button\" style=\"width: 100%\" ng-if=\"!sxCompact\"><div id=\"{{sxId}}_it\" type=\"text\" class=\"form-control no-grey sixlookup-value\" title=\"{{ngModel[sxField].code}} - {{ngModel[sxField].description}}\" ng-bind-html=\"valueToShow\" placeholder=\"{{placeholder}}\" ng-click=\"onFocusItCB()\" readonly=\"\" ng-if=\"!isMultiple()\"></div><tags-input id=\"{{sxId}}_2_it\" class=\"form-control bootstrap\" style=\"width: 100%; padding: 0px !important;\" placeholder=\"{{placeholder}}\" ng-model=\"ngModel[sxField]\" template=\"lookup-tag-template\" display-property=\"code\" key-property=\"UUID\" min-length=\"1\" ng-click=\"onFocusItCB()\" ng-if=\"isMultiple()\" add-from-autocomplete-only=\"true\" ng-disabled=\"sxDisabled\"><auto-complete source=\"list | filter: $query\" template=\"lookup-custom-template\" add-from-autocomplete-only=\"true\" min-length=\"3\"></auto-complete></tags-input><span class=\"input-group-btn\" style=\"vertical-align: top\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"clearSelect()\" six-sidebar-autoclose=\"true\" ng-disabled=\"sxDisabled\"><i class=\"fa fa-times\"></i></button> <span id=\"{{sxId}}-transclude\" ng-transclude=\"\"></span></span></div><div class=\"input-group has-button\" style=\"width: 100%\" ng-class=\"{\'has-error ng-invalid\': ngInvalid == true, \'has-success\': ngValid == true}\" ng-if=\"sxCompact\"><ui-select ng-model=\"ngModel\" theme=\"bootstrap\" on-select=\"select($item);item=$item\" ng-disabled=\"sxDisabled\" reset-search-input=\"false\" ng-if=\"!isMultiple()\"><ui-select-match class=\"ui-select-match\" placeholder=\"{{form.placeholder}}\"><span ng-bind-html=\"valueToShow\" ng-if=\"!sxItemTemplateUrl\"></span><ng-include src=\"sxItemTemplateUrl\" ng-if=\"sxItemTemplateUrl\"></ng-include></ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in list track by $index\" refresh=\"getListForTags($select.search)\" refresh-delay=\"0\"><span ng-if=\"!sxItemTemplate && !sxItemTemplateUrl\"><span ng-bind-html=\"item.code | highlight: $select.search\"></span> - <span ng-bind-html=\"item.description | highlight: $select.search\"></span></span><ng-include ng-if=\"!sxItemTemplate && sxItemTemplateUrl\" src=\"sxItemTemplateUrl\"></ng-include><span ng-if=\"sxItemTemplate\" ng-bind-html=\"evaluateTemplate(sxItemTemplate, item) | highlight: $select.search\"></span></ui-select-choices></ui-select><tags-input class=\"form-control bootstrap\" style=\"width: 100%; padding: 0px !important;\" placeholder=\"{{form.placeholder}}\" ng-model=\"ngModel[sxField]\" template=\"lookup-tag-template\" display-property=\"code\" key-property=\"UUID\" min-length=\"1\" ng-if=\"isMultiple()\" add-from-autocomplete-only=\"true\" ng-disabled=\"sxDisabled\"><auto-complete source=\"getListForTags($query)\" template=\"lookup-custom-template\" load-on-focus=\"true\" load-on-empty=\"true\" load-on-down-arrow=\"true\" add-from-autocomplete-only=\"true\" min-length=\"0\"></auto-complete></tags-input><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"clearSelect()\" ng-disabled=\"sxDisabled\"><i class=\"fa fa-times\"></i></button></span></div>");
$templateCache.put("theme/directives/templates/sixsearchform.html","<div class=\"input-group has-button\" style=\"width: 100%\"><input type=\"search\" class=\"form-control\" placeholder=\"{{placeholder}}\" ng-model=\"ngModel\" ng-keyup=\"keyupFn()\" ng-change=\"changeFn()\"> <span class=\"input-group-btn\" ng-show=\"showClearBtn\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"clearSearchFn()\"><i class=\"fa fa-times\"></i></button></span> <span class=\"input-group-btn\" ng-show=\"hideSearchBtn === \'false\'\"><button class=\"btn btn-bg btn-default\" type=\"button\" ng-click=\"searchFn()\"><i class=\"fa fa-search\"></i></button></span></div>");
$templateCache.put("theme/directives/templates/sixselect2.html","<style type=\"text/css\">\n  .no-grey {\n    background-color: #fff !important;\n  }\n\n  .adapt-margin-content {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .form-group {\n    margin-bottom: 0;\n  }\n\n  .align-content {\n    text-align: right;\n  }\n\n  .help-block {\n    margin-bottom: 0;\n  }\n\n  .custom-elem {\n    padding: 3px 5px 3px 5px;\n    display: block;\n    overflow: hidden;\n  }\n\n  .custom-elem:hover {\n    color: #212121;\n    background-color: #e0e0e0;\n  }\n\n  .custom-elem span {\n    min-width: 25px;\n    display: block;\n    overflow: hidden;\n    -webkit-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);\n    -o-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);\n    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);\n  }\n\n  .custom-elem span i {\n    text-align: center;\n  }\n\n  .custom-elem span:hover {\n    cursor: pointer;\n  }\n\n  .sixlookup-item-selected:before {\n    content: \"\\f00c\";\n    font-family: FontAwesome;\n    font-style: normal;\n    font-weight: normal;\n    text-decoration: inherit;\n    /*--adjust as necessary--*/\n    color: #000;\n    /*font-size: 18px;*/\n    padding: 0 0.5em;\n    /*position: absolute;*/\n    /*top: 10px;*/\n    /*left: 0;*/\n  }\n\n  .sixlookup-item-selected {\n    background-color: #11c7f5 !important;\n    color: #FFFFFF;\n  }\n\n  .form-control > .host {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  .form-control > .host > .tags {\n    border: 0;\n    box-shadow: none;\n  }\n\n  tags-input.form-control {\n    height: auto;\n  }\n</style><six-sidebar sx-id=\"{{sxId}}_sb\" class=\"sixlookup2\" sx-position=\"{{sxPosition}}\" sx-title=\"sxTitle || sxType\" sx-dimension=\"{{sxDimension}}\" sx-opened=\"sxVisible\" sx-pinnable=\"sxPinnable\" sx-pinned=\"sxPinned\"><ul class=\"nav list-sidebar-nav\"><li class=\"row wrapper adapt-margin-content\" ng-if=\"!sxList || sxList.length == 0\"><span ng-if=\"sxType\"><a>Nessun {{sxType}} caricato</a></span> <span ng-if=\"!sxType\"><a>Nessun tipo di asset impostato</a></span></li><li ng-if=\"sxList && sxList.length > 0\"><div class=\"form-group m-l-xs m-r-xs\"><div class=\"input-group has-button\" style=\"width: 100%\"><input id=\"{{sxId}}-filter\" type=\"search\" class=\"form-control\" placeholder=\"Filtra...\" ng-model=\"filter.text\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"clearSearchFn()\"><i class=\"fa fa-times\"></i></button></span></div><div class=\"m-t-xs m-b-xs input-group-btn\" ng-if=\"isMultiple()\"><a class=\"btn btn-success btn-sm\" title=\"Seleziona tutti\" style=\"width: 50%; display: inline-block;\" ng-click=\"selectAll()\"><i class=\"fa fa-check-square-o\"></i> Seleziona tutti</a> <a class=\"btn btn-danger btn-sm\" title=\"Deseleziona tutti\" style=\"width: 50%; display: inline-block;\" ng-click=\"unselectAll()\"><i class=\"fa fa-square-o\"></i> Deseleziona tutti</a></div></div></li><li ng-repeat=\"item in sxList | filter:filter.text track by $index\" ng-if=\"sxList && sxList.length > 0\"><span class=\"custom-elem\"><span ng-click=\"toggleSelect(item)\" title=\"{{item[sxKey]}} - {{item[sxDescription]}}\" six-sidebar-autoclose=\"true\" ng-class=\"{\'sixlookup-item-selected\': isItemSelected(item)}\"><span ng-if=\"!sxItemTemplate && !sxItemTemplateUrl\">{{item[sxKey]}} - {{item[sxDescription] | cut:true:50:\'...\'}}</span><ng-include ng-if=\"!sxItemTemplate && sxItemTemplateUrl\" src=\"sxItemTemplateUrl\"></ng-include><span ng-if=\"sxItemTemplate\" ng-bind-html=\"evaluateTemplate(sxItemTemplate, item)\"></span></span></span></li></ul></six-sidebar><script type=\"text/ng-template\" id=\"select-custom-template\"><span> <small ng-bind-html=\"$highlight($getDisplayText())\"></small> </span></script><script type=\"text/ng-template\" id=\"select-tag-template\"><span> <span ng-bind=\"$getDisplayText()\"></span> <a class=\"remove-button\" ng-click=\"$removeTag()\" ng-bind=\"::$$removeTagSymbol\"></a> </span></script><div class=\"input-group has-button\" style=\"width: 100%\" ng-class=\"{\'has-error ng-invalid\': ngInvalid, \'has-success\': ngValid}\" ng-if=\"!sxCompact\"><input id=\"{{sxId}}_it\" class=\"form-control no-grey\" ng-value=\"valueToShow\" placeholder=\"{{placeholder}}\" ng-click=\"onFocusItCB()\" readonly=\"\" ng-if=\"!isMultiple()\" ng-disabled=\"sxDisabled\"><tags-input id=\"{{sxId}}_2_it\" class=\"form-control bootstrap\" style=\"width: 100%; padding: 0 !important;\" placeholder=\"{{placeholder}}\" ng-model=\"ngModel[sxField]\" template=\"select-tag-template\" display-property=\"{{sxDescription}}\" key-property=\"{{sxKey}}\" ng-click=\"onFocusItCB()\" ng-if=\"isMultiple()\" add-from-autocomplete-only=\"true\" ng-disabled=\"sxDisabled\"><auto-complete source=\"sxList | filter: $query\" template=\"select-custom-template\" add-from-autocomplete-only=\"true\" min-length=\"3\"></auto-complete></tags-input><span class=\"input-group-btn\" style=\"vertical-align: top\"><a class=\"btn btn-bg btn-default\" ng-click=\"clearSelect()\" six-sidebar-autoclose=\"true\" ng-if=\"sxClearable\" ng-disabled=\"sxDisabled\"><i class=\"fa fa-times\"></i></a> <span id=\"{{sxId}}-transclude\" ng-transclude=\"\"></span></span></div><div class=\"input-group has-button\" style=\"width: 100%\" ng-class=\"{\'has-error ng-invalid\': ngInvalid == true, \'has-success\': ngValid == true}\" ng-if=\"sxCompact\"><ui-select ng-model=\"ngModel\" theme=\"bootstrap\" on-select=\"select($item);item=$item\" ng-disabled=\"sxDisabled\" reset-search-input=\"false\" ng-if=\"!isMultiple()\"><ui-select-match class=\"ui-select-match\" placeholder=\"{{form.placeholder}}\"><span ng-bind-html=\"valueToShow\" ng-if=\"!sxItemTemplateUrl\"></span><ng-include src=\"sxItemTemplateUrl\" ng-if=\"sxItemTemplateUrl\"></ng-include></ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in sxList | filter: $select.search track by $index\" refresh-delay=\"0\"><span ng-if=\"!sxItemTemplate && !sxItemTemplateUrl\"><span ng-bind-html=\"item[sxKey] | highlight: $select.search\"></span> - <span ng-bind-html=\"item[sxDescription] | highlight: $select.search\"></span></span><ng-include ng-if=\"!sxItemTemplate && sxItemTemplateUrl\" src=\"sxItemTemplateUrl\"></ng-include><span ng-if=\"sxItemTemplate\" ng-bind-html=\"evaluateTemplate(sxItemTemplate, item) | highlight: $select.search\"></span></ui-select-choices></ui-select><tags-input class=\"form-control bootstrap\" style=\"width: 100%; padding: 0 !important;\" placeholder=\"{{form.placeholder}}\" ng-model=\"ngModel\" template=\"select-tag-template\" display-property=\"{{sxDescription}}\" key-property=\"{{sxKey}}\" ng-if=\"isMultiple()\" add-from-autocomplete-only=\"true\" ng-disabled=\"sxDisabled\" on-tag-removed=\"unselect($tag)\" on-tag-added=\"select($tag)\"><auto-complete source=\"sxList | filter: $query\" template=\"select-custom-template\" load-on-focus=\"true\" load-on-empty=\"true\" load-on-down-arrow=\"true\" add-from-autocomplete-only=\"true\" min-length=\"0\"></auto-complete></tags-input><span class=\"input-group-btn\"><a class=\"btn btn-bg btn-default\" ng-click=\"clearSelect()\" ng-if=\"sxClearable\" ng-disabled=\"sxDisabled\"><i class=\"fa fa-times\"></i></a></span></div>");
$templateCache.put("theme/directives/templates/sixsidebar.html","<style type=\"text/css\">\n  .six-sidebar-header {\n    color: #dcf2f8;\n    background-color: #23b7e5;\n    padding: 10px 15px;\n    border-bottom: 1px solid transparent;\n    border-radius: 2px 2px 0 0;\n  }\n  .sidebar-pinned {\n    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n    -webkit-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n  }\n  .sidebar-s-left.open,\n  .sidebar-s-right.open {\n    min-width: 180px;\n    width: 180px;\n  }\n  .sidebar-s-left.open,\n  .sidebar-m-left.open,\n  .sidebar-l-left.open {\n    left: 200px;\n  }\n\n  .app.app-aside-folded .sidebar-s-left.open,\n  .app.app-aside-folded .sidebar-m-left.open,\n  .app.app-aside-folded .sidebar-l-left.open {\n    left: 60px;\n  }\n  .sidebar-m-left.open,\n  .sidebar-m-right.open {\n    min-width: 280px;\n    width: 280px;\n  }\n  .sidebar-l-left.open,\n  .sidebar-l-right.open {\n    min-width: 370px;\n    width: 370px;\n  }\n  .sidebar-xl-left.open,\n  .sidebar-xl-right.open {\n    min-width: 460px;\n    width: 460px;\n  }\n  .sidebar-xxl-left.open,\n  .sidebar-xxl-right.open {\n    min-width: 550px;\n    width: 550px;\n  }\n  .sidebar-50-left.open,\n  .sidebar-50-right.open {\n    min-width: 50%;\n    width: 50%;\n  }\n  .sidebar-100-left.open,\n  .sidebar-100-right.open {\n    min-width: 100%;\n    width: 100%;\n  }\n  .sidebar-s-left.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-s-left-padded {\n    padding: 0px 0px 0px 0px;\n    margin-left: 180px;\n  }\n  .sidebar-s-right.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-s-right-padded {\n    padding: 0px 0px 0px 0px;\n    margin-right: 180px;\n  }\n  .sidebar-m-left.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-m-left-padded {\n    padding: 0px 0px 0px 0px;\n    margin-left: 280px;\n  }\n  .sidebar-m-right.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-m-right-padded {\n    padding: 0px 0px 0px 0px;\n    margin-right: 280px;\n  }\n  .sidebar-l-left.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-l-left-padded {\n    padding: 0px 0px 0px 0px;\n    margin-left: 370px;\n  }\n  .sidebar-l-right.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-l-right-padded {\n    padding: 0px 0px 0px 0px;\n    margin-right: 370px;\n  }\n  .sidebar-xl-left.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-xl-left-padded {\n    padding: 0px 0px 0px 0px;\n    margin-left: 460px;\n  }\n  .sidebar-xl-right.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-xl-right-padded {\n    padding: 0px 0px 0px 0px;\n    margin-right: 460px;\n  }\n  .sidebar-xxl-left.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-xxl-left-padded {\n    padding: 0px 0px 0px 0px;\n    margin-left: 550px;\n  }\n  .sidebar-xxl-right.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-xxl-right-padded {\n    padding: 0px 0px 0px 0px;\n    margin-right: 550px;\n  }\n  .sidebar-50-left.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-50-left-padded {\n    padding: 0px 0px 0px 0px;\n    margin-left: 55%;\n  }\n  .sidebar-50-right.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-50-right-padded {\n    padding: 0px 0px 0px 0px;\n    margin-right: 55%;\n  }\n  .sidebar-100-left.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-100-left-padded {\n    padding: 0px 0px 0px 0px;\n    margin-left: 100%;\n  }\n  .sidebar-100-right.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-100-right-padded {\n    padding: 0px 0px 0px 0px;\n    margin-right: 100%;\n  }\n  .btn-icon-sidebar {\n    width: 34px;\n    height: 34px;\n    line-height: 34px;\n    text-align: center;\n  }\n</style><aside id=\"{{sxId}}\" class=\"list-sidebar list-sidebar-default list-sidebar-fixed-{{sxPosition}} sidebar-{{sxDimension}}-{{sxPosition}} list-sidebar-stacked custom-six-sidebar {{sxClass}}\" ng-class=\"{\'open\': sxOpened, \'sidebar-pinned\': sxPinned}\" role=\"navigation\"><div class=\"panel sidebar-panel\" ng-if=\"sxShowTitle\"><a class=\"btn btn-info pull-left btn-icon-sidebar\" title=\"Chiudi\" ng-click=\"toggleSidebar()\" ng-if=\"sxClosable\"><span class=\"fa fa-times icon-only\" style=\"font-size: 18px\"></span></a> <a class=\"btn btn-info pull-right btn-icon-sidebar\" title=\"{{sxPinned?\'Unpin\':\'Pin\'}}\" ng-click=\"togglePinnedSidebar()\" ng-if=\"sxPinnable\"><span style=\"font-size: 18px\" class=\"fa icon-only\" ng-class=\"{\'fa-chain\': sxPinned, \'fa-chain-broken\': !sxPinned}\"></span></a><div class=\"bg-info sidebar-heading six-sidebar-header\"><span>{{sxTitle}}</span></div></div><div id=\"{{sxId}}-content\" ng-click=\"smartCloseSidebar($event)\" ng-transclude=\"\"></div></aside>");
$templateCache.put("theme/modals/six-confirm-modal/six-confirm-modal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">{{$ctrl.sxTitle}}</h4></div><div class=\"modal-body\">{{$ctrl.sxMessage}}</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$close(false)\">Annulla</button> <button type=\"button\" class=\"btn btn-info\" ng-click=\"$close(true)\">Conferma</button></div></div>");
$templateCache.put("theme/modals/six-print-modal/six-print-modal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">{{$ctrl.sxTitle}}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col col-md-12\"><label class=\"control-label\">{{ \"select_printer\" | translate}}</label><six-lookup ng-model=\"$ctrl.lookup.label_printer_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-id=\"$ctrl.settings.label_printer_id\" sx-type=\"\'label_printer\'\" sx-placeholder=\"{{ \'select_printer\' | translate}}...\" sx-relational=\"true\"></six-lookup></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$close(false)\">{{ \"undo\" | translate }}</button> <button type=\"button\" class=\"btn btn-info\" ng-click=\"$close(true)\">{{ \"confirm\" | translate }}</button></div></div>");
$templateCache.put("tnt/goods-inward/accept/goods-inward-accept.html","<six-toolbar title=\"functionTitle\"></six-toolbar><div class=\"wrapper-md m-t-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-4\"><label class=\"control-label\">{{ \"supplier\" | translate }}</label><six-lookup ng-model=\"lookup.supplier_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-preselect-if-one=\"preselectSupplier\" sx-id=\"advFilter.filter.supplier_id\" sx-type=\"\'supplier\'\" sx-filter=\"supplierFilters\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-4\"><label>{{ \"goods_inward.supplier_ddt_number\" | translate }}</label> <input type=\"number\" class=\"form-control\" ng-model=\"advFilter.filter.dn_number\"></div><div class=\"col-md-4\"><label>{{ \"goods_inward.reference\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"advFilter.filter.reference\"></div><div class=\"col-md-4\"><label>{{ \"goods_inward.supplier_ddt_date_from\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.dn_date_from\"></six-date-picker></div><div class=\"col-md-4\"><label>{{ \"goods_inward.supplier_ddt_date_to\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.dn_date_to\"></six-date-picker></div></div></div></div><div ng-if=\"depotId\"><div class=\"col-lg-12 text-center\"><button class=\"btn btn-default m-xs\" ng-disabled=\"!acceptEnabled\" ng-click=\"acceptSelected()\"><i class=\"fa fa-check text-success\"></i> {{ \"goods_inward.accept_selected\" | translate}}</button></div><div style=\"padding-top: 50px;\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"result\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("tnt/goods-inward/container-envelope-association/container-envelope-association.html","<div class=\"page-title m-t-md\"><h1 class=\"m-n font-thin\">{{ \"goods_inward.container_envelope_binding\" | translate }}</h1></div><div class=\"wrapper-md\" ng-cloak=\"\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-4 form-group override-form-group\"><label>{{ \"barcode\" | translate }}</label><six-code-reader sx-escape128=\"true\" sx-read-mode=\"COMPONENT_READ_MODE.BARCODE\" sx-on-read=\"readCode(read)\" sx-disabled=\"codeReaderIsDisabled\"></six-code-reader></div><div class=\"col-md-4 form-group override-form-group\"><label>&nbsp;</label><div><button class=\"btn btn-default\" ng-click=\"confirmPack()\"><i class=\"fa fa-check text-success\"></i>&nbsp;{{ \"confirm\" | translate}}</button> &nbsp; <button class=\"btn btn-default\" ng-click=\"refreshList()\"><i class=\"fa fa-refresh\"></i>&nbsp;{{ \"reset\" | translate}}</button></div></div></div><div class=\"row\"><div class=\"col-md-4 form-group override-form-group\"><div class=\"alert alert-info\" role=\"alert\" ng-show=\"!container.id\">{{ \"goods_inward.read_container_barcode\" | translate }}</div><div class=\"alert alert-info\" role=\"alert\" ng-show=\"container.id && !containerFull\">{{ \"goods_inward.read_sequence_envelope\" | translate }}</div><div class=\"alert alert-success\" role=\"alert\" ng-show=\"container.id && containerFull\">{{ \"goods_inward.container_completed\" | translate }}</div></div></div><div class=\"row\"><div class=\"col-md-4 form-group override-form-group\"><label>{{ \"goods_inward.container\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"container.description\" ng-readonly=\"true\"></div><div class=\"col-md-2 form-group override-form-group\"><label>{{ \"goods_inward.max_quantity\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"container.max_quantity\" ng-readonly=\"true\"></div></div><div class=\"row\" ng-if=\"container.max_quantity\"><div class=\"wrapper m-t\"><div class=\"progress-s m-t-sm dk progress ng-isolate-scope\" value=\"{{percent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"0%\" style=\"width:{{percent}}%;\"></div></div></div></div><div ng-show=\"product.id\"><div class=\"row row b-b m-b\"><div class=\"col-md-4 form-group override-form-group\"><label>{{ \"product\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"product.description\" ng-readonly=\"true\"></div><div class=\"col-md-2 form-group override-form-group\"><label>{{ \"goods_inward.quantity_included\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"product.quantityIncluded\" ng-readonly=\"true\"></div><div class=\"col-md-2 form-group override-form-group\"><label>{{ \"goods_inward.package_quantity\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"product.packageQuantity\" ng-readonly=\"true\"></div></div><div ng-show=\"packages.length > 0\"><div class=\"row\"><div class=\"col-md-8\"><table class=\"table table-striped m-b-none\"><thead><tr><th colspan=\"2\"><h3>{{ \"goods_inward.package_list\" | translate }}</h3></th><th><h3>{{ \"goods_inward.serial_kits\" | translate }}</h3></th></tr></thead><tbody><tr></tr><tr ng-repeat=\"pack in packages\"><td class=\"col-md-1\" ng-show=\"pack.removable\"><button class=\"btn btn-danger\" ng-click=\"removeElement($event)\" value=\"{{ pack.barcode }}\"><i class=\"fa fa-trash\"></i></button></td><td class=\"col-md-1\" ng-show=\"!pack.removable\"><button class=\"btn btn-info\"><i class=\"fa fa-envelope\"></i></button></td><td class=\"col-md-5\"><b>{{ pack.barcode }}</b></td><td class=\"col-md-6\"><ul><li ng-repeat=\"sk in pack.sk\">{{sk.barcode}}</li></ul></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("tnt/goods-inward/detail/goods-inward-detail.html","<six-toolbar title=\"functionTitle\"><six-toolbar-button label=\"{{ \'list\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" toolbar-function=\"goToList()\"></six-toolbar-button><six-toolbar-button label=\"{{ \'print\' | translate }}\" btn-class=\"btn-warning\" icon=\"fa fa-print\" toolbar-function=\"printRowLabel()\" sx-disabled=\"!record.model.id || !selected.editing\"></six-toolbar-button><six-toolbar-button label=\"{{ \'goods_inward.add_row\' | translate }}\" btn-class=\"btn-warning\" icon=\"fa fa-plus\" toolbar-function=\"addRow()\" sx-disabled=\"!record.model.id || selected.editing || selected.readOnly\"></six-toolbar-button><six-toolbar-button label=\"{{ \'save\' | translate }}\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\" sx-disabled=\"selected.readOnly\"></six-toolbar-button></six-toolbar><div class=\"override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><uib-tabset justified=\"false\" active=\"tabs.activeTab\" class=\"tab-container\"><uib-tab index=\"tabs.TAB_HEAD\"><uib-tab-heading><span class=\"tab-heading\">{{ \"tab_head\" | translate }}</span></uib-tab-heading><div ng-include=\"\'tnt/goods-inward/detail/goods-inward-tab-head.html\'\"></div></uib-tab><uib-tab index=\"tabs.TAB_ROWS\" disable=\"selected.editing || !record.model.id\"><uib-tab-heading><span class=\"tab-heading\">{{ \"tab_rows\" | translate }}</span></uib-tab-heading><tnt-goods-inward-rows sx-selection=\"selected.row\" sx-goods-inward-id=\"record.model.id\"></tnt-goods-inward-rows></uib-tab><uib-tab index=\"tabs.TAB_ROW_DETAIL\" ng-show=\"selected.editing\"><uib-tab-heading><span class=\"tab-heading\">{{ \"detail\" | translate }}</span></uib-tab-heading><div><tnt-goods-inward-row-detail sx-print-callback=\"printKitLabel(id, isIdKitButPrintEnvelope)\" sx-goods-inward-id=\"record.model.id\" sx-row-id=\"selected.row.id\" sx-show=\"selected.editing\" sx-read-only=\"selected.readOnly\" sx-depot=\"record.model.depot_id\" sx-supplier-id=\"record.lookup.supplier_id.obj.id\" sx-close-callback=\"stopRowEditing()\" ng-if=\"!wardobeMode\"></tnt-goods-inward-row-detail><tnt-goods-inward-row-detail-dispatch sx-print-callback=\"printKitLabel(id)\" sx-goods-inward-id=\"record.model.id\" sx-row-id=\"selected.row.id\" sx-show=\"selected.editing\" sx-supplier-id=\"record.lookup.supplier_id.obj.id\" sx-close-callback=\"stopRowEditing()\" sx-customer-destination-id=\"selected.customerDestination.id\" ng-if=\"wardobeMode\"></tnt-goods-inward-row-detail-dispatch></div></uib-tab></uib-tabset></div></div><div ng-include=\"\'theme/record/std_panel_six.html\'\" class=\"panel panel-default\"></div><six-print-modal sx-title=\"\'Titolo\'\" sx-on-confirm=\"onConfirmPrintLabel(code)\"></six-print-modal></div>");
$templateCache.put("tnt/goods-inward/detail/goods-inward-tab-head.html","<form name=\"goodsInwardForm\"><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.supplier_ddt_number\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" ng-model=\"record.model.dn_number\" sx-disabled=\"readOnly\"></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.supplier_ddt_date\" | translate }}</label><div class=\"col-sm-8\"><six-date-picker ng-model=\"record.model.dn_date\" sx-disabled=\"readOnly\"></six-date-picker></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.reference\" | translate }}</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" ng-model=\"record.model.reference\" sx-disabled=\"readOnly\"></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"supplier\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.supplier_id\" sx-id=\"record.model.supplier_id\" sx-type=\"\'supplier\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-required=\"true\" sx-disabled=\"isSupplier\" sx-filter=\"supplierFilter\" sx-preselect-if-one=\"preselectSupplier\"></six-lookup></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"number\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" ng-model=\"record.model.int_number\" readonly=\"\"></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"status\" | translate }}</label><div class=\"col-sm-8\"><six-enum sx-model=\"record.model\" sx-field=\"status\" sx-options=\"enum.status\" sx-readonly=\"true\" required=\"\"></six-enum></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"date\" | translate }}</label><div class=\"col-sm-8\"><six-date-picker ng-model=\"record.model.int_date\" sx-disabled=\"true\" required=\"\"></six-date-picker></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.inward_date\" | translate }}</label><div class=\"col-sm-8\"><six-date-picker ng-model=\"record.model.rec_date\"></six-date-picker></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"depot\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.depot_id\" sx-id=\"record.model.depot_id\" sx-type=\"\'customer_destination\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"depotFilter\" sx-disabled=\"true\"></six-lookup></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"type\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.type_id\" sx-id=\"record.model.type_id\" sx-type=\"\'goods_inward_type\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-disabled=\"true\"></six-lookup></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"causal\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.inventory_reason_id\" sx-id=\"record.model.inventory_reason_id\" sx-type=\"\'inventory_reason\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"inventoryReasonFilter\" sx-disabled=\"true\"></six-lookup></div></div></div></form>");
$templateCache.put("tnt/goods-inward/direct-delivery/direct-delivery.html","<div class=\"page-title m-t-md\"><h1 class=\"m-n font-thin\">{{ \"goods_inward.package_approval\" | translate }}</h1></div><div class=\"wrapper-md\" ng-cloak=\"\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row row row b-b m-b\"><div class=\"col-md-4 form-group override-form-group\"><label>{{ \"barcode\" | translate }}</label><six-code-reader sx-escape128=\"true\" sx-read-mode=\"COMPONENT_READ_MODE.BARCODE\" sx-on-read=\"readKit(read)\" sx-disabled=\"barcodeReaderIsDisabled\"></six-code-reader></div><div class=\"col-md-4 form-group override-form-group\"><label>&nbsp;</label><div><button class=\"btn btn-default\" ng-disabled=\"confimIsDisabled\" ng-click=\"confirmPack()\"><i class=\"fa fa-check text-success\"></i>&nbsp;{{ \"confirm\" | translate}}</button> &nbsp; <button class=\"btn btn-default\" ng-click=\"refreshList()\"><i class=\"fa fa-refresh\"></i>&nbsp;{{ \"reset\" | translate}}</button></div></div></div><div class=\"row\"><div class=\"col-md-4 form-group override-form-group\"><h4>{{ \"goods_inward.last_read\" | translate }}</h4></div></div><div class=\"row\"><div class=\"col-md-4 form-group override-form-group\"><label>{{ \"goods_inward.package\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"lastPackage.barcode\" ng-readonly=\"true\"></div><div class=\"col-md-4 form-group override-form-group\"><label>{{ \"goods_inward.lot\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"lastPackage.lot\" ng-readonly=\"true\"></div><div class=\"col-md-2 form-group override-form-group\"><label>{{ \"goods_inward.expiration_date\" | translate }}</label><div><input type=\"text\" class=\"form-control\" ng-model=\"lastPackage.date\" ng-readonly=\"true\"></div></div></div><div ng-show=\"package.length > 0\"><div class=\"row\"><div class=\"col-md-8\"><table class=\"table table-striped m-b-none\"><thead><tr><th colspan=\"2\"><h3>{{ \"goods_inward.package_list\" | translate }}</h3></th><th><h3>{{ \"goods_inward.serial_kits\" | translate }}</h3></th></tr></thead><tbody><tr></tr><tr ng-repeat=\"pack in package\"><td class=\"col-md-1\"><button class=\"btn btn-danger\" ng-click=\"removeElement($event)\" value=\"{{ pack.barcode }}\"><i class=\"fa fa-trash\"></i></button></td><td class=\"col-md-5\"><b>{{ pack.barcode }}</b></td><td class=\"col-md-6\"><ul><li ng-repeat=\"sk in pack.sk\">{{sk.barcode}}</li></ul></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("tnt/goods-inward/edit-goods-inward-row-modal/edit-goods-inward-row-modal.html","<style>\n  .uib-datepicker-popup.dropdown-menu {\n    z-index: 10000000;\n  }\n</style><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">{{$ctrl.sxTitle}}</h4></div><div class=\"modal-body\" ng-if=\"!$ctrl.input.can_edit\"><div class=\"alert alert-danger\">{{ \"goods_inward.cannot_edit_row\" | translate }}</div></div><div class=\"modal-body\" ng-if=\"$ctrl.input.can_edit\"><div class=\"row\"><div class=\"col-md-12 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"goods_inward.lot\" | translate }}</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.output.lot_code\"></div></div></div><div class=\"row\"><div class=\"col-md-12 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.production_date\" | translate }}</label><div class=\"col-sm-8\"><six-date-picker ng-model=\"$ctrl.output.production_date\"></six-date-picker></div></div></div><div class=\"row\"><div class=\"col-md-12 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"goods_inward.expiration_date\" | translate }}</label><div class=\"col-sm-8\"><six-date-picker ng-model=\"$ctrl.output.expiration_date\"></six-date-picker></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$close(false)\">{{ \"undo\" | translate }}</button> <button type=\"button\" class=\"btn btn-info\" ng-click=\"$close(true)\" ng-disabled=\"$ctrl.cannotSave()\">{{\"confirm\" | translate }}</button></div></div>");
$templateCache.put("tnt/goods-inward/file-upload/file-upload.html","<six-toolbar><six-toolbar-item label=\"{{\'download_template\' | translate}}\" icon=\"fa fa-file-excel-o text-success\"><li><a ng-click=\"downloadTemplate(\'tnt_goods_inward_template_boxes.xls\')\">{{\'goods_inward.download_template_boxes\' | translate}}</a></li><li><a ng-click=\"downloadTemplate(\'tnt_goods_inward_template_barcodes.xls\')\">{{\'goods_inward.download_template_barcodes\' | translate}}</a></li></six-toolbar-item><six-toolbar-button label=\"{{ \'back\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" toolbar-function=\"goToList()\"></six-toolbar-button></six-toolbar><div class=\"override-padding-toolbar\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"m-n font-thin\">{{ \"goods_inward.upload_file_title\" | translate }}</h1></div></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><tnt-goods-inward-upload sx-depot-code=\"depotCode\" sx-wardrobe-code=\"wardrobeCode\"></tnt-goods-inward-upload></div></div></div>");
$templateCache.put("tnt/goods-inward/goods-inward-row-detail/goods-inward-row-detail.html","<div ng-if=\"$ctrl.sxShow\"><div class=\"row b-b m-b\"><div class=\"col-md-8 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.insertion_mode\" | translate }}</label><div class=\"col-sm-8\"><six-enum sx-model=\"$ctrl.selection\" sx-options=\"$ctrl.enum.insertionMode\" sx-field=\"mode\" sx-closable=\"false\"></six-enum></div></div><div class=\"col-md-4 form-group override-form-group\" ng-if=\"$ctrl.selection.mode===\'BARCODE\' || $ctrl.selection.mode===\'QRCODE\'\"><label class=\"col-sm-4 control-label\" ng-class=\"{\'text-pulsate-danger\': $ctrl.barcode.pulse}\">{{ \"goods_inward.\"+$ctrl.selection.mode | translate }}</label><div class=\"col-sm-8\"><six-code-reader sx-on-read=\"$ctrl.readBarcode(read)\" sx-read-mode=\"$ctrl.readerMode\"></six-code-reader></div></div><div class=\"col-md-12\" ng-if=\"$ctrl.selection.mode===\'BARCODE\' || $ctrl.selection.mode===\'QRCODE\'\"><div class=\"alert alert-warning\" ng-if=\"$ctrl.barcode.pulse && $ctrl.barcode.message\">{{$ctrl.barcode.message}}</div></div></div><div class=\"row\"><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"goods_inward.supplier_product\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"$ctrl.record.lookup.supplier_item_id\" sx-id=\"$ctrl.record.model.supplier_item_id\" sx-type=\"\'product_supplier\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"$ctrl.supplierProductFilter\" sx-disabled=\"$ctrl.sxRowId\"></six-lookup></div></div><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"product\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"$ctrl.record.lookup.item_id\" sx-id=\"$ctrl.record.model.item_id\" sx-type=\"\'product\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-disabled=\"true\"></six-lookup></div></div><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.lot\" | translate }}</label><div class=\"col-sm-8\"><input type=\"text\" ng-disabled=\"disableLotAndDate\" class=\"form-control\" ng-model=\"$ctrl.record.model.lot_code\" ng-readonly=\"$ctrl.sxRowId\"></div></div></div><div class=\"row\"><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.production_date\" | translate }}</label><div class=\"col-sm-8\"><six-date-picker ng-model=\"$ctrl.skData.production_date\" sx-disabled=\"$ctrl.selection.isExistingRow\"></six-date-picker></div></div><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.expiration_date\" | translate }}</label><div class=\"col-sm-8\"><six-date-picker ng-model=\"$ctrl.record.model.expiration_date\" sx-disabled=\"$ctrl.selection.isExistingRow || disableLotAndDate\"></six-date-picker></div></div><div class=\"col-md-4 form-group override-form-group\"><div class=\"col-sm-offset-4 col-sm-8\" ng-if=\"$ctrl.lotCodeNotFound\"><button class=\"btn btn-default\" ng-click=\"$ctrl.createNewLot()\">{{ \"goods_inward.create_new_lot\" | translate }}</button></div></div></div><div class=\"row\"><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.quantity_included\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.record.lookup.item_id.obj.quantity_included\" readonly=\"\"></div></div><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"goods_inward.serial_kits\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" step=\"1\" min=\"1\" class=\"form-control\" ng-model=\"$ctrl.skData.boxes\" ng-readonly=\"($ctrl.selection.mode!==\'MULTIPLE\' && $ctrl.selection.mode!==\'CREAZIONE_KIT\') || $ctrl.selection.isExistingRow\"></div></div><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.total_amount\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.record.model.stock_amount\" ng-readonly=\"true\"></div></div></div><div class=\"row\" ng-if=\"$ctrl.selection.isExistingRow && $ctrl.selection.mode===\'MULTIPLE\'\"><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.qty_add\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.skData.amount\" ng-readonly=\"true\"></div></div><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"goods_inward.boxes_add\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" step=\"1\" min=\"1\" class=\"form-control\" ng-model=\"$ctrl.skData.boxes\" ng-readonly=\"($ctrl.selection.mode!==\'MULTIPLE\')\"></div></div></div><div class=\"wrapper\"><button class=\"pull-right btn btn-sm btn-info m-t-n-xs m-l\" ng-click=\"$ctrl.saveRow()\" ng-if=\"$ctrl.selection.mode===\'BARCODE\'\" ng-disabled=\"$ctrl.sxReadOnly || !$ctrl.canAddKit()\">{{ \"goods_inward.add_box\" | translate }}</button> <button class=\"pull-right btn btn-sm btn-info m-t-n-xs m-l\" ng-click=\"$ctrl.saveRow()\" ng-if=\"$ctrl.selection.mode===\'MULTIPLE\'\" ng-disabled=\"$ctrl.sxReadOnly || !$ctrl.canAddKit()\">{{ \"goods_inward.add\" | translate }} {{ \"goods_inward.serial_kits\" | translate }} ({{$ctrl.skData.boxes}})</button> <button class=\"pull-right btn btn-sm btn-info m-t-n-xs m-l\" ng-click=\"$ctrl.createKits()\" ng-if=\"$ctrl.selection.mode===\'CREAZIONE_KIT\'\" ng-disabled=\"$ctrl.sxReadOnly || !$ctrl.canAddKit() || $ctrl.selection.isExistingRow\">Crea {{$ctrl.skData.amount}} kit</button><button class=\"pull-right btn btn-sm btn-default m-t-n-xs\" ng-click=\"$ctrl.close()\">{{ \"close\" | translate }}</button><div class=\"h4\">{{ \"detail\" | translate }}</div></div><div class=\"row\"><div class=\"col-md-12\"><six-grid-pagination get-data-callback=\"$ctrl.getData()\" get-list-callback=\"$ctrl.getData()\" items-list=\"$ctrl.result\" column-defs=\"$ctrl.viewGridOptions.columnDefs\" grid-options=\"$ctrl.viewGridOptions\" params=\"$ctrl.params\"></six-grid-pagination></div></div></div><edit-goods-inward-row-modal sx-title=\"\'Modifica\'\" sx-on-confirm=\"editRow()\" sx-msg=\"$ctrl.msgMerge\"></edit-goods-inward-row-modal>");
$templateCache.put("tnt/goods-inward/goods-inward-row-detail-dispatch/goods-inward-row-detail-dispatch.html","<div ng-if=\"$ctrl.sxShow\"><div class=\"row b-b m-b\"><div class=\"col-md-8 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.insertion_mode\" | translate }}</label><div class=\"col-sm-8\"><six-enum sx-model=\"$ctrl.selection\" sx-options=\"$ctrl.enum.insertionMode\" sx-field=\"mode\" sx-closable=\"false\"></six-enum></div></div><div class=\"col-md-4 form-group override-form-group\" ng-if=\"$ctrl.selection.mode===\'BARCODE\'\"><label class=\"col-sm-4 control-label\" ng-class=\"{\'text-pulsate-danger\': $ctrl.barcode.pulse}\">{{ \"barcode\" | translate }}</label><div class=\"col-sm-8\"><six-code-reader sx-on-read=\"$ctrl.readBarcode(read)\" sx-read-mode=\"$ctrl.readerMode\"></six-code-reader></div></div><div class=\"col-md-12\" ng-if=\"$ctrl.selection.mode===\'BARCODE\'\"><div class=\"alert alert-warning\" ng-if=\"$ctrl.barcode.pulse\">{{$ctrl.barcode.message}}</div></div></div><div class=\"row\"><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"goods_inward.supplier_product\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"$ctrl.record.lookup.supplier_item_id\" sx-id=\"$ctrl.record.model.supplier_item_id\" sx-type=\"\'product_supplier\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"$ctrl.supplierProductFilter\" sx-disabled=\"$ctrl.sxRowId\"></six-lookup></div></div><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"product\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"$ctrl.record.lookup.item_id\" sx-id=\"$ctrl.record.model.item_id\" sx-type=\"\'product\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-disabled=\"true\"></six-lookup></div></div><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"goods_inward.lot\" | translate }}</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.record.model.lot_code\" ng-readonly=\"$ctrl.sxRowId\"></div></div></div><div class=\"row\"><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.production_date\" | translate }}</label><div class=\"col-sm-8\"><six-date-picker ng-model=\"$ctrl.skData.production_date\" sx-disabled=\"$ctrl.selection.isExistingRow\"></six-date-picker></div></div><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"goods_inward.expiration_date\" | translate }}</label><div class=\"col-sm-8\"><six-date-picker ng-model=\"$ctrl.record.model.expiration_date\" sx-disabled=\"$ctrl.selection.isExistingRow\"></six-date-picker></div></div><div class=\"col-md-4 form-group override-form-group\"><div class=\"col-sm-offset-4 col-sm-8\" ng-if=\"$ctrl.lotCodeNotFound\"><button class=\"btn btn-default\" ng-click=\"$ctrl.createNewLot()\">{{ \"goods_inward.create_new_lot\" | translate }}</button></div></div></div><div class=\"row\" ng-if=\"!$ctrl.selection.isExistingRow\"><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"qty\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.record.model.stock_amount\" ng-readonly=\"true\"></div></div><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"goods_inward.boxes\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" step=\"1\" min=\"1\" class=\"form-control\" ng-model=\"$ctrl.skData.boxes\" ng-readonly=\"$ctrl.selection.mode!==\'MULTIPLE\' || $ctrl.selection.isExistingRow\"></div></div><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.quantity_included\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.record.lookup.item_id.obj.quantity_included\" readonly=\"\"></div></div></div><div class=\"row\" ng-if=\"$ctrl.selection.isExistingRow\"><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.qty_prev\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.record.model.stock_amount\" ng-readonly=\"true\"></div></div><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.boxes_prev\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" step=\"1\" min=\"1\" class=\"form-control\" ng-model=\"$ctrl.skData.boxes_prev\" ng-readonly=\"true\"></div></div><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.quantity_included\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.record.lookup.item_id.obj.quantity_included\" readonly=\"\"></div></div></div><div class=\"row\" ng-if=\"$ctrl.selection.isExistingRow && $ctrl.selection.mode===\'MULTIPLE\'\"><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"goods_inward.qty_add\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.skData.amount\" ng-readonly=\"true\"></div></div><div class=\"col-md-4 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"goods_inward.boxes_add\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" step=\"1\" min=\"1\" class=\"form-control\" ng-model=\"$ctrl.skData.boxes\" ng-readonly=\"($ctrl.selection.mode!==\'MULTIPLE\')\"></div></div></div><div class=\"row b-b\"></div><div class=\"wrapper m-b-md\"><button class=\"pull-right btn btn-sm btn-info m-t-n-xs m-l\" ng-click=\"$ctrl.saveRow()\" ng-if=\"$ctrl.selection.mode!==\'MULTIPLE\'\" ng-disabled=\"!$ctrl.canAddKit()\">{{ \"goods_inward.add_box\" | translate }}</button> <button class=\"pull-right btn btn-sm btn-info m-t-n-xs m-l\" ng-click=\"$ctrl.saveRow()\" ng-if=\"$ctrl.selection.mode===\'MULTIPLE\'\" ng-disabled=\"(!$ctrl.selection.amountToGenerate>0)\">Aggiungi {{$ctrl.skData.boxes}} colli</button> <button class=\"pull-right btn btn-sm btn-default m-t-n-xs\" ng-click=\"$ctrl.close()\">{{ \"close\" | translate }}</button></div><div class=\"row\"><div class=\"panel panel-default\" ng-if=\"$ctrl.dispatchedOrders.length > 0\"><div class=\"panel-heading\">{{ \"goods_inward.dispatched_orders\" | translate}}</div><div ng-hide=\"$ctrl.dispatchedOrders.length > 0\" class=\"alert alert-info\">{{ \"goods_inward.no_element_found\" | translate}}</div><div class=\"table-responsive\" ng-show=\"$ctrl.dispatchedOrders.length > 0\"><table class=\"table table-striped b-t b-light\"><thead><tr><th>{{ \"customer_order\" | translate}}</th><th>{{ \"item\" | translate}}</th><th>{{ \"date\" | translate}}</th><th>{{ \"qty\" | translate}}</th><th>{{ \"goods_inward.qty_dispatched\" | translate}}</th><th>{{ \"goods_inward.qty_boxes\" | translate}}</th><th>{{ \"goods_inward.qty_dispatched_boxes\" | translate}}</th></tr></thead><tbody><tr ng-repeat=\"row in $ctrl.dispatchedOrders\"><td>{{row.customer_order_number}}</td><td><span class=\"text-ellipsis\">{{row.item_id}}</span></td><td><span class=\"text-ellipsis\">{{row.delivery_date | date:\'dd/MM/yyyy\'}}</span></td><td><span class=\"text-ellipsis\">{{row.stock_amount}}</span></td><td><span class=\"text-ellipsis\">{{row.generated_amount}}</span></td><td><span class=\"text-ellipsis\">{{row.stock_boxes}}</span></td><td><span class=\"text-ellipsis\">{{row.generated_boxes}}</span></td></tr></tbody><tfoot></tfoot></table></div></div></div><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-heading\">{{ \"goods_inward.orders_to_dispath\" | translate}}</div><div ng-hide=\"$ctrl.selection.customerOrderRows.length>0\" class=\"alert alert-info\">{{ \"goods_inward.no_element_found\" | translate}}</div><div class=\"table-responsive\" ng-show=\"$ctrl.selection.customerOrderRows.length>0\"><table class=\"table table-striped b-t b-light\"><thead><tr><th>{{ \"customer_order\" | translate}}</th><th>{{ \"date\" | translate}}</th><th>{{ \"qty\" | translate}}</th><th>{{ \"goods_inward.qty_dispatched\" | translate}}</th><th>{{ \"goods_inward.qty_boxes\" | translate}}</th><th>{{ \"goods_inward.qty_dispatched_boxes\" | translate}}</th></tr></thead><tbody><tr ng-repeat=\"row in $ctrl.selection.customerOrderRows\"><td>{{row.co_number}}</td><td><span class=\"text-ellipsis\">{{row.delivery_date | date:\'dd/MM/yyyy\'}}</span></td><td><span class=\"text-ellipsis\">{{row.stock_amount}}</span></td><td><span class=\"text-ellipsis\">{{row.generated_amount}}</span></td><td><span class=\"text-ellipsis\">{{row.stock_boxes}}</span></td><td><span class=\"text-ellipsis\">{{row.generated_boxes}}</span></td></tr></tbody><tfoot><tr><th colspan=\"7\">{{ \"goods_inward.total_dispatch_qty\" | translate}} {{$ctrl.selection.amountToGenerate}} <span ng-if=\"$ctrl.selection.boxesToGenerate\">{{$ctrl.selection.boxesToGenerateMsg}}</span></th></tr></tfoot></table></div></div></div><div class=\"row\"><div class=\"panel-heading\">{{ \"goods_inward.boxes_detail\" | translate }}</div><six-grid-pagination get-data-callback=\"$ctrl.getData()\" get-list-callback=\"$ctrl.getData()\" items-list=\"$ctrl.result\" column-defs=\"$ctrl.viewGridOptions.columnDefs\" grid-options=\"$ctrl.viewGridOptions\" params=\"$ctrl.params\"></six-grid-pagination></div></div>");
$templateCache.put("tnt/goods-inward/goods-inward-rows/goods-inward-rows.html","<div ng-if=\"$ctrl.sxShow\"><div class=\"row\"><div class=\"col-md-12\"><six-grid-pagination get-data-callback=\"$ctrl.getData()\" get-list-callback=\"$ctrl.getData()\" items-list=\"$ctrl.result\" column-defs=\"$ctrl.viewGridOptions.columnDefs\" grid-options=\"$ctrl.viewGridOptions\" params=\"$ctrl.params\"></six-grid-pagination></div></div></div>");
$templateCache.put("tnt/goods-inward/goods-inward-upload/goods-inward-upload.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"row m-b\"><div class=\"lter b-b wrapper\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\"><i class=\"fa fa-circle-o m-r text-muted\"></i> {{ \"goods_inward.step_1\" | translate }}</h1></div></div></div></div><div class=\"row\"><div class=\"col-md-3\"><six-enum sx-model=\"$ctrl.upload\" sx-field=\"fileMode\" sx-options=\"$ctrl.enum.fileMode\"></six-enum></div><div class=\"col-md-3\"><input type=\"file\" accept=\".xls,.xlsx\" ng-model=\"$ctrl.selectedFile\" xlsxreader=\"\" multiple=\"false\" name=\"file\" id=\"file\" class=\"inputfile\" ng-show=\"false\"> <label for=\"file\">{{ \"select_file\" | translate }}</label></div><div class=\"col-md-6\" style=\"font-size: 21px;\" ng-if=\"$ctrl.upload.fileName\"><span class=\"fa-stack\"><i class=\"fa fa-circle fa-stack-2x\" ng-class=\"{ \'text-success\': $ctrl.upload.validated, \'text-danger\': (!$ctrl.upload.loading && !$ctrl.upload.validated), \'text-muted\': $ctrl.upload.loading }\"></i> <i class=\"fa fa-file-o fa-stack-1x text-white\"></i></span> {{$ctrl.upload.fileName}}</div></div><div class=\"row m-b m-t\"><div class=\"lter b-b wrapper\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\"><i class=\"fa fa-circle-o m-r text-muted\"></i> {{ \"goods_inward.step_2\" | translate }}</h1></div></div></div></div><div class=\"row\" ng-if=\"$ctrl.upload.loading\"><div class=\"col-md-1 text-center\"><i class=\"fa fa-spinner fa-2x fa-pulse text-muted\"></i></div></div><div class=\"row\" ng-repeat=\"error in $ctrl.upload.errors\"><div class=\"col-md-12\"><i class=\"fa {{error.icon}} m-r\"></i> {{error.description}}</div></div><div class=\"row m-b m-t\" ng-if=\"$ctrl.upload.validated\"><div class=\"col-md-12\"><div class=\"alert alert-info\"><i class=\"fa fa-check m-l-md\"></i> {{$ctrl.upload.validationMessage}}</div></div></div><div class=\"row m-t m-b\" ng-if=\"$ctrl.upload.warnings.length > 0\"><div class=\"col-md-12\"><div class=\"row\" ng-repeat=\"warning in $ctrl.upload.warnings\"><div class=\"col-md-12\"><i class=\"fa {{warning.icon}} m-r text-warning\"></i> {{warning.description}}</div></div></div></div><div class=\"row m-t m-b\" ng-if=\"$ctrl.upload.validated && $ctrl.chooseDest && $ctrl.dispatchOrders\"><div class=\"col-md-12\"><label class=\"alert alert-warning\">Compilare i campi \"Destinazione di spedizione\" (OBBLIGATORIO) e \"Ordine cliente\" e \"Data ordine cliente\" (OPZIONALI)</label></div></div><div class=\"row m-t m-b\" ng-if=\"$ctrl.upload.validated && $ctrl.chooseDest && $ctrl.dispatchOrders\" ng-repeat=\"data in $ctrl.upload.rowsData\"><div class=\"col-md-12\"><label class=\"alert alert-info\"><b>Rif. ordine:</b> {{ data.header.reference }} - <b>DDT:</b> {{ data.header.supplierDDTNumber }} ({{ data.header.row_count }} {{ data.header.row_count>1?\'righe\':\'riga\' }})</label></div><div class=\"col-md-4 col-lg-4\"><label class=\"control-label\">{{ \"goods_inward.shipment_destination\" | translate }}</label><six-lookup ng-init=\"lookup=$eval($ctrl.destinationLookups[data.header.reference])\" ng-model=\"lookup\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'customer_destination\'\" sx-id=\"$ctrl.shipmentDestinations[data.header.reference]\" sx-filter=\"$ctrl.destinationFilter\" sx-relational=\"true\" sx-placeholder=\"Seleziona una destinazione...\"></six-lookup></div><div class=\"col-md-4 col-lg-4\" style=\"padding-top: 25px;\"><input type=\"text\" style=\"width: 100%;\" class=\"form-control\" placeholder=\"{{\'goods_inward.supplier_order\' | translate }}\" ng-model=\"$ctrl.supplierOrders[data.header.reference]\" maxlength=\"20\"></div><div class=\"col-md-4 col-lg-4\" style=\"padding-top: 25px;\"><six-date-picker ng-model=\"$ctrl.supplierDates[data.header.reference]\" placeholder=\"{{\'goods_inward.supplier_order_date\' | translate }}\"></six-date-picker></div></div><div class=\"row m-b m-t\"><div class=\"lter b-b wrapper\"><div class=\"row\"><button class=\"btn btn-primary m-r-md\" style=\"float: right\" ng-click=\"$ctrl.printKitLabel()\" ng-show=\"$ctrl.viewGridKits.data.length>0\">{{ \"print\" | translate }}</button> <span class=\"col-md-6\"><h1 class=\"m-n font-thin h3 text-black\"><i class=\"fa fa-circle-o m-r text-muted\"></i> {{ \"goods_inward.step_3\" | translate }}</h1></span></div></div></div><div class=\"row\" ng-show=\"$ctrl.viewGridKits.data.length==0\"><div class=\"col-md-12\"><button class=\"btn btn-primary\" ng-show=\"$ctrl.upload.validated\" ng-click=\"$ctrl.confirmUpload()\">{{ \"confirm\" | translate }}</button></div></div><div class=\"row\" ng-show=\"$ctrl.viewGridKits.data.length>0\"><div class=\"col-md-12\"><div class=\"alert alert-warning\">{{ \"goods_inward.duplicated_barcodes_warning\" | translate }}</div></div></div><div class=\"row\" ng-if=\"$ctrl.viewGridKits.data.length>0\"><div class=\"col-md-12\"><div ui-grid=\"$ctrl.viewGridKits\" class=\"grid\" style=\"height: 420px\" ui-grid-resize-columns=\"\"></div></div></div></div><div class=\"row\"><div class=\"panel panel-default\" ng-if=\"$ctrl.dispatchedOrders.length > 0\"><div class=\"panel-heading\">{{ \"goods_inward.dispatched_orders\" | translate}}</div><div ng-hide=\"$ctrl.dispatchedOrders.length > 0\" class=\"alert alert-info\">{{ \"goods_inward.no_element_found\" | translate}}</div><div class=\"table-responsive\" ng-show=\"$ctrl.dispatchedOrders.length > 0\"><table class=\"table table-striped b-t b-light\"><thead><tr><th>{{ \"customer_order\" | translate}}</th><th>{{ \"item\" | translate}}</th><th>{{ \"date\" | translate}}</th><th>{{ \"qty\" | translate}}</th><th>{{ \"goods_inward.qty_dispatched\" | translate}}</th><th>{{ \"goods_inward.qty_boxes\" | translate}}</th><th>{{ \"goods_inward.qty_dispatched_boxes\" | translate}}</th></tr></thead><tbody><tr ng-repeat=\"row in $ctrl.dispatchedOrders\"><td>{{row.customer_order_number}}</td><td><span class=\"text-ellipsis\">{{row.item_id}}</span></td><td><span class=\"text-ellipsis\">{{row.delivery_date | date:\'dd/MM/yyyy\'}}</span></td><td><span class=\"text-ellipsis\">{{row.stock_amount}}</span></td><td><span class=\"text-ellipsis\">{{row.generated_amount}}</span></td><td><span class=\"text-ellipsis\">{{row.stock_boxes}}</span></td><td><span class=\"text-ellipsis\">{{row.generated_boxes}}</span></td></tr></tbody><tfoot></tfoot></table></div></div></div><div class=\"row\"><div class=\"row\" ng-if=\"$ctrl.viewGridAvailOrders.data.length>0\"><div class=\"col-md-12\"><div ui-grid=\"$ctrl.viewGridAvailOrders\" class=\"grid\" style=\"height: 420px\" ui-grid-resize-columns=\"\"></div></div></div><six-confirm-modal sx-title=\"$ctrl.modal.title\" sx-message=\"$ctrl.modal.message\" sx-on-confirm=\"$ctrl.modal.callback\"></six-confirm-modal><six-print-modal sx-title=\"\'Stampa\'\" sx-on-confirm=\"$ctrl.onConfirmPrintLabel(code)\"></six-print-modal></div></div>");
$templateCache.put("tnt/goods-inward/kit-envelope-association/kit-envelope-association.html","<div class=\"page-title m-t-md\"><h1 class=\"m-n font-thin\">{{ \"goods_inward.kit_envelope_binding\" | translate }}</h1></div><div class=\"wrapper-md\" ng-cloak=\"\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-4 form-group override-form-group\"><label>{{ \"barcode\" | translate }}</label><six-code-reader sx-escape128=\"true\" sx-read-mode=\"COMPONENT_READ_MODE.BARCODE\" sx-on-read=\"readKit(read)\" sx-disabled=\"codeReaderIsDisabled\"></six-code-reader></div><div class=\"col-md-4 form-group override-form-group\"><label>&nbsp;</label><div><button class=\"btn btn-default\" ng-disabled=\"confimIsDisabled\" ng-click=\"confirmPack()\"><i class=\"fa fa-check text-success\"></i>&nbsp;{{ \"confirm\" | translate}}</button> &nbsp; <button class=\"btn btn-default\" ng-click=\"refreshList()\"><i class=\"fa fa-refresh\"></i>&nbsp;{{ \"reset\" | translate}}</button></div></div></div><div class=\"row\"><div class=\"col-md-4 form-group override-form-group\"><div class=\"alert alert-info\" role=\"alert\" ng-show=\"!product.id\">{{ \"goods_inward.read_package_barcode\" | translate }}</div><div class=\"alert alert-info\" role=\"alert\" ng-show=\"product.id && !packageFull\">{{ \"goods_inward.read_sequence\" | translate }}</div><div class=\"alert alert-success\" role=\"alert\" ng-show=\"product.id && packageFull\">{{ \"goods_inward.package_completed\" | translate }}</div></div></div><div class=\"row\"><div class=\"col-md-4 form-group override-form-group\"><label>{{ \"goods_inward.package\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"package.barcode\" ng-readonly=\"true\"></div><div class=\"col-md-4 form-group override-form-group\"><label>{{ \"goods_inward.lot\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"package.lot\" ng-readonly=\"true\"></div><div class=\"col-md-2 form-group override-form-group\"><label>{{ \"goods_inward.expiration_date\" | translate }}</label><div><input type=\"text\" class=\"form-control\" ng-model=\"package.date\" ng-readonly=\"true\"></div></div></div><div ng-show=\"product.id\"><div class=\"row row b-b m-b\"><div class=\"col-md-4 form-group override-form-group\"><label>{{ \"product\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"product.description\" ng-readonly=\"true\"></div><div class=\"col-md-2 form-group override-form-group\"><label>{{ \"goods_inward.quantity_included\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"product.quantityIncluded\" ng-readonly=\"true\"></div><div class=\"col-md-2 form-group override-form-group\"><label>{{ \"goods_inward.package_quantity\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"product.packageQuantity\" ng-readonly=\"true\"></div></div><div class=\"row\"><div class=\"col-md-4\"><table class=\"table table-striped m-b-none\"><thead><tr><th colspan=\"2\"><h3>{{ \"goods_inward.serial_kit_list\" | translate }}</h3></th></tr></thead><tbody><tr></tr><tr ng-repeat=\"x in serialKit\"><td class=\"col-md-1\"><button class=\"btn btn-danger\" ng-click=\"removeElement($event)\" value=\"{{ x.id }}\"><i class=\"fa fa-trash\"></i></button></td><td class=\"col-md-11\"><b>{{ x.barcode }}<b></b></b></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("tnt/goods-inward/list/goods-inward-list.html","<six-toolbar title=\"functionTitle\"><six-toolbar-button icon=\"fa fa-upload\" label=\"{{\'upload_file\' | translate}}\" btn-class=\"btn-warning\" ng-if=\"isNewAllowed\" toolbar-function=\"goFileUpload()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-plus\" label=\"{{\'new\' | translate}}\" btn-class=\"btn-info\" ng-if=\"isNewAllowed\" toolbar-function=\"goToNew()\"></six-toolbar-button></six-toolbar><div class=\"wrapper-md m-t-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3\"><label class=\"control-label\">{{ \"supplier\" | translate }}</label><six-lookup ng-model=\"lookup.supplier_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-preselect-if-one=\"preselectSupplier\" sx-id=\"advFilter.filter.supplier_id\" sx-type=\"\'supplier\'\" sx-filter=\"supplierFilters\" sx-relational=\"true\" sx-disabled=\"isSupplier\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\">{{ \"status\" | translate }}</label><six-enum sx-model=\"advFilter.filter\" sx-field=\"status\" sx-options=\"enum.status\" sx-readonly=\"readOnly\"></six-enum></div><div class=\"col-md-3\"><label>{{ \"goods_inward.supplier_ddt_number\" | translate }}</label> <input type=\"number\" class=\"form-control\" ng-model=\"advFilter.filter.dn_number\"></div><div class=\"col-md-3\"><label>{{ \"goods_inward.reference\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"advFilter.filter.reference\"></div><div class=\"col-md-3\"><label>{{ \"goods_inward.supplier_ddt_date_from\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.dn_date_from\"></six-date-picker></div><div class=\"col-md-3\"><label>{{ \"goods_inward.supplier_ddt_date_to\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.dn_date_to\"></six-date-picker></div><div class=\"col-md-3\"><label>{{ \"Barcode\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"advFilter.filter.barcode\"></div></div></div></div><div class=\"panel panel-default\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"result\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div>");
$templateCache.put("tnt/inventory/finalize/finalize-inventory.html","<six-toolbar title=\"functionTitle\"></six-toolbar><div class=\"wrapper-md m-t-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\" style=\"padding-bottom: 20px;\"><div class=\"col-md-5\"><label class=\"control-label\">{{ \"destination\" | translate }}</label><six-lookup ng-model=\"lookup.destination_id\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-preselect-if-one=\"false\" sx-id=\"advFilter.filter.destination_id\" sx-type=\"\'customer_destination\'\" sx-filter=\"destinationFilter\" sx-relational=\"true\" sx-placeholder=\"Seleziona una destinazione...\"></six-lookup></div><div class=\"col-md-3\"><label>{{ \"Barcode\" | translate }}</label> <input type=\"text\" class=\"form-control\" ng-model=\"advFilter.filter.barcode\"></div></div><div class=\"row\"><div class=\"col-md-4\"><label class=\"control-label\">{{ \"status\" | translate }}</label><six-enum sx-model=\"advFilter.filter\" sx-field=\"status\" sx-options=\"enum.status\" sx-readonly=\"false\"></six-enum></div><div class=\"col-md-4\"><label>{{ \"inventory.inv_date_from\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.inv_date_from\"></six-date-picker></div><div class=\"col-md-4\"><label>{{ \"inventory.inv_date_to\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.inv_date_to\"></six-date-picker></div></div></div></div><div ng-show=\"lookup.destination_id.obj\"><div class=\"row\" align=\"center\"><button class=\"btn btn-danger m-xs\" ng-disabled=\"!deleteEnabled\" ng-click=\"deleteSelected()\"><i class=\"fa fa-trash\"></i> {{ \"inventory.delete_inventory\" | translate}}</button> <button class=\"btn btn-default m-xs\" ng-click=\"finalizeSelected()\"><i class=\"fa fa-shopping-cart\"></i> {{ \"inventory.do_finalize\" | translate}}</button></div><div style=\"padding-top: 50px;\"><div class=\"col-lg-{{selectedRow? 5 : 12}}\"><six-grid-pagination get-data-callback=\"getListData()\" get-list-callback=\"getListData()\" items-list=\"result\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div><div class=\"col-lg-7\" ng-show=\"selectedRow\"><six-grid-pagination get-data-callback=\"getDetailData(selectedRow)\" grid-options=\"detailGridOptions\" lazy-init=\"true\"></six-grid-pagination></div></div></div><script type=\"text/ng-template\" id=\"finalizeConfirm.html\"><style> .modal-sm { width: 300px; } </style> <div class=\"modal-header\"> <h3 class=\"modal-title\">{{\'inventory.FINALIZE_INVENTORY_MODAL_TITLE\' | translate}}</h3> </div> <div class=\"modal-body\"> <div class=\"list-group no-radius alt no-margin\"> <a class=\"list-group-item\" href=\"\"> <span class=\"badge bg-success\">{{recap.read}}</span> <i class=\"fa fa-eye fa-fw text-muted\"></i> {{\'inventory.BOXES_READ\' | translate}} </a> <a class=\"list-group-item\" href=\"\"> <span class=\"badge bg-danger\">{{recap.missing}}</span> <i class=\"fa fa-eye-slash fa-fw text-muted\"></i> {{\'inventory.BOXES_MISSING\' | translate}} </a> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">{{\'confirm\' | translate}}</button> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">{{\'undo\' | translate}}</button> </div></script><script type=\"text/ng-template\" id=\"confirmDelete.html\"><style> .modal-sm { width: 500px; } </style> <div class=\"modal-body\"> <div class=\"list-group no-radius alt no-margin\"> <h4 class=\"modal-title\">{{\'inventory.confirm_delete\' | translate}}</h4> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">{{\'confirm\' | translate}}</button> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">{{\'undo\' | translate}}</button> </div></script></div>");
$templateCache.put("tnt/reorder/endowments/admin-edit-cell.tmpl.html","<div><form name=\"inputForm\"><input type=\"number\" ng-class=\"\'colt\' + col.uid\" ui-grid-editor=\"\" ng-model=\"MODEL_COL_FIELD\" min=\"{{row.entity.min_packages || 0}}\" uib-tooltip=\"{{grid.appScope.getTooltipMessage(row.entity) | translate:row.entity}}\" tooltip-placement=\"top\" tooltip-trigger=\"none\" tooltip-append-to-body=\"true\" tooltip-class=\"grid-tooltip-err\" tooltip-is-open=\"inputForm.$invalid || MODEL_COL_FIELD &gt; row.entity.max_packages\"></form></div>");
$templateCache.put("tnt/reorder/endowments/edit-cell.tmpl.html","<div><form name=\"inputForm\"><input type=\"number\" ng-class=\"\'colt\' + col.uid\" ui-grid-editor=\"\" ng-model=\"MODEL_COL_FIELD\" min=\"{{row.entity.min_packages || 0}}\" max=\"{{row.entity.max_packages}}\" uib-tooltip=\"{{grid.appScope.getTooltipMessage(row.entity) | translate:row.entity}}\" tooltip-placement=\"top\" tooltip-trigger=\"none\" tooltip-append-to-body=\"true\" tooltip-class=\"grid-tooltip-err\" tooltip-is-open=\"inputForm.$invalid || row.entity.max_packages == 0\"></form></div>");
$templateCache.put("tnt/reorder/endowments/reorder-cell.tmpl.html","<div class=\"ui-grid-cell-contents\" title=\"TOOLTIP\">{{COL_FIELD CUSTOM_FILTERS}} <b>{{grid.appScope.getReorderInfo(row.entity)}}</b></div>");
$templateCache.put("tnt/reorder/endowments/reorder-endowments.html","<style>\n    .editable-cell {\n        background-color: #3ca2d736 !important;\n        color: #354554 !important;\n        font-weight: 600;\n    }\n    .editable-cell div:last-child {\n        height: 100%;\n    }\n    .editable-cell form,\n    .editable-cell input {\n        height: 100% !important;\n    }\n    .over-budget {\n        color: brown;\n    }\n\n    /* Specify styling for tooltip contents */\n    .tooltip.grid-tooltip-err .tooltip-inner {\n        color: #880000;\n        background-color: #ffff66;\n        box-shadow: 0 6px 12px rgba(0,0,0,.175);\n    }\n    /* Hide arrow */\n    .tooltip.grid-tooltip-err .tooltip-arrow {\n        display: none;\n    }\n</style><div class=\"panel panel-default m-t-md\"><div class=\"panel-body\"><div class=\"row m-t-xs\"><form name=\"orderForm\" class=\"form-inline form-validation\"><div class=\"form-group col-lg-4\"><input type=\"text\" style=\"width: 100%;\" class=\"form-control\" placeholder=\"{{\'reorder.supplier_order\' | translate}}\" ng-model=\"customerOrder.supplierOrder\" maxlength=\"20\"></div><div class=\"form-group col-lg-2\"><six-date-picker ng-model=\"customerOrder.supplierOrderDate\" placeholder=\"{{\'reorder.supplier_order_date\' | translate }}\"></six-date-picker></div><div class=\"checkbox m-l m-r-xs\"><label class=\"i-checks\"><input type=\"checkbox\" ng-model=\"customerOrder.priority\" ng-true-value=\"\'HIGH\'\" ng-false-value=\"\'NORMAL\'\"> <i></i> {{\'reorder.urgent\' | translate}}</label></div></form></div><div class=\"row m-t-xs\"><form name=\"orderForm\" class=\"form-inline form-validation\"><div class=\"form-group col-lg-4\"><input type=\"text\" style=\"width: 100%;\" class=\"form-control\" placeholder=\"{{\'reorder.order_reference\' | translate}}\" ng-model=\"customerOrder.orderReference\" maxlength=\"20\"></div><div class=\"form-group col-lg-2\"><six-date-picker ng-model=\"customerOrder.orderReferenceDate\" placeholder=\"{{\'reorder.order_reference_date\' | translate }}\"></six-date-picker></div><div class=\"form-group col-lg-4\"><textarea class=\"form-control\" style=\"width: 100%;\" placeholder=\"{{\'reorder.order_note\' | translate}}\" ng-model=\"customerOrder.orderNote\" maxlength=\"50\"></textarea></div></form></div><div class=\"row m-t-xs\"><div class=\"col-lg-6\"><strong>{{\'type\' | translate}}</strong> {{orderType.description}}</div><div class=\"col-lg-3\"><strong>{{\'bar\' | translate}}</strong> {{orderType.ddt_slash}}</div><div class=\"col-lg-6\"><strong>{{\'customer\' | translate}}</strong> {{customerOrder.customer.description}}</div></div></div></div><div class=\"row\"><div class=\"col-lg-12 text-center\"><button class=\"btn btn-default m-xs\" ng-disabled=\"isOrderCreationDisabled() || orderForm.$invalid\" ng-click=\"onSaveOrder()\"><i class=\"fa fa-check text-success\"></i> {{\'reorder.create_order\' | translate}}</button></div></div><div class=\"panel panel-default\" ng-if=\"endowment.items.length > 0\"><div class=\"panel-body\"><div>{{\'reorder.all_are_pieces\' | translate}}</div><div class=\"row\"><div class=\"col-lg-12\"><div ng-style=\"{ \'height\': params.gridApi.grid.gridHeight }\" class=\"grid\" ui-grid=\"gridOptions\" ui-grid-multiple=\"\" ui-grid-resize-columns=\"\" ui-grid-edit=\"\" ui-grid-pagination=\"\" ui-grid-auto-resize=\"\" ui-grid-exporter=\"\"></div></div></div></div></div>");
$templateCache.put("tnt/reorder/endowments/row.tmpl.html","<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + \'-\' + col.uid + \'-cell\'\" class=\"ui-grid-cell\" ng-class=\"{ \'ui-grid-row-header-cell\': col.isRowHeader, \'over-budget\': (row.entity.isOverBudget || row.entity.max_packages == 0) }\" role=\"{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}\" ui-grid-cell=\"\"></div>");
$templateCache.put("tnt/reorder/plant/reorder-plant.html","<six-toolbar><six-toolbar-button label=\"{{ \'clear\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-eraser\" toolbar-function=\"clearAmount()\"></six-toolbar-button><six-toolbar-button label=\"{{ \'reload\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-undo\" toolbar-function=\"computeAmount()\"></six-toolbar-button></six-toolbar><div class=\"page-title override-padding-toolbar m-b-n\" ng-if=\"routeFilter\"><h1 class=\"m-n font-thin\">{{ title | translate }}: {{destination.description}}</h1></div><div class=\"page-title override-padding-toolbar\" ng-if=\"!routeFilter\"><div class=\"col-lg-5 col-md-6\"><h1 class=\"m-n font-thin\">{{ title | translate }}:</h1></div><div class=\"col-lg-6 col-md-6\"><div class=\"input-group\"><ui-select ng-model=\"sel.dest\" ng-change=\"destinationChange()\" ng-disabled=\"destinations.length == 1\" theme=\"bootstrap\" style=\"min-width:400px\"><ui-select-match placeholder=\"{{\'reorder.wardrobe_placeholder\' | translate}}...\">{{$select.selected.description}}</ui-select-match><ui-select-choices repeat=\"item in destinations | filter: $select.search\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select><span class=\"input-group-btn\" ng-if=\"destinations.length > 1\"><button ng-click=\"(sel.dest = undefined);destinationChange()\" class=\"btn btn-bg btn-default\"><i class=\"fa fa-times\"></i></button></span></div></div></div><div class=\"wrapper-md\" ng-cloak=\"\" ng-if=\"orderType && destination\"><tnt-reorder-endowments endowment=\"endowment\" is-wardrobe=\"true\" customer-order=\"customerOrder\" order-type=\"orderType\" is-over-budget-permitted=\"isOverBudgetPermitted\" on-save-order=\"saveOrder()\"></tnt-reorder-endowments></div>");
$templateCache.put("tnt/reorder/ward/reorder-ward.html","<six-toolbar><six-toolbar-button label=\"{{ \'clear\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-eraser\" toolbar-function=\"clearAmount()\"></six-toolbar-button></six-toolbar><div class=\"page-title override-padding-toolbar\"><div class=\"col-lg-4 col-md-6\"><h1 class=\"m-n font-thin\">{{ title | translate }}: {{destination.description}}</h1></div><div class=\"col-lg-6 col-md-6\"><div class=\"input-group\" ng-if=\"wards.length>=1\"><ui-select ng-model=\"ward.selected\" ng-change=\"wardChange()\" ng-disabled=\"wards.length == 1\" theme=\"bootstrap\" style=\"min-width:400px\"><ui-select-match placeholder=\"{{\'reorder.ward_placeholder\' | translate}}...\">{{$select.selected.description}}</ui-select-match><ui-select-choices repeat=\"item in wards | filter: $select.search\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select><span class=\"input-group-btn\" ng-if=\"wards.length > 1\"><button ng-click=\"(ward.selected = undefined);wardChange()\" class=\"btn btn-bg btn-default\"><i class=\"fa fa-times\"></i></button></span></div></div></div><div class=\"wrapper-md\" ng-cloak=\"\" ng-if=\"orderType && ward.selected\"><tnt-reorder-endowments endowment=\"endowment\" is-wardrobe=\"isWardrobe()\" customer-order=\"customerOrder\" order-type=\"orderType\" is-over-budget-permitted=\"isOverBudgetPermitted\" on-save-order=\"saveOrder()\"></tnt-reorder-endowments></div>");
$templateCache.put("lm/inventory/collected/detail/inventory-collected-detail.html","<six-toolbar title=\"functionTitle\"><six-toolbar-button label=\"{{ \'list\' | translate }}\" btn-class=\"btn-default\" icon=\"fa fa-arrow-left\" toolbar-function=\"goToList()\"></six-toolbar-button></six-toolbar><div class=\"wrapper-md m-t-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"warehouse\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.warehouse\" sx-id=\"record.model.warehouse\" sx-type=\"\'facility\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\"></six-lookup></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"product\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.product\" sx-id=\"record.model.product\" sx-type=\"\'product\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"size\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.size\" sx-id=\"record.model.size\" sx-type=\"\'tab_size\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"sizeFilter\" sx-disabled=\"!record.lookup.product.obj\"></six-lookup></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"color\" | translate }}</label><div class=\"col-sm-8\"><six-lookup ng-model=\"record.lookup.color\" sx-id=\"record.model.color\" sx-type=\"\'color\'\" sx-relational=\"true\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-filter=\"colorFilter\" sx-disabled=\"!record.lookup.product.obj\"></six-lookup></div></div></div><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label out-labels-mandatory\">{{ \"quantity\" | translate }}</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" ng-model=\"record.model.quantity\" min=\"0\"></div></div></div><div class=\"wrapper\" ng-if=\"isNewAllowed\"><button class=\"pull-right btn btn-sm btn-info m-t-n-xs m-l\" ng-click=\"saveRow()\">{{ \"inventory.add\" | translate }}</button></div></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"from_date\" | translate }}</label><div class=\"col-sm-8\"><six-date-picker ng-model=\"record.filter.fromDate\"></six-date-picker></div></div><div class=\"col-md-6 form-group override-form-group\"><label class=\"col-sm-4 control-label\">{{ \"to_date\" | translate }}</label><div class=\"col-sm-8\"><six-date-picker ng-model=\"record.filter.toDate\"></six-date-picker></div></div></div></div></div><div class=\"panel panel-default\"><six-grid-pagination get-data-callback=\"getData()\" items-list=\"result\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div>");
$templateCache.put("lm/inventory/collected/list/correction-confirm.html","<div class=\"modal-dialog modal-sm\"><div class=\"modal-content\"><div class=\"modal-body\"><h4>Confermi la rettifica di <b>{{ row.amount_detected - row.stock }}</b> per {{ row.product_description }} ({{ row.product_code }}) in {{ row.facility_description }}?</h4></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"doCorrectionMov()\">OK</button> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Cancel</button></div></div></div>");
$templateCache.put("lm/inventory/collected/list/inventory-collected-list.html","<six-toolbar title=\"functionTitle\"><six-toolbar-button icon=\"fa fa-plus\" label=\"{{\'new\' | translate}}\" btn-class=\"btn-info\" toolbar-function=\"goToNew()\" sx-disabled=\"!isNewAllowed\"></six-toolbar-button></six-toolbar><div class=\"wrapper-md m-t-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"col-md-6 col-lg-4\"><label>{{ \"warehouse\" | translate }}</label><six-lookup ng-model=\"lookup.facility\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-preselect-if-one=\"true\" sx-id=\"advFilter.filter.facility\" sx-type=\"\'facility\'\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"product\" | translate }}</label><six-lookup ng-model=\"lookup.product\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'product\'\" sx-id=\"advFilter.filter.product\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-6 col-lg-4\"><label>{{ \"to_date\" | translate }}</label><six-date-picker ng-model=\"advFilter.filter.toDate\"></six-date-picker></div><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"color\" | translate }}</label><six-lookup ng-model=\"lookup.color\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'color\'\" sx-id=\"advFilter.filter.color\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"size\" | translate }}</label><six-lookup ng-model=\"lookup.size\" sx-field=\"\'obj\'\" sx-mapping=\"\'mapping\'\" sx-type=\"\'tab_size\'\" sx-id=\"advFilter.filter.size\" sx-relational=\"true\"></six-lookup></div><div class=\"col-md-6 col-lg-4\"><label class=\"control-label\">{{ \"quantity\" | translate }}</label><six-enum sx-model=\"advFilter.filter\" sx-field=\"type\" sx-options=\"enum.type\"></six-enum></div></div><div class=\"modal-body\"><div class=\"alert alert-warning\" role=\"alert\" ng-show=\"reason.message\">{{ \"inventory.missing_reasons\" | translate }} : {{ reason.message }}</div></div></div><div class=\"panel panel-default\"><six-grid-pagination get-data-callback=\"getData()\" items-list=\"result\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div>");
$templateCache.put("lm/inventory/collected/list/inventory-confirm.html","<div class=\"modal-dialog modal-sm\"><div class=\"modal-content\"><div class=\"modal-body\"><h4>Confermi l\'inseirmento di un movimento di <b>{{ row.amount_detected }}</b> per {{ row.product_description }} ({{ row.product_code }}) in {{ row.facility_description }}?</h4></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"doInventoryMov()\">OK</button> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Cancel</button></div></div></div>");}]);